webpackJsonp([1,0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  Taken from klasse by mattdesl https://github.com/mattdesl/klasse
	
	function hasGetterOrSetter (def)
	{
	    return (!!def.get && typeof def.get === 'function') || (!!def.set && typeof def.set === 'function');
	}
	
	function getProperty (definition, k, isClassDescriptor)
	{
	    //  This may be a lightweight object, OR it might be a property that was defined previously.
	
	    //  For simple class descriptors we can just assume its NOT previously defined.
	    var def = (isClassDescriptor) ? definition[k] : Object.getOwnPropertyDescriptor(definition, k);
	
	    if (!isClassDescriptor && def.value && typeof def.value === 'object')
	    {
	        def = def.value;
	    }
	
	    //  This might be a regular property, or it may be a getter/setter the user defined in a class.
	    if (def && hasGetterOrSetter(def))
	    {
	        if (typeof def.enumerable === 'undefined')
	        {
	            def.enumerable = true;
	        }
	
	        if (typeof def.configurable === 'undefined')
	        {
	            def.configurable = true;
	        }
	
	        return def;
	    }
	    else
	    {
	        return false;
	    }
	}
	
	function hasNonConfigurable (obj, k)
	{
	    var prop = Object.getOwnPropertyDescriptor(obj, k);
	
	    if (!prop)
	    {
	        return false;
	    }
	
	    if (prop.value && typeof prop.value === 'object')
	    {
	        prop = prop.value;
	    }
	
	    if (prop.configurable === false)
	    {
	        return true;
	    }
	
	    return false;
	}
	
	function extend (ctor, definition, isClassDescriptor, extend)
	{
	    for (var k in definition)
	    {
	        if (!definition.hasOwnProperty(k))
	        {
	            continue;
	        }
	
	        var def = getProperty(definition, k, isClassDescriptor);
	
	        if (def !== false)
	        {
	            //  If Extends is used, we will check its prototype to see if the final variable exists.
	
	            var parent = extend || ctor;
	
	            if (hasNonConfigurable(parent.prototype, k))
	            {
	                //  Just skip the final property
	                if (Class.ignoreFinals)
	                {
	                    continue;
	                }
	
	                //  We cannot re-define a property that is configurable=false.
	                //  So we will consider them final and throw an error. This is by
	                //  default so it is clear to the developer what is happening.
	                //  You can set ignoreFinals to true if you need to extend a class
	                //  which has configurable=false; it will simply not re-define final properties.
	                throw new Error('cannot override final property \'' + k + '\', set Class.ignoreFinals = true to skip');
	            }
	
	            Object.defineProperty(ctor.prototype, k, def);
	        }
	        else
	        {
	            ctor.prototype[k] = definition[k];
	        }
	    }
	}
	
	function mixin (myClass, mixins)
	{
	    if (!mixins)
	    {
	        return;
	    }
	
	    if (!Array.isArray(mixins))
	    {
	        mixins = [ mixins ];
	    }
	
	    for (var i = 0; i < mixins.length; i++)
	    {
	        extend(myClass, mixins[i].prototype || mixins[i]);
	    }
	}
	
	/**
	 * Creates a new class with the given descriptor.
	 * The constructor, defined by the name `initialize`,
	 * is an optional function. If unspecified, an anonymous
	 * function will be used which calls the parent class (if
	 * one exists).
	 *
	 * You can also use `Extends` and `Mixins` to provide subclassing
	 * and inheritance.
	 *
	 * @class  Class
	 * @constructor
	 * @param {Object} definition a dictionary of functions for the class
	 * @example
	 *
	 *      var MyClass = new Phaser.Class({
	 *
	 *          initialize: function() {
	 *              this.foo = 2.0;
	 *          },
	 *
	 *          bar: function() {
	 *              return this.foo + 5;
	 *          }
	 *      });
	 */
	function Class (definition)
	{
	    if (!definition)
	    {
	        definition = {};
	    }
	
	    //  The variable name here dictates what we see in Chrome debugger
	    var initialize;
	    var Extends;
	
	    if (definition.initialize)
	    {
	        if (typeof definition.initialize !== 'function')
	        {
	            throw new Error('initialize must be a function');
	        }
	
	        initialize = definition.initialize;
	
	        //  Usually we should avoid 'delete' in V8 at all costs.
	        //  However, its unlikely to make any performance difference
	        //  here since we only call this on class creation (i.e. not object creation).
	        delete definition.initialize;
	    }
	    else if (definition.Extends)
	    {
	        var base = definition.Extends;
	
	        initialize = function ()
	        {
	            base.apply(this, arguments);
	        };
	    }
	    else
	    {
	        initialize = function () {};
	    }
	
	    if (definition.Extends)
	    {
	        initialize.prototype = Object.create(definition.Extends.prototype);
	        initialize.prototype.constructor = initialize;
	
	        //  For getOwnPropertyDescriptor to work, we need to act directly on the Extends (or Mixin)
	
	        Extends = definition.Extends;
	
	        delete definition.Extends;
	    }
	    else
	    {
	        initialize.prototype.constructor = initialize;
	    }
	
	    //  Grab the mixins, if they are specified...
	    var mixins = null;
	
	    if (definition.Mixins)
	    {
	        mixins = definition.Mixins;
	        delete definition.Mixins;
	    }
	
	    //  First, mixin if we can.
	    mixin(initialize, mixins);
	
	    //  Now we grab the actual definition which defines the overrides.
	    extend(initialize, definition, true, Extends);
	
	    return initialize;
	}
	
	Class.extend = extend;
	Class.mixin = mixin;
	Class.ignoreFinals = false;
	
	module.exports = Class;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var core = __webpack_require__(59);
	var hide = __webpack_require__(45);
	var redefine = __webpack_require__(46);
	var ctx = __webpack_require__(60);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Finds the key within the top level of the {@link source} object, or returns {@link defaultValue}
	 *
	 * @function Phaser.Utils.Object.GetFastValue
	 * @since 3.0.0
	 *
	 * @param {object} source - The object to search
	 * @param {string} key - The key for the property on source. Must exist at the top level of the source object (no periods)
	 * @param {*} [defaultValue] - The default value to use if the key does not exist.
	 *
	 * @return {*} The value if found; otherwise, defaultValue (null if none provided)
	 */
	var GetFastValue = function (source, key, defaultValue)
	{
	    var t = typeof(source);
	
	    if (!source || t === 'number' || t === 'string')
	    {
	        return defaultValue;
	    }
	    else if (source.hasOwnProperty(key) && source[key] !== undefined)
	    {
	        return source[key];
	    }
	    else
	    {
	        return defaultValue;
	    }
	};
	
	module.exports = GetFastValue;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(155),
		__webpack_require__(32),
		__webpack_require__(981),
		__webpack_require__(193),
		__webpack_require__(437),
		__webpack_require__(439),
		__webpack_require__(261),
		__webpack_require__(192),
		__webpack_require__(440),
		__webpack_require__(260),
		__webpack_require__(438),
		__webpack_require__(980),
		__webpack_require__(113),
		__webpack_require__(27),
		__webpack_require__(156),
		__webpack_require__(416),
		__webpack_require__(129)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr, document, getProto, slice, concat, push, indexOf,
		class2type, toString, hasOwn, fnToString, ObjectFunctionString,
		support, isFunction, isWindow, DOMEval, toType ) {
	
	"use strict";
	
	var
		version = "3.3.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && Array.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
	
			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			DOMEval( code );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(28);
	var DataManager = __webpack_require__(194);
	var EventEmitter = __webpack_require__(22);
	
	/**
	 * @classdesc
	 * The base class that all Game Objects extend.
	 * You don't create GameObjects directly and they cannot be added to the display list.
	 * Instead, use them as the base for your own custom classes.
	 *
	 * @class GameObject
	 * @memberOf Phaser.GameObjects
	 * @extends Phaser.Events.EventEmitter
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs.
	 * @param {string} type - A textual representation of the type of Game Object, i.e. `sprite`.
	 */
	var GameObject = new Class({
	
	    Extends: EventEmitter,
	
	    initialize:
	
	    function GameObject (scene, type)
	    {
	        EventEmitter.call(this);
	
	        /**
	         * The Scene to which this Game Object belongs.
	         * Game Objects can only belong to one Scene.
	         *
	         * @name Phaser.GameObjects.GameObject#scene
	         * @type {Phaser.Scene}
	         * @protected
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * A textual representation of this Game Object, i.e. `sprite`.
	         * Used internally by Phaser but is available for your own custom classes to populate.
	         *
	         * @name Phaser.GameObjects.GameObject#type
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.type = type;
	
	        /**
	         * The parent Container of this Game Object, if it has one.
	         *
	         * @name Phaser.GameObjects.GameObject#parentContainer
	         * @type {Phaser.GameObjects.Container}
	         * @since 3.4.0
	         */
	        this.parentContainer = null;
	
	        /**
	         * The name of this Game Object.
	         * Empty by default and never populated by Phaser, this is left for developers to use.
	         *
	         * @name Phaser.GameObjects.GameObject#name
	         * @type {string}
	         * @default ''
	         * @since 3.0.0
	         */
	        this.name = '';
	
	        /**
	         * The active state of this Game Object.
	         * A Game Object with an active state of `true` is processed by the Scenes UpdateList, if added to it.
	         * An active object is one which is having its logic and internal systems updated.
	         *
	         * @name Phaser.GameObjects.GameObject#active
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.active = true;
	
	        /**
	         * The Tab Index of the Game Object.
	         * Reserved for future use by plugins and the Input Manager.
	         *
	         * @name Phaser.GameObjects.GameObject#tabIndex
	         * @type {integer}
	         * @default -1
	         * @since 3.0.0
	         */
	        this.tabIndex = -1;
	
	        /**
	         * A Data Manager.
	         * It allows you to store, query and get key/value paired information specific to this Game Object.
	         * `null` by default. Automatically created if you use `getData` or `setData` or `setDataEnabled`.
	         *
	         * @name Phaser.GameObjects.GameObject#data
	         * @type {Phaser.Data.DataManager}
	         * @default null
	         * @since 3.0.0
	         */
	        this.data = null;
	
	        /**
	         * The flags that are compared against `RENDER_MASK` to determine if this Game Object will render or not.
	         * The bits are 0001 | 0010 | 0100 | 1000 set by the components Visible, Alpha, Transform and Texture respectively.
	         * If those components are not used by your custom class then you can use this bitmask as you wish.
	         *
	         * @name Phaser.GameObjects.GameObject#renderFlags
	         * @type {integer}
	         * @default 15
	         * @since 3.0.0
	         */
	        this.renderFlags = 15;
	
	        /**
	         * A bitmask that controls if this Game Object is drawn by a Camera or not.
	         * Not usually set directly. Instead call `Camera.ignore`.
	         *
	         * @name Phaser.GameObjects.GameObject#cameraFilter
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.cameraFilter = 0;
	
	        /**
	         * If this Game Object is enabled for input then this property will contain an InteractiveObject instance.
	         * Not usually set directly. Instead call `GameObject.setInteractive()`.
	         *
	         * @name Phaser.GameObjects.GameObject#input
	         * @type {?Phaser.Input.InteractiveObject}
	         * @default null
	         * @since 3.0.0
	         */
	        this.input = null;
	
	        /**
	         * If this Game Object is enabled for physics then this property will contain a reference to a Physics Body.
	         *
	         * @name Phaser.GameObjects.GameObject#body
	         * @type {?(object|Phaser.Physics.Arcade.Body|Phaser.Physics.Impact.Body)}
	         * @default null
	         * @since 3.0.0
	         */
	        this.body = null;
	
	        /**
	         * This Game Object will ignore all calls made to its destroy method if this flag is set to `true`.
	         * This includes calls that may come from a Group, Container or the Scene itself.
	         * While it allows you to persist a Game Object across Scenes, please understand you are entirely
	         * responsible for managing references to and from this Game Object.
	         *
	         * @name Phaser.GameObjects.GameObject#ignoreDestroy
	         * @type {boolean}
	         * @default false
	         * @since 3.5.0
	         */
	        this.ignoreDestroy = false;
	
	        //  Tell the Scene to re-sort the children
	        scene.sys.queueDepthSort();
	
	        scene.sys.events.once('shutdown', this.destroy, this);
	    },
	
	    /**
	     * Sets the `active` property of this Game Object and returns this Game Object for further chaining.
	     * A Game Object with its `active` property set to `true` will be updated by the Scenes UpdateList.
	     *
	     * @method Phaser.GameObjects.GameObject#setActive
	     * @since 3.0.0
	     *
	     * @param {boolean} value - True if this Game Object should be set as active, false if not.
	     *
	     * @return {Phaser.GameObjects.GameObject} This GameObject.
	     */
	    setActive: function (value)
	    {
	        this.active = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the `name` property of this Game Object and returns this Game Object for further chaining.
	     * The `name` property is not populated by Phaser and is presented for your own use.
	     *
	     * @method Phaser.GameObjects.GameObject#setName
	     * @since 3.0.0
	     *
	     * @param {string} value - The name to be given to this Game Object.
	     *
	     * @return {Phaser.GameObjects.GameObject} This GameObject.
	     */
	    setName: function (value)
	    {
	        this.name = value;
	
	        return this;
	    },
	
	    /**
	     * Adds a DataManager to this object.
	     *
	     * @method Phaser.GameObjects.GameObject#setDataEnabled
	     * @since 3.0.0
	     * @see Phaser.Data.DataManager
	     *
	     * @return {Phaser.GameObjects.GameObject} This GameObject.
	     */
	    setDataEnabled: function ()
	    {
	        if (!this.data)
	        {
	            this.data = new DataManager(this);
	        }
	
	        return this;
	    },
	
	    /**
	     * This is a quick chainable alias to the `DataProxy.set` method.
	     * It allows you to set a key and value in this Game Objects data store.
	     *
	     * @method Phaser.GameObjects.GameObject#setData
	     * @since 3.0.0
	     *
	     * @param {string} key - The key of the property to be stored.
	     * @param {*} value - The value to store with the key. Can be a string, number, array or object.
	     *
	     * @return {Phaser.GameObjects.GameObject} This GameObject.
	     */
	    setData: function (key, value)
	    {
	        if (!this.data)
	        {
	            this.data = new DataManager(this);
	        }
	
	        this.data.set(key, value);
	
	        return this;
	    },
	
	    /**
	     * This is a quick alias to the `DataProxy.get` method to remain consistent with `setData`.
	     *
	     * @method Phaser.GameObjects.GameObject#getData
	     * @since 3.0.0
	     *
	     * @param {string} key - The key of the property to be retrieved.
	     *
	     * @return {*} The data, if present in the Data Store.
	     */
	    getData: function (key)
	    {
	        if (!this.data)
	        {
	            this.data = new DataManager(this);
	        }
	
	        return this.data.get(key);
	    },
	
	    /**
	     * Pass this Game Object to the Input Manager to enable it for Input.
	     *
	     * @method Phaser.GameObjects.GameObject#setInteractive
	     * @since 3.0.0
	     *
	     * @param {*} [shape] - A geometric shape that defines the hit area for the Game Object. If not specified a Rectangle will be used.
	     * @param {HitAreaCallback} [callback] - A callback to be invoked when the Game Object is interacted with. If you provide a shape you must also provide a callback.
	     * @param {boolean} [dropZone=false] - Should this Game Object be treated as a drop zone target?
	     *
	     * @return {Phaser.GameObjects.GameObject} This GameObject.
	     */
	    setInteractive: function (shape, callback, dropZone)
	    {
	        this.scene.sys.input.enable(this, shape, callback, dropZone);
	
	        return this;
	    },
	
	    /**
	     * If this Game Object has previously been enabled for input, this will disable it.
	     *
	     * An object that is disabled for input stops processing or being considered for
	     * input events, but can be turned back on again at any time by simply calling
	     * `setInteractive()` with no arguments provided.
	     *
	     * If want to completely remove interaction from this Game Object then use `removeInteractive` instead.
	     *
	     * @method Phaser.GameObjects.GameObject#disableInteractive
	     * @since 3.7.0
	     *
	     * @return {Phaser.GameObjects.GameObject} This GameObject.
	     */
	    disableInteractive: function ()
	    {
	        if (this.input)
	        {
	            this.input.enabled = (this.input.enabled) ? false : true;
	        }
	
	        return this;
	    },
	
	    /**
	     * If this Game Object has previously been enabled for input, this will remove it.
	     *
	     * The Interactive Object that was assigned to this Game Object will be destroyed,
	     * removed from the Input Manager and cleared from this Game Object.
	     *
	     * If you wish to re-enable this Game Object at a later date you will need to
	     * re-create its InteractiveOobject by calling `setInteractive` again.
	     *
	     * If you wish to only temporarily stop an object from receiving input then use
	     * `disableInteractive` instead, as that toggles the interactive state, where-as
	     * this erases it completely.
	     *
	     * @method Phaser.GameObjects.GameObject#removeInteractive
	     * @since 3.7.0
	     *
	     * @return {Phaser.GameObjects.GameObject} This GameObject.
	     */
	    removeInteractive: function ()
	    {
	        this.scene.sys.input.clear(this);
	
	        this.input = undefined;
	
	        return this;
	    },
	
	    /**
	     * To be overridden by custom GameObjects. Allows base objects to be used in a Pool.
	     *
	     * @method Phaser.GameObjects.GameObject#update
	     * @since 3.0.0
	     */
	    update: function ()
	    {
	    },
	
	    /**
	     * Returns a JSON representation of the Game Object.
	     *
	     * @method Phaser.GameObjects.GameObject#toJSON
	     * @since 3.0.0
	     *
	     * @return {JSONGameObject} A JSON representation of the Game Object.
	     */
	    toJSON: function ()
	    {
	        return Components.ToJSON(this);
	    },
	
	    /**
	     * Compares the renderMask with the renderFlags to see if this Game Object will render or not.
	     *
	     * @method Phaser.GameObjects.GameObject#willRender
	     * @since 3.0.0
	     *
	     * @return {boolean} True if the Game Object should be rendered, otherwise false.
	     */
	    willRender: function ()
	    {
	        return (GameObject.RENDER_MASK === this.renderFlags);
	    },
	
	    /**
	     * Returns an array containing the display list index of either this Game Object, or if it has one,
	     * its parent Container. It then iterates up through all of the parent containers until it hits the
	     * root of the display list (which is index 0 in the returned array).
	     *
	     * Used internally by the InputPlugin but also useful if you wish to find out the display depth of
	     * this Game Object and all of its ancestors.
	     *
	     * @method Phaser.GameObjects.GameObject#getIndexList
	     * @since 3.4.0
	     *
	     * @return {integer[]} An array of display list position indexes.
	     */
	    getIndexList: function ()
	    {
	        // eslint-disable-next-line consistent-this
	        var child = this;
	        var parent = this.parentContainer;
	
	        var indexes = [];
	
	        while (parent)
	        {
	            // indexes.unshift([parent.getIndex(child), parent.name]);
	            indexes.unshift(parent.getIndex(child));
	
	            child = parent;
	
	            if (!parent.parentContainer)
	            {
	                break;
	            }
	            else
	            {
	                parent = parent.parentContainer;
	            }
	        }
	
	        // indexes.unshift([this.scene.sys.displayList.getIndex(child), 'root']);
	        indexes.unshift(this.scene.sys.displayList.getIndex(child));
	
	        return indexes;
	    },
	
	    /**
	     * Destroys this Game Object removing it from the Display List and Update List and
	     * severing all ties to parent resources.
	     *
	     * Also removes itself from the Input Manager and Physics Manager if previously enabled.
	     *
	     * Use this to remove a Game Object from your game if you don't ever plan to use it again.
	     * As long as no reference to it exists within your own code it should become free for
	     * garbage collection by the browser.
	     *
	     * If you just want to temporarily disable an object then look at using the
	     * Game Object Pool instead of destroying it, as destroyed objects cannot be resurrected.
	     *
	     * @method Phaser.GameObjects.GameObject#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        //  This Game Object had already been destroyed
	        if (!this.scene || this.ignoreDestroy)
	        {
	            return;
	        }
	
	        if (this.preDestroy)
	        {
	            this.preDestroy.call(this);
	        }
	
	        this.emit('destroy', this);
	
	        var sys = this.scene.sys;
	
	        sys.displayList.remove(this);
	        sys.updateList.remove(this);
	
	        if (this.input)
	        {
	            sys.input.clear(this);
	            this.input = undefined;
	        }
	
	        if (this.data)
	        {
	            this.data.destroy();
	
	            this.data = undefined;
	        }
	
	        if (this.body)
	        {
	            this.body.destroy();
	            this.body = undefined;
	        }
	
	        //  Tell the Scene to re-sort the children
	        sys.queueDepthSort();
	
	        this.active = false;
	        this.visible = false;
	
	        this.scene = undefined;
	
	        this.parentContainer = undefined;
	
	        this.removeAllListeners();
	    }
	
	});
	
	/**
	 * The bitmask that `GameObject.renderFlags` is compared against to determine if the Game Object will render or not.
	 *
	 * @constant {integer} RENDER_MASK
	 * @memberOf Phaser.GameObjects.GameObject
	 * @default
	 */
	GameObject.RENDER_MASK = 15;
	
	module.exports = GameObject;


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * A NOOP (No Operation) callback function.
	 *
	 * Used internally by Phaser when it's more expensive to determine if a callback exists
	 * than it is to just invoke an empty function.
	 *
	 * @function Phaser.Utils.NOOP
	 * @since 3.0.0
	 */
	var NOOP = function ()
	{
	    //  NOOP
	};
	
	module.exports = NOOP;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
	//  and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
	
	var Class = __webpack_require__(1);
	
	/**
	 * @typedef {object} Vector2Like
	 *
	 * @property {number} x - [description]
	 * @property {number} y - [description]
	 */
	
	/**
	 * @classdesc
	 * A representation of a vector in 2D space.
	 *
	 * @class Vector2
	 * @memberOf Phaser.Math
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {number} [x] - The x component of this Vector.
	 * @param {number} [y] - The y component of this Vector.
	 */
	var Vector2 = new Class({
	
	    initialize:
	
	    function Vector2 (x, y)
	    {
	        /**
	         * The x component of this Vector.
	         *
	         * @name Phaser.Math.Vector2#x
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.x = 0;
	
	        /**
	         * The y component of this Vector.
	         *
	         * @name Phaser.Math.Vector2#y
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.y = 0;
	
	        if (typeof x === 'object')
	        {
	            this.x = x.x || 0;
	            this.y = x.y || 0;
	        }
	        else
	        {
	            if (y === undefined) { y = x; }
	
	            this.x = x || 0;
	            this.y = y || 0;
	        }
	    },
	
	    /**
	     * Make a clone of this Vector2.
	     *
	     * @method Phaser.Math.Vector2#clone
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Vector2} A clone of this Vector2.
	     */
	    clone: function ()
	    {
	        return new Vector2(this.x, this.y);
	    },
	
	    /**
	     * Copy the components of a given vector, into this Vector.
	     *
	     * @method Phaser.Math.Vector2#copy
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector2} src - The Vector to copy the components from.
	     *
	     * @return {Phaser.Math.Vector2} This Vector2.
	     */
	    copy: function (src)
	    {
	        this.x = src.x || 0;
	        this.y = src.y || 0;
	
	        return this;
	    },
	
	    /**
	     * Set the component values of this Vector from a given Vector2Like object.
	     *
	     * @method Phaser.Math.Vector2#setFromObject
	     * @since 3.0.0
	     *
	     * @param {Vector2Like} obj - The object containing the component values to set for this Vector.
	     *
	     * @return {Phaser.Math.Vector2} This Vector2.
	     */
	    setFromObject: function (obj)
	    {
	        this.x = obj.x || 0;
	        this.y = obj.y || 0;
	
	        return this;
	    },
	
	    /**
	     * Set the x and y components of the this Vector to the given x and y values.
	     *
	     * @method Phaser.Math.Vector2#set
	     * @since 3.0.0
	     *
	     * @param {number} x - The x value to set for this Vector.
	     * @param {number} [y=x] - The y value to set for this Vector.
	     *
	     * @return {Phaser.Math.Vector2} This Vector2.
	     */
	    set: function (x, y)
	    {
	        if (y === undefined) { y = x; }
	
	        this.x = x;
	        this.y = y;
	
	        return this;
	    },
	
	    /**
	     * This method is an alias for `Vector2.set`.
	     *
	     * @method Phaser.Math.Vector2#setTo
	     * @since 3.4.0
	     *
	     * @param {number} x - The x value to set for this Vector.
	     * @param {number} [y=x] - The y value to set for this Vector.
	     *
	     * @return {Phaser.Math.Vector2} This Vector2.
	     */
	    setTo: function (x, y)
	    {
	        return this.set(x, y);
	    },
	
	    /**
	     * Sets the `x` and `y` values of this object from a given polar coordinate.
	     *
	     * @method Phaser.Math.Vector2#setToPolar
	     * @since 3.0.0
	     *
	     * @param {float} azimuth - The angular coordinate, in radians.
	     * @param {float} [radius=1] - The radial coordinate (length).
	     *
	     * @return {Phaser.Math.Vector2} This Vector2.
	     */
	    setToPolar: function (azimuth, radius)
	    {
	        if (radius == null) { radius = 1; }
	
	        this.x = Math.cos(azimuth) * radius;
	        this.y = Math.sin(azimuth) * radius;
	
	        return this;
	    },
	
	    /**
	     * Check if this Vector is equal to a given Vector.
	     *
	     * @method Phaser.Math.Vector2#equals
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector2} v - The vector to compare with this Vector.
	     *
	     * @return {boolean} Whether the given Vector is equal to this Vector.
	     */
	    equals: function (v)
	    {
	        return ((this.x === v.x) && (this.y === v.y));
	    },
	
	    /**
	     * Calculate the angle between this Vector and the positive x-axis, in radians.
	     *
	     * @method Phaser.Math.Vector2#angle
	     * @since 3.0.0
	     *
	     * @return {number} The angle between this Vector, and the positive x-axis, given in radians.
	     */
	    angle: function ()
	    {
	        // computes the angle in radians with respect to the positive x-axis
	
	        var angle = Math.atan2(this.y, this.x);
	
	        if (angle < 0)
	        {
	            angle += 2 * Math.PI;
	        }
	
	        return angle;
	    },
	
	    /**
	     * Add a given Vector to this Vector. Addition is element-wise.
	     *
	     * @method Phaser.Math.Vector2#add
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector2} src - The Vector to add to this Vector.
	     *
	     * @return {Phaser.Math.Vector2} This Vector2.
	     */
	    add: function (src)
	    {
	        this.x += src.x;
	        this.y += src.y;
	
	        return this;
	    },
	
	    /**
	     * Subtract the given Vector from this Vector. Subtraction is element-wise.
	     *
	     * @method Phaser.Math.Vector2#subtract
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector2} src - The Vector to subtract from this Vector.
	     *
	     * @return {Phaser.Math.Vector2} This Vector2.
	     */
	    subtract: function (src)
	    {
	        this.x -= src.x;
	        this.y -= src.y;
	
	        return this;
	    },
	
	    /**
	     * Perform an element-wise multiplication between this Vector and the given Vector.
	     *
	     * @method Phaser.Math.Vector2#multiply
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector2} src - The Vector to multiply this Vector by.
	     *
	     * @return {Phaser.Math.Vector2} This Vector2.
	     */
	    multiply: function (src)
	    {
	        this.x *= src.x;
	        this.y *= src.y;
	
	        return this;
	    },
	
	    /**
	     * Scale this Vector by the given value.
	     *
	     * @method Phaser.Math.Vector2#scale
	     * @since 3.0.0
	     *
	     * @param {number} value - The value to scale this Vector by.
	     *
	     * @return {Phaser.Math.Vector2} This Vector2.
	     */
	    scale: function (value)
	    {
	        if (isFinite(value))
	        {
	            this.x *= value;
	            this.y *= value;
	        }
	        else
	        {
	            this.x = 0;
	            this.y = 0;
	        }
	
	        return this;
	    },
	
	    /**
	     * Perform an element-wise division between this Vector and the given Vector. This Vector is divided by the given Vector.
	     *
	     * @method Phaser.Math.Vector2#divide
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector2} src - The Vector to divide this Vector by.
	     *
	     * @return {Phaser.Math.Vector2} This Vector2.
	     */
	    divide: function (src)
	    {
	        this.x /= src.x;
	        this.y /= src.y;
	
	        return this;
	    },
	
	    /**
	     * Negate the x and y components of this Vector.
	     *
	     * @method Phaser.Math.Vector2#negate
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Vector2} This Vector2.
	     */
	    negate: function ()
	    {
	        this.x = -this.x;
	        this.y = -this.y;
	
	        return this;
	    },
	
	    /**
	     * Calculate the distance between this Vector, and the given Vector.
	     *
	     * @method Phaser.Math.Vector2#distance
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector2} src - The Vector to calculate the distance to.
	     *
	     * @return {number} The distance to the given Vector from this Vector.
	     */
	    distance: function (src)
	    {
	        var dx = src.x - this.x;
	        var dy = src.y - this.y;
	
	        return Math.sqrt(dx * dx + dy * dy);
	    },
	
	    /**
	     * The distance between this Vector, and the given Vector, squared.
	     *
	     * @method Phaser.Math.Vector2#distanceSq
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector2} src - The Vector to calculate the distance to.
	     *
	     * @return {number} The distance to this Vector and the given Vector, squared.
	     */
	    distanceSq: function (src)
	    {
	        var dx = src.x - this.x;
	        var dy = src.y - this.y;
	
	        return dx * dx + dy * dy;
	    },
	
	    /**
	     * The length (or magnitude) of this Vector.
	     *
	     * @method Phaser.Math.Vector2#length
	     * @since 3.0.0
	     *
	     * @return {number} The length of this Vector.
	     */
	    length: function ()
	    {
	        var x = this.x;
	        var y = this.y;
	
	        return Math.sqrt(x * x + y * y);
	    },
	
	    /**
	     * Calculate the length of this Vector squared.
	     *
	     * @method Phaser.Math.Vector2#lengthSq
	     * @since 3.0.0
	     *
	     * @return {number} The length of this Vector, squared.
	     */
	    lengthSq: function ()
	    {
	        var x = this.x;
	        var y = this.y;
	
	        return x * x + y * y;
	    },
	
	    /**
	     * Normalise this Vector, that is, make it a unit length vector (magnitude of 1) in the same direction.
	     *
	     * @method Phaser.Math.Vector2#normalize
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Vector2} This Vector2.
	     */
	    normalize: function ()
	    {
	        var x = this.x;
	        var y = this.y;
	        var len = x * x + y * y;
	
	        if (len > 0)
	        {
	            len = 1 / Math.sqrt(len);
	            this.x = x * len;
	            this.y = y * len;
	        }
	
	        return this;
	    },
	
	    /**
	    * Right-hand normalize (make unit length) this Vector
	    */
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector2#normalizeRightHand
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Vector2} This Vector2.
	     */
	    normalizeRightHand: function ()
	    {
	        var x = this.x;
	
	        this.x = this.y * -1;
	        this.y = x;
	
	        return this;
	    },
	
	    /**
	     * Perform a dot product between this Vector and the given Vector
	     *
	     * @method Phaser.Math.Vector2#dot
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector2} src - The Vector2 to dot product with this Vector2.
	     *
	     * @return {number} The result of the dot product
	     */
	    dot: function (src)
	    {
	        return this.x * src.x + this.y * src.y;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector2#cross
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector2} src - [description]
	     *
	     * @return {number} [description]
	     */
	    cross: function (src)
	    {
	        return this.x * src.y - this.y * src.x;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector2#lerp
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector2} src - [description]
	     * @param {number} [t=0] - [description]
	     *
	     * @return {Phaser.Math.Vector2} This Vector2.
	     */
	    lerp: function (src, t)
	    {
	        if (t === undefined) { t = 0; }
	
	        var ax = this.x;
	        var ay = this.y;
	
	        this.x = ax + t * (src.x - ax);
	        this.y = ay + t * (src.y - ay);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector2#transformMat3
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Matrix3} mat - [description]
	     *
	     * @return {Phaser.Math.Vector2} This Vector2.
	     */
	    transformMat3: function (mat)
	    {
	        var x = this.x;
	        var y = this.y;
	        var m = mat.val;
	
	        this.x = m[0] * x + m[3] * y + m[6];
	        this.y = m[1] * x + m[4] * y + m[7];
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector2#transformMat4
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Matrix4} mat - [description]
	     *
	     * @return {Phaser.Math.Vector2} This Vector2.
	     */
	    transformMat4: function (mat)
	    {
	        var x = this.x;
	        var y = this.y;
	        var m = mat.val;
	
	        this.x = m[0] * x + m[4] * y + m[12];
	        this.y = m[1] * x + m[5] * y + m[13];
	
	        return this;
	    },
	
	    /**
	     * Make this Vector the zero vector (0, 0).
	     *
	     * @method Phaser.Math.Vector2#reset
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Vector2} This Vector2.
	     */
	    reset: function ()
	    {
	        this.x = 0;
	        this.y = 0;
	
	        return this;
	    }
	
	});
	
	/**
	 * A static zero Vector2 for use by reference.
	 *
	 * @method Phaser.Math.Vector2.ZERO
	 * @since 3.1.0
	 */
	Vector2.ZERO = new Vector2();
	
	module.exports = Vector2;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  Source object
	//  The key as a string, or an array of keys, i.e. 'banner', or 'banner.hideBanner'
	//  The default value to use if the key doesn't exist
	
	/**
	 * [description]
	 *
	 * @function Phaser.Utils.Object.GetValue
	 * @since 3.0.0
	 *
	 * @param {object} source - [description]
	 * @param {string} key - [description]
	 * @param {*} defaultValue - [description]
	 *
	 * @return {*} [description]
	 */
	var GetValue = function (source, key, defaultValue)
	{
	    if (!source || typeof source === 'number')
	    {
	        return defaultValue;
	    }
	    else if (source.hasOwnProperty(key))
	    {
	        return source[key];
	    }
	    else if (key.indexOf('.'))
	    {
	        var keys = key.split('.');
	        var parent = source;
	        var value = defaultValue;
	
	        //  Use for loop here so we can break early
	        for (var i = 0; i < keys.length; i++)
	        {
	            if (parent.hasOwnProperty(keys[i]))
	            {
	                //  Yes it has a key property, let's carry on down
	                value = parent[keys[i]];
	
	                parent = parent[keys[i]];
	            }
	            else
	            {
	                //  Can't go any further, so reset to default
	                value = defaultValue;
	                break;
	            }
	        }
	
	        return value;
	    }
	    else
	    {
	        return defaultValue;
	    }
	};
	
	module.exports = GetValue;


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * Defines a Point in 2D space, with an x and y component.
	 *
	 * @class Point
	 * @memberOf Phaser.Geom
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {number} [x=0] - The x coordinate of this Point.
	 * @param {number} [y=x] - The y coordinate of this Point.
	 */
	var Point = new Class({
	
	    initialize:
	
	    function Point (x, y)
	    {
	        if (x === undefined) { x = 0; }
	        if (y === undefined) { y = x; }
	
	        /**
	         * The x coordinate of this Point.
	         *
	         * @name Phaser.Geom.Point#x
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.x = x;
	
	        /**
	         * The y coordinate of this Point.
	         *
	         * @name Phaser.Geom.Point#y
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.y = y;
	    },
	
	    /**
	     * Set the x and y coordinates of the point to the given values.
	     *
	     * @method Phaser.Geom.Point#setTo
	     * @since 3.0.0
	     *
	     * @param {number} [x=0] - The x coordinate of this Point.
	     * @param {number} [y=x] - The y coordinate of this Point.
	     *
	     * @return {Phaser.Geom.Point} This Point object.
	     */
	    setTo: function (x, y)
	    {
	        if (x === undefined) { x = 0; }
	        if (y === undefined) { y = x; }
	
	        this.x = x;
	        this.y = y;
	
	        return this;
	    }
	
	});
	
	module.exports = Point;


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(41),
		__webpack_require__(132),
		__webpack_require__(250),
		__webpack_require__(130),
		__webpack_require__(962),
		__webpack_require__(417),
		__webpack_require__(961),
		__webpack_require__(258),
		__webpack_require__(976),
		__webpack_require__(951),
		__webpack_require__(131),
		__webpack_require__(969),
		__webpack_require__(191),
		__webpack_require__(973),
		__webpack_require__(982),
		__webpack_require__(154),
		__webpack_require__(958),
		__webpack_require__(434),
		__webpack_require__(128),
		__webpack_require__(950),
		__webpack_require__(948),
		__webpack_require__(945),
		__webpack_require__(946),
		__webpack_require__(967),
		__webpack_require__(256),
		__webpack_require__(966),
		__webpack_require__(975),
		__webpack_require__(964),
		__webpack_require__(963),
		__webpack_require__(971),
		__webpack_require__(972)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	return jQuery;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var types = {};
	
	var FileTypesManager = {
	
	    /**
	     * Static method called when a LoaderPlugin is created.
	     * 
	     * Loops through the local types object and injects all of them as
	     * properties into the LoaderPlugin instance.
	     *
	     * @method Phaser.Loader.FileTypesManager.register
	     * @since 3.0.0
	     * 
	     * @param {Phaser.Loader.LoaderPlugin} loader - The LoaderPlugin to install the types into.
	     */
	    install: function (loader)
	    {
	        for (var key in types)
	        {
	            loader[key] = types[key];
	        }
	    },
	
	    /**
	     * Static method called directly by the File Types.
	     * 
	     * The key is a reference to the function used to load the files via the Loader, i.e. `image`.
	     *
	     * @method Phaser.Loader.FileTypesManager.register
	     * @since 3.0.0
	     * 
	     * @param {string} key - The key that will be used as the method name in the LoaderPlugin.
	     * @param {function} factoryFunction - The function that will be called when LoaderPlugin.key is invoked.
	     */
	    register: function (key, factoryFunction)
	    {
	        types[key] = factoryFunction;
	    },
	
	    /**
	     * Removed all associated file types.
	     *
	     * @method Phaser.Loader.FileTypesManager.destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        types = {};
	    }
	
	};
	
	module.exports = FileTypesManager;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(187)('wks');
	var uid = __webpack_require__(110);
	var Symbol = __webpack_require__(8).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * This is a slightly modified version of jQuery.isPlainObject.
	 * A plain object is an object whose internal class property is [object Object].
	 *
	 * @function Phaser.Utils.Object.IsPlainObject
	 * @since 3.0.0
	 *
	 * @param {object} obj - The object to inspect.
	 *
	 * @return {boolean} `true` if the object is plain, otherwise `false`.
	 */
	var IsPlainObject = function (obj)
	{
	    // Not plain objects:
	    // - Any object or value whose internal [[Class]] property is not "[object Object]"
	    // - DOM nodes
	    // - window
	    if (typeof(obj) !== 'object' || obj.nodeType || obj === obj.window)
	    {
	        return false;
	    }
	
	    // Support: Firefox <20
	    // The try/catch suppresses exceptions thrown when attempting to access
	    // the "constructor" property of certain host objects, ie. |window.location|
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=814622
	    try
	    {
	        if (obj.constructor && !({}).hasOwnProperty.call(obj.constructor.prototype, 'isPrototypeOf'))
	        {
	            return false;
	        }
	    }
	    catch (e)
	    {
	        return false;
	    }
	
	    // If the function hasn't returned already, we're confident that
	    // |obj| is a plain object, created by {} or constructed with new Object
	    return true;
	};
	
	module.exports = IsPlainObject;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var PluginCache = __webpack_require__(29);
	
	/**
	 * @classdesc
	 * The Game Object Factory is a Scene plugin that allows you to quickly create many common
	 * types of Game Objects and have them automatically registered with the Scene.
	 *
	 * Game Objects directly register themselves with the Factory and inject their own creation
	 * methods into the class.
	 *
	 * @class GameObjectFactory
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - The Scene to which this Game Object Factory belongs.
	 */
	var GameObjectFactory = new Class({
	
	    initialize:
	
	    function GameObjectFactory (scene)
	    {
	        /**
	         * The Scene to which this Game Object Factory belongs.
	         *
	         * @name Phaser.GameObjects.GameObjectFactory#scene
	         * @type {Phaser.Scene}
	         * @protected
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * A reference to the Scene.Systems.
	         *
	         * @name Phaser.GameObjects.GameObjectFactory#systems
	         * @type {Phaser.Scenes.Systems}
	         * @protected
	         * @since 3.0.0
	         */
	        this.systems = scene.sys;
	
	        /**
	         * A reference to the Scene Display List.
	         *
	         * @name Phaser.GameObjects.GameObjectFactory#displayList
	         * @type {Phaser.GameObjects.DisplayList}
	         * @protected
	         * @since 3.0.0
	         */
	        this.displayList;
	
	        /**
	         * A reference to the Scene Update List.
	         *
	         * @name Phaser.GameObjects.GameObjectFactory#updateList;
	         * @type {Phaser.GameObjects.UpdateList}
	         * @protected
	         * @since 3.0.0
	         */
	        this.updateList;
	
	        scene.sys.events.once('boot', this.boot, this);
	        scene.sys.events.on('start', this.start, this);
	    },
	
	    /**
	     * This method is called automatically, only once, when the Scene is first created.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.GameObjects.GameObjectFactory#boot
	     * @private
	     * @since 3.5.1
	     */
	    boot: function ()
	    {
	        this.displayList = this.systems.displayList;
	        this.updateList = this.systems.updateList;
	
	        this.systems.events.once('destroy', this.destroy, this);
	    },
	
	    /**
	     * This method is called automatically by the Scene when it is starting up.
	     * It is responsible for creating local systems, properties and listening for Scene events.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.GameObjects.GameObjectFactory#start
	     * @private
	     * @since 3.5.0
	     */
	    start: function ()
	    {
	        this.systems.events.once('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * Adds an existing Game Object to this Scene.
	     * 
	     * If the Game Object renders, it will be added to the Display List.
	     * If it has a `preUpdate` method, it will be added to the Update List.
	     *
	     * @method Phaser.GameObjects.GameObjectFactory#existing
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} child - The child to be added to this Scene.
	     *
	     * @return {Phaser.GameObjects.GameObject} The Game Object that was added.
	     */
	    existing: function (child)
	    {
	        if (child.renderCanvas || child.renderWebGL)
	        {
	            this.displayList.add(child);
	        }
	
	        if (child.preUpdate)
	        {
	            this.updateList.add(child);
	        }
	
	        return child;
	    },
	
	    /**
	     * The Scene that owns this plugin is shutting down.
	     * We need to kill and reset all internal properties as well as stop listening to Scene events.
	     *
	     * @method Phaser.GameObjects.GameObjectFactory#shutdown
	     * @private
	     * @since 3.0.0
	     */
	    shutdown: function ()
	    {
	        this.systems.events.off('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * The Scene that owns this plugin is being destroyed.
	     * We need to shutdown and then kill off all external references.
	     *
	     * @method Phaser.GameObjects.GameObjectFactory#destroy
	     * @private
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.shutdown();
	
	        this.scene.sys.events.off('start', this.start, this);
	
	        this.scene = null;
	        this.systems = null;
	
	        this.displayList = null;
	        this.updateList = null;
	    }
	
	});
	
	//  Static method called directly by the Game Object factory functions
	
	GameObjectFactory.register = function (factoryType, factoryFunction)
	{
	    if (!GameObjectFactory.prototype.hasOwnProperty(factoryType))
	    {
	        GameObjectFactory.prototype[factoryType] = factoryFunction;
	    }
	};
	
	PluginCache.register('GameObjectFactory', GameObjectFactory, 'add');
	
	module.exports = GameObjectFactory;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(11)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(7);
	var IE8_DOM_DEFINE = __webpack_require__(386);
	var toPrimitive = __webpack_require__(68);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(19) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(67);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';
	
	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @private
	 */
	function Events() {}
	
	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);
	
	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}
	
	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} once Specify if the listener is a one-time listener.
	 * @returns {EventEmitter}
	 * @private
	 */
	function addListener(emitter, event, fn, context, once) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('The listener must be a function');
	  }
	
	  var listener = new EE(fn, context || emitter, once)
	    , evt = prefix ? prefix + event : event;
	
	  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
	  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
	  else emitter._events[evt] = [emitter._events[evt], listener];
	
	  return emitter;
	}
	
	/**
	 * Clear event by name.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} evt The Event name.
	 * @private
	 */
	function clearEvent(emitter, evt) {
	  if (--emitter._eventsCount === 0) emitter._events = new Events();
	  else delete emitter._events[evt];
	}
	
	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;
	
	  if (this._eventsCount === 0) return names;
	
	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Array} The registered listeners.
	 * @public
	 */
	EventEmitter.prototype.listeners = function listeners(event) {
	  var evt = prefix ? prefix + event : event
	    , handlers = this._events[evt];
	
	  if (!handlers) return [];
	  if (handlers.fn) return [handlers.fn];
	
	  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
	    ee[i] = handlers[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Return the number of listeners listening to a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Number} The number of listeners.
	 * @public
	 */
	EventEmitter.prototype.listenerCount = function listenerCount(event) {
	  var evt = prefix ? prefix + event : event
	    , listeners = this._events[evt];
	
	  if (!listeners) return 0;
	  if (listeners.fn) return 1;
	  return listeners.length;
	};
	
	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  return addListener(this, event, fn, context, false);
	};
	
	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  return addListener(this, event, fn, context, true);
	};
	
	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {*} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return this;
	  if (!fn) {
	    clearEvent(this, evt);
	    return this;
	  }
	
	  var listeners = this._events[evt];
	
	  if (listeners.fn) {
	    if (
	      listeners.fn === fn &&
	      (!once || listeners.once) &&
	      (!context || listeners.context === context)
	    ) {
	      clearEvent(this, evt);
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	        listeners[i].fn !== fn ||
	        (once && !listeners[i].once) ||
	        (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }
	
	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else clearEvent(this, evt);
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {(String|Symbol)} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;
	
	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) clearEvent(this, evt);
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Contains = __webpack_require__(84);
	var GetPoint = __webpack_require__(296);
	var GetPoints = __webpack_require__(522);
	var Line = __webpack_require__(200);
	var Random = __webpack_require__(297);
	
	/**
	 * @classdesc
	 * Encapsulates a 2D rectangle defined by its corner point in the top-left and its extends in x (width) and y (height)
	 *
	 * @class Rectangle
	 * @memberOf Phaser.Geom
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {number} [x=0] - [description]
	 * @param {number} [y=0] - [description]
	 * @param {number} [width=0] - [description]
	 * @param {number} [height=0] - [description]
	 */
	var Rectangle = new Class({
	
	    initialize:
	
	    function Rectangle (x, y, width, height)
	    {
	        if (x === undefined) { x = 0; }
	        if (y === undefined) { y = 0; }
	        if (width === undefined) { width = 0; }
	        if (height === undefined) { height = 0; }
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Geom.Rectangle#x
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.x = x;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Geom.Rectangle#y
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.y = y;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Geom.Rectangle#width
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.width = width;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Geom.Rectangle#height
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.height = height;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Geom.Rectangle#contains
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     *
	     * @return {boolean} [description]
	     */
	    contains: function (x, y)
	    {
	        return Contains(this, x, y);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Geom.Rectangle#getPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Point} O - [output,$return]
	     *
	     * @param {float} position - [description]
	     * @param {(Phaser.Geom.Point|object)} [output] - [description]
	     *
	     * @return {(Phaser.Geom.Point|object)} [description]
	     */
	    getPoint: function (position, output)
	    {
	        return GetPoint(this, position, output);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Geom.Rectangle#getPoints
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Point[]} O - [output,$return]
	     *
	     * @param {integer} quantity - [description]
	     * @param {number} [stepRate] - [description]
	     * @param {(array|Phaser.Geom.Point[])} [output] - [description]
	     *
	     * @return {(array|Phaser.Geom.Point[])} [description]
	     */
	    getPoints: function (quantity, stepRate, output)
	    {
	        return GetPoints(this, quantity, stepRate, output);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Geom.Rectangle#getRandomPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Point} O - [point,$return]
	     *
	     * @param {Phaser.Geom.Point} [point] - [description]
	     *
	     * @return {Phaser.Geom.Point} [description]
	     */
	    getRandomPoint: function (point)
	    {
	        return Random(this, point);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Geom.Rectangle#setTo
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     *
	     * @return {Phaser.Geom.Rectangle} This Rectangle object.
	     */
	    setTo: function (x, y, width, height)
	    {
	        this.x = x;
	        this.y = y;
	        this.width = width;
	        this.height = height;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Geom.Rectangle#setEmpty
	     * @since 3.0.0
	     *
	     * @return {Phaser.Geom.Rectangle} This Rectangle object.
	     */
	    setEmpty: function ()
	    {
	        return this.setTo(0, 0, 0, 0);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Geom.Rectangle#setPosition
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} [y=x] - [description]
	     *
	     * @return {Phaser.Geom.Rectangle} This Rectangle object.
	     */
	    setPosition: function (x, y)
	    {
	        if (y === undefined) { y = x; }
	
	        this.x = x;
	        this.y = y;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Geom.Rectangle#setSize
	     * @since 3.0.0
	     *
	     * @param {number} width - [description]
	     * @param {number} [height=width] - [description]
	     *
	     * @return {Phaser.Geom.Rectangle} This Rectangle object.
	     */
	    setSize: function (width, height)
	    {
	        if (height === undefined) { height = width; }
	
	        this.width = width;
	        this.height = height;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Geom.Rectangle#isEmpty
	     * @since 3.0.0
	     *
	     * @return {boolean} [description]
	     */
	    isEmpty: function ()
	    {
	        return (this.width <= 0 || this.height <= 0);
	    },
	
	    /**
	     * Returns a Line object that corresponds to the top of this Rectangle.
	     *
	     * @method Phaser.Geom.Rectangle#getLineA
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Line} O - [line,$return]
	     *
	     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
	     *
	     * @return {Phaser.Geom.Line} A Line object that corresponds to the top of this Rectangle.
	     */
	    getLineA: function (line)
	    {
	        if (line === undefined) { line = new Line(); }
	
	        line.setTo(this.x, this.y, this.right, this.y);
	
	        return line;
	    },
	
	    /**
	     * Returns a Line object that corresponds to the right of this Rectangle.
	     *
	     * @method Phaser.Geom.Rectangle#getLineB
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Line} O - [line,$return]
	     *
	     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
	     *
	     * @return {Phaser.Geom.Line} A Line object that corresponds to the right of this Rectangle.
	     */
	    getLineB: function (line)
	    {
	        if (line === undefined) { line = new Line(); }
	
	        line.setTo(this.right, this.y, this.right, this.bottom);
	
	        return line;
	    },
	
	    /**
	     * Returns a Line object that corresponds to the bottom of this Rectangle.
	     *
	     * @method Phaser.Geom.Rectangle#getLineC
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Line} O - [line,$return]
	     *
	     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
	     *
	     * @return {Phaser.Geom.Line} A Line object that corresponds to the bottom of this Rectangle.
	     */
	    getLineC: function (line)
	    {
	        if (line === undefined) { line = new Line(); }
	
	        line.setTo(this.right, this.bottom, this.x, this.bottom);
	
	        return line;
	    },
	
	    /**
	     * Returns a Line object that corresponds to the left of this Rectangle.
	     *
	     * @method Phaser.Geom.Rectangle#getLineD
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Line} O - [line,$return]
	     *
	     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
	     *
	     * @return {Phaser.Geom.Line} A Line object that corresponds to the left of this Rectangle.
	     */
	    getLineD: function (line)
	    {
	        if (line === undefined) { line = new Line(); }
	
	        line.setTo(this.x, this.bottom, this.x, this.y);
	
	        return line;
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Geom.Rectangle#left
	     * @type {number}
	     * @since 3.0.0
	     */
	    left: {
	
	        get: function ()
	        {
	            return this.x;
	        },
	
	        set: function (value)
	        {
	            if (value >= this.right)
	            {
	                this.width = 0;
	            }
	            else
	            {
	                this.width = this.right - value;
	            }
	
	            this.x = value;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Geom.Rectangle#right
	     * @type {number}
	     * @since 3.0.0
	     */
	    right: {
	
	        get: function ()
	        {
	            return this.x + this.width;
	        },
	
	        set: function (value)
	        {
	            if (value <= this.x)
	            {
	                this.width = 0;
	            }
	            else
	            {
	                this.width = value - this.x;
	            }
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Geom.Rectangle#top
	     * @type {number}
	     * @since 3.0.0
	     */
	    top: {
	
	        get: function ()
	        {
	            return this.y;
	        },
	
	        set: function (value)
	        {
	            if (value >= this.bottom)
	            {
	                this.height = 0;
	            }
	            else
	            {
	                this.height = (this.bottom - value);
	            }
	
	            this.y = value;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Geom.Rectangle#bottom
	     * @type {number}
	     * @since 3.0.0
	     */
	    bottom: {
	
	        get: function ()
	        {
	            return this.y + this.height;
	        },
	
	        set: function (value)
	        {
	            if (value <= this.y)
	            {
	                this.height = 0;
	            }
	            else
	            {
	                this.height = value - this.y;
	            }
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Geom.Rectangle#centerX
	     * @type {number}
	     * @since 3.0.0
	     */
	    centerX: {
	
	        get: function ()
	        {
	            return this.x + (this.width / 2);
	        },
	
	        set: function (value)
	        {
	            this.x = value - (this.width / 2);
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Geom.Rectangle#centerY
	     * @type {number}
	     * @since 3.0.0
	     */
	    centerY: {
	
	        get: function ()
	        {
	            return this.y + (this.height / 2);
	        },
	
	        set: function (value)
	        {
	            this.y = value - (this.height / 2);
	        }
	
	    }
	
	});
	
	module.exports = Rectangle;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var MATH = __webpack_require__(33);
	var GetValue = __webpack_require__(10);
	
	//  Allowed types:
	
	//  Implicit
	//  {
	//      x: 4
	//  }
	//
	//  From function
	//  {
	//      x: function ()
	//  }
	//
	//  Randomly pick one element from the array
	//  {
	//      x: [a, b, c, d, e, f]
	//  }
	//
	//  Random integer between min and max:
	//  {
	//      x: { randInt: [min, max] }
	//  }
	//
	//  Random float between min and max:
	//  {
	//      x: { randFloat: [min, max] }
	//  }
	
	/**
	 * [description]
	 *
	 * @function Phaser.Utils.Object.GetAdvancedValue
	 * @since 3.0.0
	 *
	 * @param {object} source - [description]
	 * @param {string} key - [description]
	 * @param {*} defaultValue - [description]
	 *
	 * @return {*} [description]
	 */
	var GetAdvancedValue = function (source, key, defaultValue)
	{
	    var value = GetValue(source, key, null);
	
	    if (value === null)
	    {
	        return defaultValue;
	    }
	    else if (Array.isArray(value))
	    {
	        return MATH.RND.pick(value);
	    }
	    else if (typeof value === 'object')
	    {
	        if (value.hasOwnProperty('randInt'))
	        {
	            return MATH.RND.integerInRange(value.randInt[0], value.randInt[1]);
	        }
	        else if (value.hasOwnProperty('randFloat'))
	        {
	            return MATH.RND.realInRange(value.randFloat[0], value.randFloat[1]);
	        }
	    }
	    else if (typeof value === 'function')
	    {
	        return value(key);
	    }
	
	    return value;
	};
	
	module.exports = GetAdvancedValue;


/***/ }),
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var PluginCache = __webpack_require__(29);
	
	/**
	 * @classdesc
	 * The Game Object Creator is a Scene plugin that allows you to quickly create many common
	 * types of Game Objects and return them. Unlike the Game Object Factory, they are not automatically
	 * added to the Scene.
	 *
	 * Game Objects directly register themselves with the Creator and inject their own creation
	 * methods into the class.
	 *
	 * @class GameObjectCreator
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - The Scene to which this Game Object Factory belongs.
	 */
	var GameObjectCreator = new Class({
	
	    initialize:
	
	    function GameObjectCreator (scene)
	    {
	        /**
	         * The Scene to which this Game Object Creator belongs.
	         *
	         * @name Phaser.GameObjects.GameObjectCreator#scene
	         * @type {Phaser.Scene}
	         * @protected
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * A reference to the Scene.Systems.
	         *
	         * @name Phaser.GameObjects.GameObjectCreator#systems
	         * @type {Phaser.Scenes.Systems}
	         * @protected
	         * @since 3.0.0
	         */
	        this.systems = scene.sys;
	
	        /**
	         * A reference to the Scene Display List.
	         *
	         * @name Phaser.GameObjects.GameObjectCreator#displayList
	         * @type {Phaser.GameObjects.DisplayList}
	         * @protected
	         * @since 3.0.0
	         */
	        this.displayList;
	
	        /**
	         * A reference to the Scene Update List.
	         *
	         * @name Phaser.GameObjects.GameObjectCreator#updateList;
	         * @type {Phaser.GameObjects.UpdateList}
	         * @protected
	         * @since 3.0.0
	         */
	        this.updateList;
	
	        scene.sys.events.once('boot', this.boot, this);
	        scene.sys.events.on('start', this.start, this);
	    },
	
	    /**
	     * This method is called automatically, only once, when the Scene is first created.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.GameObjects.GameObjectCreator#boot
	     * @private
	     * @since 3.5.1
	     */
	    boot: function ()
	    {
	        this.displayList = this.systems.displayList;
	        this.updateList = this.systems.updateList;
	
	        this.systems.events.once('destroy', this.destroy, this);
	    },
	
	    /**
	     * This method is called automatically by the Scene when it is starting up.
	     * It is responsible for creating local systems, properties and listening for Scene events.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.GameObjects.GameObjectCreator#start
	     * @private
	     * @since 3.5.0
	     */
	    start: function ()
	    {
	        this.systems.events.once('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * The Scene that owns this plugin is shutting down.
	     * We need to kill and reset all internal properties as well as stop listening to Scene events.
	     *
	     * @method Phaser.GameObjects.GameObjectCreator#shutdown
	     * @private
	     * @since 3.0.0
	     */
	    shutdown: function ()
	    {
	        this.systems.events.off('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * The Scene that owns this plugin is being destroyed.
	     * We need to shutdown and then kill off all external references.
	     *
	     * @method Phaser.GameObjects.GameObjectCreator#destroy
	     * @private
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.shutdown();
	
	        this.scene.sys.events.off('start', this.start, this);
	
	        this.scene = null;
	        this.systems = null;
	        this.displayList = null;
	        this.updateList = null;
	    }
	
	});
	
	//  Static method called directly by the Game Object creator functions
	
	GameObjectCreator.register = function (factoryType, factoryFunction)
	{
	    if (!GameObjectCreator.prototype.hasOwnProperty(factoryType))
	    {
	        GameObjectCreator.prototype[factoryType] = factoryFunction;
	    }
	};
	
	PluginCache.register('GameObjectCreator', GameObjectCreator, 'make');
	
	module.exports = GameObjectCreator;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return function isFunction( obj ) {
	
	      // Support: Chrome <=57, Firefox <=52
	      // In some browsers, typeof returns "function" for HTML <object> elements
	      // (i.e., `typeof document.createElement( "object" ) === "function"`).
	      // We don't want to classify *any* DOM node as a function.
	      return typeof obj === "function" && typeof obj.nodeType !== "number";
	  };
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.GameObjects.Components
	 */
	
	module.exports = {
	
	    Alpha: __webpack_require__(1123),
	    Animation: __webpack_require__(490),
	    BlendMode: __webpack_require__(1124),
	    ComputedSize: __webpack_require__(1125),
	    Depth: __webpack_require__(1126),
	    Flip: __webpack_require__(1127),
	    GetBounds: __webpack_require__(1128),
	    Mask: __webpack_require__(1129),
	    MatrixStack: __webpack_require__(1130),
	    Origin: __webpack_require__(1131),
	    Pipeline: __webpack_require__(276),
	    ScaleMode: __webpack_require__(1132),
	    ScrollFactor: __webpack_require__(1133),
	    Size: __webpack_require__(1134),
	    Texture: __webpack_require__(1135),
	    Tint: __webpack_require__(1136),
	    ToJSON: __webpack_require__(1137),
	    Transform: __webpack_require__(1138),
	    TransformMatrix: __webpack_require__(158),
	    Visible: __webpack_require__(1139)
	
	};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  Contains the plugins that Phaser uses globally and locally.
	//  These are the source objects, not instantiated.
	var corePlugins = {};
	
	//  Contains the plugins that the dev has loaded into their game
	//  These are the source objects, not instantiated.
	var customPlugins = {};
	
	/**
	 * @typedef {object} CorePluginContainer
	 *
	 * @property {string} key - The unique name of this plugin in the core plugin cache.
	 * @property {function} plugin - The plugin to be stored. Should be the source object, not instantiated.
	 * @property {string} [mapping] - If this plugin is to be injected into the Scene Systems, this is the property key map used.
	 * @property {boolean} [custom=false] - Core Scene plugin or a Custom Scene plugin?
	 */
	
	/**
	 * @typedef {object} CustomPluginContainer
	 *
	 * @property {string} key - The unique name of this plugin in the custom plugin cache.
	 * @property {function} plugin - The plugin to be stored. Should be the source object, not instantiated.
	 */
	
	var PluginCache = {};
	
	/**
	 * Static method called directly by the Core internal Plugins.
	 * Key is a reference used to get the plugin from the plugins object (i.e. InputPlugin)
	 * Plugin is the object to instantiate to create the plugin
	 * Mapping is what the plugin is injected into the Scene.Systems as (i.e. input)
	 *
	 * @method Phaser.Plugins.PluginCache.register
	 * @since 3.8.0
	 * 
	 * @param {string} key - A reference used to get this plugin from the plugin cache.
	 * @param {function} plugin - The plugin to be stored. Should be the core object, not instantiated.
	 * @param {string} mapping - If this plugin is to be injected into the Scene Systems, this is the property key map used.
	 * @param {boolean} [custom=false] - Core Scene plugin or a Custom Scene plugin?
	 */
	PluginCache.register = function (key, plugin, mapping, custom)
	{
	    if (custom === undefined) { custom = false; }
	
	    corePlugins[key] = { plugin: plugin, mapping: mapping, custom: custom };
	};
	
	/**
	 * Stores a custom plugin in the global plugin cache.
	 * The key must be unique, within the scope of the cache.
	 *
	 * @method Phaser.Plugins.PluginCache.registerCustom
	 * @since 3.8.0
	 * 
	 * @param {string} key - A reference used to get this plugin from the plugin cache.
	 * @param {function} plugin - The plugin to be stored. Should be the core object, not instantiated.
	 * @param {string} mapping - If this plugin is to be injected into the Scene Systems, this is the property key map used.
	 */
	PluginCache.registerCustom = function (key, plugin, mapping)
	{
	    customPlugins[key] = { plugin: plugin, mapping: mapping };
	};
	
	/**
	 * Checks if the given key is already being used in the core plugin cache.
	 *
	 * @method Phaser.Plugins.PluginCache.hasCore
	 * @since 3.8.0
	 * 
	 * @param {string} key - The key to check for.
	 *
	 * @return {boolean} `true` if the key is already in use in the core cache, otherwise `false`.
	 */
	PluginCache.hasCore = function (key)
	{
	    return corePlugins.hasOwnProperty(key);
	};
	
	/**
	 * Checks if the given key is already being used in the custom plugin cache.
	 *
	 * @method Phaser.Plugins.PluginCache.hasCustom
	 * @since 3.8.0
	 * 
	 * @param {string} key - The key to check for.
	 *
	 * @return {boolean} `true` if the key is already in use in the custom cache, otherwise `false`.
	 */
	PluginCache.hasCustom = function (key)
	{
	    return customPlugins.hasOwnProperty(key);
	};
	
	/**
	 * Returns the core plugin object from the cache based on the given key.
	 *
	 * @method Phaser.Plugins.PluginCache.getCore
	 * @since 3.8.0
	 * 
	 * @param {string} key - The key of the core plugin to get.
	 *
	 * @return {CorePluginContainer} The core plugin object.
	 */
	PluginCache.getCore = function (key)
	{
	    return corePlugins[key];
	};
	
	/**
	 * Returns the custom plugin object from the cache based on the given key.
	 *
	 * @method Phaser.Plugins.PluginCache.getCustom
	 * @since 3.8.0
	 * 
	 * @param {string} key - The key of the custom plugin to get.
	 *
	 * @return {CustomPluginContainer} The custom plugin object.
	 */
	PluginCache.getCustom = function (key)
	{
	    return customPlugins[key];
	};
	
	/**
	 * Returns an object from the custom cache based on the given key that can be instantiated.
	 *
	 * @method Phaser.Plugins.PluginCache.getCustomClass
	 * @since 3.8.0
	 * 
	 * @param {string} key - The key of the custom plugin to get.
	 *
	 * @return {function} The custom plugin object.
	 */
	PluginCache.getCustomClass = function (key)
	{
	    return (customPlugins.hasOwnProperty(key)) ? customPlugins[key].plugin : null;
	};
	
	/**
	 * Removes a core plugin based on the given key.
	 *
	 * @method Phaser.Plugins.PluginCache.remove
	 * @since 3.8.0
	 * 
	 * @param {string} key - The key of the core plugin to remove.
	 */
	PluginCache.remove = function (key)
	{
	    if (corePlugins.hasOwnProperty(key))
	    {
	        delete corePlugins[key];
	    }
	};
	
	/**
	 * Removes a custom plugin based on the given key.
	 *
	 * @method Phaser.Plugins.PluginCache.removeCustom
	 * @since 3.8.0
	 * 
	 * @param {string} key - The key of the custom plugin to remove.
	 */
	PluginCache.removeCustom = function (key)
	{
	    if (customPlugins.hasOwnProperty(key))
	    {
	        delete customPlugins[key];
	    }
	};
	
	module.exports = PluginCache;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(65);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

	/**
	* The `Matter.Common` module contains utility functions that are common to all modules.
	*
	* @class Common
	*/
	
	var Common = {};
	
	module.exports = Common;
	
	(function() {
	
	    Common._nextId = 0;
	    Common._seed = 0;
	    Common._nowStartTime = +(new Date());
	
	    /**
	     * Extends the object in the first argument using the object in the second argument.
	     * @method extend
	     * @param {} obj
	     * @param {boolean} deep
	     * @return {} obj extended
	     */
	    Common.extend = function(obj, deep) {
	        var argsStart,
	            args,
	            deepClone;
	
	        if (typeof deep === 'boolean') {
	            argsStart = 2;
	            deepClone = deep;
	        } else {
	            argsStart = 1;
	            deepClone = true;
	        }
	
	        for (var i = argsStart; i < arguments.length; i++) {
	            var source = arguments[i];
	
	            if (source) {
	                for (var prop in source) {
	                    if (deepClone && source[prop] && source[prop].constructor === Object) {
	                        if (!obj[prop] || obj[prop].constructor === Object) {
	                            obj[prop] = obj[prop] || {};
	                            Common.extend(obj[prop], deepClone, source[prop]);
	                        } else {
	                            obj[prop] = source[prop];
	                        }
	                    } else {
	                        obj[prop] = source[prop];
	                    }
	                }
	            }
	        }
	        
	        return obj;
	    };
	
	    /**
	     * Creates a new clone of the object, if deep is true references will also be cloned.
	     * @method clone
	     * @param {} obj
	     * @param {bool} deep
	     * @return {} obj cloned
	     */
	    Common.clone = function(obj, deep) {
	        return Common.extend({}, deep, obj);
	    };
	
	    /**
	     * Returns the list of keys for the given object.
	     * @method keys
	     * @param {} obj
	     * @return {string[]} keys
	     */
	    Common.keys = function(obj) {
	        if (Object.keys)
	            return Object.keys(obj);
	
	        // avoid hasOwnProperty for performance
	        var keys = [];
	        for (var key in obj)
	            keys.push(key);
	        return keys;
	    };
	
	    /**
	     * Returns the list of values for the given object.
	     * @method values
	     * @param {} obj
	     * @return {array} Array of the objects property values
	     */
	    Common.values = function(obj) {
	        var values = [];
	        
	        if (Object.keys) {
	            var keys = Object.keys(obj);
	            for (var i = 0; i < keys.length; i++) {
	                values.push(obj[keys[i]]);
	            }
	            return values;
	        }
	        
	        // avoid hasOwnProperty for performance
	        for (var key in obj)
	            values.push(obj[key]);
	        return values;
	    };
	
	    /**
	     * Gets a value from `base` relative to the `path` string.
	     * @method get
	     * @param {} obj The base object
	     * @param {string} path The path relative to `base`, e.g. 'Foo.Bar.baz'
	     * @param {number} [begin] Path slice begin
	     * @param {number} [end] Path slice end
	     * @return {} The object at the given path
	     */
	    Common.get = function(obj, path, begin, end) {
	        path = path.split('.').slice(begin, end);
	
	        for (var i = 0; i < path.length; i += 1) {
	            obj = obj[path[i]];
	        }
	
	        return obj;
	    };
	
	    /**
	     * Sets a value on `base` relative to the given `path` string.
	     * @method set
	     * @param {} obj The base object
	     * @param {string} path The path relative to `base`, e.g. 'Foo.Bar.baz'
	     * @param {} val The value to set
	     * @param {number} [begin] Path slice begin
	     * @param {number} [end] Path slice end
	     * @return {} Pass through `val` for chaining
	     */
	    Common.set = function(obj, path, val, begin, end) {
	        var parts = path.split('.').slice(begin, end);
	        Common.get(obj, path, 0, -1)[parts[parts.length - 1]] = val;
	        return val;
	    };
	
	    /**
	     * Shuffles the given array in-place.
	     * The function uses a seeded random generator.
	     * @method shuffle
	     * @param {array} array
	     * @return {array} array shuffled randomly
	     */
	    Common.shuffle = function(array) {
	        for (var i = array.length - 1; i > 0; i--) {
	            var j = Math.floor(Common.random() * (i + 1));
	            var temp = array[i];
	            array[i] = array[j];
	            array[j] = temp;
	        }
	        return array;
	    };
	
	    /**
	     * Randomly chooses a value from a list with equal probability.
	     * The function uses a seeded random generator.
	     * @method choose
	     * @param {array} choices
	     * @return {object} A random choice object from the array
	     */
	    Common.choose = function(choices) {
	        return choices[Math.floor(Common.random() * choices.length)];
	    };
	
	    /**
	     * Returns true if the object is a HTMLElement, otherwise false.
	     * @method isElement
	     * @param {object} obj
	     * @return {boolean} True if the object is a HTMLElement, otherwise false
	     */
	    Common.isElement = function(obj) {
	        return obj instanceof HTMLElement;
	    };
	
	    /**
	     * Returns true if the object is an array.
	     * @method isArray
	     * @param {object} obj
	     * @return {boolean} True if the object is an array, otherwise false
	     */
	    Common.isArray = function(obj) {
	        return Object.prototype.toString.call(obj) === '[object Array]';
	    };
	
	    /**
	     * Returns true if the object is a function.
	     * @method isFunction
	     * @param {object} obj
	     * @return {boolean} True if the object is a function, otherwise false
	     */
	    Common.isFunction = function(obj) {
	        return typeof obj === "function";
	    };
	
	    /**
	     * Returns true if the object is a plain object.
	     * @method isPlainObject
	     * @param {object} obj
	     * @return {boolean} True if the object is a plain object, otherwise false
	     */
	    Common.isPlainObject = function(obj) {
	        return typeof obj === 'object' && obj.constructor === Object;
	    };
	
	    /**
	     * Returns true if the object is a string.
	     * @method isString
	     * @param {object} obj
	     * @return {boolean} True if the object is a string, otherwise false
	     */
	    Common.isString = function(obj) {
	        return Object.prototype.toString.call(obj) === '[object String]';
	    };
	    
	    /**
	     * Returns the given value clamped between a minimum and maximum value.
	     * @method clamp
	     * @param {number} value
	     * @param {number} min
	     * @param {number} max
	     * @return {number} The value clamped between min and max inclusive
	     */
	    Common.clamp = function(value, min, max) {
	        if (value < min)
	            return min;
	        if (value > max)
	            return max;
	        return value;
	    };
	    
	    /**
	     * Returns the sign of the given value.
	     * @method sign
	     * @param {number} value
	     * @return {number} -1 if negative, +1 if 0 or positive
	     */
	    Common.sign = function(value) {
	        return value < 0 ? -1 : 1;
	    };
	    
	    /**
	     * Returns the current timestamp since the time origin (e.g. from page load).
	     * The result will be high-resolution including decimal places if available.
	     * @method now
	     * @return {number} the current timestamp
	     */
	    Common.now = function() {
	        if (window.performance) {
	            if (window.performance.now) {
	                return window.performance.now();
	            } else if (window.performance.webkitNow) {
	                return window.performance.webkitNow();
	            }
	        }
	
	        return (new Date()) - Common._nowStartTime;
	    };
	    
	    /**
	     * Returns a random value between a minimum and a maximum value inclusive.
	     * The function uses a seeded random generator.
	     * @method random
	     * @param {number} min
	     * @param {number} max
	     * @return {number} A random number between min and max inclusive
	     */
	    Common.random = function(min, max) {
	        min = (typeof min !== "undefined") ? min : 0;
	        max = (typeof max !== "undefined") ? max : 1;
	        return min + _seededRandom() * (max - min);
	    };
	
	    var _seededRandom = function() {
	        // https://en.wikipedia.org/wiki/Linear_congruential_generator
	        Common._seed = (Common._seed * 9301 + 49297) % 233280;
	        return Common._seed / 233280;
	    };
	
	    /**
	     * Converts a CSS hex colour string into an integer.
	     * @method colorToNumber
	     * @param {string} colorString
	     * @return {number} An integer representing the CSS hex string
	     */
	    Common.colorToNumber = function(colorString) {
	        colorString = colorString.replace('#','');
	
	        if (colorString.length == 3) {
	            colorString = colorString.charAt(0) + colorString.charAt(0)
	                        + colorString.charAt(1) + colorString.charAt(1)
	                        + colorString.charAt(2) + colorString.charAt(2);
	        }
	
	        return parseInt(colorString, 16);
	    };
	
	    /**
	     * The console logging level to use, where each level includes all levels above and excludes the levels below.
	     * The default level is 'debug' which shows all console messages.  
	     *
	     * Possible level values are:
	     * - 0 = None
	     * - 1 = Debug
	     * - 2 = Info
	     * - 3 = Warn
	     * - 4 = Error
	     * @property Common.logLevel
	     * @type {Number}
	     * @default 1
	     */
	    Common.logLevel = 1;
	
	    /**
	     * Shows a `console.log` message only if the current `Common.logLevel` allows it.
	     * The message will be prefixed with 'matter-js' to make it easily identifiable.
	     * @method log
	     * @param ...objs {} The objects to log.
	     */
	    Common.log = function() {
	        if (console && Common.logLevel > 0 && Common.logLevel <= 3) {
	            console.log.apply(console, ['matter-js:'].concat(Array.prototype.slice.call(arguments)));
	        }
	    };
	
	    /**
	     * Shows a `console.info` message only if the current `Common.logLevel` allows it.
	     * The message will be prefixed with 'matter-js' to make it easily identifiable.
	     * @method info
	     * @param ...objs {} The objects to log.
	     */
	    Common.info = function() {
	        if (console && Common.logLevel > 0 && Common.logLevel <= 2) {
	            console.info.apply(console, ['matter-js:'].concat(Array.prototype.slice.call(arguments)));
	        }
	    };
	
	    /**
	     * Shows a `console.warn` message only if the current `Common.logLevel` allows it.
	     * The message will be prefixed with 'matter-js' to make it easily identifiable.
	     * @method warn
	     * @param ...objs {} The objects to log.
	     */
	    Common.warn = function() {
	        if (console && Common.logLevel > 0 && Common.logLevel <= 3) {
	            console.warn.apply(console, ['matter-js:'].concat(Array.prototype.slice.call(arguments)));
	        }
	    };
	
	    /**
	     * Returns the next unique sequential ID.
	     * @method nextId
	     * @return {Number} Unique sequential ID
	     */
	    Common.nextId = function() {
	        return Common._nextId++;
	    };
	
	    /**
	     * A cross browser compatible indexOf implementation.
	     * @method indexOf
	     * @param {array} haystack
	     * @param {object} needle
	     * @return {number} The position of needle in haystack, otherwise -1.
	    Common.indexOf = function(haystack, needle) {
	        if (haystack.indexOf)
	            return haystack.indexOf(needle);
	
	        for (var i = 0; i < haystack.length; i++) {
	            if (haystack[i] === needle)
	                return i;
	        }
	
	        return -1;
	    };
	     */
	
	    /**
	     * A cross browser compatible array map implementation.
	     * @method map
	     * @param {array} list
	     * @param {function} func
	     * @return {array} Values from list transformed by func.
	     */
	    Common.map = function(list, func) {
	        if (list.map) {
	            return list.map(func);
	        }
	
	        var mapped = [];
	
	        for (var i = 0; i < list.length; i += 1) {
	            mapped.push(func(list[i]));
	        }
	
	        return mapped;
	    };
	
	    /**
	     * Takes a directed graph and returns the partially ordered set of vertices in topological order.
	     * Circular dependencies are allowed.
	     * @method topologicalSort
	     * @param {object} graph
	     * @return {array} Partially ordered set of vertices in topological order.
	     */
	    Common.topologicalSort = function(graph) {
	        // https://github.com/mgechev/javascript-algorithms
	        // Copyright (c) Minko Gechev (MIT license)
	        // Modifications: tidy formatting and naming
	        var result = [],
	            visited = [],
	            temp = [];
	
	        for (var node in graph) {
	            if (!visited[node] && !temp[node]) {
	                _topologicalSort(node, visited, temp, graph, result);
	            }
	        }
	
	        return result;
	    };
	
	    var _topologicalSort = function(node, visited, temp, graph, result) {
	        var neighbors = graph[node] || [];
	        temp[node] = true;
	
	        for (var i = 0; i < neighbors.length; i += 1) {
	            var neighbor = neighbors[i];
	
	            if (temp[neighbor]) {
	                // skip circular dependencies
	                continue;
	            }
	
	            if (!visited[neighbor]) {
	                _topologicalSort(neighbor, visited, temp, graph, result);
	            }
	        }
	
	        temp[node] = false;
	        visited[node] = true;
	
	        result.push(node);
	    };
	
	    /**
	     * Takes _n_ functions as arguments and returns a new function that calls them in order.
	     * The arguments applied when calling the new function will also be applied to every function passed.
	     * The value of `this` refers to the last value returned in the chain that was not `undefined`.
	     * Therefore if a passed function does not return a value, the previously returned value is maintained.
	     * After all passed functions have been called the new function returns the last returned value (if any).
	     * If any of the passed functions are a chain, then the chain will be flattened.
	     * @method chain
	     * @param ...funcs {function} The functions to chain.
	     * @return {function} A new function that calls the passed functions in order.
	     */
	    Common.chain = function() {
	        var funcs = [];
	
	        for (var i = 0; i < arguments.length; i += 1) {
	            var func = arguments[i];
	
	            if (func._chained) {
	                // flatten already chained functions
	                funcs.push.apply(funcs, func._chained);
	            } else {
	                funcs.push(func);
	            }
	        }
	
	        var chain = function() {
	            // https://github.com/GoogleChrome/devtools-docs/issues/53#issuecomment-51941358
	            var lastResult,
	                args = new Array(arguments.length);
	
	            for (var i = 0, l = arguments.length; i < l; i++) {
	                args[i] = arguments[i];
	            }
	
	            for (i = 0; i < funcs.length; i += 1) {
	                var result = funcs[i].apply(lastResult, args);
	
	                if (typeof result !== 'undefined') {
	                    lastResult = result;
	                }
	            }
	
	            return lastResult;
	        };
	
	        chain._chained = funcs;
	
	        return chain;
	    };
	
	    /**
	     * Chains a function to excute before the original function on the given `path` relative to `base`.
	     * See also docs for `Common.chain`.
	     * @method chainPathBefore
	     * @param {} base The base object
	     * @param {string} path The path relative to `base`
	     * @param {function} func The function to chain before the original
	     * @return {function} The chained function that replaced the original
	     */
	    Common.chainPathBefore = function(base, path, func) {
	        return Common.set(base, path, Common.chain(
	            func,
	            Common.get(base, path)
	        ));
	    };
	
	    /**
	     * Chains a function to excute after the original function on the given `path` relative to `base`.
	     * See also docs for `Common.chain`.
	     * @method chainPathAfter
	     * @param {} base The base object
	     * @param {string} path The path relative to `base`
	     * @param {function} func The function to chain after the original
	     * @return {function} The chained function that replaced the original
	     */
	    Common.chainPathAfter = function(base, path, func) {
	        return Common.set(base, path, Common.chain(
	            Common.get(base, path),
	            func
	        ));
	    };
	
	})();


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return window.document;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var RND = __webpack_require__(579);
	
	var MATH_CONST = {
	
	    /**
	     * The value of PI * 2.
	     * 
	     * @name Phaser.Math.PI2
	     * @type {number}
	     * @since 3.0.0
	     */
	    PI2: Math.PI * 2,
	
	    /**
	     * The value of PI * 0.5.
	     * 
	     * @name Phaser.Math.TAU
	     * @type {number}
	     * @since 3.0.0
	     */
	    TAU: Math.PI * 0.5,
	
	    /**
	     * An epsilon value (1.0e-6)
	     * 
	     * @name Phaser.Math.EPSILON
	     * @type {number}
	     * @since 3.0.0
	     */
	    EPSILON: 1.0e-6,
	
	    /**
	     * For converting degrees to radians (PI / 180)
	     * 
	     * @name Phaser.Math.DEG_TO_RAD
	     * @type {number}
	     * @since 3.0.0
	     */
	    DEG_TO_RAD: Math.PI / 180,
	
	    /**
	     * For converting radians to degrees (180 / PI)
	     * 
	     * @name Phaser.Math.RAD_TO_DEG
	     * @type {number}
	     * @since 3.0.0
	     */
	    RAD_TO_DEG: 180 / Math.PI,
	
	    /**
	     * An instance of the Random Number Generator.
	     * 
	     * @name Phaser.Math.RND
	     * @type {Phaser.Math.RandomDataGenerator}
	     * @since 3.0.0
	     */
	    RND: new RND()
	
	};
	
	module.exports = MATH_CONST;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetFastValue = __webpack_require__(3);
	
	/**
	 * @typedef {object} GetTilesWithinFilteringOptions
	 *
	 * @property {boolean} [isNotEmpty=false] - If true, only return tiles that don't have -1 for an index.
	 * @property {boolean} [isColliding=false] - If true, only return tiles that collide on at least one side.
	 * @property {boolean} [hasInterestingFace=false] - If true, only return tiles that have at least one interesting face.
	 */
	
	/**
	 * Gets the tiles in the given rectangular area (in tile coordinates) of the layer.
	 *
	 * @function Phaser.Tilemaps.Components.GetTilesWithin
	 * @private
	 * @since 3.0.0
	 *
	 * @param {integer} tileX - [description]
	 * @param {integer} tileY - [description]
	 * @param {integer} width - [description]
	 * @param {integer} height - [description]
	 * @param {object} GetTilesWithinFilteringOptions - Optional filters to apply when getting the tiles.
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 * 
	 * @return {Phaser.Tilemaps.Tile[]} Array of Tile objects.
	 */
	var GetTilesWithin = function (tileX, tileY, width, height, filteringOptions, layer)
	{
	    if (tileX === undefined) { tileX = 0; }
	    if (tileY === undefined) { tileY = 0; }
	    if (width === undefined) { width = layer.width; }
	    if (height === undefined) { height = layer.height; }
	
	    var isNotEmpty = GetFastValue(filteringOptions, 'isNotEmpty', false);
	    var isColliding = GetFastValue(filteringOptions, 'isColliding', false);
	    var hasInterestingFace = GetFastValue(filteringOptions, 'hasInterestingFace', false);
	
	    // Clip x, y to top left of map, while shrinking width/height to match.
	    if (tileX < 0)
	    {
	        width += tileX;
	        tileX = 0;
	    }
	    if (tileY < 0)
	    {
	        height += tileY;
	        tileY = 0;
	    }
	
	    // Clip width and height to bottom right of map.
	    if (tileX + width > layer.width)
	    {
	        width = Math.max(layer.width - tileX, 0);
	    }
	    if (tileY + height > layer.height)
	    {
	        height = Math.max(layer.height - tileY, 0);
	    }
	
	    var results = [];
	
	    for (var ty = tileY; ty < tileY + height; ty++)
	    {
	        for (var tx = tileX; tx < tileX + width; tx++)
	        {
	            var tile = layer.data[ty][tx];
	            if (tile !== null)
	            {
	                if (isNotEmpty && tile.index === -1) { continue; }
	                if (isColliding && !tile.collides) { continue; }
	                if (hasInterestingFace && !tile.hasInterestingFace) { continue; }
	                results.push(tile);
	            }
	        }
	    }
	
	    return results;
	};
	
	module.exports = GetTilesWithin;


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var FILE_CONST = {
	
	    /**
	     * The Loader is idle.
	     * 
	     * @name Phaser.Loader.LOADER_IDLE
	     * @type {integer}
	     * @since 3.0.0
	     */
	    LOADER_IDLE: 0,
	
	    /**
	     * The Loader is actively loading.
	     * 
	     * @name Phaser.Loader.LOADER_LOADING
	     * @type {integer}
	     * @since 3.0.0
	     */
	    LOADER_LOADING: 1,
	
	    /**
	     * The Loader is processing files is has loaded.
	     * 
	     * @name Phaser.Loader.LOADER_PROCESSING
	     * @type {integer}
	     * @since 3.0.0
	     */
	    LOADER_PROCESSING: 2,
	
	    /**
	     * The Loader has completed loading and processing.
	     * 
	     * @name Phaser.Loader.LOADER_COMPLETE
	     * @type {integer}
	     * @since 3.0.0
	     */
	    LOADER_COMPLETE: 3,
	
	    /**
	     * The Loader is shutting down.
	     * 
	     * @name Phaser.Loader.LOADER_SHUTDOWN
	     * @type {integer}
	     * @since 3.0.0
	     */
	    LOADER_SHUTDOWN: 4,
	
	    /**
	     * The Loader has been destroyed.
	     * 
	     * @name Phaser.Loader.LOADER_DESTROYED
	     * @type {integer}
	     * @since 3.0.0
	     */
	    LOADER_DESTROYED: 5,
	
	    /**
	     * File is in the load queue but not yet started
	     * 
	     * @name Phaser.Loader.FILE_PENDING
	     * @type {integer}
	     * @since 3.0.0
	     */
	    FILE_PENDING: 10,
	
	    /**
	     * File has been started to load by the loader (onLoad called)
	     * 
	     * @name Phaser.Loader.FILE_LOADING
	     * @type {integer}
	     * @since 3.0.0
	     */
	    FILE_LOADING: 11,
	
	    /**
	     * File has loaded successfully, awaiting processing    
	     * 
	     * @name Phaser.Loader.FILE_LOADED
	     * @type {integer}
	     * @since 3.0.0
	     */
	    FILE_LOADED: 12,
	
	    /**
	     * File failed to load
	     * 
	     * @name Phaser.Loader.FILE_FAILED
	     * @type {integer}
	     * @since 3.0.0
	     */
	    FILE_FAILED: 13,
	
	    /**
	     * File is being processed (onProcess callback)
	     * 
	     * @name Phaser.Loader.FILE_PROCESSING
	     * @type {integer}
	     * @since 3.0.0
	     */
	    FILE_PROCESSING: 14,
	
	    /**
	     * The File has errored somehow during processing.
	     * 
	     * @name Phaser.Loader.FILE_ERRORED
	     * @type {integer}
	     * @since 3.0.0
	     */
	    FILE_ERRORED: 16,
	
	    /**
	     * File has finished processing.
	     * 
	     * @name Phaser.Loader.FILE_COMPLETE
	     * @type {integer}
	     * @since 3.0.0
	     */
	    FILE_COMPLETE: 17,
	
	    /**
	     * File has been destroyed
	     * 
	     * @name Phaser.Loader.FILE_DESTROYED
	     * @type {integer}
	     * @since 3.0.0
	     */
	    FILE_DESTROYED: 18,
	
	    /**
	     * File was populated from local data and doesn't need an HTTP request
	     * 
	     * @name Phaser.Loader.FILE_POPULATED
	     * @type {integer}
	     * @since 3.0.0
	     */
	    FILE_POPULATED: 19
	
	};
	
	module.exports = FILE_CONST;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var IsPlainObject = __webpack_require__(17);
	
	// @param {boolean} deep - Perform a deep copy?
	// @param {object} target - The target object to copy to.
	// @return {object} The extended object.
	
	/**
	 * This is a slightly modified version of http://api.jquery.com/jQuery.extend/
	 *
	 * @function Phaser.Utils.Object.Extend
	 * @since 3.0.0
	 *
	 * @return {object} [description]
	 */
	var Extend = function ()
	{
	    var options, name, src, copy, copyIsArray, clone,
	        target = arguments[0] || {},
	        i = 1,
	        length = arguments.length,
	        deep = false;
	
	    // Handle a deep copy situation
	    if (typeof target === 'boolean')
	    {
	        deep = target;
	        target = arguments[1] || {};
	
	        // skip the boolean and the target
	        i = 2;
	    }
	
	    // extend Phaser if only one argument is passed
	    if (length === i)
	    {
	        target = this;
	        --i;
	    }
	
	    for (; i < length; i++)
	    {
	        // Only deal with non-null/undefined values
	        if ((options = arguments[i]) != null)
	        {
	            // Extend the base object
	            for (name in options)
	            {
	                src = target[name];
	                copy = options[name];
	
	                // Prevent never-ending loop
	                if (target === copy)
	                {
	                    continue;
	                }
	
	                // Recurse if we're merging plain objects or arrays
	                if (deep && copy && (IsPlainObject(copy) || (copyIsArray = Array.isArray(copy))))
	                {
	                    if (copyIsArray)
	                    {
	                        copyIsArray = false;
	                        clone = src && Array.isArray(src) ? src : [];
	                    }
	                    else
	                    {
	                        clone = src && IsPlainObject(src) ? src : {};
	                    }
	
	                    // Never move original objects, clone them
	                    target[name] = Extend(deep, clone, copy);
	
	                // Don't bring in undefined values
	                }
	                else if (copy !== undefined)
	                {
	                    target[name] = copy;
	                }
	            }
	        }
	    }
	
	    // Return the modified object
	    return target;
	};
	
	module.exports = Extend;


/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(977) ], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	module.exports = {"version":"1.0.0","locale":"fr-BE","localization":{"page.title":"www.lesfermidables.be","errors.404.title":"Désolé, nous n’avons pas trouvé la page demandée.","navigation.home":"ACCUEIL","navigation.collect":"COLLECTIONNER","navigation.figurines":"FIGURINES","navigation.videos":"REGARDER","navigation.activities":"Bricoler","navigation.games":"JOUER","navigation.locale.nl_BE":"NL","navigation.locale.fr_BE":"FR","navigation.locale.nl_BE.full":"Nederlands","navigation.locale.fr_BE.full":"Français","navigation.menu.label":"MENU","footer.links.eula":"<a href='#eula' target='_blank'>Conditions générales</a>","footer.links.privacy_policy":"<a href='https://www.delhaize.be/fr-be/CP:privacy' target='_blank'>Déclaration de vie privée</a>","footer.links.contact":"<a href='https://www.delhaize.be/fr-be/onlineForm' target='_blank'>Contact</a>","footer.links.competition_rules":"<a href='#competion-rules' target='_blank'>Règlement du concours</a>","footer.links.delhaize":"<a href='https://www.delhaize.be' target='_blank'>delhaize.be</a>","footer.copyright":"<span class='copyright-symbol'>©</span> 2018 DELHAIZE <span class='copyright-symbol'>©</span> 2018 CARTAMUNDI - TOUS DROITS RÉSERVÉS","cookies.message":"En utilisant ce site, vous acceptez l’utilisation des cookies pour améliorer votre navigation.","cookies.link":"https://view.publitas.com/belgium-pdf/cookies-grocery-fr/page/1","cookies.link.text":"En savoir plus","cookies.button.text":"OK","countdown.title":"Prêt à partir<br/>à <span class='countdown-title-line'>l'aventure</span> avec nous?","countdown.days":"jours","countdown.day":"jour","countdown.hours":"heures","countdown.hour":"heure","countdown.mins":"minutes","countdown.min":"minute","countdown.secs":"secondes","countdown.sec":"seconde","home.title":"ÉPARGNE ET RÉCOLTE","home.subtitle":"du 7 juin au 15 août 2018","home.subtitle.small":"ÉPARGNE ET RÉCOLTE<br/>du 7 juin au </br>15 août 2018","home.figurines.carousel.title":"Découvre tous les FERMidables","home.figurines.carousel":"","home.intro.title":"<span class='bewitched'><span class='fat'>En</span>-c<span class='fat'>h</span>amp-<span class='fat'>t</span>ée","home.intro.text":"Je m’appelle Karla, je serai ton guide à la fermeeuh ! Accompagne-moi et saute vite dans le tracteur!<br/><br/>Ici, tu découvriras tout ce qu’il te faut savoir sur notre voyage: les mini-figurines, les autocollants, l’album, l’ensemencement de légumes et d’herbes à l’aide du plateau de semis, le montage d’une grange pour jouer avec tes mini-figurines, le jeu et bien d’autres choses encore. En plus, j’ai imaginé quelques jeux très rigolos.<br/><br/>Je te propose aussi de faire connaissance avec tous mes amis, les FERMidables. Je suis certaine que vous vous entendrez à merveille. À présent, il est temps de prendre le taureau par les cornes. Enfile tes bottes, car…","home.intro.tagline":"Nous partons en VOYAGE À LA FERME!","home.collect.title":"Prêt pour l’aventure?","home.collect.text":"Chaque fois que tes parents feront des courses dans leur supermarché, par tranche d’achats de €20,00 ou à l’achat de produits participants, tu recevras des pochettes contenant des autocollants, une carte à échanger contre une mini-figurine gratuite ou un sachet de semences. Tu pourras coller tes autocollants dans ton magnifique album.<br/>Et n’oublions pas la boîte de jeu et les mini-figurines, qui viendront compléter ta collection!","home.collect.button":"Découvre la collection","collect.title":"COLLECTIONNER","collect.flowpack.title":"Pochette","collect.flowpack.text":"Pour tout achat de €20,00, tes parents reçoivent une pochette. Tu peux aussi obtenir plus de pochettes grâce aux produits participants. Ces pochettes contiennent des autocollants à coller dans ton album, un sachet de semences ou une carte à échanger contre une figurine gratuite.","collect.flowpack.button":"Découvre les produits participants de cette semaine","collect.flowpack.stickers.title":"Autocollants","collect.flowpack.seeds.title":"12 SACHETS<br/>DE SEMENCES<br/>DIFFÉRENTES","collect.flowpack.card.title":"CARTE<br/>À ÉCHANGER","collect.flowpack.card.text":"Échange ta carte à la caisse contre l’une des 24 figurines!<br/>P.S.: il manque une figurine dans ta collection? Tu peux acheter les mini-figurines séparément au prix de €1,49 pièce.","collect.figurines.carousel.title":"Découvre tous les FERMidables","collect.figurines.carousel":"","collect.album.title":"ALBUM","collect.album.money":"€2,99","collect.album.text":"Collectionne tous tes autocollants dans ce magnifique album truffé d’anecdotes rigolotes et de jeux amusants!<br/><br/>P.S.: tu as des autocollants en double? N’hésite pas à les échanger avec tes amis.","collect.box.title":"BOÎTE","collect.box.money":"€4,99","collect.box.text":"Tu peux aussi créer ta propre ferme chez toi. La boîte contient un plateau de jeu et une grange à construire toi-même. Rassemble vite le kit de semis et les sachets de graines et regarde pousser les 12 sortent de semences.<br/>Tu veux t’y mettre tout de suite ? Découvre ici les règles du jeu et le manuel de construction de la grange.","collect.box.button.videos":"Regarde le film","collect.box.button.gamerules":"Télécharge les règles du jeu","figurines.title":"Figurines","figurines.carousel.title":"Découvre tous les FERMidables","figurines.carousel":"","figurines.hobby.label":"LOISIR: ","figurines.relation.label":"STATUS: ","figurines.food.label":"PLAT PRÉFÉRÉ: ","figurines.karla.name":"Karla","figurines.karla.description":"Meuh quelle belle journée, n’est-ce pas? C’est sympa de venir donner un coup de main! Je suis Karla et, comme je suis votre guide, je vais tout vous raconter sur la vie dans notre ferme. Il y a toujours quelque chose qui se passe, vous verrez. On espère que vous vous amuserez vachement bien!","figurines.karla.animal":"bœuf","figurines.karla.female":"vache","figurines.karla.male":"taureau","figurines.karla.age":"5 ans - 598 kg","figurines.karla.hobby":"faire visiter la ferme","figurines.karla.relation":"amoureuse de Diego le taureau","figurines.karla.food":"herbe fraîche","figurines.gerry.name":"Gerry","figurines.gerry.description":"Hêêêêêllo! Je m’appelle Gerry et c’est bien vrai ce qu’on dit – je fais parfois beaucoup de bouc-an... Surtout quand il y a des filles dans le coin, faut que je donne le mêêê-illeur de moi!","figurines.gerry.animal":"Chèvre","figurines.gerry.female":"Chèvre","figurines.gerry.male":"bouc","figurines.gerry.age":"8 ans - 50 kg","figurines.gerry.hobby":"mâchonner de tout","figurines.gerry.relation":"marié à Gerda la chèvre","figurines.gerry.food":"courgettes","figurines.corinne.name":"Corinne","figurines.corinne.description":"Côôôôt! Je suis Corinne et je vous souhaite la bienvenue dans notre ferme. La vie ici est très agréable et vous serez comme un coq en pâte pendant votre séjour!","figurines.corinne.animal":"poulet","figurines.corinne.female":"poule","figurines.corinne.male":"coq","figurines.corinne.age":"1 ans - 1,2 kg","figurines.corinne.hobby":"s’occuper des oeufs","figurines.corinne.relation":"mariée à Herbert le coq","figurines.corinne.food":"graines","figurines.bea.name":"Bea","figurines.bea.description":"Travail, travail, travail. Voilà la vie d’une abeille ouvrière. Mais il faut bien que quelqu'un le fasse, sinon il n’y aura zzzzzzamais de bon miel!","figurines.bea.animal":"abeille mellifère","figurines.bea.female":"ouvrière","figurines.bea.male":"faux bourdon","figurines.bea.age":"134 jours - 90 mg","figurines.bea.hobby":"butiner et fabriquer du miel","figurines.bea.relation":"célibataire et heureuse","figurines.bea.food":"nectar","figurines.leon.name":"Léon","figurines.leon.description":"Grmbl! Mon nom est Léon. Vous venez jouer avec moi dans la boue? Devise: 'Pig is beautiful'","figurines.leon.animal":"Cochon","figurines.leon.female":"truie","figurines.leon.male":"verrat","figurines.leon.age":"4 ans - 310 kg","figurines.leon.hobby":"se vautrer dans la boue","figurines.leon.relation":"amoureux de Zita la truie","figurines.leon.food":"glands","figurines.olga.name":"Olga","figurines.olga.description":"Bonjour, je m’appelle Olga! Mais, euh, je suis déjà un peu en retard. Je dois me dépêcher, je dois encore aller déposer quelques petits!","figurines.olga.animal":"cigogne","figurines.olga.female":"cigogne","figurines.olga.male":"cigogne","figurines.olga.age":"13 ans - 3,1 kg","figurines.olga.hobby":"s’occuper des petits","figurines.olga.relation":"mariée à Ollie la cigogne","figurines.olga.food":"limaces","figurines.sam.name":"Sam","figurines.sam.description":"Salut! Je suis un mouton de peu de mots. Alors pour faire bref: <span class='nowrap'>bêêêê-ienvenue!</span>","figurines.sam.animal":"mouton","figurines.sam.female":"brebis","figurines.sam.male":"bélier","figurines.sam.age":"19 ans - 124 kg","figurines.sam.hobby":"sauter par-dessus les clôtures","figurines.sam.relation":"marié à Olivia la brebis","figurines.sam.food":"jeunes branches de saule","figurines.pol.name":"Pol","figurines.pol.description":"Hey, je suis Pol. Je travaille comme un cheval, et je suis l’ami de tout le monde. Amusez-vous bien dans ce chouette endroit! Devise: 'À bride abattue!'","figurines.pol.animal":"cheval","figurines.pol.female":"jument","figurines.pol.male":"étalon","figurines.pol.age":"22 ans - 999 kg","figurines.pol.hobby":"travailler dur à la ferme","figurines.pol.relation":"marié à Mary la jument","figurines.pol.food":"herbe fraîche","figurines.martin.name":"Martin","figurines.martin.description":"Hello! Quel plaisir de vous avoir en visite dans notre ferme, notre petit paradis! Le travail est rude mais heureusement nous avons quand même le temps de souffler un peu tous ensemble.","figurines.martin.animal":"lapin","figurines.martin.female":"lapine","figurines.martin.male":"bouquin","figurines.martin.age":"4 ans - 2,2 kg","figurines.martin.hobby":"sautiller dans les prés","figurines.martin.relation":"marié à Conny la lapine","figurines.martin.food":"carottes","figurines.caroline.name":"Caroline","figurines.caroline.description":"Cancan! Je suis Caroline et je suis ici à la ferme pour le travail ‘délicat’. Venez me dire bonjour si vous me voyez au travail dans le champ!","figurines.caroline.animal":"canard","figurines.caroline.female":"cane","figurines.caroline.male":"canard","figurines.caroline.age":"6 ans - 1,234 kg","figurines.caroline.hobby":"nager","figurines.caroline.relation":"en couple","figurines.caroline.food":"graines","figurines.diego.name":"Diego","figurines.diego.description":"Ola! Je suis Diego et je suis le boss de la  ferme. Personne n’est plus fort que moi! J’espère que Karla l’a remarqué...","figurines.diego.animal":"bœuf","figurines.diego.female":"vache","figurines.diego.male":"taureau","figurines.diego.age":"4 ans - 1222 kg","figurines.diego.hobby":"pratiquer le power training et se balader avec Karla","figurines.diego.relation":"amoureux de Karla la vache","figurines.diego.food":"foin","figurines.viktor.name":"Viktor","figurines.viktor.description":"Je vous souhaite la bienvenue. Je suis Viktor et je suis déjà très vieux: je craque de partout. Ces derniers temps, les corbeaux et le renard me mènent la vie dure... Vous m’aidez à trouver une solution?","figurines.viktor.animal":"Épouvantail","figurines.viktor.female":"Épouvantail","figurines.viktor.male":"Épouvantail","figurines.viktor.age":"124 ans - 21 kg","figurines.viktor.hobby":"effrayer les corbeaux","figurines.viktor.relation":"à la recherche de l’âme sœur","figurines.viktor.food":"ne mange pas, toujours au régime","figurines.waldo.name":"Waldo","figurines.waldo.description":"Hej hej c’est Waldo! Nous venons passer l’hiver à la ferme. Quand les températures remonteront ici, nous rentrerons  chez nous dans le Nord.","figurines.waldo.animal":"oie","figurines.waldo.female":"jars","figurines.waldo.male":"jars","figurines.waldo.age":"18 ans - 3 kg","figurines.waldo.hobby":"voyager","figurines.waldo.relation":"célibataire","figurines.waldo.food":"salade","figurines.renee.name":"Renée","figurines.renee.description":"Je vous souhaite la bienvenue et une faon-tastique journée! Je suis Renée et j’adore faire la cuisine et de la pâtisserie. On se retrouve plus tard pour goûter quelques bons petits plats?","figurines.renee.animal":"cerf","figurines.renee.female":"biche","figurines.renee.male":"cerf","figurines.renee.age":"5 ans - 24 kg","figurines.renee.hobby":"saut en hauteur","figurines.renee.relation":"amoureuse de Rudy le chevreuil","figurines.renee.food":"jeunes branches d’arbres","figurines.ric.name":"Ric","figurines.ric.description":"Aaah... Bonjour et bienvenue dans cet endroit fabuleux. Vous le remarquerez vite: rien n’est ce qu'il paraît ici... Mouahahahaha!","figurines.ric.animal":"renard","figurines.ric.female":"renarde","figurines.ric.male":"renard","figurines.ric.age":"3 ans - 11 kg","figurines.ric.hobby":"chasser les poules","figurines.ric.relation":"célibataire","figurines.ric.food":"poules","figurines.maurice.name":"Maurice","figurines.maurice.description":"Mip, mon nom est Maurice et, avec toute ma famille, nous vous souhaitons de tout cœur la bienvenue à la ferme! Dites par hasard... Vous auriez pas un morceau de fromage? Même pas un tout mini bout?","figurines.maurice.animal":"campagnol","figurines.maurice.female":"campagnol","figurines.maurice.male":"campagnol","figurines.maurice.age":"1 ans - 28 g","figurines.maurice.hobby":"funambulisme","figurines.maurice.relation":"marié à Valérie le campagnol","figurines.maurice.food":"céréales et graines","figurines.henry.name":"Henry","figurines.henry.description":"Ouaf ouaf! Je suis Henry, le fidèle gardien de la ferme. Bienvenue chez nous! Mais surtout n'oubliez pas de toujours bien fermer la barrière, d'accord?","figurines.henry.animal":"chien","figurines.henry.female":"chienne","figurines.henry.male":"chien","figurines.henry.age":"10 ans - 31 kg","figurines.henry.hobby":"garder la ferme","figurines.henry.relation":"marié à Tina la chienne","figurines.henry.food":"steak","figurines.kitou.name":"Kitou","figurines.kitou.description":"Miaaaou, mon nom est Kitou! Vous venez jouer avec moi? Devise: 'Vous donnez votre langue au chat?'","figurines.kitou.animal":"chat","figurines.kitou.female":"chatte","figurines.kitou.male":"chat","figurines.kitou.age":"2 ans - 3,9 kg","figurines.kitou.hobby":"dormir","figurines.kitou.relation":"célibataire et heureux","figurines.kitou.food":"souris","figurines.max.name":"Max","figurines.max.description":"Hi haaaaan! Ici à la ferme, c’est très rigolo, vous verrez. Nous travaillons dur, mais nous nous appliquons tout autant à jouer. Bienvenue!","figurines.max.animal":"Âne","figurines.max.female":"ânesse","figurines.max.male":"baudet","figurines.max.age":"19 ans - 175 kg","figurines.max.hobby":"aider le cheval et le taureau à accomplir le dur labeur","figurines.max.relation":"à la recherche de l’âme soeur","figurines.max.food":"poires","figurines.didier.name":"Didier","figurines.didier.description":"Salut, moi, c’est Didier. Mes grand-parents viennent d’Amérique, mais moi, je reste ici pour toujours, avec mes amis de la ferme.","figurines.didier.animal":"dindon","figurines.didier.female":"dinde","figurines.didier.male":"dindon","figurines.didier.age":"3 ans - 12 kg","figurines.didier.hobby":"flâner avec des amis","figurines.didier.relation":"célibataire endurci","figurines.didier.food":"orties","figurines.astrid.name":"Astrid","figurines.astrid.description":"Aloha, quel plaisir d'accueillir un nouveau résident. Moi non plus je ne viens pas d’ici, mais je me sens comme chez moi. Alors à vous aussi: willkommen, bienvenue, welcome!","figurines.astrid.animal":"autruche","figurines.astrid.female":"autruche","figurines.astrid.male":"autruche","figurines.astrid.age":"15 ans - 108 kg","figurines.astrid.hobby":"jouer à cache-cache","figurines.astrid.relation":"mariée avec Sven l’autruche","figurines.astrid.food":"concombre","figurines.milla.name":"Milla","figurines.milla.description":"Allez, on va faire court parce que je dois retourner aux champs. Bienvenue! Je suis Milla, la taupe à tout faire de service. Profitez bien de l’endroit et... go, go, go!","figurines.milla.animal":"taupe","figurines.milla.female":"taupe","figurines.milla.male":"taupe","figurines.milla.age":"3 ans - 115 g","figurines.milla.hobby":"creuser et bricoler","figurines.milla.relation":"célibataire","figurines.milla.food":"vers de terre","figurines.herbert.name":"Herbert","figurines.herbert.description":"Cocoricoooo, je suis le coq de la ferme et j’adore mes petites poulettes. Je trouve que l’aurore a de l’or dans la bouche – et je le fais bien savoir à tout le monde, vous m’entendrez certainement demain à l’aube!","figurines.herbert.animal":"poulet","figurines.herbert.female":"poule","figurines.herbert.male":"coq","figurines.herbert.age":"4 ans - 2,6 kg","figurines.herbert.hobby":"se lever tôt","figurines.herbert.relation":"marié à Corinne la poule","figurines.herbert.food":"graines de maïs","figurines.cornelus.name":"Cornelus","figurines.cornelus.description":"Croâ croâ... Pssst... Vous n’avez pas besoin d'aider à la ferme, vous savez. Moi je ne le fais jamais. Il faut juste faire en sorte d’avoir ‘comme par hasard’ autre chose à faire... Et pendant ce temps vous pouvez chiper quelques grains par ci par là, c’est ce que je fais depuis des années. Ça marche super bien!","figurines.cornelus.animal":"corbeau","figurines.cornelus.female":"corbeau","figurines.cornelus.male":"corbeau","figurines.cornelus.age":"7 ans - 12 kg","figurines.cornelus.hobby":"taquiner Viktor","figurines.cornelus.relation":"célibataire et heureux","figurines.cornelus.food":"graines","video.title":"REGARDER","video.campagne.title":"QUE SE PASSE-T-IL À LA FERME CET ÉTÉ?","video.campagne.button.play":"","video.sow.title":"COMMENT SEMER?","video.sow.text":"Tu aimerais savoir comment une si petite graine se transforme en plante comestible? Cette vidéo t’initie en cinq étapes faciles.","video.barn.title":"CONSTRUIS LA GRANGE","video.barn.text":"Tu peux jouer avec toutes tes mini-figurines dans la seule et unique grange de la ferme.<br/>Retrousse-toi vite les manches et regarde la vidéo du montage.","activities.title":"Bricoler","activities.diy.title":"Kit de semis","activities.diy.text":"Tu as déjà rassemblé quelques sachets de graines? Super ! Alors montre que tu as la main verte et transforme-les en savoureux aliments. Comment ? En suivant les instructions de la vidéo!","activities.diy.button":"Regarde les instructions","activities.sow.text":"Quelle est la meilleure période pour semer ? Combien de temps faut-il attendre avant de pouvoir cueillir la première récolte ? Télécharge le calendrier de semis, imprime-le et affiche-le près de ton mini-potager.","activities.sow.button":"Télécharge le calendrier de semis","activities.boardgame.title":"jeu-des-fermidables","activities.boardgame.text":"Clique sur ce bouton pour découvrir les règles du jeu-des-FERMidables. Psst… Voici déjà une petite astuce: utilise un bouclier légume pour encore plus de fun!<br/>Bonne chance et… bon appétit!","activities.boardgame.button":"Télécharge les règles du jeu","activities.recipes.title":"AU TRAVAIL AVEC NOS LÉGUMES MAGIQUES","recipes.recept_id_1.title":"Soupe de fusées oranges et coco","recipes.recept_id_1.description":"<ol><li>Épluchez l’oignon et l’ail puis hachez-les. Épluchez le gingembre, hachez-le finement puis faites-le revenir avec l’ail, le cumin et l’oignon dans un peu de beurre et d’huile d’olive. Épluchez les carottes, hachez-les grossièrement et ajoutez-les au reste.</li><li>Couvrez avec 2 litres d’eau et portez à ébullition. Ajoutez les cubes de bouillon et laissez mijoter 20 minutes à feu moyen jusqu’à ce que les carottes soient fondantes.</li><li>Mixez finement la soupe avec un mixeur plongeant et laissez bouillir encore un peu. Ajoutez le jus d’orange et le curcuma, salez et poivrez à votre goût.</li><li>Hachez grossièrement les feuilles de coriandre. Parachevez la soupe avec la coriandre hachée et un soupçon de lait de coco. Les amateurs peuvent éventuellement ajouter un peu de tabasco.</li></ol>","recipes.recept_id_1.duration":"35 minutes","recipes.recept_id_1.persons":"4 personnes","recipes.recept_id_1.ingredients":"<ul><li>600 g de carottes</li><li>1 c. à s. d'huile d'olive</li><li>1 c. à s. de beurre</li><li>1 c. à s. de curcuma</li><li>1/2 c. à c. de cumin</li><li>de tabasco</li><li>1,5 dl de lait de coco</li><li>quelques branches de coriandre fraîche</li><li>3 cubes de bouillon de légumes</li><li>2 oranges (le jus)</li><li>2 gousses d’ail</li><li>1 gros oignon</li><li>5 cm de gingembre</li><li>2 dl d'eau</li></ul>","recipes.recept_id_2.title":"Crème brûlée de fusées oranges","recipes.recept_id_2.description":"<ol><li>Retirez le vert des carottes. Grattez-les rapidement, lavez-les et faites-les cuire à la vapeur jusqu’à ce qu’elles soient tendres. Mixez-les en une fine purée avec les zestes d’oranges confites et l’eau. Passez au tamis.</li><li>Préchauffez le four à 100ºC.</li><li>Fouettez les jaunes d’œufs avec le sucre de canne jusqu’à ce qu’ils blanchissent. Ajoutez la crème, la purée de carottes et donnez deux tours de moulin de poivre du Sichuan. Mélangez, versez dans des plats individuels et faites cuire 1 h. La crème sera encore tremblante, elle se raffermit en refroidissant. Laissez reposer 2 h au frais.</li><li>En assiette: au moment de servir, parsemez les crèmes de cassonade et faites caraméliser sous le gril du four ou au chalumeau de cuisine.</li></ol>","recipes.recept_id_2.duration":"15 minutes","recipes.recept_id_2.persons":"4 personnes","recipes.recept_id_2.ingredients":"<ul><li>400 g de carottes nouvelles</li><li>10 dl d'eau</li><li>25 cl de crème liquide</li><li>4 jaunes d'œufs</li><li>15 g de zeste d’oranges confites</li><li>50 g de sucre de canne en poudre</li><li>3 c. à s. de cassonade de candi blonde</li><li>poivre du Sichuan</li></ul>","recipes.recept_id_3.title":"Granité aux pommes et frisbees de lutins","recipes.recept_id_3.description":"<ol><li>Pelez les pommes et taillez-les en morceaux. Pelez le citron vert à vif et coupez la chair en morceaux. Taillez le ½ concombre (non épluché) en morceaux.</li><li>Versez le tout dans le bol du blender et ajoutez le sucre de riz, le jus de pomme, le basilic et les feuilles de menthe. Mixez jusqu'à obtention d'une préparation homogène.</li><li>Passez-la au chinois et versez-la dans un grand récipient à fond plat. Faites prendre 4 h au congélateur.</li><li>Grattez la préparation à la fourchette, répartissez dans des verres et décorez de menthe. Dégustez aussitôt, à la paille ou à la cuillère.</li></ol>","recipes.recept_id_3.duration":"10 min + 4 h de congélation","recipes.recept_id_3.persons":"4 personnes","recipes.recept_id_3.ingredients":"<ul><li>2 pommes Granny Smith</li><li>1 citron vert</li><li>1/2 Concombre</li><li>2 dl de jus de pomme</li><li>3 brins de basilic</li><li>3 brins de menthe</li><li>4 c à s de sucre de riz liquide (ou de miel)</li><li>4 brins de menthe pour décorer</li></ul>","recipes.recept_id_4.title":"Frisbees de lutins en soupe","recipes.recept_id_4.description":"<ol><li>Mixez longuement la chair des concombres avec 20 cl d’eau, le tabasco, les pignons, le fromage et les raisins, jusqu’à obtention d’une soupe homogène.</li><li>Rectifiez l’assaisonnement. Réservez, 2 h, au frais. Servez dans des bols et saupoudrez de persil haché.</li></ol>","recipes.recept_id_4.duration":"30 minutes","recipes.recept_id_4.persons":"6 personnes","recipes.recept_id_4.ingredients":"<ul><li>2 c. à s. de persil plat haché</li><li>1 c. à c. sauce tabasco vert</li><li>la chair de 2 concombres</li><li>25 g de pignons de pin</li><li>25 g de raisins secs</li><li>100 g de fromage frais en barquette</li><li>20 dl d'eau</li><li>sel</li><li>Poivre noir</li></ul>","recipes.recept_id_5.title":"Salade de luzerne et dents de dragon","recipes.recept_id_5.description":"<ol><li>Nettoyez les radis et coupez-les en morceaux (en rondelles ou en 4). Nettoyez le(s) chicon(s) et éliminez-en les extrémités. Rincez les feuilles. Égouttez bien l’artichaut. Lavez la salade et les épinards, égouttez-les, mélangez-les avec les radis, les feuilles de chicon et l’artichaut.</li><li>Saupoudrez la salade avec les graines, les pignons et les germes. Arrosez d’huile de noix.</li><li>Préparez le dressing en mélangeant tous les ingrédients et versez-le sur la salade.</li></ol>","recipes.recept_id_5.duration":"20 minutes","recipes.recept_id_5.persons":"4 personnes","recipes.recept_id_5.ingredients":"<ul><li>20 g de germes de radis</li><li>1/2 citron (le jus, pour le dressing)</li><li>1 c. à s. de moutarde (pour le dressing)</li><li>4 chicons</li><li>poivre et sel (pour le dressing)</li><li>4 c. à s. d’huile de noix</li><li>40 g de pignons de pin</li><li>30 g de graines de lin brisées</li><li>40 g de graines de tournesol</li><li>90 g d’artichaut en bocal</li><li>1 botte de radis</li><li>1 poignée de jeunes épinards</li><li>1 sachet de salade mixte</li><li>20 g de germes de luzerne</li><li>20 g de cressonnette</li><li>2 c. à s. de mayonnaise (pour le dressing)</li><li>1 c. à c. de miel (pour le dressing)</li><li>2 c. à s. d'eau (pour le dressing)</li><li>1 c. à s. d’huile d’olive (pour le dressing)</li><li>2 c. à s. de vinaigre de vin blanc (pour le dressing)</li></ul>","recipes.recept_id_6.title":"Skis de grenouille en roulade et pâtes au gratin","recipes.recept_id_6.description":"<ol><li>Equeutez les haricots verts et faites-les cuire 8 min. à l’eau bouillante. Egouttez-les et rafraîchissez-les à l’eau froide.</li><li>D’autre part, faites cuire les pâtes 3 min. de moins que le temps indiqué sur l’emballage. Egouttez-les et rafraîchissez-les un peu à l’eau froide.</li><li>Préchauffez le four sur th. 7 – 210°C.</li><li>Mélangez les pâtes avec la sauce Basilico et étalez-les dans grand plat à four. Enroulez les haricots verts par petits paquets dans les tranches de jambon et déposez-les au fur et à mesure sur les pâtes. Nappez le tout avec la béchamel et saupoudrez de fromage râpé. Faites dorer 15 min. au four.</li><li>Servez chaud, avec une salade.</li></ol>","recipes.recept_id_6.duration":"20 min. de préparation + 15 min. de cuisson","recipes.recept_id_6.persons":"4 personnes","recipes.recept_id_6.ingredients":"<ul><li>200 g de jambon « Kids »</li><li>250 g de haricots verts fins</li><li>350 g de castellani ou de penne rigate</li><li>25 cl de sauce béchamel</li><li>100 g de fromage râpé spécial gratin</li><li>500 g de sauce pour pâtes « Basilico » (en bocal)</li></ul>","recipes.recept_id_7.title":"Boîtes à trésors remplies","recipes.recept_id_7.description":"<ol><li>Coupez les poivrons en deux et videz-les.</li><li>Mélangez la viande hachée avec l'oeuf, la chapelure, du sel et du poivre. Remplissez les demi-poivrons avec la farce. Faites cuire au four à 180°C.</li><li>Coupez finement les échalotes et une gousse d'ail et faites-les revenir à la poêle dans un filet d'huile d'olive. Versez-y les tomates en dés et laissez mijoter.</li><li>Coupez les courgettes en dés et faites-les revenir à l'huile d'olive dans une poêle. Faites cuire le riz et ajoutez-le à la poêlée de courgettes. Laissez cuire et assaisonnez de sel et poivre.</li></ol>","recipes.recept_id_7.duration":"Moins ou égale à 30 min.","recipes.recept_id_7.persons":"4 personnes","recipes.recept_id_7.ingredients":"<ul><li>2 courgettes</li><li>d'huile d'olive</li><li>400 g de tomates pelées en cubes bio</li><li>1 gousse d’ail</li><li>2 échalotes</li><li>250 g de riz de basmati bio</li><li>200 g de chapelure</li><li>1 œuf bio</li><li>400 g de haché (porc & bœuf) bio</li><li>2 poivrons</li></ul>","recipes.recept_id_8.title":"Canoës d’indiens croustillants","recipes.recept_id_8.description":"<ol><li>Pour la panure: mixez du vieux pain rassis (ou simplement de la chapelure), les graines de sésames, noisettes, graines de coriandre, curcuma et gingembre sec.</li><li>Coupez les aubergines en rondelles de +/- 1 cm, saupoudrez-les de sel et laissez-les dégorger. Trempez-les dans la chapelure, puis faites-les revenir dans une poêle à l’huile d’olive.</li><li>A la fin, parsemez de coriandre fraîche, de fleur de sel et de piment d’espelette. Se mange accompagné d’un chutney de mangue indien.</li></ol>","recipes.recept_id_8.duration":" Préparation: 20 min. - Cuisson: 5 min.","recipes.recept_id_8.persons":"4 personnes","recipes.recept_id_8.ingredients":"<ul><li>2 d’aubergine</li><li>70 g de chapelure ou de vieux pain rassis</li><li>2 c. à s. de graines de sésames et noisettes</li><li>1 c. à s. graines de coriandre</li><li>1/2 c. à s. de curcuma et de gingembre sec</li><li>de sel</li><li>huile d'olive</li><li>un peu de coriandre fraîche</li><li>chutney de mangue indien</li></ul>","recipes.recept_id_9.title":"Salade de fusées oranges aux amandes et aux herbes","recipes.recept_id_9.description":"<ol><li>Taillez les carottes épluchées en bâtonnets ou en rondelles. Plongez-les dans un poêlon d’eau bouillante salée et égouttez-les après 3 min de cuisson environ ; elles doivent rester croquantes. Rafraîchissez-les longuement à l’eau froide et laissez-les égoutter.</li><li>Faites griller les amandes à sec, dans une poêle anti-adhésive, puis hachez-les grossièrement.</li><li>Versez les herbes et l’oignon rouge finement hachés dans un saladier. Ajoutez les carottes, les amandes, le vinaigre, l’huile et le cumin. Mélangez bien et rectifiez l’assaisonnement.</li><li>Couvrez et laissez reposer 1 h au frigo avant de servir.</li><li>Servez frais, en accompagnement de grillades. Super également pour un mezze oriental.</li></ol>","recipes.recept_id_9.duration":"Plus que 30 min.","recipes.recept_id_9.persons":"5 personnes","recipes.recept_id_9.ingredients":"<ul><li>500 g belles carottes</li><li>1/2 c. à c. de cumin moulu</li><li>50 g d'amandes mondées</li><li>1 petit oignon rouge</li><li>4 c. à s. d'huile d'olive</li><li>poivre</li><li>8 branches de persil plat</li><li>8 branches de coriandre fraîche</li><li>2 c. à s. de vinaigre de vin</li></ul>","recipes.recept_id_10.title":"Nez de clowns et salade pasta mamma mia","recipes.recept_id_10.description":"<ol><li>Cuisine toujours sous la surveillance d’un adulte.</li><li>Demande-lui de faire chauffer une grande casserole d’eau salée ; quand elle bout, verse-y les pâtes, mélange-les et respecte bien le temps de cuisson indiqué sur l’emballage, pour qu’elles soient « al dente ». Tu pourras ensuite les égoutter et les rincer longuement à l’eau froide.</li><li>D’autre part, presse le jus du citron et verse-le dans un saladier. Ajoute l’huile et le pesto ; mélange bien.</li><li>Retire la peau et les pépins de melon, puis coupe le melon en dés (il t’en faut environ 300 g). Verse-les dans le saladier et ajoute les tomates-cerise coupées en 2, les perlines de mozzarella (ou les boules taillées en petits dés), ainsi que les pâtes bien égouttées et le jambon émincé en lanières (avec des ciseaux, c’est plus facile).</li><li>Mélange bien, goûte et ajoute du sel et du poivre, si nécessaire. Saupoudre de basilic haché et couvre le saladier. Laisse reposer environ 2 h au frigo.</li><li>Sers bien frais, en entrée ou comme plat.</li></ol>","recipes.recept_id_10.duration":"Plus que 30 min.","recipes.recept_id_10.persons":"4 personnes","recipes.recept_id_10.ingredients":"<ul><li>250 g « conchiglie » (ou autres pâtes courtes, au choix)</li><li>quelques feuilles de basilic</li><li>poivre</li><li>2 raviers « perline » de mozzarella (ou boules)</li><li>1 citron</li><li>1/2 melon charentais</li><li>250 g de tomates-cerises</li><li>3 c. à s. d'huile d'olive</li><li>3 c. à s. de pesto</li><li>100 g prosciutto (jambon cru italien)</li></ul>","activities.coloring.title":"TÉLÉCHARGE ET IMPRIME CES DESSINS À COLORIER","activities.coloring.button":"<a href='http://boerdereis.be' target='_blank'>Imprime les dessins à colorier</a>","games.title":"JOUER","games.back":"Retour à l’aperçu","games.carrot.title":"FUSÉE ORANGE","games.carrot.text":"Aide Martin le lapin à cueillir un maximum de carottes pour son gâteau fusée orange. Tu aperçois une carotte? Attrape-la vite! Mais ne va pas te cogner contre une clôture ou un ballot de paille, sinon, la partie est finie…","games.carrot.button":"Démarre le jeu","games.scarecrow.title":"ÉPOUVANTAIL","games.scarecrow.text":"Attention! Les oiseaux essaient de chiper toutes les graines de maïs que nous venons de semer. Aide Viktor à chasser tous les oiseaux. Seras-tu assez rapide?","games.scarecrow.button":"A toi de jouer!","games.chicken.title":"CRÈCHE DES POUSSINS","games.chicken.text":"Meuuuuh! Les poussins s’échappent! Corinne la poule doit rester sur son nid. Et elle compte sur toi pour lui ramener ses petits.<br/>Cot, cot, cot… Partez!","games.chicken.button":"Joue à la crèche des poussins","contact.title":"Contact","contact.text":"Heb je een vraag over De BOER-DE-REIS? Stel ze dan hier! ","contact.form.labels.name":"Naam en voornaam","contact.form.labels.email":"E-mail","contact.form.labels.message":"Stel je vraag","contact.submit.success.dialog.title":"Bericht verstuurd","contact.submit.success.dialog.message":"Je bericht is verzonden, wij nemen binnenkort contact met jou op.","contact.form.submit":"Verstuur","games.carrot.game.title":"RÉCOLTE TOUTES LES CAROTTES !","games.carrot.game.description.line1":"Touche l’écran ou appuie sur la flèche pour faire","games.carrot.game.description.line2":"sauter Martin le lapin et éviter les obstacles.","games.carrot.game.powerups.shield.title":"BOUCLIER","games.carrot.game.powerups.shield.description.line1":"Protège contre","games.carrot.game.powerups.shield.description.line2":"les obstacles","games.carrot.game.powerups.springball.title":"BALLON SAUTEUR","games.carrot.game.powerups.springball.description.line1":"Permet de sauter","games.carrot.game.powerups.springball.description.line2":"plus haut","games.carrot.game.powerups.rocket_cake.title":"FUSÉE","games.carrot.game.powerups.rocket_cake.description.line1":"Collectionne deux fois","games.carrot.game.powerups.rocket_cake.description.line2":"plus de carottes","games.carrot.game.powerups.magnet.title":"AIMANT","games.carrot.game.powerups.magnet.description.line1":"Attire automatiquement","games.carrot.game.powerups.magnet.description.line2":"les carottes","games.carrot.game.start.btn":"Démarrer le jeu","games.carrot.game.resume.btn":"Hervat het spel","games.carrot.game.gameover.title":"BIEN JOUÉ !","games.carrot.game.gameover.highscore":"Meilleur score: ","games.carrot.game.gameover.replay.btn":"Réessayer","games.chicken.game.title":"RETIENS TOUS LES POUSSINS DANS LE POULAILLER !","games.chicken.game.description.line1":"Corinne la poule couve tranquillement, installée sur son nid. Ses œufs éclosent un à un, et les","games.chicken.game.description.line2":"poussins se mettent à courir partout. Mais Corinne ne peut pas quitter son nid. À toi de veiller à ce","games.chicken.game.description.line3":"que les poussins ne s’éloignent pas.","games.chicken.game.description.line5":"Attrape les poussins et dépose-les près de Corinne. La partie est terminée lorsqu’un poussin a réussi","games.chicken.game.description.line6":"à s’échapper.","games.chicken.game.start.btn":"Démarrer le jeu","games.chicken.game.resume.btn":"Reprend le jeu","games.chicken.game.gameover.title":"BIEN JOUÉ !","games.chicken.game.gameover.highscore":"Meilleur temps: ","games.chicken.game.gameover.replay.btn":"Réessayer"}}

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	module.exports = {"version":"1.0.0","locale":"nl-BE","localization":{"page.title":"www.deboerdereis.be","errors.404.title":"Excuses, we hebben deze pagina niet gevonden.","navigation.home":"Home","navigation.collect":"Verzamelen","navigation.figurines":"Figuurtjes","navigation.videos":"Kijken","navigation.activities":"Doen","navigation.games":"Spelen","navigation.locale.nl_BE":"NL","navigation.locale.fr_BE":"FR","navigation.locale.nl_BE.full":"Nederlands","navigation.locale.fr_BE.full":"Français","navigation.menu.label":"MENU","footer.links.eula":"<a href='#eula' target='_blank'>Algemene voorwaarden</a>","footer.links.privacy_policy":"<a href='https://www.delhaize.be/nl-be/CP:privacy' target='_blank'>Privacyverklaring</a>","footer.links.contact":"<a href='https://www.delhaize.be/nl-be/onlineForm' target='_blank'>Contact</a>","footer.links.competition_rules":"<a href='#competion-rules' target='_blank'>Wedstrijdreglement</a>","footer.links.delhaize":"<a href='https://www.delhaize.be' target='_blank'>delhaize.be</a>","footer.copyright":"<span class='copyright-symbol'>©</span> 2018 DELHAIZE <span class='copyright-symbol'>©</span> 2018 CARTAMUNDI - ALL RIGHTS RESERVED","cookies.message":"Door deze website te gebruiken, aanvaardt u het gebruik van cookies om uw surfervaring gemakkelijker te maken.","cookies.link":"https://view.publitas.com/belgium-pdf-nl/cookies-grocery-nl/page/1","cookies.link.text":"Meer weten","cookies.button.text":"OK","countdown.title":"Klaar om met ons<br/>op<span class='countdown-title-line'> reis </span>te gaan?","countdown.days":"dagen","countdown.day":"dag","countdown.hours":"uren","countdown.hour":"uur","countdown.mins":"minuten","countdown.min":"minuut","countdown.secs":"seconden","countdown.sec":"seconde","home.title":"Spaar en oogst","home.subtitle":"van 7 juni tot 15 augustus 2018","home.subtitle.small":"Spaar mee<br/>van 7 juni tot 15 augustus 2018","home.figurines.carousel.title":"Ontdek alle figuurtjes","home.figurines.carousel":"","home.intro.title":"<span class='bewitched'><span class='fat'>Ko</span>eie<span class='fat'>d</span>a<span class='fat'>g!</span>","home.intro.text":"Ik ben Karla, reisleidster van de BOER-DE-REIS. Reis je met me mee? Spring maar op de tractor!<br/><br/>Hier ontdek je alles over onze BOER-DE-REIS: de figuurtjes, de stickers, het album, hoe je kruiden en groentjes kunt zaaien met de zaaitray, hoe je een heuse schuur bouwt, het spel speelt en nog véél meer. Bovendien bedacht ik ook enkele te gekke spelletjes.<br/><br/>Ik nodig je ook graag uit om al onze boerderijvriendjes beter te leren kennen. Ik weet zeker dat jullie elkaar leuk zullen vinden. Tijd om de koe bij de horens te vatten. Trek je laarzen aan, want…","home.intro.tagline":"We gaan op BOER-DE-REIS!","home.collect.title":"Is je BOER-DE-REIS-koffer al gepakt?","home.collect.text":"Telkens je ouders voor €20,00 boodschappen doen of deelnemende producten aankopen bij jouw supermarkt, krijg je een zakje met stickers, een inruilkaart voor een gratis figuurtje of een zaaizakje. De stickers bewaar je allemaal samen in het superleuke album.<br/>Natuurlijk mogen ook de speldoos en de figuurtjes niet ontbreken: zij maken je collectie compleet!","home.collect.button":"Ontdek alle details hier","collect.title":"Verzamelen","collect.flowpack.title":"Zakje","collect.flowpack.text":"Bij elke aankoop van €20,00 krijgen je ouders een zakje. Je kan ook extra zakjes krijgen bij deelnemende producten. Daarin zitten stickers voor het album, een zaaizakje of een inruilkaart voor een figuurtje.","collect.flowpack.button":"Ontdek de deelnemende producten van deze week","collect.flowpack.stickers.title":"Stickers","collect.flowpack.seeds.title":"12 verschillende zaaizakjes","collect.flowpack.card.title":"Inruilkaart","collect.flowpack.card.text":"Wissel je inruilkaart aan de kassa in voor een van de 24 figuurtjes!<br/><br/>PS: mis je er nog eentje in je verzameling? Je kunt de figuurtjes apart kopen voor €1,49 per stuk.","collect.figurines.carousel.title":"Ontdek alle figuurtjes","collect.figurines.carousel":"","collect.album.title":"Stickeralbum","collect.album.money":"€2,99","collect.album.text":"In dit geweldige stickeralbum verzamel je al je stickers. Bovendien staat het album eivol grappige weetjes en te gekke spelletjes!<br/><br/>PS: heb je stickers dubbel, dan kan je met je vriendjes ruilen om je album volledig te maken.","collect.box.title":"Doos","collect.box.money":"€4,99","collect.box.text":"Je kunt onze boerderij ook in huis halen. In de doos vind je een spelbord en een schuur om zelf te bouwen. Sprokkel vlug de zaaikit en zaaizakjes bij elkaar en zie de 12 soorten zaadjes ontkiemen voor je ogen.<br/>Meteen aan de slag? Ontdek hier de spelregels en de handleiding om zelf de schuur te bouwen.","collect.box.button.videos":"Bekijk het filmpje","collect.box.button.gamerules":"Download de spelregels","figurines.title":"Figuurtjes","figurines.carousel.title":"Ontdek alle figuurtjes","figurines.carousel":"","figurines.hobby.label":"HOBBY: ","figurines.relation.label":"STATUS: ","figurines.food.label":"LIEVELINGSETEN: ","figurines.karla.name":"Karla","figurines.karla.description":"‘Hallo, wat een MEUH-ooie dag, he? Zo fijn dat je een handje komt toesteken! Ik ben Karla en als reisleidster zal ik jou alles vertellen over het leven op onze boerderij. Hier valt altijd wat te beleven, dat zal je zien. Hopelijk vind jij het hier net zo BOE-iend als wij!’","figurines.karla.animal":"rund","figurines.karla.female":"koe","figurines.karla.male":"stier","figurines.karla.age":"5 jaar - 598 kg","figurines.karla.hobby":"gasten rondleiden op de boerderij","figurines.karla.relation":"verliefd op Diego de stier","figurines.karla.food":"vers gras","figurines.gerry.name":"Gerry","figurines.gerry.description":"Dàààààg! Mijn naam is Gerry en het is waar wat ze zeggen – ik maak weleens veel herrie… Zeker als er vrouwtjes in de buurt zijn, dan ben ik op mijn bè-hè-hèst!","figurines.gerry.animal":"geit","figurines.gerry.female":"geit","figurines.gerry.male":"bok","figurines.gerry.age":"8 jaar - 50 kg","figurines.gerry.hobby":"knabbelen op vanalles en nog wat","figurines.gerry.relation":"getrouwd met Gerda de geit","figurines.gerry.food":"courgetten","figurines.corinne.name":"Corinne","figurines.corinne.description":"Pôôôk! Ik ben Corinne en ik heet je van harte welkom op onze boerderij. Het is hier erg gezellig dus jouw verblijf hier wordt vast een eitje!","figurines.corinne.animal":"kip","figurines.corinne.female":"hen","figurines.corinne.male":"haan","figurines.corinne.age":"1 jaar - 1,2 kg","figurines.corinne.hobby":"zorgen voor de eitjes","figurines.corinne.relation":"getrouwd met Herbert de haan","figurines.corinne.food":"graantjes","figurines.bea.name":"Bea","figurines.bea.description":"Werken, werken, werken. Dat is het leven van een bij. Maar iémand moet het doen, anders zou er nooit zzzzulke zzzzalig lekkere honing zijn, toch?","figurines.bea.animal":"honingbij","figurines.bea.female":"werkster","figurines.bea.male":"dar","figurines.bea.age":"134 dagen - 90 mg","figurines.bea.hobby":"honing maken en rondvliegen","figurines.bea.relation":"happy single","figurines.bea.food":"nectar","figurines.leon.name":"Léon","figurines.leon.description":"Knor! Léon is de naam. Kom je met me meespelen in het modderbad? Mijn motto: 'Big is beautiful.'","figurines.leon.animal":"varken","figurines.leon.female":"zeug","figurines.leon.male":"beer","figurines.leon.age":"4 jaar - 310 kg","figurines.leon.hobby":"rollebollen in het modderbad","figurines.leon.relation":"verliefd op Zita de zeug","figurines.leon.food":"eikels","figurines.olga.name":"Olga","figurines.olga.description":"Goeiedag, ik ben Olga! Maar, euh, ik ben alweer wat laat. Ik moet me haasten, ik moet dringend nog wat kleintjes rondbrengen!","figurines.olga.animal":"ooievaar","figurines.olga.female":"ooievaar","figurines.olga.male":"ooievaar","figurines.olga.age":"13 jaar - 3,1 kg","figurines.olga.hobby":"kleintjes verzorgen","figurines.olga.relation":"getrouwd met Ollie de ooievaar","figurines.olga.food":"slakken","figurines.sam.name":"Sam","figurines.sam.description":"Hooi! Ik ben een schaap van weinig woorden. Dus kort en krachtig: wèèèèlkom!","figurines.sam.animal":"schaap","figurines.sam.female":"ooi","figurines.sam.male":"ram","figurines.sam.age":"19 jaar - 124 kg","figurines.sam.hobby":"over hekjes springen","figurines.sam.relation":"getrouwd met Olivia de ooi","figurines.sam.food":"wilgentwijgjes","figurines.pol.name":"Pol","figurines.pol.description":"Hey, ik ben Pol. Ik werk als een paard, ik heb altijd honger als een paard en ik ben de vriend van iedereen. Veel plezier op deze coole plek, man! Mijn motto: 'Volle paardenkracht vooruit!'","figurines.pol.animal":"paard","figurines.pol.female":"merrie","figurines.pol.male":"hengst","figurines.pol.age":"22 jaar - 999 kg","figurines.pol.hobby":"hard werken op de boerderij","figurines.pol.relation":"getrouwd met Mary de merrie","figurines.pol.food":"gras","figurines.martin.name":"Martin","figurines.martin.description":"Hoi, fijn dat je eens op bezoek komt in onze boerderij, ons kleine paradijs! We moeten hier hard werken, maar gelukkig is er ook weleens tijd om gezellig rond te hangen.","figurines.martin.animal":"konijn","figurines.martin.female":"moer","figurines.martin.male":"rammelaar","figurines.martin.age":"4 jaar - 2,2 kg","figurines.martin.hobby":"huppelen in de wei","figurines.martin.relation":"getrouwd met Conny de moer","figurines.martin.food":"wortels","figurines.caroline.name":"Caroline","figurines.caroline.description":"Kwaak! Ik ben Caroline en ik ben hier op de boerderij eerder van het ‘fijne’ werk. Kom zeker eens hallo zeggen als je me aan het werk ziet op het veld!","figurines.caroline.animal":"eend","figurines.caroline.female":"eend","figurines.caroline.male":"woerd","figurines.caroline.age":"6 jaar - 1,234 kg","figurines.caroline.hobby":"zwemmen","figurines.caroline.relation":"in een relatie","figurines.caroline.food":"granen","figurines.diego.name":"Diego","figurines.diego.description":"Ola! Ik ben Diego en ik ben de kanjer van de boerderij. Niemand is sterker dan ik! Hopelijk weet Karla dat ook…","figurines.diego.animal":"rund","figurines.diego.female":"koe","figurines.diego.male":"rund","figurines.diego.age":"4 jaar - 1222 kg","figurines.diego.hobby":"powertraining en met Karla op stap gaan","figurines.diego.relation":"verliefd op Karla de koe","figurines.diego.food":"hooi","figurines.viktor.name":"Viktor","figurines.viktor.description":"Wees welgekomen. Ik ben Viktor en ik ben al héél oud: ik kraak langs alle kanten. De laatste tijd maken de kraaien en de vos me het leven best lastig... Help je me zoeken naar een oplossing?","figurines.viktor.animal":"vogelverschrikker","figurines.viktor.female":"vogelverschrikker","figurines.viktor.male":"vogelverschrikker","figurines.viktor.age":"124 jaar - 21 kg","figurines.viktor.hobby":"kraaien laten schrikken","figurines.viktor.relation":"op zoek naar een relatie","figurines.viktor.food":"eet niet, altijd op dieet","figurines.waldo.name":"Waldo","figurines.waldo.description":"Hej hej van Waldo! We komen overwinteren op de boerderij. Als het hier weer warmer wordt, trekken we terug naar ons huis in het noorden.","figurines.waldo.animal":"gans","figurines.waldo.female":"gans","figurines.waldo.male":"ganzerik","figurines.waldo.age":"18 jaar - 3 kg","figurines.waldo.hobby":"reizen","figurines.waldo.relation":"single","figurines.waldo.food":"sla","figurines.renee.name":"Renée","figurines.renee.description":"Goeiedag en hertelijk welkom! Ik ben Renée en ik ben dol op koken en bakken. Zullen we straks samen enkele gerechtjes uitproberen?","figurines.renee.animal":"hert","figurines.renee.female":"hinde","figurines.renee.male":"bok","figurines.renee.age":"5 jaar - 24 kg","figurines.renee.hobby":"hoogspringen","figurines.renee.relation":"verliefd op Rudy de ree","figurines.renee.food":"jonge twijgen","figurines.ric.name":"Ric","figurines.ric.description":"Ahaa… Hallo daar, en welkom op deze bijzondere plek. Je zult het nog wel merken: niets is hier wat het lijkt… Moehahahaa!","figurines.ric.animal":"vos","figurines.ric.female":"moervos","figurines.ric.male":"rekel","figurines.ric.age":"3 jaar - 11 kg","figurines.ric.hobby":"de kippetjes achterna zitten","figurines.ric.relation":"alleenstaand","figurines.ric.food":"kipjes","figurines.maurice.name":"Maurice","figurines.maurice.description":"Piep, ik ben Maurice en mijn voltallige familie en ik heten je van harte welkom op de boerderij! Zeg eens… Heb je toevallig een stukje kaas bij? Een ieniemini stukje ofzo?","figurines.maurice.animal":"veldmuis","figurines.maurice.female":"veldmuis","figurines.maurice.male":"veldmuis","figurines.maurice.age":"1 jaar - 28 g","figurines.maurice.hobby":"koorddansen","figurines.maurice.relation":"getrouwd met Valerie de veldmuis","figurines.maurice.food":"graantjes en zaden","figurines.henry.name":"Henry","figurines.henry.description":"Blaf! Ik ben Henry, de hondstrouwe bewaker van de boerderij. Je bent heel welkom hier! Wel altijd het hek sluiten, afgesproken?","figurines.henry.animal":"hond","figurines.henry.female":"teef","figurines.henry.male":"reu","figurines.henry.age":"10 jaar - 31 kg","figurines.henry.hobby":"de boel in de gaten houden","figurines.henry.relation":"getrouwd met Tina de teef","figurines.henry.food":"biefstuk","figurines.kitou.name":"Kitou","figurines.kitou.description":"Koekoe, ik ben Kitou! Kom je met me spelen? Mijn motto: 'Ik stuur je wel een kattebelletje!'","figurines.kitou.animal":"kat","figurines.kitou.female":"kattin","figurines.kitou.male":"kater","figurines.kitou.age":"2 jaar - 3,9 kg","figurines.kitou.hobby":"slapen","figurines.kitou.relation":"happy single","figurines.kitou.food":"muizen","figurines.max.name":"Max","figurines.max.description":"I-ààà! Hier op de boerderij is het heel lollig, dat zul je snel genoeg zien. We werken hard, maar we spelen ook minstens even hard. Welkom!","figurines.max.animal":"ezel","figurines.max.female":"ezelin","figurines.max.male":"ezelhengst","figurines.max.age":"19 jaar - 175 kg","figurines.max.hobby":"paard en stier helpen met het zware werk","figurines.max.relation":"op zoek","figurines.max.food":"peren","figurines.didier.name":"Didier","figurines.didier.description":"Hallo, ik ben Didier en binnenkort vertel ik jou in geuren en kleuren wat er hier allemaal gebeurt op de boerderij!","figurines.didier.animal":"kalkoen","figurines.didier.female":"hen","figurines.didier.male":"haan","figurines.didier.age":"3 jaar - 12 kg","figurines.didier.hobby":"rondhangen met mijn vrienden","figurines.didier.relation":"eeuwige vrijgezel","figurines.didier.food":"netels","figurines.astrid.name":"Astrid","figurines.astrid.description":"Aloha, wat fijn dat we weer een nieuwe bewoner hebben. Ik ben zelf ook een beetje exotisch, maar intussen voel ik me hier al helemaal thuis. Dus ook voor jou: willkommen, welcome, bienvenue!","figurines.astrid.animal":"struisvogel","figurines.astrid.female":"struisvogel","figurines.astrid.male":"struisvogel","figurines.astrid.age":"15 jaar - 108 kg","figurines.astrid.hobby":"verstoppertje spelen","figurines.astrid.relation":"getrouwd met Sven de struisvogel","figurines.astrid.food":"komkommer","figurines.milla.name":"Milla","figurines.milla.description":"Oké, even kort en dan moet ik weer naar de akkers. Welkom! Ik ben Milla, de klusjesvrouw van dienst. Veel plezier hier en… go, go, go!","figurines.milla.animal":"mol","figurines.milla.female":"mol","figurines.milla.male":"mol","figurines.milla.age":"3 jaar - 115 g","figurines.milla.hobby":"graven en klusjes opknappen","figurines.milla.relation":"alleenstaand","figurines.milla.food":"regenwormen","figurines.herbert.name":"Herbert","figurines.herbert.description":"Kukeleku, ik ben de haan van de boerderij en ik ben dol op mijn kippetjes. Ik vind dat de ochtendstond goud in de mond heeft – en dat laat ik graag aan iedereen weten, ook aan jou morgenvroeg!","figurines.herbert.animal":"kip","figurines.herbert.female":"hen","figurines.herbert.male":"haan","figurines.herbert.age":"4 jaar - 2,6 kg","figurines.herbert.hobby":"vroeg opstaan","figurines.herbert.relation":"getrouwd met Corinne de kip","figurines.herbert.food":"maïskorrels","figurines.cornelus.name":"Cornelus","figurines.cornelus.description":"Kraa, kraa… Pssst… Je hoéft niet te helpen op de boerderij, hoor. Doe ik ook nooit. Gewoon altijd zorgen dat je ‘toevallig’ net wat anders te doen hebt… En intussen hier en daar een graantje meepikken, zo doe ik het al jaren. Werkt prima!","figurines.cornelus.animal":"kraai","figurines.cornelus.female":"kraai","figurines.cornelus.male":"kraai","figurines.cornelus.age":"7 jaar - 12 kg","figurines.cornelus.hobby":"Viktor plagen","figurines.cornelus.relation":"happy single","figurines.cornelus.food":"zaadjes","video.title":"Kijken","video.campagne.title":"WAT VALT ER ALLEMAAL TE BELEVEN DEZE ZOMER?","video.campagne.button.play":"","video.sow.title":"Hoe zaaien?","video.sow.text":"Benieuwd hoe zo’n minizaadje uitgroeit tot een eetbaar plantje? Met dit filmpje krijg je het in vijf makkelijke stappen onder de knie.","video.barn.title":"Bouw de schuur","video.barn.text":"In de enige, echte schuur van de BOER-DE-REIS kan je samen met al je figuurtjes spelen.<br/>Steek snel je poten, eh, handen uit de mouwen en bekijk het bouwfilmpje.","activities.title":"Doen","activities.diy.title":"DOE-HET-ZELF-<br/>ZAAIKIT","activities.diy.text":"Spaarde jij al enkele zaaizakjes bij elkaar? Top! Haal dan nu je groene vingers boven en tover de zaadjes om tot eetbare lekkernijen. Hoe? Dat leer je in dit zaaifilmpje.","activities.diy.button":"Bekijk het zaai-instructiefilmpje","activities.sow.text":"Wat is de beste tijd om iets te zaaien? En hoe lang duurt het voor je je eerste oogst kunt plukken? Gewoon de zaaikalender downloaden, afdrukken en bij je minimoestuin hangen.","activities.sow.button":"Download de zaaikalender","activities.boardgame.title":"BOER-DE-REIS-SPEL","activities.boardgame.text":"Achter deze knop vind je de spelregels van het BOER-DE-REIS-spel. Psst… Alvast één tip: het wordt extra leuk als je dit spel met het groenteschild speelt.<br/>Veel dobbel- en knabbelplezier!","activities.boardgame.button":"Download de spelregels","activities.recipes.title":"Aan de slag met onze tovergroentjes","recipes.recept_id_1.title":"Oranje rakettensoep met kokos","recipes.recept_id_1.description":"<ol><li>Pel de ui(en) en de knoflook en snipper fijn. Schil de gember, snipper fijn en fruit samen met de ui(en), de knoflook en de komijn even glazig in wat boter en olijfolie. Schil de wortelen, hak grof en voeg toe.</li><li>Zet het onder met water en breng aan de kook. Voeg de bouillonblokjes toe en laat zo’n 20 minuten pruttelen op een matig vuur tot de wortelen gaar zijn.</li><li>Mix de soep fijn met de staafmixer en laat nogmaals doorkoken. Giet het sinaasappelsap erbij en kruid met kurkuma, peper en zout.</li><li>Hak de korianderblaadjes grof. Werk de soep af met de gehakte koriander en een scheutje kokosmelk. Geef er wat tabasco bij voor de liefhebbers.</li></ol>","recipes.recept_id_1.duration":"35 minuten","recipes.recept_id_1.persons":"4 personen","recipes.recept_id_1.ingredients":"<ul><li>600 g wortelen</li><li>1 eetlepel olijfolie</li><li>1 eetlepel boter</li><li>1 eetlepel kurkuma</li><li>1/2 koffielepel komijn</li><li>tabasco</li><li>1,5 dl kokosmelk</li><li>enkele takjes verse koriander</li><li>3 blokjes groentebouillon</li><li>2 sinaasappels (het sap)</li><li>2 teentjes knoflook</li><li>1 grote ui</li><li>5 cm gember</li><li>2 dl water</li></ul>","recipes.recept_id_2.title":"Crème brûlée van oranje raketten","recipes.recept_id_2.description":"<ol><li>Verwijder het loof van de wortelen. Schil ze, was ze en stoom ze totdat ze zacht zijn. Mix ze tot een fijne puree met de schillen van de gekonfijte sinaasappelen en het water. Zeef de puree.</li><li>Warm de oven voor op 100ºC.</li><li>Klop de eigelen wit met de rietsuiker. Voeg de room, wortelpuree en wat sechuanpeper toe. Meng, giet in individuele vormen en laat 1 uur bakken. De crème zal nog lopend zijn, maar zal steviger worden tijdens het afkoelen. Laat 2 uur afkoelen.</li><li>Op het bord: bestrooi de crème voor het opdienen met de cassonade en laat karamelliseren onder de grill van de oven of doe dit met een keukenbrander.</li></ol>","recipes.recept_id_2.duration":"15 minuten","recipes.recept_id_2.persons":"4 personen","recipes.recept_id_2.ingredients":"<ul><li>400 g nieuwe wortelen</li><li>10 dl water</li><li>25 cl vloeibare room</li><li>4 eigelen</li><li>15 g schil van geconfijte sinaasappelen</li><li>50 g rietsuiker in poeder</li><li>3 soeplepels blonde cassonadesuiker</li><li>sechuanpeper</li></ul>","recipes.recept_id_3.title":"Granité met appel en elfenfrisbees","recipes.recept_id_3.description":"<ol><li>Schil de appelen en snijd ze in stukken. Schil de limoen 'à vif' en snijd het vruchtvlees in stukken. Snijd de komkommer (met schil) in stukken.</li><li>Mix de limoen, de appelen en de komkommer samen met de rijstsuiker, het appelsap en de basilicum in de blender tot een homogeen mengsel.</li><li>Haal het mengsel door een zeef en giet het in een grote schaal met platte bodem. Laat 4 u opstijven in de diepvriezer.</li><li>Schraap de korrels van de granite los met een vork, verdeel over glazen en werk af met munt. Smul meteen met een rietje of een lepeltje.</li></ol>","recipes.recept_id_3.duration":"10 min + 4 u vriestijd","recipes.recept_id_3.persons":"4 personen","recipes.recept_id_3.ingredients":"<ul><li>2 appels (Granny Smith)</li><li>1 limoen</li><li>1/2 komkommer</li><li>2 dl appelsap</li><li>3 takjes basilicum</li><li>3 takjes munt</li><li>4 el vloeibare rijstsuiker bio (of honing)</li><li>4 takjes munt voor de afwerking</li></ul>","recipes.recept_id_4.title":"Ijskoude elfenfrisbeessoep","recipes.recept_id_4.description":"<ol><li>Mix het vruchtvlees van de komkommers met 20 cl water, de tabasco, de pijnboompitten, de verse kaas en de rozijnen, totdat je een homogene soep verkrijgt.</li><li>Zet 2 uur in de koelkast. Serveer in kommen en bestrooi met gehakte peterselie.</li></ol>","recipes.recept_id_4.duration":"30 minuten","recipes.recept_id_4.persons":"6 personen","recipes.recept_id_4.ingredients":"<ul><li>2 eetlepels bladpeterselie, fijngehakt</li><li>1 koffielepel groene tabasco</li><li>het vruchtvlees van 2 komkommers</li><li>25 g pijnboompitten</li><li>25 g rozijnen</li><li>100 g verse kaas in schaaltje</li><li>20 dl water</li><li>zout</li><li>zwarte peper</li></ul>","recipes.recept_id_5.title":"Drakentandensalade met radijsjes en kiemen","recipes.recept_id_5.description":"<ol><li>Maak de radijsjes schoon en snijd in schijfjes of kwartjes. Maak het witloof schoon en snijd het uiteinde eraf. Spoel de blaadjes. Laat de artisjokken goed uitlekken. Spoel de salade en de spinazie en meng de radijsjes, het witloof en de artisjokken eronder.</li><li>Werk de salade af met de zaden, de pitten en de kiemen. Besprenkel met de notenolie.</li><li>Bereid een dressing door alle ingrediënten van de dressing te mengen en serveer deze bij de salade.</li></ol>","recipes.recept_id_5.duration":"20 minuten","recipes.recept_id_5.persons":"4 personen","recipes.recept_id_5.ingredients":"<ul><li>20 g radijskiemen</li><li>1/2 citroen (het sap, voor de dressing)</li><li>1 eetlepel mosterd (voor de dressing)</li><li>4 stronkjes witloof</li><li>peper en zout (voor de dressing)</li><li>4 eetlepels notenolie</li><li>40 g pijnboompitten</li><li>30 g lijnzaad</li><li>40 g zonnebloempitten</li><li>90 g artisjok uit bokaal</li><li>1 bussel radijsjes</li><li>1 handvol jonge spinazie</li><li>1 zakje gemengde sla</li><li>20 g luzernekiemen</li><li>20 g tuinkers</li><li>2 eetlepels mayonaise (voor de dressing)</li><li>1 koffielepel honing (voor de dressing)</li><li>2 eetlepels water (voor de dressing)</li><li>1 eetlepel olijfolie (voor de dressing)</li><li>2 eetlepels witte wijnazijn (voor de dressing)</li></ul>","recipes.recept_id_6.title":"Gegratineerde pasta met rolletjes van kikkerskis","recipes.recept_id_6.description":"<ol><li>Verwijder de beide uiteinden van de boontjes en gaar de boontjes 8 min. in kokend water. Giet af en laat schrikken onder koud water.</li><li>Kook ondertussen de pasta 3 min. minder dan aangegeven op de verpakking. Giet af en spoel even onder koud water.</li><li>Verwarm de oven voor op th. 7 – 210°C.</li><li>Meng de pasta met de “Basilico” saus en verspreid over een grote ovenschaal. Rol enkele boontjes in elk plakje ham en leg de rolletjes op de pasta. Overgiet alles met de bechamelsaus en bestrooi met de geraspte kaas. Laat 15 min. in de oven gratineren.</li><li>Serveer warm met een slaatje.</li></ol>","recipes.recept_id_6.duration":"20 min. bereidingstijd + 15 min. baktijd","recipes.recept_id_6.persons":"4 personen","recipes.recept_id_6.ingredients":"<ul><li>200 g Kids ham</li><li>250 g fijne sperziebonen</li><li>350 g castellani of penne rigate</li><li>25 cl bechamelsaus</li><li>100 g geraspte kaas Special Gratin</li><li>500 g “Basilico” saus voor pasta (uit bokaal)</li></ul>","recipes.recept_id_7.title":"Gevulde schatkistjes","recipes.recept_id_7.description":"<ol><li>Snij de paprika's in de lengte in twee en haal de pitjes er uit.</li><li>Meng het gehakt met het eitje, het paneermeel, het peper en zout en vul er de gehalveerde paprika's mee. Bak ze gaar in de oven op 180 graden.</li><li>Snipper een sjalot en een teentje look en stoof in wat olijfolie. Voeg er nadien de tomatenblokjes aan toe en laat sudderen.</li><li>Snij de courgettes in blokjes en stoof ze in olijfolie. Kook de rijst en voeg ze bij de courgettes. Bak samen op en kruid met peper en zout.</li></ol>","recipes.recept_id_7.duration":"minder dan 30 minuten","recipes.recept_id_7.persons":"4 personen","recipes.recept_id_7.ingredients":"<ul><li>2 courgetten</li><li>olijfolie</li><li>400 g gepelde tomaten in blokjes bio</li><li>1 teentje knoflook</li><li>2 sjalotten</li><li>250 g basmatirijst bio</li><li>200 g paneermeel</li><li>1 ei bio</li><li>400 g gemengd gehakt (varkens & runds) bio</li><li>2 paprika's</li></ul>","recipes.recept_id_8.title":"Knapperige indianenkano’s","recipes.recept_id_8.description":"<ol><li>Paneermeel: vermeng een weinig oudbakken brood (of gewoon broodkruim), sesamzaadjes, hazelnoten, korianderzaadjes, kurkuma en droge gember.</li><li>Snijd de aubergines in rondjes van ±1 cm, bestrooi ze met zout en laat dit even intrekken. Laat ze weken in het broodkruim en verhit ze daarna even in een pan met olijfolie.</li><li>Bestrooi uiteindelijk met wat verse koriander, fleur de sel (grof kwaliteitszout) en espelettepeper. Serveren met een Indiase mangochutney.</li></ol>","recipes.recept_id_8.duration":"20 min. + 5 min. kooktijd","recipes.recept_id_8.persons":"4 personen","recipes.recept_id_8.ingredients":"<ul><li>2 aubergines</li><li>70 g broodkruim of oudbakken brood</li><li>2 eetlepels sesamzaadjes en hazelnoten</li><li>1 eetlepel korianderzaadjes</li><li>1/2 eetlepel kurkuma en gedroogde gember</li><li>zout</li><li>olijfolie</li><li>een beetje verse koriander</li><li>Indiase mangochutney</li></ul>","recipes.recept_id_9.title":"Salade van oranje raketten met amandelen en kruiden","recipes.recept_id_9.description":"<ol><li>Snij de geschraapte wortelen in staafjes of ringetjes. Doe ze in een steelpan met lichtgezouten kokend water en giet ze na ongeveer 3 min. af, ze moeten knapperig blijven. Spoel ze lang onder koud water en laat ze uitlekken.</li><li>Rooster de amandelen in een antikleefpan zonder vetstof en hak ze vervolgens grof.</li><li>Doe de fijngesnipperde kruiden en ui in een grote kom. Voeg de wortelen toe, de amandelen, de azijn, de olie en de komijn. Meng goed en breng op smaak met peper en zout.</li><li>Dek af en laat 1 u. voor het serveren in de koelkast rusten.</li><li>Serveer fris bij geroosterd vlees. Ook heel lekker voor een oosterse mezze.</li></ol>","recipes.recept_id_9.duration":"Meer dan 30 min.","recipes.recept_id_9.persons":"5 personen","recipes.recept_id_9.ingredients":"<ul><li>500 g dikke wortelen</li><li>1/2 koffielepel gemalen komijn</li><li>50 g gepelde amandelen</li><li>1 kleine rode ui</li><li>4 eetlepels olijfolie</li><li>peper</li><li>8 takjes bladpeterselie</li><li>8 takjes verse koriander</li><li>2 eetlepels wijnazijn</li></ul>","recipes.recept_id_10.title":"Mamma mia pastasalade met clownneuzen","recipes.recept_id_10.description":"<ol><li>Kook altijd onder toezicht van een volwassene.</li><li>Kook een grote hoeveelheid gezouten water in een kookpot. Strooi er de pasta in wanneer het water kookt en roer. Kook de deegwaren volgens de kooktijd op de verpakking zodat ze al dente zijn. Giet ze dan af en spoel ze lang onder koud water.</li><li>Pers het sap uit de citroen en doe het in een slakom. Voeg de olie en pesto toe en meng goed.</li><li>Schil de meloen, verwijder de pitjes en snij het vruchtvlees in blokjes (je hebt ongeveer 300 g nodig). Doe ze bij in de kom en voeg de in 2 gesneden kerstomaatjes toe, de mozzarellaperlines (of de in blokjes gesneden bollen), de uitgelekte deegwaren en de in reepjes gesneden ham (knip de ham met de schaar, da’s gemakkelijker).</li><li>Meng alle ingrediënten, proef en doe er peper en zout bij indien nodig. Bestrooi met fijngehakte basilicum en dek de kom af. Laat ongeveer 2 uur rusten in de koelkast.</li><li>Dien fris op als voor- of hoofdgerecht.</li></ol>","recipes.recept_id_10.duration":"meer dan 30 minuten","recipes.recept_id_10.persons":"4 personen","recipes.recept_id_10.ingredients":"<ul><li>250 g conchiglie (of andere korte deegwaren naar keuze)</li><li>enkele basilicumblaadjes</li><li>peper</li><li>2 schaaltjes « perline » mozzarella (of bollen)</li><li>1 citroen</li><li>1/2 Charentais meloen</li><li>250 g kerstomaten</li><li>3 eetlepels olijfolie</li><li>3 eetlepels pesto</li><li>100 g prosciutto (rauwe Italiaanse ham)</li></ul>","activities.coloring.title":"Download en print deze kleurplaten","activities.coloring.button":"<a href='http://boerdereis.be' target='_blank'>Print de kleurplaten</a>","games.title":"Spelen","games.back":"Terug naar overzicht","games.carrot.title":"Oranje rakettaart","games.carrot.text":"Help Martin het konijn zo veel mogelijk wortels verzamelen voor zijn oranje rakettaart. Zie je een wortel? Die moet je pakken! Maar loop niet tegen een hek of strobaal, want dan is het ‘game over’...","games.carrot.button":"Start het spel","games.scarecrow.title":"Vogelverschrikker","games.scarecrow.text":"Alarm! De vogels willen alle net gezaaide maïsgranen pikken. Jaag samen met Viktor de vogelverschrikker zo veel mogelijk vogels weg. Ben jij snel genoeg?","games.scarecrow.button":"Speel nu!","games.chicken.title":"Kuikencrèche","games.chicken.text":"Koei-oei… De kuikentjes ontsnappen! Corinne de kip moet op haar nest blijven. Ze rekent dus op jou om al haar kleintjes terug te brengen.<br/>Pok, pok, pok… Go!","games.chicken.button":"Speel kuikencrèche","contact.title":"Contact","contact.text":"Heb je een vraag over De BOER-DE-REIS? Stel ze dan hier! ","contact.form.labels.name":"Naam en voornaam","contact.form.labels.email":"E-mail","contact.form.labels.message":"Stel je vraag","contact.submit.success.dialog.title":"Bericht verstuurd","contact.submit.success.dialog.message":"Je bericht is verzonden, wij nemen binnenkort contact met jou op.","contact.form.submit":"Verstuur","games.carrot.game.title":"PROBEER ALLE WORTELS TE VERZAMELEN!","games.carrot.game.description.line1":"Tap op je scherm of duw op de pijltjestoets om Martin het","games.carrot.game.description.line2":"konijn te laten springen en zo de obstakels te vermijden.","games.carrot.game.powerups.shield.title":"SCHILD","games.carrot.game.powerups.shield.description.line1":"immuun voor","games.carrot.game.powerups.shield.description.line2":"obstakels","games.carrot.game.powerups.springball.title":"SPRINGBAL","games.carrot.game.powerups.springball.description.line1":"hoger","games.carrot.game.powerups.springball.description.line2":"springen","games.carrot.game.powerups.rocket_cake.title":"RAKETTAART","games.carrot.game.powerups.rocket_cake.description.line1":"verzamel dubbel","games.carrot.game.powerups.rocket_cake.description.line2":"zoveel wortels","games.carrot.game.powerups.magnet.title":"MAGNEET","games.carrot.game.powerups.magnet.description.line1":"automatisch wortels","games.carrot.game.powerups.magnet.description.line2":"aantrekken","games.carrot.game.start.btn":"Start het spel","games.carrot.game.resume.btn":"Hervat het spel","games.carrot.game.gameover.title":"GOED GEPROBEERD!","games.carrot.game.gameover.highscore":"BESTE SCORE: ","games.carrot.game.gameover.replay.btn":"Probeer het nog eens","games.chicken.game.title":"HOU ALLE KUIKENTJES BINNEN DE KIPPENREN!","games.chicken.game.description.line1":"Corinne de kip zit rustig op haar nest haar eitjes uit te broeden. Eén voor één komen de","games.chicken.game.description.line2":"eitjes uit en beginnen de kuikentjes rond te lopen. Corinne moet echter op haar nest","games.chicken.game.description.line3":"blijven zitten, dus jij moet er voor zorgen dat de kuikentjes niet te ver weglopen.","games.chicken.game.description.line5":"Neem de kuikentjes vast en plaats hen terug bij Corinne. Van zodra er één kuikentje","games.chicken.game.description.line6":"ontsnapt is het spel gedaan.","games.chicken.game.start.btn":"Start het spel","games.chicken.game.resume.btn":"Hervat het spel","games.chicken.game.gameover.title":"GOED GEPROBEERD!","games.chicken.game.gameover.highscore":"BESTE TIJD: ","games.chicken.game.gameover.replay.btn":"Probeer het nog eens"}}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(35);
	var GetFastValue = __webpack_require__(3);
	var GetURL = __webpack_require__(302);
	var MergeXHRSettings = __webpack_require__(303);
	var XHRLoader = __webpack_require__(544);
	var XHRSettings = __webpack_require__(202);
	
	/**
	 * @typedef {object} FileConfig
	 *
	 * @property {string} type - The file type string (image, json, etc) for sorting within the Loader.
	 * @property {string} key - Unique cache key (unique within its file type)
	 * @property {string} [url] - The URL of the file, not including baseURL.
	 * @property {string} [path] - The path of the file, not including the baseURL.
	 * @property {string} [extension] - The default extension this file uses.
	 * @property {XMLHttpRequestResponseType} [responseType] - The responseType to be used by the XHR request.
	 * @property {(XHRSettingsObject|false)} [xhrSettings=false] - Custom XHR Settings specific to this file and merged with the Loader defaults.
	 * @property {any} [config] - A config object that can be used by file types to store transitional data.
	 */
	
	/**
	 * @classdesc
	 * The base File class used by all File Types that the Loader can support.
	 * You shouldn't create an instance of a File directly, but should extend it with your own class, setting a custom type and processing methods.
	 *
	 * @class File
	 * @memberOf Phaser.Loader
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - The Loader that is going to load this File.
	 * @param {FileConfig} fileConfig - The file configuration object, as created by the file type.
	 */
	var File = new Class({
	
	    initialize:
	
	    function File (loader, fileConfig)
	    {
	        /**
	         * A reference to the Loader that is going to load this file.
	         *
	         * @name Phaser.Loader.File#loader
	         * @type {Phaser.Loader.LoaderPlugin}
	         * @since 3.0.0
	         */
	        this.loader = loader;
	
	        /**
	         * A reference to the Cache, or Texture Manager, that is going to store this file if it loads.
	         *
	         * @name Phaser.Loader.File#cache
	         * @type {(Phaser.Cache.BaseCache|Phaser.Textures.TextureManager)}
	         * @since 3.7.0
	         */
	        this.cache = GetFastValue(fileConfig, 'cache', false);
	
	        /**
	         * The file type string (image, json, etc) for sorting within the Loader.
	         *
	         * @name Phaser.Loader.File#type
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.type = GetFastValue(fileConfig, 'type', false);
	
	        /**
	         * Unique cache key (unique within its file type)
	         *
	         * @name Phaser.Loader.File#key
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.key = GetFastValue(fileConfig, 'key', false);
	
	        var loadKey = this.key;
	
	        if (loader.prefix && loader.prefix !== '')
	        {
	            this.key = loader.prefix + loadKey;
	        }
	
	        if (!this.type || !this.key)
	        {
	            throw new Error('Error calling \'Loader.' + this.type + '\' invalid key provided.');
	        }
	
	        /**
	         * The URL of the file, not including baseURL.
	         * Automatically has Loader.path prepended to it.
	         *
	         * @name Phaser.Loader.File#url
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.url = GetFastValue(fileConfig, 'url');
	
	        if (this.url === undefined)
	        {
	            this.url = loader.path + loadKey + '.' + GetFastValue(fileConfig, 'extension', '');
	        }
	        else if (typeof(this.url) !== 'function')
	        {
	            this.url = loader.path + this.url;
	        }
	
	        /**
	         * The final URL this file will load from, including baseURL and path.
	         * Set automatically when the Loader calls 'load' on this file.
	         *
	         * @name Phaser.Loader.File#src
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.src = '';
	
	        /**
	         * The merged XHRSettings for this file.
	         *
	         * @name Phaser.Loader.File#xhrSettings
	         * @type {XHRSettingsObject}
	         * @since 3.0.0
	         */
	        this.xhrSettings = XHRSettings(GetFastValue(fileConfig, 'responseType', undefined));
	
	        if (GetFastValue(fileConfig, 'xhrSettings', false))
	        {
	            this.xhrSettings = MergeXHRSettings(this.xhrSettings, GetFastValue(fileConfig, 'xhrSettings', {}));
	        }
	
	        /**
	         * The XMLHttpRequest instance (as created by XHR Loader) that is loading this File.
	         *
	         * @name Phaser.Loader.File#xhrLoader
	         * @type {?XMLHttpRequest}
	         * @since 3.0.0
	         */
	        this.xhrLoader = null;
	
	        /**
	         * The current state of the file. One of the FILE_CONST values.
	         *
	         * @name Phaser.Loader.File#state
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.state = typeof(this.url) === 'function' ? CONST.FILE_POPULATED : CONST.FILE_PENDING;
	
	        /**
	         * The total size of this file.
	         * Set by onProgress and only if loading via XHR.
	         *
	         * @name Phaser.Loader.File#bytesTotal
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.bytesTotal = 0;
	
	        /**
	         * Updated as the file loads.
	         * Only set if loading via XHR.
	         *
	         * @name Phaser.Loader.File#bytesLoaded
	         * @type {number}
	         * @default -1
	         * @since 3.0.0
	         */
	        this.bytesLoaded = -1;
	
	        /**
	         * A percentage value between 0 and 1 indicating how much of this file has loaded.
	         * Only set if loading via XHR.
	         *
	         * @name Phaser.Loader.File#percentComplete
	         * @type {float}
	         * @default -1
	         * @since 3.0.0
	         */
	        this.percentComplete = -1;
	
	        /**
	         * For CORs based loading.
	         * If this is undefined then the File will check BaseLoader.crossOrigin and use that (if set)
	         *
	         * @name Phaser.Loader.File#crossOrigin
	         * @type {(string|undefined)}
	         * @since 3.0.0
	         */
	        this.crossOrigin = undefined;
	
	        /**
	         * The processed file data, stored here after the file has loaded.
	         *
	         * @name Phaser.Loader.File#data
	         * @type {*}
	         * @since 3.0.0
	         */
	        this.data = undefined;
	
	        /**
	         * A config object that can be used by file types to store transitional data.
	         *
	         * @name Phaser.Loader.File#config
	         * @type {*}
	         * @since 3.0.0
	         */
	        this.config = GetFastValue(fileConfig, 'config', {});
	
	        /**
	         * If this is a multipart file, i.e. an atlas and its json together, then this is a reference
	         * to the parent MultiFile. Set and used internally by the Loader or specific file types.
	         *
	         * @name Phaser.Loader.File#multiFile
	         * @type {?Phaser.Loader.MultiFile}
	         * @since 3.7.0
	         */
	        this.multiFile;
	
	        /**
	         * Does this file have an associated linked file? Such as an image and a normal map.
	         * Atlases and Bitmap Fonts use the multiFile, because those files need loading together but aren't
	         * actually bound by data, where-as a linkFile is.
	         *
	         * @name Phaser.Loader.File#linkFile
	         * @type {?Phaser.Loader.File}
	         * @since 3.7.0
	         */
	        this.linkFile;
	    },
	
	    /**
	     * Links this File with another, so they depend upon each other for loading and processing.
	     *
	     * @method Phaser.Loader.File#setLink
	     * @since 3.7.0
	     *
	     * @param {Phaser.Loader.File} fileB - The file to link to this one.
	     */
	    setLink: function (fileB)
	    {
	        this.linkFile = fileB;
	
	        fileB.linkFile = this;
	    },
	
	    /**
	     * Resets the XHRLoader instance this file is using.
	     *
	     * @method Phaser.Loader.File#resetXHR
	     * @since 3.0.0
	     */
	    resetXHR: function ()
	    {
	        if (this.xhrLoader)
	        {
	            this.xhrLoader.onload = undefined;
	            this.xhrLoader.onerror = undefined;
	            this.xhrLoader.onprogress = undefined;
	        }
	    },
	
	    /**
	     * Called by the Loader, starts the actual file downloading.
	     * During the load the methods onLoad, onError and onProgress are called, based on the XHR events.
	     * You shouldn't normally call this method directly, it's meant to be invoked by the Loader.
	     *
	     * @method Phaser.Loader.File#load
	     * @since 3.0.0
	     */
	    load: function ()
	    {
	        if (this.state === CONST.FILE_POPULATED)
	        {
	            //  Can happen for example in a JSONFile if they've provided a JSON object instead of a URL
	            this.loader.nextFile(this, true);
	        }
	        else
	        {
	            this.src = GetURL(this, this.loader.baseURL);
	
	            if (this.src.indexOf('data:') === 0)
	            {
	                console.warn('Local data URIs are not supported: ' + this.key);
	            }
	            else
	            {
	                //  The creation of this XHRLoader starts the load process going.
	                //  It will automatically call the following, based on the load outcome:
	                //  
	                // xhr.onload = this.onLoad
	                // xhr.onerror = this.onError
	                // xhr.onprogress = this.onProgress
	
	                this.xhrLoader = XHRLoader(this, this.loader.xhr);
	            }
	        }
	    },
	
	    /**
	     * Called when the file finishes loading, is sent a DOM ProgressEvent.
	     *
	     * @method Phaser.Loader.File#onLoad
	     * @since 3.0.0
	     *
	     * @param {XMLHttpRequest} xhr - The XMLHttpRequest that caused this onload event.
	     * @param {ProgressEvent} event - The DOM ProgressEvent that resulted from this load.
	     */
	    onLoad: function (xhr, event)
	    {
	        var success = !(event.target && event.target.status !== 200);
	
	        //  Handle HTTP status codes of 4xx and 5xx as errors, even if xhr.onerror was not called.
	        if (xhr.readyState === 4 && xhr.status >= 400 && xhr.status <= 599)
	        {
	            success = false;
	        }
	
	        this.resetXHR();
	
	        this.loader.nextFile(this, success);
	    },
	
	    /**
	     * Called if the file errors while loading, is sent a DOM ProgressEvent.
	     *
	     * @method Phaser.Loader.File#onError
	     * @since 3.0.0
	     *
	     * @param {ProgressEvent} event - The DOM ProgressEvent that resulted from this error.
	     */
	    onError: function ()
	    {
	        this.resetXHR();
	
	        this.loader.nextFile(this, false);
	    },
	
	    /**
	     * Called during the file load progress. Is sent a DOM ProgressEvent.
	     *
	     * @method Phaser.Loader.File#onProgress
	     * @since 3.0.0
	     *
	     * @param {ProgressEvent} event - The DOM ProgressEvent.
	     */
	    onProgress: function (event)
	    {
	        if (event.lengthComputable)
	        {
	            this.bytesLoaded = event.loaded;
	            this.bytesTotal = event.total;
	
	            this.percentComplete = Math.min((this.bytesLoaded / this.bytesTotal), 1);
	
	            this.loader.emit('fileprogress', this, this.percentComplete);
	        }
	    },
	
	    /**
	     * Usually overridden by the FileTypes and is called by Loader.nextFile.
	     * This method controls what extra work this File does with its loaded data, for example a JSON file will parse itself during this stage.
	     *
	     * @method Phaser.Loader.File#onProcess
	     * @since 3.0.0
	     */
	    onProcess: function ()
	    {
	        this.state = CONST.FILE_PROCESSING;
	
	        this.onProcessComplete();
	    },
	
	    /**
	     * Called when the File has completed processing.
	     * Checks on the state of its multifile, if set.
	     *
	     * @method Phaser.Loader.File#onProcessComplete
	     * @since 3.7.0
	     */
	    onProcessComplete: function ()
	    {
	        this.state = CONST.FILE_COMPLETE;
	
	        if (this.multiFile)
	        {
	            this.multiFile.onFileComplete(this);
	        }
	
	        this.loader.fileProcessComplete(this);
	    },
	
	    /**
	     * Called when the File has completed processing but it generated an error.
	     * Checks on the state of its multifile, if set.
	     *
	     * @method Phaser.Loader.File#onProcessError
	     * @since 3.7.0
	     */
	    onProcessError: function ()
	    {
	        this.state = CONST.FILE_ERRORED;
	
	        if (this.multiFile)
	        {
	            this.multiFile.onFileFailed(this);
	        }
	
	        this.loader.fileProcessComplete(this);
	    },
	
	    /**
	     * Checks if a key matching the one used by this file exists in the target Cache or not.
	     * This is called automatically by the LoaderPlugin to decide if the file can be safely
	     * loaded or will conflict.
	     *
	     * @method Phaser.Loader.File#hasCacheConflict
	     * @since 3.7.0
	     *
	     * @return {boolean} `true` if adding this file will cause a conflict, otherwise `false`.
	     */
	    hasCacheConflict: function ()
	    {
	        return (this.cache && this.cache.exists(this.key));
	    },
	
	    /**
	     * Adds this file to its target cache upon successful loading and processing.
	     * This method is often overridden by specific file types.
	     *
	     * @method Phaser.Loader.File#addToCache
	     * @since 3.7.0
	     */
	    addToCache: function ()
	    {
	        if (this.cache)
	        {
	            this.cache.add(this.key, this.data);
	        }
	
	        this.pendingDestroy();
	    },
	
	    /**
	     * You can listen for this event from the LoaderPlugin. It is dispatched _every time_
	     * a file loads and is sent 3 arguments, which allow you to identify the file:
	     *
	     * ```javascript
	     * this.load.on('filecomplete', function (key, type, data) {
	     *     // Your handler code
	     * });
	     * ```
	     * 
	     * @event Phaser.Loader.File#fileCompleteEvent
	     * @param {string} key - The key of the file that just loaded and finished processing.
	     * @param {string} type - The type of the file that just loaded and finished processing.
	     * @param {any} data - The data of the file.
	     */
	
	    /**
	     * You can listen for this event from the LoaderPlugin. It is dispatched only once per
	     * file and you have to use a special listener handle to pick it up.
	     * 
	     * The string of the event is based on the file type and the key you gave it, split up
	     * using hyphens.
	     * 
	     * For example, if you have loaded an image with a key of `monster`, you can listen for it
	     * using the following:
	     *
	     * ```javascript
	     * this.load.on('filecomplete-image-monster', function (key, type, data) {
	     *     // Your handler code
	     * });
	     * ```
	     *
	     * Or, if you have loaded a texture atlas with a key of `Level1`:
	     * 
	     * ```javascript
	     * this.load.on('filecomplete-atlas-Level1', function (key, type, data) {
	     *     // Your handler code
	     * });
	     * ```
	     * 
	     * Or, if you have loaded a sprite sheet with a key of `Explosion` and a prefix of `GAMEOVER`:
	     * 
	     * ```javascript
	     * this.load.on('filecomplete-spritesheet-GAMEOVERExplosion', function (key, type, data) {
	     *     // Your handler code
	     * });
	     * ```
	     * 
	     * @event Phaser.Loader.File#singleFileCompleteEvent
	     * @param {any} data - The data of the file.
	     */
	
	    /**
	     * Called once the file has been added to its cache and is now ready for deletion from the Loader.
	     * It will emit a `filecomplete` event from the LoaderPlugin.
	     *
	     * @method Phaser.Loader.File#pendingDestroy
	     * @fires Phaser.Loader.File#fileCompleteEvent
	     * @fires Phaser.Loader.File#singleFileCompleteEvent
	     * @since 3.7.0
	     */
	    pendingDestroy: function (data)
	    {
	        if (data === undefined) { data = this.data; }
	
	        var key = this.key;
	        var type = this.type;
	
	        this.loader.emit('filecomplete', key, type, data);
	        this.loader.emit('filecomplete_' + type + '_' + key, key, type, data);
	
	        this.loader.flagForRemoval(this);
	    },
	
	    /**
	     * Destroy this File and any references it holds.
	     *
	     * @method Phaser.Loader.File#destroy
	     * @since 3.7.0
	     */
	    destroy: function ()
	    {
	        this.loader = null;
	        this.cache = null;
	        this.xhrSettings = null;
	        this.multiFile = null;
	        this.linkFile = null;
	        this.data = null;
	    }
	
	});
	
	/**
	 * Static method for creating object URL using URL API and setting it as image 'src' attribute.
	 * If URL API is not supported (usually on old browsers) it falls back to creating Base64 encoded url using FileReader.
	 *
	 * @method Phaser.Loader.File.createObjectURL
	 * @static
	 * @param {HTMLImageElement} image - Image object which 'src' attribute should be set to object URL.
	 * @param {Blob} blob - A Blob object to create an object URL for.
	 * @param {string} defaultType - Default mime type used if blob type is not available.
	 */
	File.createObjectURL = function (image, blob, defaultType)
	{
	    if (typeof URL === 'function')
	    {
	        image.src = URL.createObjectURL(blob);
	    }
	    else
	    {
	        var reader = new FileReader();
	
	        reader.onload = function ()
	        {
	            image.removeAttribute('crossOrigin');
	            image.src = 'data:' + (blob.type || defaultType) + ';base64,' + reader.result.split(',')[1];
	        };
	
	        reader.onerror = image.onerror;
	
	        reader.readAsDataURL(blob);
	    }
	};
	
	/**
	 * Static method for releasing an existing object URL which was previously created
	 * by calling {@link File#createObjectURL} method.
	 *
	 * @method Phaser.Loader.File.revokeObjectURL
	 * @static
	 * @param {HTMLImageElement} image - Image object which 'src' attribute should be revoked.
	 */
	File.revokeObjectURL = function (image)
	{
	    if (typeof URL === 'function')
	    {
	        URL.revokeObjectURL(image.src);
	    }
	};
	
	module.exports = File;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(20);
	var createDesc = __webpack_require__(106);
	module.exports = __webpack_require__(19) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var hide = __webpack_require__(45);
	var has = __webpack_require__(52);
	var SRC = __webpack_require__(110)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(59).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var fails = __webpack_require__(11);
	var defined = __webpack_require__(65);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Takes an array of Game Objects, or any objects that have a public property as defined in `key`,
	 * and then sets it to the given value.
	 *
	 * The optional `step` property is applied incrementally, multiplied by each item in the array.
	 *
	 * To use this with a Group: `PropertyValueSet(group.getChildren(), key, value, step)`
	 *
	 * @function Phaser.Actions.PropertyValueSet
	 * @since 3.3.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {string} key - The property to be updated.
	 * @param {number} value - The amount to set the property to.
	 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var PropertyValueSet = function (items, key, value, step, index, direction)
	{
	    if (step === undefined) { step = 0; }
	    if (index === undefined) { index = 0; }
	    if (direction === undefined) { direction = 1; }
	
	    var i;
	    var t = 0;
	    var end = items.length;
	
	    if (direction === 1)
	    {
	        //  Start to End
	        for (i = index; i < end; i++)
	        {
	            items[i][key] = value + (t * step);
	            t++;
	        }
	    }
	    else
	    {
	        //  End to Start
	        for (i = index; i >= 0; i--)
	        {
	            items[i][key] = value + (t * step);
	            t++;
	        }
	    }
	
	    return items;
	};
	
	module.exports = PropertyValueSet;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Global consts.
	 * 
	 * @ignore
	 */
	
	var CONST = {
	
	    /**
	     * Phaser Release Version
	     * 
	     * @name Phaser.VERSION
	     * @readOnly
	     * @type {string}
	     * @since 3.0.0
	     */
	    VERSION: '3.8.0',
	
	    BlendModes: __webpack_require__(145),
	
	    ScaleModes: __webpack_require__(167),
	
	    /**
	     * AUTO Detect Renderer.
	     * 
	     * @name Phaser.AUTO
	     * @readOnly
	     * @type {integer}
	     * @since 3.0.0
	     */
	    AUTO: 0,
	
	    /**
	     * Canvas Renderer.
	     * 
	     * @name Phaser.CANVAS
	     * @readOnly
	     * @type {integer}
	     * @since 3.0.0
	     */
	    CANVAS: 1,
	
	    /**
	     * WebGL Renderer.
	     * 
	     * @name Phaser.WEBGL
	     * @readOnly
	     * @type {integer}
	     * @since 3.0.0
	     */
	    WEBGL: 2,
	
	    /**
	     * Headless Renderer.
	     * 
	     * @name Phaser.HEADLESS
	     * @readOnly
	     * @type {integer}
	     * @since 3.0.0
	     */
	    HEADLESS: 3,
	
	    /**
	     * In Phaser the value -1 means 'forever' in lots of cases, this const allows you to use it instead
	     * to help you remember what the value is doing in your code.
	     * 
	     * @name Phaser.FOREVER
	     * @readOnly
	     * @type {integer}
	     * @since 3.0.0
	     */
	    FOREVER: -1,
	
	    /**
	     * Direction constant.
	     * 
	     * @name Phaser.NONE
	     * @readOnly
	     * @type {integer}
	     * @since 3.0.0
	     */
	    NONE: 4,
	
	    /**
	     * Direction constant.
	     * 
	     * @name Phaser.UP
	     * @readOnly
	     * @type {integer}
	     * @since 3.0.0
	     */
	    UP: 5,
	
	    /**
	     * Direction constant.
	     * 
	     * @name Phaser.DOWN
	     * @readOnly
	     * @type {integer}
	     * @since 3.0.0
	     */
	    DOWN: 6,
	
	    /**
	     * Direction constant.
	     * 
	     * @name Phaser.LEFT
	     * @readOnly
	     * @type {integer}
	     * @since 3.0.0
	     */
	    LEFT: 7,
	
	    /**
	     * Direction constant.
	     * 
	     * @name Phaser.RIGHT
	     * @readOnly
	     * @type {integer}
	     * @since 3.0.0
	     */
	    RIGHT: 8
	
	};
	
	module.exports = CONST;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BlendModes = __webpack_require__(145);
	var GetAdvancedValue = __webpack_require__(24);
	var ScaleModes = __webpack_require__(167);
	
	/**
	 * @typedef {object} GameObjectConfig
	 *
	 * @property {number} [x=0] - [description]
	 * @property {number} [y=0] - [description]
	 * @property {number} [depth=0] - [description]
	 * @property {boolean} [flipX=false] - [description]
	 * @property {boolean} [flipY=false] - [description]
	 * @property {?(number|object)} [scale=null] - [description]
	 * @property {?(number|object)} [scrollFactor=null] - [description]
	 * @property {number} [rotation=0] - [description]
	 * @property {?number} [angle=null] - [description]
	 * @property {number} [alpha=1] - [description]
	 * @property {?(number|object)} [origin=null] - [description]
	 * @property {number} [scaleMode=ScaleModes.DEFAULT] - [description]
	 * @property {number} [blendMode=BlendModes.DEFAULT] - [description]
	 * @property {boolean} [visible=true] - [description]
	 * @property {boolean} [add=true] - [description]
	 */
	
	/**
	 * Builds a Game Object using the provided configuration object.
	 *
	 * @function Phaser.GameObjects.BuildGameObject
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - [description]
	 * @param {Phaser.GameObjects.GameObject} gameObject - [description]
	 * @param {GameObjectConfig} config - [description]
	 *
	 * @return {Phaser.GameObjects.GameObject} The built Game Object.
	 */
	var BuildGameObject = function (scene, gameObject, config)
	{
	    //  Position
	
	    gameObject.x = GetAdvancedValue(config, 'x', 0);
	    gameObject.y = GetAdvancedValue(config, 'y', 0);
	    gameObject.depth = GetAdvancedValue(config, 'depth', 0);
	
	    //  Flip
	
	    gameObject.flipX = GetAdvancedValue(config, 'flipX', false);
	    gameObject.flipY = GetAdvancedValue(config, 'flipY', false);
	
	    //  Scale
	    //  Either: { scale: 2 } or { scale: { x: 2, y: 2 }}
	
	    var scale = GetAdvancedValue(config, 'scale', null);
	
	    if (typeof scale === 'number')
	    {
	        gameObject.setScale(scale);
	    }
	    else if (scale !== null)
	    {
	        gameObject.scaleX = GetAdvancedValue(scale, 'x', 1);
	        gameObject.scaleY = GetAdvancedValue(scale, 'y', 1);
	    }
	
	    //  ScrollFactor
	    //  Either: { scrollFactor: 2 } or { scrollFactor: { x: 2, y: 2 }}
	
	    var scrollFactor = GetAdvancedValue(config, 'scrollFactor', null);
	
	    if (typeof scrollFactor === 'number')
	    {
	        gameObject.setScrollFactor(scrollFactor);
	    }
	    else if (scrollFactor !== null)
	    {
	        gameObject.scrollFactorX = GetAdvancedValue(scrollFactor, 'x', 1);
	        gameObject.scrollFactorY = GetAdvancedValue(scrollFactor, 'y', 1);
	    }
	
	    //  Rotation
	
	    gameObject.rotation = GetAdvancedValue(config, 'rotation', 0);
	
	    var angle = GetAdvancedValue(config, 'angle', null);
	
	    if (angle !== null)
	    {
	        gameObject.angle = angle;
	    }
	
	    //  Alpha
	
	    gameObject.alpha = GetAdvancedValue(config, 'alpha', 1);
	
	    //  Origin
	    //  Either: { origin: 0.5 } or { origin: { x: 0.5, y: 0.5 }}
	
	    var origin = GetAdvancedValue(config, 'origin', null);
	
	    if (typeof origin === 'number')
	    {
	        gameObject.setOrigin(origin);
	    }
	    else if (origin !== null)
	    {
	        var ox = GetAdvancedValue(origin, 'x', 0.5);
	        var oy = GetAdvancedValue(origin, 'y', 0.5);
	
	        gameObject.setOrigin(ox, oy);
	    }
	
	    //  ScaleMode
	
	    gameObject.scaleMode = GetAdvancedValue(config, 'scaleMode', ScaleModes.DEFAULT);
	
	    //  BlendMode
	
	    gameObject.blendMode = GetAdvancedValue(config, 'blendMode', BlendModes.NORMAL);
	
	    //  Visible
	
	    gameObject.visible = GetAdvancedValue(config, 'visible', true);
	
	    //  Add to Scene
	
	    var add = GetAdvancedValue(config, 'add', true);
	
	    if (add)
	    {
	        scene.sys.displayList.add(gameObject);
	    }
	
	    if (gameObject.preUpdate)
	    {
	        scene.sys.updateList.add(gameObject);
	    }
	
	    return gameObject;
	};
	
	module.exports = BuildGameObject;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* The `Matter.Body` module contains methods for creating and manipulating body models.
	* A `Matter.Body` is a rigid body that can be simulated by a `Matter.Engine`.
	* Factories for commonly used body configurations (such as rectangles, circles and other polygons) can be found in the module `Matter.Bodies`.
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	
	* @class Body
	*/
	
	var Body = {};
	
	module.exports = Body;
	
	var Vertices = __webpack_require__(86);
	var Vector = __webpack_require__(71);
	var Sleeping = __webpack_require__(166);
	var Common = __webpack_require__(31);
	var Bounds = __webpack_require__(85);
	var Axes = __webpack_require__(321);
	
	(function() {
	
	    Body._inertiaScale = 4;
	    Body._nextCollidingGroupId = 1;
	    Body._nextNonCollidingGroupId = -1;
	    Body._nextCategory = 0x0001;
	
	    /**
	     * Creates a new rigid body model. The options parameter is an object that specifies any properties you wish to override the defaults.
	     * All properties have default values, and many are pre-calculated automatically based on other properties.
	     * Vertices must be specified in clockwise order.
	     * See the properties section below for detailed information on what you can pass via the `options` object.
	     * @method create
	     * @param {} options
	     * @return {body} body
	     */
	    Body.create = function(options) {
	        var defaults = {
	            id: Common.nextId(),
	            type: 'body',
	            label: 'Body',
	            gameObject: null,
	            parts: [],
	            plugin: {},
	            angle: 0,
	            vertices: Vertices.fromPath('L 0 0 L 40 0 L 40 40 L 0 40'),
	            position: { x: 0, y: 0 },
	            force: { x: 0, y: 0 },
	            torque: 0,
	            positionImpulse: { x: 0, y: 0 },
	            previousPositionImpulse: { x: 0, y: 0 },
	            constraintImpulse: { x: 0, y: 0, angle: 0 },
	            totalContacts: 0,
	            speed: 0,
	            angularSpeed: 0,
	            velocity: { x: 0, y: 0 },
	            angularVelocity: 0,
	            isSensor: false,
	            isStatic: false,
	            isSleeping: false,
	            ignoreGravity: false,
	            ignorePointer: false,
	            motion: 0,
	            sleepThreshold: 60,
	            density: 0.001,
	            restitution: 0,
	            friction: 0.1,
	            frictionStatic: 0.5,
	            frictionAir: 0.01,
	            collisionFilter: {
	                category: 0x0001,
	                mask: 0xFFFFFFFF,
	                group: 0
	            },
	            slop: 0.05,
	            timeScale: 1,
	            render: {
	                visible: true,
	                opacity: 1,
	                sprite: {
	                    xScale: 1,
	                    yScale: 1,
	                    xOffset: 0,
	                    yOffset: 0
	                },
	                lineWidth: 0
	            },
	
	            events: null,
	            bounds: null,
	            chamfer: null,
	            circleRadius: 0,
	            positionPrev: null,
	            anglePrev: 0,
	            parent: null,
	
	            axes: null,
	            area: 0,
	            mass: 0,
	            inertia: 0,
	
	            _original: null
	        };
	
	        var body = Common.extend(defaults, options);
	
	        _initProperties(body, options);
	
	        return body;
	    };
	
	    /**
	     * Returns the next unique group index for which bodies will collide.
	     * If `isNonColliding` is `true`, returns the next unique group index for which bodies will _not_ collide.
	     * See `body.collisionFilter` for more information.
	     * @method nextGroup
	     * @param {bool} [isNonColliding=false]
	     * @return {Number} Unique group index
	     */
	    Body.nextGroup = function(isNonColliding) {
	        if (isNonColliding)
	            return Body._nextNonCollidingGroupId--;
	
	        return Body._nextCollidingGroupId++;
	    };
	
	    /**
	     * Returns the next unique category bitfield (starting after the initial default category `0x0001`).
	     * There are 32 available. See `body.collisionFilter` for more information.
	     * @method nextCategory
	     * @return {Number} Unique category bitfield
	     */
	    Body.nextCategory = function() {
	        Body._nextCategory = Body._nextCategory << 1;
	        return Body._nextCategory;
	    };
	
	    /**
	     * Initialises body properties.
	     * @method _initProperties
	     * @private
	     * @param {body} body
	     * @param {} [options]
	     */
	    var _initProperties = function(body, options) {
	        options = options || {};
	
	        // init required properties (order is important)
	        Body.set(body, {
	            bounds: body.bounds || Bounds.create(body.vertices),
	            positionPrev: body.positionPrev || Vector.clone(body.position),
	            anglePrev: body.anglePrev || body.angle,
	            vertices: body.vertices,
	            parts: body.parts || [body],
	            isStatic: body.isStatic,
	            isSleeping: body.isSleeping,
	            parent: body.parent || body
	        });
	
	        Vertices.rotate(body.vertices, body.angle, body.position);
	        Axes.rotate(body.axes, body.angle);
	        Bounds.update(body.bounds, body.vertices, body.velocity);
	
	        // allow options to override the automatically calculated properties
	        Body.set(body, {
	            axes: options.axes || body.axes,
	            area: options.area || body.area,
	            mass: options.mass || body.mass,
	            inertia: options.inertia || body.inertia
	        });
	
	        // render properties
	        var defaultFillStyle = (body.isStatic ? '#2e2b44' : Common.choose(['#006BA6', '#0496FF', '#FFBC42', '#D81159', '#8F2D56'])),
	            defaultStrokeStyle = '#000';
	        body.render.fillStyle = body.render.fillStyle || defaultFillStyle;
	        body.render.strokeStyle = body.render.strokeStyle || defaultStrokeStyle;
	        body.render.sprite.xOffset += -(body.bounds.min.x - body.position.x) / (body.bounds.max.x - body.bounds.min.x);
	        body.render.sprite.yOffset += -(body.bounds.min.y - body.position.y) / (body.bounds.max.y - body.bounds.min.y);
	    };
	
	    /**
	     * Given a property and a value (or map of), sets the property(s) on the body, using the appropriate setter functions if they exist.
	     * Prefer to use the actual setter functions in performance critical situations.
	     * @method set
	     * @param {body} body
	     * @param {object} settings A map of properties and values to set on the body.
	     */
	    Body.set = function(body, settings) {
	        var property,
	            value;
	
	        if (typeof settings === 'string') {
	            property = settings;
	            settings = {};
	            settings[property] = value;
	        }
	
	        for (property in settings) {
	
	            if (!settings.hasOwnProperty(property))
	                continue;
	
	            value = settings[property];
	            switch (property) {
	
	            case 'isStatic':
	                Body.setStatic(body, value);
	                break;
	            case 'isSleeping':
	                Sleeping.set(body, value);
	                break;
	            case 'mass':
	                Body.setMass(body, value);
	                break;
	            case 'density':
	                Body.setDensity(body, value);
	                break;
	            case 'inertia':
	                Body.setInertia(body, value);
	                break;
	            case 'vertices':
	                Body.setVertices(body, value);
	                break;
	            case 'position':
	                Body.setPosition(body, value);
	                break;
	            case 'angle':
	                Body.setAngle(body, value);
	                break;
	            case 'velocity':
	                Body.setVelocity(body, value);
	                break;
	            case 'angularVelocity':
	                Body.setAngularVelocity(body, value);
	                break;
	            case 'parts':
	                Body.setParts(body, value);
	                break;
	            default:
	                body[property] = value;
	
	            }
	        }
	    };
	
	    /**
	     * Sets the body as static, including isStatic flag and setting mass and inertia to Infinity.
	     * @method setStatic
	     * @param {body} body
	     * @param {bool} isStatic
	     */
	    Body.setStatic = function(body, isStatic) {
	        for (var i = 0; i < body.parts.length; i++) {
	            var part = body.parts[i];
	            part.isStatic = isStatic;
	
	            if (isStatic) {
	                part._original = {
	                    restitution: part.restitution,
	                    friction: part.friction,
	                    mass: part.mass,
	                    inertia: part.inertia,
	                    density: part.density,
	                    inverseMass: part.inverseMass,
	                    inverseInertia: part.inverseInertia
	                };
	
	                part.restitution = 0;
	                part.friction = 1;
	                part.mass = part.inertia = part.density = Infinity;
	                part.inverseMass = part.inverseInertia = 0;
	
	                part.positionPrev.x = part.position.x;
	                part.positionPrev.y = part.position.y;
	                part.anglePrev = part.angle;
	                part.angularVelocity = 0;
	                part.speed = 0;
	                part.angularSpeed = 0;
	                part.motion = 0;
	            } else if (part._original) {
	                part.restitution = part._original.restitution;
	                part.friction = part._original.friction;
	                part.mass = part._original.mass;
	                part.inertia = part._original.inertia;
	                part.density = part._original.density;
	                part.inverseMass = part._original.inverseMass;
	                part.inverseInertia = part._original.inverseInertia;
	
	                part._original = null;
	            }
	        }
	    };
	
	    /**
	     * Sets the mass of the body. Inverse mass, density and inertia are automatically updated to reflect the change.
	     * @method setMass
	     * @param {body} body
	     * @param {number} mass
	     */
	    Body.setMass = function(body, mass) {
	        var moment = body.inertia / (body.mass / 6);
	        body.inertia = moment * (mass / 6);
	        body.inverseInertia = 1 / body.inertia;
	
	        body.mass = mass;
	        body.inverseMass = 1 / body.mass;
	        body.density = body.mass / body.area;
	    };
	
	    /**
	     * Sets the density of the body. Mass and inertia are automatically updated to reflect the change.
	     * @method setDensity
	     * @param {body} body
	     * @param {number} density
	     */
	    Body.setDensity = function(body, density) {
	        Body.setMass(body, density * body.area);
	        body.density = density;
	    };
	
	    /**
	     * Sets the moment of inertia (i.e. second moment of area) of the body of the body. 
	     * Inverse inertia is automatically updated to reflect the change. Mass is not changed.
	     * @method setInertia
	     * @param {body} body
	     * @param {number} inertia
	     */
	    Body.setInertia = function(body, inertia) {
	        body.inertia = inertia;
	        body.inverseInertia = 1 / body.inertia;
	    };
	
	    /**
	     * Sets the body's vertices and updates body properties accordingly, including inertia, area and mass (with respect to `body.density`).
	     * Vertices will be automatically transformed to be orientated around their centre of mass as the origin.
	     * They are then automatically translated to world space based on `body.position`.
	     *
	     * The `vertices` argument should be passed as an array of `Matter.Vector` points (or a `Matter.Vertices` array).
	     * Vertices must form a convex hull, concave hulls are not supported.
	     *
	     * @method setVertices
	     * @param {body} body
	     * @param {vector[]} vertices
	     */
	    Body.setVertices = function(body, vertices) {
	        // change vertices
	        if (vertices[0].body === body) {
	            body.vertices = vertices;
	        } else {
	            body.vertices = Vertices.create(vertices, body);
	        }
	
	        // update properties
	        body.axes = Axes.fromVertices(body.vertices);
	        body.area = Vertices.area(body.vertices);
	        Body.setMass(body, body.density * body.area);
	
	        // orient vertices around the centre of mass at origin (0, 0)
	        var centre = Vertices.centre(body.vertices);
	        Vertices.translate(body.vertices, centre, -1);
	
	        // update inertia while vertices are at origin (0, 0)
	        Body.setInertia(body, Body._inertiaScale * Vertices.inertia(body.vertices, body.mass));
	
	        // update geometry
	        Vertices.translate(body.vertices, body.position);
	        Bounds.update(body.bounds, body.vertices, body.velocity);
	    };
	
	    /**
	     * Sets the parts of the `body` and updates mass, inertia and centroid.
	     * Each part will have its parent set to `body`.
	     * By default the convex hull will be automatically computed and set on `body`, unless `autoHull` is set to `false.`
	     * Note that this method will ensure that the first part in `body.parts` will always be the `body`.
	     * @method setParts
	     * @param {body} body
	     * @param [body] parts
	     * @param {bool} [autoHull=true]
	     */
	    Body.setParts = function(body, parts, autoHull) {
	        var i;
	
	        // add all the parts, ensuring that the first part is always the parent body
	        parts = parts.slice(0);
	        body.parts.length = 0;
	        body.parts.push(body);
	        body.parent = body;
	
	        for (i = 0; i < parts.length; i++) {
	            var part = parts[i];
	            if (part !== body) {
	                part.parent = body;
	                body.parts.push(part);
	            }
	        }
	
	        if (body.parts.length === 1)
	            return;
	
	        autoHull = typeof autoHull !== 'undefined' ? autoHull : true;
	
	        // find the convex hull of all parts to set on the parent body
	        if (autoHull) {
	            var vertices = [];
	            for (i = 0; i < parts.length; i++) {
	                vertices = vertices.concat(parts[i].vertices);
	            }
	
	            Vertices.clockwiseSort(vertices);
	
	            var hull = Vertices.hull(vertices),
	                hullCentre = Vertices.centre(hull);
	
	            Body.setVertices(body, hull);
	            Vertices.translate(body.vertices, hullCentre);
	        }
	
	        // sum the properties of all compound parts of the parent body
	        var total = _totalProperties(body);
	
	        body.area = total.area;
	        body.parent = body;
	        body.position.x = total.centre.x;
	        body.position.y = total.centre.y;
	        body.positionPrev.x = total.centre.x;
	        body.positionPrev.y = total.centre.y;
	
	        Body.setMass(body, total.mass);
	        Body.setInertia(body, total.inertia);
	        Body.setPosition(body, total.centre);
	    };
	
	    /**
	     * Sets the position of the body instantly. Velocity, angle, force etc. are unchanged.
	     * @method setPosition
	     * @param {body} body
	     * @param {vector} position
	     */
	    Body.setPosition = function(body, position) {
	        var delta = Vector.sub(position, body.position);
	        body.positionPrev.x += delta.x;
	        body.positionPrev.y += delta.y;
	
	        for (var i = 0; i < body.parts.length; i++) {
	            var part = body.parts[i];
	            part.position.x += delta.x;
	            part.position.y += delta.y;
	            Vertices.translate(part.vertices, delta);
	            Bounds.update(part.bounds, part.vertices, body.velocity);
	        }
	    };
	
	    /**
	     * Sets the angle of the body instantly. Angular velocity, position, force etc. are unchanged.
	     * @method setAngle
	     * @param {body} body
	     * @param {number} angle
	     */
	    Body.setAngle = function(body, angle) {
	        var delta = angle - body.angle;
	        body.anglePrev += delta;
	
	        for (var i = 0; i < body.parts.length; i++) {
	            var part = body.parts[i];
	            part.angle += delta;
	            Vertices.rotate(part.vertices, delta, body.position);
	            Axes.rotate(part.axes, delta);
	            Bounds.update(part.bounds, part.vertices, body.velocity);
	            if (i > 0) {
	                Vector.rotateAbout(part.position, delta, body.position, part.position);
	            }
	        }
	    };
	
	    /**
	     * Sets the linear velocity of the body instantly. Position, angle, force etc. are unchanged. See also `Body.applyForce`.
	     * @method setVelocity
	     * @param {body} body
	     * @param {vector} velocity
	     */
	    Body.setVelocity = function(body, velocity) {
	        body.positionPrev.x = body.position.x - velocity.x;
	        body.positionPrev.y = body.position.y - velocity.y;
	        body.velocity.x = velocity.x;
	        body.velocity.y = velocity.y;
	        body.speed = Vector.magnitude(body.velocity);
	    };
	
	    /**
	     * Sets the angular velocity of the body instantly. Position, angle, force etc. are unchanged. See also `Body.applyForce`.
	     * @method setAngularVelocity
	     * @param {body} body
	     * @param {number} velocity
	     */
	    Body.setAngularVelocity = function(body, velocity) {
	        body.anglePrev = body.angle - velocity;
	        body.angularVelocity = velocity;
	        body.angularSpeed = Math.abs(body.angularVelocity);
	    };
	
	    /**
	     * Moves a body by a given vector relative to its current position, without imparting any velocity.
	     * @method translate
	     * @param {body} body
	     * @param {vector} translation
	     */
	    Body.translate = function(body, translation) {
	        Body.setPosition(body, Vector.add(body.position, translation));
	    };
	
	    /**
	     * Rotates a body by a given angle relative to its current angle, without imparting any angular velocity.
	     * @method rotate
	     * @param {body} body
	     * @param {number} rotation
	     * @param {vector} [point]
	     */
	    Body.rotate = function(body, rotation, point) {
	        if (!point) {
	            Body.setAngle(body, body.angle + rotation);
	        } else {
	            var cos = Math.cos(rotation),
	                sin = Math.sin(rotation),
	                dx = body.position.x - point.x,
	                dy = body.position.y - point.y;
	                
	            Body.setPosition(body, {
	                x: point.x + (dx * cos - dy * sin),
	                y: point.y + (dx * sin + dy * cos)
	            });
	
	            Body.setAngle(body, body.angle + rotation);
	        }
	    };
	
	    /**
	     * Scales the body, including updating physical properties (mass, area, axes, inertia), from a world-space point (default is body centre).
	     * @method scale
	     * @param {body} body
	     * @param {number} scaleX
	     * @param {number} scaleY
	     * @param {vector} [point]
	     */
	    Body.scale = function(body, scaleX, scaleY, point) {
	        point = point || body.position;
	
	        for (var i = 0; i < body.parts.length; i++) {
	            var part = body.parts[i];
	
	            // scale position
	            part.position.x = point.x + (part.position.x - point.x) * scaleX;
	            part.position.y = point.y + (part.position.y - point.y) * scaleY;
	
	            // scale vertices
	            Vertices.scale(part.vertices, scaleX, scaleY, point);
	
	            // update properties
	            part.axes = Axes.fromVertices(part.vertices);
	
	            if (!body.isStatic) {
	                part.area = Vertices.area(part.vertices);
	                Body.setMass(part, body.density * part.area);
	
	                // update inertia (requires vertices to be at origin)
	                Vertices.translate(part.vertices, { x: -part.position.x, y: -part.position.y });
	                Body.setInertia(part, Vertices.inertia(part.vertices, part.mass));
	                Vertices.translate(part.vertices, { x: part.position.x, y: part.position.y });
	            }
	
	            // update bounds
	            Bounds.update(part.bounds, part.vertices, body.velocity);
	        }
	
	        // handle circles
	        if (body.circleRadius) { 
	            if (scaleX === scaleY) {
	                body.circleRadius *= scaleX;
	            } else {
	                // body is no longer a circle
	                body.circleRadius = null;
	            }
	        }
	
	        if (!body.isStatic) {
	            var total = _totalProperties(body);
	            body.area = total.area;
	            Body.setMass(body, total.mass);
	            Body.setInertia(body, total.inertia);
	        }
	    };
	
	    /**
	     * Performs a simulation step for the given `body`, including updating position and angle using Verlet integration.
	     * @method update
	     * @param {body} body
	     * @param {number} deltaTime
	     * @param {number} timeScale
	     * @param {number} correction
	     */
	    Body.update = function(body, deltaTime, timeScale, correction) {
	        var deltaTimeSquared = Math.pow(deltaTime * timeScale * body.timeScale, 2);
	
	        // from the previous step
	        var frictionAir = 1 - body.frictionAir * timeScale * body.timeScale,
	            velocityPrevX = body.position.x - body.positionPrev.x,
	            velocityPrevY = body.position.y - body.positionPrev.y;
	
	        // update velocity with Verlet integration
	        body.velocity.x = (velocityPrevX * frictionAir * correction) + (body.force.x / body.mass) * deltaTimeSquared;
	        body.velocity.y = (velocityPrevY * frictionAir * correction) + (body.force.y / body.mass) * deltaTimeSquared;
	
	        body.positionPrev.x = body.position.x;
	        body.positionPrev.y = body.position.y;
	        body.position.x += body.velocity.x;
	        body.position.y += body.velocity.y;
	
	        // update angular velocity with Verlet integration
	        body.angularVelocity = ((body.angle - body.anglePrev) * frictionAir * correction) + (body.torque / body.inertia) * deltaTimeSquared;
	        body.anglePrev = body.angle;
	        body.angle += body.angularVelocity;
	
	        // track speed and acceleration
	        body.speed = Vector.magnitude(body.velocity);
	        body.angularSpeed = Math.abs(body.angularVelocity);
	
	        // transform the body geometry
	        for (var i = 0; i < body.parts.length; i++) {
	            var part = body.parts[i];
	
	            Vertices.translate(part.vertices, body.velocity);
	            
	            if (i > 0) {
	                part.position.x += body.velocity.x;
	                part.position.y += body.velocity.y;
	            }
	
	            if (body.angularVelocity !== 0) {
	                Vertices.rotate(part.vertices, body.angularVelocity, body.position);
	                Axes.rotate(part.axes, body.angularVelocity);
	                if (i > 0) {
	                    Vector.rotateAbout(part.position, body.angularVelocity, body.position, part.position);
	                }
	            }
	
	            Bounds.update(part.bounds, part.vertices, body.velocity);
	        }
	    };
	
	    /**
	     * Applies a force to a body from a given world-space position, including resulting torque.
	     * @method applyForce
	     * @param {body} body
	     * @param {vector} position
	     * @param {vector} force
	     */
	    Body.applyForce = function(body, position, force) {
	        body.force.x += force.x;
	        body.force.y += force.y;
	        var offset = { x: position.x - body.position.x, y: position.y - body.position.y };
	        body.torque += offset.x * force.y - offset.y * force.x;
	    };
	
	    /**
	     * Returns the sums of the properties of all compound parts of the parent body.
	     * @method _totalProperties
	     * @private
	     * @param {body} body
	     * @return {}
	     */
	    var _totalProperties = function(body) {
	        // from equations at:
	        // https://ecourses.ou.edu/cgi-bin/ebook.cgi?doc=&topic=st&chap_sec=07.2&page=theory
	        // http://output.to/sideway/default.asp?qno=121100087
	
	        var properties = {
	            mass: 0,
	            area: 0,
	            inertia: 0,
	            centre: { x: 0, y: 0 }
	        };
	
	        // sum the properties of all compound parts of the parent body
	        for (var i = body.parts.length === 1 ? 0 : 1; i < body.parts.length; i++) {
	            var part = body.parts[i],
	                mass = part.mass !== Infinity ? part.mass : 1;
	
	            properties.mass += part.mass;
	            properties.area += part.area;
	            properties.inertia += part.inertia;
	            properties.centre = Vector.add(properties.centre, Vector.mult(part.position, mass));
	        }
	
	        properties.centre = Vector.div(properties.centre, properties.mass);
	
	        return properties;
	    };
	
	    /*
	    *
	    *  Events Documentation
	    *
	    */
	
	    /**
	    * Fired when a body starts sleeping (where `this` is the body).
	    *
	    * @event sleepStart
	    * @this {body} The body that has started sleeping
	    * @param {} event An event object
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired when a body ends sleeping (where `this` is the body).
	    *
	    * @event sleepEnd
	    * @this {body} The body that has ended sleeping
	    * @param {} event An event object
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /*
	    *
	    *  Properties Documentation
	    *
	    */
	
	    /**
	     * An integer `Number` uniquely identifying number generated in `Body.create` by `Common.nextId`.
	     *
	     * @property id
	     * @type number
	     */
	
	    /**
	     * A `String` denoting the type of object.
	     *
	     * @property type
	     * @type string
	     * @default "body"
	     * @readOnly
	     */
	
	    /**
	     * An arbitrary `String` name to help the user identify and manage bodies.
	     *
	     * @property label
	     * @type string
	     * @default "Body"
	     */
	
	    /**
	     * An array of bodies that make up this body. 
	     * The first body in the array must always be a self reference to the current body instance.
	     * All bodies in the `parts` array together form a single rigid compound body.
	     * Parts are allowed to overlap, have gaps or holes or even form concave bodies.
	     * Parts themselves should never be added to a `World`, only the parent body should be.
	     * Use `Body.setParts` when setting parts to ensure correct updates of all properties.
	     *
	     * @property parts
	     * @type body[]
	     */
	
	    /**
	     * An object reserved for storing plugin-specific properties.
	     *
	     * @property plugin
	     * @type {}
	     */
	
	    /**
	     * A self reference if the body is _not_ a part of another body.
	     * Otherwise this is a reference to the body that this is a part of.
	     * See `body.parts`.
	     *
	     * @property parent
	     * @type body
	     */
	
	    /**
	     * A `Number` specifying the angle of the body, in radians.
	     *
	     * @property angle
	     * @type number
	     * @default 0
	     */
	
	    /**
	     * An array of `Vector` objects that specify the convex hull of the rigid body.
	     * These should be provided about the origin `(0, 0)`. E.g.
	     *
	     *     [{ x: 0, y: 0 }, { x: 25, y: 50 }, { x: 50, y: 0 }]
	     *
	     * When passed via `Body.create`, the vertices are translated relative to `body.position` (i.e. world-space, and constantly updated by `Body.update` during simulation).
	     * The `Vector` objects are also augmented with additional properties required for efficient collision detection. 
	     *
	     * Other properties such as `inertia` and `bounds` are automatically calculated from the passed vertices (unless provided via `options`).
	     * Concave hulls are not currently supported. The module `Matter.Vertices` contains useful methods for working with vertices.
	     *
	     * @property vertices
	     * @type vector[]
	     */
	
	    /**
	     * A `Vector` that specifies the current world-space position of the body.
	     *
	     * @property position
	     * @type vector
	     * @default { x: 0, y: 0 }
	     */
	
	    /**
	     * A `Vector` that specifies the force to apply in the current step. It is zeroed after every `Body.update`. See also `Body.applyForce`.
	     *
	     * @property force
	     * @type vector
	     * @default { x: 0, y: 0 }
	     */
	
	    /**
	     * A `Number` that specifies the torque (turning force) to apply in the current step. It is zeroed after every `Body.update`.
	     *
	     * @property torque
	     * @type number
	     * @default 0
	     */
	
	    /**
	     * A `Number` that _measures_ the current speed of the body after the last `Body.update`. It is read-only and always positive (it's the magnitude of `body.velocity`).
	     *
	     * @readOnly
	     * @property speed
	     * @type number
	     * @default 0
	     */
	
	    /**
	     * A `Number` that _measures_ the current angular speed of the body after the last `Body.update`. It is read-only and always positive (it's the magnitude of `body.angularVelocity`).
	     *
	     * @readOnly
	     * @property angularSpeed
	     * @type number
	     * @default 0
	     */
	
	    /**
	     * A `Vector` that _measures_ the current velocity of the body after the last `Body.update`. It is read-only. 
	     * If you need to modify a body's velocity directly, you should either apply a force or simply change the body's `position` (as the engine uses position-Verlet integration).
	     *
	     * @readOnly
	     * @property velocity
	     * @type vector
	     * @default { x: 0, y: 0 }
	     */
	
	    /**
	     * A `Number` that _measures_ the current angular velocity of the body after the last `Body.update`. It is read-only. 
	     * If you need to modify a body's angular velocity directly, you should apply a torque or simply change the body's `angle` (as the engine uses position-Verlet integration).
	     *
	     * @readOnly
	     * @property angularVelocity
	     * @type number
	     * @default 0
	     */
	
	    /**
	     * A flag that indicates whether a body is considered static. A static body can never change position or angle and is completely fixed.
	     * If you need to set a body as static after its creation, you should use `Body.setStatic` as this requires more than just setting this flag.
	     *
	     * @property isStatic
	     * @type boolean
	     * @default false
	     */
	
	    /**
	     * A flag that indicates whether a body is a sensor. Sensor triggers collision events, but doesn't react with colliding body physically.
	     *
	     * @property isSensor
	     * @type boolean
	     * @default false
	     */
	
	    /**
	     * A flag that indicates whether the body is considered sleeping. A sleeping body acts similar to a static body, except it is only temporary and can be awoken.
	     * If you need to set a body as sleeping, you should use `Sleeping.set` as this requires more than just setting this flag.
	     *
	     * @property isSleeping
	     * @type boolean
	     * @default false
	     */
	
	    /**
	     * A `Number` that _measures_ the amount of movement a body currently has (a combination of `speed` and `angularSpeed`). It is read-only and always positive.
	     * It is used and updated by the `Matter.Sleeping` module during simulation to decide if a body has come to rest.
	     *
	     * @readOnly
	     * @property motion
	     * @type number
	     * @default 0
	     */
	
	    /**
	     * A `Number` that defines the number of updates in which this body must have near-zero velocity before it is set as sleeping by the `Matter.Sleeping` module (if sleeping is enabled by the engine).
	     *
	     * @property sleepThreshold
	     * @type number
	     * @default 60
	     */
	
	    /**
	     * A `Number` that defines the density of the body, that is its mass per unit area.
	     * If you pass the density via `Body.create` the `mass` property is automatically calculated for you based on the size (area) of the object.
	     * This is generally preferable to simply setting mass and allows for more intuitive definition of materials (e.g. rock has a higher density than wood).
	     *
	     * @property density
	     * @type number
	     * @default 0.001
	     */
	
	    /**
	     * A `Number` that defines the mass of the body, although it may be more appropriate to specify the `density` property instead.
	     * If you modify this value, you must also modify the `body.inverseMass` property (`1 / mass`).
	     *
	     * @property mass
	     * @type number
	     */
	
	    /**
	     * A `Number` that defines the inverse mass of the body (`1 / mass`).
	     * If you modify this value, you must also modify the `body.mass` property.
	     *
	     * @property inverseMass
	     * @type number
	     */
	
	    /**
	     * A `Number` that defines the moment of inertia (i.e. second moment of area) of the body.
	     * It is automatically calculated from the given convex hull (`vertices` array) and density in `Body.create`.
	     * If you modify this value, you must also modify the `body.inverseInertia` property (`1 / inertia`).
	     *
	     * @property inertia
	     * @type number
	     */
	
	    /**
	     * A `Number` that defines the inverse moment of inertia of the body (`1 / inertia`).
	     * If you modify this value, you must also modify the `body.inertia` property.
	     *
	     * @property inverseInertia
	     * @type number
	     */
	
	    /**
	     * A `Number` that defines the restitution (elasticity) of the body. The value is always positive and is in the range `(0, 1)`.
	     * A value of `0` means collisions may be perfectly inelastic and no bouncing may occur. 
	     * A value of `0.8` means the body may bounce back with approximately 80% of its kinetic energy.
	     * Note that collision response is based on _pairs_ of bodies, and that `restitution` values are _combined_ with the following formula:
	     *
	     *     Math.max(bodyA.restitution, bodyB.restitution)
	     *
	     * @property restitution
	     * @type number
	     * @default 0
	     */
	
	    /**
	     * A `Number` that defines the friction of the body. The value is always positive and is in the range `(0, 1)`.
	     * A value of `0` means that the body may slide indefinitely.
	     * A value of `1` means the body may come to a stop almost instantly after a force is applied.
	     *
	     * The effects of the value may be non-linear. 
	     * High values may be unstable depending on the body.
	     * The engine uses a Coulomb friction model including static and kinetic friction.
	     * Note that collision response is based on _pairs_ of bodies, and that `friction` values are _combined_ with the following formula:
	     *
	     *     Math.min(bodyA.friction, bodyB.friction)
	     *
	     * @property friction
	     * @type number
	     * @default 0.1
	     */
	
	    /**
	     * A `Number` that defines the static friction of the body (in the Coulomb friction model). 
	     * A value of `0` means the body will never 'stick' when it is nearly stationary and only dynamic `friction` is used.
	     * The higher the value (e.g. `10`), the more force it will take to initially get the body moving when nearly stationary.
	     * This value is multiplied with the `friction` property to make it easier to change `friction` and maintain an appropriate amount of static friction.
	     *
	     * @property frictionStatic
	     * @type number
	     * @default 0.5
	     */
	
	    /**
	     * A `Number` that defines the air friction of the body (air resistance). 
	     * A value of `0` means the body will never slow as it moves through space.
	     * The higher the value, the faster a body slows when moving through space.
	     * The effects of the value are non-linear. 
	     *
	     * @property frictionAir
	     * @type number
	     * @default 0.01
	     */
	
	    /**
	     * An `Object` that specifies the collision filtering properties of this body.
	     *
	     * Collisions between two bodies will obey the following rules:
	     * - If the two bodies have the same non-zero value of `collisionFilter.group`,
	     *   they will always collide if the value is positive, and they will never collide
	     *   if the value is negative.
	     * - If the two bodies have different values of `collisionFilter.group` or if one
	     *   (or both) of the bodies has a value of 0, then the category/mask rules apply as follows:
	     *
	     * Each body belongs to a collision category, given by `collisionFilter.category`. This
	     * value is used as a bit field and the category should have only one bit set, meaning that
	     * the value of this property is a power of two in the range [1, 2^31]. Thus, there are 32
	     * different collision categories available.
	     *
	     * Each body also defines a collision bitmask, given by `collisionFilter.mask` which specifies
	     * the categories it collides with (the value is the bitwise AND value of all these categories).
	     *
	     * Using the category/mask rules, two bodies `A` and `B` collide if each includes the other's
	     * category in its mask, i.e. `(categoryA & maskB) !== 0` and `(categoryB & maskA) !== 0`
	     * are both true.
	     *
	     * @property collisionFilter
	     * @type object
	     */
	
	    /**
	     * An Integer `Number`, that specifies the collision group this body belongs to.
	     * See `body.collisionFilter` for more information.
	     *
	     * @property collisionFilter.group
	     * @type object
	     * @default 0
	     */
	
	    /**
	     * A bit field that specifies the collision category this body belongs to.
	     * The category value should have only one bit set, for example `0x0001`.
	     * This means there are up to 32 unique collision categories available.
	     * See `body.collisionFilter` for more information.
	     *
	     * @property collisionFilter.category
	     * @type object
	     * @default 1
	     */
	
	    /**
	     * A bit mask that specifies the collision categories this body may collide with.
	     * See `body.collisionFilter` for more information.
	     *
	     * @property collisionFilter.mask
	     * @type object
	     * @default -1
	     */
	
	    /**
	     * A `Number` that specifies a tolerance on how far a body is allowed to 'sink' or rotate into other bodies.
	     * Avoid changing this value unless you understand the purpose of `slop` in physics engines.
	     * The default should generally suffice, although very large bodies may require larger values for stable stacking.
	     *
	     * @property slop
	     * @type number
	     * @default 0.05
	     */
	
	    /**
	     * A `Number` that allows per-body time scaling, e.g. a force-field where bodies inside are in slow-motion, while others are at full speed.
	     *
	     * @property timeScale
	     * @type number
	     * @default 1
	     */
	
	    /**
	     * An `Object` that defines the rendering properties to be consumed by the module `Matter.Render`.
	     *
	     * @property render
	     * @type object
	     */
	
	    /**
	     * A flag that indicates if the body should be rendered.
	     *
	     * @property render.visible
	     * @type boolean
	     * @default true
	     */
	
	    /**
	     * Sets the opacity to use when rendering.
	     *
	     * @property render.opacity
	     * @type number
	     * @default 1
	    */
	
	    /**
	     * An `Object` that defines the sprite properties to use when rendering, if any.
	     *
	     * @property render.sprite
	     * @type object
	     */
	
	    /**
	     * An `String` that defines the path to the image to use as the sprite texture, if any.
	     *
	     * @property render.sprite.texture
	     * @type string
	     */
	     
	    /**
	     * A `Number` that defines the scaling in the x-axis for the sprite, if any.
	     *
	     * @property render.sprite.xScale
	     * @type number
	     * @default 1
	     */
	
	    /**
	     * A `Number` that defines the scaling in the y-axis for the sprite, if any.
	     *
	     * @property render.sprite.yScale
	     * @type number
	     * @default 1
	     */
	
	     /**
	      * A `Number` that defines the offset in the x-axis for the sprite (normalised by texture width).
	      *
	      * @property render.sprite.xOffset
	      * @type number
	      * @default 0
	      */
	
	     /**
	      * A `Number` that defines the offset in the y-axis for the sprite (normalised by texture height).
	      *
	      * @property render.sprite.yOffset
	      * @type number
	      * @default 0
	      */
	
	    /**
	     * A `Number` that defines the line width to use when rendering the body outline (if a sprite is not defined).
	     * A value of `0` means no outline will be rendered.
	     *
	     * @property render.lineWidth
	     * @type number
	     * @default 0
	     */
	
	    /**
	     * A `String` that defines the fill style to use when rendering the body (if a sprite is not defined).
	     * It is the same as when using a canvas, so it accepts CSS style property values.
	     *
	     * @property render.fillStyle
	     * @type string
	     * @default a random colour
	     */
	
	    /**
	     * A `String` that defines the stroke style to use when rendering the body outline (if a sprite is not defined).
	     * It is the same as when using a canvas, so it accepts CSS style property values.
	     *
	     * @property render.strokeStyle
	     * @type string
	     * @default a random colour
	     */
	
	    /**
	     * An array of unique axis vectors (edge normals) used for collision detection.
	     * These are automatically calculated from the given convex hull (`vertices` array) in `Body.create`.
	     * They are constantly updated by `Body.update` during the simulation.
	     *
	     * @property axes
	     * @type vector[]
	     */
	     
	    /**
	     * A `Number` that _measures_ the area of the body's convex hull, calculated at creation by `Body.create`.
	     *
	     * @property area
	     * @type string
	     * @default 
	     */
	
	    /**
	     * A `Bounds` object that defines the AABB region for the body.
	     * It is automatically calculated from the given convex hull (`vertices` array) in `Body.create` and constantly updated by `Body.update` during simulation.
	     *
	     * @property bounds
	     * @type bounds
	     */
	
	})();


/***/ }),
/* 52 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(152);
	var createDesc = __webpack_require__(106);
	var toIObject = __webpack_require__(55);
	var toPrimitive = __webpack_require__(68);
	var has = __webpack_require__(52);
	var IE8_DOM_DEFINE = __webpack_require__(386);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(19) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(52);
	var toObject = __webpack_require__(30);
	var IE_PROTO = __webpack_require__(239)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(151);
	var defined = __webpack_require__(65);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CONST = __webpack_require__(49);
	var Smoothing = __webpack_require__(268);
	
	// The pool into which the canvas elements are placed.
	var pool = [];
	
	//  Automatically apply smoothing(false) to created Canvas elements
	var _disableContextSmoothing = false;
	
	/**
	 * The CanvasPool is a global static object, that allows Phaser to recycle and pool 2D Context Canvas DOM elements.
	 * It does not pool WebGL Contexts, because once the context options are set they cannot be modified again, 
	 * which is useless for some of the Phaser pipelines / renderer.
	 *
	 * This singleton is instantiated as soon as Phaser loads, before a Phaser.Game instance has even been created.
	 * Which means all instances of Phaser Games on the same page can share the one single pool.
	 *
	 * @namespace Phaser.Display.Canvas.CanvasPool
	 * @since 3.0.0
	 */
	var CanvasPool = function ()
	{
	    /**
	     * Creates a new Canvas DOM element, or pulls one from the pool if free.
	     *
	     * @function Phaser.Display.Canvas.CanvasPool.create
	     * @since 3.0.0
	     *
	     * @param {*} parent - The parent of the Canvas object.
	     * @param {integer} [width=1] - The width of the Canvas.
	     * @param {integer} [height=1] - The height of the Canvas.
	     * @param {integer} [canvasType=Phaser.CANVAS] - The type of the Canvas. Either `Phaser.CANVAS` or `Phaser.WEBGL`.
	     * @param {boolean} [selfParent=false] - Use the generated Canvas element as the parent?
	     *
	     * @return {HTMLCanvasElement} [description]
	     */
	    var create = function (parent, width, height, canvasType, selfParent)
	    {
	        if (width === undefined) { width = 1; }
	        if (height === undefined) { height = 1; }
	        if (canvasType === undefined) { canvasType = CONST.CANVAS; }
	        if (selfParent === undefined) { selfParent = false; }
	
	        var canvas;
	        var container = first(canvasType);
	
	        if (container === null)
	        {
	            container = {
	                parent: parent,
	                canvas: document.createElement('canvas'),
	                type: canvasType
	            };
	
	            if (canvasType === CONST.CANVAS)
	            {
	                pool.push(container);
	            }
	
	            canvas = container.canvas;
	        }
	        else
	        {
	            container.parent = parent;
	
	            canvas = container.canvas;
	        }
	
	        if (selfParent)
	        {
	            container.parent = canvas;
	        }
	
	        canvas.width = width;
	        canvas.height = height;
	
	        if (_disableContextSmoothing && canvasType === CONST.CANVAS)
	        {
	            Smoothing.disable(canvas.getContext('2d'));
	        }
	
	        return canvas;
	    };
	
	    /**
	     * Creates a new Canvas DOM element, or pulls one from the pool if free.
	     *
	     * @function Phaser.Display.Canvas.CanvasPool.create2D
	     * @since 3.0.0
	     *
	     * @param {*} parent - The parent of the Canvas object.
	     * @param {integer} [width=1] - The width of the Canvas.
	     * @param {integer} [height=1] - The height of the Canvas.
	     *
	     * @return {HTMLCanvasElement} [description]
	     */
	    var create2D = function (parent, width, height)
	    {
	        return create(parent, width, height, CONST.CANVAS);
	    };
	
	    /**
	     * Creates a new Canvas DOM element, or pulls one from the pool if free.
	     *
	     * @function Phaser.Display.Canvas.CanvasPool.createWebGL
	     * @since 3.0.0
	     *
	     * @param {*} parent - The parent of the Canvas object.
	     * @param {integer} [width=1] - The width of the Canvas.
	     * @param {integer} [height=1] - The height of the Canvas.
	     *
	     * @return {HTMLCanvasElement} [description]
	     */
	    var createWebGL = function (parent, width, height)
	    {
	        return create(parent, width, height, CONST.WEBGL);
	    };
	
	    /**
	     * Gets the first free canvas index from the pool.
	     *
	     * @function Phaser.Display.Canvas.CanvasPool.first
	     * @since 3.0.0
	     *
	     * @param {integer} [canvasType=Phaser.CANVAS] - The type of the Canvas. Either `Phaser.CANVAS` or `Phaser.WEBGL`.
	     *
	     * @return {HTMLCanvasElement} [description]
	     */
	    var first = function (canvasType)
	    {
	        if (canvasType === undefined) { canvasType = CONST.CANVAS; }
	
	        if (canvasType === CONST.WEBGL)
	        {
	            return null;
	        }
	
	        for (var i = 0; i < pool.length; i++)
	        {
	            var container = pool[i];
	
	            if (!container.parent && container.type === canvasType)
	            {
	                return container;
	            }
	        }
	
	        return null;
	    };
	
	    /**
	     * Looks up a canvas based on its parent, and if found puts it back in the pool, freeing it up for re-use.
	     * The canvas has its width and height set to 1, and its parent attribute nulled.
	     *
	     * @function Phaser.Display.Canvas.CanvasPool.remove
	     * @since 3.0.0
	     *
	     * @param {*} parent - [description]
	     */
	    var remove = function (parent)
	    {
	        //  Check to see if the parent is a canvas object
	        var isCanvas = parent instanceof HTMLCanvasElement;
	
	        pool.forEach(function (container)
	        {
	            if ((isCanvas && container.canvas === parent) || (!isCanvas && container.parent === parent))
	            {
	                container.parent = null;
	                container.canvas.width = 1;
	                container.canvas.height = 1;
	            }
	        });
	    };
	
	    /**
	     * Gets the total number of used canvas elements in the pool.
	     *
	     * @function Phaser.Display.Canvas.CanvasPool.total
	     * @since 3.0.0
	     *
	     * @return {integer} [description]
	     */
	    var total = function ()
	    {
	        var c = 0;
	
	        pool.forEach(function (container)
	        {
	            if (container.parent)
	            {
	                c++;
	            }
	        });
	
	        return c;
	    };
	
	    /**
	     * Gets the total number of free canvas elements in the pool.
	     *
	     * @function Phaser.Display.Canvas.CanvasPool.free
	     * @since 3.0.0
	     *
	     * @return {integer} [description]
	     */
	    var free = function ()
	    {
	        return pool.length - total();
	    };
	
	    /**
	     * Disable context smoothing on any new Canvas element created.
	     *
	     * @function Phaser.Display.Canvas.CanvasPool.disableSmoothing
	     * @since 3.0.0
	     */
	    var disableSmoothing = function ()
	    {
	        _disableContextSmoothing = true;
	    };
	
	    /**
	     * Enable context smoothing on any new Canvas element created.
	     *
	     * @function Phaser.Display.Canvas.CanvasPool.enableSmoothing
	     * @since 3.0.0
	     */
	    var enableSmoothing = function ()
	    {
	        _disableContextSmoothing = false;
	    };
	
	    return {
	        create2D: create2D,
	        create: create,
	        createWebGL: createWebGL,
	        disableSmoothing: disableSmoothing,
	        enableSmoothing: enableSmoothing,
	        first: first,
	        free: free,
	        pool: pool,
	        remove: remove,
	        total: total
	    };
	};
	
	//  If we export the called function here, it'll only be invoked once (not every time it's required).
	module.exports = CanvasPool();


/***/ }),
/* 57 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Tilemaps.Formats
	 */
	
	module.exports = {
	
	    /**
	     * CSV Map Type
	     * 
	     * @name Phaser.Tilemaps.Formats.CSV
	     * @type {number}
	     * @since 3.0.0
	     */
	    CSV: 0,
	
	    /**
	     * Tiled JSON Map Type
	     * 
	     * @name Phaser.Tilemaps.Formats.TILED_JSON
	     * @type {number}
	     * @since 3.0.0
	     */
	    TILED_JSON: 1,
	
	    /**
	     * 2D Array Map Type
	     * 
	     * @name Phaser.Tilemaps.Formats.ARRAY_2D
	     * @type {number}
	     * @since 3.0.0
	     */
	    ARRAY_2D: 2,
	
	    /**
	     * Weltmeister (Impact.js) Map Type
	     * 
	     * @name Phaser.Tilemaps.Formats.WELTMEISTER
	     * @type {number}
	     * @since 3.0.0
	     */
	    WELTMEISTER: 3
	
	};


/***/ }),
/* 58 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.6' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(40);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(11);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Initialize a jQuery object
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(32),
		__webpack_require__(27),
		__webpack_require__(418),
	
		__webpack_require__(435)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, isFunction, rsingleTag ) {
	
	"use strict";
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	return init;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Force a value within the boundaries by clamping it to the range `min`, `max`.
	 *
	 * @function Phaser.Math.Clamp
	 * @since 3.0.0
	 *
	 * @param {number} value - The value to be clamped.
	 * @param {number} min - The minimum bounds.
	 * @param {number} max - The maximum bounds.
	 *
	 * @return {number} The clamped value.
	 */
	var Clamp = function (value, min, max)
	{
	    return Math.max(min, Math.min(max, value));
	};
	
	module.exports = Clamp;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(60);
	var IObject = __webpack_require__(151);
	var toObject = __webpack_require__(30);
	var toLength = __webpack_require__(21);
	var asc = __webpack_require__(224);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 65 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(2);
	var core = __webpack_require__(59);
	var fails = __webpack_require__(11);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(13);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(425)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( Data ) {
		"use strict";
	
		return new Data();
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Takes an array of Game Objects, or any objects that have a public property as defined in `key`,
	 * and then adds the given value to it.
	 *
	 * The optional `step` property is applied incrementally, multiplied by each item in the array.
	 *
	 * To use this with a Group: `PropertyValueInc(group.getChildren(), key, value, step)`
	 *
	 * @function Phaser.Actions.PropertyValueInc
	 * @since 3.3.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {string} key - The property to be updated.
	 * @param {number} value - The amount to be added to the property.
	 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var PropertyValueInc = function (items, key, value, step, index, direction)
	{
	    if (step === undefined) { step = 0; }
	    if (index === undefined) { index = 0; }
	    if (direction === undefined) { direction = 1; }
	
	    var i;
	    var t = 0;
	    var end = items.length;
	
	    if (direction === 1)
	    {
	        //  Start to End
	        for (i = index; i < end; i++)
	        {
	            items[i][key] += value + (t * step);
	            t++;
	        }
	    }
	    else
	    {
	        //  End to Start
	        for (i = index; i >= 0; i--)
	        {
	            items[i][key] += value + (t * step);
	            t++;
	        }
	    }
	
	    return items;
	};
	
	module.exports = PropertyValueInc;


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	/**
	* The `Matter.Vector` module contains methods for creating and manipulating vectors.
	* Vectors are the basis of all the geometry related operations in the engine.
	* A `Matter.Vector` object is of the form `{ x: 0, y: 0 }`.
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class Vector
	*/
	
	// TODO: consider params for reusing vector objects
	
	var Vector = {};
	
	module.exports = Vector;
	
	(function() {
	
	    /**
	     * Creates a new vector.
	     * @method create
	     * @param {number} x
	     * @param {number} y
	     * @return {vector} A new vector
	     */
	    Vector.create = function(x, y) {
	        return { x: x || 0, y: y || 0 };
	    };
	
	    /**
	     * Returns a new vector with `x` and `y` copied from the given `vector`.
	     * @method clone
	     * @param {vector} vector
	     * @return {vector} A new cloned vector
	     */
	    Vector.clone = function(vector) {
	        return { x: vector.x, y: vector.y };
	    };
	
	    /**
	     * Returns the magnitude (length) of a vector.
	     * @method magnitude
	     * @param {vector} vector
	     * @return {number} The magnitude of the vector
	     */
	    Vector.magnitude = function(vector) {
	        return Math.sqrt((vector.x * vector.x) + (vector.y * vector.y));
	    };
	
	    /**
	     * Returns the magnitude (length) of a vector (therefore saving a `sqrt` operation).
	     * @method magnitudeSquared
	     * @param {vector} vector
	     * @return {number} The squared magnitude of the vector
	     */
	    Vector.magnitudeSquared = function(vector) {
	        return (vector.x * vector.x) + (vector.y * vector.y);
	    };
	
	    /**
	     * Rotates the vector about (0, 0) by specified angle.
	     * @method rotate
	     * @param {vector} vector
	     * @param {number} angle
	     * @param {vector} [output]
	     * @return {vector} The vector rotated about (0, 0)
	     */
	    Vector.rotate = function(vector, angle, output) {
	        var cos = Math.cos(angle), sin = Math.sin(angle);
	        if (!output) output = {};
	        var x = vector.x * cos - vector.y * sin;
	        output.y = vector.x * sin + vector.y * cos;
	        output.x = x;
	        return output;
	    };
	
	    /**
	     * Rotates the vector about a specified point by specified angle.
	     * @method rotateAbout
	     * @param {vector} vector
	     * @param {number} angle
	     * @param {vector} point
	     * @param {vector} [output]
	     * @return {vector} A new vector rotated about the point
	     */
	    Vector.rotateAbout = function(vector, angle, point, output) {
	        var cos = Math.cos(angle), sin = Math.sin(angle);
	        if (!output) output = {};
	        var x = point.x + ((vector.x - point.x) * cos - (vector.y - point.y) * sin);
	        output.y = point.y + ((vector.x - point.x) * sin + (vector.y - point.y) * cos);
	        output.x = x;
	        return output;
	    };
	
	    /**
	     * Normalises a vector (such that its magnitude is `1`).
	     * @method normalise
	     * @param {vector} vector
	     * @return {vector} A new vector normalised
	     */
	    Vector.normalise = function(vector) {
	        var magnitude = Vector.magnitude(vector);
	        if (magnitude === 0)
	            return { x: 0, y: 0 };
	        return { x: vector.x / magnitude, y: vector.y / magnitude };
	    };
	
	    /**
	     * Returns the dot-product of two vectors.
	     * @method dot
	     * @param {vector} vectorA
	     * @param {vector} vectorB
	     * @return {number} The dot product of the two vectors
	     */
	    Vector.dot = function(vectorA, vectorB) {
	        return (vectorA.x * vectorB.x) + (vectorA.y * vectorB.y);
	    };
	
	    /**
	     * Returns the cross-product of two vectors.
	     * @method cross
	     * @param {vector} vectorA
	     * @param {vector} vectorB
	     * @return {number} The cross product of the two vectors
	     */
	    Vector.cross = function(vectorA, vectorB) {
	        return (vectorA.x * vectorB.y) - (vectorA.y * vectorB.x);
	    };
	
	    /**
	     * Returns the cross-product of three vectors.
	     * @method cross3
	     * @param {vector} vectorA
	     * @param {vector} vectorB
	     * @param {vector} vectorC
	     * @return {number} The cross product of the three vectors
	     */
	    Vector.cross3 = function(vectorA, vectorB, vectorC) {
	        return (vectorB.x - vectorA.x) * (vectorC.y - vectorA.y) - (vectorB.y - vectorA.y) * (vectorC.x - vectorA.x);
	    };
	
	    /**
	     * Adds the two vectors.
	     * @method add
	     * @param {vector} vectorA
	     * @param {vector} vectorB
	     * @param {vector} [output]
	     * @return {vector} A new vector of vectorA and vectorB added
	     */
	    Vector.add = function(vectorA, vectorB, output) {
	        if (!output) output = {};
	        output.x = vectorA.x + vectorB.x;
	        output.y = vectorA.y + vectorB.y;
	        return output;
	    };
	
	    /**
	     * Subtracts the two vectors.
	     * @method sub
	     * @param {vector} vectorA
	     * @param {vector} vectorB
	     * @param {vector} [output]
	     * @return {vector} A new vector of vectorA and vectorB subtracted
	     */
	    Vector.sub = function(vectorA, vectorB, output) {
	        if (!output) output = {};
	        output.x = vectorA.x - vectorB.x;
	        output.y = vectorA.y - vectorB.y;
	        return output;
	    };
	
	    /**
	     * Multiplies a vector and a scalar.
	     * @method mult
	     * @param {vector} vector
	     * @param {number} scalar
	     * @return {vector} A new vector multiplied by scalar
	     */
	    Vector.mult = function(vector, scalar) {
	        return { x: vector.x * scalar, y: vector.y * scalar };
	    };
	
	    /**
	     * Divides a vector and a scalar.
	     * @method div
	     * @param {vector} vector
	     * @param {number} scalar
	     * @return {vector} A new vector divided by scalar
	     */
	    Vector.div = function(vector, scalar) {
	        return { x: vector.x / scalar, y: vector.y / scalar };
	    };
	
	    /**
	     * Returns the perpendicular vector. Set `negate` to true for the perpendicular in the opposite direction.
	     * @method perp
	     * @param {vector} vector
	     * @param {bool} [negate=false]
	     * @return {vector} The perpendicular vector
	     */
	    Vector.perp = function(vector, negate) {
	        negate = negate === true ? -1 : 1;
	        return { x: negate * -vector.y, y: negate * vector.x };
	    };
	
	    /**
	     * Negates both components of a vector such that it points in the opposite direction.
	     * @method neg
	     * @param {vector} vector
	     * @return {vector} The negated vector
	     */
	    Vector.neg = function(vector) {
	        return { x: -vector.x, y: -vector.y };
	    };
	
	    /**
	     * Returns the angle in radians between the two vectors relative to the x-axis.
	     * @method angle
	     * @param {vector} vectorA
	     * @param {vector} vectorB
	     * @return {number} The angle in radians
	     */
	    Vector.angle = function(vectorA, vectorB) {
	        return Math.atan2(vectorB.y - vectorA.y, vectorB.x - vectorA.x);
	    };
	
	    /**
	     * Temporary vector pool (not thread-safe).
	     * @property _temp
	     * @type {vector[]}
	     * @private
	     */
	    Vector._temp = [
	        Vector.create(), Vector.create(), 
	        Vector.create(), Vector.create(), 
	        Vector.create(), Vector.create()
	    ];
	
	})();

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(407);
	var $export = __webpack_require__(2);
	var shared = __webpack_require__(187)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(410))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(19)) {
	  var LIBRARY = __webpack_require__(92);
	  var global = __webpack_require__(8);
	  var fails = __webpack_require__(11);
	  var $export = __webpack_require__(2);
	  var $typed = __webpack_require__(189);
	  var $buffer = __webpack_require__(245);
	  var ctx = __webpack_require__(60);
	  var anInstance = __webpack_require__(101);
	  var propertyDesc = __webpack_require__(106);
	  var hide = __webpack_require__(45);
	  var redefineAll = __webpack_require__(107);
	  var toInteger = __webpack_require__(67);
	  var toLength = __webpack_require__(21);
	  var toIndex = __webpack_require__(405);
	  var toAbsoluteIndex = __webpack_require__(109);
	  var toPrimitive = __webpack_require__(68);
	  var has = __webpack_require__(52);
	  var classof = __webpack_require__(150);
	  var isObject = __webpack_require__(13);
	  var toObject = __webpack_require__(30);
	  var isArrayIter = __webpack_require__(231);
	  var create = __webpack_require__(103);
	  var getPrototypeOf = __webpack_require__(54);
	  var gOPN = __webpack_require__(104).f;
	  var getIterFn = __webpack_require__(247);
	  var uid = __webpack_require__(110);
	  var wks = __webpack_require__(16);
	  var createArrayMethod = __webpack_require__(64);
	  var createArrayIncludes = __webpack_require__(176);
	  var speciesConstructor = __webpack_require__(188);
	  var ArrayIterators = __webpack_require__(248);
	  var Iterators = __webpack_require__(124);
	  var $iterDetect = __webpack_require__(182);
	  var setSpecies = __webpack_require__(108);
	  var arrayFill = __webpack_require__(223);
	  var arrayCopyWithin = __webpack_require__(378);
	  var $DP = __webpack_require__(20);
	  var $GOPD = __webpack_require__(53);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 74 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Returns the bottom coordinate from the bounds of the Game Object.
	 *
	 * @function Phaser.Display.Bounds.GetBottom
	 * @since 3.0.0
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
	 *
	 * @return {number} The bottom coordinate of the bounds of the Game Object.
	 */
	var GetBottom = function (gameObject)
	{
	    return (gameObject.y + gameObject.height) - (gameObject.height * gameObject.originY);
	};
	
	module.exports = GetBottom;


/***/ }),
/* 75 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Returns the left coordinate from the bounds of the Game Object.
	 *
	 * @function Phaser.Display.Bounds.GetLeft
	 * @since 3.0.0
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
	 *
	 * @return {number} The left coordinate of the bounds of the Game Object.
	 */
	var GetLeft = function (gameObject)
	{
	    return gameObject.x - (gameObject.width * gameObject.originX);
	};
	
	module.exports = GetLeft;


/***/ }),
/* 76 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Returns the right coordinate from the bounds of the Game Object.
	 *
	 * @function Phaser.Display.Bounds.GetRight
	 * @since 3.0.0
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
	 *
	 * @return {number} The right coordinate of the bounds of the Game Object.
	 */
	var GetRight = function (gameObject)
	{
	    return (gameObject.x + gameObject.width) - (gameObject.width * gameObject.originX);
	};
	
	module.exports = GetRight;


/***/ }),
/* 77 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Returns the top coordinate from the bounds of the Game Object.
	 *
	 * @function Phaser.Display.Bounds.GetTop
	 * @since 3.0.0
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
	 *
	 * @return {number} The top coordinate of the bounds of the Game Object.
	 */
	var GetTop = function (gameObject)
	{
	    return gameObject.y - (gameObject.height * gameObject.originY);
	};
	
	module.exports = GetTop;


/***/ }),
/* 78 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Positions the Game Object so that the bottom of its bounds aligns with the given coordinate.
	 *
	 * @function Phaser.Display.Bounds.SetBottom
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
	 * @param {number} value - The coordinate to position the Game Object bounds on.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
	 */
	var SetBottom = function (gameObject, value)
	{
	    gameObject.y = (value - gameObject.height) + (gameObject.height * gameObject.originY);
	
	    return gameObject;
	};
	
	module.exports = SetBottom;


/***/ }),
/* 79 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Positions the Game Object so that the left of its bounds aligns with the given coordinate.
	 *
	 * @function Phaser.Display.Bounds.SetLeft
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
	 * @param {number} value - The coordinate to position the Game Object bounds on.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
	 */
	var SetLeft = function (gameObject, value)
	{
	    gameObject.x = value + (gameObject.width * gameObject.originX);
	
	    return gameObject;
	};
	
	module.exports = SetLeft;


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Positions the Game Object so that the left of its bounds aligns with the given coordinate.
	 *
	 * @function Phaser.Display.Bounds.SetRight
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
	 * @param {number} value - The coordinate to position the Game Object bounds on.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
	 */
	var SetRight = function (gameObject, value)
	{
	    gameObject.x = (value - gameObject.width) + (gameObject.width * gameObject.originX);
	
	    return gameObject;
	};
	
	module.exports = SetRight;


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Positions the Game Object so that the top of its bounds aligns with the given coordinate.
	 *
	 * @function Phaser.Display.Bounds.SetTop
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
	 * @param {number} value - The coordinate to position the Game Object bounds on.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
	 */
	var SetTop = function (gameObject, value)
	{
	    gameObject.y = value + (gameObject.height * gameObject.originY);
	
	    return gameObject;
	};
	
	module.exports = SetTop;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(28);
	var GameObject = __webpack_require__(5);
	var SpriteRender = __webpack_require__(1184);
	
	/**
	 * @classdesc
	 * A Sprite Game Object.
	 *
	 * A Sprite Game Object is used for the display of both static and animated images in your game.
	 * Sprites can have input events and physics bodies. They can also be tweened, tinted, scrolled
	 * and animated.
	 *
	 * The main difference between a Sprite and an Image Game Object is that you cannot animate Images.
	 * As such, Sprites take a fraction longer to process and have a larger API footprint due to the Animation
	 * Component. If you do not require animation then you can safely use Images to replace Sprites in all cases.
	 *
	 * @class Sprite
	 * @extends Phaser.GameObjects.GameObject
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @since 3.0.0
	 *
	 * @extends Phaser.GameObjects.Components.Alpha
	 * @extends Phaser.GameObjects.Components.BlendMode
	 * @extends Phaser.GameObjects.Components.Depth
	 * @extends Phaser.GameObjects.Components.Flip
	 * @extends Phaser.GameObjects.Components.GetBounds
	 * @extends Phaser.GameObjects.Components.Mask
	 * @extends Phaser.GameObjects.Components.Origin
	 * @extends Phaser.GameObjects.Components.Pipeline
	 * @extends Phaser.GameObjects.Components.ScaleMode
	 * @extends Phaser.GameObjects.Components.ScrollFactor
	 * @extends Phaser.GameObjects.Components.Size
	 * @extends Phaser.GameObjects.Components.Texture
	 * @extends Phaser.GameObjects.Components.Tint
	 * @extends Phaser.GameObjects.Components.Transform
	 * @extends Phaser.GameObjects.Components.Visible
	 *
	 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	 * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	 */
	var Sprite = new Class({
	
	    Extends: GameObject,
	
	    Mixins: [
	        Components.Alpha,
	        Components.BlendMode,
	        Components.Depth,
	        Components.Flip,
	        Components.GetBounds,
	        Components.Mask,
	        Components.Origin,
	        Components.Pipeline,
	        Components.ScaleMode,
	        Components.ScrollFactor,
	        Components.Size,
	        Components.Texture,
	        Components.Tint,
	        Components.Transform,
	        Components.Visible,
	        SpriteRender
	    ],
	
	    initialize:
	
	    function Sprite (scene, x, y, texture, frame)
	    {
	        GameObject.call(this, scene, 'Sprite');
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Sprite#anims
	         * @type {Phaser.GameObjects.Components.Animation}
	         * @since 3.0.0
	         */
	        this.anims = new Components.Animation(this);
	
	        this.setTexture(texture, frame);
	        this.setPosition(x, y);
	        this.setSizeToFrame();
	        this.setOriginFromFrame();
	        this.initPipeline('TextureTintPipeline');
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Sprite#preUpdate
	     * @protected
	     * @since 3.0.0
	     *
	     * @param {number} time - [description]
	     * @param {number} delta - [description]
	     */
	    preUpdate: function (time, delta)
	    {
	        this.anims.update(time, delta);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Sprite#play
	     * @since 3.0.0
	     *
	     * @param {string} key - [description]
	     * @param {boolean} [ignoreIfPlaying=false] - [description]
	     * @param {integer} [startFrame=0] - [description]
	     *
	     * @return {Phaser.GameObjects.Sprite} This Game Object.
	     */
	    play: function (key, ignoreIfPlaying, startFrame)
	    {
	        this.anims.play(key, ignoreIfPlaying, startFrame);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Sprite#toJSON
	     * @since 3.0.0
	     *
	     * @return {JSONGameObject} A JSON representation of the Game Object.
	     */
	    toJSON: function ()
	    {
	        var data = Components.ToJSON(this);
	
	        //  Extra Sprite data is added here
	
	        return data;
	    }
	
	});
	
	module.exports = Sprite;


/***/ }),
/* 83 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Check to see if the Circle contains the given x / y coordinates.
	 *
	 * @function Phaser.Geom.Circle.Contains
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Circle} circle - The Circle to check.
	 * @param {number} x - The x coordinate to check within the circle.
	 * @param {number} y - The y coordinate to check within the circle.
	 *
	 * @return {boolean} True if the coordinates are within the circle, otherwise false.
	 */
	var Contains = function (circle, x, y)
	{
	    //  Check if x/y are within the bounds first
	    if (circle.radius > 0 && x >= circle.left && x <= circle.right && y >= circle.top && y <= circle.bottom)
	    {
	        var dx = (circle.x - x) * (circle.x - x);
	        var dy = (circle.y - y) * (circle.y - y);
	
	        return (dx + dy) <= (circle.radius * circle.radius);
	    }
	    else
	    {
	        return false;
	    }
	};
	
	module.exports = Contains;


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.Contains
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 * @param {number} x - [description]
	 * @param {number} y - [description]
	 *
	 * @return {boolean} [description]
	 */
	var Contains = function (rect, x, y)
	{
	    if (rect.width <= 0 || rect.height <= 0)
	    {
	        return false;
	    }
	
	    return (rect.x <= x && rect.x + rect.width >= x && rect.y <= y && rect.y + rect.height >= y);
	};
	
	module.exports = Contains;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

	/**
	* The `Matter.Bounds` module contains methods for creating and manipulating axis-aligned bounding boxes (AABB).
	*
	* @class Bounds
	*/
	
	var Bounds = {};
	
	module.exports = Bounds;
	
	(function() {
	
	    /**
	     * Creates a new axis-aligned bounding box (AABB) for the given vertices.
	     * @method create
	     * @param {vertices} vertices
	     * @return {bounds} A new bounds object
	     */
	    Bounds.create = function(vertices) {
	        var bounds = { 
	            min: { x: 0, y: 0 }, 
	            max: { x: 0, y: 0 }
	        };
	
	        if (vertices)
	            Bounds.update(bounds, vertices);
	        
	        return bounds;
	    };
	
	    /**
	     * Updates bounds using the given vertices and extends the bounds given a velocity.
	     * @method update
	     * @param {bounds} bounds
	     * @param {vertices} vertices
	     * @param {vector} velocity
	     */
	    Bounds.update = function(bounds, vertices, velocity) {
	        bounds.min.x = Infinity;
	        bounds.max.x = -Infinity;
	        bounds.min.y = Infinity;
	        bounds.max.y = -Infinity;
	
	        for (var i = 0; i < vertices.length; i++) {
	            var vertex = vertices[i];
	            if (vertex.x > bounds.max.x) bounds.max.x = vertex.x;
	            if (vertex.x < bounds.min.x) bounds.min.x = vertex.x;
	            if (vertex.y > bounds.max.y) bounds.max.y = vertex.y;
	            if (vertex.y < bounds.min.y) bounds.min.y = vertex.y;
	        }
	        
	        if (velocity) {
	            if (velocity.x > 0) {
	                bounds.max.x += velocity.x;
	            } else {
	                bounds.min.x += velocity.x;
	            }
	            
	            if (velocity.y > 0) {
	                bounds.max.y += velocity.y;
	            } else {
	                bounds.min.y += velocity.y;
	            }
	        }
	    };
	
	    /**
	     * Returns true if the bounds contains the given point.
	     * @method contains
	     * @param {bounds} bounds
	     * @param {vector} point
	     * @return {boolean} True if the bounds contain the point, otherwise false
	     */
	    Bounds.contains = function(bounds, point) {
	        return point.x >= bounds.min.x && point.x <= bounds.max.x 
	               && point.y >= bounds.min.y && point.y <= bounds.max.y;
	    };
	
	    /**
	     * Returns true if the two bounds intersect.
	     * @method overlaps
	     * @param {bounds} boundsA
	     * @param {bounds} boundsB
	     * @return {boolean} True if the bounds overlap, otherwise false
	     */
	    Bounds.overlaps = function(boundsA, boundsB) {
	        return (boundsA.min.x <= boundsB.max.x && boundsA.max.x >= boundsB.min.x
	                && boundsA.max.y >= boundsB.min.y && boundsA.min.y <= boundsB.max.y);
	    };
	
	    /**
	     * Translates the bounds by the given vector.
	     * @method translate
	     * @param {bounds} bounds
	     * @param {vector} vector
	     */
	    Bounds.translate = function(bounds, vector) {
	        bounds.min.x += vector.x;
	        bounds.max.x += vector.x;
	        bounds.min.y += vector.y;
	        bounds.max.y += vector.y;
	    };
	
	    /**
	     * Shifts the bounds to the given position.
	     * @method shift
	     * @param {bounds} bounds
	     * @param {vector} position
	     */
	    Bounds.shift = function(bounds, position) {
	        var deltaX = bounds.max.x - bounds.min.x,
	            deltaY = bounds.max.y - bounds.min.y;
	            
	        bounds.min.x = position.x;
	        bounds.max.x = position.x + deltaX;
	        bounds.min.y = position.y;
	        bounds.max.y = position.y + deltaY;
	    };
	    
	})();


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* The `Matter.Vertices` module contains methods for creating and manipulating sets of vertices.
	* A set of vertices is an array of `Matter.Vector` with additional indexing properties inserted by `Vertices.create`.
	* A `Matter.Body` maintains a set of vertices to represent the shape of the object (its convex hull).
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class Vertices
	*/
	
	var Vertices = {};
	
	module.exports = Vertices;
	
	var Vector = __webpack_require__(71);
	var Common = __webpack_require__(31);
	
	(function() {
	
	    /**
	     * Creates a new set of `Matter.Body` compatible vertices.
	     * The `points` argument accepts an array of `Matter.Vector` points orientated around the origin `(0, 0)`, for example:
	     *
	     *     [{ x: 0, y: 0 }, { x: 25, y: 50 }, { x: 50, y: 0 }]
	     *
	     * The `Vertices.create` method returns a new array of vertices, which are similar to Matter.Vector objects,
	     * but with some additional references required for efficient collision detection routines.
	     *
	     * Vertices must be specified in clockwise order.
	     *
	     * Note that the `body` argument is not optional, a `Matter.Body` reference must be provided.
	     *
	     * @method create
	     * @param {vector[]} points
	     * @param {body} body
	     */
	    Vertices.create = function(points, body) {
	        var vertices = [];
	
	        for (var i = 0; i < points.length; i++) {
	            var point = points[i],
	                vertex = {
	                    x: point.x,
	                    y: point.y,
	                    index: i,
	                    body: body,
	                    isInternal: false,
	                    contact: null
	                };
	
	            vertex.contact = {
	                vertex: vertex,
	                normalImpulse: 0,
	                tangentImpulse: 0
	            };
	
	            vertices.push(vertex);
	        }
	
	        return vertices;
	    };
	
	    /**
	     * Parses a string containing ordered x y pairs separated by spaces (and optionally commas), 
	     * into a `Matter.Vertices` object for the given `Matter.Body`.
	     * For parsing SVG paths, see `Svg.pathToVertices`.
	     * @method fromPath
	     * @param {string} path
	     * @param {body} body
	     * @return {vertices} vertices
	     */
	    Vertices.fromPath = function(path, body) {
	        var pathPattern = /L?\s*([\-\d\.e]+)[\s,]*([\-\d\.e]+)*/ig,
	            points = [];
	
	        path.replace(pathPattern, function(match, x, y) {
	            points.push({ x: parseFloat(x), y: parseFloat(y) });
	        });
	
	        return Vertices.create(points, body);
	    };
	
	    /**
	     * Returns the centre (centroid) of the set of vertices.
	     * @method centre
	     * @param {vertices} vertices
	     * @return {vector} The centre point
	     */
	    Vertices.centre = function(vertices) {
	        var area = Vertices.area(vertices, true),
	            centre = { x: 0, y: 0 },
	            cross,
	            temp,
	            j;
	
	        for (var i = 0; i < vertices.length; i++) {
	            j = (i + 1) % vertices.length;
	            cross = Vector.cross(vertices[i], vertices[j]);
	            temp = Vector.mult(Vector.add(vertices[i], vertices[j]), cross);
	            centre = Vector.add(centre, temp);
	        }
	
	        return Vector.div(centre, 6 * area);
	    };
	
	    /**
	     * Returns the average (mean) of the set of vertices.
	     * @method mean
	     * @param {vertices} vertices
	     * @return {vector} The average point
	     */
	    Vertices.mean = function(vertices) {
	        var average = { x: 0, y: 0 };
	
	        for (var i = 0; i < vertices.length; i++) {
	            average.x += vertices[i].x;
	            average.y += vertices[i].y;
	        }
	
	        return Vector.div(average, vertices.length);
	    };
	
	    /**
	     * Returns the area of the set of vertices.
	     * @method area
	     * @param {vertices} vertices
	     * @param {bool} signed
	     * @return {number} The area
	     */
	    Vertices.area = function(vertices, signed) {
	        var area = 0,
	            j = vertices.length - 1;
	
	        for (var i = 0; i < vertices.length; i++) {
	            area += (vertices[j].x - vertices[i].x) * (vertices[j].y + vertices[i].y);
	            j = i;
	        }
	
	        if (signed)
	            return area / 2;
	
	        return Math.abs(area) / 2;
	    };
	
	    /**
	     * Returns the moment of inertia (second moment of area) of the set of vertices given the total mass.
	     * @method inertia
	     * @param {vertices} vertices
	     * @param {number} mass
	     * @return {number} The polygon's moment of inertia
	     */
	    Vertices.inertia = function(vertices, mass) {
	        var numerator = 0,
	            denominator = 0,
	            v = vertices,
	            cross,
	            j;
	
	        // find the polygon's moment of inertia, using second moment of area
	        // from equations at http://www.physicsforums.com/showthread.php?t=25293
	        for (var n = 0; n < v.length; n++) {
	            j = (n + 1) % v.length;
	            cross = Math.abs(Vector.cross(v[j], v[n]));
	            numerator += cross * (Vector.dot(v[j], v[j]) + Vector.dot(v[j], v[n]) + Vector.dot(v[n], v[n]));
	            denominator += cross;
	        }
	
	        return (mass / 6) * (numerator / denominator);
	    };
	
	    /**
	     * Translates the set of vertices in-place.
	     * @method translate
	     * @param {vertices} vertices
	     * @param {vector} vector
	     * @param {number} scalar
	     */
	    Vertices.translate = function(vertices, vector, scalar) {
	        var i;
	        if (scalar) {
	            for (i = 0; i < vertices.length; i++) {
	                vertices[i].x += vector.x * scalar;
	                vertices[i].y += vector.y * scalar;
	            }
	        } else {
	            for (i = 0; i < vertices.length; i++) {
	                vertices[i].x += vector.x;
	                vertices[i].y += vector.y;
	            }
	        }
	
	        return vertices;
	    };
	
	    /**
	     * Rotates the set of vertices in-place.
	     * @method rotate
	     * @param {vertices} vertices
	     * @param {number} angle
	     * @param {vector} point
	     */
	    Vertices.rotate = function(vertices, angle, point) {
	        if (angle === 0)
	            return;
	
	        var cos = Math.cos(angle),
	            sin = Math.sin(angle);
	
	        for (var i = 0; i < vertices.length; i++) {
	            var vertice = vertices[i],
	                dx = vertice.x - point.x,
	                dy = vertice.y - point.y;
	                
	            vertice.x = point.x + (dx * cos - dy * sin);
	            vertice.y = point.y + (dx * sin + dy * cos);
	        }
	
	        return vertices;
	    };
	
	    /**
	     * Returns `true` if the `point` is inside the set of `vertices`.
	     * @method contains
	     * @param {vertices} vertices
	     * @param {vector} point
	     * @return {boolean} True if the vertices contains point, otherwise false
	     */
	    Vertices.contains = function(vertices, point) {
	        for (var i = 0; i < vertices.length; i++) {
	            var vertice = vertices[i],
	                nextVertice = vertices[(i + 1) % vertices.length];
	            if ((point.x - vertice.x) * (nextVertice.y - vertice.y) + (point.y - vertice.y) * (vertice.x - nextVertice.x) > 0) {
	                return false;
	            }
	        }
	
	        return true;
	    };
	
	    /**
	     * Scales the vertices from a point (default is centre) in-place.
	     * @method scale
	     * @param {vertices} vertices
	     * @param {number} scaleX
	     * @param {number} scaleY
	     * @param {vector} point
	     */
	    Vertices.scale = function(vertices, scaleX, scaleY, point) {
	        if (scaleX === 1 && scaleY === 1)
	            return vertices;
	
	        point = point || Vertices.centre(vertices);
	
	        var vertex,
	            delta;
	
	        for (var i = 0; i < vertices.length; i++) {
	            vertex = vertices[i];
	            delta = Vector.sub(vertex, point);
	            vertices[i].x = point.x + delta.x * scaleX;
	            vertices[i].y = point.y + delta.y * scaleY;
	        }
	
	        return vertices;
	    };
	
	    /**
	     * Chamfers a set of vertices by giving them rounded corners, returns a new set of vertices.
	     * The radius parameter is a single number or an array to specify the radius for each vertex.
	     * @method chamfer
	     * @param {vertices} vertices
	     * @param {number[]} radius
	     * @param {number} quality
	     * @param {number} qualityMin
	     * @param {number} qualityMax
	     */
	    Vertices.chamfer = function(vertices, radius, quality, qualityMin, qualityMax) {
	
	        if (typeof radius === 'number') {
	            radius = [radius];
	        } else {
	            radius = radius || [8];
	        }
	
	        if (!radius.length)
	            radius = [radius];
	
	        // quality defaults to -1, which is auto
	        quality = (typeof quality !== 'undefined') ? quality : -1;
	        qualityMin = qualityMin || 2;
	        qualityMax = qualityMax || 14;
	
	        var newVertices = [];
	
	        for (var i = 0; i < vertices.length; i++) {
	            var prevVertex = vertices[i - 1 >= 0 ? i - 1 : vertices.length - 1],
	                vertex = vertices[i],
	                nextVertex = vertices[(i + 1) % vertices.length],
	                currentRadius = radius[i < radius.length ? i : radius.length - 1];
	
	            if (currentRadius === 0) {
	                newVertices.push(vertex);
	                continue;
	            }
	
	            var prevNormal = Vector.normalise({ 
	                x: vertex.y - prevVertex.y, 
	                y: prevVertex.x - vertex.x
	            });
	
	            var nextNormal = Vector.normalise({ 
	                x: nextVertex.y - vertex.y, 
	                y: vertex.x - nextVertex.x
	            });
	
	            var diagonalRadius = Math.sqrt(2 * Math.pow(currentRadius, 2)),
	                radiusVector = Vector.mult(Common.clone(prevNormal), currentRadius),
	                midNormal = Vector.normalise(Vector.mult(Vector.add(prevNormal, nextNormal), 0.5)),
	                scaledVertex = Vector.sub(vertex, Vector.mult(midNormal, diagonalRadius));
	
	            var precision = quality;
	
	            if (quality === -1) {
	                // automatically decide precision
	                precision = Math.pow(currentRadius, 0.32) * 1.75;
	            }
	
	            precision = Common.clamp(precision, qualityMin, qualityMax);
	
	            // use an even value for precision, more likely to reduce axes by using symmetry
	            if (precision % 2 === 1)
	                precision += 1;
	
	            var alpha = Math.acos(Vector.dot(prevNormal, nextNormal)),
	                theta = alpha / precision;
	
	            for (var j = 0; j < precision; j++) {
	                newVertices.push(Vector.add(Vector.rotate(radiusVector, theta * j), scaledVertex));
	            }
	        }
	
	        return newVertices;
	    };
	
	    /**
	     * Sorts the input vertices into clockwise order in place.
	     * @method clockwiseSort
	     * @param {vertices} vertices
	     * @return {vertices} vertices
	     */
	    Vertices.clockwiseSort = function(vertices) {
	        var centre = Vertices.mean(vertices);
	
	        vertices.sort(function(vertexA, vertexB) {
	            return Vector.angle(centre, vertexA) - Vector.angle(centre, vertexB);
	        });
	
	        return vertices;
	    };
	
	    /**
	     * Returns true if the vertices form a convex shape (vertices must be in clockwise order).
	     * @method isConvex
	     * @param {vertices} vertices
	     * @return {bool} `true` if the `vertices` are convex, `false` if not (or `null` if not computable).
	     */
	    Vertices.isConvex = function(vertices) {
	        // http://paulbourke.net/geometry/polygonmesh/
	        // Copyright (c) Paul Bourke (use permitted)
	
	        var flag = 0,
	            n = vertices.length,
	            i,
	            j,
	            k,
	            z;
	
	        if (n < 3)
	            return null;
	
	        for (i = 0; i < n; i++) {
	            j = (i + 1) % n;
	            k = (i + 2) % n;
	            z = (vertices[j].x - vertices[i].x) * (vertices[k].y - vertices[j].y);
	            z -= (vertices[j].y - vertices[i].y) * (vertices[k].x - vertices[j].x);
	
	            if (z < 0) {
	                flag |= 1;
	            } else if (z > 0) {
	                flag |= 2;
	            }
	
	            if (flag === 3) {
	                return false;
	            }
	        }
	
	        if (flag !== 0){
	            return true;
	        } else {
	            return null;
	        }
	    };
	
	    /**
	     * Returns the convex hull of the input vertices as a new array of points.
	     * @method hull
	     * @param {vertices} vertices
	     * @return [vertex] vertices
	     */
	    Vertices.hull = function(vertices) {
	        // http://geomalgorithms.com/a10-_hull-1.html
	
	        var upper = [],
	            lower = [], 
	            vertex,
	            i;
	
	        // sort vertices on x-axis (y-axis for ties)
	        vertices = vertices.slice(0);
	        vertices.sort(function(vertexA, vertexB) {
	            var dx = vertexA.x - vertexB.x;
	            return dx !== 0 ? dx : vertexA.y - vertexB.y;
	        });
	
	        // build lower hull
	        for (i = 0; i < vertices.length; i += 1) {
	            vertex = vertices[i];
	
	            while (lower.length >= 2 
	                   && Vector.cross3(lower[lower.length - 2], lower[lower.length - 1], vertex) <= 0) {
	                lower.pop();
	            }
	
	            lower.push(vertex);
	        }
	
	        // build upper hull
	        for (i = vertices.length - 1; i >= 0; i -= 1) {
	            vertex = vertices[i];
	
	            while (upper.length >= 2 
	                   && Vector.cross3(upper[upper.length - 2], upper[upper.length - 1], vertex) <= 0) {
	                upper.pop();
	            }
	
	            upper.push(vertex);
	        }
	
	        // concatenation of the lower and upper hulls gives the convex hull
	        // omit last points because they are repeated at the beginning of the other list
	        upper.pop();
	        lower.pop();
	
	        return upper.concat(lower);
	    };
	
	})();


/***/ }),
/* 87 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Felipe Alfonso <@bitnenfer>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Renderer.WebGL.Utils
	 * @since 3.0.0
	 */
	module.exports = {
	
	    /**
	     * Packs four floats on a range from 0.0 to 1.0 into a single Uint32
	     *
	     * @function Phaser.Renderer.WebGL.Utils.getTintFromFloats
	     * @since 3.0.0
	     * 
	     * @param {number} r - Red component in a range from 0.0 to 1.0 
	     * @param {number} g - [description]
	     * @param {number} b - [description]
	     * @param {number} a - Alpha component in a range from 0.0 to 1.0
	     * 
	     * @return {number} [description]
	     */
	    getTintFromFloats: function (r, g, b, a)
	    {
	        var ur = ((r * 255.0)|0) & 0xFF;
	        var ug = ((g * 255.0)|0) & 0xFF;
	        var ub = ((b * 255.0)|0) & 0xFF;
	        var ua = ((a * 255.0)|0) & 0xFF;
	
	        return ((ua << 24) | (ur << 16) | (ug << 8) | ub) >>> 0;
	    },
	
	    /**
	     * Packs a Uint24, representing RGB components, with a Float32, representing
	     * the alpha component, with a range between 0.0 and 1.0 and return a Uint32
	     *
	     * @function Phaser.Renderer.WebGL.Utils.getTintAppendFloatAlpha
	     * @since 3.0.0
	     * 
	     * @param {number} rgb - Uint24 representing RGB components
	     * @param {number} a - Float32 representing Alpha component
	     * 
	     * @return {number} Packed RGBA as Uint32
	     */
	    getTintAppendFloatAlpha: function (rgb, a)
	    {
	        var ua = ((a * 255.0)|0) & 0xFF;
	        return ((ua << 24) | rgb) >>> 0;
	    },
	
	    /**
	     * Packs a Uint24, representing RGB components, with a Float32, representing
	     * the alpha component, with a range between 0.0 and 1.0 and return a 
	     * swizzled Uint32
	     *
	     * @function Phaser.Renderer.WebGL.Utils.getTintAppendFloatAlphaAndSwap
	     * @since 3.0.0
	     * 
	     * @param {number} rgb - Uint24 representing RGB components
	     * @param {number} a - Float32 representing Alpha component
	     * 
	     * @return {number} Packed RGBA as Uint32
	     */
	    getTintAppendFloatAlphaAndSwap: function (rgb, a)
	    {
	        var ur = ((rgb >> 16)|0) & 0xff;
	        var ug = ((rgb >> 8)|0) & 0xff;
	        var ub = (rgb|0) & 0xff;
	        var ua = ((a * 255.0)|0) & 0xFF;
	
	        return ((ua << 24) | (ub << 16) | (ug << 8) | ur) >>> 0;
	    },
	
	    /**
	     * Unpacks a Uint24 RGB into an array of floats of ranges of 0.0 and 1.0
	     *
	     * @function Phaser.Renderer.WebGL.Utils.getFloatsFromUintRGB
	     * @since 3.0.0
	     * 
	     * @param {number} rgb - RGB packed as a Uint24
	     * 
	     * @return {array} Array of floats representing each component as a float 
	     */
	    getFloatsFromUintRGB: function (rgb)
	    {
	        var ur = ((rgb >> 16)|0) & 0xff;
	        var ug = ((rgb >> 8)|0) & 0xff;
	        var ub = (rgb|0) & 0xff;
	
	        return [ ur / 255.0, ug / 255.0, ub / 255.0 ];
	    },
	
	    /**
	     * Counts how many attributes of 32 bits a vertex has
	     *
	     * @function Phaser.Renderer.WebGL.Utils.getComponentCount
	     * @since 3.0.0
	     * 
	     * @param {array} attributes - Array of attributes 
	     * @param {WebGLRenderingContext} glContext - WebGLContext used for check types
	     * 
	     * @return {number} Count of 32 bit attributes in vertex
	     */
	    getComponentCount: function (attributes, glContext)
	    {
	        var count = 0;
	
	        for (var index = 0; index < attributes.length; ++index)
	        {
	            var element = attributes[index];
	            
	            if (element.type === glContext.FLOAT)
	            {
	                count += element.size;
	            }
	            else
	            {
	                count += 1; // We'll force any other type to be 32 bit. for now
	            }
	        }
	
	        return count;
	    }
	
	};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetTileAt = __webpack_require__(212);
	var GetTilesWithin = __webpack_require__(34);
	
	/**
	 * Calculates interesting faces within the rectangular area specified (in tile coordinates) of the
	 * layer. Interesting faces are used internally for optimizing collisions against tiles. This method
	 * is mostly used internally.
	 *
	 * @function Phaser.Tilemaps.Components.CalculateFacesWithin
	 * @private
	 * @since 3.0.0
	 *
	 * @param {integer} tileX - [description]
	 * @param {integer} tileY - [description]
	 * @param {integer} width - [description]
	 * @param {integer} height - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 */
	var CalculateFacesWithin = function (tileX, tileY, width, height, layer)
	{
	    var above = null;
	    var below = null;
	    var left = null;
	    var right = null;
	
	    var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
	
	    for (var i = 0; i < tiles.length; i++)
	    {
	        var tile = tiles[i];
	
	        if (tile)
	        {
	            if (tile.collides)
	            {
	                above = GetTileAt(tile.x, tile.y - 1, true, layer);
	                below = GetTileAt(tile.x, tile.y + 1, true, layer);
	                left = GetTileAt(tile.x - 1, tile.y, true, layer);
	                right = GetTileAt(tile.x + 1, tile.y, true, layer);
	
	                tile.faceTop = (above && above.collides) ? false : true;
	                tile.faceBottom = (below && below.collides) ? false : true;
	                tile.faceLeft = (left && left.collides) ? false : true;
	                tile.faceRight = (right && right.collides) ? false : true;
	            }
	            else
	            {
	                tile.resetFaces();
	            }
	        }
	    }
	};
	
	module.exports = CalculateFacesWithin;


/***/ }),
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(16)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(45)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 92 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(110)('meta');
	var isObject = __webpack_require__(13);
	var has = __webpack_require__(52);
	var setDesc = __webpack_require__(20).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(11)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		// Only count HTML whitespace
		// Other whitespace should count in values
		// https://infra.spec.whatwg.org/#ascii-whitespace
		return ( /[^\x20\t\r\n\f]+/g );
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var GetColor = __webpack_require__(269);
	var GetColor32 = __webpack_require__(473);
	
	/**
	 * @classdesc
	 * The Color class holds a single color value and allows for easy modification and reading of it.
	 *
	 * @class Color
	 * @memberOf Phaser.Display
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {integer} [red=0] - The red color value. A number between 0 and 255.
	 * @param {integer} [green=0] - The green color value. A number between 0 and 255.
	 * @param {integer} [blue=0] - The blue color value. A number between 0 and 255.
	 * @param {integer} [alpha=255] - The alpha value. A number between 0 and 255.
	 */
	var Color = new Class({
	
	    initialize:
	
	    function Color (red, green, blue, alpha)
	    {
	        if (red === undefined) { red = 0; }
	        if (green === undefined) { green = 0; }
	        if (blue === undefined) { blue = 0; }
	        if (alpha === undefined) { alpha = 255; }
	
	        /**
	         * The internal red color value.
	         *
	         * @name Phaser.Display.Color#r
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this.r = 0;
	
	        /**
	         * The internal green color value.
	         *
	         * @name Phaser.Display.Color#g
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this.g = 0;
	
	        /**
	         * The internal blue color value.
	         *
	         * @name Phaser.Display.Color#b
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this.b = 0;
	
	        /**
	         * The internal alpha color value.
	         *
	         * @name Phaser.Display.Color#a
	         * @type {number}
	         * @private
	         * @default 255
	         * @since 3.0.0
	         */
	        this.a = 255;
	
	        /**
	         * An array containing the calculated color values for WebGL use.
	         *
	         * @name Phaser.Display.Color#gl
	         * @type {number[]}
	         * @since 3.0.0
	         */
	        this.gl = [ 0, 0, 0, 1 ];
	
	        /**
	         * Pre-calculated internal color value.
	         *
	         * @name Phaser.Display.Color#_color
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._color = 0;
	
	        /**
	         * Pre-calculated internal color32 value.
	         *
	         * @name Phaser.Display.Color#_color32
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._color32 = 0;
	
	        /**
	         * Pre-calculated internal color rgb string value.
	         *
	         * @name Phaser.Display.Color#_rgba
	         * @type {string}
	         * @private
	         * @default ''
	         * @since 3.0.0
	         */
	        this._rgba = '';
	
	        this.setTo(red, green, blue, alpha);
	    },
	
	    /**
	     * Sets this color to be transparent. Sets all values to zero.
	     *
	     * @method Phaser.Display.Color#transparent
	     * @since 3.0.0
	     *
	     * @return {Phaser.Display.Color} This Color object.
	     */
	    transparent: function ()
	    {
	        this.red = 0;
	        this.green = 0;
	        this.blue = 0;
	        this.alpha = 0;
	
	        return this.update();
	    },
	
	    /**
	     * Sets the color of this Color component.
	     *
	     * @method Phaser.Display.Color#setTo
	     * @since 3.0.0
	     *
	     * @param {integer} red - The red color value. A number between 0 and 255.
	     * @param {integer} green - The green color value. A number between 0 and 255.
	     * @param {integer} blue - The blue color value. A number between 0 and 255.
	     * @param {integer} [alpha=255] - The alpha value. A number between 0 and 255.
	     *
	     * @return {Phaser.Display.Color} This Color object.
	     */
	    setTo: function (red, green, blue, alpha)
	    {
	        if (alpha === undefined) { alpha = 255; }
	
	        this.red = red;
	        this.green = green;
	        this.blue = blue;
	        this.alpha = alpha;
	
	        return this.update();
	    },
	
	    /**
	     * Sets the red, green, blue and alpha GL values of this Color component.
	     *
	     * @method Phaser.Display.Color#setGLTo
	     * @since 3.0.0
	     *
	     * @param {float} red - The red color value. A number between 0 and 1.
	     * @param {float} green - The green color value. A number between 0 and 1.
	     * @param {float} blue - The blue color value. A number between 0 and 1.
	     * @param {float} [alpha=1] - The alpha value. A number between 0 and 1.
	     *
	     * @return {Phaser.Display.Color} This Color object.
	     */
	    setGLTo: function (red, green, blue, alpha)
	    {
	        if (alpha === undefined) { alpha = 1; }
	
	        this.redGL = red;
	        this.greenGL = green;
	        this.blueGL = blue;
	        this.alphaGL = alpha;
	
	        return this.update();
	    },
	
	    /**
	     * Sets the color based on the color object given.
	     *
	     * @method Phaser.Display.Color#setFromRGB
	     * @since 3.0.0
	     *
	     * @param {InputColorObject} color - An object containing `r`, `g`, `b` and optionally `a` values in the range 0 to 255.
	     *
	     * @return {Phaser.Display.Color} This Color object.
	     */
	    setFromRGB: function (color)
	    {
	        this.red = color.r;
	        this.green = color.g;
	        this.blue = color.b;
	
	        if (color.hasOwnProperty('a'))
	        {
	            this.alpha = color.a;
	        }
	
	        return this.update();
	    },
	
	    /**
	     * Updates the internal cache values.
	     *
	     * @method Phaser.Display.Color#update
	     * @since 3.0.0
	     *
	     * @return {Phaser.Display.Color} This Color object.
	     */
	    update: function ()
	    {
	        this._color = GetColor(this.r, this.g, this.b);
	        this._color32 = GetColor32(this.r, this.g, this.b, this.a);
	        this._rgba = 'rgba(' + this.r + ',' + this.g + ',' + this.b + ',' + (this.a / 255) + ')';
	
	        return this;
	    },
	
	    /**
	     * Returns a new Color component using the values from this one.
	     *
	     * @method Phaser.Display.Color#clone
	     * @since 3.0.0
	     *
	     * @return {Phaser.Display.Color} A new Color object.
	     */
	    clone: function ()
	    {
	        return new Color(this.r, this.g, this.b, this.a);
	    },
	
	    /**
	     * The color of this Color component, not including the alpha channel.
	     *
	     * @name Phaser.Display.Color#color
	     * @type {number}
	     * @readOnly
	     * @since 3.0.0
	     */
	    color: {
	
	        get: function ()
	        {
	            return this._color;
	        }
	
	    },
	
	    /**
	     * The color of this Color component, including the alpha channel.
	     *
	     * @name Phaser.Display.Color#color32
	     * @type {number}
	     * @readOnly
	     * @since 3.0.0
	     */
	    color32: {
	
	        get: function ()
	        {
	            return this._color32;
	        }
	
	    },
	
	    /**
	     * The color of this Color component as a string which can be used in CSS color values.
	     *
	     * @name Phaser.Display.Color#rgba
	     * @type {string}
	     * @readOnly
	     * @since 3.0.0
	     */
	    rgba: {
	
	        get: function ()
	        {
	            return this._rgba;
	        }
	
	    },
	
	    /**
	     * The red color value, normalized to the range 0 to 1.
	     *
	     * @name Phaser.Display.Color#redGL
	     * @type {float}
	     * @since 3.0.0
	     */
	    redGL: {
	
	        get: function ()
	        {
	            return this.gl[0];
	        },
	
	        set: function (value)
	        {
	            this.gl[0] = Math.min(Math.abs(value), 1);
	
	            this.r = Math.floor(this.gl[0] * 255);
	
	            this.update();
	        }
	
	    },
	
	    /**
	     * The green color value, normalized to the range 0 to 1.
	     *
	     * @name Phaser.Display.Color#greenGL
	     * @type {float}
	     * @since 3.0.0
	     */
	    greenGL: {
	
	        get: function ()
	        {
	            return this.gl[1];
	        },
	
	        set: function (value)
	        {
	            this.gl[1] = Math.min(Math.abs(value), 1);
	
	            this.g = Math.floor(this.gl[1] * 255);
	
	            this.update();
	        }
	
	    },
	
	    /**
	     * The blue color value, normalized to the range 0 to 1.
	     *
	     * @name Phaser.Display.Color#blueGL
	     * @type {float}
	     * @since 3.0.0
	     */
	    blueGL: {
	
	        get: function ()
	        {
	            return this.gl[2];
	        },
	
	        set: function (value)
	        {
	            this.gl[2] = Math.min(Math.abs(value), 1);
	
	            this.b = Math.floor(this.gl[2] * 255);
	
	            this.update();
	        }
	
	    },
	
	    /**
	     * The alpha color value, normalized to the range 0 to 1.
	     *
	     * @name Phaser.Display.Color#alphaGL
	     * @type {float}
	     * @since 3.0.0
	     */
	    alphaGL: {
	
	        get: function ()
	        {
	            return this.gl[3];
	        },
	
	        set: function (value)
	        {
	            this.gl[3] = Math.min(Math.abs(value), 1);
	
	            this.a = Math.floor(this.gl[3] * 255);
	
	            this.update();
	        }
	
	    },
	
	    /**
	     * The red color value, normalized to the range 0 to 255.
	     *
	     * @name Phaser.Display.Color#red
	     * @type {number}
	     * @since 3.0.0
	     */
	    red: {
	
	        get: function ()
	        {
	            return this.r;
	        },
	
	        set: function (value)
	        {
	            value = Math.floor(Math.abs(value));
	
	            this.r = Math.min(value, 255);
	
	            this.gl[0] = value / 255;
	
	            this.update();
	        }
	
	    },
	
	    /**
	     * The green color value, normalized to the range 0 to 255.
	     *
	     * @name Phaser.Display.Color#green
	     * @type {number}
	     * @since 3.0.0
	     */
	    green: {
	
	        get: function ()
	        {
	            return this.g;
	        },
	
	        set: function (value)
	        {
	            value = Math.floor(Math.abs(value));
	
	            this.g = Math.min(value, 255);
	
	            this.gl[1] = value / 255;
	
	            this.update();
	        }
	
	    },
	
	    /**
	     * The blue color value, normalized to the range 0 to 255.
	     *
	     * @name Phaser.Display.Color#blue
	     * @type {number}
	     * @since 3.0.0
	     */
	    blue: {
	
	        get: function ()
	        {
	            return this.b;
	        },
	
	        set: function (value)
	        {
	            value = Math.floor(Math.abs(value));
	
	            this.b = Math.min(value, 255);
	
	            this.gl[2] = value / 255;
	
	            this.update();
	        }
	
	    },
	
	    /**
	     * The alpha color value, normalized to the range 0 to 255.
	     *
	     * @name Phaser.Display.Color#alpha
	     * @type {number}
	     * @since 3.0.0
	     */
	    alpha: {
	
	        get: function ()
	        {
	            return this.a;
	        },
	
	        set: function (value)
	        {
	            value = Math.floor(Math.abs(value));
	
	            this.a = Math.min(value, 255);
	
	            this.gl[3] = value / 255;
	
	            this.update();
	        }
	
	    }
	
	});
	
	module.exports = Color;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(35);
	var File = __webpack_require__(44);
	var FileTypesManager = __webpack_require__(15);
	var GetFastValue = __webpack_require__(3);
	var GetValue = __webpack_require__(10);
	var IsPlainObject = __webpack_require__(17);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.JSONFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within both the Loader and the JSON Cache.
	 * @property {string|any} [url] - The absolute or relative URL to load the file from. Or can be a ready formed JSON object, in which case it will be directly added to the Cache.
	 * @property {string} [extension='json'] - The default file extension to use if no url is provided.
	 * @property {string} [dataKey] - If specified instead of the whole JSON file being parsed and added to the Cache, only the section corresponding to this property key will be added. If the property you want to extract is nested, use periods to divide it.
	 * @property {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	
	/**
	 * @classdesc
	 * A single JSON File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#json method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#json.
	 *
	 * @class JSONFile
	 * @extends Phaser.Loader.File
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.JSONFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
	 * @param {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 * @param {string} [dataKey] - When the JSON file loads only this property will be stored in the Cache.
	 */
	var JSONFile = new Class({
	
	    Extends: File,
	
	    initialize:
	
	    //  url can either be a string, in which case it is treated like a proper url, or an object, in which case it is treated as a ready-made JS Object
	    //  dataKey allows you to pluck a specific object out of the JSON and put just that into the cache, rather than the whole thing
	
	    function JSONFile (loader, key, url, xhrSettings, dataKey)
	    {
	        var extension = 'json';
	
	        if (IsPlainObject(key))
	        {
	            var config = key;
	
	            key = GetFastValue(config, 'key');
	            url = GetFastValue(config, 'url');
	            xhrSettings = GetFastValue(config, 'xhrSettings');
	            extension = GetFastValue(config, 'extension', extension);
	            dataKey = GetFastValue(config, 'dataKey', dataKey);
	        }
	
	        var fileConfig = {
	            type: 'json',
	            cache: loader.cacheManager.json,
	            extension: extension,
	            responseType: 'text',
	            key: key,
	            url: url,
	            xhrSettings: xhrSettings,
	            config: dataKey
	        };
	
	        File.call(this, loader, fileConfig);
	
	        if (IsPlainObject(url))
	        {
	            //  Object provided instead of a URL, so no need to actually load it (populate data with value)
	            if (dataKey)
	            {
	                this.data = GetValue(url, dataKey);
	            }
	            else
	            {
	                this.data = url;
	            }
	
	            this.state = CONST.FILE_POPULATED;
	        }
	    },
	
	    /**
	     * Called automatically by Loader.nextFile.
	     * This method controls what extra work this File does with its loaded data.
	     *
	     * @method Phaser.Loader.FileTypes.JSONFile#onProcess
	     * @since 3.7.0
	     */
	    onProcess: function ()
	    {
	        if (this.state !== CONST.FILE_POPULATED)
	        {
	            this.state = CONST.FILE_PROCESSING;
	
	            var json = JSON.parse(this.xhrLoader.responseText);
	
	            var key = this.config;
	
	            if (typeof key === 'string')
	            {
	                this.data = GetValue(json, key, json);
	            }
	            else
	            {
	                this.data = json;
	            }
	        }
	
	        this.onProcessComplete();
	    }
	
	});
	
	/**
	 * Adds a JSON file, or array of JSON files, to the current load queue.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.json('wavedata', 'files/AlienWaveData.json');
	 * }
	 * ```
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 * 
	 * The key must be a unique String. It is used to add the file to the global JSON Cache upon a successful load.
	 * The key should be unique both in terms of files being loaded and files already present in the JSON Cache.
	 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
	 * then remove it from the JSON Cache first, before loading a new one.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.json({
	 *     key: 'wavedata',
	 *     url: 'files/AlienWaveData.json'
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.JSONFileConfig` for more details.
	 *
	 * Once the file has finished loading you can access it from its Cache using its key:
	 * 
	 * ```javascript
	 * this.load.json('wavedata', 'files/AlienWaveData.json');
	 * // and later in your game ...
	 * var data = this.cache.json.get('wavedata');
	 * ```
	 *
	 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
	 * key. For example, if the prefix was `LEVEL1.` and the key was `Waves` the final key will be `LEVEL1.Waves` and
	 * this is what you would use to retrieve the text from the JSON Cache.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "data"
	 * and no URL is given then the Loader will set the URL to be "data.json". It will always add `.json` as the extension, although
	 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
	 *
	 * You can also optionally provide a `dataKey` to use. This allows you to extract only a part of the JSON and store it in the Cache,
	 * rather than the whole file. For example, if your JSON data had a structure like this:
	 * 
	 * ```json
	 * {
	 *     "level1": {
	 *         "baddies": {
	 *             "aliens": {},
	 *             "boss": {}
	 *         }
	 *     },
	 *     "level2": {},
	 *     "level3": {}
	 * }
	 * ```
	 *
	 * And you only wanted to store the `boss` data in the Cache, then you could pass `level1.baddies.boss`as the `dataKey`.
	 *
	 * Note: The ability to load this type of file will only be available if the JSON File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#json
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.0.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.JSONFileConfig|Phaser.Loader.FileTypes.JSONFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
	 * @param {string} [dataKey] - When the JSON file loads only this property will be stored in the Cache.
	 * @param {XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('json', function (key, url, dataKey, xhrSettings)
	{
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
	            this.addFile(new JSONFile(this, key[i]));
	        }
	    }
	    else
	    {
	        this.addFile(new JSONFile(this, key, url, xhrSettings, dataKey));
	    }
	
	    return this;
	});
	
	module.exports = JSONFile;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CONST = __webpack_require__(33);
	
	/**
	 * Convert the given angle from degrees, to the equivalent angle in radians.
	 *
	 * @function Phaser.Math.DegToRad
	 * @since 3.0.0
	 *
	 * @param {integer} degrees - The angle (in degrees) to convert to radians.
	 *
	 * @return {float} The given angle converted to radians.
	 */
	var DegToRad = function (degrees)
	{
	    return degrees * CONST.DEG_TO_RAD;
	};
	
	module.exports = DegToRad;


/***/ }),
/* 98 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Wrap
	 * @since 3.0.0
	 *
	 * @param {number} value - [description]
	 * @param {number} min - [description]
	 * @param {number} max - [description]
	 *
	 * @return {number} [description]
	 */
	var Wrap = function (value, min, max)
	{
	    var range = max - min;
	
	    return (min + ((((value - min) % range) + range) % range));
	};
	
	module.exports = Wrap;


/***/ }),
/* 99 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Converts from world X coordinates (pixels) to tile X coordinates (tile units), factoring in the
	 * layer's position, scale and scroll.
	 *
	 * @function Phaser.Tilemaps.Components.WorldToTileX
	 * @private
	 * @since 3.0.0
	 *
	 * @param {number} worldX - [description]
	 * @param {boolean} [snapToFloor=true] - Whether or not to round the tile coordinate down to the
	 * nearest integer.
	 * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 * 
	 * @return {number} The X location in tile units.
	 */
	var WorldToTileX = function (worldX, snapToFloor, camera, layer)
	{
	    if (snapToFloor === undefined) { snapToFloor = true; }
	
	    var tileWidth = layer.baseTileWidth;
	    var tilemapLayer = layer.tilemapLayer;
	
	    if (tilemapLayer)
	    {
	        if (camera === undefined) { camera = tilemapLayer.scene.cameras.main; }
	
	        // Find the world position relative to the static or dynamic layer's top left origin,
	        // factoring in the camera's horizontal scroll
	        worldX = worldX - (tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX));
	
	        tileWidth *= tilemapLayer.scaleX;
	    }
	
	    return snapToFloor
	        ? Math.floor(worldX / tileWidth)
	        : worldX / tileWidth;
	};
	
	module.exports = WorldToTileX;


/***/ }),
/* 100 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Converts from world Y coordinates (pixels) to tile Y coordinates (tile units), factoring in the
	 * layer's position, scale and scroll.
	 *
	 * @function Phaser.Tilemaps.Components.WorldToTileY
	 * @private
	 * @since 3.0.0
	 *
	 * @param {number} worldY - [description]
	 * @param {boolean} [snapToFloor=true] - Whether or not to round the tile coordinate down to the
	 * nearest integer.
	 * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 * 
	 * @return {number} The Y location in tile units.
	 */
	var WorldToTileY = function (worldY, snapToFloor, camera, layer)
	{
	    if (snapToFloor === undefined) { snapToFloor = true; }
	
	    var tileHeight = layer.baseTileHeight;
	    var tilemapLayer = layer.tilemapLayer;
	
	    if (tilemapLayer)
	    {
	        if (camera === undefined) { camera = tilemapLayer.scene.cameras.main; }
	
	        // Find the world position relative to the static or dynamic layer's top left origin,
	        // factoring in the camera's vertical scroll
	        worldY = worldY - (tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY));
	
	        tileHeight *= tilemapLayer.scaleY;
	    }
	
	    return snapToFloor
	        ? Math.floor(worldY / tileHeight)
	        : worldY / tileHeight;
	};
	
	module.exports = WorldToTileY;


/***/ }),
/* 101 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(60);
	var call = __webpack_require__(389);
	var isArrayIter = __webpack_require__(231);
	var anObject = __webpack_require__(7);
	var toLength = __webpack_require__(21);
	var getIterFn = __webpack_require__(247);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(7);
	var dPs = __webpack_require__(395);
	var enumBugKeys = __webpack_require__(227);
	var IE_PROTO = __webpack_require__(239)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(226)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(229).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(397);
	var hiddenKeys = __webpack_require__(227).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(397);
	var enumBugKeys = __webpack_require__(227);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 106 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(46);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(8);
	var dP = __webpack_require__(20);
	var DESCRIPTORS = __webpack_require__(19);
	var SPECIES = __webpack_require__(16)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(67);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 110 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(129),
		__webpack_require__(27)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, toType, isFunction ) {
	
	"use strict";
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	return access;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	"use strict";
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	
	return nodeName;
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		// All support tests are defined in their respective modules.
		return {};
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * A MultiFile is a special kind of parent that contains two, or more, Files as children and looks after
	 * the loading and processing of them all. It is commonly extended and used as a base class for file types such as AtlasJSON or BitmapFont.
	 * 
	 * You shouldn't create an instance of a MultiFile directly, but should extend it with your own class, setting a custom type and processing methods.
	 *
	 * @class MultiFile
	 * @memberOf Phaser.Loader
	 * @constructor
	 * @since 3.7.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - The Loader that is going to load this File.
	 * @param {string} type - The file type string for sorting within the Loader.
	 * @param {string} key - The key of the file within the loader.
	 * @param {Phaser.Loader.File[]} files - An array of Files that make-up this MultiFile.
	 */
	var MultiFile = new Class({
	
	    initialize:
	
	    function MultiFile (loader, type, key, files)
	    {
	        /**
	         * A reference to the Loader that is going to load this file.
	         *
	         * @name Phaser.Loader.MultiFile#loader
	         * @type {Phaser.Loader.LoaderPlugin}
	         * @since 3.7.0
	         */
	        this.loader = loader;
	
	        /**
	         * The file type string for sorting within the Loader.
	         *
	         * @name Phaser.Loader.MultiFile#type
	         * @type {string}
	         * @since 3.7.0
	         */
	        this.type = type;
	
	        /**
	         * Unique cache key (unique within its file type)
	         *
	         * @name Phaser.Loader.MultiFile#key
	         * @type {string}
	         * @since 3.7.0
	         */
	        this.key = key;
	
	        /**
	         * Array of files that make up this MultiFile.
	         *
	         * @name Phaser.Loader.MultiFile#files
	         * @type {Phaser.Loader.File[]}
	         * @since 3.7.0
	         */
	        this.files = files;
	
	        /**
	         * The completion status of this MultiFile.
	         *
	         * @name Phaser.Loader.MultiFile#complete
	         * @type {boolean}
	         * @default false
	         * @since 3.7.0
	         */
	        this.complete = false;
	
	        /**
	         * The number of files to load.
	         *
	         * @name Phaser.Loader.MultiFile#pending
	         * @type {integer}
	         * @since 3.7.0
	         */
	
	        this.pending = files.length;
	
	        /**
	         * The number of files that failed to load.
	         *
	         * @name Phaser.Loader.MultiFile#failed
	         * @type {integer}
	         * @default 0
	         * @since 3.7.0
	         */
	        this.failed = 0;
	
	        /**
	         * A storage container for transient data that the loading files need.
	         *
	         * @name Phaser.Loader.MultiFile#config
	         * @type {any}
	         * @since 3.7.0
	         */
	        this.config = {};
	
	        //  Link the files
	        for (var i = 0; i < files.length; i++)
	        {
	            files[i].multiFile = this;
	        }
	    },
	
	    /**
	     * Checks if this MultiFile is ready to process its children or not.
	     *
	     * @method Phaser.Loader.MultiFile#isReadyToProcess
	     * @since 3.7.0
	     *
	     * @return {boolean} `true` if all children of this MultiFile have loaded, otherwise `false`.
	     */
	    isReadyToProcess: function ()
	    {
	        return (this.pending === 0 && this.failed === 0 && !this.complete);
	    },
	
	    /**
	     * Adds another child to this MultiFile, increases the pending count and resets the completion status.
	     *
	     * @method Phaser.Loader.MultiFile#addToMultiFile
	     * @since 3.7.0
	     *
	     * @param {Phaser.Loader.File} files - The File to add to this MultiFile.
	     *
	     * @return {Phaser.Loader.MultiFile} This MultiFile instance.
	     */
	    addToMultiFile: function (file)
	    {
	        this.files.push(file);
	
	        file.multiFile = this;
	
	        this.pending++;
	
	        this.complete = false;
	
	        return this;
	    },
	
	    /**
	     * Called by each File when it finishes loading.
	     *
	     * @method Phaser.Loader.MultiFile#onFileComplete
	     * @since 3.7.0
	     *
	     * @param {Phaser.Loader.File} file - The File that has completed processing.
	     */
	    onFileComplete: function (file)
	    {
	        var index = this.files.indexOf(file);
	
	        if (index !== -1)
	        {
	            this.pending--;
	        }
	    },
	
	    /**
	     * Called by each File that fails to load.
	     *
	     * @method Phaser.Loader.MultiFile#onFileFailed
	     * @since 3.7.0
	     *
	     * @param {Phaser.Loader.File} file - The File that has failed to load.
	     */
	    onFileFailed: function (file)
	    {
	        var index = this.files.indexOf(file);
	
	        if (index !== -1)
	        {
	            this.failed++;
	        }
	    }
	
	});
	
	module.exports = MultiFile;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(35);
	var File = __webpack_require__(44);
	var FileTypesManager = __webpack_require__(15);
	var GetFastValue = __webpack_require__(3);
	var IsPlainObject = __webpack_require__(17);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.ImageFrameConfig
	 *
	 * @property {integer} frameWidth - The width of the frame in pixels.
	 * @property {integer} [frameHeight] - The height of the frame in pixels. Uses the `frameWidth` value if not provided.
	 * @property {integer} [startFrame=0] - The first frame to start parsing from.
	 * @property {integer} [endFrame] - The frame to stop parsing at. If not provided it will calculate the value based on the image and frame dimensions.
	 * @property {integer} [margin=0] - The margin in the image. This is the space around the edge of the frames.
	 * @property {integer} [spacing=0] - The spacing between each frame in the image.
	 */
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.ImageFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within both the Loader and the Texture Manager.
	 * @property {string} [url] - The absolute or relative URL to load the file from.
	 * @property {string} [extension='png'] - The default file extension to use if no url is provided.
	 * @property {string} [normalMap] - The filename of an associated normal map. It uses the same path and url to load as the image.
	 * @property {Phaser.Loader.FileTypes.ImageFrameConfig} [frameConfig] - The frame configuration object. Only provided for, and used by, Sprite Sheets.
	 * @property {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	
	/**
	 * @classdesc
	 * A single Image File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#image method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#image.
	 *
	 * @class ImageFile
	 * @extends Phaser.Loader.File
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.ImageFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string|string[]} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
	 * @param {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 * @param {Phaser.Loader.FileTypes.ImageFrameConfig} [frameConfig] - The frame configuration object. Only provided for, and used by, Sprite Sheets.
	 */
	var ImageFile = new Class({
	
	    Extends: File,
	
	    initialize:
	
	    function ImageFile (loader, key, url, xhrSettings, frameConfig)
	    {
	        var extension = 'png';
	        var normalMapURL;
	
	        if (IsPlainObject(key))
	        {
	            var config = key;
	
	            key = GetFastValue(config, 'key');
	            url = GetFastValue(config, 'url');
	            normalMapURL = GetFastValue(config, 'normalMap');
	            xhrSettings = GetFastValue(config, 'xhrSettings');
	            extension = GetFastValue(config, 'extension', extension);
	            frameConfig = GetFastValue(config, 'frameConfig');
	        }
	
	        if (Array.isArray(url))
	        {
	            normalMapURL = url[1];
	            url = url[0];
	        }
	
	        var fileConfig = {
	            type: 'image',
	            cache: loader.textureManager,
	            extension: extension,
	            responseType: 'blob',
	            key: key,
	            url: url,
	            xhrSettings: xhrSettings,
	            config: frameConfig
	        };
	
	        File.call(this, loader, fileConfig);
	
	        //  Do we have a normal map to load as well?
	        if (normalMapURL)
	        {
	            var normalMap = new ImageFile(loader, this.key, normalMapURL, xhrSettings, frameConfig);
	
	            normalMap.type = 'normalMap';
	
	            this.setLink(normalMap);
	
	            loader.addFile(normalMap);
	        }
	    },
	
	    /**
	     * Called automatically by Loader.nextFile.
	     * This method controls what extra work this File does with its loaded data.
	     *
	     * @method Phaser.Loader.FileTypes.ImageFile#onProcess
	     * @since 3.7.0
	     */
	    onProcess: function ()
	    {
	        this.state = CONST.FILE_PROCESSING;
	
	        this.data = new Image();
	
	        this.data.crossOrigin = this.crossOrigin;
	
	        var _this = this;
	
	        this.data.onload = function ()
	        {
	            File.revokeObjectURL(_this.data);
	
	            _this.onProcessComplete();
	        };
	
	        this.data.onerror = function ()
	        {
	            File.revokeObjectURL(_this.data);
	
	            _this.onProcessError();
	        };
	
	        File.createObjectURL(this.data, this.xhrLoader.response, 'image/png');
	    },
	
	    /**
	     * Adds this file to its target cache upon successful loading and processing.
	     *
	     * @method Phaser.Loader.FileTypes.ImageFile#addToCache
	     * @since 3.7.0
	     */
	    addToCache: function ()
	    {
	        var texture;
	        var linkFile = this.linkFile;
	
	        if (linkFile && linkFile.state === CONST.FILE_COMPLETE)
	        {
	            if (this.type === 'image')
	            {
	                texture = this.cache.addImage(this.key, this.data, linkFile.data);
	            }
	            else
	            {
	                texture = this.cache.addImage(linkFile.key, linkFile.data, this.data);
	            }
	
	            this.pendingDestroy(texture);
	
	            linkFile.pendingDestroy(texture);
	        }
	        else if (!linkFile)
	        {
	            texture = this.cache.addImage(this.key, this.data);
	
	            this.pendingDestroy(texture);
	        }
	    }
	
	});
	
	/**
	 * Adds an Image, or array of Images, to the current load queue.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.image('logo', 'images/phaserLogo.png');
	 * }
	 * ```
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 * 
	 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
	 * If you try to load an animated gif only the first frame will be rendered. Browsers do not natively support playback
	 * of animated gifs to Canvas elements.
	 *
	 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
	 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
	 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
	 * then remove it from the Texture Manager first, before loading a new one.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.image({
	 *     key: 'logo',
	 *     url: 'images/AtariLogo.png'
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.ImageFileConfig` for more details.
	 *
	 * Once the file has finished loading you can use it as a texture for a Game Object by referencing its key:
	 * 
	 * ```javascript
	 * this.load.image('logo', 'images/AtariLogo.png');
	 * // and later in your game ...
	 * this.add.image(x, y, 'logo');
	 * ```
	 *
	 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
	 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
	 * this is what you would use to retrieve the image from the Texture Manager.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
	 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
	 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
	 *
	 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
	 * then you can specify it by providing an array as the `url` where the second element is the normal map:
	 * 
	 * ```javascript
	 * this.load.image('logo', [ 'images/AtariLogo.png', 'images/AtariLogo-n.png' ]);
	 * ```
	 *
	 * Or, if you are using a config object use the `normalMap` property:
	 * 
	 * ```javascript
	 * this.load.image({
	 *     key: 'logo',
	 *     url: 'images/AtariLogo.png',
	 *     normalMap: 'images/AtariLogo-n.png'
	 * });
	 * ```
	 *
	 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
	 * Normal maps are a WebGL only feature.
	 *
	 * Note: The ability to load this type of file will only be available if the Image File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#image
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.0.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.ImageFileConfig|Phaser.Loader.FileTypes.ImageFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {string|string[]} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
	 * @param {XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('image', function (key, url, xhrSettings)
	{
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
	            this.addFile(new ImageFile(this, key[i]));
	        }
	    }
	    else
	    {
	        this.addFile(new ImageFile(this, key, url, xhrSettings));
	    }
	
	    return this;
	});
	
	module.exports = ImageFile;


/***/ }),
/* 116 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Distance.Between
	 * @since 3.0.0
	 *
	 * @param {number} x1 - [description]
	 * @param {number} y1 - [description]
	 * @param {number} x2 - [description]
	 * @param {number} y2 - [description]
	 *
	 * @return {number} [description]
	 */
	var DistanceBetween = function (x1, y1, x2, y2)
	{
	    var dx = x1 - x2;
	    var dy = y1 - y2;
	
	    return Math.sqrt(dx * dx + dy * dy);
	};
	
	module.exports = DistanceBetween;


/***/ }),
/* 117 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Arcade Physics consts.
	 * 
	 * @ignore
	 */
	
	var CONST = {
	
	    /**
	     * [description]
	     * 
	     * @name Phaser.Physics.Arcade.DYNAMIC_BODY
	     * @readOnly
	     * @type {number}
	     * @since 3.0.0
	     */
	    DYNAMIC_BODY: 0,
	
	    /**
	     * [description]
	     * 
	     * @name Phaser.Physics.Arcade.STATIC_BODY
	     * @readOnly
	     * @type {number}
	     * @since 3.0.0
	     */
	    STATIC_BODY: 1,
	
	    /**
	     * [description]
	     * 
	     * @name Phaser.Physics.Arcade.GROUP
	     * @readOnly
	     * @type {number}
	     * @since 3.0.0
	     */
	    GROUP: 2,
	
	    /**
	     * [description]
	     * 
	     * @name Phaser.Physics.Arcade.TILEMAPLAYER
	     * @readOnly
	     * @type {number}
	     * @since 3.0.0
	     */
	    TILEMAPLAYER: 3,
	
	    /**
	     * [description]
	     * 
	     * @name Phaser.Physics.Arcade.FACING_NONE
	     * @readOnly
	     * @type {number}
	     * @since 3.0.0
	     */
	    FACING_NONE: 10,
	
	    /**
	     * [description]
	     * 
	     * @name Phaser.Physics.Arcade.FACING_UP
	     * @readOnly
	     * @type {number}
	     * @since 3.0.0
	     */
	    FACING_UP: 11,
	
	    /**
	     * [description]
	     * 
	     * @name Phaser.Physics.Arcade.FACING_DOWN
	     * @readOnly
	     * @type {number}
	     * @since 3.0.0
	     */
	    FACING_DOWN: 12,
	
	    /**
	     * [description]
	     * 
	     * @name Phaser.Physics.Arcade.FACING_LEFT
	     * @readOnly
	     * @type {number}
	     * @since 3.0.0
	     */
	    FACING_LEFT: 13,
	
	    /**
	     * [description]
	     * 
	     * @name Phaser.Physics.Arcade.FACING_RIGHT
	     * @readOnly
	     * @type {number}
	     * @since 3.0.0
	     */
	    FACING_RIGHT: 14
	
	};
	
	module.exports = CONST;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* The `Matter.Composite` module contains methods for creating and manipulating composite bodies.
	* A composite body is a collection of `Matter.Body`, `Matter.Constraint` and other `Matter.Composite`, therefore composites form a tree structure.
	* It is important to use the functions in this module to modify composites, rather than directly modifying their properties.
	* Note that the `Matter.World` object is also a type of `Matter.Composite` and as such all composite methods here can also operate on a `Matter.World`.
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class Composite
	*/
	
	var Composite = {};
	
	module.exports = Composite;
	
	var Events = __webpack_require__(144);
	var Common = __webpack_require__(31);
	var Body = __webpack_require__(51);
	
	(function() {
	
	    /**
	     * Creates a new composite. The options parameter is an object that specifies any properties you wish to override the defaults.
	     * See the properites section below for detailed information on what you can pass via the `options` object.
	     * @method create
	     * @param {} [options]
	     * @return {composite} A new composite
	     */
	    Composite.create = function(options) {
	        return Common.extend({ 
	            id: Common.nextId(),
	            type: 'composite',
	            parent: null,
	            isModified: false,
	            bodies: [], 
	            constraints: [], 
	            composites: [],
	            label: 'Composite',
	            plugin: {}
	        }, options);
	    };
	
	    /**
	     * Sets the composite's `isModified` flag. 
	     * If `updateParents` is true, all parents will be set (default: false).
	     * If `updateChildren` is true, all children will be set (default: false).
	     * @method setModified
	     * @param {composite} composite
	     * @param {boolean} isModified
	     * @param {boolean} [updateParents=false]
	     * @param {boolean} [updateChildren=false]
	     */
	    Composite.setModified = function(composite, isModified, updateParents, updateChildren) {
	        composite.isModified = isModified;
	
	        if (updateParents && composite.parent) {
	            Composite.setModified(composite.parent, isModified, updateParents, updateChildren);
	        }
	
	        if (updateChildren) {
	            for(var i = 0; i < composite.composites.length; i++) {
	                var childComposite = composite.composites[i];
	                Composite.setModified(childComposite, isModified, updateParents, updateChildren);
	            }
	        }
	    };
	
	    /**
	     * Generic add function. Adds one or many body(s), constraint(s) or a composite(s) to the given composite.
	     * Triggers `beforeAdd` and `afterAdd` events on the `composite`.
	     * @method add
	     * @param {composite} composite
	     * @param {} object
	     * @return {composite} The original composite with the objects added
	     */
	    Composite.add = function(composite, object) {
	        var objects = [].concat(object);
	
	        Events.trigger(composite, 'beforeAdd', { object: object });
	
	        for (var i = 0; i < objects.length; i++) {
	            var obj = objects[i];
	
	            switch (obj.type) {
	
	            case 'body':
	                // skip adding compound parts
	                if (obj.parent !== obj) {
	                    Common.warn('Composite.add: skipped adding a compound body part (you must add its parent instead)');
	                    break;
	                }
	
	                Composite.addBody(composite, obj);
	                break;
	            case 'constraint':
	                Composite.addConstraint(composite, obj);
	                break;
	            case 'composite':
	                Composite.addComposite(composite, obj);
	                break;
	            case 'mouseConstraint':
	                Composite.addConstraint(composite, obj.constraint);
	                break;
	
	            }
	        }
	
	        Events.trigger(composite, 'afterAdd', { object: object });
	
	        return composite;
	    };
	
	    /**
	     * Generic remove function. Removes one or many body(s), constraint(s) or a composite(s) to the given composite.
	     * Optionally searching its children recursively.
	     * Triggers `beforeRemove` and `afterRemove` events on the `composite`.
	     * @method remove
	     * @param {composite} composite
	     * @param {} object
	     * @param {boolean} [deep=false]
	     * @return {composite} The original composite with the objects removed
	     */
	    Composite.remove = function(composite, object, deep) {
	        var objects = [].concat(object);
	
	        Events.trigger(composite, 'beforeRemove', { object: object });
	
	        for (var i = 0; i < objects.length; i++) {
	            var obj = objects[i];
	
	            switch (obj.type) {
	
	            case 'body':
	                Composite.removeBody(composite, obj, deep);
	                break;
	            case 'constraint':
	                Composite.removeConstraint(composite, obj, deep);
	                break;
	            case 'composite':
	                Composite.removeComposite(composite, obj, deep);
	                break;
	            case 'mouseConstraint':
	                Composite.removeConstraint(composite, obj.constraint);
	                break;
	
	            }
	        }
	
	        Events.trigger(composite, 'afterRemove', { object: object });
	
	        return composite;
	    };
	
	    /**
	     * Adds a composite to the given composite.
	     * @private
	     * @method addComposite
	     * @param {composite} compositeA
	     * @param {composite} compositeB
	     * @return {composite} The original compositeA with the objects from compositeB added
	     */
	    Composite.addComposite = function(compositeA, compositeB) {
	        compositeA.composites.push(compositeB);
	        compositeB.parent = compositeA;
	        Composite.setModified(compositeA, true, true, false);
	        return compositeA;
	    };
	
	    /**
	     * Removes a composite from the given composite, and optionally searching its children recursively.
	     * @private
	     * @method removeComposite
	     * @param {composite} compositeA
	     * @param {composite} compositeB
	     * @param {boolean} [deep=false]
	     * @return {composite} The original compositeA with the composite removed
	     */
	    Composite.removeComposite = function(compositeA, compositeB, deep) {
	        var position = compositeA.composites.indexOf(compositeB);
	        if (position !== -1) {
	            Composite.removeCompositeAt(compositeA, position);
	            Composite.setModified(compositeA, true, true, false);
	        }
	
	        if (deep) {
	            for (var i = 0; i < compositeA.composites.length; i++){
	                Composite.removeComposite(compositeA.composites[i], compositeB, true);
	            }
	        }
	
	        return compositeA;
	    };
	
	    /**
	     * Removes a composite from the given composite.
	     * @private
	     * @method removeCompositeAt
	     * @param {composite} composite
	     * @param {number} position
	     * @return {composite} The original composite with the composite removed
	     */
	    Composite.removeCompositeAt = function(composite, position) {
	        composite.composites.splice(position, 1);
	        Composite.setModified(composite, true, true, false);
	        return composite;
	    };
	
	    /**
	     * Adds a body to the given composite.
	     * @private
	     * @method addBody
	     * @param {composite} composite
	     * @param {body} body
	     * @return {composite} The original composite with the body added
	     */
	    Composite.addBody = function(composite, body) {
	        composite.bodies.push(body);
	        Composite.setModified(composite, true, true, false);
	        return composite;
	    };
	
	    /**
	     * Removes a body from the given composite, and optionally searching its children recursively.
	     * @private
	     * @method removeBody
	     * @param {composite} composite
	     * @param {body} body
	     * @param {boolean} [deep=false]
	     * @return {composite} The original composite with the body removed
	     */
	    Composite.removeBody = function(composite, body, deep) {
	        var position = composite.bodies.indexOf(body);
	        if (position !== -1) {
	            Composite.removeBodyAt(composite, position);
	            Composite.setModified(composite, true, true, false);
	        }
	
	        if (deep) {
	            for (var i = 0; i < composite.composites.length; i++){
	                Composite.removeBody(composite.composites[i], body, true);
	            }
	        }
	
	        return composite;
	    };
	
	    /**
	     * Removes a body from the given composite.
	     * @private
	     * @method removeBodyAt
	     * @param {composite} composite
	     * @param {number} position
	     * @return {composite} The original composite with the body removed
	     */
	    Composite.removeBodyAt = function(composite, position) {
	        composite.bodies.splice(position, 1);
	        Composite.setModified(composite, true, true, false);
	        return composite;
	    };
	
	    /**
	     * Adds a constraint to the given composite.
	     * @private
	     * @method addConstraint
	     * @param {composite} composite
	     * @param {constraint} constraint
	     * @return {composite} The original composite with the constraint added
	     */
	    Composite.addConstraint = function(composite, constraint) {
	        composite.constraints.push(constraint);
	        Composite.setModified(composite, true, true, false);
	        return composite;
	    };
	
	    /**
	     * Removes a constraint from the given composite, and optionally searching its children recursively.
	     * @private
	     * @method removeConstraint
	     * @param {composite} composite
	     * @param {constraint} constraint
	     * @param {boolean} [deep=false]
	     * @return {composite} The original composite with the constraint removed
	     */
	    Composite.removeConstraint = function(composite, constraint, deep) {
	        var position = composite.constraints.indexOf(constraint);
	        if (position !== -1) {
	            Composite.removeConstraintAt(composite, position);
	        }
	
	        if (deep) {
	            for (var i = 0; i < composite.composites.length; i++){
	                Composite.removeConstraint(composite.composites[i], constraint, true);
	            }
	        }
	
	        return composite;
	    };
	
	    /**
	     * Removes a body from the given composite.
	     * @private
	     * @method removeConstraintAt
	     * @param {composite} composite
	     * @param {number} position
	     * @return {composite} The original composite with the constraint removed
	     */
	    Composite.removeConstraintAt = function(composite, position) {
	        composite.constraints.splice(position, 1);
	        Composite.setModified(composite, true, true, false);
	        return composite;
	    };
	
	    /**
	     * Removes all bodies, constraints and composites from the given composite.
	     * Optionally clearing its children recursively.
	     * @method clear
	     * @param {composite} composite
	     * @param {boolean} keepStatic
	     * @param {boolean} [deep=false]
	     */
	    Composite.clear = function(composite, keepStatic, deep) {
	        if (deep) {
	            for (var i = 0; i < composite.composites.length; i++){
	                Composite.clear(composite.composites[i], keepStatic, true);
	            }
	        }
	        
	        if (keepStatic) {
	            composite.bodies = composite.bodies.filter(function(body) { return body.isStatic; });
	        } else {
	            composite.bodies.length = 0;
	        }
	
	        composite.constraints.length = 0;
	        composite.composites.length = 0;
	        Composite.setModified(composite, true, true, false);
	
	        return composite;
	    };
	
	    /**
	     * Returns all bodies in the given composite, including all bodies in its children, recursively.
	     * @method allBodies
	     * @param {composite} composite
	     * @return {body[]} All the bodies
	     */
	    Composite.allBodies = function(composite) {
	        var bodies = [].concat(composite.bodies);
	
	        for (var i = 0; i < composite.composites.length; i++)
	            bodies = bodies.concat(Composite.allBodies(composite.composites[i]));
	
	        return bodies;
	    };
	
	    /**
	     * Returns all constraints in the given composite, including all constraints in its children, recursively.
	     * @method allConstraints
	     * @param {composite} composite
	     * @return {constraint[]} All the constraints
	     */
	    Composite.allConstraints = function(composite) {
	        var constraints = [].concat(composite.constraints);
	
	        for (var i = 0; i < composite.composites.length; i++)
	            constraints = constraints.concat(Composite.allConstraints(composite.composites[i]));
	
	        return constraints;
	    };
	
	    /**
	     * Returns all composites in the given composite, including all composites in its children, recursively.
	     * @method allComposites
	     * @param {composite} composite
	     * @return {composite[]} All the composites
	     */
	    Composite.allComposites = function(composite) {
	        var composites = [].concat(composite.composites);
	
	        for (var i = 0; i < composite.composites.length; i++)
	            composites = composites.concat(Composite.allComposites(composite.composites[i]));
	
	        return composites;
	    };
	
	    /**
	     * Searches the composite recursively for an object matching the type and id supplied, null if not found.
	     * @method get
	     * @param {composite} composite
	     * @param {number} id
	     * @param {string} type
	     * @return {object} The requested object, if found
	     */
	    Composite.get = function(composite, id, type) {
	        var objects,
	            object;
	
	        switch (type) {
	        case 'body':
	            objects = Composite.allBodies(composite);
	            break;
	        case 'constraint':
	            objects = Composite.allConstraints(composite);
	            break;
	        case 'composite':
	            objects = Composite.allComposites(composite).concat(composite);
	            break;
	        }
	
	        if (!objects)
	            return null;
	
	        object = objects.filter(function(object) { 
	            return object.id.toString() === id.toString(); 
	        });
	
	        return object.length === 0 ? null : object[0];
	    };
	
	    /**
	     * Moves the given object(s) from compositeA to compositeB (equal to a remove followed by an add).
	     * @method move
	     * @param {compositeA} compositeA
	     * @param {object[]} objects
	     * @param {compositeB} compositeB
	     * @return {composite} Returns compositeA
	     */
	    Composite.move = function(compositeA, objects, compositeB) {
	        Composite.remove(compositeA, objects);
	        Composite.add(compositeB, objects);
	        return compositeA;
	    };
	
	    /**
	     * Assigns new ids for all objects in the composite, recursively.
	     * @method rebase
	     * @param {composite} composite
	     * @return {composite} Returns composite
	     */
	    Composite.rebase = function(composite) {
	        var objects = Composite.allBodies(composite)
	                        .concat(Composite.allConstraints(composite))
	                        .concat(Composite.allComposites(composite));
	
	        for (var i = 0; i < objects.length; i++) {
	            objects[i].id = Common.nextId();
	        }
	
	        Composite.setModified(composite, true, true, false);
	
	        return composite;
	    };
	
	    /**
	     * Translates all children in the composite by a given vector relative to their current positions, 
	     * without imparting any velocity.
	     * @method translate
	     * @param {composite} composite
	     * @param {vector} translation
	     * @param {bool} [recursive=true]
	     */
	    Composite.translate = function(composite, translation, recursive) {
	        var bodies = recursive ? Composite.allBodies(composite) : composite.bodies;
	
	        for (var i = 0; i < bodies.length; i++) {
	            Body.translate(bodies[i], translation);
	        }
	
	        Composite.setModified(composite, true, true, false);
	
	        return composite;
	    };
	
	    /**
	     * Rotates all children in the composite by a given angle about the given point, without imparting any angular velocity.
	     * @method rotate
	     * @param {composite} composite
	     * @param {number} rotation
	     * @param {vector} point
	     * @param {bool} [recursive=true]
	     */
	    Composite.rotate = function(composite, rotation, point, recursive) {
	        var cos = Math.cos(rotation),
	            sin = Math.sin(rotation),
	            bodies = recursive ? Composite.allBodies(composite) : composite.bodies;
	
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i],
	                dx = body.position.x - point.x,
	                dy = body.position.y - point.y;
	                
	            Body.setPosition(body, {
	                x: point.x + (dx * cos - dy * sin),
	                y: point.y + (dx * sin + dy * cos)
	            });
	
	            Body.rotate(body, rotation);
	        }
	
	        Composite.setModified(composite, true, true, false);
	
	        return composite;
	    };
	
	    /**
	     * Scales all children in the composite, including updating physical properties (mass, area, axes, inertia), from a world-space point.
	     * @method scale
	     * @param {composite} composite
	     * @param {number} scaleX
	     * @param {number} scaleY
	     * @param {vector} point
	     * @param {bool} [recursive=true]
	     */
	    Composite.scale = function(composite, scaleX, scaleY, point, recursive) {
	        var bodies = recursive ? Composite.allBodies(composite) : composite.bodies;
	
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i],
	                dx = body.position.x - point.x,
	                dy = body.position.y - point.y;
	                
	            Body.setPosition(body, {
	                x: point.x + dx * scaleX,
	                y: point.y + dy * scaleY
	            });
	
	            Body.scale(body, scaleX, scaleY);
	        }
	
	        Composite.setModified(composite, true, true, false);
	
	        return composite;
	    };
	
	    /**
	     * Returns the union of the bounds of all of the composite's bodies.
	     * @method bounds
	     * @param {composite} composite The composite.
	     * @returns {bounds} The composite bounds.
	     */
	    Composite.bounds = function(composite) {
	        var bodies = Matter.Composite.allBodies(composite),
	            vertices = [];
	
	        for (var i = 0; i < bodies.length; i += 1) {
	            var body = bodies[i];
	            vertices.push(body.bounds.min, body.bounds.max);
	        }
	
	        return Matter.Bounds.create(vertices);
	    };
	
	    /*
	    *
	    *  Events Documentation
	    *
	    */
	
	    /**
	    * Fired when a call to `Composite.add` is made, before objects have been added.
	    *
	    * @event beforeAdd
	    * @param {} event An event object
	    * @param {} event.object The object(s) to be added (may be a single body, constraint, composite or a mixed array of these)
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired when a call to `Composite.add` is made, after objects have been added.
	    *
	    * @event afterAdd
	    * @param {} event An event object
	    * @param {} event.object The object(s) that have been added (may be a single body, constraint, composite or a mixed array of these)
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired when a call to `Composite.remove` is made, before objects have been removed.
	    *
	    * @event beforeRemove
	    * @param {} event An event object
	    * @param {} event.object The object(s) to be removed (may be a single body, constraint, composite or a mixed array of these)
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired when a call to `Composite.remove` is made, after objects have been removed.
	    *
	    * @event afterRemove
	    * @param {} event An event object
	    * @param {} event.object The object(s) that have been removed (may be a single body, constraint, composite or a mixed array of these)
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /*
	    *
	    *  Properties Documentation
	    *
	    */
	
	    /**
	     * An integer `Number` uniquely identifying number generated in `Composite.create` by `Common.nextId`.
	     *
	     * @property id
	     * @type number
	     */
	
	    /**
	     * A `String` denoting the type of object.
	     *
	     * @property type
	     * @type string
	     * @default "composite"
	     * @readOnly
	     */
	
	    /**
	     * An arbitrary `String` name to help the user identify and manage composites.
	     *
	     * @property label
	     * @type string
	     * @default "Composite"
	     */
	
	    /**
	     * A flag that specifies whether the composite has been modified during the current step.
	     * Most `Matter.Composite` methods will automatically set this flag to `true` to inform the engine of changes to be handled.
	     * If you need to change it manually, you should use the `Composite.setModified` method.
	     *
	     * @property isModified
	     * @type boolean
	     * @default false
	     */
	
	    /**
	     * The `Composite` that is the parent of this composite. It is automatically managed by the `Matter.Composite` methods.
	     *
	     * @property parent
	     * @type composite
	     * @default null
	     */
	
	    /**
	     * An array of `Body` that are _direct_ children of this composite.
	     * To add or remove bodies you should use `Composite.add` and `Composite.remove` methods rather than directly modifying this property.
	     * If you wish to recursively find all descendants, you should use the `Composite.allBodies` method.
	     *
	     * @property bodies
	     * @type body[]
	     * @default []
	     */
	
	    /**
	     * An array of `Constraint` that are _direct_ children of this composite.
	     * To add or remove constraints you should use `Composite.add` and `Composite.remove` methods rather than directly modifying this property.
	     * If you wish to recursively find all descendants, you should use the `Composite.allConstraints` method.
	     *
	     * @property constraints
	     * @type constraint[]
	     * @default []
	     */
	
	    /**
	     * An array of `Composite` that are _direct_ children of this composite.
	     * To add or remove composites you should use `Composite.add` and `Composite.remove` methods rather than directly modifying this property.
	     * If you wish to recursively find all descendants, you should use the `Composite.allComposites` method.
	     *
	     * @property composites
	     * @type composite[]
	     * @default []
	     */
	
	    /**
	     * An object reserved for storing plugin-specific properties.
	     *
	     * @property plugin
	     * @type {}
	     */
	
	})();


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* The `Matter.Bodies` module contains factory methods for creating rigid body models 
	* with commonly used body configurations (such as rectangles, circles and other polygons).
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class Bodies
	*/
	
	// TODO: true circle bodies
	
	var Bodies = {};
	
	module.exports = Bodies;
	
	var Vertices = __webpack_require__(86);
	var Common = __webpack_require__(31);
	var Body = __webpack_require__(51);
	var Bounds = __webpack_require__(85);
	var Vector = __webpack_require__(71);
	var decomp = __webpack_require__(609);
	
	(function() {
	
	    /**
	     * Creates a new rigid body model with a rectangle hull. 
	     * The options parameter is an object that specifies any properties you wish to override the defaults.
	     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
	     * @method rectangle
	     * @param {number} x
	     * @param {number} y
	     * @param {number} width
	     * @param {number} height
	     * @param {object} [options]
	     * @return {body} A new rectangle body
	     */
	    Bodies.rectangle = function(x, y, width, height, options) {
	        options = options || {};
	
	        var rectangle = { 
	            label: 'Rectangle Body',
	            position: { x: x, y: y },
	            vertices: Vertices.fromPath('L 0 0 L ' + width + ' 0 L ' + width + ' ' + height + ' L 0 ' + height)
	        };
	
	        if (options.chamfer) {
	            var chamfer = options.chamfer;
	            rectangle.vertices = Vertices.chamfer(rectangle.vertices, chamfer.radius, 
	                                    chamfer.quality, chamfer.qualityMin, chamfer.qualityMax);
	            delete options.chamfer;
	        }
	
	        return Body.create(Common.extend({}, rectangle, options));
	    };
	    
	    /**
	     * Creates a new rigid body model with a trapezoid hull. 
	     * The options parameter is an object that specifies any properties you wish to override the defaults.
	     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
	     * @method trapezoid
	     * @param {number} x
	     * @param {number} y
	     * @param {number} width
	     * @param {number} height
	     * @param {number} slope
	     * @param {object} [options]
	     * @return {body} A new trapezoid body
	     */
	    Bodies.trapezoid = function(x, y, width, height, slope, options) {
	        options = options || {};
	
	        slope *= 0.5;
	        var roof = (1 - (slope * 2)) * width;
	        
	        var x1 = width * slope,
	            x2 = x1 + roof,
	            x3 = x2 + x1,
	            verticesPath;
	
	        if (slope < 0.5) {
	            verticesPath = 'L 0 0 L ' + x1 + ' ' + (-height) + ' L ' + x2 + ' ' + (-height) + ' L ' + x3 + ' 0';
	        } else {
	            verticesPath = 'L 0 0 L ' + x2 + ' ' + (-height) + ' L ' + x3 + ' 0';
	        }
	
	        var trapezoid = { 
	            label: 'Trapezoid Body',
	            position: { x: x, y: y },
	            vertices: Vertices.fromPath(verticesPath)
	        };
	
	        if (options.chamfer) {
	            var chamfer = options.chamfer;
	            trapezoid.vertices = Vertices.chamfer(trapezoid.vertices, chamfer.radius, 
	                                    chamfer.quality, chamfer.qualityMin, chamfer.qualityMax);
	            delete options.chamfer;
	        }
	
	        return Body.create(Common.extend({}, trapezoid, options));
	    };
	
	    /**
	     * Creates a new rigid body model with a circle hull. 
	     * The options parameter is an object that specifies any properties you wish to override the defaults.
	     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
	     * @method circle
	     * @param {number} x
	     * @param {number} y
	     * @param {number} radius
	     * @param {object} [options]
	     * @param {number} [maxSides]
	     * @return {body} A new circle body
	     */
	    Bodies.circle = function(x, y, radius, options, maxSides) {
	        options = options || {};
	
	        var circle = {
	            label: 'Circle Body',
	            circleRadius: radius
	        };
	        
	        // approximate circles with polygons until true circles implemented in SAT
	        maxSides = maxSides || 25;
	        var sides = Math.ceil(Math.max(10, Math.min(maxSides, radius)));
	
	        // optimisation: always use even number of sides (half the number of unique axes)
	        if (sides % 2 === 1)
	            sides += 1;
	
	        return Bodies.polygon(x, y, sides, radius, Common.extend({}, circle, options));
	    };
	
	    /**
	     * Creates a new rigid body model with a regular polygon hull with the given number of sides. 
	     * The options parameter is an object that specifies any properties you wish to override the defaults.
	     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
	     * @method polygon
	     * @param {number} x
	     * @param {number} y
	     * @param {number} sides
	     * @param {number} radius
	     * @param {object} [options]
	     * @return {body} A new regular polygon body
	     */
	    Bodies.polygon = function(x, y, sides, radius, options) {
	        options = options || {};
	
	        if (sides < 3)
	            return Bodies.circle(x, y, radius, options);
	
	        var theta = 2 * Math.PI / sides,
	            path = '',
	            offset = theta * 0.5;
	
	        for (var i = 0; i < sides; i += 1) {
	            var angle = offset + (i * theta),
	                xx = Math.cos(angle) * radius,
	                yy = Math.sin(angle) * radius;
	
	            path += 'L ' + xx.toFixed(3) + ' ' + yy.toFixed(3) + ' ';
	        }
	
	        var polygon = { 
	            label: 'Polygon Body',
	            position: { x: x, y: y },
	            vertices: Vertices.fromPath(path)
	        };
	
	        if (options.chamfer) {
	            var chamfer = options.chamfer;
	            polygon.vertices = Vertices.chamfer(polygon.vertices, chamfer.radius, 
	                                    chamfer.quality, chamfer.qualityMin, chamfer.qualityMax);
	            delete options.chamfer;
	        }
	
	        return Body.create(Common.extend({}, polygon, options));
	    };
	
	    /**
	     * Creates a body using the supplied vertices (or an array containing multiple sets of vertices).
	     * If the vertices are convex, they will pass through as supplied.
	     * Otherwise if the vertices are concave, they will be decomposed if [poly-decomp.js](https://github.com/schteppe/poly-decomp.js) is available.
	     * Note that this process is not guaranteed to support complex sets of vertices (e.g. those with holes may fail).
	     * By default the decomposition will discard collinear edges (to improve performance).
	     * It can also optionally discard any parts that have an area less than `minimumArea`.
	     * If the vertices can not be decomposed, the result will fall back to using the convex hull.
	     * The options parameter is an object that specifies any `Matter.Body` properties you wish to override the defaults.
	     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
	     * @method fromVertices
	     * @param {number} x
	     * @param {number} y
	     * @param [[vector]] vertexSets
	     * @param {object} [options]
	     * @param {bool} [flagInternal=false]
	     * @param {number} [removeCollinear=0.01]
	     * @param {number} [minimumArea=10]
	     * @return {body}
	     */
	    Bodies.fromVertices = function(x, y, vertexSets, options, flagInternal, removeCollinear, minimumArea) {
	        var body,
	            parts,
	            isConvex,
	            vertices,
	            i,
	            j,
	            k,
	            v,
	            z;
	
	        options = options || {};
	        parts = [];
	
	        flagInternal = typeof flagInternal !== 'undefined' ? flagInternal : false;
	        removeCollinear = typeof removeCollinear !== 'undefined' ? removeCollinear : 0.01;
	        minimumArea = typeof minimumArea !== 'undefined' ? minimumArea : 10;
	
	        if (!decomp) {
	            Common.warn('Bodies.fromVertices: poly-decomp.js required. Could not decompose vertices. Fallback to convex hull.');
	        }
	
	        // ensure vertexSets is an array of arrays
	        if (!Common.isArray(vertexSets[0])) {
	            vertexSets = [vertexSets];
	        }
	
	        for (v = 0; v < vertexSets.length; v += 1) {
	            vertices = vertexSets[v];
	            isConvex = Vertices.isConvex(vertices);
	
	            if (isConvex || !decomp) {
	                if (isConvex) {
	                    vertices = Vertices.clockwiseSort(vertices);
	                } else {
	                    // fallback to convex hull when decomposition is not possible
	                    vertices = Vertices.hull(vertices);
	                }
	
	                parts.push({
	                    position: { x: x, y: y },
	                    vertices: vertices
	                });
	            } else {
	                // initialise a decomposition
	                var concave = vertices.map(function(vertex) {
	                    return [vertex.x, vertex.y];
	                });
	
	                // vertices are concave and simple, we can decompose into parts
	                decomp.makeCCW(concave);
	                if (removeCollinear !== false)
	                    decomp.removeCollinearPoints(concave, removeCollinear);
	
	                // use the quick decomposition algorithm (Bayazit)
	                var decomposed = decomp.quickDecomp(concave);
	
	                // for each decomposed chunk
	                for (i = 0; i < decomposed.length; i++) {
	                    var chunk = decomposed[i];
	
	                    // convert vertices into the correct structure
	                    var chunkVertices = chunk.map(function(vertices) {
	                        return {
	                            x: vertices[0],
	                            y: vertices[1]
	                        };
	                    });
	
	                    // skip small chunks
	                    if (minimumArea > 0 && Vertices.area(chunkVertices) < minimumArea)
	                        continue;
	
	                    // create a compound part
	                    parts.push({
	                        position: Vertices.centre(chunkVertices),
	                        vertices: chunkVertices
	                    });
	                }
	            }
	        }
	
	        // create body parts
	        for (i = 0; i < parts.length; i++) {
	            parts[i] = Body.create(Common.extend(parts[i], options));
	        }
	
	        // flag internal edges (coincident part edges)
	        if (flagInternal) {
	            var coincident_max_dist = 5;
	
	            for (i = 0; i < parts.length; i++) {
	                var partA = parts[i];
	
	                for (j = i + 1; j < parts.length; j++) {
	                    var partB = parts[j];
	
	                    if (Bounds.overlaps(partA.bounds, partB.bounds)) {
	                        var pav = partA.vertices,
	                            pbv = partB.vertices;
	
	                        // iterate vertices of both parts
	                        for (k = 0; k < partA.vertices.length; k++) {
	                            for (z = 0; z < partB.vertices.length; z++) {
	                                // find distances between the vertices
	                                var da = Vector.magnitudeSquared(Vector.sub(pav[(k + 1) % pav.length], pbv[z])),
	                                    db = Vector.magnitudeSquared(Vector.sub(pav[k], pbv[(z + 1) % pbv.length]));
	
	                                // if both vertices are very close, consider the edge concident (internal)
	                                if (da < coincident_max_dist && db < coincident_max_dist) {
	                                    pav[k].isInternal = true;
	                                    pbv[z].isInternal = true;
	                                }
	                            }
	                        }
	
	                    }
	                }
	            }
	        }
	
	        if (parts.length > 1) {
	            // create the parent body to be returned, that contains generated compound parts
	            body = Body.create(Common.extend({ parts: parts.slice(0) }, options));
	            Body.setPosition(body, { x: x, y: y });
	
	            return body;
	        } else {
	            return parts[0];
	        }
	    };
	
	})();


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(28);
	var Rectangle = __webpack_require__(525);
	
	/**
	 * @classdesc
	 * A Tile is a representation of a single tile within the Tilemap. This is a lightweight data
	 * representation, so its position information is stored without factoring in scroll, layer
	 * scale or layer position.
	 *
	 * @class Tile
	 * @memberOf Phaser.Tilemaps
	 * @constructor
	 * @since 3.0.0
	 *
	 * @extends Phaser.GameObjects.Components.Alpha
	 * @extends Phaser.GameObjects.Components.Flip
	 * @extends Phaser.GameObjects.Components.Visible
	 *
	 * @param {Phaser.Tilemaps.LayerData} layer - The LayerData object in the Tilemap that this tile belongs to.
	 * @param {integer} index - The unique index of this tile within the map.
	 * @param {integer} x - The x coordinate of this tile in tile coordinates.
	 * @param {integer} y - The y coordinate of this tile in tile coordinates.
	 * @param {integer} width - Width of the tile in pixels.
	 * @param {integer} height - Height of the tile in pixels.
	 * @param {integer} baseWidth - The base width a tile in the map (in pixels). Tiled maps support
	 * multiple tileset sizes within one map, but they are still placed at intervals of the base
	 * tile width.
	 * @param {integer} baseHeight - The base height of the tile in pixels (in pixels). Tiled maps
	 * support multiple tileset sizes within one map, but they are still placed at intervals of the
	 * base tile height.
	 */
	var Tile = new Class({
	
	    Mixins: [
	        Components.Alpha,
	        Components.Flip,
	        Components.Visible
	    ],
	
	    initialize:
	
	    function Tile (layer, index, x, y, width, height, baseWidth, baseHeight)
	    {
	        /**
	         * The LayerData in the Tilemap data that this tile belongs to.
	         *
	         * @name Phaser.Tilemaps.Tile#layer
	         * @type {Phaser.Tilemaps.LayerData}
	         * @since 3.0.0
	         */
	        this.layer = layer;
	
	        /**
	         * The index of this tile within the map data corresponding to the tileset, or -1 if this
	         * represents a blank tile.
	         *
	         * @name Phaser.Tilemaps.Tile#index
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.index = index;
	
	        /**
	         * The x map coordinate of this tile in tile units.
	         *
	         * @name Phaser.Tilemaps.Tile#x
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.x = x;
	
	        /**
	         * The y map coordinate of this tile in tile units.
	         *
	         * @name Phaser.Tilemaps.Tile#y
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.y = y;
	
	        /**
	         * The width of the tile in pixels.
	         *
	         * @name Phaser.Tilemaps.Tile#width
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.width = width;
	
	        /**
	         * The height of the tile in pixels.
	         *
	         * @name Phaser.Tilemaps.Tile#height
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.height = height;
	
	        /**
	         * The map's base width of a tile in pixels. Tiled maps support multiple tileset sizes
	         * within one map, but they are still placed at intervals of the base tile size.
	         *
	         * @name Phaser.Tilemaps.Tile#baseWidth
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.baseWidth = (baseWidth !== undefined) ? baseWidth : width;
	
	        /**
	         * The map's base height of a tile in pixels. Tiled maps support multiple tileset sizes
	         * within one map, but they are still placed at intervals of the base tile size.
	         *
	         * @name Phaser.Tilemaps.Tile#baseHeight
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.baseHeight = (baseHeight !== undefined) ? baseHeight : height;
	
	        /**
	         * The x coordinate of the top left of this tile in pixels. This is relative to the top left
	         * of the layer this tile is being rendered within. This property does NOT factor in camera
	         * scroll, layer scale or layer position.
	         *
	         * @name Phaser.Tilemaps.Tile#pixelX
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.pixelX = 0;
	
	        /**
	         * The y coordinate of the top left of this tile in pixels. This is relative to the top left
	         * of the layer this tile is being rendered within. This property does NOT factor in camera
	         * scroll, layer scale or layer position.
	         *
	         * @name Phaser.Tilemaps.Tile#pixelY
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.pixelY = 0;
	
	        this.updatePixelXY();
	
	        /**
	         * Tile specific properties. These usually come from Tiled.
	         *
	         * @name Phaser.Tilemaps.Tile#properties
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.properties = {};
	
	        /**
	         * The rotation angle of this tile.
	         *
	         * @name Phaser.Tilemaps.Tile#rotation
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.rotation = 0;
	
	        /**
	         * Whether the tile should collide with any object on the left side.
	         *
	         * @name Phaser.Tilemaps.Tile#collideLeft
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.collideLeft = false;
	
	        /**
	         * Whether the tile should collide with any object on the right side.
	         *
	         * @name Phaser.Tilemaps.Tile#collideRight
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.collideRight = false;
	
	        /**
	         * Whether the tile should collide with any object on the top side.
	         *
	         * @name Phaser.Tilemaps.Tile#collideUp
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.collideUp = false;
	
	        /**
	         * Whether the tile should collide with any object on the bottom side.
	         *
	         * @name Phaser.Tilemaps.Tile#collideDown
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.collideDown = false;
	
	        /**
	         * Whether the tile's left edge is interesting for collisions.
	         *
	         * @name Phaser.Tilemaps.Tile#faceLeft
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.faceLeft = false;
	
	        /**
	         * Whether the tile's right edge is interesting for collisions.
	         *
	         * @name Phaser.Tilemaps.Tile#faceRight
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.faceRight = false;
	
	        /**
	         * Whether the tile's top edge is interesting for collisions.
	         *
	         * @name Phaser.Tilemaps.Tile#faceTop
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.faceTop = false;
	
	        /**
	         * Whether the tile's bottom edge is interesting for collisions.
	         *
	         * @name Phaser.Tilemaps.Tile#faceBottom
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.faceBottom = false;
	
	        /**
	         * Tile collision callback.
	         *
	         * @name Phaser.Tilemaps.Tile#collisionCallback
	         * @type {function}
	         * @since 3.0.0
	         */
	        this.collisionCallback = null;
	
	        /**
	         * The context in which the collision callback will be called.
	         *
	         * @name Phaser.Tilemaps.Tile#collisionCallbackContext
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.collisionCallbackContext = this;
	
	        /**
	         * The tint to apply to this tile. Note: tint is currently a single color value instead of
	         * the 4 corner tint component on other GameObjects.
	         *
	         * @name Phaser.Tilemaps.Tile#tint
	         * @type {number}
	         * @default
	         * @since 3.0.0
	         */
	        this.tint = 0xffffff;
	
	        /**
	         * An empty object where physics-engine specific information (e.g. bodies) may be stored.
	         *
	         * @name Phaser.Tilemaps.Tile#physics
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.physics = {};
	    },
	
	    /**
	     * Check if the given x and y world coordinates are within this Tile. This does not factor in
	     * camera scroll, layer scale or layer position.
	     *
	     * @method Phaser.Tilemaps.Tile#containsPoint
	     * @since 3.0.0
	     *
	     * @param {number} x - The x coordinate to test.
	     * @param {number} y - The y coordinate to test.
	     *
	     * @return {boolean} True if the coordinates are within this Tile, otherwise false.
	     */
	    containsPoint: function (x, y)
	    {
	        return !(x < this.pixelX || y < this.pixelY || x > this.right || y > this.bottom);
	    },
	
	    /**
	     * Copies the tile data & properties from the given tile to this tile. This copies everything
	     * except for position and interesting faces.
	     *
	     * @method Phaser.Tilemaps.Tile#copy
	     * @since 3.0.0
	     *
	     * @param {Phaser.Tilemaps.Tile} tile - The tile to copy from.
	     *
	     * @return {Phaser.Tilemaps.Tile} This Tile object.
	     */
	    copy: function (tile)
	    {
	        this.index = tile.index;
	        this.alpha = tile.alpha;
	        this.properties = tile.properties;
	        this.visible = tile.visible;
	        this.setFlip(tile.flipX, tile.flipY);
	        this.tint = tile.tint;
	        this.rotation = tile.rotation;
	        this.collideUp = tile.collideUp;
	        this.collideDown = tile.collideDown;
	        this.collideLeft = tile.collideLeft;
	        this.collideRight = tile.collideRight;
	        this.collisionCallback = tile.collisionCallback;
	        this.collisionCallbackContext = tile.collisionCallbackContext;
	
	        return this;
	    },
	
	    /**
	     * The collision group for this Tile, defined within the Tileset. This returns a reference to
	     * the collision group stored within the Tileset, so any modification of the returned object
	     * will impact all tiles that have the same index as this tile.
	     *
	     * @method Phaser.Tilemaps.Tile#getCollisionGroup
	     * @since 3.0.0
	     *
	     * @return {?object} tileset
	     */
	    getCollisionGroup: function ()
	    {
	        return this.tileset ? this.tileset.getTileCollisionGroup(this.index) : null;
	    },
	
	    /**
	     * The tile data for this Tile, defined within the Tileset. This typically contains Tiled
	     * collision data, tile animations and terrain information. This returns a reference to the tile
	     * data stored within the Tileset, so any modification of the returned object will impact all
	     * tiles that have the same index as this tile.
	     *
	     * @method Phaser.Tilemaps.Tile#getTileData
	     * @since 3.0.0
	     *
	     * @return {?object} tileset
	     */
	    getTileData: function ()
	    {
	        return this.tileset ? this.tileset.getTileData(this.index) : null;
	    },
	
	    /**
	     * Gets the world X position of the left side of the tile, factoring in the layers position,
	     * scale and scroll.
	     *
	     * @method Phaser.Tilemaps.Tile#getLeft
	     * @since 3.0.0
	     *
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
	     *
	     * @return {number}
	     */
	    getLeft: function (camera)
	    {
	        var tilemapLayer = this.tilemapLayer;
	
	        return (tilemapLayer) ? tilemapLayer.tileToWorldX(this.x, camera) : this.x * this.baseWidth;
	    },
	
	    /**
	     * Gets the world X position of the right side of the tile, factoring in the layer's position,
	     * scale and scroll.
	     *
	     * @method Phaser.Tilemaps.Tile#getRight
	     * @since 3.0.0
	     *
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
	     *
	     * @return {number}
	     */
	    getRight: function (camera)
	    {
	        var tilemapLayer = this.tilemapLayer;
	
	        return (tilemapLayer) ? this.getLeft(camera) + this.width * tilemapLayer.scaleX : this.getLeft(camera) + this.width;
	    },
	
	    /**
	     * Gets the world Y position of the top side of the tile, factoring in the layer's position,
	     * scale and scroll.
	     *
	     * @method Phaser.Tilemaps.Tile#getTop
	     * @since 3.0.0
	     *
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
	     *
	     * @return {number}
	     */
	    getTop: function (camera)
	    {
	        var tilemapLayer = this.tilemapLayer;
	
	        // Tiled places tiles on a grid of baseWidth x baseHeight. The origin for a tile in grid
	        // units is the bottom left, so the y coordinate needs to be adjusted by the difference
	        // between the base size and this tile's size.
	        return tilemapLayer
	            ? tilemapLayer.tileToWorldY(this.y, camera) - (this.height - this.baseHeight) * tilemapLayer.scaleY
	            : this.y * this.baseHeight - (this.height - this.baseHeight);
	    },
	
	    /**
	     * Gets the world Y position of the bottom side of the tile, factoring in the layer's position,
	     * scale and scroll.
	
	     * @method Phaser.Tilemaps.Tile#getBottom
	     * @since 3.0.0
	     *
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
	     *
	     * @return {number}
	     */
	    getBottom: function (camera)
	    {
	        var tilemapLayer = this.tilemapLayer;
	        return tilemapLayer
	            ? this.getTop(camera) + this.height * tilemapLayer.scaleY
	            : this.getTop(camera) + this.height;
	    },
	
	
	    /**
	     * Gets the world rectangle bounding box for the tile, factoring in the layers position,
	     * scale and scroll.
	     *
	     * @method Phaser.Tilemaps.Tile#getBounds
	     * @since 3.0.0
	     *
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
	     * @param {object} [output] - [description]
	     *
	     * @return {(Phaser.Geom.Rectangle|object)}
	     */
	    getBounds: function (camera, output)
	    {
	        if (output === undefined) { output = new Rectangle(); }
	
	        output.x = this.getLeft();
	        output.y = this.getTop();
	        output.width = this.getRight() - output.x;
	        output.height = this.getBottom() - output.y;
	
	        return output;
	    },
	
	    /**
	     * Gets the world X position of the center of the tile, factoring in the layer's position,
	     * scale and scroll.
	     *
	     * @method Phaser.Tilemaps.Tile#getCenterX
	     * @since 3.0.0
	     *
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
	     *
	     * @return {number}
	     */
	    getCenterX: function (camera)
	    {
	        return this.getLeft(camera) + this.width / 2;
	    },
	
	    /**
	     * Gets the world Y position of the center of the tile, factoring in the layer's position,
	     * scale and scroll.
	     *
	     * @method Phaser.Tilemaps.Tile#getCenterY
	     * @since 3.0.0
	     *
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to use to perform the check.
	     *
	     * @return {number}
	     */
	    getCenterY: function (camera)
	    {
	        return this.getTop(camera) + this.height / 2;
	    },
	
	    /**
	     * Clean up memory.
	     *
	     * @method Phaser.Tilemaps.Tile#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.collisionCallback = undefined;
	        this.collisionCallbackContext = undefined;
	        this.properties = undefined;
	    },
	
	    /**
	     * Check for intersection with this tile. This does not factor in camera scroll, layer scale or
	     * layer position.
	     *
	     * @method Phaser.Tilemaps.Tile#intersects
	     * @since 3.0.0
	     *
	     * @param {number} x - The x axis in pixels.
	     * @param {number} y - The y axis in pixels.
	     * @param {number} right - The right point.
	     * @param {number} bottom - The bottom point.
	     *
	     * @return {boolean}
	     */
	    intersects: function (x, y, right, bottom)
	    {
	        return !(
	            right <= this.pixelX || bottom <= this.pixelY ||
	            x >= this.right || y >= this.bottom
	        );
	    },
	
	    /**
	     * Checks if the tile is interesting.
	     *
	     * @method Phaser.Tilemaps.Tile#isInteresting
	     * @since 3.0.0
	     *
	     * @param {boolean} collides - If true, will consider the tile interesting if it collides on any side.
	     * @param {boolean} faces - If true, will consider the tile interesting if it has an interesting face.
	     *
	     * @return {boolean} True if the Tile is interesting, otherwise false.
	     */
	    isInteresting: function (collides, faces)
	    {
	        if (collides && faces) { return (this.canCollide || this.hasInterestingFace); }
	        else if (collides) { return this.collides; }
	        else if (faces) { return this.hasInterestingFace; }
	        return false;
	    },
	
	    /**
	     * Reset collision status flags.
	     *
	     * @method Phaser.Tilemaps.Tile#resetCollision
	     * @since 3.0.0
	     *
	     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate interesting faces for this tile and its neighbors.
	     *
	     * @return {Phaser.Tilemaps.Tile} This Tile object.
	     */
	    resetCollision: function (recalculateFaces)
	    {
	        if (recalculateFaces === undefined) { recalculateFaces = true; }
	
	        this.collideLeft = false;
	        this.collideRight = false;
	        this.collideUp = false;
	        this.collideDown = false;
	
	        this.faceTop = false;
	        this.faceBottom = false;
	        this.faceLeft = false;
	        this.faceRight = false;
	
	        if (recalculateFaces)
	        {
	            var tilemapLayer = this.tilemapLayer;
	
	            if (tilemapLayer)
	            {
	                this.tilemapLayer.calculateFacesAt(this.x, this.y);
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Reset faces.
	     *
	     * @method Phaser.Tilemaps.Tile#resetFaces
	     * @since 3.0.0
	     *
	     * @return {Phaser.Tilemaps.Tile} This Tile object.
	     */
	    resetFaces: function ()
	    {
	        this.faceTop = false;
	        this.faceBottom = false;
	        this.faceLeft = false;
	        this.faceRight = false;
	
	        return this;
	    },
	
	    /**
	     * Sets the collision flags for each side of this tile and updates the interesting faces list.
	     *
	     * @method Phaser.Tilemaps.Tile#setCollision
	     * @since 3.0.0
	     *
	     * @param {boolean} left - Indicating collide with any object on the left.
	     * @param {boolean} [right] - Indicating collide with any object on the right.
	     * @param {boolean} [up] - Indicating collide with any object on the top.
	     * @param {boolean} [down] - Indicating collide with any object on the bottom.
	     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate interesting faces
	     * for this tile and its neighbors.
	     *
	     * @return {Phaser.Tilemaps.Tile} This Tile object.
	     */
	    setCollision: function (left, right, up, down, recalculateFaces)
	    {
	        if (right === undefined) { right = left; }
	        if (up === undefined) { up = left; }
	        if (down === undefined) { down = left; }
	        if (recalculateFaces === undefined) { recalculateFaces = true; }
	
	        this.collideLeft = left;
	        this.collideRight = right;
	        this.collideUp = up;
	        this.collideDown = down;
	
	        this.faceLeft = left;
	        this.faceRight = right;
	        this.faceTop = up;
	        this.faceBottom = down;
	
	        if (recalculateFaces)
	        {
	            var tilemapLayer = this.tilemapLayer;
	
	            if (tilemapLayer)
	            {
	                this.tilemapLayer.calculateFacesAt(this.x, this.y);
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Set a callback to be called when this tile is hit by an object. The callback must true for
	     * collision processing to take place.
	     *
	     * @method Phaser.Tilemaps.Tile#setCollisionCallback
	     * @since 3.0.0
	     *
	     * @param {function} callback - Callback function.
	     * @param {object} context - Callback will be called within this context.
	     *
	     * @return {Phaser.Tilemaps.Tile} This Tile object.
	     */
	    setCollisionCallback: function (callback, context)
	    {
	        if (callback === null)
	        {
	            this.collisionCallback = undefined;
	            this.collisionCallbackContext = undefined;
	        }
	        else
	        {
	            this.collisionCallback = callback;
	            this.collisionCallbackContext = context;
	        }
	
	        return this;
	    },
	
	    /**
	     * Sets the size of the tile and updates its pixelX and pixelY.
	     *
	     * @method Phaser.Tilemaps.Tile#setSize
	     * @since 3.0.0
	     *
	     * @param {integer} tileWidth - The width of the tile in pixels.
	     * @param {integer} tileHeight - The height of the tile in pixels.
	     * @param {integer} baseWidth - The base width a tile in the map (in pixels).
	     * @param {integer} baseHeight - The base height of the tile in pixels (in pixels).
	     *
	     * @return {Phaser.Tilemaps.Tile} This Tile object.
	     */
	    setSize: function (tileWidth, tileHeight, baseWidth, baseHeight)
	    {
	        if (tileWidth !== undefined) { this.width = tileWidth; }
	        if (tileHeight !== undefined) { this.height = tileHeight; }
	        if (baseWidth !== undefined) { this.baseWidth = baseWidth; }
	        if (baseHeight !== undefined) { this.baseHeight = baseHeight; }
	
	        this.updatePixelXY();
	
	        return this;
	    },
	
	    /**
	     * Used internally. Updates the tile's world XY position based on the current tile size.
	     *
	     * @method Phaser.Tilemaps.Tile#updatePixelXY
	     * @since 3.0.0
	     *
	     * @return {Phaser.Tilemaps.Tile} This Tile object.
	     */
	    updatePixelXY: function ()
	    {
	        // Tiled places tiles on a grid of baseWidth x baseHeight. The origin for a tile is the
	        // bottom left, while the Phaser renderer assumes the origin is the top left. The y
	        // coordinate needs to be adjusted by the difference.
	        this.pixelX = this.x * this.baseWidth;
	        this.pixelY = this.y * this.baseHeight - (this.height - this.baseHeight);
	
	        return this;
	    },
	
	    /**
	     * True if this tile can collide on any of its faces or has a collision callback set.
	     *
	     * @name Phaser.Tilemaps.Tile#canCollide
	     * @type {boolean}
	     * @readOnly
	     * @since 3.0.0
	     */
	    canCollide: {
	        get: function ()
	        {
	            return (this.collideLeft || this.collideRight || this.collideUp || this.collideDown || this.collisionCallback);
	        }
	    },
	
	    /**
	     * True if this tile can collide on any of its faces.
	     *
	     * @name Phaser.Tilemaps.Tile#collides
	     * @type {boolean}
	     * @readOnly
	     * @since 3.0.0
	     */
	    collides: {
	        get: function ()
	        {
	            return (this.collideLeft || this.collideRight || this.collideUp || this.collideDown);
	        }
	    },
	
	    /**
	     * True if this tile has any interesting faces.
	     *
	     * @name Phaser.Tilemaps.Tile#hasInterestingFace
	     * @type {boolean}
	     * @readOnly
	     * @since 3.0.0
	     */
	    hasInterestingFace: {
	        get: function ()
	        {
	            return (this.faceTop || this.faceBottom || this.faceLeft || this.faceRight);
	        }
	    },
	
	    /**
	     * The tileset that contains this Tile. This will only return null if accessed from a LayerData
	     * instance before the tile is placed within a StaticTilemapLayer or DynamicTilemapLayer.
	     *
	     * @name Phaser.Tilemaps.Tile#tileset
	     * @type {?Phaser.Tilemaps.Tileset}
	     * @readOnly
	     * @since 3.0.0
	     */
	    tileset: {
	        get: function ()
	        {
	            var tilemapLayer = this.tilemapLayer;
	            return tilemapLayer ? tilemapLayer.tileset : null;
	        }
	    },
	
	    /**
	     * The tilemap layer that contains this Tile. This will only return null if accessed from a
	     * LayerData instance before the tile is placed within a StaticTilemapLayer or
	     * DynamicTilemapLayer.
	     *
	     * @name Phaser.Tilemaps.Tile#tilemapLayer
	     * @type {?Phaser.Tilemaps.StaticTilemapLayer|Phaser.Tilemaps.DynamicTilemapLayer}
	     * @readOnly
	     * @since 3.0.0
	     */
	    tilemapLayer: {
	        get: function ()
	        {
	            return this.layer.tilemapLayer;
	        }
	    },
	
	    /**
	     * The tilemap that contains this Tile. This will only return null if accessed from a LayerData
	     * instance before the tile is placed within a StaticTilemapLayer or DynamicTilemapLayer.
	     *
	     * @name Phaser.Tilemaps.Tile#tilemap
	     * @type {?Phaser.Tilemaps.Tilemap}
	     * @readOnly
	     * @since 3.0.0
	     */
	    tilemap: {
	        get: function ()
	        {
	            var tilemapLayer = this.tilemapLayer;
	            return tilemapLayer ? tilemapLayer.tilemap : null;
	        }
	    }
	
	});
	
	module.exports = Tile;


/***/ }),
/* 121 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Internally used method to set the colliding state of a tile. This does not recalculate
	 * interesting faces.
	 *
	 * @function Phaser.Tilemaps.Components.SetTileCollision
	 * @private
	 * @since 3.0.0
	 *
	 * @param {Phaser.Tilemaps.Tile} tile - [description]
	 * @param {boolean} [collides=true] - [description]
	 */
	var SetTileCollision = function (tile, collides)
	{
	    if (collides)
	    {
	        tile.setCollision(true, true, true, true, false);
	    }
	    else
	    {
	        tile.resetCollision(false);
	    }
	};
	
	module.exports = SetTileCollision;


/***/ }),
/* 122 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Tests if the start and end indexes are a safe range for the given array.
	 * 
	 * @function Phaser.Utils.Array.SafeRange
	 * @since 3.4.0
	 *
	 * @param {array} array - The array to check.
	 * @param {integer} startIndex - The start index.
	 * @param {integer} endIndex - The end index.
	 * @param {boolean} [throwError=true] - Throw an error if the range is out of bounds.
	 *
	 * @return {boolean} True if the range is safe, otherwise false.
	 */
	var SafeRange = function (array, startIndex, endIndex, throwError)
	{
	    var len = array.length;
	
	    if (startIndex < 0 ||
	        startIndex > len ||
	        startIndex >= endIndex ||
	        endIndex > len ||
	        startIndex + endIndex > len)
	    {
	        if (throwError)
	        {
	            throw new Error('Range Error: Values outside acceptable range');
	        }
	
	        return false;
	    }
	    else
	    {
	        return true;
	    }
	};
	
	module.exports = SafeRange;


/***/ }),
/* 123 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Shallow Object Clone. Will not clone nested objects.
	 *
	 * @function Phaser.Utils.Object.Clone
	 * @since 3.0.0
	 *
	 * @param {object} obj - the object from which to clone
	 *
	 * @return {object} a new object with the same properties as the input obj
	 */
	var Clone = function (obj)
	{
	    var clone = {};
	
	    for (var key in obj)
	    {
	        if (Array.isArray(obj[key]))
	        {
	            clone[key] = obj[key].slice(0);
	        }
	        else
	        {
	            clone[key] = obj[key];
	        }
	    }
	
	    return clone;
	};
	
	module.exports = Clone;


/***/ }),
/* 124 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(20).f;
	var has = __webpack_require__(52);
	var TAG = __webpack_require__(16)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var defined = __webpack_require__(65);
	var fails = __webpack_require__(11);
	var spaces = __webpack_require__(243);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(32),
		__webpack_require__(27),
		__webpack_require__(94),
		__webpack_require__(949),
		__webpack_require__(413),
		__webpack_require__(414),
	
		__webpack_require__(62),
		__webpack_require__(947),
		__webpack_require__(257),
		__webpack_require__(130),
		__webpack_require__(434) // jQuery.param
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, isFunction, rnothtmlwhite, location, nonce, rquery ) {
	
	"use strict";
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(192),
		__webpack_require__(440)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( class2type, toString ) {
	
	"use strict";
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	
	return toType;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(27),
		__webpack_require__(193),
		__webpack_require__(250)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, isFunction, slice ) {
	
	"use strict";
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(32),
		__webpack_require__(259),
		__webpack_require__(27),
		__webpack_require__(94),
		__webpack_require__(193),
		__webpack_require__(69),
		__webpack_require__(112),
	
		__webpack_require__(62),
		__webpack_require__(41)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, documentElement, isFunction, rnothtmlwhite,
		slice, dataPriv, nodeName ) {
	
	"use strict";
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(261),
		__webpack_require__(978),
		__webpack_require__(979),
		__webpack_require__(436),
		__webpack_require__(112),
	
		__webpack_require__(62),
		__webpack_require__(435),
		__webpack_require__(41)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, indexOf, dir, siblings, rneedsContext, nodeName ) {
	
	"use strict";
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
	        if ( nodeName( elem, "iframe" ) ) {
	            return elem.contentDocument;
	        }
	
	        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
	        // Treat the template element as a regular one in browsers that
	        // don't support it.
	        if ( nodeName( elem, "template" ) ) {
	            elem = elem.content || elem;
	        }
	
	        return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var FromPoints = __webpack_require__(294);
	var Rectangle = __webpack_require__(23);
	var Vector2 = __webpack_require__(9);
	
	/**
	 * @classdesc
	 * A Base Curve class, which all other curve types extend.
	 *
	 * Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
	 *
	 * @class Curve
	 * @memberOf Phaser.Curves
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {string} type - [description]
	 */
	var Curve = new Class({
	
	    initialize:
	
	    function Curve (type)
	    {
	        /**
	         * String based identifier for the type of curve.
	         *
	         * @name Phaser.Curves.Curve#type
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.type = type;
	
	        /**
	         * The default number of divisions within the curve.
	         *
	         * @name Phaser.Curves.Curve#defaultDivisions
	         * @type {integer}
	         * @default 5
	         * @since 3.0.0
	         */
	        this.defaultDivisions = 5;
	
	        /**
	         * The quantity of arc length divisions within the curve.
	         *
	         * @name Phaser.Curves.Curve#arcLengthDivisions
	         * @type {integer}
	         * @default 100
	         * @since 3.0.0
	         */
	        this.arcLengthDivisions = 100;
	
	        /**
	         * An array of cached arc length values.
	         *
	         * @name Phaser.Curves.Curve#cacheArcLengths
	         * @type {number[]}
	         * @default []
	         * @since 3.0.0
	         */
	        this.cacheArcLengths = [];
	
	        /**
	         * Does the data of this curve need updating?
	         *
	         * @name Phaser.Curves.Curve#needsUpdate
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.needsUpdate = true;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.Curve#active
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.active = true;
	
	        /**
	         * A temporary calculation Vector.
	         *
	         * @name Phaser.Curves.Curve#_tmpVec2A
	         * @type {Phaser.Math.Vector2}
	         * @private
	         * @since 3.0.0
	         */
	        this._tmpVec2A = new Vector2();
	
	        /**
	         * A temporary calculation Vector.
	         *
	         * @name Phaser.Curves.Curve#_tmpVec2B
	         * @type {Phaser.Math.Vector2}
	         * @private
	         * @since 3.0.0
	         */
	        this._tmpVec2B = new Vector2();
	    },
	
	    /**
	     * Draws this curve on the given Graphics object.
	     *
	     * The curve is drawn using `Graphics.strokePoints` so will be drawn at whatever the present Graphics stroke color is.
	     * The Graphics object is not cleared before the draw, so the curve will appear on-top of anything else already rendered to it.
	     *
	     * @method Phaser.Curves.Curve#draw
	     * @since 3.0.0
	     *
	     * @generic {Phaser.GameObjects.Graphics} G - [graphics,$return]
	     *
	     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics instance onto which this curve will be drawn.
	     * @param {integer} [pointsTotal=32] - The resolution of the curve. The higher the value the smoother it will render, at the cost of rendering performance.
	     *
	     * @return {Phaser.GameObjects.Graphics} The Graphics object to which the curve was drawn.
	     */
	    draw: function (graphics, pointsTotal)
	    {
	        if (pointsTotal === undefined) { pointsTotal = 32; }
	
	        //  So you can chain graphics calls
	        return graphics.strokePoints(this.getPoints(pointsTotal));
	    },
	
	    /**
	     * Returns a Rectangle where the position and dimensions match the bounds of this Curve.
	     *
	     * You can control the accuracy of the bounds. The value given is used to work out how many points
	     * to plot across the curve. Higher values are more accurate at the cost of calculation speed.
	     *
	     * @method Phaser.Curves.Curve#getBounds
	     * @since 3.0.0
	     *
	     * @param {Phaser.Geom.Rectangle} [out] - The Rectangle to store the bounds in. If falsey a new object will be created.
	     * @param {integer} [accuracy=16] - The accuracy of the bounds calculations.
	     *
	     * @return {Phaser.Geom.Rectangle} A Rectangle object holding the bounds of this curve. If `out` was given it will be this object.
	     */
	    getBounds: function (out, accuracy)
	    {
	        if (!out) { out = new Rectangle(); }
	        if (accuracy === undefined) { accuracy = 16; }
	
	        var len = this.getLength();
	
	        if (accuracy > len)
	        {
	            accuracy = len / 2;
	        }
	
	        //  The length of the curve in pixels
	        //  So we'll have 1 spaced point per 'accuracy' pixels
	
	        var spaced = Math.max(1, Math.round(len / accuracy));
	
	        return FromPoints(this.getSpacedPoints(spaced), out);
	    },
	
	    /**
	     * Returns an array of points, spaced out X distance pixels apart.
	     * The smaller the distance, the larger the array will be.
	     *
	     * @method Phaser.Curves.Curve#getDistancePoints
	     * @since 3.0.0
	     *
	     * @param {integer} distance - The distance, in pixels, between each point along the curve.
	     *
	     * @return {Phaser.Geom.Point[]} An Array of Point objects.
	     */
	    getDistancePoints: function (distance)
	    {
	        var len = this.getLength();
	
	        var spaced = Math.max(1, len / distance);
	
	        return this.getSpacedPoints(spaced);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Curve#getEndPoint
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector2} out - [description]
	     *
	     * @return {Phaser.Math.Vector2} [description]
	     */
	    getEndPoint: function (out)
	    {
	        if (out === undefined) { out = new Vector2(); }
	
	        return this.getPointAt(1, out);
	    },
	
	    // Get total curve arc length
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Curve#getLength
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    getLength: function ()
	    {
	        var lengths = this.getLengths();
	
	        return lengths[lengths.length - 1];
	    },
	
	    // Get list of cumulative segment lengths
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Curve#getLengths
	     * @since 3.0.0
	     *
	     * @param {integer} [divisions] - [description]
	     *
	     * @return {number[]} [description]
	     */
	    getLengths: function (divisions)
	    {
	        if (divisions === undefined) { divisions = this.arcLengthDivisions; }
	
	        if ((this.cacheArcLengths.length === divisions + 1) && !this.needsUpdate)
	        {
	            return this.cacheArcLengths;
	        }
	
	        this.needsUpdate = false;
	
	        var cache = [];
	        var current;
	        var last = this.getPoint(0, this._tmpVec2A);
	        var sum = 0;
	
	        cache.push(0);
	
	        for (var p = 1; p <= divisions; p++)
	        {
	            current = this.getPoint(p / divisions, this._tmpVec2B);
	
	            sum += current.distance(last);
	
	            cache.push(sum);
	
	            last.copy(current);
	        }
	
	        this.cacheArcLengths = cache;
	
	        return cache; // { sums: cache, sum:sum }; Sum is in the last element.
	    },
	
	    // Get point at relative position in curve according to arc length
	
	    // - u [0 .. 1]
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Curve#getPointAt
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {float} u - [description]
	     * @param {Phaser.Math.Vector2} [out] - [description]
	     *
	     * @return {Phaser.Math.Vector2} [description]
	     */
	    getPointAt: function (u, out)
	    {
	        var t = this.getUtoTmapping(u);
	
	        return this.getPoint(t, out);
	    },
	
	    // Get sequence of points using getPoint( t )
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Curve#getPoints
	     * @since 3.0.0
	     *
	     * @param {integer} [divisions] - [description]
	     *
	     * @return {Phaser.Math.Vector2[]} [description]
	     */
	    getPoints: function (divisions)
	    {
	        if (divisions === undefined) { divisions = this.defaultDivisions; }
	
	        var points = [];
	
	        for (var d = 0; d <= divisions; d++)
	        {
	            points.push(this.getPoint(d / divisions));
	        }
	
	        return points;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Curve#getRandomPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {Phaser.Math.Vector2} [out] - [description]
	     *
	     * @return {Phaser.Math.Vector2} [description]
	     */
	    getRandomPoint: function (out)
	    {
	        if (out === undefined) { out = new Vector2(); }
	
	        return this.getPoint(Math.random(), out);
	    },
	
	    // Get sequence of points using getPointAt( u )
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Curve#getSpacedPoints
	     * @since 3.0.0
	     *
	     * @param {integer} [divisions] - [description]
	     *
	     * @return {Phaser.Math.Vector2[]} [description]
	     */
	    getSpacedPoints: function (divisions)
	    {
	        if (divisions === undefined) { divisions = this.defaultDivisions; }
	
	        var points = [];
	
	        for (var d = 0; d <= divisions; d++)
	        {
	            var t = this.getUtoTmapping(d / divisions, null, divisions);
	
	            points.push(this.getPoint(t));
	        }
	
	        return points;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Curve#getStartPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {Phaser.Math.Vector2} [out] - [description]
	     *
	     * @return {Phaser.Math.Vector2} [description]
	     */
	    getStartPoint: function (out)
	    {
	        if (out === undefined) { out = new Vector2(); }
	
	        return this.getPointAt(0, out);
	    },
	
	    // Returns a unit vector tangent at t
	    // In case any sub curve does not implement its tangent derivation,
	    // 2 points a small delta apart will be used to find its gradient
	    // which seems to give a reasonable approximation
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Curve#getTangent
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {number} t - [description]
	     * @param {Phaser.Math.Vector2} [out] - [description]
	     *
	     * @return {Phaser.Math.Vector2} [description]
	     */
	    getTangent: function (t, out)
	    {
	        if (out === undefined) { out = new Vector2(); }
	
	        var delta = 0.0001;
	        var t1 = t - delta;
	        var t2 = t + delta;
	
	        // Capping in case of danger
	
	        if (t1 < 0)
	        {
	            t1 = 0;
	        }
	
	        if (t2 > 1)
	        {
	            t2 = 1;
	        }
	
	        this.getPoint(t1, this._tmpVec2A);
	        this.getPoint(t2, out);
	
	        return out.subtract(this._tmpVec2A).normalize();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Curve#getTangentAt
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {float} u - [description]
	     * @param {Phaser.Math.Vector2} [out] - [description]
	     *
	     * @return {Phaser.Math.Vector2} [description]
	     */
	    getTangentAt: function (u, out)
	    {
	        var t = this.getUtoTmapping(u);
	
	        return this.getTangent(t, out);
	    },
	
	    //  Given a distance in pixels, get a t to find p.
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Curve#getTFromDistance
	     * @since 3.0.0
	     *
	     * @param {integer} distance - [description]
	     * @param {integer} [divisions] - [description]
	     *
	     * @return {float} [description]
	     */
	    getTFromDistance: function (distance, divisions)
	    {
	        if (distance <= 0)
	        {
	            return 0;
	        }
	
	        return this.getUtoTmapping(0, distance, divisions);
	    },
	
	    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Curve#getUtoTmapping
	     * @since 3.0.0
	     *
	     * @param {float} u - [description]
	     * @param {integer} distance - [description]
	     * @param {integer} [divisions] - [description]
	     *
	     * @return {number} [description]
	     */
	    getUtoTmapping: function (u, distance, divisions)
	    {
	        var arcLengths = this.getLengths(divisions);
	
	        var i = 0;
	        var il = arcLengths.length;
	
	        var targetArcLength; // The targeted u distance value to get
	
	        if (distance)
	        {
	            //  Cannot overshoot the curve
	            targetArcLength = Math.min(distance, arcLengths[il - 1]);
	        }
	        else
	        {
	            targetArcLength = u * arcLengths[il - 1];
	        }
	
	        // binary search for the index with largest value smaller than target u distance
	
	        var low = 0;
	        var high = il - 1;
	        var comparison;
	
	        while (low <= high)
	        {
	            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
	
	            comparison = arcLengths[i] - targetArcLength;
	
	            if (comparison < 0)
	            {
	                low = i + 1;
	            }
	            else if (comparison > 0)
	            {
	                high = i - 1;
	            }
	            else
	            {
	                high = i;
	                break;
	            }
	        }
	
	        i = high;
	
	        if (arcLengths[i] === targetArcLength)
	        {
	            return i / (il - 1);
	        }
	
	        // we could get finer grain at lengths, or use simple interpolation between two points
	
	        var lengthBefore = arcLengths[i];
	        var lengthAfter = arcLengths[i + 1];
	
	        var segmentLength = lengthAfter - lengthBefore;
	
	        // determine where we are between the 'before' and 'after' points
	
	        var segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
	
	        // add that fractional amount to t
	
	        return (i + segmentFraction) / (il - 1);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Curve#updateArcLengths
	     * @since 3.0.0
	     */
	    updateArcLengths: function ()
	    {
	        this.needsUpdate = true;
	
	        this.getLengths();
	    }
	
	});
	
	module.exports = Curve;


/***/ }),
/* 134 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Returns the center x coordinate from the bounds of the Game Object.
	 *
	 * @function Phaser.Display.Bounds.GetCenterX
	 * @since 3.0.0
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
	 *
	 * @return {number} The center x coordinate of the bounds of the Game Object.
	 */
	var GetCenterX = function (gameObject)
	{
	    return gameObject.x - (gameObject.width * gameObject.originX) + (gameObject.width * 0.5);
	};
	
	module.exports = GetCenterX;


/***/ }),
/* 135 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Returns the center y coordinate from the bounds of the Game Object.
	 *
	 * @function Phaser.Display.Bounds.GetCenterY
	 * @since 3.0.0
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
	 *
	 * @return {number} The center y coordinate of the bounds of the Game Object.
	 */
	var GetCenterY = function (gameObject)
	{
	    return gameObject.y - (gameObject.height * gameObject.originY) + (gameObject.height * 0.5);
	};
	
	module.exports = GetCenterY;


/***/ }),
/* 136 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Positions the Game Object so that the center top of its bounds aligns with the given coordinate.
	 *
	 * @function Phaser.Display.Bounds.SetCenterX
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
	 * @param {number} x - The coordinate to position the Game Object bounds on.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
	 */
	var SetCenterX = function (gameObject, x)
	{
	    var offsetX = gameObject.width * gameObject.originX;
	
	    gameObject.x = (x + offsetX) - (gameObject.width * 0.5);
	
	    return gameObject;
	};
	
	module.exports = SetCenterX;


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Positions the Game Object so that the center top of its bounds aligns with the given coordinate.
	 *
	 * @function Phaser.Display.Bounds.SetCenterY
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
	 * @param {number} y - The coordinate to position the Game Object bounds on.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
	 */
	var SetCenterY = function (gameObject, y)
	{
	    var offsetY = gameObject.height * gameObject.originY;
	
	    gameObject.y = (y + offsetY) - (gameObject.height * 0.5);
	
	    return gameObject;
	};
	
	module.exports = SetCenterY;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(28);
	var GameObject = __webpack_require__(5);
	var ImageRender = __webpack_require__(1154);
	
	/**
	 * @classdesc
	 * An Image Game Object.
	 *
	 * An Image is a light-weight Game Object useful for the display of static images in your game,
	 * such as logos, backgrounds, scenery or other non-animated elements. Images can have input
	 * events and physics bodies, or be tweened, tinted or scrolled. The main difference between an
	 * Image and a Sprite is that you cannot animate an Image as they do not have the Animation component.
	 *
	 * @class Image
	 * @extends Phaser.GameObjects.GameObject
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @since 3.0.0
	 *
	 * @extends Phaser.GameObjects.Components.Alpha
	 * @extends Phaser.GameObjects.Components.BlendMode
	 * @extends Phaser.GameObjects.Components.Depth
	 * @extends Phaser.GameObjects.Components.Flip
	 * @extends Phaser.GameObjects.Components.GetBounds
	 * @extends Phaser.GameObjects.Components.Mask
	 * @extends Phaser.GameObjects.Components.Origin
	 * @extends Phaser.GameObjects.Components.Pipeline
	 * @extends Phaser.GameObjects.Components.ScaleMode
	 * @extends Phaser.GameObjects.Components.ScrollFactor
	 * @extends Phaser.GameObjects.Components.Size
	 * @extends Phaser.GameObjects.Components.Texture
	 * @extends Phaser.GameObjects.Components.Tint
	 * @extends Phaser.GameObjects.Components.Transform
	 * @extends Phaser.GameObjects.Components.Visible
	 *
	 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	 * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	 */
	var Image = new Class({
	
	    Extends: GameObject,
	
	    Mixins: [
	        Components.Alpha,
	        Components.BlendMode,
	        Components.Depth,
	        Components.Flip,
	        Components.GetBounds,
	        Components.Mask,
	        Components.Origin,
	        Components.Pipeline,
	        Components.ScaleMode,
	        Components.ScrollFactor,
	        Components.Size,
	        Components.Texture,
	        Components.Tint,
	        Components.Transform,
	        Components.Visible,
	        ImageRender
	    ],
	
	    initialize:
	
	    function Image (scene, x, y, texture, frame)
	    {
	        GameObject.call(this, scene, 'Image');
	
	        this.setTexture(texture, frame);
	        this.setPosition(x, y);
	        this.setSizeToFrame();
	        this.setOriginFromFrame();
	        this.initPipeline('TextureTintPipeline');
	    }
	
	});
	
	module.exports = Image;


/***/ }),
/* 139 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.Angle
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 *
	 * @return {number} [description]
	 */
	var Angle = function (line)
	{
	    return Math.atan2(line.y2 - line.y1, line.x2 - line.x1);
	};
	
	module.exports = Angle;


/***/ }),
/* 140 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  http://www.blackpawn.com/texts/pointinpoly/
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.Contains
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 * @param {number} x - [description]
	 * @param {number} y - [description]
	 *
	 * @return {boolean} [description]
	 */
	var Contains = function (triangle, x, y)
	{
	    var v0x = triangle.x3 - triangle.x1;
	    var v0y = triangle.y3 - triangle.y1;
	
	    var v1x = triangle.x2 - triangle.x1;
	    var v1y = triangle.y2 - triangle.y1;
	
	    var v2x = x - triangle.x1;
	    var v2y = y - triangle.y1;
	
	    var dot00 = (v0x * v0x) + (v0y * v0y);
	    var dot01 = (v0x * v1x) + (v0y * v1y);
	    var dot02 = (v0x * v2x) + (v0y * v2y);
	    var dot11 = (v1x * v1x) + (v1y * v1y);
	    var dot12 = (v1x * v2x) + (v1y * v2y);
	
	    // Compute barycentric coordinates
	    var b = ((dot00 * dot11) - (dot01 * dot01));
	    var inv = (b === 0) ? 0 : (1 / b);
	    var u = ((dot11 * dot02) - (dot01 * dot12)) * inv;
	    var v = ((dot00 * dot12) - (dot01 * dot02)) * inv;
	
	    return (u >= 0 && v >= 0 && (u + v < 1));
	};
	
	module.exports = Contains;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Contains = __webpack_require__(140);
	var GetPoint = __webpack_require__(528);
	var GetPoints = __webpack_require__(529);
	var Line = __webpack_require__(200);
	var Random = __webpack_require__(299);
	
	/**
	 * @classdesc
	 * A triangle is a plane created by connecting three points.
	 * The first two arguments specify the first point, the middle two arguments
	 * specify the second point, and the last two arguments specify the third point.
	 *
	 * @class Triangle
	 * @memberOf Phaser.Geom
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {number} [x1=0] - [description]
	 * @param {number} [y1=0] - [description]
	 * @param {number} [x2=0] - [description]
	 * @param {number} [y2=0] - [description]
	 * @param {number} [x3=0] - [description]
	 * @param {number} [y3=0] - [description]
	 */
	var Triangle = new Class({
	
	    initialize:
	
	    function Triangle (x1, y1, x2, y2, x3, y3)
	    {
	        if (x1 === undefined) { x1 = 0; }
	        if (y1 === undefined) { y1 = 0; }
	        if (x2 === undefined) { x2 = 0; }
	        if (y2 === undefined) { y2 = 0; }
	        if (x3 === undefined) { x3 = 0; }
	        if (y3 === undefined) { y3 = 0; }
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Geom.Triangle#x1
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.x1 = x1;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Geom.Triangle#y1
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.y1 = y1;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Geom.Triangle#x2
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.x2 = x2;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Geom.Triangle#y2
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.y2 = y2;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Geom.Triangle#x3
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.x3 = x3;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Geom.Triangle#y3
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.y3 = y3;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Geom.Triangle#contains
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     *
	     * @return {boolean} [description]
	     */
	    contains: function (x, y)
	    {
	        return Contains(this, x, y);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Geom.Triangle#getPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Point} O - [output,$return]
	     *
	     * @param {float} position - [description]
	     * @param {(Phaser.Geom.Point|object)} [output] - [description]
	     *
	     * @return {(Phaser.Geom.Point|object)} [description]
	     */
	    getPoint: function (position, output)
	    {
	        return GetPoint(this, position, output);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Geom.Triangle#getPoints
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Point[]} O - [output,$return]
	     *
	     * @param {integer} quantity - [description]
	     * @param {number} [stepRate] - [description]
	     * @param {(array|Phaser.Geom.Point[])} [output] - [description]
	     *
	     * @return {(array|Phaser.Geom.Point[])} [description]
	     */
	    getPoints: function (quantity, stepRate, output)
	    {
	        return GetPoints(this, quantity, stepRate, output);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Geom.Triangle#getRandomPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Point} O - [point,$return]
	     *
	     * @param {Phaser.Geom.Point} [point] - [description]
	     *
	     * @return {Phaser.Geom.Point} [description]
	     */
	    getRandomPoint: function (point)
	    {
	        return Random(this, point);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Geom.Triangle#setTo
	     * @since 3.0.0
	     *
	     * @param {number} [x1=0] - [description]
	     * @param {number} [y1=0] - [description]
	     * @param {number} [x2=0] - [description]
	     * @param {number} [y2=0] - [description]
	     * @param {number} [x3=0] - [description]
	     * @param {number} [y3=0] - [description]
	     *
	     * @return {Phaser.Geom.Triangle} This Triangle object.
	     */
	    setTo: function (x1, y1, x2, y2, x3, y3)
	    {
	        if (x1 === undefined) { x1 = 0; }
	        if (y1 === undefined) { y1 = 0; }
	        if (x2 === undefined) { x2 = 0; }
	        if (y2 === undefined) { y2 = 0; }
	        if (x3 === undefined) { x3 = 0; }
	        if (y3 === undefined) { y3 = 0; }
	
	        this.x1 = x1;
	        this.y1 = y1;
	
	        this.x2 = x2;
	        this.y2 = y2;
	
	        this.x3 = x3;
	        this.y3 = y3;
	
	        return this;
	    },
	
	    /**
	     * Returns a Line object that corresponds to Line A of this Triangle.
	     *
	     * @method Phaser.Geom.Triangle#getLineA
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Line} O - [line,$return]
	     *
	     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
	     *
	     * @return {Phaser.Geom.Line} A Line object that corresponds to line A of this Triangle.
	     */
	    getLineA: function (line)
	    {
	        if (line === undefined) { line = new Line(); }
	
	        line.setTo(this.x1, this.y1, this.x2, this.y2);
	
	        return line;
	    },
	
	    /**
	     * Returns a Line object that corresponds to Line B of this Triangle.
	     *
	     * @method Phaser.Geom.Triangle#getLineB
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Line} O - [line,$return]
	     *
	     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
	     *
	     * @return {Phaser.Geom.Line} A Line object that corresponds to line B of this Triangle.
	     */
	    getLineB: function (line)
	    {
	        if (line === undefined) { line = new Line(); }
	
	        line.setTo(this.x2, this.y2, this.x3, this.y3);
	
	        return line;
	    },
	
	    /**
	     * Returns a Line object that corresponds to Line C of this Triangle.
	     *
	     * @method Phaser.Geom.Triangle#getLineC
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Line} O - [line,$return]
	     *
	     * @param {Phaser.Geom.Line} [line] - A Line object to set the results in. If `undefined` a new Line will be created.
	     *
	     * @return {Phaser.Geom.Line} A Line object that corresponds to line C of this Triangle.
	     */
	    getLineC: function (line)
	    {
	        if (line === undefined) { line = new Line(); }
	
	        line.setTo(this.x3, this.y3, this.x1, this.y1);
	
	        return line;
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Geom.Triangle#left
	     * @type {number}
	     * @since 3.0.0
	     */
	    left: {
	
	        get: function ()
	        {
	            return Math.min(this.x1, this.x2, this.x3);
	        },
	
	        set: function (value)
	        {
	            var diff = 0;
	
	            if (this.x1 <= this.x2 && this.x1 <= this.x3)
	            {
	                diff = this.x1 - value;
	            }
	            else if (this.x2 <= this.x1 && this.x2 <= this.x3)
	            {
	                diff = this.x2 - value;
	            }
	            else
	            {
	                diff = this.x3 - value;
	            }
	
	            this.x1 -= diff;
	            this.x2 -= diff;
	            this.x3 -= diff;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Geom.Triangle#right
	     * @type {number}
	     * @since 3.0.0
	     */
	    right: {
	
	        get: function ()
	        {
	            return Math.max(this.x1, this.x2, this.x3);
	        },
	
	        set: function (value)
	        {
	            var diff = 0;
	
	            if (this.x1 >= this.x2 && this.x1 >= this.x3)
	            {
	                diff = this.x1 - value;
	            }
	            else if (this.x2 >= this.x1 && this.x2 >= this.x3)
	            {
	                diff = this.x2 - value;
	            }
	            else
	            {
	                diff = this.x3 - value;
	            }
	
	            this.x1 -= diff;
	            this.x2 -= diff;
	            this.x3 -= diff;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Geom.Triangle#top
	     * @type {number}
	     * @since 3.0.0
	     */
	    top: {
	
	        get: function ()
	        {
	            return Math.min(this.y1, this.y2, this.y3);
	        },
	
	        set: function (value)
	        {
	            var diff = 0;
	
	            if (this.y1 <= this.y2 && this.y1 <= this.y3)
	            {
	                diff = this.y1 - value;
	            }
	            else if (this.y2 <= this.y1 && this.y2 <= this.y3)
	            {
	                diff = this.y2 - value;
	            }
	            else
	            {
	                diff = this.y3 - value;
	            }
	
	            this.y1 -= diff;
	            this.y2 -= diff;
	            this.y3 -= diff;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Geom.Triangle#bottom
	     * @type {number}
	     * @since 3.0.0
	     */
	    bottom: {
	
	        get: function ()
	        {
	            return Math.max(this.y1, this.y2, this.y3);
	        },
	
	        set: function (value)
	        {
	            var diff = 0;
	
	            if (this.y1 >= this.y2 && this.y1 >= this.y3)
	            {
	                diff = this.y1 - value;
	            }
	            else if (this.y2 >= this.y1 && this.y2 >= this.y3)
	            {
	                diff = this.y2 - value;
	            }
	            else
	            {
	                diff = this.y3 - value;
	            }
	
	            this.y1 -= diff;
	            this.y2 -= diff;
	            this.y3 -= diff;
	        }
	
	    }
	
	});
	
	module.exports = Triangle;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
	//  and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
	
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class Vector3
	 * @memberOf Phaser.Math
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {number} [x] - [description]
	 * @param {number} [y] - [description]
	 * @param {number} [z] - [description]
	 */
	var Vector3 = new Class({
	
	    initialize:
	
	    function Vector3 (x, y, z)
	    {
	        /**
	         * The x component of this Vector.
	         *
	         * @name Phaser.Math.Vector3#x
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	
	        /**
	         * The y component of this Vector.
	         *
	         * @name Phaser.Math.Vector3#y
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	
	        /**
	         * The z component of this Vector.
	         *
	         * @name Phaser.Math.Vector3#z
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	
	        if (typeof x === 'object')
	        {
	            this.x = x.x || 0;
	            this.y = x.y || 0;
	            this.z = x.z || 0;
	        }
	        else
	        {
	            this.x = x || 0;
	            this.y = y || 0;
	            this.z = z || 0;
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#up
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Vector3} This Vector3 object.
	     */
	    up: function ()
	    {
	        this.x = 0;
	        this.y = 1;
	        this.z = 0;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#clone
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Vector3} A new Vector3 object containing this Vectors values.
	     */
	    clone: function ()
	    {
	        return new Vector3(this.x, this.y, this.z);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#crossVectors
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector3} a - [description]
	     * @param {Phaser.Math.Vector3} b - [description]
	     *
	     * @return {Phaser.Math.Vector3} This Vector3 object.
	     */
	    crossVectors: function (a, b)
	    {
	        var ax = a.x;
	        var ay = a.y;
	        var az = a.z;
	        var bx = b.x;
	        var by = b.y;
	        var bz = b.z;
	
	        this.x = ay * bz - az * by;
	        this.y = az * bx - ax * bz;
	        this.z = ax * by - ay * bx;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#equals
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector3} v - The Vector3 to compare against.
	     *
	     * @return {boolean} True if the two vectors strictly match, otherwise false.
	     */
	    equals: function (v)
	    {
	        return ((this.x === v.x) && (this.y === v.y) && (this.z === v.z));
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#copy
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} src - [description]
	     *
	     * @return {Phaser.Math.Vector3} This Vector3 object.
	     */
	    copy: function (src)
	    {
	        this.x = src.x;
	        this.y = src.y;
	        this.z = src.z || 0;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#set
	     * @since 3.0.0
	     *
	     * @param {(number|object)} x - [description]
	     * @param {number} [y] - [description]
	     * @param {number} [z] - [description]
	     *
	     * @return {Phaser.Math.Vector3} This Vector3 object.
	     */
	    set: function (x, y, z)
	    {
	        if (typeof x === 'object')
	        {
	            this.x = x.x || 0;
	            this.y = x.y || 0;
	            this.z = x.z || 0;
	        }
	        else
	        {
	            this.x = x || 0;
	            this.y = y || 0;
	            this.z = z || 0;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#add
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - [description]
	     *
	     * @return {Phaser.Math.Vector3} This Vector3 object.
	     */
	    add: function (v)
	    {
	        this.x += v.x;
	        this.y += v.y;
	        this.z += v.z || 0;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#subtract
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - [description]
	     *
	     * @return {Phaser.Math.Vector3} This Vector3 object.
	     */
	    subtract: function (v)
	    {
	        this.x -= v.x;
	        this.y -= v.y;
	        this.z -= v.z || 0;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#multiply
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - [description]
	     *
	     * @return {Phaser.Math.Vector3} This Vector3 object.
	     */
	    multiply: function (v)
	    {
	        this.x *= v.x;
	        this.y *= v.y;
	        this.z *= v.z || 1;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#scale
	     * @since 3.0.0
	     *
	     * @param {float} scale - [description]
	     *
	     * @return {Phaser.Math.Vector3} This Vector3 object.
	     */
	    scale: function (scale)
	    {
	        if (isFinite(scale))
	        {
	            this.x *= scale;
	            this.y *= scale;
	            this.z *= scale;
	        }
	        else
	        {
	            this.x = 0;
	            this.y = 0;
	            this.z = 0;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#divide
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - [description]
	     *
	     * @return {Phaser.Math.Vector3} This Vector3 object.
	     */
	    divide: function (v)
	    {
	        this.x /= v.x;
	        this.y /= v.y;
	        this.z /= v.z || 1;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#negate
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Vector3} This Vector3 object.
	     */
	    negate: function ()
	    {
	        this.x = -this.x;
	        this.y = -this.y;
	        this.z = -this.z;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#distance
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - [description]
	     *
	     * @return {number} [description]
	     */
	    distance: function (v)
	    {
	        var dx = v.x - this.x;
	        var dy = v.y - this.y;
	        var dz = v.z - this.z || 0;
	
	        return Math.sqrt(dx * dx + dy * dy + dz * dz);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#distanceSq
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - [description]
	     *
	     * @return {number} [description]
	     */
	    distanceSq: function (v)
	    {
	        var dx = v.x - this.x;
	        var dy = v.y - this.y;
	        var dz = v.z - this.z || 0;
	
	        return dx * dx + dy * dy + dz * dz;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#length
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    length: function ()
	    {
	        var x = this.x;
	        var y = this.y;
	        var z = this.z;
	
	        return Math.sqrt(x * x + y * y + z * z);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#lengthSq
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    lengthSq: function ()
	    {
	        var x = this.x;
	        var y = this.y;
	        var z = this.z;
	
	        return x * x + y * y + z * z;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#normalize
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3)} v - [description]
	     *
	     * @return {Phaser.Math.Vector3} This Vector3 object.
	     */
	    normalize: function ()
	    {
	        var x = this.x;
	        var y = this.y;
	        var z = this.z;
	        var len = x * x + y * y + z * z;
	
	        if (len > 0)
	        {
	            len = 1 / Math.sqrt(len);
	
	            this.x = x * len;
	            this.y = y * len;
	            this.z = z * len;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#dot
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector3} v - [description]
	     *
	     * @return {number} [description]
	     */
	    dot: function (v)
	    {
	        return this.x * v.x + this.y * v.y + this.z * v.z;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#cross
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector3} v - [description]
	     *
	     * @return {Phaser.Math.Vector3} This Vector3 object.
	     */
	    cross: function (v)
	    {
	        var ax = this.x;
	        var ay = this.y;
	        var az = this.z;
	        var bx = v.x;
	        var by = v.y;
	        var bz = v.z;
	
	        this.x = ay * bz - az * by;
	        this.y = az * bx - ax * bz;
	        this.z = ax * by - ay * bx;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#lerp
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector3} v - [description]
	     * @param {number} [t=0] - [description]
	     *
	     * @return {Phaser.Math.Vector3} This Vector3 object.
	     */
	    lerp: function (v, t)
	    {
	        if (t === undefined) { t = 0; }
	
	        var ax = this.x;
	        var ay = this.y;
	        var az = this.z;
	
	        this.x = ax + t * (v.x - ax);
	        this.y = ay + t * (v.y - ay);
	        this.z = az + t * (v.z - az);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#transformMat3
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Matrix3} mat - [description]
	     *
	     * @return {Phaser.Math.Vector3} This Vector3 object.
	     */
	    transformMat3: function (mat)
	    {
	        var x = this.x;
	        var y = this.y;
	        var z = this.z;
	        var m = mat.val;
	
	        this.x = x * m[0] + y * m[3] + z * m[6];
	        this.y = x * m[1] + y * m[4] + z * m[7];
	        this.z = x * m[2] + y * m[5] + z * m[8];
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#transformMat4
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Matrix4} mat - [description]
	     *
	     * @return {Phaser.Math.Vector3} This Vector3 object.
	     */
	    transformMat4: function (mat)
	    {
	        var x = this.x;
	        var y = this.y;
	        var z = this.z;
	        var m = mat.val;
	
	        this.x = m[0] * x + m[4] * y + m[8] * z + m[12];
	        this.y = m[1] * x + m[5] * y + m[9] * z + m[13];
	        this.z = m[2] * x + m[6] * y + m[10] * z + m[14];
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#transformCoordinates
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Matrix4} mat - [description]
	     *
	     * @return {Phaser.Math.Vector3} This Vector3 object.
	     */
	    transformCoordinates: function (mat)
	    {
	        var x = this.x;
	        var y = this.y;
	        var z = this.z;
	        var m = mat.val;
	
	        var tx = (x * m[0]) + (y * m[4]) + (z * m[8]) + m[12];
	        var ty = (x * m[1]) + (y * m[5]) + (z * m[9]) + m[13];
	        var tz = (x * m[2]) + (y * m[6]) + (z * m[10]) + m[14];
	        var tw = (x * m[3]) + (y * m[7]) + (z * m[11]) + m[15];
	
	        this.x = tx / tw;
	        this.y = ty / tw;
	        this.z = tz / tw;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#transformQuat
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Quaternion} q - [description]
	     *
	     * @return {Phaser.Math.Vector3} This Vector3 object.
	     */
	    transformQuat: function (q)
	    {
	        // benchmarks: http://jsperf.com/quaternion-transform-vec3-implementations
	        var x = this.x;
	        var y = this.y;
	        var z = this.z;
	        var qx = q.x;
	        var qy = q.y;
	        var qz = q.z;
	        var qw = q.w;
	
	        // calculate quat * vec
	        var ix = qw * x + qy * z - qz * y;
	        var iy = qw * y + qz * x - qx * z;
	        var iz = qw * z + qx * y - qy * x;
	        var iw = -qx * x - qy * y - qz * z;
	
	        // calculate result * inverse quat
	        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
	        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
	        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
	
	        return this;
	    },
	
	    /**
	     * Multiplies this Vector3 by the specified matrix, applying a W divide. This is useful for projection,
	     * e.g. unprojecting a 2D point into 3D space.
	     *
	     * @method Phaser.Math.Vector3#project
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Matrix4} mat - [description]
	     *
	     * @return {Phaser.Math.Vector3} This Vector3 object.
	     */
	    project: function (mat)
	    {
	        var x = this.x;
	        var y = this.y;
	        var z = this.z;
	        var m = mat.val;
	
	        var a00 = m[0];
	        var a01 = m[1];
	        var a02 = m[2];
	        var a03 = m[3];
	        var a10 = m[4];
	        var a11 = m[5];
	        var a12 = m[6];
	        var a13 = m[7];
	        var a20 = m[8];
	        var a21 = m[9];
	        var a22 = m[10];
	        var a23 = m[11];
	        var a30 = m[12];
	        var a31 = m[13];
	        var a32 = m[14];
	        var a33 = m[15];
	
	        var lw = 1 / (x * a03 + y * a13 + z * a23 + a33);
	
	        this.x = (x * a00 + y * a10 + z * a20 + a30) * lw;
	        this.y = (x * a01 + y * a11 + z * a21 + a31) * lw;
	        this.z = (x * a02 + y * a12 + z * a22 + a32) * lw;
	
	        return this;
	    },
	
	    /**
	     * Unproject this point from 2D space to 3D space.
	     * The point should have its x and y properties set to
	     * 2D screen space, and the z either at 0 (near plane)
	     * or 1 (far plane). The provided matrix is assumed to already
	     * be combined, i.e. projection * view * model.
	     *
	     * After this operation, this vector's (x, y, z) components will
	     * represent the unprojected 3D coordinate.
	     *
	     * @method Phaser.Math.Vector3#unproject
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector4} viewport - Screen x, y, width and height in pixels.
	     * @param {Phaser.Math.Matrix4} invProjectionView - Combined projection and view matrix.
	     *
	     * @return {Phaser.Math.Vector3} This Vector3 object.
	     */
	    unproject: function (viewport, invProjectionView)
	    {
	        var viewX = viewport.x;
	        var viewY = viewport.y;
	        var viewWidth = viewport.z;
	        var viewHeight = viewport.w;
	
	        var x = this.x - viewX;
	        var y = (viewHeight - this.y - 1) - viewY;
	        var z = this.z;
	
	        this.x = (2 * x) / viewWidth - 1;
	        this.y = (2 * y) / viewHeight - 1;
	        this.z = 2 * z - 1;
	
	        return this.project(invProjectionView);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector3#reset
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Vector3} This Vector3 object.
	     */
	    reset: function ()
	    {
	        this.x = 0;
	        this.y = 0;
	        this.z = 0;
	
	        return this;
	    }
	
	});
	
	/*
	Vector3.Zero = function ()
	{
	    return new Vector3(0, 0, 0);
	};
	
	Vector3.Up = function ()
	{
	    return new Vector3(0, 1.0, 0);
	};
	
	Vector3.Copy = function (source)
	{
	    return new Vector3(source.x, source.y, source.z);
	};
	
	Vector3.TransformCoordinates = function (vector, transformation)
	{
	    var x = (vector.x * transformation.m[0]) + (vector.y * transformation.m[4]) + (vector.z * transformation.m[8]) + transformation.m[12];
	    var y = (vector.x * transformation.m[1]) + (vector.y * transformation.m[5]) + (vector.z * transformation.m[9]) + transformation.m[13];
	    var z = (vector.x * transformation.m[2]) + (vector.y * transformation.m[6]) + (vector.z * transformation.m[10]) + transformation.m[14];
	    var w = (vector.x * transformation.m[3]) + (vector.y * transformation.m[7]) + (vector.z * transformation.m[11]) + transformation.m[15];
	
	    return new Vector3(x / w, y / w, z / w);
	};
	
	Vector3.TransformNormal = function (vector, transformation)
	{
	    var x = (vector.x * transformation.m[0]) + (vector.y * transformation.m[4]) + (vector.z * transformation.m[8]);
	    var y = (vector.x * transformation.m[1]) + (vector.y * transformation.m[5]) + (vector.z * transformation.m[9]);
	    var z = (vector.x * transformation.m[2]) + (vector.y * transformation.m[6]) + (vector.z * transformation.m[10]);
	
	    return new Vector3(x, y, z);
	};
	
	Vector3.Dot = function (left, right)
	{
	    return (left.x * right.x + left.y * right.y + left.z * right.z);
	};
	
	Vector3.Cross = function (left, right)
	{
	    var x = left.y * right.z - left.z * right.y;
	    var y = left.z * right.x - left.x * right.z;
	    var z = left.x * right.y - left.y * right.x;
	
	    return new Vector3(x, y, z);
	};
	
	Vector3.Normalize = function (vector)
	{
	    var newVector = Vector3.Copy(vector);
	    newVector.normalize();
	
	    return newVector;
	};
	
	Vector3.Distance = function (value1, value2)
	{
	    return Math.sqrt(Vector3.DistanceSquared(value1, value2));
	};
	
	Vector3.DistanceSquared = function (value1, value2)
	{
	    var x = value1.x - value2.x;
	    var y = value1.y - value2.y;
	    var z = value1.z - value2.z;
	
	    return (x * x) + (y * y) + (z * z);
	};
	*/
	
	module.exports = Vector3;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* The `Matter.Constraint` module contains methods for creating and manipulating constraints.
	* Constraints are used for specifying that a fixed distance must be maintained between two bodies (or a body and a fixed world-space position).
	* The stiffness of constraints can be modified to create springs or elastic.
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class Constraint
	*/
	
	var Constraint = {};
	
	module.exports = Constraint;
	
	var Vertices = __webpack_require__(86);
	var Vector = __webpack_require__(71);
	var Sleeping = __webpack_require__(166);
	var Bounds = __webpack_require__(85);
	var Axes = __webpack_require__(321);
	var Common = __webpack_require__(31);
	
	(function() {
	
	    Constraint._warming = 0.4;
	    Constraint._torqueDampen = 1;
	    Constraint._minLength = 0.000001;
	
	    /**
	     * Creates a new constraint.
	     * All properties have default values, and many are pre-calculated automatically based on other properties.
	     * To simulate a revolute constraint (or pin joint) set `length: 0` and a high `stiffness` value (e.g. `0.7` or above).
	     * If the constraint is unstable, try lowering the `stiffness` value and / or increasing `engine.constraintIterations`.
	     * See the properties section below for detailed information on what you can pass via the `options` object.
	     * @method create
	     * @param {} options
	     * @return {constraint} constraint
	     */
	    Constraint.create = function(options) {
	        var constraint = options;
	
	        // if bodies defined but no points, use body centre
	        if (constraint.bodyA && !constraint.pointA)
	            constraint.pointA = { x: 0, y: 0 };
	        if (constraint.bodyB && !constraint.pointB)
	            constraint.pointB = { x: 0, y: 0 };
	
	        // calculate static length using initial world space points
	        var initialPointA = constraint.bodyA ? Vector.add(constraint.bodyA.position, constraint.pointA) : constraint.pointA,
	            initialPointB = constraint.bodyB ? Vector.add(constraint.bodyB.position, constraint.pointB) : constraint.pointB,
	            length = Vector.magnitude(Vector.sub(initialPointA, initialPointB));
	    
	        constraint.length = typeof constraint.length !== 'undefined' ? constraint.length : length;
	
	        // option defaults
	        constraint.id = constraint.id || Common.nextId();
	        constraint.label = constraint.label || 'Constraint';
	        constraint.type = 'constraint';
	        constraint.stiffness = constraint.stiffness || (constraint.length > 0 ? 1 : 0.7);
	        constraint.damping = constraint.damping || 0;
	        constraint.angularStiffness = constraint.angularStiffness || 0;
	        constraint.angleA = constraint.bodyA ? constraint.bodyA.angle : constraint.angleA;
	        constraint.angleB = constraint.bodyB ? constraint.bodyB.angle : constraint.angleB;
	        constraint.plugin = {};
	
	        // render
	        var render = {
	            visible: true,
	            lineWidth: 2,
	            strokeStyle: '#ffffff',
	            type: 'line',
	            anchors: true
	        };
	
	        if (constraint.length === 0 && constraint.stiffness > 0.1) {
	            render.type = 'pin';
	            render.anchors = false;
	        } else if (constraint.stiffness < 0.9) {
	            render.type = 'spring';
	        }
	
	        constraint.render = Common.extend(render, constraint.render);
	
	        return constraint;
	    };
	
	    /**
	     * Prepares for solving by constraint warming.
	     * @private
	     * @method preSolveAll
	     * @param {body[]} bodies
	     */
	    Constraint.preSolveAll = function(bodies) {
	        for (var i = 0; i < bodies.length; i += 1) {
	            var body = bodies[i],
	                impulse = body.constraintImpulse;
	
	            if (body.isStatic || (impulse.x === 0 && impulse.y === 0 && impulse.angle === 0)) {
	                continue;
	            }
	
	            body.position.x += impulse.x;
	            body.position.y += impulse.y;
	            body.angle += impulse.angle;
	        }
	    };
	
	    /**
	     * Solves all constraints in a list of collisions.
	     * @private
	     * @method solveAll
	     * @param {constraint[]} constraints
	     * @param {number} timeScale
	     */
	    Constraint.solveAll = function(constraints, timeScale) {
	        // Solve fixed constraints first.
	        for (var i = 0; i < constraints.length; i += 1) {
	            var constraint = constraints[i],
	                fixedA = !constraint.bodyA || (constraint.bodyA && constraint.bodyA.isStatic),
	                fixedB = !constraint.bodyB || (constraint.bodyB && constraint.bodyB.isStatic);
	
	            if (fixedA || fixedB) {
	                Constraint.solve(constraints[i], timeScale);
	            }
	        }
	
	        // Solve free constraints last.
	        for (i = 0; i < constraints.length; i += 1) {
	            constraint = constraints[i];
	            fixedA = !constraint.bodyA || (constraint.bodyA && constraint.bodyA.isStatic);
	            fixedB = !constraint.bodyB || (constraint.bodyB && constraint.bodyB.isStatic);
	
	            if (!fixedA && !fixedB) {
	                Constraint.solve(constraints[i], timeScale);
	            }
	        }
	    };
	
	    /**
	     * Solves a distance constraint with Gauss-Siedel method.
	     * @private
	     * @method solve
	     * @param {constraint} constraint
	     * @param {number} timeScale
	     */
	    Constraint.solve = function(constraint, timeScale) {
	        var bodyA = constraint.bodyA,
	            bodyB = constraint.bodyB,
	            pointA = constraint.pointA,
	            pointB = constraint.pointB;
	
	        if (!bodyA && !bodyB)
	            return;
	
	        // update reference angle
	        if (bodyA && !bodyA.isStatic) {
	            Vector.rotate(pointA, bodyA.angle - constraint.angleA, pointA);
	            constraint.angleA = bodyA.angle;
	        }
	        
	        // update reference angle
	        if (bodyB && !bodyB.isStatic) {
	            Vector.rotate(pointB, bodyB.angle - constraint.angleB, pointB);
	            constraint.angleB = bodyB.angle;
	        }
	
	        var pointAWorld = pointA,
	            pointBWorld = pointB;
	
	        if (bodyA) pointAWorld = Vector.add(bodyA.position, pointA);
	        if (bodyB) pointBWorld = Vector.add(bodyB.position, pointB);
	
	        if (!pointAWorld || !pointBWorld)
	            return;
	
	        var delta = Vector.sub(pointAWorld, pointBWorld),
	            currentLength = Vector.magnitude(delta);
	
	        // prevent singularity
	        if (currentLength < Constraint._minLength) {
	            currentLength = Constraint._minLength;
	        }
	
	        // solve distance constraint with Gauss-Siedel method
	        var difference = (currentLength - constraint.length) / currentLength,
	            stiffness = constraint.stiffness < 1 ? constraint.stiffness * timeScale : constraint.stiffness,
	            force = Vector.mult(delta, difference * stiffness),
	            massTotal = (bodyA ? bodyA.inverseMass : 0) + (bodyB ? bodyB.inverseMass : 0),
	            inertiaTotal = (bodyA ? bodyA.inverseInertia : 0) + (bodyB ? bodyB.inverseInertia : 0),
	            resistanceTotal = massTotal + inertiaTotal,
	            torque,
	            share,
	            normal,
	            normalVelocity,
	            relativeVelocity;
	
	        if (constraint.damping) {
	            var zero = Vector.create();
	            normal = Vector.div(delta, currentLength);
	
	            relativeVelocity = Vector.sub(
	                bodyB && Vector.sub(bodyB.position, bodyB.positionPrev) || zero,
	                bodyA && Vector.sub(bodyA.position, bodyA.positionPrev) || zero
	            );
	
	            normalVelocity = Vector.dot(normal, relativeVelocity);
	        }
	
	        if (bodyA && !bodyA.isStatic) {
	            share = bodyA.inverseMass / massTotal;
	
	            // keep track of applied impulses for post solving
	            bodyA.constraintImpulse.x -= force.x * share;
	            bodyA.constraintImpulse.y -= force.y * share;
	
	            // apply forces
	            bodyA.position.x -= force.x * share;
	            bodyA.position.y -= force.y * share;
	
	            // apply damping
	            if (constraint.damping) {
	                bodyA.positionPrev.x -= constraint.damping * normal.x * normalVelocity * share;
	                bodyA.positionPrev.y -= constraint.damping * normal.y * normalVelocity * share;
	            }
	
	            // apply torque
	            torque = (Vector.cross(pointA, force) / resistanceTotal) * Constraint._torqueDampen * bodyA.inverseInertia * (1 - constraint.angularStiffness);
	            bodyA.constraintImpulse.angle -= torque;
	            bodyA.angle -= torque;
	        }
	
	        if (bodyB && !bodyB.isStatic) {
	            share = bodyB.inverseMass / massTotal;
	
	            // keep track of applied impulses for post solving
	            bodyB.constraintImpulse.x += force.x * share;
	            bodyB.constraintImpulse.y += force.y * share;
	            
	            // apply forces
	            bodyB.position.x += force.x * share;
	            bodyB.position.y += force.y * share;
	
	            // apply damping
	            if (constraint.damping) {
	                bodyB.positionPrev.x += constraint.damping * normal.x * normalVelocity * share;
	                bodyB.positionPrev.y += constraint.damping * normal.y * normalVelocity * share;
	            }
	
	            // apply torque
	            torque = (Vector.cross(pointB, force) / resistanceTotal) * Constraint._torqueDampen * bodyB.inverseInertia * (1 - constraint.angularStiffness);
	            bodyB.constraintImpulse.angle += torque;
	            bodyB.angle += torque;
	        }
	
	    };
	
	    /**
	     * Performs body updates required after solving constraints.
	     * @private
	     * @method postSolveAll
	     * @param {body[]} bodies
	     */
	    Constraint.postSolveAll = function(bodies) {
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i],
	                impulse = body.constraintImpulse;
	
	            if (body.isStatic || (impulse.x === 0 && impulse.y === 0 && impulse.angle === 0)) {
	                continue;
	            }
	
	            Sleeping.set(body, false);
	
	            // update geometry and reset
	            for (var j = 0; j < body.parts.length; j++) {
	                var part = body.parts[j];
	                
	                Vertices.translate(part.vertices, impulse);
	
	                if (j > 0) {
	                    part.position.x += impulse.x;
	                    part.position.y += impulse.y;
	                }
	
	                if (impulse.angle !== 0) {
	                    Vertices.rotate(part.vertices, impulse.angle, body.position);
	                    Axes.rotate(part.axes, impulse.angle);
	                    if (j > 0) {
	                        Vector.rotateAbout(part.position, impulse.angle, body.position, part.position);
	                    }
	                }
	
	                Bounds.update(part.bounds, part.vertices, body.velocity);
	            }
	
	            // dampen the cached impulse for warming next step
	            impulse.angle *= Constraint._warming;
	            impulse.x *= Constraint._warming;
	            impulse.y *= Constraint._warming;
	        }
	    };
	
	    /*
	    *
	    *  Properties Documentation
	    *
	    */
	
	    /**
	     * An integer `Number` uniquely identifying number generated in `Composite.create` by `Common.nextId`.
	     *
	     * @property id
	     * @type number
	     */
	
	    /**
	     * A `String` denoting the type of object.
	     *
	     * @property type
	     * @type string
	     * @default "constraint"
	     * @readOnly
	     */
	
	    /**
	     * An arbitrary `String` name to help the user identify and manage bodies.
	     *
	     * @property label
	     * @type string
	     * @default "Constraint"
	     */
	
	    /**
	     * An `Object` that defines the rendering properties to be consumed by the module `Matter.Render`.
	     *
	     * @property render
	     * @type object
	     */
	
	    /**
	     * A flag that indicates if the constraint should be rendered.
	     *
	     * @property render.visible
	     * @type boolean
	     * @default true
	     */
	
	    /**
	     * A `Number` that defines the line width to use when rendering the constraint outline.
	     * A value of `0` means no outline will be rendered.
	     *
	     * @property render.lineWidth
	     * @type number
	     * @default 2
	     */
	
	    /**
	     * A `String` that defines the stroke style to use when rendering the constraint outline.
	     * It is the same as when using a canvas, so it accepts CSS style property values.
	     *
	     * @property render.strokeStyle
	     * @type string
	     * @default a random colour
	     */
	
	    /**
	     * A `String` that defines the constraint rendering type. 
	     * The possible values are 'line', 'pin', 'spring'.
	     * An appropriate render type will be automatically chosen unless one is given in options.
	     *
	     * @property render.type
	     * @type string
	     * @default 'line'
	     */
	
	    /**
	     * A `Boolean` that defines if the constraint's anchor points should be rendered.
	     *
	     * @property render.anchors
	     * @type boolean
	     * @default true
	     */
	
	    /**
	     * The first possible `Body` that this constraint is attached to.
	     *
	     * @property bodyA
	     * @type body
	     * @default null
	     */
	
	    /**
	     * The second possible `Body` that this constraint is attached to.
	     *
	     * @property bodyB
	     * @type body
	     * @default null
	     */
	
	    /**
	     * A `Vector` that specifies the offset of the constraint from center of the `constraint.bodyA` if defined, otherwise a world-space position.
	     *
	     * @property pointA
	     * @type vector
	     * @default { x: 0, y: 0 }
	     */
	
	    /**
	     * A `Vector` that specifies the offset of the constraint from center of the `constraint.bodyA` if defined, otherwise a world-space position.
	     *
	     * @property pointB
	     * @type vector
	     * @default { x: 0, y: 0 }
	     */
	
	    /**
	     * A `Number` that specifies the stiffness of the constraint, i.e. the rate at which it returns to its resting `constraint.length`.
	     * A value of `1` means the constraint should be very stiff.
	     * A value of `0.2` means the constraint acts like a soft spring.
	     *
	     * @property stiffness
	     * @type number
	     * @default 1
	     */
	
	    /**
	     * A `Number` that specifies the damping of the constraint, 
	     * i.e. the amount of resistance applied to each body based on their velocities to limit the amount of oscillation.
	     * Damping will only be apparent when the constraint also has a very low `stiffness`.
	     * A value of `0.1` means the constraint will apply heavy damping, resulting in little to no oscillation.
	     * A value of `0` means the constraint will apply no damping.
	     *
	     * @property damping
	     * @type number
	     * @default 0
	     */
	
	    /**
	     * A `Number` that specifies the target resting length of the constraint. 
	     * It is calculated automatically in `Constraint.create` from initial positions of the `constraint.bodyA` and `constraint.bodyB`.
	     *
	     * @property length
	     * @type number
	     */
	
	    /**
	     * An object reserved for storing plugin-specific properties.
	     *
	     * @property plugin
	     * @type {}
	     */
	
	})();


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* The `Matter.Events` module contains methods to fire and listen to events on other objects.
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class Events
	*/
	
	var Events = {};
	
	module.exports = Events;
	
	var Common = __webpack_require__(31);
	
	(function() {
	
	    /**
	     * Subscribes a callback function to the given object's `eventName`.
	     * @method on
	     * @param {} object
	     * @param {string} eventNames
	     * @param {function} callback
	     */
	    Events.on = function(object, eventNames, callback) {
	        var names = eventNames.split(' '),
	            name;
	
	        for (var i = 0; i < names.length; i++) {
	            name = names[i];
	            object.events = object.events || {};
	            object.events[name] = object.events[name] || [];
	            object.events[name].push(callback);
	        }
	
	        return callback;
	    };
	
	    /**
	     * Removes the given event callback. If no callback, clears all callbacks in `eventNames`. If no `eventNames`, clears all events.
	     * @method off
	     * @param {} object
	     * @param {string} eventNames
	     * @param {function} callback
	     */
	    Events.off = function(object, eventNames, callback) {
	        if (!eventNames) {
	            object.events = {};
	            return;
	        }
	
	        // handle Events.off(object, callback)
	        if (typeof eventNames === 'function') {
	            callback = eventNames;
	            eventNames = Common.keys(object.events).join(' ');
	        }
	
	        var names = eventNames.split(' ');
	
	        for (var i = 0; i < names.length; i++) {
	            var callbacks = object.events[names[i]],
	                newCallbacks = [];
	
	            if (callback && callbacks) {
	                for (var j = 0; j < callbacks.length; j++) {
	                    if (callbacks[j] !== callback)
	                        newCallbacks.push(callbacks[j]);
	                }
	            }
	
	            object.events[names[i]] = newCallbacks;
	        }
	    };
	
	    /**
	     * Fires all the callbacks subscribed to the given object's `eventName`, in the order they subscribed, if any.
	     * @method trigger
	     * @param {} object
	     * @param {string} eventNames
	     * @param {} event
	     */
	    Events.trigger = function(object, eventNames, event) {
	        var names,
	            name,
	            callbacks,
	            eventClone;
	
	        if (object.events) {
	            if (!event)
	                event = {};
	
	            names = eventNames.split(' ');
	
	            for (var i = 0; i < names.length; i++) {
	                name = names[i];
	                callbacks = object.events[name];
	
	                if (callbacks) {
	                    eventClone = Common.clone(event, false);
	                    eventClone.name = name;
	                    eventClone.source = object;
	
	                    for (var j = 0; j < callbacks.length; j++) {
	                        callbacks[j].apply(object, [eventClone]);
	                    }
	                }
	            }
	        }
	    };
	
	})();


/***/ }),
/* 145 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Phaser Blend Modes.
	 * 
	 * @name Phaser.BlendModes
	 * @enum {integer}
	 * @memberOf Phaser
	 * @readOnly
	 * @since 3.0.0
	 */
	
	module.exports = {
	
	    /**
	     * Skips the Blend Mode check in the renderer.
	     * 
	     * @name Phaser.BlendModes.SKIP_CHECK
	     */
	    SKIP_CHECK: -1,
	
	    /**
	     * Normal blend mode.
	     * 
	     * @name Phaser.BlendModes.NORMAL
	     */
	    NORMAL: 0,
	
	    /**
	     * Add blend mode.
	     * 
	     * @name Phaser.BlendModes.ADD
	     */
	    ADD: 1,
	
	    /**
	     * Multiply blend mode.
	     * 
	     * @name Phaser.BlendModes.MULTIPLY
	     */
	    MULTIPLY: 2,
	
	    /**
	     * Screen blend mode.
	     * 
	     * @name Phaser.BlendModes.SCREEN
	     */
	    SCREEN: 3,
	
	    /**
	     * Overlay blend mode.
	     * 
	     * @name Phaser.BlendModes.OVERLAY
	     */
	    OVERLAY: 4,
	
	    /**
	     * Darken blend mode.
	     * 
	     * @name Phaser.BlendModes.DARKEN
	     */
	    DARKEN: 5,
	
	    /**
	     * Lighten blend mode.
	     * 
	     * @name Phaser.BlendModes.LIGHTEN
	     */
	    LIGHTEN: 6,
	
	    /**
	     * Color Dodge blend mode.
	     * 
	     * @name Phaser.BlendModes.COLOR_DODGE
	     */
	    COLOR_DODGE: 7,
	
	    /**
	     * Color Burn blend mode.
	     * 
	     * @name Phaser.BlendModes.COLOR_BURN
	     */
	    COLOR_BURN: 8,
	
	    /**
	     * Hard Light blend mode.
	     * 
	     * @name Phaser.BlendModes.HARD_LIGHT
	     */
	    HARD_LIGHT: 9,
	
	    /**
	     * Soft Light blend mode.
	     * 
	     * @name Phaser.BlendModes.SOFT_LIGHT
	     */
	    SOFT_LIGHT: 10,
	
	    /**
	     * Difference blend mode.
	     * 
	     * @name Phaser.BlendModes.DIFFERENCE
	     */
	    DIFFERENCE: 11,
	
	    /**
	     * Exclusion blend mode.
	     * 
	     * @name Phaser.BlendModes.EXCLUSION
	     */
	    EXCLUSION: 12,
	
	    /**
	     * Hue blend mode.
	     * 
	     * @name Phaser.BlendModes.HUE
	     */
	    HUE: 13,
	
	    /**
	     * Saturation blend mode.
	     * 
	     * @name Phaser.BlendModes.SATURATION
	     */
	    SATURATION: 14,
	
	    /**
	     * Color blend mode.
	     * 
	     * @name Phaser.BlendModes.COLOR
	     */
	    COLOR: 15,
	
	    /**
	     * Luminosity blend mode.
	     * 
	     * @name Phaser.BlendModes.LUMINOSITY
	     */
	    LUMINOSITY: 16
	
	};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	
	/**
	 * @callback EachSetCallback
	 * @generic E - [entry]
	 *
	 * @param {*} entry - [description]
	 * @param {number} index - [description]
	 *
	 * @return {?boolean} [description]
	 */
	
	/**
	 * @classdesc
	 * A Set is a collection of unique elements.
	 *
	 * @class Set
	 * @memberOf Phaser.Structs
	 * @constructor
	 * @since 3.0.0
	 *
	 * @generic T
	 * @genericUse {T[]} - [elements]
	 *
	 * @param {Array.<*>} [elements] - [description]
	 */
	var Set = new Class({
	
	    initialize:
	
	    function Set (elements)
	    {
	        /**
	         * [description]
	         *
	         * @genericUse {T[]} - [$type]
	         *
	         * @name Phaser.Structs.Set#entries
	         * @type {Array.<*>}
	         * @default []
	         * @since 3.0.0
	         */
	        this.entries = [];
	
	        if (Array.isArray(elements))
	        {
	            for (var i = 0; i < elements.length; i++)
	            {
	                this.set(elements[i]);
	            }
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.Set#set
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [value]
	     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
	     *
	     * @param {*} value - [description]
	     *
	     * @return {Phaser.Structs.Set} This Set object.
	     */
	    set: function (value)
	    {
	        if (this.entries.indexOf(value) === -1)
	        {
	            this.entries.push(value);
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.Set#get
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [value,$return]
	     *
	     * @param {string} property - [description]
	     * @param {*} value - [description]
	     *
	     * @return {*} [description]
	     */
	    get: function (property, value)
	    {
	        for (var i = 0; i < this.entries.length; i++)
	        {
	            var entry = this.entries[i];
	
	            if (entry[property] === value)
	            {
	                return entry;
	            }
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.Set#getArray
	     * @since 3.0.0
	     *
	     * @genericUse {T[]} - [$return]
	     *
	     * @return {Array.<*>} [description]
	     */
	    getArray: function ()
	    {
	        return this.entries.slice(0);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.Set#delete
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [value]
	     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
	     *
	     * @param {*} value - [description]
	     *
	     * @return {Phaser.Structs.Set} This Set object.
	     */
	    delete: function (value)
	    {
	        var index = this.entries.indexOf(value);
	
	        if (index > -1)
	        {
	            this.entries.splice(index, 1);
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.Set#dump
	     * @since 3.0.0
	     */
	    dump: function ()
	    {
	        // eslint-disable-next-line no-console
	        console.group('Set');
	
	        for (var i = 0; i < this.entries.length; i++)
	        {
	            var entry = this.entries[i];
	            console.log(entry);
	        }
	
	        // eslint-disable-next-line no-console
	        console.groupEnd();
	    },
	
	    /**
	     * For when you know this Set will be modified during the iteration.
	     *
	     * @method Phaser.Structs.Set#each
	     * @since 3.0.0
	     *
	     * @genericUse {EachSetCallback.<T>} - [callback]
	     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
	     *
	     * @param {EachSetCallback} callback - [description]
	     * @param {*} callbackScope - [description]
	     *
	     * @return {Phaser.Structs.Set} This Set object.
	     */
	    each: function (callback, callbackScope)
	    {
	        var i;
	        var temp = this.entries.slice();
	        var len = temp.length;
	
	        if (callbackScope)
	        {
	            for (i = 0; i < len; i++)
	            {
	                if (callback.call(callbackScope, temp[i], i) === false)
	                {
	                    break;
	                }
	            }
	        }
	        else
	        {
	            for (i = 0; i < len; i++)
	            {
	                if (callback(temp[i], i) === false)
	                {
	                    break;
	                }
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * For when you absolutely know this Set won't be modified during the iteration.
	     *
	     * @method Phaser.Structs.Set#iterate
	     * @since 3.0.0
	     *
	     * @genericUse {EachSetCallback.<T>} - [callback]
	     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
	     *
	     * @param {EachSetCallback} callback - [description]
	     * @param {*} callbackScope - [description]
	     *
	     * @return {Phaser.Structs.Set} This Set object.
	     */
	    iterate: function (callback, callbackScope)
	    {
	        var i;
	        var len = this.entries.length;
	
	        if (callbackScope)
	        {
	            for (i = 0; i < len; i++)
	            {
	                if (callback.call(callbackScope, this.entries[i], i) === false)
	                {
	                    break;
	                }
	            }
	        }
	        else
	        {
	            for (i = 0; i < len; i++)
	            {
	                if (callback(this.entries[i], i) === false)
	                {
	                    break;
	                }
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.Set#iterateLocal
	     * @since 3.0.0
	     *
	     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
	     *
	     * @param {string} callbackKey - [description]
	     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
	     *
	     * @return {Phaser.Structs.Set} This Set object.
	     */
	    iterateLocal: function (callbackKey)
	    {
	        var i;
	        var args = [];
	
	        for (i = 1; i < arguments.length; i++)
	        {
	            args.push(arguments[i]);
	        }
	
	        var len = this.entries.length;
	
	        for (i = 0; i < len; i++)
	        {
	            var entry = this.entries[i];
	
	            entry[callbackKey].apply(entry, args);
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.Set#clear
	     * @since 3.0.0
	     *
	     * @genericUse {Phaser.Structs.Set.<T>} - [$return]
	     *
	     * @return {Phaser.Structs.Set} This Set object.
	     */
	    clear: function ()
	    {
	        this.entries.length = 0;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.Set#contains
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [value]
	     *
	     * @param {*} value - [description]
	     *
	     * @return {boolean} [description]
	     */
	    contains: function (value)
	    {
	        return (this.entries.indexOf(value) > -1);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.Set#union
	     * @since 3.0.0
	     *
	     * @genericUse {Phaser.Structs.Set.<T>} - [set,$return]
	     *
	     * @param {Phaser.Structs.Set} set - [description]
	     *
	     * @return {Phaser.Structs.Set} [description]
	     */
	    union: function (set)
	    {
	        var newSet = new Set();
	
	        set.entries.forEach(function (value)
	        {
	            newSet.set(value);
	        });
	
	        this.entries.forEach(function (value)
	        {
	            newSet.set(value);
	        });
	
	        return newSet;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.Set#intersect
	     * @since 3.0.0
	     *
	     * @genericUse {Phaser.Structs.Set.<T>} - [set,$return]
	     *
	     * @param {Phaser.Structs.Set} set - [description]
	     *
	     * @return {Phaser.Structs.Set} [description]
	     */
	    intersect: function (set)
	    {
	        var newSet = new Set();
	
	        this.entries.forEach(function (value)
	        {
	            if (set.contains(value))
	            {
	                newSet.set(value);
	            }
	        });
	
	        return newSet;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.Set#difference
	     * @since 3.0.0
	     *
	     * @genericUse {Phaser.Structs.Set.<T>} - [set,$return]
	     *
	     * @param {Phaser.Structs.Set} set - [description]
	     *
	     * @return {Phaser.Structs.Set} [description]
	     */
	    difference: function (set)
	    {
	        var newSet = new Set();
	
	        this.entries.forEach(function (value)
	        {
	            if (!set.contains(value))
	            {
	                newSet.set(value);
	            }
	        });
	
	        return newSet;
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Structs.Set#size
	     * @type {integer}
	     * @since 3.0.0
	     */
	    size: {
	
	        get: function ()
	        {
	            return this.entries.length;
	        },
	
	        set: function (value)
	        {
	            return this.entries.length = value;
	        }
	
	    }
	
	});
	
	module.exports = Set;


/***/ }),
/* 147 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Utils.Object.HasValue
	 * @since 3.0.0
	 *
	 * @param {object} source - [description]
	 * @param {string} key - [description]
	 *
	 * @return {boolean} [description]
	 */
	var HasValue = function (source, key)
	{
	    return (source.hasOwnProperty(key));
	};
	
	module.exports = HasValue;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Clone = __webpack_require__(123);
	
	/**
	 * Creates a new Object using all values from obj1 and obj2.
	 * If a value exists in both obj1 and obj2, the value in obj1 is used.
	 *
	 * @function Phaser.Utils.Object.Merge
	 * @since 3.0.0
	 *
	 * @param {object} obj1 - [description]
	 * @param {object} obj2 - [description]
	 *
	 * @return {object} [description]
	 */
	var Merge = function (obj1, obj2)
	{
	    var clone = Clone(obj1);
	
	    for (var key in obj2)
	    {
	        if (!clone.hasOwnProperty(key))
	        {
	            clone[key] = obj2[key];
	        }
	    }
	
	    return clone;
	};
	
	module.exports = Merge;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * --------------------------------------------------------------------------
	 * Bootstrap (v4.0.0-alpha.6): util.js
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * --------------------------------------------------------------------------
	 */
	
	var Util = function ($) {
	
	  /**
	   * ------------------------------------------------------------------------
	   * Private TransitionEnd Helpers
	   * ------------------------------------------------------------------------
	   */
	
	  var transition = false;
	
	  var MAX_UID = 1000000;
	
	  var TransitionEndEvent = {
	    WebkitTransition: 'webkitTransitionEnd',
	    MozTransition: 'transitionend',
	    OTransition: 'oTransitionEnd otransitionend',
	    transition: 'transitionend'
	
	    // shoutout AngusCroll (https://goo.gl/pxwQGp)
	  };function toType(obj) {
	    return {}.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
	  }
	
	  function isElement(obj) {
	    return (obj[0] || obj).nodeType;
	  }
	
	  function getSpecialTransitionEndEvent() {
	    return {
	      bindType: transition.end,
	      delegateType: transition.end,
	      handle: function handle(event) {
	        if ($(event.target).is(this)) {
	          return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
	        }
	        return undefined;
	      }
	    };
	  }
	
	  function transitionEndTest() {
	    if (window.QUnit) {
	      return false;
	    }
	
	    var el = document.createElement('bootstrap');
	
	    for (var name in TransitionEndEvent) {
	      if (el.style[name] !== undefined) {
	        return {
	          end: TransitionEndEvent[name]
	        };
	      }
	    }
	
	    return false;
	  }
	
	  function transitionEndEmulator(duration) {
	    var _this = this;
	
	    var called = false;
	
	    $(this).one(Util.TRANSITION_END, function () {
	      called = true;
	    });
	
	    setTimeout(function () {
	      if (!called) {
	        Util.triggerTransitionEnd(_this);
	      }
	    }, duration);
	
	    return this;
	  }
	
	  function setTransitionEndSupport() {
	    transition = transitionEndTest();
	
	    $.fn.emulateTransitionEnd = transitionEndEmulator;
	
	    if (Util.supportsTransitionEnd()) {
	      $.event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
	    }
	  }
	
	  /**
	   * --------------------------------------------------------------------------
	   * Public Util Api
	   * --------------------------------------------------------------------------
	   */
	
	  var Util = {
	
	    TRANSITION_END: 'bsTransitionEnd',
	
	    getUID: function getUID(prefix) {
	      do {
	        // eslint-disable-next-line no-bitwise
	        prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
	      } while (document.getElementById(prefix));
	      return prefix;
	    },
	    getSelectorFromElement: function getSelectorFromElement(element) {
	      var selector = element.getAttribute('data-target');
	      if (!selector || selector === '#') {
	        selector = element.getAttribute('href') || '';
	      }
	
	      try {
	        var $selector = $(selector);
	        return $selector.length > 0 ? selector : null;
	      } catch (error) {
	        return null;
	      }
	    },
	    reflow: function reflow(element) {
	      return element.offsetHeight;
	    },
	    triggerTransitionEnd: function triggerTransitionEnd(element) {
	      $(element).trigger(transition.end);
	    },
	    supportsTransitionEnd: function supportsTransitionEnd() {
	      return Boolean(transition);
	    },
	    typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
	      for (var property in configTypes) {
	        if (configTypes.hasOwnProperty(property)) {
	          var expectedTypes = configTypes[property];
	          var value = config[property];
	          var valueType = value && isElement(value) ? 'element' : toType(value);
	
	          if (!new RegExp(expectedTypes).test(valueType)) {
	            throw new Error(componentName.toUpperCase() + ': ' + ('Option "' + property + '" provided type "' + valueType + '" ') + ('but expected type "' + expectedTypes + '".'));
	          }
	        }
	      }
	    }
	  };
	
	  setTransitionEndSupport();
	
	  return Util;
	}(jQuery);
	
	exports.default = Util;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(58);
	var TAG = __webpack_require__(16)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(58);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 152 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	"use strict";
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	
	return camelCase;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(262),
		__webpack_require__(111),
		__webpack_require__(153),
		__webpack_require__(32),
		__webpack_require__(263),
		__webpack_require__(254),
		__webpack_require__(253),
		__webpack_require__(422),
		__webpack_require__(424),
		__webpack_require__(421),
		__webpack_require__(420),
		__webpack_require__(419),
		__webpack_require__(252),
	
		__webpack_require__(62),
		__webpack_require__(417),
		__webpack_require__(41) // contains
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, pnum, access, camelCase, document, rcssNum, rnumnonpx, cssExpand,
		getStyles, swap, curCSS, adjustCSS, addGetHookIf, support ) {
	
	"use strict";
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a property mapped along what jQuery.cssProps suggests or to
	// a vendor prefixed property.
	function finalPropName( name ) {
		var ret = jQuery.cssProps[ name ];
		if ( !ret ) {
			ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
		}
		return ret;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
			) );
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
			val = curCSS( elem, dimension, styles ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox;
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = valueIsBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ dimension ] );
	
		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		if ( val === "auto" ||
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {
	
			val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];
	
			// offsetWidth/offsetHeight provide border-box values
			valueIsBorderBox = true;
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, dimension, extra );
							} ) :
							getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
					isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra && boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					);
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && support.scrollboxSize() === styles.position ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return [];
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Determines the operating system of the device running this Phaser Game instance.
	 * These values are read-only and populated during the boot sequence of the game.
	 * They are then referenced by internal game systems and are available for you to access
	 * via `this.sys.game.device.os` from within any Scene.
	 * 
	 * @typedef {object} Phaser.Device.OS
	 * @since 3.0.0
	 * 
	 * @property {boolean} android - Is running on android?
	 * @property {boolean} chromeOS - Is running on chromeOS?
	 * @property {boolean} cocoonJS - Is the game running under CocoonJS?
	 * @property {boolean} cocoonJSApp - Is this game running with CocoonJS.App?
	 * @property {boolean} cordova - Is the game running under Apache Cordova?
	 * @property {boolean} crosswalk - Is the game running under the Intel Crosswalk XDK?
	 * @property {boolean} desktop - Is running on a desktop?
	 * @property {boolean} ejecta - Is the game running under Ejecta?
	 * @property {boolean} electron - Is the game running under GitHub Electron?
	 * @property {boolean} iOS - Is running on iOS?
	 * @property {boolean} iPad - Is running on iPad?
	 * @property {boolean} iPhone - Is running on iPhone?
	 * @property {boolean} kindle - Is running on an Amazon Kindle?
	 * @property {boolean} linux - Is running on linux?
	 * @property {boolean} macOS - Is running on macOS?
	 * @property {boolean} node - Is the game running under Node.js?
	 * @property {boolean} nodeWebkit - Is the game running under Node-Webkit?
	 * @property {boolean} webApp - Set to true if running as a WebApp, i.e. within a WebView
	 * @property {boolean} windows - Is running on windows?
	 * @property {boolean} windowsPhone - Is running on a Windows Phone?
	 * @property {number} iOSVersion - If running in iOS this will contain the major version number.
	 * @property {number} pixelRatio - PixelRatio of the host device?
	 */
	var OS = {
	
	    android: false,
	    chromeOS: false,
	    cocoonJS: false,
	    cocoonJSApp: false,
	    cordova: false,
	    crosswalk: false,
	    desktop: false,
	    ejecta: false,
	    electron: false,
	    iOS: false,
	    iOSVersion: 0,
	    iPad: false,
	    iPhone: false,
	    kindle: false,
	    linux: false,
	    macOS: false,
	    node: false,
	    nodeWebkit: false,
	    pixelRatio: 1,
	    webApp: false,
	    windows: false,
	    windowsPhone: false
	
	};
	
	function init ()
	{
	    var ua = navigator.userAgent;
	
	    if (/Windows/.test(ua))
	    {
	        OS.windows = true;
	    }
	    else if (/Mac OS/.test(ua))
	    {
	        OS.macOS = true;
	    }
	    else if (/Linux/.test(ua))
	    {
	        OS.linux = true;
	    }
	    else if (/Android/.test(ua))
	    {
	        OS.android = true;
	    }
	    else if (/iP[ao]d|iPhone/i.test(ua))
	    {
	        OS.iOS = true;
	        (navigator.appVersion).match(/OS (\d+)/);
	        OS.iOSVersion = parseInt(RegExp.$1, 10);
	    }
	    else if (/Kindle/.test(ua) || (/\bKF[A-Z][A-Z]+/).test(ua) || (/Silk.*Mobile Safari/).test(ua))
	    {
	        OS.kindle = true;
	
	        // This will NOT detect early generations of Kindle Fire, I think there is no reliable way...
	        // E.g. "Mozilla/5.0 (Macintosh; U; Intel Mac OS X 10_6_3; en-us; Silk/1.1.0-80) AppleWebKit/533.16 (KHTML, like Gecko) Version/5.0 Safari/533.16 Silk-Accelerated=true"
	    }
	    else if (/CrOS/.test(ua))
	    {
	        OS.chromeOS = true;
	    }
	
	    if (/Windows Phone/i.test(ua) || (/IEMobile/i).test(ua))
	    {
	        OS.android = false;
	        OS.iOS = false;
	        OS.macOS = false;
	        OS.windows = true;
	        OS.windowsPhone = true;
	    }
	
	    var silk = (/Silk/).test(ua);
	
	    if (OS.windows || OS.macOS || (OS.linux && !silk) || OS.chromeOS)
	    {
	        OS.desktop = true;
	    }
	
	    //  Windows Phone / Table reset
	    if (OS.windowsPhone || ((/Windows NT/i.test(ua)) && (/Touch/i.test(ua))))
	    {
	        OS.desktop = false;
	    }
	
	    //  WebApp mode in iOS
	    if (navigator.standalone)
	    {
	        OS.webApp = true;
	    }
	    
	    if (window.cordova !== undefined)
	    {
	        OS.cordova = true;
	    }
	    
	    if (process && process.versions && process.versions.node)
	    {
	        OS.node = true;
	    }
	    
	    if (OS.node && typeof process.versions === 'object')
	    {
	        OS.nodeWebkit = !!process.versions['node-webkit'];
	        
	        OS.electron = !!process.versions.electron;
	    }
	    
	    if (navigator.isCocoonJS)
	    {
	        OS.cocoonJS = true;
	
	        try
	        {
	            OS.cocoonJSApp = (typeof CocoonJS !== 'undefined');
	        }
	        catch (error)
	        {
	            OS.cocoonJSApp = false;
	        }
	    }
	
	    if (window.ejecta !== undefined)
	    {
	        OS.ejecta = true;
	    }
	
	    if ((/Crosswalk/).test(ua))
	    {
	        OS.crosswalk = true;
	    }
	
	    OS.iPhone = ua.toLowerCase().indexOf('iphone') !== -1;
	    OS.iPad = ua.toLowerCase().indexOf('ipad') !== -1;
	
	    OS.pixelRatio = window['devicePixelRatio'] || 1;
	
	    return OS;
	}
	
	module.exports = init();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1621)))

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class TransformMatrix
	 * @memberOf Phaser.GameObjects.Components
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {number} [a=1] - The Scale X value.
	 * @param {number} [b=0] - The Shear Y value.
	 * @param {number} [c=0] - The Shear X value.
	 * @param {number} [d=1] - The Scale Y value.
	 * @param {number} [tx=0] - The Translate X value.
	 * @param {number} [ty=0] - The Translate Y value.
	 */
	var TransformMatrix = new Class({
	
	    initialize:
	
	    function TransformMatrix (a, b, c, d, tx, ty)
	    {
	        if (a === undefined) { a = 1; }
	        if (b === undefined) { b = 0; }
	        if (c === undefined) { c = 0; }
	        if (d === undefined) { d = 1; }
	        if (tx === undefined) { tx = 0; }
	        if (ty === undefined) { ty = 0; }
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Components.TransformMatrix#matrix
	         * @type {Float32Array}
	         * @since 3.0.0
	         */
	        this.matrix = new Float32Array([ a, b, c, d, tx, ty, 0, 0, 1 ]);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Components.TransformMatrix#decomposedMatrix
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.decomposedMatrix = {
	            translateX: 0,
	            translateY: 0,
	            scaleX: 1,
	            scaleY: 1,
	            rotation: 0
	        };
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.GameObjects.Components.TransformMatrix#a
	     * @type {number}
	     * @since 3.4.0
	     */
	    a: {
	
	        get: function ()
	        {
	            return this.matrix[0];
	        },
	
	        set: function (value)
	        {
	            this.matrix[0] = value;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.GameObjects.Components.TransformMatrix#b
	     * @type {number}
	     * @since 3.4.0
	     */
	    b: {
	
	        get: function ()
	        {
	            return this.matrix[1];
	        },
	
	        set: function (value)
	        {
	            this.matrix[1] = value;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.GameObjects.Components.TransformMatrix#c
	     * @type {number}
	     * @since 3.4.0
	     */
	    c: {
	
	        get: function ()
	        {
	            return this.matrix[2];
	        },
	
	        set: function (value)
	        {
	            this.matrix[2] = value;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.GameObjects.Components.TransformMatrix#d
	     * @type {number}
	     * @since 3.4.0
	     */
	    d: {
	
	        get: function ()
	        {
	            return this.matrix[3];
	        },
	
	        set: function (value)
	        {
	            this.matrix[3] = value;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.GameObjects.Components.TransformMatrix#tx
	     * @type {number}
	     * @since 3.4.0
	     */
	    tx: {
	
	        get: function ()
	        {
	            return this.matrix[4];
	        },
	
	        set: function (value)
	        {
	            this.matrix[4] = value;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.GameObjects.Components.TransformMatrix#ty
	     * @type {number}
	     * @since 3.4.0
	     */
	    ty: {
	
	        get: function ()
	        {
	            return this.matrix[5];
	        },
	
	        set: function (value)
	        {
	            this.matrix[5] = value;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.GameObjects.Components.TransformMatrix#rotation
	     * @type {number}
	     * @readOnly
	     * @since 3.4.0
	     */
	    rotation: {
	
	        get: function ()
	        {
	            return Math.acos(this.a / this.scaleX) * (Math.atan(-this.c / this.a) < 0 ? -1 : 1);
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.GameObjects.Components.TransformMatrix#scaleX
	     * @type {number}
	     * @readOnly
	     * @since 3.4.0
	     */
	    scaleX: {
	
	        get: function ()
	        {
	            return Math.sqrt((this.a * this.a) + (this.c * this.c));
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.GameObjects.Components.TransformMatrix#scaleY
	     * @type {number}
	     * @readOnly
	     * @since 3.4.0
	     */
	    scaleY: {
	
	        get: function ()
	        {
	            return Math.sqrt((this.b * this.b) + (this.d * this.d));
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Components.TransformMatrix#loadIdentity
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Components.TransformMatrix} This TransformMatrix.
	     */
	    loadIdentity: function ()
	    {
	        var matrix = this.matrix;
	
	        matrix[0] = 1;
	        matrix[1] = 0;
	        matrix[2] = 0;
	        matrix[3] = 1;
	        matrix[4] = 0;
	        matrix[5] = 0;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Components.TransformMatrix#translate
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     *
	     * @return {Phaser.GameObjects.Components.TransformMatrix} This TransformMatrix.
	     */
	    translate: function (x, y)
	    {
	        var matrix = this.matrix;
	
	        matrix[4] = matrix[0] * x + matrix[2] * y + matrix[4];
	        matrix[5] = matrix[1] * x + matrix[3] * y + matrix[5];
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Components.TransformMatrix#scale
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     *
	     * @return {Phaser.GameObjects.Components.TransformMatrix} This TransformMatrix.
	     */
	    scale: function (x, y)
	    {
	        var matrix = this.matrix;
	
	        matrix[0] *= x;
	        matrix[1] *= x;
	        matrix[2] *= y;
	        matrix[3] *= y;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Components.TransformMatrix#rotate
	     * @since 3.0.0
	     *
	     * @param {number} radian - [description]
	     *
	     * @return {Phaser.GameObjects.Components.TransformMatrix} This TransformMatrix.
	     */
	    rotate: function (radian)
	    {
	        var radianSin = Math.sin(radian);
	        var radianCos = Math.cos(radian);
	        var matrix = this.matrix;
	        var a = matrix[0];
	        var b = matrix[1];
	        var c = matrix[2];
	        var d = matrix[3];
	
	        matrix[0] = a * radianCos + c * radianSin;
	        matrix[1] = b * radianCos + d * radianSin;
	        matrix[2] = a * -radianSin + c * radianCos;
	        matrix[3] = b * -radianSin + d * radianCos;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Components.TransformMatrix#multiply
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Components.TransformMatrix} rhs - [description]
	     *
	     * @return {Phaser.GameObjects.Components.TransformMatrix} This TransformMatrix.
	     */
	    multiply: function (rhs)
	    {
	        var matrix = this.matrix;
	        var otherMatrix = rhs.matrix;
	
	        var a0 = matrix[0];
	        var b0 = matrix[1];
	        var c0 = matrix[2];
	        var d0 = matrix[3];
	        var tx0 = matrix[4];
	        var ty0 = matrix[5];
	
	        var a1 = otherMatrix[0];
	        var b1 = otherMatrix[1];
	        var c1 = otherMatrix[2];
	        var d1 = otherMatrix[3];
	        var tx1 = otherMatrix[4];
	        var ty1 = otherMatrix[5];
	
	        matrix[0] = a1 * a0 + b1 * c0;
	        matrix[1] = a1 * b0 + b1 * d0;
	        matrix[2] = c1 * a0 + d1 * c0;
	        matrix[3] = c1 * b0 + d1 * d0;
	        matrix[4] = tx1 * a0 + ty1 * c0 + tx0;
	        matrix[5] = tx1 * b0 + ty1 * d0 + ty0;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Components.TransformMatrix#transform
	     * @since 3.0.0
	     *
	     * @param {number} a - The Scale X value.
	     * @param {number} b - The Shear Y value.
	     * @param {number} c - The Shear X value.
	     * @param {number} d - The Scale Y value.
	     * @param {number} tx - The Translate X value.
	     * @param {number} ty - The Translate Y value.
	     *
	     * @return {Phaser.GameObjects.Components.TransformMatrix} This TransformMatrix.
	     */
	    transform: function (a, b, c, d, tx, ty)
	    {
	        var matrix = this.matrix;
	
	        var a0 = matrix[0];
	        var b0 = matrix[1];
	        var c0 = matrix[2];
	        var d0 = matrix[3];
	        var tx0 = matrix[4];
	        var ty0 = matrix[5];
	
	        matrix[0] = a * a0 + b * c0;
	        matrix[1] = a * b0 + b * d0;
	        matrix[2] = c * a0 + d * c0;
	        matrix[3] = c * b0 + d * d0;
	        matrix[4] = tx * a0 + ty * c0 + tx0;
	        matrix[5] = tx * b0 + ty * d0 + ty0;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Components.TransformMatrix#transformPoint
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {(Phaser.Geom.Point|Phaser.Math.Vector2|object)} point - [description]
	     *
	     * @return {(Phaser.Geom.Point|Phaser.Math.Vector2|object)} [description]
	     */
	    transformPoint: function (x, y, point)
	    {
	        if (point === undefined) { point = { x: 0, y: 0 }; }
	
	        var matrix = this.matrix;
	
	        var a = matrix[0];
	        var b = matrix[1];
	        var c = matrix[2];
	        var d = matrix[3];
	        var tx = matrix[4];
	        var ty = matrix[5];
	
	        point.x = x * a + y * c + tx;
	        point.y = x * b + y * d + ty;
	
	        return point;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Components.TransformMatrix#invert
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Components.TransformMatrix} This TransformMatrix.
	     */
	    invert: function ()
	    {
	        var matrix = this.matrix;
	
	        var a = matrix[0];
	        var b = matrix[1];
	        var c = matrix[2];
	        var d = matrix[3];
	        var tx = matrix[4];
	        var ty = matrix[5];
	
	        var n = a * d - b * c;
	
	        matrix[0] = d / n;
	        matrix[1] = -b / n;
	        matrix[2] = -c / n;
	        matrix[3] = a / n;
	        matrix[4] = (c * ty - d * tx) / n;
	        matrix[5] = -(a * ty - b * tx) / n;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Components.TransformMatrix#setTransform
	     * @since 3.0.0
	     *
	     * @param {number} a - [description]
	     * @param {number} b - [description]
	     * @param {number} c - [description]
	     * @param {number} d - [description]
	     * @param {number} tx - [description]
	     * @param {number} ty - [description]
	     *
	     * @return {Phaser.GameObjects.Components.TransformMatrix} This TransformMatrix.
	     */
	    setTransform: function (a, b, c, d, tx, ty)
	    {
	        var matrix = this.matrix;
	
	        matrix[0] = a;
	        matrix[1] = b;
	        matrix[2] = c;
	        matrix[3] = d;
	        matrix[4] = tx;
	        matrix[5] = ty;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Components.TransformMatrix#decomposeMatrix
	     * @since 3.0.0
	     *
	     * @return {object} [description]
	     */
	    decomposeMatrix: function ()
	    {
	        var decomposedMatrix = this.decomposedMatrix;
	
	        var matrix = this.matrix;
	
	        //  a = scale X (1)
	        //  b = shear Y (0)
	        //  c = shear X (0)
	        //  d = scale Y (1)
	
	        var a = matrix[0];
	        var b = matrix[1];
	        var c = matrix[2];
	        var d = matrix[3];
	
	        var a2 = a * a;
	        var b2 = b * b;
	        var c2 = c * c;
	        var d2 = d * d;
	
	        var sx = Math.sqrt(a2 + c2);
	        var sy = Math.sqrt(b2 + d2);
	
	        decomposedMatrix.translateX = matrix[4];
	        decomposedMatrix.translateY = matrix[5];
	
	        decomposedMatrix.scaleX = sx;
	        decomposedMatrix.scaleY = sy;
	
	        decomposedMatrix.rotation = Math.acos(a / sx) * (Math.atan(-c / a) < 0 ? -1 : 1);
	
	        return decomposedMatrix;
	    },
	
	    /**
	     * Identity + Translate + Rotate + Scale
	     *
	     * @method Phaser.GameObjects.Components.TransformMatrix#applyITRS
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} rotation - [description]
	     * @param {number} scaleX - [description]
	     * @param {number} scaleY - [description]
	     *
	     * @return {Phaser.GameObjects.Components.TransformMatrix} This TransformMatrix.
	     */
	    applyITRS: function (x, y, rotation, scaleX, scaleY)
	    {
	        var matrix = this.matrix;
	
	        var radianSin = Math.sin(rotation);
	        var radianCos = Math.cos(rotation);
	
	        // Translate
	        matrix[4] = x;
	        matrix[5] = y;
	
	        // Rotate and Scale
	        matrix[0] = radianCos * scaleX;
	        matrix[1] = radianSin * scaleX;
	        matrix[2] = -radianSin * scaleY;
	        matrix[3] = radianCos * scaleY;
	
	        return this;
	    },
	
	    /**
	     * Destroys this Transform Matrix.
	     *
	     * @method Phaser.GameObjects.Components.TransformMatrix#destroy
	     * @since 3.4.0
	     */
	    destroy: function ()
	    {
	        this.matrix = null;
	        this.decomposedMatrix = null;
	    }
	
	});
	
	module.exports = TransformMatrix;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Actions = __webpack_require__(441);
	var Class = __webpack_require__(1);
	var GetFastValue = __webpack_require__(3);
	var GetValue = __webpack_require__(10);
	var Range = __webpack_require__(659);
	var Set = __webpack_require__(146);
	var Sprite = __webpack_require__(82);
	
	/**
	 * @callback GroupCallback
	 *
	 * @param {Phaser.GameObjects.GameObject} item - A group member
	 */
	
	/**
	 * @callback GroupMultipleCreateCallback
	 *
	 * @param {Phaser.GameObjects.GameObject[]} items - The newly created group members
	 */
	
	/**
	 * @typedef {object} GroupConfig
	 *
	 * @property {?object} [classType=Sprite] - Sets {@link Phaser.GameObjects.Group#classType}.
	 * @property {?boolean} [active=true] - Sets {@link Phaser.GameObjects.Group#active}.
	 * @property {?number} [maxSize=-1] - Sets {@link Phaser.GameObjects.Group#maxSize}.
	 * @property {?string} [defaultKey=null] - Sets {@link Phaser.GameObjects.Group#defaultKey}.
	 * @property {?(string|integer)} [defaultFrame=null] - Sets {@link Phaser.GameObjects.Group#defaultFrame}.
	 * @property {?boolean} [runChildUpdate=false] - Sets {@link Phaser.GameObjects.Group#runChildUpdate}.
	 * @property {?GroupCallback} [createCallback=null] - Sets {@link Phaser.GameObjects.Group#createCallback}.
	 * @property {?GroupCallback} [removeCallback=null] - Sets {@link Phaser.GameObjects.Group#removeCallback}.
	 * @property {?GroupMultipleCreateCallback} [createMultipleCallback=null] - Sets {@link Phaser.GameObjects.Group#createMultipleCallback}.
	 */
	
	/**
	 * @typedef {object} GroupCreateConfig
	 *
	 * The total number of objects created will be
	 *
	 *     key.length * frame.length * frameQuantity * (yoyo ? 2 : 1) * (1 + repeat)
	 *
	 * In the simplest case, 1 + `repeat` objects will be created.
	 *
	 * If `max` is positive, then the total created will not exceed `max`.
	 *
	 * `key` is required. {@link Phaser.GameObjects.Group#defaultKey} is not used.
	 *
	 * @property {?object} [classType] - The class of each new Game Object.
	 * @property {string} [key] - The texture key of each new Game Object.
	 * @property {?(string|integer)} [frame=null] - The texture frame of each new Game Object.
	 * @property {?boolean} [visible=true] - The visible state of each new Game Object.
	 * @property {?boolean} [active=true] - The active state of each new Game Object.
	 * @property {?number} [repeat=0] - The number of times each `key` × `frame` combination will be *repeated* (after the first combination).
	 * @property {?boolean} [randomKey=false] - Select a `key` at random.
	 * @property {?boolean} [randomFrame=false] - Select a `frame` at random.
	 * @property {?boolean} [yoyo=false] - Select keys and frames by moving forward then backward through `key` and `frame`.
	 * @property {?number} [frameQuantity=1] - The number of times each `frame` should be combined with one `key`.
	 * @property {?number} [max=0] - The maximum number of new Game Objects to create. 0 is no maximum.
	 * @property {?object} [setXY]
	 * @property {?number} [setXY.x=0] - The horizontal position of each new Game Object.
	 * @property {?number} [setXY.y=0] - The vertical position of each new Game Object.
	 * @property {?number} [setXY.stepX=0] - Increment each Game Object's horizontal position from the previous by this amount, starting from `setXY.x`.
	 * @property {?number} [setXY.stepY=0] - Increment each Game Object's vertical position from the previous by this amount, starting from `setXY.y`.
	 * @property {?object} [setRotation]
	 * @property {?number} [setRotation.value=0] - Rotation of each new Game Object.
	 * @property {?number} [setRotation.step=0] - Increment each Game Object's rotation from the previous by this amount, starting at `setRotation.value`.
	 * @property {?object} [setScale]
	 * @property {?number} [setScale.x=0] - The horizontal scale of each new Game Object.
	 * @property {?number} [setScale.y=0] - The vertical scale of each new Game Object.
	 * @property {?number} [setScale.stepX=0] - Increment each Game Object's horizontal scale from the previous by this amount, starting from `setScale.x`.
	 * @property {?number} [setScale.stepY=0] - Increment each Game object's vertical scale from the previous by this amount, starting from `setScale.y`.
	 * @property {?object} [setAlpha]
	 * @property {?number} [setAlpha.value=0] - The alpha value of each new Game Object.
	 * @property {?number} [setAlpha.step=0] - Increment each Game Object's alpha from the previous by this amount, starting from `setAlpha.value`.
	 * @property {?*} [hitArea] - A geometric shape that defines the hit area for the Game Object.
	 * @property {?HitAreaCallback} [hitAreaCallback] - A callback to be invoked when the Game Object is interacted with.
	 * @property {?(false|GridAlignConfig)} [gridAlign=false] - Align the new Game Objects in a grid using these settings.
	 *
	 * @see Phaser.Actions.GridAlign
	 * @see Phaser.Actions.SetAlpha
	 * @see Phaser.Actions.SetHitArea
	 * @see Phaser.Actions.SetRotation
	 * @see Phaser.Actions.SetScale
	 * @see Phaser.Actions.SetXY
	 * @see Phaser.GameObjects.Group#createFromConfig
	 * @see Phaser.Utils.Array.Range
	 */
	
	/**
	 * @classdesc A Group is a way for you to create, manipulate, or recycle similar Game Objects.
	 *
	 * Group membership is non-exclusive. A Game Object can belong to several groups, one group, or none.
	 *
	 * Groups themselves aren't displayable, and can't be positioned, rotated, scaled, or hidden.
	 *
	 * @class Group
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @since 3.0.0
	 * @param {Phaser.Scene} scene - The scene this group belongs to.
	 * @param {(Phaser.GameObjects.GameObject[]|GroupConfig)} [children] - Game objects to add to this group; or the `config` argument.
	 * @param {GroupConfig|GroupCreateConfig} [config] - Settings for this group. If `key` is set, Phaser.GameObjects.Group#createMultiple is also called with these settings.
	 *
	 * @see Phaser.Physics.Arcade.Group
	 * @see Phaser.Physics.Arcade.StaticGroup
	 */
	var Group = new Class({
	
	    initialize:
	
	    function Group (scene, children, config)
	    {
	        if (config === undefined && !Array.isArray(children) && typeof children === 'object')
	        {
	            config = children;
	            children = null;
	        }
	
	        /**
	         * This scene this group belongs to.
	         *
	         * @name Phaser.GameObjects.Group#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * Members of this group.
	         *
	         * @name Phaser.GameObjects.Group#children
	         * @type {Phaser.Structs.Set.<Phaser.GameObjects.GameObject>}
	         * @since 3.0.0
	         */
	        this.children = new Set(children);
	
	        /**
	         * A flag identifying this object as a group.
	         *
	         * @name Phaser.GameObjects.Group#isParent
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.isParent = true;
	
	        /**
	         * The class to create new group members from.
	         *
	         * @name Phaser.GameObjects.Group#classType
	         * @type {object}
	         * @since 3.0.0
	         * @default Phaser.GameObjects.Sprite
	         */
	        this.classType = GetFastValue(config, 'classType', Sprite);
	
	        /**
	         * Whether this group runs its {@link Phaser.GameObjects.Group#preUpdate} method
	         * (which may update any members).
	         *
	         * @name Phaser.GameObjects.Group#active
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.active = GetFastValue(config, 'active', true);
	
	        /**
	         * The maximum size of this group, if used as a pool. -1 is no limit.
	         *
	         * @name Phaser.GameObjects.Group#maxSize
	         * @type {integer}
	         * @since 3.0.0
	         * @default -1
	         */
	        this.maxSize = GetFastValue(config, 'maxSize', -1);
	
	        /**
	         * A default texture key to use when creating new group members.
	         *
	         * This is used in {@link Phaser.GameObjects.Group#create}
	         * but not in {@link Phaser.GameObjects.Group#createMultiple}.
	         *
	         * @name Phaser.GameObjects.Group#defaultKey
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.defaultKey = GetFastValue(config, 'defaultKey', null);
	
	        /**
	         * A default texture frame to use when creating new group members.
	         *
	         * @name Phaser.GameObjects.Group#defaultFrame
	         * @type {(string|integer)}
	         * @since 3.0.0
	         */
	        this.defaultFrame = GetFastValue(config, 'defaultFrame', null);
	
	        /**
	         * Whether to call the update method of any members.
	         *
	         * @name Phaser.GameObjects.Group#runChildUpdate
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Group#preUpdate
	         */
	        this.runChildUpdate = GetFastValue(config, 'runChildUpdate', false);
	
	        /**
	         * A function to be called when adding or creating group members.
	         *
	         * @name Phaser.GameObjects.Group#createCallback
	         * @type {?GroupCallback}
	         * @since 3.0.0
	         */
	        this.createCallback = GetFastValue(config, 'createCallback', null);
	
	        /**
	         * A function to be called when removing group members.
	         *
	         * @name Phaser.GameObjects.Group#removeCallback
	         * @type {?GroupCallback}
	         * @since 3.0.0
	         */
	        this.removeCallback = GetFastValue(config, 'removeCallback', null);
	
	        /**
	         * A function to be called when creating several group members at once.
	         *
	         * @name Phaser.GameObjects.Group#createMultipleCallback
	         * @type {?GroupMultipleCreateCallback}
	         * @since 3.0.0
	         */
	        this.createMultipleCallback = GetFastValue(config, 'createMultipleCallback', null);
	
	        if (config)
	        {
	            this.createMultiple(config);
	        }
	    },
	
	    /**
	     * Creates a new Game Object and adds it to this group, unless the group {@link Phaser.GameObjects.Group#isFull is full}.
	     *
	     * Calls {@link Phaser.GameObjects.Group#createCallback}.
	     *
	     * @method Phaser.GameObjects.Group#create
	     * @since 3.0.0
	     *
	     * @param {number} [x=0] - The horizontal position of the new Game Object in the world.
	     * @param {number} [y=0] - The vertical position of the new Game Object in the world.
	     * @param {string} [key=defaultKey] - The texture key of the new Game Object.
	     * @param {(string|integer)} [frame=defaultFrame] - The texture frame of the new Game Object.
	     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of the new Game Object.
	     * @param {boolean} [active=true] - The {@link Phaser.GameObjects.GameObject#active} state of the new Game Object.
	     *
	     * @return {Phaser.GameObjects.GameObject} The new Game Object.
	     */
	    create: function (x, y, key, frame, visible, active)
	    {
	        if (x === undefined) { x = 0; }
	        if (y === undefined) { y = 0; }
	        if (key === undefined) { key = this.defaultKey; }
	        if (frame === undefined) { frame = this.defaultFrame; }
	        if (visible === undefined) { visible = true; }
	        if (active === undefined) { active = true; }
	
	        //  Pool?
	        if (this.isFull())
	        {
	            return null;
	        }
	
	        var child = new this.classType(this.scene, x, y, key, frame);
	
	        this.scene.sys.displayList.add(child);
	
	        if (child.preUpdate)
	        {
	            this.scene.sys.updateList.add(child);
	        }
	
	        child.visible = visible;
	        child.setActive(active);
	
	        this.add(child);
	
	        return child;
	    },
	
	    /**
	     * Creates several Game Objects and adds them to this group.
	     *
	     * If the group becomes {@link Phaser.GameObjects.Group#isFull}, no further Game Objects are created.
	     *
	     * Calls {@link Phaser.GameObjects.Group#createMultipleCallback} and {@link Phaser.GameObjects.Group#createCallback}.
	     *
	     * @method Phaser.GameObjects.Group#createMultiple
	     * @since 3.0.0
	     *
	     * @param {GroupCreateConfig|GroupCreateConfig[]} config - Creation settings. This can be a single configuration object or an array of such objects, which will be applied in turn.
	     *
	     * @return {Phaser.GameObjects.GameObject[]} The newly created Game Objects.
	     */
	    createMultiple: function (config)
	    {
	        if (this.isFull())
	        {
	            return [];
	        }
	
	        if (!Array.isArray(config))
	        {
	            config = [ config ];
	        }
	
	        if (config[0].key === undefined)
	        {
	            return [];
	        }
	
	        var output = [];
	
	        for (var i = 0; i < config.length; i++)
	        {
	            var entries = this.createFromConfig(config[i]);
	
	            output = output.concat(entries);
	        }
	
	        return output;
	    },
	
	    /**
	     * A helper for {@link Phaser.GameObjects.Group#createMultiple}.
	     *
	     * @method Phaser.GameObjects.Group#createFromConfig
	     * @since 3.0.0
	     *
	     * @param {GroupCreateConfig} options - Creation settings.
	     *
	     * @return {Phaser.GameObjects.GameObject[]} The newly created Game Objects.
	     */
	    createFromConfig: function (options)
	    {
	        if (this.isFull())
	        {
	            return [];
	        }
	
	        this.classType = GetFastValue(options, 'classType', this.classType);
	
	        var key = GetFastValue(options, 'key', undefined);
	        var frame = GetFastValue(options, 'frame', null);
	        var visible = GetFastValue(options, 'visible', true);
	        var active = GetFastValue(options, 'active', true);
	
	        var entries = [];
	
	        //  Can't do anything without at least a key
	        if (key === undefined)
	        {
	            return entries;
	        }
	        else
	        {
	            if (!Array.isArray(key))
	            {
	                key = [ key ];
	            }
	
	            if (!Array.isArray(frame))
	            {
	                frame = [ frame ];
	            }
	        }
	
	        //  Build an array of key frame pairs to loop through
	
	        var repeat = GetFastValue(options, 'repeat', 0);
	        var randomKey = GetFastValue(options, 'randomKey', false);
	        var randomFrame = GetFastValue(options, 'randomFrame', false);
	        var yoyo = GetFastValue(options, 'yoyo', false);
	        var quantity = GetFastValue(options, 'frameQuantity', 1);
	        var max = GetFastValue(options, 'max', 0);
	
	        //  If a grid is set we use that to override the quantity?
	
	        var range = Range(key, frame, {
	            max: max,
	            qty: quantity,
	            random: randomKey,
	            randomB: randomFrame,
	            repeat: repeat,
	            yoyo: yoyo
	        });
	
	        for (var c = 0; c < range.length; c++)
	        {
	            var created = this.create(0, 0, range[c].a, range[c].b, visible, active);
	
	            if (!created)
	            {
	                break;
	            }
	
	            entries.push(created);
	        }
	
	        //  Post-creation options (applied only to those items created in this call):
	
	        var x = GetValue(options, 'setXY.x', 0);
	        var y = GetValue(options, 'setXY.y', 0);
	        var stepX = GetValue(options, 'setXY.stepX', 0);
	        var stepY = GetValue(options, 'setXY.stepY', 0);
	
	        Actions.SetXY(entries, x, y, stepX, stepY);
	
	        var rotation = GetValue(options, 'setRotation.value', 0);
	        var stepRotation = GetValue(options, 'setRotation.step', 0);
	
	        Actions.SetRotation(entries, rotation, stepRotation);
	
	        var scaleX = GetValue(options, 'setScale.x', 1);
	        var scaleY = GetValue(options, 'setScale.y', scaleX);
	        var stepScaleX = GetValue(options, 'setScale.stepX', 0);
	        var stepScaleY = GetValue(options, 'setScale.stepY', 0);
	
	        Actions.SetScale(entries, scaleX, scaleY, stepScaleX, stepScaleY);
	
	        var alpha = GetValue(options, 'setAlpha.value', 1);
	        var stepAlpha = GetValue(options, 'setAlpha.step', 0);
	
	        Actions.SetAlpha(entries, alpha, stepAlpha);
	
	        var hitArea = GetFastValue(options, 'hitArea', null);
	        var hitAreaCallback = GetFastValue(options, 'hitAreaCallback', null);
	
	        if (hitArea)
	        {
	            Actions.SetHitArea(entries, hitArea, hitAreaCallback);
	        }
	
	        var grid = GetFastValue(options, 'gridAlign', false);
	
	        if (grid)
	        {
	            Actions.GridAlign(entries, grid);
	        }
	
	        if (this.createMultipleCallback)
	        {
	            this.createMultipleCallback.call(this, entries);
	        }
	
	        return entries;
	    },
	
	    /**
	     * Updates any group members, if {@link Phaser.GameObjects.Group#runChildUpdate} is enabled.
	     *
	     * @method Phaser.GameObjects.Group#preUpdate
	     * @since 3.0.0
	     *
	     * @param {number} time - The current timestamp.
	     * @param {number} delta - The delta time elapsed since the last frame.
	     */
	    preUpdate: function (time, delta)
	    {
	        if (!this.runChildUpdate || this.children.size === 0)
	        {
	            return;
	        }
	
	        //  Because a Group child may mess with the length of the Group during its update
	        var temp = this.children.entries.slice();
	
	        for (var i = 0; i < temp.length; i++)
	        {
	            var item = temp[i];
	
	            if (item.active)
	            {
	                item.update(time, delta);
	            }
	        }
	    },
	
	    /**
	     * Adds a Game Object to this group.
	     *
	     * Calls {@link Phaser.GameObjects.Group#createCallback}.
	     *
	     * @method Phaser.GameObjects.Group#add
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} child - The Game Object to add.
	     * @param {boolean} [addToScene=false] - Also add the Game Object to the scene.
	     *
	     * @return {Phaser.GameObjects.Group} This Group object.
	     */
	    add: function (child, addToScene)
	    {
	        if (addToScene === undefined) { addToScene = false; }
	
	        if (this.isFull())
	        {
	            return this;
	        }
	
	        this.children.set(child);
	
	        if (this.createCallback)
	        {
	            this.createCallback.call(this, child);
	        }
	
	        if (addToScene)
	        {
	            this.scene.sys.displayList.add(child);
	
	            if (child.preUpdate)
	            {
	                this.scene.sys.updateList.add(child);
	            }
	        }
	
	        child.on('destroy', this.remove, this);
	
	        return this;
	    },
	
	    /**
	     * Adds several Game Objects to this group.
	     *
	     * Calls {@link Phaser.GameObjects.Group#createCallback}.
	     *
	     * @method Phaser.GameObjects.Group#addMultiple
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject[]} children - The Game Objects to add.
	     * @param {boolean} [addToScene=false] - Also add the Game Objects to the scene.
	     *
	     * @return {Phaser.GameObjects.Group} This group.
	     */
	    addMultiple: function (children, addToScene)
	    {
	        if (addToScene === undefined) { addToScene = false; }
	
	        if (Array.isArray(children))
	        {
	            for (var i = 0; i < children.length; i++)
	            {
	                this.add(children[i], addToScene);
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Removes a member of this Group and optionally removes it from the Scene and / or destroys it.
	     *
	     * Calls {@link Phaser.GameObjects.Group#removeCallback}.
	     *
	     * @method Phaser.GameObjects.Group#remove
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} child - The Game Object to remove.
	     * @param {boolean} [removeFromScene=false] - Optionally remove the Group member from the Scene it belongs to.
	     * @param {boolean} [destroyChild=false] - Optionally call destroy on the removed Group member.
	     *
	     * @return {Phaser.GameObjects.Group} This Group object.
	     */
	    remove: function (child, removeFromScene, destroyChild)
	    {
	        if (removeFromScene === undefined) { removeFromScene = false; }
	        if (destroyChild === undefined) { destroyChild = false; }
	
	        if (!this.children.contains(child))
	        {
	            return this;
	        }
	
	        this.children.delete(child);
	
	        if (this.removeCallback)
	        {
	            this.removeCallback.call(this, child);
	        }
	
	        child.off('destroy', this.remove, this);
	
	        if (destroyChild)
	        {
	            child.destroy();
	        }
	        else if (removeFromScene)
	        {
	            child.scene.sys.displayList.remove(child);
	
	            if (child.preUpdate)
	            {
	                child.scene.sys.updateList.remove(child);
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Removes all members of this Group and optionally removes them from the Scene and / or destroys them.
	     *
	     * Does not call {@link Phaser.GameObjects.Group#removeCallback}.
	     *
	     * @method Phaser.GameObjects.Group#clear
	     * @since 3.0.0
	     *
	     * @param {boolean} [removeFromScene=false] - Optionally remove each Group member from the Scene.
	     * @param {boolean} [destroyChild=false] - Optionally call destroy on the removed Group members.
	     *
	     * @return {Phaser.GameObjects.Group} This group.
	     */
	    clear: function (removeFromScene, destroyChild)
	    {
	        if (removeFromScene === undefined) { removeFromScene = false; }
	        if (destroyChild === undefined) { destroyChild = false; }
	
	        var children = this.children;
	
	        for (var i = 0; i < children.size; i++)
	        {
	            var gameObject = children.entries[i];
	
	            gameObject.off('destroy', this.remove, this);
	
	            if (destroyChild)
	            {
	                gameObject.destroy();
	            }
	            else if (removeFromScene)
	            {
	                gameObject.scene.sys.displayList.remove(gameObject);
	
	                if (gameObject.preUpdate)
	                {
	                    gameObject.scene.sys.updateList.remove(gameObject);
	                }
	            }
	        }
	
	        this.children.clear();
	
	        return this;
	    },
	
	    /**
	     * Tests if a Game Object is a member of this group.
	     *
	     * @method Phaser.GameObjects.Group#contains
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} child - A Game Object.
	     *
	     * @return {boolean} True if the Game Object is a member of this group.
	     */
	    contains: function (child)
	    {
	        return this.children.contains(child);
	    },
	
	    /**
	     * All members of the group.
	     *
	     * @method Phaser.GameObjects.Group#getChildren
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.GameObject[]} The group members.
	     */
	    getChildren: function ()
	    {
	        return this.children.entries;
	    },
	
	    /**
	     * The number of members of the group.
	     *
	     * @method Phaser.GameObjects.Group#getLength
	     * @since 3.0.0
	     *
	     * @return {integer}
	     */
	    getLength: function ()
	    {
	        return this.children.size;
	    },
	
	    /**
	     * Scans the Group, from top to bottom, for the first member that has an {@link Phaser.GameObjects.GameObject#active} state matching the argument,
	     * assigns `x` and `y`, and returns the member.
	     *
	     * If no matching member is found and `createIfNull` is true and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
	     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
	     *
	     * @method Phaser.GameObjects.Group#getFirst
	     * @since 3.0.0
	     *
	     * @param {boolean} [state=false] - The {@link Phaser.GameObjects.GameObject#active} value to match.
	     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
	     * @param {number} [x] - The horizontal position of the Game Object in the world.
	     * @param {number} [y] - The vertical position of the Game Object in the world.
	     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
	     * @param {(string|integer)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
	     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
	     *
	     * @return {?Phaser.GameObjects.GameObject} The first matching group member, or a newly created member, or null.
	     */
	    getFirst: function (state, createIfNull, x, y, key, frame, visible)
	    {
	        return this.getHandler(true, 1, state, createIfNull, x, y, key, frame, visible);
	    },
	
	    /**
	     * Scans the Group, from top to bottom, for the nth member that has an {@link Phaser.GameObjects.GameObject#active} state matching the argument,
	     * assigns `x` and `y`, and returns the member.
	     *
	     * If no matching member is found and `createIfNull` is true and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
	     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
	     *
	     * @method Phaser.GameObjects.Group#getFirstNth
	     * @since 3.6.0
	     *
	     * @param {integer} nth - The nth matching Group member to search for.
	     * @param {boolean} [state=false] - The {@link Phaser.GameObjects.GameObject#active} value to match.
	     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
	     * @param {number} [x] - The horizontal position of the Game Object in the world.
	     * @param {number} [y] - The vertical position of the Game Object in the world.
	     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
	     * @param {(string|integer)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
	     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
	     *
	     * @return {?Phaser.GameObjects.GameObject} The first matching group member, or a newly created member, or null.
	     */
	    getFirstNth: function (nth, state, createIfNull, x, y, key, frame, visible)
	    {
	        return this.getHandler(true, nth, state, createIfNull, x, y, key, frame, visible);
	    },
	
	    /**
	     * Scans the Group for the last member that has an {@link Phaser.GameObjects.GameObject#active} state matching the argument,
	     * assigns `x` and `y`, and returns the member.
	     *
	     * If no matching member is found and `createIfNull` is true and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
	     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
	     *
	     * @method Phaser.GameObjects.Group#getLast
	     * @since 3.6.0
	     *
	     * @param {boolean} [state=false] - The {@link Phaser.GameObjects.GameObject#active} value to match.
	     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
	     * @param {number} [x] - The horizontal position of the Game Object in the world.
	     * @param {number} [y] - The vertical position of the Game Object in the world.
	     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
	     * @param {(string|integer)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
	     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
	     *
	     * @return {?Phaser.GameObjects.GameObject} The first matching group member, or a newly created member, or null.
	     */
	    getLast: function (state, createIfNull, x, y, key, frame, visible)
	    {
	        return this.getHandler(false, 1, state, createIfNull, x, y, key, frame, visible);
	    },
	
	    /**
	     * Scans the Group for the last nth member that has an {@link Phaser.GameObjects.GameObject#active} state matching the argument,
	     * assigns `x` and `y`, and returns the member.
	     *
	     * If no matching member is found and `createIfNull` is true and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
	     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
	     *
	     * @method Phaser.GameObjects.Group#getLastNth
	     * @since 3.6.0
	     *
	     * @param {integer} nth - The nth matching Group member to search for.
	     * @param {boolean} [state=false] - The {@link Phaser.GameObjects.GameObject#active} value to match.
	     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
	     * @param {number} [x] - The horizontal position of the Game Object in the world.
	     * @param {number} [y] - The vertical position of the Game Object in the world.
	     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
	     * @param {(string|integer)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
	     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
	     *
	     * @return {?Phaser.GameObjects.GameObject} The first matching group member, or a newly created member, or null.
	     */
	    getLastNth: function (nth, state, createIfNull, x, y, key, frame, visible)
	    {
	        return this.getHandler(false, nth, state, createIfNull, x, y, key, frame, visible);
	    },
	
	    /**
	     * Scans the group for the last member that has an {@link Phaser.GameObjects.GameObject#active} state matching the argument,
	     * assigns `x` and `y`, and returns the member.
	     *
	     * If no matching member is found and `createIfNull` is true and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
	     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
	     *
	     * @method Phaser.GameObjects.Group#getHandler
	     * @private
	     * @since 3.6.0
	     *
	     * @param {boolean} forwards - Search front to back or back to front?
	     * @param {integer} nth - Stop matching after nth successful matches.
	     * @param {boolean} [state=false] - The {@link Phaser.GameObjects.GameObject#active} value to match.
	     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
	     * @param {number} [x] - The horizontal position of the Game Object in the world.
	     * @param {number} [y] - The vertical position of the Game Object in the world.
	     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
	     * @param {(string|integer)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
	     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
	     *
	     * @return {?Phaser.GameObjects.GameObject} The first matching group member, or a newly created member, or null.
	     */
	    getHandler: function (forwards, nth, state, createIfNull, x, y, key, frame, visible)
	    {
	        if (state === undefined) { state = false; }
	        if (createIfNull === undefined) { createIfNull = false; }
	
	        var gameObject;
	
	        var i;
	        var total = 0;
	        var children = this.children.entries;
	
	        if (forwards)
	        {
	            for (i = 0; i < children.length; i++)
	            {
	                gameObject = children[i];
	
	                if (gameObject.active === state)
	                {
	                    total++;
	
	                    if (total === nth)
	                    {
	                        break;
	                    }
	                }
	                else
	                {
	                    gameObject = null;
	                }
	            }
	        }
	        else
	        {
	            for (i = children.length - 1; i >= 0; i--)
	            {
	                gameObject = children[i];
	
	                if (gameObject.active === state)
	                {
	                    total++;
	
	                    if (total === nth)
	                    {
	                        break;
	                    }
	                }
	                else
	                {
	                    gameObject = null;
	                }
	            }
	        }
	
	        if (gameObject)
	        {
	            if (typeof(x) === 'number')
	            {
	                gameObject.x = x;
	            }
	
	            if (typeof(y) === 'number')
	            {
	                gameObject.y = y;
	            }
	
	            return gameObject;
	        }
	
	        //  Got this far? We need to create or bail
	        if (createIfNull)
	        {
	            return this.create(x, y, key, frame, visible);
	        }
	        else
	        {
	            return null;
	        }
	    },
	
	    /**
	     * Scans the group for the first member that has an {@link Phaser.GameObjects.GameObject#active} state set to `false`,
	     * assigns `x` and `y`, and returns the member.
	     *
	     * If no inactive member is found and the group isn't full then it will create a new Game Object using `x`, `y`, `key`, `frame`, and `visible`.
	     * The new Game Object will have its active state set to `true`.
	     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
	     *
	     * @method Phaser.GameObjects.Group#get
	     * @since 3.0.0
	     *
	     * @param {number} [x] - The horizontal position of the Game Object in the world.
	     * @param {number} [y] - The vertical position of the Game Object in the world.
	     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
	     * @param {(string|integer)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
	     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
	     *
	     * @return {?Phaser.GameObjects.GameObject} The first inactive group member, or a newly created member, or null.
	     */
	    get: function (x, y, key, frame, visible)
	    {
	        return this.getFirst(false, true, x, y, key, frame, visible);
	    },
	
	    /**
	     * Scans the group for the first member that has an {@link Phaser.GameObjects.GameObject#active} state set to `true`,
	     * assigns `x` and `y`, and returns the member.
	     *
	     * If no active member is found and `createIfNull` is `true` and the group isn't full then it will create a new one using `x`, `y`, `key`, `frame`, and `visible`.
	     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
	     *
	     * @method Phaser.GameObjects.Group#getFirstAlive
	     * @since 3.0.0
	     *
	     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
	     * @param {number} [x] - The horizontal position of the Game Object in the world.
	     * @param {number} [y] - The vertical position of the Game Object in the world.
	     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
	     * @param {(string|integer)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
	     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
	     *
	     * @return {Phaser.GameObjects.GameObject} The first active group member, or a newly created member, or null.
	     */
	    getFirstAlive: function (createIfNull, x, y, key, frame, visible)
	    {
	        return this.getFirst(true, createIfNull, x, y, key, frame, visible);
	    },
	
	    /**
	     * Scans the group for the first member that has an {@link Phaser.GameObjects.GameObject#active} state set to `false`,
	     * assigns `x` and `y`, and returns the member.
	     *
	     * If no inactive member is found and `createIfNull` is `true` and the group isn't full then it will create a new one using `x`, `y`, `key`, `frame`, and `visible`.
	     * The new Game Object will have an active state set to `true`.
	     * Unless a new member is created, `key`, `frame`, and `visible` are ignored.
	     *
	     * @method Phaser.GameObjects.Group#getFirstDead
	     * @since 3.0.0
	     *
	     * @param {boolean} [createIfNull=false] - Create a new Game Object if no matching members are found, using the following arguments.
	     * @param {number} [x] - The horizontal position of the Game Object in the world.
	     * @param {number} [y] - The vertical position of the Game Object in the world.
	     * @param {string} [key=defaultKey] - The texture key assigned to a new Game Object (if one is created).
	     * @param {(string|integer)} [frame=defaultFrame] - A texture frame assigned to a new Game Object (if one is created).
	     * @param {boolean} [visible=true] - The {@link Phaser.GameObjects.Components.Visible#visible} state of a new Game Object (if one is created).
	     *
	     * @return {Phaser.GameObjects.GameObject} The first inactive group member, or a newly created member, or null.
	     */
	    getFirstDead: function (createIfNull, x, y, key, frame, visible)
	    {
	        return this.getFirst(false, createIfNull, x, y, key, frame, visible);
	    },
	
	    /**
	     * {@link Phaser.GameObjects.Components.Animation#play Plays} an animation for all members of this group.
	     *
	     * @method Phaser.GameObjects.Group#playAnimation
	     * @since 3.0.0
	     *
	     * @param {string} key - The string-based key of the animation to play.
	     * @param {string} [startFrame=0] - Optionally start the animation playing from this frame index.
	     *
	     * @return {Phaser.GameObjects.Group} This Group object.
	     */
	    playAnimation: function (key, startFrame)
	    {
	        Actions.PlayAnimation(this.children.entries, key, startFrame);
	
	        return this;
	    },
	
	    /**
	     * Whether this group's size at its {@link Phaser.GameObjects.Group#maxSize maximum}.
	     *
	     * @method Phaser.GameObjects.Group#isFull
	     * @since 3.0.0
	     *
	     * @return {boolean} True if the number of members equals {@link Phaser.GameObjects.Group#maxSize}.
	     */
	    isFull: function ()
	    {
	        if (this.maxSize === -1)
	        {
	            return false;
	        }
	        else
	        {
	            return (this.children.size >= this.maxSize);
	        }
	    },
	
	    /**
	     * Counts the number of active (or inactive) group members.
	     *
	     * @method Phaser.GameObjects.Group#countActive
	     * @since 3.0.0
	     *
	     * @param {boolean} [value=true] - Count active (true) or inactive (false) group members.
	     *
	     * @return {integer} The number of group members with an active state matching the `active` argument.
	     */
	    countActive: function (value)
	    {
	        if (value === undefined) { value = true; }
	
	        var total = 0;
	
	        for (var i = 0; i < this.children.size; i++)
	        {
	            if (this.children.entries[i].active === value)
	            {
	                total++;
	            }
	        }
	
	        return total;
	    },
	
	    /**
	     * Counts the number of in-use (active) group members.
	     *
	     * @method Phaser.GameObjects.Group#getTotalUsed
	     * @since 3.0.0
	     *
	     * @return {integer} The number of group members with an active state of true.
	     */
	    getTotalUsed: function ()
	    {
	        return this.countActive();
	    },
	
	    /**
	     * The difference of {@link Phaser.GameObjects.Group#maxSize} and the number of active group members.
	     *
	     * This represents the number of group members that could be created or reactivated before reaching the size limit.
	     *
	     * @method Phaser.GameObjects.Group#getTotalFree
	     * @since 3.0.0
	     *
	     * @return {integer} maxSize minus the number of active group numbers; or a large number (if maxSize is -1).
	     */
	    getTotalFree: function ()
	    {
	        var used = this.getTotalUsed();
	        var capacity = (this.maxSize === -1) ? 999999999999 : this.maxSize;
	
	        return (capacity - used);
	    },
	
	    /**
	     * Sets the depth of each group member.
	     *
	     * @method Phaser.GameObjects.Group#setDepth
	     * @since 3.0.0
	     *
	     * @param {number} value - The amount to set the property to.
	     * @param {number} step - This is added to the `value` amount, multiplied by the iteration counter.
	     *
	     * @return {Phaser.GameObjects.Group} This Group object.
	     */
	    setDepth: function (value, step)
	    {
	        Actions.SetDepth(this.children.entries, value, step);
	
	        return this;
	    },
	
	    /**
	     * Deactivates a member of this group.
	     *
	     * @method Phaser.GameObjects.Group#kill
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} gameObject - A member of this group.
	     */
	    kill: function (gameObject)
	    {
	        if (this.children.contains(gameObject))
	        {
	            gameObject.setActive(false);
	        }
	    },
	
	    /**
	     * Deactivates and hides a member of this group.
	     *
	     * @method Phaser.GameObjects.Group#killAndHide
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} gameObject - A member of this group.
	     */
	    killAndHide: function (gameObject)
	    {
	        if (this.children.contains(gameObject))
	        {
	            gameObject.setActive(false);
	            gameObject.setVisible(false);
	        }
	    },
	
	    /**
	     * Toggles (flips) the visible state of each member of this group.
	     *
	     * @method Phaser.GameObjects.Group#toggleVisible
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Group} This Group object.
	     */
	    toggleVisible: function ()
	    {
	        Actions.ToggleVisible(this.children.entries);
	
	        return this;
	    },
	
	    /**
	     * Empties this group and removes it from the scene.
	     *
	     * Does not call {@link Phaser.GameObjects.Group#removeCallback}.
	     *
	     * @method Phaser.GameObjects.Group#destroy
	     * @since 3.0.0
	     *
	     * @param {boolean} [destroyChildren=false] - Also {@link Phaser.GameObjects.GameObject#destroy} each group member.
	     */
	    destroy: function (destroyChildren)
	    {
	        if (destroyChildren === undefined) { destroyChildren = false; }
	
	        if (destroyChildren)
	        {
	            var children = this.children;
	
	            for (var i = 0; i < children.size; i++)
	            {
	                var gameObject = children.entries[i];
	
	                //  Remove the event hook first or it'll go all recursive hell on us
	                gameObject.off('destroy', this.remove, this);
	
	                gameObject.destroy();
	            }
	        }
	
	        this.children.clear();
	
	        this.scene = undefined;
	        this.children = undefined;
	    }
	
	});
	
	module.exports = Group;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Contains = __webpack_require__(83);
	var GetPoint = __webpack_require__(502);
	var GetPoints = __webpack_require__(503);
	var Random = __webpack_require__(286);
	
	/**
	 * @classdesc
	 * A Circle object.
	 *
	 * This is a geometry object, containing numerical values and related methods to inspect and modify them.
	 * It is not a Game Object, in that you cannot add it to the display list, and it has no texture.
	 * To render a Circle you should look at the capabilities of the Graphics class.
	 *
	 * @class Circle
	 * @memberOf Phaser.Geom
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {number} [x=0] - The x position of the center of the circle.
	 * @param {number} [y=0] - The y position of the center of the circle.
	 * @param {number} [radius=0] - The radius of the circle.
	 */
	var Circle = new Class({
	
	    initialize:
	
	    function Circle (x, y, radius)
	    {
	        if (x === undefined) { x = 0; }
	        if (y === undefined) { y = 0; }
	        if (radius === undefined) { radius = 0; }
	
	        /**
	         * The x position of the center of the circle.
	         *
	         * @name Phaser.Geom.Circle#x
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.x = x;
	
	        /**
	         * The y position of the center of the circle.
	         *
	         * @name Phaser.Geom.Circle#y
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.y = y;
	
	        /**
	         * The internal radius of the circle.
	         *
	         * @name Phaser.Geom.Circle#_radius
	         * @type {number}
	         * @private
	         * @since 3.0.0
	         */
	        this._radius = radius;
	
	        /**
	         * The internal diameter of the circle.
	         *
	         * @name Phaser.Geom.Circle#_diameter
	         * @type {number}
	         * @private
	         * @since 3.0.0
	         */
	        this._diameter = radius * 2;
	    },
	
	    /**
	     * Check to see if the Circle contains the given x / y coordinates.
	     *
	     * @method Phaser.Geom.Circle#contains
	     * @since 3.0.0
	     *
	     * @param {number} x - The x coordinate to check within the circle.
	     * @param {number} y - The y coordinate to check within the circle.
	     *
	     * @return {boolean} True if the coordinates are within the circle, otherwise false.
	     */
	    contains: function (x, y)
	    {
	        return Contains(this, x, y);
	    },
	
	    /**
	     * Returns a Point object containing the coordinates of a point on the circumference of the Circle
	     * based on the given angle normalized to the range 0 to 1. I.e. a value of 0.5 will give the point
	     * at 180 degrees around the circle.
	     *
	     * @method Phaser.Geom.Circle#getPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Point} O - [out,$return]
	     *
	     * @param {float} position - A value between 0 and 1, where 0 equals 0 degrees, 0.5 equals 180 degrees and 1 equals 360 around the circle.
	     * @param {(Phaser.Geom.Point|object)} [out] - An object to store the return values in. If not given a Point object will be created.
	     *
	     * @return {(Phaser.Geom.Point|object)} A Point, or point-like object, containing the coordinates of the point around the circle.
	     */
	    getPoint: function (position, point)
	    {
	        return GetPoint(this, position, point);
	    },
	
	    /**
	     * Returns an array of Point objects containing the coordinates of the points around the circumference of the Circle,
	     * based on the given quantity or stepRate values.
	     *
	     * @method Phaser.Geom.Circle#getPoints
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Point[]} O - [output,$return]
	     *
	     * @param {integer} quantity - The amount of points to return. If a falsey value the quantity will be derived from the `stepRate` instead.
	     * @param {number} [stepRate] - Sets the quantity by getting the circumference of the circle and dividing it by the stepRate.
	     * @param {(array|Phaser.Geom.Point[])} [output] - An array to insert the points in to. If not provided a new array will be created.
	     *
	     * @return {(array|Phaser.Geom.Point[])} An array of Point objects pertaining to the points around the circumference of the circle.
	     */
	    getPoints: function (quantity, stepRate, output)
	    {
	        return GetPoints(this, quantity, stepRate, output);
	    },
	
	    /**
	     * Returns a uniformly distributed random point from anywhere within the Circle.
	     *
	     * @method Phaser.Geom.Circle#getRandomPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Point} O - [point,$return]
	     *
	     * @param {(Phaser.Geom.Point|object)} [point] - A Point or point-like object to set the random `x` and `y` values in.
	     *
	     * @return {(Phaser.Geom.Point|object)} A Point object with the random values set in the `x` and `y` properties.
	     */
	    getRandomPoint: function (point)
	    {
	        return Random(this, point);
	    },
	
	    /**
	     * Sets the x, y and radius of this circle.
	     *
	     * @method Phaser.Geom.Circle#setTo
	     * @since 3.0.0
	     *
	     * @param {number} [x=0] - The x position of the center of the circle.
	     * @param {number} [y=0] - The y position of the center of the circle.
	     * @param {number} [radius=0] - The radius of the circle.
	     *
	     * @return {Phaser.Geom.Circle} This Circle object.
	     */
	    setTo: function (x, y, radius)
	    {
	        this.x = x;
	        this.y = y;
	        this._radius = radius;
	        this._diameter = radius * 2;
	
	        return this;
	    },
	
	    /**
	     * Sets this Circle to be empty with a radius of zero.
	     * Does not change its position.
	     *
	     * @method Phaser.Geom.Circle#setEmpty
	     * @since 3.0.0
	     *
	     * @return {Phaser.Geom.Circle} This Circle object.
	     */
	    setEmpty: function ()
	    {
	        this._radius = 0;
	        this._diameter = 0;
	
	        return this;
	    },
	
	    /**
	     * Sets the position of this Circle.
	     *
	     * @method Phaser.Geom.Circle#setPosition
	     * @since 3.0.0
	     *
	     * @param {number} [x=0] - The x position of the center of the circle.
	     * @param {number} [y=0] - The y position of the center of the circle.
	     *
	     * @return {Phaser.Geom.Circle} This Circle object.
	     */
	    setPosition: function (x, y)
	    {
	        if (y === undefined) { y = x; }
	
	        this.x = x;
	        this.y = y;
	
	        return this;
	    },
	
	    /**
	     * Checks to see if the Circle is empty: has a radius of zero.
	     *
	     * @method Phaser.Geom.Circle#isEmpty
	     * @since 3.0.0
	     *
	     * @return {boolean} True if the Circle is empty, otherwise false.
	     */
	    isEmpty: function ()
	    {
	        return (this._radius <= 0);
	    },
	
	    /**
	     * The radius of the Circle.
	     *
	     * @name Phaser.Geom.Circle#radius
	     * @type {number}
	     * @since 3.0.0
	     */
	    radius: {
	
	        get: function ()
	        {
	            return this._radius;
	        },
	
	        set: function (value)
	        {
	            this._radius = value;
	            this._diameter = value * 2;
	        }
	
	    },
	
	    /**
	     * The diameter of the Circle.
	     *
	     * @name Phaser.Geom.Circle#diameter
	     * @type {number}
	     * @since 3.0.0
	     */
	    diameter: {
	
	        get: function ()
	        {
	            return this._diameter;
	        },
	
	        set: function (value)
	        {
	            this._diameter = value;
	            this._radius = value * 0.5;
	        }
	
	    },
	
	    /**
	     * The left position of the Circle.
	     *
	     * @name Phaser.Geom.Circle#left
	     * @type {number}
	     * @since 3.0.0
	     */
	    left: {
	
	        get: function ()
	        {
	            return this.x - this._radius;
	        },
	
	        set: function (value)
	        {
	            this.x = value + this._radius;
	        }
	
	    },
	
	    /**
	     * The right position of the Circle.
	     *
	     * @name Phaser.Geom.Circle#right
	     * @type {number}
	     * @since 3.0.0
	     */
	    right: {
	
	        get: function ()
	        {
	            return this.x + this._radius;
	        },
	
	        set: function (value)
	        {
	            this.x = value - this._radius;
	        }
	
	    },
	
	    /**
	     * The top position of the Circle.
	     *
	     * @name Phaser.Geom.Circle#top
	     * @type {number}
	     * @since 3.0.0
	     */
	    top: {
	
	        get: function ()
	        {
	            return this.y - this._radius;
	        },
	
	        set: function (value)
	        {
	            this.y = value + this._radius;
	        }
	
	    },
	
	    /**
	     * The bottom position of the Circle.
	     *
	     * @name Phaser.Geom.Circle#bottom
	     * @type {number}
	     * @since 3.0.0
	     */
	    bottom: {
	
	        get: function ()
	        {
	            return this.y + this._radius;
	        },
	
	        set: function (value)
	        {
	            this.y = value - this._radius;
	        }
	
	    }
	
	});
	
	module.exports = Circle;


/***/ }),
/* 161 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Check to see if the Ellipse contains the given x / y coordinates.
	 *
	 * @function Phaser.Geom.Ellipse.Contains
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to check.
	 * @param {number} x - The x coordinate to check within the ellipse.
	 * @param {number} y - The y coordinate to check within the ellipse.
	 *
	 * @return {boolean} True if the coordinates are within the ellipse, otherwise false.
	 */
	var Contains = function (ellipse, x, y)
	{
	    if (ellipse.width <= 0 || ellipse.height <= 0)
	    {
	        return false;
	    }
	
	    //  Normalize the coords to an ellipse with center 0,0 and a radius of 0.5
	    var normx = ((x - ellipse.x) / ellipse.width);
	    var normy = ((y - ellipse.y) / ellipse.height);
	
	    normx *= normx;
	    normy *= normy;
	
	    return (normx + normy < 0.25);
	};
	
	module.exports = Contains;


/***/ }),
/* 162 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.Length
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 *
	 * @return {number} [description]
	 */
	var Length = function (line)
	{
	    return Math.sqrt((line.x2 - line.x1) * (line.x2 - line.x1) + (line.y2 - line.y1) * (line.y2 - line.y1));
	};
	
	module.exports = Length;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Clamp = __webpack_require__(63);
	
	/**
	 * Return a value based on the range between `min` and `max` and the percentage given.
	 *
	 * @function Phaser.Math.FromPercent
	 * @since 3.0.0
	 *
	 * @param {float} percent - A value between 0 and 1 representing the percentage.
	 * @param {number} min - [description]
	 * @param {number} [max] - [description]
	 *
	 * @return {number} [description]
	 */
	var FromPercent = function (percent, min, max)
	{
	    percent = Clamp(percent, 0, 1);
	
	    return (max - min) * percent;
	};
	
	module.exports = FromPercent;


/***/ }),
/* 164 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Collision Types - Determine if and how entities collide with each other.
	 *
	 * In ACTIVE vs. LITE or FIXED vs. ANY collisions, only the "weak" entity moves,
	 * while the other one stays fixed. In ACTIVE vs. ACTIVE and ACTIVE vs. PASSIVE
	 * collisions, both entities are moved. LITE or PASSIVE entities don't collide
	 * with other LITE or PASSIVE entities at all. The behavior for FIXED vs.
	 * FIXED collisions is undefined.
	 *
	 * @name Phaser.Physics.Impact.COLLIDES
	 * @enum {integer}
	 * @memberOf Phaser.Physics.Impact
	 * @readOnly
	 * @since 3.0.0
	 */
	module.exports = {
	
	    /**
	     * Never collides.
	     *
	     * @name Phaser.Physics.Impact.COLLIDES.NEVER
	     */
	    NEVER: 0,
	
	    /**
	     * Lite collision.
	     *
	     * @name Phaser.Physics.Impact.COLLIDES.LITE
	     */
	    LITE: 1,
	
	    /**
	     * Passive collision.
	     *
	     * @name Phaser.Physics.Impact.COLLIDES.PASSIVE
	     */
	    PASSIVE: 2,
	
	    /**
	     * Active collision.
	     *
	     * @name Phaser.Physics.Impact.COLLIDES.ACTIVE
	     */
	    ACTIVE: 4,
	
	    /**
	     * Fixed collision.
	     *
	     * @name Phaser.Physics.Impact.COLLIDES.FIXED
	     */
	    FIXED: 8
	
	};


/***/ }),
/* 165 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Collision Types - Determine if and how entities collide with each other.
	 *
	 * In ACTIVE vs. LITE or FIXED vs. ANY collisions, only the "weak" entity moves,
	 * while the other one stays fixed. In ACTIVE vs. ACTIVE and ACTIVE vs. PASSIVE
	 * collisions, both entities are moved. LITE or PASSIVE entities don't collide
	 * with other LITE or PASSIVE entities at all. The behavior for FIXED vs.
	 * FIXED collisions is undefined.
	 *
	 * @name Phaser.Physics.Impact.TYPE
	 * @enum {integer}
	 * @memberOf Phaser.Physics.Impact
	 * @readOnly
	 * @since 3.0.0
	 */
	module.exports = {
	
	    /**
	     * Collides with nothing.
	     *
	     * @name Phaser.Physics.Impact.TYPE.NONE
	     */
	    NONE: 0,
	
	    /**
	     * Type A. Collides with Type B.
	     *
	     * @name Phaser.Physics.Impact.TYPE.A
	     */
	    A: 1,
	
	    /**
	     * Type B. Collides with Type A.
	     *
	     * @name Phaser.Physics.Impact.TYPE.B
	     */
	    B: 2,
	
	    /**
	     * Collides with both types A and B.
	     *
	     * @name Phaser.Physics.Impact.TYPE.BOTH
	     */
	    BOTH: 3
	
	};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* The `Matter.Sleeping` module contains methods to manage the sleeping state of bodies.
	*
	* @class Sleeping
	*/
	
	var Sleeping = {};
	
	module.exports = Sleeping;
	
	var Events = __webpack_require__(144);
	
	(function() {
	
	    Sleeping._motionWakeThreshold = 0.18;
	    Sleeping._motionSleepThreshold = 0.08;
	    Sleeping._minBias = 0.9;
	
	    /**
	     * Puts bodies to sleep or wakes them up depending on their motion.
	     * @method update
	     * @param {body[]} bodies
	     * @param {number} timeScale
	     */
	    Sleeping.update = function(bodies, timeScale) {
	        var timeFactor = timeScale * timeScale * timeScale;
	
	        // update bodies sleeping status
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i],
	                motion = body.speed * body.speed + body.angularSpeed * body.angularSpeed;
	
	            // wake up bodies if they have a force applied
	            if (body.force.x !== 0 || body.force.y !== 0) {
	                Sleeping.set(body, false);
	                continue;
	            }
	
	            var minMotion = Math.min(body.motion, motion),
	                maxMotion = Math.max(body.motion, motion);
	        
	            // biased average motion estimation between frames
	            body.motion = Sleeping._minBias * minMotion + (1 - Sleeping._minBias) * maxMotion;
	            
	            if (body.sleepThreshold > 0 && body.motion < Sleeping._motionSleepThreshold * timeFactor) {
	                body.sleepCounter += 1;
	                
	                if (body.sleepCounter >= body.sleepThreshold)
	                    Sleeping.set(body, true);
	            } else if (body.sleepCounter > 0) {
	                body.sleepCounter -= 1;
	            }
	        }
	    };
	
	    /**
	     * Given a set of colliding pairs, wakes the sleeping bodies involved.
	     * @method afterCollisions
	     * @param {pair[]} pairs
	     * @param {number} timeScale
	     */
	    Sleeping.afterCollisions = function(pairs, timeScale) {
	        var timeFactor = timeScale * timeScale * timeScale;
	
	        // wake up bodies involved in collisions
	        for (var i = 0; i < pairs.length; i++) {
	            var pair = pairs[i];
	            
	            // don't wake inactive pairs
	            if (!pair.isActive)
	                continue;
	
	            var collision = pair.collision,
	                bodyA = collision.bodyA.parent, 
	                bodyB = collision.bodyB.parent;
	        
	            // don't wake if at least one body is static
	            if ((bodyA.isSleeping && bodyB.isSleeping) || bodyA.isStatic || bodyB.isStatic)
	                continue;
	        
	            if (bodyA.isSleeping || bodyB.isSleeping) {
	                var sleepingBody = (bodyA.isSleeping && !bodyA.isStatic) ? bodyA : bodyB,
	                    movingBody = sleepingBody === bodyA ? bodyB : bodyA;
	
	                if (!sleepingBody.isStatic && movingBody.motion > Sleeping._motionWakeThreshold * timeFactor) {
	                    Sleeping.set(sleepingBody, false);
	                }
	            }
	        }
	    };
	  
	    /**
	     * Set a body as sleeping or awake.
	     * @method set
	     * @param {body} body
	     * @param {boolean} isSleeping
	     */
	    Sleeping.set = function(body, isSleeping) {
	        var wasSleeping = body.isSleeping;
	
	        if (isSleeping) {
	            body.isSleeping = true;
	            body.sleepCounter = body.sleepThreshold;
	
	            body.positionImpulse.x = 0;
	            body.positionImpulse.y = 0;
	
	            body.positionPrev.x = body.position.x;
	            body.positionPrev.y = body.position.y;
	
	            body.anglePrev = body.angle;
	            body.speed = 0;
	            body.angularSpeed = 0;
	            body.motion = 0;
	
	            if (!wasSleeping) {
	                Events.trigger(body, 'sleepStart');
	            }
	        } else {
	            body.isSleeping = false;
	            body.sleepCounter = 0;
	
	            if (wasSleeping) {
	                Events.trigger(body, 'sleepEnd');
	            }
	        }
	    };
	
	})();


/***/ }),
/* 167 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Phaser Scale Modes.
	 * 
	 * @name Phaser.ScaleModes
	 * @enum {integer}
	 * @memberOf Phaser
	 * @readOnly
	 * @since 3.0.0
	 */
	
	module.exports = {
	
	    /**
	     * Default Scale Mode (Linear).
	     * 
	     * @name Phaser.ScaleModes.DEFAULT
	     */
	    DEFAULT: 0,
	
	    /**
	     * Linear Scale Mode.
	     * 
	     * @name Phaser.ScaleModes.LINEAR
	     */
	    LINEAR: 0,
	
	    /**
	     * Nearest Scale Mode.
	     * 
	     * @name Phaser.ScaleModes.NEAREST
	     */
	    NEAREST: 1
	
	};


/***/ }),
/* 168 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Scene consts.
	 * 
	 * @ignore
	 */
	
	var CONST = {
	
	    /**
	     * Scene state.
	     * 
	     * @name Phaser.Scenes.PENDING
	     * @readOnly
	     * @type {integer}
	     * @since 3.0.0
	     */
	    PENDING: 0,
	
	    /**
	     * Scene state.
	     * 
	     * @name Phaser.Scenes.INIT
	     * @readOnly
	     * @type {integer}
	     * @since 3.0.0
	     */
	    INIT: 1,
	
	    /**
	     * Scene state.
	     * 
	     * @name Phaser.Scenes.START
	     * @readOnly
	     * @type {integer}
	     * @since 3.0.0
	     */
	    START: 2,
	
	    /**
	     * Scene state.
	     * 
	     * @name Phaser.Scenes.LOADING
	     * @readOnly
	     * @type {integer}
	     * @since 3.0.0
	     */
	    LOADING: 3,
	
	    /**
	     * Scene state.
	     * 
	     * @name Phaser.Scenes.CREATING
	     * @readOnly
	     * @type {integer}
	     * @since 3.0.0
	     */
	    CREATING: 4,
	
	    /**
	     * Scene state.
	     * 
	     * @name Phaser.Scenes.RUNNING
	     * @readOnly
	     * @type {integer}
	     * @since 3.0.0
	     */
	    RUNNING: 5,
	
	    /**
	     * Scene state.
	     * 
	     * @name Phaser.Scenes.PAUSED
	     * @readOnly
	     * @type {integer}
	     * @since 3.0.0
	     */
	    PAUSED: 6,
	
	    /**
	     * Scene state.
	     * 
	     * @name Phaser.Scenes.SLEEPING
	     * @readOnly
	     * @type {integer}
	     * @since 3.0.0
	     */
	    SLEEPING: 7,
	
	    /**
	     * Scene state.
	     * 
	     * @name Phaser.Scenes.SHUTDOWN
	     * @readOnly
	     * @type {integer}
	     * @since 3.0.0
	     */
	    SHUTDOWN: 8,
	
	    /**
	     * Scene state.
	     * 
	     * @name Phaser.Scenes.DESTROYED
	     * @readOnly
	     * @type {integer}
	     * @since 3.0.0
	     */
	    DESTROYED: 9
	
	};
	
	module.exports = CONST;


/***/ }),
/* 169 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Checks if the given tile coordinates are within the bounds of the layer.
	 *
	 * @function Phaser.Tilemaps.Components.IsInLayerBounds
	 * @private
	 * @since 3.0.0
	 *
	 * @param {integer} tileX - [description]
	 * @param {integer} tileY - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 * 
	 * @return {boolean}
	 */
	var IsInLayerBounds = function (tileX, tileY, layer)
	{
	    return (tileX >= 0 && tileX < layer.width && tileY >= 0 && tileY < layer.height);
	};
	
	module.exports = IsInLayerBounds;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var GetFastValue = __webpack_require__(3);
	
	/**
	 * @classdesc
	 * A class for representing data about about a layer in a map. Maps are parsed from CSV, Tiled,
	 * etc. into this format. Tilemap, StaticTilemapLayer and DynamicTilemapLayer have a reference
	 * to this data and use it to look up and perform operations on tiles.
	 *
	 * @class LayerData
	 * @memberOf Phaser.Tilemaps
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {object} [config] - [description]
	 */
	var LayerData = new Class({
	
	    initialize:
	
	    function LayerData (config)
	    {
	        if (config === undefined) { config = {}; }
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.LayerData#name
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.name = GetFastValue(config, 'name', 'layer');
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.LayerData#x
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.x = GetFastValue(config, 'x', 0);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.LayerData#y
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.y = GetFastValue(config, 'y', 0);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.LayerData#width
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.width = GetFastValue(config, 'width', 0);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.LayerData#height
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.height = GetFastValue(config, 'height', 0);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.LayerData#tileWidth
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.tileWidth = GetFastValue(config, 'tileWidth', 0);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.LayerData#tileHeight
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.tileHeight = GetFastValue(config, 'tileHeight', 0);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.LayerData#baseTileWidth
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.baseTileWidth = GetFastValue(config, 'baseTileWidth', this.tileWidth);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.LayerData#baseTileHeight
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.baseTileHeight = GetFastValue(config, 'baseTileHeight', this.tileHeight);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.LayerData#widthInPixels
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.widthInPixels = GetFastValue(config, 'widthInPixels', this.width * this.baseTileWidth);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.LayerData#heightInPixels
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.heightInPixels = GetFastValue(config, 'heightInPixels', this.height * this.baseTileHeight);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.LayerData#alpha
	         * @type {float}
	         * @since 3.0.0
	         */
	        this.alpha = GetFastValue(config, 'alpha', 1);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.LayerData#visible
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.visible = GetFastValue(config, 'visible', true);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.LayerData#properties
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.properties = GetFastValue(config, 'properties', {});
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.LayerData#indexes
	         * @type {array}
	         * @since 3.0.0
	         */
	        this.indexes = GetFastValue(config, 'indexes', []);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.LayerData#collideIndexes
	         * @type {array}
	         * @since 3.0.0
	         */
	        this.collideIndexes = GetFastValue(config, 'collideIndexes', []);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.LayerData#callbacks
	         * @type {array}
	         * @since 3.0.0
	         */
	        this.callbacks = GetFastValue(config, 'callbacks', []);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.LayerData#bodies
	         * @type {array}
	         * @since 3.0.0
	         */
	        this.bodies = GetFastValue(config, 'bodies', []);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.LayerData#data
	         * @type {array}
	         * @since 3.0.0
	         */
	        this.data = GetFastValue(config, 'data', []);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.LayerData#tilemapLayer
	         * @type {(Phaser.Tilemaps.DynamicTilemapLayer|Phaser.Tilemaps.StaticTilemapLayer)}
	         * @since 3.0.0
	         */
	        this.tilemapLayer = GetFastValue(config, 'tilemapLayer', null);
	    }
	
	});
	
	module.exports = LayerData;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var GetFastValue = __webpack_require__(3);
	
	/**
	 * @classdesc
	 * A class for representing data about a map. Maps are parsed from CSV, Tiled, etc. into this
	 * format. A Tilemap object get a copy of this data and then unpacks the needed properties into
	 * itself.
	 *
	 * @class MapData
	 * @memberOf Phaser.Tilemaps
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {object} [config] - [description]
	 */
	var MapData = new Class({
	
	    initialize:
	
	    function MapData (config)
	    {
	        if (config === undefined) { config = {}; }
	
	        /**
	         * [description]
	         * 
	         * @name Phaser.Tilemaps.MapData#name
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.name = GetFastValue(config, 'name', 'map');
	
	        /**
	         * [description]
	         * 
	         * @name Phaser.Tilemaps.MapData#width
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.width = GetFastValue(config, 'width', 0);
	
	        /**
	         * [description]
	         * 
	         * @name Phaser.Tilemaps.MapData#height
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.height = GetFastValue(config, 'height', 0);
	
	        /**
	         * [description]
	         * 
	         * @name Phaser.Tilemaps.MapData#tileWidth
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.tileWidth = GetFastValue(config, 'tileWidth', 0);
	
	        /**
	         * [description]
	         * 
	         * @name Phaser.Tilemaps.MapData#tileHeight
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.tileHeight = GetFastValue(config, 'tileHeight', 0);
	
	        /**
	         * [description]
	         * 
	         * @name Phaser.Tilemaps.MapData#widthInPixels
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.widthInPixels = GetFastValue(config, 'widthInPixels', this.width * this.tileWidth);
	
	        /**
	         * [description]
	         * 
	         * @name Phaser.Tilemaps.MapData#heightInPixels
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.heightInPixels = GetFastValue(config, 'heightInPixels', this.height * this.tileHeight);
	
	        /**
	         * [description]
	         * 
	         * @name Phaser.Tilemaps.MapData#format
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.format = GetFastValue(config, 'format', null);
	
	        /**
	         * [description]
	         * 
	         * @name Phaser.Tilemaps.MapData#orientation
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.orientation = GetFastValue(config, 'orientation', 'orthogonal');
	
	        /**
	         * [description]
	         * 
	         * @name Phaser.Tilemaps.MapData#version
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.version = GetFastValue(config, 'version', '1');
	
	        /**
	         * [description]
	         * 
	         * @name Phaser.Tilemaps.MapData#properties
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.properties = GetFastValue(config, 'properties', {});
	
	        /**
	         * [description]
	         * 
	         * @name Phaser.Tilemaps.MapData#layers
	         * @type {array}
	         * @since 3.0.0
	         */
	        this.layers = GetFastValue(config, 'layers', []);
	
	        /**
	         * [description]
	         * 
	         * @name Phaser.Tilemaps.MapData#images
	         * @type {array}
	         * @since 3.0.0
	         */
	        this.images = GetFastValue(config, 'images', []);
	
	        /**
	         * [description]
	         * 
	         * @name Phaser.Tilemaps.MapData#objects
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.objects = GetFastValue(config, 'objects', {});
	
	        /**
	         * [description]
	         * 
	         * @name Phaser.Tilemaps.MapData#collision
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.collision = GetFastValue(config, 'collision', {});
	
	        /**
	         * [description]
	         * 
	         * @name Phaser.Tilemaps.MapData#tilesets
	         * @type {array}
	         * @since 3.0.0
	         */
	        this.tilesets = GetFastValue(config, 'tilesets', []);
	
	        /**
	         * [description]
	         * 
	         * @name Phaser.Tilemaps.MapData#imageCollections
	         * @type {array}
	         * @since 3.0.0
	         */
	        this.imageCollections = GetFastValue(config, 'imageCollections', []);
	
	        /**
	         * [description]
	         * 
	         * @name Phaser.Tilemaps.MapData#tiles
	         * @type {array}
	         * @since 3.0.0
	         */
	        this.tiles = GetFastValue(config, 'tiles', []);
	    }
	
	});
	
	module.exports = MapData;


/***/ }),
/* 172 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Tweens.Builders.GetBoolean
	 * @since 3.0.0
	 *
	 * @param {object} source - [description]
	 * @param {string} key - [description]
	 * @param {*} defaultValue - [description]
	 *
	 * @return {*} [description]
	 */
	var GetBoolean = function (source, key, defaultValue)
	{
	    if (!source)
	    {
	        return defaultValue;
	    }
	    else if (source.hasOwnProperty(key))
	    {
	        return source[key];
	    }
	    else
	    {
	        return defaultValue;
	    }
	};
	
	module.exports = GetBoolean;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var EaseMap = __webpack_require__(1374);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Tweens.Builders.GetEaseFunction
	 * @since 3.0.0
	 *
	 * @param {(string|function)} ease - [description]
	 * @param {array} easeParams - [description]
	 *
	 * @return {function} [description]
	 */
	var GetEaseFunction = function (ease, easeParams)
	{
	    if (typeof ease === 'string' && EaseMap.hasOwnProperty(ease))
	    {
	        if (easeParams)
	        {
	            var cloneParams = easeParams.slice(0);
	
	            cloneParams.unshift(0);
	
	            return function (v)
	            {
	                cloneParams[0] = v;
	
	                return EaseMap[ease].apply(this, cloneParams);
	            };
	        }
	        else
	        {
	            //  String based look-up
	            return EaseMap[ease];
	        }
	    }
	    else if (typeof ease === 'function')
	    {
	        //  Custom function
	        return ease;
	    }
	    else if (Array.isArray(ease) && ease.length === 4)
	    {
	        //  Bezier function (TODO)
	    }
	
	    return EaseMap.Power0;
	};
	
	module.exports = GetEaseFunction;


/***/ }),
/* 174 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var TWEEN_CONST = {
	
	    /**
	     * TweenData state.
	     * 
	     * @name Phaser.Tweens.CREATED
	     * @type {integer}
	     * @since 3.0.0
	     */
	    CREATED: 0,
	
	    /**
	     * TweenData state.
	     * 
	     * @name Phaser.Tweens.INIT
	     * @type {integer}
	     * @since 3.0.0
	     */
	    INIT: 1,
	
	    /**
	     * TweenData state.
	     * 
	     * @name Phaser.Tweens.DELAY
	     * @type {integer}
	     * @since 3.0.0
	     */
	    DELAY: 2,
	
	    /**
	     * TweenData state.
	     * 
	     * @name Phaser.Tweens.OFFSET_DELAY
	     * @type {integer}
	     * @since 3.0.0
	     */
	    OFFSET_DELAY: 3,
	
	    /**
	     * TweenData state.
	     * 
	     * @name Phaser.Tweens.PENDING_RENDER
	     * @type {integer}
	     * @since 3.0.0
	     */
	    PENDING_RENDER: 4,
	
	    /**
	     * TweenData state.
	     * 
	     * @name Phaser.Tweens.PLAYING_FORWARD
	     * @type {integer}
	     * @since 3.0.0
	     */
	    PLAYING_FORWARD: 5,
	
	    /**
	     * TweenData state.
	     * 
	     * @name Phaser.Tweens.PLAYING_BACKWARD
	     * @type {integer}
	     * @since 3.0.0
	     */
	    PLAYING_BACKWARD: 6,
	
	    /**
	     * TweenData state.
	     * 
	     * @name Phaser.Tweens.HOLD_DELAY
	     * @type {integer}
	     * @since 3.0.0
	     */
	    HOLD_DELAY: 7,
	
	    /**
	     * TweenData state.
	     * 
	     * @name Phaser.Tweens.REPEAT_DELAY
	     * @type {integer}
	     * @since 3.0.0
	     */
	    REPEAT_DELAY: 8,
	
	    /**
	     * TweenData state.
	     * 
	     * @name Phaser.Tweens.COMPLETE
	     * @type {integer}
	     * @since 3.0.0
	     */
	    COMPLETE: 9,
	
	    //  Tween specific (starts from 20 to cleanly allow extra TweenData consts in the future)
	
	    /**
	     * Tween state.
	     * 
	     * @name Phaser.Tweens.PENDING_ADD
	     * @type {integer}
	     * @since 3.0.0
	     */
	    PENDING_ADD: 20,
	
	    /**
	     * Tween state.
	     * 
	     * @name Phaser.Tweens.PAUSED
	     * @type {integer}
	     * @since 3.0.0
	     */
	    PAUSED: 21,
	
	    /**
	     * Tween state.
	     * 
	     * @name Phaser.Tweens.LOOP_DELAY
	     * @type {integer}
	     * @since 3.0.0
	     */
	    LOOP_DELAY: 22,
	
	    /**
	     * Tween state.
	     * 
	     * @name Phaser.Tweens.ACTIVE
	     * @type {integer}
	     * @since 3.0.0
	     */
	    ACTIVE: 23,
	
	    /**
	     * Tween state.
	     * 
	     * @name Phaser.Tweens.COMPLETE_DELAY
	     * @type {integer}
	     * @since 3.0.0
	     */
	    COMPLETE_DELAY: 24,
	
	    /**
	     * Tween state.
	     * 
	     * @name Phaser.Tweens.PENDING_REMOVE
	     * @type {integer}
	     * @since 3.0.0
	     */
	    PENDING_REMOVE: 25,
	
	    /**
	     * Tween state.
	     * 
	     * @name Phaser.Tweens.REMOVED
	     * @type {integer}
	     * @since 3.0.0
	     */
	    REMOVED: 26
	
	};
	
	module.exports = TWEEN_CONST;


/***/ }),
/* 175 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Removes a single item from an array and returns it without creating gc, like the native splice does.
	 * Based on code by Mike Reinstein.
	 *
	 * @function Phaser.Utils.Array.SpliceOne
	 * @since 3.0.0
	 *
	 * @param {array} array - [description]
	 * @param {integer} index - [description]
	 *
	 * @return {*} [description]
	 */
	var SpliceOne = function (array, index)
	{
	    if (index >= array.length)
	    {
	        return;
	    }
	
	    var len = array.length - 1;
	
	    var item = array[index];
	
	    for (var i = index; i < len; i++)
	    {
	        array[i] = array[i + 1];
	    }
	
	    array.length = len;
	
	    return item;
	};
	
	module.exports = SpliceOne;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(55);
	var toLength = __webpack_require__(21);
	var toAbsoluteIndex = __webpack_require__(109);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(8);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(46);
	var redefineAll = __webpack_require__(107);
	var meta = __webpack_require__(93);
	var forOf = __webpack_require__(102);
	var anInstance = __webpack_require__(101);
	var isObject = __webpack_require__(13);
	var fails = __webpack_require__(11);
	var $iterDetect = __webpack_require__(182);
	var setToStringTag = __webpack_require__(125);
	var inheritIfRequired = __webpack_require__(230);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var hide = __webpack_require__(45);
	var redefine = __webpack_require__(46);
	var fails = __webpack_require__(11);
	var defined = __webpack_require__(65);
	var wks = __webpack_require__(16);
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	  var fns = exec(defined, SYMBOL, ''[KEY]);
	  var strfn = fns[0];
	  var rxfn = fns[1];
	  if (fails(function () {
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  })) {
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(7);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(58);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(13);
	var cof = __webpack_require__(58);
	var MATCH = __webpack_require__(16)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(16)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(92) || !__webpack_require__(11)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(8)[K];
	});


/***/ }),
/* 184 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(40);
	var ctx = __webpack_require__(60);
	var forOf = __webpack_require__(102);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(2);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(59);
	var global = __webpack_require__(8);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(92) ? 'pure' : 'global',
	  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(7);
	var aFunction = __webpack_require__(40);
	var SPECIES = __webpack_require__(16)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var hide = __webpack_require__(45);
	var uid = __webpack_require__(110);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(437),
		__webpack_require__(27),
		__webpack_require__(439),
		__webpack_require__(111),
		__webpack_require__(430),
		__webpack_require__(432),
		__webpack_require__(431),
		__webpack_require__(433),
		__webpack_require__(428),
		__webpack_require__(429),
		__webpack_require__(427),
		__webpack_require__(974),
	
		__webpack_require__(69),
		__webpack_require__(426),
		__webpack_require__(255),
		__webpack_require__(416),
		__webpack_require__(112),
	
		__webpack_require__(62),
		__webpack_require__(132),
		__webpack_require__(41),
		__webpack_require__(131)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, concat, isFunction, push, access,
		rcheckableType, rtagName, rscriptType,
		wrapMap, getAll, setGlobalEval, buildFragment, support,
		dataPriv, dataUser, acceptData, DOMEval, nodeName ) {
	
	"use strict";
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		// [[Class]] -> type pairs
		return {};
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(155)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr ) {
		"use strict";
	
		return arr.slice;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	
	/**
	 * @callback DataEachCallback
	 *
	 * @param {*} parent - The parent object of the DataManager.
	 * @param {string} key - The key of the value.
	 * @param {*} value - The value.
	 * @param {...*} [args] - Additional arguments that will be passed to the callback, after the game object, key, and data.
	 */
	
	/**
	 * @classdesc
	 * The Data Component features a means to store pieces of data specific to a Game Object, System or Plugin.
	 * You can then search, query it, and retrieve the data. The parent must either extend EventEmitter,
	 * or have a property called `events` that is an instance of it.
	 *
	 * @class DataManager
	 * @memberOf Phaser.Data
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {object} parent - The object that this DataManager belongs to.
	 * @param {Phaser.Events.EventEmitter} eventEmitter - The DataManager's event emitter.
	 */
	var DataManager = new Class({
	
	    initialize:
	
	    function DataManager (parent, eventEmitter)
	    {
	        /**
	         * The object that this DataManager belongs to.
	         *
	         * @name Phaser.Data.DataManager#parent
	         * @type {*}
	         * @since 3.0.0
	         */
	        this.parent = parent;
	
	        /**
	         * The DataManager's event emitter.
	         *
	         * @name Phaser.Data.DataManager#events
	         * @type {Phaser.Events.EventEmitter}
	         * @since 3.0.0
	         */
	        this.events = eventEmitter;
	
	        if (!eventEmitter)
	        {
	            this.events = (parent.events) ? parent.events : parent;
	        }
	
	        /**
	         * The data list.
	         *
	         * @name Phaser.Data.DataManager#list
	         * @type {Object.<string, *>}
	         * @default {}
	         * @since 3.0.0
	         */
	        this.list = {};
	
	        /**
	         * Whether setting data is blocked for this DataManager.
	         *
	         * Used temporarily to allow 'changedata' event listeners to prevent
	         * specific data from being set.
	         *
	         * @name Phaser.Data.DataManager#blockSet
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.blockSet = false;
	
	        /**
	         * Whether setting data is frozen for this DataManager.
	         *
	         * @name Phaser.Data.DataManager#_frozen
	         * @type {boolean}
	         * @private
	         * @default false
	         * @since 3.0.0
	         */
	        this._frozen = false;
	
	        if (!parent.hasOwnProperty('sys') && this.events)
	        {
	            this.events.once('destroy', this.destroy, this);
	        }
	    },
	
	    /**
	     * Retrieves the value for the given key, or undefined if it doesn't exist.
	     *
	     * @method Phaser.Data.DataManager#get
	     * @since 3.0.0
	     *
	     * @param {string} key - The key of the value to retrieve.
	     *
	     * @return {*} The value belonging to the given key.
	     */
	    get: function (key)
	    {
	        return this.list[key];
	    },
	
	    /**
	     * Retrieves all data values.
	     *
	     * @method Phaser.Data.DataManager#getAll
	     * @since 3.0.0
	     *
	     * @return {Object.<string, *>} All data values.
	     */
	    getAll: function ()
	    {
	        var results = {};
	
	        for (var key in this.list)
	        {
	            if(this.list.hasOwnProperty(key))
	            {
	                results[key] = this.list[key];
	            }
	        }
	
	        return results;
	    },
	
	    /**
	     * Queries the DataManager for the values of keys matching the given search string.
	     *
	     * @method Phaser.Data.DataManager#query
	     * @since 3.0.0
	     *
	     * @param {string} search - The search string.
	     *
	     * @return {Object.<string, *>} The values of the keys matching the search string.
	     */
	    query: function (search)
	    {
	        var results = {};
	
	        for (var key in this.list)
	        {
	            if (this.list.hasOwnProperty(key) && key.match(search))
	            {
	                results[key] = this.list[key];
	            }
	        }
	
	        return results;
	    },
	
	    /**
	     * Sets the value for the given key.
	     *
	     * Emits the 'changedata' and 'setdata' events.
	     *
	     * @method Phaser.Data.DataManager#set
	     * @since 3.0.0
	     *
	     * @param {string} key - The key to set the value for.
	     * @param {*} data - The value to set.
	     *
	     * @return {Phaser.Data.DataManager} This DataManager object.
	     */
	    set: function (key, data)
	    {
	        if (this._frozen)
	        {
	            return this;
	        }
	
	        if (this.events.listenerCount('changedata') > 0)
	        {
	            this.blockSet = false;
	
	            var _this = this;
	
	            var resetFunction = function (value)
	            {
	                _this.blockSet = true;
	                _this.list[key] = value;
	                _this.events.emit('setdata', _this.parent, key, value);
	            };
	
	            this.events.emit('changedata', this.parent, key, data, resetFunction);
	
	            //  One of the listeners blocked this update from being set, so abort
	            if (this.blockSet)
	            {
	                return this;
	            }
	        }
	
	        this.list[key] = data;
	
	        this.events.emit('setdata', this.parent, key, data);
	
	        return this;
	    },
	
	    /**
	     * Passes all data entries to the given callback. Stores the result of the callback.
	     *
	     * @method Phaser.Data.DataManager#each
	     * @since 3.0.0
	     *
	     * @param {DataEachCallback} callback - The function to call.
	     * @param {*} [scope] - Value to use as `this` when executing callback.
	     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the game object, key, and data.
	     *
	     * @return {Phaser.Data.DataManager} This DataManager object.
	     */
	    each: function (callback, scope)
	    {
	        var args = [ this.parent, null, undefined ];
	
	        for (var i = 1; i < arguments.length; i++)
	        {
	            args.push(arguments[i]);
	        }
	
	        for (var key in this.list)
	        {
	            args[1] = key;
	            args[2] = this.list[key];
	
	            callback.apply(scope, args);
	        }
	
	        return this;
	    },
	
	    /**
	     * Merge the given data object into this DataManager's data object.
	     *
	     * @method Phaser.Data.DataManager#merge
	     * @since 3.0.0
	     *
	     * @param {Object.<string, *>} data - The data to merge.
	     * @param {boolean} overwrite - Whether to overwrite existing data. Defaults to true.
	     *
	     * @return {Phaser.Data.DataManager} This DataManager object.
	     */
	    merge: function (data, overwrite)
	    {
	        if (overwrite === undefined) { overwrite = true; }
	
	        //  Merge data from another component into this one
	        for (var key in data)
	        {
	            if (data.hasOwnProperty(key) && (overwrite || (!overwrite && !this.has(key))))
	            {
	                this.list[key] = data[key];
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Remove the value for the given key.
	     *
	     * @method Phaser.Data.DataManager#remove
	     * @since 3.0.0
	     *
	     * @param {string} key - The key to remove
	     *
	     * @return {Phaser.Data.DataManager} This DataManager object.
	     */
	    remove: function (key)
	    {
	        if (!this._frozen && this.has(key))
	        {
	            var data = this.list[key];
	
	            delete this.list[key];
	
	            this.events.emit('removedata', this, key, data);
	        }
	
	        return this;
	    },
	
	    /**
	     * Retrieves the data associated with the given 'key', deletes it from this Data store, then returns it.
	     *
	     * @method Phaser.Data.DataManager#pop
	     * @since 3.0.0
	     *
	     * @param {string} key - The key of the value to retrieve and delete.
	     *
	     * @return {*} The value of the given key.
	     */
	    pop: function (key)
	    {
	        var data = undefined;
	
	        if (!this._frozen && this.has(key))
	        {
	            data = this.list[key];
	
	            delete this.list[key];
	
	            this.events.emit('removedata', this, key, data);
	        }
	
	        return data;
	    },
	
	    /**
	     * Determines whether the given key is set in this Data store.
	     *
	     * @method Phaser.Data.DataManager#has
	     * @since 3.0.0
	     *
	     * @param {string} key - The key to check.
	     *
	     * @return {boolean} Whether the key is set.
	     */
	    has: function (key)
	    {
	        return this.list.hasOwnProperty(key);
	    },
	
	    /**
	     * Freeze or unfreeze this Data store, to allow or prevent setting its values.
	     *
	     * @method Phaser.Data.DataManager#setFreeze
	     * @since 3.0.0
	     *
	     * @param {boolean} value - Whether to freeze the Data store.
	     *
	     * @return {Phaser.Data.DataManager} This DataManager object.
	     */
	    setFreeze: function (value)
	    {
	        this._frozen = value;
	
	        return this;
	    },
	
	    /**
	     * Delete all data in this Data store and unfreeze it.
	     *
	     * @method Phaser.Data.DataManager#reset
	     * @since 3.0.0
	     *
	     * @return {Phaser.Data.DataManager} This DataManager object.
	     */
	    reset: function ()
	    {
	        for (var key in this.list)
	        {
	            delete this.list[key];
	        }
	
	        this.blockSet = false;
	        this._frozen = false;
	
	        return this;
	    },
	
	    /**
	     * Destroy this data manager.
	     *
	     * @method Phaser.Data.DataManager#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.reset();
	
	        this.events.off('changedata');
	        this.events.off('setdata');
	        this.events.off('removedata');
	
	        this.parent = null;
	    },
	
	    /**
	     * Freeze this Data component, so no values can be set.
	     *
	     * @name Phaser.Data.DataManager#freeze
	     * @type {boolean}
	     * @since 3.0.0
	     */
	    freeze: {
	
	        get: function ()
	        {
	            return this._frozen;
	        },
	
	        set: function (value)
	        {
	            this._frozen = (value) ? true : false;
	        }
	
	    },
	
	    /**
	     * Return the total number of entries in this Data component.
	     *
	     * @name Phaser.Data.DataManager#count
	     * @type {integer}
	     * @since 3.0.0
	     */
	    count: {
	
	        get: function ()
	        {
	            var i = 0;
	
	            for (var key in this.list)
	            {
	                if (this.list[key] !== undefined)
	                {
	                    i++;
	                }
	            }
	
	            return i;
	        }
	
	    }
	
	});
	
	module.exports = DataManager;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var OS = __webpack_require__(157);
	
	/**
	 * Determines the browser type and version running this Phaser Game instance.
	 * These values are read-only and populated during the boot sequence of the game.
	 * They are then referenced by internal game systems and are available for you to access
	 * via `this.sys.game.device.browser` from within any Scene.
	 * 
	 * @typedef {object} Phaser.Device.Browser
	 * @since 3.0.0
	 * 
	 * @property {boolean} chrome - Set to true if running in Chrome.
	 * @property {boolean} edge - Set to true if running in Microsoft Edge browser.
	 * @property {boolean} firefox - Set to true if running in Firefox.
	 * @property {boolean} ie - Set to true if running in Internet Explorer 11 or less (not Edge).
	 * @property {boolean} mobileSafari - Set to true if running in Mobile Safari.
	 * @property {boolean} opera - Set to true if running in Opera.
	 * @property {boolean} safari - Set to true if running in Safari.
	 * @property {boolean} silk - Set to true if running in the Silk browser (as used on the Amazon Kindle)
	 * @property {boolean} trident - Set to true if running a Trident version of Internet Explorer (IE11+)
	 * @property {number} chromeVersion - If running in Chrome this will contain the major version number.
	 * @property {number} firefoxVersion - If running in Firefox this will contain the major version number.
	 * @property {number} ieVersion - If running in Internet Explorer this will contain the major version number. Beyond IE10 you should use Browser.trident and Browser.tridentVersion.
	 * @property {number} safariVersion - If running in Safari this will contain the major version number.
	 * @property {number} tridentVersion - If running in Internet Explorer 11 this will contain the major version number. See {@link http://msdn.microsoft.com/en-us/library/ie/ms537503(v=vs.85).aspx}
	 */
	var Browser = {
	
	    chrome: false,
	    chromeVersion: 0,
	    edge: false,
	    firefox: false,
	    firefoxVersion: 0,
	    ie: false,
	    ieVersion: 0,
	    mobileSafari: false,
	    opera: false,
	    safari: false,
	    safariVersion: 0,
	    silk: false,
	    trident: false,
	    tridentVersion: 0
	
	};
	
	function init ()
	{
	    var ua = navigator.userAgent;
	
	    if (/Edge\/\d+/.test(ua))
	    {
	        Browser.edge = true;
	    }
	    else if ((/Chrome\/(\d+)/).test(ua) && !OS.windowsPhone)
	    {
	        Browser.chrome = true;
	        Browser.chromeVersion = parseInt(RegExp.$1, 10);
	    }
	    else if ((/Firefox\D+(\d+)/).test(ua))
	    {
	        Browser.firefox = true;
	        Browser.firefoxVersion = parseInt(RegExp.$1, 10);
	    }
	    else if ((/AppleWebKit/).test(ua) && OS.iOS)
	    {
	        Browser.mobileSafari = true;
	    }
	    else if ((/MSIE (\d+\.\d+);/).test(ua))
	    {
	        Browser.ie = true;
	        Browser.ieVersion = parseInt(RegExp.$1, 10);
	    }
	    else if ((/Opera/).test(ua))
	    {
	        Browser.opera = true;
	    }
	    else if ((/Safari/).test(ua) && !OS.windowsPhone)
	    {
	        Browser.safari = true;
	    }
	    else if ((/Trident\/(\d+\.\d+)(.*)rv:(\d+\.\d+)/).test(ua))
	    {
	        Browser.ie = true;
	        Browser.trident = true;
	        Browser.tridentVersion = parseInt(RegExp.$1, 10);
	        Browser.ieVersion = parseInt(RegExp.$3, 10);
	    }
	
	    //  Silk gets its own if clause because its ua also contains 'Safari'
	    if ((/Silk/).test(ua))
	    {
	        Browser.silk = true;
	    }
	
	    return Browser;
	}
	
	module.exports = init();


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(28);
	var GameObject = __webpack_require__(5);
	var MeshRender = __webpack_require__(1161);
	
	/**
	 * @classdesc
	 * A Mesh Game Object.
	 *
	 * @class Mesh
	 * @extends Phaser.GameObjects.GameObject
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @webglOnly
	 * @since 3.0.0
	 *
	 * @extends Phaser.GameObjects.Components.Alpha
	 * @extends Phaser.GameObjects.Components.BlendMode
	 * @extends Phaser.GameObjects.Components.Depth
	 * @extends Phaser.GameObjects.Components.Flip
	 * @extends Phaser.GameObjects.Components.GetBounds
	 * @extends Phaser.GameObjects.Components.Mask
	 * @extends Phaser.GameObjects.Components.Origin
	 * @extends Phaser.GameObjects.Components.Pipeline
	 * @extends Phaser.GameObjects.Components.ScaleMode
	 * @extends Phaser.GameObjects.Components.Size
	 * @extends Phaser.GameObjects.Components.Texture
	 * @extends Phaser.GameObjects.Components.Transform
	 * @extends Phaser.GameObjects.Components.Visible
	 * @extends Phaser.GameObjects.Components.ScrollFactor
	 *
	 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {float[]} vertices - An array containing the vertices data for this Mesh.
	 * @param {float[]} uv - An array containing the uv data for this Mesh.
	 * @param {float[]} colors - An array containing the color data for this Mesh.
	 * @param {float[]} alphas - An array containing the alpha data for this Mesh.
	 * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	 * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	 */
	var Mesh = new Class({
	
	    Extends: GameObject,
	
	    Mixins: [
	        Components.Alpha,
	        Components.BlendMode,
	        Components.Depth,
	        Components.Flip,
	        Components.GetBounds,
	        Components.Mask,
	        Components.Origin,
	        Components.Pipeline,
	        Components.ScaleMode,
	        Components.Size,
	        Components.Texture,
	        Components.Transform,
	        Components.Visible,
	        Components.ScrollFactor,
	        MeshRender
	    ],
	
	    initialize:
	
	    function Mesh (scene, x, y, vertices, uv, colors, alphas, texture, frame)
	    {
	        GameObject.call(this, scene, 'Mesh');
	
	        this.setTexture(texture, frame);
	        this.setPosition(x, y);
	        this.setSizeToFrame();
	        this.setOrigin();
	        this.initPipeline('TextureTintPipeline');
	
	        if (vertices.length !== uv.length)
	        {
	            throw new Error('Mesh Vertex count must match UV count');
	        }
	
	        var verticesUB = (vertices.length / 2) | 0;
	
	        if (colors.length > 0 && colors.length < verticesUB)
	        {
	            throw new Error('Mesh Color count must match Vertex count');
	        }
	
	        if (alphas.length > 0 && alphas.length < verticesUB)
	        {
	            throw new Error('Mesh Alpha count must match Vertex count');
	        }
	
	        var i;
	
	        if (colors.length === 0)
	        {
	            for (i = 0; i < verticesUB; ++i)
	            {
	                colors[i] = 0xFFFFFF;
	            }
	        }
	
	        if (alphas.length === 0)
	        {
	            for (i = 0; i < verticesUB; ++i)
	            {
	                alphas[i] = 1.0;
	            }
	        }
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Mesh#vertices
	         * @type {Float32Array}
	         * @since 3.0.0
	         */
	        this.vertices = new Float32Array(vertices);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Mesh#uv
	         * @type {Float32Array}
	         * @since 3.0.0
	         */
	        this.uv = new Float32Array(uv);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Mesh#colors
	         * @type {Uint32Array}
	         * @since 3.0.0
	         */
	        this.colors = new Uint32Array(colors);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Mesh#alphas
	         * @type {Float32Array}
	         * @since 3.0.0
	         */
	        this.alphas = new Float32Array(alphas);
	    }
	
	});
	
	module.exports = Mesh;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var GameObject = __webpack_require__(5);
	var Sprite = __webpack_require__(82);
	var Vector2 = __webpack_require__(9);
	var Vector4 = __webpack_require__(310);
	
	/**
	 * @classdesc
	 * A Sprite 3D Game Object.
	 *
	 * The Sprite 3D object is an encapsulation of a standard Sprite object, with additional methods to allow
	 * it to be rendered by a 3D Camera. The Sprite can be positioned anywhere within 3D space.
	 *
	 * @class Sprite3D
	 * @extends Phaser.GameObjects.GameObject
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
	 * @param {number} x - The x position of this Game Object.
	 * @param {number} y - The y position of this Game Object.
	 * @param {number} z - The z position of this Game Object.
	 * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	 * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	 */
	var Sprite3D = new Class({
	
	    Extends: GameObject,
	
	    initialize:
	
	    function Sprite3D (scene, x, y, z, texture, frame)
	    {
	        GameObject.call(this, scene, 'Sprite3D');
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Sprite3D#gameObject
	         * @type {Phaser.GameObjects.GameObject}
	         * @since 3.0.0
	         */
	        this.gameObject = new Sprite(scene, 0, 0, texture, frame);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Sprite3D#position
	         * @type {Phaser.Math.Vector4}
	         * @since 3.0.0
	         */
	        this.position = new Vector4(x, y, z);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Sprite3D#size
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.size = new Vector2(this.gameObject.width, this.gameObject.height);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Sprite3D#scale
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.scale = new Vector2(1, 1);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Sprite3D#adjustScaleX
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.adjustScaleX = true;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Sprite3D#adjustScaleY
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.adjustScaleY = true;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Sprite3D#_visible
	         * @type {boolean}
	         * @default true
	         * @private
	         * @since 3.0.0
	         */
	        this._visible = true;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Sprite3D#project
	     * @since 3.0.0
	     *
	     * @param {Phaser.Cameras.Sprite3D.Camera} camera - The 3D Camera onto which to project this Sprite.
	     */
	    project: function (camera)
	    {
	        var pos = this.position;
	
	        var gameObject = this.gameObject;
	
	        camera.project(pos, gameObject);
	
	        camera.getPointSize(pos, this.size, this.scale);
	
	        if (this.scale.x <= 0 || this.scale.y <= 0)
	        {
	            gameObject.setVisible(false);
	        }
	        else
	        {
	            if (!gameObject.visible)
	            {
	                gameObject.setVisible(true);
	            }
	
	            if (this.adjustScaleX)
	            {
	                gameObject.scaleX = this.scale.x;
	            }
	
	            if (this.adjustScaleY)
	            {
	                gameObject.scaleY = this.scale.y;
	            }
	
	            gameObject.setDepth(gameObject.z * -1);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Sprite3D#setVisible
	     * @since 3.0.0
	     *
	     * @param {boolean} value - [description]
	     *
	     * @return {Phaser.GameObjects.Sprite3D} This Sprite3D Object.
	     */
	    setVisible: function (value)
	    {
	        this.visible = value;
	
	        return this;
	    },
	
	    /**
	     * The visible state of the Game Object.
	     *
	     * An invisible Game Object will skip rendering, but will still process update logic.
	     *
	     * @name Phaser.GameObjects.Sprite3D#visible
	     * @type {boolean}
	     * @since 3.0.0
	     */
	    visible: {
	
	        get: function ()
	        {
	            return this._visible;
	        },
	
	        set: function (value)
	        {
	            this._visible = value;
	            this.gameObject.visible = value;
	        }
	
	    },
	
	    /**
	     * The x position of this Game Object.
	     *
	     * @name Phaser.GameObjects.Sprite3D#x
	     * @type {number}
	     * @since 3.0.0
	     */
	    x: {
	
	        get: function ()
	        {
	            return this.position.x;
	        },
	
	        set: function (value)
	        {
	            this.position.x = value;
	        }
	
	    },
	
	    /**
	     * The y position of this Game Object.
	     *
	     * @name Phaser.GameObjects.Sprite3D#y
	     * @type {number}
	     * @since 3.0.0
	     */
	    y: {
	
	        get: function ()
	        {
	            return this.position.y;
	        },
	
	        set: function (value)
	        {
	            this.position.y = value;
	        }
	
	    },
	
	    /**
	     * The z position of this Game Object.
	     *
	     * @name Phaser.GameObjects.Sprite3D#z
	     * @type {number}
	     * @since 3.0.0
	     */
	    z: {
	
	        get: function ()
	        {
	            return this.position.z;
	        },
	
	        set: function (value)
	        {
	            this.position.z = value;
	        }
	
	    }
	
	});
	
	module.exports = Sprite3D;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BlendModes = __webpack_require__(145);
	var Circle = __webpack_require__(160);
	var CircleContains = __webpack_require__(83);
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(28);
	var GameObject = __webpack_require__(5);
	var Rectangle = __webpack_require__(23);
	var RectangleContains = __webpack_require__(84);
	
	/**
	 * @classdesc
	 * A Zone Game Object.
	 *
	 * A Zone is a non-rendering rectangular Game Object that has a position and size.
	 * It has no texture and never displays, but does live on the display list and
	 * can be moved, scaled and rotated like any other Game Object.
	 *
	 * Its primary use is for creating Drop Zones and Input Hit Areas and it has a couple of helper methods
	 * specifically for this. It is also useful for object overlap checks, or as a base for your own
	 * non-displaying Game Objects.
	
	 * The default origin is 0.5, the center of the Zone, the same as with Game Objects.
	 *
	 * @class Zone
	 * @extends Phaser.GameObjects.GameObject
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @since 3.0.0
	 *
	 * @extends Phaser.GameObjects.Components.Depth
	 * @extends Phaser.GameObjects.Components.GetBounds
	 * @extends Phaser.GameObjects.Components.Origin
	 * @extends Phaser.GameObjects.Components.ScaleMode
	 * @extends Phaser.GameObjects.Components.Transform
	 * @extends Phaser.GameObjects.Components.ScrollFactor
	 * @extends Phaser.GameObjects.Components.Visible
	 *
	 * @param {Phaser.Scene} scene - [description]
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {number} [width=1] - The width of the Game Object.
	 * @param {number} [height=1] - The height of the Game Object.
	 */
	var Zone = new Class({
	
	    Extends: GameObject,
	
	    Mixins: [
	        Components.Depth,
	        Components.GetBounds,
	        Components.Origin,
	        Components.ScaleMode,
	        Components.Transform,
	        Components.ScrollFactor,
	        Components.Visible
	    ],
	
	    initialize:
	
	    function Zone (scene, x, y, width, height)
	    {
	        if (width === undefined) { width = 1; }
	        if (height === undefined) { height = width; }
	
	        GameObject.call(this, scene, 'Zone');
	
	        this.setPosition(x, y);
	
	        /**
	         * The native (un-scaled) width of this Game Object.
	         *
	         * @name Phaser.GameObjects.Zone#width
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.width = width;
	
	        /**
	         * The native (un-scaled) height of this Game Object.
	         *
	         * @name Phaser.GameObjects.Zone#height
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.height = height;
	
	        /**
	         * The Blend Mode of the Game Object.
	         * Although a Zone never renders, it still has a blend mode to allow it to fit seamlessly into
	         * display lists without causing a batch flush.
	         *
	         * @name Phaser.GameObjects.Zone#blendMode
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.blendMode = BlendModes.NORMAL;
	    },
	
	    /**
	     * The displayed width of this Game Object.
	     * This value takes into account the scale factor.
	     *
	     * @name Phaser.GameObjects.Zone#displayWidth
	     * @type {number}
	     * @since 3.0.0
	     */
	    displayWidth: {
	
	        get: function ()
	        {
	            return this.scaleX * this.width;
	        },
	
	        set: function (value)
	        {
	            this.scaleX = value / this.width;
	        }
	
	    },
	
	    /**
	     * The displayed height of this Game Object.
	     * This value takes into account the scale factor.
	     *
	     * @name Phaser.GameObjects.Zone#displayHeight
	     * @type {number}
	     * @since 3.0.0
	     */
	    displayHeight: {
	
	        get: function ()
	        {
	            return this.scaleY * this.height;
	        },
	
	        set: function (value)
	        {
	            this.scaleY = value / this.height;
	        }
	
	    },
	
	    /**
	     * Sets the size of this Game Object.
	     *
	     * @method Phaser.GameObjects.Zone#setSize
	     * @since 3.0.0
	     *
	     * @param {number} width - The width of this Game Object.
	     * @param {number} height - The height of this Game Object.
	     * @param {boolean} [resizeInput=true] - If this Zone has a Rectangle for a hit area this argument will resize the hit area as well.
	     *
	     * @return {Phaser.GameObjects.Zone} This Game Object.
	     */
	    setSize: function (width, height, resizeInput)
	    {
	        if (resizeInput === undefined) { resizeInput = true; }
	
	        this.width = width;
	        this.height = height;
	
	        if (resizeInput && this.input && this.input.hitArea instanceof Rectangle)
	        {
	            this.input.hitArea.width = width;
	            this.input.hitArea.height = height;
	        }
	
	        return this;
	    },
	
	    /**
	     * Sets the display size of this Game Object.
	     * Calling this will adjust the scale.
	     *
	     * @method Phaser.GameObjects.Zone#setDisplaySize
	     * @since 3.0.0
	     *
	     * @param {number} width - The width of this Game Object.
	     * @param {number} height - The height of this Game Object.
	     *
	     * @return {Phaser.GameObjects.Zone} This Game Object.
	     */
	    setDisplaySize: function (width, height)
	    {
	        this.displayWidth = width;
	        this.displayHeight = height;
	
	        return this;
	    },
	
	    /**
	     * Sets this Zone to be a Circular Drop Zone.
	     * The circle is centered on this Zones `x` and `y` coordinates.
	     *
	     * @method Phaser.GameObjects.Zone#setCircleDropZone
	     * @since 3.0.0
	     *
	     * @param {number} radius - The radius of the Circle that will form the Drop Zone.
	     *
	     * @return {Phaser.GameObjects.Zone} This Game Object.
	     */
	    setCircleDropZone: function (radius)
	    {
	        return this.setDropZone(new Circle(0, 0, radius), CircleContains);
	    },
	
	    /**
	     * Sets this Zone to be a Rectangle Drop Zone.
	     * The rectangle is centered on this Zones `x` and `y` coordinates.
	     *
	     * @method Phaser.GameObjects.Zone#setRectangleDropZone
	     * @since 3.0.0
	     *
	     * @param {number} width - The width of the rectangle drop zone.
	     * @param {number} height - The height of the rectangle drop zone.
	     *
	     * @return {Phaser.GameObjects.Zone} This Game Object.
	     */
	    setRectangleDropZone: function (width, height)
	    {
	        var x = -(width / 2);
	        var y = -(height / 2);
	
	        return this.setDropZone(new Rectangle(x, y, width, height), RectangleContains);
	    },
	
	    /**
	     * Allows you to define your own Geometry shape to be used as a Drop Zone.
	     *
	     * @method Phaser.GameObjects.Zone#setDropZone
	     * @since 3.0.0
	     *
	     * @param {object} shape - A Geometry shape instance, such as Phaser.Geom.Ellipse, or your own custom shape.
	     * @param {HitAreaCallback} callback - A function that will return `true` if the given x/y coords it is sent are within the shape.
	     *
	     * @return {Phaser.GameObjects.Zone} This Game Object.
	     */
	    setDropZone: function (shape, callback)
	    {
	        if (shape === undefined)
	        {
	            this.setRectangleDropZone(this.width, this.height);
	        }
	        else
	        if (!this.input)
	        {
	            this.setInteractive(shape, callback, true);
	        }
	
	        return this;
	    },
	
	    /**
	     * A Zone does not render.
	     *
	     * @method Phaser.GameObjects.Zone#renderCanvas
	     * @private
	     * @since 3.0.0
	     */
	    renderCanvas: function ()
	    {
	    },
	
	    /**
	     * A Zone does not render.
	     *
	     * @method Phaser.GameObjects.Zone#renderWebGL
	     * @private
	     * @since 3.0.0
	     */
	    renderWebGL: function ()
	    {
	    }
	
	});
	
	module.exports = Zone;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	
	//  This is based off an explanation and expanded math presented by Paul Bourke:
	//  See http:'local.wasp.uwa.edu.au/~pbourke/geometry/lineline2d/
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Intersects.LineToLine
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Line} line1 - [description]
	 * @param {Phaser.Geom.Line} line2 - [description]
	 * @param {Phaser.Geom.Point} [out] - [description]
	 *
	 * @return {boolean} [description]
	 */
	var LineToLine = function (line1, line2, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    var x1 = line1.x1;
	    var y1 = line1.y1;
	    var x2 = line1.x2;
	    var y2 = line1.y2;
	
	    var x3 = line2.x1;
	    var y3 = line2.y1;
	    var x4 = line2.x2;
	    var y4 = line2.y2;
	
	    var numA = (x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3);
	    var numB = (x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3);
	    var deNom = (y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1);
	
	    //  Make sure there is not a division by zero - this also indicates that the lines are parallel.
	    //  If numA and numB were both equal to zero the lines would be on top of each other (coincidental).
	    //  This check is not done because it is not necessary for this implementation (the parallel check accounts for this).
	
	    if (deNom === 0)
	    {
	        return false;
	    }
	
	    //  Calculate the intermediate fractional point that the lines potentially intersect.
	
	    var uA = numA / deNom;
	    var uB = numB / deNom;
	
	    //  The fractional point will be between 0 and 1 inclusive if the lines intersect.
	    //  If the fractional calculation is larger than 1 or smaller than 0 the lines would need to be longer to intersect.
	
	    if (uA >= 0 && uA <= 1 && uB >= 0 && uB <= 1)
	    {
	        out.x = x1 + (uA * (x2 - x1));
	        out.y = y1 + (uA * (y2 - y1));
	
	        return true;
	    }
	
	    return false;
	};
	
	module.exports = LineToLine;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var GetPoint = __webpack_require__(514);
	var GetPoints = __webpack_require__(290);
	var Random = __webpack_require__(291);
	var Vector2 = __webpack_require__(9);
	
	/**
	 * @classdesc
	 * Defines a Line segment, a part of a line between two endpoints.
	 *
	 * @class Line
	 * @memberOf Phaser.Geom
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {number} [x1=0] - The x coordinate of the lines starting point.
	 * @param {number} [y1=0] - The y coordinate of the lines starting point.
	 * @param {number} [x2=0] - The x coordinate of the lines ending point.
	 * @param {number} [y2=0] - The y coordinate of the lines ending point.
	 */
	var Line = new Class({
	
	    initialize:
	
	    function Line (x1, y1, x2, y2)
	    {
	        if (x1 === undefined) { x1 = 0; }
	        if (y1 === undefined) { y1 = 0; }
	        if (x2 === undefined) { x2 = 0; }
	        if (y2 === undefined) { y2 = 0; }
	
	        /**
	         * The x coordinate of the lines starting point.
	         *
	         * @name Phaser.Geom.Line#x1
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.x1 = x1;
	
	        /**
	         * The y coordinate of the lines starting point.
	         *
	         * @name Phaser.Geom.Line#y1
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.y1 = y1;
	
	        /**
	         * The x coordinate of the lines ending point.
	         *
	         * @name Phaser.Geom.Line#x2
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.x2 = x2;
	
	        /**
	         * The y coordinate of the lines ending point.
	         *
	         * @name Phaser.Geom.Line#y2
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.y2 = y2;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Geom.Line#getPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Point} O - [output,$return]
	     *
	     * @param {float} position - [description]
	     * @param {(Phaser.Geom.Point|object)} [output] - [description]
	     *
	     * @return {(Phaser.Geom.Point|object)} A Point, or point-like object, containing the coordinates of the point on the line.
	     */
	    getPoint: function (position, output)
	    {
	        return GetPoint(this, position, output);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Geom.Line#getPoints
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Point} O - [output,$return]
	     *
	     * @param {integer} quantity - [description]
	     * @param {integer} [stepRate] - [description]
	     * @param {(array|Phaser.Geom.Point[])} [output] - [description]
	     *
	     * @return {(array|Phaser.Geom.Point[])} [description]
	     */
	    getPoints: function (quantity, stepRate, output)
	    {
	        return GetPoints(this, quantity, stepRate, output);
	    },
	
	    /**
	     * Get a random Point on the Line.
	     *
	     * @method Phaser.Geom.Line#getRandomPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Point} O - [point,$return]
	     *
	     * @param {(Phaser.Geom.Point|object)} [point] - An instance of a Point to be modified.
	     *
	     * @return {Phaser.Geom.Point} A random Point on the Line.
	     */
	    getRandomPoint: function (point)
	    {
	        return Random(this, point);
	    },
	
	    /**
	     * Set new coordinates for the line endpoints.
	     *
	     * @method Phaser.Geom.Line#setTo
	     * @since 3.0.0
	     *
	     * @param {number} [x1=0] - The x coordinate of the lines starting point.
	     * @param {number} [y1=0] - The y coordinate of the lines starting point.
	     * @param {number} [x2=0] - The x coordinate of the lines ending point.
	     * @param {number} [y2=0] - The y coordinate of the lines ending point.
	     *
	     * @return {Phaser.Geom.Line} This Line object.
	     */
	    setTo: function (x1, y1, x2, y2)
	    {
	        if (x1 === undefined) { x1 = 0; }
	        if (y1 === undefined) { y1 = 0; }
	        if (x2 === undefined) { x2 = 0; }
	        if (y2 === undefined) { y2 = 0; }
	
	        this.x1 = x1;
	        this.y1 = y1;
	
	        this.x2 = x2;
	        this.y2 = y2;
	
	        return this;
	    },
	
	    /**
	     * Returns a Vector2 object that corresponds to the start of this Line.
	     *
	     * @method Phaser.Geom.Line#getPointA
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [vec2,$return]
	     *
	     * @param {Phaser.Math.Vector2} [vec2] - A Vector2 object to set the results in. If `undefined` a new Vector2 will be created.
	     *
	     * @return {Phaser.Math.Vector2} A Vector2 object that corresponds to the start of this Line.
	     */
	    getPointA: function (vec2)
	    {
	        if (vec2 === undefined) { vec2 = new Vector2(); }
	
	        vec2.set(this.x1, this.y1);
	
	        return vec2;
	    },
	
	    /**
	     * Returns a Vector2 object that corresponds to the start of this Line.
	     *
	     * @method Phaser.Geom.Line#getPointB
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [vec2,$return]
	     *
	     * @param {Phaser.Math.Vector2} [vec2] - A Vector2 object to set the results in. If `undefined` a new Vector2 will be created.
	     *
	     * @return {Phaser.Math.Vector2} A Vector2 object that corresponds to the start of this Line.
	     */
	    getPointB: function (vec2)
	    {
	        if (vec2 === undefined) { vec2 = new Vector2(); }
	
	        vec2.set(this.x2, this.y2);
	
	        return vec2;
	    },
	
	    /**
	     * The left position of the Line.
	     *
	     * @name Phaser.Geom.Line#left
	     * @type {number}
	     * @since 3.0.0
	     */
	    left: {
	
	        get: function ()
	        {
	            return Math.min(this.x1, this.x2);
	        },
	
	        set: function (value)
	        {
	            if (this.x1 <= this.x2)
	            {
	                this.x1 = value;
	            }
	            else
	            {
	                this.x2 = value;
	            }
	        }
	
	    },
	
	    /**
	     * The right position of the Line.
	     *
	     * @name Phaser.Geom.Line#right
	     * @type {number}
	     * @since 3.0.0
	     */
	    right: {
	
	        get: function ()
	        {
	            return Math.max(this.x1, this.x2);
	        },
	
	        set: function (value)
	        {
	            if (this.x1 > this.x2)
	            {
	                this.x1 = value;
	            }
	            else
	            {
	                this.x2 = value;
	            }
	        }
	
	    },
	
	    /**
	     * The top position of the Line.
	     *
	     * @name Phaser.Geom.Line#top
	     * @type {number}
	     * @since 3.0.0
	     */
	    top: {
	
	        get: function ()
	        {
	            return Math.min(this.y1, this.y2);
	        },
	
	        set: function (value)
	        {
	            if (this.y1 <= this.y2)
	            {
	                this.y1 = value;
	            }
	            else
	            {
	                this.y2 = value;
	            }
	        }
	
	    },
	
	    /**
	     * The bottom position of the Line.
	     *
	     * @name Phaser.Geom.Line#bottom
	     * @type {number}
	     * @since 3.0.0
	     */
	    bottom: {
	
	        get: function ()
	        {
	            return Math.max(this.y1, this.y2);
	        },
	
	        set: function (value)
	        {
	            if (this.y1 > this.y2)
	            {
	                this.y1 = value;
	            }
	            else
	            {
	                this.y2 = value;
	            }
	        }
	
	    }
	
	});
	
	module.exports = Line;


/***/ }),
/* 201 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.Perimeter
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 *
	 * @return {number} [description]
	 */
	var Perimeter = function (rect)
	{
	    return 2 * (rect.width + rect.height);
	};
	
	module.exports = Perimeter;


/***/ }),
/* 202 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @typedef {object} XHRSettingsObject
	 *
	 * @property {XMLHttpRequestResponseType} responseType - The response type of the XHR request, i.e. `blob`, `text`, etc.
	 * @property {boolean} [async=true] - Should the XHR request use async or not?
	 * @property {string} [user=''] - Optional username for the XHR request.
	 * @property {string} [password=''] - Optional password for the XHR request.
	 * @property {integer} [timeout=0] - Optional XHR timeout value.
	 * @property {(string|undefined)} [header] - This value is used to populate the XHR `setRequestHeader` and is undefined by default.
	 * @property {(string|undefined)} [headerValue] - This value is used to populate the XHR `setRequestHeader` and is undefined by default.
	 * @property {(string|undefined)} [requestedWith] - This value is used to populate the XHR `setRequestHeader` and is undefined by default.
	 * @property {(string|undefined)} [overrideMimeType] - Provide a custom mime-type to use instead of the default.
	 */
	
	/**
	 * Creates an XHRSettings Object with default values.
	 *
	 * @function Phaser.Loader.XHRSettings
	 * @since 3.0.0
	 *
	 * @param {XMLHttpRequestResponseType} [responseType=''] - The responseType, such as 'text'.
	 * @param {boolean} [async=true] - Should the XHR request use async or not?
	 * @param {string} [user=''] - Optional username for the XHR request.
	 * @param {string} [password=''] - Optional password for the XHR request.
	 * @param {integer} [timeout=0] - Optional XHR timeout value.
	 *
	 * @return {XHRSettingsObject} The XHRSettings object as used by the Loader.
	 */
	var XHRSettings = function (responseType, async, user, password, timeout)
	{
	    if (responseType === undefined) { responseType = ''; }
	    if (async === undefined) { async = true; }
	    if (user === undefined) { user = ''; }
	    if (password === undefined) { password = ''; }
	    if (timeout === undefined) { timeout = 0; }
	
	    // Before sending a request, set the xhr.responseType to "text",
	    // "arraybuffer", "blob", or "document", depending on your data needs.
	    // Note, setting xhr.responseType = '' (or omitting) will default the response to "text".
	
	    return {
	
	        //  Ignored by the Loader, only used by File.
	        responseType: responseType,
	
	        async: async,
	
	        //  credentials
	        user: user,
	        password: password,
	
	        //  timeout in ms (0 = no timeout)
	        timeout: timeout,
	
	        //  setRequestHeader
	        header: undefined,
	        headerValue: undefined,
	        requestedWith: false,
	
	        //  overrideMimeType
	        overrideMimeType: undefined
	
	    };
	};
	
	module.exports = XHRSettings;


/***/ }),
/* 203 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Checks if the given `width` and `height` are a power of two.
	 * Useful for checking texture dimensions.
	 *
	 * @function Phaser.Math.Pow2.IsSizePowerOfTwo
	 * @since 3.0.0
	 *
	 * @param {number} width - The width.
	 * @param {number} height - The height.
	 *
	 * @return {boolean} `true` if `width` and `height` are a power of two, otherwise `false`.
	 */
	var IsSizePowerOfTwo = function (width, height)
	{
	    return (width > 0 && (width & (width - 1)) === 0 && height > 0 && (height & (height - 1)) === 0);
	};
	
	module.exports = IsSizePowerOfTwo;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(590);
	var Sprite = __webpack_require__(82);
	
	/**
	 * @classdesc
	 * An Arcade Physics Sprite Game Object.
	 *
	 * A Sprite Game Object is used for the display of both static and animated images in your game.
	 * Sprites can have input events and physics bodies. They can also be tweened, tinted, scrolled
	 * and animated.
	 *
	 * The main difference between a Sprite and an Image Game Object is that you cannot animate Images.
	 * As such, Sprites take a fraction longer to process and have a larger API footprint due to the Animation
	 * Component. If you do not require animation then you can safely use Images to replace Sprites in all cases.
	 *
	 * @class Sprite
	 * @extends Phaser.GameObjects.Sprite
	 * @memberOf Phaser.Physics.Arcade
	 * @constructor
	 * @since 3.0.0
	 *
	 * @extends Phaser.Physics.Arcade.Components.Acceleration
	 * @extends Phaser.Physics.Arcade.Components.Angular
	 * @extends Phaser.Physics.Arcade.Components.Bounce
	 * @extends Phaser.Physics.Arcade.Components.Debug
	 * @extends Phaser.Physics.Arcade.Components.Drag
	 * @extends Phaser.Physics.Arcade.Components.Enable
	 * @extends Phaser.Physics.Arcade.Components.Friction
	 * @extends Phaser.Physics.Arcade.Components.Gravity
	 * @extends Phaser.Physics.Arcade.Components.Immovable
	 * @extends Phaser.Physics.Arcade.Components.Mass
	 * @extends Phaser.Physics.Arcade.Components.Size
	 * @extends Phaser.Physics.Arcade.Components.Velocity
	 * @extends Phaser.GameObjects.Components.Alpha
	 * @extends Phaser.GameObjects.Components.BlendMode
	 * @extends Phaser.GameObjects.Components.Depth
	 * @extends Phaser.GameObjects.Components.Flip
	 * @extends Phaser.GameObjects.Components.GetBounds
	 * @extends Phaser.GameObjects.Components.Origin
	 * @extends Phaser.GameObjects.Components.Pipeline
	 * @extends Phaser.GameObjects.Components.ScaleMode
	 * @extends Phaser.GameObjects.Components.ScrollFactor
	 * @extends Phaser.GameObjects.Components.Size
	 * @extends Phaser.GameObjects.Components.Texture
	 * @extends Phaser.GameObjects.Components.Tint
	 * @extends Phaser.GameObjects.Components.Transform
	 * @extends Phaser.GameObjects.Components.Visible
	 *
	 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	 * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	 */
	var ArcadeSprite = new Class({
	
	    Extends: Sprite,
	
	    Mixins: [
	        Components.Acceleration,
	        Components.Angular,
	        Components.Bounce,
	        Components.Debug,
	        Components.Drag,
	        Components.Enable,
	        Components.Friction,
	        Components.Gravity,
	        Components.Immovable,
	        Components.Mass,
	        Components.Size,
	        Components.Velocity
	    ],
	
	    initialize:
	
	    function ArcadeSprite (scene, x, y, texture, frame)
	    {
	        Sprite.call(this, scene, x, y, texture, frame);
	    }
	
	});
	
	module.exports = ArcadeSprite;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Physics.Matter.Components
	 */
	
	module.exports = {
	
	    Bounce: __webpack_require__(1471),
	    Collision: __webpack_require__(1472),
	    Force: __webpack_require__(1473),
	    Friction: __webpack_require__(1474),
	    Gravity: __webpack_require__(1475),
	    Mass: __webpack_require__(1476),
	    Static: __webpack_require__(1480),
	    Sensor: __webpack_require__(1477),
	    SetBody: __webpack_require__(1478),
	    Sleep: __webpack_require__(1479),
	    Transform: __webpack_require__(1481),
	    Velocity: __webpack_require__(1482)
	
	};


/***/ }),
/* 206 */
/***/ (function(module, exports) {

	/**
	* The `Matter.Pair` module contains methods for creating and manipulating collision pairs.
	*
	* @class Pair
	*/
	
	var Pair = {};
	
	module.exports = Pair;
	
	(function() {
	    
	    /**
	     * Creates a pair.
	     * @method create
	     * @param {collision} collision
	     * @param {number} timestamp
	     * @return {pair} A new pair
	     */
	    Pair.create = function(collision, timestamp) {
	        var bodyA = collision.bodyA,
	            bodyB = collision.bodyB;
	
	        var pair = {
	            id: Pair.id(bodyA, bodyB),
	            bodyA: bodyA,
	            bodyB: bodyB,
	            activeContacts: [],
	            separation: 0,
	            isActive: true,
	            confirmedActive: true,
	            isSensor: bodyA.isSensor || bodyB.isSensor,
	            timeCreated: timestamp,
	            timeUpdated: timestamp,
	
	            collision: null,
	            inverseMass: 0,
	            friction: 0,
	            frictionStatic: 0,
	            restitution: 0,
	            slop: 0
	        };
	
	        Pair.update(pair, collision, timestamp);
	
	        return pair;
	    };
	
	    /**
	     * Updates a pair given a collision.
	     * @method update
	     * @param {pair} pair
	     * @param {collision} collision
	     * @param {number} timestamp
	     */
	    Pair.update = function(pair, collision, timestamp) {
	        // var contacts = pair.contacts,
	        //     supports = collision.supports,
	        //     activeContacts = pair.activeContacts,
	        //     parentA = collision.parentA,
	        //     parentB = collision.parentB;
	        
	        pair.collision = collision;
	        // pair.inverseMass = parentA.inverseMass + parentB.inverseMass;
	        // pair.friction = Math.min(parentA.friction, parentB.friction);
	        // pair.frictionStatic = Math.max(parentA.frictionStatic, parentB.frictionStatic);
	        // pair.restitution = Math.max(parentA.restitution, parentB.restitution);
	        // pair.slop = Math.max(parentA.slop, parentB.slop);
	        // activeContacts.length = 0;
	        
	        if (collision.collided) {
	
	            var supports = collision.supports,
	                activeContacts = pair.activeContacts,
	                parentA = collision.parentA,
	                parentB = collision.parentB;
	
	            pair.inverseMass = parentA.inverseMass + parentB.inverseMass;
	            pair.friction = Math.min(parentA.friction, parentB.friction);
	            pair.frictionStatic = Math.max(parentA.frictionStatic, parentB.frictionStatic);
	            pair.restitution = Math.max(parentA.restitution, parentB.restitution);
	            pair.slop = Math.max(parentA.slop, parentB.slop);
	
	            for (var i = 0; i < supports.length; i++) {
	                activeContacts[i] = supports[i].contact;
	            }
	
	            var supportCount = supports.length;
	
	            if (supportCount < activeContacts.length) {
	                activeContacts.length = supportCount;
	            }
	
	            pair.separation = collision.depth;
	            Pair.setActive(pair, true, timestamp);
	        } else {
	            if (pair.isActive === true)
	                Pair.setActive(pair, false, timestamp);
	        }
	    };
	    
	    /**
	     * Set a pair as active or inactive.
	     * @method setActive
	     * @param {pair} pair
	     * @param {bool} isActive
	     * @param {number} timestamp
	     */
	    Pair.setActive = function(pair, isActive, timestamp) {
	        if (isActive) {
	            pair.isActive = true;
	            pair.timeUpdated = timestamp;
	        } else {
	            pair.isActive = false;
	            pair.activeContacts.length = 0;
	        }
	    };
	
	    /**
	     * Get the id for the given pair.
	     * @method id
	     * @param {body} bodyA
	     * @param {body} bodyB
	     * @return {string} Unique pairId
	     */
	    Pair.id = function(bodyA, bodyB) {
	        if (bodyA.id < bodyB.id) {
	            return 'A' + bodyA.id + 'B' + bodyB.id;
	        } else {
	            return 'A' + bodyB.id + 'B' + bodyA.id;
	        }
	    };
	
	})();


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Felipe Alfonso <@bitnenfer>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Utils = __webpack_require__(87);
	
	/**
	 * @classdesc
	 * WebGLPipeline is a class that describes the way elements will be rendererd 
	 * in WebGL, specially focused on batching vertices (batching is not provided). 
	 * Pipelines are mostly used for describing 2D rendering passes but it's 
	 * flexible enough to be used for any type of rendering including 3D. 
	 * Internally WebGLPipeline will handle things like compiling shaders,
	 * creating vertex buffers, assigning primitive topology and binding 
	 * vertex attributes.
	 *
	 * The config properties are:
	 * - game: Current game instance.
	 * - renderer: Current WebGL renderer.
	 * - gl: Current WebGL context.
	 * - topology: This indicates how the primitives are rendered. The default value is GL_TRIANGLES.
	 *              Here is the full list of rendering primitives (https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/Constants).
	 * - vertShader: Source for vertex shader as a string.
	 * - fragShader: Source for fragment shader as a string.
	 * - vertexCapacity: The amount of vertices that shall be allocated
	 * - vertexSize: The size of a single vertex in bytes.
	 * - vertices: An optional buffer of vertices
	 * - attributes: An array describing the vertex attributes
	 *  
	 * The vertex attributes properties are:
	 * - name : String - Name of the attribute in the vertex shader
	 * - size : integer - How many components describe the attribute. For ex: vec3 = size of 3, float = size of 1
	 * - type : GLenum - WebGL type (gl.BYTE, gl.SHORT, gl.UNSIGNED_BYTE, gl.UNSIGNED_SHORT, gl.FLOAT)
	 * - normalized : boolean - Is the attribute normalized
	 * - offset : integer - The offset in bytes to the current attribute in the vertex. Equivalent to offsetof(vertex, attrib) in C
	 * Here you can find more information of how to describe an attribute:
	 * - https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/vertexAttribPointer
	 *
	 * @class WebGLPipeline
	 * @memberOf Phaser.Renderer.WebGL
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {object} config - [description]
	 */
	var WebGLPipeline = new Class({
	
	    initialize:
	
	    function WebGLPipeline (config)
	    {
	        /**
	         * Name of the Pipeline. Used for identifying
	         *
	         * @name Phaser.Renderer.WebGL.WebGLPipeline#name
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.name = 'WebGLPipeline';
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.WebGL.WebGLPipeline#game
	         * @type {Phaser.Game}
	         * @since 3.0.0
	         */
	        this.game = config.game;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.WebGL.WebGLPipeline#view
	         * @type {HTMLCanvasElement}
	         * @since 3.0.0
	         */
	        this.view = config.game.canvas;
	
	        /**
	         * Used to store the current game resolution
	         *
	         * @name Phaser.Renderer.WebGL.WebGLPipeline#resolution
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.resolution = config.game.config.resolution;
	
	        /**
	         * Width of the current viewport
	         *
	         * @name Phaser.Renderer.WebGL.WebGLPipeline#width
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.width = config.game.config.width * this.resolution;
	
	        /**
	         * Height of the current viewport
	         *
	         * @name Phaser.Renderer.WebGL.WebGLPipeline#height
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.height = config.game.config.height * this.resolution;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.WebGL.WebGLPipeline#gl
	         * @type {WebGLRenderingContext}
	         * @since 3.0.0
	         */
	        this.gl = config.gl;
	
	        /**
	         * How many vertices have been fed to the current pipeline.
	         *
	         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexCount
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.vertexCount = 0;
	
	        /**
	         * The limit of vertices that the pipeline can hold
	         *
	         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexCapacity
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.vertexCapacity = config.vertexCapacity;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.WebGL.WebGLPipeline#renderer
	         * @type {Phaser.Renderer.WebGL.WebGLRenderer}
	         * @since 3.0.0
	         */
	        this.renderer = config.renderer;
	
	        /**
	         * Raw byte buffer of vertices.
	         *
	         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexData
	         * @type {ArrayBuffer}
	         * @since 3.0.0
	         */
	        this.vertexData = (config.vertices ? config.vertices : new ArrayBuffer(config.vertexCapacity * config.vertexSize));
	
	        /**
	         * The handle to a WebGL vertex buffer object.
	         *
	         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexBuffer
	         * @type {WebGLBuffer}
	         * @since 3.0.0
	         */
	        this.vertexBuffer = this.renderer.createVertexBuffer((config.vertices ? config.vertices : this.vertexData.byteLength), this.gl.STREAM_DRAW);
	
	        /**
	         * The handle to a WebGL program
	         *
	         * @name Phaser.Renderer.WebGL.WebGLPipeline#program
	         * @type {WebGLProgram}
	         * @since 3.0.0
	         */
	        this.program = this.renderer.createProgram(config.vertShader, config.fragShader);
	
	        /**
	         * Array of objects that describe the vertex attributes
	         *
	         * @name Phaser.Renderer.WebGL.WebGLPipeline#attributes
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.attributes = config.attributes;
	
	        /**
	         * The size in bytes of the vertex
	         *
	         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexSize
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.vertexSize = config.vertexSize;
	
	        /**
	         * The primitive topology which the pipeline will use to submit draw calls
	         *
	         * @name Phaser.Renderer.WebGL.WebGLPipeline#topology
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.topology = config.topology;
	
	        /**
	         * Uint8 view to the vertex raw buffer. Used for uploading vertex buffer resources
	         * to the GPU.
	         *
	         * @name Phaser.Renderer.WebGL.WebGLPipeline#bytes
	         * @type {Uint8Array}
	         * @since 3.0.0
	         */
	        this.bytes = new Uint8Array(this.vertexData);
	
	        /**
	         * This will store the amount of components of 32 bit length
	         *
	         * @name Phaser.Renderer.WebGL.WebGLPipeline#vertexComponentCount
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.vertexComponentCount = Utils.getComponentCount(config.attributes, this.gl);
	
	        /**
	         * Indicates if the current pipeline is flushing the contents to the GPU.
	         * When the variable is set the flush function will be locked.
	         *
	         * @name Phaser.Renderer.WebGL.WebGLPipeline#flushLocked
	         * @type {boolean}
	         * @since 3.1.0
	         */
	        this.flushLocked = false;
	    },
	
	    /**
	     * Adds a description of vertex attribute to the pipeline
	     *
	     * @method Phaser.Renderer.WebGL.WebGLPipeline#addAttribute
	     * @since 3.2.0
	     *
	     * @param {string} name - Name of the vertex attribute
	     * @param {integer} size - Vertex component size
	     * @param {integer} type - Type of the attribute
	     * @param {boolean} normalized - Is the value normalized to a range
	     * @param {integer} offset - Byte offset to the beginning of the first element in the vertex
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} [description]
	     */
	    addAttribute: function (name, size, type, normalized, offset)
	    {
	        this.attributes.push({
	            name: name,
	            size: size,
	            type: this.renderer.glFormats[type],
	            normalized: normalized,
	            offset: offset
	        });
	
	        return this;
	    },
	
	    /**
	     * Check if the current batch of vertices is full.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLPipeline#shouldFlush
	     * @since 3.0.0
	     *
	     * @return {boolean} [description]
	     */
	    shouldFlush: function ()
	    {
	        return (this.vertexCount >= this.vertexCapacity);
	    },
	
	    /**
	     * Resizes the properties used to describe the viewport
	     *
	     * @method Phaser.Renderer.WebGL.WebGLPipeline#resize
	     * @since 3.0.0
	     *
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     * @param {number} resolution - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} [description]
	     */
	    resize: function (width, height, resolution)
	    {
	        this.width = width * resolution;
	        this.height = height * resolution;
	        return this;
	    },
	
	    /**
	     * Binds the pipeline resources, including programs, vertex buffers and binds attributes
	     *
	     * @method Phaser.Renderer.WebGL.WebGLPipeline#bind
	     * @since 3.0.0
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} [description]
	     */
	    bind: function ()
	    {
	        var gl = this.gl;
	        var vertexBuffer = this.vertexBuffer;
	        var attributes = this.attributes;
	        var program = this.program;
	        var renderer = this.renderer;
	        var vertexSize = this.vertexSize;
	
	        renderer.setProgram(program);
	        renderer.setVertexBuffer(vertexBuffer);
	
	        for (var index = 0; index < attributes.length; ++index)
	        {
	            var element = attributes[index];
	            var location = gl.getAttribLocation(program, element.name);
	
	            if (location >= 0)
	            {
	                gl.enableVertexAttribArray(location);
	                gl.vertexAttribPointer(location, element.size, element.type, element.normalized, vertexSize, element.offset);
	            }
	            else
	            {
	                gl.disableVertexAttribArray(location);
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLPipeline#onBind
	     * @since 3.0.0
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} [description]
	     */
	    onBind: function ()
	    {
	        // This is for updating uniform data it's called on each bind attempt.
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLPipeline#onPreRender
	     * @since 3.0.0
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} [description]
	     */
	    onPreRender: function ()
	    {
	        // called once every frame
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLPipeline#onRender
	     * @since 3.0.0
	     *
	     * @param {Phaser.Scene} scene - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} [description]
	     */
	    onRender: function ()
	    {
	        // called for each camera
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLPipeline#onPostRender
	     * @since 3.0.0
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} [description]
	     */
	    onPostRender: function ()
	    {
	        // called once every frame
	        return this;
	    },
	
	    /**
	     * Uploads the vertex data and emits a draw call
	     * for the current batch of vertices.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLPipeline#flush
	     * @since 3.0.0
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} [description]
	     */
	    flush: function ()
	    {
	        if (this.flushLocked) { return this; }
	
	        this.flushLocked = true;
	
	        var gl = this.gl;
	        var vertexCount = this.vertexCount;
	        var topology = this.topology;
	        var vertexSize = this.vertexSize;
	
	        if (vertexCount === 0)
	        {
	            this.flushLocked = false;
	            return;
	        }
	
	        gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.bytes.subarray(0, vertexCount * vertexSize));
	        gl.drawArrays(topology, 0, vertexCount);
	
	        this.vertexCount = 0;
	        this.flushLocked = false;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLPipeline#destroy
	     * @since 3.0.0
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} [description]
	     */
	    destroy: function ()
	    {
	        var gl = this.gl;
	
	        gl.deleteProgram(this.program);
	        gl.deleteBuffer(this.vertexBuffer);
	
	        delete this.program;
	        delete this.vertexBuffer;
	        delete this.gl;
	
	        return this;
	    },
	
	    /**
	     * Set a uniform value of the current pipeline program.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLPipeline#setFloat1
	     * @since 3.2.0
	     *
	     * @param {string} name - [description]
	     * @param {float} x - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} [description]
	     */
	    setFloat1: function (name, x)
	    {
	        this.renderer.setFloat1(this.program, name, x);
	        return this;
	    },
	
	    /**
	     * Set a uniform value of the current pipeline program.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLPipeline#setFloat2
	     * @since 3.2.0
	     *
	     * @param {string} name - [description]
	     * @param {float} x - [description]
	     * @param {float} y - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} [description]
	     */
	    setFloat2: function (name, x, y)
	    {
	
	        this.renderer.setFloat2(this.program, name, x, y);
	        return this;
	    },
	
	    /**
	     * Set a uniform value of the current pipeline program.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLPipeline#setFloat3
	     * @since 3.2.0
	     *
	     * @param {string} name - [description]
	     * @param {float} x - [description]
	     * @param {float} y - [description]
	     * @param {float} z - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} [description]
	     */
	    setFloat3: function (name, x, y, z)
	    {
	
	        this.renderer.setFloat3(this.program, name, x, y, z);
	        return this;
	    },
	
	    /**
	     * Set a uniform value of the current pipeline program.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLPipeline#setFloat4
	     * @since 3.2.0
	     *
	     * @param {string} name - Name of the uniform
	     * @param {float} x - X component of the uniform
	     * @param {float} y - Y component of the uniform
	     * @param {float} z - Z component of the uniform
	     * @param {float} w - W component of the uniform
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} [description]
	     */
	    setFloat4: function (name, x, y, z, w)
	    {
	
	        this.renderer.setFloat4(this.program, name, x, y, z, w);
	        return this;
	    },
	
	    /**
	     * Set a uniform value of the current pipeline program.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLPipeline#setInt1
	     * @since 3.2.0
	     *
	     * @param {string} name - [description]
	     * @param {integer} x - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} [description]
	     */
	    setInt1: function (name, x)
	    {
	        this.renderer.setInt1(this.program, name, x);
	        return this;
	    },
	
	    /**
	     * Set a uniform value of the current pipeline program.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLPipeline#setInt2
	     * @since 3.2.0
	     *
	     * @param {string} name - [description]
	     * @param {integer} x - [description]
	     * @param {integer} y - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} [description]
	     */
	    setInt2: function (name, x, y)
	    {
	        this.renderer.setInt2(this.program, name, x, y);
	        return this;
	    },
	
	    /**
	     * Set a uniform value of the current pipeline program.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLPipeline#setInt3
	     * @since 3.2.0
	     *
	     * @param {string} name - [description]
	     * @param {integer} x - [description]
	     * @param {integer} y - [description]
	     * @param {integer} z - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} [description]
	     */
	    setInt3: function (name, x, y, z)
	    {
	        this.renderer.setInt3(this.program, name, x, y, z);
	        return this;
	    },
	
	    /**
	     * Set a uniform value of the current pipeline program.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLPipeline#setInt4
	     * @since 3.2.0
	     *
	     * @param {string} name - Name of the uniform
	     * @param {integer} x - X component of the uniform
	     * @param {integer} y - Y component of the uniform
	     * @param {integer} z - Z component of the uniform
	     * @param {integer} w - W component of the uniform
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} [description]
	     */
	    setInt4: function (name, x, y, z, w)
	    {
	        this.renderer.setInt4(this.program, name, x, y, z, w);
	        return this;
	    },
	
	    /**
	     * Set a uniform value of the current pipeline program.
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLPipeline#setMatrix2
	     * @since 3.2.0
	     *
	     * @param {string} name - [description]
	     * @param {boolean} transpose - [description]
	     * @param {Float32Array} matrix - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} [description]
	     */
	    setMatrix2: function (name, transpose, matrix)
	    {
	        this.renderer.setMatrix2(this.program, name, transpose, matrix);
	        return this;
	    },
	
	    /**
	     * Set a uniform value of the current pipeline program.
	     * [description]
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLPipeline#setMatrix3
	     * @since 3.2.0
	     *
	     * @param {string} name - [description]
	     * @param {boolean} transpose - [description]
	     * @param {Float32Array} matrix - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} [description]
	     */
	    setMatrix3: function (name, transpose, matrix)
	    {
	        this.renderer.setMatrix3(this.program, name, transpose, matrix);
	        return this;
	    },
	
	    /**
	     * Set a uniform value of the current pipeline program.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLPipeline#setMatrix4
	     * @since 3.2.0
	     *
	     * @param {string} name - Name of the uniform
	     * @param {boolean} transpose - Should the matrix be transpose
	     * @param {Float32Array} matrix - Matrix data
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} [description]
	     */
	    setMatrix4: function (name, transpose, matrix)
	    {
	        this.renderer.setMatrix4(this.program, name, transpose, matrix);
	        return this;
	    }
	
	});
	
	module.exports = WebGLPipeline;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var EventEmitter = __webpack_require__(22);
	var Extend = __webpack_require__(36);
	var NOOP = __webpack_require__(6);
	
	/**
	 * @classdesc
	 * Class containing all the shared state and behavior of a sound object, independent of the implementation.
	 *
	 * @class BaseSound
	 * @extends Phaser.Events.EventEmitter
	 * @memberOf Phaser.Sound
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Sound.BaseSoundManager} manager - Reference to the current sound manager instance.
	 * @param {string} key - Asset key for the sound.
	 * @param {SoundConfig} [config] - An optional config object containing default sound settings.
	 */
	var BaseSound = new Class({
	
	    Extends: EventEmitter,
	
	    initialize:
	
	    function BaseSound (manager, key, config)
	    {
	        EventEmitter.call(this);
	
	        /**
	         * Local reference to the sound manager.
	         *
	         * @name Phaser.Sound.BaseSound#manager
	         * @type {Phaser.Sound.BaseSoundManager}
	         * @private
	         * @since 3.0.0
	         */
	        this.manager = manager;
	
	        /**
	         * Asset key for the sound.
	         *
	         * @name Phaser.Sound.BaseSound#key
	         * @type {string}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.key = key;
	
	        /**
	         * Flag indicating if sound is currently playing.
	         *
	         * @name Phaser.Sound.BaseSound#isPlaying
	         * @type {boolean}
	         * @default false
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.isPlaying = false;
	
	        /**
	         * Flag indicating if sound is currently paused.
	         *
	         * @name Phaser.Sound.BaseSound#isPaused
	         * @type {boolean}
	         * @default false
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.isPaused = false;
	
	        /**
	         * A property that holds the value of sound's actual playback rate,
	         * after its rate and detune values has been combined with global
	         * rate and detune values.
	         *
	         * @name Phaser.Sound.BaseSound#totalRate
	         * @type {number}
	         * @default 1
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.totalRate = 1;
	
	        /**
	         * A value representing the duration, in seconds.
	         * It could be total sound duration or a marker duration.
	         *
	         * @name Phaser.Sound.BaseSound#duration
	         * @type {number}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.duration = this.duration || 0;
	
	        /**
	         * The total duration of the sound in seconds.
	         *
	         * @name Phaser.Sound.BaseSound#totalDuration
	         * @type {number}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.totalDuration = this.totalDuration || 0;
	
	        /**
	         * A config object used to store default sound settings' values.
	         * Default values will be set by properties' setters.
	         *
	         * @name Phaser.Sound.BaseSound#config
	         * @type {SoundConfig}
	         * @private
	         * @since 3.0.0
	         */
	        this.config = {
	
	            mute: false,
	            volume: 1,
	            rate: 1,
	            detune: 0,
	            seek: 0,
	            loop: false,
	            delay: 0
	
	        };
	
	        /**
	         * Reference to the currently used config.
	         * It could be default config or marker config.
	         *
	         * @name Phaser.Sound.BaseSound#currentConfig
	         * @type {SoundConfig}
	         * @private
	         * @since 3.0.0
	         */
	        this.currentConfig = this.config;
	
	        this.config = Extend(this.config, config);
	
	        /**
	         * Object containing markers definitions.
	         *
	         * @name Phaser.Sound.BaseSound#markers
	         * @type {Object.<string, SoundMarker>}
	         * @default {}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.markers = {};
	
	        /**
	         * Currently playing marker.
	         * 'null' if whole sound is playing.
	         *
	         * @name Phaser.Sound.BaseSound#currentMarker
	         * @type {SoundMarker}
	         * @default null
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.currentMarker = null;
	
	        /**
	         * Flag indicating if destroy method was called on this sound.
	         *
	         * @name Phaser.Sound.BaseSound#pendingRemove
	         * @type {boolean}
	         * @private
	         * @default false
	         * @since 3.0.0
	         */
	        this.pendingRemove = false;
	    },
	
	    /**
	     * Adds a marker into the current sound. A marker is represented by name, start time, duration, and optionally config object.
	     * This allows you to bundle multiple sounds together into a single audio file and use markers to jump between them for playback.
	     *
	     * @method Phaser.Sound.BaseSound#addMarker
	     * @since 3.0.0
	     *
	     * @param {SoundMarker} marker - Marker object.
	     *
	     * @return {boolean} Whether the marker was added successfully.
	     */
	    addMarker: function (marker)
	    {
	        if (!marker || !marker.name || typeof marker.name !== 'string')
	        {
	            return false;
	        }
	
	        if (this.markers[marker.name])
	        {
	            // eslint-disable-next-line no-console
	            console.error('addMarker ' + marker.name + ' already exists in Sound');
	
	            return false;
	        }
	
	        marker = Extend(true, {
	            name: '',
	            start: 0,
	            duration: this.totalDuration - (marker.start || 0),
	            config: {
	                mute: false,
	                volume: 1,
	                rate: 1,
	                detune: 0,
	                seek: 0,
	                loop: false,
	                delay: 0
	            }
	        }, marker);
	
	        this.markers[marker.name] = marker;
	
	        return true;
	    },
	
	    /**
	     * Updates previously added marker.
	     *
	     * @method Phaser.Sound.BaseSound#updateMarker
	     * @since 3.0.0
	     *
	     * @param {SoundMarker} marker - Marker object with updated values.
	     *
	     * @return {boolean} Whether the marker was updated successfully.
	     */
	    updateMarker: function (marker)
	    {
	        if (!marker || !marker.name || typeof marker.name !== 'string')
	        {
	            return false;
	        }
	
	        if (!this.markers[marker.name])
	        {
	            // eslint-disable-next-line no-console
	            console.warn('Audio Marker: ' + marker.name + ' missing in Sound: ' + this.key);
	
	            return false;
	        }
	
	        this.markers[marker.name] = Extend(true, this.markers[marker.name], marker);
	
	        return true;
	    },
	
	    /**
	     * Removes a marker from the sound.
	     *
	     * @method Phaser.Sound.BaseSound#removeMarker
	     * @since 3.0.0
	     *
	     * @param {string} markerName - The name of the marker to remove.
	     *
	     * @return {?SoundMarker} Removed marker object or 'null' if there was no marker with provided name.
	     */
	    removeMarker: function (markerName)
	    {
	        var marker = this.markers[markerName];
	
	        if (!marker)
	        {
	            return null;
	        }
	
	        this.markers[markerName] = null;
	
	        return marker;
	    },
	
	    /**
	     * Play this sound, or a marked section of it.
	     * It always plays the sound from the start. If you want to start playback from a specific time
	     * you can set 'seek' setting of the config object, provided to this call, to that value.
	     *
	     * @method Phaser.Sound.BaseSound#play
	     * @since 3.0.0
	     *
	     * @param {string} [markerName=''] - If you want to play a marker then provide the marker name here, otherwise omit it to play the full sound.
	     * @param {SoundConfig} [config] - Optional sound config object to be applied to this marker or entire sound if no marker name is provided. It gets memorized for future plays of current section of the sound.
	     *
	     * @return {boolean} Whether the sound started playing successfully.
	     */
	    play: function (markerName, config)
	    {
	        if (markerName === undefined) { markerName = ''; }
	
	        if (typeof markerName === 'object')
	        {
	            config = markerName;
	            markerName = '';
	        }
	
	        if (typeof markerName !== 'string')
	        {
	            return false;
	        }
	
	        if (!markerName)
	        {
	            this.currentMarker = null;
	            this.currentConfig = this.config;
	            this.duration = this.totalDuration;
	        }
	        else
	        {
	            if (!this.markers[markerName])
	            {
	                // eslint-disable-next-line no-console
	                console.warn('Marker: ' + markerName + ' missing in Sound: ' + this.key);
	
	                return false;
	            }
	
	            this.currentMarker = this.markers[markerName];
	            this.currentConfig = this.currentMarker.config;
	            this.duration = this.currentMarker.duration;
	        }
	
	        this.resetConfig();
	
	        this.currentConfig = Extend(this.currentConfig, config);
	
	        this.isPlaying = true;
	        this.isPaused = false;
	
	        return true;
	    },
	
	    /**
	     * Pauses the sound.
	     *
	     * @method Phaser.Sound.BaseSound#pause
	     * @since 3.0.0
	     *
	     * @return {boolean} Whether the sound was paused successfully.
	     */
	    pause: function ()
	    {
	        if (this.isPaused || !this.isPlaying)
	        {
	            return false;
	        }
	
	        this.isPlaying = false;
	        this.isPaused = true;
	
	        return true;
	    },
	
	    /**
	     * Resumes the sound.
	     *
	     * @method Phaser.Sound.BaseSound#resume
	     * @since 3.0.0
	     *
	     * @return {boolean} Whether the sound was resumed successfully.
	     */
	    resume: function ()
	    {
	        if (!this.isPaused || this.isPlaying)
	        {
	            return false;
	        }
	
	        this.isPlaying = true;
	        this.isPaused = false;
	
	        return true;
	    },
	
	    /**
	     * Stop playing this sound.
	     *
	     * @method Phaser.Sound.BaseSound#stop
	     * @since 3.0.0
	     *
	     * @return {boolean} Whether the sound was stopped successfully.
	     */
	    stop: function ()
	    {
	        if (!this.isPaused && !this.isPlaying)
	        {
	            return false;
	        }
	
	        this.isPlaying = false;
	        this.isPaused = false;
	
	        this.resetConfig();
	
	        return true;
	    },
	
	    /**
	     * Method used internally for applying config values to some of the sound properties.
	     *
	     * @method Phaser.Sound.BaseSound#applyConfig
	     * @protected
	     * @since 3.0.0
	     */
	    applyConfig: function ()
	    {
	        this.mute = this.currentConfig.mute;
	        this.volume = this.currentConfig.volume;
	        this.rate = this.currentConfig.rate;
	        this.detune = this.currentConfig.detune;
	        this.loop = this.currentConfig.loop;
	    },
	
	    /**
	     * Method used internally for resetting values of some of the config properties.
	     *
	     * @method Phaser.Sound.BaseSound#resetConfig
	     * @protected
	     * @since 3.0.0
	     */
	    resetConfig: function ()
	    {
	        this.currentConfig.seek = 0;
	        this.currentConfig.delay = 0;
	    },
	
	    /**
	     * Update method called automatically by sound manager on every game step.
	     *
	     * @method Phaser.Sound.BaseSound#update
	     * @override
	     * @protected
	     * @since 3.0.0
	     *
	     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
	     * @param {number} delta - The delta time elapsed since the last frame.
	     */
	    update: NOOP,
	
	    /**
	     * Method used internally to calculate total playback rate of the sound.
	     *
	     * @method Phaser.Sound.BaseSound#calculateRate
	     * @protected
	     * @since 3.0.0
	     */
	    calculateRate: function ()
	    {
	        var cent = 1.0005777895065548; // Math.pow(2, 1/1200);
	        var totalDetune = this.currentConfig.detune + this.manager.detune;
	        var detuneRate = Math.pow(cent, totalDetune);
	
	        this.totalRate = this.currentConfig.rate * this.manager.rate * detuneRate;
	    },
	
	    /**
	     * Destroys this sound and all associated events and marks it for removal from the sound manager.
	     *
	     * @method Phaser.Sound.BaseSound#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        if (this.pendingRemove)
	        {
	            return;
	        }
	
	        this.emit('destroy', this);
	        this.pendingRemove = true;
	        this.manager = null;
	        this.key = '';
	        this.removeAllListeners();
	        this.isPlaying = false;
	        this.isPaused = false;
	        this.config = null;
	        this.currentConfig = null;
	        this.markers = null;
	        this.currentMarker = null;
	    }
	
	});
	
	module.exports = BaseSound;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Clone = __webpack_require__(123);
	var EventEmitter = __webpack_require__(22);
	var NOOP = __webpack_require__(6);
	
	/**
	 * @callback EachActiveSoundCallback
	 *
	 * @param {Phaser.Sound.BaseSoundManager} manager - [description]
	 * @param {Phaser.Sound.BaseSound} sound - [description]
	 * @param {number} index - [description]
	 * @param {Phaser.Sound.BaseSound[]} sounds - [description]
	 */
	
	/**
	 * Audio sprite sound type.
	 *
	 * @typedef {Phaser.Sound.BaseSound} Phaser.Sound.BaseSound.AudioSpriteSound
	 *
	 * @property {object} spritemap - Local reference to 'spritemap' object form json file generated by audiosprite tool.
	 */
	
	/**
	 * @classdesc
	 * The sound manager is responsible for playing back audio via Web Audio API or HTML Audio tag as fallback.
	 * The audio file type and the encoding of those files are extremely important.
	 *
	 * Not all browsers can play all audio formats.
	 *
	 * There is a good guide to what's supported [here](https://developer.mozilla.org/en-US/Apps/Fundamentals/Audio_and_video_delivery/Cross-browser_audio_basics#Audio_Codec_Support).
	 *
	 * @class BaseSoundManager
	 * @extends Phaser.Events.EventEmitter
	 * @memberOf Phaser.Sound
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Game} game - Reference to the current game instance.
	 */
	var BaseSoundManager = new Class({
	
	    Extends: EventEmitter,
	
	    initialize:
	
	    function BaseSoundManager (game)
	    {
	        EventEmitter.call(this);
	
	        /**
	         * Local reference to game.
	         *
	         * @name Phaser.Sound.BaseSoundManager#game
	         * @type {Phaser.Game}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.game = game;
	
	        /**
	         * Local reference to the JSON Cache, as used by Audio Sprites.
	         *
	         * @name Phaser.Sound.BaseSoundManager#jsonCache
	         * @type {Phaser.Cache.BaseCache}
	         * @readOnly
	         * @since 3.7.0
	         */
	        this.jsonCache = game.cache.json;
	
	        /**
	         * An array containing all added sounds.
	         *
	         * @name Phaser.Sound.BaseSoundManager#sounds
	         * @type {Phaser.Sound.BaseSound[]}
	         * @default []
	         * @private
	         * @since 3.0.0
	         */
	        this.sounds = [];
	
	        /**
	         * Global mute setting.
	         *
	         * @name Phaser.Sound.BaseSoundManager#mute
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.mute = false;
	
	        /**
	         * Global volume setting.
	         *
	         * @name Phaser.Sound.BaseSoundManager#volume
	         * @type {number}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.volume = 1;
	
	        /**
	         * Flag indicating if sounds should be paused when game looses focus,
	         * for instance when user switches to another tab/program/app.
	         *
	         * @name Phaser.Sound.BaseSoundManager#pauseOnBlur
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.pauseOnBlur = true;
	
	        /**
	         * Property that actually holds the value of global playback rate.
	         *
	         * @name Phaser.Sound.BaseSoundManager#_rate
	         * @type {number}
	         * @private
	         * @default 1
	         * @since 3.0.0
	         */
	        this._rate = 1;
	
	        /**
	         * Property that actually holds the value of global detune.
	         *
	         * @name Phaser.Sound.BaseSoundManager#_detune
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._detune = 0;
	
	        /**
	         * Mobile devices require sounds to be triggered from an explicit user action,
	         * such as a tap, before any sound can be loaded/played on a web page.
	         * Set to true if the audio system is currently locked awaiting user interaction.
	         *
	         * @name Phaser.Sound.BaseSoundManager#locked
	         * @type {boolean}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.locked = this.locked || false;
	
	        /**
	         * Flag used internally for handling when the audio system
	         * has been unlocked, if there ever was a need for it.
	         *
	         * @name Phaser.Sound.BaseSoundManager#unlocked
	         * @type {boolean}
	         * @default false
	         * @private
	         * @since 3.0.0
	         */
	        this.unlocked = false;
	
	        game.events.on('blur', function ()
	        {
	            if (this.pauseOnBlur)
	            {
	                this.onBlur();
	            }
	        }, this);
	
	        game.events.on('focus', function ()
	        {
	            if (this.pauseOnBlur)
	            {
	                this.onFocus();
	            }
	        }, this);
	
	        game.events.on('prestep', this.update, this);
	        game.events.once('destroy', this.destroy, this);
	    },
	
	    /**
	     * Adds a new sound into the sound manager.
	     *
	     * @method Phaser.Sound.BaseSoundManager#add
	     * @override
	     * @since 3.0.0
	     *
	     * @param {string} key - Asset key for the sound.
	     * @param {SoundConfig} [config] - An optional config object containing default sound settings.
	     *
	     * @return {Phaser.Sound.BaseSound} The new sound instance.
	     */
	    add: NOOP,
	
	    /**
	     * Adds a new audio sprite sound into the sound manager.
	     * Audio Sprites are a combination of audio files and a JSON configuration.
	     * The JSON follows the format of that created by https://github.com/tonistiigi/audiosprite
	     *
	     * @method Phaser.Sound.BaseSoundManager#addAudioSprite
	     * @since 3.0.0
	     *
	     * @param {string} key - Asset key for the sound.
	     * @param {SoundConfig} [config] - An optional config object containing default sound settings.
	     *
	     * @return {Phaser.Sound.BaseSound.AudioSpriteSound} The new audio sprite sound instance.
	     */
	    addAudioSprite: function (key, config)
	    {
	        if (config === undefined) { config = {}; }
	
	        var sound = this.add(key, config);
	
	        sound.spritemap = this.jsonCache.get(key).spritemap;
	
	        for (var markerName in sound.spritemap)
	        {
	            if (!sound.spritemap.hasOwnProperty(markerName))
	            {
	                continue;
	            }
	
	            var markerConfig = Clone(config);
	
	            var marker = sound.spritemap[markerName];
	
	            markerConfig.loop = (marker.hasOwnProperty('loop')) ? marker.loop : false;
	
	            sound.addMarker({
	                name: markerName,
	                start: marker.start,
	                duration: marker.end - marker.start,
	                config: markerConfig
	            });
	        }
	
	        return sound;
	    },
	
	    /**
	     * Enables playing sound on the fly without the need to keep a reference to it.
	     * Sound will auto destroy once its playback ends.
	     *
	     * @method Phaser.Sound.BaseSoundManager#play
	     * @since 3.0.0
	     *
	     * @param {string} key - Asset key for the sound.
	     * @param {(SoundConfig|SoundMarker)} [extra] - An optional additional object containing settings to be applied to the sound. It could be either config or marker object.
	     *
	     * @return {boolean} Whether the sound started playing successfully.
	     */
	    play: function (key, extra)
	    {
	        var sound = this.add(key);
	
	        sound.once('ended', sound.destroy, sound);
	
	        if (extra)
	        {
	            if (extra.name)
	            {
	                sound.addMarker(extra);
	
	                return sound.play(extra.name);
	            }
	            else
	            {
	                return sound.play(extra);
	            }
	        }
	        else
	        {
	            return sound.play();
	        }
	    },
	
	    /**
	     * Enables playing audio sprite sound on the fly without the need to keep a reference to it.
	     * Sound will auto destroy once its playback ends.
	     *
	     * @method Phaser.Sound.BaseSoundManager#playAudioSprite
	     * @since 3.0.0
	     *
	     * @param {string} key - Asset key for the sound.
	     * @param {string} spriteName - The name of the sound sprite to play.
	     * @param {SoundConfig} [config] - An optional config object containing default sound settings.
	     *
	     * @return {boolean} Whether the audio sprite sound started playing successfully.
	     */
	    playAudioSprite: function (key, spriteName, config)
	    {
	        var sound = this.addAudioSprite(key);
	
	        sound.once('ended', sound.destroy, sound);
	
	        return sound.play(spriteName, config);
	    },
	
	    /**
	     * Removes a sound from the sound manager.
	     * The removed sound is destroyed before removal.
	     *
	     * @method Phaser.Sound.BaseSoundManager#remove
	     * @since 3.0.0
	     *
	     * @param {Phaser.Sound.BaseSound} sound - The sound object to remove.
	     *
	     * @return {boolean} True if the sound was removed successfully, otherwise false.
	     */
	    remove: function (sound)
	    {
	        var index = this.sounds.indexOf(sound);
	
	        if (index !== -1)
	        {
	            sound.destroy();
	
	            this.sounds.splice(index, 1);
	
	            return true;
	        }
	
	        return false;
	    },
	
	    /**
	     * Removes all sounds from the sound manager that have an asset key matching the given value.
	     * The removed sounds are destroyed before removal.
	     *
	     * @method Phaser.Sound.BaseSoundManager#removeByKey
	     * @since 3.0.0
	     *
	     * @param {string} key - The key to match when removing sound objects.
	     *
	     * @return {number} The number of matching sound objects that were removed.
	     */
	    removeByKey: function (key)
	    {
	        var removed = 0;
	
	        for (var i = this.sounds.length - 1; i >= 0; i--)
	        {
	            var sound = this.sounds[i];
	
	            if (sound.key === key)
	            {
	                sound.destroy();
	
	                this.sounds.splice(i, 1);
	
	                removed++;
	            }
	        }
	
	        return removed;
	    },
	
	    /**
	     * @event Phaser.Sound.BaseSoundManager#pauseall
	     * @param {Phaser.Sound.BaseSoundManager} soundManager - Reference to the sound manager that emitted event.
	     */
	
	    /**
	     * Pauses all the sounds in the game.
	     *
	     * @method Phaser.Sound.BaseSoundManager#pauseAll
	     * @fires Phaser.Sound.BaseSoundManager#pauseall
	     * @since 3.0.0
	     */
	    pauseAll: function ()
	    {
	        this.forEachActiveSound(function (sound)
	        {
	            sound.pause();
	        });
	
	        this.emit('pauseall', this);
	    },
	
	    /**
	     * @event Phaser.Sound.BaseSoundManager#resumeall
	     * @param {Phaser.Sound.BaseSoundManager} soundManager - Reference to the sound manager that emitted event.
	     */
	
	    /**
	     * Resumes all the sounds in the game.
	     *
	     * @method Phaser.Sound.BaseSoundManager#resumeAll
	     * @fires Phaser.Sound.BaseSoundManager#resumeall
	     * @since 3.0.0
	     */
	    resumeAll: function ()
	    {
	        this.forEachActiveSound(function (sound)
	        {
	            sound.resume();
	        });
	
	        this.emit('resumeall', this);
	    },
	
	    /**
	     * @event Phaser.Sound.BaseSoundManager#stopall
	     * @param {Phaser.Sound.BaseSoundManager} soundManager - Reference to the sound manager that emitted event.
	     */
	
	    /**
	     * Stops all the sounds in the game.
	     *
	     * @method Phaser.Sound.BaseSoundManager#stopAll
	     * @fires Phaser.Sound.BaseSoundManager#stopall
	     * @since 3.0.0
	     */
	    stopAll: function ()
	    {
	        this.forEachActiveSound(function (sound)
	        {
	            sound.stop();
	        });
	
	        this.emit('stopall', this);
	    },
	
	    /**
	     * Method used internally for unlocking audio playback on devices that
	     * require user interaction before any sound can be played on a web page.
	     *
	     * Read more about how this issue is handled here in [this article](https://medium.com/@pgoloskokovic/unlocking-web-audio-the-smarter-way-8858218c0e09).
	     *
	     * @method Phaser.Sound.BaseSoundManager#unlock
	     * @override
	     * @protected
	     * @since 3.0.0
	     */
	    unlock: NOOP,
	
	    /**
	     * Method used internally for pausing sound manager if
	     * Phaser.Sound.BaseSoundManager#pauseOnBlur is set to true.
	     *
	     * @method Phaser.Sound.BaseSoundManager#onBlur
	     * @override
	     * @protected
	     * @since 3.0.0
	     */
	    onBlur: NOOP,
	
	    /**
	     * Method used internally for resuming sound manager if
	     * Phaser.Sound.BaseSoundManager#pauseOnBlur is set to true.
	     *
	     * @method Phaser.Sound.BaseSoundManager#onFocus
	     * @override
	     * @protected
	     * @since 3.0.0
	     */
	    onFocus: NOOP,
	
	    /**
	     * Update method called on every game step.
	     * Removes destroyed sounds and updates every active sound in the game.
	     *
	     * @method Phaser.Sound.BaseSoundManager#update
	     * @protected
	     * @since 3.0.0
	     *
	     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
	     * @param {number} delta - The delta time elapsed since the last frame.
	     */
	    update: function (time, delta)
	    {
	        if (this.unlocked)
	        {
	            this.unlocked = false;
	            this.locked = false;
	
	            /**
	             * @event Phaser.Sound.BaseSoundManager#unlocked
	             * @param {Phaser.Sound.BaseSoundManager} soundManager - Reference to the sound manager that emitted event.
	             */
	            this.emit('unlocked', this);
	        }
	
	        for (var i = this.sounds.length - 1; i >= 0; i--)
	        {
	            if (this.sounds[i].pendingRemove)
	            {
	                this.sounds.splice(i, 1);
	            }
	        }
	
	        this.sounds.forEach(function (sound)
	        {
	            sound.update(time, delta);
	        });
	    },
	
	    /**
	     * Destroys all the sounds in the game and all associated events.
	     *
	     * @method Phaser.Sound.BaseSoundManager#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.removeAllListeners();
	
	        this.forEachActiveSound(function (sound)
	        {
	            sound.destroy();
	        });
	
	        this.sounds.length = 0;
	        this.sounds = null;
	
	        this.game = null;
	    },
	
	    /**
	     * Method used internally for iterating only over active sounds and skipping sounds that are marked for removal.
	     *
	     * @method Phaser.Sound.BaseSoundManager#forEachActiveSound
	     * @private
	     * @since 3.0.0
	     *
	     * @param {EachActiveSoundCallback} callback - Callback function. (sound: ISound, index: number, array: ISound[]) => void
	     * @param {*} [scope] - Callback context.
	     */
	    forEachActiveSound: function (callback, scope)
	    {
	        var _this = this;
	
	        this.sounds.forEach(function (sound, index)
	        {
	            if (!sound.pendingRemove)
	            {
	                callback.call(scope || _this, sound, index, _this.sounds);
	            }
	        });
	    },
	
	    /**
	     * @event Phaser.Sound.BaseSoundManager#rate
	     * @param {Phaser.Sound.BaseSoundManager} soundManager - Reference to the sound manager that emitted event.
	     * @param {number} value - An updated value of Phaser.Sound.BaseSoundManager#rate property.
	     */
	
	    /**
	     * Sets the global playback rate at which all the sounds will be played.
	     *
	     * For example, a value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
	     * and 2.0 doubles the audios playback speed.
	     *
	     * @method Phaser.Sound.BaseSoundManager#setRate
	     * @fires Phaser.Sound.BaseSoundManager#rate
	     * @since 3.3.0
	     *
	     * @param {number} value - Global playback rate at which all the sounds will be played.
	     *
	     * @return {Phaser.Sound.BaseSoundManager} This Sound Manager.
	     */
	    setRate: function (value)
	    {
	        this.rate = value;
	
	        return this;
	    },
	
	    /**
	     * Global playback rate at which all the sounds will be played.
	     * Value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
	     * and 2.0 doubles the audio's playback speed.
	     *
	     * @name Phaser.Sound.BaseSoundManager#rate
	     * @type {number}
	     * @default 1
	     * @since 3.0.0
	     */
	    rate: {
	
	        get: function ()
	        {
	            return this._rate;
	        },
	
	        set: function (value)
	        {
	            this._rate = value;
	
	            this.forEachActiveSound(function (sound)
	            {
	                sound.calculateRate();
	            });
	
	            this.emit('rate', this, value);
	        }
	
	    },
	
	    /**
	     * Sets the global detuning of all sounds in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
	     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
	     *
	     * @method Phaser.Sound.BaseSoundManager#setDetune
	     * @fires Phaser.Sound.BaseSoundManager#detune
	     * @since 3.3.0
	     *
	     * @param {number} value - The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
	     *
	     * @return {Phaser.Sound.BaseSoundManager} This Sound Manager.
	     */
	    setDetune: function (value)
	    {
	        this.detune = value;
	
	        return this;
	    },
	
	    /**
	     * @event Phaser.Sound.BaseSoundManager#detune
	     * @param {Phaser.Sound.BaseSoundManager} soundManager - Reference to the sound manager that emitted event.
	     * @param {number} value - An updated value of Phaser.Sound.BaseSoundManager#detune property.
	     */
	
	    /**
	     * Global detuning of all sounds in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
	     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
	     *
	     * @name Phaser.Sound.BaseSoundManager#detune
	     * @type {number}
	     * @default 0
	     * @since 3.0.0
	     */
	    detune: {
	
	        get: function ()
	        {
	            return this._detune;
	        },
	
	        set: function (value)
	        {
	            this._detune = value;
	
	            this.forEachActiveSound(function (sound)
	            {
	                sound.calculateRate();
	            });
	
	            this.emit('detune', this, value);
	        }
	
	    }
	
	});
	
	module.exports = BaseSoundManager;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var ArrayUtils = __webpack_require__(340);
	var Class = __webpack_require__(1);
	var NOOP = __webpack_require__(6);
	var StableSort = __webpack_require__(219);
	
	/**
	 * @callback EachListCallback
	 * @generic I - [item]
	 *
	 * @param {*} item - [description]
	 * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
	 */
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class List
	 * @memberOf Phaser.Structs
	 * @constructor
	 * @since 3.0.0
	 *
	 * @generic T
	 *
	 * @param {*} parent - [description]
	 */
	var List = new Class({
	
	    initialize:
	
	    function List (parent)
	    {
	        /**
	         * The parent of this list.
	         *
	         * @name Phaser.Structs.List#parent
	         * @type {*}
	         * @since 3.0.0
	         */
	        this.parent = parent;
	
	        /**
	         * The objects that belong to this collection.
	         *
	         * @genericUse {T[]} - [$type]
	         *
	         * @name Phaser.Structs.List#list
	         * @type {Array.<*>}
	         * @default []
	         * @since 3.0.0
	         */
	        this.list = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Structs.List#position
	         * @type {integer}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.position = 0;
	
	        /**
	         * A callback that is invoked every time a child is added to this list.
	         *
	         * @name Phaser.Structs.List#addCallback
	         * @type {function}
	         * @since 3.4.0
	         */
	        this.addCallback = NOOP;
	
	        /**
	         * A callback that is invoked every time a child is removed from this list.
	         *
	         * @name Phaser.Structs.List#removeCallback
	         * @type {function}
	         * @since 3.4.0
	         */
	        this.removeCallback = NOOP;
	
	        /**
	         * The property key to sort by.
	         *
	         * @name Phaser.Structs.List#_sortKey
	         * @type {string}
	         * @since 3.4.0
	         */
	        this._sortKey = '';
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.List#add
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [child,$return]
	     *
	     * @param {*|Array.<*>} child - [description]
	     * @param {boolean} [skipCallback=false] - Skip calling the List.addCallback if this child is added successfully.
	     *
	     * @return {*} [description]
	     */
	    add: function (child, skipCallback)
	    {
	        if (skipCallback)
	        {
	            return ArrayUtils.Add(this.list, child);
	        }
	        else
	        {
	            return ArrayUtils.Add(this.list, child, 0, this.addCallback, this);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.List#addAt
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [child,$return]
	     *
	     * @param {*} child - [description]
	     * @param {integer} [index=0] - [description]
	     * @param {boolean} [skipCallback=false] - Skip calling the List.addCallback if this child is added successfully.
	     *
	     * @return {*} [description]
	     */
	    addAt: function (child, index, skipCallback)
	    {
	        if (skipCallback)
	        {
	            return ArrayUtils.AddAt(this.list, child, index);
	        }
	        else
	        {
	            return ArrayUtils.AddAt(this.list, child, index, 0, this.addCallback, this);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.List#getAt
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [$return]
	     *
	     * @param {integer} index - [description]
	     *
	     * @return {*} [description]
	     */
	    getAt: function (index)
	    {
	        return this.list[index];
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.List#getIndex
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [child]
	     *
	     * @param {*} child - [description]
	     *
	     * @return {integer} [description]
	     */
	    getIndex: function (child)
	    {
	        //  Return -1 if given child isn't a child of this display list
	        return this.list.indexOf(child);
	    },
	
	    /**
	     * Sort the contents of this List so the items are in order based
	     * on the given property. For example, `sort('alpha')` would sort the List
	     * contents based on the value of their `alpha` property.
	     *
	     * @method Phaser.Structs.List#sort
	     * @since 3.0.0
	     *
	     * @genericUse {T[]} - [children,$return]
	     *
	     * @param {string} property - The property to lexically sort by.
	     *
	     * @return {Array.<*>} [description]
	     */
	    sort: function (property)
	    {
	        if (property)
	        {
	            this._sortKey = property;
	
	            StableSort.inplace(this.list, this.sortHandler);
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.List#sortHandler
	     * @private
	     * @since 3.4.0
	     *
	     * @genericUse {T} - [childA,childB]
	     *
	     * @param {*} childA - [description]
	     * @param {*} childB - [description]
	     *
	     * @return {integer} [description]
	     */
	    sortHandler: function (childA, childB)
	    {
	        return childA[this._sortKey] - childB[this._sortKey];
	    },
	
	    /**
	     * Searches for the first instance of a child with its `name`
	     * property matching the given argument. Should more than one child have
	     * the same name only the first is returned.
	     *
	     * @method Phaser.Structs.List#getByName
	     * @since 3.0.0
	     *
	     * @genericUse {T | null} - [$return]
	     *
	     * @param {string} name - The name to search for.
	     *
	     * @return {?*} The first child with a matching name, or null if none were found.
	     */
	    getByName: function (name)
	    {
	        return ArrayUtils.GetFirst(this.list, 'name', name);
	    },
	
	    /**
	     * Returns a random child from the group.
	     *
	     * @method Phaser.Structs.List#getRandom
	     * @since 3.0.0
	     *
	     * @genericUse {T | null} - [$return]
	     *
	     * @param {integer} [startIndex=0] - Offset from the front of the group (lowest child).
	     * @param {integer} [length=(to top)] - Restriction on the number of values you want to randomly select from.
	     *
	     * @return {?*} A random child of this Group.
	     */
	    getRandom: function (startIndex, length)
	    {
	        return ArrayUtils.GetRandom(this.list, startIndex, length);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.List#getFirst
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [value]
	     * @genericUse {T | null} - [$return]
	     *
	     * @param {string} property - [description]
	     * @param {*} value - [description]
	     * @param {number} [startIndex=0] - [description]
	     * @param {number} [endIndex] - [description]
	     *
	     * @return {?*} [description]
	     */
	    getFirst: function (property, value, startIndex, endIndex)
	    {
	        return ArrayUtils.GetFirstElement(this.list, property, value, startIndex, endIndex);
	    },
	
	    /**
	     * Returns all children in this List.
	     *
	     * You can optionally specify a matching criteria using the `property` and `value` arguments.
	     *
	     * For example: `getAll('parent')` would return only children that have a property called `parent`.
	     *
	     * You can also specify a value to compare the property to:
	     * 
	     * `getAll('visible', true)` would return only children that have their visible property set to `true`.
	     *
	     * Optionally you can specify a start and end index. For example if this List had 100 children,
	     * and you set `startIndex` to 0 and `endIndex` to 50, it would return matches from only
	     * the first 50 children in the List.
	     *
	     * @method Phaser.Structs.List#getAll
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [value]
	     * @genericUse {T[]} - [$return]
	     *
	     * @param {string} [property] - An optional property to test against the value argument.
	     * @param {*} [value] - If property is set then Child.property must strictly equal this value to be included in the results.
	     * @param {integer} [startIndex] - The first child index to start the search from.
	     * @param {integer} [endIndex] - The last child index to search up until.
	     *
	     * @return {Array.<*>} [description]
	     */
	    getAll: function (property, value, startIndex, endIndex)
	    {
	        return ArrayUtils.GetAll(this.list, property, value, startIndex, endIndex);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.List#count
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [value]
	     *
	     * @param {string} property - [description]
	     * @param {*} value - [description]
	     *
	     * @return {integer} [description]
	     */
	    count: function (property, value)
	    {
	        return ArrayUtils.CountAllMatching(this.list, property, value);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.List#swap
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [child1,child2]
	     *
	     * @param {*} child1 - [description]
	     * @param {*} child2 - [description]
	     */
	    swap: function (child1, child2)
	    {
	        ArrayUtils.Swap(this.list, child1, child2);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.List#moveTo
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [child,$return]
	     *
	     * @param {*} child - [description]
	     * @param {integer} index - [description]
	     *
	     * @return {*} [description]
	     */
	    moveTo: function (child, index)
	    {
	        return ArrayUtils.MoveTo(this.list, child, index);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.List#remove
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [child,$return]
	     *
	     * @param {*} child - [description]
	     * @param {boolean} [skipCallback=false] - Skip calling the List.removeCallback.
	     *
	     * @return {*} [description]
	     */
	    remove: function (child, skipCallback)
	    {
	        if (skipCallback)
	        {
	            return ArrayUtils.Remove(this.list, child);
	        }
	        else
	        {
	            return ArrayUtils.Remove(this.list, child, this.removeCallback, this);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.List#removeAt
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [$return]
	     *
	     * @param {integer} index - [description]
	     * @param {boolean} [skipCallback=false] - Skip calling the List.removeCallback.
	     *
	     * @return {*} [description]
	     */
	    removeAt: function (index, skipCallback)
	    {
	        if (skipCallback)
	        {
	            return ArrayUtils.RemoveAt(this.list, index);
	        }
	        else
	        {
	            return ArrayUtils.RemoveAt(this.list, index, this.removeCallback, this);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.List#removeBetween
	     * @since 3.0.0
	     *
	     * @genericUse {T[]} - [$return]
	     *
	     * @param {integer} [startIndex=0] - [description]
	     * @param {integer} [endIndex] - [description]
	     * @param {boolean} [skipCallback=false] - Skip calling the List.removeCallback.
	     *
	     * @return {Array.<*>} [description]
	     */
	    removeBetween: function (startIndex, endIndex, skipCallback)
	    {
	        if (skipCallback)
	        {
	            return ArrayUtils.RemoveBetween(this.list, startIndex, endIndex);
	        }
	        else
	        {
	            return ArrayUtils.RemoveBetween(this.list, startIndex, endIndex, this.removeCallback, this);
	        }
	    },
	
	    /**
	     * Removes all the items.
	     *
	     * @method Phaser.Structs.List#removeAll
	     * @since 3.0.0
	     *
	     * @genericUse {Phaser.Structs.List.<T>} - [$return]
	     * 
	     * @param {boolean} [skipCallback=false] - Skip calling the List.removeCallback.
	     *
	     * @return {Phaser.Structs.List} This List object.
	     */
	    removeAll: function (skipCallback)
	    {
	        var i = this.list.length;
	
	        while (i--)
	        {
	            this.remove(this.list[i], skipCallback);
	        }
	
	        return this;
	    },
	
	    /**
	     * Brings the given child to the top of this List.
	     *
	     * @method Phaser.Structs.List#bringToTop
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [child,$return]
	     *
	     * @param {*} child - [description]
	     *
	     * @return {*} [description]
	     */
	    bringToTop: function (child)
	    {
	        return ArrayUtils.BringToTop(this.list, child);
	    },
	
	    /**
	     * Sends the given child to the bottom of this List.
	     *
	     * @method Phaser.Structs.List#sendToBack
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [child,$return]
	     *
	     * @param {*} child - [description]
	     *
	     * @return {*} [description]
	     */
	    sendToBack: function (child)
	    {
	        return ArrayUtils.SendToBack(this.list, child);
	    },
	
	    /**
	     * Moves the given child up one place in this group unless it's already at the top.
	     *
	     * @method Phaser.Structs.List#moveUp
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [child,$return]
	     *
	     * @param {*} child - [description]
	     *
	     * @return {*} [description]
	     */
	    moveUp: function (child)
	    {
	        ArrayUtils.MoveUp(this.list, child);
	
	        return child;
	    },
	
	    /**
	     * Moves the given child down one place in this group unless it's already at the bottom.
	     *
	     * @method Phaser.Structs.List#moveDown
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [child,$return]
	     *
	     * @param {*} child - [description]
	     *
	     * @return {*} [description]
	     */
	    moveDown: function (child)
	    {
	        ArrayUtils.MoveDown(this.list, child);
	
	        return child;
	    },
	
	    /**
	     * Reverses the order of all children in this List.
	     *
	     * @method Phaser.Structs.List#reverse
	     * @since 3.0.0
	     *
	     * @genericUse {Phaser.Structs.List.<T>} - [$return]
	     *
	     * @return {Phaser.Structs.List} This List object.
	     */
	    reverse: function ()
	    {
	        this.list.reverse();
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.List#shuffle
	     * @since 3.0.0
	     *
	     * @genericUse {Phaser.Structs.List.<T>} - [$return]
	     *
	     * @return {Phaser.Structs.List} This List object.
	     */
	    shuffle: function ()
	    {
	        ArrayUtils.Shuffle(this.list);
	
	        return this;
	    },
	
	    /**
	     * Replaces a child of this List with the given newChild. The newChild cannot be a member of this List.
	     *
	     * @method Phaser.Structs.List#replace
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [oldChild,newChild,$return]
	     *
	     * @param {*} oldChild - The child in this List that will be replaced.
	     * @param {*} newChild - The child to be inserted into this List.
	     *
	     * @return {*} Returns the oldChild that was replaced within this group.
	     */
	    replace: function (oldChild, newChild)
	    {
	        return ArrayUtils.Replace(this.list, oldChild, newChild);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.List#exists
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [child]
	     *
	     * @param {*} child - [description]
	     *
	     * @return {boolean} True if the item is found in the list, otherwise false.
	     */
	    exists: function (child)
	    {
	        return (this.list.indexOf(child) > -1);
	    },
	
	    /**
	     * Sets the property `key` to the given value on all members of this List.
	     *
	     * @method Phaser.Structs.List#setAll
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [value]
	     *
	     * @param {string} property - [description]
	     * @param {*} value - [description]
	     * @param {integer} [startIndex] - The first child index to start the search from.
	     * @param {integer} [endIndex] - The last child index to search up until.
	     */
	    setAll: function (property, value, startIndex, endIndex)
	    {
	        ArrayUtils.SetAll(this.list, property, value, startIndex, endIndex);
	
	        return this;
	    },
	
	    /**
	     * Passes all children to the given callback.
	     *
	     * @method Phaser.Structs.List#each
	     * @since 3.0.0
	     *
	     * @genericUse {EachListCallback.<T>} - [callback]
	     *
	     * @param {EachListCallback} callback - The function to call.
	     * @param {*} [thisArg] - Value to use as `this` when executing callback.
	     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
	     */
	    each: function (callback, context)
	    {
	        var args = [ null ];
	
	        for (var i = 2; i < arguments.length; i++)
	        {
	            args.push(arguments[i]);
	        }
	
	        for (i = 0; i < this.list.length; i++)
	        {
	            args[0] = this.list[i];
	
	            callback.apply(context, args);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.List#shutdown
	     * @since 3.0.0
	     */
	    shutdown: function ()
	    {
	        this.removeAll();
	
	        this.list = [];
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.List#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.removeAll();
	
	        this.parent = null;
	        this.addCallback = null;
	        this.removeCallback = null;
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Structs.List#length
	     * @type {integer}
	     * @readOnly
	     * @since 3.0.0
	     */
	    length: {
	
	        get: function ()
	        {
	            return this.list.length;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Structs.List#first
	     * @type {integer}
	     * @readOnly
	     * @since 3.0.0
	     */
	    first: {
	
	        get: function ()
	        {
	            this.position = 0;
	
	            if (this.list.length > 0)
	            {
	                return this.list[0];
	            }
	            else
	            {
	                return null;
	            }
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Structs.List#last
	     * @type {integer}
	     * @readOnly
	     * @since 3.0.0
	     */
	    last: {
	
	        get: function ()
	        {
	            if (this.list.length > 0)
	            {
	                this.position = this.list.length - 1;
	
	                return this.list[this.position];
	            }
	            else
	            {
	                return null;
	            }
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Structs.List#next
	     * @type {integer}
	     * @readOnly
	     * @since 3.0.0
	     */
	    next: {
	
	        get: function ()
	        {
	            if (this.position < this.list.length)
	            {
	                this.position++;
	
	                return this.list[this.position];
	            }
	            else
	            {
	                return null;
	            }
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Structs.List#previous
	     * @type {integer}
	     * @readOnly
	     * @since 3.0.0
	     */
	    previous: {
	
	        get: function ()
	        {
	            if (this.position > 0)
	            {
	                this.position--;
	
	                return this.list[this.position];
	            }
	            else
	            {
	                return null;
	            }
	        }
	
	    }
	
	});
	
	module.exports = List;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * A Tileset is a combination of an image containing the tiles and a container for data about
	 * each tile.
	 *
	 * @class Tileset
	 * @memberOf Phaser.Tilemaps
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {string} name - The name of the tileset in the map data.
	 * @param {integer} firstgid - The first tile index this tileset contains.
	 * @param {integer} [tileWidth=32] - Width of each tile (in pixels).
	 * @param {integer} [tileHeight=32] - Height of each tile (in pixels).
	 * @param {integer} [tileMargin=0] - The margin around all tiles in the sheet (in pixels).
	 * @param {integer} [tileSpacing=0] - The spacing between each tile in the sheet (in pixels).
	 * @param {object} [tileProperties={}] - Custom properties defined per tile in the Tileset.
	 * These typically are custom properties created in Tiled when editing a tileset.
	 * @param {object} [tileData={}] - Data stored per tile. These typically are created in Tiled
	 * when editing a tileset, e.g. from Tiled's tile collision editor or terrain editor.
	 */
	var Tileset = new Class({
	
	    initialize:
	
	    function Tileset (name, firstgid, tileWidth, tileHeight, tileMargin, tileSpacing, tileProperties, tileData)
	    {
	        if (tileWidth === undefined || tileWidth <= 0) { tileWidth = 32; }
	        if (tileHeight === undefined || tileHeight <= 0) { tileHeight = 32; }
	        if (tileMargin === undefined) { tileMargin = 0; }
	        if (tileSpacing === undefined) { tileSpacing = 0; }
	        if (tileProperties === undefined) { tileProperties = {}; }
	        if (tileData === undefined) { tileData = {}; }
	
	        /**
	         * The name of the Tileset.
	         *
	         * @name Phaser.Tilemaps.Tileset#name
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.name = name;
	
	        /**
	         * The starting index of the first tile index this Tileset contains.
	         *
	         * @name Phaser.Tilemaps.Tileset#firstgid
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.firstgid = firstgid;
	
	        /**
	         * The width of each tile (in pixels). Use setTileSize to change.
	         *
	         * @name Phaser.Tilemaps.Tileset#tileWidth
	         * @type {integer}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.tileWidth = tileWidth;
	
	        /**
	         * The height of each tile (in pixels). Use setTileSize to change.
	         *
	         * @name Phaser.Tilemaps.Tileset#tileHeight
	         * @type {integer}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.tileHeight = tileHeight;
	
	        /**
	         * The margin around the tiles in the sheet (in pixels). Use `setSpacing` to change.
	         *
	         * @name Phaser.Tilemaps.Tileset#tileMargin
	         * @type {integer}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.tileMargin = tileMargin;
	
	        /**
	         * The spacing between each the tile in the sheet (in pixels). Use `setSpacing` to change.
	         *
	         * @name Phaser.Tilemaps.Tileset#tileSpacing
	         * @type {integer}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.tileSpacing = tileSpacing;
	
	        /**
	         * Tileset-specific properties per tile that are typically defined in the Tiled editor in the
	         * Tileset editor.
	         *
	         * @name Phaser.Tilemaps.Tileset#tileProperties
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.tileProperties = tileProperties;
	
	        /**
	         * Tileset-specific data per tile that are typically defined in the Tiled editor, e.g. within
	         * the Tileset collision editor. This is where collision objects and terrain are stored.
	         *
	         * @name Phaser.Tilemaps.Tileset#tileData
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.tileData = tileData;
	
	        /**
	         * The cached image that contains the individual tiles. Use setImage to set.
	         *
	         * @name Phaser.Tilemaps.Tileset#image
	         * @type {?Phaser.Textures.Texture}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.image = null;
	
	        /**
	         * The number of tile rows in the the tileset.
	         *
	         * @name Phaser.Tilemaps.Tileset#rows
	         * @type {integer}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.rows = 0;
	
	        /**
	         * The number of tile columns in the tileset.
	         *
	         * @name Phaser.Tilemaps.Tileset#columns
	         * @type {integer}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.columns = 0;
	
	        /**
	         * The total number of tiles in the tileset.
	         *
	         * @name Phaser.Tilemaps.Tileset#total
	         * @type {integer}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.total = 0;
	
	        /**
	         * The look-up table to specific tile image texture coordinates (UV in pixels). Each element
	         * contains the coordinates for a tile in an object of the form {x, y}.
	         *
	         * @name Phaser.Tilemaps.Tileset#texCoordinates
	         * @type {object[]}
	         * @readOnly
	         * @since 3.0.0
	        */
	        this.texCoordinates = [];
	    },
	
	    /**
	     * Get a tiles properties that are stored in the Tileset. Returns null if tile index is not
	     * contained in this Tileset. This is typically defined in Tiled under the Tileset editor.
	     *
	     * @method Phaser.Tilemaps.Tileset#getTileProperties
	     * @since 3.0.0
	     *
	     * @param {integer} tileIndex - The unique id of the tile across all tilesets in the map.
	     *
	     * @return {?(object|undefined)}
	     */
	    getTileProperties: function (tileIndex)
	    {
	        if (!this.containsTileIndex(tileIndex)) { return null; }
	
	        return this.tileProperties[tileIndex - this.firstgid];
	    },
	
	    /**
	     * Get a tile's data that is stored in the Tileset. Returns null if tile index is not contained
	     * in this Tileset. This is typically defined in Tiled and will contain both Tileset collision
	     * info and terrain mapping.
	     *
	     * @method Phaser.Tilemaps.Tileset#getTileData
	     * @since 3.0.0
	     *
	     * @param {integer} tileIndex - The unique id of the tile across all tilesets in the map.
	     *
	     * @return {?object|undefined}
	     */
	    getTileData: function (tileIndex)
	    {
	        if (!this.containsTileIndex(tileIndex)) { return null; }
	
	        return this.tileData[tileIndex - this.firstgid];
	    },
	
	    /**
	     * Get a tile's collision group that is stored in the Tileset. Returns null if tile index is not
	     * contained in this Tileset. This is typically defined within Tiled's tileset collision editor.
	     *
	     * @method Phaser.Tilemaps.Tileset#getTileCollisionGroup
	     * @since 3.0.0
	     *
	     * @param {integer} tileIndex - The unique id of the tile across all tilesets in the map.
	     *
	     * @return {?object}
	     */
	    getTileCollisionGroup: function (tileIndex)
	    {
	        var data = this.getTileData(tileIndex);
	
	        return (data && data.objectgroup) ? data.objectgroup : null;
	    },
	
	    /**
	     * Returns true if and only if this Tileset contains the given tile index.
	     *
	     * @method Phaser.Tilemaps.Tileset#containsTileIndex
	     * @since 3.0.0
	     *
	     * @param {integer} tileIndex - The unique id of the tile across all tilesets in the map.
	     *
	     * @return {boolean}
	     */
	    containsTileIndex: function (tileIndex)
	    {
	        return (
	            tileIndex >= this.firstgid &&
	            tileIndex < (this.firstgid + this.total)
	        );
	    },
	
	    /**
	     * Returns the texture coordinates (UV in pixels) in the Tileset image for the given tile index.
	     * Returns null if tile index is not contained in this Tileset.
	     *
	     * @method Phaser.Tilemaps.Tileset#getTileTextureCoordinates
	     * @since 3.0.0
	     *
	     * @param {integer} tileIndex - The unique id of the tile across all tilesets in the map.
	     *
	     * @return {?object} Object in the form { x, y } representing the top-left UV coordinate
	     * within the Tileset image.
	     */
	    getTileTextureCoordinates: function (tileIndex)
	    {
	        if (!this.containsTileIndex(tileIndex)) { return null; }
	
	        return this.texCoordinates[tileIndex - this.firstgid];
	    },
	
	    /**
	     * Sets the image associated with this Tileset and updates the tile data (rows, columns, etc.).
	     *
	     * @method Phaser.Tilemaps.Tileset#setImage
	     * @since 3.0.0
	     *
	     * @param {Phaser.Textures.Texture} texture - The image that contains the tiles.
	     *
	     * @return {Phaser.Tilemaps.Tileset} This Tileset object.
	     */
	    setImage: function (texture)
	    {
	        this.image = texture;
	
	        this.updateTileData(this.image.source[0].width, this.image.source[0].height);
	
	        return this;
	    },
	
	    /**
	     * Sets the tile width & height and updates the tile data (rows, columns, etc.).
	     *
	     * @method Phaser.Tilemaps.Tileset#setTileSize
	     * @since 3.0.0
	     *
	     * @param {integer} [tileWidth] - The width of a tile in pixels.
	     * @param {integer} [tileHeight] - The height of a tile in pixels.
	     *
	     * @return {Phaser.Tilemaps.Tileset} This Tileset object.
	     */
	    setTileSize: function (tileWidth, tileHeight)
	    {
	        if (tileWidth !== undefined) { this.tileWidth = tileWidth; }
	        if (tileHeight !== undefined) { this.tileHeight = tileHeight; }
	
	        if (this.image)
	        {
	            this.updateTileData(this.image.source[0].width, this.image.source[0].height);
	        }
	
	        return this;
	    },
	
	    /**
	     * Sets the tile margin & spacing and updates the tile data (rows, columns, etc.).
	     *
	     * @method Phaser.Tilemaps.Tileset#setSpacing
	     * @since 3.0.0
	     *
	     * @param {integer} [margin] - The margin around the tiles in the sheet (in pixels).
	     * @param {integer} [spacing] - The spacing between the tiles in the sheet (in pixels).
	     *
	     * @return {Phaser.Tilemaps.Tileset} This Tileset object.
	     */
	    setSpacing: function (margin, spacing)
	    {
	        if (margin !== undefined) { this.tileMargin = margin; }
	        if (spacing !== undefined) { this.tileSpacing = spacing; }
	
	        if (this.image)
	        {
	            this.updateTileData(this.image.source[0].width, this.image.source[0].height);
	        }
	
	        return this;
	    },
	
	    /**
	     * Updates tile texture coordinates and tileset data.
	     *
	     * @method Phaser.Tilemaps.Tileset#updateTileData
	     * @since 3.0.0
	     *
	     * @param {integer} imageWidth - The (expected) width of the image to slice.
	     * @param {integer} imageHeight - The (expected) height of the image to slice.
	     *
	     * @return {Phaser.Tilemaps.Tileset} This Tileset object.
	     */
	    updateTileData: function (imageWidth, imageHeight)
	    {
	        var rowCount = (imageHeight - this.tileMargin * 2 + this.tileSpacing) / (this.tileHeight + this.tileSpacing);
	        var colCount = (imageWidth - this.tileMargin * 2 + this.tileSpacing) / (this.tileWidth + this.tileSpacing);
	
	        if (rowCount % 1 !== 0 || colCount % 1 !== 0)
	        {
	            console.warn('Tileset ' + this.name + ' image tile area is not an even multiple of tile size');
	        }
	
	        // In Tiled a tileset image that is not an even multiple of the tile dimensions is truncated
	        // - hence the floor when calculating the rows/columns.
	        rowCount = Math.floor(rowCount);
	        colCount = Math.floor(colCount);
	
	        this.rows = rowCount;
	        this.columns = colCount;
	
	        // In Tiled, "empty" spaces in a tileset count as tiles and hence count towards the gid
	        this.total = rowCount * colCount;
	
	        this.texCoordinates.length = 0;
	
	        var tx = this.tileMargin;
	        var ty = this.tileMargin;
	
	        for (var y = 0; y < this.rows; y++)
	        {
	            for (var x = 0; x < this.columns; x++)
	            {
	                this.texCoordinates.push({ x: tx, y: ty });
	                tx += this.tileWidth + this.tileSpacing;
	            }
	
	            tx = this.tileMargin;
	            ty += this.tileHeight + this.tileSpacing;
	        }
	
	        return this;
	    }
	
	});
	
	module.exports = Tileset;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var IsInLayerBounds = __webpack_require__(169);
	
	/**
	 * Gets a tile at the given tile coordinates from the given layer.
	 *
	 * @function Phaser.Tilemaps.Components.GetTileAt
	 * @private
	 * @since 3.0.0
	 *
	 * @param {integer} tileX - X position to get the tile from (given in tile units, not pixels).
	 * @param {integer} tileY - Y position to get the tile from (given in tile units, not pixels).
	 * @param {boolean} [nonNull=false] - If true getTile won't return null for empty tiles, but a Tile
	 * object with an index of -1.
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 * 
	 * @return {Phaser.Tilemaps.Tile} The tile at the given coordinates or null if no tile was found or the coordinates
	 * were invalid.
	 */
	var GetTileAt = function (tileX, tileY, nonNull, layer)
	{
	    if (nonNull === undefined) { nonNull = false; }
	
	    if (IsInLayerBounds(tileX, tileY, layer))
	    {
	        var tile = layer.data[tileY][tileX];
	        if (tile === null)
	        {
	            return null;
	        }
	        else if (tile.index === -1)
	        {
	            return nonNull ? tile : null;
	        }
	        else
	        {
	            return tile;
	        }
	    }
	    else
	    {
	        return null;
	    }
	};
	
	module.exports = GetTileAt;


/***/ }),
/* 213 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Converts from tile X coordinates (tile units) to world X coordinates (pixels), factoring in the
	 * layer's position, scale and scroll.
	 *
	 * @function Phaser.Tilemaps.Components.TileToWorldX
	 * @private
	 * @since 3.0.0
	 *
	 * @param {integer} tileX - [description]
	 * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 * 
	 * @return {number}
	 */
	var TileToWorldX = function (tileX, camera, layer)
	{
	    var tileWidth = layer.baseTileWidth;
	    var tilemapLayer = layer.tilemapLayer;
	    var layerWorldX = 0;
	
	    if (tilemapLayer)
	    {
	        if (camera === undefined) { camera = tilemapLayer.scene.cameras.main; }
	
	        layerWorldX = tilemapLayer.x + camera.scrollX * (1 - tilemapLayer.scrollFactorX);
	
	        tileWidth *= tilemapLayer.scaleX;
	    }
	
	    return layerWorldX + tileX * tileWidth;
	};
	
	module.exports = TileToWorldX;


/***/ }),
/* 214 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Converts from tile Y coordinates (tile units) to world Y coordinates (pixels), factoring in the
	 * layer's position, scale and scroll.
	 *
	 * @function Phaser.Tilemaps.Components.TileToWorldY
	 * @private
	 * @since 3.0.0
	 *
	 * @param {integer} tileY - [description]
	 * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 * 
	 * @return {number}
	 */
	var TileToWorldY = function (tileY, camera, layer)
	{
	    var tileHeight = layer.baseTileHeight;
	    var tilemapLayer = layer.tilemapLayer;
	    var layerWorldY = 0;
	
	    if (tilemapLayer)
	    {
	        if (camera === undefined) { camera = tilemapLayer.scene.cameras.main; }
	
	        layerWorldY = (tilemapLayer.y + camera.scrollY * (1 - tilemapLayer.scrollFactorY));
	
	        tileHeight *= tilemapLayer.scaleY;
	    }
	
	    return layerWorldY + tileY * tileHeight;
	};
	
	module.exports = TileToWorldY;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Tilemaps.Components
	 */
	
	module.exports = {
	
	    CalculateFacesAt: __webpack_require__(330),
	    CalculateFacesWithin: __webpack_require__(88),
	    Copy: __webpack_require__(1533),
	    CreateFromTiles: __webpack_require__(1534),
	    CullTiles: __webpack_require__(1535),
	    Fill: __webpack_require__(1536),
	    FilterTiles: __webpack_require__(1537),
	    FindByIndex: __webpack_require__(1538),
	    FindTile: __webpack_require__(1539),
	    ForEachTile: __webpack_require__(1540),
	    GetTileAt: __webpack_require__(212),
	    GetTileAtWorldXY: __webpack_require__(1541),
	    GetTilesWithin: __webpack_require__(34),
	    GetTilesWithinShape: __webpack_require__(1542),
	    GetTilesWithinWorldXY: __webpack_require__(1543),
	    HasTileAt: __webpack_require__(639),
	    HasTileAtWorldXY: __webpack_require__(1544),
	    IsInLayerBounds: __webpack_require__(169),
	    PutTileAt: __webpack_require__(331),
	    PutTileAtWorldXY: __webpack_require__(1545),
	    PutTilesAt: __webpack_require__(1546),
	    Randomize: __webpack_require__(1547),
	    RemoveTileAt: __webpack_require__(640),
	    RemoveTileAtWorldXY: __webpack_require__(1548),
	    RenderDebug: __webpack_require__(1549),
	    ReplaceByIndex: __webpack_require__(641),
	    SetCollision: __webpack_require__(1550),
	    SetCollisionBetween: __webpack_require__(1551),
	    SetCollisionByExclusion: __webpack_require__(1552),
	    SetCollisionByProperty: __webpack_require__(1553),
	    SetCollisionFromCollisionGroup: __webpack_require__(1554),
	    SetTileIndexCallback: __webpack_require__(1555),
	    SetTileLocationCallback: __webpack_require__(1556),
	    Shuffle: __webpack_require__(1557),
	    SwapByIndex: __webpack_require__(1558),
	    TileToWorldX: __webpack_require__(213),
	    TileToWorldXY: __webpack_require__(1559),
	    TileToWorldY: __webpack_require__(214),
	    WeightedRandomize: __webpack_require__(1560),
	    WorldToTileX: __webpack_require__(99),
	    WorldToTileXY: __webpack_require__(1561),
	    WorldToTileY: __webpack_require__(100)
	
	};


/***/ }),
/* 216 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Tweens.Builders.GetNewValue
	 * @since 3.0.0
	 *
	 * @param {object} source - [description]
	 * @param {string} key - [description]
	 * @param {*} defaultValue - [description]
	 *
	 * @return {function} [description]
	 */
	var GetNewValue = function (source, key, defaultValue)
	{
	    var valueCallback;
	
	    if (source.hasOwnProperty(key))
	    {
	        var t = typeof(source[key]);
	
	        if (t === 'function')
	        {
	            valueCallback = function (index, totalTargets, target)
	            {
	                return source[key](index, totalTargets, target);
	            };
	        }
	        else
	        {
	            valueCallback = function ()
	            {
	                return source[key];
	            };
	        }
	    }
	    else if (typeof defaultValue === 'function')
	    {
	        valueCallback = defaultValue;
	    }
	    else
	    {
	        valueCallback = function ()
	        {
	            return defaultValue;
	        };
	    }
	
	    return valueCallback;
	};
	
	module.exports = GetNewValue;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Defaults = __webpack_require__(336);
	var GetAdvancedValue = __webpack_require__(24);
	var GetBoolean = __webpack_require__(172);
	var GetEaseFunction = __webpack_require__(173);
	var GetNewValue = __webpack_require__(216);
	var GetProps = __webpack_require__(653);
	var GetTargets = __webpack_require__(334);
	var GetValue = __webpack_require__(10);
	var GetValueOp = __webpack_require__(335);
	var Tween = __webpack_require__(337);
	var TweenData = __webpack_require__(338);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Tweens.Builders.TweenBuilder
	 * @since 3.0.0
	 *
	 * @param {(Phaser.Tweens.TweenManager|Phaser.Tweens.Timeline)} parent - [description]
	 * @param {object} config - [description]
	 * @param {Phaser.Tweens.TweenConfigDefaults} defaults - [description]
	 *
	 * @return {Phaser.Tweens.Tween} [description]
	 */
	var TweenBuilder = function (parent, config, defaults)
	{
	    if (defaults === undefined)
	    {
	        defaults = Defaults;
	    }
	
	    //  Create arrays of the Targets and the Properties
	    var targets = (defaults.targets) ? defaults.targets : GetTargets(config);
	
	    // var props = (defaults.props) ? defaults.props : GetProps(config);
	    var props = GetProps(config);
	
	    //  Default Tween values
	    var delay = GetNewValue(config, 'delay', defaults.delay);
	    var duration = GetNewValue(config, 'duration', defaults.duration);
	    var easeParams = GetValue(config, 'easeParams', defaults.easeParams);
	    var ease = GetEaseFunction(GetValue(config, 'ease', defaults.ease), easeParams);
	    var hold = GetNewValue(config, 'hold', defaults.hold);
	    var repeat = GetNewValue(config, 'repeat', defaults.repeat);
	    var repeatDelay = GetNewValue(config, 'repeatDelay', defaults.repeatDelay);
	    var yoyo = GetBoolean(config, 'yoyo', defaults.yoyo);
	    var flipX = GetBoolean(config, 'flipX', defaults.flipX);
	    var flipY = GetBoolean(config, 'flipY', defaults.flipY);
	
	    var data = [];
	
	    //  Loop through every property defined in the Tween, i.e.: props { x, y, alpha }
	    for (var p = 0; p < props.length; p++)
	    {
	        var key = props[p].key;
	        var value = props[p].value;
	
	        //  Create 1 TweenData per target, per property
	        for (var t = 0; t < targets.length; t++)
	        {
	            var ops = GetValueOp(key, value);
	
	            var tweenData = TweenData(
	                targets[t],
	                key,
	                ops.getEnd,
	                ops.getStart,
	                GetEaseFunction(GetValue(value, 'ease', ease), easeParams),
	                GetNewValue(value, 'delay', delay),
	                GetNewValue(value, 'duration', duration),
	                GetBoolean(value, 'yoyo', yoyo),
	                GetNewValue(value, 'hold', hold),
	                GetNewValue(value, 'repeat', repeat),
	                GetNewValue(value, 'repeatDelay', repeatDelay),
	                GetBoolean(value, 'flipX', flipX),
	                GetBoolean(value, 'flipY', flipY)
	            );
	
	            data.push(tweenData);
	        }
	    }
	
	    var tween = new Tween(parent, data, targets);
	
	    tween.offset = GetAdvancedValue(config, 'offset', null);
	    tween.completeDelay = GetAdvancedValue(config, 'completeDelay', 0);
	    tween.loop = Math.round(GetAdvancedValue(config, 'loop', 0));
	    tween.loopDelay = Math.round(GetAdvancedValue(config, 'loopDelay', 0));
	    tween.paused = GetBoolean(config, 'paused', false);
	    tween.useFrames = GetBoolean(config, 'useFrames', false);
	
	    //  Set the Callbacks
	    var scope = GetValue(config, 'callbackScope', tween);
	
	    //  Callback parameters: 0 = a reference to the Tween itself, 1 = the target/s of the Tween, ... your own params
	    var tweenArray = [ tween, null ];
	
	    var callbacks = Tween.TYPES;
	
	    for (var i = 0; i < callbacks.length; i++)
	    {
	        var type = callbacks[i];
	
	        var callback = GetValue(config, type, false);
	
	        if (callback)
	        {
	            var callbackScope = GetValue(config, type + 'Scope', scope);
	            var callbackParams = GetValue(config, type + 'Params', []);
	
	            //  The null is reset to be the Tween target
	            tween.setCallback(type, callback, tweenArray.concat(callbackParams), callbackScope);
	        }
	    }
	
	    return tween;
	};
	
	module.exports = TweenBuilder;


/***/ }),
/* 218 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Shuffles the contents of the given array using the Fisher-Yates implementation.
	 *
	 * The original array is modified directly and returned.
	 *
	 * @function Phaser.Utils.Array.Shuffle
	 * @since 3.0.0
	 *
	 * @param {array} array - The array to shuffle. This array is modified in place.
	 *
	 * @return {array} The shuffled array.
	 */
	var Shuffle = function (array)
	{
	    for (var i = array.length - 1; i > 0; i--)
	    {
	        var j = Math.floor(Math.random() * (i + 1));
	        var temp = array[i];
	        array[i] = array[j];
	        array[j] = temp;
	    }
	
	    return array;
	};
	
	module.exports = Shuffle;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//! stable.js 0.1.6, https://github.com/Two-Screen/stable
	//! © 2017 Angry Bytes and contributors. MIT licensed.
	
	(function() {
	
	// A stable array sort, because `Array#sort()` is not guaranteed stable.
	// This is an implementation of merge sort, without recursion.
	
	var stable = function(arr, comp) {
	    return exec(arr.slice(), comp);
	};
	
	stable.inplace = function(arr, comp) {
	    var result = exec(arr, comp);
	
	    // This simply copies back if the result isn't in the original array,
	    // which happens on an odd number of passes.
	    if (result !== arr) {
	        pass(result, null, arr.length, arr);
	    }
	
	    return arr;
	};
	
	// Execute the sort using the input array and a second buffer as work space.
	// Returns one of those two, containing the final result.
	function exec(arr, comp) {
	    if (typeof(comp) !== 'function') {
	        comp = function(a, b) {
	            return String(a).localeCompare(b);
	        };
	    }
	
	    // Short-circuit when there's nothing to sort.
	    var len = arr.length;
	    if (len <= 1) {
	        return arr;
	    }
	
	    // Rather than dividing input, simply iterate chunks of 1, 2, 4, 8, etc.
	    // Chunks are the size of the left or right hand in merge sort.
	    // Stop when the left-hand covers all of the array.
	    var buffer = new Array(len);
	    for (var chk = 1; chk < len; chk *= 2) {
	        pass(arr, comp, chk, buffer);
	
	        var tmp = arr;
	        arr = buffer;
	        buffer = tmp;
	    }
	
	    return arr;
	}
	
	// Run a single pass with the given chunk size.
	var pass = function(arr, comp, chk, result) {
	    var len = arr.length;
	    var i = 0;
	    // Step size / double chunk size.
	    var dbl = chk * 2;
	    // Bounds of the left and right chunks.
	    var l, r, e;
	    // Iterators over the left and right chunk.
	    var li, ri;
	
	    // Iterate over pairs of chunks.
	    for (l = 0; l < len; l += dbl) {
	        r = l + chk;
	        e = r + chk;
	        if (r > len) r = len;
	        if (e > len) e = len;
	
	        // Iterate both chunks in parallel.
	        li = l;
	        ri = r;
	        while (true) {
	            // Compare the chunks.
	            if (li < r && ri < e) {
	                // This works for a regular `sort()` compatible comparator,
	                // but also for a simple comparator like: `a > b`
	                if (comp(arr[li], arr[ri]) <= 0) {
	                    result[i++] = arr[li++];
	                }
	                else {
	                    result[i++] = arr[ri++];
	                }
	            }
	            // Nothing to compare, just flush what's left.
	            else if (li < r) {
	                result[i++] = arr[li++];
	            }
	            else if (ri < e) {
	                result[i++] = arr[ri++];
	            }
	            // Both iterators are at the chunk ends.
	            else {
	                break;
	            }
	        }
	    }
	};
	
	// Export using CommonJS or to the window.
	if (true) {
	    module.exports = stable;
	}
	else {
	    window.stable = stable;
	}
	
	})();

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	// Based on the routine from {@link http://jsfiddle.net/MrPolywhirl/NH42z/}.
	
	var CheckMatrix = __webpack_require__(341);
	var TransposeMatrix = __webpack_require__(663);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Utils.Array.Matrix.RotateMatrix
	 * @since 3.0.0
	 *
	 * @param {array} matrix - The array to rotate.
	 * @param {(number|string)} [direction=90] - The amount to rotate the matrix by. The value can be given in degrees: 90, -90, 270, -270 or 180, or a string command: `rotateLeft`, `rotateRight` or `rotate180`.
	 *
	 * @return {array} The rotated matrix array. The source matrix should be discard for the returned matrix.
	 */
	var RotateMatrix = function (matrix, direction)
	{
	    if (direction === undefined) { direction = 90; }
	
	    if (!CheckMatrix(matrix))
	    {
	        return null;
	    }
	
	    if (typeof direction !== 'string')
	    {
	        direction = ((direction % 360) + 360) % 360;
	    }
	
	    if (direction === 90 || direction === -270 || direction === 'rotateLeft')
	    {
	        matrix = TransposeMatrix(matrix);
	        matrix.reverse();
	    }
	    else if (direction === -90 || direction === 270 || direction === 'rotateRight')
	    {
	        matrix.reverse();
	        matrix = TransposeMatrix(matrix);
	    }
	    else if (Math.abs(direction) === 180 || direction === 'rotate180')
	    {
	        for (var i = 0; i < matrix.length; i++)
	        {
	            matrix[i].reverse();
	        }
	
	        matrix.reverse();
	    }
	
	    return matrix;
	};
	
	module.exports = RotateMatrix;


/***/ }),
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(30);
	var toAbsoluteIndex = __webpack_require__(109);
	var toLength = __webpack_require__(21);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(708);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(20);
	var createDesc = __webpack_require__(106);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	var document = __webpack_require__(8).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 227 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(16)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(8).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	var setPrototypeOf = __webpack_require__(238).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(124);
	var ITERATOR = __webpack_require__(16)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(103);
	var descriptor = __webpack_require__(106);
	var setToStringTag = __webpack_require__(125);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(45)(IteratorPrototype, __webpack_require__(16)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(92);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(46);
	var hide = __webpack_require__(45);
	var Iterators = __webpack_require__(124);
	var $iterCreate = __webpack_require__(232);
	var setToStringTag = __webpack_require__(125);
	var getPrototypeOf = __webpack_require__(54);
	var ITERATOR = __webpack_require__(16)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 234 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 235 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var macrotask = __webpack_require__(244).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(58)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(40);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(13);
	var anObject = __webpack_require__(7);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(60)(Function.call, __webpack_require__(53).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(187)('keys');
	var uid = __webpack_require__(110);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(67);
	var defined = __webpack_require__(65);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(181);
	var defined = __webpack_require__(65);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(67);
	var defined = __webpack_require__(65);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 243 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(60);
	var invoke = __webpack_require__(387);
	var html = __webpack_require__(229);
	var cel = __webpack_require__(226);
	var global = __webpack_require__(8);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(58)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(8);
	var DESCRIPTORS = __webpack_require__(19);
	var LIBRARY = __webpack_require__(92);
	var $typed = __webpack_require__(189);
	var hide = __webpack_require__(45);
	var redefineAll = __webpack_require__(107);
	var fails = __webpack_require__(11);
	var anInstance = __webpack_require__(101);
	var toInteger = __webpack_require__(67);
	var toLength = __webpack_require__(21);
	var toIndex = __webpack_require__(405);
	var gOPN = __webpack_require__(104).f;
	var dP = __webpack_require__(20).f;
	var arrayFill = __webpack_require__(223);
	var setToStringTag = __webpack_require__(125);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var core = __webpack_require__(59);
	var LIBRARY = __webpack_require__(92);
	var wksExt = __webpack_require__(406);
	var defineProperty = __webpack_require__(20).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(150);
	var ITERATOR = __webpack_require__(16)('iterator');
	var Iterators = __webpack_require__(124);
	module.exports = __webpack_require__(59).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(91);
	var step = __webpack_require__(390);
	var Iterators = __webpack_require__(124);
	var toIObject = __webpack_require__(55);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(233)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(32),
		__webpack_require__(113)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( document, support ) {
	
	"use strict";
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	return support;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(129),
		__webpack_require__(27),
		__webpack_require__(94)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, toType, isFunction, rnothtmlwhite ) {
	
	"use strict";
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(94)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( rnothtmlwhite ) {
		"use strict";
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
		return stripAndCollapse;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(32),
		__webpack_require__(259),
		__webpack_require__(113)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, documentElement, support ) {
	
	"use strict";
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			div.style.position = "absolute";
			scrollboxSizeVal = div.offsetWidth === 36 || "absolute";
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			}
		} );
	} )();
	
	return support;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return [ "Top", "Right", "Bottom", "Left" ];
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(262)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( pnum ) {
		"use strict";
	
		return new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	"use strict";
	
	/**
	 * Determines whether an object can have data
	 */
	return function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(153),
		__webpack_require__(32),
		__webpack_require__(27),
		__webpack_require__(263),
		__webpack_require__(94),
		__webpack_require__(253),
		__webpack_require__(423),
		__webpack_require__(424),
		__webpack_require__(420),
		__webpack_require__(69),
		__webpack_require__(959),
	
		__webpack_require__(62),
		__webpack_require__(258),
		__webpack_require__(130),
		__webpack_require__(132),
		__webpack_require__(191),
		__webpack_require__(154),
		__webpack_require__(965)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, camelCase, document, isFunction, rcssNum, rnothtmlwhite, cssExpand,
		isHiddenWithinTree, swap, adjustCSS, dataPriv, showHide ) {
	
	"use strict";
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(32),
		__webpack_require__(69),
		__webpack_require__(255),
		__webpack_require__(260),
		__webpack_require__(27),
		__webpack_require__(156),
		__webpack_require__(131)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, dataPriv, acceptData, hasOwn, isFunction, isWindow ) {
	
	"use strict";
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(69),
		__webpack_require__(130),
		__webpack_require__(250)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, dataPriv ) {
	
	"use strict";
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(32)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( document ) {
		"use strict";
	
		return document.documentElement;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(192)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( class2type ) {
		"use strict";
	
		return class2type.hasOwnProperty;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(155)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr ) {
		"use strict";
	
		return arr.indexOf;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(262)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( pnum ) {
	
	"use strict";
	
	return new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var DegToRad = __webpack_require__(97);
	var EventEmitter = __webpack_require__(22);
	var Effects = __webpack_require__(447);
	var Rectangle = __webpack_require__(23);
	var TransformMatrix = __webpack_require__(158);
	var ValueToColor = __webpack_require__(270);
	var Vector2 = __webpack_require__(9);
	
	/**
	 * @typedef {object} JSONCameraBounds
	 * @property {number} x - The horizontal position of camera
	 * @property {number} y - The vertical position of camera
	 * @property {number} width - The width size of camera
	 * @property {number} height - The height size of camera
	 */
	
	/**
	 * @typedef {object} JSONCamera
	 *
	 * @property {string} name - The name of the camera
	 * @property {number} x - The horizontal position of camera
	 * @property {number} y - The vertical position of camera
	 * @property {number} width - The width size of camera
	 * @property {number} height - The height size of camera
	 * @property {number} zoom - The zoom of camera
	 * @property {number} rotation - The rotation of camera
	 * @property {boolean} roundPixels - The round pixels st status of camera
	 * @property {number} scrollX - The horizontal scroll of camera
	 * @property {number} scrollY - The vertical scroll of camera
	 * @property {string} backgroundColor - The background color of camera
	 * @property {(JSONCameraBounds|undefined)} [bounds] - The bounds of camera
	 */
	
	/**
	 * @classdesc
	 * A Camera.
	 *
	 * The Camera is the way in which all games are rendered in Phaser. They provide a view into your game world,
	 * and can be positioned, rotated, zoomed and scrolled accordingly.
	 *
	 * A Camera consists of two elements: The viewport and the scroll values.
	 *
	 * The viewport is the physical position and size of the Camera within your game. Cameras, by default, are
	 * created the same size as your game, but their position and size can be set to anything. This means if you
	 * wanted to create a camera that was 320x200 in size, positioned in the bottom-right corner of your game,
	 * you'd adjust the viewport to do that (using methods like `setViewport` and `setSize`).
	 *
	 * If you wish to change where the Camera is looking in your game, then you scroll it. You can do this
	 * via the properties `scrollX` and `scrollY` or the method `setScroll`. Scrolling has no impact on the
	 * viewport, and changing the viewport has no impact on the scrolling.
	 *
	 * By default a Camera will render all Game Objects it can see. You can change this using the `ignore` method,
	 * allowing you to filter Game Objects out on a per-Camera basis.
	 *
	 * A Camera also has built-in special effects including Fade, Flash and Camera Shake.
	 *
	 * @class Camera
	 * @extends Phaser.Events.EventEmitter
	 * @memberOf Phaser.Cameras.Scene2D
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {number} x - The x position of the Camera, relative to the top-left of the game canvas.
	 * @param {number} y - The y position of the Camera, relative to the top-left of the game canvas.
	 * @param {number} width - The width of the Camera, in pixels.
	 * @param {number} height - The height of the Camera, in pixels.
	 */
	var Camera = new Class({
	
	    Extends: EventEmitter,
	
	    initialize:
	
	    function Camera (x, y, width, height)
	    {
	        EventEmitter.call(this);
	
	        /**
	         * A reference to the Scene this camera belongs to.
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene;
	
	        /**
	         * The name of the Camera. This is left empty for your own use.
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#name
	         * @type {string}
	         * @default ''
	         * @since 3.0.0
	         */
	        this.name = '';
	
	        /**
	         * The x position of the Camera, relative to the top-left of the game canvas.
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#x
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.x = x;
	
	        /**
	         * The y position of the Camera, relative to the top-left of the game canvas.
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#y
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.y = y;
	
	        /**
	         * The width of the Camera, in pixels.
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#width
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.width = width;
	
	        /**
	         * The height of the Camera, in pixels.
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#height
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.height = height;
	
	        /**
	         * Should this camera round its pixel values to integers?
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#roundPixels
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.roundPixels = false;
	
	        /**
	         * Is this Camera using a bounds to restrict scrolling movement?
	         * Set this property along with the bounds via `Camera.setBounds`.
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#useBounds
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.useBounds = false;
	
	        /**
	         * The bounds the camera is restrained to during scrolling.
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#_bounds
	         * @type {Phaser.Geom.Rectangle}
	         * @private
	         * @since 3.0.0
	         */
	        this._bounds = new Rectangle();
	
	        /**
	         * Does this Camera allow the Game Objects it renders to receive input events?
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#inputEnabled
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.inputEnabled = true;
	
	        /**
	         * The horizontal scroll position of this camera.
	         * Optionally restricted via the Camera bounds.
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#scrollX
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.scrollX = 0;
	
	        /**
	         * The vertical scroll position of this camera.
	         * Optionally restricted via the Camera bounds.
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#scrollY
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.scrollY = 0;
	
	        /**
	         * The Camera zoom value. Change this value to zoom in, or out of, a Scene.
	         * Set to 1 to return to the default zoom level.
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#zoom
	         * @type {float}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.zoom = 1;
	
	        /**
	         * The rotation of the Camera. This influences the rendering of all Game Objects visible by this camera.
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#rotation
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.rotation = 0;
	
	        /**
	         * A local transform matrix used for internal calculations.
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#matrix
	         * @type {Phaser.GameObjects.Components.TransformMatrix}
	         * @since 3.0.0
	         */
	        this.matrix = new TransformMatrix(1, 0, 0, 1, 0, 0);
	
	        /**
	         * Does this Camera have a transparent background?
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#transparent
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.transparent = true;
	
	        /**
	         * The background color of this Camera. Only used if `transparent` is `false`.
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#backgroundColor
	         * @type {Phaser.Display.Color}
	         * @since 3.0.0
	         */
	        this.backgroundColor = ValueToColor('rgba(0,0,0,0)');
	
	        /**
	         * The Camera Fade effect handler.
	         * To fade this camera see the `Camera.fade` methods.
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#fadeEffect
	         * @type {Phaser.Cameras.Scene2D.Effects.Fade}
	         * @since 3.5.0
	         */
	        this.fadeEffect = new Effects.Fade(this);
	
	        /**
	         * The Camera Flash effect handler.
	         * To flash this camera see the `Camera.flash` method.
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#flashEffect
	         * @type {Phaser.Cameras.Scene2D.Effects.Flash}
	         * @since 3.5.0
	         */
	        this.flashEffect = new Effects.Flash(this);
	
	        /**
	         * The Camera Shake effect handler.
	         * To shake this camera see the `Camera.shake` method.
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#shakeEffect
	         * @type {Phaser.Cameras.Scene2D.Effects.Shake}
	         * @since 3.5.0
	         */
	        this.shakeEffect = new Effects.Shake(this);
	
	        /**
	         * Should the camera cull Game Objects before checking them for input hit tests?
	         * In some special cases it may be beneficial to disable this.
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#disableCull
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.disableCull = false;
	
	        /**
	         * A temporary array of culled objects.
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#culledObjects
	         * @type {Phaser.GameObjects.GameObject[]}
	         * @default []
	         * @since 3.0.0
	         */
	        this.culledObjects = [];
	
	        /**
	         * Internal follow target reference.
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#_follow
	         * @type {?any}
	         * @private
	         * @default null
	         * @since 3.0.0
	         */
	        this._follow = null;
	
	        /**
	         * Internal camera ID. Assigned by the Camera Manager and used in the camera pool.
	         *
	         * @name Phaser.Cameras.Scene2D.Camera#_id
	         * @type {integer}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._id = 0;
	    },
	
	    /**
	     * Scrolls the Camera so that it is looking at the center of the Camera Bounds (if previously enabled)
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#centerToBounds
	     * @since 3.0.0
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    centerToBounds: function ()
	    {
	        if (this.useBounds)
	        {
	            this.scrollX = (this._bounds.width * 0.5) - (this.width * 0.5);
	            this.scrollY = (this._bounds.height * 0.5) - (this.height * 0.5);
	        }
	
	        return this;
	    },
	
	    /**
	     * Scrolls the Camera so that it is re-centered based on its viewport size.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#centerToSize
	     * @since 3.0.0
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    centerToSize: function ()
	    {
	        this.scrollX = this.width * 0.5;
	        this.scrollY = this.height * 0.5;
	
	        return this;
	    },
	
	    /**
	     * Takes an array of Game Objects and returns a new array featuring only those objects
	     * visible by this camera.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#cull
	     * @since 3.0.0
	     *
	     * @generic {Phaser.GameObjects.GameObject[]} G - [renderableObjects,$return]
	     *
	     * @param {Phaser.GameObjects.GameObject[]} renderableObjects - An array of Game Objects to cull.
	     *
	     * @return {Phaser.GameObjects.GameObject[]} An array of Game Objects visible to this Camera.
	     */
	    cull: function (renderableObjects)
	    {
	        if (this.disableCull)
	        {
	            return renderableObjects;
	        }
	
	        var cameraMatrix = this.matrix.matrix;
	
	        var mva = cameraMatrix[0];
	        var mvb = cameraMatrix[1];
	        var mvc = cameraMatrix[2];
	        var mvd = cameraMatrix[3];
	
	        /* First Invert Matrix */
	        var determinant = (mva * mvd) - (mvb * mvc);
	
	        if (!determinant)
	        {
	            return renderableObjects;
	        }
	
	        var mve = cameraMatrix[4];
	        var mvf = cameraMatrix[5];
	
	        var scrollX = this.scrollX;
	        var scrollY = this.scrollY;
	        var cameraW = this.width;
	        var cameraH = this.height;
	        var culledObjects = this.culledObjects;
	        var length = renderableObjects.length;
	
	        determinant = 1 / determinant;
	
	        culledObjects.length = 0;
	
	        for (var index = 0; index < length; ++index)
	        {
	            var object = renderableObjects[index];
	
	            if (!object.hasOwnProperty('width') || object.parentContainer)
	            {
	                culledObjects.push(object);
	                continue;
	            }
	
	            var objectW = object.width;
	            var objectH = object.height;
	            var objectX = (object.x - (scrollX * object.scrollFactorX)) - (objectW * object.originX);
	            var objectY = (object.y - (scrollY * object.scrollFactorY)) - (objectH * object.originY);
	            var tx = (objectX * mva + objectY * mvc + mve);
	            var ty = (objectX * mvb + objectY * mvd + mvf);
	            var tw = ((objectX + objectW) * mva + (objectY + objectH) * mvc + mve);
	            var th = ((objectX + objectW) * mvb + (objectY + objectH) * mvd + mvf);
	            var cullW = cameraW + objectW;
	            var cullH = cameraH + objectH;
	
	            if (tx > -objectW || ty > -objectH || tx < cullW || ty < cullH ||
	                tw > -objectW || th > -objectH || tw < cullW || th < cullH)
	            {
	                culledObjects.push(object);
	            }
	        }
	
	        return culledObjects;
	    },
	
	    /**
	     * Fades the Camera in from the given color over the duration specified.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#fadeIn
	     * @since 3.3.0
	     *
	     * @param {integer} [duration=1000] - The duration of the effect in milliseconds.
	     * @param {integer} [red=0] - The amount to fade the red channel towards. A value between 0 and 255.
	     * @param {integer} [green=0] - The amount to fade the green channel towards. A value between 0 and 255.
	     * @param {integer} [blue=0] - The amount to fade the blue channel towards. A value between 0 and 255.
	     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
	     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
	     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    fadeIn: function (duration, red, green, blue, callback, context)
	    {
	        return this.fadeEffect.start(false, duration, red, green, blue, true, callback, context);
	    },
	
	    /**
	     * Fades the Camera out to the given color over the duration specified.
	     * This is an alias for Camera.fade that forces the fade to start, regardless of existing fades.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#fadeOut
	     * @since 3.3.0
	     *
	     * @param {integer} [duration=1000] - The duration of the effect in milliseconds.
	     * @param {integer} [red=0] - The amount to fade the red channel towards. A value between 0 and 255.
	     * @param {integer} [green=0] - The amount to fade the green channel towards. A value between 0 and 255.
	     * @param {integer} [blue=0] - The amount to fade the blue channel towards. A value between 0 and 255.
	     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
	     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
	     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    fadeOut: function (duration, red, green, blue, callback, context)
	    {
	        return this.fadeEffect.start(true, duration, red, green, blue, true, callback, context);
	    },
	
	    /**
	     * Fades the Camera from the given color to transparent over the duration specified.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#fadeFrom
	     * @since 3.5.0
	     *
	     * @param {integer} [duration=1000] - The duration of the effect in milliseconds.
	     * @param {integer} [red=0] - The amount to fade the red channel towards. A value between 0 and 255.
	     * @param {integer} [green=0] - The amount to fade the green channel towards. A value between 0 and 255.
	     * @param {integer} [blue=0] - The amount to fade the blue channel towards. A value between 0 and 255.
	     * @param {boolean} [force=false] - Force the effect to start immediately, even if already running.
	     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
	     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
	     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    fadeFrom: function (duration, red, green, blue, force, callback, context)
	    {
	        return this.fadeEffect.start(false, duration, red, green, blue, force, callback, context);
	    },
	
	    /**
	     * Fades the Camera from transparent to the given color over the duration specified.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#fade
	     * @since 3.0.0
	     *
	     * @param {integer} [duration=1000] - The duration of the effect in milliseconds.
	     * @param {integer} [red=0] - The amount to fade the red channel towards. A value between 0 and 255.
	     * @param {integer} [green=0] - The amount to fade the green channel towards. A value between 0 and 255.
	     * @param {integer} [blue=0] - The amount to fade the blue channel towards. A value between 0 and 255.
	     * @param {boolean} [force=false] - Force the effect to start immediately, even if already running.
	     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
	     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
	     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    fade: function (duration, red, green, blue, force, callback, context)
	    {
	        return this.fadeEffect.start(true, duration, red, green, blue, force, callback, context);
	    },
	
	    /**
	     * Flashes the Camera by setting it to the given color immediately and then fading it away again quickly over the duration specified.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#flash
	     * @since 3.0.0
	     *
	     * @param {integer} [duration=250] - The duration of the effect in milliseconds.
	     * @param {integer} [red=255] - The amount to fade the red channel towards. A value between 0 and 255.
	     * @param {integer} [green=255] - The amount to fade the green channel towards. A value between 0 and 255.
	     * @param {integer} [blue=255] - The amount to fade the blue channel towards. A value between 0 and 255.
	     * @param {boolean} [force=false] - Force the effect to start immediately, even if already running.
	     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
	     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
	     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    flash: function (duration, red, green, blue, force, callback, context)
	    {
	        return this.flashEffect.start(duration, red, green, blue, force, callback, context);
	    },
	
	    /**
	     * Shakes the Camera by the given intensity over the duration specified.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#shake
	     * @since 3.0.0
	     *
	     * @param {integer} [duration=100] - The duration of the effect in milliseconds.
	     * @param {number} [intensity=0.05] - The intensity of the shake.
	     * @param {boolean} [force=false] - Force the shake effect to start immediately, even if already running.
	     * @param {function} [callback] - This callback will be invoked every frame for the duration of the effect.
	     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
	     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    shake: function (duration, intensity, force, callback, context)
	    {
	        return this.shakeEffect.start(duration, intensity, force, callback, context);
	    },
	
	    /**
	     * Converts the given `x` and `y` coordinates into World space, based on this Cameras transform.
	     * You can optionally provide a Vector2, or similar object, to store the results in.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#getWorldPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [output,$return]
	     *
	     * @param {number} x - The x position to convert to world space.
	     * @param {number} y - The y position to convert to world space.
	     * @param {(object|Phaser.Math.Vector2)} [output] - An optional object to store the results in. If not provided a new Vector2 will be created.
	     *
	     * @return {Phaser.Math.Vector2} An object holding the converted values in its `x` and `y` properties.
	     */
	    getWorldPoint: function (x, y, output)
	    {
	        if (output === undefined) { output = new Vector2(); }
	
	        var cameraMatrix = this.matrix.matrix;
	
	        var mva = cameraMatrix[0];
	        var mvb = cameraMatrix[1];
	        var mvc = cameraMatrix[2];
	        var mvd = cameraMatrix[3];
	        var mve = cameraMatrix[4];
	        var mvf = cameraMatrix[5];
	
	        /* First Invert Matrix */
	        var determinant = (mva * mvd) - (mvb * mvc);
	
	        if (!determinant)
	        {
	            output.x = x;
	            output.y = y;
	
	            return output;
	        }
	
	        determinant = 1 / determinant;
	
	        var ima = mvd * determinant;
	        var imb = -mvb * determinant;
	        var imc = -mvc * determinant;
	        var imd = mva * determinant;
	        var ime = (mvc * mvf - mvd * mve) * determinant;
	        var imf = (mvb * mve - mva * mvf) * determinant;
	
	        var c = Math.cos(this.rotation);
	        var s = Math.sin(this.rotation);
	
	        var zoom = this.zoom;
	
	        var scrollX = this.scrollX;
	        var scrollY = this.scrollY;
	
	        var sx = x + ((scrollX * c - scrollY * s) * zoom);
	        var sy = y + ((scrollX * s + scrollY * c) * zoom);
	
	        /* Apply transform to point */
	        output.x = (sx * ima + sy * imc + ime);
	        output.y = (sx * imb + sy * imd + imf);
	
	        return output;
	    },
	
	    /**
	     * Given a Game Object, or an array of Game Objects, it will update all of their camera filter settings
	     * so that they are ignored by this Camera. This means they will not be rendered by this Camera.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#ignore
	     * @since 3.0.0
	     *
	     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObject - The Game Object, or array of Game Objects, to be ignored by this Camera.
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    ignore: function (gameObject)
	    {
	        var id = this._id;
	
	        if (Array.isArray(gameObject))
	        {
	            for (var i = 0; i < gameObject.length; i++)
	            {
	                gameObject[i].cameraFilter |= id;
	            }
	        }
	        else
	        {
	            gameObject.cameraFilter |= id;
	        }
	
	        return this;
	    },
	
	    /**
	     * Internal preRender step.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#preRender
	     * @protected
	     * @since 3.0.0
	     *
	     * @param {number} baseScale - The base scale, as set in the Camera Manager.
	     * @param {number} resolution - The game resolution.
	     */
	    preRender: function (baseScale, resolution)
	    {
	        var width = this.width;
	        var height = this.height;
	        var zoom = this.zoom * baseScale;
	        var matrix = this.matrix;
	        var originX = width / 2;
	        var originY = height / 2;
	        var follow = this._follow;
	
	        if (follow !== null)
	        {
	            originX = follow.x;
	            originY = follow.y;
	
	            this.scrollX = (originX - width * 0.5) / zoom;
	            this.scrollY = (originY - height * 0.5) / zoom;
	        }
	
	        if (this.useBounds)
	        {
	            var bounds = this._bounds;
	
	            var bw = Math.max(0, bounds.right - width);
	            var bh = Math.max(0, bounds.bottom - height);
	
	            if (this.scrollX < bounds.x)
	            {
	                this.scrollX = bounds.x;
	            }
	            else if (this.scrollX > bw)
	            {
	                this.scrollX = bw;
	            }
	
	            if (this.scrollY < bounds.y)
	            {
	                this.scrollY = bounds.y;
	            }
	            else if (this.scrollY > bh)
	            {
	                this.scrollY = bh;
	            }
	        }
	
	        if (this.roundPixels)
	        {
	            this.scrollX = Math.round(this.scrollX);
	            this.scrollY = Math.round(this.scrollY);
	        }
	
	        matrix.loadIdentity();
	        matrix.scale(resolution, resolution);
	        matrix.translate(this.x + originX, this.y + originY);
	        matrix.rotate(this.rotation);
	        matrix.scale(zoom, zoom);
	        matrix.translate(-originX, -originY);
	
	        this.shakeEffect.preRender();
	    },
	
	    /**
	     * If this Camera has previously had movement bounds set on it, this will remove them.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#removeBounds
	     * @since 3.0.0
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    removeBounds: function ()
	    {
	        this.useBounds = false;
	
	        this._bounds.setEmpty();
	
	        return this;
	    },
	
	    /**
	     * Set the rotation of this Camera. This causes everything it renders to appear rotated.
	     * 
	     * Rotating a camera does not rotate the viewport itself, it is applied during rendering.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#setAngle
	     * @since 3.0.0
	     *
	     * @param {number} [value=0] - The cameras angle of rotation, given in degrees.
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    setAngle: function (value)
	    {
	        if (value === undefined) { value = 0; }
	
	        this.rotation = DegToRad(value);
	
	        return this;
	    },
	
	    /**
	     * Sets the background color for this Camera.
	     * 
	     * By default a Camera has a transparent background but it can be given a solid color, with any level
	     * of transparency, via this method.
	     *
	     * The color value can be specified using CSS color notation, hex or numbers.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#setBackgroundColor
	     * @since 3.0.0
	     *
	     * @param {(string|number|InputColorObject)} [color='rgba(0,0,0,0)'] - The color value. In CSS, hex or numeric color notation.
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    setBackgroundColor: function (color)
	    {
	        if (color === undefined) { color = 'rgba(0,0,0,0)'; }
	
	        this.backgroundColor = ValueToColor(color);
	
	        this.transparent = (this.backgroundColor.alpha === 0);
	
	        return this;
	    },
	
	    /**
	     * Set the world bounds for this Camera.
	     *
	     * A Camera bounds controls where the camera can scroll to within the world. It does not limit
	     * rendering of the camera, or placement of the viewport within your game.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#setBounds
	     * @since 3.0.0
	     *
	     * @param {integer} x - The top-left x coordinate of the bounds.
	     * @param {integer} y - The top-left y coordinate of the bounds.
	     * @param {integer} width - The width of the bounds, in pixels.
	     * @param {integer} height - The height of the bounds, in pixels.
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    setBounds: function (x, y, width, height)
	    {
	        this._bounds.setTo(x, y, width, height);
	
	        this.useBounds = true;
	
	        return this;
	    },
	
	    /**
	     * Sets the name of this Camera.
	     * This value is for your own use and isn't used internally.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#setName
	     * @since 3.0.0
	     *
	     * @param {string} [value=''] - The name of the Camera.
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    setName: function (value)
	    {
	        if (value === undefined) { value = ''; }
	
	        this.name = value;
	
	        return this;
	    },
	
	    /**
	     * Set the position of the Camera viewport within the game.
	     * 
	     * This does not change where the camera is 'looking'. See `setScroll` to control that.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#setPosition
	     * @since 3.0.0
	     *
	     * @param {number} x - The top-left x coordinate of the Camera viewport.
	     * @param {number} [y=x] - The top-left y coordinate of the Camera viewport.
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    setPosition: function (x, y)
	    {
	        if (y === undefined) { y = x; }
	
	        this.x = x;
	        this.y = y;
	
	        return this;
	    },
	
	    /**
	     * Set the rotation of this Camera. This causes everything it renders to appear rotated.
	     * 
	     * Rotating a camera does not rotate the viewport itself, it is applied during rendering.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#setRotation
	     * @since 3.0.0
	     *
	     * @param {number} [value=0] - The rotation of the Camera, in radians.
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    setRotation: function (value)
	    {
	        if (value === undefined) { value = 0; }
	
	        this.rotation = value;
	
	        return this;
	    },
	
	    /**
	     * Should the Camera round pixel values to whole integers when scrolling?
	     * In some types of game this is required to prevent sub-pixel aliasing.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#setRoundPixels
	     * @since 3.0.0
	     *
	     * @param {boolean} value - `true` to round Camera pixels, `false` to not.
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    setRoundPixels: function (value)
	    {
	        this.roundPixels = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the Scene the Camera is bound to.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#setScene
	     * @since 3.0.0
	     *
	     * @param {Phaser.Scene} scene - The Scene the camera is bound to.
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    setScene: function (scene)
	    {
	        this.scene = scene;
	
	        return this;
	    },
	
	    /**
	     * Set the position of where the Camera is looking within the game.
	     * You can also modify the properties `Camera.scrollX` and `Camera.scrollY` directly.
	     * Use this method, or the scroll properties, to move your camera around the game world.
	     * 
	     * This does not change where the camera viewport is placed. See `setPosition` to control that.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#setScroll
	     * @since 3.0.0
	     *
	     * @param {number} x - The x coordinate of the Camera in the game world.
	     * @param {number} [y=x] - The y coordinate of the Camera in the game world.
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    setScroll: function (x, y)
	    {
	        if (y === undefined) { y = x; }
	
	        this.scrollX = x;
	        this.scrollY = y;
	
	        return this;
	    },
	
	    /**
	     * Set the size of the Camera viewport.
	     *
	     * By default a Camera is the same size as the game, but can be made smaller via this method,
	     * allowing you to create mini-cam style effects by creating and positioning a smaller Camera
	     * viewport within your game.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#setSize
	     * @since 3.0.0
	     *
	     * @param {integer} width - The width of the Camera viewport.
	     * @param {integer} [height=width] - The height of the Camera viewport.
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    setSize: function (width, height)
	    {
	        if (height === undefined) { height = width; }
	
	        this.width = width;
	        this.height = height;
	
	        return this;
	    },
	
	    /**
	     * This method sets the position and size of the Camera viewport in a single call.
	     *
	     * If you're trying to change where the Camera is looking at in your game, then see
	     * the method `Camera.setScroll` instead. This method is for changing the viewport
	     * itself, not what the camera can see.
	     * 
	     * By default a Camera is the same size as the game, but can be made smaller via this method,
	     * allowing you to create mini-cam style effects by creating and positioning a smaller Camera
	     * viewport within your game.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#setViewport
	     * @since 3.0.0
	     *
	     * @param {number} x - The top-left x coordinate of the Camera viewport.
	     * @param {number} y - The top-left y coordinate of the Camera viewport.
	     * @param {integer} width - The width of the Camera viewport.
	     * @param {integer} [height=width] - The height of the Camera viewport.
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    setViewport: function (x, y, width, height)
	    {
	        this.x = x;
	        this.y = y;
	        this.width = width;
	        this.height = height;
	
	        return this;
	    },
	
	    /**
	     * Set the zoom value of the Camera.
	     *
	     * Changing to a smaller value, such as 0.5, will cause the camera to 'zoom out'.
	     * Changing to a larger value, such as 2, will cause the camera to 'zoom in'.
	     *
	     * A value of 1 means 'no zoom' and is the default.
	     *
	     * Changing the zoom does not impact the Camera viewport in any way, it is only applied during rendering.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#setZoom
	     * @since 3.0.0
	     *
	     * @param {float} [value=1] - The zoom value of the Camera.
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    setZoom: function (value)
	    {
	        if (value === undefined) { value = 1; }
	
	        this.zoom = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the Camera to follow a Game Object.
	     *
	     * When enabled the Camera will automatically adjust its scroll position to keep the target Game Object
	     * in its center.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#startFollow
	     * @since 3.0.0
	     *
	     * @param {(Phaser.GameObjects.GameObject|object)} target - The target for the Camera to follow.
	     * @param {boolean} [roundPx=false] - Round the movement pixels to whole integers?
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    startFollow: function (target, roundPx)
	    {
	        if (roundPx === undefined) { roundPx = false; }
	
	        this._follow = target;
	
	        this.roundPixels = roundPx;
	
	        return this;
	    },
	
	    /**
	     * Stops a Camera from following a Game Object, if previously set via `Camera.startFollow`.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#stopFollow
	     * @since 3.0.0
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    stopFollow: function ()
	    {
	        this._follow = null;
	
	        return this;
	    },
	
	    /**
	     * Returns an Object suitable for JSON storage containing all of the Camera viewport and rendering properties.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#toJSON
	     * @since 3.0.0
	     *
	     * @return {JSONCamera} A well-formed object suitable for conversion to JSON.
	     */
	    toJSON: function ()
	    {
	        var output = {
	            name: this.name,
	            x: this.x,
	            y: this.y,
	            width: this.width,
	            height: this.height,
	            zoom: this.zoom,
	            rotation: this.rotation,
	            roundPixels: this.roundPixels,
	            scrollX: this.scrollX,
	            scrollY: this.scrollY,
	            backgroundColor: this.backgroundColor.rgba
	        };
	
	        if (this.useBounds)
	        {
	            output['bounds'] = {
	                x: this._bounds.x,
	                y: this._bounds.y,
	                width: this._bounds.width,
	                height: this._bounds.height
	            };
	        }
	
	        return output;
	    },
	
	    /**
	     * Resets any active FX, such as a fade, flash or shake. Useful to call after a fade in order to
	     * remove the fade.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#resetFX
	     * @since 3.0.0
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} This Camera instance.
	     */
	    resetFX: function ()
	    {
	        this.shakeEffect.reset();
	        this.flashEffect.reset();
	        this.fadeEffect.reset();
	
	        return this;
	    },
	
	    /**
	     * Internal method called automatically by the Camera Manager.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#update
	     * @protected
	     * @since 3.0.0
	     *
	     * @param {integer} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
	     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
	     */
	    update: function (time, delta)
	    {
	        this.shakeEffect.update(time, delta);
	        this.flashEffect.update(time, delta);
	        this.fadeEffect.update(time, delta);
	    },
	
	    /**
	     * This event is fired when a camera is destroyed by the Camera Manager.
	     *
	     * @event CameraDestroyEvent
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that was destroyed.
	     */
	
	    /**
	     * Destroys this Camera instance. You rarely need to call this directly.
	     *
	     * Called by the Camera Manager. If you wish to destroy a Camera please use `CameraManager.remove` as
	     * cameras are stored in a pool, ready for recycling later, and calling this directly will prevent that.
	     *
	     * @method Phaser.Cameras.Scene2D.Camera#destroy
	     * @fires CameraDestroyEvent
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.emit('cameradestroy', this);
	
	        this.removeAllListeners();
	
	        this.resetFX();
	
	        this.matrix.destroy();
	
	        this.culledObjects = [];
	
	        this.target = undefined;
	
	        this._bounds = undefined;
	
	        this.scene = undefined;
	    }
	
	});
	
	module.exports = Camera;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Matrix4 = __webpack_require__(307);
	var RandomXYZ = __webpack_require__(554);
	var RandomXYZW = __webpack_require__(555);
	var RotateVec3 = __webpack_require__(558);
	var Set = __webpack_require__(146);
	var Sprite3D = __webpack_require__(197);
	var Vector2 = __webpack_require__(9);
	var Vector3 = __webpack_require__(142);
	var Vector4 = __webpack_require__(310);
	
	//  Local cache vars
	var tmpVec3 = new Vector3();
	var tmpVec4 = new Vector4();
	var dirvec = new Vector3();
	var rightvec = new Vector3();
	var billboardMatrix = new Matrix4();
	
	//  @author attribute https://github.com/mattdesl/cam3d/wiki
	
	/**
	 * @typedef {object} RayDef
	 *
	 * @property {Phaser.Math.Vector3} origin - [description]
	 * @property {Phaser.Math.Vector3} direction - [description]
	 */
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class Camera
	 * @memberOf Phaser.Cameras.Sprite3D
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - [description]
	 */
	var Camera = new Class({
	
	    initialize:
	
	    function Camera (scene)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D#displayList
	         * @type {Phaser.GameObjects.DisplayList}
	         * @since 3.0.0
	         */
	        this.displayList = scene.sys.displayList;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D#updateList
	         * @type {Phaser.GameObjects.UpdateList}
	         * @since 3.0.0
	         */
	        this.updateList = scene.sys.updateList;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D#name
	         * @type {string}
	         * @default ''
	         * @since 3.0.0
	         */
	        this.name = '';
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D#direction
	         * @type {Phaser.Math.Vector3}
	         * @since 3.0.0
	         */
	        this.direction = new Vector3(0, 0, -1);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D#up
	         * @type {Phaser.Math.Vector3}
	         * @since 3.0.0
	         */
	        this.up = new Vector3(0, 1, 0);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D#position
	         * @type {Phaser.Math.Vector3}
	         * @since 3.0.0
	         */
	        this.position = new Vector3();
	
	        //  The mapping from 3D size units to pixels.
	        //  In the default case 1 3D unit = 128 pixels. So a sprite that is
	        //  256 x 128 px in size will be 2 x 1 units.
	        //  Change to whatever best fits your game assets.
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D#pixelScale
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.pixelScale = 128;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D#projection
	         * @type {Phaser.Math.Matrix4}
	         * @since 3.0.0
	         */
	        this.projection = new Matrix4();
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D#view
	         * @type {Phaser.Math.Matrix4}
	         * @since 3.0.0
	         */
	        this.view = new Matrix4();
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D#combined
	         * @type {Phaser.Math.Matrix4}
	         * @since 3.0.0
	         */
	        this.combined = new Matrix4();
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D#invProjectionView
	         * @type {Phaser.Math.Matrix4}
	         * @since 3.0.0
	         */
	        this.invProjectionView = new Matrix4();
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D#near
	         * @type {number}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.near = 1;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D#far
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.far = 100;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D#ray
	         * @type {RayDef}
	         * @since 3.0.0
	         */
	        this.ray = {
	            origin: new Vector3(),
	            direction: new Vector3()
	        };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D#viewportWidth
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.viewportWidth = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D#viewportHeight
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.viewportHeight = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D#billboardMatrixDirty
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.billboardMatrixDirty = true;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D#children
	         * @type {Phaser.Structs.Set.<Phaser.GameObjects.GameObject>}
	         * @since 3.0.0
	         */
	        this.children = new Set();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#setPosition
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} z - [description]
	     *
	     * @return {Phaser.Cameras.Sprite3D.Camera} This Camera object.
	     */
	    setPosition: function (x, y, z)
	    {
	        this.position.set(x, y, z);
	
	        return this.update();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#setScene
	     * @since 3.0.0
	     *
	     * @param {Phaser.Scene} scene - [description]
	     *
	     * @return {Phaser.Cameras.Sprite3D.Camera} This Camera object.
	     */
	    setScene: function (scene)
	    {
	        this.scene = scene;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#setPixelScale
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.Cameras.Sprite3D.Camera} This Camera object.
	     */
	    setPixelScale: function (value)
	    {
	        this.pixelScale = value;
	
	        return this.update();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#add
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Sprite3D} sprite3D - [description]
	     *
	     * @return {Phaser.GameObjects.Sprite3D} [description]
	     */
	    add: function (sprite3D)
	    {
	        this.children.set(sprite3D);
	
	        this.updateChildren();
	
	        return sprite3D;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#remove
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} child - [description]
	     *
	     * @return {Phaser.Cameras.Sprite3D.Camera} This Camera object.
	     */
	    remove: function (child)
	    {
	        this.displayList.remove(child.gameObject);
	        this.updateList.remove(child.gameObject);
	
	        this.children.delete(child);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#clear
	     * @since 3.0.0
	     *
	     * @return {Phaser.Cameras.Sprite3D.Camera} This Camera object.
	     */
	    clear: function ()
	    {
	        var children = this.getChildren();
	
	        for (var i = 0; i < children.length; i++)
	        {
	            this.remove(children[i]);
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#getChildren
	     * @since 3.0.0
	     *
	     * @return {array} [description]
	     */
	    getChildren: function ()
	    {
	        return this.children.entries;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#create
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} z - [description]
	     * @param {string} key - [description]
	     * @param {(string|number)} frame - [description]
	     * @param {boolean} [visible=true] - [description]
	     *
	     * @return {Phaser.GameObjects.Sprite3D} [description]
	     */
	    create: function (x, y, z, key, frame, visible)
	    {
	        if (visible === undefined) { visible = true; }
	
	        var child = new Sprite3D(this.scene, x, y, z, key, frame);
	
	        this.displayList.add(child.gameObject);
	        this.updateList.add(child.gameObject);
	
	        child.visible = visible;
	
	        this.children.set(child);
	
	        this.updateChildren();
	
	        return child;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#createMultiple
	     * @since 3.0.0
	     *
	     * @param {number} quantity - [description]
	     * @param {string} key - [description]
	     * @param {(string|number)} frame - [description]
	     * @param {boolean} [visible=true] - [description]
	     *
	     * @return {Phaser.GameObjects.Sprite3D[]} [description]
	     */
	    createMultiple: function (quantity, key, frame, visible)
	    {
	        if (visible === undefined) { visible = true; }
	
	        var output = [];
	
	        for (var i = 0; i < quantity; i++)
	        {
	            var child = new Sprite3D(this.scene, 0, 0, 0, key, frame);
	
	            this.displayList.add(child.gameObject);
	            this.updateList.add(child.gameObject);
	
	            child.visible = visible;
	
	            this.children.set(child);
	
	            output.push(child);
	        }
	
	        return output;
	    },
	
	    //  Create a bunch of Sprite3D objects in a rectangle
	    //  size and spacing are Vec3s (or if integers are converted to vec3s)
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#createRect
	     * @since 3.0.0
	     *
	     * @param {(number|{x:number,y:number})} size - [description]
	     * @param {(number|{x:number,y:number,z:number})} spacing - [description]
	     * @param {string} key - [description]
	     * @param {(string|number)} [frame] - [description]
	     *
	     * @return {Phaser.GameObjects.Sprite3D[]} [description]
	     */
	    createRect: function (size, spacing, key, frame)
	    {
	        if (typeof size === 'number') { size = { x: size, y: size, z: size }; }
	        if (typeof spacing === 'number') { spacing = { x: spacing, y: spacing, z: spacing }; }
	
	        var quantity = size.x * size.y * size.z;
	
	        var sprites = this.createMultiple(quantity, key, frame);
	
	        var i = 0;
	
	        for (var z = 0.5 - (size.z / 2); z < (size.z / 2); z++)
	        {
	            for (var y = 0.5 - (size.y / 2); y < (size.y / 2); y++)
	            {
	                for (var x = 0.5 - (size.x / 2); x < (size.x / 2); x++)
	                {
	                    var bx = (x * spacing.x);
	                    var by = (y * spacing.y);
	                    var bz = (z * spacing.z);
	
	                    sprites[i].position.set(bx, by, bz);
	
	                    i++;
	                }
	            }
	        }
	
	        this.update();
	
	        return sprites;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#randomSphere
	     * @since 3.0.0
	     *
	     * @param {number} [radius=1] - [description]
	     * @param {Phaser.GameObjects.Sprite3D[]} [sprites] - [description]
	     *
	     * @return {Phaser.Cameras.Sprite3D.Camera} This Camera object.
	     */
	    randomSphere: function (radius, sprites)
	    {
	        if (sprites === undefined) { sprites = this.getChildren(); }
	
	        for (var i = 0; i < sprites.length; i++)
	        {
	            RandomXYZ(sprites[i].position, radius);
	        }
	
	        return this.update();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#randomCube
	     * @since 3.0.0
	     *
	     * @param {float} [scale=1] - [description]
	     * @param {Phaser.GameObjects.Sprite3D[]} [sprites] - [description]
	     *
	     * @return {Phaser.Cameras.Sprite3D.Camera} This Camera object.
	     */
	    randomCube: function (scale, sprites)
	    {
	        if (sprites === undefined) { sprites = this.getChildren(); }
	
	        for (var i = 0; i < sprites.length; i++)
	        {
	            RandomXYZW(sprites[i].position, scale);
	        }
	
	        return this.update();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#translateChildren
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector3} vec3 - [description]
	     * @param {Phaser.GameObjects.Sprite3D[]} sprites - [description]
	     *
	     * @return {Phaser.Cameras.Sprite3D.Camera} This Camera object.
	     */
	    translateChildren: function (vec3, sprites)
	    {
	        if (sprites === undefined) { sprites = this.getChildren(); }
	
	        for (var i = 0; i < sprites.length; i++)
	        {
	            sprites[i].position.add(vec3);
	        }
	
	        return this.update();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#transformChildren
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Matrix4} mat4 - [description]
	     * @param {Phaser.GameObjects.Sprite3D[]} sprites - [description]
	     *
	     * @return {Phaser.Cameras.Sprite3D.Camera} This Camera object.
	     */
	    transformChildren: function (mat4, sprites)
	    {
	        if (sprites === undefined) { sprites = this.getChildren(); }
	
	        for (var i = 0; i < sprites.length; i++)
	        {
	            sprites[i].position.transformMat4(mat4);
	        }
	
	        return this.update();
	    },
	
	    /**
	     * Sets the width and height of the viewport. Does not update any matrices.
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#setViewport
	     * @since 3.0.0
	     *
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     *
	     * @return {Phaser.Cameras.Sprite3D.Camera} This Camera object.
	     */
	    setViewport: function (width, height)
	    {
	        this.viewportWidth = width;
	        this.viewportHeight = height;
	
	        return this.update();
	    },
	
	    /**
	     * Translates this camera by a specified Vector3 object
	     * or x, y, z parameters. Any undefined x y z values will
	     * default to zero, leaving that component unaffected.
	     * If you wish to set the camera position directly call setPosition instead.
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#translate
	     * @since 3.0.0
	     *
	     * @param {(number|object)} x - [description]
	     * @param {number} [y] - [description]
	     * @param {number} [z] - [description]
	     *
	     * @return {Phaser.Cameras.Sprite3D.Camera} This Camera object.
	     */
	    translate: function (x, y, z)
	    {
	        if (typeof x === 'object')
	        {
	            this.position.x += x.x || 0;
	            this.position.y += x.y || 0;
	            this.position.z += x.z || 0;
	        }
	        else
	        {
	            this.position.x += x || 0;
	            this.position.y += y || 0;
	            this.position.z += z || 0;
	        }
	
	        return this.update();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#lookAt
	     * @since 3.0.0
	     *
	     * @param {(number|object)} x - [description]
	     * @param {number} [y] - [description]
	     * @param {number} [z] - [description]
	     *
	     * @return {Phaser.Cameras.Sprite3D.Camera} This Camera object.
	     */
	    lookAt: function (x, y, z)
	    {
	        var dir = this.direction;
	        var up = this.up;
	
	        if (typeof x === 'object')
	        {
	            dir.copy(x);
	        }
	        else
	        {
	            dir.set(x, y, z);
	        }
	
	        dir.subtract(this.position).normalize();
	
	        //  Calculate right vector
	        tmpVec3.copy(dir).cross(up).normalize();
	
	        //  Calculate up vector
	        up.copy(tmpVec3).cross(dir).normalize();
	
	        return this.update();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#rotate
	     * @since 3.0.0
	     *
	     * @param {float} radians - [description]
	     * @param {Phaser.Math.Vector3} axis - [description]
	     *
	     * @return {Phaser.Cameras.Sprite3D.Camera} This Camera object.
	     */
	    rotate: function (radians, axis)
	    {
	        RotateVec3(this.direction, axis, radians);
	        RotateVec3(this.up, axis, radians);
	
	        return this.update();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#rotateAround
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector3} point - [description]
	     * @param {float} radians - [description]
	     * @param {Phaser.Math.Vector3} axis - [description]
	     *
	     * @return {Phaser.Cameras.Sprite3D.Camera} This Camera object.
	     */
	    rotateAround: function (point, radians, axis)
	    {
	        tmpVec3.copy(point).subtract(this.position);
	
	        this.translate(tmpVec3);
	        this.rotate(radians, axis);
	        this.translate(tmpVec3.negate());
	
	        return this.update();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#project
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector3} vec - [description]
	     * @param {Phaser.Math.Vector4} out - [description]
	     *
	     * @return {Phaser.Math.Vector4} [description]
	     */
	    project: function (vec, out)
	    {
	        if (out === undefined) { out = new Vector4(); }
	
	        //  TODO: support viewport XY
	        var viewportWidth = this.viewportWidth;
	        var viewportHeight = this.viewportHeight;
	        var n = Camera.NEAR_RANGE;
	        var f = Camera.FAR_RANGE;
	
	        //  For useful Z and W values we should do the usual steps: clip space -> NDC -> window coords
	
	        //  Implicit 1.0 for w component
	        tmpVec4.set(vec.x, vec.y, vec.z, 1.0);
	
	        //  Transform into clip space
	        tmpVec4.transformMat4(this.combined);
	
	        //  Avoid divide by zero when 0x0x0 camera projects to a 0x0x0 vec3
	        if (tmpVec4.w === 0)
	        {
	            tmpVec4.w = 1;
	        }
	
	        //  Now into NDC
	        tmpVec4.x = tmpVec4.x / tmpVec4.w;
	        tmpVec4.y = tmpVec4.y / tmpVec4.w;
	        tmpVec4.z = tmpVec4.z / tmpVec4.w;
	
	        //  And finally into window coordinates
	        out.x = viewportWidth / 2 * tmpVec4.x + (0 + viewportWidth / 2);
	        out.y = viewportHeight / 2 * tmpVec4.y + (0 + viewportHeight / 2);
	        out.z = (f - n) / 2 * tmpVec4.z + (f + n) / 2;
	
	        //  If the out vector has a fourth component, we also store (1/clip.w), same idea as gl_FragCoord.w
	        if (out.w === 0 || out.w)
	        {
	            out.w = 1 / tmpVec4.w;
	        }
	
	        return out;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#unproject
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector4} vec - [description]
	     * @param {Phaser.Math.Vector3} out - [description]
	     *
	     * @return {Phaser.Math.Vector3} [description]
	     */
	    unproject: function (vec, out)
	    {
	        if (out === undefined) { out = new Vector3(); }
	
	        var viewport = tmpVec4.set(0, 0, this.viewportWidth, this.viewportHeight);
	
	        return out.copy(vec).unproject(viewport, this.invProjectionView);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#getPickRay
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} [y] - [description]
	     *
	     * @return {RayDef} [description]
	     */
	    getPickRay: function (x, y)
	    {
	        var origin = this.ray.origin.set(x, y, 0);
	        var direction = this.ray.direction.set(x, y, 1);
	        var viewport = tmpVec4.set(0, 0, this.viewportWidth, this.viewportHeight);
	        var mtx = this.invProjectionView;
	
	        origin.unproject(viewport, mtx);
	
	        direction.unproject(viewport, mtx);
	
	        direction.subtract(origin).normalize();
	
	        return this.ray;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#updateChildren
	     * @since 3.0.0
	     *
	     * @return {Phaser.Cameras.Sprite3D.Camera} This Camera object.
	     */
	    updateChildren: function ()
	    {
	        var children = this.children.entries;
	
	        for (var i = 0; i < children.length; i++)
	        {
	            children[i].project(this);
	        }
	
	        return this;
	    },
	
	    //  Overriden by subclasses
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#update
	     * @since 3.0.0
	     *
	     * @return {Phaser.Cameras.Sprite3D.Camera} This Camera object.
	     */
	    update: function ()
	    {
	        return this.updateChildren();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#updateBillboardMatrix
	     * @since 3.0.0
	     */
	    updateBillboardMatrix: function ()
	    {
	        var dir = dirvec.set(this.direction).negate();
	
	        // Better view-aligned billboards might use this:
	        // var dir = tmp.set(camera.position).subtract(p).normalize();
	
	        var right = rightvec.set(this.up).cross(dir).normalize();
	        var up = tmpVec3.set(dir).cross(right).normalize();
	
	        var out = billboardMatrix.val;
	
	        out[0] = right.x;
	        out[1] = right.y;
	        out[2] = right.z;
	        out[3] = 0;
	
	        out[4] = up.x;
	        out[5] = up.y;
	        out[6] = up.z;
	        out[7] = 0;
	
	        out[8] = dir.x;
	        out[9] = dir.y;
	        out[10] = dir.z;
	        out[11] = 0;
	
	        out[12] = 0;
	        out[13] = 0;
	        out[14] = 0;
	        out[15] = 1;
	
	        this.billboardMatrixDirty = false;
	    },
	
	    /**
	     * This is a utility function for canvas 3D rendering,
	     * which determines the "point size" of a camera-facing
	     * sprite billboard given its 3D world position
	     * (origin at center of sprite) and its world width
	     * and height in x/y.
	     *
	     * We place into the output Vector2 the scaled width
	     * and height. If no `out` is specified, a new Vector2
	     * will be created for convenience (this should be avoided
	     * in tight loops).
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#getPointSize
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector2} vec - The position of the 3D Sprite.
	     * @param {Phaser.Math.Vector2} size - The x and y dimensions.
	     * @param {Phaser.Math.Vector2} out - The result, scaled x and y dimensions.
	     *
	     * @return {Phaser.Math.Vector2} [description]
	     */
	    getPointSize: function (vec, size, out)
	    {
	        if (out === undefined) { out = new Vector2(); }
	
	        // TODO: optimize this with a simple distance calculation:
	        // https://developer.valvesoftware.com/wiki/Field_of_View
	
	        if (this.billboardMatrixDirty)
	        {
	            this.updateBillboardMatrix();
	        }
	
	        var tmp = tmpVec3;
	
	        var dx = (size.x / this.pixelScale) / 2;
	        var dy = (size.y / this.pixelScale) / 2;
	
	        tmp.set(-dx, -dy, 0).transformMat4(billboardMatrix).add(vec);
	
	        this.project(tmp, tmp);
	
	        var tlx = tmp.x;
	        var tly = tmp.y;
	
	        tmp.set(dx, dy, 0).transformMat4(billboardMatrix).add(vec);
	
	        this.project(tmp, tmp);
	
	        var brx = tmp.x;
	        var bry = tmp.y;
	
	        // var w = Math.abs(brx - tlx);
	        // var h = Math.abs(bry - tly);
	
	        //  Allow the projection to get negative ...
	        var w = brx - tlx;
	        var h = bry - tly;
	
	        return out.set(w, h);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.children.clear();
	
	        this.scene = undefined;
	        this.children = undefined;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#setX
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.Cameras.Sprite3D.Camera} This Camera object.
	     */
	    setX: function (value)
	    {
	        this.position.x = value;
	
	        return this.update();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#setY
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.Cameras.Sprite3D.Camera} This Camera object.
	     */
	    setY: function (value)
	    {
	        this.position.y = value;
	
	        return this.update();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.Camera#setZ
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.Cameras.Sprite3D.Camera} This Camera object.
	     */
	    setZ: function (value)
	    {
	        this.position.z = value;
	
	        return this.update();
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Cameras.Sprite3D.Camera#x
	     * @type {number}
	     * @since 3.0.0
	     */
	    x: {
	        get: function ()
	        {
	            return this.position.x;
	        },
	
	        set: function (value)
	        {
	            this.position.x = value;
	            this.update();
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Cameras.Sprite3D.Camera#y
	     * @type {number}
	     * @since 3.0.0
	     */
	    y: {
	        get: function ()
	        {
	            return this.position.y;
	        },
	
	        set: function (value)
	        {
	            this.position.y = value;
	            this.update();
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Cameras.Sprite3D.Camera#z
	     * @type {number}
	     * @since 3.0.0
	     */
	    z: {
	        get: function ()
	        {
	            return this.position.z;
	        },
	
	        set: function (value)
	        {
	            this.position.z = value;
	            this.update();
	        }
	    }
	
	});
	
	Camera.FAR_RANGE = 1.0;
	Camera.NEAR_RANGE = 0.0;
	
	module.exports = Camera;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var OS = __webpack_require__(157);
	var Browser = __webpack_require__(195);
	var CanvasPool = __webpack_require__(56);
	
	/**
	 * Determines the features of the browser running this Phaser Game instance.
	 * These values are read-only and populated during the boot sequence of the game.
	 * They are then referenced by internal game systems and are available for you to access
	 * via `this.sys.game.device.features` from within any Scene.
	 * 
	 * @typedef {object} Phaser.Device.Features
	 * @since 3.0.0
	 * 
	 * @property {?boolean} canvasBitBltShift - True if canvas supports a 'copy' bitblt onto itself when the source and destination regions overlap.
	 * @property {boolean} canvas - Is canvas available?
	 * @property {boolean} file - Is file available?
	 * @property {boolean} fileSystem - Is fileSystem available?
	 * @property {boolean} getUserMedia - Does the device support the getUserMedia API?
	 * @property {boolean} littleEndian - Is the device big or little endian? (only detected if the browser supports TypedArrays)
	 * @property {boolean} localStorage - Is localStorage available?
	 * @property {boolean} pointerLock - Is Pointer Lock available?
	 * @property {boolean} support32bit - Does the device context support 32bit pixel manipulation using array buffer views?
	 * @property {boolean} vibration - Does the device support the Vibration API?
	 * @property {boolean} webGL - Is webGL available?
	 * @property {boolean} worker - Is worker available?
	 */
	var Features = {
	
	    canvas: false,
	    canvasBitBltShift: null,
	    file: false,
	    fileSystem: false,
	    getUserMedia: true,
	    littleEndian: false,
	    localStorage: false,
	    pointerLock: false,
	    support32bit: false,
	    vibration: false,
	    webGL: false,
	    worker: false
	
	};
	
	// Check Little or Big Endian system.
	// @author Matt DesLauriers (@mattdesl)
	function checkIsLittleEndian ()
	{
	    var a = new ArrayBuffer(4);
	    var b = new Uint8Array(a);
	    var c = new Uint32Array(a);
	
	    b[0] = 0xa1;
	    b[1] = 0xb2;
	    b[2] = 0xc3;
	    b[3] = 0xd4;
	
	    if (c[0] === 0xd4c3b2a1)
	    {
	        return true;
	    }
	
	    if (c[0] === 0xa1b2c3d4)
	    {
	        return false;
	    }
	    else
	    {
	        //  Could not determine endianness
	        return null;
	    }
	}
	
	function init ()
	{
	    Features.canvas = !!window['CanvasRenderingContext2D'] || OS.cocoonJS;
	
	    try
	    {
	        Features.localStorage = !!localStorage.getItem;
	    }
	    catch (error)
	    {
	        Features.localStorage = false;
	    }
	
	    Features.file = !!window['File'] && !!window['FileReader'] && !!window['FileList'] && !!window['Blob'];
	    Features.fileSystem = !!window['requestFileSystem'];
	
	    var isUint8 = false;
	
	    var testWebGL = function ()
	    {
	        if (window['WebGLRenderingContext'])
	        {
	            try
	            {
	                var canvas = CanvasPool.createWebGL(this);
	
	                if (OS.cocoonJS)
	                {
	                    canvas.screencanvas = false;
	                }
	
	                var ctx = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
	
	                var canvas2D = CanvasPool.create2D(this);
	
	                var ctx2D = canvas2D.getContext('2d');
	
	                //  Can't be done on a webgl context
	                var image = ctx2D.createImageData(1, 1);
	
	                //  Test to see if ImageData uses CanvasPixelArray or Uint8ClampedArray.
	                //  @author Matt DesLauriers (@mattdesl)
	                isUint8 = image.data instanceof Uint8ClampedArray;
	
	                CanvasPool.remove(canvas);
	                CanvasPool.remove(canvas2D);
	
	                return !!ctx;
	            }
	            catch (e)
	            {
	                return false;
	            }
	        }
	
	        return false;
	    };
	
	    Features.webGL = testWebGL();
	
	    Features.worker = !!window['Worker'];
	
	    Features.pointerLock = 'pointerLockElement' in document || 'mozPointerLockElement' in document || 'webkitPointerLockElement' in document;
	
	    navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia || navigator.oGetUserMedia;
	
	    window.URL = window.URL || window.webkitURL || window.mozURL || window.msURL;
	
	    Features.getUserMedia = Features.getUserMedia && !!navigator.getUserMedia && !!window.URL;
	
	    // Older versions of firefox (< 21) apparently claim support but user media does not actually work
	    if (Browser.firefox && Browser.firefoxVersion < 21)
	    {
	        Features.getUserMedia = false;
	    }
	
	    // Excludes iOS versions as they generally wrap UIWebView (eg. Safari WebKit) and it
	    // is safer to not try and use the fast copy-over method.
	    if (!OS.iOS && (Browser.ie || Browser.firefox || Browser.chrome))
	    {
	        Features.canvasBitBltShift = true;
	    }
	
	    // Known not to work
	    if (Browser.safari || Browser.mobileSafari)
	    {
	        Features.canvasBitBltShift = false;
	    }
	
	    navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
	
	    if (navigator.vibrate)
	    {
	        Features.vibration = true;
	    }
	
	    if (typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint32Array !== 'undefined')
	    {
	        Features.littleEndian = checkIsLittleEndian();
	    }
	
	    Features.support32bit = (
	        typeof ArrayBuffer !== 'undefined' &&
	        typeof Uint8ClampedArray !== 'undefined' &&
	        typeof Int32Array !== 'undefined' &&
	        Features.littleEndian !== null &&
	        isUint8
	    );
	
	    return Features;
	}
	
	module.exports = init();


/***/ }),
/* 267 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var ALIGN_CONST = {
	
	    /**
	    * A constant representing a top-left alignment or position.
	    * @constant
	    * @name Phaser.Display.Align.TOP_LEFT
	    * @since 3.0.0
	    * @type {integer}
	    */
	    TOP_LEFT: 0,
	
	    /**
	    * A constant representing a top-center alignment or position.
	    * @constant
	    * @name Phaser.Display.Align.TOP_CENTER
	    * @since 3.0.0
	    * @type {integer}
	    */
	    TOP_CENTER: 1,
	
	    /**
	    * A constant representing a top-right alignment or position.
	    * @constant
	    * @name Phaser.Display.Align.TOP_RIGHT
	    * @since 3.0.0
	    * @type {integer}
	    */
	    TOP_RIGHT: 2,
	
	    /**
	    * A constant representing a left-top alignment or position.
	    * @constant
	    * @name Phaser.Display.Align.LEFT_TOP
	    * @since 3.0.0
	    * @type {integer}
	    */
	    LEFT_TOP: 3,
	
	    /**
	    * A constant representing a left-center alignment or position.
	    * @constant
	    * @name Phaser.Display.Align.LEFT_CENTER
	    * @since 3.0.0
	    * @type {integer}
	    */
	    LEFT_CENTER: 4,
	
	    /**
	    * A constant representing a left-bottom alignment or position.
	    * @constant
	    * @name Phaser.Display.Align.LEFT_BOTTOM
	    * @since 3.0.0
	    * @type {integer}
	    */
	    LEFT_BOTTOM: 5,
	
	    /**
	    * A constant representing a center alignment or position.
	    * @constant
	    * @name Phaser.Display.Align.CENTER
	    * @since 3.0.0
	    * @type {integer}
	    */
	    CENTER: 6,
	
	    /**
	    * A constant representing a right-top alignment or position.
	    * @constant
	    * @name Phaser.Display.Align.RIGHT_TOP
	    * @since 3.0.0
	    * @type {integer}
	    */
	    RIGHT_TOP: 7,
	
	    /**
	    * A constant representing a right-center alignment or position.
	    * @constant
	    * @name Phaser.Display.Align.RIGHT_CENTER
	    * @since 3.0.0
	    * @type {integer}
	    */
	    RIGHT_CENTER: 8,
	
	    /**
	    * A constant representing a right-bottom alignment or position.
	    * @constant
	    * @name Phaser.Display.Align.RIGHT_BOTTOM
	    * @since 3.0.0
	    * @type {integer}
	    */
	    RIGHT_BOTTOM: 9,
	
	    /**
	    * A constant representing a bottom-left alignment or position.
	    * @constant
	    * @name Phaser.Display.Align.BOTTOM_LEFT
	    * @since 3.0.0
	    * @type {integer}
	    */
	    BOTTOM_LEFT: 10,
	
	    /**
	    * A constant representing a bottom-center alignment or position.
	    * @constant
	    * @name Phaser.Display.Align.BOTTOM_CENTER
	    * @since 3.0.0
	    * @type {integer}
	    */
	    BOTTOM_CENTER: 11,
	
	    /**
	    * A constant representing a bottom-right alignment or position.
	    * @constant
	    * @name Phaser.Display.Align.BOTTOM_RIGHT
	    * @since 3.0.0
	    * @type {integer}
	    */
	    BOTTOM_RIGHT: 12
	
	};
	
	module.exports = ALIGN_CONST;


/***/ }),
/* 268 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  Browser specific prefix, so not going to change between contexts, only between browsers
	var prefix = '';
	
	/**
	 * @namespace Phaser.Display.Canvas.Smoothing
	 * @since 3.0.0
	 */
	var Smoothing = function ()
	{
	    /**
	     * Gets the Smoothing Enabled vendor prefix being used on the given context, or null if not set.
	     *
	     * @function Phaser.Display.Canvas.Smoothing.getPrefix
	     * @since 3.0.0
	     *
	     * @param {(CanvasRenderingContext2D|WebGLRenderingContext)} context - [description]
	     *
	     * @return {string} [description]
	     */
	    var getPrefix = function (context)
	    {
	        var vendors = [ 'i', 'webkitI', 'msI', 'mozI', 'oI' ];
	
	        for (var i = 0; i < vendors.length; i++)
	        {
	            var s = vendors[i] + 'mageSmoothingEnabled';
	
	            if (s in context)
	            {
	                return s;
	            }
	        }
	
	        return null;
	    };
	
	    /**
	     * Sets the Image Smoothing property on the given context. Set to false to disable image smoothing.
	     * By default browsers have image smoothing enabled, which isn't always what you visually want, especially
	     * when using pixel art in a game. Note that this sets the property on the context itself, so that any image
	     * drawn to the context will be affected. This sets the property across all current browsers but support is
	     * patchy on earlier browsers, especially on mobile.
	     *
	     * @function Phaser.Display.Canvas.Smoothing.enable
	     * @since 3.0.0
	     *
	     * @param {(CanvasRenderingContext2D|WebGLRenderingContext)} context - [description]
	     *
	     * @return {(CanvasRenderingContext2D|WebGLRenderingContext)} [description]
	     */
	    var enable = function (context)
	    {
	        if (prefix === '')
	        {
	            prefix = getPrefix(context);
	        }
	
	        if (prefix)
	        {
	            context[prefix] = true;
	        }
	
	        return context;
	    };
	
	    /**
	     * Sets the Image Smoothing property on the given context. Set to false to disable image smoothing.
	     * By default browsers have image smoothing enabled, which isn't always what you visually want, especially
	     * when using pixel art in a game. Note that this sets the property on the context itself, so that any image
	     * drawn to the context will be affected. This sets the property across all current browsers but support is
	     * patchy on earlier browsers, especially on mobile.
	     *
	     * @function Phaser.Display.Canvas.Smoothing.disable
	     * @since 3.0.0
	     *
	     * @param {(CanvasRenderingContext2D|WebGLRenderingContext)} context - [description]
	     *
	     * @return {(CanvasRenderingContext2D|WebGLRenderingContext)} [description]
	     */
	    var disable = function (context)
	    {
	        if (prefix === '')
	        {
	            prefix = getPrefix(context);
	        }
	
	        if (prefix)
	        {
	            context[prefix] = false;
	        }
	
	        return context;
	    };
	
	    /**
	     * Returns `true` if the given context has image smoothing enabled, otherwise returns `false`.
	     * Returns null if no smoothing prefix is available.
	     *
	     * @function Phaser.Display.Canvas.Smoothing.isEnabled
	     * @since 3.0.0
	     *
	     * @param {(CanvasRenderingContext2D|WebGLRenderingContext)} context - [description]
	     *
	     * @return {?boolean} [description]
	     */
	    var isEnabled = function (context)
	    {
	        return (prefix !== null) ? context[prefix] : null;
	    };
	
	    return {
	        disable: disable,
	        enable: enable,
	        getPrefix: getPrefix,
	        isEnabled: isEnabled
	    };
	
	};
	
	module.exports = Smoothing();


/***/ }),
/* 269 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Given 3 separate color values this will return an integer representation of it.
	 *
	 * @function Phaser.Display.Color.GetColor
	 * @since 3.0.0
	 *
	 * @param {integer} red - The red color value. A number between 0 and 255.
	 * @param {integer} green - The green color value. A number between 0 and 255.
	 * @param {integer} blue - The blue color value. A number between 0 and 255.
	 *
	 * @return {number} The combined color value.
	 */
	var GetColor = function (red, green, blue)
	{
	    return red << 16 | green << 8 | blue;
	};
	
	module.exports = GetColor;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var HexStringToColor = __webpack_require__(475);
	var IntegerToColor = __webpack_require__(477);
	var ObjectToColor = __webpack_require__(479);
	var RGBStringToColor = __webpack_require__(480);
	
	/**
	 * Converts the given source color value into an instance of a Color class.
	 * The value can be either a string, prefixed with `rgb` or a hex string, a number or an Object.
	 *
	 * @function Phaser.Display.Color.ValueToColor
	 * @since 3.0.0
	 *
	 * @param {(string|number|InputColorObject)} input - The source color value to convert.
	 *
	 * @return {Phaser.Display.Color} A Color object.
	 */
	var ValueToColor = function (input)
	{
	    var t = typeof input;
	
	    switch (t)
	    {
	        case 'string':
	
	            if (input.substr(0, 3).toLowerCase() === 'rgb')
	            {
	                return RGBStringToColor(input);
	            }
	            else
	            {
	                return HexStringToColor(input);
	            }
	
	        case 'number':
	
	            return IntegerToColor(input);
	
	        case 'object':
	
	            return ObjectToColor(input);
	    }
	};
	
	module.exports = ValueToColor;


/***/ }),
/* 271 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Adds the given element to the DOM. If a parent is provided the element is added as a child of the parent, providing it was able to access it.
	 * If no parent was given or falls back to using `document.body`.
	 *
	 * @function Phaser.DOM.AddToDOM
	 * @since 3.0.0
	 *
	 * @param {HTMLElement} element - The element to be added to the DOM. Usually a Canvas object.
	 * @param {(string|HTMLElement)} [parent] - The parent in which to add the element. Can be a string which is passed to `getElementById` or an actual DOM object.
	 * @param {boolean} [overflowHidden=true] - Whether or not to hide overflowing content inside the parent.
	 *
	 * @return {HTMLElement} The element that was added to the DOM.
	 */
	var AddToDOM = function (element, parent, overflowHidden)
	{
	    if (overflowHidden === undefined) { overflowHidden = true; }
	
	    var target;
	
	    if (parent)
	    {
	        if (typeof parent === 'string')
	        {
	            //  Hopefully an element ID
	            target = document.getElementById(parent);
	        }
	        else if (typeof parent === 'object' && parent.nodeType === 1)
	        {
	            //  Quick test for a HTMLelement
	            target = parent;
	        }
	    }
	
	    //  Fallback, covers an invalid ID and a non HTMLelement object
	    if (!target)
	    {
	        target = document.body;
	    }
	
	    if (overflowHidden && target.style)
	    {
	        target.style.overflow = 'hidden';
	    }
	
	    target.appendChild(element);
	
	    return element;
	};
	
	module.exports = AddToDOM;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetAdvancedValue = __webpack_require__(24);
	
	/**
	 * Adds an Animation component to a Sprite and populates it based on the given config.
	 *
	 * @function Phaser.GameObjects.BuildGameObjectAnimation
	 * @since 3.0.0
	 *
	 * @param {Phaser.GameObjects.Sprite} sprite - [description]
	 * @param {object} config - [description]
	 *
	 * @return {Phaser.GameObjects.Sprite} The updated Sprite.
	 */
	var BuildGameObjectAnimation = function (sprite, config)
	{
	    var animConfig = GetAdvancedValue(config, 'anims', null);
	
	    if (animConfig === null)
	    {
	        return sprite;
	    }
	
	    if (typeof animConfig === 'string')
	    {
	        //  { anims: 'key' }
	        sprite.anims.play(animConfig);
	    }
	    else if (typeof animConfig === 'object')
	    {
	        //  { anims: {
	        //              key: string
	        //              startFrame: [string|integer]
	        //              delay: [float]
	        //              repeat: [integer]
	        //              repeatDelay: [float]
	        //              yoyo: [boolean]
	        //              play: [boolean]
	        //              delayedPlay: [boolean]
	        //           }
	        //  }
	
	        var anims = sprite.anims;
	
	        var key = GetAdvancedValue(animConfig, 'key', undefined);
	        var startFrame = GetAdvancedValue(animConfig, 'startFrame', undefined);
	
	        var delay = GetAdvancedValue(animConfig, 'delay', 0);
	        var repeat = GetAdvancedValue(animConfig, 'repeat', 0);
	        var repeatDelay = GetAdvancedValue(animConfig, 'repeatDelay', 0);
	        var yoyo = GetAdvancedValue(animConfig, 'yoyo', false);
	        
	        var play = GetAdvancedValue(animConfig, 'play', false);
	        var delayedPlay = GetAdvancedValue(animConfig, 'delayedPlay', 0);
	
	        anims.delay(delay);
	        anims.repeat(repeat);
	        anims.repeatDelay(repeatDelay);
	        anims.yoyo(yoyo);
	
	        if (play)
	        {
	            anims.play(key, startFrame);
	        }
	        else if (delayedPlay > 0)
	        {
	            anims.delayedPlay(delayedPlay, key, startFrame);
	        }
	        else
	        {
	            anims.load(key);
	        }
	    }
	
	    return sprite;
	};
	
	module.exports = BuildGameObjectAnimation;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(28);
	var GameObject = __webpack_require__(5);
	var GetBitmapTextSize = __webpack_require__(488);
	var Render = __webpack_require__(1110);
	
	/**
	 * @typedef {object} DisplayCallbackConfig
	 * @property {{topLeft:number,topRight:number,bottomLeft:number,bottomRight:number}} tint - [description]
	 * @property {number} index - [description]
	 * @property {number} charCode - [description]
	 * @property {number} x - [description]
	 * @property {number} y - [description]
	 * @property {number} scale - [description]
	 * @property {number} rotation - [description]
	 * @property {any} data - [description]
	 */
	
	/**
	 * @callback DisplayCallback
	 *
	 * @param {DisplayCallbackConfig} display - [description]
	 */
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class DynamicBitmapText
	 * @extends Phaser.GameObjects.GameObject
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @since 3.0.0
	 *
	 * @extends Phaser.GameObjects.Components.Alpha
	 * @extends Phaser.GameObjects.Components.BlendMode
	 * @extends Phaser.GameObjects.Components.Depth
	 * @extends Phaser.GameObjects.Components.Mask
	 * @extends Phaser.GameObjects.Components.Origin
	 * @extends Phaser.GameObjects.Components.Pipeline
	 * @extends Phaser.GameObjects.Components.ScrollFactor
	 * @extends Phaser.GameObjects.Components.Texture
	 * @extends Phaser.GameObjects.Components.Tint
	 * @extends Phaser.GameObjects.Components.Transform
	 * @extends Phaser.GameObjects.Components.Visible
	 *
	 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. It can only belong to one Scene at any given time.
	 * @param {number} x - The x coordinate of this Game Object in world space.
	 * @param {number} y - The y coordinate of this Game Object in world space.
	 * @param {string} font - [description]
	 * @param {(string|string[])} [text] - [description]
	 * @param {number} [size] - [description]
	 */
	var DynamicBitmapText = new Class({
	
	    Extends: GameObject,
	
	    Mixins: [
	        Components.Alpha,
	        Components.BlendMode,
	        Components.Depth,
	        Components.Mask,
	        Components.Origin,
	        Components.Pipeline,
	        Components.ScrollFactor,
	        Components.Texture,
	        Components.Tint,
	        Components.Transform,
	        Components.Visible,
	        Render
	    ],
	
	    initialize:
	
	    function DynamicBitmapText (scene, x, y, font, text, size)
	    {
	        if (text === undefined) { text = ''; }
	
	        GameObject.call(this, scene, 'DynamicBitmapText');
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.DynamicBitmapText#font
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.font = font;
	
	        var entry = this.scene.sys.cache.bitmapFont.get(font);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.DynamicBitmapText#fontData
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.fontData = entry.data;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.DynamicBitmapText#text
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.text = '';
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.DynamicBitmapText#fontSize
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.fontSize = size || this.fontData.size;
	
	        /**
	         * Adds/Removes spacing between characters
	         * Can be a negative or positive number
	         *
	         * @name Phaser.GameObjects.DynamicBitmapText#letterSpacing
	         * @type {number}
	         * @since 3.5.0
	         */
	        this.letterSpacing = 0;
	
	        this.setText(text);
	
	        this.setTexture(entry.texture, entry.frame);
	        this.setPosition(x, y);
	        this.setOrigin(0, 0);
	        this.initPipeline('TextureTintPipeline');
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.DynamicBitmapText#_bounds
	         * @type {TextBounds}
	         * @private
	         * @since 3.0.0
	         */
	        this._bounds = this.getTextBounds();
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.DynamicBitmapText#scrollX
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.scrollX = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.DynamicBitmapText#scrollY
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.scrollY = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.DynamicBitmapText#cropWidth
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.cropWidth = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.DynamicBitmapText#cropHeight
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.cropHeight = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.DynamicBitmapText#displayCallback;
	         * @type {DisplayCallback}
	         * @since 3.0.0
	         */
	        this.displayCallback;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.DynamicBitmapText#setSize
	     * @since 3.0.0
	     *
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     *
	     * @return {Phaser.GameObjects.DynamicBitmapText} This Game Object.
	     */
	    setSize: function (width, height)
	    {
	        this.cropWidth = width;
	        this.cropHeight = height;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.DynamicBitmapText#setDisplayCallback
	     * @since 3.0.0
	     *
	     * @param {DisplayCallback} callback - [description]
	     *
	     * @return {Phaser.GameObjects.DynamicBitmapText} This Game Object.
	     */
	    setDisplayCallback: function (callback)
	    {
	        this.displayCallback = callback;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.DynamicBitmapText#setFontSize
	     * @since 3.0.0
	     *
	     * @param {number} size - [description]
	     *
	     * @return {Phaser.GameObjects.DynamicBitmapText} This Game Object.
	     */
	    setFontSize: function (size)
	    {
	        this.fontSize = size;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.DynamicBitmapText#setText
	     * @since 3.0.0
	     *
	     * @param {(string|string[])} value - The string, or array of strings, to be set as the content of this BitmapText.
	     *
	     * @return {Phaser.GameObjects.DynamicBitmapText} This Game Object.
	     */
	    setText: function (value)
	    {
	        if (!value && value !== 0)
	        {
	            value = '';
	        }
	
	        if (Array.isArray(value))
	        {
	            value = value.join('\n');
	        }
	
	        if (value !== this.text)
	        {
	            this.text = value.toString();
	
	            this.updateDisplayOrigin();
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.DynamicBitmapText#setScrollX
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.DynamicBitmapText} This Game Object.
	     */
	    setScrollX: function (value)
	    {
	        this.scrollX = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.DynamicBitmapText#setScrollY
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.DynamicBitmapText} This Game Object.
	     */
	    setScrollY: function (value)
	    {
	        this.scrollY = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.DynamicBitmapText#getTextBounds
	     * @since 3.0.0
	     *
	     * @param {boolean} round - [description]
	     *
	     * @return {TextBounds} [description]
	     */
	    getTextBounds: function (round)
	    {
	        //  local = the BitmapText based on fontSize and 0x0 coords
	        //  global = the BitmapText, taking into account scale and world position
	
	        this._bounds = GetBitmapTextSize(this, round);
	
	        return this._bounds;
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.GameObjects.DynamicBitmapText#width
	     * @type {number}
	     * @since 3.0.0
	     */
	    width: {
	
	        get: function ()
	        {
	            this.getTextBounds(false);
	            return this._bounds.global.width;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.GameObjects.DynamicBitmapText#height
	     * @type {number}
	     * @since 3.0.0
	     */
	    height: {
	
	        get: function ()
	        {
	            this.getTextBounds(false);
	            return this._bounds.global.height;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.DynamicBitmapText#toJSON
	     * @since 3.0.0
	     *
	     * @return {JSONBitmapText} [description]
	     */
	    toJSON: function ()
	    {
	        var out = Components.ToJSON(this);
	
	        //  Extra data is added here
	
	        var data = {
	            font: this.font,
	            text: this.text,
	            fontSize: this.fontSize
	        };
	
	        out.data = data;
	
	        return out;
	    }
	
	});
	
	module.exports = DynamicBitmapText;


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(28);
	var GameObject = __webpack_require__(5);
	var GetBitmapTextSize = __webpack_require__(488);
	var ParseFromAtlas = __webpack_require__(1103);
	var Render = __webpack_require__(1115);
	
	/**
	 * @typedef {object} TextBounds
	 *
	 * @property {object} local - [description]
	 * @property {number} local.x - [description]
	 * @property {number} local.y - [description]
	 * @property {number} local.width - [description]
	 * @property {number} local.height - [description]
	 * @property {object} global - [description]
	 * @property {number} global.x - [description]
	 * @property {number} global.y - [description]
	 * @property {number} global.width - [description]
	 * @property {number} global.height - [description]
	 */
	
	/**
	 * @typedef {object} JSONBitmapText
	 * @extends {JSONGameObject}
	 *
	 * @property {string} font - [description]
	 * @property {string} text - [description]
	 * @property {number} fontSize - [description]
	 * @property {number} letterSpacing - Adds/Removes spacing between characters
	 */
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class BitmapText
	 * @extends Phaser.GameObjects.GameObject
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @since 3.0.0
	 *
	 * @extends Phaser.GameObjects.Components.Alpha
	 * @extends Phaser.GameObjects.Components.BlendMode
	 * @extends Phaser.GameObjects.Components.Depth
	 * @extends Phaser.GameObjects.Components.Mask
	 * @extends Phaser.GameObjects.Components.Origin
	 * @extends Phaser.GameObjects.Components.Pipeline
	 * @extends Phaser.GameObjects.Components.ScaleMode
	 * @extends Phaser.GameObjects.Components.ScrollFactor
	 * @extends Phaser.GameObjects.Components.Texture
	 * @extends Phaser.GameObjects.Components.Tint
	 * @extends Phaser.GameObjects.Components.Transform
	 * @extends Phaser.GameObjects.Components.Visible
	 * 
	 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. It can only belong to one Scene at any given time.
	 * @param {number} x - The x coordinate of this Game Object in world space.
	 * @param {number} y - The y coordinate of this Game Object in world space.
	 * @param {string} font - [description]
	 * @param {(string|string[])} [text] - [description]
	 * @param {number} [size] - [description]
	 */
	var BitmapText = new Class({
	
	    Extends: GameObject,
	
	    Mixins: [
	        Components.Alpha,
	        Components.BlendMode,
	        Components.Depth,
	        Components.Mask,
	        Components.Origin,
	        Components.Pipeline,
	        Components.ScaleMode,
	        Components.ScrollFactor,
	        Components.Texture,
	        Components.Tint,
	        Components.Transform,
	        Components.Visible,
	        Render
	    ],
	
	    initialize:
	
	    function BitmapText (scene, x, y, font, text, size)
	    {
	        if (text === undefined) { text = ''; }
	
	        GameObject.call(this, scene, 'BitmapText');
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.BitmapText#font
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.font = font;
	
	        var entry = this.scene.sys.cache.bitmapFont.get(font);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.BitmapText#fontData
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.fontData = entry.data;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.BitmapText#text
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.text = '';
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.BitmapText#fontSize
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.fontSize = size || this.fontData.size;
	
	        /**
	         * Adds/Removes spacing between characters
	         * Can be a negative or positive number
	         *
	         * @name Phaser.GameObjects.BitmapText#letterSpacing
	         * @type {number}
	         * @since 3.4.0
	         */
	        this.letterSpacing = 0;
	
	        this.setText(text);
	
	        this.setTexture(entry.texture, entry.frame);
	        this.setPosition(x, y);
	        this.setOrigin(0, 0);
	        this.initPipeline('TextureTintPipeline');
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.BitmapText#_bounds
	         * @type {TextBounds}
	         * @private
	         * @since 3.0.0
	         */
	        this._bounds = this.getTextBounds();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.BitmapText#setFontSize
	     * @since 3.0.0
	     *
	     * @param {number} size - [description]
	     *
	     * @return {Phaser.GameObjects.BitmapText} This Game Object.
	     */
	    setFontSize: function (size)
	    {
	        this.fontSize = size;
	
	        return this;
	    },
	
	    /**
	     * Sets the letter spacing between each character of this Bitmap Text.
	     * Can be a positive value to increase the space, or negative to reduce it.
	     * Spacing is applied after the kerning values have been set.
	     *
	     * @method Phaser.GameObjects.BitmapText#setLetterSpacing
	     * @since 3.4.0
	     *
	     * @param {number} [spacing=0] - The amount of horizontal space to add between each character.
	     *
	     * @return {Phaser.GameObjects.BitmapText} This Game Object.
	     */
	    setLetterSpacing: function (spacing)
	    {
	        if (spacing === undefined) { spacing = 0; }
	
	        this.letterSpacing = spacing;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.BitmapText#setText
	     * @since 3.0.0
	     *
	     * @param {(string|string[])} value - The string, or array of strings, to be set as the content of this BitmapText.
	     *
	     * @return {Phaser.GameObjects.BitmapText} This Game Object.
	     */
	    setText: function (value)
	    {
	        if (!value && value !== 0)
	        {
	            value = '';
	        }
	
	        if (Array.isArray(value))
	        {
	            value = value.join('\n');
	        }
	
	        if (value !== this.text)
	        {
	            this.text = value.toString();
	
	            this.updateDisplayOrigin();
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.BitmapText#getTextBounds
	     * @since 3.0.0
	     *
	     * @param {boolean} round - [description]
	     *
	     * @return {TextBounds} [description]
	     */
	    getTextBounds: function (round)
	    {
	        //  local = the BitmapText based on fontSize and 0x0 coords
	        //  global = the BitmapText, taking into account scale and world position
	
	        this._bounds = GetBitmapTextSize(this, round);
	
	        return this._bounds;
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.GameObjects.BitmapText#width
	     * @type {number}
	     * @since 3.0.0
	     */
	    width: {
	
	        get: function ()
	        {
	            this.getTextBounds(false);
	
	            return this._bounds.global.width;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.GameObjects.BitmapText#height
	     * @type {number}
	     * @since 3.0.0
	     */
	    height: {
	
	        get: function ()
	        {
	            this.getTextBounds(false);
	
	            return this._bounds.global.height;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.BitmapText#toJSON
	     * @since 3.0.0
	     *
	     * @return {JSONBitmapText} [description]
	     */
	    toJSON: function ()
	    {
	        var out = Components.ToJSON(this);
	
	        //  Extra data is added here
	
	        var data = {
	            font: this.font,
	            text: this.text,
	            fontSize: this.fontSize,
	            letterSpacing: this.letterSpacing
	        };
	
	        out.data = data;
	
	        return out;
	    }
	
	});
	
	BitmapText.ParseFromAtlas = ParseFromAtlas;
	
	module.exports = BitmapText;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BlitterRender = __webpack_require__(1120);
	var Bob = __webpack_require__(1122);
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(28);
	var Frame = __webpack_require__(327);
	var GameObject = __webpack_require__(5);
	var List = __webpack_require__(210);
	
	/**
	 * @callback Phaser.GameObjects.Blitter.BlitterFromCallback
	 *
	 * @param {Phaser.GameObjects.Blitter} blitter - [description]
	 * @param {integer} index - [description]
	 */
	
	/**
	 * @classdesc
	 * A Blitter Game Object.
	 *
	 * The Blitter Game Object is a special kind of container that creates, updates and manages Bob objects.
	 * Bobs are designed for rendering speed rather than flexibility. They consist of a texture, or frame from a texture,
	 * a position and an alpha value. You cannot scale or rotate them. They use a batched drawing method for speed
	 * during rendering.
	 *
	 * A Blitter Game Object has one texture bound to it. Bobs created by the Blitter can use any Frame from this
	 * Texture to render with, but they cannot use any other Texture. It is this single texture-bind that allows
	 * them their speed.
	 *
	 * If you have a need to blast a large volume of frames around the screen then Blitter objects are well worth
	 * investigating. They are especially useful for using as a base for your own special effects systems.
	 *
	 * @class Blitter
	 * @extends Phaser.GameObjects.GameObject
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @since 3.0.0
	 *
	 * @extends Phaser.GameObjects.Components.Alpha
	 * @extends Phaser.GameObjects.Components.BlendMode
	 * @extends Phaser.GameObjects.Components.Depth
	 * @extends Phaser.GameObjects.Components.Mask
	 * @extends Phaser.GameObjects.Components.Pipeline
	 * @extends Phaser.GameObjects.Components.ScaleMode
	 * @extends Phaser.GameObjects.Components.ScrollFactor
	 * @extends Phaser.GameObjects.Components.Size
	 * @extends Phaser.GameObjects.Components.Texture
	 * @extends Phaser.GameObjects.Components.Transform
	 * @extends Phaser.GameObjects.Components.Visible
	 *
	 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. It can only belong to one Scene at any given time.
	 * @param {number} [x=0] - The x coordinate of this Game Object in world space.
	 * @param {number} [y=0] - The y coordinate of this Game Object in world space.
	 * @param {string} [texture='__DEFAULT'] - The key of the texture this Game Object will use for rendering. The Texture must already exist in the Texture Manager.
	 * @param {(string|integer)} [frame=0] - The Frame of the Texture that this Game Object will use. Only set if the Texture has multiple frames, such as a Texture Atlas or Sprite Sheet.
	 */
	var Blitter = new Class({
	
	    Extends: GameObject,
	
	    Mixins: [
	        Components.Alpha,
	        Components.BlendMode,
	        Components.Depth,
	        Components.Mask,
	        Components.Pipeline,
	        Components.ScaleMode,
	        Components.ScrollFactor,
	        Components.Size,
	        Components.Texture,
	        Components.Transform,
	        Components.Visible,
	        BlitterRender
	    ],
	
	    initialize:
	
	    function Blitter (scene, x, y, texture, frame)
	    {
	        GameObject.call(this, scene, 'Blitter');
	
	        this.setTexture(texture, frame);
	        this.setPosition(x, y);
	        this.initPipeline('TextureTintPipeline');
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Blitter#children
	         * @type {Phaser.Structs.List.<Phaser.GameObjects.Blitter.Bob>}
	         * @since 3.0.0
	         */
	        this.children = new List();
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Blitter#renderList
	         * @type {Phaser.GameObjects.Blitter.Bob[]}
	         * @default []
	         * @since 3.0.0
	         */
	        this.renderList = [];
	
	        this.dirty = false;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Blitter#create
	     * @since 3.0.0
	     *
	     * @param {number} x - The x position of the Bob. Bob coordinate are relative to the position of the Blitter object.
	     * @param {number} y - The y position of the Bob. Bob coordinate are relative to the position of the Blitter object.
	     * @param {(string|integer|Phaser.Textures.Frame)} [frame] - The Frame the Bob will use. It _must_ be part of the Texture the parent Blitter object is using.
	     * @param {boolean} [visible=true] - Should the created Bob render or not?
	     * @param {integer} [index] - The position in the Blitters Display List to add the new Bob at. Defaults to the top of the list.
	     *
	     * @return {Phaser.GameObjects.Blitter.Bob} The newly created Bob object.
	     */
	    create: function (x, y, frame, visible, index)
	    {
	        if (visible === undefined) { visible = true; }
	        if (index === undefined) { index = this.children.length; }
	
	        if (frame === undefined)
	        {
	            frame = this.frame;
	        }
	        else if (!(frame instanceof Frame))
	        {
	            frame = this.texture.get(frame);
	        }
	
	        var bob = new Bob(this, x, y, frame, visible);
	
	        this.children.addAt(bob, index, false);
	
	        this.dirty = true;
	
	        return bob;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Blitter#createFromCallback
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Blitter.BlitterFromCallback} callback - The callback to invoke after creating a bob. It will be sent two arguments: The Bob and the index of the Bob.
	     * @param {integer} quantity - The quantity of Bob objects to create.
	     * @param {(string|integer|Phaser.Textures.Frame|string[]|integer[]|Phaser.Textures.Frame[])} [frame] - The Frame the Bobs will use. It must be part of the Blitter Texture.
	     * @param {boolean} [visible=true] - [description]
	     *
	     * @return {Phaser.GameObjects.Blitter.Bob[]} An array of Bob objects that were created.
	     */
	    createFromCallback: function (callback, quantity, frame, visible)
	    {
	        var bobs = this.createMultiple(quantity, frame, visible);
	
	        for (var i = 0; i < bobs.length; i++)
	        {
	            var bob = bobs[i];
	
	            callback.call(this, bob, i);
	        }
	
	        return bobs;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Blitter#createMultiple
	     * @since 3.0.0
	     *
	     * @param {integer} quantity - The quantity of Bob objects to create.
	     * @param {(string|integer|Phaser.Textures.Frame|string[]|integer[]|Phaser.Textures.Frame[])} [frame] - The Frame the Bobs will use. It must be part of the Blitter Texture.
	     * @param {boolean} [visible=true] - [description]
	     *
	     * @return {Phaser.GameObjects.Blitter.Bob[]} An array of Bob objects that were created.
	     */
	    createMultiple: function (quantity, frame, visible)
	    {
	        if (frame === undefined) { frame = this.frame.name; }
	        if (visible === undefined) { visible = true; }
	
	        if (!Array.isArray(frame))
	        {
	            frame = [ frame ];
	        }
	
	        var bobs = [];
	        var _this = this;
	
	        frame.forEach(function (singleFrame)
	        {
	            for (var i = 0; i < quantity; i++)
	            {
	                bobs.push(_this.create(0, 0, singleFrame, visible));
	            }
	        });
	
	        return bobs;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Blitter#childCanRender
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Blitter.Bob} child - [description]
	     *
	     * @return {boolean} [description]
	     */
	    childCanRender: function (child)
	    {
	        return (child.visible && child.alpha > 0);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Blitter#getRenderList
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Blitter.Bob[]} An array of Bob objects that will be rendered this frame.
	     */
	    getRenderList: function ()
	    {
	        if (this.dirty)
	        {
	            this.renderList = this.children.list.filter(this.childCanRender, this);
	            this.dirty = false;
	        }
	
	        return this.renderList;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Blitter#clear
	     * @since 3.0.0
	     */
	    clear: function ()
	    {
	        this.children.removeAll();
	        this.dirty = true;
	    }
	
	});
	
	module.exports = Blitter;


/***/ }),
/* 276 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Provides methods used for setting the WebGL rendering pipeline of a Game Object.
	 * 
	 * @name Phaser.GameObjects.Components.Pipeline
	 * @webglOnly
	 * @since 3.0.0
	 */
	
	var Pipeline = {
	    
	    /**
	     * [description]
	     * 
	     * @name Phaser.GameObjects.Components.Pipeline#defaultPipeline
	     * @type {Phaser.Renderer.WebGL.WebGLPipeline}
	     * @default null
	     * @webglOnly
	     * @since 3.0.0
	     */
	    defaultPipeline: null,
	
	    /**
	     * [description]
	     * 
	     * @name Phaser.GameObjects.Components.Pipeline#pipeline
	     * @type {Phaser.Renderer.WebGL.WebGLPipeline}
	     * @default null
	     * @webglOnly
	     * @since 3.0.0
	     */
	    pipeline: null,
	
	    /**
	     * Sets the initial WebGL Pipeline of this Game Object.
	     * This should only be called during the instantiation of the Game Object.
	     * 
	     * @method Phaser.GameObjects.Components.Pipeline#initPipeline
	     * @webglOnly
	     * @since 3.0.0
	     *
	     * @param {string} pipelineName - The name of the pipeline to set on this Game Object.
	     * 
	     * @return {boolean} `true` if the pipeline was set successfully, otherwise `false`.
	     */
	    initPipeline: function (pipelineName)
	    {
	        var renderer = this.scene.sys.game.renderer;
	
	        if (renderer && renderer.gl && renderer.hasPipeline(pipelineName))
	        {
	            this.defaultPipeline = renderer.getPipeline(pipelineName);
	            this.pipeline = this.defaultPipeline;
	
	            return true;
	        }
	
	        return false;
	    },
	
	    /**
	     * Sets the active WebGL Pipeline of this Game Object.
	     * 
	     * @method Phaser.GameObjects.Components.Pipeline#setPipeline
	     * @webglOnly
	     * @since 3.0.0
	     *
	     * @param {string} pipelineName - The name of the pipeline to set on this Game Object.
	     * 
	     * @return {boolean} `true` if the pipeline was set successfully, otherwise `false`.
	     */
	    setPipeline: function (pipelineName)
	    {
	        var renderer = this.scene.sys.game.renderer;
	
	        if (renderer && renderer.gl && renderer.hasPipeline(pipelineName))
	        {
	            this.pipeline = renderer.getPipeline(pipelineName);
	
	            return true;
	        }
	        
	        return false;
	    },
	
	    /**
	     * Resets the WebGL Pipeline of this Game Object back to the default it was created with.
	     * 
	     * @method Phaser.GameObjects.Components.Pipeline#resetPipeline
	     * @webglOnly
	     * @since 3.0.0
	     *
	     * @return {boolean} `true` if the pipeline was set successfully, otherwise `false`.
	     */
	    resetPipeline: function ()
	    {
	        this.pipeline = this.defaultPipeline;
	
	        return (this.pipeline !== null);
	    },
	
	    /**
	     * Gets the name of the WebGL Pipeline this Game Object is currently using.
	     * 
	     * @method Phaser.GameObjects.Components.Pipeline#getPipelineName
	     * @webglOnly
	     * @since 3.0.0
	     *
	     * @return {string} The string-based name of the pipeline being used by this Game Object.
	     */
	    getPipelineName: function ()
	    {
	        return this.pipeline.name;
	    }
	
	};
	
	module.exports = Pipeline;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Felipe Alfonso <@bitnenfer>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var ArrayUtils = __webpack_require__(340);
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(28);
	var GameObject = __webpack_require__(5);
	var Rectangle = __webpack_require__(23);
	var Render = __webpack_require__(1143);
	var Union = __webpack_require__(524);
	var Vector2 = __webpack_require__(9);
	
	/**
	 * @classdesc
	 * A Container Game Object.
	 *
	 * A Container, as the name implies, can 'contain' other types of Game Object.
	 * When a Game Object is added to a Container, the Container becomes responsible for the rendering of it.
	 * By default it will be removed from the Display List and instead added to the Containers own internal list.
	 *
	 * The position of the Game Object automatically becomes relative to the position of the Container.
	 * 
	 * When the Container is rendered, all of its children are rendered as well, in the order in which they exist
	 * within the Container. Container children can be repositioned using methods such as `MoveUp`, `MoveDown` and `SendToBack`.
	 *
	 * If you modify a transform property of the Container, such as `Container.x` or `Container.rotation` then it will
	 * automatically influence all children as well.
	 *
	 * Containers can include other Containers for deeply nested transforms.
	 *
	 * Containers can have masks set on them and can be used as a mask too. However, Container children cannot be masked.
	 * The masks do not 'stack up'. Only a Container on the root of the display list will use its mask.
	 *
	 * Containers can be enabled for input. Because they do not have a texture you need to provide a shape for them
	 * to use as their hit area. Container children can also be enabled for input, independent of the Container.
	 *
	 * Containers can be given a physics body for either Arcade Physics, Impact Physics or Matter Physics. However,
	 * if Container _children_ are enabled for physics you may get unexpected results, such as offset bodies,
	 * if the Container itself, or any of its ancestors, is positioned anywhere other than at 0 x 0. Container children
	 * with physics do not factor in the Container due to the excessive extra calculations needed. Please structure
	 * your game to work around this.
	 *
	 * It's important to understand the impact of using Containers. They add additional processing overhead into
	 * every one of their children. The deeper you nest them, the more the cost escalates. This is especially true
	 * for input events. You also loose the ability to set the display depth of Container children in the same
	 * flexible manner as those not within them. In short, don't use them for the sake of it. You pay a small cost
	 * every time you create one, try to structure your game around avoiding that where possible.
	 *
	 * @class Container
	 * @extends Phaser.GameObjects.GameObject
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @since 3.4.0
	 *
	 * @extends Phaser.GameObjects.Components.Alpha
	 * @extends Phaser.GameObjects.Components.BlendMode
	 * @extends Phaser.GameObjects.Components.ComputedSize
	 * @extends Phaser.GameObjects.Components.Depth
	 * @extends Phaser.GameObjects.Components.ScrollFactor
	 * @extends Phaser.GameObjects.Components.Transform
	 * @extends Phaser.GameObjects.Components.Visible
	 *
	 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
	 * @param {number} [x=0] - The horizontal position of this Game Object in the world.
	 * @param {number} [y=0] - The vertical position of this Game Object in the world.
	 * @param {Phaser.GameObjects.GameObject[]} [children] - An optional array of Game Objects to add to this Container.
	 */
	var Container = new Class({
	
	    Extends: GameObject,
	
	    Mixins: [
	        Components.Alpha,
	        Components.BlendMode,
	        Components.ComputedSize,
	        Components.Depth,
	        Components.ScrollFactor,
	        Components.Transform,
	        Components.Visible,
	        Render
	    ],
	
	    initialize:
	
	    function Container (scene, x, y, children)
	    {
	        GameObject.call(this, scene, 'Container');
	
	        /**
	         * An array holding the children of this Container.
	         *
	         * @name Phaser.GameObjects.Container#list
	         * @type {Phaser.GameObjects.GameObject[]}
	         * @since 3.4.0
	         */
	        this.list = [];
	
	        /**
	         * Does this Container exclusively manage its children?
	         * 
	         * The default is `true` which means a child added to this Container cannot
	         * belong in another Container, which includes the Scene display list.
	         * 
	         * If you disable this then this Container will no longer exclusively manage its children.
	         * This allows you to create all kinds of interesting graphical effects, such as replicating
	         * Game Objects without reparenting them all over the Scene.
	         * However, doing so will prevent children from receiving any kind of input event or have
	         * their physics bodies work by default, as they're no longer a single entity on the
	         * display list, but are being replicated where-ever this Container is.
	         *
	         * @name Phaser.GameObjects.Container#exclusive
	         * @type {boolean}
	         * @default true
	         * @since 3.4.0
	         */
	        this.exclusive = true;
	
	        /**
	         * Containers can have an optional maximum size. If set to anything above 0 it
	         * will constrict the addition of new Game Objects into the Container, capping off
	         * the maximum limit the Container can grow in size to.
	         *
	         * @name Phaser.GameObjects.Container#maxSize
	         * @type {integer}
	         * @default -1
	         * @since 3.4.0
	         */
	        this.maxSize = -1;
	
	        /**
	         * The cursor position.
	         *
	         * @name Phaser.GameObjects.Container#position
	         * @type {integer}
	         * @since 3.4.0
	         */
	        this.position = 0;
	
	        /**
	         * Internal Transform Matrix used for local space conversion.
	         *
	         * @name Phaser.GameObjects.Container#localTransform
	         * @type {Phaser.GameObjects.Components.TransformMatrix}
	         * @since 3.4.0
	         */
	        this.localTransform = new Components.TransformMatrix();
	
	        /**
	         * Internal temporary Transform Matrix used to avoid object creation.
	         *
	         * @name Phaser.GameObjects.Container#tempTransformMatrix
	         * @type {Phaser.GameObjects.Components.TransformMatrix}
	         * @private
	         * @since 3.4.0
	         */
	        this.tempTransformMatrix = new Components.TransformMatrix();
	 
	        /**
	         * A reference to the Scene Display List.
	         *
	         * @name Phaser.GameObjects.Container#_displayList
	         * @type {Phaser.GameObjects.DisplayList}
	         * @private
	         * @since 3.4.0
	         */
	        this._displayList = scene.sys.displayList;
	
	        /**
	         * The property key to sort by.
	         *
	         * @name Phaser.GameObjects.Container#_sortKey
	         * @type {string}
	         * @since 3.4.0
	         */
	        this._sortKey = '';
	
	        this.setPosition(x, y);
	
	        this.clearAlpha();
	
	        if (children)
	        {
	            this.add(children);
	        }
	    },
	
	    /**
	     * Internal value to allow Containers to be used for input and physics.
	     * Do not change this value. It has no effect other than to break things.
	     *
	     * @name Phaser.GameObjects.Container#originX
	     * @type {number}
	     * @readOnly
	     * @since 3.4.0
	     */
	    originX: {
	
	        get: function ()
	        {
	            return 0.5;
	        }
	
	    },
	
	    /**
	     * Internal value to allow Containers to be used for input and physics.
	     * Do not change this value. It has no effect other than to break things.
	     *
	     * @name Phaser.GameObjects.Container#originY
	     * @type {number}
	     * @readOnly
	     * @since 3.4.0
	     */
	    originY: {
	
	        get: function ()
	        {
	            return 0.5;
	        }
	
	    },
	
	    /**
	     * Internal value to allow Containers to be used for input and physics.
	     * Do not change this value. It has no effect other than to break things.
	     *
	     * @name Phaser.GameObjects.Container#displayOriginX
	     * @type {number}
	     * @readOnly
	     * @since 3.4.0
	     */
	    displayOriginX: {
	
	        get: function ()
	        {
	            return this.width * 0.5;
	        }
	
	    },
	
	    /**
	     * Internal value to allow Containers to be used for input and physics.
	     * Do not change this value. It has no effect other than to break things.
	     *
	     * @name Phaser.GameObjects.Container#displayOriginY
	     * @type {number}
	     * @readOnly
	     * @since 3.4.0
	     */
	    displayOriginY: {
	
	        get: function ()
	        {
	            return this.height * 0.5;
	        }
	
	    },
	
	    /**
	     * Does this Container exclusively manage its children?
	     * 
	     * The default is `true` which means a child added to this Container cannot
	     * belong in another Container, which includes the Scene display list.
	     * 
	     * If you disable this then this Container will no longer exclusively manage its children.
	     * This allows you to create all kinds of interesting graphical effects, such as replicating
	     * Game Objects without reparenting them all over the Scene.
	     * However, doing so will prevent children from receiving any kind of input event or have
	     * their physics bodies work by default, as they're no longer a single entity on the
	     * display list, but are being replicated where-ever this Container is.
	     *
	     * @method Phaser.GameObjects.Container#setExclusive
	     * @since 3.4.0
	     *
	     * @param {boolean} [value=true] - The exclusive state of this Container.
	     *
	     * @return {Phaser.GameObjects.Container} This Container.
	     */
	    setExclusive: function (value)
	    {
	        if (value === undefined) { value = true; }
	
	        this.exclusive = value;
	
	        return this;
	    },
	
	    /**
	     * Gets the bounds of this Container. It works by iterating all children of the Container,
	     * getting their respective bounds, and then working out a min-max rectangle from that.
	     * It does not factor in if the children render or not, all are included.
	     *
	     * Some children are unable to return their bounds, such as Graphics objects, in which case
	     * they are skipped.
	     * 
	     * Depending on the quantity of children in this Container it could be a really expensive call,
	     * so cache it and only poll it as needed.
	     * 
	     * The values are stored and returned in a Rectangle object.
	     *
	     * @method Phaser.GameObjects.Container#getBounds
	     * @since 3.4.0
	     *
	     * @param {Phaser.Geom.Rectangle} [output] - A Geom.Rectangle object to store the values in. If not provided a new Rectangle will be created.
	     *
	     * @return {Phaser.Geom.Rectangle} The values stored in the output object.
	     */
	    getBounds: function (output)
	    {
	        if (output === undefined) { output = new Rectangle(); }
	
	        output.setTo(this.x, this.y, 0, 0);
	
	        if (this.list.length > 0)
	        {
	            var children = this.list;
	            var tempRect = new Rectangle();
	
	            for (var i = 0; i < children.length; i++)
	            {
	                var entry = children[i];
	
	                if (entry.getBounds)
	                {
	                    entry.getBounds(tempRect);
	
	                    Union(tempRect, output, output);
	                }
	            }
	        }
	
	        return output;
	    },
	
	    /**
	     * Internal add handler.
	     *
	     * @method Phaser.GameObjects.Container#addHandler
	     * @private
	     * @since 3.4.0
	     *
	     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was just added to this Container.
	     */
	    addHandler: function (gameObject)
	    {
	        gameObject.on('destroy', this.remove, this);
	
	        if (this.exclusive)
	        {
	            this._displayList.remove(gameObject);
	
	            if (gameObject.parentContainer)
	            {
	                gameObject.parentContainer.remove(gameObject);
	            }
	
	            gameObject.parentContainer = this;
	        }
	    },
	
	    /**
	     * Internal remove handler.
	     *
	     * @method Phaser.GameObjects.Container#removeHandler
	     * @private
	     * @since 3.4.0
	     *
	     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that was just removed from this Container.
	     */
	    removeHandler: function (gameObject)
	    {
	        gameObject.off('destroy', this.remove, this);
	
	        if (this.exclusive)
	        {
	            gameObject.parentContainer = null;
	        }
	    },
	
	    /**
	     * Takes a Point-like object, such as a Vector2, Geom.Point or object with public x and y properties,
	     * and transforms it into the space of this Container, then returns it in the output object.
	     *
	     * @method Phaser.GameObjects.Container#pointToContainer
	     * @since 3.4.0
	     *
	     * @param {(object|Phaser.Geom.Point|Phaser.Math.Vector2)} source - The Source Point to be transformed.
	     * @param {(object|Phaser.Geom.Point|Phaser.Math.Vector2)} [output] - A destination object to store the transformed point in. If none given a Vector2 will be created and returned.
	     *
	     * @return {(object|Phaser.Geom.Point|Phaser.Math.Vector2)} The transformed point.
	     */
	    pointToContainer: function (source, output)
	    {
	        if (output === undefined) { output = new Vector2(); }
	
	        if (this.parentContainer)
	        {
	            return this.parentContainer.pointToContainer(source, output);
	        }
	
	        var tempMatrix = this.tempTransformMatrix;
	
	        //  No need to loadIdentity because applyITRS overwrites every value anyway
	        tempMatrix.applyITRS(this.x, this.y, this.rotation, this.scaleX, this.scaleY);
	
	        tempMatrix.invert();
	
	        tempMatrix.transformPoint(source.x, source.y, output);
	
	        return output;
	    },
	
	    /**
	     * Returns the world transform matrix as used for Bounds checks.
	     * The returned matrix is temporal and shouldn't be stored.
	     *
	     * @method Phaser.GameObjects.Container#getBoundsTransformMatrix
	     * @since 3.4.0
	     *
	     * @return {Phaser.GameObjects.Components.TransformMatrix} The world transform matrix.
	     */
	    getBoundsTransformMatrix: function ()
	    {
	        return this.getWorldTransformMatrix(this.tempTransformMatrix);
	    },
	
	    /**
	     * Adds the given Game Object, or array of Game Objects, to this Container.
	     * 
	     * Each Game Object must be unique within the Container.
	     *
	     * @method Phaser.GameObjects.Container#add
	     * @since 3.4.0
	     *
	     * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} child - The Game Object, or array of Game Objects, to add to the Container.
	     *
	     * @return {Phaser.GameObjects.Container} This Container instance.
	     */
	    add: function (child)
	    {
	        ArrayUtils.Add(this.list, child, this.maxSize, this.addHandler, this);
	
	        return this;
	    },
	
	    /**
	     * Adds the given Game Object, or array of Game Objects, to this Container at the specified position.
	     * 
	     * Existing Game Objects in the Container are shifted up.
	     * 
	     * Each Game Object must be unique within the Container.
	     *
	     * @method Phaser.GameObjects.Container#addAt
	     * @since 3.4.0
	     *
	     * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} child - The Game Object, or array of Game Objects, to add to the Container.
	     * @param {integer} [index=0] - The position to insert the Game Object/s at.
	     *
	     * @return {Phaser.GameObjects.Container} This Container instance.
	     */
	    addAt: function (child, index)
	    {
	        ArrayUtils.AddAt(this.list, child, index, this.maxSize, this.addHandler, this);
	
	        return this;
	    },
	
	    /**
	     * Returns the Game Object at the given position in this Container.
	     *
	     * @method Phaser.GameObjects.Container#getAt
	     * @since 3.4.0
	     *
	     * @param {integer} index - The position to get the Game Object from.
	     *
	     * @return {?Phaser.GameObjects.GameObject} The Game Object at the specified index, or `null` if none found.
	     */
	    getAt: function (index)
	    {
	        return this.list[index];
	    },
	
	    /**
	     * Returns the index of the given Game Object in this Container.
	     *
	     * @method Phaser.GameObjects.Container#getIndex
	     * @since 3.4.0
	     *
	     * @param {Phaser.GameObjects.GameObject} child - The Game Object to search for in this Container.
	     *
	     * @return {integer} The index of the Game Object in this Container, or -1 if not found.
	     */
	    getIndex: function (child)
	    {
	        return this.list.indexOf(child);
	    },
	
	    /**
	     * Sort the contents of this Container so the items are in order based on the given property.
	     * For example: `sort('alpha')` would sort the elements based on the value of their `alpha` property.
	     *
	     * @method Phaser.GameObjects.Container#sort
	     * @since 3.4.0
	     *
	     * @param {string} property - The property to lexically sort by.
	     *
	     * @return {Phaser.GameObjects.Container} This Container instance.
	     */
	    sort: function (property)
	    {
	        if (property)
	        {
	            this._sortKey = property;
	
	            ArrayUtils.StableSort.inplace(this.list, this.sortHandler);
	        }
	
	        return this;
	    },
	
	    /**
	     * Internal sort handler method.
	     *
	     * @method Phaser.GameObjects.Container#sortHandler
	     * @private
	     * @since 3.4.0
	     *
	     * @param {Phaser.GameObjects.GameObject} childA - The first child to sort.
	     * @param {Phaser.GameObjects.GameObject} childB - The second child to sort.
	     *
	     * @return {integer} The sort results.
	     */
	    sortHandler: function (childA, childB)
	    {
	        return childA[this._sortKey] - childB[this._sortKey];
	    },
	
	    /**
	     * Searches for the first instance of a child with its `name` property matching the given argument.
	     * Should more than one child have the same name only the first is returned.
	     *
	     * @method Phaser.GameObjects.Container#getByName
	     * @since 3.4.0
	     *
	     * @param {string} name - The name to search for.
	     *
	     * @return {?Phaser.GameObjects.GameObject} The first child with a matching name, or `null` if none were found.
	     */
	    getByName: function (name)
	    {
	        return ArrayUtils.GetFirst(this.list, 'name', name);
	    },
	
	    /**
	     * Returns a random Game Object from this Container.
	     *
	     * @method Phaser.GameObjects.Container#getRandom
	     * @since 3.4.0
	     *
	     * @param {integer} [startIndex=0] - An optional start index.
	     * @param {integer} [length] - An optional length, the total number of elements (from the startIndex) to choose from.
	     *
	     * @return {?Phaser.GameObjects.GameObject} A random child from the Container, or `null` if the Container is empty.
	     */
	    getRandom: function (startIndex, length)
	    {
	        return ArrayUtils.GetRandom(this.list, startIndex, length);
	    },
	
	    /**
	     * Gets the first Game Object in this Container.
	     *
	     * You can also specify a property and value to search for, in which case it will return the first
	     * Game Object in this Container with a matching property and / or value.
	     * 
	     * For example: `getFirst('visible', true)` would return the first Game Object that had its `visible` property set.
	     *
	     * You can limit the search to the `startIndex` - `endIndex` range.
	     *
	     * @method Phaser.GameObjects.Container#getFirst
	     * @since 3.4.0
	     *
	     * @param {string} [property] - The property to test on each Game Object in the Container.
	     * @param {*} [value] - The value to test the property against. Must pass a strict (`===`) comparison check.
	     * @param {integer} [startIndex=0] - An optional start index to search from.
	     * @param {integer} [endIndex=Container.length] - An optional end index to search up to (but not included)
	     *
	     * @return {?Phaser.GameObjects.GameObject} The first matching Game Object, or `null` if none was found.
	     */
	    getFirst: function (property, value, startIndex, endIndex)
	    {
	        return ArrayUtils.GetFirstElement(this.list, property, value, startIndex, endIndex);
	    },
	
	    /**
	     * Returns all Game Objects in this Container.
	     *
	     * You can optionally specify a matching criteria using the `property` and `value` arguments.
	     *
	     * For example: `getAll('body')` would return only Game Objects that have a body property.
	     *
	     * You can also specify a value to compare the property to:
	     * 
	     * `getAll('visible', true)` would return only Game Objects that have their visible property set to `true`.
	     *
	     * Optionally you can specify a start and end index. For example if this Container had 100 Game Objects,
	     * and you set `startIndex` to 0 and `endIndex` to 50, it would return matches from only
	     * the first 50 Game Objects.
	     *
	     * @method Phaser.GameObjects.Container#getAll
	     * @since 3.4.0
	     *
	     * @param {string} [property] - The property to test on each Game Object in the Container.
	     * @param {any} [value] - If property is set then the `property` must strictly equal this value to be included in the results.
	     * @param {integer} [startIndex=0] - An optional start index to search from.
	     * @param {integer} [endIndex=Container.length] - An optional end index to search up to (but not included)
	     *
	     * @return {Phaser.GameObjects.GameObject[]} An array of matching Game Objects from this Container.
	     */
	    getAll: function (property, value, startIndex, endIndex)
	    {
	        return ArrayUtils.GetAll(this.list, property, value, startIndex, endIndex);
	    },
	
	    /**
	     * Returns the total number of Game Objects in this Container that have a property
	     * matching the given value.
	     * 
	     * For example: `count('visible', true)` would count all the elements that have their visible property set.
	     * 
	     * You can optionally limit the operation to the `startIndex` - `endIndex` range.
	     *
	     * @method Phaser.GameObjects.Container#count
	     * @since 3.4.0
	     *
	     * @param {string} property - [description]
	     * @param {any} value - [description]
	     * @param {integer} [startIndex=0] - An optional start index to search from.
	     * @param {integer} [endIndex=Container.length] - An optional end index to search up to (but not included)
	     *
	     * @return {integer} The total number of Game Objects in this Container with a property matching the given value.
	     */
	    count: function (property, value, startIndex, endIndex)
	    {
	        return ArrayUtils.CountAllMatching(this.list, property, value, startIndex, endIndex);
	    },
	
	    /**
	     * Swaps the position of two Game Objects in this Container.
	     * Both Game Objects must belong to this Container.
	     *
	     * @method Phaser.GameObjects.Container#swap
	     * @since 3.4.0
	     *
	     * @param {Phaser.GameObjects.GameObject} child1 - The first Game Object to swap.
	     * @param {Phaser.GameObjects.GameObject} child2 - The second Game Object to swap.
	     * 
	     * @return {Phaser.GameObjects.Container} This Container instance.
	     */
	    swap: function (child1, child2)
	    {
	        ArrayUtils.Swap(this.list, child1, child2);
	
	        return this;
	    },
	
	    /**
	     * Moves a Game Object to a new position within this Container.
	     * 
	     * The Game Object must already be a child of this Container.
	     *
	     * The Game Object is removed from its old position and inserted into the new one.
	     * Therefore the Container size does not change. Other children will change position accordingly.
	     *
	     * @method Phaser.GameObjects.Container#moveTo
	     * @since 3.4.0
	     *
	     * @param {Phaser.GameObjects.GameObject} child - The Game Object to move.
	     * @param {integer} index - The new position of the Game Object in this Container.
	     *
	     * @return {Phaser.GameObjects.Container} This Container instance.
	     */
	    moveTo: function (child, index)
	    {
	        ArrayUtils.MoveTo(this.list, child, index);
	
	        return this;
	    },
	
	    /**
	     * Removes the given Game Object, or array of Game Objects, from this Container.
	     * 
	     * The Game Objects must already be children of this Container.
	     *
	     * You can also optionally call `destroy` on each Game Object that is removed from the Container.
	     *
	     * @method Phaser.GameObjects.Container#remove
	     * @since 3.4.0
	     *
	     * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} child - The Game Object, or array of Game Objects, to be removed from the Container.
	     * @param {boolean} [destroyChild=false] - Optionally call `destroy` on each child successfully removed from this Container.
	     *
	     * @return {Phaser.GameObjects.Container} This Container instance.
	     */
	    remove: function (child, destroyChild)
	    {
	        var removed = ArrayUtils.Remove(this.list, child, this.removeHandler, this);
	
	        if (destroyChild && removed)
	        {
	            if (!Array.isArray(removed))
	            {
	                removed = [ removed ];
	            }
	
	            for (var i = 0; i < removed.length; i++)
	            {
	                removed[i].destroy();
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Removes the Game Object at the given position in this Container.
	     * 
	     * You can also optionally call `destroy` on the Game Object, if one is found.
	     *
	     * @method Phaser.GameObjects.Container#removeAt
	     * @since 3.4.0
	     *
	     * @param {integer} index - The index of the Game Object to be removed.
	     * @param {boolean} [destroyChild=false] - Optionally call `destroy` on the Game Object if successfully removed from this Container.
	     *
	     * @return {Phaser.GameObjects.Container} This Container instance.
	     */
	    removeAt: function (index, destroyChild)
	    {
	        var removed = ArrayUtils.RemoveAt(this.list, index, this.removeHandler, this);
	
	        if (destroyChild && removed)
	        {
	            removed.destroy();
	        }
	
	        return this;
	    },
	
	    /**
	     * Removes the Game Objects between the given positions in this Container.
	     * 
	     * You can also optionally call `destroy` on each Game Object that is removed from the Container.
	     *
	     * @method Phaser.GameObjects.Container#removeBetween
	     * @since 3.4.0
	     *
	     * @param {integer} [startIndex=0] - An optional start index to search from.
	     * @param {integer} [endIndex=Container.length] - An optional end index to search up to (but not included)
	     * @param {boolean} [destroyChild=false] - Optionally call `destroy` on each Game Object successfully removed from this Container.
	     *
	     * @return {Phaser.GameObjects.Container} This Container instance.
	     */
	    removeBetween: function (startIndex, endIndex, destroyChild)
	    {
	        var removed = ArrayUtils.RemoveBetween(this.list, startIndex, endIndex, this.removeHandler, this);
	
	        if (destroyChild)
	        {
	            for (var i = 0; i < removed.length; i++)
	            {
	                removed[i].destroy();
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Removes all Game Objects from this Container.
	     * 
	     * You can also optionally call `destroy` on each Game Object that is removed from the Container.
	     *
	     * @method Phaser.GameObjects.Container#removeAll
	     * @since 3.4.0
	     *
	     * @param {boolean} [destroyChild=false] - Optionally call `destroy` on each Game Object successfully removed from this Container.
	     *
	     * @return {Phaser.GameObjects.Container} This Container instance.
	     */
	    removeAll: function (destroyChild)
	    {
	        var removed = ArrayUtils.RemoveBetween(this.list, 0, this.list.length, this.removeHandler, this);
	
	        if (destroyChild)
	        {
	            for (var i = 0; i < removed.length; i++)
	            {
	                removed[i].destroy();
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Brings the given Game Object to the top of this Container.
	     * This will cause it to render on-top of any other objects in the Container.
	     *
	     * @method Phaser.GameObjects.Container#bringToTop
	     * @since 3.4.0
	     *
	     * @param {Phaser.GameObjects.GameObject} child - The Game Object to bring to the top of the Container.
	     *
	     * @return {Phaser.GameObjects.Container} This Container instance.
	     */
	    bringToTop: function (child)
	    {
	        ArrayUtils.BringToTop(this.list, child);
	
	        return this;
	    },
	
	    /**
	     * Sends the given Game Object to the bottom of this Container.
	     * This will cause it to render below any other objects in the Container.
	     *
	     * @method Phaser.GameObjects.Container#sendToBack
	     * @since 3.4.0
	     *
	     * @param {Phaser.GameObjects.GameObject} child - The Game Object to send to the bottom of the Container.
	     *
	     * @return {Phaser.GameObjects.Container} This Container instance.
	     */
	    sendToBack: function (child)
	    {
	        ArrayUtils.SendToBack(this.list, child);
	
	        return this;
	    },
	
	    /**
	     * Moves the given Game Object up one place in this Container, unless it's already at the top.
	     *
	     * @method Phaser.GameObjects.Container#moveUp
	     * @since 3.4.0
	     *
	     * @param {Phaser.GameObjects.GameObject} child - The Game Object to be moved in the Container.
	     *
	     * @return {Phaser.GameObjects.Container} This Container instance.
	     */
	    moveUp: function (child)
	    {
	        ArrayUtils.MoveUp(this.list, child);
	
	        return this;
	    },
	
	    /**
	     * Moves the given Game Object down one place in this Container, unless it's already at the bottom.
	     *
	     * @method Phaser.GameObjects.Container#moveDown
	     * @since 3.4.0
	     *
	     * @param {Phaser.GameObjects.GameObject} child - The Game Object to be moved in the Container.
	     *
	     * @return {Phaser.GameObjects.Container} This Container instance.
	     */
	    moveDown: function (child)
	    {
	        ArrayUtils.MoveDown(this.list, child);
	
	        return this;
	    },
	
	    /**
	     * Reverses the order of all Game Objects in this Container.
	     *
	     * @method Phaser.GameObjects.Container#reverse
	     * @since 3.4.0
	     *
	     * @return {Phaser.GameObjects.Container} This Container instance.
	     */
	    reverse: function ()
	    {
	        this.list.reverse();
	
	        return this;
	    },
	
	    /**
	     * Shuffles the all Game Objects in this Container using the Fisher-Yates implementation.
	     *
	     * @method Phaser.GameObjects.Container#shuffle
	     * @since 3.4.0
	     *
	     * @return {Phaser.GameObjects.Container} This Container instance.
	     */
	    shuffle: function ()
	    {
	        ArrayUtils.Shuffle(this.list);
	
	        return this;
	    },
	
	    /**
	     * Replaces a Game Object in this Container with the new Game Object.
	     * The new Game Object cannot already be a child of this Container.
	     *
	     * @method Phaser.GameObjects.Container#replace
	     * @since 3.4.0
	     *
	     * @param {Phaser.GameObjects.GameObject} oldChild - The Game Object in this Container that will be replaced.
	     * @param {Phaser.GameObjects.GameObject} newChild - The Game Object to be added to this Container.
	     * @param {boolean} [destroyChild=false] - Optionally call `destroy` on the Game Object if successfully removed from this Container.
	     *
	     * @return {Phaser.GameObjects.Container} This Container instance.
	     */
	    replace: function (oldChild, newChild, destroyChild)
	    {
	        var moved = ArrayUtils.Replace(this.list, oldChild, newChild);
	
	        if (moved)
	        {
	            this.addHandler(newChild);
	            this.removeHandler(oldChild);
	
	            if (destroyChild)
	            {
	                oldChild.destroy();
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Returns `true` if the given Game Object is a direct child of this Container.
	     * 
	     * This check does not scan nested Containers.
	     *
	     * @method Phaser.GameObjects.Container#exists
	     * @since 3.4.0
	     *
	     * @param {Phaser.GameObjects.GameObject} child - The Game Object to check for within this Container.
	     *
	     * @return {boolean} True if the Game Object is an immediate child of this Container, otherwise false.
	     */
	    exists: function (child)
	    {
	        return (this.list.indexOf(child) > -1);
	    },
	
	    /**
	     * Sets the property to the given value on all Game Objects in this Container.
	     * 
	     * Optionally you can specify a start and end index. For example if this Container had 100 Game Objects,
	     * and you set `startIndex` to 0 and `endIndex` to 50, it would return matches from only
	     * the first 50 Game Objects.
	     *
	     * @method Phaser.GameObjects.Container#setAll
	     * @since 3.4.0
	     *
	     * @param {string} property - The property that must exist on the Game Object.
	     * @param {any} value - The value to get the property to.
	     * @param {integer} [startIndex=0] - An optional start index to search from.
	     * @param {integer} [endIndex=Container.length] - An optional end index to search up to (but not included)
	     * 
	     * @return {Phaser.GameObjects.Container} This Container instance.
	     */
	    setAll: function (property, value, startIndex, endIndex)
	    {
	        ArrayUtils.SetAll(this.list, property, value, startIndex, endIndex);
	
	        return this;
	    },
	
	    /**
	     * @callback EachContainerCallback
	     * @generic I - [item]
	     *
	     * @param {*} item - [description]
	     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
	     */
	
	    /**
	     * Passes all Game Objects in this Container to the given callback.
	     *
	     * A copy of the Container is made before passing each entry to your callback.
	     * This protects against the callback itself modifying the Container.
	     * 
	     * If you know for sure that the callback will not change the size of this Container
	     * then you can use the more performant `Container.iterate` method instead.
	     *
	     * @method Phaser.GameObjects.Container#each
	     * @since 3.4.0
	     *
	     * @param {function} callback - The function to call.
	     * @param {object} [context] - Value to use as `this` when executing callback.
	     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
	     * 
	     * @return {Phaser.GameObjects.Container} This Container instance.
	     */
	    each: function (callback, context)
	    {
	        var args = [ null ];
	        var i;
	        var temp = this.list.slice();
	        var len = temp.length;
	
	        for (i = 2; i < arguments.length; i++)
	        {
	            args.push(arguments[i]);
	        }
	
	        for (i = 0; i < len; i++)
	        {
	            args[0] = temp[i];
	
	            callback.apply(context, args);
	        }
	
	        return this;
	    },
	
	    /**
	     * Passes all Game Objects in this Container to the given callback.
	     *
	     * Only use this method when you absolutely know that the Container will not be modified during
	     * the iteration, i.e. by removing or adding to its contents.
	     *
	     * @method Phaser.GameObjects.Container#iterate
	     * @since 3.4.0
	     *
	     * @param {function} callback - The function to call.
	     * @param {object} [context] - Value to use as `this` when executing callback.
	     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
	     * 
	     * @return {Phaser.GameObjects.Container} This Container instance.
	     */
	    iterate: function (callback, context)
	    {
	        var args = [ null ];
	        var i;
	
	        for (i = 2; i < arguments.length; i++)
	        {
	            args.push(arguments[i]);
	        }
	
	        for (i = 0; i < this.list.length; i++)
	        {
	            args[0] = this.list[i];
	
	            callback.apply(context, args);
	        }
	
	        return this;
	    },
	
	    /**
	     * The number of Game Objects inside this Container.
	     *
	     * @name Phaser.GameObjects.Container#length
	     * @type {integer}
	     * @readOnly
	     * @since 3.4.0
	     */
	    length: {
	
	        get: function ()
	        {
	            return this.list.length;
	        }
	
	    },
	
	    /**
	     * Returns the first Game Object within the Container, or `null` if it is empty.
	     * 
	     * You can move the cursor by calling `Container.next` and `Container.previous`.
	     *
	     * @name Phaser.GameObjects.Container#first
	     * @type {?Phaser.GameObjects.GameObject}
	     * @readOnly
	     * @since 3.4.0
	     */
	    first: {
	
	        get: function ()
	        {
	            this.position = 0;
	
	            if (this.list.length > 0)
	            {
	                return this.list[0];
	            }
	            else
	            {
	                return null;
	            }
	        }
	
	    },
	
	    /**
	     * Returns the last Game Object within the Container, or `null` if it is empty.
	     * 
	     * You can move the cursor by calling `Container.next` and `Container.previous`.
	     *
	     * @name Phaser.GameObjects.Container#last
	     * @type {?Phaser.GameObjects.GameObject}
	     * @readOnly
	     * @since 3.4.0
	     */
	    last: {
	
	        get: function ()
	        {
	            if (this.list.length > 0)
	            {
	                this.position = this.list.length - 1;
	
	                return this.list[this.position];
	            }
	            else
	            {
	                return null;
	            }
	        }
	
	    },
	
	    /**
	     * Returns the next Game Object within the Container, or `null` if it is empty.
	     * 
	     * You can move the cursor by calling `Container.next` and `Container.previous`.
	     *
	     * @name Phaser.GameObjects.Container#next
	     * @type {?Phaser.GameObjects.GameObject}
	     * @readOnly
	     * @since 3.4.0
	     */
	    next: {
	
	        get: function ()
	        {
	            if (this.position < this.list.length)
	            {
	                this.position++;
	
	                return this.list[this.position];
	            }
	            else
	            {
	                return null;
	            }
	        }
	
	    },
	
	    /**
	     * Returns the previous Game Object within the Container, or `null` if it is empty.
	     * 
	     * You can move the cursor by calling `Container.next` and `Container.previous`.
	     *
	     * @name Phaser.GameObjects.Container#previous
	     * @type {?Phaser.GameObjects.GameObject}
	     * @readOnly
	     * @since 3.4.0
	     */
	    previous: {
	
	        get: function ()
	        {
	            if (this.position > 0)
	            {
	                this.position--;
	
	                return this.list[this.position];
	            }
	            else
	            {
	                return null;
	            }
	        }
	
	    },
	
	    /**
	     * Destroys this Container, removing it from the Display List.
	     *
	     * If `Container.exclusive` is `true` then it will also destroy all children.
	     *
	     * Use this to remove a Container from your game if you don't ever plan to use it again.
	     * As long as no reference to it exists within your own code it should become free for
	     * garbage collection.
	     *
	     * If you just want to temporarily disable an object then look at using the
	     * Game Object Pool instead of destroying it, as destroyed objects cannot be resurrected.
	     *
	     * @method Phaser.GameObjects.Container#destroy
	     * @since 3.4.0
	     */
	    destroy: function ()
	    {
	        this.removeAll(!!this.exclusive);
	
	        this.localTransform.destroy();
	        this.tempTransformMatrix.destroy();
	
	        this.list = [];
	        this._displayList = null;
	
	        GameObject.prototype.destroy.call(this);
	    }
	
	});
	
	module.exports = Container;


/***/ }),
/* 278 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.GameObjects.Graphics.Commands
	 */
	
	module.exports = {
	
	    ARC: 0,
	    BEGIN_PATH: 1,
	    CLOSE_PATH: 2,
	    FILL_RECT: 3,
	    LINE_TO: 4,
	    MOVE_TO: 5,
	    LINE_STYLE: 6,
	    FILL_STYLE: 7,
	    FILL_PATH: 8,
	    STROKE_PATH: 9,
	    FILL_TRIANGLE: 10,
	    STROKE_TRIANGLE: 11,
	    LINE_FX_TO: 12,
	    MOVE_FX_TO: 13,
	    SAVE: 14,
	    RESTORE: 15,
	    TRANSLATE: 16,
	    SCALE: 17,
	    ROTATE: 18
	
	};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Camera = __webpack_require__(264);
	var Class = __webpack_require__(1);
	var Commands = __webpack_require__(278);
	var Components = __webpack_require__(28);
	var Ellipse = __webpack_require__(507);
	var GameObject = __webpack_require__(5);
	var GetValue = __webpack_require__(10);
	var MATH_CONST = __webpack_require__(33);
	var Render = __webpack_require__(1147);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class Graphics
	 * @extends Phaser.GameObjects.GameObject
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @since 3.0.0
	 *
	 * @extends Phaser.GameObjects.Components.Alpha
	 * @extends Phaser.GameObjects.Components.BlendMode
	 * @extends Phaser.GameObjects.Components.Depth
	 * @extends Phaser.GameObjects.Components.Mask
	 * @extends Phaser.GameObjects.Components.Pipeline
	 * @extends Phaser.GameObjects.Components.Transform
	 * @extends Phaser.GameObjects.Components.Visible
	 * @extends Phaser.GameObjects.Components.ScrollFactor
	 *
	 * @param {Phaser.Scene} scene - [description]
	 * @param {object} options - [description]
	 */
	var Graphics = new Class({
	
	    Extends: GameObject,
	
	    Mixins: [
	        Components.Alpha,
	        Components.BlendMode,
	        Components.Depth,
	        Components.Mask,
	        Components.Pipeline,
	        Components.Transform,
	        Components.Visible,
	        Components.ScrollFactor,
	        Render
	    ],
	
	    initialize:
	
	    function Graphics (scene, options)
	    {
	        var x = GetValue(options, 'x', 0);
	        var y = GetValue(options, 'y', 0);
	
	        GameObject.call(this, scene, 'Graphics');
	
	        this.setPosition(x, y);
	        this.initPipeline('FlatTintPipeline');
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Graphics#displayOriginX
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.displayOriginX = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Graphics#displayOriginY
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.displayOriginY = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Graphics#commandBuffer
	         * @type {array}
	         * @default []
	         * @since 3.0.0
	         */
	        this.commandBuffer = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Graphics#defaultFillColor
	         * @type {number}
	         * @default -1
	         * @since 3.0.0
	         */
	        this.defaultFillColor = -1;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Graphics#defaultFillAlpha
	         * @type {number}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.defaultFillAlpha = 1;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Graphics#defaultStrokeWidth
	         * @type {number}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.defaultStrokeWidth = 1;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Graphics#defaultStrokeColor
	         * @type {number}
	         * @default -1
	         * @since 3.0.0
	         */
	        this.defaultStrokeColor = -1;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Graphics#defaultStrokeAlpha
	         * @type {number}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.defaultStrokeAlpha = 1;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Graphics#_lineWidth
	         * @type {number}
	         * @private
	         * @since 3.0.0
	         */
	        this._lineWidth = 1.0;
	
	        this.setDefaultStyles(options);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#setDefaultStyles
	     * @since 3.0.0
	     *
	     * @param {object} options - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    setDefaultStyles: function (options)
	    {
	        if (GetValue(options, 'lineStyle', null))
	        {
	            this.defaultStrokeWidth = GetValue(options, 'lineStyle.width', 1);
	            this.defaultStrokeColor = GetValue(options, 'lineStyle.color', 0xffffff);
	            this.defaultStrokeAlpha = GetValue(options, 'lineStyle.alpha', 1);
	
	            this.lineStyle(this.defaultStrokeWidth, this.defaultStrokeColor, this.defaultStrokeAlpha);
	        }
	
	        if (GetValue(options, 'fillStyle', null))
	        {
	            this.defaultFillColor = GetValue(options, 'fillStyle.color', 0xffffff);
	            this.defaultFillAlpha = GetValue(options, 'fillStyle.alpha', 1);
	
	            this.fillStyle(this.defaultFillColor, this.defaultFillAlpha);
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#lineStyle
	     * @since 3.0.0
	     *
	     * @param {number} lineWidth - [description]
	     * @param {number} color - [description]
	     * @param {float} [alpha=1] - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    lineStyle: function (lineWidth, color, alpha)
	    {
	        if (alpha === undefined) { alpha = 1; }
	
	        this.commandBuffer.push(
	            Commands.LINE_STYLE,
	            lineWidth, color, alpha
	        );
	
	        this._lineWidth = lineWidth;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#fillStyle
	     * @since 3.0.0
	     *
	     * @param {number} color - [description]
	     * @param {float} [alpha=1] - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    fillStyle: function (color, alpha)
	    {
	        if (alpha === undefined) { alpha = 1; }
	
	        this.commandBuffer.push(
	            Commands.FILL_STYLE,
	            color, alpha
	        );
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#beginPath
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    beginPath: function ()
	    {
	        this.commandBuffer.push(
	            Commands.BEGIN_PATH
	        );
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#closePath
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    closePath: function ()
	    {
	        this.commandBuffer.push(
	            Commands.CLOSE_PATH
	        );
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#fillPath
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    fillPath: function ()
	    {
	        this.commandBuffer.push(
	            Commands.FILL_PATH
	        );
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#strokePath
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    strokePath: function ()
	    {
	        this.commandBuffer.push(
	            Commands.STROKE_PATH
	        );
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#fillCircleShape
	     * @since 3.0.0
	     *
	     * @param {Phaser.Geom.Circle} circle - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    fillCircleShape: function (circle)
	    {
	        return this.fillCircle(circle.x, circle.y, circle.radius);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#strokeCircleShape
	     * @since 3.0.0
	     *
	     * @param {Phaser.Geom.Circle} circle - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    strokeCircleShape: function (circle)
	    {
	        return this.strokeCircle(circle.x, circle.y, circle.radius);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#fillCircle
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} radius - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    fillCircle: function (x, y, radius)
	    {
	        this.beginPath();
	        this.arc(x, y, radius, 0, MATH_CONST.PI2);
	        this.fillPath();
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#strokeCircle
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} radius - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    strokeCircle: function (x, y, radius)
	    {
	        this.beginPath();
	        this.arc(x, y, radius, 0, MATH_CONST.PI2);
	        this.strokePath();
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#fillRectShape
	     * @since 3.0.0
	     *
	     * @param {Phaser.Geom.Rectangle} rect - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    fillRectShape: function (rect)
	    {
	        return this.fillRect(rect.x, rect.y, rect.width, rect.height);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#strokeRectShape
	     * @since 3.0.0
	     *
	     * @param {Phaser.Geom.Rectangle} rect - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    strokeRectShape: function (rect)
	    {
	        return this.strokeRect(rect.x, rect.y, rect.width, rect.height);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#fillRect
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    fillRect: function (x, y, width, height)
	    {
	        this.commandBuffer.push(
	            Commands.FILL_RECT,
	            x, y, width, height
	        );
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#strokeRect
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    strokeRect: function (x, y, width, height)
	    {
	        var lineWidthHalf = this._lineWidth / 2;
	        var minx = x - lineWidthHalf;
	        var maxx = x + lineWidthHalf;
	
	        this.beginPath();
	        this.moveTo(x, y);
	        this.lineTo(x, y + height);
	        this.strokePath();
	
	        this.beginPath();
	        this.moveTo(x + width, y);
	        this.lineTo(x + width, y + height);
	        this.strokePath();
	
	        this.beginPath();
	        this.moveTo(minx, y);
	        this.lineTo(maxx + width, y);
	        this.strokePath();
	
	        this.beginPath();
	        this.moveTo(minx, y + height);
	        this.lineTo(maxx + width, y + height);
	        this.strokePath();
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#fillPointShape
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Geom.Point|Phaser.Math.Vector2|object)} point - [description]
	     * @param {number} [size=1] - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    fillPointShape: function (point, size)
	    {
	        return this.fillPoint(point.x, point.y, size);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#fillPoint
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} [size=1] - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    fillPoint: function (x, y, size)
	    {
	        if (!size || size < 1)
	        {
	            size = 1;
	        }
	        else
	        {
	            x -= (size / 2);
	            y -= (size / 2);
	        }
	
	        this.commandBuffer.push(
	            Commands.FILL_RECT,
	            x, y, size, size
	        );
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#fillTriangleShape
	     * @since 3.0.0
	     *
	     * @param {Phaser.Geom.Triangle} triangle - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    fillTriangleShape: function (triangle)
	    {
	        return this.fillTriangle(triangle.x1, triangle.y1, triangle.x2, triangle.y2, triangle.x3, triangle.y3);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#strokeTriangleShape
	     * @since 3.0.0
	     *
	     * @param {Phaser.Geom.Triangle} triangle - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    strokeTriangleShape: function (triangle)
	    {
	        return this.strokeTriangle(triangle.x1, triangle.y1, triangle.x2, triangle.y2, triangle.x3, triangle.y3);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#fillTriangle
	     * @since 3.0.0
	     *
	     * @param {number} x0 - [description]
	     * @param {number} y0 - [description]
	     * @param {number} x1 - [description]
	     * @param {number} y1 - [description]
	     * @param {number} x2 - [description]
	     * @param {number} y2 - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    fillTriangle: function (x0, y0, x1, y1, x2, y2)
	    {
	        this.commandBuffer.push(
	            Commands.FILL_TRIANGLE,
	            x0, y0, x1, y1, x2, y2
	        );
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#strokeTriangle
	     * @since 3.0.0
	     *
	     * @param {number} x0 - [description]
	     * @param {number} y0 - [description]
	     * @param {number} x1 - [description]
	     * @param {number} y1 - [description]
	     * @param {number} x2 - [description]
	     * @param {number} y2 - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    strokeTriangle: function (x0, y0, x1, y1, x2, y2)
	    {
	        this.commandBuffer.push(
	            Commands.STROKE_TRIANGLE,
	            x0, y0, x1, y1, x2, y2
	        );
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#strokeLineShape
	     * @since 3.0.0
	     *
	     * @param {Phaser.Geom.Line} line - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    strokeLineShape: function (line)
	    {
	        return this.lineBetween(line.x1, line.y1, line.x2, line.y2);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#lineBetween
	     * @since 3.0.0
	     *
	     * @param {number} x1 - [description]
	     * @param {number} y1 - [description]
	     * @param {number} x2 - [description]
	     * @param {number} y2 - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    lineBetween: function (x1, y1, x2, y2)
	    {
	        this.beginPath();
	        this.moveTo(x1, y1);
	        this.lineTo(x2, y2);
	        this.strokePath();
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#lineTo
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    lineTo: function (x, y)
	    {
	        this.commandBuffer.push(
	            Commands.LINE_TO,
	            x, y
	        );
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#moveTo
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    moveTo: function (x, y)
	    {
	        this.commandBuffer.push(
	            Commands.MOVE_TO,
	            x, y
	        );
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#lineFxTo
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} width - [description]
	     * @param {number} rgb - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    lineFxTo: function (x, y, width, rgb)
	    {
	        this.commandBuffer.push(
	            Commands.LINE_FX_TO,
	            x, y, width, rgb, 1
	        );
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#moveFxTo
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} width - [description]
	     * @param {number} rgb - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    moveFxTo: function (x, y, width, rgb)
	    {
	        this.commandBuffer.push(
	            Commands.MOVE_FX_TO,
	            x, y, width, rgb, 1
	        );
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#strokePoints
	     * @since 3.0.0
	     *
	     * @param {(array|Phaser.Geom.Point[])} points - [description]
	     * @param {boolean} [autoClose=false] - [description]
	     * @param {integer} [endIndex] - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    strokePoints: function (points, autoClose, endIndex)
	    {
	        if (autoClose === undefined) { autoClose = false; }
	        if (endIndex === undefined) { endIndex = points.length; }
	
	        this.beginPath();
	
	        this.moveTo(points[0].x, points[0].y);
	
	        for (var i = 1; i < endIndex; i++)
	        {
	            this.lineTo(points[i].x, points[i].y);
	        }
	
	        if (autoClose)
	        {
	            this.lineTo(points[0].x, points[0].y);
	        }
	
	        this.strokePath();
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#fillPoints
	     * @since 3.0.0
	     *
	     * @param {(array|Phaser.Geom.Point[])} points - [description]
	     * @param {boolean} [autoClose=false] - [description]
	     * @param {integer} [endIndex] - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    fillPoints: function (points, autoClose, endIndex)
	    {
	        if (autoClose === undefined) { autoClose = false; }
	        if (endIndex === undefined) { endIndex = points.length; }
	
	        this.beginPath();
	
	        this.moveTo(points[0].x, points[0].y);
	
	        for (var i = 1; i < endIndex; i++)
	        {
	            this.lineTo(points[i].x, points[i].y);
	        }
	
	        if (autoClose)
	        {
	            this.lineTo(points[0].x, points[0].y);
	        }
	
	        this.fillPath();
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#strokeEllipseShape
	     * @since 3.0.0
	     *
	     * @param {Phaser.Geom.Ellipse} ellipse - [description]
	     * @param {integer} [smoothness=32] - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    strokeEllipseShape: function (ellipse, smoothness)
	    {
	        if (smoothness === undefined) { smoothness = 32; }
	
	        var points = ellipse.getPoints(smoothness);
	
	        return this.strokePoints(points, true);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#strokeEllipse
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     * @param {integer} [smoothness=32] - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    strokeEllipse: function (x, y, width, height, smoothness)
	    {
	        if (smoothness === undefined) { smoothness = 32; }
	
	        var ellipse = new Ellipse(x, y, width, height);
	
	        var points = ellipse.getPoints(smoothness);
	
	        return this.strokePoints(points, true);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#fillEllipseShape
	     * @since 3.0.0
	     *
	     * @param {Phaser.Geom.Ellipse} ellipse - [description]
	     * @param {integer} [smoothness=32] - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    fillEllipseShape: function (ellipse, smoothness)
	    {
	        if (smoothness === undefined) { smoothness = 32; }
	
	        var points = ellipse.getPoints(smoothness);
	
	        return this.fillPoints(points, true);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#fillEllipse
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     * @param {integer} [smoothness=32] - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    fillEllipse: function (x, y, width, height, smoothness)
	    {
	        if (smoothness === undefined) { smoothness = 32; }
	
	        var ellipse = new Ellipse(x, y, width, height);
	
	        var points = ellipse.getPoints(smoothness);
	
	        return this.fillPoints(points, true);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#arc
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} radius - [description]
	     * @param {number} startAngle - [description]
	     * @param {number} endAngle - [description]
	     * @param {boolean} anticlockwise - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    arc: function (x, y, radius, startAngle, endAngle, anticlockwise)
	    {
	        this.commandBuffer.push(
	            Commands.ARC,
	            x, y, radius, startAngle, endAngle, anticlockwise
	        );
	
	        return this;
	    },
	
	    /**
	     * Creates a pie-chart slice shape centered at `x`, `y` with the given radius.
	     * You must define the start and end angle of the slice.
	     *
	     * Setting the `anticlockwise` argument to `true` creates a shape similar to Pacman.
	     * Setting it to `false` creates a shape like a slice of pie.
	     *
	     * This method will begin a new path and close the path at the end of it.
	     * To display the actual slice you need to call either `strokePath` or `fillPath` after it.
	     *
	     * @method Phaser.GameObjects.Graphics#slice
	     * @since 3.4.0
	     *
	     * @param {number} x - The horizontal center of the slice.
	     * @param {number} y - The vertical center of the slice.
	     * @param {number} radius - The radius of the slice.
	     * @param {number} startAngle - The start angle of the slice, given in radians.
	     * @param {number} endAngle - The end angle of the slice, given in radians.
	     * @param {boolean} [anticlockwise=false] - Draw the slice piece anticlockwise or clockwise?
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    slice: function (x, y, radius, startAngle, endAngle, anticlockwise)
	    {
	        if (anticlockwise === undefined) { anticlockwise = false; }
	
	        this.commandBuffer.push(Commands.BEGIN_PATH);
	
	        this.commandBuffer.push(Commands.MOVE_TO, x, y);
	
	        this.commandBuffer.push(Commands.ARC, x, y, radius, startAngle, endAngle, anticlockwise);
	
	        this.commandBuffer.push(Commands.CLOSE_PATH);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#save
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    save: function ()
	    {
	        this.commandBuffer.push(
	            Commands.SAVE
	        );
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#restore
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    restore: function ()
	    {
	        this.commandBuffer.push(
	            Commands.RESTORE
	        );
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#translate
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    translate: function (x, y)
	    {
	        this.commandBuffer.push(
	            Commands.TRANSLATE,
	            x, y
	        );
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#scale
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    scale: function (x, y)
	    {
	        this.commandBuffer.push(
	            Commands.SCALE,
	            x, y
	        );
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#rotate
	     * @since 3.0.0
	     *
	     * @param {number} radians - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    rotate: function (radians)
	    {
	        this.commandBuffer.push(
	            Commands.ROTATE,
	            radians
	        );
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Graphics#clear
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    clear: function ()
	    {
	        this.commandBuffer.length = 0;
	
	        if (this.defaultFillColor > -1)
	        {
	            this.fillStyle(this.defaultFillColor, this.defaultFillAlpha);
	        }
	
	        if (this.defaultStrokeColor > -1)
	        {
	            this.lineStyle(this.defaultStrokeWidth, this.defaultStrokeColor, this.defaultStrokeAlpha);
	        }
	
	        return this;
	    },
	
	    /**
	     * If key is a string it'll generate a new texture using it and add it into the
	     * Texture Manager (assuming no key conflict happens).
	     *
	     * If key is a Canvas it will draw the texture to that canvas context. Note that it will NOT
	     * automatically upload it to the GPU in WebGL mode.
	     *
	     * @method Phaser.GameObjects.Graphics#generateTexture
	     * @since 3.0.0
	     *
	     * @param {(string|HTMLCanvasElement)} key - [description]
	     * @param {integer} [width] - [description]
	     * @param {integer} [height] - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} This Game Object.
	     */
	    generateTexture: function (key, width, height)
	    {
	        var sys = this.scene.sys;
	
	        if (width === undefined) { width = sys.game.config.width; }
	        if (height === undefined) { height = sys.game.config.height; }
	
	        Graphics.TargetCamera.setViewport(0, 0, width, height);
	        Graphics.TargetCamera.scrollX = this.x;
	        Graphics.TargetCamera.scrollY = this.y;
	
	        var texture;
	        var ctx;
	
	        if (typeof key === 'string')
	        {
	            if (sys.textures.exists(key))
	            {
	                //  Key is a string, it DOES exist in the Texture Manager AND is a canvas, so draw to it
	
	                texture = sys.textures.get(key);
	
	                var src = texture.getSourceImage();
	
	                if (src instanceof HTMLCanvasElement)
	                {
	                    ctx = src.getContext('2d');
	                }
	            }
	            else
	            {
	                //  Key is a string and doesn't exist in the Texture Manager, so generate and save it
	
	                texture = sys.textures.createCanvas(key, width, height);
	
	                ctx = texture.getSourceImage().getContext('2d');
	            }
	        }
	        else if (key instanceof HTMLCanvasElement)
	        {
	            //  Key is a Canvas, so draw to it
	
	            ctx = key.getContext('2d');
	        }
	
	        if (ctx)
	        {
	            this.renderCanvas(sys.game.renderer, this, 0.0, Graphics.TargetCamera, null, ctx);
	
	            if (sys.game.renderer.gl && texture)
	            {
	                texture.source[0].glTexture = sys.game.renderer.canvasToTexture(ctx.canvas, texture.source[0].glTexture);
	            }
	        }
	
	        return this;
	    }
	
	});
	
	/**
	 * A Camera used specifically by the Graphics system for rendering to textures.
	 *
	 * @name Phaser.GameObjects.Graphics.TargetCamera
	 * @type {Phaser.Cameras.Scene2D.Camera}
	 * @since 3.1.0
	 */
	Graphics.TargetCamera = new Camera(0, 0, 0, 0);
	
	module.exports = Graphics;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(28);
	var GameObject = __webpack_require__(5);
	var GravityWell = __webpack_require__(494);
	var List = __webpack_require__(210);
	var ParticleEmitter = __webpack_require__(496);
	var Render = __webpack_require__(1167);
	
	/**
	 * @classdesc
	 * A Particle Emitter Manager creates and controls {@link Phaser.GameObjects.Particles.ParticleEmitter Particle Emitters} and {@link Phaser.GameObjects.Particles.GravityWell Gravity Wells}.
	 *
	 * @class ParticleEmitterManager
	 * @extends Phaser.GameObjects.GameObject
	 * @memberOf Phaser.GameObjects.Particles
	 * @constructor
	 * @since 3.0.0
	 *
	 * @extends Phaser.GameObjects.Particles.Components.Depth
	 * @extends Phaser.GameObjects.Particles.Components.Visible
	 * @extends Phaser.GameObjects.Particles.Components.Pipeline
	 *
	 * @param {Phaser.Scene} scene - The Scene to which this Emitter Manager belongs.
	 * @param {string} texture - The key of the Texture this Emitter Manager will use to render particles, as stored in the Texture Manager.
	 * @param {(string|integer)} frame - An optional frame from the Texture this Emitter Manager will use to render particles.
	 * @param {ParticleEmitterConfig|ParticleEmitterConfig[]} emitters - Configuration settings for one or more emitters to create.
	 */
	var ParticleEmitterManager = new Class({
	
	    Extends: GameObject,
	
	    Mixins: [
	        Components.Depth,
	        Components.Visible,
	        Components.Pipeline,
	        Render
	    ],
	
	    initialize:
	
	    //  frame is optional and can contain the emitters array or object if skipped
	    function ParticleEmitterManager (scene, texture, frame, emitters)
	    {
	        GameObject.call(this, scene, 'ParticleEmitterManager');
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitterManager#blendMode
	         * @type {integer}
	         * @default -1
	         * @private
	         * @since 3.0.0
	         */
	        this.blendMode = -1;
	
	        /**
	         * The time scale applied to all emitters and particles, affecting flow rate, lifespan, and movement.
	         * Values larger than 1 are faster than normal.
	         * This is multiplied with any timeScale set on each individual emitter.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitterManager#timeScale
	         * @type {float}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.timeScale = 1;
	
	        /**
	         * The texture used to render this Emitter Manager's particles.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitterManager#texture
	         * @type {Phaser.Textures.Texture}
	         * @default null
	         * @since 3.0.0
	         */
	        this.texture = null;
	
	        /**
	         * The texture frame used to render this Emitter Manager's particles.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitterManager#frame
	         * @type {Phaser.Textures.Frame}
	         * @default null
	         * @since 3.0.0
	         */
	        this.frame = null;
	
	        /**
	         * Names of this Emitter Manager's texture frames.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitterManager#frameNames
	         * @type {Phaser.Textures.Frame[]}
	         * @since 3.0.0
	         */
	        this.frameNames = [];
	
	        //  frame is optional and can contain the emitters array or object if skipped
	        if (frame !== null && (typeof frame === 'object' || Array.isArray(frame)))
	        {
	            emitters = frame;
	            frame = null;
	        }
	
	        this.setTexture(texture, frame);
	
	        this.initPipeline('TextureTintPipeline');
	
	        /**
	         * A list of Emitters being managed by this Emitter Manager.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitterManager#emitters
	             * @type {Phaser.Structs.List.<Phaser.GameObjects.Particles.ParticleEmitter>}
	         * @since 3.0.0
	         */
	        this.emitters = new List(this);
	
	        /**
	         * A list of Gravity Wells being managed by this Emitter Manager.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitterManager#wells
	         * @type {Phaser.Structs.List.<Phaser.GameObjects.Particles.GravityWell>}
	         * @since 3.0.0
	         */
	        this.wells = new List(this);
	
	        if (emitters)
	        {
	            //  An array of emitter configs?
	            if (!Array.isArray(emitters))
	            {
	                emitters = [ emitters ];
	            }
	
	            for (var i = 0; i < emitters.length; i++)
	            {
	                this.createEmitter(emitters[i]);
	            }
	        }
	    },
	
	    /**
	     * Sets the texture and frame this Emitter Manager will use to render with.
	     *
	     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#setTexture
	     * @since 3.0.0
	     *
	     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
	     * @param {(string|integer)} [frame] - The name or index of the frame within the Texture.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitterManager} This Emitter Manager.
	     */
	    setTexture: function (key, frame)
	    {
	        this.texture = this.scene.sys.textures.get(key);
	
	        return this.setFrame(frame);
	    },
	
	    /**
	     * Sets the frame this Emitter Manager will use to render with.
	     *
	     * The Frame has to belong to the current Texture being used.
	     *
	     * It can be either a string or an index.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#setFrame
	     * @since 3.0.0
	     *
	     * @param {(string|integer)} [frame] - The name or index of the frame within the Texture.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitterManager} This Emitter Manager.
	     */
	    setFrame: function (frame)
	    {
	        this.frame = this.texture.get(frame);
	
	        this.frameNames = this.texture.getFramesFromTextureSource(this.frame.sourceIndex);
	
	        this.defaultFrame = this.frame;
	
	        return this;
	    },
	
	    /**
	     * Assigns texture frames to an emitter.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#setEmitterFrames
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Textures.Frame|Phaser.Textures.Frame[])} frames - The texture frames.
	     * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - The particle emitter to modify.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitterManager} This Emitter Manager.
	     */
	    setEmitterFrames: function (frames, emitter)
	    {
	        if (!Array.isArray(frames))
	        {
	            frames = [ frames ];
	        }
	
	        var out = emitter.frames;
	
	        out.length = 0;
	
	        for (var i = 0; i < frames.length; i++)
	        {
	            var frame = frames[i];
	
	            if (this.frameNames.indexOf(frame) !== -1)
	            {
	                out.push(this.texture.get(frame));
	            }
	        }
	
	        if (out.length > 0)
	        {
	            emitter.defaultFrame = out[0];
	        }
	        else
	        {
	            emitter.defaultFrame = this.defaultFrame;
	        }
	
	        return this;
	    },
	
	    /**
	     * Adds an existing Particle Emitter to this Emitter Manager.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#addEmitter
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - The Particle Emitter to add to this Emitter Manager.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} The Particle Emitter that was added to this Emitter Manager.
	     */
	    addEmitter: function (emitter)
	    {
	        return this.emitters.add(emitter);
	    },
	
	    /**
	     * Creates a new Particle Emitter object, adds it to this Emitter Manager and returns a reference to it.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#createEmitter
	     * @since 3.0.0
	     *
	     * @param {object} config - [description]
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} The Particle Emitter that was created.
	     */
	    createEmitter: function (config)
	    {
	        return this.addEmitter(new ParticleEmitter(this, config));
	    },
	
	    /**
	     * Adds an existing Gravity Well object to this Emitter Manager.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#addGravityWell
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Particles.GravityWell} well - The Gravity Well to add to this Emitter Manager.
	     *
	     * @return {Phaser.GameObjects.Particles.GravityWell} The Gravity Well that was added to this Emitter Manager.
	     */
	    addGravityWell: function (well)
	    {
	        return this.wells.add(well);
	    },
	
	    /**
	     * Creates a new Gravity Well, adds it to this Emitter Manager and returns a reference to it.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#createGravityWell
	     * @since 3.0.0
	     *
	     * @param {object} config - [description]
	     *
	     * @return {Phaser.GameObjects.Particles.GravityWell} The Gravity Well that was created.
	     */
	    createGravityWell: function (config)
	    {
	        return this.addGravityWell(new GravityWell(config));
	    },
	
	    /**
	     * Emits particles from each active emitter.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#emitParticle
	     * @since 3.0.0
	     *
	     * @param {integer} [count] - The number of particles to release from each emitter. The default is the emitter's own {@link Phaser.GameObjects.Particles.ParticleEmitter#quantity}.
	     * @param {float} [x] - The x-coordinate to to emit particles from. The default is the x-coordinate of the emitter's current location.
	     * @param {float} [y] - The y-coordinate to to emit particles from. The default is the y-coordinate of the emitter's current location.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitterManager} This Emitter Manager.
	     */
	    emitParticle: function (count, x, y)
	    {
	        var emitters = this.emitters.list;
	
	        for (var i = 0; i < emitters.length; i++)
	        {
	            var emitter = emitters[i];
	
	            if (emitter.active)
	            {
	                emitter.emitParticle(count, x, y);
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Emits particles from each active emitter.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#emitParticleAt
	     * @since 3.0.0
	     *
	     * @param {float} [x] - The x-coordinate to to emit particles from. The default is the x-coordinate of the emitter's current location.
	     * @param {float} [y] - The y-coordinate to to emit particles from. The default is the y-coordinate of the emitter's current location.
	     * @param {integer} [count] - The number of particles to release from each emitter. The default is the emitter's own {@link Phaser.GameObjects.Particles.ParticleEmitter#quantity}.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitterManager} This Emitter Manager.
	     */
	    emitParticleAt: function (x, y, count)
	    {
	        return this.emitParticle(count, x, y);
	    },
	
	    /**
	     * Pauses this Emitter Manager.
	     *
	     * This has the effect of pausing all emitters, and all particles of those emitters, currently under its control.
	     *
	     * The particles will still render, but they will not have any of their logic updated.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#pause
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitterManager} This Emitter Manager.
	     */
	    pause: function ()
	    {
	        this.active = false;
	
	        return this;
	    },
	
	    /**
	     * Resumes this Emitter Manager, should it have been previously paused.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#resume
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitterManager} This Emitter Manager.
	     */
	    resume: function ()
	    {
	        this.active = true;
	
	        return this;
	    },
	
	    /**
	     * Gets all active particle processors (gravity wells).
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#getProcessors
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Particles.GravityWell[]} - The active gravity wells.
	     */
	    getProcessors: function ()
	    {
	        return this.wells.getAll('active', true);
	    },
	
	    /**
	     * Updates all active emitters.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitterManager#preUpdate
	     * @since 3.0.0
	     *
	     * @param {integer} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
	     * @param {float} delta - The delta time, in ms, elapsed since the last frame.
	     */
	    preUpdate: function (time, delta)
	    {
	        //  Scale the delta
	        delta *= this.timeScale;
	
	        var emitters = this.emitters.list;
	
	        for (var i = 0; i < emitters.length; i++)
	        {
	            var emitter = emitters[i];
	
	            if (emitter.active)
	            {
	                emitter.preUpdate(time, delta);
	            }
	        }
	    }
	
	});
	
	module.exports = ParticleEmitterManager;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Mesh = __webpack_require__(196);
	
	/**
	 * @classdesc
	 * A Quad Game Object.
	 *
	 * A Quad is a Mesh Game Object pre-configured with two triangles arranged into a rectangle, with a single
	 * texture spread across them.
	 *
	 * You can manipulate the corner points of the quad via the getters and setters such as `topLeftX`, and also
	 * change their alpha and color values. The quad itself can be moved by adjusting the `x` and `y` properties.
	 *
	 * @class Quad
	 * @extends Phaser.GameObjects.Mesh
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @webglOnly
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - [description]
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	 * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	 */
	var Quad = new Class({
	
	    Extends: Mesh,
	
	    initialize:
	
	    function Quad (scene, x, y, texture, frame)
	    {
	        //  0----3
	        //  |\  B|
	        //  | \  |
	        //  |  \ |
	        //  | A \|
	        //  |    \
	        //  1----2
	
	        var vertices = [
	            0, 0, // tl
	            0, 0, // bl
	            0, 0, // br
	            0, 0, // tl
	            0, 0, // br
	            0, 0 // tr
	        ];
	        var uv = [
	            0, 0, // tl
	            0, 1, // bl
	            1, 1, // br
	            0, 0, // tl
	            1, 1, // br
	            1, 0 // tr
	        ];
	        var colors = [
	            0xffffff, // tl
	            0xffffff, // bl
	            0xffffff, // br
	            0xffffff, // tl
	            0xffffff, // br
	            0xffffff // tr
	        ];
	        var alphas = [
	            1, // tl
	            1, // bl
	            1, // br
	            1, // tl
	            1, // br
	            1 // tr
	        ];
	
	        Mesh.call(this, scene, x, y, vertices, uv, colors, alphas, texture, frame);
	
	        this.resetPosition();
	    },
	
	    /**
	     * The top-left x vertex of this Quad.
	     *
	     * @name Phaser.GameObjects.Quad#topLeftX
	     * @type {number}
	     * @since 3.0.0
	     */
	    topLeftX: {
	
	        get: function ()
	        {
	            return this.x + this.vertices[0];
	        },
	
	        set: function (value)
	        {
	            this.vertices[0] = value - this.x;
	            this.vertices[6] = value - this.x;
	        }
	
	    },
	
	    /**
	     * The top-left y vertex of this Quad.
	     *
	     * @name Phaser.GameObjects.Quad#topLeftY
	     * @type {number}
	     * @since 3.0.0
	     */
	    topLeftY: {
	
	        get: function ()
	        {
	            return this.y + this.vertices[1];
	        },
	
	        set: function (value)
	        {
	            this.vertices[1] = value - this.y;
	            this.vertices[7] = value - this.y;
	        }
	
	    },
	
	    /**
	     * The top-right x vertex of this Quad.
	     *
	     * @name Phaser.GameObjects.Quad#topRightX
	     * @type {number}
	     * @since 3.0.0
	     */
	    topRightX: {
	
	        get: function ()
	        {
	            return this.x + this.vertices[10];
	        },
	
	        set: function (value)
	        {
	            this.vertices[10] = value - this.x;
	        }
	
	    },
	
	    /**
	     * The top-right y vertex of this Quad.
	     *
	     * @name Phaser.GameObjects.Quad#topRightY
	     * @type {number}
	     * @since 3.0.0
	     */
	    topRightY: {
	
	        get: function ()
	        {
	            return this.y + this.vertices[11];
	        },
	
	        set: function (value)
	        {
	            this.vertices[11] = value - this.y;
	        }
	
	    },
	
	    /**
	     * The bottom-left x vertex of this Quad.
	     *
	     * @name Phaser.GameObjects.Quad#bottomLeftX
	     * @type {number}
	     * @since 3.0.0
	     */
	    bottomLeftX: {
	
	        get: function ()
	        {
	            return this.x + this.vertices[2];
	        },
	
	        set: function (value)
	        {
	            this.vertices[2] = value - this.x;
	        }
	
	    },
	
	    /**
	     * The bottom-left y vertex of this Quad.
	     *
	     * @name Phaser.GameObjects.Quad#bottomLeftY
	     * @type {number}
	     * @since 3.0.0
	     */
	    bottomLeftY: {
	
	        get: function ()
	        {
	            return this.y + this.vertices[3];
	        },
	
	        set: function (value)
	        {
	            this.vertices[3] = value - this.y;
	        }
	
	    },
	
	    /**
	     * The bottom-right x vertex of this Quad.
	     *
	     * @name Phaser.GameObjects.Quad#bottomRightX
	     * @type {number}
	     * @since 3.0.0
	     */
	    bottomRightX: {
	
	        get: function ()
	        {
	            return this.x + this.vertices[4];
	        },
	
	        set: function (value)
	        {
	            this.vertices[4] = value - this.x;
	            this.vertices[8] = value - this.x;
	        }
	
	    },
	
	    /**
	     * The bottom-right y vertex of this Quad.
	     *
	     * @name Phaser.GameObjects.Quad#bottomRightY
	     * @type {number}
	     * @since 3.0.0
	     */
	    bottomRightY: {
	
	        get: function ()
	        {
	            return this.y + this.vertices[5];
	        },
	
	        set: function (value)
	        {
	            this.vertices[5] = value - this.y;
	            this.vertices[9] = value - this.y;
	        }
	
	    },
	
	    /**
	     * The top-left alpha value of this Quad.
	     *
	     * @name Phaser.GameObjects.Quad#topLeftAlpha
	     * @type {float}
	     * @since 3.0.0
	     */
	    topLeftAlpha: {
	
	        get: function ()
	        {
	            return this.alphas[0];
	        },
	
	        set: function (value)
	        {
	            this.alphas[0] = value;
	            this.alphas[3] = value;
	        }
	
	    },
	
	    /**
	     * The top-right alpha value of this Quad.
	     *
	     * @name Phaser.GameObjects.Quad#topRightAlpha
	     * @type {float}
	     * @since 3.0.0
	     */
	    topRightAlpha: {
	
	        get: function ()
	        {
	            return this.alphas[5];
	        },
	
	        set: function (value)
	        {
	            this.alphas[5] = value;
	        }
	
	    },
	
	    /**
	     * The bottom-left alpha value of this Quad.
	     *
	     * @name Phaser.GameObjects.Quad#bottomLeftAlpha
	     * @type {float}
	     * @since 3.0.0
	     */
	    bottomLeftAlpha: {
	
	        get: function ()
	        {
	            return this.alphas[1];
	        },
	
	        set: function (value)
	        {
	            this.alphas[1] = value;
	        }
	
	    },
	
	    /**
	     * The bottom-right alpha value of this Quad.
	     *
	     * @name Phaser.GameObjects.Quad#bottomRightAlpha
	     * @type {float}
	     * @since 3.0.0
	     */
	    bottomRightAlpha: {
	
	        get: function ()
	        {
	            return this.alphas[2];
	        },
	
	        set: function (value)
	        {
	            this.alphas[2] = value;
	            this.alphas[4] = value;
	        }
	
	    },
	
	    /**
	     * The top-left color value of this Quad.
	     *
	     * @name Phaser.GameObjects.Quad#topLeftColor
	     * @type {number}
	     * @since 3.0.0
	     */
	    topLeftColor: {
	
	        get: function ()
	        {
	            return this.colors[0];
	        },
	
	        set: function (value)
	        {
	            this.colors[0] = value;
	            this.colors[3] = value;
	        }
	
	    },
	
	    /**
	     * The top-right color value of this Quad.
	     *
	     * @name Phaser.GameObjects.Quad#topRightColor
	     * @type {number}
	     * @since 3.0.0
	     */
	    topRightColor: {
	
	        get: function ()
	        {
	            return this.colors[5];
	        },
	
	        set: function (value)
	        {
	            this.colors[5] = value;
	        }
	
	    },
	
	    /**
	     * The bottom-left color value of this Quad.
	     *
	     * @name Phaser.GameObjects.Quad#bottomLeftColor
	     * @type {number}
	     * @since 3.0.0
	     */
	    bottomLeftColor: {
	
	        get: function ()
	        {
	            return this.colors[1];
	        },
	
	        set: function (value)
	        {
	            this.colors[1] = value;
	        }
	
	    },
	
	    /**
	     * The bottom-right color value of this Quad.
	     *
	     * @name Phaser.GameObjects.Quad#bottomRightColor
	     * @type {number}
	     * @since 3.0.0
	     */
	    bottomRightColor: {
	
	        get: function ()
	        {
	            return this.colors[2];
	        },
	
	        set: function (value)
	        {
	            this.colors[2] = value;
	            this.colors[4] = value;
	        }
	
	    },
	
	    /**
	     * Sets the top-left vertex position of this Quad.
	     *
	     * @method Phaser.GameObjects.Quad#setTopLeft
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal coordinate of the vertex.
	     * @param {number} y - The vertical coordinate of the vertex.
	     *
	     * @return {Phaser.GameObjects.Quad} This Game Object.
	     */
	    setTopLeft: function (x, y)
	    {
	        this.topLeftX = x;
	        this.topLeftY = y;
	
	        return this;
	    },
	
	    /**
	     * Sets the top-right vertex position of this Quad.
	     *
	     * @method Phaser.GameObjects.Quad#setTopRight
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal coordinate of the vertex.
	     * @param {number} y - The vertical coordinate of the vertex.
	     *
	     * @return {Phaser.GameObjects.Quad} This Game Object.
	     */
	    setTopRight: function (x, y)
	    {
	        this.topRightX = x;
	        this.topRightY = y;
	
	        return this;
	    },
	
	    /**
	     * Sets the bottom-left vertex position of this Quad.
	     *
	     * @method Phaser.GameObjects.Quad#setBottomLeft
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal coordinate of the vertex.
	     * @param {number} y - The vertical coordinate of the vertex.
	     *
	     * @return {Phaser.GameObjects.Quad} This Game Object.
	     */
	    setBottomLeft: function (x, y)
	    {
	        this.bottomLeftX = x;
	        this.bottomLeftY = y;
	
	        return this;
	    },
	
	    /**
	     * Sets the bottom-right vertex position of this Quad.
	     *
	     * @method Phaser.GameObjects.Quad#setBottomRight
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal coordinate of the vertex.
	     * @param {number} y - The vertical coordinate of the vertex.
	     *
	     * @return {Phaser.GameObjects.Quad} This Game Object.
	     */
	    setBottomRight: function (x, y)
	    {
	        this.bottomRightX = x;
	        this.bottomRightY = y;
	
	        return this;
	    },
	
	    /**
	     * Resets the positions of the four corner vertices of this Quad.
	     *
	     * @method Phaser.GameObjects.Quad#resetPosition
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Quad} This Game Object.
	     */
	    resetPosition: function ()
	    {
	        var x = this.x;
	        var y = this.y;
	        var halfWidth = Math.floor(this.width / 2);
	        var halfHeight = Math.floor(this.height / 2);
	
	        this.setTopLeft(x - halfWidth, y - halfHeight);
	        this.setTopRight(x + halfWidth, y - halfHeight);
	        this.setBottomLeft(x - halfWidth, y + halfHeight);
	        this.setBottomRight(x + halfWidth, y + halfHeight);
	
	        return this;
	    },
	
	    /**
	     * Resets the alpha values used by this Quad back to 1.
	     *
	     * @method Phaser.GameObjects.Quad#resetAlpha
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Quad} This Game Object.
	     */
	    resetAlpha: function ()
	    {
	        var alphas = this.alphas;
	
	        alphas[0] = 1;
	        alphas[1] = 1;
	        alphas[2] = 1;
	        alphas[3] = 1;
	        alphas[4] = 1;
	        alphas[5] = 1;
	
	        return this;
	    },
	
	    /**
	     * Resets the color values used by this Quad back to 0xffffff.
	     *
	     * @method Phaser.GameObjects.Quad#resetColors
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Quad} This Game Object.
	     */
	    resetColors: function ()
	    {
	        var colors = this.colors;
	
	        colors[0] = 0xffffff;
	        colors[1] = 0xffffff;
	        colors[2] = 0xffffff;
	        colors[3] = 0xffffff;
	        colors[4] = 0xffffff;
	        colors[5] = 0xffffff;
	
	        return this;
	    },
	
	    /**
	     * Resets the position, alpha and color values used by this Quad.
	     *
	     * @method Phaser.GameObjects.Quad#reset
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Quad} This Game Object.
	     */
	    reset: function ()
	    {
	        this.resetPosition();
	
	        this.resetAlpha();
	
	        return this.resetColors();
	    }
	
	});
	
	module.exports = Quad;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CanvasPool = __webpack_require__(56);
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(28);
	var CONST = __webpack_require__(49);
	var GameObject = __webpack_require__(5);
	var Render = __webpack_require__(1178);
	var RenderTextureCanvas = __webpack_require__(1174);
	var RenderTextureWebGL = __webpack_require__(1179);
	
	/**
	 * @classdesc
	 * A Render Texture.
	 *
	 * @class RenderTexture
	 * @extends Phaser.GameObjects.GameObject
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @since 3.2.0
	 *
	 * @extends Phaser.GameObjects.Components.Alpha
	 * @extends Phaser.GameObjects.Components.BlendMode
	 * @extends Phaser.GameObjects.Components.ComputedSize
	 * @extends Phaser.GameObjects.Components.Depth
	 * @extends Phaser.GameObjects.Components.Flip
	 * @extends Phaser.GameObjects.Components.GetBounds
	 * @extends Phaser.GameObjects.Components.Mask
	 * @extends Phaser.GameObjects.Components.MatrixStack
	 * @extends Phaser.GameObjects.Components.Origin
	 * @extends Phaser.GameObjects.Components.Pipeline
	 * @extends Phaser.GameObjects.Components.ScaleMode
	 * @extends Phaser.GameObjects.Components.ScrollFactor
	 * @extends Phaser.GameObjects.Components.Tint
	 * @extends Phaser.GameObjects.Components.Transform
	 * @extends Phaser.GameObjects.Components.Visible
	 *
	 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {integer} [width=32] - The width of the Render Texture.
	 * @param {integer} [height=32] - The height of the Render Texture.
	 */
	var RenderTexture = new Class({
	
	    Extends: GameObject,
	
	    Mixins: [
	        Components.Alpha,
	        Components.BlendMode,
	        Components.ComputedSize,
	        Components.Depth,
	        Components.Flip,
	        Components.GetBounds,
	        Components.Mask,
	        Components.MatrixStack,
	        Components.Origin,
	        Components.Pipeline,
	        Components.ScaleMode,
	        Components.ScrollFactor,
	        Components.Tint,
	        Components.Transform,
	        Components.Visible,
	        Render
	    ],
	
	    initialize:
	
	    function RenderTexture (scene, x, y, width, height)
	    {
	        if (width === undefined) { width = 32; }
	        if (height === undefined) { height = 32; }
	
	        GameObject.call(this, scene, 'RenderTexture');
	
	        this.initMatrixStack();
	
	        /**
	         * A reference to either the Canvas or WebGL Renderer that the Game instance is using.
	         *
	         * @name Phaser.GameObjects.RenderTexture#renderer
	         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
	         * @since 3.2.0
	         */
	        this.renderer = scene.sys.game.renderer;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.RenderTexture#globalTint
	         * @type {number}
	         * @default 0xffffff
	         * @since 3.2.0
	         */
	        this.globalTint = 0xffffff;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.RenderTexture#globalAlpha
	         * @type {float}
	         * @default 1
	         * @since 3.2.0
	         */
	        this.globalAlpha = 1;
	
	        if (this.renderer.type === CONST.WEBGL)
	        {
	            var gl = this.renderer.gl;
	
	            this.gl = gl;
	            this.fill = RenderTextureWebGL.fill;
	            this.clear = RenderTextureWebGL.clear;
	            this.draw = RenderTextureWebGL.draw;
	            this.drawFrame = RenderTextureWebGL.drawFrame;
	            this.texture = this.renderer.createTexture2D(0, gl.NEAREST, gl.NEAREST, gl.CLAMP_TO_EDGE, gl.CLAMP_TO_EDGE, gl.RGBA, null, width, height, false);
	            this.framebuffer = this.renderer.createFramebuffer(width, height, this.texture, false);
	        }
	        else if (this.renderer.type === CONST.CANVAS)
	        {
	            this.fill = RenderTextureCanvas.fill;
	            this.clear = RenderTextureCanvas.clear;
	            this.draw = RenderTextureCanvas.draw;
	            this.drawFrame = RenderTextureCanvas.drawFrame;
	            this.canvas = CanvasPool.create2D(this, width, height);
	            this.context = this.canvas.getContext('2d');
	        }
	
	        this.setPosition(x, y);
	        this.setSize(width, height);
	        this.initPipeline('TextureTintPipeline');
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.RenderTexture#destroy
	     * @since 3.2.0
	     */
	    destroy: function ()
	    {
	        GameObject.prototype.destroy.call(this);
	
	        if (this.renderer.type === CONST.WEBGL)
	        {
	            this.renderer.deleteTexture(this.texture);
	            this.renderer.deleteFramebuffer(this.framebuffer);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.RenderTexture#setGlobalTint
	     * @since 3.2.0
	     *
	     * @param {integer} tint [description]
	     *
	     * @return {Phaser.GameObjects.RenderTexture} [description]
	     */
	    setGlobalTint: function (tint)
	    {
	        this.globalTint = tint;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.RenderTexture#setGlobalAlpha
	     * @since 3.2.0
	     *
	     * @param {float} alpha [description]
	     *
	     * @return {Phaser.GameObjects.RenderTexture} [description]
	     */
	    setGlobalAlpha: function (alpha)
	    {
	        this.globalAlpha = alpha;
	
	        return this;
	    }
	
	    /**
	     * Fills the Render Texture with the given color.
	     *
	     * @method Phaser.GameObjects.RenderTexture#fill
	     * @since 3.2.0
	     *
	     * @param {number} rgb - The color to fill the Render Texture with.
	     *
	     * @return {Phaser.GameObjects.RenderTexture} This Game Object.
	     */
	
	    /**
	     * Clears the Render Texture.
	     *
	     * @method Phaser.GameObjects.RenderTexture#clear
	     * @since 3.2.0
	     *
	     * @return {Phaser.GameObjects.RenderTexture} This Game Object.
	     */
	
	    /**
	     * Draws a texture frame to the Render Texture at the given position.
	     *
	     * @method Phaser.GameObjects.RenderTexture#draw
	     * @since 3.2.0
	     *
	     * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	     * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	     * @param {number} x - The x position to draw the frame at.
	     * @param {number} y - The y position to draw the frame at.
	     *
	     * @return {Phaser.GameObjects.RenderTexture} This Game Object.
	     */
	
	});
	
	module.exports = RenderTexture;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var AddToDOM = __webpack_require__(271);
	var CanvasPool = __webpack_require__(56);
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(28);
	var CONST = __webpack_require__(49);
	var GameObject = __webpack_require__(5);
	var GetTextSize = __webpack_require__(1188);
	var GetValue = __webpack_require__(10);
	var RemoveFromDOM = __webpack_require__(486);
	var TextRender = __webpack_require__(1194);
	var TextStyle = __webpack_require__(1190);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class Text
	 * @extends Phaser.GameObjects.GameObject
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @since 3.0.0
	 *
	 * @extends Phaser.GameObjects.Components.Alpha
	 * @extends Phaser.GameObjects.Components.BlendMode
	 * @extends Phaser.GameObjects.Components.ComputedSize
	 * @extends Phaser.GameObjects.Components.Depth
	 * @extends Phaser.GameObjects.Components.Flip
	 * @extends Phaser.GameObjects.Components.GetBounds
	 * @extends Phaser.GameObjects.Components.Mask
	 * @extends Phaser.GameObjects.Components.Origin
	 * @extends Phaser.GameObjects.Components.Pipeline
	 * @extends Phaser.GameObjects.Components.ScaleMode
	 * @extends Phaser.GameObjects.Components.ScrollFactor
	 * @extends Phaser.GameObjects.Components.Tint
	 * @extends Phaser.GameObjects.Components.Transform
	 * @extends Phaser.GameObjects.Components.Visible
	 *
	 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {(string|string[])} text - The text this Text object will display.
	 * @param {object} style - The text style configuration object.
	 */
	var Text = new Class({
	
	    Extends: GameObject,
	
	    Mixins: [
	        Components.Alpha,
	        Components.BlendMode,
	        Components.ComputedSize,
	        Components.Depth,
	        Components.Flip,
	        Components.GetBounds,
	        Components.Mask,
	        Components.Origin,
	        Components.Pipeline,
	        Components.ScaleMode,
	        Components.ScrollFactor,
	        Components.Tint,
	        Components.Transform,
	        Components.Visible,
	        TextRender
	    ],
	
	    initialize:
	
	    function Text (scene, x, y, text, style)
	    {
	        if (x === undefined) { x = 0; }
	        if (y === undefined) { y = 0; }
	
	        GameObject.call(this, scene, 'Text');
	
	        this.setPosition(x, y);
	        this.setOrigin(0, 0);
	        this.initPipeline('TextureTintPipeline');
	
	        /**
	         * The canvas element that the text is rendered to.
	         *
	         * @name Phaser.GameObjects.Text#canvas
	         * @type {HTMLCanvasElement}
	         * @since 3.0.0
	         */
	        this.canvas = CanvasPool.create(this);
	
	        /**
	         * The context of the canvas element that the text is rendered to.
	         *
	         * @name Phaser.GameObjects.Text#context
	         * @type {CanvasRenderingContext2D}
	         * @since 3.0.0
	         */
	        this.context = this.canvas.getContext('2d');
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text#style
	         * @type {Phaser.GameObjects.Text.TextStyle}
	         * @since 3.0.0
	         */
	        this.style = new TextStyle(this, style);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text#autoRound
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.autoRound = true;
	
	        /**
	         * The Regular Expression that is used to split the text up into lines, in
	         * multi-line text. By default this is `/(?:\r\n|\r|\n)/`.
	         * You can change this RegExp to be anything else that you may need.
	         *
	         * @name Phaser.GameObjects.Text#splitRegExp
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.splitRegExp = /(?:\r\n|\r|\n)/;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text#text
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.text = '';
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text#resolution
	         * @type {number}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.resolution = 1;
	
	        /**
	         * Specify a padding value which is added to the line width and height when calculating the Text size.
	         * Allows you to add extra spacing if the browser is unable to accurately determine the true font dimensions.
	         *
	         * @name Phaser.GameObjects.Text#padding
	         * @type {{left:number,right:number,top:number,bottom:number}}
	         * @since 3.0.0
	         */
	        this.padding = { left: 0, right: 0, top: 0, bottom: 0 };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text#width
	         * @type {number}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.width = 1;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text#height
	         * @type {number}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.height = 1;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text#canvasTexture
	         * @type {HTMLCanvasElement}
	         * @default null
	         * @since 3.0.0
	         */
	        this.canvasTexture = null;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text#dirty
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.dirty = false;
	
	        this.initRTL();
	
	        if (style && style.padding)
	        {
	            this.setPadding(style.padding);
	        }
	
	        if (style && style.lineSpacing)
	        {
	            this._lineSpacing = style.lineSpacing;
	        }
	
	        this.setText(text);
	
	        if (scene.sys.game.config.renderType === CONST.WEBGL)
	        {
	            scene.sys.game.renderer.onContextRestored(function ()
	            {
	                this.canvasTexture = null;
	                this.dirty = true;
	            }, this);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#initRTL
	     * @since 3.0.0
	     */
	    initRTL: function ()
	    {
	        if (!this.style.rtl)
	        {
	            return;
	        }
	
	        //  Here is where the crazy starts.
	        //
	        //  Due to browser implementation issues, you cannot fillText BiDi text to a canvas
	        //  that is not part of the DOM. It just completely ignores the direction property.
	
	        this.canvas.dir = 'rtl';
	
	        //  Experimental atm, but one day ...
	        this.context.direction = 'rtl';
	
	        //  Add it to the DOM, but hidden within the parent canvas.
	        this.canvas.style.display = 'none';
	
	        AddToDOM(this.canvas, this.scene.sys.canvas);
	
	        //  And finally we set the x origin
	        this.originX = 1;
	    },
	
	    /**
	     * Greedy wrapping algorithm that will wrap words as the line grows longer than its horizontal
	     * bounds.
	     *
	     * @method Phaser.GameObjects.Text#runWordWrap
	     * @since 3.0.0
	     *
	     * @param {string} text - The text to perform word wrap detection against.
	     *
	     * @return {string} The text after wrapping has been applied.
	     */
	    runWordWrap: function (text)
	    {
	        var style = this.style;
	
	        if (style.wordWrapCallback)
	        {
	            var wrappedLines = style.wordWrapCallback.call(style.wordWrapCallbackScope, text, this);
	
	            if (Array.isArray(wrappedLines))
	            {
	                wrappedLines = wrappedLines.join('\n');
	            }
	
	            return wrappedLines;
	        }
	        else if (style.wordWrapWidth)
	        {
	            if (style.wordWrapUseAdvanced)
	            {
	                return this.advancedWordWrap(text, this.context, this.style.wordWrapWidth);
	            }
	            else
	            {
	                return this.basicWordWrap(text, this.context, this.style.wordWrapWidth);
	            }
	        }
	        else
	        {
	            return text;
	        }
	    },
	
	    /**
	     * Advanced wrapping algorithm that will wrap words as the line grows longer than its horizontal
	     * bounds. Consecutive spaces will be collapsed and replaced with a single space. Lines will be
	     * trimmed of white space before processing. Throws an error if wordWrapWidth is less than a
	     * single character.
	     *
	     * @method Phaser.GameObjects.Text#advancedWordWrap
	     * @since 3.0.0
	     *
	     * @param {string} text - The text to perform word wrap detection against.
	     * @param {CanvasRenderingContext2D} context - [description]
	     * @param {number} wordWrapWidth - [description]
	     *
	     * @return {string} The wrapped text.
	     */
	    advancedWordWrap: function (text, context, wordWrapWidth)
	    {
	        var output = '';
	
	        // Condense consecutive spaces and split into lines
	        var lines = text
	            .replace(/ +/gi, ' ')
	            .split(this.splitRegExp);
	
	        var linesCount = lines.length;
	
	        for (var i = 0; i < linesCount; i++)
	        {
	            var line = lines[i];
	            var out = '';
	
	            // Trim whitespace
	            line = line.replace(/^ *|\s*$/gi, '');
	
	            // If entire line is less than wordWrapWidth append the entire line and exit early
	            var lineWidth = context.measureText(line).width;
	
	            if (lineWidth < wordWrapWidth)
	            {
	                output += line + '\n';
	                continue;
	            }
	
	            // Otherwise, calculate new lines
	            var currentLineWidth = wordWrapWidth;
	
	            // Split into words
	            var words = line.split(' ');
	
	            for (var j = 0; j < words.length; j++)
	            {
	                var word = words[j];
	                var wordWithSpace = word + ' ';
	                var wordWidth = context.measureText(wordWithSpace).width;
	
	                if (wordWidth > currentLineWidth)
	                {
	                    // Break word
	                    if (j === 0)
	                    {
	                        // Shave off letters from word until it's small enough
	                        var newWord = wordWithSpace;
	
	                        while (newWord.length)
	                        {
	                            newWord = newWord.slice(0, -1);
	                            wordWidth = context.measureText(newWord).width;
	
	                            if (wordWidth <= currentLineWidth)
	                            {
	                                break;
	                            }
	                        }
	
	                        // If wordWrapWidth is too small for even a single letter, shame user
	                        // failure with a fatal error
	                        if (!newWord.length)
	                        {
	                            throw new Error('This text\'s wordWrapWidth setting is less than a single character!');
	                        }
	
	                        // Replace current word in array with remainder
	                        var secondPart = word.substr(newWord.length);
	
	                        words[j] = secondPart;
	
	                        // Append first piece to output
	                        out += newWord;
	                    }
	
	                    // If existing word length is 0, don't include it
	                    var offset = (words[j].length) ? j : j + 1;
	
	                    // Collapse rest of sentence and remove any trailing white space
	                    var remainder = words.slice(offset).join(' ')
	                        .replace(/[ \n]*$/gi, '');
	
	                    // Prepend remainder to next line
	                    lines[i + 1] = remainder + ' ' + (lines[i + 1] || '');
	                    linesCount = lines.length;
	
	                    break; // Processing on this line
	
	                    // Append word with space to output
	                }
	                else
	                {
	                    out += wordWithSpace;
	                    currentLineWidth -= wordWidth;
	                }
	            }
	
	            // Append processed line to output
	            output += out.replace(/[ \n]*$/gi, '') + '\n';
	        }
	
	        // Trim the end of the string
	        output = output.replace(/[\s|\n]*$/gi, '');
	
	        return output;
	    },
	
	    /**
	     * Greedy wrapping algorithm that will wrap words as the line grows longer than its horizontal
	     * bounds. Spaces are not collapsed and whitespace is not trimmed.
	     *
	     * @method Phaser.GameObjects.Text#basicWordWrap
	     * @since 3.0.0
	     *
	     * @param {string} text - The text to perform word wrap detection against.
	     * @param {CanvasRenderingContext2D} context - [description]
	     * @param {number} wordWrapWidth - [description]
	     *
	     * @return {string} The wrapped text.
	     */
	    basicWordWrap: function (text, context, wordWrapWidth)
	    {
	        var result = '';
	        var lines = text.split(this.splitRegExp);
	
	        for (var i = 0; i < lines.length; i++)
	        {
	            var spaceLeft = wordWrapWidth;
	            var words = lines[i].split(' ');
	
	            for (var j = 0; j < words.length; j++)
	            {
	                var wordWidth = context.measureText(words[j]).width;
	                var wordWidthWithSpace = wordWidth + context.measureText(' ').width;
	
	                if (wordWidthWithSpace > spaceLeft)
	                {
	                    // Skip printing the newline if it's the first word of the line that is greater
	                    // than the word wrap width.
	                    if (j > 0)
	                    {
	                        result += '\n';
	                    }
	
	                    result += words[j] + ' ';
	                    spaceLeft = wordWrapWidth - wordWidth;
	                }
	                else
	                {
	                    spaceLeft -= wordWidthWithSpace;
	                    result += words[j];
	
	                    if (j < (words.length - 1))
	                    {
	                        result += ' ';
	                    }
	                }
	            }
	
	            if (i < lines.length - 1)
	            {
	                result += '\n';
	            }
	        }
	
	        return result;
	    },
	
	    /**
	     * Runs the given text through this Text objects word wrapping and returns the results as an
	     * array, where each element of the array corresponds to a wrapped line of text.
	     *
	     * @method Phaser.GameObjects.Text#getWrappedText
	     * @since 3.0.0
	     *
	     * @param {string} text - The text for which the wrapping will be calculated. If unspecified, the Text objects current text will be used.
	     *
	     * @return {string[]} An array of strings with the pieces of wrapped text.
	     */
	    getWrappedText: function (text)
	    {
	        if (text === undefined) { text = this.text; }
	
	        this.style.syncFont(this.canvas, this.context);
	
	        var wrappedLines = this.runWordWrap(text);
	
	        return wrappedLines.split(this.splitRegExp);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#setText
	     * @since 3.0.0
	     *
	     * @param {(string|string[])} value - The string, or array of strings, to be set as the content of this Text object.
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    setText: function (value)
	    {
	        if (!value && value !== 0)
	        {
	            value = '';
	        }
	
	        if (Array.isArray(value))
	        {
	            value = value.join('\n');
	        }
	
	        if (value !== this.text)
	        {
	            this.text = value.toString();
	
	            this.updateText();
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#setStyle
	     * @since 3.0.0
	     *
	     * @param {object} style - [description]
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    setStyle: function (style)
	    {
	        return this.style.setStyle(style);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#setFont
	     * @since 3.0.0
	     *
	     * @param {string} font - [description]
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    setFont: function (font)
	    {
	        return this.style.setFont(font);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#setFontFamily
	     * @since 3.0.0
	     *
	     * @param {string} family - [description]
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    setFontFamily: function (family)
	    {
	        return this.style.setFontFamily(family);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#setFontSize
	     * @since 3.0.0
	     *
	     * @param {number} size - [description]
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    setFontSize: function (size)
	    {
	        return this.style.setFontSize(size);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#setFontStyle
	     * @since 3.0.0
	     *
	     * @param {string} style - [description]
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    setFontStyle: function (style)
	    {
	        return this.style.setFontStyle(style);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#setFixedSize
	     * @since 3.0.0
	     *
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    setFixedSize: function (width, height)
	    {
	        return this.style.setFixedSize(width, height);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#setBackgroundColor
	     * @since 3.0.0
	     *
	     * @param {string} color - [description]
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    setBackgroundColor: function (color)
	    {
	        return this.style.setBackgroundColor(color);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#setFill
	     * @since 3.0.0
	     *
	     * @param {string} color - [description]
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    setFill: function (color)
	    {
	        return this.style.setFill(color);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#setColor
	     * @since 3.0.0
	     *
	     * @param {string} color - [description]
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    setColor: function (color)
	    {
	        return this.style.setColor(color);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#setStroke
	     * @since 3.0.0
	     *
	     * @param {string} color - [description]
	     * @param {number} thickness - [description]
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    setStroke: function (color, thickness)
	    {
	        return this.style.setStroke(color, thickness);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#setShadow
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {string} color - [description]
	     * @param {number} blur - [description]
	     * @param {boolean} shadowStroke - [description]
	     * @param {boolean} shadowFill - [description]
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    setShadow: function (x, y, color, blur, shadowStroke, shadowFill)
	    {
	        return this.style.setShadow(x, y, color, blur, shadowStroke, shadowFill);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#setShadowOffset
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    setShadowOffset: function (x, y)
	    {
	        return this.style.setShadowOffset(x, y);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#setShadowColor
	     * @since 3.0.0
	     *
	     * @param {string} color - [description]
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    setShadowColor: function (color)
	    {
	        return this.style.setShadowColor(color);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#setShadowBlur
	     * @since 3.0.0
	     *
	     * @param {number} blur - [description]
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    setShadowBlur: function (blur)
	    {
	        return this.style.setShadowBlur(blur);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#setShadowStroke
	     * @since 3.0.0
	     *
	     * @param {boolean} enabled - [description]
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    setShadowStroke: function (enabled)
	    {
	        return this.style.setShadowStroke(enabled);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#setShadowFill
	     * @since 3.0.0
	     *
	     * @param {boolean} enabled - [description]
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    setShadowFill: function (enabled)
	    {
	        return this.style.setShadowFill(enabled);
	    },
	
	    /**
	     * Set the width (in pixels) to use for wrapping lines. Pass in null to remove wrapping by width.
	     *
	     * @method Phaser.GameObjects.Text#setWordWrapWidth
	     * @since 3.0.0
	     *
	     * @param {?number} width - The maximum width of a line in pixels. Set to null to remove wrapping.
	     * @param {boolean} [useAdvancedWrap=false] - Whether or not to use the advanced wrapping
	     * algorithm. If true, spaces are collapsed and whitespace is trimmed from lines. If false,
	     * spaces and whitespace are left as is.
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    setWordWrapWidth: function (width, useAdvancedWrap)
	    {
	        return this.style.setWordWrapWidth(width, useAdvancedWrap);
	    },
	
	    /**
	     * Set a custom callback for wrapping lines. Pass in null to remove wrapping by callback.
	     *
	     * @method Phaser.GameObjects.Text#setWordWrapCallback
	     * @since 3.0.0
	     *
	     * @param {TextStyleWordWrapCallback} callback - A custom function that will be responsible for wrapping the
	     * text. It will receive two arguments: text (the string to wrap), textObject (this Text
	     * instance). It should return the wrapped lines either as an array of lines or as a string with
	     * newline characters in place to indicate where breaks should happen.
	     * @param {object} [scope=null] - The scope that will be applied when the callback is invoked.
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    setWordWrapCallback: function (callback, scope)
	    {
	        return this.style.setWordWrapCallback(callback, scope);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#setAlign
	     * @since 3.0.0
	     *
	     * @param {string} align - [description]
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    setAlign: function (align)
	    {
	        return this.style.setAlign(align);
	    },
	
	    /**
	     * 'left' can be an object.
	     * If only 'left' and 'top' are given they are treated as 'x' and 'y'
	     *
	     * @method Phaser.GameObjects.Text#setPadding
	     * @since 3.0.0
	     *
	     * @param {(number|object)} left - [description]
	     * @param {number} top - [description]
	     * @param {number} right - [description]
	     * @param {number} bottom - [description]
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    setPadding: function (left, top, right, bottom)
	    {
	        if (typeof left === 'object')
	        {
	            var config = left;
	
	            //  If they specify x and/or y this applies to all
	            var x = GetValue(config, 'x', null);
	
	            if (x !== null)
	            {
	                left = x;
	                right = x;
	            }
	            else
	            {
	                left = GetValue(config, 'left', 0);
	                right = GetValue(config, 'right', left);
	            }
	
	            var y = GetValue(config, 'y', null);
	
	            if (y !== null)
	            {
	                top = y;
	                bottom = y;
	            }
	            else
	            {
	                top = GetValue(config, 'top', 0);
	                bottom = GetValue(config, 'bottom', top);
	            }
	        }
	        else
	        {
	            if (left === undefined) { left = 0; }
	            if (top === undefined) { top = left; }
	            if (right === undefined) { right = left; }
	            if (bottom === undefined) { bottom = top; }
	        }
	
	        this.padding.left = left;
	        this.padding.top = top;
	        this.padding.right = right;
	        this.padding.bottom = bottom;
	
	        return this.updateText();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#setMaxLines
	     * @since 3.0.0
	     *
	     * @param {integer} [max=0] - [description]
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    setMaxLines: function (max)
	    {
	        return this.style.setMaxLines(max);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#updateText
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Text} This Text object.
	     */
	    updateText: function ()
	    {
	        var canvas = this.canvas;
	        var context = this.context;
	        var style = this.style;
	        var resolution = this.resolution;
	        var size = style.metrics;
	
	        style.syncFont(canvas, context);
	
	        var outputText = this.text;
	
	        if (style.wordWrapWidth || style.wordWrapCallback)
	        {
	            outputText = this.runWordWrap(this.text);
	        }
	
	        //  Split text into lines
	        var lines = outputText.split(this.splitRegExp);
	
	        var textSize = GetTextSize(this, size, lines);
	
	        var padding = this.padding;
	
	        var w = textSize.width + padding.left + padding.right;
	        var h = textSize.height + padding.top + padding.bottom;
	
	        if (style.fixedWidth === 0)
	        {
	            this.width = w;
	        }
	
	        if (style.fixedHeight === 0)
	        {
	            this.height = h;
	        }
	
	        this.updateDisplayOrigin();
	
	        w *= resolution;
	        h *= resolution;
	
	        w = Math.max(w, 1);
	        h = Math.max(h, 1);
	
	        if (canvas.width !== w || canvas.height !== h)
	        {
	            canvas.width = w;
	            canvas.height = h;
	            style.syncFont(canvas, context); // Resizing resets the context
	        }
	        else
	        {
	            context.clearRect(0, 0, w, h);
	        }
	
	        context.save();
	
	        // context.scale(resolution, resolution);
	
	        if (style.backgroundColor)
	        {
	            context.fillStyle = style.backgroundColor;
	            context.fillRect(0, 0, w, h);
	        }
	
	        style.syncStyle(canvas, context);
	
	        context.textBaseline = 'alphabetic';
	
	        //  Apply padding
	        context.translate(padding.left, padding.top);
	
	        var linePositionX;
	        var linePositionY;
	
	        //  Draw text line by line
	        for (var i = 0; i < textSize.lines; i++)
	        {
	            linePositionX = style.strokeThickness / 2;
	            linePositionY = (style.strokeThickness / 2 + i * textSize.lineHeight) + size.ascent;
	
	            if (i > 0)
	            {
	                linePositionY += (textSize.lineSpacing * i);
	            }
	
	            if (style.rtl)
	            {
	                linePositionX = w - linePositionX;
	            }
	            else if (style.align === 'right')
	            {
	                linePositionX += textSize.width - textSize.lineWidths[i];
	            }
	            else if (style.align === 'center')
	            {
	                linePositionX += (textSize.width - textSize.lineWidths[i]) / 2;
	            }
	
	            if (this.autoRound)
	            {
	                linePositionX = Math.round(linePositionX);
	                linePositionY = Math.round(linePositionY);
	            }
	
	            if (style.strokeThickness)
	            {
	                this.style.syncShadow(context, style.shadowStroke);
	
	                context.strokeText(lines[i], linePositionX, linePositionY);
	            }
	
	            if (style.color)
	            {
	                this.style.syncShadow(context, style.shadowFill);
	
	                context.fillText(lines[i], linePositionX, linePositionY);
	            }
	        }
	
	        context.restore();
	
	        this.dirty = true;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#getTextMetrics
	     * @since 3.0.0
	     *
	     * @return {object} [description]
	     */
	    getTextMetrics: function ()
	    {
	        return this.style.getTextMetrics();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#toJSON
	     * @since 3.0.0
	     *
	     * @return {JSONGameObject} A JSON representation of the Game Object.
	     */
	    toJSON: function ()
	    {
	        var out = Components.ToJSON(this);
	
	        //  Extra Text data is added here
	
	        var data = {
	            autoRound: this.autoRound,
	            text: this.text,
	            style: this.style.toJSON(),
	            resolution: this.resolution,
	            padding: {
	                left: this.padding.left,
	                right: this.padding.right,
	                top: this.padding.top,
	                bottom: this.padding.bottom
	            }
	        };
	
	        out.data = data;
	
	        return out;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text#preDestroy
	     * @since 3.0.0
	     */
	    preDestroy: function ()
	    {
	        if (this.style.rtl)
	        {
	            RemoveFromDOM(this.canvas);
	        }
	
	        CanvasPool.remove(this.canvas);
	    }
	
	});
	
	module.exports = Text;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CanvasPool = __webpack_require__(56);
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(28);
	var CONST = __webpack_require__(49);
	var GameObject = __webpack_require__(5);
	var GetPowerOfTwo = __webpack_require__(578);
	var TileSpriteRender = __webpack_require__(1199);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class TileSprite
	 * @extends Phaser.GameObjects.GameObject
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @since 3.0.0
	 *
	 * @extends Phaser.GameObjects.Components.Alpha
	 * @extends Phaser.GameObjects.Components.BlendMode
	 * @extends Phaser.GameObjects.Components.Depth
	 * @extends Phaser.GameObjects.Components.Flip
	 * @extends Phaser.GameObjects.Components.GetBounds
	 * @extends Phaser.GameObjects.Components.Mask
	 * @extends Phaser.GameObjects.Components.Origin
	 * @extends Phaser.GameObjects.Components.Pipeline
	 * @extends Phaser.GameObjects.Components.ScaleMode
	 * @extends Phaser.GameObjects.Components.ScrollFactor
	 * @extends Phaser.GameObjects.Components.Size
	 * @extends Phaser.GameObjects.Components.Texture
	 * @extends Phaser.GameObjects.Components.Tint
	 * @extends Phaser.GameObjects.Components.Transform
	 * @extends Phaser.GameObjects.Components.Visible
	 *
	 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {number} width - The width of the Game Object.
	 * @param {number} height - The height of the Game Object.
	 * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	 * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	 */
	var TileSprite = new Class({
	
	    Extends: GameObject,
	
	    Mixins: [
	        Components.Alpha,
	        Components.BlendMode,
	        Components.Depth,
	        Components.Flip,
	        Components.GetBounds,
	        Components.Mask,
	        Components.Origin,
	        Components.Pipeline,
	        Components.ScaleMode,
	        Components.ScrollFactor,
	        Components.Size,
	        Components.Texture,
	        Components.Tint,
	        Components.Transform,
	        Components.Visible,
	        TileSpriteRender
	    ],
	
	    initialize:
	
	    function TileSprite (scene, x, y, width, height, texture, frame)
	    {
	        var renderer = scene.sys.game.renderer;
	
	        GameObject.call(this, scene, 'TileSprite');
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.TileSprite#tilePositionX
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.tilePositionX = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.TileSprite#tilePositionY
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.tilePositionY = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.TileSprite#dirty
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.dirty = true;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.TileSprite#tileTexture
	         * @type {?WebGLTexture}
	         * @default null
	         * @since 3.0.0
	         */
	        this.tileTexture = null;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.TileSprite#renderer
	         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
	         * @since 3.0.0
	         */
	        this.renderer = renderer;
	
	        this.setTexture(texture, frame);
	        this.setPosition(x, y);
	        this.setSize(width, height);
	        this.setOriginFromFrame();
	        this.initPipeline('TextureTintPipeline');
	
	        /**
	         * The next power of two value from the width of the Frame.
	         *
	         * @name Phaser.GameObjects.TileSprite#potWidth
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.potWidth = GetPowerOfTwo(this.frame.width);
	
	        /**
	         * The next power of two value from the height of the Frame.
	         *
	         * @name Phaser.GameObjects.TileSprite#potHeight
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.potHeight = GetPowerOfTwo(this.frame.height);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.TileSprite#canvasPattern
	         * @type {?CanvasPattern}
	         * @default null
	         * @since 3.0.0
	         */
	        this.canvasPattern = null;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.TileSprite#canvasBuffer
	         * @type {HTMLCanvasElement}
	         * @since 3.0.0
	         */
	        this.canvasBuffer = CanvasPool.create2D(this, this.potWidth, this.potHeight);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.TileSprite#canvasBufferCtx
	         * @type {CanvasRenderingContext2D}
	         * @since 3.0.0
	         */
	        this.canvasBufferCtx = this.canvasBuffer.getContext('2d');
	
	        this.oldFrame = null;
	
	        this.updateTileTexture();
	
	        if (scene.sys.game.config.renderType === CONST.WEBGL)
	        {
	            scene.sys.game.renderer.onContextRestored(function (renderer)
	            {
	                var gl = renderer.gl;
	
	                this.tileTexture = null;
	                this.dirty = true;
	                this.tileTexture = renderer.createTexture2D(0, gl.LINEAR, gl.LINEAR, gl.REPEAT, gl.REPEAT, gl.RGBA, this.canvasBuffer, this.potWidth, this.potHeight);
	            }, this);
	        }
	    },
	
	    /**
	     * Sets {@link Phaser.GameObjects.TileSprite#tilePositionX} and {@link Phaser.GameObjects.TileSprite#tilePositionY}.
	     *
	     * @method Phaser.GameObjects.TileSprite#setTilePosition
	     * @since 3.3.0
	     *
	     * @param {number} [x] - The x position of this sprite's tiling texture.
	     * @param {number} [y] - The y position of this sprite's tiling texture.
	     *
	     * @return {Phaser.GameObjects.TileSprite} This Tile Sprite instance.
	     */
	    setTilePosition: function (x, y)
	    {
	        if (x !== undefined)
	        {
	            this.tilePositionX = x;
	        }
	
	        if (y !== undefined)
	        {
	            this.tilePositionY = y;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.TileSprite#updateTileTexture
	     * @since 3.0.0
	     */
	    updateTileTexture: function ()
	    {
	        if (!this.dirty && this.oldFrame === this.frame)
	        {
	            return;
	        }
	
	        this.oldFrame = this.frame;
	
	        this.canvasBufferCtx.clearRect(0, 0, this.canvasBuffer.width, this.canvasBuffer.height);
	
	        if (this.renderer.gl)
	        {
	            this.canvasBufferCtx.drawImage(
	                this.frame.source.image,
	                this.frame.cutX, this.frame.cutY,
	                this.frame.cutWidth, this.frame.cutHeight,
	                0, 0,
	                this.potWidth, this.potHeight
	            );
	
	            this.tileTexture = this.renderer.canvasToTexture(this.canvasBuffer, this.tileTexture);
	        }
	        else
	        {
	            this.canvasBuffer.width = this.frame.cutWidth;
	            this.canvasBuffer.height = this.frame.cutHeight;
	            this.canvasBufferCtx.drawImage(
	                this.frame.source.image,
	                this.frame.cutX, this.frame.cutY,
	                this.frame.cutWidth, this.frame.cutHeight,
	                0, 0,
	                this.frame.cutWidth, this.frame.cutHeight
	            );
	
	            this.canvasPattern = this.canvasBufferCtx.createPattern(this.canvasBuffer, 'repeat');
	        }
	
	        this.dirty = false;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.TileSprite#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        if (this.renderer.gl)
	        {
	            this.renderer.deleteTexture(this.tileTexture);
	        }
	
	        CanvasPool.remove(this.canvasBuffer);
	
	        this.canvasPattern = null;
	        this.canvasBufferCtx = null;
	        this.canvasBuffer = null;
	
	        this.renderer = null;
	        this.visible = false;
	    }
	
	});
	
	module.exports = TileSprite;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	
	/**
	 * Returns a Point object containing the coordinates of a point on the circumference of the Circle based on the given angle.
	 *
	 * @function Phaser.Geom.Circle.CircumferencePoint
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Circle} circle - The Circle to get the circumference point on.
	 * @param {number} angle - The angle from the center of the Circle to the circumference to return the point from. Given in radians.
	 * @param {(Phaser.Geom.Point|object)} [out] - A Point, or point-like object, to store the results in. If not given a Point will be created.
	 *
	 * @return {(Phaser.Geom.Point|object)} A Point object where the `x` and `y` properties are the point on the circumference.
	 */
	var CircumferencePoint = function (circle, angle, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    out.x = circle.x + (circle.radius * Math.cos(angle));
	    out.y = circle.y + (circle.radius * Math.sin(angle));
	
	    return out;
	};
	
	module.exports = CircumferencePoint;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	
	/**
	 * Returns a uniformly distributed random point from anywhere within the given Circle.
	 *
	 * @function Phaser.Geom.Circle.Random
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Circle} circle - The Circle to get a random point from.
	 * @param {(Phaser.Geom.Point|object)} [out] - A Point or point-like object to set the random `x` and `y` values in.
	 *
	 * @return {(Phaser.Geom.Point|object)} A Point object with the random values set in the `x` and `y` properties.
	 */
	var Random = function (circle, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    var t = 2 * Math.PI * Math.random();
	    var u = Math.random() + Math.random();
	    var r = (u > 1) ? 2 - u : u;
	    var x = r * Math.cos(t);
	    var y = r * Math.sin(t);
	
	    out.x = circle.x + (x * circle.radius);
	    out.y = circle.y + (y * circle.radius);
	
	    return out;
	};
	
	module.exports = Random;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	
	/**
	 * Returns a Point object containing the coordinates of a point on the circumference of the Ellipse based on the given angle.
	 *
	 * @function Phaser.Geom.Ellipse.CircumferencePoint
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the circumference point on.
	 * @param {number} angle - The angle from the center of the Ellipse to the circumference to return the point from. Given in radians.
	 * @param {(Phaser.Geom.Point|object)} [out] - A Point, or point-like object, to store the results in. If not given a Point will be created.
	 *
	 * @return {(Phaser.Geom.Point|object)} A Point object where the `x` and `y` properties are the point on the circumference.
	 */
	var CircumferencePoint = function (ellipse, angle, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    var halfWidth = ellipse.width / 2;
	    var halfHeight = ellipse.height / 2;
	
	    out.x = ellipse.x + halfWidth * Math.cos(angle);
	    out.y = ellipse.y + halfHeight * Math.sin(angle);
	
	    return out;
	};
	
	module.exports = CircumferencePoint;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Contains = __webpack_require__(161);
	var GetPoint = __webpack_require__(505);
	var GetPoints = __webpack_require__(506);
	var Random = __webpack_require__(289);
	
	/**
	 * @classdesc
	 * An Ellipse object.
	 *
	 * This is a geometry object, containing numerical values and related methods to inspect and modify them.
	 * It is not a Game Object, in that you cannot add it to the display list, and it has no texture.
	 * To render an Ellipse you should look at the capabilities of the Graphics class.
	 *
	 * @class Ellipse
	 * @memberOf Phaser.Geom
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {number} [x=0] - The x position of the center of the ellipse.
	 * @param {number} [y=0] - The y position of the center of the ellipse.
	 * @param {number} [width=0] - The width of the ellipse.
	 * @param {number} [height=0] - The height of the ellipse.
	 */
	var Ellipse = new Class({
	
	    initialize:
	
	    function Ellipse (x, y, width, height)
	    {
	        if (x === undefined) { x = 0; }
	        if (y === undefined) { y = 0; }
	        if (width === undefined) { width = 0; }
	        if (height === undefined) { height = 0; }
	
	        /**
	         * The x position of the center of the ellipse.
	         *
	         * @name Phaser.Geom.Ellipse#x
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.x = x;
	
	        /**
	         * The y position of the center of the ellipse.
	         *
	         * @name Phaser.Geom.Ellipse#y
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.y = y;
	
	        /**
	         * The width of the ellipse.
	         *
	         * @name Phaser.Geom.Ellipse#width
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.width = width;
	
	        /**
	         * The height of the ellipse.
	         *
	         * @name Phaser.Geom.Ellipse#height
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.height = height;
	    },
	
	    /**
	     * Check to see if the Ellipse contains the given x / y coordinates.
	     *
	     * @method Phaser.Geom.Ellipse#contains
	     * @since 3.0.0
	     *
	     * @param {number} x - The x coordinate to check within the ellipse.
	     * @param {number} y - The y coordinate to check within the ellipse.
	     *
	     * @return {boolean} True if the coordinates are within the ellipse, otherwise false.
	     */
	    contains: function (x, y)
	    {
	        return Contains(this, x, y);
	    },
	
	    /**
	     * Returns a Point object containing the coordinates of a point on the circumference of the Ellipse
	     * based on the given angle normalized to the range 0 to 1. I.e. a value of 0.5 will give the point
	     * at 180 degrees around the circle.
	     *
	     * @method Phaser.Geom.Ellipse#getPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Point} O - [out,$return]
	     *
	     * @param {float} position - A value between 0 and 1, where 0 equals 0 degrees, 0.5 equals 180 degrees and 1 equals 360 around the ellipse.
	     * @param {(Phaser.Geom.Point|object)} [out] - An object to store the return values in. If not given a Point object will be created.
	     *
	     * @return {(Phaser.Geom.Point|object)} A Point, or point-like object, containing the coordinates of the point around the ellipse.
	     */
	    getPoint: function (position, point)
	    {
	        return GetPoint(this, position, point);
	    },
	
	    /**
	     * Returns an array of Point objects containing the coordinates of the points around the circumference of the Ellipse,
	     * based on the given quantity or stepRate values.
	     *
	     * @method Phaser.Geom.Ellipse#getPoints
	     * @since 3.0.0
	     *
	     * @param {integer} quantity - The amount of points to return. If a falsey value the quantity will be derived from the `stepRate` instead.
	     * @param {number} [stepRate] - Sets the quantity by getting the circumference of the ellipse and dividing it by the stepRate.
	     * @param {array} [output] - An array to insert the points in to. If not provided a new array will be created.
	     *
	     * @return {Phaser.Geom.Point[]} An array of Point objects pertaining to the points around the circumference of the ellipse.
	     */
	    getPoints: function (quantity, stepRate, output)
	    {
	        return GetPoints(this, quantity, stepRate, output);
	    },
	
	    /**
	     * Returns a uniformly distributed random point from anywhere within the given Ellipse.
	     *
	     * @method Phaser.Geom.Ellipse#getRandomPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Point} O - [point,$return]
	     *
	     * @param {(Phaser.Geom.Point|object)} [point] - A Point or point-like object to set the random `x` and `y` values in.
	     *
	     * @return {(Phaser.Geom.Point|object)} A Point object with the random values set in the `x` and `y` properties.
	     */
	    getRandomPoint: function (point)
	    {
	        return Random(this, point);
	    },
	
	    /**
	     * Sets the x, y, width and height of this ellipse.
	     *
	     * @method Phaser.Geom.Ellipse#setTo
	     * @since 3.0.0
	     *
	     * @param {number} x - The x position of the center of the ellipse.
	     * @param {number} y - The y position of the center of the ellipse.
	     * @param {number} width - The width of the ellipse.
	     * @param {number} height - The height of the ellipse.
	     *
	     * @return {Phaser.Geom.Ellipse} This Ellipse object.
	     */
	    setTo: function (x, y, width, height)
	    {
	        this.x = x;
	        this.y = y;
	        this.width = width;
	        this.height = height;
	
	        return this;
	    },
	
	    /**
	     * Sets this Ellipse to be empty with a width and height of zero.
	     * Does not change its position.
	     *
	     * @method Phaser.Geom.Ellipse#setEmpty
	     * @since 3.0.0
	     *
	     * @return {Phaser.Geom.Ellipse} This Ellipse object.
	     */
	    setEmpty: function ()
	    {
	        this.width = 0;
	        this.height = 0;
	
	        return this;
	    },
	
	    /**
	     * Sets the position of this Ellipse.
	     *
	     * @method Phaser.Geom.Ellipse#setPosition
	     * @since 3.0.0
	     *
	     * @param {number} x - The x position of the center of the ellipse.
	     * @param {number} y - The y position of the center of the ellipse.
	     *
	     * @return {Phaser.Geom.Ellipse} This Ellipse object.
	     */
	    setPosition: function (x, y)
	    {
	        if (y === undefined) { y = x; }
	
	        this.x = x;
	        this.y = y;
	
	        return this;
	    },
	
	    /**
	     * Sets the size of this Ellipse.
	     * Does not change its position.
	     *
	     * @method Phaser.Geom.Ellipse#setSize
	     * @since 3.0.0
	     *
	     * @param {number} width - The width of the ellipse.
	     * @param {number} [height=width] - The height of the ellipse.
	     *
	     * @return {Phaser.Geom.Ellipse} This Ellipse object.
	     */
	    setSize: function (width, height)
	    {
	        if (height === undefined) { height = width; }
	
	        this.width = width;
	        this.height = height;
	
	        return this;
	    },
	
	    /**
	     * Checks to see if the Ellipse is empty: has a width or height equal to zero.
	     *
	     * @method Phaser.Geom.Ellipse#isEmpty
	     * @since 3.0.0
	     *
	     * @return {boolean} True if the Ellipse is empty, otherwise false.
	     */
	    isEmpty: function ()
	    {
	        return (this.width <= 0 || this.height <= 0);
	    },
	
	    /**
	     * Returns the minor radius of the ellipse. Also known as the Semi Minor Axis.
	     *
	     * @method Phaser.Geom.Ellipse#getMinorRadius
	     * @since 3.0.0
	     *
	     * @return {number} The minor radius.
	     */
	    getMinorRadius: function ()
	    {
	        return Math.min(this.width, this.height) / 2;
	    },
	
	    /**
	     * Returns the major radius of the ellipse. Also known as the Semi Major Axis.
	     *
	     * @method Phaser.Geom.Ellipse#getMajorRadius
	     * @since 3.0.0
	     *
	     * @return {number} The major radius.
	     */
	    getMajorRadius: function ()
	    {
	        return Math.max(this.width, this.height) / 2;
	    },
	
	    /**
	     * The left position of the Ellipse.
	     *
	     * @name Phaser.Geom.Ellipse#left
	     * @type {number}
	     * @since 3.0.0
	     */
	    left: {
	
	        get: function ()
	        {
	            return this.x - (this.width / 2);
	        },
	
	        set: function (value)
	        {
	            this.x = value + (this.width / 2);
	        }
	
	    },
	
	    /**
	     * The right position of the Ellipse.
	     *
	     * @name Phaser.Geom.Ellipse#right
	     * @type {number}
	     * @since 3.0.0
	     */
	    right: {
	
	        get: function ()
	        {
	            return this.x + (this.width / 2);
	        },
	
	        set: function (value)
	        {
	            this.x = value - (this.width / 2);
	        }
	
	    },
	
	    /**
	     * The top position of the Ellipse.
	     *
	     * @name Phaser.Geom.Ellipse#top
	     * @type {number}
	     * @since 3.0.0
	     */
	    top: {
	
	        get: function ()
	        {
	            return this.y - (this.height / 2);
	        },
	
	        set: function (value)
	        {
	            this.y = value + (this.height / 2);
	        }
	
	    },
	
	    /**
	     * The bottom position of the Ellipse.
	     *
	     * @name Phaser.Geom.Ellipse#bottom
	     * @type {number}
	     * @since 3.0.0
	     */
	    bottom: {
	
	        get: function ()
	        {
	            return this.y + (this.height / 2);
	        },
	
	        set: function (value)
	        {
	            this.y = value - (this.height / 2);
	        }
	
	    }
	
	});
	
	module.exports = Ellipse;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	
	/**
	 * Returns a uniformly distributed random point from anywhere within the given Ellipse.
	 *
	 * @function Phaser.Geom.Ellipse.Random
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get a random point from.
	 * @param {(Phaser.Geom.Point|object)} [out] - A Point or point-like object to set the random `x` and `y` values in.
	 *
	 * @return {(Phaser.Geom.Point|object)} A Point object with the random values set in the `x` and `y` properties.
	 */
	var Random = function (ellipse, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    var p = Math.random() * Math.PI * 2;
	    var s = Math.sqrt(Math.random());
	
	    out.x = ellipse.x + ((s * Math.cos(p)) * ellipse.width / 2);
	    out.y = ellipse.y + ((s * Math.sin(p)) * ellipse.height / 2);
	
	    return out;
	};
	
	module.exports = Random;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Length = __webpack_require__(162);
	var Point = __webpack_require__(12);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.GetPoints
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point[]} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 * @param {integer} quantity - [description]
	 * @param {integer} [stepRate] - [description]
	 * @param {(array|Phaser.Geom.Point[])} [out] - [description]
	 *
	 * @return {(array|Phaser.Geom.Point[])} [description]
	 */
	var GetPoints = function (line, quantity, stepRate, out)
	{
	    if (out === undefined) { out = []; }
	
	    //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
	    if (!quantity)
	    {
	        quantity = Length(line) / stepRate;
	    }
	
	    var x1 = line.x1;
	    var y1 = line.y1;
	
	    var x2 = line.x2;
	    var y2 = line.y2;
	
	    for (var i = 0; i < quantity; i++)
	    {
	        var position = i / quantity;
	
	        var x = x1 + (x2 - x1) * position;
	        var y = y1 + (y2 - y1) * position;
	
	        out.push(new Point(x, y));
	    }
	
	    return out;
	};
	
	module.exports = GetPoints;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	
	/**
	 * Returns a random point on a given Line.
	 *
	 * @function Phaser.Geom.Line.Random
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Line} line - The Line to calculate the random Point on.
	 * @param {(Phaser.Geom.Point|object)} [out] - An instance of a Point to be modified.
	 *
	 * @return {(Phaser.Geom.Point|object)} A random Point on the Line.
	 */
	var Random = function (line, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    var t = Math.random();
	
	    out.x = line.x1 + t * (line.x2 - line.x1);
	    out.y = line.y1 + t * (line.y2 - line.y1);
	
	    return out;
	};
	
	module.exports = Random;


/***/ }),
/* 292 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.RotateAroundXY
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Line} O - [line,$return]
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 * @param {number} x - [description]
	 * @param {number} y - [description]
	 * @param {number} angle - [description]
	 *
	 * @return {Phaser.Geom.Line} [description]
	 */
	var RotateAroundXY = function (line, x, y, angle)
	{
	    var c = Math.cos(angle);
	    var s = Math.sin(angle);
	
	    var tx = line.x1 - x;
	    var ty = line.y1 - y;
	
	    line.x1 = tx * c - ty * s + x;
	    line.y1 = tx * s + ty * c + y;
	
	    tx = line.x2 - x;
	    ty = line.y2 - y;
	
	    line.x2 = tx * c - ty * s + x;
	    line.y2 = tx * s + ty * c + y;
	
	    return line;
	};
	
	module.exports = RotateAroundXY;


/***/ }),
/* 293 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	// Checks whether the x and y coordinates are contained within this polygon.
	//  Adapted from http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html by Jonas Raoni Soares Silva
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Polygon.Contains
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Polygon} polygon - [description]
	 * @param {number} x - [description]
	 * @param {number} y - [description]
	 *
	 * @return {boolean} [description]
	 */
	var Contains = function (polygon, x, y)
	{
	    var inside = false;
	
	    for (var i = -1, j = polygon.points.length - 1; ++i < polygon.points.length; j = i)
	    {
	        var ix = polygon.points[i].x;
	        var iy = polygon.points[i].y;
	
	        var jx = polygon.points[j].x;
	        var jy = polygon.points[j].y;
	
	        if (((iy <= y && y < jy) || (jy <= y && y < iy)) && (x < (jx - ix) * (y - iy) / (jy - iy) + ix))
	        {
	            inside = !inside;
	        }
	    }
	
	    return inside;
	};
	
	module.exports = Contains;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Rectangle = __webpack_require__(23);
	
	//  points is an array of Point-like objects,
	//  either 2 dimensional arrays, or objects with public x/y properties:
	//  var points = [
	//      [100, 200],
	//      [200, 400],
	//      { x: 30, y: 60 }
	//  ]
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.FromPoints
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
	 *
	 * @param {array} points - [description]
	 * @param {Phaser.Geom.Rectangle} [out] - [description]
	 *
	 * @return {Phaser.Geom.Rectangle} [description]
	 */
	var FromPoints = function (points, out)
	{
	    if (out === undefined) { out = new Rectangle(); }
	
	    if (points.length === 0)
	    {
	        return out;
	    }
	
	    var minX = Number.MAX_VALUE;
	    var minY = Number.MAX_VALUE;
	
	    var maxX = Number.MIN_SAFE_INTEGER;
	    var maxY = Number.MIN_SAFE_INTEGER;
	
	    var p;
	    var px;
	    var py;
	
	    for (var i = 0; i < points.length; i++)
	    {
	        p = points[i];
	
	        if (Array.isArray(p))
	        {
	            px = p[0];
	            py = p[1];
	        }
	        else
	        {
	            px = p.x;
	            py = p.y;
	        }
	
	        minX = Math.min(minX, px);
	        minY = Math.min(minY, py);
	
	        maxX = Math.max(maxX, px);
	        maxY = Math.max(maxY, py);
	    }
	
	    out.x = minX;
	    out.y = minY;
	    out.width = maxX - minX;
	    out.height = maxY - minY;
	
	    return out;
	};
	
	module.exports = FromPoints;


/***/ }),
/* 295 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.GetAspectRatio
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 *
	 * @return {number} [description]
	 */
	var GetAspectRatio = function (rect)
	{
	    return (rect.height === 0) ? NaN : rect.width / rect.height;
	};
	
	module.exports = GetAspectRatio;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Perimeter = __webpack_require__(201);
	var Point = __webpack_require__(12);
	
	/**
	 * Position is a value between 0 and 1 where 0 = the top-left of the rectangle and 0.5 = the bottom right.
	 *
	 * @function Phaser.Geom.Rectangle.GetPoint
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} rectangle - [description]
	 * @param {float} position - [description]
	 * @param {(Phaser.Geom.Point|object)} [out] - [description]
	 *
	 * @return {Phaser.Geom.Point} [description]
	 */
	var GetPoint = function (rectangle, position, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    if (position <= 0 || position >= 1)
	    {
	        out.x = rectangle.x;
	        out.y = rectangle.y;
	
	        return out;
	    }
	
	    var p = Perimeter(rectangle) * position;
	
	    if (position > 0.5)
	    {
	        p -= (rectangle.width + rectangle.height);
	
	        if (p <= rectangle.width)
	        {
	            //  Face 3
	            out.x = rectangle.right - p;
	            out.y = rectangle.bottom;
	        }
	        else
	        {
	            //  Face 4
	            out.x = rectangle.x;
	            out.y = rectangle.bottom - (p - rectangle.width);
	        }
	    }
	    else if (p <= rectangle.width)
	    {
	        //  Face 1
	        out.x = rectangle.x + p;
	        out.y = rectangle.y;
	    }
	    else
	    {
	        //  Face 2
	        out.x = rectangle.right;
	        out.y = rectangle.y + (p - rectangle.width);
	    }
	
	    return out;
	};
	
	module.exports = GetPoint;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.Random
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 * @param {Phaser.Geom.Point} out - [description]
	 *
	 * @return {Phaser.Geom.Point} [description]
	 */
	var Random = function (rect, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    out.x = rect.x + (Math.random() * rect.width);
	    out.y = rect.y + (Math.random() * rect.height);
	
	    return out;
	};
	
	module.exports = Random;


/***/ }),
/* 298 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  http://www.blackpawn.com/texts/pointinpoly/
	
	//  points is an array of Point-like objects with public x/y properties
	//  returns an array containing all points that are within the triangle, or an empty array if none
	//  if 'returnFirst' is true it will return after the first point within the triangle is found
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.ContainsArray
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 * @param {Phaser.Geom.Point[]} points - [description]
	 * @param {boolean} [returnFirst] - [description]
	 * @param {array} [out] - [description]
	 *
	 * @return {Phaser.Geom.Point[]} [description]
	 */
	var ContainsArray = function (triangle, points, returnFirst, out)
	{
	    if (returnFirst === undefined) { returnFirst = false; }
	    if (out === undefined) { out = []; }
	
	    var v0x = triangle.x3 - triangle.x1;
	    var v0y = triangle.y3 - triangle.y1;
	
	    var v1x = triangle.x2 - triangle.x1;
	    var v1y = triangle.y2 - triangle.y1;
	
	    var dot00 = (v0x * v0x) + (v0y * v0y);
	    var dot01 = (v0x * v1x) + (v0y * v1y);
	    var dot11 = (v1x * v1x) + (v1y * v1y);
	
	    // Compute barycentric coordinates
	    var b = ((dot00 * dot11) - (dot01 * dot01));
	    var inv = (b === 0) ? 0 : (1 / b);
	
	    var u;
	    var v;
	    var v2x;
	    var v2y;
	    var dot02;
	    var dot12;
	
	    var x1 = triangle.x1;
	    var y1 = triangle.y1;
	
	    for (var i = 0; i < points.length; i++)
	    {
	        v2x = points[i].x - x1;
	        v2y = points[i].y - y1;
	
	        dot02 = (v0x * v2x) + (v0y * v2y);
	        dot12 = (v1x * v2x) + (v1y * v2y);
	
	        u = ((dot11 * dot02) - (dot01 * dot12)) * inv;
	        v = ((dot00 * dot12) - (dot01 * dot02)) * inv;
	    
	        if (u >= 0 && v >= 0 && (u + v < 1))
	        {
	            out.push({ x: points[i].x, y: points[i].y });
	
	            if (returnFirst)
	            {
	                break;
	            }
	        }
	    }
	
	    return out;
	};
	
	module.exports = ContainsArray;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.Random
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 * @param {Phaser.Geom.Point} [out] - [description]
	 *
	 * @return {Phaser.Geom.Point} [description]
	 */
	var Random = function (triangle, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    //  Basis vectors
	    var ux = triangle.x2 - triangle.x1;
	    var uy = triangle.y2 - triangle.y1;
	
	    var vx = triangle.x3 - triangle.x1;
	    var vy = triangle.y3 - triangle.y1;
	
	    //  Random point within the unit square
	    var r = Math.random();
	    var s = Math.random();
	
	    //  Point outside the triangle? Remap it.
	    if (r + s >= 1)
	    {
	        r = 1 - r;
	        s = 1 - s;
	    }
	
	    out.x = triangle.x1 + ((ux * r) + (vx * s));
	    out.y = triangle.y1 + ((uy * r) + (vy * s));
	
	    return out;
	};
	
	module.exports = Random;


/***/ }),
/* 300 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.RotateAroundXY
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Triangle} O - [triangle,$return]
	 *
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 * @param {number} x - [description]
	 * @param {number} y - [description]
	 * @param {number} angle - [description]
	 *
	 * @return {Phaser.Geom.Triangle} [description]
	 */
	var RotateAroundXY = function (triangle, x, y, angle)
	{
	    var c = Math.cos(angle);
	    var s = Math.sin(angle);
	
	    var tx = triangle.x1 - x;
	    var ty = triangle.y1 - y;
	
	    triangle.x1 = tx * c - ty * s + x;
	    triangle.y1 = tx * s + ty * c + y;
	
	    tx = triangle.x2 - x;
	    ty = triangle.y2 - y;
	
	    triangle.x2 = tx * c - ty * s + x;
	    triangle.y2 = tx * s + ty * c + y;
	
	    tx = triangle.x3 - x;
	    ty = triangle.y3 - y;
	
	    triangle.x3 = tx * c - ty * s + x;
	    triangle.y3 = tx * s + ty * c + y;
	
	    return triangle;
	};
	
	module.exports = RotateAroundXY;


/***/ }),
/* 301 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Keyboard Codes.
	 * 
	 * @name Phaser.Input.Keyboard.KeyCodes
	 * @enum {integer}
	 * @memberOf Phaser.Input.Keyboard
	 * @readOnly
	 * @since 3.0.0
	 */
	
	var KeyCodes = {
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.BACKSPACE
	     */
	    BACKSPACE: 8,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.TAB
	     */
	    TAB: 9,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.ENTER
	     */
	    ENTER: 13,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.SHIFT
	     */
	    SHIFT: 16,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.CTRL
	     */
	    CTRL: 17,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.ALT
	     */
	    ALT: 18,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.PAUSE
	     */
	    PAUSE: 19,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.CAPS_LOCK
	     */
	    CAPS_LOCK: 20,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.ESC
	     */
	    ESC: 27,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.SPACE
	     */
	    SPACE: 32,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.PAGE_UP
	     */
	    PAGE_UP: 33,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.PAGE_DOWN
	     */
	    PAGE_DOWN: 34,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.END
	     */
	    END: 35,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.HOME
	     */
	    HOME: 36,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.LEFT
	     */
	    LEFT: 37,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.UP
	     */
	    UP: 38,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.RIGHT
	     */
	    RIGHT: 39,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.DOWN
	     */
	    DOWN: 40,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.PRINT_SCREEN
	     */
	    PRINT_SCREEN: 42,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.INSERT
	     */
	    INSERT: 45,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.DELETE
	     */
	    DELETE: 46,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.ZERO
	     */
	    ZERO: 48,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.ONE
	     */
	    ONE: 49,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.TWO
	     */
	    TWO: 50,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.THREE
	     */
	    THREE: 51,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.FOUR
	     */
	    FOUR: 52,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.FIVE
	     */
	    FIVE: 53,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.SIX
	     */
	    SIX: 54,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.SEVEN
	     */
	    SEVEN: 55,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.EIGHT
	     */
	    EIGHT: 56,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.NINE
	     */
	    NINE: 57,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_ZERO
	     */
	    NUMPAD_ZERO: 96,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_ONE
	     */
	    NUMPAD_ONE: 97,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_TWO
	     */
	    NUMPAD_TWO: 98,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_THREE
	     */
	    NUMPAD_THREE: 99,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_FOUR
	     */
	    NUMPAD_FOUR: 100,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_FIVE
	     */
	    NUMPAD_FIVE: 101,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_SIX
	     */
	    NUMPAD_SIX: 102,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_SEVEN
	     */
	    NUMPAD_SEVEN: 103,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_EIGHT
	     */
	    NUMPAD_EIGHT: 104,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.NUMPAD_NINE
	     */
	    NUMPAD_NINE: 105,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.A
	     */
	    A: 65,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.B
	     */
	    B: 66,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.C
	     */
	    C: 67,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.D
	     */
	    D: 68,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.E
	     */
	    E: 69,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.F
	     */
	    F: 70,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.G
	     */
	    G: 71,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.H
	     */
	    H: 72,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.I
	     */
	    I: 73,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.J
	     */
	    J: 74,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.K
	     */
	    K: 75,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.L
	     */
	    L: 76,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.M
	     */
	    M: 77,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.N
	     */
	    N: 78,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.O
	     */
	    O: 79,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.P
	     */
	    P: 80,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.Q
	     */
	    Q: 81,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.R
	     */
	    R: 82,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.S
	     */
	    S: 83,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.T
	     */
	    T: 84,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.U
	     */
	    U: 85,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.V
	     */
	    V: 86,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.W
	     */
	    W: 87,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.X
	     */
	    X: 88,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.Y
	     */
	    Y: 89,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.Z
	     */
	    Z: 90,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.F1
	     */
	    F1: 112,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.F2
	     */
	    F2: 113,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.F3
	     */
	    F3: 114,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.F4
	     */
	    F4: 115,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.F5
	     */
	    F5: 116,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.F6
	     */
	    F6: 117,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.F7
	     */
	    F7: 118,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.F8
	     */
	    F8: 119,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.F9
	     */
	    F9: 120,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.F10
	     */
	    F10: 121,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.F11
	     */
	    F11: 122,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.F12
	     */
	    F12: 123,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.SEMICOLON
	     */
	    SEMICOLON: 186,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.PLUS
	     */
	    PLUS: 187,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.COMMA
	     */
	    COMMA: 188,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.MINUS
	     */
	    MINUS: 189,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.PERIOD
	     */
	    PERIOD: 190,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.FORWARD_SLASH
	     */
	    FORWARD_SLASH: 191,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.BACK_SLASH
	     */
	    BACK_SLASH: 220,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.QUOTES
	     */
	    QUOTES: 222,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.BACKTICK
	     */
	    BACKTICK: 192,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.OPEN_BRACKET
	     */
	    OPEN_BRACKET: 219,
	
	    /**
	     * @name Phaser.Input.Keyboard.KeyCodes.CLOSED_BRACKET
	     */
	    CLOSED_BRACKET: 221
	
	};
	
	module.exports = KeyCodes;


/***/ }),
/* 302 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Given a File and a baseURL value this returns the URL the File will use to download from.
	 *
	 * @function Phaser.Loader.GetURL
	 * @since 3.0.0
	 *
	 * @param {Phaser.Loader.File} file - The File object.
	 * @param {string} baseURL - A default base URL.
	 *
	 * @return {string} The URL the File will use.
	 */
	var GetURL = function (file, baseURL)
	{
	    if (!file.url)
	    {
	        return false;
	    }
	
	    if (file.url.match(/^(?:blob:|data:|http:\/\/|https:\/\/|\/\/)/))
	    {
	        return file.url;
	    }
	    else
	    {
	        return baseURL + file.url;
	    }
	};
	
	module.exports = GetURL;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Extend = __webpack_require__(36);
	var XHRSettings = __webpack_require__(202);
	
	/**
	 * Takes two XHRSettings Objects and creates a new XHRSettings object from them.
	 *
	 * The new object is seeded by the values given in the global settings, but any setting in
	 * the local object overrides the global ones.
	 *
	 * @function Phaser.Loader.MergeXHRSettings
	 * @since 3.0.0
	 *
	 * @param {XHRSettingsObject} global - The global XHRSettings object.
	 * @param {XHRSettingsObject} local - The local XHRSettings object.
	 *
	 * @return {XHRSettingsObject} A newly formed XHRSettings object.
	 */
	var MergeXHRSettings = function (global, local)
	{
	    var output = (global === undefined) ? XHRSettings() : Extend({}, global);
	
	    if (local)
	    {
	        for (var setting in local)
	        {
	            if (local[setting] !== undefined)
	            {
	                output[setting] = local[setting];
	            }
	        }
	    }
	
	    return output;
	};
	
	module.exports = MergeXHRSettings;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(35);
	var File = __webpack_require__(44);
	var FileTypesManager = __webpack_require__(15);
	var GetFastValue = __webpack_require__(3);
	var IsPlainObject = __webpack_require__(17);
	var ParseXML = __webpack_require__(485);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.XMLFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within both the Loader and the Text Cache.
	 * @property {string} [url] - The absolute or relative URL to load the file from.
	 * @property {string} [extension='xml'] - The default file extension to use if no url is provided.
	 * @property {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	
	/**
	 * @classdesc
	 * A single XML File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#xml method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#xml.
	 *
	 * @class XMLFile
	 * @extends Phaser.Loader.File
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.XMLFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
	 * @param {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	var XMLFile = new Class({
	
	    Extends: File,
	
	    initialize:
	
	    function XMLFile (loader, key, url, xhrSettings)
	    {
	        var extension = 'xml';
	
	        if (IsPlainObject(key))
	        {
	            var config = key;
	
	            key = GetFastValue(config, 'key');
	            url = GetFastValue(config, 'url');
	            xhrSettings = GetFastValue(config, 'xhrSettings');
	            extension = GetFastValue(config, 'extension', extension);
	        }
	
	        var fileConfig = {
	            type: 'xml',
	            cache: loader.cacheManager.xml,
	            extension: extension,
	            responseType: 'text',
	            key: key,
	            url: url,
	            xhrSettings: xhrSettings
	        };
	
	        File.call(this, loader, fileConfig);
	    },
	
	    /**
	     * Called automatically by Loader.nextFile.
	     * This method controls what extra work this File does with its loaded data.
	     *
	     * @method Phaser.Loader.FileTypes.XMLFile#onProcess
	     * @since 3.7.0
	     */
	    onProcess: function ()
	    {
	        this.state = CONST.FILE_PROCESSING;
	
	        this.data = ParseXML(this.xhrLoader.responseText);
	
	        if (this.data)
	        {
	            this.onProcessComplete();
	        }
	        else
	        {
	            console.warn('Invalid XMLFile: ' + this.key);
	            
	            this.onProcessError();
	        }
	    }
	
	});
	
	/**
	 * Adds an XML file, or array of XML files, to the current load queue.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.xml('wavedata', 'files/AlienWaveData.xml');
	 * }
	 * ```
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 * 
	 * The key must be a unique String. It is used to add the file to the global XML Cache upon a successful load.
	 * The key should be unique both in terms of files being loaded and files already present in the XML Cache.
	 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
	 * then remove it from the XML Cache first, before loading a new one.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.xml({
	 *     key: 'wavedata',
	 *     url: 'files/AlienWaveData.xml'
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.XMLFileConfig` for more details.
	 *
	 * Once the file has finished loading you can access it from its Cache using its key:
	 * 
	 * ```javascript
	 * this.load.xml('wavedata', 'files/AlienWaveData.xml');
	 * // and later in your game ...
	 * var data = this.cache.xml.get('wavedata');
	 * ```
	 *
	 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
	 * key. For example, if the prefix was `LEVEL1.` and the key was `Waves` the final key will be `LEVEL1.Waves` and
	 * this is what you would use to retrieve the text from the XML Cache.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "data"
	 * and no URL is given then the Loader will set the URL to be "data.xml". It will always add `.xml` as the extension, although
	 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
	 *
	 * Note: The ability to load this type of file will only be available if the XML File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#xml
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.0.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.XMLFileConfig|Phaser.Loader.FileTypes.XMLFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
	 * @param {XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('xml', function (key, url, xhrSettings)
	{
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
	            this.addFile(new XMLFile(this, key[i]));
	        }
	    }
	    else
	    {
	        this.addFile(new XMLFile(this, key, url, xhrSettings));
	    }
	
	    return this;
	});
	
	module.exports = XMLFile;


/***/ }),
/* 305 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.CatmullRom
	 * @since 3.0.0
	 *
	 * @param {number} t - [description]
	 * @param {number} p0 - [description]
	 * @param {number} p1 - [description]
	 * @param {number} p2 - [description]
	 * @param {number} p3 - [description]
	 *
	 * @return {number} [description]
	 */
	var CatmullRom = function (t, p0, p1, p2, p3)
	{
	    var v0 = (p2 - p0) * 0.5;
	    var v1 = (p3 - p1) * 0.5;
	    var t2 = t * t;
	    var t3 = t * t2;
	
	    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
	};
	
	module.exports = CatmullRom;


/***/ }),
/* 306 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Calculates a linear (interpolation) value over t.
	 *
	 * @function Phaser.Math.Linear
	 * @since 3.0.0
	 *
	 * @param {number} p0 - The first point
	 * @param {number} p1 - The second point
	 * @param {float} t -The percentage between p0 and p1 to return represented as a number between 0 and 1.
	 *
	 * @return {number} The step t% of the way between p0 and p1
	 */
	var Linear = function (p0, p1, t)
	{
	    return (p1 - p0) * t + p0;
	};
	
	module.exports = Linear;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
	//  and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
	
	var Class = __webpack_require__(1);
	
	var EPSILON = 0.000001;
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class Matrix4
	 * @memberOf Phaser.Math
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Math.Matrix4} [m] - [description]
	 */
	var Matrix4 = new Class({
	
	    initialize:
	
	    function Matrix4 (m)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Math.Matrix4#val
	         * @type {Float32Array}
	         * @since 3.0.0
	         */
	        this.val = new Float32Array(16);
	
	        if (m)
	        {
	            //  Assume Matrix4 with val:
	            this.copy(m);
	        }
	        else
	        {
	            //  Default to identity
	            this.identity();
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#clone
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Matrix4} A new Matrix4 object.
	     */
	    clone: function ()
	    {
	        return new Matrix4(this);
	    },
	
	    //  TODO - Should work with basic values
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#set
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Matrix4} src - [description]
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    set: function (src)
	    {
	        return this.copy(src);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#copy
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Matrix4} src - [description]
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    copy: function (src)
	    {
	        var out = this.val;
	        var a = src.val;
	
	        out[0] = a[0];
	        out[1] = a[1];
	        out[2] = a[2];
	        out[3] = a[3];
	        out[4] = a[4];
	        out[5] = a[5];
	        out[6] = a[6];
	        out[7] = a[7];
	        out[8] = a[8];
	        out[9] = a[9];
	        out[10] = a[10];
	        out[11] = a[11];
	        out[12] = a[12];
	        out[13] = a[13];
	        out[14] = a[14];
	        out[15] = a[15];
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#fromArray
	     * @since 3.0.0
	     *
	     * @param {array} a - [description]
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    fromArray: function (a)
	    {
	        var out = this.val;
	
	        out[0] = a[0];
	        out[1] = a[1];
	        out[2] = a[2];
	        out[3] = a[3];
	        out[4] = a[4];
	        out[5] = a[5];
	        out[6] = a[6];
	        out[7] = a[7];
	        out[8] = a[8];
	        out[9] = a[9];
	        out[10] = a[10];
	        out[11] = a[11];
	        out[12] = a[12];
	        out[13] = a[13];
	        out[14] = a[14];
	        out[15] = a[15];
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#zero
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    zero: function ()
	    {
	        var out = this.val;
	
	        out[0] = 0;
	        out[1] = 0;
	        out[2] = 0;
	        out[3] = 0;
	        out[4] = 0;
	        out[5] = 0;
	        out[6] = 0;
	        out[7] = 0;
	        out[8] = 0;
	        out[9] = 0;
	        out[10] = 0;
	        out[11] = 0;
	        out[12] = 0;
	        out[13] = 0;
	        out[14] = 0;
	        out[15] = 0;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#xyz
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} z - [description]
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    xyz: function (x, y, z)
	    {
	        this.identity();
	
	        var out = this.val;
	
	        out[12] = x;
	        out[13] = y;
	        out[14] = z;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#scaling
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} z - [description]
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    scaling: function (x, y, z)
	    {
	        this.zero();
	
	        var out = this.val;
	
	        out[0] = x;
	        out[5] = y;
	        out[10] = z;
	        out[15] = 1;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#identity
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    identity: function ()
	    {
	        var out = this.val;
	
	        out[0] = 1;
	        out[1] = 0;
	        out[2] = 0;
	        out[3] = 0;
	        out[4] = 0;
	        out[5] = 1;
	        out[6] = 0;
	        out[7] = 0;
	        out[8] = 0;
	        out[9] = 0;
	        out[10] = 1;
	        out[11] = 0;
	        out[12] = 0;
	        out[13] = 0;
	        out[14] = 0;
	        out[15] = 1;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#transpose
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    transpose: function ()
	    {
	        var a = this.val;
	
	        var a01 = a[1];
	        var a02 = a[2];
	        var a03 = a[3];
	        var a12 = a[6];
	        var a13 = a[7];
	        var a23 = a[11];
	
	        a[1] = a[4];
	        a[2] = a[8];
	        a[3] = a[12];
	        a[4] = a01;
	        a[6] = a[9];
	        a[7] = a[13];
	        a[8] = a02;
	        a[9] = a12;
	        a[11] = a[14];
	        a[12] = a03;
	        a[13] = a13;
	        a[14] = a23;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#invert
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    invert: function ()
	    {
	        var a = this.val;
	
	        var a00 = a[0];
	        var a01 = a[1];
	        var a02 = a[2];
	        var a03 = a[3];
	
	        var a10 = a[4];
	        var a11 = a[5];
	        var a12 = a[6];
	        var a13 = a[7];
	
	        var a20 = a[8];
	        var a21 = a[9];
	        var a22 = a[10];
	        var a23 = a[11];
	
	        var a30 = a[12];
	        var a31 = a[13];
	        var a32 = a[14];
	        var a33 = a[15];
	
	        var b00 = a00 * a11 - a01 * a10;
	        var b01 = a00 * a12 - a02 * a10;
	        var b02 = a00 * a13 - a03 * a10;
	        var b03 = a01 * a12 - a02 * a11;
	
	        var b04 = a01 * a13 - a03 * a11;
	        var b05 = a02 * a13 - a03 * a12;
	        var b06 = a20 * a31 - a21 * a30;
	        var b07 = a20 * a32 - a22 * a30;
	
	        var b08 = a20 * a33 - a23 * a30;
	        var b09 = a21 * a32 - a22 * a31;
	        var b10 = a21 * a33 - a23 * a31;
	        var b11 = a22 * a33 - a23 * a32;
	
	        // Calculate the determinant
	        var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
	
	        if (!det)
	        {
	            return null;
	        }
	
	        det = 1 / det;
	
	        a[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
	        a[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
	        a[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
	        a[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
	        a[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
	        a[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
	        a[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
	        a[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
	        a[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
	        a[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
	        a[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
	        a[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
	        a[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
	        a[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
	        a[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
	        a[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#adjoint
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    adjoint: function ()
	    {
	        var a = this.val;
	
	        var a00 = a[0];
	        var a01 = a[1];
	        var a02 = a[2];
	        var a03 = a[3];
	
	        var a10 = a[4];
	        var a11 = a[5];
	        var a12 = a[6];
	        var a13 = a[7];
	
	        var a20 = a[8];
	        var a21 = a[9];
	        var a22 = a[10];
	        var a23 = a[11];
	
	        var a30 = a[12];
	        var a31 = a[13];
	        var a32 = a[14];
	        var a33 = a[15];
	
	        a[0] = (a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22));
	        a[1] = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
	        a[2] = (a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12));
	        a[3] = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
	        a[4] = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
	        a[5] = (a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22));
	        a[6] = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
	        a[7] = (a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12));
	        a[8] = (a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21));
	        a[9] = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
	        a[10] = (a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11));
	        a[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
	        a[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
	        a[13] = (a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21));
	        a[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
	        a[15] = (a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11));
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#determinant
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    determinant: function ()
	    {
	        var a = this.val;
	
	        var a00 = a[0];
	        var a01 = a[1];
	        var a02 = a[2];
	        var a03 = a[3];
	
	        var a10 = a[4];
	        var a11 = a[5];
	        var a12 = a[6];
	        var a13 = a[7];
	
	        var a20 = a[8];
	        var a21 = a[9];
	        var a22 = a[10];
	        var a23 = a[11];
	
	        var a30 = a[12];
	        var a31 = a[13];
	        var a32 = a[14];
	        var a33 = a[15];
	
	        var b00 = a00 * a11 - a01 * a10;
	        var b01 = a00 * a12 - a02 * a10;
	        var b02 = a00 * a13 - a03 * a10;
	        var b03 = a01 * a12 - a02 * a11;
	        var b04 = a01 * a13 - a03 * a11;
	        var b05 = a02 * a13 - a03 * a12;
	        var b06 = a20 * a31 - a21 * a30;
	        var b07 = a20 * a32 - a22 * a30;
	        var b08 = a20 * a33 - a23 * a30;
	        var b09 = a21 * a32 - a22 * a31;
	        var b10 = a21 * a33 - a23 * a31;
	        var b11 = a22 * a33 - a23 * a32;
	
	        // Calculate the determinant
	        return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#multiply
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Matrix4} src - [description]
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    multiply: function (src)
	    {
	        var a = this.val;
	
	        var a00 = a[0];
	        var a01 = a[1];
	        var a02 = a[2];
	        var a03 = a[3];
	
	        var a10 = a[4];
	        var a11 = a[5];
	        var a12 = a[6];
	        var a13 = a[7];
	
	        var a20 = a[8];
	        var a21 = a[9];
	        var a22 = a[10];
	        var a23 = a[11];
	
	        var a30 = a[12];
	        var a31 = a[13];
	        var a32 = a[14];
	        var a33 = a[15];
	
	        var b = src.val;
	
	        // Cache only the current line of the second matrix
	        var b0 = b[0];
	        var b1 = b[1];
	        var b2 = b[2];
	        var b3 = b[3];
	
	        a[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
	        a[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
	        a[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
	        a[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
	
	        b0 = b[4];
	        b1 = b[5];
	        b2 = b[6];
	        b3 = b[7];
	
	        a[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
	        a[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
	        a[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
	        a[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
	
	        b0 = b[8];
	        b1 = b[9];
	        b2 = b[10];
	        b3 = b[11];
	
	        a[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
	        a[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
	        a[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
	        a[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
	
	        b0 = b[12];
	        b1 = b[13];
	        b2 = b[14];
	        b3 = b[15];
	
	        a[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
	        a[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
	        a[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
	        a[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#multiplyLocal
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Matrix4} src - [description]
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    multiplyLocal: function (src)
	    {
	        var a = [];
	        var m1 = this.val;
	        var m2 = src.val;
	
	        a[0] = m1[0] * m2[0] + m1[1] * m2[4] + m1[2] * m2[8] + m1[3] * m2[12];
	        a[1] = m1[0] * m2[1] + m1[1] * m2[5] + m1[2] * m2[9] + m1[3] * m2[13];
	        a[2] = m1[0] * m2[2] + m1[1] * m2[6] + m1[2] * m2[10] + m1[3] * m2[14];
	        a[3] = m1[0] * m2[3] + m1[1] * m2[7] + m1[2] * m2[11] + m1[3] * m2[15];
	
	        a[4] = m1[4] * m2[0] + m1[5] * m2[4] + m1[6] * m2[8] + m1[7] * m2[12];
	        a[5] = m1[4] * m2[1] + m1[5] * m2[5] + m1[6] * m2[9] + m1[7] * m2[13];
	        a[6] = m1[4] * m2[2] + m1[5] * m2[6] + m1[6] * m2[10] + m1[7] * m2[14];
	        a[7] = m1[4] * m2[3] + m1[5] * m2[7] + m1[6] * m2[11] + m1[7] * m2[15];
	
	        a[8] = m1[8] * m2[0] + m1[9] * m2[4] + m1[10] * m2[8] + m1[11] * m2[12];
	        a[9] = m1[8] * m2[1] + m1[9] * m2[5] + m1[10] * m2[9] + m1[11] * m2[13];
	        a[10] = m1[8] * m2[2] + m1[9] * m2[6] + m1[10] * m2[10] + m1[11] * m2[14];
	        a[11] = m1[8] * m2[3] + m1[9] * m2[7] + m1[10] * m2[11] + m1[11] * m2[15];
	
	        a[12] = m1[12] * m2[0] + m1[13] * m2[4] + m1[14] * m2[8] + m1[15] * m2[12];
	        a[13] = m1[12] * m2[1] + m1[13] * m2[5] + m1[14] * m2[9] + m1[15] * m2[13];
	        a[14] = m1[12] * m2[2] + m1[13] * m2[6] + m1[14] * m2[10] + m1[15] * m2[14];
	        a[15] = m1[12] * m2[3] + m1[13] * m2[7] + m1[14] * m2[11] + m1[15] * m2[15];
	
	        return this.fromArray(a);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#translate
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Vector3|Phaser.Math.Vector4)} v - [description]
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    translate: function (v)
	    {
	        var x = v.x;
	        var y = v.y;
	        var z = v.z;
	        var a = this.val;
	
	        a[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
	        a[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
	        a[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
	        a[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#scale
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Vector3|Phaser.Math.Vector4)} v - [description]
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    scale: function (v)
	    {
	        var x = v.x;
	        var y = v.y;
	        var z = v.z;
	        var a = this.val;
	
	        a[0] = a[0] * x;
	        a[1] = a[1] * x;
	        a[2] = a[2] * x;
	        a[3] = a[3] * x;
	
	        a[4] = a[4] * y;
	        a[5] = a[5] * y;
	        a[6] = a[6] * y;
	        a[7] = a[7] * y;
	
	        a[8] = a[8] * z;
	        a[9] = a[9] * z;
	        a[10] = a[10] * z;
	        a[11] = a[11] * z;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#makeRotationAxis
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Vector3|Phaser.Math.Vector4)} axis - [description]
	     * @param {float} angle - The angle of rotation in radians.
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    makeRotationAxis: function (axis, angle)
	    {
	        // Based on http://www.gamedev.net/reference/articles/article1199.asp
	
	        var c = Math.cos(angle);
	        var s = Math.sin(angle);
	        var t = 1 - c;
	        var x = axis.x;
	        var y = axis.y;
	        var z = axis.z;
	        var tx = t * x;
	        var ty = t * y;
	
	        this.set(
	            tx * x + c, tx * y - s * z, tx * z + s * y, 0,
	            tx * y + s * z, ty * y + c, ty * z - s * x, 0,
	            tx * z - s * y, ty * z + s * x, t * z * z + c, 0,
	            0, 0, 0, 1
	        );
	
	        return this;
	    },
	
	    //  aka rotationAxis
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#rotate
	     * @since 3.0.0
	     *
	     * @param {float} rad - [description]
	     * @param {Phaser.Math.Vector3} axis - [description]
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    rotate: function (rad, axis)
	    {
	        var a = this.val;
	        var x = axis.x;
	        var y = axis.y;
	        var z = axis.z;
	        var len = Math.sqrt(x * x + y * y + z * z);
	
	        if (Math.abs(len) < EPSILON)
	        {
	            return null;
	        }
	
	        len = 1 / len;
	        x *= len;
	        y *= len;
	        z *= len;
	
	        var s = Math.sin(rad);
	        var c = Math.cos(rad);
	        var t = 1 - c;
	
	        var a00 = a[0];
	        var a01 = a[1];
	        var a02 = a[2];
	        var a03 = a[3];
	
	        var a10 = a[4];
	        var a11 = a[5];
	        var a12 = a[6];
	        var a13 = a[7];
	
	        var a20 = a[8];
	        var a21 = a[9];
	        var a22 = a[10];
	        var a23 = a[11];
	
	        // Construct the elements of the rotation matrix
	        var b00 = x * x * t + c;
	        var b01 = y * x * t + z * s;
	        var b02 = z * x * t - y * s;
	
	        var b10 = x * y * t - z * s;
	        var b11 = y * y * t + c;
	        var b12 = z * y * t + x * s;
	
	        var b20 = x * z * t + y * s;
	        var b21 = y * z * t - x * s;
	        var b22 = z * z * t + c;
	
	        // Perform rotation-specific matrix multiplication
	        a[0] = a00 * b00 + a10 * b01 + a20 * b02;
	        a[1] = a01 * b00 + a11 * b01 + a21 * b02;
	        a[2] = a02 * b00 + a12 * b01 + a22 * b02;
	        a[3] = a03 * b00 + a13 * b01 + a23 * b02;
	        a[4] = a00 * b10 + a10 * b11 + a20 * b12;
	        a[5] = a01 * b10 + a11 * b11 + a21 * b12;
	        a[6] = a02 * b10 + a12 * b11 + a22 * b12;
	        a[7] = a03 * b10 + a13 * b11 + a23 * b12;
	        a[8] = a00 * b20 + a10 * b21 + a20 * b22;
	        a[9] = a01 * b20 + a11 * b21 + a21 * b22;
	        a[10] = a02 * b20 + a12 * b21 + a22 * b22;
	        a[11] = a03 * b20 + a13 * b21 + a23 * b22;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#rotateX
	     * @since 3.0.0
	     *
	     * @param {float} rad - [description]
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    rotateX: function (rad)
	    {
	        var a = this.val;
	        var s = Math.sin(rad);
	        var c = Math.cos(rad);
	
	        var a10 = a[4];
	        var a11 = a[5];
	        var a12 = a[6];
	        var a13 = a[7];
	
	        var a20 = a[8];
	        var a21 = a[9];
	        var a22 = a[10];
	        var a23 = a[11];
	
	        // Perform axis-specific matrix multiplication
	        a[4] = a10 * c + a20 * s;
	        a[5] = a11 * c + a21 * s;
	        a[6] = a12 * c + a22 * s;
	        a[7] = a13 * c + a23 * s;
	        a[8] = a20 * c - a10 * s;
	        a[9] = a21 * c - a11 * s;
	        a[10] = a22 * c - a12 * s;
	        a[11] = a23 * c - a13 * s;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#rotateY
	     * @since 3.0.0
	     *
	     * @param {float} rad - [description]
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    rotateY: function (rad)
	    {
	        var a = this.val;
	        var s = Math.sin(rad);
	        var c = Math.cos(rad);
	
	        var a00 = a[0];
	        var a01 = a[1];
	        var a02 = a[2];
	        var a03 = a[3];
	
	        var a20 = a[8];
	        var a21 = a[9];
	        var a22 = a[10];
	        var a23 = a[11];
	
	        // Perform axis-specific matrix multiplication
	        a[0] = a00 * c - a20 * s;
	        a[1] = a01 * c - a21 * s;
	        a[2] = a02 * c - a22 * s;
	        a[3] = a03 * c - a23 * s;
	        a[8] = a00 * s + a20 * c;
	        a[9] = a01 * s + a21 * c;
	        a[10] = a02 * s + a22 * c;
	        a[11] = a03 * s + a23 * c;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#rotateZ
	     * @since 3.0.0
	     *
	     * @param {float} rad - [description]
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    rotateZ: function (rad)
	    {
	        var a = this.val;
	        var s = Math.sin(rad);
	        var c = Math.cos(rad);
	
	        var a00 = a[0];
	        var a01 = a[1];
	        var a02 = a[2];
	        var a03 = a[3];
	
	        var a10 = a[4];
	        var a11 = a[5];
	        var a12 = a[6];
	        var a13 = a[7];
	
	        // Perform axis-specific matrix multiplication
	        a[0] = a00 * c + a10 * s;
	        a[1] = a01 * c + a11 * s;
	        a[2] = a02 * c + a12 * s;
	        a[3] = a03 * c + a13 * s;
	        a[4] = a10 * c - a00 * s;
	        a[5] = a11 * c - a01 * s;
	        a[6] = a12 * c - a02 * s;
	        a[7] = a13 * c - a03 * s;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#fromRotationTranslation
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Quaternion} q - [description]
	     * @param {Phaser.Math.Vector3} v - [description]
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    fromRotationTranslation: function (q, v)
	    {
	        // Quaternion math
	        var out = this.val;
	
	        var x = q.x;
	        var y = q.y;
	        var z = q.z;
	        var w = q.w;
	
	        var x2 = x + x;
	        var y2 = y + y;
	        var z2 = z + z;
	
	        var xx = x * x2;
	        var xy = x * y2;
	        var xz = x * z2;
	
	        var yy = y * y2;
	        var yz = y * z2;
	        var zz = z * z2;
	
	        var wx = w * x2;
	        var wy = w * y2;
	        var wz = w * z2;
	
	        out[0] = 1 - (yy + zz);
	        out[1] = xy + wz;
	        out[2] = xz - wy;
	        out[3] = 0;
	
	        out[4] = xy - wz;
	        out[5] = 1 - (xx + zz);
	        out[6] = yz + wx;
	        out[7] = 0;
	
	        out[8] = xz + wy;
	        out[9] = yz - wx;
	        out[10] = 1 - (xx + yy);
	        out[11] = 0;
	
	        out[12] = v.x;
	        out[13] = v.y;
	        out[14] = v.z;
	        out[15] = 1;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#fromQuat
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Quaternion} q - [description]
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    fromQuat: function (q)
	    {
	        var out = this.val;
	
	        var x = q.x;
	        var y = q.y;
	        var z = q.z;
	        var w = q.w;
	
	        var x2 = x + x;
	        var y2 = y + y;
	        var z2 = z + z;
	
	        var xx = x * x2;
	        var xy = x * y2;
	        var xz = x * z2;
	
	        var yy = y * y2;
	        var yz = y * z2;
	        var zz = z * z2;
	
	        var wx = w * x2;
	        var wy = w * y2;
	        var wz = w * z2;
	
	        out[0] = 1 - (yy + zz);
	        out[1] = xy + wz;
	        out[2] = xz - wy;
	        out[3] = 0;
	
	        out[4] = xy - wz;
	        out[5] = 1 - (xx + zz);
	        out[6] = yz + wx;
	        out[7] = 0;
	
	        out[8] = xz + wy;
	        out[9] = yz - wx;
	        out[10] = 1 - (xx + yy);
	        out[11] = 0;
	
	        out[12] = 0;
	        out[13] = 0;
	        out[14] = 0;
	        out[15] = 1;
	
	        return this;
	    },
	
	    /**
	     * Generates a frustum matrix with the given bounds.
	     *
	     * @method Phaser.Math.Matrix4#frustum
	     * @since 3.0.0
	     *
	     * @param {number} left - The left bound of the frustum.
	     * @param {number} right - The right bound of the frustum.
	     * @param {number} bottom - The bottom bound of the frustum.
	     * @param {number} top - The top bound of the frustum.
	     * @param {number} near - The near bound of the frustum.
	     * @param {number} far - The far bound of the frustum.
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    frustum: function (left, right, bottom, top, near, far)
	    {
	        var out = this.val;
	
	        var rl = 1 / (right - left);
	        var tb = 1 / (top - bottom);
	        var nf = 1 / (near - far);
	
	        out[0] = (near * 2) * rl;
	        out[1] = 0;
	        out[2] = 0;
	        out[3] = 0;
	
	        out[4] = 0;
	        out[5] = (near * 2) * tb;
	        out[6] = 0;
	        out[7] = 0;
	
	        out[8] = (right + left) * rl;
	        out[9] = (top + bottom) * tb;
	        out[10] = (far + near) * nf;
	        out[11] = -1;
	
	        out[12] = 0;
	        out[13] = 0;
	        out[14] = (far * near * 2) * nf;
	        out[15] = 0;
	
	        return this;
	    },
	
	    /**
	     * Generates a perspective projection matrix with the given bounds.
	     * perspective fov lh
	     *
	     * @method Phaser.Math.Matrix4#perspective
	     * @since 3.0.0
	     *
	     * @param {number} fovy - Vertical field of view in radians
	     * @param {number} aspect - Aspect ratio. Typically viewport width  /height.
	     * @param {number} near - Near bound of the frustum.
	     * @param {number} far - Far bound of the frustum.
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    perspective: function (fovy, aspect, near, far)
	    {
	        var out = this.val;
	        var f = 1.0 / Math.tan(fovy / 2);
	        var nf = 1 / (near - far);
	
	        out[0] = f / aspect;
	        out[1] = 0;
	        out[2] = 0;
	        out[3] = 0;
	
	        out[4] = 0;
	        out[5] = f;
	        out[6] = 0;
	        out[7] = 0;
	
	        out[8] = 0;
	        out[9] = 0;
	        out[10] = (far + near) * nf;
	        out[11] = -1;
	
	        out[12] = 0;
	        out[13] = 0;
	        out[14] = (2 * far * near) * nf;
	        out[15] = 0;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#perspectiveLH
	     * @since 3.0.0
	     *
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     * @param {number} near - Near bound of the frustum.
	     * @param {number} far - Far bound of the frustum.
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    perspectiveLH: function (width, height, near, far)
	    {
	        var out = this.val;
	
	        out[0] = (2 * near) / width;
	        out[1] = 0;
	        out[2] = 0;
	        out[3] = 0;
	
	        out[4] = 0;
	        out[5] = (2 * near) / height;
	        out[6] = 0;
	        out[7] = 0;
	
	        out[8] = 0;
	        out[9] = 0;
	        out[10] = -far / (near - far);
	        out[11] = 1;
	
	        out[12] = 0;
	        out[13] = 0;
	        out[14] = (near * far) / (near - far);
	        out[15] = 0;
	
	        return this;
	    },
	
	    /**
	     * Generates a orthogonal projection matrix with the given bounds.
	     *
	     * @method Phaser.Math.Matrix4#ortho
	     * @since 3.0.0
	     *
	     * @param {number} left - The left bound of the frustum.
	     * @param {number} right - The right bound of the frustum.
	     * @param {number} bottom - The bottom bound of the frustum.
	     * @param {number} top - The top bound of the frustum.
	     * @param {number} near - The near bound of the frustum.
	     * @param {number} far - The far bound of the frustum.
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    ortho: function (left, right, bottom, top, near, far)
	    {
	        var out = this.val;
	        var lr = left - right;
	        var bt = bottom - top;
	        var nf = near - far;
	
	        //  Avoid division by zero
	        lr = (lr === 0) ? lr : 1 / lr;
	        bt = (bt === 0) ? bt : 1 / bt;
	        nf = (nf === 0) ? nf : 1 / nf;
	
	        out[0] = -2 * lr;
	        out[1] = 0;
	        out[2] = 0;
	        out[3] = 0;
	
	        out[4] = 0;
	        out[5] = -2 * bt;
	        out[6] = 0;
	        out[7] = 0;
	
	        out[8] = 0;
	        out[9] = 0;
	        out[10] = 2 * nf;
	        out[11] = 0;
	
	        out[12] = (left + right) * lr;
	        out[13] = (top + bottom) * bt;
	        out[14] = (far + near) * nf;
	        out[15] = 1;
	
	        return this;
	    },
	
	    /**
	     * Generates a look-at matrix with the given eye position, focal point, and up axis.
	     *
	     * @method Phaser.Math.Matrix4#lookAt
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector3} eye - Position of the viewer
	     * @param {Phaser.Math.Vector3} center - Point the viewer is looking at
	     * @param {Phaser.Math.Vector3} up - vec3 pointing up.
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    lookAt: function (eye, center, up)
	    {
	        var out = this.val;
	
	        var eyex = eye.x;
	        var eyey = eye.y;
	        var eyez = eye.z;
	
	        var upx = up.x;
	        var upy = up.y;
	        var upz = up.z;
	
	        var centerx = center.x;
	        var centery = center.y;
	        var centerz = center.z;
	
	        if (Math.abs(eyex - centerx) < EPSILON &&
	            Math.abs(eyey - centery) < EPSILON &&
	            Math.abs(eyez - centerz) < EPSILON)
	        {
	            return this.identity();
	        }
	
	        var z0 = eyex - centerx;
	        var z1 = eyey - centery;
	        var z2 = eyez - centerz;
	
	        var len = 1 / Math.sqrt(z0 * z0 + z1 * z1 + z2 * z2);
	
	        z0 *= len;
	        z1 *= len;
	        z2 *= len;
	
	        var x0 = upy * z2 - upz * z1;
	        var x1 = upz * z0 - upx * z2;
	        var x2 = upx * z1 - upy * z0;
	
	        len = Math.sqrt(x0 * x0 + x1 * x1 + x2 * x2);
	
	        if (!len)
	        {
	            x0 = 0;
	            x1 = 0;
	            x2 = 0;
	        }
	        else
	        {
	            len = 1 / len;
	            x0 *= len;
	            x1 *= len;
	            x2 *= len;
	        }
	
	        var y0 = z1 * x2 - z2 * x1;
	        var y1 = z2 * x0 - z0 * x2;
	        var y2 = z0 * x1 - z1 * x0;
	
	        len = Math.sqrt(y0 * y0 + y1 * y1 + y2 * y2);
	
	        if (!len)
	        {
	            y0 = 0;
	            y1 = 0;
	            y2 = 0;
	        }
	        else
	        {
	            len = 1 / len;
	            y0 *= len;
	            y1 *= len;
	            y2 *= len;
	        }
	
	        out[0] = x0;
	        out[1] = y0;
	        out[2] = z0;
	        out[3] = 0;
	
	        out[4] = x1;
	        out[5] = y1;
	        out[6] = z1;
	        out[7] = 0;
	
	        out[8] = x2;
	        out[9] = y2;
	        out[10] = z2;
	        out[11] = 0;
	
	        out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
	        out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
	        out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
	        out[15] = 1;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#yawPitchRoll
	     * @since 3.0.0
	     *
	     * @param {number} yaw - [description]
	     * @param {number} pitch - [description]
	     * @param {number} roll - [description]
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    yawPitchRoll: function (yaw, pitch, roll)
	    {
	        this.zero();
	        _tempMat1.zero();
	        _tempMat2.zero();
	
	        var m0 = this.val;
	        var m1 = _tempMat1.val;
	        var m2 = _tempMat2.val;
	
	        //  Rotate Z
	        var s = Math.sin(roll);
	        var c = Math.cos(roll);
	
	        m0[10] = 1;
	        m0[15] = 1;
	        m0[0] = c;
	        m0[1] = s;
	        m0[4] = -s;
	        m0[5] = c;
	
	        //  Rotate X
	        s = Math.sin(pitch);
	        c = Math.cos(pitch);
	
	        m1[0] = 1;
	        m1[15] = 1;
	        m1[5] = c;
	        m1[10] = c;
	        m1[9] = -s;
	        m1[6] = s;
	
	        //  Rotate Y
	        s = Math.sin(yaw);
	        c = Math.cos(yaw);
	
	        m2[5] = 1;
	        m2[15] = 1;
	        m2[0] = c;
	        m2[2] = -s;
	        m2[8] = s;
	        m2[10] = c;
	
	        this.multiplyLocal(_tempMat1);
	        this.multiplyLocal(_tempMat2);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix4#setWorldMatrix
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector3} rotation - [description]
	     * @param {Phaser.Math.Vector3} position - [description]
	     * @param {Phaser.Math.Vector3} scale - [description]
	     * @param {Phaser.Math.Matrix4} [viewMatrix] - [description]
	     * @param {Phaser.Math.Matrix4} [projectionMatrix] - [description]
	     *
	     * @return {Phaser.Math.Matrix4} This Matrix4 object.
	     */
	    setWorldMatrix: function (rotation, position, scale, viewMatrix, projectionMatrix)
	    {
	        this.yawPitchRoll(rotation.y, rotation.x, rotation.z);
	
	        _tempMat1.scaling(scale.x, scale.y, scale.z);
	        _tempMat2.xyz(position.x, position.y, position.z);
	
	        this.multiplyLocal(_tempMat1);
	        this.multiplyLocal(_tempMat2);
	
	        if (viewMatrix !== undefined)
	        {
	            this.multiplyLocal(viewMatrix);
	        }
	
	        if (projectionMatrix !== undefined)
	        {
	            this.multiplyLocal(projectionMatrix);
	        }
	
	        return this;
	    }
	
	});
	
	var _tempMat1 = new Matrix4();
	var _tempMat2 = new Matrix4();
	
	module.exports = Matrix4;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CONST = __webpack_require__(33);
	
	/**
	 * Convert the given angle in radians, to the equivalent angle in degrees.
	 *
	 * @function Phaser.Math.RadToDeg
	 * @since 3.0.0
	 *
	 * @param {float} radians - The angle in radians to convert ot degrees.
	 *
	 * @return {integer} The given angle converted to degrees.
	 */
	var RadToDeg = function (radians)
	{
	    return radians * CONST.RAD_TO_DEG;
	};
	
	module.exports = RadToDeg;


/***/ }),
/* 309 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.RotateAroundDistance
	 * @since 3.0.0
	 *
	 * @param {(Phaser.Geom.Point|object)} point - The Point to be rotated.
	 * @param {number} x - The horizontal coordinate to rotate around.
	 * @param {number} y - The vertical coordinate to rotate around.
	 * @param {number} angle - The angle of rotation in radians.
	 * @param {number} distance - [description]
	 *
	 * @return {Phaser.Geom.Point} [description]
	 */
	var RotateAroundDistance = function (point, x, y, angle, distance)
	{
	    var t = angle + Math.atan2(point.y - y, point.x - x);
	
	    point.x = x + (distance * Math.cos(t));
	    point.y = y + (distance * Math.sin(t));
	
	    return point;
	};
	
	module.exports = RotateAroundDistance;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
	//  and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
	
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class Vector4
	 * @memberOf Phaser.Math
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {number} [x] - [description]
	 * @param {number} [y] - [description]
	 * @param {number} [z] - [description]
	 * @param {number} [w] - [description]
	 */
	var Vector4 = new Class({
	
	    initialize:
	
	    function Vector4 (x, y, z, w)
	    {
	        /**
	         * The x component of this Vector.
	         *
	         * @name Phaser.Math.Vector4#x
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	
	        /**
	         * The y component of this Vector.
	         *
	         * @name Phaser.Math.Vector4#y
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	
	        /**
	         * The z component of this Vector.
	         *
	         * @name Phaser.Math.Vector4#z
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	
	        /**
	         * The w component of this Vector.
	         *
	         * @name Phaser.Math.Vector4#w
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	
	        if (typeof x === 'object')
	        {
	            this.x = x.x || 0;
	            this.y = x.y || 0;
	            this.z = x.z || 0;
	            this.w = x.w || 0;
	        }
	        else
	        {
	            this.x = x || 0;
	            this.y = y || 0;
	            this.z = z || 0;
	            this.w = w || 0;
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector4#clone
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Vector4} [description]
	     */
	    clone: function ()
	    {
	        return new Vector4(this.x, this.y, this.z, this.w);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector4#copy
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector4} src - [description]
	     *
	     * @return {Phaser.Math.Vector4} This Vector4 object.
	     */
	    copy: function (src)
	    {
	        this.x = src.x;
	        this.y = src.y;
	        this.z = src.z || 0;
	        this.w = src.w || 0;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector4#equals
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector4} v - [description]
	     *
	     * @return {boolean} [description]
	     */
	    equals: function (v)
	    {
	        return ((this.x === v.x) && (this.y === v.y) && (this.z === v.z) && (this.w === v.w));
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector4#set
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} z - [description]
	     * @param {number} w - [description]
	     *
	     * @return {Phaser.Math.Vector4} This Vector4 object.
	     */
	    set: function (x, y, z, w)
	    {
	        if (typeof x === 'object')
	        {
	            this.x = x.x || 0;
	            this.y = x.y || 0;
	            this.z = x.z || 0;
	            this.w = x.w || 0;
	        }
	        else
	        {
	            this.x = x || 0;
	            this.y = y || 0;
	            this.z = z || 0;
	            this.w = w || 0;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector4#add
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - [description]
	     *
	     * @return {Phaser.Math.Vector4} This Vector4 object.
	     */
	    add: function (v)
	    {
	        this.x += v.x;
	        this.y += v.y;
	        this.z += v.z || 0;
	        this.w += v.w || 0;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector4#subtract
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - [description]
	     *
	     * @return {Phaser.Math.Vector4} This Vector4 object.
	     */
	    subtract: function (v)
	    {
	        this.x -= v.x;
	        this.y -= v.y;
	        this.z -= v.z || 0;
	        this.w -= v.w || 0;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector4#scale
	     * @since 3.0.0
	     *
	     * @param {number} scale - [description]
	     *
	     * @return {Phaser.Math.Vector4} This Vector4 object.
	     */
	    scale: function (scale)
	    {
	        this.x *= scale;
	        this.y *= scale;
	        this.z *= scale;
	        this.w *= scale;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector4#length
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    length: function ()
	    {
	        var x = this.x;
	        var y = this.y;
	        var z = this.z;
	        var w = this.w;
	
	        return Math.sqrt(x * x + y * y + z * z + w * w);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector4#lengthSq
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    lengthSq: function ()
	    {
	        var x = this.x;
	        var y = this.y;
	        var z = this.z;
	        var w = this.w;
	
	        return x * x + y * y + z * z + w * w;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector4#normalize
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Vector4} This Vector4 object.
	     */
	    normalize: function ()
	    {
	        var x = this.x;
	        var y = this.y;
	        var z = this.z;
	        var w = this.w;
	        var len = x * x + y * y + z * z + w * w;
	
	        if (len > 0)
	        {
	            len = 1 / Math.sqrt(len);
	
	            this.x = x * len;
	            this.y = y * len;
	            this.z = z * len;
	            this.w = w * len;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector4#dot
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector4} v - [description]
	     *
	     * @return {number} [description]
	     */
	    dot: function (v)
	    {
	        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector4#lerp
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector4} v - [description]
	     * @param {number} [t=0] - [description]
	     *
	     * @return {Phaser.Math.Vector4} This Vector4 object.
	     */
	    lerp: function (v, t)
	    {
	        if (t === undefined) { t = 0; }
	
	        var ax = this.x;
	        var ay = this.y;
	        var az = this.z;
	        var aw = this.w;
	
	        this.x = ax + t * (v.x - ax);
	        this.y = ay + t * (v.y - ay);
	        this.z = az + t * (v.z - az);
	        this.w = aw + t * (v.w - aw);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector4#multiply
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - [description]
	     *
	     * @return {Phaser.Math.Vector4} This Vector4 object.
	     */
	    multiply: function (v)
	    {
	        this.x *= v.x;
	        this.y *= v.y;
	        this.z *= v.z || 1;
	        this.w *= v.w || 1;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector4#divide
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - [description]
	     *
	     * @return {Phaser.Math.Vector4} This Vector4 object.
	     */
	    divide: function (v)
	    {
	        this.x /= v.x;
	        this.y /= v.y;
	        this.z /= v.z || 1;
	        this.w /= v.w || 1;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector4#distance
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - [description]
	     *
	     * @return {number} [description]
	     */
	    distance: function (v)
	    {
	        var dx = v.x - this.x;
	        var dy = v.y - this.y;
	        var dz = v.z - this.z || 0;
	        var dw = v.w - this.w || 0;
	
	        return Math.sqrt(dx * dx + dy * dy + dz * dz + dw * dw);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector4#distanceSq
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - [description]
	     *
	     * @return {number} [description]
	     */
	    distanceSq: function (v)
	    {
	        var dx = v.x - this.x;
	        var dy = v.y - this.y;
	        var dz = v.z - this.z || 0;
	        var dw = v.w - this.w || 0;
	
	        return dx * dx + dy * dy + dz * dz + dw * dw;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector4#negate
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Vector4} This Vector4 object.
	     */
	    negate: function ()
	    {
	        this.x = -this.x;
	        this.y = -this.y;
	        this.z = -this.z;
	        this.w = -this.w;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector4#transformMat4
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Matrix4} mat - [description]
	     *
	     * @return {Phaser.Math.Vector4} This Vector4 object.
	     */
	    transformMat4: function (mat)
	    {
	        var x = this.x;
	        var y = this.y;
	        var z = this.z;
	        var w = this.w;
	        var m = mat.val;
	
	        this.x = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
	        this.y = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
	        this.z = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
	        this.w = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
	
	        return this;
	    },
	
	    //  TODO: is this really the same as Vector3?
	    //  Also, what about this: http://molecularmusings.wordpress.com/2013/05/24/a-faster-quaternion-vector-multiplication/
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector4#transformQuat
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Quaternion} q - [description]
	     *
	     * @return {Phaser.Math.Vector4} This Vector4 object.
	     */
	    transformQuat: function (q)
	    {
	        // benchmarks: http://jsperf.com/quaternion-transform-vec3-implementations
	        var x = this.x;
	        var y = this.y;
	        var z = this.z;
	        var qx = q.x;
	        var qy = q.y;
	        var qz = q.z;
	        var qw = q.w;
	
	        // calculate quat * vec
	        var ix = qw * x + qy * z - qz * y;
	        var iy = qw * y + qz * x - qx * z;
	        var iz = qw * z + qx * y - qy * x;
	        var iw = -qx * x - qy * y - qz * z;
	
	        // calculate result * inverse quat
	        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
	        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
	        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Vector4#reset
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Vector4} This Vector4 object.
	     */
	    reset: function ()
	    {
	        this.x = 0;
	        this.y = 0;
	        this.z = 0;
	        this.w = 0;
	
	        return this;
	    }
	
	});
	
	//  TODO: Check if these are required internally, if not, remove.
	Vector4.prototype.sub = Vector4.prototype.subtract;
	Vector4.prototype.mul = Vector4.prototype.multiply;
	Vector4.prototype.div = Vector4.prototype.divide;
	Vector4.prototype.dist = Vector4.prototype.distance;
	Vector4.prototype.distSq = Vector4.prototype.distanceSq;
	Vector4.prototype.len = Vector4.prototype.length;
	Vector4.prototype.lenSq = Vector4.prototype.lengthSq;
	
	module.exports = Vector4;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var MathWrap = __webpack_require__(98);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Angle.Wrap
	 * @since 3.0.0
	 *
	 * @param {number} angle - [description]
	 *
	 * @return {number} [description]
	 */
	var Wrap = function (angle)
	{
	    return MathWrap(angle, -Math.PI, Math.PI);
	};
	
	module.exports = Wrap;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Wrap = __webpack_require__(98);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Angle.WrapDegrees
	 * @since 3.0.0
	 *
	 * @param {number} angle - [description]
	 *
	 * @return {number} [description]
	 */
	var WrapDegrees = function (angle)
	{
	    return Wrap(angle, -180, 180);
	};
	
	module.exports = WrapDegrees;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	__webpack_require__(1498);
	
	var CONST = __webpack_require__(49);
	var Extend = __webpack_require__(36);
	
	/**
	 * @namespace Phaser
	 */
	
	var Phaser = {
	
	    Actions: __webpack_require__(441),
	    Animation: __webpack_require__(1035),
	    Cache: __webpack_require__(1042),
	    Cameras: __webpack_require__(1049),
	    Class: __webpack_require__(1),
	    Create: __webpack_require__(1052),
	    Curves: __webpack_require__(1058),
	    Data: __webpack_require__(1062),
	    Display: __webpack_require__(1096),
	    DOM: __webpack_require__(1098),
	    Events: __webpack_require__(1100),
	    Game: __webpack_require__(1039),
	    GameObjects: __webpack_require__(1156),
	    Geom: __webpack_require__(508),
	    Input: __webpack_require__(1313),
	    Loader: __webpack_require__(1348),
	    Math: __webpack_require__(1414),
	    Physics: __webpack_require__(1467),
	    Plugins: __webpack_require__(1490),
	    Renderer: __webpack_require__(1502),
	    Scene: __webpack_require__(622),
	    Scenes: __webpack_require__(1517),
	    Sound: __webpack_require__(1518),
	    Structs: __webpack_require__(1519),
	    Textures: __webpack_require__(1522),
	    Tilemaps: __webpack_require__(1565),
	    Time: __webpack_require__(1581),
	    Tweens: __webpack_require__(1584),
	    Utils: __webpack_require__(1613)
	
	};
	
	//   Merge in the consts
	
	Phaser = Extend(false, Phaser, CONST);
	
	//  Export it
	
	module.exports = Phaser;
	
	global.Phaser = Phaser;
	
	/*
	 * "Documentation is like pizza: when it is good, it is very, very good;
	 * and when it is bad, it is better than nothing."
	 *  -- Dick Brandon
	 */
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Physics.Impact.Components
	 */
	
	module.exports = {
	
	    Acceleration: __webpack_require__(1454),
	    BodyScale: __webpack_require__(1455),
	    BodyType: __webpack_require__(1456),
	    Bounce: __webpack_require__(1457),
	    CheckAgainst: __webpack_require__(1458),
	    Collides: __webpack_require__(1459),
	    Debug: __webpack_require__(1460),
	    Friction: __webpack_require__(1461),
	    Gravity: __webpack_require__(1462),
	    Offset: __webpack_require__(1463),
	    SetGameObject: __webpack_require__(1464),
	    Velocity: __webpack_require__(1465)
	
	};


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Matter = __webpack_require__(607);
	
	Matter.Body = __webpack_require__(51);
	Matter.Composite = __webpack_require__(118);
	Matter.World = __webpack_require__(317);
	
	Matter.Detector = __webpack_require__(318);
	Matter.Grid = __webpack_require__(603);
	Matter.Pairs = __webpack_require__(604);
	Matter.Pair = __webpack_require__(206);
	Matter.Query = __webpack_require__(1484);
	Matter.Resolver = __webpack_require__(605);
	Matter.SAT = __webpack_require__(319);
	
	Matter.Constraint = __webpack_require__(143);
	
	Matter.Common = __webpack_require__(31);
	Matter.Engine = __webpack_require__(606);
	Matter.Events = __webpack_require__(144);
	Matter.Sleeping = __webpack_require__(166);
	Matter.Plugin = __webpack_require__(320);
	
	Matter.Bodies = __webpack_require__(119);
	Matter.Composites = __webpack_require__(608);
	
	Matter.Axes = __webpack_require__(321);
	Matter.Bounds = __webpack_require__(85);
	Matter.Svg = __webpack_require__(1486);
	Matter.Vector = __webpack_require__(71);
	Matter.Vertices = __webpack_require__(86);
	
	// aliases
	
	Matter.World.add = Matter.Composite.add;
	Matter.World.remove = Matter.Composite.remove;
	Matter.World.addComposite = Matter.Composite.addComposite;
	Matter.World.addBody = Matter.Composite.addBody;
	Matter.World.addConstraint = Matter.Composite.addConstraint;
	Matter.World.clear = Matter.Composite.clear;
	
	module.exports = Matter;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Bodies = __webpack_require__(119);
	var Body = __webpack_require__(51);
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(205);
	var GetFastValue = __webpack_require__(3);
	var HasValue = __webpack_require__(147);
	var Vertices = __webpack_require__(86);
	
	/**
	 * @classdesc
	 * A wrapper around a Tile that provides access to a corresponding Matter body. A tile can only
	 * have one Matter body associated with it. You can either pass in an existing Matter body for
	 * the tile or allow the constructor to create the corresponding body for you. If the Tile has a
	 * collision group (defined in Tiled), those shapes will be used to create the body. If not, the
	 * tile's rectangle bounding box will be used.
	 *
	 * The corresponding body will be accessible on the Tile itself via Tile.physics.matterBody.
	 *
	 * Note: not all Tiled collision shapes are supported. See
	 * Phaser.Physics.Matter.TileBody#setFromTileCollision for more information.
	 *
	 * @class TileBody
	 * @memberOf Phaser.Physics.Matter
	 * @constructor
	 * @since 3.0.0
	 *
	 * @extends Phaser.Physics.Matter.Components.Bounce
	 * @extends Phaser.Physics.Matter.Components.Collision
	 * @extends Phaser.Physics.Matter.Components.Friction
	 * @extends Phaser.Physics.Matter.Components.Gravity
	 * @extends Phaser.Physics.Matter.Components.Mass
	 * @extends Phaser.Physics.Matter.Components.Sensor
	 * @extends Phaser.Physics.Matter.Components.Sleep
	 * @extends Phaser.Physics.Matter.Components.Static
	 *
	 * @param {Phaser.Physics.Matter.World} world - [description]
	 * @param {Phaser.Tilemaps.Tile} tile - The target tile that should have a Matter body.
	 * @param {object} [options] - Options to be used when creating the Matter body. See
	 * Phaser.Physics.Matter.Matter.Body for a list of what Matter accepts.
	 * @param {Phaser.Physics.Matter.Matter.Body} [options.body=null] - An existing Matter body to
	 * be used instead of creating a new one.
	 * @param {boolean} [options.isStatic=true] - Whether or not the newly created body should be
	 * made static. This defaults to true since typically tiles should not be moved.
	 * @param {boolean} [options.addToWorld=true] - Whether or not to add the newly created body (or
	 * existing body if options.body is used) to the Matter world.
	 */
	var MatterTileBody = new Class({
	
	    Mixins: [
	        Components.Bounce,
	        Components.Collision,
	        Components.Friction,
	        Components.Gravity,
	        Components.Mass,
	        Components.Sensor,
	        Components.Sleep,
	        Components.Static
	    ],
	
	    initialize:
	
	    function MatterTileBody (world, tile, options)
	    {
	        /**
	         * The tile object the body is associated with.
	         *
	         * @name Phaser.Physics.Matter.TileBody#tile
	         * @type {Phaser.Tilemaps.Tile}
	         * @since 3.0.0
	         */
	        this.tile = tile;
	
	        /**
	         * The Matter world the body exists within.
	         *
	         * @name Phaser.Physics.Matter.TileBody#world
	         * @type {Phaser.Physics.Matter.World}
	         * @since 3.0.0
	         */
	        this.world = world;
	
	        // Install a reference to 'this' on the tile and ensure there can only be one matter body
	        // associated with the tile
	        if (tile.physics.matterBody)
	        {
	            tile.physics.matterBody.destroy();
	        }
	
	        tile.physics.matterBody = this;
	
	        // Set the body either from an existing body (if provided), the shapes in the tileset
	        // collision layer (if it exists) or a rectangle matching the tile.
	        var body = GetFastValue(options, 'body', null);
	
	        var addToWorld = GetFastValue(options, 'addToWorld', true);
	
	        if (!body)
	        {
	            var collisionGroup = tile.getCollisionGroup();
	            var collisionObjects = GetFastValue(collisionGroup, 'objects', []);
	
	            if (collisionObjects.length > 0)
	            {
	                this.setFromTileCollision(options);
	            }
	            else
	            {
	                this.setFromTileRectangle(options);
	            }
	        }
	        else
	        {
	            this.setBody(body, addToWorld);
	        }
	    },
	
	    /**
	     * Sets the current body to a rectangle that matches the bounds of the tile.
	     *
	     * @method Phaser.Physics.Matter.TileBody#setFromTileRectangle
	     * @since 3.0.0
	     *
	     * @param {object} [options] - Options to be used when creating the Matter body. See MatterJS.Body for a list of what Matter accepts.
	     * @param {boolean} [options.isStatic=true] - Whether or not the newly created body should be
	     * made static. This defaults to true since typically tiles should not be moved.
	     * @param {boolean} [options.addToWorld=true] - Whether or not to add the newly created body (or
	     * existing body if options.body is used) to the Matter world.
	     * 
	     * @return {Phaser.Physics.Matter.TileBody} This TileBody object.
	     */
	    setFromTileRectangle: function (options)
	    {
	        if (options === undefined) { options = {}; }
	        if (!HasValue(options, 'isStatic')) { options.isStatic = true; }
	        if (!HasValue(options, 'addToWorld')) { options.addToWorld = true; }
	
	        var bounds = this.tile.getBounds();
	        var cx = bounds.x + (bounds.width / 2);
	        var cy = bounds.y + (bounds.height / 2);
	        var body = Bodies.rectangle(cx, cy, bounds.width, bounds.height, options);
	
	        this.setBody(body, options.addToWorld);
	
	        return this;
	    },
	
	    /**
	     * Sets the current body from the collision group associated with the Tile. This is typically
	     * set up in Tiled's collision editor.
	     *
	     * Note: Matter doesn't support all shapes from Tiled. Rectangles and polygons are directly
	     * supported. Ellipses are converted into circle bodies. Polylines are treated as if they are
	     * closed polygons. If a tile has multiple shapes, a multi-part body will be created. Concave
	     * shapes are supported if poly-decomp library is included. Decomposition is not guaranteed to
	     * work for complex shapes (e.g. holes), so it's often best to manually decompose a concave
	     * polygon into multiple convex polygons yourself.
	     *
	     * @method Phaser.Physics.Matter.TileBody#setFromTileCollision
	     * @since 3.0.0
	     *
	     * @param {object} [options] - Options to be used when creating the Matter body. See MatterJS.Body for a list of what Matter accepts.
	     * @param {boolean} [options.isStatic=true] - Whether or not the newly created body should be
	     * made static. This defaults to true since typically tiles should not be moved.
	     * @param {boolean} [options.addToWorld=true] - Whether or not to add the newly created body (or
	     * existing body if options.body is used) to the Matter world.
	     * 
	     * @return {Phaser.Physics.Matter.TileBody} This TileBody object.
	     */
	    setFromTileCollision: function (options)
	    {
	        if (options === undefined) { options = {}; }
	        if (!HasValue(options, 'isStatic')) { options.isStatic = true; }
	        if (!HasValue(options, 'addToWorld')) { options.addToWorld = true; }
	
	        var sx = this.tile.tilemapLayer.scaleX;
	        var sy = this.tile.tilemapLayer.scaleY;
	        var tileX = this.tile.getLeft();
	        var tileY = this.tile.getTop();
	        var collisionGroup = this.tile.getCollisionGroup();
	        var collisionObjects = GetFastValue(collisionGroup, 'objects', []);
	
	        var parts = [];
	
	        for (var i = 0; i < collisionObjects.length; i++)
	        {
	            var object = collisionObjects[i];
	            var ox = tileX + (object.x * sx);
	            var oy = tileY + (object.y * sy);
	            var ow = object.width * sx;
	            var oh = object.height * sy;
	            var body = null;
	
	            if (object.rectangle)
	            {
	                body = Bodies.rectangle(ox + ow / 2, oy + oh / 2, ow, oh, options);
	            }
	            else if (object.ellipse)
	            {
	                body = Bodies.circle(ox + ow / 2, oy + oh / 2, ow / 2, options);
	            }
	            else if (object.polygon || object.polyline)
	            {
	                // Polygons and polylines are both treated as closed polygons
	                var originalPoints = object.polygon ? object.polygon : object.polyline;
	
	                var points = originalPoints.map(function (p)
	                {
	                    return { x: p.x * sx, y: p.y * sy };
	                });
	
	                var vertices = Vertices.create(points);
	
	                // Points are relative to the object's origin (first point placed in Tiled), but
	                // matter expects points to be relative to the center of mass. This only applies to
	                // convex shapes. When a concave shape is decomposed, multiple parts are created and
	                // the individual parts are positioned relative to (ox, oy).
	                if (Vertices.isConvex(points))
	                {
	                    var center = Vertices.centre(vertices);
	                    ox += center.x;
	                    oy += center.y;
	                }
	
	                body = Bodies.fromVertices(ox, oy, vertices, options);
	            }
	
	            if (body)
	            {
	                parts.push(body);
	            }
	        }
	
	        if (parts.length === 1)
	        {
	            this.setBody(parts[0], options.addToWorld);
	        }
	        else if (parts.length > 1)
	        {
	            options.parts = parts;
	            this.setBody(Body.create(options), options.addToWorld);
	        }
	
	        return this;
	    },
	
	    /**
	     * Sets the current body to the given body. This will remove the previous body, if one already
	     * exists.
	     *
	     * @method Phaser.Physics.Matter.TileBody#setBody
	     * @since 3.0.0
	     *
	     * @param {MatterJS.Body} body - The new Matter body to use.
	     * @param {boolean} [addToWorld=true] - Whether or not to add the body to the Matter world.
	     * 
	     * @return {Phaser.Physics.Matter.TileBody} This TileBody object.
	     */
	    setBody: function (body, addToWorld)
	    {
	        if (addToWorld === undefined) { addToWorld = true; }
	
	        if (this.body)
	        {
	            this.removeBody();
	        }
	
	        this.body = body;
	        this.body.gameObject = this;
	
	        if (addToWorld)
	        {
	            this.world.add(this.body);
	        }
	
	        return this;
	    },
	
	    /**
	     * Removes the current body from the TileBody and from the Matter world
	     *
	     * @method Phaser.Physics.Matter.TileBody#removeBody
	     * @since 3.0.0
	     *
	     * @return {Phaser.Physics.Matter.TileBody} This TileBody object.
	     */
	    removeBody: function ()
	    {
	        if (this.body)
	        {
	            this.world.remove(this.body);
	            this.body.gameObject = undefined;
	            this.body = undefined;
	        }
	
	        return this;
	    },
	
	    /**
	     * Removes the current body from the tile and the world.
	     *
	     * @method Phaser.Physics.Matter.TileBody#destroy
	     * @since 3.0.0
	     *
	     * @return {Phaser.Physics.Matter.TileBody} This TileBody object.
	     */
	    destroy: function ()
	    {
	        this.removeBody();
	        this.tile.physics.matterBody = undefined;
	    }
	
	});
	
	module.exports = MatterTileBody;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* The `Matter.World` module contains methods for creating and manipulating the world composite.
	* A `Matter.World` is a `Matter.Composite` body, which is a collection of `Matter.Body`, `Matter.Constraint` and other `Matter.Composite`.
	* A `Matter.World` has a few additional properties including `gravity` and `bounds`.
	* It is important to use the functions in the `Matter.Composite` module to modify the world composite, rather than directly modifying its properties.
	* There are also a few methods here that alias those in `Matter.Composite` for easier readability.
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class World
	* @extends Composite
	*/
	
	var World = {};
	
	module.exports = World;
	
	var Composite = __webpack_require__(118);
	var Constraint = __webpack_require__(143);
	var Common = __webpack_require__(31);
	
	(function() {
	
	    /**
	     * Creates a new world composite. The options parameter is an object that specifies any properties you wish to override the defaults.
	     * See the properties section below for detailed information on what you can pass via the `options` object.
	     * @method create
	     * @constructor
	     * @param {} options
	     * @return {world} A new world
	     */
	    World.create = function(options) {
	        var composite = Composite.create();
	
	        var defaults = {
	            label: 'World',
	            gravity: {
	                x: 0,
	                y: 1,
	                scale: 0.001
	            },
	            bounds: { 
	                min: { x: -Infinity, y: -Infinity }, 
	                max: { x: Infinity, y: Infinity } 
	            }
	        };
	        
	        return Common.extend(composite, defaults, options);
	    };
	
	    /*
	    *
	    *  Properties Documentation
	    *
	    */
	
	    /**
	     * The gravity to apply on the world.
	     *
	     * @property gravity
	     * @type object
	     */
	
	    /**
	     * The gravity x component.
	     *
	     * @property gravity.x
	     * @type object
	     * @default 0
	     */
	
	    /**
	     * The gravity y component.
	     *
	     * @property gravity.y
	     * @type object
	     * @default 1
	     */
	
	    /**
	     * The gravity scale factor.
	     *
	     * @property gravity.scale
	     * @type object
	     * @default 0.001
	     */
	
	    /**
	     * A `Bounds` object that defines the world bounds for collision detection.
	     *
	     * @property bounds
	     * @type bounds
	     * @default { min: { x: -Infinity, y: -Infinity }, max: { x: Infinity, y: Infinity } }
	     */
	
	    // World is a Composite body
	    // see src/module/Outro.js for these aliases:
	    
	    /**
	     * An alias for Composite.clear
	     * @method clear
	     * @param {world} world
	     * @param {boolean} keepStatic
	     */
	
	    /**
	     * An alias for Composite.add
	     * @method addComposite
	     * @param {world} world
	     * @param {composite} composite
	     * @return {world} The original world with the objects from composite added
	     */
	    
	     /**
	      * An alias for Composite.addBody
	      * @method addBody
	      * @param {world} world
	      * @param {body} body
	      * @return {world} The original world with the body added
	      */
	
	     /**
	      * An alias for Composite.addConstraint
	      * @method addConstraint
	      * @param {world} world
	      * @param {constraint} constraint
	      * @return {world} The original world with the constraint added
	      */
	
	})();


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* The `Matter.Detector` module contains methods for detecting collisions given a set of pairs.
	*
	* @class Detector
	*/
	
	// TODO: speculative contacts
	
	var Detector = {};
	
	module.exports = Detector;
	
	var SAT = __webpack_require__(319);
	var Pair = __webpack_require__(206);
	var Bounds = __webpack_require__(85);
	
	(function() {
	
	    /**
	     * Finds all collisions given a list of pairs.
	     * @method collisions
	     * @param {pair[]} broadphasePairs
	     * @param {engine} engine
	     * @return {array} collisions
	     */
	    Detector.collisions = function(broadphasePairs, engine) {
	        var collisions = [],
	            pairsTable = engine.pairs.table;
	
	        // @if DEBUG
	        var metrics = engine.metrics;
	        // @endif
	        
	        for (var i = 0; i < broadphasePairs.length; i++) {
	            var bodyA = broadphasePairs[i][0], 
	                bodyB = broadphasePairs[i][1];
	
	            if ((bodyA.isStatic || bodyA.isSleeping) && (bodyB.isStatic || bodyB.isSleeping))
	                continue;
	            
	            if (!Detector.canCollide(bodyA.collisionFilter, bodyB.collisionFilter))
	                continue;
	
	            // @if DEBUG
	            metrics.midphaseTests += 1;
	            // @endif
	
	            // mid phase
	            if (Bounds.overlaps(bodyA.bounds, bodyB.bounds)) {
	                for (var j = bodyA.parts.length > 1 ? 1 : 0; j < bodyA.parts.length; j++) {
	                    var partA = bodyA.parts[j];
	
	                    for (var k = bodyB.parts.length > 1 ? 1 : 0; k < bodyB.parts.length; k++) {
	                        var partB = bodyB.parts[k];
	
	                        if ((partA === bodyA && partB === bodyB) || Bounds.overlaps(partA.bounds, partB.bounds)) {
	                            // find a previous collision we could reuse
	                            var pairId = Pair.id(partA, partB),
	                                pair = pairsTable[pairId],
	                                previousCollision;
	
	                            if (pair && pair.isActive) {
	                                previousCollision = pair.collision;
	                            } else {
	                                previousCollision = null;
	                            }
	
	                            // narrow phase
	                            var collision = SAT.collides(partA, partB, previousCollision);
	
	                            // @if DEBUG
	                            metrics.narrowphaseTests += 1;
	                            if (collision.reused)
	                                metrics.narrowReuseCount += 1;
	                            // @endif
	
	                            if (collision.collided) {
	                                collisions.push(collision);
	                                // @if DEBUG
	                                metrics.narrowDetections += 1;
	                                // @endif
	                            }
	                        }
	                    }
	                }
	            }
	        }
	
	        return collisions;
	    };
	
	    /**
	     * Returns `true` if both supplied collision filters will allow a collision to occur.
	     * See `body.collisionFilter` for more information.
	     * @method canCollide
	     * @param {} filterA
	     * @param {} filterB
	     * @return {bool} `true` if collision can occur
	     */
	    Detector.canCollide = function(filterA, filterB) {
	        if (filterA.group === filterB.group && filterA.group !== 0)
	            return filterA.group > 0;
	
	        return (filterA.mask & filterB.category) !== 0 && (filterB.mask & filterA.category) !== 0;
	    };
	
	})();


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* The `Matter.SAT` module contains methods for detecting collisions using the Separating Axis Theorem.
	*
	* @class SAT
	*/
	
	// TODO: true circles and curves
	
	var SAT = {};
	
	module.exports = SAT;
	
	var Vertices = __webpack_require__(86);
	var Vector = __webpack_require__(71);
	
	(function() {
	
	    /**
	     * Detect collision between two bodies using the Separating Axis Theorem.
	     * @method collides
	     * @param {body} bodyA
	     * @param {body} bodyB
	     * @param {collision} previousCollision
	     * @return {collision} collision
	     */
	    SAT.collides = function(bodyA, bodyB, previousCollision) {
	        var overlapAB,
	            overlapBA, 
	            minOverlap,
	            collision,
	            canReusePrevCol = false;
	
	        if (previousCollision) {
	            // estimate total motion
	            var parentA = bodyA.parent,
	                parentB = bodyB.parent,
	                motion = parentA.speed * parentA.speed + parentA.angularSpeed * parentA.angularSpeed
	                       + parentB.speed * parentB.speed + parentB.angularSpeed * parentB.angularSpeed;
	
	            // we may be able to (partially) reuse collision result 
	            // but only safe if collision was resting
	            canReusePrevCol = previousCollision && previousCollision.collided && motion < 0.2;
	
	            // reuse collision object
	            collision = previousCollision;
	        } else {
	            collision = { collided: false, bodyA: bodyA, bodyB: bodyB };
	        }
	
	        if (previousCollision && canReusePrevCol) {
	            // if we can reuse the collision result
	            // we only need to test the previously found axis
	            var axisBodyA = collision.axisBody,
	                axisBodyB = axisBodyA === bodyA ? bodyB : bodyA,
	                axes = [axisBodyA.axes[previousCollision.axisNumber]];
	
	            minOverlap = _overlapAxes(axisBodyA.vertices, axisBodyB.vertices, axes);
	            collision.reused = true;
	
	            if (minOverlap.overlap <= 0) {
	                collision.collided = false;
	                return collision;
	            }
	        } else {
	            // if we can't reuse a result, perform a full SAT test
	
	            overlapAB = _overlapAxes(bodyA.vertices, bodyB.vertices, bodyA.axes);
	
	            if (overlapAB.overlap <= 0) {
	                collision.collided = false;
	                return collision;
	            }
	
	            overlapBA = _overlapAxes(bodyB.vertices, bodyA.vertices, bodyB.axes);
	
	            if (overlapBA.overlap <= 0) {
	                collision.collided = false;
	                return collision;
	            }
	
	            if (overlapAB.overlap < overlapBA.overlap) {
	                minOverlap = overlapAB;
	                collision.axisBody = bodyA;
	            } else {
	                minOverlap = overlapBA;
	                collision.axisBody = bodyB;
	            }
	
	            // important for reuse later
	            collision.axisNumber = minOverlap.axisNumber;
	        }
	
	        collision.bodyA = bodyA.id < bodyB.id ? bodyA : bodyB;
	        collision.bodyB = bodyA.id < bodyB.id ? bodyB : bodyA;
	        collision.collided = true;
	        collision.depth = minOverlap.overlap;
	        collision.parentA = collision.bodyA.parent;
	        collision.parentB = collision.bodyB.parent;
	        
	        bodyA = collision.bodyA;
	        bodyB = collision.bodyB;
	
	        // ensure normal is facing away from bodyA
	        if (Vector.dot(minOverlap.axis, Vector.sub(bodyB.position, bodyA.position)) < 0) {
	            collision.normal = {
	                x: minOverlap.axis.x,
	                y: minOverlap.axis.y
	            };
	        } else {
	            collision.normal = {
	                x: -minOverlap.axis.x,
	                y: -minOverlap.axis.y
	            };
	        }
	
	        collision.tangent = Vector.perp(collision.normal);
	
	        collision.penetration = collision.penetration || {};
	        collision.penetration.x = collision.normal.x * collision.depth;
	        collision.penetration.y = collision.normal.y * collision.depth; 
	
	        // find support points, there is always either exactly one or two
	        var verticesB = _findSupports(bodyA, bodyB, collision.normal),
	            supports = [];
	
	        // find the supports from bodyB that are inside bodyA
	        if (Vertices.contains(bodyA.vertices, verticesB[0]))
	            supports.push(verticesB[0]);
	
	        if (Vertices.contains(bodyA.vertices, verticesB[1]))
	            supports.push(verticesB[1]);
	
	        // find the supports from bodyA that are inside bodyB
	        if (supports.length < 2) {
	            var verticesA = _findSupports(bodyB, bodyA, Vector.neg(collision.normal));
	                
	            if (Vertices.contains(bodyB.vertices, verticesA[0]))
	                supports.push(verticesA[0]);
	
	            if (supports.length < 2 && Vertices.contains(bodyB.vertices, verticesA[1]))
	                supports.push(verticesA[1]);
	        }
	
	        // account for the edge case of overlapping but no vertex containment
	        if (supports.length < 1)
	            supports = [verticesB[0]];
	        
	        collision.supports = supports;
	
	        return collision;
	    };
	
	    /**
	     * Find the overlap between two sets of vertices.
	     * @method _overlapAxes
	     * @private
	     * @param {} verticesA
	     * @param {} verticesB
	     * @param {} axes
	     * @return result
	     */
	    var _overlapAxes = function(verticesA, verticesB, axes) {
	        var projectionA = Vector._temp[0], 
	            projectionB = Vector._temp[1],
	            result = { overlap: Number.MAX_VALUE },
	            overlap,
	            axis;
	
	        for (var i = 0; i < axes.length; i++) {
	            axis = axes[i];
	
	            _projectToAxis(projectionA, verticesA, axis);
	            _projectToAxis(projectionB, verticesB, axis);
	
	            overlap = Math.min(projectionA.max - projectionB.min, projectionB.max - projectionA.min);
	
	            if (overlap <= 0) {
	                result.overlap = overlap;
	                return result;
	            }
	
	            if (overlap < result.overlap) {
	                result.overlap = overlap;
	                result.axis = axis;
	                result.axisNumber = i;
	            }
	        }
	
	        return result;
	    };
	
	    /**
	     * Projects vertices on an axis and returns an interval.
	     * @method _projectToAxis
	     * @private
	     * @param {} projection
	     * @param {} vertices
	     * @param {} axis
	     */
	    var _projectToAxis = function(projection, vertices, axis) {
	        var min = Vector.dot(vertices[0], axis),
	            max = min;
	
	        for (var i = 1; i < vertices.length; i += 1) {
	            var dot = Vector.dot(vertices[i], axis);
	
	            if (dot > max) { 
	                max = dot; 
	            } else if (dot < min) { 
	                min = dot; 
	            }
	        }
	
	        projection.min = min;
	        projection.max = max;
	    };
	    
	    /**
	     * Finds supporting vertices given two bodies along a given direction using hill-climbing.
	     * @method _findSupports
	     * @private
	     * @param {} bodyA
	     * @param {} bodyB
	     * @param {} normal
	     * @return [vector]
	     */
	    var _findSupports = function(bodyA, bodyB, normal) {
	        var nearestDistance = Number.MAX_VALUE,
	            vertexToBody = Vector._temp[0],
	            vertices = bodyB.vertices,
	            bodyAPosition = bodyA.position,
	            distance,
	            vertex,
	            vertexA,
	            vertexB;
	
	        // find closest vertex on bodyB
	        for (var i = 0; i < vertices.length; i++) {
	            vertex = vertices[i];
	            vertexToBody.x = vertex.x - bodyAPosition.x;
	            vertexToBody.y = vertex.y - bodyAPosition.y;
	            distance = -Vector.dot(normal, vertexToBody);
	
	            if (distance < nearestDistance) {
	                nearestDistance = distance;
	                vertexA = vertex;
	            }
	        }
	
	        // find next closest vertex using the two connected to it
	        var prevIndex = vertexA.index - 1 >= 0 ? vertexA.index - 1 : vertices.length - 1;
	        vertex = vertices[prevIndex];
	        vertexToBody.x = vertex.x - bodyAPosition.x;
	        vertexToBody.y = vertex.y - bodyAPosition.y;
	        nearestDistance = -Vector.dot(normal, vertexToBody);
	        vertexB = vertex;
	
	        var nextIndex = (vertexA.index + 1) % vertices.length;
	        vertex = vertices[nextIndex];
	        vertexToBody.x = vertex.x - bodyAPosition.x;
	        vertexToBody.y = vertex.y - bodyAPosition.y;
	        distance = -Vector.dot(normal, vertexToBody);
	        if (distance < nearestDistance) {
	            vertexB = vertex;
	        }
	
	        return [vertexA, vertexB];
	    };
	
	})();


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* The `Matter.Plugin` module contains functions for registering and installing plugins on modules.
	*
	* @class Plugin
	*/
	
	var Plugin = {};
	
	module.exports = Plugin;
	
	var Common = __webpack_require__(31);
	
	(function() {
	
	    Plugin._registry = {};
	
	    /**
	     * Registers a plugin object so it can be resolved later by name.
	     * @method register
	     * @param plugin {} The plugin to register.
	     * @return {object} The plugin.
	     */
	    Plugin.register = function(plugin) {
	        if (!Plugin.isPlugin(plugin)) {
	            Common.warn('Plugin.register:', Plugin.toString(plugin), 'does not implement all required fields.');
	        }
	
	        if (plugin.name in Plugin._registry) {
	            var registered = Plugin._registry[plugin.name],
	                pluginVersion = Plugin.versionParse(plugin.version).number,
	                registeredVersion = Plugin.versionParse(registered.version).number;
	
	            if (pluginVersion > registeredVersion) {
	                Common.warn('Plugin.register:', Plugin.toString(registered), 'was upgraded to', Plugin.toString(plugin));
	                Plugin._registry[plugin.name] = plugin;
	            } else if (pluginVersion < registeredVersion) {
	                Common.warn('Plugin.register:', Plugin.toString(registered), 'can not be downgraded to', Plugin.toString(plugin));
	            } else if (plugin !== registered) {
	                Common.warn('Plugin.register:', Plugin.toString(plugin), 'is already registered to different plugin object');
	            }
	        } else {
	            Plugin._registry[plugin.name] = plugin;
	        }
	
	        return plugin;
	    };
	
	    /**
	     * Resolves a dependency to a plugin object from the registry if it exists. 
	     * The `dependency` may contain a version, but only the name matters when resolving.
	     * @method resolve
	     * @param dependency {string} The dependency.
	     * @return {object} The plugin if resolved, otherwise `undefined`.
	     */
	    Plugin.resolve = function(dependency) {
	        return Plugin._registry[Plugin.dependencyParse(dependency).name];
	    };
	
	    /**
	     * Returns a pretty printed plugin name and version.
	     * @method toString
	     * @param plugin {} The plugin.
	     * @return {string} Pretty printed plugin name and version.
	     */
	    Plugin.toString = function(plugin) {
	        return typeof plugin === 'string' ? plugin : (plugin.name || 'anonymous') + '@' + (plugin.version || plugin.range || '0.0.0');
	    };
	
	    /**
	     * Returns `true` if the object meets the minimum standard to be considered a plugin.
	     * This means it must define the following properties:
	     * - `name`
	     * - `version`
	     * - `install`
	     * @method isPlugin
	     * @param obj {} The obj to test.
	     * @return {boolean} `true` if the object can be considered a plugin otherwise `false`.
	     */
	    Plugin.isPlugin = function(obj) {
	        return obj && obj.name && obj.version && obj.install;
	    };
	
	    /**
	     * Returns `true` if a plugin with the given `name` been installed on `module`.
	     * @method isUsed
	     * @param module {} The module.
	     * @param name {string} The plugin name.
	     * @return {boolean} `true` if a plugin with the given `name` been installed on `module`, otherwise `false`.
	     */
	    Plugin.isUsed = function(module, name) {
	        return module.used.indexOf(name) > -1;
	    };
	
	    /**
	     * Returns `true` if `plugin.for` is applicable to `module` by comparing against `module.name` and `module.version`.
	     * If `plugin.for` is not specified then it is assumed to be applicable.
	     * The value of `plugin.for` is a string of the format `'module-name'` or `'module-name@version'`.
	     * @method isFor
	     * @param plugin {} The plugin.
	     * @param module {} The module.
	     * @return {boolean} `true` if `plugin.for` is applicable to `module`, otherwise `false`.
	     */
	    Plugin.isFor = function(plugin, module) {
	        var parsed = plugin.for && Plugin.dependencyParse(plugin.for);
	        return !plugin.for || (module.name === parsed.name && Plugin.versionSatisfies(module.version, parsed.range));
	    };
	
	    /**
	     * Installs the plugins by calling `plugin.install` on each plugin specified in `plugins` if passed, otherwise `module.uses`.
	     * For installing plugins on `Matter` see the convenience function `Matter.use`.
	     * Plugins may be specified either by their name or a reference to the plugin object.
	     * Plugins themselves may specify further dependencies, but each plugin is installed only once.
	     * Order is important, a topological sort is performed to find the best resulting order of installation.
	     * This sorting attempts to satisfy every dependency's requested ordering, but may not be exact in all cases.
	     * This function logs the resulting status of each dependency in the console, along with any warnings.
	     * - A green tick ✅ indicates a dependency was resolved and installed.
	     * - An orange diamond 🔶 indicates a dependency was resolved but a warning was thrown for it or one if its dependencies.
	     * - A red cross ❌ indicates a dependency could not be resolved.
	     * Avoid calling this function multiple times on the same module unless you intend to manually control installation order.
	     * @method use
	     * @param module {} The module install plugins on.
	     * @param [plugins=module.uses] {} The plugins to install on module (optional, defaults to `module.uses`).
	     */
	    Plugin.use = function(module, plugins) {
	        module.uses = (module.uses || []).concat(plugins || []);
	
	        if (module.uses.length === 0) {
	            Common.warn('Plugin.use:', Plugin.toString(module), 'does not specify any dependencies to install.');
	            return;
	        }
	
	        var dependencies = Plugin.dependencies(module),
	            sortedDependencies = Common.topologicalSort(dependencies),
	            status = [];
	
	        for (var i = 0; i < sortedDependencies.length; i += 1) {
	            if (sortedDependencies[i] === module.name) {
	                continue;
	            }
	
	            var plugin = Plugin.resolve(sortedDependencies[i]);
	
	            if (!plugin) {
	                status.push('❌ ' + sortedDependencies[i]);
	                continue;
	            }
	
	            if (Plugin.isUsed(module, plugin.name)) {
	                continue;
	            }
	
	            if (!Plugin.isFor(plugin, module)) {
	                Common.warn('Plugin.use:', Plugin.toString(plugin), 'is for', plugin.for, 'but installed on', Plugin.toString(module) + '.');
	                plugin._warned = true;
	            }
	
	            if (plugin.install) {
	                plugin.install(module);
	            } else {
	                Common.warn('Plugin.use:', Plugin.toString(plugin), 'does not specify an install function.');
	                plugin._warned = true;
	            }
	
	            if (plugin._warned) {
	                status.push('🔶 ' + Plugin.toString(plugin));
	                delete plugin._warned;
	            } else {
	                status.push('✅ ' + Plugin.toString(plugin));
	            }
	
	            module.used.push(plugin.name);
	        }
	
	        if (status.length > 0 && !plugin.silent) {
	            Common.info(status.join('  '));
	        }
	    };
	
	    /**
	     * Recursively finds all of a module's dependencies and returns a flat dependency graph.
	     * @method dependencies
	     * @param module {} The module.
	     * @return {object} A dependency graph.
	     */
	    Plugin.dependencies = function(module, tracked) {
	        var parsedBase = Plugin.dependencyParse(module),
	            name = parsedBase.name;
	
	        tracked = tracked || {};
	
	        if (name in tracked) {
	            return;
	        }
	
	        module = Plugin.resolve(module) || module;
	
	        tracked[name] = Common.map(module.uses || [], function(dependency) {
	            if (Plugin.isPlugin(dependency)) {
	                Plugin.register(dependency);
	            }
	
	            var parsed = Plugin.dependencyParse(dependency),
	                resolved = Plugin.resolve(dependency);
	
	            if (resolved && !Plugin.versionSatisfies(resolved.version, parsed.range)) {
	                Common.warn(
	                    'Plugin.dependencies:', Plugin.toString(resolved), 'does not satisfy',
	                    Plugin.toString(parsed), 'used by', Plugin.toString(parsedBase) + '.'
	                );
	
	                resolved._warned = true;
	                module._warned = true;
	            } else if (!resolved) {
	                Common.warn(
	                    'Plugin.dependencies:', Plugin.toString(dependency), 'used by',
	                    Plugin.toString(parsedBase), 'could not be resolved.'
	                );
	
	                module._warned = true;
	            }
	
	            return parsed.name;
	        });
	
	        for (var i = 0; i < tracked[name].length; i += 1) {
	            Plugin.dependencies(tracked[name][i], tracked);
	        }
	
	        return tracked;
	    };
	
	    /**
	     * Parses a dependency string into its components.
	     * The `dependency` is a string of the format `'module-name'` or `'module-name@version'`.
	     * See documentation for `Plugin.versionParse` for a description of the format.
	     * This function can also handle dependencies that are already resolved (e.g. a module object).
	     * @method dependencyParse
	     * @param dependency {string} The dependency of the format `'module-name'` or `'module-name@version'`.
	     * @return {object} The dependency parsed into its components.
	     */
	    Plugin.dependencyParse = function(dependency) {
	        if (Common.isString(dependency)) {
	            var pattern = /^[\w-]+(@(\*|[\^~]?\d+\.\d+\.\d+(-[0-9A-Za-z-]+)?))?$/;
	
	            if (!pattern.test(dependency)) {
	                Common.warn('Plugin.dependencyParse:', dependency, 'is not a valid dependency string.');
	            }
	
	            return {
	                name: dependency.split('@')[0],
	                range: dependency.split('@')[1] || '*'
	            };
	        }
	
	        return {
	            name: dependency.name,
	            range: dependency.range || dependency.version
	        };
	    };
	
	    /**
	     * Parses a version string into its components.  
	     * Versions are strictly of the format `x.y.z` (as in [semver](http://semver.org/)).
	     * Versions may optionally have a prerelease tag in the format `x.y.z-alpha`.
	     * Ranges are a strict subset of [npm ranges](https://docs.npmjs.com/misc/semver#advanced-range-syntax).
	     * Only the following range types are supported:
	     * - Tilde ranges e.g. `~1.2.3`
	     * - Caret ranges e.g. `^1.2.3`
	     * - Exact version e.g. `1.2.3`
	     * - Any version `*`
	     * @method versionParse
	     * @param range {string} The version string.
	     * @return {object} The version range parsed into its components.
	     */
	    Plugin.versionParse = function(range) {
	        var pattern = /^\*|[\^~]?\d+\.\d+\.\d+(-[0-9A-Za-z-]+)?$/;
	
	        if (!pattern.test(range)) {
	            Common.warn('Plugin.versionParse:', range, 'is not a valid version or range.');
	        }
	
	        var identifiers = range.split('-');
	        range = identifiers[0];
	
	        var isRange = isNaN(Number(range[0])),
	            version = isRange ? range.substr(1) : range,
	            parts = Common.map(version.split('.'), function(part) {
	                return Number(part);
	            });
	
	        return {
	            isRange: isRange,
	            version: version,
	            range: range,
	            operator: isRange ? range[0] : '',
	            parts: parts,
	            prerelease: identifiers[1],
	            number: parts[0] * 1e8 + parts[1] * 1e4 + parts[2]
	        };
	    };
	
	    /**
	     * Returns `true` if `version` satisfies the given `range`.
	     * See documentation for `Plugin.versionParse` for a description of the format.
	     * If a version or range is not specified, then any version (`*`) is assumed to satisfy.
	     * @method versionSatisfies
	     * @param version {string} The version string.
	     * @param range {string} The range string.
	     * @return {boolean} `true` if `version` satisfies `range`, otherwise `false`.
	     */
	    Plugin.versionSatisfies = function(version, range) {
	        range = range || '*';
	
	        var rangeParsed = Plugin.versionParse(range),
	            rangeParts = rangeParsed.parts,
	            versionParsed = Plugin.versionParse(version),
	            versionParts = versionParsed.parts;
	
	        if (rangeParsed.isRange) {
	            if (rangeParsed.operator === '*' || version === '*') {
	                return true;
	            }
	
	            if (rangeParsed.operator === '~') {
	                return versionParts[0] === rangeParts[0] && versionParts[1] === rangeParts[1] && versionParts[2] >= rangeParts[2];
	            }
	
	            if (rangeParsed.operator === '^') {
	                if (rangeParts[0] > 0) {
	                    return versionParts[0] === rangeParts[0] && versionParsed.number >= rangeParsed.number;
	                }
	
	                if (rangeParts[1] > 0) {
	                    return versionParts[1] === rangeParts[1] && versionParts[2] >= rangeParts[2];
	                }
	
	                return versionParts[2] === rangeParts[2];
	            }
	        }
	
	        return version === range || version === '*';
	    };
	
	})();


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* The `Matter.Axes` module contains methods for creating and manipulating sets of axes.
	*
	* @class Axes
	*/
	
	var Axes = {};
	
	module.exports = Axes;
	
	var Vector = __webpack_require__(71);
	var Common = __webpack_require__(31);
	
	(function() {
	
	    /**
	     * Creates a new set of axes from the given vertices.
	     * @method fromVertices
	     * @param {vertices} vertices
	     * @return {axes} A new axes from the given vertices
	     */
	    Axes.fromVertices = function(vertices) {
	        var axes = {};
	
	        // find the unique axes, using edge normal gradients
	        for (var i = 0; i < vertices.length; i++) {
	            var j = (i + 1) % vertices.length, 
	                normal = Vector.normalise({ 
	                    x: vertices[j].y - vertices[i].y, 
	                    y: vertices[i].x - vertices[j].x
	                }),
	                gradient = (normal.y === 0) ? Infinity : (normal.x / normal.y);
	            
	            // limit precision
	            gradient = gradient.toFixed(3).toString();
	            axes[gradient] = normal;
	        }
	
	        return Common.values(axes);
	    };
	
	    /**
	     * Rotates a set of axes by the given angle.
	     * @method rotate
	     * @param {axes} axes
	     * @param {number} angle
	     */
	    Axes.rotate = function(axes, angle) {
	        if (angle === 0)
	            return;
	        
	        var cos = Math.cos(angle),
	            sin = Math.sin(angle);
	
	        for (var i = 0; i < axes.length; i++) {
	            var axis = axes[i],
	                xx;
	            xx = axis.x * cos - axis.y * sin;
	            axis.y = axis.x * sin + axis.y * cos;
	            axis.x = xx;
	        }
	    };
	
	})();


/***/ }),
/* 322 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @typedef {object} Phaser.Plugins.DefaultPlugins
	 * 
	 * @property {array} Global - These are the Global Managers that are created by the Phaser.Game instance.
	 * @property {array} CoreScene - These are the core plugins that are installed into every Scene.Systems instance, no matter what.
	 * @property {array} DefaultScene - These plugins are created in Scene.Systems in addition to the CoreScenePlugins.
	 */
	
	var DefaultPlugins = {
	
	    /**
	     * These are the Global Managers that are created by the Phaser.Game instance.
	     * They are referenced from Scene.Systems so that plugins can use them.
	     * 
	     * @name Phaser.Plugins.Global
	     * @type {array}
	     * @since 3.0.0
	     */
	    Global: [
	
	        'anims',
	        'cache',
	        'plugins',
	        'registry',
	        'sound',
	        'textures'
	
	    ],
	
	    /**
	     * These are the core plugins that are installed into every Scene.Systems instance, no matter what.
	     * They are optionally exposed in the Scene as well (see the InjectionMap for details)
	     * 
	     * They are created in the order in which they appear in this array and EventEmitter is always first.
	     * 
	     * @name Phaser.Plugins.CoreScene
	     * @type {array}
	     * @since 3.0.0
	     */
	    CoreScene: [
	
	        'EventEmitter',
	
	        'CameraManager',
	        'GameObjectCreator',
	        'GameObjectFactory',
	        'ScenePlugin',
	        'DisplayList',
	        'UpdateList'
	
	    ],
	
	    /**
	     * These plugins are created in Scene.Systems in addition to the CoreScenePlugins.
	     * 
	     * You can elect not to have these plugins by either creating a DefaultPlugins object as part
	     * of the Game Config, by creating a Plugins object as part of a Scene Config, or by modifying this array
	     * and building your own bundle.
	     * 
	     * They are optionally exposed in the Scene as well (see the InjectionMap for details)
	     * 
	     * They are always created in the order in which they appear in the array.
	     * 
	     * @name Phaser.Plugins.DefaultScene
	     * @type {array}
	     * @since 3.0.0
	     */
	    DefaultScene: [
	
	        'CameraManager3D',
	        'Clock',
	        'DataManagerPlugin',
	        'InputPlugin',
	        'Loader',
	        'TweenManager',
	        'LightsPlugin'
	
	    ]
	
	};
	
	module.exports = DefaultPlugins;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Felipe Alfonso <@bitnenfer>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var ShaderSourceFS = __webpack_require__(1510);
	var TextureTintPipeline = __webpack_require__(324);
	
	var LIGHT_COUNT = 10;
	
	/**
	 * @classdesc
	 * ForwardDiffuseLightPipeline implements a forward rendering approach for 2D lights.
	 * This pipeline extends TextureTintPipeline so it implements all it's rendering functions
	 * and batching system.
	 *
	 * @class ForwardDiffuseLightPipeline
	 * @extends Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline
	 * @memberOf Phaser.Renderer.WebGL.Pipelines
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {object} config - [description]
	 */
	var ForwardDiffuseLightPipeline = new Class({
	
	    Extends: TextureTintPipeline,
	
	    initialize:
	
	    function ForwardDiffuseLightPipeline (config)
	    {
	        config.fragShader = ShaderSourceFS.replace('%LIGHT_COUNT%', LIGHT_COUNT.toString());
	
	        TextureTintPipeline.call(this, config);
	    },
	
	    /**
	     * This function binds it's base class resources and this lights 2D resources.
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.ForwardDiffuseLightPipeline#onBind
	     * @override
	     * @since 3.0.0
	     *
	     * @return {Phaser.Renderer.WebGL.Pipelines.ForwardDiffuseLightPipeline} [description]
	     */
	    onBind: function ()
	    {
	        TextureTintPipeline.prototype.onBind.call(this);
	
	        var renderer = this.renderer;
	        var program = this.program;
	
	        this.mvpUpdate();
	
	        renderer.setInt1(program, 'uNormSampler', 1);
	        renderer.setFloat2(program, 'uResolution', this.width, this.height);
	
	        return this;
	    },
	
	    /**
	     * This function sets all the needed resources for each camera pass.
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.ForwardDiffuseLightPipeline#onRender
	     * @since 3.0.0
	     *
	     * @param {Phaser.Scene} scene - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.Pipelines.ForwardDiffuseLightPipeline} [description]
	     */
	    onRender: function (scene, camera)
	    {
	        var lightManager = scene.sys.lights;
	
	        if (!lightManager)
	        {
	            return this;
	        }
	
	        lightManager.culledLights.length = 0;
	
	        if (lightManager.lights.length <= 0 || !lightManager.active)
	        {
	            return this; // If not visible lights just passthrough
	        }
	
	        var renderer = this.renderer;
	        var program = this.program;
	        var lights = lightManager.cull(camera);
	        var lightCount = Math.min(lights.length, LIGHT_COUNT);
	        var cameraMatrix = camera.matrix;
	        var point = {x: 0, y: 0};
	        var height = renderer.height;
	        var index;
	
	        for (index = 0; index < LIGHT_COUNT; ++index)
	        {
	            renderer.setFloat1(program, 'uLights[' + index + '].radius', 0); // reset lights
	        }
	
	        if (lightCount <= 0) { return this; }
	
	        renderer.setFloat4(program, 'uCamera', camera.x, camera.y, camera.rotation, camera.zoom);
	        renderer.setFloat3(program, 'uAmbientLightColor', lightManager.ambientColor.r, lightManager.ambientColor.g, lightManager.ambientColor.b);
	
	        for (index = 0; index < lightCount; ++index)
	        {
	            var light = lights[index];
	            var lightName = 'uLights[' + index + '].';
	            cameraMatrix.transformPoint(light.x, light.y, point);
	            renderer.setFloat2(program, lightName + 'position', point.x - (camera.scrollX * light.scrollFactorX * camera.zoom), height - (point.y - (camera.scrollY * light.scrollFactorY) * camera.zoom));
	            renderer.setFloat3(program, lightName + 'color', light.r, light.g, light.b);
	            renderer.setFloat1(program, lightName + 'intensity', light.intensity);
	            renderer.setFloat1(program, lightName + 'radius', light.radius);
	        }
	        
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.ForwardDiffuseLightPipeline#drawStaticTilemapLayer
	     * @override
	     * @since 3.0.0
	     *
	     * @param {Phaser.Tilemaps.StaticTilemapLayer} tilemap - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - [description]
	     */
	    drawStaticTilemapLayer: function (tilemap, camera, parentTransformMatrix)
	    {
	        var normalTexture = tilemap.tileset.image.dataSource[0];
	
	        if (normalTexture)
	        {
	            this.renderer.setPipeline(this);
	            this.setTexture2D(normalTexture.glTexture, 1);
	            TextureTintPipeline.prototype.drawStaticTilemapLayer.call(this, tilemap, camera, parentTransformMatrix);
	        }
	        else
	        {
	            console.warn('Normal map texture missing for using Light2D pipeline. StaticTilemapLayer rendered with default pipeline.');
	            this.renderer.pipelines.TextureTintPipeline.drawStaticTilemapLayer(tilemap, camera, parentTransformMatrix);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.ForwardDiffuseLightPipeline#drawEmitterManager
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Particles.ParticleEmitterManager} emitterManager - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - [description]
	     *
	     */
	    drawEmitterManager: function (emitterManager, camera, parentTransformMatrix)
	    {
	        var normalTexture = emitterManager.texture.dataSource[emitterManager.frame.sourceIndex];
	
	        if (normalTexture)
	        {
	            this.renderer.setPipeline(this);
	            this.setTexture2D(normalTexture.glTexture, 1);
	            TextureTintPipeline.prototype.drawEmitterManager.call(this, emitterManager, camera, parentTransformMatrix);
	        }
	        else
	        {
	            console.warn('Normal map texture missing for using Light2D pipeline. EmitterManager rendered with default pipeline.');
	            this.renderer.pipelines.TextureTintPipeline.drawEmitterManager(emitterManager, camera, parentTransformMatrix);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.ForwardDiffuseLightPipeline#drawBlitter
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Blitter} blitter - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - [description]
	     *
	     */
	    drawBlitter: function (blitter, camera, parentTransformMatrix)
	    {
	        var normalTexture = blitter.texture.dataSource[blitter.frame.sourceIndex];
	
	        if (normalTexture)
	        {
	            this.renderer.setPipeline(this);
	            this.setTexture2D(normalTexture.glTexture, 1);
	            TextureTintPipeline.prototype.drawBlitter.call(this, blitter, camera, parentTransformMatrix);
	        }
	        else
	        {
	            console.warn('Normal map texture missing for using Light2D pipeline. Blitter rendered with default pipeline.');
	            this.renderer.pipelines.TextureTintPipeline.drawBlitter(blitter, camera, parentTransformMatrix);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.ForwardDiffuseLightPipeline#batchSprite
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Sprite} sprite - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - [description]
	     *
	     */
	    batchSprite: function (sprite, camera, parentTransformMatrix)
	    {
	        var normalTexture = sprite.texture.dataSource[sprite.frame.sourceIndex];
	
	        if (normalTexture)
	        {
	            this.renderer.setPipeline(this);
	            this.setTexture2D(normalTexture.glTexture, 1);
	            TextureTintPipeline.prototype.batchSprite.call(this, sprite, camera, parentTransformMatrix);
	        }
	        else
	        {
	            console.warn('Normal map texture missing for using Light2D pipeline. Sprite rendered with default pipeline.');
	            this.renderer.pipelines.TextureTintPipeline.batchSprite(sprite, camera, parentTransformMatrix);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.ForwardDiffuseLightPipeline#batchMesh
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Mesh} mesh - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - [description]
	     *
	     */
	    batchMesh: function (mesh, camera, parentTransformMatrix)
	    {
	        var normalTexture = mesh.texture.dataSource[mesh.frame.sourceIndex];
	
	        if (normalTexture)
	        {
	            this.renderer.setPipeline(this);
	            this.setTexture2D(normalTexture.glTexture, 1);
	            TextureTintPipeline.prototype.batchMesh.call(this, mesh, camera, parentTransformMatrix);
	        }
	        else
	        {
	            console.warn('Normal map texture missing for using Light2D pipeline. Mesh rendered with default pipeline.');
	            this.renderer.pipelines.TextureTintPipeline.batchMesh(mesh, camera, parentTransformMatrix);
	
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.ForwardDiffuseLightPipeline#batchBitmapText
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.BitmapText} bitmapText - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - [description]
	     *
	     */
	    batchBitmapText: function (bitmapText, camera, parentTransformMatrix)
	    {
	        var normalTexture = bitmapText.texture.dataSource[bitmapText.frame.sourceIndex];
	
	        if (normalTexture)
	        {
	            this.renderer.setPipeline(this);
	            this.setTexture2D(normalTexture.glTexture, 1);
	            TextureTintPipeline.prototype.batchBitmapText.call(this, bitmapText, camera, parentTransformMatrix);
	        }
	        else
	        {
	            console.warn('Normal map texture missing for using Light2D pipeline. BitmapText rendered with default pipeline.');
	            this.renderer.pipelines.TextureTintPipeline.batchBitmapText(bitmapText, camera, parentTransformMatrix);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.ForwardDiffuseLightPipeline#batchDynamicBitmapText
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.DynamicBitmapText} bitmapText - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - [description]
	     *
	     */
	    batchDynamicBitmapText: function (bitmapText, camera, parentTransformMatrix)
	    {
	        var normalTexture = bitmapText.texture.dataSource[bitmapText.frame.sourceIndex];
	
	        if (normalTexture)
	        {
	            this.renderer.setPipeline(this);
	            this.setTexture2D(normalTexture.glTexture, 1);
	            TextureTintPipeline.prototype.batchDynamicBitmapText.call(this, bitmapText, camera, parentTransformMatrix);
	        }
	        else
	        {
	            console.warn('Normal map texture missing for using Light2D pipeline. DynamicBitmapText rendered with default pipeline.');
	            this.renderer.pipelines.TextureTintPipeline.batchDynamicBitmapText(bitmapText, camera, parentTransformMatrix);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.ForwardDiffuseLightPipeline#batchText
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Text} text - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - [description]
	     *
	     */
	    batchText: function (text, camera, parentTransformMatrix)
	    {
	        var normalTexture = text.texture.dataSource[text.frame.sourceIndex];
	
	        if (normalTexture)
	        {
	            this.renderer.setPipeline(this);
	            this.setTexture2D(normalTexture.glTexture, 1);
	            TextureTintPipeline.prototype.batchText.call(this, text, camera, parentTransformMatrix);
	        }
	        else
	        {
	            console.warn('Normal map texture missing for using Light2D pipeline. Text rendered with default pipeline.');
	            this.renderer.pipelines.TextureTintPipeline.batchText(text, camera, parentTransformMatrix);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.ForwardDiffuseLightPipeline#batchDynamicTilemapLayer
	     * @since 3.0.0
	     *
	     * @param {Phaser.Tilemaps.DynamicTilemapLayer} tilemapLayer - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - [description]
	     *
	     */
	    batchDynamicTilemapLayer: function (tilemapLayer, camera, parentTransformMatrix)
	    {
	        var normalTexture = tilemapLayer.tileset.image.dataSource[0];
	
	        if (normalTexture)
	        {
	            this.renderer.setPipeline(this);
	            this.setTexture2D(normalTexture.glTexture, 1);
	            TextureTintPipeline.prototype.batchDynamicTilemapLayer.call(this, tilemapLayer, camera, parentTransformMatrix);
	        }
	        else
	        {
	            console.warn('Normal map texture missing for using Light2D pipeline. DynamicTilemapLayer rendered with default pipeline.');
	            this.renderer.pipelines.TextureTintPipeline.batchDynamicTilemapLayer(tilemapLayer, camera, parentTransformMatrix);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.ForwardDiffuseLightPipeline#batchTileSprite
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.TileSprite} tileSprite - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - [description]
	     *
	     */
	    batchTileSprite: function (tileSprite, camera, parentTransformMatrix)
	    {
	        var normalTexture = tileSprite.texture.dataSource[tileSprite.frame.sourceIndex];
	
	        if (normalTexture)
	        {
	            this.renderer.setPipeline(this);
	            this.setTexture2D(normalTexture.glTexture, 1);
	            TextureTintPipeline.prototype.batchTileSprite.call(this, tileSprite, camera, parentTransformMatrix);
	        }
	        else
	        {
	            console.warn('Normal map texture missing for using Light2D pipeline. TileSprite rendered with default pipeline.');
	            this.renderer.pipelines.TextureTintPipeline.batchTileSprite(tileSprite, camera, parentTransformMatrix);
	        }
	    }
	
	});
	
	ForwardDiffuseLightPipeline.LIGHT_COUNT = LIGHT_COUNT;
	
	module.exports = ForwardDiffuseLightPipeline;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Felipe Alfonso <@bitnenfer>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var ModelViewProjection = __webpack_require__(621);
	var ShaderSourceFS = __webpack_require__(1511);
	var ShaderSourceVS = __webpack_require__(1512);
	var Utils = __webpack_require__(87);
	var WebGLPipeline = __webpack_require__(207);
	
	/**
	 * @classdesc
	 * TextureTintPipeline implements the rendering infrastructure
	 * for displaying textured objects
	 * The config properties are:
	 * - game: Current game instance.
	 * - renderer: Current WebGL renderer.
	 * - topology: This indicates how the primitives are rendered. The default value is GL_TRIANGLES.
	 *              Here is the full list of rendering primitives (https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/Constants).
	 * - vertShader: Source for vertex shader as a string.
	 * - fragShader: Source for fragment shader as a string.
	 * - vertexCapacity: The amount of vertices that shall be allocated
	 * - vertexSize: The size of a single vertex in bytes.
	 *
	 * @class TextureTintPipeline
	 * @extends Phaser.Renderer.WebGL.WebGLPipeline
	 * @memberOf Phaser.Renderer.WebGL.Pipelines
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {object} config - [description]
	 */
	var TextureTintPipeline = new Class({
	
	    Extends: WebGLPipeline,
	
	    Mixins: [
	        ModelViewProjection
	    ],
	
	    initialize:
	
	    function TextureTintPipeline (config)
	    {
	        WebGLPipeline.call(this, {
	            game: config.game,
	            renderer: config.renderer,
	            gl: config.renderer.gl,
	            topology: (config.topology ? config.topology : config.renderer.gl.TRIANGLES),
	            vertShader: (config.vertShader ? config.vertShader : ShaderSourceVS),
	            fragShader: (config.fragShader ? config.fragShader : ShaderSourceFS),
	            vertexCapacity: (config.vertexCapacity ? config.vertexCapacity : 6 * 2000),
	
	            vertexSize: (config.vertexSize ? config.vertexSize :
	                Float32Array.BYTES_PER_ELEMENT * 2 +
	                Float32Array.BYTES_PER_ELEMENT * 2 +
	                Uint8Array.BYTES_PER_ELEMENT * 4),
	
	            attributes: [
	                {
	                    name: 'inPosition',
	                    size: 2,
	                    type: config.renderer.gl.FLOAT,
	                    normalized: false,
	                    offset: 0
	                },
	                {
	                    name: 'inTexCoord',
	                    size: 2,
	                    type: config.renderer.gl.FLOAT,
	                    normalized: false,
	                    offset: Float32Array.BYTES_PER_ELEMENT * 2
	                },
	                {
	                    name: 'inTint',
	                    size: 4,
	                    type: config.renderer.gl.UNSIGNED_BYTE,
	                    normalized: true,
	                    offset: Float32Array.BYTES_PER_ELEMENT * 4
	                }
	            ]
	        });
	
	        /**
	         * Float32 view of the array buffer containing the pipeline's vertices.
	         *
	         * @name Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline#vertexViewF32
	         * @type {Float32Array}
	         * @since 3.0.0
	         */
	        this.vertexViewF32 = new Float32Array(this.vertexData);
	
	        /**
	         * Uint32 view of the array buffer containing the pipeline's vertices.
	         *
	         * @name Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline#vertexViewU32
	         * @type {Uint32Array}
	         * @since 3.0.0
	         */
	        this.vertexViewU32 = new Uint32Array(this.vertexData);
	
	        /**
	         * Size of the batch.
	         *
	         * @name Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline#maxQuads
	         * @type {integer}
	         * @default 2000
	         * @since 3.0.0
	         */
	        this.maxQuads = 2000;
	
	        /**
	         * Collection of batch information
	         *
	         * @name Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline#batches
	         * @type {array}
	         * @since 3.1.0
	         */
	        this.batches = [];
	
	        this.mvpInit();
	    },
	
	    /**
	     * Assigns a texture to the current batch. If a texture is already set it creates
	     * a new batch object.
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline#setTexture2D
	     * @since 3.1.0
	     *
	     * @param {WebGLTexture} texture - WebGLTexture that will be assigned to the current batch.
	     * @param {integer} textureUnit - Texture unit to which the texture needs to be bound.
	     *
	     * @return {Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline} [description]
	     */
	    setTexture2D: function (texture, unit)
	    {
	        if (!texture)
	        {
	            return this;
	        }
	
	        var batches = this.batches;
	
	        if (batches.length === 0)
	        {
	            this.pushBatch();
	        }
	
	        var batch = batches[batches.length - 1];
	
	        if (unit > 0)
	        {
	            if (batch.textures[unit - 1] &&
	                batch.textures[unit - 1] !== texture)
	            {
	                this.pushBatch();
	            }
	
	            batches[batches.length - 1].textures[unit - 1] = texture;
	        }
	        else
	        {
	            if (batch.texture !== null &&
	                batch.texture !== texture)
	            {
	                this.pushBatch();
	            }
	
	            batches[batches.length - 1].texture = texture;
	        }
	
	        return this;
	    },
	
	    /**
	     * Creates a new batch object and pushes it to a batch array.
	     * The batch object contains information relevant to the current 
	     * vertex batch like the offset in the vertex buffer, vertex count and 
	     * the textures used by that batch.
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline#pushBatch
	     * @since 3.1.0
	     */
	    pushBatch: function ()
	    {
	        var batch = {
	            first: this.vertexCount,
	            texture: null,
	            textures: []
	        };
	
	        this.batches.push(batch);
	    },
	
	    /**
	     * Binds, uploads resources and processes all batches generating draw calls.
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline#flush
	     * @since 3.1.0
	     *
	     * @return {Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline} This Pipeline.
	     */
	    flush: function ()
	    {
	        if (this.flushLocked)
	        {
	            return this;
	        }
	
	        this.flushLocked = true;
	
	        var gl = this.gl;
	        var renderer = this.renderer;
	        var vertexCount = this.vertexCount;
	        var topology = this.topology;
	        var vertexSize = this.vertexSize;
	        var batches = this.batches;
	        var batchCount = batches.length;
	        var batchVertexCount = 0;
	        var batch = null;
	        var batchNext;
	        var textureIndex;
	        var nTexture;
	
	        if (batchCount === 0 || vertexCount === 0)
	        {
	            this.flushLocked = false;
	            return this;
	        }
	
	        gl.bufferSubData(gl.ARRAY_BUFFER, 0, this.bytes.subarray(0, vertexCount * vertexSize));
	
	        for (var index = 0; index < batches.length - 1; ++index)
	        {
	            batch = batches[index];
	            batchNext = batches[index + 1];
	
	            if (batch.textures.length > 0)
	            {
	                for (textureIndex = 0; textureIndex < batch.textures.length; ++textureIndex)
	                {
	                    nTexture = batch.textures[textureIndex];
	
	                    if (nTexture)
	                    {
	                        renderer.setTexture2D(nTexture, 1 + textureIndex);
	                    }
	                }
	
	                gl.activeTexture(gl.TEXTURE0);
	            }
	
	            batchVertexCount = batchNext.first - batch.first;
	
	            if (batch.texture === null || batchVertexCount <= 0) { continue; }
	
	            renderer.setTexture2D(batch.texture, 0);
	            gl.drawArrays(topology, batch.first, batchVertexCount);
	        }
	
	        // Left over data
	        batch = batches[batches.length - 1];
	
	        if (batch.textures.length > 0)
	        {
	            for (textureIndex = 0; textureIndex < batch.textures.length; ++textureIndex)
	            {
	                nTexture = batch.textures[textureIndex];
	
	                if (nTexture)
	                {
	                    renderer.setTexture2D(nTexture, 1 + textureIndex);
	                }
	            }
	
	            gl.activeTexture(gl.TEXTURE0);
	        }
	
	        batchVertexCount = vertexCount - batch.first;
	
	        if (batch.texture && batchVertexCount > 0)
	        {
	            renderer.setTexture2D(batch.texture, 0);
	            gl.drawArrays(topology, batch.first, batchVertexCount);
	        }
	
	        this.vertexCount = 0;
	        batches.length = 0;
	        this.pushBatch();
	        this.flushLocked = false;
	
	        return this;
	    },
	
	    /**
	     * Called every time the pipeline needs to be used.
	     * It binds all necessary resources.
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline#onBind
	     * @since 3.0.0
	     *
	     * @return {Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline} [description]
	     */
	    onBind: function ()
	    {
	        WebGLPipeline.prototype.onBind.call(this);
	
	        this.mvpUpdate();
	
	        if (this.batches.length === 0)
	        {
	            this.pushBatch();
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline#resize
	     * @since 3.0.0
	     *
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     * @param {number} resolution - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline} [description]
	     */
	    resize: function (width, height, resolution)
	    {
	        WebGLPipeline.prototype.resize.call(this, width, height, resolution);
	        this.projOrtho(0, this.width, this.height, 0, -1000.0, 1000.0);
	        return this;
	    },
	
	    /**
	     * Renders immediately a static tilemap. This function won't use
	     * the batching functionality of the pipeline.
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline#drawStaticTilemapLayer
	     * @since 3.0.0
	     *
	     * @param {Phaser.Tilemaps.StaticTilemapLayer} tilemap - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - [description]
	     */
	    drawStaticTilemapLayer: function (tilemap)
	    {
	        if (tilemap.vertexCount > 0)
	        {
	            var pipelineVertexBuffer = this.vertexBuffer;
	            var gl = this.gl;
	            var renderer = this.renderer;
	            var frame = tilemap.tileset.image.get();
	
	            if (renderer.currentPipeline &&
	                renderer.currentPipeline.vertexCount > 0)
	            {
	                renderer.flush();
	            }
	
	            this.vertexBuffer = tilemap.vertexBuffer;
	            renderer.setPipeline(this);
	            renderer.setTexture2D(frame.source.glTexture, 0);
	            gl.drawArrays(this.topology, 0, tilemap.vertexCount);
	            this.vertexBuffer = pipelineVertexBuffer;
	        }
	
	        this.viewIdentity();
	        this.modelIdentity();
	    },
	
	    /**
	     * Renders contents of a ParticleEmitterManager. It'll batch all particles if possible.
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline#drawEmitterManager
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Particles.ParticleEmitterManager} emitterManager - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - [description]
	     */
	    drawEmitterManager: function (emitterManager, camera, parentTransformMatrix)
	    {
	        var parentMatrix = null;
	
	        if (parentTransformMatrix)
	        {
	            parentMatrix = parentTransformMatrix.matrix;
	        }
	
	        this.renderer.setPipeline(this);
	
	        var roundPixels = this.renderer.config.roundPixels;
	        var emitters = emitterManager.emitters.list;
	        var emitterCount = emitters.length;
	        var vertexViewF32 = this.vertexViewF32;
	        var vertexViewU32 = this.vertexViewU32;
	        var renderer = this.renderer;
	        var maxQuads = this.maxQuads;
	        var cameraScrollX = camera.scrollX;
	        var cameraScrollY = camera.scrollY;
	        var cameraMatrix = camera.matrix.matrix;
	        var cma = cameraMatrix[0];
	        var cmb = cameraMatrix[1];
	        var cmc = cameraMatrix[2];
	        var cmd = cameraMatrix[3];
	        var cme = cameraMatrix[4];
	        var cmf = cameraMatrix[5];
	        var sin = Math.sin;
	        var cos = Math.cos;
	        var vertexComponentCount = this.vertexComponentCount;
	        var vertexCapacity = this.vertexCapacity;
	        var texture = emitterManager.defaultFrame.source.glTexture;
	        var pca, pcb, pcc, pcd, pce, pcf;
	        var pma, pmb, pmc, pmd, pme, pmf;
	
	        if (parentMatrix)
	        {
	            pma = parentMatrix[0];
	            pmb = parentMatrix[1];
	            pmc = parentMatrix[2];
	            pmd = parentMatrix[3];
	            pme = parentMatrix[4];
	            pmf = parentMatrix[5];
	        }
	
	        this.setTexture2D(texture, 0);
	        
	        for (var emitterIndex = 0; emitterIndex < emitterCount; ++emitterIndex)
	        {
	            var emitter = emitters[emitterIndex];
	            var particles = emitter.alive;
	            var aliveLength = particles.length;
	            var batchCount = Math.ceil(aliveLength / maxQuads);
	            var particleOffset = 0;
	            var scrollX = cameraScrollX * emitter.scrollFactorX;
	            var scrollY = cameraScrollY * emitter.scrollFactorY;
	
	            if (parentMatrix)
	            {
	                var cse = -scrollX;
	                var csf = -scrollY;
	                var pse = cse * cma + csf * cmc + cme;
	                var psf = cse * cmb + csf * cmd + cmf;
	                pca = pma * cma + pmb * cmc;
	                pcb = pma * cmb + pmb * cmd;
	                pcc = pmc * cma + pmd * cmc;
	                pcd = pmc * cmb + pmd * cmd;
	                pce = pme * cma + pmf * cmc + pse;
	                pcf = pme * cmb + pmf * cmd + psf;
	
	                cma = pca;
	                cmb = pcb;
	                cmc = pcc;
	                cmd = pcd;
	                cme = pce;
	                cmf = pcf;
	
	                scrollX = 0.0;
	                scrollY = 0.0;
	            }
	
	
	            if (!emitter.visible || aliveLength === 0)
	            {
	                continue;
	            }
	
	            renderer.setBlendMode(emitter.blendMode);
	
	            if (this.vertexCount >= vertexCapacity)
	            {
	                this.flush();
	                this.setTexture2D(texture, 0);
	            }
	
	            for (var batchIndex = 0; batchIndex < batchCount; ++batchIndex)
	            {
	                var batchSize = Math.min(aliveLength, maxQuads);
	
	                for (var index = 0; index < batchSize; ++index)
	                {
	                    var particle = particles[particleOffset + index];
	
	                    if (particle.alpha <= 0)
	                    {
	                        continue;
	                    }
	
	                    var frame = particle.frame;
	                    var uvs = frame.uvs;
	                    var x = -(frame.halfWidth);
	                    var y = -(frame.halfHeight);
	                    var color = particle.color;
	                    var xw = x + frame.width;
	                    var yh = y + frame.height;
	                    var sr = sin(particle.rotation);
	                    var cr = cos(particle.rotation);
	                    var sra = cr * particle.scaleX;
	                    var srb = sr * particle.scaleX;
	                    var src = -sr * particle.scaleY;
	                    var srd = cr * particle.scaleY;
	                    var sre = particle.x - scrollX;
	                    var srf = particle.y - scrollY;
	                    var mva = sra * cma + srb * cmc;
	                    var mvb = sra * cmb + srb * cmd;
	                    var mvc = src * cma + srd * cmc;
	                    var mvd = src * cmb + srd * cmd;
	                    var mve = sre * cma + srf * cmc + cme;
	                    var mvf = sre * cmb + srf * cmd + cmf;
	                    var tx0 = x * mva + y * mvc + mve;
	                    var ty0 = x * mvb + y * mvd + mvf;
	                    var tx1 = x * mva + yh * mvc + mve;
	                    var ty1 = x * mvb + yh * mvd + mvf;
	                    var tx2 = xw * mva + yh * mvc + mve;
	                    var ty2 = xw * mvb + yh * mvd + mvf;
	                    var tx3 = xw * mva + y * mvc + mve;
	                    var ty3 = xw * mvb + y * mvd + mvf;
	                    var vertexOffset = this.vertexCount * vertexComponentCount;
	
	                    if (roundPixels)
	                    {
	                        tx0 |= 0;
	                        ty0 |= 0;
	                        tx1 |= 0;
	                        ty1 |= 0;
	                        tx2 |= 0;
	                        ty2 |= 0;
	                        tx3 |= 0;
	                        ty3 |= 0;
	                    }
	
	                    vertexViewF32[vertexOffset + 0] = tx0;
	                    vertexViewF32[vertexOffset + 1] = ty0;
	                    vertexViewF32[vertexOffset + 2] = uvs.x0;
	                    vertexViewF32[vertexOffset + 3] = uvs.y0;
	                    vertexViewU32[vertexOffset + 4] = color;
	                    vertexViewF32[vertexOffset + 5] = tx1;
	                    vertexViewF32[vertexOffset + 6] = ty1;
	                    vertexViewF32[vertexOffset + 7] = uvs.x1;
	                    vertexViewF32[vertexOffset + 8] = uvs.y1;
	                    vertexViewU32[vertexOffset + 9] = color;
	                    vertexViewF32[vertexOffset + 10] = tx2;
	                    vertexViewF32[vertexOffset + 11] = ty2;
	                    vertexViewF32[vertexOffset + 12] = uvs.x2;
	                    vertexViewF32[vertexOffset + 13] = uvs.y2;
	                    vertexViewU32[vertexOffset + 14] = color;
	                    vertexViewF32[vertexOffset + 15] = tx0;
	                    vertexViewF32[vertexOffset + 16] = ty0;
	                    vertexViewF32[vertexOffset + 17] = uvs.x0;
	                    vertexViewF32[vertexOffset + 18] = uvs.y0;
	                    vertexViewU32[vertexOffset + 19] = color;
	                    vertexViewF32[vertexOffset + 20] = tx2;
	                    vertexViewF32[vertexOffset + 21] = ty2;
	                    vertexViewF32[vertexOffset + 22] = uvs.x2;
	                    vertexViewF32[vertexOffset + 23] = uvs.y2;
	                    vertexViewU32[vertexOffset + 24] = color;
	                    vertexViewF32[vertexOffset + 25] = tx3;
	                    vertexViewF32[vertexOffset + 26] = ty3;
	                    vertexViewF32[vertexOffset + 27] = uvs.x3;
	                    vertexViewF32[vertexOffset + 28] = uvs.y3;
	                    vertexViewU32[vertexOffset + 29] = color;
	
	                    this.vertexCount += 6;
	
	                    if (this.vertexCount >= vertexCapacity)
	                    {
	                        this.flush();
	                        this.setTexture2D(texture, 0);
	                    }
	
	                }
	
	                particleOffset += batchSize;
	                aliveLength -= batchSize;
	
	                if (this.vertexCount >= vertexCapacity)
	                {
	                    this.flush();
	                    this.setTexture2D(texture, 0);
	                }
	            }
	        }
	        
	        this.setTexture2D(texture, 0);
	    },
	
	    /**
	     * Batches blitter game object
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline#drawBlitter
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Blitter} blitter - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - [description]
	     */
	    drawBlitter: function (blitter, camera, parentTransformMatrix)
	    {
	        var parentMatrix = null;
	
	        if (parentTransformMatrix)
	        {
	            parentMatrix = parentTransformMatrix.matrix;
	        }
	
	        this.renderer.setPipeline(this);
	
	        var roundPixels = this.renderer.config.roundPixels;
	        var getTint = Utils.getTintAppendFloatAlpha;
	        var vertexViewF32 = this.vertexViewF32;
	        var vertexViewU32 = this.vertexViewU32;
	        var list = blitter.getRenderList();
	        var length = list.length;
	        var cameraMatrix = camera.matrix.matrix;
	        var a = cameraMatrix[0];
	        var b = cameraMatrix[1];
	        var c = cameraMatrix[2];
	        var d = cameraMatrix[3];
	        var e = cameraMatrix[4];
	        var f = cameraMatrix[5];
	        var cameraScrollX = camera.scrollX * blitter.scrollFactorX;
	        var cameraScrollY = camera.scrollY * blitter.scrollFactorY;
	        var batchCount = Math.ceil(length / this.maxQuads);
	        var batchOffset = 0;
	
	        if (parentMatrix)
	        {
	            var pma = parentMatrix[0];
	            var pmb = parentMatrix[1];
	            var pmc = parentMatrix[2];
	            var pmd = parentMatrix[3];
	            var pme = parentMatrix[4];
	            var pmf = parentMatrix[5];
	            var cse = -cameraScrollX;
	            var csf = -cameraScrollY;
	            var pse = cse * a + csf * c + e;
	            var psf = cse * b + csf * d + f;
	            var pca = pma * a + pmb * c;
	            var pcb = pma * b + pmb * d;
	            var pcc = pmc * a + pmd * c;
	            var pcd = pmc * b + pmd * d;
	            var pce = pme * a + pmf * c + pse;
	            var pcf = pme * b + pmf * d + psf;
	
	            a = pca;
	            b = pcb;
	            c = pcc;
	            d = pcd;
	            e = pce;
	            f = pcf;
	
	            cameraScrollX = 0.0;
	            cameraScrollY = 0.0;
	        }
	
	        var blitterX = blitter.x - cameraScrollX;
	        var blitterY = blitter.y - cameraScrollY;
	
	        var prevTextureSourceIndex;
	
	        for (var batchIndex = 0; batchIndex < batchCount; ++batchIndex)
	        {
	            var batchSize = Math.min(length, this.maxQuads);
	
	            for (var index = 0; index < batchSize; ++index)
	            {
	                var bob = list[batchOffset + index];
	                var frame = bob.frame;
	                var alpha = bob.alpha;
	
	                if (alpha === 0)
	                {
	                    //  Nothing to see here, moving on ...
	                    continue;
	                }
	
	                var tint = getTint(0xffffff, alpha);
	                var uvs = frame.uvs;
	                var flipX = bob.flipX;
	                var flipY = bob.flipY;
	                var width = frame.width * (flipX ? -1.0 : 1.0);
	                var height = frame.height * (flipY ? -1.0 : 1.0);
	                var x = blitterX + bob.x + frame.x + (frame.width * ((flipX) ? 1.0 : 0.0));
	                var y = blitterY + bob.y + frame.y + (frame.height * ((flipY) ? 1.0 : 0.0));
	                var xw = x + width;
	                var yh = y + height;
	                var tx0 = x * a + y * c + e;
	                var ty0 = x * b + y * d + f;
	                var tx1 = xw * a + yh * c + e;
	                var ty1 = xw * b + yh * d + f;
	            
	                //  Bind texture only if the Texture Source is different from before
	                if (frame.sourceIndex !== prevTextureSourceIndex)
	                {
	                    this.setTexture2D(frame.texture.source[frame.sourceIndex].glTexture, 0);
	
	                    prevTextureSourceIndex = frame.sourceIndex;
	                }
	
	                var vertexOffset = this.vertexCount * this.vertexComponentCount;
	
	                if (roundPixels)
	                {
	                    tx0 |= 0;
	                    ty0 |= 0;
	                    tx1 |= 0;
	                    ty1 |= 0;
	                }
	            
	                vertexViewF32[vertexOffset + 0] = tx0;
	                vertexViewF32[vertexOffset + 1] = ty0;
	                vertexViewF32[vertexOffset + 2] = uvs.x0;
	                vertexViewF32[vertexOffset + 3] = uvs.y0;
	                vertexViewU32[vertexOffset + 4] = tint;
	                vertexViewF32[vertexOffset + 5] = tx0;
	                vertexViewF32[vertexOffset + 6] = ty1;
	                vertexViewF32[vertexOffset + 7] = uvs.x1;
	                vertexViewF32[vertexOffset + 8] = uvs.y1;
	                vertexViewU32[vertexOffset + 9] = tint;
	                vertexViewF32[vertexOffset + 10] = tx1;
	                vertexViewF32[vertexOffset + 11] = ty1;
	                vertexViewF32[vertexOffset + 12] = uvs.x2;
	                vertexViewF32[vertexOffset + 13] = uvs.y2;
	                vertexViewU32[vertexOffset + 14] = tint;
	                vertexViewF32[vertexOffset + 15] = tx0;
	                vertexViewF32[vertexOffset + 16] = ty0;
	                vertexViewF32[vertexOffset + 17] = uvs.x0;
	                vertexViewF32[vertexOffset + 18] = uvs.y0;
	                vertexViewU32[vertexOffset + 19] = tint;
	                vertexViewF32[vertexOffset + 20] = tx1;
	                vertexViewF32[vertexOffset + 21] = ty1;
	                vertexViewF32[vertexOffset + 22] = uvs.x2;
	                vertexViewF32[vertexOffset + 23] = uvs.y2;
	                vertexViewU32[vertexOffset + 24] = tint;
	                vertexViewF32[vertexOffset + 25] = tx1;
	                vertexViewF32[vertexOffset + 26] = ty0;
	                vertexViewF32[vertexOffset + 27] = uvs.x3;
	                vertexViewF32[vertexOffset + 28] = uvs.y3;
	                vertexViewU32[vertexOffset + 29] = tint;
	
	                this.vertexCount += 6;
	
	                if (this.vertexCount >= this.vertexCapacity)
	                {
	                    this.flush();
	
	                    prevTextureSourceIndex = -1;
	                }
	            }
	
	            batchOffset += batchSize;
	            length -= batchSize;
	
	            if (this.vertexCount >= this.vertexCapacity)
	            {
	                this.flush();
	            }
	        }
	    },
	
	    /**
	     * Batches Sprite game object
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline#batchSprite
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Sprite} sprite - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - [description]
	     */
	    batchSprite: function (sprite, camera, parentTransformMatrix)
	    {
	        var parentMatrix = null;
	
	        if (parentTransformMatrix)
	        {
	            parentMatrix = parentTransformMatrix.matrix;
	        }
	
	        this.renderer.setPipeline(this);
	
	        if (this.vertexCount + 6 > this.vertexCapacity)
	        {
	            this.flush();
	        }
	        
	        var roundPixels = this.renderer.config.roundPixels;
	        var getTint = Utils.getTintAppendFloatAlpha;
	        var vertexViewF32 = this.vertexViewF32;
	        var vertexViewU32 = this.vertexViewU32;
	        var cameraMatrix = camera.matrix.matrix;
	        var frame = sprite.frame;
	        var texture = frame.texture.source[frame.sourceIndex].glTexture;
	        var forceFlipY = (texture.isRenderTexture ? true : false);
	        var flipX = sprite.flipX;
	        var flipY = sprite.flipY ^ forceFlipY;
	        var uvs = frame.uvs;
	        var width = frame.width * (flipX ? -1.0 : 1.0);
	        var height = frame.height * (flipY ? -1.0 : 1.0);
	        var x = -sprite.displayOriginX + frame.x + ((frame.width) * (flipX ? 1.0 : 0.0));
	        var y = -sprite.displayOriginY + frame.y + ((frame.height) * (flipY ? 1.0 : 0.0));
	        var xw = (roundPixels ? (x|0) : x) + width;
	        var yh = (roundPixels ? (y|0) : y) + height;
	        var scaleX = sprite.scaleX;
	        var scaleY = sprite.scaleY;
	        var rotation = sprite.rotation;
	        var alphaTL = sprite._alphaTL;
	        var alphaTR = sprite._alphaTR;
	        var alphaBL = sprite._alphaBL;
	        var alphaBR = sprite._alphaBR;
	        var tintTL = sprite._tintTL;
	        var tintTR = sprite._tintTR;
	        var tintBL = sprite._tintBL;
	        var tintBR = sprite._tintBR;
	        var sr = Math.sin(rotation);
	        var cr = Math.cos(rotation);
	        var sra = cr * scaleX;
	        var srb = sr * scaleX;
	        var src = -sr * scaleY;
	        var srd = cr * scaleY;
	        var sre = sprite.x;
	        var srf = sprite.y;
	        var cma = cameraMatrix[0];
	        var cmb = cameraMatrix[1];
	        var cmc = cameraMatrix[2];
	        var cmd = cameraMatrix[3];
	        var cme = cameraMatrix[4];
	        var cmf = cameraMatrix[5];
	        var mva, mvb, mvc, mvd, mve, mvf;
	
	        if (parentMatrix)
	        {
	            var pma = parentMatrix[0];
	            var pmb = parentMatrix[1];
	            var pmc = parentMatrix[2];
	            var pmd = parentMatrix[3];
	            var pme = parentMatrix[4];
	            var pmf = parentMatrix[5];
	            var cse = -camera.scrollX * sprite.scrollFactorX;
	            var csf = -camera.scrollY * sprite.scrollFactorY;
	            var pse = cse * cma + csf * cmc + cme;
	            var psf = cse * cmb + csf * cmd + cmf;
	            var pca = pma * cma + pmb * cmc;
	            var pcb = pma * cmb + pmb * cmd;
	            var pcc = pmc * cma + pmd * cmc;
	            var pcd = pmc * cmb + pmd * cmd;
	            var pce = pme * cma + pmf * cmc + pse;
	            var pcf = pme * cmb + pmf * cmd + psf;
	
	            mva = sra * pca + srb * pcc;
	            mvb = sra * pcb + srb * pcd;
	            mvc = src * pca + srd * pcc;
	            mvd = src * pcb + srd * pcd;
	            mve = sre * pca + srf * pcc + pce;
	            mvf = sre * pcb + srf * pcd + pcf;
	        }
	        else
	        {
	            sre -= camera.scrollX * sprite.scrollFactorX;
	            srf -= camera.scrollY * sprite.scrollFactorY;
	
	            mva = sra * cma + srb * cmc;
	            mvb = sra * cmb + srb * cmd;
	            mvc = src * cma + srd * cmc;
	            mvd = src * cmb + srd * cmd;
	            mve = sre * cma + srf * cmc + cme;
	            mvf = sre * cmb + srf * cmd + cmf;
	        }
	
	        var tx0 = x * mva + y * mvc + mve;
	        var ty0 = x * mvb + y * mvd + mvf;
	        var tx1 = x * mva + yh * mvc + mve;
	        var ty1 = x * mvb + yh * mvd + mvf;
	        var tx2 = xw * mva + yh * mvc + mve;
	        var ty2 = xw * mvb + yh * mvd + mvf;
	        var tx3 = xw * mva + y * mvc + mve;
	        var ty3 = xw * mvb + y * mvd + mvf;
	        var vTintTL = getTint(tintTL, alphaTL);
	        var vTintTR = getTint(tintTR, alphaTR);
	        var vTintBL = getTint(tintBL, alphaBL);
	        var vTintBR = getTint(tintBR, alphaBR);
	        var vertexOffset = 0;
	
	        if (roundPixels)
	        {
	            tx0 |= 0;
	            ty0 |= 0;
	            tx1 |= 0;
	            ty1 |= 0;
	            tx2 |= 0;
	            ty2 |= 0;
	            tx3 |= 0;
	            ty3 |= 0;
	        }
	
	        this.setTexture2D(texture, 0);
	
	        vertexOffset = this.vertexCount * this.vertexComponentCount;
	
	        vertexViewF32[vertexOffset + 0] = tx0;
	        vertexViewF32[vertexOffset + 1] = ty0;
	        vertexViewF32[vertexOffset + 2] = uvs.x0;
	        vertexViewF32[vertexOffset + 3] = uvs.y0;
	        vertexViewU32[vertexOffset + 4] = vTintTL;
	        vertexViewF32[vertexOffset + 5] = tx1;
	        vertexViewF32[vertexOffset + 6] = ty1;
	        vertexViewF32[vertexOffset + 7] = uvs.x1;
	        vertexViewF32[vertexOffset + 8] = uvs.y1;
	        vertexViewU32[vertexOffset + 9] = vTintBL;
	        vertexViewF32[vertexOffset + 10] = tx2;
	        vertexViewF32[vertexOffset + 11] = ty2;
	        vertexViewF32[vertexOffset + 12] = uvs.x2;
	        vertexViewF32[vertexOffset + 13] = uvs.y2;
	        vertexViewU32[vertexOffset + 14] = vTintBR;
	        vertexViewF32[vertexOffset + 15] = tx0;
	        vertexViewF32[vertexOffset + 16] = ty0;
	        vertexViewF32[vertexOffset + 17] = uvs.x0;
	        vertexViewF32[vertexOffset + 18] = uvs.y0;
	        vertexViewU32[vertexOffset + 19] = vTintTL;
	        vertexViewF32[vertexOffset + 20] = tx2;
	        vertexViewF32[vertexOffset + 21] = ty2;
	        vertexViewF32[vertexOffset + 22] = uvs.x2;
	        vertexViewF32[vertexOffset + 23] = uvs.y2;
	        vertexViewU32[vertexOffset + 24] = vTintBR;
	        vertexViewF32[vertexOffset + 25] = tx3;
	        vertexViewF32[vertexOffset + 26] = ty3;
	        vertexViewF32[vertexOffset + 27] = uvs.x3;
	        vertexViewF32[vertexOffset + 28] = uvs.y3;
	        vertexViewU32[vertexOffset + 29] = vTintTR;
	
	        this.vertexCount += 6;
	    },
	
	    /**
	     * Batches Mesh game object
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline#batchMesh
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Mesh} mesh - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - [description]
	     */
	    batchMesh: function (mesh, camera, parentTransformMatrix)
	    {
	        var parentMatrix = null;
	
	        if (parentTransformMatrix)
	        {
	            parentMatrix = parentTransformMatrix.matrix;
	        }
	
	        var vertices = mesh.vertices;
	        var length = vertices.length;
	        var vertexCount = (length / 2)|0;
	
	        this.renderer.setPipeline(this);
	
	        if (this.vertexCount + vertexCount > this.vertexCapacity)
	        {
	            this.flush();
	        }
	
	        var roundPixels = this.renderer.config.roundPixels;
	        var getTint = Utils.getTintAppendFloatAlpha;
	        var uvs = mesh.uv;
	        var colors = mesh.colors;
	        var alphas = mesh.alphas;
	        var vertexViewF32 = this.vertexViewF32;
	        var vertexViewU32 = this.vertexViewU32;
	        var cameraMatrix = camera.matrix.matrix;
	        var frame = mesh.frame;
	        var texture = mesh.texture.source[frame.sourceIndex].glTexture;
	        var translateX = mesh.x;
	        var translateY = mesh.y;
	        var scaleX = mesh.scaleX;
	        var scaleY = mesh.scaleY;
	        var rotation = mesh.rotation;
	        var sr = Math.sin(rotation);
	        var cr = Math.cos(rotation);
	        var sra = cr * scaleX;
	        var srb = sr * scaleX;
	        var src = -sr * scaleY;
	        var srd = cr * scaleY;
	        var sre = translateX;
	        var srf = translateY;
	        var cma = cameraMatrix[0];
	        var cmb = cameraMatrix[1];
	        var cmc = cameraMatrix[2];
	        var cmd = cameraMatrix[3];
	        var cme = cameraMatrix[4];
	        var cmf = cameraMatrix[5];
	        var vertexOffset = 0;
	        var mva, mvb, mvc, mvd, mve, mvf;
	
	        if (parentMatrix)
	        {
	            var pma = parentMatrix[0];
	            var pmb = parentMatrix[1];
	            var pmc = parentMatrix[2];
	            var pmd = parentMatrix[3];
	            var pme = parentMatrix[4];
	            var pmf = parentMatrix[5];
	            var cse = -camera.scrollX * mesh.scrollFactorX;
	            var csf = -camera.scrollY * mesh.scrollFactorY;
	            var pse = cse * cma + csf * cmc + cme;
	            var psf = cse * cmb + csf * cmd + cmf;
	            var pca = pma * cma + pmb * cmc;
	            var pcb = pma * cmb + pmb * cmd;
	            var pcc = pmc * cma + pmd * cmc;
	            var pcd = pmc * cmb + pmd * cmd;
	            var pce = pme * cma + pmf * cmc + pse;
	            var pcf = pme * cmb + pmf * cmd + psf;
	
	            mva = sra * pca + srb * pcc;
	            mvb = sra * pcb + srb * pcd;
	            mvc = src * pca + srd * pcc;
	            mvd = src * pcb + srd * pcd;
	            mve = sre * pca + srf * pcc + pce;
	            mvf = sre * pcb + srf * pcd + pcf;
	        }
	        else
	        {
	            sre -= camera.scrollX * mesh.scrollFactorX;
	            srf -= camera.scrollY * mesh.scrollFactorY;
	
	            mva = sra * cma + srb * cmc;
	            mvb = sra * cmb + srb * cmd;
	            mvc = src * cma + srd * cmc;
	            mvd = src * cmb + srd * cmd;
	            mve = sre * cma + srf * cmc + cme;
	            mvf = sre * cmb + srf * cmd + cmf;
	        }
	
	        this.setTexture2D(texture, 0);
	
	        vertexOffset = this.vertexCount * this.vertexComponentCount;
	
	        for (var index = 0, index0 = 0; index < length; index += 2)
	        {
	            var x = vertices[index + 0];
	            var y = vertices[index + 1];
	            var tx = x * mva + y * mvc + mve;
	            var ty = x * mvb + y * mvd + mvf;
	
	            if (roundPixels)
	            {
	                tx |= 0;
	                ty |= 0;
	            }
	
	            vertexViewF32[vertexOffset + 0] = tx;
	            vertexViewF32[vertexOffset + 1] = ty;
	            vertexViewF32[vertexOffset + 2] = uvs[index + 0];
	            vertexViewF32[vertexOffset + 3] = uvs[index + 1];
	            vertexViewU32[vertexOffset + 4] = getTint(colors[index0], alphas[index0]);
	
	            vertexOffset += 5;
	            index0 += 1;
	        }
	
	        this.vertexCount += vertexCount;
	    },
	
	    /**
	     * Batches BitmapText game object
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline#batchBitmapText
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.BitmapText} bitmapText - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - [description]
	     */
	    batchBitmapText: function (bitmapText, camera, parentTransformMatrix)
	    {
	        var parentMatrix = null;
	
	        if (parentTransformMatrix)
	        {
	            parentMatrix = parentTransformMatrix.matrix;
	        }
	
	        this.renderer.setPipeline(this);
	
	        if (this.vertexCount + 6 > this.vertexCapacity)
	        {
	            this.flush();
	        }
	
	        var roundPixels = this.renderer.config.roundPixels;
	        var text = bitmapText.text;
	        var textLength = text.length;
	        var getTint = Utils.getTintAppendFloatAlpha;
	        var vertexViewF32 = this.vertexViewF32;
	        var vertexViewU32 = this.vertexViewU32;
	        var cameraMatrix = camera.matrix.matrix;
	        var cameraWidth = camera.width + 50;
	        var cameraHeight = camera.height + 50;
	        var cameraX = -50;
	        var cameraY = -50;
	        var frame = bitmapText.frame;
	        var textureSource = bitmapText.texture.source[frame.sourceIndex];
	        var cameraScrollX = camera.scrollX * bitmapText.scrollFactorX;
	        var cameraScrollY = camera.scrollY * bitmapText.scrollFactorY;
	        var fontData = bitmapText.fontData;
	        var lineHeight = fontData.lineHeight;
	        var scale = (bitmapText.fontSize / fontData.size);
	        var chars = fontData.chars;
	        var alpha = bitmapText.alpha;
	        var vTintTL = getTint(bitmapText._tintTL, alpha);
	        var vTintTR = getTint(bitmapText._tintTR, alpha);
	        var vTintBL = getTint(bitmapText._tintBL, alpha);
	        var vTintBR = getTint(bitmapText._tintBR, alpha);
	        var srcX = bitmapText.x;
	        var srcY = bitmapText.y;
	        var textureX = frame.cutX;
	        var textureY = frame.cutY;
	        var textureWidth = textureSource.width;
	        var textureHeight = textureSource.height;
	        var texture = textureSource.glTexture;
	        var xAdvance = 0;
	        var yAdvance = 0;
	        var indexCount = 0;
	        var charCode = 0;
	        var glyph = null;
	        var glyphX = 0;
	        var glyphY = 0;
	        var glyphW = 0;
	        var glyphH = 0;
	        var x = 0;
	        var y = 0;
	        var xw = 0;
	        var yh = 0;
	
	        var tx0;
	        var ty0;
	        var tx1;
	        var ty1;
	        var tx2;
	        var ty2;
	        var tx3;
	        var ty3;
	
	        var umin = 0;
	        var umax = 0;
	        var vmin = 0;
	        var vmax = 0;
	        var lastGlyph = null;
	        var lastCharCode = 0;
	        var translateX = srcX + frame.x;
	        var translateY = srcY + frame.y;
	        var rotation = bitmapText.rotation;
	        var scaleX = bitmapText.scaleX;
	        var scaleY = bitmapText.scaleY;
	        var letterSpacing = bitmapText.letterSpacing;
	        var sr = Math.sin(rotation);
	        var cr = Math.cos(rotation);
	        var sra = cr * scaleX;
	        var srb = sr * scaleX;
	        var src = -sr * scaleY;
	        var srd = cr * scaleY;
	        var sre = translateX;
	        var srf = translateY;
	        var cma = cameraMatrix[0];
	        var cmb = cameraMatrix[1];
	        var cmc = cameraMatrix[2];
	        var cmd = cameraMatrix[3];
	        var cme = cameraMatrix[4];
	        var cmf = cameraMatrix[5];
	        var vertexOffset = 0;
	        var mva, mvb, mvc, mvd, mve, mvf;
	
	        if (parentMatrix)
	        {
	            var pma = parentMatrix[0];
	            var pmb = parentMatrix[1];
	            var pmc = parentMatrix[2];
	            var pmd = parentMatrix[3];
	            var pme = parentMatrix[4];
	            var pmf = parentMatrix[5];
	            var cse = -cameraScrollX;
	            var csf = -cameraScrollY;
	            var pse = cse * cma + csf * cmc + cme;
	            var psf = cse * cmb + csf * cmd + cmf;
	            var pca = pma * cma + pmb * cmc;
	            var pcb = pma * cmb + pmb * cmd;
	            var pcc = pmc * cma + pmd * cmc;
	            var pcd = pmc * cmb + pmd * cmd;
	            var pce = pme * cma + pmf * cmc + pse;
	            var pcf = pme * cmb + pmf * cmd + psf;
	
	            mva = sra * pca + srb * pcc;
	            mvb = sra * pcb + srb * pcd;
	            mvc = src * pca + srd * pcc;
	            mvd = src * pcb + srd * pcd;
	            mve = sre * pca + srf * pcc + pce;
	            mvf = sre * pcb + srf * pcd + pcf;
	        }
	        else
	        {
	            sre -= cameraScrollX;
	            srf -= cameraScrollY;
	
	            mva = sra * cma + srb * cmc;
	            mvb = sra * cmb + srb * cmd;
	            mvc = src * cma + srd * cmc;
	            mvd = src * cmb + srd * cmd;
	            mve = sre * cma + srf * cmc + cme;
	            mvf = sre * cmb + srf * cmd + cmf;
	        }
	
	        this.setTexture2D(texture, 0);
	
	        for (var index = 0; index < textLength; ++index)
	        {
	            charCode = text.charCodeAt(index);
	
	            if (charCode === 10)
	            {
	                xAdvance = 0;
	                indexCount = 0;
	                yAdvance += lineHeight;
	                lastGlyph = null;
	                continue;
	            }
	
	            glyph = chars[charCode];
	
	            if (!glyph)
	            {
	                continue;
	            }
	
	            glyphX = textureX + glyph.x;
	            glyphY = textureY + glyph.y;
	
	            glyphW = glyph.width;
	            glyphH = glyph.height;
	
	            x = (indexCount + glyph.xOffset + xAdvance) * scale;
	            y = (glyph.yOffset + yAdvance) * scale;
	
	            if (lastGlyph !== null)
	            {
	                var kerningOffset = glyph.kerning[lastCharCode];
	                x += (kerningOffset !== undefined) ? kerningOffset : 0;
	            }
	
	            xAdvance += glyph.xAdvance + letterSpacing;
	            indexCount += 1;
	            lastGlyph = glyph;
	            lastCharCode = charCode;
	
	            //  Nothing to render or a space? Then skip to the next glyph
	            if (glyphW === 0 || glyphH === 0 || charCode === 32)
	            {
	                continue;
	            }
	
	            x -= bitmapText.displayOriginX;
	            y -= bitmapText.displayOriginY;
	
	            xw = x + glyphW * scale;
	            yh = y + glyphH * scale;
	            tx0 = x * mva + y * mvc + mve;
	            ty0 = x * mvb + y * mvd + mvf;
	            tx1 = x * mva + yh * mvc + mve;
	            ty1 = x * mvb + yh * mvd + mvf;
	            tx2 = xw * mva + yh * mvc + mve;
	            ty2 = xw * mvb + yh * mvd + mvf;
	            tx3 = xw * mva + y * mvc + mve;
	            ty3 = xw * mvb + y * mvd + mvf;
	
	            umin = glyphX / textureWidth;
	            umax = (glyphX + glyphW) / textureWidth;
	            vmin = glyphY / textureHeight;
	            vmax = (glyphY + glyphH) / textureHeight;
	
	            if ((tx0 < cameraX || tx0 > cameraWidth || ty0 < cameraY || ty0 > cameraHeight) &&
	                (tx1 < cameraX || tx1 > cameraWidth || ty1 < cameraY || ty1 > cameraHeight) &&
	                (tx2 < cameraX || tx2 > cameraWidth || ty2 < cameraY || ty2 > cameraHeight) &&
	                (tx3 < cameraX || tx3 > cameraWidth || ty3 < cameraY || ty3 > cameraHeight))
	            {
	                continue;
	            }
	
	            if (this.vertexCount + 6 > this.vertexCapacity)
	            {
	                this.flush();
	            }
	            
	            vertexOffset = this.vertexCount * this.vertexComponentCount;
	
	            if (roundPixels)
	            {
	                tx0 |= 0;
	                ty0 |= 0;
	                tx1 |= 0;
	                ty1 |= 0;
	                tx2 |= 0;
	                ty2 |= 0;
	                tx3 |= 0;
	                ty3 |= 0;
	            }
	
	            vertexViewF32[vertexOffset + 0] = tx0;
	            vertexViewF32[vertexOffset + 1] = ty0;
	            vertexViewF32[vertexOffset + 2] = umin;
	            vertexViewF32[vertexOffset + 3] = vmin;
	            vertexViewU32[vertexOffset + 4] = vTintTL;
	            vertexViewF32[vertexOffset + 5] = tx1;
	            vertexViewF32[vertexOffset + 6] = ty1;
	            vertexViewF32[vertexOffset + 7] = umin;
	            vertexViewF32[vertexOffset + 8] = vmax;
	            vertexViewU32[vertexOffset + 9] = vTintBL;
	            vertexViewF32[vertexOffset + 10] = tx2;
	            vertexViewF32[vertexOffset + 11] = ty2;
	            vertexViewF32[vertexOffset + 12] = umax;
	            vertexViewF32[vertexOffset + 13] = vmax;
	            vertexViewU32[vertexOffset + 14] = vTintBR;
	            vertexViewF32[vertexOffset + 15] = tx0;
	            vertexViewF32[vertexOffset + 16] = ty0;
	            vertexViewF32[vertexOffset + 17] = umin;
	            vertexViewF32[vertexOffset + 18] = vmin;
	            vertexViewU32[vertexOffset + 19] = vTintTL;
	            vertexViewF32[vertexOffset + 20] = tx2;
	            vertexViewF32[vertexOffset + 21] = ty2;
	            vertexViewF32[vertexOffset + 22] = umax;
	            vertexViewF32[vertexOffset + 23] = vmax;
	            vertexViewU32[vertexOffset + 24] = vTintBR;
	            vertexViewF32[vertexOffset + 25] = tx3;
	            vertexViewF32[vertexOffset + 26] = ty3;
	            vertexViewF32[vertexOffset + 27] = umax;
	            vertexViewF32[vertexOffset + 28] = vmin;
	            vertexViewU32[vertexOffset + 29] = vTintTR;
	        
	            this.vertexCount += 6;
	        }
	    },
	
	    /**
	     * Batches DynamicBitmapText game object
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline#batchDynamicBitmapText
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.DynamicBitmapText} bitmapText - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - [description]
	     */
	    batchDynamicBitmapText: function (bitmapText, camera, parentTransformMatrix)
	    {
	        var parentMatrix = null;
	
	        if (parentTransformMatrix)
	        {
	            parentMatrix = parentTransformMatrix.matrix;
	        }
	
	        this.renderer.setPipeline(this);
	
	        if (this.vertexCount + 6 > this.vertexCapacity)
	        {
	            this.flush();
	        }
	
	        var roundPixels = this.renderer.config.roundPixels;
	        var displayCallback = bitmapText.displayCallback;
	        var text = bitmapText.text;
	        var textLength = text.length;
	        var getTint = Utils.getTintAppendFloatAlpha;
	        var vertexViewF32 = this.vertexViewF32;
	        var vertexViewU32 = this.vertexViewU32;
	        var renderer = this.renderer;
	        var cameraMatrix = camera.matrix.matrix;
	        var frame = bitmapText.frame;
	        var textureSource = bitmapText.texture.source[frame.sourceIndex];
	        var cameraScrollX = camera.scrollX * bitmapText.scrollFactorX;
	        var cameraScrollY = camera.scrollY * bitmapText.scrollFactorY;
	        var scrollX = bitmapText.scrollX;
	        var scrollY = bitmapText.scrollY;
	        var fontData = bitmapText.fontData;
	        var lineHeight = fontData.lineHeight;
	        var scale = (bitmapText.fontSize / fontData.size);
	        var chars = fontData.chars;
	        var alpha = bitmapText.alpha;
	        var vTintTL = getTint(bitmapText._tintTL, alpha);
	        var vTintTR = getTint(bitmapText._tintTR, alpha);
	        var vTintBL = getTint(bitmapText._tintBL, alpha);
	        var vTintBR = getTint(bitmapText._tintBR, alpha);
	        var srcX = bitmapText.x;
	        var srcY = bitmapText.y;
	        var textureX = frame.cutX;
	        var textureY = frame.cutY;
	        var textureWidth = textureSource.width;
	        var textureHeight = textureSource.height;
	        var texture = textureSource.glTexture;
	        var xAdvance = 0;
	        var yAdvance = 0;
	        var indexCount = 0;
	        var charCode = 0;
	        var glyph = null;
	        var glyphX = 0;
	        var glyphY = 0;
	        var glyphW = 0;
	        var glyphH = 0;
	        var x = 0;
	        var y = 0;
	        var xw = 0;
	        var tx0;
	        var ty0;
	        var tx1;
	        var ty1;
	        var tx2;
	        var ty2;
	        var tx3;
	        var ty3;
	        var yh = 0;
	        var umin = 0;
	        var umax = 0;
	        var vmin = 0;
	        var vmax = 0;
	        var lastGlyph = null;
	        var lastCharCode = 0;
	        var translateX = srcX + frame.x;
	        var translateY = srcY + frame.y;
	        var rotation = bitmapText.rotation;
	        var scaleX = bitmapText.scaleX;
	        var scaleY = bitmapText.scaleY;
	        var letterSpacing = bitmapText.letterSpacing;
	        var sr = Math.sin(rotation);
	        var cr = Math.cos(rotation);
	        var sra = cr * scaleX;
	        var srb = sr * scaleX;
	        var src = -sr * scaleY;
	        var srd = cr * scaleY;
	        var sre = translateX;
	        var srf = translateY;
	        var cma = cameraMatrix[0];
	        var cmb = cameraMatrix[1];
	        var cmc = cameraMatrix[2];
	        var cmd = cameraMatrix[3];
	        var cme = cameraMatrix[4];
	        var cmf = cameraMatrix[5];
	        var crop = (bitmapText.cropWidth > 0 || bitmapText.cropHeight > 0);
	        var uta, utb, utc, utd, ute, utf;
	        var vertexOffset = 0;
	        var mva, mvb, mvc, mvd, mve, mvf;
	
	        if (parentMatrix)
	        {
	            var pma = parentMatrix[0];
	            var pmb = parentMatrix[1];
	            var pmc = parentMatrix[2];
	            var pmd = parentMatrix[3];
	            var pme = parentMatrix[4];
	            var pmf = parentMatrix[5];
	            var cse = -cameraScrollX;
	            var csf = -cameraScrollY;
	            var pse = cse * cma + csf * cmc + cme;
	            var psf = cse * cmb + csf * cmd + cmf;
	            var pca = pma * cma + pmb * cmc;
	            var pcb = pma * cmb + pmb * cmd;
	            var pcc = pmc * cma + pmd * cmc;
	            var pcd = pmc * cmb + pmd * cmd;
	            var pce = pme * cma + pmf * cmc + pse;
	            var pcf = pme * cmb + pmf * cmd + psf;
	
	            mva = sra * pca + srb * pcc;
	            mvb = sra * pcb + srb * pcd;
	            mvc = src * pca + srd * pcc;
	            mvd = src * pcb + srd * pcd;
	            mve = sre * pca + srf * pcc + pce;
	            mvf = sre * pcb + srf * pcd + pcf;
	        }
	        else
	        {
	            sre -= cameraScrollX;
	            srf -= cameraScrollY;
	
	            mva = sra * cma + srb * cmc;
	            mvb = sra * cmb + srb * cmd;
	            mvc = src * cma + srd * cmc;
	            mvd = src * cmb + srd * cmd;
	            mve = sre * cma + srf * cmc + cme;
	            mvf = sre * cmb + srf * cmd + cmf;
	        }
	
	        this.setTexture2D(texture, 0);
	
	        if (crop)
	        {
	            renderer.pushScissor(
	                bitmapText.x,
	                bitmapText.y,
	                bitmapText.cropWidth * bitmapText.scaleX,
	                bitmapText.cropHeight * bitmapText.scaleY
	            );
	        }
	
	        for (var index = 0; index < textLength; ++index)
	        {
	            scale = (bitmapText.fontSize / bitmapText.fontData.size);
	            rotation = 0;
	
	            charCode = text.charCodeAt(index);
	
	            if (charCode === 10)
	            {
	                xAdvance = 0;
	                indexCount = 0;
	                yAdvance += lineHeight;
	                lastGlyph = null;
	                continue;
	            }
	
	            glyph = chars[charCode];
	
	            if (!glyph)
	            {
	                continue;
	            }
	
	            glyphX = textureX + glyph.x;
	            glyphY = textureY + glyph.y;
	
	            glyphW = glyph.width;
	            glyphH = glyph.height;
	            
	            x = (indexCount + glyph.xOffset + xAdvance) - scrollX;
	            y = (glyph.yOffset + yAdvance) - scrollY;
	
	            if (lastGlyph !== null)
	            {
	                var kerningOffset = glyph.kerning[lastCharCode];
	                x += (kerningOffset !== undefined) ? kerningOffset : 0;
	            }
	
	            xAdvance += glyph.xAdvance + letterSpacing;
	            indexCount += 1;
	            lastGlyph = glyph;
	            lastCharCode = charCode;
	
	            //  Nothing to render or a space? Then skip to the next glyph
	            if (glyphW === 0 || glyphH === 0 || charCode === 32)
	            {
	                continue;
	            }
	
	            if (displayCallback)
	            {
	                var output = displayCallback({
	                    color: 0,
	                    tint: {
	                        topLeft: vTintTL,
	                        topRight: vTintTR,
	                        bottomLeft: vTintBL,
	                        bottomRight: vTintBR
	                    },
	                    index: index,
	                    charCode: charCode,
	                    x: x,
	                    y: y,
	                    scale: scale,
	                    rotation: 0,
	                    data: glyph.data
	                });
	
	                x = output.x;
	                y = output.y;
	                scale = output.scale;
	                rotation = output.rotation;
	
	                if (output.color)
	                {
	                    vTintTL = output.color;
	                    vTintTR = output.color;
	                    vTintBL = output.color;
	                    vTintBR = output.color;
	                }
	                else
	                {
	                    vTintTL = output.tint.topLeft;
	                    vTintTR = output.tint.topRight;
	                    vTintBL = output.tint.bottomLeft;
	                    vTintBR = output.tint.bottomRight;
	                }
	
	                vTintTL = getTint(vTintTL, alpha);
	                vTintTR = getTint(vTintTR, alpha);
	                vTintBL = getTint(vTintBL, alpha);
	                vTintBR = getTint(vTintBR, alpha);
	            }
	
	            x -= bitmapText.displayOriginX;
	            y -= bitmapText.displayOriginY;
	            x *= scale;
	            y *= scale;
	
	            sr = Math.sin(rotation);
	            cr = Math.cos(rotation);
	            uta = cr * scale;
	            utb = sr * scale;
	            utc = -sr * scale;
	            utd = cr * scale;
	            ute = x;
	            utf = y;
	
	            sra = uta * mva + utb * mvc;
	            srb = uta * mvb + utb * mvd;
	            src = utc * mva + utd * mvc;
	            srd = utc * mvb + utd * mvd;
	            sre = ute * mva + utf * mvc + mve;
	            srf = ute * mvb + utf * mvd + mvf;
	
	            xw = glyphW;
	            yh = glyphH;
	            tx0 = sre;
	            ty0 = srf;
	            tx1 = yh * src + sre;
	            ty1 = yh * srd + srf;
	            tx2 = xw * sra + yh * src + sre;
	            ty2 = xw * srb + yh * srd + srf;
	            tx3 = xw * sra + sre;
	            ty3 = xw * srb + srf;
	
	            umin = glyphX / textureWidth;
	            umax = (glyphX + glyphW) / textureWidth;
	            vmin = glyphY / textureHeight;
	            vmax = (glyphY + glyphH) / textureHeight;
	
	            if (this.vertexCount + 6 > this.vertexCapacity)
	            {
	                this.flush();
	            }
	            
	            vertexOffset = this.vertexCount * this.vertexComponentCount;
	
	            if (roundPixels)
	            {
	                tx0 |= 0;
	                ty0 |= 0;
	                tx1 |= 0;
	                ty1 |= 0;
	                tx2 |= 0;
	                ty2 |= 0;
	                tx3 |= 0;
	                ty3 |= 0;
	            }
	
	            vertexViewF32[vertexOffset + 0] = tx0;
	            vertexViewF32[vertexOffset + 1] = ty0;
	            vertexViewF32[vertexOffset + 2] = umin;
	            vertexViewF32[vertexOffset + 3] = vmin;
	            vertexViewU32[vertexOffset + 4] = vTintTL;
	            vertexViewF32[vertexOffset + 5] = tx1;
	            vertexViewF32[vertexOffset + 6] = ty1;
	            vertexViewF32[vertexOffset + 7] = umin;
	            vertexViewF32[vertexOffset + 8] = vmax;
	            vertexViewU32[vertexOffset + 9] = vTintBL;
	            vertexViewF32[vertexOffset + 10] = tx2;
	            vertexViewF32[vertexOffset + 11] = ty2;
	            vertexViewF32[vertexOffset + 12] = umax;
	            vertexViewF32[vertexOffset + 13] = vmax;
	            vertexViewU32[vertexOffset + 14] = vTintBR;
	            vertexViewF32[vertexOffset + 15] = tx0;
	            vertexViewF32[vertexOffset + 16] = ty0;
	            vertexViewF32[vertexOffset + 17] = umin;
	            vertexViewF32[vertexOffset + 18] = vmin;
	            vertexViewU32[vertexOffset + 19] = vTintTL;
	            vertexViewF32[vertexOffset + 20] = tx2;
	            vertexViewF32[vertexOffset + 21] = ty2;
	            vertexViewF32[vertexOffset + 22] = umax;
	            vertexViewF32[vertexOffset + 23] = vmax;
	            vertexViewU32[vertexOffset + 24] = vTintBR;
	            vertexViewF32[vertexOffset + 25] = tx3;
	            vertexViewF32[vertexOffset + 26] = ty3;
	            vertexViewF32[vertexOffset + 27] = umax;
	            vertexViewF32[vertexOffset + 28] = vmin;
	            vertexViewU32[vertexOffset + 29] = vTintTR;
	        
	            this.vertexCount += 6;
	        }
	
	        if (crop)
	        {
	            renderer.popScissor();
	        }
	    },
	
	    /**
	     * Batches Text game object
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline#batchText
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Text} text - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - [description]
	     */
	    batchText: function (text, camera, parentTransformMatrix)
	    {
	        var getTint = Utils.getTintAppendFloatAlpha;
	
	        this.batchTexture(
	            text,
	            text.canvasTexture,
	            text.canvasTexture.width, text.canvasTexture.height,
	            text.x, text.y,
	            text.canvasTexture.width, text.canvasTexture.height,
	            text.scaleX, text.scaleY,
	            text.rotation,
	            text.flipX, text.flipY,
	            text.scrollFactorX, text.scrollFactorY,
	            text.displayOriginX, text.displayOriginY,
	            0, 0, text.canvasTexture.width, text.canvasTexture.height,
	            getTint(text._tintTL, text._alphaTL),
	            getTint(text._tintTR, text._alphaTR),
	            getTint(text._tintBL, text._alphaBL),
	            getTint(text._tintBR, text._alphaBR),
	            0, 0,
	            camera,
	            parentTransformMatrix
	        );
	    },
	
	    /**
	     * Batches DynamicTilemapLayer game object
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline#batchDynamicTilemapLayer
	     * @since 3.0.0
	     *
	     * @param {Phaser.Tilemaps.DynamicTilemapLayer} tilemapLayer - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - [description]
	     */
	    batchDynamicTilemapLayer: function (tilemapLayer, camera, parentTransformMatrix)
	    {
	        var renderTiles = tilemapLayer.culledTiles;
	        var length = renderTiles.length;
	        var texture = tilemapLayer.tileset.image.get().source.glTexture;
	        var tileset = tilemapLayer.tileset;
	        var scrollFactorX = tilemapLayer.scrollFactorX;
	        var scrollFactorY = tilemapLayer.scrollFactorY;
	        var alpha = tilemapLayer.alpha;
	        var x = tilemapLayer.x;
	        var y = tilemapLayer.y;
	        var sx = tilemapLayer.scaleX;
	        var sy = tilemapLayer.scaleY;
	        var getTint = Utils.getTintAppendFloatAlpha;
	
	        for (var index = 0; index < length; ++index)
	        {
	            var tile = renderTiles[index];
	
	            var tileTexCoords = tileset.getTileTextureCoordinates(tile.index);
	            if (tileTexCoords === null) { continue; }
	
	            var frameWidth = tile.width;
	            var frameHeight = tile.height;
	            var frameX = tileTexCoords.x;
	            var frameY = tileTexCoords.y;
	            var tint = getTint(tile.tint, alpha * tile.alpha);
	
	            this.batchTexture(
	                tilemapLayer,
	                texture,
	                texture.width, texture.height,
	                (tile.width / 2) + x + tile.pixelX * sx, (tile.height / 2) + y + tile.pixelY * sy,
	                tile.width * sx, tile.height * sy,
	                1, 1,
	                tile.rotation,
	                tile.flipX, tile.flipY,
	                scrollFactorX, scrollFactorY,
	                (tile.width / 2), (tile.height / 2),
	                frameX, frameY, frameWidth, frameHeight,
	                tint, tint, tint, tint,
	                0, 0,
	                camera,
	                parentTransformMatrix
	            );
	        }
	    },
	
	    /**
	     * Batches TileSprite game object
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline#batchTileSprite
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.TileSprite} tileSprite - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - [description]
	     */
	    batchTileSprite: function (tileSprite, camera, parentTransformMatrix)
	    {
	        var getTint = Utils.getTintAppendFloatAlpha;
	
	        this.batchTexture(
	            tileSprite,
	            tileSprite.tileTexture,
	            tileSprite.frame.width, tileSprite.frame.height,
	            tileSprite.x, tileSprite.y,
	            tileSprite.width, tileSprite.height,
	            tileSprite.scaleX, tileSprite.scaleY,
	            tileSprite.rotation,
	            tileSprite.flipX, tileSprite.flipY,
	            tileSprite.scrollFactorX, tileSprite.scrollFactorY,
	            tileSprite.originX * tileSprite.width, tileSprite.originY * tileSprite.height,
	            0, 0, tileSprite.width, tileSprite.height,
	            getTint(tileSprite._tintTL, tileSprite._alphaTL),
	            getTint(tileSprite._tintTR, tileSprite._alphaTR),
	            getTint(tileSprite._tintBL, tileSprite._alphaBL),
	            getTint(tileSprite._tintBR, tileSprite._alphaBR),
	            (tileSprite.tilePositionX % tileSprite.frame.width) / tileSprite.frame.width,
	            (tileSprite.tilePositionY % tileSprite.frame.height) / tileSprite.frame.height,
	            camera,
	            parentTransformMatrix
	        );
	    },
	
	    /**
	     * Generic function for batching a textured quad
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline#batchTexture
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} gameObject - Source GameObject
	     * @param {WebGLTexture} texture - Raw WebGLTexture associated with the quad
	     * @param {integer} textureWidth - Real texture width
	     * @param {integer} textureHeight - Real texture height
	     * @param {float} srcX - X coordinate of the quad
	     * @param {float} srcY - Y coordinate of the quad
	     * @param {float} srcWidth - Width of the quad
	     * @param {float} srcHeight - Height of the quad
	     * @param {float} scaleX - X component of scale
	     * @param {float} scaleY - Y component of scale
	     * @param {float} rotation - Rotation of the quad
	     * @param {boolean} flipX - Indicates if the quad is horizontally flipped
	     * @param {boolean} flipY - Indicates if the quad is vertically flipped
	     * @param {float} scrollFactorX - By which factor is the quad affected by the camera horizontal scroll
	     * @param {float} scrollFactorY - By which factor is the quad effected by the camera vertical scroll
	     * @param {float} displayOriginX - Horizontal origin in pixels
	     * @param {float} displayOriginY - Vertical origin in pixels
	     * @param {float} frameX - X coordinate of the texture frame
	     * @param {float} frameY - Y coordinate of the texture frame
	     * @param {float} frameWidth - Width of the texture frame
	     * @param {float} frameHeight - Height of the texture frame
	     * @param {integer} tintTL - Tint for top left
	     * @param {integer} tintTR - Tint for top right
	     * @param {integer} tintBL - Tint for bottom left
	     * @param {integer} tintBR - Tint for bottom right
	     * @param {float} uOffset - Horizontal offset on texture coordinate
	     * @param {float} vOffset - Vertical offset on texture coordinate
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - Current used camera
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - Parent container
	     */
	    batchTexture: function (
	        gameObject,
	        texture,
	        textureWidth, textureHeight,
	        srcX, srcY,
	        srcWidth, srcHeight,
	        scaleX, scaleY,
	        rotation,
	        flipX, flipY,
	        scrollFactorX, scrollFactorY,
	        displayOriginX, displayOriginY,
	        frameX, frameY, frameWidth, frameHeight,
	        tintTL, tintTR, tintBL, tintBR,
	        uOffset, vOffset,
	        camera,
	        parentTransformMatrix)
	    {
	        var parentMatrix = null;
	
	        if (parentTransformMatrix)
	        {
	            parentMatrix = parentTransformMatrix.matrix;
	        }
	
	        this.renderer.setPipeline(this);
	
	        if (this.vertexCount + 6 > this.vertexCapacity)
	        {
	            this.flush();
	        }
	
	        flipY = flipY ^ (texture.isRenderTexture ? 1 : 0);
	
	        var roundPixels = this.renderer.config.roundPixels;
	        var vertexViewF32 = this.vertexViewF32;
	        var vertexViewU32 = this.vertexViewU32;
	        var cameraMatrix = camera.matrix.matrix;
	        var width = srcWidth * (flipX ? -1.0 : 1.0);
	        var height = srcHeight * (flipY ? -1.0 : 1.0);
	        var x = -displayOriginX + ((srcWidth) * (flipX ? 1.0 : 0.0));
	        var y = -displayOriginY + ((srcHeight) * (flipY ? 1.0 : 0.0));
	        var xw = x + width;
	        var yh = y + height;
	        var translateX = srcX;
	        var translateY = srcY;
	        var sr = Math.sin(rotation);
	        var cr = Math.cos(rotation);
	        var sra = cr * scaleX;
	        var srb = sr * scaleX;
	        var src = -sr * scaleY;
	        var srd = cr * scaleY;
	        var sre = translateX;
	        var srf = translateY;
	        var cma = cameraMatrix[0];
	        var cmb = cameraMatrix[1];
	        var cmc = cameraMatrix[2];
	        var cmd = cameraMatrix[3];
	        var cme = cameraMatrix[4];
	        var cmf = cameraMatrix[5];
	        var mva, mvb, mvc, mvd, mve, mvf;
	
	        if (parentMatrix)
	        {
	            var pma = parentMatrix[0];
	            var pmb = parentMatrix[1];
	            var pmc = parentMatrix[2];
	            var pmd = parentMatrix[3];
	            var pme = parentMatrix[4];
	            var pmf = parentMatrix[5];
	            var cse = -camera.scrollX * scrollFactorX;
	            var csf = -camera.scrollY * scrollFactorY;
	            var pse = cse * cma + csf * cmc + cme;
	            var psf = cse * cmb + csf * cmd + cmf;
	            var pca = pma * cma + pmb * cmc;
	            var pcb = pma * cmb + pmb * cmd;
	            var pcc = pmc * cma + pmd * cmc;
	            var pcd = pmc * cmb + pmd * cmd;
	            var pce = pme * cma + pmf * cmc + pse;
	            var pcf = pme * cmb + pmf * cmd + psf;
	
	            mva = sra * pca + srb * pcc;
	            mvb = sra * pcb + srb * pcd;
	            mvc = src * pca + srd * pcc;
	            mvd = src * pcb + srd * pcd;
	            mve = sre * pca + srf * pcc + pce;
	            mvf = sre * pcb + srf * pcd + pcf;
	        }
	        else
	        {
	            sre -= camera.scrollX * scrollFactorX;
	            srf -= camera.scrollY * scrollFactorY;
	
	            mva = sra * cma + srb * cmc;
	            mvb = sra * cmb + srb * cmd;
	            mvc = src * cma + srd * cmc;
	            mvd = src * cmb + srd * cmd;
	            mve = sre * cma + srf * cmc + cme;
	            mvf = sre * cmb + srf * cmd + cmf;
	        }
	
	        var tx0 = x * mva + y * mvc + mve;
	        var ty0 = x * mvb + y * mvd + mvf;
	        var tx1 = x * mva + yh * mvc + mve;
	        var ty1 = x * mvb + yh * mvd + mvf;
	        var tx2 = xw * mva + yh * mvc + mve;
	        var ty2 = xw * mvb + yh * mvd + mvf;
	        var tx3 = xw * mva + y * mvc + mve;
	        var ty3 = xw * mvb + y * mvd + mvf;
	        var vertexOffset = 0;
	        var u0 = (frameX / textureWidth) + uOffset;
	        var v0 = (frameY / textureHeight) + vOffset;
	        var u1 = (frameX + frameWidth) / textureWidth + uOffset;
	        var v1 = (frameY + frameHeight) / textureHeight + vOffset;
	        
	        this.setTexture2D(texture, 0);
	
	        vertexOffset = this.vertexCount * this.vertexComponentCount;
	
	        if (roundPixels)
	        {
	            tx0 |= 0;
	            ty0 |= 0;
	            tx1 |= 0;
	            ty1 |= 0;
	            tx2 |= 0;
	            ty2 |= 0;
	            tx3 |= 0;
	            ty3 |= 0;
	        }
	
	        vertexViewF32[vertexOffset + 0] = tx0;
	        vertexViewF32[vertexOffset + 1] = ty0;
	        vertexViewF32[vertexOffset + 2] = u0;
	        vertexViewF32[vertexOffset + 3] = v0;
	        vertexViewU32[vertexOffset + 4] = tintTL;
	        vertexViewF32[vertexOffset + 5] = tx1;
	        vertexViewF32[vertexOffset + 6] = ty1;
	        vertexViewF32[vertexOffset + 7] = u0;
	        vertexViewF32[vertexOffset + 8] = v1;
	        vertexViewU32[vertexOffset + 9] = tintTR;
	        vertexViewF32[vertexOffset + 10] = tx2;
	        vertexViewF32[vertexOffset + 11] = ty2;
	        vertexViewF32[vertexOffset + 12] = u1;
	        vertexViewF32[vertexOffset + 13] = v1;
	        vertexViewU32[vertexOffset + 14] = tintBL;
	        vertexViewF32[vertexOffset + 15] = tx0;
	        vertexViewF32[vertexOffset + 16] = ty0;
	        vertexViewF32[vertexOffset + 17] = u0;
	        vertexViewF32[vertexOffset + 18] = v0;
	        vertexViewU32[vertexOffset + 19] = tintTL;
	        vertexViewF32[vertexOffset + 20] = tx2;
	        vertexViewF32[vertexOffset + 21] = ty2;
	        vertexViewF32[vertexOffset + 22] = u1;
	        vertexViewF32[vertexOffset + 23] = v1;
	        vertexViewU32[vertexOffset + 24] = tintBL;
	        vertexViewF32[vertexOffset + 25] = tx3;
	        vertexViewF32[vertexOffset + 26] = ty3;
	        vertexViewF32[vertexOffset + 27] = u1;
	        vertexViewF32[vertexOffset + 28] = v0;
	        vertexViewU32[vertexOffset + 29] = tintBR;
	
	        this.vertexCount += 6;
	    },
	
	    /**
	     * Immediately draws a texture with no batching.
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline#drawTexture
	     * @since 3.2.0
	     *
	     * @param {WebGLTexture} texture [description]
	     * @param {number} srcX - [description]
	     * @param {number} srcY - [description]
	     * @param {number} tint - [description]
	     * @param {number} alpha - [description]
	     * @param {number} frameX - [description]
	     * @param {number} frameY - [description]
	     * @param {number} frameWidth - [description]
	     * @param {number} frameHeight - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} transformMatrix - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline} This Pipeline.
	     */
	    drawTexture: function (
	        texture,
	        srcX, srcY,
	        tint, alpha,
	        frameX, frameY, frameWidth, frameHeight,
	        transformMatrix,
	        parentTransformMatrix
	    )
	    {
	        var parentMatrix = null;
	
	        if (parentTransformMatrix)
	        {
	            parentMatrix = parentTransformMatrix.matrix;
	        }
	
	        this.renderer.setPipeline(this);
	
	        if (this.vertexCount + 6 > this.vertexCapacity)
	        {
	            this.flush();
	        }
	
	        var roundPixels = this.renderer.config.roundPixels;
	        var vertexViewF32 = this.vertexViewF32;
	        var vertexViewU32 = this.vertexViewU32;
	        var width = frameWidth;
	        var height = frameHeight;
	        var x = srcX;
	        var y = srcY;
	        var xw = x + width;
	        var yh = y + height;
	        var mva = transformMatrix[0];
	        var mvb = transformMatrix[1];
	        var mvc = transformMatrix[2];
	        var mvd = transformMatrix[3];
	        var mve = transformMatrix[4];
	        var mvf = transformMatrix[5];
	
	        if (parentMatrix)
	        {
	            var pma = parentMatrix[0];
	            var pmb = parentMatrix[1];
	            var pmc = parentMatrix[2];
	            var pmd = parentMatrix[3];
	            var pme = parentMatrix[4];
	            var pmf = parentMatrix[5];
	            var pca = mva * pma + mvb * pmc;
	            var pcb = mva * pmb + mvb * pmd;
	            var pcc = mvc * pma + mvd * pmc;
	            var pcd = mvc * pmb + mvd * pmd;
	            var pce = mve * pma + mvf * pmc + pme;
	            var pcf = mve * pmb + mvf * pmd + pmf;
	            mva = pca;
	            mvb = pcb;
	            mvc = pcc;
	            mvd = pcd;
	            mve = pce;
	            mvf = pcf;
	        }
	
	        var tx0 = x * mva + y * mvc + mve;
	        var ty0 = x * mvb + y * mvd + mvf;
	        var tx1 = x * mva + yh * mvc + mve;
	        var ty1 = x * mvb + yh * mvd + mvf;
	        var tx2 = xw * mva + yh * mvc + mve;
	        var ty2 = xw * mvb + yh * mvd + mvf;
	        var tx3 = xw * mva + y * mvc + mve;
	        var ty3 = xw * mvb + y * mvd + mvf;
	        var vertexOffset = 0;
	        var textureWidth = texture.width;
	        var textureHeight = texture.height;
	        var u0 = (frameX / textureWidth);
	        var v0 = (frameY / textureHeight);
	        var u1 = (frameX + frameWidth) / textureWidth;
	        var v1 = (frameY + frameHeight) / textureHeight;
	        tint = Utils.getTintAppendFloatAlpha(tint, alpha);
	        
	        this.setTexture2D(texture, 0);
	
	        vertexOffset = this.vertexCount * this.vertexComponentCount;
	
	        if (roundPixels)
	        {
	            tx0 |= 0;
	            ty0 |= 0;
	            tx1 |= 0;
	            ty1 |= 0;
	            tx2 |= 0;
	            ty2 |= 0;
	            tx3 |= 0;
	            ty3 |= 0;
	        }
	
	        vertexViewF32[vertexOffset + 0] = tx0;
	        vertexViewF32[vertexOffset + 1] = ty0;
	        vertexViewF32[vertexOffset + 2] = u0;
	        vertexViewF32[vertexOffset + 3] = v0;
	        vertexViewU32[vertexOffset + 4] = tint;
	        vertexViewF32[vertexOffset + 5] = tx1;
	        vertexViewF32[vertexOffset + 6] = ty1;
	        vertexViewF32[vertexOffset + 7] = u0;
	        vertexViewF32[vertexOffset + 8] = v1;
	        vertexViewU32[vertexOffset + 9] = tint;
	        vertexViewF32[vertexOffset + 10] = tx2;
	        vertexViewF32[vertexOffset + 11] = ty2;
	        vertexViewF32[vertexOffset + 12] = u1;
	        vertexViewF32[vertexOffset + 13] = v1;
	        vertexViewU32[vertexOffset + 14] = tint;
	        vertexViewF32[vertexOffset + 15] = tx0;
	        vertexViewF32[vertexOffset + 16] = ty0;
	        vertexViewF32[vertexOffset + 17] = u0;
	        vertexViewF32[vertexOffset + 18] = v0;
	        vertexViewU32[vertexOffset + 19] = tint;
	        vertexViewF32[vertexOffset + 20] = tx2;
	        vertexViewF32[vertexOffset + 21] = ty2;
	        vertexViewF32[vertexOffset + 22] = u1;
	        vertexViewF32[vertexOffset + 23] = v1;
	        vertexViewU32[vertexOffset + 24] = tint;
	        vertexViewF32[vertexOffset + 25] = tx3;
	        vertexViewF32[vertexOffset + 26] = ty3;
	        vertexViewF32[vertexOffset + 27] = u1;
	        vertexViewF32[vertexOffset + 28] = v0;
	        vertexViewU32[vertexOffset + 29] = tint;
	
	        this.vertexCount += 6;
	
	        // Force an immediate draw
	        this.flush();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline#batchGraphics
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Graphics} graphics - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     */
	    batchGraphics: function ()
	    {
	        // Stub
	    }
	
	});
	
	module.exports = TextureTintPipeline;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(168);
	var DefaultPlugins = __webpack_require__(322);
	var GetPhysicsPlugins = __webpack_require__(1513);
	var GetScenePlugins = __webpack_require__(1514);
	var Settings = __webpack_require__(624);
	
	/**
	 * @classdesc
	 * The Scene Systems class.
	 *
	 * This class is available from within a Scene under the property `sys`.
	 * It is responsible for managing all of the plugins a Scene has running, including the display list, and
	 * handling the update step and renderer. It also contains references to global systems belonging to Game.
	 *
	 * @class Systems
	 * @memberOf Phaser.Scenes
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - The Scene that owns this Systems instance.
	 * @param {(string|Phaser.Scenes.Settings.Config)} config - Scene specific configuration settings.
	 */
	var Systems = new Class({
	
	    initialize:
	
	    function Systems (scene, config)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Scenes.Systems#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Scenes.Systems#game
	         * @type {Phaser.Game}
	         * @since 3.0.0
	         */
	        this.game;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Scenes.Systems#config
	         * @type {(string|Phaser.Scenes.Settings.Config)}
	         * @since 3.0.0
	         */
	        this.config = config;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Scenes.Systems#settings
	         * @type {Phaser.Scenes.Settings.Object}
	         * @since 3.0.0
	         */
	        this.settings = Settings.create(config);
	
	        /**
	         * A handy reference to the Scene canvas / context.
	         *
	         * @name Phaser.Scenes.Systems#canvas
	         * @type {HTMLCanvasElement}
	         * @since 3.0.0
	         */
	        this.canvas;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Scenes.Systems#context
	         * @type {CanvasRenderingContext2D}
	         * @since 3.0.0
	         */
	        this.context;
	
	        //  Global Systems - these are single-instance global managers that belong to Game
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Scenes.Systems#anims
	         * @type {Phaser.Animations.AnimationManager}
	         * @since 3.0.0
	         */
	        this.anims;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Scenes.Systems#cache
	         * @type {Phaser.Cache.CacheManager}
	         * @since 3.0.0
	         */
	        this.cache;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Scenes.Systems#plugins
	         * @type {Phaser.Plugins.PluginManager}
	         * @since 3.0.0
	         */
	        this.plugins;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Scenes.Systems#registry
	         * @type {Phaser.Data.DataManager}
	         * @since 3.0.0
	         */
	        this.registry;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Scenes.Systems#sound
	         * @type {Phaser.Sound.BaseSoundManager}
	         * @since 3.0.0
	         */
	        this.sound;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Scenes.Systems#textures
	         * @type {Phaser.Textures.TextureManager}
	         * @since 3.0.0
	         */
	        this.textures;
	
	        //  Core Plugins - these are non-optional Scene plugins, needed by lots of the other systems
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Scenes.Systems#add
	         * @type {Phaser.GameObjects.GameObjectFactory}
	         * @since 3.0.0
	         */
	        this.add;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Scenes.Systems#cameras
	         * @type {Phaser.Cameras.Scene2D.CameraManager}
	         * @since 3.0.0
	         */
	        this.cameras;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Scenes.Systems#displayList
	         * @type {Phaser.GameObjects.DisplayList}
	         * @since 3.0.0
	         */
	        this.displayList;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Scenes.Systems#events
	         * @type {Phaser.Events.EventEmitter}
	         * @since 3.0.0
	         */
	        this.events;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Scenes.Systems#make
	         * @type {Phaser.GameObjects.GameObjectCreator}
	         * @since 3.0.0
	         */
	        this.make;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Scenes.Systems#scenePlugin
	         * @type {Phaser.Scenes.ScenePlugin}
	         * @since 3.0.0
	         */
	        this.scenePlugin;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Scenes.Systems#updateList
	         * @type {Phaser.GameObjects.UpdateList}
	         * @since 3.0.0
	         */
	        this.updateList;
	    },
	
	    /**
	     * This method is called only once by the Scene Manager when the Scene is instantiated.
	     * It is responsible for setting up all of the Scene plugins and references.
	     * It should never be called directly.
	     *
	     * @method Phaser.Scenes.Systems#init
	     * @protected
	     * @since 3.0.0
	     *
	     * @param {Phaser.Game} game - A reference to the Phaser Game instance.
	     */
	    init: function (game)
	    {
	        this.settings.status = CONST.INIT;
	
	        this.game = game;
	
	        this.canvas = game.canvas;
	        this.context = game.context;
	
	        var pluginManager = game.plugins;
	
	        this.plugins = pluginManager;
	
	        pluginManager.addToScene(this, DefaultPlugins.Global, [ DefaultPlugins.CoreScene, GetScenePlugins(this), GetPhysicsPlugins(this) ]);
	
	        // pluginManager.installSceneGlobal(this, DefaultPlugins.Global);
	        // pluginManager.installSceneLocal(this, DefaultPlugins.CoreScene);
	        // pluginManager.installSceneLocal(this, GetScenePlugins(this));
	        // pluginManager.installSceneLocal(this, GetPhysicsPlugins(this));
	
	        this.events.emit('boot', this);
	
	        this.settings.isBooted = true;
	    },
	
	    /**
	     * Called by a plugin, it tells the System to install the plugin locally.
	     *
	     * @method Phaser.Scenes.Systems#install
	     * @private
	     * @since 3.0.0
	     *
	     * @param {array} plugin - An array of plugins to install into this Scene.
	     */
	    install: function (plugin)
	    {
	        if (!Array.isArray(plugin))
	        {
	            plugin = [ plugin ];
	        }
	
	        this.plugins.installLocal(this, plugin);
	    },
	
	    /**
	     * A single game step. Called automatically by the Scene Manager as a result of a Request Animation
	     * Frame or Set Timeout call to the main Game instance.
	     *
	     * @method Phaser.Scenes.Systems#step
	     * @since 3.0.0
	     *
	     * @param {number} time - [description]
	     * @param {number} delta - [description]
	     */
	    step: function (time, delta)
	    {
	        this.events.emit('preupdate', time, delta);
	
	        this.events.emit('update', time, delta);
	
	        this.scene.update.call(this.scene, time, delta);
	
	        this.events.emit('postupdate', time, delta);
	    },
	
	    /**
	     * Called automatically by the Scene Manager. Instructs the Scene to render itself via
	     * its Camera Manager to the renderer given.
	     *
	     * @method Phaser.Scenes.Systems#render
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - [description]
	     */
	    render: function (renderer)
	    {
	        var displayList = this.displayList;
	
	        displayList.depthSort();
	
	        this.cameras.render(renderer, displayList);
	
	        this.events.emit('render', renderer);
	    },
	
	    /**
	     * Force a sort of the display list on the next render.
	     *
	     * @method Phaser.Scenes.Systems#queueDepthSort
	     * @since 3.0.0
	     */
	    queueDepthSort: function ()
	    {
	        this.displayList.queueDepthSort();
	    },
	
	    /**
	     * Immediately sorts the display list if the flag is set.
	     *
	     * @method Phaser.Scenes.Systems#depthSort
	     * @since 3.0.0
	     */
	    depthSort: function ()
	    {
	        this.displayList.depthSort();
	    },
	
	    /**
	     * Pause this Scene.
	     * A paused Scene still renders, it just doesn't run ANY of its update handlers or systems.
	     *
	     * @method Phaser.Scenes.Systems#pause
	     * @since 3.0.0
	     *
	     * @return {Phaser.Scenes.Systems} This Systems object.
	     */
	    pause: function ()
	    {
	        if (this.settings.active)
	        {
	            this.settings.status = CONST.PAUSED;
	
	            this.settings.active = false;
	
	            this.events.emit('pause', this);
	        }
	
	        return this;
	    },
	
	    /**
	     * Resume this Scene from a paused state.
	     *
	     * @method Phaser.Scenes.Systems#resume
	     * @since 3.0.0
	     *
	     * @return {Phaser.Scenes.Systems} This Systems object.
	     */
	    resume: function ()
	    {
	        if (!this.settings.active)
	        {
	            this.settings.status = CONST.RUNNING;
	
	            this.settings.active = true;
	
	            this.events.emit('resume', this);
	        }
	
	        return this;
	    },
	
	    /**
	     * Send this Scene to sleep.
	     *
	     * A sleeping Scene doesn't run it's update step or render anything, but it also isn't shut down
	     * or have any of its systems or children removed, meaning it can be re-activated at any point and
	     * will carry on from where it left off. It also keeps everything in memory and events and callbacks
	     * from other Scenes may still invoke changes within it, so be careful what is left active.
	     *
	     * @method Phaser.Scenes.Systems#sleep
	     * @since 3.0.0
	     *
	     * @return {Phaser.Scenes.Systems} This Systems object.
	     */
	    sleep: function ()
	    {
	        this.settings.status = CONST.SLEEPING;
	
	        this.settings.active = false;
	        this.settings.visible = false;
	
	        this.events.emit('sleep', this);
	
	        return this;
	    },
	
	    /**
	     * Wake-up this Scene if it was previously asleep.
	     *
	     * @method Phaser.Scenes.Systems#wake
	     * @since 3.0.0
	     *
	     * @return {Phaser.Scenes.Systems} This Systems object.
	     */
	    wake: function ()
	    {
	        var settings = this.settings;
	
	        settings.status = CONST.RUNNING;
	
	        settings.active = true;
	        settings.visible = true;
	
	        this.events.emit('wake', this);
	
	        if (settings.isTransition)
	        {
	            this.events.emit('transitionwake', settings.transitionFrom, settings.transitionDuration);
	        }
	
	        return this;
	    },
	
	    /**
	     * Is this Scene sleeping?
	     *
	     * @method Phaser.Scenes.Systems#isSleeping
	     * @since 3.0.0
	     *
	     * @return {boolean} [description]
	     */
	    isSleeping: function ()
	    {
	        return (this.settings.status === CONST.SLEEPING);
	    },
	
	    /**
	     * Is this Scene active?
	     *
	     * @method Phaser.Scenes.Systems#isActive
	     * @since 3.0.0
	     *
	     * @return {boolean} [description]
	     */
	    isActive: function ()
	    {
	        return (this.settings.status === CONST.RUNNING);
	    },
	
	    /**
	     * Is this Scene currently transitioning out to, or in from another Scene?
	     *
	     * @method Phaser.Scenes.Systems#isTransitioning
	     * @since 3.5.0
	     *
	     * @return {boolean} `true` if this Scene is currently transitioning, otherwise `false`.
	     */
	    isTransitioning: function ()
	    {
	        return (this.settings.isTransition || this.scenePlugin._target !== null);
	    },
	
	    /**
	     * Is this Scene currently transitioning out from itself to another Scene?
	     *
	     * @method Phaser.Scenes.Systems#isTransitionOut
	     * @since 3.5.0
	     *
	     * @return {boolean} `true` if this Scene is in transition to another Scene, otherwise `false`.
	     */
	    isTransitionOut: function ()
	    {
	        return (this.scenePlugin._target !== null && this.scenePlugin._duration > 0);
	    },
	
	    /**
	     * Is this Scene currently transitioning in from another Scene?
	     *
	     * @method Phaser.Scenes.Systems#isTransitionIn
	     * @since 3.5.0
	     *
	     * @return {boolean} `true` if this Scene is transitioning in from another Scene, otherwise `false`.
	     */
	    isTransitionIn: function ()
	    {
	        return (this.settings.isTransition);
	    },
	
	    /**
	     * Is this Scene visible and rendering?
	     *
	     * @method Phaser.Scenes.Systems#isVisible
	     * @since 3.0.0
	     *
	     * @return {boolean} [description]
	     */
	    isVisible: function ()
	    {
	        return this.settings.visible;
	    },
	
	    /**
	     * Sets the visible state of this Scene.
	     * An invisible Scene will not render, but will still process updates.
	     *
	     * @method Phaser.Scenes.Systems#setVisible
	     * @since 3.0.0
	     *
	     * @param {boolean} value - [description]
	     *
	     * @return {Phaser.Scenes.Systems} This Systems object.
	     */
	    setVisible: function (value)
	    {
	        this.settings.visible = value;
	
	        return this;
	    },
	
	    /**
	     * Set the active state of this Scene.
	     * An active Scene will run its core update loop.
	     *
	     * @method Phaser.Scenes.Systems#setActive
	     * @since 3.0.0
	     *
	     * @param {boolean} value - If `true` the Scene will be resumed, if previously paused. If `false` it will be paused.
	     *
	     * @return {Phaser.Scenes.Systems} This Systems object.
	     */
	    setActive: function (value)
	    {
	        if (value)
	        {
	            return this.resume();
	        }
	        else
	        {
	            return this.pause();
	        }
	    },
	
	    /**
	     * Start this Scene running and rendering.
	     * Called automatically by the SceneManager.
	     *
	     * @method Phaser.Scenes.Systems#start
	     * @since 3.0.0
	     *
	     * @param {object} data - Optional data object that may have been passed to this Scene from another.
	     */
	    start: function (data)
	    {
	        if (data)
	        {
	            this.settings.data = data;
	        }
	
	        this.settings.status = CONST.START;
	
	        this.settings.active = true;
	        this.settings.visible = true;
	
	        //  For plugins to listen out for
	        this.events.emit('start', this);
	
	        //  For user-land code to listen out for
	        this.events.emit('ready', this);
	    },
	
	    /**
	     * Called automatically by the SceneManager if the Game resizes.
	     * Dispatches an event you can respond to in your game code.
	     *
	     * @method Phaser.Scenes.Systems#resize
	     * @since 3.2.0
	     *
	     * @param {number} width - The new width of the game.
	     * @param {number} height - The new height of the game.
	     */
	    resize: function (width, height)
	    {
	        this.events.emit('resize', width, height);
	    },
	
	    /**
	     * Shutdown this Scene and send a shutdown event to all of its systems.
	     * A Scene that has been shutdown will not run its update loop or render, but it does
	     * not destroy any of its plugins or references. It is put into hibernation for later use.
	     * If you don't ever plan to use this Scene again, then it should be destroyed instead
	     * to free-up resources.
	     *
	     * @method Phaser.Scenes.Systems#shutdown
	     * @since 3.0.0
	     */
	    shutdown: function ()
	    {
	        this.events.off('transitioninit');
	        this.events.off('transitionstart');
	        this.events.off('transitioncomplete');
	        this.events.off('transitionout');
	
	        this.settings.status = CONST.SHUTDOWN;
	
	        this.settings.active = false;
	        this.settings.visible = false;
	
	        this.events.emit('shutdown', this);
	    },
	
	    /**
	     * Destroy this Scene and send a destroy event all of its systems.
	     * A destroyed Scene cannot be restarted.
	     * You should not call this directly, instead use `SceneManager.remove`.
	     *
	     * @method Phaser.Scenes.Systems#destroy
	     * @private
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.settings.status = CONST.DESTROYED;
	
	        this.settings.active = false;
	        this.settings.visible = false;
	
	        this.events.emit('destroy', this);
	
	        this.events.removeAllListeners();
	
	        var props = [ 'scene', 'game', 'anims', 'cache', 'plugins', 'registry', 'sound', 'textures', 'add', 'camera', 'displayList', 'events', 'make', 'scenePlugin', 'updateList' ];
	
	        for (var i = 0; i < props.length; i++)
	        {
	            this[props[i]] = null;
	        }
	    }
	
	});
	
	module.exports = Systems;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	
	/**
	 * @callback EachMapCallback
	 * @generic E - [entry]
	 *
	 * @param {string} key - [description]
	 * @param {*} entry - [description]
	 *
	 * @return {?boolean} [description]
	 */
	
	/**
	 * @classdesc
	 * The keys of a Map can be arbitrary values.
	 * var map = new Map([
	 *    [ 1, 'one' ],
	 *    [ 2, 'two' ],
	 *    [ 3, 'three' ]
	 * ]);
	 *
	 * @class Map
	 * @memberOf Phaser.Structs
	 * @constructor
	 * @since 3.0.0
	 *
	 * @generic K
	 * @generic V
	 * @genericUse {V[]} - [elements]
	 *
	 * @param {Array.<*>} elements - [description]
	 */
	var Map = new Class({
	
	    initialize:
	
	    function Map (elements)
	    {
	        /**
	         * [description]
	         *
	         * @genericUse {Object.<string, V>} - [$type]
	         *
	         * @name Phaser.Structs.Map#entries
	         * @type {Object.<string, *>}
	         * @default {}
	         * @since 3.0.0
	         */
	        this.entries = {};
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Structs.Map#size
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.size = 0;
	
	        if (Array.isArray(elements))
	        {
	            for (var i = 0; i < elements.length; i++)
	            {
	                this.set(elements[i][0], elements[i][1]);
	            }
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.Map#set
	     * @since 3.0.0
	     *
	     * @genericUse {K} - [key]
	     * @genericUse {V} - [value]
	     * @genericUse {Phaser.Structs.Map.<K, V>} - [$return]
	     *
	     * @param {string} key - [description]
	     * @param {*} value - [description]
	     *
	     * @return {Phaser.Structs.Map} This Map object.
	     */
	    set: function (key, value)
	    {
	        if (!this.has(key))
	        {
	            this.entries[key] = value;
	            this.size++;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.Map#get
	     * @since 3.0.0
	     *
	     * @genericUse {K} - [key]
	     * @genericUse {V} - [$return]
	     *
	     * @param {string} key - [description]
	     *
	     * @return {*} [description]
	     */
	    get: function (key)
	    {
	        if (this.has(key))
	        {
	            return this.entries[key];
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.Map#getArray
	     * @since 3.0.0
	     *
	     * @genericUse {V[]} - [$return]
	     *
	     * @return {Array.<*>} [description]
	     */
	    getArray: function ()
	    {
	        var output = [];
	        var entries = this.entries;
	
	        for (var key in entries)
	        {
	            output.push(entries[key]);
	        }
	
	        return output;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.Map#has
	     * @since 3.0.0
	     *
	     * @genericUse {K} - [key]
	     *
	     * @param {string} key - [description]
	     *
	     * @return {boolean} [description]
	     */
	    has: function (key)
	    {
	        return (this.entries.hasOwnProperty(key));
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.Map#delete
	     * @since 3.0.0
	     *
	     * @genericUse {K} - [key]
	     * @genericUse {Phaser.Structs.Map.<K, V>} - [$return]
	     *
	     * @param {string} key - [description]
	     *
	     * @return {Phaser.Structs.Map} This Map object.
	     */
	    delete: function (key)
	    {
	        if (this.has(key))
	        {
	            delete this.entries[key];
	            this.size--;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.Map#clear
	     * @since 3.0.0
	     *
	     * @genericUse {Phaser.Structs.Map.<K, V>} - [$return]
	     *
	     * @return {Phaser.Structs.Map} This Map object.
	     */
	    clear: function ()
	    {
	        Object.keys(this.entries).forEach(function (prop)
	        {
	            delete this.entries[prop];
	
	        }, this);
	
	        this.size = 0;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.Map#keys
	     * @since 3.0.0
	     *
	     * @genericUse {K[]} - [$return]
	     *
	     * @return {string[]} [description]
	     */
	    keys: function ()
	    {
	        return Object.keys(this.entries);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.Map#values
	     * @since 3.0.0
	     *
	     * @genericUse {V[]} - [$return]
	     *
	     * @return {Array.<*>} [description]
	     */
	    values: function ()
	    {
	        var output = [];
	        var entries = this.entries;
	
	        for (var key in entries)
	        {
	            output.push(entries[key]);
	        }
	
	        return output;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.Map#dump
	     * @since 3.0.0
	     */
	    dump: function ()
	    {
	        var entries = this.entries;
	
	        // eslint-disable-next-line no-console
	        console.group('Map');
	
	        for (var key in entries)
	        {
	            console.log(key, entries[key]);
	        }
	
	        // eslint-disable-next-line no-console
	        console.groupEnd();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.Map#each
	     * @since 3.0.0
	     *
	     * @genericUse {EachMapCallback.<V>} - [callback]
	     * @genericUse {Phaser.Structs.Map.<K, V>} - [$return]
	     *
	     * @param {EachMapCallback} callback - [description]
	     *
	     * @return {Phaser.Structs.Map} This Map object.
	     */
	    each: function (callback)
	    {
	        var entries = this.entries;
	
	        for (var key in entries)
	        {
	            if (callback(key, entries[key]) === false)
	            {
	                break;
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.Map#contains
	     * @since 3.0.0
	     *
	     * @genericUse {V} - [value]
	     *
	     * @param {*} value - [description]
	     *
	     * @return {boolean} [description]
	     */
	    contains: function (value)
	    {
	        var entries = this.entries;
	
	        for (var key in entries)
	        {
	            if (entries[key] === value)
	            {
	                return true;
	            }
	        }
	
	        return false;
	    },
	
	    /**
	     * Merges all new keys from the given Map into this one
	     * If it encounters a key that already exists it will be skipped
	     * unless override = true.
	     *
	     * @method Phaser.Structs.Map#merge
	     * @since 3.0.0
	     *
	     * @genericUse {Phaser.Structs.Map.<K, V>} - [map,$return]
	     *
	     * @param {Phaser.Structs.Map} map - [description]
	     * @param {boolean} [override=false] - [description]
	     *
	     * @return {Phaser.Structs.Map} This Map object.
	     */
	    merge: function (map, override)
	    {
	        if (override === undefined) { override = false; }
	
	        var local = this.entries;
	        var source = map.entries;
	
	        for (var key in source)
	        {
	            if (local.hasOwnProperty(key) && override)
	            {
	                local[key] = source[key];
	            }
	            else
	            {
	                this.set(key, source[key]);
	            }
	        }
	
	        return this;
	    }
	
	});
	
	module.exports = Map;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Extend = __webpack_require__(36);
	
	/**
	 * @classdesc
	 * A Frame is a section of a Texture.
	 *
	 * @class Frame
	 * @memberOf Phaser.Textures
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Textures.Texture} texture - The Texture this Frame is a part of.
	 * @param {(integer|string)} name - The name of this Frame. The name is unique within the Texture.
	 * @param {integer} sourceIndex - The index of the TextureSource that this Frame is a part of.
	 * @param {number} x - The x coordinate of the top-left of this Frame.
	 * @param {number} y - The y coordinate of the top-left of this Frame.
	 * @param {number} width - The width of this Frame.
	 * @param {number} height - The height of this Frame.
	 */
	var Frame = new Class({
	
	    initialize:
	
	    function Frame (texture, name, sourceIndex, x, y, width, height)
	    {
	        /**
	         * The Texture this Frame is a part of.
	         *
	         * @name Phaser.Textures.Frame#texture
	         * @type {Phaser.Textures.Texture}
	         * @since 3.0.0
	         */
	        this.texture = texture;
	
	        /**
	         * The name of this Frame.
	         * The name is unique within the Texture.
	         *
	         * @name Phaser.Textures.Frame#name
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.name = name;
	
	        /**
	         * The TextureSource this Frame is part of.
	         *
	         * @name Phaser.Textures.Frame#source
	         * @type {Phaser.Textures.TextureSource}
	         * @since 3.0.0
	         */
	        this.source = texture.source[sourceIndex];
	
	        /**
	         * The index of the TextureSource in the Texture sources array.
	         *
	         * @name Phaser.Textures.Frame#sourceIndex
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.sourceIndex = sourceIndex;
	
	        /**
	         * X position within the source image to cut from.
	         *
	         * @name Phaser.Textures.Frame#cutX
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.cutX;
	
	        /**
	         * Y position within the source image to cut from.
	         *
	         * @name Phaser.Textures.Frame#cutY
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.cutY;
	
	        /**
	         * The width of the area in the source image to cut.
	         *
	         * @name Phaser.Textures.Frame#cutWidth
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.cutWidth;
	
	        /**
	         * The height of the area in the source image to cut.
	         *
	         * @name Phaser.Textures.Frame#cutHeight
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.cutHeight;
	
	        /**
	         * The X rendering offset of this Frame, taking trim into account.
	         *
	         * @name Phaser.Textures.Frame#x
	         * @type {integer}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.x = 0;
	
	        /**
	         * The Y rendering offset of this Frame, taking trim into account.
	         *
	         * @name Phaser.Textures.Frame#y
	         * @type {integer}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.y = 0;
	
	        /**
	         * The rendering width of this Frame, taking trim into account.
	         *
	         * @name Phaser.Textures.Frame#width
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.width;
	
	        /**
	         * The rendering height of this Frame, taking trim into account.
	         *
	         * @name Phaser.Textures.Frame#height
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.height;
	
	        /**
	         * Half the width, floored.
	         * Precalculated for the renderer.
	         *
	         * @name Phaser.Textures.Frame#halfWidth
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.halfWidth;
	
	        /**
	         * Half the height, floored.
	         * Precalculated for the renderer.
	         *
	         * @name Phaser.Textures.Frame#halfHeight
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.halfHeight;
	
	        /**
	         * The x center of this frame, floored.
	         *
	         * @name Phaser.Textures.Frame#centerX
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.centerX;
	
	        /**
	         * The y center of this frame, floored.
	         *
	         * @name Phaser.Textures.Frame#centerY
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.centerY;
	
	        /**
	         * The horizontal pivot point of this Frame.
	         *
	         * @name Phaser.Textures.Frame#pivotX
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.pivotX = 0;
	
	        /**
	         * The vertical pivot point of this Frame.
	         *
	         * @name Phaser.Textures.Frame#pivotY
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.pivotY = 0;
	
	        /**
	         * Does this Frame have a custom pivot point?
	         *
	         * @name Phaser.Textures.Frame#customPivot
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.customPivot = false;
	
	        /**
	         * **CURRENTLY UNSUPPORTED**
	         *
	         * Is this frame is rotated or not in the Texture?
	         * Rotation allows you to use rotated frames in texture atlas packing.
	         * It has nothing to do with Sprite rotation.
	         *
	         * @name Phaser.Textures.Frame#rotated
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.rotated = false;
	
	        /**
	         * Over-rides the Renderer setting.
	         * -1 = use Renderer Setting
	         * 0 = No rounding
	         * 1 = Round
	         *
	         * @name Phaser.Textures.Frame#autoRound
	         * @type {integer}
	         * @default -1
	         * @since 3.0.0
	         */
	        this.autoRound = -1;
	
	        /**
	         * Any Frame specific custom data can be stored here.
	         *
	         * @name Phaser.Textures.Frame#customData
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.customData = {};
	
	        /**
	         * The un-modified source frame, trim and UV data.
	         *
	         * @name Phaser.Textures.Frame#data
	         * @type {object}
	         * @private
	         * @since 3.0.0
	         */
	        this.data = {
	            cut: {
	                x: 0,
	                y: 0,
	                w: 0,
	                h: 0,
	                r: 0,
	                b: 0
	            },
	            trim: false,
	            sourceSize: {
	                w: 0,
	                h: 0
	            },
	            spriteSourceSize: {
	                x: 0,
	                y: 0,
	                w: 0,
	                h: 0
	            },
	            uvs: {
	                x0: 0,
	                y0: 0,
	                x1: 0,
	                y1: 0,
	                x2: 0,
	                y2: 0,
	                x3: 0,
	                y3: 0
	            },
	            radius: 0,
	            drawImage: {
	                sx: 0,
	                sy: 0,
	                sWidth: 0,
	                sHeight: 0,
	                dWidth: 0,
	                dHeight: 0
	            }
	        };
	
	        this.setSize(width, height, x, y);
	    },
	
	    /**
	     * Sets the width, height, x and y of this Frame.
	     * 
	     * This is called automatically by the constructor
	     * and should rarely be changed on-the-fly.
	     *
	     * @method Phaser.Textures.Frame#setSize
	     * @since 3.7.0
	     *
	     * @param {integer} width - The width of the frame before being trimmed.
	     * @param {integer} height - The height of the frame before being trimmed.
	     * @param {integer} [x=0] - The x coordinate of the top-left of this Frame.
	     * @param {integer} [y=0] - The y coordinate of the top-left of this Frame.
	     *
	     * @return {Phaser.Textures.Frame} This Frame object.
	     */
	    setSize: function (width, height, x, y)
	    {
	        if (x === undefined) { x = 0; }
	        if (y === undefined) { y = 0; }
	
	        this.cutX = x;
	        this.cutY = y;
	        this.cutWidth = width;
	        this.cutHeight = height;
	
	        this.width = width;
	        this.height = height;
	
	        this.halfWidth = Math.floor(width * 0.5);
	        this.halfHeight = Math.floor(height * 0.5);
	
	        this.centerX = Math.floor(width / 2);
	        this.centerY = Math.floor(height / 2);
	
	        var data = this.data;
	        var cut = data.cut;
	
	        cut.x = x;
	        cut.y = y;
	        cut.w = width;
	        cut.h = height;
	        cut.r = x + width;
	        cut.b = y + height;
	
	        data.sourceSize.w = width;
	        data.sourceSize.h = height;
	
	        data.spriteSourceSize.w = width;
	        data.spriteSourceSize.h = height;
	
	        data.radius = 0.5 * Math.sqrt(width * width + height * height);
	
	        var drawImage = data.drawImage;
	
	        drawImage.sx = x;
	        drawImage.sy = y;
	        drawImage.sWidth = width;
	        drawImage.sHeight = height;
	        drawImage.dWidth = width;
	        drawImage.dHeight = height;
	
	        return this.updateUVs();
	    },
	
	    /**
	     * If the frame was trimmed when added to the Texture Atlas, this records the trim and source data.
	     *
	     * @method Phaser.Textures.Frame#setTrim
	     * @since 3.0.0
	     *
	     * @param {number} actualWidth - The width of the frame before being trimmed.
	     * @param {number} actualHeight - The height of the frame before being trimmed.
	     * @param {number} destX - The destination X position of the trimmed frame for display.
	     * @param {number} destY - The destination Y position of the trimmed frame for display.
	     * @param {number} destWidth - The destination width of the trimmed frame for display.
	     * @param {number} destHeight - The destination height of the trimmed frame for display.
	     *
	     * @return {Phaser.Textures.Frame} This Frame object.
	     */
	    setTrim: function (actualWidth, actualHeight, destX, destY, destWidth, destHeight)
	    {
	        var data = this.data;
	        var ss = data.spriteSourceSize;
	
	        //  Store actual values
	
	        data.trim = true;
	
	        data.sourceSize.w = actualWidth;
	        data.sourceSize.h = actualHeight;
	
	        ss.x = destX;
	        ss.y = destY;
	        ss.w = destWidth;
	        ss.h = destHeight;
	
	        //  Adjust properties
	        this.x = destX;
	        this.y = destY;
	
	        this.width = destWidth;
	        this.height = destHeight;
	
	        this.halfWidth = destWidth * 0.5;
	        this.halfHeight = destHeight * 0.5;
	
	        this.centerX = Math.floor(destWidth / 2);
	        this.centerY = Math.floor(destHeight / 2);
	
	        return this.updateUVs();
	    },
	
	    /**
	     * Updates the internal WebGL UV cache and the drawImage cache.
	     *
	     * @method Phaser.Textures.Frame#updateUVs
	     * @since 3.0.0
	     *
	     * @return {Phaser.Textures.Frame} This Frame object.
	     */
	    updateUVs: function ()
	    {
	        var cx = this.cutX;
	        var cy = this.cutY;
	        var cw = this.cutWidth;
	        var ch = this.cutHeight;
	
	        //  Canvas data
	
	        var cd = this.data.drawImage;
	
	        cd.sWidth = cw;
	        cd.sHeight = ch;
	        cd.dWidth = cw;
	        cd.dHeight = ch;
	
	        //  WebGL data
	
	        var tw = this.source.width;
	        var th = this.source.height;
	        var uvs = this.data.uvs;
	
	        uvs.x0 = cx / tw;
	        uvs.y0 = cy / th;
	
	        uvs.x1 = cx / tw;
	        uvs.y1 = (cy + ch) / th;
	
	        uvs.x2 = (cx + cw) / tw;
	        uvs.y2 = (cy + ch) / th;
	
	        uvs.x3 = (cx + cw) / tw;
	        uvs.y3 = cy / th;
	
	        return this;
	    },
	
	    /**
	     * Updates the internal WebGL UV cache.
	     *
	     * @method Phaser.Textures.Frame#updateUVsInverted
	     * @since 3.0.0
	     *
	     * @return {Phaser.Textures.Frame} This Frame object.
	     */
	    updateUVsInverted: function ()
	    {
	        var tw = this.source.width;
	        var th = this.source.height;
	        var uvs = this.data.uvs;
	
	        uvs.x3 = (this.cutX + this.cutHeight) / tw;
	        uvs.y3 = (this.cutY + this.cutWidth) / th;
	
	        uvs.x2 = this.cutX / tw;
	        uvs.y2 = (this.cutY + this.cutWidth) / th;
	
	        uvs.x1 = this.cutX / tw;
	        uvs.y1 = this.cutY / th;
	
	        uvs.x0 = (this.cutX + this.cutHeight) / tw;
	        uvs.y0 = this.cutY / th;
	
	        return this;
	    },
	
	    /**
	     * Clones this Frame into a new Frame object.
	     *
	     * @method Phaser.Textures.Frame#clone
	     * @since 3.0.0
	     *
	     * @return {Phaser.Textures.Frame} A clone of this Frame.
	     */
	    clone: function ()
	    {
	        var clone = new Frame(this.texture, this.name, this.sourceIndex);
	
	        clone.cutX = this.cutX;
	        clone.cutY = this.cutY;
	        clone.cutWidth = this.cutWidth;
	        clone.cutHeight = this.cutHeight;
	
	        clone.x = this.x;
	        clone.y = this.y;
	
	        clone.width = this.width;
	        clone.height = this.height;
	
	        clone.halfWidth = this.halfWidth;
	        clone.halfHeight = this.halfHeight;
	
	        clone.centerX = this.centerX;
	        clone.centerY = this.centerY;
	
	        clone.rotated = this.rotated;
	
	        clone.data = Extend(true, clone.data, this.data);
	
	        clone.updateUVs();
	
	        return clone;
	    },
	
	    /**
	     * Destroys this Frames references.
	     *
	     * @method Phaser.Textures.Frame#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.texture = null;
	
	        this.source = null;
	    },
	
	    /**
	     * The width of the Frame in its un-trimmed, un-padded state, as prepared in the art package,
	     * before being packed.
	     *
	     * @name Phaser.Textures.Frame#realWidth
	     * @type {number}
	     * @readOnly
	     * @since 3.0.0
	     */
	    realWidth: {
	
	        get: function ()
	        {
	            return this.data.sourceSize.w;
	        }
	
	    },
	
	    /**
	     * The height of the Frame in its un-trimmed, un-padded state, as prepared in the art package,
	     * before being packed.
	     *
	     * @name Phaser.Textures.Frame#realHeight
	     * @type {number}
	     * @readOnly
	     * @since 3.0.0
	     */
	    realHeight: {
	
	        get: function ()
	        {
	            return this.data.sourceSize.h;
	        }
	
	    },
	
	    /**
	     * The UV data for this Frame.
	     *
	     * @name Phaser.Textures.Frame#uvs
	     * @type {object}
	     * @readOnly
	     * @since 3.0.0
	     */
	    uvs: {
	
	        get: function ()
	        {
	            return this.data.uvs;
	        }
	
	    },
	
	    /**
	     * The radius of the Frame (derived from sqrt(w * w + h * h) / 2)
	     *
	     * @name Phaser.Textures.Frame#radius
	     * @type {number}
	     * @readOnly
	     * @since 3.0.0
	     */
	    radius: {
	
	        get: function ()
	        {
	            return this.data.radius;
	        }
	
	    },
	
	    /**
	     * Is the Frame trimmed or not?
	     *
	     * @name Phaser.Textures.Frame#trimmed
	     * @type {boolean}
	     * @readOnly
	     * @since 3.0.0
	     */
	    trimmed: {
	
	        get: function ()
	        {
	            return this.data.trim;
	        }
	
	    },
	
	    /**
	     * The Canvas drawImage data object.
	     *
	     * @name Phaser.Textures.Frame#canvasData
	     * @type {object}
	     * @readOnly
	     * @since 3.0.0
	     */
	    canvasData: {
	
	        get: function ()
	        {
	            return this.data.drawImage;
	        }
	
	    }
	
	});
	
	module.exports = Frame;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Frame = __webpack_require__(327);
	var TextureSource = __webpack_require__(635);
	
	/**
	 * @classdesc
	 * A Texture consists of a source, usually an Image from the Cache, and a collection of Frames.
	 * The Frames represent the different areas of the Texture. For example a texture atlas
	 * may have many Frames, one for each element within the atlas. Where-as a single image would have
	 * just one frame, that encompasses the whole image.
	 *
	 * Textures are managed by the global TextureManager. This is a singleton class that is
	 * responsible for creating and delivering Textures and their corresponding Frames to Game Objects.
	 *
	 * Sprites and other Game Objects get the texture data they need from the TextureManager.
	 *
	 * @class Texture
	 * @memberOf Phaser.Textures
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Textures.TextureManager} manager - A reference to the Texture Manager this Texture belongs to.
	 * @param {string} key - The unique string-based key of this Texture.
	 * @param {(HTMLImageElement[]|HTMLCanvasElement[])} source - An array of sources that are used to create the texture. Usually Images, but can also be a Canvas.
	 * @param {number} [width] - The width of the Texture. This is optional and automatically derived from the source images.
	 * @param {number} [height] - The height of the Texture. This is optional and automatically derived from the source images.
	 */
	var Texture = new Class({
	
	    initialize:
	
	    function Texture (manager, key, source, width, height)
	    {
	        if (!Array.isArray(source))
	        {
	            source = [ source ];
	        }
	
	        /**
	         * A reference to the Texture Manager this Texture belongs to.
	         *
	         * @name Phaser.Textures.Texture#manager
	         * @type {Phaser.Textures.TextureManager}
	         * @since 3.0.0
	         */
	        this.manager = manager;
	
	        /**
	         * The unique string-based key of this Texture.
	         *
	         * @name Phaser.Textures.Texture#key
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.key = key;
	
	        /**
	         * An array of TextureSource instances.
	         * These are unique to this Texture and contain the actual Image (or Canvas) data.
	         *
	         * @name Phaser.Textures.Texture#source
	         * @type {Phaser.Textures.TextureSource[]}
	         * @since 3.0.0
	         */
	        this.source = [];
	
	        /**
	         * An array of TextureSource data instances.
	         * Used to store additional data images, such as normal maps or specular maps.
	         *
	         * @name Phaser.Textures.Texture#dataSource
	         * @type {array}
	         * @since 3.0.0
	         */
	        this.dataSource = [];
	
	        /**
	         * A key-value object pair associating the unique Frame keys with the Frames objects.
	         *
	         * @name Phaser.Textures.Texture#frames
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.frames = {};
	
	        /**
	         * Any additional data that was set in the source JSON (if any),
	         * or any extra data you'd like to store relating to this texture
	         *
	         * @name Phaser.Textures.Texture#customData
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.customData = {};
	
	        /**
	         * The name of the first frame of the Texture.
	         *
	         * @name Phaser.Textures.Texture#firstFrame
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.firstFrame = '__BASE';
	
	        /**
	         * The total number of Frames in this Texture.
	         *
	         * @name Phaser.Textures.Texture#frameTotal
	         * @type {integer}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.frameTotal = 0;
	
	        //  Load the Sources
	        for (var i = 0; i < source.length; i++)
	        {
	            this.source.push(new TextureSource(this, source[i], width, height));
	        }
	    },
	
	    /**
	     * Adds a new Frame to this Texture.
	     *
	     * A Frame is a rectangular region of a TextureSource with a unique index or string-based key.
	     *
	     * @method Phaser.Textures.Texture#add
	     * @since 3.0.0
	     *
	     * @param {(integer|string)} name - The name of this Frame. The name is unique within the Texture.
	     * @param {integer} sourceIndex - The index of the TextureSource that this Frame is a part of.
	     * @param {number} x - The x coordinate of the top-left of this Frame.
	     * @param {number} y - The y coordinate of the top-left of this Frame.
	     * @param {number} width - The width of this Frame.
	     * @param {number} height - The height of this Frame.
	     *
	     * @return {Phaser.Textures.Frame} The Frame that was added to this Texture.
	     */
	    add: function (name, sourceIndex, x, y, width, height)
	    {
	        var frame = new Frame(this, name, sourceIndex, x, y, width, height);
	
	        this.frames[name] = frame;
	
	        //  Set the first frame of the Texture (other than __BASE)
	        //  This is used to ensure we don't spam the display with entire
	        //  atlases of sprite sheets, but instead just the first frame of them
	        //  should the dev incorrectly specify the frame index
	        if (this.frameTotal === 1)
	        {
	            this.firstFrame = name;
	        }
	
	        this.frameTotal++;
	
	        return frame;
	    },
	
	    /**
	     * Checks to see if a Frame matching the given key exists within this Texture.
	     *
	     * @method Phaser.Textures.Texture#has
	     * @since 3.0.0
	     *
	     * @param {string} name - The key of the Frame to check for.
	     *
	     * @return {boolean} True if a Frame with the matching key exists in this Texture.
	     */
	    has: function (name)
	    {
	        return (this.frames[name]);
	    },
	
	    /**
	     * Gets a Frame from this Texture based on either the key or the index of the Frame.
	     *
	     * In a Texture Atlas Frames are typically referenced by a key.
	     * In a Sprite Sheet Frames are referenced by an index.
	     * Passing no value for the name returns the base texture.
	     *
	     * @method Phaser.Textures.Texture#get
	     * @since 3.0.0
	     *
	     * @param {(string|integer)} [name] - The string-based name, or integer based index, of the Frame to get from this Texture.
	     *
	     * @return {Phaser.Textures.Frame} The Texture Frame.
	     */
	    get: function (name)
	    {
	        //  null, undefined, empty string, zero
	        if (!name)
	        {
	            name = this.firstFrame;
	        }
	
	        var frame = this.frames[name];
	
	        if (!frame)
	        {
	            console.warn('No Texture.frame found with name ' + name);
	
	            frame = this.frames[this.firstFrame];
	        }
	
	        return frame;
	    },
	
	    /**
	     * Takes the given TextureSource and returns the index of it within this Texture.
	     * If it's not in this Texture, it returns -1.
	     * Unless this Texture has multiple TextureSources, such as with a multi-atlas, this
	     * method will always return zero or -1.
	     *
	     * @method Phaser.Textures.Texture#getTextureSourceIndex
	     * @since 3.0.0
	     *
	     * @param {Phaser.Textures.TextureSource} source - The TextureSource to check.
	     *
	     * @return {integer} The index of the TextureSource within this Texture, or -1 if not in this Texture.
	     */
	    getTextureSourceIndex: function (source)
	    {
	        for (var i = 0; i < this.source.length; i++)
	        {
	            if (this.source[i] === source)
	            {
	                return i;
	            }
	        }
	
	        return -1;
	    },
	
	    /**
	     * Returns an array of all the Frames in the given TextureSource.
	     *
	     * @method Phaser.Textures.Texture#getFramesFromTextureSource
	     * @since 3.0.0
	     *
	     * @param {integer} sourceIndex - The index of the TextureSource to get the Frames from.
	     *
	     * @return {Phaser.Textures.Frame[]} An array of Texture Frames.
	     */
	    getFramesFromTextureSource: function (sourceIndex)
	    {
	        var out = [];
	
	        for (var frameName in this.frames)
	        {
	            if (frameName === '__BASE')
	            {
	                continue;
	            }
	
	            var frame = this.frames[frameName];
	
	            if (frame.sourceIndex === sourceIndex)
	            {
	                out.push(frame.name);
	            }
	        }
	
	        return out;
	    },
	
	    /**
	     * Returns an array with all of the names of the Frames in this Texture.
	     *
	     * Useful if you want to randomly assign a Frame to a Game Object, as you can
	     * pick a random element from the returned array.
	     *
	     * @method Phaser.Textures.Texture#getFrameNames
	     * @since 3.0.0
	     *
	     * @param {boolean} [includeBase=false] - Include the `__BASE` Frame in the output array?
	     *
	     * @return {string[]} An array of all Frame names in this Texture.
	     */
	    getFrameNames: function (includeBase)
	    {
	        if (includeBase === undefined) { includeBase = false; }
	
	        var out = Object.keys(this.frames);
	
	        if (!includeBase)
	        {
	            var idx = out.indexOf('__BASE');
	
	            if (idx !== -1)
	            {
	                out.splice(idx, 1);
	            }
	        }
	
	        return out;
	    },
	
	    /**
	     * Given a Frame name, return the source image it uses to render with.
	     *
	     * This will return the actual DOM Image or Canvas element.
	     *
	     * @method Phaser.Textures.Texture#getSourceImage
	     * @since 3.0.0
	     *
	     * @param {(string|integer)} [name] - The string-based name, or integer based index, of the Frame to get from this Texture.
	     *
	     * @return {(HTMLImageElement|HTMLCanvasElement)} The DOM Image or Canvas Element.
	     */
	    getSourceImage: function (name)
	    {
	        if (name === undefined || name === null || this.frameTotal === 1)
	        {
	            name = '__BASE';
	        }
	
	        var frame = this.frames[name];
	
	        if (!frame)
	        {
	            console.warn('No Texture.frame found with name ' + name);
	
	            return this.frames['__BASE'].source.image;
	        }
	        else
	        {
	            return frame.source.image;
	        }
	    },
	
	    /**
	     * Given a Frame name, return the data source image it uses to render with.
	     * You can use this to get the normal map for an image for example.
	     *
	     * This will return the actual DOM Image.
	     *
	     * @method Phaser.Textures.Texture#getDataSourceImage
	     * @since 3.7.0
	     *
	     * @param {(string|integer)} [name] - The string-based name, or integer based index, of the Frame to get from this Texture.
	     *
	     * @return {(HTMLImageElement|HTMLCanvasElement)} The DOM Image or Canvas Element.
	     */
	    getDataSourceImage: function (name)
	    {
	        if (name === undefined || name === null || this.frameTotal === 1)
	        {
	            name = '__BASE';
	        }
	
	        var frame = this.frames[name];
	        var idx;
	
	        if (!frame)
	        {
	            console.warn('No Texture.frame found with name ' + name);
	
	            idx = this.frames['__BASE'].sourceIndex;
	        }
	        else
	        {
	            idx = frame.sourceIndex;
	        }
	
	        return this.dataSource[idx].image;
	    },
	
	    /**
	     * Adds a data source image to this Texture.
	     *
	     * An example of a data source image would be a normal map, where all of the Frames for this Texture
	     * equally apply to the normal map.
	     *
	     * @method Phaser.Textures.Texture#setDataSource
	     * @since 3.0.0
	     *
	     * @param {(HTMLImageElement|HTMLCanvasElement)} data - The source image.
	     */
	    setDataSource: function (data)
	    {
	        if (!Array.isArray(data))
	        {
	            data = [ data ];
	        }
	
	        for (var i = 0; i < data.length; i++)
	        {
	            var source = this.source[i];
	
	            this.dataSource.push(new TextureSource(this, data[i], source.width, source.height));
	        }
	    },
	
	    /**
	     * Sets the Filter Mode for this Texture.
	     *
	     * The mode can be either Linear, the default, or Nearest.
	     *
	     * For pixel-art you should use Nearest.
	     *
	     * The mode applies to the entire Texture, not just a specific Frame of it.
	     *
	     * @method Phaser.Textures.Texture#setFilter
	     * @since 3.0.0
	     *
	     * @param {Phaser.Textures.FilterMode} filterMode - The Filter Mode.
	     */
	    setFilter: function (filterMode)
	    {
	        var i;
	
	        for (i = 0; i < this.source.length; i++)
	        {
	            this.source[i].setFilter(filterMode);
	        }
	
	        for (i = 0; i < this.dataSource.length; i++)
	        {
	            this.dataSource[i].setFilter(filterMode);
	        }
	    },
	
	    /**
	     * Destroys this Texture and releases references to its sources and frames.
	     *
	     * @method Phaser.Textures.Texture#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        var i;
	
	        for (i = 0; i < this.source.length; i++)
	        {
	            this.source[i].destroy();
	        }
	
	        for (i = 0; i < this.dataSource.length; i++)
	        {
	            this.dataSource[i].destroy();
	        }
	
	        for (var frameName in this.frames)
	        {
	            var frame = this.frames[frameName];
	
	            frame.destroy();
	        }
	
	        this.source = [];
	        this.dataSource = [];
	        this.frames = {};
	        this.manager = null;
	    }
	
	});
	
	module.exports = Texture;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Formats = __webpack_require__(57);
	var MapData = __webpack_require__(171);
	var Parse = __webpack_require__(644);
	var Tilemap = __webpack_require__(638);
	
	/**
	 * Create a Tilemap from the given key or data. If neither is given, make a blank Tilemap. When
	 * loading from CSV or a 2D array, you should specify the tileWidth & tileHeight. When parsing from
	 * a map from Tiled, the tileWidth, tileHeight, width & height will be pulled from the map data. For
	 * an empty map, you should specify tileWidth, tileHeight, width & height.
	 *
	 * @function Phaser.Tilemaps.ParseToTilemap
	 * @since 3.0.0
	 * 
	 * @param {Phaser.Scene} scene - The Scene to which this Tilemap belongs.
	 * @param {string} [key] - The key in the Phaser cache that corresponds to the loaded tilemap data.
	 * @param {integer} [tileWidth=32] - The width of a tile in pixels.
	 * @param {integer} [tileHeight=32] - The height of a tile in pixels.
	 * @param {integer} [width=10] - The width of the map in tiles.
	 * @param {integer} [height=10] - The height of the map in tiles.
	 * @param {integer[][]} [data] - Instead of loading from the cache, you can also load directly from
	 * a 2D array of tile indexes.
	 * @param {boolean} [insertNull=false] - Controls how empty tiles, tiles with an index of -1, in the
	 * map data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
	 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
	 * the tile data doesn't need to change then setting this value to `true` will help with memory
	 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
	 * the default value set.
	 * 
	 * @return {Phaser.Tilemaps.Tilemap}
	 */
	var ParseToTilemap = function (scene, key, tileWidth, tileHeight, width, height, data, insertNull)
	{
	    if (tileWidth === undefined) { tileWidth = 32; }
	    if (tileHeight === undefined) { tileHeight = 32; }
	    if (width === undefined) { width = 10; }
	    if (height === undefined) { height = 10; }
	    if (insertNull === undefined) { insertNull = false; }
	
	    var mapData = null;
	
	    if (Array.isArray(data))
	    {
	        var name = key !== undefined ? key : 'map';
	        mapData = Parse(name, Formats.ARRAY_2D, data, tileWidth, tileHeight, insertNull);
	    }
	    else if (key !== undefined)
	    {
	        var tilemapData = scene.cache.tilemap.get(key);
	
	        if (!tilemapData)
	        {
	            console.warn('No map data found for key ' + key);
	        }
	        else
	        {
	            mapData = Parse(key, tilemapData.format, tilemapData.data, tileWidth, tileHeight, insertNull);
	        }
	    }
	
	    if (mapData === null)
	    {
	        mapData = new MapData({
	            tileWidth: tileWidth,
	            tileHeight: tileHeight,
	            width: width,
	            height: height
	        });
	    }
	
	    return new Tilemap(scene, mapData);
	};
	
	module.exports = ParseToTilemap;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetTileAt = __webpack_require__(212);
	
	/**
	 * Calculates interesting faces at the given tile coordinates of the specified layer. Interesting
	 * faces are used internally for optimizing collisions against tiles. This method is mostly used
	 * internally to optimize recalculating faces when only one tile has been changed.
	 *
	 * @function Phaser.Tilemaps.Components.CalculateFacesAt
	 * @private
	 * @since 3.0.0
	 * 
	 * @param {integer} tileX - The x coordinate.
	 * @param {integer} tileY - The y coordinate.
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 */
	var CalculateFacesAt = function (tileX, tileY, layer)
	{
	    var tile = GetTileAt(tileX, tileY, true, layer);
	    var above = GetTileAt(tileX, tileY - 1, true, layer);
	    var below = GetTileAt(tileX, tileY + 1, true, layer);
	    var left = GetTileAt(tileX - 1, tileY, true, layer);
	    var right = GetTileAt(tileX + 1, tileY, true, layer);
	    var tileCollides = tile && tile.collides;
	
	    // Assume the changed tile has all interesting edges
	    if (tileCollides)
	    {
	        tile.faceTop = true;
	        tile.faceBottom = true;
	        tile.faceLeft = true;
	        tile.faceRight = true;
	    }
	
	    // Reset edges that are shared between tile and its neighbors
	    if (above && above.collides)
	    {
	        if (tileCollides) { tile.faceTop = false; }
	        above.faceBottom = !tileCollides;
	    }
	
	    if (below && below.collides)
	    {
	        if (tileCollides) { tile.faceBottom = false; }
	        below.faceTop = !tileCollides;
	    }
	
	    if (left && left.collides)
	    {
	        if (tileCollides) { tile.faceLeft = false; }
	        left.faceRight = !tileCollides;
	    }
	
	    if (right && right.collides)
	    {
	        if (tileCollides) { tile.faceRight = false; }
	        right.faceLeft = !tileCollides;
	    }
	
	    if (tile && !tile.collides) { tile.resetFaces(); }
	
	    return tile;
	};
	
	module.exports = CalculateFacesAt;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Tile = __webpack_require__(120);
	var IsInLayerBounds = __webpack_require__(169);
	var CalculateFacesAt = __webpack_require__(330);
	var SetTileCollision = __webpack_require__(121);
	
	/**
	 * Puts a tile at the given tile coordinates in the specified layer. You can pass in either an index
	 * or a Tile object. If you pass in a Tile, all attributes will be copied over to the specified
	 * location. If you pass in an index, only the index at the specified location will be changed.
	 * Collision information will be recalculated at the specified location.
	 *
	 * @function Phaser.Tilemaps.Components.PutTileAt
	 * @private
	 * @since 3.0.0
	 *
	 * @param {(integer|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
	 * @param {integer} tileX - [description]
	 * @param {integer} tileY - [description]
	 * @param {boolean} [recalculateFaces=true] - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 *
	 * @return {Phaser.Tilemaps.Tile} The Tile object that was created or added to this map.
	 */
	var PutTileAt = function (tile, tileX, tileY, recalculateFaces, layer)
	{
	    if (!IsInLayerBounds(tileX, tileY, layer)) { return null; }
	    if (recalculateFaces === undefined) { recalculateFaces = true; }
	
	    var oldTile = layer.data[tileY][tileX];
	    var oldTileCollides = oldTile && oldTile.collides;
	
	    if (tile instanceof Tile)
	    {
	        if (layer.data[tileY][tileX] === null)
	        {
	            layer.data[tileY][tileX] = new Tile(layer, tile.index, tileX, tileY, tile.width, tile.height);
	        }
	        layer.data[tileY][tileX].copy(tile);
	    }
	    else
	    {
	        var index = tile;
	        if (layer.data[tileY][tileX] === null)
	        {
	            layer.data[tileY][tileX] = new Tile(layer, index, tileX, tileY, layer.tileWidth, layer.tileHeight);
	        }
	        else
	        {
	            layer.data[tileY][tileX].index = index;
	        }
	    }
	
	    // Updating colliding flag on the new tile
	    var newTile = layer.data[tileY][tileX];
	    var collides = layer.collideIndexes.indexOf(newTile.index) !== -1;
	    SetTileCollision(newTile, collides);
	
	    // Recalculate faces only if the colliding flag at (tileX, tileY) has changed
	    if (recalculateFaces && (oldTileCollides !== newTile.collides))
	    {
	        CalculateFacesAt(tileX, tileY, layer);
	    }
	
	    return newTile;
	};
	
	module.exports = PutTileAt;
	


/***/ }),
/* 332 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Internally used method to keep track of the tile indexes that collide within a layer. This
	 * updates LayerData.collideIndexes to either contain or not contain the given `tileIndex`.
	 *
	 * @function Phaser.Tilemaps.Components.SetLayerCollisionIndex
	 * @private
	 * @since 3.0.0
	 *
	 * @param {integer} tileIndex - [description]
	 * @param {boolean} [collides=true] - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 */
	var SetLayerCollisionIndex = function (tileIndex, collides, layer)
	{
	    var loc = layer.collideIndexes.indexOf(tileIndex);
	
	    if (collides && loc === -1)
	    {
	        layer.collideIndexes.push(tileIndex);
	    }
	    else if (!collides && loc !== -1)
	    {
	        layer.collideIndexes.splice(loc, 1);
	    }
	};
	
	module.exports = SetLayerCollisionIndex;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Formats = __webpack_require__(57);
	var LayerData = __webpack_require__(170);
	var MapData = __webpack_require__(171);
	var Tile = __webpack_require__(120);
	
	/**
	 * Parses a 2D array of tile indexes into a new MapData object with a single layer.
	 *
	 * @function Phaser.Tilemaps.Parsers.Parse2DArray
	 * @since 3.0.0
	 *
	 * @param {string} name - The name of the tilemap, used to set the name on the MapData.
	 * @param {integer[][]} data - 2D array, CSV string or Tiled JSON object.
	 * @param {integer} tileWidth - The width of a tile in pixels.
	 * @param {integer} tileHeight - The height of a tile in pixels.
	 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
	 * data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
	 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
	 * the tile data doesn't need to change then setting this value to `true` will help with memory
	 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
	 * the default value set.
	 *
	 * @return {Phaser.Tilemaps.MapData} [description]
	 */
	var Parse2DArray = function (name, data, tileWidth, tileHeight, insertNull)
	{
	    var layerData = new LayerData({
	        tileWidth: tileWidth,
	        tileHeight: tileHeight
	    });
	
	    var mapData = new MapData({
	        name: name,
	        tileWidth: tileWidth,
	        tileHeight: tileHeight,
	        format: Formats.ARRAY_2D,
	        layers: [ layerData ]
	    });
	
	    var tiles = [];
	    var height = data.length;
	    var width = 0;
	
	    for (var y = 0; y < data.length; y++)
	    {
	        tiles[y] = [];
	        var row = data[y];
	
	        for (var x = 0; x < row.length; x++)
	        {
	            var tileIndex = parseInt(row[x], 10);
	
	            if (Number.isNaN(tileIndex) || tileIndex === -1)
	            {
	                tiles[y][x] = insertNull
	                    ? null
	                    : new Tile(layerData, -1, x, y, tileWidth, tileHeight);
	            }
	            else
	            {
	                tiles[y][x] = new Tile(layerData, tileIndex, x, y, tileWidth, tileHeight);
	            }
	        }
	
	        if (width === 0)
	        {
	            width = row.length;
	        }
	    }
	
	    mapData.width = layerData.width = width;
	    mapData.height = layerData.height = height;
	    mapData.widthInPixels = layerData.widthInPixels = width * tileWidth;
	    mapData.heightInPixels = layerData.heightInPixels = height * tileHeight;
	    layerData.data = tiles;
	
	    return mapData;
	};
	
	module.exports = Parse2DArray;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetValue = __webpack_require__(10);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Tweens.Builders.GetTargets
	 * @since 3.0.0
	 *
	 * @param {object} config - [description]
	 *
	 * @return {array} [description]
	 */
	var GetTargets = function (config)
	{
	    var targets = GetValue(config, 'targets', null);
	
	    if (targets === null)
	    {
	        return targets;
	    }
	
	    if (typeof targets === 'function')
	    {
	        targets = targets.call();
	    }
	
	    if (!Array.isArray(targets))
	    {
	        targets = [ targets ];
	    }
	
	    return targets;
	};
	
	module.exports = GetTargets;


/***/ }),
/* 335 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	function hasGetStart (def)
	{
	    return (!!def.getStart && typeof def.getStart === 'function');
	}
	
	function hasGetEnd (def)
	{
	    return (!!def.getEnd && typeof def.getEnd === 'function');
	}
	
	function hasGetters (def)
	{
	    return hasGetStart(def) || hasGetEnd(def);
	}
	
	/**
	 * [description]
	 *
	 * @function Phaser.Tweens.Builders.GetValueOp
	 * @since 3.0.0
	 *
	 * @param {string} key - [description]
	 * @param {*} propertyValue - [description]
	 *
	 * @return {function} [description]
	 */
	var GetValueOp = function (key, propertyValue)
	{
	    var callbacks;
	
	    //  The returned value sets what the property will be at the END of the Tween (usually called at the start of the Tween)
	    var getEnd = function (target, key, value) { return value; };
	
	    //  The returned value sets what the property will be at the START of the Tween (usually called at the end of the Tween)
	    var getStart = function (target, key, value) { return value; };
	
	    var t = typeof(propertyValue);
	
	    if (t === 'number')
	    {
	        // props: {
	        //     x: 400,
	        //     y: 300
	        // }
	
	        getEnd = function ()
	        {
	            return propertyValue;
	        };
	    }
	    else if (t === 'string')
	    {
	        // props: {
	        //     x: '+=400',
	        //     y: '-=300',
	        //     z: '*=2',
	        //     w: '/=2'
	        // }
	
	        var op = propertyValue[0];
	        var num = parseFloat(propertyValue.substr(2));
	
	        switch (op)
	        {
	            case '+':
	                getEnd = function (target, key, value)
	                {
	                    return value + num;
	                };
	                break;
	
	            case '-':
	                getEnd = function (target, key, value)
	                {
	                    return value - num;
	                };
	                break;
	
	            case '*':
	                getEnd = function (target, key, value)
	                {
	                    return value * num;
	                };
	                break;
	
	            case '/':
	                getEnd = function (target, key, value)
	                {
	                    return value / num;
	                };
	                break;
	
	            default:
	                getEnd = function ()
	                {
	                    return parseFloat(propertyValue);
	                };
	        }
	    }
	    else if (t === 'function')
	    {
	        //  The same as setting just the getEnd function and no getStart
	
	        // props: {
	        //     x: function (target, key, value) { return value + 50); },
	        // }
	
	        getEnd = propertyValue;
	    }
	    else if (t === 'object' && hasGetters(propertyValue))
	    {
	        /*
	        x: {
	            //  Called at the start of the Tween. The returned value sets what the property will be at the END of the Tween.
	            getEnd: function (target, key, value)
	            {
	                return value;
	            },
	
	            //  Called at the end of the Tween. The returned value sets what the property will be at the START of the Tween.
	            getStart: function (target, key, value)
	            {
	                return value;
	            }
	        }
	        */
	
	        if (hasGetEnd(propertyValue))
	        {
	            getEnd = propertyValue.getEnd;
	        }
	
	        if (hasGetStart(propertyValue))
	        {
	            getStart = propertyValue.getStart;
	        }
	    }
	    else if (propertyValue.hasOwnProperty('value'))
	    {
	        //  Value may still be a string, function or a number
	        // props: {
	        //     x: { value: 400, ... },
	        //     y: { value: 300, ... }
	        // }
	
	        callbacks = GetValueOp(key, propertyValue.value);
	    }
	
	    //  If callback not set by the else if block above then set it here and return it
	    if (!callbacks)
	    {
	        callbacks = {
	            getEnd: getEnd,
	            getStart: getStart
	        };
	    }
	
	    return callbacks;
	};
	
	module.exports = GetValueOp;


/***/ }),
/* 336 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @typedef {object} Phaser.Tweens.TweenConfigDefaults
	 * 
	 * @property {(object|object[])} targets - [description]
	 * @property {number} [delay=0] - [description]
	 * @property {number} [duration=1000] - [description]
	 * @property {string} [ease='Power0'] - [description]
	 * @property {array} [easeParams] - [description]
	 * @property {number} [hold=0] - [description]
	 * @property {number} [repeat=0] - [description]
	 * @property {number} [repeatDelay=0] - [description]
	 * @property {boolean} [yoyo=false] - [description]
	 * @property {boolean} [flipX=false] - [description]
	 * @property {boolean} [flipY=false] - [description]
	 */
	
	var TWEEN_DEFAULTS = {
	    targets: null,
	    delay: 0,
	    duration: 1000,
	    ease: 'Power0',
	    easeParams: null,
	    hold: 0,
	    repeat: 0,
	    repeatDelay: 0,
	    yoyo: false,
	    flipX: false,
	    flipY: false
	};
	
	module.exports = TWEEN_DEFAULTS;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var GameObjectCreator = __webpack_require__(26);
	var GameObjectFactory = __webpack_require__(18);
	var TWEEN_CONST = __webpack_require__(174);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class Tween
	 * @memberOf Phaser.Tweens
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {(Phaser.Tweens.TweenManager|Phaser.Tweens.Timeline)} parent - [description]
	 * @param {Phaser.Tweens.TweenDataConfig[]} data - [description]
	 * @param {array} targets - [description]
	 */
	var Tween = new Class({
	
	    initialize:
	
	    function Tween (parent, data, targets)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Tweens.Tween#parent
	         * @type {(Phaser.Tweens.TweenManager|Phaser.Tweens.Timeline)}
	         * @since 3.0.0
	         */
	        this.parent = parent;
	
	        /**
	         * Is the parent of this Tween a Timeline?
	         *
	         * @name Phaser.Tweens.Tween#parentIsTimeline
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.parentIsTimeline = parent.hasOwnProperty('isTimeline');
	
	        /**
	         * An array of TweenData objects, each containing a unique property and target being tweened.
	         *
	         * @name Phaser.Tweens.Tween#data
	         * @type {Phaser.Tweens.TweenDataConfig[]}
	         * @since 3.0.0
	         */
	        this.data = data;
	
	        /**
	         * data array doesn't change, so we can cache the length
	         *
	         * @name Phaser.Tweens.Tween#totalData
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.totalData = data.length;
	
	        /**
	         * An array of references to the target/s this Tween is operating on
	         *
	         * @name Phaser.Tweens.Tween#targets
	         * @type {object[]}
	         * @since 3.0.0
	         */
	        this.targets = targets;
	
	        /**
	         * Cached target total (not necessarily the same as the data total)
	         *
	         * @name Phaser.Tweens.Tween#totalTargets
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.totalTargets = targets.length;
	
	        /**
	         * If true then duration, delay, etc values are all frame totals.
	         *
	         * @name Phaser.Tweens.Tween#useFrames
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.useFrames = false;
	
	        /**
	         * Scales the time applied to this Tween. A value of 1 runs in real-time. A value of 0.5 runs 50% slower, and so on.
	         * Value isn't used when calculating total duration of the tween, it's a run-time delta adjustment only.
	         *
	         * @name Phaser.Tweens.Tween#timeScale
	         * @type {number}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.timeScale = 1;
	
	        /**
	         * Loop this tween? Can be -1 for an infinite loop, or an integer.
	         * When enabled it will play through ALL TweenDatas again (use TweenData.repeat to loop a single TD)
	         *
	         * @name Phaser.Tweens.Tween#loop
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.loop = 0;
	
	        /**
	         * Time in ms/frames before the tween loops.
	         *
	         * @name Phaser.Tweens.Tween#loopDelay
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.loopDelay = 0;
	
	        /**
	         * How many loops are left to run?
	         *
	         * @name Phaser.Tweens.Tween#loopCounter
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.loopCounter = 0;
	
	        /**
	         * Time in ms/frames before the 'onComplete' event fires. This never fires if loop = -1 (as it never completes)
	         *
	         * @name Phaser.Tweens.Tween#completeDelay
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.completeDelay = 0;
	
	        /**
	         * Countdown timer (used by timeline offset, loopDelay and completeDelay)
	         *
	         * @name Phaser.Tweens.Tween#countdown
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.countdown = 0;
	
	        /**
	         * Set only if this Tween is part of a Timeline.
	         *
	         * @name Phaser.Tweens.Tween#offset
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.offset = 0;
	
	        /**
	         * Set only if this Tween is part of a Timeline. The calculated offset amount.
	         *
	         * @name Phaser.Tweens.Tween#calculatedOffset
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.calculatedOffset = 0;
	
	        /**
	         * The current state of the tween
	         *
	         * @name Phaser.Tweens.Tween#state
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.state = TWEEN_CONST.PENDING_ADD;
	
	        /**
	         * The state of the tween when it was paused (used by Resume)
	         *
	         * @name Phaser.Tweens.Tween#_pausedState
	         * @type {integer}
	         * @private
	         * @since 3.0.0
	         */
	        this._pausedState = TWEEN_CONST.PENDING_ADD;
	
	        /**
	         * Does the Tween start off paused? (if so it needs to be started with Tween.play)
	         *
	         * @name Phaser.Tweens.Tween#paused
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.paused = false;
	
	        /**
	         * Elapsed time in ms/frames of this run through the Tween.
	         *
	         * @name Phaser.Tweens.Tween#elapsed
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.elapsed = 0;
	
	        /**
	         * Total elapsed time in ms/frames of the entire Tween, including looping.
	         *
	         * @name Phaser.Tweens.Tween#totalElapsed
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.totalElapsed = 0;
	
	        /**
	         * Time in ms/frames for the whole Tween to play through once, excluding loop amounts and loop delays.
	         *
	         * @name Phaser.Tweens.Tween#duration
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.duration = 0;
	
	        /**
	         * Value between 0 and 1. The amount through the Tween, excluding loops.
	         *
	         * @name Phaser.Tweens.Tween#progress
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.progress = 0;
	
	        /**
	         * Time in ms/frames for the Tween to complete (including looping)
	         *
	         * @name Phaser.Tweens.Tween#totalDuration
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.totalDuration = 0;
	
	        /**
	         * Value between 0 and 1. The amount through the entire Tween, including looping.
	         *
	         * @name Phaser.Tweens.Tween#totalProgress
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.totalProgress = 0;
	
	        /**
	         * An object containing the various Tween callback references.
	         *
	         * @name Phaser.Tweens.Tween#callbacks
	         * @type {object}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.callbacks = {
	            onComplete: null,
	            onLoop: null,
	            onRepeat: null,
	            onStart: null,
	            onUpdate: null,
	            onYoyo: null
	        };
	
	        this.callbackScope;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Tween#getValue
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    getValue: function ()
	    {
	        return this.data[0].current;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Tween#setTimeScale
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.Tweens.Tween} This Tween object.
	     */
	    setTimeScale: function (value)
	    {
	        this.timeScale = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Tween#getTimeScale
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    getTimeScale: function ()
	    {
	        return this.timeScale;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Tween#isPlaying
	     * @since 3.0.0
	     *
	     * @return {boolean} [description]
	     */
	    isPlaying: function ()
	    {
	        return (this.state === TWEEN_CONST.ACTIVE);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Tween#isPaused
	     * @since 3.0.0
	     *
	     * @return {boolean} [description]
	     */
	    isPaused: function ()
	    {
	        return (this.state === TWEEN_CONST.PAUSED);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Tween#hasTarget
	     * @since 3.0.0
	     *
	     * @param {object} target - [description]
	     *
	     * @return {boolean} [description]
	     */
	    hasTarget: function (target)
	    {
	        return (this.targets.indexOf(target) !== -1);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Tween#updateTo
	     * @since 3.0.0
	     *
	     * @param {string} key - [description]
	     * @param {*} value - [description]
	     * @param {boolean} startToCurrent - [description]
	     *
	     * @return {Phaser.Tweens.Tween} This Tween object.
	     */
	    updateTo: function (key, value, startToCurrent)
	    {
	        for (var i = 0; i < this.totalData; i++)
	        {
	            var tweenData = this.data[i];
	
	            if (tweenData.key === key)
	            {
	                tweenData.end = value;
	
	                if (startToCurrent)
	                {
	                    tweenData.start = tweenData.current;
	                }
	
	                break;
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Tween#restart
	     * @since 3.0.0
	     */
	    restart: function ()
	    {
	        if (this.state === TWEEN_CONST.REMOVED)
	        {
	            this.seek(0);
	            this.parent.makeActive(this);
	        }
	        else
	        {
	            this.stop();
	            this.play();
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Tween#calcDuration
	     * @since 3.0.0
	     */
	    calcDuration: function ()
	    {
	        var max = 0;
	
	        var data = this.data;
	
	        for (var i = 0; i < this.totalData; i++)
	        {
	            var tweenData = data[i];
	
	            //  Set t1 (duration + hold + yoyo)
	            tweenData.t1 = tweenData.duration + tweenData.hold;
	
	            if (tweenData.yoyo)
	            {
	                tweenData.t1 += tweenData.duration;
	            }
	
	            //  Set t2 (repeatDelay + duration + hold + yoyo)
	            tweenData.t2 = tweenData.t1 + tweenData.repeatDelay;
	
	            //  Total Duration
	            tweenData.totalDuration = tweenData.delay + tweenData.t1;
	
	            if (tweenData.repeat === -1)
	            {
	                tweenData.totalDuration += (tweenData.t2 * 999999999999);
	            }
	            else if (tweenData.repeat > 0)
	            {
	                tweenData.totalDuration += (tweenData.t2 * tweenData.repeat);
	            }
	
	            if (tweenData.totalDuration > max)
	            {
	                //  Get the longest TweenData from the Tween, used to calculate the Tween TD
	                max = tweenData.totalDuration;
	            }
	        }
	
	        //  Excludes loop values
	        this.duration = max;
	
	        this.loopCounter = (this.loop === -1) ? 999999999999 : this.loop;
	
	        if (this.loopCounter > 0)
	        {
	            this.totalDuration = this.duration + this.completeDelay + ((this.duration + this.loopDelay) * this.loopCounter);
	        }
	        else
	        {
	            this.totalDuration = this.duration + this.completeDelay;
	        }
	    },
	
	    /**
	     * Called by TweenManager.preUpdate as part of its loop to check pending and active tweens.
	     * Should not be called directly.
	     *
	     * @method Phaser.Tweens.Tween#init
	     * @since 3.0.0
	     *
	     * @return {boolean} Returns `true` if this Tween should be moved from the pending list to the active list by the Tween Manager.
	     */
	    init: function ()
	    {
	        var data = this.data;
	        var totalTargets = this.totalTargets;
	
	        for (var i = 0; i < this.totalData; i++)
	        {
	            var tweenData = data[i];
	            var target = tweenData.target;
	            var gen = tweenData.gen;
	
	            tweenData.delay = gen.delay(i, totalTargets, target);
	            tweenData.duration = gen.duration(i, totalTargets, target);
	            tweenData.hold = gen.hold(i, totalTargets, target);
	            tweenData.repeat = gen.repeat(i, totalTargets, target);
	            tweenData.repeatDelay = gen.repeatDelay(i, totalTargets, target);
	        }
	
	        this.calcDuration();
	
	        this.progress = 0;
	        this.totalProgress = 0;
	        this.elapsed = 0;
	        this.totalElapsed = 0;
	
	        //  You can't have a paused Tween if it's part of a Timeline
	        if (this.paused && !this.parentIsTimeline)
	        {
	            this.state = TWEEN_CONST.PENDING_ADD;
	            this._pausedState = TWEEN_CONST.INIT;
	
	            return false;
	        }
	        else
	        {
	            this.state = TWEEN_CONST.INIT;
	
	            return true;
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Tween#nextState
	     * @since 3.0.0
	     */
	    nextState: function ()
	    {
	        if (this.loopCounter > 0)
	        {
	            this.elapsed = 0;
	            this.progress = 0;
	            this.loopCounter--;
	
	            var onLoop = this.callbacks.onLoop;
	
	            if (onLoop)
	            {
	                onLoop.params[1] = this.targets;
	
	                onLoop.func.apply(onLoop.scope, onLoop.params);
	            }
	
	            this.resetTweenData(true);
	
	            if (this.loopDelay > 0)
	            {
	                this.countdown = this.loopDelay;
	                this.state = TWEEN_CONST.LOOP_DELAY;
	            }
	            else
	            {
	                this.state = TWEEN_CONST.ACTIVE;
	            }
	        }
	        else if (this.completeDelay > 0)
	        {
	            this.countdown = this.completeDelay;
	            this.state = TWEEN_CONST.COMPLETE_DELAY;
	        }
	        else
	        {
	            var onComplete = this.callbacks.onComplete;
	
	            if (onComplete)
	            {
	                onComplete.params[1] = this.targets;
	
	                onComplete.func.apply(onComplete.scope, onComplete.params);
	            }
	
	            this.state = TWEEN_CONST.PENDING_REMOVE;
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Tween#pause
	     * @since 3.0.0
	     *
	     * @return {Phaser.Tweens.Tween} This Tween object.
	     */
	    pause: function ()
	    {
	        if (this.state === TWEEN_CONST.PAUSED)
	        {
	            return;
	        }
	
	        this.paused = true;
	
	        this._pausedState = this.state;
	
	        this.state = TWEEN_CONST.PAUSED;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Tween#play
	     * @since 3.0.0
	     *
	     * @param {boolean} resetFromTimeline - [description]
	     */
	    play: function (resetFromTimeline)
	    {
	        if (this.state === TWEEN_CONST.ACTIVE)
	        {
	            return;
	        }
	        else if (this.state === TWEEN_CONST.PENDING_REMOVE || this.state === TWEEN_CONST.REMOVED)
	        {
	            this.init();
	            this.parent.makeActive(this);
	            resetFromTimeline = true;
	        }
	
	        var onStart = this.callbacks.onStart;
	
	        if (this.parentIsTimeline)
	        {
	            this.resetTweenData(resetFromTimeline);
	
	            if (this.calculatedOffset === 0)
	            {
	                if (onStart)
	                {
	                    onStart.params[1] = this.targets;
	
	                    onStart.func.apply(onStart.scope, onStart.params);
	                }
	
	                this.state = TWEEN_CONST.ACTIVE;
	            }
	            else
	            {
	                this.countdown = this.calculatedOffset;
	
	                this.state = TWEEN_CONST.OFFSET_DELAY;
	            }
	        }
	        else if (this.paused)
	        {
	            this.paused = false;
	
	            this.parent.makeActive(this);
	        }
	        else
	        {
	            this.resetTweenData(resetFromTimeline);
	
	            this.state = TWEEN_CONST.ACTIVE;
	
	            if (onStart)
	            {
	                onStart.params[1] = this.targets;
	
	                onStart.func.apply(onStart.scope, onStart.params);
	            }
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Tween#resetTweenData
	     * @since 3.0.0
	     *
	     * @param {boolean} resetFromLoop - [description]
	     */
	    resetTweenData: function (resetFromLoop)
	    {
	        var data = this.data;
	
	        for (var i = 0; i < this.totalData; i++)
	        {
	            var tweenData = data[i];
	
	            tweenData.progress = 0;
	            tweenData.elapsed = 0;
	
	            tweenData.repeatCounter = (tweenData.repeat === -1) ? 999999999999 : tweenData.repeat;
	
	            if (resetFromLoop)
	            {
	                tweenData.start = tweenData.getStartValue(tweenData.target, tweenData.key, tweenData.start);
	
	                tweenData.end = tweenData.getEndValue(tweenData.target, tweenData.key, tweenData.end);
	
	                tweenData.current = tweenData.start;
	
	                tweenData.state = TWEEN_CONST.PLAYING_FORWARD;
	            }
	            else if (tweenData.delay > 0)
	            {
	                tweenData.elapsed = tweenData.delay;
	                tweenData.state = TWEEN_CONST.DELAY;
	            }
	            else
	            {
	                tweenData.state = TWEEN_CONST.PENDING_RENDER;
	            }
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Tween#resume
	     * @since 3.0.0
	     *
	     * @return {Phaser.Tweens.Tween} This Tween object.
	     */
	    resume: function ()
	    {
	        if (this.state === TWEEN_CONST.PAUSED)
	        {
	            this.paused = false;
	
	            this.state = this._pausedState;
	        }
	        else
	        {
	            this.play();
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Tween#seek
	     * @since 3.0.0
	     *
	     * @param {float} toPosition - A value between 0 and 1.
	     */
	    seek: function (toPosition)
	    {
	        var data = this.data;
	
	        for (var i = 0; i < this.totalData; i++)
	        {
	            //  This won't work with loop > 0 yet
	            var ms = this.totalDuration * toPosition;
	
	            var tweenData = data[i];
	            var progress = 0;
	            var elapsed = 0;
	
	            if (ms <= tweenData.delay)
	            {
	                progress = 0;
	                elapsed = 0;
	            }
	            else if (ms >= tweenData.totalDuration)
	            {
	                progress = 1;
	                elapsed = tweenData.duration;
	            }
	            else if (ms > tweenData.delay && ms <= tweenData.t1)
	            {
	                //  Keep it zero bound
	                ms = Math.max(0, ms - tweenData.delay);
	
	                //  Somewhere in the first playthru range
	                progress = ms / tweenData.t1;
	                elapsed = tweenData.duration * progress;
	            }
	            else if (ms > tweenData.t1 && ms < tweenData.totalDuration)
	            {
	                //  Somewhere in repeat land
	                ms -= tweenData.delay;
	                ms -= tweenData.t1;
	
	                // var repeats = Math.floor(ms / tweenData.t2);
	
	                //  remainder
	                ms = ((ms / tweenData.t2) % 1) * tweenData.t2;
	
	                if (ms > tweenData.repeatDelay)
	                {
	                    progress = ms / tweenData.t1;
	                    elapsed = tweenData.duration * progress;
	                }
	            }
	
	            tweenData.progress = progress;
	            tweenData.elapsed = elapsed;
	
	            var v = tweenData.ease(tweenData.progress);
	
	            tweenData.current = tweenData.start + ((tweenData.end - tweenData.start) * v);
	
	            // console.log(tweenData.key, 'Seek', tweenData.target[tweenData.key], 'to', tweenData.current, 'pro', tweenData.progress, 'marker', toPosition, progress);
	
	            // if (tweenData.current === 0)
	            // {
	            //     console.log('zero', tweenData.start, tweenData.end, v, 'progress', progress);
	            // }
	
	            tweenData.target[tweenData.key] = tweenData.current;
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Tween#setCallback
	     * @since 3.0.0
	     *
	     * @param {string} type - [description]
	     * @param {function} callback - [description]
	     * @param {array} [params] - [description]
	     * @param {object} [scope] - [description]
	     *
	     * @return {Phaser.Tweens.Tween} This Tween object.
	     */
	    setCallback: function (type, callback, params, scope)
	    {
	        this.callbacks[type] = { func: callback, scope: scope, params: params };
	
	        return this;
	    },
	
	    /**
	     * Flags the Tween as being complete, whatever stage of progress it is at.
	     *
	     * If an onComplete callback has been defined it will automatically invoke it, unless a `delay`
	     * argument is provided, in which case the Tween will delay for that period of time before calling the callback.
	     *
	     * If you don't need a delay, or have an onComplete callback, then call `Tween.stop` instead.
	     *
	     * @method Phaser.Tweens.Tween#complete
	     * @since 3.2.0
	     *
	     * @param {number} [delay=0] - The time to wait before invoking the complete callback. If zero it will fire immediately.
	     */
	    complete: function (delay)
	    {
	        if (delay === undefined) { delay = 0; }
	
	        if (delay)
	        {
	            this.countdown = delay;
	            this.state = TWEEN_CONST.COMPLETE_DELAY;
	        }
	        else
	        {
	            var onComplete = this.callbacks.onComplete;
	
	            if (onComplete)
	            {
	                onComplete.params[1] = this.targets;
	
	                onComplete.func.apply(onComplete.scope, onComplete.params);
	            }
	
	            this.state = TWEEN_CONST.PENDING_REMOVE;
	        }
	    },
	
	    /**
	     * Stops the Tween immediately, whatever stage of progress it is at and flags it for removal by the TweenManager.
	     *
	     * @method Phaser.Tweens.Tween#stop
	     * @since 3.0.0
	     *
	     * @param {float} [resetTo] - A value between 0 and 1.
	     */
	    stop: function (resetTo)
	    {
	        if (this.state === TWEEN_CONST.ACTIVE)
	        {
	            if (resetTo !== undefined)
	            {
	                this.seek(resetTo);
	            }
	        }
	
	        if (this.state !== TWEEN_CONST.REMOVED)
	        {
	            this.state = TWEEN_CONST.PENDING_REMOVE;
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Tween#update
	     * @since 3.0.0
	     *
	     * @param {number} timestamp - [description]
	     * @param {number} delta - [description]
	     *
	     * @return {boolean} Returns `true` if this Tween has finished and should be removed from the Tween Manager, otherwise returns `false`.
	     */
	    update: function (timestamp, delta)
	    {
	        if (this.state === TWEEN_CONST.PAUSED)
	        {
	            return false;
	        }
	
	        if (this.useFrames)
	        {
	            delta = 1 * this.parent.timeScale;
	        }
	
	        delta *= this.timeScale;
	
	        this.elapsed += delta;
	        this.progress = Math.min(this.elapsed / this.duration, 1);
	
	        this.totalElapsed += delta;
	        this.totalProgress = Math.min(this.totalElapsed / this.totalDuration, 1);
	
	        switch (this.state)
	        {
	            case TWEEN_CONST.ACTIVE:
	
	                var stillRunning = false;
	
	                for (var i = 0; i < this.totalData; i++)
	                {
	                    if (this.updateTweenData(this, this.data[i], delta))
	                    {
	                        stillRunning = true;
	                    }
	                }
	
	                //  Anything still running? If not, we're done
	                if (!stillRunning)
	                {
	                    this.nextState();
	                }
	
	                break;
	
	            case TWEEN_CONST.LOOP_DELAY:
	
	                this.countdown -= delta;
	
	                if (this.countdown <= 0)
	                {
	                    this.state = TWEEN_CONST.ACTIVE;
	                }
	
	                break;
	
	            case TWEEN_CONST.OFFSET_DELAY:
	
	                this.countdown -= delta;
	
	                if (this.countdown <= 0)
	                {
	                    var onStart = this.callbacks.onStart;
	
	                    if (onStart)
	                    {
	                        onStart.params[1] = this.targets;
	
	                        onStart.func.apply(onStart.scope, onStart.params);
	                    }
	
	                    this.state = TWEEN_CONST.ACTIVE;
	                }
	
	                break;
	
	            case TWEEN_CONST.COMPLETE_DELAY:
	
	                this.countdown -= delta;
	
	                if (this.countdown <= 0)
	                {
	                    var onComplete = this.callbacks.onComplete;
	
	                    if (onComplete)
	                    {
	                        onComplete.func.apply(onComplete.scope, onComplete.params);
	                    }
	
	                    this.state = TWEEN_CONST.PENDING_REMOVE;
	                }
	
	                break;
	        }
	
	        return (this.state === TWEEN_CONST.PENDING_REMOVE);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Tween#setStateFromEnd
	     * @since 3.0.0
	     *
	     * @param {Phaser.Tweens.Tween} tween - [description]
	     * @param {Phaser.Tweens.TweenDataConfig} tweenData - [description]
	     * @param {number} diff - [description]
	     *
	     * @return {integer} The state of this Tween.
	     */
	    setStateFromEnd: function (tween, tweenData, diff)
	    {
	        if (tweenData.yoyo)
	        {
	            //  We've hit the end of a Playing Forward TweenData and we have a yoyo
	
	            //  Account for any extra time we got from the previous frame
	            tweenData.elapsed = diff;
	            tweenData.progress = diff / tweenData.duration;
	
	            if (tweenData.flipX)
	            {
	                tweenData.target.toggleFlipX();
	            }
	
	            //  Problem: The flip and callback and so on gets called for every TweenData that triggers it at the same time.
	            //  If you're tweening several properties it can fire for all of them, at once.
	
	            if (tweenData.flipY)
	            {
	                tweenData.target.toggleFlipY();
	            }
	
	            var onYoyo = tween.callbacks.onYoyo;
	
	            if (onYoyo)
	            {
	                //  Element 1 is reserved for the target of the yoyo (and needs setting here)
	                onYoyo.params[1] = tweenData.target;
	
	                onYoyo.func.apply(onYoyo.scope, onYoyo.params);
	            }
	
	            tweenData.start = tweenData.getStartValue(tweenData.target, tweenData.key, tweenData.start);
	
	            return TWEEN_CONST.PLAYING_BACKWARD;
	        }
	        else if (tweenData.repeatCounter > 0)
	        {
	            //  We've hit the end of a Playing Forward TweenData and we have a Repeat.
	            //  So we're going to go right back to the start to repeat it again.
	
	            tweenData.repeatCounter--;
	
	            //  Account for any extra time we got from the previous frame
	            tweenData.elapsed = diff;
	            tweenData.progress = diff / tweenData.duration;
	
	            if (tweenData.flipX)
	            {
	                tweenData.target.toggleFlipX();
	            }
	
	            if (tweenData.flipY)
	            {
	                tweenData.target.toggleFlipY();
	            }
	
	            var onRepeat = tween.callbacks.onRepeat;
	
	            if (onRepeat)
	            {
	                //  Element 1 is reserved for the target of the repeat (and needs setting here)
	                onRepeat.params[1] = tweenData.target;
	
	                onRepeat.func.apply(onRepeat.scope, onRepeat.params);
	            }
	
	            tweenData.start = tweenData.getStartValue(tweenData.target, tweenData.key, tweenData.start);
	
	            tweenData.end = tweenData.getEndValue(tweenData.target, tweenData.key, tweenData.start);
	
	            //  Delay?
	            if (tweenData.repeatDelay > 0)
	            {
	                tweenData.elapsed = tweenData.repeatDelay - diff;
	
	                tweenData.current = tweenData.start;
	
	                tweenData.target[tweenData.key] = tweenData.current;
	
	                return TWEEN_CONST.REPEAT_DELAY;
	            }
	            else
	            {
	                return TWEEN_CONST.PLAYING_FORWARD;
	            }
	        }
	
	        return TWEEN_CONST.COMPLETE;
	    },
	
	    /**
	     * Was PLAYING_BACKWARD and has hit the start.
	     *
	     * @method Phaser.Tweens.Tween#setStateFromStart
	     * @since 3.0.0
	     *
	     * @param {Phaser.Tweens.Tween} tween - [description]
	     * @param {Phaser.Tweens.TweenDataConfig} tweenData - [description]
	     * @param {number} diff - [description]
	     *
	     * @return {integer} The state of this Tween.
	     */
	    setStateFromStart: function (tween, tweenData, diff)
	    {
	        if (tweenData.repeatCounter > 0)
	        {
	            tweenData.repeatCounter--;
	
	            //  Account for any extra time we got from the previous frame
	            tweenData.elapsed = diff;
	            tweenData.progress = diff / tweenData.duration;
	
	            if (tweenData.flipX)
	            {
	                tweenData.target.toggleFlipX();
	            }
	
	            if (tweenData.flipY)
	            {
	                tweenData.target.toggleFlipY();
	            }
	
	            var onRepeat = tween.callbacks.onRepeat;
	
	            if (onRepeat)
	            {
	                //  Element 1 is reserved for the target of the repeat (and needs setting here)
	                onRepeat.params[1] = tweenData.target;
	
	                onRepeat.func.apply(onRepeat.scope, onRepeat.params);
	            }
	
	            tweenData.end = tweenData.getEndValue(tweenData.target, tweenData.key, tweenData.start);
	
	            //  Delay?
	            if (tweenData.repeatDelay > 0)
	            {
	                tweenData.elapsed = tweenData.repeatDelay - diff;
	
	                tweenData.current = tweenData.start;
	
	                tweenData.target[tweenData.key] = tweenData.current;
	
	                return TWEEN_CONST.REPEAT_DELAY;
	            }
	            else
	            {
	                return TWEEN_CONST.PLAYING_FORWARD;
	            }
	        }
	
	        return TWEEN_CONST.COMPLETE;
	    },
	
	    //
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Tween#updateTweenData
	     * @since 3.0.0
	     *
	     * @param {Phaser.Tweens.Tween} tween - [description]
	     * @param {Phaser.Tweens.TweenDataConfig} tweenData - [description]
	     * @param {number} delta - Either a value in ms, or 1 if Tween.useFrames is true
	     *
	     * @return {boolean} [description]
	     */
	    updateTweenData: function (tween, tweenData, delta)
	    {
	        switch (tweenData.state)
	        {
	            case TWEEN_CONST.PLAYING_FORWARD:
	            case TWEEN_CONST.PLAYING_BACKWARD:
	
	                if (!tweenData.target)
	                {
	                    tweenData.state = TWEEN_CONST.COMPLETE;
	                    break;
	                }
	
	                var elapsed = tweenData.elapsed;
	                var duration = tweenData.duration;
	                var diff = 0;
	
	                elapsed += delta;
	
	                if (elapsed > duration)
	                {
	                    diff = elapsed - duration;
	                    elapsed = duration;
	                }
	
	                var forward = (tweenData.state === TWEEN_CONST.PLAYING_FORWARD);
	                var progress = elapsed / duration;
	
	                var v;
	
	                if (forward)
	                {
	                    v = tweenData.ease(progress);
	                }
	                else
	                {
	                    v = tweenData.ease(1 - progress);
	                }
	
	                tweenData.current = tweenData.start + ((tweenData.end - tweenData.start) * v);
	
	                tweenData.target[tweenData.key] = tweenData.current;
	
	                tweenData.elapsed = elapsed;
	                tweenData.progress = progress;
	
	                var onUpdate = tween.callbacks.onUpdate;
	
	                if (onUpdate)
	                {
	                    onUpdate.params[1] = tweenData.target;
	
	                    onUpdate.func.apply(onUpdate.scope, onUpdate.params);
	                }
	
	                if (progress === 1)
	                {
	                    if (forward)
	                    {
	                        if (tweenData.hold > 0)
	                        {
	                            tweenData.elapsed = tweenData.hold - diff;
	
	                            tweenData.state = TWEEN_CONST.HOLD_DELAY;
	                        }
	                        else
	                        {
	                            tweenData.state = this.setStateFromEnd(tween, tweenData, diff);
	                        }
	                    }
	                    else
	                    {
	                        tweenData.state = this.setStateFromStart(tween, tweenData, diff);
	                    }
	                }
	
	                break;
	
	            case TWEEN_CONST.DELAY:
	
	                tweenData.elapsed -= delta;
	
	                if (tweenData.elapsed <= 0)
	                {
	                    tweenData.elapsed = Math.abs(tweenData.elapsed);
	
	                    tweenData.state = TWEEN_CONST.PENDING_RENDER;
	                }
	
	                break;
	
	            case TWEEN_CONST.REPEAT_DELAY:
	
	                tweenData.elapsed -= delta;
	
	                if (tweenData.elapsed <= 0)
	                {
	                    tweenData.elapsed = Math.abs(tweenData.elapsed);
	
	                    tweenData.state = TWEEN_CONST.PLAYING_FORWARD;
	                }
	
	                break;
	
	            case TWEEN_CONST.HOLD_DELAY:
	
	                tweenData.elapsed -= delta;
	
	                if (tweenData.elapsed <= 0)
	                {
	                    tweenData.state = this.setStateFromEnd(tween, tweenData, Math.abs(tweenData.elapsed));
	                }
	
	                break;
	
	            case TWEEN_CONST.PENDING_RENDER:
	
	                if (tweenData.target)
	                {
	                    tweenData.start = tweenData.getStartValue(tweenData.target, tweenData.key, tweenData.target[tweenData.key]);
	
	                    tweenData.end = tweenData.getEndValue(tweenData.target, tweenData.key, tweenData.start);
	
	                    tweenData.current = tweenData.start;
	
	                    tweenData.target[tweenData.key] = tweenData.start;
	
	                    tweenData.state = TWEEN_CONST.PLAYING_FORWARD;
	                }
	                else
	                {
	                    tweenData.state = TWEEN_CONST.COMPLETE;
	                }
	
	                break;
	        }
	
	        //  Return TRUE if this TweenData still playing, otherwise return FALSE
	        return (tweenData.state !== TWEEN_CONST.COMPLETE);
	    }
	
	});
	
	Tween.TYPES = [
	    'onComplete',
	    'onLoop',
	    'onRepeat',
	    'onStart',
	    'onUpdate',
	    'onYoyo'
	];
	
	/**
	 * Creates a new Tween object.
	 *
	 * Note: This method will only be available Tweens have been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectFactory#tween
	 * @since 3.0.0
	 *
	 * @param {object} config - The Tween configuration.
	 *
	 * @return {Phaser.Tweens.Tween} The Tween that was created.
	 */
	GameObjectFactory.register('tween', function (config)
	{
	    return this.scene.sys.tweens.add(config);
	});
	
	//  When registering a factory function 'this' refers to the GameObjectFactory context.
	//
	//  There are several properties available to use:
	//
	//  this.scene - a reference to the Scene that owns the GameObjectFactory
	//  this.displayList - a reference to the Display List the Scene owns
	//  this.updateList - a reference to the Update List the Scene owns
	
	/**
	 * Creates a new Tween object and returns it.
	 *
	 * Note: This method will only be available if Tweens have been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectCreator#tween
	 * @since 3.0.0
	 *
	 * @param {object} config - The Tween configuration.
	 *
	 * @return {Phaser.Tweens.Tween} The Tween that was created.
	 */
	GameObjectCreator.register('tween', function (config)
	{
	    return this.scene.sys.tweens.create(config);
	});
	
	//  When registering a factory function 'this' refers to the GameObjectCreator context.
	
	module.exports = Tween;


/***/ }),
/* 338 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @typedef {object} TweenDataGenConfig
	 *
	 * @property {function} delay - [description]
	 * @property {function} duration - [description]
	 * @property {function} hold - [description]
	 * @property {function} repeat - [description]
	 * @property {function} repeatDelay - [description]
	 */
	
	/**
	 * @typedef {object} Phaser.Tweens.TweenDataConfig
	 *
	 * @property {object} target - The target to tween.
	 * @property {string} key - The property of the target being tweened.
	 * @property {function} getEndValue - The returned value sets what the property will be at the END of the Tween.
	 * @property {function} getStartValue - The returned value sets what the property will be at the START of the Tween.
	 * @property {function} ease - The ease function this tween uses.
	 * @property {number} [duration=0] - Duration of the tween in ms/frames, excludes time for yoyo or repeats.
	 * @property {number} [totalDuration=0] - The total calculated duration of this TweenData (based on duration, repeat, delay and yoyo)
	 * @property {number} [delay=0] - Time in ms/frames before tween will start.
	 * @property {boolean} [yoyo=false] - Cause the tween to return back to its start value after hold has expired.
	 * @property {number} [hold=0] - Time in ms/frames the tween will pause before running the yoyo or starting a repeat.
	 * @property {integer} [repeat=0] - Number of times to repeat the tween. The tween will always run once regardless, so a repeat value of '1' will play the tween twice.
	 * @property {number} [repeatDelay=0] - Time in ms/frames before the repeat will start.
	 * @property {boolean} [flipX=false] - Automatically call toggleFlipX when the TweenData yoyos or repeats
	 * @property {boolean} [flipY=false] - Automatically call toggleFlipY when the TweenData yoyos or repeats
	 * @property {float} [progress=0] - Between 0 and 1 showing completion of this TweenData.
	 * @property {float} [elapsed=0] - Delta counter
	 * @property {integer} [repeatCounter=0] - How many repeats are left to run?
	 * @property {number} [start=0] - Ease value data.
	 * @property {number} [current=0] - Ease value data.
	 * @property {number} [end=0] - Ease value data.
	 * @property {number} [t1=0] - Time duration 1.
	 * @property {number} [t2=0] - Time duration 2.
	 * @property {TweenDataGenConfig} [gen] - LoadValue generation functions.
	 * @property {integer} [state=0] - TWEEN_CONST.CREATED
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Tweens.TweenData
	 * @since 3.0.0
	 *
	 * @param {object} target - [description]
	 * @param {string} key - [description]
	 * @param {function} getEnd - [description]
	 * @param {function} getStart - [description]
	 * @param {function} ease - [description]
	 * @param {number} delay - [description]
	 * @param {number} duration - [description]
	 * @param {boolean} yoyo - [description]
	 * @param {number} hold - [description]
	 * @param {number} repeat - [description]
	 * @param {number} repeatDelay - [description]
	 * @param {boolean} flipX - [description]
	 * @param {boolean} flipY - [description]
	 *
	 * @return {TweenDataConfig} [description]
	 */
	var TweenData = function (target, key, getEnd, getStart, ease, delay, duration, yoyo, hold, repeat, repeatDelay, flipX, flipY)
	{
	    return {
	
	        //  The target to tween
	        target: target,
	
	        //  The property of the target to tween
	        key: key,
	
	        //  The returned value sets what the property will be at the END of the Tween.
	        getEndValue: getEnd,
	
	        //  The returned value sets what the property will be at the START of the Tween.
	        getStartValue: getStart,
	
	        //  The ease function this tween uses.
	        ease: ease,
	
	        //  Duration of the tween in ms/frames, excludes time for yoyo or repeats.
	        duration: 0,
	
	        //  The total calculated duration of this TweenData (based on duration, repeat, delay and yoyo)
	        totalDuration: 0,
	
	        //  Time in ms/frames before tween will start.
	        delay: 0,
	
	        //  Cause the tween to return back to its start value after hold has expired.
	        yoyo: yoyo,
	
	        //  Time in ms/frames the tween will pause before running the yoyo or starting a repeat.
	        hold: 0,
	
	        //  Number of times to repeat the tween. The tween will always run once regardless, so a repeat value of '1' will play the tween twice.
	        repeat: 0,
	
	        //  Time in ms/frames before the repeat will start.
	        repeatDelay: 0,
	
	        //  Automatically call toggleFlipX when the TweenData yoyos or repeats
	        flipX: flipX,
	
	        //  Automatically call toggleFlipY when the TweenData yoyos or repeats
	        flipY: flipY,
	
	        //  Between 0 and 1 showing completion of this TweenData.
	        progress: 0,
	
	        //  Delta counter.
	        elapsed: 0,
	
	        //  How many repeats are left to run?
	        repeatCounter: 0,
	
	        //  Ease Value Data:
	
	        start: 0,
	        current: 0,
	        end: 0,
	
	        //  Time Durations
	        t1: 0,
	        t2: 0,
	
	        //  LoadValue generation functions
	        gen: {
	            delay: delay,
	            duration: duration,
	            hold: hold,
	            repeat: repeat,
	            repeatDelay: repeatDelay
	        },
	
	        //  TWEEN_CONST.CREATED
	        state: 0
	    };
	};
	
	module.exports = TweenData;


/***/ }),
/* 339 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Returns a Random element from the array.
	 *
	 * @function Phaser.Utils.Array.GetRandom
	 * @since 3.0.0
	 *
	 * @param {array} array - The array to select the random entry from.
	 * @param {integer} [startIndex=0] - An optional start index.
	 * @param {integer} [length=array.length] - An optional length, the total number of elements (from the startIndex) to choose from.
	 *
	 * @return {object} A random element from the array, or `null` if no element could be found in the range given.
	 */
	var GetRandom = function (array, startIndex, length)
	{
	    if (startIndex === undefined) { startIndex = 0; }
	    if (length === undefined) { length = array.length; }
	
	    var randomIndex = startIndex + Math.floor(Math.random() * length);
	
	    return (array[randomIndex] === undefined) ? null : array[randomIndex];
	};
	
	module.exports = GetRandom;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Utils.Array
	 */
	
	module.exports = {
	
	    Matrix: __webpack_require__(1612),
	
	    Add: __webpack_require__(1586),
	    AddAt: __webpack_require__(1587),
	    BringToTop: __webpack_require__(1588),
	    CountAllMatching: __webpack_require__(1589),
	    Each: __webpack_require__(1590),
	    EachInRange: __webpack_require__(1591),
	    FindClosestInSorted: __webpack_require__(657),
	    GetAll: __webpack_require__(1592),
	    GetFirst: __webpack_require__(1593),
	    GetRandom: __webpack_require__(339),
	    MoveDown: __webpack_require__(1594),
	    MoveTo: __webpack_require__(1595),
	    MoveUp: __webpack_require__(1596),
	    NumberArray: __webpack_require__(1597),
	    NumberArrayStep: __webpack_require__(1598),
	    QuickSelect: __webpack_require__(658),
	    Range: __webpack_require__(659),
	    Remove: __webpack_require__(660),
	    RemoveAt: __webpack_require__(1599),
	    RemoveBetween: __webpack_require__(1600),
	    RemoveRandomElement: __webpack_require__(1601),
	    Replace: __webpack_require__(1602),
	    RotateLeft: __webpack_require__(661),
	    RotateRight: __webpack_require__(662),
	    SafeRange: __webpack_require__(122),
	    SendToBack: __webpack_require__(1603),
	    SetAll: __webpack_require__(1604),
	    Shuffle: __webpack_require__(218),
	    SpliceOne: __webpack_require__(175),
	    StableSort: __webpack_require__(219),
	    Swap: __webpack_require__(1605)
	
	};


/***/ }),
/* 341 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	* A Matrix is simply an array of arrays, where each sub-array (the rows) have the same length:
	*
	* let matrix2 = [
	*    [ 1, 1, 1, 1, 1, 1 ],
	*    [ 2, 0, 0, 0, 0, 4 ],
	*    [ 2, 0, 1, 2, 0, 4 ],
	*    [ 2, 0, 3, 4, 0, 4 ],
	*    [ 2, 0, 0, 0, 0, 4 ],
	*    [ 3, 3, 3, 3, 3, 3 ]
	*];
	*/
	
	/**
	 * [description]
	 *
	 * @function Phaser.Utils.Array.Matrix.CheckMatrix
	 * @since 3.0.0
	 *
	 * @param {array} matrix - [description]
	 *
	 * @return {boolean} [description]
	 */
	var CheckMatrix = function (matrix)
	{
	    if (!Array.isArray(matrix) || matrix.length < 2 || !Array.isArray(matrix[0]))
	    {
	        return false;
	    }
	
	    //  How long is the first row?
	    var size = matrix[0].length;
	
	    //  Validate the rest of the rows are the same length
	    for (var i = 1; i < matrix.length; i++)
	    {
	        if (matrix[i].length !== size)
	        {
	            return false;
	        }
	    }
	
	    return true;
	};
	
	module.exports = CheckMatrix;


/***/ }),
/* 342 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Takes the given string and pads it out, to the length required, using the character
	 * specified. For example if you need a string to be 6 characters long, you can call:
	 *
	 * `pad('bob', 6, '-', 2)`
	 *
	 * This would return: `bob---` as it has padded it out to 6 characters, using the `-` on the right.
	 *
	 * You can also use it to pad numbers (they are always returned as strings):
	 * 
	 * `pad(512, 6, '0', 1)`
	 *
	 * Would return: `000512` with the string padded to the left.
	 *
	 * If you don't specify a direction it'll pad to both sides:
	 * 
	 * `pad('c64', 7, '*')`
	 *
	 * Would return: `**c64**`
	 *
	 * @function Phaser.Utils.String.Pad
	 * @since 3.0.0
	 *
	 * @param {string} str - The target string. `toString()` will be called on the string, which means you can also pass in common data types like numbers.
	 * @param {integer} [len=0] - The number of characters to be added.
	 * @param {string} [pad=" "] - The string to pad it out with (defaults to a space).
	 * @param {integer} [dir=3] - The direction dir = 1 (left), 2 (right), 3 (both).
	 * 
	 * @return {string} The padded string.
	 */
	var Pad = function (str, len, pad, dir)
	{
	    if (len === undefined) { len = 0; }
	    if (pad === undefined) { pad = ' '; }
	    if (dir === undefined) { dir = 3; }
	
	    str = str.toString();
	
	    var padlen = 0;
	
	    if (len + 1 >= str.length)
	    {
	        switch (dir)
	        {
	            case 1:
	                str = new Array(len + 1 - str.length).join(pad) + str;
	                break;
	
	            case 3:
	                var right = Math.ceil((padlen = len - str.length) / 2);
	                var left = padlen - right;
	                str = new Array(left + 1).join(pad) + str + new Array(right + 1).join(pad);
	                break;
	
	            default:
	                str = str + new Array(len + 1 - str.length).join(pad);
	                break;
	        }
	    }
	
	    return str;
	};
	
	module.exports = Pad;


/***/ }),
/* 343 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	module.exports = function(src) {
		function log(error) {
			(typeof console !== "undefined")
			&& (console.error || console.log)("[Script Loader]", error);
		}
	
		// Check for IE =< 8
		function isIE() {
			return typeof attachEvent !== "undefined" && typeof addEventListener === "undefined";
		}
	
		try {
			if (typeof execScript !== "undefined" && isIE()) {
				execScript(src);
			} else if (typeof eval !== "undefined") {
				eval.call(null, src);
			} else {
				log("EvalError: No eval function available");
			}
		} catch (error) {
			log(error);
		}
	}


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_astrid.e2dd972.png";

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_bea.a128342.png";

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_caroline.306f19f.png";

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_corinne.4846fb8.png";

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_cornelus.ce271b9.png";

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_didier.9c794d0.png";

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_diego.72fbe86.png";

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_gerry.e86bf52.png";

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_henry.478b144.png";

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_herbert.e117846.png";

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_karla.45f0908.png";

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_kitou.32fe4d6.png";

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_leon.19006e3.png";

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_martin.106067f.png";

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_maurice.df0dc1e.png";

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_max.9f9590d.png";

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_milla.e8c2102.png";

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_olga.97482c6.png";

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_pol.b01297f.png";

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_renee.61a82e9.png";

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_ric.fedda98.png";

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_sam.da15802.png";

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_viktor.d1ad01f.png";

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/figurine_waldo.df89da1.png";

/***/ }),
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global Popper */
	
	var _util = __webpack_require__(149);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _popper = __webpack_require__(666);
	
	var _popper2 = _interopRequireDefault(_popper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * --------------------------------------------------------------------------
	 * Bootstrap (v4.0.0-alpha.6): tooltip.js
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * --------------------------------------------------------------------------
	 */
	
	var Tooltip = function ($) {
	
	  /**
	   * Check for Popper dependency
	   * Popper - https://popper.js.org
	   */
	  if (typeof _popper2.default === 'undefined') {
	    throw new Error('Bootstrap tooltips require Popper.js (https://popper.js.org)');
	  }
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME = 'tooltip';
	  var VERSION = '4.0.0-alpha.6';
	  var DATA_KEY = 'bs.tooltip';
	  var EVENT_KEY = '.' + DATA_KEY;
	  var JQUERY_NO_CONFLICT = $.fn[NAME];
	  var TRANSITION_DURATION = 150;
	  var CLASS_PREFIX = 'bs-tooltip';
	  var BSCLS_PREFIX_REGEX = new RegExp('(^|\\s)' + CLASS_PREFIX + '\\S+', 'g');
	
	  var DefaultType = {
	    animation: 'boolean',
	    template: 'string',
	    title: '(string|element|function)',
	    trigger: 'string',
	    delay: '(number|object)',
	    html: 'boolean',
	    selector: '(string|boolean)',
	    placement: '(string|function)',
	    offset: '(number|string)',
	    container: '(string|element|boolean)',
	    fallbackPlacement: '(string|array)'
	  };
	
	  var AttachmentMap = {
	    AUTO: 'auto',
	    TOP: 'top',
	    RIGHT: 'right',
	    BOTTOM: 'bottom',
	    LEFT: 'left'
	  };
	
	  var Default = {
	    animation: true,
	    template: '<div class="tooltip" role="tooltip">' + '<div class="arrow"></div>' + '<div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    selector: false,
	    placement: 'top',
	    offset: 0,
	    container: false,
	    fallbackPlacement: 'flip'
	  };
	
	  var HoverState = {
	    SHOW: 'show',
	    OUT: 'out'
	  };
	
	  var Event = {
	    HIDE: 'hide' + EVENT_KEY,
	    HIDDEN: 'hidden' + EVENT_KEY,
	    SHOW: 'show' + EVENT_KEY,
	    SHOWN: 'shown' + EVENT_KEY,
	    INSERTED: 'inserted' + EVENT_KEY,
	    CLICK: 'click' + EVENT_KEY,
	    FOCUSIN: 'focusin' + EVENT_KEY,
	    FOCUSOUT: 'focusout' + EVENT_KEY,
	    MOUSEENTER: 'mouseenter' + EVENT_KEY,
	    MOUSELEAVE: 'mouseleave' + EVENT_KEY
	  };
	
	  var ClassName = {
	    FADE: 'fade',
	    SHOW: 'show'
	  };
	
	  var Selector = {
	    TOOLTIP: '.tooltip',
	    TOOLTIP_INNER: '.tooltip-inner',
	    ARROW: '.arrow'
	  };
	
	  var Trigger = {
	    HOVER: 'hover',
	    FOCUS: 'focus',
	    CLICK: 'click',
	    MANUAL: 'manual'
	
	    /**
	     * ------------------------------------------------------------------------
	     * Class Definition
	     * ------------------------------------------------------------------------
	     */
	
	  };
	  var Tooltip = function () {
	    function Tooltip(element, config) {
	      _classCallCheck(this, Tooltip);
	
	      // private
	      this._isEnabled = true;
	      this._timeout = 0;
	      this._hoverState = '';
	      this._activeTrigger = {};
	      this._popper = null;
	
	      // protected
	      this.element = element;
	      this.config = this._getConfig(config);
	      this.tip = null;
	
	      this._setListeners();
	    }
	
	    // getters
	
	    _createClass(Tooltip, [{
	      key: 'enable',
	
	
	      // public
	
	      value: function enable() {
	        this._isEnabled = true;
	      }
	    }, {
	      key: 'disable',
	      value: function disable() {
	        this._isEnabled = false;
	      }
	    }, {
	      key: 'toggleEnabled',
	      value: function toggleEnabled() {
	        this._isEnabled = !this._isEnabled;
	      }
	    }, {
	      key: 'toggle',
	      value: function toggle(event) {
	        if (event) {
	          var dataKey = this.constructor.DATA_KEY;
	          var context = $(event.currentTarget).data(dataKey);
	
	          if (!context) {
	            context = new this.constructor(event.currentTarget, this._getDelegateConfig());
	            $(event.currentTarget).data(dataKey, context);
	          }
	
	          context._activeTrigger.click = !context._activeTrigger.click;
	
	          if (context._isWithActiveTrigger()) {
	            context._enter(null, context);
	          } else {
	            context._leave(null, context);
	          }
	        } else {
	
	          if ($(this.getTipElement()).hasClass(ClassName.SHOW)) {
	            this._leave(null, this);
	            return;
	          }
	
	          this._enter(null, this);
	        }
	      }
	    }, {
	      key: 'dispose',
	      value: function dispose() {
	        clearTimeout(this._timeout);
	
	        $.removeData(this.element, this.constructor.DATA_KEY);
	
	        $(this.element).off(this.constructor.EVENT_KEY);
	        $(this.element).closest('.modal').off('hide.bs.modal');
	
	        if (this.tip) {
	          $(this.tip).remove();
	        }
	
	        this._isEnabled = null;
	        this._timeout = null;
	        this._hoverState = null;
	        this._activeTrigger = null;
	        if (this._popper !== null) {
	          this._popper.destroy();
	        }
	        this._popper = null;
	
	        this.element = null;
	        this.config = null;
	        this.tip = null;
	      }
	    }, {
	      key: 'show',
	      value: function show() {
	        var _this = this;
	
	        if ($(this.element).css('display') === 'none') {
	          throw new Error('Please use show on visible elements');
	        }
	
	        var showEvent = $.Event(this.constructor.Event.SHOW);
	        if (this.isWithContent() && this._isEnabled) {
	          $(this.element).trigger(showEvent);
	
	          var isInTheDom = $.contains(this.element.ownerDocument.documentElement, this.element);
	
	          if (showEvent.isDefaultPrevented() || !isInTheDom) {
	            return;
	          }
	
	          var tip = this.getTipElement();
	          var tipId = _util2.default.getUID(this.constructor.NAME);
	
	          tip.setAttribute('id', tipId);
	          this.element.setAttribute('aria-describedby', tipId);
	
	          this.setContent();
	
	          if (this.config.animation) {
	            $(tip).addClass(ClassName.FADE);
	          }
	
	          var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tip, this.element) : this.config.placement;
	
	          var attachment = this._getAttachment(placement);
	          this.addAttachmentClass(attachment);
	
	          var container = this.config.container === false ? document.body : $(this.config.container);
	
	          $(tip).data(this.constructor.DATA_KEY, this);
	
	          if (!$.contains(this.element.ownerDocument.documentElement, this.tip)) {
	            $(tip).appendTo(container);
	          }
	
	          $(this.element).trigger(this.constructor.Event.INSERTED);
	
	          this._popper = new _popper2.default(this.element, tip, {
	            placement: attachment,
	            modifiers: {
	              offset: {
	                offset: this.config.offset
	              },
	              flip: {
	                behavior: this.config.fallbackPlacement
	              },
	              arrow: {
	                element: Selector.ARROW
	              }
	            },
	            onCreate: function onCreate(data) {
	              if (data.originalPlacement !== data.placement) {
	                _this._handlePopperPlacementChange(data);
	              }
	            },
	            onUpdate: function onUpdate(data) {
	              _this._handlePopperPlacementChange(data);
	            }
	          });
	
	          $(tip).addClass(ClassName.SHOW);
	
	          // if this is a touch-enabled device we add extra
	          // empty mouseover listeners to the body's immediate children;
	          // only needed because of broken event delegation on iOS
	          // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
	          if ('ontouchstart' in document.documentElement) {
	            $('body').children().on('mouseover', null, $.noop);
	          }
	
	          var complete = function complete() {
	            if (_this.config.animation) {
	              _this._fixTransition();
	            }
	            var prevHoverState = _this._hoverState;
	            _this._hoverState = null;
	
	            $(_this.element).trigger(_this.constructor.Event.SHOWN);
	
	            if (prevHoverState === HoverState.OUT) {
	              _this._leave(null, _this);
	            }
	          };
	
	          if (_util2.default.supportsTransitionEnd() && $(this.tip).hasClass(ClassName.FADE)) {
	            $(this.tip).one(_util2.default.TRANSITION_END, complete).emulateTransitionEnd(Tooltip._TRANSITION_DURATION);
	          } else {
	            complete();
	          }
	        }
	      }
	    }, {
	      key: 'hide',
	      value: function hide(callback) {
	        var _this2 = this;
	
	        var tip = this.getTipElement();
	        var hideEvent = $.Event(this.constructor.Event.HIDE);
	        var complete = function complete() {
	          if (_this2._hoverState !== HoverState.SHOW && tip.parentNode) {
	            tip.parentNode.removeChild(tip);
	          }
	
	          _this2._cleanTipClass();
	          _this2.element.removeAttribute('aria-describedby');
	          $(_this2.element).trigger(_this2.constructor.Event.HIDDEN);
	          if (_this2._popper !== null) {
	            _this2._popper.destroy();
	          }
	
	          if (callback) {
	            callback();
	          }
	        };
	
	        $(this.element).trigger(hideEvent);
	
	        if (hideEvent.isDefaultPrevented()) {
	          return;
	        }
	
	        $(tip).removeClass(ClassName.SHOW);
	
	        // if this is a touch-enabled device we remove the extra
	        // empty mouseover listeners we added for iOS support
	        if ('ontouchstart' in document.documentElement) {
	          $('body').children().off('mouseover', null, $.noop);
	        }
	
	        this._activeTrigger[Trigger.CLICK] = false;
	        this._activeTrigger[Trigger.FOCUS] = false;
	        this._activeTrigger[Trigger.HOVER] = false;
	
	        if (_util2.default.supportsTransitionEnd() && $(this.tip).hasClass(ClassName.FADE)) {
	
	          $(tip).one(_util2.default.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
	        } else {
	          complete();
	        }
	
	        this._hoverState = '';
	      }
	    }, {
	      key: 'update',
	      value: function update() {
	        if (this._popper !== null) {
	          this._popper.scheduleUpdate();
	        }
	      }
	
	      // protected
	
	    }, {
	      key: 'isWithContent',
	      value: function isWithContent() {
	        return Boolean(this.getTitle());
	      }
	    }, {
	      key: 'addAttachmentClass',
	      value: function addAttachmentClass(attachment) {
	        $(this.getTipElement()).addClass(CLASS_PREFIX + '-' + attachment);
	      }
	    }, {
	      key: 'getTipElement',
	      value: function getTipElement() {
	        return this.tip = this.tip || $(this.config.template)[0];
	      }
	    }, {
	      key: 'setContent',
	      value: function setContent() {
	        var $tip = $(this.getTipElement());
	        this.setElementContent($tip.find(Selector.TOOLTIP_INNER), this.getTitle());
	        $tip.removeClass(ClassName.FADE + ' ' + ClassName.SHOW);
	      }
	    }, {
	      key: 'setElementContent',
	      value: function setElementContent($element, content) {
	        var html = this.config.html;
	        if ((typeof content === 'undefined' ? 'undefined' : _typeof(content)) === 'object' && (content.nodeType || content.jquery)) {
	          // content is a DOM node or a jQuery
	          if (html) {
	            if (!$(content).parent().is($element)) {
	              $element.empty().append(content);
	            }
	          } else {
	            $element.text($(content).text());
	          }
	        } else {
	          $element[html ? 'html' : 'text'](content);
	        }
	      }
	    }, {
	      key: 'getTitle',
	      value: function getTitle() {
	        var title = this.element.getAttribute('data-original-title');
	
	        if (!title) {
	          title = typeof this.config.title === 'function' ? this.config.title.call(this.element) : this.config.title;
	        }
	
	        return title;
	      }
	
	      // private
	
	    }, {
	      key: '_getAttachment',
	      value: function _getAttachment(placement) {
	        return AttachmentMap[placement.toUpperCase()];
	      }
	    }, {
	      key: '_setListeners',
	      value: function _setListeners() {
	        var _this3 = this;
	
	        var triggers = this.config.trigger.split(' ');
	
	        triggers.forEach(function (trigger) {
	          if (trigger === 'click') {
	            $(_this3.element).on(_this3.constructor.Event.CLICK, _this3.config.selector, function (event) {
	              return _this3.toggle(event);
	            });
	          } else if (trigger !== Trigger.MANUAL) {
	            var eventIn = trigger === Trigger.HOVER ? _this3.constructor.Event.MOUSEENTER : _this3.constructor.Event.FOCUSIN;
	            var eventOut = trigger === Trigger.HOVER ? _this3.constructor.Event.MOUSELEAVE : _this3.constructor.Event.FOCUSOUT;
	
	            $(_this3.element).on(eventIn, _this3.config.selector, function (event) {
	              return _this3._enter(event);
	            }).on(eventOut, _this3.config.selector, function (event) {
	              return _this3._leave(event);
	            });
	          }
	
	          $(_this3.element).closest('.modal').on('hide.bs.modal', function () {
	            return _this3.hide();
	          });
	        });
	
	        if (this.config.selector) {
	          this.config = $.extend({}, this.config, {
	            trigger: 'manual',
	            selector: ''
	          });
	        } else {
	          this._fixTitle();
	        }
	      }
	    }, {
	      key: '_fixTitle',
	      value: function _fixTitle() {
	        var titleType = _typeof(this.element.getAttribute('data-original-title'));
	        if (this.element.getAttribute('title') || titleType !== 'string') {
	          this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
	          this.element.setAttribute('title', '');
	        }
	      }
	    }, {
	      key: '_enter',
	      value: function _enter(event, context) {
	        var dataKey = this.constructor.DATA_KEY;
	
	        context = context || $(event.currentTarget).data(dataKey);
	
	        if (!context) {
	          context = new this.constructor(event.currentTarget, this._getDelegateConfig());
	          $(event.currentTarget).data(dataKey, context);
	        }
	
	        if (event) {
	          context._activeTrigger[event.type === 'focusin' ? Trigger.FOCUS : Trigger.HOVER] = true;
	        }
	
	        if ($(context.getTipElement()).hasClass(ClassName.SHOW) || context._hoverState === HoverState.SHOW) {
	          context._hoverState = HoverState.SHOW;
	          return;
	        }
	
	        clearTimeout(context._timeout);
	
	        context._hoverState = HoverState.SHOW;
	
	        if (!context.config.delay || !context.config.delay.show) {
	          context.show();
	          return;
	        }
	
	        context._timeout = setTimeout(function () {
	          if (context._hoverState === HoverState.SHOW) {
	            context.show();
	          }
	        }, context.config.delay.show);
	      }
	    }, {
	      key: '_leave',
	      value: function _leave(event, context) {
	        var dataKey = this.constructor.DATA_KEY;
	
	        context = context || $(event.currentTarget).data(dataKey);
	
	        if (!context) {
	          context = new this.constructor(event.currentTarget, this._getDelegateConfig());
	          $(event.currentTarget).data(dataKey, context);
	        }
	
	        if (event) {
	          context._activeTrigger[event.type === 'focusout' ? Trigger.FOCUS : Trigger.HOVER] = false;
	        }
	
	        if (context._isWithActiveTrigger()) {
	          return;
	        }
	
	        clearTimeout(context._timeout);
	
	        context._hoverState = HoverState.OUT;
	
	        if (!context.config.delay || !context.config.delay.hide) {
	          context.hide();
	          return;
	        }
	
	        context._timeout = setTimeout(function () {
	          if (context._hoverState === HoverState.OUT) {
	            context.hide();
	          }
	        }, context.config.delay.hide);
	      }
	    }, {
	      key: '_isWithActiveTrigger',
	      value: function _isWithActiveTrigger() {
	        for (var trigger in this._activeTrigger) {
	          if (this._activeTrigger[trigger]) {
	            return true;
	          }
	        }
	
	        return false;
	      }
	    }, {
	      key: '_getConfig',
	      value: function _getConfig(config) {
	        config = $.extend({}, this.constructor.Default, $(this.element).data(), config);
	
	        if (config.delay && typeof config.delay === 'number') {
	          config.delay = {
	            show: config.delay,
	            hide: config.delay
	          };
	        }
	
	        if (config.title && typeof config.title === 'number') {
	          config.title = config.title.toString();
	        }
	
	        if (config.content && typeof config.content === 'number') {
	          config.content = config.content.toString();
	        }
	
	        _util2.default.typeCheckConfig(NAME, config, this.constructor.DefaultType);
	
	        return config;
	      }
	    }, {
	      key: '_getDelegateConfig',
	      value: function _getDelegateConfig() {
	        var config = {};
	
	        if (this.config) {
	          for (var key in this.config) {
	            if (this.constructor.Default[key] !== this.config[key]) {
	              config[key] = this.config[key];
	            }
	          }
	        }
	
	        return config;
	      }
	    }, {
	      key: '_cleanTipClass',
	      value: function _cleanTipClass() {
	        var $tip = $(this.getTipElement());
	        var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);
	        if (tabClass !== null && tabClass.length > 0) {
	          $tip.removeClass(tabClass.join(''));
	        }
	      }
	    }, {
	      key: '_handlePopperPlacementChange',
	      value: function _handlePopperPlacementChange(data) {
	        this._cleanTipClass();
	        this.addAttachmentClass(this._getAttachment(data.placement));
	      }
	    }, {
	      key: '_fixTransition',
	      value: function _fixTransition() {
	        var tip = this.getTipElement();
	        var initConfigAnimation = this.config.animation;
	        if (tip.getAttribute('x-placement') !== null) {
	          return;
	        }
	        $(tip).removeClass(ClassName.FADE);
	        this.config.animation = false;
	        this.hide();
	        this.show();
	        this.config.animation = initConfigAnimation;
	      }
	
	      // static
	
	    }], [{
	      key: '_jQueryInterface',
	      value: function _jQueryInterface(config) {
	        return this.each(function () {
	          var data = $(this).data(DATA_KEY);
	          var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config;
	
	          if (!data && /dispose|hide/.test(config)) {
	            return;
	          }
	
	          if (!data) {
	            data = new Tooltip(this, _config);
	            $(this).data(DATA_KEY, data);
	          }
	
	          if (typeof config === 'string') {
	            if (data[config] === undefined) {
	              throw new Error('No method named "' + config + '"');
	            }
	            data[config]();
	          }
	        });
	      }
	    }, {
	      key: 'VERSION',
	      get: function get() {
	        return VERSION;
	      }
	    }, {
	      key: 'Default',
	      get: function get() {
	        return Default;
	      }
	    }, {
	      key: 'NAME',
	      get: function get() {
	        return NAME;
	      }
	    }, {
	      key: 'DATA_KEY',
	      get: function get() {
	        return DATA_KEY;
	      }
	    }, {
	      key: 'Event',
	      get: function get() {
	        return Event;
	      }
	    }, {
	      key: 'EVENT_KEY',
	      get: function get() {
	        return EVENT_KEY;
	      }
	    }, {
	      key: 'DefaultType',
	      get: function get() {
	        return DefaultType;
	      }
	    }]);
	
	    return Tooltip;
	  }();
	
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	   */
	
	  $.fn[NAME] = Tooltip._jQueryInterface;
	  $.fn[NAME].Constructor = Tooltip;
	  $.fn[NAME].noConflict = function () {
	    $.fn[NAME] = JQUERY_NO_CONFLICT;
	    return Tooltip._jQueryInterface;
	  };
	
	  return Tooltip;
	}(jQuery);
	
	exports.default = Tooltip;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(58);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(30);
	var toAbsoluteIndex = __webpack_require__(109);
	var toLength = __webpack_require__(21);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(102);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(40);
	var toObject = __webpack_require__(30);
	var IObject = __webpack_require__(151);
	var toLength = __webpack_require__(21);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(40);
	var isObject = __webpack_require__(13);
	var invoke = __webpack_require__(387);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(20).f;
	var create = __webpack_require__(103);
	var redefineAll = __webpack_require__(107);
	var ctx = __webpack_require__(60);
	var anInstance = __webpack_require__(101);
	var forOf = __webpack_require__(102);
	var $iterDefine = __webpack_require__(233);
	var step = __webpack_require__(390);
	var setSpecies = __webpack_require__(108);
	var DESCRIPTORS = __webpack_require__(19);
	var fastKey = __webpack_require__(93).fastKey;
	var validate = __webpack_require__(127);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(150);
	var from = __webpack_require__(379);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(107);
	var getWeak = __webpack_require__(93).getWeak;
	var anObject = __webpack_require__(7);
	var isObject = __webpack_require__(13);
	var anInstance = __webpack_require__(101);
	var forOf = __webpack_require__(102);
	var createArrayMethod = __webpack_require__(64);
	var $has = __webpack_require__(52);
	var validate = __webpack_require__(127);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(180);
	var isObject = __webpack_require__(13);
	var toLength = __webpack_require__(21);
	var ctx = __webpack_require__(60);
	var IS_CONCAT_SPREADABLE = __webpack_require__(16)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(19) && !__webpack_require__(11)(function () {
	  return Object.defineProperty(__webpack_require__(226)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 387 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(13);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(7);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 390 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(235);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 392 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 393 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(105);
	var gOPS = __webpack_require__(184);
	var pIE = __webpack_require__(152);
	var toObject = __webpack_require__(30);
	var IObject = __webpack_require__(151);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(11)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(20);
	var anObject = __webpack_require__(7);
	var getKeys = __webpack_require__(105);
	
	module.exports = __webpack_require__(19) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(55);
	var gOPN = __webpack_require__(104).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(52);
	var toIObject = __webpack_require__(55);
	var arrayIndexOf = __webpack_require__(176)(false);
	var IE_PROTO = __webpack_require__(239)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(105);
	var toIObject = __webpack_require__(55);
	var isEnum = __webpack_require__(152).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(104);
	var gOPS = __webpack_require__(184);
	var anObject = __webpack_require__(7);
	var Reflect = __webpack_require__(8).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(8).parseFloat;
	var $trim = __webpack_require__(126).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(243) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(8).parseInt;
	var $trim = __webpack_require__(126).trim;
	var ws = __webpack_require__(243);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 402 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(7);
	var isObject = __webpack_require__(13);
	var newPromiseCapability = __webpack_require__(237);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(21);
	var repeat = __webpack_require__(242);
	var defined = __webpack_require__(65);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(67);
	var toLength = __webpack_require__(21);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(16);


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(382);
	var validate = __webpack_require__(127);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(177)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(19) && /./g.flags != 'g') __webpack_require__(20).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(179)
	});


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(382);
	var validate = __webpack_require__(127);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(177)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var each = __webpack_require__(64)(0);
	var redefine = __webpack_require__(46);
	var meta = __webpack_require__(93);
	var assign = __webpack_require__(394);
	var weak = __webpack_require__(384);
	var isObject = __webpack_require__(13);
	var fails = __webpack_require__(11);
	var validate = __webpack_require__(127);
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var tmp = {};
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(177)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7929d08b27cc41b833aa9e16ce9f10a0.pdf";

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c7db4567635b47f4826bce71d023654a.pdf";

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return Date.now();
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return ( /\?/ );
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(111),
		__webpack_require__(249),
		__webpack_require__(41)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, access, support ) {
	
	"use strict";
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(32)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( document ) {
		"use strict";
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			noModule: true
		};
	
		function DOMEval( code, doc, node ) {
			doc = doc || document;
	
			var i,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
					if ( node[ i ] ) {
						script[ i ] = node[ i ];
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
		return DOMEval;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(32),
		__webpack_require__(956),
		__webpack_require__(130)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document ) {
	
	"use strict";
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		// Match a standalone tag
		return ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	"use strict";
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	return addGetHookIf;
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(263)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, rcssNum ) {
	
	"use strict";
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	return adjustCSS;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(960),
		__webpack_require__(254),
		__webpack_require__(422),
		__webpack_require__(252),
		__webpack_require__(41) // Get jQuery.contains
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, rboxStyle, rnumnonpx, getStyles, support ) {
	
	"use strict";
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	return curCSS;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(41)
	
		// css is assumed
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
		"use strict";
	
		// isHiddenWithinTree reports if an element has a non-"none" display style (inline and/or
		// through the CSS cascade), which is useful in deciding whether or not to make it visible.
		// It differs from the :hidden selector (jQuery.expr.pseudos.hidden) in two important ways:
		// * A hidden ancestor does not force an element to be classified as hidden.
		// * Being disconnected from the document does not force an element to be classified as hidden.
		// These differences improve the behavior of .toggle() et al. when applied to elements that are
		// detached or contained within hidden ancestors (gh-2404, gh-2863).
		return function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				jQuery.contains( elem.ownerDocument, elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	"use strict";
	
	// A method for quickly swapping in/out CSS properties to get correct calculations.
	return function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(153),
		__webpack_require__(94),
		__webpack_require__(255)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, camelCase, rnothtmlwhite, acceptData ) {
	
	"use strict";
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	
	return Data;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 426 */
69,
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(129),
		__webpack_require__(432),
		__webpack_require__(431),
		__webpack_require__(433),
		__webpack_require__(428),
		__webpack_require__(429)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, toType, rtagName, rscriptType, wrapMap, getAll, setGlobalEval ) {
	
	"use strict";
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	return buildFragment;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(112)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, nodeName ) {
	
	"use strict";
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	return getAll;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(69)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( dataPriv ) {
	
	"use strict";
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	return setGlobalEval;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return ( /^(?:checkbox|radio)$/i );
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return ( /^$|^module$|\/(?:java|ecma)script/i );
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	"use strict";
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	return wrapMap;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(129),
		__webpack_require__(430),
		__webpack_require__(27),
		__webpack_require__(62),
		__webpack_require__(132), // filter
		__webpack_require__(415)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, toType, rcheckableType, isFunction ) {
	
	"use strict";
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(261),
		__webpack_require__(27),
		__webpack_require__(436),
		__webpack_require__(41)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, indexOf, isFunction, rneedsContext ) {
	
	"use strict";
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(41)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
		"use strict";
	
		return jQuery.expr.match.needsContext;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(155)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr ) {
		"use strict";
	
		return arr.concat;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(260)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( hasOwn ) {
		"use strict";
	
		return hasOwn.toString;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(155)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr ) {
		"use strict";
	
		return arr.push;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(192)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( class2type ) {
		"use strict";
	
		return class2type.toString;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Actions
	 */
	
	module.exports = {
	
	    Angle: __webpack_require__(988),
	    Call: __webpack_require__(989),
	    GetFirst: __webpack_require__(990),
	    GetLast: __webpack_require__(991),
	    GridAlign: __webpack_require__(992),
	    IncAlpha: __webpack_require__(993),
	    IncX: __webpack_require__(994),
	    IncXY: __webpack_require__(995),
	    IncY: __webpack_require__(996),
	    PlaceOnCircle: __webpack_require__(997),
	    PlaceOnEllipse: __webpack_require__(998),
	    PlaceOnLine: __webpack_require__(999),
	    PlaceOnRectangle: __webpack_require__(1000),
	    PlaceOnTriangle: __webpack_require__(1001),
	    PlayAnimation: __webpack_require__(1002),
	    PropertyValueInc: __webpack_require__(70),
	    PropertyValueSet: __webpack_require__(48),
	    RandomCircle: __webpack_require__(1003),
	    RandomEllipse: __webpack_require__(1004),
	    RandomLine: __webpack_require__(1005),
	    RandomRectangle: __webpack_require__(1006),
	    RandomTriangle: __webpack_require__(1007),
	    Rotate: __webpack_require__(1008),
	    RotateAround: __webpack_require__(1009),
	    RotateAroundDistance: __webpack_require__(1010),
	    ScaleX: __webpack_require__(1011),
	    ScaleXY: __webpack_require__(1012),
	    ScaleY: __webpack_require__(1013),
	    SetAlpha: __webpack_require__(1014),
	    SetBlendMode: __webpack_require__(1015),
	    SetDepth: __webpack_require__(1016),
	    SetHitArea: __webpack_require__(1017),
	    SetOrigin: __webpack_require__(1018),
	    SetRotation: __webpack_require__(1019),
	    SetScale: __webpack_require__(1020),
	    SetScaleX: __webpack_require__(1021),
	    SetScaleY: __webpack_require__(1022),
	    SetTint: __webpack_require__(1023),
	    SetVisible: __webpack_require__(1024),
	    SetX: __webpack_require__(1025),
	    SetXY: __webpack_require__(1026),
	    SetY: __webpack_require__(1027),
	    ShiftPosition: __webpack_require__(1028),
	    Shuffle: __webpack_require__(1029),
	    SmootherStep: __webpack_require__(1031),
	    SmoothStep: __webpack_require__(1030),
	    Spread: __webpack_require__(1032),
	    ToggleVisible: __webpack_require__(1033),
	    WrapInRectangle: __webpack_require__(1034)
	
	};


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Clamp = __webpack_require__(63);
	var Class = __webpack_require__(1);
	var FindClosestInSorted = __webpack_require__(657);
	var Frame = __webpack_require__(443);
	var GetValue = __webpack_require__(10);
	
	/**
	 * @typedef {object} JSONAnimation
	 *
	 * @property {string} key - The key that the animation will be associated with. i.e. sprite.animations.play(key)
	 * @property {string} type - A frame based animation (as opposed to a bone based animation)
	 * @property {JSONAnimationFrame[]} frames - [description]
	 * @property {integer} frameRate - The frame rate of playback in frames per second (default 24 if duration is null)
	 * @property {integer} duration - How long the animation should play for in milliseconds. If not given its derived from frameRate.
	 * @property {boolean} skipMissedFrames - Skip frames if the time lags, or always advanced anyway?
	 * @property {integer} delay - Delay before starting playback. Value given in milliseconds.
	 * @property {integer} repeat - Number of times to repeat the animation (-1 for infinity)
	 * @property {integer} repeatDelay - Delay before the animation repeats. Value given in milliseconds.
	 * @property {boolean} yoyo - Should the animation yoyo? (reverse back down to the start) before repeating?
	 * @property {boolean} showOnStart - Should sprite.visible = true when the animation starts to play?
	 * @property {boolean} hideOnComplete - Should sprite.visible = false when the animation finishes?
	 */
	
	/**
	 * @typedef {object} AnimationFrameConfig
	 *
	 * @property {string} key - The key that the animation will be associated with. i.e. sprite.animations.play(key)
	 * @property {(string|number)} frame - [description]
	 * @property {float} [duration=0] - [description]
	 * @property {boolean} [visible] - [description]
	 */
	
	/**
	 * @typedef {object} AnimationConfig
	 *
	 * @property {string} [key] - The key that the animation will be associated with. i.e. sprite.animations.play(key)
	 * @property {AnimationFrameConfig[]} [frames] - An object containing data used to generate the frames for the animation
	 * @property {string} [defaultTextureKey=null] - The key of the texture all frames of the animation will use. Can be overridden on a per frame basis.
	 * @property {integer} [frameRate] - The frame rate of playback in frames per second (default 24 if duration is null)
	 * @property {integer} [duration] - How long the animation should play for in milliseconds. If not given its derived from frameRate.
	 * @property {boolean} [skipMissedFrames=true] - Skip frames if the time lags, or always advanced anyway?
	 * @property {integer} [delay=0] - Delay before starting playback. Value given in milliseconds.
	 * @property {integer} [repeat=0] - Number of times to repeat the animation (-1 for infinity)
	 * @property {integer} [repeatDelay=0] - Delay before the animation repeats. Value given in milliseconds.
	 * @property {boolean} [yoyo=false] - Should the animation yoyo? (reverse back down to the start) before repeating?
	 * @property {boolean} [showOnStart=false] - Should sprite.visible = true when the animation starts to play?
	 * @property {boolean} [hideOnComplete=false] - Should sprite.visible = false when the animation finishes?
	 */
	
	/**
	 * @classdesc
	 * A Frame based Animation.
	 *
	 * This consists of a key, some default values (like the frame rate) and a bunch of Frame objects.
	 *
	 * The Animation Manager creates these. Game Objects don't own an instance of these directly.
	 * Game Objects have the Animation Component, which are like playheads to global Animations (these objects)
	 * So multiple Game Objects can have playheads all pointing to this one Animation instance.
	 *
	 * @class Animation
	 * @memberOf Phaser.Animations
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Animations.AnimationManager} manager - [description]
	 * @param {string} key - [description]
	 * @param {AnimationConfig} config - [description]
	 */
	var Animation = new Class({
	
	    initialize:
	
	    function Animation (manager, key, config)
	    {
	        /**
	         * A reference to the global Animation Manager
	         *
	         * @name Phaser.Animations.Animation#manager
	         * @type {Phaser.Animations.AnimationManager}
	         * @since 3.0.0
	         */
	        this.manager = manager;
	
	        /**
	         * The unique identifying string for this animation
	         *
	         * @name Phaser.Animations.Animation#key
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.key = key;
	
	        /**
	         * A frame based animation (as opposed to a bone based animation)
	         *
	         * @name Phaser.Animations.Animation#type
	         * @type {string}
	         * @default frame
	         * @since 3.0.0
	         */
	        this.type = 'frame';
	
	        /**
	         * Extract all the frame data into the frames array
	         *
	         * @name Phaser.Animations.Animation#frames
	         * @type {Phaser.Animations.AnimationFrame[]}
	         * @since 3.0.0
	         */
	        this.frames = this.getFrames(
	            manager.textureManager,
	            GetValue(config, 'frames', []),
	            GetValue(config, 'defaultTextureKey', null)
	        );
	
	        /**
	         * The frame rate of playback in frames per second (default 24 if duration is null)
	         *
	         * @name Phaser.Animations.Animation#frameRate
	         * @type {integer}
	         * @default 24
	         * @since 3.0.0
	         */
	        this.frameRate = GetValue(config, 'frameRate', null);
	
	        /**
	         * How long the animation should play for, in milliseconds.
	         * If the `frameRate` property has been set then it overrides this value,
	         * otherwise the `frameRate` is derived from `duration`.
	         *
	         * @name Phaser.Animations.Animation#duration
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.duration = GetValue(config, 'duration', null);
	
	        if (this.duration === null && this.frameRate === null)
	        {
	            //  No duration or frameRate given, use default frameRate of 24fps
	            this.frameRate = 24;
	            this.duration = (this.frameRate / this.frames.length) * 1000;
	        }
	        else if (this.duration && this.frameRate === null)
	        {
	            //  Duration given but no frameRate, so set the frameRate based on duration
	            //  I.e. 12 frames in the animation, duration = 4000 ms
	            //  So frameRate is 12 / (4000 / 1000) = 3 fps
	            this.frameRate = this.frames.length / (this.duration / 1000);
	        }
	        else
	        {
	            //  frameRate given, derive duration from it (even if duration also specified)
	            //  I.e. 15 frames in the animation, frameRate = 30 fps
	            //  So duration is 15 / 30 = 0.5 * 1000 (half a second, or 500ms)
	            this.duration = (this.frames.length / this.frameRate) * 1000;
	        }
	
	        /**
	         * How many ms per frame, not including frame specific modifiers.
	         *
	         * @name Phaser.Animations.Animation#msPerFrame
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.msPerFrame = 1000 / this.frameRate;
	
	        /**
	         * Skip frames if the time lags, or always advanced anyway?
	         *
	         * @name Phaser.Animations.Animation#skipMissedFrames
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.skipMissedFrames = GetValue(config, 'skipMissedFrames', true);
	
	        /**
	         * The delay in ms before the playback will begin.
	         *
	         * @name Phaser.Animations.Animation#delay
	         * @type {integer}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.delay = GetValue(config, 'delay', 0);
	
	        /**
	         * Number of times to repeat the animation. Set to -1 to repeat forever.
	         *
	         * @name Phaser.Animations.Animation#repeat
	         * @type {integer}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.repeat = GetValue(config, 'repeat', 0);
	
	        /**
	         * The delay in ms before the a repeat playthrough starts.
	         *
	         * @name Phaser.Animations.Animation#repeatDelay
	         * @type {integer}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.repeatDelay = GetValue(config, 'repeatDelay', 0);
	
	        /**
	         * Should the animation yoyo? (reverse back down to the start) before repeating?
	         *
	         * @name Phaser.Animations.Animation#yoyo
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.yoyo = GetValue(config, 'yoyo', false);
	
	        /**
	         * Should sprite.visible = true when the animation starts to play?
	         *
	         * @name Phaser.Animations.Animation#showOnStart
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.showOnStart = GetValue(config, 'showOnStart', false);
	
	        /**
	         * Should sprite.visible = false when the animation finishes?
	         *
	         * @name Phaser.Animations.Animation#hideOnComplete
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.hideOnComplete = GetValue(config, 'hideOnComplete', false);
	
	        /**
	         * Global pause. All Game Objects using this Animation instance are impacted by this property.
	         *
	         * @name Phaser.Animations.Animation#paused
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.paused = false;
	
	        this.manager.on('pauseall', this.pause, this);
	        this.manager.on('resumeall', this.resume, this);
	    },
	
	    /**
	     * Add frames to the end of the animation.
	     *
	     * @method Phaser.Animations.Animation#addFrame
	     * @since 3.0.0
	     *
	     * @param {(string|AnimationFrameConfig[])} config - [description]
	     *
	     * @return {Phaser.Animations.Animation} This Animation object.
	     */
	    addFrame: function (config)
	    {
	        return this.addFrameAt(this.frames.length, config);
	    },
	
	    /**
	     * Add frame/s into the animation.
	     *
	     * @method Phaser.Animations.Animation#addFrameAt
	     * @since 3.0.0
	     *
	     * @param {integer} index - [description]
	     * @param {(string|AnimationFrameConfig[])} config - [description]
	     *
	     * @return {Phaser.Animations.Animation} This Animation object.
	     */
	    addFrameAt: function (index, config)
	    {
	        var newFrames = this.getFrames(this.manager.textureManager, config);
	
	        if (newFrames.length > 0)
	        {
	            if (index === 0)
	            {
	                this.frames = newFrames.concat(this.frames);
	            }
	            else if (index === this.frames.length)
	            {
	                this.frames = this.frames.concat(newFrames);
	            }
	            else
	            {
	                var pre = this.frames.slice(0, index);
	                var post = this.frames.slice(index);
	
	                this.frames = pre.concat(newFrames, post);
	            }
	
	            this.updateFrameSequence();
	        }
	
	        return this;
	    },
	
	    /**
	     * Check if the given frame index is valid.
	     *
	     * @method Phaser.Animations.Animation#checkFrame
	     * @since 3.0.0
	     *
	     * @param {integer} index - The index to be checked.
	     *
	     * @return {boolean} `true` if the index is valid, otherwise `false`.
	     */
	    checkFrame: function (index)
	    {
	        return (index >= 0 && index < this.frames.length);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.Animation#completeAnimation
	     * @protected
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Components.Animation} component - [description]
	     */
	    completeAnimation: function (component)
	    {
	        if (this.hideOnComplete)
	        {
	            component.parent.visible = false;
	        }
	
	        component.stop();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.Animation#getFirstTick
	     * @protected
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Components.Animation} component - [description]
	     * @param {boolean} [includeDelay=true] - [description]
	     */
	    getFirstTick: function (component, includeDelay)
	    {
	        if (includeDelay === undefined) { includeDelay = true; }
	
	        //  When is the first update due?
	        component.accumulator = 0;
	        component.nextTick = component.msPerFrame + component.currentFrame.duration;
	
	        if (includeDelay)
	        {
	            component.nextTick += component._delay;
	        }
	    },
	
	    /**
	     * Returns the AnimationFrame at the provided index
	     *
	     * @method Phaser.Animations.Animation#getFrameAt
	     * @protected
	     * @since 3.0.0
	     *
	     * @param {integer} index - The index in the AnimationFrame array
	     *
	     * @return {Phaser.Animations.AnimationFrame} The frame at the index provided from the animation sequence
	     */
	    getFrameAt: function (index)
	    {
	        return this.frames[index];
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.Animation#getFrames
	     * @since 3.0.0
	     *
	     * @param {Phaser.Textures.TextureManager} textureManager - [description]
	     * @param {(string|AnimationFrameConfig[])} frames - [description]
	     * @param {string} [defaultTextureKey] - [description]
	     *
	     * @return {Phaser.Animations.AnimationFrame[]} [description]
	     */
	    getFrames: function (textureManager, frames, defaultTextureKey)
	    {
	        var out = [];
	        var prev;
	        var animationFrame;
	        var index = 1;
	        var i;
	        var textureKey;
	
	        //  if frames is a string, we'll get all the frames from the texture manager as if it's a sprite sheet
	        if (typeof frames === 'string')
	        {
	            textureKey = frames;
	
	            var texture = textureManager.get(textureKey);
	            var frameKeys = texture.getFrameNames();
	
	            frames = [];
	
	            frameKeys.forEach(function (idx, value)
	            {
	                frames.push({ key: textureKey, frame: value });
	            });
	        }
	
	        if (!Array.isArray(frames) || frames.length === 0)
	        {
	            return out;
	        }
	
	        for (i = 0; i < frames.length; i++)
	        {
	            var item = frames[i];
	
	            var key = GetValue(item, 'key', defaultTextureKey);
	
	            if (!key)
	            {
	                continue;
	            }
	
	            //  Could be an integer or a string
	            var frame = GetValue(item, 'frame', 0);
	
	            //  The actual texture frame
	            var textureFrame = textureManager.getFrame(key, frame);
	
	            animationFrame = new Frame(key, frame, index, textureFrame);
	
	            animationFrame.duration = GetValue(item, 'duration', 0);
	
	            animationFrame.isFirst = (!prev);
	
	            //  The previously created animationFrame
	            if (prev)
	            {
	                prev.nextFrame = animationFrame;
	
	                animationFrame.prevFrame = prev;
	            }
	
	            out.push(animationFrame);
	
	            prev = animationFrame;
	
	            index++;
	        }
	
	        if (out.length > 0)
	        {
	            animationFrame.isLast = true;
	
	            //  Link them end-to-end, so they loop
	            animationFrame.nextFrame = out[0];
	
	            out[0].prevFrame = animationFrame;
	
	            //  Generate the progress data
	
	            var slice = 1 / (out.length - 1);
	
	            for (i = 0; i < out.length; i++)
	            {
	                out[i].progress = i * slice;
	            }
	        }
	
	        return out;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.Animation#getNextTick
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Components.Animation} component - [description]
	     */
	    getNextTick: function (component)
	    {
	        // accumulator += delta * _timeScale
	        // after a large delta surge (perf issue for example) we need to adjust for it here
	
	        //  When is the next update due?
	        component.accumulator -= component.nextTick;
	
	        component.nextTick = component.msPerFrame + component.currentFrame.duration;
	    },
	
	    /**
	     * Loads the Animation values into the Animation Component.
	     *
	     * @method Phaser.Animations.Animation#load
	     * @private
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Components.Animation} component - [description]
	     * @param {integer} startFrame - [description]
	     */
	    load: function (component, startFrame)
	    {
	        if (startFrame >= this.frames.length)
	        {
	            startFrame = 0;
	        }
	
	        if (component.currentAnim !== this)
	        {
	            component.currentAnim = this;
	
	            component.frameRate = this.frameRate;
	            component.duration = this.duration;
	            component.msPerFrame = this.msPerFrame;
	            component.skipMissedFrames = this.skipMissedFrames;
	
	            component._timeScale = 1;
	            component._delay = this.delay;
	            component._repeat = this.repeat;
	            component._repeatDelay = this.repeatDelay;
	            component._yoyo = this.yoyo;
	        }
	
	        component.updateFrame(this.frames[startFrame]);
	    },
	
	    /**
	     * Returns the frame closest to the given progress value between 0 and 1.
	     *
	     * @method Phaser.Animations.Animation#getFrameByProgress
	     * @since 3.4.0
	     *
	     * @param {float} value - A value between 0 and 1.
	     *
	     * @return {Phaser.Animations.AnimationFrame} [description]
	     */
	    getFrameByProgress: function (value)
	    {
	        value = Clamp(value, 0, 1);
	
	        return FindClosestInSorted(value, this.frames, 'progress');
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.Animation#nextFrame
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Components.Animation} component - [description]
	     */
	    nextFrame: function (component)
	    {
	        var frame = component.currentFrame;
	
	        //  TODO: Add frame skip support
	
	        if (frame.isLast)
	        {
	            //  We're at the end of the animation
	
	            //  Yoyo? (happens before repeat)
	            if (component._yoyo)
	            {
	                component.forward = false;
	
	                component.updateFrame(frame.prevFrame);
	
	                //  Delay for the current frame
	                this.getNextTick(component);
	            }
	            else if (component.repeatCounter > 0)
	            {
	                //  Repeat (happens before complete)
	                this.repeatAnimation(component);
	            }
	            else
	            {
	                this.completeAnimation(component);
	            }
	        }
	        else
	        {
	            component.updateFrame(frame.nextFrame);
	
	            this.getNextTick(component);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.Animation#previousFrame
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Components.Animation} component - [description]
	     */
	    previousFrame: function (component)
	    {
	        var frame = component.currentFrame;
	
	        //  TODO: Add frame skip support
	
	        if (frame.isFirst)
	        {
	            //  We're at the start of the animation
	
	            if (component.repeatCounter > 0)
	            {
	                //  Repeat (happens before complete)
	                this.repeatAnimation(component);
	            }
	            else
	            {
	                this.completeAnimation(component);
	            }
	        }
	        else
	        {
	            component.updateFrame(frame.prevFrame);
	
	            this.getNextTick(component);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.Animation#removeFrame
	     * @since 3.0.0
	     *
	     * @param {Phaser.Animations.AnimationFrame} frame - [description]
	     *
	     * @return {Phaser.Animations.Animation} This Animation object.
	     */
	    removeFrame: function (frame)
	    {
	        var index = this.frames.indexOf(frame);
	
	        if (index !== -1)
	        {
	            this.removeFrameAt(index);
	        }
	
	        return this;
	    },
	
	    /**
	     * Removes a frame from the AnimationFrame array at the provided index
	     * and updates the animation accordingly.
	     *
	     * @method Phaser.Animations.Animation#removeFrameAt
	     * @since 3.0.0
	     *
	     * @param {integer} index - The index in the AnimationFrame array
	     *
	     * @return {Phaser.Animations.Animation} This Animation object.
	     */
	    removeFrameAt: function (index)
	    {
	        this.frames.splice(index, 1);
	
	        this.updateFrameSequence();
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.Animation#repeatAnimation
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Components.Animation} component - [description]
	     */
	    repeatAnimation: function (component)
	    {
	        if (component._pendingStop === 2)
	        {
	            return this.completeAnimation(component);
	        }
	
	        if (component._repeatDelay > 0 && component.pendingRepeat === false)
	        {
	            component.pendingRepeat = true;
	            component.accumulator -= component.nextTick;
	            component.nextTick += component._repeatDelay;
	        }
	        else
	        {
	            component.repeatCounter--;
	
	            component.forward = true;
	
	            component.updateFrame(component.currentFrame.nextFrame);
	
	            if (component.isPlaying)
	            {
	                this.getNextTick(component);
	
	                component.pendingRepeat = false;
	
	                component.parent.emit('animationrepeat', this, component.currentFrame, component.repeatCounter);
	            }
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.Animation#setFrame
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Components.Animation} component - [description]
	     */
	    setFrame: function (component)
	    {
	        //  Work out which frame should be set next on the child, and set it
	        if (component.forward)
	        {
	            this.nextFrame(component);
	        }
	        else
	        {
	            this.previousFrame(component);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.Animation#toJSON
	     * @since 3.0.0
	     *
	     * @return {JSONAnimation} [description]
	     */
	    toJSON: function ()
	    {
	        var output = {
	            key: this.key,
	            type: this.type,
	            frames: [],
	            frameRate: this.frameRate,
	            duration: this.duration,
	            skipMissedFrames: this.skipMissedFrames,
	            delay: this.delay,
	            repeat: this.repeat,
	            repeatDelay: this.repeatDelay,
	            yoyo: this.yoyo,
	            showOnStart: this.showOnStart,
	            hideOnComplete: this.hideOnComplete
	        };
	
	        this.frames.forEach(function (frame)
	        {
	            output.frames.push(frame.toJSON());
	        });
	
	        return output;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.Animation#updateFrameSequence
	     * @since 3.0.0
	     *
	     * @return {Phaser.Animations.Animation} This Animation object.
	     */
	    updateFrameSequence: function ()
	    {
	        var len = this.frames.length;
	        var slice = 1 / (len - 1);
	
	        for (var i = 0; i < len; i++)
	        {
	            var frame = this.frames[i];
	
	            frame.index = i + 1;
	            frame.isFirst = false;
	            frame.isLast = false;
	            frame.progress = i * slice;
	
	            if (i === 0)
	            {
	                frame.isFirst = true;
	                frame.isLast = (len === 1);
	                frame.prevFrame = this.frames[len - 1];
	                frame.nextFrame = this.frames[i + 1];
	            }
	            else if (i === len - 1)
	            {
	                frame.isLast = true;
	                frame.prevFrame = this.frames[len - 2];
	                frame.nextFrame = this.frames[0];
	            }
	            else if (len > 1)
	            {
	                frame.prevFrame = this.frames[i - 1];
	                frame.nextFrame = this.frames[i + 1];
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.Animation#pause
	     * @since 3.0.0
	     *
	     * @return {Phaser.Animations.Animation} This Animation object.
	     */
	    pause: function ()
	    {
	        this.paused = true;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.Animation#resume
	     * @since 3.0.0
	     *
	     * @return {Phaser.Animations.Animation} This Animation object.
	     */
	    resume: function ()
	    {
	        this.paused = false;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.Animation#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.manager.off('pauseall', this.pause, this);
	        this.manager.off('resumeall', this.resume, this);
	
	        this.manager.remove(this.key);
	
	        for (var i = 0; i < this.frames.length; i++)
	        {
	            this.frames[i].destroy();
	        }
	
	        this.frames = [];
	
	        this.manager = null;
	    }
	
	});
	
	module.exports = Animation;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	
	/**
	 * @typedef {object} JSONAnimationFrame
	 *
	 * @property {string} key - The key of the Texture this AnimationFrame uses.
	 * @property {(string|integer)} frame - The key of the Frame within the Texture that this AnimationFrame uses.
	 * @property {number} duration - Additional time (in ms) that this frame should appear for during playback.
	 */
	
	/**
	 * @classdesc
	 * A single frame in an Animation sequence.
	 *
	 * An AnimationFrame consists of a reference to the Texture it uses for rendering, references to other
	 * frames in the animation, and index data. It also has the ability to fire its own `onUpdate` callback
	 * and modify the animation timing.
	 *
	 * AnimationFrames are generated automatically by the Animation class.
	 *
	 * @class AnimationFrame
	 * @memberOf Phaser.Animations
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {string} textureKey - The key of the Texture this AnimationFrame uses.
	 * @param {(string|integer)} textureFrame - The key of the Frame within the Texture that this AnimationFrame uses.
	 * @param {integer} index - The index of this AnimationFrame within the Animation sequence.
	 * @param {Phaser.Textures.Frame} frame - A reference to the Texture Frame this AnimationFrame uses for rendering.
	 */
	var AnimationFrame = new Class({
	
	    initialize:
	
	    function AnimationFrame (textureKey, textureFrame, index, frame)
	    {
	        /**
	         * The key of the Texture this AnimationFrame uses.
	         *
	         * @name Phaser.Animations.AnimationFrame#textureKey
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.textureKey = textureKey;
	
	        /**
	         * The key of the Frame within the Texture that this AnimationFrame uses.
	         *
	         * @name Phaser.Animations.AnimationFrame#textureFrame
	         * @type {(string|integer)}
	         * @since 3.0.0
	         */
	        this.textureFrame = textureFrame;
	
	        /**
	         * The index of this AnimationFrame within the Animation sequence.
	         *
	         * @name Phaser.Animations.AnimationFrame#index
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.index = index;
	
	        /**
	         * A reference to the Texture Frame this AnimationFrame uses for rendering.
	         *
	         * @name Phaser.Animations.AnimationFrame#frame
	         * @type {Phaser.Textures.Frame}
	         * @since 3.0.0
	         */
	        this.frame = frame;
	
	        /**
	         * Is this the first frame in an animation sequence?
	         *
	         * @name Phaser.Animations.AnimationFrame#isFirst
	         * @type {boolean}
	         * @default false
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.isFirst = false;
	
	        /**
	         * Is this the last frame in an animation sequence?
	         *
	         * @name Phaser.Animations.AnimationFrame#isLast
	         * @type {boolean}
	         * @default false
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.isLast = false;
	
	        /**
	         * A reference to the AnimationFrame that comes before this one in the animation, if any.
	         *
	         * @name Phaser.Animations.AnimationFrame#prevFrame
	         * @type {?Phaser.Animations.AnimationFrame}
	         * @default null
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.prevFrame = null;
	
	        /**
	         * A reference to the AnimationFrame that comes after this one in the animation, if any.
	         *
	         * @name Phaser.Animations.AnimationFrame#nextFrame
	         * @type {?Phaser.Animations.AnimationFrame}
	         * @default null
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.nextFrame = null;
	
	        /**
	         * Additional time (in ms) that this frame should appear for during playback.
	         * The value is added onto the msPerFrame set by the animation.
	         *
	         * @name Phaser.Animations.AnimationFrame#duration
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.duration = 0;
	
	        /**
	         * What % through the animation does this frame come?
	         * This value is generated when the animation is created and cached here.
	         *
	         * @name Phaser.Animations.AnimationFrame#progress
	         * @type {number}
	         * @default 0
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.progress = 0;
	    },
	
	    /**
	     * Generates a JavaScript object suitable for converting to JSON.
	     *
	     * @method Phaser.Animations.AnimationFrame#toJSON
	     * @since 3.0.0
	     *
	     * @return {JSONAnimationFrame} The AnimationFrame data.
	     */
	    toJSON: function ()
	    {
	        return {
	            key: this.textureKey,
	            frame: this.textureFrame,
	            duration: this.duration
	        };
	    },
	
	    /**
	     * Destroys this object by removing references to external resources and callbacks.
	     *
	     * @method Phaser.Animations.AnimationFrame#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.frame = undefined;
	    }
	
	});
	
	module.exports = AnimationFrame;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Animation = __webpack_require__(442);
	var Class = __webpack_require__(1);
	var CustomMap = __webpack_require__(326);
	var EventEmitter = __webpack_require__(22);
	var GetValue = __webpack_require__(10);
	var Pad = __webpack_require__(342);
	
	/**
	 * @typedef {object} JSONAnimationManager
	 *
	 * @property {JSONAnimation[]} anims - [description]
	 * @property {number} globalTimeScale - [description]
	 */
	
	/**
	 * @classdesc
	 * The Animation Manager.
	 *
	 * Animations are managed by the global Animation Manager. This is a singleton class that is
	 * responsible for creating and delivering animations and their corresponding data to all Game Objects.
	 * Unlike plugins it is owned by the Game instance, not the Scene.
	 *
	 * Sprites and other Game Objects get the data they need from the AnimationManager.
	 *
	 * @class AnimationManager
	 * @extends Phaser.Events.EventEmitter
	 * @memberOf Phaser.Animations
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Game} game - [description]
	 */
	var AnimationManager = new Class({
	
	    Extends: EventEmitter,
	
	    initialize:
	
	    function AnimationManager (game)
	    {
	        EventEmitter.call(this);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Animations.AnimationManager#game
	         * @type {Phaser.Game}
	         * @protected
	         * @since 3.0.0
	         */
	        this.game = game;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Animations.AnimationManager#textureManager
	         * @type {Phaser.Textures.TextureManager}
	         * @protected
	         * @since 3.0.0
	         */
	        this.textureManager = null;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Animations.AnimationManager#globalTimeScale
	         * @type {number}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.globalTimeScale = 1;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Animations.AnimationManager#anims
	         * @type {Phaser.Structs.Map.<string, Phaser.Animations.Animation>}
	         * @protected
	         * @since 3.0.0
	         */
	        this.anims = new CustomMap();
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Animations.AnimationManager#paused
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.paused = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Animations.AnimationManager#name
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.name = 'AnimationManager';
	
	        game.events.once('boot', this.boot, this);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.AnimationManager#boot
	     * @since 3.0.0
	     */
	    boot: function ()
	    {
	        this.textureManager = this.game.textures;
	
	        this.game.events.once('destroy', this.destroy, this);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.AnimationManager#add
	     * @fires AddAnimationEvent
	     * @since 3.0.0
	     *
	     * @param {string} key - [description]
	     * @param {Phaser.Animations.Animation} animation - [description]
	     *
	     * @return {Phaser.Animations.AnimationManager} This Animation Manager.
	     */
	    add: function (key, animation)
	    {
	        if (this.anims.has(key))
	        {
	            console.warn('Animation with key', key, 'already exists');
	            return;
	        }
	
	        animation.key = key;
	
	        this.anims.set(key, animation);
	
	        this.emit('add', key, animation);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.AnimationManager#create
	     * @fires AddAnimationEvent
	     * @since 3.0.0
	     *
	     * @param {AnimationConfig} config - [description]
	     *
	     * @return {Phaser.Animations.Animation} The Animation that was created.
	     */
	    create: function (config)
	    {
	        var key = config.key;
	
	        if (!key || this.anims.has(key))
	        {
	            console.warn('Invalid Animation Key, or Key already in use: ' + key);
	            return;
	        }
	
	        var anim = new Animation(this, key, config);
	
	        this.anims.set(key, anim);
	
	        this.emit('add', key, anim);
	
	        return anim;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.AnimationManager#fromJSON
	     * @since 3.0.0
	     *
	     * @param {(string|JSONAnimationManager|JSONAnimation)} data - [description]
	     * @param {boolean} [clearCurrentAnimations=false] - [description]
	     *
	     * @return {Phaser.Animations.Animation[]} An array containing all of the Animation objects that were created as a result of this call.
	     */
	    fromJSON: function (data, clearCurrentAnimations)
	    {
	        if (clearCurrentAnimations === undefined) { clearCurrentAnimations = false; }
	
	        if (clearCurrentAnimations)
	        {
	            this.anims.clear();
	        }
	
	        //  Do we have a String (i.e. from JSON, or an Object?)
	        if (typeof data === 'string')
	        {
	            data = JSON.parse(data);
	        }
	
	        var output = [];
	
	        //  Array of animations, or a single animation?
	        if (data.hasOwnProperty('anims') && Array.isArray(data.anims))
	        {
	            for (var i = 0; i < data.anims.length; i++)
	            {
	                output.push(this.create(data.anims[i]));
	            }
	
	            if (data.hasOwnProperty('globalTimeScale'))
	            {
	                this.globalTimeScale = data.globalTimeScale;
	            }
	        }
	        else if (data.hasOwnProperty('key') && data.type === 'frame')
	        {
	            output.push(this.create(data));
	        }
	
	        return output;
	    },
	
	    /**
	     * @typedef {object} GenerateFrameNamesConfig
	     *
	     * @property {string} [prefix=''] - [description]
	     * @property {integer} [start=0] - [description]
	     * @property {integer} [end=0] - [description]
	     * @property {string} [suffix=''] - [description]
	     * @property {integer} [zeroPad=0] - [description]
	     * @property {AnimationFrameConfig[]} [outputArray=[]] - [description]
	     * @property {boolean} [frames=false] - [description]
	     */
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.AnimationManager#generateFrameNames
	     * @since 3.0.0
	     *
	     * @param {string} key - [description]
	     * @param {GenerateFrameNamesConfig} [config] - [description]
	     *
	     * @return {AnimationFrameConfig[]} [description]
	     */
	    generateFrameNames: function (key, config)
	    {
	        var prefix = GetValue(config, 'prefix', '');
	        var start = GetValue(config, 'start', 0);
	        var end = GetValue(config, 'end', 0);
	        var suffix = GetValue(config, 'suffix', '');
	        var zeroPad = GetValue(config, 'zeroPad', 0);
	        var out = GetValue(config, 'outputArray', []);
	        var frames = GetValue(config, 'frames', false);
	
	        var texture = this.textureManager.get(key);
	
	        if (!texture)
	        {
	            return out;
	        }
	
	        var diff = (start < end) ? 1 : -1;
	
	        //  Adjust because we use i !== end in the for loop
	        end += diff;
	
	        var i;
	        var frame;
	
	        if (!config)
	        {
	            //  Use every frame in the atlas?
	            frames = texture.getFrameNames();
	
	            for (i = 0; i < frames.length; i++)
	            {
	                out.push({ key: key, frame: frames[i] });
	            }
	        }
	        else if (Array.isArray(frames))
	        {
	            //  Have they provided their own custom frame sequence array?
	            for (i = 0; i < frames.length; i++)
	            {
	                frame = prefix + Pad(frames[i], zeroPad, '0', 1) + suffix;
	
	                if (texture.has(frame))
	                {
	                    out.push({ key: key, frame: frame });
	                }
	            }
	        }
	        else
	        {
	            for (i = start; i !== end; i += diff)
	            {
	                frame = prefix + Pad(i, zeroPad, '0', 1) + suffix;
	
	                if (texture.has(frame))
	                {
	                    out.push({ key: key, frame: frame });
	                }
	            }
	        }
	
	        return out;
	    },
	
	    /**
	     * @typedef {object} GenerateFrameNumbersConfig
	     *
	     * @property {integer} [start=0] - [description]
	     * @property {integer} [end=-1] - [description]
	     * @property {boolean} [first=false] - [description]
	     * @property {AnimationFrameConfig[]} [outputArray=[]] - [description]
	     * @property {boolean} [frames=false] - [description]
	     */
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.AnimationManager#generateFrameNumbers
	     * @since 3.0.0
	     *
	     * @param {string} key - [description]
	     * @param {GenerateFrameNumbersConfig} config - [description]
	     *
	     * @return {AnimationFrameConfig[]} [description]
	     */
	    generateFrameNumbers: function (key, config)
	    {
	        var startFrame = GetValue(config, 'start', 0);
	        var endFrame = GetValue(config, 'end', -1);
	        var firstFrame = GetValue(config, 'first', false);
	        var out = GetValue(config, 'outputArray', []);
	        var frames = GetValue(config, 'frames', false);
	
	        var texture = this.textureManager.get(key);
	
	        if (!texture)
	        {
	            return out;
	        }
	
	        if (firstFrame && texture.has(firstFrame))
	        {
	            out.push({ key: key, frame: firstFrame });
	        }
	
	        var i;
	
	        //  Have they provided their own custom frame sequence array?
	        if (Array.isArray(frames))
	        {
	            for (i = 0; i < frames.length; i++)
	            {
	                if (texture.has(frames[i]))
	                {
	                    out.push({ key: key, frame: frames[i] });
	                }
	            }
	        }
	        else
	        {
	            //  No endFrame then see if we can get it
	            if (endFrame === -1)
	            {
	                endFrame = texture.frameTotal;
	            }
	
	            for (i = startFrame; i <= endFrame; i++)
	            {
	                if (texture.has(i))
	                {
	                    out.push({ key: key, frame: i });
	                }
	            }
	        }
	
	        return out;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.AnimationManager#get
	     * @since 3.0.0
	     *
	     * @param {string} key - [description]
	     *
	     * @return {Phaser.Animations.Animation} [description]
	     */
	    get: function (key)
	    {
	        return this.anims.get(key);
	    },
	
	    /**
	     * Load an Animation into a Game Objects Animation Component.
	     *
	     * @method Phaser.Animations.AnimationManager#load
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} child - [description]
	     * @param {string} key - [description]
	     * @param {(string|integer)} [startFrame] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} [description]
	     */
	    load: function (child, key, startFrame)
	    {
	        var anim = this.get(key);
	
	        if (anim)
	        {
	            anim.load(child, startFrame);
	        }
	
	        return child;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.AnimationManager#pauseAll
	     * @fires PauseAllAnimationEvent
	     * @since 3.0.0
	     *
	     * @return {Phaser.Animations.AnimationManager} This Animation Manager.
	     */
	    pauseAll: function ()
	    {
	        if (!this.paused)
	        {
	            this.paused = true;
	
	            this.emit('pauseall');
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.AnimationManager#play
	     * @since 3.0.0
	     *
	     * @param {string} key - [description]
	     * @param {Phaser.GameObjects.GameObject} child - [description]
	     *
	     * @return {Phaser.Animations.AnimationManager} This Animation Manager.
	     */
	    play: function (key, child)
	    {
	        if (!Array.isArray(child))
	        {
	            child = [ child ];
	        }
	
	        var anim = this.get(key);
	
	        if (!anim)
	        {
	            return;
	        }
	
	        for (var i = 0; i < child.length; i++)
	        {
	            child[i].anims.play(key);
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.AnimationManager#remove
	     * @fires RemoveAnimationEvent
	     * @since 3.0.0
	     *
	     * @param {string} key - [description]
	     *
	     * @return {Phaser.Animations.Animation} [description]
	     */
	    remove: function (key)
	    {
	        var anim = this.get(key);
	
	        if (anim)
	        {
	            this.emit('remove', key, anim);
	
	            this.anims.delete(key);
	        }
	
	        return anim;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.AnimationManager#resumeAll
	     * @fires ResumeAllAnimationEvent
	     * @since 3.0.0
	     *
	     * @return {Phaser.Animations.AnimationManager} This Animation Manager.
	     */
	    resumeAll: function ()
	    {
	        if (this.paused)
	        {
	            this.paused = false;
	
	            this.emit('resumeall');
	        }
	
	        return this;
	    },
	
	    /**
	     * Takes an array of Game Objects that have the Animation Component and then
	     * starts the given animation playing on them, each one offset by the
	     * `stagger` amount given to this method.
	     *
	     * @method Phaser.Animations.AnimationManager#staggerPlay
	     * @since 3.0.0
	     * 
	     * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	     *
	     * @param {string} key - The key of the animation to play on the Game Objects.
	     * @param {Phaser.GameObjects.GameObject[]} children - An array of Game Objects to play the animation on. They must have the Animation Component.
	     * @param {number} [stagger=0] - The amount of time, in milliseconds, to offset each play time by.
	     *
	     * @return {Phaser.Animations.AnimationManager} This Animation Manager.
	     */
	    staggerPlay: function (key, children, stagger)
	    {
	        if (stagger === undefined) { stagger = 0; }
	
	        if (!Array.isArray(children))
	        {
	            children = [ children ];
	        }
	
	        var anim = this.get(key);
	
	        if (!anim)
	        {
	            return;
	        }
	
	        for (var i = 0; i < children.length; i++)
	        {
	            children[i].anims.delayedPlay(stagger * i, key);
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.AnimationManager#toJSON
	     * @since 3.0.0
	     *
	     * @param {string} key - [description]
	     *
	     * @return {JSONAnimationManager} [description]
	     */
	    toJSON: function (key)
	    {
	        if (key !== undefined && key !== '')
	        {
	            return this.anims.get(key).toJSON();
	        }
	        else
	        {
	            var output = {
	                anims: [],
	                globalTimeScale: this.globalTimeScale
	            };
	
	            this.anims.each(function (animationKey, animation)
	            {
	                output.anims.push(animation.toJSON());
	            });
	
	            return output;
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Animations.AnimationManager#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.anims.clear();
	
	        this.textureManager = null;
	
	        this.game = null;
	    }
	
	});
	
	module.exports = AnimationManager;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var CustomMap = __webpack_require__(326);
	var EventEmitter = __webpack_require__(22);
	
	/**
	 * @classdesc
	 * The BaseCache is a base Cache class that can be used for storing references to any kind of data.
	 *
	 * Data can be added, retrieved and removed based on the given keys.
	 *
	 * Keys are string-based.
	 *
	 * @class BaseCache
	 * @memberOf Phaser.Cache
	 * @constructor
	 * @since 3.0.0
	 */
	var BaseCache = new Class({
	
	    initialize:
	
	    function BaseCache ()
	    {
	        /**
	         * The Map in which the cache objects are stored.
	         *
	         * You can query the Map directly or use the BaseCache methods.
	         *
	         * @name Phaser.Cache.BaseCache#entries
	         * @type {Phaser.Structs.Map.<String, *>}
	         * @since 3.0.0
	         */
	        this.entries = new CustomMap();
	
	        /**
	         * An instance of EventEmitter used by the cache to emit related events.
	         *
	         * @name Phaser.Cache.BaseCache#events
	         * @type {Phaser.Events.EventEmitter}
	         * @since 3.0.0
	         */
	        this.events = new EventEmitter();
	    },
	
	    /**
	     * Cache add event.
	     *
	     * This event is fired by the Cache each time a new object is added to it.
	     *
	     * @event Phaser.Cache.BaseCache#addEvent
	     * @param {Phaser.Cache.BaseCache} cache - The BaseCache to which the object was added.
	     * @param {string} key - The key of the object added to the cache.
	     * @param {*} object - A reference to the object added to the cache.
	     */
	
	    /**
	     * Adds an item to this cache. The item is referenced by a unique string, which you are responsible
	     * for setting and keeping track of. The item can only be retrieved by using this string.
	     *
	     * @method Phaser.Cache.BaseCache#add
	     * @fires Phaser.Cache.BaseCache#addEvent
	     * @since 3.0.0
	     *
	     * @param {string} key - The unique key by which the data added to the cache will be referenced.
	     * @param {*} data - The data to be stored in the cache.
	     *
	     * @return {Phaser.Cache.BaseCache} This BaseCache object.
	     */
	    add: function (key, data)
	    {
	        this.entries.set(key, data);
	
	        this.events.emit('add', this, key, data);
	
	        return this;
	    },
	
	    /**
	     * Checks if this cache contains an item matching the given key.
	     * This performs the same action as `BaseCache.exists`.
	     *
	     * @method Phaser.Cache.BaseCache#has
	     * @since 3.0.0
	     *
	     * @param {string} key - The unique key of the item to be checked in this cache.
	     *
	     * @return {boolean} Returns `true` if the cache contains an item matching the given key, otherwise `false`.
	     */
	    has: function (key)
	    {
	        return this.entries.has(key);
	    },
	
	    /**
	     * Checks if this cache contains an item matching the given key.
	     * This performs the same action as `BaseCache.has` and is called directly by the Loader.
	     *
	     * @method Phaser.Cache.BaseCache#exists
	     * @since 3.7.0
	     *
	     * @param {string} key - The unique key of the item to be checked in this cache.
	     *
	     * @return {boolean} Returns `true` if the cache contains an item matching the given key, otherwise `false`.
	     */
	    exists: function (key)
	    {
	        return this.entries.has(key);
	    },
	
	    /**
	     * Gets an item from this cache based on the given key.
	     *
	     * @method Phaser.Cache.BaseCache#get
	     * @since 3.0.0
	     *
	     * @param {string} key - The unique key of the item to be retrieved from this cache.
	     *
	     * @return {*} The item in the cache, or `null` if no item matching the given key was found.
	     */
	    get: function (key)
	    {
	        return this.entries.get(key);
	    },
	
	    /**
	     * Cache remove event.
	     *
	     * This event is fired by the Cache each time an object is removed from it.
	     *
	     * @event Phaser.Cache.BaseCache#removeEvent
	     * @param {Phaser.Cache.BaseCache} cache - The BaseCache from which the object was removed.
	     * @param {string} key - The key of the object removed from the cache.
	     * @param {*} object - The object that was removed from the cache.
	     */
	
	    /**
	     * Removes and item from this cache based on the given key.
	     *
	     * If an entry matching the key is found it is removed from the cache and a `remove` event emitted.
	     * No additional checks are done on the item removed. If other systems or parts of your game code
	     * are relying on this item, it is up to you to sever those relationships prior to removing the item.
	     *
	     * @method Phaser.Cache.BaseCache#remove
	     * @fires Phaser.Cache.BaseCache#removeEvent
	     * @since 3.0.0
	     *
	     * @param {string} key - The unique key of the item to remove from the cache.
	     *
	     * @return {Phaser.Cache.BaseCache} This BaseCache object.
	     */
	    remove: function (key)
	    {
	        var entry = this.get(key);
	
	        if (entry)
	        {
	            this.entries.delete(key);
	
	            this.events.emit('remove', this, key, entry.data);
	        }
	
	        return this;
	    },
	
	    /**
	     * Destroys this cache and all items within it.
	     *
	     * @method Phaser.Cache.BaseCache#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.entries.clear();
	        this.events.removeAllListeners();
	
	        this.entries = null;
	        this.events = null;
	    }
	
	});
	
	module.exports = BaseCache;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BaseCache = __webpack_require__(445);
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * The Cache Manager is the global cache owned and maintained by the Game instance.
	 *
	 * Various systems, such as the file Loader, rely on this cache in order to store the files
	 * it has loaded. The manager itself doesn't store any files, but instead owns multiple BaseCache
	 * instances, one per type of file. You can also add your own custom caches.
	 *
	 * @class CacheManager
	 * @memberOf Phaser.Cache
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Game} game - A reference to the Phaser.Game instance that owns this CacheManager.
	 */
	var CacheManager = new Class({
	
	    initialize:
	
	    function CacheManager (game)
	    {
	        /**
	         * A reference to the Phaser.Game instance that owns this CacheManager.
	         *
	         * @name Phaser.Cache.CacheManager#game
	         * @type {Phaser.Game}
	         * @protected
	         * @since 3.0.0
	         */
	        this.game = game;
	
	        /**
	         * A Cache storing all binary files, typically added via the Loader.
	         *
	         * @name Phaser.Cache.CacheManager#binary
	         * @type {Phaser.Cache.BaseCache}
	         * @since 3.0.0
	         */
	        this.binary = new BaseCache();
	
	        /**
	         * A Cache storing all bitmap font data files, typically added via the Loader.
	         * Only the font data is stored in this cache, the textures are part of the Texture Manager.
	         *
	         * @name Phaser.Cache.CacheManager#bitmapFont
	         * @type {Phaser.Cache.BaseCache}
	         * @since 3.0.0
	         */
	        this.bitmapFont = new BaseCache();
	
	        /**
	         * A Cache storing all JSON data files, typically added via the Loader.
	         *
	         * @name Phaser.Cache.CacheManager#json
	         * @type {Phaser.Cache.BaseCache}
	         * @since 3.0.0
	         */
	        this.json = new BaseCache();
	
	        /**
	         * A Cache storing all physics data files, typically added via the Loader.
	         *
	         * @name Phaser.Cache.CacheManager#physics
	         * @type {Phaser.Cache.BaseCache}
	         * @since 3.0.0
	         */
	        this.physics = new BaseCache();
	
	        /**
	         * A Cache storing all shader source files, typically added via the Loader.
	         *
	         * @name Phaser.Cache.CacheManager#shader
	         * @type {Phaser.Cache.BaseCache}
	         * @since 3.0.0
	         */
	        this.shader = new BaseCache();
	
	        /**
	         * A Cache storing all non-streaming audio files, typically added via the Loader.
	         *
	         * @name Phaser.Cache.CacheManager#audio
	         * @type {Phaser.Cache.BaseCache}
	         * @since 3.0.0
	         */
	        this.audio = new BaseCache();
	
	        /**
	         * A Cache storing all text files, typically added via the Loader.
	         *
	         * @name Phaser.Cache.CacheManager#text
	         * @type {Phaser.Cache.BaseCache}
	         * @since 3.0.0
	         */
	        this.text = new BaseCache();
	
	        /**
	         * A Cache storing all WaveFront OBJ files, typically added via the Loader.
	         *
	         * @name Phaser.Cache.CacheManager#obj
	         * @type {Phaser.Cache.BaseCache}
	         * @since 3.0.0
	         */
	        this.obj = new BaseCache();
	
	        /**
	         * A Cache storing all tilemap data files, typically added via the Loader.
	         * Only the data is stored in this cache, the textures are part of the Texture Manager.
	         *
	         * @name Phaser.Cache.CacheManager#tilemap
	         * @type {Phaser.Cache.BaseCache}
	         * @since 3.0.0
	         */
	        this.tilemap = new BaseCache();
	
	        /**
	         * A Cache storing all xml data files, typically added via the Loader.
	         *
	         * @name Phaser.Cache.CacheManager#xml
	         * @type {Phaser.Cache.BaseCache}
	         * @since 3.0.0
	         */
	        this.xml = new BaseCache();
	
	        /**
	         * An object that contains your own custom BaseCache entries.
	         * Add to this via the `addCustom` method.
	         *
	         * @name Phaser.Cache.CacheManager#custom
	         * @type {Object.<Phaser.Cache.BaseCache>}
	         * @since 3.0.0
	         */
	        this.custom = {};
	
	        this.game.events.once('destroy', this.destroy, this);
	    },
	
	    /**
	     * Add your own custom Cache for storing your own files.
	     * The cache will be available under `Cache.custom.key`.
	     * The cache will only be created if the key is not already in use.
	     *
	     * @method Phaser.Cache.CacheManager#addCustom
	     * @since 3.0.0
	     *
	     * @param {string} key - The unique key of your custom cache.
	     *
	     * @return {Phaser.Cache.BaseCache} A reference to the BaseCache that was created. If the key was already in use, a reference to the existing cache is returned instead.
	     */
	    addCustom: function (key)
	    {
	        if (!this.custom.hasOwnProperty(key))
	        {
	            this.custom[key] = new BaseCache();
	        }
	
	        return this.custom[key];
	    },
	
	    /**
	     * Removes all entries from all BaseCaches and destroys all custom caches.
	     *
	     * @method Phaser.Cache.CacheManager#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        var keys = [
	            'binary',
	            'bitmapFont',
	            'json',
	            'physics',
	            'shader',
	            'audio',
	            'text',
	            'obj',
	            'tilemap',
	            'xml'
	        ];
	
	        for (var i = 0; i < keys.length; i++)
	        {
	            this[keys[i]].destroy();
	            this[keys[i]] = null;
	        }
	
	        for (var key in this.custom)
	        {
	            this.custom[key].destroy();
	        }
	
	        this.custom = null;
	
	        this.game = null;
	    }
	
	});
	
	module.exports = CacheManager;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Cameras.Scene2D.Effects
	 */
	
	module.exports = {
	
	    Fade: __webpack_require__(1044),
	    Flash: __webpack_require__(1045),
	    Shake: __webpack_require__(1046)
	
	};


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var GetValue = __webpack_require__(10);
	
	//  var camControl = new CameraControl({
	//      camera: this.cameras.main,
	//      left: cursors.left,
	//      right: cursors.right,
	//      speed: float OR { x: 0, y: 0 }
	//  })
	
	/**
	 * @typedef {object} FixedKeyControlConfig
	 *
	 * @property {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera that this Control will update.
	 * @property {Phaser.Input.Keyboard.Key} [left] - The Key to be pressed that will move the Camera left.
	 * @property {Phaser.Input.Keyboard.Key} [right] - The Key to be pressed that will move the Camera right.
	 * @property {Phaser.Input.Keyboard.Key} [up] - The Key to be pressed that will move the Camera up.
	 * @property {Phaser.Input.Keyboard.Key} [zoomIn] - The Key to be pressed that will zoom the Camera in.
	 * @property {Phaser.Input.Keyboard.Key} [zoomOut] - The Key to be pressed that will zoom the Camera out.
	 * @property {float} [zoomSpeed=0.01] - The speed at which the camera will zoom if the `zoomIn` or `zoomOut` keys are pressed.
	 * @property {(float|{x:float,y:float})} [speed=0] - The horizontal and vertical speed the camera will move.
	 */
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class FixedKeyControl
	 * @memberOf Phaser.Cameras.Controls
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {FixedKeyControlConfig} config - [description]
	 */
	var FixedKeyControl = new Class({
	
	    initialize:
	
	    function FixedKeyControl (config)
	    {
	        /**
	         * The Camera that this Control will update.
	         *
	         * @name Phaser.Cameras.Controls.FixedKeyControl#camera
	         * @type {?Phaser.Cameras.Scene2D.Camera}
	         * @default null
	         * @since 3.0.0
	         */
	        this.camera = GetValue(config, 'camera', null);
	
	        /**
	         * The Key to be pressed that will move the Camera left.
	         *
	         * @name Phaser.Cameras.Controls.FixedKeyControl#left
	         * @type {?Phaser.Input.Keyboard.Key}
	         * @default null
	         * @since 3.0.0
	         */
	        this.left = GetValue(config, 'left', null);
	
	        /**
	         * The Key to be pressed that will move the Camera right.
	         *
	         * @name Phaser.Cameras.Controls.FixedKeyControl#right
	         * @type {?Phaser.Input.Keyboard.Key}
	         * @default null
	         * @since 3.0.0
	         */
	        this.right = GetValue(config, 'right', null);
	
	        /**
	         * The Key to be pressed that will move the Camera up.
	         *
	         * @name Phaser.Cameras.Controls.FixedKeyControl#up
	         * @type {?Phaser.Input.Keyboard.Key}
	         * @default null
	         * @since 3.0.0
	         */
	        this.up = GetValue(config, 'up', null);
	
	        /**
	         * The Key to be pressed that will move the Camera down.
	         *
	         * @name Phaser.Cameras.Controls.FixedKeyControl#down
	         * @type {?Phaser.Input.Keyboard.Key}
	         * @default null
	         * @since 3.0.0
	         */
	        this.down = GetValue(config, 'down', null);
	
	        /**
	         * The Key to be pressed that will zoom the Camera in.
	         *
	         * @name Phaser.Cameras.Controls.FixedKeyControl#zoomIn
	         * @type {?Phaser.Input.Keyboard.Key}
	         * @default null
	         * @since 3.0.0
	         */
	        this.zoomIn = GetValue(config, 'zoomIn', null);
	
	        /**
	         * The Key to be pressed that will zoom the Camera out.
	         *
	         * @name Phaser.Cameras.Controls.FixedKeyControl#zoomOut
	         * @type {?Phaser.Input.Keyboard.Key}
	         * @default null
	         * @since 3.0.0
	         */
	        this.zoomOut = GetValue(config, 'zoomOut', null);
	
	        /**
	         * The speed at which the camera will zoom if the `zoomIn` or `zoomOut` keys are pressed.
	         *
	         * @name Phaser.Cameras.Controls.FixedKeyControl#zoomSpeed
	         * @type {float}
	         * @default 0.01
	         * @since 3.0.0
	         */
	        this.zoomSpeed = GetValue(config, 'zoomSpeed', 0.01);
	
	        /**
	         * The horizontal speed the camera will move.
	         *
	         * @name Phaser.Cameras.Controls.FixedKeyControl#speedX
	         * @type {float}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.speedX = 0;
	
	        /**
	         * The vertical speed the camera will move.
	         *
	         * @name Phaser.Cameras.Controls.FixedKeyControl#speedY
	         * @type {float}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.speedY = 0;
	
	        var speed = GetValue(config, 'speed', null);
	
	        if (typeof speed === 'number')
	        {
	            this.speedX = speed;
	            this.speedY = speed;
	        }
	        else
	        {
	            this.speedX = GetValue(config, 'speed.x', 0);
	            this.speedY = GetValue(config, 'speed.y', 0);
	        }
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Controls.FixedKeyControl#_zoom
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._zoom = 0;
	
	        /**
	         * A flag controlling if the Controls will update the Camera or not.
	         *
	         * @name Phaser.Cameras.Controls.FixedKeyControl#active
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.active = (this.camera !== null);
	    },
	
	    /**
	     * Starts the Key Control running, providing it has been linked to a camera.
	     *
	     * @method Phaser.Cameras.Controls.FixedKeyControl#start
	     * @since 3.0.0
	     *
	     * @return {Phaser.Cameras.Controls.FixedKeyControl} This Key Control instance.
	     */
	    start: function ()
	    {
	        this.active = (this.camera !== null);
	
	        return this;
	    },
	
	    /**
	     * Stops this Key Control from running. Call `start` to start it again.
	     *
	     * @method Phaser.Cameras.Controls.FixedKeyControl#stop
	     * @since 3.0.0
	     *
	     * @return {Phaser.Cameras.Controls.FixedKeyControl} This Key Control instance.
	     */
	    stop: function ()
	    {
	        this.active = false;
	
	        return this;
	    },
	
	    /**
	     * Binds this Key Control to a camera.
	     *
	     * @method Phaser.Cameras.Controls.FixedKeyControl#setCamera
	     * @since 3.0.0
	     *
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera to bind this Key Control to.
	     *
	     * @return {Phaser.Cameras.Controls.FixedKeyControl} This Key Control instance.
	     */
	    setCamera: function (camera)
	    {
	        this.camera = camera;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Controls.FixedKeyControl#update
	     * @since 3.0.0
	     *
	     * @param {number} delta - [description]
	     */
	    update: function (delta)
	    {
	        if (!this.active)
	        {
	            return;
	        }
	
	        if (delta === undefined) { delta = 1; }
	
	        var cam = this.camera;
	
	        if (this.up && this.up.isDown)
	        {
	            cam.scrollY -= ((this.speedY * delta) | 0);
	        }
	        else if (this.down && this.down.isDown)
	        {
	            cam.scrollY += ((this.speedY * delta) | 0);
	        }
	
	        if (this.left && this.left.isDown)
	        {
	            cam.scrollX -= ((this.speedX * delta) | 0);
	        }
	        else if (this.right && this.right.isDown)
	        {
	            cam.scrollX += ((this.speedX * delta) | 0);
	        }
	
	        //  Camera zoom
	
	        if (this.zoomIn && this.zoomIn.isDown)
	        {
	            cam.zoom -= this.zoomSpeed;
	
	            if (cam.zoom < 0.1)
	            {
	                cam.zoom = 0.1;
	            }
	        }
	        else if (this.zoomOut && this.zoomOut.isDown)
	        {
	            cam.zoom += this.zoomSpeed;
	        }
	    },
	
	    /**
	     * Destroys this Key Control.
	     *
	     * @method Phaser.Cameras.Controls.FixedKeyControl#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.camera = null;
	
	        this.left = null;
	        this.right = null;
	        this.up = null;
	        this.down = null;
	
	        this.zoomIn = null;
	        this.zoomOut = null;
	    }
	
	});
	
	module.exports = FixedKeyControl;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var GetValue = __webpack_require__(10);
	
	// var controlConfig = {
	//     camera: this.cameras.main,
	//     left: cursors.left,
	//     right: cursors.right,
	//     up: cursors.up,
	//     down: cursors.down,
	//     zoomIn: this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.Q),
	//     zoomOut: this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.E),
	//     zoomSpeed: 0.02,
	//     acceleration: 0.06,
	//     drag: 0.0005,
	//     maxSpeed: 1.0
	// };
	
	/**
	 * @typedef {object} SmoothedKeyControlConfig
	 *
	 * @property {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera that this Control will update.
	 * @property {Phaser.Input.Keyboard.Key} [left] - The Key to be pressed that will move the Camera left.
	 * @property {Phaser.Input.Keyboard.Key} [right] - The Key to be pressed that will move the Camera right.
	 * @property {Phaser.Input.Keyboard.Key} [up] - The Key to be pressed that will move the Camera up.
	 * @property {Phaser.Input.Keyboard.Key} [zoomIn] - The Key to be pressed that will zoom the Camera in.
	 * @property {Phaser.Input.Keyboard.Key} [zoomOut] - The Key to be pressed that will zoom the Camera out.
	 * @property {float} [zoomSpeed=0.01] - The speed at which the camera will zoom if the `zoomIn` or `zoomOut` keys are pressed.
	 * @property {(float|{x:float,y:float})} [acceleration=0] - The horizontal and vertical acceleration the camera will move.
	 * @property {(float|{x:float,y:float})} [drag=0] - The horizontal and vertical drag applied to the camera when it is moving.
	 * @property {(float|{x:float,y:float})} [maxSpeed=0] - The maximum horizontal and vertical speed the camera will move.
	 */
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class SmoothedKeyControl
	 * @memberOf Phaser.Cameras.Controls
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {SmoothedKeyControlConfig} config - [description]
	 */
	var SmoothedKeyControl = new Class({
	
	    initialize:
	
	    function SmoothedKeyControl (config)
	    {
	        /**
	         * The Camera that this Control will update.
	         *
	         * @name Phaser.Cameras.Controls.SmoothedKeyControl#camera
	         * @type {?Phaser.Cameras.Scene2D.Camera}
	         * @default null
	         * @since 3.0.0
	         */
	        this.camera = GetValue(config, 'camera', null);
	
	        /**
	         * The Key to be pressed that will move the Camera left.
	         *
	         * @name Phaser.Cameras.Controls.SmoothedKeyControl#left
	         * @type {?Phaser.Input.Keyboard.Key}
	         * @default null
	         * @since 3.0.0
	         */
	        this.left = GetValue(config, 'left', null);
	
	        /**
	         * The Key to be pressed that will move the Camera right.
	         *
	         * @name Phaser.Cameras.Controls.SmoothedKeyControl#right
	         * @type {?Phaser.Input.Keyboard.Key}
	         * @default null
	         * @since 3.0.0
	         */
	        this.right = GetValue(config, 'right', null);
	
	        /**
	         * The Key to be pressed that will move the Camera up.
	         *
	         * @name Phaser.Cameras.Controls.SmoothedKeyControl#up
	         * @type {?Phaser.Input.Keyboard.Key}
	         * @default null
	         * @since 3.0.0
	         */
	        this.up = GetValue(config, 'up', null);
	
	        /**
	         * The Key to be pressed that will move the Camera down.
	         *
	         * @name Phaser.Cameras.Controls.SmoothedKeyControl#down
	         * @type {?Phaser.Input.Keyboard.Key}
	         * @default null
	         * @since 3.0.0
	         */
	        this.down = GetValue(config, 'down', null);
	
	        /**
	         * The Key to be pressed that will zoom the Camera in.
	         *
	         * @name Phaser.Cameras.Controls.SmoothedKeyControl#zoomIn
	         * @type {?Phaser.Input.Keyboard.Key}
	         * @default null
	         * @since 3.0.0
	         */
	        this.zoomIn = GetValue(config, 'zoomIn', null);
	
	        /**
	         * The Key to be pressed that will zoom the Camera out.
	         *
	         * @name Phaser.Cameras.Controls.SmoothedKeyControl#zoomOut
	         * @type {?Phaser.Input.Keyboard.Key}
	         * @default null
	         * @since 3.0.0
	         */
	        this.zoomOut = GetValue(config, 'zoomOut', null);
	
	        /**
	         * The speed at which the camera will zoom if the `zoomIn` or `zoomOut` keys are pressed.
	         *
	         * @name Phaser.Cameras.Controls.SmoothedKeyControl#zoomSpeed
	         * @type {float}
	         * @default 0.01
	         * @since 3.0.0
	         */
	        this.zoomSpeed = GetValue(config, 'zoomSpeed', 0.01);
	
	        /**
	         * The horizontal acceleration the camera will move.
	         *
	         * @name Phaser.Cameras.Controls.SmoothedKeyControl#accelX
	         * @type {float}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.accelX = 0;
	
	        /**
	         * The vertical acceleration the camera will move.
	         *
	         * @name Phaser.Cameras.Controls.SmoothedKeyControl#accelY
	         * @type {float}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.accelY = 0;
	
	        var accel = GetValue(config, 'acceleration', null);
	
	        if (typeof accel === 'number')
	        {
	            this.accelX = accel;
	            this.accelY = accel;
	        }
	        else
	        {
	            this.accelX = GetValue(config, 'acceleration.x', 0);
	            this.accelY = GetValue(config, 'acceleration.y', 0);
	        }
	
	        /**
	         * The horizontal drag applied to the camera when it is moving.
	         *
	         * @name Phaser.Cameras.Controls.SmoothedKeyControl#dragX
	         * @type {float}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.dragX = 0;
	
	        /**
	         * The vertical drag applied to the camera when it is moving.
	         *
	         * @name Phaser.Cameras.Controls.SmoothedKeyControl#dragY
	         * @type {float}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.dragY = 0;
	
	        var drag = GetValue(config, 'drag', null);
	
	        if (typeof drag === 'number')
	        {
	            this.dragX = drag;
	            this.dragY = drag;
	        }
	        else
	        {
	            this.dragX = GetValue(config, 'drag.x', 0);
	            this.dragY = GetValue(config, 'drag.y', 0);
	        }
	
	        /**
	         * The maximum horizontal speed the camera will move.
	         *
	         * @name Phaser.Cameras.Controls.SmoothedKeyControl#maxSpeedX
	         * @type {float}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.maxSpeedX = 0;
	
	        /**
	         * The maximum vertical speed the camera will move.
	         *
	         * @name Phaser.Cameras.Controls.SmoothedKeyControl#maxSpeedY
	         * @type {float}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.maxSpeedY = 0;
	
	        var maxSpeed = GetValue(config, 'maxSpeed', null);
	
	        if (typeof maxSpeed === 'number')
	        {
	            this.maxSpeedX = maxSpeed;
	            this.maxSpeedY = maxSpeed;
	        }
	        else
	        {
	            this.maxSpeedX = GetValue(config, 'maxSpeed.x', 0);
	            this.maxSpeedY = GetValue(config, 'maxSpeed.y', 0);
	        }
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Controls.SmoothedKeyControl#_speedX
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._speedX = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Controls.SmoothedKeyControl#_speedY
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._speedY = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Controls.SmoothedKeyControl#_zoom
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._zoom = 0;
	
	        /**
	         * A flag controlling if the Controls will update the Camera or not.
	         *
	         * @name Phaser.Cameras.Controls.SmoothedKeyControl#active
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.active = (this.camera !== null);
	    },
	
	    /**
	     * Starts the Key Control running, providing it has been linked to a camera.
	     *
	     * @method Phaser.Cameras.Controls.SmoothedKeyControl#start
	     * @since 3.0.0
	     *
	     * @return {Phaser.Cameras.Controls.SmoothedKeyControl} This Key Control instance.
	     */
	    start: function ()
	    {
	        this.active = (this.camera !== null);
	
	        return this;
	    },
	
	    /**
	     * Stops this Key Control from running. Call `start` to start it again.
	     *
	     * @method Phaser.Cameras.Controls.SmoothedKeyControl#stop
	     * @since 3.0.0
	     *
	     * @return {Phaser.Cameras.Controls.SmoothedKeyControl} This Key Control instance.
	     */
	    stop: function ()
	    {
	        this.active = false;
	
	        return this;
	    },
	
	    /**
	     * Binds this Key Control to a camera.
	     *
	     * @method Phaser.Cameras.Controls.SmoothedKeyControl#setCamera
	     * @since 3.0.0
	     *
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera to bind this Key Control to.
	     *
	     * @return {Phaser.Cameras.Controls.SmoothedKeyControl} This Key Control instance.
	     */
	    setCamera: function (camera)
	    {
	        this.camera = camera;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Controls.SmoothedKeyControl#update
	     * @since 3.0.0
	     *
	     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
	     */
	    update: function (delta)
	    {
	        if (!this.active)
	        {
	            return;
	        }
	
	        if (delta === undefined) { delta = 1; }
	
	        var cam = this.camera;
	
	        //  Apply Deceleration
	
	        if (this._speedX > 0)
	        {
	            this._speedX -= this.dragX * delta;
	
	            if (this._speedX < 0)
	            {
	                this._speedX = 0;
	            }
	        }
	        else if (this._speedX < 0)
	        {
	            this._speedX += this.dragX * delta;
	
	            if (this._speedX > 0)
	            {
	                this._speedX = 0;
	            }
	        }
	
	        if (this._speedY > 0)
	        {
	            this._speedY -= this.dragY * delta;
	
	            if (this._speedY < 0)
	            {
	                this._speedY = 0;
	            }
	        }
	        else if (this._speedY < 0)
	        {
	            this._speedY += this.dragY * delta;
	
	            if (this._speedY > 0)
	            {
	                this._speedY = 0;
	            }
	        }
	
	        //  Check for keys
	
	        if (this.up && this.up.isDown)
	        {
	            this._speedY += this.accelY;
	
	            if (this._speedY > this.maxSpeedY)
	            {
	                this._speedY = this.maxSpeedY;
	            }
	        }
	        else if (this.down && this.down.isDown)
	        {
	            this._speedY -= this.accelY;
	
	            if (this._speedY < -this.maxSpeedY)
	            {
	                this._speedY = -this.maxSpeedY;
	            }
	        }
	
	        if (this.left && this.left.isDown)
	        {
	            this._speedX += this.accelX;
	
	            if (this._speedX > this.maxSpeedX)
	            {
	                this._speedX = this.maxSpeedX;
	            }
	        }
	        else if (this.right && this.right.isDown)
	        {
	            this._speedX -= this.accelX;
	
	            if (this._speedX < -this.maxSpeedX)
	            {
	                this._speedX = -this.maxSpeedX;
	            }
	        }
	
	        //  Camera zoom
	
	        if (this.zoomIn && this.zoomIn.isDown)
	        {
	            this._zoom = -this.zoomSpeed;
	        }
	        else if (this.zoomOut && this.zoomOut.isDown)
	        {
	            this._zoom = this.zoomSpeed;
	        }
	        else
	        {
	            this._zoom = 0;
	        }
	
	        //  Apply to Camera
	
	        if (this._speedX !== 0)
	        {
	            cam.scrollX -= ((this._speedX * delta) | 0);
	        }
	
	        if (this._speedY !== 0)
	        {
	            cam.scrollY -= ((this._speedY * delta) | 0);
	        }
	
	        if (this._zoom !== 0)
	        {
	            cam.zoom += this._zoom;
	
	            if (cam.zoom < 0.1)
	            {
	                cam.zoom = 0.1;
	            }
	        }
	    },
	
	    /**
	     * Destroys this Key Control.
	     *
	     * @method Phaser.Cameras.Controls.SmoothedKeyControl#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.camera = null;
	
	        this.left = null;
	        this.right = null;
	        this.up = null;
	        this.down = null;
	
	        this.zoomIn = null;
	        this.zoomOut = null;
	    }
	
	});
	
	module.exports = SmoothedKeyControl;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Camera = __webpack_require__(265);
	var Class = __webpack_require__(1);
	var Vector3 = __webpack_require__(142);
	
	//  Local cache vars
	var tmpVec3 = new Vector3();
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class OrthographicCamera
	 * @extends Phaser.Cameras.Sprite3D.Camera
	 * @memberOf Phaser.Cameras.Sprite3D
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - [description]
	 * @param {integer} [viewportWidth=0] - [description]
	 * @param {integer} [viewportHeight=0] - [description]
	 */
	var OrthographicCamera = new Class({
	
	    Extends: Camera,
	
	    initialize:
	
	    function OrthographicCamera (scene, viewportWidth, viewportHeight)
	    {
	        if (viewportWidth === undefined) { viewportWidth = 0; }
	        if (viewportHeight === undefined) { viewportHeight = 0; }
	
	        Camera.call(this, scene);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D.OrthographicCamera#viewportWidth
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.viewportWidth = viewportWidth;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D.OrthographicCamera#viewportHeight
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.viewportHeight = viewportHeight;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D.OrthographicCamera#_zoom
	         * @type {float}
	         * @private
	         * @since 3.0.0
	         */
	        this._zoom = 1.0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D.OrthographicCamera#near
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.near = 0;
	
	        this.update();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.OrthographicCamera#setToOrtho
	     * @since 3.0.0
	     *
	     * @param {number} yDown - [description]
	     * @param {number} [viewportWidth] - [description]
	     * @param {number} [viewportHeight] - [description]
	     *
	     * @return {Phaser.Cameras.Sprite3D.OrthographicCamera} [description]
	     */
	    setToOrtho: function (yDown, viewportWidth, viewportHeight)
	    {
	        if (viewportWidth === undefined) { viewportWidth = this.viewportWidth; }
	        if (viewportHeight === undefined) { viewportHeight = this.viewportHeight; }
	
	        var zoom = this.zoom;
	
	        this.up.set(0, (yDown) ? -1 : 1, 0);
	        this.direction.set(0, 0, (yDown) ? 1 : -1);
	        this.position.set(zoom * viewportWidth / 2, zoom * viewportHeight / 2, 0);
	
	        this.viewportWidth = viewportWidth;
	        this.viewportHeight = viewportHeight;
	
	        return this.update();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.OrthographicCamera#update
	     * @since 3.0.0
	     *
	     * @return {Phaser.Cameras.Sprite3D.OrthographicCamera} [description]
	     */
	    update: function ()
	    {
	        var w = this.viewportWidth;
	        var h = this.viewportHeight;
	        var near = Math.abs(this.near);
	        var far = Math.abs(this.far);
	        var zoom = this.zoom;
	
	        if (w === 0 || h === 0)
	        {
	            //  What to do here... hmm?
	            return this;
	        }
	
	        this.projection.ortho(
	            zoom * -w / 2, zoom * w / 2,
	            zoom * -h / 2, zoom * h / 2,
	            near,
	            far
	        );
	
	        //  Build the view matrix
	        tmpVec3.copy(this.position).add(this.direction);
	
	        this.view.lookAt(this.position, tmpVec3, this.up);
	
	        //  Projection * view matrix
	        this.combined.copy(this.projection).multiply(this.view);
	
	        //  Invert combined matrix, used for unproject
	        this.invProjectionView.copy(this.combined).invert();
	
	        this.billboardMatrixDirty = true;
	
	        this.updateChildren();
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Cameras.Sprite3D.OrthographicCamera#zoom
	     * @type {number}
	     * @since 3.0.0
	     */
	    zoom: {
	
	        get: function ()
	        {
	            return this._zoom;
	        },
	
	        set: function (value)
	        {
	            this._zoom = value;
	            this.update();
	        }
	    }
	
	});
	
	module.exports = OrthographicCamera;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Camera = __webpack_require__(265);
	var Class = __webpack_require__(1);
	var Vector3 = __webpack_require__(142);
	
	//  Local cache vars
	var tmpVec3 = new Vector3();
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class PerspectiveCamera
	 * @extends Phaser.Cameras.Sprite3D.Camera
	 * @memberOf Phaser.Cameras.Sprite3D
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - [description]
	 * @param {integer} [fieldOfView=80] - [description]
	 * @param {integer} [viewportWidth=0] - [description]
	 * @param {integer} [viewportHeight=0] - [description]
	 */
	var PerspectiveCamera = new Class({
	
	    Extends: Camera,
	
	    //  FOV is converted to radians automatically
	    initialize:
	
	    function PerspectiveCamera (scene, fieldOfView, viewportWidth, viewportHeight)
	    {
	        if (fieldOfView === undefined) { fieldOfView = 80; }
	        if (viewportWidth === undefined) { viewportWidth = 0; }
	        if (viewportHeight === undefined) { viewportHeight = 0; }
	
	        Camera.call(this, scene);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D.PerspectiveCamera#viewportWidth
	         * @type {integer}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.viewportWidth = viewportWidth;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D.PerspectiveCamera#viewportHeight
	         * @type {integer}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.viewportHeight = viewportHeight;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D.PerspectiveCamera#fieldOfView
	         * @type {integer}
	         * @default 80
	         * @since 3.0.0
	         */
	        this.fieldOfView = fieldOfView * Math.PI / 180;
	
	        this.update();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.PerspectiveCamera#setFOV
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.Cameras.Sprite3D.PerspectiveCamera} [description]
	     */
	    setFOV: function (value)
	    {
	        this.fieldOfView = value * Math.PI / 180;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.PerspectiveCamera#update
	     * @since 3.0.0
	     *
	     * @return {Phaser.Cameras.Sprite3D.PerspectiveCamera} [description]
	     */
	    update: function ()
	    {
	        var aspect = this.viewportWidth / this.viewportHeight;
	
	        //  Create a perspective matrix for our camera
	        this.projection.perspective(
	            this.fieldOfView,
	            aspect,
	            Math.abs(this.near),
	            Math.abs(this.far)
	        );
	
	        //  Build the view matrix
	        tmpVec3.copy(this.position).add(this.direction);
	
	        this.view.lookAt(this.position, tmpVec3, this.up);
	
	        //  Projection * view matrix
	        this.combined.copy(this.projection).multiply(this.view);
	
	        //  Invert combined matrix, used for unproject
	        this.invProjectionView.copy(this.combined).invert();
	
	        this.billboardMatrixDirty = true;
	
	        this.updateChildren();
	
	        return this;
	    }
	
	});
	
	module.exports = PerspectiveCamera;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Arne16 = __webpack_require__(453);
	var CanvasPool = __webpack_require__(56);
	var GetValue = __webpack_require__(10);
	
	/**
	 * @callback GenerateTextureRendererCallback
	 *
	 * @param {HTMLCanvasElement} canvas - [description]
	 * @param {CanvasRenderingContext2D} context - [description]
	 */
	
	/**
	 * @typedef {object} GenerateTextureConfig
	 *
	 * @property {array} [data=[]] - [description]
	 * @property {HTMLCanvasElement} [canvas=null] - [description]
	 * @property {Palette} [palette=Arne16] - [description]
	 * @property {number} [pixelWidth=1] - [description]
	 * @property {number} [pixelHeight=1] - [description]
	 * @property {boolean} [resizeCanvas=true] - [description]
	 * @property {boolean} [clearCanvas=true] - [description]
	 * @property {GenerateTextureRendererCallback} [preRender] - [description]
	 * @property {GenerateTextureRendererCallback} [postRender] - [description]
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Create.GenerateTexture
	 * @since 3.0.0
	 *
	 * @param {GenerateTextureConfig} config - [description]
	 *
	 * @return {HTMLCanvasElement} [description]
	 */
	var GenerateTexture = function (config)
	{
	    var data = GetValue(config, 'data', []);
	    var canvas = GetValue(config, 'canvas', null);
	    var palette = GetValue(config, 'palette', Arne16);
	    var pixelWidth = GetValue(config, 'pixelWidth', 1);
	    var pixelHeight = GetValue(config, 'pixelHeight', pixelWidth);
	    var resizeCanvas = GetValue(config, 'resizeCanvas', true);
	    var clearCanvas = GetValue(config, 'clearCanvas', true);
	    var preRender = GetValue(config, 'preRender', null);
	    var postRender = GetValue(config, 'postRender', null);
	
	    var width = Math.floor(Math.abs(data[0].length * pixelWidth));
	    var height = Math.floor(Math.abs(data.length * pixelHeight));
	
	    if (!canvas)
	    {
	        canvas = CanvasPool.create2D(this, width, height);
	        resizeCanvas = false;
	        clearCanvas = false;
	    }
	
	    if (resizeCanvas)
	    {
	        canvas.width = width;
	        canvas.height = height;
	    }
	
	    var ctx = canvas.getContext('2d');
	
	    if (clearCanvas)
	    {
	        ctx.clearRect(0, 0, width, height);
	    }
	
	    //  preRender Callback?
	    if (preRender)
	    {
	        preRender(canvas, ctx);
	    }
	
	    //  Draw it
	    for (var y = 0; y < data.length; y++)
	    {
	        var row = data[y];
	
	        for (var x = 0; x < row.length; x++)
	        {
	            var d = row[x];
	
	            if (d !== '.' && d !== ' ')
	            {
	                ctx.fillStyle = palette[d];
	                ctx.fillRect(x * pixelWidth, y * pixelHeight, pixelWidth, pixelHeight);
	            }
	        }
	    }
	
	    //  postRender Callback?
	    if (postRender)
	    {
	        postRender(canvas, ctx);
	    }
	
	    return canvas;
	};
	
	module.exports = GenerateTexture;


/***/ }),
/* 453 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * A 16 color palette by [Arne](http://androidarts.com/palette/16pal.htm)
	 *
	 * @name Phaser.Create.Palettes.ARNE16
	 * @since 3.0.0
	 *
	 * @type {Palette}
	 */
	module.exports = {
	    0: '#000',
	    1: '#9D9D9D',
	    2: '#FFF',
	    3: '#BE2633',
	    4: '#E06F8B',
	    5: '#493C2B',
	    6: '#A46422',
	    7: '#EB8931',
	    8: '#F7E26B',
	    9: '#2F484E',
	    A: '#44891A',
	    B: '#A3CE27',
	    C: '#1B2632',
	    D: '#005784',
	    E: '#31A2F2',
	    F: '#B2DCEF'
	};


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
	
	var Class = __webpack_require__(1);
	var CubicBezier = __webpack_require__(576);
	var Curve = __webpack_require__(133);
	var Vector2 = __webpack_require__(9);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class CubicBezierCurve
	 * @extends Phaser.Curves.Curve
	 * @memberOf Phaser.Curves
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {(Phaser.Math.Vector2|Phaser.Math.Vector2[])} p0 - Start point, or an array of point pairs.
	 * @param {Phaser.Math.Vector2} p1 - Control Point 1.
	 * @param {Phaser.Math.Vector2} p2 - Control Point 2.
	 * @param {Phaser.Math.Vector2} p3 - End Point.
	 */
	var CubicBezierCurve = new Class({
	
	    Extends: Curve,
	
	    initialize:
	
	    function CubicBezierCurve (p0, p1, p2, p3)
	    {
	        Curve.call(this, 'CubicBezierCurve');
	
	        if (Array.isArray(p0))
	        {
	            p3 = new Vector2(p0[6], p0[7]);
	            p2 = new Vector2(p0[4], p0[5]);
	            p1 = new Vector2(p0[2], p0[3]);
	            p0 = new Vector2(p0[0], p0[1]);
	        }
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.CubicBezierCurve#p0
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.p0 = p0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.CubicBezierCurve#p1
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.p1 = p1;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.CubicBezierCurve#p2
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.p2 = p2;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.CubicBezierCurve#p3
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.p3 = p3;
	    },
	
	    /**
	     * Gets the starting point on the curve.
	     *
	     * @method Phaser.Curves.CubicBezierCurve#getStartPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
	     *
	     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
	     */
	    getStartPoint: function (out)
	    {
	        if (out === undefined) { out = new Vector2(); }
	
	        return out.copy(this.p0);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.CubicBezierCurve#getResolution
	     * @since 3.0.0
	     *
	     * @param {number} divisions - The amount of divisions used by this curve.
	     *
	     * @return {number} The resolution of the curve.
	     */
	    getResolution: function (divisions)
	    {
	        return divisions;
	    },
	
	    /**
	     * Get point at relative position in curve according to length.
	     *
	     * @method Phaser.Curves.CubicBezierCurve#getPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {float} t - The position along the curve to return. Where 0 is the start and 1 is the end.
	     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
	     *
	     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
	     */
	    getPoint: function (t, out)
	    {
	        if (out === undefined) { out = new Vector2(); }
	
	        var p0 = this.p0;
	        var p1 = this.p1;
	        var p2 = this.p2;
	        var p3 = this.p3;
	
	        return out.set(CubicBezier(t, p0.x, p1.x, p2.x, p3.x), CubicBezier(t, p0.y, p1.y, p2.y, p3.y));
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.CubicBezierCurve#draw
	     * @since 3.0.0
	     *
	     * @generic {Phaser.GameObjects.Graphics} G - [graphics,$return]
	     *
	     * @param {Phaser.GameObjects.Graphics} graphics - [description]
	     * @param {integer} [pointsTotal=32] - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} [description]
	     */
	    draw: function (graphics, pointsTotal)
	    {
	        if (pointsTotal === undefined) { pointsTotal = 32; }
	
	        var points = this.getPoints(pointsTotal);
	
	        graphics.beginPath();
	        graphics.moveTo(this.p0.x, this.p0.y);
	
	        for (var i = 1; i < points.length; i++)
	        {
	            graphics.lineTo(points[i].x, points[i].y);
	        }
	
	        graphics.strokePath();
	
	        //  So you can chain graphics calls
	        return graphics;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.CubicBezierCurve#toJSON
	     * @since 3.0.0
	     *
	     * @return {JSONCurve} The JSON object containing this curve data.
	     */
	    toJSON: function ()
	    {
	        return {
	            type: this.type,
	            points: [
	                this.p0.x, this.p0.y,
	                this.p1.x, this.p1.y,
	                this.p2.x, this.p2.y,
	                this.p3.x, this.p3.y
	            ]
	        };
	    }
	
	});
	
	/**
	 * [description]
	 *
	 * @function Phaser.Curves.CubicBezierCurve.fromJSON
	 * @since 3.0.0
	 *
	 * @param {JSONCurve} data - The JSON object containing this curve data.
	 *
	 * @return {Phaser.Curves.CubicBezierCurve} [description]
	 */
	CubicBezierCurve.fromJSON = function (data)
	{
	    var points = data.points;
	
	    var p0 = new Vector2(points[0], points[1]);
	    var p1 = new Vector2(points[2], points[3]);
	    var p2 = new Vector2(points[4], points[5]);
	    var p3 = new Vector2(points[6], points[7]);
	
	    return new CubicBezierCurve(p0, p1, p2, p3);
	};
	
	module.exports = CubicBezierCurve;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
	
	var Class = __webpack_require__(1);
	var Curve = __webpack_require__(133);
	var DegToRad = __webpack_require__(97);
	var GetValue = __webpack_require__(10);
	var RadToDeg = __webpack_require__(308);
	var Vector2 = __webpack_require__(9);
	
	/**
	 * @typedef {object} JSONEllipseCurve
	 *
	 * @property {string} type - The of the curve.
	 * @property {number} x - [description]
	 * @property {number} y - [description]
	 * @property {number} xRadius - The horizontal radius of ellipse.
	 * @property {number} yRadius - The vertical radius of ellipse.
	 * @property {integer} startAngle - The start angle of ellipse.
	 * @property {integer} endAngle - The end angle of ellipse.
	 * @property {boolean} clockwise - The clockwise of ellipse.
	 * @property {integer} rotation - The rotation of ellipse.
	 */
	
	/**
	 * @typedef {object} EllipseCurveConfig
	 *
	 * @property {number} [x=0] - [description]
	 * @property {number} [y=0] - [description]
	 * @property {number} [xRadius=0] - [description]
	 * @property {number} [yRadius=0] - [description]
	 * @property {integer} [startAngle=0] - [description]
	 * @property {integer} [endAngle=360] - [description]
	 * @property {boolean} [clockwise=false] - [description]
	 * @property {integer} [rotation=0] - [description]
	  */
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class EllipseCurve
	 * @extends Phaser.Curves.Curve
	 * @memberOf Phaser.Curves
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {(number|EllipseCurveConfig)} [x=0] - [description]
	 * @param {number} [y=0] - [description]
	 * @param {number} [xRadius=0] - [description]
	 * @param {number} [yRadius=0] - [description]
	 * @param {integer} [startAngle=0] - [description]
	 * @param {integer} [endAngle=360] - [description]
	 * @param {boolean} [clockwise=false] - [description]
	 * @param {integer} [rotation=0] - [description]
	 */
	var EllipseCurve = new Class({
	
	    Extends: Curve,
	
	    initialize:
	
	    function EllipseCurve (x, y, xRadius, yRadius, startAngle, endAngle, clockwise, rotation)
	    {
	        if (typeof x === 'object')
	        {
	            var config = x;
	
	            x = GetValue(config, 'x', 0);
	            y = GetValue(config, 'y', 0);
	            xRadius = GetValue(config, 'xRadius', 0);
	            yRadius = GetValue(config, 'yRadius', xRadius);
	            startAngle = GetValue(config, 'startAngle', 0);
	            endAngle = GetValue(config, 'endAngle', 360);
	            clockwise = GetValue(config, 'clockwise', false);
	            rotation = GetValue(config, 'rotation', 0);
	        }
	        else
	        {
	            if (yRadius === undefined) { yRadius = xRadius; }
	            if (startAngle === undefined) { startAngle = 0; }
	            if (endAngle === undefined) { endAngle = 360; }
	            if (clockwise === undefined) { clockwise = false; }
	            if (rotation === undefined) { rotation = 0; }
	        }
	
	        Curve.call(this, 'EllipseCurve');
	
	        //  Center point
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.EllipseCurve#p0
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.p0 = new Vector2(x, y);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.EllipseCurve#_xRadius
	         * @type {number}
	         * @private
	         * @since 3.0.0
	         */
	        this._xRadius = xRadius;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.EllipseCurve#_yRadius
	         * @type {number}
	         * @private
	         * @since 3.0.0
	         */
	        this._yRadius = yRadius;
	
	        //  Radians
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.EllipseCurve#_startAngle
	         * @type {number}
	         * @private
	         * @since 3.0.0
	         */
	        this._startAngle = DegToRad(startAngle);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.EllipseCurve#_endAngle
	         * @type {number}
	         * @private
	         * @since 3.0.0
	         */
	        this._endAngle = DegToRad(endAngle);
	
	        /**
	         * Anti-clockwise direction.
	         *
	         * @name Phaser.Curves.EllipseCurve#_clockwise
	         * @type {boolean}
	         * @private
	         * @since 3.0.0
	         */
	        this._clockwise = clockwise;
	
	        /**
	         * The rotation of the arc.
	         *
	         * @name Phaser.Curves.EllipseCurve#_rotation
	         * @type {number}
	         * @private
	         * @since 3.0.0
	         */
	        this._rotation = DegToRad(rotation);
	    },
	
	    /**
	     * Gets the starting point on the curve.
	     *
	     * @method Phaser.Curves.EllipseCurve#getStartPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
	     *
	     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
	     */
	    getStartPoint: function (out)
	    {
	        if (out === undefined) { out = new Vector2(); }
	
	        return this.getPoint(0, out);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.EllipseCurve#getResolution
	     * @since 3.0.0
	     *
	     * @param {number} divisions - [description]
	     *
	     * @return {number} [description]
	     */
	    getResolution: function (divisions)
	    {
	        return divisions * 2;
	    },
	
	    /**
	     * Get point at relative position in curve according to length.
	     *
	     * @method Phaser.Curves.EllipseCurve#getPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {float} t - The position along the curve to return. Where 0 is the start and 1 is the end.
	     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
	     *
	     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
	     */
	    getPoint: function (t, out)
	    {
	        if (out === undefined) { out = new Vector2(); }
	
	        var twoPi = Math.PI * 2;
	        var deltaAngle = this._endAngle - this._startAngle;
	        var samePoints = Math.abs(deltaAngle) < Number.EPSILON;
	
	        // ensures that deltaAngle is 0 .. 2 PI
	        while (deltaAngle < 0)
	        {
	            deltaAngle += twoPi;
	        }
	
	        while (deltaAngle > twoPi)
	        {
	            deltaAngle -= twoPi;
	        }
	
	        if (deltaAngle < Number.EPSILON)
	        {
	            if (samePoints)
	            {
	                deltaAngle = 0;
	            }
	            else
	            {
	                deltaAngle = twoPi;
	            }
	        }
	
	        if (this._clockwise && !samePoints)
	        {
	            if (deltaAngle === twoPi)
	            {
	                deltaAngle = - twoPi;
	            }
	            else
	            {
	                deltaAngle = deltaAngle - twoPi;
	            }
	        }
	
	        var angle = this._startAngle + t * deltaAngle;
	        var x = this.p0.x + this._xRadius * Math.cos(angle);
	        var y = this.p0.y + this._yRadius * Math.sin(angle);
	
	        if (this._rotation !== 0)
	        {
	            var cos = Math.cos(this._rotation);
	            var sin = Math.sin(this._rotation);
	
	            var tx = x - this.p0.x;
	            var ty = y - this.p0.y;
	
	            // Rotate the point about the center of the ellipse.
	            x = tx * cos - ty * sin + this.p0.x;
	            y = tx * sin + ty * cos + this.p0.y;
	        }
	
	        return out.set(x, y);
	    },
	
	    /**
	     * Sets the horizontal radius of this curve.
	     *
	     * @method Phaser.Curves.EllipseCurve#setXRadius
	     * @since 3.0.0
	     *
	     * @param {number} value - The horizontal radius of this curve.
	     *
	     * @return {Phaser.Curves.EllipseCurve} This curve object.
	     */
	    setXRadius: function (value)
	    {
	        this.xRadius = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the vertical radius of this curve.
	     *
	     * @method Phaser.Curves.EllipseCurve#setYRadius
	     * @since 3.0.0
	     *
	     * @param {number} value - The vertical radius of this curve.
	     *
	     * @return {Phaser.Curves.EllipseCurve} This curve object.
	     */
	    setYRadius: function (value)
	    {
	        this.yRadius = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the width of this curve.
	     *
	     * @method Phaser.Curves.EllipseCurve#setWidth
	     * @since 3.0.0
	     *
	     * @param {number} value - The width of this curve.
	     *
	     * @return {Phaser.Curves.EllipseCurve} This curve object.
	     */
	    setWidth: function (value)
	    {
	        this.xRadius = value * 2;
	
	        return this;
	    },
	
	    /**
	     * Sets the height of this curve.
	     *
	     * @method Phaser.Curves.EllipseCurve#setHeight
	     * @since 3.0.0
	     *
	     * @param {number} value - The height of this curve.
	     *
	     * @return {Phaser.Curves.EllipseCurve} This curve object.
	     */
	    setHeight: function (value)
	    {
	        this.yRadius = value * 2;
	
	        return this;
	    },
	
	    /**
	     * Sets the start angle of this curve.
	     *
	     * @method Phaser.Curves.EllipseCurve#setStartAngle
	     * @since 3.0.0
	     *
	     * @param {number} value - The start angle of this curve, in radians.
	     *
	     * @return {Phaser.Curves.EllipseCurve} This curve object.
	     */
	    setStartAngle: function (value)
	    {
	        this.startAngle = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the end angle of this curve.
	     *
	     * @method Phaser.Curves.EllipseCurve#setEndAngle
	     * @since 3.0.0
	     *
	     * @param {number} value - The end angle of this curve, in radians.
	     *
	     * @return {Phaser.Curves.EllipseCurve} This curve object.
	     */
	    setEndAngle: function (value)
	    {
	        this.endAngle = value;
	
	        return this;
	    },
	
	    /**
	     * Sets if this curve extends clockwise or anti-clockwise.
	     *
	     * @method Phaser.Curves.EllipseCurve#setClockwise
	     * @since 3.0.0
	     *
	     * @param {boolean} value - The clockwise state of this curve.
	     *
	     * @return {Phaser.Curves.EllipseCurve} This curve object.
	     */
	    setClockwise: function (value)
	    {
	        this.clockwise = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the rotation of this curve.
	     *
	     * @method Phaser.Curves.EllipseCurve#setRotation
	     * @since 3.0.0
	     *
	     * @param {number} value - The rotation of this curve, in radians.
	     *
	     * @return {Phaser.Curves.EllipseCurve} This curve object.
	     */
	    setRotation: function (value)
	    {
	        this.rotation = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Curves.EllipseCurve#x
	     * @type {number}
	     * @since 3.0.0
	     */
	    x: {
	
	        get: function ()
	        {
	            return this.p0.x;
	        },
	
	        set: function (value)
	        {
	            this.p0.x = value;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Curves.EllipseCurve#y
	     * @type {number}
	     * @since 3.0.0
	     */
	    y: {
	
	        get: function ()
	        {
	            return this.p0.y;
	        },
	
	        set: function (value)
	        {
	            this.p0.y = value;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Curves.EllipseCurve#xRadius
	     * @type {number}
	     * @since 3.0.0
	     */
	    xRadius: {
	
	        get: function ()
	        {
	            return this._xRadius;
	        },
	
	        set: function (value)
	        {
	            this._xRadius = value;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Curves.EllipseCurve#yRadius
	     * @type {number}
	     * @since 3.0.0
	     */
	    yRadius: {
	
	        get: function ()
	        {
	            return this._yRadius;
	        },
	
	        set: function (value)
	        {
	            this._yRadius = value;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Curves.EllipseCurve#startAngle
	     * @type {number}
	     * @since 3.0.0
	     */
	    startAngle: {
	
	        get: function ()
	        {
	            return RadToDeg(this._startAngle);
	        },
	
	        set: function (value)
	        {
	            this._startAngle = DegToRad(value);
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Curves.EllipseCurve#endAngle
	     * @type {number}
	     * @since 3.0.0
	     */
	    endAngle: {
	
	        get: function ()
	        {
	            return RadToDeg(this._endAngle);
	        },
	
	        set: function (value)
	        {
	            this._endAngle = DegToRad(value);
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Curves.EllipseCurve#clockwise
	     * @type {boolean}
	     * @since 3.0.0
	     */
	    clockwise: {
	
	        get: function ()
	        {
	            return this._clockwise;
	        },
	
	        set: function (value)
	        {
	            this._clockwise = value;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Curves.EllipseCurve#rotation
	     * @type {number}
	     * @since 3.0.0
	     */
	    rotation: {
	
	        get: function ()
	        {
	            return this._rotation;
	        },
	
	        set: function (value)
	        {
	            this._rotation = DegToRad(value);
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.EllipseCurve#toJSON
	     * @since 3.0.0
	     *
	     * @return {JSONEllipseCurve} The JSON object containing this curve data.
	     */
	    toJSON: function ()
	    {
	        return {
	            type: this.type,
	            x: this.p0.x,
	            y: this.p0.y,
	            xRadius: this._xRadius,
	            yRadius: this._yRadius,
	            startAngle: RadToDeg(this._startAngle),
	            endAngle: RadToDeg(this._endAngle),
	            clockwise: this._clockwise,
	            rotation: RadToDeg(this._rotation)
	        };
	    }
	
	});
	
	/**
	 * [description]
	 *
	 * @function Phaser.Curves.EllipseCurve.fromJSON
	 * @since 3.0.0
	 *
	 * @param {JSONEllipseCurve} data - The JSON object containing this curve data.
	 *
	 * @return {Phaser.Curves.EllipseCurve} [description]
	 */
	EllipseCurve.fromJSON = function (data)
	{
	    return new EllipseCurve(data);
	};
	
	module.exports = EllipseCurve;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
	
	var Class = __webpack_require__(1);
	var Curve = __webpack_require__(133);
	var FromPoints = __webpack_require__(294);
	var Rectangle = __webpack_require__(23);
	var Vector2 = __webpack_require__(9);
	
	var tmpVec2 = new Vector2();
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class LineCurve
	 * @extends Phaser.Curves.Curve
	 * @memberOf Phaser.Curves
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {(Phaser.Math.Vector2|number[])} p0 - [description]
	 * @param {Phaser.Math.Vector2} [p1] - [description]
	 */
	var LineCurve = new Class({
	
	    Extends: Curve,
	
	    initialize:
	
	    //  vec2s or array
	    function LineCurve (p0, p1)
	    {
	        Curve.call(this, 'LineCurve');
	
	        if (Array.isArray(p0))
	        {
	            p1 = new Vector2(p0[2], p0[3]);
	            p0 = new Vector2(p0[0], p0[1]);
	        }
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.LineCurve#p0
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.p0 = p0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.LineCurve#p1
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.p1 = p1;
	    },
	
	    /**
	     * Returns a Rectangle where the position and dimensions match the bounds of this Curve.
	     *
	     * @method Phaser.Curves.LineCurve#getBounds
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Rectangle} O - [out,$return]
	     *
	     * @param {Phaser.Geom.Rectangle} [out] - A Rectangle object to store the bounds in. If not given a new Rectangle will be created.
	     *
	     * @return {Phaser.Geom.Rectangle} A Rectangle object holding the bounds of this curve. If `out` was given it will be this object.
	     */
	    getBounds: function (out)
	    {
	        if (out === undefined) { out = new Rectangle(); }
	
	        return FromPoints([ this.p0, this.p1 ], out);
	    },
	
	    /**
	     * Gets the starting point on the curve.
	     *
	     * @method Phaser.Curves.LineCurve#getStartPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
	     *
	     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
	     */
	    getStartPoint: function (out)
	    {
	        if (out === undefined) { out = new Vector2(); }
	
	        return out.copy(this.p0);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.LineCurve#getResolution
	     * @since 3.0.0
	     *
	     * @param {number} [divisions=1] - [description]
	     *
	     * @return {number} [description]
	     */
	    getResolution: function (divisions)
	    {
	        if (divisions === undefined) { divisions = 1; }
	
	        return divisions;
	    },
	
	    /**
	     * Get point at relative position in curve according to length.
	     *
	     * @method Phaser.Curves.LineCurve#getPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {float} t - The position along the curve to return. Where 0 is the start and 1 is the end.
	     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
	     *
	     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
	     */
	    getPoint: function (t, out)
	    {
	        if (out === undefined) { out = new Vector2(); }
	
	        if (t === 1)
	        {
	            return out.copy(this.p1);
	        }
	
	        out.copy(this.p1).subtract(this.p0).scale(t).add(this.p0);
	
	        return out;
	    },
	
	    // Line curve is linear, so we can overwrite default getPointAt
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.LineCurve#getPointAt
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {float} u - The position along the curve to return. Where 0 is the start and 1 is the end.
	     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
	     *
	     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
	     */
	    getPointAt: function (u, out)
	    {
	        return this.getPoint(u, out);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.LineCurve#getTangent
	     * @since 3.0.0
	     * 
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @return {Phaser.Math.Vector2} [description]
	     */
	    getTangent: function ()
	    {
	        var tangent = tmpVec2.copy(this.p1).subtract(this.p0);
	
	        return tangent.normalize();
	    },
	
	    //  Override default Curve.draw because this is better than calling getPoints on a line!
	
	    /**
	     * Draws this curve on the given Graphics object.
	     *
	     * The curve is drawn using `Graphics.lineBetween` so will be drawn at whatever the present Graphics line color is.
	     * The Graphics object is not cleared before the draw, so the curve will appear on-top of anything else already rendered to it.
	     *
	     * @method Phaser.Curves.LineCurve#draw
	     * @since 3.0.0
	     *
	     * @generic {Phaser.GameObjects.Graphics} G - [graphics,$return]
	     *
	     * @param {Phaser.GameObjects.Graphics} graphics - The Graphics instance onto which this curve will be drawn.
	     *
	     * @return {Phaser.GameObjects.Graphics} The Graphics object to which the curve was drawn.
	     */
	    draw: function (graphics)
	    {
	        graphics.lineBetween(this.p0.x, this.p0.y, this.p1.x, this.p1.y);
	
	        //  So you can chain graphics calls
	        return graphics;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.LineCurve#toJSON
	     * @since 3.0.0
	     *
	     * @return {JSONCurve} The JSON object containing this curve data.
	     */
	    toJSON: function ()
	    {
	        return {
	            type: this.type,
	            points: [
	                this.p0.x, this.p0.y,
	                this.p1.x, this.p1.y
	            ]
	        };
	    }
	
	});
	
	/**
	 * [description]
	 *
	 * @function Phaser.Curves.LineCurve.fromJSON
	 * @since 3.0.0
	 *
	 * @param {JSONCurve} data - The JSON object containing this curve data.
	 *
	 * @return {Phaser.Curves.LineCurve} [description]
	 */
	LineCurve.fromJSON = function (data)
	{
	    var points = data.points;
	
	    var p0 = new Vector2(points[0], points[1]);
	    var p1 = new Vector2(points[2], points[3]);
	
	    return new LineCurve(p0, p1);
	};
	
	module.exports = LineCurve;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Curve = __webpack_require__(133);
	var QuadraticBezierInterpolation = __webpack_require__(577);
	var Vector2 = __webpack_require__(9);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class QuadraticBezier
	 * @extends Phaser.Curves.Curve
	 * @memberOf Phaser.Curves
	 * @constructor
	 * @since 3.2.0
	 *
	 * @param {(Phaser.Math.Vector2|number[])} p0 - Start point, or an array of point pairs.
	 * @param {Phaser.Math.Vector2} p1 - Control Point 1.
	 * @param {Phaser.Math.Vector2} p2 - Control Point 2.
	 */
	var QuadraticBezier = new Class({
	
	    Extends: Curve,
	
	    initialize:
	
	    function QuadraticBezier (p0, p1, p2)
	    {
	        Curve.call(this, 'QuadraticBezier');
	
	        if (Array.isArray(p0))
	        {
	            p2 = new Vector2(p0[4], p0[5]);
	            p1 = new Vector2(p0[2], p0[3]);
	            p0 = new Vector2(p0[0], p0[1]);
	        }
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.QuadraticBezier#p0
	         * @type {Phaser.Math.Vector2}
	         * @since 3.2.0
	         */
	        this.p0 = p0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.QuadraticBezier#p1
	         * @type {Phaser.Math.Vector2}
	         * @since 3.2.0
	         */
	        this.p1 = p1;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.QuadraticBezier#p2
	         * @type {Phaser.Math.Vector2}
	         * @since 3.2.0
	         */
	        this.p2 = p2;
	    },
	
	    /**
	     * Gets the starting point on the curve.
	     *
	     * @method Phaser.Curves.QuadraticBezier#getStartPoint
	     * @since 3.2.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
	     *
	     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
	     */
	    getStartPoint: function (out)
	    {
	        if (out === undefined) { out = new Vector2(); }
	
	        return out.copy(this.p0);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.QuadraticBezier#getResolution
	     * @since 3.2.0
	     *
	     * @param {number} divisions - [description]
	     *
	     * @return {number} [description]
	     */
	    getResolution: function (divisions)
	    {
	        return divisions;
	    },
	
	    /**
	     * Get point at relative position in curve according to length.
	     *
	     * @method Phaser.Curves.QuadraticBezier#getPoint
	     * @since 3.2.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {float} t - The position along the curve to return. Where 0 is the start and 1 is the end.
	     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
	     *
	     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
	     */
	    getPoint: function (t, out)
	    {
	        if (out === undefined) { out = new Vector2(); }
	
	        var p0 = this.p0;
	        var p1 = this.p1;
	        var p2 = this.p2;
	
	        return out.set(
	            QuadraticBezierInterpolation(t, p0.x, p1.x, p2.x),
	            QuadraticBezierInterpolation(t, p0.y, p1.y, p2.y)
	        );
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.QuadraticBezier#draw
	     * @since 3.2.0
	     *
	     * @generic {Phaser.GameObjects.Graphics} G - [graphics,$return]
	     *
	     * @param {Phaser.GameObjects.Graphics} graphics - [description]
	     * @param {integer} [pointsTotal=32] - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} [description]
	     */
	    draw: function (graphics, pointsTotal)
	    {
	        if (pointsTotal === undefined) { pointsTotal = 32; }
	
	        var points = this.getPoints(pointsTotal);
	
	        graphics.beginPath();
	        graphics.moveTo(this.p0.x, this.p0.y);
	
	        for (var i = 1; i < points.length; i++)
	        {
	            graphics.lineTo(points[i].x, points[i].y);
	        }
	
	        graphics.strokePath();
	
	        //  So you can chain graphics calls
	        return graphics;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.QuadraticBezier#toJSON
	     * @since 3.2.0
	     *
	     * @return {JSONCurve} The JSON object containing this curve data.
	     */
	    toJSON: function ()
	    {
	        return {
	            type: this.type,
	            points: [
	                this.p0.x, this.p0.y,
	                this.p1.x, this.p1.y,
	                this.p2.x, this.p2.y
	            ]
	        };
	    }
	
	});
	
	/**
	 * [description]
	 *
	 * @function Phaser.Curves.QuadraticBezier.fromJSON
	 * @since 3.2.0
	 *
	 * @param {JSONCurve} data - The JSON object containing this curve data.
	 *
	 * @return {Phaser.Curves.QuadraticBezier} [description]
	 */
	QuadraticBezier.fromJSON = function (data)
	{
	    var points = data.points;
	
	    var p0 = new Vector2(points[0], points[1]);
	    var p1 = new Vector2(points[2], points[3]);
	    var p2 = new Vector2(points[4], points[5]);
	
	    return new QuadraticBezier(p0, p1, p2);
	};
	
	module.exports = QuadraticBezier;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
	
	var CatmullRom = __webpack_require__(305);
	var Class = __webpack_require__(1);
	var Curve = __webpack_require__(133);
	var Vector2 = __webpack_require__(9);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class SplineCurve
	 * @extends Phaser.Curves.Curve
	 * @memberOf Phaser.Curves
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Math.Vector2[]} [points] - [description]
	 */
	var SplineCurve = new Class({
	
	    Extends: Curve,
	
	    initialize:
	
	    function SplineCurve (points)
	    {
	        if (points === undefined) { points = []; }
	
	        Curve.call(this, 'SplineCurve');
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.SplineCurve#points
	         * @type {Phaser.Math.Vector2[]}
	         * @default []
	         * @since 3.0.0
	         */
	        this.points = [];
	
	        this.addPoints(points);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.SplineCurve#addPoints
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Vector2[]|number[]|number[][])} points - [description]
	     *
	     * @return {Phaser.Curves.SplineCurve} This curve object.
	     */
	    addPoints: function (points)
	    {
	        for (var i = 0; i < points.length; i++)
	        {
	            var p = new Vector2();
	
	            if (typeof points[i] === 'number')
	            {
	                p.x = points[i];
	                p.y = points[i + 1];
	                i++;
	            }
	            else if (Array.isArray(points[i]))
	            {
	                //  An array of arrays?
	                p.x = points[i][0];
	                p.y = points[i][1];
	            }
	            else
	            {
	                p.x = points[i].x;
	                p.y = points[i].y;
	            }
	
	            this.points.push(p);
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.SplineCurve#addPoint
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     *
	     * @return {Phaser.Math.Vector2} [description]
	     */
	    addPoint: function (x, y)
	    {
	        var vec = new Vector2(x, y);
	
	        this.points.push(vec);
	
	        return vec;
	    },
	
	    /**
	     * Gets the starting point on the curve.
	     *
	     * @method Phaser.Curves.SplineCurve#getStartPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
	     *
	     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
	     */
	    getStartPoint: function (out)
	    {
	        if (out === undefined) { out = new Vector2(); }
	
	        return out.copy(this.points[0]);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.SplineCurve#getResolution
	     * @since 3.0.0
	     *
	     * @param {number} divisions - [description]
	     *
	     * @return {number} [description]
	     */
	    getResolution: function (divisions)
	    {
	        return divisions * this.points.length;
	    },
	
	    /**
	     * Get point at relative position in curve according to length.
	     *
	     * @method Phaser.Curves.SplineCurve#getPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {float} t - The position along the curve to return. Where 0 is the start and 1 is the end.
	     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
	     *
	     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
	     */
	    getPoint: function (t, out)
	    {
	        if (out === undefined) { out = new Vector2(); }
	
	        var points = this.points;
	
	        var point = (points.length - 1) * t;
	
	        var intPoint = Math.floor(point);
	
	        var weight = point - intPoint;
	
	        var p0 = points[(intPoint === 0) ? intPoint : intPoint - 1];
	        var p1 = points[intPoint];
	        var p2 = points[(intPoint > points.length - 2) ? points.length - 1 : intPoint + 1];
	        var p3 = points[(intPoint > points.length - 3) ? points.length - 1 : intPoint + 2];
	
	        return out.set(CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.SplineCurve#toJSON
	     * @since 3.0.0
	     *
	     * @return {JSONCurve} The JSON object containing this curve data.
	     */
	    toJSON: function ()
	    {
	        var points = [];
	
	        for (var i = 0; i < this.points.length; i++)
	        {
	            points.push(this.points[i].x);
	            points.push(this.points[i].y);
	        }
	
	        return {
	            type: this.type,
	            points: points
	        };
	    }
	
	});
	
	/**
	 * [description]
	 *
	 * @function Phaser.Curves.SplineCurve.fromJSON
	 * @since 3.0.0
	 *
	 * @param {JSONCurve} data - The JSON object containing this curve data.
	 *
	 * @return {Phaser.Curves.SplineCurve} [description]
	 */
	SplineCurve.fromJSON = function (data)
	{
	    return new SplineCurve(data.points);
	};
	
	module.exports = SplineCurve;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CanvasPool = __webpack_require__(56);
	
	/**
	 * Determines the canvas features of the browser running this Phaser Game instance.
	 * These values are read-only and populated during the boot sequence of the game.
	 * They are then referenced by internal game systems and are available for you to access
	 * via `this.sys.game.device.canvasFeatures` from within any Scene.
	 * 
	 * @typedef {object} Phaser.Device.CanvasFeatures
	 * @since 3.0.0
	 * 
	 * @property {boolean} supportInverseAlpha - Set to true if the browser supports inversed alpha.
	 * @property {boolean} supportNewBlendModes - Set to true if the browser supports new canvas blend modes.
	 */
	var CanvasFeatures = {
	
	    supportInverseAlpha: false,
	    supportNewBlendModes: false
	
	};
	
	function checkBlendMode ()
	{
	    var pngHead = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAABAQMAAADD8p2OAAAAA1BMVEX/';
	    var pngEnd = 'AAAACklEQVQI12NgAAAAAgAB4iG8MwAAAABJRU5ErkJggg==';
	
	    var magenta = new Image();
	
	    magenta.onload = function ()
	    {
	        var yellow = new Image();
	
	        yellow.onload = function ()
	        {
	            var canvas = CanvasPool.create(yellow, 6, 1);
	            var context = canvas.getContext('2d');
	
	            context.globalCompositeOperation = 'multiply';
	
	            context.drawImage(magenta, 0, 0);
	            context.drawImage(yellow, 2, 0);
	
	            if (!context.getImageData(2, 0, 1, 1))
	            {
	                return false;
	            }
	
	            var data = context.getImageData(2, 0, 1, 1).data;
	
	            CanvasPool.remove(yellow);
	
	            CanvasFeatures.supportNewBlendModes = (data[0] === 255 && data[1] === 0 && data[2] === 0);
	        };
	
	        yellow.src = pngHead + '/wCKxvRF' + pngEnd;
	    };
	
	    magenta.src = pngHead + 'AP804Oa6' + pngEnd;
	
	    return false;
	}
	
	function checkInverseAlpha ()
	{
	    var canvas = CanvasPool.create(this, 2, 1);
	    var context = canvas.getContext('2d');
	
	    context.fillStyle = 'rgba(10, 20, 30, 0.5)';
	
	    //  Draw a single pixel
	    context.fillRect(0, 0, 1, 1);
	
	    //  Get the color values
	    var s1 = context.getImageData(0, 0, 1, 1);
	
	    if (s1 === null)
	    {
	        return false;
	    }
	
	    //  Plot them to x2
	    context.putImageData(s1, 1, 0);
	
	    //  Get those values
	    var s2 = context.getImageData(1, 0, 1, 1);
	
	    //  Compare and return
	    return (s2.data[0] === s1.data[0] && s2.data[1] === s1.data[1] && s2.data[2] === s1.data[2] && s2.data[3] === s1.data[3]);
	}
	
	function init ()
	{
	    if (document !== undefined)
	    {
	        CanvasFeatures.supportNewBlendModes = checkBlendMode();
	        CanvasFeatures.supportInverseAlpha = checkInverseAlpha();
	    }
	
	    return CanvasFeatures;
	}
	
	module.exports = init();


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetBottom = __webpack_require__(74);
	var GetCenterX = __webpack_require__(134);
	var SetBottom = __webpack_require__(78);
	var SetCenterX = __webpack_require__(136);
	
	/**
	 * Takes given Game Object and aligns it so that it is positioned in the bottom center of the other.
	 *
	 * @function Phaser.Display.Align.In.BottomCenter
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
	 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
	 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
	 * @param {number} [offsetY=0] - Optional vertical offset from the position.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
	 */
	var BottomCenter = function (gameObject, alignIn, offsetX, offsetY)
	{
	    if (offsetX === undefined) { offsetX = 0; }
	    if (offsetY === undefined) { offsetY = 0; }
	
	    SetCenterX(gameObject, GetCenterX(alignIn) + offsetX);
	    SetBottom(gameObject, GetBottom(alignIn) + offsetY);
	
	    return gameObject;
	};
	
	module.exports = BottomCenter;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetBottom = __webpack_require__(74);
	var GetLeft = __webpack_require__(75);
	var SetBottom = __webpack_require__(78);
	var SetLeft = __webpack_require__(79);
	
	/**
	 * Takes given Game Object and aligns it so that it is positioned in the bottom left of the other.
	 *
	 * @function Phaser.Display.Align.In.BottomLeft
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
	 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
	 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
	 * @param {number} [offsetY=0] - Optional vertical offset from the position.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
	 */
	var BottomLeft = function (gameObject, alignIn, offsetX, offsetY)
	{
	    if (offsetX === undefined) { offsetX = 0; }
	    if (offsetY === undefined) { offsetY = 0; }
	
	    SetLeft(gameObject, GetLeft(alignIn) - offsetX);
	    SetBottom(gameObject, GetBottom(alignIn) + offsetY);
	
	    return gameObject;
	};
	
	module.exports = BottomLeft;


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetBottom = __webpack_require__(74);
	var GetRight = __webpack_require__(76);
	var SetBottom = __webpack_require__(78);
	var SetRight = __webpack_require__(80);
	
	/**
	 * Takes given Game Object and aligns it so that it is positioned in the bottom right of the other.
	 *
	 * @function Phaser.Display.Align.In.BottomRight
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
	 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
	 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
	 * @param {number} [offsetY=0] - Optional vertical offset from the position.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
	 */
	var BottomRight = function (gameObject, alignIn, offsetX, offsetY)
	{
	    if (offsetX === undefined) { offsetX = 0; }
	    if (offsetY === undefined) { offsetY = 0; }
	
	    SetRight(gameObject, GetRight(alignIn) + offsetX);
	    SetBottom(gameObject, GetBottom(alignIn) + offsetY);
	
	    return gameObject;
	};
	
	module.exports = BottomRight;


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CenterOn = __webpack_require__(470);
	var GetCenterX = __webpack_require__(134);
	var GetCenterY = __webpack_require__(135);
	
	/**
	 * Takes given Game Object and aligns it so that it is positioned in the center of the other.
	 *
	 * @function Phaser.Display.Align.In.Center
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
	 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
	 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
	 * @param {number} [offsetY=0] - Optional vertical offset from the position.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
	 */
	var Center = function (gameObject, alignIn, offsetX, offsetY)
	{
	    if (offsetX === undefined) { offsetX = 0; }
	    if (offsetY === undefined) { offsetY = 0; }
	
	    CenterOn(gameObject, GetCenterX(alignIn) + offsetX, GetCenterY(alignIn) + offsetY);
	
	    return gameObject;
	};
	
	module.exports = Center;


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetCenterY = __webpack_require__(135);
	var GetLeft = __webpack_require__(75);
	var SetCenterY = __webpack_require__(137);
	var SetLeft = __webpack_require__(79);
	
	/**
	 * Takes given Game Object and aligns it so that it is positioned in the left center of the other.
	 *
	 * @function Phaser.Display.Align.In.LeftCenter
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
	 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
	 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
	 * @param {number} [offsetY=0] - Optional vertical offset from the position.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
	 */
	var LeftCenter = function (gameObject, alignIn, offsetX, offsetY)
	{
	    if (offsetX === undefined) { offsetX = 0; }
	    if (offsetY === undefined) { offsetY = 0; }
	
	    SetLeft(gameObject, GetLeft(alignIn) - offsetX);
	    SetCenterY(gameObject, GetCenterY(alignIn) + offsetY);
	
	    return gameObject;
	};
	
	module.exports = LeftCenter;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var ALIGN_CONST = __webpack_require__(267);
	
	var AlignInMap = [];
	
	AlignInMap[ALIGN_CONST.BOTTOM_CENTER] = __webpack_require__(460);
	AlignInMap[ALIGN_CONST.BOTTOM_LEFT] = __webpack_require__(461);
	AlignInMap[ALIGN_CONST.BOTTOM_RIGHT] = __webpack_require__(462);
	AlignInMap[ALIGN_CONST.CENTER] = __webpack_require__(463);
	AlignInMap[ALIGN_CONST.LEFT_CENTER] = __webpack_require__(464);
	AlignInMap[ALIGN_CONST.RIGHT_CENTER] = __webpack_require__(466);
	AlignInMap[ALIGN_CONST.TOP_CENTER] = __webpack_require__(467);
	AlignInMap[ALIGN_CONST.TOP_LEFT] = __webpack_require__(468);
	AlignInMap[ALIGN_CONST.TOP_RIGHT] = __webpack_require__(469);
	
	/**
	 * Takes given Game Object and aligns it so that it is positioned relative to the other.
	 * The alignment used is based on the `position` argument, which is an `ALIGN_CONST` value, such as `LEFT_CENTER` or `TOP_RIGHT`.
	 *
	 * @function Phaser.Display.Align.In.QuickSet
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [child,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} child - The Game Object that will be positioned.
	 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
	 * @param {integer} position - The position to align the Game Object with. This is an align constant, such as `ALIGN_CONST.LEFT_CENTER`.
	 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
	 * @param {number} [offsetY=0] - Optional vertical offset from the position.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
	 */
	var QuickSet = function (child, alignIn, position, offsetX, offsetY)
	{
	    return AlignInMap[position](child, alignIn, offsetX, offsetY);
	};
	
	module.exports = QuickSet;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetCenterY = __webpack_require__(135);
	var GetRight = __webpack_require__(76);
	var SetCenterY = __webpack_require__(137);
	var SetRight = __webpack_require__(80);
	
	/**
	 * Takes given Game Object and aligns it so that it is positioned in the right center of the other.
	 *
	 * @function Phaser.Display.Align.In.RightCenter
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
	 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
	 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
	 * @param {number} [offsetY=0] - Optional vertical offset from the position.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
	 */
	var RightCenter = function (gameObject, alignIn, offsetX, offsetY)
	{
	    if (offsetX === undefined) { offsetX = 0; }
	    if (offsetY === undefined) { offsetY = 0; }
	
	    SetRight(gameObject, GetRight(alignIn) + offsetX);
	    SetCenterY(gameObject, GetCenterY(alignIn) + offsetY);
	
	    return gameObject;
	};
	
	module.exports = RightCenter;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetCenterX = __webpack_require__(134);
	var GetTop = __webpack_require__(77);
	var SetCenterX = __webpack_require__(136);
	var SetTop = __webpack_require__(81);
	
	/**
	 * Takes given Game Object and aligns it so that it is positioned in the top center of the other.
	 *
	 * @function Phaser.Display.Align.In.TopCenter
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
	 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
	 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
	 * @param {number} [offsetY=0] - Optional vertical offset from the position.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
	 */
	var TopCenter = function (gameObject, alignIn, offsetX, offsetY)
	{
	    if (offsetX === undefined) { offsetX = 0; }
	    if (offsetY === undefined) { offsetY = 0; }
	
	    SetCenterX(gameObject, GetCenterX(alignIn) + offsetX);
	    SetTop(gameObject, GetTop(alignIn) - offsetY);
	
	    return gameObject;
	};
	
	module.exports = TopCenter;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetLeft = __webpack_require__(75);
	var GetTop = __webpack_require__(77);
	var SetLeft = __webpack_require__(79);
	var SetTop = __webpack_require__(81);
	
	/**
	 * Takes given Game Object and aligns it so that it is positioned in the top left of the other.
	 *
	 * @function Phaser.Display.Align.In.TopLeft
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
	 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
	 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
	 * @param {number} [offsetY=0] - Optional vertical offset from the position.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
	 */
	var TopLeft = function (gameObject, alignIn, offsetX, offsetY)
	{
	    if (offsetX === undefined) { offsetX = 0; }
	    if (offsetY === undefined) { offsetY = 0; }
	
	    SetLeft(gameObject, GetLeft(alignIn) - offsetX);
	    SetTop(gameObject, GetTop(alignIn) - offsetY);
	
	    return gameObject;
	};
	
	module.exports = TopLeft;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetRight = __webpack_require__(76);
	var GetTop = __webpack_require__(77);
	var SetRight = __webpack_require__(80);
	var SetTop = __webpack_require__(81);
	
	/**
	 * Takes given Game Object and aligns it so that it is positioned in the top right of the other.
	 *
	 * @function Phaser.Display.Align.In.TopRight
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
	 * @param {Phaser.GameObjects.GameObject} alignIn - The Game Object to base the alignment position on.
	 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
	 * @param {number} [offsetY=0] - Optional vertical offset from the position.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
	 */
	var TopRight = function (gameObject, alignIn, offsetX, offsetY)
	{
	    if (offsetX === undefined) { offsetX = 0; }
	    if (offsetY === undefined) { offsetY = 0; }
	
	    SetRight(gameObject, GetRight(alignIn) + offsetX);
	    SetTop(gameObject, GetTop(alignIn) - offsetY);
	
	    return gameObject;
	};
	
	module.exports = TopRight;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var SetCenterX = __webpack_require__(136);
	var SetCenterY = __webpack_require__(137);
	
	/**
	 * Positions the Game Object so that it is centered on the given coordinates.
	 *
	 * @function Phaser.Display.Bounds.CenterOn
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be re-positioned.
	 * @param {number} x - The horizontal coordinate to position the Game Object on.
	 * @param {number} y - The vertical coordinate to position the Game Object on.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was positioned.
	 */
	var CenterOn = function (gameObject, x, y)
	{
	    SetCenterX(gameObject, x);
	
	    return SetCenterY(gameObject, y);
	};
	
	module.exports = CenterOn;


/***/ }),
/* 471 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Display.Canvas.CanvasInterpolation
	 * @since 3.0.0
	 */
	var CanvasInterpolation = {
	
	    /**
	     * Sets the CSS image-rendering property on the given canvas to be 'crisp' (aka 'optimize contrast' on webkit).
	     *
	     * @function Phaser.Display.Canvas.CanvasInterpolation.setCrisp
	     * @since 3.0.0
	     * 
	     * @param {HTMLCanvasElement} canvas - The canvas object to have the style set on.
	     * 
	     * @return {HTMLCanvasElement} The canvas.
	     */
	    setCrisp: function (canvas)
	    {
	        var types = [ 'optimizeSpeed', 'crisp-edges', '-moz-crisp-edges', '-webkit-optimize-contrast', 'optimize-contrast', 'pixelated' ];
	
	        types.forEach(function (type)
	        {
	            canvas.style['image-rendering'] = type;
	        });
	
	        canvas.style.msInterpolationMode = 'nearest-neighbor';
	
	        return canvas;
	    },
	
	    /**
	     * Sets the CSS image-rendering property on the given canvas to be 'bicubic' (aka 'auto').
	     *
	     * @function Phaser.Display.Canvas.CanvasInterpolation.setBicubic
	     * @since 3.0.0
	     * 
	     * @param {HTMLCanvasElement} canvas - The canvas object to have the style set on.
	     * 
	     * @return {HTMLCanvasElement} The canvas.
	     */
	    setBicubic: function (canvas)
	    {
	        canvas.style['image-rendering'] = 'auto';
	        canvas.style.msInterpolationMode = 'bicubic';
	
	        return canvas;
	    }
	
	};
	
	module.exports = CanvasInterpolation;


/***/ }),
/* 472 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Returns a string containing a hex representation of the given color component.
	 *
	 * @function Phaser.Display.Color.ComponentToHex
	 * @since 3.0.0
	 *
	 * @param {integer} color - The color channel to get the hex value for, must be a value between 0 and 255.
	 *
	 * @return {string} A string of length 2 characters, i.e. 255 = ff, 100 = 64.
	 */
	var ComponentToHex = function (color)
	{
	    var hex = color.toString(16);
	
	    return (hex.length === 1) ? '0' + hex : hex;
	};
	
	module.exports = ComponentToHex;


/***/ }),
/* 473 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Given an alpha and 3 color values this will return an integer representation of it.
	 *
	 * @function Phaser.Display.Color.GetColor32
	 * @since 3.0.0
	 *
	 * @param {integer} red - The red color value. A number between 0 and 255.
	 * @param {integer} green - The green color value. A number between 0 and 255.
	 * @param {integer} blue - The blue color value. A number between 0 and 255.
	 * @param {integer} alpha - The alpha color value. A number between 0 and 255.
	 *
	 * @return {number} The combined color value.
	 */
	var GetColor32 = function (red, green, blue, alpha)
	{
	    return alpha << 24 | red << 16 | green << 8 | blue;
	};
	
	module.exports = GetColor32;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetColor = __webpack_require__(269);
	
	/**
	 * Converts an HSV (hue, saturation and value) color value to RGB.
	 * Conversion formula from http://en.wikipedia.org/wiki/HSL_color_space.
	 * Assumes HSV values are contained in the set [0, 1].
	 * Based on code by Michael Jackson (https://github.com/mjijackson)
	 *
	 * @function Phaser.Display.Color.HSVToRGB
	 * @since 3.0.0
	 *
	 * @param {number} h - The hue, in the range 0 - 1.
	 * @param {number} s - The saturation, in the range 0 - 1.
	 * @param {number} v - The value, in the range 0 - 1.
	 *
	 * @return {ColorObject} An object with the red, green and blue values set in the r, g and b properties.
	 */
	var HSVToRGB = function (h, s, v)
	{
	    if (s === undefined) { s = 1; }
	    if (v === undefined) { v = 1; }
	
	    var i = Math.floor(h * 6);
	    var f = h * 6 - i;
	
	    var p = Math.floor((v * (1 - s)) * 255);
	    var q = Math.floor((v * (1 - f * s)) * 255);
	    var t = Math.floor((v * (1 - (1 - f) * s)) * 255);
	
	    v = Math.floor(v *= 255);
	
	    var output = { r: v, g: v, b: v, color: 0 };
	
	    var r = i % 6;
	
	    if (r === 0)
	    {
	        output.g = t;
	        output.b = p;
	    }
	    else if (r === 1)
	    {
	        output.r = q;
	        output.b = p;
	    }
	    else if (r === 2)
	    {
	        output.r = p;
	        output.b = t;
	    }
	    else if (r === 3)
	    {
	        output.r = p;
	        output.g = q;
	    }
	    else if (r === 4)
	    {
	        output.r = t;
	        output.g = p;
	    }
	    else if (r === 5)
	    {
	        output.g = p;
	        output.b = q;
	    }
	
	    output.color = GetColor(output.r, output.g, output.b);
	
	    return output;
	};
	
	module.exports = HSVToRGB;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Color = __webpack_require__(95);
	
	/**
	 * Converts a hex string into a Phaser Color object.
	 * 
	 * The hex string can supplied as `'#0033ff'` or the short-hand format of `'#03f'`; it can begin with an optional "#" or "0x", or be unprefixed.
	 *
	 * An alpha channel is _not_ supported.
	 *
	 * @function Phaser.Display.Color.HexStringToColor
	 * @since 3.0.0
	 *
	 * @param {string} hex - The hex color value to convert, such as `#0033ff` or the short-hand format: `#03f`.
	 *
	 * @return {Phaser.Display.Color} A Color object populated by the values of the given string.
	 */
	var HexStringToColor = function (hex)
	{
	    var color = new Color();
	
	    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
	    hex = hex.replace(/^(?:#|0x)?([a-f\d])([a-f\d])([a-f\d])$/i, function (m, r, g, b)
	    {
	        return r + r + g + g + b + b;
	    });
	
	    var result = (/^(?:#|0x)?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i).exec(hex);
	
	    if (result)
	    {
	        var r = parseInt(result[1], 16);
	        var g = parseInt(result[2], 16);
	        var b = parseInt(result[3], 16);
	
	        color.setTo(r, g, b);
	    }
	
	    return color;
	};
	
	module.exports = HexStringToColor;


/***/ }),
/* 476 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Converts a hue to an RGB color.
	 * Based on code by Michael Jackson (https://github.com/mjijackson)
	 *
	 * @function Phaser.Display.Color.HueToComponent
	 * @since 3.0.0
	 *
	 * @param {number} p
	 * @param {number} q
	 * @param {number} t
	 *
	 * @return {number} The combined color value.
	 */
	var HueToComponent = function (p, q, t)
	{
	    if (t < 0)
	    {
	        t += 1;
	    }
	
	    if (t > 1)
	    {
	        t -= 1;
	    }
	
	    if (t < 1 / 6)
	    {
	        return p + (q - p) * 6 * t;
	    }
	
	    if (t < 1 / 2)
	    {
	        return q;
	    }
	
	    if (t < 2 / 3)
	    {
	        return p + (q - p) * (2 / 3 - t) * 6;
	    }
	
	    return p;
	};
	
	module.exports = HueToComponent;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Color = __webpack_require__(95);
	var IntegerToRGB = __webpack_require__(478);
	
	/**
	 * Converts the given color value into an instance of a Color object.
	 *
	 * @function Phaser.Display.Color.IntegerToColor
	 * @since 3.0.0
	 *
	 * @param {integer} input - The color value to convert into a Color object.
	 *
	 * @return {Phaser.Display.Color} A Color object.
	 */
	var IntegerToColor = function (input)
	{
	    var rgb = IntegerToRGB(input);
	
	    return new Color(rgb.r, rgb.g, rgb.b, rgb.a);
	};
	
	module.exports = IntegerToColor;


/***/ }),
/* 478 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Return the component parts of a color as an Object with the properties alpha, red, green, blue.
	 *
	 * Alpha will only be set if it exists in the given color (0xAARRGGBB)
	 *
	 * @function Phaser.Display.Color.IntegerToRGB
	 * @since 3.0.0
	 *
	 * @param {integer} input - The color value to convert into a Color object.
	 *
	 * @return {ColorObject} An object with the red, green and blue values set in the r, g and b properties.
	 */
	var IntegerToRGB = function (color)
	{
	    if (color > 16777215)
	    {
	        //  The color value has an alpha component
	        return {
	            a: color >>> 24,
	            r: color >> 16 & 0xFF,
	            g: color >> 8 & 0xFF,
	            b: color & 0xFF
	        };
	    }
	    else
	    {
	        return {
	            a: 255,
	            r: color >> 16 & 0xFF,
	            g: color >> 8 & 0xFF,
	            b: color & 0xFF
	        };
	    }
	};
	
	module.exports = IntegerToRGB;


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Color = __webpack_require__(95);
	
	/**
	 * Converts an object containing `r`, `g`, `b` and `a` properties into a Color class instance.
	 *
	 * @function Phaser.Display.Color.ObjectToColor
	 * @since 3.0.0
	 *
	 * @param {InputColorObject} input - An object containing `r`, `g`, `b` and `a` properties in the range 0 to 255.
	 *
	 * @return {Phaser.Display.Color} A Color object.
	 */
	var ObjectToColor = function (input)
	{
	    return new Color(input.r, input.g, input.b, input.a);
	};
	
	module.exports = ObjectToColor;


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Color = __webpack_require__(95);
	
	/**
	 * Converts a CSS 'web' string into a Phaser Color object.
	 * 
	 * The web string can be in the format `'rgb(r,g,b)'` or `'rgba(r,g,b,a)'` where r/g/b are in the range [0..255] and a is in the range [0..1].
	 *
	 * @function Phaser.Display.Color.RGBStringToColor
	 * @since 3.0.0
	 *
	 * @param {string} rgb - The CSS format color string, using the `rgb` or `rgba` format.
	 *
	 * @return {Phaser.Display.Color} A Color object.
	 */
	var RGBStringToColor = function (rgb)
	{
	    var color = new Color();
	
	    var result = (/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d+(?:\.\d+)?))?\s*\)$/).exec(rgb.toLowerCase());
	
	    if (result)
	    {
	        var r = parseInt(result[1], 10);
	        var g = parseInt(result[2], 10);
	        var b = parseInt(result[3], 10);
	        var a = (result[4] !== undefined) ? parseFloat(result[4]) : 1;
	
	        color.setTo(r, g, b, a * 255);
	    }
	
	    return color;
	};
	
	module.exports = RGBStringToColor;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @typedef {object} InputColorObject
	 *
	 * @property {number} [r] - The red color value in the range 0 to 255.
	 * @property {number} [g] - The green color value in the range 0 to 255.
	 * @property {number} [b] - The blue color value in the range 0 to 255.
	 * @property {number} [a] - The alpha color value in the range 0 to 255.
	 */
	
	/**
	 * @typedef {Object} ColorObject
	 * @property {number} r - The red color value in the range 0 to 255.
	 * @property {number} g - The green color value in the range 0 to 255.
	 * @property {number} b - The blue color value in the range 0 to 255.
	 * @property {number} a - The alpha color value in the range 0 to 255.
	 */
	
	var Color = __webpack_require__(95);
	
	Color.ColorToRGBA = __webpack_require__(1089);
	Color.ComponentToHex = __webpack_require__(472);
	Color.GetColor = __webpack_require__(269);
	Color.GetColor32 = __webpack_require__(473);
	Color.HexStringToColor = __webpack_require__(475);
	Color.HSLToColor = __webpack_require__(1090);
	Color.HSVColorWheel = __webpack_require__(1091);
	Color.HSVToRGB = __webpack_require__(474);
	Color.HueToComponent = __webpack_require__(476);
	Color.IntegerToColor = __webpack_require__(477);
	Color.IntegerToRGB = __webpack_require__(478);
	Color.Interpolate = __webpack_require__(1092);
	Color.ObjectToColor = __webpack_require__(479);
	Color.RandomRGB = __webpack_require__(1095);
	Color.RGBStringToColor = __webpack_require__(480);
	Color.RGBToHSV = __webpack_require__(1093);
	Color.RGBToString = __webpack_require__(1094);
	Color.ValueToColor = __webpack_require__(270);
	
	module.exports = Color;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class BitmapMask
	 * @memberOf Phaser.Display.Masks
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - [description]
	 * @param {Phaser.GameObjects.GameObject} renderable - A renderable Game Object that uses a texture, such as a Sprite.
	 */
	var BitmapMask = new Class({
	
	    initialize:
	
	    function BitmapMask (scene, renderable)
	    {
	        var renderer = scene.sys.game.renderer;
	
	        /**
	         * A renderable Game Object that uses a texture, such as a Sprite.
	         *
	         * @name Phaser.Display.Masks.BitmapMask#bitmapMask
	         * @type {Phaser.GameObjects.GameObject}
	         * @since 3.0.0
	         */
	        this.bitmapMask = renderable;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Display.Masks.BitmapMask#maskTexture
	         * @type {WebGLTexture}
	         * @default null
	         * @since 3.0.0
	         */
	        this.maskTexture = null;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Display.Masks.BitmapMask#mainTexture
	         * @type {WebGLTexture}
	         * @default null
	         * @since 3.0.0
	         */
	        this.mainTexture = null;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Display.Masks.BitmapMask#dirty
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.dirty = true;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Display.Masks.BitmapMask#mainFramebuffer
	         * @type {WebGLFramebuffer}
	         * @since 3.0.0
	         */
	        this.mainFramebuffer = null;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Display.Masks.BitmapMask#maskFramebuffer
	         * @type {WebGLFramebuffer}
	         * @since 3.0.0
	         */
	        this.maskFramebuffer = null;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Display.Masks.BitmapMask#invertAlpha
	         * @type {boolean}
	         * @since 3.1.2
	         */
	        this.invertAlpha = false;
	
	        if (renderer && renderer.gl)
	        {
	            var width = renderer.width;
	            var height = renderer.height;
	            var pot = ((width & (width - 1)) === 0 && (height & (height - 1)) === 0);
	            var gl = renderer.gl;
	            var wrap = pot ? gl.REPEAT : gl.CLAMP_TO_EDGE;
	            var filter = gl.LINEAR;
	
	            this.mainTexture = renderer.createTexture2D(0, filter, filter, wrap, wrap, gl.RGBA, null, width, height);
	            this.maskTexture = renderer.createTexture2D(0, filter, filter, wrap, wrap, gl.RGBA, null, width, height);
	            this.mainFramebuffer = renderer.createFramebuffer(width, height, this.mainTexture, false);
	            this.maskFramebuffer = renderer.createFramebuffer(width, height, this.maskTexture, false);
	
	            renderer.onContextRestored(function (renderer)
	            {
	                var width = renderer.width;
	                var height = renderer.height;
	                var pot = ((width & (width - 1)) === 0 && (height & (height - 1)) === 0);
	                var gl = renderer.gl;
	                var wrap = pot ? gl.REPEAT : gl.CLAMP_TO_EDGE;
	                var filter = gl.LINEAR;
	
	                this.mainTexture = renderer.createTexture2D(0, filter, filter, wrap, wrap, gl.RGBA, null, width, height);
	                this.maskTexture = renderer.createTexture2D(0, filter, filter, wrap, wrap, gl.RGBA, null, width, height);
	                this.mainFramebuffer = renderer.createFramebuffer(width, height, this.mainTexture, false);
	                this.maskFramebuffer = renderer.createFramebuffer(width, height, this.maskTexture, false);
	
	            }, this);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Display.Masks.BitmapMask#setBitmap
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} renderable - A renderable Game Object that uses a texture, such as a Sprite.
	     */
	    setBitmap: function (renderable)
	    {
	        this.bitmapMask = renderable;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Display.Masks.BitmapMask#preRenderWebGL
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - [description]
	     * @param {Phaser.GameObjects.GameObject} maskedObject - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to render to.
	     */
	    preRenderWebGL: function (renderer, maskedObject, camera)
	    {
	        renderer.pipelines.BitmapMaskPipeline.beginMask(this, maskedObject, camera);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Display.Masks.BitmapMask#postRenderWebGL
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - [description]
	     */
	    postRenderWebGL: function (renderer)
	    {
	        renderer.pipelines.BitmapMaskPipeline.endMask(this);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Display.Masks.BitmapMask#preRenderCanvas
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - [description]
	     * @param {Phaser.GameObjects.GameObject} mask - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera to render to.
	     */
	    preRenderCanvas: function ()
	    {
	        // NOOP
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Display.Masks.BitmapMask#postRenderCanvas
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - [description]
	     */
	    postRenderCanvas: function ()
	    {
	        // NOOP
	    },
	
	    /**
	     * Destroys this BitmapMask and nulls any references it holds.
	     * 
	     * Note that if a Game Object is currently using this mask it will _not_ automatically detect you have destroyed it,
	     * so be sure to call `clearMask` on any Game Object using it, before destroying it.
	     *
	     * @method Phaser.Display.Masks.BitmapMask#destroy
	     * @since 3.7.0
	     */
	    destroy: function ()
	    {
	        this.bitmapMask = null;
	        this.mainTexture = null;
	        this.maskTexture = null;
	        this.mainFramebuffer = null;
	        this.maskFramebuffer = null;
	    }
	
	});
	
	module.exports = BitmapMask;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class GeometryMask
	 * @memberOf Phaser.Display.Masks
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - [description]
	 * @param {Phaser.GameObjects.Graphics} graphicsGeometry - [description]
	 */
	var GeometryMask = new Class({
	
	    initialize:
	
	    function GeometryMask (scene, graphicsGeometry)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Display.Masks.GeometryMask#geometryMask
	         * @type {Phaser.GameObjects.Graphics}
	         * @since 3.0.0
	         */
	        this.geometryMask = graphicsGeometry;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Display.Masks.GeometryMask#setShape
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Graphics} graphicsGeometry - [description]
	     */
	    setShape: function (graphicsGeometry)
	    {
	        this.geometryMask = graphicsGeometry;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Display.Masks.GeometryMask#preRenderWebGL
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - [description]
	     * @param {Phaser.GameObjects.GameObject} mask - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     */
	    preRenderWebGL: function (renderer, mask, camera)
	    {
	        var gl = renderer.gl;
	        var geometryMask = this.geometryMask;
	
	        // Force flushing before drawing to stencil buffer
	        renderer.flush();
	
	        // Enable and setup GL state to write to stencil buffer
	        gl.enable(gl.STENCIL_TEST);
	        gl.clear(gl.STENCIL_BUFFER_BIT);
	        gl.colorMask(false, false, false, false);
	        gl.stencilFunc(gl.NOTEQUAL, 1, 1);
	        gl.stencilOp(gl.REPLACE, gl.REPLACE, gl.REPLACE);
	
	        // Write stencil buffer
	        geometryMask.renderWebGL(renderer, geometryMask, 0.0, camera);
	        renderer.flush();
	
	        // Use stencil buffer to affect next rendering object
	        gl.colorMask(true, true, true, true);
	        gl.stencilFunc(gl.EQUAL, 1, 1);
	        gl.stencilOp(gl.INVERT, gl.INVERT, gl.INVERT);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Display.Masks.GeometryMask#postRenderWebGL
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - [description]
	     */
	    postRenderWebGL: function (renderer)
	    {
	        var gl = renderer.gl;
	
	        // Force flush before disabling stencil test
	        renderer.flush();
	        gl.disable(gl.STENCIL_TEST);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Display.Masks.GeometryMask#preRenderCanvas
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - [description]
	     * @param {Phaser.GameObjects.GameObject} mask - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     */
	    preRenderCanvas: function (renderer, mask, camera)
	    {
	        var geometryMask = this.geometryMask;
	
	        renderer.currentContext.save();
	
	        geometryMask.renderCanvas(renderer, geometryMask, 0.0, camera, undefined, null, true);
	
	        renderer.currentContext.clip();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Display.Masks.GeometryMask#postRenderCanvas
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - [description]
	     */
	    postRenderCanvas: function (renderer)
	    {
	        renderer.currentContext.restore();
	    },
	
	    /**
	     * Destroys this GeometryMask and nulls any references it holds.
	     * 
	     * Note that if a Game Object is currently using this mask it will _not_ automatically detect you have destroyed it,
	     * so be sure to call `clearMask` on any Game Object using it, before destroying it.
	     *
	     * @method Phaser.Display.Masks.GeometryMask#destroy
	     * @since 3.7.0
	     */
	    destroy: function ()
	    {
	        this.geometryMask = null;
	    }
	
	});
	
	module.exports = GeometryMask;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var OS = __webpack_require__(157);
	
	/**
	 * @callback ContentLoadedCallback
	 */
	
	/**
	 * Inspects the readyState of the document. If the document is already complete then it invokes the given callback.
	 * If not complete it sets up several event listeners such as `deviceready`, and once those fire, it invokes the callback.
	 * Called automatically by the Phaser.Game instance. Should not usually be accessed directly.
	 *
	 * @function Phaser.DOM.DOMContentLoaded
	 * @since 3.0.0
	 *
	 * @param {ContentLoadedCallback} callback - The callback to be invoked when the device is ready and the DOM content is loaded.
	 */
	var DOMContentLoaded = function (callback)
	{
	    if (document.readyState === 'complete' || document.readyState === 'interactive')
	    {
	        callback();
	
	        return;
	    }
	
	    var check = function ()
	    {
	        document.removeEventListener('deviceready', check, true);
	        document.removeEventListener('DOMContentLoaded', check, true);
	        window.removeEventListener('load', check, true);
	
	        callback();
	    };
	
	    if (!document.body)
	    {
	        window.setTimeout(check, 20);
	    }
	    else if (OS.cordova && !OS.cocoonJS)
	    {
	        //  Ref. http://docs.phonegap.com/en/3.5.0/cordova_events_events.md.html#deviceready
	        document.addEventListener('deviceready', check, false);
	    }
	    else
	    {
	        document.addEventListener('DOMContentLoaded', check, true);
	        window.addEventListener('load', check, true);
	    }
	};
	
	module.exports = DOMContentLoaded;


/***/ }),
/* 485 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Takes the given data string and parses it as XML.
	 * First tries to use the window.DOMParser and reverts to the Microsoft.XMLDOM if that fails.
	 * The parsed XML object is returned, or `null` if there was an error while parsing the data.
	 *
	 * @function Phaser.DOM.ParseXML
	 * @since 3.0.0
	 *
	 * @param {string} data - The XML source stored in a string.
	 *
	 * @return {?(DOMParser|ActiveXObject)} The parsed XML data, or `null` if the data could not be parsed.
	 */
	var ParseXML = function (data)
	{
	    var xml = '';
	
	    try
	    {
	        if (window['DOMParser'])
	        {
	            var domparser = new DOMParser();
	            xml = domparser.parseFromString(data, 'text/xml');
	        }
	        else
	        {
	            xml = new ActiveXObject('Microsoft.XMLDOM');
	            xml.loadXML(data);
	        }
	    }
	    catch (e)
	    {
	        xml = null;
	    }
	
	    if (!xml || !xml.documentElement || xml.getElementsByTagName('parsererror').length)
	    {
	        return null;
	    }
	    else
	    {
	        return xml;
	    }
	};
	
	module.exports = ParseXML;


/***/ }),
/* 486 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Attempts to remove the element from its parentNode in the DOM.
	 *
	 * @function Phaser.DOM.RemoveFromDOM
	 * @since 3.0.0
	 *
	 * @param {HTMLElement} element - The DOM element to remove from its parent node.
	 */
	var RemoveFromDOM = function (element)
	{
	    if (element.parentNode)
	    {
	        element.parentNode.removeChild(element);
	    }
	};
	
	module.exports = RemoveFromDOM;


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var NOOP = __webpack_require__(6);
	
	/**
	 * @classdesc
	 * Abstracts away the use of RAF or setTimeOut for the core game update loop.
	 * This is invoked automatically by the Phaser.Game instance.
	 *
	 * @class RequestAnimationFrame
	 * @memberOf Phaser.DOM
	 * @constructor
	 * @since 3.0.0
	 */
	var RequestAnimationFrame = new Class({
	
	    initialize:
	
	    function RequestAnimationFrame ()
	    {
	        /**
	         * True if RequestAnimationFrame is running, otherwise false.
	         *
	         * @name Phaser.DOM.RequestAnimationFrame#isRunning
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.isRunning = false;
	
	        /**
	         * The callback to be invoked each step.
	         *
	         * @name Phaser.DOM.RequestAnimationFrame#callback
	         * @type {FrameRequestCallback}
	         * @since 3.0.0
	         */
	        this.callback = NOOP;
	
	        /**
	         * The most recent timestamp. Either a DOMHighResTimeStamp under RAF or `Date.now` under SetTimeout.
	         *
	         * @name Phaser.DOM.RequestAnimationFrame#tick
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.tick = 0;
	
	        /**
	         * True if the step is using setTimeout instead of RAF.
	         *
	         * @name Phaser.DOM.RequestAnimationFrame#isSetTimeOut
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.isSetTimeOut = false;
	
	        /**
	         * The setTimeout or RAF callback ID used when canceling them.
	         *
	         * @name Phaser.DOM.RequestAnimationFrame#timeOutID
	         * @type {?number}
	         * @default null
	         * @since 3.0.0
	         */
	        this.timeOutID = null;
	
	        /**
	         * The previous time the step was called.
	         *
	         * @name Phaser.DOM.RequestAnimationFrame#lastTime
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.lastTime = 0;
	
	        var _this = this;
	
	        /**
	         * The RAF step function.
	         * Updates the local tick value, invokes the callback and schedules another call to requestAnimationFrame.
	         *
	         * @name Phaser.DOM.RequestAnimationFrame#step
	         * @type {FrameRequestCallback}
	         * @since 3.0.0
	         */
	        this.step = function step (timestamp)
	        {
	            // DOMHighResTimeStamp
	            _this.lastTime = _this.tick;
	
	            _this.tick = timestamp;
	
	            _this.callback(timestamp);
	
	            _this.timeOutID = window.requestAnimationFrame(step);
	        };
	
	        /**
	         * The SetTimeout step function.
	         * Updates the local tick value, invokes the callback and schedules another call to setTimeout.
	         *
	         * @name Phaser.DOM.RequestAnimationFrame#stepTimeout
	         * @type {function}
	         * @since 3.0.0
	         */
	        this.stepTimeout = function stepTimeout ()
	        {
	            var d = Date.now();
	
	            var delay = Math.max(16 + _this.lastTime - d, 0);
	
	            _this.lastTime = _this.tick;
	
	            _this.tick = d;
	
	            _this.callback(d);
	
	            _this.timeOutID = window.setTimeout(stepTimeout, delay);
	        };
	    },
	
	    /**
	     * Starts the requestAnimationFrame or setTimeout process running.
	     *
	     * @method Phaser.DOM.RequestAnimationFrame#start
	     * @since 3.0.0
	     *
	     * @param {FrameRequestCallback} callback - The callback to invoke each step.
	     * @param {boolean} forceSetTimeOut - Should it use SetTimeout, even if RAF is available?
	     */
	    start: function (callback, forceSetTimeOut)
	    {
	        if (this.isRunning)
	        {
	            return;
	        }
	
	        this.callback = callback;
	
	        this.isSetTimeOut = forceSetTimeOut;
	
	        this.isRunning = true;
	
	        this.timeOutID = (forceSetTimeOut) ? window.setTimeout(this.stepTimeout, 0) : window.requestAnimationFrame(this.step);
	    },
	
	    /**
	     * Stops the requestAnimationFrame or setTimeout from running.
	     *
	     * @method Phaser.DOM.RequestAnimationFrame#stop
	     * @since 3.0.0
	     */
	    stop: function ()
	    {
	        this.isRunning = false;
	
	        if (this.isSetTimeOut)
	        {
	            clearTimeout(this.timeOutID);
	        }
	        else
	        {
	            window.cancelAnimationFrame(this.timeOutID);
	        }
	    },
	
	    /**
	     * Stops the step from running and clears the callback reference.
	     *
	     * @method Phaser.DOM.RequestAnimationFrame#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.stop();
	
	        this.callback = NOOP;
	    }
	
	});
	
	module.exports = RequestAnimationFrame;


/***/ }),
/* 488 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function GetBitmapTextSize
	 * @since 3.0.0
	 * @private
	 *
	 * @param {(Phaser.GameObjects.DynamicBitmapText|Phaser.GameObjects.BitmapText)} src - [description]
	 * @param {boolean} round - [description]
	 */
	var GetBitmapTextSize = function (src, round)
	{
	    var text = src.text;
	    var textLength = text.length;
	
	    var bx = Number.MAX_VALUE;
	    var by = Number.MAX_VALUE;
	    var bw = 0;
	    var bh = 0;
	
	    var chars = src.fontData.chars;
	    var lineHeight = src.fontData.lineHeight;
	    var letterSpacing = src.letterSpacing;
	
	    var xAdvance = 0;
	    var yAdvance = 0;
	
	    var indexCount = 0;
	    var charCode = 0;
	
	    var glyph = null;
	    var glyphW = 0;
	    var glyphH = 0;
	
	    var x = 0;
	    var y = 0;
	
	    var lastGlyph = null;
	    var lastCharCode = 0;
	
	    for (var index = 0; index < textLength; ++index)
	    {
	        charCode = text.charCodeAt(index);
	
	        if (charCode === 10)
	        {
	            xAdvance = 0;
	            indexCount = 0;
	            yAdvance += lineHeight;
	            lastGlyph = null;
	            continue;
	        }
	
	        glyph = chars[charCode];
	
	        if (!glyph)
	        {
	            continue;
	        }
	
	        glyphW = glyph.width;
	        glyphH = glyph.height;
	
	        x = indexCount + glyph.xOffset + xAdvance;
	        y = glyph.yOffset + yAdvance;
	
	        if (lastGlyph !== null)
	        {
	            var kerningOffset = glyph.kerning[lastCharCode];
	            x += (kerningOffset !== undefined) ? kerningOffset : 0;
	        }
	
	        if (bx > x)
	        {
	            bx = x;
	        }
	
	        if (by > y)
	        {
	            by = y;
	        }
	
	        var gw = x + glyphW - bx;
	        var gh = y + glyphH - by;
	
	        if (bw < gw)
	        {
	            bw = gw;
	        }
	
	        if (bh < gh)
	        {
	            bh = gh;
	        }
	
	        xAdvance += glyph.xAdvance + letterSpacing;
	        indexCount += 1;
	        lastGlyph = glyph;
	        lastCharCode = charCode;
	    }
	
	    var scale = (src.fontSize / src.fontData.size);
	    var sx = scale * src.scaleX;
	    var sy = scale * src.scaleY;
	
	    var out = {
	        local: {
	            x: bx * scale,
	            y: by * scale,
	            width: bw * scale,
	            height: bh * scale
	        },
	        global: {
	            x: src.x + (bx * sx),
	            y: src.y + (by * sy),
	            width: bw * sx,
	            height: bh * sy
	        }
	    };
	
	    if (round)
	    {
	        out.local.x = Math.round(out.local.x);
	        out.local.y = Math.round(out.local.y);
	        out.local.width = Math.round(out.local.width);
	        out.local.height = Math.round(out.local.height);
	
	        out.global.x = Math.round(out.global.x);
	        out.global.y = Math.round(out.global.y);
	        out.global.width = Math.round(out.global.width);
	        out.global.height = Math.round(out.global.height);
	    }
	
	    return out;
	};
	
	module.exports = GetBitmapTextSize;


/***/ }),
/* 489 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @function getValue
	 * @since 3.0.0
	 * @private
	 */
	function getValue (node, attribute)
	{
	    return parseInt(node.getAttribute(attribute), 10);
	}
	
	/**
	 * @function ParseXMLBitmapFont
	 * @since 3.0.0
	 * @private
	 *
	 * @param {XMLDocument} xml - [description]
	 * @param {integer} [xSpacing=0] - [description]
	 * @param {integer} [ySpacing=0] - [description]
	 * @param {Phaser.Textures.Frame} [frame] - [description]
	 */
	var ParseXMLBitmapFont = function (xml, xSpacing, ySpacing, frame)
	{
	    if (xSpacing === undefined) { xSpacing = 0; }
	    if (ySpacing === undefined) { ySpacing = 0; }
	
	    var data = {};
	    var info = xml.getElementsByTagName('info')[0];
	    var common = xml.getElementsByTagName('common')[0];
	
	    data.font = info.getAttribute('face');
	    data.size = getValue(info, 'size');
	    data.lineHeight = getValue(common, 'lineHeight') + ySpacing;
	    data.chars = {};
	
	    var letters = xml.getElementsByTagName('char');
	
	    var adjustForTrim = (frame !== undefined && frame.trimmed);
	
	    if (adjustForTrim)
	    {
	        var top = frame.height;
	        var left = frame.width;
	    }
	
	    for (var i = 0; i < letters.length; i++)
	    {
	        var node = letters[i];
	
	        var charCode = getValue(node, 'id');
	        var gx = getValue(node, 'x');
	        var gy = getValue(node, 'y');
	        var gw = getValue(node, 'width');
	        var gh = getValue(node, 'height');
	
	        //  Handle frame trim issues
	
	        if (adjustForTrim)
	        {
	            if (gx < left)
	            {
	                left = gx;
	            }
	
	            if (gy < top)
	            {
	                top = gy;
	            }
	        }
	
	        data.chars[charCode] =
	        {
	            x: gx,
	            y: gy,
	            width: gw,
	            height: gh,
	            centerX: Math.floor(gw / 2),
	            centerY: Math.floor(gh / 2),
	            xOffset: getValue(node, 'xoffset'),
	            yOffset: getValue(node, 'yoffset'),
	            xAdvance: getValue(node, 'xadvance') + xSpacing,
	            data: {},
	            kerning: {}
	        };
	    }
	
	    if (adjustForTrim && top !== 0 && left !== 0)
	    {
	        // console.log('top and left', top, left, frame.x, frame.y);
	
	        //  Now we know the top and left coordinates of the glyphs in the original data
	        //  so we can work out how much to adjust the glyphs by
	
	        for (var code in data.chars)
	        {
	            var glyph = data.chars[code];
	
	            glyph.x -= frame.x;
	            glyph.y -= frame.y;
	        }
	    }
	
	    var kernings = xml.getElementsByTagName('kerning');
	
	    for (i = 0; i < kernings.length; i++)
	    {
	        var kern = kernings[i];
	
	        var first = getValue(kern, 'first');
	        var second = getValue(kern, 'second');
	        var amount = getValue(kern, 'amount');
	
	        data.chars[second].kerning[first] = amount;
	    }
	
	    return data;
	};
	
	module.exports = ParseXMLBitmapFont;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	
	/**
	 * This event is dispatched when an animation starts playing.
	 *
	 * @event Phaser.GameObjects.Components.Animation#onStartEvent
	 * @param {Phaser.Animations.Animation} animation - Reference to the currently playing animation.
	 * @param {Phaser.Animations.AnimationFrame} frame - Reference to the current Animation Frame.
	 */
	
	/**
	 * This event is dispatched when an animation repeats.
	 *
	 * @event Phaser.GameObjects.Components.Animation#onRepeatEvent
	 * @param {Phaser.Animations.Animation} animation - Reference to the currently playing animation.
	 * @param {Phaser.Animations.AnimationFrame} frame - Reference to the current Animation Frame.
	 * @param {integer} repeatCount - The number of times this animation has repeated.
	 */
	
	/**
	 * This event is dispatched when an animation updates. This happens when the animation frame changes,
	 * based on the animation frame rate and other factors like timeScale and delay.
	 *
	 * @event Phaser.GameObjects.Components.Animation#onUpdateEvent
	 * @param {Phaser.Animations.Animation} animation - Reference to the currently playing animation.
	 * @param {Phaser.Animations.AnimationFrame} frame - Reference to the current Animation Frame.
	 */
	
	/**
	 * This event is dispatched when an animation completes playing, either naturally or via Animation.stop.
	 *
	 * @event Phaser.GameObjects.Components.Animation#onCompleteEvent
	 * @param {Phaser.Animations.Animation} animation - Reference to the currently playing animation.
	 * @param {Phaser.Animations.AnimationFrame} frame - Reference to the current Animation Frame.
	 */
	
	/**
	 * @classdesc
	 * A Game Object Animation Controller.
	 *
	 * This controller lives as an instance within a Game Object, accessible as `sprite.anims`.
	 *
	 * @class Animation
	 * @memberOf Phaser.GameObjects.Components
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.GameObjects.GameObject} parent - The Game Object to which this animation controller belongs.
	 */
	var Animation = new Class({
	
	    initialize:
	
	    function Animation (parent)
	    {
	        /**
	         * The Game Object to which this animation controller belongs.
	         *
	         * @name Phaser.GameObjects.Components.Animation#parent
	         * @type {Phaser.GameObjects.GameObject}
	         * @since 3.0.0
	         */
	        this.parent = parent;
	
	        /**
	         * A reference to the global Animation Manager.
	         *
	         * @name Phaser.GameObjects.Components.Animation#animationManager
	         * @type {Phaser.Animations.AnimationManager}
	         * @since 3.0.0
	         */
	        this.animationManager = parent.scene.sys.anims;
	
	        this.animationManager.once('remove', this.remove, this);
	
	        /**
	         * Is an animation currently playing or not?
	         *
	         * @name Phaser.GameObjects.Components.Animation#isPlaying
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.isPlaying = false;
	
	        /**
	         * The current Animation loaded into this Animation Controller.
	         *
	         * @name Phaser.GameObjects.Components.Animation#currentAnim
	         * @type {?Phaser.Animations.Animation}
	         * @default null
	         * @since 3.0.0
	         */
	        this.currentAnim = null;
	
	        /**
	         * The current AnimationFrame being displayed by this Animation Controller.
	         *
	         * @name Phaser.GameObjects.Components.Animation#currentFrame
	         * @type {?Phaser.Animations.AnimationFrame}
	         * @default null
	         * @since 3.0.0
	         */
	        this.currentFrame = null;
	
	        /**
	         * Time scale factor.
	         *
	         * @name Phaser.GameObjects.Components.Animation#_timeScale
	         * @type {number}
	         * @private
	         * @default 1
	         * @since 3.0.0
	         */
	        this._timeScale = 1;
	
	        /**
	         * The frame rate of playback in frames per second.
	         * The default is 24 if the `duration` property is `null`.
	         *
	         * @name Phaser.GameObjects.Components.Animation#frameRate
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.frameRate = 0;
	
	        /**
	         * How long the animation should play for, in milliseconds.
	         * If the `frameRate` property has been set then it overrides this value,
	         * otherwise the `frameRate` is derived from `duration`.
	         *
	         * @name Phaser.GameObjects.Components.Animation#duration
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.duration = 0;
	
	        /**
	         * ms per frame, not including frame specific modifiers that may be present in the Animation data.
	         *
	         * @name Phaser.GameObjects.Components.Animation#msPerFrame
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.msPerFrame = 0;
	
	        /**
	         * Skip frames if the time lags, or always advanced anyway?
	         *
	         * @name Phaser.GameObjects.Components.Animation#skipMissedFrames
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.skipMissedFrames = true;
	
	        /**
	         * A delay before starting playback, in milliseconds.
	         *
	         * @name Phaser.GameObjects.Components.Animation#_delay
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._delay = 0;
	
	        /**
	         * Number of times to repeat the animation (-1 for infinity)
	         *
	         * @name Phaser.GameObjects.Components.Animation#_repeat
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._repeat = 0;
	
	        /**
	         * Delay before the repeat starts, in milliseconds.
	         *
	         * @name Phaser.GameObjects.Components.Animation#_repeatDelay
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._repeatDelay = 0;
	
	        /**
	         * Should the animation yoyo? (reverse back down to the start) before repeating?
	         *
	         * @name Phaser.GameObjects.Components.Animation#_yoyo
	         * @type {boolean}
	         * @private
	         * @default false
	         * @since 3.0.0
	         */
	        this._yoyo = false;
	
	        /**
	         * Will the playhead move forwards (`true`) or in reverse (`false`)
	         *
	         * @name Phaser.GameObjects.Components.Animation#forward
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.forward = true;
	
	        /**
	         * Internal time overflow accumulator.
	         *
	         * @name Phaser.GameObjects.Components.Animation#accumulator
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.accumulator = 0;
	
	        /**
	         * The time point at which the next animation frame will change.
	         *
	         * @name Phaser.GameObjects.Components.Animation#nextTick
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.nextTick = 0;
	
	        /**
	         * An internal counter keeping track of how many repeats are left to play.
	         *
	         * @name Phaser.GameObjects.Components.Animation#repeatCounter
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.repeatCounter = 0;
	
	        /**
	         * An internal flag keeping track of pending repeats.
	         *
	         * @name Phaser.GameObjects.Components.Animation#pendingRepeat
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.pendingRepeat = false;
	
	        /**
	         * Is the Animation paused?
	         *
	         * @name Phaser.GameObjects.Components.Animation#_paused
	         * @type {boolean}
	         * @private
	         * @default false
	         * @since 3.0.0
	         */
	        this._paused = false;
	
	        /**
	         * Was the animation previously playing before being paused?
	         *
	         * @name Phaser.GameObjects.Components.Animation#_wasPlaying
	         * @type {boolean}
	         * @private
	         * @default false
	         * @since 3.0.0
	         */
	        this._wasPlaying = false;
	
	        /**
	         * Internal property tracking if this Animation is waiting to stop.
	         *
	         * 0 = No
	         * 1 = Waiting for ms to pass
	         * 2 = Waiting for repeat
	         * 3 = Waiting for specific frame
	         *
	         * @name Phaser.GameObjects.Components.Animation#_pendingStop
	         * @type {integer}
	         * @private
	         * @since 3.4.0
	         */
	        this._pendingStop = 0;
	
	        /**
	         * Internal property used by _pendingStop.
	         *
	         * @name Phaser.GameObjects.Components.Animation#_pendingStopValue
	         * @type {any}
	         * @private
	         * @since 3.4.0
	         */
	        this._pendingStopValue;
	    },
	
	    /**
	     * Sets the amount of time, in milliseconds, that the animation will be delayed before starting playback.
	     *
	     * @method Phaser.GameObjects.Components.Animation#setDelay
	     * @since 3.4.0
	     *
	     * @param {integer} [value=0] - The amount of time, in milliseconds, to wait before starting playback.
	     *
	     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
	     */
	    setDelay: function (value)
	    {
	        if (value === undefined) { value = 0; }
	
	        this._delay = value;
	
	        return this.parent;
	    },
	
	    /**
	     * Gets the amount of time, in milliseconds that the animation will be delayed before starting playback.
	     *
	     * @method Phaser.GameObjects.Components.Animation#getDelay
	     * @since 3.4.0
	     *
	     * @return {integer} The amount of time, in milliseconds, the Animation will wait before starting playback.
	     */
	    getDelay: function ()
	    {
	        return this._delay;
	    },
	
	    /**
	     * Waits for the specified delay, in milliseconds, then starts playback of the requested animation.
	     *
	     * @method Phaser.GameObjects.Components.Animation#delayedPlay
	     * @since 3.0.0
	     *
	     * @param {integer} delay - The delay, in milliseconds, to wait before starting the animation playing.
	     * @param {string} key - The key of the animation to play.
	     * @param {integer} [startFrame=0] - The frame of the animation to start from.
	     *
	     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
	     */
	    delayedPlay: function (delay, key, startFrame)
	    {
	        this.play(key, true, startFrame);
	
	        this.nextTick += delay;
	
	        return this.parent;
	    },
	
	    /**
	     * Returns the key of the animation currently loaded into this component.
	     *
	     * @method Phaser.GameObjects.Components.Animation#getCurrentKey
	     * @since 3.0.0
	     *
	     * @return {string} The key of the Animation loaded into this component.
	     */
	    getCurrentKey: function ()
	    {
	        if (this.currentAnim)
	        {
	            return this.currentAnim.key;
	        }
	    },
	
	    /**
	     * Internal method used to load an animation into this component.
	     *
	     * @method Phaser.GameObjects.Components.Animation#load
	     * @protected
	     * @since 3.0.0
	     *
	     * @param {string} key - [description]
	     * @param {integer} [startFrame=0] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
	     */
	    load: function (key, startFrame)
	    {
	        if (startFrame === undefined) { startFrame = 0; }
	
	        if (this.isPlaying)
	        {
	            this.stop();
	        }
	
	        //  Load the new animation in
	        this.animationManager.load(this, key, startFrame);
	
	        return this.parent;
	    },
	
	    /**
	     * Pause the current animation and set the `isPlaying` property to `false`.
	     * You can optionally pause it at a specific frame.
	     *
	     * @method Phaser.GameObjects.Components.Animation#pause
	     * @since 3.0.0
	     *
	     * @param {Phaser.Animations.AnimationFrame} [atFrame] - An optional frame to set after pausing the animation.
	     *
	     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
	     */
	    pause: function (atFrame)
	    {
	        if (!this._paused)
	        {
	            this._paused = true;
	            this._wasPlaying = this.isPlaying;
	            this.isPlaying = false;
	        }
	
	        if (atFrame !== undefined)
	        {
	            this.updateFrame(atFrame);
	        }
	
	        return this.parent;
	    },
	
	    /**
	     * Resumes playback of a paused animation and sets the `isPlaying` property to `true`.
	     * You can optionally tell it to start playback from a specific frame.
	     *
	     * @method Phaser.GameObjects.Components.Animation#resume
	     * @since 3.0.0
	     *
	     * @param {Phaser.Animations.AnimationFrame} [fromFrame] - An optional frame to set before restarting playback.
	     *
	     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
	     */
	    resume: function (fromFrame)
	    {
	        if (this._paused)
	        {
	            this._paused = false;
	            this.isPlaying = this._wasPlaying;
	        }
	
	        if (fromFrame !== undefined)
	        {
	            this.updateFrame(fromFrame);
	        }
	
	        return this.parent;
	    },
	
	    /**
	     * `true` if the current animation is paused, otherwise `false`.
	     *
	     * @name Phaser.GameObjects.Components.Animation#isPaused
	     * @readOnly
	     * @type {boolean}
	     * @since 3.4.0
	     */
	    isPaused: {
	
	        get: function ()
	        {
	            return this._paused;
	        }
	
	    },
	
	    /**
	     * Plays an Animation on the Game Object that owns this Animation Component.
	     *
	     * @method Phaser.GameObjects.Components.Animation#play
	     * @fires Phaser.GameObjects.Components.Animation#onStartEvent
	     * @since 3.0.0
	     *
	     * @param {string} key - The string-based key of the animation to play, as defined previously in the Animation Manager.
	     * @param {boolean} [ignoreIfPlaying=false] - If an animation is already playing then ignore this call.
	     * @param {integer} [startFrame=0] - Optionally start the animation playing from this frame index.
	     *
	     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
	     */
	    play: function (key, ignoreIfPlaying, startFrame)
	    {
	        if (ignoreIfPlaying === undefined) { ignoreIfPlaying = false; }
	        if (startFrame === undefined) { startFrame = 0; }
	
	        if (ignoreIfPlaying && this.isPlaying && this.currentAnim.key === key)
	        {
	            return this.parent;
	        }
	
	        this.load(key, startFrame);
	
	        var anim = this.currentAnim;
	        var gameObject = this.parent;
	
	        //  Should give us 9,007,199,254,740,991 safe repeats
	        this.repeatCounter = (this._repeat === -1) ? Number.MAX_VALUE : this._repeat;
	
	        anim.getFirstTick(this);
	
	        this.forward = true;
	        this.isPlaying = true;
	        this.pendingRepeat = false;
	
	        if (anim.showOnStart)
	        {
	            gameObject.visible = true;
	        }
	
	        gameObject.emit('animationstart', this.currentAnim, this.currentFrame);
	
	        return gameObject;
	    },
	
	    /**
	     * Returns a value between 0 and 1 indicating how far this animation is through, ignoring repeats and yoyos.
	     * If the animation has a non-zero repeat defined, `getProgress` and `getTotalProgress` will be different
	     * because `getProgress` doesn't include any repeats or repeat delays, whereas `getTotalProgress` does.
	     *
	     * @method Phaser.GameObjects.Components.Animation#getProgress
	     * @since 3.4.0
	     *
	     * @return {float} The progress of the current animation, between 0 and 1.
	     */
	    getProgress: function ()
	    {
	        var p = this.currentFrame.progress;
	
	        if (!this.forward)
	        {
	            p = 1 - p;
	        }
	
	        return p;
	    },
	
	    /**
	     * Takes a value between 0 and 1 and uses it to set how far this animation is through playback.
	     * Does not factor in repeats or yoyos, but does handle playing forwards or backwards.
	     *
	     * @method Phaser.GameObjects.Components.Animation#setProgress
	     * @since 3.4.0
	     *
	     * @param {float} [value=0] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
	     */
	    setProgress: function (value)
	    {
	        if (!this.forward)
	        {
	            value = 1 - value;
	        }
	
	        this.setCurrentFrame(this.currentAnim.getFrameByProgress(value));
	
	        return this.parent;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Components.Animation#remove
	     * @since 3.0.0
	     *
	     * @param {Phaser.Animations.Animation} [event] - [description]
	     */
	    remove: function (event)
	    {
	        if (event === undefined) { event = this.currentAnim; }
	
	        if (this.isPlaying && event.key === this.currentAnim.key)
	        {
	            this.stop();
	
	            this.setCurrentFrame(this.currentAnim.frames[0]);
	        }
	    },
	
	    /**
	     * Gets the number of times that the animation will repeat
	     * after its first iteration. For example, if returns 1, the animation will
	     * play a total of twice (the initial play plus 1 repeat).
	     * A value of -1 means the animation will repeat indefinitely.
	     *
	     * @method Phaser.GameObjects.Components.Animation#getRepeat
	     * @since 3.4.0
	     *
	     * @return {integer} The number of times that the animation will repeat.
	     */
	    getRepeat: function ()
	    {
	        return this._repeat;
	    },
	
	    /**
	     * Sets the number of times that the animation should repeat
	     * after its first iteration. For example, if repeat is 1, the animation will
	     * play a total of twice (the initial play plus 1 repeat).
	     * To repeat indefinitely, use -1. repeat should always be an integer.
	     *
	     * @method Phaser.GameObjects.Components.Animation#setRepeat
	     * @since 3.4.0
	     *
	     * @param {integer} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
	     */
	    setRepeat: function (value)
	    {
	        this._repeat = value;
	
	        this.repeatCounter = 0;
	
	        return this.parent;
	    },
	
	    /**
	     * Gets the amount of delay between repeats, if any.
	     *
	     * @method Phaser.GameObjects.Components.Animation#getRepeatDelay
	     * @since 3.4.0
	     *
	     * @return {number} The delay between repeats.
	     */
	    getRepeatDelay: function ()
	    {
	        return this._repeatDelay;
	    },
	
	    /**
	     * Sets the amount of time in seconds between repeats.
	     * For example, if `repeat` is 2 and `repeatDelay` is 10, the animation will play initially,
	     * then wait for 10 seconds before repeating, then play again, then wait another 10 seconds
	     * before doing its final repeat.
	     *
	     * @method Phaser.GameObjects.Components.Animation#setRepeatDelay
	     * @since 3.4.0
	     *
	     * @param {number} value - The delay to wait between repeats, in seconds.
	     *
	     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
	     */
	    setRepeatDelay: function (value)
	    {
	        this._repeatDelay = value;
	
	        return this.parent;
	    },
	
	    /**
	     * Restarts the current animation from its beginning, optionally including its delay value.
	     *
	     * @method Phaser.GameObjects.Components.Animation#restart
	     * @since 3.0.0
	     *
	     * @param {boolean} [includeDelay=false] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
	     */
	    restart: function (includeDelay)
	    {
	        if (includeDelay === undefined) { includeDelay = false; }
	
	        this.currentAnim.getFirstTick(this, includeDelay);
	
	        this.forward = true;
	        this.isPlaying = true;
	        this.pendingRepeat = false;
	        this._paused = false;
	
	        //  Set frame
	        this.updateFrame(this.currentAnim.frames[0]);
	
	        return this.parent;
	    },
	
	    /**
	     * Immediately stops the current animation from playing and dispatches the `animationcomplete` event.
	     *
	     * @method Phaser.GameObjects.Components.Animation#stop
	     * @fires Phaser.GameObjects.Components.Animation#onCompleteEvent
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
	     */
	    stop: function ()
	    {
	        this._pendingStop = 0;
	
	        this.isPlaying = false;
	
	        var gameObject = this.parent;
	
	        gameObject.emit('animationcomplete', this.currentAnim, this.currentFrame);
	
	        return gameObject;
	    },
	
	    /**
	     * Stops the current animation from playing after the specified time delay, given in milliseconds.
	     *
	     * @method Phaser.GameObjects.Components.Animation#stopAfterDelay
	     * @fires Phaser.GameObjects.Components.Animation#onCompleteEvent
	     * @since 3.4.0
	     *
	     * @param {integer} delay - The number of milliseconds to wait before stopping this animation.
	     *
	     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
	     */
	    stopAfterDelay: function (delay)
	    {
	        this._pendingStop = 1;
	        this._pendingStopValue = delay;
	
	        return this.parent;
	    },
	
	    /**
	     * Stops the current animation from playing when it next repeats.
	     *
	     * @method Phaser.GameObjects.Components.Animation#stopOnRepeat
	     * @fires Phaser.GameObjects.Components.Animation#onCompleteEvent
	     * @since 3.4.0
	     *
	     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
	     */
	    stopOnRepeat: function ()
	    {
	        this._pendingStop = 2;
	
	        return this.parent;
	    },
	
	    /**
	     * Stops the current animation from playing when it next sets the given frame.
	     * If this frame doesn't exist within the animation it will not stop it from playing.
	     *
	     * @method Phaser.GameObjects.Components.Animation#stopOnFrame
	     * @fires Phaser.GameObjects.Components.Animation#onCompleteEvent
	     * @since 3.4.0
	     *
	     * @param {Phaser.Animations.AnimationFrame} delay - The frame to check before stopping this animation.
	     *
	     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
	     */
	    stopOnFrame: function (frame)
	    {
	        this._pendingStop = 3;
	        this._pendingStopValue = frame;
	
	        return this.parent;
	    },
	
	    /**
	     * Sets the Time Scale factor, allowing you to make the animation go go faster or slower than default.
	     * Where 1 = normal speed (the default), 0.5 = half speed, 2 = double speed, etc.
	     *
	     * @method Phaser.GameObjects.Components.Animation#setTimeScale
	     * @since 3.4.0
	     *
	     * @param {number} [value=1] - The time scale factor, where 1 is no change, 0.5 is half speed, etc.
	     *
	     * @return {Phaser.GameObjects.GameObject} The Game Object that owns this Animation Component.
	     */
	    setTimeScale: function (value)
	    {
	        if (value === undefined) { value = 1; }
	
	        this._timeScale = value;
	
	        return this.parent;
	    },
	
	    /**
	     * Gets the Time Scale factor.
	     *
	     * @method Phaser.GameObjects.Components.Animation#getTimeScale
	     * @since 3.4.0
	     *
	     * @return {number} The Time Scale value.
	     */
	    getTimeScale: function ()
	    {
	        return this._timeScale;
	    },
	
	    /**
	     * Returns the total number of frames in this animation.
	     *
	     * @method Phaser.GameObjects.Components.Animation#getTotalFrames
	     * @since 3.4.0
	     *
	     * @return {integer} The total number of frames in this animation.
	     */
	    getTotalFrames: function ()
	    {
	        return this.currentAnim.frames.length;
	    },
	
	    /**
	     * The internal update loop for the Animation Component.
	     *
	     * @method Phaser.GameObjects.Components.Animation#update
	     * @since 3.0.0
	     *
	     * @param {number} timestamp - [description]
	     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
	     */
	    update: function (timestamp, delta)
	    {
	        if (!this.currentAnim || !this.isPlaying || this.currentAnim.paused)
	        {
	            return;
	        }
	
	        this.accumulator += delta * this._timeScale;
	
	        if (this._pendingStop === 1)
	        {
	            this._pendingStopValue -= delta;
	
	            if (this._pendingStopValue <= 0)
	            {
	                return this.currentAnim.completeAnimation(this);
	            }
	        }
	
	        if (this.accumulator >= this.nextTick)
	        {
	            this.currentAnim.setFrame(this);
	        }
	    },
	
	    /**
	     * Sets the given Animation Frame as being the current frame
	     * and applies it to the parent Game Object, adjusting its size and origin as needed.
	     *
	     * @method Phaser.GameObjects.Components.Animation#setCurrentFrame
	     * @since 3.4.0
	     *
	     * @param {Phaser.Animations.AnimationFrame} animationFrame - The Animation Frame to set as being current.
	     *
	     * @return {Phaser.GameObjects.GameObject} The Game Object this Animation Component belongs to.
	     */
	    setCurrentFrame: function (animationFrame)
	    {
	        var gameObject = this.parent;
	
	        this.currentFrame = animationFrame;
	
	        gameObject.texture = animationFrame.frame.texture;
	        gameObject.frame = animationFrame.frame;
	
	        gameObject.setSizeToFrame();
	
	        if (animationFrame.frame.customPivot)
	        {
	            gameObject.setOrigin(animationFrame.frame.pivotX, animationFrame.frame.pivotY);
	        }
	        else
	        {
	            gameObject.updateDisplayOrigin();
	        }
	
	        return gameObject;
	    },
	
	    /**
	     * Internal frame change handler.
	     *
	     * @method Phaser.GameObjects.Components.Animation#updateFrame
	     * @fires Phaser.GameObjects.Components.Animation#onUpdateEvent
	     * @private
	     * @since 3.0.0
	     *
	     * @param {Phaser.Animations.AnimationFrame} animationFrame - [description]
	     */
	    updateFrame: function (animationFrame)
	    {
	        var gameObject = this.setCurrentFrame(animationFrame);
	
	        if (this.isPlaying)
	        {
	            if (animationFrame.setAlpha)
	            {
	                gameObject.alpha = animationFrame.alpha;
	            }
	
	            var anim = this.currentAnim;
	
	            gameObject.emit('animationupdate', anim, animationFrame);
	
	            if (this._pendingStop === 3 && this._pendingStopValue === animationFrame)
	            {
	                this.currentAnim.completeAnimation(this);
	            }
	        }
	    },
	
	    /**
	     * Sets if the current Animation will yoyo when it reaches the end.
	     * A yoyo'ing animation will play through consecutively, and then reverse-play back to the start again.
	     *
	     * @method Phaser.GameObjects.Components.Animation#setYoyo
	     * @since 3.4.0
	     *
	     * @param {boolean} [value=false] - `true` if the animation should yoyo, `false` to not.
	     *
	     * @return {Phaser.GameObjects.GameObject} The Game Object this Animation Component belongs to.
	     */
	    setYoyo: function (value)
	    {
	        if (value === undefined) { value = false; }
	
	        this._yoyo = value;
	
	        return this.parent;
	    },
	
	    /**
	     * Gets if the current Animation will yoyo when it reaches the end.
	     * A yoyo'ing animation will play through consecutively, and then reverse-play back to the start again.
	     *
	     * @method Phaser.GameObjects.Components.Animation#getYoyo
	     * @since 3.4.0
	     *
	     * @return {boolean} `true` if the animation is set to yoyo, `false` if not.
	     */
	    getYoyo: function ()
	    {
	        return this._yoyo;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Components.Animation#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.animationManager.off('remove', this.remove, this);
	
	        this.animationManager = null;
	        this.parent = null;
	
	        this.currentAnim = null;
	        this.currentFrame = null;
	    }
	
	});
	
	module.exports = Animation;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Commands = __webpack_require__(278);
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the Canvas Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.Graphics#renderCanvas
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
	 * @param {Phaser.GameObjects.Graphics} src - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 * @param {CanvasRenderingContext2D} renderTargetCtx - [description]
	 * @param {boolean} allowClip - [description]
	 */
	var GraphicsCanvasRenderer = function (renderer, src, interpolationPercentage, camera, parentMatrix, renderTargetCtx, allowClip)
	{
	    if (GameObject.RENDER_MASK !== src.renderFlags || (src.cameraFilter > 0 && (src.cameraFilter & camera._id)))
	    {
	        return;
	    }
	
	    var cameraScrollX = camera.scrollX * src.scrollFactorX;
	    var cameraScrollY = camera.scrollY * src.scrollFactorY;
	    var srcX = src.x;
	    var srcY = src.y;
	    var srcScaleX = src.scaleX;
	    var srcScaleY = src.scaleY;
	    var srcRotation = src.rotation;
	    var commandBuffer = src.commandBuffer;
	    var ctx = renderTargetCtx || renderer.currentContext;
	    var lineAlpha = 1.0;
	    var fillAlpha = 1.0;
	    var lineColor = 0;
	    var fillColor = 0;
	    var lineWidth = 1.0;
	    var red = 0;
	    var green = 0;
	    var blue = 0;
	
	    //  Blend Mode
	    if (renderer.currentBlendMode !== src.blendMode)
	    {
	        renderer.currentBlendMode = src.blendMode;
	        ctx.globalCompositeOperation = renderer.blendModes[src.blendMode];
	    }
	
	    //  Alpha
	    if (renderer.currentAlpha !== src.alpha)
	    {
	        renderer.currentAlpha = src.alpha;
	        ctx.globalAlpha = src.alpha;
	    }
	
	    //  Smoothing
	    if (renderer.currentScaleMode !== src.scaleMode)
	    {
	        renderer.currentScaleMode = src.scaleMode;
	    }
	
	    ctx.save();
	    if (parentMatrix)
	    {
	        var matrix = parentMatrix.matrix;
	        ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
	    }
	    ctx.translate(srcX - cameraScrollX, srcY - cameraScrollY);
	    ctx.rotate(srcRotation);
	    ctx.scale(srcScaleX, srcScaleY);
	    ctx.fillStyle = '#fff';
	    ctx.globalAlpha = src.alpha;
	
	    for (var index = 0, length = commandBuffer.length; index < length; ++index)
	    {
	        var commandID = commandBuffer[index];
	
	        switch (commandID)
	        {
	            case Commands.ARC:
	                ctx.arc(
	                    commandBuffer[index + 1],
	                    commandBuffer[index + 2],
	                    commandBuffer[index + 3],
	                    commandBuffer[index + 4],
	                    commandBuffer[index + 5],
	                    commandBuffer[index + 6]
	                );
	                index += 6;
	                break;
	
	            case Commands.LINE_STYLE:
	                lineWidth = commandBuffer[index + 1];
	                lineColor = commandBuffer[index + 2];
	                lineAlpha = commandBuffer[index + 3];
	                red = ((lineColor & 0xFF0000) >>> 16);
	                green = ((lineColor & 0xFF00) >>> 8);
	                blue = (lineColor & 0xFF);
	                ctx.strokeStyle = 'rgba(' + red + ',' + green + ',' + blue + ',' + lineAlpha + ')';
	                ctx.lineWidth = lineWidth;
	                index += 3;
	                break;
	
	            case Commands.FILL_STYLE:
	                fillColor = commandBuffer[index + 1];
	                fillAlpha = commandBuffer[index + 2];
	                red = ((fillColor & 0xFF0000) >>> 16);
	                green = ((fillColor & 0xFF00) >>> 8);
	                blue = (fillColor & 0xFF);
	                ctx.fillStyle = 'rgba(' + red + ',' + green + ',' + blue + ',' + fillAlpha + ')';
	                index += 2;
	                break;
	
	            case Commands.BEGIN_PATH:
	                ctx.beginPath();
	                break;
	
	            case Commands.CLOSE_PATH:
	                ctx.closePath();
	                break;
	
	            case Commands.FILL_PATH:
	                if (!allowClip)
	                {
	                    ctx.fill();
	                }
	                break;
	
	            case Commands.STROKE_PATH:
	                if (!allowClip)
	                {
	                    ctx.stroke();
	                }
	                break;
	
	            case Commands.FILL_RECT:
	                if (!allowClip)
	                {
	                    ctx.fillRect(
	                        commandBuffer[index + 1],
	                        commandBuffer[index + 2],
	                        commandBuffer[index + 3],
	                        commandBuffer[index + 4]
	                    );
	                }
	                else
	                {
	                    ctx.rect(
	                        commandBuffer[index + 1],
	                        commandBuffer[index + 2],
	                        commandBuffer[index + 3],
	                        commandBuffer[index + 4]
	                    );
	                }
	                index += 4;
	                break;
	
	            case Commands.FILL_TRIANGLE:
	                ctx.beginPath();
	                ctx.moveTo(commandBuffer[index + 1], commandBuffer[index + 2]);
	                ctx.lineTo(commandBuffer[index + 3], commandBuffer[index + 4]);
	                ctx.lineTo(commandBuffer[index + 5], commandBuffer[index + 6]);
	                ctx.closePath();
	                if (!allowClip)
	                {
	                    ctx.fill();
	                }
	                index += 6;
	                break;
	
	            case Commands.STROKE_TRIANGLE:
	                ctx.beginPath();
	                ctx.moveTo(commandBuffer[index + 1], commandBuffer[index + 2]);
	                ctx.lineTo(commandBuffer[index + 3], commandBuffer[index + 4]);
	                ctx.lineTo(commandBuffer[index + 5], commandBuffer[index + 6]);
	                ctx.closePath();
	                if (!allowClip)
	                {
	                    ctx.stroke();
	                }
	                index += 6;
	                break;
	
	            case Commands.LINE_TO:
	                ctx.lineTo(
	                    commandBuffer[index + 1],
	                    commandBuffer[index + 2]
	                );
	                index += 2;
	                break;
	
	            case Commands.MOVE_TO:
	                ctx.moveTo(
	                    commandBuffer[index + 1],
	                    commandBuffer[index + 2]
	                );
	                index += 2;
	                break;
	
	            case Commands.LINE_FX_TO:
	                ctx.lineTo(
	                    commandBuffer[index + 1],
	                    commandBuffer[index + 2]
	                );
	                index += 5;
	                break;
	
	            case Commands.MOVE_FX_TO:
	                ctx.moveTo(
	                    commandBuffer[index + 1],
	                    commandBuffer[index + 2]
	                );
	                index += 5;
	                break;
	
	            case Commands.SAVE:
	                ctx.save();
	                break;
	
	            case Commands.RESTORE:
	                ctx.restore();
	                break;
	
	            case Commands.TRANSLATE:
	                ctx.translate(
	                    commandBuffer[index + 1],
	                    commandBuffer[index + 2]
	                );
	                index += 2;
	                break;
	
	            case Commands.SCALE:
	                ctx.scale(
	                    commandBuffer[index + 1],
	                    commandBuffer[index + 2]
	                );
	                index += 2;
	                break;
	
	            case Commands.ROTATE:
	                ctx.rotate(
	                    commandBuffer[index + 1]
	                );
	                index += 1;
	                break;
	
	            default:
	                // console.error('Phaser: Invalid Graphics Command ID ' + commandID);
	                break;
	        }
	    }
	
	    ctx.restore();
	};
	
	module.exports = GraphicsCanvasRenderer;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Utils = __webpack_require__(87);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class Light
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {number} x - The horizontal position of the light.
	 * @param {number} y - The vertical position of the light.
	 * @param {number} radius - The radius of the light.
	 * @param {number} r - The red color. A value between 0 and 1.
	 * @param {number} g - The green color. A value between 0 and 1.
	 * @param {number} b - The blue color. A value between 0 and 1.
	 * @param {number} intensity - The intensity of the light.
	 */
	var Light = new Class({
	
	    initialize:
	
	    function Light (x, y, radius, r, g, b, intensity)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Light#x
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.x = x;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Light#y
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.y = y;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Light#radius
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.radius = radius;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Light#r
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.r = r;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Light#g
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.g = g;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Light#b
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.b = b;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Light#intensity
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.intensity = intensity;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Light#scrollFactorX
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.scrollFactorX = 1.0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Light#scrollFactorY
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.scrollFactorY = 1.0;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Light#set
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal position of the light.
	     * @param {number} y - The vertical position of the light.
	     * @param {number} radius - The radius of the light.
	     * @param {number} r - The red color. A value between 0 and 1.
	     * @param {number} g - The green color. A value between 0 and 1.
	     * @param {number} b - The blue color. A value between 0 and 1.
	     * @param {number} intensity - The intensity of the light.
	     *
	     * @return {Phaser.GameObjects.Light} This Light object.
	     */
	    set: function (x, y, radius, r, g, b, intensity)
	    {
	        this.x = x;
	        this.y = y;
	
	        this.radius = radius;
	
	        this.r = r;
	        this.g = g;
	        this.b = b;
	
	        this.intensity = intensity;
	
	        this.scrollFactorX = 1;
	        this.scrollFactorY = 1;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Light#setScrollFactor
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal scroll factor of the light.
	     * @param {number} y - The vertical scroll factor of the light.
	     *
	     * @return {Phaser.GameObjects.Light} This Light object.
	     */
	    setScrollFactor: function (x, y)
	    {
	        if (x === undefined) { x = 1; }
	        if (y === undefined) { y = x; }
	
	        this.scrollFactorX = x;
	        this.scrollFactorY = y;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Light#setColor
	     * @since 3.0.0
	     *
	     * @param {number} rgb - [description]
	     *
	     * @return {Phaser.GameObjects.Light} This Light object.
	     */
	    setColor: function (rgb)
	    {
	        var color = Utils.getFloatsFromUintRGB(rgb);
	        
	        this.r = color[0];
	        this.g = color[1];
	        this.b = color[2];
	        
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Light#setIntensity
	     * @since 3.0.0
	     *
	     * @param {number} intensity - [description]
	     *
	     * @return {Phaser.GameObjects.Light} This Light object.
	     */
	    setIntensity: function (intensity)
	    {
	        this.intensity = intensity;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Light#setPosition
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal position of the light.
	     * @param {number} y - The vertical position of the light.
	     *
	     * @return {Phaser.GameObjects.Light} This Light object.
	     */
	    setPosition: function (x, y)
	    {
	        this.x = x;
	        this.y = y;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Light#setRadius
	     * @since 3.0.0
	     *
	     * @param {number} radius - [description]
	     *
	     * @return {Phaser.GameObjects.Light} This Light object.
	     */
	    setRadius: function (radius)
	    {
	        this.radius = radius;
	
	        return this;
	    }
	
	});
	
	module.exports = Light;


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Light = __webpack_require__(492);
	var LightPipeline = __webpack_require__(323);
	var Utils = __webpack_require__(87);
	
	/**
	 * @callback LightForEach
	 *
	 * @param {Phaser.GameObjects.Light} light - [description]
	 */
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class LightsManager
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @since 3.0.0
	 */
	var LightsManager = new Class({
	
	    initialize:
	
	    function LightsManager ()
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.LightsManager#lightPool
	         * @type {Phaser.GameObjects.Light[]}
	         * @default []
	         * @since 3.0.0
	         */
	        this.lightPool = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.LightsManager#lights
	         * @type {Phaser.GameObjects.Light[]}
	         * @default []
	         * @since 3.0.0
	         */
	        this.lights = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.LightsManager#culledLights
	         * @type {Phaser.GameObjects.Light[]}
	         * @default []
	         * @since 3.0.0
	         */
	        this.culledLights = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.LightsManager#ambientColor
	         * @type {{ r: float, g: float, b: float }}
	         * @since 3.0.0
	         */
	        this.ambientColor = { r: 0.1, g: 0.1, b: 0.1 };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.LightsManager#active
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.active = false;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.LightsManager#enable
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.LightsManager} This Lights Manager object.
	     */
	    enable: function ()
	    {
	        this.active = true;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.LightsManager#disable
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.LightsManager} This Lights Manager object.
	     */
	    disable: function ()
	    {
	        this.active = false;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.LightsManager#cull
	     * @since 3.0.0
	     *
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     *
	     * @return {Phaser.GameObjects.Light[]} [description]
	     */
	    cull: function (camera)
	    {
	        var lights = this.lights;
	        var culledLights = this.culledLights;
	        var length = lights.length;
	        var cameraCenterX = camera.x + camera.width / 2.0;
	        var cameraCenterY = camera.y + camera.height / 2.0;
	        var cameraRadius = (camera.width + camera.height) / 2.0;
	        var point = { x: 0, y: 0 };
	        var cameraMatrix = camera.matrix;
	        var viewportHeight = this.systems.game.config.height;
	
	        culledLights.length = 0;
	
	        for (var index = 0; index < length && culledLights.length < LightPipeline.LIGHT_COUNT; ++index)
	        {
	            var light = lights[index];
	
	            cameraMatrix.transformPoint(light.x, light.y, point);
	
	            // We'll just use bounding spheres to test
	            // if lights should be rendered
	            var dx = cameraCenterX - (point.x - (camera.scrollX * light.scrollFactorX * camera.zoom));
	            var dy = cameraCenterY - (viewportHeight - (point.y - (camera.scrollY * light.scrollFactorY) * camera.zoom));
	            var distance = Math.sqrt(dx * dx + dy * dy);
	
	            if (distance < light.radius + cameraRadius)
	            {
	                culledLights.push(lights[index]);
	            }
	        }
	
	        return culledLights;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.LightsManager#forEachLight
	     * @since 3.0.0
	     *
	     * @param {LightForEach} callback - [description]
	     *
	     * @return {Phaser.GameObjects.LightsManager} This Lights Manager object.
	     */
	    forEachLight: function (callback)
	    {
	        if (!callback)
	        {
	            return;
	        }
	
	        var lights = this.lights;
	        var length = lights.length;
	
	        for (var index = 0; index < length; ++index)
	        {
	            callback(lights[index]);
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.LightsManager#setAmbientColor
	     * @since 3.0.0
	     *
	     * @param {number} rgb - [description]
	     *
	     * @return {Phaser.GameObjects.LightsManager} This Lights Manager object.
	     */
	    setAmbientColor: function (rgb)
	    {
	        var color = Utils.getFloatsFromUintRGB(rgb);
	
	        this.ambientColor.r = color[0];
	        this.ambientColor.g = color[1];
	        this.ambientColor.b = color[2];
	
	        return this;
	    },
	
	    /**
	     * Returns the maximum number of Lights allowed to appear at once.
	     *
	     * @method Phaser.GameObjects.LightsManager#getMaxVisibleLights
	     * @since 3.0.0
	     *
	     * @return {integer} [description]
	     */
	    getMaxVisibleLights: function ()
	    {
	        return 10;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.LightsManager#getLightCount
	     * @since 3.0.0
	     *
	     * @return {integer} [description]
	     */
	    getLightCount: function ()
	    {
	        return this.lights.length;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.LightsManager#addLight
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} radius - [description]
	     * @param {number} rgb - [description]
	     * @param {number} intensity - [description]
	     *
	     * @return {Phaser.GameObjects.Light} [description]
	     */
	    addLight: function (x, y, radius, rgb, intensity)
	    {
	        var color = null;
	        var light = null;
	
	        x = (x === undefined) ? 0.0 : x;
	        y = (y === undefined) ? 0.0 : y;
	        rgb = (rgb === undefined) ? 0xffffff : rgb;
	        radius = (radius === undefined) ? 100.0 : radius;
	        intensity = (intensity === undefined) ? 1.0 : intensity;
	
	        color = Utils.getFloatsFromUintRGB(rgb);
	        light = null;
	
	        if (this.lightPool.length > 0)
	        {
	            light = this.lightPool.pop();
	            light.set(x, y, radius, color[0], color[1], color[2], intensity);
	        }
	        else
	        {
	            light = new Light(x, y, radius, color[0], color[1], color[2], intensity);
	        }
	
	        this.lights.push(light);
	
	        return light;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.LightsManager#removeLight
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Light} light - [description]
	     *
	     * @return {Phaser.GameObjects.LightsManager} This Lights Manager object.
	     */
	    removeLight: function (light)
	    {
	        var index = this.lights.indexOf(light);
	
	        if (index >= 0)
	        {
	            this.lightPool.push(light);
	            this.lights.splice(index, 1);
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.LightsManager#shutdown
	     * @since 3.0.0
	     */
	    shutdown: function ()
	    {
	        while (this.lights.length > 0)
	        {
	            this.lightPool.push(this.lights.pop());
	        }
	
	        this.ambientColor = { r: 0.1, g: 0.1, b: 0.1 };
	        this.culledLights.length = 0;
	        this.lights.length = 0;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.LightsManager#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.shutdown();
	    }
	
	});
	
	module.exports = LightsManager;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var GetFastValue = __webpack_require__(3);
	
	/**
	 * @typedef {object} GravityWellConfig
	 *
	 * @property {number} [x=0] - The x coordinate of the Gravity Well, in world space.
	 * @property {number} [y=0] - The y coordinate of the Gravity Well, in world space.
	 * @property {number} [power=0] - The power of the Gravity Well.
	 * @property {number} [epsilon=100] - [description]
	 * @property {number} [gravity=50] - The gravitational force of this Gravity Well.
	 */
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class GravityWell
	 * @memberOf Phaser.GameObjects.Particles
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {(number|GravityWellConfig)} [x=0] - The x coordinate of the Gravity Well, in world space.
	 * @param {number} [y=0] - The y coordinate of the Gravity Well, in world space.
	 * @param {number} [power=0] - The power of the Gravity Well.
	 * @param {number} [epsilon=100] - [description]
	 * @param {number} [gravity=50] - The gravitational force of this Gravity Well.
	 */
	var GravityWell = new Class({
	
	    initialize:
	
	    function GravityWell (x, y, power, epsilon, gravity)
	    {
	        if (typeof x === 'object')
	        {
	            var config = x;
	
	            x = GetFastValue(config, 'x', 0);
	            y = GetFastValue(config, 'y', 0);
	            power = GetFastValue(config, 'power', 0);
	            epsilon = GetFastValue(config, 'epsilon', 100);
	            gravity = GetFastValue(config, 'gravity', 50);
	        }
	        else
	        {
	            if (x === undefined) { x = 0; }
	            if (y === undefined) { y = 0; }
	            if (power === undefined) { power = 0; }
	            if (epsilon === undefined) { epsilon = 100; }
	            if (gravity === undefined) { gravity = 50; }
	        }
	
	        /**
	         * The x coordinate of the Gravity Well, in world space.
	         *
	         * @name Phaser.GameObjects.Particles.GravityWell#x
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.x = x;
	
	        /**
	         * The y coordinate of the Gravity Well, in world space.
	         *
	         * @name Phaser.GameObjects.Particles.GravityWell#y
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.y = y;
	
	        /**
	         * The active state of the Gravity Well. An inactive Gravity Well will not influence any particles.
	         *
	         * @name Phaser.GameObjects.Particles.GravityWell#active
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.active = true;
	
	        /**
	         * Internal gravity value.
	         *
	         * @name Phaser.GameObjects.Particles.GravityWell#_gravity
	         * @type {number}
	         * @private
	         * @since 3.0.0
	         */
	        this._gravity = gravity;
	
	        /**
	         * Internal power value.
	         *
	         * @name Phaser.GameObjects.Particles.GravityWell#_power
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._power = 0;
	
	        /**
	         * Internal epsilon value.
	         *
	         * @name Phaser.GameObjects.Particles.GravityWell#_epsilon
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._epsilon = 0;
	
	        /**
	         * The power of the Gravity Well.
	         *
	         * @name Phaser.GameObjects.Particles.GravityWell#power
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.power = power;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Particles.GravityWell#epsilon
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.epsilon = epsilon;
	    },
	
	    /**
	     * Takes a Particle and updates it based on the properties of this Gravity Well.
	     *
	     * @method Phaser.GameObjects.Particles.GravityWell#update
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Particles.Particle} particle - The Particle to update.
	     * @param {number} delta - The delta time in ms.
	     * @param {float} step - The delta value divided by 1000.
	     */
	    update: function (particle, delta)
	    {
	        var x = this.x - particle.x;
	        var y = this.y - particle.y;
	        var dSq = x * x + y * y;
	
	        if (dSq === 0)
	        {
	            return;
	        }
	
	        var d = Math.sqrt(dSq);
	
	        if (dSq < this._epsilon)
	        {
	            dSq = this._epsilon;
	        }
	
	        var factor = ((this._power * delta) / (dSq * d)) * 100;
	
	        particle.velocityX += x * factor;
	        particle.velocityY += y * factor;
	    },
	
	    epsilon: {
	
	        get: function ()
	        {
	            return Math.sqrt(this._epsilon);
	        },
	
	        set: function (value)
	        {
	            this._epsilon = value * value;
	        }
	
	    },
	
	    power: {
	
	        get: function ()
	        {
	            return this._power / this._gravity;
	        },
	
	        set: function (value)
	        {
	            this._power = value * this._gravity;
	        }
	
	    },
	
	    gravity: {
	
	        get: function ()
	        {
	            return this._gravity;
	        },
	
	        set: function (value)
	        {
	            var pwr = this.power;
	            this._gravity = value;
	            this.power = pwr;
	        }
	
	    }
	
	});
	
	module.exports = GravityWell;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var DegToRad = __webpack_require__(97);
	var DistanceBetween = __webpack_require__(116);
	
	/**
	 * @classdesc
	 * A Particle is a simple Game Object controlled by a Particle Emitter and Manager, and rendered by the Manager.
	 * It uses its own lightweight physics system, and can interact only with its Emitter's bounds and zones.
	 *
	 * @class Particle
	 * @memberOf Phaser.GameObjects.Particles
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - The Emitter to which this Particle belongs.
	 */
	var Particle = new Class({
	
	    initialize:
	
	    function Particle (emitter)
	    {
	        /**
	         * The Emitter to which this Particle belongs.
	         *
	         * A Particle can only belong to a single Emitter and is created, updated and destroyed via it.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#emitter
	         * @type {Phaser.GameObjects.Particles.ParticleEmitter}
	         * @since 3.0.0
	         */
	        this.emitter = emitter;
	
	        /**
	         * The texture frame used to render this Particle.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#frame
	         * @type {Phaser.Textures.Frame}
	         * @default null
	         * @since 3.0.0
	         */
	        this.frame = null;
	
	        /**
	         * The position of this Particle within its Emitter's particle pool.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#index
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.index = 0;
	
	        /**
	         * The x coordinate of this Particle.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#x
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.x = 0;
	
	        /**
	         * The y coordinate of this Particle.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#y
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.y = 0;
	
	        /**
	         * The x velocity of this Particle.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#velocityX
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.velocityX = 0;
	
	        /**
	         * The y velocity of this Particle.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#velocityY
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.velocityY = 0;
	
	        /**
	         * The x acceleration of this Particle.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#accelerationX
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.accelerationX = 0;
	
	        /**
	         * The y acceleration of this Particle.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#accelerationY
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.accelerationY = 0;
	
	        /**
	         * The maximum horizontal velocity this Particle can travel at.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#maxVelocityX
	         * @type {number}
	         * @default 10000
	         * @since 3.0.0
	         */
	        this.maxVelocityX = 10000;
	
	        /**
	         * The maximum vertical velocity this Particle can travel at.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#maxVelocityY
	         * @type {number}
	         * @default 10000
	         * @since 3.0.0
	         */
	        this.maxVelocityY = 10000;
	
	        /**
	         * The bounciness, or restitution, of this Particle.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#bounce
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.bounce = 0;
	
	        /**
	         * The horizontal scale of this Particle.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#scaleX
	         * @type {float}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.scaleX = 1;
	
	        /**
	         * The vertical scale of this Particle.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#scaleY
	         * @type {float}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.scaleY = 1;
	
	        /**
	         * The alpha value of this Particle.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#alpha
	         * @type {float}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.alpha = 1;
	
	        /**
	         * The angle of this Particle in degrees.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#angle
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.angle = 0;
	
	        /**
	         * The angle of this Particle in radians.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#rotation
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.rotation = 0;
	
	        /**
	         * The tint applied to this Particle.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#tint
	         * @type {number}
	         * @webglOnly
	         * @since 3.0.0
	         */
	        this.tint = 0xffffffff;
	
	        /**
	         * The full color of this Particle, computed from its alpha and tint.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#color
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.color = 0xffffffff;
	
	        /**
	         * The lifespan of this Particle in ms.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#life
	         * @type {number}
	         * @default 1000
	         * @since 3.0.0
	         */
	        this.life = 1000;
	
	        /**
	         * The current life of this Particle in ms.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#lifeCurrent
	         * @type {number}
	         * @default 1000
	         * @since 3.0.0
	         */
	        this.lifeCurrent = 1000;
	
	        /**
	         * The delay applied to this Particle upon emission, in ms.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#delayCurrent
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.delayCurrent = 0;
	
	        /**
	         * The normalized lifespan T value, where 0 is the start and 1 is the end.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#lifeT
	         * @type {float}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.lifeT = 0;
	
	        /**
	         * The data used by the ease equation.
	         *
	         * @name Phaser.GameObjects.Particles.Particle#data
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.data = {
	            tint: { min: 0xffffff, max: 0xffffff, current: 0xffffff },
	            alpha: { min: 1, max: 1 },
	            rotate: { min: 0, max: 0 },
	            scaleX: { min: 1, max: 1 },
	            scaleY: { min: 1, max: 1 }
	        };
	    },
	
	    /**
	     * Checks to see if this Particle is alive and updating.
	     *
	     * @method Phaser.GameObjects.Particles.Particle#isAlive
	     * @since 3.0.0
	     *
	     * @return {boolean} `true` if this Particle is alive and updating, otherwise `false`.
	     */
	    isAlive: function ()
	    {
	        return (this.lifeCurrent > 0);
	    },
	
	    /**
	     * Starts this Particle from the given coordinates.
	     *
	     * @method Phaser.GameObjects.Particles.Particle#fire
	     * @since 3.0.0
	     *
	     * @param {number} x - The x coordinate to launch this Particle from.
	     * @param {number} y - The y coordinate to launch this Particle from.
	     */
	    fire: function (x, y)
	    {
	        var emitter = this.emitter;
	
	        this.frame = emitter.getFrame();
	
	        if (emitter.emitZone)
	        {
	            //  Updates particle.x and particle.y during this call
	            emitter.emitZone.getPoint(this);
	        }
	
	        if (x === undefined)
	        {
	            if (emitter.follow)
	            {
	                this.x += emitter.follow.x + emitter.followOffset.x;
	            }
	
	            this.x += emitter.x.onEmit(this, 'x');
	        }
	        else
	        {
	            this.x += x;
	        }
	
	        if (y === undefined)
	        {
	            if (emitter.follow)
	            {
	                this.y += emitter.follow.y + emitter.followOffset.y;
	            }
	
	            this.y += emitter.y.onEmit(this, 'y');
	        }
	        else
	        {
	            this.y += y;
	        }
	
	        this.life = emitter.lifespan.onEmit(this, 'lifespan');
	        this.lifeCurrent = this.life;
	        this.lifeT = 0;
	
	        var sx = emitter.speedX.onEmit(this, 'speedX');
	        var sy = (emitter.speedY) ? emitter.speedY.onEmit(this, 'speedY') : sx;
	
	        if (emitter.radial)
	        {
	            var rad = DegToRad(emitter.angle.onEmit(this, 'angle'));
	
	            this.velocityX = Math.cos(rad) * Math.abs(sx);
	            this.velocityY = Math.sin(rad) * Math.abs(sy);
	        }
	        else if (emitter.moveTo)
	        {
	            var mx = emitter.moveToX.onEmit(this, 'moveToX');
	            var my = (emitter.moveToY) ? emitter.moveToY.onEmit(this, 'moveToY') : mx;
	
	            var angle = Math.atan2(my - this.y, mx - this.x);
	
	            var speed = DistanceBetween(this.x, this.y, mx, my) / (this.life / 1000);
	
	            //  We know how many pixels we need to move, but how fast?
	            // var speed = this.distanceToXY(displayObject, x, y) / (maxTime / 1000);
	
	            this.velocityX = Math.cos(angle) * speed;
	            this.velocityY = Math.sin(angle) * speed;
	        }
	        else
	        {
	            this.velocityX = sx;
	            this.velocityY = sy;
	        }
	
	        if (emitter.acceleration)
	        {
	            this.accelerationX = emitter.accelerationX.onEmit(this, 'accelerationX');
	            this.accelerationY = emitter.accelerationY.onEmit(this, 'accelerationY');
	        }
	
	        this.maxVelocityX = emitter.maxVelocityX.onEmit(this, 'maxVelocityX');
	        this.maxVelocityY = emitter.maxVelocityY.onEmit(this, 'maxVelocityY');
	
	        this.delayCurrent = emitter.delay.onEmit(this, 'delay');
	
	        this.scaleX = emitter.scaleX.onEmit(this, 'scaleX');
	        this.scaleY = (emitter.scaleY) ? emitter.scaleY.onEmit(this, 'scaleY') : this.scaleX;
	
	        this.angle = emitter.rotate.onEmit(this, 'rotate');
	        this.rotation = DegToRad(this.angle);
	
	        this.bounce = emitter.bounce.onEmit(this, 'bounce');
	
	        this.alpha = emitter.alpha.onEmit(this, 'alpha');
	
	        this.tint = emitter.tint.onEmit(this, 'tint');
	
	        this.color = (this.tint & 0x00FFFFFF) | (((this.alpha * 0xFF) | 0) << 24);
	
	        this.index = emitter.alive.length;
	    },
	
	    /**
	     * An internal method that calculates the velocity of the Particle.
	     *
	     * @method Phaser.GameObjects.Particles.Particle#computeVelocity
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - The Emitter that is updating this Particle.
	     * @param {number} delta - The delta time in ms.
	     * @param {float} step - The delta value divided by 1000.
	     * @param {array} processors - Particle processors (gravity wells).
	     */
	    computeVelocity: function (emitter, delta, step, processors)
	    {
	        var vx = this.velocityX;
	        var vy = this.velocityY;
	
	        var ax = this.accelerationX;
	        var ay = this.accelerationY;
	
	        var mx = this.maxVelocityX;
	        var my = this.maxVelocityY;
	
	        vx += (emitter.gravityX * step);
	        vy += (emitter.gravityY * step);
	
	        if (ax)
	        {
	            vx += (ax * step);
	        }
	
	        if (ay)
	        {
	            vy += (ay * step);
	        }
	
	        if (vx > mx)
	        {
	            vx = mx;
	        }
	        else if (vx < -mx)
	        {
	            vx = -mx;
	        }
	
	        if (vy > my)
	        {
	            vy = my;
	        }
	        else if (vy < -my)
	        {
	            vy = -my;
	        }
	
	        this.velocityX = vx;
	        this.velocityY = vy;
	
	        //  Apply any additional processors
	        for (var i = 0; i < processors.length; i++)
	        {
	            processors[i].update(this, delta, step);
	        }
	    },
	
	    /**
	     * Checks if this Particle is still within the bounds defined by the given Emitter.
	     *
	     * If not, and depending on the Emitter collision flags, the Particle may either stop or rebound.
	     *
	     * @method Phaser.GameObjects.Particles.Particle#checkBounds
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - The Emitter to check the bounds against.
	     */
	    checkBounds: function (emitter)
	    {
	        var bounds = emitter.bounds;
	        var bounce = -this.bounce;
	
	        if (this.x < bounds.x && emitter.collideLeft)
	        {
	            this.x = bounds.x;
	            this.velocityX *= bounce;
	        }
	        else if (this.x > bounds.right && emitter.collideRight)
	        {
	            this.x = bounds.right;
	            this.velocityX *= bounce;
	        }
	
	        if (this.y < bounds.y && emitter.collideTop)
	        {
	            this.y = bounds.y;
	            this.velocityY *= bounce;
	        }
	        else if (this.y > bounds.bottom && emitter.collideBottom)
	        {
	            this.y = bounds.bottom;
	            this.velocityY *= bounce;
	        }
	    },
	
	    /**
	     * The main update method for this Particle.
	     *
	     * Updates its life values, computes the velocity and repositions the Particle.
	     *
	     * @method Phaser.GameObjects.Particles.Particle#update
	     * @since 3.0.0
	     *
	     * @param {number} delta - The delta time in ms.
	     * @param {float} step - The delta value divided by 1000.
	     * @param {array} processors - An optional array of update processors.
	     *
	     * @return {boolean} Returns `true` if this Particle has now expired and should be removed, otherwise `false` if still active.
	     */
	    update: function (delta, step, processors)
	    {
	        if (this.delayCurrent > 0)
	        {
	            this.delayCurrent -= delta;
	
	            return false;
	        }
	
	        var emitter = this.emitter;
	
	        //  How far along in life is this particle? (t = 0 to 1)
	        var t = 1 - (this.lifeCurrent / this.life);
	
	        this.lifeT = t;
	
	        this.computeVelocity(emitter, delta, step, processors);
	
	        this.x += this.velocityX * step;
	        this.y += this.velocityY * step;
	
	        if (emitter.bounds)
	        {
	            this.checkBounds(emitter);
	        }
	
	        if (emitter.deathZone && emitter.deathZone.willKill(this))
	        {
	            this.lifeCurrent = 0;
	
	            //  No need to go any further, particle has been killed
	            return true;
	        }
	
	        this.scaleX = emitter.scaleX.onUpdate(this, 'scaleX', t, this.scaleX);
	
	        if (emitter.scaleY)
	        {
	            this.scaleY = emitter.scaleY.onUpdate(this, 'scaleY', t, this.scaleY);
	        }
	        else
	        {
	            this.scaleY = this.scaleX;
	        }
	
	        this.angle = emitter.rotate.onUpdate(this, 'rotate', t, this.angle);
	        this.rotation = DegToRad(this.angle);
	
	        this.alpha = emitter.alpha.onUpdate(this, 'alpha', t, this.alpha);
	
	        this.tint = emitter.tint.onUpdate(this, 'tint', t, this.tint);
	
	        this.color = (this.tint & 0x00FFFFFF) | (((this.alpha * 0xFF) | 0) << 24);
	
	        this.lifeCurrent -= delta;
	
	        return (this.lifeCurrent <= 0);
	    }
	
	});
	
	module.exports = Particle;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BlendModes = __webpack_require__(145);
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(28);
	var DeathZone = __webpack_require__(497);
	var EdgeZone = __webpack_require__(498);
	var EmitterOp = __webpack_require__(1163);
	var GetFastValue = __webpack_require__(3);
	var GetRandom = __webpack_require__(339);
	var HasAny = __webpack_require__(664);
	var HasValue = __webpack_require__(147);
	var Particle = __webpack_require__(495);
	var RandomZone = __webpack_require__(499);
	var Rectangle = __webpack_require__(23);
	var StableSort = __webpack_require__(219);
	var Vector2 = __webpack_require__(9);
	var Wrap = __webpack_require__(98);
	
	/**
	 * @callback ParticleEmitterCallback
	 *
	 * @param {Phaser.GameObjects.Particles.Particle} particle - The particle associated with the call.
	 * @param {Phaser.GameObjects.Particles.ParticleEmitter} emitter - This particle emitter associated with the call.
	 */
	
	/**
	 * @callback ParticleDeathCallback
	 *
	 * @param {Phaser.GameObjects.Particles.Particle} particle - The particle that died.
	*/
	
	/**
	 * @typedef {object} ParticleEmitterBounds
	 *
	 * @property {float} x - The left edge of the rectangle.
	 * @property {float} y - The top edge of the rectangle.
	 * @property {float} width - The width of the rectangle.
	 * @property {float} height - The height of the rectangle.
	 *
	 * @see Phaser.GameObjects.Particles.ParticleEmitter#setBounds
	 */
	
	/**
	 * @typedef {object} ParticleEmitterBoundsAlt
	 *
	 * @property {float} x - The left edge of the rectangle.
	 * @property {float} y - The top edge of the rectangle.
	 * @property {float} w - The width of the rectangle.
	 * @property {float} h - The height of the rectangle.
	 *
	 * @see Phaser.GameObjects.Particles.ParticleEmitter#setBounds
	 */
	
	/**
	 * @typedef {object} ParticleEmitterDeathZoneConfig
	 *
	 * @property {DeathZoneSource} source - A shape representing the zone. See {@link Phaser.GameObjects.Particles.Zones.DeathZone#source}.
	 * @property {string} [type='onEnter'] - 'onEnter' or 'onLeave'.
	 */
	
	/**
	 * @typedef {object} ParticleEmitterEdgeZoneConfig
	 *
	 * @property {EdgeZoneSource} source - A shape representing the zone. See {@link Phaser.GameObjects.Particles.Zones.EdgeZone#source}.
	 * @property {string} type - 'edge'.
	 * @property {integer} quantity - The number of particles to place on the source edge. Set to 0 to use `stepRate` instead.
	 * @property {float} [stepRate] - The distance between each particle. When set, `quantity` is implied and should be set to 0.
	 * @property {boolean} [yoyo=false] - Whether particles are placed from start to end and then end to start.
	 * @property {boolean} [seamless=true] - Whether one endpoint will be removed if it's identical to the other.
	 */
	
	/**
	 * @typedef {object} ParticleEmitterRandomZoneConfig
	 *
	 * @property {RandomZoneSource} source - A shape representing the zone. See {@link Phaser.GameObjects.Particles.Zones.RandomZone#source}.
	 * @property {string} [type] - 'random'.
	 */
	
	/**
	 * @typedef {object} ParticleEmitterConfig
	 *
	 * @property {boolean} [active] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#active}.
	 * @property {integer} [blendMode] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#blendMode}.
	 * @property {*} [callbackScope] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#deathCallbackScope} and {@link Phaser.GameObjects.Particles.ParticleEmitter#emitCallbackScope}.
	 * @property {boolean} [collideBottom] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#collideBottom}.
	 * @property {boolean} [collideLeft] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#collideLeft}.
	 * @property {boolean} [collideRight] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#collideRight}.
	 * @property {boolean} [collideTop] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#collideTop}.
	 * @property {boolean} [deathCallback] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#deathCallback}.
	 * @property {*} [deathCallbackScope] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#deathCallbackScope}.
	 * @property {function} [emitCallback] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#emitCallback}.
	 * @property {*} [emitCallbackScope] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#emitCallbackScope}.
	 * @property {Phaser.GameObjects.GameObject} [follow] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#follow}.
	 * @property {float} [frequency] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#frequency}.
	 * @property {float} [gravityX] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#gravityX}.
	 * @property {float} [gravityY] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#gravityY}.
	 * @property {integer} [maxParticles] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#maxParticles}.
	 * @property {string} [name] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#name}.
	 * @property {boolean} [on] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#on}.
	 * @property {boolean} [particleBringToTop] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#particleBringToTop}.
	 * @property {Phaser.GameObjects.Particles.Particle} [particleClass] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#particleClass}.
	 * @property {boolean} [radial] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#radial}.
	 * @property {float} [timeScale] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#timeScale}.
	 * @property {boolean} [trackVisible] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#trackVisible}.
	 * @property {boolean} [visible] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#visible}.
	 * @property {float|float[]|EmitterOpOnEmitCallback|object} [accelerationX] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#accelerationX} (emit only).
	 * @property {float|float[]|EmitterOpOnEmitCallback|object} [accelerationY] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#accelerationY} (emit only).
	 * @property {float|float[]|EmitterOpOnUpdateCallback|object} [alpha] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#alpha}.
	 * @property {float|float[]|EmitterOpOnEmitCallback|object} [angle] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#angle} (emit only)
	 * @property {float|float[]|EmitterOpOnEmitCallback|object} [bounce] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#bounce} (emit only).
	 * @property {float|float[]|EmitterOpOnEmitCallback|object} [delay] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#delay} (emit only).
	 * @property {float|float[]|EmitterOpOnEmitCallback|object} [lifespan] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#lifespan} (emit only).
	 * @property {float|float[]|EmitterOpOnEmitCallback|object} [maxVelocityX] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#maxVelocityX} (emit only).
	 * @property {float|float[]|EmitterOpOnEmitCallback|object} [maxVelocityY] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#maxVelocityY} (emit only).
	 * @property {float|float[]|EmitterOpOnEmitCallback|object} [moveToX] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#moveToX} (emit only).
	 * @property {float|float[]|EmitterOpOnEmitCallback|object} [moveToY] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#moveToY} (emit only).
	 * @property {float|float[]|EmitterOpOnEmitCallback|object} [quantity] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#quantity} (emit only).
	 * @property {float|float[]|EmitterOpOnUpdateCallback|object} [rotate] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#rotate}.
	 * @property {float|float[]|EmitterOpOnUpdateCallback|object} [scale] - As {@link Phaser.GameObjects.Particles.ParticleEmitter#setScale}.
	 * @property {float|float[]|EmitterOpOnUpdateCallback|object} [scaleX] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#scaleX}.
	 * @property {float|float[]|EmitterOpOnUpdateCallback|object} [scaleY] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#scaleY}.
	 * @property {float|float[]|EmitterOpOnEmitCallback|object} [speed] - As {@link Phaser.GameObjects.Particles.ParticleEmitter#setSpeed} (emit only).
	 * @property {float|float[]|EmitterOpOnEmitCallback|object} [speedX] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#speedX} (emit only).
	 * @property {float|float[]|EmitterOpOnEmitCallback|object} [speedY] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#speedY} (emit only).
	 * @property {float|float[]|EmitterOpOnEmitCallback|object} [tint] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#tint}.
	 * @property {float|float[]|EmitterOpOnEmitCallback|object} [x] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#x} (emit only).
	 * @property {float|float[]|EmitterOpOnEmitCallback|object} [y] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#y} (emit only).
	 * @property {object} [emitZone] - As {@link Phaser.GameObjects.Particles.ParticleEmitter#setEmitZone}.
	 * @property {ParticleEmitterBounds|ParticleEmitterBoundsAlt} [bounds] - As {@link Phaser.GameObjects.Particles.ParticleEmitter#setBounds}.
	 * @property {object} [followOffset] - Assigns to {@link Phaser.GameObjects.Particles.ParticleEmitter#followOffset}.
	 * @property {float} [followOffset.x] - x-coordinate of the offset.
	 * @property {float} [followOffset.y] - y-coordinate of the offset.
	 * @property {number|number[]|string|string[]|Phaser.Textures.Frame|Phaser.Textures.Frame[]|ParticleEmitterFrameConfig} [frames] - Sets {@link Phaser.GameObjects.Particles.ParticleEmitter#frames}.
	 */
	
	/**
	 * @typedef {object} ParticleEmitterFrameConfig
	 *
	 * @property {number|number[]|string|string[]|Phaser.Textures.Frame|Phaser.Textures.Frame[]} [frames] - One or more texture frames.
	 * @property {boolean} [cycle] - Whether texture frames will be assigned consecutively (true) or at random (false).
	 * @property {integer} [quantity] - The number of consecutive particles receiving each texture frame, when `cycle` is true.
	 */
	
	/**
	 * @classdesc
	 * A particle emitter represents a single particle stream.
	 * It controls a pool of {@link Phaser.GameObjects.Particles.Particle Particles} and is controlled by a {@link Phaser.GameObjects.Particles.ParticleEmitterManager Particle Emitter Manager}.
	 *
	 * @class ParticleEmitter
	 * @memberOf Phaser.GameObjects.Particles
	 * @constructor
	 * @since 3.0.0
	 *
	 * @extends Phaser.GameObjects.Components.BlendMode
	 * @extends Phaser.GameObjects.Components.Mask
	 * @extends Phaser.GameObjects.Components.ScrollFactor
	 * @extends Phaser.GameObjects.Components.Visible
	 *
	 * @param {Phaser.GameObjects.Particles.ParticleEmitterManager} manager - The Emitter Manager this Emitter belongs to.
	 * @param {ParticleEmitterConfig} config - Settings for this emitter.
	 */
	var ParticleEmitter = new Class({
	
	    Mixins: [
	        Components.BlendMode,
	        Components.Mask,
	        Components.ScrollFactor,
	        Components.Visible
	    ],
	
	    initialize:
	
	    function ParticleEmitter (manager, config)
	    {
	        /**
	         * The Emitter Manager this Emitter belongs to.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#manager
	         * @type {Phaser.GameObjects.Particles.ParticleEmitterManager}
	         * @since 3.0.0
	         */
	        this.manager = manager;
	
	        /**
	         * The texture assigned to particles.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#texture
	         * @type {Phaser.Textures.Texture}
	         * @since 3.0.0
	         */
	        this.texture = manager.texture;
	
	        /**
	         * The texture frames assigned to particles.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#frames
	         * @type {Phaser.Textures.Frame[]}
	         * @since 3.0.0
	         */
	        this.frames = [ manager.defaultFrame ];
	
	        /**
	         * The default texture frame assigned to particles.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#defaultFrame
	         * @type {Phaser.Textures.Frame}
	         * @since 3.0.0
	         */
	        this.defaultFrame = manager.defaultFrame;
	
	        /**
	         * Names of simple configuration properties.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#configFastMap
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.configFastMap = [
	            'active',
	            'blendMode',
	            'collideBottom',
	            'collideLeft',
	            'collideRight',
	            'collideTop',
	            'deathCallback',
	            'deathCallbackScope',
	            'emitCallback',
	            'emitCallbackScope',
	            'follow',
	            'frequency',
	            'gravityX',
	            'gravityY',
	            'maxParticles',
	            'name',
	            'on',
	            'particleBringToTop',
	            'particleClass',
	            'radial',
	            'timeScale',
	            'trackVisible',
	            'visible'
	        ];
	
	        /**
	         * Names of complex configuration properties.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#configOpMap
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.configOpMap = [
	            'accelerationX',
	            'accelerationY',
	            'angle',
	            'alpha',
	            'bounce',
	            'delay',
	            'lifespan',
	            'maxVelocityX',
	            'maxVelocityY',
	            'moveToX',
	            'moveToY',
	            'quantity',
	            'rotate',
	            'scaleX',
	            'scaleY',
	            'speedX',
	            'speedY',
	            'tint',
	            'x',
	            'y'
	        ];
	
	        /**
	         * The name of this Particle Emitter.
	         *
	         * Empty by default and never populated by Phaser, this is left for developers to use.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#name
	         * @type {string}
	         * @default ''
	         * @since 3.0.0
	         */
	        this.name = '';
	
	        /**
	         * The Particle Class which will be emitted by this Emitter.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#particleClass
	         * @type {Phaser.GameObjects.Particles.Particle}
	         * @default Phaser.GameObjects.Particles.Particle
	         * @since 3.0.0
	         */
	        this.particleClass = Particle;
	
	        /**
	         * The x-coordinate of the particle origin (where particles will be emitted).
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#x
	         * @type {Phaser.GameObjects.Particles.EmitterOp}
	         * @default 0
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setPosition
	         */
	        this.x = new EmitterOp(config, 'x', 0);
	
	        /**
	         * The y-coordinate of the particle origin (where particles will be emitted).
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#y
	         * @type {Phaser.GameObjects.Particles.EmitterOp}
	         * @default 0
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setPosition
	         */
	        this.y = new EmitterOp(config, 'y', 0);
	
	        /**
	         * A radial emitter will emit particles in all directions between angle min and max,
	         * using {@link Phaser.GameObjects.Particles.ParticleEmitter#speed} as the value. If set to false then this acts as a point Emitter.
	         * A point emitter will emit particles only in the direction derived from the speedX and speedY values.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#radial
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setRadial
	         */
	        this.radial = true;
	
	        /**
	         * Horizontal acceleration applied to emitted particles, in pixels per second squared.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#gravityX
	         * @type {float}
	         * @default 0
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setGravity
	         */
	        this.gravityX = 0;
	
	        /**
	         * Vertical acceleration applied to emitted particles, in pixels per second squared.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#gravityY
	         * @type {float}
	         * @default 0
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setGravity
	         */
	        this.gravityY = 0;
	
	        /**
	         * Whether accelerationX and accelerationY are nonzero. Set automatically during configuration.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#acceleration
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.acceleration = false;
	
	        /**
	         * Horizontal acceleration applied to emitted particles, in pixels per second squared.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#accelerationX
	         * @type {Phaser.GameObjects.Particles.EmitterOp}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.accelerationX = new EmitterOp(config, 'accelerationX', 0, true);
	
	        /**
	         * Vertical acceleration applied to emitted particles, in pixels per second squared.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#accelerationY
	         * @type {Phaser.GameObjects.Particles.EmitterOp}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.accelerationY = new EmitterOp(config, 'accelerationY', 0, true);
	
	        /**
	         * The maximum horizontal velocity of emitted particles, in pixels per second squared.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#maxVelocityX
	         * @type {Phaser.GameObjects.Particles.EmitterOp}
	         * @default 10000
	         * @since 3.0.0
	         */
	        this.maxVelocityX = new EmitterOp(config, 'maxVelocityX', 10000, true);
	
	        /**
	         * The maximum vertical velocity of emitted particles, in pixels per second squared.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#maxVelocityY
	         * @type {Phaser.GameObjects.Particles.EmitterOp}
	         * @default 10000
	         * @since 3.0.0
	         */
	        this.maxVelocityY = new EmitterOp(config, 'maxVelocityY', 10000, true);
	
	        /**
	         * The initial horizontal speed of emitted particles, in pixels per second.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#speedX
	         * @type {Phaser.GameObjects.Particles.EmitterOp}
	         * @default 0
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setSpeedX
	         */
	        this.speedX = new EmitterOp(config, 'speedX', 0, true);
	
	        /**
	         * The initial vertical speed of emitted particles, in pixels per second.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#speedY
	         * @type {Phaser.GameObjects.Particles.EmitterOp}
	         * @default 0
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setSpeedY
	         */
	        this.speedY = new EmitterOp(config, 'speedY', 0, true);
	
	        /**
	         * Whether moveToX and moveToY are nonzero. Set automatically during configuration.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#moveTo
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.moveTo = false;
	
	        /**
	         * The x-coordinate emitted particles move toward, when {@link Phaser.GameObjects.Particles.ParticleEmitter#moveTo} is true.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#moveToX
	         * @type {Phaser.GameObjects.Particles.EmitterOp}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.moveToX = new EmitterOp(config, 'moveToX', 0, true);
	
	        /**
	         * The y-coordinate emitted particles move toward, when {@link Phaser.GameObjects.Particles.ParticleEmitter#moveTo} is true.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#moveToY
	         * @type {Phaser.GameObjects.Particles.EmitterOp}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.moveToY = new EmitterOp(config, 'moveToY', 0, true);
	
	        /**
	         * Whether particles will rebound when they meet the emitter bounds.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#bounce
	         * @type {Phaser.GameObjects.Particles.EmitterOp}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.bounce = new EmitterOp(config, 'bounce', 0, true);
	
	        /**
	         * The horizontal scale of emitted particles.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#scaleX
	         * @type {Phaser.GameObjects.Particles.EmitterOp}
	         * @default 1
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setScale
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setScaleX
	         */
	        this.scaleX = new EmitterOp(config, 'scaleX', 1);
	
	        /**
	         * The vertical scale of emitted particles.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#scaleY
	         * @type {Phaser.GameObjects.Particles.EmitterOp}
	         * @default 1
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setScale
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setScaleY
	         */
	        this.scaleY = new EmitterOp(config, 'scaleY', 1);
	
	        /**
	         * Color tint applied to emitted particles. Any alpha component (0xAA000000) is ignored.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#tint
	         * @type {Phaser.GameObjects.Particles.EmitterOp}
	         * @default 0xffffffff
	         * @since 3.0.0
	         */
	        this.tint = new EmitterOp(config, 'tint', 0xffffffff);
	
	        /**
	         * The alpha (transparency) of emitted particles.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#alpha
	         * @type {Phaser.GameObjects.Particles.EmitterOp}
	         * @default 1
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setAlpha
	         */
	        this.alpha = new EmitterOp(config, 'alpha', 1);
	
	        /**
	         * The lifespan of emitted particles, in ms.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#lifespan
	         * @type {Phaser.GameObjects.Particles.EmitterOp}
	         * @default 1000
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setLifespan
	         */
	        this.lifespan = new EmitterOp(config, 'lifespan', 1000);
	
	        /**
	         * The angle of the initial velocity of emitted particles, in degrees.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#angle
	         * @type {Phaser.GameObjects.Particles.EmitterOp}
	         * @default { min: 0, max: 360 }
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setAngle
	         */
	        this.angle = new EmitterOp(config, 'angle', { min: 0, max: 360 });
	
	        /**
	         * The rotation of emitted particles, in degrees.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#rotate
	         * @type {Phaser.GameObjects.Particles.EmitterOp}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.rotate = new EmitterOp(config, 'rotate', 0);
	
	        /**
	         * A function to call when a particle is emitted.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#emitCallback
	         * @type {?ParticleEmitterCallback}
	         * @default null
	         * @since 3.0.0
	         */
	        this.emitCallback = null;
	
	        /**
	         * The calling context for {@link Phaser.GameObjects.Particles.ParticleEmitter#emitCallback}.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#emitCallbackScope
	         * @type {?*}
	         * @default null
	         * @since 3.0.0
	         */
	        this.emitCallbackScope = null;
	
	        /**
	         * A function to call when a particle dies.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#deathCallback
	         * @type {?ParticleDeathCallback}
	         * @default null
	         * @since 3.0.0
	         */
	        this.deathCallback = null;
	
	        /**
	         * The calling context for {@link Phaser.GameObjects.Particles.ParticleEmitter#deathCallback}.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#deathCallbackScope
	         * @type {?*}
	         * @default null
	         * @since 3.0.0
	         */
	        this.deathCallbackScope = null;
	
	        /**
	         * Set to hard limit the amount of particle objects this emitter is allowed to create.
	         * 0 means unlimited.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#maxParticles
	         * @type {integer}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.maxParticles = 0;
	
	        /**
	         * How many particles are emitted each time particles are emitted (one explosion or one flow cycle).
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#quantity
	         * @type {Phaser.GameObjects.Particles.EmitterOp}
	         * @default 1
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setFrequency
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setQuantity
	         */
	        this.quantity = new EmitterOp(config, 'quantity', 1, true);
	
	        /**
	         * How many ms to wait after emission before the particles start updating.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#delay
	         * @type {Phaser.GameObjects.Particles.EmitterOp}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.delay = new EmitterOp(config, 'delay', 0, true);
	
	        /**
	         * For a flow emitter, the time interval (>= 0) between particle flow cycles in ms.
	         * A value of 0 means there is one particle flow cycle for each logic update (the maximum flow frequency). This is the default setting.
	         * For an exploding emitter, this value will be -1.
	         * Calling {@link Phaser.GameObjects.Particles.ParticleEmitter#flow} also puts the emitter in flow mode (frequency >= 0).
	         * Calling {@link Phaser.GameObjects.Particles.ParticleEmitter#explode} also puts the emitter in explode mode (frequency = -1).
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#frequency
	         * @type {float}
	         * @default 0
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setFrequency
	         */
	        this.frequency = 0;
	
	        /**
	         * Controls if the emitter is currently emitting a particle flow (when frequency >= 0).
	         * Already alive particles will continue to update until they expire.
	         * Controlled by {@link Phaser.GameObjects.Particles.ParticleEmitter#start}.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#on
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.on = true;
	
	        /**
	         * Newly emitted particles are added to the top of the particle list, i.e. rendered above those already alive.
	         * Set to false to send them to the back.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#particleBringToTop
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.particleBringToTop = true;
	
	        /**
	         * The time rate applied to active particles, affecting lifespan, movement, and tweens. Values larger than 1 are faster than normal.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#timeScale
	         * @type {float}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.timeScale = 1;
	
	        /**
	         * An object describing a shape to emit particles from.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#emitZone
	         * @type {?Phaser.GameObjects.Particles.Zones.EdgeZone|Phaser.GameObjects.Particles.Zones.RandomZone}
	         * @default null
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setEmitZone
	         */
	        this.emitZone = null;
	
	        /**
	         * An object describing a shape that deactivates particles when they interact with it.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#deathZone
	         * @type {?Phaser.GameObjects.Particles.Zones.DeathZone}
	         * @default null
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setDeathZone
	         */
	        this.deathZone = null;
	
	        /**
	         * A rectangular boundary constraining particle movement.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#bounds
	         * @type {?Phaser.Geom.Rectangle}
	         * @default null
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setBounds
	         */
	        this.bounds = null;
	
	        /**
	         * Whether particles interact with the left edge of the emitter {@link Phaser.GameObjects.Particles.ParticleEmitter#bounds}.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#collideLeft
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.collideLeft = true;
	
	        /**
	         * Whether particles interact with the right edge of the emitter {@link Phaser.GameObjects.Particles.ParticleEmitter#bounds}.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#collideRight
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.collideRight = true;
	
	        /**
	         * Whether particles interact with the top edge of the emitter {@link Phaser.GameObjects.Particles.ParticleEmitter#bounds}.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#collideTop
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.collideTop = true;
	
	        /**
	         * Whether particles interact with the bottom edge of the emitter {@link Phaser.GameObjects.Particles.ParticleEmitter#bounds}.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#collideBottom
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.collideBottom = true;
	
	        /**
	         * Whether this emitter updates itself and its particles.
	         *
	         * Controlled by {@link Phaser.GameObjects.Particles.ParticleEmitter#pause}
	         * and {@link Phaser.GameObjects.Particles.ParticleEmitter#resume}.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#active
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.active = true;
	
	        /**
	         * Set this to false to hide any active particles.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#visible
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setVisible
	         */
	        this.visible = true;
	
	        /**
	         * The blend mode of this emitter's particles.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#blendMode
	         * @type {integer}
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setBlendMode
	         */
	        this.blendMode = BlendModes.NORMAL;
	
	        /**
	         * A Game Object whose position is used as the particle origin.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#follow
	         * @type {?Phaser.GameObjects.GameObject}
	         * @default null
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#startFollow
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#stopFollow
	         */
	        this.follow = null;
	
	        /**
	         * The offset of the particle origin from the {@link Phaser.GameObjects.Particles.ParticleEmitter#follow} target.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#followOffset
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#startFollow
	         */
	        this.followOffset = new Vector2();
	
	        /**
	         * Whether the emitter's {@link Phaser.GameObjects.Particles.ParticleEmitter#visible} state will track
	         * the {@link Phaser.GameObjects.Particles.ParticleEmitter#follow} target's visibility state.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#trackVisible
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#startFollow
	         */
	        this.trackVisible = false;
	
	        /**
	         * The current texture frame, as an index of {@link Phaser.GameObjects.Particles.ParticleEmitter#frames}.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#currentFrame
	         * @type {integer}
	         * @default 0
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setFrame
	         */
	        this.currentFrame = 0;
	
	        /**
	         * Whether texture {@link Phaser.GameObjects.Particles.ParticleEmitter#frames} are selected at random.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#randomFrame
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setFrame
	         */
	        this.randomFrame = true;
	
	        /**
	         * The number of consecutive particles that receive a single texture frame (per frame cycle).
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#frameQuantity
	         * @type {integer}
	         * @default 1
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Particles.ParticleEmitter#setFrame
	         */
	        this.frameQuantity = 1;
	
	        /**
	         * Inactive particles.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#dead
	         * @type {Phaser.GameObjects.Particles.Particle[]}
	         * @private
	         * @since 3.0.0
	         */
	        this.dead = [];
	
	        /**
	         * Active particles
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#alive
	         * @type {Phaser.GameObjects.Particles.Particle[]}
	         * @private
	         * @since 3.0.0
	         */
	        this.alive = [];
	
	        /**
	         * The time until the next flow cycle.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#_counter
	         * @type {float}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._counter = 0;
	
	        /**
	         * Counts up to {@link Phaser.GameObjects.Particles.ParticleEmitter#frameQuantity}.
	         *
	         * @name Phaser.GameObjects.Particles.ParticleEmitter#_frameCounter
	         * @type {integer}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._frameCounter = 0;
	
	        if (config)
	        {
	            this.fromJSON(config);
	        }
	    },
	
	    /**
	     * Merges configuration settings into the emitter's current settings.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#fromJSON
	     * @since 3.0.0
	     *
	     * @param {ParticleEmitterConfig} config - Settings for this emitter.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    fromJSON: function (config)
	    {
	        if (!config)
	        {
	            return this;
	        }
	
	        //  Only update properties from their current state if they exist in the given config
	
	        var i = 0;
	        var key = '';
	
	        for (i = 0; i < this.configFastMap.length; i++)
	        {
	            key = this.configFastMap[i];
	
	            if (HasValue(config, key))
	            {
	                this[key] = GetFastValue(config, key);
	            }
	        }
	
	        for (i = 0; i < this.configOpMap.length; i++)
	        {
	            key = this.configOpMap[i];
	
	            if (HasValue(config, key))
	            {
	                this[key].loadConfig(config);
	            }
	        }
	
	        this.acceleration = (this.accelerationX.propertyValue !== 0 || this.accelerationY.propertyValue !== 0);
	
	        this.moveTo = (this.moveToX.propertyValue !== 0 || this.moveToY.propertyValue !== 0);
	
	        //  Special 'speed' override
	
	        if (HasValue(config, 'speed'))
	        {
	            this.speedX.loadConfig(config, 'speed');
	            this.speedY = null;
	        }
	
	        //  If you specify speedX, speedY or moveTo then it changes the emitter from radial to a point emitter
	        if (HasAny(config, [ 'speedX', 'speedY' ]) || this.moveTo)
	        {
	            this.radial = false;
	        }
	
	        //  Special 'scale' override
	
	        if (HasValue(config, 'scale'))
	        {
	            this.scaleX.loadConfig(config, 'scale');
	            this.scaleY = null;
	        }
	
	        if (HasValue(config, 'callbackScope'))
	        {
	            var callbackScope = GetFastValue(config, 'callbackScope', null);
	
	            this.emitCallbackScope = callbackScope;
	            this.deathCallbackScope = callbackScope;
	        }
	
	        if (HasValue(config, 'emitZone'))
	        {
	            this.setEmitZone(config.emitZone);
	        }
	
	        if (HasValue(config, 'deathZone'))
	        {
	            this.setDeathZone(config.deathZone);
	        }
	
	        if (HasValue(config, 'bounds'))
	        {
	            this.setBounds(config.bounds);
	        }
	
	        if (HasValue(config, 'followOffset'))
	        {
	            this.followOffset.setFromObject(GetFastValue(config, 'followOffset', 0));
	        }
	
	        if (HasValue(config, 'frame'))
	        {
	            this.setFrame(config.frame);
	        }
	
	        return this;
	    },
	
	    /**
	     * Creates a description of this emitter suitable for JSON serialization.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#toJSON
	     * @since 3.0.0
	     *
	     * @param {object} [output] - An object to copy output into.
	     *
	     * @return {object} - The output object.
	     */
	    toJSON: function (output)
	    {
	        if (output === undefined) { output = {}; }
	
	        var i = 0;
	        var key = '';
	
	        for (i = 0; i < this.configFastMap.length; i++)
	        {
	            key = this.configFastMap[i];
	
	            output[key] = this[key];
	        }
	
	        for (i = 0; i < this.configOpMap.length; i++)
	        {
	            key = this.configOpMap[i];
	
	            if (this[key])
	            {
	                output[key] = this[key].toJSON();
	            }
	        }
	
	        //  special handlers
	        if (!this.speedY)
	        {
	            delete output.speedX;
	            output.speed = this.speedX.toJSON();
	        }
	
	        if (!this.scaleY)
	        {
	            delete output.scaleX;
	            output.scale = this.scaleX.toJSON();
	        }
	
	        return output;
	    },
	
	    /**
	     * Continuously moves the particle origin to follow a Game Object's position.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#startFollow
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Particles.Particle} target - The Game Object to follow.
	     * @param {float} [offsetX=0] - Horizontal offset of the particle origin from the Game Object.
	     * @param {float} [offsetY=0] - Vertical offset of the particle origin from the Game Object.
	     * @param {boolean} [trackVisible=false] - Whether the emitter's visible state will track the target's visible state.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    startFollow: function (target, offsetX, offsetY, trackVisible)
	    {
	        if (offsetX === undefined) { offsetX = 0; }
	        if (offsetY === undefined) { offsetY = 0; }
	        if (trackVisible === undefined) { trackVisible = false; }
	
	        this.follow = target;
	        this.followOffset.set(offsetX, offsetY);
	        this.trackVisible = trackVisible;
	
	        return this;
	    },
	
	    /**
	     * Stops following a Game Object.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#stopFollow
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    stopFollow: function ()
	    {
	        this.follow = null;
	        this.followOffset.set(0, 0);
	        this.trackVisible = false;
	
	        return this;
	    },
	
	    /**
	     * Chooses a texture frame from {@link Phaser.GameObjects.Particles.ParticleEmitter#frames}.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#getFrame
	     * @since 3.0.0
	     *
	     * @return {Phaser.Textures.Frame} The texture frame.
	     */
	    getFrame: function ()
	    {
	        if (this.frames.length === 1)
	        {
	            return this.defaultFrame;
	        }
	        else if (this.randomFrame)
	        {
	            return GetRandom(this.frames);
	        }
	        else
	        {
	            var frame = this.frames[this.currentFrame];
	
	            this._frameCounter++;
	
	            if (this._frameCounter === this.frameQuantity)
	            {
	                this._frameCounter = 0;
	                this.currentFrame = Wrap(this.currentFrame + 1, 0, this._frameLength);
	            }
	
	            return frame;
	        }
	    },
	
	    // frame: 0
	    // frame: 'red'
	    // frame: [ 0, 1, 2, 3 ]
	    // frame: [ 'red', 'green', 'blue', 'pink', 'white' ]
	    // frame: { frames: [ 'red', 'green', 'blue', 'pink', 'white' ], [cycle: bool], [quantity: int] }
	
	    /**
	     * Sets a pattern for assigning texture frames to emitted particles.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#setFrame
	     * @since 3.0.0
	     *
	     * @param {(array|string|integer|ParticleEmitterFrameConfig)} frames - One or more texture frames, or a configuration object.
	     * @param {boolean} [pickRandom=true] - Whether frames should be assigned at random from `frames`.
	     * @param {integer} [quantity=1] - The number of consecutive particles that will receive each frame.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    setFrame: function (frames, pickRandom, quantity)
	    {
	        if (pickRandom === undefined) { pickRandom = true; }
	        if (quantity === undefined) { quantity = 1; }
	
	        this.randomFrame = pickRandom;
	        this.frameQuantity = quantity;
	        this.currentFrame = 0;
	        this._frameCounter = 0;
	
	        var t = typeof (frames);
	
	        if (Array.isArray(frames) || t === 'string' || t === 'number')
	        {
	            this.manager.setEmitterFrames(frames, this);
	        }
	        else if (t === 'object')
	        {
	            var frameConfig = frames;
	
	            frames = GetFastValue(frameConfig, 'frames', null);
	
	            if (frames)
	            {
	                this.manager.setEmitterFrames(frames, this);
	            }
	
	            var isCycle = GetFastValue(frameConfig, 'cycle', false);
	
	            this.randomFrame = (isCycle) ? false : true;
	
	            this.frameQuantity = GetFastValue(frameConfig, 'quantity', quantity);
	        }
	
	        this._frameLength = this.frames.length;
	
	        if (this._frameLength === 1)
	        {
	            this.frameQuantity = 1;
	            this.randomFrame = false;
	        }
	
	        return this;
	    },
	
	    /**
	     * Turns {@link Phaser.GameObjects.Particles.ParticleEmitter#radial} particle movement on or off.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#setRadial
	     * @since 3.0.0
	     *
	     * @param {boolean} [value=true] - Radial mode (true) or point mode (true).
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    setRadial: function (value)
	    {
	        if (value === undefined) { value = true; }
	
	        this.radial = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the position of the emitter's particle origin.
	     * New particles will be emitted here.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#setPosition
	     * @since 3.0.0
	     *
	     * @param {float|float[]|EmitterOpOnEmitCallback|object} x - The x-coordinate of the particle origin.
	     * @param {float|float[]|EmitterOpOnEmitCallback|object} y - The y-coordinate of the particle origin.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    setPosition: function (x, y)
	    {
	        this.x.onChange(x);
	        this.y.onChange(y);
	
	        return this;
	    },
	
	    /**
	     * Sets or modifies a rectangular boundary constraining the particles.
	     *
	     * To remove the boundary, set {@link Phaser.GameObjects.Particles.ParticleEmitter#bounds} to null.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#setBounds
	     * @since 3.0.0
	     *
	     * @param {(number|ParticleEmitterBounds|ParticleEmitterBoundsAlt)} x - The x-coordinate of the left edge of the boundary, or an object representing a rectangle.
	     * @param {float} y - The y-coordinate of the top edge of the boundary.
	     * @param {float} width - The width of the boundary.
	     * @param {float} height - The height of the boundary.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    setBounds: function (x, y, width, height)
	    {
	        if (typeof x === 'object')
	        {
	            var obj = x;
	
	            x = obj.x;
	            y = obj.y;
	            width = (HasValue(obj, 'w')) ? obj.w : obj.width;
	            height = (HasValue(obj, 'h')) ? obj.h : obj.height;
	        }
	
	        if (this.bounds)
	        {
	            this.bounds.setTo(x, y, width, height);
	        }
	        else
	        {
	            this.bounds = new Rectangle(x, y, width, height);
	        }
	
	        return this;
	    },
	
	    /**
	     * Sets the initial horizontal speed of emitted particles.
	     * Changes the emitter to point mode.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#setSpeedX
	     * @since 3.0.0
	     *
	     * @param {float|float[]|EmitterOpOnEmitCallback|object} value - The speed, in pixels per second.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    setSpeedX: function (value)
	    {
	        this.speedX.onChange(value);
	
	        //  If you specify speedX and Y then it changes the emitter from radial to a point emitter
	        this.radial = false;
	
	        return this;
	    },
	
	    /**
	     * Sets the initial vertical speed of emitted particles.
	     * Changes the emitter to point mode.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#setSpeedY
	     * @since 3.0.0
	     *
	     * @param {float|float[]|EmitterOpOnEmitCallback|object} value - The speed, in pixels per second.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    setSpeedY: function (value)
	    {
	        if (this.speedY)
	        {
	            this.speedY.onChange(value);
	
	            //  If you specify speedX and Y then it changes the emitter from radial to a point emitter
	            this.radial = false;
	        }
	
	        return this;
	    },
	
	    /**
	     * Sets the initial radial speed of emitted particles.
	     * Changes the emitter to radial mode.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#setSpeed
	     * @since 3.0.0
	     *
	     * @param {float|float[]|EmitterOpOnEmitCallback|object} value - The speed, in pixels per second.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    setSpeed: function (value)
	    {
	        this.speedX.onChange(value);
	        this.speedY = null;
	
	        //  If you specify speedX and Y then it changes the emitter from radial to a point emitter
	        this.radial = true;
	
	        return this;
	    },
	
	    /**
	     * Sets the horizontal scale of emitted particles.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#setScaleX
	     * @since 3.0.0
	     *
	     * @param {float|float[]|EmitterOpOnUpdateCallback|object} value - The scale, relative to 1.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    setScaleX: function (value)
	    {
	        this.scaleX.onChange(value);
	
	        return this;
	    },
	
	    /**
	     * Sets the vertical scale of emitted particles.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#setScaleY
	     * @since 3.0.0
	     *
	     * @param {float|float[]|EmitterOpOnUpdateCallback|object} value - The scale, relative to 1.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    setScaleY: function (value)
	    {
	        this.scaleY.onChange(value);
	
	        return this;
	    },
	
	    /**
	     * Sets the scale of emitted particles.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#setScale
	     * @since 3.0.0
	     *
	     * @param {float|float[]|EmitterOpOnUpdateCallback|object} value - The scale, relative to 1.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    setScale: function (value)
	    {
	        this.scaleX.onChange(value);
	        this.scaleY = null;
	
	        return this;
	    },
	
	    /**
	     * Sets the horizontal gravity applied to emitted particles.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#setGravityX
	     * @since 3.0.0
	     *
	     * @param {float} value - Acceleration due to gravity, in pixels per second squared.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    setGravityX: function (value)
	    {
	        this.gravityX = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the vertical gravity applied to emitted particles.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#setGravityY
	     * @since 3.0.0
	     *
	     * @param {float} value - Acceleration due to gravity, in pixels per second squared.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    setGravityY: function (value)
	    {
	        this.gravityY = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the gravity applied to emitted particles.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#setGravity
	     * @since 3.0.0
	     *
	     * @param {float} x - Horizontal acceleration due to gravity, in pixels per second squared.
	     * @param {float} y - Vertical acceleration due to gravity, in pixels per second squared.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    setGravity: function (x, y)
	    {
	        this.gravityX = x;
	        this.gravityY = y;
	
	        return this;
	    },
	
	    /**
	     * Sets the opacity of emitted particles.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#setAlpha
	     * @since 3.0.0
	     *
	     * @param {float|float[]|EmitterOpOnUpdateCallback|object} value - A value between 0 (transparent) and 1 (opaque).
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    setAlpha: function (value)
	    {
	        this.alpha.onChange(value);
	
	        return this;
	    },
	
	    /**
	     * Sets the angle of a {@link Phaser.GameObjects.Particles.ParticleEmitter#radial} particle stream.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#setEmitterAngle
	     * @since 3.0.0
	     *
	     * @param {float|float[]|EmitterOpOnEmitCallback|object} value - The angle of the initial velocity of emitted particles.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    setEmitterAngle: function (value)
	    {
	        this.angle.onChange(value);
	
	        return this;
	    },
	
	    /**
	     * Sets the angle of a {@link Phaser.GameObjects.Particles.ParticleEmitter#radial} particle stream.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#setAngle
	     * @since 3.0.0
	     *
	     * @param {float|float[]|EmitterOpOnEmitCallback|object} value - The angle of the initial velocity of emitted particles.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    setAngle: function (value)
	    {
	        this.angle.onChange(value);
	
	        return this;
	    },
	
	    /**
	     * Sets the lifespan of newly emitted particles.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#setLifespan
	     * @since 3.0.0
	     *
	     * @param {float|float[]|EmitterOpOnEmitCallback|object} value - The particle lifespan, in ms.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    setLifespan: function (value)
	    {
	        this.lifespan.onChange(value);
	
	        return this;
	    },
	
	    /**
	     * Sets the number of particles released at each flow cycle or explosion.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#setQuantity
	     * @since 3.0.0
	     *
	     * @param {float|float[]|EmitterOpOnEmitCallback|object} quantity - The number of particles to release at each flow cycle or explosion.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    setQuantity: function (quantity)
	    {
	        this.quantity.onChange(quantity);
	
	        return this;
	    },
	
	    /**
	     * Sets the emitter's {@link Phaser.GameObjects.Particles.ParticleEmitter#frequency}
	     * and {@link Phaser.GameObjects.Particles.ParticleEmitter#quantity}.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#setFrequency
	     * @since 3.0.0
	     *
	     * @param {float} frequency - The time interval (>= 0) of each flow cycle, in ms; or -1 to put the emitter in explosion mode.
	     * @param {float|float[]|EmitterOpOnEmitCallback|object} [quantity] - The number of particles to release at each flow cycle or explosion.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    setFrequency: function (frequency, quantity)
	    {
	        this.frequency = frequency;
	
	        this._counter = 0;
	
	        if (quantity)
	        {
	            this.quantity.onChange(quantity);
	        }
	
	        return this;
	    },
	
	    /**
	     * Sets or removes the {@link Phaser.GameObjects.Particles.ParticleEmitter#emitZone}.
	     *
	     * An {@link ParticleEmitterEdgeZoneConfig EdgeZone} places particles on its edges. Its {@link EdgeZoneSource source} can be a Curve, Path, Circle, Ellipse, Line, Polygon, Rectangle, or Triangle; or any object with a suitable {@link EdgeZoneSourceCallback getPoints} method.
	     *
	     * A {@link ParticleEmitterRandomZoneConfig RandomZone} places randomly within its interior. Its {@link RandomZoneSource source} can be a Circle, Ellipse, Line, Polygon, Rectangle, or Triangle; or any object with a suitable {@link RandomZoneSourceCallback getRandomPoint} method.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#setEmitZone
	     * @since 3.0.0
	     *
	     * @param {ParticleEmitterEdgeZoneConfig|ParticleEmitterRandomZoneConfig} [zoneConfig] - An object describing the zone, or `undefined` to remove any current emit zone.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    setEmitZone: function (zoneConfig)
	    {
	        if (zoneConfig === undefined)
	        {
	            this.emitZone = null;
	        }
	        else
	        {
	            //  Where source = Geom like Circle, or a Path or Curve
	            //  emitZone: { type: 'random', source: X }
	            //  emitZone: { type: 'edge', source: X, quantity: 32, [stepRate=0], [yoyo=false], [seamless=true] }
	
	            var type = GetFastValue(zoneConfig, 'type', 'random');
	            var source = GetFastValue(zoneConfig, 'source', null);
	
	            switch (type)
	            {
	                case 'random':
	
	                    this.emitZone = new RandomZone(source);
	
	                    break;
	
	                case 'edge':
	
	                    var quantity = GetFastValue(zoneConfig, 'quantity', 1);
	                    var stepRate = GetFastValue(zoneConfig, 'stepRate', 0);
	                    var yoyo = GetFastValue(zoneConfig, 'yoyo', false);
	                    var seamless = GetFastValue(zoneConfig, 'seamless', true);
	
	                    this.emitZone = new EdgeZone(source, quantity, stepRate, yoyo, seamless);
	
	                    break;
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Sets or removes the {@link Phaser.GameObjects.Particles.ParticleEmitter#deathZone}.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#setDeathZone
	     * @since 3.0.0
	     *
	     * @param {ParticleEmitterDeathZoneConfig} [zoneConfig] - An object describing the zone, or `undefined` to remove any current death zone.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    setDeathZone: function (zoneConfig)
	    {
	        if (zoneConfig === undefined)
	        {
	            this.deathZone = null;
	        }
	        else
	        {
	            //  Where source = Geom like Circle or Rect that supports a 'contains' function
	            //  deathZone: { type: 'onEnter', source: X }
	            //  deathZone: { type: 'onLeave', source: X }
	
	            var type = GetFastValue(zoneConfig, 'type', 'onEnter');
	            var source = GetFastValue(zoneConfig, 'source', null);
	
	            if (source && typeof source.contains === 'function')
	            {
	                var killOnEnter = (type === 'onEnter') ? true : false;
	
	                this.deathZone = new DeathZone(source, killOnEnter);
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Creates inactive particles and adds them to this emitter's pool.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#reserve
	     * @since 3.0.0
	     *
	     * @param {integer} particleCount - The number of particles to create.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    reserve: function (particleCount)
	    {
	        var dead = this.dead;
	
	        for (var i = 0; i < particleCount; i++)
	        {
	            dead.push(new this.particleClass(this));
	        }
	
	        return this;
	    },
	
	    /**
	     * Gets the number of active (in-use) particles in this emitter.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#getAliveParticleCount
	     * @since 3.0.0
	     *
	     * @return {integer} The number of particles with `active=true`.
	     */
	    getAliveParticleCount: function ()
	    {
	        return this.alive.length;
	    },
	
	    /**
	     * Gets the number of inactive (available) particles in this emitter.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#getDeadParticleCount
	     * @since 3.0.0
	     *
	     * @return {integer} The number of particles with `active=false`.
	     */
	    getDeadParticleCount: function ()
	    {
	        return this.dead.length;
	    },
	
	    /**
	     * Gets the total number of particles in this emitter.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#getParticleCount
	     * @since 3.0.0
	     *
	     * @return {integer} The number of particles, including both alive and dead.
	     */
	    getParticleCount: function ()
	    {
	        return this.getAliveParticleCount() + this.getDeadParticleCount();
	    },
	
	    /**
	     * Whether this emitter is at its limit (if set).
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#atLimit
	     * @since 3.0.0
	     *
	     * @return {boolean} Returns `true` if this Emitter is at its limit, or `false` if no limit, or below the `maxParticles` level.
	     */
	    atLimit: function ()
	    {
	        return (this.maxParticles > 0 && this.getParticleCount() === this.maxParticles);
	    },
	
	    /**
	     * Sets a function to call for each newly emitted particle.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#onParticleEmit
	     * @since 3.0.0
	     *
	     * @param {ParticleEmitterCallback} callback - The function.
	     * @param {*} [context] - The calling context.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    onParticleEmit: function (callback, context)
	    {
	        if (callback === undefined)
	        {
	            //  Clear any previously set callback
	            this.emitCallback = null;
	            this.emitCallbackScope = null;
	        }
	        else if (typeof callback === 'function')
	        {
	            this.emitCallback = callback;
	
	            if (context)
	            {
	                this.emitCallbackScope = context;
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Sets a function to call for each particle death.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#onParticleDeath
	     * @since 3.0.0
	     *
	     * @param {ParticleDeathCallback} callback - The function.
	     * @param {*} [context] - The function's calling context.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    onParticleDeath: function (callback, context)
	    {
	        if (callback === undefined)
	        {
	            //  Clear any previously set callback
	            this.deathCallback = null;
	            this.deathCallbackScope = null;
	        }
	        else if (typeof callback === 'function')
	        {
	            this.deathCallback = callback;
	
	            if (context)
	            {
	                this.deathCallbackScope = context;
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Deactivates every particle in this emitter.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#killAll
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    killAll: function ()
	    {
	        var dead = this.dead;
	        var alive = this.alive;
	
	        while (alive.length > 0)
	        {
	            dead.push(alive.pop());
	        }
	
	        return this;
	    },
	
	    /**
	     * Calls a function for each active particle in this emitter.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#forEachAlive
	     * @since 3.0.0
	     *
	     * @param {ParticleEmitterCallback} callback - The function.
	     * @param {*} thisArg - The function's calling context.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    forEachAlive: function (callback, thisArg)
	    {
	        var alive = this.alive;
	        var length = alive.length;
	
	        for (var index = 0; index < length; ++index)
	        {
	            //  Sends the Particle and the Emitter
	            callback.call(thisArg, alive[index], this);
	        }
	
	        return this;
	    },
	
	    /**
	     * Calls a function for each inactive particle in this emitter.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#forEachDead
	     * @since 3.0.0
	     *
	     * @param {ParticleEmitterCallback} callback - The function.
	     * @param {*} thisArg - The function's calling context.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    forEachDead: function (callback, thisArg)
	    {
	        var dead = this.dead;
	        var length = dead.length;
	
	        for (var index = 0; index < length; ++index)
	        {
	            //  Sends the Particle and the Emitter
	            callback.call(thisArg, dead[index], this);
	        }
	
	        return this;
	    },
	
	    /**
	     * Turns {@link Phaser.GameObjects.Particles.ParticleEmitter#on} the emitter and resets the flow counter.
	     *
	     * If this emitter is in flow mode (frequency >= 0; the default), the particle flow will start (or restart).
	     *
	     * If this emitter is in explode mode (frequency = -1), nothing will happen.
	     * Use {@link Phaser.GameObjects.Particles.ParticleEmitter#explode} or {@link Phaser.GameObjects.Particles.ParticleEmitter#flow} instead.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#start
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    start: function ()
	    {
	        this.on = true;
	
	        this._counter = 0;
	
	        return this;
	    },
	
	    /**
	     * {@link Phaser.GameObjects.Particles.ParticleEmitter#active Deactivates} the emitter.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#pause
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    pause: function ()
	    {
	        this.active = false;
	
	        return this;
	    },
	
	    /**
	     * {@link Phaser.GameObjects.Particles.ParticleEmitter#active Activates} the emitter.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#resume
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    resume: function ()
	    {
	        this.active = true;
	
	        return this;
	    },
	
	    /**
	     * Sorts active particles with {@link Phaser.GameObjects.Particles.ParticleEmitter#depthSortCallback}.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#depthSort
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    depthSort: function ()
	    {
	        StableSort.inplace(this.alive, this.depthSortCallback);
	
	        return this;
	    },
	
	    /**
	     * Puts the emitter in flow mode (frequency >= 0) and starts (or restarts) a particle flow.
	     *
	     * To resume a flow at the current frequency and quantity, use {@link Phaser.GameObjects.Particles.ParticleEmitter#start} instead.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#flow
	     * @since 3.0.0
	     *
	     * @param {float} frequency - The time interval (>= 0) of each flow cycle, in ms.
	     * @param {float|float[]|EmitterOpOnEmitCallback|object} [count=1] - The number of particles to emit at each flow cycle.
	     *
	     * @return {Phaser.GameObjects.Particles.ParticleEmitter} This Particle Emitter.
	     */
	    flow: function (frequency, count)
	    {
	        if (count === undefined) { count = 1; }
	
	        this.frequency = frequency;
	
	        this.quantity.onChange(count);
	
	        return this.start();
	    },
	
	    /**
	     * Puts the emitter in explode mode (frequency = -1), stopping any current particle flow, and emits several particles all at once.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#explode
	     * @since 3.0.0
	     *
	     * @param {integer} count - The amount of Particles to emit.
	     * @param {float} x - The x coordinate to emit the Particles from.
	     * @param {float} y - The y coordinate to emit the Particles from.
	     *
	     * @return {Phaser.GameObjects.Particles.Particle} The most recently emitted Particle.
	     */
	    explode: function (count, x, y)
	    {
	        this.frequency = -1;
	
	        return this.emitParticle(count, x, y);
	    },
	
	    /**
	     * Emits particles at a given position (or the emitter's current position).
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#emitParticleAt
	     * @since 3.0.0
	     *
	     * @param {float} [x=this.x] - The x coordinate to emit the Particles from.
	     * @param {float} [y=this.x] - The y coordinate to emit the Particles from.
	     * @param {integer} [count=this.quantity] - The number of Particles to emit.
	     *
	     * @return {Phaser.GameObjects.Particles.Particle} The most recently emitted Particle.
	     */
	    emitParticleAt: function (x, y, count)
	    {
	        return this.emitParticle(count, x, y);
	    },
	
	    /**
	     * Emits particles at a given position (or the emitter's current position).
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#emitParticle
	     * @since 3.0.0
	     *
	     * @param {integer} [count=this.quantity] - The number of Particles to emit.
	     * @param {float} [x=this.x] - The x coordinate to emit the Particles from.
	     * @param {float} [y=this.x] - The y coordinate to emit the Particles from.
	     *
	     * @return {Phaser.GameObjects.Particles.Particle} The most recently emitted Particle.
	     *
	     * @see Phaser.GameObjects.Particles.Particle#fire
	     */
	    emitParticle: function (count, x, y)
	    {
	        if (this.atLimit())
	        {
	            return;
	        }
	
	        if (count === undefined)
	        {
	            count = this.quantity.onEmit();
	        }
	
	        var dead = this.dead;
	
	        for (var i = 0; i < count; i++)
	        {
	            var particle;
	
	            if (dead.length > 0)
	            {
	                particle = dead.pop();
	            }
	            else
	            {
	                particle = new this.particleClass(this);
	            }
	
	            particle.fire(x, y);
	
	            if (this.particleBringToTop)
	            {
	                this.alive.push(particle);
	            }
	            else
	            {
	                this.alive.unshift(particle);
	            }
	
	            if (this.emitCallback)
	            {
	                this.emitCallback.call(this.emitCallbackScope, particle, this);
	            }
	
	            if (this.atLimit())
	            {
	                break;
	            }
	        }
	
	        return particle;
	    },
	
	    /**
	     * Updates this emitter and its particles.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#preUpdate
	     * @since 3.0.0
	     *
	     * @param {integer} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
	     * @param {float} delta - The delta time, in ms, elapsed since the last frame.
	     */
	    preUpdate: function (time, delta)
	    {
	        //  Scale the delta
	        delta *= this.timeScale;
	
	        var step = (delta / 1000);
	
	        if (this.trackVisible)
	        {
	            this.visible = this.follow.visible;
	        }
	
	        //  Any particle processors?
	        var processors = this.manager.getProcessors();
	
	        var particles = this.alive;
	        var length = particles.length;
	
	        for (var index = 0; index < length; index++)
	        {
	            var particle = particles[index];
	
	            //  update returns `true` if the particle is now dead (lifeStep < 0)
	            if (particle.update(delta, step, processors))
	            {
	                //  Moves the dead particle to the end of the particles array (ready for splicing out later)
	                var last = particles[length - 1];
	
	                particles[length - 1] = particle;
	                particles[index] = last;
	
	                index -= 1;
	                length -= 1;
	            }
	        }
	
	        //  Move dead particles to the dead array
	        var deadLength = particles.length - length;
	
	        if (deadLength > 0)
	        {
	            var rip = particles.splice(particles.length - deadLength, deadLength);
	
	            var deathCallback = this.deathCallback;
	            var deathCallbackScope = this.deathCallbackScope;
	
	            if (deathCallback)
	            {
	                for (var i = 0; i < rip.length; i++)
	                {
	                    deathCallback.call(deathCallbackScope, rip[i]);
	                }
	            }
	
	            this.dead.concat(rip);
	
	            StableSort.inplace(particles, this.indexSortCallback);
	        }
	
	        if (!this.on)
	        {
	            return;
	        }
	
	        if (this.frequency === 0)
	        {
	            this.emitParticle();
	        }
	        else if (this.frequency > 0)
	        {
	            this._counter -= delta;
	
	            if (this._counter <= 0)
	            {
	                this.emitParticle();
	
	                //  counter = frequency - remained from previous delta
	                this._counter = (this.frequency - Math.abs(this._counter));
	            }
	        }
	    },
	
	    /**
	     * Calculates the difference of two particles, for sorting them by depth.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#depthSortCallback
	     * @since 3.0.0
	     *
	     * @param {object} a - The first particle.
	     * @param {object} b - The second particle.
	     *
	     * @return {integer} The difference of a and b's y coordinates.
	     */
	    depthSortCallback: function (a, b)
	    {
	        return a.y - b.y;
	    },
	
	    /**
	     * Calculates the difference of two particles, for sorting them by index.
	     *
	     * @method Phaser.GameObjects.Particles.ParticleEmitter#indexSortCallback
	     * @since 3.0.0
	     *
	     * @param {object} a - The first particle.
	     * @param {object} b - The second particle.
	     *
	     * @return {integer} The difference of a and b's `index` properties.
	     */
	    indexSortCallback: function (a, b)
	    {
	        return a.index - b.index;
	    }
	
	});
	
	module.exports = ParticleEmitter;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	
	/**
	 * @callback DeathZoneSourceCallback
	 *
	 * @param {float} x - [description]
	 * @param {float} y - [description]
	 *
	 * @return {boolean} - True if the coordinates are within the source area.
	 */
	
	/**
	 * @typedef {object} DeathZoneSource
	 *
	 * @property {DeathZoneSourceCallback} contains
	 *
	 * @see Phaser.Geom.Circle
	 * @see Phaser.Geom.Ellipse
	 * @see Phaser.Geom.Polygon
	 * @see Phaser.Geom.Rectangle
	 * @see Phaser.Geom.Triangle
	 */
	
	/**
	 * @classdesc
	 * A Death Zone.
	 *
	 * A Death Zone is a special type of zone that will kill a Particle as soon as it either enters, or leaves, the zone.
	 *
	 * The zone consists of a `source` which could be a Geometric shape, such as a Rectangle or Ellipse, or your own
	 * object as long as it includes a `contains` method for which the Particles can be tested against.
	 *
	 * @class DeathZone
	 * @memberOf Phaser.GameObjects.Particles.Zones
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {DeathZoneSource} source - An object instance that has a `contains` method that returns a boolean when given `x` and `y` arguments.
	 * @param {boolean} killOnEnter - Should the Particle be killed when it enters the zone? `true` or leaves it? `false`
	 */
	var DeathZone = new Class({
	
	    initialize:
	
	    function DeathZone (source, killOnEnter)
	    {
	        /**
	         * An object instance that has a `contains` method that returns a boolean when given `x` and `y` arguments.
	         * This could be a Geometry shape, such as `Phaser.Geom.Circle`, or your own custom object.
	         *
	         * @name Phaser.GameObjects.Particles.Zones.DeathZone#source
	         * @type {DeathZoneSource}
	         * @since 3.0.0
	         */
	        this.source = source;
	
	        /**
	         * Set to `true` if the Particle should be killed if it enters this zone.
	         * Set to `false` to kill the Particle if it leaves this zone.
	         *
	         * @name Phaser.GameObjects.Particles.Zones.DeathZone#killOnEnter
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.killOnEnter = killOnEnter;
	    },
	
	    /**
	     * Checks if the given Particle will be killed or not by this zone.
	     *
	     * @method Phaser.GameObjects.Particles.Zones.DeathZone#willKill
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Particles.Particle} particle - The Particle to be checked against this zone.
	     *
	     * @return {boolean} Return `true` if the Particle is to be killed, otherwise return `false`.
	     */
	    willKill: function (particle)
	    {
	        var withinZone = this.source.contains(particle.x, particle.y);
	
	        return (withinZone && this.killOnEnter || !withinZone && !this.killOnEnter);
	    }
	
	});
	
	module.exports = DeathZone;


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	
	/**
	 * @callback EdgeZoneSourceCallback
	 *
	 * @param {integer} quantity - [description]
	 * @param {integer} [stepRate] - [description]
	 *
	 * @return {Phaser.Geom.Point[]} - [description]
	 */
	
	/**
	 * @typedef {object} EdgeZoneSource
	 *
	 * @property {EdgeZoneSourceCallback} getPoints - A function placing points on the source's edge or edges.
	 *
	 * @see Phaser.Curves.Curve
	 * @see Phaser.Curves.Path
	 * @see Phaser.Geom.Circle
	 * @see Phaser.Geom.Ellipse
	 * @see Phaser.Geom.Line
	 * @see Phaser.Geom.Polygon
	 * @see Phaser.Geom.Rectangle
	 * @see Phaser.Geom.Triangle
	 */
	
	/**
	 * @classdesc
	 * A zone that places particles on a shape's edges.
	 *
	 * @class EdgeZone
	 * @memberOf Phaser.GameObjects.Particles.Zones
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {EdgeZoneSource} source - An object instance with a `getPoints(quantity, stepRate)` method returning an array of points.
	 * @param {number} quantity - [description]
	 * @param {number} stepRate - [description]
	 * @param {boolean} [yoyo=false] - [description]
	 * @param {boolean} [seamless=true] - [description]
	 */
	var EdgeZone = new Class({
	
	    initialize:
	
	    function EdgeZone (source, quantity, stepRate, yoyo, seamless)
	    {
	        if (yoyo === undefined) { yoyo = false; }
	        if (seamless === undefined) { seamless = true; }
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#source
	         * @type {EdgeZoneSource|RandomZoneSource}
	         * @since 3.0.0
	         */
	        this.source = source;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#points
	         * @type {Phaser.Geom.Point[]}
	         * @default []
	         * @since 3.0.0
	         */
	        this.points = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#quantity
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.quantity = quantity;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#stepRate
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.stepRate = stepRate;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#yoyo
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.yoyo = yoyo;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#counter
	         * @type {number}
	         * @default -1
	         * @since 3.0.0
	         */
	        this.counter = -1;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#seamless
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.seamless = seamless;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#_length
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._length = 0;
	
	        /**
	         * 0 = forwards, 1 = backwards
	         *
	         * @name Phaser.GameObjects.Particles.Zones.EdgeZone#_direction
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._direction = 0;
	
	        this.updateSource();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Particles.Zones.EdgeZone#updateSource
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Particles.Zones.EdgeZone} This Edge Zone.
	     */
	    updateSource: function ()
	    {
	        this.points = this.source.getPoints(this.quantity, this.stepRate);
	
	        //  Remove ends?
	        if (this.seamless)
	        {
	            var a = this.points[0];
	            var b = this.points[this.points.length - 1];
	
	            if (a.x === b.x && a.y === b.y)
	            {
	                this.points.pop();
	            }
	        }
	
	        var oldLength = this._length;
	
	        this._length = this.points.length;
	
	        //  Adjust counter if we now have less points than before
	        if (this._length < oldLength && this.counter > this._length)
	        {
	            this.counter = this._length - 1;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Particles.Zones.EdgeZone#changeSource
	     * @since 3.0.0
	     *
	     * @param {object} source - [description]
	     *
	     * @return {Phaser.GameObjects.Particles.Zones.EdgeZone} This Edge Zone.
	     */
	    changeSource: function (source)
	    {
	        this.source = source;
	
	        return this.updateSource();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Particles.Zones.EdgeZone#getPoint
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Particles.Particle} particle - [description]
	     */
	    getPoint: function (particle)
	    {
	        if (this._direction === 0)
	        {
	            this.counter++;
	
	            if (this.counter >= this._length)
	            {
	                if (this.yoyo)
	                {
	                    this._direction = 1;
	                    this.counter = this._length - 1;
	                }
	                else
	                {
	                    this.counter = 0;
	                }
	            }
	        }
	        else
	        {
	            this.counter--;
	
	            if (this.counter === -1)
	            {
	                if (this.yoyo)
	                {
	                    this._direction = 0;
	                    this.counter = 0;
	                }
	                else
	                {
	                    this.counter = this._length - 1;
	                }
	            }
	        }
	
	        var point = this.points[this.counter];
	
	        if (point)
	        {
	            particle.x = point.x;
	            particle.y = point.y;
	        }
	    }
	
	});
	
	module.exports = EdgeZone;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Vector2 = __webpack_require__(9);
	
	/**
	 * @callback RandomZoneSourceCallback
	 *
	 * @param {Phaser.Math.Vector2} point - A point to modify.
	 */
	
	/**
	 * @typedef {object} RandomZoneSource
	 *
	 * @property {RandomZoneSourceCallback} getRandomPoint - A function modifying its point argument.
	 *
	 * @see Phaser.Geom.Circle
	 * @see Phaser.Geom.Ellipse
	 * @see Phaser.Geom.Line
	 * @see Phaser.Geom.Polygon
	 * @see Phaser.Geom.Rectangle
	 * @see Phaser.Geom.Triangle
	 */
	
	/**
	 * @classdesc
	 * A zone that places particles randomly within a shape's area.
	 *
	 * @class RandomZone
	 * @memberOf Phaser.GameObjects.Particles.Zones
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {RandomZoneSource} source - An object instance with a `getRandomPoint(point)` method.
	 */
	var RandomZone = new Class({
	
	    initialize:
	
	    function RandomZone (source)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Particles.Zones.RandomZone#source
	         * @type {RandomZoneSource}
	         * @since 3.0.0
	         */
	        this.source = source;
	
	        /**
	         * Internal calculation vector.
	         *
	         * @name Phaser.GameObjects.Particles.Zones.RandomZone#_tempVec
	         * @type {Phaser.Math.Vector2}
	         * @private
	         * @since 3.0.0
	         */
	        this._tempVec = new Vector2();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Particles.Zones.RandomZone#getPoint
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Particles.Particle} particle - [description]
	     */
	    getPoint: function (particle)
	    {
	        var vec = this._tempVec;
	
	        this.source.getRandomPoint(vec);
	
	        particle.x = vec.x;
	        particle.y = vec.y;
	    }
	
	});
	
	module.exports = RandomZone;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var DegToRad = __webpack_require__(97);
	var GetBoolean = __webpack_require__(172);
	var GetValue = __webpack_require__(10);
	var Sprite = __webpack_require__(82);
	var TWEEN_CONST = __webpack_require__(174);
	var Vector2 = __webpack_require__(9);
	
	/**
	 * @typedef {object} PathConfig
	 *
	 * @property {number} duration - [description]
	 * @property {number} from - [description]
	 * @property {number} to - [description]
	 * @property {boolean} [positionOnPath=false] - [description]
	 * @property {boolean} [rotateToPath=false] - [description]
	 * @property {number} [rotationOffset=0] - [description]
	 * @property {boolean} [verticalAdjust=false] - [description]
	 */
	
	/**
	 * @classdesc
	 * A PathFollower Game Object.
	 *
	 * A PathFollower is a Sprite Game Object with some extra helpers to allow it to follow a Path automatically.
	 *
	 * Anything you can do with a standard Sprite can be done with this PathFollower, such as animate it, tint it,
	 * scale it and so on.
	 *
	 * PathFollowers are bound to a single Path at any one time and can traverse the length of the Path, from start
	 * to finish, forwards or backwards, or from any given point on the Path to its end. They can optionally rotate
	 * to face the direction of the path, be offset from the path coordinates or rotate independently of the Path.
	 *
	 * @class PathFollower
	 * @extends Phaser.GameObjects.Sprite
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - [description]
	 * @param {Phaser.Curves.Path} path - The Path this PathFollower is following. It can only follow one Path at a time.
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	 * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	 */
	var PathFollower = new Class({
	
	    Extends: Sprite,
	
	    initialize:
	
	    function PathFollower (scene, path, x, y, texture, frame)
	    {
	        Sprite.call(this, scene, x, y, texture, frame);
	
	        /**
	         * The Path this PathFollower is following. It can only follow one Path at a time.
	         *
	         * @name Phaser.GameObjects.PathFollower#path
	         * @type {Phaser.Curves.Path}
	         * @since 3.0.0
	         */
	        this.path = path;
	
	        /**
	         * Should the PathFollower automatically rotate to point in the direction of the Path?
	         *
	         * @name Phaser.GameObjects.PathFollower#rotateToPath
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.rotateToPath = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.PathFollower#pathRotationVerticalAdjust
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.pathRotationVerticalAdjust = false;
	
	        /**
	         * If the PathFollower is rotating to match the Path (@see Phaser.GameObjects.PathFollower#rotateToPath)
	         * this value is added to the rotation value. This allows you to rotate objects to a path but control
	         * the angle of the rotation as well.
	         *
	         * @name Phaser.GameObjects.PathFollower#pathRotationOffset
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.pathRotationOffset = 0;
	
	        /**
	         * An additional vector to add to the PathFollowers position, allowing you to offset it from the
	         * Path coordinates.
	         *
	         * @name Phaser.GameObjects.PathFollower#pathOffset
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.pathOffset = new Vector2(x, y);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.PathFollower#pathVector
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.pathVector = new Vector2();
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.PathFollower#pathTween
	         * @type {Phaser.Tweens.Tween}
	         * @since 3.0.0
	         */
	        this.pathTween;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.PathFollower#pathConfig
	         * @type {?PathConfig}
	         * @default null
	         * @since 3.0.0
	         */
	        this.pathConfig = null;
	
	        /**
	         * Records the direction of the follower so it can change direction.
	         *
	         * @name Phaser.GameObjects.PathFollower#_prevDirection
	         * @type {integer}
	         * @private
	         * @since 3.0.0
	         */
	        this._prevDirection = TWEEN_CONST.PLAYING_FORWARD;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.PathFollower#setPath
	     * @since 3.0.0
	     *
	     * @param {Phaser.Curves.Path} path - The Path this PathFollower is following. It can only follow one Path at a time.
	     * @param {PathConfig} [config] - [description]
	     *
	     * @return {Phaser.GameObjects.PathFollower} This Game Object.
	     */
	    setPath: function (path, config)
	    {
	        if (config === undefined) { config = this.pathConfig; }
	
	        var tween = this.pathTween;
	
	        if (tween && tween.isPlaying())
	        {
	            tween.stop();
	        }
	
	        this.path = path;
	
	        if (config)
	        {
	            this.startFollow(config);
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.PathFollower#setRotateToPath
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     * @param {number} [offset=0] - Rotation offset in degrees.
	     * @param {boolean} [verticalAdjust=false] - [description]
	     *
	     * @return {Phaser.GameObjects.PathFollower} This Game Object.
	     */
	    setRotateToPath: function (value, offset, verticalAdjust)
	    {
	        if (offset === undefined) { offset = 0; }
	        if (verticalAdjust === undefined) { verticalAdjust = false; }
	
	        this.rotateToPath = value;
	
	        this.pathRotationOffset = offset;
	        this.pathRotationVerticalAdjust = verticalAdjust;
	
	        return this;
	    },
	
	    /**
	     * Is this PathFollower actively following a Path or not?
	     * To be considered as `isFollowing` it must be currently moving on a Path, and not paused.
	     *
	     * @method Phaser.GameObjects.PathFollower#isFollowing
	     * @since 3.0.0
	     *
	     * @return {boolean} `true` is this PathFollower is actively following a Path, otherwise `false`.
	     */
	    isFollowing: function ()
	    {
	        var tween = this.pathTween;
	
	        return (tween && tween.isPlaying());
	    },
	
	    /**
	     * Starts this PathFollower following its given Path.
	     *
	     * @method Phaser.GameObjects.PathFollower#startFollow
	     * @since 3.3.0
	     *
	     * @param {(number|PathConfig)} [config={}] - [description]
	     * @param {number} [startAt=0] - [description]
	     *
	     * @return {Phaser.GameObjects.PathFollower} This Game Object.
	     */
	    startFollow: function (config, startAt)
	    {
	        if (config === undefined) { config = {}; }
	        if (startAt === undefined) { startAt = 0; }
	
	        var tween = this.pathTween;
	
	        if (tween && tween.isPlaying())
	        {
	            tween.stop();
	        }
	
	        if (typeof config === 'number')
	        {
	            config = { duration: config };
	        }
	
	        //  Override in case they've been specified in the config
	        config.from = 0;
	        config.to = 1;
	
	        //  Can also read extra values out of the config:
	
	        var positionOnPath = GetBoolean(config, 'positionOnPath', false);
	
	        this.rotateToPath = GetBoolean(config, 'rotateToPath', false);
	        this.pathRotationOffset = GetValue(config, 'rotationOffset', 0);
	        this.pathRotationVerticalAdjust = GetBoolean(config, 'verticalAdjust', false);
	
	        this.pathTween = this.scene.sys.tweens.addCounter(config);
	
	        //  The starting point of the path, relative to this follower
	        this.path.getStartPoint(this.pathOffset);
	
	        if (positionOnPath)
	        {
	            this.x = this.pathOffset.x;
	            this.y = this.pathOffset.y;
	        }
	
	        this.pathOffset.x = this.x - this.pathOffset.x;
	        this.pathOffset.y = this.y - this.pathOffset.y;
	
	        this._prevDirection = TWEEN_CONST.PLAYING_FORWARD;
	
	        if (this.rotateToPath)
	        {
	            //  Set the rotation now (in case the tween has a delay on it, etc)
	            var nextPoint = this.path.getPoint(0.1);
	
	            this.rotation = Math.atan2(nextPoint.y - this.y, nextPoint.x - this.x) + DegToRad(this.pathRotationOffset);
	        }
	
	        this.pathConfig = config;
	
	        return this;
	    },
	
	    /**
	     * Pauses this PathFollower. It will still continue to render, but it will remain motionless at the
	     * point on the Path at which you paused it.
	     *
	     * @method Phaser.GameObjects.PathFollower#pauseFollow
	     * @since 3.3.0
	     *
	     * @return {Phaser.GameObjects.PathFollower} This Game Object.
	     */
	    pauseFollow: function ()
	    {
	        var tween = this.pathTween;
	
	        if (tween && tween.isPlaying())
	        {
	            tween.pause();
	        }
	
	        return this;
	    },
	
	    /**
	     * Resumes a previously paused PathFollower.
	     * If the PathFollower was not paused this has no effect.
	     *
	     * @method Phaser.GameObjects.PathFollower#resumeFollow
	     * @since 3.3.0
	     *
	     * @return {Phaser.GameObjects.PathFollower} This Game Object.
	     */
	    resumeFollow: function ()
	    {
	        var tween = this.pathTween;
	
	        if (tween && tween.isPaused())
	        {
	            tween.resume();
	        }
	
	        return this;
	    },
	
	    /**
	     * Stops this PathFollower from following the path any longer.
	     * This will invoke any 'stop' conditions that may exist on the Path, or for the follower.
	     *
	     * @method Phaser.GameObjects.PathFollower#stopFollow
	     * @since 3.3.0
	     *
	     * @return {Phaser.GameObjects.PathFollower} This Game Object.
	     */
	    stopFollow: function ()
	    {
	        var tween = this.pathTween;
	
	        if (tween && tween.isPlaying())
	        {
	            tween.stop();
	        }
	
	        return this;
	    },
	
	    /**
	     * Internal update handler that advances this PathFollower along the path.
	     * Called automatically by the Scene step, should not typically be called directly.
	     *
	     * @method Phaser.GameObjects.PathFollower#preUpdate
	     * @protected
	     * @since 3.0.0
	     *
	     * @param {integer} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
	     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
	     */
	    preUpdate: function (time, delta)
	    {
	        this.anims.update(time, delta);
	
	        var tween = this.pathTween;
	
	        if (tween)
	        {
	            var tweenData = tween.data[0];
	
	            if (tweenData.state !== TWEEN_CONST.PLAYING_FORWARD && tweenData.state !== TWEEN_CONST.PLAYING_BACKWARD)
	            {
	                //  If delayed, etc then bail out
	                return;
	            }
	
	            var pathVector = this.pathVector;
	
	            this.path.getPoint(tween.getValue(), pathVector);
	
	            pathVector.add(this.pathOffset);
	
	            var oldX = this.x;
	            var oldY = this.y;
	
	            this.setPosition(pathVector.x, pathVector.y);
	
	            var speedX = this.x - oldX;
	            var speedY = this.y - oldY;
	
	            if (speedX === 0 && speedY === 0)
	            {
	                //  Bail out early
	                return;
	            }
	
	            if (tweenData.state !== this._prevDirection)
	            {
	                //  We've changed direction, so don't do a rotate this frame
	                this._prevDirection = tweenData.state;
	
	                return;
	            }
	
	            if (this.rotateToPath)
	            {
	                this.rotation = Math.atan2(speedY, speedX) + DegToRad(this.pathRotationOffset);
	
	                if (this.pathRotationVerticalAdjust)
	                {
	                    this.flipY = (this.rotation !== 0 && tweenData.state === TWEEN_CONST.PLAYING_BACKWARD);
	                }
	            }
	        }
	    }
	
	});
	
	module.exports = PathFollower;


/***/ }),
/* 501 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Returns the circumference of the given Circle.
	 *
	 * @function Phaser.Geom.Circle.Circumference
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Circle} circle - The Circle to get the circumference of.
	 *
	 * @return {number} The circumference of the Circle.
	 */
	var Circumference = function (circle)
	{
	    return 2 * (Math.PI * circle.radius);
	};
	
	module.exports = Circumference;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CircumferencePoint = __webpack_require__(285);
	var FromPercent = __webpack_require__(163);
	var MATH_CONST = __webpack_require__(33);
	var Point = __webpack_require__(12);
	
	/**
	 * Returns a Point object containing the coordinates of a point on the circumference of the Circle
	 * based on the given angle normalized to the range 0 to 1. I.e. a value of 0.5 will give the point
	 * at 180 degrees around the circle.
	 *
	 * @function Phaser.Geom.Circle.GetPoint
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Circle} circle - The Circle to get the circumference point on.
	 * @param {float} position - A value between 0 and 1, where 0 equals 0 degrees, 0.5 equals 180 degrees and 1 equals 360 around the circle.
	 * @param {(Phaser.Geom.Point|object)} [out] - An object to store the return values in. If not given a Point object will be created.
	 *
	 * @return {(Phaser.Geom.Point|object)} A Point, or point-like object, containing the coordinates of the point around the circle.
	 */
	var GetPoint = function (circle, position, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    var angle = FromPercent(position, 0, MATH_CONST.PI2);
	
	    return CircumferencePoint(circle, angle, out);
	};
	
	module.exports = GetPoint;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Circumference = __webpack_require__(501);
	var CircumferencePoint = __webpack_require__(285);
	var FromPercent = __webpack_require__(163);
	var MATH_CONST = __webpack_require__(33);
	
	/**
	 * Returns an array of Point objects containing the coordinates of the points around the circumference of the Circle,
	 * based on the given quantity or stepRate values.
	 *
	 * @function Phaser.Geom.Circle.GetPoints
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Circle} circle - The Circle to get the points from.
	 * @param {integer} quantity - The amount of points to return. If a falsey value the quantity will be derived from the `stepRate` instead.
	 * @param {number} [stepRate] - Sets the quantity by getting the circumference of the circle and dividing it by the stepRate.
	 * @param {array} [output] - An array to insert the points in to. If not provided a new array will be created.
	 *
	 * @return {Phaser.Geom.Point[]} An array of Point objects pertaining to the points around the circumference of the circle.
	 */
	var GetPoints = function (circle, quantity, stepRate, out)
	{
	    if (out === undefined) { out = []; }
	
	    //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
	    if (!quantity)
	    {
	        quantity = Circumference(circle) / stepRate;
	    }
	
	    for (var i = 0; i < quantity; i++)
	    {
	        var angle = FromPercent(i / quantity, 0, MATH_CONST.PI2);
	
	        out.push(CircumferencePoint(circle, angle));
	    }
	
	    return out;
	};
	
	module.exports = GetPoints;


/***/ }),
/* 504 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Returns the circumference of the given Ellipse.
	 *
	 * @function Phaser.Geom.Ellipse.Circumference
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the circumference of.
	 *
	 * @return {number} The circumference of th Ellipse.
	 */
	var Circumference = function (ellipse)
	{
	    var rx = ellipse.width / 2;
	    var ry = ellipse.height / 2;
	    var h = Math.pow((rx - ry), 2) / Math.pow((rx + ry), 2);
	
	    return (Math.PI * (rx + ry)) * (1 + ((3 * h) / (10 + Math.sqrt(4 - (3 * h)))));
	};
	
	module.exports = Circumference;


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CircumferencePoint = __webpack_require__(287);
	var FromPercent = __webpack_require__(163);
	var MATH_CONST = __webpack_require__(33);
	var Point = __webpack_require__(12);
	
	/**
	 * Returns a Point object containing the coordinates of a point on the circumference of the Ellipse
	 * based on the given angle normalized to the range 0 to 1. I.e. a value of 0.5 will give the point
	 * at 180 degrees around the circle.
	 *
	 * @function Phaser.Geom.Ellipse.GetPoint
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the circumference point on.
	 * @param {float} position - A value between 0 and 1, where 0 equals 0 degrees, 0.5 equals 180 degrees and 1 equals 360 around the ellipse.
	 * @param {(Phaser.Geom.Point|object)} [out] - An object to store the return values in. If not given a Point object will be created.
	 *
	 * @return {(Phaser.Geom.Point|object)} A Point, or point-like object, containing the coordinates of the point around the ellipse.
	 */
	var GetPoint = function (ellipse, position, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    var angle = FromPercent(position, 0, MATH_CONST.PI2);
	
	    return CircumferencePoint(ellipse, angle, out);
	};
	
	module.exports = GetPoint;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Circumference = __webpack_require__(504);
	var CircumferencePoint = __webpack_require__(287);
	var FromPercent = __webpack_require__(163);
	var MATH_CONST = __webpack_require__(33);
	
	/**
	 * Returns an array of Point objects containing the coordinates of the points around the circumference of the Ellipse,
	 * based on the given quantity or stepRate values.
	 *
	 * @function Phaser.Geom.Ellipse.GetPoints
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point[]} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the points from.
	 * @param {integer} quantity - The amount of points to return. If a falsey value the quantity will be derived from the `stepRate` instead.
	 * @param {number} [stepRate] - Sets the quantity by getting the circumference of the ellipse and dividing it by the stepRate.
	 * @param {(array|Phaser.Geom.Point[])} [out] - An array to insert the points in to. If not provided a new array will be created.
	 *
	 * @return {(array|Phaser.Geom.Point[])} An array of Point objects pertaining to the points around the circumference of the ellipse.
	 */
	var GetPoints = function (ellipse, quantity, stepRate, out)
	{
	    if (out === undefined) { out = []; }
	
	    //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
	    if (!quantity)
	    {
	        quantity = Circumference(ellipse) / stepRate;
	    }
	
	    for (var i = 0; i < quantity; i++)
	    {
	        var angle = FromPercent(i / quantity, 0, MATH_CONST.PI2);
	
	        out.push(CircumferencePoint(ellipse, angle));
	    }
	
	    return out;
	};
	
	module.exports = GetPoints;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Ellipse = __webpack_require__(288);
	
	Ellipse.Area = __webpack_require__(1213);
	Ellipse.Circumference = __webpack_require__(504);
	Ellipse.CircumferencePoint = __webpack_require__(287);
	Ellipse.Clone = __webpack_require__(1214);
	Ellipse.Contains = __webpack_require__(161);
	Ellipse.ContainsPoint = __webpack_require__(1215);
	Ellipse.ContainsRect = __webpack_require__(1216);
	Ellipse.CopyFrom = __webpack_require__(1217);
	Ellipse.Equals = __webpack_require__(1218);
	Ellipse.GetBounds = __webpack_require__(1219);
	Ellipse.GetPoint = __webpack_require__(505);
	Ellipse.GetPoints = __webpack_require__(506);
	Ellipse.Offset = __webpack_require__(1220);
	Ellipse.OffsetPoint = __webpack_require__(1221);
	Ellipse.Random = __webpack_require__(289);
	
	module.exports = Ellipse;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Geom
	 */
	
	module.exports = {
	    
	    Circle: __webpack_require__(1212),
	    Ellipse: __webpack_require__(507),
	    Intersects: __webpack_require__(512),
	    Line: __webpack_require__(1249),
	    Point: __webpack_require__(1263),
	    Polygon: __webpack_require__(1268),
	    Rectangle: __webpack_require__(525),
	    Triangle: __webpack_require__(1306)
	
	};


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  Based on code by Matt DesLauriers
	//  https://github.com/mattdesl/line-circle-collision/blob/master/LICENSE.md
	
	var Contains = __webpack_require__(83);
	var Point = __webpack_require__(12);
	
	var tmp = new Point();
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Intersects.LineToCircle
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 * @param {Phaser.Geom.Circle} circle - [description]
	 * @param {Phaser.Geom.Point} [nearest] - [description]
	 *
	 * @return {boolean} [description]
	 */
	var LineToCircle = function (line, circle, nearest)
	{
	    if (nearest === undefined) { nearest = tmp; }
	
	    if (Contains(circle, line.x1, line.y1))
	    {
	        nearest.x = line.x1;
	        nearest.y = line.y1;
	
	        return true;
	    }
	
	    if (Contains(circle, line.x2, line.y2))
	    {
	        nearest.x = line.x2;
	        nearest.y = line.y2;
	
	        return true;
	    }
	
	    var dx = line.x2 - line.x1;
	    var dy = line.y2 - line.y1;
	
	    var lcx = circle.x - line.x1;
	    var lcy = circle.y - line.y1;
	
	    //  project lc onto d, resulting in vector p
	    var dLen2 = (dx * dx) + (dy * dy);
	    var px = dx;
	    var py = dy;
	
	    if (dLen2 > 0)
	    {
	        var dp = ((lcx * dx) + (lcy * dy)) / dLen2;
	
	        px *= dp;
	        py *= dp;
	    }
	
	    nearest.x = line.x1 + px;
	    nearest.y = line.y1 + py;
	    
	    //  len2 of p
	    var pLen2 = (px * px) + (py * py);
	    
	    return (
	        pLen2 <= dLen2 &&
	        ((px * dx) + (py * dy)) >= 0 &&
	        Contains(circle, nearest.x, nearest.y)
	    );
	};
	
	module.exports = LineToCircle;


/***/ }),
/* 510 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Intersects.PointToLine
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Point} point - [description]
	 * @param {Phaser.Geom.Line} line - [description]
	 *
	 * @return {boolean} [description]
	 */
	var PointToLine = function (point, line)
	{
	    return ((point.x - line.x1) * (line.y2 - line.y1) === (line.x2 - line.x1) * (point.y - line.y1));
	};
	
	module.exports = PointToLine;


/***/ }),
/* 511 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Intersects.RectangleToRectangle
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Rectangle} rectA - [description]
	 * @param {Phaser.Geom.Rectangle} rectB - [description]
	 *
	 * @return {boolean} [description]
	 */
	var RectangleToRectangle = function (rectA, rectB)
	{
	    if (rectA.width <= 0 || rectA.height <= 0 || rectB.width <= 0 || rectB.height <= 0)
	    {
	        return false;
	    }
	
	    return !(rectA.right < rectB.x || rectA.bottom < rectB.y || rectA.x > rectB.right || rectA.y > rectB.bottom);
	};
	
	module.exports = RectangleToRectangle;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Geom.Intersects
	 */
	
	module.exports = {
	
	    CircleToCircle: __webpack_require__(1222),
	    CircleToRectangle: __webpack_require__(1223),
	    GetRectangleIntersection: __webpack_require__(1224),
	    LineToCircle: __webpack_require__(509),
	    LineToLine: __webpack_require__(199),
	    LineToRectangle: __webpack_require__(1225),
	    PointToLine: __webpack_require__(510),
	    PointToLineSegment: __webpack_require__(1226),
	    RectangleToRectangle: __webpack_require__(511),
	    RectangleToTriangle: __webpack_require__(1227),
	    RectangleToValues: __webpack_require__(1228),
	    TriangleToCircle: __webpack_require__(1229),
	    TriangleToLine: __webpack_require__(1230),
	    TriangleToTriangle: __webpack_require__(1231)
	
	};


/***/ }),
/* 513 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Using Bresenham's line algorithm this will return an array of all coordinates on this line.
	 * The start and end points are rounded before this runs as the algorithm works on integers.
	 *
	 * @function Phaser.Geom.Line.BresenhamPoints
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 * @param {integer} [stepRate=1] - [description]
	 * @param {array} [results] - [description]
	 *
	 * @return {array} [description]
	 */
	var BresenhamPoints = function (line, stepRate, results)
	{
	    if (stepRate === undefined) { stepRate = 1; }
	    if (results === undefined) { results = []; }
	
	    var x1 = Math.round(line.x1);
	    var y1 = Math.round(line.y1);
	    var x2 = Math.round(line.x2);
	    var y2 = Math.round(line.y2);
	
	    var dx = Math.abs(x2 - x1);
	    var dy = Math.abs(y2 - y1);
	    var sx = (x1 < x2) ? 1 : -1;
	    var sy = (y1 < y2) ? 1 : -1;
	    var err = dx - dy;
	
	    results.push({ x: x1, y: y1 });
	
	    var i = 1;
	
	    while (!((x1 === x2) && (y1 === y2)))
	    {
	        var e2 = err << 1;
	
	        if (e2 > -dy)
	        {
	            err -= dy;
	            x1 += sx;
	        }
	
	        if (e2 < dx)
	        {
	            err += dx;
	            y1 += sy;
	        }
	
	        if (i % stepRate === 0)
	        {
	            results.push({ x: x1, y: y1 });
	        }
	
	        i++;
	    }
	
	    return results;
	};
	
	module.exports = BresenhamPoints;


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	
	//  Get a point on the given line 'progress' percentage along its length.
	//  progress is a value between 0 and 1.
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.GetPoint
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 * @param {float} position - A value between 0 and 1, where 0 equals 0 degrees, 0.5 equals 180 degrees and 1 equals 360 around the circle.
	 * @param {(Phaser.Geom.Point|object)} [out] - [description]
	 *
	 * @return {(Phaser.Geom.Point|object)} [description]
	 */
	var GetPoint = function (line, position, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    out.x = line.x1 + (line.x2 - line.x1) * position;
	    out.y = line.y1 + (line.y2 - line.y1) * position;
	
	    return out;
	};
	
	module.exports = GetPoint;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var MATH_CONST = __webpack_require__(33);
	var Wrap = __webpack_require__(98);
	var Angle = __webpack_require__(139);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.NormalAngle
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 *
	 * @return {number} [description]
	 */
	var NormalAngle = function (line)
	{
	    var angle = Angle(line) - MATH_CONST.TAU;
	
	    return Wrap(angle, -Math.PI, Math.PI);
	};
	
	module.exports = NormalAngle;


/***/ }),
/* 516 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Point.GetMagnitude
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Point} point - [description]
	 *
	 * @return {number} [description]
	 */
	var GetMagnitude = function (point)
	{
	    return Math.sqrt((point.x * point.x) + (point.y * point.y));
	};
	
	module.exports = GetMagnitude;


/***/ }),
/* 517 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Point.GetMagnitudeSq
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Point} point - [description]
	 *
	 * @return {number} [description]
	 */
	var GetMagnitudeSq = function (point)
	{
	    return (point.x * point.x) + (point.y * point.y);
	};
	
	module.exports = GetMagnitudeSq;


/***/ }),
/* 518 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  2.1.1 (Mar 17, 2016)
	
	/*
	ISC License
	
	Copyright (c) 2016, Mapbox
	
	Permission to use, copy, modify, and/or distribute this software for any purpose
	with or without fee is hereby granted, provided that the above copyright notice
	and this permission notice appear in all copies.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND
	FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS
	OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER
	TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF
	THIS SOFTWARE.
	 */
	
	'use strict';
	
	module.exports = earcut;
	
	/*
	vertices is a flat array of vertice coordinates like [x0,y0, x1,y1, x2,y2, ...].
	holes is an array of hole indices if any (e.g. [5, 8] for a 12-vertice input would mean one hole with vertices 5–7 and another with 8–11).
	dimensions is the number of coordinates per vertice in the input array (2 by default).
	Each group of three vertice indices in the resulting array forms a triangle.
	 */
	
	function earcut(data, holeIndices, dim) {
	
	    dim = dim || 2;
	
	    var hasHoles = holeIndices && holeIndices.length,
	        outerLen = hasHoles ? holeIndices[0] * dim : data.length,
	        outerNode = linkedList(data, 0, outerLen, dim, true),
	        triangles = [];
	
	    if (!outerNode) return triangles;
	
	    var minX, minY, maxX, maxY, x, y, size;
	
	    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
	
	    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
	    if (data.length > 80 * dim) {
	        minX = maxX = data[0];
	        minY = maxY = data[1];
	
	        for (var i = dim; i < outerLen; i += dim) {
	            x = data[i];
	            y = data[i + 1];
	            if (x < minX) minX = x;
	            if (y < minY) minY = y;
	            if (x > maxX) maxX = x;
	            if (y > maxY) maxY = y;
	        }
	
	        // minX, minY and size are later used to transform coords into integers for z-order calculation
	        size = Math.max(maxX - minX, maxY - minY);
	    }
	
	    earcutLinked(outerNode, triangles, dim, minX, minY, size);
	
	    return triangles;
	}
	
	// create a circular doubly linked list from polygon points in the specified winding order
	function linkedList(data, start, end, dim, clockwise) {
	    var i, last;
	
	    if (clockwise === (signedArea(data, start, end, dim) > 0)) {
	        for (i = start; i < end; i += dim) last = insertNode(i, data[i], data[i + 1], last);
	    } else {
	        for (i = end - dim; i >= start; i -= dim) last = insertNode(i, data[i], data[i + 1], last);
	    }
	
	    if (last && equals(last, last.next)) {
	        removeNode(last);
	        last = last.next;
	    }
	
	    return last;
	}
	
	// eliminate colinear or duplicate points
	function filterPoints(start, end) {
	    if (!start) return start;
	    if (!end) end = start;
	
	    var p = start,
	        again;
	    do {
	        again = false;
	
	        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
	            removeNode(p);
	            p = end = p.prev;
	            if (p === p.next) return null;
	            again = true;
	
	        } else {
	            p = p.next;
	        }
	    } while (again || p !== end);
	
	    return end;
	}
	
	// main ear slicing loop which triangulates a polygon (given as a linked list)
	function earcutLinked(ear, triangles, dim, minX, minY, size, pass) {
	    if (!ear) return;
	
	    // interlink polygon nodes in z-order
	    if (!pass && size) indexCurve(ear, minX, minY, size);
	
	    var stop = ear,
	        prev, next;
	
	    // iterate through ears, slicing them one by one
	    while (ear.prev !== ear.next) {
	        prev = ear.prev;
	        next = ear.next;
	
	        if (size ? isEarHashed(ear, minX, minY, size) : isEar(ear)) {
	            // cut off the triangle
	            triangles.push(prev.i / dim);
	            triangles.push(ear.i / dim);
	            triangles.push(next.i / dim);
	
	            removeNode(ear);
	
	            // skipping the next vertice leads to less sliver triangles
	            ear = next.next;
	            stop = next.next;
	
	            continue;
	        }
	
	        ear = next;
	
	        // if we looped through the whole remaining polygon and can't find any more ears
	        if (ear === stop) {
	            // try filtering points and slicing again
	            if (!pass) {
	                earcutLinked(filterPoints(ear), triangles, dim, minX, minY, size, 1);
	
	            // if this didn't work, try curing all small self-intersections locally
	            } else if (pass === 1) {
	                ear = cureLocalIntersections(ear, triangles, dim);
	                earcutLinked(ear, triangles, dim, minX, minY, size, 2);
	
	            // as a last resort, try splitting the remaining polygon into two
	            } else if (pass === 2) {
	                splitEarcut(ear, triangles, dim, minX, minY, size);
	            }
	
	            break;
	        }
	    }
	}
	
	// check whether a polygon node forms a valid ear with adjacent nodes
	function isEar(ear) {
	    var a = ear.prev,
	        b = ear,
	        c = ear.next;
	
	    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
	
	    // now make sure we don't have other points inside the potential ear
	    var p = ear.next.next;
	
	    while (p !== ear.prev) {
	        if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.next;
	    }
	
	    return true;
	}
	
	function isEarHashed(ear, minX, minY, size) {
	    var a = ear.prev,
	        b = ear,
	        c = ear.next;
	
	    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
	
	    // triangle bbox; min & max are calculated like this for speed
	    var minTX = a.x < b.x ? (a.x < c.x ? a.x : c.x) : (b.x < c.x ? b.x : c.x),
	        minTY = a.y < b.y ? (a.y < c.y ? a.y : c.y) : (b.y < c.y ? b.y : c.y),
	        maxTX = a.x > b.x ? (a.x > c.x ? a.x : c.x) : (b.x > c.x ? b.x : c.x),
	        maxTY = a.y > b.y ? (a.y > c.y ? a.y : c.y) : (b.y > c.y ? b.y : c.y);
	
	    // z-order range for the current triangle bbox;
	    var minZ = zOrder(minTX, minTY, minX, minY, size),
	        maxZ = zOrder(maxTX, maxTY, minX, minY, size);
	
	    // first look for points inside the triangle in increasing z-order
	    var p = ear.nextZ;
	
	    while (p && p.z <= maxZ) {
	        if (p !== ear.prev && p !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.nextZ;
	    }
	
	    // then look for points in decreasing z-order
	    p = ear.prevZ;
	
	    while (p && p.z >= minZ) {
	        if (p !== ear.prev && p !== ear.next &&
	            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
	            area(p.prev, p, p.next) >= 0) return false;
	        p = p.prevZ;
	    }
	
	    return true;
	}
	
	// go through all polygon nodes and cure small local self-intersections
	function cureLocalIntersections(start, triangles, dim) {
	    var p = start;
	    do {
	        var a = p.prev,
	            b = p.next.next;
	
	        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
	
	            triangles.push(a.i / dim);
	            triangles.push(p.i / dim);
	            triangles.push(b.i / dim);
	
	            // remove two nodes involved
	            removeNode(p);
	            removeNode(p.next);
	
	            p = start = b;
	        }
	        p = p.next;
	    } while (p !== start);
	
	    return p;
	}
	
	// try splitting polygon into two and triangulate them independently
	function splitEarcut(start, triangles, dim, minX, minY, size) {
	    // look for a valid diagonal that divides the polygon into two
	    var a = start;
	    do {
	        var b = a.next.next;
	        while (b !== a.prev) {
	            if (a.i !== b.i && isValidDiagonal(a, b)) {
	                // split the polygon in two by the diagonal
	                var c = splitPolygon(a, b);
	
	                // filter colinear points around the cuts
	                a = filterPoints(a, a.next);
	                c = filterPoints(c, c.next);
	
	                // run earcut on each half
	                earcutLinked(a, triangles, dim, minX, minY, size);
	                earcutLinked(c, triangles, dim, minX, minY, size);
	                return;
	            }
	            b = b.next;
	        }
	        a = a.next;
	    } while (a !== start);
	}
	
	// link every hole into the outer loop, producing a single-ring polygon without holes
	function eliminateHoles(data, holeIndices, outerNode, dim) {
	    var queue = [],
	        i, len, start, end, list;
	
	    for (i = 0, len = holeIndices.length; i < len; i++) {
	        start = holeIndices[i] * dim;
	        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
	        list = linkedList(data, start, end, dim, false);
	        if (list === list.next) list.steiner = true;
	        queue.push(getLeftmost(list));
	    }
	
	    queue.sort(compareX);
	
	    // process holes from left to right
	    for (i = 0; i < queue.length; i++) {
	        eliminateHole(queue[i], outerNode);
	        outerNode = filterPoints(outerNode, outerNode.next);
	    }
	
	    return outerNode;
	}
	
	function compareX(a, b) {
	    return a.x - b.x;
	}
	
	// find a bridge between vertices that connects hole with an outer ring and and link it
	function eliminateHole(hole, outerNode) {
	    outerNode = findHoleBridge(hole, outerNode);
	    if (outerNode) {
	        var b = splitPolygon(outerNode, hole);
	        filterPoints(b, b.next);
	    }
	}
	
	// David Eberly's algorithm for finding a bridge between hole and outer polygon
	function findHoleBridge(hole, outerNode) {
	    var p = outerNode,
	        hx = hole.x,
	        hy = hole.y,
	        qx = -Infinity,
	        m;
	
	    // find a segment intersected by a ray from the hole's leftmost point to the left;
	    // segment's endpoint with lesser x will be potential connection point
	    do {
	        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
	            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
	            if (x <= hx && x > qx) {
	                qx = x;
	                if (x === hx) {
	                    if (hy === p.y) return p;
	                    if (hy === p.next.y) return p.next;
	                }
	                m = p.x < p.next.x ? p : p.next;
	            }
	        }
	        p = p.next;
	    } while (p !== outerNode);
	
	    if (!m) return null;
	
	    if (hx === qx) return m.prev; // hole touches outer segment; pick lower endpoint
	
	    // look for points inside the triangle of hole point, segment intersection and endpoint;
	    // if there are no points found, we have a valid connection;
	    // otherwise choose the point of the minimum angle with the ray as connection point
	
	    var stop = m,
	        mx = m.x,
	        my = m.y,
	        tanMin = Infinity,
	        tan;
	
	    p = m.next;
	
	    while (p !== stop) {
	        if (hx >= p.x && p.x >= mx && hx !== p.x &&
	                pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
	
	            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
	
	            if ((tan < tanMin || (tan === tanMin && p.x > m.x)) && locallyInside(p, hole)) {
	                m = p;
	                tanMin = tan;
	            }
	        }
	
	        p = p.next;
	    }
	
	    return m;
	}
	
	// interlink polygon nodes in z-order
	function indexCurve(start, minX, minY, size) {
	    var p = start;
	    do {
	        if (p.z === null) p.z = zOrder(p.x, p.y, minX, minY, size);
	        p.prevZ = p.prev;
	        p.nextZ = p.next;
	        p = p.next;
	    } while (p !== start);
	
	    p.prevZ.nextZ = null;
	    p.prevZ = null;
	
	    sortLinked(p);
	}
	
	// Simon Tatham's linked list merge sort algorithm
	// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
	function sortLinked(list) {
	    var i, p, q, e, tail, numMerges, pSize, qSize,
	        inSize = 1;
	
	    do {
	        p = list;
	        list = null;
	        tail = null;
	        numMerges = 0;
	
	        while (p) {
	            numMerges++;
	            q = p;
	            pSize = 0;
	            for (i = 0; i < inSize; i++) {
	                pSize++;
	                q = q.nextZ;
	                if (!q) break;
	            }
	            qSize = inSize;
	
	            while (pSize > 0 || (qSize > 0 && q)) {
	
	                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
	                    e = p;
	                    p = p.nextZ;
	                    pSize--;
	                } else {
	                    e = q;
	                    q = q.nextZ;
	                    qSize--;
	                }
	
	                if (tail) tail.nextZ = e;
	                else list = e;
	
	                e.prevZ = tail;
	                tail = e;
	            }
	
	            p = q;
	        }
	
	        tail.nextZ = null;
	        inSize *= 2;
	
	    } while (numMerges > 1);
	
	    return list;
	}
	
	// z-order of a point given coords and size of the data bounding box
	function zOrder(x, y, minX, minY, size) {
	    // coords are transformed into non-negative 15-bit integer range
	    x = 32767 * (x - minX) / size;
	    y = 32767 * (y - minY) / size;
	
	    x = (x | (x << 8)) & 0x00FF00FF;
	    x = (x | (x << 4)) & 0x0F0F0F0F;
	    x = (x | (x << 2)) & 0x33333333;
	    x = (x | (x << 1)) & 0x55555555;
	
	    y = (y | (y << 8)) & 0x00FF00FF;
	    y = (y | (y << 4)) & 0x0F0F0F0F;
	    y = (y | (y << 2)) & 0x33333333;
	    y = (y | (y << 1)) & 0x55555555;
	
	    return x | (y << 1);
	}
	
	// find the leftmost node of a polygon ring
	function getLeftmost(start) {
	    var p = start,
	        leftmost = start;
	    do {
	        if (p.x < leftmost.x) leftmost = p;
	        p = p.next;
	    } while (p !== start);
	
	    return leftmost;
	}
	
	// check if a point lies within a convex triangle
	function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
	    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 &&
	           (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 &&
	           (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
	}
	
	// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
	function isValidDiagonal(a, b) {
	    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) &&
	           locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b);
	}
	
	// signed area of a triangle
	function area(p, q, r) {
	    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
	}
	
	// check if two points are equal
	function equals(p1, p2) {
	    return p1.x === p2.x && p1.y === p2.y;
	}
	
	// check if two segments intersect
	function intersects(p1, q1, p2, q2) {
	    if ((equals(p1, q1) && equals(p2, q2)) ||
	        (equals(p1, q2) && equals(p2, q1))) return true;
	    return area(p1, q1, p2) > 0 !== area(p1, q1, q2) > 0 &&
	           area(p2, q2, p1) > 0 !== area(p2, q2, q1) > 0;
	}
	
	// check if a polygon diagonal intersects any polygon segments
	function intersectsPolygon(a, b) {
	    var p = a;
	    do {
	        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i &&
	                intersects(p, p.next, a, b)) return true;
	        p = p.next;
	    } while (p !== a);
	
	    return false;
	}
	
	// check if a polygon diagonal is locally inside the polygon
	function locallyInside(a, b) {
	    return area(a.prev, a, a.next) < 0 ?
	        area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 :
	        area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
	}
	
	// check if the middle point of a polygon diagonal is inside the polygon
	function middleInside(a, b) {
	    var p = a,
	        inside = false,
	        px = (a.x + b.x) / 2,
	        py = (a.y + b.y) / 2;
	    do {
	        if (((p.y > py) !== (p.next.y > py)) && p.next.y !== p.y &&
	                (px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x))
	            inside = !inside;
	        p = p.next;
	    } while (p !== a);
	
	    return inside;
	}
	
	// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
	// if one belongs to the outer ring and another to a hole, it merges it into a single ring
	function splitPolygon(a, b) {
	    var a2 = new Node(a.i, a.x, a.y),
	        b2 = new Node(b.i, b.x, b.y),
	        an = a.next,
	        bp = b.prev;
	
	    a.next = b;
	    b.prev = a;
	
	    a2.next = an;
	    an.prev = a2;
	
	    b2.next = a2;
	    a2.prev = b2;
	
	    bp.next = b2;
	    b2.prev = bp;
	
	    return b2;
	}
	
	// create a node and optionally link it with previous one (in a circular doubly linked list)
	function insertNode(i, x, y, last) {
	    var p = new Node(i, x, y);
	
	    if (!last) {
	        p.prev = p;
	        p.next = p;
	
	    } else {
	        p.next = last.next;
	        p.prev = last;
	        last.next.prev = p;
	        last.next = p;
	    }
	    return p;
	}
	
	function removeNode(p) {
	    p.next.prev = p.prev;
	    p.prev.next = p.next;
	
	    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
	    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
	}
	
	function Node(i, x, y) {
	    // vertice index in coordinates array
	    this.i = i;
	
	    // vertex coordinates
	    this.x = x;
	    this.y = y;
	
	    // previous and next vertice nodes in a polygon ring
	    this.prev = null;
	    this.next = null;
	
	    // z-order curve value
	    this.z = null;
	
	    // previous and next nodes in z-order
	    this.prevZ = null;
	    this.nextZ = null;
	
	    // indicates whether this is a steiner point
	    this.steiner = false;
	}
	
	// return a percentage difference between the polygon area and its triangulation area;
	// used to verify correctness of triangulation
	earcut.deviation = function (data, holeIndices, dim, triangles) {
	    var hasHoles = holeIndices && holeIndices.length;
	    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
	
	    var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
	    if (hasHoles) {
	        for (var i = 0, len = holeIndices.length; i < len; i++) {
	            var start = holeIndices[i] * dim;
	            var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
	            polygonArea -= Math.abs(signedArea(data, start, end, dim));
	        }
	    }
	
	    var trianglesArea = 0;
	    for (i = 0; i < triangles.length; i += 3) {
	        var a = triangles[i] * dim;
	        var b = triangles[i + 1] * dim;
	        var c = triangles[i + 2] * dim;
	        trianglesArea += Math.abs(
	            (data[a] - data[c]) * (data[b + 1] - data[a + 1]) -
	            (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
	    }
	
	    return polygonArea === 0 && trianglesArea === 0 ? 0 :
	        Math.abs((trianglesArea - polygonArea) / polygonArea);
	};
	
	function signedArea(data, start, end, dim) {
	    var sum = 0;
	    for (var i = start, j = end - dim; i < end; i += dim) {
	        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
	        j = i;
	    }
	    return sum;
	}
	
	// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
	earcut.flatten = function (data) {
	    var dim = data[0][0].length,
	        result = {vertices: [], holes: [], dimensions: dim},
	        holeIndex = 0;
	
	    for (var i = 0; i < data.length; i++) {
	        for (var j = 0; j < data[i].length; j++) {
	            for (var d = 0; d < dim; d++) result.vertices.push(data[i][j][d]);
	        }
	        if (i > 0) {
	            holeIndex += data[i - 1].length;
	            result.holes.push(holeIndex);
	        }
	    }
	    return result;
	};

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Contains = __webpack_require__(293);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class Polygon
	 * @memberOf Phaser.Geom
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Point[]} [points] - [description]
	 */
	var Polygon = new Class({
	
	    initialize:
	
	    function Polygon (points)
	    {
	        /**
	         * The area of this Polygon.
	         *
	         * @name Phaser.Geom.Polygon#area
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.area = 0;
	
	        /**
	         * An array of number pair objects that make up this polygon. I.e. [ {x,y}, {x,y}, {x,y} ]
	         *
	         * @name Phaser.Geom.Polygon#points
	         * @type {Phaser.Geom.Point[]}
	         * @since 3.0.0
	         */
	        this.points = [];
	
	        if (points)
	        {
	            this.setTo(points);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Geom.Polygon#contains
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     *
	     * @return {boolean} [description]
	     */
	    contains: function (x, y)
	    {
	        return Contains(this, x, y);
	    },
	
	    /**
	     * Sets this Polygon to the given points.
	     *
	     * The points can be set from a variety of formats:
	     *
	     * - An array of Point objects: `[new Phaser.Point(x1, y1), ...]`
	     * - An array of objects with public x/y properties: `[obj1, obj2, ...]`
	     * - An array of paired numbers that represent point coordinates: `[x1,y1, x2,y2, ...]`
	     * - An array of arrays with two elements representing x/y coordinates: `[[x1, y1], [x2, y2], ...]`
	     *
	     * `setTo` may also be called without any arguments to remove all points.
	     *
	     * @method Phaser.Geom.Polygon#setTo
	     * @since 3.0.0
	     *
	     * @param {array} points - [description]
	     *
	     * @return {Phaser.Geom.Polygon} This Polygon object.
	     */
	    setTo: function (points)
	    {
	        this.area = 0;
	        this.points = [];
	
	        if (!Array.isArray(points))
	        {
	            return this;
	        }
	
	        var p;
	        var y0 = Number.MAX_VALUE;
	
	        //  The points argument is an array, so iterate through it
	        for (var i = 0; i < points.length; i++)
	        {
	            p = { x: 0, y: 0 };
	
	            if (typeof points[i] === 'number')
	            {
	                p.x = points[i];
	                p.y = points[i + 1];
	                i++;
	            }
	            else if (Array.isArray(points[i]))
	            {
	                //  An array of arrays?
	                p.x = points[i][0];
	                p.y = points[i][1];
	            }
	            else
	            {
	                p.x = points[i].x;
	                p.y = points[i].y;
	            }
	
	            this.points.push(p);
	
	            //  Lowest boundary
	            if (p.y < y0)
	            {
	                y0 = p.y;
	            }
	        }
	
	        this.calculateArea(y0);
	
	        return this;
	    },
	
	    /**
	     * Calculates the area of the Polygon. This is available in the property Polygon.area
	     *
	     * @method Phaser.Geom.Polygon#calculateArea
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    calculateArea: function ()
	    {
	        if (this.points.length < 3)
	        {
	            this.area = 0;
	
	            return this.area;
	        }
	
	        var sum = 0;
	        var p1;
	        var p2;
	
	        for (var i = 0; i < this.points.length - 1; i++)
	        {
	            p1 = this.points[i];
	            p2 = this.points[i + 1];
	
	            sum += (p2.x - p1.x) * (p1.y + p2.y);
	        }
	
	        p1 = this.points[0];
	        p2 = this.points[this.points.length - 1];
	
	        sum += (p1.x - p2.x) * (p2.y + p1.y);
	
	        this.area = -sum * 0.5;
	
	        return this.area;
	    }
	
	});
	
	module.exports = Polygon;


/***/ }),
/* 520 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	// Centers this Rectangle so that the center coordinates match the given x and y values.
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.CenterOn
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 * @param {number} x - [description]
	 * @param {number} y - [description]
	 *
	 * @return {Phaser.Geom.Rectangle} [description]
	 */
	var CenterOn = function (rect, x, y)
	{
	    rect.x = x - (rect.width / 2);
	    rect.y = y - (rect.height / 2);
	
	    return rect;
	};
	
	module.exports = CenterOn;


/***/ }),
/* 521 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.Decompose
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 * @param {array} [out] - [description]
	 *
	 * @return {array} [description]
	 */
	var Decompose = function (rect, out)
	{
	    if (out === undefined) { out = []; }
	
	    out.push({ x: rect.x, y: rect.y });
	    out.push({ x: rect.right, y: rect.y });
	    out.push({ x: rect.right, y: rect.bottom });
	    out.push({ x: rect.x, y: rect.bottom });
	
	    return out;
	};
	
	module.exports = Decompose;


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetPoint = __webpack_require__(296);
	var Perimeter = __webpack_require__(201);
	
	//  Return an array of points from the perimeter of the rectangle
	//  each spaced out based on the quantity or step required
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.GetPoints
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point[]} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} rectangle - [description]
	 * @param {number} step - [description]
	 * @param {integer} quantity - [description]
	 * @param {(array|Phaser.Geom.Point[])} [out] - [description]
	 *
	 * @return {(array|Phaser.Geom.Point[])} [description]
	 */
	var GetPoints = function (rectangle, quantity, stepRate, out)
	{
	    if (out === undefined) { out = []; }
	
	    //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
	    if (!quantity)
	    {
	        quantity = Perimeter(rectangle) / stepRate;
	    }
	
	    for (var i = 0; i < quantity; i++)
	    {
	        var position = i / quantity;
	
	        out.push(GetPoint(rectangle, position));
	    }
	
	    return out;
	};
	
	module.exports = GetPoints;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Perimeter = __webpack_require__(201);
	var Point = __webpack_require__(12);
	
	//  Return an array of points from the perimeter of the rectangle
	//  each spaced out based on the quantity or step required
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.MarchingAnts
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point[]} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 * @param {number} step - [description]
	 * @param {integer} quantity - [description]
	 * @param {(array|Phaser.Geom.Point[])} [out] - [description]
	 *
	 * @return {(array|Phaser.Geom.Point[])} [description]
	 */
	var MarchingAnts = function (rect, step, quantity, out)
	{
	    if (out === undefined) { out = []; }
	
	    if (!step && !quantity)
	    {
	        //  Bail out
	        return out;
	    }
	
	    //  If step is a falsey value (false, null, 0, undefined, etc) then we calculate
	    //  it based on the quantity instead, otherwise we always use the step value
	    if (!step)
	    {
	        step = Perimeter(rect) / quantity;
	    }
	    else
	    {
	        quantity = Math.round(Perimeter(rect) / step);
	    }
	
	    var x = rect.x;
	    var y = rect.y;
	    var face = 0;
	
	    //  Loop across each face of the rectangle
	
	    for (var i = 0; i < quantity; i++)
	    {
	        out.push(new Point(x, y));
	
	        switch (face)
	        {
	
	            //  Top face
	            case 0:
	                x += step;
	
	                if (x >= rect.right)
	                {
	                    face = 1;
	                    y += (x - rect.right);
	                    x = rect.right;
	                }
	                break;
	
	            //  Right face
	            case 1:
	                y += step;
	
	                if (y >= rect.bottom)
	                {
	                    face = 2;
	                    x -= (y - rect.bottom);
	                    y = rect.bottom;
	                }
	                break;
	
	            //  Bottom face
	            case 2:
	                x -= step;
	
	                if (x <= rect.left)
	                {
	                    face = 3;
	                    y -= (rect.left - x);
	                    x = rect.left;
	                }
	                break;
	
	            //  Left face
	            case 3:
	                y -= step;
	
	                if (y <= rect.top)
	                {
	                    face = 0;
	                    y = rect.top;
	                }
	                break;
	        }
	    }
	
	    return out;
	};
	
	module.exports = MarchingAnts;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Rectangle = __webpack_require__(23);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.Union
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} rectA - [description]
	 * @param {Phaser.Geom.Rectangle} rectB - [description]
	 * @param {Phaser.Geom.Rectangle} [out] - [description]
	 *
	 * @return {Phaser.Geom.Rectangle} [description]
	 */
	var Union = function (rectA, rectB, out)
	{
	    if (out === undefined) { out = new Rectangle(); }
	
	    //  Cache vars so we can use one of the input rects as the output rect
	    var x = Math.min(rectA.x, rectB.x);
	    var y = Math.min(rectA.y, rectB.y);
	    var w = Math.max(rectA.right, rectB.right) - x;
	    var h = Math.max(rectA.bottom, rectB.bottom) - y;
	
	    return out.setTo(x, y, w, h);
	};
	
	module.exports = Union;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Rectangle = __webpack_require__(23);
	
	Rectangle.Area = __webpack_require__(1269);
	Rectangle.Ceil = __webpack_require__(1270);
	Rectangle.CeilAll = __webpack_require__(1271);
	Rectangle.CenterOn = __webpack_require__(520);
	Rectangle.Clone = __webpack_require__(1272);
	Rectangle.Contains = __webpack_require__(84);
	Rectangle.ContainsPoint = __webpack_require__(1273);
	Rectangle.ContainsRect = __webpack_require__(1274);
	Rectangle.CopyFrom = __webpack_require__(1275);
	Rectangle.Decompose = __webpack_require__(521);
	Rectangle.Equals = __webpack_require__(1276);
	Rectangle.FitInside = __webpack_require__(1277);
	Rectangle.FitOutside = __webpack_require__(1278);
	Rectangle.Floor = __webpack_require__(1279);
	Rectangle.FloorAll = __webpack_require__(1280);
	Rectangle.FromPoints = __webpack_require__(294);
	Rectangle.GetAspectRatio = __webpack_require__(295);
	Rectangle.GetCenter = __webpack_require__(1281);
	Rectangle.GetPoint = __webpack_require__(296);
	Rectangle.GetPoints = __webpack_require__(522);
	Rectangle.GetSize = __webpack_require__(1282);
	Rectangle.Inflate = __webpack_require__(1283);
	Rectangle.MarchingAnts = __webpack_require__(523);
	Rectangle.MergePoints = __webpack_require__(1284);
	Rectangle.MergeRect = __webpack_require__(1285);
	Rectangle.MergeXY = __webpack_require__(1286);
	Rectangle.Offset = __webpack_require__(1287);
	Rectangle.OffsetPoint = __webpack_require__(1288);
	Rectangle.Overlaps = __webpack_require__(1289);
	Rectangle.Perimeter = __webpack_require__(201);
	Rectangle.PerimeterPoint = __webpack_require__(1290);
	Rectangle.Random = __webpack_require__(297);
	Rectangle.Scale = __webpack_require__(1291);
	Rectangle.Union = __webpack_require__(524);
	
	module.exports = Rectangle;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	
	//  The three medians (the lines drawn from the vertices to the bisectors of the opposite sides)
	//  meet in the centroid or center of mass (center of gravity).
	//  The centroid divides each median in a ratio of 2:1
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.Centroid
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 * @param {(Phaser.Geom.Point|object)} [out] - [description]
	 *
	 * @return {(Phaser.Geom.Point|object)} [description]
	 */
	var Centroid = function (triangle, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    out.x = (triangle.x1 + triangle.x2 + triangle.x3) / 3;
	    out.y = (triangle.y1 + triangle.y2 + triangle.y3) / 3;
	
	    return out;
	};
	
	module.exports = Centroid;


/***/ }),
/* 527 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.Decompose
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 * @param {array} [out] - [description]
	 *
	 * @return {array} [description]
	 */
	var Decompose = function (triangle, out)
	{
	    if (out === undefined) { out = []; }
	
	    out.push({ x: triangle.x1, y: triangle.y1 });
	    out.push({ x: triangle.x2, y: triangle.y2 });
	    out.push({ x: triangle.x3, y: triangle.y3 });
	
	    return out;
	};
	
	module.exports = Decompose;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	var Length = __webpack_require__(162);
	
	//  Position is a value between 0 and 1
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.GetPoint
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 * @param {float} position - [description]
	 * @param {(Phaser.Geom.Point|object)} [out] - [description]
	 *
	 * @return {(Phaser.Geom.Point|object)} [description]
	 */
	var GetPoint = function (triangle, position, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    var line1 = triangle.getLineA();
	    var line2 = triangle.getLineB();
	    var line3 = triangle.getLineC();
	
	    if (position <= 0 || position >= 1)
	    {
	        out.x = line1.x1;
	        out.y = line1.y1;
	
	        return out;
	    }
	
	    var length1 = Length(line1);
	    var length2 = Length(line2);
	    var length3 = Length(line3);
	
	    var perimeter = length1 + length2 + length3;
	
	    var p = perimeter * position;
	    var localPosition = 0;
	
	    //  Which line is it on?
	
	    if (p < length1)
	    {
	        //  Line 1
	        localPosition = p / length1;
	
	        out.x = line1.x1 + (line1.x2 - line1.x1) * localPosition;
	        out.y = line1.y1 + (line1.y2 - line1.y1) * localPosition;
	    }
	    else if (p > length1 + length2)
	    {
	        //  Line 3
	        p -= length1 + length2;
	        localPosition = p / length3;
	
	        out.x = line3.x1 + (line3.x2 - line3.x1) * localPosition;
	        out.y = line3.y1 + (line3.y2 - line3.y1) * localPosition;
	    }
	    else
	    {
	        //  Line 2
	        p -= length1;
	        localPosition = p / length2;
	
	        out.x = line2.x1 + (line2.x2 - line2.x1) * localPosition;
	        out.y = line2.y1 + (line2.y2 - line2.y1) * localPosition;
	    }
	
	    return out;
	};
	
	module.exports = GetPoint;


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Length = __webpack_require__(162);
	var Point = __webpack_require__(12);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.GetPoints
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 * @param {integer} quantity - [description]
	 * @param {number} stepRate - [description]
	 * @param {(array|Phaser.Geom.Point[])} [out] - [description]
	 *
	 * @return {(array|Phaser.Geom.Point[])} [description]
	 */
	var GetPoints = function (triangle, quantity, stepRate, out)
	{
	    if (out === undefined) { out = []; }
	
	    var line1 = triangle.getLineA();
	    var line2 = triangle.getLineB();
	    var line3 = triangle.getLineC();
	
	    var length1 = Length(line1);
	    var length2 = Length(line2);
	    var length3 = Length(line3);
	
	    var perimeter = length1 + length2 + length3;
	
	    //  If quantity is a falsey value (false, null, 0, undefined, etc) then we calculate it based on the stepRate instead.
	    if (!quantity)
	    {
	        quantity = perimeter / stepRate;
	    }
	
	    for (var i = 0; i < quantity; i++)
	    {
	        var p = perimeter * (i / quantity);
	        var localPosition = 0;
	
	        var point = new Point();
	
	        //  Which line is it on?
	
	        if (p < length1)
	        {
	            //  Line 1
	            localPosition = p / length1;
	
	            point.x = line1.x1 + (line1.x2 - line1.x1) * localPosition;
	            point.y = line1.y1 + (line1.y2 - line1.y1) * localPosition;
	        }
	        else if (p > length1 + length2)
	        {
	            //  Line 3
	            p -= length1 + length2;
	            localPosition = p / length3;
	
	            point.x = line3.x1 + (line3.x2 - line3.x1) * localPosition;
	            point.y = line3.y1 + (line3.y2 - line3.y1) * localPosition;
	        }
	        else
	        {
	            //  Line 2
	            p -= length1;
	            localPosition = p / length2;
	
	            point.x = line2.x1 + (line2.x2 - line2.x1) * localPosition;
	            point.y = line2.y1 + (line2.y2 - line2.y1) * localPosition;
	        }
	
	        out.push(point);
	    }
	
	    return out;
	};
	
	module.exports = GetPoints;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	
	// The three angle bisectors of a triangle meet in one point called the incenter.
	// It is the center of the incircle, the circle inscribed in the triangle.
	
	function getLength (x1, y1, x2, y2)
	{
	    var x = x1 - x2;
	    var y = y1 - y2;
	    var magnitude = (x * x) + (y * y);
	
	    return Math.sqrt(magnitude);
	}
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.InCenter
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 * @param {Phaser.Geom.Point} [out] - [description]
	 *
	 * @return {Phaser.Geom.Point} [description]
	 */
	var InCenter = function (triangle, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    var x1 = triangle.x1;
	    var y1 = triangle.y1;
	
	    var x2 = triangle.x2;
	    var y2 = triangle.y2;
	
	    var x3 = triangle.x3;
	    var y3 = triangle.y3;
	
	    var d1 = getLength(x3, y3, x2, y2);
	    var d2 = getLength(x1, y1, x3, y3);
	    var d3 = getLength(x2, y2, x1, y1);
	
	    var p = d1 + d2 + d3;
	
	    out.x = (x1 * d1 + x2 * d2 + x3 * d3) / p;
	    out.y = (y1 * d1 + y2 * d2 + y3 * d3) / p;
	
	    return out;
	};
	
	module.exports = InCenter;


/***/ }),
/* 531 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.Offset
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Triangle} O - [triangle,$return]
	 *
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 * @param {number} x - [description]
	 * @param {number} y - [description]
	 *
	 * @return {Phaser.Geom.Triangle} [description]
	 */
	var Offset = function (triangle, x, y)
	{
	    triangle.x1 += x;
	    triangle.y1 += y;
	
	    triangle.x2 += x;
	    triangle.y2 += y;
	
	    triangle.x3 += x;
	    triangle.y3 += y;
	
	    return triangle;
	};
	
	module.exports = Offset;


/***/ }),
/* 532 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @callback HitAreaCallback
	 *
	 * @param {*} hitArea - [description]
	 * @param {number} x - [description]
	 * @param {number} y - [description]
	 * @param {Phaser.GameObjects.GameObject} gameObject - [description]
	 *
	 * @return {boolean} [description]
	 */
	
	/**
	 * @typedef {object} Phaser.Input.InteractiveObject
	 *
	 * @property {Phaser.GameObjects.GameObject} gameObject - [description]
	 * @property {boolean} enabled - [description]
	 * @property {boolean} draggable - [description]
	 * @property {boolean} dropZone - [description]
	 * @property {?Phaser.GameObjects.GameObject} target - [description]
	 * @property {Phaser.Cameras.Scene2D.Camera} camera - [description]
	 * @property {*} hitArea - [description]
	 * @property {HitAreaCallback} hitAreaCallback - [description]
	 * @property {number} localX - [description]
	 * @property {number} localY - [description]
	 * @property {(0|1|2)} dragState - [description]
	 * @property {number} dragStartX - [description]
	 * @property {number} dragStartY - [description]
	 * @property {number} dragX - [description]
	 * @property {number} dragY - [description]
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Input.CreateInteractiveObject
	 * @since 3.0.0
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - [description]
	 * @param {*} hitArea - [description]
	 * @param {HitAreaCallback} hitAreaCallback - [description]
	 *
	 * @return {Phaser.Input.InteractiveObject} [description]
	 */
	var CreateInteractiveObject = function (gameObject, hitArea, hitAreaCallback)
	{
	    return {
	
	        gameObject: gameObject,
	
	        enabled: true,
	        draggable: false,
	        dropZone: false,
	
	        target: null,
	
	        camera: null,
	
	        hitArea: hitArea,
	        hitAreaCallback: hitAreaCallback,
	
	        localX: 0,
	        localY: 0,
	
	        //  0 = Not being dragged
	        //  1 = Being checked for dragging
	        //  2 = Being dragged
	        dragState: 0,
	
	        dragStartX: 0,
	        dragStartY: 0,
	
	        dragX: 0,
	        dragY: 0
	
	    };
	};
	
	module.exports = CreateInteractiveObject;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var EventEmitter = __webpack_require__(22);
	var Gamepad = __webpack_require__(538);
	var Keyboard = __webpack_require__(539);
	var Mouse = __webpack_require__(542);
	var Pointer = __webpack_require__(534);
	var Rectangle = __webpack_require__(23);
	var Touch = __webpack_require__(543);
	var TransformMatrix = __webpack_require__(158);
	var TransformXY = __webpack_require__(562);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class InputManager
	 * @memberOf Phaser.Input
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Game} game - [description]
	 * @param {object} config - [description]
	 */
	var InputManager = new Class({
	
	    initialize:
	
	    function InputManager (game, config)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputManager#game
	         * @type {Phaser.Game}
	         * @since 3.0.0
	         */
	        this.game = game;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputManager#canvas
	         * @type {HTMLCanvasElement}
	         * @since 3.0.0
	         */
	        this.canvas;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputManager#config
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.config = config;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputManager#enabled
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.enabled = true;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputManager#events
	         * @type {Phaser.Events.EventEmitter}
	         * @since 3.0.0
	         */
	        this.events = new EventEmitter();
	
	        /**
	         * Standard FIFO queue.
	         *
	         * @name Phaser.Input.InputManager#queue
	         * @type {array}
	         * @default []
	         * @since 3.0.0
	         */
	        this.queue = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputManager#keyboard
	         * @type {Phaser.Input.Keyboard.KeyboardManager}
	         * @since 3.0.0
	         */
	        this.keyboard = new Keyboard(this);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputManager#mouse
	         * @type {Phaser.Input.Mouse.MouseManager}
	         * @since 3.0.0
	         */
	        this.mouse = new Mouse(this);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputManager#touch
	         * @type {Phaser.Input.Touch.TouchManager}
	         * @since 3.0.0
	         */
	        this.touch = new Touch(this);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputManager#gamepad
	         * @type {Phaser.Input.Gamepad.GamepadManager}
	         * @since 3.0.0
	         */
	        this.gamepad = new Gamepad(this);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputManager#activePointer
	         * @type {Phaser.Input.Pointer}
	         * @since 3.0.0
	         */
	        this.activePointer = new Pointer(this, 0);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputManager#scale
	         * @type {{x:number,y:number}}
	         * @since 3.0.0
	         */
	        this.scale = { x: 1, y: 1 };
	
	        /**
	         * If the top-most Scene in the Scene List receives an input it will stop input from
	         * propagating any lower down the scene list, i.e. if you have a UI Scene at the top
	         * and click something on it, that click will not then be passed down to any other
	         * Scene below. Disable this to have input events passed through all Scenes, all the time.
	         *
	         * @name Phaser.Input.InputManager#globalTopOnly
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.globalTopOnly = true;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputManager#ignoreEvents
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.ignoreEvents = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputManager#bounds
	         * @type {Phaser.Geom.Rectangle}
	         * @since 3.0.0
	         */
	        this.bounds = new Rectangle();
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputManager#_tempPoint
	         * @type {{x:number,y:number}}
	         * @private
	         * @since 3.0.0
	         */
	        this._tempPoint = { x: 0, y: 0 };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputManager#_tempHitTest
	         * @type {array}
	         * @private
	         * @default []
	         * @since 3.0.0
	         */
	        this._tempHitTest = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputManager#_tempMatrix
	         * @type {Phaser.GameObjects.Components.TransformMatrix}
	         * @private
	         * @since 3.4.0
	         */
	        this._tempMatrix = new TransformMatrix();
	
	        game.events.once('boot', this.boot, this);
	    },
	
	    /**
	     * The Boot handler is called by Phaser.Game when it first starts up.
	     * The renderer is available by now.
	     *
	     * @method Phaser.Input.InputManager#boot
	     * @since 3.0.0
	     */
	    boot: function ()
	    {
	        this.canvas = this.game.canvas;
	
	        this.updateBounds();
	
	        this.keyboard.boot();
	        this.mouse.boot();
	        this.touch.boot();
	        this.gamepad.boot();
	
	        this.game.events.on('prestep', this.update, this);
	        this.game.events.once('destroy', this.destroy, this);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputManager#updateBounds
	     * @since 3.0.0
	     */
	    updateBounds: function ()
	    {
	        var bounds = this.bounds;
	
	        var clientRect = this.canvas.getBoundingClientRect();
	
	        bounds.x = clientRect.left + window.pageXOffset - document.documentElement.clientLeft;
	        bounds.y = clientRect.top + window.pageYOffset - document.documentElement.clientTop;
	        bounds.width = clientRect.width;
	        bounds.height = clientRect.height;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputManager#resize
	     * @since 3.2.0
	     */
	    resize: function ()
	    {
	        this.updateBounds();
	
	        //  Game config size
	        var gw = this.game.config.width;
	        var gh = this.game.config.height;
	
	        //  Actual canvas size
	        var bw = this.bounds.width;
	        var bh = this.bounds.height;
	
	        //  Scale factor
	        this.scale.x = gw / bw;
	        this.scale.y = gh / bh;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputManager#update
	     * @since 3.0.0
	     *
	     * @param {number} time - [description]
	     */
	    update: function (time)
	    {
	        this.keyboard.update();
	        this.gamepad.update();
	
	        this.ignoreEvents = false;
	
	        var len = this.queue.length;
	
	        //  Currently just 1 pointer supported
	        var pointer = this.activePointer;
	
	        pointer.reset();
	
	        if (!this.enabled || len === 0)
	        {
	            return;
	        }
	
	        this.updateBounds();
	
	        this.scale.x = this.game.config.width / this.bounds.width;
	        this.scale.y = this.game.config.height / this.bounds.height;
	
	        //  Clears the queue array, and also means we don't work on array data that could potentially
	        //  be modified during the processing phase
	        var queue = this.queue.splice(0, len);
	
	        //  Process the event queue, dispatching all of the events that have stored up
	        for (var i = 0; i < len; i++)
	        {
	            var event = queue[i];
	
	            //  TODO: Move to CONSTs so we can do integer comparisons instead of strings.
	            switch (event.type)
	            {
	                case 'mousemove':
	
	                    pointer.move(event, time);
	                    break;
	
	                case 'mousedown':
	
	                    pointer.down(event, time);
	                    break;
	
	                case 'mouseup':
	
	                    pointer.up(event, time);
	                    break;
	
	                case 'touchmove':
	
	                    pointer.touchmove(event, time);
	                    break;
	
	                case 'touchstart':
	
	                    pointer.touchstart(event, time);
	                    break;
	
	                case 'touchend':
	
	                    pointer.touchend(event, time);
	                    break;
	
	                case 'pointerlockchange':
	
	                    this.events.emit('pointerlockchange', event, this.mouse.locked);
	                    break;
	            }
	        }
	    },
	
	    /**
	     * Will always return an array.
	     * Array contains matching Interactive Objects.
	     * Array will be empty if no objects were matched.
	     * x/y = pointer x/y (un-translated)
	     *
	     * @method Phaser.Input.InputManager#hitTest
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {array} gameObjects - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {array} output - [description]
	     *
	     * @return {array} [description]
	     */
	    hitTest: function (x, y, gameObjects, camera, output)
	    {
	        if (output === undefined) { output = this._tempHitTest; }
	
	        var tempPoint = this._tempPoint;
	        var cameraW = camera.width;
	        var cameraH = camera.height;
	
	        output.length = 0;
	
	        if (!(x >= camera.x && y >= camera.y && x <= camera.x + cameraW && y <= camera.y + cameraH))
	        {
	            return output;
	        }
	
	        //  Stores the world point inside of tempPoint
	        camera.getWorldPoint(x, y, tempPoint);
	
	        var culledGameObjects = camera.cull(gameObjects);
	
	        var point = { x: 0, y: 0 };
	
	        var res = this.game.config.resolution;
	
	        var matrix = this._tempMatrix;
	
	        for (var i = 0; i < culledGameObjects.length; i++)
	        {
	            var gameObject = culledGameObjects[i];
	
	            if (!gameObject.input || !gameObject.input.enabled || !gameObject.willRender())
	            {
	                continue;
	            }
	
	            var px = tempPoint.x * res + (camera.scrollX * gameObject.scrollFactorX) - camera.scrollX;
	            var py = tempPoint.y * res + (camera.scrollY * gameObject.scrollFactorY) - camera.scrollY;
	
	            if (gameObject.parentContainer)
	            {
	                gameObject.getWorldTransformMatrix(matrix);
	
	                TransformXY(px, py, matrix.tx, matrix.ty, matrix.rotation, matrix.scaleX, matrix.scaleY, point);
	            }
	            else
	            {
	                TransformXY(px, py, gameObject.x, gameObject.y, gameObject.rotation, gameObject.scaleX, gameObject.scaleY, point);
	            }
	
	            if (this.pointWithinHitArea(gameObject, point.x, point.y))
	            {
	                output.push(gameObject);
	            }
	        }
	
	        return output;
	    },
	
	    /*
	    debugHitTest: function (x, y, gameObject, camera, output)
	    {
	        if (output === undefined) { output = this._tempHitTest; }
	
	        var tempPoint = this._tempPoint;
	
	        //  Stores the translated world point inside of tempPoint
	        camera.getWorldPoint(x, y, tempPoint);
	
	        var point = { x: 0, y: 0 };
	
	        var res = this.game.config.resolution;
	
	        var matrix = this._tempMatrix;
	
	        var px = tempPoint.x * res + (camera.scrollX * gameObject.scrollFactorX) - camera.scrollX;
	        var py = tempPoint.y * res + (camera.scrollY * gameObject.scrollFactorY) - camera.scrollY;
	
	        gameObject.getWorldTransformMatrix(matrix);
	
	        // matrix.invert();
	        matrix.transformPoint(px, py, point);
	
	        // var tt = new TransformMatrix();
	
	        // tt.translate(px, py);
	
	        // matrix.invert();
	        // matrix.multiply(tt);
	
	        // TransformXY(px, py, matrix.tx, matrix.ty, matrix.rotation, matrix.scaleX, matrix.scaleY, point);
	
	        // point.x = px;
	        // point.y = py;
	
	        return [ matrix, point, this.pointWithinHitArea(gameObject, point.x, point.y) ];
	    },
	    */
	
	    /**
	     * x/y MUST be translated before being passed to this function,
	     * unless the gameObject is guaranteed to not be rotated or scaled in any way.
	     *
	     * @method Phaser.Input.InputManager#pointWithinHitArea
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} gameObject - [description]
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     *
	     * @return {boolean} [description]
	     */
	    pointWithinHitArea: function (gameObject, x, y)
	    {
	        var input = gameObject.input;
	
	        //  Normalize the origin
	        x += gameObject.displayOriginX;
	        y += gameObject.displayOriginY;
	
	        if (input.hitAreaCallback(input.hitArea, x, y, gameObject))
	        {
	            input.localX = x;
	            input.localY = y;
	
	            return true;
	        }
	        else
	        {
	            return false;
	        }
	    },
	
	    /**
	     * x/y MUST be translated before being passed to this function,
	     * unless the gameObject is guaranteed to not be rotated or scaled in any way.
	     *
	     * @method Phaser.Input.InputManager#pointWithinInteractiveObject
	     * @since 3.0.0
	     *
	     * @param {Phaser.Input.InteractiveObject} object - [description]
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     *
	     * @return {boolean} [description]
	     */
	    pointWithinInteractiveObject: function (object, x, y)
	    {
	        if (!object.hitArea)
	        {
	            return false;
	        }
	
	        //  Normalize the origin
	        x += object.gameObject.displayOriginX;
	        y += object.gameObject.displayOriginY;
	
	        object.localX = x;
	        object.localY = y;
	
	        return object.hitAreaCallback(object.hitArea, x, y, object);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputManager#transformX
	     * @since 3.0.0
	     *
	     * @param {number} pageX - [description]
	     *
	     * @return {number} [description]
	     */
	    transformX: function (pageX)
	    {
	        return (pageX - this.bounds.left) * this.scale.x;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputManager#transformY
	     * @since 3.0.0
	     *
	     * @param {number} pageY - [description]
	     *
	     * @return {number} [description]
	     */
	    transformY: function (pageY)
	    {
	        return (pageY - this.bounds.top) * this.scale.y;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputManager#getOffsetX
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    getOffsetX: function ()
	    {
	        return this.bounds.left;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputManager#getOffsetY
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    getOffsetY: function ()
	    {
	        return this.bounds.top;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputManager#getScaleX
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    getScaleX: function ()
	    {
	        return this.game.config.width / this.bounds.width;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputManager#getScaleY
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    getScaleY: function ()
	    {
	        return this.game.config.height / this.bounds.height;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputManager#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.events.removeAllListeners();
	
	        this.keyboard.destroy();
	        this.mouse.destroy();
	        this.touch.destroy();
	        this.gamepad.destroy();
	
	        this.activePointer.destroy();
	
	        this.queue = [];
	
	        this.game = null;
	    }
	
	});
	
	module.exports = InputManager;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Vector2 = __webpack_require__(9);
	
	// DOM event button value:
	// A number representing a given button:
	// 0: Main button pressed, usually the left button or the un-initialized state
	// 1: Auxiliary button pressed, usually the wheel button or the middle button (if present)
	// 2: Secondary button pressed, usually the right button
	// 3: Fourth button, typically the Browser Back button
	// 4: Fifth button, typically the Browser Forward button
	// For a mouse configured for left-handed use, the button actions are reversed. In this case, the values are read from right to left.
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class Pointer
	 * @memberOf Phaser.Input
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Input.InputManager} manager - [description]
	 * @param {integer} id - [description]
	 */
	var Pointer = new Class({
	
	    initialize:
	
	    function Pointer (manager, id)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Pointer#manager
	         * @type {Phaser.Input.InputManager}
	         * @since 3.0.0
	         */
	        this.manager = manager;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Pointer#id
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.id = id;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Pointer#event
	         * @type {null}
	         * @since 3.0.0
	         */
	        this.event;
	
	        /**
	         * The camera the Pointer interacted with during its last update.
	         * A Pointer can only ever interact with one camera at once, which will be the top-most camera
	         * in the list should multiple cameras be positioned on-top of each other.
	         *
	         * @name Phaser.Input.Pointer#camera
	         * @type {Phaser.Cameras.Scene2D.Camera}
	         * @default null
	         * @since 3.0.0
	         */
	        this.camera = null;
	
	        /**
	         * 0: No button or un-initialized
	         * 1: Left button
	         * 2: Right button
	         * 4: Wheel button or middle button
	         * 8: 4th button (typically the "Browser Back" button)
	         * 16: 5th button (typically the "Browser Forward" button)
	         *
	         * @name Phaser.Input.Pointer#buttons
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.buttons = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Pointer#position
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.position = new Vector2();
	
	        /**
	         * X coordinate of the Pointer when Button 1 (left button), or Touch, was pressed, used for dragging objects.
	         *
	         * @name Phaser.Input.Pointer#downX
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.downX = 0;
	
	        /**
	         * Y coordinate of the Pointer when Button 1 (left button), or Touch, was pressed, used for dragging objects.
	         *
	         * @name Phaser.Input.Pointer#downY
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.downY = 0;
	
	        /**
	         * Time when Button 1 (left button), or Touch, was pressed, used for dragging objects.
	         *
	         * @name Phaser.Input.Pointer#downTime
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.downTime = 0;
	
	        /**
	         * X coordinate of the Pointer when Button 1 (left button), or Touch, was released, used for dragging objects.
	         *
	         * @name Phaser.Input.Pointer#upX
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.upX = 0;
	
	        /**
	         * Y coordinate of the Pointer when Button 1 (left button), or Touch, was released, used for dragging objects.
	         *
	         * @name Phaser.Input.Pointer#upY
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.upY = 0;
	
	        /**
	         * Time when Button 1 (left button), or Touch, was released, used for dragging objects.
	         *
	         * @name Phaser.Input.Pointer#upTime
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.upTime = 0;
	
	        /**
	         * Is the primary button down? (usually button 0, the left mouse button)
	         *
	         * @name Phaser.Input.Pointer#primaryDown
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.primaryDown = false;
	
	
	        /**
	         * The Drag State of the Pointer:
	         *
	         * 0 = Not dragging anything
	         * 1 = Being checked if dragging
	         * 2 = Dragging something
	         *
	         * @name Phaser.Input.Pointer#dragState
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.dragState = 0;
	
	        /**
	         * Is _any_ button on this pointer considered as being down?
	         *
	         * @name Phaser.Input.Pointer#isDown
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.isDown = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Pointer#dirty
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.dirty = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Pointer#justDown
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.justDown = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Pointer#justUp
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.justUp = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Pointer#justMoved
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.justMoved = false;
	
	        /**
	         * Did the previous input event come from a Touch input (true) or Mouse? (false)
	         *
	         * @name Phaser.Input.Pointer#wasTouch
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.wasTouch = false;
	
	        /**
	         * If the mouse is locked, the horizontal relative movement of the Pointer in pixels since last frame.
	         *
	         * @name Phaser.Input.Pointer#movementX
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.movementX = 0;
	
	        /**
	         * If the mouse is locked, the vertical relative movement of the Pointer in pixels since last frame.
	         *
	         * @name Phaser.Input.Pointer#movementY
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.movementY = 0;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Pointer#positionToCamera
	     * @since 3.0.0
	     *
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {(Phaser.Math.Vector2|object)} [output] - [description]
	     *
	     * @return {(Phaser.Math.Vector2|object)} [description]
	     */
	    positionToCamera: function (camera, output)
	    {
	        return camera.getWorldPoint(this.x, this.y, output);
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Input.Pointer#x
	     * @type {number}
	     * @since 3.0.0
	     */
	    x: {
	
	        get: function ()
	        {
	            return this.position.x;
	        },
	
	        set: function (value)
	        {
	            this.position.x = value;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Input.Pointer#y
	     * @type {number}
	     * @since 3.0.0
	     */
	    y: {
	
	        get: function ()
	        {
	            return this.position.y;
	        },
	
	        set: function (value)
	        {
	            this.position.y = value;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Pointer#reset
	     * @since 3.0.0
	     */
	    reset: function ()
	    {
	        // this.buttons = 0;
	
	        this.dirty = false;
	
	        this.justDown = false;
	        this.justUp = false;
	        this.justMoved = false;
	
	        this.movementX = 0;
	        this.movementY = 0;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Pointer#touchmove
	     * @since 3.0.0
	     *
	     * @param {TouchEvent} event - [description]
	     * @param {integer} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
	     */
	    touchmove: function (event)
	    {
	        this.event = event;
	
	        this.x = this.manager.transformX(event.changedTouches[0].pageX);
	        this.y = this.manager.transformY(event.changedTouches[0].pageY);
	
	        this.justMoved = true;
	
	        this.dirty = true;
	
	        this.wasTouch = true;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Pointer#move
	     * @since 3.0.0
	     *
	     * @param {MouseEvent} event - [description]
	     * @param {integer} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
	     */
	    move: function (event)
	    {
	        if (event.buttons)
	        {
	            this.buttons = event.buttons;
	        }
	
	        this.event = event;
	
	        this.x = this.manager.transformX(event.pageX);
	        this.y = this.manager.transformY(event.pageY);
	
	        if (this.manager.mouse.locked)
	        {
	            // Multiple DOM events may occur within one frame, but only one Phaser event will fire
	            this.movementX += event.movementX || event.mozMovementX || event.webkitMovementX || 0;
	            this.movementY += event.movementY || event.mozMovementY || event.webkitMovementY || 0;
	        }
	
	        this.justMoved = true;
	
	        this.dirty = true;
	
	        this.wasTouch = false;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Pointer#down
	     * @since 3.0.0
	     *
	     * @param {MouseEvent} event - [description]
	     * @param {integer} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
	     */
	    down: function (event, time)
	    {
	        if (event.buttons)
	        {
	            this.buttons = event.buttons;
	        }
	
	        this.event = event;
	
	        this.x = this.manager.transformX(event.pageX);
	        this.y = this.manager.transformY(event.pageY);
	
	        //  0: Main button pressed, usually the left button or the un-initialized state
	        if (event.button === 0)
	        {
	            this.primaryDown = true;
	            this.downX = this.x;
	            this.downY = this.y;
	            this.downTime = time;
	        }
	
	        this.justDown = true;
	        this.isDown = true;
	
	        this.dirty = true;
	
	        this.wasTouch = false;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Pointer#touchstart
	     * @since 3.0.0
	     *
	     * @param {TouchEvent} event - [description]
	     * @param {integer} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
	     */
	    touchstart: function (event, time)
	    {
	        this.buttons = 1;
	
	        this.event = event;
	
	        this.x = this.manager.transformX(event.changedTouches[0].pageX);
	        this.y = this.manager.transformY(event.changedTouches[0].pageY);
	
	        this.primaryDown = true;
	        this.downX = this.x;
	        this.downY = this.y;
	        this.downTime = time;
	
	        this.justDown = true;
	        this.isDown = true;
	
	        this.dirty = true;
	
	        this.wasTouch = true;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Pointer#up
	     * @since 3.0.0
	     *
	     * @param {MouseEvent} event - [description]
	     * @param {integer} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
	     */
	    up: function (event, time)
	    {
	        if (event.buttons)
	        {
	            this.buttons = event.buttons;
	        }
	
	        this.event = event;
	
	        this.x = this.manager.transformX(event.pageX);
	        this.y = this.manager.transformY(event.pageY);
	
	        //  0: Main button pressed, usually the left button or the un-initialized state
	        if (event.button === 0)
	        {
	            this.primaryDown = false;
	            this.upX = this.x;
	            this.upY = this.y;
	            this.upTime = time;
	        }
	
	        this.justUp = true;
	        this.isDown = false;
	
	        this.dirty = true;
	
	        this.wasTouch = false;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Pointer#touchend
	     * @since 3.0.0
	     *
	     * @param {TouchEvent} event - [description]
	     * @param {integer} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
	     */
	    touchend: function (event, time)
	    {
	        this.buttons = 0;
	
	        this.event = event;
	
	        this.x = this.manager.transformX(event.changedTouches[0].pageX);
	        this.y = this.manager.transformY(event.changedTouches[0].pageY);
	
	        this.primaryDown = false;
	        this.upX = this.x;
	        this.upY = this.y;
	        this.upTime = time;
	
	        this.justUp = true;
	        this.isDown = false;
	
	        this.dirty = true;
	
	        this.wasTouch = true;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Pointer#noButtonDown
	     * @since 3.0.0
	     *
	     * @return {boolean} [description]
	     */
	    noButtonDown: function ()
	    {
	        return (this.buttons === 0);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Pointer#leftButtonDown
	     * @since 3.0.0
	     *
	     * @return {boolean} [description]
	     */
	    leftButtonDown: function ()
	    {
	        return (this.buttons & 1);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Pointer#rightButtonDown
	     * @since 3.0.0
	     *
	     * @return {boolean} [description]
	     */
	    rightButtonDown: function ()
	    {
	        return (this.buttons & 2);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Pointer#middleButtonDown
	     * @since 3.0.0
	     *
	     * @return {boolean} [description]
	     */
	    middleButtonDown: function ()
	    {
	        return (this.buttons & 4);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Pointer#backButtonDown
	     * @since 3.0.0
	     *
	     * @return {boolean} [description]
	     */
	    backButtonDown: function ()
	    {
	        return (this.buttons & 8);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Pointer#forwardButtonDown
	     * @since 3.0.0
	     *
	     * @return {boolean} [description]
	     */
	    forwardButtonDown: function ()
	    {
	        return (this.buttons & 16);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Pointer#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.camera = null;
	        this.manager = null;
	        this.position = null;
	    }
	
	});
	
	module.exports = Pointer;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class Axis
	 * @memberOf Phaser.Input.Gamepad
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Input.Gamepad.Gamepad} pad - [description]
	 * @param {integer} index - [description]
	 */
	var Axis = new Class({
	
	    initialize:
	
	    function Axis (pad, index)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Gamepad.Axis#pad
	         * @type {Phaser.Input.Gamepad.Gamepad}
	         * @since 3.0.0
	         */
	        this.pad = pad;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Gamepad.Axis#events
	         * @type {Phaser.Events.EventEmitter}
	         * @since 3.0.0
	         */
	        this.events = pad.events;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Gamepad.Axis#index
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.index = index;
	
	        /**
	         * The raw axis value, between -1 and 1 with 0 being dead center.
	         * Use the method `getValue` to get a normalized value with the threshold applied.
	         *
	         * @name Phaser.Input.Gamepad.Axis#value
	         * @type {float}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.value = 0;
	
	        /**
	         * Movement tolerance threshold below which axis values are ignored in `getValue`.
	         *
	         * @name Phaser.Input.Gamepad.Axis#threshold
	         * @type {float}
	         * @default 0.1
	         * @since 3.0.0
	         */
	        this.threshold = 0.1;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Gamepad.Axis#update
	     * @since 3.0.0
	     *
	     * @param {float} value - [description]
	     */
	    update: function (value)
	    {
	        this.value = value;
	    },
	
	    /**
	     * Applies threshold to the value and returns it.
	     *
	     * @method Phaser.Input.Gamepad.Axis#getValue
	     * @since 3.0.0
	     *
	     * @return {float} [description]
	     */
	    getValue: function ()
	    {
	        return (Math.abs(this.value) < this.threshold) ? 0 : this.value;
	    }
	
	});
	
	module.exports = Axis;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class Button
	 * @memberOf Phaser.Input.Gamepad
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Input.Gamepad.Gamepad} pad - [description]
	 * @param {integer} index - [description]
	 */
	var Button = new Class({
	
	    initialize:
	
	    function Button (pad, index)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Gamepad.Button#pad
	         * @type {Phaser.Input.Gamepad.Gamepad}
	         * @since 3.0.0
	         */
	        this.pad = pad;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Gamepad.Button#events
	         * @type {Phaser.Events.EventEmitter}
	         * @since 3.0.0
	         */
	        this.events = pad.manager;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Gamepad.Button#index
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.index = index;
	
	        /**
	         * Between 0 and 1.
	         *
	         * @name Phaser.Input.Gamepad.Button#value
	         * @type {float}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.value = 0;
	
	        /**
	         * Can be set for Analogue buttons to enable a 'pressure' threshold before considered as 'pressed'.
	         *
	         * @name Phaser.Input.Gamepad.Button#threshold
	         * @type {float}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.threshold = 1;
	
	        /**
	         * Is the Button being pressed down or not?
	         *
	         * @name Phaser.Input.Gamepad.Button#pressed
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.pressed = false;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Gamepad.Button#update
	     * @since 3.0.0
	     *
	     * @param {GamepadButton} data - [description]
	     */
	    update: function (data)
	    {
	        this.value = data.value;
	
	        if (this.value >= this.threshold)
	        {
	            if (!this.pressed)
	            {
	                this.pressed = true;
	                this.events.emit('down', this.pad, this, this.value, data);
	            }
	        }
	        else if (this.pressed)
	        {
	            this.pressed = false;
	            this.events.emit('up', this.pad, this, this.value, data);
	        }
	    }
	
	});
	
	module.exports = Button;


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Axis = __webpack_require__(535);
	var Button = __webpack_require__(536);
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class Gamepad
	 * @memberOf Phaser.Input.Gamepad
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Input.Gamepad.GamepadManager} manager - [description]
	 * @param {string} id - [description]
	 * @param {number} index - [description]
	 */
	var Gamepad = new Class({
	
	    initialize:
	
	    function Gamepad (manager, id, index)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Gamepad.Gamepad#manager
	         * @type {Phaser.Input.Gamepad.GamepadManager}
	         * @since 3.0.0
	         */
	        this.manager = manager;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Gamepad.Gamepad#id
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.id = id;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Gamepad.Gamepad#index
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.index = index;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Gamepad.Gamepad#connected
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.connected = true;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Gamepad.Gamepad#timestamp
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.timestamp = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Gamepad.Gamepad#buttons
	         * @type {Phaser.Input.Gamepad.Button[]}
	         * @default []
	         * @since 3.0.0
	         */
	        this.buttons = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Gamepad.Gamepad#axes
	         * @type {Phaser.Input.Gamepad.Axis[]}
	         * @default []
	         * @since 3.0.0
	         */
	        this.axes = [];
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Gamepad.Gamepad#update
	     * @since 3.0.0
	     *
	     * @param {Gamepad} data - [description]
	     */
	    update: function (data)
	    {
	        this.timestamp = data.timestamp;
	        this.connected = data.connected;
	
	        var i;
	
	        var axes = this.axes;
	        var buttons = this.buttons;
	
	        for (i = 0; i < data.buttons.length; i++)
	        {
	            var buttonData = data.buttons[i];
	
	            if (buttons[i] === undefined)
	            {
	                buttons[i] = new Button(this, i);
	            }
	
	            buttons[i].update(buttonData);
	        }
	
	        //  Axes
	        for (i = 0; i < data.axes.length; i++)
	        {
	            var axisData = data.axes[i];
	
	            if (axes[i] === undefined)
	            {
	                axes[i] = new Axis(this, i);
	            }
	            else
	            {
	                axes[i].update(axisData);
	            }
	        }
	    }
	
	});
	
	module.exports = Gamepad;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var EventEmitter = __webpack_require__(22);
	var Gamepad = __webpack_require__(537);
	
	// https://developer.mozilla.org/en-US/docs/Web/API/Gamepad_API
	// https://developer.mozilla.org/en-US/docs/Web/API/Gamepad_API/Using_the_Gamepad_API
	// https://www.smashingmagazine.com/2015/11/gamepad-api-in-web-games/
	// http://html5gamepad.com/
	
	/**
	 * @typedef {object} Pad
	 *
	 * @property {string} id - [description]
	 * @property {integer} index - [description]
	 */
	
	/**
	 * @callback GamepadHandler
	 *
	 * @property {GamepadEvent} event - [description]
	 */
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class GamepadManager
	 * @extends Phaser.Events.EventEmitter
	 * @memberOf Phaser.Input.Gamepad
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Input.InputManager} inputManager - [description]
	 */
	var GamepadManager = new Class({
	
	    Extends: EventEmitter,
	
	    initialize:
	
	    function GamepadManager (inputManager)
	    {
	        EventEmitter.call(this);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Gamepad.GamepadManager#manager
	         * @type {Phaser.Input.InputManager}
	         * @since 3.0.0
	         */
	        this.manager = inputManager;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Gamepad.GamepadManager#enabled
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.enabled = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Gamepad.GamepadManager#target
	         * @type {?object}
	         * @since 3.0.0
	         */
	        this.target;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Gamepad.GamepadManager#handler
	         * @type {?GamepadHandler}
	         * @since 3.0.0
	         */
	        this.handler;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Gamepad.GamepadManager#gamepads
	         * @type {Phaser.Input.Gamepad.Gamepad[]}
	         * @default []
	         * @since 3.0.0
	         */
	        this.gamepads = [];
	
	        /**
	         * Standard FIFO queue.
	         *
	         * @name Phaser.Input.Gamepad.GamepadManager#queue
	         * @type {GamepadEvent[]}
	         * @default []
	         * @since 3.0.0
	         */
	        this.queue = [];
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Gamepad.GamepadManager#boot
	     * @since 3.0.0
	     */
	    boot: function ()
	    {
	        var config = this.manager.config;
	
	        this.enabled = config.inputGamepad && this.manager.game.device.input.gamepads;
	
	        this.target = window;
	
	        if (this.enabled)
	        {
	            this.startListeners();
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Gamepad.GamepadManager#startListeners
	     * @since 3.0.0
	     */
	    startListeners: function ()
	    {
	        var queue = this.queue;
	
	        var handler = function handler (event)
	        {
	            if (event.defaultPrevented)
	            {
	                // Do nothing if event already handled
	                return;
	            }
	
	            queue.push(event);
	        };
	
	        this.handler = handler;
	
	        var target = this.target;
	
	        target.addEventListener('gamepadconnected', handler, false);
	        target.addEventListener('gamepaddisconnected', handler, false);
	
	        //  FF only for now:
	        target.addEventListener('gamepadbuttondown', handler, false);
	        target.addEventListener('gamepadbuttonup', handler, false);
	        target.addEventListener('gamepadaxismove', handler, false);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Gamepad.GamepadManager#stopListeners
	     * @since 3.0.0
	     */
	    stopListeners: function ()
	    {
	        var target = this.target;
	        var handler = this.handler;
	
	        target.removeEventListener('gamepadconnected', handler);
	        target.removeEventListener('gamepaddisconnected', handler);
	
	        target.removeEventListener('gamepadbuttondown', handler);
	        target.removeEventListener('gamepadbuttonup', handler);
	        target.removeEventListener('gamepadaxismove', handler);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Gamepad.GamepadManager#disconnectAll
	     * @since 3.0.0
	     */
	    disconnectAll: function ()
	    {
	        for (var i = 0; i < this.gamepads.length; i++)
	        {
	            this.gamepads.connected = false;
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Gamepad.GamepadManager#addPad
	     * @since 3.0.0
	     *
	     * @param {Pad} pad - [description]
	     *
	     * @return {Phaser.Input.Gamepad.Gamepad} [description]
	     */
	    addPad: function (pad)
	    {
	        var gamepad = new Gamepad(this, pad.id, pad.index);
	
	        this.gamepads[pad.index] = gamepad;
	
	        return gamepad;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Gamepad.GamepadManager#removePad
	     * @since 3.0.0
	     * @todo  Code this feature
	     *
	     * @param {number} index - [description]
	     * @param {Pad} pad - [description]
	     */
	    removePad: function ()
	    {
	        //  TODO
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Gamepad.GamepadManager#refreshPads
	     * @since 3.0.0
	     *
	     * @param {Pad[]} pads - [description]
	     */
	    refreshPads: function (pads)
	    {
	        if (!pads)
	        {
	            this.disconnectAll();
	        }
	        else
	        {
	            for (var i = 0; i < pads.length; i++)
	            {
	                var pad = pads[i];
	
	                if (!pad)
	                {
	                    //  removePad?
	                    continue;
	                }
	
	                if (this.gamepads[pad.index] === undefined)
	                {
	                    this.addPad(pad);
	                }
	
	                this.gamepads[pad.index].update(pad);
	            }
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Gamepad.GamepadManager#getAll
	     * @since 3.0.0
	     *
	     * @return {Phaser.Input.Gamepad.Gamepad[]} [description]
	     */
	    getAll: function ()
	    {
	        var out = [];
	
	        for (var i = 0; i < this.gamepads.length; i++)
	        {
	            if (this.gamepads[i])
	            {
	                out.push(this.gamepads[i]);
	            }
	        }
	
	        return out;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Gamepad.GamepadManager#getPad
	     * @since 3.0.0
	     *
	     * @param {number} index - [description]
	     *
	     * @return {Phaser.Input.Gamepad.Gamepad} [description]
	     */
	    getPad: function (index)
	    {
	        for (var i = 0; i < this.gamepads.length; i++)
	        {
	            if (this.gamepads[i].index === index)
	            {
	                return this.gamepads[i];
	            }
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Gamepad.GamepadManager#update
	     * @since 3.0.0
	     */
	    update: function ()
	    {
	        if (!this.enabled)
	        {
	            return;
	        }
	
	        this.refreshPads(navigator.getGamepads());
	
	        var len = this.queue.length;
	
	        if (len === 0)
	        {
	            return;
	        }
	
	        var queue = this.queue.splice(0, len);
	
	        //  Process the event queue, dispatching all of the events that have stored up
	        for (var i = 0; i < len; i++)
	        {
	            var event = queue[i];
	            var pad;
	
	            switch (event.type)
	            {
	                case 'gamepadconnected':
	
	                    pad = this.getPad(event.gamepad.index);
	
	                    this.emit('connected', pad, event);
	
	                    break;
	
	                case 'gamepaddisconnected':
	
	                    pad = this.getPad(event.gamepad.index);
	
	                    this.emit('disconnected', pad, event);
	
	                    break;
	            }
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Gamepad.GamepadManager#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.stopListeners();
	        this.disconnectAll();
	
	        this.gamepads = [];
	    },
	
	    /**
	     * The total number of connected game pads.
	     *
	     * @name Phaser.Input.Gamepad.GamepadManager#total
	     * @type {number}
	     * @since 3.0.0
	     */
	    total: {
	
	        get: function ()
	        {
	            return this.gamepads.length;
	        }
	
	    }
	
	});
	
	module.exports = GamepadManager;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var EventEmitter = __webpack_require__(22);
	var Key = __webpack_require__(541);
	var KeyCodes = __webpack_require__(301);
	var KeyCombo = __webpack_require__(540);
	var KeyMap = __webpack_require__(1321);
	var ProcessKeyDown = __webpack_require__(1322);
	var ProcessKeyUp = __webpack_require__(1323);
	
	/**
	 * @callback KeyboardHandler
	 *
	 * @property {KeyboardEvent} event - [description]
	 */
	
	/**
	 * @classdesc
	 * The Keyboard class monitors keyboard input and dispatches keyboard events.
	 *
	 * _Note_: many keyboards are unable to process certain combinations of keys due to hardware limitations known as ghosting.
	 * See http://www.html5gamedevs.com/topic/4876-impossible-to-use-more-than-2-keyboard-input-buttons-at-the-same-time/ for more details.
	 *
	 * Also please be aware that certain browser extensions can disable or override Phaser keyboard handling.
	 * For example the Chrome extension vimium is known to disable Phaser from using the D key. And there are others.
	 * So please check your extensions before opening Phaser issues.
	 *
	 * @class KeyboardManager
	 * @extends Phaser.Events.EventEmitter
	 * @memberOf Phaser.Input.Keyboard
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Input.InputManager} inputManager - [description]
	 */
	var KeyboardManager = new Class({
	
	    Extends: EventEmitter,
	
	    initialize:
	
	    function KeyboardManager (inputManager)
	    {
	        EventEmitter.call(this);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Keyboard.KeyboardManager#manager
	         * @type {Phaser.Input.InputManager}
	         * @since 3.0.0
	         */
	        this.manager = inputManager;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Keyboard.KeyboardManager#enabled
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.enabled = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Keyboard.KeyboardManager#target
	         * @type {?object}
	         * @since 3.0.0
	         */
	        this.target;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Keyboard.KeyboardManager#keys
	         * @type {Phaser.Input.Keyboard.Key[]}
	         * @default []
	         * @since 3.0.0
	         */
	        this.keys = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Keyboard.KeyboardManager#combos
	         * @type {Phaser.Input.Keyboard.KeyCombo[]}
	         * @default []
	         * @since 3.0.0
	         */
	        this.combos = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Keyboard.KeyboardManager#captures
	         * @type {array}
	         * @default []
	         * @since 3.0.0
	         */
	        this.captures = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Keyboard.KeyboardManager#queue
	         * @type {KeyboardEvent[]}
	         * @default []
	         * @since 3.0.0
	         */
	        this.queue = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Keyboard.KeyboardManager#handler
	         * @type {?KeyboardHandler}
	         * @since 3.0.0
	         */
	        this.handler;
	    },
	
	    /**
	     * The Boot handler is called by Phaser.Game when it first starts up.
	     *
	     * @method Phaser.Input.Keyboard.KeyboardManager#boot
	     * @since 3.0.0
	     */
	    boot: function ()
	    {
	        var config = this.manager.config;
	
	        this.enabled = config.inputKeyboard;
	        this.target = config.inputKeyboardEventTarget;
	
	        if (this.enabled)
	        {
	            this.startListeners();
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Keyboard.KeyboardManager#startListeners
	     * @since 3.0.0
	     */
	    startListeners: function ()
	    {
	        var queue = this.queue;
	        var captures = this.captures;
	
	        var handler = function (event)
	        {
	            if (event.defaultPrevented)
	            {
	                // Do nothing if event already handled
	                return;
	            }
	
	            queue.push(event);
	
	            if (captures[event.keyCode])
	            {
	                event.preventDefault();
	            }
	        };
	
	        this.handler = handler;
	
	        this.target.addEventListener('keydown', handler, false);
	        this.target.addEventListener('keyup', handler, false);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Keyboard.KeyboardManager#stopListeners
	     * @since 3.0.0
	     */
	    stopListeners: function ()
	    {
	        this.target.removeEventListener('keydown', this.handler);
	        this.target.removeEventListener('keyup', this.handler);
	    },
	
	    /**
	     * @typedef {object} CursorKeys
	     *
	     * @property {Phaser.Input.Keyboard.Key} [up] - [description]
	     * @property {Phaser.Input.Keyboard.Key} [down] - [description]
	     * @property {Phaser.Input.Keyboard.Key} [left] - [description]
	     * @property {Phaser.Input.Keyboard.Key} [right] - [description]
	     * @property {Phaser.Input.Keyboard.Key} [space] - [description]
	     * @property {Phaser.Input.Keyboard.Key} [shift] - [description]
	     */
	
	    /**
	     * Creates and returns an object containing 4 hotkeys for Up, Down, Left and Right, and also space and shift.
	     *
	     * @method Phaser.Input.Keyboard.KeyboardManager#createCursorKeys
	     * @since 3.0.0
	     *
	     * @return {CursorKeys} [description]
	     */
	    createCursorKeys: function ()
	    {
	        return this.addKeys({
	            up: KeyCodes.UP,
	            down: KeyCodes.DOWN,
	            left: KeyCodes.LEFT,
	            right: KeyCodes.RIGHT,
	            space: KeyCodes.SPACE,
	            shift: KeyCodes.SHIFT
	        });
	    },
	
	    /**
	     * A practical way to create an object containing user selected hotkeys.
	     *
	     * For example,
	     *
	     *     addKeys({ 'up': Phaser.Input.Keyboard.KeyCodes.W, 'down': Phaser.Input.Keyboard.KeyCodes.S });
	     *
	     * would return an object containing properties (`up` and `down`) referring to {@link Phaser.Input.Keyboard.Key} objects.
	     *
	     * @method Phaser.Input.Keyboard.KeyboardManager#addKeys
	     * @since 3.0.0
	     *
	     * @param {object} keys - [description]
	     *
	     * @return {object} [description]
	     */
	    addKeys: function (keys)
	    {
	        var output = {};
	
	        for (var key in keys)
	        {
	            output[key] = this.addKey(keys[key]);
	        }
	
	        return output;
	    },
	
	    /**
	     * If you need more fine-grained control over a Key you can create a new Phaser.Key object via this method.
	     * The Key object can then be polled, have events attached to it, etc.
	     *
	     * @method Phaser.Input.Keyboard.KeyboardManager#addKey
	     * @since 3.0.0
	     *
	     * @param {(string|integer)} keyCode - [description]
	     *
	     * @return {Phaser.Input.Keyboard.Key} [description]
	     */
	    addKey: function (keyCode)
	    {
	        var keys = this.keys;
	
	        if (!keys[keyCode])
	        {
	            keys[keyCode] = new Key(keyCode);
	            this.captures[keyCode] = true;
	        }
	
	        return keys[keyCode];
	    },
	
	    /**
	     * Removes a Key object from the Keyboard manager.
	     *
	     * @method Phaser.Input.Keyboard.KeyboardManager#removeKey
	     * @since 3.0.0
	     *
	     * @param {(string|integer)} keyCode - [description]
	     */
	    removeKey: function (keyCode)
	    {
	        if (this.keys[keyCode])
	        {
	            this.keys[keyCode] = undefined;
	            this.captures[keyCode] = false;
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Keyboard.KeyboardManager#addKeyCapture
	     * @since 3.0.0
	     *
	     * @param {(string|integer|string[]|integer[])} keyCodes - [description]
	     */
	    addKeyCapture: function (keyCodes)
	    {
	        if (!Array.isArray(keyCodes))
	        {
	            keyCodes = [ keyCodes ];
	        }
	
	        for (var i = 0; i < keyCodes.length; i++)
	        {
	            this.captures[keyCodes[i]] = true;
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Keyboard.KeyboardManager#removeKeyCapture
	     * @since 3.0.0
	     *
	     * @param {(string|integer|string[]|integer[])} keyCodes - [description]
	     */
	    removeKeyCapture: function (keyCodes)
	    {
	        if (!Array.isArray(keyCodes))
	        {
	            keyCodes = [ keyCodes ];
	        }
	
	        for (var i = 0; i < keyCodes.length; i++)
	        {
	            this.captures[keyCodes[i]] = false;
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Keyboard.KeyboardManager#createCombo
	     * @since 3.0.0
	     *
	     * @param {(string|integer[]|object[])} keys - [description]
	     * @param {KeyComboConfig} config - [description]
	     *
	     * @return {Phaser.Input.Keyboard.KeyCombo} [description]
	     */
	    createCombo: function (keys, config)
	    {
	        return new KeyCombo(this, keys, config);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Keyboard.KeyboardManager#update
	     * @since 3.0.0
	     */
	    update: function ()
	    {
	        var len = this.queue.length;
	
	        if (!this.enabled || len === 0)
	        {
	            return;
	        }
	
	        //  Clears the queue array, and also means we don't work on array data that could potentially
	        //  be modified during the processing phase
	        var queue = this.queue.splice(0, len);
	
	        var keys = this.keys;
	
	        //  Process the event queue, dispatching all of the events that have stored up
	        for (var i = 0; i < len; i++)
	        {
	            var event = queue[i];
	            var code = event.keyCode;
	
	            if (event.type === 'keydown')
	            {
	                if (KeyMap[code] && (keys[code] === undefined || keys[code].isDown === false))
	                {
	                    //  Will emit a keyboard or keyup event
	                    this.emit(event.type, event);
	
	                    this.emit('keydown_' + KeyMap[code], event);
	                }
	
	                if (keys[code])
	                {
	                    ProcessKeyDown(keys[code], event);
	                }
	            }
	            else
	            {
	                //  Will emit a keyboard or keyup event
	                this.emit(event.type, event);
	
	                this.emit('keyup_' + KeyMap[code], event);
	
	                if (keys[code])
	                {
	                    ProcessKeyUp(keys[code], event);
	                }
	            }
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Keyboard.KeyboardManager#shutdown
	     * @since 3.0.0
	     */
	    shutdown: function ()
	    {
	        this.removeAllListeners();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Keyboard.KeyboardManager#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.stopListeners();
	
	        this.removeAllListeners();
	
	        this.keys = [];
	        this.combos = [];
	        this.captures = [];
	        this.queue = [];
	        this.handler = undefined;
	
	        this.manager = null;
	    }
	
	});
	
	module.exports = KeyboardManager;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var GetFastValue = __webpack_require__(3);
	var ProcessKeyCombo = __webpack_require__(1315);
	var ResetKeyCombo = __webpack_require__(1316);
	
	/**
	 * @callback KeyboardKeydownCallback
	 *
	 * @param {KeyboardEvent} event - [description]
	 */
	
	/**
	 * @typedef {object} KeyComboConfig
	 *
	 * @property {boolean} [resetOnWrongKey=true] - [description]
	 * @property {number} [maxKeyDelay=0] - [description]
	 * @property {boolean} [resetOnMatch=false] - [description]
	 * @property {boolean} [deleteOnMatch=false] - [description]
	 */
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * `keys` argument can be:
	 *
	 * A string (ATARI)
	 * An array of either integers (key codes) or strings, or a mixture of both
	 * An array of objects (such as Key objects) with a public 'keyCode' property
	 *
	 * @class KeyCombo
	 * @memberOf Phaser.Input.Keyboard
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Input.Keyboard.KeyboardManager} keyboardManager - [description]
	 * @param {(string|integer[]|object[])} keys - [description]
	 * @param {KeyComboConfig} [config] - [description]
	 */
	var KeyCombo = new Class({
	
	    initialize:
	
	    function KeyCombo (keyboardManager, keys, config)
	    {
	        if (config === undefined) { config = {}; }
	
	        //  Can't have a zero or single length combo (string or array based)
	        if (keys.length < 2)
	        {
	            return false;
	        }
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Keyboard.KeyCombo#manager
	         * @type {Phaser.Input.Keyboard.KeyboardManager}
	         * @since 3.0.0
	         */
	        this.manager = keyboardManager;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Keyboard.KeyCombo#enabled
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.enabled = true;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Keyboard.KeyCombo#keyCodes
	         * @type {array}
	         * @default []
	         * @since 3.0.0
	         */
	        this.keyCodes = [];
	
	        //  if 'keys' is a string we need to get the keycode of each character in it
	
	        for (var i = 0; i < keys.length; i++)
	        {
	            var char = keys[i];
	
	            if (typeof char === 'string')
	            {
	                this.keyCodes.push(char.toUpperCase().charCodeAt(0));
	            }
	            else if (typeof char === 'number')
	            {
	                this.keyCodes.push(char);
	            }
	            else if (char.hasOwnProperty('keyCode'))
	            {
	                this.keyCodes.push(char.keyCode);
	            }
	        }
	
	        /**
	         * The current keyCode the combo is waiting for.
	         *
	         * @name Phaser.Input.Keyboard.KeyCombo#current
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.current = this.keyCodes[0];
	
	        /**
	         * The current index of the key being waited for in the 'keys' string.
	         *
	         * @name Phaser.Input.Keyboard.KeyCombo#index
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.index = 0;
	
	        /**
	         * The length of this combo (in keycodes)
	         *
	         * @name Phaser.Input.Keyboard.KeyCombo#size
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.size = this.keyCodes.length;
	
	        /**
	         * The time the previous key in the combo was matched.
	         *
	         * @name Phaser.Input.Keyboard.KeyCombo#timeLastMatched
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.timeLastMatched = 0;
	
	        /**
	         * Has this Key Combo been matched yet?
	         *
	         * @name Phaser.Input.Keyboard.KeyCombo#matched
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.matched = false;
	
	        /**
	         * The time the entire combo was matched.
	         *
	         * @name Phaser.Input.Keyboard.KeyCombo#timeMatched
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.timeMatched = 0;
	
	        /**
	         * If they press the wrong key do we reset the combo?
	         *
	         * @name Phaser.Input.Keyboard.KeyCombo#resetOnWrongKey
	         * @type {boolean}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.resetOnWrongKey = GetFastValue(config, 'resetOnWrongKey', true);
	
	        /**
	         * The max delay in ms between each key press. Above this the combo is reset. 0 means disabled.
	         *
	         * @name Phaser.Input.Keyboard.KeyCombo#maxKeyDelay
	         * @type {integer}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.maxKeyDelay = GetFastValue(config, 'maxKeyDelay', 0);
	
	        /**
	         * If previously matched and they press Key 1 again, will it reset?
	         *
	         * @name Phaser.Input.Keyboard.KeyCombo#resetOnMatch
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.resetOnMatch = GetFastValue(config, 'resetOnMatch', false);
	
	        /**
	         * If the combo matches, will it delete itself?
	         *
	         * @name Phaser.Input.Keyboard.KeyCombo#deleteOnMatch
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.deleteOnMatch = GetFastValue(config, 'deleteOnMatch', false);
	
	        var _this = this;
	
	        var onKeyDownHandler = function (event)
	        {
	            if (_this.matched || !_this.enabled)
	            {
	                return;
	            }
	
	            var matched = ProcessKeyCombo(event, _this);
	
	            if (matched)
	            {
	                _this.manager.emit('keycombomatch', _this, event);
	
	                if (_this.resetOnMatch)
	                {
	                    ResetKeyCombo(_this);
	                }
	                else if (_this.deleteOnMatch)
	                {
	                    _this.destroy();
	                }
	            }
	        };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Keyboard.KeyCombo#onKeyDown
	         * @type {KeyboardKeydownCallback}
	         * @since 3.0.0
	         */
	        this.onKeyDown = onKeyDownHandler;
	
	        this.manager.on('keydown', onKeyDownHandler);
	    },
	
	    /**
	     * How far complete is this combo? A value between 0 and 1.
	     *
	     * @name Phaser.Input.Keyboard.KeyCombo#progress
	     * @type {number}
	     * @readOnly
	     * @since 3.0.0
	     */
	    progress: {
	
	        get: function ()
	        {
	            return this.index / this.size;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Keyboard.KeyCombo#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.enabled = false;
	        this.keyCodes = [];
	
	        this.manager.off('keydown', this.onKeyDown);
	        this.manager = undefined;
	    }
	
	});
	
	module.exports = KeyCombo;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * A generic Key object which can be passed to the Process functions (and so on)
	 * keycode must be an integer
	 *
	 * @class Key
	 * @memberOf Phaser.Input.Keyboard
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {integer} keyCode - The keycode of this key.
	 */
	var Key = new Class({
	
	    initialize:
	
	    function Key (keyCode)
	    {
	        /**
	         * The keycode of this key.
	         *
	         * @name Phaser.Input.Keyboard.Key#keyCode
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.keyCode = keyCode;
	
	        /**
	         * The original DOM event.
	         *
	         * @name Phaser.Input.Keyboard.Key#originalEvent
	         * @type {KeyboardEvent}
	         * @since 3.0.0
	         */
	        this.originalEvent = undefined;
	
	        /**
	         * Should this Key prevent event propagation?
	         *
	         * @name Phaser.Input.Keyboard.Key#preventDefault
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.preventDefault = true;
	
	        /**
	         * Can this Key be processed?
	         *
	         * @name Phaser.Input.Keyboard.Key#enabled
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.enabled = true;
	
	        /**
	         * The "down" state of the key. This will remain `true` for as long as the keyboard thinks this key is held down.
	         *
	         * @name Phaser.Input.Keyboard.Key#isDown
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.isDown = false;
	
	        /**
	         * The "up" state of the key. This will remain `true` for as long as the keyboard thinks this key is up.
	         *
	         * @name Phaser.Input.Keyboard.Key#isUp
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.isUp = true;
	
	        /**
	         * The down state of the ALT key, if pressed at the same time as this key.
	         *
	         * @name Phaser.Input.Keyboard.Key#altKey
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.altKey = false;
	
	        /**
	         * The down state of the CTRL key, if pressed at the same time as this key.
	         *
	         * @name Phaser.Input.Keyboard.Key#ctrlKey
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.ctrlKey = false;
	
	        /**
	         * The down state of the SHIFT key, if pressed at the same time as this key.
	         *
	         * @name Phaser.Input.Keyboard.Key#shiftKey
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.shiftKey = false;
	
	        /**
	         * The location of the modifier key. 0 for standard (or unknown), 1 for left, 2 for right, 3 for numpad.
	         *
	         * @name Phaser.Input.Keyboard.Key#location
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.location = 0;
	
	        /**
	         * The timestamp when the key was last pressed down.
	         *
	         * @name Phaser.Input.Keyboard.Key#timeDown
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.timeDown = 0;
	
	        /**
	         * The number of milliseconds this key has been held down for.
	         * If the key is down this value holds the duration of that key press and is constantly updated.
	         * If the key is up it holds the duration of the previous down session.
	         *
	         * @name Phaser.Input.Keyboard.Key#duration
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.duration = 0;
	
	        /**
	         * The timestamp when the key was last released.
	         *
	         * @name Phaser.Input.Keyboard.Key#timeUp
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.timeUp = 0;
	
	        /**
	         * If a key is held down this holds down the number of times the key has 'repeated'.
	         *
	         * @name Phaser.Input.Keyboard.Key#repeats
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.repeats = 0;
	
	        /**
	         * True if the key has just been pressed (NOTE: requires to be reset, see justDown getter)
	         *
	         * @name Phaser.Input.Keyboard.Key#_justDown
	         * @type {boolean}
	         * @private
	         * @default false
	         * @since 3.0.0
	         */
	        this._justDown = false;
	
	        /**
	         * True if the key has just been pressed (NOTE: requires to be reset, see justDown getter)
	         *
	         * @name Phaser.Input.Keyboard.Key#_justUp
	         * @type {boolean}
	         * @private
	         * @default false
	         * @since 3.0.0
	         */
	        this._justUp = false;
	    },
	
	    /**
	     * Resets this Key object back to its default un-pressed state.
	     *
	     * @method Phaser.Input.Keyboard.Key.reset
	     * @since 3.6.0
	     * 
	     * @return {Phaser.Input.Keyboard.Key} This Key instance.
	     */
	    reset: function ()
	    {
	        this.preventDefault = true;
	        this.enabled = true;
	        this.isDown = false;
	        this.isUp = true;
	        this.altKey = false;
	        this.ctrlKey = false;
	        this.shiftKey = false;
	        this.timeDown = 0;
	        this.duration = 0;
	        this.timeUp = 0;
	        this.repeats = 0;
	        this._justDown = false;
	        this._justUp = false;
	
	        return this;
	    }
	
	});
	
	module.exports = Key;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Features = __webpack_require__(266);
	
	//  https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent
	//  https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
	
	/**
	 * @callback MouseHandler
	 *
	 * @property {MouseEvent} event - [description]
	 */
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class MouseManager
	 * @memberOf Phaser.Input.Mouse
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Input.InputManager} inputManager - [description]
	 */
	var MouseManager = new Class({
	
	    initialize:
	
	    function MouseManager (inputManager)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Mouse.MouseManager#manager
	         * @type {Phaser.Input.InputManager}
	         * @since 3.0.0
	         */
	        this.manager = inputManager;
	
	        /**
	         * If true the DOM mouse events will have event.preventDefault applied to them, if false they will propagate fully.
	         *
	         * @name Phaser.Input.Mouse.MouseManager#capture
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.capture = true;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Mouse.MouseManager#enabled
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.enabled = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Mouse.MouseManager#target
	         * @type {null}
	         * @since 3.0.0
	         */
	        this.target;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Mouse.MouseManager#handler
	         * @type {?MouseHandler}
	         * @since 3.0.0
	         */
	        this.handler;
	
	        /**
	         * If the mouse has been pointer locked successfully this will be set to true.
	         *
	         * @name Phaser.Input.Mouse.MouseManager#locked
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.locked = false;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Mouse.MouseManager#boot
	     * @since 3.0.0
	     */
	    boot: function ()
	    {
	        var config = this.manager.config;
	
	        this.enabled = config.inputMouse;
	        this.target = config.inputMouseEventTarget;
	        this.capture = config.inputMouseCapture;
	
	        if (!this.target)
	        {
	            this.target = this.manager.game.canvas;
	        }
	
	        if (config.disableContextMenu)
	        {
	            this.disableContextMenu();
	        }
	
	        if (this.enabled)
	        {
	            this.startListeners();
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Mouse.MouseManager#disableContextMenu
	     * @since 3.0.0
	     *
	     * @return {Phaser.Input.Mouse.MouseManager} [description]
	     */
	    disableContextMenu: function ()
	    {
	        document.body.addEventListener('contextmenu', function (event)
	        {
	            event.preventDefault();
	            return false;
	        });
	
	        return this;
	    },
	
	    /**
	     * If the browser supports it, you can request that the pointer be locked to the browser window.
	     *
	     * This is classically known as 'FPS controls', where the pointer can't leave the browser until
	     * the user presses an exit key.
	     *
	     * If the browser successfully enters a locked state, a `POINTER_LOCK_CHANGE_EVENT` will be dispatched,
	     * from the games Input Manager, with an `isPointerLocked` property.
	     *
	     * It is important to note that pointer lock can only be enabled after an 'engagement gesture',
	     * see: https://w3c.github.io/pointerlock/#dfn-engagement-gesture.
	     *
	     * @method Phaser.Input.Mouse.MouseManager#requestPointerLock
	     * @since 3.0.0
	     */
	    requestPointerLock: function ()
	    {
	        if (Features.pointerLock)
	        {
	            var element = this.target;
	            element.requestPointerLock = element.requestPointerLock || element.mozRequestPointerLock || element.webkitRequestPointerLock;
	            element.requestPointerLock();
	        }
	    },
	
	    /**
	     * Internal pointerLockChange handler.
	     *
	     * @method Phaser.Input.Mouse.MouseManager#pointerLockChange
	     * @since 3.0.0
	     *
	     * @param {MouseHandler} event - The native event from the browser.
	     */
	    pointerLockChange: function (event)
	    {
	        var element = this.target;
	
	        this.locked = (document.pointerLockElement === element || document.mozPointerLockElement === element || document.webkitPointerLockElement === element) ? true : false;
	
	        this.manager.queue.push(event);
	    },
	
	    /**
	     * If the browser supports pointer lock, this will request that the pointer lock is released. If
	     * the browser successfully enters a locked state, a 'POINTER_LOCK_CHANGE_EVENT' will be
	     * dispatched - from the game's input manager - with an `isPointerLocked` property.
	     *
	     * @method Phaser.Input.Mouse.MouseManager#releasePointerLock
	     * @since 3.0.0
	     */
	    releasePointerLock: function ()
	    {
	        if (Features.pointerLock)
	        {
	            document.exitPointerLock = document.exitPointerLock || document.mozExitPointerLock || document.webkitExitPointerLock;
	            document.exitPointerLock();
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Mouse.MouseManager#startListeners
	     * @since 3.0.0
	     */
	    startListeners: function ()
	    {
	        var queue = this.manager.queue;
	        var target = this.target;
	
	        var passive = { passive: true };
	        var nonPassive = { passive: false };
	
	        var handler;
	
	        if (this.capture)
	        {
	            handler = function (event)
	            {
	                if (event.defaultPrevented)
	                {
	                    // Do nothing if event already handled
	                    return;
	                }
	
	                // console.log('mouse', event);
	
	                queue.push(event);
	
	                event.preventDefault();
	            };
	
	            target.addEventListener('mousemove', handler, nonPassive);
	            target.addEventListener('mousedown', handler, nonPassive);
	            target.addEventListener('mouseup', handler, nonPassive);
	        }
	        else
	        {
	            handler = function (event)
	            {
	                if (event.defaultPrevented)
	                {
	                    // Do nothing if event already handled
	                    return;
	                }
	
	                queue.push(event);
	            };
	
	            target.addEventListener('mousemove', handler, passive);
	            target.addEventListener('mousedown', handler, passive);
	            target.addEventListener('mouseup', handler, passive);
	        }
	
	        this.handler = handler;
	
	        if (Features.pointerLock)
	        {
	            this.pointerLockChange = this.pointerLockChange.bind(this);
	
	            document.addEventListener('pointerlockchange', this.pointerLockChange, true);
	            document.addEventListener('mozpointerlockchange', this.pointerLockChange, true);
	            document.addEventListener('webkitpointerlockchange', this.pointerLockChange, true);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Mouse.MouseManager#stopListeners
	     * @since 3.0.0
	     */
	    stopListeners: function ()
	    {
	        var target = this.target;
	
	        target.removeEventListener('mousemove', this.handler);
	        target.removeEventListener('mousedown', this.handler);
	        target.removeEventListener('mouseup', this.handler);
	
	        if (Features.pointerLock)
	        {
	            document.removeEventListener('pointerlockchange', this.pointerLockChange, true);
	            document.removeEventListener('mozpointerlockchange', this.pointerLockChange, true);
	            document.removeEventListener('webkitpointerlockchange', this.pointerLockChange, true);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Mouse.MouseManager#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.stopListeners();
	
	        this.manager = null;
	    }
	
	});
	
	module.exports = MouseManager;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	
	// https://developer.mozilla.org/en-US/docs/Web/API/Touch_events
	// https://patrickhlauke.github.io/touch/tests/results/
	// https://www.html5rocks.com/en/mobile/touch/
	
	/**
	 * @callback TouchHandler
	 *
	 * @param {TouchEvent} event - [description]
	 */
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class TouchManager
	 * @memberOf Phaser.Input.Touch
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Input.InputManager} inputManager - [description]
	 */
	var TouchManager = new Class({
	
	    initialize:
	
	    function TouchManager (inputManager)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Touch.TouchManager#manager
	         * @type {Phaser.Input.InputManager}
	         * @since 3.0.0
	         */
	        this.manager = inputManager;
	
	        /**
	         * If true the DOM events will have event.preventDefault applied to them, if false they will propagate fully.
	         *
	         * @name Phaser.Input.Touch.TouchManager#capture
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.capture = true;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Touch.TouchManager#enabled
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.enabled = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Touch.TouchManager#target
	         * @type {null}
	         * @since 3.0.0
	         */
	        this.target;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.Touch.TouchManager#handler
	         * @type {?TouchHandler}
	         * @since 3.0.0
	         */
	        this.handler;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Touch.TouchManager#boot
	     * @since 3.0.0
	     */
	    boot: function ()
	    {
	        var config = this.manager.config;
	
	        this.enabled = config.inputTouch;
	        this.target = config.inputTouchEventTarget;
	        this.capture = config.inputTouchCapture;
	
	        if (!this.target)
	        {
	            this.target = this.manager.game.canvas;
	        }
	
	        if (this.enabled)
	        {
	            this.startListeners();
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Touch.TouchManager#startListeners
	     * @since 3.0.0
	     */
	    startListeners: function ()
	    {
	        var queue = this.manager.queue;
	        var target = this.target;
	
	        var passive = { passive: true };
	        var nonPassive = { passive: false };
	
	        var handler;
	
	        if (this.capture)
	        {
	            handler = function (event)
	            {
	                if (event.defaultPrevented)
	                {
	                    // Do nothing if event already handled
	                    return;
	                }
	
	                // console.log('touch', event);
	
	                queue.push(event);
	
	                event.preventDefault();
	            };
	
	            target.addEventListener('touchstart', handler, nonPassive);
	            target.addEventListener('touchmove', handler, nonPassive);
	            target.addEventListener('touchend', handler, nonPassive);
	        }
	        else
	        {
	            handler = function (event)
	            {
	                if (event.defaultPrevented)
	                {
	                    // Do nothing if event already handled
	                    return;
	                }
	
	                queue.push(event);
	            };
	
	            target.addEventListener('touchstart', handler, passive);
	            target.addEventListener('touchmove', handler, passive);
	            target.addEventListener('touchend', handler, passive);
	        }
	
	        this.handler = handler;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Touch.TouchManager#stopListeners
	     * @since 3.0.0
	     */
	    stopListeners: function ()
	    {
	        var target = this.target;
	
	        target.removeEventListener('touchstart', this.handler);
	        target.removeEventListener('touchmove', this.handler);
	        target.removeEventListener('touchend', this.handler);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.Touch.TouchManager#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.stopListeners();
	
	        this.manager = null;
	    }
	
	});
	
	module.exports = TouchManager;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var MergeXHRSettings = __webpack_require__(303);
	
	/**
	 * Creates a new XMLHttpRequest (xhr) object based on the given File and XHRSettings
	 * and starts the download of it. It uses the Files own XHRSettings and merges them
	 * with the global XHRSettings object to set the xhr values before download.
	 *
	 * @function Phaser.Loader.XHRLoader
	 * @since 3.0.0
	 *
	 * @param {Phaser.Loader.File} file - The File to download.
	 * @param {XHRSettingsObject} globalXHRSettings - The global XHRSettings object.
	 *
	 * @return {XMLHttpRequest} The XHR object.
	 */
	var XHRLoader = function (file, globalXHRSettings)
	{
	    var config = MergeXHRSettings(globalXHRSettings, file.xhrSettings);
	
	    var xhr = new XMLHttpRequest();
	
	    xhr.open('GET', file.src, config.async, config.user, config.password);
	
	    xhr.responseType = file.xhrSettings.responseType;
	    xhr.timeout = config.timeout;
	
	    if (config.header && config.headerValue)
	    {
	        xhr.setRequestHeader(config.header, config.headerValue);
	    }
	
	    if (config.requestedWith)
	    {
	        xhr.setRequestHeader('X-Requested-With', config.requestedWith);
	    }
	
	    if (config.overrideMimeType)
	    {
	        xhr.overrideMimeType(config.overrideMimeType);
	    }
	
	    // After a successful request, the xhr.response property will contain the requested data as a DOMString, ArrayBuffer, Blob, or Document (depending on what was set for responseType.)
	
	    xhr.onload = file.onLoad.bind(file, xhr);
	    xhr.onerror = file.onError.bind(file);
	    xhr.onprogress = file.onProgress.bind(file);
	
	    //  This is the only standard method, the ones above are browser additions (maybe not universal?)
	    // xhr.onreadystatechange
	
	    xhr.send();
	
	    return xhr;
	};
	
	module.exports = XHRLoader;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(49);
	var File = __webpack_require__(44);
	var FileTypesManager = __webpack_require__(15);
	var GetFastValue = __webpack_require__(3);
	var HTML5AudioFile = __webpack_require__(546);
	var IsPlainObject = __webpack_require__(17);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.AudioFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within the Loader and Audio Cache.
	 * @property {string} [urlConfig] - The absolute or relative URL to load the file from.
	 * @property {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 * @property {AudioContext} [audioContext] - The AudioContext this file will use to process itself.
	 */
	
	/**
	 * @classdesc
	 * A single Audio File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#audio method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#audio.
	 *
	 * @class AudioFile
	 * @extends Phaser.Loader.File
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.AudioFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {any} [urlConfig] - The absolute or relative URL to load this file from in a config object.
	 * @param {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 * @param {AudioContext} [audioContext] - The AudioContext this file will use to process itself.
	 */
	var AudioFile = new Class({
	
	    Extends: File,
	
	    initialize:
	
	    //  URL is an object created by AudioFile.findAudioURL
	    function AudioFile (loader, key, urlConfig, xhrSettings, audioContext)
	    {
	        if (IsPlainObject(key))
	        {
	            var config = key;
	
	            key = GetFastValue(config, 'key');
	            xhrSettings = GetFastValue(config, 'xhrSettings');
	            audioContext = GetFastValue(config, 'context', audioContext);
	        }
	
	        var fileConfig = {
	            type: 'audio',
	            cache: loader.cacheManager.audio,
	            extension: urlConfig.type,
	            responseType: 'arraybuffer',
	            key: key,
	            url: urlConfig.url,
	            xhrSettings: xhrSettings,
	            config: { context: audioContext }
	        };
	
	        File.call(this, loader, fileConfig);
	    },
	
	    /**
	     * Called automatically by Loader.nextFile.
	     * This method controls what extra work this File does with its loaded data.
	     *
	     * @method Phaser.Loader.FileTypes.AudioFile#onProcess
	     * @since 3.0.0
	     */
	    onProcess: function ()
	    {
	        this.state = CONST.FILE_PROCESSING;
	
	        var _this = this;
	
	        // interesting read https://github.com/WebAudio/web-audio-api/issues/1305
	        this.config.context.decodeAudioData(this.xhrLoader.response,
	            function (audioBuffer)
	            {
	                _this.data = audioBuffer;
	
	                _this.onProcessComplete();
	            },
	            function (e)
	            {
	                // eslint-disable-next-line no-console
	                console.error('Error decoding audio: ' + this.key + ' - ', e.message);
	
	                _this.onProcessError();
	            }
	        );
	
	        this.config.context = null;
	    }
	
	});
	
	AudioFile.create = function (loader, key, urls, config, xhrSettings)
	{
	    var game = loader.systems.game;
	    var audioConfig = game.config.audio;
	    var deviceAudio = game.device.audio;
	
	    //  url may be inside key, which may be an object
	    if (IsPlainObject(key))
	    {
	        urls = GetFastValue(key, 'url', []);
	        config = GetFastValue(key, 'config', {});
	    }
	
	    var urlConfig = AudioFile.getAudioURL(game, urls);
	
	    if (!urlConfig)
	    {
	        return null;
	    }
	
	    // https://developers.google.com/web/updates/2012/02/HTML5-audio-and-the-Web-Audio-API-are-BFFs
	    // var stream = GetFastValue(config, 'stream', false);
	
	    if (deviceAudio.webAudio && !(audioConfig && audioConfig.disableWebAudio))
	    {
	        return new AudioFile(loader, key, urlConfig, xhrSettings, game.sound.context);
	    }
	    else
	    {
	        return new HTML5AudioFile(loader, key, urlConfig, config);
	    }
	};
	
	AudioFile.getAudioURL = function (game, urls)
	{
	    if (!Array.isArray(urls))
	    {
	        urls = [ urls ];
	    }
	
	    for (var i = 0; i < urls.length; i++)
	    {
	        var url = GetFastValue(urls[i], 'url', urls[i]);
	
	        if (url.indexOf('blob:') === 0 || url.indexOf('data:') === 0)
	        {
	            return url;
	        }
	
	        var audioType = url.match(/\.([a-zA-Z0-9]+)($|\?)/);
	
	        audioType = GetFastValue(urls[i], 'type', (audioType) ? audioType[1] : '').toLowerCase();
	
	        if (game.device.audio[audioType])
	        {
	            return {
	                url: url,
	                type: audioType
	            };
	        }
	    }
	
	    return null;
	};
	
	/**
	 * Adds an Audio or HTML5Audio file, or array of audio files, to the current load queue.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.audio('title', [ 'music/Title.ogg', 'music/Title.mp3', 'music/Title.m4a' ]);
	 * }
	 * ```
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 * 
	 * The key must be a unique String. It is used to add the file to the global Audio Cache upon a successful load.
	 * The key should be unique both in terms of files being loaded and files already present in the Audio Cache.
	 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
	 * then remove it from the Audio Cache first, before loading a new one.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.audio({
	 *     key: 'title',
	 *     url: [ 'music/Title.ogg', 'music/Title.mp3', 'music/Title.m4a' ]
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.AudioFileConfig` for more details.
	 *
	 * The URLs can be relative or absolute. If the URLs are relative the `Loader.baseURL` and `Loader.path` values will be prepended to them.
	 *
	 * Due to different browsers supporting different audio file types you should usually provide your audio files in a variety of formats.
	 * ogg, mp3 and m4a are the most common. If you provide an array of URLs then the Loader will determine which _one_ file to load based on
	 * browser support.
	 *
	 * If audio has been disabled in your game, either via the game config, or lack of support from the device, then no audio will be loaded.
	 *
	 * Note: The ability to load this type of file will only be available if the Audio File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#audio
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.0.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.AudioFileConfig|Phaser.Loader.FileTypes.AudioFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {(string|string[])} [urls] - The absolute or relative URL to load the audio files from.
	 * @param {any} [config] - An object containing an `instances` property for HTML5Audio. Defaults to 1.
	 * @param {XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('audio', function (key, urls, config, xhrSettings)
	{
	    var game = this.systems.game;
	    var audioConfig = game.config.audio;
	    var deviceAudio = game.device.audio;
	
	    if ((audioConfig && audioConfig.noAudio) || (!deviceAudio.webAudio && !deviceAudio.audioData))
	    {
	        //  Sounds are disabled, so skip loading audio
	        return this;
	    }
	
	    var audioFile;
	
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
	            audioFile = AudioFile.create(this, key[i]);
	
	            if (audioFile)
	            {
	                this.addFile(audioFile);
	            }
	        }
	    }
	    else
	    {
	        audioFile = AudioFile.create(this, key, urls, config, xhrSettings);
	
	        if (audioFile)
	        {
	            this.addFile(audioFile);
	        }
	    }
	
	    return this;
	});
	
	module.exports = AudioFile;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var File = __webpack_require__(44);
	var GetFastValue = __webpack_require__(3);
	var GetURL = __webpack_require__(302);
	var IsPlainObject = __webpack_require__(17);
	
	/**
	 * @classdesc
	 * A single Audio File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#audio method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#audio.
	 *
	 * @class HTML5AudioFile
	 * @extends Phaser.Loader.File
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.AudioFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string} [urlConfig] - The absolute or relative URL to load this file from.
	 * @param {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	var HTML5AudioFile = new Class({
	
	    Extends: File,
	
	    initialize:
	
	    function HTML5AudioFile (loader, key, urlConfig, audioConfig)
	    {
	        if (IsPlainObject(key))
	        {
	            var config = key;
	
	            key = GetFastValue(config, 'key');
	            audioConfig = GetFastValue(config, 'config', audioConfig);
	        }
	
	        var fileConfig = {
	            type: 'audio',
	            cache: loader.cacheManager.audio,
	            extension: urlConfig.type,
	            key: key,
	            url: urlConfig.url,
	            config: audioConfig
	        };
	
	        File.call(this, loader, fileConfig);
	
	        //  New properties specific to this class
	        this.locked = 'ontouchstart' in window;
	        this.loaded = false;
	        this.filesLoaded = 0;
	        this.filesTotal = 0;
	    },
	
	    /**
	     * Called when the file finishes loading.
	     *
	     * @method Phaser.Loader.FileTypes.HTML5AudioFile#onLoad
	     * @since 3.0.0
	     */
	    onLoad: function ()
	    {
	        if (this.loaded)
	        {
	            return;
	        }
	
	        this.loaded = true;
	
	        this.loader.nextFile(this, true);
	    },
	
	    /**
	     * Called if the file errors while loading.
	     *
	     * @method Phaser.Loader.FileTypes.HTML5AudioFile#onError
	     * @since 3.0.0
	     */
	    onError: function ()
	    {
	        for (var i = 0; i < this.data.length; i++)
	        {
	            var audio = this.data[i];
	
	            audio.oncanplaythrough = null;
	            audio.onerror = null;
	        }
	
	        this.loader.nextFile(this, false);
	    },
	
	    /**
	     * Called during the file load progress. Is sent a DOM ProgressEvent.
	     *
	     * @method Phaser.Loader.FileTypes.HTML5AudioFile#onProgress
	     * @since 3.0.0
	     */
	    onProgress: function (event)
	    {
	        var audio = event.target;
	
	        audio.oncanplaythrough = null;
	        audio.onerror = null;
	
	        this.filesLoaded++;
	
	        this.percentComplete = Math.min((this.filesLoaded / this.filesTotal), 1);
	
	        this.loader.emit('fileprogress', this, this.percentComplete);
	
	        if (this.filesLoaded === this.filesTotal)
	        {
	            this.onLoad();
	        }
	    },
	
	    /**
	     * Called by the Loader, starts the actual file downloading.
	     * During the load the methods onLoad, onError and onProgress are called, based on the XHR events.
	     * You shouldn't normally call this method directly, it's meant to be invoked by the Loader.
	     *
	     * @method Phaser.Loader.FileTypes.HTML5AudioFile#load
	     * @since 3.0.0
	     */
	    load: function ()
	    {
	        this.data = [];
	
	        var instances = (this.config && this.config.instances) || 1;
	
	        this.filesTotal = instances;
	        this.filesLoaded = 0;
	        this.percentComplete = 0;
	
	        for (var i = 0; i < instances; i++)
	        {
	            var audio = new Audio();
	
	            audio.dataset.name = this.key + ('0' + i).slice(-2);
	            audio.dataset.used = 'false';
	
	            if (this.locked)
	            {
	                audio.dataset.locked = 'true';
	            }
	            else
	            {
	                audio.dataset.locked = 'false';
	
	                audio.preload = 'auto';
	                audio.oncanplaythrough = this.onProgress.bind(this);
	                audio.onerror = this.onError.bind(this);
	            }
	
	            this.data.push(audio);
	        }
	
	        for (i = 0; i < this.data.length; i++)
	        {
	            audio = this.data[i];
	            audio.src = GetURL(this, this.loader.baseURL);
	
	            if (!this.locked)
	            {
	                audio.load();
	            }
	        }
	
	        if (this.locked)
	        {
	            //  This is super-dangerous but works. Race condition potential high.
	            //  Is there another way?
	            setTimeout(this.onLoad.bind(this));
	        }
	    }
	
	});
	
	module.exports = HTML5AudioFile;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(35);
	var File = __webpack_require__(44);
	var FileTypesManager = __webpack_require__(15);
	var GetFastValue = __webpack_require__(3);
	var IsPlainObject = __webpack_require__(17);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.TextFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within both the Loader and the Text Cache.
	 * @property {string} [url] - The absolute or relative URL to load the file from.
	 * @property {string} [extension='txt'] - The default file extension to use if no url is provided.
	 * @property {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	
	/**
	 * @classdesc
	 * A single Text File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#text method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#text.
	 *
	 * @class TextFile
	 * @extends Phaser.Loader.File
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.TextFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.txt`, i.e. if `key` was "alien" then the URL will be "alien.txt".
	 * @param {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	var TextFile = new Class({
	
	    Extends: File,
	
	    initialize:
	
	    function TextFile (loader, key, url, xhrSettings)
	    {
	        var extension = 'txt';
	
	        if (IsPlainObject(key))
	        {
	            var config = key;
	
	            key = GetFastValue(config, 'key');
	            url = GetFastValue(config, 'url');
	            xhrSettings = GetFastValue(config, 'xhrSettings');
	            extension = GetFastValue(config, 'extension', extension);
	        }
	
	        var fileConfig = {
	            type: 'text',
	            cache: loader.cacheManager.text,
	            extension: extension,
	            responseType: 'text',
	            key: key,
	            url: url,
	            xhrSettings: xhrSettings
	        };
	
	        File.call(this, loader, fileConfig);
	    },
	
	    /**
	     * Called automatically by Loader.nextFile.
	     * This method controls what extra work this File does with its loaded data.
	     *
	     * @method Phaser.Loader.FileTypes.TextFile#onProcess
	     * @since 3.7.0
	     */
	    onProcess: function ()
	    {
	        this.state = CONST.FILE_PROCESSING;
	
	        this.data = this.xhrLoader.responseText;
	
	        this.onProcessComplete();
	    }
	
	});
	
	/**
	 * Adds a Text file, or array of Text files, to the current load queue.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.text('story', files/IntroStory.txt');
	 * }
	 * ```
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 * 
	 * The key must be a unique String. It is used to add the file to the global Text Cache upon a successful load.
	 * The key should be unique both in terms of files being loaded and files already present in the Text Cache.
	 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
	 * then remove it from the Text Cache first, before loading a new one.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.text({
	 *     key: 'story',
	 *     url: 'files/IntroStory.txt'
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.TextFileConfig` for more details.
	 *
	 * Once the file has finished loading you can access it from its Cache using its key:
	 * 
	 * ```javascript
	 * this.load.image('story', 'files/IntroStory.txt');
	 * // and later in your game ...
	 * var data = this.cache.text.get('story');
	 * ```
	 *
	 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
	 * key. For example, if the prefix was `LEVEL1.` and the key was `Story` the final key will be `LEVEL1.Story` and
	 * this is what you would use to retrieve the text from the Text Cache.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "story"
	 * and no URL is given then the Loader will set the URL to be "story.txt". It will always add `.txt` as the extension, although
	 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
	 *
	 * Note: The ability to load this type of file will only be available if the Text File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#text
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.0.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.TextFileConfig|Phaser.Loader.FileTypes.TextFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.txt`, i.e. if `key` was "alien" then the URL will be "alien.txt".
	 * @param {XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('text', function (key, url, xhrSettings)
	{
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
	            this.addFile(new TextFile(this, key[i]));
	        }
	    }
	    else
	    {
	        this.addFile(new TextFile(this, key, url, xhrSettings));
	    }
	
	    return this;
	});
	
	module.exports = TextFile;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Factorial = __webpack_require__(550);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Bernstein
	 * @since 3.0.0
	 *
	 * @param {number} n - [description]
	 * @param {number} i - [description]
	 *
	 * @return {number} [description]
	 */
	var Bernstein = function (n, i)
	{
	    return Factorial(n) / Factorial(i) / Factorial(n - i);
	};
	
	module.exports = Bernstein;


/***/ }),
/* 549 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Between
	 * @since 3.0.0
	 *
	 * @param {integer} min - [description]
	 * @param {integer} max - [description]
	 *
	 * @return {integer} [description]
	 */
	var Between = function (min, max)
	{
	    return Math.floor(Math.random() * (max - min + 1) + min);
	};
	
	module.exports = Between;


/***/ }),
/* 550 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Calculates the factorial of a given number for integer values greater than 0.
	 *
	 * @function Phaser.Math.Factorial
	 * @since 3.0.0
	 *
	 * @param {number} value - A positive integer to calculate the factorial of.
	 *
	 * @return {number} The factorial of the given number.
	 */
	var Factorial = function (value)
	{
	    if (value === 0)
	    {
	        return 1;
	    }
	
	    var res = value;
	
	    while (--value)
	    {
	        res *= value;
	    }
	
	    return res;
	};
	
	module.exports = Factorial;


/***/ }),
/* 551 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Generate a random floating point number between the two given bounds, minimum inclusive, maximum exclusive.
	 *
	 * @function Phaser.Math.FloatBetween
	 * @since 3.0.0
	 *
	 * @param {float} min - The lower bound for the float, inclusive.
	 * @param {float} max - The upper bound for the float exclusive.
	 *
	 * @return {float} A random float within the given range.
	 */
	var FloatBetween = function (min, max)
	{
	    return Math.random() * (max - min) + min;
	};
	
	module.exports = FloatBetween;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
	//  and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
	
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class Matrix3
	 * @memberOf Phaser.Math
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Math.Matrix3} [m] - [description]
	 */
	
	var Matrix3 = new Class({
	
	    initialize:
	
	    function Matrix3 (m)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Math.Matrix3#val
	         * @type {Float32Array}
	         * @since 3.0.0
	         */
	        this.val = new Float32Array(9);
	
	        if (m)
	        {
	            //  Assume Matrix3 with val:
	            this.copy(m);
	        }
	        else
	        {
	            //  Default to identity
	            this.identity();
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix3#clone
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Matrix3} A new Matrix3 object.
	     */
	    clone: function ()
	    {
	        return new Matrix3(this);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix3#set
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Matrix3} src - [description]
	     *
	     * @return {Phaser.Math.Matrix3} This Matrix3 object.
	     */
	    set: function (src)
	    {
	        return this.copy(src);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix3#copy
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Matrix3} src - [description]
	     *
	     * @return {Phaser.Math.Matrix3} This Matrix3 object.
	     */
	    copy: function (src)
	    {
	        var out = this.val;
	        var a = src.val;
	
	        out[0] = a[0];
	        out[1] = a[1];
	        out[2] = a[2];
	        out[3] = a[3];
	        out[4] = a[4];
	        out[5] = a[5];
	        out[6] = a[6];
	        out[7] = a[7];
	        out[8] = a[8];
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix3#fromMat4
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Matrix4} m - [description]
	     *
	     * @return {Phaser.Math.Matrix3} This Matrix3 object.
	     */
	    fromMat4: function (m)
	    {
	        var a = m.val;
	        var out = this.val;
	
	        out[0] = a[0];
	        out[1] = a[1];
	        out[2] = a[2];
	        out[3] = a[4];
	        out[4] = a[5];
	        out[5] = a[6];
	        out[6] = a[8];
	        out[7] = a[9];
	        out[8] = a[10];
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix3#fromArray
	     * @since 3.0.0
	     *
	     * @param {array} a - [description]
	     *
	     * @return {Phaser.Math.Matrix3} This Matrix3 object.
	     */
	    fromArray: function (a)
	    {
	        var out = this.val;
	
	        out[0] = a[0];
	        out[1] = a[1];
	        out[2] = a[2];
	        out[3] = a[3];
	        out[4] = a[4];
	        out[5] = a[5];
	        out[6] = a[6];
	        out[7] = a[7];
	        out[8] = a[8];
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix3#identity
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Matrix3} This Matrix3 object.
	     */
	    identity: function ()
	    {
	        var out = this.val;
	
	        out[0] = 1;
	        out[1] = 0;
	        out[2] = 0;
	        out[3] = 0;
	        out[4] = 1;
	        out[5] = 0;
	        out[6] = 0;
	        out[7] = 0;
	        out[8] = 1;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix3#transpose
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Matrix3} This Matrix3 object.
	     */
	    transpose: function ()
	    {
	        var a = this.val;
	        var a01 = a[1];
	        var a02 = a[2];
	        var a12 = a[5];
	
	        a[1] = a[3];
	        a[2] = a[6];
	        a[3] = a01;
	        a[5] = a[7];
	        a[6] = a02;
	        a[7] = a12;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix3#invert
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Matrix3} This Matrix3 object.
	     */
	    invert: function ()
	    {
	        var a = this.val;
	
	        var a00 = a[0];
	        var a01 = a[1];
	        var a02 = a[2];
	        var a10 = a[3];
	        var a11 = a[4];
	        var a12 = a[5];
	        var a20 = a[6];
	        var a21 = a[7];
	        var a22 = a[8];
	
	        var b01 = a22 * a11 - a12 * a21;
	        var b11 = -a22 * a10 + a12 * a20;
	        var b21 = a21 * a10 - a11 * a20;
	
	        // Calculate the determinant
	        var det = a00 * b01 + a01 * b11 + a02 * b21;
	
	        if (!det)
	        {
	            return null;
	        }
	
	        det = 1 / det;
	
	        a[0] = b01 * det;
	        a[1] = (-a22 * a01 + a02 * a21) * det;
	        a[2] = (a12 * a01 - a02 * a11) * det;
	        a[3] = b11 * det;
	        a[4] = (a22 * a00 - a02 * a20) * det;
	        a[5] = (-a12 * a00 + a02 * a10) * det;
	        a[6] = b21 * det;
	        a[7] = (-a21 * a00 + a01 * a20) * det;
	        a[8] = (a11 * a00 - a01 * a10) * det;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix3#adjoint
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Matrix3} This Matrix3 object.
	     */
	    adjoint: function ()
	    {
	        var a = this.val;
	
	        var a00 = a[0];
	        var a01 = a[1];
	        var a02 = a[2];
	        var a10 = a[3];
	        var a11 = a[4];
	        var a12 = a[5];
	        var a20 = a[6];
	        var a21 = a[7];
	        var a22 = a[8];
	
	        a[0] = (a11 * a22 - a12 * a21);
	        a[1] = (a02 * a21 - a01 * a22);
	        a[2] = (a01 * a12 - a02 * a11);
	        a[3] = (a12 * a20 - a10 * a22);
	        a[4] = (a00 * a22 - a02 * a20);
	        a[5] = (a02 * a10 - a00 * a12);
	        a[6] = (a10 * a21 - a11 * a20);
	        a[7] = (a01 * a20 - a00 * a21);
	        a[8] = (a00 * a11 - a01 * a10);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix3#determinant
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    determinant: function ()
	    {
	        var a = this.val;
	
	        var a00 = a[0];
	        var a01 = a[1];
	        var a02 = a[2];
	        var a10 = a[3];
	        var a11 = a[4];
	        var a12 = a[5];
	        var a20 = a[6];
	        var a21 = a[7];
	        var a22 = a[8];
	
	        return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix3#multiply
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Matrix3} src - [description]
	     *
	     * @return {Phaser.Math.Matrix3} This Matrix3 object.
	     */
	    multiply: function (src)
	    {
	        var a = this.val;
	
	        var a00 = a[0];
	        var a01 = a[1];
	        var a02 = a[2];
	        var a10 = a[3];
	        var a11 = a[4];
	        var a12 = a[5];
	        var a20 = a[6];
	        var a21 = a[7];
	        var a22 = a[8];
	
	        var b = src.val;
	
	        var b00 = b[0];
	        var b01 = b[1];
	        var b02 = b[2];
	        var b10 = b[3];
	        var b11 = b[4];
	        var b12 = b[5];
	        var b20 = b[6];
	        var b21 = b[7];
	        var b22 = b[8];
	
	        a[0] = b00 * a00 + b01 * a10 + b02 * a20;
	        a[1] = b00 * a01 + b01 * a11 + b02 * a21;
	        a[2] = b00 * a02 + b01 * a12 + b02 * a22;
	
	        a[3] = b10 * a00 + b11 * a10 + b12 * a20;
	        a[4] = b10 * a01 + b11 * a11 + b12 * a21;
	        a[5] = b10 * a02 + b11 * a12 + b12 * a22;
	
	        a[6] = b20 * a00 + b21 * a10 + b22 * a20;
	        a[7] = b20 * a01 + b21 * a11 + b22 * a21;
	        a[8] = b20 * a02 + b21 * a12 + b22 * a22;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix3#translate
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - [description]
	     *
	     * @return {Phaser.Math.Matrix3} This Matrix3 object.
	     */
	    translate: function (v)
	    {
	        var a = this.val;
	        var x = v.x;
	        var y = v.y;
	
	        a[6] = x * a[0] + y * a[3] + a[6];
	        a[7] = x * a[1] + y * a[4] + a[7];
	        a[8] = x * a[2] + y * a[5] + a[8];
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix3#rotate
	     * @since 3.0.0
	     *
	     * @param {number} rad - [description]
	     *
	     * @return {Phaser.Math.Matrix3} This Matrix3 object.
	     */
	    rotate: function (rad)
	    {
	        var a = this.val;
	
	        var a00 = a[0];
	        var a01 = a[1];
	        var a02 = a[2];
	        var a10 = a[3];
	        var a11 = a[4];
	        var a12 = a[5];
	
	        var s = Math.sin(rad);
	        var c = Math.cos(rad);
	
	        a[0] = c * a00 + s * a10;
	        a[1] = c * a01 + s * a11;
	        a[2] = c * a02 + s * a12;
	
	        a[3] = c * a10 - s * a00;
	        a[4] = c * a11 - s * a01;
	        a[5] = c * a12 - s * a02;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix3#scale
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Vector2|Phaser.Math.Vector3|Phaser.Math.Vector4)} v - [description]
	     *
	     * @return {Phaser.Math.Matrix3} This Matrix3 object.
	     */
	    scale: function (v)
	    {
	        var a = this.val;
	        var x = v.x;
	        var y = v.y;
	
	        a[0] = x * a[0];
	        a[1] = x * a[1];
	        a[2] = x * a[2];
	
	        a[3] = y * a[3];
	        a[4] = y * a[4];
	        a[5] = y * a[5];
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix3#fromQuat
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Quaternion} q - [description]
	     *
	     * @return {Phaser.Math.Matrix3} This Matrix3 object.
	     */
	    fromQuat: function (q)
	    {
	        var x = q.x;
	        var y = q.y;
	        var z = q.z;
	        var w = q.w;
	
	        var x2 = x + x;
	        var y2 = y + y;
	        var z2 = z + z;
	
	        var xx = x * x2;
	        var xy = x * y2;
	        var xz = x * z2;
	
	        var yy = y * y2;
	        var yz = y * z2;
	        var zz = z * z2;
	
	        var wx = w * x2;
	        var wy = w * y2;
	        var wz = w * z2;
	
	        var out = this.val;
	
	        out[0] = 1 - (yy + zz);
	        out[3] = xy + wz;
	        out[6] = xz - wy;
	
	        out[1] = xy - wz;
	        out[4] = 1 - (xx + zz);
	        out[7] = yz + wx;
	
	        out[2] = xz + wy;
	        out[5] = yz - wx;
	        out[8] = 1 - (xx + yy);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Matrix3#normalFromMat4
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Matrix4} m - [description]
	     *
	     * @return {Phaser.Math.Matrix3} This Matrix3 object.
	     */
	    normalFromMat4: function (m)
	    {
	        var a = m.val;
	        var out = this.val;
	
	        var a00 = a[0];
	        var a01 = a[1];
	        var a02 = a[2];
	        var a03 = a[3];
	
	        var a10 = a[4];
	        var a11 = a[5];
	        var a12 = a[6];
	        var a13 = a[7];
	
	        var a20 = a[8];
	        var a21 = a[9];
	        var a22 = a[10];
	        var a23 = a[11];
	
	        var a30 = a[12];
	        var a31 = a[13];
	        var a32 = a[14];
	        var a33 = a[15];
	
	        var b00 = a00 * a11 - a01 * a10;
	        var b01 = a00 * a12 - a02 * a10;
	        var b02 = a00 * a13 - a03 * a10;
	        var b03 = a01 * a12 - a02 * a11;
	
	        var b04 = a01 * a13 - a03 * a11;
	        var b05 = a02 * a13 - a03 * a12;
	        var b06 = a20 * a31 - a21 * a30;
	        var b07 = a20 * a32 - a22 * a30;
	
	        var b08 = a20 * a33 - a23 * a30;
	        var b09 = a21 * a32 - a22 * a31;
	        var b10 = a21 * a33 - a23 * a31;
	        var b11 = a22 * a33 - a23 * a32;
	
	        // Calculate the determinant
	        var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
	
	        if (!det)
	        {
	            return null;
	        }
	
	        det = 1 / det;
	
	        out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
	        out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
	        out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
	
	        out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
	        out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
	        out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
	
	        out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
	        out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
	        out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
	
	        return this;
	    }
	
	});
	
	module.exports = Matrix3;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  Adapted from [gl-matrix](https://github.com/toji/gl-matrix) by toji
	//  and [vecmath](https://github.com/mattdesl/vecmath) by mattdesl
	
	var Class = __webpack_require__(1);
	var Vector3 = __webpack_require__(142);
	var Matrix3 = __webpack_require__(552);
	
	var EPSILON = 0.000001;
	
	//  Some shared 'private' arrays
	var siNext = new Int8Array([ 1, 2, 0 ]);
	var tmp = new Float32Array([ 0, 0, 0 ]);
	
	var xUnitVec3 = new Vector3(1, 0, 0);
	var yUnitVec3 = new Vector3(0, 1, 0);
	
	var tmpvec = new Vector3();
	var tmpMat3 = new Matrix3();
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class Quaternion
	 * @memberOf Phaser.Math
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {number} [x] - [description]
	 * @param {number} [y] - [description]
	 * @param {number} [z] - [description]
	 * @param {number} [w] - [description]
	 */
	var Quaternion = new Class({
	
	    initialize:
	
	    function Quaternion (x, y, z, w)
	    {
	        /**
	         * The x component of this Quaternion.
	         *
	         * @name Phaser.Math.Quaternion#x
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	
	        /**
	         * The y component of this Quaternion.
	         *
	         * @name Phaser.Math.Quaternion#y
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	
	        /**
	         * The z component of this Quaternion.
	         *
	         * @name Phaser.Math.Quaternion#z
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	
	        /**
	         * The w component of this Quaternion.
	         *
	         * @name Phaser.Math.Quaternion#w
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	
	        if (typeof x === 'object')
	        {
	            this.x = x.x || 0;
	            this.y = x.y || 0;
	            this.z = x.z || 0;
	            this.w = x.w || 0;
	        }
	        else
	        {
	            this.x = x || 0;
	            this.y = y || 0;
	            this.z = z || 0;
	            this.w = w || 0;
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#copy
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} src - [description]
	     *
	     * @return {Phaser.Math.Quaternion} This Quaternion object.
	     */
	    copy: function (src)
	    {
	        this.x = src.x;
	        this.y = src.y;
	        this.z = src.z;
	        this.w = src.w;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#set
	     * @since 3.0.0
	     *
	     * @param {(number|object)} [x=0] - [description]
	     * @param {number} [y=0] - [description]
	     * @param {number} [z=0] - [description]
	     * @param {number} [w=0] - [description]
	     *
	     * @return {Phaser.Math.Quaternion} This Quaternion object.
	     */
	    set: function (x, y, z, w)
	    {
	        if (typeof x === 'object')
	        {
	            this.x = x.x || 0;
	            this.y = x.y || 0;
	            this.z = x.z || 0;
	            this.w = x.w || 0;
	        }
	        else
	        {
	            this.x = x || 0;
	            this.y = y || 0;
	            this.z = z || 0;
	            this.w = w || 0;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#add
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} v - [description]
	     *
	     * @return {Phaser.Math.Quaternion} This Quaternion object.
	     */
	    add: function (v)
	    {
	        this.x += v.x;
	        this.y += v.y;
	        this.z += v.z;
	        this.w += v.w;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#subtract
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} v - [description]
	     *
	     * @return {Phaser.Math.Quaternion} This Quaternion object.
	     */
	    subtract: function (v)
	    {
	        this.x -= v.x;
	        this.y -= v.y;
	        this.z -= v.z;
	        this.w -= v.w;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#scale
	     * @since 3.0.0
	     *
	     * @param {number} scale - [description]
	     *
	     * @return {Phaser.Math.Quaternion} This Quaternion object.
	     */
	    scale: function (scale)
	    {
	        this.x *= scale;
	        this.y *= scale;
	        this.z *= scale;
	        this.w *= scale;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#length
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    length: function ()
	    {
	        var x = this.x;
	        var y = this.y;
	        var z = this.z;
	        var w = this.w;
	
	        return Math.sqrt(x * x + y * y + z * z + w * w);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#lengthSq
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    lengthSq: function ()
	    {
	        var x = this.x;
	        var y = this.y;
	        var z = this.z;
	        var w = this.w;
	
	        return x * x + y * y + z * z + w * w;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#normalize
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Quaternion} This Quaternion object.
	     */
	    normalize: function ()
	    {
	        var x = this.x;
	        var y = this.y;
	        var z = this.z;
	        var w = this.w;
	        var len = x * x + y * y + z * z + w * w;
	
	        if (len > 0)
	        {
	            len = 1 / Math.sqrt(len);
	
	            this.x = x * len;
	            this.y = y * len;
	            this.z = z * len;
	            this.w = w * len;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#dot
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} v - [description]
	     *
	     * @return {number} [description]
	     */
	    dot: function (v)
	    {
	        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#lerp
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} v - [description]
	     * @param {number} [t=0] - [description]
	     *
	     * @return {Phaser.Math.Quaternion} This Quaternion object.
	     */
	    lerp: function (v, t)
	    {
	        if (t === undefined) { t = 0; }
	
	        var ax = this.x;
	        var ay = this.y;
	        var az = this.z;
	        var aw = this.w;
	
	        this.x = ax + t * (v.x - ax);
	        this.y = ay + t * (v.y - ay);
	        this.z = az + t * (v.z - az);
	        this.w = aw + t * (v.w - aw);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#rotationTo
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector3} a - [description]
	     * @param {Phaser.Math.Vector3} b - [description]
	     *
	     * @return {Phaser.Math.Quaternion} This Quaternion object.
	     */
	    rotationTo: function (a, b)
	    {
	        var dot = a.x * b.x + a.y * b.y + a.z * b.z;
	
	        if (dot < -0.999999)
	        {
	            if (tmpvec.copy(xUnitVec3).cross(a).length() < EPSILON)
	            {
	                tmpvec.copy(yUnitVec3).cross(a);
	            }
	
	            tmpvec.normalize();
	
	            return this.setAxisAngle(tmpvec, Math.PI);
	
	        }
	        else if (dot > 0.999999)
	        {
	            this.x = 0;
	            this.y = 0;
	            this.z = 0;
	            this.w = 1;
	
	            return this;
	        }
	        else
	        {
	            tmpvec.copy(a).cross(b);
	
	            this.x = tmpvec.x;
	            this.y = tmpvec.y;
	            this.z = tmpvec.z;
	            this.w = 1 + dot;
	
	            return this.normalize();
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#setAxes
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector3} view - [description]
	     * @param {Phaser.Math.Vector3} right - [description]
	     * @param {Phaser.Math.Vector3} up - [description]
	     *
	     * @return {Phaser.Math.Quaternion} This Quaternion object.
	     */
	    setAxes: function (view, right, up)
	    {
	        var m = tmpMat3.val;
	
	        m[0] = right.x;
	        m[3] = right.y;
	        m[6] = right.z;
	
	        m[1] = up.x;
	        m[4] = up.y;
	        m[7] = up.z;
	
	        m[2] = -view.x;
	        m[5] = -view.y;
	        m[8] = -view.z;
	
	        return this.fromMat3(tmpMat3).normalize();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#identity
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Quaternion} This Quaternion object.
	     */
	    identity: function ()
	    {
	        this.x = 0;
	        this.y = 0;
	        this.z = 0;
	        this.w = 1;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#setAxisAngle
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector3} axis - [description]
	     * @param {number} rad - [description]
	     *
	     * @return {Phaser.Math.Quaternion} This Quaternion object.
	     */
	    setAxisAngle: function (axis, rad)
	    {
	        rad = rad * 0.5;
	
	        var s = Math.sin(rad);
	
	        this.x = s * axis.x;
	        this.y = s * axis.y;
	        this.z = s * axis.z;
	        this.w = Math.cos(rad);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#multiply
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} b - [description]
	     *
	     * @return {Phaser.Math.Quaternion} This Quaternion object.
	     */
	    multiply: function (b)
	    {
	        var ax = this.x;
	        var ay = this.y;
	        var az = this.z;
	        var aw = this.w;
	
	        var bx = b.x;
	        var by = b.y;
	        var bz = b.z;
	        var bw = b.w;
	
	        this.x = ax * bw + aw * bx + ay * bz - az * by;
	        this.y = ay * bw + aw * by + az * bx - ax * bz;
	        this.z = az * bw + aw * bz + ax * by - ay * bx;
	        this.w = aw * bw - ax * bx - ay * by - az * bz;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#slerp
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Math.Quaternion|Phaser.Math.Vector4)} b - [description]
	     * @param {number} t - [description]
	     *
	     * @return {Phaser.Math.Quaternion} This Quaternion object.
	     */
	    slerp: function (b, t)
	    {
	        // benchmarks: http://jsperf.com/quaternion-slerp-implementations
	
	        var ax = this.x;
	        var ay = this.y;
	        var az = this.z;
	        var aw = this.w;
	
	        var bx = b.x;
	        var by = b.y;
	        var bz = b.z;
	        var bw = b.w;
	
	        // calc cosine
	        var cosom = ax * bx + ay * by + az * bz + aw * bw;
	
	        // adjust signs (if necessary)
	        if (cosom < 0)
	        {
	            cosom = -cosom;
	            bx = - bx;
	            by = - by;
	            bz = - bz;
	            bw = - bw;
	        }
	
	        // "from" and "to" quaternions are very close
	        //  ... so we can do a linear interpolation
	        var scale0 = 1 - t;
	        var scale1 = t;
	
	        // calculate coefficients
	        if ((1 - cosom) > EPSILON)
	        {
	            // standard case (slerp)
	            var omega = Math.acos(cosom);
	            var sinom = Math.sin(omega);
	
	            scale0 = Math.sin((1.0 - t) * omega) / sinom;
	            scale1 = Math.sin(t * omega) / sinom;
	        }
	
	        // calculate final values
	        this.x = scale0 * ax + scale1 * bx;
	        this.y = scale0 * ay + scale1 * by;
	        this.z = scale0 * az + scale1 * bz;
	        this.w = scale0 * aw + scale1 * bw;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#invert
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Quaternion} This Quaternion object.
	     */
	    invert: function ()
	    {
	        var a0 = this.x;
	        var a1 = this.y;
	        var a2 = this.z;
	        var a3 = this.w;
	
	        var dot = a0 * a0 + a1 * a1 + a2 * a2 + a3 * a3;
	        var invDot = (dot) ? 1 / dot : 0;
	
	        // TODO: Would be faster to return [0,0,0,0] immediately if dot == 0
	
	        this.x = -a0 * invDot;
	        this.y = -a1 * invDot;
	        this.z = -a2 * invDot;
	        this.w = a3 * invDot;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#conjugate
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Quaternion} This Quaternion object.
	     */
	    conjugate: function ()
	    {
	        this.x = -this.x;
	        this.y = -this.y;
	        this.z = -this.z;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#rotateX
	     * @since 3.0.0
	     *
	     * @param {number} rad - [description]
	     *
	     * @return {Phaser.Math.Quaternion} This Quaternion object.
	     */
	    rotateX: function (rad)
	    {
	        rad *= 0.5;
	
	        var ax = this.x;
	        var ay = this.y;
	        var az = this.z;
	        var aw = this.w;
	
	        var bx = Math.sin(rad);
	        var bw = Math.cos(rad);
	
	        this.x = ax * bw + aw * bx;
	        this.y = ay * bw + az * bx;
	        this.z = az * bw - ay * bx;
	        this.w = aw * bw - ax * bx;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#rotateY
	     * @since 3.0.0
	     *
	     * @param {number} rad - [description]
	     *
	     * @return {Phaser.Math.Quaternion} This Quaternion object.
	     */
	    rotateY: function (rad)
	    {
	        rad *= 0.5;
	
	        var ax = this.x;
	        var ay = this.y;
	        var az = this.z;
	        var aw = this.w;
	
	        var by = Math.sin(rad);
	        var bw = Math.cos(rad);
	
	        this.x = ax * bw - az * by;
	        this.y = ay * bw + aw * by;
	        this.z = az * bw + ax * by;
	        this.w = aw * bw - ay * by;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#rotateZ
	     * @since 3.0.0
	     *
	     * @param {number} rad - [description]
	     *
	     * @return {Phaser.Math.Quaternion} This Quaternion object.
	     */
	    rotateZ: function (rad)
	    {
	        rad *= 0.5;
	
	        var ax = this.x;
	        var ay = this.y;
	        var az = this.z;
	        var aw = this.w;
	
	        var bz = Math.sin(rad);
	        var bw = Math.cos(rad);
	
	        this.x = ax * bw + ay * bz;
	        this.y = ay * bw - ax * bz;
	        this.z = az * bw + aw * bz;
	        this.w = aw * bw - az * bz;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#calculateW
	     * @since 3.0.0
	     *
	     * @return {Phaser.Math.Quaternion} This Quaternion object.
	     */
	    calculateW: function ()
	    {
	        var x = this.x;
	        var y = this.y;
	        var z = this.z;
	
	        this.w = -Math.sqrt(Math.abs(1.0 - x * x - y * y - z * z));
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.Quaternion#fromMat3
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Matrix3} mat - [description]
	     *
	     * @return {Phaser.Math.Quaternion} This Quaternion object.
	     */
	    fromMat3: function (mat)
	    {
	        // benchmarks:
	        //    http://jsperf.com/typed-array-access-speed
	        //    http://jsperf.com/conversion-of-3x3-matrix-to-quaternion
	
	        // Algorithm in Ken Shoemake's article in 1987 SIGGRAPH course notes
	        // article "Quaternion Calculus and Fast Animation".
	        var m = mat.val;
	        var fTrace = m[0] + m[4] + m[8];
	        var fRoot;
	
	        if (fTrace > 0)
	        {
	            // |w| > 1/2, may as well choose w > 1/2
	            fRoot = Math.sqrt(fTrace + 1.0); // 2w
	
	            this.w = 0.5 * fRoot;
	
	            fRoot = 0.5 / fRoot; // 1/(4w)
	
	            this.x = (m[7] - m[5]) * fRoot;
	            this.y = (m[2] - m[6]) * fRoot;
	            this.z = (m[3] - m[1]) * fRoot;
	        }
	        else
	        {
	            // |w| <= 1/2
	            var i = 0;
	
	            if (m[4] > m[0])
	            {
	                i = 1;
	            }
	
	            if (m[8] > m[i * 3 + i])
	            {
	                i = 2;
	            }
	
	            var j = siNext[i];
	            var k = siNext[j];
	
	            //  This isn't quite as clean without array access
	            fRoot = Math.sqrt(m[i * 3 + i] - m[j * 3 + j] - m[k * 3 + k] + 1);
	            tmp[i] = 0.5 * fRoot;
	
	            fRoot = 0.5 / fRoot;
	
	            tmp[j] = (m[j * 3 + i] + m[i * 3 + j]) * fRoot;
	            tmp[k] = (m[k * 3 + i] + m[i * 3 + k]) * fRoot;
	
	            this.x = tmp[0];
	            this.y = tmp[1];
	            this.z = tmp[2];
	            this.w = (m[k * 3 + j] - m[j * 3 + k]) * fRoot;
	        }
	
	        return this;
	    }
	
	});
	
	module.exports = Quaternion;


/***/ }),
/* 554 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  Position Vector randomly in a spherical area defined by the given radius
	/**
	 * [description]
	 *
	 * @function Phaser.Math.RandomXYZ
	 * @since 3.0.0
	 *
	 * @param {Phaser.Math.Vector3} vec3 - [description]
	 * @param {number} [radius=1] - [description]
	 *
	 * @return {Phaser.Math.Vector3} [description]
	 */
	var RandomXYZ = function (vec3, radius)
	{
	    if (radius === undefined) { radius = 1; }
	
	    var r = Math.random() * 2 * Math.PI;
	    var z = (Math.random() * 2) - 1;
	    var zScale = Math.sqrt(1 - z * z) * radius;
	    
	    vec3.x = Math.cos(r) * zScale;
	    vec3.y = Math.sin(r) * zScale;
	    vec3.z = z * radius;
	
	    return vec3;
	};
	
	module.exports = RandomXYZ;


/***/ }),
/* 555 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.RandomXYZW
	 * @since 3.0.0
	 *
	 * @param {Phaser.Math.Vector4} vec4 - [description]
	 * @param {float} [scale=1] - [description]
	 *
	 * @return {Phaser.Math.Vector4} [description]
	 */
	var RandomXYZW = function (vec4, scale)
	{
	    if (scale === undefined) { scale = 1; }
	
	    // Not spherical; should fix this for more uniform distribution
	    vec4.x = (Math.random() * 2 - 1) * scale;
	    vec4.y = (Math.random() * 2 - 1) * scale;
	    vec4.z = (Math.random() * 2 - 1) * scale;
	    vec4.w = (Math.random() * 2 - 1) * scale;
	
	    return vec4;
	};
	
	module.exports = RandomXYZW;


/***/ }),
/* 556 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Rotate a given point by a given angle around the origin (0, 0), in an anti-clockwise direction.
	 *
	 * @function Phaser.Math.Rotate
	 * @since 3.0.0
	 *
	 * @param {(Phaser.Geom.Point|object)} point - The point to be rotated.
	 * @param {number} angle - The angle to be rotated by in an anticlockwise direction.
	 *
	 * @return {Phaser.Geom.Point} The given point, rotated by the given angle in an anticlockwise direction.
	 */
	var Rotate = function (point, angle)
	{
	    var x = point.x;
	    var y = point.y;
	
	    point.x = (x * Math.cos(angle)) - (y * Math.sin(angle));
	    point.y = (x * Math.sin(angle)) + (y * Math.cos(angle));
	
	    return point;
	};
	
	module.exports = Rotate;


/***/ }),
/* 557 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.RotateAround
	 * @since 3.0.0
	 *
	 * @param {(Phaser.Geom.Point|object)} point - [description]
	 * @param {number} x - [description]
	 * @param {number} y - [description]
	 * @param {number} angle - [description]
	 *
	 * @return {Phaser.Geom.Point} [description]
	 */
	var RotateAround = function (point, x, y, angle)
	{
	    var c = Math.cos(angle);
	    var s = Math.sin(angle);
	
	    var tx = point.x - x;
	    var ty = point.y - y;
	
	    point.x = tx * c - ty * s + x;
	    point.y = tx * s + ty * c + y;
	
	    return point;
	};
	
	module.exports = RotateAround;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Vector3 = __webpack_require__(142);
	var Matrix4 = __webpack_require__(307);
	var Quaternion = __webpack_require__(553);
	
	var tmpMat4 = new Matrix4();
	var tmpQuat = new Quaternion();
	var tmpVec3 = new Vector3();
	
	/**
	 * Rotates a vector in place by axis angle.
	 *
	 * This is the same as transforming a point by an 
	 * axis-angle quaternion, but it has higher precision.
	 *
	 * @function Phaser.Math.RotateVec3
	 * @since 3.0.0
	 *
	 * @param {Phaser.Math.Vector3} vec - [description]
	 * @param {Phaser.Math.Vector3} axis - [description]
	 * @param {float} radians - [description]
	 *
	 * @return {Phaser.Math.Vector3} [description]
	 */
	var RotateVec3 = function (vec, axis, radians)
	{
	    //  Set the quaternion to our axis angle
	    tmpQuat.setAxisAngle(axis, radians);
	
	    //  Create a rotation matrix from the axis angle
	    tmpMat4.fromRotationTranslation(tmpQuat, tmpVec3.set(0, 0, 0));
	
	    //  Multiply our vector by the rotation matrix
	    return vec.transformMat4(tmpMat4);
	};
	
	module.exports = RotateVec3;


/***/ }),
/* 559 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Round a given number so it is further away from zero. That is, positive numbers are rounded up, and negative numbers are rounded down.
	 *
	 * @function Phaser.Math.RoundAwayFromZero
	 * @since 3.0.0
	 *
	 * @param {number} value - The number to round.
	 *
	 * @return {number} The rounded number, rounded away from zero.
	 */
	var RoundAwayFromZero = function (value)
	{
	    // "Opposite" of truncate.
	    return (value > 0) ? Math.ceil(value) : Math.floor(value);
	};
	
	module.exports = RoundAwayFromZero;


/***/ }),
/* 560 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.SmoothStep
	 * @since 3.0.0
	 *
	 * @param {number} x - [description]
	 * @param {number} min - [description]
	 * @param {number} max - [description]
	 *
	 * @return {number} [description]
	 */
	var SmoothStep = function (x, min, max)
	{
	    x = Math.max(0, Math.min(1, (x - min) / (max - min)));
	
	    return x * x * (3 - 2 * x);
	};
	
	module.exports = SmoothStep;


/***/ }),
/* 561 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.SmootherStep
	 * @since 3.0.0
	 *
	 * @param {number} x - [description]
	 * @param {number} min - [description]
	 * @param {number} max - [description]
	 *
	 * @return {number} [description]
	 */
	var SmootherStep = function (x, min, max)
	{
	    x = Math.max(0, Math.min(1, (x - min) / (max - min)));
	
	    return x * x * x * (x * (x * 6 - 15) + 10);
	};
	
	module.exports = SmootherStep;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Vector2 = __webpack_require__(9);
	
	/**
	 * Takes the `x` and `y` coordinates and transforms them into the same space as
	 * defined by the position, rotation and scale values.
	 *
	 * @function Phaser.Math.TransformXY
	 * @since 3.0.0
	 *
	 * @param {number} x - The x coordinate to be transformed.
	 * @param {number} y - The y coordinate to be transformed.
	 * @param {number} positionX - Horizontal position of the transform point.
	 * @param {number} positionY - Vertical position of the transform point.
	 * @param {number} rotation - Rotation of the transform point, in radians.
	 * @param {number} scaleX - Horizontal scale of the transform point.
	 * @param {number} scaleY - Vertical scale of the transform point.
	 * @param {(Phaser.Math.Vector2|Phaser.Geom.Point|object)} [output] - [description]
	 *
	 * @return {(Phaser.Math.Vector2|Phaser.Geom.Point|object)} The translated point.
	 */
	var TransformXY = function (x, y, positionX, positionY, rotation, scaleX, scaleY, output)
	{
	    if (output === undefined) { output = new Vector2(); }
	
	    //  ITRS
	
	    var sr = Math.sin(-rotation);
	    var cr = Math.cos(-rotation);
	
	    var a = cr * scaleX;
	    var b = -sr * scaleX;
	    var c = sr * scaleY;
	    var d = cr * scaleY;
	
	    //  Invert
	
	    var n = a * d - b * c;
	
	    var m0 = d / n;
	    var m1 = -b / n;
	    var m2 = -c / n;
	    var m3 = a / n;
	    var m4 = (c * positionY - d * positionX) / n;
	    var m5 = -(a * positionY - b * positionX) / n;
	
	    //  Transform
	
	    output.x = x * m0 + y * m2 + m4;
	    output.y = x * m1 + y * m3 + m5;
	
	    return output;
	};
	
	module.exports = TransformXY;


/***/ }),
/* 563 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Angle.Normalize
	 * @since 3.0.0
	 *
	 * @param {number} angle - [description]
	 *
	 * @return {number} [description]
	 */
	var Normalize = function (angle)
	{
	    angle = angle % (2 * Math.PI);
	
	    if (angle >= 0)
	    {
	        return angle;
	    }
	    else
	    {
	        return angle + 2 * Math.PI;
	    }
	};
	
	module.exports = Normalize;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Math.Easing.Back
	 */
	
	module.exports = {
	
	    In: __webpack_require__(1375),
	    Out: __webpack_require__(1377),
	    InOut: __webpack_require__(1376)
	
	};


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Math.Easing.Bounce
	 */
	
	module.exports = {
	
	    In: __webpack_require__(1378),
	    Out: __webpack_require__(1380),
	    InOut: __webpack_require__(1379)
	
	};


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Math.Easing.Circular
	 */
	
	module.exports = {
	
	    In: __webpack_require__(1381),
	    Out: __webpack_require__(1383),
	    InOut: __webpack_require__(1382)
	
	};


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Math.Easing.Cubic
	 */
	
	module.exports = {
	
	    In: __webpack_require__(1384),
	    Out: __webpack_require__(1386),
	    InOut: __webpack_require__(1385)
	
	};


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Math.Easing.Elastic
	 */
	
	module.exports = {
	
	    In: __webpack_require__(1387),
	    Out: __webpack_require__(1389),
	    InOut: __webpack_require__(1388)
	
	};


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Math.Easing.Expo
	 */
	
	module.exports = {
	
	    In: __webpack_require__(1390),
	    Out: __webpack_require__(1392),
	    InOut: __webpack_require__(1391)
	
	};


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Math.Easing.Linear
	 */
	
	module.exports = __webpack_require__(1394);


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Math.Easing.Quadratic
	 */
	
	module.exports = {
	
	    In: __webpack_require__(1395),
	    Out: __webpack_require__(1397),
	    InOut: __webpack_require__(1396)
	
	};


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Math.Easing.Quartic
	 */
	
	module.exports = {
	
	    In: __webpack_require__(1398),
	    Out: __webpack_require__(1400),
	    InOut: __webpack_require__(1399)
	
	};


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Math.Easing.Quintic
	 */
	
	module.exports = {
	
	    In: __webpack_require__(1401),
	    Out: __webpack_require__(1403),
	    InOut: __webpack_require__(1402)
	
	};


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Math.Easing.Sine
	 */
	
	module.exports = {
	
	    In: __webpack_require__(1404),
	    Out: __webpack_require__(1406),
	    InOut: __webpack_require__(1405)
	
	};


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Math.Easing.Stepped
	 */
	
	module.exports = __webpack_require__(1407);


/***/ }),
/* 576 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	function P0 (t, p)
	{
	    var k = 1 - t;
	
	    return k * k * k * p;
	}
	
	function P1 (t, p)
	{
	    var k = 1 - t;
	
	    return 3 * k * k * t * p;
	}
	
	function P2 (t, p)
	{
	    return 3 * (1 - t) * t * t * p;
	}
	
	function P3 (t, p)
	{
	    return t * t * t * p;
	}
	
	//  p0 = start point
	//  p1 = control point 1
	//  p2 = control point 2
	//  p3 = end point
	
	// https://medium.com/@adrian_cooney/bezier-interpolation-13b68563313a
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Interpolation.CubicBezier
	 * @since 3.0.0
	 *
	 * @param {float} t - [description]
	 * @param {number} p0 - [description]
	 * @param {number} p1 - [description]
	 * @param {number} p2 - [description]
	 * @param {number} p3 - [description]
	 *
	 * @return {number} [description]
	 */
	var CubicBezierInterpolation = function (t, p0, p1, p2, p3)
	{
	    return P0(t, p0) + P1(t, p1) + P2(t, p2) + P3(t, p3);
	};
	
	module.exports = CubicBezierInterpolation;


/***/ }),
/* 577 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	function P0 (t, p)
	{
	    var k = 1 - t;
	
	    return k * k * p;
	}
	
	function P1 (t, p)
	{
	    return 2 * (1 - t) * t * p;
	}
	
	function P2 (t, p)
	{
	    return t * t * p;
	}
	
	//  p0 = start point
	//  p1 = control point 1
	//  p2 = end point
	
	// https://github.com/mrdoob/three.js/blob/master/src/extras/core/Interpolations.js
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Interpolation.QuadraticBezier
	 * @since 3.2.0
	 *
	 * @param {float} t - [description]
	 * @param {number} p0 - [description]
	 * @param {number} p1 - [description]
	 * @param {number} p2 - [description]
	 *
	 * @return {number} [description]
	 */
	var QuadraticBezierInterpolation = function (t, p0, p1, p2)
	{
	    return P0(t, p0) + P1(t, p1) + P2(t, p2);
	};
	
	module.exports = QuadraticBezierInterpolation;


/***/ }),
/* 578 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Returns the nearest power of 2 to the given `value`.
	 *
	 * @function Phaser.Math.Pow2.GetPowerOfTwo
	 * @since 3.0.0
	 *
	 * @param {number} value - [description]
	 *
	 * @return {integer} [description]
	 */
	var GetPowerOfTwo = function (value)
	{
	    //  Math.log(2)
	    var index = Math.log(value) / 0.6931471805599453;
	
	    return (1 << Math.ceil(index));
	};
	
	module.exports = GetPowerOfTwo;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class RandomDataGenerator
	 * @memberOf Phaser.Math
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {string[]} [seeds] - [description]
	 */
	var RandomDataGenerator = new Class({
	
	    initialize:
	
	    function RandomDataGenerator (seeds)
	    {
	        /**
	         * Internal var.
	         *
	         * @name Phaser.Math.RandomDataGenerator#c
	         * @type {number}
	         * @default 1
	         * @private
	         * @since 3.0.0
	         */
	        this.c = 1;
	
	        /**
	         * Internal var.
	         *
	         * @name Phaser.Math.RandomDataGenerator#s0
	         * @type {number}
	         * @default 0
	         * @private
	         * @since 3.0.0
	         */
	        this.s0 = 0;
	
	        /**
	         * Internal var.
	         *
	         * @name Phaser.Math.RandomDataGenerator#s1
	         * @type {number}
	         * @default 0
	         * @private
	         * @since 3.0.0
	         */
	        this.s1 = 0;
	
	        /**
	         * Internal var.
	         *
	         * @name Phaser.Math.RandomDataGenerator#s2
	         * @type {number}
	         * @default 0
	         * @private
	         * @since 3.0.0
	         */
	        this.s2 = 0;
	
	        /**
	         * Internal var.
	         *
	         * @name Phaser.Math.RandomDataGenerator#n
	         * @type {number}
	         * @default 0
	         * @private
	         * @since 3.2.0
	         */
	        this.n = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Math.RandomDataGenerator#signs
	         * @type {number[]}
	         * @since 3.0.0
	         */
	        this.signs = [ -1, 1 ];
	
	        if (seeds)
	        {
	            this.init(seeds);
	        }
	    },
	
	    /**
	     * Private random helper.
	     *
	     * @method Phaser.Math.RandomDataGenerator#rnd
	     * @since 3.0.0
	     * @private
	     *
	     * @return {number} [description]
	     */
	    rnd: function ()
	    {
	        var t = 2091639 * this.s0 + this.c * 2.3283064365386963e-10; // 2^-32
	
	        this.c = t | 0;
	        this.s0 = this.s1;
	        this.s1 = this.s2;
	        this.s2 = t - this.c;
	
	        return this.s2;
	    },
	
	    /**
	     * Internal method that creates a seed hash.
	     *
	     * @method Phaser.Math.RandomDataGenerator#hash
	     * @since 3.0.0
	     * @private
	     *
	     * @param {string} data - [description]
	     *
	     * @return {number} The hashed value.
	     */
	    hash: function (data)
	    {
	        var h;
	        var n = this.n;
	
	        data = data.toString();
	
	        for (var i = 0; i < data.length; i++)
	        {
	            n += data.charCodeAt(i);
	            h = 0.02519603282416938 * n;
	            n = h >>> 0;
	            h -= n;
	            h *= n;
	            n = h >>> 0;
	            h -= n;
	            n += h * 0x100000000;// 2^32
	        }
	
	        this.n = n;
	
	        return (n >>> 0) * 2.3283064365386963e-10;// 2^-32
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Math.RandomDataGenerator#init
	     * @since 3.0.0
	     *
	     * @param {(string|string[])} seeds - [description]
	     */
	    init: function (seeds)
	    {
	        if (typeof seeds === 'string')
	        {
	            this.state(seeds);
	        }
	        else
	        {
	            this.sow(seeds);
	        }
	    },
	
	    /**
	     * Reset the seed of the random data generator.
	     *
	     * _Note_: the seed array is only processed up to the first `undefined` (or `null`) value, should such be present.
	     *
	     * @method Phaser.Math.RandomDataGenerator#sow
	     * @since 3.0.0
	     *
	     * @param {string[]} seeds - The array of seeds: the `toString()` of each value is used.
	     */
	    sow: function (seeds)
	    {
	        // Always reset to default seed
	        this.n = 0xefc8249d;
	        this.s0 = this.hash(' ');
	        this.s1 = this.hash(' ');
	        this.s2 = this.hash(' ');
	        this.c = 1;
	
	        if (!seeds)
	        {
	            return;
	        }
	
	        // Apply any seeds
	        for (var i = 0; i < seeds.length && (seeds[i] != null); i++)
	        {
	            var seed = seeds[i];
	
	            this.s0 -= this.hash(seed);
	            this.s0 += ~~(this.s0 < 0);
	            this.s1 -= this.hash(seed);
	            this.s1 += ~~(this.s1 < 0);
	            this.s2 -= this.hash(seed);
	            this.s2 += ~~(this.s2 < 0);
	        }
	    },
	
	    /**
	     * Returns a random integer between 0 and 2^32.
	     *
	     * @method Phaser.Math.RandomDataGenerator#integer
	     * @since 3.0.0
	     *
	     * @return {number} A random integer between 0 and 2^32.
	     */
	    integer: function ()
	    {
	        // 2^32
	        return this.rnd() * 0x100000000;
	    },
	
	    /**
	     * Returns a random real number between 0 and 1.
	     *
	     * @method Phaser.Math.RandomDataGenerator#frac
	     * @since 3.0.0
	     *
	     * @return {number} A random real number between 0 and 1.
	     */
	    frac: function ()
	    {
	        // 2^-53
	        return this.rnd() + (this.rnd() * 0x200000 | 0) * 1.1102230246251565e-16;
	    },
	
	    /**
	     * Returns a random real number between 0 and 2^32.
	     *
	     * @method Phaser.Math.RandomDataGenerator#real
	     * @since 3.0.0
	     *
	     * @return {number} A random real number between 0 and 2^32.
	     */
	    real: function ()
	    {
	        return this.integer() + this.frac();
	    },
	
	    /**
	     * Returns a random integer between and including min and max.
	     *
	     * @method Phaser.Math.RandomDataGenerator#integerInRange
	     * @since 3.0.0
	     *
	     * @param {number} min - The minimum value in the range.
	     * @param {number} max - The maximum value in the range.
	     *
	     * @return {number} A random number between min and max.
	     */
	    integerInRange: function (min, max)
	    {
	        return Math.floor(this.realInRange(0, max - min + 1) + min);
	    },
	
	    /**
	     * Returns a random integer between and including min and max.
	     * This method is an alias for RandomDataGenerator.integerInRange.
	     *
	     * @method Phaser.Math.RandomDataGenerator#between
	     * @since 3.0.0
	     *
	     * @param {number} min - The minimum value in the range.
	     * @param {number} max - The maximum value in the range.
	     *
	     * @return {number} A random number between min and max.
	     */
	    between: function (min, max)
	    {
	        return Math.floor(this.realInRange(0, max - min + 1) + min);
	    },
	
	    /**
	     * Returns a random real number between min and max.
	     *
	     * @method Phaser.Math.RandomDataGenerator#realInRange
	     * @since 3.0.0
	     *
	     * @param {number} min - The minimum value in the range.
	     * @param {number} max - The maximum value in the range.
	     *
	     * @return {number} A random number between min and max.
	     */
	    realInRange: function (min, max)
	    {
	        return this.frac() * (max - min) + min;
	    },
	
	    /**
	     * Returns a random real number between -1 and 1.
	     *
	     * @method Phaser.Math.RandomDataGenerator#normal
	     * @since 3.0.0
	     *
	     * @return {number} A random real number between -1 and 1.
	     */
	    normal: function ()
	    {
	        return 1 - (2 * this.frac());
	    },
	
	    /**
	     * Returns a valid RFC4122 version4 ID hex string from https://gist.github.com/1308368
	     *
	     * @method Phaser.Math.RandomDataGenerator#uuid
	     * @since 3.0.0
	     *
	     * @return {string} A valid RFC4122 version4 ID hex string
	     */
	    uuid: function ()
	    {
	        var a = '';
	        var b = '';
	
	        for (b = a = ''; a++ < 36; b += ~a % 5 | a * 3 & 4 ? (a ^ 15 ? 8 ^ this.frac() * (a ^ 20 ? 16 : 4) : 4).toString(16) : '-')
	        {
	            // eslint-disable-next-line no-empty
	        }
	
	        return b;
	    },
	
	    /**
	     * Returns a random element from within the given array.
	     *
	     * @method Phaser.Math.RandomDataGenerator#pick
	     * @since 3.0.0
	     *
	     * @param {array} array - The array to pick a random element from.
	     *
	     * @return {*} A random member of the array.
	     */
	    pick: function (array)
	    {
	        return array[this.integerInRange(0, array.length - 1)];
	    },
	
	    /**
	     * Returns a sign to be used with multiplication operator.
	     *
	     * @method Phaser.Math.RandomDataGenerator#sign
	     * @since 3.0.0
	     *
	     * @return {number} -1 or +1.
	     */
	    sign: function ()
	    {
	        return this.pick(this.signs);
	    },
	
	    /**
	     * Returns a random element from within the given array, favoring the earlier entries.
	     *
	     * @method Phaser.Math.RandomDataGenerator#weightedPick
	     * @since 3.0.0
	     *
	     * @param {array} array - The array to pick a random element from.
	     *
	     * @return {*} A random member of the array.
	     */
	    weightedPick: function (array)
	    {
	        return array[~~(Math.pow(this.frac(), 2) * (array.length - 1) + 0.5)];
	    },
	
	    /**
	     * Returns a random timestamp between min and max, or between the beginning of 2000 and the end of 2020 if min and max aren't specified.
	     *
	     * @method Phaser.Math.RandomDataGenerator#timestamp
	     * @since 3.0.0
	     *
	     * @param {number} min - The minimum value in the range.
	     * @param {number} max - The maximum value in the range.
	     *
	     * @return {number} A random timestamp between min and max.
	     */
	    timestamp: function (min, max)
	    {
	        return this.realInRange(min || 946684800000, max || 1577862000000);
	    },
	
	    /**
	     * Returns a random angle between -180 and 180.
	     *
	     * @method Phaser.Math.RandomDataGenerator#angle
	     * @since 3.0.0
	     *
	     * @return {number} A random number between -180 and 180.
	     */
	    angle: function ()
	    {
	        return this.integerInRange(-180, 180);
	    },
	
	    /**
	     * Returns a random rotation in radians, between -3.141 and 3.141
	     *
	     * @method Phaser.Math.RandomDataGenerator#rotation
	     * @since 3.0.0
	     *
	     * @return {number} A random number between -3.141 and 3.141
	     */
	    rotation: function ()
	    {
	        return this.realInRange(-3.1415926, 3.1415926);
	    },
	
	    /**
	     * Gets or Sets the state of the generator. This allows you to retain the values
	     * that the generator is using between games, i.e. in a game save file.
	     *
	     * To seed this generator with a previously saved state you can pass it as the
	     * `seed` value in your game config, or call this method directly after Phaser has booted.
	     *
	     * Call this method with no parameters to return the current state.
	     *
	     * If providing a state it should match the same format that this method
	     * returns, which is a string with a header `!rnd` followed by the `c`,
	     * `s0`, `s1` and `s2` values respectively, each comma-delimited.
	     *
	     * @method Phaser.Math.RandomDataGenerator#state
	     * @since 3.0.0
	     *
	     * @param {string} [state] - Generator state to be set.
	     *
	     * @return {string} The current state of the generator.
	     */
	    state: function (state)
	    {
	        if (typeof state === 'string' && state.match(/^!rnd/))
	        {
	            state = state.split(',');
	
	            this.c = parseFloat(state[1]);
	            this.s0 = parseFloat(state[2]);
	            this.s1 = parseFloat(state[3]);
	            this.s2 = parseFloat(state[4]);
	        }
	
	        return [ '!rnd', this.c, this.s0, this.s1, this.s2 ].join(',');
	    },
	
	    /**
	     * Shuffles the given array, using the current seed.
	     *
	     * @method Phaser.Math.RandomDataGenerator#shuffle
	     * @since 3.7.0
	     * 
	     * @param {array[]} [array] - The array to be shuffled.
	     *
	     * @return {array} The shuffled array.
	     */
	    shuffle: function (array)
	    {
	        var len = array.length - 1;
	
	        for (var i = len; i > 0; i--)
	        {
	            var randomIndex = Math.floor(this.frac() * (len + 1));
	            var itemAtIndex = array[randomIndex];
	
	            array[randomIndex] = array[i];
	            array[i] = itemAtIndex;
	        }
	
	        return array;
	    }
	
	});
	
	module.exports = RandomDataGenerator;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(590);
	var Image = __webpack_require__(138);
	
	/**
	 * @classdesc
	 * An Arcade Physics Image Game Object.
	 *
	 * An Image is a light-weight Game Object useful for the display of static images in your game,
	 * such as logos, backgrounds, scenery or other non-animated elements. Images can have input
	 * events and physics bodies, or be tweened, tinted or scrolled. The main difference between an
	 * Image and a Sprite is that you cannot animate an Image as they do not have the Animation component.
	 *
	 * @class Image
	 * @extends Phaser.GameObjects.Image
	 * @memberOf Phaser.Physics.Arcade
	 * @constructor
	 * @since 3.0.0
	 *
	 * @extends Phaser.Physics.Arcade.Components.Acceleration
	 * @extends Phaser.Physics.Arcade.Components.Angular
	 * @extends Phaser.Physics.Arcade.Components.Bounce
	 * @extends Phaser.Physics.Arcade.Components.Debug
	 * @extends Phaser.Physics.Arcade.Components.Drag
	 * @extends Phaser.Physics.Arcade.Components.Enable
	 * @extends Phaser.Physics.Arcade.Components.Friction
	 * @extends Phaser.Physics.Arcade.Components.Gravity
	 * @extends Phaser.Physics.Arcade.Components.Immovable
	 * @extends Phaser.Physics.Arcade.Components.Mass
	 * @extends Phaser.Physics.Arcade.Components.Size
	 * @extends Phaser.Physics.Arcade.Components.Velocity
	 * @extends Phaser.GameObjects.Components.Alpha
	 * @extends Phaser.GameObjects.Components.BlendMode
	 * @extends Phaser.GameObjects.Components.Depth
	 * @extends Phaser.GameObjects.Components.Flip
	 * @extends Phaser.GameObjects.Components.GetBounds
	 * @extends Phaser.GameObjects.Components.Origin
	 * @extends Phaser.GameObjects.Components.Pipeline
	 * @extends Phaser.GameObjects.Components.ScaleMode
	 * @extends Phaser.GameObjects.Components.ScrollFactor
	 * @extends Phaser.GameObjects.Components.Size
	 * @extends Phaser.GameObjects.Components.Texture
	 * @extends Phaser.GameObjects.Components.Tint
	 * @extends Phaser.GameObjects.Components.Transform
	 * @extends Phaser.GameObjects.Components.Visible
	 *
	 * @param {Phaser.Scene} scene - The Scene to which this Game Object belongs. A Game Object can only belong to one Scene at a time.
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	 * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	 */
	var ArcadeImage = new Class({
	
	    Extends: Image,
	
	    Mixins: [
	        Components.Acceleration,
	        Components.Angular,
	        Components.Bounce,
	        Components.Debug,
	        Components.Drag,
	        Components.Enable,
	        Components.Friction,
	        Components.Gravity,
	        Components.Immovable,
	        Components.Mass,
	        Components.Size,
	        Components.Velocity
	    ],
	
	    initialize:
	
	    function ArcadeImage (scene, x, y, texture, frame)
	    {
	        Image.call(this, scene, x, y, texture, frame);
	    }
	
	});
	
	module.exports = ArcadeImage;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CircleContains = __webpack_require__(83);
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(117);
	var RadToDeg = __webpack_require__(308);
	var Rectangle = __webpack_require__(23);
	var RectangleContains = __webpack_require__(84);
	var TransformMatrix = __webpack_require__(158);
	var Vector2 = __webpack_require__(9);
	
	/**
	 * @typedef {object} ArcadeBodyBounds
	 *
	 * @property {number} x - The left edge.
	 * @property {number} y - The upper edge.
	 * @property {number} right - The right edge.
	 * @property {number} bottom - The lower edge.
	 */
	
	/**
	 * @typedef {object} ArcadeBodyCollision
	 *
	 * @property {boolean} none - True if the Body is not colliding.
	 * @property {boolean} up - True if the Body is colliding on its upper edge.
	 * @property {boolean} down - True if the Body is colliding on its lower edge.
	 * @property {boolean} left - True if the Body is colliding on its left edge.
	 * @property {boolean} right - True if the Body is colliding on its right edge.
	 */
	
	/**
	 * @classdesc
	 * A Dynamic Arcade Body.
	 *
	 * @class Body
	 * @memberOf Phaser.Physics.Arcade
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Physics.Arcade.World} world - The Arcade Physics simulation this Body belongs to.
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object this Body belongs to.
	 */
	var Body = new Class({
	
	    initialize:
	
	    function Body (world, gameObject)
	    {
	        var width = (gameObject.width) ? gameObject.width : 64;
	        var height = (gameObject.height) ? gameObject.height : 64;
	
	        /**
	         * The Arcade Physics simulation this Body belongs to.
	         *
	         * @name Phaser.Physics.Arcade.Body#world
	         * @type {Phaser.Physics.Arcade.World}
	         * @since 3.0.0
	         */
	        this.world = world;
	
	        /**
	         * The Game Object this Body belongs to.
	         *
	         * @name Phaser.Physics.Arcade.Body#gameObject
	         * @type {Phaser.GameObjects.GameObject}
	         * @since 3.0.0
	         */
	        this.gameObject = gameObject;
	
	        /**
	         * Transformations applied to this Body.
	         *
	         * @name Phaser.Physics.Arcade.Body#transform
	         * @type {object}
	         * @since 3.4.0
	         */
	        this.transform = {
	            x: gameObject.x,
	            y: gameObject.y,
	            rotation: gameObject.angle,
	            scaleX: gameObject.scaleX,
	            scaleY: gameObject.scaleY,
	            displayOriginX: gameObject.displayOriginX,
	            displayOriginY: gameObject.displayOriginY
	        };
	
	        /**
	         * Whether the Body's boundary is drawn to the debug display.
	         *
	         * @name Phaser.Physics.Arcade.Body#debugShowBody
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.debugShowBody = world.defaults.debugShowBody;
	
	        /**
	         * Whether the Body's velocity is drawn to the debug display.
	         *
	         * @name Phaser.Physics.Arcade.Body#debugShowVelocity
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.debugShowVelocity = world.defaults.debugShowVelocity;
	
	        /**
	         * The color of this Body on the debug display.
	         *
	         * @name Phaser.Physics.Arcade.Body#debugBodyColor
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.debugBodyColor = world.defaults.bodyDebugColor;
	
	        /**
	         * Whether this Body is updated by the physics simulation.
	         *
	         * @name Phaser.Physics.Arcade.Body#enable
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.enable = true;
	
	        /**
	         * Whether this Body's boundary is circular (true) or rectangular (false).
	         *
	         * @name Phaser.Physics.Arcade.Body#isCircle
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         * @see Phaser.Physics.Arcade.Body#setCircle
	         */
	        this.isCircle = false;
	
	        /**
	         * The unscaled radius of this Body's boundary (if circular), as set by setCircle, in source pixels.
	         * The true radius (if circular) is equal to halfWidth.
	         *
	         * @name Phaser.Physics.Arcade.Body#radius
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         * @see Phaser.Physics.Arcade.Body#setCircle
	         */
	        this.radius = 0;
	
	        /**
	         * The offset of this Body's position from its Game Object's position, in source pixels.
	         *
	         * @name Phaser.Physics.Arcade.Body#offset
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         * @see Phaser.Physics.Arcade.Body#setOffset
	         */
	        this.offset = new Vector2();
	
	        /**
	         * The position of this Body within the simulation.
	         *
	         * @name Phaser.Physics.Arcade.Body#position
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.position = new Vector2(gameObject.x, gameObject.y);
	
	        /**
	         * The position of this Body during the previous step.
	         *
	         * @name Phaser.Physics.Arcade.Body#prev
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.prev = new Vector2(gameObject.x, gameObject.y);
	
	        /**
	         * Whether this Body's rotation is affected by its angular acceleration and velocity.
	         *
	         * @name Phaser.Physics.Arcade.Body#allowRotation
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.allowRotation = true;
	
	        /**
	         * This body's rotation, in degrees, based on its angular acceleration and velocity.
	         * The Body's rotation controls the `angle` of its Game Object.
	         * It doesn't rotate the Body's boundary, which is always an axis-aligned rectangle or a circle.
	         *
	         * @name Phaser.Physics.Arcade.Body#rotation
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.rotation = gameObject.angle;
	
	        /**
	         * The Body's rotation, in degrees, during the previous step.
	         *
	         * @name Phaser.Physics.Arcade.Body#preRotation
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.preRotation = gameObject.angle;
	
	        /**
	         * The width of the Body's boundary. If circular, this is also the Body's diameter.
	         *
	         * @name Phaser.Physics.Arcade.Body#width
	         * @type {number}
	         * @default 64
	         * @since 3.0.0
	         */
	        this.width = width;
	
	        /**
	         * The height of the Body's boundary. If circular, this is also the Body's diameter.
	         *
	         * @name Phaser.Physics.Arcade.Body#height
	         * @type {number}
	         * @default 64
	         * @since 3.0.0
	         */
	        this.height = height;
	
	        /**
	         * The unscaled width of the Body, in source pixels. The default is the width of the Body's Game Object's texture frame.
	         *
	         * @name Phaser.Physics.Arcade.Body#sourceWidth
	         * @type {number}
	         * @since 3.0.0
	         * @see Phaser.Physics.Arcade.Body#setSize
	         */
	        this.sourceWidth = width;
	
	        /**
	         * The unscaled height of the Body, in source pixels. The default is the height of the Body's Game Object's texture frame.
	         *
	         * @name Phaser.Physics.Arcade.Body#sourceHeight
	         * @type {number}
	         * @since 3.0.0
	         * @see Phaser.Physics.Arcade.Body#setSize
	         */
	        this.sourceHeight = height;
	
	        if (gameObject.frame)
	        {
	            this.sourceWidth = gameObject.frame.realWidth;
	            this.sourceHeight = gameObject.frame.realHeight;
	        }
	
	        /**
	         * Half the Body's width.
	         *
	         * @name Phaser.Physics.Arcade.Body#halfWidth
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.halfWidth = Math.abs(width / 2);
	
	        /**
	         * Half the Body's height.
	         *
	         * @name Phaser.Physics.Arcade.Body#halfHeight
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.halfHeight = Math.abs(height / 2);
	
	        /**
	         * The center of the Body's boundary. The midpoint of its `position` (top-left corner) and its bottom-right corner.
	         *
	         * @name Phaser.Physics.Arcade.Body#center
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.center = new Vector2(gameObject.x + this.halfWidth, gameObject.y + this.halfHeight);
	
	        /**
	         * The Body's change in position, in pixels per second.
	         *
	         * @name Phaser.Physics.Arcade.Body#velocity
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.velocity = new Vector2();
	
	        /**
	         * The Body's calculated change in position, in pixels, at the last step.
	         *
	         * @name Phaser.Physics.Arcade.Body#newVelocity
	         * @type {Phaser.Math.Vector2}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.newVelocity = new Vector2();
	
	        /**
	         * The Body's absolute maximum change in position, in pixels per step.
	         *
	         * @name Phaser.Physics.Arcade.Body#deltaMax
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.deltaMax = new Vector2();
	
	        /**
	         * The Body's change in velocity, in pixels per second squared.
	         *
	         * @name Phaser.Physics.Arcade.Body#acceleration
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.acceleration = new Vector2();
	
	        /**
	         * Whether this Body's velocity is affected by its drag vector.
	         *
	         * @name Phaser.Physics.Arcade.Body#allowDrag
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.allowDrag = true;
	
	        /**
	         * Absolute loss of velocity due to movement, in pixels per second squared.
	         *
	         * @name Phaser.Physics.Arcade.Body#drag
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.drag = new Vector2();
	
	        /**
	         * Whether this Body's position is affected by its gravity vector.
	         *
	         * @name Phaser.Physics.Arcade.Body#allowGravity
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.allowGravity = true;
	
	        /**
	         * Acceleration due to gravity (specific to this Body), in pixels per second squared.
	         * Total gravity is the sum of this vector and the simulation's `gravity`.
	         *
	         * @name Phaser.Physics.Arcade.Body#gravity
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.gravity = new Vector2();
	
	        /**
	         * Rebound following a collision, relative to 1.
	         *
	         * @name Phaser.Physics.Arcade.Body#bounce
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.bounce = new Vector2();
	
	        /**
	         * Rebound following a collision with the world boundary, relative to 1.
	         * If empty, `bounce` is used instead.
	         *
	         * @name Phaser.Physics.Arcade.Body#worldBounce
	         * @type {?Phaser.Math.Vector2}
	         * @default null
	         * @since 3.0.0
	         */
	        this.worldBounce = null;
	
	        //  If true this Body will dispatch events
	
	        /**
	         * Whether the simulation emits a `worldbounds` event when this Body collides with the world boundary (and `collideWorldBounds` is also true).
	         *
	         * @name Phaser.Physics.Arcade.Body#onWorldBounds
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         * @see Phaser.Physics.Arcade.World#event:worldbounds
	         */
	        this.onWorldBounds = false;
	
	        /**
	         * Whether the simulation emits a `collide` event when this Body collides with another.
	         *
	         * @name Phaser.Physics.Arcade.Body#onCollide
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         * @see Phaser.Physics.Arcade.World#event:collide
	         */
	        this.onCollide = false;
	
	        /**
	         * Whether the simulation emits an `overlap` event when this Body overlaps with another.
	         *
	         * @name Phaser.Physics.Arcade.Body#onOverlap
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         * @see Phaser.Physics.Arcade.World#event:overlap
	         */
	        this.onOverlap = false;
	
	        /**
	         * The Body's absolute maximum velocity, in pixels per second.
	         * This limits the Body's rate of movement but not its `velocity` values (which can still exceed `maxVelocity`).
	         *
	         * @name Phaser.Physics.Arcade.Body#maxVelocity
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.maxVelocity = new Vector2(10000, 10000);
	
	        /**
	         * If this Body is `immovable` and in motion, this the proportion of this Body's movement received by the riding body on each axis, relative to 1.
	         * The default value (1, 0) moves the riding body horizontally in equal proportion and vertically not at all.
	         *
	         * @name Phaser.Physics.Arcade.Body#friction
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.friction = new Vector2(1, 0);
	
	        /**
	         * The rate of change of this Body's rotation, in degrees per second.
	         *
	         * @name Phaser.Physics.Arcade.Body#angularVelocity
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.angularVelocity = 0;
	
	        /**
	         * The rate of change of this Body's angular velocity, in degrees per second squared.
	         *
	         * @name Phaser.Physics.Arcade.Body#angularAcceleration
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.angularAcceleration = 0;
	
	        /**
	         * Loss of angular velocity due to angular movement, in degrees per second.
	         *
	         * @name Phaser.Physics.Arcade.Body#angularDrag
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.angularDrag = 0;
	
	        /**
	         * The Body's maximum angular velocity, in degrees per second.
	         *
	         * @name Phaser.Physics.Arcade.Body#maxAngular
	         * @type {number}
	         * @default 1000
	         * @since 3.0.0
	         */
	        this.maxAngular = 1000;
	
	        /**
	         * The Body's inertia, relative to a default unit (1).
	         * With `bounce`, this affects the exchange of momentum (velocities) during collisions.
	         *
	         * @name Phaser.Physics.Arcade.Body#mass
	         * @type {number}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.mass = 1;
	
	        /**
	         * The angle of this Body's velocity vector, in degrees.
	         *
	         * @name Phaser.Physics.Arcade.Body#angle
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.angle = 0;
	
	        /**
	         * The magnitude of the Body's velocity, as calculated during the last update.
	         *
	         * @name Phaser.Physics.Arcade.Body#speed
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.speed = 0;
	
	        /**
	         * The calculated direction of the Body's velocity.
	         *
	         * @name Phaser.Physics.Arcade.Body#facing
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.facing = CONST.FACING_NONE;
	
	        /**
	         * Whether this object can be moved by collisions with another body.
	         *
	         * @name Phaser.Physics.Arcade.Body#immovable
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.immovable = false;
	
	        /**
	         * Whether the Body's position and rotation are affected by its velocity, acceleration, drag, and gravity.
	         *
	         * @name Phaser.Physics.Arcade.Body#moves
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.moves = true;
	
	        /**
	         * A flag disabling the default horizontal separation of colliding bodies. Pass your own `processHandler` to the collider.
	         *
	         * @name Phaser.Physics.Arcade.Body#customSeparateX
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.customSeparateX = false;
	
	        /**
	         * A flag disabling the default vertical separation of colliding bodies. Pass your own `processHandler` to the collider.
	         *
	         * @name Phaser.Physics.Arcade.Body#customSeparateY
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.customSeparateY = false;
	
	        /**
	         * The amount of horizontal overlap (before separation), if this Body is colliding with another.
	         *
	         * @name Phaser.Physics.Arcade.Body#overlapX
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.overlapX = 0;
	
	        /**
	         * The amount of vertical overlap (before separation), if this Body is colliding with another.
	         *
	         * @name Phaser.Physics.Arcade.Body#overlapY
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.overlapY = 0;
	
	        /**
	         * The amount of overlap (before separation), if this Body is circular and colliding with another circular body.
	         *
	         * @name Phaser.Physics.Arcade.Body#overlapR
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.overlapR = 0;
	
	        /**
	         * Whether this Body is overlapped with another and both have zero velocity.
	         *
	         * @name Phaser.Physics.Arcade.Body#embedded
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.embedded = false;
	
	        /**
	         * Whether this Body interacts with the world boundary.
	         *
	         * @name Phaser.Physics.Arcade.Body#collideWorldBounds
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.collideWorldBounds = false;
	
	        /**
	         * Whether this Body is checked for collisions and for which directions.
	         * You can set `checkCollision.none = false` to disable collision checks.
	         *
	         * @name Phaser.Physics.Arcade.Body#checkCollision
	         * @type {ArcadeBodyCollision}
	         * @since 3.0.0
	         */
	        this.checkCollision = { none: false, up: true, down: true, left: true, right: true };
	
	        /**
	         * Whether this Body is colliding with another and in which direction.
	         *
	         * @name Phaser.Physics.Arcade.Body#touching
	         * @type {ArcadeBodyCollision}
	         * @since 3.0.0
	         */
	        this.touching = { none: true, up: false, down: false, left: false, right: false };
	
	        /**
	         * Whether this Body was colliding with another during the last step, and in which direction.
	         *
	         * @name Phaser.Physics.Arcade.Body#wasTouching
	         * @type {ArcadeBodyCollision}
	         * @since 3.0.0
	         */
	        this.wasTouching = { none: true, up: false, down: false, left: false, right: false };
	
	        /**
	         * Whether this Body is colliding with a tile or the world boundary.
	         *
	         * @name Phaser.Physics.Arcade.Body#blocked
	         * @type {ArcadeBodyCollision}
	         * @since 3.0.0
	         */
	        this.blocked = { none: true, up: false, down: false, left: false, right: false };
	
	        /**
	         * Whether this Body is in its `update` phase.
	         *
	         * @name Phaser.Physics.Arcade.Body#dirty
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.dirty = false;
	
	        /**
	         * Whether to automatically synchronize this Body's dimensions to the dimensions of its Game Object's visual bounds.
	         *
	         * @name Phaser.Physics.Arcade.Body#syncBounds
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         * @see Phaser.GameObjects.Components.GetBounds#getBounds
	         */
	        this.syncBounds = false;
	
	        /**
	         * Whether this Body is being moved by the `moveTo` or `moveFrom` methods.
	         *
	         * @name Phaser.Physics.Arcade.Body#isMoving
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.isMoving = false;
	
	        /**
	         * Whether this Body's movement by `moveTo` or `moveFrom` will be stopped by collisions with other bodies.
	         *
	         * @name Phaser.Physics.Arcade.Body#stopVelocityOnCollide
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.stopVelocityOnCollide = true;
	
	        //  read-only
	
	        /**
	         * The Body's physics type (dynamic or static).
	         *
	         * @name Phaser.Physics.Arcade.Body#physicsType
	         * @type {integer}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.physicsType = CONST.DYNAMIC_BODY;
	
	        /**
	         * Whether the Body's position needs updating from its Game Object.
	         *
	         * @name Phaser.Physics.Arcade.Body#_reset
	         * @type {boolean}
	         * @private
	         * @default true
	         * @since 3.0.0
	         */
	        this._reset = true;
	
	        /**
	         * Cached horizontal scale of the Body's Game Object.
	         *
	         * @name Phaser.Physics.Arcade.Body#_sx
	         * @type {number}
	         * @private
	         * @since 3.0.0
	         */
	        this._sx = gameObject.scaleX;
	
	        /**
	         * Cached vertical scale of the Body's Game Object.
	         *
	         * @name Phaser.Physics.Arcade.Body#_sy
	         * @type {number}
	         * @private
	         * @since 3.0.0
	         */
	        this._sy = gameObject.scaleY;
	
	        /**
	         * The calculated change in the Body's horizontal position during the current step.
	         *
	         * @name Phaser.Physics.Arcade.Body#_dx
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._dx = 0;
	
	        /**
	         * The calculated change in the Body's vertical position during the current step.
	         *
	         * @name Phaser.Physics.Arcade.Body#_dy
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._dy = 0;
	
	        /**
	         * Stores the Game Object's bounds.
	         *
	         * @name Phaser.Physics.Arcade.Body#_bounds
	         * @type {Phaser.Geom.Rectangle}
	         * @private
	         * @since 3.0.0
	         */
	        this._bounds = new Rectangle();
	
	        this._tempMatrix = new TransformMatrix();
	    },
	
	    /**
	     * Updates this Body's transform, dimensions, and position from its Game Object.
	     *
	     * @method Phaser.Physics.Arcade.Body#updateBounds
	     * @since 3.0.0
	     */
	    updateBounds: function ()
	    {
	        var sprite = this.gameObject;
	
	        //  Container?
	
	        var transform = this.transform;
	
	        if (sprite.parentContainer)
	        {
	            var matrix = sprite.getWorldTransformMatrix(this._tempMatrix);
	
	            transform.x = matrix.tx;
	            transform.y = matrix.ty;
	            transform.rotation = RadToDeg(matrix.rotation);
	            transform.scaleX = matrix.scaleX;
	            transform.scaleY = matrix.scaleY;
	        }
	        else
	        {
	            transform.x = sprite.x;
	            transform.y = sprite.y;
	            transform.rotation = sprite.angle;
	            transform.scaleX = sprite.scaleX;
	            transform.scaleY = sprite.scaleY;
	        }
	
	        if (this.syncBounds)
	        {
	            var b = sprite.getBounds(this._bounds);
	
	            if (b.width !== this.width || b.height !== this.height)
	            {
	                this.width = b.width;
	                this.height = b.height;
	                this._reset = true;
	            }
	        }
	        else
	        {
	            var asx = Math.abs(transform.scaleX);
	            var asy = Math.abs(transform.scaleY);
	
	            if (asx !== this._sx || asy !== this._sy)
	            {
	                this.width = this.sourceWidth * asx;
	                this.height = this.sourceHeight * asy;
	                this._sx = asx;
	                this._sy = asy;
	                this._reset = true;
	            }
	        }
	
	        if (this._reset)
	        {
	            this.halfWidth = Math.floor(this.width / 2);
	            this.halfHeight = Math.floor(this.height / 2);
	            this.updateCenter();
	        }
	    },
	
	    /**
	     * Updates the Body's `center` from its `position` and dimensions.
	     *
	     * @method Phaser.Physics.Arcade.Body#updateCenter
	     * @since 3.0.0
	     */
	    updateCenter: function ()
	    {
	        this.center.set(this.position.x + this.halfWidth, this.position.y + this.halfHeight);
	    },
	
	    /**
	     * Updates the Body.
	     *
	     * @method Phaser.Physics.Arcade.Body#update
	     * @fires Phaser.Physics.Arcade.World#worldbounds
	     * @since 3.0.0
	     *
	     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
	     */
	    update: function (delta)
	    {
	        this.dirty = true;
	
	        //  Store and reset collision flags
	        this.wasTouching.none = this.touching.none;
	        this.wasTouching.up = this.touching.up;
	        this.wasTouching.down = this.touching.down;
	        this.wasTouching.left = this.touching.left;
	        this.wasTouching.right = this.touching.right;
	
	        this.touching.none = true;
	        this.touching.up = false;
	        this.touching.down = false;
	        this.touching.left = false;
	        this.touching.right = false;
	
	        this.blocked.none = true;
	        this.blocked.up = false;
	        this.blocked.down = false;
	        this.blocked.left = false;
	        this.blocked.right = false;
	
	        this.overlapR = 0;
	        this.overlapX = 0;
	        this.overlapY = 0;
	
	        this.embedded = false;
	
	        //  Updates the transform values
	        this.updateBounds();
	
	        var sprite = this.transform;
	
	        this.position.x = sprite.x + sprite.scaleX * (this.offset.x - sprite.displayOriginX);
	        this.position.y = sprite.y + sprite.scaleY * (this.offset.y - sprite.displayOriginY);
	
	        this.updateCenter();
	
	        this.rotation = sprite.rotation;
	
	        this.preRotation = this.rotation;
	
	        if (this._reset)
	        {
	            this.prev.x = this.position.x;
	            this.prev.y = this.position.y;
	        }
	
	        if (this.moves)
	        {
	            this.world.updateMotion(this);
	
	            this.newVelocity.set(this.velocity.x * delta, this.velocity.y * delta);
	
	            this.position.x += this.newVelocity.x;
	            this.position.y += this.newVelocity.y;
	
	            this.updateCenter();
	
	            if (this.position.x !== this.prev.x || this.position.y !== this.prev.y)
	            {
	                this.angle = Math.atan2(this.velocity.y, this.velocity.x);
	            }
	
	            this.speed = Math.sqrt(this.velocity.x * this.velocity.x + this.velocity.y * this.velocity.y);
	
	            //  Now the State update will throw collision checks at the Body
	            //  And finally we'll integrate the new position back to the Sprite in postUpdate
	
	            if (this.collideWorldBounds && this.checkWorldBounds() && this.onWorldBounds)
	            {
	                this.world.emit('worldbounds', this, this.blocked.up, this.blocked.down, this.blocked.left, this.blocked.right);
	            }
	        }
	
	        this._dx = this.deltaX();
	        this._dy = this.deltaY();
	
	        this._reset = false;
	    },
	
	    /**
	     * Feeds the Body results back into the parent Game Object.
	     *
	     * @method Phaser.Physics.Arcade.Body#postUpdate
	     * @since 3.0.0
	     */
	    postUpdate: function ()
	    {
	        //  Only allow postUpdate to be called once per frame
	        if (!this.enable || !this.dirty)
	        {
	            return;
	        }
	
	        this.dirty = false;
	
	        this._dx = this.deltaX();
	        this._dy = this.deltaY();
	
	        if (this._dx < 0)
	        {
	            this.facing = CONST.FACING_LEFT;
	        }
	        else if (this._dx > 0)
	        {
	            this.facing = CONST.FACING_RIGHT;
	        }
	
	        if (this._dy < 0)
	        {
	            this.facing = CONST.FACING_UP;
	        }
	        else if (this._dy > 0)
	        {
	            this.facing = CONST.FACING_DOWN;
	        }
	
	        if (this.moves)
	        {
	            if (this.deltaMax.x !== 0 && this._dx !== 0)
	            {
	                if (this._dx < 0 && this._dx < -this.deltaMax.x)
	                {
	                    this._dx = -this.deltaMax.x;
	                }
	                else if (this._dx > 0 && this._dx > this.deltaMax.x)
	                {
	                    this._dx = this.deltaMax.x;
	                }
	            }
	
	            if (this.deltaMax.y !== 0 && this._dy !== 0)
	            {
	                if (this._dy < 0 && this._dy < -this.deltaMax.y)
	                {
	                    this._dy = -this.deltaMax.y;
	                }
	                else if (this._dy > 0 && this._dy > this.deltaMax.y)
	                {
	                    this._dy = this.deltaMax.y;
	                }
	            }
	
	            // this.transform.x += this._dx;
	            // this.transform.y += this._dy;
	
	            this.gameObject.x += this._dx;
	            this.gameObject.y += this._dy;
	
	            this._reset = true;
	        }
	
	        this.updateCenter();
	
	        if (this.allowRotation)
	        {
	            this.gameObject.angle += this.deltaZ();
	        }
	
	        this.prev.x = this.position.x;
	        this.prev.y = this.position.y;
	    },
	
	    /**
	     * Checks for collisions between this Body and the world boundary and separates them.
	     *
	     * @method Phaser.Physics.Arcade.Body#checkWorldBounds
	     * @since 3.0.0
	     *
	     * @return {boolean} True if this Body is colliding with the world boundary.
	     */
	    checkWorldBounds: function ()
	    {
	        var pos = this.position;
	        var bounds = this.world.bounds;
	        var check = this.world.checkCollision;
	
	        var bx = (this.worldBounce) ? -this.worldBounce.x : -this.bounce.x;
	        var by = (this.worldBounce) ? -this.worldBounce.y : -this.bounce.y;
	
	        if (pos.x < bounds.x && check.left)
	        {
	            pos.x = bounds.x;
	            this.velocity.x *= bx;
	            this.blocked.left = true;
	            this.blocked.none = false;
	        }
	        else if (this.right > bounds.right && check.right)
	        {
	            pos.x = bounds.right - this.width;
	            this.velocity.x *= bx;
	            this.blocked.right = true;
	            this.blocked.none = false;
	        }
	
	        if (pos.y < bounds.y && check.up)
	        {
	            pos.y = bounds.y;
	            this.velocity.y *= by;
	            this.blocked.up = true;
	            this.blocked.none = false;
	        }
	        else if (this.bottom > bounds.bottom && check.down)
	        {
	            pos.y = bounds.bottom - this.height;
	            this.velocity.y *= by;
	            this.blocked.down = true;
	            this.blocked.none = false;
	        }
	
	        return !this.blocked.none;
	    },
	
	    /**
	     * Sets the offset of the Body's position from its Game Object's position.
	     *
	     * @method Phaser.Physics.Arcade.Body#setOffset
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal offset, in source pixels.
	     * @param {number} [y=x] - The vertical offset, in source pixels.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setOffset: function (x, y)
	    {
	        if (y === undefined) { y = x; }
	
	        this.offset.set(x, y);
	
	        return this;
	    },
	
	    /**
	     * Sizes and positions this Body's boundary, as a rectangle.
	     * Modifies the Body's `offset` if `center` is true (the default).
	     *
	     * @method Phaser.Physics.Arcade.Body#setSize
	     * @since 3.0.0
	     *
	     * @param {number} width - The width of the Body, in source pixels.
	     * @param {number} height - The height of the Body, in source pixels.
	     * @param {boolean} [center=true] - Modify the Body's `offset`, placing the Body's center on its Game Object's center.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setSize: function (width, height, center)
	    {
	        if (center === undefined) { center = true; }
	
	        var gameObject = this.gameObject;
	
	        this.sourceWidth = width;
	        this.sourceHeight = height;
	
	        this.width = this.sourceWidth * this._sx;
	        this.height = this.sourceHeight * this._sy;
	
	        this.halfWidth = Math.floor(this.width / 2);
	        this.halfHeight = Math.floor(this.height / 2);
	
	        this.updateCenter();
	
	        if (center && gameObject.getCenter)
	        {
	            var ox = gameObject.displayWidth / 2;
	            var oy = gameObject.displayHeight / 2;
	
	            this.offset.set(ox - this.halfWidth, oy - this.halfHeight);
	        }
	
	        this.isCircle = false;
	        this.radius = 0;
	
	        return this;
	    },
	
	    /**
	     * Sizes and positions this Body's boundary, as a circle.
	     *
	     * @method Phaser.Physics.Arcade.Body#setCircle
	     * @since 3.0.0
	     *
	     * @param {number} radius - The radius of the Body, in source pixels.
	     * @param {number} [offsetX] - The horizontal offset of the Body from its Game Object, in source pixels.
	     * @param {number} [offsetY] - The vertical offset of the Body from its Game Object, in source pixels.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setCircle: function (radius, offsetX, offsetY)
	    {
	        if (offsetX === undefined) { offsetX = this.offset.x; }
	        if (offsetY === undefined) { offsetY = this.offset.y; }
	
	        if (radius > 0)
	        {
	            this.isCircle = true;
	            this.radius = radius;
	
	            this.sourceWidth = radius * 2;
	            this.sourceHeight = radius * 2;
	
	            this.width = this.sourceWidth * this._sx;
	            this.height = this.sourceHeight * this._sy;
	
	            this.halfWidth = Math.floor(this.width / 2);
	            this.halfHeight = Math.floor(this.height / 2);
	
	            this.offset.set(offsetX, offsetY);
	
	            this.updateCenter();
	        }
	        else
	        {
	            this.isCircle = false;
	        }
	
	        return this;
	    },
	
	    /**
	     * Resets this Body to the given coordinates. Also positions its parent Game Object to the same coordinates.
	     * If the Body had any velocity or acceleration it is lost as a result of calling this.
	     *
	     * @method Phaser.Physics.Arcade.Body#reset
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal position to place the Game Object and Body.
	     * @param {number} y - The vertical position to place the Game Object and Body.
	     */
	    reset: function (x, y)
	    {
	        this.stop();
	
	        var gameObject = this.gameObject;
	
	        gameObject.setPosition(x, y);
	
	        gameObject.getTopLeft(this.position);
	
	        this.prev.copy(this.position);
	
	        this.rotation = gameObject.angle;
	        this.preRotation = gameObject.angle;
	
	        this.updateBounds();
	        this.updateCenter();
	    },
	
	    /**
	     * Sets acceleration, velocity, and speed to zero.
	     *
	     * @method Phaser.Physics.Arcade.Body#stop
	     * @since 3.0.0
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    stop: function ()
	    {
	        this.velocity.set(0);
	        this.acceleration.set(0);
	        this.speed = 0;
	        this.angularVelocity = 0;
	        this.angularAcceleration = 0;
	
	        return this;
	    },
	
	    /**
	     * Copies the coordinates of this Body's edges into an object.
	     *
	     * @method Phaser.Physics.Arcade.Body#getBounds
	     * @since 3.0.0
	     *
	     * @param {ArcadeBodyBounds} obj - An object to copy the values into.
	     *
	     * @return {ArcadeBodyBounds} - An object with {x, y, right, bottom}.
	     */
	    getBounds: function (obj)
	    {
	        obj.x = this.x;
	        obj.y = this.y;
	        obj.right = this.right;
	        obj.bottom = this.bottom;
	
	        return obj;
	    },
	
	    /**
	     * Tests if the coordinates are within this Body's boundary.
	     *
	     * @method Phaser.Physics.Arcade.Body#hitTest
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal coordinate.
	     * @param {number} y - The vertical coordinate.
	     *
	     * @return {boolean} True if (x, y) is within this Body.
	     */
	    hitTest: function (x, y)
	    {
	        return (this.isCircle) ? CircleContains(this, x, y) : RectangleContains(this, x, y);
	    },
	
	    /**
	     * Whether this Body is touching a tile or the world boundary while moving down.
	     *
	     * @method Phaser.Physics.Arcade.Body#onFloor
	     * @since 3.0.0
	     * @see Phaser.Physics.Arcade.Body#blocked
	     *
	     * @return {boolean} True if touching.
	     */
	    onFloor: function ()
	    {
	        return this.blocked.down;
	    },
	
	    /**
	     * Whether this Body is touching a tile or the world boundary while moving up.
	     *
	     * @method Phaser.Physics.Arcade.Body#onCeiling
	     * @since 3.0.0
	     * @see Phaser.Physics.Arcade.Body#blocked
	     *
	     * @return {boolean} True if touching.
	     */
	    onCeiling: function ()
	    {
	        return this.blocked.up;
	    },
	
	    /**
	     * Whether this Body is touching a tile or the world boundary while moving left or right.
	     *
	     * @method Phaser.Physics.Arcade.Body#onWall
	     * @since 3.0.0
	     * @see Phaser.Physics.Arcade.Body#blocked
	     *
	     * @return {boolean} True if touching.
	     */
	    onWall: function ()
	    {
	        return (this.blocked.left || this.blocked.right);
	    },
	
	    /**
	     * The absolute (nonnegative) change in this Body's horizontal position from the previous step.
	     * This value is set only during the Body's `dirty` (update) phase.
	     *
	     * @method Phaser.Physics.Arcade.Body#deltaAbsX
	     * @since 3.0.0
	     *
	     * @return {number} The delta value.
	     */
	    deltaAbsX: function ()
	    {
	        return (this.deltaX() > 0) ? this.deltaX() : -this.deltaX();
	    },
	
	    /**
	     * The absolute (nonnegative) change in this Body's horizontal position from the previous step.
	     * This value is set only during the Body's `dirty` (update) phase.
	     *
	     * @method Phaser.Physics.Arcade.Body#deltaAbsY
	     * @since 3.0.0
	     *
	     * @return {number} The delta value.
	     */
	    deltaAbsY: function ()
	    {
	        return (this.deltaY() > 0) ? this.deltaY() : -this.deltaY();
	    },
	
	    /**
	     * The change in this Body's horizontal position from the previous step.
	     * This value is set only during the Body's `dirty` (update) phase.
	     *
	     * @method Phaser.Physics.Arcade.Body#deltaX
	     * @since 3.0.0
	     *
	     * @return {number} The delta value.
	     */
	    deltaX: function ()
	    {
	        return this.position.x - this.prev.x;
	    },
	
	    /**
	     * The change in this Body's vertical position from the previous step.
	     *
	     * @method Phaser.Physics.Arcade.Body#deltaY
	     * @since 3.0.0
	     *
	     * @return {number} The delta value.
	     */
	    deltaY: function ()
	    {
	        return this.position.y - this.prev.y;
	    },
	
	    /**
	     * The change in this Body's rotation from the previous step, in degrees.
	     *
	     * @method Phaser.Physics.Arcade.Body#deltaZ
	     * @since 3.0.0
	     *
	     * @return {number} The delta value.
	     */
	    deltaZ: function ()
	    {
	        return this.rotation - this.preRotation;
	    },
	
	    /**
	     * Disables this Body and marks it for deletion by the simulation.
	     *
	     * @method Phaser.Physics.Arcade.Body#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.enable = false;
	
	        this.world.pendingDestroy.set(this);
	    },
	
	    /**
	     * Draws this Body's boundary and velocity, if enabled.
	     *
	     * @method Phaser.Physics.Arcade.Body#drawDebug
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Graphics} graphic - The Graphics object to draw on.
	     */
	    drawDebug: function (graphic)
	    {
	        var pos = this.position;
	        var x = pos.x + this.halfWidth;
	        var y = pos.y + this.halfHeight;
	
	        if (this.debugShowBody)
	        {
	            graphic.lineStyle(1, this.debugBodyColor);
	
	            if (this.isCircle)
	            {
	                graphic.strokeCircle(x, y, this.width / 2);
	            }
	            else
	            {
	                graphic.strokeRect(pos.x, pos.y, this.width, this.height);
	            }
	        }
	
	        if (this.debugShowVelocity)
	        {
	            graphic.lineStyle(1, this.world.defaults.velocityDebugColor, 1);
	            graphic.lineBetween(x, y, x + this.velocity.x / 2, y + this.velocity.y / 2);
	        }
	    },
	
	    /**
	     * Whether this Body will be drawn to the debug display.
	     *
	     * @method Phaser.Physics.Arcade.Body#willDrawDebug
	     * @since 3.0.0
	     *
	     * @return {boolean} True if either `debugShowBody` or `debugShowVelocity` are enabled.
	     */
	    willDrawDebug: function ()
	    {
	        return (this.debugShowBody || this.debugShowVelocity);
	    },
	
	    /**
	     * Sets whether this Body collides with the world boundary.
	     *
	     * @method Phaser.Physics.Arcade.Body#setCollideWorldBounds
	     * @since 3.0.0
	     *
	     * @param {boolean} value - True (collisions) or false (no collisions).
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setCollideWorldBounds: function (value)
	    {
	        this.collideWorldBounds = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's velocity.
	     *
	     * @method Phaser.Physics.Arcade.Body#setVelocity
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal velocity, in pixels per second.
	     * @param {number} y - The vertical velocity, in pixels per second.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setVelocity: function (x, y)
	    {
	        this.velocity.set(x, y);
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's horizontal velocity.
	     *
	     * @method Phaser.Physics.Arcade.Body#setVelocityX
	     * @since 3.0.0
	     *
	     * @param {number} value - The velocity, in pixels per second.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setVelocityX: function (value)
	    {
	        this.velocity.x = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's vertical velocity.
	     *
	     * @method Phaser.Physics.Arcade.Body#setVelocityY
	     * @since 3.0.0
	     *
	     * @param {number} value - The velocity, in pixels per second.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setVelocityY: function (value)
	    {
	        this.velocity.y = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's bounce.
	     *
	     * @method Phaser.Physics.Arcade.Body#setBounce
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal bounce, relative to 1.
	     * @param {number} y - The vertical bounce, relative to 1.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setBounce: function (x, y)
	    {
	        this.bounce.set(x, y);
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's horizontal bounce.
	     *
	     * @method Phaser.Physics.Arcade.Body#setBounceX
	     * @since 3.0.0
	     *
	     * @param {number} value - The bounce, relative to 1.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setBounceX: function (value)
	    {
	        this.bounce.x = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's vertical bounce.
	     *
	     * @method Phaser.Physics.Arcade.Body#setBounceY
	     * @since 3.0.0
	     *
	     * @param {number} value - The bounce, relative to 1.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setBounceY: function (value)
	    {
	        this.bounce.y = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's acceleration.
	     *
	     * @method Phaser.Physics.Arcade.Body#setAcceleration
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal component, in pixels per second squared.
	     * @param {number} y - The vertical component, in pixels per second squared.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setAcceleration: function (x, y)
	    {
	        this.acceleration.set(x, y);
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's horizontal acceleration.
	     *
	     * @method Phaser.Physics.Arcade.Body#setAccelerationX
	     * @since 3.0.0
	     *
	     * @param {number} value - The acceleration, in pixels per second squared.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setAccelerationX: function (value)
	    {
	        this.acceleration.x = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's vertical acceleration.
	     *
	     * @method Phaser.Physics.Arcade.Body#setAccelerationY
	     * @since 3.0.0
	     *
	     * @param {number} value - The acceleration, in pixels per second squared.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setAccelerationY: function (value)
	    {
	        this.acceleration.y = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's drag.
	     *
	     * @method Phaser.Physics.Arcade.Body#setDrag
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal component, in pixels per second squared.
	     * @param {number} y - The vertical component, in pixels per second squared.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setDrag: function (x, y)
	    {
	        this.drag.set(x, y);
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's horizontal drag.
	     *
	     * @method Phaser.Physics.Arcade.Body#setDragX
	     * @since 3.0.0
	     *
	     * @param {number} value - The drag, in pixels per second squared.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setDragX: function (value)
	    {
	        this.drag.x = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's vertical drag.
	     *
	     * @method Phaser.Physics.Arcade.Body#setDragY
	     * @since 3.0.0
	     *
	     * @param {number} value - The drag, in pixels per second squared.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setDragY: function (value)
	    {
	        this.drag.y = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's gravity.
	     *
	     * @method Phaser.Physics.Arcade.Body#setGravity
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal component, in pixels per second squared.
	     * @param {number} y - The vertical component, in pixels per second squared.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setGravity: function (x, y)
	    {
	        this.gravity.set(x, y);
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's horizontal gravity.
	     *
	     * @method Phaser.Physics.Arcade.Body#setGravityX
	     * @since 3.0.0
	     *
	     * @param {number} value - The gravity, in pixels per second squared.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setGravityX: function (value)
	    {
	        this.gravity.x = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's vertical gravity.
	     *
	     * @method Phaser.Physics.Arcade.Body#setGravityY
	     * @since 3.0.0
	     *
	     * @param {number} value - The gravity, in pixels per second squared.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setGravityY: function (value)
	    {
	        this.gravity.y = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's friction.
	     *
	     * @method Phaser.Physics.Arcade.Body#setFriction
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal component, relative to 1.
	     * @param {number} y - The vertical component, relative to 1.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setFriction: function (x, y)
	    {
	        this.friction.set(x, y);
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's horizontal friction.
	     *
	     * @method Phaser.Physics.Arcade.Body#setFrictionX
	     * @since 3.0.0
	     *
	     * @param {number} value - The friction value, relative to 1.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setFrictionX: function (value)
	    {
	        this.friction.x = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's vertical friction.
	     *
	     * @method Phaser.Physics.Arcade.Body#setFrictionY
	     * @since 3.0.0
	     *
	     * @param {number} value - The friction value, relative to 1.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setFrictionY: function (value)
	    {
	        this.friction.y = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's angular velocity.
	     *
	     * @method Phaser.Physics.Arcade.Body#setAngularVelocity
	     * @since 3.0.0
	     *
	     * @param {number} value - The velocity, in degrees per second.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setAngularVelocity: function (value)
	    {
	        this.angularVelocity = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's angular acceleration.
	     *
	     * @method Phaser.Physics.Arcade.Body#setAngularAcceleration
	     * @since 3.0.0
	     *
	     * @param {number} value - The acceleration, in degrees per second squared.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setAngularAcceleration: function (value)
	    {
	        this.angularAcceleration = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's angular drag.
	     *
	     * @method Phaser.Physics.Arcade.Body#setAngularDrag
	     * @since 3.0.0
	     *
	     * @param {number} value - The drag, in degrees per second squared.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setAngularDrag: function (value)
	    {
	        this.angularDrag = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's mass.
	     *
	     * @method Phaser.Physics.Arcade.Body#setMass
	     * @since 3.0.0
	     *
	     * @param {number} value - The mass value, relative to 1.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setMass: function (value)
	    {
	        this.mass = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the Body's `immovable` property.
	     *
	     * @method Phaser.Physics.Arcade.Body#setImmovable
	     * @since 3.0.0
	     *
	     * @param {boolean} value - The value to assign to `immovable`.
	     *
	     * @return {Phaser.Physics.Arcade.Body} This Body object.
	     */
	    setImmovable: function (value)
	    {
	        this.immovable = value;
	
	        return this;
	    },
	
	    /**
	     * The Body's horizontal position (left edge).
	     *
	     * @name Phaser.Physics.Arcade.Body#x
	     * @type {number}
	     * @since 3.0.0
	     */
	    x: {
	
	        get: function ()
	        {
	            return this.position.x;
	        },
	
	        set: function (value)
	        {
	            this.position.x = value;
	        }
	
	    },
	
	    /**
	     * The Body's vertical position (top edge).
	     *
	     * @name Phaser.Physics.Arcade.Body#y
	     * @type {number}
	     * @since 3.0.0
	     */
	    y: {
	
	        get: function ()
	        {
	            return this.position.y;
	        },
	
	        set: function (value)
	        {
	            this.position.y = value;
	        }
	
	    },
	
	    /**
	     * The left edge of the Body's boundary. Identical to x.
	     *
	     * @name Phaser.Physics.Arcade.Body#left
	     * @type {number}
	     * @readOnly
	     * @since 3.0.0
	     */
	    left: {
	
	        get: function ()
	        {
	            return this.position.x;
	        }
	
	    },
	
	    /**
	     * The right edge of the Body's boundary.
	     *
	     * @name Phaser.Physics.Arcade.Body#right
	     * @type {number}
	     * @readOnly
	     * @since 3.0.0
	     */
	    right: {
	
	        get: function ()
	        {
	            return this.position.x + this.width;
	        }
	
	    },
	
	    /**
	     * The top edge of the Body's boundary. Identical to y.
	     *
	     * @name Phaser.Physics.Arcade.Body#top
	     * @type {number}
	     * @readOnly
	     * @since 3.0.0
	     */
	    top: {
	
	        get: function ()
	        {
	            return this.position.y;
	        }
	
	    },
	
	    /**
	     * The bottom edge of this Body's boundary.
	     *
	     * @name Phaser.Physics.Arcade.Body#bottom
	     * @type {number}
	     * @readOnly
	     * @since 3.0.0
	     */
	    bottom: {
	
	        get: function ()
	        {
	            return this.position.y + this.height;
	        }
	
	    }
	
	});
	
	module.exports = Body;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class Collider
	 * @memberOf Phaser.Physics.Arcade
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Physics.Arcade.World} world - [description]
	 * @param {boolean} overlapOnly - [description]
	 * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} object1 - The first object to check for collision.
	 * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} object2 - The second object to check for collision.
	 * @param {ArcadePhysicsCallback} collideCallback - The callback to invoke when the two objects collide.
	 * @param {ArcadePhysicsCallback} processCallback - The callback to invoke when the two objects collide. Must return a boolean.
	 * @param {object} callbackContext - The scope in which to call the callbacks.
	 */
	var Collider = new Class({
	
	    initialize:
	
	    function Collider (world, overlapOnly, object1, object2, collideCallback, processCallback, callbackContext)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.Collider#world
	         * @type {Phaser.Physics.Arcade.World}
	         * @since 3.0.0
	         */
	        this.world = world;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.Collider#name
	         * @type {string}
	         * @since 3.1.0
	         */
	        this.name = '';
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.Collider#active
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.active = true;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.Collider#overlapOnly
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.overlapOnly = overlapOnly;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.Collider#object1
	         * @type {Phaser.Physics.Arcade.Body}
	         * @since 3.0.0
	         */
	        this.object1 = object1;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.Collider#object2
	         * @type {Phaser.Physics.Arcade.Body}
	         * @since 3.0.0
	         */
	        this.object2 = object2;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.Collider#collideCallback
	         * @type {ArcadePhysicsCallback}
	         * @since 3.0.0
	         */
	        this.collideCallback = collideCallback;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.Collider#processCallback
	         * @type {ArcadePhysicsCallback}
	         * @since 3.0.0
	         */
	        this.processCallback = processCallback;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.Collider#callbackContext
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.callbackContext = callbackContext;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Collider#setName
	     * @since 3.1.0
	     *
	     * @param {string} name - [description]
	     *
	     * @return {Phaser.Physics.Arcade.Collider} [description]
	     */
	    setName: function (name)
	    {
	        this.name = name;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Collider#update
	     * @since 3.0.0
	     */
	    update: function ()
	    {
	        this.world.collideObjects(
	            this.object1,
	            this.object2,
	            this.collideCallback,
	            this.processCallback,
	            this.callbackContext,
	            this.overlapOnly
	        );
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Collider#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.world.removeCollider(this);
	
	        this.active = false;
	
	        this.world = null;
	
	        this.object1 = null;
	        this.object2 = null;
	
	        this.collideCallback = null;
	        this.processCallback = null;
	        this.callbackContext = null;
	    }
	
	});
	
	module.exports = Collider;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var ArcadeImage = __webpack_require__(580);
	var ArcadeSprite = __webpack_require__(204);
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(117);
	var PhysicsGroup = __webpack_require__(586);
	var StaticPhysicsGroup = __webpack_require__(588);
	
	/**
	 * @classdesc
	 * The Arcade Physics Factory allows you to easily create Arcade Physics enabled Game Objects.
	 * Objects that are created by this Factory are automatically added to the physics world.
	 *
	 * @class Factory
	 * @memberOf Phaser.Physics.Arcade
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Physics.Arcade.World} world - The Arcade Physics World instance.
	 */
	var Factory = new Class({
	
	    initialize:
	
	    function Factory (world)
	    {
	        /**
	         * A reference to the Arcade Physics World.
	         *
	         * @name Phaser.Physics.Arcade.Factory#world
	         * @type {Phaser.Physics.Arcade.World}
	         * @since 3.0.0
	         */
	        this.world = world;
	
	        /**
	         * A reference to the Scene this Arcade Physics instance belongs to.
	         *
	         * @name Phaser.Physics.Arcade.Factory#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = world.scene;
	
	        /**
	         * A reference to the Scene.Systems this Arcade Physics instance belongs to.
	         *
	         * @name Phaser.Physics.Arcade.Factory#sys
	         * @type {Phaser.Scenes.Systems}
	         * @since 3.0.0
	         */
	        this.sys = world.scene.sys;
	    },
	
	    /**
	     * Create a new Arcade Physics Collider object.
	     *
	     * @method Phaser.Physics.Arcade.Factory#collider
	     * @since 3.0.0
	     *
	     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} object1 - The first object to check for collision.
	     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} object2 - The second object to check for collision.
	     * @param {ArcadePhysicsCallback} [collideCallback] - The callback to invoke when the two objects collide.
	     * @param {ArcadePhysicsCallback} [processCallback] - The callback to invoke when the two objects collide. Must return a boolean.
	     * @param {*} [callbackContext] - The scope in which to call the callbacks.
	     *
	     * @return {Phaser.Physics.Arcade.Collider} The Collider that was created.
	     */
	    collider: function (object1, object2, collideCallback, processCallback, callbackContext)
	    {
	        return this.world.addCollider(object1, object2, collideCallback, processCallback, callbackContext);
	    },
	
	    /**
	     * Create a new Arcade Physics Collider Overlap object.
	     *
	     * @method Phaser.Physics.Arcade.Factory#overlap
	     * @since 3.0.0
	     *
	     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} object1 - The first object to check for overlap.
	     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} object2 - The second object to check for overlap.
	     * @param {ArcadePhysicsCallback} [collideCallback] - The callback to invoke when the two objects collide.
	     * @param {ArcadePhysicsCallback} [processCallback] - The callback to invoke when the two objects collide. Must return a boolean.
	     * @param {*} [callbackContext] - The scope in which to call the callbacks.
	     *
	     * @return {Phaser.Physics.Arcade.Collider} The Collider that was created.
	     */
	    overlap: function (object1, object2, collideCallback, processCallback, callbackContext)
	    {
	        return this.world.addOverlap(object1, object2, collideCallback, processCallback, callbackContext);
	    },
	
	    /**
	     * Adds an Arcade Physics Body to the given Game Object.
	     *
	     * @method Phaser.Physics.Arcade.Factory#existing
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} gameObject - [description]
	     * @param {boolean} [isStatic=false] - Set to true to create a Static body, otherwise it will create a Dynamic body.
	     *
	     * @return {Phaser.GameObjects.GameObject} The Game Object.
	     */
	    existing: function (gameObject, isStatic)
	    {
	        var type = (isStatic) ? CONST.STATIC_BODY : CONST.DYNAMIC_BODY;
	
	        this.world.enableBody(gameObject, type);
	
	        return gameObject;
	    },
	
	    /**
	     * Creates a new Arcade Image object with a Static body.
	     *
	     * @method Phaser.Physics.Arcade.Factory#staticImage
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal position of this Game Object in the world.
	     * @param {number} y - The vertical position of this Game Object in the world.
	     * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	     * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	     *
	     * @return {Phaser.Physics.Arcade.Image} The Image object that was created.
	     */
	    staticImage: function (x, y, key, frame)
	    {
	        var image = new ArcadeImage(this.scene, x, y, key, frame);
	
	        this.sys.displayList.add(image);
	
	        this.world.enableBody(image, CONST.STATIC_BODY);
	
	        return image;
	    },
	
	    /**
	     * Creates a new Arcade Image object with a Dynamic body.
	     *
	     * @method Phaser.Physics.Arcade.Factory#image
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal position of this Game Object in the world.
	     * @param {number} y - The vertical position of this Game Object in the world.
	     * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	     * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	     *
	     * @return {Phaser.Physics.Arcade.Image} The Image object that was created.
	     */
	    image: function (x, y, key, frame)
	    {
	        var image = new ArcadeImage(this.scene, x, y, key, frame);
	
	        this.sys.displayList.add(image);
	
	        this.world.enableBody(image, CONST.DYNAMIC_BODY);
	
	        return image;
	    },
	
	    /**
	     * Creates a new Arcade Sprite object with a Static body.
	     *
	     * @method Phaser.Physics.Arcade.Factory#staticSprite
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal position of this Game Object in the world.
	     * @param {number} y - The vertical position of this Game Object in the world.
	     * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	     * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	     *
	     * @return {Phaser.Physics.Arcade.Sprite} The Sprite object that was created.
	     */
	    staticSprite: function (x, y, key, frame)
	    {
	        var sprite = new ArcadeSprite(this.scene, x, y, key, frame);
	
	        this.sys.displayList.add(sprite);
	        this.sys.updateList.add(sprite);
	
	        this.world.enableBody(sprite, CONST.STATIC_BODY);
	
	        return sprite;
	    },
	
	    /**
	     * Creates a new Arcade Sprite object with a Dynamic body.
	     *
	     * @method Phaser.Physics.Arcade.Factory#sprite
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal position of this Game Object in the world.
	     * @param {number} y - The vertical position of this Game Object in the world.
	     * @param {string} key - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	     * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	     *
	     * @return {Phaser.Physics.Arcade.Sprite} The Sprite object that was created.
	     */
	    sprite: function (x, y, key, frame)
	    {
	        var sprite = new ArcadeSprite(this.scene, x, y, key, frame);
	
	        this.sys.displayList.add(sprite);
	        this.sys.updateList.add(sprite);
	
	        this.world.enableBody(sprite, CONST.DYNAMIC_BODY);
	
	        return sprite;
	    },
	
	    /**
	     * Creates a Static Physics Group object.
	     * All Game Objects created by this Group will automatically be static Arcade Physics objects.
	     *
	     * @method Phaser.Physics.Arcade.Factory#staticGroup
	     * @since 3.0.0
	     *
	     * @param {array} [children] - [description]
	     * @param {GroupConfig} [config] - [description]
	     *
	     * @return {Phaser.Physics.Arcade.StaticGroup} The Static Group object that was created.
	     */
	    staticGroup: function (children, config)
	    {
	        return this.sys.updateList.add(new StaticPhysicsGroup(this.world, this.world.scene, children, config));
	    },
	
	    /**
	     * Creates a Physics Group object.
	     * All Game Objects created by this Group will automatically be dynamic Arcade Physics objects.
	     *
	     * @method Phaser.Physics.Arcade.Factory#group
	     * @since 3.0.0
	     *
	     * @param {array} [children] - [description]
	     * @param {PhysicsGroupConfig} [config] - [description]
	     *
	     * @return {Phaser.Physics.Arcade.Group} The Group object that was created.
	     */
	    group: function (children, config)
	    {
	        return this.sys.updateList.add(new PhysicsGroup(this.world, this.world.scene, children, config));
	    },
	
	    /**
	     * Destroys this Factory.
	     *
	     * @method Phaser.Physics.Arcade.Factory#destroy
	     * @since 3.5.0
	     */
	    destroy: function ()
	    {
	        this.world = null;
	        this.scene = null;
	        this.sys = null;
	    }
	
	});
	
	module.exports = Factory;


/***/ }),
/* 584 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Physics.Arcade.GetOverlapX
	 * @since 3.0.0
	 *
	 * @param {Phaser.Physics.Arcade.Body} body1 - [description]
	 * @param {Phaser.Physics.Arcade.Body} body2 - [description]
	 * @param {boolean} overlapOnly - [description]
	 * @param {number} bias - [description]
	 *
	 * @return {number} [description]
	 */
	var GetOverlapX = function (body1, body2, overlapOnly, bias)
	{
	    var overlap = 0;
	    var maxOverlap = body1.deltaAbsX() + body2.deltaAbsX() + bias;
	
	    if (body1.deltaX() === 0 && body2.deltaX() === 0)
	    {
	        //  They overlap but neither of them are moving
	        body1.embedded = true;
	        body2.embedded = true;
	    }
	    else if (body1.deltaX() > body2.deltaX())
	    {
	        //  Body1 is moving right and / or Body2 is moving left
	        overlap = body1.right - body2.x;
	
	        if ((overlap > maxOverlap && !overlapOnly) || body1.checkCollision.right === false || body2.checkCollision.left === false)
	        {
	            overlap = 0;
	        }
	        else
	        {
	            body1.touching.none = false;
	            body1.touching.right = true;
	            body2.touching.none = false;
	            body2.touching.left = true;
	        }
	    }
	    else if (body1.deltaX() < body2.deltaX())
	    {
	        //  Body1 is moving left and/or Body2 is moving right
	        overlap = body1.x - body2.width - body2.x;
	
	        if ((-overlap > maxOverlap && !overlapOnly) || body1.checkCollision.left === false || body2.checkCollision.right === false)
	        {
	            overlap = 0;
	        }
	        else
	        {
	            body1.touching.none = false;
	            body1.touching.left = true;
	            body2.touching.none = false;
	            body2.touching.right = true;
	        }
	    }
	
	    //  Resets the overlapX to zero if there is no overlap, or to the actual pixel value if there is
	    body1.overlapX = overlap;
	    body2.overlapX = overlap;
	
	    return overlap;
	};
	
	module.exports = GetOverlapX;


/***/ }),
/* 585 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Physics.Arcade.GetOverlapY
	 * @since 3.0.0
	 *
	 * @param {Phaser.Physics.Arcade.Body} body1 - [description]
	 * @param {Phaser.Physics.Arcade.Body} body2 - [description]
	 * @param {boolean} overlapOnly - [description]
	 * @param {number} bias - [description]
	 *
	 * @return {number} [description]
	 */
	var GetOverlapY = function (body1, body2, overlapOnly, bias)
	{
	    var overlap = 0;
	    var maxOverlap = body1.deltaAbsY() + body2.deltaAbsY() + bias;
	
	    if (body1.deltaY() === 0 && body2.deltaY() === 0)
	    {
	        //  They overlap but neither of them are moving
	        body1.embedded = true;
	        body2.embedded = true;
	    }
	    else if (body1.deltaY() > body2.deltaY())
	    {
	        //  Body1 is moving down and/or Body2 is moving up
	        overlap = body1.bottom - body2.y;
	
	        if ((overlap > maxOverlap && !overlapOnly) || body1.checkCollision.down === false || body2.checkCollision.up === false)
	        {
	            overlap = 0;
	        }
	        else
	        {
	            body1.touching.none = false;
	            body1.touching.down = true;
	            body2.touching.none = false;
	            body2.touching.up = true;
	        }
	    }
	    else if (body1.deltaY() < body2.deltaY())
	    {
	        //  Body1 is moving up and/or Body2 is moving down
	        overlap = body1.y - body2.bottom;
	
	        if ((-overlap > maxOverlap && !overlapOnly) || body1.checkCollision.up === false || body2.checkCollision.down === false)
	        {
	            overlap = 0;
	        }
	        else
	        {
	            body1.touching.none = false;
	            body1.touching.up = true;
	            body2.touching.none = false;
	            body2.touching.down = true;
	        }
	    }
	
	    //  Resets the overlapY to zero if there is no overlap, or to the actual pixel value if there is
	    body1.overlapY = overlap;
	    body2.overlapY = overlap;
	
	    return overlap;
	};
	
	module.exports = GetOverlapY;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var ArcadeSprite = __webpack_require__(204);
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(117);
	var GetFastValue = __webpack_require__(3);
	var Group = __webpack_require__(159);
	
	/**
	 * @typedef {object} PhysicsGroupConfig
	 * @extends GroupConfig
	 *
	 * @property {boolean} [collideWorldBounds=false] - Sets {@link Phaser.Physics.Arcade.Body#collideWorldBounds}.
	 * @property {number} [accelerationX=0] - Sets {@link Phaser.Physics.Arcade.Body#acceleration acceleration.x}.
	 * @property {number} [accelerationY=0] - Sets {@link Phaser.Physics.Arcade.Body#acceleration acceleration.y}.
	 * @property {number} [bounceX=0] - Sets {@link Phaser.Physics.Arcade.Body#bounce bounce.x}.
	 * @property {number} [bounceY=0] - Sets {@link Phaser.Physics.Arcade.Body#bounce bounce.y}.
	 * @property {number} [dragX=0] - Sets {@link Phaser.Physics.Arcade.Body#drag drag.x}.
	 * @property {number} [dragY=0] - Sets {@link Phaser.Physics.Arcade.Body#drag drag.y}.
	 * @property {number} [gravityX=0] - Sets {@link Phaser.Physics.Arcade.Body#gravity gravity.x}.
	 * @property {number} [gravityY=0] - Sets {@link Phaser.Physics.Arcade.Body#gravity gravity.y}.
	 * @property {number} [frictionX=0] - Sets {@link Phaser.Physics.Arcade.Body#friction friction.x}.
	 * @property {number} [frictionY=0] - Sets {@link Phaser.Physics.Arcade.Body#friction friction.y}.
	 * @property {number} [velocityX=0] - Sets {@link Phaser.Physics.Arcade.Body#velocity velocity.x}.
	 * @property {number} [velocityY=0] - Sets {@link Phaser.Physics.Arcade.Body#velocity velocity.y}.
	 * @property {number} [angularVelocity=0] - Sets {@link Phaser.Physics.Arcade.Body#angularVelocity}.
	 * @property {number} [angularAcceleration=0] - Sets {@link Phaser.Physics.Arcade.Body#angularAcceleration}.
	 * @property {number} [angularDrag=0] - Sets {@link Phaser.Physics.Arcade.Body#angularDrag}.
	 * @property {number} [mass=0] - Sets {@link Phaser.Physics.Arcade.Body#mass}.
	 * @property {boolean} [immovable=false] - Sets {@link Phaser.Physics.Arcade.Body#immovable}.
	 */
	
	/**
	 * @typedef {object} PhysicsGroupDefaults
	 *
	 * @property {boolean} setCollideWorldBounds - [description]
	 * @property {number} setAccelerationX - [description]
	 * @property {number} setAccelerationY - [description]
	 * @property {number} setBounceX - [description]
	 * @property {number} setBounceY - [description]
	 * @property {number} setDragX - [description]
	 * @property {number} setDragY - [description]
	 * @property {number} setGravityX - [description]
	 * @property {number} setGravityY - [description]
	 * @property {number} setFrictionX - [description]
	 * @property {number} setFrictionY - [description]
	 * @property {number} setVelocityX - [description]
	 * @property {number} setVelocityY - [description]
	 * @property {number} setAngularVelocity - [description]
	 * @property {number} setAngularAcceleration - [description]
	 * @property {number} setAngularDrag - [description]
	 * @property {number} setMass - [description]
	 * @property {boolean} setImmovable - [description]
	 */
	
	/**
	 * @classdesc
	 * An Arcade Physics Group object.
	 *
	 * All Game Objects created by this Group will automatically be dynamic Arcade Physics objects.
	 *
	 * @class Group
	 * @extends Phaser.GameObjects.Group
	 * @memberOf Phaser.Physics.Arcade
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Physics.Arcade.World} world - [description]
	 * @param {Phaser.Scene} scene - [description]
	 * @param {array} children - [description]
	 * @param {PhysicsGroupConfig} [config] - [description]
	 */
	var PhysicsGroup = new Class({
	
	    Extends: Group,
	
	    initialize:
	
	    function PhysicsGroup (world, scene, children, config)
	    {
	        if (config === undefined && !Array.isArray(children) && typeof children === 'object')
	        {
	            config = children;
	            children = null;
	        }
	        else if (config === undefined)
	        {
	            config = {};
	        }
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.Group#world
	         * @type {Phaser.Physics.Arcade.World}
	         * @since 3.0.0
	         */
	        this.world = world;
	
	        config.createCallback = this.createCallbackHandler;
	        config.removeCallback = this.removeCallbackHandler;
	
	        /**
	         * The class to create new group members from.
	         *
	         * @name Phaser.Physics.Arcade.Group#classType
	         * @type {Phaser.Physics.Arcade.Sprite}
	         * @default ArcadeSprite
	         */
	        config.classType = GetFastValue(config, 'classType', ArcadeSprite);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.Group#physicsType
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.physicsType = CONST.DYNAMIC_BODY;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.Group#defaults
	         * @type {PhysicsGroupDefaults}
	         * @since 3.0.0
	         */
	        this.defaults = {
	            setCollideWorldBounds: GetFastValue(config, 'collideWorldBounds', false),
	            setAccelerationX: GetFastValue(config, 'accelerationX', 0),
	            setAccelerationY: GetFastValue(config, 'accelerationY', 0),
	            setBounceX: GetFastValue(config, 'bounceX', 0),
	            setBounceY: GetFastValue(config, 'bounceY', 0),
	            setDragX: GetFastValue(config, 'dragX', 0),
	            setDragY: GetFastValue(config, 'dragY', 0),
	            setGravityX: GetFastValue(config, 'gravityX', 0),
	            setGravityY: GetFastValue(config, 'gravityY', 0),
	            setFrictionX: GetFastValue(config, 'frictionX', 0),
	            setFrictionY: GetFastValue(config, 'frictionY', 0),
	            setVelocityX: GetFastValue(config, 'velocityX', 0),
	            setVelocityY: GetFastValue(config, 'velocityY', 0),
	            setAngularVelocity: GetFastValue(config, 'angularVelocity', 0),
	            setAngularAcceleration: GetFastValue(config, 'angularAcceleration', 0),
	            setAngularDrag: GetFastValue(config, 'angularDrag', 0),
	            setMass: GetFastValue(config, 'mass', 1),
	            setImmovable: GetFastValue(config, 'immovable', false)
	        };
	
	        Group.call(this, scene, children, config);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Group#createCallbackHandler
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} child - [description]
	     */
	    createCallbackHandler: function (child)
	    {
	        if (!child.body)
	        {
	            this.world.enableBody(child, CONST.DYNAMIC_BODY);
	        }
	
	        var body = child.body;
	
	        for (var key in this.defaults)
	        {
	            body[key](this.defaults[key]);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Group#removeCallbackHandler
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} child - [description]
	     */
	    removeCallbackHandler: function (child)
	    {
	        if (child.body)
	        {
	            this.world.disableBody(child);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Group#setVelocity
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} step - [description]
	     *
	     * @return {Phaser.Physics.Arcade.Group} This Physics Group object.
	     */
	    setVelocity: function (x, y, step)
	    {
	        if (step === undefined) { step = 0; }
	
	        var items = this.getChildren();
	
	        for (var i = 0; i < items.length; i++)
	        {
	            items[i].body.velocity.set(x + (i * step), y + (i * step));
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Group#setVelocityX
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     * @param {number} step - [description]
	     *
	     * @return {Phaser.Physics.Arcade.Group} This Physics Group object.
	     */
	    setVelocityX: function (value, step)
	    {
	        if (step === undefined) { step = 0; }
	
	        var items = this.getChildren();
	
	        for (var i = 0; i < items.length; i++)
	        {
	            items[i].body.velocity.x = value + (i * step);
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Group#setVelocityY
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     * @param {number} step - [description]
	     *
	     * @return {Phaser.Physics.Arcade.Group} This Physics Group object.
	     */
	    setVelocityY: function (value, step)
	    {
	        if (step === undefined) { step = 0; }
	
	        var items = this.getChildren();
	
	        for (var i = 0; i < items.length; i++)
	        {
	            items[i].body.velocity.y = value + (i * step);
	        }
	
	        return this;
	    }
	
	});
	
	module.exports = PhysicsGroup;


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CircleContains = __webpack_require__(83);
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(117);
	var RectangleContains = __webpack_require__(84);
	var Vector2 = __webpack_require__(9);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class StaticBody
	 * @memberOf Phaser.Physics.Arcade
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Physics.Arcade.World} world - [description]
	 * @param {Phaser.GameObjects.GameObject} gameObject - [description]
	 */
	var StaticBody = new Class({
	
	    initialize:
	
	    function StaticBody (world, gameObject)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#world
	         * @type {Phaser.Physics.Arcade.World}
	         * @since 3.0.0
	         */
	        this.world = world;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#gameObject
	         * @type {Phaser.GameObjects.GameObject}
	         * @since 3.0.0
	         */
	        this.gameObject = gameObject;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#debugShowBody
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.debugShowBody = world.defaults.debugShowStaticBody;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#debugBodyColor
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.debugBodyColor = world.defaults.staticBodyDebugColor;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#enable
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.enable = true;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#isCircle
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.isCircle = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#radius
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.radius = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#offset
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.offset = new Vector2();
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#position
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.position = new Vector2(gameObject.x - gameObject.displayOriginX, gameObject.y - gameObject.displayOriginY);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#width
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.width = gameObject.displayWidth;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#height
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.height = gameObject.displayHeight;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#halfWidth
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.halfWidth = Math.abs(this.width / 2);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#halfHeight
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.halfHeight = Math.abs(this.height / 2);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#center
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.center = new Vector2(gameObject.x + this.halfWidth, gameObject.y + this.halfHeight);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#velocity
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.velocity = Vector2.ZERO;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#allowGravity
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.allowGravity = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#gravity
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.gravity = Vector2.ZERO;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#bounce
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.bounce = Vector2.ZERO;
	
	        //  If true this Body will dispatch events
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#onWorldBounds
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.onWorldBounds = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#onCollide
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.onCollide = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#onOverlap
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.onOverlap = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#mass
	         * @type {number}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.mass = 1;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#immovable
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.immovable = true;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#customSeparateX
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.customSeparateX = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#customSeparateY
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.customSeparateY = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#overlapX
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.overlapX = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#overlapY
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.overlapY = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#overlapR
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.overlapR = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#embedded
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.embedded = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#collideWorldBounds
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.collideWorldBounds = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#checkCollision
	         * @type {ArcadeBodyCollision}
	         * @since 3.0.0
	         */
	        this.checkCollision = { none: false, up: true, down: true, left: true, right: true };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#touching
	         * @type {ArcadeBodyCollision}
	         * @since 3.0.0
	         */
	        this.touching = { none: true, up: false, down: false, left: false, right: false };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#wasTouching
	         * @type {ArcadeBodyCollision}
	         * @since 3.0.0
	         */
	        this.wasTouching = { none: true, up: false, down: false, left: false, right: false };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#blocked
	         * @type {ArcadeBodyCollision}
	         * @since 3.0.0
	         */
	        this.blocked = { none: true, up: false, down: false, left: false, right: false };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticBody#physicsType
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.physicsType = CONST.STATIC_BODY;
	    },
	
	    /**
	     * Changes the Game Object this Body is bound to.
	     * First it removes its reference from the old Game Object, then sets the new one.
	     * You can optionally update the position and dimensions of this Body to reflect that of the new Game Object.
	     *
	     * @method Phaser.Physics.Arcade.StaticBody#setGameObject
	     * @since 3.1.0
	     *
	     * @param {Phaser.GameObjects.GameObject} gameObject - The new Game Object that will own this Body.
	     * @param {boolean} [update=true] - Reposition and resize this Body to match the new Game Object?
	     *
	     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
	     */
	    setGameObject: function (gameObject, update)
	    {
	        if (gameObject && gameObject !== this.gameObject)
	        {
	            //  Remove this body from the old game object
	            this.gameObject.body = null;
	
	            gameObject.body = this;
	
	            //  Update our reference
	            this.gameObject = gameObject;
	        }
	
	        if (update)
	        {
	            this.updateFromGameObject();
	        }
	
	        return this;
	    },
	
	    /**
	     * Updates this Static Body so that its position and dimensions are updated
	     * based on the current Game Object it is bound to.
	     *
	     * @method Phaser.Physics.Arcade.StaticBody#updateFromGameObject
	     * @since 3.1.0
	     *
	     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
	     */
	    updateFromGameObject: function ()
	    {
	        this.world.staticTree.remove(this);
	
	        var gameObject = this.gameObject;
	
	        gameObject.getTopLeft(this.position);
	
	        this.width = gameObject.displayWidth;
	        this.height = gameObject.displayHeight;
	
	        this.halfWidth = Math.abs(this.width / 2);
	        this.halfHeight = Math.abs(this.height / 2);
	
	        this.center.set(this.position.x + this.halfWidth, this.position.y + this.halfHeight);
	
	        this.world.staticTree.insert(this);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.StaticBody#setOffset
	     * @since 3.4.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     *
	     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
	     */
	    setOffset: function (x, y)
	    {
	        if (y === undefined) { y = x; }
	
	        this.world.staticTree.remove(this);
	
	        this.position.x -= this.offset.x;
	        this.position.y -= this.offset.y;
	
	        this.offset.set(x, y);
	
	        this.position.x += this.offset.x;
	        this.position.y += this.offset.y;
	
	        this.updateCenter();
	
	        this.world.staticTree.insert(this);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.StaticBody#setSize
	     * @since 3.0.0
	     *
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     * @param {number} [offsetX] - [description]
	     * @param {number} [offsetY] - [description]
	     *
	     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
	     */
	    setSize: function (width, height, offsetX, offsetY)
	    {
	        if (offsetX === undefined) { offsetX = this.offset.x; }
	        if (offsetY === undefined) { offsetY = this.offset.y; }
	
	        this.world.staticTree.remove(this);
	
	        this.width = width;
	        this.height = height;
	
	        this.halfWidth = Math.floor(width / 2);
	        this.halfHeight = Math.floor(height / 2);
	
	        this.offset.set(offsetX, offsetY);
	
	        this.updateCenter();
	
	        this.isCircle = false;
	        this.radius = 0;
	
	        this.world.staticTree.insert(this);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.StaticBody#setCircle
	     * @since 3.0.0
	     *
	     * @param {number} radius - [description]
	     * @param {number} [offsetX] - [description]
	     * @param {number} [offsetY] - [description]
	     *
	     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
	     */
	    setCircle: function (radius, offsetX, offsetY)
	    {
	        if (offsetX === undefined) { offsetX = this.offset.x; }
	        if (offsetY === undefined) { offsetY = this.offset.y; }
	
	        if (radius > 0)
	        {
	            this.world.staticTree.remove(this);
	
	            this.isCircle = true;
	
	            this.radius = radius;
	
	            this.width = radius * 2;
	            this.height = radius * 2;
	
	            this.halfWidth = Math.floor(this.width / 2);
	            this.halfHeight = Math.floor(this.height / 2);
	
	            this.offset.set(offsetX, offsetY);
	
	            this.updateCenter();
	
	            this.world.staticTree.insert(this);
	        }
	        else
	        {
	            this.isCircle = false;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.StaticBody#updateCenter
	     * @since 3.0.0
	     */
	    updateCenter: function ()
	    {
	        this.center.set(this.position.x + this.halfWidth, this.position.y + this.halfHeight);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.StaticBody#reset
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     */
	    reset: function (x, y)
	    {
	        var gameObject = this.gameObject;
	
	        if (x === undefined) { x = gameObject.x; }
	        if (y === undefined) { y = gameObject.y; }
	
	        this.world.staticTree.remove(this);
	
	        gameObject.getTopLeft(this.position);
	
	        this.updateCenter();
	
	        this.world.staticTree.insert(this);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.StaticBody#stop
	     * @since 3.0.0
	     *
	     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
	     */
	    stop: function ()
	    {
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.StaticBody#getBounds
	     * @since 3.0.0
	     *
	     * @param {ArcadeBodyBounds} obj - [description]
	     *
	     * @return {ArcadeBodyBounds} [description]
	     */
	    getBounds: function (obj)
	    {
	        obj.x = this.x;
	        obj.y = this.y;
	        obj.right = this.right;
	        obj.bottom = this.bottom;
	
	        return obj;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.StaticBody#hitTest
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     *
	     * @return {boolean} [description]
	     */
	    hitTest: function (x, y)
	    {
	        return (this.isCircle) ? CircleContains(this, x, y) : RectangleContains(this, x, y);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.StaticBody#deltaAbsX
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    deltaAbsX: function ()
	    {
	        return 0;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.StaticBody#deltaAbsY
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    deltaAbsY: function ()
	    {
	        return 0;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.StaticBody#deltaX
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    deltaX: function ()
	    {
	        return 0;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.StaticBody#deltaY
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    deltaY: function ()
	    {
	        return 0;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.StaticBody#deltaZ
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    deltaZ: function ()
	    {
	        return 0;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.StaticBody#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.enable = false;
	
	        this.world.pendingDestroy.set(this);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.StaticBody#drawDebug
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Graphics} graphic - [description]
	     */
	    drawDebug: function (graphic)
	    {
	        var pos = this.position;
	
	        if (this.debugShowBody)
	        {
	            graphic.lineStyle(1, this.debugBodyColor, 1);
	            graphic.strokeRect(pos.x, pos.y, this.width, this.height);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.StaticBody#willDrawDebug
	     * @since 3.0.0
	     *
	     * @return {boolean} [description]
	     */
	    willDrawDebug: function ()
	    {
	        return this.debugShowBody;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.StaticBody#setMass
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.Physics.Arcade.StaticBody} This Static Body object.
	     */
	    setMass: function (value)
	    {
	        if (value <= 0)
	        {
	            //  Causes havoc otherwise
	            value = 0.1;
	        }
	
	        this.mass = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Physics.Arcade.StaticBody#x
	     * @type {number}
	     * @since 3.0.0
	     */
	    x: {
	
	        get: function ()
	        {
	            return this.position.x;
	        },
	
	        set: function (value)
	        {
	            this.world.staticTree.remove(this);
	
	            this.position.x = value;
	
	            this.world.staticTree.insert(this);
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Physics.Arcade.StaticBody#y
	     * @type {number}
	     * @since 3.0.0
	     */
	    y: {
	
	        get: function ()
	        {
	            return this.position.y;
	        },
	
	        set: function (value)
	        {
	            this.world.staticTree.remove(this);
	
	            this.position.y = value;
	
	            this.world.staticTree.insert(this);
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Physics.Arcade.StaticBody#left
	     * @type {number}
	     * @readOnly
	     * @since 3.0.0
	     */
	    left: {
	
	        get: function ()
	        {
	            return this.position.x;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Physics.Arcade.StaticBody#right
	     * @type {number}
	     * @readOnly
	     * @since 3.0.0
	     */
	    right: {
	
	        get: function ()
	        {
	            return this.position.x + this.width;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Physics.Arcade.StaticBody#top
	     * @type {number}
	     * @readOnly
	     * @since 3.0.0
	     */
	    top: {
	
	        get: function ()
	        {
	            return this.position.y;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Physics.Arcade.StaticBody#bottom
	     * @type {number}
	     * @readOnly
	     * @since 3.0.0
	     */
	    bottom: {
	
	        get: function ()
	        {
	            return this.position.y + this.height;
	        }
	
	    }
	
	});
	
	module.exports = StaticBody;


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  Phaser.Physics.Arcade.StaticGroup
	
	var ArcadeSprite = __webpack_require__(204);
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(117);
	var Group = __webpack_require__(159);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class StaticGroup
	 * @extends Phaser.GameObjects.Group
	 * @memberOf Phaser.Physics.Arcade
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Physics.Arcade.World} world - [description]
	 * @param {Phaser.Scene} scene - [description]
	 * @param {array} children - [description]
	 * @param {GroupConfig} config - [description]
	 */
	var StaticPhysicsGroup = new Class({
	
	    Extends: Group,
	
	    initialize:
	
	    function StaticPhysicsGroup (world, scene, children, config)
	    {
	        if (config === undefined && !Array.isArray(children) && typeof children === 'object')
	        {
	            config = children;
	            children = null;
	        }
	        else if (config === undefined)
	        {
	            config = {};
	        }
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticGroup#world
	         * @type {Phaser.Physics.Arcade.World}
	         * @since 3.0.0
	         */
	        this.world = world;
	
	        config.createCallback = this.createCallbackHandler;
	        config.removeCallback = this.removeCallbackHandler;
	        config.createMultipleCallback = this.createMultipleCallbackHandler;
	
	        config.classType = ArcadeSprite;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.StaticGroup#physicsType
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.physicsType = CONST.STATIC_BODY;
	
	        Group.call(this, scene, children, config);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.StaticGroup#createCallbackHandler
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} child - [description]
	     */
	    createCallbackHandler: function (child)
	    {
	        if (!child.body)
	        {
	            this.world.enableBody(child, CONST.STATIC_BODY);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.StaticGroup#removeCallbackHandler
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} child - [description]
	     */
	    removeCallbackHandler: function (child)
	    {
	        if (child.body)
	        {
	            this.world.disableBody(child);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.StaticGroup#createMultipleCallbackHandler
	     * @since 3.0.0
	     *
	     * @param {object} entries - [description]
	     */
	    createMultipleCallbackHandler: function ()
	    {
	        this.refresh();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.StaticGroup#refresh
	     * @since 3.0.0
	     *
	     * @return {Phaser.Physics.Arcade.StaticGroup} [description]
	     */
	    refresh: function ()
	    {
	        var children = this.children.entries;
	
	        for (var i = 0; i < children.length; i++)
	        {
	            children[i].body.reset();
	        }
	
	        return this;
	    }
	
	});
	
	module.exports = StaticPhysicsGroup;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Body = __webpack_require__(581);
	var Clamp = __webpack_require__(63);
	var Class = __webpack_require__(1);
	var Collider = __webpack_require__(582);
	var CONST = __webpack_require__(117);
	var DistanceBetween = __webpack_require__(116);
	var EventEmitter = __webpack_require__(22);
	var GetOverlapX = __webpack_require__(584);
	var GetOverlapY = __webpack_require__(585);
	var GetValue = __webpack_require__(10);
	var ProcessQueue = __webpack_require__(632);
	var ProcessTileCallbacks = __webpack_require__(1441);
	var Rectangle = __webpack_require__(23);
	var RTree = __webpack_require__(633);
	var SeparateTile = __webpack_require__(1444);
	var SeparateX = __webpack_require__(1426);
	var SeparateY = __webpack_require__(1427);
	var Set = __webpack_require__(146);
	var StaticBody = __webpack_require__(587);
	var TileIntersectsBody = __webpack_require__(591);
	var Vector2 = __webpack_require__(9);
	var Wrap = __webpack_require__(98);
	
	/**
	 * @event Phaser.Physics.Arcade.World#pause
	 */
	
	/**
	 * @event Phaser.Physics.Arcade.World#resume
	 */
	
	/**
	 * @event Phaser.Physics.Arcade.World#collide
	 * @param {Phaser.GameObjects.GameObject} gameObject1
	 * @param {Phaser.GameObjects.GameObject} gameObject2
	 * @param {Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody} body1
	 * @param {Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody} body2
	 */
	
	/**
	 * @event Phaser.Physics.Arcade.World#overlap
	 * @param {Phaser.GameObjects.GameObject} gameObject1
	 * @param {Phaser.GameObjects.GameObject} gameObject2
	 * @param {Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody} body1
	 * @param {Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody} body2
	 */
	
	/**
	 * @event Phaser.Physics.Arcade.World#worldbounds
	 * @param {Phaser.Physics.Arcade.Body} body
	 * @param {boolean} up
	 * @param {boolean} down
	 * @param {boolean} left
	 * @param {boolean} right
	 */
	
	/**
	 * @typedef {object} ArcadeWorldConfig
	 *
	 * @property {object} [gravity] - Sets {@link Phaser.Physics.Arcade.World#gravity}.
	 * @property {number} [gravity.x=0] - [description]
	 * @property {number} [gravity.y=0] - [description]
	 * @property {number} [x=0] - Sets {@link Phaser.Physics.Arcade.World#bounds bounds.x}.
	 * @property {number} [y=0] - Sets {@link Phaser.Physics.Arcade.World#bounds bounds.y}.
	 * @property {number} [width=0] - Sets {@link Phaser.Physics.Arcade.World#bounds bounds.width}.
	 * @property {number} [height=0] - Sets {@link Phaser.Physics.Arcade.World#bounds bounds.height}.
	 * @property {object} [checkCollision] - Sets {@link Phaser.Physics.Arcade.World#checkCollision}.
	 * @property {boolean} [checkCollision.up=true] - [description]
	 * @property {boolean} [checkCollision.down=true] - [description]
	 * @property {boolean} [checkCollision.left=true] - [description]
	 * @property {boolean} [checkCollision.right=true] - [description]
	 * @property {number} [overlapBias=4] - Sets {@link Phaser.Physics.Arcade.World#OVERLAP_BIAS}.
	 * @property {number} [tileBias=16] - Sets {@link Phaser.Physics.Arcade.World#TILE_BIAS}.
	 * @property {boolean} [forceX=false] - Sets {@link Phaser.Physics.Arcade.World#forceX}.
	 * @property {boolean} [isPaused=false] - Sets {@link Phaser.Physics.Arcade.World#isPaused}.
	 * @property {boolean} [debug=false] - Sets {@link Phaser.Physics.Arcade.World#debug}.
	 * @property {boolean} [debugShowBody=true] - Sets {@link Phaser.Physics.Arcade.World#defaults debugShowBody}.
	 * @property {boolean} [debugShowStaticBody=true] - Sets {@link Phaser.Physics.Arcade.World#defaults debugShowStaticBody}.
	 * @property {boolean} [debugShowVelocity=true] - Sets {@link Phaser.Physics.Arcade.World#defaults debugShowStaticBody}.
	 * @property {number} [debugBodyColor=0xff00ff] - Sets {@link Phaser.Physics.Arcade.World#defaults debugBodyColor}.
	 * @property {number} [debugStaticBodyColor=0x0000ff] - Sets {@link Phaser.Physics.Arcade.World#defaults debugStaticBodyColor}.
	 * @property {number} [debugVelocityColor=0x00ff00] - Sets {@link Phaser.Physics.Arcade.World#defaults debugVelocityColor}.
	 * @property {number} [maxEntries=16] - Sets {@link Phaser.Physics.Arcade.World#maxEntries}.
	 */
	
	/**
	 * @typedef {object} CheckCollisionObject
	 *
	 * @property {boolean} up - [description]
	 * @property {boolean} down - [description]
	 * @property {boolean} left - [description]
	 * @property {boolean} right - [description]
	 */
	
	/**
	 * @typedef {object} ArcadeWorldDefaults
	 *
	 * @property {boolean} debugShowBody - [description]
	 * @property {boolean} debugShowStaticBody - [description]
	 * @property {boolean} debugShowVelocity - [description]
	 * @property {number} bodyDebugColor - [description]
	 * @property {number} staticBodyDebugColor - [description]
	 * @property {number} velocityDebugColor - [description]
	 */
	
	/**
	 * @typedef {object} ArcadeWorldTreeMinMax
	 *
	 * @property {number} minX - [description]
	 * @property {number} minY - [description]
	 * @property {number} maxX - [description]
	 * @property {number} maxY - [description]
	 */
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class World
	 * @extends Phaser.Events.EventEmitter
	 * @memberOf Phaser.Physics.Arcade
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - [description]
	 * @param {ArcadeWorldConfig} config - [description]
	 */
	var World = new Class({
	
	    Extends: EventEmitter,
	
	    initialize:
	
	    function World (scene, config)
	    {
	        EventEmitter.call(this);
	
	        /**
	         * The Scene this simulation belongs to.
	         *
	         * @name Phaser.Physics.Arcade.World#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * Dynamic Bodies in this simulation.
	         *
	         * @name Phaser.Physics.Arcade.World#bodies
	         * @type {Phaser.Structs.Set.<Phaser.Physics.Arcade.Body>}
	         * @since 3.0.0
	         */
	        this.bodies = new Set();
	
	        /**
	         * Static Bodies in this simulation.
	         *
	         * @name Phaser.Physics.Arcade.World#staticBodies
	         * @type {Phaser.Structs.Set.<Phaser.Physics.Arcade.StaticBody>}
	         * @since 3.0.0
	         */
	        this.staticBodies = new Set();
	
	        /**
	         * Static Bodies marked for deletion.
	         *
	         * @name Phaser.Physics.Arcade.World#pendingDestroy
	         * @type {Phaser.Structs.Set.<(Phaser.Physics.Arcade.Body|Phaser.Physics.Arcade.StaticBody)>}
	         * @since 3.1.0
	         */
	        this.pendingDestroy = new Set();
	
	        /**
	         * This simulation's collision processors.
	         *
	         * @name Phaser.Physics.Arcade.World#colliders
	         * @type {Phaser.Structs.ProcessQueue.<Phaser.Physics.Arcade.Collider>}
	         * @since 3.0.0
	         */
	        this.colliders = new ProcessQueue();
	
	        /**
	         * Acceleration of Bodies due to gravity, in pixels per second.
	         *
	         * @name Phaser.Physics.Arcade.World#gravity
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.gravity = new Vector2(GetValue(config, 'gravity.x', 0), GetValue(config, 'gravity.y', 0));
	
	        /**
	         * A boundary constraining Bodies.
	         *
	         * @name Phaser.Physics.Arcade.World#bounds
	         * @type {Phaser.Geom.Rectangle}
	         * @since 3.0.0
	         */
	        this.bounds = new Rectangle(
	            GetValue(config, 'x', 0),
	            GetValue(config, 'y', 0),
	            GetValue(config, 'width', scene.sys.game.config.width),
	            GetValue(config, 'height', scene.sys.game.config.height)
	        );
	
	        /**
	         * The boundary edges that Bodies can collide with.
	         *
	         * @name Phaser.Physics.Arcade.World#checkCollision
	         * @type {CheckCollisionObject}
	         * @since 3.0.0
	         */
	        this.checkCollision = {
	            up: GetValue(config, 'checkCollision.up', true),
	            down: GetValue(config, 'checkCollision.down', true),
	            left: GetValue(config, 'checkCollision.left', true),
	            right: GetValue(config, 'checkCollision.right', true)
	        };
	
	        /**
	         * The maximum absolute difference of a Body's per-step velocity and its overlap with another Body that will result in separation on *each axis*.
	         * Larger values favor separation.
	         * Smaller values favor no separation.
	         *
	         * @name Phaser.Physics.Arcade.World#OVERLAP_BIAS
	         * @type {number}
	         * @default 4
	         * @since 3.0.0
	         */
	        this.OVERLAP_BIAS = GetValue(config, 'overlapBias', 4);
	
	        /**
	         * The maximum absolute value of a Body's overlap with a tile that will result in separation on *each axis*.
	         * Larger values favor separation.
	         * Smaller values favor no separation.
	         * The optimum value may be similar to the tile size.
	         *
	         * @name Phaser.Physics.Arcade.World#TILE_BIAS
	         * @type {number}
	         * @default 16
	         * @since 3.0.0
	         */
	        this.TILE_BIAS = GetValue(config, 'tileBias', 16);
	
	        /**
	         * Always separate overlapping Bodies horizontally before vertically.
	         * False (the default) means Bodies are first separated on the axis of greater gravity, or the vertical axis if neither is greater.
	         *
	         * @name Phaser.Physics.Arcade.World#forceX
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.forceX = GetValue(config, 'forceX', false);
	
	        /**
	         * Whether the simulation advances with the game loop.
	         *
	         * @name Phaser.Physics.Arcade.World#isPaused
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.isPaused = GetValue(config, 'isPaused', false);
	
	        /**
	         * Temporary total of colliding Bodies.
	         *
	         * @name Phaser.Physics.Arcade.World#_total
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._total = 0;
	
	        /**
	         * Enables the debug display.
	         *
	         * @name Phaser.Physics.Arcade.World#drawDebug
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.drawDebug = GetValue(config, 'debug', false);
	
	        /**
	         * The graphics object drawing the debug display.
	         *
	         * @name Phaser.Physics.Arcade.World#debugGraphic
	         * @type {Phaser.GameObjects.Graphics}
	         * @since 3.0.0
	         */
	        this.debugGraphic;
	
	        /**
	         * Default debug display settings for new Bodies.
	         *
	         * @name Phaser.Physics.Arcade.World#defaults
	         * @type {ArcadeWorldDefaults}
	         * @since 3.0.0
	         */
	        this.defaults = {
	            debugShowBody: GetValue(config, 'debugShowBody', true),
	            debugShowStaticBody: GetValue(config, 'debugShowStaticBody', true),
	            debugShowVelocity: GetValue(config, 'debugShowVelocity', true),
	            bodyDebugColor: GetValue(config, 'debugBodyColor', 0xff00ff),
	            staticBodyDebugColor: GetValue(config, 'debugStaticBodyColor', 0x0000ff),
	            velocityDebugColor: GetValue(config, 'debugVelocityColor', 0x00ff00)
	        };
	
	        /**
	         * The maximum number of items per tree node.
	         *
	         * @name Phaser.Physics.Arcade.World#maxEntries
	         * @type {integer}
	         * @default 16
	         * @since 3.0.0
	         */
	        this.maxEntries = GetValue(config, 'maxEntries', 16);
	
	        /**
	         * The spatial index of Dynamic Bodies.
	         *
	         * @name Phaser.Physics.Arcade.World#tree
	         * @type {Phaser.Structs.RTree}
	         * @since 3.0.0
	         */
	        this.tree = new RTree(this.maxEntries);
	
	        /**
	         * The spatial index of Static Bodies.
	         *
	         * @name Phaser.Physics.Arcade.World#staticTree
	         * @type {Phaser.Structs.RTree}
	         * @since 3.0.0
	         */
	        this.staticTree = new RTree(this.maxEntries);
	
	        /**
	         * Recycled input for tree searches.
	         *
	         * @name Phaser.Physics.Arcade.World#treeMinMax
	         * @type {ArcadeWorldTreeMinMax}
	         * @since 3.0.0
	         */
	        this.treeMinMax = { minX: 0, minY: 0, maxX: 0, maxY: 0 };
	
	        if (this.drawDebug)
	        {
	            this.createDebugGraphic();
	        }
	    },
	
	    /**
	     * Adds an Arcade Physics Body to a Game Object.
	     *
	     * @method Phaser.Physics.Arcade.World#enable
	     * @since 3.0.0
	     *
	     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} object - [description]
	     * @param {integer} [bodyType] - The type of Body to create. Either `DYNAMIC_BODY` or `STATIC_BODY`.
	     */
	    enable: function (object, bodyType)
	    {
	        if (bodyType === undefined) { bodyType = CONST.DYNAMIC_BODY; }
	
	        var i = 1;
	
	        if (Array.isArray(object))
	        {
	            i = object.length;
	
	            while (i--)
	            {
	                if (object[i].hasOwnProperty('children'))
	                {
	                    //  If it's a Group then we do it on the children regardless
	                    this.enable(object[i].children.entries, bodyType);
	                }
	                else
	                {
	                    this.enableBody(object[i], bodyType);
	                }
	            }
	        }
	        else if (object.hasOwnProperty('children'))
	        {
	            //  If it's a Group then we do it on the children regardless
	            this.enable(object.children.entries, bodyType);
	        }
	        else
	        {
	            this.enableBody(object, bodyType);
	        }
	    },
	
	    /**
	     * Helper for Phaser.Physics.Arcade.World#enable.
	     *
	     * @method Phaser.Physics.Arcade.World#enableBody
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} object - [description]
	     * @param {integer} [bodyType] - The type of Body to create. Either `DYNAMIC_BODY` or `STATIC_BODY`.
	     *
	     * @return {Phaser.GameObjects.GameObject} [description]
	     */
	    enableBody: function (object, bodyType)
	    {
	        if (object.body === null)
	        {
	            if (bodyType === CONST.DYNAMIC_BODY)
	            {
	                object.body = new Body(this, object);
	
	                this.bodies.set(object.body);
	            }
	            else if (bodyType === CONST.STATIC_BODY)
	            {
	                object.body = new StaticBody(this, object);
	
	                this.staticBodies.set(object.body);
	
	                this.staticTree.insert(object.body);
	            }
	        }
	
	        return object;
	    },
	
	    /**
	     * Remove a Body from the simulation.
	     *
	     * @method Phaser.Physics.Arcade.World#remove
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Arcade.Body} object - [description]
	     */
	    remove: function (object)
	    {
	        this.disableBody(object);
	    },
	
	    /**
	     * Disables the Body of a Game Object, or the Bodies of several Game Objects.
	     *
	     * @method Phaser.Physics.Arcade.World#disable
	     * @since 3.0.0
	     *
	     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} object - [description]
	     */
	    disable: function (object)
	    {
	        var i = 1;
	
	        if (Array.isArray(object))
	        {
	            i = object.length;
	
	            while (i--)
	            {
	                if (object[i].hasOwnProperty('children'))
	                {
	                    //  If it's a Group then we do it on the children regardless
	                    this.disable(object[i].children.entries);
	                }
	                else
	                {
	                    this.disableGameObjectBody(object[i]);
	                }
	            }
	        }
	        else if (object.hasOwnProperty('children'))
	        {
	            //  If it's a Group then we do it on the children regardless
	            this.disable(object.children.entries);
	        }
	        else
	        {
	            this.disableGameObjectBody(object);
	        }
	    },
	
	    /**
	     * Disables the Body of a Game Object.
	     *
	     * @method Phaser.Physics.Arcade.World#disableGameObjectBody
	     * @since 3.1.0
	     *
	     * @param {Phaser.GameObjects.GameObject} object - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} [description]
	     */
	    disableGameObjectBody: function (object)
	    {
	        if (object.body)
	        {
	            if (object.body.physicsType === CONST.DYNAMIC_BODY)
	            {
	                this.bodies.delete(object.body);
	            }
	            else if (object.body.physicsType === CONST.STATIC_BODY)
	            {
	                this.staticBodies.delete(object.body);
	                this.staticTree.remove(object.body);
	            }
	
	            object.body.enable = false;
	        }
	
	        return object;
	    },
	
	    /**
	     * Disables a Body.
	     * A disabled Body is ignored by the simulation. It doesn't move or interact with other Bodies.
	     *
	     * @method Phaser.Physics.Arcade.World#disableBody
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Arcade.Body} body - [description]
	     */
	    disableBody: function (body)
	    {
	        if (body.physicsType === CONST.DYNAMIC_BODY)
	        {
	            this.tree.remove(body);
	            this.bodies.delete(body);
	        }
	        else if (body.physicsType === CONST.STATIC_BODY)
	        {
	            this.staticBodies.delete(body);
	            this.staticTree.remove(body);
	        }
	
	        body.enable = false;
	    },
	
	    /**
	     * Creates the graphics object responsible for debug display.
	     *
	     * @method Phaser.Physics.Arcade.World#createDebugGraphic
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Graphics} [description]
	     */
	    createDebugGraphic: function ()
	    {
	        var graphic = this.scene.sys.add.graphics({ x: 0, y: 0 });
	
	        graphic.setDepth(Number.MAX_VALUE);
	
	        this.debugGraphic = graphic;
	
	        this.drawDebug = true;
	
	        return graphic;
	    },
	
	    /**
	     * Sets the dimensions of the world boundary.
	     *
	     * @method Phaser.Physics.Arcade.World#setBounds
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     * @param {boolean} [checkLeft] - [description]
	     * @param {boolean} [checkRight] - [description]
	     * @param {boolean} [checkUp] - [description]
	     * @param {boolean} [checkDown] - [description]
	     *
	     * @return {Phaser.Physics.Arcade.World} This World object.
	     */
	    setBounds: function (x, y, width, height, checkLeft, checkRight, checkUp, checkDown)
	    {
	        this.bounds.setTo(x, y, width, height);
	
	        if (checkLeft !== undefined)
	        {
	            this.setBoundsCollision(checkLeft, checkRight, checkUp, checkDown);
	        }
	
	        return this;
	    },
	
	    /**
	     * Enables or disables collisions on each boundary edge.
	     *
	     * @method Phaser.Physics.Arcade.World#setBoundsCollision
	     * @since 3.0.0
	     *
	     * @param {boolean} [left=true] - [description]
	     * @param {boolean} [right=true] - [description]
	     * @param {boolean} [up=true] - [description]
	     * @param {boolean} [down=true] - [description]
	     *
	     * @return {Phaser.Physics.Arcade.World} This World object.
	     */
	    setBoundsCollision: function (left, right, up, down)
	    {
	        if (left === undefined) { left = true; }
	        if (right === undefined) { right = true; }
	        if (up === undefined) { up = true; }
	        if (down === undefined) { down = true; }
	
	        this.checkCollision.left = left;
	        this.checkCollision.right = right;
	        this.checkCollision.up = up;
	        this.checkCollision.down = down;
	
	        return this;
	    },
	
	    /**
	     * Pauses the simulation.
	     *
	     * @method Phaser.Physics.Arcade.World#pause
	     * @fires Phaser.Physics.Arcade.World#pause
	     * @since 3.0.0
	     *
	     * @return {Phaser.Physics.Arcade.World} This World object.
	     */
	    pause: function ()
	    {
	        this.isPaused = true;
	
	        this.emit('pause');
	
	        return this;
	    },
	
	    /**
	     * Resumes the simulation, if paused.
	     *
	     * @method Phaser.Physics.Arcade.World#resume
	     * @fires Phaser.Physics.Arcade.World#resume
	     * @since 3.0.0
	     *
	     * @return {Phaser.Physics.Arcade.World} This World object.
	     */
	    resume: function ()
	    {
	        this.isPaused = false;
	
	        this.emit('resume');
	
	        return this;
	    },
	
	    /**
	     * Adds a collision processor, which runs automatically.
	     *
	     * @method Phaser.Physics.Arcade.World#addCollider
	     * @since 3.0.0
	     * @see Phaser.Physics.Arcade.World#collide
	     *
	     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} object1 - The first object to check for collision.
	     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} object2 - The second object to check for collision.
	     * @param {ArcadePhysicsCallback} [collideCallback] - The callback to invoke when the two objects collide.
	     * @param {ArcadePhysicsCallback} [processCallback] - The callback to invoke when the two objects collide. Must return a boolean.
	     * @param {*} [callbackContext] - The scope in which to call the callbacks.
	     *
	     * @return {Phaser.Physics.Arcade.Collider} The Collider that was created.
	     */
	    addCollider: function (object1, object2, collideCallback, processCallback, callbackContext)
	    {
	        if (collideCallback === undefined) { collideCallback = null; }
	        if (processCallback === undefined) { processCallback = null; }
	        if (callbackContext === undefined) { callbackContext = collideCallback; }
	
	        var collider = new Collider(this, false, object1, object2, collideCallback, processCallback, callbackContext);
	
	        this.colliders.add(collider);
	
	        return collider;
	    },
	
	    /**
	     * Adds an overlap processor, which runs automatically.
	     *
	     * @method Phaser.Physics.Arcade.World#addOverlap
	     * @since 3.0.0
	     *
	     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} object1 - The first object to check for overlap.
	     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} object2 - The second object to check for overlap.
	     * @param {ArcadePhysicsCallback} [collideCallback] - The callback to invoke when the two objects overlap.
	     * @param {ArcadePhysicsCallback} [processCallback] - The callback to invoke when the two objects overlap. Must return a boolean.
	     * @param {*} [callbackContext] - The scope in which to call the callbacks.
	     *
	     * @return {Phaser.Physics.Arcade.Collider} The Collider that was created.
	     */
	    addOverlap: function (object1, object2, collideCallback, processCallback, callbackContext)
	    {
	        if (collideCallback === undefined) { collideCallback = null; }
	        if (processCallback === undefined) { processCallback = null; }
	        if (callbackContext === undefined) { callbackContext = collideCallback; }
	
	        var collider = new Collider(this, true, object1, object2, collideCallback, processCallback, callbackContext);
	
	        this.colliders.add(collider);
	
	        return collider;
	    },
	
	    /**
	     * Removes a collision or overlap processor.
	     *
	     * @method Phaser.Physics.Arcade.World#removeCollider
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Arcade.Collider} collider - [description]
	     *
	     * @return {Phaser.Physics.Arcade.World} This World object.
	     */
	    removeCollider: function (collider)
	    {
	        this.colliders.remove(collider);
	
	        return this;
	    },
	
	    /**
	     * Advances the simulation.
	     *
	     * @method Phaser.Physics.Arcade.World#update
	     * @since 3.0.0
	     *
	     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
	     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
	     */
	    update: function (time, delta)
	    {
	        if (this.isPaused || this.bodies.size === 0)
	        {
	            return;
	        }
	
	        // this.delta = Math.min(delta / 1000, this.maxStep) * this.timeScale;
	        delta /= 1000;
	
	        this.delta = delta;
	
	        //  Update all active bodies
	
	        var i;
	        var body;
	        var bodies = this.bodies.entries;
	        var len = bodies.length;
	
	        for (i = 0; i < len; i++)
	        {
	            body = bodies[i];
	
	            if (body.enable)
	            {
	                body.update(delta);
	            }
	        }
	
	        //  Populate our dynamic collision tree
	        this.tree.clear();
	        this.tree.load(bodies);
	
	        //  Process any colliders
	        var colliders = this.colliders.update();
	
	        for (i = 0; i < colliders.length; i++)
	        {
	            var collider = colliders[i];
	
	            if (collider.active)
	            {
	                collider.update();
	            }
	        }
	    },
	
	    /**
	     * Updates bodies, draws the debug display, and handles pending queue operations.
	     *
	     * @method Phaser.Physics.Arcade.World#postUpdate
	     * @since 3.0.0
	     */
	    postUpdate: function ()
	    {
	        var i;
	        var body;
	
	        var dynamic = this.bodies;
	        var staticBodies = this.staticBodies;
	        var pending = this.pendingDestroy;
	
	        var bodies = dynamic.entries;
	        var len = bodies.length;
	
	        for (i = 0; i < len; i++)
	        {
	            body = bodies[i];
	
	            if (body.enable)
	            {
	                body.postUpdate();
	            }
	        }
	
	        if (this.drawDebug)
	        {
	            var graphics = this.debugGraphic;
	
	            graphics.clear();
	
	            for (i = 0; i < len; i++)
	            {
	                body = bodies[i];
	
	                if (body.willDrawDebug())
	                {
	                    body.drawDebug(graphics);
	                }
	            }
	
	            bodies = staticBodies.entries;
	            len = bodies.length;
	
	            for (i = 0; i < len; i++)
	            {
	                body = bodies[i];
	
	                if (body.willDrawDebug())
	                {
	                    body.drawDebug(graphics);
	                }
	            }
	        }
	
	        if (pending.size > 0)
	        {
	            var dynamicTree = this.tree;
	            var staticTree = this.staticTree;
	
	            bodies = pending.entries;
	            len = bodies.length;
	
	            for (i = 0; i < len; i++)
	            {
	                body = bodies[i];
	
	                if (body.physicsType === CONST.DYNAMIC_BODY)
	                {
	                    dynamicTree.remove(body);
	                    dynamic.delete(body);
	                }
	                else if (body.physicsType === CONST.STATIC_BODY)
	                {
	                    staticTree.remove(body);
	                    staticBodies.delete(body);
	                }
	
	                body.world = undefined;
	                body.gameObject = undefined;
	            }
	
	            pending.clear();
	        }
	    },
	
	    /**
	     * Calculates a Body's velocity and updates its position.
	     *
	     * @method Phaser.Physics.Arcade.World#updateMotion
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Arcade.Body} body - [description]
	     */
	    updateMotion: function (body)
	    {
	        if (body.allowRotation)
	        {
	            var velocityDelta = this.computeVelocity(0, body, body.angularVelocity, body.angularAcceleration, body.angularDrag, body.maxAngular) - body.angularVelocity;
	
	            body.angularVelocity += velocityDelta;
	            body.rotation += (body.angularVelocity * this.delta);
	        }
	
	        body.velocity.x = this.computeVelocity(1, body, body.velocity.x, body.acceleration.x, body.drag.x, body.maxVelocity.x);
	        body.velocity.y = this.computeVelocity(2, body, body.velocity.y, body.acceleration.y, body.drag.y, body.maxVelocity.y);
	    },
	
	    /**
	     * Calculates a Body's per-axis velocity.
	     *
	     * @method Phaser.Physics.Arcade.World#computeVelocity
	     * @since 3.0.0
	     *
	     * @param {integer} axis - [description]
	     * @param {Phaser.Physics.Arcade.Body} body - [description]
	     * @param {number} velocity - [description]
	     * @param {number} acceleration - [description]
	     * @param {number} drag - [description]
	     * @param {number} max - [description]
	     *
	     * @return {number} [description]
	     */
	    computeVelocity: function (axis, body, velocity, acceleration, drag, max)
	    {
	        if (max === undefined) { max = 10000; }
	
	        if (axis === 1 && body.allowGravity)
	        {
	            velocity += (this.gravity.x + body.gravity.x) * this.delta;
	        }
	        else if (axis === 2 && body.allowGravity)
	        {
	            velocity += (this.gravity.y + body.gravity.y) * this.delta;
	        }
	
	        if (acceleration)
	        {
	            velocity += acceleration * this.delta;
	        }
	        else if (drag && body.allowDrag)
	        {
	            drag *= this.delta;
	
	            if (velocity - drag > 0)
	            {
	                velocity -= drag;
	            }
	            else if (velocity + drag < 0)
	            {
	                velocity += drag;
	            }
	            else
	            {
	                velocity = 0;
	            }
	        }
	
	        if (velocity > max)
	        {
	            velocity = max;
	        }
	        else if (velocity < -max)
	        {
	            velocity = -max;
	        }
	
	        return velocity;
	    },
	
	    /**
	     * Separates two Bodies, when at least one is rectangular.
	     *
	     * @method Phaser.Physics.Arcade.World#separate
	     * @fires Phaser.Physics.Arcade.World#collide
	     * @fires Phaser.Physics.Arcade.World#overlap
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Arcade.Body} body1 - [description]
	     * @param {Phaser.Physics.Arcade.Body} body2 - [description]
	     * @param {ArcadePhysicsCallback} [processCallback] - [description]
	     * @param {*} [callbackContext] - [description]
	     * @param {boolean} [overlapOnly] - [description]
	     *
	     * @return {boolean} [description]
	     */
	    separate: function (body1, body2, processCallback, callbackContext, overlapOnly)
	    {
	        if (
	            !body1.enable ||
	            !body2.enable ||
	            body1.checkCollision.none ||
	            body2.checkCollision.none ||
	            !this.intersects(body1, body2))
	        {
	            return false;
	        }
	
	        //  They overlap. Is there a custom process callback? If it returns true then we can carry on, otherwise we should abort.
	        if (processCallback && processCallback.call(callbackContext, body1.gameObject, body2.gameObject) === false)
	        {
	            return false;
	        }
	
	        //  Circle vs. Circle quick bail out
	        if (body1.isCircle && body2.isCircle)
	        {
	            return this.separateCircle(body1, body2, overlapOnly);
	        }
	
	        // We define the behavior of bodies in a collision circle and rectangle
	        // If a collision occurs in the corner points of the rectangle, the body behave like circles
	
	        //  Either body1 or body2 is a circle
	        if (body1.isCircle !== body2.isCircle)
	        {
	            var bodyRect = (body1.isCircle) ? body2 : body1;
	            var bodyCircle = (body1.isCircle) ? body1 : body2;
	
	            var rect = {
	                x: bodyRect.x,
	                y: bodyRect.y,
	                right: bodyRect.right,
	                bottom: bodyRect.bottom
	            };
	
	            var circle = bodyCircle.center;
	
	            if (circle.y < rect.y || circle.y > rect.bottom)
	            {
	                if (circle.x < rect.x || circle.x > rect.right)
	                {
	                    return this.separateCircle(body1, body2, overlapOnly);
	                }
	            }
	        }
	
	        var resultX = false;
	        var resultY = false;
	
	        //  Do we separate on x or y first?
	        if (this.forceX || Math.abs(this.gravity.y + body1.gravity.y) < Math.abs(this.gravity.x + body1.gravity.x))
	        {
	            resultX = SeparateX(body1, body2, overlapOnly, this.OVERLAP_BIAS);
	
	            //  Are they still intersecting? Let's do the other axis then
	            if (this.intersects(body1, body2))
	            {
	                resultY = SeparateY(body1, body2, overlapOnly, this.OVERLAP_BIAS);
	            }
	        }
	        else
	        {
	            resultY = SeparateY(body1, body2, overlapOnly, this.OVERLAP_BIAS);
	
	            //  Are they still intersecting? Let's do the other axis then
	            if (this.intersects(body1, body2))
	            {
	                resultX = SeparateX(body1, body2, overlapOnly, this.OVERLAP_BIAS);
	            }
	        }
	
	        var result = (resultX || resultY);
	
	        if (result)
	        {
	            if (overlapOnly && (body1.onOverlap || body2.onOverlap))
	            {
	                this.emit('overlap', body1.gameObject, body2.gameObject, body1, body2);
	            }
	            else if (body1.onCollide || body2.onCollide)
	            {
	                this.emit('collide', body1.gameObject, body2.gameObject, body1, body2);
	            }
	        }
	
	        return result;
	    },
	
	    /**
	     * Separates two Bodies, when both are circular.
	     *
	     * @method Phaser.Physics.Arcade.World#separateCircle
	     * @fires Phaser.Physics.Arcade.World#collide
	     * @fires Phaser.Physics.Arcade.World#overlap
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Arcade.Body} body1 - [description]
	     * @param {Phaser.Physics.Arcade.Body} body2 - [description]
	     * @param {boolean} overlapOnly - [description]
	     * @param {number} bias - [description]
	     *
	     * @return {boolean} [description]
	     */
	    separateCircle: function (body1, body2, overlapOnly, bias)
	    {
	        //  Set the bounding box overlap values into the bodies themselves (hence we don't use the return values here)
	        GetOverlapX(body1, body2, false, bias);
	        GetOverlapY(body1, body2, false, bias);
	
	        var dx = body2.center.x - body1.center.x;
	        var dy = body2.center.y - body1.center.y;
	
	        var angleCollision = Math.atan2(dy, dx);
	
	        var overlap = 0;
	
	        if (body1.isCircle !== body2.isCircle)
	        {
	            var rect = {
	                x: (body2.isCircle) ? body1.position.x : body2.position.x,
	                y: (body2.isCircle) ? body1.position.y : body2.position.y,
	                right: (body2.isCircle) ? body1.right : body2.right,
	                bottom: (body2.isCircle) ? body1.bottom : body2.bottom
	            };
	
	            var circle = {
	                x: (body1.isCircle) ? body1.center.x : body2.center.x,
	                y: (body1.isCircle) ? body1.center.y : body2.center.y,
	                radius: (body1.isCircle) ? body1.halfWidth : body2.halfWidth
	            };
	
	            if (circle.y < rect.y)
	            {
	                if (circle.x < rect.x)
	                {
	                    overlap = DistanceBetween(circle.x, circle.y, rect.x, rect.y) - circle.radius;
	                }
	                else if (circle.x > rect.right)
	                {
	                    overlap = DistanceBetween(circle.x, circle.y, rect.right, rect.y) - circle.radius;
	                }
	            }
	            else if (circle.y > rect.bottom)
	            {
	                if (circle.x < rect.x)
	                {
	                    overlap = DistanceBetween(circle.x, circle.y, rect.x, rect.bottom) - circle.radius;
	                }
	                else if (circle.x > rect.right)
	                {
	                    overlap = DistanceBetween(circle.x, circle.y, rect.right, rect.bottom) - circle.radius;
	                }
	            }
	
	            overlap *= -1;
	        }
	        else
	        {
	            overlap = (body1.halfWidth + body2.halfWidth) - DistanceBetween(body1.center.x, body1.center.y, body2.center.x, body2.center.y);
	        }
	
	        //  Can't separate two immovable bodies, or a body with its own custom separation logic
	        if (overlapOnly || overlap === 0 || (body1.immovable && body2.immovable) || body1.customSeparateX || body2.customSeparateX)
	        {
	            if (overlap !== 0 && (body1.onOverlap || body2.onOverlap))
	            {
	                this.emit('overlap', body1.gameObject, body2.gameObject, body1, body2);
	            }
	
	            //  return true if there was some overlap, otherwise false
	            return (overlap !== 0);
	        }
	
	        // Transform the velocity vector to the coordinate system oriented along the direction of impact.
	        // This is done to eliminate the vertical component of the velocity
	
	        var b1vx = body1.velocity.x;
	        var b1vy = body1.velocity.y;
	        var b1mass = body1.mass;
	
	        var b2vx = body2.velocity.x;
	        var b2vy = body2.velocity.y;
	        var b2mass = body2.mass;
	
	        var v1 = {
	            x: b1vx * Math.cos(angleCollision) + b1vy * Math.sin(angleCollision),
	            y: b1vx * Math.sin(angleCollision) - b1vy * Math.cos(angleCollision)
	        };
	
	        var v2 = {
	            x: b2vx * Math.cos(angleCollision) + b2vy * Math.sin(angleCollision),
	            y: b2vx * Math.sin(angleCollision) - b2vy * Math.cos(angleCollision)
	        };
	
	        // We expect the new velocity after impact
	        var tempVel1 = ((b1mass - b2mass) * v1.x + 2 * b2mass * v2.x) / (b1mass + b2mass);
	        var tempVel2 = (2 * b1mass * v1.x + (b2mass - b1mass) * v2.x) / (b1mass + b2mass);
	
	        // We convert the vector to the original coordinate system and multiplied by factor of rebound
	        if (!body1.immovable)
	        {
	            body1.velocity.x = (tempVel1 * Math.cos(angleCollision) - v1.y * Math.sin(angleCollision)) * body1.bounce.x;
	            body1.velocity.y = (v1.y * Math.cos(angleCollision) + tempVel1 * Math.sin(angleCollision)) * body1.bounce.y;
	
	            //  Reset local var
	            b1vx = body1.velocity.x;
	            b1vy = body1.velocity.y;
	        }
	
	        if (!body2.immovable)
	        {
	            body2.velocity.x = (tempVel2 * Math.cos(angleCollision) - v2.y * Math.sin(angleCollision)) * body2.bounce.x;
	            body2.velocity.y = (v2.y * Math.cos(angleCollision) + tempVel2 * Math.sin(angleCollision)) * body2.bounce.y;
	
	            //  Reset local var
	            b2vx = body2.velocity.x;
	            b2vy = body2.velocity.y;
	        }
	
	        // When the collision angle is almost perpendicular to the total initial velocity vector
	        // (collision on a tangent) vector direction can be determined incorrectly.
	        // This code fixes the problem
	
	        if (Math.abs(angleCollision) < Math.PI / 2)
	        {
	            if ((b1vx > 0) && !body1.immovable && (b2vx > b1vx))
	            {
	                body1.velocity.x *= -1;
	            }
	            else if ((b2vx < 0) && !body2.immovable && (b1vx < b2vx))
	            {
	                body2.velocity.x *= -1;
	            }
	            else if ((b1vy > 0) && !body1.immovable && (b2vy > b1vy))
	            {
	                body1.velocity.y *= -1;
	            }
	            else if ((b2vy < 0) && !body2.immovable && (b1vy < b2vy))
	            {
	                body2.velocity.y *= -1;
	            }
	        }
	        else if (Math.abs(angleCollision) > Math.PI / 2)
	        {
	            if ((b1vx < 0) && !body1.immovable && (b2vx < b1vx))
	            {
	                body1.velocity.x *= -1;
	            }
	            else if ((b2vx > 0) && !body2.immovable && (b1vx > b2vx))
	            {
	                body2.velocity.x *= -1;
	            }
	            else if ((b1vy < 0) && !body1.immovable && (b2vy < b1vy))
	            {
	                body1.velocity.y *= -1;
	            }
	            else if ((b2vy > 0) && !body2.immovable && (b1vx > b2vy))
	            {
	                body2.velocity.y *= -1;
	            }
	        }
	
	        if (!body1.immovable)
	        {
	            body1.x += (body1.velocity.x * this.delta) - overlap * Math.cos(angleCollision);
	            body1.y += (body1.velocity.y * this.delta) - overlap * Math.sin(angleCollision);
	        }
	
	        if (!body2.immovable)
	        {
	            body2.x += (body2.velocity.x * this.delta) + overlap * Math.cos(angleCollision);
	            body2.y += (body2.velocity.y * this.delta) + overlap * Math.sin(angleCollision);
	        }
	
	        if (body1.onCollide || body2.onCollide)
	        {
	            this.emit('collide', body1.gameObject, body2.gameObject, body1, body2);
	        }
	
	        return true;
	    },
	
	    /**
	     * Tests of two bodies intersect (overlap).
	     *
	     * @method Phaser.Physics.Arcade.World#intersects
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Arcade.Body} body1 - [description]
	     * @param {Phaser.Physics.Arcade.Body} body2 - [description]
	     *
	     * @return {boolean} [description]
	     */
	    intersects: function (body1, body2)
	    {
	        if (body1 === body2)
	        {
	            return false;
	        }
	
	        if (body1.isCircle)
	        {
	            if (body2.isCircle)
	            {
	                //  Circle vs. Circle
	                return DistanceBetween(body1.center.x, body1.center.y, body2.center.x, body2.center.y) <= (body1.halfWidth + body2.halfWidth);
	            }
	            else
	            {
	                //  Circle vs. Rect
	                return this.circleBodyIntersects(body1, body2);
	            }
	        }
	        else if (body2.isCircle)
	        {
	            //  Rect vs. Circle
	            return this.circleBodyIntersects(body2, body1);
	        }
	        else
	        {
	            //  Rect vs. Rect
	            if (body1.right <= body2.position.x)
	            {
	                return false;
	            }
	
	            if (body1.bottom <= body2.position.y)
	            {
	                return false;
	            }
	
	            if (body1.position.x >= body2.right)
	            {
	                return false;
	            }
	
	            if (body1.position.y >= body2.bottom)
	            {
	                return false;
	            }
	
	            return true;
	        }
	    },
	
	    /**
	     * Tests if a circular Body intersects with another Body.
	     *
	     * @method Phaser.Physics.Arcade.World#circleBodyIntersects
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Arcade.Body} circle - [description]
	     * @param {Phaser.Physics.Arcade.Body} body - [description]
	     *
	     * @return {boolean} [description]
	     */
	    circleBodyIntersects: function (circle, body)
	    {
	        var x = Clamp(circle.center.x, body.left, body.right);
	        var y = Clamp(circle.center.y, body.top, body.bottom);
	
	        var dx = (circle.center.x - x) * (circle.center.x - x);
	        var dy = (circle.center.y - y) * (circle.center.y - y);
	
	        return (dx + dy) <= (circle.halfWidth * circle.halfWidth);
	    },
	
	    /**
	     * Tests if Game Objects overlap.
	     *
	     * @method Phaser.Physics.Arcade.World#overlap
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} object1 - [description]
	     * @param {Phaser.GameObjects.GameObject} object2 - [description]
	     * @param {ArcadePhysicsCallback} [overlapCallback] - [description]
	     * @param {ArcadePhysicsCallback} [processCallback] - [description]
	     * @param {*} [callbackContext] - [description]
	     *
	     * @return {boolean} True if at least one Game Object overlaps another.
	     */
	    overlap: function (object1, object2, overlapCallback, processCallback, callbackContext)
	    {
	        if (overlapCallback === undefined) { overlapCallback = null; }
	        if (processCallback === undefined) { processCallback = null; }
	        if (callbackContext === undefined) { callbackContext = overlapCallback; }
	
	        return this.collideObjects(object1, object2, overlapCallback, processCallback, callbackContext, true);
	    },
	
	    /**
	     * Tests if Game Objects overlap and separates them (if possible).
	     *
	     * @method Phaser.Physics.Arcade.World#collide
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} object1 - [description]
	     * @param {Phaser.GameObjects.GameObject} object2 - [description]
	     * @param {ArcadePhysicsCallback} [collideCallback] - [description]
	     * @param {ArcadePhysicsCallback} [processCallback] - [description]
	     * @param {*} [callbackContext] - [description]
	     *
	     * @return {boolean} True if any overlapping Game Objects were separated.
	     */
	    collide: function (object1, object2, collideCallback, processCallback, callbackContext)
	    {
	        if (collideCallback === undefined) { collideCallback = null; }
	        if (processCallback === undefined) { processCallback = null; }
	        if (callbackContext === undefined) { callbackContext = collideCallback; }
	
	        return this.collideObjects(object1, object2, collideCallback, processCallback, callbackContext, false);
	    },
	
	    /**
	     * Helper for Phaser.Physics.Arcade.World#collide.
	     *
	     * @method Phaser.Physics.Arcade.World#collideObjects
	     * @since 3.0.0
	     *
	     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} object1 - [description]
	     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} object2 - [description]
	     * @param {ArcadePhysicsCallback} collideCallback - [description]
	     * @param {ArcadePhysicsCallback} processCallback - [description]
	     * @param {*} callbackContext - [description]
	     * @param {boolean} overlapOnly - [description]
	     *
	     * @return {boolean} True if any overlapping objects were separated.
	     */
	    collideObjects: function (object1, object2, collideCallback, processCallback, callbackContext, overlapOnly)
	    {
	        var i;
	        object1 = object1.isParent && typeof(object1.physicsType) === 'undefined' ? object1.children.entries : object1;
	        object2 = object2.isParent && typeof(object2.physicsType) === 'undefined' ? object2.children.entries : object2;
	        var object1isArray = Array.isArray(object1);
	        var object2isArray = Array.isArray(object2);
	
	        this._total = 0;
	
	        if (!object1isArray && !object2isArray)
	        {
	            //  Neither of them are arrays - do this first as it's the most common use-case
	            this.collideHandler(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
	        }
	        else if (!object1isArray && object2isArray)
	        {
	            //  Object 2 is an Array
	            for (i = 0; i < object2.length; i++)
	            {
	                this.collideHandler(object1, object2[i], collideCallback, processCallback, callbackContext, overlapOnly);
	            }
	        }
	        else if (object1isArray && !object2isArray)
	        {
	            //  Object 1 is an Array
	            for (i = 0; i < object1.length; i++)
	            {
	                this.collideHandler(object1[i], object2, collideCallback, processCallback, callbackContext, overlapOnly);
	            }
	        }
	        else
	        {
	            //  They're both arrays
	            for (i = 0; i < object1.length; i++)
	            {
	                for (var j = 0; j < object2.length; j++)
	                {
	                    this.collideHandler(object1[i], object2[j], collideCallback, processCallback, callbackContext, overlapOnly);
	                }
	            }
	        }
	
	        return (this._total > 0);
	    },
	
	    /**
	     * Helper for Phaser.Physics.Arcade.World#collide and Phaser.Physics.Arcade.World#overlap.
	     *
	     * @method Phaser.Physics.Arcade.World#collideHandler
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} object1 - [description]
	     * @param {Phaser.GameObjects.GameObject} object2 - [description]
	     * @param {ArcadePhysicsCallback} collideCallback - [description]
	     * @param {ArcadePhysicsCallback} processCallback - [description]
	     * @param {*} callbackContext - [description]
	     * @param {boolean} overlapOnly - [description]
	     *
	     * @return {boolean} [description]
	     */
	    collideHandler: function (object1, object2, collideCallback, processCallback, callbackContext, overlapOnly)
	    {
	        //  Collide Group with Self
	        //  Only collide valid objects
	        if (object2 === undefined && object1.isParent)
	        {
	            return this.collideGroupVsGroup(object1, object1, collideCallback, processCallback, callbackContext, overlapOnly);
	        }
	
	        //  If neither of the objects are set then bail out
	        if (!object1 || !object2)
	        {
	            return false;
	        }
	
	        //  A Body
	        if (object1.body)
	        {
	            if (object2.body)
	            {
	                return this.collideSpriteVsSprite(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
	            }
	            else if (object2.isParent)
	            {
	                return this.collideSpriteVsGroup(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
	            }
	            else if (object2.isTilemap)
	            {
	                return this.collideSpriteVsTilemapLayer(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
	            }
	        }
	
	        //  GROUPS
	        else if (object1.isParent)
	        {
	            if (object2.body)
	            {
	                return this.collideSpriteVsGroup(object2, object1, collideCallback, processCallback, callbackContext, overlapOnly);
	            }
	            else if (object2.isParent)
	            {
	                return this.collideGroupVsGroup(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
	            }
	            else if (object2.isTilemap)
	            {
	                return this.collideGroupVsTilemapLayer(object1, object2, collideCallback, processCallback, callbackContext, overlapOnly);
	            }
	        }
	
	        //  TILEMAP LAYERS
	        else if (object1.isTilemap)
	        {
	            if (object2.body)
	            {
	                return this.collideSpriteVsTilemapLayer(object2, object1, collideCallback, processCallback, callbackContext, overlapOnly);
	            }
	            else if (object2.isParent)
	            {
	                return this.collideGroupVsTilemapLayer(object2, object1, collideCallback, processCallback, callbackContext, overlapOnly);
	            }
	        }
	    },
	
	    /**
	     * Handler for Sprite vs. Sprite collisions.
	     *
	     * @method Phaser.Physics.Arcade.World#collideSpriteVsSprite
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} sprite1 - [description]
	     * @param {Phaser.GameObjects.GameObject} sprite2 - [description]
	     * @param {ArcadePhysicsCallback} collideCallback - [description]
	     * @param {ArcadePhysicsCallback} processCallback - [description]
	     * @param {*} callbackContext - [description]
	     * @param {boolean} overlapOnly - [description]
	     *
	     * @return {boolean} [description]
	     */
	    collideSpriteVsSprite: function (sprite1, sprite2, collideCallback, processCallback, callbackContext, overlapOnly)
	    {
	        if (!sprite1.body || !sprite2.body)
	        {
	            return false;
	        }
	
	        if (this.separate(sprite1.body, sprite2.body, processCallback, callbackContext, overlapOnly))
	        {
	            if (collideCallback)
	            {
	                collideCallback.call(callbackContext, sprite1, sprite2);
	            }
	
	            this._total++;
	        }
	
	        return true;
	    },
	
	    /**
	     * Handler for Sprite vs. Group collisions.
	     *
	     * @method Phaser.Physics.Arcade.World#collideSpriteVsGroup
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} sprite - [description]
	     * @param {Phaser.GameObjects.Group} group - [description]
	     * @param {ArcadePhysicsCallback} collideCallback - [description]
	     * @param {ArcadePhysicsCallback} processCallback - [description]
	     * @param {*} callbackContext - [description]
	     * @param {boolean} overlapOnly - [description]
	     *
	     * @return {boolean} [description]
	     */
	    collideSpriteVsGroup: function (sprite, group, collideCallback, processCallback, callbackContext, overlapOnly)
	    {
	        var bodyA = sprite.body;
	
	        if (group.length === 0 || !bodyA)
	        {
	            return;
	        }
	
	        //  Does sprite collide with anything?
	
	        var minMax = this.treeMinMax;
	
	        minMax.minX = bodyA.left;
	        minMax.minY = bodyA.top;
	        minMax.maxX = bodyA.right;
	        minMax.maxY = bodyA.bottom;
	
	        var results = (group.physicsType === CONST.DYNAMIC_BODY) ? this.tree.search(minMax) : this.staticTree.search(minMax);
	
	        if (results.length === 0)
	        {
	            return;
	        }
	
	        var children = group.getChildren();
	
	        for (var i = 0; i < children.length; i++)
	        {
	            var bodyB = children[i].body;
	
	            if (!bodyB || bodyA === bodyB || results.indexOf(bodyB) === -1)
	            {
	                continue;
	            }
	
	            if (this.separate(bodyA, bodyB, processCallback, callbackContext, overlapOnly))
	            {
	                if (collideCallback)
	                {
	                    collideCallback.call(callbackContext, bodyA.gameObject, bodyB.gameObject);
	                }
	
	                this._total++;
	            }
	        }
	    },
	
	    /**
	     * Helper for Group vs. Tilemap collisions.
	     *
	     * @method Phaser.Physics.Arcade.World#collideGroupVsTilemapLayer
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Group} group - [description]
	     * @param {(Phaser.Tilemaps.DynamicTilemapLayer|Phaser.Tilemaps.StaticTilemapLayer)} tilemapLayer - [description]
	     * @param {ArcadePhysicsCallback} collideCallback - [description]
	     * @param {ArcadePhysicsCallback} processCallback - [description]
	     * @param {*} callbackContext - [description]
	     * @param {boolean} overlapOnly - [description]
	     *
	     * @return {boolean} [description]
	     */
	    collideGroupVsTilemapLayer: function (group, tilemapLayer, collideCallback, processCallback, callbackContext, overlapOnly)
	    {
	        var children = group.getChildren();
	
	        if (children.length === 0)
	        {
	            return false;
	        }
	
	        var didCollide = false;
	
	        for (var i = 0; i < children.length; i++)
	        {
	            if (children[i].body)
	            {
	                if (this.collideSpriteVsTilemapLayer(children[i], tilemapLayer, collideCallback, processCallback, callbackContext, overlapOnly))
	                {
	                    didCollide = true;
	                }
	            }
	        }
	
	        return didCollide;
	    },
	
	    /**
	     * Helper for Sprite vs. Tilemap collisions.
	     *
	     * @method Phaser.Physics.Arcade.World#collideSpriteVsTilemapLayer
	     * @fires Phaser.Physics.Arcade.World#collide
	     * @fires Phaser.Physics.Arcade.World#overlap
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} sprite - [description]
	     * @param {(Phaser.Tilemaps.DynamicTilemapLayer|Phaser.Tilemaps.StaticTilemapLayer)} tilemapLayer - [description]
	     * @param {ArcadePhysicsCallback} collideCallback - [description]
	     * @param {ArcadePhysicsCallback} processCallback - [description]
	     * @param {*} callbackContext - [description]
	     * @param {boolean} overlapOnly - [description]
	     *
	     * @return {boolean} [description]
	     */
	    collideSpriteVsTilemapLayer: function (sprite, tilemapLayer, collideCallback, processCallback, callbackContext, overlapOnly)
	    {
	        var body = sprite.body;
	
	        if (!body.enable)
	        {
	            return false;
	        }
	
	        var x = body.position.x;
	        var y = body.position.y;
	        var w = body.width;
	        var h = body.height;
	
	        // TODO: this logic should be encapsulated within the Tilemap API at some point.
	        // If the maps base tile size differs from the layer's tile size, we need to adjust the
	        // selection area by the difference between the two.
	        var layerData = tilemapLayer.layer;
	
	        if (layerData.tileWidth > layerData.baseTileWidth)
	        {
	            // The x origin of a tile is the left side, so x and width need to be adjusted.
	            var xDiff = (layerData.tileWidth - layerData.baseTileWidth) * tilemapLayer.scaleX;
	            x -= xDiff;
	            w += xDiff;
	        }
	
	        if (layerData.tileHeight > layerData.baseTileHeight)
	        {
	            // The y origin of a tile is the bottom side, so just the height needs to be adjusted.
	            var yDiff = (layerData.tileHeight - layerData.baseTileHeight) * tilemapLayer.scaleY;
	            h += yDiff;
	        }
	
	        var mapData = tilemapLayer.getTilesWithinWorldXY(x, y, w, h);
	
	        if (mapData.length === 0)
	        {
	            return false;
	        }
	
	        var tile;
	        var tileWorldRect = { left: 0, right: 0, top: 0, bottom: 0 };
	
	        for (var i = 0; i < mapData.length; i++)
	        {
	            tile = mapData[i];
	            tileWorldRect.left = tilemapLayer.tileToWorldX(tile.x);
	            tileWorldRect.top = tilemapLayer.tileToWorldY(tile.y);
	
	            // If the map's base tile size differs from the layer's tile size, only the top of the rect
	            // needs to be adjusted since it's origin is (0, 1).
	            if (tile.baseHeight !== tile.height)
	            {
	                tileWorldRect.top -= (tile.height - tile.baseHeight) * tilemapLayer.scaleY;
	            }
	
	            tileWorldRect.right = tileWorldRect.left + tile.width * tilemapLayer.scaleX;
	            tileWorldRect.bottom = tileWorldRect.top + tile.height * tilemapLayer.scaleY;
	
	            if (TileIntersectsBody(tileWorldRect, body)
	                && (!processCallback || processCallback.call(callbackContext, sprite, tile))
	                && ProcessTileCallbacks(tile, sprite)
	                && (overlapOnly || SeparateTile(i, body, tile, tileWorldRect, tilemapLayer, this.TILE_BIAS)))
	            {
	                this._total++;
	
	                if (collideCallback)
	                {
	                    collideCallback.call(callbackContext, sprite, tile);
	                }
	
	                if (overlapOnly && body.onOverlap)
	                {
	                    sprite.emit('overlap', body.gameObject, tile, body, null);
	                }
	                else if (body.onCollide)
	                {
	                    sprite.emit('collide', body.gameObject, tile, body, null);
	                }
	            }
	        }
	    },
	
	    /**
	     * Helper for Group vs. Group collisions.
	     *
	     * @method Phaser.Physics.Arcade.World#collideGroupVsGroup
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Group} group1 - [description]
	     * @param {Phaser.GameObjects.Group} group2 - [description]
	     * @param {ArcadePhysicsCallback} collideCallback - [description]
	     * @param {ArcadePhysicsCallback} processCallback - [description]
	     * @param {*} callbackContext - [description]
	     * @param {boolean} overlapOnly - [description]
	     *
	     * @return {boolean} [description]
	     */
	    collideGroupVsGroup: function (group1, group2, collideCallback, processCallback, callbackContext, overlapOnly)
	    {
	        if (group1.length === 0 || group2.length === 0)
	        {
	            return;
	        }
	
	        var children = group1.getChildren();
	
	        for (var i = 0; i < children.length; i++)
	        {
	            this.collideSpriteVsGroup(children[i], group2, collideCallback, processCallback, callbackContext, overlapOnly);
	        }
	    },
	
	    /**
	    * Wrap an object's coordinates (or several objects' coordinates) within {@link Phaser.Physics.Arcade.World#bounds}.
	    *
	    * If the object is outside any boundary edge (left, top, right, bottom), it will be moved to the same offset from the opposite edge (the interior).
	    *
	    * @method Phaser.Physics.Arcade.World#wrap
	    * @since 3.3.0
	    *
	    * @param {*} object - A Game Object, a Group, an object with `x` and `y` coordinates, or an array of such objects.
	    * @param {number} [padding=0] - An amount added to each boundary edge during the operation.
	    */
	    wrap: function (object, padding)
	    {
	        if (object.body)
	        {
	            this.wrapObject(object, padding);
	        }
	        else if (object.getChildren)
	        {
	            this.wrapArray(object.getChildren(), padding);
	        }
	        else if (Array.isArray(object))
	        {
	            this.wrapArray(object, padding);
	        }
	        else
	        {
	            this.wrapObject(object, padding);
	        }
	    },
	
	
	    /**
	    * Wrap each object's coordinates within {@link Phaser.Physics.Arcade.World#bounds}.
	    *
	    * @method Phaser.Physics.Arcade.World#wrapArray
	    * @since 3.3.0
	    *
	    * @param {Array.<*>} arr
	    * @param {number} [padding=0] - An amount added to the boundary.
	    */
	    wrapArray: function (arr, padding)
	    {
	        if (arr.length === 0)
	        {
	            return;
	        }
	
	        for (var i = 0, len = arr.length; i < len; i++)
	        {
	            this.wrapObject(arr[i], padding);
	        }
	    },
	
	    /**
	    * Wrap an object's coordinates within {@link Phaser.Physics.Arcade.World#bounds}.
	    *
	    * @method Phaser.Physics.Arcade.World#wrapObject
	    * @since 3.3.0
	    *
	    * @param {*} object - A Game Object, a Physics Body, or any object with `x` and `y` coordinates
	    * @param {number} [padding=0] - An amount added to the boundary.
	    */
	    wrapObject: function (object, padding)
	    {
	        if (padding === undefined)
	        {
	            padding = 0;
	        }
	
	        object.x = Wrap(object.x, this.bounds.left - padding, this.bounds.right + padding);
	        object.y = Wrap(object.y, this.bounds.top - padding, this.bounds.bottom + padding);
	    },
	
	    /**
	     * Shuts down the simulation, clearing physics data and removing listeners.
	     *
	     * @method Phaser.Physics.Arcade.World#shutdown
	     * @since 3.0.0
	     */
	    shutdown: function ()
	    {
	        this.tree.clear();
	        this.staticTree.clear();
	        this.bodies.clear();
	        this.staticBodies.clear();
	        this.colliders.destroy();
	
	        this.removeAllListeners();
	    },
	
	    /**
	     * Shuts down the simulation and disconnects it from the current scene.
	     *
	     * @method Phaser.Physics.Arcade.World#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.shutdown();
	
	        this.scene = null;
	    }
	
	});
	
	module.exports = World;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Physics.Arcade.Components
	 */
	
	module.exports = {
	
	    Acceleration: __webpack_require__(1428),
	    Angular: __webpack_require__(1429),
	    Bounce: __webpack_require__(1430),
	    Debug: __webpack_require__(1431),
	    Drag: __webpack_require__(1432),
	    Enable: __webpack_require__(1433),
	    Friction: __webpack_require__(1434),
	    Gravity: __webpack_require__(1435),
	    Immovable: __webpack_require__(1436),
	    Mass: __webpack_require__(1437),
	    Size: __webpack_require__(1438),
	    Velocity: __webpack_require__(1439)
	
	};


/***/ }),
/* 591 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Physics.Arcade.Tilemap.TileIntersectsBody
	 * @since 3.0.0
	 *
	 * @param {{ left: number, right: number, top: number, bottom: number }} tileWorldRect - [description]
	 * @param {Phaser.Physics.Arcade.Body} body - [description]
	 *
	 * @return {boolean} [description]
	 */
	var TileIntersectsBody = function (tileWorldRect, body)
	{
	    // Currently, all bodies are treated as rectangles when colliding with a Tile. Eventually, this
	    // should support circle bodies when those are less buggy in v3.
	
	    return !(
	        body.right <= tileWorldRect.left ||
	        body.bottom <= tileWorldRect.top ||
	        body.position.x >= tileWorldRect.right ||
	        body.position.y >= tileWorldRect.bottom
	    );
	};
	
	module.exports = TileIntersectsBody;


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var COLLIDES = __webpack_require__(164);
	var GetVelocity = __webpack_require__(1448);
	var TYPE = __webpack_require__(165);
	var UpdateMotion = __webpack_require__(1453);
	
	/**
	 * @callback BodyUpdateCallback
	 *
	 * @param {Phaser.Physics.Impact.Body} body - [description]
	 */
	
	/**
	 * @typedef {object} JSONImpactBody
	 * @todo Replace object types
	 *
	 * @property {string} name - [description]
	 * @property {object} size - [description]
	 * @property {object} pos - [description]
	 * @property {object} vel - [description]
	 * @property {object} accel - [description]
	 * @property {object} friction - [description]
	 * @property {object} maxVel - [description]
	 * @property {number} gravityFactor - [description]
	 * @property {number} bounciness - [description]
	 * @property {number} minBounceVelocity - [description]
	 * @property {Phaser.Physics.Impact.TYPE} type - [description]
	 * @property {Phaser.Physics.Impact.TYPE} checkAgainst - [description]
	 * @property {Phaser.Physics.Impact.COLLIDES} collides - [description]
	 */
	
	/**
	 * @classdesc
	 * An Impact.js compatible physics body.
	 * This re-creates the properties you'd get on an Entity and the math needed to update them.
	 *
	 * @class Body
	 * @memberOf Phaser.Physics.Impact
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Physics.Impact.World} world - [description]
	 * @param {number} x - [description]
	 * @param {number} y - [description]
	 * @param {number} [sx=16] - [description]
	 * @param {number} [sy=16] - [description]
	 */
	var Body = new Class({
	
	    initialize:
	
	    function Body (world, x, y, sx, sy)
	    {
	        if (sx === undefined) { sx = 16; }
	        if (sy === undefined) { sy = sx; }
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#world
	         * @type {Phaser.Physics.Impact.World}
	         * @since 3.0.0
	         */
	        this.world = world;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#gameObject
	         * @type {Phaser.GameObjects.GameObject}
	         * @default null
	         * @since 3.0.0
	         */
	        this.gameObject = null;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#enabled
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.enabled = true;
	
	        /**
	         * The ImpactBody, ImpactSprite or ImpactImage object that owns this Body, if any.
	         *
	         * @name Phaser.Physics.Impact.Body#parent
	         * @type {?(Phaser.Physics.Impact.ImpactBody|Phaser.Physics.Impact.ImpactImage|Phaser.Physics.Impact.ImpactSprite)}
	         * @since 3.0.0
	         */
	        this.parent;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#id
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.id = world.getNextID();
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#name
	         * @type {string}
	         * @default ''
	         * @since 3.0.0
	         */
	        this.name = '';
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#size
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.size = { x: sx, y: sy };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#offset
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.offset = { x: 0, y: 0 };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#pos
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.pos = { x: x, y: y };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#last
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.last = { x: x, y: y };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#vel
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.vel = { x: 0, y: 0 };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#accel
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.accel = { x: 0, y: 0 };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#friction
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.friction = { x: 0, y: 0 };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#maxVel
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.maxVel = { x: world.defaults.maxVelocityX, y: world.defaults.maxVelocityY };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#standing
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.standing = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#gravityFactor
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.gravityFactor = world.defaults.gravityFactor;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#bounciness
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.bounciness = world.defaults.bounciness;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#minBounceVelocity
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.minBounceVelocity = world.defaults.minBounceVelocity;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#accelGround
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.accelGround = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#accelAir
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.accelAir = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#jumpSpeed
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.jumpSpeed = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#type
	         * @type {Phaser.Physics.Impact.TYPE}
	         * @since 3.0.0
	         */
	        this.type = TYPE.NONE;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#checkAgainst
	         * @type {Phaser.Physics.Impact.TYPE}
	         * @since 3.0.0
	         */
	        this.checkAgainst = TYPE.NONE;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#collides
	         * @type {Phaser.Physics.Impact.COLLIDES}
	         * @since 3.0.0
	         */
	        this.collides = COLLIDES.NEVER;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#debugShowBody
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.debugShowBody = world.defaults.debugShowBody;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#debugShowVelocity
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.debugShowVelocity = world.defaults.debugShowVelocity;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#debugBodyColor
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.debugBodyColor = world.defaults.bodyDebugColor;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Body#updateCallback
	         * @type {?BodyUpdateCallback}
	         * @since 3.0.0
	         */
	        this.updateCallback;
	
	        /**
	         * min 44 deg, max 136 deg
	         *
	         * @name Phaser.Physics.Impact.Body#slopeStanding
	         * @type {{ min: number, max: number }}
	         * @since 3.0.0
	         */
	        this.slopeStanding = { min: 0.767944870877505, max: 2.3736477827122884 };
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Body#reset
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     */
	    reset: function (x, y)
	    {
	        this.pos = { x: x, y: y };
	        this.last = { x: x, y: y };
	        this.vel = { x: 0, y: 0 };
	        this.accel = { x: 0, y: 0 };
	        this.friction = { x: 0, y: 0 };
	        this.maxVel = { x: 100, y: 100 };
	
	        this.standing = false;
	
	        this.gravityFactor = 1;
	        this.bounciness = 0;
	        this.minBounceVelocity = 40;
	
	        this.accelGround = 0;
	        this.accelAir = 0;
	        this.jumpSpeed = 0;
	
	        this.type = TYPE.NONE;
	        this.checkAgainst = TYPE.NONE;
	        this.collides = COLLIDES.NEVER;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Body#update
	     * @since 3.0.0
	     *
	     * @param {number} delta - [description]
	     */
	    update: function (delta)
	    {
	        var pos = this.pos;
	
	        this.last.x = pos.x;
	        this.last.y = pos.y;
	
	        this.vel.y += this.world.gravity * delta * this.gravityFactor;
	
	        this.vel.x = GetVelocity(delta, this.vel.x, this.accel.x, this.friction.x, this.maxVel.x);
	        this.vel.y = GetVelocity(delta, this.vel.y, this.accel.y, this.friction.y, this.maxVel.y);
	
	        var mx = this.vel.x * delta;
	        var my = this.vel.y * delta;
	
	        var res = this.world.collisionMap.trace(pos.x, pos.y, mx, my, this.size.x, this.size.y);
	
	        if (this.handleMovementTrace(res))
	        {
	            UpdateMotion(this, res);
	        }
	
	        var go = this.gameObject;
	
	        if (go)
	        {
	            go.x = (pos.x - this.offset.x) + go.displayOriginX * go.scaleX;
	            go.y = (pos.y - this.offset.y) + go.displayOriginY * go.scaleY;
	        }
	
	        if (this.updateCallback)
	        {
	            this.updateCallback(this);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Body#drawDebug
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Graphics} graphic - [description]
	     */
	    drawDebug: function (graphic)
	    {
	        var pos = this.pos;
	
	        if (this.debugShowBody)
	        {
	            graphic.lineStyle(1, this.debugBodyColor, 1);
	            graphic.strokeRect(pos.x, pos.y, this.size.x, this.size.y);
	        }
	
	        if (this.debugShowVelocity)
	        {
	            var x = pos.x + this.size.x / 2;
	            var y = pos.y + this.size.y / 2;
	
	            graphic.lineStyle(1, this.world.defaults.velocityDebugColor, 1);
	            graphic.lineBetween(x, y, x + this.vel.x, y + this.vel.y);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Body#willDrawDebug
	     * @since 3.0.0
	     *
	     * @return {boolean} [description]
	     */
	    willDrawDebug: function ()
	    {
	        return (this.debugShowBody || this.debugShowVelocity);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Body#skipHash
	     * @since 3.0.0
	     *
	     * @return {boolean} [description]
	     */
	    skipHash: function ()
	    {
	        return (!this.enabled || (this.type === 0 && this.checkAgainst === 0 && this.collides === 0));
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Body#touches
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Impact.Body} other - [description]
	     *
	     * @return {boolean} [description]
	     */
	    touches: function (other)
	    {
	        return !(
	            this.pos.x >= other.pos.x + other.size.x ||
	            this.pos.x + this.size.x <= other.pos.x ||
	            this.pos.y >= other.pos.y + other.size.y ||
	            this.pos.y + this.size.y <= other.pos.y
	        );
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Body#resetSize
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     *
	     * @return {Phaser.Physics.Impact.Body} This Body object.
	     */
	    resetSize: function (x, y, width, height)
	    {
	        this.pos.x = x;
	        this.pos.y = y;
	        this.size.x = width;
	        this.size.y = height;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Body#toJSON
	     * @since 3.0.0
	     *
	     * @return {JSONImpactBody} [description]
	     */
	    toJSON: function ()
	    {
	        var output = {
	            name: this.name,
	            size: { x: this.size.x, y: this.size.y },
	            pos: { x: this.pos.x, y: this.pos.y },
	            vel: { x: this.vel.x, y: this.vel.y },
	            accel: { x: this.accel.x, y: this.accel.y },
	            friction: { x: this.friction.x, y: this.friction.y },
	            maxVel: { x: this.maxVel.x, y: this.maxVel.y },
	            gravityFactor: this.gravityFactor,
	            bounciness: this.bounciness,
	            minBounceVelocity: this.minBounceVelocity,
	            type: this.type,
	            checkAgainst: this.checkAgainst,
	            collides: this.collides
	        };
	
	        return output;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Body#fromJSON
	     * @todo Code it!
	     * @since 3.0.0
	     *
	     * @param {object} config - [description]
	     */
	    fromJSON: function ()
	    {
	    },
	
	    /**
	     * Can be overridden by user code
	     *
	     * @method Phaser.Physics.Impact.Body#check
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Impact.Body} other - [description]
	     */
	    check: function ()
	    {
	    },
	
	    /**
	     * Can be overridden by user code
	     *
	     * @method Phaser.Physics.Impact.Body#collideWith
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Impact.Body} other - [description]
	     * @param {string} axis - [description]
	     */
	    collideWith: function (other, axis)
	    {
	        if (this.parent && this.parent._collideCallback)
	        {
	            this.parent._collideCallback.call(this.parent._callbackScope, this, other, axis);
	        }
	    },
	
	    /**
	     * Can be overridden by user code but must return a boolean.
	     *
	     * @method Phaser.Physics.Impact.Body#handleMovementTrace
	     * @since 3.0.0
	     *
	     * @param {number} res - [description]
	     *
	     * @return {boolean} [description]
	     */
	    handleMovementTrace: function ()
	    {
	        return true;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Body#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.world.remove(this);
	
	        this.enabled = false;
	
	        this.world = null;
	
	        this.gameObject = null;
	
	        this.parent = null;
	    }
	
	});
	
	module.exports = Body;


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var DefaultDefs = __webpack_require__(1447);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class CollisionMap
	 * @memberOf Phaser.Physics.Impact
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {integer} [tilesize=32] - [description]
	 * @param {array} [data] - [description]
	 */
	var CollisionMap = new Class({
	
	    initialize:
	
	    function CollisionMap (tilesize, data)
	    {
	        if (tilesize === undefined) { tilesize = 32; }
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.CollisionMap#tilesize
	         * @type {integer}
	         * @default 32
	         * @since 3.0.0
	         */
	        this.tilesize = tilesize;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.CollisionMap#data
	         * @type {array}
	         * @since 3.0.0
	         */
	        this.data = (Array.isArray(data)) ? data : [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.CollisionMap#width
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.width = (Array.isArray(data)) ? data[0].length : 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.CollisionMap#height
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.height = (Array.isArray(data)) ? data.length : 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.CollisionMap#lastSlope
	         * @type {integer}
	         * @default 55
	         * @since 3.0.0
	         */
	        this.lastSlope = 55;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.CollisionMap#tiledef
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.tiledef = DefaultDefs;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.CollisionMap#trace
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} vx - [description]
	     * @param {number} vy - [description]
	     * @param {number} objectWidth - [description]
	     * @param {number} objectHeight - [description]
	     *
	     * @return {boolean} [description]
	     */
	    trace: function (x, y, vx, vy, objectWidth, objectHeight)
	    {
	        // Set up the trace-result
	        var res = {
	            collision: { x: false, y: false, slope: false },
	            pos: { x: x + vx, y: y + vy },
	            tile: { x: 0, y: 0 }
	        };
	
	        if (!this.data)
	        {
	            return res;
	        }
	        
	        var steps = Math.ceil(Math.max(Math.abs(vx), Math.abs(vy)) / this.tilesize);
	
	        if (steps > 1)
	        {
	            var sx = vx / steps;
	            var sy = vy / steps;
	            
	            for (var i = 0; i < steps && (sx || sy); i++)
	            {
	                this.step(res, x, y, sx, sy, objectWidth, objectHeight, vx, vy, i);
	                
	                x = res.pos.x;
	                y = res.pos.y;
	
	                if (res.collision.x)
	                {
	                    sx = 0;
	                    vx = 0;
	                }
	
	                if (res.collision.y)
	                {
	                    sy = 0;
	                    vy = 0;
	                }
	
	                if (res.collision.slope)
	                {
	                    break;
	                }
	            }
	        }
	        else
	        {
	            this.step(res, x, y, vx, vy, objectWidth, objectHeight, vx, vy, 0);
	        }
	        
	        return res;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.CollisionMap#step
	     * @since 3.0.0
	     *
	     * @param {object} res - [description]
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} vx - [description]
	     * @param {number} vy - [description]
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     * @param {number} rvx - [description]
	     * @param {number} rvy - [description]
	     * @param {number} step - [description]
	     */
	    step: function (res, x, y, vx, vy, width, height, rvx, rvy, step)
	    {
	        var t = 0;
	        var tileX;
	        var tileY;
	        var tilesize = this.tilesize;
	        var mapWidth = this.width;
	        var mapHeight = this.height;
	        
	        //  Horizontal
	        if (vx)
	        {
	            var pxOffsetX = (vx > 0 ? width : 0);
	            var tileOffsetX = (vx < 0 ? tilesize : 0);
	            
	            var firstTileY = Math.max(Math.floor(y / tilesize), 0);
	            var lastTileY = Math.min(Math.ceil((y + height) / tilesize), mapHeight);
	            
	            tileX = Math.floor((res.pos.x + pxOffsetX) / tilesize);
	
	            var prevTileX = Math.floor((x + pxOffsetX) / tilesize);
	
	            if (step > 0 || tileX === prevTileX || prevTileX < 0 || prevTileX >= mapWidth)
	            {
	                prevTileX = -1;
	            }
	           
	            if (tileX >= 0 && tileX < mapWidth)
	            {
	                for (tileY = firstTileY; tileY < lastTileY; tileY++)
	                {
	                    if (prevTileX !== -1)
	                    {
	                        t = this.data[tileY][prevTileX];
	
	                        if (t > 1 && t <= this.lastSlope && this.checkDef(res, t, x, y, rvx, rvy, width, height, prevTileX, tileY))
	                        {
	                            break;
	                        }
	                    }
	                    
	                    t = this.data[tileY][tileX];
	
	                    if (t === 1 || t > this.lastSlope || (t > 1 && this.checkDef(res, t, x, y, rvx, rvy, width, height, tileX, tileY)))
	                    {
	                        if (t > 1 && t <= this.lastSlope && res.collision.slope)
	                        {
	                            break;
	                        }
	                        
	                        res.collision.x = true;
	                        res.tile.x = t;
	                        res.pos.x = (tileX * tilesize) - pxOffsetX + tileOffsetX;
	                        x = res.pos.x;
	                        rvx = 0;
	
	                        break;
	                    }
	                }
	            }
	        }
	        
	        //  Vertical
	        if (vy)
	        {
	            var pxOffsetY = (vy > 0 ? height : 0);
	            var tileOffsetY = (vy < 0 ? tilesize : 0);
	            
	            var firstTileX = Math.max(Math.floor(res.pos.x / tilesize), 0);
	            var lastTileX = Math.min(Math.ceil((res.pos.x + width) / tilesize), mapWidth);
	            
	            tileY = Math.floor((res.pos.y + pxOffsetY) / tilesize);
	            
	            var prevTileY = Math.floor((y + pxOffsetY) / tilesize);
	
	            if (step > 0 || tileY === prevTileY || prevTileY < 0 || prevTileY >= mapHeight)
	            {
	                prevTileY = -1;
	            }
	            
	            if (tileY >= 0 && tileY < mapHeight)
	            {
	                for (tileX = firstTileX; tileX < lastTileX; tileX++)
	                {
	                    if (prevTileY !== -1)
	                    {
	                        t = this.data[prevTileY][tileX];
	
	                        if (t > 1 && t <= this.lastSlope && this.checkDef(res, t, x, y, rvx, rvy, width, height, tileX, prevTileY))
	                        {
	                            break;
	                        }
	                    }
	                    
	                    t = this.data[tileY][tileX];
	
	                    if (t === 1 || t > this.lastSlope || (t > 1 && this.checkDef(res, t, x, y, rvx, rvy, width, height, tileX, tileY)))
	                    {
	                        if (t > 1 && t <= this.lastSlope && res.collision.slope)
	                        {
	                            break;
	                        }
	                        
	                        res.collision.y = true;
	                        res.tile.y = t;
	                        res.pos.y = tileY * tilesize - pxOffsetY + tileOffsetY;
	
	                        break;
	                    }
	                }
	            }
	        }
	    },
	    
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.CollisionMap#checkDef
	     * @since 3.0.0
	     *
	     * @param {object} res - [description]
	     * @param {number} t - [description]
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} vx - [description]
	     * @param {number} vy - [description]
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     * @param {number} tileX - [description]
	     * @param {number} tileY - [description]
	     *
	     * @return {boolean} [description]
	     */
	    checkDef: function (res, t, x, y, vx, vy, width, height, tileX, tileY)
	    {
	        var def = this.tiledef[t];
	
	        if (!def)
	        {
	            return false;
	        }
	
	        var tilesize = this.tilesize;
	        
	        var lx = (tileX + def[0]) * tilesize;
	        var ly = (tileY + def[1]) * tilesize;
	        var lvx = (def[2] - def[0]) * tilesize;
	        var lvy = (def[3] - def[1]) * tilesize;
	        var solid = def[4];
	        
	        var tx = x + vx + (lvy < 0 ? width : 0) - lx;
	        var ty = y + vy + (lvx > 0 ? height : 0) - ly;
	        
	        if (lvx * ty - lvy * tx > 0)
	        {
	            if (vx * -lvy + vy * lvx < 0)
	            {
	                return solid;
	            }
	            
	            var length = Math.sqrt(lvx * lvx + lvy * lvy);
	            var nx = lvy / length;
	            var ny = -lvx / length;
	            
	            var proj = tx * nx + ty * ny;
	            var px = nx * proj;
	            var py = ny * proj;
	            
	            if (px * px + py * py >= vx * vx + vy * vy)
	            {
	                return solid || (lvx * (ty - vy) - lvy * (tx - vx) < 0.5);
	            }
	            
	            res.pos.x = x + vx - px;
	            res.pos.y = y + vy - py;
	            res.collision.slope = { x: lvx, y: lvy, nx: nx, ny: ny };
	
	            return true;
	        }
	        
	        return false;
	    }
	
	});
	
	module.exports = CollisionMap;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var ImpactBody = __webpack_require__(595);
	var ImpactImage = __webpack_require__(596);
	var ImpactSprite = __webpack_require__(597);
	
	/**
	 * @classdesc
	 * The Impact Physics Factory allows you to easily create Impact Physics enabled Game Objects.
	 * Objects that are created by this Factory are automatically added to the physics world.
	 *
	 * @class Factory
	 * @memberOf Phaser.Physics.Impact
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Physics.Impact.World} world - [description]
	 */
	var Factory = new Class({
	
	    initialize:
	
	    function Factory (world)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.Factory#world
	         * @type {Phaser.Physics.Impact.World}
	         * @since 3.0.0
	         */
	        this.world = world;
	
	        /**
	         * A reference to the Scene.Systems this Impact Physics instance belongs to.
	         *
	         * @name Phaser.Physics.Impact.Factory#sys
	         * @type {Phaser.Scenes.Systems}
	         * @since 3.0.0
	         */
	        this.sys = world.scene.sys;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Factory#body
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     *
	     * @return {Phaser.Physics.Impact.ImpactBody} The ImpactBody object that was created.
	     */
	    body: function (x, y, width, height)
	    {
	        return new ImpactBody(this.world, x, y, width, height);
	    },
	
	    /**
	     * Adds an Impact Physics Body to the given Game Object.
	     *
	     * @method Phaser.Physics.Impact.Factory#existing
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} gameObject - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} The Game Object.
	     */
	    existing: function (gameObject)
	    {
	        var x = gameObject.x - gameObject.frame.centerX;
	        var y = gameObject.y - gameObject.frame.centerY;
	        var w = gameObject.width;
	        var h = gameObject.height;
	
	        gameObject.body = this.world.create(x, y, w, h);
	
	        gameObject.body.parent = gameObject;
	        gameObject.body.gameObject = gameObject;
	
	        return gameObject;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Factory#image
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal position of this Game Object in the world.
	     * @param {number} y - The vertical position of this Game Object in the world.
	     * @param {string} key - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	     * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	     *
	     * @return {Phaser.Physics.Impact.ImpactImage} The ImpactImage object that was created.
	     */
	    image: function (x, y, key, frame)
	    {
	        var image = new ImpactImage(this.world, x, y, key, frame);
	
	        this.sys.displayList.add(image);
	
	        return image;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Factory#sprite
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal position of this Game Object in the world.
	     * @param {number} y - The vertical position of this Game Object in the world.
	     * @param {string} key - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	     * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	     *
	     * @return {Phaser.Physics.Impact.ImpactSprite} The ImpactSprite object that was created.
	     */
	    sprite: function (x, y, key, frame)
	    {
	        var sprite = new ImpactSprite(this.world, x, y, key, frame);
	
	        this.sys.displayList.add(sprite);
	        this.sys.updateList.add(sprite);
	
	        return sprite;
	    },
	
	    /**
	     * Destroys this Factory.
	     *
	     * @method Phaser.Physics.Impact.Factory#destroy
	     * @since 3.5.0
	     */
	    destroy: function ()
	    {
	        this.world = null;
	        this.sys = null;
	    }
	
	});
	
	module.exports = Factory;


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(314);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class ImpactBody
	 * @memberOf Phaser.Physics.Impact
	 * @constructor
	 * @since 3.0.0
	 *
	 * @extends Phaser.Physics.Impact.Components.Acceleration
	 * @extends Phaser.Physics.Impact.Components.BodyScale
	 * @extends Phaser.Physics.Impact.Components.BodyType
	 * @extends Phaser.Physics.Impact.Components.Bounce
	 * @extends Phaser.Physics.Impact.Components.CheckAgainst
	 * @extends Phaser.Physics.Impact.Components.Collides
	 * @extends Phaser.Physics.Impact.Components.Debug
	 * @extends Phaser.Physics.Impact.Components.Friction
	 * @extends Phaser.Physics.Impact.Components.Gravity
	 * @extends Phaser.Physics.Impact.Components.Offset
	 * @extends Phaser.Physics.Impact.Components.SetGameObject
	 * @extends Phaser.Physics.Impact.Components.Velocity
	 *
	 * @param {Phaser.Physics.Impact.World} world - [description]
	 * @param {number} x - [description]
	 * @param {number} y - [description]
	 * @param {number} width - [description]
	 * @param {number} height - [description]
	 */
	var ImpactBody = new Class({
	
	    Mixins: [
	        Components.Acceleration,
	        Components.BodyScale,
	        Components.BodyType,
	        Components.Bounce,
	        Components.CheckAgainst,
	        Components.Collides,
	        Components.Debug,
	        Components.Friction,
	        Components.Gravity,
	        Components.Offset,
	        Components.SetGameObject,
	        Components.Velocity
	    ],
	
	    initialize:
	
	    function ImpactBody (world, x, y, width, height)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactBody#body
	         * @type {Phaser.Physics.Impact.Body}
	         * @since 3.0.0
	         */
	        this.body = world.create(x, y, width, height);
	
	        this.body.parent = this;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactBody#size
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.size = this.body.size;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactBody#offset
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.offset = this.body.offset;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactBody#vel
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.vel = this.body.vel;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactBody#accel
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.accel = this.body.accel;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactBody#friction
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.friction = this.body.friction;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactBody#maxVel
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.maxVel = this.body.maxVel;
	    }
	
	});
	
	module.exports = ImpactBody;


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(314);
	var Image = __webpack_require__(138);
	
	/**
	 * @classdesc
	 * An Impact Physics Image Game Object.
	 * 
	 * An Image is a light-weight Game Object useful for the display of static images in your game,
	 * such as logos, backgrounds, scenery or other non-animated elements. Images can have input
	 * events and physics bodies, or be tweened, tinted or scrolled. The main difference between an
	 * Image and a Sprite is that you cannot animate an Image as they do not have the Animation component.
	 *
	 * @class ImpactImage
	 * @extends Phaser.GameObjects.Image
	 * @memberOf Phaser.Physics.Impact
	 * @constructor
	 * @since 3.0.0
	 *
	 * @extends Phaser.Physics.Impact.Components.Acceleration
	 * @extends Phaser.Physics.Impact.Components.BodyScale
	 * @extends Phaser.Physics.Impact.Components.BodyType
	 * @extends Phaser.Physics.Impact.Components.Bounce
	 * @extends Phaser.Physics.Impact.Components.CheckAgainst
	 * @extends Phaser.Physics.Impact.Components.Collides
	 * @extends Phaser.Physics.Impact.Components.Debug
	 * @extends Phaser.Physics.Impact.Components.Friction
	 * @extends Phaser.Physics.Impact.Components.Gravity
	 * @extends Phaser.Physics.Impact.Components.Offset
	 * @extends Phaser.Physics.Impact.Components.SetGameObject
	 * @extends Phaser.Physics.Impact.Components.Velocity
	 * @extends Phaser.GameObjects.Components.Alpha
	 * @extends Phaser.GameObjects.Components.BlendMode
	 * @extends Phaser.GameObjects.Components.Depth
	 * @extends Phaser.GameObjects.Components.Flip
	 * @extends Phaser.GameObjects.Components.GetBounds
	 * @extends Phaser.GameObjects.Components.Origin
	 * @extends Phaser.GameObjects.Components.Pipeline
	 * @extends Phaser.GameObjects.Components.ScaleMode
	 * @extends Phaser.GameObjects.Components.ScrollFactor
	 * @extends Phaser.GameObjects.Components.Size
	 * @extends Phaser.GameObjects.Components.Texture
	 * @extends Phaser.GameObjects.Components.Tint
	 * @extends Phaser.GameObjects.Components.Transform
	 * @extends Phaser.GameObjects.Components.Visible
	 *
	 * @param {Phaser.Physics.Impact.World} world - [description]
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	 * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	 */
	var ImpactImage = new Class({
	
	    Extends: Image,
	
	    Mixins: [
	        Components.Acceleration,
	        Components.BodyScale,
	        Components.BodyType,
	        Components.Bounce,
	        Components.CheckAgainst,
	        Components.Collides,
	        Components.Debug,
	        Components.Friction,
	        Components.Gravity,
	        Components.Offset,
	        Components.SetGameObject,
	        Components.Velocity
	    ],
	
	    initialize:
	
	    function ImpactImage (world, x, y, texture, frame)
	    {
	        Image.call(this, world.scene, x, y, texture, frame);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactImage#body
	         * @type {Phaser.Physics.Impact.Body}
	         * @since 3.0.0
	         */
	        this.body = world.create(x - this.frame.centerX, y - this.frame.centerY, this.width, this.height);
	
	        this.body.parent = this;
	        this.body.gameObject = this;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactImage#size
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.size = this.body.size;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactImage#offset
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.offset = this.body.offset;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactImage#vel
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.vel = this.body.vel;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactImage#accel
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.accel = this.body.accel;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactImage#friction
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.friction = this.body.friction;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactImage#maxVel
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.maxVel = this.body.maxVel;
	    }
	
	});
	
	module.exports = ImpactImage;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(314);
	var Sprite = __webpack_require__(82);
	
	/**
	 * @classdesc
	 * An Impact Physics Sprite Game Object.
	 *
	 * A Sprite Game Object is used for the display of both static and animated images in your game.
	 * Sprites can have input events and physics bodies. They can also be tweened, tinted, scrolled
	 * and animated.
	 *
	 * The main difference between a Sprite and an Image Game Object is that you cannot animate Images.
	 * As such, Sprites take a fraction longer to process and have a larger API footprint due to the Animation
	 * Component. If you do not require animation then you can safely use Images to replace Sprites in all cases.
	 *
	 * @class ImpactSprite
	 * @extends Phaser.GameObjects.Sprite
	 * @memberOf Phaser.Physics.Impact
	 * @constructor
	 * @since 3.0.0
	 *
	 * @extends Phaser.Physics.Impact.Components.Acceleration
	 * @extends Phaser.Physics.Impact.Components.BodyScale
	 * @extends Phaser.Physics.Impact.Components.BodyType
	 * @extends Phaser.Physics.Impact.Components.Bounce
	 * @extends Phaser.Physics.Impact.Components.CheckAgainst
	 * @extends Phaser.Physics.Impact.Components.Collides
	 * @extends Phaser.Physics.Impact.Components.Debug
	 * @extends Phaser.Physics.Impact.Components.Friction
	 * @extends Phaser.Physics.Impact.Components.Gravity
	 * @extends Phaser.Physics.Impact.Components.Offset
	 * @extends Phaser.Physics.Impact.Components.SetGameObject
	 * @extends Phaser.Physics.Impact.Components.Velocity
	 * @extends Phaser.GameObjects.Components.Alpha
	 * @extends Phaser.GameObjects.Components.BlendMode
	 * @extends Phaser.GameObjects.Components.Depth
	 * @extends Phaser.GameObjects.Components.Flip
	 * @extends Phaser.GameObjects.Components.GetBounds
	 * @extends Phaser.GameObjects.Components.Origin
	 * @extends Phaser.GameObjects.Components.Pipeline
	 * @extends Phaser.GameObjects.Components.ScaleMode
	 * @extends Phaser.GameObjects.Components.ScrollFactor
	 * @extends Phaser.GameObjects.Components.Size
	 * @extends Phaser.GameObjects.Components.Texture
	 * @extends Phaser.GameObjects.Components.Tint
	 * @extends Phaser.GameObjects.Components.Transform
	 * @extends Phaser.GameObjects.Components.Visible
	 *
	 * @param {Phaser.Physics.Impact.World} world - [description]
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	 * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	 */
	var ImpactSprite = new Class({
	
	    Extends: Sprite,
	
	    Mixins: [
	        Components.Acceleration,
	        Components.BodyScale,
	        Components.BodyType,
	        Components.Bounce,
	        Components.CheckAgainst,
	        Components.Collides,
	        Components.Debug,
	        Components.Friction,
	        Components.Gravity,
	        Components.Offset,
	        Components.SetGameObject,
	        Components.Velocity
	    ],
	
	    initialize:
	
	    function ImpactSprite (world, x, y, texture, frame)
	    {
	        Sprite.call(this, world.scene, x, y, texture, frame);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactSprite#body
	         * @type {Phaser.Physics.Impact.Body}
	         * @since 3.0.0
	         */
	        this.body = world.create(x - this.frame.centerX, y - this.frame.centerY, this.width, this.height);
	
	        this.body.parent = this;
	        this.body.gameObject = this;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactSprite#size
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.size = this.body.size;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactSprite#offset
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.offset = this.body.offset;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactSprite#vel
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.vel = this.body.vel;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactSprite#accel
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.accel = this.body.accel;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactSprite#friction
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.friction = this.body.friction;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactSprite#maxVel
	         * @type {{x: number, y: number}}
	         * @since 3.0.0
	         */
	        this.maxVel = this.body.maxVel;
	    }
	
	});
	
	module.exports = ImpactSprite;


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Body = __webpack_require__(592);
	var Class = __webpack_require__(1);
	var COLLIDES = __webpack_require__(164);
	var CollisionMap = __webpack_require__(593);
	var EventEmitter = __webpack_require__(22);
	var GetFastValue = __webpack_require__(3);
	var HasValue = __webpack_require__(147);
	var Set = __webpack_require__(146);
	var Solver = __webpack_require__(1452);
	var TILEMAP_FORMATS = __webpack_require__(57);
	var TYPE = __webpack_require__(165);
	
	/**
	 * @typedef {object} Phaser.Physics.Impact.WorldConfig
	 *
	 * @property {number} [gravity=0] - [description]
	 * @property {number} [cellSize=64] - [description]
	 * @property {number} [timeScale=1] - [description]
	 * @property {float} [maxStep=0.05] - [description]
	 * @property {boolean} [debug=false] - [description]
	 * @property {number} [maxVelocity=100] - [description]
	 * @property {boolean} [debugShowBody=true] - [description]
	 * @property {boolean} [debugShowVelocity=true] - [description]
	 * @property {number} [debugBodyColor=0xff00ff] - [description]
	 * @property {number} [debugVelocityColor=0x00ff00] - [description]
	 * @property {number} [maxVelocityX=maxVelocity] - [description]
	 * @property {number} [maxVelocityY=maxVelocity] - [description]
	 * @property {number} [minBounceVelocity=40] - [description]
	 * @property {number} [gravityFactor=1] - [description]
	 * @property {number} [bounciness=0] - [description]
	 * @property {(object|boolean)} [setBounds] - [description]
	 * @property {number} [setBounds.x=0] - [description]
	 * @property {number} [setBounds.y=0] - [description]
	 * @property {number} [setBounds.width] - [description]
	 * @property {number} [setBounds.height] - [description]
	 * @property {number} [setBounds.thickness=64] - [description]
	 * @property {boolean} [setBounds.left=true] - [description]
	 * @property {boolean} [setBounds.right=true] - [description]
	 * @property {boolean} [setBounds.top=true] - [description]
	 * @property {boolean} [setBounds.bottom=true] - [description]
	 */
	
	/**
	 * An object containing the 4 wall bodies that bound the physics world.
	 * 
	 * @typedef {object} Phaser.Physics.Impact.WorldDefaults
	 *
	 * @property {boolean} debugShowBody - [description]
	 * @property {boolean} debugShowVelocity - [description]
	 * @property {number} bodyDebugColor - [description]
	 * @property {number} velocityDebugColor - [description]
	 * @property {number} maxVelocityX - [description]
	 * @property {number} maxVelocityY - [description]
	 * @property {number} minBounceVelocity - [description]
	 * @property {number} gravityFactor - [description]
	 * @property {number} bounciness - [description]
	 */
	
	/**
	 * @typedef {object} Phaser.Physics.Impact.WorldWalls
	 *
	 * @property {?Phaser.Physics.Impact.Body} left - [description]
	 * @property {?Phaser.Physics.Impact.Body} right - [description]
	 * @property {?Phaser.Physics.Impact.Body} top - [description]
	 * @property {?Phaser.Physics.Impact.Body} bottom - [description]
	 */
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class World
	 * @extends Phaser.Events.EventEmitter
	 * @memberOf Phaser.Physics.Impact
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - [description]
	 * @param {Phaser.Physics.Impact.WorldConfig} config - [description]
	 */
	var World = new Class({
	
	    Extends: EventEmitter,
	
	    initialize:
	
	    function World (scene, config)
	    {
	        EventEmitter.call(this);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.World#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.World#bodies
	         * @type {Phaser.Structs.Set.<Phaser.Physics.Impact.Body>}
	         * @since 3.0.0
	         */
	        this.bodies = new Set();
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.World#gravity
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.gravity = GetFastValue(config, 'gravity', 0);
	
	        /**
	         * Spatial hash cell dimensions
	         *
	         * @name Phaser.Physics.Impact.World#cellSize
	         * @type {integer}
	         * @default 64
	         * @since 3.0.0
	         */
	        this.cellSize = GetFastValue(config, 'cellSize', 64);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.World#collisionMap
	         * @type {Phaser.Physics.Impact.CollisionMap}
	         * @since 3.0.0
	         */
	        this.collisionMap = new CollisionMap();
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.World#timeScale
	         * @type {float}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.timeScale = GetFastValue(config, 'timeScale', 1);
	
	        /**
	         * Impacts maximum time step is 20 fps.
	         *
	         * @name Phaser.Physics.Impact.World#maxStep
	         * @type {number}
	         * @default 0.05
	         * @since 3.0.0
	         */
	        this.maxStep = GetFastValue(config, 'maxStep', 0.05);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.World#enabled
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.enabled = true;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.World#drawDebug
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.drawDebug = GetFastValue(config, 'debug', false);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.World#debugGraphic
	         * @type {Phaser.GameObjects.Graphics}
	         * @since 3.0.0
	         */
	        this.debugGraphic;
	
	        var _maxVelocity = GetFastValue(config, 'maxVelocity', 100);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.World#defaults
	         * @type {Phaser.Physics.Impact.WorldDefaults}
	         * @since 3.0.0
	         */
	        this.defaults = {
	            debugShowBody: GetFastValue(config, 'debugShowBody', true),
	            debugShowVelocity: GetFastValue(config, 'debugShowVelocity', true),
	            bodyDebugColor: GetFastValue(config, 'debugBodyColor', 0xff00ff),
	            velocityDebugColor: GetFastValue(config, 'debugVelocityColor', 0x00ff00),
	            maxVelocityX: GetFastValue(config, 'maxVelocityX', _maxVelocity),
	            maxVelocityY: GetFastValue(config, 'maxVelocityY', _maxVelocity),
	            minBounceVelocity: GetFastValue(config, 'minBounceVelocity', 40),
	            gravityFactor: GetFastValue(config, 'gravityFactor', 1),
	            bounciness: GetFastValue(config, 'bounciness', 0)
	        };
	
	        /**
	         * An object containing the 4 wall bodies that bound the physics world.
	         *
	         * @name Phaser.Physics.Impact.World#walls
	         * @type {Phaser.Physics.Impact.WorldWalls}
	         * @since 3.0.0
	         */
	        this.walls = { left: null, right: null, top: null, bottom: null };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.World#delta
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.delta = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.World#_lastId
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._lastId = 0;
	
	        if (GetFastValue(config, 'setBounds', false))
	        {
	            var boundsConfig = config['setBounds'];
	
	            if (typeof boundsConfig === 'boolean')
	            {
	                this.setBounds();
	            }
	            else
	            {
	                var x = GetFastValue(boundsConfig, 'x', 0);
	                var y = GetFastValue(boundsConfig, 'y', 0);
	                var width = GetFastValue(boundsConfig, 'width', scene.sys.game.config.width);
	                var height = GetFastValue(boundsConfig, 'height', scene.sys.game.config.height);
	                var thickness = GetFastValue(boundsConfig, 'thickness', 64);
	                var left = GetFastValue(boundsConfig, 'left', true);
	                var right = GetFastValue(boundsConfig, 'right', true);
	                var top = GetFastValue(boundsConfig, 'top', true);
	                var bottom = GetFastValue(boundsConfig, 'bottom', true);
	
	                this.setBounds(x, y, width, height, thickness, left, right, top, bottom);
	            }
	        }
	
	        if (this.drawDebug)
	        {
	            this.createDebugGraphic();
	        }
	    },
	
	    /**
	     * Sets the collision map for the world either from a Weltmeister JSON level in the cache or from
	     * a 2D array. If loading from a Weltmeister level, the map must have a layer called "collision".
	     *
	     * @method Phaser.Physics.Impact.World#setCollisionMap
	     * @since 3.0.0
	     *
	     * @param {(string|integer[][])} key - Either a string key that corresponds to a Weltmeister level
	     * in the cache, or a 2D array of collision IDs.
	     * @param {integer} tileSize - The size of a tile. This is optional if loading from a Weltmeister
	     * level in the cache.
	     *
	     * @return {?Phaser.Physics.Impact.CollisionMap} The newly created CollisionMap, or null if the method failed to
	     * create the CollisionMap.
	     */
	    setCollisionMap: function (key, tileSize)
	    {
	        if (typeof key === 'string')
	        {
	            var tilemapData = this.scene.cache.tilemap.get(key);
	
	            if (!tilemapData || tilemapData.format !== TILEMAP_FORMATS.WELTMEISTER)
	            {
	                console.warn('The specified key does not correspond to a Weltmeister tilemap: ' + key);
	                return null;
	            }
	
	            var layers = tilemapData.data.layer;
	            var collisionLayer;
	            for (var i = 0; i < layers.length; i++)
	            {
	                if (layers[i].name === 'collision')
	                {
	                    collisionLayer = layers[i];
	                    break;
	                }
	            }
	
	            if (tileSize === undefined) { tileSize = collisionLayer.tilesize; }
	
	            this.collisionMap = new CollisionMap(tileSize, collisionLayer.data);
	        }
	        else if (Array.isArray(key))
	        {
	            this.collisionMap = new CollisionMap(tileSize, key);
	        }
	        else
	        {
	            console.warn('Invalid Weltmeister collision map data: ' + key);
	        }
	
	        return this.collisionMap;
	    },
	
	    /**
	     * Sets the collision map for the world from a tilemap layer. Only tiles that are marked as
	     * colliding will be used. You can specify the mapping from tiles to slope IDs in a couple of
	     * ways. The easiest is to use Tiled and the slopeTileProperty option. Alternatively, you can
	     * manually create a slopeMap that stores the mapping between tile indices and slope IDs.
	     *
	     * @method Phaser.Physics.Impact.World#setCollisionMapFromTilemapLayer
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Tilemaps.DynamicTilemapLayer|Phaser.Tilemaps.StaticTilemapLayer)} tilemapLayer - The tilemap layer to use.
	     * @param {object} [options] - Options for controlling the mapping from tiles to slope IDs.
	     * @param {string} [options.slopeTileProperty=null] - Slope IDs can be stored on tiles directly
	     * using Tiled's tileset editor. If a tile has a property with the given slopeTileProperty string
	     * name, the value of that property for the tile will be used for its slope mapping. E.g. a 45
	     * degree slope upward could be given a "slope" property with a value of 2.
	     * @param {object} [options.slopeMap=null] - A tile index to slope definition map.
	     * @param {integer} [options.defaultCollidingSlope=null] - If specified, the default slope ID to
	     * assign to a colliding tile. If not specified, the tile's index is used.
	     * @param {integer} [options.defaultNonCollidingSlope=0] - The default slope ID to assign to a
	     * non-colliding tile.
	     *
	     * @return {Phaser.Physics.Impact.CollisionMap} The newly created CollisionMap.
	     */
	    setCollisionMapFromTilemapLayer: function (tilemapLayer, options)
	    {
	        if (options === undefined) { options = {}; }
	        var slopeProperty = GetFastValue(options, 'slopeProperty', null);
	        var slopeMap = GetFastValue(options, 'slopeMap', null);
	        var collidingSlope = GetFastValue(options, 'defaultCollidingSlope', null);
	        var nonCollidingSlope = GetFastValue(options, 'defaultNonCollidingSlope', 0);
	
	        var layerData = tilemapLayer.layer;
	        var tileSize = layerData.baseTileWidth;
	        var collisionData = [];
	
	        for (var ty = 0; ty < layerData.height; ty++)
	        {
	            collisionData[ty] = [];
	
	            for (var tx = 0; tx < layerData.width; tx++)
	            {
	                var tile = layerData.data[ty][tx];
	
	                if (tile && tile.collides)
	                {
	                    if (slopeProperty !== null && HasValue(tile.properties, slopeProperty))
	                    {
	                        collisionData[ty][tx] = parseInt(tile.properties[slopeProperty], 10);
	                    }
	                    else if (slopeMap !== null && HasValue(slopeMap, tile.index))
	                    {
	                        collisionData[ty][tx] = slopeMap[tile.index];
	                    }
	                    else if (collidingSlope !== null)
	                    {
	                        collisionData[ty][tx] = collidingSlope;
	                    }
	                    else
	                    {
	                        collisionData[ty][tx] = tile.index;
	                    }
	                }
	                else
	                {
	                    collisionData[ty][tx] = nonCollidingSlope;
	                }
	            }
	        }
	
	        this.collisionMap = new CollisionMap(tileSize, collisionData);
	
	        return this.collisionMap;
	    },
	
	    /**
	     * Sets the bounds of the Physics world to match the given world pixel dimensions.
	     * You can optionally set which 'walls' to create: left, right, top or bottom.
	     * If none of the walls are given it will default to use the walls settings it had previously.
	     * I.e. if you previously told it to not have the left or right walls, and you then adjust the world size
	     * the newly created bounds will also not have the left and right walls.
	     * Explicitly state them in the parameters to override this.
	     *
	     * @method Phaser.Physics.Impact.World#setBounds
	     * @since 3.0.0
	     *
	     * @param {number} [x] - The x coordinate of the top-left corner of the bounds.
	     * @param {number} [y] - The y coordinate of the top-left corner of the bounds.
	     * @param {number} [width] - The width of the bounds.
	     * @param {number} [height] - The height of the bounds.
	     * @param {number} [thickness=64] - [description]
	     * @param {boolean} [left=true] - If true will create the left bounds wall.
	     * @param {boolean} [right=true] - If true will create the right bounds wall.
	     * @param {boolean} [top=true] - If true will create the top bounds wall.
	     * @param {boolean} [bottom=true] - If true will create the bottom bounds wall.
	     *
	     * @return {Phaser.Physics.Impact.World} This World object.
	     */
	    setBounds: function (x, y, width, height, thickness, left, right, top, bottom)
	    {
	        if (x === undefined) { x = 0; }
	        if (y === undefined) { y = 0; }
	        if (width === undefined) { width = this.scene.sys.game.config.width; }
	        if (height === undefined) { height = this.scene.sys.game.config.height; }
	        if (thickness === undefined) { thickness = 64; }
	        if (left === undefined) { left = true; }
	        if (right === undefined) { right = true; }
	        if (top === undefined) { top = true; }
	        if (bottom === undefined) { bottom = true; }
	
	        this.updateWall(left, 'left', x - thickness, y, thickness, height);
	        this.updateWall(right, 'right', x + width, y, thickness, height);
	        this.updateWall(top, 'top', x, y - thickness, width, thickness);
	        this.updateWall(bottom, 'bottom', x, y + height, width, thickness);
	
	        return this;
	    },
	
	    /**
	     * position = 'left', 'right', 'top' or 'bottom'
	     *
	     * @method Phaser.Physics.Impact.World#updateWall
	     * @since 3.0.0
	     *
	     * @param {boolean} add - [description]
	     * @param {string} position - [description]
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     */
	    updateWall: function (add, position, x, y, width, height)
	    {
	        var wall = this.walls[position];
	
	        if (add)
	        {
	            if (wall)
	            {
	                wall.resetSize(x, y, width, height);
	            }
	            else
	            {
	                this.walls[position] = this.create(x, y, width, height);
	                this.walls[position].name = position;
	                this.walls[position].gravityFactor = 0;
	                this.walls[position].collides = COLLIDES.FIXED;
	            }
	        }
	        else
	        {
	            if (wall)
	            {
	                this.bodies.remove(wall);
	            }
	
	            this.walls[position] = null;
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#createDebugGraphic
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Graphics} [description]
	     */
	    createDebugGraphic: function ()
	    {
	        var graphic = this.scene.sys.add.graphics({ x: 0, y: 0 });
	
	        graphic.setDepth(Number.MAX_VALUE);
	
	        this.debugGraphic = graphic;
	
	        this.drawDebug = true;
	
	        return graphic;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#getNextID
	     * @since 3.0.0
	     *
	     * @return {integer} [description]
	     */
	    getNextID: function ()
	    {
	        return this._lastId++;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#create
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} sizeX - [description]
	     * @param {number} sizeY - [description]
	     *
	     * @return {Phaser.Physics.Impact.Body} The Body that was added to this World.
	     */
	    create: function (x, y, sizeX, sizeY)
	    {
	        var body = new Body(this, x, y, sizeX, sizeY);
	
	        this.bodies.set(body);
	
	        return body;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#remove
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Impact.Body} object - The Body to remove from this World.
	     */
	    remove: function (object)
	    {
	        this.bodies.delete(object);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#pause
	     * @since 3.0.0
	     *
	     * @return {Phaser.Physics.Impact.World} This World object.
	     */
	    pause: function ()
	    {
	        this.enabled = false;
	
	        this.emit('pause');
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#resume
	     * @since 3.0.0
	     *
	     * @return {Phaser.Physics.Impact.World} This World object.
	     */
	    resume: function ()
	    {
	        this.enabled = true;
	
	        this.emit('resume');
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#update
	     * @since 3.0.0
	     *
	     * @param {number} time - [description]
	     * @param {number} delta - [description]
	     */
	    update: function (time, delta)
	    {
	        if (!this.enabled || this.bodies.size === 0)
	        {
	            return;
	        }
	
	        //  Impact uses a divided delta value that is clamped to the maxStep (20fps) maximum
	
	        var clampedDelta = Math.min(delta / 1000, this.maxStep) * this.timeScale;
	
	        this.delta = clampedDelta;
	
	        //  Update all active bodies
	
	        var i;
	        var body;
	        var bodies = this.bodies.entries;
	        var len = bodies.length;
	        var hash = {};
	        var size = this.cellSize;
	
	        for (i = 0; i < len; i++)
	        {
	            body = bodies[i];
	
	            if (body.enabled)
	            {
	                body.update(clampedDelta);
	            }
	        }
	
	        //  Run collision against them all now they're in the new positions from the update
	
	        for (i = 0; i < len; i++)
	        {
	            body = bodies[i];
	
	            if (body && !body.skipHash())
	            {
	                this.checkHash(body, hash, size);
	            }
	        }
	
	        if (this.drawDebug)
	        {
	            var graphics = this.debugGraphic;
	
	            graphics.clear();
	
	            for (i = 0; i < len; i++)
	            {
	                body = bodies[i];
	
	                if (body && body.willDrawDebug())
	                {
	                    body.drawDebug(graphics);
	                }
	            }
	        }
	    },
	
	    /**
	     * Check the body against the spatial hash.
	     *
	     * @method Phaser.Physics.Impact.World#checkHash
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Impact.Body} body - [description]
	     * @param {object} hash - [description]
	     * @param {number} size - [description]
	     */
	    checkHash: function (body, hash, size)
	    {
	        var checked = {};
	
	        var xmin = Math.floor(body.pos.x / size);
	        var ymin = Math.floor(body.pos.y / size);
	        var xmax = Math.floor((body.pos.x + body.size.x) / size) + 1;
	        var ymax = Math.floor((body.pos.y + body.size.y) / size) + 1;
	
	        for (var x = xmin; x < xmax; x++)
	        {
	            for (var y = ymin; y < ymax; y++)
	            {
	                if (!hash[x])
	                {
	                    hash[x] = {};
	                    hash[x][y] = [ body ];
	                }
	                else if (!hash[x][y])
	                {
	                    hash[x][y] = [ body ];
	                }
	                else
	                {
	                    var cell = hash[x][y];
	
	                    for (var c = 0; c < cell.length; c++)
	                    {
	                        if (body.touches(cell[c]) && !checked[cell[c].id])
	                        {
	                            checked[cell[c].id] = true;
	
	                            this.checkBodies(body, cell[c]);
	                        }
	                    }
	
	                    cell.push(body);
	                }
	            }
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#checkBodies
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Impact.Body} bodyA - [description]
	     * @param {Phaser.Physics.Impact.Body} bodyB - [description]
	     */
	    checkBodies: function (bodyA, bodyB)
	    {
	        //  2 fixed bodies won't do anything
	        if (bodyA.collides === COLLIDES.FIXED && bodyB.collides === COLLIDES.FIXED)
	        {
	            return;
	        }
	
	        //  bitwise checks
	        if (bodyA.checkAgainst & bodyB.type)
	        {
	            bodyA.check(bodyB);
	        }
	
	        if (bodyB.checkAgainst & bodyA.type)
	        {
	            bodyB.check(bodyA);
	        }
	
	        if (bodyA.collides && bodyB.collides && bodyA.collides + bodyB.collides > COLLIDES.ACTIVE)
	        {
	            Solver(this, bodyA, bodyB);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#setCollidesNever
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Impact.Body[]} bodies - An Array of Impact Bodies to set the collides value on.
	     *
	     * @return {Phaser.Physics.Impact.World} This World object.
	     */
	    setCollidesNever: function (bodies)
	    {
	        for (var i = 0; i < bodies.length; i++)
	        {
	            bodies[i].collides = COLLIDES.NEVER;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#setLite
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Impact.Body[]} bodies - An Array of Impact Bodies to set the collides value on.
	     *
	     * @return {Phaser.Physics.Impact.World} This World object.
	     */
	    setLite: function (bodies)
	    {
	        for (var i = 0; i < bodies.length; i++)
	        {
	            bodies[i].collides = COLLIDES.LITE;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#setPassive
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Impact.Body[]} bodies - An Array of Impact Bodies to set the collides value on.
	     *
	     * @return {Phaser.Physics.Impact.World} This World object.
	     */
	    setPassive: function (bodies)
	    {
	        for (var i = 0; i < bodies.length; i++)
	        {
	            bodies[i].collides = COLLIDES.PASSIVE;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#setActive
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Impact.Body[]} bodies - An Array of Impact Bodies to set the collides value on.
	     *
	     * @return {Phaser.Physics.Impact.World} This World object.
	     */
	    setActive: function (bodies)
	    {
	        for (var i = 0; i < bodies.length; i++)
	        {
	            bodies[i].collides = COLLIDES.ACTIVE;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#setFixed
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Impact.Body[]} bodies - An Array of Impact Bodies to set the collides value on.
	     *
	     * @return {Phaser.Physics.Impact.World} This World object.
	     */
	    setFixed: function (bodies)
	    {
	        for (var i = 0; i < bodies.length; i++)
	        {
	            bodies[i].collides = COLLIDES.FIXED;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#setTypeNone
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Impact.Body[]} bodies - An Array of Impact Bodies to set the type value on.
	     *
	     * @return {Phaser.Physics.Impact.World} This World object.
	     */
	    setTypeNone: function (bodies)
	    {
	        for (var i = 0; i < bodies.length; i++)
	        {
	            bodies[i].type = TYPE.NONE;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#setTypeA
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Impact.Body[]} bodies - An Array of Impact Bodies to set the type value on.
	     *
	     * @return {Phaser.Physics.Impact.World} This World object.
	     */
	    setTypeA: function (bodies)
	    {
	        for (var i = 0; i < bodies.length; i++)
	        {
	            bodies[i].type = TYPE.A;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#setTypeB
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Impact.Body[]} bodies - An Array of Impact Bodies to set the type value on.
	     *
	     * @return {Phaser.Physics.Impact.World} This World object.
	     */
	    setTypeB: function (bodies)
	    {
	        for (var i = 0; i < bodies.length; i++)
	        {
	            bodies[i].type = TYPE.B;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#setAvsB
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Impact.Body[]} bodies - An Array of Impact Bodies to set the type value on.
	     *
	     * @return {Phaser.Physics.Impact.World} This World object.
	     */
	    setAvsB: function (bodies)
	    {
	        for (var i = 0; i < bodies.length; i++)
	        {
	            bodies[i].type = TYPE.A;
	            bodies[i].checkAgainst = TYPE.B;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#setBvsA
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Impact.Body[]} bodies - An Array of Impact Bodies to set the type value on.
	     *
	     * @return {Phaser.Physics.Impact.World} This World object.
	     */
	    setBvsA: function (bodies)
	    {
	        for (var i = 0; i < bodies.length; i++)
	        {
	            bodies[i].type = TYPE.B;
	            bodies[i].checkAgainst = TYPE.A;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#setCheckAgainstNone
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Impact.Body[]} bodies - An Array of Impact Bodies to set the type value on.
	     *
	     * @return {Phaser.Physics.Impact.World} This World object.
	     */
	    setCheckAgainstNone: function (bodies)
	    {
	        for (var i = 0; i < bodies.length; i++)
	        {
	            bodies[i].checkAgainst = TYPE.NONE;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#setCheckAgainstA
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Impact.Body[]} bodies - An Array of Impact Bodies to set the type value on.
	     *
	     * @return {Phaser.Physics.Impact.World} This World object.
	     */
	    setCheckAgainstA: function (bodies)
	    {
	        for (var i = 0; i < bodies.length; i++)
	        {
	            bodies[i].checkAgainst = TYPE.A;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#setCheckAgainstB
	     * @since 3.0.0
	     *
	     * @param {Phaser.Physics.Impact.Body[]} bodies - An Array of Impact Bodies to set the type value on.
	     *
	     * @return {Phaser.Physics.Impact.World} This World object.
	     */
	    setCheckAgainstB: function (bodies)
	    {
	        for (var i = 0; i < bodies.length; i++)
	        {
	            bodies[i].checkAgainst = TYPE.B;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#shutdown
	     * @since 3.0.0
	     */
	    shutdown: function ()
	    {
	        this.removeAllListeners();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.World#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.removeAllListeners();
	
	        this.scene = null;
	
	        this.bodies.clear();
	
	        this.bodies = null;
	
	        this.collisionMap = null;
	    }
	
	});
	
	module.exports = World;


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Bodies = __webpack_require__(119);
	var Class = __webpack_require__(1);
	var Composites = __webpack_require__(608);
	var Constraint = __webpack_require__(143);
	var MatterGameObject = __webpack_require__(1468);
	var MatterImage = __webpack_require__(600);
	var MatterSprite = __webpack_require__(601);
	var MatterTileBody = __webpack_require__(316);
	var PointerConstraint = __webpack_require__(1470);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class Factory
	 * @memberOf Phaser.Physics.Matter
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Physics.Matter.World} world - [description]
	 */
	var Factory = new Class({
	
	    initialize:
	
	    function Factory (world)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.Factory#world
	         * @type {Phaser.Physics.Matter.World}
	         * @since 3.0.0
	         */
	        this.world = world;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.Factory#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = world.scene;
	
	        /**
	         * A reference to the Scene.Systems this Matter Physics instance belongs to.
	         *
	         * @name Phaser.Physics.Matter.Factory#sys
	         * @type {Phaser.Scenes.Systems}
	         * @since 3.0.0
	         */
	        this.sys = world.scene.sys;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Factory#rectangle
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     * @param {object} options - [description]
	     *
	     * @return {MatterJS.Body} A Matter JS Body.
	     */
	    rectangle: function (x, y, width, height, options)
	    {
	        var body = Bodies.rectangle(x, y, width, height, options);
	
	        this.world.add(body);
	
	        return body;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Factory#trapezoid
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     * @param {number} slope - [description]
	     * @param {object} options - [description]
	     *
	     * @return {MatterJS.Body} A Matter JS Body.
	     */
	    trapezoid: function (x, y, width, height, slope, options)
	    {
	        var body = Bodies.trapezoid(x, y, width, height, slope, options);
	
	        this.world.add(body);
	
	        return body;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Factory#circle
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} radius - [description]
	     * @param {object} options - [description]
	     * @param {number} maxSides - [description]
	     *
	     * @return {MatterJS.Body} A Matter JS Body.
	     */
	    circle: function (x, y, radius, options, maxSides)
	    {
	        var body = Bodies.circle(x, y, radius, options, maxSides);
	
	        this.world.add(body);
	
	        return body;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Factory#polygon
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} sides - [description]
	     * @param {number} radius - [description]
	     * @param {object} options - [description]
	     *
	     * @return {MatterJS.Body} A Matter JS Body.
	     */
	    polygon: function (x, y, sides, radius, options)
	    {
	        var body = Bodies.polygon(x, y, sides, radius, options);
	
	        this.world.add(body);
	
	        return body;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Factory#fromVertices
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {array} vertexSets - [description]
	     * @param {object} options - [description]
	     * @param {boolean} flagInternal - [description]
	     * @param {boolean} removeCollinear - [description]
	     * @param {number} minimumArea - [description]
	     *
	     * @return {MatterJS.Body} A Matter JS Body.
	     */
	    fromVertices: function (x, y, vertexSets, options, flagInternal, removeCollinear, minimumArea)
	    {
	        var body = Bodies.fromVertices(x, y, vertexSets, options, flagInternal, removeCollinear, minimumArea);
	
	        this.world.add(body);
	
	        return body;
	    },
	
	    /**
	     * Create a new composite containing Matter Image objects created in a grid arrangement.
	     * This function uses the body bounds to prevent overlaps.
	     *
	     * @method Phaser.Physics.Matter.Factory#imageStack
	     * @since 3.0.0
	     *
	     * @param {string} key - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	     * @param {(string|integer)} frame - An optional frame from the Texture this Game Object is rendering with. Set to `null` to skip this value.
	     * @param {number} x - The horizontal position of this composite in the world.
	     * @param {number} y - The vertical position of this composite in the world.
	     * @param {number} columns - The number of columns in the grid.
	     * @param {number} rows - The number of rows in the grid.
	     * @param {number} [columnGap=0] - The distance between each column.
	     * @param {number} [rowGap=0] - The distance between each row.
	     * @param {object} [options] - [description]
	     *
	     * @return {MatterJS.Composite} A Matter JS Composite Stack.
	     */
	    imageStack: function (key, frame, x, y, columns, rows, columnGap, rowGap, options)
	    {
	        if (columnGap === undefined) { columnGap = 0; }
	        if (rowGap === undefined) { rowGap = 0; }
	        if (options === undefined) { options = {}; }
	
	        var world = this.world;
	        var displayList = this.sys.displayList;
	
	        options.addToWorld = false;
	
	        var stack = Composites.stack(x, y, columns, rows, columnGap, rowGap, function (x, y)
	        {
	            var image = new MatterImage(world, x, y, key, frame, options);
	
	            displayList.add(image);
	
	            return image.body;
	        });
	
	        world.add(stack);
	
	        return stack;
	    },
	
	    /**
	     * Create a new composite containing bodies created in the callback in a grid arrangement.
	     * This function uses the body bounds to prevent overlaps.
	     *
	     * @method Phaser.Physics.Matter.Factory#stack
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal position of this composite in the world.
	     * @param {number} y - The vertical position of this composite in the world.
	     * @param {number} columns - The number of columns in the grid.
	     * @param {number} rows - The number of rows in the grid.
	     * @param {number} columnGap - The distance between each column.
	     * @param {number} rowGap - The distance between each row.
	     * @param {function} callback - The callback that creates the stack.
	     *
	     * @return {MatterJS.Composite} A new composite containing objects created in the callback.
	     */
	    stack: function (x, y, columns, rows, columnGap, rowGap, callback)
	    {
	        var stack = Composites.stack(x, y, columns, rows, columnGap, rowGap, callback);
	
	        this.world.add(stack);
	
	        return stack;
	    },
	
	    /**
	     * Create a new composite containing bodies created in the callback in a pyramid arrangement.
	     * This function uses the body bounds to prevent overlaps.
	     *
	     * @method Phaser.Physics.Matter.Factory#pyramid
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal position of this composite in the world.
	     * @param {number} y - The vertical position of this composite in the world.
	     * @param {number} columns - The number of columns in the pyramid.
	     * @param {number} rows - The number of rows in the pyramid.
	     * @param {number} columnGap - The distance between each column.
	     * @param {number} rowGap - The distance between each row.
	     * @param {function} callback - [description]
	     *
	     * @return {MatterJS.Composite} A Matter JS Composite pyramid.
	     */
	    pyramid: function (x, y, columns, rows, columnGap, rowGap, callback)
	    {
	        var stack = Composites.pyramid(x, y, columns, rows, columnGap, rowGap, callback);
	
	        this.world.add(stack);
	
	        return stack;
	    },
	
	    /**
	     * Chains all bodies in the given composite together using constraints.
	     *
	     * @method Phaser.Physics.Matter.Factory#chain
	     * @since 3.0.0
	     *
	     * @param {MatterJS.Composite} composite - [description]
	     * @param {number} xOffsetA - [description]
	     * @param {number} yOffsetA - [description]
	     * @param {number} xOffsetB - [description]
	     * @param {number} yOffsetB - [description]
	     * @param {object} options - [description]
	     *
	     * @return {MatterJS.Composite} A new composite containing objects chained together with constraints.
	     */
	    chain: function (composite, xOffsetA, yOffsetA, xOffsetB, yOffsetB, options)
	    {
	        return Composites.chain(composite, xOffsetA, yOffsetA, xOffsetB, yOffsetB, options);
	    },
	
	    /**
	     * Connects bodies in the composite with constraints in a grid pattern, with optional cross braces.
	     *
	     * @method Phaser.Physics.Matter.Factory#mesh
	     * @since 3.0.0
	     *
	     * @param {MatterJS.Composite} composite - [description]
	     * @param {number} columns - [description]
	     * @param {number} rows - [description]
	     * @param {boolean} crossBrace - [description]
	     * @param {object} options - [description]
	     *
	     * @return {MatterJS.Composite} The composite containing objects meshed together with constraints.
	     */
	    mesh: function (composite, columns, rows, crossBrace, options)
	    {
	        return Composites.mesh(composite, columns, rows, crossBrace, options);
	    },
	
	    /**
	     * Creates a composite with a Newton's Cradle setup of bodies and constraints.
	     *
	     * @method Phaser.Physics.Matter.Factory#newtonsCradle
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} number - [description]
	     * @param {number} size - [description]
	     * @param {number} length - [description]
	     *
	     * @return {MatterJS.Composite} A new composite newtonsCradle body.
	     */
	    newtonsCradle: function (x, y, number, size, length)
	    {
	        var composite = Composites.newtonsCradle(x, y, number, size, length);
	
	        this.world.add(composite);
	
	        return composite;
	    },
	
	    /**
	     * Creates a composite with simple car setup of bodies and constraints.
	     *
	     * @method Phaser.Physics.Matter.Factory#car
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     * @param {number} wheelSize - [description]
	     *
	     * @return {MatterJS.Composite} A new composite car body.
	     */
	    car: function (x, y, width, height, wheelSize)
	    {
	        var composite = Composites.car(x, y, width, height, wheelSize);
	
	        this.world.add(composite);
	
	        return composite;
	    },
	
	    /**
	     * Creates a simple soft body like object.
	     *
	     * @method Phaser.Physics.Matter.Factory#softBody
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal position of this composite in the world.
	     * @param {number} y - The vertical position of this composite in the world.
	     * @param {number} columns - The number of columns in the Composite.
	     * @param {number} rows - The number of rows in the Composite.
	     * @param {number} columnGap - The distance between each column.
	     * @param {number} rowGap - The distance between each row.
	     * @param {boolean} crossBrace - [description]
	     * @param {number} particleRadius - [description]
	     * @param {object} particleOptions - [description]
	     * @param {object} constraintOptions - [description]
	     *
	     * @return {MatterJS.Composite} A new composite simple soft body.
	     */
	    softBody: function (x, y, columns, rows, columnGap, rowGap, crossBrace, particleRadius, particleOptions, constraintOptions)
	    {
	        var composite = Composites.softBody(x, y, columns, rows, columnGap, rowGap, crossBrace, particleRadius, particleOptions, constraintOptions);
	
	        this.world.add(composite);
	
	        return composite;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Factory#joint
	     * @since 3.0.0
	     *
	     * @param {MatterJS.Body} bodyA - [description]
	     * @param {MatterJS.Body} bodyB - [description]
	     * @param {number} length - [description]
	     * @param {number} [stiffness=1] - [description]
	     * @param {object} [options={}] - [description]
	     *
	     * @return {MatterJS.Constraint} A Matter JS Constraint.
	     */
	    joint: function (bodyA, bodyB, length, stiffness, options)
	    {
	        return this.constraint(bodyA, bodyB, length, stiffness, options);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Factory#spring
	     * @since 3.0.0
	     *
	     * @param {MatterJS.Body} bodyA - [description]
	     * @param {MatterJS.Body} bodyB - [description]
	     * @param {number} length - [description]
	     * @param {number} [stiffness=1] - [description]
	     * @param {object} [options={}] - [description]
	     *
	     * @return {MatterJS.Constraint} A Matter JS Constraint.
	     */
	    spring: function (bodyA, bodyB, length, stiffness, options)
	    {
	        return this.constraint(bodyA, bodyB, length, stiffness, options);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Factory#constraint
	     * @since 3.0.0
	     *
	     * @param {MatterJS.Body} bodyA - [description]
	     * @param {MatterJS.Body} bodyB - [description]
	     * @param {number} length - [description]
	     * @param {number} [stiffness=1] - [description]
	     * @param {object} [options={}] - [description]
	     *
	     * @return {MatterJS.Constraint} A Matter JS Constraint.
	     */
	    constraint: function (bodyA, bodyB, length, stiffness, options)
	    {
	        if (stiffness === undefined) { stiffness = 1; }
	        if (options === undefined) { options = {}; }
	
	        options.bodyA = (bodyA.type === 'body') ? bodyA : bodyA.body;
	        options.bodyB = (bodyB.type === 'body') ? bodyB : bodyB.body;
	        options.length = length;
	        options.stiffness = stiffness;
	
	        var constraint = Constraint.create(options);
	
	        this.world.add(constraint);
	
	        return constraint;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Factory#worldConstraint
	     * @since 3.0.0
	     *
	     * @param {MatterJS.Body} bodyB - [description]
	     * @param {number} length - [description]
	     * @param {number} [stiffness=1] - [description]
	     * @param {object} [options={}] - [description]
	     *
	     * @return {MatterJS.Constraint} A Matter JS Constraint.
	     */
	    worldConstraint: function (bodyB, length, stiffness, options)
	    {
	        if (stiffness === undefined) { stiffness = 1; }
	        if (options === undefined) { options = {}; }
	
	        options.bodyB = (bodyB.type === 'body') ? bodyB : bodyB.body;
	        options.length = length;
	        options.stiffness = stiffness;
	
	        var constraint = Constraint.create(options);
	
	        this.world.add(constraint);
	
	        return constraint;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Factory#mouseSpring
	     * @since 3.0.0
	     *
	     * @param {object} options - [description]
	     *
	     * @return {MatterJS.Constraint} A Matter JS Constraint.
	     */
	    mouseSpring: function (options)
	    {
	        return this.pointerConstraint(options);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Factory#pointerConstraint
	     * @since 3.0.0
	     *
	     * @param {object} options - [description]
	     *
	     * @return {MatterJS.Constraint} A Matter JS Constraint.
	     */
	    pointerConstraint: function (options)
	    {
	        if (options === undefined) { options = {}; }
	
	        if (!options.hasOwnProperty('render'))
	        {
	            options.render = { visible: false };
	        }
	
	        var pointerConstraint = new PointerConstraint(this.scene, this.world, options);
	
	        this.world.add(pointerConstraint.constraint);
	
	        return pointerConstraint;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Factory#image
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal position of this Game Object in the world.
	     * @param {number} y - The vertical position of this Game Object in the world.
	     * @param {string} key - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	     * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with. Set to `null` to skip this value.
	     * @param {object} [options={}] - [description]
	     *
	     * @return {Phaser.Physics.Matter.Image} [description]
	     */
	    image: function (x, y, key, frame, options)
	    {
	        var image = new MatterImage(this.world, x, y, key, frame, options);
	
	        this.sys.displayList.add(image);
	
	        return image;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Factory#tileBody
	     * @since 3.0.0
	     *
	     * @param {Phaser.Tilemaps.Tile} tile - [description]
	     * @param {object} options - [description]
	     *
	     * @return {Phaser.Physics.Matter.TileBody} [description]
	     */
	    tileBody: function (tile, options)
	    {
	        var tileBody = new MatterTileBody(this.world, tile, options);
	
	        return tileBody;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Factory#sprite
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal position of this Game Object in the world.
	     * @param {number} y - The vertical position of this Game Object in the world.
	     * @param {string} key - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	     * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with. Set to `null` to skip this value.
	     * @param {object} [options={}] - [description]
	     *
	     * @return {Phaser.Physics.Matter.Sprite} [description]
	     */
	    sprite: function (x, y, key, frame, options)
	    {
	        var sprite = new MatterSprite(this.world, x, y, key, frame, options);
	
	        this.sys.displayList.add(sprite);
	        this.sys.updateList.add(sprite);
	
	        return sprite;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Factory#gameObject
	     * @since 3.3.0
	     *
	     * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to inject the Matter Body in to.
	     * @param {object} options - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} The Game Object that had the Matter Body injected into it.
	     */
	    gameObject: function (gameObject, options)
	    {
	        return MatterGameObject(this.world, gameObject, options);
	    },
	
	    /**
	     * Destroys this Factory.
	     *
	     * @method Phaser.Physics.Matter.Factory#destroy
	     * @since 3.5.0
	     */
	    destroy: function ()
	    {
	        this.world = null;
	        this.scene = null;
	        this.sys = null;
	    }
	
	});
	
	module.exports = Factory;


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(205);
	var GameObject = __webpack_require__(5);
	var GetFastValue = __webpack_require__(3);
	var Image = __webpack_require__(138);
	var Pipeline = __webpack_require__(276);
	var Vector2 = __webpack_require__(9);
	
	/**
	 * @classdesc
	 * A Matter Physics Image Game Object.
	 * 
	 * An Image is a light-weight Game Object useful for the display of static images in your game,
	 * such as logos, backgrounds, scenery or other non-animated elements. Images can have input
	 * events and physics bodies, or be tweened, tinted or scrolled. The main difference between an
	 * Image and a Sprite is that you cannot animate an Image as they do not have the Animation component.
	 *
	 * @class Image
	 * @extends Phaser.GameObjects.Image
	 * @memberOf Phaser.Physics.Matter
	 * @constructor
	 * @since 3.0.0
	 *
	 * @extends Phaser.Physics.Matter.Components.Bounce
	 * @extends Phaser.Physics.Matter.Components.Collision
	 * @extends Phaser.Physics.Matter.Components.Force
	 * @extends Phaser.Physics.Matter.Components.Friction
	 * @extends Phaser.Physics.Matter.Components.Gravity
	 * @extends Phaser.Physics.Matter.Components.Mass
	 * @extends Phaser.Physics.Matter.Components.Sensor
	 * @extends Phaser.Physics.Matter.Components.SetBody
	 * @extends Phaser.Physics.Matter.Components.Sleep
	 * @extends Phaser.Physics.Matter.Components.Static
	 * @extends Phaser.Physics.Matter.Components.Transform
	 * @extends Phaser.Physics.Matter.Components.Velocity
	 * @extends Phaser.GameObjects.Components.Alpha
	 * @extends Phaser.GameObjects.Components.BlendMode
	 * @extends Phaser.GameObjects.Components.Depth
	 * @extends Phaser.GameObjects.Components.Flip
	 * @extends Phaser.GameObjects.Components.GetBounds
	 * @extends Phaser.GameObjects.Components.Origin
	 * @extends Phaser.GameObjects.Components.Pipeline
	 * @extends Phaser.GameObjects.Components.ScaleMode
	 * @extends Phaser.GameObjects.Components.ScrollFactor
	 * @extends Phaser.GameObjects.Components.Size
	 * @extends Phaser.GameObjects.Components.Texture
	 * @extends Phaser.GameObjects.Components.Tint
	 * @extends Phaser.GameObjects.Components.Transform
	 * @extends Phaser.GameObjects.Components.Visible
	 *
	 * @param {Phaser.Physics.Matter.World} world - [description]
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	 * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	 * @param {object} [options={}] - Matter.js configuration object.
	 */
	var MatterImage = new Class({
	
	    Extends: Image,
	
	    Mixins: [
	        Components.Bounce,
	        Components.Collision,
	        Components.Force,
	        Components.Friction,
	        Components.Gravity,
	        Components.Mass,
	        Components.Sensor,
	        Components.SetBody,
	        Components.Sleep,
	        Components.Static,
	        Components.Transform,
	        Components.Velocity,
	        Pipeline
	    ],
	
	    initialize:
	
	    function MatterImage (world, x, y, texture, frame, options)
	    {
	        GameObject.call(this, world.scene, 'Image');
	
	        this.setTexture(texture, frame);
	        this.setSizeToFrame();
	        this.setOrigin();
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.Image#world
	         * @type {Phaser.Physics.Matter.World}
	         * @since 3.0.0
	         */
	        this.world = world;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.Image#_tempVec2
	         * @type {Phaser.Math.Vector2}
	         * @private
	         * @since 3.0.0
	         */
	        this._tempVec2 = new Vector2(x, y);
	
	        var shape = GetFastValue(options, 'shape', null);
	
	        if (shape)
	        {
	            this.setBody(shape, options);
	        }
	        else
	        {
	            this.setRectangle(this.width, this.height, options);
	        }
	
	        this.setPosition(x, y);
	
	        this.initPipeline('TextureTintPipeline');
	    }
	
	});
	
	module.exports = MatterImage;


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var AnimationComponent = __webpack_require__(490);
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(205);
	var GameObject = __webpack_require__(5);
	var GetFastValue = __webpack_require__(3);
	var Pipeline = __webpack_require__(276);
	var Sprite = __webpack_require__(82);
	var Vector2 = __webpack_require__(9);
	
	/**
	 * @classdesc
	 * A Matter Physics Sprite Game Object.
	 *
	 * A Sprite Game Object is used for the display of both static and animated images in your game.
	 * Sprites can have input events and physics bodies. They can also be tweened, tinted, scrolled
	 * and animated.
	 *
	 * The main difference between a Sprite and an Image Game Object is that you cannot animate Images.
	 * As such, Sprites take a fraction longer to process and have a larger API footprint due to the Animation
	 * Component. If you do not require animation then you can safely use Images to replace Sprites in all cases.
	 *
	 * @class Sprite
	 * @extends Phaser.GameObjects.Sprite
	 * @memberOf Phaser.Physics.Matter
	 * @constructor
	 * @since 3.0.0
	 *
	 * @extends Phaser.Physics.Matter.Components.Bounce
	 * @extends Phaser.Physics.Matter.Components.Collision
	 * @extends Phaser.Physics.Matter.Components.Force
	 * @extends Phaser.Physics.Matter.Components.Friction
	 * @extends Phaser.Physics.Matter.Components.Gravity
	 * @extends Phaser.Physics.Matter.Components.Mass
	 * @extends Phaser.Physics.Matter.Components.Sensor
	 * @extends Phaser.Physics.Matter.Components.SetBody
	 * @extends Phaser.Physics.Matter.Components.Sleep
	 * @extends Phaser.Physics.Matter.Components.Static
	 * @extends Phaser.Physics.Matter.Components.Transform
	 * @extends Phaser.Physics.Matter.Components.Velocity
	 * @extends Phaser.GameObjects.Components.Alpha
	 * @extends Phaser.GameObjects.Components.BlendMode
	 * @extends Phaser.GameObjects.Components.Depth
	 * @extends Phaser.GameObjects.Components.Flip
	 * @extends Phaser.GameObjects.Components.GetBounds
	 * @extends Phaser.GameObjects.Components.Origin
	 * @extends Phaser.GameObjects.Components.Pipeline
	 * @extends Phaser.GameObjects.Components.ScaleMode
	 * @extends Phaser.GameObjects.Components.ScrollFactor
	 * @extends Phaser.GameObjects.Components.Size
	 * @extends Phaser.GameObjects.Components.Texture
	 * @extends Phaser.GameObjects.Components.Tint
	 * @extends Phaser.GameObjects.Components.Transform
	 * @extends Phaser.GameObjects.Components.Visible
	 *
	 * @param {Phaser.Physics.Matter.World} world - [description]
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	 * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	 * @param {object} [options={}] - Matter.js configuration object.
	 */
	var MatterSprite = new Class({
	
	    Extends: Sprite,
	
	    Mixins: [
	        Components.Bounce,
	        Components.Collision,
	        Components.Force,
	        Components.Friction,
	        Components.Gravity,
	        Components.Mass,
	        Components.Sensor,
	        Components.SetBody,
	        Components.Sleep,
	        Components.Static,
	        Components.Transform,
	        Components.Velocity,
	        Pipeline
	    ],
	
	    initialize:
	
	    function MatterSprite (world, x, y, texture, frame, options)
	    {
	        GameObject.call(this, world.scene, 'Image');
	
	        this.anims = new AnimationComponent(this);
	
	        this.setTexture(texture, frame);
	        this.setSizeToFrame();
	        this.setOrigin();
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.Sprite#world
	         * @type {Phaser.Physics.Matter.World}
	         * @since 3.0.0
	         */
	        this.world = world;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.Sprite#_tempVec2
	         * @type {Phaser.Math.Vector2}
	         * @private
	         * @since 3.0.0
	         */
	        this._tempVec2 = new Vector2(x, y);
	
	        var shape = GetFastValue(options, 'shape', null);
	
	        if (shape)
	        {
	            this.setBody(shape, options);
	        }
	        else
	        {
	            this.setRectangle(this.width, this.height, options);
	        }
	
	        this.setPosition(x, y);
	
	        this.initPipeline('TextureTintPipeline');
	    }
	
	});
	
	module.exports = MatterSprite;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Bodies = __webpack_require__(119);
	var Class = __webpack_require__(1);
	var Common = __webpack_require__(31);
	var Composite = __webpack_require__(118);
	var Engine = __webpack_require__(606);
	var EventEmitter = __webpack_require__(22);
	var GetFastValue = __webpack_require__(3);
	var GetValue = __webpack_require__(10);
	var MatterBody = __webpack_require__(51);
	var MatterEvents = __webpack_require__(144);
	var MatterTileBody = __webpack_require__(316);
	var MatterWorld = __webpack_require__(317);
	var Vector = __webpack_require__(71);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class World
	 * @extends Phaser.Events.EventEmitter
	 * @memberOf Phaser.Physics.Matter
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - [description]
	 * @param {object} config - [description]
	 */
	var World = new Class({
	
	    Extends: EventEmitter,
	
	    initialize:
	
	    function World (scene, config)
	    {
	        EventEmitter.call(this);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.World#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.World#engine
	         * @type {MatterJS.Engine}
	         * @since 3.0.0
	         */
	        this.engine = Engine.create(config);
	
	        /**
	         * A `World` composite object that will contain all simulated bodies and constraints.
	         *
	         * @name Phaser.Physics.Matter.World#localWorld
	         * @type {MatterJS.World}
	         * @since 3.0.0
	         */
	        this.localWorld = this.engine.world;
	
	        var gravity = GetValue(config, 'gravity', null);
	
	        if (gravity)
	        {
	            this.setGravity(gravity.x, gravity.y, gravity.scale);
	        }
	
	        /**
	         * An object containing the 4 wall bodies that bound the physics world.
	         *
	         * @name Phaser.Physics.Matter.World#walls
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.walls = { left: null, right: null, top: null, bottom: null };
	
	        if (GetFastValue(config, 'setBounds', false))
	        {
	            var boundsConfig = config['setBounds'];
	
	            if (typeof boundsConfig === 'boolean')
	            {
	                this.setBounds();
	            }
	            else
	            {
	                var x = GetFastValue(boundsConfig, 'x', 0);
	                var y = GetFastValue(boundsConfig, 'y', 0);
	                var width = GetFastValue(boundsConfig, 'width', scene.sys.game.config.width);
	                var height = GetFastValue(boundsConfig, 'height', scene.sys.game.config.height);
	                var thickness = GetFastValue(boundsConfig, 'thickness', 64);
	                var left = GetFastValue(boundsConfig, 'left', true);
	                var right = GetFastValue(boundsConfig, 'right', true);
	                var top = GetFastValue(boundsConfig, 'top', true);
	                var bottom = GetFastValue(boundsConfig, 'bottom', true);
	
	                this.setBounds(x, y, width, height, thickness, left, right, top, bottom);
	            }
	        }
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.World#enabled
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.enabled = GetValue(config, 'enabled', true);
	
	        /**
	         * The correction argument is an optional Number that specifies the time correction factor to apply to the update.
	         * This can help improve the accuracy of the simulation in cases where delta is changing between updates.
	         * The value of correction is defined as delta / lastDelta, i.e. the percentage change of delta over the last step.
	         * Therefore the value is always 1 (no correction) when delta constant (or when no correction is desired, which is the default).
	         * See the paper on Time Corrected Verlet for more information.
	         *
	         * @name Phaser.Physics.Matter.World#correction
	         * @type {number}
	         * @default 1
	         * @since 3.4.0
	         */
	        this.correction = GetValue(config, 'correction', 1);
	
	        /**
	         * This function is called every time the core game loop steps, which is bound to the
	         * Request Animation Frame frequency unless otherwise modified.
	         * 
	         * The function is passed two values: `time` and `delta`, both of which come from the game step values.
	         * 
	         * It must return a number. This number is used as the delta value passed to Matter.Engine.update.
	         * 
	         * You can override this function with your own to define your own timestep.
	         * 
	         * If you need to update the Engine multiple times in a single game step then call
	         * `World.update` as many times as required. Each call will trigger the `getDelta` function.
	         * If you wish to have full control over when the Engine updates then see the property `autoUpdate`.
	         *
	         * You can also adjust the number of iterations that Engine.update performs.
	         * Use the Scene Matter Physics config object to set the following properties:
	         *
	         * positionIterations (defaults to 6)
	         * velocityIterations (defaults to 4)
	         * constraintIterations (defaults to 2)
	         *
	         * Adjusting these values can help performance in certain situations, depending on the physics requirements
	         * of your game.
	         *
	         * @name Phaser.Physics.Matter.World#getDelta
	         * @type {function}
	         * @since 3.4.0
	         */
	        this.getDelta = GetValue(config, 'getDelta', this.update60Hz);
	
	        /**
	         * Automatically call Engine.update every time the game steps.
	         * If you disable this then you are responsible for calling `World.step` directly from your game.
	         * If you call `set60Hz` or `set30Hz` then `autoUpdate` is reset to `true`.
	         *
	         * @name Phaser.Physics.Matter.World#autoUpdate
	         * @type {boolean}
	         * @default true
	         * @since 3.4.0
	         */
	        this.autoUpdate = GetValue(config, 'autoUpdate', true);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.World#drawDebug
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.drawDebug = GetValue(config, 'debug', false);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.World#debugGraphic
	         * @type {Phaser.GameObjects.Graphics}
	         * @since 3.0.0
	         */
	        this.debugGraphic;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.World#defaults
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.defaults = {
	            debugShowBody: GetValue(config, 'debugShowBody', true),
	            debugShowStaticBody: GetValue(config, 'debugShowStaticBody', true),
	            debugShowVelocity: GetValue(config, 'debugShowVelocity', true),
	            bodyDebugColor: GetValue(config, 'debugBodyColor', 0xff00ff),
	            staticBodyDebugColor: GetValue(config, 'debugBodyColor', 0x0000ff),
	            velocityDebugColor: GetValue(config, 'debugVelocityColor', 0x00ff00),
	            debugShowJoint: GetValue(config, 'debugShowJoint', true),
	            jointDebugColor: GetValue(config, 'debugJointColor', 0x000000)
	        };
	
	        if (this.drawDebug)
	        {
	            this.createDebugGraphic();
	        }
	
	        this.setEventsProxy();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.World#setEventsProxy
	     * @since 3.0.0
	     */
	    setEventsProxy: function ()
	    {
	        var _this = this;
	        var engine = this.engine;
	
	        MatterEvents.on(engine, 'beforeUpdate', function (event)
	        {
	            _this.emit('beforeupdate', event);
	        });
	
	        MatterEvents.on(engine, 'afterUpdate', function (event)
	        {
	            _this.emit('afterupdate', event);
	        });
	
	        MatterEvents.on(engine, 'collisionStart', function (event)
	        {
	            var pairs = event.pairs;
	            var bodyA;
	            var bodyB;
	
	            if (pairs.length > 0)
	            {
	                bodyA = pairs[0].bodyA;
	                bodyB = pairs[0].bodyB;
	            }
	
	            _this.emit('collisionstart', event, bodyA, bodyB);
	        });
	
	        MatterEvents.on(engine, 'collisionActive', function (event)
	        {
	            var pairs = event.pairs;
	            var bodyA;
	            var bodyB;
	
	            if (pairs.length > 0)
	            {
	                bodyA = pairs[0].bodyA;
	                bodyB = pairs[0].bodyB;
	            }
	
	            _this.emit('collisionactive', event, bodyA, bodyB);
	        });
	
	        MatterEvents.on(engine, 'collisionEnd', function (event)
	        {
	            var pairs = event.pairs;
	            var bodyA;
	            var bodyB;
	
	            if (pairs.length > 0)
	            {
	                bodyA = pairs[0].bodyA;
	                bodyB = pairs[0].bodyB;
	            }
	
	            _this.emit('collisionend', event, bodyA, bodyB);
	        });
	    },
	
	    /**
	     * Sets the bounds of the Physics world to match the given world pixel dimensions.
	     * You can optionally set which 'walls' to create: left, right, top or bottom.
	     * If none of the walls are given it will default to use the walls settings it had previously.
	     * I.e. if you previously told it to not have the left or right walls, and you then adjust the world size
	     * the newly created bounds will also not have the left and right walls.
	     * Explicitly state them in the parameters to override this.
	     *
	     * @method Phaser.Physics.Matter.World#setBounds
	     * @since 3.0.0
	     *
	     * @param {number} [x=0] - The x coordinate of the top-left corner of the bounds.
	     * @param {number} [y=0] - The y coordinate of the top-left corner of the bounds.
	     * @param {number} [width] - The width of the bounds.
	     * @param {number} [height] - The height of the bounds.
	     * @param {number} [thickness=128] - The thickness of each wall, in pixels.
	     * @param {boolean} [left=true] - If true will create the left bounds wall.
	     * @param {boolean} [right=true] - If true will create the right bounds wall.
	     * @param {boolean} [top=true] - If true will create the top bounds wall.
	     * @param {boolean} [bottom=true] - If true will create the bottom bounds wall.
	     *
	     * @return {Phaser.Physics.Matter.World} This Matter World object.
	     */
	    setBounds: function (x, y, width, height, thickness, left, right, top, bottom)
	    {
	        if (x === undefined) { x = 0; }
	        if (y === undefined) { y = 0; }
	        if (width === undefined) { width = this.scene.sys.game.config.width; }
	        if (height === undefined) { height = this.scene.sys.game.config.height; }
	        if (thickness === undefined) { thickness = 128; }
	        if (left === undefined) { left = true; }
	        if (right === undefined) { right = true; }
	        if (top === undefined) { top = true; }
	        if (bottom === undefined) { bottom = true; }
	
	        this.updateWall(left, 'left', x - thickness, y, thickness, height);
	        this.updateWall(right, 'right', x + width, y, thickness, height);
	        this.updateWall(top, 'top', x, y - thickness, width, thickness);
	        this.updateWall(bottom, 'bottom', x, y + height, width, thickness);
	
	        return this;
	    },
	
	    //  position = 'left', 'right', 'top' or 'bottom'
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.World#updateWall
	     * @since 3.0.0
	     *
	     * @param {boolean} add - [description]
	     * @param {string} position - [description]
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     */
	    updateWall: function (add, position, x, y, width, height)
	    {
	        var wall = this.walls[position];
	
	        if (add)
	        {
	            if (wall)
	            {
	                MatterWorld.remove(this.localWorld, wall);
	            }
	
	            //  adjust center
	            x += (width / 2);
	            y += (height / 2);
	
	            this.walls[position] = this.create(x, y, width, height, { isStatic: true, friction: 0, frictionStatic: 0 });
	        }
	        else
	        {
	            if (wall)
	            {
	                MatterWorld.remove(this.localWorld, wall);
	            }
	
	            this.walls[position] = null;
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.World#createDebugGraphic
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Graphics} [description]
	     */
	    createDebugGraphic: function ()
	    {
	        var graphic = this.scene.sys.add.graphics({ x: 0, y: 0 });
	
	        graphic.setDepth(Number.MAX_VALUE);
	
	        this.debugGraphic = graphic;
	
	        this.drawDebug = true;
	
	        return graphic;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.World#disableGravity
	     * @since 3.0.0
	     *
	     * @return {Phaser.Physics.Matter.World} This Matter World object.
	     */
	    disableGravity: function ()
	    {
	        this.localWorld.gravity.x = 0;
	        this.localWorld.gravity.y = 0;
	        this.localWorld.gravity.scale = 0;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.World#setGravity
	     * @since 3.0.0
	     *
	     * @param {number} [x=0] - [description]
	     * @param {number} [y=1] - [description]
	     * @param {number} [scale] - [description]
	     *
	     * @return {Phaser.Physics.Matter.World} This Matter World object.
	     */
	    setGravity: function (x, y, scale)
	    {
	        if (x === undefined) { x = 0; }
	        if (y === undefined) { y = 1; }
	
	        this.localWorld.gravity.x = x;
	        this.localWorld.gravity.y = y;
	
	        if (scale !== undefined)
	        {
	            this.localWorld.gravity.scale = scale;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.World#create
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     * @param {object} options - [description]
	     *
	     * @return {MatterJS.Body} [description]
	     */
	    create: function (x, y, width, height, options)
	    {
	        var body = Bodies.rectangle(x, y, width, height, options);
	
	        MatterWorld.add(this.localWorld, body);
	
	        return body;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.World#add
	     * @since 3.0.0
	     *
	     * @param {(object|object[])} object - Can be single or an array, and can be a body, composite or constraint
	     *
	     * @return {Phaser.Physics.Matter.World} This Matter World object.
	     */
	    add: function (object)
	    {
	        MatterWorld.add(this.localWorld, object);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.World#remove
	     * @since 3.0.0
	     *
	     * @param {object} object - The object to be removed from the world.
	     * @param {boolean} deep - [description]
	     *
	     * @return {Phaser.Physics.Matter.World} This Matter World object.
	     */
	    remove: function (object, deep)
	    {
	        var body = (object.body) ? object.body : object;
	
	        Composite.removeBody(this.localWorld, body, deep);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.World#removeConstraint
	     * @since 3.0.0
	     *
	     * @param {MatterJS.Constraint} constraint - [description]
	     * @param {boolean} deep - [description]
	     *
	     * @return {Phaser.Physics.Matter.World} This Matter World object.
	     */
	    removeConstraint: function (constraint, deep)
	    {
	        Composite.remove(this.localWorld, constraint, deep);
	
	        return this;
	    },
	
	    /**
	     * Adds MatterTileBody instances for all the colliding tiles within the given tilemap layer. Set
	     * the appropriate tiles in your layer to collide before calling this method!
	     *
	     * @method Phaser.Physics.Matter.World#convertTilemapLayer
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Tilemaps.DynamicTilemapLayer|Phaser.Tilemaps.StaticTilemapLayer)} tilemapLayer -
	     * An array of tiles.
	     * @param {object} [options] - Options to be passed to the MatterTileBody constructor. {@ee Phaser.Physics.Matter.TileBody}
	     *
	     * @return {Phaser.Physics.Matter.World} This Matter World object.
	     */
	    convertTilemapLayer: function (tilemapLayer, options)
	    {
	        var layerData = tilemapLayer.layer;
	        var tiles = tilemapLayer.getTilesWithin(0, 0, layerData.width, layerData.height, {isColliding: true});
	
	        this.convertTiles(tiles, options);
	
	        return this;
	    },
	
	    /**
	     * Adds MatterTileBody instances for the given tiles. This adds bodies regardless of whether the
	     * tiles are set to collide or not.
	     *
	     * @method Phaser.Physics.Matter.World#convertTiles
	     * @since 3.0.0
	     *
	     * @param {Phaser.Tilemaps.Tile[]} tiles - An array of tiles.
	     * @param {object} [options] - Options to be passed to the MatterTileBody constructor. {@see Phaser.Physics.Matter.TileBody}
	     *
	     * @return {Phaser.Physics.Matter.World} This Matter World object.
	     */
	    convertTiles: function (tiles, options)
	    {
	        if (tiles.length === 0)
	        {
	            return this;
	        }
	
	        for (var i = 0; i < tiles.length; i++)
	        {
	            new MatterTileBody(this, tiles[i], options);
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.World#nextGroup
	     * @since 3.0.0
	     *
	     * @param {boolean} isNonColliding - [description]
	     *
	     * @return {number} [description]
	     */
	    nextGroup: function (isNonColliding)
	    {
	        return MatterBody.nextGroup(isNonColliding);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.World#nextCategory
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    nextCategory: function ()
	    {
	        return MatterBody.nextCategory();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.World#pause
	     * @since 3.0.0
	     *
	     * @return {Phaser.Physics.Matter.World} This Matter World object.
	     */
	    pause: function ()
	    {
	        this.enabled = false;
	
	        this.emit('pause');
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.World#resume
	     * @since 3.0.0
	     *
	     * @return {Phaser.Physics.Matter.World} This Matter World object.
	     */
	    resume: function ()
	    {
	        this.enabled = true;
	
	        this.emit('resume');
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.World#update
	     * @since 3.0.0
	     *
	     * @param {number} time - [description]
	     * @param {number} delta - [description]
	     */
	    update: function (time, delta)
	    {
	        if (this.enabled && this.autoUpdate)
	        {
	            Engine.update(this.engine, this.getDelta(time, delta), this.correction);
	        }
	    },
	
	    /**
	     * Manually advances the physics simulation by one iteration.
	     * 
	     * You can optionally pass in the `delta` and `correction` values to be used by Engine.update.
	     * If undefined they use the Matter defaults of 60Hz and no correction.
	     * 
	     * Calling `step` directly bypasses any checks of `enabled` or `autoUpdate`.
	     * 
	     * It also ignores any custom `getDelta` functions, as you should be passing the delta
	     * value in to this call.
	     *
	     * You can adjust the number of iterations that Engine.update performs internally.
	     * Use the Scene Matter Physics config object to set the following properties:
	     *
	     * positionIterations (defaults to 6)
	     * velocityIterations (defaults to 4)
	     * constraintIterations (defaults to 2)
	     *
	     * Adjusting these values can help performance in certain situations, depending on the physics requirements
	     * of your game.
	     *
	     * @method Phaser.Physics.Matter.World#step
	     * @since 3.4.0
	     *
	     * @param {number} [delta=16.666] - [description]
	     * @param {number} [correction=1] - [description]
	     */
	    step: function (delta, correction)
	    {
	        Engine.update(this.engine, delta, correction);
	    },
	
	    /**
	     * Runs the Matter Engine.update at a fixed timestep of 60Hz.
	     *
	     * @method Phaser.Physics.Matter.World#update60Hz
	     * @since 3.4.0
	     *
	     * @return {number} The delta value to be passed to Engine.update.
	     */
	    update60Hz: function ()
	    {
	        return 1000 / 60;
	    },
	
	    /**
	     * Runs the Matter Engine.update at a fixed timestep of 30Hz.
	     *
	     * @method Phaser.Physics.Matter.World#update30Hz
	     * @since 3.4.0
	     *
	     * @return {number} The delta value to be passed to Engine.update.
	     */
	    update30Hz: function ()
	    {
	        return 1000 / 30;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.World#postUpdate
	     * @since 3.0.0
	     */
	    postUpdate: function ()
	    {
	        if (!this.drawDebug)
	        {
	            return;
	        }
	
	        var graphics = this.debugGraphic;
	        var bodies = Composite.allBodies(this.localWorld);
	
	        graphics.clear();
	        graphics.lineStyle(1, this.defaults.bodyDebugColor);
	        graphics.beginPath();
	
	        var i,j;
	
	        for (i = 0; i < bodies.length; i++)
	        {
	            if (!bodies[i].render.visible)
	            {
	                return;
	            }
	
	            // Handle drawing both single bodies and compound bodies. If compound, draw both the
	            // convex hull (first part) and the rest of the bodies.
	            for (j = 0; j < bodies[i].parts.length; j++)
	            {
	                var body = bodies[i].parts[j];
	
	                var vertices = body.vertices;
	
	                graphics.moveTo(vertices[0].x, vertices[0].y);
	
	                for (var k = 1; k < vertices.length; k++)
	                {
	                    graphics.lineTo(vertices[k].x, vertices[k].y);
	                }
	
	                graphics.lineTo(vertices[0].x, vertices[0].y);
	
	                graphics.strokePath();
	            }
	        }
	
	        graphics.closePath();
	
	        if (this.defaults.debugShowJoint)
	        {
	            graphics.lineStyle(2, this.defaults.jointDebugColor);
	
	            // Render constraints 
	            var constraints = Composite.allConstraints(this.localWorld);
	
	            for (i = 0; i < constraints.length; i++)
	            {
	                var constraint = constraints[i];
	
	                if (!constraint.render.visible || !constraint.pointA || !constraint.pointB)
	                {
	                    continue;
	                }
	
	                if (constraint.render.lineWidth)
	                {
	                    graphics.lineStyle(constraint.render.lineWidth, Common.colorToNumber(constraint.render.strokeStyle));
	                }
	
	                var bodyA = constraint.bodyA;
	                var bodyB = constraint.bodyB;
	                var start;
	                var end;
	
	                if (bodyA)
	                {
	                    start = Vector.add(bodyA.position, constraint.pointA);
	                }
	                else
	                {
	                    start = constraint.pointA;
	                }
	
	                if (constraint.render.type === 'pin')
	                {
	                    graphics.beginPath();
	                    graphics.arc(start.x, start.y, 3, 0, 2 * Math.PI);
	                    graphics.closePath();
	                }
	                else
	                {
	                    if (bodyB)
	                    {
	                        end = Vector.add(bodyB.position, constraint.pointB);
	                    }
	                    else
	                    {
	                        end = constraint.pointB;
	                    }
	
	                    graphics.beginPath();
	                    graphics.moveTo(start.x, start.y);
	
	                    if (constraint.render.type === 'spring')
	                    {
	                        var delta = Vector.sub(end, start);
	                        var normal = Vector.perp(Vector.normalise(delta));
	                        var coils = Math.ceil(Common.clamp(constraint.length / 5, 12, 20));
	                        var offset;
	
	                        for (j = 1; j < coils; j += 1)
	                        {
	                            offset = (j % 2 === 0) ? 1 : -1;
	
	                            graphics.lineTo(
	                                start.x + delta.x * (j / coils) + normal.x * offset * 4,
	                                start.y + delta.y * (j / coils) + normal.y * offset * 4
	                            );
	                        }
	                    }
	
	                    graphics.lineTo(end.x, end.y);
	                }
	
	                if (constraint.render.lineWidth)
	                {
	                    graphics.strokePath();
	                }
	
	                if (constraint.render.anchors)
	                {
	                    graphics.fillStyle(Common.colorToNumber(constraint.render.strokeStyle));
	                    graphics.beginPath();
	                    graphics.arc(start.x, start.y, 6, 0, 2 * Math.PI);
	                    graphics.arc(end.x, end.y, 6, 0, 2 * Math.PI);
	                    graphics.closePath();
	                    graphics.fillPath();
	                }
	            }
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.World#fromPath
	     * @since 3.0.0
	     *
	     * @param {string} path - [description]
	     * @param {array} points - [description]
	     *
	     * @return {array} [description]
	     */
	    fromPath: function (path, points)
	    {
	        if (points === undefined) { points = []; }
	
	        // var pathPattern = /L?\s*([-\d.e]+)[\s,]*([-\d.e]+)*/ig;
	
	        // eslint-disable-next-line no-useless-escape
	        var pathPattern = /L?\s*([\-\d\.e]+)[\s,]*([\-\d\.e]+)*/ig;
	
	        path.replace(pathPattern, function (match, x, y)
	        {
	            points.push({ x: parseFloat(x), y: parseFloat(y) });
	        });
	
	        return points;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.World#shutdown
	     * @since 3.0.0
	     */
	    shutdown: function ()
	    {
	        MatterEvents.off(this.engine);
	
	        this.removeAllListeners();
	
	        MatterWorld.clear(this.localWorld, false);
	
	        Engine.clear(this.engine);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.World#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.shutdown();
	    }
	
	});
	
	module.exports = World;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* The `Matter.Grid` module contains methods for creating and manipulating collision broadphase grid structures.
	*
	* @class Grid
	*/
	
	var Grid = {};
	
	module.exports = Grid;
	
	var Pair = __webpack_require__(206);
	var Detector = __webpack_require__(318);
	var Common = __webpack_require__(31);
	
	(function() {
	
	    /**
	     * Creates a new grid.
	     * @method create
	     * @param {} options
	     * @return {grid} A new grid
	     */
	    Grid.create = function(options) {
	        var defaults = {
	            controller: Grid,
	            detector: Detector.collisions,
	            buckets: {},
	            pairs: {},
	            pairsList: [],
	            bucketWidth: 48,
	            bucketHeight: 48
	        };
	
	        return Common.extend(defaults, options);
	    };
	
	    /**
	     * The width of a single grid bucket.
	     *
	     * @property bucketWidth
	     * @type number
	     * @default 48
	     */
	
	    /**
	     * The height of a single grid bucket.
	     *
	     * @property bucketHeight
	     * @type number
	     * @default 48
	     */
	
	    /**
	     * Updates the grid.
	     * @method update
	     * @param {grid} grid
	     * @param {body[]} bodies
	     * @param {engine} engine
	     * @param {boolean} forceUpdate
	     */
	    Grid.update = function(grid, bodies, engine, forceUpdate) {
	        var i, col, row,
	            world = engine.world,
	            buckets = grid.buckets,
	            bucket,
	            bucketId,
	            gridChanged = false;
	
	        // @if DEBUG
	        var metrics = engine.metrics;
	        metrics.broadphaseTests = 0;
	        // @endif
	
	        for (i = 0; i < bodies.length; i++) {
	            var body = bodies[i];
	
	            if (body.isSleeping && !forceUpdate)
	                continue;
	
	            // don't update out of world bodies
	            if (body.bounds.max.x < world.bounds.min.x || body.bounds.min.x > world.bounds.max.x
	                || body.bounds.max.y < world.bounds.min.y || body.bounds.min.y > world.bounds.max.y)
	                continue;
	
	            var newRegion = _getRegion(grid, body);
	
	            // if the body has changed grid region
	            if (!body.region || newRegion.id !== body.region.id || forceUpdate) {
	
	                // @if DEBUG
	                metrics.broadphaseTests += 1;
	                // @endif
	
	                if (!body.region || forceUpdate)
	                    body.region = newRegion;
	
	                var union = _regionUnion(newRegion, body.region);
	
	                // update grid buckets affected by region change
	                // iterate over the union of both regions
	                for (col = union.startCol; col <= union.endCol; col++) {
	                    for (row = union.startRow; row <= union.endRow; row++) {
	                        bucketId = _getBucketId(col, row);
	                        bucket = buckets[bucketId];
	
	                        var isInsideNewRegion = (col >= newRegion.startCol && col <= newRegion.endCol
	                                                && row >= newRegion.startRow && row <= newRegion.endRow);
	
	                        var isInsideOldRegion = (col >= body.region.startCol && col <= body.region.endCol
	                                                && row >= body.region.startRow && row <= body.region.endRow);
	
	                        // remove from old region buckets
	                        if (!isInsideNewRegion && isInsideOldRegion) {
	                            if (isInsideOldRegion) {
	                                if (bucket)
	                                    _bucketRemoveBody(grid, bucket, body);
	                            }
	                        }
	
	                        // add to new region buckets
	                        if (body.region === newRegion || (isInsideNewRegion && !isInsideOldRegion) || forceUpdate) {
	                            if (!bucket)
	                                bucket = _createBucket(buckets, bucketId);
	                            _bucketAddBody(grid, bucket, body);
	                        }
	                    }
	                }
	
	                // set the new region
	                body.region = newRegion;
	
	                // flag changes so we can update pairs
	                gridChanged = true;
	            }
	        }
	
	        // update pairs list only if pairs changed (i.e. a body changed region)
	        if (gridChanged)
	            grid.pairsList = _createActivePairsList(grid);
	    };
	
	    /**
	     * Clears the grid.
	     * @method clear
	     * @param {grid} grid
	     */
	    Grid.clear = function(grid) {
	        grid.buckets = {};
	        grid.pairs = {};
	        grid.pairsList = [];
	    };
	
	    /**
	     * Finds the union of two regions.
	     * @method _regionUnion
	     * @private
	     * @param {} regionA
	     * @param {} regionB
	     * @return {} region
	     */
	    var _regionUnion = function(regionA, regionB) {
	        var startCol = Math.min(regionA.startCol, regionB.startCol),
	            endCol = Math.max(regionA.endCol, regionB.endCol),
	            startRow = Math.min(regionA.startRow, regionB.startRow),
	            endRow = Math.max(regionA.endRow, regionB.endRow);
	
	        return _createRegion(startCol, endCol, startRow, endRow);
	    };
	
	    /**
	     * Gets the region a given body falls in for a given grid.
	     * @method _getRegion
	     * @private
	     * @param {} grid
	     * @param {} body
	     * @return {} region
	     */
	    var _getRegion = function(grid, body) {
	        var bounds = body.bounds,
	            startCol = Math.floor(bounds.min.x / grid.bucketWidth),
	            endCol = Math.floor(bounds.max.x / grid.bucketWidth),
	            startRow = Math.floor(bounds.min.y / grid.bucketHeight),
	            endRow = Math.floor(bounds.max.y / grid.bucketHeight);
	
	        return _createRegion(startCol, endCol, startRow, endRow);
	    };
	
	    /**
	     * Creates a region.
	     * @method _createRegion
	     * @private
	     * @param {} startCol
	     * @param {} endCol
	     * @param {} startRow
	     * @param {} endRow
	     * @return {} region
	     */
	    var _createRegion = function(startCol, endCol, startRow, endRow) {
	        return { 
	            id: startCol + ',' + endCol + ',' + startRow + ',' + endRow,
	            startCol: startCol, 
	            endCol: endCol, 
	            startRow: startRow, 
	            endRow: endRow 
	        };
	    };
	
	    /**
	     * Gets the bucket id at the given position.
	     * @method _getBucketId
	     * @private
	     * @param {} column
	     * @param {} row
	     * @return {string} bucket id
	     */
	    var _getBucketId = function(column, row) {
	        return 'C' + column + 'R' + row;
	    };
	
	    /**
	     * Creates a bucket.
	     * @method _createBucket
	     * @private
	     * @param {} buckets
	     * @param {} bucketId
	     * @return {} bucket
	     */
	    var _createBucket = function(buckets, bucketId) {
	        var bucket = buckets[bucketId] = [];
	        return bucket;
	    };
	
	    /**
	     * Adds a body to a bucket.
	     * @method _bucketAddBody
	     * @private
	     * @param {} grid
	     * @param {} bucket
	     * @param {} body
	     */
	    var _bucketAddBody = function(grid, bucket, body) {
	        // add new pairs
	        for (var i = 0; i < bucket.length; i++) {
	            var bodyB = bucket[i];
	
	            if (body.id === bodyB.id || (body.isStatic && bodyB.isStatic))
	                continue;
	
	            // keep track of the number of buckets the pair exists in
	            // important for Grid.update to work
	            var pairId = Pair.id(body, bodyB),
	                pair = grid.pairs[pairId];
	
	            if (pair) {
	                pair[2] += 1;
	            } else {
	                grid.pairs[pairId] = [body, bodyB, 1];
	            }
	        }
	
	        // add to bodies (after pairs, otherwise pairs with self)
	        bucket.push(body);
	    };
	
	    /**
	     * Removes a body from a bucket.
	     * @method _bucketRemoveBody
	     * @private
	     * @param {} grid
	     * @param {} bucket
	     * @param {} body
	     */
	    var _bucketRemoveBody = function(grid, bucket, body) {
	        // remove from bucket
	        bucket.splice(bucket.indexOf(body), 1);
	
	        // update pair counts
	        for (var i = 0; i < bucket.length; i++) {
	            // keep track of the number of buckets the pair exists in
	            // important for _createActivePairsList to work
	            var bodyB = bucket[i],
	                pairId = Pair.id(body, bodyB),
	                pair = grid.pairs[pairId];
	
	            if (pair)
	                pair[2] -= 1;
	        }
	    };
	
	    /**
	     * Generates a list of the active pairs in the grid.
	     * @method _createActivePairsList
	     * @private
	     * @param {} grid
	     * @return [] pairs
	     */
	    var _createActivePairsList = function(grid) {
	        var pairKeys,
	            pair,
	            pairs = [];
	
	        // grid.pairs is used as a hashmap
	        pairKeys = Common.keys(grid.pairs);
	
	        // iterate over grid.pairs
	        for (var k = 0; k < pairKeys.length; k++) {
	            pair = grid.pairs[pairKeys[k]];
	
	            // if pair exists in at least one bucket
	            // it is a pair that needs further collision testing so push it
	            if (pair[2] > 0) {
	                pairs.push(pair);
	            } else {
	                delete grid.pairs[pairKeys[k]];
	            }
	        }
	
	        return pairs;
	    };
	    
	})();


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* The `Matter.Pairs` module contains methods for creating and manipulating collision pair sets.
	*
	* @class Pairs
	*/
	
	var Pairs = {};
	
	module.exports = Pairs;
	
	var Pair = __webpack_require__(206);
	var Common = __webpack_require__(31);
	
	(function() {
	    
	    var _pairMaxIdleLife = 1000;
	
	    /**
	     * Creates a new pairs structure.
	     * @method create
	     * @param {object} options
	     * @return {pairs} A new pairs structure
	     */
	    Pairs.create = function(options) {
	        return Common.extend({ 
	            table: {},
	            list: [],
	            collisionStart: [],
	            collisionActive: [],
	            collisionEnd: []
	        }, options);
	    };
	
	    /**
	     * Updates pairs given a list of collisions.
	     * @method update
	     * @param {object} pairs
	     * @param {collision[]} collisions
	     * @param {number} timestamp
	     */
	    Pairs.update = function(pairs, collisions, timestamp) {
	        var pairsList = pairs.list,
	            pairsTable = pairs.table,
	            collisionStart = pairs.collisionStart,
	            collisionEnd = pairs.collisionEnd,
	            collisionActive = pairs.collisionActive,
	            collision,
	            pairId,
	            pair,
	            i;
	
	        // clear collision state arrays, but maintain old reference
	        collisionStart.length = 0;
	        collisionEnd.length = 0;
	        collisionActive.length = 0;
	
	        for (i = 0; i < pairsList.length; i++) {
	            pairsList[i].confirmedActive = false;
	        }
	
	        for (i = 0; i < collisions.length; i++) {
	            collision = collisions[i];
	
	            if (collision.collided) {
	                pairId = Pair.id(collision.bodyA, collision.bodyB);
	
	                pair = pairsTable[pairId];
	                
	                if (pair) {
	                    // pair already exists (but may or may not be active)
	                    if (pair.isActive) {
	                        // pair exists and is active
	                        collisionActive.push(pair);
	                    } else {
	                        // pair exists but was inactive, so a collision has just started again
	                        collisionStart.push(pair);
	                    }
	
	                    // update the pair
	                    Pair.update(pair, collision, timestamp);
	                    pair.confirmedActive = true;
	                } else {
	                    // pair did not exist, create a new pair
	                    pair = Pair.create(collision, timestamp);
	                    pairsTable[pairId] = pair;
	
	                    // push the new pair
	                    collisionStart.push(pair);
	                    pairsList.push(pair);
	                }
	            }
	        }
	
	        // deactivate previously active pairs that are now inactive
	        for (i = 0; i < pairsList.length; i++) {
	            pair = pairsList[i];
	            if (!pair.confirmedActive) {
	                Pair.setActive(pair, false, timestamp);
	                collisionEnd.push(pair);
	            }
	        }
	    };
	    
	    /**
	     * Finds and removes pairs that have been inactive for a set amount of time.
	     * @method removeOld
	     * @param {object} pairs
	     * @param {number} timestamp
	     */
	    Pairs.removeOld = function(pairs, timestamp) {
	        var pairsList = pairs.list,
	            pairsTable = pairs.table,
	            indexesToRemove = [],
	            pair,
	            collision,
	            pairIndex,
	            i;
	
	        for (i = 0; i < pairsList.length; i++) {
	            pair = pairsList[i];
	            collision = pair.collision;
	            
	            // never remove sleeping pairs
	            if (collision.bodyA.isSleeping || collision.bodyB.isSleeping) {
	                pair.timeUpdated = timestamp;
	                continue;
	            }
	
	            // if pair is inactive for too long, mark it to be removed
	            if (timestamp - pair.timeUpdated > _pairMaxIdleLife) {
	                indexesToRemove.push(i);
	            }
	        }
	
	        // remove marked pairs
	        for (i = 0; i < indexesToRemove.length; i++) {
	            pairIndex = indexesToRemove[i] - i;
	            pair = pairsList[pairIndex];
	            delete pairsTable[pair.id];
	            pairsList.splice(pairIndex, 1);
	        }
	    };
	
	    /**
	     * Clears the given pairs structure.
	     * @method clear
	     * @param {pairs} pairs
	     * @return {pairs} pairs
	     */
	    Pairs.clear = function(pairs) {
	        pairs.table = {};
	        pairs.list.length = 0;
	        pairs.collisionStart.length = 0;
	        pairs.collisionActive.length = 0;
	        pairs.collisionEnd.length = 0;
	        return pairs;
	    };
	
	})();


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* The `Matter.Resolver` module contains methods for resolving collision pairs.
	*
	* @class Resolver
	*/
	
	var Resolver = {};
	
	module.exports = Resolver;
	
	var Vertices = __webpack_require__(86);
	var Vector = __webpack_require__(71);
	var Common = __webpack_require__(31);
	var Bounds = __webpack_require__(85);
	
	(function() {
	
	    Resolver._restingThresh = 4;
	    Resolver._restingThreshTangent = 6;
	    Resolver._positionDampen = 0.9;
	    Resolver._positionWarming = 0.8;
	    Resolver._frictionNormalMultiplier = 5;
	
	    /**
	     * Prepare pairs for position solving.
	     * @method preSolvePosition
	     * @param {pair[]} pairs
	     */
	    Resolver.preSolvePosition = function(pairs) {
	        var i,
	            pair,
	            activeCount;
	
	        // find total contacts on each body
	        for (i = 0; i < pairs.length; i++) {
	            pair = pairs[i];
	            
	            if (!pair.isActive)
	                continue;
	            
	            activeCount = pair.activeContacts.length;
	            pair.collision.parentA.totalContacts += activeCount;
	            pair.collision.parentB.totalContacts += activeCount;
	        }
	    };
	
	    /**
	     * Find a solution for pair positions.
	     * @method solvePosition
	     * @param {pair[]} pairs
	     * @param {number} timeScale
	     */
	    Resolver.solvePosition = function(pairs, bodies, timeScale) {
	        var i,
	            normalX,
	            normalY,
	            pair,
	            collision,
	            bodyA,
	            bodyB,
	            normal,
	            separation,
	            penetration,
	            positionImpulseA,
	            positionImpulseB,
	            contactShare,
	            bodyBtoAX,
	            bodyBtoAY,
	            positionImpulse,
	                impulseCoefficient = timeScale * Resolver._positionDampen;
	
	        for (i = 0; i < bodies.length; i++) {
	            var body = bodies[i];
	            body.previousPositionImpulse.x = body.positionImpulse.x;
	            body.previousPositionImpulse.y = body.positionImpulse.y;
	        }
	
	        // find impulses required to resolve penetration
	        for (i = 0; i < pairs.length; i++) {
	            pair = pairs[i];
	            
	            if (!pair.isActive || pair.isSensor)
	                continue;
	
	            collision = pair.collision;
	            bodyA = collision.parentA;
	            bodyB = collision.parentB;
	            normal = collision.normal;
	
	            positionImpulseA = bodyA.previousPositionImpulse;
	            positionImpulseB = bodyB.previousPositionImpulse;
	
	            penetration = collision.penetration;
	
	            // bodyBtoA = positionImpulseB - positionImpulseA + penetration
	            bodyBtoAX = positionImpulseB.x - positionImpulseA.x + penetration.x;
	            bodyBtoAY = positionImpulseB.y - positionImpulseA.y + penetration.y;
	
	            normalX = normal.x;
	            normalY = normal.y;
	
	            // separation = dot(normal, bodyBtoA)
	            separation = normalX * bodyBtoAX + normalY * bodyBtoAY;
	            pair.separation = separation;
	
	            positionImpulse = (separation - pair.slop) * impulseCoefficient;
	
	            if (bodyA.isStatic || bodyB.isStatic)
	                positionImpulse *= 2;
	            
	            if (!(bodyA.isStatic || bodyA.isSleeping)) {
	                contactShare = positionImpulse / bodyA.totalContacts;
	                bodyA.positionImpulse.x += normalX * contactShare;
	                bodyA.positionImpulse.y += normalY * contactShare;
	            }
	
	            if (!(bodyB.isStatic || bodyB.isSleeping)) {
	                contactShare = positionImpulse / bodyB.totalContacts;
	                bodyB.positionImpulse.x -= normalX * contactShare;
	                bodyB.positionImpulse.y -= normalY * contactShare;
	            }
	        }
	    };
	
	    /**
	     * Apply position resolution.
	     * @method postSolvePosition
	     * @param {body[]} bodies
	     */
	    Resolver.postSolvePosition = function(bodies) {
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i];
	
	            // reset contact count
	            body.totalContacts = 0;
	
	            if (body.positionImpulse.x !== 0 || body.positionImpulse.y !== 0) {
	                // update body geometry
	                for (var j = 0; j < body.parts.length; j++) {
	                    var part = body.parts[j];
	                    Vertices.translate(part.vertices, body.positionImpulse);
	                    Bounds.update(part.bounds, part.vertices, body.velocity);
	                    part.position.x += body.positionImpulse.x;
	                    part.position.y += body.positionImpulse.y;
	                }
	
	                // move the body without changing velocity
	                body.positionPrev.x += body.positionImpulse.x;
	                body.positionPrev.y += body.positionImpulse.y;
	
	                if (Vector.dot(body.positionImpulse, body.velocity) < 0) {
	                    // reset cached impulse if the body has velocity along it
	                    body.positionImpulse.x = 0;
	                    body.positionImpulse.y = 0;
	                } else {
	                    // warm the next iteration
	                    body.positionImpulse.x *= Resolver._positionWarming;
	                    body.positionImpulse.y *= Resolver._positionWarming;
	                }
	            }
	        }
	    };
	
	    /**
	     * Prepare pairs for velocity solving.
	     * @method preSolveVelocity
	     * @param {pair[]} pairs
	     */
	    Resolver.preSolveVelocity = function(pairs) {
	        var i,
	            j,
	            pair,
	            contacts,
	            collision,
	            bodyA,
	            bodyB,
	            normal,
	            tangent,
	            contact,
	            contactVertex,
	            normalImpulse,
	            tangentImpulse,
	            offset,
	            impulse = Vector._temp[0],
	            tempA = Vector._temp[1];
	        
	        for (i = 0; i < pairs.length; i++) {
	            pair = pairs[i];
	            
	            if (!pair.isActive || pair.isSensor)
	                continue;
	            
	            contacts = pair.activeContacts;
	            collision = pair.collision;
	            bodyA = collision.parentA;
	            bodyB = collision.parentB;
	            normal = collision.normal;
	            tangent = collision.tangent;
	
	            // resolve each contact
	            for (j = 0; j < contacts.length; j++) {
	                contact = contacts[j];
	                contactVertex = contact.vertex;
	                normalImpulse = contact.normalImpulse;
	                tangentImpulse = contact.tangentImpulse;
	
	                if (normalImpulse !== 0 || tangentImpulse !== 0) {
	                    // total impulse from contact
	                    impulse.x = (normal.x * normalImpulse) + (tangent.x * tangentImpulse);
	                    impulse.y = (normal.y * normalImpulse) + (tangent.y * tangentImpulse);
	                    
	                    // apply impulse from contact
	                    if (!(bodyA.isStatic || bodyA.isSleeping)) {
	                        offset = Vector.sub(contactVertex, bodyA.position, tempA);
	                        bodyA.positionPrev.x += impulse.x * bodyA.inverseMass;
	                        bodyA.positionPrev.y += impulse.y * bodyA.inverseMass;
	                        bodyA.anglePrev += Vector.cross(offset, impulse) * bodyA.inverseInertia;
	                    }
	
	                    if (!(bodyB.isStatic || bodyB.isSleeping)) {
	                        offset = Vector.sub(contactVertex, bodyB.position, tempA);
	                        bodyB.positionPrev.x -= impulse.x * bodyB.inverseMass;
	                        bodyB.positionPrev.y -= impulse.y * bodyB.inverseMass;
	                        bodyB.anglePrev -= Vector.cross(offset, impulse) * bodyB.inverseInertia;
	                    }
	                }
	            }
	        }
	    };
	
	    /**
	     * Find a solution for pair velocities.
	     * @method solveVelocity
	     * @param {pair[]} pairs
	     * @param {number} timeScale
	     */
	    Resolver.solveVelocity = function(pairs, timeScale) {
	        var timeScaleSquared = timeScale * timeScale,
	            impulse = Vector._temp[0],
	            tempA = Vector._temp[1],
	            tempB = Vector._temp[2],
	            tempC = Vector._temp[3],
	            tempD = Vector._temp[4],
	            tempE = Vector._temp[5];
	        
	        for (var i = 0; i < pairs.length; i++) {
	            var pair = pairs[i];
	            
	            if (!pair.isActive || pair.isSensor)
	                continue;
	            
	            var collision = pair.collision,
	                bodyA = collision.parentA,
	                bodyB = collision.parentB,
	                normal = collision.normal,
	                tangent = collision.tangent,
	                contacts = pair.activeContacts,
	                contactShare = 1 / contacts.length;
	
	            // update body velocities
	            bodyA.velocity.x = bodyA.position.x - bodyA.positionPrev.x;
	            bodyA.velocity.y = bodyA.position.y - bodyA.positionPrev.y;
	            bodyB.velocity.x = bodyB.position.x - bodyB.positionPrev.x;
	            bodyB.velocity.y = bodyB.position.y - bodyB.positionPrev.y;
	            bodyA.angularVelocity = bodyA.angle - bodyA.anglePrev;
	            bodyB.angularVelocity = bodyB.angle - bodyB.anglePrev;
	
	            // resolve each contact
	            for (var j = 0; j < contacts.length; j++) {
	                var contact = contacts[j],
	                    contactVertex = contact.vertex,
	                    offsetA = Vector.sub(contactVertex, bodyA.position, tempA),
	                    offsetB = Vector.sub(contactVertex, bodyB.position, tempB),
	                    velocityPointA = Vector.add(bodyA.velocity, Vector.mult(Vector.perp(offsetA), bodyA.angularVelocity), tempC),
	                    velocityPointB = Vector.add(bodyB.velocity, Vector.mult(Vector.perp(offsetB), bodyB.angularVelocity), tempD), 
	                    relativeVelocity = Vector.sub(velocityPointA, velocityPointB, tempE),
	                    normalVelocity = Vector.dot(normal, relativeVelocity);
	
	                var tangentVelocity = Vector.dot(tangent, relativeVelocity),
	                    tangentSpeed = Math.abs(tangentVelocity),
	                    tangentVelocityDirection = Common.sign(tangentVelocity);
	
	                // raw impulses
	                var normalImpulse = (1 + pair.restitution) * normalVelocity,
	                    normalForce = Common.clamp(pair.separation + normalVelocity, 0, 1) * Resolver._frictionNormalMultiplier;
	
	                // coulomb friction
	                var tangentImpulse = tangentVelocity,
	                    maxFriction = Infinity;
	
	                if (tangentSpeed > pair.friction * pair.frictionStatic * normalForce * timeScaleSquared) {
	                    maxFriction = tangentSpeed;
	                    tangentImpulse = Common.clamp(
	                        pair.friction * tangentVelocityDirection * timeScaleSquared,
	                        -maxFriction, maxFriction
	                    );
	                }
	
	                // modify impulses accounting for mass, inertia and offset
	                var oAcN = Vector.cross(offsetA, normal),
	                    oBcN = Vector.cross(offsetB, normal),
	                    share = contactShare / (bodyA.inverseMass + bodyB.inverseMass + bodyA.inverseInertia * oAcN * oAcN  + bodyB.inverseInertia * oBcN * oBcN);
	
	                normalImpulse *= share;
	                tangentImpulse *= share;
	
	                // handle high velocity and resting collisions separately
	                if (normalVelocity < 0 && normalVelocity * normalVelocity > Resolver._restingThresh * timeScaleSquared) {
	                    // high normal velocity so clear cached contact normal impulse
	                    contact.normalImpulse = 0;
	                } else {
	                    // solve resting collision constraints using Erin Catto's method (GDC08)
	                    // impulse constraint tends to 0
	                    var contactNormalImpulse = contact.normalImpulse;
	                    contact.normalImpulse = Math.min(contact.normalImpulse + normalImpulse, 0);
	                    normalImpulse = contact.normalImpulse - contactNormalImpulse;
	                }
	
	                // handle high velocity and resting collisions separately
	                if (tangentVelocity * tangentVelocity > Resolver._restingThreshTangent * timeScaleSquared) {
	                    // high tangent velocity so clear cached contact tangent impulse
	                    contact.tangentImpulse = 0;
	                } else {
	                    // solve resting collision constraints using Erin Catto's method (GDC08)
	                    // tangent impulse tends to -tangentSpeed or +tangentSpeed
	                    var contactTangentImpulse = contact.tangentImpulse;
	                    contact.tangentImpulse = Common.clamp(contact.tangentImpulse + tangentImpulse, -maxFriction, maxFriction);
	                    tangentImpulse = contact.tangentImpulse - contactTangentImpulse;
	                }
	
	                // total impulse from contact
	                impulse.x = (normal.x * normalImpulse) + (tangent.x * tangentImpulse);
	                impulse.y = (normal.y * normalImpulse) + (tangent.y * tangentImpulse);
	                
	                // apply impulse from contact
	                if (!(bodyA.isStatic || bodyA.isSleeping)) {
	                    bodyA.positionPrev.x += impulse.x * bodyA.inverseMass;
	                    bodyA.positionPrev.y += impulse.y * bodyA.inverseMass;
	                    bodyA.anglePrev += Vector.cross(offsetA, impulse) * bodyA.inverseInertia;
	                }
	
	                if (!(bodyB.isStatic || bodyB.isSleeping)) {
	                    bodyB.positionPrev.x -= impulse.x * bodyB.inverseMass;
	                    bodyB.positionPrev.y -= impulse.y * bodyB.inverseMass;
	                    bodyB.anglePrev -= Vector.cross(offsetB, impulse) * bodyB.inverseInertia;
	                }
	            }
	        }
	    };
	
	})();


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* The `Matter.Engine` module contains methods for creating and manipulating engines.
	* An engine is a controller that manages updating the simulation of the world.
	* See `Matter.Runner` for an optional game loop utility.
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class Engine
	*/
	
	var Engine = {};
	
	module.exports = Engine;
	
	var World = __webpack_require__(317);
	var Sleeping = __webpack_require__(166);
	var Resolver = __webpack_require__(605);
	var Pairs = __webpack_require__(604);
	var Metrics = __webpack_require__(1485);
	var Grid = __webpack_require__(603);
	var Events = __webpack_require__(144);
	var Composite = __webpack_require__(118);
	var Constraint = __webpack_require__(143);
	var Common = __webpack_require__(31);
	var Body = __webpack_require__(51);
	
	(function() {
	
	    /**
	     * Creates a new engine. The options parameter is an object that specifies any properties you wish to override the defaults.
	     * All properties have default values, and many are pre-calculated automatically based on other properties.
	     * See the properties section below for detailed information on what you can pass via the `options` object.
	     * @method create
	     * @param {object} [options]
	     * @return {engine} engine
	     */
	    Engine.create = function(element, options) {
	        // options may be passed as the first (and only) argument
	        options = Common.isElement(element) ? options : element;
	        element = Common.isElement(element) ? element : null;
	        options = options || {};
	
	        if (element || options.render) {
	            Common.warn('Engine.create: engine.render is deprecated (see docs)');
	        }
	
	        var defaults = {
	            positionIterations: 6,
	            velocityIterations: 4,
	            constraintIterations: 2,
	            enableSleeping: false,
	            events: [],
	            plugin: {},
	            timing: {
	                timestamp: 0,
	                timeScale: 1
	            },
	            broadphase: {
	                controller: Grid
	            }
	        };
	
	        var engine = Common.extend(defaults, options);
	
	        /*
	        // @deprecated
	        if (element || engine.render) {
	            var renderDefaults = {
	                element: element,
	                controller: Render
	            };
	            
	            engine.render = Common.extend(renderDefaults, engine.render);
	        }
	
	        // @deprecated
	        if (engine.render && engine.render.controller) {
	            engine.render = engine.render.controller.create(engine.render);
	        }
	
	        // @deprecated
	        if (engine.render) {
	            engine.render.engine = engine;
	        }
	        */
	
	        engine.world = options.world || World.create(engine.world);
	        engine.pairs = Pairs.create();
	        engine.broadphase = engine.broadphase.controller.create(engine.broadphase);
	        engine.metrics = engine.metrics || { extended: false };
	
	        // @if DEBUG
	        engine.metrics = Metrics.create(engine.metrics);
	        // @endif
	
	        return engine;
	    };
	
	    /**
	     * Moves the simulation forward in time by `delta` ms.
	     * The `correction` argument is an optional `Number` that specifies the time correction factor to apply to the update.
	     * This can help improve the accuracy of the simulation in cases where `delta` is changing between updates.
	     * The value of `correction` is defined as `delta / lastDelta`, i.e. the percentage change of `delta` over the last step.
	     * Therefore the value is always `1` (no correction) when `delta` constant (or when no correction is desired, which is the default).
	     * See the paper on <a href="http://lonesock.net/article/verlet.html">Time Corrected Verlet</a> for more information.
	     *
	     * Triggers `beforeUpdate` and `afterUpdate` events.
	     * Triggers `collisionStart`, `collisionActive` and `collisionEnd` events.
	     * @method update
	     * @param {engine} engine
	     * @param {number} [delta=16.666]
	     * @param {number} [correction=1]
	     */
	    Engine.update = function(engine, delta, correction) {
	        delta = delta || 1000 / 60;
	        correction = correction || 1;
	
	        var world = engine.world,
	            timing = engine.timing,
	            broadphase = engine.broadphase,
	            broadphasePairs = [],
	            i;
	
	        // increment timestamp
	        timing.timestamp += delta * timing.timeScale;
	
	        // create an event object
	        var event = {
	            timestamp: timing.timestamp
	        };
	
	        Events.trigger(engine, 'beforeUpdate', event);
	
	        // get lists of all bodies and constraints, no matter what composites they are in
	        var allBodies = Composite.allBodies(world),
	            allConstraints = Composite.allConstraints(world);
	
	        // @if DEBUG
	        // reset metrics logging
	        Metrics.reset(engine.metrics);
	        // @endif
	
	        // if sleeping enabled, call the sleeping controller
	        if (engine.enableSleeping)
	            Sleeping.update(allBodies, timing.timeScale);
	
	        // applies gravity to all bodies
	        _bodiesApplyGravity(allBodies, world.gravity);
	
	        // update all body position and rotation by integration
	        _bodiesUpdate(allBodies, delta, timing.timeScale, correction, world.bounds);
	
	        // update all constraints (first pass)
	        Constraint.preSolveAll(allBodies);
	        for (i = 0; i < engine.constraintIterations; i++) {
	            Constraint.solveAll(allConstraints, timing.timeScale);
	        }
	        Constraint.postSolveAll(allBodies);
	
	        // broadphase pass: find potential collision pairs
	        if (broadphase.controller) {
	            // if world is dirty, we must flush the whole grid
	            if (world.isModified)
	                broadphase.controller.clear(broadphase);
	
	            // update the grid buckets based on current bodies
	            broadphase.controller.update(broadphase, allBodies, engine, world.isModified);
	            broadphasePairs = broadphase.pairsList;
	        } else {
	            // if no broadphase set, we just pass all bodies
	            broadphasePairs = allBodies;
	        }
	
	        // clear all composite modified flags
	        if (world.isModified) {
	            Composite.setModified(world, false, false, true);
	        }
	
	        // narrowphase pass: find actual collisions, then create or update collision pairs
	        var collisions = broadphase.detector(broadphasePairs, engine);
	
	        // update collision pairs
	        var pairs = engine.pairs,
	            timestamp = timing.timestamp;
	        Pairs.update(pairs, collisions, timestamp);
	        Pairs.removeOld(pairs, timestamp);
	
	        // wake up bodies involved in collisions
	        if (engine.enableSleeping)
	            Sleeping.afterCollisions(pairs.list, timing.timeScale);
	
	        // trigger collision events
	        if (pairs.collisionStart.length > 0)
	            Events.trigger(engine, 'collisionStart', { pairs: pairs.collisionStart });
	
	        // iteratively resolve position between collisions
	        Resolver.preSolvePosition(pairs.list);
	        for (i = 0; i < engine.positionIterations; i++) {
	            Resolver.solvePosition(pairs.list, allBodies, timing.timeScale);
	        }
	        Resolver.postSolvePosition(allBodies);
	
	        // update all constraints (second pass)
	        Constraint.preSolveAll(allBodies);
	        for (i = 0; i < engine.constraintIterations; i++) {
	            Constraint.solveAll(allConstraints, timing.timeScale);
	        }
	        Constraint.postSolveAll(allBodies);
	
	        // iteratively resolve velocity between collisions
	        Resolver.preSolveVelocity(pairs.list);
	        for (i = 0; i < engine.velocityIterations; i++) {
	            Resolver.solveVelocity(pairs.list, timing.timeScale);
	        }
	
	        // trigger collision events
	        if (pairs.collisionActive.length > 0)
	            Events.trigger(engine, 'collisionActive', { pairs: pairs.collisionActive });
	
	        if (pairs.collisionEnd.length > 0)
	            Events.trigger(engine, 'collisionEnd', { pairs: pairs.collisionEnd });
	
	        // @if DEBUG
	        // update metrics log
	        Metrics.update(engine.metrics, engine);
	        // @endif
	
	        // clear force buffers
	        _bodiesClearForces(allBodies);
	
	        Events.trigger(engine, 'afterUpdate', event);
	
	        return engine;
	    };
	    
	    /**
	     * Merges two engines by keeping the configuration of `engineA` but replacing the world with the one from `engineB`.
	     * @method merge
	     * @param {engine} engineA
	     * @param {engine} engineB
	     */
	    Engine.merge = function(engineA, engineB) {
	        Common.extend(engineA, engineB);
	        
	        if (engineB.world) {
	            engineA.world = engineB.world;
	
	            Engine.clear(engineA);
	
	            var bodies = Composite.allBodies(engineA.world);
	
	            for (var i = 0; i < bodies.length; i++) {
	                var body = bodies[i];
	                Sleeping.set(body, false);
	                body.id = Common.nextId();
	            }
	        }
	    };
	
	    /**
	     * Clears the engine including the world, pairs and broadphase.
	     * @method clear
	     * @param {engine} engine
	     */
	    Engine.clear = function(engine) {
	        var world = engine.world;
	        
	        Pairs.clear(engine.pairs);
	
	        var broadphase = engine.broadphase;
	        if (broadphase.controller) {
	            var bodies = Composite.allBodies(world);
	            broadphase.controller.clear(broadphase);
	            broadphase.controller.update(broadphase, bodies, engine, true);
	        }
	    };
	
	    /**
	     * Zeroes the `body.force` and `body.torque` force buffers.
	     * @method bodiesClearForces
	     * @private
	     * @param {body[]} bodies
	     */
	    var _bodiesClearForces = function(bodies) {
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i];
	
	            // reset force buffers
	            body.force.x = 0;
	            body.force.y = 0;
	            body.torque = 0;
	        }
	    };
	
	    /**
	     * Applys a mass dependant force to all given bodies.
	     * @method bodiesApplyGravity
	     * @private
	     * @param {body[]} bodies
	     * @param {vector} gravity
	     */
	    var _bodiesApplyGravity = function(bodies, gravity) {
	        var gravityScale = typeof gravity.scale !== 'undefined' ? gravity.scale : 0.001;
	
	        if ((gravity.x === 0 && gravity.y === 0) || gravityScale === 0) {
	            return;
	        }
	        
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i];
	
	            if (body.ignoreGravity || body.isStatic || body.isSleeping)
	                continue;
	
	            // apply gravity
	            body.force.y += body.mass * gravity.y * gravityScale;
	            body.force.x += body.mass * gravity.x * gravityScale;
	        }
	    };
	
	    /**
	     * Applys `Body.update` to all given `bodies`.
	     * @method updateAll
	     * @private
	     * @param {body[]} bodies
	     * @param {number} deltaTime 
	     * The amount of time elapsed between updates
	     * @param {number} timeScale
	     * @param {number} correction 
	     * The Verlet correction factor (deltaTime / lastDeltaTime)
	     * @param {bounds} worldBounds
	     */
	    var _bodiesUpdate = function(bodies, deltaTime, timeScale, correction, worldBounds) {
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i];
	
	            if (body.isStatic || body.isSleeping)
	                continue;
	
	            Body.update(body, deltaTime, timeScale, correction);
	        }
	    };
	
	    /**
	     * An alias for `Runner.run`, see `Matter.Runner` for more information.
	     * @method run
	     * @param {engine} engine
	     */
	
	    /**
	    * Fired just before an update
	    *
	    * @event beforeUpdate
	    * @param {} event An event object
	    * @param {number} event.timestamp The engine.timing.timestamp of the event
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired after engine update and all collision events
	    *
	    * @event afterUpdate
	    * @param {} event An event object
	    * @param {number} event.timestamp The engine.timing.timestamp of the event
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired after engine update, provides a list of all pairs that have started to collide in the current tick (if any)
	    *
	    * @event collisionStart
	    * @param {} event An event object
	    * @param {} event.pairs List of affected pairs
	    * @param {number} event.timestamp The engine.timing.timestamp of the event
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired after engine update, provides a list of all pairs that are colliding in the current tick (if any)
	    *
	    * @event collisionActive
	    * @param {} event An event object
	    * @param {} event.pairs List of affected pairs
	    * @param {number} event.timestamp The engine.timing.timestamp of the event
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired after engine update, provides a list of all pairs that have ended collision in the current tick (if any)
	    *
	    * @event collisionEnd
	    * @param {} event An event object
	    * @param {} event.pairs List of affected pairs
	    * @param {number} event.timestamp The engine.timing.timestamp of the event
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /*
	    *
	    *  Properties Documentation
	    *
	    */
	
	    /**
	     * An integer `Number` that specifies the number of position iterations to perform each update.
	     * The higher the value, the higher quality the simulation will be at the expense of performance.
	     *
	     * @property positionIterations
	     * @type number
	     * @default 6
	     */
	
	    /**
	     * An integer `Number` that specifies the number of velocity iterations to perform each update.
	     * The higher the value, the higher quality the simulation will be at the expense of performance.
	     *
	     * @property velocityIterations
	     * @type number
	     * @default 4
	     */
	
	    /**
	     * An integer `Number` that specifies the number of constraint iterations to perform each update.
	     * The higher the value, the higher quality the simulation will be at the expense of performance.
	     * The default value of `2` is usually very adequate.
	     *
	     * @property constraintIterations
	     * @type number
	     * @default 2
	     */
	
	    /**
	     * A flag that specifies whether the engine should allow sleeping via the `Matter.Sleeping` module.
	     * Sleeping can improve stability and performance, but often at the expense of accuracy.
	     *
	     * @property enableSleeping
	     * @type boolean
	     * @default false
	     */
	
	    /**
	     * An `Object` containing properties regarding the timing systems of the engine. 
	     *
	     * @property timing
	     * @type object
	     */
	
	    /**
	     * A `Number` that specifies the global scaling factor of time for all bodies.
	     * A value of `0` freezes the simulation.
	     * A value of `0.1` gives a slow-motion effect.
	     * A value of `1.2` gives a speed-up effect.
	     *
	     * @property timing.timeScale
	     * @type number
	     * @default 1
	     */
	
	    /**
	     * A `Number` that specifies the current simulation-time in milliseconds starting from `0`. 
	     * It is incremented on every `Engine.update` by the given `delta` argument. 
	     *
	     * @property timing.timestamp
	     * @type number
	     * @default 0
	     */
	
	    /**
	     * An instance of a `Render` controller. The default value is a `Matter.Render` instance created by `Engine.create`.
	     * One may also develop a custom renderer module based on `Matter.Render` and pass an instance of it to `Engine.create` via `options.render`.
	     *
	     * A minimal custom renderer object must define at least three functions: `create`, `clear` and `world` (see `Matter.Render`).
	     * It is also possible to instead pass the _module_ reference via `options.render.controller` and `Engine.create` will instantiate one for you.
	     *
	     * @property render
	     * @type render
	     * @deprecated see Demo.js for an example of creating a renderer
	     * @default a Matter.Render instance
	     */
	
	    /**
	     * An instance of a broadphase controller. The default value is a `Matter.Grid` instance created by `Engine.create`.
	     *
	     * @property broadphase
	     * @type grid
	     * @default a Matter.Grid instance
	     */
	
	    /**
	     * A `World` composite object that will contain all simulated bodies and constraints.
	     *
	     * @property world
	     * @type world
	     * @default a Matter.World instance
	     */
	
	    /**
	     * An object reserved for storing plugin-specific properties.
	     *
	     * @property plugin
	     * @type {}
	     */
	
	})();


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* The `Matter` module is the top level namespace. It also includes a function for installing plugins on top of the library.
	*
	* @class Matter
	*/
	
	var Matter = {};
	
	module.exports = Matter;
	
	var Plugin = __webpack_require__(320);
	var Common = __webpack_require__(31);
	
	(function() {
	
	    /**
	     * The library name.
	     * @property name
	     * @readOnly
	     * @type {String}
	     */
	    Matter.name = 'matter-js';
	
	    /**
	     * The library version.
	     * @property version
	     * @readOnly
	     * @type {String}
	     */
	    Matter.version = '0.13.1';
	
	    /**
	     * A list of plugin dependencies to be installed. These are normally set and installed through `Matter.use`.
	     * Alternatively you may set `Matter.uses` manually and install them by calling `Plugin.use(Matter)`.
	     * @property uses
	     * @type {Array}
	     */
	    Matter.uses = [];
	
	    /**
	     * The plugins that have been installed through `Matter.Plugin.install`. Read only.
	     * @property used
	     * @readOnly
	     * @type {Array}
	     */
	    Matter.used = [];
	
	    /**
	     * Installs the given plugins on the `Matter` namespace.
	     * This is a short-hand for `Plugin.use`, see it for more information.
	     * Call this function once at the start of your code, with all of the plugins you wish to install as arguments.
	     * Avoid calling this function multiple times unless you intend to manually control installation order.
	     * @method use
	     * @param ...plugin {Function} The plugin(s) to install on `base` (multi-argument).
	     */
	    Matter.use = function() {
	        Plugin.use(Matter, Array.prototype.slice.call(arguments));
	    };
	
	    /**
	     * Chains a function to excute before the original function on the given `path` relative to `Matter`.
	     * See also docs for `Common.chain`.
	     * @method before
	     * @param {string} path The path relative to `Matter`
	     * @param {function} func The function to chain before the original
	     * @return {function} The chained function that replaced the original
	     */
	    Matter.before = function(path, func) {
	        path = path.replace(/^Matter./, '');
	        return Common.chainPathBefore(Matter, path, func);
	    };
	
	    /**
	     * Chains a function to excute after the original function on the given `path` relative to `Matter`.
	     * See also docs for `Common.chain`.
	     * @method after
	     * @param {string} path The path relative to `Matter`
	     * @param {function} func The function to chain after the original
	     * @return {function} The chained function that replaced the original
	     */
	    Matter.after = function(path, func) {
	        path = path.replace(/^Matter./, '');
	        return Common.chainPathAfter(Matter, path, func);
	    };
	
	})();


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* The `Matter.Composites` module contains factory methods for creating composite bodies
	* with commonly used configurations (such as stacks and chains).
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class Composites
	*/
	
	var Composites = {};
	
	module.exports = Composites;
	
	var Composite = __webpack_require__(118);
	var Constraint = __webpack_require__(143);
	var Common = __webpack_require__(31);
	var Body = __webpack_require__(51);
	var Bodies = __webpack_require__(119);
	
	(function() {
	
	    /**
	     * Create a new composite containing bodies created in the callback in a grid arrangement.
	     * This function uses the body's bounds to prevent overlaps.
	     * @method stack
	     * @param {number} xx
	     * @param {number} yy
	     * @param {number} columns
	     * @param {number} rows
	     * @param {number} columnGap
	     * @param {number} rowGap
	     * @param {function} callback
	     * @return {composite} A new composite containing objects created in the callback
	     */
	    Composites.stack = function(xx, yy, columns, rows, columnGap, rowGap, callback) {
	        var stack = Composite.create({ label: 'Stack' }),
	            x = xx,
	            y = yy,
	            lastBody,
	            i = 0;
	
	        for (var row = 0; row < rows; row++) {
	            var maxHeight = 0;
	            
	            for (var column = 0; column < columns; column++) {
	                var body = callback(x, y, column, row, lastBody, i);
	                    
	                if (body) {
	                    var bodyHeight = body.bounds.max.y - body.bounds.min.y,
	                        bodyWidth = body.bounds.max.x - body.bounds.min.x; 
	
	                    if (bodyHeight > maxHeight)
	                        maxHeight = bodyHeight;
	                    
	                    Body.translate(body, { x: bodyWidth * 0.5, y: bodyHeight * 0.5 });
	
	                    x = body.bounds.max.x + columnGap;
	
	                    Composite.addBody(stack, body);
	                    
	                    lastBody = body;
	                    i += 1;
	                } else {
	                    x += columnGap;
	                }
	            }
	            
	            y += maxHeight + rowGap;
	            x = xx;
	        }
	
	        return stack;
	    };
	    
	    /**
	     * Chains all bodies in the given composite together using constraints.
	     * @method chain
	     * @param {composite} composite
	     * @param {number} xOffsetA
	     * @param {number} yOffsetA
	     * @param {number} xOffsetB
	     * @param {number} yOffsetB
	     * @param {object} options
	     * @return {composite} A new composite containing objects chained together with constraints
	     */
	    Composites.chain = function(composite, xOffsetA, yOffsetA, xOffsetB, yOffsetB, options) {
	        var bodies = composite.bodies;
	        
	        for (var i = 1; i < bodies.length; i++) {
	            var bodyA = bodies[i - 1],
	                bodyB = bodies[i],
	                bodyAHeight = bodyA.bounds.max.y - bodyA.bounds.min.y,
	                bodyAWidth = bodyA.bounds.max.x - bodyA.bounds.min.x, 
	                bodyBHeight = bodyB.bounds.max.y - bodyB.bounds.min.y,
	                bodyBWidth = bodyB.bounds.max.x - bodyB.bounds.min.x;
	        
	            var defaults = {
	                bodyA: bodyA,
	                pointA: { x: bodyAWidth * xOffsetA, y: bodyAHeight * yOffsetA },
	                bodyB: bodyB,
	                pointB: { x: bodyBWidth * xOffsetB, y: bodyBHeight * yOffsetB }
	            };
	            
	            var constraint = Common.extend(defaults, options);
	        
	            Composite.addConstraint(composite, Constraint.create(constraint));
	        }
	
	        composite.label += ' Chain';
	        
	        return composite;
	    };
	
	    /**
	     * Connects bodies in the composite with constraints in a grid pattern, with optional cross braces.
	     * @method mesh
	     * @param {composite} composite
	     * @param {number} columns
	     * @param {number} rows
	     * @param {boolean} crossBrace
	     * @param {object} options
	     * @return {composite} The composite containing objects meshed together with constraints
	     */
	    Composites.mesh = function(composite, columns, rows, crossBrace, options) {
	        var bodies = composite.bodies,
	            row,
	            col,
	            bodyA,
	            bodyB,
	            bodyC;
	        
	        for (row = 0; row < rows; row++) {
	            for (col = 1; col < columns; col++) {
	                bodyA = bodies[(col - 1) + (row * columns)];
	                bodyB = bodies[col + (row * columns)];
	                Composite.addConstraint(composite, Constraint.create(Common.extend({ bodyA: bodyA, bodyB: bodyB }, options)));
	            }
	
	            if (row > 0) {
	                for (col = 0; col < columns; col++) {
	                    bodyA = bodies[col + ((row - 1) * columns)];
	                    bodyB = bodies[col + (row * columns)];
	                    Composite.addConstraint(composite, Constraint.create(Common.extend({ bodyA: bodyA, bodyB: bodyB }, options)));
	
	                    if (crossBrace && col > 0) {
	                        bodyC = bodies[(col - 1) + ((row - 1) * columns)];
	                        Composite.addConstraint(composite, Constraint.create(Common.extend({ bodyA: bodyC, bodyB: bodyB }, options)));
	                    }
	
	                    if (crossBrace && col < columns - 1) {
	                        bodyC = bodies[(col + 1) + ((row - 1) * columns)];
	                        Composite.addConstraint(composite, Constraint.create(Common.extend({ bodyA: bodyC, bodyB: bodyB }, options)));
	                    }
	                }
	            }
	        }
	
	        composite.label += ' Mesh';
	        
	        return composite;
	    };
	    
	    /**
	     * Create a new composite containing bodies created in the callback in a pyramid arrangement.
	     * This function uses the body's bounds to prevent overlaps.
	     * @method pyramid
	     * @param {number} xx
	     * @param {number} yy
	     * @param {number} columns
	     * @param {number} rows
	     * @param {number} columnGap
	     * @param {number} rowGap
	     * @param {function} callback
	     * @return {composite} A new composite containing objects created in the callback
	     */
	    Composites.pyramid = function(xx, yy, columns, rows, columnGap, rowGap, callback) {
	        return Composites.stack(xx, yy, columns, rows, columnGap, rowGap, function(x, y, column, row, lastBody, i) {
	            var actualRows = Math.min(rows, Math.ceil(columns / 2)),
	                lastBodyWidth = lastBody ? lastBody.bounds.max.x - lastBody.bounds.min.x : 0;
	            
	            if (row > actualRows)
	                return;
	            
	            // reverse row order
	            row = actualRows - row;
	            
	            var start = row,
	                end = columns - 1 - row;
	
	            if (column < start || column > end)
	                return;
	            
	            // retroactively fix the first body's position, since width was unknown
	            if (i === 1) {
	                Body.translate(lastBody, { x: (column + (columns % 2 === 1 ? 1 : -1)) * lastBodyWidth, y: 0 });
	            }
	
	            var xOffset = lastBody ? column * lastBodyWidth : 0;
	            
	            return callback(xx + xOffset + column * columnGap, y, column, row, lastBody, i);
	        });
	    };
	
	    /**
	     * Creates a composite with a Newton's Cradle setup of bodies and constraints.
	     * @method newtonsCradle
	     * @param {number} xx
	     * @param {number} yy
	     * @param {number} number
	     * @param {number} size
	     * @param {number} length
	     * @return {composite} A new composite newtonsCradle body
	     */
	    Composites.newtonsCradle = function(xx, yy, number, size, length) {
	        var newtonsCradle = Composite.create({ label: 'Newtons Cradle' });
	
	        for (var i = 0; i < number; i++) {
	            var separation = 1.9,
	                circle = Bodies.circle(xx + i * (size * separation), yy + length, size, 
	                            { inertia: Infinity, restitution: 1, friction: 0, frictionAir: 0.0001, slop: 1 }),
	                constraint = Constraint.create({ pointA: { x: xx + i * (size * separation), y: yy }, bodyB: circle });
	
	            Composite.addBody(newtonsCradle, circle);
	            Composite.addConstraint(newtonsCradle, constraint);
	        }
	
	        return newtonsCradle;
	    };
	    
	    /**
	     * Creates a composite with simple car setup of bodies and constraints.
	     * @method car
	     * @param {number} xx
	     * @param {number} yy
	     * @param {number} width
	     * @param {number} height
	     * @param {number} wheelSize
	     * @return {composite} A new composite car body
	     */
	    Composites.car = function(xx, yy, width, height, wheelSize) {
	        var group = Body.nextGroup(true),
	            wheelBase = 20,
	            wheelAOffset = -width * 0.5 + wheelBase,
	            wheelBOffset = width * 0.5 - wheelBase,
	            wheelYOffset = 0;
	    
	        var car = Composite.create({ label: 'Car' }),
	            body = Bodies.rectangle(xx, yy, width, height, { 
	                collisionFilter: {
	                    group: group
	                },
	                chamfer: {
	                    radius: height * 0.5
	                },
	                density: 0.0002
	            });
	    
	        var wheelA = Bodies.circle(xx + wheelAOffset, yy + wheelYOffset, wheelSize, { 
	            collisionFilter: {
	                group: group
	            },
	            friction: 0.8
	        });
	                    
	        var wheelB = Bodies.circle(xx + wheelBOffset, yy + wheelYOffset, wheelSize, { 
	            collisionFilter: {
	                group: group
	            },
	            friction: 0.8
	        });
	                    
	        var axelA = Constraint.create({
	            bodyB: body,
	            pointB: { x: wheelAOffset, y: wheelYOffset },
	            bodyA: wheelA,
	            stiffness: 1,
	            length: 0
	        });
	                        
	        var axelB = Constraint.create({
	            bodyB: body,
	            pointB: { x: wheelBOffset, y: wheelYOffset },
	            bodyA: wheelB,
	            stiffness: 1,
	            length: 0
	        });
	        
	        Composite.addBody(car, body);
	        Composite.addBody(car, wheelA);
	        Composite.addBody(car, wheelB);
	        Composite.addConstraint(car, axelA);
	        Composite.addConstraint(car, axelB);
	
	        return car;
	    };
	
	    /**
	     * Creates a simple soft body like object.
	     * @method softBody
	     * @param {number} xx
	     * @param {number} yy
	     * @param {number} columns
	     * @param {number} rows
	     * @param {number} columnGap
	     * @param {number} rowGap
	     * @param {boolean} crossBrace
	     * @param {number} particleRadius
	     * @param {} particleOptions
	     * @param {} constraintOptions
	     * @return {composite} A new composite softBody
	     */
	    Composites.softBody = function(xx, yy, columns, rows, columnGap, rowGap, crossBrace, particleRadius, particleOptions, constraintOptions) {
	        particleOptions = Common.extend({ inertia: Infinity }, particleOptions);
	        constraintOptions = Common.extend({ stiffness: 0.2, render: { type: 'line', anchors: false } }, constraintOptions);
	
	        var softBody = Composites.stack(xx, yy, columns, rows, columnGap, rowGap, function(x, y) {
	            return Bodies.circle(x, y, particleRadius, particleOptions);
	        });
	
	        Composites.mesh(softBody, columns, rows, crossBrace, constraintOptions);
	
	        softBody.label = 'Soft Body';
	
	        return softBody;
	    };
	
	})();


/***/ }),
/* 609 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	module.exports = {
	    decomp: polygonDecomp,
	    quickDecomp: polygonQuickDecomp,
	    isSimple: polygonIsSimple,
	    removeCollinearPoints: polygonRemoveCollinearPoints,
	    makeCCW: polygonMakeCCW
	};
	
	/**
	 * Compute the intersection between two lines.
	 * @static
	 * @method lineInt
	 * @param  {Array}  l1          Line vector 1
	 * @param  {Array}  l2          Line vector 2
	 * @param  {Number} precision   Precision to use when checking if the lines are parallel
	 * @return {Array}              The intersection point.
	 */
	function lineInt(l1,l2,precision){
	    precision = precision || 0;
	    var i = [0,0]; // point
	    var a1, b1, c1, a2, b2, c2, det; // scalars
	    a1 = l1[1][1] - l1[0][1];
	    b1 = l1[0][0] - l1[1][0];
	    c1 = a1 * l1[0][0] + b1 * l1[0][1];
	    a2 = l2[1][1] - l2[0][1];
	    b2 = l2[0][0] - l2[1][0];
	    c2 = a2 * l2[0][0] + b2 * l2[0][1];
	    det = a1 * b2 - a2*b1;
	    if (!scalar_eq(det, 0, precision)) { // lines are not parallel
	        i[0] = (b2 * c1 - b1 * c2) / det;
	        i[1] = (a1 * c2 - a2 * c1) / det;
	    }
	    return i;
	}
	
	/**
	 * Checks if two line segments intersects.
	 * @method segmentsIntersect
	 * @param {Array} p1 The start vertex of the first line segment.
	 * @param {Array} p2 The end vertex of the first line segment.
	 * @param {Array} q1 The start vertex of the second line segment.
	 * @param {Array} q2 The end vertex of the second line segment.
	 * @return {Boolean} True if the two line segments intersect
	 */
	function lineSegmentsIntersect(p1, p2, q1, q2){
		var dx = p2[0] - p1[0];
		var dy = p2[1] - p1[1];
		var da = q2[0] - q1[0];
		var db = q2[1] - q1[1];
	
		// segments are parallel
		if((da*dy - db*dx) === 0){
			return false;
		}
	
		var s = (dx * (q1[1] - p1[1]) + dy * (p1[0] - q1[0])) / (da * dy - db * dx);
		var t = (da * (p1[1] - q1[1]) + db * (q1[0] - p1[0])) / (db * dx - da * dy);
	
		return (s>=0 && s<=1 && t>=0 && t<=1);
	}
	
	/**
	 * Get the area of a triangle spanned by the three given points. Note that the area will be negative if the points are not given in counter-clockwise order.
	 * @static
	 * @method area
	 * @param  {Array} a
	 * @param  {Array} b
	 * @param  {Array} c
	 * @return {Number}
	 */
	function triangleArea(a,b,c){
	    return (((b[0] - a[0])*(c[1] - a[1]))-((c[0] - a[0])*(b[1] - a[1])));
	}
	
	function isLeft(a,b,c){
	    return triangleArea(a,b,c) > 0;
	}
	
	function isLeftOn(a,b,c) {
	    return triangleArea(a, b, c) >= 0;
	}
	
	function isRight(a,b,c) {
	    return triangleArea(a, b, c) < 0;
	}
	
	function isRightOn(a,b,c) {
	    return triangleArea(a, b, c) <= 0;
	}
	
	var tmpPoint1 = [],
	    tmpPoint2 = [];
	
	/**
	 * Check if three points are collinear
	 * @method collinear
	 * @param  {Array} a
	 * @param  {Array} b
	 * @param  {Array} c
	 * @param  {Number} [thresholdAngle=0] Threshold angle to use when comparing the vectors. The function will return true if the angle between the resulting vectors is less than this value. Use zero for max precision.
	 * @return {Boolean}
	 */
	function collinear(a,b,c,thresholdAngle) {
	    if(!thresholdAngle){
	        return triangleArea(a, b, c) === 0;
	    } else {
	        var ab = tmpPoint1,
	            bc = tmpPoint2;
	
	        ab[0] = b[0]-a[0];
	        ab[1] = b[1]-a[1];
	        bc[0] = c[0]-b[0];
	        bc[1] = c[1]-b[1];
	
	        var dot = ab[0]*bc[0] + ab[1]*bc[1],
	            magA = Math.sqrt(ab[0]*ab[0] + ab[1]*ab[1]),
	            magB = Math.sqrt(bc[0]*bc[0] + bc[1]*bc[1]),
	            angle = Math.acos(dot/(magA*magB));
	        return angle < thresholdAngle;
	    }
	}
	
	function sqdist(a,b){
	    var dx = b[0] - a[0];
	    var dy = b[1] - a[1];
	    return dx * dx + dy * dy;
	}
	
	/**
	 * Get a vertex at position i. It does not matter if i is out of bounds, this function will just cycle.
	 * @method at
	 * @param  {Number} i
	 * @return {Array}
	 */
	function polygonAt(polygon, i){
	    var s = polygon.length;
	    return polygon[i < 0 ? i % s + s : i % s];
	}
	
	/**
	 * Clear the polygon data
	 * @method clear
	 * @return {Array}
	 */
	function polygonClear(polygon){
	    polygon.length = 0;
	}
	
	/**
	 * Append points "from" to "to"-1 from an other polygon "poly" onto this one.
	 * @method append
	 * @param {Polygon} poly The polygon to get points from.
	 * @param {Number}  from The vertex index in "poly".
	 * @param {Number}  to The end vertex index in "poly". Note that this vertex is NOT included when appending.
	 * @return {Array}
	 */
	function polygonAppend(polygon, poly, from, to){
	    for(var i=from; i<to; i++){
	        polygon.push(poly[i]);
	    }
	}
	
	/**
	 * Make sure that the polygon vertices are ordered counter-clockwise.
	 * @method makeCCW
	 */
	function polygonMakeCCW(polygon){
	    var br = 0,
	        v = polygon;
	
	    // find bottom right point
	    for (var i = 1; i < polygon.length; ++i) {
	        if (v[i][1] < v[br][1] || (v[i][1] === v[br][1] && v[i][0] > v[br][0])) {
	            br = i;
	        }
	    }
	
	    // reverse poly if clockwise
	    if (!isLeft(polygonAt(polygon, br - 1), polygonAt(polygon, br), polygonAt(polygon, br + 1))) {
	        polygonReverse(polygon);
	    }
	}
	
	/**
	 * Reverse the vertices in the polygon
	 * @method reverse
	 */
	function polygonReverse(polygon){
	    var tmp = [];
	    var N = polygon.length;
	    for(var i=0; i!==N; i++){
	        tmp.push(polygon.pop());
	    }
	    for(var i=0; i!==N; i++){
			polygon[i] = tmp[i];
	    }
	}
	
	/**
	 * Check if a point in the polygon is a reflex point
	 * @method isReflex
	 * @param  {Number}  i
	 * @return {Boolean}
	 */
	function polygonIsReflex(polygon, i){
	    return isRight(polygonAt(polygon, i - 1), polygonAt(polygon, i), polygonAt(polygon, i + 1));
	}
	
	var tmpLine1=[],
	    tmpLine2=[];
	
	/**
	 * Check if two vertices in the polygon can see each other
	 * @method canSee
	 * @param  {Number} a Vertex index 1
	 * @param  {Number} b Vertex index 2
	 * @return {Boolean}
	 */
	function polygonCanSee(polygon, a,b) {
	    var p, dist, l1=tmpLine1, l2=tmpLine2;
	
	    if (isLeftOn(polygonAt(polygon, a + 1), polygonAt(polygon, a), polygonAt(polygon, b)) && isRightOn(polygonAt(polygon, a - 1), polygonAt(polygon, a), polygonAt(polygon, b))) {
	        return false;
	    }
	    dist = sqdist(polygonAt(polygon, a), polygonAt(polygon, b));
	    for (var i = 0; i !== polygon.length; ++i) { // for each edge
	        if ((i + 1) % polygon.length === a || i === a){ // ignore incident edges
	            continue;
	        }
	        if (isLeftOn(polygonAt(polygon, a), polygonAt(polygon, b), polygonAt(polygon, i + 1)) && isRightOn(polygonAt(polygon, a), polygonAt(polygon, b), polygonAt(polygon, i))) { // if diag intersects an edge
	            l1[0] = polygonAt(polygon, a);
	            l1[1] = polygonAt(polygon, b);
	            l2[0] = polygonAt(polygon, i);
	            l2[1] = polygonAt(polygon, i + 1);
	            p = lineInt(l1,l2);
	            if (sqdist(polygonAt(polygon, a), p) < dist) { // if edge is blocking visibility to b
	                return false;
	            }
	        }
	    }
	
	    return true;
	}
	
	/**
	 * Copy the polygon from vertex i to vertex j.
	 * @method copy
	 * @param  {Number} i
	 * @param  {Number} j
	 * @param  {Polygon} [targetPoly]   Optional target polygon to save in.
	 * @return {Polygon}                The resulting copy.
	 */
	function polygonCopy(polygon, i,j,targetPoly){
	    var p = targetPoly || [];
	    polygonClear(p);
	    if (i < j) {
	        // Insert all vertices from i to j
	        for(var k=i; k<=j; k++){
	            p.push(polygon[k]);
	        }
	
	    } else {
	
	        // Insert vertices 0 to j
	        for(var k=0; k<=j; k++){
	            p.push(polygon[k]);
	        }
	
	        // Insert vertices i to end
	        for(var k=i; k<polygon.length; k++){
	            p.push(polygon[k]);
	        }
	    }
	
	    return p;
	}
	
	/**
	 * Decomposes the polygon into convex pieces. Returns a list of edges [[p1,p2],[p2,p3],...] that cuts the polygon.
	 * Note that this algorithm has complexity O(N^4) and will be very slow for polygons with many vertices.
	 * @method getCutEdges
	 * @return {Array}
	 */
	function polygonGetCutEdges(polygon) {
	    var min=[], tmp1=[], tmp2=[], tmpPoly = [];
	    var nDiags = Number.MAX_VALUE;
	
	    for (var i = 0; i < polygon.length; ++i) {
	        if (polygonIsReflex(polygon, i)) {
	            for (var j = 0; j < polygon.length; ++j) {
	                if (polygonCanSee(polygon, i, j)) {
	                    tmp1 = polygonGetCutEdges(polygonCopy(polygon, i, j, tmpPoly));
	                    tmp2 = polygonGetCutEdges(polygonCopy(polygon, j, i, tmpPoly));
	
	                    for(var k=0; k<tmp2.length; k++){
	                        tmp1.push(tmp2[k]);
	                    }
	
	                    if (tmp1.length < nDiags) {
	                        min = tmp1;
	                        nDiags = tmp1.length;
	                        min.push([polygonAt(polygon, i), polygonAt(polygon, j)]);
	                    }
	                }
	            }
	        }
	    }
	
	    return min;
	}
	
	/**
	 * Decomposes the polygon into one or more convex sub-Polygons.
	 * @method decomp
	 * @return {Array} An array or Polygon objects.
	 */
	function polygonDecomp(polygon){
	    var edges = polygonGetCutEdges(polygon);
	    if(edges.length > 0){
	        return polygonSlice(polygon, edges);
	    } else {
	        return [polygon];
	    }
	}
	
	/**
	 * Slices the polygon given one or more cut edges. If given one, this function will return two polygons (false on failure). If many, an array of polygons.
	 * @method slice
	 * @param {Array} cutEdges A list of edges, as returned by .getCutEdges()
	 * @return {Array}
	 */
	function polygonSlice(polygon, cutEdges){
	    if(cutEdges.length === 0){
			return [polygon];
	    }
	    if(cutEdges instanceof Array && cutEdges.length && cutEdges[0] instanceof Array && cutEdges[0].length===2 && cutEdges[0][0] instanceof Array){
	
	        var polys = [polygon];
	
	        for(var i=0; i<cutEdges.length; i++){
	            var cutEdge = cutEdges[i];
	            // Cut all polys
	            for(var j=0; j<polys.length; j++){
	                var poly = polys[j];
	                var result = polygonSlice(poly, cutEdge);
	                if(result){
	                    // Found poly! Cut and quit
	                    polys.splice(j,1);
	                    polys.push(result[0],result[1]);
	                    break;
	                }
	            }
	        }
	
	        return polys;
	    } else {
	
	        // Was given one edge
	        var cutEdge = cutEdges;
	        var i = polygon.indexOf(cutEdge[0]);
	        var j = polygon.indexOf(cutEdge[1]);
	
	        if(i !== -1 && j !== -1){
	            return [polygonCopy(polygon, i,j),
	                    polygonCopy(polygon, j,i)];
	        } else {
	            return false;
	        }
	    }
	}
	
	/**
	 * Checks that the line segments of this polygon do not intersect each other.
	 * @method isSimple
	 * @param  {Array} path An array of vertices e.g. [[0,0],[0,1],...]
	 * @return {Boolean}
	 * @todo Should it check all segments with all others?
	 */
	function polygonIsSimple(polygon){
	    var path = polygon, i;
	    // Check
	    for(i=0; i<path.length-1; i++){
	        for(var j=0; j<i-1; j++){
	            if(lineSegmentsIntersect(path[i], path[i+1], path[j], path[j+1] )){
	                return false;
	            }
	        }
	    }
	
	    // Check the segment between the last and the first point to all others
	    for(i=1; i<path.length-2; i++){
	        if(lineSegmentsIntersect(path[0], path[path.length-1], path[i], path[i+1] )){
	            return false;
	        }
	    }
	
	    return true;
	}
	
	function getIntersectionPoint(p1, p2, q1, q2, delta){
		delta = delta || 0;
		var a1 = p2[1] - p1[1];
		var b1 = p1[0] - p2[0];
		var c1 = (a1 * p1[0]) + (b1 * p1[1]);
		var a2 = q2[1] - q1[1];
		var b2 = q1[0] - q2[0];
		var c2 = (a2 * q1[0]) + (b2 * q1[1]);
		var det = (a1 * b2) - (a2 * b1);
	
		if(!scalar_eq(det,0,delta)){
			return [((b2 * c1) - (b1 * c2)) / det, ((a1 * c2) - (a2 * c1)) / det];
		} else {
			return [0,0];
	    }
	}
	
	/**
	 * Quickly decompose the Polygon into convex sub-polygons.
	 * @method quickDecomp
	 * @param  {Array} result
	 * @param  {Array} [reflexVertices]
	 * @param  {Array} [steinerPoints]
	 * @param  {Number} [delta]
	 * @param  {Number} [maxlevel]
	 * @param  {Number} [level]
	 * @return {Array}
	 */
	function polygonQuickDecomp(polygon, result,reflexVertices,steinerPoints,delta,maxlevel,level){
	    maxlevel = maxlevel || 100;
	    level = level || 0;
	    delta = delta || 25;
	    result = typeof(result)!=="undefined" ? result : [];
	    reflexVertices = reflexVertices || [];
	    steinerPoints = steinerPoints || [];
	
	    var upperInt=[0,0], lowerInt=[0,0], p=[0,0]; // Points
	    var upperDist=0, lowerDist=0, d=0, closestDist=0; // scalars
	    var upperIndex=0, lowerIndex=0, closestIndex=0; // Integers
	    var lowerPoly=[], upperPoly=[]; // polygons
	    var poly = polygon,
	        v = polygon;
	
	    if(v.length < 3){
			return result;
	    }
	
	    level++;
	    if(level > maxlevel){
	        console.warn("quickDecomp: max level ("+maxlevel+") reached.");
	        return result;
	    }
	
	    for (var i = 0; i < polygon.length; ++i) {
	        if (polygonIsReflex(poly, i)) {
	            reflexVertices.push(poly[i]);
	            upperDist = lowerDist = Number.MAX_VALUE;
	
	
	            for (var j = 0; j < polygon.length; ++j) {
	                if (isLeft(polygonAt(poly, i - 1), polygonAt(poly, i), polygonAt(poly, j)) && isRightOn(polygonAt(poly, i - 1), polygonAt(poly, i), polygonAt(poly, j - 1))) { // if line intersects with an edge
	                    p = getIntersectionPoint(polygonAt(poly, i - 1), polygonAt(poly, i), polygonAt(poly, j), polygonAt(poly, j - 1)); // find the point of intersection
	                    if (isRight(polygonAt(poly, i + 1), polygonAt(poly, i), p)) { // make sure it's inside the poly
	                        d = sqdist(poly[i], p);
	                        if (d < lowerDist) { // keep only the closest intersection
	                            lowerDist = d;
	                            lowerInt = p;
	                            lowerIndex = j;
	                        }
	                    }
	                }
	                if (isLeft(polygonAt(poly, i + 1), polygonAt(poly, i), polygonAt(poly, j + 1)) && isRightOn(polygonAt(poly, i + 1), polygonAt(poly, i), polygonAt(poly, j))) {
	                    p = getIntersectionPoint(polygonAt(poly, i + 1), polygonAt(poly, i), polygonAt(poly, j), polygonAt(poly, j + 1));
	                    if (isLeft(polygonAt(poly, i - 1), polygonAt(poly, i), p)) {
	                        d = sqdist(poly[i], p);
	                        if (d < upperDist) {
	                            upperDist = d;
	                            upperInt = p;
	                            upperIndex = j;
	                        }
	                    }
	                }
	            }
	
	            // if there are no vertices to connect to, choose a point in the middle
	            if (lowerIndex === (upperIndex + 1) % polygon.length) {
	                //console.log("Case 1: Vertex("+i+"), lowerIndex("+lowerIndex+"), upperIndex("+upperIndex+"), poly.size("+polygon.length+")");
	                p[0] = (lowerInt[0] + upperInt[0]) / 2;
	                p[1] = (lowerInt[1] + upperInt[1]) / 2;
	                steinerPoints.push(p);
	
	                if (i < upperIndex) {
	                    //lowerPoly.insert(lowerPoly.end(), poly.begin() + i, poly.begin() + upperIndex + 1);
	                    polygonAppend(lowerPoly, poly, i, upperIndex+1);
	                    lowerPoly.push(p);
	                    upperPoly.push(p);
	                    if (lowerIndex !== 0){
	                        //upperPoly.insert(upperPoly.end(), poly.begin() + lowerIndex, poly.end());
	                        polygonAppend(upperPoly, poly,lowerIndex,poly.length);
	                    }
	                    //upperPoly.insert(upperPoly.end(), poly.begin(), poly.begin() + i + 1);
	                    polygonAppend(upperPoly, poly,0,i+1);
	                } else {
	                    if (i !== 0){
	                        //lowerPoly.insert(lowerPoly.end(), poly.begin() + i, poly.end());
	                        polygonAppend(lowerPoly, poly,i,poly.length);
	                    }
	                    //lowerPoly.insert(lowerPoly.end(), poly.begin(), poly.begin() + upperIndex + 1);
	                    polygonAppend(lowerPoly, poly,0,upperIndex+1);
	                    lowerPoly.push(p);
	                    upperPoly.push(p);
	                    //upperPoly.insert(upperPoly.end(), poly.begin() + lowerIndex, poly.begin() + i + 1);
	                    polygonAppend(upperPoly, poly,lowerIndex,i+1);
	                }
	            } else {
	                // connect to the closest point within the triangle
	                //console.log("Case 2: Vertex("+i+"), closestIndex("+closestIndex+"), poly.size("+polygon.length+")\n");
	
	                if (lowerIndex > upperIndex) {
	                    upperIndex += polygon.length;
	                }
	                closestDist = Number.MAX_VALUE;
	
	                if(upperIndex < lowerIndex){
	                    return result;
	                }
	
	                for (var j = lowerIndex; j <= upperIndex; ++j) {
	                    if (isLeftOn(polygonAt(poly, i - 1), polygonAt(poly, i), polygonAt(poly, j)) && isRightOn(polygonAt(poly, i + 1), polygonAt(poly, i), polygonAt(poly, j))) {
	                        d = sqdist(polygonAt(poly, i), polygonAt(poly, j));
	                        if (d < closestDist) {
	                            closestDist = d;
	                            closestIndex = j % polygon.length;
	                        }
	                    }
	                }
	
	                if (i < closestIndex) {
	                    polygonAppend(lowerPoly, poly,i,closestIndex+1);
	                    if (closestIndex !== 0){
	                        polygonAppend(upperPoly, poly,closestIndex,v.length);
	                    }
	                    polygonAppend(upperPoly, poly,0,i+1);
	                } else {
	                    if (i !== 0){
	                        polygonAppend(lowerPoly, poly,i,v.length);
	                    }
	                    polygonAppend(lowerPoly, poly,0,closestIndex+1);
	                    polygonAppend(upperPoly, poly,closestIndex,i+1);
	                }
	            }
	
	            // solve smallest poly first
	            if (lowerPoly.length < upperPoly.length) {
	                polygonQuickDecomp(lowerPoly,result,reflexVertices,steinerPoints,delta,maxlevel,level);
	                polygonQuickDecomp(upperPoly,result,reflexVertices,steinerPoints,delta,maxlevel,level);
	            } else {
	                polygonQuickDecomp(upperPoly,result,reflexVertices,steinerPoints,delta,maxlevel,level);
	                polygonQuickDecomp(lowerPoly,result,reflexVertices,steinerPoints,delta,maxlevel,level);
	            }
	
	            return result;
	        }
	    }
	    result.push(polygon);
	
	    return result;
	}
	
	/**
	 * Remove collinear points in the polygon.
	 * @method removeCollinearPoints
	 * @param  {Number} [precision] The threshold angle to use when determining whether two edges are collinear. Use zero for finest precision.
	 * @return {Number}           The number of points removed
	 */
	function polygonRemoveCollinearPoints(polygon, precision){
	    var num = 0;
	    for(var i=polygon.length-1; polygon.length>3 && i>=0; --i){
	        if(collinear(polygonAt(polygon, i-1),polygonAt(polygon, i),polygonAt(polygon, i+1),precision)){
	            // Remove the middle point
	            polygon.splice(i%polygon.length,1);
	            num++;
	        }
	    }
	    return num;
	}
	
	/**
	 * Check if two scalars are equal
	 * @static
	 * @method eq
	 * @param  {Number} a
	 * @param  {Number} b
	 * @param  {Number} [precision]
	 * @return {Boolean}
	 */
	function scalar_eq(a,b,precision){
	    precision = precision || 0;
	    return Math.abs(a-b) < precision;
	}


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2018 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser3-plugin-template/blob/master/LICENSE|MIT License}
	*/
	
	var Class = __webpack_require__(1);
	
	//  A Scene Level Plugin is installed into every Scene and belongs to that Scene.
	//  It can listen for Scene events and respond to them.
	//  It can map itself to a Scene property, or into the Scene Systems, or both.
	//  
	//  A Global Plugin is installed just once into the Game owned Plugin Manager.
	//  It can listen for Game events and respond to them.
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class BasePlugin
	 * @memberOf Phaser.Plugins
	 * @constructor
	 * @since 3.8.0
	 *
	 * @param {Phaser.Game} game - [description]
	 */
	var BasePlugin = new Class({
	
	    initialize:
	
	    function BasePlugin (pluginManager)
	    {
	        /**
	         * A handy reference to the Plugin Manager that is responsible for this plugin.
	         * Can be used as a route to gain access to game systems and  events.
	         * 
	         * @name Phaser.Plugins.BasePlugin#pluginManager
	         * @type {Phaser.Plugins.BasePluginManager}
	         * @protected
	         * @since 3.8.0
	         */
	        this.pluginManager = pluginManager;
	
	        /**
	         * A reference to the Game instance this plugin is running under.
	         *
	         * @name Phaser.Plugins.BasePlugin#game
	         * @type {Phaser.Game}
	         * @protected
	         * @since 3.8.0
	         */
	        this.game = pluginManager.game;
	
	        /**
	         * A reference to the Scene that has installed this plugin.
	         * Only set if it's a Scene Plugin, otherwise `null`.
	         * This property is only set when the plugin is instantiated and added to the Scene, not before.
	         * You cannot use it during the `init` method, but you can during the `boot` method.
	         *
	         * @name Phaser.Plugins.BasePlugin#scene
	         * @type {?Phaser.Scene}
	         * @protected
	         * @since 3.8.0
	         */
	        this.scene;
	
	        /**
	         * A reference to the Scene Systems of the Scene that has installed this plugin.
	         * Only set if it's a Scene Plugin, otherwise `null`.
	         * This property is only set when the plugin is instantiated and added to the Scene, not before.
	         * You cannot use it during the `init` method, but you can during the `boot` method.
	         *
	         * @name Phaser.Plugins.BasePlugin#systems
	         * @type {?Phaser.Scene.Systems}
	         * @protected
	         * @since 3.8.0
	         */
	        this.systems;
	    },
	
	    /**
	     * Called by the PluginManager when this plugin is first instantiated.
	     * It will never be called again on this instance.
	     * In here you can set-up whatever you need for this plugin to run.
	     * If a plugin is set to automatically start then `BasePlugin.start` will be called immediately after this.
	     *
	     * @method Phaser.Plugins.BasePlugin#init
	     * @since 3.8.0
	     */
	    init: function ()
	    {
	    },
	
	    /**
	     * Called by the PluginManager when this plugin is started.
	     * If a plugin is stopped, and then started again, this will get called again.
	     * Typically called immediately after `BasePlugin.init`.
	     *
	     * @method Phaser.Plugins.BasePlugin#start
	     * @since 3.8.0
	     */
	    start: function ()
	    {
	        //  Here are the game-level events you can listen to.
	        //  At the very least you should offer a destroy handler for when the game closes down.
	
	        // var eventEmitter = this.game.events;
	
	        // eventEmitter.once('destroy', this.gameDestroy, this);
	        // eventEmitter.on('pause', this.gamePause, this);
	        // eventEmitter.on('resume', this.gameResume, this);
	        // eventEmitter.on('resize', this.gameResize, this);
	        // eventEmitter.on('prestep', this.gamePreStep, this);
	        // eventEmitter.on('step', this.gameStep, this);
	        // eventEmitter.on('poststep', this.gamePostStep, this);
	        // eventEmitter.on('prerender', this.gamePreRender, this);
	        // eventEmitter.on('postrender', this.gamePostRender, this);
	    },
	
	    /**
	     * Called by the PluginManager when this plugin is stopped.
	     * The game code has requested that your plugin stop doing whatever it does.
	     * It is now considered as 'inactive' by the PluginManager.
	     * Handle that process here (i.e. stop listening for events, etc)
	     * If the plugin is started again then `BasePlugin.start` will be called again.
	     *
	     * @method Phaser.Plugins.BasePlugin#stop
	     * @since 3.8.0
	     */
	    stop: function ()
	    {
	    },
	
	    /**
	     * If this is a Scene Plugin (i.e. installed into a Scene) then this method is called when the Scene boots.
	     * By this point the plugin properties `scene` and `systems` will have already been set.
	     * In here you can listen for Scene events and set-up whatever you need for this plugin to run.
	     *
	     * @method Phaser.Plugins.BasePlugin#boot
	     * @since 3.8.0
	     */
	    boot: function ()
	    {
	        //  Here are the Scene events you can listen to.
	        //  At the very least you should offer a destroy handler for when the Scene closes down.
	
	        // var eventEmitter = this.systems.events;
	
	        // eventEmitter.once('destroy', this.sceneDestroy, this);
	        // eventEmitter.on('start', this.sceneStart, this);
	        // eventEmitter.on('preupdate', this.scenePreUpdate, this);
	        // eventEmitter.on('update', this.sceneUpdate, this);
	        // eventEmitter.on('postupdate', this.scenePostUpdate, this);
	        // eventEmitter.on('pause', this.scenePause, this);
	        // eventEmitter.on('resume', this.sceneResume, this);
	        // eventEmitter.on('sleep', this.sceneSleep, this);
	        // eventEmitter.on('wake', this.sceneWake, this);
	        // eventEmitter.on('shutdown', this.sceneShutdown, this);
	        // eventEmitter.on('destroy', this.sceneDestroy, this);
	    },
	
	    /**
	     * Game instance has been destroyed.
	     * You must release everything in here, all references, all objects, free it all up.
	     *
	     * @method Phaser.Plugins.BasePlugin#destroy
	     * @since 3.8.0
	     */
	    destroy: function ()
	    {
	        this.pluginManager = null;
	        this.game = null;
	        this.scene = null;
	        this.systems = null;
	    }
	
	});
	
	module.exports = BasePlugin;


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var EventEmitter = __webpack_require__(22);
	var FileTypesManager = __webpack_require__(15);
	var GameObjectCreator = __webpack_require__(26);
	var GameObjectFactory = __webpack_require__(18);
	var GetFastValue = __webpack_require__(3);
	var PluginCache = __webpack_require__(29);
	var Remove = __webpack_require__(660);
	
	/**
	 * @typedef {object} GlobalPlugin
	 *
	 * @property {string} key - The unique name of this plugin within the plugin cache.
	 * @property {function} plugin - An instance of the plugin.
	 * @property {boolean} [active] - Is the plugin active or not?
	 */
	
	/**
	 * @classdesc
	 * The PluginManager is responsible for installing and adding plugins to Phaser.
	 *
	 * It is a global system and therefore belongs to the Game instance, not a specific Scene.
	 *
	 * It works in conjunction with the PluginCache. Core internal plugins automatically register themselves 
	 * with the Cache, but it's the Plugin Manager that is responsible for injecting them into the Scenes.
	 *
	 * There are two types of plugin:
	 *
	 * 1) A Global Plugin
	 * 2) A Scene Plugin
	 *
	 * A Global Plugin is a plugin that lives within the Plugin Manager rather than a Scene. You can get
	 * access to it by calling `PluginManager.get` and providing a key. Any Scene that requests a plugin in
	 * this way will all get access to the same plugin instance, allowing you to use a single plugin across
	 * multiple Scenes.
	 *
	 * A Scene Plugin is a plugin dedicated to running within a Scene. These are different to Global Plugins
	 * in that their instances do not live within the Plugin Manager, but within the Scene Systems class instead.
	 * And that every Scene created is given its own unique instance of a Scene Plugin. Examples of core Scene
	 * Plugins include the Input Plugin, the Tween Plugin and the physics Plugins.
	 *
	 * You can add a plugin to Phaser in three different ways:
	 *
	 * 1) Preload it
	 * 2) Include it in your source code and install it via the Game Config
	 * 3) Include it in your source code and install it within a Scene
	 *
	 * For examples of all of these approaches please see the Phaser 3 Examples Repo `plugins` folder.
	 *
	 * For information on creating your own plugin please see the Phaser 3 Plugin Template.
	 *
	 * @class PluginManager
	 * @memberOf Phaser.Plugins
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Game} game - The game instance that owns this Plugin Manager.
	 */
	var PluginManager = new Class({
	
	    Extends: EventEmitter,
	
	    initialize:
	
	    function PluginManager (game)
	    {
	        EventEmitter.call(this);
	
	        /**
	         * The game instance that owns this Plugin Manager.
	         *
	         * @name Phaser.Plugins.PluginManager#game
	         * @type {Phaser.Game}
	         * @since 3.0.0
	         */
	        this.game = game;
	
	        /**
	         * The global plugins currently running and managed by this Plugin Manager.
	         * A plugin must have been started at least once in order to appear in this list.
	         *
	         * @name Phaser.Plugins.PluginManager#plugins
	         * @type {GlobalPlugin[]}
	         * @since 3.8.0
	         */
	        this.plugins = [];
	
	        /**
	         * A list of plugin keys that should be installed into Scenes as well as the Core Plugins.
	         *
	         * @name Phaser.Plugins.PluginManager#scenePlugins
	         * @type {string[]}
	         * @since 3.8.0
	         */
	        this.scenePlugins = [];
	
	        /**
	         * A temporary list of plugins to install when the game has booted.
	         *
	         * @name Phaser.Plugins.PluginManager#_pendingGlobal
	         * @private
	         * @type {array}
	         * @since 3.8.0
	         */
	        this._pendingGlobal = [];
	
	        /**
	         * A temporary list of scene plugins to install when the game has booted.
	         *
	         * @name Phaser.Plugins.PluginManager#_pendingScene
	         * @private
	         * @type {array}
	         * @since 3.8.0
	         */
	        this._pendingScene = [];
	
	        if (game.isBooted)
	        {
	            this.boot();
	        }
	        else
	        {
	            game.events.once('boot', this.boot, this);
	        }
	    },
	
	    /**
	     * Run once the game has booted and installs all of the plugins configured in the Game Config.
	     *
	     * @method Phaser.Plugins.PluginManager#boot
	     * @protected
	     * @since 3.0.0
	     */
	    boot: function ()
	    {
	        var i;
	        var entry;
	        var key;
	        var plugin;
	        var start;
	        var mapping;
	        var config = this.game.config;
	
	        //  Any plugins to install?
	        var list = config.installGlobalPlugins;
	
	        //  Any plugins added outside of the game config, but before the game booted?
	        list = list.concat(this._pendingGlobal);
	
	        for (i = 0; i < list.length; i++)
	        {
	            entry = list[i];
	
	            // { key: 'TestPlugin', plugin: TestPlugin, start: true }
	
	            key = GetFastValue(entry, 'key', null);
	            plugin = GetFastValue(entry, 'plugin', null);
	            start = GetFastValue(entry, 'start', false);
	
	            if (key && plugin)
	            {
	                this.install(key, plugin, start);
	            }
	        }
	
	        //  Any scene plugins to install?
	        list = config.installScenePlugins;
	
	        //  Any plugins added outside of the game config, but before the game booted?
	        list = list.concat(this._pendingScene);
	
	        for (i = 0; i < list.length; i++)
	        {
	            entry = list[i];
	
	            // { key: 'moveSpritePlugin', plugin: MoveSpritePlugin, , mapping: 'move' }
	
	            key = GetFastValue(entry, 'key', null);
	            plugin = GetFastValue(entry, 'plugin', null);
	            mapping = GetFastValue(entry, 'mapping', null);
	
	            if (key && plugin)
	            {
	                this.installScenePlugin(key, plugin, mapping);
	            }
	        }
	
	        this._pendingGlobal = [];
	        this._pendingScene = [];
	
	        this.game.events.once('destroy', this.destroy, this);
	    },
	
	    /**
	     * Called by the Scene Systems class. Tells the plugin manager to install all Scene plugins into it.
	     *
	     * @method Phaser.Plugins.PluginManager#addToScene
	     * @protected
	     * @since 3.8.0
	     *
	     * @param {Phaser.Scenes.Systems} sys - The Scene Systems class to install all the plugins in to.
	     * @param {array} globalPlugins - An array of global plugins to install.
	     * @param {array} scenePlugins - An array of scene plugins to install.
	     */
	    addToScene: function (sys, globalPlugins, scenePlugins)
	    {
	        var i;
	        var pluginKey;
	        var game = this.game;
	        var scene = sys.scene;
	        var map = sys.settings.map;
	        var isBooted = sys.settings.isBooted;
	
	        //  Reference the GlobalPlugins from Game into Scene.Systems
	        for (i = 0; i < globalPlugins.length; i++)
	        {
	            pluginKey = globalPlugins[i];
	           
	            if (game[pluginKey])
	            {
	                sys[pluginKey] = game[pluginKey];
	
	                //  Scene level injection
	                if (map.hasOwnProperty(pluginKey))
	                {
	                    scene[map[pluginKey]] = sys[pluginKey];
	                }
	            }
	        }
	
	        for (var s = 0; s < scenePlugins.length; s++)
	        {
	            var pluginList = scenePlugins[s];
	
	            for (i = 0; i < pluginList.length; i++)
	            {
	                pluginKey = pluginList[i];
	
	                if (!PluginCache.hasCore(pluginKey))
	                {
	                    continue;
	                }
	
	                var source = PluginCache.getCore(pluginKey);
	
	                var plugin = new source.plugin(scene, this);
	                
	                sys[source.mapping] = plugin;
	
	                //  Scene level injection
	                if (source.custom)
	                {
	                    scene[source.mapping] = plugin;
	                }
	                else if (map.hasOwnProperty(source.mapping))
	                {
	                    scene[map[source.mapping]] = plugin;
	                }
	
	                //  Scene is already booted, usually because this method is being called at run-time, so boot the plugin
	                if (isBooted)
	                {
	                    plugin.boot();
	                }
	            }
	        }
	    },
	
	    /**
	     * Called by the Scene Systems class. Returns a list of plugins to be installed.
	     *
	     * @method Phaser.Plugins.PluginManager#getDefaultScenePlugins
	     * @protected
	     * @since 3.8.0
	     *
	     * @return {string[]} A list keys of all the Scene Plugins to install.
	     */
	    getDefaultScenePlugins: function ()
	    {
	        var list = this.game.config.defaultPlugins;
	
	        //  Merge in custom Scene plugins
	        list = list.concat(this.scenePlugins);
	
	        return list;
	    },
	
	    /**
	     * Installs a new Scene Plugin into the Plugin Manager and optionally adds it
	     * to the given Scene as well. A Scene Plugin added to the manager in this way
	     * will be automatically installed into all new Scenes using the key and mapping given.
	     *
	     * The `key` property is what the plugin is injected into Scene.Systems as.
	     * The `mapping` property is optional, and if specified is what the plugin is installed into
	     * the Scene as. For example:
	     *
	     * ```javascript
	     * this.plugins.installScenePlugin('powerupsPlugin', pluginCode, 'powerups');
	     * 
	     * // and from within the scene:
	     * this.sys.powerupsPlugin; // key value
	     * this.powerups; // mapping value
	     * ```
	     *
	     * This method is called automatically by Phaser if you install your plugins using either the
	     * Game Configuration object, or by preloading them via the Loader.
	     *
	     * @method Phaser.Plugins.PluginManager#installScenePlugin
	     * @since 3.8.0
	     *
	     * @param {string} key - The property key that will be used to add this plugin to Scene.Systems.
	     * @param {function} plugin - The plugin code. This should be the non-instantiated version.
	     * @param {string} [mapping] - If this plugin is injected into the Phaser.Scene class, this is the property key to use.
	     * @param {Phaser.Scene} [addToScene] - Optionally automatically add this plugin to the given Scene.
	     */
	    installScenePlugin: function (key, plugin, mapping, addToScene)
	    {
	        if (typeof plugin !== 'function')
	        {
	            console.warn('Invalid Scene Plugin: ' + key);
	            return;
	        }
	
	        if (PluginCache.hasCore(key))
	        {
	            console.warn('Scene Plugin key in use: ' + key);
	            return;
	        }
	
	        PluginCache.register(key, plugin, mapping, true);
	
	        this.scenePlugins.push(key);
	
	        if (addToScene)
	        {
	            var instance = new plugin(addToScene, this);
	
	            addToScene.sys[key] = instance;
	
	            if (mapping && mapping !== '')
	            {
	                addToScene[mapping] = instance;
	            }
	
	            instance.boot();
	        }
	    },
	
	    /**
	     * Installs a new Global Plugin into the Plugin Manager and optionally starts it running.
	     * A global plugin belongs to the Plugin Manager, rather than a specific Scene, and can be accessed
	     * and used by all Scenes in your game.
	     *
	     * The `key` property is what you use to access this plugin from the Plugin Manager.
	     *
	     * ```javascript
	     * this.plugins.install('powerupsPlugin', pluginCode);
	     * 
	     * // and from within the scene:
	     * this.plugins.get('powerupsPlugin');
	     * ```
	     *
	     * This method is called automatically by Phaser if you install your plugins using either the
	     * Game Configuration object, or by preloading them via the Loader.
	     *
	     * The same plugin can be installed multiple times into the Plugin Manager by simply giving each
	     * instance its own unique key.
	     *
	     * @method Phaser.Plugins.PluginManager#install
	     * @since 3.8.0
	     * 
	     * @param {string} key - The unique handle given to this plugin within the Plugin Manager.
	     * @param {function} plugin - The plugin code. This should be the non-instantiated version.
	     * @param {boolean} [start=false] - Automatically start the plugin running?
	     */
	    install: function (key, plugin, start)
	    {
	        if (start === undefined) { start = false; }
	
	        if (typeof plugin !== 'function')
	        {
	            console.warn('Invalid Plugin: ' + key);
	            return;
	        }
	
	        if (PluginCache.hasCustom(key))
	        {
	            console.warn('Plugin key in use: ' + key);
	            return;
	        }
	
	        if (!this.game.isBooted)
	        {
	            this._pendingGlobal.push({ key: key, plugin: plugin, start: start });
	        }
	        else
	        {
	            //  Add it to the plugin store
	            PluginCache.registerCustom(key, plugin);
	
	            // gamePlugins[key] = plugin;
	
	            if (start)
	            {
	                return this.start(key);
	            }
	        }
	    },
	
	    /**
	     * Gets an index of a global plugin based on the given key.
	     *
	     * @method Phaser.Plugins.PluginManager#getIndex
	     * @protected
	     * @since 3.8.0
	     *
	     * @param {string} key - The unique plugin key.
	     *
	     * @return {integer} The index of the plugin within the plugins array.
	     */
	    getIndex: function (key)
	    {
	        var list = this.plugins;
	
	        for (var i = 0; i < list.length; i++)
	        {
	            var entry = list[i];
	
	            if (entry.key === key)
	            {
	                return i;
	            }
	        }
	
	        return -1;
	    },
	
	    /**
	     * Gets a global plugin based on the given key.
	     *
	     * @method Phaser.Plugins.PluginManager#getEntry
	     * @protected
	     * @since 3.8.0
	     *
	     * @param {string} key - The unique plugin key.
	     *
	     * @return {GlobalPlugin} The plugin entry.
	     */
	    getEntry: function (key)
	    {
	        var idx = this.getIndex(key);
	
	        if (idx !== -1)
	        {
	            return this.plugins[idx];
	        }
	    },
	
	    /**
	     * Checks if the given global plugin, based on its key, is active or not.
	     *
	     * @method Phaser.Plugins.PluginManager#isActive
	     * @since 3.8.0
	     *
	     * @param {string} key - The unique plugin key.
	     *
	     * @return {boolean} `true` if the plugin is active, otherwise `false`.
	     */
	    isActive: function (key)
	    {
	        var entry = this.getEntry(key);
	
	        return (entry && entry.active);
	    },
	
	    /**
	     * Starts a global plugin running.
	     *
	     * If the plugin was previously active then calling `start` will reset it to an active state and then
	     * call its `start` method.
	     *
	     * If the plugin has never been run before a new instance of it will be created within the Plugin Manager,
	     * its active state set and then both of its `init` and `start` methods called, in that order.
	     *
	     * If the plugin is already running under the given key then nothing happens.
	     *
	     * @method Phaser.Plugins.PluginManager#start
	     * @since 3.8.0
	     *
	     * @param {string} key - The key of the plugin to start.
	     * @param {string} [runAs] - Run the plugin under a new key. This allows you to run one plugin multiple times.
	     *
	     * @return {?Phaser.Plugins.BasePlugin} The plugin that was started, or `null` if invalid key given or plugin is already stopped.
	     */
	    start: function (key, runAs)
	    {
	        if (runAs === undefined) { runAs = key; }
	
	        var entry = this.getEntry(runAs);
	
	        //  Plugin already running under this key?
	        if (entry && !entry.active)
	        {
	            //  It exists, we just need to start it up again
	            entry.active = true;
	            entry.plugin.start();
	        }
	        else if (!entry)
	        {
	            var plugin = this.getClass(key);
	
	            if (plugin)
	            {
	                var instance = new plugin(this);
	
	                entry = {
	                    key: runAs,
	                    plugin: instance,
	                    active: true
	                };
	
	                this.plugins.push(entry);
	
	                instance.init();
	                instance.start();
	            }
	        }
	
	        return (entry) ? entry.plugin : null;
	    },
	
	    /**
	     * Stops a global plugin from running.
	     *
	     * If the plugin is active then its active state will be set to false and the plugins `stop` method
	     * will be called.
	     *
	     * If the plugin is not already running, nothing will happen.
	     *
	     * @method Phaser.Plugins.PluginManager#stop
	     * @since 3.8.0
	     *
	     * @param {string} key - The key of the plugin to stop.
	     *
	     * @return {Phaser.Plugins.PluginManager} The Plugin Manager.
	     */
	    stop: function (key)
	    {
	        var entry = this.getEntry(key);
	
	        if (entry && entry.active)
	        {
	            entry.active = false;
	            entry.plugin.stop();
	        }
	
	        return this;
	    },
	
	    /**
	     * Gets a global plugin from the Plugin Manager based on the given key and returns it.
	     *
	     * If it cannot find an active plugin based on the key, but there is one in the Plugin Cache with the same key,
	     * then it will create a new instance of the cached plugin and return that.
	     *
	     * @method Phaser.Plugins.PluginManager#get
	     * @since 3.8.0
	     *
	     * @param {string} key - The key of the plugin to get.
	     * @param {boolean} [autoStart=true] - Automatically start a new instance of the plugin if found in the cache, but not actively running.
	     *
	     * @return {?(Phaser.Plugins.BasePlugin|function)} The plugin, or `null` if no plugin was found matching the key.
	     */
	    get: function (key, autoStart)
	    {
	        if (autoStart === undefined) { autoStart = true; }
	
	        var entry = this.getEntry(key);
	
	        if (entry)
	        {
	            return entry.plugin;
	        }
	        else
	        {
	            var plugin = this.getClass(key);
	
	            if (plugin && autoStart)
	            {
	                var instance = new plugin(this);
	
	                entry = {
	                    key: key,
	                    plugin: instance,
	                    active: true
	                };
	
	                this.plugins.push(entry);
	
	                instance.init();
	                instance.start();
	
	                return instance;
	            }
	            else if (plugin)
	            {
	                return plugin;
	            }
	        }
	
	        return null;
	    },
	
	    /**
	     * Returns the plugin class from the cache.
	     * Used internally by the Plugin Manager.
	     *
	     * @method Phaser.Plugins.PluginManager#getClass
	     * @since 3.8.0
	     *
	     * @param {string} key - The key of the plugin to get.
	     *
	     * @return {Phaser.Plugins.BasePlugin} A Plugin object
	     */
	    getClass: function (key)
	    {
	        return PluginCache.getCustomClass(key);
	    },
	
	    /**
	     * Removes a global plugin from the Plugin Manager and Plugin Cache.
	     *
	     * It is up to you to remove all references to this plugin that you may hold within your game code.
	     *
	     * @method Phaser.Plugins.PluginManager#removeGlobalPlugin
	     * @since 3.8.0
	     *
	     * @param {string} key - The key of the plugin to remove.
	     */
	    removeGlobalPlugin: function (key)
	    {
	        var entry = this.getEntry(key);
	
	        if (entry)
	        {
	            Remove(this.plugins, entry);
	        }
	
	        PluginCache.removeCustom(key);
	    },
	
	    /**
	     * Removes a scene plugin from the Plugin Manager and Plugin Cache.
	     *
	     * This will not remove the plugin from any active Scenes that are already using it.
	     *
	     * It is up to you to remove all references to this plugin that you may hold within your game code.
	     *
	     * @method Phaser.Plugins.PluginManager#removeScenePlugin
	     * @since 3.8.0
	     *
	     * @param {string} key - The key of the plugin to remove.
	     */
	    removeScenePlugin: function (key)
	    {
	        Remove(this.scenePlugins, key);
	
	        PluginCache.remove(key);
	    },
	
	    /**
	     * Registers a new type of Game Object with the global Game Object Factory and / or Creator.
	     * This is usually called from within your Plugin code and is a helpful short-cut for creating
	     * new Game Objects.
	     *
	     * The key is the property that will be injected into the factories and used to create the
	     * Game Object. For example:
	     *
	     * ```javascript
	     * this.plugins.registerGameObject('clown', clownFactoryCallback, clownCreatorCallback);
	     * // later in your game code:
	     * this.add.clown();
	     * this.make.clown();
	     * ```
	     * 
	     * The callbacks are what are called when the factories try to create a Game Object
	     * matching the given key. It's important to understand that the callbacks are invoked within
	     * the context of the GameObjectFactory. In this context there are several properties available
	     * to use:
	     * 
	     * this.scene - A reference to the Scene that owns the GameObjectFactory.
	     * this.displayList - A reference to the Display List the Scene owns.
	     * this.updateList - A reference to the Update List the Scene owns.
	     * 
	     * See the GameObjectFactory and GameObjectCreator classes for more details.
	     * Any public property or method listed is available from your callbacks under `this`.
	     *
	     * @method Phaser.Plugins.PluginManager#registerGameObject
	     * @since 3.8.0
	     *
	     * @param {string} key - The key of the Game Object that the given callbacks will create, i.e. `image`, `sprite`.
	     * @param {function} [factoryCallback] - The callback to invoke when the Game Object Factory is called.
	     * @param {function} [creatorCallback] - The callback to invoke when the Game Object Creator is called.
	     */
	    registerGameObject: function (key, factoryCallback, creatorCallback)
	    {
	        if (factoryCallback)
	        {
	            GameObjectFactory.register(key, factoryCallback);
	        }
	
	        if (creatorCallback)
	        {
	            GameObjectCreator.register(key, creatorCallback);
	        }
	
	        return this;
	    },
	
	    /**
	     * Registers a new file type with the global File Types Manager, making it available to all Loader
	     * Plugins created after this.
	     * 
	     * This is usually called from within your Plugin code and is a helpful short-cut for creating
	     * new loader file types.
	     *
	     * The key is the property that will be injected into the Loader Plugin and used to load the
	     * files. For example:
	     *
	     * ```javascript
	     * this.plugins.registerFileType('wad', doomWadLoaderCallback);
	     * // later in your preload code:
	     * this.load.wad();
	     * ```
	     * 
	     * The callback is what is called when the loader tries to load a file  matching the given key.
	     * It's important to understand that the callback is invoked within
	     * the context of the LoaderPlugin. In this context there are several properties / methods available
	     * to use:
	     * 
	     * this.addFile - A method to add the new file to the load queue.
	     * this.scene - The Scene that owns the Loader Plugin instance.
	     *
	     * See the LoaderPlugin class for more details. Any public property or method listed is available from
	     * your callback under `this`.
	     *
	     * @method Phaser.Plugins.PluginManager#registerFileType
	     * @since 3.8.0
	     *
	     * @param {string} key - The key of the Game Object that the given callbacks will create, i.e. `image`, `sprite`.
	     * @param {function} callback - The callback to invoke when the Game Object Factory is called.
	     */
	    registerFileType: function (key, callback)
	    {
	        FileTypesManager.register(key, callback);
	    },
	
	    /**
	     * Destroys this Plugin Manager and all associated plugins.
	     * It will iterate all plugins found and call their `destroy` methods.
	     * Note that the PluginCache is NOT cleared by this as it doesn't hold any plugin instances.
	     *
	     * @method Phaser.Plugins.PluginManager#destroy
	     * @since 3.8.0
	     */
	    destroy: function ()
	    {
	        for (var i = 0; i < this.plugins.length; i++)
	        {
	            this.plugins[i].destroy();
	        }
	
	        this.game = null;
	        this.plugins = [];
	        this.scenePlugins = [];
	    }
	
	});
	
	/*
	 * "Sometimes, the elegant implementation is just a function.
	 * Not a method. Not a class. Not a framework. Just a function."
	 *  -- John Carmack
	 */
	
	module.exports = PluginManager;


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Felipe Alfonso <@bitnenfer>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BlitImage = __webpack_require__(613);
	var CanvasSnapshot = __webpack_require__(616);
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(49);
	var DrawImage = __webpack_require__(614);
	var GetBlendModes = __webpack_require__(615);
	var ScaleModes = __webpack_require__(167);
	var Smoothing = __webpack_require__(268);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class CanvasRenderer
	 * @memberOf Phaser.Renderer.Canvas
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Game} game - The Phaser Game instance that owns this renderer.
	 */
	var CanvasRenderer = new Class({
	
	    initialize:
	
	    function CanvasRenderer (game)
	    {
	        /**
	         * The Phaser Game instance that owns this renderer.
	         *
	         * @name Phaser.Renderer.Canvas.CanvasRenderer#game
	         * @type {Phaser.Game}
	         * @since 3.0.0
	         */
	        this.game = game;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.Canvas.CanvasRenderer#type
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.type = CONST.CANVAS;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.Canvas.CanvasRenderer#drawCount
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.drawCount = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.Canvas.CanvasRenderer#width
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.width = game.config.width;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.Canvas.CanvasRenderer#height
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.height = game.config.height;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.Canvas.CanvasRenderer#config
	         * @type {RendererConfig}
	         * @since 3.0.0
	         */
	        this.config = {
	            clearBeforeRender: game.config.clearBeforeRender,
	            pixelArt: game.config.pixelArt,
	            backgroundColor: game.config.backgroundColor,
	            resolution: game.config.resolution,
	            autoResize: game.config.autoResize,
	            roundPixels: game.config.roundPixels
	        };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.Canvas.CanvasRenderer#scaleMode
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.scaleMode = (game.config.pixelArt) ? ScaleModes.NEAREST : ScaleModes.LINEAR;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.Canvas.CanvasRenderer#gameCanvas
	         * @type {HTMLCanvasElement}
	         * @since 3.0.0
	         */
	        this.gameCanvas = game.canvas;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.Canvas.CanvasRenderer#gameContext
	         * @type {CanvasRenderingContext2D}
	         * @since 3.0.0
	         */
	        this.gameContext = (this.game.config.context) ? this.game.config.context : this.gameCanvas.getContext('2d');
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.Canvas.CanvasRenderer#currentContext
	         * @type {CanvasRenderingContext2D}
	         * @since 3.0.0
	         */
	        this.currentContext = this.gameContext;
	
	        /**
	         * Map to the required function.
	         *
	         * @name Phaser.Renderer.Canvas.CanvasRenderer#drawImage
	         * @type {function}
	         * @since 3.0.0
	         */
	        this.drawImage = DrawImage(this.config.roundPixels);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.Canvas.CanvasRenderer#blitImage
	         * @type {function}
	         * @since 3.0.0
	         */
	        this.blitImage = BlitImage(this.config.roundPixels);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.Canvas.CanvasRenderer#blendModes
	         * @type {array}
	         * @since 3.0.0
	         */
	        this.blendModes = GetBlendModes();
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.Canvas.CanvasRenderer#currentAlpha
	         * @type {number}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.currentAlpha = 1;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.Canvas.CanvasRenderer#currentBlendMode
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.currentBlendMode = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.Canvas.CanvasRenderer#currentScaleMode
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.currentScaleMode = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.Canvas.CanvasRenderer#snapshotCallback
	         * @type {?SnapshotCallback}
	         * @default null
	         * @since 3.0.0
	         */
	        this.snapshotCallback = null;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.Canvas.CanvasRenderer#snapshotType
	         * @type {?string}
	         * @default null
	         * @since 3.0.0
	         */
	        this.snapshotType = null;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.Canvas.CanvasRenderer#snapshotEncoder
	         * @type {?number}
	         * @default null
	         * @since 3.0.0
	         */
	        this.snapshotEncoder = null;
	
	        this.init();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.Canvas.CanvasRenderer#init
	     * @since 3.0.0
	     */
	    init: function ()
	    {
	        this.resize(this.width, this.height);
	    },
	
	    /**
	     * Resize the main game canvas.
	     *
	     * @method Phaser.Renderer.Canvas.CanvasRenderer#resize
	     * @since 3.0.0
	     *
	     * @param {integer} width - [description]
	     * @param {integer} height - [description]
	     */
	    resize: function (width, height)
	    {
	        var resolution = this.config.resolution;
	
	        this.width = width * resolution;
	        this.height = height * resolution;
	
	        this.gameCanvas.width = this.width;
	        this.gameCanvas.height = this.height;
	
	        if (this.config.autoResize)
	        {
	            this.gameCanvas.style.width = (this.width / resolution) + 'px';
	            this.gameCanvas.style.height = (this.height / resolution) + 'px';
	        }
	
	        //  Resizing a canvas will reset imageSmoothingEnabled (and probably other properties)
	        if (this.scaleMode === ScaleModes.NEAREST)
	        {
	            Smoothing.disable(this.gameContext);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.Canvas.CanvasRenderer#onContextLost
	     * @since 3.0.0
	     *
	     * @param {function} callback - [description]
	     */
	    onContextLost: function ()
	    {
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.Canvas.CanvasRenderer#onContextRestored
	     * @since 3.0.0
	     *
	     * @param {function} callback - [description]
	     */
	    onContextRestored: function ()
	    {
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.Canvas.CanvasRenderer#resetTransform
	     * @since 3.0.0
	     */
	    resetTransform: function ()
	    {
	        this.currentContext.setTransform(1, 0, 0, 1, 0, 0);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.Canvas.CanvasRenderer#setBlendMode
	     * @since 3.0.0
	     *
	     * @param {number} blendMode - [description]
	     *
	     * @return {number} [description]
	     */
	    setBlendMode: function (blendMode)
	    {
	        if (this.currentBlendMode !== blendMode)
	        {
	            this.currentContext.globalCompositeOperation = blendMode;
	            this.currentBlendMode = blendMode;
	        }
	
	        return this.currentBlendMode;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.Canvas.CanvasRenderer#setAlpha
	     * @since 3.0.0
	     *
	     * @param {float} alpha - [description]
	     *
	     * @return {float} [description]
	     */
	    setAlpha: function (alpha)
	    {
	        if (this.currentAlpha !== alpha)
	        {
	            this.currentContext.globalAlpha = alpha;
	            this.currentAlpha = alpha;
	        }
	
	        return this.currentAlpha;
	    },
	
	    /**
	     * Called at the start of the render loop.
	     *
	     * @method Phaser.Renderer.Canvas.CanvasRenderer#preRender
	     * @since 3.0.0
	     */
	    preRender: function ()
	    {
	        var ctx = this.gameContext;
	        var config = this.config;
	
	        var width = this.width;
	        var height = this.height;
	
	        if (config.clearBeforeRender)
	        {
	            ctx.clearRect(0, 0, width, height);
	        }
	
	        if (!config.transparent)
	        {
	            ctx.fillStyle = config.backgroundColor.rgba;
	            ctx.fillRect(0, 0, width, height);
	        }
	
	        this.drawCount = 0;
	    },
	
	    /**
	     * Renders the Scene to the given Camera.
	     *
	     * @method Phaser.Renderer.Canvas.CanvasRenderer#render
	     * @since 3.0.0
	     *
	     * @param {Phaser.Scene} scene - [description]
	     * @param {Phaser.GameObjects.DisplayList} children - [description]
	     * @param {float} interpolationPercentage - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     */
	    render: function (scene, children, interpolationPercentage, camera)
	    {
	        var ctx = scene.sys.context;
	        var scissor = (camera.x !== 0 || camera.y !== 0 || camera.width !== ctx.canvas.width || camera.height !== ctx.canvas.height);
	        var list = children.list;
	        var resolution = this.config.resolution;
	
	        this.currentContext = ctx;
	
	        //  If the alpha or blend mode didn't change since the last render, then don't set them again (saves 2 ops)
	
	        if (!camera.transparent)
	        {
	            ctx.fillStyle = camera.backgroundColor.rgba;
	            ctx.fillRect(camera.x, camera.y, camera.width, camera.height);
	        }
	
	        if (this.currentAlpha !== 1)
	        {
	            ctx.globalAlpha = 1;
	            this.currentAlpha = 1;
	        }
	
	        if (this.currentBlendMode !== 0)
	        {
	            ctx.globalCompositeOperation = 'source-over';
	            this.currentBlendMode = 0;
	        }
	
	        this.currentScaleMode = 0;
	
	        this.drawCount += list.length;
	
	        if (scissor)
	        {
	            ctx.save();
	            ctx.beginPath();
	            ctx.rect(camera.x * resolution, camera.y * resolution, camera.width * resolution, camera.height * resolution);
	            ctx.clip();
	        }
	
	        var matrix = camera.matrix.matrix;
	
	        ctx.setTransform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
	
	        for (var c = 0; c < list.length; c++)
	        {
	            var child = list[c];
	
	            if (child.mask)
	            {
	                child.mask.preRenderCanvas(this, child, camera);
	            }
	
	            child.renderCanvas(this, child, interpolationPercentage, camera);
	
	            if (child.mask)
	            {
	                child.mask.postRenderCanvas(this, child, camera);
	            }
	        }
	
	        ctx.setTransform(1, 0, 0, 1, 0, 0);
	        ctx.globalCompositeOperation = 'source-over';
	
	        camera.flashEffect.postRenderCanvas(ctx);
	        camera.fadeEffect.postRenderCanvas(ctx);
	
	        //  Reset the camera scissor
	        if (scissor)
	        {
	            ctx.restore();
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.Canvas.CanvasRenderer#postRender
	     * @since 3.0.0
	     */
	    postRender: function ()
	    {
	        var ctx = this.gameContext;
	
	        ctx.globalAlpha = 1;
	        ctx.globalCompositeOperation = 'source-over';
	
	        this.currentAlpha = 1;
	        this.currentBlendMode = 0;
	
	        if (this.snapshotCallback)
	        {
	            this.snapshotCallback(CanvasSnapshot(this.gameCanvas, this.snapshotType, this.snapshotEncoder));
	            this.snapshotCallback = null;
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.Canvas.CanvasRenderer#snapshot
	     * @since 3.0.0
	     *
	     * @param {SnapshotCallback} callback - [description]
	     * @param {string} type - [description]
	     * @param {number} encoderOptions - [description]
	     */
	    snapshot: function (callback, type, encoderOptions)
	    {
	        this.snapshotCallback = callback;
	        this.snapshotType = type;
	        this.snapshotEncoder = encoderOptions;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.Canvas.CanvasRenderer#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.gameCanvas = null;
	        this.gameContext = null;
	
	        this.game = null;
	    }
	
	});
	
	module.exports = CanvasRenderer;


/***/ }),
/* 613 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var roundPixels = false;
	
	/**
	 * No scaling, anchor, rotation or effects, literally draws the frame directly to the canvas.
	 *
	 * @function Phaser.Renderer.Canvas.BlitImage
	 * @since 3.0.0
	 *
	 * @param {number} dx - The x coordinate to render the Frame to.
	 * @param {number} dy - The y coordinate to render the Frame to.
	 * @param {Phaser.Textures.Frame} frame - The Frame to render.
	 */
	var BlitImage = function (dx, dy, frame)
	{
	    var ctx = this.currentContext;
	    var cd = frame.canvasData;
	
	    if (roundPixels)
	    {
	        dx |= 0;
	        dy |= 0;
	    }
	
	    ctx.drawImage(
	        frame.source.image,
	        cd.sx,
	        cd.sy,
	        cd.sWidth,
	        cd.sHeight,
	        dx,
	        dy,
	        cd.dWidth,
	        cd.dHeight
	    );
	};
	
	//  Special return so we can store the config value locally
	
	module.exports = function (configRoundPixels)
	{
	    roundPixels = configRoundPixels;
	
	    return BlitImage;
	};


/***/ }),
/* 614 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var roundPixels = false;
	
	/**
	 * [description]
	 *
	 * @function Phaser.Renderer.Canvas.DrawImage
	 * @since 3.0.0
	 *
	 * @param {Phaser.GameObjects.GameObject} src - [description]
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - [description]
	 */
	var DrawImage = function (src, camera, parentMatrix)
	{
	    var ctx = this.currentContext;
	    var frame = src.frame;
	    var cd = frame.canvasData;
	
	    //  Blend Mode
	
	    if (this.currentBlendMode !== src.blendMode)
	    {
	        this.currentBlendMode = src.blendMode;
	        ctx.globalCompositeOperation = this.blendModes[src.blendMode];
	    }
	
	    //  Alpha
	
	    if (this.currentAlpha !== src.alpha)
	    {
	        this.currentAlpha = src.alpha;
	        ctx.globalAlpha = src.alpha;
	    }
	
	    //  Smoothing
	
	    if (this.currentScaleMode !== src.scaleMode)
	    {
	        this.currentScaleMode = src.scaleMode;
	
	        // ctx[this.smoothProperty] = (source.scaleMode === ScaleModes.LINEAR);
	    }
	
	    var dx = frame.x;
	    var dy = frame.y;
	
	    var fx = 1;
	    var fy = 1;
	
	    if (src.flipX)
	    {
	        fx = -1;
	        dx -= cd.dWidth - src.displayOriginX;
	    }
	    else
	    {
	        dx -= src.displayOriginX;
	    }
	
	    if (src.flipY)
	    {
	        fy = -1;
	        dy -= cd.dHeight - src.displayOriginY;
	    }
	    else
	    {
	        dy -= src.displayOriginY;
	    }
	
	    var tx = src.x - camera.scrollX * src.scrollFactorX;
	    var ty = src.y - camera.scrollY * src.scrollFactorY;
	
	    if (roundPixels)
	    {
	        tx |= 0;
	        ty |= 0;
	        dx |= 0;
	        dy |= 0;
	    }
	
	    //  Perform Matrix ITRS
	
	    ctx.save();
	
	    if (parentMatrix)
	    {
	        var matrix = parentMatrix.matrix;
	
	        ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
	    }
	
	    ctx.translate(tx, ty);
	
	    ctx.rotate(src.rotation);
	
	    ctx.scale(src.scaleX, src.scaleY);
	    ctx.scale(fx, fy);
	
	    ctx.drawImage(frame.source.image, cd.sx, cd.sy, cd.sWidth, cd.sHeight, dx, dy, cd.dWidth, cd.dHeight);
	
	    ctx.restore();
	};
	
	//  Special return so we can store the config value locally
	
	module.exports = function (configRoundPixels)
	{
	    roundPixels = configRoundPixels;
	
	    return DrawImage;
	};


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var modes = __webpack_require__(145);
	var CanvasFeatures = __webpack_require__(459);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Renderer.Canvas.GetBlendModes
	 * @since 3.0.0
	 *
	 * @return {array} [description]
	 */
	var GetBlendModes = function ()
	{
	    var output = [];
	    var useNew = CanvasFeatures.supportNewBlendModes;
	
	    output[modes.NORMAL] = 'source-over';
	    output[modes.ADD] = 'lighter';
	    output[modes.MULTIPLY] = (useNew) ? 'multiply' : 'source-over';
	    output[modes.SCREEN] = (useNew) ? 'screen' : 'source-over';
	    output[modes.OVERLAY] = (useNew) ? 'overlay' : 'source-over';
	    output[modes.DARKEN] = (useNew) ? 'darken' : 'source-over';
	    output[modes.LIGHTEN] = (useNew) ? 'lighten' : 'source-over';
	    output[modes.COLOR_DODGE] = (useNew) ? 'color-dodge' : 'source-over';
	    output[modes.COLOR_BURN] = (useNew) ? 'color-burn' : 'source-over';
	    output[modes.HARD_LIGHT] = (useNew) ? 'hard-light' : 'source-over';
	    output[modes.SOFT_LIGHT] = (useNew) ? 'soft-light' : 'source-over';
	    output[modes.DIFFERENCE] = (useNew) ? 'difference' : 'source-over';
	    output[modes.EXCLUSION] = (useNew) ? 'exclusion' : 'source-over';
	    output[modes.HUE] = (useNew) ? 'hue' : 'source-over';
	    output[modes.SATURATION] = (useNew) ? 'saturation' : 'source-over';
	    output[modes.COLOR] = (useNew) ? 'color' : 'source-over';
	    output[modes.LUMINOSITY] = (useNew) ? 'luminosity' : 'source-over';
	
	    return output;
	};
	
	module.exports = GetBlendModes;


/***/ }),
/* 616 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Renderer.Snapshot.Canvas
	 * @since 3.0.0
	 *
	 * @param {HTMLCanvasElement} canvas - [description]
	 * @param {string} [type='image/png'] - [description]
	 * @param {float} [encoderOptions=0.92] - [description]
	 *
	 * @return {HTMLImageElement} [description]
	 */
	var CanvasSnapshot = function (canvas, type, encoderOptions)
	{
	    if (type === undefined) { type = 'image/png'; }
	    if (encoderOptions === undefined) { encoderOptions = 0.92; }
	
	    var src = canvas.toDataURL(type, encoderOptions);
	
	    var image = new Image();
	
	    image.src = src;
	
	    return image;
	};
	
	module.exports = CanvasSnapshot;


/***/ }),
/* 617 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Renderer.Snapshot.WebGL
	 * @since 3.0.0
	 *
	 * @param {HTMLCanvasElement} sourceCanvas - [description]
	 * @param {string} [type='image/png'] - [description]
	 * @param {float} [encoderOptions=0.92] - [description]
	 *
	 * @return {HTMLImageElement} [description]
	 */
	var WebGLSnapshot = function (sourceCanvas, type, encoderOptions)
	{
	    if (!type) { type = 'image/png'; }
	    if (!encoderOptions) { encoderOptions = 0.92; }
	
	    var gl = sourceCanvas.getContext('experimental-webgl');
	    var pixels = new Uint8Array(gl.drawingBufferWidth * gl.drawingBufferHeight * 4);
	    gl.readPixels(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
	
	    //  CanvasPool?
	    var canvas = document.createElement('canvas');
	    var ctx = canvas.getContext('2d');
	    var imageData;
	
	    canvas.width = gl.drawingBufferWidth;
	    canvas.height = gl.drawingBufferHeight;
	
	    imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
	
	    var data = imageData.data;
	
	    for (var y = 0; y < canvas.height; y += 1)
	    {
	        for (var x = 0; x < canvas.width; x += 1)
	        {
	            var si = ((canvas.height - y) * canvas.width + x) * 4;
	            var di = (y * canvas.width + x) * 4;
	            data[di + 0] = pixels[si + 0];
	            data[di + 1] = pixels[si + 1];
	            data[di + 2] = pixels[si + 2];
	            data[di + 3] = pixels[si + 3];
	        }
	    }
	
	    ctx.putImageData(imageData, 0, 0);
	
	    var src = canvas.toDataURL(type, encoderOptions);
	    var image = new Image();
	
	    image.src = src;
	
	    return image;
	};
	
	module.exports = WebGLSnapshot;


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Felipe Alfonso <@bitnenfer>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(49);
	var IsSizePowerOfTwo = __webpack_require__(203);
	var SpliceOne = __webpack_require__(175);
	var Utils = __webpack_require__(87);
	var WebGLSnapshot = __webpack_require__(617);
	
	// Default Pipelines
	var BitmapMaskPipeline = __webpack_require__(619);
	var FlatTintPipeline = __webpack_require__(620);
	var ForwardDiffuseLightPipeline = __webpack_require__(323);
	var TextureTintPipeline = __webpack_require__(324);
	
	/**
	 * @callback WebGLContextCallback
	 *
	 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - [description]
	 */
	
	/**
	 * @typedef {object} SnapshotState
	 *
	 * @property {SnapshotCallback} callback - [description]
	 * @property {string} type - [description]
	 * @property {float} encoder - [description]
	 */
	
	/**
	 * @classdesc
	 * WebGLRenderer is a class that contains the needed functionality to keep the
	 * WebGLRenderingContext state clean. The main idea of the WebGLRenderer is to keep track of
	 * any context change that happens for WebGL rendering inside of Phaser. This means
	 * if raw webgl functions are called outside the WebGLRenderer of the Phaser WebGL
	 * rendering ecosystem they might pollute the current WebGLRenderingContext state producing
	 * unexpected behaviour. It's recommended that WebGL interaction is done through 
	 * WebGLRenderer and/or WebGLPipeline.
	 *
	 * @class WebGLRenderer
	 * @memberOf Phaser.Renderer.WebGL
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Game} game - [description]
	 */
	var WebGLRenderer = new Class({
	
	    initialize:
	
	    function WebGLRenderer (game)
	    {
	        // eslint-disable-next-line consistent-this
	        var renderer = this;
	
	        var gameConfig = game.config;
	
	        var contextCreationConfig = {
	            alpha: gameConfig.transparent,
	            depth: false, // enable when 3D is added in the future
	            antialias: gameConfig.antialias,
	            premultipliedAlpha: gameConfig.premultipliedAlpha,
	            stencil: true,
	            preserveDrawingBuffer: gameConfig.preserveDrawingBuffer,
	            failIfMajorPerformanceCaveat: gameConfig.failIfMajorPerformanceCaveat,
	            powerPreference: gameConfig.powerPreference
	        };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#config
	         * @type {RendererConfig}
	         * @since 3.0.0
	         */
	        this.config = {
	            clearBeforeRender: gameConfig.clearBeforeRender,
	            pixelArt: gameConfig.pixelArt,
	            backgroundColor: gameConfig.backgroundColor,
	            contextCreation: contextCreationConfig,
	            resolution: gameConfig.resolution,
	            autoResize: gameConfig.autoResize,
	            roundPixels: gameConfig.roundPixels,
	            maxTextures: gameConfig.maxTextures,
	            maxTextureSize: gameConfig.maxTextureSize
	        };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#game
	         * @type {Phaser.Game}
	         * @since 3.0.0
	         */
	        this.game = game;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#type
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.type = CONST.WEBGL;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#width
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.width = game.config.width;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#height
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.height = game.config.height;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#canvas
	         * @type {HTMLCanvasElement}
	         * @since 3.0.0
	         */
	        this.canvas = game.canvas;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#lostContextCallbacks
	         * @type {WebGLContextCallback[]}
	         * @since 3.0.0
	         */
	        this.lostContextCallbacks = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#restoredContextCallbacks
	         * @type {WebGLContextCallback[]}
	         * @since 3.0.0
	         */
	        this.restoredContextCallbacks = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#blendModes
	         * @type {array}
	         * @default []
	         * @since 3.0.0
	         */
	        this.blendModes = [];
	
	        /**
	         * Keeps track of any WebGLTexture created with the current WebGLRenderingContext
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#nativeTextures
	         * @type {array}
	         * @default []
	         * @since 3.0.0
	         */
	        this.nativeTextures = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#contextLost
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.contextLost = false;
	
	        /**
	         * This object will store all pipelines created through addPipeline
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#pipelines
	         * @type {object}
	         * @default null
	         * @since 3.0.0
	         */
	        this.pipelines = null;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#snapshotState
	         * @type {SnapshotState}
	         * @since 3.0.0
	         */
	        this.snapshotState = {
	            callback: null,
	            type: null,
	            encoder: null
	        };
	
	        // Internal Renderer State (Textures, Framebuffers, Pipelines, Buffers, etc)
	
	        /**
	         * Cached value for the last texture unit that was used
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentActiveTextureUnit
	         * @type {integer}
	         * @since 3.1.0
	         */
	        this.currentActiveTextureUnit = 0;
	
	        /**
	         * An array of the last texture handles that were bound to the WebGLRenderingContext
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentTextures
	         * @type {array}
	         * @since 3.0.0
	         */
	        this.currentTextures = new Array(16);
	
	        /**
	         * Current framebuffer in use
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentFramebuffer
	         * @type {WebGLFramebuffer}
	         * @default null
	         * @since 3.0.0
	         */
	        this.currentFramebuffer = null;
	
	        /**
	         * Current WebGLPipeline in use
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentPipeline
	         * @type {Phaser.Renderer.WebGL.WebGLPipeline}
	         * @default null
	         * @since 3.0.0
	         */
	        this.currentPipeline = null;
	
	        /**
	         * Current WebGLProgram in use
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentProgram
	         * @type {WebGLProgram}
	         * @default null
	         * @since 3.0.0
	         */
	        this.currentProgram = null;
	
	        /**
	         * Current WebGLBuffer (Vertex buffer) in use
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentVertexBuffer
	         * @type {WebGLBuffer}
	         * @default null
	         * @since 3.0.0
	         */
	        this.currentVertexBuffer = null;
	
	        /**
	         * Current WebGLBuffer (Index buffer) in use
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentIndexBuffer
	         * @type {WebGLBuffer}
	         * @default null
	         * @since 3.0.0
	         */
	        this.currentIndexBuffer = null;
	
	        /**
	         * Current blend mode in use
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentBlendMode
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.currentBlendMode = Infinity;
	
	        /**
	         * Indicates if the the scissor state is enabled in WebGLRenderingContext
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentScissorEnabled
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.currentScissorEnabled = false;
	
	        /**
	         * Stores the current scissor data
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentScissor
	         * @type {Uint32Array}
	         * @since 3.0.0
	         */
	        this.currentScissor = new Uint32Array([ 0, 0, this.width, this.height ]);
	
	        /**
	         * Index to the scissor stack top
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#currentScissorIdx
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.currentScissorIdx = 0;
	
	        /**
	         * Stack of scissor data
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#scissorStack
	         * @type {Uint32Array}
	         * @since 3.0.0
	         */
	        this.scissorStack = new Uint32Array(4 * 1000);
	
	        // Setup context lost and restore event listeners
	
	        this.canvas.addEventListener('webglcontextlost', function (event)
	        {
	            renderer.contextLost = true;
	            event.preventDefault();
	
	            for (var index = 0; index < renderer.lostContextCallbacks.length; ++index)
	            {
	                var callback = renderer.lostContextCallbacks[index];
	                callback[0].call(callback[1], renderer);
	            }
	        }, false);
	
	        this.canvas.addEventListener('webglcontextrestored', function ()
	        {
	            renderer.contextLost = false;
	            renderer.init(renderer.config);
	            for (var index = 0; index < renderer.restoredContextCallbacks.length; ++index)
	            {
	                var callback = renderer.restoredContextCallbacks[index];
	                callback[0].call(callback[1], renderer);
	            }
	        }, false);
	
	        // These are initialized post context creation
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#gl
	         * @type {WebGLRenderingContext}
	         * @default null
	         * @since 3.0.0
	         */
	        this.gl = null;
	
	        /**
	         * Array of strings that indicate which WebGL extensions are supported by the browser
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#supportedExtensions
	         * @type {object}
	         * @default null
	         * @since 3.0.0
	         */
	        this.supportedExtensions = null;
	
	        /**
	         * Extensions loaded into the current context
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#extensions
	         * @type {object}
	         * @default {}
	         * @since 3.0.0
	         */
	        this.extensions = {};
	
	        /**
	         * Stores the current WebGL component formats for further use
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#glFormats
	         * @type {array}
	         * @default []
	         * @since 3.2.0
	         */
	        this.glFormats = [];
	
	        /**
	         * Stores the supported WebGL texture compression formats.
	         *
	         * @name Phaser.Renderer.WebGL.WebGLRenderer#compression
	         * @type {array}
	         * @since 3.8.0
	         */
	        this.compression = {
	            ETC1: false,
	            PVRTC: false,
	            S3TC: false
	        };
	
	        this.init(this.config);
	    },
	
	    /**
	     * Creates a new WebGLRenderingContext and initializes all internal
	     * state.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#init
	     * @since 3.0.0
	     *
	     * @param {object} config - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} [description]
	     */
	    init: function (config)
	    {
	        var gl;
	        var canvas = this.canvas;
	        var clearColor = config.backgroundColor;
	
	        //  Did they provide their own context?
	        if (this.game.config.context)
	        {
	            gl = this.game.config.context;
	        }
	        else
	        {
	            gl = canvas.getContext('webgl', config.contextCreation) || canvas.getContext('experimental-webgl', config.contextCreation);
	        }
	
	        if (!gl || gl.isContextLost())
	        {
	            this.contextLost = true;
	
	            throw new Error('This browser does not support WebGL. Try using the Canvas pipeline.');
	        }
	
	        this.gl = gl;
	
	        //  Set it back into the Game, so devs can access it from there too
	        this.game.context = gl;
	
	        for (var i = 0; i <= 16; i++)
	        {
	            this.blendModes.push({ func: [ gl.ONE, gl.ONE_MINUS_SRC_ALPHA ], equation: gl.FUNC_ADD });
	        }
	
	        this.blendModes[1].func = [ gl.ONE, gl.DST_ALPHA ];
	        this.blendModes[2].func = [ gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA ];
	        this.blendModes[3].func = [ gl.ONE, gl.ONE_MINUS_SRC_COLOR ];
	
	        this.glFormats[0] = gl.BYTE;
	        this.glFormats[1] = gl.SHORT;
	        this.glFormats[2] = gl.UNSIGNED_BYTE;
	        this.glFormats[3] = gl.UNSIGNED_SHORT;
	        this.glFormats[4] = gl.FLOAT;
	
	        // Load supported extensions
	        var exts = gl.getSupportedExtensions();
	
	        if (!config.maxTextures)
	        {
	            config.maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
	        }
	
	        if (!config.maxTextureSize)
	        {
	            config.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
	        }
	
	        var extString = 'WEBGL_compressed_texture_';
	        var wkExtString = 'WEBKIT_' + extString;
	
	        this.compression.ETC1 = gl.getExtension(extString + 'etc1') || gl.getExtension(wkExtString + 'etc1');
	        this.compression.PVRTC = gl.getExtension(extString + 'pvrtc') || gl.getExtension(wkExtString + 'pvrtc');
	        this.compression.S3TC = gl.getExtension(extString + 's3tc') || gl.getExtension(wkExtString + 's3tc');
	        
	        this.supportedExtensions = exts;
	
	        // Setup initial WebGL state
	        gl.disable(gl.DEPTH_TEST);
	        gl.disable(gl.CULL_FACE);
	        gl.disable(gl.SCISSOR_TEST);
	        gl.enable(gl.BLEND);
	        gl.clearColor(clearColor.redGL, clearColor.greenGL, clearColor.blueGL, 1.0);
	
	        // Initialize all textures to null
	        for (var index = 0; index < this.currentTextures.length; ++index)
	        {
	            this.currentTextures[index] = null;
	        }
	
	        // Clear previous pipelines and reload default ones
	        this.pipelines = {};
	
	        this.addPipeline('TextureTintPipeline', new TextureTintPipeline({ game: this.game, renderer: this }));
	        this.addPipeline('FlatTintPipeline', new FlatTintPipeline({ game: this.game, renderer: this }));
	        this.addPipeline('BitmapMaskPipeline', new BitmapMaskPipeline({ game: this.game, renderer: this }));
	        this.addPipeline('Light2D', new ForwardDiffuseLightPipeline({ game: this.game, renderer: this }));
	
	        this.setBlendMode(CONST.BlendModes.NORMAL);
	        this.resize(this.width, this.height);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#resize
	     * @since 3.0.0
	     *
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} [description]
	     */
	    resize: function (width, height)
	    {
	        var gl = this.gl;
	        var pipelines = this.pipelines;
	        var resolution = this.config.resolution;
	
	        this.width = Math.floor(width * resolution);
	        this.height = Math.floor(height * resolution);
	
	        this.canvas.width = this.width;
	        this.canvas.height = this.height;
	
	        if (this.config.autoResize)
	        {
	            this.canvas.style.width = (this.width / resolution) + 'px';
	            this.canvas.style.height = (this.height / resolution) + 'px';
	        }
	
	        gl.viewport(0, 0, this.width, this.height);
	
	        // Update all registered pipelines
	        for (var pipelineName in pipelines)
	        {
	            pipelines[pipelineName].resize(width, height, resolution);
	        }
	                
	        this.currentScissor.set([ 0, 0, this.width, this.height ]);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#onContextRestored
	     * @since 3.0.0
	     *
	     * @param {WebGLContextCallback} callback - [description]
	     * @param {object} target - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} [description]
	     */
	    onContextRestored: function (callback, target)
	    {
	        this.restoredContextCallbacks.push([ callback, target ]);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#onContextLost
	     * @since 3.0.0
	     *
	     * @param {WebGLContextCallback} callback - [description]
	     * @param {object} target - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} [description]
	     */
	    onContextLost: function (callback, target)
	    {
	        this.lostContextCallbacks.push([ callback, target ]);
	
	        return this;
	    },
	
	    /**
	     * Checks if a WebGL extension is supported
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#hasExtension
	     * @since 3.0.0
	     *
	     * @param {string} extensionName - Name of the WebGL extension
	     *
	     * @return {boolean} [description]
	     */
	    hasExtension: function (extensionName)
	    {
	        return this.supportedExtensions ? this.supportedExtensions.indexOf(extensionName) : false;
	    },
	
	    /**
	     * Loads a WebGL extension
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#getExtension
	     * @since 3.0.0
	     *
	     * @param {string} extensionName - [description]
	     *
	     * @return {object} WebGL extension if the extension is supported
	     */
	    getExtension: function (extensionName)
	    {
	        if (!this.hasExtension(extensionName)) { return null; }
	
	        if (!(extensionName in this.extensions))
	        {
	            this.extensions[extensionName] = this.gl.getExtension(extensionName);
	        }
	
	        return this.extensions[extensionName];
	    },
	
	    /**
	     * Flushes the current pipeline if the pipeline is bound
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#flush
	     * @since 3.0.0
	     */
	    flush: function ()
	    {
	        if (this.currentPipeline)
	        {
	            this.currentPipeline.flush();
	        }
	    },
	
	    /* Renderer State Manipulation Functions */
	
	    /**
	     * Checks if a pipeline is present in the current WebGLRenderer
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#hasPipeline
	     * @since 3.0.0
	     *
	     * @param {string} pipelineName - Name of the pipeline
	     *
	     * @return {boolean} [description]
	     */
	    hasPipeline: function (pipelineName)
	    {
	        return (pipelineName in this.pipelines);
	    },
	
	    /**
	     * Returns the pipeline by name if the pipeline exists
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#getPipeline
	     * @since 3.0.0
	     *
	     * @param {string} pipelineName - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} [description]
	     */
	    getPipeline: function (pipelineName)
	    {
	        return (this.hasPipeline(pipelineName)) ? this.pipelines[pipelineName] : null;
	    },
	
	    /**
	     * Removes a pipeline by name
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#removePipeline
	     * @since 3.0.0
	     *
	     * @param {string} pipelineName - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} [description]
	     */
	    removePipeline: function (pipelineName)
	    {
	        delete this.pipelines[pipelineName];
	
	        return this;
	    },
	
	    /**
	     * Adds a pipeline instance into the collection of pipelines
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#addPipeline
	     * @since 3.0.0
	     *
	     * @param {string} pipelineName - [description]
	     * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipelineInstance - Pipeline instance must extend WebGLPipeline
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} The instance that was passed.
	     */
	    addPipeline: function (pipelineName, pipelineInstance)
	    {
	        if (!this.hasPipeline(pipelineName))
	        {
	            this.pipelines[pipelineName] = pipelineInstance;
	        }
	        else
	        {
	            console.warn('Pipeline', pipelineName, ' already exists.');
	        }
	
	        pipelineInstance.name = pipelineName;
	
	        this.pipelines[pipelineName].resize(this.width, this.height, this.config.resolution);
	
	        return pipelineInstance;
	    },
	
	    /**
	     * Sets the current scissor state
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#setScissor
	     * @since 3.0.0
	     *
	     * @param {integer} x - [description]
	     * @param {integer} y - [description]
	     * @param {integer} w - [description]
	     * @param {integer} h - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} [description]
	     */
	    setScissor: function (x, y, w, h)
	    {
	        var gl = this.gl;
	        var currentScissor = this.currentScissor;
	        var enabled = (x === 0 && y === 0 && w === gl.canvas.width && h === gl.canvas.height && w >= 0 && h >= 0);
	
	        if (currentScissor[0] !== x ||
	            currentScissor[1] !== y ||
	            currentScissor[2] !== w ||
	            currentScissor[3] !== h)
	        {
	            this.flush();
	        }
	
	        currentScissor[0] = x;
	        currentScissor[1] = y;
	        currentScissor[2] = w;
	        currentScissor[3] = h;
	
	        this.currentScissorEnabled = enabled;
	
	        if (enabled)
	        {
	            gl.disable(gl.SCISSOR_TEST);
	
	            return this;
	        }
	
	        gl.enable(gl.SCISSOR_TEST);
	        gl.scissor(x, (gl.drawingBufferHeight - y - h), w, h);
	
	        return this;
	    },
	
	    /**
	     * Pushes a new scissor state. This is used to set nested scissor states.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#pushScissor
	     * @since 3.0.0
	     *
	     * @param {integer} x - [description]
	     * @param {integer} y - [description]
	     * @param {integer} w - [description]
	     * @param {integer} h - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} [description]
	     */
	    pushScissor: function (x, y, w, h)
	    {
	        var scissorStack = this.scissorStack;
	        var stackIndex = this.currentScissorIdx;
	        var currentScissor = this.currentScissor;
	
	        scissorStack[stackIndex + 0] = currentScissor[0];
	        scissorStack[stackIndex + 1] = currentScissor[1];
	        scissorStack[stackIndex + 2] = currentScissor[2];
	        scissorStack[stackIndex + 3] = currentScissor[3];
	
	        this.currentScissorIdx += 4;
	        this.setScissor(x, y, w, h);
	
	        return this;
	    },
	
	    /**
	     * Pops the last scissor state and sets it.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#popScissor
	     * @since 3.0.0
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} [description]
	     */
	    popScissor: function ()
	    {
	        var scissorStack = this.scissorStack;
	        var stackIndex = this.currentScissorIdx - 4;
	
	        var x = scissorStack[stackIndex + 0];
	        var y = scissorStack[stackIndex + 1];
	        var w = scissorStack[stackIndex + 2];
	        var h = scissorStack[stackIndex + 3];
	
	        this.currentScissorIdx = stackIndex;
	        this.setScissor(x, y, w, h);
	
	        return this;
	    },
	
	    /**
	     * Binds a WebGLPipeline and sets it as the current pipeline to be used.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#setPipeline
	     * @since 3.0.0
	     *
	     * @param {Phaser.Renderer.WebGL.WebGLPipeline} pipelineInstance - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLPipeline} [description]
	     */
	    setPipeline: function (pipelineInstance)
	    {
	        if (this.currentPipeline !== pipelineInstance ||
	            this.currentPipeline.vertexBuffer !== this.currentVertexBuffer ||
	            this.currentPipeline.program !== this.currentProgram)
	        {
	            this.flush();
	            this.currentPipeline = pipelineInstance;
	            this.currentPipeline.bind();
	        }
	
	        this.currentPipeline.onBind();
	
	        return this.currentPipeline;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#setBlendMode
	     * @since 3.0.0
	     *
	     * @param {integer} blendModeId - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} [description]
	     */
	    setBlendMode: function (blendModeId)
	    {
	        var gl = this.gl;
	        var blendMode = this.blendModes[blendModeId];
	
	        if (blendModeId !== CONST.BlendModes.SKIP_CHECK &&
	            this.currentBlendMode !== blendModeId)
	        {
	            this.flush();
	
	            gl.enable(gl.BLEND);
	            gl.blendEquation(blendMode.equation);
	
	            if (blendMode.func.length > 2)
	            {
	                gl.blendFuncSeparate(blendMode.func[0], blendMode.func[1], blendMode.func[2], blendMode.func[3]);
	            }
	            else
	            {
	                gl.blendFunc(blendMode.func[0], blendMode.func[1]);
	            }
	
	            this.currentBlendMode = blendModeId;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#addBlendMode
	     * @since 3.0.0
	     *
	     * @param {function} func - [description]
	     * @param {function} equation - [description]
	     *
	     * @return {integer} [description]
	     */
	    addBlendMode: function (func, equation)
	    {
	        var index = this.blendModes.push({ func: func, equation: equation });
	
	        return index - 1;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#updateBlendMode
	     * @since 3.0.0
	     *
	     * @param {integer} index - [description]
	     * @param {function} func - [description]
	     * @param {function} equation - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} This WebGL Renderer.
	     */
	    updateBlendMode: function (index, func, equation)
	    {
	        if (this.blendModes[index])
	        {
	            this.blendModes[index].func = func;
	
	            if (equation)
	            {
	                this.blendModes[index].equation = equation;
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#removeBlendMode
	     * @since 3.0.0
	     *
	     * @param {integer} index - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} This WebGL Renderer.
	     */
	    removeBlendMode: function (index)
	    {
	        if (index > 16 && this.blendModes[index])
	        {
	            this.blendModes.splice(index, 1);
	        }
	
	        return this;
	    },
	
	    /**
	     * Binds a texture at a texture unit. If a texture is already 
	     * bound to that unit it will force a flush on the current pipeline.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#setTexture2D
	     * @since 3.0.0
	     *
	     * @param {WebGLTexture} texture - The WebGL texture that needs to be bound
	     * @param {integer} textureUnit - The texture unit to which the texture will be bound
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} This WebGL Renderer.
	     */
	    setTexture2D: function (texture, textureUnit)
	    {
	        var gl = this.gl;
	
	        if (texture !== this.currentTextures[textureUnit])
	        {
	            this.flush();
	
	            if (this.currentActiveTextureUnit !== textureUnit)
	            {
	                gl.activeTexture(gl.TEXTURE0 + textureUnit);
	
	                this.currentActiveTextureUnit = textureUnit;
	            }
	
	            gl.bindTexture(gl.TEXTURE_2D, texture);
	
	            this.currentTextures[textureUnit] = texture;
	        }
	
	        return this;
	    },
	
	    /**
	     * Binds a framebuffer. If there was another framebuffer already bound
	     * it will force a pipeline flush.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#setFramebuffer
	     * @since 3.0.0
	     *
	     * @param {WebGLFramebuffer} framebuffer - The framebuffer that needs to be bound
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} This WebGL Renderer.
	     */
	    setFramebuffer: function (framebuffer)
	    {
	        var gl = this.gl;
	
	        if (framebuffer !== this.currentFramebuffer)
	        {
	            this.flush();
	
	            gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
	
	            this.currentFramebuffer = framebuffer;
	        }
	
	        return this;
	    },
	
	    /**
	     * Binds a program. If there was another program already bound
	     * it will force a pipeline flush
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#setProgram
	     * @since 3.0.0
	     *
	     * @param {WebGLProgram} program - The program that needs to be bound
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} This WebGL Renderer.
	     */
	    setProgram: function (program)
	    {
	        var gl = this.gl;
	
	        if (program !== this.currentProgram)
	        {
	            this.flush();
	
	            gl.useProgram(program);
	
	            this.currentProgram = program;
	        }
	
	        return this;
	    },
	
	    /**
	     * Bounds a vertex buffer. If there is a vertex buffer already bound
	     * it'll force a pipeline flush.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#setVertexBuffer
	     * @since 3.0.0
	     *
	     * @param {WebGLBuffer} vertexBuffer - The buffer that needs to be bound
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} This WebGL Renderer.
	     */
	    setVertexBuffer: function (vertexBuffer)
	    {
	        var gl = this.gl;
	
	        if (vertexBuffer !== this.currentVertexBuffer)
	        {
	            this.flush();
	
	            gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer);
	
	            this.currentVertexBuffer = vertexBuffer;
	        }
	
	        return this;
	    },
	
	    /**
	     * Bounds a index buffer. If there is a index buffer already bound
	     * it'll force a pipeline flush.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#setIndexBuffer
	     * @since 3.0.0
	     *
	     * @param {WebGLBuffer} indexBuffer - The buffer the needs to be bound
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} This WebGL Renderer.
	     */
	    setIndexBuffer: function (indexBuffer)
	    {
	        var gl = this.gl;
	
	        if (indexBuffer !== this.currentIndexBuffer)
	        {
	            this.flush();
	
	            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
	
	            this.currentIndexBuffer = indexBuffer;
	        }
	
	        return this;
	    },
	
	    /* Renderer Resource Creation Functions */
	
	    /**
	     * Creates a texture from an image source. If the source is not valid
	     * it creates an empty texture
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#createTextureFromSource
	     * @since 3.0.0
	     *
	     * @param {object} source - [description]
	     * @param {integer} width - [description]
	     * @param {integer} height - [description]
	     * @param {integer} scaleMode - [description]
	     *
	     * @return {WebGLTexture} [description]
	     */
	    createTextureFromSource: function (source, width, height, scaleMode)
	    {
	        var gl = this.gl;
	        var filter = gl.NEAREST;
	        var wrap = gl.CLAMP_TO_EDGE;
	        var texture = null;
	
	        width = source ? source.width : width;
	        height = source ? source.height : height;
	
	        if (IsSizePowerOfTwo(width, height))
	        {
	            wrap = gl.REPEAT;
	        }
	
	        if (scaleMode === CONST.ScaleModes.LINEAR)
	        {
	            filter = gl.LINEAR;
	        }
	        else if (scaleMode === CONST.ScaleModes.NEAREST || this.config.pixelArt)
	        {
	            filter = gl.NEAREST;
	        }
	
	        if (!source && typeof width === 'number' && typeof height === 'number')
	        {
	            texture = this.createTexture2D(0, filter, filter, wrap, wrap, gl.RGBA, null, width, height);
	        }
	        else
	        {
	            texture = this.createTexture2D(0, filter, filter, wrap, wrap, gl.RGBA, source);
	        }
	
	        return texture;
	    },
	
	    /**
	     * A wrapper for creating a WebGLTexture. If not pixel data is passed
	     * it will create an empty texture.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#createTexture2D
	     * @since 3.0.0
	     *
	     * @param {integer} mipLevel - Mip level of the texture
	     * @param {integer} minFilter - Filtering of the texture
	     * @param {integer} magFilter - Filtering of the texture
	     * @param {integer} wrapT - Wrapping mode of the texture
	     * @param {integer} wrapS - Wrapping mode of the texture
	     * @param {integer} format - Which format does the texture use
	     * @param {object} pixels - pixel data
	     * @param {integer} width - Width of the texture in pixels
	     * @param {integer} height - Height of the texture in pixels
	     * @param {boolean} pma - Does the texture hace premultiplied alpha.
	     *
	     * @return {WebGLTexture} Raw WebGLTexture
	     */
	    createTexture2D: function (mipLevel, minFilter, magFilter, wrapT, wrapS, format, pixels, width, height, pma)
	    {
	        var gl = this.gl;
	        var texture = gl.createTexture();
	
	        pma = (pma === undefined || pma === null) ? true : pma;
	
	        this.setTexture2D(texture, 0);
	
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, minFilter);
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, magFilter);
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, wrapS);
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, wrapT);
	        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, pma);
	
	        if (pixels === null || pixels === undefined)
	        {
	            gl.texImage2D(gl.TEXTURE_2D, mipLevel, format, width, height, 0, format, gl.UNSIGNED_BYTE, null);
	        }
	        else
	        {
	            gl.texImage2D(gl.TEXTURE_2D, mipLevel, format, format, gl.UNSIGNED_BYTE, pixels);
	            width = pixels.width;
	            height = pixels.height;
	        }
	
	        this.setTexture2D(null, 0);
	
	        texture.isAlphaPremultiplied = pma;
	        texture.isRenderTexture = false;
	        texture.width = width;
	        texture.height = height;
	
	        this.nativeTextures.push(texture);
	
	        return texture;
	    },
	
	    /**
	     * Wrapper for creating WebGLFramebuffer.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#createFramebuffer
	     * @since 3.0.0
	     *
	     * @param {integer} width - Width in pixels of the framebuffer
	     * @param {integer} height - Height in pixels of the framebuffer
	     * @param {WebGLTexture} renderTexture - The color texture to where the color pixels are written 
	     * @param {boolean} addDepthStencilBuffer - Indicates if the current framebuffer support depth and stencil buffers
	     *
	     * @return {WebGLFramebuffer} Raw WebGLFramebuffer
	     */
	    createFramebuffer: function (width, height, renderTexture, addDepthStencilBuffer)
	    {
	        var gl = this.gl;
	        var framebuffer = gl.createFramebuffer();
	        var complete = 0;
	
	        this.setFramebuffer(framebuffer);
	
	        if (addDepthStencilBuffer)
	        {
	            var depthStencilBuffer = gl.createRenderbuffer();
	            gl.bindRenderbuffer(gl.RENDERBUFFER, depthStencilBuffer);
	            gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, width, height);
	            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, depthStencilBuffer);
	        }
	
	        renderTexture.isRenderTexture = true;
	        renderTexture.isAlphaPremultiplied = false;
	
	        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, renderTexture, 0);
	
	        complete = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
	
	        if (complete !== gl.FRAMEBUFFER_COMPLETE)
	        {
	            var errors = {
	                36054: 'Incomplete Attachment',
	                36055: 'Missing Attachment',
	                36057: 'Incomplete Dimensions',
	                36061: 'Framebuffer Unsupported'
	            };
	
	            throw new Error('Framebuffer incomplete. Framebuffer status: ' + errors[complete]);
	        }
	
	        framebuffer.renderTexture = renderTexture;
	
	        this.setFramebuffer(null);
	
	        return framebuffer;
	    },
	
	    /**
	     * Wrapper for creating a WebGLProgram
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#createProgram
	     * @since 3.0.0
	     *
	     * @param {string} vertexShader - Source to the vertex shader
	     * @param {string} fragmentShader - Source to the fragment shader
	     *
	     * @return {WebGLProgram} Raw WebGLProgram
	     */
	    createProgram: function (vertexShader, fragmentShader)
	    {
	        var gl = this.gl;
	        var program = gl.createProgram();
	        var vs = gl.createShader(gl.VERTEX_SHADER);
	        var fs = gl.createShader(gl.FRAGMENT_SHADER);
	
	        gl.shaderSource(vs, vertexShader);
	        gl.shaderSource(fs, fragmentShader);
	        gl.compileShader(vs);
	        gl.compileShader(fs);
	
	        if (!gl.getShaderParameter(vs, gl.COMPILE_STATUS))
	        {
	            throw new Error('Failed to compile Vertex Shader:\n' + gl.getShaderInfoLog(vs));
	        }
	        if (!gl.getShaderParameter(fs, gl.COMPILE_STATUS))
	        {
	            throw new Error('Failed to compile Fragment Shader:\n' + gl.getShaderInfoLog(fs));
	        }
	
	        gl.attachShader(program, vs);
	        gl.attachShader(program, fs);
	        gl.linkProgram(program);
	
	        if (!gl.getProgramParameter(program, gl.LINK_STATUS))
	        {
	            throw new Error('Failed to link program:\n' + gl.getProgramInfoLog(program));
	        }
	
	        return program;
	    },
	
	    /**
	     * Wrapper for creating a vertex buffer.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#createVertexBuffer
	     * @since 3.0.0
	     *
	     * @param {ArrayBuffer} initialDataOrSize - It's either ArrayBuffer or an integer indicating the size of the vbo
	     * @param {integer} bufferUsage - How the buffer is used. gl.DYNAMIC_DRAW, gl.STATIC_DRAW or gl.STREAM_DRAW
	     *
	     * @return {WebGLBuffer} Raw vertex buffer
	     */
	    createVertexBuffer: function (initialDataOrSize, bufferUsage)
	    {
	        var gl = this.gl;
	        var vertexBuffer = gl.createBuffer();
	
	        this.setVertexBuffer(vertexBuffer);
	
	        gl.bufferData(gl.ARRAY_BUFFER, initialDataOrSize, bufferUsage);
	
	        this.setVertexBuffer(null);
	
	        return vertexBuffer;
	    },
	
	    /**
	     * Wrapper for creating a vertex buffer.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#createIndexBuffer
	     * @since 3.0.0
	     *
	     * @param {ArrayBuffer} initialDataOrSize - It's either ArrayBuffer or an integer indicating the size of the vbo
	     * @param {integer} bufferUsage - How the buffer is used. gl.DYNAMIC_DRAW, gl.STATIC_DRAW or gl.STREAM_DRAW
	     *
	     * @return {WebGLBuffer} Raw index buffer
	     */
	    createIndexBuffer: function (initialDataOrSize, bufferUsage)
	    {
	        var gl = this.gl;
	        var indexBuffer = gl.createBuffer();
	
	        this.setIndexBuffer(indexBuffer);
	
	        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, initialDataOrSize, bufferUsage);
	
	        this.setIndexBuffer(null);
	
	        return indexBuffer;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#deleteTexture
	     * @since 3.0.0
	     *
	     * @param {WebGLTexture} texture - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} This WebGL Renderer.
	     */
	    deleteTexture: function (texture)
	    {
	        var index = this.nativeTextures.indexOf(texture);
	
	        if (index !== -1)
	        {
	            SpliceOne(this.nativeTextures, index);
	        }
	
	        this.gl.deleteTexture(texture);
	
	        return this;
	    },
	
	    /**
	     * Wrapper for deleting a raw WebGLFramebuffer
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#deleteFramebuffer
	     * @since 3.0.0
	     *
	     * @param {WebGLFramebuffer} framebuffer - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} This WebGL Renderer.
	     */
	    deleteFramebuffer: function (framebuffer)
	    {
	        this.gl.deleteFramebuffer(framebuffer);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#deleteProgram
	     * @since 3.0.0
	     *
	     * @param {WebGLProgram} program - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} This WebGL Renderer.
	     */
	    deleteProgram: function (program)
	    {
	        this.gl.deleteProgram(program);
	
	        return this;
	    },
	
	    /**
	     * Wrapper for deleting a vertex or index buffer
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#deleteBuffer
	     * @since 3.0.0
	     *
	     * @param {WebGLBuffer} vertexBuffer - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} This WebGL Renderer.
	     */
	    deleteBuffer: function (buffer)
	    {
	        this.gl.deleteBuffer(buffer);
	
	        return this;
	    },
	
	    /* Rendering Functions */
	
	    /**
	     * Handles any clipping needed by the camera and renders the background
	     * color if a color is visible.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#preRenderCamera
	     * @since 3.0.0
	     *
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     */
	    preRenderCamera: function (camera)
	    {
	        var resolution = this.config.resolution;
	
	        var cx = Math.floor(camera.x * resolution);
	        var cy = Math.floor(camera.y * resolution);
	        var cw = Math.floor(camera.width * resolution);
	        var ch = Math.floor(camera.height * resolution);
	
	        this.pushScissor(cx, cy, cw, ch);
	
	        if (camera.backgroundColor.alphaGL > 0)
	        {
	            var color = camera.backgroundColor;
	            var FlatTintPipeline = this.pipelines.FlatTintPipeline;
	
	            FlatTintPipeline.batchFillRect(
	                0, 0, 1, 1, 0,
	                camera.x, camera.y, camera.width, camera.height,
	                Utils.getTintFromFloats(color.redGL, color.greenGL, color.blueGL, 1.0),
	                color.alphaGL,
	                1, 0, 0, 1, 0, 0,
	                [ 1, 0, 0, 1, 0, 0 ]
	            );
	
	            FlatTintPipeline.flush();
	        }
	    },
	
	    /**
	     * Renders the foreground camera effects like flash and fading.
	     * It resets the current scissor state.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#postRenderCamera
	     * @since 3.0.0
	     *
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     */
	    postRenderCamera: function (camera)
	    {
	        var FlatTintPipeline = this.pipelines.FlatTintPipeline;
	
	        var isFlashing = camera.flashEffect.postRenderWebGL(FlatTintPipeline, Utils.getTintFromFloats);
	        var isFading = camera.fadeEffect.postRenderWebGL(FlatTintPipeline, Utils.getTintFromFloats);
	
	        if (isFading || isFlashing)
	        {
	            FlatTintPipeline.flush();
	        }
	
	        this.popScissor();
	    },
	
	    /**
	     * Clears the current vertex buffer and updates pipelines.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#preRender
	     * @since 3.0.0
	     */
	    preRender: function ()
	    {
	        if (this.contextLost) { return; }
	
	        var gl = this.gl;
	        var color = this.config.backgroundColor;
	        var pipelines = this.pipelines;
	
	        // Bind custom framebuffer here
	        gl.clearColor(color.redGL, color.greenGL, color.blueGL, color.alphaGL);
	
	        if (this.config.clearBeforeRender)
	        {
	            gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT | gl.STENCIL_BUFFER_BIT);
	        }
	
	        for (var key in pipelines)
	        {
	            pipelines[key].onPreRender();
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#render
	     * @since 3.0.0
	     *
	     * @param {Phaser.Scene} scene - [description]
	     * @param {Phaser.GameObjects.GameObject} children - [description]
	     * @param {number} interpolationPercentage - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     */
	    render: function (scene, children, interpolationPercentage, camera)
	    {
	        if (this.contextLost) { return; }
	
	        var list = children.list;
	        var childCount = list.length;
	        var pipelines = this.pipelines;
	
	        for (var key in pipelines)
	        {
	            pipelines[key].onRender(scene, camera);
	        }
	
	        this.preRenderCamera(camera);
	
	        for (var index = 0; index < childCount; ++index)
	        {
	            var child = list[index];
	
	            if (!child.willRender())
	            {
	                continue;
	            }
	
	            if (child.blendMode !== this.currentBlendMode)
	            {
	                this.setBlendMode(child.blendMode);
	            }
	
	            if (child.mask)
	            {
	                child.mask.preRenderWebGL(this, child, camera);
	            }
	
	            child.renderWebGL(this, child, interpolationPercentage, camera);
	
	            if (child.mask)
	            {
	                child.mask.postRenderWebGL(this, child);
	            }
	        }
	
	        this.flush();
	        this.setBlendMode(CONST.BlendModes.NORMAL);
	        this.postRenderCamera(camera);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#postRender
	     * @since 3.0.0
	     */
	    postRender: function ()
	    {
	        if (this.contextLost) { return; }
	
	        // Unbind custom framebuffer here
	
	        if (this.snapshotState.callback)
	        {
	            this.snapshotState.callback(WebGLSnapshot(this.canvas, this.snapshotState.type, this.snapshotState.encoder));
	            this.snapshotState.callback = null;
	        }
	
	        var pipelines = this.pipelines;
	
	        for (var key in pipelines)
	        {
	            pipelines[key].onPostRender();
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#snapshot
	     * @since 3.0.0
	     *
	     * @param {SnapshotCallback} callback - [description]
	     * @param {string} type - [description]
	     * @param {float} encoderOptions - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} [description]
	     */
	    snapshot: function (callback, type, encoderOptions)
	    {
	        this.snapshotState.callback = callback;
	        this.snapshotState.type = type;
	        this.snapshotState.encoder = encoderOptions;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#canvasToTexture
	     * @since 3.0.0
	     *
	     * @param {HTMLCanvasElement} srcCanvas - [description]
	     * @param {WebGLTexture} [dstTexture] - [description]
	     *
	     * @return {WebGLTexture} [description]
	     */
	    canvasToTexture: function (srcCanvas, dstTexture)
	    {
	        var gl = this.gl;
	
	        if (!dstTexture)
	        {
	            var wrapping = gl.CLAMP_TO_EDGE;
	
	            if (IsSizePowerOfTwo(srcCanvas.width, srcCanvas.height))
	            {
	                wrapping = gl.REPEAT;
	            }
	
	            dstTexture = this.createTexture2D(0, gl.NEAREST, gl.NEAREST, wrapping, wrapping, gl.RGBA, srcCanvas, srcCanvas.width, srcCanvas.height, true);
	        }
	        else
	        {
	            this.setTexture2D(dstTexture, 0);
	
	            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, srcCanvas);
	
	            dstTexture.width = srcCanvas.width;
	            dstTexture.height = srcCanvas.height;
	
	            this.setTexture2D(null, 0);
	        }
	
	        return dstTexture;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#setTextureFilter
	     * @since 3.0.0
	     *
	     * @param {integer} texture - [description]
	     * @param {integer} filter - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} [description]
	     */
	    setTextureFilter: function (texture, filter)
	    {
	        var gl = this.gl;
	        var glFilter = [ gl.LINEAR, gl.NEAREST ][filter];
	
	        this.setTexture2D(texture, 0);
	
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, glFilter);
	        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, glFilter);
	
	        this.setTexture2D(null, 0);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#setFloat1
	     * @since 3.0.0
	     *
	     * @param {WebGLProgram} program - [description]
	     * @param {string} name - [description]
	     * @param {float} x - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} [description]
	     */
	    setFloat1: function (program, name, x)
	    {
	        this.setProgram(program);
	
	        this.gl.uniform1f(this.gl.getUniformLocation(program, name), x);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#setFloat2
	     * @since 3.0.0
	     *
	     * @param {WebGLProgram} program - [description]
	     * @param {string} name - [description]
	     * @param {float} x - [description]
	     * @param {float} y - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} [description]
	     */
	    setFloat2: function (program, name, x, y)
	    {
	        this.setProgram(program);
	
	        this.gl.uniform2f(this.gl.getUniformLocation(program, name), x, y);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#setFloat3
	     * @since 3.0.0
	     *
	     * @param {WebGLProgram} program - [description]
	     * @param {string} name - [description]
	     * @param {float} x - [description]
	     * @param {float} y - [description]
	     * @param {float} z - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} [description]
	     */
	    setFloat3: function (program, name, x, y, z)
	    {
	        this.setProgram(program);
	
	        this.gl.uniform3f(this.gl.getUniformLocation(program, name), x, y, z);
	
	        return this;
	    },
	
	    /**
	     * Sets uniform of a WebGLProgram
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#setFloat4
	     * @since 3.0.0
	     *
	     * @param {WebGLProgram} program - Target program
	     * @param {string} name - Name of the uniform
	     * @param {float} x - X component
	     * @param {float} y - Y component
	     * @param {float} z - Z component
	     * @param {float} w - W component
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} [description]
	     */
	    setFloat4: function (program, name, x, y, z, w)
	    {
	        this.setProgram(program);
	
	        this.gl.uniform4f(this.gl.getUniformLocation(program, name), x, y, z, w);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#setInt1
	     * @since 3.0.0
	     *
	     * @param {WebGLProgram} program - [description]
	     * @param {string} name - [description]
	     * @param {integer} x - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} [description]
	     */
	    setInt1: function (program, name, x)
	    {
	        this.setProgram(program);
	
	        this.gl.uniform1i(this.gl.getUniformLocation(program, name), x);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#setInt2
	     * @since 3.0.0
	     *
	     * @param {WebGLProgram} program - [description]
	     * @param {string} name - [description]
	     * @param {integer} x - [description]
	     * @param {integer} y - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} [description]
	     */
	    setInt2: function (program, name, x, y)
	    {
	        this.setProgram(program);
	
	        this.gl.uniform2i(this.gl.getUniformLocation(program, name), x, y);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#setInt3
	     * @since 3.0.0
	     *
	     * @param {WebGLProgram} program - [description]
	     * @param {string} name - [description]
	     * @param {integer} x - [description]
	     * @param {integer} y - [description]
	     * @param {integer} z - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} [description]
	     */
	    setInt3: function (program, name, x, y, z)
	    {
	        this.setProgram(program);
	
	        this.gl.uniform3i(this.gl.getUniformLocation(program, name), x, y, z);
	
	        return this;
	    },
	
	    /**
	     * Sets uniform of a WebGLProgram
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#setInt4
	     * @since 3.0.0
	     *
	     * @param {WebGLProgram} program - Target Program
	     * @param {string} name - Name of the uniform
	     * @param {integer} x - X component
	     * @param {integer} y - Y component
	     * @param {integer} z - Z component
	     * @param {integer} w - W component
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} [description]
	     */
	    setInt4: function (program, name, x, y, z, w)
	    {
	        this.setProgram(program);
	
	        this.gl.uniform4i(this.gl.getUniformLocation(program, name), x, y, z, w);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#setMatrix2
	     * @since 3.0.0
	     *
	     * @param {WebGLProgram} program - [description]
	     * @param {string} name - [description]
	     * @param {boolean} transpose - [description]
	     * @param {Float32Array} matrix - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} [description]
	     */
	    setMatrix2: function (program, name, transpose, matrix)
	    {
	        this.setProgram(program);
	
	        this.gl.uniformMatrix2fv(this.gl.getUniformLocation(program, name), transpose, matrix);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#setMatrix3
	     * @since 3.0.0
	     *
	     * @param {WebGLProgram} program - [description]
	     * @param {string} name - [description]
	     * @param {boolean} transpose - [description]
	     * @param {Float32Array} matrix - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} [description]
	     */
	    setMatrix3: function (program, name, transpose, matrix)
	    {
	        this.setProgram(program);
	
	        this.gl.uniformMatrix3fv(this.gl.getUniformLocation(program, name), transpose, matrix);
	
	        return this;
	    },
	
	    /**
	     * Sets uniform of a WebGLProgram
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#setMatrix4
	     * @since 3.0.0
	     *
	     * @param {WebGLProgram} program - Target program
	     * @param {string} name - Name of the uniform
	     * @param {boolean} transpose - Is the matrix transposed
	     * @param {Float32Array} matrix - Matrix data
	     *
	     * @return {Phaser.Renderer.WebGL.WebGLRenderer} [description]
	     */
	    setMatrix4: function (program, name, transpose, matrix)
	    {
	        this.setProgram(program);
	
	        this.gl.uniformMatrix4fv(this.gl.getUniformLocation(program, name), transpose, matrix);
	
	        return this;
	    },
	
	    /**
	     * Returns the maximum number of texture units that can be used in a fragment shader.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#getMaxTextures
	     * @since 3.8.0
	     *
	     * @return {integer} The maximum number of textures WebGL supports.
	     */
	    getMaxTextures: function ()
	    {
	        return this.config.maxTextures;
	    },
	
	    /**
	     * Returns the largest texture size (either width or height) that can be created.
	     * Note that VRAM may not allow a texture of any given size, it just expresses
	     * hardware / driver support for a given size.
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#getMaxTextureSize
	     * @since 3.8.0
	     *
	     * @return {integer} ...
	     */
	    getMaxTextureSize: function ()
	    {
	        return this.config.maxTextureSize;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.WebGLRenderer#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        //  Clear-up anything that should be cleared :)
	        for (var key in this.pipelines)
	        {
	            this.pipelines[key].destroy();
	
	            delete this.pipelines[key];
	        }
	
	        for (var index = 0; index < this.nativeTextures.length; ++index)
	        {
	            this.deleteTexture(this.nativeTextures[index]);
	
	            delete this.nativeTextures[index];
	        }
	
	        delete this.gl;
	        delete this.game;
	
	        this.contextLost = true;
	        this.extensions = {};
	        this.nativeTextures.length = 0;
	    }
	
	});
	
	module.exports = WebGLRenderer;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Felipe Alfonso <@bitnenfer>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var ShaderSourceFS = __webpack_require__(1506);
	var ShaderSourceVS = __webpack_require__(1507);
	var WebGLPipeline = __webpack_require__(207);
	
	/**
	 * @classdesc
	 * BitmapMaskPipeline handles all bitmap masking rendering in WebGL. It works by using 
	 * sampling two texture on the fragment shader and using the fragment's alpha to clip the region.
	 * The config properties are:
	 * - game: Current game instance.
	 * - renderer: Current WebGL renderer.
	 * - topology: This indicates how the primitives are rendered. The default value is GL_TRIANGLES.
	 *              Here is the full list of rendering primitives (https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/Constants).
	 * - vertShader: Source for vertex shader as a string.
	 * - fragShader: Source for fragment shader as a string.
	 * - vertexCapacity: The amount of vertices that shall be allocated
	 * - vertexSize: The size of a single vertex in bytes.
	 *
	 * @class BitmapMaskPipeline
	 * @extends Phaser.Renderer.WebGL.WebGLPipeline
	 * @memberOf Phaser.Renderer.WebGL.Pipelines
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {object} config - Used for overriding shader an pipeline properties if extending this pipeline.
	 */
	var BitmapMaskPipeline = new Class({
	
	    Extends: WebGLPipeline,
	    
	    initialize:
	
	    function BitmapMaskPipeline (config)
	    {
	        WebGLPipeline.call(this, {
	            game: config.game,
	            renderer: config.renderer,
	            gl: config.renderer.gl,
	            topology: (config.topology ? config.topology : config.renderer.gl.TRIANGLES),
	            vertShader: (config.vertShader ? config.vertShader : ShaderSourceVS),
	            fragShader: (config.fragShader ? config.fragShader : ShaderSourceFS),
	            vertexCapacity: (config.vertexCapacity ? config.vertexCapacity : 3),
	
	            vertexSize: (config.vertexSize ? config.vertexSize :
	                Float32Array.BYTES_PER_ELEMENT * 2),
	
	            vertices: new Float32Array([
	                -1, +1, -1, -7, +7, +1
	            ]).buffer,
	
	            attributes: [
	                {
	                    name: 'inPosition',
	                    size: 2,
	                    type: config.renderer.gl.FLOAT,
	                    normalized: false,
	                    offset: 0
	                }
	            ]
	        });
	
	        /**
	         * Float32 view of the array buffer containing the pipeline's vertices.
	         *
	         * @name Phaser.Renderer.WebGL.Pipelines.BitmapMaskPipeline#vertexViewF32
	         * @type {Float32Array}
	         * @since 3.0.0
	         */
	        this.vertexViewF32 = new Float32Array(this.vertexData);
	
	        /**
	         * Size of the batch.
	         *
	         * @name Phaser.Renderer.WebGL.Pipelines.BitmapMaskPipeline#maxQuads
	         * @type {number}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.maxQuads = 1;
	
	        /**
	         * Dirty flag to check if resolution properties need to be updated on the 
	         * masking shader.
	         *
	         * @name Phaser.Renderer.WebGL.Pipelines.BitmapMaskPipeline#resolutionDirty
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.resolutionDirty = true;
	    },
	
	    /**
	     * Called every time the pipeline needs to be used.
	     * It binds all necessary resources.
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.BitmapMaskPipeline#onBind
	     * @since 3.0.0
	     *
	     * @return {Phaser.Renderer.WebGL.Pipelines.BitmapMaskPipeline} [description]
	     */
	    onBind: function ()
	    {
	        WebGLPipeline.prototype.onBind.call(this);
	
	        var renderer = this.renderer;
	        var program = this.program;
	        
	        if (this.resolutionDirty)
	        {
	            renderer.setFloat2(program, 'uResolution', this.width, this.height);
	            renderer.setInt1(program, 'uMainSampler', 0);
	            renderer.setInt1(program, 'uMaskSampler', 1);
	            this.resolutionDirty = false;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.BitmapMaskPipeline#resize
	     * @since 3.0.0
	     *
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     * @param {number} resolution - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.Pipelines.BitmapMaskPipeline} [description]
	     */
	    resize: function (width, height, resolution)
	    {
	        WebGLPipeline.prototype.resize.call(this, width, height, resolution);
	        this.resolutionDirty = true;
	        return this;
	    },
	
	    /**
	     * Binds necessary resources and renders the mask to a separated framebuffer.
	     * The framebuffer for the masked object is also bound for further use.
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.BitmapMaskPipeline#beginMask
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} mask - GameObject used as mask.
	     * @param {Phaser.GameObjects.GameObject} maskedObject - GameObject masked by the mask GameObject.
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     */
	    beginMask: function (mask, maskedObject, camera)
	    {
	        var bitmapMask = mask.bitmapMask;
	        var renderer = this.renderer;
	        var gl = this.gl;
	        var visible = bitmapMask.visible;
	
	        if (bitmapMask && gl)
	        {
	            // First we clear the mask framebuffer
	            renderer.setFramebuffer(mask.maskFramebuffer);
	            gl.clearColor(0, 0, 0, 0);
	            gl.clear(gl.COLOR_BUFFER_BIT);
	
	            // We render out mask source
	            bitmapMask.visible = true;
	            bitmapMask.renderWebGL(renderer, bitmapMask, 0.0, camera);
	            bitmapMask.visible = visible;
	            renderer.flush();
	
	            // Bind and clear our main source (masked object)
	            renderer.setFramebuffer(mask.mainFramebuffer);
	            gl.clearColor(0, 0, 0, 0);
	            gl.clear(gl.COLOR_BUFFER_BIT);
	        }
	    },
	
	    /**
	     * The masked game object's framebuffer is unbound and it's texture 
	     * is bound together with the mask texture and the mask shader and 
	     * a draw call with a single quad is processed. Here is where the
	     * masking effect is applied.  
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.BitmapMaskPipeline#endMask
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} mask - GameObject used as a mask.
	     */
	    endMask: function (mask)
	    {
	        var bitmapMask = mask.bitmapMask;
	        var renderer = this.renderer;
	        var gl = this.gl;
	
	        if (bitmapMask)
	        {
	            // Return to default framebuffer
	            renderer.setFramebuffer(null);
	            
	            // Bind bitmap mask pipeline and draw
	            renderer.setPipeline(this);
	            
	            renderer.setTexture2D(mask.maskTexture, 1);
	            renderer.setTexture2D(mask.mainTexture, 0);
	            renderer.setInt1(this.program, 'uInvertMaskAlpha', mask.invertAlpha);
	
	            // Finally draw a triangle filling the whole screen
	            gl.drawArrays(this.topology, 0, 3);
	        }
	    }
	
	});
	
	module.exports = BitmapMaskPipeline;


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Felipe Alfonso <@bitnenfer>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Commands = __webpack_require__(278);
	var Earcut = __webpack_require__(518);
	var ModelViewProjection = __webpack_require__(621);
	var ShaderSourceFS = __webpack_require__(1508);
	var ShaderSourceVS = __webpack_require__(1509);
	var Utils = __webpack_require__(87);
	var WebGLPipeline = __webpack_require__(207);
	
	var Point = function (x, y, width, rgb, alpha)
	{
	    this.x = x;
	    this.y = y;
	    this.width = width;
	    this.rgb = rgb;
	    this.alpha = alpha;
	};
	
	var Path = function (x, y, width, rgb, alpha)
	{
	    this.points = [];
	    this.pointsLength = 1;
	    this.points[0] = new Point(x, y, width, rgb, alpha);
	};
	
	var currentMatrix = new Float32Array([ 1, 0, 0, 1, 0, 0 ]);
	var matrixStack = new Float32Array(6 * 1000);
	var matrixStackLength = 0;
	var pathArray = [];
	
	/**
	 * @classdesc
	 * The FlatTintPipeline is used for rendering flat colored shapes. 
	 * Mostly used by the Graphics game object.
	 * The config properties are:
	 * - game: Current game instance.
	 * - renderer: Current WebGL renderer.
	 * - topology: This indicates how the primitives are rendered. The default value is GL_TRIANGLES.
	 *              Here is the full list of rendering primitives (https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/Constants).
	 * - vertShader: Source for vertex shader as a string.
	 * - fragShader: Source for fragment shader as a string.
	 * - vertexCapacity: The amount of vertices that shall be allocated
	 * - vertexSize: The size of a single vertex in bytes.
	 *
	 * @class FlatTintPipeline
	 * @extends Phaser.Renderer.WebGL.WebGLPipeline
	 * @memberOf Phaser.Renderer.WebGL.Pipelines
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {object} config - Used for overriding shader an pipeline properties if extending this pipeline.
	 */
	var FlatTintPipeline = new Class({
	
	    Extends: WebGLPipeline,
	
	    Mixins: [
	        ModelViewProjection
	    ],
	
	    initialize:
	
	    function FlatTintPipeline (config)
	    {
	        WebGLPipeline.call(this, {
	            game: config.game,
	            renderer: config.renderer,
	            gl: config.renderer.gl,
	            topology: (config.topology ? config.topology : config.renderer.gl.TRIANGLES),
	            vertShader: (config.vertShader ? config.vertShader : ShaderSourceVS),
	            fragShader: (config.fragShader ? config.fragShader : ShaderSourceFS),
	            vertexCapacity: (config.vertexCapcity ? config.vertexCapacity : 12000),
	
	            vertexSize: (config.vertexSize ? config.vertexSize :
	                Float32Array.BYTES_PER_ELEMENT * 2 +
	                Uint8Array.BYTES_PER_ELEMENT * 4),
	
	            attributes: [
	                {
	                    name: 'inPosition',
	                    size: 2,
	                    type: config.renderer.gl.FLOAT,
	                    normalized: false,
	                    offset: 0
	                },
	                {
	                    name: 'inTint',
	                    size: 4,
	                    type: config.renderer.gl.UNSIGNED_BYTE,
	                    normalized: true,
	                    offset: Float32Array.BYTES_PER_ELEMENT * 2
	                }
	            ]
	        });
	
	        /**
	         * Float32 view of the array buffer containing the pipeline's vertices.
	         *
	         * @name Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#vertexViewF32
	         * @type {Float32Array}
	         * @since 3.0.0
	         */
	        this.vertexViewF32 = new Float32Array(this.vertexData);
	
	        /**
	         * Uint32 view of the array buffer containing the pipeline's vertices.
	         *
	         * @name Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#vertexViewU32
	         * @type {Uint32Array}
	         * @since 3.0.0
	         */
	        this.vertexViewU32 = new Uint32Array(this.vertexData);
	
	        /**
	         * Used internally to draw triangles
	         *
	         * @name Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#tempTriangle
	         * @type {array}
	         * @since 3.0.0
	         */
	        this.tempTriangle = [
	            {x: 0, y: 0, width: 0, rgb: 0xFFFFFF, alpha: 1.0},
	            {x: 0, y: 0, width: 0, rgb: 0xFFFFFF, alpha: 1.0},
	            {x: 0, y: 0, width: 0, rgb: 0xFFFFFF, alpha: 1.0},
	            {x: 0, y: 0, width: 0, rgb: 0xFFFFFF, alpha: 1.0}
	        ];
	
	        /**
	         * Used internally by for triangulating a polyong
	         *
	         * @name Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#polygonCache
	         * @type {array}
	         * @default []
	         * @since 3.0.0
	         */
	        this.polygonCache = [];
	
	        this.mvpInit();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#onBind
	     * @since 3.0.0
	     *
	     * @return {Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline} [description]
	     */
	    onBind: function ()
	    {
	        WebGLPipeline.prototype.onBind.call(this);
	        this.mvpUpdate();
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#resize
	     * @since 3.0.0
	     *
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     * @param {number} resolution - [description]
	     *
	     * @return {Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline} [description]
	     */
	    resize: function (width, height, resolution)
	    {
	        WebGLPipeline.prototype.resize.call(this, width, height, resolution);
	        this.projOrtho(0, this.width, this.height, 0, -1000.0, 1000.0);
	        
	        return this;
	    },
	
	    /**
	     * Pushes a rectangle into the vertex batch
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#batchFillRect
	     * @since 3.0.0
	     *
	     * @param {float} srcX - Graphics horizontal component for translation
	     * @param {float} srcY - Graphics vertical component for translation
	     * @param {float} srcScaleX - Graphics horizontal component for scale
	     * @param {float} srcScaleY - Graphics vertical component for scale
	     * @param {float} srcRotation - Graphics rotation
	     * @param {float} x - Horiztonal top left coordinate of the rectangle
	     * @param {float} y - Vertical top left coordinate of the rectangle
	     * @param {float} width - Width of the rectangle
	     * @param {float} height - Height of the rectangle
	     * @param {integer} fillColor - RGB color packed as a uint
	     * @param {float} fillAlpha - Alpha represented as float
	     * @param {float} a1 - Matrix stack top a component
	     * @param {float} b1 - Matrix stack top b component
	     * @param {float} c1 - Matrix stack top c component
	     * @param {float} d1 - Matrix stack top d component
	     * @param {float} e1 - Matrix stack top e component
	     * @param {float} f1 - Matrix stack top f component
	     * @param {Float32Array} currentMatrix - Parent matrix, generally used by containers
	     */
	    batchFillRect: function (srcX, srcY, srcScaleX, srcScaleY, srcRotation, x, y, width, height, fillColor, fillAlpha, a1, b1, c1, d1, e1, f1, currentMatrix)
	    {
	        this.renderer.setPipeline(this);
	
	        if (this.vertexCount + 6 > this.vertexCapacity)
	        {
	            this.flush();
	        }
	        
	        var vertexViewF32 = this.vertexViewF32;
	        var vertexViewU32 = this.vertexViewU32;
	        var vertexOffset = this.vertexCount * this.vertexComponentCount;
	        var xw = x + width;
	        var yh = y + height;
	        var a0 = currentMatrix[0];
	        var b0 = currentMatrix[1];
	        var c0 = currentMatrix[2];
	        var d0 = currentMatrix[3];
	        var e0 = currentMatrix[4];
	        var f0 = currentMatrix[5];
	        var a = a1 * a0 + b1 * c0;
	        var b = a1 * b0 + b1 * d0;
	        var c = c1 * a0 + d1 * c0;
	        var d = c1 * b0 + d1 * d0;
	        var e = e1 * a0 + f1 * c0 + e0;
	        var f = e1 * b0 + f1 * d0 + f0;
	        var tx0 = x * a + y * c + e;
	        var ty0 = x * b + y * d + f;
	        var tx1 = x * a + yh * c + e;
	        var ty1 = x * b + yh * d + f;
	        var tx2 = xw * a + yh * c + e;
	        var ty2 = xw * b + yh * d + f;
	        var tx3 = xw * a + y * c + e;
	        var ty3 = xw * b + y * d + f;
	        var tint = Utils.getTintAppendFloatAlphaAndSwap(fillColor, fillAlpha);
	
	        vertexViewF32[vertexOffset + 0] = tx0;
	        vertexViewF32[vertexOffset + 1] = ty0;
	        vertexViewU32[vertexOffset + 2] = tint;
	        vertexViewF32[vertexOffset + 3] = tx1;
	        vertexViewF32[vertexOffset + 4] = ty1;
	        vertexViewU32[vertexOffset + 5] = tint;
	        vertexViewF32[vertexOffset + 6] = tx2;
	        vertexViewF32[vertexOffset + 7] = ty2;
	        vertexViewU32[vertexOffset + 8] = tint;
	        vertexViewF32[vertexOffset + 9] = tx0;
	        vertexViewF32[vertexOffset + 10] = ty0;
	        vertexViewU32[vertexOffset + 11] = tint;
	        vertexViewF32[vertexOffset + 12] = tx2;
	        vertexViewF32[vertexOffset + 13] = ty2;
	        vertexViewU32[vertexOffset + 14] = tint;
	        vertexViewF32[vertexOffset + 15] = tx3;
	        vertexViewF32[vertexOffset + 16] = ty3;
	        vertexViewU32[vertexOffset + 17] = tint;
	
	        this.vertexCount += 6;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#batchFillTriangle
	     * @since 3.0.0
	     *
	     * @param {float} srcX - Graphics horizontal component for translation
	     * @param {float} srcY - Graphics vertical component for translation
	     * @param {float} srcScaleX - Graphics horizontal component for scale
	     * @param {float} srcScaleY - Graphics vertical component for scale
	     * @param {float} srcRotation - Graphics rotation
	     * @param {float} x0 - Point 0 x coordinate
	     * @param {float} y0 - Point 0 y coordinate
	     * @param {float} x1 - Point 1 x coordinate
	     * @param {float} y1 - Point 1 y coordinate
	     * @param {float} x2 - Point 2 x coordinate
	     * @param {float} y2 - Point 2 y coordinate
	     * @param {integer} fillColor - RGB color packed as a uint
	     * @param {float} fillAlpha - Alpha represented as float
	     * @param {float} a1 - Matrix stack top a component
	     * @param {float} b1 - Matrix stack top b component
	     * @param {float} c1 - Matrix stack top c component
	     * @param {float} d1 - Matrix stack top d component
	     * @param {float} e1 - Matrix stack top e component
	     * @param {float} f1 - Matrix stack top f component
	     * @param {Float32Array} currentMatrix - Parent matrix, generally used by containers
	     */
	    batchFillTriangle: function (srcX, srcY, srcScaleX, srcScaleY, srcRotation, x0, y0, x1, y1, x2, y2, fillColor, fillAlpha, a1, b1, c1, d1, e1, f1, currentMatrix)
	    {
	        this.renderer.setPipeline(this);
	
	        if (this.vertexCount + 3 > this.vertexCapacity)
	        {
	            this.flush();
	        }
	
	        var vertexViewF32 = this.vertexViewF32;
	        var vertexViewU32 = this.vertexViewU32;
	        var vertexOffset = this.vertexCount * this.vertexComponentCount;
	        var a0 = currentMatrix[0];
	        var b0 = currentMatrix[1];
	        var c0 = currentMatrix[2];
	        var d0 = currentMatrix[3];
	        var e0 = currentMatrix[4];
	        var f0 = currentMatrix[5];
	        var a = a1 * a0 + b1 * c0;
	        var b = a1 * b0 + b1 * d0;
	        var c = c1 * a0 + d1 * c0;
	        var d = c1 * b0 + d1 * d0;
	        var e = e1 * a0 + f1 * c0 + e0;
	        var f = e1 * b0 + f1 * d0 + f0;
	        var tx0 = x0 * a + y0 * c + e;
	        var ty0 = x0 * b + y0 * d + f;
	        var tx1 = x1 * a + y1 * c + e;
	        var ty1 = x1 * b + y1 * d + f;
	        var tx2 = x2 * a + y2 * c + e;
	        var ty2 = x2 * b + y2 * d + f;
	        var tint = Utils.getTintAppendFloatAlphaAndSwap(fillColor, fillAlpha);
	
	        vertexViewF32[vertexOffset + 0] = tx0;
	        vertexViewF32[vertexOffset + 1] = ty0;
	        vertexViewU32[vertexOffset + 2] = tint;
	        vertexViewF32[vertexOffset + 3] = tx1;
	        vertexViewF32[vertexOffset + 4] = ty1;
	        vertexViewU32[vertexOffset + 5] = tint;
	        vertexViewF32[vertexOffset + 6] = tx2;
	        vertexViewF32[vertexOffset + 7] = ty2;
	        vertexViewU32[vertexOffset + 8] = tint;
	
	        this.vertexCount += 3;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#batchStrokeTriangle
	     * @since 3.0.0
	     *
	     * @param {float} srcX - Graphics horizontal component for translation
	     * @param {float} srcY - Graphics vertical component for translation
	     * @param {float} srcScaleX - Graphics horizontal component for scale
	     * @param {float} srcScaleY - Graphics vertical component for scale
	     * @param {float} srcRotation - Graphics rotation
	     * @param {float} x0 - [description]
	     * @param {float} y0 - [description]
	     * @param {float} x1 - [description]
	     * @param {float} y1 - [description]
	     * @param {float} x2 - [description]
	     * @param {float} y2 - [description]
	     * @param {float} lineWidth - Size of the line as a float value
	     * @param {integer} lineColor - RGB color packed as a uint
	     * @param {float} lineAlpha - Alpha represented as float
	     * @param {float} a - Matrix stack top a component
	     * @param {float} b - Matrix stack top b component
	     * @param {float} c - Matrix stack top c component
	     * @param {float} d - Matrix stack top d component
	     * @param {float} e - Matrix stack top e component
	     * @param {float} f - Matrix stack top f component
	     * @param {Float32Array} currentMatrix - Parent matrix, generally used by containers
	     */
	    batchStrokeTriangle: function (srcX, srcY, srcScaleX, srcScaleY, srcRotation, x0, y0, x1, y1, x2, y2, lineWidth, lineColor, lineAlpha, a, b, c, d, e, f, currentMatrix)
	    {
	        var tempTriangle = this.tempTriangle;
	
	        tempTriangle[0].x = x0;
	        tempTriangle[0].y = y0;
	        tempTriangle[0].width = lineWidth;
	        tempTriangle[0].rgb = lineColor;
	        tempTriangle[0].alpha = lineAlpha;
	        tempTriangle[1].x = x1;
	        tempTriangle[1].y = y1;
	        tempTriangle[1].width = lineWidth;
	        tempTriangle[1].rgb = lineColor;
	        tempTriangle[1].alpha = lineAlpha;
	        tempTriangle[2].x = x2;
	        tempTriangle[2].y = y2;
	        tempTriangle[2].width = lineWidth;
	        tempTriangle[2].rgb = lineColor;
	        tempTriangle[2].alpha = lineAlpha;
	        tempTriangle[3].x = x0;
	        tempTriangle[3].y = y0;
	        tempTriangle[3].width = lineWidth;
	        tempTriangle[3].rgb = lineColor;
	        tempTriangle[3].alpha = lineAlpha;
	
	        this.batchStrokePath(
	            srcX, srcY, srcScaleX, srcScaleY, srcRotation,
	            tempTriangle, lineWidth, lineColor, lineAlpha,
	            a, b, c, d, e, f,
	            false,
	            currentMatrix
	        );
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#batchFillPath
	     * @since 3.0.0
	     *
	     * @param {float} srcX - Graphics horizontal component for translation
	     * @param {float} srcY - Graphics vertical component for translation
	     * @param {float} srcScaleX - Graphics horizontal component for scale
	     * @param {float} srcScaleY - Graphics vertical component for scale
	     * @param {float} srcRotation - Graphics rotation
	     * @param {float} path - Collection of points that represent the path
	     * @param {integer} fillColor - RGB color packed as a uint
	     * @param {float} fillAlpha - Alpha represented as float
	     * @param {float} a1 - Matrix stack top a component
	     * @param {float} b1 - Matrix stack top b component
	     * @param {float} c1 - Matrix stack top c component
	     * @param {float} d1 - Matrix stack top d component
	     * @param {float} e1 - Matrix stack top e component
	     * @param {float} f1 - Matrix stack top f component
	     * @param {Float32Array} currentMatrix - Parent matrix, generally used by containers
	     */
	    batchFillPath: function (srcX, srcY, srcScaleX, srcScaleY, srcRotation, path, fillColor, fillAlpha, a1, b1, c1, d1, e1, f1, currentMatrix)
	    {
	        this.renderer.setPipeline(this);
	
	        var length = path.length;
	        var polygonCache = this.polygonCache;
	        var polygonIndexArray;
	        var point;
	        var v0, v1, v2;
	        var vertexViewF32 = this.vertexViewF32;
	        var vertexViewU32 = this.vertexViewU32;
	        var vertexOffset = 0;
	        var x0, y0, x1, y1, x2, y2;
	        var tx0, ty0, tx1, ty1, tx2, ty2;
	        var a0 = currentMatrix[0];
	        var b0 = currentMatrix[1];
	        var c0 = currentMatrix[2];
	        var d0 = currentMatrix[3];
	        var e0 = currentMatrix[4];
	        var f0 = currentMatrix[5];
	        var a = a1 * a0 + b1 * c0;
	        var b = a1 * b0 + b1 * d0;
	        var c = c1 * a0 + d1 * c0;
	        var d = c1 * b0 + d1 * d0;
	        var e = e1 * a0 + f1 * c0 + e0;
	        var f = e1 * b0 + f1 * d0 + f0;
	        var tint = Utils.getTintAppendFloatAlphaAndSwap(fillColor, fillAlpha);
	
	        for (var pathIndex = 0; pathIndex < length; ++pathIndex)
	        {
	            point = path[pathIndex];
	            polygonCache.push(point.x, point.y);
	        }
	
	        polygonIndexArray = Earcut(polygonCache);
	        length = polygonIndexArray.length;
	
	        for (var index = 0; index < length; index += 3)
	        {
	            v0 = polygonIndexArray[index + 0] * 2;
	            v1 = polygonIndexArray[index + 1] * 2;
	            v2 = polygonIndexArray[index + 2] * 2;
	
	            if (this.vertexCount + 3 > this.vertexCapacity)
	            {
	                this.flush();
	            }
	
	            vertexOffset = this.vertexCount * this.vertexComponentCount;
	
	            x0 = polygonCache[v0 + 0];
	            y0 = polygonCache[v0 + 1];
	            x1 = polygonCache[v1 + 0];
	            y1 = polygonCache[v1 + 1];
	            x2 = polygonCache[v2 + 0];
	            y2 = polygonCache[v2 + 1];
	
	            tx0 = x0 * a + y0 * c + e;
	            ty0 = x0 * b + y0 * d + f;
	            tx1 = x1 * a + y1 * c + e;
	            ty1 = x1 * b + y1 * d + f;
	            tx2 = x2 * a + y2 * c + e;
	            ty2 = x2 * b + y2 * d + f;
	
	            vertexViewF32[vertexOffset + 0] = tx0;
	            vertexViewF32[vertexOffset + 1] = ty0;
	            vertexViewU32[vertexOffset + 2] = tint;
	            vertexViewF32[vertexOffset + 3] = tx1;
	            vertexViewF32[vertexOffset + 4] = ty1;
	            vertexViewU32[vertexOffset + 5] = tint;
	            vertexViewF32[vertexOffset + 6] = tx2;
	            vertexViewF32[vertexOffset + 7] = ty2;
	            vertexViewU32[vertexOffset + 8] = tint;
	
	            this.vertexCount += 3;
	        }
	
	        polygonCache.length = 0;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#batchStrokePath
	     * @since 3.0.0
	     *
	     * @param {float} srcX - Graphics horizontal component for translation
	     * @param {float} srcY - Graphics vertical component for translation
	     * @param {float} srcScaleX - Graphics horizontal component for scale
	     * @param {float} srcScaleY - Graphics vertical component for scale
	     * @param {float} srcRotation - Graphics rotation
	     * @param {array} path - [description]
	     * @param {float} lineWidth - [description]
	     * @param {integer} lineColor - RGB color packed as a uint
	     * @param {float} lineAlpha - Alpha represented as float
	     * @param {float} a - Matrix stack top a component
	     * @param {float} b - Matrix stack top b component
	     * @param {float} c - Matrix stack top c component
	     * @param {float} d - Matrix stack top d component
	     * @param {float} e - Matrix stack top e component
	     * @param {float} f - Matrix stack top f component
	     * @param {boolean} isLastPath - Indicates if the path should be closed
	     * @param {Float32Array} currentMatrix - Parent matrix, generally used by containers
	     */
	    batchStrokePath: function (srcX, srcY, srcScaleX, srcScaleY, srcRotation, path, lineWidth, lineColor, lineAlpha, a, b, c, d, e, f, isLastPath, currentMatrix)
	    {
	        this.renderer.setPipeline(this);
	
	        var point0, point1;
	        var pathLength = path.length;
	        var polylines = this.polygonCache;
	        var last, curr;
	        var vertexViewF32 = this.vertexViewF32;
	        var vertexViewU32 = this.vertexViewU32;
	        var vertexOffset;
	        var line;
	        var getTint = Utils.getTintAppendFloatAlphaAndSwap;
	
	        for (var pathIndex = 0; pathIndex + 1 < pathLength; pathIndex += 1)
	        {
	            point0 = path[pathIndex];
	            point1 = path[pathIndex + 1];
	
	            line = this.batchLine(
	                srcX, srcY, srcScaleX, srcScaleY, srcRotation,
	                point0.x, point0.y,
	                point1.x, point1.y,
	                point0.width / 2, point1.width / 2,
	                point0.rgb, point1.rgb, lineAlpha,
	                a, b, c, d, e, f,
	                currentMatrix
	            );
	
	            polylines.push(line);
	        }
	
	        /* Render joints */
	        for (var index = 1, polylinesLength = polylines.length; index < polylinesLength; ++index)
	        {
	            if (this.vertexCount + 6 > this.vertexCapacity)
	            {
	                this.flush();
	            }
	
	            last = polylines[index - 1] || polylines[polylinesLength - 1];
	            curr = polylines[index];
	            vertexOffset = this.vertexCount * this.vertexComponentCount;
	
	            vertexViewF32[vertexOffset + 0] = last[3 * 2 + 0];
	            vertexViewF32[vertexOffset + 1] = last[3 * 2 + 1];
	            vertexViewU32[vertexOffset + 2] = getTint(last[3 * 2 + 2], lineAlpha);
	            vertexViewF32[vertexOffset + 3] = last[3 * 0 + 0];
	            vertexViewF32[vertexOffset + 4] = last[3 * 0 + 1];
	            vertexViewU32[vertexOffset + 5] = getTint(last[3 * 0 + 2], lineAlpha);
	            vertexViewF32[vertexOffset + 6] = curr[3 * 3 + 0];
	            vertexViewF32[vertexOffset + 7] = curr[3 * 3 + 1];
	            vertexViewU32[vertexOffset + 8] = getTint(curr[3 * 3 + 2], lineAlpha);
	            vertexViewF32[vertexOffset + 9] = last[3 * 0 + 0];
	            vertexViewF32[vertexOffset + 10] = last[3 * 0 + 1];
	            vertexViewU32[vertexOffset + 11] = getTint(last[3 * 0 + 2], lineAlpha);
	            vertexViewF32[vertexOffset + 12] = last[3 * 2 + 0];
	            vertexViewF32[vertexOffset + 13] = last[3 * 2 + 1];
	            vertexViewU32[vertexOffset + 14] = getTint(last[3 * 2 + 2], lineAlpha);
	            vertexViewF32[vertexOffset + 15] = curr[3 * 1 + 0];
	            vertexViewF32[vertexOffset + 16] = curr[3 * 1 + 1];
	            vertexViewU32[vertexOffset + 17] = getTint(curr[3 * 1 + 2], lineAlpha);
	
	            this.vertexCount += 6;
	        }
	
	        polylines.length = 0;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#batchLine
	     * @since 3.0.0
	     *
	     * @param {float} srcX - Graphics horizontal component for translation
	     * @param {float} srcY - Graphics vertical component for translation
	     * @param {float} srcScaleX - Graphics horizontal component for scale
	     * @param {float} srcScaleY - Graphics vertical component for scale
	     * @param {float} srcRotation - Graphics rotation
	     * @param {float} ax - X coordinate to the start of the line
	     * @param {float} ay - Y coordinate to the start of the line
	     * @param {float} bx - X coordinate to the end of the line
	     * @param {float} by - Y coordinate to the end of the line
	     * @param {float} aLineWidth - Width of the start of the line
	     * @param {float} bLineWidth - Width of the end of the line
	     * @param {integer} aLineColor - RGB color packed as a uint
	     * @param {integer} bLineColor - RGB color packed as a uint
	     * @param {float} lineAlpha - Alpha represented as float
	     * @param {float} a1 - Matrix stack top a component
	     * @param {float} b1 - Matrix stack top b component
	     * @param {float} c1 - Matrix stack top c component
	     * @param {float} d1 - Matrix stack top d component
	     * @param {float} e1 - Matrix stack top e component
	     * @param {float} f1 - Matrix stack top f component
	     * @param {Float32Array} currentMatrix - Parent matrix, generally used by containers
	     */
	    batchLine: function (srcX, srcY, srcScaleX, srcScaleY, srcRotation, ax, ay, bx, by, aLineWidth, bLineWidth, aLineColor, bLineColor, lineAlpha, a1, b1, c1, d1, e1, f1, currentMatrix)
	    {
	        this.renderer.setPipeline(this);
	
	        if (this.vertexCount + 6 > this.vertexCapacity)
	        {
	            this.flush();
	        }
	        
	        var a0 = currentMatrix[0];
	        var b0 = currentMatrix[1];
	        var c0 = currentMatrix[2];
	        var d0 = currentMatrix[3];
	        var e0 = currentMatrix[4];
	        var f0 = currentMatrix[5];
	        var a = a1 * a0 + b1 * c0;
	        var b = a1 * b0 + b1 * d0;
	        var c = c1 * a0 + d1 * c0;
	        var d = c1 * b0 + d1 * d0;
	        var e = e1 * a0 + f1 * c0 + e0;
	        var f = e1 * b0 + f1 * d0 + f0;
	        var vertexViewF32 = this.vertexViewF32;
	        var vertexViewU32 = this.vertexViewU32;
	        var dx = bx - ax;
	        var dy = by - ay;
	        var len = Math.sqrt(dx * dx + dy * dy);
	        var al0 = aLineWidth * (by - ay) / len;
	        var al1 = aLineWidth * (ax - bx) / len;
	        var bl0 = bLineWidth * (by - ay) / len;
	        var bl1 = bLineWidth * (ax - bx) / len;
	        var lx0 = bx - bl0;
	        var ly0 = by - bl1;
	        var lx1 = ax - al0;
	        var ly1 = ay - al1;
	        var lx2 = bx + bl0;
	        var ly2 = by + bl1;
	        var lx3 = ax + al0;
	        var ly3 = ay + al1;
	        var x0 = lx0 * a + ly0 * c + e;
	        var y0 = lx0 * b + ly0 * d + f;
	        var x1 = lx1 * a + ly1 * c + e;
	        var y1 = lx1 * b + ly1 * d + f;
	        var x2 = lx2 * a + ly2 * c + e;
	        var y2 = lx2 * b + ly2 * d + f;
	        var x3 = lx3 * a + ly3 * c + e;
	        var y3 = lx3 * b + ly3 * d + f;
	        var getTint = Utils.getTintAppendFloatAlphaAndSwap;
	        var aTint = getTint(aLineColor, lineAlpha);
	        var bTint = getTint(bLineColor, lineAlpha);
	        var vertexOffset = this.vertexCount * this.vertexComponentCount;
	
	        vertexViewF32[vertexOffset + 0] = x0;
	        vertexViewF32[vertexOffset + 1] = y0;
	        vertexViewU32[vertexOffset + 2] = bTint;
	        vertexViewF32[vertexOffset + 3] = x1;
	        vertexViewF32[vertexOffset + 4] = y1;
	        vertexViewU32[vertexOffset + 5] = aTint;
	        vertexViewF32[vertexOffset + 6] = x2;
	        vertexViewF32[vertexOffset + 7] = y2;
	        vertexViewU32[vertexOffset + 8] = bTint;
	        vertexViewF32[vertexOffset + 9] = x1;
	        vertexViewF32[vertexOffset + 10] = y1;
	        vertexViewU32[vertexOffset + 11] = aTint;
	        vertexViewF32[vertexOffset + 12] = x3;
	        vertexViewF32[vertexOffset + 13] = y3;
	        vertexViewU32[vertexOffset + 14] = aTint;
	        vertexViewF32[vertexOffset + 15] = x2;
	        vertexViewF32[vertexOffset + 16] = y2;
	        vertexViewU32[vertexOffset + 17] = bTint;
	
	        this.vertexCount += 6;
	
	        return [
	            x0, y0, bLineColor,
	            x1, y1, aLineColor,
	            x2, y2, bLineColor,
	            x3, y3, aLineColor
	        ];
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#batchGraphics
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Graphics} graphics - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     * @param {Phaser.GameObjects.Components.TransformMatrix} parentTransformMatrix - [description]
	     */
	    batchGraphics: function (graphics, camera, parentTransformMatrix)
	    {
	        if (graphics.commandBuffer.length <= 0) { return; }
	
	        var parentMatrix = null;
	
	        if (parentTransformMatrix)
	        {
	            parentMatrix = parentTransformMatrix.matrix;
	        }
	        
	        this.renderer.setPipeline(this);
	
	        var cameraScrollX = camera.scrollX * graphics.scrollFactorX;
	        var cameraScrollY = camera.scrollY * graphics.scrollFactorY;
	        var srcX = graphics.x;
	        var srcY = graphics.y;
	        var srcScaleX = graphics.scaleX;
	        var srcScaleY = graphics.scaleY;
	        var srcRotation = graphics.rotation;
	        var commands = graphics.commandBuffer;
	        var alpha = graphics.alpha;
	        var lineAlpha = 1.0;
	        var fillAlpha = 1.0;
	        var lineColor = 0;
	        var fillColor = 0;
	        var lineWidth = 1.0;
	        var cameraMatrix = camera.matrix.matrix;
	        var lastPath = null;
	        var iteration = 0;
	        var iterStep = 0.01;
	        var tx = 0;
	        var ty = 0;
	        var ta = 0;
	        var x = 0;
	        var y = 0;
	        var radius = 0;
	        var startAngle = 0;
	        var endAngle = 0;
	        var anticlockwise = 0;
	        var path = null;
	        var sin = Math.sin;
	        var cos = Math.cos;
	        var PI2 = Math.PI * 2;
	        var sr = sin(srcRotation);
	        var cr = cos(srcRotation);
	        var sra = cr * srcScaleX;
	        var srb = sr * srcScaleX;
	        var src = -sr * srcScaleY;
	        var srd = cr * srcScaleY;
	        var sre = srcX;
	        var srf = srcY;
	        var cma = cameraMatrix[0];
	        var cmb = cameraMatrix[1];
	        var cmc = cameraMatrix[2];
	        var cmd = cameraMatrix[3];
	        var cme = cameraMatrix[4];
	        var cmf = cameraMatrix[5];
	        var mva, mvb, mvc, mvd, mve, mvf;
	
	        if (parentMatrix)
	        {
	            var pma = parentMatrix[0];
	            var pmb = parentMatrix[1];
	            var pmc = parentMatrix[2];
	            var pmd = parentMatrix[3];
	            var pme = parentMatrix[4];
	            var pmf = parentMatrix[5];
	            var cse = -cameraScrollX;
	            var csf = -cameraScrollY;
	            var pse = cse * cma + csf * cmc + cme;
	            var psf = cse * cmb + csf * cmd + cmf;
	            var pca = pma * cma + pmb * cmc;
	            var pcb = pma * cmb + pmb * cmd;
	            var pcc = pmc * cma + pmd * cmc;
	            var pcd = pmc * cmb + pmd * cmd;
	            var pce = pme * cma + pmf * cmc + pse;
	            var pcf = pme * cmb + pmf * cmd + psf;
	
	            mva = sra * pca + srb * pcc;
	            mvb = sra * pcb + srb * pcd;
	            mvc = src * pca + srd * pcc;
	            mvd = src * pcb + srd * pcd;
	            mve = sre * pca + srf * pcc + pce;
	            mvf = sre * pcb + srf * pcd + pcf;
	        }
	        else
	        {
	            sre -= cameraScrollX;
	            srf -= cameraScrollY;
	
	            mva = sra * cma + srb * cmc;
	            mvb = sra * cmb + srb * cmd;
	            mvc = src * cma + srd * cmc;
	            mvd = src * cmb + srd * cmd;
	            mve = sre * cma + srf * cmc + cme;
	            mvf = sre * cmb + srf * cmd + cmf;
	        }
	
	        var pathArrayIndex;
	        var pathArrayLength;
	
	        pathArray.length = 0;
	
	        for (var cmdIndex = 0, cmdLength = commands.length; cmdIndex < cmdLength; ++cmdIndex)
	        {
	            cmd = commands[cmdIndex];
	
	            switch (cmd)
	            {
	                case Commands.ARC:
	                    iteration = 0;
	                    x = commands[cmdIndex + 1];
	                    y = commands[cmdIndex + 2];
	                    radius = commands[cmdIndex + 3];
	                    startAngle = commands[cmdIndex + 4];
	                    endAngle = commands[cmdIndex + 5];
	                    anticlockwise = commands[cmdIndex + 6];
	
	                    if (lastPath === null)
	                    {
	                        lastPath = new Path(x + cos(startAngle) * radius, y + sin(startAngle) * radius, lineWidth, lineColor, lineAlpha * alpha);
	                        pathArray.push(lastPath);
	                        iteration += iterStep;
	                    }
	
	                    endAngle -= startAngle;
	
	                    if (anticlockwise)
	                    {
	                        if (endAngle < -PI2)
	                        {
	                            endAngle = -PI2;
	                        }
	                        else if (endAngle > 0)
	                        {
	                            endAngle = -PI2 + endAngle % PI2;
	                        }
	                    }
	                    else if (endAngle > PI2)
	                    {
	                        endAngle = PI2;
	                    }
	                    else if (endAngle < 0)
	                    {
	                        endAngle = PI2 + endAngle % PI2;
	                    }
	
	                    while (iteration < 1)
	                    {
	                        ta = endAngle * iteration + startAngle;
	                        tx = x + cos(ta) * radius;
	                        ty = y + sin(ta) * radius;
	
	                        lastPath.points.push(new Point(tx, ty, lineWidth, lineColor, lineAlpha * alpha));
	
	                        iteration += iterStep;
	                    }
	
	                    ta = endAngle + startAngle;
	                    tx = x + cos(ta) * radius;
	                    ty = y + sin(ta) * radius;
	
	                    lastPath.points.push(new Point(tx, ty, lineWidth, lineColor, lineAlpha * alpha));
	
	                    cmdIndex += 6;
	                    break;
	
	                case Commands.LINE_STYLE:
	                    lineWidth = commands[cmdIndex + 1];
	                    lineColor = commands[cmdIndex + 2];
	                    lineAlpha = commands[cmdIndex + 3];
	                    cmdIndex += 3;
	                    break;
	
	                case Commands.FILL_STYLE:
	                    fillColor = commands[cmdIndex + 1];
	                    fillAlpha = commands[cmdIndex + 2];
	                    cmdIndex += 2;
	                    break;
	
	                case Commands.BEGIN_PATH:
	                    pathArray.length = 0;
	                    lastPath = null;
	                    break;
	
	                case Commands.CLOSE_PATH:
	                    if (lastPath && lastPath.points.length)
	                    {
	                        lastPath.points.push(lastPath.points[0]);
	                    }
	                    break;
	
	                case Commands.FILL_PATH:
	                    for (pathArrayIndex = 0, pathArrayLength = pathArray.length;
	                        pathArrayIndex < pathArrayLength;
	                        ++pathArrayIndex)
	                    {
	                        this.batchFillPath(
	
	                            /* Graphics Game Object Properties */
	                            srcX, srcY, srcScaleX, srcScaleY, srcRotation,
	
	                            /* Rectangle properties */ 
	                            pathArray[pathArrayIndex].points,
	                            fillColor,
	                            fillAlpha * alpha,
	
	                            /* Transform */
	                            mva, mvb, mvc, mvd, mve, mvf,
	                            currentMatrix
	                        );
	                    }
	                    break;
	
	                case Commands.STROKE_PATH:
	                    for (pathArrayIndex = 0, pathArrayLength = pathArray.length;
	                        pathArrayIndex < pathArrayLength;
	                        ++pathArrayIndex)
	                    {
	                        path = pathArray[pathArrayIndex];
	                        this.batchStrokePath(
	
	                            /* Graphics Game Object Properties */
	                            srcX, srcY, srcScaleX, srcScaleY, srcRotation,
	
	                            /* Rectangle properties */ 
	                            path.points,
	                            lineWidth,
	                            lineColor,
	                            lineAlpha * alpha,
	
	                            /* Transform */
	                            mva, mvb, mvc, mvd, mve, mvf,
	                            path === this._lastPath,
	                            currentMatrix
	                        );
	                    }
	                    break;
	                    
	                case Commands.FILL_RECT:
	                    this.batchFillRect(
	
	                        /* Graphics Game Object Properties */
	                        srcX, srcY, srcScaleX, srcScaleY, srcRotation,
	
	                        /* Rectangle properties */ 
	                        commands[cmdIndex + 1],
	                        commands[cmdIndex + 2],
	                        commands[cmdIndex + 3],
	                        commands[cmdIndex + 4],
	                        fillColor,
	                        fillAlpha * alpha,
	
	                        /* Transform */
	                        mva, mvb, mvc, mvd, mve, mvf,
	                        currentMatrix
	                    );
	                 
	                    cmdIndex += 4;
	                    break;
	
	                case Commands.FILL_TRIANGLE:
	                    this.batchFillTriangle(
	
	                        /* Graphics Game Object Properties */
	                        srcX, srcY, srcScaleX, srcScaleY, srcRotation,
	
	                        /* Triangle properties */ 
	                        commands[cmdIndex + 1],
	                        commands[cmdIndex + 2],
	                        commands[cmdIndex + 3],
	                        commands[cmdIndex + 4],
	                        commands[cmdIndex + 5],
	                        commands[cmdIndex + 6],
	                        fillColor,
	                        fillAlpha * alpha,
	
	                        /* Transform */
	                        mva, mvb, mvc, mvd, mve, mvf,
	                        currentMatrix
	                    );
	                    
	                    cmdIndex += 6;
	                    break;
	
	                case Commands.STROKE_TRIANGLE:
	                    this.batchStrokeTriangle(
	
	                        /* Graphics Game Object Properties */
	                        srcX, srcY, srcScaleX, srcScaleY, srcRotation,
	
	                        /* Triangle properties */ 
	                        commands[cmdIndex + 1],
	                        commands[cmdIndex + 2],
	                        commands[cmdIndex + 3],
	                        commands[cmdIndex + 4],
	                        commands[cmdIndex + 5],
	                        commands[cmdIndex + 6],
	                        lineWidth,
	                        lineColor,
	                        lineAlpha * alpha,
	
	                        /* Transform */
	                        mva, mvb, mvc, mvd, mve, mvf,
	                        currentMatrix
	                    );
	                    
	                    cmdIndex += 6;
	                    break;
	
	                case Commands.LINE_TO:
	                    if (lastPath !== null)
	                    {
	                        lastPath.points.push(new Point(commands[cmdIndex + 1], commands[cmdIndex + 2], lineWidth, lineColor, lineAlpha * alpha));
	                    }
	                    else
	                    {
	                        lastPath = new Path(commands[cmdIndex + 1], commands[cmdIndex + 2], lineWidth, lineColor, lineAlpha * alpha);
	                        pathArray.push(lastPath);
	                    }
	                    cmdIndex += 2;
	                    break;
	
	                case Commands.MOVE_TO:
	                    lastPath = new Path(commands[cmdIndex + 1], commands[cmdIndex + 2], lineWidth, lineColor, lineAlpha * alpha);
	                    pathArray.push(lastPath);
	                    cmdIndex += 2;
	                    break;
	
	                case Commands.LINE_FX_TO:
	                    if (lastPath !== null)
	                    {
	                        lastPath.points.push(new Point(
	                            commands[cmdIndex + 1],
	                            commands[cmdIndex + 2],
	                            commands[cmdIndex + 3],
	                            commands[cmdIndex + 4],
	                            commands[cmdIndex + 5] * alpha
	                        ));
	                    }
	                    else
	                    {
	                        lastPath = new Path(
	                            commands[cmdIndex + 1],
	                            commands[cmdIndex + 2],
	                            commands[cmdIndex + 3],
	                            commands[cmdIndex + 4],
	                            commands[cmdIndex + 5] * alpha
	                        );
	                        pathArray.push(lastPath);
	                    }
	                    cmdIndex += 5;
	                    break;
	
	                case Commands.MOVE_FX_TO:
	                    lastPath = new Path(
	                        commands[cmdIndex + 1],
	                        commands[cmdIndex + 2],
	                        commands[cmdIndex + 3],
	                        commands[cmdIndex + 4],
	                        commands[cmdIndex + 5] * alpha
	                    );
	                    pathArray.push(lastPath);
	                    cmdIndex += 5;
	                    break;
	
	                case Commands.SAVE:
	                    matrixStack[matrixStackLength + 0] = currentMatrix[0];
	                    matrixStack[matrixStackLength + 1] = currentMatrix[1];
	                    matrixStack[matrixStackLength + 2] = currentMatrix[2];
	                    matrixStack[matrixStackLength + 3] = currentMatrix[3];
	                    matrixStack[matrixStackLength + 4] = currentMatrix[4];
	                    matrixStack[matrixStackLength + 5] = currentMatrix[5];
	                    matrixStackLength += 6;
	                    break;
	
	                case Commands.RESTORE:
	                    matrixStackLength -= 6;
	                    currentMatrix[0] = matrixStack[matrixStackLength + 0];
	                    currentMatrix[1] = matrixStack[matrixStackLength + 1];
	                    currentMatrix[2] = matrixStack[matrixStackLength + 2];
	                    currentMatrix[3] = matrixStack[matrixStackLength + 3];
	                    currentMatrix[4] = matrixStack[matrixStackLength + 4];
	                    currentMatrix[5] = matrixStack[matrixStackLength + 5];
	                    break;
	
	                case Commands.TRANSLATE:
	                    x = commands[cmdIndex + 1];
	                    y = commands[cmdIndex + 2];
	                    currentMatrix[4] = currentMatrix[0] * x + currentMatrix[2] * y + currentMatrix[4];
	                    currentMatrix[5] = currentMatrix[1] * x + currentMatrix[3] * y + currentMatrix[5];
	                    cmdIndex += 2;
	                    break;
	
	                case Commands.SCALE:
	                    x = commands[cmdIndex + 1];
	                    y = commands[cmdIndex + 2];
	                    currentMatrix[0] *= x;
	                    currentMatrix[1] *= x;
	                    currentMatrix[2] *= y;
	                    currentMatrix[3] *= y;
	                    cmdIndex += 2;
	                    break;
	
	                case Commands.ROTATE:
	                    y = commands[cmdIndex + 1];
	                    x = sin(y);
	                    y = cos(y);
	                    sra = currentMatrix[0];
	                    srb = currentMatrix[1];
	                    src = currentMatrix[2];
	                    srd = currentMatrix[3];
	                    currentMatrix[0] = y * sra + x * src;
	                    currentMatrix[1] = y * srb + x * srd;
	                    currentMatrix[2] = -x * sra + y * src;
	                    currentMatrix[3] = -x * srb + y * srd;
	                    cmdIndex += 1;
	                    break;
	
	                default:
	                    // eslint-disable-next-line no-console
	                    console.error('Phaser: Invalid Graphics Command ID ' + cmd);
	                    break;
	            }
	        }
	    },
	
	    // Stubs
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#drawStaticTilemapLayer
	     * @since 3.0.0
	     *
	     * @param {Phaser.Tilemaps.StaticTilemapLayer} tilemap - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     */
	    drawStaticTilemapLayer: function ()
	    {
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#drawEmitterManager
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Particles.ParticleEmitterManager} emitterManager - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     */
	    drawEmitterManager: function ()
	    {
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#drawBlitter
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Blitter} blitter - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     */
	    drawBlitter: function ()
	    {
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#batchSprite
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Sprite} sprite - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     */
	    batchSprite: function ()
	    {
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#batchMesh
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Mesh} mesh - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     */
	    batchMesh: function ()
	    {
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#batchBitmapText
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.BitmapText} bitmapText - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     */
	    batchBitmapText: function ()
	    {
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#batchDynamicBitmapText
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.DynamicBitmapText} bitmapText - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     */
	    batchDynamicBitmapText: function ()
	    {
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#batchText
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Text} text - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     */
	    batchText: function ()
	    {
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#batchDynamicTilemapLayer
	     * @since 3.0.0
	     *
	     * @param {Phaser.Tilemaps.DynamicTilemapLayer} tilemapLayer - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     */
	    batchDynamicTilemapLayer: function ()
	    {
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline#batchTileSprite
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.TileSprite} tileSprite - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     */
	    batchTileSprite: function ()
	    {
	    }
	
	});
	
	module.exports = FlatTintPipeline;


/***/ }),
/* 621 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	
	/**
	 * Implements a model view projection matrices.
	 * Pipelines can implement this for doing 2D and 3D rendering.
	 */
	
	var ModelViewProjection = {
	
	    /**
	     * Dirty flag for checking if model matrix needs to be updated on GPU.
	     */
	    modelMatrixDirty: false,
	
	    /**
	     * Dirty flag for checking if view matrix needs to be updated on GPU.
	     */
	    viewMatrixDirty: false,
	
	    /**
	     * Dirty flag for checking if projection matrix needs to be updated on GPU.
	     */
	    projectionMatrixDirty: false,
	
	    /**
	     * Model matrix
	     */
	    modelMatrix: null,
	
	    /**
	     * View matrix
	     */
	    viewMatrix: null,
	
	    /**
	     * Projection matrix
	     */
	    projectionMatrix: null,
	
	    /**
	     * Initializes MVP matrices with an identity matrix
	     */
	    mvpInit: function ()
	    {
	        this.modelMatrixDirty = true;
	        this.viewMatrixDirty = true;
	        this.projectionMatrixDirty = true;
	        
	        this.modelMatrix = new Float32Array([
	            1, 0, 0, 0,
	            0, 1, 0, 0,
	            0, 0, 1, 0,
	            0, 0, 0, 1
	        ]);
	        
	        this.viewMatrix = new Float32Array([
	            1, 0, 0, 0,
	            0, 1, 0, 0,
	            0, 0, 1, 0,
	            0, 0, 0, 1
	        ]);
	        
	        this.projectionMatrix = new Float32Array([
	            1, 0, 0, 0,
	            0, 1, 0, 0,
	            0, 0, 1, 0,
	            0, 0, 0, 1
	        ]);
	        
	        return this;
	    },
	
	    /**
	     * If dirty flags are set then the matrices are uploaded to the GPU.
	     */
	    mvpUpdate: function ()
	    {
	        var program = this.program;
	
	        if (this.modelMatrixDirty)
	        {
	            this.renderer.setMatrix4(program, 'uModelMatrix', false, this.modelMatrix);
	            this.modelMatrixDirty = false;
	        }
	        
	        if (this.viewMatrixDirty)
	        {
	            this.renderer.setMatrix4(program, 'uViewMatrix', false, this.viewMatrix);
	            this.viewMatrixDirty = false;
	        }
	
	        if (this.projectionMatrixDirty)
	        {
	            this.renderer.setMatrix4(program, 'uProjectionMatrix', false, this.projectionMatrix);
	            this.projectionMatrixDirty = false;
	        }
	
	        return this;
	    },
	
	    /**
	     * Loads an identity matrix to the model matrix
	     */
	    modelIdentity: function ()
	    {
	        var modelMatrix = this.modelMatrix;
	        
	        modelMatrix[0] = 1;
	        modelMatrix[1] = 0;
	        modelMatrix[2] = 0;
	        modelMatrix[3] = 0;
	        modelMatrix[4] = 0;
	        modelMatrix[5] = 1;
	        modelMatrix[6] = 0;
	        modelMatrix[7] = 0;
	        modelMatrix[8] = 0;
	        modelMatrix[9] = 0;
	        modelMatrix[10] = 1;
	        modelMatrix[11] = 0;
	        modelMatrix[12] = 0;
	        modelMatrix[13] = 0;
	        modelMatrix[14] = 0;
	        modelMatrix[15] = 1;
	
	        this.modelMatrixDirty = true;
	        
	        return this;
	    },
	
	    /**
	     * Scale model matrix
	     */
	    modelScale: function (x, y, z)
	    {
	        var modelMatrix = this.modelMatrix;
	
	        modelMatrix[0] = modelMatrix[0] * x;
	        modelMatrix[1] = modelMatrix[1] * x;
	        modelMatrix[2] = modelMatrix[2] * x;
	        modelMatrix[3] = modelMatrix[3] * x;
	        modelMatrix[4] = modelMatrix[4] * y;
	        modelMatrix[5] = modelMatrix[5] * y;
	        modelMatrix[6] = modelMatrix[6] * y;
	        modelMatrix[7] = modelMatrix[7] * y;
	        modelMatrix[8] = modelMatrix[8] * z;
	        modelMatrix[9] = modelMatrix[9] * z;
	        modelMatrix[10] = modelMatrix[10] * z;
	        modelMatrix[11] = modelMatrix[11] * z;
	    
	        this.modelMatrixDirty = true;
	
	        return this;
	    },
	
	    /**
	     * Translate model matrix
	     */
	    modelTranslate: function (x, y, z)
	    {
	        var modelMatrix = this.modelMatrix;
	
	        modelMatrix[12] = modelMatrix[0] * x + modelMatrix[4] * y + modelMatrix[8] * z + modelMatrix[12];
	        modelMatrix[13] = modelMatrix[1] * x + modelMatrix[5] * y + modelMatrix[9] * z + modelMatrix[13];
	        modelMatrix[14] = modelMatrix[2] * x + modelMatrix[6] * y + modelMatrix[10] * z + modelMatrix[14];
	        modelMatrix[15] = modelMatrix[3] * x + modelMatrix[7] * y + modelMatrix[11] * z + modelMatrix[15];
	
	        this.modelMatrixDirty = true;
	
	        return this;
	    },
	
	
	    /**
	     * Rotates the model matrix in the X axis.
	     */
	    modelRotateX: function (radians)
	    {
	        var modelMatrix = this.modelMatrix;
	        var s = Math.sin(radians);
	        var c = Math.cos(radians);
	        var a10 = modelMatrix[4];
	        var a11 = modelMatrix[5];
	        var a12 = modelMatrix[6];
	        var a13 = modelMatrix[7];
	        var a20 = modelMatrix[8];
	        var a21 = modelMatrix[9];
	        var a22 = modelMatrix[10];
	        var a23 = modelMatrix[11];
	
	        modelMatrix[4] = a10 * c + a20 * s;
	        modelMatrix[5] = a11 * c + a21 * s;
	        modelMatrix[6] = a12 * c + a22 * s;
	        modelMatrix[7] = a13 * c + a23 * s;
	        modelMatrix[8] = a20 * c - a10 * s;
	        modelMatrix[9] = a21 * c - a11 * s;
	        modelMatrix[10] = a22 * c - a12 * s;
	        modelMatrix[11] = a23 * c - a13 * s;
	
	        this.modelMatrixDirty = true;
	
	        return this;
	    },
	
	    /**
	     * Rotates the model matrix in the Y axis.
	     */
	    modelRotateY: function (radians)
	    {
	        var modelMatrix = this.modelMatrix;
	        var s = Math.sin(radians);
	        var c = Math.cos(radians);
	        var a00 = modelMatrix[0];
	        var a01 = modelMatrix[1];
	        var a02 = modelMatrix[2];
	        var a03 = modelMatrix[3];
	        var a20 = modelMatrix[8];
	        var a21 = modelMatrix[9];
	        var a22 = modelMatrix[10];
	        var a23 = modelMatrix[11];
	
	        modelMatrix[0] = a00 * c - a20 * s;
	        modelMatrix[1] = a01 * c - a21 * s;
	        modelMatrix[2] = a02 * c - a22 * s;
	        modelMatrix[3] = a03 * c - a23 * s;
	        modelMatrix[8] = a00 * s + a20 * c;
	        modelMatrix[9] = a01 * s + a21 * c;
	        modelMatrix[10] = a02 * s + a22 * c;
	        modelMatrix[11] = a03 * s + a23 * c;
	
	        this.modelMatrixDirty = true;
	        
	        return this;
	    },
	    
	    /**
	     * Rotates the model matrix in the Z axis.
	     */
	    modelRotateZ: function (radians)
	    {
	        var modelMatrix = this.modelMatrix;
	        var s = Math.sin(radians);
	        var c = Math.cos(radians);
	        var a00 = modelMatrix[0];
	        var a01 = modelMatrix[1];
	        var a02 = modelMatrix[2];
	        var a03 = modelMatrix[3];
	        var a10 = modelMatrix[4];
	        var a11 = modelMatrix[5];
	        var a12 = modelMatrix[6];
	        var a13 = modelMatrix[7];
	
	        modelMatrix[0] = a00 * c + a10 * s;
	        modelMatrix[1] = a01 * c + a11 * s;
	        modelMatrix[2] = a02 * c + a12 * s;
	        modelMatrix[3] = a03 * c + a13 * s;
	        modelMatrix[4] = a10 * c - a00 * s;
	        modelMatrix[5] = a11 * c - a01 * s;
	        modelMatrix[6] = a12 * c - a02 * s;
	        modelMatrix[7] = a13 * c - a03 * s;
	
	        this.modelMatrixDirty = true;
	
	        return this;
	    },
	
	    /**
	     * Loads identity matrix into the view matrix
	     */
	    viewIdentity: function ()
	    {
	        var viewMatrix = this.viewMatrix;
	        
	        viewMatrix[0] = 1;
	        viewMatrix[1] = 0;
	        viewMatrix[2] = 0;
	        viewMatrix[3] = 0;
	        viewMatrix[4] = 0;
	        viewMatrix[5] = 1;
	        viewMatrix[6] = 0;
	        viewMatrix[7] = 0;
	        viewMatrix[8] = 0;
	        viewMatrix[9] = 0;
	        viewMatrix[10] = 1;
	        viewMatrix[11] = 0;
	        viewMatrix[12] = 0;
	        viewMatrix[13] = 0;
	        viewMatrix[14] = 0;
	        viewMatrix[15] = 1;
	
	        this.viewMatrixDirty = true;
	        
	        return this;
	    },
	    
	    /**
	     * Scales view matrix
	     */
	    viewScale: function (x, y, z)
	    {
	        var viewMatrix = this.viewMatrix;
	
	        viewMatrix[0] = viewMatrix[0] * x;
	        viewMatrix[1] = viewMatrix[1] * x;
	        viewMatrix[2] = viewMatrix[2] * x;
	        viewMatrix[3] = viewMatrix[3] * x;
	        viewMatrix[4] = viewMatrix[4] * y;
	        viewMatrix[5] = viewMatrix[5] * y;
	        viewMatrix[6] = viewMatrix[6] * y;
	        viewMatrix[7] = viewMatrix[7] * y;
	        viewMatrix[8] = viewMatrix[8] * z;
	        viewMatrix[9] = viewMatrix[9] * z;
	        viewMatrix[10] = viewMatrix[10] * z;
	        viewMatrix[11] = viewMatrix[11] * z;
	    
	        this.viewMatrixDirty = true;
	
	        return this;
	    },
	
	    /**
	     * Translates view matrix
	     */
	    viewTranslate: function (x, y, z)
	    {
	        var viewMatrix = this.viewMatrix;
	
	        viewMatrix[12] = viewMatrix[0] * x + viewMatrix[4] * y + viewMatrix[8] * z + viewMatrix[12];
	        viewMatrix[13] = viewMatrix[1] * x + viewMatrix[5] * y + viewMatrix[9] * z + viewMatrix[13];
	        viewMatrix[14] = viewMatrix[2] * x + viewMatrix[6] * y + viewMatrix[10] * z + viewMatrix[14];
	        viewMatrix[15] = viewMatrix[3] * x + viewMatrix[7] * y + viewMatrix[11] * z + viewMatrix[15];
	
	        this.viewMatrixDirty = true;
	
	        return this;
	    },
	    
	    /**
	     * Rotates view matrix in the X axis.
	     */
	    viewRotateX: function (radians)
	    {
	        var viewMatrix = this.viewMatrix;
	        var s = Math.sin(radians);
	        var c = Math.cos(radians);
	        var a10 = viewMatrix[4];
	        var a11 = viewMatrix[5];
	        var a12 = viewMatrix[6];
	        var a13 = viewMatrix[7];
	        var a20 = viewMatrix[8];
	        var a21 = viewMatrix[9];
	        var a22 = viewMatrix[10];
	        var a23 = viewMatrix[11];
	
	        viewMatrix[4] = a10 * c + a20 * s;
	        viewMatrix[5] = a11 * c + a21 * s;
	        viewMatrix[6] = a12 * c + a22 * s;
	        viewMatrix[7] = a13 * c + a23 * s;
	        viewMatrix[8] = a20 * c - a10 * s;
	        viewMatrix[9] = a21 * c - a11 * s;
	        viewMatrix[10] = a22 * c - a12 * s;
	        viewMatrix[11] = a23 * c - a13 * s;
	
	        this.viewMatrixDirty = true;
	
	        return this;
	    },
	    
	    /**
	     * Rotates view matrix in the Y axis.
	     */
	    viewRotateY: function (radians)
	    {
	        var viewMatrix = this.viewMatrix;
	        var s = Math.sin(radians);
	        var c = Math.cos(radians);
	        var a00 = viewMatrix[0];
	        var a01 = viewMatrix[1];
	        var a02 = viewMatrix[2];
	        var a03 = viewMatrix[3];
	        var a20 = viewMatrix[8];
	        var a21 = viewMatrix[9];
	        var a22 = viewMatrix[10];
	        var a23 = viewMatrix[11];
	
	        viewMatrix[0] = a00 * c - a20 * s;
	        viewMatrix[1] = a01 * c - a21 * s;
	        viewMatrix[2] = a02 * c - a22 * s;
	        viewMatrix[3] = a03 * c - a23 * s;
	        viewMatrix[8] = a00 * s + a20 * c;
	        viewMatrix[9] = a01 * s + a21 * c;
	        viewMatrix[10] = a02 * s + a22 * c;
	        viewMatrix[11] = a03 * s + a23 * c;
	
	        this.viewMatrixDirty = true;
	        
	        return this;
	    },
	    
	    /**
	     * Rotates view matrix in the Z axis.
	     */
	    viewRotateZ: function (radians)
	    {
	        var viewMatrix = this.viewMatrix;
	        var s = Math.sin(radians);
	        var c = Math.cos(radians);
	        var a00 = viewMatrix[0];
	        var a01 = viewMatrix[1];
	        var a02 = viewMatrix[2];
	        var a03 = viewMatrix[3];
	        var a10 = viewMatrix[4];
	        var a11 = viewMatrix[5];
	        var a12 = viewMatrix[6];
	        var a13 = viewMatrix[7];
	
	        viewMatrix[0] = a00 * c + a10 * s;
	        viewMatrix[1] = a01 * c + a11 * s;
	        viewMatrix[2] = a02 * c + a12 * s;
	        viewMatrix[3] = a03 * c + a13 * s;
	        viewMatrix[4] = a10 * c - a00 * s;
	        viewMatrix[5] = a11 * c - a01 * s;
	        viewMatrix[6] = a12 * c - a02 * s;
	        viewMatrix[7] = a13 * c - a03 * s;
	
	        this.viewMatrixDirty = true;
	
	        return this;
	    },
	
	    /**
	     * Loads a 2D view matrix (3x2 matrix) into a 4x4 view matrix 
	     */
	    viewLoad2D: function (matrix2D)
	    {
	        var vm = this.viewMatrix;
	
	        vm[0] = matrix2D[0];
	        vm[1] = matrix2D[1];
	        vm[2] = 0.0;
	        vm[3] = 0.0;
	        vm[4] = matrix2D[2];
	        vm[5] = matrix2D[3];
	        vm[6] = 0.0;
	        vm[7] = 0.0;
	        vm[8] = matrix2D[4];
	        vm[9] = matrix2D[5];
	        vm[10] = 1.0;
	        vm[11] = 0.0;
	        vm[12] = 0.0;
	        vm[13] = 0.0;
	        vm[14] = 0.0;
	        vm[15] = 1.0;
	
	        this.viewMatrixDirty = true;
	
	        return this;
	    },
	
	
	    /**
	     * Copies a 4x4 matrix into the view matrix
	     */
	    viewLoad: function (matrix)
	    {
	        var vm = this.viewMatrix;
	
	        vm[0] = matrix[0];
	        vm[1] = matrix[1];
	        vm[2] = matrix[2];
	        vm[3] = matrix[3];
	        vm[4] = matrix[4];
	        vm[5] = matrix[5];
	        vm[6] = matrix[6];
	        vm[7] = matrix[7];
	        vm[8] = matrix[8];
	        vm[9] = matrix[9];
	        vm[10] = matrix[10];
	        vm[11] = matrix[11];
	        vm[12] = matrix[12];
	        vm[13] = matrix[13];
	        vm[14] = matrix[14];
	        vm[15] = matrix[15];
	
	        this.viewMatrixDirty = true;
	
	        return this;
	    },
	    
	    /**
	     * Loads identity matrix into the projection matrix.
	     */
	    projIdentity: function ()
	    {
	        var projectionMatrix = this.projectionMatrix;
	        
	        projectionMatrix[0] = 1;
	        projectionMatrix[1] = 0;
	        projectionMatrix[2] = 0;
	        projectionMatrix[3] = 0;
	        projectionMatrix[4] = 0;
	        projectionMatrix[5] = 1;
	        projectionMatrix[6] = 0;
	        projectionMatrix[7] = 0;
	        projectionMatrix[8] = 0;
	        projectionMatrix[9] = 0;
	        projectionMatrix[10] = 1;
	        projectionMatrix[11] = 0;
	        projectionMatrix[12] = 0;
	        projectionMatrix[13] = 0;
	        projectionMatrix[14] = 0;
	        projectionMatrix[15] = 1;
	
	        this.projectionMatrixDirty = true;
	
	        return this;
	    },
	
	    /**
	     * Sets up an orthographics projection matrix
	     */
	    projOrtho: function (left, right, bottom, top, near, far)
	    {
	        var projectionMatrix = this.projectionMatrix;
	        var leftRight = 1.0 / (left - right);
	        var bottomTop = 1.0 / (bottom - top);
	        var nearFar = 1.0 / (near - far);
	
	        projectionMatrix[0] = -2.0 * leftRight;
	        projectionMatrix[1] = 0.0;
	        projectionMatrix[2] = 0.0;
	        projectionMatrix[3] = 0.0;
	        projectionMatrix[4] = 0.0;
	        projectionMatrix[5] = -2.0 * bottomTop;
	        projectionMatrix[6] = 0.0;
	        projectionMatrix[7] = 0.0;
	        projectionMatrix[8] = 0.0;
	        projectionMatrix[9] = 0.0;
	        projectionMatrix[10] = 2.0 * nearFar;
	        projectionMatrix[11] = 0.0;
	        projectionMatrix[12] = (left + right) * leftRight;
	        projectionMatrix[13] = (top + bottom) * bottomTop;
	        projectionMatrix[14] = (far + near) * nearFar;
	        projectionMatrix[15] = 1.0;
	
	        this.projectionMatrixDirty = true;
	        return this;
	    },
	    
	    /**
	     * Sets up a perspective projection matrix
	     */
	    projPersp: function (fovy, aspectRatio, near, far)
	    {
	        var projectionMatrix = this.projectionMatrix;
	        var fov = 1.0 / Math.tan(fovy / 2.0);
	        var nearFar = 1.0 / (near - far);
	        
	        projectionMatrix[0] = fov / aspectRatio;
	        projectionMatrix[1] = 0.0;
	        projectionMatrix[2] = 0.0;
	        projectionMatrix[3] = 0.0;
	        projectionMatrix[4] = 0.0;
	        projectionMatrix[5] = fov;
	        projectionMatrix[6] = 0.0;
	        projectionMatrix[7] = 0.0;
	        projectionMatrix[8] = 0.0;
	        projectionMatrix[9] = 0.0;
	        projectionMatrix[10] = (far + near) * nearFar;
	        projectionMatrix[11] = -1.0;
	        projectionMatrix[12] = 0.0;
	        projectionMatrix[13] = 0.0;
	        projectionMatrix[14] = (2.0 * far * near) * nearFar;
	        projectionMatrix[15] = 0.0;
	        
	        this.projectionMatrixDirty = true;
	        return this;
	    }
	};
	
	module.exports = ModelViewProjection;


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Systems = __webpack_require__(325);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class Scene
	 * @memberOf Phaser
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {(string|Phaser.Scenes.Settings.Config)} config - Scene specific configuration settings.
	 */
	var Scene = new Class({
	
	    initialize:
	
	    function Scene (config)
	    {
	        /**
	         * The Scene Systems. You must never overwrite this property, or all hell will break lose.
	         *
	         * @name Phaser.Scene#sys
	         * @type {Phaser.Scenes.Systems}
	         * @since 3.0.0
	         */
	        this.sys = new Systems(this, config);
	
	        /**
	         * A reference to the Phaser.Game instance.
	         * This property will only be available if defined in the Scene Injection Map.
	         *
	         * @name Phaser.Scene#game
	         * @type {Phaser.Game}
	         * @since 3.0.0
	         */
	        this.game;
	
	        /**
	         * A reference to the global Animation Manager.
	         * This property will only be available if defined in the Scene Injection Map.
	         *
	         * @name Phaser.Scene#anims
	         * @type {Phaser.Animations.AnimationManager}
	         * @since 3.0.0
	         */
	        this.anims;
	
	        /**
	         * A reference to the global Cache.
	         * This property will only be available if defined in the Scene Injection Map.
	         *
	         * @name Phaser.Scene#cache
	         * @type {Phaser.Cache.CacheManager}
	         * @since 3.0.0
	         */
	        this.cache;
	
	        /**
	         * A reference to the game level Data Manager.
	         * This property will only be available if defined in the Scene Injection Map.
	         *
	         * @name Phaser.Scene#registry
	         * @type {Phaser.Data.DataManager}
	         * @since 3.0.0
	         */
	        this.registry;
	
	        /**
	         * A reference to the Sound Manager.
	         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
	         *
	         * @name Phaser.Scene#sound
	         * @type {Phaser.Sound.BaseSoundManager}
	         * @since 3.0.0
	         */
	        this.sound;
	
	        /**
	         * A reference to the Texture Manager.
	         * This property will only be available if defined in the Scene Injection Map.
	         *
	         * @name Phaser.Scene#textures
	         * @type {Phaser.Textures.TextureManager}
	         * @since 3.0.0
	         */
	        this.textures;
	
	        /**
	         * A scene level Event Emitter.
	         * This property will only be available if defined in the Scene Injection Map.
	         *
	         * @name Phaser.Scene#events
	         * @type {Phaser.Events.EventEmitter}
	         * @since 3.0.0
	         */
	        this.events;
	
	        /**
	         * A scene level Camera System.
	         * This property will only be available if defined in the Scene Injection Map.
	         *
	         * @name Phaser.Scene#cameras
	         * @type {Phaser.Cameras.Scene2D.CameraManager}
	         * @since 3.0.0
	         */
	        this.cameras;
	
	        /**
	         * A scene level 3D Camera System.
	         * This property will only be available if defined in the Scene Injection Map.
	         *
	         * @name Phaser.Scene#cameras3d
	         * @type {Phaser.Cameras.Sprite3D.CameraManager}
	         * @since 3.0.0
	         */
	        this.cameras3d;
	
	        /**
	         * A scene level Game Object Factory.
	         * This property will only be available if defined in the Scene Injection Map.
	         *
	         * @name Phaser.Scene#add
	         * @type {Phaser.GameObjects.GameObjectFactory}
	         * @since 3.0.0
	         */
	        this.add;
	
	        /**
	         * A scene level Game Object Creator.
	         * This property will only be available if defined in the Scene Injection Map.
	         *
	         * @name Phaser.Scene#make
	         * @type {Phaser.GameObjects.GameObjectCreator}
	         * @since 3.0.0
	         */
	        this.make;
	
	        /**
	         * A reference to the Scene Manager Plugin.
	         * This property will only be available if defined in the Scene Injection Map.
	         *
	         * @name Phaser.Scene#scene
	         * @type {Phaser.Scenes.ScenePlugin}
	         * @since 3.0.0
	         */
	        this.scene;
	
	        /**
	         * A scene level Game Object Display List.
	         * This property will only be available if defined in the Scene Injection Map.
	         *
	         * @name Phaser.Scene#children
	         * @type {Phaser.GameObjects.DisplayList}
	         * @since 3.0.0
	         */
	        this.children;
	
	        /**
	         * A scene level Lights Manager Plugin.
	         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
	         *
	         * @name Phaser.Scene#lights
	         * @type {Phaser.GameObjects.LightsManager}
	         * @since 3.0.0
	         */
	        this.lights;
	
	        /**
	         * A scene level Data Manager Plugin.
	         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
	         *
	         * @name Phaser.Scene#data
	         * @type {Phaser.Data.DataManager}
	         * @since 3.0.0
	         */
	        this.data;
	
	        /**
	         * A scene level Input Manager Plugin.
	         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
	         *
	         * @name Phaser.Scene#input
	         * @type {Phaser.Input.InputPlugin}
	         * @since 3.0.0
	         */
	        this.input;
	
	        /**
	         * A scene level Loader Plugin.
	         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
	         *
	         * @name Phaser.Scene#load
	         * @type {Phaser.Loader.LoaderPlugin}
	         * @since 3.0.0
	         */
	        this.load;
	
	        /**
	         * A scene level Time and Clock Plugin.
	         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
	         *
	         * @name Phaser.Scene#time
	         * @type {Phaser.Time.Clock}
	         * @since 3.0.0
	         */
	        this.time;
	
	        /**
	         * A scene level Tween Manager Plugin.
	         * This property will only be available if defined in the Scene Injection Map and the plugin is installed.
	         *
	         * @name Phaser.Scene#tweens
	         * @type {Phaser.Tweens.TweenManager}
	         * @since 3.0.0
	         */
	        this.tweens;
	
	        /**
	         * A scene level Arcade Physics Plugin.
	         * This property will only be available if defined in the Scene Injection Map, the plugin is installed and configured.
	         *
	         * @name Phaser.Scene#physics
	         * @type {Phaser.Physics.Arcade.ArcadePhysics}
	         * @since 3.0.0
	         */
	        this.physics;
	
	        /**
	         * A scene level Impact Physics Plugin.
	         * This property will only be available if defined in the Scene Injection Map, the plugin is installed and configured.
	         *
	         * @name Phaser.Scene#impact
	         * @type {Phaser.Physics.Impact.ImpactPhysics}
	         * @since 3.0.0
	         */
	        this.impact;
	
	        /**
	         * A scene level Matter Physics Plugin.
	         * This property will only be available if defined in the Scene Injection Map, the plugin is installed and configured.
	         *
	         * @name Phaser.Scene#matter
	         * @type {Phaser.Physics.Matter.MatterPhysics}
	         * @since 3.0.0
	         */
	        this.matter;
	    },
	
	    /**
	     * Should be overridden by your own Scenes.
	     *
	     * @method Phaser.Scene#update
	     * @override
	     * @since 3.0.0
	     *
	     * @param {number} time - [description]
	     * @param {number} delta - [description]
	     */
	    update: function ()
	    {
	    }
	
	});
	
	module.exports = Scene;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(168);
	var GetValue = __webpack_require__(10);
	var NOOP = __webpack_require__(6);
	var Scene = __webpack_require__(622);
	var Systems = __webpack_require__(325);
	
	/**
	 * @classdesc
	 * The Scene Manager.
	 *
	 * The Scene Manager is a Game level system, responsible for creating, processing and updating all of the
	 * Scenes in a Game instance.
	 *
	 *
	 * @class SceneManager
	 * @memberOf Phaser.Scenes
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Game} game - The Phaser.Game instance this Scene Manager belongs to.
	 * @param {object} sceneConfig - Scene specific configuration settings.
	 */
	var SceneManager = new Class({
	
	    initialize:
	
	    function SceneManager (game, sceneConfig)
	    {
	        /**
	         * The Game that this SceneManager belongs to.
	         *
	         * @name Phaser.Scenes.SceneManager#game
	         * @type {Phaser.Game}
	         * @since 3.0.0
	         */
	        this.game = game;
	
	        /**
	         * An object that maps the keys to the scene so we can quickly get a scene from a key without iteration.
	         *
	         * @name Phaser.Scenes.SceneManager#keys
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.keys = {};
	
	        /**
	         * The array in which all of the scenes are kept.
	         *
	         * @name Phaser.Scenes.SceneManager#scenes
	         * @type {array}
	         * @since 3.0.0
	         */
	        this.scenes = [];
	
	        /**
	         * Scenes pending to be added are stored in here until the manager has time to add it.
	         *
	         * @name Phaser.Scenes.SceneManager#_pending
	         * @type {array}
	         * @private
	         * @since 3.0.0
	         */
	        this._pending = [];
	
	        /**
	         * An array of scenes waiting to be started once the game has booted.
	         *
	         * @name Phaser.Scenes.SceneManager#_start
	         * @type {array}
	         * @private
	         * @since 3.0.0
	         */
	        this._start = [];
	
	        /**
	         * An operations queue, because we don't manipulate the scenes array during processing.
	         *
	         * @name Phaser.Scenes.SceneManager#_queue
	         * @type {array}
	         * @private
	         * @since 3.0.0
	         */
	        this._queue = [];
	
	        /**
	         * Boot time data to merge.
	         *
	         * @name Phaser.Scenes.SceneManager#_data
	         * @type {object}
	         * @private
	         * @since 3.4.0
	         */
	        this._data = {};
	
	        /**
	         * Is the Scene Manager actively processing the Scenes list?
	         *
	         * @name Phaser.Scenes.SceneManager#isProcessing
	         * @type {boolean}
	         * @default false
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.isProcessing = false;
	
	        /**
	         * Has the Scene Manager properly started?
	         *
	         * @name Phaser.Scenes.SceneManager#isBooted
	         * @type {boolean}
	         * @default false
	         * @readOnly
	         * @since 3.4.0
	         */
	        this.isBooted = false;
	
	        if (sceneConfig)
	        {
	            if (!Array.isArray(sceneConfig))
	            {
	                sceneConfig = [ sceneConfig ];
	            }
	
	            for (var i = 0; i < sceneConfig.length; i++)
	            {
	                //  The i === 0 part just autostarts the first Scene given (unless it says otherwise in its config)
	                this._pending.push({
	                    key: 'default',
	                    scene: sceneConfig[i],
	                    autoStart: (i === 0),
	                    data: {}
	                });
	            }
	        }
	        
	        game.events.once('ready', this.bootQueue, this);
	    },
	
	    /**
	     * Internal first-time Scene boot handler.
	     *
	     * @method Phaser.Scenes.SceneManager#bootQueue
	     * @private
	     * @since 3.2.0
	     */
	    bootQueue: function ()
	    {
	        if (this.isBooted)
	        {
	            return;
	        }
	
	        var i;
	        var entry;
	        var key;
	        var sceneConfig;
	
	        for (i = 0; i < this._pending.length; i++)
	        {
	            entry = this._pending[i];
	
	            key = entry.key;
	            sceneConfig = entry.scene;
	
	            var newScene;
	
	            if (sceneConfig instanceof Scene)
	            {
	                newScene = this.createSceneFromInstance(key, sceneConfig);
	            }
	            else if (typeof sceneConfig === 'object')
	            {
	                newScene = this.createSceneFromObject(key, sceneConfig);
	            }
	            else if (typeof sceneConfig === 'function')
	            {
	                newScene = this.createSceneFromFunction(key, sceneConfig);
	            }
	
	            //  Replace key in case the scene changed it
	            key = newScene.sys.settings.key;
	
	            this.keys[key] = newScene;
	
	            this.scenes.push(newScene);
	
	            //  Any data to inject?
	            if (this._data[key])
	            {
	                newScene.sys.settings.data = this._data[key].data;
	
	                if (this._data[key].autoStart)
	                {
	                    entry.autoStart = true;
	                }
	            }
	
	            if (entry.autoStart || newScene.sys.settings.active)
	            {
	                this._start.push(key);
	            }
	        }
	
	        //  Clear the pending lists
	        this._pending.length = 0;
	
	        this._data = {};
	
	        this.isBooted = true;
	
	        //  _start might have been populated by the above
	        for (i = 0; i < this._start.length; i++)
	        {
	            entry = this._start[i];
	
	            this.start(entry);
	        }
	
	        this._start.length = 0;
	    },
	
	    /**
	     * Process the Scene operations queue.
	     *
	     * @method Phaser.Scenes.SceneManager#processQueue
	     * @since 3.0.0
	     */
	    processQueue: function ()
	    {
	        var pendingLength = this._pending.length;
	        var queueLength = this._queue.length;
	
	        if (pendingLength === 0 && queueLength === 0)
	        {
	            return;
	        }
	
	        var i;
	        var entry;
	
	        if (pendingLength)
	        {
	            for (i = 0; i < pendingLength; i++)
	            {
	                entry = this._pending[i];
	
	                this.add(entry.key, entry.scene, entry.autoStart, entry.data);
	            }
	
	            //  _start might have been populated by this.add
	            for (i = 0; i < this._start.length; i++)
	            {
	                entry = this._start[i];
	
	                this.start(entry);
	            }
	
	            //  Clear the pending lists
	            this._start.length = 0;
	            this._pending.length = 0;
	
	            return;
	        }
	
	        for (i = 0; i < this._queue.length; i++)
	        {
	            entry = this._queue[i];
	
	            this[entry.op](entry.keyA, entry.keyB);
	        }
	
	        this._queue.length = 0;
	    },
	
	    /**
	     * Adds a new Scene into the SceneManager.
	     * You must give each Scene a unique key by which you'll identify it.
	     *
	     * The `sceneConfig` can be:
	     *
	     * * A `Phaser.Scene` object, or an object that extends it.
	     * * A plain JavaScript object
	     * * A JavaScript ES6 Class that extends `Phaser.Scene`
	     * * A JavaScript ES5 prototype based Class
	     * * A JavaScript function
	     *
	     * If a function is given then a new Scene will be created by calling it.
	     *
	     * @method Phaser.Scenes.SceneManager#add
	     * @since 3.0.0
	     *
	     * @param {string} key - A unique key used to reference the Scene, i.e. `MainMenu` or `Level1`.
	     * @param {(Phaser.Scene|Phaser.Scenes.Settings.Config|function)} sceneConfig - The config for the Scene
	     * @param {boolean} [autoStart=false] - If `true` the Scene will be started immediately after being added.
	     * @param {object} [data] - Optional data object. This will be set as Scene.settings.data and passed to `Scene.init`.
	     *
	     * @return {?Phaser.Scene} The added Scene, if it was added immediately, otherwise `null`.
	     */
	    add: function (key, sceneConfig, autoStart, data)
	    {
	        if (autoStart === undefined) { autoStart = false; }
	        if (data === undefined) { data = {}; }
	
	        //  If processing or not booted then put scene into a holding pattern
	        if (this.isProcessing || !this.isBooted)
	        {
	            this._pending.push({
	                key: key,
	                scene: sceneConfig,
	                autoStart: autoStart,
	                data: data
	            });
	
	            if (!this.isBooted)
	            {
	                this._data[key] = { data: data };
	            }
	
	            return null;
	        }
	
	        key = this.getKey(key, sceneConfig);
	
	        var newScene;
	
	        if (sceneConfig instanceof Scene)
	        {
	            newScene = this.createSceneFromInstance(key, sceneConfig);
	        }
	        else if (typeof sceneConfig === 'object')
	        {
	            sceneConfig.key = key;
	
	            newScene = this.createSceneFromObject(key, sceneConfig);
	        }
	        else if (typeof sceneConfig === 'function')
	        {
	            newScene = this.createSceneFromFunction(key, sceneConfig);
	        }
	
	        //  Any data to inject?
	        newScene.sys.settings.data = data;
	
	        //  Replace key in case the scene changed it
	        key = newScene.sys.settings.key;
	
	        this.keys[key] = newScene;
	
	        this.scenes.push(newScene);
	
	        if (autoStart || newScene.sys.settings.active)
	        {
	            if (this._pending.length)
	            {
	                this._start.push(key);
	            }
	            else
	            {
	                this.start(key);
	            }
	        }
	
	        return newScene;
	    },
	
	    /**
	     * Removes a Scene from the SceneManager.
	     *
	     * The Scene is removed from the local scenes array, it's key is cleared from the keys
	     * cache and Scene.Systems.destroy is then called on it.
	     *
	     * If the SceneManager is processing the Scenes when this method is called it wil
	     * queue the operation for the next update sequence.
	     *
	     * @method Phaser.Scenes.SceneManager#remove
	     * @since 3.2.0
	     *
	     * @param {(string|Phaser.Scene)} scene - The Scene to be removed.
	     *
	     * @return {Phaser.Scenes.SceneManager} This SceneManager.
	     */
	    remove: function (key)
	    {
	        if (this.isProcessing)
	        {
	            this._queue.push({ op: 'remove', keyA: key, keyB: null });
	        }
	        else
	        {
	            var sceneToRemove = this.getScene(key);
	
	            if (!sceneToRemove || sceneToRemove.sys.isTransitioning())
	            {
	                return this;
	            }
	
	            var index = this.scenes.indexOf(sceneToRemove);
	            var sceneKey = sceneToRemove.sys.settings.key;
	
	            if (index > -1)
	            {
	                delete this.keys[sceneKey];
	                this.scenes.splice(index, 1);
	
	                if (this._start.indexOf(sceneKey) > -1)
	                {
	                    index = this._start.indexOf(sceneKey);
	                    this._start.splice(index, 1);
	                }
	
	                sceneToRemove.sys.destroy();
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Boot the given Scene.
	     *
	     * @method Phaser.Scenes.SceneManager#bootScene
	     * @private
	     * @since 3.0.0
	     *
	     * @param {Phaser.Scene} scene - The Scene to boot.
	     */
	    bootScene: function (scene)
	    {
	        var sys = scene.sys;
	        var settings = sys.settings;
	
	        if (scene.init)
	        {
	            scene.init.call(scene, settings.data);
	
	            if (settings.isTransition)
	            {
	                sys.events.emit('transitioninit', settings.transitionFrom, settings.transitionDuration);
	            }
	        }
	
	        var loader;
	
	        if (sys.load)
	        {
	            loader = sys.load;
	
	            loader.reset();
	        }
	
	        if (loader && scene.preload)
	        {
	            scene.preload.call(scene);
	
	            //  Is the loader empty?
	            if (loader.list.size === 0)
	            {
	                this.create(scene);
	            }
	            else
	            {
	                settings.status = CONST.LOADING;
	
	                //  Start the loader going as we have something in the queue
	                loader.once('complete', this.loadComplete, this);
	
	                loader.start();
	            }
	        }
	        else
	        {
	            //  No preload? Then there was nothing to load either
	            this.create(scene);
	        }
	    },
	
	    /**
	     * Handles load completion for a Scene's Loader.
	     *
	     * Starts the Scene that the Loader belongs to.
	     *
	     * @method Phaser.Scenes.SceneManager#loadComplete
	     * @private
	     * @since 3.0.0
	     *
	     * @param {Phaser.Loader.LoaderPlugin} loader - The loader that has completed loading.
	     */
	    loadComplete: function (loader)
	    {
	        var scene = loader.scene;
	
	        // Try to unlock HTML5 sounds every time any loader completes
	        if (this.game.sound.onBlurPausedSounds)
	        {
	            this.game.sound.unlock();
	        }
	
	        this.create(scene);
	    },
	
	    /**
	     * Handle payload completion for a Scene.
	     *
	     * @method Phaser.Scenes.SceneManager#payloadComplete
	     * @private
	     * @since 3.0.0
	     *
	     * @param {Phaser.Loader.LoaderPlugin} loader - The loader that has completed loading its Scene's payload.
	     */
	    payloadComplete: function (loader)
	    {
	        this.bootScene(loader.scene);
	    },
	
	    /**
	     * Updates the Scenes.
	     *
	     * @method Phaser.Scenes.SceneManager#update
	     * @since 3.0.0
	     *
	     * @param {number} time - Time elapsed.
	     * @param {number} delta - Delta time from the last update.
	     */
	    update: function (time, delta)
	    {
	        this.processQueue();
	
	        this.isProcessing = true;
	
	        //  Loop through the active scenes in reverse order
	        for (var i = this.scenes.length - 1; i >= 0; i--)
	        {
	            var sys = this.scenes[i].sys;
	
	            if (sys.settings.status === CONST.RUNNING)
	            {
	                sys.step(time, delta);
	            }
	        }
	    },
	
	    /**
	     * Informs the Scenes of the Game being resized.
	     *
	     * @method Phaser.Scenes.SceneManager#resize
	     * @since 3.2.0
	     *
	     * @param {number} width - The new width of the game.
	     * @param {number} height - The new height of the game.
	     */
	    resize: function (width, height)
	    {
	        //  Loop through the scenes in forward order
	        for (var i = 0; i < this.scenes.length; i++)
	        {
	            var sys = this.scenes[i].sys;
	
	            sys.resize(width, height);
	        }
	    },
	
	    /**
	     * Renders the Scenes.
	     *
	     * @method Phaser.Scenes.SceneManager#render
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The renderer to use.
	     */
	    render: function (renderer)
	    {
	        //  Loop through the scenes in forward order
	        for (var i = 0; i < this.scenes.length; i++)
	        {
	            var sys = this.scenes[i].sys;
	
	            if (sys.settings.visible && sys.settings.status >= CONST.LOADING && sys.settings.status < CONST.SLEEPING)
	            {
	                sys.render(renderer);
	            }
	        }
	
	        this.isProcessing = false;
	    },
	
	    /**
	     * Calls the given Scene's {@link Phaser.Scene#create} method and updates its status.
	     *
	     * @method Phaser.Scenes.SceneManager#create
	     * @private
	     * @since 3.0.0
	     *
	     * @param {Phaser.Scene} scene - The Scene to create.
	     */
	    create: function (scene)
	    {
	        var sys = scene.sys;
	        var settings = sys.settings;
	
	        if (scene.create)
	        {
	            scene.sys.settings.status = CONST.CREATING;
	
	            scene.create.call(scene, scene.sys.settings.data);
	
	            if (settings.isTransition)
	            {
	                sys.events.emit('transitionstart', settings.transitionFrom, settings.transitionDuration);
	            }
	        }
	
	        settings.status = CONST.RUNNING;
	    },
	
	    /**
	     * Creates and initializes a Scene from a function.
	     *
	     * @method Phaser.Scenes.SceneManager#createSceneFromFunction
	     * @private
	     * @since 3.0.0
	     *
	     * @param {string} key - The key of the Scene.
	     * @param {function} scene - The function to create the Scene from.
	     *
	     * @return {Phaser.Scene} The created Scene.
	     */
	    createSceneFromFunction: function (key, scene)
	    {
	        var newScene = new scene();
	
	        if (newScene instanceof Scene)
	        {
	            var configKey = newScene.sys.settings.key;
	
	            if (configKey !== '')
	            {
	                key = configKey;
	            }
	
	            if (this.keys.hasOwnProperty(key))
	            {
	                throw new Error('Cannot add a Scene with duplicate key: ' + key);
	            }
	
	            return this.createSceneFromInstance(key, newScene);
	        }
	        else
	        {
	            newScene.sys = new Systems(newScene);
	
	            newScene.sys.settings.key = key;
	
	            newScene.sys.init(this.game);
	
	            if (!newScene.update)
	            {
	                newScene.update = NOOP;
	            }
	
	            return newScene;
	        }
	    },
	
	    /**
	     * Creates and initializes a Scene instance.
	     *
	     * @method Phaser.Scenes.SceneManager#createSceneFromInstance
	     * @private
	     * @since 3.0.0
	     *
	     * @param {string} key - The key of the Scene.
	     * @param {Phaser.Scene} newScene - The Scene instance.
	     *
	     * @return {Phaser.Scene} The created Scene.
	     */
	    createSceneFromInstance: function (key, newScene)
	    {
	        var configKey = newScene.sys.settings.key;
	
	        if (configKey !== '')
	        {
	            key = configKey;
	        }
	        else
	        {
	            newScene.sys.settings.key = key;
	        }
	
	        newScene.sys.init(this.game);
	
	        return newScene;
	    },
	
	    /**
	     * Creates and initializes a Scene from an Object definition.
	     *
	     * @method Phaser.Scenes.SceneManager#createSceneFromObject
	     * @private
	     * @since 3.0.0
	     *
	     * @param {string} key - The key of the Scene.
	     * @param {(string|Phaser.Scenes.Settings.Config)} sceneConfig - The Scene config.
	     *
	     * @return {Phaser.Scene} The created Scene.
	     */
	    createSceneFromObject: function (key, sceneConfig)
	    {
	        var newScene = new Scene(sceneConfig);
	
	        var configKey = newScene.sys.settings.key;
	
	        if (configKey !== '')
	        {
	            key = configKey;
	        }
	        else
	        {
	            newScene.sys.settings.key = key;
	        }
	
	        newScene.sys.init(this.game);
	
	        //  Extract callbacks
	
	        var defaults = [ 'init', 'preload', 'create', 'update', 'render' ];
	
	        for (var i = 0; i < defaults.length; i++)
	        {
	            var sceneCallback = GetValue(sceneConfig, defaults[i], null);
	
	            //  Must always have an update function, no matter what (the rest are optional)
	            if (defaults[i] === 'update' && !sceneCallback)
	            {
	                sceneCallback = NOOP;
	            }
	
	            if (sceneCallback)
	            {
	                newScene[defaults[i]] = sceneCallback;
	            }
	        }
	
	        //  Now let's move across any other functions or properties that may exist in the extend object:
	
	        /*
	        scene: {
	            preload: preload,
	            create: create,
	            extend: {
	                hello: 1,
	                test: 'atari',
	                addImage: addImage
	            }
	        }
	        */
	
	        if (sceneConfig.hasOwnProperty('extend'))
	        {
	            for (var propertyKey in sceneConfig.extend)
	            {
	                var value = sceneConfig.extend[propertyKey];
	
	                if (propertyKey === 'data' && newScene.hasOwnProperty('data') && typeof value === 'object')
	                {
	                    //  Populate the DataManager
	                    newScene.data.merge(value);
	                }
	                else if (propertyKey !== 'sys')
	                {
	                    newScene[propertyKey] = value;
	                }
	            }
	        }
	
	        return newScene;
	    },
	
	    /**
	     * Retrieves the key of a Scene from a Scene config.
	     *
	     * @method Phaser.Scenes.SceneManager#getKey
	     * @private
	     * @since 3.0.0
	     *
	     * @param {string} key - The key to check in the Scene config.
	     * @param {(Phaser.Scene|Phaser.Scenes.Settings.Config|function)} sceneConfig - The Scene config.
	     *
	     * @return {string} The Scene key.
	     */
	    getKey: function (key, sceneConfig)
	    {
	        if (!key) { key = 'default'; }
	
	        if (typeof sceneConfig === 'function')
	        {
	            return key;
	        }
	        else if (sceneConfig instanceof Scene)
	        {
	            key = sceneConfig.sys.settings.key;
	        }
	        else if (typeof sceneConfig === 'object' && sceneConfig.hasOwnProperty('key'))
	        {
	            key = sceneConfig.key;
	        }
	
	        //  By this point it's either 'default' or extracted from the Scene
	
	        if (this.keys.hasOwnProperty(key))
	        {
	            throw new Error('Cannot add a Scene with duplicate key: ' + key);
	        }
	        else
	        {
	            return key;
	        }
	    },
	
	    /**
	     * Retrieves a Scene.
	     *
	     * @method Phaser.Scenes.SceneManager#getScene
	     * @since 3.0.0
	     *
	     * @param {string|Phaser.Scene} key - The Scene to retrieve.
	     *
	     * @return {?Phaser.Scene} The Scene.
	     */
	    getScene: function (key)
	    {
	        if (typeof key === 'string')
	        {
	            if (this.keys[key])
	            {
	                return this.keys[key];
	            }
	        }
	        else
	        {
	            for (var i = 0; i < this.scenes.length; i++)
	            {
	                if (key === this.scenes[i])
	                {
	                    return key;
	                }
	            }
	        }
	
	        return null;
	    },
	
	    /**
	     * Determines whether a Scene is active.
	     *
	     * @method Phaser.Scenes.SceneManager#isActive
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to check.
	     *
	     * @return {boolean} Whether the Scene is active.
	     */
	    isActive: function (key)
	    {
	        var scene = this.getScene(key);
	
	        if (scene)
	        {
	            return scene.sys.isActive();
	        }
	
	        return null;
	    },
	
	    /**
	     * Determines whether a Scene is visible.
	     *
	     * @method Phaser.Scenes.SceneManager#isVisible
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to check.
	     *
	     * @return {boolean} Whether the Scene is visible.
	     */
	    isVisible: function (key)
	    {
	        var scene = this.getScene(key);
	
	        if (scene)
	        {
	            return scene.sys.isVisible();
	        }
	
	        return null;
	    },
	
	    /**
	     * Determines whether a Scene is sleeping.
	     *
	     * @method Phaser.Scenes.SceneManager#isSleeping
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to check.
	     *
	     * @return {boolean} Whether the Scene is sleeping.
	     */
	    isSleeping: function (key)
	    {
	        var scene = this.getScene(key);
	
	        if (scene)
	        {
	            return scene.sys.isSleeping();
	        }
	
	        return null;
	    },
	
	    /**
	     * Pauses the given Scene.
	     *
	     * @method Phaser.Scenes.SceneManager#pause
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to pause.
	     *
	     * @return {Phaser.Scenes.SceneManager} This SceneManager.
	     */
	    pause: function (key)
	    {
	        var scene = this.getScene(key);
	
	        if (scene)
	        {
	            scene.sys.pause();
	        }
	
	        return this;
	    },
	
	    /**
	     * Resumes the given Scene.
	     *
	     * @method Phaser.Scenes.SceneManager#resume
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to resume.
	     *
	     * @return {Phaser.Scenes.SceneManager} This SceneManager.
	     */
	    resume: function (key)
	    {
	        var scene = this.getScene(key);
	
	        if (scene)
	        {
	            scene.sys.resume();
	        }
	
	        return this;
	    },
	
	    /**
	     * Puts the given Scene to sleep.
	     *
	     * @method Phaser.Scenes.SceneManager#sleep
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to put to sleep.
	     *
	     * @return {Phaser.Scenes.SceneManager} This SceneManager.
	     */
	    sleep: function (key)
	    {
	        var scene = this.getScene(key);
	
	        if (scene && !scene.sys.isTransitioning())
	        {
	            scene.sys.sleep();
	        }
	
	        return this;
	    },
	
	    /**
	     * Awakens the given Scene.
	     *
	     * @method Phaser.Scenes.SceneManager#wake
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to wake up.
	     *
	     * @return {Phaser.Scenes.SceneManager} This SceneManager.
	     */
	    wake: function (key)
	    {
	        var scene = this.getScene(key);
	
	        if (scene)
	        {
	            scene.sys.wake();
	        }
	
	        return this;
	    },
	
	    /**
	     * Starts the given Scene.
	     *
	     * @method Phaser.Scenes.SceneManager#start
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to start.
	     * @param {object} [data] - Optional data object to pass to Scene.Settings and Scene.init.
	     *
	     * @return {Phaser.Scenes.SceneManager} This SceneManager.
	     */
	    start: function (key, data)
	    {
	        //  If the Scene Manager is not running, then put the Scene into a holding pattern
	        if (!this.isBooted)
	        {
	            this._data[key] = {
	                autoStart: true,
	                data: data
	            };
	
	            return this;
	        }
	
	        var scene = this.getScene(key);
	
	        if (scene)
	        {
	            scene.sys.start(data);
	
	            var loader;
	
	            if (scene.sys.load)
	            {
	                loader = scene.sys.load;
	            }
	
	            //  Files payload?
	            if (loader && scene.sys.settings.hasOwnProperty('pack'))
	            {
	                loader.reset();
	
	                if (loader.addPack({ payload: scene.sys.settings.pack }))
	                {
	                    scene.sys.settings.status = CONST.LOADING;
	
	                    loader.once('complete', this.payloadComplete, this);
	
	                    loader.start();
	
	                    return this;
	                }
	            }
	
	            this.bootScene(scene);
	        }
	
	        return this;
	    },
	
	    /**
	     * Stops the given Scene.
	     *
	     * @method Phaser.Scenes.SceneManager#stop
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to stop.
	     *
	     * @return {Phaser.Scenes.SceneManager} This SceneManager.
	     */
	    stop: function (key)
	    {
	        var scene = this.getScene(key);
	
	        if (scene && !scene.sys.isTransitioning())
	        {
	            scene.sys.shutdown();
	        }
	
	        return this;
	    },
	
	    /**
	     * Sleeps one one Scene and starts the other.
	     *
	     * @method Phaser.Scenes.SceneManager#switch
	     * @since 3.0.0
	     *
	     * @param {string} from - The Scene to sleep.
	     * @param {string} to - The Scene to start.
	     *
	     * @return {Phaser.Scenes.SceneManager} This SceneManager.
	     */
	    switch: function (from, to)
	    {
	        var sceneA = this.getScene(from);
	        var sceneB = this.getScene(to);
	
	        if (sceneA && sceneB && sceneA !== sceneB)
	        {
	            this.sleep(from);
	
	            if (this.isSleeping(to))
	            {
	                this.wake(to);
	            }
	            else
	            {
	                this.start(to);
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Retrieves a Scene by numeric index.
	     *
	     * @method Phaser.Scenes.SceneManager#getAt
	     * @since 3.0.0
	     *
	     * @param {integer} index - The index of the Scene to retrieve.
	     *
	     * @return {(Phaser.Scene|undefined)} The Scene.
	     */
	    getAt: function (index)
	    {
	        return this.scenes[index];
	    },
	
	    /**
	     * Retrieves the numeric index of a Scene.
	     *
	     * @method Phaser.Scenes.SceneManager#getIndex
	     * @since 3.0.0
	     *
	     * @param {(string|Phaser.Scene)} key - The key of the Scene.
	     *
	     * @return {integer} The index of the Scene.
	     */
	    getIndex: function (key)
	    {
	        var scene = this.getScene(key);
	
	        return this.scenes.indexOf(scene);
	    },
	
	    /**
	     * Brings a Scene to the top of the Scenes list.
	     *
	     * This means it will render above all other Scenes.
	     *
	     * @method Phaser.Scenes.SceneManager#bringToTop
	     * @since 3.0.0
	     *
	     * @param {(string|Phaser.Scene)} key - The Scene to move.
	     *
	     * @return {Phaser.Scenes.SceneManager} This SceneManager.
	     */
	    bringToTop: function (key)
	    {
	        if (this.isProcessing)
	        {
	            this._queue.push({ op: 'bringToTop', keyA: key, keyB: null });
	        }
	        else
	        {
	            var index = this.getIndex(key);
	
	            if (index !== -1 && index < this.scenes.length)
	            {
	                var scene = this.getScene(key);
	
	                this.scenes.splice(index, 1);
	                this.scenes.push(scene);
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Sends a Scene to the back of the Scenes list.
	     *
	     * This means it will render below all other Scenes.
	     *
	     * @method Phaser.Scenes.SceneManager#sendToBack
	     * @since 3.0.0
	     *
	     * @param {(string|Phaser.Scene)} key - The Scene to move.
	     *
	     * @return {Phaser.Scenes.SceneManager} This SceneManager.
	     */
	    sendToBack: function (key)
	    {
	        if (this.isProcessing)
	        {
	            this._queue.push({ op: 'sendToBack', keyA: key, keyB: null });
	        }
	        else
	        {
	            var index = this.getIndex(key);
	
	            if (index !== -1 && index > 0)
	            {
	                var scene = this.getScene(key);
	
	                this.scenes.splice(index, 1);
	                this.scenes.unshift(scene);
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Moves a Scene down one position in the Scenes list.
	     *
	     * @method Phaser.Scenes.SceneManager#moveDown
	     * @since 3.0.0
	     *
	     * @param {(string|Phaser.Scene)} key - The Scene to move.
	     *
	     * @return {Phaser.Scenes.SceneManager} This SceneManager.
	     */
	    moveDown: function (key)
	    {
	        if (this.isProcessing)
	        {
	            this._queue.push({ op: 'moveDown', keyA: key, keyB: null });
	        }
	        else
	        {
	            var indexA = this.getIndex(key);
	
	            if (indexA > 0)
	            {
	                var indexB = indexA - 1;
	                var sceneA = this.getScene(key);
	                var sceneB = this.getAt(indexB);
	
	                this.scenes[indexA] = sceneB;
	                this.scenes[indexB] = sceneA;
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Moves a Scene up one position in the Scenes list.
	     *
	     * @method Phaser.Scenes.SceneManager#moveUp
	     * @since 3.0.0
	     *
	     * @param {(string|Phaser.Scene)} key - The Scene to move.
	     *
	     * @return {Phaser.Scenes.SceneManager} This SceneManager.
	     */
	    moveUp: function (key)
	    {
	        if (this.isProcessing)
	        {
	            this._queue.push({ op: 'moveUp', keyA: key, keyB: null });
	        }
	        else
	        {
	            var indexA = this.getIndex(key);
	
	            if (indexA < this.scenes.length - 1)
	            {
	                var indexB = indexA + 1;
	                var sceneA = this.getScene(key);
	                var sceneB = this.getAt(indexB);
	
	                this.scenes[indexA] = sceneB;
	                this.scenes[indexB] = sceneA;
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Moves a Scene so it is immediately above another Scene in the Scenes list.
	     *
	     * This means it will render over the top of the other Scene.
	     *
	     * @method Phaser.Scenes.SceneManager#moveAbove
	     * @since 3.2.0
	     *
	     * @param {(string|Phaser.Scene)} keyA - The Scene that Scene B will be moved above.
	     * @param {(string|Phaser.Scene)} keyB - The Scene to be moved.
	     *
	     * @return {Phaser.Scenes.SceneManager} This SceneManager.
	     */
	    moveAbove: function (keyA, keyB)
	    {
	        if (keyA === keyB)
	        {
	            return this;
	        }
	
	        if (this.isProcessing)
	        {
	            this._queue.push({ op: 'moveAbove', keyA: keyA, keyB: keyB });
	        }
	        else
	        {
	            var indexA = this.getIndex(keyA);
	            var indexB = this.getIndex(keyB);
	
	            if (indexA !== -1 && indexB !== -1)
	            {
	                var tempScene = this.getAt(indexB);
	
	                //  Remove
	                this.scenes.splice(indexB, 1);
	
	                //  Add in new location
	                this.scenes.splice(indexA + 1, 0, tempScene);
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Moves a Scene so it is immediately below another Scene in the Scenes list.
	     *
	     * This means it will render behind the other Scene.
	     *
	     * @method Phaser.Scenes.SceneManager#moveBelow
	     * @since 3.2.0
	     *
	     * @param {(string|Phaser.Scene)} keyA - The Scene that Scene B will be moved above.
	     * @param {(string|Phaser.Scene)} keyB - The Scene to be moved.
	     *
	     * @return {Phaser.Scenes.SceneManager} This SceneManager.
	     */
	    moveBelow: function (keyA, keyB)
	    {
	        if (keyA === keyB)
	        {
	            return this;
	        }
	
	        if (this.isProcessing)
	        {
	            this._queue.push({ op: 'moveBelow', keyA: keyA, keyB: keyB });
	        }
	        else
	        {
	            var indexA = this.getIndex(keyA);
	            var indexB = this.getIndex(keyB);
	
	            if (indexA !== -1 && indexB !== -1)
	            {
	                var tempScene = this.getAt(indexB);
	
	                //  Remove
	                this.scenes.splice(indexB, 1);
	
	                if (indexA === 0)
	                {
	                    this.scenes.unshift(tempScene);
	                }
	                else
	                {
	                    //  Add in new location
	                    this.scenes.splice(indexA, 0, tempScene);
	                }
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Queue a Scene operation for the next update.
	     *
	     * @method Phaser.Scenes.SceneManager#queueOp
	     * @private
	     * @since 3.0.0
	     *
	     * @param {string} op - The operation to perform.
	     * @param {(string|Phaser.Scene)} keyA - Scene A.
	     * @param {(string|Phaser.Scene)} [keyB] - Scene B.
	     *
	     * @return {Phaser.Scenes.SceneManager} This SceneManager.
	     */
	    queueOp: function (op, keyA, keyB)
	    {
	        this._queue.push({ op: op, keyA: keyA, keyB: keyB });
	
	        return this;
	    },
	
	    /**
	     * Swaps the positions of two Scenes in the Scenes list.
	     *
	     * @method Phaser.Scenes.SceneManager#swapPosition
	     * @since 3.0.0
	     *
	     * @param {(string|Phaser.Scene)} keyA - The first Scene to swap.
	     * @param {(string|Phaser.Scene)} keyB - The second Scene to swap.
	     *
	     * @return {Phaser.Scenes.SceneManager} This SceneManager.
	     */
	    swapPosition: function (keyA, keyB)
	    {
	        if (keyA === keyB)
	        {
	            return this;
	        }
	
	        if (this.isProcessing)
	        {
	            this._queue.push({ op: 'swapPosition', keyA: keyA, keyB: keyB });
	        }
	        else
	        {
	            var indexA = this.getIndex(keyA);
	            var indexB = this.getIndex(keyB);
	
	            if (indexA !== indexB && indexA !== -1 && indexB !== -1)
	            {
	                var tempScene = this.getAt(indexA);
	
	                this.scenes[indexA] = this.scenes[indexB];
	                this.scenes[indexB] = tempScene;
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Dumps debug information about each Scene to the developer console.
	     *
	     * @method Phaser.Scenes.SceneManager#dump
	     * @since 3.2.0
	     */
	    dump: function ()
	    {
	        var out = [];
	        var map = [ 'pending', 'init', 'start', 'loading', 'creating', 'running', 'paused', 'sleeping', 'shutdown', 'destroyed' ];
	
	        for (var i = 0; i < this.scenes.length; i++)
	        {
	            var sys = this.scenes[i].sys;
	
	            var key = (sys.settings.visible && (sys.settings.status === CONST.RUNNING || sys.settings.status === CONST.PAUSED)) ? '[*] ' : '[-] ';
	            key += sys.settings.key + ' (' + map[sys.settings.status] + ')';
	
	            out.push(key);
	        }
	
	        console.log(out.join('\n'));
	    },
	
	    /**
	     * Destroy the SceneManager and all of its Scene's systems.
	     *
	     * @method Phaser.Scenes.SceneManager#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        for (var i = this.scenes.length - 1; i >= 0; i--)
	        {
	            var sys = this.scenes[i].sys;
	
	            sys.destroy();
	        }
	
	        this.update = NOOP;
	
	        this.scenes = [];
	
	        this._pending = [];
	        this._start = [];
	        this._queue = [];
	
	        this.game = null;
	    }
	
	});
	
	module.exports = SceneManager;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CONST = __webpack_require__(168);
	var GetValue = __webpack_require__(10);
	var Merge = __webpack_require__(148);
	var InjectionMap = __webpack_require__(1515);
	
	/**
	 * @namespace Phaser.Scenes.Settings
	 */
	
	/**
	 * @typedef {object} Phaser.Scenes.Settings.Config
	 *
	 * @property {string} [key] - [description]
	 * @property {boolean} [active=false] - [description]
	 * @property {boolean} [visible=true] - [description]
	 * @property {(false|Phaser.Loader.FileTypes.PackFileConfig)} [pack=false] - [description]
	 * @property {?(InputJSONCameraObject|InputJSONCameraObject[])} [cameras=null] - [description]
	 * @property {Object.<string, string>} [map] - Overwrites the default injection map for a scene.
	 * @property {Object.<string, string>} [mapAdd] - Extends the injection map for a scene.
	 * @property {object} [physics={}] - [description]
	 * @property {object} [loader={}] - [description]
	 * @property {(false|*)} [plugins=false] - [description]
	 */
	
	/**
	 * @typedef {object} Phaser.Scenes.Settings.Object
	 *
	 * @property {number} status - [description]
	 * @property {string} key - [description]
	 * @property {boolean} active - [description]
	 * @property {boolean} visible - [description]
	 * @property {boolean} isBooted - [description]
	 * @property {boolean} isTransition - [description]
	 * @property {?Phaser.Scene} transitionFrom - [description]
	 * @property {integer} transitionDuration - [description]
	 * @property {boolean} transitionAllowInput - [description]
	 * @property {object} data - [description]
	 * @property {(false|Phaser.Loader.FileTypes.PackFileConfig)} pack - [description]
	 * @property {?(InputJSONCameraObject|InputJSONCameraObject[])} cameras - [description]
	 * @property {Object.<string, string>} map - [description]
	 * @property {object} physics - [description]
	 * @property {object} loader - [description]
	 * @property {(false|*)} plugins - [description]
	 */
	
	var Settings = {
	
	    /**
	     * Takes a Scene configuration object and returns a fully formed Systems object.
	     *
	     * @function Phaser.Scenes.Settings.create
	     * @since 3.0.0
	     *
	     * @param {(string|Phaser.Scenes.Settings.Config)} config - [description]
	     *
	     * @return {Phaser.Scenes.Settings.Object} [description]
	     */
	    create: function (config)
	    {
	        if (typeof config === 'string')
	        {
	            config = { key: config };
	        }
	        else if (config === undefined)
	        {
	            //  Pass the 'hasOwnProperty' checks
	            config = {};
	        }
	
	        return {
	
	            status: CONST.PENDING,
	
	            key: GetValue(config, 'key', ''),
	            active: GetValue(config, 'active', false),
	            visible: GetValue(config, 'visible', true),
	
	            isBooted: false,
	
	            isTransition: false,
	            transitionFrom: null,
	            transitionDuration: 0,
	            transitionAllowInput: true,
	
	            //  Loader payload array
	
	            data: {},
	
	            pack: GetValue(config, 'pack', false),
	
	            //  Cameras
	
	            cameras: GetValue(config, 'cameras', null),
	
	            //  Scene Property Injection Map
	
	            map: GetValue(config, 'map', Merge(InjectionMap, GetValue(config, 'mapAdd', {}))),
	
	            //  Physics
	
	            physics: GetValue(config, 'physics', {}),
	
	            //  Loader
	
	            loader: GetValue(config, 'loader', {}),
	
	            //  Plugins
	
	            plugins: GetValue(config, 'plugins', false)
	
	        };
	    }
	
	};
	
	module.exports = Settings;


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var HTML5AudioSoundManager = __webpack_require__(627);
	var NoAudioSoundManager = __webpack_require__(629);
	var WebAudioSoundManager = __webpack_require__(631);
	
	/**
	 * Creates a Web Audio, HTML5 Audio or No Audio Sound Manager based on config and device settings.
	 *
	 * Be aware of https://developers.google.com/web/updates/2017/09/autoplay-policy-changes
	 *
	 * @function Phaser.Sound.SoundManagerCreator
	 * @since 3.0.0
	 *
	 * @param {Phaser.Game} game - Reference to the current game instance.
	 */
	var SoundManagerCreator = {
	
	    create: function (game)
	    {
	        var audioConfig = game.config.audio;
	        var deviceAudio = game.device.audio;
	
	        if ((audioConfig && audioConfig.noAudio) || (!deviceAudio.webAudio && !deviceAudio.audioData))
	        {
	            return new NoAudioSoundManager(game);
	        }
	
	        if (deviceAudio.webAudio && !(audioConfig && audioConfig.disableWebAudio))
	        {
	            return new WebAudioSoundManager(game);
	        }
	
	        return new HTML5AudioSoundManager(game);
	    }
	
	};
	
	module.exports = SoundManagerCreator;


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BaseSound = __webpack_require__(208);
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * HTML5 Audio implementation of the sound.
	 *
	 * @class HTML5AudioSound
	 * @extends Phaser.Sound.BaseSound
	 * @memberOf Phaser.Sound
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Sound.HTML5AudioSoundManager} manager - Reference to the current sound manager instance.
	 * @param {string} key - Asset key for the sound.
	 * @param {SoundConfig} [config={}] - An optional config object containing default sound settings.
	 */
	var HTML5AudioSound = new Class({
	
	    Extends: BaseSound,
	
	    initialize:
	
	    function HTML5AudioSound (manager, key, config)
	    {
	        if (config === undefined) { config = {}; }
	
	        /**
	         * An array containing all HTML5 Audio tags that could be used for individual
	         * sound's playback. Number of instances depends on the config value passed
	         * to the Loader#audio method call, default is 1.
	         *
	         * @name Phaser.Sound.HTML5AudioSound#tags
	         * @type {HTMLAudioElement[]}
	         * @private
	         * @since 3.0.0
	         */
	        this.tags = manager.game.cache.audio.get(key);
	
	        if (!this.tags)
	        {
	            // eslint-disable-next-line no-console
	            console.warn('Audio cache entry missing: ' + key);
	            return;
	        }
	
	        /**
	         * Reference to an HTML5 Audio tag used for playing sound.
	         *
	         * @name Phaser.Sound.HTML5AudioSound#audio
	         * @type {HTMLAudioElement}
	         * @private
	         * @default null
	         * @since 3.0.0
	         */
	        this.audio = null;
	
	        /**
	         * Timestamp as generated by the Request Animation Frame or SetTimeout
	         * representing the time at which the delayed sound playback should start.
	         * Set to 0 if sound playback is not delayed.
	         *
	         * @name Phaser.Sound.HTML5AudioSound#startTime
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this.startTime = 0;
	
	        /**
	         * Audio tag's playback position recorded on previous
	         * update method call. Set to 0 if sound is not playing.
	         *
	         * @name Phaser.Sound.HTML5AudioSound#previousTime
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this.previousTime = 0;
	
	        this.duration = this.tags[0].duration;
	
	        this.totalDuration = this.tags[0].duration;
	
	        BaseSound.call(this, manager, key, config);
	    },
	
	    /**
	     * @event Phaser.Sound.HTML5AudioSound#playEvent
	     * @param {Phaser.Sound.HTML5AudioSound} sound - Reference to the sound that emitted event.
	     */
	
	    /**
	     * Play this sound, or a marked section of it.
	     * It always plays the sound from the start. If you want to start playback from a specific time
	     * you can set 'seek' setting of the config object, provided to this call, to that value.
	     *
	     * @method Phaser.Sound.HTML5AudioSound#play
	     * @fires Phaser.Sound.HTML5AudioSound#playEvent
	     * @since 3.0.0
	     *
	     * @param {string} [markerName=''] - If you want to play a marker then provide the marker name here, otherwise omit it to play the full sound.
	     * @param {SoundConfig} [config] - Optional sound config object to be applied to this marker or entire sound if no marker name is provided. It gets memorized for future plays of current section of the sound.
	     *
	     * @return {boolean} Whether the sound started playing successfully.
	     */
	    play: function (markerName, config)
	    {
	        if (this.manager.isLocked(this, 'play', [ markerName, config ]))
	        {
	            return false;
	        }
	
	        if (!BaseSound.prototype.play.call(this, markerName, config))
	        {
	            return false;
	        }
	
	        //  \/\/\/ isPlaying = true, isPaused = false \/\/\/
	        if (!this.pickAndPlayAudioTag())
	        {
	            return false;
	        }
	
	        this.emit('play', this);
	
	        return true;
	    },
	
	    /**
	     * @event Phaser.Sound.HTML5AudioSound#pauseEvent
	     * @param {Phaser.Sound.HTML5AudioSound} sound - Reference to the sound that emitted event.
	     */
	
	    /**
	     * Pauses the sound.
	     *
	     * @method Phaser.Sound.HTML5AudioSound#pause
	     * @fires Phaser.Sound.HTML5AudioSound#pauseEvent
	     * @since 3.0.0
	     *
	     * @return {boolean} Whether the sound was paused successfully.
	     */
	    pause: function ()
	    {
	        if (this.manager.isLocked(this, 'pause'))
	        {
	            return false;
	        }
	
	        if (this.startTime > 0)
	        {
	            return false;
	        }
	
	        if (!BaseSound.prototype.pause.call(this))
	        {
	            return false;
	        }
	
	        //  \/\/\/ isPlaying = false, isPaused = true \/\/\/
	        this.currentConfig.seek = this.audio.currentTime - (this.currentMarker ? this.currentMarker.start : 0);
	
	        this.stopAndReleaseAudioTag();
	
	        this.emit('pause', this);
	
	        return true;
	    },
	
	    /**
	     * @event Phaser.Sound.HTML5AudioSound#resumeEvent
	     * @param {Phaser.Sound.HTML5AudioSound} sound - Reference to the sound that emitted event.
	     */
	
	    /**
	     * Resumes the sound.
	     *
	     * @method Phaser.Sound.HTML5AudioSound#resume
	     * @fires Phaser.Sound.HTML5AudioSound#resumeEvent
	     * @since 3.0.0
	     *
	     * @return {boolean} Whether the sound was resumed successfully.
	     */
	    resume: function ()
	    {
	        if (this.manager.isLocked(this, 'resume'))
	        {
	            return false;
	        }
	
	        if (this.startTime > 0)
	        {
	            return false;
	        }
	
	        if (!BaseSound.prototype.resume.call(this))
	        {
	            return false;
	        }
	
	        //  \/\/\/ isPlaying = true, isPaused = false \/\/\/
	        if (!this.pickAndPlayAudioTag())
	        {
	            return false;
	        }
	
	        this.emit('resume', this);
	
	        return true;
	    },
	
	    /**
	     * @event Phaser.Sound.HTML5AudioSound#stopEvent
	     * @param {Phaser.Sound.HTML5AudioSound} sound - Reference to the sound that emitted event.
	     */
	
	    /**
	     * Stop playing this sound.
	     *
	     * @method Phaser.Sound.HTML5AudioSound#stop
	     * @fires Phaser.Sound.HTML5AudioSound#stopEvent
	     * @since 3.0.0
	     *
	     * @return {boolean} Whether the sound was stopped successfully.
	     */
	    stop: function ()
	    {
	        if (this.manager.isLocked(this, 'stop'))
	        {
	            return false;
	        }
	
	        if (!BaseSound.prototype.stop.call(this))
	        {
	            return false;
	        }
	
	        //  \/\/\/ isPlaying = false, isPaused = false \/\/\/
	        this.stopAndReleaseAudioTag();
	
	        this.emit('stop', this);
	
	        return true;
	    },
	
	    /**
	     * Used internally to do what the name says.
	     *
	     * @method Phaser.Sound.HTML5AudioSound#pickAndPlayAudioTag
	     * @private
	     * @since 3.0.0
	     *
	     * @return {boolean} Whether the sound was assigned an audio tag successfully.
	     */
	    pickAndPlayAudioTag: function ()
	    {
	        if (!this.pickAudioTag())
	        {
	            this.reset();
	            return false;
	        }
	
	        var seek = this.currentConfig.seek;
	        var delay = this.currentConfig.delay;
	        var offset = (this.currentMarker ? this.currentMarker.start : 0) + seek;
	
	        this.previousTime = offset;
	        this.audio.currentTime = offset;
	        this.applyConfig();
	
	        if (delay === 0)
	        {
	            this.startTime = 0;
	
	            if (this.audio.paused)
	            {
	                this.playCatchPromise();
	            }
	        }
	        else
	        {
	            this.startTime = window.performance.now() + delay * 1000;
	
	            if (!this.audio.paused)
	            {
	                this.audio.pause();
	            }
	        }
	
	        this.resetConfig();
	
	        return true;
	    },
	
	    /**
	     * This method performs the audio tag pooling logic. It first looks for
	     * unused audio tag to assign to this sound object. If there are no unused
	     * audio tags, based on HTML5AudioSoundManager#override property value, it
	     * looks for sound with most advanced playback and hijacks its audio tag or
	     * does nothing.
	     *
	     * @method Phaser.Sound.HTML5AudioSound#pickAudioTag
	     * @private
	     * @since 3.0.0
	     *
	     * @return {boolean} Whether the sound was assigned an audio tag successfully.
	     */
	    pickAudioTag: function ()
	    {
	        if (this.audio)
	        {
	            return true;
	        }
	
	        for (var i = 0; i < this.tags.length; i++)
	        {
	            var audio = this.tags[i];
	
	            if (audio.dataset.used === 'false')
	            {
	                audio.dataset.used = 'true';
	                this.audio = audio;
	                return true;
	            }
	        }
	
	        if (!this.manager.override)
	        {
	            return false;
	        }
	
	        var otherSounds = [];
	
	        this.manager.forEachActiveSound(function (sound)
	        {
	            if (sound.key === this.key && sound.audio)
	            {
	                otherSounds.push(sound);
	            }
	        }, this);
	
	        otherSounds.sort(function (a1, a2)
	        {
	            if (a1.loop === a2.loop)
	            {
	                // sort by progress
	                return (a2.seek / a2.duration) - (a1.seek / a1.duration);
	            }
	            return a1.loop ? 1 : -1;
	        });
	
	        var selectedSound = otherSounds[0];
	
	        this.audio = selectedSound.audio;
	
	        selectedSound.reset();
	        selectedSound.audio = null;
	        selectedSound.startTime = 0;
	        selectedSound.previousTime = 0;
	
	        return true;
	    },
	
	    /**
	     * Method used for playing audio tag and catching possible exceptions
	     * thrown from rejected Promise returned from play method call.
	     *
	     * @method Phaser.Sound.HTML5AudioSound#playCatchPromise
	     * @private
	     * @since 3.0.0
	     */
	    playCatchPromise: function ()
	    {
	        var playPromise = this.audio.play();
	
	        if (playPromise)
	        {
	            // eslint-disable-next-line no-unused-vars
	            playPromise.catch(function (reason)
	            {
	                console.warn(reason);
	            });
	        }
	    },
	
	    /**
	     * Used internally to do what the name says.
	     *
	     * @method Phaser.Sound.HTML5AudioSound#stopAndReleaseAudioTag
	     * @private
	     * @since 3.0.0
	     */
	    stopAndReleaseAudioTag: function ()
	    {
	        this.audio.pause();
	        this.audio.dataset.used = 'false';
	        this.audio = null;
	        this.startTime = 0;
	        this.previousTime = 0;
	    },
	
	    /**
	     * Method used internally to reset sound state, usually when stopping sound
	     * or when hijacking audio tag from another sound.
	     *
	     * @method Phaser.Sound.HTML5AudioSound#reset
	     * @private
	     * @since 3.0.0
	     */
	    reset: function ()
	    {
	        BaseSound.prototype.stop.call(this);
	    },
	
	    /**
	     * Method used internally by sound manager for pausing sound if
	     * Phaser.Sound.HTML5AudioSoundManager#pauseOnBlur is set to true.
	     *
	     * @method Phaser.Sound.HTML5AudioSoundManager#onBlur
	     * @private
	     * @since 3.0.0
	     */
	    onBlur: function ()
	    {
	        this.isPlaying = false;
	        this.isPaused = true;
	
	        this.currentConfig.seek = this.audio.currentTime - (this.currentMarker ? this.currentMarker.start : 0);
	
	        this.currentConfig.delay = Math.max(0, (this.startTime - window.performance.now()) / 1000);
	
	        this.stopAndReleaseAudioTag();
	    },
	
	    /**
	     * Method used internally by sound manager for resuming sound if
	     * Phaser.Sound.HTML5AudioSoundManager#pauseOnBlur is set to true.
	     *
	     * @method Phaser.Sound.HTML5AudioSound#onFocus
	     * @private
	     * @since 3.0.0
	     */
	    onFocus: function ()
	    {
	        this.isPlaying = true;
	        this.isPaused = false;
	        this.pickAndPlayAudioTag();
	    },
	
	    /**
	     * @event Phaser.Sound.HTML5AudioSound#loopedEvent
	     * @param {Phaser.Sound.HTML5AudioSound} sound - Reference to the sound that emitted event.
	     */
	
	    /**
	     * @event Phaser.Sound.HTML5AudioSound#endedEvent
	     * @param {Phaser.Sound.HTML5AudioSound} sound - Reference to the sound that emitted event.
	     */
	
	    /**
	     * Update method called automatically by sound manager on every game step.
	     *
	     * @method Phaser.Sound.HTML5AudioSound#update
	     * @fires Phaser.Sound.HTML5AudioSound#loopedEvent
	     * @fires Phaser.Sound.HTML5AudioSound#endedEvent
	     * @protected
	     * @since 3.0.0
	     *
	     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
	     * @param {number} delta - The delta time elapsed since the last frame.
	     */
	    // eslint-disable-next-line no-unused-vars
	    update: function (time, delta)
	    {
	        if (!this.isPlaying)
	        {
	            return;
	        }
	
	        // handling delayed playback
	        if (this.startTime > 0)
	        {
	            if (this.startTime < time - this.manager.audioPlayDelay)
	            {
	                this.audio.currentTime += Math.max(0, time - this.startTime) / 1000;
	                this.startTime = 0;
	                this.previousTime = this.audio.currentTime;
	                this.playCatchPromise();
	            }
	
	            return;
	        }
	
	        // handle looping and ending
	        var startTime = this.currentMarker ? this.currentMarker.start : 0;
	        var endTime = startTime + this.duration;
	        var currentTime = this.audio.currentTime;
	
	        if (this.currentConfig.loop)
	        {
	            if (currentTime >= endTime - this.manager.loopEndOffset)
	            {
	                this.audio.currentTime = startTime + Math.max(0, currentTime - endTime);
	                currentTime = this.audio.currentTime;
	            }
	            else if (currentTime < startTime)
	            {
	                this.audio.currentTime += startTime;
	                currentTime = this.audio.currentTime;
	            }
	
	            if (currentTime < this.previousTime)
	            {
	                this.emit('looped', this);
	            }
	        }
	        else if (currentTime >= endTime)
	        {
	            this.reset();
	
	            this.stopAndReleaseAudioTag();
	
	            this.emit('ended', this);
	
	            return;
	        }
	
	        this.previousTime = currentTime;
	    },
	
	    /**
	     * Calls Phaser.Sound.BaseSound#destroy method
	     * and cleans up all HTML5 Audio related stuff.
	     *
	     * @method Phaser.Sound.HTML5AudioSound#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        BaseSound.prototype.destroy.call(this);
	
	        this.tags = null;
	
	        if (this.audio)
	        {
	            this.stopAndReleaseAudioTag();
	        }
	    },
	
	    /**
	     * Method used internally to determine mute setting of the sound.
	     *
	     * @method Phaser.Sound.HTML5AudioSound#updateMute
	     * @private
	     * @since 3.0.0
	     */
	    updateMute: function ()
	    {
	        if (this.audio)
	        {
	            this.audio.muted = this.currentConfig.mute || this.manager.mute;
	        }
	    },
	
	    /**
	     * Method used internally to calculate total volume of the sound.
	     *
	     * @method Phaser.Sound.HTML5AudioSound#updateVolume
	     * @private
	     * @since 3.0.0
	     */
	    updateVolume: function ()
	    {
	        if (this.audio)
	        {
	            this.audio.volume = this.currentConfig.volume * this.manager.volume;
	        }
	    },
	
	    /**
	     * Method used internally to calculate total playback rate of the sound.
	     *
	     * @method Phaser.Sound.HTML5AudioSound#calculateRate
	     * @protected
	     * @since 3.0.0
	     */
	    calculateRate: function ()
	    {
	        BaseSound.prototype.calculateRate.call(this);
	
	        if (this.audio)
	        {
	            this.audio.playbackRate = this.totalRate;
	        }
	    },
	
	    /**
	     * @event Phaser.Sound.HTML5AudioSound#muteEvent
	     * @param {Phaser.Sound.HTML5AudioSound} sound - Reference to the sound that emitted event.
	     * @param {boolean} value - An updated value of Phaser.Sound.HTML5AudioSound#mute property.
	     */
	
	    /**
	     * Boolean indicating whether the sound is muted or not.
	     * Gets or sets the muted state of this sound.
	     * 
	     * @name Phaser.Sound.HTML5AudioSound#mute
	     * @type {boolean}
	     * @default false
	     * @since 3.0.0
	     */
	    mute: {
	
	        get: function ()
	        {
	            return this.currentConfig.mute;
	        },
	
	        set: function (value)
	        {
	            this.currentConfig.mute = value;
	
	            if (this.manager.isLocked(this, 'mute', value))
	            {
	                return;
	            }
	
	            this.emit('mute', this, value);
	        }
	    },
	
	    /**
	     * Sets the muted state of this Sound.
	     *
	     * @method Phaser.Sound.HTML5AudioSound#setMute
	     * @fires Phaser.Sound.HTML5AudioSound#muteEvent
	     * @since 3.4.0
	     *
	     * @param {boolean} value - `true` to mute this sound, `false` to unmute it.
	     *
	     * @return {Phaser.Sound.HTML5AudioSound} This Sound instance.
	     */
	    setMute: function (value)
	    {
	        this.mute = value;
	
	        return this;
	    },
	
	    /**
	     * @event Phaser.Sound.HTML5AudioSound#volumeEvent
	     * @param {Phaser.Sound.HTML5AudioSound} sound - Reference to the sound that emitted event.
	     * @param {number} value - An updated value of Phaser.Sound.HTML5AudioSound#volume property.
	     */
	
	    /**
	     * Gets or sets the volume of this sound, a value between 0 (silence) and 1 (full volume).
	     * 
	     * @name Phaser.Sound.HTML5AudioSound#volume
	     * @type {number}
	     * @default 1
	     * @since 3.0.0
	     */
	    volume: {
	
	        get: function ()
	        {
	            return this.currentConfig.volume;
	        },
	
	        set: function (value)
	        {
	            this.currentConfig.volume = value;
	
	            if (this.manager.isLocked(this, 'volume', value))
	            {
	                return;
	            }
	
	            this.emit('volume', this, value);
	        }
	    },
	
	    /**
	     * Sets the volume of this Sound.
	     *
	     * @method Phaser.Sound.HTML5AudioSound#setVolume
	     * @fires Phaser.Sound.HTML5AudioSound#volumeEvent
	     * @since 3.4.0
	     *
	     * @param {number} value - The volume of the sound.
	     *
	     * @return {Phaser.Sound.HTML5AudioSound} This Sound instance.
	     */
	    setVolume: function (value)
	    {
	        this.volume = value;
	
	        return this;
	    },
	
	    /**
	     * @event Phaser.Sound.HTML5AudioSound#rateEvent
	     * @param {Phaser.Sound.HTML5AudioSound} sound - Reference to the sound that emitted the event.
	     * @param {number} value - An updated value of Phaser.Sound.HTML5AudioSound#rate property.
	     */
	
	    /**
	     * Rate at which this Sound will be played.
	     * Value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
	     * and 2.0 doubles the audios playback speed.
	     *
	     * @name Phaser.Sound.HTML5AudioSound#rate
	     * @type {number}
	     * @default 1
	     * @since 3.0.0
	     */
	    rate: {
	
	        get: function ()
	        {
	            return this.currentConfig.rate;
	        },
	
	        set: function (value)
	        {
	            this.currentConfig.rate = value;
	
	            if (this.manager.isLocked(this, 'rate', value))
	            {
	                return;
	            }
	            else
	            {
	                this.calculateRate();
	
	                this.emit('rate', this, value);
	            }
	        }
	
	    },
	
	    /**
	     * Sets the playback rate of this Sound.
	     * 
	     * For example, a value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
	     * and 2.0 doubles the audios playback speed.
	     *
	     * @method Phaser.Sound.HTML5AudioSound#setRate
	     * @fires Phaser.Sound.HTML5AudioSound#rateEvent
	     * @since 3.3.0
	     *
	     * @param {number} value - The playback rate at of this Sound.
	     *
	     * @return {Phaser.Sound.HTML5AudioSound} This Sound.
	     */
	    setRate: function (value)
	    {
	        this.rate = value;
	
	        return this;
	    },
	
	    /**
	     * @event Phaser.Sound.HTML5AudioSound#detuneEvent
	     * @param {Phaser.Sound.HTML5AudioSound} sound - Reference to the Sound that emitted event.
	     * @param {number} value - An updated value of Phaser.Sound.HTML5AudioSound#detune property.
	     */
	
	    /**
	     * The detune value of this Sound, given in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
	     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
	     *
	     * @name Phaser.Sound.HTML5AudioSound#detune
	     * @type {number}
	     * @default 0
	     * @since 3.0.0
	     */
	    detune: {
	
	        get: function ()
	        {
	            return this.currentConfig.detune;
	        },
	
	        set: function (value)
	        {
	            this.currentConfig.detune = value;
	
	            if (this.manager.isLocked(this, 'detune', value))
	            {
	                return;
	            }
	            else
	            {
	                this.calculateRate();
	
	                this.emit('detune', this, value);
	            }
	        }
	
	    },
	
	    /**
	     * Sets the detune value of this Sound, given in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
	     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
	     *
	     * @method Phaser.Sound.HTML5AudioSound#setDetune
	     * @fires Phaser.Sound.HTML5AudioSound#detuneEvent
	     * @since 3.3.0
	     *
	     * @param {number} value - The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
	     *
	     * @return {Phaser.Sound.HTML5AudioSound} This Sound.
	     */
	    setDetune: function (value)
	    {
	        this.detune = value;
	
	        return this;
	    },
	
	    /**
	     * @event Phaser.Sound.HTML5AudioSound#seekEvent
	     * @param {Phaser.Sound.HTML5AudioSound} sound - Reference to the sound that emitted event.
	     * @param {number} value - An updated value of Phaser.Sound.HTML5AudioSound#seek property.
	     */
	
	    /**
	     * Property representing the position of playback for this sound, in seconds.
	     * Setting it to a specific value moves current playback to that position.
	     * The value given is clamped to the range 0 to current marker duration.
	     * Setting seek of a stopped sound has no effect.
	     * 
	     * @name Phaser.Sound.HTML5AudioSound#seek
	     * @type {number}
	     * @since 3.0.0
	     */
	    seek: {
	
	        get: function ()
	        {
	            if (this.isPlaying)
	            {
	                return this.audio.currentTime - (this.currentMarker ? this.currentMarker.start : 0);
	            }
	            else if (this.isPaused)
	            {
	                return this.currentConfig.seek;
	            }
	            else
	            {
	                return 0;
	            }
	        },
	
	        set: function (value)
	        {
	            if (this.manager.isLocked(this, 'seek', value))
	            {
	                return;
	            }
	
	            if (this.startTime > 0)
	            {
	                return;
	            }
	
	            if (this.isPlaying || this.isPaused)
	            {
	                value = Math.min(Math.max(0, value), this.duration);
	
	                if (this.isPlaying)
	                {
	                    this.previousTime = value;
	                    this.audio.currentTime = value;
	                }
	                else if (this.isPaused)
	                {
	                    this.currentConfig.seek = value;
	                }
	
	                this.emit('seek', this, value);
	            }
	        }
	    },
	
	    /**
	     * Seeks to a specific point in this sound.
	     *
	     * @method Phaser.Sound.HTML5AudioSound#setSeek
	     * @fires Phaser.Sound.HTML5AudioSound#seekEvent
	     * @since 3.4.0
	     *
	     * @param {number} value - The point in the sound to seek to.
	     *
	     * @return {Phaser.Sound.HTML5AudioSound} This Sound instance.
	     */
	    setSeek: function (value)
	    {
	        this.seek = value;
	
	        return this;
	    },
	
	    /**
	     * @event Phaser.Sound.HTML5AudioSound#loopEvent
	     * @param {Phaser.Sound.HTML5AudioSound} sound - Reference to the sound that emitted event.
	     * @param {boolean} value - An updated value of Phaser.Sound.HTML5AudioSound#loop property.
	     */
	
	    /**
	     * Flag indicating whether or not the sound or current sound marker will loop.
	     * 
	     * @name Phaser.Sound.HTML5AudioSound#loop
	     * @type {boolean}
	     * @default false
	     * @since 3.0.0
	     */
	    loop: {
	
	        get: function ()
	        {
	            return this.currentConfig.loop;
	        },
	
	        set: function (value)
	        {
	            this.currentConfig.loop = value;
	
	            if (this.manager.isLocked(this, 'loop', value))
	            {
	                return;
	            }
	
	            if (this.audio)
	            {
	                this.audio.loop = value;
	            }
	
	            this.emit('loop', this, value);
	        }
	
	    },
	
	    /**
	     * Sets the loop state of this Sound.
	     *
	     * @method Phaser.Sound.HTML5AudioSound#setLoop
	     * @fires Phaser.Sound.HTML5AudioSound#loopEvent
	     * @since 3.4.0
	     *
	     * @param {boolean} value - `true` to loop this sound, `false` to not loop it.
	     *
	     * @return {Phaser.Sound.HTML5AudioSound} This Sound instance.
	     */
	    setLoop: function (value)
	    {
	        this.loop = value;
	
	        return this;
	    }
	
	});
	
	module.exports = HTML5AudioSound;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BaseSoundManager = __webpack_require__(209);
	var Class = __webpack_require__(1);
	var HTML5AudioSound = __webpack_require__(626);
	
	/**
	 * HTML5 Audio implementation of the Sound Manager.
	 *
	 * @class HTML5AudioSoundManager
	 * @extends Phaser.Sound.BaseSoundManager
	 * @memberOf Phaser.Sound
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Game} game - Reference to the current game instance.
	 */
	var HTML5AudioSoundManager = new Class({
	
	    Extends: BaseSoundManager,
	
	    initialize:
	
	    function HTML5AudioSoundManager (game)
	    {
	        /**
	         * Flag indicating whether if there are no idle instances of HTML5 Audio tag,
	         * for any particular sound, if one of the used tags should be hijacked and used
	         * for succeeding playback or if succeeding Phaser.Sound.HTML5AudioSound#play
	         * call should be ignored.
	         *
	         * @name Phaser.Sound.HTML5AudioSoundManager#override
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.override = true;
	
	        /**
	         * Value representing time difference, in seconds, between calling
	         * play method on an audio tag and when it actually starts playing.
	         * It is used to achieve more accurate delayed sound playback.
	         *
	         * You might need to tweak this value to get the desired results
	         * since audio play delay varies depending on the browser/platform.
	         *
	         * @name Phaser.Sound.HTML5AudioSoundManager#audioPlayDelay
	         * @type {number}
	         * @default 0.1
	         * @since 3.0.0
	         */
	        this.audioPlayDelay = 0.1;
	
	        /**
	         * A value by which we should offset the loop end marker of the
	         * looping sound to compensate for lag, caused by changing audio
	         * tag playback position, in order to achieve gapless looping.
	         *
	         * You might need to tweak this value to get the desired results
	         * since loop lag varies depending on the browser/platform.
	         *
	         * @name Phaser.Sound.HTML5AudioSoundManager#loopEndOffset
	         * @type {number}
	         * @default 0.05
	         * @since 3.0.0
	         */
	        this.loopEndOffset = 0.05;
	
	        /**
	         * An array for keeping track of all the sounds
	         * that were paused when game lost focus.
	         *
	         * @name Phaser.Sound.HTML5AudioSoundManager#onBlurPausedSounds
	         * @type {Phaser.Sound.HTML5AudioSound[]}
	         * @private
	         * @default []
	         * @since 3.0.0
	         */
	        this.onBlurPausedSounds = [];
	
	        this.locked = 'ontouchstart' in window;
	
	        /**
	         * A queue of all actions performed on sound objects while audio was locked.
	         * Once the audio gets unlocked, after an explicit user interaction,
	         * all actions will be performed in chronological order.
	         * Array of object types: { sound: Phaser.Sound.HTML5AudioSound, name: string, value?: * }
	         *
	         * @name Phaser.Sound.HTML5AudioSoundManager#lockedActionsQueue
	         * @type {array}
	         * @private
	         * @since 3.0.0
	         */
	        this.lockedActionsQueue = this.locked ? [] : null;
	
	        /**
	         * Property that actually holds the value of global mute
	         * for HTML5 Audio sound manager implementation.
	         *
	         * @name Phaser.Sound.HTML5AudioSoundManager#_mute
	         * @type {boolean}
	         * @private
	         * @default false
	         * @since 3.0.0
	         */
	        this._mute = false;
	
	        /**
	         * Property that actually holds the value of global volume
	         * for HTML5 Audio sound manager implementation.
	         *
	         * @name Phaser.Sound.HTML5AudioSoundManager#_volume
	         * @type {boolean}
	         * @private
	         * @default 1
	         * @since 3.0.0
	         */
	        this._volume = 1;
	
	        BaseSoundManager.call(this, game);
	    },
	
	    /**
	     * Adds a new sound into the sound manager.
	     *
	     * @method Phaser.Sound.HTML5AudioSoundManager#add
	     * @since 3.0.0
	     *
	     * @param {string} key - Asset key for the sound.
	     * @param {SoundConfig} [config] - An optional config object containing default sound settings.
	     *
	     * @return {Phaser.Sound.HTML5AudioSound} The new sound instance.
	     */
	    add: function (key, config)
	    {
	        var sound = new HTML5AudioSound(this, key, config);
	
	        this.sounds.push(sound);
	
	        return sound;
	    },
	
	    /**
	     * Unlocks HTML5 Audio loading and playback on mobile
	     * devices on the initial explicit user interaction.
	     *
	     * @method Phaser.Sound.HTML5AudioSoundManager#unlock
	     * @since 3.0.0
	     */
	    unlock: function ()
	    {
	        this.locked = false;
	
	        var _this = this;
	
	        this.game.cache.audio.entries.each(function (key, tags)
	        {
	            for (var i = 0; i < tags.length; i++)
	            {
	                if (tags[i].dataset.locked === 'true')
	                {
	                    _this.locked = true;
	
	                    return false;
	                }
	            }
	
	            return true;
	        });
	
	        if (!this.locked)
	        {
	            return;
	        }
	
	        var moved = false;
	
	        var detectMove = function ()
	        {
	            moved = true;
	        };
	
	        var unlock = function ()
	        {
	            if (moved)
	            {
	                moved = false;
	                return;
	            }
	
	            document.body.removeEventListener('touchmove', detectMove);
	            document.body.removeEventListener('touchend', unlock);
	
	            var lockedTags = [];
	
	            _this.game.cache.audio.entries.each(function (key, tags)
	            {
	                for (var i = 0; i < tags.length; i++)
	                {
	                    var tag = tags[i];
	
	                    if (tag.dataset.locked === 'true')
	                    {
	                        lockedTags.push(tag);
	                    }
	                }
	
	                return true;
	            });
	
	            if (lockedTags.length === 0)
	            {
	                return;
	            }
	
	            var lastTag = lockedTags[lockedTags.length - 1];
	
	            lastTag.oncanplaythrough = function ()
	            {
	                lastTag.oncanplaythrough = null;
	
	                lockedTags.forEach(function (tag)
	                {
	                    tag.dataset.locked = 'false';
	                });
	
	                _this.unlocked = true;
	            };
	
	            lockedTags.forEach(function (tag)
	            {
	                tag.load();
	            });
	        };
	
	        this.once('unlocked', function ()
	        {
	            this.forEachActiveSound(function (sound)
	            {
	                if (sound.currentMarker === null && sound.duration === 0)
	                {
	                    sound.duration = sound.tags[0].duration;
	                }
	
	                sound.totalDuration = sound.tags[0].duration;
	            });
	
	            while (this.lockedActionsQueue.length)
	            {
	                var lockedAction = this.lockedActionsQueue.shift();
	
	                if (lockedAction.sound[lockedAction.prop].apply)
	                {
	                    lockedAction.sound[lockedAction.prop].apply(lockedAction.sound, lockedAction.value || []);
	                }
	                else
	                {
	                    lockedAction.sound[lockedAction.prop] = lockedAction.value;
	                }
	            }
	
	        }, this);
	
	        document.body.addEventListener('touchmove', detectMove, false);
	        document.body.addEventListener('touchend', unlock, false);
	    },
	
	    /**
	     * Method used internally for pausing sound manager if
	     * Phaser.Sound.HTML5AudioSoundManager#pauseOnBlur is set to true.
	     *
	     * @method Phaser.Sound.HTML5AudioSoundManager#onBlur
	     * @protected
	     * @since 3.0.0
	     */
	    onBlur: function ()
	    {
	        this.forEachActiveSound(function (sound)
	        {
	            if (sound.isPlaying)
	            {
	                this.onBlurPausedSounds.push(sound);
	                sound.onBlur();
	            }
	        });
	    },
	
	    /**
	     * Method used internally for resuming sound manager if
	     * Phaser.Sound.HTML5AudioSoundManager#pauseOnBlur is set to true.
	     *
	     * @method Phaser.Sound.HTML5AudioSoundManager#onFocus
	     * @protected
	     * @since 3.0.0
	     */
	    onFocus: function ()
	    {
	        this.onBlurPausedSounds.forEach(function (sound)
	        {
	            sound.onFocus();
	        });
	
	        this.onBlurPausedSounds.length = 0;
	    },
	
	    /**
	     * Calls Phaser.Sound.BaseSoundManager#destroy method
	     * and cleans up all HTML5 Audio related stuff.
	     *
	     * @method Phaser.Sound.HTML5AudioSoundManager#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        BaseSoundManager.prototype.destroy.call(this);
	
	        this.onBlurPausedSounds.length = 0;
	        this.onBlurPausedSounds = null;
	    },
	
	    /**
	     * Method used internally by Phaser.Sound.HTML5AudioSound class methods and property setters
	     * to check if sound manager is locked and then either perform action immediately or queue it
	     * to be performed once the sound manager gets unlocked.
	     *
	     * @method Phaser.Sound.HTML5AudioSoundManager#isLocked
	     * @protected
	     * @since 3.0.0
	     *
	     * @param {Phaser.Sound.HTML5AudioSound} sound - Sound object on which to perform queued action.
	     * @param {string} prop - Name of the method to be called or property to be assigned a value to.
	     * @param {*} [value] - An optional parameter that either holds an array of arguments to be passed to the method call or value to be set to the property.
	     *
	     * @return {boolean} Whether the sound manager is locked.
	     */
	    isLocked: function (sound, prop, value)
	    {
	        if (sound.tags[0].dataset.locked === 'true')
	        {
	            this.lockedActionsQueue.push({
	                sound: sound,
	                prop: prop,
	                value: value
	            });
	
	            return true;
	        }
	
	        return false;
	    },
	
	    /**
	     * @event Phaser.Sound.HTML5AudioSoundManager#muteEvent
	     * @param {Phaser.Sound.HTML5AudioSoundManager} soundManager - Reference to the sound manager that emitted event.
	     * @param {boolean} value - An updated value of Phaser.Sound.HTML5AudioSoundManager#mute property.
	     */
	
	    /**
	     * Sets the muted state of all this Sound Manager.
	     *
	     * @method Phaser.Sound.HTML5AudioSoundManager#setMute
	     * @fires Phaser.Sound.HTML5AudioSoundManager#muteEvent
	     * @since 3.3.0
	     *
	     * @param {boolean} value - `true` to mute all sounds, `false` to unmute them.
	     *
	     * @return {Phaser.Sound.HTML5AudioSoundManager} This Sound Manager.
	     */
	    setMute: function (value)
	    {
	        this.mute = value;
	
	        return this;
	    },
	
	    /**
	     * @name Phaser.Sound.HTML5AudioSoundManager#mute
	     * @type {boolean}
	     * @fires Phaser.Sound.HTML5AudioSoundManager#muteEvent
	     * @since 3.0.0
	     */
	    mute: {
	
	        get: function ()
	        {
	            return this._mute;
	        },
	
	        set: function (value)
	        {
	            this._mute = value;
	
	            this.forEachActiveSound(function (sound)
	            {
	                sound.updateMute();
	            });
	
	            this.emit('mute', this, value);
	        }
	
	    },
	
	    /**
	     * @event Phaser.Sound.HTML5AudioSoundManager#volumeEvent
	     * @param {Phaser.Sound.HTML5AudioSoundManager} soundManager - Reference to the sound manager that emitted event.
	     * @param {number} value - An updated value of Phaser.Sound.HTML5AudioSoundManager#volume property.
	     */
	
	    /**
	     * Sets the volume of this Sound Manager.
	     *
	     * @method Phaser.Sound.HTML5AudioSoundManager#setVolume
	     * @fires Phaser.Sound.HTML5AudioSoundManager#volumeEvent
	     * @since 3.3.0
	     *
	     * @param {number} value - The global volume of this Sound Manager.
	     *
	     * @return {Phaser.Sound.HTML5AudioSoundManager} This Sound Manager.
	     */
	    setVolume: function (value)
	    {
	        this.volume = value;
	
	        return this;
	    },
	
	    /**
	     * @name Phaser.Sound.HTML5AudioSoundManager#volume
	     * @type {number}
	     * @fires Phaser.Sound.HTML5AudioSoundManager#volumeEvent
	     * @since 3.0.0
	     */
	    volume: {
	
	        get: function ()
	        {
	            return this._volume;
	        },
	
	        set: function (value)
	        {
	            this._volume = value;
	
	            this.forEachActiveSound(function (sound)
	            {
	                sound.updateVolume();
	            });
	
	            this.emit('volume', this, value);
	        }
	
	    }
	
	});
	
	module.exports = HTML5AudioSoundManager;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BaseSound = __webpack_require__(208);
	var Class = __webpack_require__(1);
	var EventEmitter = __webpack_require__(22);
	var Extend = __webpack_require__(36);
	
	/**
	 * @classdesc
	 * No audio implementation of the sound. It is used if audio has been
	 * disabled in the game config or the device doesn't support any audio.
	 *
	 * It represents a graceful degradation of sound logic that provides
	 * minimal functionality and prevents Phaser projects that use audio from
	 * breaking on devices that don't support any audio playback technologies.
	 *
	 * @class NoAudioSound
	 * @extends Phaser.Sound.BaseSound
	 * @memberOf Phaser.Sound
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Sound.NoAudioSoundManager} manager - Reference to the current sound manager instance.
	 * @param {string} key - Asset key for the sound.
	 * @param {SoundConfig} [config={}] - An optional config object containing default sound settings.
	 */
	var NoAudioSound = new Class({
	
	    Extends: EventEmitter,
	
	    initialize:
	
	    function NoAudioSound (manager, key, config)
	    {
	        if (config === void 0) { config = {}; }
	
	        EventEmitter.call(this);
	
	        this.manager = manager;
	        this.key = key;
	        this.isPlaying = false;
	        this.isPaused = false;
	        this.totalRate = 1;
	        this.duration = 0;
	        this.totalDuration = 0;
	
	        this.config = Extend({
	            mute: false,
	            volume: 1,
	            rate: 1,
	            detune: 0,
	            seek: 0,
	            loop: false,
	            delay: 0
	        }, config);
	
	        this.currentConfig = this.config;
	        this.mute = false;
	        this.volume = 1;
	        this.rate = 1;
	        this.detune = 0;
	        this.seek = 0;
	        this.loop = false;
	        this.markers = {};
	        this.currentMarker = null;
	        this.pendingRemove = false;
	    },
	
	    // eslint-disable-next-line no-unused-vars
	    addMarker: function (marker)
	    {
	        return false;
	    },
	
	    // eslint-disable-next-line no-unused-vars
	    updateMarker: function (marker)
	    {
	        return false;
	    },
	
	    // eslint-disable-next-line no-unused-vars
	    removeMarker: function (markerName)
	    {
	        return null;
	    },
	
	    // eslint-disable-next-line no-unused-vars
	    play: function (markerName, config)
	    {
	        return false;
	    },
	
	    pause: function ()
	    {
	        return false;
	    },
	
	    resume: function ()
	    {
	        return false;
	    },
	
	    stop: function ()
	    {
	        return false;
	    },
	
	    destroy: function ()
	    {
	        this.manager.remove(this);
	
	        BaseSound.prototype.destroy.call(this);
	    }
	});
	
	module.exports = NoAudioSound;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BaseSoundManager = __webpack_require__(209);
	var Class = __webpack_require__(1);
	var EventEmitter = __webpack_require__(22);
	var NoAudioSound = __webpack_require__(628);
	var NOOP = __webpack_require__(6);
	
	/**
	 * @classdesc
	 * No audio implementation of the sound manager. It is used if audio has been
	 * disabled in the game config or the device doesn't support any audio.
	 *
	 * It represents a graceful degradation of sound manager logic that provides
	 * minimal functionality and prevents Phaser projects that use audio from
	 * breaking on devices that don't support any audio playback technologies.
	 *
	 * @class NoAudioSoundManager
	 * @extends Phaser.Sound.BaseSoundManager
	 * @memberOf Phaser.Sound
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Game} game - Reference to the current game instance.
	 */
	var NoAudioSoundManager = new Class({
	
	    Extends: EventEmitter,
	
	    initialize:
	
	    function NoAudioSoundManager (game)
	    {
	        EventEmitter.call(this);
	
	        this.game = game;
	        this.sounds = [];
	        this.mute = false;
	        this.volume = 1;
	        this.rate = 1;
	        this.detune = 0;
	        this.pauseOnBlur = true;
	        this.locked = false;
	    },
	
	    add: function (key, config)
	    {
	        var sound = new NoAudioSound(this, key, config);
	
	        this.sounds.push(sound);
	
	        return sound;
	    },
	
	    addAudioSprite: function (key, config)
	    {
	        var sound = this.add(key, config);
	
	        sound.spritemap = {};
	
	        return sound;
	    },
	
	    // eslint-disable-next-line no-unused-vars
	    play: function (key, extra)
	    {
	        return false;
	    },
	
	    // eslint-disable-next-line no-unused-vars
	    playAudioSprite: function (key, spriteName, config)
	    {
	        return false;
	    },
	
	    remove: function (sound)
	    {
	        return BaseSoundManager.prototype.remove.call(this, sound);
	    },
	
	    removeByKey: function (key)
	    {
	        return BaseSoundManager.prototype.removeByKey.call(this, key);
	    },
	
	    pauseAll: NOOP,
	    resumeAll: NOOP,
	    stopAll: NOOP,
	    update: NOOP,
	    setRate: NOOP,
	    setDetune: NOOP,
	    setMute: NOOP,
	    setVolume: NOOP,
	
	    forEachActiveSound: function (callbackfn, scope)
	    {
	        BaseSoundManager.prototype.forEachActiveSound.call(this, callbackfn, scope);
	    },
	
	    destroy: function ()
	    {
	        BaseSoundManager.prototype.destroy.call(this);
	    }
	
	});
	
	module.exports = NoAudioSoundManager;


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BaseSound = __webpack_require__(208);
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * Web Audio API implementation of the sound.
	 *
	 * @class WebAudioSound
	 * @extends Phaser.Sound.BaseSound
	 * @memberOf Phaser.Sound
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Sound.WebAudioSoundManager} manager - Reference to the current sound manager instance.
	 * @param {string} key - Asset key for the sound.
	 * @param {SoundConfig} [config={}] - An optional config object containing default sound settings.
	 */
	var WebAudioSound = new Class({
	
	    Extends: BaseSound,
	
	    initialize:
	
	    function WebAudioSound (manager, key, config)
	    {
	        if (config === undefined) { config = {}; }
	
	        /**
	         * Audio buffer containing decoded data of the audio asset to be played.
	         *
	         * @name Phaser.Sound.WebAudioSound#audioBuffer
	         * @type {AudioBuffer}
	         * @private
	         * @since 3.0.0
	         */
	        this.audioBuffer = manager.game.cache.audio.get(key);
	
	        if (!this.audioBuffer)
	        {
	            // eslint-disable-next-line no-console
	            console.warn('Audio cache entry missing: ' + key);
	            return;
	        }
	
	        /**
	         * A reference to an audio source node used for playing back audio from
	         * audio data stored in Phaser.Sound.WebAudioSound#audioBuffer.
	         *
	         * @name Phaser.Sound.WebAudioSound#source
	         * @type {AudioBufferSourceNode}
	         * @private
	         * @default null
	         * @since 3.0.0
	         */
	        this.source = null;
	
	        /**
	         * A reference to a second audio source used for gapless looped playback.
	         *
	         * @name Phaser.Sound.WebAudioSound#loopSource
	         * @type {AudioBufferSourceNode}
	         * @private
	         * @default null
	         * @since 3.0.0
	         */
	        this.loopSource = null;
	
	        /**
	         * Gain node responsible for controlling this sound's muting.
	         *
	         * @name Phaser.Sound.WebAudioSound#muteNode
	         * @type {GainNode}
	         * @private
	         * @since 3.0.0
	         */
	        this.muteNode = manager.context.createGain();
	
	        /**
	         * Gain node responsible for controlling this sound's volume.
	         *
	         * @name Phaser.Sound.WebAudioSound#volumeNode
	         * @type {GainNode}
	         * @private
	         * @since 3.0.0
	         */
	        this.volumeNode = manager.context.createGain();
	
	        /**
	         * The time at which the sound should have started playback from the beginning.
	         * Based on BaseAudioContext.currentTime value.
	         *
	         * @name Phaser.Sound.WebAudioSound#playTime
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this.playTime = 0;
	
	        /**
	         * The time at which the sound source should have actually started playback.
	         * Based on BaseAudioContext.currentTime value.
	         *
	         * @name Phaser.Sound.WebAudioSound#startTime
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this.startTime = 0;
	
	        /**
	         * The time at which the sound loop source should actually start playback.
	         * Based on BaseAudioContext.currentTime value.
	         *
	         * @name Phaser.Sound.WebAudioSound#loopTime
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this.loopTime = 0;
	
	        /**
	         * An array where we keep track of all rate updates during playback.
	         * Array of object types: { time: number, rate: number }
	         *
	         * @name Phaser.Sound.WebAudioSound#rateUpdates
	         * @type {array}
	         * @private
	         * @default []
	         * @since 3.0.0
	         */
	        this.rateUpdates = [];
	
	        /**
	         * Used for keeping track when sound source playback has ended
	         * so its state can be updated accordingly.
	         *
	         * @name Phaser.Sound.WebAudioSound#hasEnded
	         * @type {boolean}
	         * @private
	         * @default false
	         * @since 3.0.0
	         */
	        this.hasEnded = false;
	
	        /**
	         * Used for keeping track when sound source has looped
	         * so its state can be updated accordingly.
	         *
	         * @name Phaser.Sound.WebAudioSound#hasLooped
	         * @type {boolean}
	         * @private
	         * @default false
	         * @since 3.0.0
	         */
	        this.hasLooped = false;
	
	        this.muteNode.connect(this.volumeNode);
	
	        this.volumeNode.connect(manager.destination);
	
	        this.duration = this.audioBuffer.duration;
	
	        this.totalDuration = this.audioBuffer.duration;
	
	        BaseSound.call(this, manager, key, config);
	    },
	
	    /**
	     * @event Phaser.Sound.WebAudioSound#playEvent
	     * @param {Phaser.Sound.WebAudioSound} sound - Reference to the Sound that emitted event.
	     */
	
	    /**
	     * Play this sound, or a marked section of it.
	     * 
	     * It always plays the sound from the start. If you want to start playback from a specific time
	     * you can set 'seek' setting of the config object, provided to this call, to that value.
	     *
	     * @method Phaser.Sound.WebAudioSound#play
	     * @fires Phaser.Sound.WebAudioSound#playEvent
	     * @since 3.0.0
	     *
	     * @param {string} [markerName=''] - If you want to play a marker then provide the marker name here, otherwise omit it to play the full sound.
	     * @param {SoundConfig} [config] - Optional sound config object to be applied to this marker or entire sound if no marker name is provided. It gets memorized for future plays of current section of the sound.
	     *
	     * @return {boolean} Whether the sound started playing successfully.
	     */
	    play: function (markerName, config)
	    {
	        if (!BaseSound.prototype.play.call(this, markerName, config))
	        {
	            return false;
	        }
	
	        //  \/\/\/ isPlaying = true, isPaused = false \/\/\/
	        this.stopAndRemoveBufferSource();
	        this.createAndStartBufferSource();
	
	        this.emit('play', this);
	
	        return true;
	    },
	
	    /**
	     * @event Phaser.Sound.WebAudioSound#pauseEvent
	     * @param {Phaser.Sound.WebAudioSound} sound - Reference to the Sound that emitted event.
	     */
	
	    /**
	     * Pauses the sound.
	     *
	     * @method Phaser.Sound.WebAudioSound#pause
	     * @fires Phaser.Sound.WebAudioSound#pauseEvent
	     * @since 3.0.0
	     *
	     * @return {boolean} Whether the sound was paused successfully.
	     */
	    pause: function ()
	    {
	        if (this.manager.context.currentTime < this.startTime)
	        {
	            return false;
	        }
	
	        if (!BaseSound.prototype.pause.call(this))
	        {
	            return false;
	        }
	
	        //  \/\/\/ isPlaying = false, isPaused = true \/\/\/
	        this.currentConfig.seek = this.getCurrentTime(); // Equivalent to setting paused time
	        this.stopAndRemoveBufferSource();
	
	        this.emit('pause', this);
	
	        return true;
	    },
	
	    /**
	     * @event Phaser.Sound.WebAudioSound#resumeEvent
	     * @param {Phaser.Sound.WebAudioSound} sound - Reference to the Sound that emitted event.
	     */
	
	    /**
	     * Resumes the sound.
	     *
	     * @method Phaser.Sound.WebAudioSound#resume
	     * @fires Phaser.Sound.WebAudioSound#resumeEvent
	     * @since 3.0.0
	     *
	     * @return {boolean} Whether the sound was resumed successfully.
	     */
	    resume: function ()
	    {
	        if (this.manager.context.currentTime < this.startTime)
	        {
	            return false;
	        }
	
	        if (!BaseSound.prototype.resume.call(this))
	        {
	            return false;
	        }
	
	        //  \/\/\/ isPlaying = true, isPaused = false \/\/\/
	        this.createAndStartBufferSource();
	
	        this.emit('resume', this);
	
	        return true;
	    },
	
	    /**
	     * @event Phaser.Sound.WebAudioSound#stopEvent
	     * @param {Phaser.Sound.WebAudioSound} sound - Reference to the Sound that emitted event.
	     */
	
	    /**
	     * Stop playing this sound.
	     *
	     * @method Phaser.Sound.WebAudioSound#stop
	     * @fires Phaser.Sound.WebAudioSound#stopEvent
	     * @since 3.0.0
	     *
	     * @return {boolean} Whether the sound was stopped successfully.
	     */
	    stop: function ()
	    {
	        if (!BaseSound.prototype.stop.call(this))
	        {
	            return false;
	        }
	
	        //  \/\/\/ isPlaying = false, isPaused = false \/\/\/
	        this.stopAndRemoveBufferSource();
	
	        this.emit('stop', this);
	
	        return true;
	    },
	
	    /**
	     * Used internally.
	     *
	     * @method Phaser.Sound.WebAudioSound#createAndStartBufferSource
	     * @private
	     * @since 3.0.0
	     */
	    createAndStartBufferSource: function ()
	    {
	        var seek = this.currentConfig.seek;
	        var delay = this.currentConfig.delay;
	        var when = this.manager.context.currentTime + delay;
	        var offset = (this.currentMarker ? this.currentMarker.start : 0) + seek;
	        var duration = this.duration - seek;
	
	        this.playTime = when - seek;
	        this.startTime = when;
	        this.source = this.createBufferSource();
	
	        this.applyConfig();
	
	        this.source.start(Math.max(0, when), Math.max(0, offset), Math.max(0, duration));
	
	        this.resetConfig();
	    },
	
	    /**
	     * Used internally.
	     *
	     * @method Phaser.Sound.WebAudioSound#createAndStartLoopBufferSource
	     * @private
	     * @since 3.0.0
	     */
	    createAndStartLoopBufferSource: function ()
	    {
	        var when = this.getLoopTime();
	        var offset = this.currentMarker ? this.currentMarker.start : 0;
	        var duration = this.duration;
	
	        this.loopTime = when;
	        this.loopSource = this.createBufferSource();
	        this.loopSource.playbackRate.setValueAtTime(this.totalRate, 0);
	        this.loopSource.start(Math.max(0, when), Math.max(0, offset), Math.max(0, duration));
	    },
	
	    /**
	     * Used internally.
	     *
	     * @method Phaser.Sound.WebAudioSound#createBufferSource
	     * @private
	     * @since 3.0.0
	     *
	     * @return {AudioBufferSourceNode}
	     */
	    createBufferSource: function ()
	    {
	        var _this = this;
	        var source = this.manager.context.createBufferSource();
	
	        source.buffer = this.audioBuffer;
	
	        source.connect(this.muteNode);
	
	        source.onended = function (ev)
	        {
	            if (ev.target === _this.source)
	            {
	                // sound ended
	                if (_this.currentConfig.loop)
	                {
	                    _this.hasLooped = true;
	                }
	                else
	                {
	                    _this.hasEnded = true;
	                }
	            }
	
	            // else was stopped
	        };
	
	        return source;
	    },
	
	    /**
	     * Used internally.
	     *
	     * @method Phaser.Sound.WebAudioSound#stopAndRemoveBufferSource
	     * @private
	     * @since 3.0.0
	     */
	    stopAndRemoveBufferSource: function ()
	    {
	        if (this.source)
	        {
	            this.source.stop();
	            this.source.disconnect();
	            this.source = null;
	        }
	
	        this.playTime = 0;
	        this.startTime = 0;
	
	        this.stopAndRemoveLoopBufferSource();
	    },
	
	    /**
	     * Used internally.
	     *
	     * @method Phaser.Sound.WebAudioSound#stopAndRemoveLoopBufferSource
	     * @private
	     * @since 3.0.0
	     */
	    stopAndRemoveLoopBufferSource: function ()
	    {
	        if (this.loopSource)
	        {
	            this.loopSource.stop();
	            this.loopSource.disconnect();
	            this.loopSource = null;
	        }
	
	        this.loopTime = 0;
	    },
	
	    /**
	     * Method used internally for applying config values to some of the sound properties.
	     *
	     * @method Phaser.Sound.WebAudioSound#applyConfig
	     * @protected
	     * @since 3.0.0
	     */
	    applyConfig: function ()
	    {
	        this.rateUpdates.length = 0;
	
	        this.rateUpdates.push({
	            time: 0,
	            rate: 1
	        });
	
	        BaseSound.prototype.applyConfig.call(this);
	    },
	
	    /**
	     * @event Phaser.Sound.WebAudioSound#endedEvent
	     * @param {Phaser.Sound.WebAudioSound} sound - Reference to the sound that emitted event.
	     */
	
	    /**
	     * @event Phaser.Sound.WebAudioSound#loopedEvent
	     * @param {Phaser.Sound.WebAudioSound} sound - Reference to the sound that emitted event.
	     */
	
	    /**
	     * Update method called automatically by sound manager on every game step.
	     *
	     * @method Phaser.Sound.WebAudioSound#update
	     * @fires Phaser.Sound.WebAudioSound#endedEvent
	     * @fires Phaser.Sound.WebAudioSound#loopedEvent
	     * @protected
	     * @since 3.0.0
	     *
	     * @param {number} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
	     * @param {number} delta - The delta time elapsed since the last frame.
	     */
	    // eslint-disable-next-line no-unused-vars
	    update: function (time, delta)
	    {
	        if (this.hasEnded)
	        {
	            this.hasEnded = false;
	
	            BaseSound.prototype.stop.call(this);
	
	            this.stopAndRemoveBufferSource();
	
	            this.emit('ended', this);
	        }
	        else if (this.hasLooped)
	        {
	            this.hasLooped = false;
	            this.source = this.loopSource;
	            this.loopSource = null;
	            this.playTime = this.startTime = this.loopTime;
	            this.rateUpdates.length = 0;
	
	            this.rateUpdates.push({
	                time: 0,
	                rate: this.totalRate
	            });
	
	            this.createAndStartLoopBufferSource();
	
	            this.emit('looped', this);
	        }
	    },
	
	    /**
	     * Calls Phaser.Sound.BaseSound#destroy method
	     * and cleans up all Web Audio API related stuff.
	     *
	     * @method Phaser.Sound.WebAudioSound#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        BaseSound.prototype.destroy.call(this);
	
	        this.audioBuffer = null;
	        this.stopAndRemoveBufferSource();
	        this.muteNode.disconnect();
	        this.muteNode = null;
	        this.volumeNode.disconnect();
	        this.volumeNode = null;
	        this.rateUpdates.length = 0;
	        this.rateUpdates = null;
	    },
	
	    /**
	     * Method used internally to calculate total playback rate of the sound.
	     *
	     * @method Phaser.Sound.WebAudioSound#calculateRate
	     * @protected
	     * @since 3.0.0
	     */
	    calculateRate: function ()
	    {
	        BaseSound.prototype.calculateRate.call(this);
	
	        var now = this.manager.context.currentTime;
	
	        if (this.source && typeof this.totalRate === 'number')
	        {
	            this.source.playbackRate.setValueAtTime(this.totalRate, now);
	        }
	
	        if (this.isPlaying)
	        {
	            this.rateUpdates.push({
	                time: Math.max(this.startTime, now) - this.playTime,
	                rate: this.totalRate
	            });
	
	            if (this.loopSource)
	            {
	                this.stopAndRemoveLoopBufferSource();
	                this.createAndStartLoopBufferSource();
	            }
	        }
	    },
	
	    /**
	     * Method used internally for calculating current playback time of a playing sound.
	     *
	     * @method Phaser.Sound.WebAudioSound#getCurrentTime
	     * @private
	     * @since 3.0.0
	     */
	    getCurrentTime: function ()
	    {
	        var currentTime = 0;
	
	        for (var i = 0; i < this.rateUpdates.length; i++)
	        {
	            var nextTime = 0;
	
	            if (i < this.rateUpdates.length - 1)
	            {
	                nextTime = this.rateUpdates[i + 1].time;
	            }
	            else
	            {
	                nextTime = this.manager.context.currentTime - this.playTime;
	            }
	
	            currentTime += (nextTime - this.rateUpdates[i].time) * this.rateUpdates[i].rate;
	        }
	
	        return currentTime;
	    },
	
	    /**
	     * Method used internally for calculating the time
	     * at witch the loop source should start playing.
	     *
	     * @method Phaser.Sound.WebAudioSound#getLoopTime
	     * @private
	     * @since 3.0.0
	     */
	    getLoopTime: function ()
	    {
	        var lastRateUpdateCurrentTime = 0;
	
	        for (var i = 0; i < this.rateUpdates.length - 1; i++)
	        {
	            lastRateUpdateCurrentTime += (this.rateUpdates[i + 1].time - this.rateUpdates[i].time) * this.rateUpdates[i].rate;
	        }
	
	        var lastRateUpdate = this.rateUpdates[this.rateUpdates.length - 1];
	
	        return this.playTime + lastRateUpdate.time + (this.duration - lastRateUpdateCurrentTime) / lastRateUpdate.rate;
	    },
	
	    /**
	     * @event Phaser.Sound.WebAudioSound#rateEvent
	     * @param {Phaser.Sound.WebAudioSound} sound - Reference to the sound that emitted the event.
	     * @param {number} value - An updated value of Phaser.Sound.WebAudioSound#rate property.
	     */
	
	    /**
	     * Rate at which this Sound will be played.
	     * Value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
	     * and 2.0 doubles the audios playback speed.
	     *
	     * @name Phaser.Sound.WebAudioSound#rate
	     * @type {number}
	     * @default 1
	     * @since 3.0.0
	     */
	    rate: {
	
	        get: function ()
	        {
	            return this.currentConfig.rate;
	        },
	
	        set: function (value)
	        {
	            this.currentConfig.rate = value;
	
	            this.calculateRate();
	
	            this.emit('rate', this, value);
	        }
	
	    },
	
	    /**
	     * Sets the playback rate of this Sound.
	     * 
	     * For example, a value of 1.0 plays the audio at full speed, 0.5 plays the audio at half speed
	     * and 2.0 doubles the audios playback speed.
	     *
	     * @method Phaser.Sound.WebAudioSound#setRate
	     * @fires Phaser.Sound.WebAudioSound#rateEvent
	     * @since 3.3.0
	     *
	     * @param {number} value - The playback rate at of this Sound.
	     *
	     * @return {Phaser.Sound.WebAudioSound} This Sound.
	     */
	    setRate: function (value)
	    {
	        this.rate = value;
	
	        return this;
	    },
	
	    /**
	     * @event Phaser.Sound.WebAudioSound#detuneEvent
	     * @param {Phaser.Sound.WebAudioSound} sound - Reference to the Sound that emitted event.
	     * @param {number} value - An updated value of Phaser.Sound.WebAudioSound#detune property.
	     */
	
	    /**
	     * The detune value of this Sound, given in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
	     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
	     *
	     * @name Phaser.Sound.WebAudioSound#detune
	     * @type {number}
	     * @default 0
	     * @since 3.0.0
	     */
	    detune: {
	
	        get: function ()
	        {
	            return this.currentConfig.detune;
	        },
	
	        set: function (value)
	        {
	            this.currentConfig.detune = value;
	
	            this.calculateRate();
	
	            this.emit('detune', this, value);
	        }
	
	    },
	
	    /**
	     * Sets the detune value of this Sound, given in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
	     * The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
	     *
	     * @method Phaser.Sound.WebAudioSound#setDetune
	     * @fires Phaser.Sound.WebAudioSound#detuneEvent
	     * @since 3.3.0
	     *
	     * @param {number} value - The range of the value is -1200 to 1200, but we recommend setting it to [50](https://en.wikipedia.org/wiki/50_Cent).
	     *
	     * @return {Phaser.Sound.WebAudioSound} This Sound.
	     */
	    setDetune: function (value)
	    {
	        this.detune = value;
	
	        return this;
	    },
	
	    /**
	     * @event Phaser.Sound.WebAudioSound#muteEvent
	     * @param {Phaser.Sound.WebAudioSound} sound - Reference to the sound that emitted event.
	     * @param {boolean} value - An updated value of Phaser.Sound.WebAudioSound#mute property.
	     */
	
	    /**
	     * Boolean indicating whether the sound is muted or not.
	     * Gets or sets the muted state of this sound.
	     * 
	     * @name Phaser.Sound.WebAudioSound#mute
	     * @type {boolean}
	     * @default false
	     * @since 3.0.0
	     */
	    mute: {
	
	        get: function ()
	        {
	            return (this.muteNode.gain.value === 0);
	        },
	
	        set: function (value)
	        {
	            this.currentConfig.mute = value;
	            this.muteNode.gain.setValueAtTime(value ? 0 : 1, 0);
	
	            this.emit('mute', this, value);
	        }
	
	    },
	
	    /**
	     * Sets the muted state of this Sound.
	     *
	     * @method Phaser.Sound.WebAudioSound#setMute
	     * @fires Phaser.Sound.WebAudioSound#muteEvent
	     * @since 3.4.0
	     *
	     * @param {boolean} value - `true` to mute this sound, `false` to unmute it.
	     *
	     * @return {Phaser.Sound.WebAudioSound} This Sound instance.
	     */
	    setMute: function (value)
	    {
	        this.mute = value;
	
	        return this;
	    },
	
	    /**
	     * @event Phaser.Sound.WebAudioSound#volumeEvent
	     * @param {Phaser.Sound.WebAudioSound} sound - Reference to the sound that emitted event.
	     * @param {number} value - An updated value of Phaser.Sound.WebAudioSound#volume property.
	     */
	
	    /**
	     * Gets or sets the volume of this sound, a value between 0 (silence) and 1 (full volume).
	     * 
	     * @name Phaser.Sound.WebAudioSound#volume
	     * @type {number}
	     * @default 1
	     * @since 3.0.0
	     */
	    volume: {
	
	        get: function ()
	        {
	            return this.volumeNode.gain.value;
	        },
	
	        set: function (value)
	        {
	            this.currentConfig.volume = value;
	            this.volumeNode.gain.setValueAtTime(value, 0);
	
	            this.emit('volume', this, value);
	        }
	    },
	
	    /**
	     * Sets the volume of this Sound.
	     *
	     * @method Phaser.Sound.WebAudioSound#setVolume
	     * @fires Phaser.Sound.WebAudioSound#volumeEvent
	     * @since 3.4.0
	     *
	     * @param {number} value - The volume of the sound.
	     *
	     * @return {Phaser.Sound.WebAudioSound} This Sound instance.
	     */
	    setVolume: function (value)
	    {
	        this.volume = value;
	
	        return this;
	    },
	
	    /**
	     * @event Phaser.Sound.WebAudioSound#seekEvent
	     * @param {Phaser.Sound.WebAudioSound} sound - Reference to the sound that emitted event.
	     * @param {number} value - An updated value of Phaser.Sound.WebAudioSound#seek property.
	     */
	
	    /**
	     * Property representing the position of playback for this sound, in seconds.
	     * Setting it to a specific value moves current playback to that position.
	     * The value given is clamped to the range 0 to current marker duration.
	     * Setting seek of a stopped sound has no effect.
	     * 
	     * @name Phaser.Sound.WebAudioSound#seek
	     * @type {number}
	     * @since 3.0.0
	     */
	    seek: {
	
	        get: function ()
	        {
	            if (this.isPlaying)
	            {
	                if (this.manager.context.currentTime < this.startTime)
	                {
	                    return this.startTime - this.playTime;
	                }
	
	                return this.getCurrentTime();
	            }
	            else if (this.isPaused)
	            {
	                return this.currentConfig.seek;
	            }
	            else
	            {
	                return 0;
	            }
	        },
	
	        set: function (value)
	        {
	            if (this.manager.context.currentTime < this.startTime)
	            {
	                return;
	            }
	
	            if (this.isPlaying || this.isPaused)
	            {
	                value = Math.min(Math.max(0, value), this.duration);
	
	                this.currentConfig.seek = value;
	
	                if (this.isPlaying)
	                {
	                    this.stopAndRemoveBufferSource();
	                    this.createAndStartBufferSource();
	                }
	
	                this.emit('seek', this, value);
	            }
	        }
	    },
	
	    /**
	     * Seeks to a specific point in this sound.
	     *
	     * @method Phaser.Sound.WebAudioSound#setSeek
	     * @fires Phaser.Sound.WebAudioSound#seekEvent
	     * @since 3.4.0
	     *
	     * @param {number} value - The point in the sound to seek to.
	     *
	     * @return {Phaser.Sound.WebAudioSound} This Sound instance.
	     */
	    setSeek: function (value)
	    {
	        this.seek = value;
	
	        return this;
	    },
	
	    /**
	     * @event Phaser.Sound.WebAudioSound#loopEvent
	     * @param {Phaser.Sound.WebAudioSound} sound - Reference to the sound that emitted event.
	     * @param {boolean} value - An updated value of Phaser.Sound.WebAudioSound#loop property.
	     */
	
	    /**
	     * Flag indicating whether or not the sound or current sound marker will loop.
	     * 
	     * @name Phaser.Sound.WebAudioSound#loop
	     * @type {boolean}
	     * @default false
	     * @since 3.0.0
	     */
	    loop: {
	
	        get: function ()
	        {
	            return this.currentConfig.loop;
	        },
	
	        set: function (value)
	        {
	            this.currentConfig.loop = value;
	
	            if (this.isPlaying)
	            {
	                this.stopAndRemoveLoopBufferSource();
	
	                if (value)
	                {
	                    this.createAndStartLoopBufferSource();
	                }
	            }
	
	            this.emit('loop', this, value);
	        }
	    },
	
	    /**
	     * Sets the loop state of this Sound.
	     *
	     * @method Phaser.Sound.WebAudioSound#setLoop
	     * @fires Phaser.Sound.WebAudioSound#loopEvent
	     * @since 3.4.0
	     *
	     * @param {boolean} value - `true` to loop this sound, `false` to not loop it.
	     *
	     * @return {Phaser.Sound.WebAudioSound} This Sound instance.
	     */
	    setLoop: function (value)
	    {
	        this.loop = value;
	
	        return this;
	    }
	
	});
	
	module.exports = WebAudioSound;


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BaseSoundManager = __webpack_require__(209);
	var Class = __webpack_require__(1);
	var WebAudioSound = __webpack_require__(630);
	
	/**
	 * @classdesc
	 * Web Audio API implementation of the sound manager.
	 *
	 * @class WebAudioSoundManager
	 * @extends Phaser.Sound.BaseSoundManager
	 * @memberOf Phaser.Sound
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Game} game - Reference to the current game instance.
	 */
	var WebAudioSoundManager = new Class({
	
	    Extends: BaseSoundManager,
	
	    initialize:
	
	    function WebAudioSoundManager (game)
	    {
	        /**
	         * The AudioContext being used for playback.
	         *
	         * @name Phaser.Sound.WebAudioSoundManager#context
	         * @type {AudioContext}
	         * @private
	         * @since 3.0.0
	         */
	        this.context = this.createAudioContext(game);
	
	        /**
	         * Gain node responsible for controlling global muting.
	         *
	         * @name Phaser.Sound.WebAudioSoundManager#masterMuteNode
	         * @type {GainNode}
	         * @private
	         * @since 3.0.0
	         */
	        this.masterMuteNode = this.context.createGain();
	
	        /**
	         * Gain node responsible for controlling global volume.
	         *
	         * @name Phaser.Sound.WebAudioSoundManager#masterVolumeNode
	         * @type {GainNode}
	         * @private
	         * @since 3.0.0
	         */
	        this.masterVolumeNode = this.context.createGain();
	
	        this.masterMuteNode.connect(this.masterVolumeNode);
	
	        this.masterVolumeNode.connect(this.context.destination);
	
	        /**
	         * Destination node for connecting individual sounds to.
	         *
	         * @name Phaser.Sound.WebAudioSoundManager#destination
	         * @type {AudioNode}
	         * @private
	         * @since 3.0.0
	         */
	        this.destination = this.masterMuteNode;
	
	        this.locked = this.context.state === 'suspended' && ('ontouchstart' in window || 'onclick' in window);
	
	        BaseSoundManager.call(this, game);
	
	        if (this.locked)
	        {
	            this.unlock();
	        }
	    },
	
	    /**
	     * Method responsible for instantiating and returning AudioContext instance.
	     * If an instance of an AudioContext class was provided through the game config,
	     * that instance will be returned instead. This can come in handy if you are reloading
	     * a Phaser game on a page that never properly refreshes (such as in an SPA project)
	     * and you want to reuse already instantiated AudioContext.
	     *
	     * @method Phaser.Sound.WebAudioSoundManager#createAudioContext
	     * @private
	     * @since 3.0.0
	     *
	     * @param {Phaser.Game} game - Reference to the current game instance.
	     *
	     * @return {AudioContext} The AudioContext instance to be used for playback.
	     */
	    createAudioContext: function (game)
	    {
	        var audioConfig = game.config.audio;
	
	        if (audioConfig && audioConfig.context)
	        {
	            audioConfig.context.resume();
	
	            return audioConfig.context;
	        }
	
	        return new AudioContext();
	    },
	
	    /**
	     * Adds a new sound into the sound manager.
	     *
	     * @method Phaser.Sound.WebAudioSoundManager#add
	     * @since 3.0.0
	     *
	     * @param {string} key - Asset key for the sound.
	     * @param {SoundConfig} [config] - An optional config object containing default sound settings.
	     *
	     * @return {Phaser.Sound.WebAudioSound} The new sound instance.
	     */
	    add: function (key, config)
	    {
	        var sound = new WebAudioSound(this, key, config);
	
	        this.sounds.push(sound);
	
	        return sound;
	    },
	
	    /**
	     * Unlocks Web Audio API on the initial input event.
	     *
	     * Read more about how this issue is handled here in [this article](https://medium.com/@pgoloskokovic/unlocking-web-audio-the-smarter-way-8858218c0e09).
	     *
	     * @method Phaser.Sound.WebAudioSoundManager#unlock
	     * @since 3.0.0
	     */
	    unlock: function ()
	    {
	        var _this = this;
	
	        var unlock = function ()
	        {
	            _this.context.resume().then(function ()
	            {
	                document.body.removeEventListener('touchstart', unlock);
	                document.body.removeEventListener('touchend', unlock);
	                document.body.removeEventListener('click', unlock);
	
	                _this.unlocked = true;
	            });
	        };
	
	        if (document.body)
	        {
	            document.body.addEventListener('touchstart', unlock, false);
	            document.body.addEventListener('touchend', unlock, false);
	            document.body.addEventListener('click', unlock, false);
	        }
	    },
	
	    /**
	     * Method used internally for pausing sound manager if
	     * Phaser.Sound.WebAudioSoundManager#pauseOnBlur is set to true.
	     *
	     * @method Phaser.Sound.WebAudioSoundManager#onBlur
	     * @protected
	     * @since 3.0.0
	     */
	    onBlur: function ()
	    {
	        this.context.suspend();
	    },
	
	    /**
	     * Method used internally for resuming sound manager if
	     * Phaser.Sound.WebAudioSoundManager#pauseOnBlur is set to true.
	     *
	     * @method Phaser.Sound.WebAudioSoundManager#onFocus
	     * @protected
	     * @since 3.0.0
	     */
	    onFocus: function ()
	    {
	        this.context.resume();
	    },
	
	    /**
	     * Calls Phaser.Sound.BaseSoundManager#destroy method
	     * and cleans up all Web Audio API related stuff.
	     *
	     * @method Phaser.Sound.WebAudioSoundManager#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.destination = null;
	        this.masterVolumeNode.disconnect();
	        this.masterVolumeNode = null;
	        this.masterMuteNode.disconnect();
	        this.masterMuteNode = null;
	
	        if (this.game.config.audio && this.game.config.audio.context)
	        {
	            this.context.suspend();
	        }
	        else
	        {
	            var _this = this;
	
	            this.context.close().then(function ()
	            {
	
	                _this.context = null;
	
	            });
	        }
	
	        BaseSoundManager.prototype.destroy.call(this);
	    },
	
	    /**
	     * @event Phaser.Sound.WebAudioSoundManager#muteEvent
	     * @param {Phaser.Sound.WebAudioSoundManager} soundManager - Reference to the sound manager that emitted event.
	     * @param {boolean} value - An updated value of Phaser.Sound.WebAudioSoundManager#mute property.
	     */
	
	    /**
	     * Sets the muted state of all this Sound Manager.
	     *
	     * @method Phaser.Sound.WebAudioSoundManager#setMute
	     * @fires Phaser.Sound.WebAudioSoundManager#muteEvent
	     * @since 3.3.0
	     *
	     * @param {boolean} value - `true` to mute all sounds, `false` to unmute them.
	     *
	     * @return {Phaser.Sound.WebAudioSoundManager} This Sound Manager.
	     */
	    setMute: function (value)
	    {
	        this.mute = value;
	
	        return this;
	    },
	
	    /**
	     * @name Phaser.Sound.WebAudioSoundManager#mute
	     * @type {boolean}
	     * @fires Phaser.Sound.WebAudioSoundManager#MuteEvent
	     * @since 3.0.0
	     */
	    mute: {
	
	        get: function ()
	        {
	            return (this.masterMuteNode.gain.value === 0);
	        },
	
	        set: function (value)
	        {
	            this.masterMuteNode.gain.setValueAtTime(value ? 0 : 1, 0);
	
	            this.emit('mute', this, value);
	        }
	
	    },
	
	    /**
	     * @event Phaser.Sound.WebAudioSoundManager#VolumeEvent
	     * @param {Phaser.Sound.WebAudioSoundManager} soundManager - Reference to the sound manager that emitted event.
	     * @param {number} value - An updated value of Phaser.Sound.WebAudioSoundManager#volume property.
	     */
	
	    /**
	     * Sets the volume of this Sound Manager.
	     *
	     * @method Phaser.Sound.WebAudioSoundManager#setVolume
	     * @fires Phaser.Sound.WebAudioSoundManager#VolumeEvent
	     * @since 3.3.0
	     *
	     * @param {number} value - The global volume of this Sound Manager.
	     *
	     * @return {Phaser.Sound.WebAudioSoundManager} This Sound Manager.
	     */
	    setVolume: function (value)
	    {
	        this.volume = value;
	
	        return this;
	    },
	
	    /**
	     * @name Phaser.Sound.WebAudioSoundManager#volume
	     * @type {number}
	     * @fires Phaser.Sound.WebAudioSoundManager#VolumeEvent
	     * @since 3.0.0
	     */
	    volume: {
	
	        get: function ()
	        {
	            return this.masterVolumeNode.gain.value;
	        },
	
	        set: function (value)
	        {
	            this.masterVolumeNode.gain.setValueAtTime(value, 0);
	
	            this.emit('volume', this, value);
	        }
	
	    }
	
	});
	
	module.exports = WebAudioSoundManager;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class ProcessQueue
	 * @memberOf Phaser.Structs
	 * @constructor
	 * @since 3.0.0
	 *
	 * @generic T
	 */
	var ProcessQueue = new Class({
	
	    initialize:
	
	    function ProcessQueue ()
	    {
	        /**
	         * [description]
	         *
	         * @genericUse {T[]} - [$type]
	         *
	         * @name Phaser.Structs.ProcessQueue#_pending
	         * @type {Array.<*>}
	         * @private
	         * @default []
	         * @since 3.0.0
	         */
	        this._pending = [];
	
	        /**
	         * [description]
	         *
	         * @genericUse {T[]} - [$type]
	         *
	         * @name Phaser.Structs.ProcessQueue#_active
	         * @type {Array.<*>}
	         * @private
	         * @default []
	         * @since 3.0.0
	         */
	        this._active = [];
	
	        /**
	         * [description]
	         *
	         * @genericUse {T[]} - [$type]
	         *
	         * @name Phaser.Structs.ProcessQueue#_destroy
	         * @type {Array.<*>}
	         * @private
	         * @default []
	         * @since 3.0.0
	         */
	        this._destroy = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Structs.ProcessQueue#_toProcess
	         * @type {integer}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._toProcess = 0;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.ProcessQueue#add
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [item]
	     * @genericUse {Phaser.Structs.ProcessQueue.<T>} - [$return]
	     *
	     * @param {*} item - [description]
	     *
	     * @return {Phaser.Structs.ProcessQueue} This Process Queue object.
	     */
	    add: function (item)
	    {
	        this._pending.push(item);
	
	        this._toProcess++;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.ProcessQueue#remove
	     * @since 3.0.0
	     *
	     * @genericUse {T} - [item]
	     * @genericUse {Phaser.Structs.ProcessQueue.<T>} - [$return]
	     *
	     * @param {*} item - [description]
	     *
	     * @return {Phaser.Structs.ProcessQueue} This Process Queue object.
	     */
	    remove: function (item)
	    {
	        this._destroy.push(item);
	
	        this._toProcess++;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.ProcessQueue#update
	     * @since 3.0.0
	     *
	     * @genericUse {T[]} - [$return]
	     *
	     * @return {Array.<*>} [description]
	     */
	    update: function ()
	    {
	        if (this._toProcess === 0)
	        {
	            //  Quick bail
	            return this._active;
	        }
	
	        var list = this._destroy;
	        var active = this._active;
	        var i;
	        var item;
	
	        //  Clear the 'destroy' list
	        for (i = 0; i < list.length; i++)
	        {
	            item = list[i];
	
	            //  Remove from the 'active' array
	            var idx = active.indexOf(item);
	
	            if (idx !== -1)
	            {
	                active.splice(idx, 1);
	            }
	        }
	
	        list.length = 0;
	
	        //  Process the pending addition list
	        //  This stops callbacks and out of sync events from populating the active array mid-way during an update
	
	        list = this._pending;
	
	        for (i = 0; i < list.length; i++)
	        {
	            item = list[i];
	
	            this._active.push(item);
	        }
	
	        list.length = 0;
	
	        this._toProcess = 0;
	
	        //  The owner of this queue can now safely do whatever it needs to with the active list
	        return this._active;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.ProcessQueue#getActive
	     * @since 3.0.0
	     *
	     * @genericUse {T[]} - [$return]
	     *
	     * @return {Array.<*>} [description]
	     */
	    getActive: function ()
	    {
	        return this._active;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Structs.ProcessQueue#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this._pending = [];
	        this._active = [];
	        this._destroy = [];
	    }
	
	});
	
	module.exports = ProcessQueue;


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var quickselect = __webpack_require__(658);
	
	/**
	 * @classdesc
	 * RBush is a high-performance JavaScript library for 2D spatial indexing of points and rectangles.
	 * It's based on an optimized R-tree data structure with bulk insertion support.
	 *
	 * Spatial index is a special data structure for points and rectangles that allows you to perform queries like
	 * "all items within this bounding box" very efficiently (e.g. hundreds of times faster than looping over all items).
	 *
	 * This version of RBush uses a fixed min/max accessor structure of `[ '.left', '.top', '.right', '.bottom' ]`.
	 * This is to avoid the eval like function creation that the original library used, which caused CSP policy violations.
	 *
	 * @class RTree
	 * @memberOf Phaser.Structs
	 * @constructor
	 * @since 3.0.0
	 */
	
	function rbush (maxEntries)
	{
	    var format = [ '.left', '.top', '.right', '.bottom' ];
	
	    if (!(this instanceof rbush)) return new rbush(maxEntries, format);
	
	    // max entries in a node is 9 by default; min node fill is 40% for best performance
	    this._maxEntries = Math.max(4, maxEntries || 9);
	    this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4));
	
	    this.clear();
	}
	
	rbush.prototype = {
	
	    all: function ()
	    {
	        return this._all(this.data, []);
	    },
	
	    search: function (bbox)
	    {
	        var node = this.data,
	            result = [],
	            toBBox = this.toBBox;
	
	        if (!intersects(bbox, node)) return result;
	
	        var nodesToSearch = [],
	            i, len, child, childBBox;
	
	        while (node) {
	            for (i = 0, len = node.children.length; i < len; i++) {
	
	                child = node.children[i];
	                childBBox = node.leaf ? toBBox(child) : child;
	
	                if (intersects(bbox, childBBox)) {
	                    if (node.leaf) result.push(child);
	                    else if (contains(bbox, childBBox)) this._all(child, result);
	                    else nodesToSearch.push(child);
	                }
	            }
	            node = nodesToSearch.pop();
	        }
	
	        return result;
	    },
	
	    collides: function (bbox)
	    {
	        var node = this.data,
	            toBBox = this.toBBox;
	
	        if (!intersects(bbox, node)) return false;
	
	        var nodesToSearch = [],
	            i, len, child, childBBox;
	
	        while (node) {
	            for (i = 0, len = node.children.length; i < len; i++) {
	
	                child = node.children[i];
	                childBBox = node.leaf ? toBBox(child) : child;
	
	                if (intersects(bbox, childBBox)) {
	                    if (node.leaf || contains(bbox, childBBox)) return true;
	                    nodesToSearch.push(child);
	                }
	            }
	            node = nodesToSearch.pop();
	        }
	
	        return false;
	    },
	
	    load: function (data)
	    {
	        if (!(data && data.length)) return this;
	
	        if (data.length < this._minEntries) {
	            for (var i = 0, len = data.length; i < len; i++) {
	                this.insert(data[i]);
	            }
	            return this;
	        }
	
	        // recursively build the tree with the given data from scratch using OMT algorithm
	        var node = this._build(data.slice(), 0, data.length - 1, 0);
	
	        if (!this.data.children.length) {
	            // save as is if tree is empty
	            this.data = node;
	
	        } else if (this.data.height === node.height) {
	            // split root if trees have the same height
	            this._splitRoot(this.data, node);
	
	        } else {
	            if (this.data.height < node.height) {
	                // swap trees if inserted one is bigger
	                var tmpNode = this.data;
	                this.data = node;
	                node = tmpNode;
	            }
	
	            // insert the small tree into the large tree at appropriate level
	            this._insert(node, this.data.height - node.height - 1, true);
	        }
	
	        return this;
	    },
	
	    insert: function (item)
	    {
	        if (item) this._insert(item, this.data.height - 1);
	        return this;
	    },
	
	    clear: function ()
	    {
	        this.data = createNode([]);
	        return this;
	    },
	
	    remove: function (item, equalsFn)
	    {
	        if (!item) return this;
	
	        var node = this.data,
	            bbox = this.toBBox(item),
	            path = [],
	            indexes = [],
	            i, parent, index, goingUp;
	
	        // depth-first iterative tree traversal
	        while (node || path.length) {
	
	            if (!node) { // go up
	                node = path.pop();
	                parent = path[path.length - 1];
	                i = indexes.pop();
	                goingUp = true;
	            }
	
	            if (node.leaf) { // check current node
	                index = findItem(item, node.children, equalsFn);
	
	                if (index !== -1) {
	                    // item found, remove the item and condense tree upwards
	                    node.children.splice(index, 1);
	                    path.push(node);
	                    this._condense(path);
	                    return this;
	                }
	            }
	
	            if (!goingUp && !node.leaf && contains(node, bbox)) { // go down
	                path.push(node);
	                indexes.push(i);
	                i = 0;
	                parent = node;
	                node = node.children[0];
	
	            } else if (parent) { // go right
	                i++;
	                node = parent.children[i];
	                goingUp = false;
	
	            } else node = null; // nothing found
	        }
	
	        return this;
	    },
	
	    toBBox: function (item) { return item; },
	
	    compareMinX: compareNodeMinX,
	    compareMinY: compareNodeMinY,
	
	    toJSON: function () { return this.data; },
	
	    fromJSON: function (data)
	    {
	        this.data = data;
	        return this;
	    },
	
	    _all: function (node, result)
	    {
	        var nodesToSearch = [];
	        while (node) {
	            if (node.leaf) result.push.apply(result, node.children);
	            else nodesToSearch.push.apply(nodesToSearch, node.children);
	
	            node = nodesToSearch.pop();
	        }
	        return result;
	    },
	
	    _build: function (items, left, right, height)
	    {
	        var N = right - left + 1,
	            M = this._maxEntries,
	            node;
	
	        if (N <= M) {
	            // reached leaf level; return leaf
	            node = createNode(items.slice(left, right + 1));
	            calcBBox(node, this.toBBox);
	            return node;
	        }
	
	        if (!height) {
	            // target height of the bulk-loaded tree
	            height = Math.ceil(Math.log(N) / Math.log(M));
	
	            // target number of root entries to maximize storage utilization
	            M = Math.ceil(N / Math.pow(M, height - 1));
	        }
	
	        node = createNode([]);
	        node.leaf = false;
	        node.height = height;
	
	        // split the items into M mostly square tiles
	
	        var N2 = Math.ceil(N / M),
	            N1 = N2 * Math.ceil(Math.sqrt(M)),
	            i, j, right2, right3;
	
	        multiSelect(items, left, right, N1, this.compareMinX);
	
	        for (i = left; i <= right; i += N1) {
	
	            right2 = Math.min(i + N1 - 1, right);
	
	            multiSelect(items, i, right2, N2, this.compareMinY);
	
	            for (j = i; j <= right2; j += N2) {
	
	                right3 = Math.min(j + N2 - 1, right2);
	
	                // pack each entry recursively
	                node.children.push(this._build(items, j, right3, height - 1));
	            }
	        }
	
	        calcBBox(node, this.toBBox);
	
	        return node;
	    },
	
	    _chooseSubtree: function (bbox, node, level, path)
	    {
	        var i, len, child, targetNode, area, enlargement, minArea, minEnlargement;
	
	        while (true) {
	            path.push(node);
	
	            if (node.leaf || path.length - 1 === level) break;
	
	            minArea = minEnlargement = Infinity;
	
	            for (i = 0, len = node.children.length; i < len; i++) {
	                child = node.children[i];
	                area = bboxArea(child);
	                enlargement = enlargedArea(bbox, child) - area;
	
	                // choose entry with the least area enlargement
	                if (enlargement < minEnlargement) {
	                    minEnlargement = enlargement;
	                    minArea = area < minArea ? area : minArea;
	                    targetNode = child;
	
	                } else if (enlargement === minEnlargement) {
	                    // otherwise choose one with the smallest area
	                    if (area < minArea) {
	                        minArea = area;
	                        targetNode = child;
	                    }
	                }
	            }
	
	            node = targetNode || node.children[0];
	        }
	
	        return node;
	    },
	
	    _insert: function (item, level, isNode)
	    {
	        var toBBox = this.toBBox,
	            bbox = isNode ? item : toBBox(item),
	            insertPath = [];
	
	        // find the best node for accommodating the item, saving all nodes along the path too
	        var node = this._chooseSubtree(bbox, this.data, level, insertPath);
	
	        // put the item into the node
	        node.children.push(item);
	        extend(node, bbox);
	
	        // split on node overflow; propagate upwards if necessary
	        while (level >= 0) {
	            if (insertPath[level].children.length > this._maxEntries) {
	                this._split(insertPath, level);
	                level--;
	            } else break;
	        }
	
	        // adjust bboxes along the insertion path
	        this._adjustParentBBoxes(bbox, insertPath, level);
	    },
	
	    // split overflowed node into two
	    _split: function (insertPath, level)
	    {
	        var node = insertPath[level],
	            M = node.children.length,
	            m = this._minEntries;
	
	        this._chooseSplitAxis(node, m, M);
	
	        var splitIndex = this._chooseSplitIndex(node, m, M);
	
	        var newNode = createNode(node.children.splice(splitIndex, node.children.length - splitIndex));
	        newNode.height = node.height;
	        newNode.leaf = node.leaf;
	
	        calcBBox(node, this.toBBox);
	        calcBBox(newNode, this.toBBox);
	
	        if (level) insertPath[level - 1].children.push(newNode);
	        else this._splitRoot(node, newNode);
	    },
	
	    _splitRoot: function (node, newNode)
	    {
	        // split root node
	        this.data = createNode([node, newNode]);
	        this.data.height = node.height + 1;
	        this.data.leaf = false;
	        calcBBox(this.data, this.toBBox);
	    },
	
	    _chooseSplitIndex: function (node, m, M)
	    {
	        var i, bbox1, bbox2, overlap, area, minOverlap, minArea, index;
	
	        minOverlap = minArea = Infinity;
	
	        for (i = m; i <= M - m; i++) {
	            bbox1 = distBBox(node, 0, i, this.toBBox);
	            bbox2 = distBBox(node, i, M, this.toBBox);
	
	            overlap = intersectionArea(bbox1, bbox2);
	            area = bboxArea(bbox1) + bboxArea(bbox2);
	
	            // choose distribution with minimum overlap
	            if (overlap < minOverlap) {
	                minOverlap = overlap;
	                index = i;
	
	                minArea = area < minArea ? area : minArea;
	
	            } else if (overlap === minOverlap) {
	                // otherwise choose distribution with minimum area
	                if (area < minArea) {
	                    minArea = area;
	                    index = i;
	                }
	            }
	        }
	
	        return index;
	    },
	
	    // sorts node children by the best axis for split
	    _chooseSplitAxis: function (node, m, M)
	    {
	        var compareMinX = node.leaf ? this.compareMinX : compareNodeMinX,
	            compareMinY = node.leaf ? this.compareMinY : compareNodeMinY,
	            xMargin = this._allDistMargin(node, m, M, compareMinX),
	            yMargin = this._allDistMargin(node, m, M, compareMinY);
	
	        // if total distributions margin value is minimal for x, sort by minX,
	        // otherwise it's already sorted by minY
	        if (xMargin < yMargin) node.children.sort(compareMinX);
	    },
	
	    // total margin of all possible split distributions where each node is at least m full
	    _allDistMargin: function (node, m, M, compare)
	    {
	        node.children.sort(compare);
	
	        var toBBox = this.toBBox,
	            leftBBox = distBBox(node, 0, m, toBBox),
	            rightBBox = distBBox(node, M - m, M, toBBox),
	            margin = bboxMargin(leftBBox) + bboxMargin(rightBBox),
	            i, child;
	
	        for (i = m; i < M - m; i++) {
	            child = node.children[i];
	            extend(leftBBox, node.leaf ? toBBox(child) : child);
	            margin += bboxMargin(leftBBox);
	        }
	
	        for (i = M - m - 1; i >= m; i--) {
	            child = node.children[i];
	            extend(rightBBox, node.leaf ? toBBox(child) : child);
	            margin += bboxMargin(rightBBox);
	        }
	
	        return margin;
	    },
	
	    _adjustParentBBoxes: function (bbox, path, level)
	    {
	        // adjust bboxes along the given tree path
	        for (var i = level; i >= 0; i--) {
	            extend(path[i], bbox);
	        }
	    },
	
	    _condense: function (path)
	    {
	        // go through the path, removing empty nodes and updating bboxes
	        for (var i = path.length - 1, siblings; i >= 0; i--) {
	            if (path[i].children.length === 0) {
	                if (i > 0) {
	                    siblings = path[i - 1].children;
	                    siblings.splice(siblings.indexOf(path[i]), 1);
	
	                } else this.clear();
	
	            } else calcBBox(path[i], this.toBBox);
	        }
	    },
	
	    compareMinX: function (a, b)
	    {
	        return a.left - b.left;
	    },
	
	    compareMinY: function (a, b)
	    {
	        return a.top - b.top;
	    },
	
	    toBBox: function (a)
	    {
	        return {
	            minX: a.left,
	            minY: a.top,
	            maxX: a.right,
	            maxY: a.bottom
	        };
	    }
	};
	
	function findItem (item, items, equalsFn)
	{
	    if (!equalsFn) return items.indexOf(item);
	
	    for (var i = 0; i < items.length; i++) {
	        if (equalsFn(item, items[i])) return i;
	    }
	    return -1;
	}
	
	// calculate node's bbox from bboxes of its children
	function calcBBox (node, toBBox)
	{
	    distBBox(node, 0, node.children.length, toBBox, node);
	}
	
	// min bounding rectangle of node children from k to p-1
	function distBBox (node, k, p, toBBox, destNode)
	{
	    if (!destNode) destNode = createNode(null);
	    destNode.minX = Infinity;
	    destNode.minY = Infinity;
	    destNode.maxX = -Infinity;
	    destNode.maxY = -Infinity;
	
	    for (var i = k, child; i < p; i++) {
	        child = node.children[i];
	        extend(destNode, node.leaf ? toBBox(child) : child);
	    }
	
	    return destNode;
	}
	
	function extend (a, b)
	{
	    a.minX = Math.min(a.minX, b.minX);
	    a.minY = Math.min(a.minY, b.minY);
	    a.maxX = Math.max(a.maxX, b.maxX);
	    a.maxY = Math.max(a.maxY, b.maxY);
	    return a;
	}
	
	function compareNodeMinX (a, b) { return a.minX - b.minX; }
	function compareNodeMinY (a, b) { return a.minY - b.minY; }
	
	function bboxArea (a) { return (a.maxX - a.minX) * (a.maxY - a.minY); }
	function bboxMargin (a) { return (a.maxX - a.minX) + (a.maxY - a.minY); }
	
	function enlargedArea (a, b)
	{
	    return (Math.max(b.maxX, a.maxX) - Math.min(b.minX, a.minX)) *
	           (Math.max(b.maxY, a.maxY) - Math.min(b.minY, a.minY));
	}
	
	function intersectionArea (a, b)
	{
	    var minX = Math.max(a.minX, b.minX),
	        minY = Math.max(a.minY, b.minY),
	        maxX = Math.min(a.maxX, b.maxX),
	        maxY = Math.min(a.maxY, b.maxY);
	
	    return Math.max(0, maxX - minX) *
	           Math.max(0, maxY - minY);
	}
	
	function contains (a, b)
	{
	    return a.minX <= b.minX &&
	           a.minY <= b.minY &&
	           b.maxX <= a.maxX &&
	           b.maxY <= a.maxY;
	}
	
	function intersects (a, b)
	{
	    return b.minX <= a.maxX &&
	           b.minY <= a.maxY &&
	           b.maxX >= a.minX &&
	           b.maxY >= a.minY;
	}
	
	function createNode (children)
	{
	    return {
	        children: children,
	        height: 1,
	        leaf: true,
	        minX: Infinity,
	        minY: Infinity,
	        maxX: -Infinity,
	        maxY: -Infinity
	    };
	}
	
	// sort an array so that items come in groups of n unsorted items, with groups sorted between each other;
	// combines selection algorithm with binary divide & conquer approach
	
	function multiSelect (arr, left, right, n, compare)
	{
	    var stack = [left, right],
	        mid;
	
	    while (stack.length)
	    {
	        right = stack.pop();
	        left = stack.pop();
	
	        if (right - left <= n) continue;
	
	        mid = left + Math.ceil((right - left) / n / 2) * n;
	        quickselect(arr, mid, left, right, compare);
	
	        stack.push(left, mid, mid, right);
	    }
	}
	
	module.exports = rbush;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CanvasPool = __webpack_require__(56);
	var CanvasTexture = __webpack_require__(1520);
	var Class = __webpack_require__(1);
	var Color = __webpack_require__(95);
	var CONST = __webpack_require__(49);
	var EventEmitter = __webpack_require__(22);
	var GenerateTexture = __webpack_require__(452);
	var GetValue = __webpack_require__(10);
	var Parser = __webpack_require__(636);
	var Texture = __webpack_require__(328);
	
	/**
	 * @callback EachTextureCallback
	 *
	 * @param {Phaser.Textures.Texture} texture - [description]
	 * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
	 */
	
	/**
	 * @classdesc
	 * Textures are managed by the global TextureManager. This is a singleton class that is
	 * responsible for creating and delivering Textures and their corresponding Frames to Game Objects.
	 *
	 * Sprites and other Game Objects get the texture data they need from the TextureManager.
	 *
	 * Access it via `scene.textures`.
	 *
	 * @class TextureManager
	 * @extends Phaser.Events.EventEmitter
	 * @memberOf Phaser.Textures
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Game} game - [description]
	 */
	var TextureManager = new Class({
	
	    Extends: EventEmitter,
	
	    initialize:
	
	    function TextureManager (game)
	    {
	        EventEmitter.call(this);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Textures.TextureManager#game
	         * @type {Phaser.Game}
	         * @since 3.0.0
	         */
	        this.game = game;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Textures.TextureManager#name
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.name = 'TextureManager';
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Textures.TextureManager#list
	         * @type {object}
	         * @default {}
	         * @since 3.0.0
	         */
	        this.list = {};
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Textures.TextureManager#_tempCanvas
	         * @type {HTMLCanvasElement}
	         * @private
	         * @since 3.0.0
	         */
	        this._tempCanvas = CanvasPool.create2D(this, 1, 1);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Textures.TextureManager#_tempContext
	         * @type {CanvasRenderingContext2D}
	         * @private
	         * @since 3.0.0
	         */
	        this._tempContext = this._tempCanvas.getContext('2d');
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Textures.TextureManager#_pending
	         * @type {integer}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._pending = 0;
	
	        game.events.once('boot', this.boot, this);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Textures.TextureManager#boot
	     * @since 3.0.0
	     */
	    boot: function ()
	    {
	        this._pending = 2;
	
	        this.on('onload', this.updatePending, this);
	        this.on('onerror', this.updatePending, this);
	
	        this.addBase64('__DEFAULT', this.game.config.defaultImage);
	        this.addBase64('__MISSING', this.game.config.missingImage);
	
	        this.game.events.once('destroy', this.destroy, this);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Textures.TextureManager#updatePending
	     * @since 3.0.0
	     */
	    updatePending: function ()
	    {
	        this._pending--;
	
	        if (this._pending === 0)
	        {
	            this.off('onload');
	            this.off('onerror');
	
	            this.game.events.emit('ready');
	        }
	    },
	
	    /**
	     * Checks the given texture key and throws a console.warn if the key is already in use, then returns false.
	     * If you wish to avoid the console.warn then use `TextureManager.exists` instead.
	     *
	     * @method Phaser.Textures.TextureManager#checkKey
	     * @since 3.7.0
	     *
	     * @param {string} key - The texture key to check.
	     *
	     * @return {boolean} `true` if it's safe to use the texture key, otherwise `false`.
	     */
	    checkKey: function (key)
	    {
	        if (this.exists(key))
	        {
	            // eslint-disable-next-line no-console
	            console.error('Texture key already in use: ' + key);
	
	            return false;
	        }
	
	        return true;
	    },
	
	    /**
	     * Removes a Texture from the Texture Manager and destroys it. This will immediately
	     * clear all references to it from the Texture Manager, and if it has one, destroy its
	     * WebGLTexture. This will emit a `removetexture` event.
	     *
	     * Note: If you have any Game Objects still using this texture they will start throwing
	     * errors the next time they try to render. Make sure that removing the texture is the final
	     * step when clearing down to avoid this.
	     *
	     * @method Phaser.Textures.TextureManager#remove
	     * @since 3.7.0
	     *
	     * @param {(string|Phaser.Textures.Texture)} key - The key of the Texture to remove, or a reference to it.
	     *
	     * @return {Phaser.Textures.TextureManager} The Texture Manager.
	     */
	    remove: function (key)
	    {
	        if (typeof key === 'string')
	        {
	            if (this.exists(key))
	            {
	                key = this.get(key);
	            }
	            else
	            {
	                console.warn('No texture found matching key: ' + key);
	                return this;
	            }
	        }
	
	        //  By this point key should be a Texture, if not, the following fails anyway
	        if (this.list.hasOwnProperty(key.key))
	        {
	            delete this.list[key.key];
	
	            key.destroy();
	
	            this.emit('removetexture', key.key);
	        }
	
	        return this;
	    },
	
	    /**
	     * Adds a new Texture to the Texture Manager created from the given Base64 encoded data.
	     *
	     * @method Phaser.Textures.TextureManager#addBase64
	     * @since 3.0.0
	     *
	     * @param {string} key - The unique string-based key of the Texture.
	     * @param {*} data - The Base64 encoded data.
	     */
	    addBase64: function (key, data)
	    {
	        if (this.checkKey(key))
	        {
	            var _this = this;
	
	            var image = new Image();
	
	            image.onerror = function ()
	            {
	                _this.emit('onerror', key);
	            };
	
	            image.onload = function ()
	            {
	                var texture = _this.create(key, image);
	
	                Parser.Image(texture, 0);
	
	                _this.emit('addtexture', key, texture);
	
	                _this.emit('onload', key, texture);
	            };
	
	            image.src = data;
	        }
	    },
	
	    /**
	     * Adds a new Texture to the Texture Manager created from the given Image element.
	     *
	     * @method Phaser.Textures.TextureManager#addImage
	     * @since 3.0.0
	     *
	     * @param {string} key - The unique string-based key of the Texture.
	     * @param {HTMLImageElement} source - The source Image element.
	     * @param {HTMLImageElement} [dataSource] - An optional data Image element.
	     *
	     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
	     */
	    addImage: function (key, source, dataSource)
	    {
	        var texture = null;
	
	        if (this.checkKey(key))
	        {
	            texture = this.create(key, source);
	
	            Parser.Image(texture, 0);
	
	            if (dataSource)
	            {
	                texture.setDataSource(dataSource);
	            }
	
	            this.emit('addtexture', key, texture);
	        }
	        
	        return texture;
	    },
	
	    /**
	     * Creates a new Texture using the given config values.
	     * Generated textures consist of a Canvas element to which the texture data is drawn.
	     * See the Phaser.Create function for the more direct way to create textures.
	     *
	     * @method Phaser.Textures.TextureManager#generate
	     * @since 3.0.0
	     *
	     * @param {string} key - The unique string-based key of the Texture.
	     * @param {object} config - [description]
	     *
	     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
	     */
	    generate: function (key, config)
	    {
	        if (this.checkKey(key))
	        {
	            var canvas = CanvasPool.create(this, 1, 1);
	
	            config.canvas = canvas;
	
	            GenerateTexture(config);
	
	            return this.addCanvas(key, canvas);
	        }
	        else
	        {
	            return null;
	        }
	    },
	
	    /**
	     * Creates a new Texture using a blank Canvas element of the size given.
	     *
	     * Canvas elements are automatically pooled and calling this method will
	     * extract a free canvas from the CanvasPool, or create one if none are available.
	     *
	     * @method Phaser.Textures.TextureManager#createCanvas
	     * @since 3.0.0
	     *
	     * @param {string} key - The unique string-based key of the Texture.
	     * @param {integer} [width=256]- The width of the Canvas element.
	     * @param {integer} [height=256] - The height of the Canvas element.
	     *
	     * @return {?Phaser.Textures.CanvasTexture} The Canvas Texture that was created, or `null` if the key is already in use.
	     */
	    createCanvas: function (key, width, height)
	    {
	        if (width === undefined) { width = 256; }
	        if (height === undefined) { height = 256; }
	
	        if (this.checkKey(key))
	        {
	            var canvas = CanvasPool.create(this, width, height, CONST.CANVAS, true);
	
	            return this.addCanvas(key, canvas);
	        }
	
	        return null;
	    },
	
	    /**
	     * Creates a new Canvas Texture object from an existing Canvas element and adds
	     * it to this Texture Manager.
	     *
	     * @method Phaser.Textures.TextureManager#addCanvas
	     * @since 3.0.0
	     *
	     * @param {string} key - The unique string-based key of the Texture.
	     * @param {HTMLCanvasElement} source - The Canvas element to form the base of the new Texture.
	     *
	     * @return {?Phaser.Textures.CanvasTexture} The Canvas Texture that was created, or `null` if the key is already in use.
	     */
	    addCanvas: function (key, source)
	    {
	        var texture = null;
	
	        if (this.checkKey(key))
	        {
	            texture = new CanvasTexture(this, key, source, source.width, source.height);
	
	            this.list[key] = texture;
	
	            this.emit('addtexture', key, texture);
	        }
	
	        return texture;
	    },
	
	    /**
	     * Adds a new Texture Atlas to this Texture Manager.
	     * It can accept either JSON Array or JSON Hash formats, as exported by Texture Packer and similar software.
	     *
	     * @method Phaser.Textures.TextureManager#addAtlas
	     * @since 3.0.0
	     *
	     * @param {string} key - The unique string-based key of the Texture.
	     * @param {HTMLImageElement} source - The source Image element.
	     * @param {object} data - The Texture Atlas data.
	     * @param {HTMLImageElement} [dataSource] - An optional data Image element.
	     *
	     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
	     */
	    addAtlas: function (key, source, data, dataSource)
	    {
	        //  New Texture Packer format?
	        if (Array.isArray(data.textures) || Array.isArray(data.frames))
	        {
	            return this.addAtlasJSONArray(key, source, data, dataSource);
	        }
	        else
	        {
	            return this.addAtlasJSONHash(key, source, data, dataSource);
	        }
	    },
	
	    /**
	     * Adds a Texture Atlas to this Texture Manager.
	     * The frame data of the atlas must be stored in an Array within the JSON.
	     * This is known as a JSON Array in software such as Texture Packer.
	     *
	     * @method Phaser.Textures.TextureManager#addAtlasJSONArray
	     * @since 3.0.0
	     *
	     * @param {string} key - The unique string-based key of the Texture.
	     * @param {(HTMLImageElement|HTMLImageElement[])} source - The source Image element/s.
	     * @param {(object|object[])} data - The Texture Atlas data/s.
	     * @param {HTMLImageElement} [dataSource] - An optional data Image element.
	     *
	     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
	     */
	    addAtlasJSONArray: function (key, source, data, dataSource)
	    {
	        var texture = null;
	
	        if (this.checkKey(key))
	        {
	            texture = this.create(key, source);
	
	            //  Multi-Atlas?
	            if (Array.isArray(data))
	            {
	                var singleAtlasFile = (data.length === 1); // multi-pack with one atlas file for all images
	
	                //  !! Assumes the textures are in the same order in the source array as in the json data !!
	                for (var i = 0; i < texture.source.length; i++)
	                {
	                    var atlasData = singleAtlasFile ? data[0] : data[i];
	
	                    Parser.JSONArray(texture, i, atlasData);
	                }
	            }
	            else
	            {
	                Parser.JSONArray(texture, 0, data);
	            }
	
	            if (dataSource)
	            {
	                texture.setDataSource(dataSource);
	            }
	
	            this.emit('addtexture', key, texture);
	        }
	
	        return texture;
	    },
	
	    /**
	     * Adds a Texture Atlas to this Texture Manager.
	     * The frame data of the atlas must be stored in an Object within the JSON.
	     * This is known as a JSON Hash in software such as Texture Packer.
	     *
	     * @method Phaser.Textures.TextureManager#addAtlasJSONHash
	     * @since 3.0.0
	     *
	     * @param {string} key - The unique string-based key of the Texture.
	     * @param {HTMLImageElement} source - The source Image element.
	     * @param {object} data - The Texture Atlas data.
	     * @param {HTMLImageElement} [dataSource] - An optional data Image element.
	     *
	     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
	     */
	    addAtlasJSONHash: function (key, source, data, dataSource)
	    {
	        var texture = null;
	
	        if (this.checkKey(key))
	        {
	            texture = this.create(key, source);
	
	            if (Array.isArray(data))
	            {
	                for (var i = 0; i < data.length; i++)
	                {
	                    Parser.JSONHash(texture, i, data[i]);
	                }
	            }
	            else
	            {
	                Parser.JSONHash(texture, 0, data);
	            }
	
	            if (dataSource)
	            {
	                texture.setDataSource(dataSource);
	            }
	
	            this.emit('addtexture', key, texture);
	        }
	
	        return texture;
	    },
	
	    /**
	     * Adds a Texture Atlas to this Texture Manager, where the atlas data is given
	     * in the XML format.
	     *
	     * @method Phaser.Textures.TextureManager#addAtlasXML
	     * @since 3.7.0
	     *
	     * @param {string} key - The unique string-based key of the Texture.
	     * @param {HTMLImageElement} source - The source Image element.
	     * @param {object} data - The Texture Atlas XML data.
	     * @param {HTMLImageElement} [dataSource] - An optional data Image element.
	     *
	     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
	     */
	    addAtlasXML: function (key, source, data, dataSource)
	    {
	        var texture = null;
	
	        if (this.checkKey(key))
	        {
	            texture = this.create(key, source);
	            
	            Parser.AtlasXML(texture, 0, data);
	
	            if (dataSource)
	            {
	                texture.setDataSource(dataSource);
	            }
	
	            this.emit('addtexture', key, texture);
	        }
	
	        return texture;
	    },
	
	    /**
	     * Adds a Unity Texture Atlas to this Texture Manager.
	     * The data must be in the form of a Unity YAML file.
	     *
	     * @method Phaser.Textures.TextureManager#addUnityAtlas
	     * @since 3.0.0
	     *
	     * @param {string} key - The unique string-based key of the Texture.
	     * @param {HTMLImageElement} source - The source Image element.
	     * @param {object} data - The Texture Atlas data.
	     * @param {HTMLImageElement} [dataSource] - An optional data Image element.
	     *
	     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
	     */
	    addUnityAtlas: function (key, source, data, dataSource)
	    {
	        var texture = null;
	
	        if (this.checkKey(key))
	        {
	            texture = this.create(key, source);
	
	            Parser.UnityYAML(texture, 0, data);
	
	            if (dataSource)
	            {
	                texture.setDataSource(dataSource);
	            }
	
	            this.emit('addtexture', key, texture);
	        }
	
	        return texture;
	    },
	
	    /**
	     * @typedef {object} SpriteSheetConfig
	     * 
	     * @property {integer} frameWidth - The fixed width of each frame.
	     * @property {integer} [frameHeight] - The fixed height of each frame. If not set it will use the frameWidth as the height.
	     * @property {integer} [startFrame=0] - Skip a number of frames. Useful when there are multiple sprite sheets in one Texture.
	     * @property {integer} [endFrame=-1] - The total number of frames to extract from the Sprite Sheet. The default value of -1 means "extract all frames".
	     * @property {integer} [margin=0] - If the frames have been drawn with a margin, specify the amount here.
	     * @property {integer} [spacing=0] - If the frames have been drawn with spacing between them, specify the amount here.
	     */
	
	    /**
	     * Adds a Sprite Sheet to this Texture Manager.
	     *
	     * In Phaser terminology a Sprite Sheet is a texture containing different frames, but each frame is the exact
	     * same size and cannot be trimmed or rotated.
	     *
	     * @method Phaser.Textures.TextureManager#addSpriteSheet
	     * @since 3.0.0
	     *
	     * @param {string} key - The unique string-based key of the Texture.
	     * @param {HTMLImageElement} source - The source Image element.
	     * @param {SpriteSheetConfig} config - The configuration object for this Sprite Sheet.
	     *
	     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
	     */
	    addSpriteSheet: function (key, source, config)
	    {
	        var texture = null;
	
	        if (this.checkKey(key))
	        {
	            texture = this.create(key, source);
	
	            var width = texture.source[0].width;
	            var height = texture.source[0].height;
	
	            Parser.SpriteSheet(texture, 0, 0, 0, width, height, config);
	
	            this.emit('addtexture', key, texture);
	        }
	
	        return texture;
	    },
	
	    /**
	     * @typedef {object} SpriteSheetFromAtlasConfig
	     * 
	     * @property {string} atlas - The key of the Texture Atlas in which this Sprite Sheet can be found.
	     * @property {string} frame - The key of the Texture Atlas Frame in which this Sprite Sheet can be found.
	     * @property {integer} frameWidth - The fixed width of each frame.
	     * @property {integer} [frameHeight] - The fixed height of each frame. If not set it will use the frameWidth as the height.
	     * @property {integer} [startFrame=0] - Skip a number of frames. Useful when there are multiple sprite sheets in one Texture.
	     * @property {integer} [endFrame=-1] - The total number of frames to extract from the Sprite Sheet. The default value of -1 means "extract all frames".
	     * @property {integer} [margin=0] - If the frames have been drawn with a margin, specify the amount here.
	     * @property {integer} [spacing=0] - If the frames have been drawn with spacing between them, specify the amount here.
	     */
	
	    /**
	     * Adds a Sprite Sheet to this Texture Manager, where the Sprite Sheet exists as a Frame within a Texture Atlas.
	     *
	     * In Phaser terminology a Sprite Sheet is a texture containing different frames, but each frame is the exact
	     * same size and cannot be trimmed or rotated.
	     *
	     * @method Phaser.Textures.TextureManager#addSpriteSheetFromAtlas
	     * @since 3.0.0
	     *
	     * @param {string} key - The unique string-based key of the Texture.
	     * @param {SpriteSheetFromAtlasConfig} config - The configuration object for this Sprite Sheet.
	     *
	     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
	     */
	    addSpriteSheetFromAtlas: function (key, config)
	    {
	        if (!this.checkKey(key))
	        {
	            return null;
	        }
	
	        var atlasKey = GetValue(config, 'atlas', null);
	        var atlasFrame = GetValue(config, 'frame', null);
	
	        if (!atlasKey || !atlasFrame)
	        {
	            return;
	        }
	
	        var atlas = this.get(atlasKey);
	        var sheet = atlas.get(atlasFrame);
	
	        if (sheet)
	        {
	            var texture = this.create(key, sheet.source.image);
	
	            if (sheet.trimmed)
	            {
	                //  If trimmed we need to help the parser adjust
	                Parser.SpriteSheetFromAtlas(texture, sheet, config);
	            }
	            else
	            {
	                Parser.SpriteSheet(texture, 0, sheet.cutX, sheet.cutY, sheet.cutWidth, sheet.cutHeight, config);
	            }
	
	            this.emit('addtexture', key, texture);
	
	            return texture;
	        }
	    },
	
	    /**
	     * Creates a new Texture using the given source and dimensions.
	     *
	     * @method Phaser.Textures.TextureManager#create
	     * @since 3.0.0
	     *
	     * @param {string} key - The unique string-based key of the Texture.
	     * @param {HTMLImageElement} source - The source Image element.
	     * @param {integer} width - The width of the Texture.
	     * @param {integer} height - The height of the Texture.
	     *
	     * @return {?Phaser.Textures.Texture} The Texture that was created, or `null` if the key is already in use.
	     */
	    create: function (key, source, width, height)
	    {
	        var texture = null;
	
	        if (this.checkKey(key))
	        {
	            texture = new Texture(this, key, source, width, height);
	
	            this.list[key] = texture;
	        }
	
	        return texture;
	    },
	
	    /**
	     * Checks the given key to see if a Texture using it exists within this Texture Manager.
	     *
	     * @method Phaser.Textures.TextureManager#exists
	     * @since 3.0.0
	     *
	     * @param {string} key - The unique string-based key of the Texture.
	     *
	     * @return {boolean} Returns `true` if a Texture matching the given key exists in this Texture Manager.
	     */
	    exists: function (key)
	    {
	        return (this.list.hasOwnProperty(key));
	    },
	
	    /**
	     * Returns a Texture from the Texture Manager that matches the given key.
	     * If the key is undefined it will return the `__DEFAULT` Texture.
	     * If the key is given, but not found, it will return the `__MISSING` Texture.
	     *
	     * @method Phaser.Textures.TextureManager#get
	     * @since 3.0.0
	     *
	     * @param {string} key - The unique string-based key of the Texture.
	     *
	     * @return {Phaser.Textures.Texture} The Texture that was created.
	     */
	    get: function (key)
	    {
	        if (key === undefined) { key = '__DEFAULT'; }
	
	        if (this.list[key])
	        {
	            return this.list[key];
	        }
	        else
	        {
	            return this.list['__MISSING'];
	        }
	    },
	
	    /**
	     * Takes a Texture key and Frame name and returns a clone of that Frame if found.
	     *
	     * @method Phaser.Textures.TextureManager#cloneFrame
	     * @since 3.0.0
	     *
	     * @param {string} key - The unique string-based key of the Texture.
	     * @param {(string|integer)} frame - The string or index of the Frame to be cloned.
	     *
	     * @return {Phaser.Textures.Frame} A Clone of the given Frame.
	     */
	    cloneFrame: function (key, frame)
	    {
	        if (this.list[key])
	        {
	            return this.list[key].get(frame).clone();
	        }
	    },
	
	    /**
	     * Takes a Texture key and Frame name and returns a reference to that Frame, if found.
	     *
	     * @method Phaser.Textures.TextureManager#getFrame
	     * @since 3.0.0
	     *
	     * @param {string} key - The unique string-based key of the Texture.
	     * @param {(string|integer)} frame - The string or index of the Frame.
	     *
	     * @return {Phaser.Textures.Frame} A Texture Frame object.
	     */
	    getFrame: function (key, frame)
	    {
	        if (this.list[key])
	        {
	            return this.list[key].get(frame);
	        }
	    },
	
	    /**
	     * Returns an array with all of the keys of all Textures in this Texture Manager.
	     * The output array will exclude the `__DEFAULT` and `__MISSING` keys.
	     *
	     * @method Phaser.Textures.TextureManager#getTextureKeys
	     * @since 3.0.0
	     *
	     * @return {string[]} An array containing all of the Texture keys stored in this Texture Manager.
	     */
	    getTextureKeys: function ()
	    {
	        var output = [];
	
	        for (var key in this.list)
	        {
	            if (key !== '__DEFAULT' && key !== '__MISSING')
	            {
	                output.push(key);
	            }
	        }
	
	        return output;
	    },
	
	    /**
	     * Given a Texture and an `x` and `y` coordinate this method will return a new
	     * Color object that has been populated with the color and alpha values of the pixel
	     * at that location in the Texture.
	     *
	     * @method Phaser.Textures.TextureManager#getPixel
	     * @since 3.0.0
	     *
	     * @param {integer} x - The x coordinate of the pixel within the Texture.
	     * @param {integer} y - The y coordinate of the pixel within the Texture.
	     * @param {string} key - The unique string-based key of the Texture.
	     * @param {(string|integer)} frame - The string or index of the Frame.
	     *
	     * @return {?Phaser.Display.Color} A Color object populated with the color values of the requested pixel,
	     * or `null` if the coordinates were out of bounds.
	     */
	    getPixel: function (x, y, key, frame)
	    {
	        var textureFrame = this.getFrame(key, frame);
	
	        if (textureFrame)
	        {
	            var source = textureFrame.source.image;
	
	            if (x >= 0 && x <= source.width && y >= 0 && y <= source.height)
	            {
	                x += textureFrame.cutX;
	                y += textureFrame.cutY;
	
	                // if (textureFrame.trimmed)
	                // {
	                //     x -= this.sprite.texture.trim.x;
	                //     y -= this.sprite.texture.trim.y;
	                // }
	
	                var context = this._tempContext;
	
	                context.clearRect(0, 0, 1, 1);
	                context.drawImage(source, x, y, 1, 1, 0, 0, 1, 1);
	
	                var rgb = context.getImageData(0, 0, 1, 1);
	
	                return new Color(rgb.data[0], rgb.data[1], rgb.data[2], rgb.data[3]);
	            }
	        }
	
	        return null;
	    },
	
	    /**
	     * Sets the given Game Objects `texture` and `frame` properties so that it uses
	     * the Texture and Frame specified in the `key` and `frame` arguments to this method.
	     *
	     * @method Phaser.Textures.TextureManager#setTexture
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} gameObject - [description]
	     * @param {string} key - The unique string-based key of the Texture.
	     * @param {(string|integer)} frame - The string or index of the Frame.
	     *
	     * @return {Phaser.GameObjects.GameObject} The Game Object the texture was set on.
	     */
	    setTexture: function (gameObject, key, frame)
	    {
	        if (this.list[key])
	        {
	            gameObject.texture = this.list[key];
	            gameObject.frame = gameObject.texture.get(frame);
	        }
	
	        return gameObject;
	    },
	
	    /**
	     * Passes all Textures to the given callback.
	     *
	     * @method Phaser.Textures.TextureManager#each
	     * @since 3.0.0
	     *
	     * @param {EachTextureCallback} callback - The callback function to be sent the Textures.
	     * @param {object} scope - The value to use as `this` when executing the callback.
	     * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
	     */
	    each: function (callback, scope)
	    {
	        var args = [ null ];
	
	        for (var i = 1; i < arguments.length; i++)
	        {
	            args.push(arguments[i]);
	        }
	
	        for (var texture in this.list)
	        {
	            args[0] = this.list[texture];
	
	            callback.apply(scope, args);
	        }
	    },
	
	    /**
	     * Destroys the Texture Manager and all Textures stored within it.
	     *
	     * @method Phaser.Textures.TextureManager#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        for (var texture in this.list)
	        {
	            this.list[texture].destroy();
	        }
	
	        this.list = {};
	
	        this.game = null;
	
	        CanvasPool.remove(this._tempCanvas);
	    }
	
	});
	
	module.exports = TextureManager;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CanvasPool = __webpack_require__(56);
	var Class = __webpack_require__(1);
	var IsSizePowerOfTwo = __webpack_require__(203);
	var ScaleModes = __webpack_require__(167);
	
	/**
	 * @classdesc
	 * A Texture Source is the encapsulation of the actual source data for a Texture.
	 * This is typically an Image Element, loaded from the file system or network, or a Canvas Element.
	 *
	 * A Texture can contain multiple Texture Sources, which only happens when a multi-atlas is loaded.
	 *
	 * @class TextureSource
	 * @memberOf Phaser.Textures
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Textures.Texture} texture - The Texture this TextureSource belongs to.
	 * @param {(HTMLImageElement|HTMLCanvasElement)} source - The source image data.
	 * @param {integer} [width] - Optional width of the source image. If not given it's derived from the source itself.
	 * @param {integer} [height] - Optional height of the source image. If not given it's derived from the source itself.
	 */
	var TextureSource = new Class({
	
	    initialize:
	
	    function TextureSource (texture, source, width, height)
	    {
	        var game = texture.manager.game;
	
	        /**
	         * The Texture this TextureSource belongs to.
	         *
	         * @name Phaser.Textures.TextureSource#renderer
	         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
	         * @since 3.7.0
	         */
	        this.renderer = game.renderer;
	
	        /**
	         * The Texture this TextureSource belongs to.
	         *
	         * @name Phaser.Textures.TextureSource#texture
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.texture = texture;
	
	        /**
	         * The source image data. This is either an Image Element, or a Canvas Element.
	         *
	         * @name Phaser.Textures.TextureSource#image
	         * @type {(HTMLImageElement|HTMLCanvasElement)}
	         * @since 3.0.0
	         */
	        this.image = source;
	
	        /**
	         * Currently un-used.
	         *
	         * @name Phaser.Textures.TextureSource#compressionAlgorithm
	         * @type {integer}
	         * @default null
	         * @since 3.0.0
	         */
	        this.compressionAlgorithm = null;
	
	        /**
	         * The resolution of the source image.
	         *
	         * @name Phaser.Textures.TextureSource#resolution
	         * @type {number}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.resolution = 1;
	
	        /**
	         * The width of the source image. If not specified in the constructor it will check
	         * the `naturalWidth` and then `width` properties of the source image.
	         *
	         * @name Phaser.Textures.TextureSource#width
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.width = width || source.naturalWidth || source.width || 0;
	
	        /**
	         * The height of the source image. If not specified in the constructor it will check
	         * the `naturalHeight` and then `height` properties of the source image.
	         *
	         * @name Phaser.Textures.TextureSource#height
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.height = height || source.naturalHeight || source.height || 0;
	
	        /**
	         * The Scale Mode the image will use when rendering.
	         * Either Linear or Nearest.
	         *
	         * @name Phaser.Textures.TextureSource#scaleMode
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.scaleMode = ScaleModes.DEFAULT;
	
	        /**
	         * Is the source image a Canvas Element?
	         *
	         * @name Phaser.Textures.TextureSource#isCanvas
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.isCanvas = (source instanceof HTMLCanvasElement);
	
	        /**
	         * Are the source image dimensions a power of two?
	         *
	         * @name Phaser.Textures.TextureSource#isPowerOf2
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.isPowerOf2 = IsSizePowerOfTwo(this.width, this.height);
	
	        /**
	         * The WebGL Texture of the source image.
	         *
	         * @name Phaser.Textures.TextureSource#glTexture
	         * @type {?WebGLTexture}
	         * @default null
	         * @since 3.0.0
	         */
	        this.glTexture = null;
	
	        this.init(game);
	    },
	
	    /**
	     * Creates a WebGL Texture, if required, and sets the Texture filter mode.
	     *
	     * @method Phaser.Textures.TextureSource#init
	     * @since 3.0.0
	     *
	     * @param {Phaser.Game} game - A reference to the Phaser Game instance.
	     */
	    init: function (game)
	    {
	        if (this.renderer && this.renderer.gl)
	        {
	            if (this.isCanvas)
	            {
	                this.glTexture = this.renderer.canvasToTexture(this.image);
	            }
	            else
	            {
	                this.glTexture = this.renderer.createTextureFromSource(this.image, this.width, this.height, this.scaleMode);
	            }
	        }
	
	        if (game.config.pixelArt)
	        {
	            this.setFilter(1);
	        }
	    },
	
	    /**
	     * Sets the Filter Mode for this Texture.
	     *
	     * The mode can be either Linear, the default, or Nearest.
	     *
	     * For pixel-art you should use Nearest.
	     *
	     * @method Phaser.Textures.TextureSource#setFilter
	     * @since 3.0.0
	     *
	     * @param {Phaser.Textures.FilterMode} filterMode - The Filter Mode.
	     */
	    setFilter: function (filterMode)
	    {
	        if (this.renderer.gl)
	        {
	            this.renderer.setTextureFilter(this.glTexture, filterMode);
	        }
	    },
	
	    /**
	     * If this TextureSource is backed by a Canvas and is running under WebGL,
	     * it updates the WebGLTexture using the canvas data.
	     *
	     * @method Phaser.Textures.TextureSource#update
	     * @since 3.7.0
	     */
	    update: function ()
	    {
	        if (this.renderer.gl && this.isCanvas)
	        {
	            this.renderer.canvasToTexture(this.image, this.glTexture);
	        }
	    },
	
	    /**
	     * Destroys this Texture Source and nulls the references.
	     *
	     * @method Phaser.Textures.TextureSource#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        if (this.glTexture)
	        {
	            this.renderer.deleteTexture(this.glTexture);
	        }
	
	        if (this.isCanvas)
	        {
	            CanvasPool.remove(this.image);
	        }
	
	        this.renderer = null;
	        this.texture = null;
	        this.image = null;
	    }
	
	});
	
	module.exports = TextureSource;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Textures.Parsers
	 */
	
	module.exports = {
	
	    AtlasXML: __webpack_require__(1523),
	    Canvas: __webpack_require__(1524),
	    Image: __webpack_require__(1525),
	    JSONArray: __webpack_require__(1526),
	    JSONHash: __webpack_require__(1527),
	    SpriteSheet: __webpack_require__(1528),
	    SpriteSheetFromAtlas: __webpack_require__(1529),
	    UnityYAML: __webpack_require__(1530)
	
	};


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * An Image Collection is a special Tile Set containing multiple images, with no slicing into each image.
	 *
	 * Image Collections are normally created automatically when Tiled data is loaded.
	 *
	 * @class ImageCollection
	 * @memberOf Phaser.Tilemaps
	 * @constructor
	 * @since 3.0.0
	 * 
	 * @param {string} name - The name of the image collection in the map data.
	 * @param {integer} firstgid - The first image index this image collection contains.
	 * @param {integer} [width=32] - Width of widest image (in pixels).
	 * @param {integer} [height=32] - Height of tallest image (in pixels).
	 * @param {integer} [margin=0] - The margin around all images in the collection (in pixels).
	 * @param {integer} [spacing=0] - The spacing between each image in the collection (in pixels).
	 * @param {object} [properties={}] - Custom Image Collection properties.
	 */
	var ImageCollection = new Class({
	
	    initialize:
	
	    function ImageCollection (name, firstgid, width, height, margin, spacing, properties)
	    {
	        if (width === undefined || width <= 0) { width = 32; }
	        if (height === undefined || height <= 0) { height = 32; }
	        if (margin === undefined) { margin = 0; }
	        if (spacing === undefined) { spacing = 0; }
	
	        /**
	         * The name of the Image Collection.
	         * 
	         * @name Phaser.Tilemaps.ImageCollection#name
	         * @type {string}
	         * @since 3.0.0
	        */
	        this.name = name;
	
	        /**
	         * The Tiled firstgid value.
	         * This is the starting index of the first image index this Image Collection contains.
	         * 
	         * @name Phaser.Tilemaps.ImageCollection#firstgid
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.firstgid = firstgid | 0;
	
	        /**
	         * The width of the widest image (in pixels).
	         * 
	         * @name Phaser.Tilemaps.ImageCollection#imageWidth
	         * @type {integer}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.imageWidth = width | 0;
	
	        /**
	         * The height of the tallest image (in pixels).
	         * 
	         * @name Phaser.Tilemaps.ImageCollection#imageHeight
	         * @type {integer}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.imageHeight = height | 0;
	
	        /**
	         * The margin around the images in the collection (in pixels).
	         * Use `setSpacing` to change.
	         * 
	         * @name Phaser.Tilemaps.ImageCollection#imageMarge
	         * @type {integer}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.imageMargin = margin | 0;
	
	        /**
	         * The spacing between each image in the collection (in pixels).
	         * Use `setSpacing` to change.
	         * 
	         * @name Phaser.Tilemaps.ImageCollection#imageSpacing
	         * @type {integer}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.imageSpacing = spacing | 0;
	
	        /**
	         * Image Collection-specific properties that are typically defined in the Tiled editor.
	         * 
	         * @name Phaser.Tilemaps.ImageCollection#properties
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.properties = properties || {};
	
	        /**
	         * The cached images that are a part of this collection.
	         * 
	         * @name Phaser.Tilemaps.ImageCollection#images
	         * @type {array}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.images = [];
	
	        /**
	         * The total number of images in the image collection.
	         * 
	         * @name Phaser.Tilemaps.ImageCollection#total
	         * @type {integer}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.total = 0;
	    },
	
	    /**
	     * Returns true if and only if this image collection contains the given image index.
	     *
	     * @method Phaser.Tilemaps.ImageCollection#containsImageIndex
	     * @since 3.0.0
	     * 
	     * @param {integer} imageIndex - The image index to search for.
	     * 
	     * @return {boolean} True if this Image Collection contains the given index.
	     */
	    containsImageIndex: function (imageIndex)
	    {
	        return (imageIndex >= this.firstgid && imageIndex < (this.firstgid + this.total));
	    },
	
	    /**
	     * Add an image to this Image Collection.
	     *
	     * @method Phaser.Tilemaps.ImageCollection#addImage
	     * @since 3.0.0
	     * 
	     * @param {integer} gid - The gid of the image in the Image Collection.
	     * @param {string} image - The the key of the image in the Image Collection and in the cache.
	     *
	     * @return {Phaser.Tilemaps.ImageCollection} This ImageCollection object.
	     */
	    addImage: function (gid, image)
	    {
	        this.images.push({ gid: gid, image: image });
	        this.total++;
	
	        return this;
	    }
	
	});
	
	module.exports = ImageCollection;


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var DegToRad = __webpack_require__(97);
	var DynamicTilemapLayer = __webpack_require__(642);
	var Extend = __webpack_require__(36);
	var Formats = __webpack_require__(57);
	var LayerData = __webpack_require__(170);
	var Rotate = __webpack_require__(556);
	var StaticTilemapLayer = __webpack_require__(650);
	var Tile = __webpack_require__(120);
	var TilemapComponents = __webpack_require__(215);
	var Tileset = __webpack_require__(211);
	
	/**
	 * @callback TilemapFilterCallback
	 *
	 * @param {Phaser.GameObjects.GameObject} value - [description]
	 * @param {number} index - [description]
	 * @param {Phaser.GameObjects.GameObject[]} array - [description]
	 *
	 * @return {Phaser.GameObjects.GameObject} [description]
	 */
	
	/**
	 * @callback TilemapFindCallback
	 *
	 * @param {Phaser.GameObjects.GameObject} value - [description]
	 * @param {number} index - [description]
	 * @param {Phaser.GameObjects.GameObject[]} array - [description]
	 *
	 * @return {boolean} [description]
	 */
	
	/**
	 * @classdesc
	 * A Tilemap is a container for Tilemap data. This isn't a display object, rather, it holds data
	 * about the map and allows you to add tilesets and tilemap layers to it. A map can have one or
	 * more tilemap layers (StaticTilemapLayer or DynamicTilemapLayer), which are the display
	 * objects that actually render tiles.
	 *
	 * The Tilemap data be parsed from a Tiled JSON file, a CSV file or a 2D array. Tiled is a free
	 * software package specifically for creating tile maps, and is available from:
	 * http://www.mapeditor.org
	 *
	 * A Tilemap has handy methods for getting & manipulating the tiles within a layer. You can only
	 * use the methods that change tiles (e.g. removeTileAt) on a DynamicTilemapLayer.
	 *
	 * Note that all Tilemaps use a base tile size to calculate dimensions from, but that a
	 * StaticTilemapLayer or DynamicTilemapLayer may have its own unique tile size that overrides
	 * it.
	 *
	 * @class Tilemap
	 * @memberOf Phaser.Tilemaps
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - The Scene to which this Tilemap belongs.
	 * @param {Phaser.Tilemaps.MapData} mapData - A MapData instance containing Tilemap data.
	 */
	var Tilemap = new Class({
	
	    initialize:
	
	    function Tilemap (scene, mapData)
	    {
	        /**
	         * @name Phaser.Tilemaps.Tilemap#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * The base width of a tile in pixels. Note that individual layers may have a different tile
	         * width.
	         *
	         * @name Phaser.Tilemaps.Tilemap#tileWidth
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.tileWidth = mapData.tileWidth;
	
	        /**
	         * The base height of a tile in pixels. Note that individual layers may have a different
	         * tile height.
	         *
	         * @name Phaser.Tilemaps.Tilemap#tileHeight
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.tileHeight = mapData.tileHeight;
	
	        /**
	         * The width of the map (in tiles).
	         *
	         * @name Phaser.Tilemaps.Tilemap#width
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.width = mapData.width;
	
	        /**
	         * The height of the map (in tiles).
	         *
	         * @name Phaser.Tilemaps.Tilemap#height
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.height = mapData.height;
	
	        /**
	         * The orientation of the map data (as specified in Tiled), usually 'orthogonal'.
	         *
	         * @name Phaser.Tilemaps.Tilemap#orientation
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.orientation = mapData.orientation;
	
	        /**
	         * The format of the map data.
	         *
	         * @name Phaser.Tilemaps.Tilemap#format
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.format = mapData.format;
	
	        /**
	         * The version of the map data (as specified in Tiled, usually 1).
	         *
	         * @name Phaser.Tilemaps.Tilemap#version
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.version = mapData.version;
	
	        /**
	         * Map specific properties as specified in Tiled.
	         *
	         * @name Phaser.Tilemaps.Tilemap#properties
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.properties = mapData.properties;
	
	        /**
	         * The width of the map in pixels based on width * tileWidth.
	         *
	         * @name Phaser.Tilemaps.Tilemap#widthInPixels
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.widthInPixels = mapData.widthInPixels;
	
	        /**
	         * The height of the map in pixels based on height * tileHeight.
	         *
	         * @name Phaser.Tilemaps.Tilemap#heightInPixels
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.heightInPixels = mapData.heightInPixels;
	
	        /**
	         *
	         * @name Phaser.Tilemaps.Tilemap#imageCollections
	         * @type {Phaser.Tilemaps.ImageCollection[]}
	         * @since 3.0.0
	         */
	        this.imageCollections = mapData.imageCollections;
	
	        /**
	         * An array of Tiled Image Layers.
	         *
	         * @name Phaser.Tilemaps.Tilemap#images
	         * @type {array}
	         * @since 3.0.0
	         */
	        this.images = mapData.images;
	
	        /**
	         * An array of Tilemap layer data.
	         *
	         * @name Phaser.Tilemaps.Tilemap#layers
	         * @type {Phaser.Tilemaps.LayerData[]}
	         * @since 3.0.0
	         */
	        this.layers = mapData.layers;
	
	        /**
	         * An array of Tilesets used in the map.
	         *
	         * @name Phaser.Tilemaps.Tilemap#tilesets
	         * @type {Phaser.Tilemaps.Tileset[]}
	         * @since 3.0.0
	         */
	        this.tilesets = mapData.tilesets;
	
	        /**
	         * An array of ObjectLayer instances parsed from Tiled object layers.
	         *
	         * @name Phaser.Tilemaps.Tilemap#objects
	         * @type {Phaser.Tilemaps.ObjectLayer[]}
	         * @since 3.0.0
	         */
	        this.objects = mapData.objects;
	
	        /**
	         * The index of the currently selected LayerData object.
	         *
	         * @name Phaser.Tilemaps.Tilemap#currentLayerIndex
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.currentLayerIndex = 0;
	    },
	
	    /**
	     * Adds an image to the map to be used as a tileset. A single map may use multiple tilesets.
	     * Note that the tileset name can be found in the JSON file exported from Tiled, or in the Tiled
	     * editor.
	     *
	     * @method Phaser.Tilemaps.Tilemap#addTilesetImage
	     * @since 3.0.0
	     *
	     * @param {string} tilesetName - The name of the tileset as specified in the map data.
	     * @param {string} [key] - The key of the Phaser.Cache image used for this tileset. If
	     * `undefined` or `null` it will look for an image with a key matching the tilesetName parameter.
	     * @param {integer} [tileWidth] - The width of the tile (in pixels) in the Tileset Image. If not
	     * given it will default to the map's tileWidth value, or the tileWidth specified in the Tiled
	     * JSON file.
	     * @param {integer} [tileHeight] - The height of the tiles (in pixels) in the Tileset Image. If
	     * not given it will default to the map's tileHeight value, or the tileHeight specified in the
	     * Tiled JSON file.
	     * @param {integer} [tileMargin] - The margin around the tiles in the sheet (in pixels). If not
	     * specified, it will default to 0 or the value specified in the Tiled JSON file.
	     * @param {integer} [tileSpacing] - The spacing between each the tile in the sheet (in pixels).
	     * If not specified, it will default to 0 or the value specified in the Tiled JSON file.
	     * @param {integer} [gid=0] - If adding multiple tilesets to a blank map, specify the starting
	     * GID this set will use here.
	     *
	     * @return {?Phaser.Tilemaps.Tileset} Returns the Tileset object that was created or updated, or null if it
	     * failed.
	     */
	    addTilesetImage: function (tilesetName, key, tileWidth, tileHeight, tileMargin, tileSpacing, gid)
	    {
	        if (tilesetName === undefined) { return null; }
	        if (key === undefined || key === null) { key = tilesetName; }
	
	        if (!this.scene.sys.textures.exists(key))
	        {
	            console.warn('Invalid image key given for tileset: "' + key + '"');
	            return null;
	        }
	
	        var texture = this.scene.sys.textures.get(key);
	
	        var index = this.getTilesetIndex(tilesetName);
	
	        if (index === null && this.format === Formats.TILED_JSON)
	        {
	            console.warn('No data found in the JSON tilemap from Tiled matching the tileset name: "' + tilesetName + '"');
	            return null;
	        }
	
	        if (this.tilesets[index])
	        {
	            this.tilesets[index].setTileSize(tileWidth, tileHeight);
	            this.tilesets[index].setSpacing(tileMargin, tileSpacing);
	            this.tilesets[index].setImage(texture);
	            return this.tilesets[index];
	        }
	
	        if (tileWidth === undefined) { tileWidth = this.tileWidth; }
	        if (tileHeight === undefined) { tileHeight = this.tileHeight; }
	        if (tileMargin === undefined) { tileMargin = 0; }
	        if (tileSpacing === undefined) { tileSpacing = 0; }
	        if (gid === undefined) { gid = 0; }
	
	        var tileset = new Tileset(tilesetName, gid, tileWidth, tileHeight, tileMargin, tileSpacing);
	        tileset.setImage(texture);
	        this.tilesets.push(tileset);
	
	        return tileset;
	    },
	
	    /**
	     * Turns the StaticTilemapLayer associated with the given layer into a DynamicTilemapLayer. If
	     * no layer specified, the map's current layer is used. This is useful if you want to manipulate
	     * a map at the start of a scene, but then make it non-manipulable and optimize it for speed.
	     * Note: the DynamicTilemapLayer passed in is destroyed, so make sure to store the value
	     * returned from this method if you want to manipulate the new StaticTilemapLayer.
	     *
	     * @method Phaser.Tilemaps.Tilemap#convertLayerToStatic
	     * @since 3.0.0
	     *
	     * @param {(string|integer|Phaser.Tilemaps.DynamicTilemapLayer)} [layer] - The name of the layer from Tiled, the
	     * index of the layer in the map, or a DynamicTilemapLayer.
	     *
	     * @return {?Phaser.Tilemaps.StaticTilemapLayer} Returns the new layer that was created, or null if it
	     * failed.
	     */
	    convertLayerToStatic: function (layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return null; }
	
	        var dynamicLayer = layer.tilemapLayer;
	
	        if (!dynamicLayer || !(dynamicLayer instanceof DynamicTilemapLayer))
	        {
	            return null;
	        }
	
	        var staticLayer = new StaticTilemapLayer(
	            dynamicLayer.scene,
	            dynamicLayer.tilemap,
	            dynamicLayer.layerIndex,
	            dynamicLayer.tileset,
	            dynamicLayer.x,
	            dynamicLayer.y
	        );
	
	        this.scene.sys.displayList.add(staticLayer);
	
	        dynamicLayer.destroy();
	
	        return staticLayer;
	    },
	
	    /**
	     * See component documentation. If no layer specified, the map's current layer is used. This
	     * cannot be applied to StaticTilemapLayers.
	     *
	     * @method Phaser.Tilemaps.Tilemap#copy
	     * @since 3.0.0
	     *
	     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
	     */
	    copy: function (srcTileX, srcTileY, width, height, destTileX, destTileY, recalculateFaces, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (this._isStaticCall(layer, 'copy')) { return this; }
	
	        if (layer !== null)
	        {
	            TilemapComponents.Copy(
	                srcTileX, srcTileY,
	                width, height,
	                destTileX, destTileY,
	                recalculateFaces, layer
	            );
	        }
	
	        return this;
	    },
	
	    /**
	     * Creates a new and empty DynamicTilemapLayer. The currently selected layer in the map is set
	     * to this new layer.
	     *
	     * @method Phaser.Tilemaps.Tilemap#createBlankDynamicLayer
	     * @since 3.0.0
	     *
	     * @param {string} name - The name of this layer. Must be unique within the map.
	     * @param {Phaser.Tilemaps.Tileset} tileset - The tileset the new layer will use.
	     * @param {integer} width - The width of the layer in tiles. If not specified, it will default
	     * to the map's width.
	     * @param {integer} height - The height of the layer in tiles. If not specified, it will default
	     * to the map's height.
	     * @param {integer} tileWidth - The width of the tiles the layer uses for calculations. If not
	     * specified, it will default to the map's tileWidth.
	     * @param {integer} tileHeight - The height of the tiles the layer uses for calculations. If not
	     * specified, it will default to the map's tileHeight.
	     * @return {?Phaser.Tilemaps.DynamicTilemapLayer} Returns the new layer was created, or null if it failed.
	     */
	    createBlankDynamicLayer: function (name, tileset, x, y, width, height, tileWidth, tileHeight)
	    {
	        if (tileWidth === undefined) { tileWidth = tileset.tileWidth; }
	        if (tileHeight === undefined) { tileHeight = tileset.tileHeight; }
	        if (width === undefined) { width = this.width; }
	        if (height === undefined) { height = this.height; }
	        if (x === undefined) { x = 0; }
	        if (y === undefined) { y = 0; }
	
	        var index = this.getLayerIndex(name);
	
	        if (index !== null)
	        {
	            console.warn('Cannot create blank layer: layer with matching name already exists ' + name);
	            return null;
	        }
	
	        var layerData = new LayerData({
	            name: name,
	            tileWidth: tileWidth,
	            tileHeight: tileHeight,
	            width: width,
	            height: height
	        });
	
	        var row;
	
	        for (var tileY = 0; tileY < height; tileY++)
	        {
	            row = [];
	
	            for (var tileX = 0; tileX < width; tileX++)
	            {
	                row.push(new Tile(layerData, -1, tileX, tileY, tileWidth, tileHeight, this.tileWidth, this.tileHeight));
	            }
	
	            layerData.data.push(row);
	        }
	
	        this.layers.push(layerData);
	        this.currentLayerIndex = this.layers.length - 1;
	
	        var dynamicLayer = new DynamicTilemapLayer(this.scene, this, this.currentLayerIndex, tileset, x, y);
	        this.scene.sys.displayList.add(dynamicLayer);
	
	        return dynamicLayer;
	    },
	
	    /**
	     * Creates a new DynamicTilemapLayer that renders the LayerData associated with the given
	     * `layerID`. The currently selected layer in the map is set to this new layer.
	     *
	     * The `layerID` is important. If you've created your map in Tiled then you can get this by
	     * looking in Tiled and looking at the layer name. Or you can open the JSON file it exports and
	     * look at the layers[].name value. Either way it must match.
	     *
	     * Unlike a static layer, a dynamic layer can be modified. See DynamicTilemapLayer for more
	     * information.
	     *
	     * @method Phaser.Tilemaps.Tilemap#createDynamicLayer
	     * @since 3.0.0
	     *
	     * @param {(integer|string)} layerID - The layer array index value, or if a string is given, the
	     * layer name from Tiled.
	     * @param {Phaser.Tilemaps.Tileset} tileset - The tileset the new layer will use.
	     * @param {number} x - The x position to place the layer in the world. If not specified, it will
	     * default to the layer offset from Tiled or 0.
	     * @param {number} y - The y position to place the layer in the world. If not specified, it will
	     * default to the layer offset from Tiled or 0.
	     *
	     * @return {?Phaser.Tilemaps.DynamicTilemapLayer} Returns the new layer was created, or null if it failed.
	     */
	    createDynamicLayer: function (layerID, tileset, x, y)
	    {
	        var index = this.getLayerIndex(layerID);
	
	        if (index === null)
	        {
	            console.warn('Cannot create tilemap layer, invalid layer ID given: ' + layerID);
	            return null;
	        }
	
	        var layerData = this.layers[index];
	
	        // Check for an associated static or dynamic tilemap layer
	        if (layerData.tilemapLayer)
	        {
	            console.warn('Cannot create dynamic tilemap layer since a static or dynamic tilemap layer exists for layer ID:' + layerID);
	            return null;
	        }
	
	        this.currentLayerIndex = index;
	
	        // Make sure that all the LayerData & the tiles have the correct tile size. They usually
	        // are, but wouldn't match if you try to load a 2x or 4x res tileset when the map was made
	        // with a 1x res tileset.
	        if (layerData.tileWidth !== tileset.tileWidth || layerData.tileHeight !== tileset.tileHeight)
	        {
	            this.setLayerTileSize(tileset.tileWidth, tileset.tileHeight, index);
	        }
	
	        // Default the x/y position to match Tiled layer offset, if it exists.
	        if (x === undefined && this.layers[index].x) { x = this.layers[index].x; }
	        if (y === undefined && this.layers[index].y) { y = this.layers[index].y; }
	
	        var layer = new DynamicTilemapLayer(this.scene, this, index, tileset, x, y);
	        this.scene.sys.displayList.add(layer);
	
	        return layer;
	    },
	
	    /**
	     * Creates a Sprite for every object matching the given gid in the map data. All properties from
	     * the map data objectgroup are copied into the `spriteConfig`, so you can use this as an easy
	     * way to configure Sprite properties from within the map editor. For example giving an object a
	     * property of alpha: 0.5 in the map editor will duplicate that when the Sprite is created.
	     *
	     * @method Phaser.Tilemaps.Tilemap#createFromObjects
	     * @since 3.0.0
	     *
	     * @param {string} name - The name of the object layer (from Tiled) to create Sprites from.
	     * @param {(integer|string)} id - Either the id (object), gid (tile object) or name (object or
	     * tile object) from Tiled. Ids are unique in Tiled, but a gid is shared by all tile objects
	     * with the same graphic. The same name can be used on multiple objects.
	     * @param {object} spriteConfig - The config object to pass into the Sprite creator (i.e.
	     * scene.make.sprite).
	     * @param {Phaser.Scene} [scene=the scene the map is within] - The Scene to create the Sprites within.
	     *
	     * @return {Phaser.GameObjects.Sprite[]} An array of the Sprites that were created.
	     */
	    createFromObjects: function (name, id, spriteConfig, scene)
	    {
	        if (spriteConfig === undefined) { spriteConfig = {}; }
	        if (scene === undefined) { scene = this.scene; }
	
	        var objectLayer = this.getObjectLayer(name);
	        if (!objectLayer)
	        {
	            console.warn('Cannot create from object. Invalid objectgroup name given: ' + name);
	            return;
	        }
	
	        var objects = objectLayer.objects;
	        var sprites = [];
	
	        for (var i = 0; i < objects.length; i++)
	        {
	            var found = false;
	            var obj = objects[i];
	
	            if (obj.gid !== undefined && typeof id === 'number' && obj.gid === id ||
	                obj.id !== undefined && typeof id === 'number' && obj.id === id ||
	                obj.name !== undefined && typeof id === 'string' && obj.name === id)
	            {
	                found = true;
	            }
	
	            if (found)
	            {
	                var config = Extend({}, spriteConfig, obj.properties);
	
	                config.x = obj.x;
	                config.y = obj.y;
	
	                var sprite = this.scene.make.sprite(config);
	
	                sprite.name = obj.name;
	
	                if (obj.width) { sprite.displayWidth = obj.width; }
	                if (obj.height) { sprite.displayHeight = obj.height; }
	
	                // Origin is (0, 1) in Tiled, so find the offset that matches the Sprite's origin.
	                var offset = {
	                    x: sprite.originX * sprite.displayWidth,
	                    y: (sprite.originY - 1) * sprite.displayHeight
	                };
	
	                // If the object is rotated, then the origin offset also needs to be rotated.
	                if (obj.rotation)
	                {
	                    var angle = DegToRad(obj.rotation);
	                    Rotate(offset, angle);
	                    sprite.rotation = angle;
	                }
	
	                sprite.x += offset.x;
	                sprite.y += offset.y;
	
	                if (obj.flippedHorizontal !== undefined || obj.flippedVertical !== undefined)
	                {
	                    sprite.setFlip(obj.flippedHorizontal, obj.flippedVertical);
	                }
	
	                if (!obj.visible) { sprite.visible = false; }
	
	                sprites.push(sprite);
	            }
	        }
	
	        return sprites;
	    },
	
	    /**
	     * Creates a Sprite for every object matching the given tile indexes in the layer. You can
	     * optionally specify if each tile will be replaced with a new tile after the Sprite has been
	     * created. This is useful if you want to lay down special tiles in a level that are converted to
	     * Sprites, but want to replace the tile itself with a floor tile or similar once converted.
	     *
	     * @method Phaser.Tilemaps.Tilemap#createFromTiles
	     * @since 3.0.0
	     *
	     * @param {(integer|array)} indexes - The tile index, or array of indexes, to create Sprites from.
	     * @param {(integer|array)} replacements - The tile index, or array of indexes, to change a converted
	     * tile to. Set to `null` to leave the tiles unchanged. If an array is given, it is assumed to be a
	     * one-to-one mapping with the indexes array.
	     * @param {object} spriteConfig - The config object to pass into the Sprite creator (i.e.
	     * scene.make.sprite).
	     * @param {Phaser.Scene} [scene=scene the map is within] - The Scene to create the Sprites within.
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - The Camera to use when determining the world XY
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.GameObjects.Sprite[]} Returns an array of Tiles, or null if the layer given was invalid.
	     */
	    createFromTiles: function (indexes, replacements, spriteConfig, scene, camera, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return null; }
	
	        return TilemapComponents.CreateFromTiles(indexes, replacements, spriteConfig, scene, camera, layer);
	    },
	
	    /**
	     * Creates a new StaticTilemapLayer that renders the LayerData associated with the given
	     * `layerID`. The currently selected layer in the map is set to this new layer.
	     *
	     * The `layerID` is important. If you've created your map in Tiled then you can get this by
	     * looking in Tiled and looking at the layer name. Or you can open the JSON file it exports and
	     * look at the layers[].name value. Either way it must match.
	     *
	     * It's important to remember that a static layer cannot be modified. See StaticTilemapLayer for
	     * more information.
	     *
	     * @method Phaser.Tilemaps.Tilemap#createStaticLayer
	     * @since 3.0.0
	     *
	     * @param {(integer|string)} layerID - The layer array index value, or if a string is given, the
	     * layer name from Tiled.
	     * @param {Phaser.Tilemaps.Tileset} tileset - The tileset the new layer will use.
	     * @param {number} x - The x position to place the layer in the world. If not specified, it will
	     * default to the layer offset from Tiled or 0.
	     * @param {number} y - The y position to place the layer in the world. If not specified, it will
	     * default to the layer offset from Tiled or 0.
	     *
	     * @return {?Phaser.Tilemaps.StaticTilemapLayer} Returns the new layer was created, or null if it failed.
	     */
	    createStaticLayer: function (layerID, tileset, x, y)
	    {
	        var index = this.getLayerIndex(layerID);
	
	        if (index === null)
	        {
	            console.warn('Cannot create tilemap layer, invalid layer ID given: ' + layerID);
	            return null;
	        }
	
	        var layerData = this.layers[index];
	
	        // Check for an associated static or dynamic tilemap layer
	        if (layerData.tilemapLayer)
	        {
	            console.warn('Cannot create static tilemap layer since a static or dynamic tilemap layer exists for layer ID:' + layerID);
	            return null;
	        }
	
	        this.currentLayerIndex = index;
	
	        // Make sure that all the LayerData & the tiles have the correct tile size. They usually
	        // are, but wouldn't match if you try to load a 2x or 4x res tileset when the map was made
	        // with a 1x res tileset.
	        if (layerData.tileWidth !== tileset.tileWidth || layerData.tileHeight !== tileset.tileHeight)
	        {
	            this.setLayerTileSize(tileset.tileWidth, tileset.tileHeight, index);
	        }
	
	        // Default the x/y position to match Tiled layer offset, if it exists.
	        if (x === undefined && this.layers[index].x) { x = this.layers[index].x; }
	        if (y === undefined && this.layers[index].y) { y = this.layers[index].y; }
	
	        var layer = new StaticTilemapLayer(this.scene, this, index, tileset, x, y);
	        this.scene.sys.displayList.add(layer);
	
	        return layer;
	    },
	
	    /**
	     * Removes all layer data from this Tilemap and nulls the scene reference. This will destroy any
	     * StaticTilemapLayers or DynamicTilemapLayers that have been linked to LayerData.
	     *
	     * @method Phaser.Tilemaps.Tilemap#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.removeAllLayers();
	        this.tilesets.length = 0;
	        this.objects.length = 0;
	        this.scene = undefined;
	    },
	
	    /**
	     * Sets the tiles in the given rectangular area (in tile coordinates) of the layer with the
	     * specified index. Tiles will be set to collide if the given index is a colliding index.
	     * Collision information in the region will be recalculated.
	     *
	     * If no layer specified, the map's current layer is used.
	     * This cannot be applied to StaticTilemapLayers.
	     *
	     * @method Phaser.Tilemaps.Tilemap#fill
	     * @since 3.0.0
	     *
	     * @param {integer} index - [description]
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     * @param {boolean} [recalculateFaces=true] - [description]
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
	     */
	    fill: function (index, tileX, tileY, width, height, recalculateFaces, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (this._isStaticCall(layer, 'fill')) { return this; }
	
	        if (layer !== null)
	        {
	            TilemapComponents.Fill(index, tileX, tileY, width, height, recalculateFaces, layer);
	        }
	
	        return this;
	    },
	
	    /**
	     * For each object in the given object layer, run the given filter callback function. Any
	     * objects that pass the filter test (i.e. where the callback returns true) will returned as a
	     * new array. Similar to Array.prototype.Filter in vanilla JS.
	     *
	     * @method Phaser.Tilemaps.Tilemap#filterObjects
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Tilemaps.ObjectLayer|string)} objectLayer - The name of an object layer (from Tiled) or an ObjectLayer instance.
	     * @param {TilemapFilterCallback} callback - The callback. Each object in the given area will be passed to this callback as the first and only parameter.
	     * @param {object} [context] - The context under which the callback should be run.
	     *
	     * @return {?Phaser.GameObjects.GameObject[]} An array of object that match the search, or null if the objectLayer given was invalid.
	     */
	    filterObjects: function (objectLayer, callback, context)
	    {
	        if (typeof objectLayer === 'string')
	        {
	            var name = objectLayer;
	
	            objectLayer = this.getObjectLayer(objectLayer);
	
	            if (!objectLayer)
	            {
	                console.warn('No object layer found with the name: ' + name);
	                return null;
	            }
	        }
	
	        return objectLayer.objects.filter(callback, context);
	    },
	
	    /**
	     * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
	     * filter callback function. Any tiles that pass the filter test (i.e. where the callback returns
	     * true) will returned as a new array. Similar to Array.prototype.Filter in vanilla JS.
	     * If no layer specified, the map's current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#filterTiles
	     * @since 3.0.0
	     *
	     * @param {function} callback - The callback. Each tile in the given area will be passed to this
	     * callback as the first and only parameter. The callback should return true for tiles that pass the
	     * filter.
	     * @param {object} [context] - The context under which the callback should be run.
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	     * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	     * -1 for an index.
	     * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide
	     * on at least one side.
	     * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	     * have at least one interesting face.
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tile[]} Returns an array of Tiles, or null if the layer given was invalid.
	     */
	    filterTiles: function (callback, context, tileX, tileY, width, height, filteringOptions, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return null; }
	
	        return TilemapComponents.FilterTiles(callback, context, tileX, tileY, width, height, filteringOptions, layer);
	    },
	
	    /**
	     * Searches the entire map layer for the first tile matching the given index, then returns that Tile
	     * object. If no match is found, it returns null. The search starts from the top-left tile and
	     * continues horizontally until it hits the end of the row, then it drops down to the next column.
	     * If the reverse boolean is true, it scans starting from the bottom-right corner traveling up to
	     * the top-left.
	     * If no layer specified, the map's current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#findByIndex
	     * @since 3.0.0
	     *
	     * @param {integer} index - The tile index value to search for.
	     * @param {integer} [skip=0] - The number of times to skip a matching tile before returning.
	     * @param {boolean} [reverse=false] - If true it will scan the layer in reverse, starting at the
	     * bottom-right. Otherwise it scans from the top-left.
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tile} Returns a Tiles, or null if the layer given was invalid.
	     */
	    findByIndex: function (findIndex, skip, reverse, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return null; }
	
	        return TilemapComponents.FindByIndex(findIndex, skip, reverse, layer);
	    },
	
	    /**
	     * Find the first object in the given object layer that satisfies the provided testing function.
	     * I.e. finds the first object for which `callback` returns true. Similar to
	     * Array.prototype.find in vanilla JS.
	     *
	     * @method Phaser.Tilemaps.Tilemap#findObject
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Tilemaps.ObjectLayer|string)} objectLayer - The name of an object layer (from Tiled) or an ObjectLayer instance.
	     * @param {TilemapFindCallback} callback - The callback. Each object in the given area will be passed to this callback as the first and only parameter.
	     * @param {object} [context] - The context under which the callback should be run.
	     *
	     * @return {?Phaser.GameObjects.GameObject} An object that matches the search, or null if no object found.
	     */
	    findObject: function (objectLayer, callback, context)
	    {
	        if (typeof objectLayer === 'string')
	        {
	            var name = objectLayer;
	
	            objectLayer = this.getObjectLayer(objectLayer);
	
	            if (!objectLayer)
	            {
	                console.warn('No object layer found with the name: ' + name);
	                return null;
	            }
	        }
	
	        return objectLayer.objects.find(callback, context) || null;
	    },
	
	    /**
	     * Find the first tile in the given rectangular area (in tile coordinates) of the layer that
	     * satisfies the provided testing function. I.e. finds the first tile for which `callback` returns
	     * true. Similar to Array.prototype.find in vanilla JS.
	     * If no layer specified, the maps current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#findTile
	     * @since 3.0.0
	     *
	     * @param {FindTileCallback} callback - The callback. Each tile in the given area will be passed to this
	     * callback as the first and only parameter.
	     * @param {object} [context] - The context under which the callback should be run.
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	     * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	     * -1 for an index.
	     * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide
	     * on at least one side.
	     * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	     * have at least one interesting face.
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tile} Returns a Tiles, or null if the layer given was invalid.
	     */
	    findTile: function (callback, context, tileX, tileY, width, height, filteringOptions, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return null; }
	
	        return TilemapComponents.FindTile(callback, context, tileX, tileY, width, height, filteringOptions, layer);
	    },
	
	    /**
	     * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
	     * callback. Similar to Array.prototype.forEach in vanilla JS.
	     *
	     * If no layer specified, the map's current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#forEachTile
	     * @since 3.0.0
	     *
	     * @param {EachTileCallback} callback - The callback. Each tile in the given area will be passed to this
	     * callback as the first and only parameter.
	     * @param {object} [context] - The context under which the callback should be run.
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	     * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	     * -1 for an index.
	     * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide
	     * on at least one side.
	     * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	     * have at least one interesting face.
	     * @param {LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
	     */
	    forEachTile: function (callback, context, tileX, tileY, width, height, filteringOptions, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer !== null)
	        {
	            TilemapComponents.ForEachTile(callback, context, tileX, tileY, width, height, filteringOptions, layer);
	        }
	
	        return this;
	    },
	
	    /**
	     * Gets the image layer index based on its name.
	     *
	     * @method Phaser.Tilemaps.Tilemap#getImageIndex
	     * @since 3.0.0
	     *
	     * @param {string} name - The name of the image to get.
	     *
	     * @return {integer} The index of the image in this tilemap, or null if not found.
	     */
	    getImageIndex: function (name)
	    {
	        return this.getIndex(this.images, name);
	    },
	
	    /**
	     * Internally used. Returns the index of the object in one of the Tilemaps arrays whose name
	     * property matches the given `name`.
	     *
	     * @method Phaser.Tilemaps.Tilemap#getIndex
	     * @since 3.0.0
	     *
	     * @param {array} location - The Tilemap array to search.
	     * @param {string} name - The name of the array element to get.
	     *
	     * @return {number} The index of the element in the array, or null if not found.
	     */
	    getIndex: function (location, name)
	    {
	        for (var i = 0; i < location.length; i++)
	        {
	            if (location[i].name === name)
	            {
	                return i;
	            }
	        }
	
	        return null;
	    },
	
	    /**
	     * Gets the LayerData from this.layers that is associated with `layer`, or null if an invalid
	     * `layer` is given.
	     *
	     * @method Phaser.Tilemaps.Tilemap#getLayer
	     * @since 3.0.0
	     *
	     * @param {(string|integer|Phaser.Tilemaps.DynamicTilemapLayer|Phaser.Tilemaps.StaticTilemapLayer)} [layer] - The name of the
	     * layer from Tiled, the index of the layer in the map, a DynamicTilemapLayer or a
	     * StaticTilemapLayer. If not given will default to the maps current layer index.
	     *
	     * @return {Phaser.Tilemaps.LayerData} The corresponding LayerData within this.layers.
	     */
	    getLayer: function (layer)
	    {
	        var index = this.getLayerIndex(layer);
	
	        return index !== null ? this.layers[index] : null;
	    },
	
	    /**
	     * Gets the ObjectLayer from this.objects that has the given `name`, or null if no ObjectLayer
	     * is found with that name.
	     *
	     * @method Phaser.Tilemaps.Tilemap#getObjectLayer
	     * @since 3.0.0
	     *
	     * @param {string} [name] - The name of the object layer from Tiled.
	     *
	     * @return {?Phaser.Tilemaps.ObjectLayer} The corresponding ObjectLayer within this.objects or null.
	     */
	    getObjectLayer: function (name)
	    {
	        var index = this.getIndex(this.objects, name);
	
	        return index !== null ? this.objects[index] : null;
	    },
	
	    /**
	     * Gets the LayerData index of the given `layer` within this.layers, or null if an invalid
	     * `layer` is given.
	     *
	     * @method Phaser.Tilemaps.Tilemap#getLayerIndex
	     * @since 3.0.0
	     *
	     * @param {(string|integer|Phaser.Tilemaps.DynamicTilemapLayer|Phaser.Tilemaps.StaticTilemapLayer)} [layer] - The name of the
	     * layer from Tiled, the index of the layer in the map, a DynamicTilemapLayer or a
	     * StaticTilemapLayer. If not given will default to the map's current layer index.
	     *
	     * @return {integer} The LayerData index within this.layers.
	     */
	    getLayerIndex: function (layer)
	    {
	        if (layer === undefined)
	        {
	            return this.currentLayerIndex;
	        }
	        else if (typeof layer === 'string')
	        {
	            return this.getLayerIndexByName(layer);
	        }
	        else if (typeof layer === 'number' && layer < this.layers.length)
	        {
	            return layer;
	        }
	        else if (layer instanceof StaticTilemapLayer || layer instanceof DynamicTilemapLayer)
	        {
	            return layer.layerIndex;
	        }
	        else
	        {
	            return null;
	        }
	    },
	
	    /**
	     * Gets the index of the LayerData within this.layers that has the given `name`, or null if an
	     * invalid `name` is given.
	     *
	     * @method Phaser.Tilemaps.Tilemap#getLayerIndexByName
	     * @since 3.0.0
	     *
	     * @param {string} name - The name of the layer to get.
	     *
	     * @return {integer} The LayerData index within this.layers.
	     */
	    getLayerIndexByName: function (name)
	    {
	        return this.getIndex(this.layers, name);
	    },
	
	    /**
	     * Gets a tile at the given tile coordinates from the given layer.
	     * If no layer specified, the map's current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#getTileAt
	     * @since 3.0.0
	     *
	     * @param {integer} tileX - X position to get the tile from (given in tile units, not pixels).
	     * @param {integer} tileY - Y position to get the tile from (given in tile units, not pixels).
	     * @param {boolean} [nonNull=false] - If true getTile won't return null for empty tiles, but a Tile
	     * object with an index of -1.
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tile} Returns a Tile, or null if the layer given was invalid.
	     */
	    getTileAt: function (tileX, tileY, nonNull, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return null; }
	
	        return TilemapComponents.GetTileAt(tileX, tileY, nonNull, layer);
	    },
	
	    /**
	     * Gets a tile at the given world coordinates from the given layer.
	     * If no layer specified, the map's current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#getTileAtWorldXY
	     * @since 3.0.0
	     *
	     * @param {number} worldX - X position to get the tile from (given in pixels)
	     * @param {number} worldY - Y position to get the tile from (given in pixels)
	     * @param {boolean} [nonNull=false] - If true, function won't return null for empty tiles, but a Tile
	     * object with an index of -1.
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tile} Returns a Tile, or null if the layer given was invalid.
	     */
	    getTileAtWorldXY: function (worldX, worldY, nonNull, camera, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null)
	        {
	            return null;
	        }
	        else
	        {
	            return TilemapComponents.GetTileAtWorldXY(worldX, worldY, nonNull, camera, layer);
	        }
	    },
	
	    /**
	     * Gets the tiles in the given rectangular area (in tile coordinates) of the layer.
	     * If no layer specified, the maps current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#getTilesWithin
	     * @since 3.0.0
	     *
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	     * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	     * -1 for an index.
	     * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide on
	     * at least one side.
	     * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	     * have at least one interesting face.
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tile[]} Returns an array of Tiles, or null if the layer given was invalid.
	     */
	    getTilesWithin: function (tileX, tileY, width, height, filteringOptions, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return null; }
	
	        return TilemapComponents.GetTilesWithin(tileX, tileY, width, height, filteringOptions, layer);
	    },
	
	    /**
	     * Gets the tiles that overlap with the given shape in the given layer. The shape must be a Circle,
	     * Line, Rectangle or Triangle. The shape should be in world coordinates.
	     * If no layer specified, the maps current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#getTilesWithinShape
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Geom.Circle|Phaser.Geom.Line|Phaser.Geom.Rectangle|Phaser.Geom.Triangle)} shape - A shape in world (pixel) coordinates
	     * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	     * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	     * -1 for an index.
	     * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide on
	     * at least one side.
	     * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	     * have at least one interesting face.
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tile[]} Returns an array of Tiles, or null if the layer given was invalid.
	     */
	    getTilesWithinShape: function (shape, filteringOptions, camera, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return null; }
	
	        return TilemapComponents.GetTilesWithinShape(shape, filteringOptions, camera, layer);
	    },
	
	    /**
	     * Gets the tiles in the given rectangular area (in world coordinates) of the layer.
	     * If no layer specified, the maps current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#getTilesWithinWorldXY
	     * @since 3.0.0
	     *
	     * @param {number} worldX - [description]
	     * @param {number} worldY - [description]
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	     * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	     * -1 for an index.
	     * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide on
	     * at least one side.
	     * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	     * have at least one interesting face.
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tile[]} Returns an array of Tiles, or null if the layer given was invalid.
	     */
	    getTilesWithinWorldXY: function (worldX, worldY, width, height, filteringOptions, camera, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return null; }
	
	        return TilemapComponents.GetTilesWithinWorldXY(worldX, worldY, width, height, filteringOptions, camera, layer);
	    },
	
	    /**
	     * Gets the index of the Tileset within this.tilesets that has the given `name`, or null if an
	     * invalid `name` is given.
	     *
	     * @method Phaser.Tilemaps.Tilemap#getTilesetIndex
	     * @since 3.0.0
	     *
	     * @param {string} name - The name of the Tileset to get.
	     *
	     * @return {integer} The Tileset index within this.tilesets.
	     */
	    getTilesetIndex: function (name)
	    {
	        return this.getIndex(this.tilesets, name);
	    },
	
	    /**
	     * Checks if there is a tile at the given location (in tile coordinates) in the given layer. Returns
	     * false if there is no tile or if the tile at that location has an index of -1.
	     *
	     * If no layer specified, the map's current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#hasTileAt
	     * @since 3.0.0
	     *
	     * @param {integer} tileX - [description]
	     * @param {integer} tileY - [description]
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?boolean} Returns a boolean, or null if the layer given was invalid.
	     */
	    hasTileAt: function (tileX, tileY, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return null; }
	
	        return TilemapComponents.HasTileAt(tileX, tileY, layer);
	    },
	
	    /**
	     * Checks if there is a tile at the given location (in world coordinates) in the given layer. Returns
	     * false if there is no tile or if the tile at that location has an index of -1.
	     *
	     * If no layer specified, the maps current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#hasTileAtWorldXY
	     * @since 3.0.0
	     *
	     * @param {number} worldX - [description]
	     * @param {number} worldY - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?boolean} Returns a boolean, or null if the layer given was invalid.
	     */
	    hasTileAtWorldXY: function (worldX, worldY, camera, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return null; }
	
	        return TilemapComponents.HasTileAtWorldXY(worldX, worldY, camera, layer);
	    },
	
	    /**
	     * The LayerData object that is currently selected in the map. You can set this property using
	     * any type supported by setLayer.
	     *
	     * @name Phaser.Tilemaps.Tilemap#layer
	     * @type {Phaser.Tilemaps.LayerData}
	     * @since 3.0.0
	     */
	    layer: {
	        get: function ()
	        {
	            return this.layers[this.currentLayerIndex];
	        },
	
	        set: function (layer)
	        {
	            this.setLayer(layer);
	        }
	    },
	
	    /**
	     * Puts a tile at the given tile coordinates in the specified layer. You can pass in either an index
	     * or a Tile object. If you pass in a Tile, all attributes will be copied over to the specified
	     * location. If you pass in an index, only the index at the specified location will be changed.
	     * Collision information will be recalculated at the specified location.
	     *
	     * If no layer specified, the maps current layer is used.
	     *
	     * This cannot be applied to StaticTilemapLayers.
	     *
	     * @method Phaser.Tilemaps.Tilemap#putTileAt
	     * @since 3.0.0
	     *
	     * @param {(integer|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
	     * @param {integer} tileX - [description]
	     * @param {integer} tileY - [description]
	     * @param {boolean} [recalculateFaces=true] - [description]
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tile} Returns a Tile, or null if the layer given was invalid.
	     */
	    putTileAt: function (tile, tileX, tileY, recalculateFaces, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (this._isStaticCall(layer, 'putTileAt')) { return null; }
	
	        if (layer === null) { return null; }
	
	        return TilemapComponents.PutTileAt(tile, tileX, tileY, recalculateFaces, layer);
	    },
	
	    /**
	     * Puts a tile at the given world coordinates (pixels) in the specified layer. You can pass in either
	     * an index or a Tile object. If you pass in a Tile, all attributes will be copied over to the
	     * specified location. If you pass in an index, only the index at the specified location will be
	     * changed. Collision information will be recalculated at the specified location.
	     *
	     * If no layer specified, the maps current layer is used. This
	     * cannot be applied to StaticTilemapLayers.
	     *
	     * @method Phaser.Tilemaps.Tilemap#putTileAtWorldXY
	     * @since 3.0.0
	     *
	     * @param {(integer|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
	     * @param {integer} worldX - [description]
	     * @param {integer} worldY - [description]
	     * @param {boolean} [recalculateFaces=true] - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tile} Returns a Tile, or null if the layer given was invalid.
	     */
	    putTileAtWorldXY: function (tile, worldX, worldY, recalculateFaces, camera, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (this._isStaticCall(layer, 'putTileAtWorldXY')) { return null; }
	
	        if (layer === null) { return null; }
	
	        return TilemapComponents.PutTileAtWorldXY(tile, worldX, worldY, recalculateFaces, camera, layer);
	    },
	
	    /**
	     * Puts an array of tiles or a 2D array of tiles at the given tile coordinates in the specified
	     * layer. The array can be composed of either tile indexes or Tile objects. If you pass in a Tile,
	     * all attributes will be copied over to the specified location. If you pass in an index, only the
	     * index at the specified location will be changed. Collision information will be recalculated
	     * within the region tiles were changed.
	     *
	     * If no layer specified, the maps current layer is used.
	     * This cannot be applied to StaticTilemapLayers.
	     *
	     * @method Phaser.Tilemaps.Tilemap#putTilesAt
	     * @since 3.0.0
	     *
	     * @param {(integer[]|integer[][]|Phaser.Tilemaps.Tile[]|Phaser.Tilemaps.Tile[][])} tile - A row (array) or grid (2D array) of Tiles
	     * or tile indexes to place.
	     * @param {integer} tileX - [description]
	     * @param {integer} tileY - [description]
	     * @param {boolean} [recalculateFaces=true] - [description]
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
	     */
	    putTilesAt: function (tilesArray, tileX, tileY, recalculateFaces, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (this._isStaticCall(layer, 'putTilesAt')) { return this; }
	
	        if (layer !== null)
	        {
	            TilemapComponents.PutTilesAt(tilesArray, tileX, tileY, recalculateFaces, layer);
	        }
	
	        return this;
	    },
	
	    /**
	     * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
	     * specified layer. Each tile will recieve a new index. If an array of indexes is passed in, then
	     * those will be used for randomly assigning new tile indexes. If an array is not provided, the
	     * indexes found within the region (excluding -1) will be used for randomly assigning new tile
	     * indexes. This method only modifies tile indexes and does not change collision information.
	     *
	     * If no layer specified, the maps current layer is used.
	     * This cannot be applied to StaticTilemapLayers.
	     *
	     * @method Phaser.Tilemaps.Tilemap#randomize
	     * @since 3.0.0
	     *
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     * @param {integer[]} [indexes] - An array of indexes to randomly draw from during randomization.
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
	     */
	    randomize: function (tileX, tileY, width, height, indexes, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (this._isStaticCall(layer, 'randomize')) { return this; }
	
	        if (layer !== null)
	        {
	            TilemapComponents.Randomize(tileX, tileY, width, height, indexes, layer);
	        }
	
	        return this;
	    },
	
	    /**
	     * Calculates interesting faces at the given tile coordinates of the specified layer. Interesting
	     * faces are used internally for optimizing collisions against tiles. This method is mostly used
	     * internally to optimize recalculating faces when only one tile has been changed.
	     *
	     * If no layer specified, the maps current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#calculateFacesAt
	     * @since 3.0.0
	     *
	     * @param {integer} tileX - [description]
	     * @param {integer} tileY - [description]
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
	     */
	    calculateFacesAt: function (tileX, tileY, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return this; }
	
	        TilemapComponents.CalculateFacesAt(tileX, tileY, layer);
	
	        return this;
	    },
	
	    /**
	     * Calculates interesting faces within the rectangular area specified (in tile coordinates) of the
	     * layer. Interesting faces are used internally for optimizing collisions against tiles. This method
	     * is mostly used internally.
	     *
	     * If no layer specified, the map's current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#calculateFacesWithin
	     * @since 3.0.0
	     *
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tilemap} Returns this, or null if the layer given was invalid.
	     */
	    calculateFacesWithin: function (tileX, tileY, width, height, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return this; }
	
	        TilemapComponents.CalculateFacesWithin(tileX, tileY, width, height, layer);
	
	        return this;
	    },
	
	    /**
	     * Removes all layers from this Tilemap and destroys any associated StaticTilemapLayers or
	     * DynamicTilemapLayers.
	     *
	     * @method Phaser.Tilemaps.Tilemap#removeAllLayers
	     * @since 3.0.0
	     *
	     * @return {Phaser.Tilemaps.Tilemap} This Tilemap object.
	     */
	    removeAllLayers: function ()
	    {
	        // Destroy any StaticTilemapLayers or DynamicTilemapLayers that are stored in LayerData
	        for (var i = 0; i < this.layers.length; i++)
	        {
	            if (this.layers[i].tilemapLayer)
	            {
	                this.layers[i].tilemapLayer.destroy();
	            }
	        }
	
	        this.layers.length = 0;
	        this.currentLayerIndex = 0;
	
	        return this;
	    },
	
	    /**
	     * Removes the tile at the given tile coordinates in the specified layer and updates the layer's
	     * collision information.
	     *
	     * If no layer specified, the maps current layer is used.
	     * This cannot be applied to StaticTilemapLayers.
	     *
	     * @method Phaser.Tilemaps.Tilemap#removeTileAt
	     * @since 3.0.0
	     *
	     * @param {(integer|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
	     * @param {integer} tileX - [description]
	     * @param {integer} tileY - [description]
	     * @param {boolean} [replaceWithNull=true] - If true, this will replace the tile at the specified
	     * location with null instead of a Tile with an index of -1.
	     * @param {boolean} [recalculateFaces=true] - [description]
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tile} Returns a Tile, or null if the layer given was invalid.
	     */
	    removeTileAt: function (tileX, tileY, replaceWithNull, recalculateFaces, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (this._isStaticCall(layer, 'removeTileAt')) { return null; }
	
	        if (layer === null) { return null; }
	
	        return TilemapComponents.RemoveTileAt(tileX, tileY, replaceWithNull, recalculateFaces, layer);
	    },
	
	    /**
	     * Removes the tile at the given world coordinates in the specified layer and updates the layer's
	     * collision information.
	     *
	     * If no layer specified, the maps current layer is used.
	     * This cannot be applied to StaticTilemapLayers.
	     *
	     * @method Phaser.Tilemaps.Tilemap#removeTileAtWorldXY
	     * @since 3.0.0
	     *
	     * @param {(integer|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
	     * @param {number} worldX - [description]
	     * @param {number} worldY - [description]
	     * @param {boolean} [replaceWithNull=true] - If true, this will replace the tile at the specified
	     * location with null instead of a Tile with an index of -1.
	     * @param {boolean} [recalculateFaces=true] - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tile} Returns a Tile, or null if the layer given was invalid.
	     */
	    removeTileAtWorldXY: function (worldX, worldY, replaceWithNull, recalculateFaces, camera, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (this._isStaticCall(layer, 'removeTileAtWorldXY')) { return null; }
	
	        if (layer === null) { return null; }
	
	        return TilemapComponents.RemoveTileAtWorldXY(worldX, worldY, replaceWithNull, recalculateFaces, camera, layer);
	    },
	
	    /**
	     * Draws a debug representation of the layer to the given Graphics. This is helpful when you want to
	     * get a quick idea of which of your tiles are colliding and which have interesting faces. The tiles
	     * are drawn starting at (0, 0) in the Graphics, allowing you to place the debug representation
	     * wherever you want on the screen.
	     *
	     * If no layer specified, the maps current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#renderDebug
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Graphics} graphics - The target Graphics object to draw upon.
	     * @param {object} styleConfig - An object specifying the colors to use for the debug drawing.
	     * @param {?Color} [styleConfig.tileColor=blue] - Color to use for drawing a filled rectangle at
	     * non-colliding tile locations. If set to null, non-colliding tiles will not be drawn.
	     * @param {?Color} [styleConfig.collidingTileColor=orange] - Color to use for drawing a filled
	     * rectangle at colliding tile locations. If set to null, colliding tiles will not be drawn.
	     * @param {?Color} [styleConfig.faceColor=grey] - Color to use for drawing a line at interesting
	     * tile faces. If set to null, interesting tile faces will not be drawn.
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
	     */
	    renderDebug: function (graphics, styleConfig, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return this; }
	
	        TilemapComponents.RenderDebug(graphics, styleConfig, layer);
	
	        return this;
	    },
	
	    /**
	     * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
	     * `findIndex` and updates their index to match `newIndex`. This only modifies the index and does
	     * not change collision information.
	     *
	     * If no layer specified, the maps current layer is used.
	     * This cannot be applied to StaticTilemapLayers.
	     *
	     * @method Phaser.Tilemaps.Tilemap#replaceByIndex
	     * @since 3.0.0
	     *
	     * @param {integer} findIndex - [description]
	     * @param {integer} newIndex - [description]
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
	     */
	    replaceByIndex: function (findIndex, newIndex, tileX, tileY, width, height, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (this._isStaticCall(layer, 'replaceByIndex')) { return this; }
	
	        if (layer !== null)
	        {
	            TilemapComponents.ReplaceByIndex(findIndex, newIndex, tileX, tileY, width, height, layer);
	        }
	
	        return this;
	    },
	
	    /**
	     * Sets collision on the given tile or tiles within a layer by index. You can pass in either a
	     * single numeric index or an array of indexes: [2, 3, 15, 20]. The `collides` parameter controls if
	     * collision will be enabled (true) or disabled (false).
	     *
	     * If no layer specified, the map's current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#setCollision
	     * @since 3.0.0
	     *
	     * @param {(integer|array)} indexes - Either a single tile index, or an array of tile indexes.
	     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear
	     * collision.
	     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the
	     * update.
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
	     */
	    setCollision: function (indexes, collides, recalculateFaces, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return this; }
	
	        TilemapComponents.SetCollision(indexes, collides, recalculateFaces, layer);
	
	        return this;
	    },
	
	    /**
	     * Sets collision on a range of tiles in a layer whose index is between the specified `start` and
	     * `stop` (inclusive). Calling this with a start value of 10 and a stop value of 14 would set
	     * collision for tiles 10, 11, 12, 13 and 14. The `collides` parameter controls if collision will be
	     * enabled (true) or disabled (false).
	     *
	     * If no layer specified, the map's current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#setCollisionBetween
	     * @since 3.0.0
	     *
	     * @param {integer} start - The first index of the tile to be set for collision.
	     * @param {integer} stop - The last index of the tile to be set for collision.
	     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear
	     * collision.
	     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the
	     * update.
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
	     */
	    setCollisionBetween: function (start, stop, collides, recalculateFaces, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return this; }
	
	        TilemapComponents.SetCollisionBetween(start, stop, collides, recalculateFaces, layer);
	
	        return this;
	    },
	
	    /**
	     * Sets collision on the tiles within a layer by checking tile properties. If a tile has a property
	     * that matches the given properties object, its collision flag will be set. The `collides`
	     * parameter controls if collision will be enabled (true) or disabled (false). Passing in
	     * `{ collides: true }` would update the collision flag on any tiles with a "collides" property that
	     * has a value of true. Any tile that doesn't have "collides" set to true will be ignored. You can
	     * also use an array of values, e.g. `{ types: ["stone", "lava", "sand" ] }`. If a tile has a
	     * "types" property that matches any of those values, its collision flag will be updated.
	     *
	     * If no layer specified, the map's current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#setCollisionByProperty
	     * @since 3.0.0
	     *
	     * @param {object} properties - An object with tile properties and corresponding values that should
	     * be checked.
	     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear
	     * collision.
	     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the
	     * update.
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
	     */
	    setCollisionByProperty: function (properties, collides, recalculateFaces, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return this; }
	
	        TilemapComponents.SetCollisionByProperty(properties, collides, recalculateFaces, layer);
	
	        return this;
	    },
	
	    /**
	     * Sets collision on all tiles in the given layer, except for tiles that have an index specified in
	     * the given array. The `collides` parameter controls if collision will be enabled (true) or
	     * disabled (false).
	     *
	     * If no layer specified, the map's current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#setCollisionByExclusion
	     * @since 3.0.0
	     *
	     * @param {integer[]} indexes - An array of the tile indexes to not be counted for collision.
	     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear
	     * collision.
	     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the
	     * update.
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
	     */
	    setCollisionByExclusion: function (indexes, collides, recalculateFaces, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return this; }
	
	        TilemapComponents.SetCollisionByExclusion(indexes, collides, recalculateFaces, layer);
	
	        return this;
	    },
	
	    /**
	     * Sets collision on the tiles within a layer by checking each tile's collision group data
	     * (typically defined in Tiled within the tileset collision editor). If any objects are found within
	     * a tile's collision group, the tile's colliding information will be set. The `collides` parameter
	     * controls if collision will be enabled (true) or disabled (false).
	     *
	     * If no layer specified, the map's current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#setCollisionFromCollisionGroup
	     * @since 3.0.0
	     *
	     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear
	     * collision.
	     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the
	     * update.
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
	     */
	    setCollisionFromCollisionGroup: function (collides, recalculateFaces, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return this; }
	
	        TilemapComponents.SetCollisionFromCollisionGroup(collides, recalculateFaces, layer);
	
	        return this;
	    },
	
	    /**
	     * Sets a global collision callback for the given tile index within the layer. This will affect all
	     * tiles on this layer that have the same index. If a callback is already set for the tile index it
	     * will be replaced. Set the callback to null to remove it. If you want to set a callback for a tile
	     * at a specific location on the map then see setTileLocationCallback.
	     *
	     * If no layer specified, the map's current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#setTileIndexCallback
	     * @since 3.0.0
	     *
	     * @param {(integer|array)} indexes - Either a single tile index, or an array of tile indexes to have a
	     * collision callback set for.
	     * @param {function} callback - The callback that will be invoked when the tile is collided with.
	     * @param {object} callbackContext - The context under which the callback is called.
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
	     */
	    setTileIndexCallback: function (indexes, callback, callbackContext, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return this; }
	
	        TilemapComponents.SetTileIndexCallback(indexes, callback, callbackContext, layer);
	
	        return this;
	    },
	
	    /**
	     * Sets a collision callback for the given rectangular area (in tile coordindates) within the layer.
	     * If a callback is already set for the tile index it will be replaced. Set the callback to null to
	     * remove it.
	     *
	     * If no layer specified, the map's current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#setTileLocationCallback
	     * @since 3.0.0
	     *
	     * @param {integer} tileX - [description]
	     * @param {integer} tileY - [description]
	     * @param {integer} width - [description]
	     * @param {integer} height - [description]
	     * @param {function} callback - The callback that will be invoked when the tile is collided with.
	     * @param {object} [callbackContext] - The context under which the callback is called.
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
	     */
	    setTileLocationCallback: function (tileX, tileY, width, height, callback, callbackContext, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return this; }
	
	        TilemapComponents.SetTileLocationCallback(tileX, tileY, width, height, callback, callbackContext, layer);
	
	        return this;
	    },
	
	    /**
	     * Sets the current layer to the LayerData associated with `layer`.
	     *
	     * @method Phaser.Tilemaps.Tilemap#setLayer
	     * @since 3.0.0
	     *
	     * @param {(string|integer|Phaser.Tilemaps.DynamicTilemapLayer|Phaser.Tilemaps.StaticTilemapLayer)} [layer] - The name of the
	     * layer from Tiled, the index of the layer in the map, a DynamicTilemapLayer or a
	     * StaticTilemapLayer. If not given will default to the map's current layer index.
	     *
	     * @return {Phaser.Tilemaps.Tilemap} This Tilemap object.
	     */
	    setLayer: function (layer)
	    {
	        var index = this.getLayerIndex(layer);
	
	        if (index !== null)
	        {
	            this.currentLayerIndex = index;
	        }
	
	        return this;
	    },
	
	    /**
	     * Sets the base tile size for the map. Note: this does not necessarily match the tileWidth and
	     * tileHeight for all layers. This also updates the base size on all tiles across all layers.
	     *
	     * @method Phaser.Tilemaps.Tilemap#setBaseTileSize
	     * @since 3.0.0
	     *
	     * @param {integer} tileWidth - The width of the tiles the map uses for calculations.
	     * @param {integer} tileHeight - The height of the tiles the map uses for calculations.
	     *
	     * @return {Phaser.Tilemaps.Tilemap} This Tilemap object.
	     */
	    setBaseTileSize: function (tileWidth, tileHeight)
	    {
	        this.tileWidth = tileWidth;
	        this.tileHeight = tileHeight;
	        this.widthInPixels = this.width * tileWidth;
	        this.heightInPixels = this.height * tileHeight;
	
	        // Update the base tile size on all layers & tiles
	        for (var i = 0; i < this.layers.length; i++)
	        {
	            this.layers[i].baseWidth = tileWidth;
	            this.layers[i].baseHeight = tileHeight;
	
	            var mapData = this.layers[i].data;
	            var mapWidth = this.layers[i].width;
	            var mapHeight = this.layers[i].height;
	
	            for (var row = 0; row < mapHeight; ++row)
	            {
	                for (var col = 0; col < mapWidth; ++col)
	                {
	                    var tile = mapData[row][col];
	
	                    if (tile !== null)
	                    {
	                        tile.setSize(undefined, undefined, tileWidth, tileHeight);
	                    }
	                }
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Sets the tile size for a specific `layer`. Note: this does not necessarily match the map's
	     * tileWidth and tileHeight for all layers. This will set the tile size for the layer and any
	     * tiles the layer has.
	     *
	     * @method Phaser.Tilemaps.Tilemap#setLayerTileSize
	     * @since 3.0.0
	     *
	     * @param {integer} tileWidth - The width of the tiles (in pixels) in the layer.
	     * @param {integer} tileHeight - The height of the tiles (in pixels) in the layer.
	     * @param {(string|integer|Phaser.Tilemaps.DynamicTilemapLayer|Phaser.Tilemaps.StaticTilemapLayer)} [layer] - The name of the
	     * layer from Tiled, the index of the layer in the map, a DynamicTilemapLayer or a
	     * StaticTilemapLayer. If not given will default to the map's current layer index.
	     *
	     * @return {Phaser.Tilemaps.Tilemap} This Tilemap object.
	     */
	    setLayerTileSize: function (tileWidth, tileHeight, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return this; }
	
	        layer.tileWidth = tileWidth;
	        layer.tileHeight = tileHeight;
	
	        var mapData = layer.data;
	        var mapWidth = layer.width;
	        var mapHeight = layer.height;
	
	        for (var row = 0; row < mapHeight; ++row)
	        {
	            for (var col = 0; col < mapWidth; ++col)
	            {
	                var tile = mapData[row][col];
	
	                if (tile !== null) { tile.setSize(tileWidth, tileHeight); }
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Shuffles the tiles in a rectangular region (specified in tile coordinates) within the given
	     * layer. It will only randomize the tiles in that area, so if they're all the same nothing will
	     * appear to have changed! This method only modifies tile indexes and does not change collision
	     * information.
	     *
	     * If no layer specified, the maps current layer is used.
	     * This cannot be applied to StaticTilemapLayers.
	     *
	     * @method Phaser.Tilemaps.Tilemap#shuffle
	     * @since 3.0.0
	     *
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
	     */
	    shuffle: function (tileX, tileY, width, height, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (this._isStaticCall(layer, 'shuffle')) { return this; }
	
	        if (layer !== null)
	        {
	            TilemapComponents.Shuffle(tileX, tileY, width, height, layer);
	        }
	
	        return this;
	    },
	
	    /**
	     * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
	     * `indexA` and swaps then with `indexB`. This only modifies the index and does not change collision
	     * information.
	     *
	     * If no layer specified, the maps current layer is used.
	     * This cannot be applied to StaticTilemapLayers.
	     *
	     * @method Phaser.Tilemaps.Tilemap#swapByIndex
	     * @since 3.0.0
	     *
	     * @param {integer} tileA - First tile index.
	     * @param {integer} tileB - Second tile index.
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
	     */
	    swapByIndex: function (indexA, indexB, tileX, tileY, width, height, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (this._isStaticCall(layer, 'swapByIndex')) { return this; }
	
	        if (layer !== null)
	        {
	            TilemapComponents.SwapByIndex(indexA, indexB, tileX, tileY, width, height, layer);
	        }
	
	        return this;
	    },
	
	    /**
	     * Converts from tile X coordinates (tile units) to world X coordinates (pixels), factoring in the
	     * layers position, scale and scroll.
	     *
	     * If no layer specified, the maps current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#tileToWorldX
	     * @since 3.0.0
	     *
	     * @param {integer} tileX - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?number} Returns a number, or null if the layer given was invalid.
	     */
	    tileToWorldX: function (tileX, camera, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return null; }
	
	        return TilemapComponents.TileToWorldX(tileX, camera, layer);
	    },
	
	    /**
	     * Converts from tile Y coordinates (tile units) to world Y coordinates (pixels), factoring in the
	     * layers position, scale and scroll.
	     *
	     * If no layer specified, the maps current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#tileToWorldY
	     * @since 3.0.0
	     *
	     * @param {integer} tileY - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?number} Returns a number, or null if the layer given was invalid.
	     */
	    tileToWorldY: function (tileX, camera, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return null; }
	
	        return TilemapComponents.TileToWorldY(tileX, camera, layer);
	    },
	
	    /**
	     * Converts from tile XY coordinates (tile units) to world XY coordinates (pixels), factoring in the
	     * layers position, scale and scroll. This will return a new Vector2 object or update the given
	     * `point` object.
	     *
	     * If no layer specified, the maps current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#tileToWorldXY
	     * @since 3.0.0
	     *
	     * @param {integer} tileX - [description]
	     * @param {integer} tileY - [description]
	     * @param {Phaser.Math.Vector2} [point] - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Math.Vector2} Returns a point, or null if the layer given was invalid.
	     */
	    tileToWorldXY: function (tileX, tileY, point, camera, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return null; }
	
	        return TilemapComponents.TileToWorldXY(tileX, tileY, point, camera, layer);
	    },
	
	    /**
	     * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
	     * specified layer. Each tile will receive a new index. New indexes are drawn from the given
	     * weightedIndexes array. An example weighted array:
	     *
	     * [
	     *  { index: 6, weight: 4 },    // Probability of index 6 is 4 / 8
	     *  { index: 7, weight: 2 },    // Probability of index 7 would be 2 / 8
	     *  { index: 8, weight: 1.5 },  // Probability of index 8 would be 1.5 / 8
	     *  { index: 26, weight: 0.5 }  // Probability of index 27 would be 0.5 / 8
	     * ]
	     *
	     * The probability of any index being choose is (the index's weight) / (sum of all weights). This
	     * method only modifies tile indexes and does not change collision information.
	     *
	     * If no layer specified, the map's current layer is used. This
	     * cannot be applied to StaticTilemapLayers.
	     *
	     * @method Phaser.Tilemaps.Tilemap#weightedRandomize
	     * @since 3.0.0
	     *
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     * @param {object[]} [weightedIndexes] - An array of objects to randomly draw from during
	     * randomization. They should be in the form: { index: 0, weight: 4 } or
	     * { index: [0, 1], weight: 4 } if you wish to draw from multiple tile indexes.
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Tilemaps.Tilemap} Return this Tilemap object, or null if the layer given was invalid.
	     */
	    weightedRandomize: function (tileX, tileY, width, height, weightedIndexes, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (this._isStaticCall(layer, 'weightedRandomize')) { return this; }
	
	        if (layer !== null)
	        {
	            TilemapComponents.WeightedRandomize(tileX, tileY, width, height, weightedIndexes, layer);
	        }
	
	        return this;
	    },
	
	    /**
	     * Converts from world X coordinates (pixels) to tile X coordinates (tile units), factoring in the
	     * layers position, scale and scroll.
	     *
	     * If no layer specified, the maps current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#worldToTileX
	     * @since 3.0.0
	     *
	     * @param {number} worldX - [description]
	     * @param {boolean} [snapToFloor=true] - Whether or not to round the tile coordinate down to the
	     * nearest integer.
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?number} Returns a number, or null if the layer given was invalid.
	     */
	    worldToTileX: function (worldX, snapToFloor, camera, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return null; }
	
	        return TilemapComponents.WorldToTileX(worldX, snapToFloor, camera, layer);
	    },
	
	    /**
	     * Converts from world Y coordinates (pixels) to tile Y coordinates (tile units), factoring in the
	     * layers position, scale and scroll.
	     *
	     * If no layer specified, the maps current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#worldToTileY
	     * @since 3.0.0
	     *
	     * @param {number} worldY - [description]
	     * @param {boolean} [snapToFloor=true] - Whether or not to round the tile coordinate down to the
	     * nearest integer.
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?number} Returns a number, or null if the layer given was invalid.
	     */
	    worldToTileY: function (worldY, snapToFloor, camera, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return null; }
	
	        return TilemapComponents.WorldToTileY(worldY, snapToFloor, camera, layer);
	    },
	
	    /**
	     * Converts from world XY coordinates (pixels) to tile XY coordinates (tile units), factoring in the
	     * layers position, scale and scroll. This will return a new Vector2 object or update the given
	     * `point` object.
	     *
	     * If no layer specified, the maps current layer is used.
	     *
	     * @method Phaser.Tilemaps.Tilemap#worldToTileXY
	     * @since 3.0.0
	     *
	     * @param {number} worldX - [description]
	     * @param {number} worldY - [description]
	     * @param {boolean} [snapToFloor=true] - Whether or not to round the tile coordinate down to the
	     * nearest integer.
	     * @param {Phaser.Math.Vector2} [point] - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     * @param {Phaser.Tilemaps.LayerData} [layer] - [description]
	     *
	     * @return {?Phaser.Math.Vector2} Returns a point, or null if the layer given was invalid.
	     */
	    worldToTileXY: function (worldX, worldY, snapToFloor, point, camera, layer)
	    {
	        layer = this.getLayer(layer);
	
	        if (layer === null) { return null; }
	
	        return TilemapComponents.WorldToTileXY(worldX, worldY, snapToFloor, point, camera, layer);
	    },
	
	    /**
	     * Used internally to check if a layer is static and prints out a warning.
	     *
	     * @method Phaser.Tilemaps.Tilemap#_isStaticCall
	     * @private
	     * @since 3.0.0
	     *
	     * @return {boolean}
	     */
	    _isStaticCall: function (layer, functionName)
	    {
	        if (layer.tilemapLayer instanceof StaticTilemapLayer)
	        {
	            console.warn(functionName + ': You cannot change the tiles in a static tilemap layer');
	            return true;
	        }
	        else
	        {
	            return false;
	        }
	    }
	
	});
	
	module.exports = Tilemap;


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var IsInLayerBounds = __webpack_require__(169);
	
	/**
	 * Checks if there is a tile at the given location (in tile coordinates) in the given layer. Returns
	 * false if there is no tile or if the tile at that location has an index of -1.
	 *
	 * @function Phaser.Tilemaps.Components.HasTileAt
	 * @private
	 * @since 3.0.0
	 *
	 * @param {integer} tileX - [description]
	 * @param {integer} tileY - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 * 
	 * @return {boolean}
	 */
	var HasTileAt = function (tileX, tileY, layer)
	{
	    if (IsInLayerBounds(tileX, tileY, layer))
	    {
	        var tile = layer.data[tileY][tileX];
	        return (tile !== null && tile.index > -1);
	    }
	    else
	    {
	        return false;
	    }
	
	};
	
	module.exports = HasTileAt;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Tile = __webpack_require__(120);
	var IsInLayerBounds = __webpack_require__(169);
	var CalculateFacesAt = __webpack_require__(330);
	
	/**
	 * Removes the tile at the given tile coordinates in the specified layer and updates the layer's
	 * collision information.
	 *
	 * @function Phaser.Tilemaps.Components.RemoveTileAt
	 * @private
	 * @since 3.0.0
	 *
	 * @param {(integer|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
	 * @param {integer} tileX - [description]
	 * @param {integer} tileY - [description]
	 * @param {boolean} [replaceWithNull=true] - If true, this will replace the tile at the specified
	 * location with null instead of a Tile with an index of -1.
	 * @param {boolean} [recalculateFaces=true] - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 *
	 * @return {Phaser.Tilemaps.Tile} The Tile object that was removed.
	 */
	var RemoveTileAt = function (tileX, tileY, replaceWithNull, recalculateFaces, layer)
	{
	    if (replaceWithNull === undefined) { replaceWithNull = false; }
	    if (recalculateFaces === undefined) { recalculateFaces = true; }
	    if (!IsInLayerBounds(tileX, tileY, layer)) { return null; }
	
	    var tile = layer.data[tileY][tileX];
	    if (tile === null)
	    {
	        return null;
	    }
	    else
	    {
	        layer.data[tileY][tileX] = replaceWithNull
	            ? null
	            : new Tile(layer, -1, tileX, tileY, tile.width, tile.height);
	    }
	
	    // Recalculate faces only if the removed tile was a colliding tile
	    if (recalculateFaces && tile && tile.collides)
	    {
	        CalculateFacesAt(tileX, tileY, layer);
	    }
	
	    return tile;
	};
	
	module.exports = RemoveTileAt;


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetTilesWithin = __webpack_require__(34);
	
	/**
	 * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
	 * `findIndex` and updates their index to match `newIndex`. This only modifies the index and does
	 * not change collision information.
	 *
	 * @function Phaser.Tilemaps.Components.ReplaceByIndex
	 * @private
	 * @since 3.0.0
	 *
	 * @param {integer} findIndex - [description]
	 * @param {integer} newIndex - [description]
	 * @param {integer} [tileX=0] - [description]
	 * @param {integer} [tileY=0] - [description]
	 * @param {integer} [width=max width based on tileX] - [description]
	 * @param {integer} [height=max height based on tileY] - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 */
	var ReplaceByIndex = function (findIndex, newIndex, tileX, tileY, width, height, layer)
	{
	    var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
	    for (var i = 0; i < tiles.length; i++)
	    {
	        if (tiles[i] && tiles[i].index === findIndex)
	        {
	            tiles[i].index = newIndex;
	        }
	    }
	};
	
	module.exports = ReplaceByIndex;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(28);
	var DynamicTilemapLayerRender = __webpack_require__(1563);
	var GameObject = __webpack_require__(5);
	var TilemapComponents = __webpack_require__(215);
	
	/**
	 * @classdesc
	 * A DynamicTilemapLayer is a game object that renders LayerData from a Tilemap. A
	 * DynamicTilemapLayer can only render tiles from a single tileset.
	 *
	 * A DynamicTilemapLayer trades some speed for being able to apply powerful effects. Unlike a
	 * StaticTilemapLayer, you can apply per-tile effects like tint or alpha, and you can change the
	 * tiles in a DynamicTilemapLayer. Use this over a StaticTilemapLayer when you need those
	 * features.
	 *
	 * @class DynamicTilemapLayer
	 * @extends Phaser.GameObjects.GameObject
	 * @memberOf Phaser.Tilemaps
	 * @constructor
	 * @since 3.0.0
	 *
	 * @extends Phaser.GameObjects.Components.Alpha
	 * @extends Phaser.GameObjects.Components.BlendMode
	 * @extends Phaser.GameObjects.Components.ComputedSize
	 * @extends Phaser.GameObjects.Components.Depth
	 * @extends Phaser.GameObjects.Components.Flip
	 * @extends Phaser.GameObjects.Components.GetBounds
	 * @extends Phaser.GameObjects.Components.Origin
	 * @extends Phaser.GameObjects.Components.Pipeline
	 * @extends Phaser.GameObjects.Components.ScaleMode
	 * @extends Phaser.GameObjects.Components.ScrollFactor
	 * @extends Phaser.GameObjects.Components.Transform
	 * @extends Phaser.GameObjects.Components.Visible
	 *
	 * @param {Phaser.Scene} scene - [description]
	 * @param {Phaser.Tilemaps.Tilemap} tilemap - The Tilemap this layer is a part of.
	 * @param {integer} layerIndex - The index of the LayerData associated with this layer.
	 * @param {Phaser.Tilemaps.Tileset} tileset - The tileset used to render the tiles in this layer.
	 * @param {number} [x=0] - The world x position where the top left of this layer will be placed.
	 * @param {number} [y=0] - The world y position where the top left of this layer will be placed.
	 */
	var DynamicTilemapLayer = new Class({
	
	    Extends: GameObject,
	
	    Mixins: [
	        Components.Alpha,
	        Components.BlendMode,
	        Components.ComputedSize,
	        Components.Depth,
	        Components.Flip,
	        Components.GetBounds,
	        Components.Origin,
	        Components.Pipeline,
	        Components.ScaleMode,
	        Components.Transform,
	        Components.Visible,
	        Components.ScrollFactor,
	        DynamicTilemapLayerRender
	    ],
	
	    initialize:
	
	    function DynamicTilemapLayer (scene, tilemap, layerIndex, tileset, x, y)
	    {
	        GameObject.call(this, scene, 'DynamicTilemapLayer');
	
	        /**
	         * Used internally by physics system to perform fast type checks.
	         *
	         * @name Phaser.Tilemaps.DynamicTilemapLayer#isTilemap
	         * @type {boolean}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.isTilemap = true;
	
	        /**
	         * The Tilemap that this layer is a part of.
	         *
	         * @name Phaser.Tilemaps.DynamicTilemapLayer#tilemap
	         * @type {Phaser.Tilemaps.Tilemap}
	         * @since 3.0.0
	         */
	        this.tilemap = tilemap;
	
	        /**
	         * The index of the LayerData associated with this layer.
	         *
	         * @name Phaser.Tilemaps.DynamicTilemapLayer#layerIndex
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.layerIndex = layerIndex;
	
	        /**
	         * The LayerData associated with this layer. LayerData can only be associated with one
	         * tilemap layer.
	         *
	         * @name Phaser.Tilemaps.DynamicTilemapLayer#layer
	         * @type {Phaser.Tilemaps.LayerData}
	         * @since 3.0.0
	         */
	        this.layer = tilemap.layers[layerIndex];
	
	        this.layer.tilemapLayer = this; // Link the LayerData with this static tilemap layer
	
	        /**
	         * The Tileset associated with this layer. A tilemap layer can only render from one Tileset.
	         *
	         * @name Phaser.Tilemaps.DynamicTilemapLayer#tileset
	         * @type {Phaser.Tilemaps.Tileset}
	         * @since 3.0.0
	         */
	        this.tileset = tileset;
	
	        /**
	         * Used internally with the canvas render. This holds the tiles that are visible within the
	         * camera.
	         *
	         * @name Phaser.Tilemaps.DynamicTilemapLayer#culledTiles
	         * @type {array}
	         * @since 3.0.0
	         */
	        this.culledTiles = [];
	
	        this.setAlpha(this.layer.alpha);
	        this.setPosition(x, y);
	        this.setOrigin();
	        this.setSize(this.layer.tileWidth * this.layer.width, this.layer.tileHeight * this.layer.height);
	
	        this.initPipeline('TextureTintPipeline');
	    },
	
	    /**
	     * Calculates interesting faces at the given tile coordinates of the specified layer. Interesting
	     * faces are used internally for optimizing collisions against tiles. This method is mostly used
	     * internally to optimize recalculating faces when only one tile has been changed.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#calculateFacesAt
	     * @since 3.0.0
	     *
	     * @param {integer} tileX - The x coordinate.
	     * @param {integer} tileY - The y coordinate.
	     *
	     * @return {Phaser.Tilemaps.DynamicTilemapLayer} This Tilemap Layer object.
	     */
	    calculateFacesAt: function (tileX, tileY)
	    {
	        TilemapComponents.CalculateFacesAt(tileX, tileY, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Calculates interesting faces within the rectangular area specified (in tile coordinates) of the
	     * layer. Interesting faces are used internally for optimizing collisions against tiles. This method
	     * is mostly used internally.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#calculateFacesWithin
	     * @since 3.0.0
	     *
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     *
	     * @return {Phaser.Tilemaps.DynamicTilemapLayer} This Tilemap Layer object.
	     */
	    calculateFacesWithin: function (tileX, tileY, width, height)
	    {
	        TilemapComponents.CalculateFacesWithin(tileX, tileY, width, height, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Creates a Sprite for every object matching the given tile indexes in the layer. You can
	     * optionally specify if each tile will be replaced with a new tile after the Sprite has been
	     * created. This is useful if you want to lay down special tiles in a level that are converted to
	     * Sprites, but want to replace the tile itself with a floor tile or similar once converted.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#createFromTiles
	     * @since 3.0.0
	     *
	     * @param {(integer|array)} indexes - The tile index, or array of indexes, to create Sprites from.
	     * @param {(integer|array)} replacements - The tile index, or array of indexes, to change a converted
	     * tile to. Set to `null` to leave the tiles unchanged. If an array is given, it is assumed to be a
	     * one-to-one mapping with the indexes array.
	     * @param {object} spriteConfig - The config object to pass into the Sprite creator (i.e.
	     * scene.make.sprite).
	     * @param {Phaser.Scene} [scene=scene the map is within] - The Scene to create the Sprites within.
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - The Camera to use when determining the world XY
	     *
	     * @return {Phaser.GameObjects.Sprite[]} An array of the Sprites that were created.
	     */
	    createFromTiles: function (indexes, replacements, spriteConfig, scene, camera)
	    {
	        return TilemapComponents.CreateFromTiles(indexes, replacements, spriteConfig, scene, camera, this.layer);
	    },
	
	    /**
	     * Returns the tiles in the given layer that are within the cameras viewport.
	     * This is used internally.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#cull
	     * @since 3.0.0
	     *
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to run the cull check against.
	     *
	     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
	     */
	    cull: function (camera)
	    {
	        return TilemapComponents.CullTiles(this.layer, camera, this.culledTiles);
	    },
	
	    /**
	     * Copies the tiles in the source rectangular area to a new destination (all specified in tile
	     * coordinates) within the layer. This copies all tile properties & recalculates collision
	     * information in the destination region.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#copy
	     * @since 3.0.0
	     *
	     * @param {integer} srcTileX - [description]
	     * @param {integer} srcTileY - [description]
	     * @param {integer} width - [description]
	     * @param {integer} height - [description]
	     * @param {integer} destTileX - [description]
	     * @param {integer} destTileY - [description]
	     * @param {boolean} [recalculateFaces=true] - [description]
	     *
	     * @return {Phaser.Tilemaps.DynamicTilemapLayer} This Tilemap Layer object.
	     */
	    copy: function (srcTileX, srcTileY, width, height, destTileX, destTileY, recalculateFaces)
	    {
	        TilemapComponents.Copy(srcTileX, srcTileY, width, height, destTileX, destTileY, recalculateFaces, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Destroys this DynamicTilemapLayer and removes its link to the associated LayerData.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        // Uninstall this layer only if it is still installed on the LayerData object
	        if (this.layer.tilemapLayer === this)
	        {
	            this.layer.tilemapLayer = undefined;
	        }
	
	        this.tilemap = undefined;
	        this.layer = undefined;
	        this.tileset = undefined;
	        this.culledTiles.length = 0;
	
	        GameObject.prototype.destroy.call(this);
	    },
	
	    /**
	     * Sets the tiles in the given rectangular area (in tile coordinates) of the layer with the
	     * specified index. Tiles will be set to collide if the given index is a colliding index.
	     * Collision information in the region will be recalculated.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#fill
	     * @since 3.0.0
	     *
	     * @param {integer} index - [description]
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     * @param {boolean} [recalculateFaces=true] - [description]
	     *
	     * @return {Phaser.Tilemaps.DynamicTilemapLayer} This Tilemap Layer object.
	     */
	    fill: function (index, tileX, tileY, width, height, recalculateFaces)
	    {
	        TilemapComponents.Fill(index, tileX, tileY, width, height, recalculateFaces, this.layer);
	
	        return this;
	    },
	
	    /**
	     * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
	     * filter callback function. Any tiles that pass the filter test (i.e. where the callback returns
	     * true) will returned as a new array. Similar to Array.prototype.Filter in vanilla JS.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#filterTiles
	     * @since 3.0.0
	     *
	     * @param {function} callback - The callback. Each tile in the given area will be passed to this
	     * callback as the first and only parameter. The callback should return true for tiles that pass the
	     * filter.
	     * @param {object} [context] - The context under which the callback should be run.
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	     * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	     * -1 for an index.
	     * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide
	     * on at least one side.
	     * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	     * have at least one interesting face.
	     *
	     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
	     */
	    filterTiles: function (callback, context, tileX, tileY, width, height, filteringOptions)
	    {
	        return TilemapComponents.FilterTiles(callback, context, tileX, tileY, width, height, filteringOptions, this.layer);
	    },
	
	    /**
	     * Searches the entire map layer for the first tile matching the given index, then returns that Tile
	     * object. If no match is found, it returns null. The search starts from the top-left tile and
	     * continues horizontally until it hits the end of the row, then it drops down to the next column.
	     * If the reverse boolean is true, it scans starting from the bottom-right corner traveling up to
	     * the top-left.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#findByIndex
	     * @since 3.0.0
	     *
	     * @param {integer} index - The tile index value to search for.
	     * @param {integer} [skip=0] - The number of times to skip a matching tile before returning.
	     * @param {boolean} [reverse=false] - If true it will scan the layer in reverse, starting at the
	     * bottom-right. Otherwise it scans from the top-left.
	     *
	     * @return {Phaser.Tilemaps.Tile} A Tile object.
	     */
	    findByIndex: function (findIndex, skip, reverse)
	    {
	        return TilemapComponents.FindByIndex(findIndex, skip, reverse, this.layer);
	    },
	
	    /**
	     * Find the first tile in the given rectangular area (in tile coordinates) of the layer that
	     * satisfies the provided testing function. I.e. finds the first tile for which `callback` returns
	     * true. Similar to Array.prototype.find in vanilla JS.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#findTile
	     * @since 3.0.0
	     *
	     * @param {function} callback - The callback. Each tile in the given area will be passed to this
	     * callback as the first and only parameter.
	     * @param {object} [context] - The context under which the callback should be run.
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	     * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	     * -1 for an index.
	     * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide
	     * on at least one side.
	     * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	     * have at least one interesting face.
	     *
	     * @return {?Phaser.Tilemaps.Tile}
	     */
	    findTile: function (callback, context, tileX, tileY, width, height, filteringOptions)
	    {
	        return TilemapComponents.FindTile(callback, context, tileX, tileY, width, height, filteringOptions, this.layer);
	    },
	
	    /**
	     * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
	     * callback. Similar to Array.prototype.forEach in vanilla JS.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#forEachTile
	     * @since 3.0.0
	     *
	     * @param {function} callback - The callback. Each tile in the given area will be passed to this
	     * callback as the first and only parameter.
	     * @param {object} [context] - The context under which the callback should be run.
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	     * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	     * -1 for an index.
	     * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide
	     * on at least one side.
	     * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	     * have at least one interesting face.
	     *
	     * @return {Phaser.Tilemaps.DynamicTilemapLayer} This Tilemap Layer object.
	     */
	    forEachTile: function (callback, context, tileX, tileY, width, height, filteringOptions)
	    {
	        TilemapComponents.ForEachTile(callback, context, tileX, tileY, width, height, filteringOptions, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Gets a tile at the given tile coordinates from the given layer.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#getTileAt
	     * @since 3.0.0
	     *
	     * @param {integer} tileX - X position to get the tile from (given in tile units, not pixels).
	     * @param {integer} tileY - Y position to get the tile from (given in tile units, not pixels).
	     * @param {boolean} [nonNull=false] - If true getTile won't return null for empty tiles, but a Tile
	     * object with an index of -1.
	     *
	     * @return {Phaser.Tilemaps.Tile} The tile at the given coordinates or null if no tile was found or the coordinates were invalid.
	     */
	    getTileAt: function (tileX, tileY, nonNull)
	    {
	        return TilemapComponents.GetTileAt(tileX, tileY, nonNull, this.layer);
	    },
	
	    /**
	     * Gets a tile at the given world coordinates from the given layer.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#getTileAtWorldXY
	     * @since 3.0.0
	     *
	     * @param {number} worldX - X position to get the tile from (given in pixels)
	     * @param {number} worldY - Y position to get the tile from (given in pixels)
	     * @param {boolean} [nonNull=false] - If true, function won't return null for empty tiles, but a Tile
	     * object with an index of -1.
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     *
	     * @return {Phaser.Tilemaps.Tile} The tile at the given coordinates or null if no tile was found or the coordinates
	     * were invalid.
	     */
	    getTileAtWorldXY: function (worldX, worldY, nonNull, camera)
	    {
	        return TilemapComponents.GetTileAtWorldXY(worldX, worldY, nonNull, camera, this.layer);
	    },
	
	    /**
	     * Gets the tiles in the given rectangular area (in tile coordinates) of the layer.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#getTilesWithin
	     * @since 3.0.0
	     *
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	     * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	     * -1 for an index.
	     * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide on
	     * at least one side.
	     * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	     * have at least one interesting face.
	     *
	     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
	     */
	    getTilesWithin: function (tileX, tileY, width, height, filteringOptions)
	    {
	        return TilemapComponents.GetTilesWithin(tileX, tileY, width, height, filteringOptions, this.layer);
	    },
	
	    /**
	     * Gets the tiles that overlap with the given shape in the given layer. The shape must be a Circle,
	     * Line, Rectangle or Triangle. The shape should be in world coordinates.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#getTilesWithinShape
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Geom.Circle|Phaser.Geom.Line|Phaser.Geom.Rectangle|Phaser.Geom.Triangle)} shape - A shape in world (pixel) coordinates
	     * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	     * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	     * -1 for an index.
	     * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide on
	     * at least one side.
	     * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	     * have at least one interesting face.
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     *
	     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
	     */
	    getTilesWithinShape: function (shape, filteringOptions, camera)
	    {
	        return TilemapComponents.GetTilesWithinShape(shape, filteringOptions, camera, this.layer);
	    },
	
	    /**
	     * Gets the tiles in the given rectangular area (in world coordinates) of the layer.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#getTilesWithinWorldXY
	     * @since 3.0.0
	     *
	     * @param {number} worldX - [description]
	     * @param {number} worldY - [description]
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	     * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	     * -1 for an index.
	     * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide on
	     * at least one side.
	     * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	     * have at least one interesting face.
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     *
	     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
	     */
	    getTilesWithinWorldXY: function (worldX, worldY, width, height, filteringOptions, camera)
	    {
	        return TilemapComponents.GetTilesWithinWorldXY(worldX, worldY, width, height, filteringOptions, camera, this.layer);
	    },
	
	    /**
	     * Checks if there is a tile at the given location (in tile coordinates) in the given layer. Returns
	     * false if there is no tile or if the tile at that location has an index of -1.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#hasTileAt
	     * @since 3.0.0
	     *
	     * @param {integer} tileX - [description]
	     * @param {integer} tileY - [description]
	     *
	     * @return {boolean}
	     */
	    hasTileAt: function (tileX, tileY)
	    {
	        return TilemapComponents.HasTileAt(tileX, tileY, this.layer);
	    },
	
	    /**
	     * Checks if there is a tile at the given location (in world coordinates) in the given layer. Returns
	     * false if there is no tile or if the tile at that location has an index of -1.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#hasTileAtWorldXY
	     * @since 3.0.0
	     *
	     * @param {number} worldX - [description]
	     * @param {number} worldY - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     *
	     * @return {boolean}
	     */
	    hasTileAtWorldXY: function (worldX, worldY, camera)
	    {
	        return TilemapComponents.HasTileAtWorldXY(worldX, worldY, camera, this.layer);
	    },
	
	    /**
	     * Puts a tile at the given tile coordinates in the specified layer. You can pass in either an index
	     * or a Tile object. If you pass in a Tile, all attributes will be copied over to the specified
	     * location. If you pass in an index, only the index at the specified location will be changed.
	     * Collision information will be recalculated at the specified location.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#putTileAt
	     * @since 3.0.0
	     *
	     * @param {(integer|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
	     * @param {integer} tileX - [description]
	     * @param {integer} tileY - [description]
	     * @param {boolean} [recalculateFaces=true] - [description]
	     *
	     * @return {Phaser.Tilemaps.Tile} A Tile object.
	     */
	    putTileAt: function (tile, tileX, tileY, recalculateFaces)
	    {
	        return TilemapComponents.PutTileAt(tile, tileX, tileY, recalculateFaces, this.layer);
	    },
	
	    /**
	     * Puts a tile at the given world coordinates (pixels) in the specified layer. You can pass in either
	     * an index or a Tile object. If you pass in a Tile, all attributes will be copied over to the
	     * specified location. If you pass in an index, only the index at the specified location will be
	     * changed. Collision information will be recalculated at the specified location.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#putTileAtWorldXY
	     * @since 3.0.0
	     *
	     * @param {(integer|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
	     * @param {integer} worldX - [description]
	     * @param {integer} worldY - [description]
	     * @param {boolean} [recalculateFaces=true] - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - [description]
	     *
	     * @return {Phaser.Tilemaps.Tile} A Tile object.
	     */
	    putTileAtWorldXY: function (tile, worldX, worldY, recalculateFaces, camera)
	    {
	        return TilemapComponents.PutTileAtWorldXY(tile, worldX, worldY, recalculateFaces, camera, this.layer);
	    },
	
	    /**
	     * Puts an array of tiles or a 2D array of tiles at the given tile coordinates in the specified
	     * layer. The array can be composed of either tile indexes or Tile objects. If you pass in a Tile,
	     * all attributes will be copied over to the specified location. If you pass in an index, only the
	     * index at the specified location will be changed. Collision information will be recalculated
	     * within the region tiles were changed.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#putTilesAt
	     * @since 3.0.0
	     *
	     * @param {(integer[]|integer[][]|Phaser.Tilemaps.Tile[]|Phaser.Tilemaps.Tile[][])} tile - A row (array) or grid (2D array) of Tiles
	     * or tile indexes to place.
	     * @param {integer} tileX - [description]
	     * @param {integer} tileY - [description]
	     * @param {boolean} [recalculateFaces=true] - [description]
	     *
	     * @return {Phaser.Tilemaps.DynamicTilemapLayer} This Tilemap Layer object.
	     */
	    putTilesAt: function (tilesArray, tileX, tileY, recalculateFaces)
	    {
	        TilemapComponents.PutTilesAt(tilesArray, tileX, tileY, recalculateFaces, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
	     * specified layer. Each tile will receive a new index. If an array of indexes is passed in, then
	     * those will be used for randomly assigning new tile indexes. If an array is not provided, the
	     * indexes found within the region (excluding -1) will be used for randomly assigning new tile
	     * indexes. This method only modifies tile indexes and does not change collision information.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#randomize
	     * @since 3.0.0
	     *
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     * @param {integer[]} [indexes] - An array of indexes to randomly draw from during randomization.
	     *
	     * @return {Phaser.Tilemaps.DynamicTilemapLayer} This Tilemap Layer object.
	     */
	    randomize: function (tileX, tileY, width, height, indexes)
	    {
	        TilemapComponents.Randomize(tileX, tileY, width, height, indexes, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Removes the tile at the given tile coordinates in the specified layer and updates the layer's
	     * collision information.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#removeTileAt
	     * @since 3.0.0
	     *
	     * @param {(integer|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
	     * @param {integer} tileX - [description]
	     * @param {integer} tileY - [description]
	     * @param {boolean} [replaceWithNull=true] - If true, this will replace the tile at the specified
	     * location with null instead of a Tile with an index of -1.
	     * @param {boolean} [recalculateFaces=true] - [description]
	     *
	     * @return {Phaser.Tilemaps.Tile} A Tile object.
	     */
	    removeTileAt: function (tileX, tileY, replaceWithNull, recalculateFaces)
	    {
	        return TilemapComponents.RemoveTileAt(tileX, tileY, replaceWithNull, recalculateFaces, this.layer);
	    },
	
	    /**
	     * Removes the tile at the given world coordinates in the specified layer and updates the layer's
	     * collision information.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#removeTileAtWorldXY
	     * @since 3.0.0
	     *
	     * @param {(integer|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
	     * @param {number} worldX - [description]
	     * @param {number} worldY - [description]
	     * @param {boolean} [replaceWithNull=true] - If true, this will replace the tile at the specified
	     * location with null instead of a Tile with an index of -1.
	     * @param {boolean} [recalculateFaces=true] - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     *
	     * @return {Phaser.Tilemaps.Tile} A Tile object.
	     */
	    removeTileAtWorldXY: function (worldX, worldY, replaceWithNull, recalculateFaces, camera)
	    {
	        return TilemapComponents.RemoveTileAtWorldXY(worldX, worldY, replaceWithNull, recalculateFaces, camera, this.layer);
	    },
	
	    /**
	     * Draws a debug representation of the layer to the given Graphics. This is helpful when you want to
	     * get a quick idea of which of your tiles are colliding and which have interesting faces. The tiles
	     * are drawn starting at (0, 0) in the Graphics, allowing you to place the debug representation
	     * wherever you want on the screen.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#renderDebug
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Graphics} graphics - The target Graphics object to draw upon.
	     * @param {object} styleConfig - An object specifying the colors to use for the debug drawing.
	     * @param {?Color} [styleConfig.tileColor=blue] - Color to use for drawing a filled rectangle at
	     * non-colliding tile locations. If set to null, non-colliding tiles will not be drawn.
	     * @param {?Color} [styleConfig.collidingTileColor=orange] - Color to use for drawing a filled
	     * rectangle at colliding tile locations. If set to null, colliding tiles will not be drawn.
	     * @param {?Color} [styleConfig.faceColor=grey] - Color to use for drawing a line at interesting
	     * tile faces. If set to null, interesting tile faces will not be drawn.
	     *
	     * @return {Phaser.Tilemaps.DynamicTilemapLayer} This Tilemap Layer object.
	     */
	    renderDebug: function (graphics, styleConfig)
	    {
	        TilemapComponents.RenderDebug(graphics, styleConfig, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
	     * `findIndex` and updates their index to match `newIndex`. This only modifies the index and does
	     * not change collision information.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#replaceByIndex
	     * @since 3.0.0
	     *
	     * @param {integer} findIndex - [description]
	     * @param {integer} newIndex - [description]
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     *
	     * @return {Phaser.Tilemaps.DynamicTilemapLayer} This Tilemap Layer object.
	     */
	    replaceByIndex: function (findIndex, newIndex, tileX, tileY, width, height)
	    {
	        TilemapComponents.ReplaceByIndex(findIndex, newIndex, tileX, tileY, width, height, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Sets collision on the given tile or tiles within a layer by index. You can pass in either a
	     * single numeric index or an array of indexes: [2, 3, 15, 20]. The `collides` parameter controls if
	     * collision will be enabled (true) or disabled (false).
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#setCollision
	     * @since 3.0.0
	     *
	     * @param {(integer|array)} indexes - Either a single tile index, or an array of tile indexes.
	     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear
	     * collision.
	     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the
	     * update.
	     *
	     * @return {Phaser.Tilemaps.DynamicTilemapLayer} This Tilemap Layer object.
	     */
	    setCollision: function (indexes, collides, recalculateFaces)
	    {
	        TilemapComponents.SetCollision(indexes, collides, recalculateFaces, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Sets collision on a range of tiles in a layer whose index is between the specified `start` and
	     * `stop` (inclusive). Calling this with a start value of 10 and a stop value of 14 would set
	     * collision for tiles 10, 11, 12, 13 and 14. The `collides` parameter controls if collision will be
	     * enabled (true) or disabled (false).
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#setCollisionBetween
	     * @since 3.0.0
	     *
	     * @param {integer} start - The first index of the tile to be set for collision.
	     * @param {integer} stop - The last index of the tile to be set for collision.
	     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear
	     * collision.
	     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the
	     * update.
	     *
	     * @return {Phaser.Tilemaps.DynamicTilemapLayer} This Tilemap Layer object.
	     */
	    setCollisionBetween: function (start, stop, collides, recalculateFaces)
	    {
	        TilemapComponents.SetCollisionBetween(start, stop, collides, recalculateFaces, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Sets collision on the tiles within a layer by checking tile properties. If a tile has a property
	     * that matches the given properties object, its collision flag will be set. The `collides`
	     * parameter controls if collision will be enabled (true) or disabled (false). Passing in
	     * `{ collides: true }` would update the collision flag on any tiles with a "collides" property that
	     * has a value of true. Any tile that doesn't have "collides" set to true will be ignored. You can
	     * also use an array of values, e.g. `{ types: ["stone", "lava", "sand" ] }`. If a tile has a
	     * "types" property that matches any of those values, its collision flag will be updated.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#setCollisionByProperty
	     * @since 3.0.0
	     *
	     * @param {object} properties - An object with tile properties and corresponding values that should
	     * be checked.
	     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear
	     * collision.
	     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the
	     * update.
	     *
	     * @return {Phaser.Tilemaps.DynamicTilemapLayer} This Tilemap Layer object.
	     */
	    setCollisionByProperty: function (properties, collides, recalculateFaces)
	    {
	        TilemapComponents.SetCollisionByProperty(properties, collides, recalculateFaces, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Sets collision on all tiles in the given layer, except for tiles that have an index specified in
	     * the given array. The `collides` parameter controls if collision will be enabled (true) or
	     * disabled (false).
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#setCollisionByExclusion
	     * @since 3.0.0
	     *
	     * @param {integer[]} indexes - An array of the tile indexes to not be counted for collision.
	     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear
	     * collision.
	     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the
	     * update.
	     *
	     * @return {Phaser.Tilemaps.DynamicTilemapLayer} This Tilemap Layer object.
	     */
	    setCollisionByExclusion: function (indexes, collides, recalculateFaces)
	    {
	        TilemapComponents.SetCollisionByExclusion(indexes, collides, recalculateFaces, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Sets collision on the tiles within a layer by checking each tiles collision group data
	     * (typically defined in Tiled within the tileset collision editor). If any objects are found within
	     * a tiles collision group, the tile's colliding information will be set. The `collides` parameter
	     * controls if collision will be enabled (true) or disabled (false).
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#setCollisionFromCollisionGroup
	     * @since 3.0.0
	     *
	     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear
	     * collision.
	     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the
	     * update.
	     *
	     * @return {Phaser.Tilemaps.DynamicTilemapLayer} This Tilemap Layer object.
	     */
	    setCollisionFromCollisionGroup: function (collides, recalculateFaces)
	    {
	        TilemapComponents.SetCollisionFromCollisionGroup(collides, recalculateFaces, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Sets a global collision callback for the given tile index within the layer. This will affect all
	     * tiles on this layer that have the same index. If a callback is already set for the tile index it
	     * will be replaced. Set the callback to null to remove it. If you want to set a callback for a tile
	     * at a specific location on the map then see setTileLocationCallback.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#setTileIndexCallback
	     * @since 3.0.0
	     *
	     * @param {(integer|array)} indexes - Either a single tile index, or an array of tile indexes to have a
	     * collision callback set for.
	     * @param {function} callback - The callback that will be invoked when the tile is collided with.
	     * @param {object} callbackContext - The context under which the callback is called.
	     *
	     * @return {Phaser.Tilemaps.DynamicTilemapLayer} This Tilemap Layer object.
	     */
	    setTileIndexCallback: function (indexes, callback, callbackContext)
	    {
	        TilemapComponents.SetTileIndexCallback(indexes, callback, callbackContext, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Sets a collision callback for the given rectangular area (in tile coordinates) within the layer.
	     * If a callback is already set for the tile index it will be replaced. Set the callback to null to
	     * remove it.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#setTileLocationCallback
	     * @since 3.0.0
	     *
	     * @param {integer} tileX - [description]
	     * @param {integer} tileY - [description]
	     * @param {integer} width - [description]
	     * @param {integer} height - [description]
	     * @param {function} callback - The callback that will be invoked when the tile is collided with.
	     * @param {object} [callbackContext] - The context under which the callback is called.
	     *
	     * @return {Phaser.Tilemaps.DynamicTilemapLayer} This Tilemap Layer object.
	     */
	    setTileLocationCallback: function (tileX, tileY, width, height, callback, callbackContext)
	    {
	        TilemapComponents.SetTileLocationCallback(tileX, tileY, width, height, callback, callbackContext, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Shuffles the tiles in a rectangular region (specified in tile coordinates) within the given
	     * layer. It will only randomize the tiles in that area, so if they're all the same nothing will
	     * appear to have changed! This method only modifies tile indexes and does not change collision
	     * information.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#shuffle
	     * @since 3.0.0
	     *
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     *
	     * @return {Phaser.Tilemaps.DynamicTilemapLayer} This Tilemap Layer object.
	     */
	    shuffle: function (tileX, tileY, width, height)
	    {
	        TilemapComponents.Shuffle(tileX, tileY, width, height, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
	     * `indexA` and swaps then with `indexB`. This only modifies the index and does not change collision
	     * information.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#swapByIndex
	     * @since 3.0.0
	     *
	     * @param {integer} tileA - First tile index.
	     * @param {integer} tileB - Second tile index.
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     *
	     * @return {Phaser.Tilemaps.DynamicTilemapLayer} This Tilemap Layer object.
	     */
	    swapByIndex: function (indexA, indexB, tileX, tileY, width, height)
	    {
	        TilemapComponents.SwapByIndex(indexA, indexB, tileX, tileY, width, height, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Converts from tile X coordinates (tile units) to world X coordinates (pixels), factoring in the
	     * layers position, scale and scroll.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#tileToWorldX
	     * @since 3.0.0
	     *
	     * @param {integer} tileX - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     *
	     * @return {number}
	     */
	    tileToWorldX: function (tileX, camera)
	    {
	        return TilemapComponents.TileToWorldX(tileX, camera, this.layer);
	    },
	
	    /**
	     * Converts from tile Y coordinates (tile units) to world Y coordinates (pixels), factoring in the
	     * layers position, scale and scroll.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#tileToWorldY
	     * @since 3.0.0
	     *
	     * @param {integer} tileY - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     *
	     * @return {number}
	     */
	    tileToWorldY: function (tileY, camera)
	    {
	        return TilemapComponents.TileToWorldY(tileY, camera, this.layer);
	    },
	
	    /**
	     * Converts from tile XY coordinates (tile units) to world XY coordinates (pixels), factoring in the
	     * layers position, scale and scroll. This will return a new Vector2 object or update the given
	     * `point` object.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#tileToWorldXY
	     * @since 3.0.0
	     *
	     * @param {integer} tileX - [description]
	     * @param {integer} tileY - [description]
	     * @param {Phaser.Math.Vector2} [point] - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     *
	     * @return {Phaser.Math.Vector2}
	     */
	    tileToWorldXY: function (tileX, tileY, point, camera)
	    {
	        return TilemapComponents.TileToWorldXY(tileX, tileY, point, camera, this.layer);
	    },
	
	    /**
	     * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
	     * specified layer. Each tile will recieve a new index. New indexes are drawn from the given
	     * weightedIndexes array. An example weighted array:
	     *
	     * [
	     *  { index: 6, weight: 4 },    // Probability of index 6 is 4 / 8
	     *  { index: 7, weight: 2 },    // Probability of index 7 would be 2 / 8
	     *  { index: 8, weight: 1.5 },  // Probability of index 8 would be 1.5 / 8
	     *  { index: 26, weight: 0.5 }  // Probability of index 27 would be 0.5 / 8
	     * ]
	     *
	     * The probability of any index being choose is (the index's weight) / (sum of all weights). This
	     * method only modifies tile indexes and does not change collision information.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#weightedRandomize
	     * @since 3.0.0
	     *
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     * @param {object[]} [weightedIndexes] - An array of objects to randomly draw from during
	     * randomization. They should be in the form: { index: 0, weight: 4 } or
	     * { index: [0, 1], weight: 4 } if you wish to draw from multiple tile indexes.
	     *
	     * @return {Phaser.Tilemaps.DynamicTilemapLayer} This Tilemap Layer object.
	     */
	    weightedRandomize: function (tileX, tileY, width, height, weightedIndexes)
	    {
	        TilemapComponents.WeightedRandomize(tileX, tileY, width, height, weightedIndexes, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Converts from world X coordinates (pixels) to tile X coordinates (tile units), factoring in the
	     * layers position, scale and scroll.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#worldToTileX
	     * @since 3.0.0
	     *
	     * @param {number} worldX - [description]
	     * @param {boolean} [snapToFloor=true] - Whether or not to round the tile coordinate down to the
	     * nearest integer.
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     *
	     * @return {number}
	     */
	    worldToTileX: function (worldX, snapToFloor, camera)
	    {
	        return TilemapComponents.WorldToTileX(worldX, snapToFloor, camera, this.layer);
	    },
	
	    /**
	     * Converts from world Y coordinates (pixels) to tile Y coordinates (tile units), factoring in the
	     * layers position, scale and scroll.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#worldToTileY
	     * @since 3.0.0
	     *
	     * @param {number} worldY - [description]
	     * @param {boolean} [snapToFloor=true] - Whether or not to round the tile coordinate down to the
	     * nearest integer.
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     *
	     * @return {number}
	     */
	    worldToTileY: function (worldY, snapToFloor, camera)
	    {
	        return TilemapComponents.WorldToTileY(worldY, snapToFloor, camera, this.layer);
	    },
	
	    /**
	     * Converts from world XY coordinates (pixels) to tile XY coordinates (tile units), factoring in the
	     * layers position, scale and scroll. This will return a new Vector2 object or update the given
	     * `point` object.
	     *
	     * @method Phaser.Tilemaps.DynamicTilemapLayer#worldToTileXY
	     * @since 3.0.0
	     *
	     * @param {number} worldX - [description]
	     * @param {number} worldY - [description]
	     * @param {boolean} [snapToFloor=true] - Whether or not to round the tile coordinate down to the
	     * nearest integer.
	     * @param {Phaser.Math.Vector2} [point] - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     *
	     * @return {Phaser.Math.Vector2}
	     */
	    worldToTileXY: function (worldX, worldY, snapToFloor, point, camera)
	    {
	        return TilemapComponents.WorldToTileXY(worldX, worldY, snapToFloor, point, camera, this.layer);
	    }
	
	});
	
	module.exports = DynamicTilemapLayer;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var GetFastValue = __webpack_require__(3);
	
	/**
	 * @classdesc
	 * A class for representing a Tiled object layer in a map. This mirrors the structure of a Tiled
	 * object layer, except:
	 *  - "x" & "y" properties are ignored since these cannot be changed in Tiled.
	 *  - "offsetx" & "offsety" are applied to the individual object coordinates directly, so they
	 *    are ignored as well.
	 *  - "draworder" is ignored.
	 *
	 * @class ObjectLayer
	 * @memberOf Phaser.Tilemaps
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {object} [config] - [description]
	 */
	var ObjectLayer = new Class({
	
	    initialize:
	
	    function ObjectLayer (config)
	    {
	        if (config === undefined) { config = {}; }
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.ObjectLayer#name
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.name = GetFastValue(config, 'name', 'object layer');
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.ObjectLayer#opacity
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.opacity = GetFastValue(config, 'opacity', 1);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.ObjectLayer#properties
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.properties = GetFastValue(config, 'properties', {});
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.ObjectLayer#propertyTypes
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.propertyTypes = GetFastValue(config, 'propertytypes', {});
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.ObjectLayer#type
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.type = GetFastValue(config, 'type', 'objectgroup');
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.ObjectLayer#visible
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.visible = GetFastValue(config, 'visible', true);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tilemaps.ObjectLayer#objects
	         * @type {Phaser.GameObjects.GameObject[]}
	         * @since 3.0.0
	         */
	        this.objects = GetFastValue(config, 'objects', []);
	    }
	
	});
	
	module.exports = ObjectLayer;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Formats = __webpack_require__(57);
	var Parse2DArray = __webpack_require__(333);
	var ParseCSV = __webpack_require__(645);
	var ParseJSONTiled = __webpack_require__(648);
	var ParseWeltmeister = __webpack_require__(646);
	
	/**
	 * Parses raw data of a given Tilemap format into a new MapData object. If no recognized data format
	 * is found, returns `null`. When loading from CSV or a 2D array, you should specify the tileWidth &
	 * tileHeight. When parsing from a map from Tiled, the tileWidth & tileHeight will be pulled from
	 * the map data.
	 *
	 * @function Phaser.Tilemaps.Parsers.Parse
	 * @since 3.0.0
	 *
	 * @param {string} name - The name of the tilemap, used to set the name on the MapData.
	 * @param {integer} mapFormat - See ../Formats.js.
	 * @param {(integer[][]|string|object)} data - 2D array, CSV string or Tiled JSON object.
	 * @param {integer} tileWidth - The width of a tile in pixels. Required for 2D array and CSV, but
	 * ignored for Tiled JSON.
	 * @param {integer} tileHeight - The height of a tile in pixels. Required for 2D array and CSV, but
	 * ignored for Tiled JSON.
	 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
	 * data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
	 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
	 * the tile data doesn't need to change then setting this value to `true` will help with memory
	 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
	 * the default value set.
	 *
	 * @return {Phaser.Tilemaps.MapData} [description]
	 */
	var Parse = function (name, mapFormat, data, tileWidth, tileHeight, insertNull)
	{
	    var newMap;
	
	    switch (mapFormat)
	    {
	        case (Formats.ARRAY_2D):
	            newMap = Parse2DArray(name, data, tileWidth, tileHeight, insertNull);
	            break;
	        case (Formats.CSV):
	            newMap = ParseCSV(name, data, tileWidth, tileHeight, insertNull);
	            break;
	        case (Formats.TILED_JSON):
	            newMap = ParseJSONTiled(name, data, insertNull);
	            break;
	        case (Formats.WELTMEISTER):
	            newMap = ParseWeltmeister(name, data, insertNull);
	            break;
	        default:
	            console.warn('Unrecognized tilemap data format: ' + mapFormat);
	            newMap = null;
	    }
	
	    return newMap;
	};
	
	module.exports = Parse;


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Formats = __webpack_require__(57);
	var Parse2DArray = __webpack_require__(333);
	
	/**
	 * Parses a CSV string of tile indexes into a new MapData object with a single layer.
	 *
	 * @function Phaser.Tilemaps.Parsers.ParseCSV
	 * @since 3.0.0
	 *
	 * @param {string} name - The name of the tilemap, used to set the name on the MapData.
	 * @param {string} data - CSV string of tile indexes.
	 * @param {integer} tileWidth - The width of a tile in pixels.
	 * @param {integer} tileHeight - The height of a tile in pixels.
	 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
	 * data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
	 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
	 * the tile data doesn't need to change then setting this value to `true` will help with memory
	 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
	 * the default value set.
	 *
	 * @return {Phaser.Tilemaps.MapData} [description]
	 */
	var ParseCSV = function (name, data, tileWidth, tileHeight, insertNull)
	{
	    var array2D = data
	        .trim()
	        .split('\n')
	        .map(function (row) { return row.split(','); });
	
	    var map = Parse2DArray(name, array2D, tileWidth, tileHeight, insertNull);
	    map.format = Formats.CSV;
	
	    return map;
	};
	
	module.exports = ParseCSV;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Formats = __webpack_require__(57);
	var MapData = __webpack_require__(171);
	var ParseTileLayers = __webpack_require__(1566);
	var ParseTilesets = __webpack_require__(1567);
	
	/**
	 * @namespace Phaser.Tilemaps.Parsers.Impact
	 */
	
	/**
	 * Parses a Weltmeister JSON object into a new MapData object.
	 *
	 * @function Phaser.Tilemaps.Parsers.Impact.ParseWeltmeister
	 * @since 3.0.0
	 *
	 * @param {string} name - The name of the tilemap, used to set the name on the MapData.
	 * @param {object} json - The Weltmeister JSON object.
	 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
	 * data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
	 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
	 * the tile data doesn't need to change then setting this value to `true` will help with memory
	 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
	 * the default value set.
	 *
	 * @return {?object} [description]
	 */
	var ParseWeltmeister = function (name, json, insertNull)
	{
	    if (json.layer.length === 0)
	    {
	        console.warn('No layers found in the Weltmeister map: ' + name);
	        return null;
	    }
	
	    var width = 0;
	    var height = 0;
	
	    for (var i = 0; i < json.layer.length; i++)
	    {
	        if (json.layer[i].width > width) { width = json.layer[i].width; }
	        if (json.layer[i].height > height) { height = json.layer[i].height; }
	    }
	
	    var mapData = new MapData({
	        width: width,
	        height: height,
	        name: name,
	        tileWidth: json.layer[0].tilesize,
	        tileHeight: json.layer[0].tilesize,
	        format: Formats.WELTMEISTER
	    });
	
	    mapData.layers = ParseTileLayers(json, insertNull);
	    mapData.tilesets = ParseTilesets(json);
	
	    return mapData;
	};
	
	module.exports = ParseWeltmeister;


/***/ }),
/* 647 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var FLIPPED_HORIZONTAL = 0x80000000;
	var FLIPPED_VERTICAL = 0x40000000;
	var FLIPPED_ANTI_DIAGONAL = 0x20000000; // Top-right is swapped with bottom-left corners
	
	/**
	 * See Tiled documentation on tile flipping:
	 * http://docs.mapeditor.org/en/latest/reference/tmx-map-format/
	 *
	 * @function Phaser.Tilemaps.Parsers.Tiled.ParseGID
	 * @since 3.0.0
	 *
	 * @param {number} gid - [description]
	 *
	 * @return {object} [description]
	 */
	var ParseGID = function (gid)
	{
	    var flippedHorizontal = Boolean(gid & FLIPPED_HORIZONTAL);
	    var flippedVertical = Boolean(gid & FLIPPED_VERTICAL);
	    var flippedAntiDiagonal = Boolean(gid & FLIPPED_ANTI_DIAGONAL);
	    gid = gid & ~(FLIPPED_HORIZONTAL | FLIPPED_VERTICAL | FLIPPED_ANTI_DIAGONAL);
	
	    // Parse the flip flags into something Phaser can use
	    var rotation = 0;
	    var flipped = false;
	
	    if (flippedHorizontal && flippedVertical && flippedAntiDiagonal)
	    {
	        rotation = Math.PI / 2;
	        flipped = true;
	    }
	    else if (flippedHorizontal && flippedVertical && !flippedAntiDiagonal)
	    {
	        rotation = Math.PI;
	        flipped = false;
	    }
	    else if (flippedHorizontal && !flippedVertical && flippedAntiDiagonal)
	    {
	        rotation = Math.PI / 2;
	        flipped = false;
	    }
	    else if (flippedHorizontal && !flippedVertical && !flippedAntiDiagonal)
	    {
	        rotation = 0;
	        flipped = true;
	    }
	    else if (!flippedHorizontal && flippedVertical && flippedAntiDiagonal)
	    {
	        rotation = 3 * Math.PI / 2;
	        flipped = false;
	    }
	    else if (!flippedHorizontal && flippedVertical && !flippedAntiDiagonal)
	    {
	        rotation = Math.PI;
	        flipped = true;
	    }
	    else if (!flippedHorizontal && !flippedVertical && flippedAntiDiagonal)
	    {
	        rotation = 3 * Math.PI / 2;
	        flipped = true;
	    }
	    else if (!flippedHorizontal && !flippedVertical && !flippedAntiDiagonal)
	    {
	        rotation = 0;
	        flipped = false;
	    }
	
	    return {
	        gid: gid,
	        flippedHorizontal: flippedHorizontal,
	        flippedVertical: flippedVertical,
	        flippedAntiDiagonal: flippedAntiDiagonal,
	        rotation: rotation,
	        flipped: flipped
	    };
	};
	
	module.exports = ParseGID;


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Formats = __webpack_require__(57);
	var MapData = __webpack_require__(171);
	var ParseTileLayers = __webpack_require__(1574);
	var ParseImageLayers = __webpack_require__(1572);
	var ParseTilesets = __webpack_require__(1575);
	var ParseObjectLayers = __webpack_require__(1573);
	var BuildTilesetIndex = __webpack_require__(1571);
	var AssignTileProperties = __webpack_require__(1569);
	
	/**
	 * @namespace Phaser.Tilemaps.Parsers.Tiled
	 */
	
	/**
	 * Parses a Tiled JSON object into a new MapData object.
	 *
	 * @function Phaser.Tilemaps.Parsers.Tiled.ParseJSONTiled
	 * @since 3.0.0
	 *
	 * @param {string} name - The name of the tilemap, used to set the name on the MapData.
	 * @param {object} json - The Tiled JSON object.
	 * @param {boolean} insertNull - Controls how empty tiles, tiles with an index of -1, in the map
	 * data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
	 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
	 * the tile data doesn't need to change then setting this value to `true` will help with memory
	 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
	 * the default value set.
	 *
	 * @return {?Phaser.Tilemaps.MapData} [description]
	 */
	var ParseJSONTiled = function (name, json, insertNull)
	{
	    if (json.orientation !== 'orthogonal')
	    {
	        console.warn('Only orthogonal map types are supported in this version of Phaser');
	        return null;
	    }
	
	    //  Map data will consist of: layers, objects, images, tilesets, sizes
	    var mapData = new MapData({
	        width: json.width,
	        height: json.height,
	        name: name,
	        tileWidth: json.tilewidth,
	        tileHeight: json.tileheight,
	        orientation: json.orientation,
	        format: Formats.TILED_JSON,
	        version: json.version,
	        properties: json.properties
	    });
	
	    mapData.layers = ParseTileLayers(json, insertNull);
	    mapData.images = ParseImageLayers(json);
	
	    var sets = ParseTilesets(json);
	    mapData.tilesets = sets.tilesets;
	    mapData.imageCollections = sets.imageCollections;
	
	    mapData.objects = ParseObjectLayers(json);
	
	    mapData.tiles = BuildTilesetIndex(mapData);
	
	    AssignTileProperties(mapData);
	
	    return mapData;
	};
	
	module.exports = ParseJSONTiled;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Pick = __webpack_require__(1576);
	var ParseGID = __webpack_require__(647);
	
	var copyPoints = function (p) { return { x: p.x, y: p.y }; };
	
	var commonObjectProps = [ 'id', 'name', 'type', 'rotation', 'properties', 'visible', 'x', 'y', 'width', 'height' ];
	
	/**
	 * [description]
	 *
	 * @function Phaser.Tilemaps.Parsers.Tiled.ParseObject
	 * @since 3.0.0
	 *
	 * @param {object} tiledObject - [description]
	 * @param {number} [offsetX=0] - [description]
	 * @param {number} [offsetY=0] - [description]
	 *
	 * @return {object} [description]
	 */
	var ParseObject = function (tiledObject, offsetX, offsetY)
	{
	    if (offsetX === undefined) { offsetX = 0; }
	    if (offsetY === undefined) { offsetY = 0; }
	
	    var parsedObject = Pick(tiledObject, commonObjectProps);
	
	    parsedObject.x += offsetX;
	    parsedObject.y += offsetY;
	
	    if (tiledObject.gid)
	    {
	        //  Object tiles
	        var gidInfo = ParseGID(tiledObject.gid);
	        parsedObject.gid = gidInfo.gid;
	        parsedObject.flippedHorizontal = gidInfo.flippedHorizontal;
	        parsedObject.flippedVertical = gidInfo.flippedVertical;
	        parsedObject.flippedAntiDiagonal = gidInfo.flippedAntiDiagonal;
	    }
	    else if (tiledObject.polyline)
	    {
	        parsedObject.polyline = tiledObject.polyline.map(copyPoints);
	    }
	    else if (tiledObject.polygon)
	    {
	        parsedObject.polygon = tiledObject.polygon.map(copyPoints);
	    }
	    else if (tiledObject.ellipse)
	    {
	        parsedObject.ellipse = tiledObject.ellipse;
	        parsedObject.width = tiledObject.width;
	        parsedObject.height = tiledObject.height;
	    }
	    else if (tiledObject.text)
	    {
	        parsedObject.width = tiledObject.width;
	        parsedObject.height = tiledObject.height;
	        parsedObject.text = tiledObject.text;
	    }
	    else
	    {
	        // Otherwise, assume it is a rectangle
	        parsedObject.rectangle = true;
	        parsedObject.width = tiledObject.width;
	        parsedObject.height = tiledObject.height;
	    }
	
	    return parsedObject;
	};
	
	module.exports = ParseObject;


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Components = __webpack_require__(28);
	var CONST = __webpack_require__(49);
	var GameObject = __webpack_require__(5);
	var StaticTilemapLayerRender = __webpack_require__(1578);
	var TilemapComponents = __webpack_require__(215);
	var Utils = __webpack_require__(87);
	
	/**
	 * @classdesc
	 * A StaticTilemapLayer is a game object that renders LayerData from a Tilemap. A
	 * StaticTilemapLayer can only render tiles from a single tileset.
	 *
	 * A StaticTilemapLayer is optimized for speed over flexibility. You cannot apply per-tile
	 * effects like tint or alpha. You cannot change the tiles in a StaticTilemapLayer. Use this
	 * over a DynamicTilemapLayer when you don't need either of those features.
	 *
	 * @class StaticTilemapLayer
	 * @extends Phaser.GameObjects.GameObject
	 * @memberOf Phaser.Tilemaps
	 * @constructor
	 * @since 3.0.0
	 *
	 * @extends Phaser.GameObjects.Components.Alpha
	 * @extends Phaser.GameObjects.Components.BlendMode
	 * @extends Phaser.GameObjects.Components.ComputedSize
	 * @extends Phaser.GameObjects.Components.Depth
	 * @extends Phaser.GameObjects.Components.Flip
	 * @extends Phaser.GameObjects.Components.GetBounds
	 * @extends Phaser.GameObjects.Components.Origin
	 * @extends Phaser.GameObjects.Components.Pipeline
	 * @extends Phaser.GameObjects.Components.ScaleMode
	 * @extends Phaser.GameObjects.Components.Transform
	 * @extends Phaser.GameObjects.Components.Visible
	 * @extends Phaser.GameObjects.Components.ScrollFactor
	 *
	 * @param {Phaser.Scene} scene - [description]
	 * @param {Phaser.Tilemaps.Tilemap} tilemap - The Tilemap this layer is a part of.
	 * @param {integer} layerIndex - The index of the LayerData associated with this layer.
	 * @param {Phaser.Tilemaps.Tileset} tileset - The tileset used to render the tiles in this layer.
	 * @param {number} [x=0] - The world x position where the top left of this layer will be placed.
	 * @param {number} [y=0] - The world y position where the top left of this layer will be placed.
	 */
	var StaticTilemapLayer = new Class({
	
	    Extends: GameObject,
	
	    Mixins: [
	        Components.Alpha,
	        Components.BlendMode,
	        Components.ComputedSize,
	        Components.Depth,
	        Components.Flip,
	        Components.GetBounds,
	        Components.Origin,
	        Components.Pipeline,
	        Components.ScaleMode,
	        Components.Transform,
	        Components.Visible,
	        Components.ScrollFactor,
	        StaticTilemapLayerRender
	    ],
	
	    initialize:
	
	    function StaticTilemapLayer (scene, tilemap, layerIndex, tileset, x, y)
	    {
	        GameObject.call(this, scene, 'StaticTilemapLayer');
	
	        /**
	         * Used internally by physics system to perform fast type checks.
	         *
	         * @name Phaser.Tilemaps.StaticTilemapLayer#isTilemap
	         * @type {boolean}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.isTilemap = true;
	
	        /**
	         * The Tilemap that this layer is a part of.
	         *
	         * @name Phaser.Tilemaps.StaticTilemapLayer#tilemap
	         * @type {Phaser.Tilemaps.Tilemap}
	         * @since 3.0.0
	         */
	        this.tilemap = tilemap;
	
	        /**
	         * The index of the LayerData associated with this layer.
	         *
	         * @name Phaser.Tilemaps.StaticTilemapLayer#layerIndex
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.layerIndex = layerIndex;
	
	        /**
	         * The LayerData associated with this layer. LayerData can only be associated with one
	         * tilemap layer.
	         *
	         * @name Phaser.Tilemaps.StaticTilemapLayer#layer
	         * @type {Phaser.Tilemaps.LayerData}
	         * @since 3.0.0
	         */
	        this.layer = tilemap.layers[layerIndex];
	
	        this.layer.tilemapLayer = this; // Link the LayerData with this static tilemap layer
	
	        /**
	         * The Tileset associated with this layer. A tilemap layer can only render from one Tileset.
	         *
	         * @name Phaser.Tilemaps.StaticTilemapLayer#tileset
	         * @type {Phaser.Tilemaps.Tileset}
	         * @since 3.0.0
	         */
	        this.tileset = tileset;
	
	        /**
	         * Used internally with the canvas render. This holds the tiles that are visible within the
	         * camera.
	         *
	         * @name Phaser.Tilemaps.StaticTilemapLayer#culledTiles
	         * @type {array}
	         * @since 3.0.0
	         */
	        this.culledTiles = [];
	
	        /**
	         * @name Phaser.Tilemaps.StaticTilemapLayer#vertexBuffer
	         * @type {array}
	         * @private
	         * @since 3.0.0
	         */
	        this.vertexBuffer = null;
	
	        /**
	         * @name Phaser.Tilemaps.StaticTilemapLayer#renderer
	         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
	         * @private
	         * @since 3.0.0
	         */
	        this.renderer = scene.sys.game.renderer;
	
	        /**
	         * @name Phaser.Tilemaps.StaticTilemapLayer#bufferData
	         * @type {ArrayBuffer}
	         * @private
	         * @since 3.0.0
	         */
	        this.bufferData = null;
	
	        /**
	         * @name Phaser.Tilemaps.StaticTilemapLayer#vertexViewF32
	         * @type {Float32Array}
	         * @private
	         * @since 3.0.0
	         */
	        this.vertexViewF32 = null;
	
	        /**
	         * @name Phaser.Tilemaps.StaticTilemapLayer#vertexViewU32
	         * @type {Uint32Array}
	         * @private
	         * @since 3.0.0
	         */
	        this.vertexViewU32 = null;
	
	        /**
	         * @name Phaser.Tilemaps.StaticTilemapLayer#dirty
	         * @type {boolean}
	         * @private
	         * @since 3.0.0
	         */
	        this.dirty = true;
	
	        /**
	         * @name Phaser.Tilemaps.StaticTilemapLayer#vertexCount
	         * @type {integer}
	         * @private
	         * @since 3.0.0
	         */
	        this.vertexCount = 0;
	
	        this.setAlpha(this.layer.alpha);
	        this.setPosition(x, y);
	        this.setOrigin();
	        this.setSize(this.layer.tileWidth * this.layer.width, this.layer.tileHeight * this.layer.height);
	
	        this.initPipeline('TextureTintPipeline');
	
	        if (scene.sys.game.config.renderType === CONST.WEBGL)
	        {
	            scene.sys.game.renderer.onContextRestored(function ()
	            {
	                this.dirty = true;
	                this.vertexBuffer = null;
	            }, this);
	        }
	    },
	
	    /**
	     * Upload the tile data to a VBO.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#upload
	     * @since 3.0.0
	     *
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera to render to.
	     *
	     * @return {Phaser.Tilemaps.StaticTilemapLayer} This Tilemap Layer object.
	     */
	    upload: function (camera)
	    {
	        var tileset = this.tileset;
	        var mapWidth = this.layer.width;
	        var mapHeight = this.layer.height;
	        var width = tileset.image.source[0].width;
	        var height = tileset.image.source[0].height;
	        var mapData = this.layer.data;
	        var renderer = this.renderer;
	        var tile;
	        var row;
	        var col;
	        var texCoords;
	
	        if (renderer.gl)
	        {
	            var pipeline = renderer.pipelines.TextureTintPipeline;
	
	            if (this.dirty)
	            {
	                var gl = renderer.gl;
	                var vertexBuffer = this.vertexBuffer;
	                var bufferData = this.bufferData;
	                var voffset = 0;
	                var vertexCount = 0;
	                var bufferSize = (mapWidth * mapHeight) * pipeline.vertexSize * 6;
	
	                if (bufferData === null)
	                {
	                    bufferData = new ArrayBuffer(bufferSize);
	                    this.bufferData = bufferData;
	                    this.vertexViewF32 = new Float32Array(bufferData);
	                    this.vertexViewU32 = new Uint32Array(bufferData);
	                }
	
	                var vertexViewF32 = this.vertexViewF32;
	                var vertexViewU32 = this.vertexViewU32;
	
	                for (row = 0; row < mapHeight; ++row)
	                {
	                    for (col = 0; col < mapWidth; ++col)
	                    {
	                        tile = mapData[row][col];
	                        if (tile === null || tile.index === -1) { continue; }
	
	                        var tx = tile.pixelX;
	                        var ty = tile.pixelY;
	                        var txw = tx + tile.width;
	                        var tyh = ty + tile.height;
	
	                        texCoords = tileset.getTileTextureCoordinates(tile.index);
	                        if (texCoords === null) { continue; }
	
	                        var u0 = texCoords.x / width;
	                        var v0 = texCoords.y / height;
	                        var u1 = (texCoords.x + tile.width) / width;
	                        var v1 = (texCoords.y + tile.height) / height;
	
	                        var tx0 = tx;
	                        var ty0 = ty;
	                        var tx1 = tx;
	                        var ty1 = tyh;
	                        var tx2 = txw;
	                        var ty2 = tyh;
	                        var tx3 = txw;
	                        var ty3 = ty;
	                        var tint = Utils.getTintAppendFloatAlpha(0xffffff, this.alpha * tile.alpha);
	
	                        vertexViewF32[voffset + 0] = tx0;
	                        vertexViewF32[voffset + 1] = ty0;
	                        vertexViewF32[voffset + 2] = u0;
	                        vertexViewF32[voffset + 3] = v0;
	                        vertexViewU32[voffset + 4] = tint;
	                        vertexViewF32[voffset + 5] = tx1;
	                        vertexViewF32[voffset + 6] = ty1;
	                        vertexViewF32[voffset + 7] = u0;
	                        vertexViewF32[voffset + 8] = v1;
	                        vertexViewU32[voffset + 9] = tint;
	                        vertexViewF32[voffset + 10] = tx2;
	                        vertexViewF32[voffset + 11] = ty2;
	                        vertexViewF32[voffset + 12] = u1;
	                        vertexViewF32[voffset + 13] = v1;
	                        vertexViewU32[voffset + 14] = tint;
	                        vertexViewF32[voffset + 15] = tx0;
	                        vertexViewF32[voffset + 16] = ty0;
	                        vertexViewF32[voffset + 17] = u0;
	                        vertexViewF32[voffset + 18] = v0;
	                        vertexViewU32[voffset + 19] = tint;
	                        vertexViewF32[voffset + 20] = tx2;
	                        vertexViewF32[voffset + 21] = ty2;
	                        vertexViewF32[voffset + 22] = u1;
	                        vertexViewF32[voffset + 23] = v1;
	                        vertexViewU32[voffset + 24] = tint;
	                        vertexViewF32[voffset + 25] = tx3;
	                        vertexViewF32[voffset + 26] = ty3;
	                        vertexViewF32[voffset + 27] = u1;
	                        vertexViewF32[voffset + 28] = v0;
	                        vertexViewU32[voffset + 29] = tint;
	
	                        voffset += 30;
	                        vertexCount += 6;
	                    }
	                }
	
	                this.vertexCount = vertexCount;
	                this.dirty = false;
	                if (vertexBuffer === null)
	                {
	                    vertexBuffer = renderer.createVertexBuffer(bufferData, gl.STATIC_DRAW);
	                    this.vertexBuffer = vertexBuffer;
	                }
	                else
	                {
	                    renderer.setVertexBuffer(vertexBuffer);
	                    gl.bufferSubData(gl.ARRAY_BUFFER, 0, bufferData);
	                }
	            }
	
	            pipeline.modelIdentity();
	            pipeline.modelTranslate(this.x - (camera.scrollX * this.scrollFactorX), this.y - (camera.scrollY * this.scrollFactorY), 0.0);
	            pipeline.modelScale(this.scaleX, this.scaleY, 1.0);
	            pipeline.viewLoad2D(camera.matrix.matrix);
	        }
	
	        return this;
	    },
	
	    /**
	     * Calculates interesting faces at the given tile coordinates of the specified layer. Interesting
	     * faces are used internally for optimizing collisions against tiles. This method is mostly used
	     * internally to optimize recalculating faces when only one tile has been changed.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#calculateFacesAt
	     * @since 3.0.0
	     *
	     * @param {integer} tileX - The x coordinate.
	     * @param {integer} tileY - The y coordinate.
	     *
	     * @return {Phaser.Tilemaps.StaticTilemapLayer} This Tilemap Layer object.
	     */
	    calculateFacesAt: function (tileX, tileY)
	    {
	        TilemapComponents.CalculateFacesAt(tileX, tileY, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Calculates interesting faces within the rectangular area specified (in tile coordinates) of the
	     * layer. Interesting faces are used internally for optimizing collisions against tiles. This method
	     * is mostly used internally.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#calculateFacesWithin
	     * @since 3.0.0
	     *
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     *
	     * @return {Phaser.Tilemaps.StaticTilemapLayer} This Tilemap Layer object.
	     */
	    calculateFacesWithin: function (tileX, tileY, width, height)
	    {
	        TilemapComponents.CalculateFacesWithin(tileX, tileY, width, height, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Creates a Sprite for every object matching the given tile indexes in the layer. You can
	     * optionally specify if each tile will be replaced with a new tile after the Sprite has been
	     * created. This is useful if you want to lay down special tiles in a level that are converted to
	     * Sprites, but want to replace the tile itself with a floor tile or similar once converted.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#createFromTiles
	     * @since 3.0.0
	     *
	     * @param {(integer|array)} indexes - The tile index, or array of indexes, to create Sprites from.
	     * @param {(integer|array)} replacements - The tile index, or array of indexes, to change a converted
	     * tile to. Set to `null` to leave the tiles unchanged. If an array is given, it is assumed to be a
	     * one-to-one mapping with the indexes array.
	     * @param {object} spriteConfig - The config object to pass into the Sprite creator (i.e.
	     * scene.make.sprite).
	     * @param {Phaser.Scene} [scene=scene the map is within] - The Scene to create the Sprites within.
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - The Camera to use when determining the world XY
	     *
	     * @return {Phaser.GameObjects.Sprite[]} An array of the Sprites that were created.
	     */
	    createFromTiles: function (indexes, replacements, spriteConfig, scene, camera)
	    {
	        return TilemapComponents.CreateFromTiles(indexes, replacements, spriteConfig, scene, camera, this.layer);
	    },
	
	    /**
	     * Returns the tiles in the given layer that are within the cameras viewport.
	     * This is used internally.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#cull
	     * @since 3.0.0
	     *
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to run the cull check against.
	     *
	     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
	     */
	    cull: function (camera)
	    {
	        return TilemapComponents.CullTiles(this.layer, camera, this.culledTiles);
	    },
	
	    /**
	     * Destroys this StaticTilemapLayer and removes its link to the associated LayerData.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        // Uninstall this layer only if it is still installed on the LayerData object
	        if (this.layer.tilemapLayer === this)
	        {
	            this.layer.tilemapLayer = undefined;
	        }
	
	        this.tilemap = undefined;
	        this.layer = undefined;
	        this.tileset = undefined;
	
	        GameObject.prototype.destroy.call(this);
	    },
	
	    /**
	     * Searches the entire map layer for the first tile matching the given index, then returns that Tile
	     * object. If no match is found, it returns null. The search starts from the top-left tile and
	     * continues horizontally until it hits the end of the row, then it drops down to the next column.
	     * If the reverse boolean is true, it scans starting from the bottom-right corner traveling up to
	     * the top-left.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#findByIndex
	     * @since 3.0.0
	     *
	     * @param {integer} index - The tile index value to search for.
	     * @param {integer} [skip=0] - The number of times to skip a matching tile before returning.
	     * @param {boolean} [reverse=false] - If true it will scan the layer in reverse, starting at the
	     * bottom-right. Otherwise it scans from the top-left.
	     *
	     * @return {Phaser.Tilemaps.Tile} A Tile object.
	     */
	    findByIndex: function (findIndex, skip, reverse)
	    {
	        return TilemapComponents.FindByIndex(findIndex, skip, reverse, this.layer);
	    },
	
	    /**
	     * Find the first tile in the given rectangular area (in tile coordinates) of the layer that
	     * satisfies the provided testing function. I.e. finds the first tile for which `callback` returns
	     * true. Similar to Array.prototype.find in vanilla JS.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#findTile
	     * @since 3.0.0
	     *
	     * @param {function} callback - The callback. Each tile in the given area will be passed to this
	     * callback as the first and only parameter.
	     * @param {object} [context] - The context under which the callback should be run.
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	     * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	     * -1 for an index.
	     * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide
	     * on at least one side.
	     * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	     * have at least one interesting face.
	     *
	     * @return {?Phaser.Tilemaps.Tile}
	     */
	    findTile: function (callback, context, tileX, tileY, width, height, filteringOptions)
	    {
	        return TilemapComponents.FindTile(callback, context, tileX, tileY, width, height, filteringOptions, this.layer);
	    },
	
	    /**
	     * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
	     * filter callback function. Any tiles that pass the filter test (i.e. where the callback returns
	     * true) will returned as a new array. Similar to Array.prototype.Filter in vanilla JS.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#filterTiles
	     * @since 3.0.0
	     *
	     * @param {function} callback - The callback. Each tile in the given area will be passed to this
	     * callback as the first and only parameter. The callback should return true for tiles that pass the
	     * filter.
	     * @param {object} [context] - The context under which the callback should be run.
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	     * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	     * -1 for an index.
	     * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide
	     * on at least one side.
	     * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	     * have at least one interesting face.
	     *
	     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
	     */
	    filterTiles: function (callback, context, tileX, tileY, width, height, filteringOptions)
	    {
	        return TilemapComponents.FilterTiles(callback, context, tileX, tileY, width, height, filteringOptions, this.layer);
	    },
	
	    /**
	     * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
	     * callback. Similar to Array.prototype.forEach in vanilla JS.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#forEachTile
	     * @since 3.0.0
	     *
	     * @param {function} callback - The callback. Each tile in the given area will be passed to this
	     * callback as the first and only parameter.
	     * @param {object} [context] - The context under which the callback should be run.
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	     * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	     * -1 for an index.
	     * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide
	     * on at least one side.
	     * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	     * have at least one interesting face.
	     *
	     * @return {Phaser.Tilemaps.StaticTilemapLayer} This Tilemap Layer object.
	     */
	    forEachTile: function (callback, context, tileX, tileY, width, height, filteringOptions)
	    {
	        TilemapComponents.ForEachTile(callback, context, tileX, tileY, width, height, filteringOptions, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Gets a tile at the given tile coordinates from the given layer.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#getTileAt
	     * @since 3.0.0
	     *
	     * @param {integer} tileX - X position to get the tile from (given in tile units, not pixels).
	     * @param {integer} tileY - Y position to get the tile from (given in tile units, not pixels).
	     * @param {boolean} [nonNull=false] - If true getTile won't return null for empty tiles, but a Tile
	     * object with an index of -1.
	     *
	     * @return {Phaser.Tilemaps.Tile} The tile at the given coordinates or null if no tile was found or the coordinates were invalid.
	     */
	    getTileAt: function (tileX, tileY, nonNull)
	    {
	        return TilemapComponents.GetTileAt(tileX, tileY, nonNull, this.layer);
	    },
	
	    /**
	     * Gets a tile at the given world coordinates from the given layer.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#getTileAtWorldXY
	     * @since 3.0.0
	     *
	     * @param {number} worldX - X position to get the tile from (given in pixels)
	     * @param {number} worldY - Y position to get the tile from (given in pixels)
	     * @param {boolean} [nonNull=false] - If true, function won't return null for empty tiles, but a Tile
	     * object with an index of -1.
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     *
	     * @return {Phaser.Tilemaps.Tile} The tile at the given coordinates or null if no tile was found or the coordinates
	     * were invalid.
	     */
	    getTileAtWorldXY: function (worldX, worldY, nonNull, camera)
	    {
	        return TilemapComponents.GetTileAtWorldXY(worldX, worldY, nonNull, camera, this.layer);
	    },
	
	    /**
	     * Gets the tiles in the given rectangular area (in tile coordinates) of the layer.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#getTilesWithin
	     * @since 3.0.0
	     *
	     * @param {integer} [tileX=0] - [description]
	     * @param {integer} [tileY=0] - [description]
	     * @param {integer} [width=max width based on tileX] - [description]
	     * @param {integer} [height=max height based on tileY] - [description]
	     * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	     * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	     * -1 for an index.
	     * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide on
	     * at least one side.
	     * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	     * have at least one interesting face.
	     *
	     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
	     */
	    getTilesWithin: function (tileX, tileY, width, height, filteringOptions)
	    {
	        return TilemapComponents.GetTilesWithin(tileX, tileY, width, height, filteringOptions, this.layer);
	    },
	
	    /**
	     * Gets the tiles in the given rectangular area (in world coordinates) of the layer.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#getTilesWithinWorldXY
	     * @since 3.0.0
	     *
	     * @param {number} worldX - [description]
	     * @param {number} worldY - [description]
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	     * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	     * -1 for an index.
	     * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide on
	     * at least one side.
	     * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	     * have at least one interesting face.
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     *
	     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
	     */
	    getTilesWithinWorldXY: function (worldX, worldY, width, height, filteringOptions, camera)
	    {
	        return TilemapComponents.GetTilesWithinWorldXY(worldX, worldY, width, height, filteringOptions, camera, this.layer);
	    },
	
	    /**
	     * Gets the tiles that overlap with the given shape in the given layer. The shape must be a Circle,
	     * Line, Rectangle or Triangle. The shape should be in world coordinates.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#getTilesWithinShape
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Geom.Circle|Phaser.Geom.Line|Phaser.Geom.Rectangle|Phaser.Geom.Triangle)} shape - A shape in world (pixel) coordinates
	     * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	     * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	     * -1 for an index.
	     * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide on
	     * at least one side.
	     * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	     * have at least one interesting face.
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     *
	     * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
	     */
	    getTilesWithinShape: function (shape, filteringOptions, camera)
	    {
	        return TilemapComponents.GetTilesWithinShape(shape, filteringOptions, camera, this.layer);
	    },
	
	    /**
	     * Checks if there is a tile at the given location (in tile coordinates) in the given layer. Returns
	     * false if there is no tile or if the tile at that location has an index of -1.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#hasTileAt
	     * @since 3.0.0
	     *
	     * @param {integer} tileX - [description]
	     * @param {integer} tileY - [description]
	     *
	     * @return {boolean}
	     */
	    hasTileAt: function (tileX, tileY)
	    {
	        return TilemapComponents.HasTileAt(tileX, tileY, this.layer);
	    },
	
	    /**
	     * Checks if there is a tile at the given location (in world coordinates) in the given layer. Returns
	     * false if there is no tile or if the tile at that location has an index of -1.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#hasTileAtWorldXY
	     * @since 3.0.0
	     *
	     * @param {number} worldX - [description]
	     * @param {number} worldY - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     *
	     * @return {boolean}
	     */
	    hasTileAtWorldXY: function (worldX, worldY, camera)
	    {
	        return TilemapComponents.HasTileAtWorldXY(worldX, worldY, camera, this.layer);
	    },
	
	    /**
	     * Draws a debug representation of the layer to the given Graphics. This is helpful when you want to
	     * get a quick idea of which of your tiles are colliding and which have interesting faces. The tiles
	     * are drawn starting at (0, 0) in the Graphics, allowing you to place the debug representation
	     * wherever you want on the screen.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#renderDebug
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Graphics} graphics - The target Graphics object to draw upon.
	     * @param {object} styleConfig - An object specifying the colors to use for the debug drawing.
	     * @param {?Color} [styleConfig.tileColor=blue] - Color to use for drawing a filled rectangle at
	     * non-colliding tile locations. If set to null, non-colliding tiles will not be drawn.
	     * @param {?Color} [styleConfig.collidingTileColor=orange] - Color to use for drawing a filled
	     * rectangle at colliding tile locations. If set to null, colliding tiles will not be drawn.
	     * @param {?Color} [styleConfig.faceColor=grey] - Color to use for drawing a line at interesting
	     * tile faces. If set to null, interesting tile faces will not be drawn.
	     *
	     * @return {Phaser.Tilemaps.StaticTilemapLayer} This Tilemap Layer object.
	     */
	    renderDebug: function (graphics, styleConfig)
	    {
	        TilemapComponents.RenderDebug(graphics, styleConfig, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Sets collision on the given tile or tiles within a layer by index. You can pass in either a
	     * single numeric index or an array of indexes: [2, 3, 15, 20]. The `collides` parameter controls if
	     * collision will be enabled (true) or disabled (false).
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#setCollision
	     * @since 3.0.0
	     *
	     * @param {(integer|array)} indexes - Either a single tile index, or an array of tile indexes.
	     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear
	     * collision.
	     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the
	     * update.
	     *
	     * @return {Phaser.Tilemaps.StaticTilemapLayer} This Tilemap Layer object.
	     */
	    setCollision: function (indexes, collides, recalculateFaces)
	    {
	        TilemapComponents.SetCollision(indexes, collides, recalculateFaces, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Sets collision on a range of tiles in a layer whose index is between the specified `start` and
	     * `stop` (inclusive). Calling this with a start value of 10 and a stop value of 14 would set
	     * collision for tiles 10, 11, 12, 13 and 14. The `collides` parameter controls if collision will be
	     * enabled (true) or disabled (false).
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#setCollisionBetween
	     * @since 3.0.0
	     *
	     * @param {integer} start - The first index of the tile to be set for collision.
	     * @param {integer} stop - The last index of the tile to be set for collision.
	     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear
	     * collision.
	     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the
	     * update.
	     *
	     * @return {Phaser.Tilemaps.StaticTilemapLayer} This Tilemap Layer object.
	     */
	    setCollisionBetween: function (start, stop, collides, recalculateFaces)
	    {
	        TilemapComponents.SetCollisionBetween(start, stop, collides, recalculateFaces, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Sets collision on the tiles within a layer by checking tile properties. If a tile has a property
	     * that matches the given properties object, its collision flag will be set. The `collides`
	     * parameter controls if collision will be enabled (true) or disabled (false). Passing in
	     * `{ collides: true }` would update the collision flag on any tiles with a "collides" property that
	     * has a value of true. Any tile that doesn't have "collides" set to true will be ignored. You can
	     * also use an array of values, e.g. `{ types: ["stone", "lava", "sand" ] }`. If a tile has a
	     * "types" property that matches any of those values, its collision flag will be updated.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#setCollisionByProperty
	     * @since 3.0.0
	     *
	     * @param {object} properties - An object with tile properties and corresponding values that should
	     * be checked.
	     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear
	     * collision.
	     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the
	     * update.
	     *
	     * @return {Phaser.Tilemaps.StaticTilemapLayer} This Tilemap Layer object.
	     */
	    setCollisionByProperty: function (properties, collides, recalculateFaces)
	    {
	        TilemapComponents.SetCollisionByProperty(properties, collides, recalculateFaces, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Sets collision on all tiles in the given layer, except for tiles that have an index specified in
	     * the given array. The `collides` parameter controls if collision will be enabled (true) or
	     * disabled (false).
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#setCollisionByExclusion
	     * @since 3.0.0
	     *
	     * @param {integer[]} indexes - An array of the tile indexes to not be counted for collision.
	     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear
	     * collision.
	     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the
	     * update.
	     *
	     * @return {Phaser.Tilemaps.StaticTilemapLayer} This Tilemap Layer object.
	     */
	    setCollisionByExclusion: function (indexes, collides, recalculateFaces)
	    {
	        TilemapComponents.SetCollisionByExclusion(indexes, collides, recalculateFaces, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Sets a global collision callback for the given tile index within the layer. This will affect all
	     * tiles on this layer that have the same index. If a callback is already set for the tile index it
	     * will be replaced. Set the callback to null to remove it. If you want to set a callback for a tile
	     * at a specific location on the map then see setTileLocationCallback.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#setTileIndexCallback
	     * @since 3.0.0
	     *
	     * @param {(integer|array)} indexes - Either a single tile index, or an array of tile indexes to have a
	     * collision callback set for.
	     * @param {function} callback - The callback that will be invoked when the tile is collided with.
	     * @param {object} callbackContext - The context under which the callback is called.
	     *
	     * @return {Phaser.Tilemaps.StaticTilemapLayer} This Tilemap Layer object.
	     */
	    setTileIndexCallback: function (indexes, callback, callbackContext)
	    {
	        TilemapComponents.SetTileIndexCallback(indexes, callback, callbackContext, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Sets collision on the tiles within a layer by checking each tiles collision group data
	     * (typically defined in Tiled within the tileset collision editor). If any objects are found within
	     * a tiles collision group, the tile's colliding information will be set. The `collides` parameter
	     * controls if collision will be enabled (true) or disabled (false).
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#setCollisionFromCollisionGroup
	     * @since 3.0.0
	     *
	     * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear
	     * collision.
	     * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the
	     * update.
	     *
	     * @return {Phaser.Tilemaps.StaticTilemapLayer} This Tilemap Layer object.
	     */
	    setCollisionFromCollisionGroup: function (collides, recalculateFaces)
	    {
	        TilemapComponents.SetCollisionFromCollisionGroup(collides, recalculateFaces, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Sets a collision callback for the given rectangular area (in tile coordinates) within the layer.
	     * If a callback is already set for the tile index it will be replaced. Set the callback to null to
	     * remove it.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#setTileLocationCallback
	     * @since 3.0.0
	     *
	     * @param {integer} tileX - [description]
	     * @param {integer} tileY - [description]
	     * @param {integer} width - [description]
	     * @param {integer} height - [description]
	     * @param {function} callback - The callback that will be invoked when the tile is collided with.
	     * @param {object} [callbackContext] - The context under which the callback is called.
	     *
	     * @return {Phaser.Tilemaps.StaticTilemapLayer} This Tilemap Layer object.
	     */
	    setTileLocationCallback: function (tileX, tileY, width, height, callback, callbackContext)
	    {
	        TilemapComponents.SetTileLocationCallback(tileX, tileY, width, height, callback, callbackContext, this.layer);
	
	        return this;
	    },
	
	    /**
	     * Converts from tile X coordinates (tile units) to world X coordinates (pixels), factoring in the
	     * layers position, scale and scroll.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#tileToWorldX
	     * @since 3.0.0
	     *
	     * @param {integer} tileX - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     *
	     * @return {number}
	     */
	    tileToWorldX: function (tileX, camera)
	    {
	        return TilemapComponents.TileToWorldX(tileX, camera, this.layer);
	    },
	
	    /**
	     * Converts from tile Y coordinates (tile units) to world Y coordinates (pixels), factoring in the
	     * layers position, scale and scroll.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#tileToWorldY
	     * @since 3.0.0
	     *
	     * @param {integer} tileY - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     *
	     * @return {number}
	     */
	    tileToWorldY: function (tileY, camera)
	    {
	        return TilemapComponents.TileToWorldY(tileY, camera, this.layer);
	    },
	
	    /**
	     * Converts from tile XY coordinates (tile units) to world XY coordinates (pixels), factoring in the
	     * layers position, scale and scroll. This will return a new Vector2 object or update the given
	     * `point` object.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#tileToWorldXY
	     * @since 3.0.0
	     *
	     * @param {integer} tileX - [description]
	     * @param {integer} tileY - [description]
	     * @param {Phaser.Math.Vector2} [point] - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     *
	     * @return {Phaser.Math.Vector2}
	     */
	    tileToWorldXY: function (tileX, tileY, point, camera)
	    {
	        return TilemapComponents.TileToWorldXY(tileX, tileY, point, camera, this.layer);
	    },
	
	    /**
	     * Converts from world X coordinates (pixels) to tile X coordinates (tile units), factoring in the
	     * layers position, scale and scroll.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#worldToTileX
	     * @since 3.0.0
	     *
	     * @param {number} worldX - [description]
	     * @param {boolean} [snapToFloor=true] - Whether or not to round the tile coordinate down to the
	     * nearest integer.
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     *
	     * @return {number}
	     */
	    worldToTileX: function (worldX, snapToFloor, camera)
	    {
	        return TilemapComponents.WorldToTileX(worldX, snapToFloor, camera, this.layer);
	    },
	
	    /**
	     * Converts from world Y coordinates (pixels) to tile Y coordinates (tile units), factoring in the
	     * layers position, scale and scroll.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#worldToTileY
	     * @since 3.0.0
	     *
	     * @param {number} worldY - [description]
	     * @param {boolean} [snapToFloor=true] - Whether or not to round the tile coordinate down to the
	     * nearest integer.
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     *
	     * @return {number}
	     */
	    worldToTileY: function (worldY, snapToFloor, camera)
	    {
	        return TilemapComponents.WorldToTileY(worldY, snapToFloor, camera, this.layer);
	    },
	
	    /**
	     * Converts from world XY coordinates (pixels) to tile XY coordinates (tile units), factoring in the
	     * layers position, scale and scroll. This will return a new Vector2 object or update the given
	     * `point` object.
	     *
	     * @method Phaser.Tilemaps.StaticTilemapLayer#worldToTileXY
	     * @since 3.0.0
	     *
	     * @param {number} worldX - [description]
	     * @param {number} worldY - [description]
	     * @param {boolean} [snapToFloor=true] - Whether or not to round the tile coordinate down to the
	     * nearest integer.
	     * @param {Phaser.Math.Vector2} [point] - [description]
	     * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	     *
	     * @return {Phaser.Math.Vector2}
	     */
	    worldToTileXY: function (worldX, worldY, snapToFloor, point, camera)
	    {
	        return TilemapComponents.WorldToTileXY(worldX, worldY, snapToFloor, point, camera, this.layer);
	    }
	
	});
	
	module.exports = StaticTilemapLayer;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var GetFastValue = __webpack_require__(3);
	
	/**
	 * @typedef {object} TimerEventConfig
	 *
	 * @property {number} [delay=0] - [description]
	 * @property {number} [repeat=0] - [description]
	 * @property {boolean} [loop=false] - [description]
	 * @property {function} [callback] - [description]
	 * @property {*} [callbackScope] - [description]
	 * @property {Array.<*>} [args] - [description]
	 * @property {number} [timeScale=1] - [description]
	 * @property {number} [startAt=1] - [description]
	 * @property {boolean} [paused=false] - [description]
	 */
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class TimerEvent
	 * @memberOf Phaser.Time
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {TimerEventConfig} config - [description]
	 */
	var TimerEvent = new Class({
	
	    initialize:
	
	    function TimerEvent (config)
	    {
	        /**
	         * The delay in ms at which this TimerEvent fires.
	         *
	         * @name Phaser.Time.TimerEvent#delay
	         * @type {number}
	         * @default 0
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.delay = 0;
	
	        /**
	         * The total number of times this TimerEvent will repeat before finishing.
	         *
	         * @name Phaser.Time.TimerEvent#repeat
	         * @type {number}
	         * @default 0
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.repeat = 0;
	
	        /**
	         * If repeating this contains the current repeat count.
	         *
	         * @name Phaser.Time.TimerEvent#repeatCount
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.repeatCount = 0;
	
	        /**
	         * True if this TimerEvent loops, otherwise false.
	         *
	         * @name Phaser.Time.TimerEvent#loop
	         * @type {boolean}
	         * @default false
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.loop = false;
	
	        /**
	         * The callback that will be called when the TimerEvent occurs.
	         *
	         * @name Phaser.Time.TimerEvent#callback
	         * @type {function}
	         * @since 3.0.0
	         */
	        this.callback;
	
	        /**
	         * The scope in which the callback will be called.
	         *
	         * @name Phaser.Time.TimerEvent#callbackScope
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.callbackScope;
	
	        /**
	         * Additional arguments to be passed to the callback.
	         *
	         * @name Phaser.Time.TimerEvent#args
	         * @type {array}
	         * @since 3.0.0
	         */
	        this.args;
	
	        /**
	         * Scale the time causing this TimerEvent to update.
	         *
	         * @name Phaser.Time.TimerEvent#timeScale
	         * @type {number}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.timeScale = 1;
	
	        /**
	         * Start this many MS into the elapsed (useful if you want a long duration with repeat, but for the first loop to fire quickly)
	         *
	         * @name Phaser.Time.TimerEvent#startAt
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.startAt = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Time.TimerEvent#elapsed
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.elapsed = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Time.TimerEvent#paused
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.paused = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Time.TimerEvent#hasDispatched
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.hasDispatched = false;
	
	        this.reset(config);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Time.TimerEvent#reset
	     * @since 3.0.0
	     *
	     * @param {TimerEventConfig} config - [description]
	     *
	     * @return {Phaser.Time.TimerEvent} This TimerEvent object.
	     */
	    reset: function (config)
	    {
	        this.delay = GetFastValue(config, 'delay', 0);
	
	        //  Can also be set to -1 for an infinite loop (same as setting loop: true)
	        this.repeat = GetFastValue(config, 'repeat', 0);
	
	        this.loop = GetFastValue(config, 'loop', false);
	
	        this.callback = GetFastValue(config, 'callback', undefined);
	
	        this.callbackScope = GetFastValue(config, 'callbackScope', this.callback);
	
	        this.args = GetFastValue(config, 'args', []);
	
	        this.timeScale = GetFastValue(config, 'timeScale', 1);
	
	        this.startAt = GetFastValue(config, 'startAt', 0);
	
	        this.paused = GetFastValue(config, 'paused', false);
	
	        this.elapsed = this.startAt;
	        this.hasDispatched = false;
	        this.repeatCount = (this.repeat === -1 || this.loop) ? 999999999999 : this.repeat;
	
	        return this;
	    },
	
	    /**
	     * Gets the progress of the current iteration, not factoring in repeats.
	     *
	     * @method Phaser.Time.TimerEvent#getProgress
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    getProgress: function ()
	    {
	        return (this.elapsed / this.delay);
	    },
	
	    /**
	     * Gets the progress of the timer overall, factoring in repeats.
	     *
	     * @method Phaser.Time.TimerEvent#getOverallProgress
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    getOverallProgress: function ()
	    {
	        if (this.repeat > 0)
	        {
	            var totalDuration = this.delay + (this.delay * this.repeat);
	            var totalElapsed = this.elapsed + (this.delay * (this.repeat - this.repeatCount));
	
	            return (totalElapsed / totalDuration);
	        }
	        else
	        {
	            return this.getProgress();
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Time.TimerEvent#getRepeatCount
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    getRepeatCount: function ()
	    {
	        return this.repeatCount;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Time.TimerEvent#getElapsed
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    getElapsed: function ()
	    {
	        return this.elapsed;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Time.TimerEvent#getElapsedSeconds
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    getElapsedSeconds: function ()
	    {
	        return this.elapsed * 0.001;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Time.TimerEvent#remove
	     * @since 3.0.0
	     *
	     * @param {function} dispatchCallback - [description]
	     */
	    remove: function (dispatchCallback)
	    {
	        if (dispatchCallback === undefined) { dispatchCallback = false; }
	
	        this.elapsed = this.delay;
	
	        this.hasDispatched = !dispatchCallback;
	
	        this.repeatCount = 0;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Time.TimerEvent#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.callback = undefined;
	        this.callbackScope = undefined;
	        this.args = [];
	    }
	
	});
	
	module.exports = TimerEvent;


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var EventEmitter = __webpack_require__(22);
	var TweenBuilder = __webpack_require__(217);
	var TWEEN_CONST = __webpack_require__(174);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class Timeline
	 * @memberOf Phaser.Tweens
	 * @extends Phaser.Events.EventEmitter
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Tweens.TweenManager} manager - [description]
	 */
	var Timeline = new Class({
	
	    Extends: EventEmitter,
	
	    initialize:
	
	    function Timeline (manager)
	    {
	        EventEmitter.call(this);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tweens.Timeline#manager
	         * @type {Phaser.Tweens.TweenManager}
	         * @since 3.0.0
	         */
	        this.manager = manager;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tweens.Timeline#isTimeline
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.isTimeline = true;
	
	        /**
	         * An array of Tween objects, each containing a unique property and target being tweened.
	         *
	         * @name Phaser.Tweens.Timeline#data
	         * @type {array}
	         * @default []
	         * @since 3.0.0
	         */
	        this.data = [];
	
	        /**
	         * data array doesn't usually change, so we can cache the length
	         *
	         * @name Phaser.Tweens.Timeline#totalData
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.totalData = 0;
	
	        /**
	         * If true then duration, delay, etc values are all frame totals.
	         *
	         * @name Phaser.Tweens.Timeline#useFrames
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.useFrames = false;
	
	        /**
	         * Scales the time applied to this Tween. A value of 1 runs in real-time. A value of 0.5 runs 50% slower, and so on.
	         * Value isn't used when calculating total duration of the tween, it's a run-time delta adjustment only.
	         *
	         * @name Phaser.Tweens.Timeline#timeScale
	         * @type {number}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.timeScale = 1;
	
	        /**
	         * Loop this tween? Can be -1 for an infinite loop, or an integer.
	         * When enabled it will play through ALL TweenDatas again (use TweenData.repeat to loop a single TD)
	         *
	         * @name Phaser.Tweens.Timeline#loop
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.loop = 0;
	
	        /**
	         * Time in ms/frames before the tween loops.
	         *
	         * @name Phaser.Tweens.Timeline#loopDelay
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.loopDelay = 0;
	
	        /**
	         * How many loops are left to run?
	         *
	         * @name Phaser.Tweens.Timeline#loopCounter
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.loopCounter = 0;
	
	        /**
	         * Time in ms/frames before the 'onComplete' event fires. This never fires if loop = true (as it never completes)
	         *
	         * @name Phaser.Tweens.Timeline#completeDelay
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.completeDelay = 0;
	
	        /**
	         * Countdown timer (used by loopDelay and completeDelay)
	         *
	         * @name Phaser.Tweens.Timeline#countdown
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.countdown = 0;
	
	        /**
	         * The current state of the tween
	         *
	         * @name Phaser.Tweens.Timeline#state
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.state = TWEEN_CONST.PENDING_ADD;
	
	        /**
	         * The state of the tween when it was paused (used by Resume)
	         *
	         * @name Phaser.Tweens.Timeline#_pausedState
	         * @type {integer}
	         * @private
	         * @since 3.0.0
	         */
	        this._pausedState = TWEEN_CONST.PENDING_ADD;
	
	        /**
	         * Does the Tween start off paused? (if so it needs to be started with Tween.play)
	         *
	         * @name Phaser.Tweens.Timeline#paused
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.paused = false;
	
	        /**
	         * Elapsed time in ms/frames of this run through the Tween.
	         *
	         * @name Phaser.Tweens.Timeline#elapsed
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.elapsed = 0;
	
	        /**
	         * Total elapsed time in ms/frames of the entire Tween, including looping.
	         *
	         * @name Phaser.Tweens.Timeline#totalElapsed
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.totalElapsed = 0;
	
	        /**
	         * Time in ms/frames for the whole Tween to play through once, excluding loop amounts and loop delays.
	         *
	         * @name Phaser.Tweens.Timeline#duration
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.duration = 0;
	
	        /**
	         * Value between 0 and 1. The amount through the Tween, excluding loops.
	         *
	         * @name Phaser.Tweens.Timeline#progress
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.progress = 0;
	
	        /**
	         * Time in ms/frames for all Tweens to complete (including looping)
	         *
	         * @name Phaser.Tweens.Timeline#totalDuration
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.totalDuration = 0;
	
	        /**
	         * Value between 0 and 1. The amount through the entire Tween, including looping.
	         *
	         * @name Phaser.Tweens.Timeline#totalProgress
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.totalProgress = 0;
	
	        this.callbacks = {
	            onComplete: null,
	            onLoop: null,
	            onStart: null,
	            onUpdate: null,
	            onYoyo: null
	        };
	
	        this.callbackScope;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Timeline#setTimeScale
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.Tweens.Timeline} This Timeline object.
	     */
	    setTimeScale: function (value)
	    {
	        this.timeScale = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Timeline#getTimeScale
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    getTimeScale: function ()
	    {
	        return this.timeScale;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Timeline#isPlaying
	     * @since 3.0.0
	     *
	     * @return {boolean} [description]
	     */
	    isPlaying: function ()
	    {
	        return (this.state === TWEEN_CONST.ACTIVE);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Timeline#add
	     * @since 3.0.0
	     *
	     * @param {object} config - [description]
	     *
	     * @return {Phaser.Tweens.Timeline} This Timeline object.
	     */
	    add: function (config)
	    {
	        return this.queue(TweenBuilder(this, config));
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Timeline#queue
	     * @since 3.0.0
	     *
	     * @param {Phaser.Tweens.Tween} tween - [description]
	     *
	     * @return {Phaser.Tweens.Timeline} This Timeline object.
	     */
	    queue: function (tween)
	    {
	        if (!this.isPlaying())
	        {
	            tween.parent = this;
	            tween.parentIsTimeline = true;
	
	            this.data.push(tween);
	
	            this.totalData = this.data.length;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Timeline#hasOffset
	     * @since 3.0.0
	     *
	     * @param {Phaser.Tweens.Tween} tween - [description]
	     *
	     * @return {boolean} [description]
	     */
	    hasOffset: function (tween)
	    {
	        return (tween.offset !== null);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Timeline#isOffsetAbsolute
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {boolean} [description]
	     */
	    isOffsetAbsolute: function (value)
	    {
	        return (typeof(value) === 'number');
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Timeline#isOffsetRelative
	     * @since 3.0.0
	     *
	     * @param {string} value - [description]
	     *
	     * @return {boolean} [description]
	     */
	    isOffsetRelative: function (value)
	    {
	        var t = typeof(value);
	
	        if (t === 'string')
	        {
	            var op = value[0];
	
	            if (op === '-' || op === '+')
	            {
	                return true;
	            }
	        }
	
	        return false;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Timeline#getRelativeOffset
	     * @since 3.0.0
	     *
	     * @param {string} value - [description]
	     * @param {number} base - [description]
	     *
	     * @return {number} [description]
	     */
	    getRelativeOffset: function (value, base)
	    {
	        var op = value[0];
	        var num = parseFloat(value.substr(2));
	        var result = base;
	
	        switch (op)
	        {
	            case '+':
	                result += num;
	                break;
	
	            case '-':
	                result -= num;
	                break;
	        }
	
	        //  Cannot ever be < 0
	        return Math.max(0, result);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Timeline#calcDuration
	     * @since 3.0.0
	     */
	    calcDuration: function ()
	    {
	        var prevEnd = 0;
	        var totalDuration = 0;
	        var offsetDuration = 0;
	
	        for (var i = 0; i < this.totalData; i++)
	        {
	            var tween = this.data[i];
	
	            tween.init();
	
	            if (this.hasOffset(tween))
	            {
	                if (this.isOffsetAbsolute(tween.offset))
	                {
	                    //  An actual number, so it defines the start point from the beginning of the timeline
	                    tween.calculatedOffset = tween.offset;
	
	                    if (tween.offset === 0)
	                    {
	                        offsetDuration = 0;
	                    }
	                }
	                else if (this.isOffsetRelative(tween.offset))
	                {
	                    //  A relative offset (i.e. '-=1000', so starts at 'offset' ms relative to the PREVIOUS Tweens ending time)
	                    tween.calculatedOffset = this.getRelativeOffset(tween.offset, prevEnd);
	                }
	            }
	            else
	            {
	                //  Sequential
	                tween.calculatedOffset = offsetDuration;
	            }
	
	            prevEnd = tween.totalDuration + tween.calculatedOffset;
	
	            totalDuration += tween.totalDuration;
	            offsetDuration += tween.totalDuration;
	        }
	
	        //  Excludes loop values
	        this.duration = totalDuration;
	
	        this.loopCounter = (this.loop === -1) ? 999999999999 : this.loop;
	
	        if (this.loopCounter > 0)
	        {
	            this.totalDuration = this.duration + this.completeDelay + ((this.duration + this.loopDelay) * this.loopCounter);
	        }
	        else
	        {
	            this.totalDuration = this.duration + this.completeDelay;
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Timeline#init
	     * @since 3.0.0
	     *
	     * @return {boolean} [description]
	     */
	    init: function ()
	    {
	        this.calcDuration();
	
	        this.progress = 0;
	        this.totalProgress = 0;
	
	        if (this.paused)
	        {
	            this.state = TWEEN_CONST.PAUSED;
	
	            return false;
	        }
	        else
	        {
	            return true;
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Timeline#resetTweens
	     * @since 3.0.0
	     *
	     * @param {boolean} resetFromLoop - [description]
	     */
	    resetTweens: function (resetFromLoop)
	    {
	        for (var i = 0; i < this.totalData; i++)
	        {
	            var tween = this.data[i];
	
	            tween.play(resetFromLoop);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Timeline#setCallback
	     * @since 3.0.0
	     *
	     * @param {string} type - [description]
	     * @param {function} callback - [description]
	     * @param {array} [params] - [description]
	     * @param {object} [scope] - [description]
	     *
	     * @return {Phaser.Tweens.Timeline} This Timeline object.
	     */
	    setCallback: function (type, callback, params, scope)
	    {
	        if (Timeline.TYPES.indexOf(type) !== -1)
	        {
	            this.callbacks[type] = { func: callback, scope: scope, params: params };
	        }
	
	        return this;
	    },
	
	    /**
	     * Delegates #makeActive to the Tween manager.
	     *
	     * @method Phaser.Tweens.Timeline#makeActive
	     * @since 3.3.0
	     *
	     * @param {Phaser.Tweens.Tween} tween - The tween object to make active.
	     *
	     * @return {Phaser.Tweens.TweenManager} The Timeline's Tween Manager object.
	     */
	    makeActive: function (tween)
	    {
	        return this.manager.makeActive(tween);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Timeline#play
	     * @since 3.0.0
	     */
	    play: function ()
	    {
	        if (this.state === TWEEN_CONST.ACTIVE)
	        {
	            return;
	        }
	
	        if (this.paused)
	        {
	            this.paused = false;
	
	            this.manager.makeActive(this);
	
	            return;
	        }
	        else
	        {
	            this.resetTweens(false);
	
	            this.state = TWEEN_CONST.ACTIVE;
	        }
	
	        var onStart = this.callbacks.onStart;
	
	        if (onStart)
	        {
	            onStart.func.apply(onStart.scope, onStart.params);
	        }
	
	        this.emit('start', this);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Timeline#nextState
	     * @since 3.0.0
	     */
	    nextState: function ()
	    {
	        if (this.loopCounter > 0)
	        {
	            //  Reset the elapsed time
	            //  TODO: Probably ought to be set to the remainder from elapsed - duration
	            //  as the tweens nearly always over-run by a few ms due to rAf
	
	            this.elapsed = 0;
	            this.progress = 0;
	
	            this.loopCounter--;
	
	            var onLoop = this.callbacks.onLoop;
	
	            if (onLoop)
	            {
	                onLoop.func.apply(onLoop.scope, onLoop.params);
	            }
	
	            this.emit('loop', this, this.loopCounter);
	
	            this.resetTweens(true);
	
	            if (this.loopDelay > 0)
	            {
	                this.countdown = this.loopDelay;
	                this.state = TWEEN_CONST.LOOP_DELAY;
	            }
	            else
	            {
	                this.state = TWEEN_CONST.ACTIVE;
	            }
	        }
	        else if (this.completeDelay > 0)
	        {
	            this.countdown = this.completeDelay;
	            this.state = TWEEN_CONST.COMPLETE_DELAY;
	        }
	        else
	        {
	            var onComplete = this.callbacks.onComplete;
	
	            if (onComplete)
	            {
	                onComplete.func.apply(onComplete.scope, onComplete.params);
	            }
	
	            this.emit('complete', this);
	
	            this.state = TWEEN_CONST.PENDING_REMOVE;
	        }
	    },
	
	    /**
	     * Returns 'true' if this Timeline has finished and should be removed from the Tween Manager.
	     * Otherwise, returns false.
	     *
	     * @method Phaser.Tweens.Timeline#update
	     * @since 3.0.0
	     *
	     * @param {number} timestamp - [description]
	     * @param {number} delta - [description]
	     *
	     * @return {boolean} Returns `true` if this Timeline has finished and should be removed from the Tween Manager.
	     */
	    update: function (timestamp, delta)
	    {
	        if (this.state === TWEEN_CONST.PAUSED)
	        {
	            return;
	        }
	
	        var rawDelta = delta;
	
	        if (this.useFrames)
	        {
	            delta = 1 * this.manager.timeScale;
	        }
	
	        delta *= this.timeScale;
	
	        this.elapsed += delta;
	        this.progress = Math.min(this.elapsed / this.duration, 1);
	
	        this.totalElapsed += delta;
	        this.totalProgress = Math.min(this.totalElapsed / this.totalDuration, 1);
	
	        switch (this.state)
	        {
	            case TWEEN_CONST.ACTIVE:
	
	                var stillRunning = this.totalData;
	
	                for (var i = 0; i < this.totalData; i++)
	                {
	                    var tween = this.data[i];
	
	                    if (tween.update(timestamp, rawDelta))
	                    {
	                        stillRunning--;
	                    }
	                }
	
	                var onUpdate = this.callbacks.onUpdate;
	
	                if (onUpdate)
	                {
	                    onUpdate.func.apply(onUpdate.scope, onUpdate.params);
	                }
	
	                this.emit('update', this);
	
	                //  Anything still running? If not, we're done
	                if (stillRunning === 0)
	                {
	                    this.nextState();
	                }
	
	                break;
	
	            case TWEEN_CONST.LOOP_DELAY:
	
	                this.countdown -= delta;
	
	                if (this.countdown <= 0)
	                {
	                    this.state = TWEEN_CONST.ACTIVE;
	                }
	
	                break;
	
	            case TWEEN_CONST.COMPLETE_DELAY:
	
	                this.countdown -= delta;
	
	                if (this.countdown <= 0)
	                {
	                    var onComplete = this.callbacks.onComplete;
	
	                    if (onComplete)
	                    {
	                        onComplete.func.apply(onComplete.scope, onComplete.params);
	                    }
	
	                    this.emit('complete', this);
	
	                    this.state = TWEEN_CONST.PENDING_REMOVE;
	                }
	
	                break;
	        }
	
	        return (this.state === TWEEN_CONST.PENDING_REMOVE);
	    },
	
	    /**
	     * Stops the Tween immediately, whatever stage of progress it is at and flags it for removal by the TweenManager.
	     *
	     * @method Phaser.Tweens.Timeline#stop
	     * @since 3.0.0
	     */
	    stop: function ()
	    {
	        this.state = TWEEN_CONST.PENDING_REMOVE;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Timeline#pause
	     * @since 3.0.0
	     *
	     * @return {Phaser.Tweens.Timeline} This Timeline object.
	     */
	    pause: function ()
	    {
	        if (this.state === TWEEN_CONST.PAUSED)
	        {
	            return;
	        }
	
	        this.paused = true;
	
	        this._pausedState = this.state;
	
	        this.state = TWEEN_CONST.PAUSED;
	
	        this.emit('pause', this);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Timeline#resume
	     * @since 3.0.0
	     *
	     * @return {Phaser.Tweens.Timeline} This Timeline object.
	     */
	    resume: function ()
	    {
	        if (this.state === TWEEN_CONST.PAUSED)
	        {
	            this.paused = false;
	
	            this.state = this._pausedState;
	        }
	
	        this.emit('resume', this);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Timeline#hasTarget
	     * @since 3.0.0
	     *
	     * @param {object} target - [description]
	     *
	     * @return {boolean} [description]
	     */
	    hasTarget: function (target)
	    {
	        for (var i = 0; i < this.data.length; i++)
	        {
	            if (this.data[i].hasTarget(target))
	            {
	                return true;
	            }
	        }
	
	        return false;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.Timeline#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        for (var i = 0; i < this.data.length; i++)
	        {
	            this.data[i].stop();
	        }
	
	    }
	});
	
	Timeline.TYPES = [ 'onStart', 'onUpdate', 'onLoop', 'onComplete', 'onYoyo' ];
	
	module.exports = Timeline;


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var RESERVED = __webpack_require__(1585);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Tweens.Builders.GetProps
	 * @since 3.0.0
	 *
	 * @param {object} config - [description]
	 *
	 * @return {array} [description]
	 */
	var GetProps = function (config)
	{
	    var key;
	    var keys = [];
	
	    //  First see if we have a props object
	
	    if (config.hasOwnProperty('props'))
	    {
	        for (key in config.props)
	        {
	            //  Skip any property that starts with an underscore
	            if (key.substr(0, 1) !== '_')
	            {
	                keys.push({ key: key, value: config.props[key] });
	            }
	        }
	    }
	    else
	    {
	        for (key in config)
	        {
	            //  Skip any property that is in the ReservedProps list or that starts with an underscore
	            if (RESERVED.indexOf(key) === -1 && key.substr(0, 1) !== '_')
	            {
	                keys.push({ key: key, value: config[key] });
	            }
	        }
	    }
	
	    return keys;
	};
	
	module.exports = GetProps;


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetValue = __webpack_require__(10);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Tweens.Builders.GetTweens
	 * @since 3.0.0
	 *
	 * @param {object} config - [description]
	 *
	 * @return {array} [description]
	 */
	var GetTweens = function (config)
	{
	    var tweens = GetValue(config, 'tweens', null);
	
	    if (tweens === null)
	    {
	        return [];
	    }
	    else if (typeof tweens === 'function')
	    {
	        tweens = tweens.call();
	    }
	
	    if (!Array.isArray(tweens))
	    {
	        tweens = [ tweens ];
	    }
	
	    return tweens;
	};
	
	module.exports = GetTweens;


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Defaults = __webpack_require__(336);
	var GetAdvancedValue = __webpack_require__(24);
	var GetBoolean = __webpack_require__(172);
	var GetEaseFunction = __webpack_require__(173);
	var GetNewValue = __webpack_require__(216);
	var GetValue = __webpack_require__(10);
	var GetValueOp = __webpack_require__(335);
	var Tween = __webpack_require__(337);
	var TweenData = __webpack_require__(338);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Tweens.Builders.NumberTweenBuilder
	 * @since 3.0.0
	 *
	 * @param {(Phaser.Tweens.TweenManager|Phaser.Tweens.Timeline)} parent - [description]
	 * @param {object} config - [description]
	 * @param {Phaser.Tweens.TweenConfigDefaults} defaults - [description]
	 *
	 * @return {Phaser.Tweens.Tween} [description]
	 */
	var NumberTweenBuilder = function (parent, config, defaults)
	{
	    if (defaults === undefined)
	    {
	        defaults = Defaults;
	    }
	
	    //  var tween = this.tweens.addCounter({
	    //      from: 100,
	    //      to: 200,
	    //      ... (normal tween properties)
	    //  })
	    //
	    //  Then use it in your game via:
	    //
	    //  tween.getValue()
	
	    var from = GetValue(config, 'from', 0);
	    var to = GetValue(config, 'to', 1);
	
	    var targets = [ { value: from } ];
	
	    var delay = GetNewValue(config, 'delay', defaults.delay);
	    var duration = GetNewValue(config, 'duration', defaults.duration);
	    var easeParams = GetValue(config, 'easeParams', defaults.easeParams);
	    var ease = GetEaseFunction(GetValue(config, 'ease', defaults.ease), easeParams);
	    var hold = GetNewValue(config, 'hold', defaults.hold);
	    var repeat = GetNewValue(config, 'repeat', defaults.repeat);
	    var repeatDelay = GetNewValue(config, 'repeatDelay', defaults.repeatDelay);
	    var yoyo = GetBoolean(config, 'yoyo', defaults.yoyo);
	
	    var data = [];
	
	    var ops = GetValueOp('value', to);
	
	    var tweenData = TweenData(
	        targets[0],
	        'value',
	        ops.getEnd,
	        ops.getStart,
	        ease,
	        delay,
	        duration,
	        yoyo,
	        hold,
	        repeat,
	        repeatDelay,
	        false,
	        false
	    );
	
	    tweenData.start = from;
	    tweenData.current = from;
	    tweenData.to = to;
	
	    data.push(tweenData);
	
	    var tween = new Tween(parent, data, targets);
	
	    tween.offset = GetAdvancedValue(config, 'offset', null);
	    tween.completeDelay = GetAdvancedValue(config, 'completeDelay', 0);
	    tween.loop = Math.round(GetAdvancedValue(config, 'loop', 0));
	    tween.loopDelay = Math.round(GetAdvancedValue(config, 'loopDelay', 0));
	    tween.paused = GetBoolean(config, 'paused', false);
	    tween.useFrames = GetBoolean(config, 'useFrames', false);
	
	    //  Set the Callbacks
	    var scope = GetValue(config, 'callbackScope', tween);
	
	    //  Callback parameters: 0 = a reference to the Tween itself, 1 = the target/s of the Tween, ... your own params
	    var tweenArray = [ tween, null ];
	
	    var callbacks = Tween.TYPES;
	
	    for (var i = 0; i < callbacks.length; i++)
	    {
	        var type = callbacks[i];
	
	        var callback = GetValue(config, type, false);
	
	        if (callback)
	        {
	            var callbackScope = GetValue(config, type + 'Scope', scope);
	            var callbackParams = GetValue(config, type + 'Params', []);
	
	            //  The null is reset to be the Tween target
	            tween.setCallback(type, callback, tweenArray.concat(callbackParams), callbackScope);
	        }
	    }
	
	    return tween;
	};
	
	module.exports = NumberTweenBuilder;


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Clone = __webpack_require__(123);
	var Defaults = __webpack_require__(336);
	var GetAdvancedValue = __webpack_require__(24);
	var GetBoolean = __webpack_require__(172);
	var GetEaseFunction = __webpack_require__(173);
	var GetNewValue = __webpack_require__(216);
	var GetTargets = __webpack_require__(334);
	var GetTweens = __webpack_require__(654);
	var GetValue = __webpack_require__(10);
	var Timeline = __webpack_require__(652);
	var TweenBuilder = __webpack_require__(217);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Tweens.Builders.TimelineBuilder
	 * @since 3.0.0
	 *
	 * @param {Phaser.Tweens.TweenManager} manager - [description]
	 * @param {object} config - [description]
	 *
	 * @return {Phaser.Tweens.Timeline} [description]
	 */
	var TimelineBuilder = function (manager, config)
	{
	    var timeline = new Timeline(manager);
	
	    var tweens = GetTweens(config);
	
	    if (tweens.length === 0)
	    {
	        timeline.paused = true;
	
	        return timeline;
	    }
	
	    var defaults = Clone(Defaults);
	
	    defaults.targets = GetTargets(config);
	
	    //  totalDuration: If specified each tween in the Timeline is given an equal portion of the totalDuration
	
	    var totalDuration = GetAdvancedValue(config, 'totalDuration', 0);
	
	    if (totalDuration > 0)
	    {
	        defaults.duration = Math.floor(totalDuration / tweens.length);
	    }
	    else
	    {
	        defaults.duration = GetNewValue(config, 'duration', defaults.duration);
	    }
	
	    defaults.delay = GetNewValue(config, 'delay', defaults.delay);
	    defaults.easeParams = GetValue(config, 'easeParams', defaults.easeParams);
	    defaults.ease = GetEaseFunction(GetValue(config, 'ease', defaults.ease), defaults.easeParams);
	    defaults.hold = GetNewValue(config, 'hold', defaults.hold);
	    defaults.repeat = GetNewValue(config, 'repeat', defaults.repeat);
	    defaults.repeatDelay = GetNewValue(config, 'repeatDelay', defaults.repeatDelay);
	    defaults.yoyo = GetBoolean(config, 'yoyo', defaults.yoyo);
	    defaults.flipX = GetBoolean(config, 'flipX', defaults.flipX);
	    defaults.flipY = GetBoolean(config, 'flipY', defaults.flipY);
	
	    //  Create the Tweens
	    for (var i = 0; i < tweens.length; i++)
	    {
	        timeline.queue(TweenBuilder(timeline, tweens[i], defaults));
	    }
	
	    timeline.completeDelay = GetAdvancedValue(config, 'completeDelay', 0);
	    timeline.loop = Math.round(GetAdvancedValue(config, 'loop', 0));
	    timeline.loopDelay = Math.round(GetAdvancedValue(config, 'loopDelay', 0));
	    timeline.paused = GetBoolean(config, 'paused', false);
	    timeline.useFrames = GetBoolean(config, 'useFrames', false);
	
	    //  Callbacks
	
	    var scope = GetValue(config, 'callbackScope', timeline);
	
	    var timelineArray = [ timeline ];
	
	    var onStart = GetValue(config, 'onStart', false);
	
	    //  The Start of the Timeline
	    if (onStart)
	    {
	        var onStartScope = GetValue(config, 'onStartScope', scope);
	        var onStartParams = GetValue(config, 'onStartParams', []);
	
	        timeline.setCallback('onStart', onStart, timelineArray.concat(onStartParams), onStartScope);
	    }
	
	    var onUpdate = GetValue(config, 'onUpdate', false);
	
	    //  Every time the Timeline updates (regardless which Tweens are running)
	    if (onUpdate)
	    {
	        var onUpdateScope = GetValue(config, 'onUpdateScope', scope);
	        var onUpdateParams = GetValue(config, 'onUpdateParams', []);
	
	        timeline.setCallback('onUpdate', onUpdate, timelineArray.concat(onUpdateParams), onUpdateScope);
	    }
	
	    var onLoop = GetValue(config, 'onLoop', false);
	
	    //  Called when the whole Timeline loops
	    if (onLoop)
	    {
	        var onLoopScope = GetValue(config, 'onLoopScope', scope);
	        var onLoopParams = GetValue(config, 'onLoopParams', []);
	
	        timeline.setCallback('onLoop', onLoop, timelineArray.concat(onLoopParams), onLoopScope);
	    }
	
	    var onYoyo = GetValue(config, 'onYoyo', false);
	
	    //  Called when a Timeline yoyos
	    if (onYoyo)
	    {
	        var onYoyoScope = GetValue(config, 'onYoyoScope', scope);
	        var onYoyoParams = GetValue(config, 'onYoyoParams', []);
	
	        timeline.setCallback('onYoyo', onYoyo, timelineArray.concat(null, onYoyoParams), onYoyoScope);
	    }
	
	    var onComplete = GetValue(config, 'onComplete', false);
	
	    //  Called when the Timeline completes, after the completeDelay, etc.
	    if (onComplete)
	    {
	        var onCompleteScope = GetValue(config, 'onCompleteScope', scope);
	        var onCompleteParams = GetValue(config, 'onCompleteParams', []);
	
	        timeline.setCallback('onComplete', onComplete, timelineArray.concat(onCompleteParams), onCompleteScope);
	    }
	
	    return timeline;
	};
	
	module.exports = TimelineBuilder;


/***/ }),
/* 657 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Utils.Array.FindClosestInSorted
	 * @since 3.0.0
	 *
	 * @param {number} value - The value to search for in the array.
	 * @param {array} array - The array to search, which must be sorted.
	 * @param {string} [key] - An optional property key. If specified the array elements property will be checked against value.
	 *
	 * @return {number|object} The nearest value found in the array, or if a `key` was given, the nearest object with the matching property value.
	 */
	var FindClosestInSorted = function (value, array, key)
	{
	    if (!array.length)
	    {
	        return NaN;
	    }
	    else if (array.length === 1)
	    {
	        return array[0];
	    }
	
	    var i = 1;
	    var low;
	    var high;
	
	    if (key)
	    {
	        if (value < array[0][key])
	        {
	            return array[0];
	        }
	
	        while (array[i][key] < value)
	        {
	            i++;
	        }
	    }
	    else
	    {
	        while (array[i] < value)
	        {
	            i++;
	        }
	    }
	
	    if (i > array.length)
	    {
	        i = array.length;
	    }
	
	    if (key)
	    {
	        low = array[i - 1][key];
	        high = array[i][key];
	
	        return ((high - value) <= (value - low)) ? array[i] : array[i - 1];
	    }
	    else
	    {
	        low = array[i - 1];
	        high = array[i];
	
	        return ((high - value) <= (value - low)) ? high : low;
	    }
	};
	
	module.exports = FindClosestInSorted;


/***/ }),
/* 658 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  This is from the quickselect npm package: https://www.npmjs.com/package/quickselect
	//  Coded by https://www.npmjs.com/~mourner (Vladimir Agafonkin)
	
	// https://en.wikipedia.org/wiki/Floyd%E2%80%93Rivest_algorithm
	
	// Floyd-Rivest selection algorithm:
	// Rearrange items so that all items in the [left, k] range are smaller than all items in (k, right];
	// The k-th element will have the (k - left + 1)th smallest value in [left, right]
	
	/**
	 * [description]
	 *
	 * @function Phaser.Utils.Array.QuickSelect
	 * @since 3.0.0
	 *
	 * @param {array} arr - [description]
	 * @param {number} k - [description]
	 * @param {number} left - [description]
	 * @param {number} right - [description]
	 * @param {function} compare - [description]
	 */
	var QuickSelect = function (arr, k, left, right, compare)
	{
	    left = left || 0;
	    right = right || (arr.length - 1);
	    compare = compare || defaultCompare;
	
	    while (right > left)
	    {
	        if (right - left > 600)
	        {
	            var n = right - left + 1;
	            var m = k - left + 1;
	            var z = Math.log(n);
	            var s = 0.5 * Math.exp(2 * z / 3);
	            var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
	            var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
	            var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
	
	            QuickSelect(arr, k, newLeft, newRight, compare);
	        }
	
	        var t = arr[k];
	        var i = left;
	        var j = right;
	
	        swap(arr, left, k);
	
	        if (compare(arr[right], t) > 0)
	        {
	            swap(arr, left, right);
	        }
	
	        while (i < j)
	        {
	            swap(arr, i, j);
	
	            i++;
	            j--;
	
	            while (compare(arr[i], t) < 0)
	            {
	                i++;
	            }
	
	            while (compare(arr[j], t) > 0)
	            {
	                j--;
	            }
	        }
	
	        if (compare(arr[left], t) === 0)
	        {
	            swap(arr, left, j);
	        }
	        else
	        {
	            j++;
	            swap(arr, j, right);
	        }
	
	        if (j <= k)
	        {
	            left = j + 1;
	        }
	
	        if (k <= j)
	        {
	            right = j - 1;
	        }
	    }
	};
	
	function swap (arr, i, j)
	{
	    var tmp = arr[i];
	    arr[i] = arr[j];
	    arr[j] = tmp;
	}
	
	function defaultCompare (a, b)
	{
	    return a < b ? -1 : a > b ? 1 : 0;
	}
	
	module.exports = QuickSelect;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetValue = __webpack_require__(10);
	var Shuffle = __webpack_require__(218);
	
	var BuildChunk = function (a, b, qty)
	{
	    var out = [];
	
	    for (var aIndex = 0; aIndex < a.length; aIndex++)
	    {
	        for (var bIndex = 0; bIndex < b.length; bIndex++)
	        {
	            for (var i = 0; i < qty; i++)
	            {
	                out.push({ a: a[aIndex], b: b[bIndex] });
	            }
	        }
	    }
	
	    return out;
	};
	
	//  options = repeat, random, randomB, yoyo, max, qty
	
	//  Range ([a,b,c], [1,2,3]) =
	//  a1, a2, a3, b1, b2, b3, c1, c2, c3
	
	//  Range ([a,b], [1,2,3], qty = 3) =
	//  a1, a1, a1, a2, a2, a2, a3, a3, a3, b1, b1, b1, b2, b2, b2, b3, b3, b3
	
	//  Range ([a,b,c], [1,2,3], repeat x1) =
	//  a1, a2, a3, b1, b2, b3, c1, c2, c3, a1, a2, a3, b1, b2, b3, c1, c2, c3
	
	//  Range ([a,b], [1,2], repeat -1 = endless, max = 14) =
	//  Maybe if max is set then repeat goes to -1 automatically?
	//  a1, a2, b1, b2, a1, a2, b1, b2, a1, a2, b1, b2, a1, a2 (capped at 14 elements)
	
	//  Range ([a], [1,2,3,4,5], random = true) =
	//  a4, a1, a5, a2, a3
	
	//  Range ([a, b], [1,2,3], random = true) =
	//  b3, a2, a1, b1, a3, b2
	
	//  Range ([a, b, c], [1,2,3], randomB = true) =
	//  a3, a1, a2, b2, b3, b1, c1, c3, c2
	
	//  Range ([a], [1,2,3,4,5], yoyo = true) =
	//  a1, a2, a3, a4, a5, a5, a4, a3, a2, a1
	
	//  Range ([a, b], [1,2,3], yoyo = true) =
	//  a1, a2, a3, b1, b2, b3, b3, b2, b1, a3, a2, a1
	
	/**
	 * [description]
	 *
	 * @function Phaser.Utils.Array.Range
	 * @since 3.0.0
	 *
	 * @param {array} a - [description]
	 * @param {array} b - [description]
	 * @param {object} options - [description]
	 *
	 * @return {array} [description]
	 */
	var Range = function (a, b, options)
	{
	    var max = GetValue(options, 'max', 0);
	    var qty = GetValue(options, 'qty', 1);
	    var random = GetValue(options, 'random', false);
	    var randomB = GetValue(options, 'randomB', false);
	    var repeat = GetValue(options, 'repeat', 0);
	    var yoyo = GetValue(options, 'yoyo', false);
	
	    var out = [];
	
	    if (randomB)
	    {
	        Shuffle(b);
	    }
	
	    //  Endless repeat, so limit by max
	    if (repeat === -1)
	    {
	        if (max === 0)
	        {
	            repeat = 0;
	        }
	        else
	        {
	            //  Work out how many repeats we need
	            var total = (a.length * b.length) * qty;
	
	            if (yoyo)
	            {
	                total *= 2;
	            }
	
	            repeat = Math.ceil(max / total);
	        }
	    }
	
	    for (var i = 0; i <= repeat; i++)
	    {
	        var chunk = BuildChunk(a, b, qty);
	
	        if (random)
	        {
	            Shuffle(chunk);
	        }
	
	        out = out.concat(chunk);
	
	        if (yoyo)
	        {
	            chunk.reverse();
	
	            out = out.concat(chunk);
	        }
	    }
	
	    if (max)
	    {
	        out.splice(max);
	    }
	
	    return out;
	};
	
	module.exports = Range;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var SpliceOne = __webpack_require__(175);
	
	/**
	 * Removes the given item, or array of items, from the array.
	 * 
	 * The array is modified in-place.
	 * 
	 * You can optionally specify a callback to be invoked for each item successfully removed from the array.
	 *
	 * @function Phaser.Utils.Array.Remove
	 * @since 3.4.0
	 *
	 * @param {array} array - The array to be modified.
	 * @param {*|Array.<*>} item - The item, or array of items, to be removed from the array.
	 * @param {function} [callback] - A callback to be invoked for each item successfully removed from the array.
	 * @param {object} [context] - The context in which the callback is invoked.
	 *
	 * @return {*|Array.<*>} The item, or array of items, that were successfully removed from the array.
	 */
	var Remove = function (array, item, callback, context)
	{
	    if (context === undefined) { context = array; }
	
	    var index;
	
	    //  Fast path to avoid array mutation and iteration
	    if (!Array.isArray(item))
	    {
	        index = array.indexOf(item);
	
	        if (index !== -1)
	        {
	            SpliceOne(array, index);
	
	            if (callback)
	            {
	                callback.call(context, item);
	            }
	
	            return item;
	        }
	        else
	        {
	            return null;
	        }
	    }
	
	    //  If we got this far, we have an array of items to remove
	
	    var itemLength = item.length - 1;
	
	    while (itemLength >= 0)
	    {
	        var entry = item[itemLength];
	
	        index = array.indexOf(entry);
	
	        if (index !== -1)
	        {
	            SpliceOne(array, index);
	
	            if (callback)
	            {
	                callback.call(context, entry);
	            }
	        }
	        else
	        {
	            //  Item wasn't found in the array, so remove it from our return results
	            item.pop();
	        }
	
	        itemLength--;
	    }
	
	    return item;
	};
	
	module.exports = Remove;


/***/ }),
/* 661 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Moves the element at the start of the array to the end, shifting all items in the process.
	 * The "rotation" happens to the left.
	 *
	 * @function Phaser.Utils.Array.RotateLeft
	 * @since 3.0.0
	 *
	 * @param {array} array - The array to shift to the left. This array is modified in place.
	 * @param {integer} [total=1] - The number of times to shift the array.
	 *
	 * @return {*} The most recently shifted element.
	 */
	var RotateLeft = function (array, total)
	{
	    if (total === undefined) { total = 1; }
	
	    var element = null;
	
	    for (var i = 0; i < total; i++)
	    {
	        element = array.shift();
	        array.push(element);
	    }
	
	    return element;
	};
	
	module.exports = RotateLeft;


/***/ }),
/* 662 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Moves the element at the end of the array to the start, shifting all items in the process.
	 * The "rotation" happens to the right.
	 *
	 * @function Phaser.Utils.Array.RotateRight
	 * @since 3.0.0
	 *
	 * @param {array} array - The array to shift to the right. This array is modified in place.
	 * @param {integer} [total=1] - The number of times to shift the array.
	 *
	 * @return {*} The most recently shifted element.
	 */
	var RotateRight = function (array, total)
	{
	    if (total === undefined) { total = 1; }
	
	    var element = null;
	
	    for (var i = 0; i < total; i++)
	    {
	        element = array.pop();
	        array.unshift(element);
	    }
	
	    return element;
	};
	
	module.exports = RotateRight;


/***/ }),
/* 663 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	// Transposes the elements of the given matrix (array of arrays).
	// The transpose of a matrix is a new matrix whose rows are the columns of the original.
	
	/**
	 * [description]
	 *
	 * @function Phaser.Utils.Array.Matrix.TransposeMatrix
	 * @since 3.0.0
	 *
	 * @param {array} array - The array matrix to transpose.
	 *
	 * @return {array} A new array matrix which is a transposed version of the given array.
	 */
	var TransposeMatrix = function (array)
	{
	    var sourceRowCount = array.length;
	    var sourceColCount = array[0].length;
	
	    var result = new Array(sourceColCount);
	
	    for (var i = 0; i < sourceColCount; i++)
	    {
	        result[i] = new Array(sourceRowCount);
	
	        for (var j = sourceRowCount - 1; j > -1; j--)
	        {
	            result[i][j] = array[j][i];
	        }
	    }
	
	    return result;
	};
	
	module.exports = TransposeMatrix;


/***/ }),
/* 664 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Verifies that an object contains at least one of the requested keys
	 *
	 * @function Phaser.Utils.Object.HasAny
	 * @since 3.0.0
	 *
	 * @param {object} source - an object on which to check for key existence
	 * @param {string[]} keys - an array of keys to search the object for
	 *
	 * @return {boolean} true if the source object contains at least one of the keys, false otherwise
	 */
	var HasAny = function (source, keys)
	{
	    for (var i = 0; i < keys.length; i++)
	    {
	        if (source.hasOwnProperty(keys[i]))
	        {
	            return true;
	        }
	    }
	
	    return false;
	};
	
	module.exports = HasAny;


/***/ }),
/* 665 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Capitalizes the first letter of a string if there is one.
	 * @example
	 * UppercaseFirst('abc');
	 * // returns 'Abc'
	 * @example
	 * UppercaseFirst('the happy family');
	 * // returns 'The happy family'
	 * @example
	 * UppercaseFirst('');
	 * // returns ''
	 *
	 * @function Phaser.Utils.String.UppercaseFirst
	 * @since 3.0.0
	 *
	 * @param {string} str - The string to capitalize.
	 *
	 * @return {string} A new string, same as the first, but with the first letter capitalized.
	 */
	var UppercaseFirst = function (str)
	{
	    return str && str[0].toUpperCase() + str.slice(1);
	};
	
	module.exports = UppercaseFirst;


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.14.3
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
	
	var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	var timeoutDuration = 0;
	for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	    timeoutDuration = 1;
	    break;
	  }
	}
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var css = getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? html['offset' + axis] + computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')] + computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')] : 0);
	}
	
	function getWindowSizes() {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes() : {};
	  var width = sizes.width || element.clientWidth || result.right - result.left;
	  var height = sizes.height || element.clientHeight || result.bottom - result.top;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && parent.nodeName === 'HTML') {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop, 10);
	    var marginLeft = parseFloat(styles.marginLeft, 10);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  return isFixed(getParentNode(element));
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  boundaries.left += padding;
	  boundaries.top += padding;
	  boundaries.right -= padding;
	  boundaries.bottom -= padding;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var styles = getComputedStyle(element);
	  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
	  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroy the popper
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicity asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger onUpdate callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  // Avoid blurry text by using full pixel integers.
	  // For pixel-perfect positioning, top/bottom prefers rounded
	  // values, while left/right prefers floored values.
	  var offsets = {
	    left: Math.floor(popper.left),
	    top: Math.round(popper.top),
	    bottom: Math.round(popper.bottom),
	    right: Math.floor(popper.right)
	  };
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    top = -offsetParentRect.height + offsets.bottom;
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    left = -offsetParentRect.width + offsets.right;
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjuction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-right` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unitless, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the height.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > More on this [reading this issue](https://github.com/FezVrasta/popper.js/issues/373)
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * An scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper this makes sure the popper has always a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier, can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near eachothers
	   * without leaving any gap between the two. Expecially useful when the arrow is
	   * enabled and you want to assure it to point to its reference element.
	   * It cares only about the first axis, you can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjuction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations).
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position,
	     * the popper will never be placed outside of the defined boundaries
	     * (except if keepTogether is enabled)
	     */
	    boundariesElement: 'viewport'
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3d transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties.
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define you own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3d transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties.
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the informations used by Popper.js
	 * this object get passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper.
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper, it expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow, it expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements.
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overriden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass as 3rd argument an object with the same
	 * structure of this object, example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated, this callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Create a new Popper.js instance
	   * @class Popper
	   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
	   * @param {HTMLElement} popper - The HTML element used as popper.
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedule an update, it will run on the next UI update available
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/games/atlas_chicken-game-0.a5f1611.png";

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/games/atlas_chicken-game-1.156be9a.png";

/***/ }),
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tab = __webpack_require__(704);
	
	var _tab2 = _interopRequireDefault(_tab);
	
	var _collapse = __webpack_require__(700);
	
	var _collapse2 = _interopRequireDefault(_collapse);
	
	var _dropdown = __webpack_require__(701);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _modal = __webpack_require__(702);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _tooltip = __webpack_require__(376);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _popover = __webpack_require__(703);
	
	var _popover2 = _interopRequireDefault(_popover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by jv on 24/07/2017.
	 */
	exports.default = {
	  Tab: _tab2.default,
	  Collapse: _collapse2.default,
	  Dropdown: _dropdown2.default,
	  Modal: _modal2.default,
	  Tooltip: _tooltip2.default,
	  Popover: _popover2.default
	};

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __webpack_require__(149);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * --------------------------------------------------------------------------
	 * Bootstrap (v4.0.0-alpha.6): collapse.js
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * --------------------------------------------------------------------------
	 */
	
	var Collapse = function ($) {
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME = 'collapse';
	  var VERSION = '4.0.0-alpha.6';
	  var DATA_KEY = 'bs.collapse';
	  var EVENT_KEY = '.' + DATA_KEY;
	  var DATA_API_KEY = '.data-api';
	  var JQUERY_NO_CONFLICT = $.fn[NAME];
	  var TRANSITION_DURATION = 600;
	
	  var Default = {
	    toggle: true,
	    parent: ''
	  };
	
	  var DefaultType = {
	    toggle: 'boolean',
	    parent: 'string'
	  };
	
	  var Event = {
	    SHOW: 'show' + EVENT_KEY,
	    SHOWN: 'shown' + EVENT_KEY,
	    HIDE: 'hide' + EVENT_KEY,
	    HIDDEN: 'hidden' + EVENT_KEY,
	    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
	  };
	
	  var ClassName = {
	    SHOW: 'show',
	    COLLAPSE: 'collapse',
	    COLLAPSING: 'collapsing',
	    COLLAPSED: 'collapsed'
	  };
	
	  var Dimension = {
	    WIDTH: 'width',
	    HEIGHT: 'height'
	  };
	
	  var Selector = {
	    ACTIVES: '.show, .collapsing',
	    DATA_TOGGLE: '[data-toggle="collapse"]'
	
	    /**
	     * ------------------------------------------------------------------------
	     * Class Definition
	     * ------------------------------------------------------------------------
	     */
	
	  };
	  var Collapse = function () {
	    function Collapse(element, config) {
	      _classCallCheck(this, Collapse);
	
	      this._isTransitioning = false;
	      this._element = element;
	      this._config = this._getConfig(config);
	      this._triggerArray = $.makeArray($('[data-toggle="collapse"][href="#' + element.id + '"],' + ('[data-toggle="collapse"][data-target="#' + element.id + '"]')));
	      var tabToggles = $(Selector.DATA_TOGGLE);
	      for (var i = 0; i < tabToggles.length; i++) {
	        var elem = tabToggles[i];
	        var selector = _util2.default.getSelectorFromElement(elem);
	        if (selector !== null && $(selector).filter(element).length > 0) {
	          this._triggerArray.push(elem);
	        }
	      }
	
	      this._parent = this._config.parent ? this._getParent() : null;
	
	      if (!this._config.parent) {
	        this._addAriaAndCollapsedClass(this._element, this._triggerArray);
	      }
	
	      if (this._config.toggle) {
	        this.toggle();
	      }
	    }
	
	    // getters
	
	    _createClass(Collapse, [{
	      key: 'toggle',
	
	
	      // public
	
	      value: function toggle() {
	        if ($(this._element).hasClass(ClassName.SHOW)) {
	          this.hide();
	        } else {
	          this.show();
	        }
	      }
	    }, {
	      key: 'show',
	      value: function show() {
	        var _this = this;
	
	        if (this._isTransitioning || $(this._element).hasClass(ClassName.SHOW)) {
	          return;
	        }
	
	        var actives = void 0;
	        var activesData = void 0;
	
	        if (this._parent) {
	          actives = $.makeArray($(this._parent).children().children(Selector.ACTIVES));
	          if (!actives.length) {
	            actives = null;
	          }
	        }
	
	        if (actives) {
	          activesData = $(actives).data(DATA_KEY);
	          if (activesData && activesData._isTransitioning) {
	            return;
	          }
	        }
	
	        var startEvent = $.Event(Event.SHOW);
	        $(this._element).trigger(startEvent);
	        if (startEvent.isDefaultPrevented()) {
	          return;
	        }
	
	        if (actives) {
	          Collapse._jQueryInterface.call($(actives), 'hide');
	          if (!activesData) {
	            $(actives).data(DATA_KEY, null);
	          }
	        }
	
	        var dimension = this._getDimension();
	
	        $(this._element).removeClass(ClassName.COLLAPSE).addClass(ClassName.COLLAPSING);
	
	        this._element.style[dimension] = 0;
	
	        if (this._triggerArray.length) {
	          $(this._triggerArray).removeClass(ClassName.COLLAPSED).attr('aria-expanded', true);
	        }
	
	        this.setTransitioning(true);
	
	        var complete = function complete() {
	          $(_this._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).addClass(ClassName.SHOW);
	
	          _this._element.style[dimension] = '';
	
	          _this.setTransitioning(false);
	
	          $(_this._element).trigger(Event.SHOWN);
	        };
	
	        if (!_util2.default.supportsTransitionEnd()) {
	          complete();
	          return;
	        }
	
	        var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
	        var scrollSize = 'scroll' + capitalizedDimension;
	
	        $(this._element).one(_util2.default.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
	
	        this._element.style[dimension] = this._element[scrollSize] + 'px';
	      }
	    }, {
	      key: 'hide',
	      value: function hide() {
	        var _this2 = this;
	
	        if (this._isTransitioning || !$(this._element).hasClass(ClassName.SHOW)) {
	          return;
	        }
	
	        var startEvent = $.Event(Event.HIDE);
	        $(this._element).trigger(startEvent);
	        if (startEvent.isDefaultPrevented()) {
	          return;
	        }
	
	        var dimension = this._getDimension();
	
	        this._element.style[dimension] = this._element.getBoundingClientRect()[dimension] + 'px';
	
	        _util2.default.reflow(this._element);
	
	        $(this._element).addClass(ClassName.COLLAPSING).removeClass(ClassName.COLLAPSE).removeClass(ClassName.SHOW);
	
	        if (this._triggerArray.length) {
	          for (var i = 0; i < this._triggerArray.length; i++) {
	            var trigger = this._triggerArray[i];
	            var selector = _util2.default.getSelectorFromElement(trigger);
	            if (selector !== null) {
	              var $elem = $(selector);
	              if (!$elem.hasClass(ClassName.SHOW)) {
	                $(trigger).addClass(ClassName.COLLAPSED).attr('aria-expanded', false);
	              }
	            }
	          }
	        }
	
	        this.setTransitioning(true);
	
	        var complete = function complete() {
	          _this2.setTransitioning(false);
	          $(_this2._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).trigger(Event.HIDDEN);
	        };
	
	        this._element.style[dimension] = '';
	
	        if (!_util2.default.supportsTransitionEnd()) {
	          complete();
	          return;
	        }
	
	        $(this._element).one(_util2.default.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
	      }
	    }, {
	      key: 'setTransitioning',
	      value: function setTransitioning(isTransitioning) {
	        this._isTransitioning = isTransitioning;
	      }
	    }, {
	      key: 'dispose',
	      value: function dispose() {
	        $.removeData(this._element, DATA_KEY);
	
	        this._config = null;
	        this._parent = null;
	        this._element = null;
	        this._triggerArray = null;
	        this._isTransitioning = null;
	      }
	
	      // private
	
	    }, {
	      key: '_getConfig',
	      value: function _getConfig(config) {
	        config = $.extend({}, Default, config);
	        config.toggle = Boolean(config.toggle); // coerce string values
	        _util2.default.typeCheckConfig(NAME, config, DefaultType);
	        return config;
	      }
	    }, {
	      key: '_getDimension',
	      value: function _getDimension() {
	        var hasWidth = $(this._element).hasClass(Dimension.WIDTH);
	        return hasWidth ? Dimension.WIDTH : Dimension.HEIGHT;
	      }
	    }, {
	      key: '_getParent',
	      value: function _getParent() {
	        var _this3 = this;
	
	        var parent = $(this._config.parent)[0];
	        var selector = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]';
	
	        $(parent).find(selector).each(function (i, element) {
	          _this3._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [element]);
	        });
	
	        return parent;
	      }
	    }, {
	      key: '_addAriaAndCollapsedClass',
	      value: function _addAriaAndCollapsedClass(element, triggerArray) {
	        if (element) {
	          var isOpen = $(element).hasClass(ClassName.SHOW);
	
	          if (triggerArray.length) {
	            $(triggerArray).toggleClass(ClassName.COLLAPSED, !isOpen).attr('aria-expanded', isOpen);
	          }
	        }
	      }
	
	      // static
	
	    }], [{
	      key: '_getTargetFromElement',
	      value: function _getTargetFromElement(element) {
	        var selector = _util2.default.getSelectorFromElement(element);
	        return selector ? $(selector)[0] : null;
	      }
	    }, {
	      key: '_jQueryInterface',
	      value: function _jQueryInterface(config) {
	        return this.each(function () {
	          var $this = $(this);
	          var data = $this.data(DATA_KEY);
	          var _config = $.extend({}, Default, $this.data(), (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config);
	
	          if (!data && _config.toggle && /show|hide/.test(config)) {
	            _config.toggle = false;
	          }
	
	          if (!data) {
	            data = new Collapse(this, _config);
	            $this.data(DATA_KEY, data);
	          }
	
	          if (typeof config === 'string') {
	            if (data[config] === undefined) {
	              throw new Error('No method named "' + config + '"');
	            }
	            data[config]();
	          }
	        });
	      }
	    }, {
	      key: 'VERSION',
	      get: function get() {
	        return VERSION;
	      }
	    }, {
	      key: 'Default',
	      get: function get() {
	        return Default;
	      }
	    }]);
	
	    return Collapse;
	  }();
	
	  /**
	   * ------------------------------------------------------------------------
	   * Data Api implementation
	   * ------------------------------------------------------------------------
	   */
	
	  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
	    if (!/input|textarea/i.test(event.target.tagName)) {
	      event.preventDefault();
	    }
	
	    var $trigger = $(this);
	    var selector = _util2.default.getSelectorFromElement(this);
	    $(selector).each(function () {
	      var $target = $(this);
	      var data = $target.data(DATA_KEY);
	      var config = data ? 'toggle' : $trigger.data();
	      Collapse._jQueryInterface.call($target, config);
	    });
	  });
	
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	   */
	
	  $.fn[NAME] = Collapse._jQueryInterface;
	  $.fn[NAME].Constructor = Collapse;
	  $.fn[NAME].noConflict = function () {
	    $.fn[NAME] = JQUERY_NO_CONFLICT;
	    return Collapse._jQueryInterface;
	  };
	
	  return Collapse;
	}(jQuery);
	
	exports.default = Collapse;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _popper = __webpack_require__(666);
	
	var _popper2 = _interopRequireDefault(_popper);
	
	var _util = __webpack_require__(149);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * --------------------------------------------------------------------------
	 * Bootstrap (v4.0.0-beta): dropdown.js
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * --------------------------------------------------------------------------
	 */
	
	var Dropdown = function () {
	
	  /**
	   * Check for Popper dependency
	   * Popper - https://popper.js.org
	   */
	  if (typeof _popper2.default === 'undefined') {
	    throw new Error('Bootstrap dropdown require Popper.js (https://popper.js.org)');
	  }
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME = 'dropdown';
	  var VERSION = '4.0.0-beta';
	  var DATA_KEY = 'bs.dropdown';
	  var EVENT_KEY = '.' + DATA_KEY;
	  var DATA_API_KEY = '.data-api';
	  var JQUERY_NO_CONFLICT = _jquery2.default.fn[NAME];
	  var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key
	  var SPACE_KEYCODE = 32; // KeyboardEvent.which value for space key
	  var TAB_KEYCODE = 9; // KeyboardEvent.which value for tab key
	  var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key
	  var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key
	  var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)
	  var REGEXP_KEYDOWN = new RegExp(ARROW_UP_KEYCODE + '|' + ARROW_DOWN_KEYCODE + '|' + ESCAPE_KEYCODE);
	
	  var Event = {
	    HIDE: 'hide' + EVENT_KEY,
	    HIDDEN: 'hidden' + EVENT_KEY,
	    SHOW: 'show' + EVENT_KEY,
	    SHOWN: 'shown' + EVENT_KEY,
	    CLICK: 'click' + EVENT_KEY,
	    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY,
	    KEYDOWN_DATA_API: 'keydown' + EVENT_KEY + DATA_API_KEY,
	    KEYUP_DATA_API: 'keyup' + EVENT_KEY + DATA_API_KEY
	  };
	
	  var ClassName = {
	    DISABLED: 'disabled',
	    SHOW: 'show',
	    DROPUP: 'dropup',
	    MENURIGHT: 'dropdown-menu-right',
	    MENULEFT: 'dropdown-menu-left'
	  };
	
	  var Selector = {
	    DATA_TOGGLE: '[data-toggle="dropdown"]',
	    FORM_CHILD: '.dropdown form',
	    MENU: '.dropdown-menu',
	    NAVBAR_NAV: '.navbar-nav',
	    VISIBLE_ITEMS: '.dropdown-menu .dropdown-item:not(.disabled)'
	  };
	
	  var AttachmentMap = {
	    TOP: 'top-start',
	    TOPEND: 'top-end',
	    BOTTOM: 'bottom-start',
	    BOTTOMEND: 'bottom-end'
	  };
	
	  var Default = {
	    offset: 0,
	    flip: true
	  };
	
	  var DefaultType = {
	    offset: '(number|string|function)',
	    flip: 'boolean'
	
	    /**
	     * ------------------------------------------------------------------------
	     * Class Definition
	     * ------------------------------------------------------------------------
	     */
	
	  };
	  var Dropdown = function () {
	    function Dropdown(element, config) {
	      _classCallCheck(this, Dropdown);
	
	      this._element = element;
	      this._popper = null;
	      this._config = this._getConfig(config);
	      this._menu = this._getMenuElement();
	      this._inNavbar = this._detectNavbar();
	
	      this._addEventListeners();
	    }
	
	    // getters
	
	    _createClass(Dropdown, [{
	      key: 'toggle',
	
	
	      // public
	
	      value: function toggle() {
	        if (this._element.disabled || (0, _jquery2.default)(this._element).hasClass(ClassName.DISABLED)) {
	          return;
	        }
	
	        var parent = Dropdown._getParentFromElement(this._element);
	        var isActive = (0, _jquery2.default)(this._menu).hasClass(ClassName.SHOW);
	
	        Dropdown._clearMenus();
	
	        if (isActive) {
	          return;
	        }
	
	        var relatedTarget = {
	          relatedTarget: this._element
	        };
	        var showEvent = _jquery2.default.Event(Event.SHOW, relatedTarget);
	
	        (0, _jquery2.default)(parent).trigger(showEvent);
	
	        if (showEvent.isDefaultPrevented()) {
	          return;
	        }
	
	        var element = this._element;
	        // for dropup with alignment we use the parent as popper container
	        if ((0, _jquery2.default)(parent).hasClass(ClassName.DROPUP)) {
	          if ((0, _jquery2.default)(this._menu).hasClass(ClassName.MENULEFT) || (0, _jquery2.default)(this._menu).hasClass(ClassName.MENURIGHT)) {
	            element = parent;
	          }
	        }
	        this._popper = new _popper2.default(element, this._menu, this._getPopperConfig());
	
	        // if this is a touch-enabled device we add extra
	        // empty mouseover listeners to the body's immediate children;
	        // only needed because of broken event delegation on iOS
	        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
	        if ('ontouchstart' in document.documentElement && !(0, _jquery2.default)(parent).closest(Selector.NAVBAR_NAV).length) {
	          (0, _jquery2.default)('body').children().on('mouseover', null, _jquery2.default.noop);
	        }
	
	        this._element.focus();
	        this._element.setAttribute('aria-expanded', true);
	
	        (0, _jquery2.default)(this._menu).toggleClass(ClassName.SHOW);
	        (0, _jquery2.default)(parent).toggleClass(ClassName.SHOW).trigger(_jquery2.default.Event(Event.SHOWN, relatedTarget));
	      }
	    }, {
	      key: 'dispose',
	      value: function dispose() {
	        _jquery2.default.removeData(this._element, DATA_KEY);
	        (0, _jquery2.default)(this._element).off(EVENT_KEY);
	        this._element = null;
	        this._menu = null;
	        if (this._popper !== null) {
	          this._popper.destroy();
	        }
	        this._popper = null;
	      }
	    }, {
	      key: 'update',
	      value: function update() {
	        this._inNavbar = this._detectNavbar();
	        if (this._popper !== null) {
	          this._popper.scheduleUpdate();
	        }
	      }
	
	      // private
	
	    }, {
	      key: '_addEventListeners',
	      value: function _addEventListeners() {
	        var _this = this;
	
	        (0, _jquery2.default)(this._element).on(Event.CLICK, function (event) {
	          event.preventDefault();
	          event.stopPropagation();
	          _this.toggle();
	        });
	      }
	    }, {
	      key: '_getConfig',
	      value: function _getConfig(config) {
	        config = _jquery2.default.extend({}, this.constructor.Default, (0, _jquery2.default)(this._element).data(), config);
	
	        _util2.default.typeCheckConfig(NAME, config, this.constructor.DefaultType);
	
	        return config;
	      }
	    }, {
	      key: '_getMenuElement',
	      value: function _getMenuElement() {
	        if (!this._menu) {
	          var parent = Dropdown._getParentFromElement(this._element);
	          this._menu = (0, _jquery2.default)(parent).find(Selector.MENU)[0];
	        }
	        return this._menu;
	      }
	    }, {
	      key: '_getPlacement',
	      value: function _getPlacement() {
	        var $parentDropdown = (0, _jquery2.default)(this._element).parent();
	        var placement = AttachmentMap.BOTTOM;
	
	        // Handle dropup
	        if ($parentDropdown.hasClass(ClassName.DROPUP)) {
	          placement = AttachmentMap.TOP;
	          if ((0, _jquery2.default)(this._menu).hasClass(ClassName.MENURIGHT)) {
	            placement = AttachmentMap.TOPEND;
	          }
	        } else if ((0, _jquery2.default)(this._menu).hasClass(ClassName.MENURIGHT)) {
	          placement = AttachmentMap.BOTTOMEND;
	        }
	        return placement;
	      }
	    }, {
	      key: '_detectNavbar',
	      value: function _detectNavbar() {
	        return (0, _jquery2.default)(this._element).closest('.navbar').length > 0;
	      }
	    }, {
	      key: '_getPopperConfig',
	      value: function _getPopperConfig() {
	        var _this2 = this;
	
	        var offsetConf = {};
	        if (typeof this._config.offset === 'function') {
	          offsetConf.fn = function (data) {
	            data.offsets = _jquery2.default.extend({}, data.offsets, _this2._config.offset(data.offsets) || {});
	            return data;
	          };
	        } else {
	          offsetConf.offset = this._config.offset;
	        }
	        var popperConfig = {
	          placement: this._getPlacement(),
	          modifiers: {
	            offset: offsetConf,
	            flip: {
	              enabled: this._config.flip
	            }
	          }
	
	          // Disable Popper.js for Dropdown in Navbar
	        };if (this._inNavbar) {
	          popperConfig.modifiers.applyStyle = {
	            enabled: !this._inNavbar
	          };
	        }
	        return popperConfig;
	      }
	
	      // static
	
	    }], [{
	      key: '_jQueryInterface',
	      value: function _jQueryInterface(config) {
	        return this.each(function () {
	          var data = (0, _jquery2.default)(this).data(DATA_KEY);
	          var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' ? config : null;
	
	          if (!data) {
	            data = new Dropdown(this, _config);
	            (0, _jquery2.default)(this).data(DATA_KEY, data);
	          }
	
	          if (typeof config === 'string') {
	            if (typeof data[config] === 'undefined') {
	              throw new Error('No method named "' + config + '"');
	            }
	            data[config]();
	          }
	        });
	      }
	    }, {
	      key: '_clearMenus',
	      value: function _clearMenus(event) {
	        if (event && (event.which === RIGHT_MOUSE_BUTTON_WHICH || event.type === 'keyup' && event.which !== TAB_KEYCODE)) {
	          return;
	        }
	
	        var toggles = _jquery2.default.makeArray((0, _jquery2.default)(Selector.DATA_TOGGLE));
	        for (var i = 0; i < toggles.length; i++) {
	          var parent = Dropdown._getParentFromElement(toggles[i]);
	          var context = (0, _jquery2.default)(toggles[i]).data(DATA_KEY);
	          var relatedTarget = {
	            relatedTarget: toggles[i]
	          };
	
	          if (!context) {
	            continue;
	          }
	
	          var dropdownMenu = context._menu;
	          if (!(0, _jquery2.default)(parent).hasClass(ClassName.SHOW)) {
	            continue;
	          }
	
	          if (event && (event.type === 'click' && /input|textarea/i.test(event.target.tagName) || event.type === 'keyup' && event.which === TAB_KEYCODE) && _jquery2.default.contains(parent, event.target)) {
	            continue;
	          }
	
	          var hideEvent = _jquery2.default.Event(Event.HIDE, relatedTarget);
	          (0, _jquery2.default)(parent).trigger(hideEvent);
	          if (hideEvent.isDefaultPrevented()) {
	            continue;
	          }
	
	          // if this is a touch-enabled device we remove the extra
	          // empty mouseover listeners we added for iOS support
	          if ('ontouchstart' in document.documentElement) {
	            (0, _jquery2.default)('body').children().off('mouseover', null, _jquery2.default.noop);
	          }
	
	          toggles[i].setAttribute('aria-expanded', 'false');
	
	          (0, _jquery2.default)(dropdownMenu).removeClass(ClassName.SHOW);
	          (0, _jquery2.default)(parent).removeClass(ClassName.SHOW).trigger(_jquery2.default.Event(Event.HIDDEN, relatedTarget));
	        }
	      }
	    }, {
	      key: '_getParentFromElement',
	      value: function _getParentFromElement(element) {
	        var parent = void 0;
	        var selector = _util2.default.getSelectorFromElement(element);
	
	        if (selector) {
	          parent = (0, _jquery2.default)(selector)[0];
	        }
	
	        return parent || element.parentNode;
	      }
	    }, {
	      key: '_dataApiKeydownHandler',
	      value: function _dataApiKeydownHandler(event) {
	        if (!REGEXP_KEYDOWN.test(event.which) || /button/i.test(event.target.tagName) && event.which === SPACE_KEYCODE || /input|textarea/i.test(event.target.tagName)) {
	          return;
	        }
	
	        event.preventDefault();
	        event.stopPropagation();
	
	        if (this.disabled || (0, _jquery2.default)(this).hasClass(ClassName.DISABLED)) {
	          return;
	        }
	
	        var parent = Dropdown._getParentFromElement(this);
	        var isActive = (0, _jquery2.default)(parent).hasClass(ClassName.SHOW);
	
	        if (!isActive && (event.which !== ESCAPE_KEYCODE || event.which !== SPACE_KEYCODE) || isActive && (event.which === ESCAPE_KEYCODE || event.which === SPACE_KEYCODE)) {
	
	          if (event.which === ESCAPE_KEYCODE) {
	            var toggle = (0, _jquery2.default)(parent).find(Selector.DATA_TOGGLE)[0];
	            (0, _jquery2.default)(toggle).trigger('focus');
	          }
	
	          (0, _jquery2.default)(this).trigger('click');
	          return;
	        }
	
	        var items = (0, _jquery2.default)(parent).find(Selector.VISIBLE_ITEMS).get();
	
	        if (!items.length) {
	          return;
	        }
	
	        var index = items.indexOf(event.target);
	
	        if (event.which === ARROW_UP_KEYCODE && index > 0) {
	          // up
	          index--;
	        }
	
	        if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) {
	          // down
	          index++;
	        }
	
	        if (index < 0) {
	          index = 0;
	        }
	
	        items[index].focus();
	      }
	    }, {
	      key: 'VERSION',
	      get: function get() {
	        return VERSION;
	      }
	    }, {
	      key: 'Default',
	      get: function get() {
	        return Default;
	      }
	    }, {
	      key: 'DefaultType',
	      get: function get() {
	        return DefaultType;
	      }
	    }]);
	
	    return Dropdown;
	  }();
	
	  /**
	   * ------------------------------------------------------------------------
	   * Data Api implementation
	   * ------------------------------------------------------------------------
	   */
	
	  (0, _jquery2.default)(document).on(Event.KEYDOWN_DATA_API, Selector.DATA_TOGGLE, Dropdown._dataApiKeydownHandler).on(Event.KEYDOWN_DATA_API, Selector.MENU, Dropdown._dataApiKeydownHandler).on(Event.CLICK_DATA_API + ' ' + Event.KEYUP_DATA_API, Dropdown._clearMenus).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
	    event.preventDefault();
	    event.stopPropagation();
	    Dropdown._jQueryInterface.call((0, _jquery2.default)(this), 'toggle');
	  }).on(Event.CLICK_DATA_API, Selector.FORM_CHILD, function (e) {
	    e.stopPropagation();
	  });
	
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	   */
	
	  _jquery2.default.fn[NAME] = Dropdown._jQueryInterface;
	  _jquery2.default.fn[NAME].Constructor = Dropdown;
	  _jquery2.default.fn[NAME].noConflict = function () {
	    _jquery2.default.fn[NAME] = JQUERY_NO_CONFLICT;
	    return Dropdown._jQueryInterface;
	  };
	
	  return Dropdown;
	}(_jquery2.default, _popper2.default);
	
	exports.default = Dropdown;

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(14);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _util = __webpack_require__(149);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * --------------------------------------------------------------------------
	 * Bootstrap (v4.0.0-beta): modal.js
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * --------------------------------------------------------------------------
	 */
	
	var Modal = function () {
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME = 'modal';
	  var VERSION = '4.0.0-beta';
	  var DATA_KEY = 'bs.modal';
	  var EVENT_KEY = '.' + DATA_KEY;
	  var DATA_API_KEY = '.data-api';
	  var JQUERY_NO_CONFLICT = _jquery2.default.fn[NAME];
	  var TRANSITION_DURATION = 300;
	  var BACKDROP_TRANSITION_DURATION = 150;
	  var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key
	
	  var Default = {
	    backdrop: true,
	    keyboard: true,
	    focus: true,
	    show: true
	  };
	
	  var DefaultType = {
	    backdrop: '(boolean|string)',
	    keyboard: 'boolean',
	    focus: 'boolean',
	    show: 'boolean'
	  };
	
	  var Event = {
	    HIDE: 'hide' + EVENT_KEY,
	    HIDDEN: 'hidden' + EVENT_KEY,
	    SHOW: 'show' + EVENT_KEY,
	    SHOWN: 'shown' + EVENT_KEY,
	    FOCUSIN: 'focusin' + EVENT_KEY,
	    RESIZE: 'resize' + EVENT_KEY,
	    CLICK_DISMISS: 'click.dismiss' + EVENT_KEY,
	    KEYDOWN_DISMISS: 'keydown.dismiss' + EVENT_KEY,
	    MOUSEUP_DISMISS: 'mouseup.dismiss' + EVENT_KEY,
	    MOUSEDOWN_DISMISS: 'mousedown.dismiss' + EVENT_KEY,
	    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
	  };
	
	  var ClassName = {
	    SCROLLBAR_MEASURER: 'modal-scrollbar-measure',
	    BACKDROP: 'modal-backdrop',
	    OPEN: 'modal-open',
	    FADE: 'fade',
	    SHOW: 'show'
	  };
	
	  var Selector = {
	    DIALOG: '.modal-dialog',
	    DATA_TOGGLE: '[data-toggle="modal"]',
	    DATA_DISMISS: '[data-dismiss="modal"]',
	    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
	    STICKY_CONTENT: '.sticky-top',
	    NAVBAR_TOGGLER: '.navbar-toggler'
	
	    /**
	     * ------------------------------------------------------------------------
	     * Class Definition
	     * ------------------------------------------------------------------------
	     */
	
	  };
	  var Modal = function () {
	    function Modal(element, config) {
	      _classCallCheck(this, Modal);
	
	      this._config = this._getConfig(config);
	      this._element = element;
	      this._dialog = (0, _jquery2.default)(element).find(Selector.DIALOG)[0];
	      this._backdrop = null;
	      this._isShown = false;
	      this._isBodyOverflowing = false;
	      this._ignoreBackdropClick = false;
	      this._originalBodyPadding = 0;
	      this._scrollbarWidth = 0;
	    }
	
	    // getters
	
	    _createClass(Modal, [{
	      key: 'toggle',
	
	
	      // public
	
	      value: function toggle(relatedTarget) {
	        return this._isShown ? this.hide() : this.show(relatedTarget);
	      }
	    }, {
	      key: 'show',
	      value: function show(relatedTarget) {
	        var _this = this;
	
	        if (this._isTransitioning) {
	          return;
	        }
	
	        if (_util2.default.supportsTransitionEnd() && (0, _jquery2.default)(this._element).hasClass(ClassName.FADE)) {
	          this._isTransitioning = true;
	        }
	
	        var showEvent = _jquery2.default.Event(Event.SHOW, {
	          relatedTarget: relatedTarget
	        });
	
	        (0, _jquery2.default)(this._element).trigger(showEvent);
	
	        if (this._isShown || showEvent.isDefaultPrevented()) {
	          return;
	        }
	
	        this._isShown = true;
	
	        this._checkScrollbar();
	        this._setScrollbar();
	
	        this._adjustDialog();
	
	        (0, _jquery2.default)(document.body).addClass(ClassName.OPEN);
	
	        this._setEscapeEvent();
	        this._setResizeEvent();
	
	        (0, _jquery2.default)(this._element).on(Event.CLICK_DISMISS, Selector.DATA_DISMISS, function (event) {
	          return _this.hide(event);
	        });
	
	        (0, _jquery2.default)(this._dialog).on(Event.MOUSEDOWN_DISMISS, function () {
	          (0, _jquery2.default)(_this._element).one(Event.MOUSEUP_DISMISS, function (event) {
	            if ((0, _jquery2.default)(event.target).is(_this._element)) {
	              _this._ignoreBackdropClick = true;
	            }
	          });
	        });
	
	        this._showBackdrop(function () {
	          return _this._showElement(relatedTarget);
	        });
	      }
	    }, {
	      key: 'hide',
	      value: function hide(event) {
	        var _this2 = this;
	
	        if (event) {
	          event.preventDefault();
	        }
	
	        if (this._isTransitioning || !this._isShown) {
	          return;
	        }
	
	        var transition = _util2.default.supportsTransitionEnd() && (0, _jquery2.default)(this._element).hasClass(ClassName.FADE);
	
	        if (transition) {
	          this._isTransitioning = true;
	        }
	
	        var hideEvent = _jquery2.default.Event(Event.HIDE);
	
	        (0, _jquery2.default)(this._element).trigger(hideEvent);
	
	        if (!this._isShown || hideEvent.isDefaultPrevented()) {
	          return;
	        }
	
	        this._isShown = false;
	
	        this._setEscapeEvent();
	        this._setResizeEvent();
	
	        (0, _jquery2.default)(document).off(Event.FOCUSIN);
	
	        (0, _jquery2.default)(this._element).removeClass(ClassName.SHOW);
	
	        (0, _jquery2.default)(this._element).off(Event.CLICK_DISMISS);
	        (0, _jquery2.default)(this._dialog).off(Event.MOUSEDOWN_DISMISS);
	
	        if (transition) {
	
	          (0, _jquery2.default)(this._element).one(_util2.default.TRANSITION_END, function (event) {
	            return _this2._hideModal(event);
	          }).emulateTransitionEnd(TRANSITION_DURATION);
	        } else {
	          this._hideModal();
	        }
	      }
	    }, {
	      key: 'dispose',
	      value: function dispose() {
	        _jquery2.default.removeData(this._element, DATA_KEY);
	
	        (0, _jquery2.default)(window, document, this._element, this._backdrop).off(EVENT_KEY);
	
	        this._config = null;
	        this._element = null;
	        this._dialog = null;
	        this._backdrop = null;
	        this._isShown = null;
	        this._isBodyOverflowing = null;
	        this._ignoreBackdropClick = null;
	        this._scrollbarWidth = null;
	      }
	    }, {
	      key: 'handleUpdate',
	      value: function handleUpdate() {
	        this._adjustDialog();
	      }
	
	      // private
	
	    }, {
	      key: '_getConfig',
	      value: function _getConfig(config) {
	        config = _jquery2.default.extend({}, Default, config);
	        _util2.default.typeCheckConfig(NAME, config, DefaultType);
	        return config;
	      }
	    }, {
	      key: '_showElement',
	      value: function _showElement(relatedTarget) {
	        var _this3 = this;
	
	        var transition = _util2.default.supportsTransitionEnd() && (0, _jquery2.default)(this._element).hasClass(ClassName.FADE);
	
	        if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
	          // don't move modals dom position
	          document.body.appendChild(this._element);
	        }
	
	        this._element.style.display = 'block';
	        this._element.removeAttribute('aria-hidden');
	        this._element.scrollTop = 0;
	
	        if (transition) {
	          _util2.default.reflow(this._element);
	        }
	
	        (0, _jquery2.default)(this._element).addClass(ClassName.SHOW);
	
	        if (this._config.focus) {
	          this._enforceFocus();
	        }
	
	        var shownEvent = _jquery2.default.Event(Event.SHOWN, {
	          relatedTarget: relatedTarget
	        });
	
	        var transitionComplete = function transitionComplete() {
	          if (_this3._config.focus) {
	            _this3._element.focus();
	          }
	          _this3._isTransitioning = false;
	          (0, _jquery2.default)(_this3._element).trigger(shownEvent);
	        };
	
	        if (transition) {
	          (0, _jquery2.default)(this._dialog).one(_util2.default.TRANSITION_END, transitionComplete).emulateTransitionEnd(TRANSITION_DURATION);
	        } else {
	          transitionComplete();
	        }
	      }
	    }, {
	      key: '_enforceFocus',
	      value: function _enforceFocus() {
	        var _this4 = this;
	
	        (0, _jquery2.default)(document).off(Event.FOCUSIN) // guard against infinite focus loop
	        .on(Event.FOCUSIN, function (event) {
	          if (document !== event.target && _this4._element !== event.target && !(0, _jquery2.default)(_this4._element).has(event.target).length) {
	            _this4._element.focus();
	          }
	        });
	      }
	    }, {
	      key: '_setEscapeEvent',
	      value: function _setEscapeEvent() {
	        var _this5 = this;
	
	        if (this._isShown && this._config.keyboard) {
	          (0, _jquery2.default)(this._element).on(Event.KEYDOWN_DISMISS, function (event) {
	            if (event.which === ESCAPE_KEYCODE) {
	              event.preventDefault();
	              _this5.hide();
	            }
	          });
	        } else if (!this._isShown) {
	          (0, _jquery2.default)(this._element).off(Event.KEYDOWN_DISMISS);
	        }
	      }
	    }, {
	      key: '_setResizeEvent',
	      value: function _setResizeEvent() {
	        var _this6 = this;
	
	        if (this._isShown) {
	          (0, _jquery2.default)(window).on(Event.RESIZE, function (event) {
	            return _this6.handleUpdate(event);
	          });
	        } else {
	          (0, _jquery2.default)(window).off(Event.RESIZE);
	        }
	      }
	    }, {
	      key: '_hideModal',
	      value: function _hideModal() {
	        var _this7 = this;
	
	        this._element.style.display = 'none';
	        this._element.setAttribute('aria-hidden', true);
	        this._isTransitioning = false;
	        this._showBackdrop(function () {
	          (0, _jquery2.default)(document.body).removeClass(ClassName.OPEN);
	          _this7._resetAdjustments();
	          _this7._resetScrollbar();
	          (0, _jquery2.default)(_this7._element).trigger(Event.HIDDEN);
	        });
	      }
	    }, {
	      key: '_removeBackdrop',
	      value: function _removeBackdrop() {
	        if (this._backdrop) {
	          (0, _jquery2.default)(this._backdrop).remove();
	          this._backdrop = null;
	        }
	      }
	    }, {
	      key: '_showBackdrop',
	      value: function _showBackdrop(callback) {
	        var _this8 = this;
	
	        var animate = (0, _jquery2.default)(this._element).hasClass(ClassName.FADE) ? ClassName.FADE : '';
	
	        if (this._isShown && this._config.backdrop) {
	          var doAnimate = _util2.default.supportsTransitionEnd() && animate;
	
	          this._backdrop = document.createElement('div');
	          this._backdrop.className = ClassName.BACKDROP;
	
	          if (animate) {
	            (0, _jquery2.default)(this._backdrop).addClass(animate);
	          }
	
	          (0, _jquery2.default)(this._backdrop).appendTo(document.body);
	
	          (0, _jquery2.default)(this._element).on(Event.CLICK_DISMISS, function (event) {
	            if (_this8._ignoreBackdropClick) {
	              _this8._ignoreBackdropClick = false;
	              return;
	            }
	            if (event.target !== event.currentTarget) {
	              return;
	            }
	            if (_this8._config.backdrop === 'static') {
	              _this8._element.focus();
	            } else {
	              _this8.hide();
	            }
	          });
	
	          if (doAnimate) {
	            _util2.default.reflow(this._backdrop);
	          }
	
	          (0, _jquery2.default)(this._backdrop).addClass(ClassName.SHOW);
	
	          if (!callback) {
	            return;
	          }
	
	          if (!doAnimate) {
	            callback();
	            return;
	          }
	
	          (0, _jquery2.default)(this._backdrop).one(_util2.default.TRANSITION_END, callback).emulateTransitionEnd(BACKDROP_TRANSITION_DURATION);
	        } else if (!this._isShown && this._backdrop) {
	          (0, _jquery2.default)(this._backdrop).removeClass(ClassName.SHOW);
	
	          var callbackRemove = function callbackRemove() {
	            _this8._removeBackdrop();
	            if (callback) {
	              callback();
	            }
	          };
	
	          if (_util2.default.supportsTransitionEnd() && (0, _jquery2.default)(this._element).hasClass(ClassName.FADE)) {
	            (0, _jquery2.default)(this._backdrop).one(_util2.default.TRANSITION_END, callbackRemove).emulateTransitionEnd(BACKDROP_TRANSITION_DURATION);
	          } else {
	            callbackRemove();
	          }
	        } else if (callback) {
	          callback();
	        }
	      }
	
	      // ----------------------------------------------------------------------
	      // the following methods are used to handle overflowing modals
	      // todo (fat): these should probably be refactored out of modal.js
	      // ----------------------------------------------------------------------
	
	    }, {
	      key: '_adjustDialog',
	      value: function _adjustDialog() {
	        var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
	
	        if (!this._isBodyOverflowing && isModalOverflowing) {
	          this._element.style.paddingLeft = this._scrollbarWidth + 'px';
	        }
	
	        if (this._isBodyOverflowing && !isModalOverflowing) {
	          this._element.style.paddingRight = this._scrollbarWidth + 'px';
	        }
	      }
	    }, {
	      key: '_resetAdjustments',
	      value: function _resetAdjustments() {
	        this._element.style.paddingLeft = '';
	        this._element.style.paddingRight = '';
	      }
	    }, {
	      key: '_checkScrollbar',
	      value: function _checkScrollbar() {
	        var rect = document.body.getBoundingClientRect();
	        this._isBodyOverflowing = rect.left + rect.right < window.innerWidth;
	        this._scrollbarWidth = this._getScrollbarWidth();
	      }
	    }, {
	      key: '_setScrollbar',
	      value: function _setScrollbar() {
	        var _this9 = this;
	
	        if (this._isBodyOverflowing) {
	          // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
	          //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
	
	          // Adjust fixed content padding
	          (0, _jquery2.default)(Selector.FIXED_CONTENT).each(function (index, element) {
	            var actualPadding = (0, _jquery2.default)(element)[0].style.paddingRight;
	            var calculatedPadding = (0, _jquery2.default)(element).css('padding-right');
	            (0, _jquery2.default)(element).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + _this9._scrollbarWidth + 'px');
	          });
	
	          // Adjust sticky content margin
	          (0, _jquery2.default)(Selector.STICKY_CONTENT).each(function (index, element) {
	            var actualMargin = (0, _jquery2.default)(element)[0].style.marginRight;
	            var calculatedMargin = (0, _jquery2.default)(element).css('margin-right');
	            (0, _jquery2.default)(element).data('margin-right', actualMargin).css('margin-right', parseFloat(calculatedMargin) - _this9._scrollbarWidth + 'px');
	          });
	
	          // Adjust navbar-toggler margin
	          (0, _jquery2.default)(Selector.NAVBAR_TOGGLER).each(function (index, element) {
	            var actualMargin = (0, _jquery2.default)(element)[0].style.marginRight;
	            var calculatedMargin = (0, _jquery2.default)(element).css('margin-right');
	            (0, _jquery2.default)(element).data('margin-right', actualMargin).css('margin-right', parseFloat(calculatedMargin) + _this9._scrollbarWidth + 'px');
	          });
	
	          // Adjust body padding
	          var actualPadding = document.body.style.paddingRight;
	          var calculatedPadding = (0, _jquery2.default)('body').css('padding-right');
	          (0, _jquery2.default)('body').data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + this._scrollbarWidth + 'px');
	        }
	      }
	    }, {
	      key: '_resetScrollbar',
	      value: function _resetScrollbar() {
	        // Restore fixed content padding
	        (0, _jquery2.default)(Selector.FIXED_CONTENT).each(function (index, element) {
	          var padding = (0, _jquery2.default)(element).data('padding-right');
	          if (typeof padding !== 'undefined') {
	            (0, _jquery2.default)(element).css('padding-right', padding).removeData('padding-right');
	          }
	        });
	
	        // Restore sticky content and navbar-toggler margin
	        (0, _jquery2.default)(Selector.STICKY_CONTENT + ', ' + Selector.NAVBAR_TOGGLER).each(function (index, element) {
	          var margin = (0, _jquery2.default)(element).data('margin-right');
	          if (typeof margin !== 'undefined') {
	            (0, _jquery2.default)(element).css('margin-right', margin).removeData('margin-right');
	          }
	        });
	
	        // Restore body padding
	        var padding = (0, _jquery2.default)('body').data('padding-right');
	        if (typeof padding !== 'undefined') {
	          (0, _jquery2.default)('body').css('padding-right', padding).removeData('padding-right');
	        }
	      }
	    }, {
	      key: '_getScrollbarWidth',
	      value: function _getScrollbarWidth() {
	        // thx d.walsh
	        var scrollDiv = document.createElement('div');
	        scrollDiv.className = ClassName.SCROLLBAR_MEASURER;
	        document.body.appendChild(scrollDiv);
	        var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
	        document.body.removeChild(scrollDiv);
	        return scrollbarWidth;
	      }
	
	      // static
	
	    }], [{
	      key: '_jQueryInterface',
	      value: function _jQueryInterface(config, relatedTarget) {
	        return this.each(function () {
	          var data = (0, _jquery2.default)(this).data(DATA_KEY);
	          var _config = _jquery2.default.extend({}, Modal.Default, (0, _jquery2.default)(this).data(), (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config);
	
	          if (!data) {
	            data = new Modal(this, _config);
	            (0, _jquery2.default)(this).data(DATA_KEY, data);
	          }
	
	          if (typeof config === 'string') {
	            if (typeof data[config] === 'undefined') {
	              throw new Error('No method named "' + config + '"');
	            }
	            data[config](relatedTarget);
	          } else if (_config.show) {
	            data.show(relatedTarget);
	          }
	        });
	      }
	    }, {
	      key: 'VERSION',
	      get: function get() {
	        return VERSION;
	      }
	    }, {
	      key: 'Default',
	      get: function get() {
	        return Default;
	      }
	    }]);
	
	    return Modal;
	  }();
	
	  /**
	   * ------------------------------------------------------------------------
	   * Data Api implementation
	   * ------------------------------------------------------------------------
	   */
	
	  (0, _jquery2.default)(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
	    var _this10 = this;
	
	    var target = void 0;
	    var selector = _util2.default.getSelectorFromElement(this);
	
	    if (selector) {
	      target = (0, _jquery2.default)(selector)[0];
	    }
	
	    var config = (0, _jquery2.default)(target).data(DATA_KEY) ? 'toggle' : _jquery2.default.extend({}, (0, _jquery2.default)(target).data(), (0, _jquery2.default)(this).data());
	
	    if (this.tagName === 'A' || this.tagName === 'AREA') {
	      event.preventDefault();
	    }
	
	    var $target = (0, _jquery2.default)(target).one(Event.SHOW, function (showEvent) {
	      if (showEvent.isDefaultPrevented()) {
	        // only register focus restorer if modal will actually get shown
	        return;
	      }
	
	      $target.one(Event.HIDDEN, function () {
	        if ((0, _jquery2.default)(_this10).is(':visible')) {
	          _this10.focus();
	        }
	      });
	    });
	
	    Modal._jQueryInterface.call((0, _jquery2.default)(target), config, this);
	  });
	
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	   */
	
	  _jquery2.default.fn[NAME] = Modal._jQueryInterface;
	  _jquery2.default.fn[NAME].Constructor = Modal;
	  _jquery2.default.fn[NAME].noConflict = function () {
	    _jquery2.default.fn[NAME] = JQUERY_NO_CONFLICT;
	    return Modal._jQueryInterface;
	  };
	
	  return Modal;
	}(jQuery);
	
	exports.default = Modal;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _tooltip = __webpack_require__(376);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * --------------------------------------------------------------------------
	 * Bootstrap (v4.0.0-alpha.6): popover.js
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * --------------------------------------------------------------------------
	 */
	
	var Popover = function ($) {
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME = 'popover';
	  var VERSION = '4.0.0-alpha.6';
	  var DATA_KEY = 'bs.popover';
	  var EVENT_KEY = '.' + DATA_KEY;
	  var JQUERY_NO_CONFLICT = $.fn[NAME];
	  var CLASS_PREFIX = 'bs-popover';
	  var BSCLS_PREFIX_REGEX = new RegExp('(^|\\s)' + CLASS_PREFIX + '\\S+', 'g');
	
	  var Default = $.extend({}, _tooltip2.default.Default, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip">' + '<div class="arrow"></div>' + '<h3 class="popover-header"></h3>' + '<div class="popover-body"></div></div>'
	  });
	
	  var DefaultType = $.extend({}, _tooltip2.default.DefaultType, {
	    content: '(string|element|function)'
	  });
	
	  var ClassName = {
	    FADE: 'fade',
	    SHOW: 'show'
	  };
	
	  var Selector = {
	    TITLE: '.popover-header',
	    CONTENT: '.popover-body'
	  };
	
	  var Event = {
	    HIDE: 'hide' + EVENT_KEY,
	    HIDDEN: 'hidden' + EVENT_KEY,
	    SHOW: 'show' + EVENT_KEY,
	    SHOWN: 'shown' + EVENT_KEY,
	    INSERTED: 'inserted' + EVENT_KEY,
	    CLICK: 'click' + EVENT_KEY,
	    FOCUSIN: 'focusin' + EVENT_KEY,
	    FOCUSOUT: 'focusout' + EVENT_KEY,
	    MOUSEENTER: 'mouseenter' + EVENT_KEY,
	    MOUSELEAVE: 'mouseleave' + EVENT_KEY
	
	    /**
	     * ------------------------------------------------------------------------
	     * Class Definition
	     * ------------------------------------------------------------------------
	     */
	
	  };
	  var Popover = function (_Tooltip) {
	    _inherits(Popover, _Tooltip);
	
	    function Popover() {
	      _classCallCheck(this, Popover);
	
	      return _possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).apply(this, arguments));
	    }
	
	    _createClass(Popover, [{
	      key: 'isWithContent',
	
	
	      // overrides
	
	      value: function isWithContent() {
	        return this.getTitle() || this._getContent();
	      }
	    }, {
	      key: 'addAttachmentClass',
	      value: function addAttachmentClass(attachment) {
	        $(this.getTipElement()).addClass(CLASS_PREFIX + '-' + attachment);
	      }
	    }, {
	      key: 'getTipElement',
	      value: function getTipElement() {
	        return this.tip = this.tip || $(this.config.template)[0];
	      }
	    }, {
	      key: 'setContent',
	      value: function setContent() {
	        var $tip = $(this.getTipElement());
	
	        // we use append for html objects to maintain js events
	        this.setElementContent($tip.find(Selector.TITLE), this.getTitle());
	        this.setElementContent($tip.find(Selector.CONTENT), this._getContent());
	
	        $tip.removeClass(ClassName.FADE + ' ' + ClassName.SHOW);
	      }
	
	      // private
	
	    }, {
	      key: '_getContent',
	      value: function _getContent() {
	        return this.element.getAttribute('data-content') || (typeof this.config.content === 'function' ? this.config.content.call(this.element) : this.config.content);
	      }
	    }, {
	      key: '_cleanTipClass',
	      value: function _cleanTipClass() {
	        var $tip = $(this.getTipElement());
	        var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);
	        if (tabClass !== null && tabClass.length > 0) {
	          $tip.removeClass(tabClass.join(''));
	        }
	      }
	
	      // static
	
	    }], [{
	      key: '_jQueryInterface',
	      value: function _jQueryInterface(config) {
	        return this.each(function () {
	          var data = $(this).data(DATA_KEY);
	          var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' ? config : null;
	
	          if (!data && /destroy|hide/.test(config)) {
	            return;
	          }
	
	          if (!data) {
	            data = new Popover(this, _config);
	            $(this).data(DATA_KEY, data);
	          }
	
	          if (typeof config === 'string') {
	            if (data[config] === undefined) {
	              throw new Error('No method named "' + config + '"');
	            }
	            data[config]();
	          }
	        });
	      }
	    }, {
	      key: 'VERSION',
	
	
	      // getters
	
	      get: function get() {
	        return VERSION;
	      }
	    }, {
	      key: 'Default',
	      get: function get() {
	        return Default;
	      }
	    }, {
	      key: 'NAME',
	      get: function get() {
	        return NAME;
	      }
	    }, {
	      key: 'DATA_KEY',
	      get: function get() {
	        return DATA_KEY;
	      }
	    }, {
	      key: 'Event',
	      get: function get() {
	        return Event;
	      }
	    }, {
	      key: 'EVENT_KEY',
	      get: function get() {
	        return EVENT_KEY;
	      }
	    }, {
	      key: 'DefaultType',
	      get: function get() {
	        return DefaultType;
	      }
	    }]);
	
	    return Popover;
	  }(_tooltip2.default);
	
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	   */
	
	  $.fn[NAME] = Popover._jQueryInterface;
	  $.fn[NAME].Constructor = Popover;
	  $.fn[NAME].noConflict = function () {
	    $.fn[NAME] = JQUERY_NO_CONFLICT;
	    return Popover._jQueryInterface;
	  };
	
	  return Popover;
	}(jQuery);
	
	exports.default = Popover;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __webpack_require__(149);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * --------------------------------------------------------------------------
	 * Bootstrap (v4.0.0-alpha.6): tab.js
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * --------------------------------------------------------------------------
	 */
	
	var Tab = function ($) {
	
	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */
	
	  var NAME = 'tab';
	  var VERSION = '4.0.0-alpha.6';
	  var DATA_KEY = 'bs.tab';
	  var EVENT_KEY = '.' + DATA_KEY;
	  var DATA_API_KEY = '.data-api';
	  var JQUERY_NO_CONFLICT = $.fn[NAME];
	  var TRANSITION_DURATION = 150;
	
	  var Event = {
	    HIDE: 'hide' + EVENT_KEY,
	    HIDDEN: 'hidden' + EVENT_KEY,
	    SHOW: 'show' + EVENT_KEY,
	    SHOWN: 'shown' + EVENT_KEY,
	    CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
	  };
	
	  var ClassName = {
	    DROPDOWN_MENU: 'dropdown-menu',
	    ACTIVE: 'active',
	    DISABLED: 'disabled',
	    FADE: 'fade',
	    SHOW: 'show'
	  };
	
	  var Selector = {
	    DROPDOWN: '.dropdown',
	    NAV_LIST_GROUP: '.nav, .list-group',
	    ACTIVE: '.active',
	    DATA_TOGGLE: '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',
	    DROPDOWN_TOGGLE: '.dropdown-toggle',
	    DROPDOWN_ACTIVE_CHILD: '> .dropdown-menu .active'
	
	    /**
	     * ------------------------------------------------------------------------
	     * Class Definition
	     * ------------------------------------------------------------------------
	     */
	
	  };
	  var Tab = function () {
	    function Tab(element) {
	      _classCallCheck(this, Tab);
	
	      this._element = element;
	    }
	
	    // getters
	
	    _createClass(Tab, [{
	      key: 'show',
	
	
	      // public
	
	      value: function show() {
	        var _this = this;
	
	        if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && $(this._element).hasClass(ClassName.ACTIVE) || $(this._element).hasClass(ClassName.DISABLED)) {
	          return;
	        }
	
	        var target = void 0;
	        var previous = void 0;
	        var listElement = $(this._element).closest(Selector.NAV_LIST_GROUP)[0];
	        var selector = _util2.default.getSelectorFromElement(this._element);
	
	        if (listElement) {
	          previous = $.makeArray($(listElement).find(Selector.ACTIVE));
	          previous = previous[previous.length - 1];
	        }
	
	        var hideEvent = $.Event(Event.HIDE, {
	          relatedTarget: this._element
	        });
	
	        var showEvent = $.Event(Event.SHOW, {
	          relatedTarget: previous
	        });
	
	        if (previous) {
	          $(previous).trigger(hideEvent);
	        }
	
	        $(this._element).trigger(showEvent);
	
	        if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) {
	          return;
	        }
	
	        if (selector) {
	          target = $(selector)[0];
	        }
	
	        this._activate(this._element, listElement);
	
	        var complete = function complete() {
	          var hiddenEvent = $.Event(Event.HIDDEN, {
	            relatedTarget: _this._element
	          });
	
	          var shownEvent = $.Event(Event.SHOWN, {
	            relatedTarget: previous
	          });
	
	          $(previous).trigger(hiddenEvent);
	          $(_this._element).trigger(shownEvent);
	        };
	
	        if (target) {
	          this._activate(target, target.parentNode, complete);
	        } else {
	          complete();
	        }
	      }
	    }, {
	      key: 'dispose',
	      value: function dispose() {
	        $.removeData(this._element, DATA_KEY);
	        this._element = null;
	      }
	
	      // private
	
	    }, {
	      key: '_activate',
	      value: function _activate(element, container, callback) {
	        var _this2 = this;
	
	        var active = $(container).find(Selector.ACTIVE)[0];
	        var isTransitioning = callback && _util2.default.supportsTransitionEnd() && active && $(active).hasClass(ClassName.FADE);
	
	        var complete = function complete() {
	          return _this2._transitionComplete(element, active, isTransitioning, callback);
	        };
	
	        if (active && isTransitioning) {
	          $(active).one(_util2.default.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
	        } else {
	          complete();
	        }
	
	        if (active) {
	          $(active).removeClass(ClassName.SHOW);
	        }
	      }
	    }, {
	      key: '_transitionComplete',
	      value: function _transitionComplete(element, active, isTransitioning, callback) {
	        if (active) {
	          $(active).removeClass(ClassName.ACTIVE);
	
	          var dropdownChild = $(active.parentNode).find(Selector.DROPDOWN_ACTIVE_CHILD)[0];
	
	          if (dropdownChild) {
	            $(dropdownChild).removeClass(ClassName.ACTIVE);
	          }
	
	          active.setAttribute('aria-expanded', false);
	        }
	
	        $(element).addClass(ClassName.ACTIVE);
	        element.setAttribute('aria-expanded', true);
	
	        if (isTransitioning) {
	          _util2.default.reflow(element);
	          $(element).addClass(ClassName.SHOW);
	        } else {
	          $(element).removeClass(ClassName.FADE);
	        }
	
	        if (element.parentNode && $(element.parentNode).hasClass(ClassName.DROPDOWN_MENU)) {
	
	          var dropdownElement = $(element).closest(Selector.DROPDOWN)[0];
	          if (dropdownElement) {
	            $(dropdownElement).find(Selector.DROPDOWN_TOGGLE).addClass(ClassName.ACTIVE);
	          }
	
	          element.setAttribute('aria-expanded', true);
	        }
	
	        if (callback) {
	          callback();
	        }
	      }
	
	      // static
	
	    }], [{
	      key: '_jQueryInterface',
	      value: function _jQueryInterface(config) {
	        return this.each(function () {
	          var $this = $(this);
	          var data = $this.data(DATA_KEY);
	
	          if (!data) {
	            data = new Tab(this);
	            $this.data(DATA_KEY, data);
	          }
	
	          if (typeof config === 'string') {
	            if (data[config] === undefined) {
	              throw new Error('No method named "' + config + '"');
	            }
	            data[config]();
	          }
	        });
	      }
	    }, {
	      key: 'VERSION',
	      get: function get() {
	        return VERSION;
	      }
	    }]);
	
	    return Tab;
	  }();
	
	  /**
	   * ------------------------------------------------------------------------
	   * Data Api implementation
	   * ------------------------------------------------------------------------
	   */
	
	  $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
	    event.preventDefault();
	    Tab._jQueryInterface.call($(this), 'show');
	  });
	
	  /**
	   * ------------------------------------------------------------------------
	   * jQuery
	   * ------------------------------------------------------------------------
	   */
	
	  $.fn[NAME] = Tab._jQueryInterface;
	  $.fn[NAME].Constructor = Tab;
	  $.fn[NAME].noConflict = function () {
	    $.fn[NAME] = JQUERY_NO_CONFLICT;
	    return Tab._jQueryInterface;
	  };
	
	  return Tab;
	}(jQuery);
	
	exports.default = Tab;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(906);
	
	__webpack_require__(706);
	
	__webpack_require__(707);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 706 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(714);
	module.exports = __webpack_require__(59).RegExp.escape;


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	var isArray = __webpack_require__(180);
	var SPECIES = __webpack_require__(16)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(11);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(7);
	var toPrimitive = __webpack_require__(68);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(105);
	var gOPS = __webpack_require__(184);
	var pIE = __webpack_require__(152);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 712 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 713 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(2);
	var $re = __webpack_require__(712)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(378) });
	
	__webpack_require__(91)('copyWithin');


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $every = __webpack_require__(64)(4);
	
	$export($export.P + $export.F * !__webpack_require__(61)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Array', { fill: __webpack_require__(223) });
	
	__webpack_require__(91)('fill');


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $filter = __webpack_require__(64)(2);
	
	$export($export.P + $export.F * !__webpack_require__(61)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(2);
	var $find = __webpack_require__(64)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(91)(KEY);


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(2);
	var $find = __webpack_require__(64)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(91)(KEY);


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $forEach = __webpack_require__(64)(0);
	var STRICT = __webpack_require__(61)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(60);
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(30);
	var call = __webpack_require__(389);
	var isArrayIter = __webpack_require__(231);
	var toLength = __webpack_require__(21);
	var createProperty = __webpack_require__(225);
	var getIterFn = __webpack_require__(247);
	
	$export($export.S + $export.F * !__webpack_require__(182)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $indexOf = __webpack_require__(176)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(61)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(180) });


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(55);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(151) != Object || !__webpack_require__(61)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(55);
	var toInteger = __webpack_require__(67);
	var toLength = __webpack_require__(21);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(61)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $map = __webpack_require__(64)(1);
	
	$export($export.P + $export.F * !__webpack_require__(61)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var createProperty = __webpack_require__(225);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(11)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $reduce = __webpack_require__(380);
	
	$export($export.P + $export.F * !__webpack_require__(61)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $reduce = __webpack_require__(380);
	
	$export($export.P + $export.F * !__webpack_require__(61)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var html = __webpack_require__(229);
	var cof = __webpack_require__(58);
	var toAbsoluteIndex = __webpack_require__(109);
	var toLength = __webpack_require__(21);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(11)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $some = __webpack_require__(64)(3);
	
	$export($export.P + $export.F * !__webpack_require__(61)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(40);
	var toObject = __webpack_require__(30);
	var fails = __webpack_require__(11);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(61)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(108)('Array');


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(2);
	var toISOString = __webpack_require__(709);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(30);
	var toPrimitive = __webpack_require__(68);
	
	$export($export.P + $export.F * __webpack_require__(11)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(16)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(45)(proto, TO_PRIMITIVE, __webpack_require__(710));


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(46)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(2);
	
	$export($export.P, 'Function', { bind: __webpack_require__(381) });


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(13);
	var getPrototypeOf = __webpack_require__(54);
	var HAS_INSTANCE = __webpack_require__(16)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(20).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(20).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(19) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(2);
	var log1p = __webpack_require__(392);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(2);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(2);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(2);
	var sign = __webpack_require__(235);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(2);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(2);
	var $expm1 = __webpack_require__(234);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { fround: __webpack_require__(391) });


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(2);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(2);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(11)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(392) });


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { sign: __webpack_require__(235) });


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(2);
	var expm1 = __webpack_require__(234);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(11)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(2);
	var expm1 = __webpack_require__(234);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(8);
	var has = __webpack_require__(52);
	var cof = __webpack_require__(58);
	var inheritIfRequired = __webpack_require__(230);
	var toPrimitive = __webpack_require__(68);
	var fails = __webpack_require__(11);
	var gOPN = __webpack_require__(104).f;
	var gOPD = __webpack_require__(53).f;
	var dP = __webpack_require__(20).f;
	var $trim = __webpack_require__(126).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(103)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(19) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(46)(global, NUMBER, $Number);
	}


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(2);
	var _isFinite = __webpack_require__(8).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(388) });


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(2);
	var isInteger = __webpack_require__(388);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseFloat = __webpack_require__(400);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseInt = __webpack_require__(401);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toInteger = __webpack_require__(67);
	var aNumberValue = __webpack_require__(377);
	var repeat = __webpack_require__(242);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(11)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $fails = __webpack_require__(11);
	var aNumberValue = __webpack_require__(377);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(2);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(394) });


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(103) });


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(19), 'Object', { defineProperties: __webpack_require__(395) });


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(19), 'Object', { defineProperty: __webpack_require__(20).f });


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(13);
	var meta = __webpack_require__(93).onFreeze;
	
	__webpack_require__(66)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(55);
	var $getOwnPropertyDescriptor = __webpack_require__(53).f;
	
	__webpack_require__(66)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(66)('getOwnPropertyNames', function () {
	  return __webpack_require__(396).f;
	});


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(30);
	var $getPrototypeOf = __webpack_require__(54);
	
	__webpack_require__(66)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(13);
	
	__webpack_require__(66)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(13);
	
	__webpack_require__(66)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(13);
	
	__webpack_require__(66)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(2);
	$export($export.S, 'Object', { is: __webpack_require__(713) });


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(30);
	var $keys = __webpack_require__(105);
	
	__webpack_require__(66)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(13);
	var meta = __webpack_require__(93).onFreeze;
	
	__webpack_require__(66)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(13);
	var meta = __webpack_require__(93).onFreeze;
	
	__webpack_require__(66)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(2);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(238).set });


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(150);
	var test = {};
	test[__webpack_require__(16)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(46)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseFloat = __webpack_require__(400);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $parseInt = __webpack_require__(401);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(92);
	var global = __webpack_require__(8);
	var ctx = __webpack_require__(60);
	var classof = __webpack_require__(150);
	var $export = __webpack_require__(2);
	var isObject = __webpack_require__(13);
	var aFunction = __webpack_require__(40);
	var anInstance = __webpack_require__(101);
	var forOf = __webpack_require__(102);
	var speciesConstructor = __webpack_require__(188);
	var task = __webpack_require__(244).set;
	var microtask = __webpack_require__(236)();
	var newPromiseCapabilityModule = __webpack_require__(237);
	var perform = __webpack_require__(402);
	var userAgent = __webpack_require__(190);
	var promiseResolve = __webpack_require__(403);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(16)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(107)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(125)($Promise, PROMISE);
	__webpack_require__(108)(PROMISE);
	Wrapper = __webpack_require__(59)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(182)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(2);
	var aFunction = __webpack_require__(40);
	var anObject = __webpack_require__(7);
	var rApply = (__webpack_require__(8).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(11)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(2);
	var create = __webpack_require__(103);
	var aFunction = __webpack_require__(40);
	var anObject = __webpack_require__(7);
	var isObject = __webpack_require__(13);
	var fails = __webpack_require__(11);
	var bind = __webpack_require__(381);
	var rConstruct = (__webpack_require__(8).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(20);
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(7);
	var toPrimitive = __webpack_require__(68);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(11)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(2);
	var gOPD = __webpack_require__(53).f;
	var anObject = __webpack_require__(7);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(7);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(232)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(53);
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(7);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(2);
	var getProto = __webpack_require__(54);
	var anObject = __webpack_require__(7);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(53);
	var getPrototypeOf = __webpack_require__(54);
	var has = __webpack_require__(52);
	var $export = __webpack_require__(2);
	var isObject = __webpack_require__(13);
	var anObject = __webpack_require__(7);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(7);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(399) });


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(2);
	var anObject = __webpack_require__(7);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(2);
	var setProto = __webpack_require__(238);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(20);
	var gOPD = __webpack_require__(53);
	var getPrototypeOf = __webpack_require__(54);
	var has = __webpack_require__(52);
	var $export = __webpack_require__(2);
	var createDesc = __webpack_require__(106);
	var anObject = __webpack_require__(7);
	var isObject = __webpack_require__(13);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var inheritIfRequired = __webpack_require__(230);
	var dP = __webpack_require__(20).f;
	var gOPN = __webpack_require__(104).f;
	var isRegExp = __webpack_require__(181);
	var $flags = __webpack_require__(179);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(19) && (!CORRECT_NEW || __webpack_require__(11)(function () {
	  re2[__webpack_require__(16)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(46)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(108)('RegExp');


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(178)('match', 1, function (defined, MATCH, $match) {
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(178)('replace', 2, function (defined, REPLACE, $replace) {
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue) {
	    'use strict';
	    var O = defined(this);
	    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(178)('search', 1, function (defined, SEARCH, $search) {
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp) {
	    'use strict';
	    var O = defined(this);
	    var fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(178)('split', 2, function (defined, SPLIT, $split) {
	  'use strict';
	  var isRegExp = __webpack_require__(181);
	  var _split = $split;
	  var $push = [].push;
	  var $SPLIT = 'split';
	  var LENGTH = 'length';
	  var LAST_INDEX = 'lastIndex';
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while (match = separatorCopy.exec(string)) {
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          // eslint-disable-next-line no-loop-func
	          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
	            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
	          });
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    $split = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit) {
	    var O = defined(this);
	    var fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(408);
	var anObject = __webpack_require__(7);
	var $flags = __webpack_require__(179);
	var DESCRIPTORS = __webpack_require__(19);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(46)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(11)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(47)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(47)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(47)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(47)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $at = __webpack_require__(240)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(2);
	var toLength = __webpack_require__(21);
	var context = __webpack_require__(241);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(228)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(47)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(47)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(47)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var toAbsoluteIndex = __webpack_require__(109);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(2);
	var context = __webpack_require__(241);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(228)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(47)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(240)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(233)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(47)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var toIObject = __webpack_require__(55);
	var toLength = __webpack_require__(21);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(242)
	});


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(47)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(2);
	var toLength = __webpack_require__(21);
	var context = __webpack_require__(241);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(228)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(47)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(47)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(47)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(126)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(8);
	var has = __webpack_require__(52);
	var DESCRIPTORS = __webpack_require__(19);
	var $export = __webpack_require__(2);
	var redefine = __webpack_require__(46);
	var META = __webpack_require__(93).KEY;
	var $fails = __webpack_require__(11);
	var shared = __webpack_require__(187);
	var setToStringTag = __webpack_require__(125);
	var uid = __webpack_require__(110);
	var wks = __webpack_require__(16);
	var wksExt = __webpack_require__(406);
	var wksDefine = __webpack_require__(246);
	var enumKeys = __webpack_require__(711);
	var isArray = __webpack_require__(180);
	var anObject = __webpack_require__(7);
	var isObject = __webpack_require__(13);
	var toIObject = __webpack_require__(55);
	var toPrimitive = __webpack_require__(68);
	var createDesc = __webpack_require__(106);
	var _create = __webpack_require__(103);
	var gOPNExt = __webpack_require__(396);
	var $GOPD = __webpack_require__(53);
	var $DP = __webpack_require__(20);
	var $keys = __webpack_require__(105);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(104).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(152).f = $propertyIsEnumerable;
	  __webpack_require__(184).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(92)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(45)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var $typed = __webpack_require__(189);
	var buffer = __webpack_require__(245);
	var anObject = __webpack_require__(7);
	var toAbsoluteIndex = __webpack_require__(109);
	var toLength = __webpack_require__(21);
	var isObject = __webpack_require__(13);
	var ArrayBuffer = __webpack_require__(8).ArrayBuffer;
	var speciesConstructor = __webpack_require__(188);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(11)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var final = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < final) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(108)(ARRAY_BUFFER);


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	$export($export.G + $export.W + $export.F * !__webpack_require__(189).ABV, {
	  DataView: __webpack_require__(245).DataView
	});


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(73)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(73)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(73)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(73)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(73)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(73)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(73)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(73)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(73)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(384);
	var validate = __webpack_require__(127);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(177)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(2);
	var flattenIntoArray = __webpack_require__(385);
	var toObject = __webpack_require__(30);
	var toLength = __webpack_require__(21);
	var aFunction = __webpack_require__(40);
	var arraySpeciesCreate = __webpack_require__(224);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(91)('flatMap');


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(2);
	var flattenIntoArray = __webpack_require__(385);
	var toObject = __webpack_require__(30);
	var toLength = __webpack_require__(21);
	var toInteger = __webpack_require__(67);
	var arraySpeciesCreate = __webpack_require__(224);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(91)('flatten');


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(2);
	var $includes = __webpack_require__(176)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(91)('includes');


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(2);
	var microtask = __webpack_require__(236)();
	var process = __webpack_require__(8).process;
	var isNode = __webpack_require__(58)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(2);
	var cof = __webpack_require__(58);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(2);
	
	$export($export.G, { global: __webpack_require__(8) });


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(185)('Map');


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(186)('Map');


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(2);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(383)('Map') });


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var scale = __webpack_require__(393);
	var fround = __webpack_require__(391);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { scale: __webpack_require__(393) });


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(2);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(30);
	var aFunction = __webpack_require__(40);
	var $defineProperty = __webpack_require__(20);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(19) && $export($export.P + __webpack_require__(183), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(30);
	var aFunction = __webpack_require__(40);
	var $defineProperty = __webpack_require__(20);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(19) && $export($export.P + __webpack_require__(183), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(2);
	var $entries = __webpack_require__(398)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(2);
	var ownKeys = __webpack_require__(399);
	var toIObject = __webpack_require__(55);
	var gOPD = __webpack_require__(53);
	var createProperty = __webpack_require__(225);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(30);
	var toPrimitive = __webpack_require__(68);
	var getPrototypeOf = __webpack_require__(54);
	var getOwnPropertyDescriptor = __webpack_require__(53).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(19) && $export($export.P + __webpack_require__(183), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(2);
	var toObject = __webpack_require__(30);
	var toPrimitive = __webpack_require__(68);
	var getPrototypeOf = __webpack_require__(54);
	var getOwnPropertyDescriptor = __webpack_require__(53).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(19) && $export($export.P + __webpack_require__(183), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(2);
	var $values = __webpack_require__(398)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(2);
	var global = __webpack_require__(8);
	var core = __webpack_require__(59);
	var microtask = __webpack_require__(236)();
	var OBSERVABLE = __webpack_require__(16)('observable');
	var aFunction = __webpack_require__(40);
	var anObject = __webpack_require__(7);
	var anInstance = __webpack_require__(101);
	var redefineAll = __webpack_require__(107);
	var hide = __webpack_require__(45);
	var forOf = __webpack_require__(102);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(108)('Observable');


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(2);
	var core = __webpack_require__(59);
	var global = __webpack_require__(8);
	var speciesConstructor = __webpack_require__(188);
	var promiseResolve = __webpack_require__(403);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(2);
	var newPromiseCapability = __webpack_require__(237);
	var perform = __webpack_require__(402);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(72);
	var anObject = __webpack_require__(7);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(72);
	var anObject = __webpack_require__(7);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(409);
	var from = __webpack_require__(379);
	var metadata = __webpack_require__(72);
	var anObject = __webpack_require__(7);
	var getPrototypeOf = __webpack_require__(54);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(72);
	var anObject = __webpack_require__(7);
	var getPrototypeOf = __webpack_require__(54);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(72);
	var anObject = __webpack_require__(7);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(72);
	var anObject = __webpack_require__(7);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(72);
	var anObject = __webpack_require__(7);
	var getPrototypeOf = __webpack_require__(54);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(72);
	var anObject = __webpack_require__(7);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(72);
	var anObject = __webpack_require__(7);
	var aFunction = __webpack_require__(40);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(185)('Set');


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(186)('Set');


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(2);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(383)('Set') });


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(2);
	var $at = __webpack_require__(240)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(2);
	var defined = __webpack_require__(65);
	var toLength = __webpack_require__(21);
	var isRegExp = __webpack_require__(181);
	var getFlags = __webpack_require__(179);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(232)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(2);
	var $pad = __webpack_require__(404);
	var userAgent = __webpack_require__(190);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(2);
	var $pad = __webpack_require__(404);
	var userAgent = __webpack_require__(190);
	
	// https://github.com/zloirock/core-js/issues/280
	$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(126)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(126)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(246)('asyncIterator');


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(246)('observable');


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(2);
	
	$export($export.S, 'System', { global: __webpack_require__(8) });


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(185)('WeakMap');


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(186)('WeakMap');


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(185)('WeakSet');


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(186)('WeakSet');


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(248);
	var getKeys = __webpack_require__(105);
	var redefine = __webpack_require__(46);
	var global = __webpack_require__(8);
	var hide = __webpack_require__(45);
	var Iterators = __webpack_require__(124);
	var wks = __webpack_require__(16);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(2);
	var $task = __webpack_require__(244);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(8);
	var $export = __webpack_require__(2);
	var userAgent = __webpack_require__(190);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(834);
	__webpack_require__(773);
	__webpack_require__(775);
	__webpack_require__(774);
	__webpack_require__(777);
	__webpack_require__(779);
	__webpack_require__(784);
	__webpack_require__(778);
	__webpack_require__(776);
	__webpack_require__(786);
	__webpack_require__(785);
	__webpack_require__(781);
	__webpack_require__(782);
	__webpack_require__(780);
	__webpack_require__(772);
	__webpack_require__(783);
	__webpack_require__(787);
	__webpack_require__(788);
	__webpack_require__(740);
	__webpack_require__(742);
	__webpack_require__(741);
	__webpack_require__(790);
	__webpack_require__(789);
	__webpack_require__(760);
	__webpack_require__(770);
	__webpack_require__(771);
	__webpack_require__(761);
	__webpack_require__(762);
	__webpack_require__(763);
	__webpack_require__(764);
	__webpack_require__(765);
	__webpack_require__(766);
	__webpack_require__(767);
	__webpack_require__(768);
	__webpack_require__(769);
	__webpack_require__(743);
	__webpack_require__(744);
	__webpack_require__(745);
	__webpack_require__(746);
	__webpack_require__(747);
	__webpack_require__(748);
	__webpack_require__(749);
	__webpack_require__(750);
	__webpack_require__(751);
	__webpack_require__(752);
	__webpack_require__(753);
	__webpack_require__(754);
	__webpack_require__(755);
	__webpack_require__(756);
	__webpack_require__(757);
	__webpack_require__(758);
	__webpack_require__(759);
	__webpack_require__(821);
	__webpack_require__(826);
	__webpack_require__(833);
	__webpack_require__(824);
	__webpack_require__(816);
	__webpack_require__(817);
	__webpack_require__(822);
	__webpack_require__(827);
	__webpack_require__(829);
	__webpack_require__(812);
	__webpack_require__(813);
	__webpack_require__(814);
	__webpack_require__(815);
	__webpack_require__(818);
	__webpack_require__(819);
	__webpack_require__(820);
	__webpack_require__(823);
	__webpack_require__(825);
	__webpack_require__(828);
	__webpack_require__(830);
	__webpack_require__(831);
	__webpack_require__(832);
	__webpack_require__(735);
	__webpack_require__(737);
	__webpack_require__(736);
	__webpack_require__(739);
	__webpack_require__(738);
	__webpack_require__(724);
	__webpack_require__(722);
	__webpack_require__(728);
	__webpack_require__(725);
	__webpack_require__(731);
	__webpack_require__(733);
	__webpack_require__(721);
	__webpack_require__(727);
	__webpack_require__(718);
	__webpack_require__(732);
	__webpack_require__(716);
	__webpack_require__(730);
	__webpack_require__(729);
	__webpack_require__(723);
	__webpack_require__(726);
	__webpack_require__(715);
	__webpack_require__(717);
	__webpack_require__(720);
	__webpack_require__(719);
	__webpack_require__(734);
	__webpack_require__(248);
	__webpack_require__(806);
	__webpack_require__(811);
	__webpack_require__(408);
	__webpack_require__(807);
	__webpack_require__(808);
	__webpack_require__(809);
	__webpack_require__(810);
	__webpack_require__(791);
	__webpack_require__(407);
	__webpack_require__(409);
	__webpack_require__(410);
	__webpack_require__(846);
	__webpack_require__(835);
	__webpack_require__(836);
	__webpack_require__(841);
	__webpack_require__(844);
	__webpack_require__(845);
	__webpack_require__(839);
	__webpack_require__(842);
	__webpack_require__(840);
	__webpack_require__(843);
	__webpack_require__(837);
	__webpack_require__(838);
	__webpack_require__(792);
	__webpack_require__(793);
	__webpack_require__(794);
	__webpack_require__(795);
	__webpack_require__(796);
	__webpack_require__(799);
	__webpack_require__(797);
	__webpack_require__(798);
	__webpack_require__(800);
	__webpack_require__(801);
	__webpack_require__(802);
	__webpack_require__(803);
	__webpack_require__(805);
	__webpack_require__(804);
	__webpack_require__(849);
	__webpack_require__(847);
	__webpack_require__(848);
	__webpack_require__(890);
	__webpack_require__(893);
	__webpack_require__(892);
	__webpack_require__(894);
	__webpack_require__(895);
	__webpack_require__(891);
	__webpack_require__(896);
	__webpack_require__(897);
	__webpack_require__(871);
	__webpack_require__(874);
	__webpack_require__(870);
	__webpack_require__(868);
	__webpack_require__(869);
	__webpack_require__(872);
	__webpack_require__(873);
	__webpack_require__(855);
	__webpack_require__(889);
	__webpack_require__(854);
	__webpack_require__(888);
	__webpack_require__(900);
	__webpack_require__(902);
	__webpack_require__(853);
	__webpack_require__(887);
	__webpack_require__(899);
	__webpack_require__(901);
	__webpack_require__(852);
	__webpack_require__(898);
	__webpack_require__(851);
	__webpack_require__(856);
	__webpack_require__(857);
	__webpack_require__(858);
	__webpack_require__(859);
	__webpack_require__(860);
	__webpack_require__(862);
	__webpack_require__(861);
	__webpack_require__(863);
	__webpack_require__(864);
	__webpack_require__(865);
	__webpack_require__(867);
	__webpack_require__(866);
	__webpack_require__(876);
	__webpack_require__(877);
	__webpack_require__(878);
	__webpack_require__(879);
	__webpack_require__(881);
	__webpack_require__(880);
	__webpack_require__(883);
	__webpack_require__(882);
	__webpack_require__(884);
	__webpack_require__(885);
	__webpack_require__(886);
	__webpack_require__(850);
	__webpack_require__(875);
	__webpack_require__(905);
	__webpack_require__(904);
	__webpack_require__(903);
	module.exports = __webpack_require__(59);


/***/ }),
/* 907 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 908 */
907,
/* 909 */
907,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */
907,
/* 923 */
907,
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1705c3f3dde54cd38737dcaa2c332ef2.pdf";

/***/ }),
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b2bef32b87bb41c9914baf964030842e.pdf";

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "576a6e72a69871fd6b74650b381d14fb.pdf";

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "d9fd02c5b33f5bf92866121053ef7f77.pdf";

/***/ }),
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Sizzle CSS Selector Engine v2.3.3
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-08-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		disabledAncestor = addCombinator(
			function( elem ) {
				return elem.disabled === true && ("form" in elem || "label" in elem);
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							disabledAncestor( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	// EXPOSE
	var _sizzle = window.Sizzle;
	
	Sizzle.noConflict = function() {
		if ( window.Sizzle === Sizzle ) {
			window.Sizzle = _sizzle;
		}
	
		return Sizzle;
	};
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return Sizzle; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	// Sizzle requires that there be a global window in Common-JS like environments
	} else if ( typeof module !== "undefined" && module.exports ) {
		module.exports = Sizzle;
	} else {
		window.Sizzle = Sizzle;
	}
	// EXPOSE
	
	})( window );


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(27),
		__webpack_require__(413),
		__webpack_require__(414),
		__webpack_require__(128)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, isFunction, nonce, rquery ) {
	
	"use strict";
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(251),
		__webpack_require__(27),
		__webpack_require__(955),
		__webpack_require__(128),
		__webpack_require__(132),
		__webpack_require__(191),
		__webpack_require__(41)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, stripAndCollapse, isFunction ) {
	
	"use strict";
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	return jQuery.parseXML;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(32),
		__webpack_require__(128)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document ) {
	
	"use strict";
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return window.location;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(113),
		__webpack_require__(128)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, support ) {
	
	"use strict";
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(952),
		__webpack_require__(415),
		__webpack_require__(953),
		__webpack_require__(954)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	// Return jQuery for attributes-only inclusion
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(111),
		__webpack_require__(112),
		__webpack_require__(249),
		__webpack_require__(94),
		__webpack_require__(41)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, access, nodeName, support, rnothtmlwhite ) {
	
	"use strict";
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(251),
		__webpack_require__(27),
		__webpack_require__(94),
		__webpack_require__(69),
		__webpack_require__(62)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, stripAndCollapse, isFunction, rnothtmlwhite, dataPriv ) {
	
	"use strict";
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(251),
		__webpack_require__(249),
		__webpack_require__(112),
		__webpack_require__(27),
	
		__webpack_require__(62)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, stripAndCollapse, support, nodeName, isFunction ) {
	
	"use strict";
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(32),
		__webpack_require__(418),
		__webpack_require__(427),
	
		// This is the only module that needs core/support
		__webpack_require__(957)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, rsingleTag, buildFragment, support ) {
	
	"use strict";
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	return jQuery.parseHTML;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(32),
		__webpack_require__(113)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( document, support ) {
	
	"use strict";
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	return support;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(41)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(69),
		__webpack_require__(423)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, dataPriv, isHiddenWithinTree ) {
	
	"use strict";
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	
	return showHide;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(253)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( cssExpand ) {
		"use strict";
	
		return new RegExp( cssExpand.join( "|" ), "i" );
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(111),
		__webpack_require__(153),
		__webpack_require__(69),
		__webpack_require__(426)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, access, camelCase, dataPriv, dataUser ) {
	
	"use strict";
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(130)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(112),
		__webpack_require__(153),
		__webpack_require__(129),
		__webpack_require__(27),
		__webpack_require__(156),
		__webpack_require__(193),
	
		__webpack_require__(968)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, nodeName, camelCase, toType, isFunction, isWindow, slice ) {
	
	"use strict";
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(111),
		__webpack_require__(156),
		__webpack_require__(154)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, access, isWindow ) {
	
	"use strict";
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(154)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(41),
		__webpack_require__(256)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(131)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
	
		__webpack_require__(131),
		__webpack_require__(257)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(69),
		__webpack_require__(970),
	
		__webpack_require__(131),
		__webpack_require__(257)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, dataPriv, support ) {
	
	"use strict";
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(113)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( support ) {
	
	"use strict";
	
	support.focusin = "onfocusin" in window;
	
	return support;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, noGlobal ) {
	
	"use strict";
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(128)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	return jQuery._evalUrl;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(32),
		__webpack_require__(113)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( document, support ) {
	
	"use strict";
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	
	return support;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(111),
		__webpack_require__(32),
		__webpack_require__(259),
		__webpack_require__(27),
		__webpack_require__(254),
		__webpack_require__(421),
		__webpack_require__(419),
		__webpack_require__(252),
		__webpack_require__(156),
		__webpack_require__(62),
		__webpack_require__(154),
		__webpack_require__(41) // contains
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, access, document, documentElement, isFunction, rnumnonpx,
	             curCSS, addGetHookIf, support, isWindow ) {
	
	"use strict";
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(258),
		__webpack_require__(256) // Delay is optional because of this dependency
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	return jQuery.fn.delay;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(944)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, Sizzle ) {
	
	"use strict";
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	return function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	"use strict";
	
	return function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(438)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( fnToString ) {
		"use strict";
	
		return fnToString.call( Object );
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return Object.getPrototypeOf;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(4),
		__webpack_require__(27),
		__webpack_require__(62),
		__webpack_require__(191), // clone
		__webpack_require__(132) // parent, contents
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, isFunction ) {
	
	"use strict";
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 983 */
/***/ (function(module, exports) {

	module.exports = {"figurines":[{"id":"karla","sex":"female"},{"id":"gerry","sex":"male"},{"id":"corinne","sex":"female"},{"id":"bea","sex":"female"},{"id":"leon","sex":"male"},{"id":"olga","sex":"female"},{"id":"sam","sex":"male"},{"id":"pol","sex":"male"},{"id":"martin","sex":"male"},{"id":"caroline","sex":"female"},{"id":"diego","sex":"male"},{"id":"viktor","sex":"male"},{"id":"waldo","sex":"male"},{"id":"renee","sex":"female"},{"id":"ric","sex":"male"},{"id":"maurice","sex":"male"},{"id":"henry","sex":"male"},{"id":"kitou","sex":"male"},{"id":"max","sex":"male"},{"id":"didier","sex":"male"},{"id":"astrid","sex":"female"},{"id":"milla","sex":"female"},{"id":"herbert","sex":"male"},{"id":"cornelus","sex":"male"}]}

/***/ }),
/* 984 */
/***/ (function(module, exports) {

	module.exports = {"textures":[{"image":"atlas_carrot-game.png","format":"RGBA8888","size":{"w":985,"h":1088},"scale":1,"frames":[{"filename":"misc/image_paint_light-green.png","rotated":false,"trimmed":false,"sourceSize":{"w":949,"h":261},"spriteSourceSize":{"x":0,"y":0,"w":949,"h":261},"frame":{"x":1,"y":1,"w":949,"h":261}},{"filename":"misc/icon_restart.png","rotated":false,"trimmed":false,"sourceSize":{"w":32,"h":29},"spriteSourceSize":{"x":0,"y":0,"w":32,"h":29},"frame":{"x":952,"y":1,"w":32,"h":29}},{"filename":"consumables/consumable_carrot.png","rotated":false,"trimmed":false,"sourceSize":{"w":18,"h":73},"spriteSourceSize":{"x":0,"y":0,"w":18,"h":73},"frame":{"x":952,"y":32,"w":18,"h":73}},{"filename":"misc/icon_play.png","rotated":false,"trimmed":false,"sourceSize":{"w":15,"h":19},"spriteSourceSize":{"x":0,"y":0,"w":15,"h":19},"frame":{"x":952,"y":107,"w":15,"h":19}},{"filename":"power-ups/powerup_magnet-active.png","rotated":false,"trimmed":false,"sourceSize":{"w":244,"h":428},"spriteSourceSize":{"x":0,"y":0,"w":244,"h":428},"frame":{"x":1,"y":264,"w":244,"h":428}},{"filename":"rabbit/jump/rocket-cake/down.png","rotated":false,"trimmed":false,"sourceSize":{"w":147,"h":237},"spriteSourceSize":{"x":0,"y":0,"w":147,"h":237},"frame":{"x":1,"y":694,"w":147,"h":237}},{"filename":"obstacles/obstacle_fence.png","rotated":false,"trimmed":false,"sourceSize":{"w":113,"h":124},"spriteSourceSize":{"x":0,"y":0,"w":113,"h":124},"frame":{"x":1,"y":933,"w":113,"h":124}},{"filename":"consumables/consumable_carrot-shadow.png","rotated":false,"trimmed":false,"sourceSize":{"w":72,"h":23},"spriteSourceSize":{"x":0,"y":0,"w":72,"h":23},"frame":{"x":1,"y":1059,"w":72,"h":23}},{"filename":"rabbit/jump/down_shadow.png","rotated":false,"trimmed":true,"sourceSize":{"w":171,"h":21},"spriteSourceSize":{"x":38,"y":0,"w":94,"h":16},"frame":{"x":75,"y":1059,"w":94,"h":16}},{"filename":"rabbit/run/shadow.png","rotated":false,"trimmed":true,"sourceSize":{"w":171,"h":20},"spriteSourceSize":{"x":27,"y":5,"w":121,"h":10},"frame":{"x":75,"y":1077,"w":121,"h":10}},{"filename":"power-ups/powerup_shield-active.png","rotated":false,"trimmed":false,"sourceSize":{"w":89,"h":120},"spriteSourceSize":{"x":0,"y":0,"w":89,"h":120},"frame":{"x":116,"y":933,"w":89,"h":120}},{"filename":"rabbit/jump/up_shadow.png","rotated":false,"trimmed":true,"sourceSize":{"w":171,"h":21},"spriteSourceSize":{"x":56,"y":0,"w":55,"h":15},"frame":{"x":171,"y":1055,"w":55,"h":15}},{"filename":"rabbit/jump/down.png","rotated":false,"trimmed":true,"sourceSize":{"w":171,"h":232},"spriteSourceSize":{"x":22,"y":1,"w":143,"h":225},"frame":{"x":150,"y":694,"w":143,"h":225}},{"filename":"obstacles/obstacle_manger.png","rotated":false,"trimmed":false,"sourceSize":{"w":189,"h":118},"spriteSourceSize":{"x":0,"y":0,"w":189,"h":118},"frame":{"x":207,"y":921,"w":189,"h":118}},{"filename":"misc/image_info.png","rotated":false,"trimmed":false,"sourceSize":{"w":45,"h":45},"spriteSourceSize":{"x":0,"y":0,"w":45,"h":45},"frame":{"x":228,"y":1041,"w":45,"h":45}},{"filename":"consumables/consumable_carrot-2x-shadow.png","rotated":false,"trimmed":false,"sourceSize":{"w":85,"h":35},"spriteSourceSize":{"x":0,"y":0,"w":85,"h":35},"frame":{"x":275,"y":1041,"w":85,"h":35}},{"filename":"rabbit/run/0001.png","rotated":false,"trimmed":true,"sourceSize":{"w":171,"h":208},"spriteSourceSize":{"x":0,"y":0,"w":166,"h":204},"frame":{"x":247,"y":264,"w":166,"h":204}},{"filename":"rabbit/run/rocket-cake/0001.png","rotated":false,"trimmed":true,"sourceSize":{"w":218,"h":208},"spriteSourceSize":{"x":26,"y":0,"w":166,"h":204},"frame":{"x":247,"y":470,"w":166,"h":204}},{"filename":"rabbit/run/0006.png","rotated":false,"trimmed":true,"sourceSize":{"w":171,"h":208},"spriteSourceSize":{"x":6,"y":0,"w":153,"h":204},"frame":{"x":295,"y":676,"w":153,"h":204}},{"filename":"rabbit/run/rocket-cake/0006.png","rotated":false,"trimmed":false,"sourceSize":{"w":175,"h":203},"spriteSourceSize":{"x":0,"y":0,"w":175,"h":203},"frame":{"x":398,"y":882,"w":175,"h":203}},{"filename":"misc/image_button.png","rotated":false,"trimmed":false,"sourceSize":{"w":270,"h":59},"spriteSourceSize":{"x":0,"y":0,"w":270,"h":59},"frame":{"x":575,"y":264,"w":270,"h":59}},{"filename":"rabbit/run/0004.png","rotated":false,"trimmed":true,"sourceSize":{"w":171,"h":208},"spriteSourceSize":{"x":1,"y":0,"w":158,"h":203},"frame":{"x":415,"y":264,"w":158,"h":203}},{"filename":"rabbit/run/rocket-cake/0004.png","rotated":false,"trimmed":true,"sourceSize":{"w":193,"h":208},"spriteSourceSize":{"x":26,"y":0,"w":158,"h":203},"frame":{"x":415,"y":264,"w":158,"h":203}},{"filename":"rabbit/run/0003.png","rotated":false,"trimmed":true,"sourceSize":{"w":171,"h":208},"spriteSourceSize":{"x":6,"y":0,"w":153,"h":201},"frame":{"x":415,"y":469,"w":153,"h":201}},{"filename":"rabbit/run/rocket-cake/0003.png","rotated":false,"trimmed":true,"sourceSize":{"w":185,"h":208},"spriteSourceSize":{"x":26,"y":0,"w":153,"h":201},"frame":{"x":415,"y":469,"w":153,"h":201}},{"filename":"rabbit/run/rocket-cake/0002.png","rotated":false,"trimmed":true,"sourceSize":{"w":222,"h":208},"spriteSourceSize":{"x":26,"y":1,"w":170,"h":200},"frame":{"x":450,"y":672,"w":170,"h":200}},{"filename":"rabbit/run/0002.png","rotated":false,"trimmed":true,"sourceSize":{"w":171,"h":208},"spriteSourceSize":{"x":0,"y":1,"w":169,"h":200},"frame":{"x":570,"y":469,"w":169,"h":200}},{"filename":"obstacles/obstacle_mudpool.png","rotated":false,"trimmed":false,"sourceSize":{"w":129,"h":55},"spriteSourceSize":{"x":0,"y":0,"w":129,"h":55},"frame":{"x":847,"y":264,"w":129,"h":55}},{"filename":"rabbit/run/rocket-cake/0005.png","rotated":false,"trimmed":true,"sourceSize":{"w":218,"h":208},"spriteSourceSize":{"x":26,"y":1,"w":166,"h":200},"frame":{"x":575,"y":874,"w":166,"h":200}},{"filename":"rabbit/run/0005.png","rotated":false,"trimmed":true,"sourceSize":{"w":171,"h":208},"spriteSourceSize":{"x":6,"y":1,"w":165,"h":200},"frame":{"x":622,"y":671,"w":165,"h":200}},{"filename":"rabbit/jump/rocket-cake/up.png","rotated":false,"trimmed":false,"sourceSize":{"w":142,"h":200},"spriteSourceSize":{"x":0,"y":0,"w":142,"h":200},"frame":{"x":743,"y":873,"w":142,"h":200}},{"filename":"obstacles/obstacle_watering-can.png","rotated":false,"trimmed":false,"sourceSize":{"w":96,"h":82},"spriteSourceSize":{"x":0,"y":0,"w":96,"h":82},"frame":{"x":887,"y":321,"w":96,"h":82}},{"filename":"rabbit/jump/up.png","rotated":false,"trimmed":true,"sourceSize":{"w":171,"h":232},"spriteSourceSize":{"x":21,"y":37,"w":144,"h":195},"frame":{"x":741,"y":325,"w":144,"h":195}},{"filename":"obstacles/obstacle_hay-bale.png","rotated":false,"trimmed":false,"sourceSize":{"w":164,"h":114},"spriteSourceSize":{"x":0,"y":0,"w":164,"h":114},"frame":{"x":575,"y":325,"w":164,"h":114}},{"filename":"power-ups/powerup_shield.png","rotated":false,"trimmed":false,"sourceSize":{"w":95,"h":90},"spriteSourceSize":{"x":0,"y":0,"w":95,"h":90},"frame":{"x":887,"y":405,"w":95,"h":90}},{"filename":"misc/image_menu_springball.png","rotated":false,"trimmed":false,"sourceSize":{"w":90,"h":109},"spriteSourceSize":{"x":0,"y":0,"w":90,"h":109},"frame":{"x":887,"y":497,"w":90,"h":109}},{"filename":"misc/image_menu_rocket-cake.png","rotated":false,"trimmed":false,"sourceSize":{"w":140,"h":108},"spriteSourceSize":{"x":0,"y":0,"w":140,"h":108},"frame":{"x":741,"y":522,"w":140,"h":108}},{"filename":"power-ups/powerup_rocket-cake.png","rotated":false,"trimmed":false,"sourceSize":{"w":101,"h":90},"spriteSourceSize":{"x":0,"y":0,"w":101,"h":90},"frame":{"x":883,"y":608,"w":101,"h":90}},{"filename":"power-ups/powerup_bounce-ball.png","rotated":false,"trimmed":false,"sourceSize":{"w":79,"h":90},"spriteSourceSize":{"x":0,"y":0,"w":79,"h":90},"frame":{"x":789,"y":632,"w":79,"h":90}},{"filename":"misc/image_controls.png","rotated":false,"trimmed":false,"sourceSize":{"w":106,"h":73},"spriteSourceSize":{"x":0,"y":0,"w":106,"h":73},"frame":{"x":870,"y":700,"w":106,"h":73}},{"filename":"misc/image_menu_shield.png","rotated":false,"trimmed":false,"sourceSize":{"w":78,"h":111},"spriteSourceSize":{"x":0,"y":0,"w":78,"h":111},"frame":{"x":789,"y":724,"w":78,"h":111}},{"filename":"consumables/consumable_carrot-2x.png","rotated":false,"trimmed":false,"sourceSize":{"w":33,"h":90},"spriteSourceSize":{"x":0,"y":0,"w":33,"h":90},"frame":{"x":869,"y":775,"w":33,"h":90}},{"filename":"obstacles/obstacle_bucket.png","rotated":false,"trimmed":false,"sourceSize":{"w":70,"h":84},"spriteSourceSize":{"x":0,"y":0,"w":70,"h":84},"frame":{"x":904,"y":775,"w":70,"h":84}},{"filename":"misc/image_menu_magnet.png","rotated":false,"trimmed":false,"sourceSize":{"w":63,"h":103},"spriteSourceSize":{"x":0,"y":0,"w":63,"h":103},"frame":{"x":904,"y":861,"w":63,"h":103}},{"filename":"obstacles/obstacle_milk-jug.png","rotated":false,"trimmed":false,"sourceSize":{"w":57,"h":106},"spriteSourceSize":{"x":0,"y":0,"w":57,"h":106},"frame":{"x":887,"y":966,"w":57,"h":106}},{"filename":"power-ups/powerup_magnet.png","rotated":false,"trimmed":false,"sourceSize":{"w":37,"h":53},"spriteSourceSize":{"x":0,"y":0,"w":37,"h":53},"frame":{"x":946,"y":966,"w":37,"h":53}}]}],"meta":{"app":"https://www.codeandweb.com/texturepacker","version":"3.0","smartupdate":"$TexturePacker:SmartUpdate:b2f002a0f23b0ece8bdffe7fd074d92b:6972d7c3258c9107d5ae8e7ab73c3236:b8183a45531806d910075fc554cad4c9$"}}

/***/ }),
/* 985 */
/***/ (function(module, exports) {

	module.exports = {"textures":[{"image":"atlas_chicken-game-0.png","format":"RGBA8888","size":{"w":1986,"h":2006},"scale":1,"frames":[{"filename":"misc/bg_overlay.png","rotated":false,"trimmed":false,"sourceSize":{"w":961,"h":542},"spriteSourceSize":{"x":0,"y":0,"w":961,"h":542},"frame":{"x":1,"y":1,"w":961,"h":542}},{"filename":"scene/grass.png","rotated":false,"trimmed":false,"sourceSize":{"w":960,"h":540},"spriteSourceSize":{"x":0,"y":0,"w":960,"h":540},"frame":{"x":1,"y":545,"w":960,"h":540}},{"filename":"scene/sand.jpg","rotated":false,"trimmed":false,"sourceSize":{"w":960,"h":540},"spriteSourceSize":{"x":0,"y":0,"w":960,"h":540},"frame":{"x":964,"y":1,"w":960,"h":540}},{"filename":"misc/background_cloud.png","rotated":false,"trimmed":true,"sourceSize":{"w":961,"h":542},"spriteSourceSize":{"x":8,"y":0,"w":953,"h":542},"frame":{"x":1,"y":1087,"w":953,"h":542}},{"filename":"misc/menu_chicks.png","rotated":false,"trimmed":false,"sourceSize":{"w":705,"h":161},"spriteSourceSize":{"x":0,"y":0,"w":705,"h":161},"frame":{"x":1,"y":1631,"w":705,"h":161}},{"filename":"scene/fence.png","rotated":false,"trimmed":true,"sourceSize":{"w":960,"h":540},"spriteSourceSize":{"x":155,"y":22,"w":645,"h":496},"frame":{"x":964,"y":543,"w":645,"h":496}},{"filename":"misc/button.png","rotated":true,"trimmed":false,"sourceSize":{"w":270,"h":59},"spriteSourceSize":{"x":0,"y":0,"w":270,"h":59},"frame":{"x":1926,"y":1,"w":270,"h":59}},{"filename":"animations/corinne/0000.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":10,"w":154,"h":209},"frame":{"x":1,"y":1794,"w":154,"h":209}},{"filename":"animations/corinne/0220.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":10,"w":154,"h":209},"frame":{"x":1,"y":1794,"w":154,"h":209}},{"filename":"animations/corinne/0020.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":10,"w":154,"h":209},"frame":{"x":708,"y":1631,"w":154,"h":209}},{"filename":"animations/corinne/0040.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":10,"w":154,"h":209},"frame":{"x":708,"y":1631,"w":154,"h":209}},{"filename":"animations/corinne/0060.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":10,"w":154,"h":209},"frame":{"x":708,"y":1631,"w":154,"h":209}},{"filename":"animations/corinne/0160.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":10,"w":154,"h":209},"frame":{"x":708,"y":1631,"w":154,"h":209}},{"filename":"animations/corinne/0180.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":10,"w":154,"h":209},"frame":{"x":708,"y":1631,"w":154,"h":209}},{"filename":"animations/corinne/0200.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":10,"w":154,"h":209},"frame":{"x":708,"y":1631,"w":154,"h":209}},{"filename":"animations/corinne/0001.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1611,"y":543,"w":154,"h":208}},{"filename":"animations/corinne/0299.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1611,"y":543,"w":154,"h":208}},{"filename":"animations/corinne/0002.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":157,"y":1794,"w":154,"h":208}},{"filename":"animations/corinne/0298.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":157,"y":1794,"w":154,"h":208}},{"filename":"animations/corinne/0003.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1611,"y":753,"w":154,"h":208}},{"filename":"animations/corinne/0297.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1611,"y":753,"w":154,"h":208}},{"filename":"animations/corinne/0004.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1767,"y":543,"w":154,"h":208}},{"filename":"animations/corinne/0005.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":313,"y":1794,"w":154,"h":208}},{"filename":"animations/corinne/0006.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1767,"y":753,"w":154,"h":208}},{"filename":"animations/corinne/0007.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":469,"y":1794,"w":154,"h":208}},{"filename":"animations/corinne/0013.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":625,"y":1794,"w":154,"h":208}},{"filename":"animations/corinne/0033.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":625,"y":1794,"w":154,"h":208}},{"filename":"animations/corinne/0073.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":625,"y":1794,"w":154,"h":208}},{"filename":"animations/corinne/0153.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":625,"y":1794,"w":154,"h":208}},{"filename":"animations/corinne/0173.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":625,"y":1794,"w":154,"h":208}},{"filename":"animations/corinne/0207.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":625,"y":1794,"w":154,"h":208}},{"filename":"animations/corinne/0213.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":625,"y":1794,"w":154,"h":208}},{"filename":"animations/corinne/0014.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":781,"y":1787,"w":154,"h":208}},{"filename":"animations/corinne/0154.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":781,"y":1787,"w":154,"h":208}},{"filename":"animations/corinne/0206.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":781,"y":1787,"w":154,"h":208}},{"filename":"animations/corinne/0214.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":781,"y":1787,"w":154,"h":208}},{"filename":"animations/corinne/0226.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":781,"y":1787,"w":154,"h":208}},{"filename":"animations/corinne/0015.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1611,"y":963,"w":154,"h":208}},{"filename":"animations/corinne/0155.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1611,"y":963,"w":154,"h":208}},{"filename":"animations/corinne/0205.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1611,"y":963,"w":154,"h":208}},{"filename":"animations/corinne/0215.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1611,"y":963,"w":154,"h":208}},{"filename":"animations/corinne/0225.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1611,"y":963,"w":154,"h":208}},{"filename":"animations/corinne/0008.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1821,"y":963,"w":154,"h":207}},{"filename":"animations/corinne/0016.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":963,"y":1041,"w":154,"h":208}},{"filename":"animations/corinne/0156.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":963,"y":1041,"w":154,"h":208}},{"filename":"animations/corinne/0204.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":963,"y":1041,"w":154,"h":208}},{"filename":"animations/corinne/0216.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":963,"y":1041,"w":154,"h":208}},{"filename":"animations/corinne/0224.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":963,"y":1041,"w":154,"h":208}},{"filename":"animations/corinne/0017.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1173,"y":1041,"w":154,"h":208}},{"filename":"animations/corinne/0157.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1173,"y":1041,"w":154,"h":208}},{"filename":"animations/corinne/0203.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1173,"y":1041,"w":154,"h":208}},{"filename":"animations/corinne/0217.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1173,"y":1041,"w":154,"h":208}},{"filename":"animations/corinne/0223.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1173,"y":1041,"w":154,"h":208}},{"filename":"animations/corinne/0018.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1383,"y":1041,"w":154,"h":208}},{"filename":"animations/corinne/0202.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1383,"y":1041,"w":154,"h":208}},{"filename":"animations/corinne/0218.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1383,"y":1041,"w":154,"h":208}},{"filename":"animations/corinne/0222.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1383,"y":1041,"w":154,"h":208}},{"filename":"animations/corinne/0019.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":956,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0201.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":956,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0219.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":956,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0221.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":956,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0021.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":956,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0039.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":956,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0041.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":956,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0059.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":956,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0061.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":956,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0159.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":956,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0161.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":956,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0179.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":956,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0181.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":956,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0199.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":956,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0022.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1112,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0038.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1112,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0042.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1112,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0058.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1112,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0062.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1112,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0158.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1112,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0162.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1112,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0178.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1112,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0182.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1112,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0198.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1112,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0023.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1112,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0037.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1112,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0043.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1112,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0057.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1112,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0063.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1112,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0163.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1112,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0177.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1112,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0183.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1112,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0197.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1112,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0024.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1268,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0036.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1268,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0044.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1268,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0056.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1268,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0064.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1268,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0164.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1268,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0176.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1268,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0184.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1268,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0196.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1268,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0025.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1268,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0035.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1268,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0045.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1268,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0055.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1268,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0065.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1268,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0165.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1268,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0175.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1268,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0185.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1268,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0195.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1268,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0026.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1424,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0034.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1424,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0046.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1424,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0054.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1424,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0066.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1424,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0166.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1424,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0174.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1424,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0186.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1424,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0194.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1424,"y":1197,"w":154,"h":208}},{"filename":"animations/corinne/0027.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1424,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0047.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1424,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0053.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1424,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0067.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1424,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0167.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1424,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0187.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1424,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0193.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":11,"w":154,"h":208},"frame":{"x":1424,"y":1407,"w":154,"h":208}},{"filename":"animations/corinne/0009.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1593,"y":1119,"w":154,"h":207}},{"filename":"animations/corinne/0010.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1580,"y":1275,"w":154,"h":207}},{"filename":"animations/corinne/0070.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1580,"y":1275,"w":154,"h":207}},{"filename":"animations/corinne/0150.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1580,"y":1275,"w":154,"h":207}},{"filename":"animations/corinne/0170.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1580,"y":1275,"w":154,"h":207}},{"filename":"animations/corinne/0210.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1580,"y":1275,"w":154,"h":207}},{"filename":"scene/nest.png","rotated":false,"trimmed":false,"sourceSize":{"w":170,"h":158},"spriteSourceSize":{"x":0,"y":0,"w":170,"h":158},"frame":{"x":1580,"y":1484,"w":170,"h":158}},{"filename":"animations/corinne/0011.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1736,"y":1275,"w":154,"h":207}},{"filename":"animations/corinne/0069.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1736,"y":1275,"w":154,"h":207}},{"filename":"animations/corinne/0071.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1736,"y":1275,"w":154,"h":207}},{"filename":"animations/corinne/0151.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1736,"y":1275,"w":154,"h":207}},{"filename":"animations/corinne/0171.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1736,"y":1275,"w":154,"h":207}},{"filename":"animations/corinne/0209.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1736,"y":1275,"w":154,"h":207}},{"filename":"animations/corinne/0211.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1736,"y":1275,"w":154,"h":207}},{"filename":"animations/corinne/0012.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1752,"y":1484,"w":154,"h":207}},{"filename":"animations/corinne/0032.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1752,"y":1484,"w":154,"h":207}},{"filename":"animations/corinne/0068.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1752,"y":1484,"w":154,"h":207}},{"filename":"animations/corinne/0072.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1752,"y":1484,"w":154,"h":207}},{"filename":"animations/corinne/0152.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1752,"y":1484,"w":154,"h":207}},{"filename":"animations/corinne/0172.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1752,"y":1484,"w":154,"h":207}},{"filename":"animations/corinne/0208.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1752,"y":1484,"w":154,"h":207}},{"filename":"animations/corinne/0212.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1752,"y":1484,"w":154,"h":207}},{"filename":"animations/corinne/0028.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":956,"y":1617,"w":154,"h":207}},{"filename":"animations/corinne/0048.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":956,"y":1617,"w":154,"h":207}},{"filename":"animations/corinne/0052.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":956,"y":1617,"w":154,"h":207}},{"filename":"animations/corinne/0168.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":956,"y":1617,"w":154,"h":207}},{"filename":"animations/corinne/0188.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":956,"y":1617,"w":154,"h":207}},{"filename":"animations/corinne/0192.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":956,"y":1617,"w":154,"h":207}},{"filename":"animations/corinne/0029.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1165,"y":1617,"w":154,"h":207}},{"filename":"animations/corinne/0031.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1165,"y":1617,"w":154,"h":207}},{"filename":"animations/corinne/0049.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1165,"y":1617,"w":154,"h":207}},{"filename":"animations/corinne/0051.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1165,"y":1617,"w":154,"h":207}},{"filename":"animations/corinne/0169.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1165,"y":1617,"w":154,"h":207}},{"filename":"animations/corinne/0189.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1165,"y":1617,"w":154,"h":207}},{"filename":"animations/corinne/0191.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":1165,"y":1617,"w":154,"h":207}},{"filename":"animations/corinne/0074.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1374,"y":1617,"w":154,"h":204}},{"filename":"animations/corinne/0114.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1374,"y":1617,"w":154,"h":204}},{"filename":"animations/corinne/0146.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1374,"y":1617,"w":154,"h":204}},{"filename":"animations/corinne/0030.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":937,"y":1773,"w":154,"h":207}},{"filename":"animations/corinne/0050.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":937,"y":1773,"w":154,"h":207}},{"filename":"animations/corinne/0190.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":12,"w":154,"h":207},"frame":{"x":937,"y":1773,"w":154,"h":207}},{"filename":"animations/corinne/0078.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1093,"y":1773,"w":154,"h":205}},{"filename":"animations/corinne/0082.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1093,"y":1773,"w":154,"h":205}},{"filename":"animations/corinne/0079.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1249,"y":1773,"w":154,"h":205}},{"filename":"animations/corinne/0081.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1249,"y":1773,"w":154,"h":205}},{"filename":"animations/corinne/0080.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1405,"y":1773,"w":154,"h":205}},{"filename":"animations/corinne/0098.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1580,"y":1644,"w":154,"h":205}},{"filename":"animations/corinne/0102.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1580,"y":1644,"w":154,"h":205}},{"filename":"animations/corinne/0118.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1580,"y":1644,"w":154,"h":205}},{"filename":"animations/corinne/0122.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1580,"y":1644,"w":154,"h":205}},{"filename":"animations/corinne/0138.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1580,"y":1644,"w":154,"h":205}},{"filename":"animations/corinne/0142.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1580,"y":1644,"w":154,"h":205}},{"filename":"animations/corinne/0099.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1561,"y":1851,"w":154,"h":205}},{"filename":"animations/corinne/0101.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1561,"y":1851,"w":154,"h":205}},{"filename":"animations/corinne/0119.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1561,"y":1851,"w":154,"h":205}},{"filename":"animations/corinne/0121.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1561,"y":1851,"w":154,"h":205}},{"filename":"animations/corinne/0139.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1561,"y":1851,"w":154,"h":205}},{"filename":"animations/corinne/0141.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1561,"y":1851,"w":154,"h":205}},{"filename":"animations/corinne/0100.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1736,"y":1693,"w":154,"h":205}},{"filename":"animations/corinne/0120.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1736,"y":1693,"w":154,"h":205}},{"filename":"animations/corinne/0140.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1736,"y":1693,"w":154,"h":205}},{"filename":"animations/corinne/0239.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1768,"y":1849,"w":154,"h":205}},{"filename":"animations/corinne/0241.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1768,"y":1849,"w":154,"h":205}},{"filename":"animations/corinne/0261.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1768,"y":1849,"w":154,"h":205}},{"filename":"animations/corinne/0279.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1768,"y":1849,"w":154,"h":205}},{"filename":"animations/corinne/0281.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1768,"y":1849,"w":154,"h":205}},{"filename":"animations/chicks/plop/right/0005.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":0,"w":35,"h":37},"frame":{"x":919,"y":1631,"w":35,"h":37}},{"filename":"animations/chicks/run/s/0001.png","rotated":true,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":2,"y":2,"w":37,"h":35},"frame":{"x":919,"y":1670,"w":37,"h":35}},{"filename":"animations/chicks/run/s/0004.png","rotated":true,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":2,"y":2,"w":37,"h":35},"frame":{"x":919,"y":1709,"w":37,"h":35}},{"filename":"misc/image_info.png","rotated":false,"trimmed":false,"sourceSize":{"w":45,"h":45},"spriteSourceSize":{"x":0,"y":0,"w":45,"h":45},"frame":{"x":1926,"y":273,"w":45,"h":45}},{"filename":"animations/chicks/run/e/shadow.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":8,"y":19,"w":34,"h":23},"frame":{"x":937,"y":1982,"w":34,"h":23}},{"filename":"animations/chicks/run/e/0002.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":1,"y":2,"w":40,"h":38},"frame":{"x":1926,"y":320,"w":40,"h":38}},{"filename":"animations/chicks/run/w/0002.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":1,"y":2,"w":40,"h":38},"frame":{"x":1926,"y":360,"w":40,"h":38}},{"filename":"animations/chicks/run/n/0002.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":0,"w":36,"h":42},"frame":{"x":1926,"y":400,"w":36,"h":42}},{"filename":"animations/chicks/run/n/0005.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":0,"w":36,"h":42},"frame":{"x":1926,"y":444,"w":36,"h":42}},{"filename":"animations/chicks/run/ne/0002.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":0,"w":36,"h":42},"frame":{"x":1926,"y":488,"w":36,"h":42}},{"filename":"animations/chicks/plop/bottom/0004.png","rotated":true,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":6,"y":23,"w":27,"h":16},"frame":{"x":1593,"y":1041,"w":27,"h":16}},{"filename":"animations/chicks/plop/right/0004.png","rotated":true,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":2,"y":24,"w":26,"h":17},"frame":{"x":1802,"y":1119,"w":26,"h":17}},{"filename":"animations/chicks/run/nw/0002.png","rotated":true,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":0,"w":36,"h":42},"frame":{"x":1943,"y":1172,"w":36,"h":42}},{"filename":"animations/chicks/plop/bottom/0006.png","rotated":true,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":2,"y":3,"w":37,"h":33},"frame":{"x":1908,"y":1172,"w":37,"h":33}},{"filename":"animations/chicks/plop/left/0004.png","rotated":true,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":14,"y":25,"w":25,"h":16},"frame":{"x":1593,"y":1070,"w":25,"h":16}},{"filename":"animations/chicks/run/sw/shadow.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":10,"y":17,"w":32,"h":25},"frame":{"x":1093,"y":1980,"w":32,"h":25}},{"filename":"animations/chicks/run/nw/shadow.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":6,"y":18,"w":36,"h":24},"frame":{"x":1127,"y":1980,"w":36,"h":24}},{"filename":"animations/chicks/run/s/0005.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":2,"y":1,"w":37,"h":40},"frame":{"x":1802,"y":1172,"w":37,"h":40}},{"filename":"animations/chicks/run/e/0001.png","rotated":true,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":2,"y":3,"w":39,"h":37},"frame":{"x":1802,"y":1214,"w":39,"h":37}},{"filename":"animations/chicks/run/e/0003.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":2,"y":3,"w":39,"h":37},"frame":{"x":1841,"y":1172,"w":39,"h":37}},{"filename":"animations/chicks/run/n/0004.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":0,"w":36,"h":40},"frame":{"x":1841,"y":1211,"w":36,"h":40}},{"filename":"animations/chicks/run/w/shadow.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":10,"y":22,"w":32,"h":20},"frame":{"x":1841,"y":1253,"w":32,"h":20}},{"filename":"animations/chicks/run/se/shadow.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":10,"y":20,"w":32,"h":22},"frame":{"x":919,"y":1748,"w":32,"h":22}},{"filename":"animations/chicks/plop/bottom/0003.png","rotated":true,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":11,"y":26,"w":18,"h":14},"frame":{"x":1736,"y":1644,"w":18,"h":14}},{"filename":"animations/chicks/run/ne/0001.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":1,"w":36,"h":40},"frame":{"x":1879,"y":1211,"w":36,"h":40}},{"filename":"animations/chicks/run/nw/0001.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":1,"w":36,"h":40},"frame":{"x":1917,"y":1211,"w":36,"h":40}},{"filename":"animations/chicks/run/n/shadow.png","rotated":true,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":11,"y":14,"w":31,"h":28},"frame":{"x":1955,"y":1210,"w":31,"h":28}},{"filename":"animations/chicks/run/e/0004.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":2,"y":3,"w":39,"h":37},"frame":{"x":1892,"y":1253,"w":39,"h":37}},{"filename":"animations/chicks/run/e/0005.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":2,"y":2,"w":39,"h":37},"frame":{"x":1892,"y":1292,"w":39,"h":37}},{"filename":"animations/chicks/run/e/0006.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":2,"y":3,"w":39,"h":37},"frame":{"x":1892,"y":1331,"w":39,"h":37}},{"filename":"animations/chicks/run/ne/0004.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":1,"w":39,"h":37},"frame":{"x":1892,"y":1370,"w":39,"h":37}},{"filename":"animations/chicks/run/ne/0005.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":0,"y":0,"w":39,"h":37},"frame":{"x":1892,"y":1409,"w":39,"h":37}},{"filename":"animations/chicks/run/sw/0003.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":2,"y":3,"w":36,"h":34},"frame":{"x":1892,"y":1448,"w":36,"h":34}},{"filename":"animations/chicks/run/n/0001.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":0,"w":36,"h":39},"frame":{"x":1933,"y":1253,"w":36,"h":39}},{"filename":"animations/chicks/run/nw/0006.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":1,"w":36,"h":39},"frame":{"x":1933,"y":1294,"w":36,"h":39}},{"filename":"animations/chicks/run/nw/0004.png","rotated":true,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":0,"y":1,"w":39,"h":37},"frame":{"x":1933,"y":1335,"w":39,"h":37}},{"filename":"animations/chicks/run/w/0001.png","rotated":true,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":1,"y":3,"w":39,"h":37},"frame":{"x":1933,"y":1376,"w":39,"h":37}},{"filename":"animations/chicks/run/w/0003.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":1,"y":3,"w":39,"h":37},"frame":{"x":1933,"y":1417,"w":39,"h":37}},{"filename":"animations/chicks/run/w/0004.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":1,"y":3,"w":39,"h":37},"frame":{"x":1930,"y":1456,"w":39,"h":37}},{"filename":"misc/icon_play.png","rotated":false,"trimmed":false,"sourceSize":{"w":15,"h":19},"spriteSourceSize":{"x":0,"y":0,"w":15,"h":19},"frame":{"x":1875,"y":1253,"w":15,"h":19}},{"filename":"animations/chicks/run/w/0005.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":1,"y":2,"w":39,"h":37},"frame":{"x":1908,"y":1495,"w":39,"h":37}},{"filename":"animations/chicks/run/sw/0005.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":2,"y":2,"w":36,"h":39},"frame":{"x":1949,"y":1495,"w":36,"h":39}},{"filename":"animations/chicks/run/w/0006.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":1,"y":3,"w":39,"h":37},"frame":{"x":1908,"y":1534,"w":39,"h":37}},{"filename":"animations/chicks/run/ne/0006.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":2,"w":36,"h":38},"frame":{"x":1949,"y":1536,"w":36,"h":38}},{"filename":"animations/chicks/run/nw/0005.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":0,"w":38,"h":37},"frame":{"x":1908,"y":1573,"w":38,"h":37}},{"filename":"animations/chicks/run/s/0002.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":2,"y":1,"w":37,"h":38},"frame":{"x":1948,"y":1576,"w":37,"h":38}},{"filename":"animations/chicks/run/sw/0002.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":2,"y":2,"w":38,"h":37},"frame":{"x":1908,"y":1612,"w":38,"h":37}},{"filename":"animations/chicks/run/s/0003.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":2,"y":2,"w":37,"h":38},"frame":{"x":1948,"y":1616,"w":37,"h":38}},{"filename":"animations/chicks/run/se/0002.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":1,"y":2,"w":38,"h":36},"frame":{"x":1908,"y":1651,"w":38,"h":36}},{"filename":"animations/chicks/run/se/0006.png","rotated":true,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":2,"w":36,"h":37},"frame":{"x":1948,"y":1656,"w":36,"h":37}},{"filename":"animations/chicks/run/se/0004.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":2,"w":36,"h":38},"frame":{"x":1943,"y":1694,"w":36,"h":38}},{"filename":"animations/chicks/run/se/0005.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":2,"w":36,"h":38},"frame":{"x":1943,"y":1734,"w":36,"h":38}},{"filename":"animations/chicks/run/sw/0004.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":2,"y":2,"w":36,"h":38},"frame":{"x":1943,"y":1774,"w":36,"h":38}},{"filename":"animations/chicks/plop/bottom/0005.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":2,"y":3,"w":37,"h":31},"frame":{"x":1943,"y":1814,"w":37,"h":31}},{"filename":"animations/chicks/run/n/0003.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":0,"w":36,"h":36},"frame":{"x":1926,"y":532,"w":36,"h":36}},{"filename":"animations/chicks/run/n/0006.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":0,"w":36,"h":36},"frame":{"x":1923,"y":570,"w":36,"h":36}},{"filename":"animations/chicks/run/ne/0003.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":1,"w":36,"h":36},"frame":{"x":1923,"y":608,"w":36,"h":36}},{"filename":"animations/chicks/run/nw/0003.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":1,"w":36,"h":36},"frame":{"x":1923,"y":646,"w":36,"h":36}},{"filename":"animations/chicks/run/s/0006.png","rotated":true,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":2,"y":2,"w":37,"h":35},"frame":{"x":1923,"y":684,"w":37,"h":35}},{"filename":"animations/chicks/run/se/0001.png","rotated":true,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":2,"w":36,"h":35},"frame":{"x":1923,"y":723,"w":36,"h":35}},{"filename":"animations/chicks/run/se/0003.png","rotated":true,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":2,"w":36,"h":35},"frame":{"x":1923,"y":761,"w":36,"h":35}},{"filename":"animations/chicks/run/sw/0001.png","rotated":true,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":2,"y":2,"w":36,"h":35},"frame":{"x":1923,"y":799,"w":36,"h":35}},{"filename":"animations/chicks/run/sw/0006.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":2,"y":3,"w":36,"h":36},"frame":{"x":1923,"y":837,"w":36,"h":36}},{"filename":"animations/chicks/plop/left/0005.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":3,"y":1,"w":34,"h":36},"frame":{"x":1923,"y":875,"w":34,"h":36}},{"filename":"animations/chicks/plop/right/0006.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":5,"y":0,"w":34,"h":36},"frame":{"x":1923,"y":913,"w":34,"h":36}},{"filename":"animations/chicks/plop/left/0003.png","rotated":true,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":18,"y":26,"w":15,"h":11},"frame":{"x":1580,"y":1197,"w":15,"h":11}},{"filename":"animations/chicks/plop/bottom/0002.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":17,"y":26,"w":9,"h":8},"frame":{"x":1955,"y":1243,"w":9,"h":8}},{"filename":"animations/chicks/plop/right/0002.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":10,"y":26,"w":8,"h":9},"frame":{"x":1908,"y":1484,"w":8,"h":9}},{"filename":"animations/chicks/plop/right/0001.png","rotated":true,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":9,"y":29,"w":9,"h":7},"frame":{"x":1918,"y":1484,"w":9,"h":7}},{"filename":"animations/chicks/plop/left/0002.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":22,"y":28,"w":8,"h":8},"frame":{"x":781,"y":1997,"w":8,"h":8}},{"filename":"animations/chicks/plop/bottom/0001.png","rotated":true,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":17,"y":28,"w":8,"h":7},"frame":{"x":791,"y":1997,"w":8,"h":7}},{"filename":"animations/chicks/plop/left/0001.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":24,"y":30,"w":7,"h":7},"frame":{"x":1561,"y":1773,"w":7,"h":7}}]},{"image":"atlas_chicken-game-1.png","format":"RGBA8888","size":{"w":936,"h":1392},"scale":1,"frames":[{"filename":"animations/corinne/0240.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1,"y":1,"w":154,"h":205}},{"filename":"animations/corinne/0280.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1,"y":1,"w":154,"h":205}},{"filename":"animations/corinne/0259.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":1,"y":208,"w":154,"h":205}},{"filename":"animations/corinne/0260.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":14,"w":154,"h":205},"frame":{"x":157,"y":1,"w":154,"h":205}},{"filename":"animations/corinne/0075.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1,"y":415,"w":154,"h":204}},{"filename":"animations/corinne/0085.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1,"y":415,"w":154,"h":204}},{"filename":"animations/corinne/0115.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1,"y":415,"w":154,"h":204}},{"filename":"animations/corinne/0076.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":157,"y":208,"w":154,"h":204}},{"filename":"animations/corinne/0084.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":157,"y":208,"w":154,"h":204}},{"filename":"animations/corinne/0077.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":313,"y":1,"w":154,"h":204}},{"filename":"animations/corinne/0083.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":313,"y":1,"w":154,"h":204}},{"filename":"animations/corinne/0086.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1,"y":621,"w":154,"h":204}},{"filename":"animations/corinne/0094.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1,"y":621,"w":154,"h":204}},{"filename":"animations/corinne/0106.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1,"y":621,"w":154,"h":204}},{"filename":"animations/corinne/0126.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1,"y":621,"w":154,"h":204}},{"filename":"animations/corinne/0134.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1,"y":621,"w":154,"h":204}},{"filename":"animations/corinne/0087.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":157,"y":414,"w":154,"h":204}},{"filename":"animations/corinne/0093.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":157,"y":414,"w":154,"h":204}},{"filename":"animations/corinne/0107.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":157,"y":414,"w":154,"h":204}},{"filename":"animations/corinne/0127.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":157,"y":414,"w":154,"h":204}},{"filename":"animations/corinne/0133.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":157,"y":414,"w":154,"h":204}},{"filename":"animations/corinne/0088.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":313,"y":207,"w":154,"h":204}},{"filename":"animations/corinne/0092.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":313,"y":207,"w":154,"h":204}},{"filename":"animations/corinne/0108.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":313,"y":207,"w":154,"h":204}},{"filename":"animations/corinne/0128.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":313,"y":207,"w":154,"h":204}},{"filename":"animations/corinne/0132.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":313,"y":207,"w":154,"h":204}},{"filename":"animations/corinne/0095.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":469,"y":1,"w":154,"h":204}},{"filename":"animations/corinne/0105.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":469,"y":1,"w":154,"h":204}},{"filename":"animations/corinne/0125.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":469,"y":1,"w":154,"h":204}},{"filename":"animations/corinne/0135.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":469,"y":1,"w":154,"h":204}},{"filename":"animations/corinne/0145.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":469,"y":1,"w":154,"h":204}},{"filename":"animations/corinne/0096.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1,"y":827,"w":154,"h":204}},{"filename":"animations/corinne/0104.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1,"y":827,"w":154,"h":204}},{"filename":"animations/corinne/0116.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1,"y":827,"w":154,"h":204}},{"filename":"animations/corinne/0124.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1,"y":827,"w":154,"h":204}},{"filename":"animations/corinne/0136.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1,"y":827,"w":154,"h":204}},{"filename":"animations/corinne/0144.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1,"y":827,"w":154,"h":204}},{"filename":"animations/corinne/0097.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":157,"y":620,"w":154,"h":204}},{"filename":"animations/corinne/0103.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":157,"y":620,"w":154,"h":204}},{"filename":"animations/corinne/0117.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":157,"y":620,"w":154,"h":204}},{"filename":"animations/corinne/0123.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":157,"y":620,"w":154,"h":204}},{"filename":"animations/corinne/0137.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":157,"y":620,"w":154,"h":204}},{"filename":"animations/corinne/0143.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":157,"y":620,"w":154,"h":204}},{"filename":"animations/corinne/0112.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":313,"y":413,"w":154,"h":204}},{"filename":"animations/corinne/0148.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":313,"y":413,"w":154,"h":204}},{"filename":"animations/corinne/0113.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":469,"y":207,"w":154,"h":204}},{"filename":"animations/corinne/0147.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":469,"y":207,"w":154,"h":204}},{"filename":"animations/corinne/0227.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":625,"y":1,"w":154,"h":204}},{"filename":"animations/corinne/0233.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":625,"y":1,"w":154,"h":204}},{"filename":"animations/corinne/0234.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":781,"y":1,"w":154,"h":204}},{"filename":"animations/corinne/0235.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1,"y":1033,"w":154,"h":204}},{"filename":"animations/corinne/0245.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1,"y":1033,"w":154,"h":204}},{"filename":"animations/corinne/0255.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1,"y":1033,"w":154,"h":204}},{"filename":"animations/corinne/0265.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1,"y":1033,"w":154,"h":204}},{"filename":"animations/corinne/0275.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1,"y":1033,"w":154,"h":204}},{"filename":"animations/corinne/0285.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":1,"y":1033,"w":154,"h":204}},{"filename":"animations/corinne/0236.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":157,"y":826,"w":154,"h":204}},{"filename":"animations/corinne/0244.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":157,"y":826,"w":154,"h":204}},{"filename":"animations/corinne/0256.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":157,"y":826,"w":154,"h":204}},{"filename":"animations/corinne/0264.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":157,"y":826,"w":154,"h":204}},{"filename":"animations/corinne/0276.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":157,"y":826,"w":154,"h":204}},{"filename":"animations/corinne/0284.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":157,"y":826,"w":154,"h":204}},{"filename":"animations/corinne/0237.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":313,"y":619,"w":154,"h":204}},{"filename":"animations/corinne/0243.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":313,"y":619,"w":154,"h":204}},{"filename":"animations/corinne/0263.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":313,"y":619,"w":154,"h":204}},{"filename":"animations/corinne/0277.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":313,"y":619,"w":154,"h":204}},{"filename":"animations/corinne/0283.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":313,"y":619,"w":154,"h":204}},{"filename":"animations/corinne/0238.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":469,"y":413,"w":154,"h":204}},{"filename":"animations/corinne/0242.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":469,"y":413,"w":154,"h":204}},{"filename":"animations/corinne/0262.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":469,"y":413,"w":154,"h":204}},{"filename":"animations/corinne/0278.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":469,"y":413,"w":154,"h":204}},{"filename":"animations/corinne/0282.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":469,"y":413,"w":154,"h":204}},{"filename":"animations/corinne/0246.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":625,"y":207,"w":154,"h":204}},{"filename":"animations/corinne/0254.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":625,"y":207,"w":154,"h":204}},{"filename":"animations/corinne/0266.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":625,"y":207,"w":154,"h":204}},{"filename":"animations/corinne/0274.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":625,"y":207,"w":154,"h":204}},{"filename":"animations/corinne/0286.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":625,"y":207,"w":154,"h":204}},{"filename":"animations/corinne/0247.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":781,"y":207,"w":154,"h":204}},{"filename":"animations/corinne/0253.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":781,"y":207,"w":154,"h":204}},{"filename":"animations/corinne/0267.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":781,"y":207,"w":154,"h":204}},{"filename":"animations/corinne/0273.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":781,"y":207,"w":154,"h":204}},{"filename":"animations/corinne/0287.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":781,"y":207,"w":154,"h":204}},{"filename":"animations/corinne/0257.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":157,"y":1032,"w":154,"h":204}},{"filename":"animations/corinne/0258.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":313,"y":825,"w":154,"h":204}},{"filename":"animations/corinne/0293.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":469,"y":619,"w":154,"h":204}},{"filename":"animations/corinne/0294.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":625,"y":413,"w":154,"h":204}},{"filename":"animations/corinne/0295.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":781,"y":413,"w":154,"h":204}},{"filename":"animations/corinne/0296.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":15,"w":154,"h":204},"frame":{"x":313,"y":1031,"w":154,"h":204}},{"filename":"animations/corinne/0089.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":313,"y":1237,"w":154,"h":203}},{"filename":"animations/corinne/0091.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":313,"y":1237,"w":154,"h":203}},{"filename":"animations/corinne/0109.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":313,"y":1237,"w":154,"h":203}},{"filename":"animations/corinne/0111.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":313,"y":1237,"w":154,"h":203}},{"filename":"animations/corinne/0129.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":313,"y":1237,"w":154,"h":203}},{"filename":"animations/corinne/0131.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":313,"y":1237,"w":154,"h":203}},{"filename":"animations/corinne/0090.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":625,"y":619,"w":154,"h":203}},{"filename":"animations/corinne/0110.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":625,"y":619,"w":154,"h":203}},{"filename":"animations/corinne/0130.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":625,"y":619,"w":154,"h":203}},{"filename":"animations/corinne/0149.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":781,"y":619,"w":154,"h":203}},{"filename":"animations/corinne/0228.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":469,"y":825,"w":154,"h":203}},{"filename":"animations/corinne/0232.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":469,"y":825,"w":154,"h":203}},{"filename":"animations/corinne/0229.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":625,"y":824,"w":154,"h":203}},{"filename":"animations/corinne/0231.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":625,"y":824,"w":154,"h":203}},{"filename":"animations/corinne/0289.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":625,"y":824,"w":154,"h":203}},{"filename":"animations/corinne/0230.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":781,"y":824,"w":154,"h":203}},{"filename":"animations/corinne/0290.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":781,"y":824,"w":154,"h":203}},{"filename":"animations/corinne/0248.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":469,"y":1030,"w":154,"h":203}},{"filename":"animations/corinne/0252.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":469,"y":1030,"w":154,"h":203}},{"filename":"animations/corinne/0268.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":469,"y":1030,"w":154,"h":203}},{"filename":"animations/corinne/0272.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":469,"y":1030,"w":154,"h":203}},{"filename":"animations/corinne/0288.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":469,"y":1030,"w":154,"h":203}},{"filename":"animations/corinne/0249.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":625,"y":1029,"w":154,"h":203}},{"filename":"animations/corinne/0251.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":625,"y":1029,"w":154,"h":203}},{"filename":"animations/corinne/0269.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":625,"y":1029,"w":154,"h":203}},{"filename":"animations/corinne/0271.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":625,"y":1029,"w":154,"h":203}},{"filename":"animations/corinne/0250.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":781,"y":1029,"w":154,"h":203}},{"filename":"animations/corinne/0270.png","rotated":false,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":781,"y":1029,"w":154,"h":203}},{"filename":"animations/corinne/0291.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":518,"y":1235,"w":154,"h":203}},{"filename":"animations/corinne/0292.png","rotated":true,"trimmed":true,"sourceSize":{"w":154,"h":219},"spriteSourceSize":{"x":0,"y":16,"w":154,"h":203},"frame":{"x":723,"y":1234,"w":154,"h":203}},{"filename":"animations/chicks/plop/left/0006.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":2,"y":2,"w":33,"h":35},"frame":{"x":1,"y":1239,"w":33,"h":35}},{"filename":"misc/icon_restart.png","rotated":false,"trimmed":false,"sourceSize":{"w":32,"h":29},"spriteSourceSize":{"x":0,"y":0,"w":32,"h":29},"frame":{"x":1,"y":1276,"w":32,"h":29}},{"filename":"animations/chicks/run/s/shadow.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":11,"y":19,"w":31,"h":23},"frame":{"x":36,"y":1239,"w":31,"h":23}},{"filename":"animations/chicks/run/ne/shadow.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":11,"y":22,"w":31,"h":20},"frame":{"x":1,"y":1307,"w":31,"h":20}},{"filename":"animations/chicks/plop/right/0003.png","rotated":false,"trimmed":true,"sourceSize":{"w":42,"h":42},"spriteSourceSize":{"x":8,"y":24,"w":16,"h":13},"frame":{"x":69,"y":1239,"w":16,"h":13}}]}],"meta":{"app":"https://www.codeandweb.com/texturepacker","version":"3.0","smartupdate":"$TexturePacker:SmartUpdate:87bf0e1963da36eef623f7b424afa67b:53f1a3bb7d5b56b7f05c269d0c5cfb2a:e58e2d248ff9a52916862a131fa6d304$"}}

/***/ }),
/* 986 */
/***/ (function(module, exports) {

	module.exports = {"textures":[{"image":"scarecrow.png","format":"RGBA8888","size":{"w":2044,"h":1246},"scale":1,"frames":[{"filename":"scene/sky.jpg","rotated":false,"trimmed":false,"sourceSize":{"w":960,"h":576},"spriteSourceSize":{"x":0,"y":0,"w":960,"h":576},"frame":{"x":1,"y":1,"w":960,"h":576},"anchor":{"x":0,"y":0}},{"filename":"interface/background_overlay.png","rotated":false,"trimmed":false,"sourceSize":{"w":961,"h":542},"spriteSourceSize":{"x":0,"y":0,"w":961,"h":542},"frame":{"x":963,"y":1,"w":961,"h":542},"anchor":{"x":0,"y":0}},{"filename":"interface/background_cloud.png","rotated":false,"trimmed":true,"sourceSize":{"w":961,"h":542},"spriteSourceSize":{"x":8,"y":0,"w":953,"h":542},"frame":{"x":1,"y":579,"w":953,"h":542},"anchor":{"x":0,"y":0}},{"filename":"scene/back.png","rotated":false,"trimmed":false,"sourceSize":{"w":960,"h":117},"spriteSourceSize":{"x":0,"y":0,"w":960,"h":117},"frame":{"x":1,"y":1123,"w":960,"h":117},"anchor":{"x":0,"y":0}},{"filename":"scene/front.png","rotated":false,"trimmed":false,"sourceSize":{"w":960,"h":214},"spriteSourceSize":{"x":0,"y":0,"w":960,"h":214},"frame":{"x":963,"y":545,"w":960,"h":214},"anchor":{"x":0,"y":0}},{"filename":"interface/paint_green.png","rotated":false,"trimmed":false,"sourceSize":{"w":705,"h":207},"spriteSourceSize":{"x":0,"y":0,"w":705,"h":207},"frame":{"x":956,"y":761,"w":705,"h":207},"anchor":{"x":0.5,"y":0.5}},{"filename":"interface/birds.png","rotated":false,"trimmed":false,"sourceSize":{"w":336,"h":167},"spriteSourceSize":{"x":0,"y":0,"w":336,"h":167},"frame":{"x":1663,"y":761,"w":336,"h":167},"anchor":{"x":0.5,"y":0.5}},{"filename":"interface/button.png","rotated":false,"trimmed":false,"sourceSize":{"w":270,"h":59},"spriteSourceSize":{"x":0,"y":0,"w":270,"h":59},"frame":{"x":956,"y":970,"w":270,"h":59},"anchor":{"x":0.5,"y":0.5}},{"filename":"victor/victor_01.png","rotated":true,"trimmed":true,"sourceSize":{"w":194,"h":320},"spriteSourceSize":{"x":1,"y":92,"w":191,"h":226},"frame":{"x":963,"y":1031,"w":191,"h":226},"anchor":{"x":0.5,"y":1}},{"filename":"victor/victor_03.png","rotated":true,"trimmed":true,"sourceSize":{"w":194,"h":320},"spriteSourceSize":{"x":17,"y":2,"w":159,"h":228},"frame":{"x":1228,"y":970,"w":159,"h":228},"anchor":{"x":0.5,"y":1}},{"filename":"victor/victor_04.png","rotated":true,"trimmed":true,"sourceSize":{"w":194,"h":320},"spriteSourceSize":{"x":1,"y":24,"w":191,"h":226},"frame":{"x":1458,"y":970,"w":191,"h":226},"anchor":{"x":0.5,"y":1}},{"filename":"victor/victor_06.png","rotated":false,"trimmed":true,"sourceSize":{"w":194,"h":320},"spriteSourceSize":{"x":1,"y":92,"w":190,"h":226},"frame":{"x":1686,"y":930,"w":190,"h":226},"anchor":{"x":0.5,"y":1}},{"filename":"bird/fly_05.png","rotated":true,"trimmed":true,"sourceSize":{"w":163,"h":170},"spriteSourceSize":{"x":0,"y":9,"w":163,"h":131},"frame":{"x":1878,"y":930,"w":163,"h":131},"anchor":{"x":0.5,"y":1}},{"filename":"victor/victor_02.png","rotated":false,"trimmed":true,"sourceSize":{"w":194,"h":320},"spriteSourceSize":{"x":15,"y":168,"w":163,"h":150},"frame":{"x":1878,"y":1095,"w":163,"h":150},"anchor":{"x":0.5,"y":1}},{"filename":"victor/victor_05.png","rotated":false,"trimmed":true,"sourceSize":{"w":194,"h":320},"spriteSourceSize":{"x":15,"y":168,"w":163,"h":150},"frame":{"x":1878,"y":1095,"w":163,"h":150},"anchor":{"x":0.5,"y":1}},{"filename":"bird/fly_03.png","rotated":true,"trimmed":true,"sourceSize":{"w":163,"h":170},"spriteSourceSize":{"x":0,"y":49,"w":163,"h":99},"frame":{"x":1926,"y":1,"w":163,"h":99},"anchor":{"x":0.5,"y":1}},{"filename":"bird/fly_06.png","rotated":true,"trimmed":true,"sourceSize":{"w":163,"h":170},"spriteSourceSize":{"x":0,"y":45,"w":163,"h":95},"frame":{"x":1926,"y":166,"w":163,"h":95},"anchor":{"x":0.5,"y":1}},{"filename":"bird/fly_04.png","rotated":true,"trimmed":true,"sourceSize":{"w":163,"h":170},"spriteSourceSize":{"x":0,"y":49,"w":163,"h":91},"frame":{"x":1926,"y":331,"w":163,"h":91},"anchor":{"x":0.5,"y":1}},{"filename":"bird/fly_02.png","rotated":false,"trimmed":true,"sourceSize":{"w":163,"h":170},"spriteSourceSize":{"x":0,"y":46,"w":117,"h":105},"frame":{"x":1191,"y":1131,"w":117,"h":105},"anchor":{"x":0.5,"y":1}},{"filename":"bird/bird_03.png","rotated":false,"trimmed":true,"sourceSize":{"w":149,"h":169},"spriteSourceSize":{"x":17,"y":96,"w":113,"h":69},"frame":{"x":1310,"y":1131,"w":113,"h":69},"anchor":{"x":0.5,"y":1}},{"filename":"bird/bird_02.png","rotated":true,"trimmed":true,"sourceSize":{"w":149,"h":169},"spriteSourceSize":{"x":6,"y":27,"w":129,"h":117},"frame":{"x":1926,"y":496,"w":129,"h":117},"anchor":{"x":0.5,"y":1}},{"filename":"bird/fly_01.png","rotated":true,"trimmed":true,"sourceSize":{"w":163,"h":170},"spriteSourceSize":{"x":11,"y":51,"w":128,"h":116},"frame":{"x":1925,"y":627,"w":128,"h":116},"anchor":{"x":0.5,"y":1}},{"filename":"bird/bird_04.png","rotated":false,"trimmed":true,"sourceSize":{"w":149,"h":169},"spriteSourceSize":{"x":15,"y":104,"w":113,"h":61},"frame":{"x":1425,"y":1163,"w":113,"h":61},"anchor":{"x":0.5,"y":1}},{"filename":"interface/icon_gameplay.png","rotated":false,"trimmed":false,"sourceSize":{"w":106,"h":73},"spriteSourceSize":{"x":0,"y":0,"w":106,"h":73},"frame":{"x":1540,"y":1163,"w":106,"h":73},"anchor":{"x":0.5,"y":0.5}},{"filename":"bird/bird_01.png","rotated":true,"trimmed":true,"sourceSize":{"w":149,"h":169},"spriteSourceSize":{"x":71,"y":0,"w":65,"h":90},"frame":{"x":1648,"y":1163,"w":65,"h":90},"anchor":{"x":0.5,"y":1}},{"filename":"interface/info.png","rotated":false,"trimmed":false,"sourceSize":{"w":45,"h":45},"spriteSourceSize":{"x":0,"y":0,"w":45,"h":45},"frame":{"x":1740,"y":1158,"w":45,"h":45},"anchor":{"x":0.5,"y":0.5}},{"filename":"seeds/seed_04.png","rotated":true,"trimmed":true,"sourceSize":{"w":56,"h":42},"spriteSourceSize":{"x":13,"y":13,"w":31,"h":21},"frame":{"x":1663,"y":930,"w":31,"h":21},"anchor":{"x":0.5,"y":0.5}},{"filename":"seeds/seed_01.png","rotated":true,"trimmed":true,"sourceSize":{"w":56,"h":42},"spriteSourceSize":{"x":4,"y":7,"w":48,"h":28},"frame":{"x":1191,"y":1031,"w":48,"h":28},"anchor":{"x":0.5,"y":0.5}},{"filename":"seeds/seed_03.png","rotated":false,"trimmed":true,"sourceSize":{"w":56,"h":42},"spriteSourceSize":{"x":2,"y":8,"w":50,"h":23},"frame":{"x":1310,"y":1202,"w":50,"h":23},"anchor":{"x":0.5,"y":0.5}},{"filename":"seeds/seed_02.png","rotated":false,"trimmed":true,"sourceSize":{"w":56,"h":42},"spriteSourceSize":{"x":14,"y":14,"w":33,"h":18},"frame":{"x":1310,"y":1227,"w":33,"h":18},"anchor":{"x":0.5,"y":0.5}},{"filename":"interface/icon_restart.png","rotated":false,"trimmed":false,"sourceSize":{"w":32,"h":29},"spriteSourceSize":{"x":0,"y":0,"w":32,"h":29},"frame":{"x":1787,"y":1158,"w":32,"h":29},"anchor":{"x":0.5,"y":0.5}},{"filename":"interface/icon_play.png","rotated":true,"trimmed":false,"sourceSize":{"w":15,"h":19},"spriteSourceSize":{"x":0,"y":0,"w":15,"h":19},"frame":{"x":1648,"y":1230,"w":15,"h":19},"anchor":{"x":0.5,"y":0.5}},{"filename":"seeds/seed_05.png","rotated":true,"trimmed":true,"sourceSize":{"w":56,"h":42},"spriteSourceSize":{"x":21,"y":15,"w":15,"h":10},"frame":{"x":1669,"y":1230,"w":15,"h":10},"anchor":{"x":0.5,"y":0.5}}]}],"meta":{"app":"https://www.codeandweb.com/texturepacker","version":"3.0","smartupdate":"$TexturePacker:SmartUpdate:8e4eda9d77c8f74f0a89331a8f612db7:00eb596622eb26aa9db396152de694ef:cc4d5bff0734c3fea53e37ad1cab81da$"}}

/***/ }),
/* 987 */,
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PropertyValueInc = __webpack_require__(70);
	
	/**
	 * Takes an array of Game Objects, or any objects that have a public `angle` property,
	 * and then adds the given value to each of their `angle` properties.
	 *
	 * The optional `step` property is applied incrementally, multiplied by each item in the array.
	 *
	 * To use this with a Group: `Angle(group.getChildren(), value, step)`
	 *
	 * @function Phaser.Actions.Angle
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {number} value - The amount to be added to the `angle` property.
	 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var Angle = function (items, value, step, index, direction)
	{
	    return PropertyValueInc(items, 'angle', value, step, index, direction);
	};
	
	module.exports = Angle;


/***/ }),
/* 989 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @callback CallCallback
	 *
	 * @param {Phaser.GameObjects.GameObject} item - [description]
	 */
	
	/**
	 * Takes an array of objects and passes each of them to the given callback.
	 *
	 * @function Phaser.Actions.Call
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {CallCallback} callback - The callback to be invoked. It will be passed just one argument: the item from the array.
	 * @param {*} context - The scope in which the callback will be invoked.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that was passed to this Action.
	 */
	var Call = function (items, callback, context)
	{
	    for (var i = 0; i < items.length; i++)
	    {
	        var item = items[i];
	
	        callback.call(context, item);
	    }
	
	    return items;
	};
	
	module.exports = Call;


/***/ }),
/* 990 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Takes an array of objects and returns the first element in the array that has properties which match
	 * all of those specified in the `compare` object. For example, if the compare object was: `{ scaleX: 0.5, alpha: 1 }`
	 * then it would return the first item which had the property `scaleX` set to 0.5 and `alpha` set to 1.
	 *
	 * To use this with a Group: `GetFirst(group.getChildren(), compare, index)`
	 *
	 * @function Phaser.Actions.GetFirst
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be searched by this action.
	 * @param {object} compare - The comparison object. Each property in this object will be checked against the items of the array.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 *
	 * @return {?(object|Phaser.GameObjects.GameObject)} The first object in the array that matches the comparison object, or `null` if no match was found.
	 */
	var GetFirst = function (items, compare, index)
	{
	    if (index === undefined) { index = 0; }
	
	    for (var i = index; i < items.length; i++)
	    {
	        var item = items[i];
	
	        var match = true;
	
	        for (var property in compare)
	        {
	            if (item[property] !== compare[property])
	            {
	                match = false;
	            }
	        }
	
	        if (match)
	        {
	            return item;
	        }
	    }
	
	    return null;
	};
	
	module.exports = GetFirst;


/***/ }),
/* 991 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Takes an array of objects and returns the last element in the array that has properties which match
	 * all of those specified in the `compare` object. For example, if the compare object was: `{ scaleX: 0.5, alpha: 1 }`
	 * then it would return the last item which had the property `scaleX` set to 0.5 and `alpha` set to 1.
	 *
	 * To use this with a Group: `GetLast(group.getChildren(), compare, index)`
	 *
	 * @function Phaser.Actions.GetLast
	 * @since 3.3.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be searched by this action.
	 * @param {object} compare - The comparison object. Each property in this object will be checked against the items of the array.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 *
	 * @return {?(object|Phaser.GameObjects.GameObject)} The last object in the array that matches the comparison object, or `null` if no match was found.
	 */
	var GetLast = function (items, compare, index)
	{
	    if (index === undefined) { index = 0; }
	
	    for (var i = index; i < items.length; i++)
	    {
	        var item = items[i];
	
	        var match = true;
	
	        for (var property in compare)
	        {
	            if (item[property] !== compare[property])
	            {
	                match = false;
	            }
	        }
	
	        if (match)
	        {
	            return item;
	        }
	    }
	
	    return null;
	};
	
	module.exports = GetLast;


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var AlignIn = __webpack_require__(465);
	var CONST = __webpack_require__(267);
	var GetFastValue = __webpack_require__(3);
	var NOOP = __webpack_require__(6);
	var Zone = __webpack_require__(198);
	
	var tempZone = new Zone({ sys: { queueDepthSort: NOOP, events: { once: NOOP } } }, 0, 0, 1, 1);
	
	/**
	 * @typedef {object} GridAlignConfig
	 *
	 * @property {integer} [width=-1] - The width of the grid in items (not pixels). -1 means lay all items out horizontally, regardless of quantity.
	 *                                  If both this value and height are set to -1 then this value overrides it and the `height` value is ignored.
	 * @property {integer} [height=-1] - The height of the grid in items (not pixels). -1 means lay all items out vertically, regardless of quantity.
	 *                                   If both this value and `width` are set to -1 then `width` overrides it and this value is ignored.
	 * @property {integer} [cellWidth=1] - The width of the cell, in pixels, in which the item is positioned.
	 * @property {integer} [cellHeight=1] - The height of the cell, in pixels, in which the item is positioned.
	 * @property {integer} [position=0] - The alignment position. One of the Phaser.Display.Align consts such as `TOP_LEFT` or `RIGHT_CENTER`.
	 * @property {number} [x=0] - Optionally place the top-left of the final grid at this coordinate.
	 * @property {number} [y=0] - Optionally place the top-left of the final grid at this coordinate.
	 */
	
	/**
	 * Takes an array of Game Objects, or any objects that have public `x` and `y` properties,
	 * and then aligns them based on the grid configuration given to this action.
	 *
	 * @function Phaser.Actions.GridAlign
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {GridAlignConfig} options - The GridAlign Configuration object.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var GridAlign = function (items, options)
	{
	    if (options === undefined) { options = {}; }
	
	    var width = GetFastValue(options, 'width', -1);
	    var height = GetFastValue(options, 'height', -1);
	    var cellWidth = GetFastValue(options, 'cellWidth', 1);
	    var cellHeight = GetFastValue(options, 'cellHeight', cellWidth);
	    var position = GetFastValue(options, 'position', CONST.TOP_LEFT);
	    var x = GetFastValue(options, 'x', 0);
	    var y = GetFastValue(options, 'y', 0);
	
	    var cx = 0;
	    var cy = 0;
	    var w = (width * cellWidth);
	    var h = (height * cellHeight);
	
	    tempZone.setPosition(x, y);
	    tempZone.setSize(cellWidth, cellHeight);
	
	    for (var i = 0; i < items.length; i++)
	    {
	        AlignIn(items[i], tempZone, position);
	
	        if (width === -1)
	        {
	            //  We keep laying them out horizontally until we've done them all
	            cy += cellHeight;
	            tempZone.y += cellHeight;
	
	            if (cy === h)
	            {
	                cy = 0;
	                tempZone.x += cellWidth;
	                tempZone.y = y;
	            }
	        }
	        else if (height === -1)
	        {
	            //  We keep laying them out vertically until we've done them all
	            cx += cellWidth;
	            tempZone.x += cellWidth;
	
	            if (cx === w)
	            {
	                cx = 0;
	                tempZone.x = x;
	                tempZone.y += cellHeight;
	            }
	        }
	        else
	        {
	            //  We keep laying them out until we hit the column limit
	            cx += cellWidth;
	            tempZone.x += cellWidth;
	
	            if (cx === w)
	            {
	                cx = 0;
	                cy += cellHeight;
	                tempZone.x = x;
	                tempZone.y += cellHeight;
	
	                if (cy === h)
	                {
	                    //  We've hit the column limit, so return, even if there are items left
	                    break;
	                }
	            }
	        }
	    }
	
	    return items;
	};
	
	module.exports = GridAlign;


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PropertyValueInc = __webpack_require__(70);
	
	/**
	 * Takes an array of Game Objects, or any objects that have a public `alpha` property,
	 * and then adds the given value to each of their `alpha` properties.
	 *
	 * The optional `step` property is applied incrementally, multiplied by each item in the array.
	 *
	 * To use this with a Group: `IncAlpha(group.getChildren(), value, step)`
	 *
	 * @function Phaser.Actions.IncAlpha
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {number} value - The amount to be added to the `alpha` property.
	 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var IncAlpha = function (items, value, step, index, direction)
	{
	    return PropertyValueInc(items, 'alpha', value, step, index, direction);
	};
	
	module.exports = IncAlpha;


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PropertyValueInc = __webpack_require__(70);
	
	/**
	 * Takes an array of Game Objects, or any objects that have a public `x` property,
	 * and then adds the given value to each of their `x` properties.
	 *
	 * The optional `step` property is applied incrementally, multiplied by each item in the array.
	 *
	 * To use this with a Group: `IncX(group.getChildren(), value, step)`
	 *
	 * @function Phaser.Actions.IncX
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {number} value - The amount to be added to the `x` property.
	 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var IncX = function (items, value, step, index, direction)
	{
	    return PropertyValueInc(items, 'x', value, step, index, direction);
	};
	
	module.exports = IncX;


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PropertyValueInc = __webpack_require__(70);
	
	/**
	 * Takes an array of Game Objects, or any objects that have public `x` and `y` properties,
	 * and then adds the given value to each of them.
	 *
	 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
	 *
	 * To use this with a Group: `IncXY(group.getChildren(), x, y, stepX, stepY)`
	 *
	 * @function Phaser.Actions.IncXY
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {number} x - The amount to be added to the `x` property.
	 * @param {number} [y=x] - The amount to be added to the `y` property. If `undefined` or `null` it uses the `x` value.
	 * @param {number} [stepX=0] - This is added to the `x` amount, multiplied by the iteration counter.
	 * @param {number} [stepY=0] - This is added to the `y` amount, multiplied by the iteration counter.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var IncXY = function (items, x, y, stepX, stepY, index, direction)
	{
	    if (y === undefined || y === null) { y = x; }
	
	    PropertyValueInc(items, 'x', x, stepX, index, direction);
	
	    return PropertyValueInc(items, 'y', y, stepY, index, direction);
	};
	
	module.exports = IncXY;


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PropertyValueInc = __webpack_require__(70);
	
	/**
	 * Takes an array of Game Objects, or any objects that have a public `y` property,
	 * and then adds the given value to each of their `y` properties.
	 *
	 * The optional `step` property is applied incrementally, multiplied by each item in the array.
	 *
	 * To use this with a Group: `IncY(group.getChildren(), value, step)`
	 *
	 * @function Phaser.Actions.IncY
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {number} value - The amount to be added to the `y` property.
	 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var IncY = function (items, value, step, index, direction)
	{
	    return PropertyValueInc(items, 'y', value, step, index, direction);
	};
	
	module.exports = IncY;


/***/ }),
/* 997 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Actions.PlaceOnCircle
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
	 * @param {Phaser.Geom.Circle} circle - [description]
	 * @param {number} [startAngle=0] - [description]
	 * @param {number} [endAngle=6.28] - [description]
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
	 */
	var PlaceOnCircle = function (items, circle, startAngle, endAngle)
	{
	    if (startAngle === undefined) { startAngle = 0; }
	    if (endAngle === undefined) { endAngle = 6.28; }
	
	    var angle = startAngle;
	    var angleStep = (endAngle - startAngle) / items.length;
	
	    for (var i = 0; i < items.length; i++)
	    {
	        items[i].x = circle.x + (circle.radius * Math.cos(angle));
	        items[i].y = circle.y + (circle.radius * Math.sin(angle));
	
	        angle += angleStep;
	    }
	
	    return items;
	};
	
	module.exports = PlaceOnCircle;


/***/ }),
/* 998 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Actions.PlaceOnEllipse
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
	 * @param {Phaser.Geom.Ellipse} ellipse - [description]
	 * @param {number} [startAngle=0] - [description]
	 * @param {number} [endAngle=6.28] - [description]
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
	 */
	var PlaceOnEllipse = function (items, ellipse, startAngle, endAngle)
	{
	    if (startAngle === undefined) { startAngle = 0; }
	    if (endAngle === undefined) { endAngle = 6.28; }
	
	    var angle = startAngle;
	    var angleStep = (endAngle - startAngle) / items.length;
	
	    var a = ellipse.width / 2;
	    var b = ellipse.height / 2;
	
	    for (var i = 0; i < items.length; i++)
	    {
	        items[i].x = ellipse.x + a * Math.cos(angle);
	        items[i].y = ellipse.y + b * Math.sin(angle);
	
	        angle += angleStep;
	    }
	
	    return items;
	};
	
	module.exports = PlaceOnEllipse;


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetPoints = __webpack_require__(290);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Actions.PlaceOnLine
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
	 * @param {Phaser.Geom.Line} line - [description]
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
	 */
	var PlaceOnLine = function (items, line)
	{
	    var points = GetPoints(line, items.length);
	
	    for (var i = 0; i < items.length; i++)
	    {
	        var item = items[i];
	        var point = points[i];
	
	        item.x = point.x;
	        item.y = point.y;
	    }
	
	    return items;
	};
	
	module.exports = PlaceOnLine;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var MarchingAnts = __webpack_require__(523);
	var RotateLeft = __webpack_require__(661);
	var RotateRight = __webpack_require__(662);
	
	//  Place the items in the array around the perimeter of the given rectangle.
	
	//  Placement starts from the top-left of the rectangle, and proceeds in a
	//  clockwise direction. If the shift parameter is given you can offset where
	//  placement begins.
	
	/**
	 * [description]
	 *
	 * @function Phaser.Actions.PlaceOnRectangle
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 * @param {integer} [shift=1] - [description]
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
	 */
	var PlaceOnRectangle = function (items, rect, shift)
	{
	    if (shift === undefined) { shift = 0; }
	
	    var points = MarchingAnts(rect, false, items.length);
	
	    if (shift > 0)
	    {
	        RotateLeft(points, shift);
	    }
	    else if (shift < 0)
	    {
	        RotateRight(points, Math.abs(shift));
	    }
	
	    for (var i = 0; i < items.length; i++)
	    {
	        items[i].x = points[i].x;
	        items[i].y = points[i].y;
	    }
	
	    return items;
	};
	
	module.exports = PlaceOnRectangle;


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	// var GetPointsOnLine = require('../geom/line/GetPointsOnLine');
	var BresenhamPoints = __webpack_require__(513);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Actions.PlaceOnTriangle
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 * @param {number} [stepRate=1] - [description]
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
	 */
	var PlaceOnTriangle = function (items, triangle, stepRate)
	{
	    var p1 = BresenhamPoints({ x1: triangle.x1, y1: triangle.y1, x2: triangle.x2, y2: triangle.y2 }, stepRate);
	    var p2 = BresenhamPoints({ x1: triangle.x2, y1: triangle.y2, x2: triangle.x3, y2: triangle.y3 }, stepRate);
	    var p3 = BresenhamPoints({ x1: triangle.x3, y1: triangle.y3, x2: triangle.x1, y2: triangle.y1 }, stepRate);
	
	    //  Remove overlaps
	    p1.pop();
	    p2.pop();
	    p3.pop();
	
	    p1 = p1.concat(p2, p3);
	
	    var step = p1.length / items.length;
	    var p = 0;
	
	    for (var i = 0; i < items.length; i++)
	    {
	        var item = items[i];
	        var point = p1[Math.floor(p)];
	
	        item.x = point.x;
	        item.y = point.y;
	
	        p += step;
	    }
	
	    return items;
	};
	
	module.exports = PlaceOnTriangle;


/***/ }),
/* 1002 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Play an animation with the given key, starting at the given startFrame on all Game Objects in items.
	 *
	 * @function Phaser.Actions.PlayAnimation
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
	 * @param {string} key - The name of the animation to play.
	 * @param {(string|integer)} [startFrame] - The starting frame of the animation with the given key.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
	 */
	var PlayAnimation = function (items, key, startFrame)
	{
	    for (var i = 0; i < items.length; i++)
	    {
	        items[i].anims.play(key, startFrame);
	    }
	
	    return items;
	};
	
	module.exports = PlayAnimation;


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Random = __webpack_require__(286);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Actions.RandomCircle
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
	 * @param {Phaser.Geom.Circle} circle - [description]
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
	 */
	var RandomCircle = function (items, circle)
	{
	    for (var i = 0; i < items.length; i++)
	    {
	        Random(circle, items[i]);
	    }
	
	    return items;
	};
	
	module.exports = RandomCircle;


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Random = __webpack_require__(289);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Actions.RandomEllipse
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
	 * @param {Phaser.Geom.Ellipse} ellipse - [description]
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
	 */
	var RandomEllipse = function (items, ellipse)
	{
	    for (var i = 0; i < items.length; i++)
	    {
	        Random(ellipse, items[i]);
	    }
	
	    return items;
	};
	
	module.exports = RandomEllipse;


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Random = __webpack_require__(291);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Actions.RandomLine
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
	 * @param {Phaser.Geom.Line} line - [description]
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
	 */
	var RandomLine = function (items, line)
	{
	    for (var i = 0; i < items.length; i++)
	    {
	        Random(line, items[i]);
	    }
	
	    return items;
	};
	
	module.exports = RandomLine;


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Random = __webpack_require__(297);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Actions.RandomRectangle
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
	 */
	var RandomRectangle = function (items, rect)
	{
	    for (var i = 0; i < items.length; i++)
	    {
	        Random(rect, items[i]);
	    }
	
	    return items;
	};
	
	module.exports = RandomRectangle;


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Random = __webpack_require__(299);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Actions.RandomTriangle
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
	 */
	var RandomTriangle = function (items, triangle)
	{
	    for (var i = 0; i < items.length; i++)
	    {
	        Random(triangle, items[i]);
	    }
	
	    return items;
	};
	
	module.exports = RandomTriangle;


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PropertyValueInc = __webpack_require__(70);
	
	/**
	 * Takes an array of Game Objects, or any objects that have a public `rotation` property,
	 * and then adds the given value to each of their `rotation` properties.
	 *
	 * The optional `step` property is applied incrementally, multiplied by each item in the array.
	 *
	 * To use this with a Group: `Rotate(group.getChildren(), value, step)`
	 *
	 * @function Phaser.Actions.Rotate
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {number} value - The amount to be added to the `rotation` property (in radians).
	 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var Rotate = function (items, value, step, index, direction)
	{
	    return PropertyValueInc(items, 'rotation', value, step, index, direction);
	};
	
	module.exports = Rotate;


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var RotateAroundDistance = __webpack_require__(309);
	var DistanceBetween = __webpack_require__(116);
	
	/**
	 * Rotates each item around the given point by the given angle.
	 *
	 * @function Phaser.Actions.RotateAround
	 * @since 3.0.0
	 * @see Phaser.Math.RotateAroundDistance
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
	 * @param {object} point - Any object with public `x` and `y` properties.
	 * @param {number} angle - The angle to rotate by, in radians.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
	 */
	var RotateAround = function (items, point, angle)
	{
	    var x = point.x;
	    var y = point.y;
	
	    for (var i = 0; i < items.length; i++)
	    {
	        var item = items[i];
	
	        RotateAroundDistance(item, x, y, angle, Math.max(1, DistanceBetween(item.x, item.y, x, y)));
	    }
	
	    return items;
	};
	
	module.exports = RotateAround;


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var MathRotateAroundDistance = __webpack_require__(309);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Actions.RotateAroundDistance
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
	 * @param {object} point - Any object with public `x` and `y` properties.
	 * @param {number} angle - The angle to rotate by, in radians.
	 * @param {number} distance - The distance from the point of rotation in pixels.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
	 */
	var RotateAroundDistance = function (items, point, angle, distance)
	{
	    var x = point.x;
	    var y = point.y;
	
	    //  There's nothing to do
	    if (distance === 0)
	    {
	        return items;
	    }
	
	    for (var i = 0; i < items.length; i++)
	    {
	        MathRotateAroundDistance(items[i], x, y, angle, distance);
	    }
	
	    return items;
	};
	
	module.exports = RotateAroundDistance;


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PropertyValueInc = __webpack_require__(70);
	
	/**
	 * Takes an array of Game Objects, or any objects that have a public `scaleX` property,
	 * and then adds the given value to each of their `scaleX` properties.
	 *
	 * The optional `step` property is applied incrementally, multiplied by each item in the array.
	 *
	 * To use this with a Group: `ScaleX(group.getChildren(), value, step)`
	 *
	 * @function Phaser.Actions.ScaleX
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {number} value - The amount to be added to the `scaleX` property.
	 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var ScaleX = function (items, value, step, index, direction)
	{
	    return PropertyValueInc(items, 'scaleX', value, step, index, direction);
	};
	
	module.exports = ScaleX;


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PropertyValueInc = __webpack_require__(70);
	
	/**
	 * Takes an array of Game Objects, or any objects that have public `scaleX` and `scaleY` properties,
	 * and then adds the given value to each of them.
	 *
	 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
	 *
	 * To use this with a Group: `ScaleXY(group.getChildren(), scaleX, scaleY, stepX, stepY)`
	 *
	 * @function Phaser.Actions.ScaleXY
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {number} scaleX - The amount to be added to the `scaleX` property.
	 * @param {number} [scaleY] - The amount to be added to the `scaleY` property. If `undefined` or `null` it uses the `scaleX` value.
	 * @param {number} [stepX=0] - This is added to the `scaleX` amount, multiplied by the iteration counter.
	 * @param {number} [stepY=0] - This is added to the `y` amount, multiplied by the iteration counter.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var ScaleXY = function (items, scaleX, scaleY, stepX, stepY, index, direction)
	{
	    if (scaleY === undefined || scaleY === null) { scaleY = scaleX; }
	
	    PropertyValueInc(items, 'scaleX', scaleX, stepX, index, direction);
	
	    return PropertyValueInc(items, 'scaleY', scaleY, stepY, index, direction);
	};
	
	module.exports = ScaleXY;


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PropertyValueInc = __webpack_require__(70);
	
	/**
	 * Takes an array of Game Objects, or any objects that have a public `scaleY` property,
	 * and then adds the given value to each of their `scaleY` properties.
	 *
	 * The optional `step` property is applied incrementally, multiplied by each item in the array.
	 *
	 * To use this with a Group: `ScaleY(group.getChildren(), value, step)`
	 *
	 * @function Phaser.Actions.ScaleY
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {number} value - The amount to be added to the `scaleY` property.
	 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var ScaleY = function (items, value, step, index, direction)
	{
	    return PropertyValueInc(items, 'scaleY', value, step, index, direction);
	};
	
	module.exports = ScaleY;


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PropertyValueSet = __webpack_require__(48);
	
	/**
	 * Takes an array of Game Objects, or any objects that have the public property `alpha`
	 * and then sets it to the given value.
	 *
	 * The optional `step` property is applied incrementally, multiplied by each item in the array.
	 *
	 * To use this with a Group: `SetAlpha(group.getChildren(), value, step)`
	 *
	 * @function Phaser.Actions.SetAlpha
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {number} value - The amount to set the property to.
	 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var SetAlpha = function (items, value, step, index, direction)
	{
	    return PropertyValueSet(items, 'alpha', value, step, index, direction);
	};
	
	module.exports = SetAlpha;


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PropertyValueSet = __webpack_require__(48);
	
	/**
	 * Takes an array of Game Objects, or any objects that have the public property `blendMode`
	 * and then sets it to the given value.
	 *
	 * The optional `step` property is applied incrementally, multiplied by each item in the array.
	 *
	 * To use this with a Group: `SetBlendMode(group.getChildren(), value)`
	 *
	 * @function Phaser.Actions.SetBlendMode
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {number} value - The amount to set the property to.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var SetBlendMode = function (items, value, index, direction)
	{
	    return PropertyValueSet(items, 'blendMode', value, 0, index, direction);
	};
	
	module.exports = SetBlendMode;


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PropertyValueSet = __webpack_require__(48);
	
	/**
	 * Takes an array of Game Objects, or any objects that have the public property `depth`
	 * and then sets it to the given value.
	 *
	 * The optional `step` property is applied incrementally, multiplied by each item in the array.
	 *
	 * To use this with a Group: `SetDepth(group.getChildren(), value, step)`
	 *
	 * @function Phaser.Actions.SetDepth
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {number} value - The amount to set the property to.
	 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var SetDepth = function (items, value, step, index, direction)
	{
	    return PropertyValueSet(items, 'depth', value, step, index, direction);
	};
	
	module.exports = SetDepth;


/***/ }),
/* 1017 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Actions.SetHitArea
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
	 * @param {*} hitArea - [description]
	 * @param {HitAreaCallback} hitAreaCallback - [description]
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
	 */
	var SetHitArea = function (items, hitArea, hitAreaCallback)
	{
	    for (var i = 0; i < items.length; i++)
	    {
	        items[i].setInteractive(hitArea, hitAreaCallback);
	    }
	
	    return items;
	};
	
	module.exports = SetHitArea;


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PropertyValueSet = __webpack_require__(48);
	
	/**
	 * Takes an array of Game Objects, or any objects that have the public properties `originX` and `originY`
	 * and then sets them to the given values.
	 *
	 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
	 *
	 * To use this with a Group: `SetOrigin(group.getChildren(), originX, originY, stepX, stepY)`
	 *
	 * @function Phaser.Actions.SetOrigin
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {number} originX - The amount to set the `originX` property to.
	 * @param {number} [originY] - The amount to set the `originY` property to. If `undefined` or `null` it uses the `originX` value.
	 * @param {number} [stepX=0] - This is added to the `originX` amount, multiplied by the iteration counter.
	 * @param {number} [stepY=0] - This is added to the `originY` amount, multiplied by the iteration counter.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var SetOrigin = function (items, originX, originY, stepX, stepY, index, direction)
	{
	    if (originY === undefined || originY === null) { originY = originX; }
	
	    PropertyValueSet(items, 'originX', originX, stepX, index, direction);
	
	    return PropertyValueSet(items, 'originY', originY, stepY, index, direction);
	};
	
	module.exports = SetOrigin;


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PropertyValueSet = __webpack_require__(48);
	
	/**
	 * Takes an array of Game Objects, or any objects that have the public property `rotation`
	 * and then sets it to the given value.
	 *
	 * The optional `step` property is applied incrementally, multiplied by each item in the array.
	 *
	 * To use this with a Group: `SetRotation(group.getChildren(), value, step)`
	 *
	 * @function Phaser.Actions.SetRotation
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {number} value - The amount to set the property to.
	 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var SetRotation = function (items, value, step, index, direction)
	{
	    return PropertyValueSet(items, 'rotation', value, step, index, direction);
	};
	
	module.exports = SetRotation;


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PropertyValueSet = __webpack_require__(48);
	
	/**
	 * Takes an array of Game Objects, or any objects that have the public properties `scaleX` and `scaleY`
	 * and then sets them to the given values.
	 *
	 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
	 *
	 * To use this with a Group: `SetScale(group.getChildren(), scaleX, scaleY, stepX, stepY)`
	 *
	 * @function Phaser.Actions.SetScale
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {number} scaleX - The amount to set the `scaleX` property to.
	 * @param {number} [scaleY] - The amount to set the `scaleY` property to. If `undefined` or `null` it uses the `scaleX` value.
	 * @param {number} [stepX=0] - This is added to the `scaleX` amount, multiplied by the iteration counter.
	 * @param {number} [stepY=0] - This is added to the `scaleY` amount, multiplied by the iteration counter.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var SetScale = function (items, scaleX, scaleY, stepX, stepY, index, direction)
	{
	    if (scaleY === undefined || scaleY === null) { scaleY = scaleX; }
	
	    PropertyValueSet(items, 'scaleX', scaleX, stepX, index, direction);
	
	    return PropertyValueSet(items, 'scaleY', scaleY, stepY, index, direction);
	};
	
	module.exports = SetScale;


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PropertyValueSet = __webpack_require__(48);
	
	/**
	 * Takes an array of Game Objects, or any objects that have the public property `scaleX`
	 * and then sets it to the given value.
	 *
	 * The optional `step` property is applied incrementally, multiplied by each item in the array.
	 *
	 * To use this with a Group: `SetScaleX(group.getChildren(), value, step)`
	 *
	 * @function Phaser.Actions.SetScaleX
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {number} value - The amount to set the property to.
	 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var SetScaleX = function (items, value, step, index, direction)
	{
	    return PropertyValueSet(items, 'scaleX', value, step, index, direction);
	};
	
	module.exports = SetScaleX;


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PropertyValueSet = __webpack_require__(48);
	
	/**
	 * Takes an array of Game Objects, or any objects that have the public property `scaleY`
	 * and then sets it to the given value.
	 *
	 * The optional `step` property is applied incrementally, multiplied by each item in the array.
	 *
	 * To use this with a Group: `SetScaleY(group.getChildren(), value, step)`
	 *
	 * @function Phaser.Actions.SetScaleY
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {number} value - The amount to set the property to.
	 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var SetScaleY = function (items, value, step, index, direction)
	{
	    return PropertyValueSet(items, 'scaleY', value, step, index, direction);
	};
	
	module.exports = SetScaleY;


/***/ }),
/* 1023 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Actions.SetTint
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
	 * @param {number} topLeft - [description]
	 * @param {number} [topRight] - [description]
	 * @param {number} [bottomLeft] - [description]
	 * @param {number} [bottomRight] - [description]
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
	 */
	var SetTint = function (items, topLeft, topRight, bottomLeft, bottomRight)
	{
	    for (var i = 0; i < items.length; i++)
	    {
	        items[i].setTint(topLeft, topRight, bottomLeft, bottomRight);
	    }
	
	    return items;
	};
	
	module.exports = SetTint;


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PropertyValueSet = __webpack_require__(48);
	
	/**
	 * Takes an array of Game Objects, or any objects that have the public property `visible`
	 * and then sets it to the given value.
	 *
	 * To use this with a Group: `SetVisible(group.getChildren(), value)`
	 *
	 * @function Phaser.Actions.SetVisible
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {boolean} value - The value to set the property to.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var SetVisible = function (items, value, index, direction)
	{
	    return PropertyValueSet(items, 'visible', value, 0, index, direction);
	};
	
	module.exports = SetVisible;


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PropertyValueSet = __webpack_require__(48);
	
	/**
	 * Takes an array of Game Objects, or any objects that have the public property `x`
	 * and then sets it to the given value.
	 *
	 * The optional `step` property is applied incrementally, multiplied by each item in the array.
	 *
	 * To use this with a Group: `SetX(group.getChildren(), value, step)`
	 *
	 * @function Phaser.Actions.SetX
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {number} value - The amount to set the property to.
	 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var SetX = function (items, value, step, index, direction)
	{
	    return PropertyValueSet(items, 'x', value, step, index, direction);
	};
	
	module.exports = SetX;


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PropertyValueSet = __webpack_require__(48);
	
	/**
	 * Takes an array of Game Objects, or any objects that have the public properties `x` and `y`
	 * and then sets them to the given values.
	 *
	 * The optional `stepX` and `stepY` properties are applied incrementally, multiplied by each item in the array.
	 *
	 * To use this with a Group: `SetXY(group.getChildren(), x, y, stepX, stepY)`
	 *
	 * @function Phaser.Actions.SetXY
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {number} x - The amount to set the `x` property to.
	 * @param {number} [y=x] - The amount to set the `y` property to. If `undefined` or `null` it uses the `x` value.
	 * @param {number} [stepX=0] - This is added to the `x` amount, multiplied by the iteration counter.
	 * @param {number} [stepY=0] - This is added to the `y` amount, multiplied by the iteration counter.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var SetXY = function (items, x, y, stepX, stepY, index, direction)
	{
	    if (y === undefined || y === null) { y = x; }
	
	    PropertyValueSet(items, 'x', x, stepX, index, direction);
	
	    return PropertyValueSet(items, 'y', y, stepY, index, direction);
	};
	
	module.exports = SetXY;


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PropertyValueSet = __webpack_require__(48);
	
	/**
	 * Takes an array of Game Objects, or any objects that have the public property `y`
	 * and then sets it to the given value.
	 *
	 * The optional `step` property is applied incrementally, multiplied by each item in the array.
	 *
	 * To use this with a Group: `SetY(group.getChildren(), value, step)`
	 *
	 * @function Phaser.Actions.SetY
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - The array of items to be updated by this action.
	 * @param {number} value - The amount to set the property to.
	 * @param {number} [step=0] - This is added to the `value` amount, multiplied by the iteration counter.
	 * @param {integer} [index=0] - An optional offset to start searching from within the items array.
	 * @param {integer} [direction=1] - The direction to iterate through the array. 1 is from beginning to end, -1 from end to beginning.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of objects that were passed to this Action.
	 */
	var SetY = function (items, value, step, index, direction)
	{
	    return PropertyValueSet(items, 'y', value, step, index, direction);
	};
	
	module.exports = SetY;


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Vector2 = __webpack_require__(9);
	
	/**
	 * Iterate through items changing the position of each element to
	 * be that of the element that came before it in the array (or after it if direction = 1)
	 * The first items position is set to x/y.
	 * The final x/y coords are returned
	 *
	 * @function Phaser.Actions.ShiftPosition
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items]
	 * @generic {Phaser.Math.Vector2} O - [output,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
	 * @param {number} x - [description]
	 * @param {number} y - [description]
	 * @param {integer} [direction=0] - [description]
	 * @param {(Phaser.Math.Vector2|object)} [output] - [description]
	 *
	 * @return {Phaser.Math.Vector2} The output vector.
	 */
	var ShiftPosition = function (items, x, y, direction, output)
	{
	    if (direction === undefined) { direction = 0; }
	    if (output === undefined) { output = new Vector2(); }
	
	    var px;
	    var py;
	
	    if (items.length > 1)
	    {
	        var i;
	        var cx;
	        var cy;
	        var cur;
	
	        if (direction === 0)
	        {
	            //  Bottom to Top
	
	            var len = items.length - 1;
	
	            px = items[len].x;
	            py = items[len].y;
	
	            for (i = len - 1; i >= 0; i--)
	            {
	                //  Current item
	                cur = items[i];
	
	                //  Get current item x/y, to be passed to the next item in the list
	                cx = cur.x;
	                cy = cur.y;
	
	                //  Set current item to the previous items x/y
	                cur.x = px;
	                cur.y = py;
	
	                //  Set current as previous
	                px = cx;
	                py = cy;
	            }
	
	            //  Update the head item to the new x/y coordinates
	            items[len].x = x;
	            items[len].y = y;
	        }
	        else
	        {
	            //  Top to Bottom
	
	            px = items[0].x;
	            py = items[0].y;
	
	            for (i = 1; i < items.length; i++)
	            {
	                //  Current item
	                cur = items[i];
	
	                //  Get current item x/y, to be passed to the next item in the list
	                cx = cur.x;
	                cy = cur.y;
	
	                //  Set current item to the previous items x/y
	                cur.x = px;
	                cur.y = py;
	
	                //  Set current as previous
	                px = cx;
	                py = cy;
	            }
	
	            //  Update the head item to the new x/y coordinates
	            items[0].x = x;
	            items[0].y = y;
	        }
	    }
	    else
	    {
	        px = items[0].x;
	        py = items[0].y;
	
	        items[0].x = x;
	        items[0].y = y;
	    }
	
	    //  Return the final set of coordinates as they're effectively lost from the shift and may be needed
	
	    output.x = px;
	    output.y = py;
	
	    return output;
	};
	
	module.exports = ShiftPosition;


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var ArrayShuffle = __webpack_require__(218);
	
	/**
	 * Shuffles the array in place. The shuffled array is both modified and returned.
	 *
	 * @function Phaser.Actions.Shuffle
	 * @since 3.0.0
	 * @see Phaser.Utils.Array.Shuffle
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
	 */
	var Shuffle = function (items)
	{
	    return ArrayShuffle(items);
	};
	
	module.exports = Shuffle;


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var MathSmoothStep = __webpack_require__(560);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Actions.SmoothStep
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
	 * @param {string} property - [description]
	 * @param {number} min - [description]
	 * @param {number} max - [description]
	 * @param {number} inc - [description]
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
	 */
	var SmoothStep = function (items, property, min, max, inc)
	{
	    if (inc === undefined) { inc = false; }
	
	    var step = Math.abs(max - min) / items.length;
	    var i;
	
	    if (inc)
	    {
	        for (i = 0; i < items.length; i++)
	        {
	            items[i][property] += MathSmoothStep(i * step, min, max);
	        }
	    }
	    else
	    {
	        for (i = 0; i < items.length; i++)
	        {
	            items[i][property] = MathSmoothStep(i * step, min, max);
	        }
	    }
	
	    return items;
	};
	
	module.exports = SmoothStep;


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var MathSmootherStep = __webpack_require__(561);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Actions.SmootherStep
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
	 * @param {string} property - [description]
	 * @param {number} min - [description]
	 * @param {number} max - [description]
	 * @param {number} inc - [description]
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
	 */
	var SmootherStep = function (items, property, min, max, inc)
	{
	    if (inc === undefined) { inc = false; }
	
	    var step = Math.abs(max - min) / items.length;
	    var i;
	
	    if (inc)
	    {
	        for (i = 0; i < items.length; i++)
	        {
	            items[i][property] += MathSmootherStep(i * step, min, max);
	        }
	    }
	    else
	    {
	        for (i = 0; i < items.length; i++)
	        {
	            items[i][property] = MathSmootherStep(i * step, min, max);
	        }
	    }
	
	    return items;
	};
	
	module.exports = SmootherStep;


/***/ }),
/* 1032 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Actions.Spread
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
	 * @param {string} property - [description]
	 * @param {number} min - [description]
	 * @param {number} max - [description]
	 * @param {number} [inc=false] - [description]
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
	 */
	var Spread = function (items, property, min, max, inc)
	{
	    if (inc === undefined) { inc = false; }
	
	    var step = Math.abs(max - min) / items.length;
	    var i;
	
	    if (inc)
	    {
	        for (i = 0; i < items.length; i++)
	        {
	            items[i][property] += i * step;
	        }
	    }
	    else
	    {
	        for (i = 0; i < items.length; i++)
	        {
	            items[i][property] = i * step;
	        }
	    }
	
	    return items;
	};
	
	module.exports = Spread;


/***/ }),
/* 1033 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Actions.ToggleVisible
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
	 */
	var ToggleVisible = function (items)
	{
	    for (var i = 0; i < items.length; i++)
	    {
	        items[i].visible = !items[i].visible;
	    }
	
	    return items;
	};
	
	module.exports = ToggleVisible;


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       samme <samme.npm@gmail.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Wrap = __webpack_require__(98);
	
	/**
	 * Wrap each item's coordinates within a rectangle's area.
	 *
	 * @function Phaser.Actions.WrapInRectangle
	 * @since 3.0.0
	 * @see Phaser.Math.Wrap
	 *
	 * @generic {Phaser.GameObjects.GameObject[]} G - [items,$return]
	 *
	 * @param {(array|Phaser.GameObjects.GameObject[])} items - An array of Game Objects. The contents of this array are updated by this Action.
	 * @param {Phaser.Geom.Rectangle} rect - The rectangle.
	 * @param {number} [padding=0] - An amount added to each side of the rectangle during the operation.
	 *
	 * @return {(array|Phaser.GameObjects.GameObject[])} The array of Game Objects that was passed to this Action.
	 */
	var WrapInRectangle = function (items, rect, padding)
	{
	    if (padding === undefined)
	    {
	        padding = 0;
	    }
	
	    for (var i = 0; i < items.length; i++)
	    {
	        var item = items[i];
	
	        item.x = Wrap(item.x, rect.left - padding, rect.right + padding);
	        item.y = Wrap(item.y, rect.top - padding, rect.bottom + padding);
	    }
	
	    return items;
	};
	
	module.exports = WrapInRectangle;


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Animations
	 */
	
	module.exports = {
	
	    Animation: __webpack_require__(442),
	    AnimationFrame: __webpack_require__(443),
	    AnimationManager: __webpack_require__(444)
	
	};


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(49);
	var GetFastValue = __webpack_require__(3);
	var GetValue = __webpack_require__(10);
	var IsPlainObject = __webpack_require__(17);
	var MATH = __webpack_require__(33);
	var NOOP = __webpack_require__(6);
	var DefaultPlugins = __webpack_require__(322);
	var ValueToColor = __webpack_require__(270);
	
	/**
	 * This callback type is completely empty, a no-operation.
	 *
	 * @callback NOOP
	 */
	
	/**
	 * @callback BootCallback
	 *
	 * @param {Phaser.Game} game - [description]
	 */
	
	/**
	 * @typedef {object} FPSConfig
	 *
	 * @property {integer} [min=10] - [description]
	 * @property {integer} [target=60] - [description]
	 * @property {boolean} [forceSetTimeOut=false] - [description]
	 * @property {integer} [deltaHistory=10] - [description]
	 * @property {integer} [panicMax=120] - [description]
	 */
	
	/**
	 * @typedef {object} LoaderConfig
	 *
	 * @property {string} [baseURL] - [description]
	 * @property {string} [path] - [description]
	 * @property {integer} [maxParallelDownloads=32] - [description]
	 * @property {(string|undefined)} [crossOrigin=undefined] - [description]
	 * @property {string} [responseType] - [description]
	 * @property {boolean} [async=true] - [description]
	 * @property {string} [user] - [description]
	 * @property {string} [password] - [description]
	 * @property {integer} [timeout=0] - [description]
	 */
	
	/**
	 * @typedef {object} GameConfig
	 *
	 * @property {(integer|string)} [width=1024] - [description]
	 * @property {(integer|string)} [height=768] - [description]
	 * @property {number} [zoom=1] - [description]
	 * @property {number} [resolution=1] - [description]
	 * @property {number} [type=CONST.AUTO] - [description]
	 * @property {*} [parent=null] - [description]
	 * @property {HTMLCanvasElement} [canvas=null] - Provide your own Canvas element for Phaser to use instead of creating one.
	 * @property {string} [canvasStyle=null] - [description]
	 * @property {CanvasRenderingContext2D} [context] - Provide your own Canvas Context for Phaser to use, instead of creating one.
	 * @property {object} [scene=null] - [description]
	 * @property {string[]} [seed] - [description]
	 * @property {string} [title=''] - [description]
	 * @property {string} [url='http://phaser.io'] - [description]
	 * @property {string} [version=''] - [description]
	 * @property {(boolean|object)} [input] - [description]
	 * @property {boolean} [input.keyboard=true] - [description]
	 * @property {*} [input.keyboard.target=window] - [description]
	 * @property {(boolean|object)} [input.mouse=true] - [description]
	 * @property {*} [input.mouse.target=null] - [description]
	 * @property {boolean} [input.touch=true] - [description]
	 * @property {*} [input.touch.target=null] - [description]
	 * @property {boolean} [input.touch.capture=true] - [description]
	 * @property {(boolean|object)} [input.gamepad=false] - [description]
	 * @property {boolean} [disableContextMenu=false] - [description]
	 * @property {(boolean|object)} [banner=false] - [description]
	 * @property {boolean} [banner.hidePhaser=false] - [description]
	 * @property {string} [banner.text='#ffffff'] - [description]
	 * @property {string[]} [banner.background] - [description]
	 * @property {FPSConfig} [fps] - [description]
	 * @property {boolean} [render.antialias=true] - [description]
	 * @property {boolean} [render.pixelArt=false] - [description]
	 * @property {boolean} [render.autoResize=false] - [description]
	 * @property {boolean} [render.roundPixels=false] - [description]
	 * @property {boolean} [render.transparent=false] - [description]
	 * @property {boolean} [render.clearBeforeRender=true] - [description]
	 * @property {boolean} [render.premultipliedAlpha=true] - [description]
	 * @property {boolean} [render.preserveDrawingBuffer=false] - [description]
	 * @property {boolean} [render.failIfMajorPerformanceCaveat=false] - [description]
	 * @property {string} [render.powerPreference='default'] - "high-performance", "low-power" or "default"
	 * @property {(string|number)} [backgroundColor=0x000000] - [description]
	 * @property {object} [callbacks] - [description]
	 * @property {BootCallback} [callbacks.preBoot=NOOP] - [description]
	 * @property {BootCallback} [callbacks.postBoot=NOOP] - [description]
	 * @property {LoaderConfig} [loader] - [description]
	 * @property {object} [images] - [description]
	 * @property {string} [images.default] - [description]
	 * @property {string} [images.missing] - [description]
	 * @property {object} [physics] - [description]
	 */
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class Config
	 * @memberOf Phaser.Boot
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {GameConfig} [GameConfig] - The configuration object for your Phaser Game instance.
	 */
	var Config = new Class({
	
	    initialize:
	
	    function Config (config)
	    {
	        if (config === undefined) { config = {}; }
	
	        var defaultBannerColor = [
	            '#ff0000',
	            '#ffff00',
	            '#00ff00',
	            '#00ffff',
	            '#000000'
	        ];
	
	        var defaultBannerTextColor = '#ffffff';
	
	        /**
	         * @const {(integer|string)} Phaser.Boot.Config#width - [description]
	         */
	        this.width = GetValue(config, 'width', 1024);
	
	        /**
	         * @const {(integer|string)} Phaser.Boot.Config#height - [description]
	         */
	        this.height = GetValue(config, 'height', 768);
	
	        /**
	         * @const {number} Phaser.Boot.Config#zoom - [description]
	         */
	        this.zoom = GetValue(config, 'zoom', 1);
	
	        /**
	         * @const {number} Phaser.Boot.Config#resolution - [description]
	         */
	        this.resolution = GetValue(config, 'resolution', 1);
	
	        /**
	         * @const {number} Phaser.Boot.Config#renderType - [description]
	         */
	        this.renderType = GetValue(config, 'type', CONST.AUTO);
	
	        /**
	         * @const {?*} Phaser.Boot.Config#parent - [description]
	         */
	        this.parent = GetValue(config, 'parent', null);
	
	        /**
	         * @const {?HTMLCanvasElement} Phaser.Boot.Config#canvas - Force Phaser to use your own Canvas element instead of creating one.
	         */
	        this.canvas = GetValue(config, 'canvas', null);
	
	        /**
	         * @const {?(CanvasRenderingContext2D|WebGLRenderingContext)} Phaser.Boot.Config#context - Force Phaser to use your own Canvas context instead of creating one.
	         */
	        this.context = GetValue(config, 'context', null);
	
	        /**
	         * @const {?string} Phaser.Boot.Config#canvasStyle - [description]
	         */
	        this.canvasStyle = GetValue(config, 'canvasStyle', null);
	
	        /**
	         * @const {?object} Phaser.Boot.Config#sceneConfig - [description]
	         */
	        this.sceneConfig = GetValue(config, 'scene', null);
	
	        /**
	         * @const {string[]} Phaser.Boot.Config#seed - [description]
	         */
	        this.seed = GetValue(config, 'seed', [ (Date.now() * Math.random()).toString() ]);
	
	        MATH.RND.init(this.seed);
	
	        /**
	         * @const {string} Phaser.Boot.Config#gameTitle - [description]
	         */
	        this.gameTitle = GetValue(config, 'title', '');
	
	        /**
	         * @const {string} Phaser.Boot.Config#gameURL - [description]
	         */
	        this.gameURL = GetValue(config, 'url', 'https://phaser.io');
	
	        /**
	         * @const {string} Phaser.Boot.Config#gameVersion - [description]
	         */
	        this.gameVersion = GetValue(config, 'version', '');
	
	        //  Input
	
	        /**
	         * @const {boolean} Phaser.Boot.Config#inputKeyboard - [description]
	         */
	        this.inputKeyboard = GetValue(config, 'input.keyboard', true);
	
	        /**
	         * @const {*} Phaser.Boot.Config#inputKeyboardEventTarget - [description]
	         */
	        this.inputKeyboardEventTarget = GetValue(config, 'input.keyboard.target', window);
	
	        /**
	         * @const {(boolean|object)} Phaser.Boot.Config#inputMouse - [description]
	         */
	        this.inputMouse = GetValue(config, 'input.mouse', true);
	
	        /**
	         * @const {?*} Phaser.Boot.Config#inputMouseEventTarget - [description]
	         */
	        this.inputMouseEventTarget = GetValue(config, 'input.mouse.target', null);
	
	        /**
	         * @const {boolean} Phaser.Boot.Config#inputMouseCapture - [description]
	         */
	        this.inputMouseCapture = GetValue(config, 'input.mouse.capture', true);
	
	        /**
	         * @const {boolean} Phaser.Boot.Config#inputTouch - [description]
	         */
	        this.inputTouch = GetValue(config, 'input.touch', true);
	
	        /**
	         * @const {?*} Phaser.Boot.Config#inputTouchEventTarget - [description]
	         */
	        this.inputTouchEventTarget = GetValue(config, 'input.touch.target', null);
	
	        /**
	         * @const {boolean} Phaser.Boot.Config#inputTouchCapture - [description]
	         */
	        this.inputTouchCapture = GetValue(config, 'input.touch.capture', true);
	
	        /**
	         * @const {boolean} Phaser.Boot.Config#inputGamepad - [description]
	         */
	        this.inputGamepad = GetValue(config, 'input.gamepad', false);
	
	        /**
	         * @const {boolean} Phaser.Boot.Config#disableContextMenu - [description]
	         */
	        this.disableContextMenu = GetValue(config, 'disableContextMenu', false);
	
	        /**
	         * @const {any} Phaser.Boot.Config#audio - [description]
	         */
	        this.audio = GetValue(config, 'audio');
	
	        //  If you do: { banner: false } it won't display any banner at all
	
	        /**
	         * @const {boolean} Phaser.Boot.Config#hideBanner - [description]
	         */
	        this.hideBanner = (GetValue(config, 'banner', null) === false);
	
	        /**
	         * @const {boolean} Phaser.Boot.Config#hidePhaser - [description]
	         */
	        this.hidePhaser = GetValue(config, 'banner.hidePhaser', false);
	
	        /**
	         * @const {string} Phaser.Boot.Config#bannerTextColor - [description]
	         */
	        this.bannerTextColor = GetValue(config, 'banner.text', defaultBannerTextColor);
	
	        /**
	         * @const {string[]} Phaser.Boot.Config#bannerBackgroundColor - [description]
	         */
	        this.bannerBackgroundColor = GetValue(config, 'banner.background', defaultBannerColor);
	
	        if (this.gameTitle === '' && this.hidePhaser)
	        {
	            this.hideBanner = true;
	        }
	
	        //  Frame Rate config
	        //      fps: {
	        //          min: 10,
	        //          target: 60,
	        //          forceSetTimeOut: false,
	        //          deltaHistory: 10
	        //     }
	
	        /**
	         * @const {?FPSConfig} Phaser.Boot.Config#fps - [description]
	         */
	        this.fps = GetValue(config, 'fps', null);
	
	        //  Renderer Settings
	        //  These can either be in a `render` object within the Config, or specified on their own
	
	        var renderConfig = GetValue(config, 'render', config);
	
	        /**
	         * @const {boolean} Phaser.Boot.Config#antialias - [description]
	         */
	        this.antialias = GetValue(renderConfig, 'antialias', true);
	
	        /**
	         * @const {boolean} Phaser.Boot.Config#pixelArt - [description]
	         */
	        this.pixelArt = GetValue(renderConfig, 'pixelArt', false);
	
	        /**
	         * @const {boolean} Phaser.Boot.Config#autoResize - [description]
	         */
	        this.autoResize = GetValue(renderConfig, 'autoResize', false);
	
	        /**
	         * @const {boolean} Phaser.Boot.Config#roundPixels - [description]
	         */
	        this.roundPixels = GetValue(renderConfig, 'roundPixels', false);
	
	        /**
	         * @const {boolean} Phaser.Boot.Config#transparent - [description]
	         */
	        this.transparent = GetValue(renderConfig, 'transparent', false);
	
	        /**
	         * @const {boolean} Phaser.Boot.Config#zoclearBeforeRenderom - [description]
	         */
	        this.clearBeforeRender = GetValue(renderConfig, 'clearBeforeRender', true);
	
	        /**
	         * @const {boolean} Phaser.Boot.Config#premultipliedAlpha - [description]
	         */
	        this.premultipliedAlpha = GetValue(renderConfig, 'premultipliedAlpha', true);
	
	        /**
	         * @const {boolean} Phaser.Boot.Config#preserveDrawingBuffer - [description]
	         */
	        this.preserveDrawingBuffer = GetValue(renderConfig, 'preserveDrawingBuffer', false);
	
	        /**
	         * @const {boolean} Phaser.Boot.Config#failIfMajorPerformanceCaveat - [description]
	         */
	        this.failIfMajorPerformanceCaveat = GetValue(renderConfig, 'failIfMajorPerformanceCaveat', false);
	
	        /**
	         * @const {string} Phaser.Boot.Config#powerPreference - [description]
	         */
	        this.powerPreference = GetValue(renderConfig, 'powerPreference', 'default');
	
	        var bgc = GetValue(config, 'backgroundColor', 0);
	
	        /**
	         * @const {Phaser.Display.Color} Phaser.Boot.Config#backgroundColor - [description]
	         */
	        this.backgroundColor = ValueToColor(bgc);
	
	        if (bgc === 0 && this.transparent)
	        {
	            this.backgroundColor.alpha = 0;
	        }
	
	        //  Callbacks
	        /**
	         * @const {BootCallback} Phaser.Boot.Config#preBoot - [description]
	         */
	        this.preBoot = GetValue(config, 'callbacks.preBoot', NOOP);
	
	        /**
	         * @const {BootCallback} Phaser.Boot.Config#postBoot - [description]
	         */
	        this.postBoot = GetValue(config, 'callbacks.postBoot', NOOP);
	
	        //  Physics
	        //  physics: {
	        //      system: 'impact',
	        //      setBounds: true,
	        //      gravity: 0,
	        //      cellSize: 64
	        //  }
	
	        /**
	         * @const {object} Phaser.Boot.Config#physics - [description]
	         */
	        this.physics = GetValue(config, 'physics', {});
	
	        /**
	         * @const {boolean} Phaser.Boot.Config#defaultPhysicsSystem - [description]
	         */
	        this.defaultPhysicsSystem = GetValue(this.physics, 'default', false);
	
	        //  Loader Defaults
	
	        /**
	         * @const {string} Phaser.Boot.Config#loaderBaseURL - [description]
	         */
	        this.loaderBaseURL = GetValue(config, 'loader.baseURL', '');
	
	        /**
	         * @const {string} Phaser.Boot.Config#loaderPath - [description]
	         */
	        this.loaderPath = GetValue(config, 'loader.path', '');
	
	        /**
	         * @const {integer} Phaser.Boot.Config#loaderMaxParallelDownloads - [description]
	         */
	        this.loaderMaxParallelDownloads = GetValue(config, 'loader.maxParallelDownloads', 32);
	
	        /**
	         * @const {(string|undefined)} Phaser.Boot.Config#loaderCrossOrigin - [description]
	         */
	        this.loaderCrossOrigin = GetValue(config, 'loader.crossOrigin', undefined);
	
	        /**
	         * @const {string} Phaser.Boot.Config#loaderResponseType - [description]
	         */
	        this.loaderResponseType = GetValue(config, 'loader.responseType', '');
	
	        /**
	         * @const {boolean} Phaser.Boot.Config#loaderAsync - [description]
	         */
	        this.loaderAsync = GetValue(config, 'loader.async', true);
	
	        /**
	         * @const {string} Phaser.Boot.Config#loaderUser - [description]
	         */
	        this.loaderUser = GetValue(config, 'loader.user', '');
	
	        /**
	         * @const {string} Phaser.Boot.Config#loaderPassword - [description]
	         */
	        this.loaderPassword = GetValue(config, 'loader.password', '');
	
	        /**
	         * @const {integer} Phaser.Boot.Config#loaderTimeout - [description]
	         */
	        this.loaderTimeout = GetValue(config, 'loader.timeout', 0);
	
	        //  Plugins
	
	        /*
	         * Allows `plugins` property to either be an array, in which case it just replaces
	         * the default plugins like previously, or a config object.
	         *
	         * plugins: {
	         *    global: [
	         *        { key: 'TestPlugin', plugin: TestPlugin, start: true },
	         *    ],
	         *    scene: [
	         *        { key: 'WireFramePlugin', plugin: WireFramePlugin, systemKey: 'wireFramePlugin', sceneKey: 'wireframe' }
	         *    ],
	         *    default: [], OR
	         *    defaultMerge: {
	         *        'ModPlayer'
	         *    }
	         * }
	         */
	
	        /**
	         * @const {any} Phaser.Boot.Config#installGlobalPlugins - [description]
	         */
	        this.installGlobalPlugins = [];
	
	        /**
	         * @const {any} Phaser.Boot.Config#installScenePlugins - [description]
	         */
	        this.installScenePlugins = [];
	
	        var plugins = GetValue(config, 'plugins', null);
	        var defaultPlugins = DefaultPlugins.DefaultScene;
	
	        if (plugins)
	        {
	            //  Old 3.7 array format?
	            if (Array.isArray(plugins))
	            {
	                this.defaultPlugins = plugins;
	            }
	            else if (IsPlainObject(plugins))
	            {
	                this.installGlobalPlugins = GetFastValue(plugins, 'global', []);
	                this.installScenePlugins = GetFastValue(plugins, 'scene', []);
	
	                if (Array.isArray(plugins.default))
	                {
	                    defaultPlugins = plugins.default;
	                }
	                else if (Array.isArray(plugins.defaultMerge))
	                {
	                    defaultPlugins = defaultPlugins.concat(plugins.defaultMerge);
	                }
	            }
	        }
	
	        /**
	         * @const {any} Phaser.Boot.Config#defaultPlugins - The plugins installed into every Scene (in addition to CoreScene and Global).
	         */
	        this.defaultPlugins = defaultPlugins;
	
	        //  Default / Missing Images
	        var pngPrefix = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAg';
	
	        /**
	         * @const {string} Phaser.Boot.Config#defaultImage - [description]
	         */
	        this.defaultImage = GetValue(config, 'images.default', pngPrefix + 'AQMAAABJtOi3AAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABVJREFUeF7NwIEAAAAAgKD9qdeocAMAoAABm3DkcAAAAABJRU5ErkJggg==');
	        
	        /**
	         * @const {string} Phaser.Boot.Config#missingImage - [description]
	         */
	        this.missingImage = GetValue(config, 'images.missing', pngPrefix + 'CAIAAAD8GO2jAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJ9JREFUeNq01ssOwyAMRFG46v//Mt1ESmgh+DFmE2GPOBARKb2NVjo+17PXLD8a1+pl5+A+wSgFygymWYHBb0FtsKhJDdZlncG2IzJ4ayoMDv20wTmSMzClEgbWYNTAkQ0Z+OJ+A/eWnAaR9+oxCF4Os0H8htsMUp+pwcgBBiMNnAwF8GqIgL2hAzaGFFgZauDPKABmowZ4GL369/0rwACp2yA/ttmvsQAAAABJRU5ErkJggg==');
	    }
	
	});
	
	module.exports = Config;


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CanvasInterpolation = __webpack_require__(471);
	var CanvasPool = __webpack_require__(56);
	var CONST = __webpack_require__(49);
	var Features = __webpack_require__(266);
	
	/**
	 * Called automatically by Phaser.Game and responsible for creating the renderer it will use.
	 *
	 * Relies upon two webpack global flags to be defined: `WEBGL_RENDERER` and `CANVAS_RENDERER` during build time, but not at run-time.
	 *
	 * @function Phaser.Boot.CreateRenderer
	 * @since 3.0.0
	 *
	 * @param {Phaser.Game} game - The Phaser.Game instance on which the renderer will be set.
	 */
	var CreateRenderer = function (game)
	{
	    var config = game.config;
	
	    //  Game either requested Canvas,
	    //  or requested AUTO or WEBGL but the browser doesn't support it, so fall back to Canvas
	
	    if (config.renderType !== CONST.HEADLESS)
	    {
	        if (config.renderType === CONST.CANVAS || (config.renderType !== CONST.CANVAS && !Features.webGL))
	        {
	            if (Features.canvas)
	            {
	                //  They requested Canvas and their browser supports it
	                config.renderType = CONST.CANVAS;
	            }
	            else
	            {
	                throw new Error('Cannot create Canvas or WebGL context, aborting.');
	            }
	        }
	        else
	        {
	            //  Game requested WebGL and browser says it supports it
	            config.renderType = CONST.WEBGL;
	        }
	    }
	
	    //  Pixel Art mode?
	    if (config.pixelArt)
	    {
	        CanvasPool.disableSmoothing();
	    }
	
	    //  Does the game config provide its own canvas element to use?
	    if (config.canvas)
	    {
	        game.canvas = config.canvas;
	    }
	    else
	    {
	        game.canvas = CanvasPool.create(game, config.width, config.height, config.renderType);
	    }
	
	    //  Does the game config provide some canvas css styles to use?
	    if (config.canvasStyle)
	    {
	        game.canvas.style = config.canvasStyle;
	    }
	
	    //  Pixel Art mode?
	    if (config.pixelArt)
	    {
	        CanvasInterpolation.setCrisp(game.canvas);
	    }
	
	    //  Zoomed?
	    if (config.zoom !== 1)
	    {
	        game.canvas.style.width = (config.width * config.zoom).toString() + 'px';
	        game.canvas.style.height = (config.height * config.zoom).toString() + 'px';
	    }
	
	    if (config.renderType === CONST.HEADLESS)
	    {
	        //  Nothing more to do here
	        return;
	    }
	
	    var CanvasRenderer;
	    var WebGLRenderer;
	
	    if (true)
	    {
	        CanvasRenderer = __webpack_require__(612);
	        WebGLRenderer = __webpack_require__(618);
	
	        //  Let the config pick the renderer type, as both are included
	        if (config.renderType === CONST.WEBGL)
	        {
	            game.renderer = new WebGLRenderer(game);
	
	            //  The WebGL Renderer sets this value during its init, not on construction
	            game.context = null;
	        }
	        else
	        {
	            game.renderer = new CanvasRenderer(game);
	            game.context = game.renderer.gameContext;
	        }
	    }
	
	    if (false)
	    {
	        WebGLRenderer = require('../renderer/webgl/WebGLRenderer');
	
	        //  Force the type to WebGL, regardless what was requested
	        config.renderType = CONST.WEBGL;
	
	        game.renderer = new WebGLRenderer(game);
	
	        //  The WebGL Renderer sets this value during its init, not on construction
	        game.context = null;
	    }
	
	    if (false)
	    {
	        CanvasRenderer = require('../renderer/canvas/CanvasRenderer');
	
	        //  Force the type to Canvas, regardless what was requested
	        config.renderType = CONST.CANVAS;
	
	        game.renderer = new CanvasRenderer(game);
	
	        game.context = game.renderer.gameContext;
	    }
	};
	
	module.exports = CreateRenderer;


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CONST = __webpack_require__(49);
	
	/**
	 * Called automatically by Phaser.Game and responsible for creating the console.log debug header.
	 *
	 * You can customize or disable the header via the Game Config object.
	 *
	 * @function Phaser.Boot.DebugHeader
	 * @since 3.0.0
	 *
	 * @param {Phaser.Game} game - The Phaser.Game instance which will output this debug header.
	 */
	var DebugHeader = function (game)
	{
	    var config = game.config;
	
	    if (config.hideBanner)
	    {
	        return;
	    }
	
	    var renderType = 'WebGL';
	
	    if (config.renderType === CONST.CANVAS)
	    {
	        renderType = 'Canvas';
	    }
	    else if (config.renderType === CONST.HEADLESS)
	    {
	        renderType = 'Headless';
	    }
	
	    var audioConfig = config.audio;
	    var deviceAudio = game.device.audio;
	
	    var audioType;
	
	    if (deviceAudio.webAudio && !(audioConfig && audioConfig.disableWebAudio))
	    {
	        audioType = 'Web Audio';
	    }
	    else if ((audioConfig && audioConfig.noAudio) || (!deviceAudio.webAudio && !deviceAudio.audioData))
	    {
	        audioType = 'No Audio';
	    }
	    else
	    {
	        audioType = 'HTML5 Audio';
	    }
	
	    if (!game.device.browser.ie)
	    {
	        var c = '';
	        var args = [ c ];
	
	        if (Array.isArray(config.bannerBackgroundColor))
	        {
	            var lastColor;
	
	            config.bannerBackgroundColor.forEach(function (color)
	            {
	                c = c.concat('%c ');
	
	                args.push('background: ' + color);
	
	                lastColor = color;
	
	            });
	
	            //  inject the text color
	            args[args.length - 1] = 'color: ' + config.bannerTextColor + '; background: ' + lastColor;
	        }
	        else
	        {
	            c = c.concat('%c ');
	
	            args.push('color: ' + config.bannerTextColor + '; background: ' + config.bannerBackgroundColor);
	        }
	
	        //  URL link background color (always white)
	        args.push('background: #fff');
	
	        if (config.gameTitle)
	        {
	            c = c.concat(config.gameTitle);
	
	            if (config.gameVersion)
	            {
	                c = c.concat(' v' + config.gameVersion);
	            }
	
	            if (!config.hidePhaser)
	            {
	                c = c.concat(' / ');
	            }
	        }
	
	        if (!config.hidePhaser)
	        {
	            c = c.concat('Phaser v' + CONST.VERSION + ' (' + renderType + ' | ' + audioType + ')');
	        }
	
	        c = c.concat(' %c ' + config.gameURL);
	
	        //  Inject the new string back into the args array
	        args[0] = c;
	
	        console.log.apply(console, args);
	    }
	    else if (window['console'])
	    {
	        console.log('Phaser v' + CONST.VERSION + ' / https://phaser.io');
	    }
	};
	
	module.exports = DebugHeader;


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var AddToDOM = __webpack_require__(271);
	var AnimationManager = __webpack_require__(444);
	var CacheManager = __webpack_require__(446);
	var CanvasPool = __webpack_require__(56);
	var Class = __webpack_require__(1);
	var Config = __webpack_require__(1036);
	var CreateRenderer = __webpack_require__(1037);
	var DataManager = __webpack_require__(194);
	var DebugHeader = __webpack_require__(1038);
	var Device = __webpack_require__(1067);
	var DOMContentLoaded = __webpack_require__(484);
	var EventEmitter = __webpack_require__(22);
	var InputManager = __webpack_require__(533);
	var PluginManager = __webpack_require__(611);
	var SceneManager = __webpack_require__(623);
	var SoundManagerCreator = __webpack_require__(625);
	var TextureManager = __webpack_require__(634);
	var TimeStep = __webpack_require__(1040);
	var VisibilityHandler = __webpack_require__(1041);
	
	/**
	 * @classdesc
	 * The Phaser.Game instance is the main controller for the entire Phaser game. It is responsible
	 * for handling the boot process, parsing the configuration values, creating the renderer,
	 * and setting-up all of the global Phaser systems, such as sound and input.
	 * Once that is complete it will start the Scene Manager and then begin the main game loop.
	 *
	 * You should generally avoid accessing any of the systems created by Game, and instead use those
	 * made available to you via the Phaser.Scene Systems class instead.
	 *
	 * @class Game
	 * @memberOf Phaser
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {GameConfig} [GameConfig] - The configuration object for your Phaser Game instance.
	 */
	var Game = new Class({
	
	    initialize:
	
	    function Game (config)
	    {
	        /**
	         * The parsed Game Configuration object.
	         *
	         * The values stored within this object are read-only and should not be changed at run-time.
	         *
	         * @name Phaser.Game#config
	         * @type {Phaser.Boot.Config}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.config = new Config(config);
	
	        /**
	         * A reference to either the Canvas or WebGL Renderer that this Game is using.
	         *
	         * @name Phaser.Game#renderer
	         * @type {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)}
	         * @since 3.0.0
	         */
	        this.renderer = null;
	
	        /**
	         * A reference to the HTML Canvas Element that Phaser uses to render the game.
	         * This is created automatically by Phaser unless you provide a `canvas` property
	         * in your Game Config.
	         *
	         * @name Phaser.Game#canvas
	         * @type {HTMLCanvasElement}
	         * @since 3.0.0
	         */
	        this.canvas = null;
	
	        /**
	         * A reference to the Rendering Context belonging to the Canvas Element this game is rendering to.
	         * If the game is running under Canvas it will be a 2d Canvas Rendering Context.
	         * If the game is running under WebGL it will be a WebGL Rendering Context.
	         * This context is created automatically by Phaser unless you provide a `context` property
	         * in your Game Config.
	         *
	         * @name Phaser.Game#context
	         * @type {(CanvasRenderingContext2D|WebGLRenderingContext|WebGL2RenderingContext)}
	         * @since 3.0.0
	         */
	        this.context = null;
	
	        /**
	         * A flag indicating when this Game instance has finished its boot process.
	         *
	         * @name Phaser.Game#isBooted
	         * @type {boolean}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.isBooted = false;
	
	        /**
	         * A flag indicating if this Game is currently running its game step or not.
	         *
	         * @name Phaser.Game#isRunning
	         * @type {boolean}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.isRunning = false;
	
	        /**
	         * An Event Emitter which is used to broadcast game-level events from the global systems.
	         *
	         * @name Phaser.Game#events
	         * @type {Phaser.Events.EventEmitter}
	         * @since 3.0.0
	         */
	        this.events = new EventEmitter();
	
	        /**
	         * An instance of the Animation Manager.
	         *
	         * The Animation Manager is a global system responsible for managing all animations used within your game.
	         *
	         * @name Phaser.Game#anims
	         * @type {Phaser.Animations.AnimationManager}
	         * @since 3.0.0
	         */
	        this.anims = new AnimationManager(this);
	
	        /**
	         * An instance of the Texture Manager.
	         *
	         * The Texture Manager is a global system responsible for managing all textures being used by your game.
	         *
	         * @name Phaser.Game#textures
	         * @type {Phaser.Textures.TextureManager}
	         * @since 3.0.0
	         */
	        this.textures = new TextureManager(this);
	
	        /**
	         * An instance of the Cache Manager.
	         *
	         * The Cache Manager is a global system responsible for caching, accessing and releasing external game assets.
	         *
	         * @name Phaser.Game#cache
	         * @type {Phaser.Cache.CacheManager}
	         * @since 3.0.0
	         */
	        this.cache = new CacheManager(this);
	
	        /**
	         * An instance of the Data Manager
	         *
	         * @name Phaser.Game#registry
	         * @type {Phaser.Data.DataManager}
	         * @since 3.0.0
	         */
	        this.registry = new DataManager(this);
	
	        /**
	         * An instance of the Input Manager.
	         *
	         * The Input Manager is a global system responsible for the capture of browser-level input events.
	         *
	         * @name Phaser.Game#input
	         * @type {Phaser.Input.InputManager}
	         * @since 3.0.0
	         */
	        this.input = new InputManager(this, this.config);
	
	        /**
	         * An instance of the Scene Manager.
	         *
	         * The Scene Manager is a global system responsible for creating, modifying and updating the Scenes in your game.
	         *
	         * @name Phaser.Game#scene
	         * @type {Phaser.Scenes.SceneManager}
	         * @since 3.0.0
	         */
	        this.scene = new SceneManager(this, this.config.sceneConfig);
	
	        /**
	         * A reference to the Device inspector.
	         *
	         * Contains information about the device running this game, such as OS, browser vendor and feature support.
	         * Used by various systems to determine capabilities and code paths.
	         *
	         * @name Phaser.Game#device
	         * @type {Phaser.DeviceConf}
	         * @since 3.0.0
	         */
	        this.device = Device;
	
	        /**
	         * An instance of the base Sound Manager.
	         *
	         * The Sound Manager is a global system responsible for the playback and updating of all audio in your game.
	         *
	         * @name Phaser.Game#sound
	         * @type {Phaser.Sound.BaseSoundManager}
	         * @since 3.0.0
	         */
	        this.sound = SoundManagerCreator.create(this);
	
	        /**
	         * An instance of the Time Step.
	         *
	         * The Time Step is a global system responsible for setting-up and responding to the browser frame events, processing
	         * them and calculating delta values. It then automatically calls the game step.
	         *
	         * @name Phaser.Game#loop
	         * @type {Phaser.Boot.TimeStep}
	         * @since 3.0.0
	         */
	        this.loop = new TimeStep(this, this.config.fps);
	
	        /**
	         * An instance of the Plugin Manager.
	         *
	         * The Plugin Manager is a global system that allows plugins to register themselves with it, and can then install
	         * those plugins into Scenes as required.
	         *
	         * @name Phaser.Game#plugins
	         * @type {Phaser.Plugins.PluginManager}
	         * @since 3.0.0
	         */
	        this.plugins = new PluginManager(this, this.config);
	
	        /**
	         * Is this Game pending destruction at the start of the next frame?
	         *
	         * @name Phaser.Game#pendingDestroy
	         * @type {boolean}
	         * @private
	         * @since 3.5.0
	         */
	        this.pendingDestroy = false;
	
	        /**
	         * Remove the Canvas once the destroy is over?
	         *
	         * @name Phaser.Game#removeCanvas
	         * @type {boolean}
	         * @private
	         * @since 3.5.0
	         */
	        this.removeCanvas = false;
	
	        //  Wait for the DOM Ready event, then call boot.
	        DOMContentLoaded(this.boot.bind(this));
	    },
	
	    /**
	     * Game boot event.
	     *
	     * This is an internal event dispatched when the game has finished booting, but before it is ready to start running.
	     * The global systems use this event to know when to set themselves up, dispatching their own `ready` events as required.
	     *
	     * @event Phaser.Game#boot
	     */
	
	    /**
	     * This method is called automatically when the DOM is ready. It is responsible for creating the renderer,
	     * displaying the Debug Header, adding the game canvas to the DOM and emitting the 'boot' event.
	     * It listens for a 'ready' event from the base systems and once received it will call `Game.start`.
	     *
	     * @method Phaser.Game#boot
	     * @protected
	     * @fires Phaser.Game#boot
	     * @since 3.0.0
	     */
	    boot: function ()
	    {
	        this.isBooted = true;
	
	        this.config.preBoot(this);
	
	        CreateRenderer(this);
	
	        DebugHeader(this);
	
	        AddToDOM(this.canvas, this.config.parent);
	
	        this.events.emit('boot');
	
	        //  The Texture Manager has to wait on a couple of non-blocking events before it's fully ready, so it will emit this event
	        this.events.once('ready', this.start, this);
	    },
	
	    /**
	     * Called automatically by Game.boot once all of the global systems have finished setting themselves up.
	     * By this point the Game is now ready to start the main loop running.
	     * It will also enable the Visibility Handler.
	     *
	     * @method Phaser.Game#start
	     * @protected
	     * @since 3.0.0
	     */
	    start: function ()
	    {
	        this.isRunning = true;
	
	        this.config.postBoot(this);
	
	        if (this.renderer)
	        {
	            this.loop.start(this.step.bind(this));
	        }
	        else
	        {
	            this.loop.start(this.headlessStep.bind(this));
	        }
	
	        VisibilityHandler(this.events);
	
	        var eventEmitter = this.events;
	
	        eventEmitter.on('hidden', this.onHidden, this);
	        eventEmitter.on('visible', this.onVisible, this);
	        eventEmitter.on('blur', this.onBlur, this);
	        eventEmitter.on('focus', this.onFocus, this);
	    },
	
	    /**
	     * Game Pre-Step event.
	     *
	     * This event is dispatched before the main Step starts.
	     * By this point none of the Scene updates have happened.
	     * Hook into it from plugins or systems that need to update before the Scene Manager does.
	     *
	     * @event Phaser.Game#prestepEvent
	     * @param {number} time - [description]
	     * @param {number} delta - [description]
	     */
	
	    /**
	     * Game Step event.
	     *
	     * This event is dispatched after Pre-Step and before the Scene Manager steps.
	     * Hook into it from plugins or systems that need to update before the Scene Manager does, but after core Systems.
	     *
	     * @event Phaser.Game#stepEvent
	     * @param {number} time - [description]
	     * @param {number} delta - [description]
	     */
	
	    /**
	     * Game Post-Step event.
	     *
	     * This event is dispatched after the Scene Manager has updated.
	     * Hook into it from plugins or systems that need to do things before the render starts.
	     *
	     * @event Phaser.Game#poststepEvent
	     * @param {number} time - [description]
	     * @param {number} delta - [description]
	     */
	
	    /**
	     * Game Pre-Render event.
	     *
	     * This event is dispatched immediately before any of the Scenes have started to render.
	     * The renderer will already have been initialized this frame, clearing itself and preparing to receive
	     * the Scenes for rendering, but it won't have actually drawn anything yet.
	     *
	     * @event Phaser.Game#prerenderEvent
	     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - A reference to the current renderer.
	     */
	
	    /**
	     * Game Post-Render event.
	     *
	     * This event is dispatched right at the end of the render process.
	     * Every Scene will have rendered and drawn to the canvas.
	     *
	     * @event Phaser.Game#postrenderEvent
	     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - A reference to the current renderer.
	     */
	
	    /**
	     * The main Game Step. Called automatically by the Time Step, once per browser frame (typically as a result of
	     * Request Animation Frame, or Set Timeout on very old browsers.)
	     *
	     * The step will update the global managers first, then proceed to update each Scene in turn, via the Scene Manager.
	     *
	     * It will then render each Scene in turn, via the Renderer. This process emits `prerender` and `postrender` events.
	     *
	     * @method Phaser.Game#step
	     * @fires Phaser.Game#prestepEvent
	     * @fires Phaser.Game#stepEvent
	     * @fires Phaser.Game#poststepEvent
	     * @fires Phaser.Game#prerenderEvent
	     * @fires Phaser.Game#postrenderEvent
	     * @since 3.0.0
	     *
	     * @param {integer} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
	     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
	     */
	    step: function (time, delta)
	    {
	        if (this.pendingDestroy)
	        {
	            return this.runDestroy();
	        }
	
	        var eventEmitter = this.events;
	
	        //  Global Managers like Input and Sound update in the prestep
	
	        eventEmitter.emit('prestep', time, delta);
	
	        //  This is mostly meant for user-land code and plugins
	
	        eventEmitter.emit('step', time, delta);
	
	        //  Update the Scene Manager and all active Scenes
	
	        this.scene.update(time, delta);
	
	        //  Our final event before rendering starts
	
	        eventEmitter.emit('poststep', time, delta);
	
	        var renderer = this.renderer;
	
	        //  Run the Pre-render (clearing the canvas, setting background colors, etc)
	
	        renderer.preRender();
	
	        eventEmitter.emit('prerender', renderer, time, delta);
	
	        //  The main render loop. Iterates all Scenes and all Cameras in those scenes, rendering to the renderer instance.
	
	        this.scene.render(renderer);
	
	        //  The Post-Render call. Tidies up loose end, takes snapshots, etc.
	
	        renderer.postRender();
	
	        //  The final event before the step repeats. Your last chance to do anything to the canvas before it all starts again.
	
	        eventEmitter.emit('postrender', renderer, time, delta);
	    },
	
	    /**
	     * A special version of the Game Step for the HEADLESS renderer only.
	     *
	     * The main Game Step. Called automatically by the Time Step, once per browser frame (typically as a result of
	     * Request Animation Frame, or Set Timeout on very old browsers.)
	     *
	     * The step will update the global managers first, then proceed to update each Scene in turn, via the Scene Manager.
	     *
	     * This process emits `prerender` and `postrender` events, even though nothing actually displays.
	     *
	     * @method Phaser.Game#headlessStep
	     * @fires Phaser.Game#prerenderEvent
	     * @fires Phaser.Game#postrenderEvent
	     * @since 3.2.0
	     *
	     * @param {integer} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
	     * @param {number} delta - The delta time elapsed since the last frame.
	     */
	    headlessStep: function (time, delta)
	    {
	        var eventEmitter = this.events;
	
	        //  Global Managers
	
	        eventEmitter.emit('prestep', time, delta);
	
	        eventEmitter.emit('step', time, delta);
	
	        //  Scenes
	
	        this.scene.update(time, delta);
	
	        eventEmitter.emit('poststep', time, delta);
	
	        //  Render
	
	        eventEmitter.emit('prerender');
	
	        eventEmitter.emit('postrender');
	    },
	
	    /**
	     * Game Pause event.
	     *
	     * This event is dispatched when the game loop enters a paused state, usually as a result of the Visibility Handler.
	     *
	     * @event Phaser.Game#pauseEvent
	     */
	
	    /**
	     * Called automatically by the Visibility Handler.
	     * This will pause the main loop and then emit a pause event.
	     *
	     * @method Phaser.Game#onHidden
	     * @protected
	     * @fires Phaser.Game#pauseEvent
	     * @since 3.0.0
	     */
	    onHidden: function ()
	    {
	        this.loop.pause();
	
	        this.events.emit('pause');
	    },
	
	    /**
	     * Game Resume event.
	     *
	     * This event is dispatched when the game loop leaves a paused state and resumes running.
	     *
	     * @event Phaser.Game#resumeEvent
	     */
	
	    /**
	     * Called automatically by the Visibility Handler.
	     * This will resume the main loop and then emit a resume event.
	     *
	     * @method Phaser.Game#onVisible
	     * @protected
	     * @fires Phaser.Game#resumeEvent
	     * @since 3.0.0
	     */
	    onVisible: function ()
	    {
	        this.loop.resume();
	
	        this.events.emit('resume');
	    },
	
	    /**
	     * Called automatically by the Visibility Handler.
	     * This will set the main loop into a 'blurred' state, which pauses it.
	     *
	     * @method Phaser.Game#onBlur
	     * @protected
	     * @since 3.0.0
	     */
	    onBlur: function ()
	    {
	        this.loop.blur();
	    },
	
	    /**
	     * Called automatically by the Visibility Handler.
	     * This will set the main loop into a 'focused' state, which resumes it.
	     *
	     * @method Phaser.Game#onFocus
	     * @protected
	     * @since 3.0.0
	     */
	    onFocus: function ()
	    {
	        this.loop.focus();
	    },
	
	    /**
	     * Game Resize event.
	     *
	     * @event Phaser.Game#resizeEvent
	     * @param {number} width - The new width of the Game.
	     * @param {number} height - The new height of the Game.
	     */
	
	    /**
	     * Updates the Game Config with the new width and height values given.
	     * Then resizes the Renderer and Input Manager scale.
	     *
	     * @method Phaser.Game#resize
	     * @since 3.2.0
	     *
	     * @param {number} width - The new width of the game.
	     * @param {number} height - The new height of the game.
	     */
	    resize: function (width, height)
	    {
	        this.config.width = width;
	        this.config.height = height;
	
	        this.renderer.resize(width, height);
	
	        this.input.resize();
	
	        this.scene.resize(width, height);
	
	        this.events.emit('resize', width, height);
	    },
	
	    /**
	     * Flags this Game instance as needing to be destroyed on the next frame.
	     * It will wait until the current frame has completed and then call `runDestroy` internally.
	     *
	     * @method Phaser.Game#destroy
	     * @since 3.0.0
	     *
	     * @param {boolean} removeCanvas - Set to `true` if you would like the parent canvas element removed from the DOM, or `false` to leave it in place.
	     */
	    destroy: function (removeCanvas)
	    {
	        this.pendingDestroy = true;
	
	        this.removeCanvas = removeCanvas;
	    },
	
	    /**
	     * Destroys this Phaser.Game instance, all global systems, all sub-systems and all Scenes.
	     *
	     * @method Phaser.Game#runDestroy
	     * @private
	     * @since 3.5.0
	     */
	    runDestroy: function ()
	    {
	        this.events.emit('destroy');
	
	        this.events.removeAllListeners();
	
	        this.scene.destroy();
	
	        if (this.renderer)
	        {
	            this.renderer.destroy();
	        }
	
	        if (this.removeCanvas && this.canvas)
	        {
	            CanvasPool.remove(this.canvas);
	
	            if (this.canvas.parentNode)
	            {
	                this.canvas.parentNode.removeChild(this.canvas);
	            }
	        }
	
	        this.loop.destroy();
	
	        this.pendingDestroy = false;
	    }
	
	});
	
	module.exports = Game;


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var GetValue = __webpack_require__(10);
	var NOOP = __webpack_require__(6);
	var RequestAnimationFrame = __webpack_require__(487);
	
	//  Frame Rate config
	//      fps: {
	//          min: 10,
	//          target: 60,
	//          forceSetTimeOut: false,
	//          deltaHistory: 10,
	//          panicMax: 120
	//     }
	
	// http://www.testufo.com/#test=animation-time-graph
	
	/**
	 * @callback TimeStepCallback
	 *
	 * @param {number} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
	 * @param {number} average - The Delta Average.
	 * @param {number} interpolation - Interpolation - how far between what is expected and where we are?
	 */
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class TimeStep
	 * @memberOf Phaser.Boot
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Game} game - A reference to the Phaser.Game instance that owns this Time Step.
	 * @param {FPSConfig} config
	 */
	var TimeStep = new Class({
	
	    initialize:
	
	    function TimeStep (game, config)
	    {
	        /**
	         * A reference to the Phaser.Game instance.
	         *
	         * @name Phaser.Boot.TimeStep#game
	         * @type {Phaser.Game}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.game = game;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Boot.TimeStep#raf
	         * @type {Phaser.DOM.RequestAnimationFrame}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.raf = new RequestAnimationFrame();
	
	        /**
	         * A flag that is set once the TimeStep has started running and toggled when it stops.
	         *
	         * @name Phaser.Boot.TimeStep#started
	         * @type {boolean}
	         * @readOnly
	         * @default false
	         * @since 3.0.0
	         */
	        this.started = false;
	
	        /**
	         * A flag that is set once the TimeStep has started running and toggled when it stops.
	         * The difference between this value and `started` is that `running` is toggled when
	         * the TimeStep is sent to sleep, where-as `started` remains `true`, only changing if
	         * the TimeStep is actually stopped, not just paused.
	         *
	         * @name Phaser.Boot.TimeStep#running
	         * @type {boolean}
	         * @readOnly
	         * @default false
	         * @since 3.0.0
	         */
	        this.running = false;
	
	        /**
	         * The minimum fps rate you want the Time Step to run at.
	         *
	         * @name Phaser.Boot.TimeStep#minFps
	         * @type {integer}
	         * @default 5
	         * @since 3.0.0
	         */
	        this.minFps = GetValue(config, 'min', 5);
	
	        /**
	         * The target fps rate for the Time Step to run at.
	         *
	         * Setting this value will not actually change the speed at which the browser runs, that is beyond
	         * the control of Phaser. Instead, it allows you to determine performance issues and if the Time Step
	         * is spiraling out of control.
	         *
	         * @name Phaser.Boot.TimeStep#targetFps
	         * @type {integer}
	         * @default 60
	         * @since 3.0.0
	         */
	        this.targetFps = GetValue(config, 'target', 60);
	
	        /**
	         * The minFps value in ms.
	         * Defaults to 200ms between frames (i.e. super slow!)
	         *
	         * @name Phaser.Boot.TimeStep#_min
	         * @type {number}
	         * @private
	         * @since 3.0.0
	         */
	        this._min = 1000 / this.minFps;
	
	        /**
	         * The targetFps value in ms.
	         * Defaults to 16.66ms between frames (i.e. normal)
	         *
	         * @name Phaser.Boot.TimeStep#_target
	         * @type {number}
	         * @private
	         * @since 3.0.0
	         */
	        this._target = 1000 / this.targetFps;
	
	        /**
	         * An exponential moving average of the frames per second.
	         *
	         * @name Phaser.Boot.TimeStep#actualFps
	         * @type {integer}
	         * @readOnly
	         * @default 60
	         * @since 3.0.0
	         */
	        this.actualFps = this.targetFps;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Boot.TimeStep#nextFpsUpdate
	         * @type {integer}
	         * @readOnly
	         * @default 0
	         * @since 3.0.0
	         */
	        this.nextFpsUpdate = 0;
	
	        /**
	         * The number of frames processed this second.
	         *
	         * @name Phaser.Boot.TimeStep#framesThisSecond
	         * @type {integer}
	         * @readOnly
	         * @default 0
	         * @since 3.0.0
	         */
	        this.framesThisSecond = 0;
	
	        /**
	         * A callback to be invoked each time the Time Step steps.
	         *
	         * @name Phaser.Boot.TimeStep#callback
	         * @type {TimeStepCallback}
	         * @default NOOP
	         * @since 3.0.0
	         */
	        this.callback = NOOP;
	
	        /**
	         * You can force the Time Step to use Set Timeout instead of Request Animation Frame by setting
	         * the `forceSetTimeOut` property to `true` in the Game Configuration object. It cannot be changed at run-time.
	         *
	         * @name Phaser.Boot.TimeStep#forceSetTimeOut
	         * @type {boolean}
	         * @readOnly
	         * @default false
	         * @since 3.0.0
	         */
	        this.forceSetTimeOut = GetValue(config, 'forceSetTimeOut', false);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Boot.TimeStep#time
	         * @type {integer}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.time = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Boot.TimeStep#startTime
	         * @type {integer}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.startTime = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Boot.TimeStep#lastTime
	         * @type {integer}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.lastTime = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Boot.TimeStep#frame
	         * @type {integer}
	         * @readOnly
	         * @default 0
	         * @since 3.0.0
	         */
	        this.frame = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Boot.TimeStep#inFocus
	         * @type {boolean}
	         * @readOnly
	         * @default true
	         * @since 3.0.0
	         */
	        this.inFocus = true;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Boot.TimeStep#_pauseTime
	         * @type {integer}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._pauseTime = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Boot.TimeStep#_coolDown
	         * @type {integer}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._coolDown = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Boot.TimeStep#delta
	         * @type {integer}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.delta = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Boot.TimeStep#deltaIndex
	         * @type {integer}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.deltaIndex = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Boot.TimeStep#deltaHistory
	         * @type {array}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.deltaHistory = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Boot.TimeStep#deltaSmoothingMax
	         * @type {integer}
	         * @default 10
	         * @since 3.0.0
	         */
	        this.deltaSmoothingMax = GetValue(config, 'deltaHistory', 10);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Boot.TimeStep#panicMax
	         * @type {integer}
	         * @default 120
	         * @since 3.0.0
	         */
	        this.panicMax = GetValue(config, 'panicMax', 120);
	
	        /**
	         * The actual elapsed time in ms between one update and the next.
	         * Unlike with `delta` no smoothing, capping, or averaging is applied to this value.
	         * So please be careful when using this value in calculations.
	         *
	         * @name Phaser.Boot.TimeStep#rawDelta
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.rawDelta = 0;
	    },
	
	    /**
	     * Called when the DOM window.onBlur event triggers.
	     *
	     * @method Phaser.Boot.TimeStep#blur
	     * @since 3.0.0
	     */
	    blur: function ()
	    {
	        this.inFocus = false;
	    },
	
	    /**
	     * Called when the DOM window.onFocus event triggers.
	     *
	     * @method Phaser.Boot.TimeStep#focus
	     * @since 3.0.0
	     */
	    focus: function ()
	    {
	        this.inFocus = true;
	
	        this.resetDelta();
	    },
	
	    /**
	     * Called when the visibility API says the game is 'hidden' (tab switch out of view, etc)
	     *
	     * @method Phaser.Boot.TimeStep#pause
	     * @since 3.0.0
	     */
	    pause: function ()
	    {
	        this._pauseTime = window.performance.now();
	    },
	
	    /**
	     * Called when the visibility API says the game is 'visible' again (tab switch back into view, etc)
	     *
	     * @method Phaser.Boot.TimeStep#resume
	     * @since 3.0.0
	     */
	    resume: function ()
	    {
	        this.resetDelta();
	
	        this.startTime += this.time - this._pauseTime;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Boot.TimeStep#resetDelta
	     * @since 3.0.0
	     */
	    resetDelta: function ()
	    {
	        var now = window.performance.now();
	
	        this.time = now;
	        this.lastTime = now;
	        this.nextFpsUpdate = now + 1000;
	        this.framesThisSecond = 0;
	        this.frame = 0;
	
	        //  Pre-populate smoothing array
	
	        for (var i = 0; i < this.deltaSmoothingMax; i++)
	        {
	            this.deltaHistory[i] = Math.min(this._target, this.deltaHistory[i]);
	        }
	
	        this.delta = 0;
	        this.deltaIndex = 0;
	
	        this._coolDown = this.panicMax;
	    },
	
	    /**
	     * Starts the Time Step running, if it is not already doing so.
	     * Called automatically by the Game Boot process.
	     *
	     * @method Phaser.Boot.TimeStep#start
	     * @since 3.0.0
	     *
	     * @param {TimeStepCallback} callback - The callback to be invoked each time the Time Step steps.
	     */
	    start: function (callback)
	    {
	        if (this.started)
	        {
	            return this;
	        }
	
	        this.started = true;
	        this.running = true;
	
	        for (var i = 0; i < this.deltaSmoothingMax; i++)
	        {
	            this.deltaHistory[i] = this._target;
	        }
	
	        this.resetDelta();
	
	        this.startTime = window.performance.now();
	
	        this.callback = callback;
	
	        this.raf.start(this.step.bind(this), this.forceSetTimeOut);
	    },
	
	    /**
	     * The main step method. This is called each time the browser updates, either by Request Animation Frame,
	     * or by Set Timeout. It is responsible for calculating the delta values, frame totals, cool down history and more.
	     * You generally should never call this method directly.
	     *
	     * @method Phaser.Boot.TimeStep#step
	     * @since 3.0.0
	     *
	     * @param {integer} time - The current time. Either a High Resolution Timer value if it comes from Request Animation Frame, or Date.now if using SetTimeout.
	     */
	    step: function (time)
	    {
	        this.frame++;
	
	        this.rawDelta = time - this.lastTime;
	
	        var idx = this.deltaIndex;
	        var history = this.deltaHistory;
	        var max = this.deltaSmoothingMax;
	
	        //  delta time (time is in ms)
	        var dt = (time - this.lastTime);
	
	        //  When a browser switches tab, then comes back again, it takes around 10 frames before
	        //  the delta time settles down so we employ a 'cooling down' period before we start
	        //  trusting the delta values again, to avoid spikes flooding through our delta average
	
	        if (this._coolDown > 0 || !this.inFocus)
	        {
	            this._coolDown--;
	
	            dt = Math.min(dt, this._target);
	        }
	
	        if (dt > this._min)
	        {
	            //  Probably super bad start time or browser tab context loss,
	            //  so use the last 'sane' dt value
	
	            dt = history[idx];
	
	            //  Clamp delta to min (in case history has become corrupted somehow)
	            dt = Math.min(dt, this._min);
	        }
	
	        //  Smooth out the delta over the previous X frames
	
	        //  add the delta to the smoothing array
	        history[idx] = dt;
	
	        //  adjusts the delta history array index based on the smoothing count
	        //  this stops the array growing beyond the size of deltaSmoothingMax
	        this.deltaIndex++;
	
	        if (this.deltaIndex > max)
	        {
	            this.deltaIndex = 0;
	        }
	
	        //  Delta Average
	        var avg = 0;
	
	        //  Loop the history array, adding the delta values together
	
	        for (var i = 0; i < max; i++)
	        {
	            avg += history[i];
	        }
	
	        //  Then divide by the array length to get the average delta
	        avg /= max;
	
	        //  Set as the world delta value
	        this.delta = avg;
	
	        //  Real-world timer advance
	        this.time += this.rawDelta;
	
	        // Update the estimate of the frame rate, `fps`. Every second, the number
	        // of frames that occurred in that second are included in an exponential
	        // moving average of all frames per second, with an alpha of 0.25. This
	        // means that more recent seconds affect the estimated frame rate more than
	        // older seconds.
	        //
	        // When a browser window is NOT minimized, but is covered up (i.e. you're using
	        // another app which has spawned a window over the top of the browser), then it
	        // will start to throttle the raf callback time. It waits for a while, and then
	        // starts to drop the frame rate at 1 frame per second until it's down to just over 1fps.
	        // So if the game was running at 60fps, and the player opens a new window, then
	        // after 60 seconds (+ the 'buffer time') it'll be down to 1fps, so rafin'g at 1Hz.
	        //
	        // When they make the game visible again, the frame rate is increased at a rate of
	        // approx. 8fps, back up to 60fps (or the max it can obtain)
	        //
	        // There is no easy way to determine if this drop in frame rate is because the
	        // browser is throttling raf, or because the game is struggling with performance
	        // because you're asking it to do too much on the device.
	
	        if (time > this.nextFpsUpdate)
	        {
	            //  Compute the new exponential moving average with an alpha of 0.25.
	            this.actualFps = 0.25 * this.framesThisSecond + 0.75 * this.actualFps;
	            this.nextFpsUpdate = time + 1000;
	            this.framesThisSecond = 0;
	        }
	
	        this.framesThisSecond++;
	
	        //  Interpolation - how far between what is expected and where we are?
	        var interpolation = avg / this._target;
	
	        this.callback(time, avg, interpolation);
	
	        //  Shift time value over
	        this.lastTime = time;
	    },
	
	    /**
	     * Manually calls TimeStep.step, passing in the performance.now value to it.
	     *
	     * @method Phaser.Boot.TimeStep#tick
	     * @since 3.0.0
	     */
	    tick: function ()
	    {
	        this.step(window.performance.now());
	    },
	
	    /**
	     * Sends the TimeStep to sleep, stopping Request Animation Frame (or SetTimeout) and toggling the `running` flag to false.
	     *
	     * @method Phaser.Boot.TimeStep#sleep
	     * @since 3.0.0
	     */
	    sleep: function ()
	    {
	        if (this.running)
	        {
	            this.raf.stop();
	
	            this.running = false;
	        }
	    },
	
	    /**
	     * Wakes-up the TimeStep, restarting Request Animation Frame (or SetTimeout) and toggling the `running` flag to true.
	     * The `seamless` argument controls if the wake-up should adjust the start time or not.
	     *
	     * @method Phaser.Boot.TimeStep#wake
	     * @since 3.0.0
	     *
	     * @param {boolean} [seamless=false] - Adjust the startTime based on the lastTime values.
	     */
	    wake: function (seamless)
	    {
	        if (this.running)
	        {
	            this.sleep();
	        }
	        else if (seamless)
	        {
	            this.startTime += -this.lastTime + (this.lastTime = window.performance.now());
	        }
	
	        this.raf.start(this.step.bind(this), this.useRAF);
	
	        this.running = true;
	
	        this.step(window.performance.now());
	    },
	
	    /**
	     * Stops the TimeStep running.
	     *
	     * @method Phaser.Boot.TimeStep#stop
	     * @since 3.0.0
	     *
	     * @return {Phaser.Boot.TimeStep} The TimeStep object.
	     */
	    stop: function ()
	    {
	        this.running = false;
	        this.started = false;
	
	        this.raf.stop();
	
	        return this;
	    },
	
	    /**
	     * Destroys the TimeStep. This will stop Request Animation Frame, stop the step, clear the callbacks and null
	     * any objects.
	     *
	     * @method Phaser.Boot.TimeStep#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.stop();
	
	        this.callback = NOOP;
	
	        this.raf = null;
	        this.game = null;
	    }
	
	});
	
	module.exports = TimeStep;


/***/ }),
/* 1041 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Visibility Handler hidden event.
	 *
	 * The document in which the Game is embedded has entered a hidden state.
	 *
	 * @event Phaser.Boot.VisibilityHandler#hidden
	 */
	
	/**
	 * Visibility Handler visible event.
	 *
	 * The document in which the Game is embedded has entered a visible state.
	 *
	 * @event Phaser.Boot.VisibilityHandler#visible
	 */
	
	/**
	 * Visibility Handler blur event.
	 *
	 * The window in which the Game is embedded has entered a blurred state.
	 *
	 * @event Phaser.Boot.VisibilityHandler#blur
	 */
	
	/**
	 * Visibility Handler focus event.
	 *
	 * The window in which the Game is embedded has entered a focused state.
	 *
	 * @event Phaser.Boot.VisibilityHandler#focus
	 */
	
	/**
	 * The Visibility Handler is responsible for listening out for document level visibility change events.
	 * This includes `visibilitychange` if the browser supports it, and blur and focus events. It then uses
	 * the provided Event Emitter and fires the related events.
	 *
	 * @function Phaser.Boot.VisibilityHandler
	 * @fires Phaser.Boot.VisibilityHandler#hidden
	 * @fires Phaser.Boot.VisibilityHandler#visible
	 * @fires Phaser.Boot.VisibilityHandler#blur
	 * @fires Phaser.Boot.VisibilityHandler#focus
	 * @since 3.0.0
	 *
	 * @param {Phaser.Events.EventEmitter} eventEmitter - The EventEmitter that will emit the visibility events.
	 */
	var VisibilityHandler = function (eventEmitter)
	{
	    var hiddenVar;
	
	    if (document.hidden !== undefined)
	    {
	        hiddenVar = 'visibilitychange';
	    }
	    else
	    {
	        var vendors = [ 'webkit', 'moz', 'ms' ];
	
	        vendors.forEach(function (prefix)
	        {
	            if (document[prefix + 'Hidden'] !== undefined)
	            {
	                document.hidden = function ()
	                {
	                    return document[prefix + 'Hidden'];
	                };
	
	                hiddenVar = prefix + 'visibilitychange';
	            }
	
	        });
	    }
	
	    var onChange = function (event)
	    {
	        if (document.hidden || event.type === 'pause')
	        {
	            eventEmitter.emit('hidden');
	        }
	        else
	        {
	            eventEmitter.emit('visible');
	        }
	    };
	
	    if (hiddenVar)
	    {
	        document.addEventListener(hiddenVar, onChange, false);
	    }
	
	    window.onblur = function ()
	    {
	        eventEmitter.emit('blur');
	    };
	
	    window.onfocus = function ()
	    {
	        eventEmitter.emit('focus');
	    };
	};
	
	module.exports = VisibilityHandler;


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Cache
	 */
	
	module.exports = {
	
	    BaseCache: __webpack_require__(445),
	    CacheManager: __webpack_require__(446)
	
	};


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Camera = __webpack_require__(264);
	var Class = __webpack_require__(1);
	var GetFastValue = __webpack_require__(3);
	var PluginCache = __webpack_require__(29);
	var RectangleContains = __webpack_require__(84);
	
	/**
	 * @typedef {object} InputJSONCameraObject
	 *
	 * @property {string} [name=''] - [description]
	 * @property {integer} [x=0] - [description]
	 * @property {integer} [y=0] - [description]
	 * @property {integer} [width] - [description]
	 * @property {integer} [height] - [description]
	 * @property {float} [zoom=1] - [description]
	 * @property {float} [rotation=0] - [description]
	 * @property {boolean} [roundPixels=false] - [description]
	 * @property {float} [scrollX=0] - [description]
	 * @property {float} [scrollY=0] - [description]
	 * @property {(false|string)} [backgroundColor=false] - [description]
	 * @property {?object} [bounds] - [description]
	 * @property {number} [bounds.x=0] - [description]
	 * @property {number} [bounds.y=0] - [description]
	 * @property {number} [bounds.width] - [description]
	 * @property {number} [bounds.height] - [description]
	 */
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class CameraManager
	 * @memberOf Phaser.Cameras.Scene2D
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - The Scene that owns the Camera Manager plugin.
	 */
	var CameraManager = new Class({
	
	    initialize:
	
	    function CameraManager (scene)
	    {
	        /**
	         * The Scene that owns the Camera Manager plugin.
	         *
	         * @name Phaser.Cameras.Scene2D.CameraManager#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * A reference to the Scene.Systems handler for the Scene that owns the Camera Manager.
	         *
	         * @name Phaser.Cameras.Scene2D.CameraManager#systems
	         * @type {Phaser.Scenes.Systems}
	         * @since 3.0.0
	         */
	        this.systems = scene.sys;
	
	        /**
	         * The current Camera ID.
	         *
	         * @name Phaser.Cameras.Scene2D.CameraManager#currentCameraId
	         * @type {number}
	         * @default 1
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.currentCameraId = 1;
	
	        /**
	         * An Array of the Camera objects being managed by this Camera Manager.
	         *
	         * @name Phaser.Cameras.Scene2D.CameraManager#cameras
	         * @type {Phaser.Cameras.Scene2D.Camera[]}
	         * @since 3.0.0
	         */
	        this.cameras = [];
	
	        /**
	         * A pool of Camera objects available to be used by the Camera Manager.
	         *
	         * @name Phaser.Cameras.Scene2D.CameraManager#cameraPool
	         * @type {Phaser.Cameras.Scene2D.Camera[]}
	         * @since 3.0.0
	         */
	        this.cameraPool = [];
	
	        /**
	         * The default Camera in the Camera Manager.
	         *
	         * @name Phaser.Cameras.Scene2D.CameraManager#main
	         * @type {Phaser.Cameras.Scene2D.Camera}
	         * @since 3.0.0
	         */
	        this.main;
	
	        /**
	         * This scale affects all cameras. It's used by Scale Manager.
	         *
	         * @name Phaser.Cameras.Scene2D.CameraManager#baseScale
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.baseScale = 1;
	
	        scene.sys.events.once('boot', this.boot, this);
	        scene.sys.events.on('start', this.start, this);
	    },
	
	    /**
	     * This method is called automatically, only once, when the Scene is first created.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.Cameras.Scene2D.CameraManager#boot
	     * @private
	     * @since 3.5.1
	     */
	    boot: function ()
	    {
	        var sys = this.systems;
	
	        if (sys.settings.cameras)
	        {
	            //  We have cameras to create
	            this.fromJSON(sys.settings.cameras);
	        }
	        else
	        {
	            //  Make one
	            this.add();
	        }
	
	        this.main = this.cameras[0];
	
	        this.systems.events.once('destroy', this.destroy, this);
	    },
	
	    /**
	     * This method is called automatically by the Scene when it is starting up.
	     * It is responsible for creating local systems, properties and listening for Scene events.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.Cameras.Scene2D.CameraManager#start
	     * @private
	     * @since 3.5.0
	     */
	    start: function ()
	    {
	        if (!this.main)
	        {
	            this.boot();
	        }
	
	        var eventEmitter = this.systems.events;
	
	        eventEmitter.on('update', this.update, this);
	        eventEmitter.once('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Scene2D.CameraManager#add
	     * @since 3.0.0
	     *
	     * @param {number} [x=0] - [description]
	     * @param {number} [y=0] - [description]
	     * @param {number} [width] - [description]
	     * @param {number} [height] - [description]
	     * @param {boolean} [makeMain=false] - [description]
	     * @param {string} [name=''] - [description]
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} [description]
	     */
	    add: function (x, y, width, height, makeMain, name)
	    {
	        if (x === undefined) { x = 0; }
	        if (y === undefined) { y = 0; }
	        if (width === undefined) { width = this.scene.sys.game.config.width; }
	        if (height === undefined) { height = this.scene.sys.game.config.height; }
	        if (makeMain === undefined) { makeMain = false; }
	        if (name === undefined) { name = ''; }
	
	        var camera = null;
	
	        if (this.cameraPool.length > 0)
	        {
	            camera = this.cameraPool.pop();
	
	            camera.setViewport(x, y, width, height);
	        }
	        else
	        {
	            camera = new Camera(x, y, width, height);
	        }
	
	        camera.setName(name);
	        camera.setScene(this.scene);
	
	        this.cameras.push(camera);
	
	        if (makeMain)
	        {
	            this.main = camera;
	        }
	
	        camera._id = this.currentCameraId;
	
	        this.currentCameraId = this.currentCameraId << 1;
	
	        return camera;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Scene2D.CameraManager#addExisting
	     * @since 3.0.0
	     *
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} [description]
	     */
	    addExisting: function (camera)
	    {
	        var index = this.cameras.indexOf(camera);
	        var poolIndex = this.cameraPool.indexOf(camera);
	
	        if (index < 0 && poolIndex >= 0)
	        {
	            this.cameras.push(camera);
	            this.cameraPool.slice(poolIndex, 1);
	            return camera;
	        }
	
	        return null;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Scene2D.CameraManager#fromJSON
	     * @since 3.0.0
	     *
	     * @param {(InputJSONCameraObject|InputJSONCameraObject[])} config - [description]
	     *
	     * @return {Phaser.Cameras.Scene2D.CameraManager} [description]
	     */
	    fromJSON: function (config)
	    {
	        if (!Array.isArray(config))
	        {
	            config = [ config ];
	        }
	
	        var gameWidth = this.scene.sys.game.config.width;
	        var gameHeight = this.scene.sys.game.config.height;
	
	        for (var i = 0; i < config.length; i++)
	        {
	            var cameraConfig = config[i];
	
	            var x = GetFastValue(cameraConfig, 'x', 0);
	            var y = GetFastValue(cameraConfig, 'y', 0);
	            var width = GetFastValue(cameraConfig, 'width', gameWidth);
	            var height = GetFastValue(cameraConfig, 'height', gameHeight);
	
	            var camera = this.add(x, y, width, height);
	
	            //  Direct properties
	            camera.name = GetFastValue(cameraConfig, 'name', '');
	            camera.zoom = GetFastValue(cameraConfig, 'zoom', 1);
	            camera.rotation = GetFastValue(cameraConfig, 'rotation', 0);
	            camera.scrollX = GetFastValue(cameraConfig, 'scrollX', 0);
	            camera.scrollY = GetFastValue(cameraConfig, 'scrollY', 0);
	            camera.roundPixels = GetFastValue(cameraConfig, 'roundPixels', false);
	
	            // Background Color
	
	            var backgroundColor = GetFastValue(cameraConfig, 'backgroundColor', false);
	
	            if (backgroundColor)
	            {
	                camera.setBackgroundColor(backgroundColor);
	            }
	
	            //  Bounds
	
	            var boundsConfig = GetFastValue(cameraConfig, 'bounds', null);
	
	            if (boundsConfig)
	            {
	                var bx = GetFastValue(boundsConfig, 'x', 0);
	                var by = GetFastValue(boundsConfig, 'y', 0);
	                var bwidth = GetFastValue(boundsConfig, 'width', gameWidth);
	                var bheight = GetFastValue(boundsConfig, 'height', gameHeight);
	
	                camera.setBounds(bx, by, bwidth, bheight);
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Scene2D.CameraManager#getCamera
	     * @since 3.0.0
	     *
	     * @param {string} name - [description]
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} [description]
	     */
	    getCamera: function (name)
	    {
	        for (var i = 0; i < this.cameras.length; i++)
	        {
	            if (this.cameras[i].name === name)
	            {
	                return this.cameras[i];
	            }
	        }
	
	        return null;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Scene2D.CameraManager#getCameraBelowPointer
	     * @since 3.0.0
	     *
	     * @param {Phaser.Input.Pointer} pointer - [description]
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} [description]
	     */
	    getCameraBelowPointer: function (pointer)
	    {
	        var cameras = this.cameras;
	
	        //  Start from the most recently added camera (the 'top' camera)
	        for (var i = cameras.length - 1; i >= 0; i--)
	        {
	            var camera = cameras[i];
	
	            if (camera.inputEnabled && RectangleContains(camera, pointer.x, pointer.y))
	            {
	                return camera;
	            }
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Scene2D.CameraManager#remove
	     * @since 3.0.0
	     *
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - [description]
	     */
	    remove: function (camera)
	    {
	        var cameraIndex = this.cameras.indexOf(camera);
	
	        if (cameraIndex >= 0 && this.cameras.length > 1)
	        {
	            this.cameraPool.push(this.cameras[cameraIndex]);
	            this.cameras.splice(cameraIndex, 1);
	
	            if (this.main === camera)
	            {
	                this.main = this.cameras[0];
	            }
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Scene2D.CameraManager#render
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Renderer.Canvas.CanvasRenderer|Phaser.Renderer.WebGL.WebGLRenderer)} renderer - The Renderer that will render the children to this camera.
	     * @param {Phaser.GameObjects.GameObject[]} children - An array of renderable Game Objects.
	     * @param {number} interpolation - Interpolation value. Reserved for future use.
	     */
	    render: function (renderer, children, interpolation)
	    {
	        var cameras = this.cameras;
	        var baseScale = this.baseScale;
	
	        for (var i = 0, l = cameras.length; i < l; ++i)
	        {
	            var camera = cameras[i];
	
	            camera.preRender(baseScale, renderer.config.resolution);
	
	            renderer.render(this.scene, children, interpolation, camera);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Scene2D.CameraManager#resetAll
	     * @since 3.0.0
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} [description]
	     */
	    resetAll: function ()
	    {
	        while (this.cameras.length > 0)
	        {
	            this.cameraPool.push(this.cameras.pop());
	        }
	
	        this.main = this.add();
	
	        return this.main;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Scene2D.CameraManager#update
	     * @since 3.0.0
	     *
	     * @param {number} timestep - [description]
	     * @param {number} delta - [description]
	     */
	    update: function (timestep, delta)
	    {
	        for (var i = 0, l = this.cameras.length; i < l; ++i)
	        {
	            this.cameras[i].update(timestep, delta);
	        }
	    },
	
	    /**
	     * Resizes all cameras to the given dimensions.
	     *
	     * @method Phaser.Cameras.Scene2D.CameraManager#resize
	     * @since 3.2.0
	     *
	     * @param {number} width - The new width of the camera.
	     * @param {number} height - The new height of the camera.
	     */
	    resize: function (width, height)
	    {
	        for (var i = 0, l = this.cameras.length; i < l; ++i)
	        {
	            this.cameras[i].setSize(width, height);
	        }
	    },
	
	    /**
	     * The Scene that owns this plugin is shutting down.
	     * We need to kill and reset all internal properties as well as stop listening to Scene events.
	     *
	     * @method Phaser.Cameras.Scene2D.CameraManager#shutdown
	     * @private
	     * @since 3.0.0
	     */
	    shutdown: function ()
	    {
	        this.main = undefined;
	
	        for (var i = 0; i < this.cameras.length; i++)
	        {
	            this.cameras[i].destroy();
	        }
	
	        for (i = 0; i < this.cameraPool.length; i++)
	        {
	            this.cameraPool[i].destroy();
	        }
	
	        this.cameras = [];
	        this.cameraPool = [];
	
	        var eventEmitter = this.systems.events;
	
	        eventEmitter.off('update', this.update, this);
	        eventEmitter.off('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * The Scene that owns this plugin is being destroyed.
	     * We need to shutdown and then kill off all external references.
	     *
	     * @method Phaser.Cameras.Scene2D.CameraManager#destroy
	     * @private
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.shutdown();
	
	        this.scene.sys.events.off('start', this.start, this);
	
	        this.scene = null;
	        this.systems = null;
	    }
	
	});
	
	PluginCache.register('CameraManager', CameraManager, 'cameras');
	
	module.exports = CameraManager;


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Clamp = __webpack_require__(63);
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * A Camera Fade effect.
	 *
	 * This effect will fade the camera viewport to the given color, over the duration specified.
	 *
	 * Only the camera viewport is faded. None of the objects it is displaying are impacted, i.e. their colors do
	 * not change.
	 *
	 * The effect will dispatch several events on the Camera itself and you can also specify an `onUpdate` callback,
	 * which is invoked each frame for the duration of the effect, if required.
	 *
	 * @class Fade
	 * @memberOf Phaser.Cameras.Scene2D.Effects
	 * @constructor
	 * @since 3.5.0
	 *
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera this effect is acting upon.
	 */
	var Fade = new Class({
	
	    initialize:
	
	    function Fade (camera)
	    {
	        /**
	         * The Camera this effect belongs to.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Fade#camera
	         * @type {Phaser.Cameras.Scene2D.Camera}
	         * @readOnly
	         * @since 3.5.0
	         */
	        this.camera = camera;
	
	        /**
	         * Is this effect actively running?
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Fade#isRunning
	         * @type {boolean}
	         * @readOnly
	         * @default false
	         * @since 3.5.0
	         */
	        this.isRunning = false;
	
	        /**
	         * Has this effect finished running?
	         * 
	         * This is different from `isRunning` because it remains set to `true` when the effect is over,
	         * until the effect is either reset or started again.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Fade#isComplete
	         * @type {boolean}
	         * @readOnly
	         * @default false
	         * @since 3.5.0
	         */
	        this.isComplete = false;
	
	        /**
	         * The direction of the fade.
	         * `true` = fade out (transparent to color), `false` = fade in (color to transparent)
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Fade#direction
	         * @type {boolean}
	         * @readOnly
	         * @since 3.5.0
	         */
	        this.direction = true;
	
	        /**
	         * The duration of the effect, in milliseconds.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Fade#duration
	         * @type {integer}
	         * @readOnly
	         * @default 0
	         * @since 3.5.0
	         */
	        this.duration = 0;
	
	        /**
	         * The value of the red color channel the camera will use for the fade effect.
	         * A value between 0 and 255.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Fade#red
	         * @type {integer}
	         * @private
	         * @since 3.5.0
	         */
	        this.red = 0;
	
	        /**
	         * The value of the green color channel the camera will use for the fade effect.
	         * A value between 0 and 255.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Fade#green
	         * @type {integer}
	         * @private
	         * @since 3.5.0
	         */
	        this.green = 0;
	
	        /**
	         * The value of the blue color channel the camera will use for the fade effect.
	         * A value between 0 and 255.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Fade#blue
	         * @type {integer}
	         * @private
	         * @since 3.5.0
	         */
	        this.blue = 0;
	
	        /**
	         * The value of the alpha channel used during the fade effect.
	         * A value between 0 and 1.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Fade#alpha
	         * @type {float}
	         * @private
	         * @since 3.5.0
	         */
	        this.alpha = 0;
	
	        /**
	         * If this effect is running this holds the current percentage of the progress, a value between 0 and 1.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Fade#progress
	         * @type {float}
	         * @since 3.5.0
	         */
	        this.progress = 0;
	
	        /**
	         * Effect elapsed timer.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Fade#_elapsed
	         * @type {number}
	         * @private
	         * @since 3.5.0
	         */
	        this._elapsed = 0;
	
	        /**
	         * @callback CameraFadeCallback
	         *
	         * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera on which the effect is running.
	         * @param {float} progress - The progress of the effect. A value between 0 and 1.
	         */
	
	        /**
	         * This callback is invoked every frame for the duration of the effect.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Fade#_onUpdate
	         * @type {?CameraFadeCallback}
	         * @private
	         * @default null
	         * @since 3.5.0
	         */
	        this._onUpdate;
	
	        /**
	         * On Complete callback scope.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Fade#_onUpdateScope
	         * @type {any}
	         * @private
	         * @since 3.5.0
	         */
	        this._onUpdateScope;
	    },
	
	    /**
	     * This event is fired when the fade in effect begins to run on a camera.
	     *
	     * @event CameraFadeInStartEvent
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
	     * @param {Phaser.Cameras.Scene2D.Effects.Fade} effect - A reference to the effect instance.
	     * @param {integer} duration - The duration of the effect.
	     * @param {integer} red - The red color channel value.
	     * @param {integer} green - The green color channel value.
	     * @param {integer} blue - The blue color channel value.
	     */
	
	    /**
	     * This event is fired when the fade out effect begins to run on a camera.
	     *
	     * @event CameraFadeOutStartEvent
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
	     * @param {Phaser.Cameras.Scene2D.Effects.Fade} effect - A reference to the effect instance.
	     * @param {integer} duration - The duration of the effect.
	     * @param {integer} red - The red color channel value.
	     * @param {integer} green - The green color channel value.
	     * @param {integer} blue - The blue color channel value.
	     */
	
	    /**
	     * This event is fired when the fade in effect completes.
	     *
	     * @event CameraFadeInCompleteEvent
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
	     * @param {Phaser.Cameras.Scene2D.Effects.Fade} effect - A reference to the effect instance.
	     */
	
	    /**
	     * This event is fired when the fade out effect completes.
	     *
	     * @event CameraFadeOutCompleteEvent
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
	     * @param {Phaser.Cameras.Scene2D.Effects.Fade} effect - A reference to the effect instance.
	     */
	
	    /**
	     * Fades the Camera to or from the given color over the duration specified.
	     *
	     * @method Phaser.Cameras.Scene2D.Effects.Fade#start
	     * @fires CameraFadeInStartEvent
	     * @fires CameraFadeInCompleteEvent
	     * @fires CameraFadeOutStartEvent
	     * @fires CameraFadeOutCompleteEvent
	     * @since 3.5.0
	     *
	     * @param {boolean} [direction=true] - The direction of the fade. `true` = fade out (transparent to color), `false` = fade in (color to transparent)
	     * @param {integer} [duration=1000] - The duration of the effect in milliseconds.
	     * @param {integer} [red=0] - The amount to fade the red channel towards. A value between 0 and 255.
	     * @param {integer} [green=0] - The amount to fade the green channel towards. A value between 0 and 255.
	     * @param {integer} [blue=0] - The amount to fade the blue channel towards. A value between 0 and 255.
	     * @param {boolean} [force=false] - Force the effect to start immediately, even if already running.
	     * @param {CameraFadeCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
	     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
	     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} The Camera on which the effect was started.
	     */
	    start: function (direction, duration, red, green, blue, force, callback, context)
	    {
	        if (direction === undefined) { direction = true; }
	        if (duration === undefined) { duration = 1000; }
	        if (red === undefined) { red = 0; }
	        if (green === undefined) { green = 0; }
	        if (blue === undefined) { blue = 0; }
	        if (force === undefined) { force = false; }
	        if (callback === undefined) { callback = null; }
	        if (context === undefined) { context = this.camera.scene; }
	
	        if (!force && this.isRunning)
	        {
	            return this.camera;
	        }
	
	        this.isRunning = true;
	        this.isComplete = false;
	        this.duration = duration;
	        this.direction = direction;
	        this.progress = 0;
	
	        this.red = red;
	        this.green = green;
	        this.blue = blue;
	        this.alpha = (direction) ? Number.MIN_VALUE : 1;
	
	        this._elapsed = 0;
	
	        this._onUpdate = callback;
	        this._onUpdateScope = context;
	
	        var eventName = (direction) ? 'camerafadeoutstart' : 'camerafadeinstart';
	
	        this.camera.emit(eventName, this.camera, this, duration, red, green, blue);
	
	        return this.camera;
	    },
	
	    /**
	     * The main update loop for this effect. Called automatically by the Camera.
	     *
	     * @method Phaser.Cameras.Scene2D.Effects.Fade#update
	     * @since 3.5.0
	     *
	     * @param {integer} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
	     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
	     */
	    update: function (time, delta)
	    {
	        if (!this.isRunning)
	        {
	            return;
	        }
	
	        this._elapsed += delta;
	
	        this.progress = Clamp(this._elapsed / this.duration, 0, 1);
	
	        if (this._onUpdate)
	        {
	            this._onUpdate.call(this._onUpdateScope, this.camera, this.progress);
	        }
	
	        if (this._elapsed < this.duration)
	        {
	            this.alpha = (this.direction) ? this.progress : 1 - this.progress;
	        }
	        else
	        {
	            this.effectComplete();
	        }
	    },
	
	    /**
	     * Called internally by the Canvas Renderer.
	     *
	     * @method Phaser.Cameras.Scene2D.Effects.Fade#postRenderCanvas
	     * @since 3.5.0
	     *
	     * @param {CanvasRenderingContext2D} ctx - The Canvas context to render to.
	     *
	     * @return {boolean} `true` if the effect drew to the renderer, otherwise `false`.
	     */
	    postRenderCanvas: function (ctx)
	    {
	        if (!this.isRunning && !this.isComplete)
	        {
	            return false;
	        }
	
	        var camera = this.camera;
	
	        ctx.fillStyle = 'rgba(' + this.red + ',' + this.green + ',' + this.blue + ',' + this.alpha + ')';
	        ctx.fillRect(camera.x, camera.y, camera.width, camera.height);
	
	        return true;
	    },
	
	    /**
	     * Called internally by the WebGL Renderer.
	     *
	     * @method Phaser.Cameras.Scene2D.Effects.Fade#postRenderWebGL
	     * @since 3.5.0
	     *
	     * @param {Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline} pipeline - The WebGL Pipeline to render to.
	     * @param {function} getTintFunction - A function that will return the gl safe tint colors.
	     *
	     * @return {boolean} `true` if the effect drew to the renderer, otherwise `false`.
	     */
	    postRenderWebGL: function (pipeline, getTintFunction)
	    {
	        if (!this.isRunning && !this.isComplete)
	        {
	            return false;
	        }
	
	        var camera = this.camera;
	        var red = this.red / 255;
	        var blue = this.blue / 255;
	        var green = this.green / 255;
	
	        pipeline.batchFillRect(
	            0, 0, 1, 1, 0,
	            camera.x, camera.y, camera.width, camera.height,
	            getTintFunction(red, green, blue, 1),
	            this.alpha,
	            1, 0, 0, 1, 0, 0,
	            [ 1, 0, 0, 1, 0, 0 ]
	        );
	
	        return true;
	    },
	
	    /**
	     * Called internally when the effect completes.
	     *
	     * @method Phaser.Cameras.Scene2D.Effects.Fade#effectComplete
	     * @since 3.5.0
	     */
	    effectComplete: function ()
	    {
	        this._onUpdate = null;
	        this._onUpdateScope = null;
	
	        this.isRunning = false;
	        this.isComplete = true;
	
	        var eventName = (this.direction) ? 'camerafadeoutcomplete' : 'camerafadeincomplete';
	
	        this.camera.emit(eventName, this.camera, this);
	    },
	
	    /**
	     * Resets this camera effect.
	     * If it was previously running, it stops instantly without calling its onComplete callback or emitting an event.
	     *
	     * @method Phaser.Cameras.Scene2D.Effects.Fade#reset
	     * @since 3.5.0
	     */
	    reset: function ()
	    {
	        this.isRunning = false;
	        this.isComplete = false;
	
	        this._onUpdate = null;
	        this._onUpdateScope = null;
	    },
	
	    /**
	     * Destroys this effect, releasing it from the Camera.
	     *
	     * @method Phaser.Cameras.Scene2D.Effects.Fade#destroy
	     * @since 3.5.0
	     */
	    destroy: function ()
	    {
	        this.reset();
	
	        this.camera = null;
	    }
	
	});
	
	module.exports = Fade;


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Clamp = __webpack_require__(63);
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * A Camera Flash effect.
	 *
	 * This effect will flash the camera viewport to the given color, over the duration specified.
	 *
	 * Only the camera viewport is flashed. None of the objects it is displaying are impacted, i.e. their colors do
	 * not change.
	 *
	 * The effect will dispatch several events on the Camera itself and you can also specify an `onUpdate` callback,
	 * which is invoked each frame for the duration of the effect, if required.
	 *
	 * @class Flash
	 * @memberOf Phaser.Cameras.Scene2D.Effects
	 * @constructor
	 * @since 3.5.0
	 *
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera this effect is acting upon.
	 */
	var Flash = new Class({
	
	    initialize:
	
	    function Flash (camera)
	    {
	        /**
	         * The Camera this effect belongs to.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Flash#camera
	         * @type {Phaser.Cameras.Scene2D.Camera}
	         * @readOnly
	         * @since 3.5.0
	         */
	        this.camera = camera;
	
	        /**
	         * Is this effect actively running?
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Flash#isRunning
	         * @type {boolean}
	         * @readOnly
	         * @default false
	         * @since 3.5.0
	         */
	        this.isRunning = false;
	
	        /**
	         * The duration of the effect, in milliseconds.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Flash#duration
	         * @type {integer}
	         * @readOnly
	         * @default 0
	         * @since 3.5.0
	         */
	        this.duration = 0;
	
	        /**
	         * The value of the red color channel the camera will use for the fade effect.
	         * A value between 0 and 255.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Flash#red
	         * @type {integer}
	         * @private
	         * @since 3.5.0
	         */
	        this.red = 0;
	
	        /**
	         * The value of the green color channel the camera will use for the fade effect.
	         * A value between 0 and 255.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Flash#green
	         * @type {integer}
	         * @private
	         * @since 3.5.0
	         */
	        this.green = 0;
	
	        /**
	         * The value of the blue color channel the camera will use for the fade effect.
	         * A value between 0 and 255.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Flash#blue
	         * @type {integer}
	         * @private
	         * @since 3.5.0
	         */
	        this.blue = 0;
	
	        /**
	         * The value of the alpha channel used during the fade effect.
	         * A value between 0 and 1.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Flash#alpha
	         * @type {float}
	         * @private
	         * @since 3.5.0
	         */
	        this.alpha = 0;
	
	        /**
	         * If this effect is running this holds the current percentage of the progress, a value between 0 and 1.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Flash#progress
	         * @type {float}
	         * @since 3.5.0
	         */
	        this.progress = 0;
	
	        /**
	         * Effect elapsed timer.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Flash#_elapsed
	         * @type {number}
	         * @private
	         * @since 3.5.0
	         */
	        this._elapsed = 0;
	
	        /**
	         * @callback CameraFlashCallback
	         *
	         * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera on which the effect is running.
	         * @param {float} progress - The progress of the effect. A value between 0 and 1.
	         */
	
	        /**
	         * This callback is invoked every frame for the duration of the effect.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Flash#_onUpdate
	         * @type {?CameraFlashCallback}
	         * @private
	         * @default null
	         * @since 3.5.0
	         */
	        this._onUpdate;
	
	        /**
	         * On Complete callback scope.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Flash#_onUpdateScope
	         * @type {any}
	         * @private
	         * @since 3.5.0
	         */
	        this._onUpdateScope;
	    },
	
	    /**
	     * This event is fired when the flash effect begins to run on a camera.
	     *
	     * @event CameraFlashStartEvent
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
	     * @param {Phaser.Cameras.Scene2D.Effects.Flash} effect - A reference to the effect instance.
	     * @param {integer} duration - The duration of the effect.
	     * @param {integer} red - The red color channel value.
	     * @param {integer} green - The green color channel value.
	     * @param {integer} blue - The blue color channel value.
	     */
	
	    /**
	     * This event is fired when the flash effect completes.
	     *
	     * @event CameraFlashCompleteEvent
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
	     * @param {Phaser.Cameras.Scene2D.Effects.Flash} effect - A reference to the effect instance.
	     */
	
	    /**
	     * Flashes the Camera to or from the given color over the duration specified.
	     *
	     * @method Phaser.Cameras.Scene2D.Effects.Flash#start
	     * @fires CameraFlashStartEvent
	     * @fires CameraFlashCompleteEvent
	     * @since 3.5.0
	     *
	     * @param {integer} [duration=250] - The duration of the effect in milliseconds.
	     * @param {integer} [red=255] - The amount to fade the red channel towards. A value between 0 and 255.
	     * @param {integer} [green=255] - The amount to fade the green channel towards. A value between 0 and 255.
	     * @param {integer} [blue=255] - The amount to fade the blue channel towards. A value between 0 and 255.
	     * @param {boolean} [force=false] - Force the effect to start immediately, even if already running.
	     * @param {CameraFlashCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
	     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
	     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} The Camera on which the effect was started.
	     */
	    start: function (duration, red, green, blue, force, callback, context)
	    {
	        if (duration === undefined) { duration = 250; }
	        if (red === undefined) { red = 255; }
	        if (green === undefined) { green = 255; }
	        if (blue === undefined) { blue = 255; }
	        if (force === undefined) { force = false; }
	        if (callback === undefined) { callback = null; }
	        if (context === undefined) { context = this.camera.scene; }
	
	        if (!force && this.isRunning)
	        {
	            return this.camera;
	        }
	
	        this.isRunning = true;
	        this.duration = duration;
	        this.progress = 0;
	
	        this.red = red;
	        this.green = green;
	        this.blue = blue;
	        this.alpha = 1;
	
	        this._elapsed = 0;
	
	        this._onUpdate = callback;
	        this._onUpdateScope = context;
	
	        this.camera.emit('cameraflashstart', this.camera, this, duration, red, green, blue);
	
	        return this.camera;
	    },
	
	    /**
	     * The main update loop for this effect. Called automatically by the Camera.
	     *
	     * @method Phaser.Cameras.Scene2D.Effects.Flash#update
	     * @since 3.5.0
	     *
	     * @param {integer} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
	     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
	     */
	    update: function (time, delta)
	    {
	        if (!this.isRunning)
	        {
	            return;
	        }
	
	        this._elapsed += delta;
	
	        this.progress = Clamp(this._elapsed / this.duration, 0, 1);
	
	        if (this._onUpdate)
	        {
	            this._onUpdate.call(this._onUpdateScope, this.camera, this.progress);
	        }
	
	        if (this._elapsed < this.duration)
	        {
	            this.alpha = 1 - this.progress;
	        }
	        else
	        {
	            this.effectComplete();
	        }
	    },
	
	    /**
	     * Called internally by the Canvas Renderer.
	     *
	     * @method Phaser.Cameras.Scene2D.Effects.Flash#postRenderCanvas
	     * @since 3.5.0
	     *
	     * @param {CanvasRenderingContext2D} ctx - The Canvas context to render to.
	     *
	     * @return {boolean} `true` if the effect drew to the renderer, otherwise `false`.
	     */
	    postRenderCanvas: function (ctx)
	    {
	        if (!this.isRunning)
	        {
	            return false;
	        }
	
	        var camera = this.camera;
	
	        ctx.fillStyle = 'rgba(' + this.red + ',' + this.green + ',' + this.blue + ',' + this.alpha + ')';
	        ctx.fillRect(camera.x, camera.y, camera.width, camera.height);
	
	        return true;
	    },
	
	    /**
	     * Called internally by the WebGL Renderer.
	     *
	     * @method Phaser.Cameras.Scene2D.Effects.Flash#postRenderWebGL
	     * @since 3.5.0
	     *
	     * @param {Phaser.Renderer.WebGL.Pipelines.FlatTintPipeline} pipeline - The WebGL Pipeline to render to.
	     * @param {function} getTintFunction - A function that will return the gl safe tint colors.
	     *
	     * @return {boolean} `true` if the effect drew to the renderer, otherwise `false`.
	     */
	    postRenderWebGL: function (pipeline, getTintFunction)
	    {
	        if (!this.isRunning)
	        {
	            return false;
	        }
	
	        var camera = this.camera;
	        var red = this.red / 255;
	        var blue = this.blue / 255;
	        var green = this.green / 255;
	
	        pipeline.batchFillRect(
	            0, 0, 1, 1, 0,
	            camera.x, camera.y, camera.width, camera.height,
	            getTintFunction(red, green, blue, 1),
	            this.alpha,
	            1, 0, 0, 1, 0, 0,
	            [ 1, 0, 0, 1, 0, 0 ]
	        );
	
	        return true;
	    },
	
	    /**
	     * Called internally when the effect completes.
	     *
	     * @method Phaser.Cameras.Scene2D.Effects.Flash#effectComplete
	     * @since 3.5.0
	     */
	    effectComplete: function ()
	    {
	        this._onUpdate = null;
	        this._onUpdateScope = null;
	
	        this.isRunning = false;
	
	        this.camera.emit('cameraflashcomplete', this.camera, this);
	    },
	
	    /**
	     * Resets this camera effect.
	     * If it was previously running, it stops instantly without calling its onComplete callback or emitting an event.
	     *
	     * @method Phaser.Cameras.Scene2D.Effects.Flash#reset
	     * @since 3.5.0
	     */
	    reset: function ()
	    {
	        this.isRunning = false;
	
	        this._onUpdate = null;
	        this._onUpdateScope = null;
	    },
	
	    /**
	     * Destroys this effect, releasing it from the Camera.
	     *
	     * @method Phaser.Cameras.Scene2D.Effects.Flash#destroy
	     * @since 3.5.0
	     */
	    destroy: function ()
	    {
	        this.reset();
	
	        this.camera = null;
	    }
	
	});
	
	module.exports = Flash;


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Clamp = __webpack_require__(63);
	var Class = __webpack_require__(1);
	var Vector2 = __webpack_require__(9);
	
	/**
	 * @classdesc
	 * A Camera Shake effect.
	 *
	 * This effect will shake the camera viewport by a random amount, bounded by the specified intensity, each frame.
	 *
	 * Only the camera viewport is moved. None of the objects it is displaying are impacted, i.e. their positions do
	 * not change.
	 *
	 * The effect will dispatch several events on the Camera itself and you can also specify an `onUpdate` callback,
	 * which is invoked each frame for the duration of the effect if required.
	 *
	 * @class Shake
	 * @memberOf Phaser.Cameras.Scene2D.Effects
	 * @constructor
	 * @since 3.5.0
	 *
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera this effect is acting upon.
	 */
	var Shake = new Class({
	
	    initialize:
	
	    function Shake (camera)
	    {
	        /**
	         * The Camera this effect belongs to.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Shake#camera
	         * @type {Phaser.Cameras.Scene2D.Camera}
	         * @readOnly
	         * @since 3.5.0
	         */
	        this.camera = camera;
	
	        /**
	         * Is this effect actively running?
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Shake#isRunning
	         * @type {boolean}
	         * @readOnly
	         * @default false
	         * @since 3.5.0
	         */
	        this.isRunning = false;
	
	        /**
	         * The duration of the effect, in milliseconds.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Shake#duration
	         * @type {integer}
	         * @readOnly
	         * @default 0
	         * @since 3.5.0
	         */
	        this.duration = 0;
	
	        /**
	         * The intensity of the effect. Use small float values. The default when the effect starts is 0.05.
	         * This is a Vector2 object, allowing you to control the shake intensity independently across x and y.
	         * You can modify this value while the effect is active to create more varied shake effects.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Shake#intensity
	         * @type {Phaser.Math.Vector2}
	         * @since 3.5.0
	         */
	        this.intensity = new Vector2();
	
	        /**
	         * If this effect is running this holds the current percentage of the progress, a value between 0 and 1.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Shake#progress
	         * @type {float}
	         * @since 3.5.0
	         */
	        this.progress = 0;
	
	        /**
	         * Effect elapsed timer.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Shake#_elapsed
	         * @type {number}
	         * @private
	         * @since 3.5.0
	         */
	        this._elapsed = 0;
	
	        /**
	         * How much to offset the camera by horizontally.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Shake#_offsetX
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._offsetX = 0;
	
	        /**
	         * How much to offset the camera by vertically.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Shake#_offsetY
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._offsetY = 0;
	
	        /**
	         * @callback CameraShakeCallback
	         *
	         * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera on which the effect is running.
	         * @param {float} progress - The progress of the effect. A value between 0 and 1.
	         */
	
	        /**
	         * This callback is invoked every frame for the duration of the effect.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Shake#_onUpdate
	         * @type {?CameraShakeCallback}
	         * @private
	         * @default null
	         * @since 3.5.0
	         */
	        this._onUpdate;
	
	        /**
	         * On Complete callback scope.
	         *
	         * @name Phaser.Cameras.Scene2D.Effects.Shake#_onUpdateScope
	         * @type {any}
	         * @private
	         * @since 3.5.0
	         */
	        this._onUpdateScope;
	    },
	
	    /**
	     * This event is fired when the shake effect begins to run on a camera.
	     *
	     * @event CameraShakeStartEvent
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
	     * @param {Phaser.Cameras.Scene2D.Effects.Shake} effect - A reference to the effect instance.
	     * @param {integer} duration - The duration of the effect.
	     * @param {float} intensity - The intensity of the effect.
	     */
	
	    /**
	     * This event is fired when the shake effect completes.
	     *
	     * @event CameraShakeCompleteEvent
	     * @param {Phaser.Cameras.Scene2D.Camera} camera - The camera that the effect began on.
	     * @param {Phaser.Cameras.Scene2D.Effects.Shake} effect - A reference to the effect instance.
	     */
	
	    /**
	     * Shakes the Camera by the given intensity over the duration specified.
	     *
	     * @method Phaser.Cameras.Scene2D.Effects.Shake#start
	     * @fires CameraShakeStartEvent
	     * @fires CameraShakeCompleteEvent
	     * @since 3.5.0
	     *
	     * @param {integer} [duration=100] - The duration of the effect in milliseconds.
	     * @param {number} [intensity=0.05] - The intensity of the shake.
	     * @param {boolean} [force=false] - Force the shake effect to start immediately, even if already running.
	     * @param {CameraShakeCallback} [callback] - This callback will be invoked every frame for the duration of the effect.
	     * It is sent two arguments: A reference to the camera and a progress amount between 0 and 1 indicating how complete the effect is.
	     * @param {any} [context] - The context in which the callback is invoked. Defaults to the Scene to which the Camera belongs.
	     *
	     * @return {Phaser.Cameras.Scene2D.Camera} The Camera on which the effect was started.
	     */
	    start: function (duration, intensity, force, callback, context)
	    {
	        if (duration === undefined) { duration = 100; }
	        if (intensity === undefined) { intensity = 0.05; }
	        if (force === undefined) { force = false; }
	        if (callback === undefined) { callback = null; }
	        if (context === undefined) { context = this.camera.scene; }
	
	        if (!force && this.isRunning)
	        {
	            return this.camera;
	        }
	
	        this.isRunning = true;
	        this.duration = duration;
	        this.progress = 0;
	
	        if (typeof intensity === 'number')
	        {
	            this.intensity.set(intensity);
	        }
	        else
	        {
	            this.intensity.set(intensity.x, intensity.y);
	        }
	
	        this._elapsed = 0;
	        this._offsetX = 0;
	        this._offsetY = 0;
	
	        this._onUpdate = callback;
	        this._onUpdateScope = context;
	
	        this.camera.emit('camerashakestart', this.camera, this, duration, intensity);
	
	        return this.camera;
	    },
	
	    /**
	     * The pre-render step for this effect. Called automatically by the Camera.
	     *
	     * @method Phaser.Cameras.Scene2D.Effects.Shake#preRender
	     * @since 3.5.0
	     */
	    preRender: function ()
	    {
	        if (this.isRunning)
	        {
	            this.camera.matrix.translate(this._offsetX, this._offsetY);
	        }
	    },
	
	    /**
	     * The main update loop for this effect. Called automatically by the Camera.
	     *
	     * @method Phaser.Cameras.Scene2D.Effects.Shake#update
	     * @since 3.5.0
	     *
	     * @param {integer} time - The current timestamp as generated by the Request Animation Frame or SetTimeout.
	     * @param {number} delta - The delta time, in ms, elapsed since the last frame.
	     */
	    update: function (time, delta)
	    {
	        if (!this.isRunning)
	        {
	            return;
	        }
	
	        this._elapsed += delta;
	
	        this.progress = Clamp(this._elapsed / this.duration, 0, 1);
	
	        if (this._onUpdate)
	        {
	            this._onUpdate.call(this._onUpdateScope, this.camera, this.progress);
	        }
	
	        if (this._elapsed < this.duration)
	        {
	            var intensity = this.intensity;
	            var width = this.camera.width;
	            var height = this.camera.height;
	            var zoom = this.camera.zoom;
	
	            this._offsetX = (Math.random() * intensity.x * width * 2 - intensity.x * width) * zoom;
	            this._offsetY = (Math.random() * intensity.y * height * 2 - intensity.y * height) * zoom;
	
	            if (this.camera.roundPixels)
	            {
	                this._offsetX |= 0;
	                this._offsetY |= 0;
	            }
	        }
	        else
	        {
	            this.effectComplete();
	        }
	    },
	
	    /**
	     * Called internally when the effect completes.
	     *
	     * @method Phaser.Cameras.Scene2D.Effects.Shake#effectComplete
	     * @since 3.5.0
	     */
	    effectComplete: function ()
	    {
	        this._offsetX = 0;
	        this._offsetY = 0;
	
	        this._onUpdate = null;
	        this._onUpdateScope = null;
	
	        this.isRunning = false;
	
	        this.camera.emit('camerashakecomplete', this.camera, this);
	    },
	
	    /**
	     * Resets this camera effect.
	     * If it was previously running, it stops instantly without calling its onComplete callback or emitting an event.
	     *
	     * @method Phaser.Cameras.Scene2D.Effects.Shake#reset
	     * @since 3.5.0
	     */
	    reset: function ()
	    {
	        this.isRunning = false;
	
	        this._offsetX = 0;
	        this._offsetY = 0;
	
	        this._onUpdate = null;
	        this._onUpdateScope = null;
	    },
	
	    /**
	     * Destroys this effect, releasing it from the Camera.
	     *
	     * @method Phaser.Cameras.Scene2D.Effects.Shake#destroy
	     * @since 3.5.0
	     */
	    destroy: function ()
	    {
	        this.reset();
	
	        this.camera = null;
	        this.intensity = null;
	    }
	
	});
	
	module.exports = Shake;


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Cameras.Scene2D
	 */
	
	module.exports = {
	
	    Camera: __webpack_require__(264),
	    CameraManager: __webpack_require__(1043),
	    Effects: __webpack_require__(447)
	
	};


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Cameras.Controls
	 */
	
	module.exports = {
	
	    /**
	     * This alias will be removed in a future version.
	     * Use `FixedKeyControl` instead.
	     * 
	     * @deprecated
	     * @name Phaser.Cameras.Controls.Fixed
	     */
	    Fixed: __webpack_require__(448),
	
	    FixedKeyControl: __webpack_require__(448),
	
	    /**
	     * This alias will be removed in a future version.
	     * Use `SmoothedKeyControl` instead.
	     * 
	     * @deprecated
	     * @name Phaser.Cameras.Controls.Smoothed
	     */
	    Smoothed: __webpack_require__(449),
	
	    SmoothedKeyControl: __webpack_require__(449)
	
	};


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Cameras
	 */
	
	module.exports = {
	
	    Controls: __webpack_require__(1048),
	    Scene2D: __webpack_require__(1047),
	    Sprite3D: __webpack_require__(1051)
	
	};


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var OrthographicCamera = __webpack_require__(450);
	var PerspectiveCamera = __webpack_require__(451);
	var PluginCache = __webpack_require__(29);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class CameraManager
	 * @memberOf Phaser.Cameras.Sprite3D
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - [description]
	 */
	var CameraManager = new Class({
	
	    initialize:
	
	    function CameraManager (scene)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D.CameraManager#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Cameras.Sprite3D.CameraManager#systems
	         * @type {Phaser.Scenes.Systems}
	         * @since 3.0.0
	         */
	        this.systems = scene.sys;
	
	        /**
	         * An Array of the Camera objects being managed by this Camera Manager.
	         *
	         * @name Phaser.Cameras.Sprite3D.CameraManager#cameras
	         * @type {Phaser.Cameras.Sprite3D.Camera[]}
	         * @since 3.0.0
	         */
	        this.cameras = [];
	
	        scene.sys.events.once('boot', this.boot, this);
	        scene.sys.events.on('start', this.start, this);
	    },
	
	
	    /**
	     * This method is called automatically, only once, when the Scene is first created.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.Cameras.Scene3D.CameraManager#boot
	     * @private
	     * @since 3.5.1
	     */
	    boot: function ()
	    {
	        this.systems.events.once('destroy', this.destroy, this);
	    },
	
	    /**
	     * This method is called automatically by the Scene when it is starting up.
	     * It is responsible for creating local systems, properties and listening for Scene events.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.Cameras.Sprite3D.CameraManager#start
	     * @private
	     * @since 3.5.0
	     */
	    start: function ()
	    {
	        var eventEmitter = this.systems.events;
	
	        eventEmitter.on('update', this.update, this);
	        eventEmitter.once('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.CameraManager#add
	     * @since 3.0.0
	     *
	     * @param {number} [fieldOfView=80] - [description]
	     * @param {number} [width] - [description]
	     * @param {number} [height] - [description]
	     *
	     * @return {Phaser.Cameras.Sprite3D.PerspectiveCamera} [description]
	     */
	    add: function (fieldOfView, width, height)
	    {
	        return this.addPerspectiveCamera(fieldOfView, width, height);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.CameraManager#addOrthographicCamera
	     * @since 3.0.0
	     *
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     *
	     * @return {Phaser.Cameras.Sprite3D.OrthographicCamera} [description]
	     */
	    addOrthographicCamera: function (width, height)
	    {
	        var config = this.scene.sys.game.config;
	
	        if (width === undefined) { width = config.width; }
	        if (height === undefined) { height = config.height; }
	
	        var camera = new OrthographicCamera(this.scene, width, height);
	
	        this.cameras.push(camera);
	
	        return camera;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.CameraManager#addPerspectiveCamera
	     * @since 3.0.0
	     *
	     * @param {number} [fieldOfView=80] - [description]
	     * @param {number} [width] - [description]
	     * @param {number} [height] - [description]
	     *
	     * @return {Phaser.Cameras.Sprite3D.PerspectiveCamera} [description]
	     */
	    addPerspectiveCamera: function (fieldOfView, width, height)
	    {
	        var config = this.scene.sys.game.config;
	
	        if (fieldOfView === undefined) { fieldOfView = 80; }
	        if (width === undefined) { width = config.width; }
	        if (height === undefined) { height = config.height; }
	
	        var camera = new PerspectiveCamera(this.scene, fieldOfView, width, height);
	
	        this.cameras.push(camera);
	
	        return camera;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.CameraManager#getCamera
	     * @since 3.0.0
	     *
	     * @param {string} name - [description]
	     *
	     * @return {(Phaser.Cameras.Sprite3D.OrthographicCamera|Phaser.Cameras.Sprite3D.PerspectiveCamera)} [description]
	     */
	    getCamera: function (name)
	    {
	        for (var i = 0; i < this.cameras.length; i++)
	        {
	            if (this.cameras[i].name === name)
	            {
	                return this.cameras[i];
	            }
	        }
	
	        return null;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.CameraManager#removeCamera
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Cameras.Sprite3D.OrthographicCamera|Phaser.Cameras.Sprite3D.PerspectiveCamera)} camera - [description]
	     */
	    removeCamera: function (camera)
	    {
	        var cameraIndex = this.cameras.indexOf(camera);
	
	        if (cameraIndex !== -1)
	        {
	            this.cameras.splice(cameraIndex, 1);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.CameraManager#removeAll
	     * @since 3.0.0
	     *
	     * @return {(Phaser.Cameras.Sprite3D.OrthographicCamera|Phaser.Cameras.Sprite3D.PerspectiveCamera)} [description]
	     */
	    removeAll: function ()
	    {
	        while (this.cameras.length > 0)
	        {
	            var camera = this.cameras.pop();
	
	            camera.destroy();
	        }
	
	        return this.main;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Cameras.Sprite3D.CameraManager#update
	     * @since 3.0.0
	     *
	     * @param {number} timestep - [description]
	     * @param {number} delta - [description]
	     */
	    update: function (timestep, delta)
	    {
	        for (var i = 0, l = this.cameras.length; i < l; ++i)
	        {
	            this.cameras[i].update(timestep, delta);
	        }
	    },
	
	    /**
	     * The Scene that owns this plugin is shutting down.
	     * We need to kill and reset all internal properties as well as stop listening to Scene events.
	     *
	     * @method Phaser.Cameras.Sprite3D.CameraManager#shutdown
	     * @private
	     * @since 3.0.0
	     */
	    shutdown: function ()
	    {
	        var eventEmitter = this.systems.events;
	
	        eventEmitter.off('update', this.update, this);
	        eventEmitter.off('shutdown', this.shutdown, this);
	
	        this.removeAll();
	    },
	
	    /**
	     * The Scene that owns this plugin is being destroyed.
	     * We need to shutdown and then kill off all external references.
	     *
	     * @method Phaser.Cameras.Sprite3D.CameraManager#destroy
	     * @private
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.shutdown();
	
	        this.scene.sys.events.off('start', this.start, this);
	
	        this.scene = null;
	        this.systems = null;
	    }
	
	});
	
	PluginCache.register('CameraManager3D', CameraManager, 'cameras3d');
	
	module.exports = CameraManager;


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Cameras.Sprite3D
	 */
	
	module.exports = {
	
	    Camera: __webpack_require__(265),
	    CameraManager: __webpack_require__(1050),
	    OrthographicCamera: __webpack_require__(450),
	    PerspectiveCamera: __webpack_require__(451)
	
	};


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Create
	 */
	
	module.exports = {
	  
	    GenerateTexture: __webpack_require__(452),
	    Palettes: __webpack_require__(1057)
	
	};


/***/ }),
/* 1053 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * A 16 color palette inspired by the Commodore 64.
	 *
	 * @name Phaser.Create.Palettes.C64
	 * @since 3.0.0
	 *
	 * @type {Palette}
	 */
	module.exports = {
	    0: '#000',
	    1: '#fff',
	    2: '#8b4131',
	    3: '#7bbdc5',
	    4: '#8b41ac',
	    5: '#6aac41',
	    6: '#3931a4',
	    7: '#d5de73',
	    8: '#945a20',
	    9: '#5a4100',
	    A: '#bd736a',
	    B: '#525252',
	    C: '#838383',
	    D: '#acee8b',
	    E: '#7b73de',
	    F: '#acacac'
	};


/***/ }),
/* 1054 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * A 16 color CGA inspired palette by [Arne](http://androidarts.com/palette/16pal.htm)
	 *
	 * @name Phaser.Create.Palettes.CGA
	 * @since 3.0.0
	 *
	 * @type {Palette}
	 */
	module.exports = {
	    0: '#000',
	    1: '#2234d1',
	    2: '#0c7e45',
	    3: '#44aacc',
	    4: '#8a3622',
	    5: '#5c2e78',
	    6: '#aa5c3d',
	    7: '#b5b5b5',
	    8: '#5e606e',
	    9: '#4c81fb',
	    A: '#6cd947',
	    B: '#7be2f9',
	    C: '#eb8a60',
	    D: '#e23d69',
	    E: '#ffd93f',
	    F: '#fff'
	};


/***/ }),
/* 1055 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * A 16 color JMP palette by [Arne](http://androidarts.com/palette/16pal.htm)
	 *
	 * @name Phaser.Create.Palettes.JMP
	 * @since 3.0.0
	 *
	 * @type {Palette}
	 */
	module.exports = {
	    0: '#000',
	    1: '#191028',
	    2: '#46af45',
	    3: '#a1d685',
	    4: '#453e78',
	    5: '#7664fe',
	    6: '#833129',
	    7: '#9ec2e8',
	    8: '#dc534b',
	    9: '#e18d79',
	    A: '#d6b97b',
	    B: '#e9d8a1',
	    C: '#216c4b',
	    D: '#d365c8',
	    E: '#afaab9',
	    F: '#f5f4eb'
	};


/***/ }),
/* 1056 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * A 16 color palette inspired by Japanese computers like the MSX.
	 *
	 * @name Phaser.Create.Palettes.MSX
	 * @since 3.0.0
	 *
	 * @type {Palette}
	 */
	module.exports = {
	    0: '#000',
	    1: '#191028',
	    2: '#46af45',
	    3: '#a1d685',
	    4: '#453e78',
	    5: '#7664fe',
	    6: '#833129',
	    7: '#9ec2e8',
	    8: '#dc534b',
	    9: '#e18d79',
	    A: '#d6b97b',
	    B: '#e9d8a1',
	    C: '#216c4b',
	    D: '#d365c8',
	    E: '#afaab9',
	    F: '#fff'
	};


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @typedef {object} Palette
	 *
	 * @property {string} 0 - Color value 1.
	 * @property {string} 1 - Color value 2.
	 * @property {string} 2 - Color value 3.
	 * @property {string} 3 - Color value 4.
	 * @property {string} 4 - Color value 5.
	 * @property {string} 5 - Color value 6.
	 * @property {string} 6 - Color value 7.
	 * @property {string} 7 - Color value 8.
	 * @property {string} 8 - Color value 9.
	 * @property {string} 9 - Color value 10.
	 * @property {string} A - Color value 11.
	 * @property {string} B - Color value 12.
	 * @property {string} C - Color value 13.
	 * @property {string} D - Color value 14.
	 * @property {string} E - Color value 15.
	 * @property {string} F - Color value 16.
	 */
	
	/**
	 * @namespace Phaser.Create.Palettes
	 */
	
	module.exports = {
	
	    ARNE16: __webpack_require__(453),
	    C64: __webpack_require__(1053),
	    CGA: __webpack_require__(1054),
	    JMP: __webpack_require__(1055),
	    MSX: __webpack_require__(1056)
	
	};


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Curves
	 */
	
	/**
	 * @typedef {object} JSONCurve
	 *
	 * @property {string} type - The of the curve
	 * @property {number[]} points - The arrays of points like `[x1, y1, x2, y2]`
	 */
	
	module.exports = {
	    Path: __webpack_require__(1060),
	
	    CubicBezier: __webpack_require__(454),
	    Curve: __webpack_require__(133),
	    Ellipse: __webpack_require__(455),
	    Line: __webpack_require__(456),
	    QuadraticBezier: __webpack_require__(457),
	    Spline: __webpack_require__(458)
	};


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Vector2 = __webpack_require__(9);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class MoveTo
	 * @memberOf Phaser.Curves
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {number} [x] - [description]
	 * @param {number} [y] - [description]
	 */
	var MoveTo = new Class({
	
	    initialize:
	
	    function MoveTo (x, y)
	    {
	        //  Skip length calcs in paths
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.MoveTo#active
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.active = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.MoveTo#p0
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.p0 = new Vector2(x, y);
	    },
	
	    /**
	     * Get point at relative position in curve according to length.
	     *
	     * @method Phaser.Curves.MoveTo#getPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {float} t - The position along the curve to return. Where 0 is the start and 1 is the end.
	     * @param {Phaser.Math.Vector2} [out] - A Vector2 object to store the result in. If not given will be created.
	     *
	     * @return {Phaser.Math.Vector2} The coordinates of the point on the curve. If an `out` object was given this will be returned.
	     */
	    getPoint: function (t, out)
	    {
	        if (out === undefined) { out = new Vector2(); }
	
	        return out.copy(this.p0);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.MoveTo#getPointAt
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {float} u - [description]
	     * @param {Phaser.Math.Vector2} [out] - [description]
	     *
	     * @return {Phaser.Math.Vector2} [description]
	     */
	    getPointAt: function (u, out)
	    {
	        return this.getPoint(u, out);
	    },
	
	    /**
	     * Gets the resolution of this curve.
	     *
	     * @method Phaser.Curves.MoveTo#getResolution
	     * @since 3.0.0
	     *
	     * @return {number} The resolution of this curve. For a MoveTo the value is always 1.
	     */
	    getResolution: function ()
	    {
	        return 1;
	    },
	
	    /**
	     * Gets the length of this curve.
	     *
	     * @method Phaser.Curves.MoveTo#getLength
	     * @since 3.0.0
	     *
	     * @return {number} The length of this curve. For a MoveTo the value is always 0.
	     */
	    getLength: function ()
	    {
	        return 0;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.MoveTo#toJSON
	     * @since 3.0.0
	     *
	     * @return {JSONCurve} [description]
	     */
	    toJSON: function ()
	    {
	        return {
	            type: 'MoveTo',
	            points: [
	                this.p0.x, this.p0.y
	            ]
	        };
	    }
	
	});
	
	module.exports = MoveTo;


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  Based on the three.js Curve classes created by [zz85](http://www.lab4games.net/zz85/blog)
	
	var Class = __webpack_require__(1);
	var CubicBezierCurve = __webpack_require__(454);
	var EllipseCurve = __webpack_require__(455);
	var GameObjectFactory = __webpack_require__(18);
	var LineCurve = __webpack_require__(456);
	var MovePathTo = __webpack_require__(1059);
	var QuadraticBezierCurve = __webpack_require__(457);
	var Rectangle = __webpack_require__(23);
	var SplineCurve = __webpack_require__(458);
	var Vector2 = __webpack_require__(9);
	
	/**
	 * @typedef {object} JSONPath
	 *
	 * @property {string} type - The of the curve.
	 * @property {number} x - [description]
	 * @property {number} y - [description]
	 * @property {boolean} autoClose - The path is auto closed.
	 * @property {JSONCurve[]} curves - The list of the curves
	 */
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class Path
	 * @memberOf Phaser.Curves
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {number} [x=0] - [description]
	 * @param {number} [y=0] - [description]
	 */
	var Path = new Class({
	
	    initialize:
	
	    function Path (x, y)
	    {
	        if (x === undefined) { x = 0; }
	        if (y === undefined) { y = 0; }
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.Path#name
	         * @type {string}
	         * @default ''
	         * @since 3.0.0
	         */
	        this.name = '';
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.Path#curves
	         * @type {Phaser.Curves.Curve[]}
	         * @default []
	         * @since 3.0.0
	         */
	        this.curves = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.Path#cacheLengths
	         * @type {number[]}
	         * @default []
	         * @since 3.0.0
	         */
	        this.cacheLengths = [];
	
	        /**
	         * Automatically closes the path.
	         *
	         * @name Phaser.Curves.Path#autoClose
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.autoClose = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.Path#startPoint
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.startPoint = new Vector2();
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.Path#_tmpVec2A
	         * @type {Phaser.Math.Vector2}
	         * @private
	         * @since 3.0.0
	         */
	        this._tmpVec2A = new Vector2();
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Curves.Path#_tmpVec2B
	         * @type {Phaser.Math.Vector2}
	         * @private
	         * @since 3.0.0
	         */
	        this._tmpVec2B = new Vector2();
	
	        if (typeof x === 'object')
	        {
	            this.fromJSON(x);
	        }
	        else
	        {
	            this.startPoint.set(x, y);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Path#add
	     * @since 3.0.0
	     *
	     * @param {Phaser.Curves.Curve} curve - [description]
	     *
	     * @return {Phaser.Curves.Path} [description]
	     */
	    add: function (curve)
	    {
	        this.curves.push(curve);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Path#circleTo
	     * @since 3.0.0
	     *
	     * @param {number} radius - [description]
	     * @param {boolean} [clockwise=false] - [description]
	     * @param {number} [rotation=0] - [description]
	     *
	     * @return {Phaser.Curves.Path} [description]
	     */
	    circleTo: function (radius, clockwise, rotation)
	    {
	        if (clockwise === undefined) { clockwise = false; }
	
	        return this.ellipseTo(radius, radius, 0, 360, clockwise, rotation);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Path#closePath
	     * @since 3.0.0
	     *
	     * @return {Phaser.Curves.Path} [description]
	     */
	    closePath: function ()
	    {
	        // Add a line curve if start and end of lines are not connected
	        var startPoint = this.curves[0].getPoint(0);
	        var endPoint = this.curves[this.curves.length - 1].getPoint(1);
	
	        if (!startPoint.equals(endPoint))
	        {
	            //  This will copy a reference to the vectors, which probably isn't sensible
	            this.curves.push(new LineCurve(endPoint, startPoint));
	        }
	
	        return this;
	    },
	
	    //  Creates a cubic bezier curve starting at the previous end point and ending at p3, using p1 and p2 as control points
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Path#cubicBezierTo
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {Phaser.Math.Vector2} control1X - [description]
	     * @param {Phaser.Math.Vector2} control1Y - [description]
	     * @param {Phaser.Math.Vector2} control2X - [description]
	     * @param {Phaser.Math.Vector2} control2Y - [description]
	     *
	     * @return {Phaser.Curves.Path} [description]
	     */
	    cubicBezierTo: function (x, y, control1X, control1Y, control2X, control2Y)
	    {
	        var p0 = this.getEndPoint();
	        var p1;
	        var p2;
	        var p3;
	
	        //  Assume they're all vec2s
	        if (x instanceof Vector2)
	        {
	            p1 = x;
	            p2 = y;
	            p3 = control1X;
	        }
	        else
	        {
	            p1 = new Vector2(control1X, control1Y);
	            p2 = new Vector2(control2X, control2Y);
	            p3 = new Vector2(x, y);
	        }
	
	        return this.add(new CubicBezierCurve(p0, p1, p2, p3));
	    },
	
	    //  Creates a quadratic bezier curve starting at the previous end point and ending at p2, using p1 as a control point
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Path#quadraticBezierTo
	     * @since 3.2.0
	     *
	     * @param {(number|Phaser.Math.Vector2[])} x - [description]
	     * @param {number} [y] - [description]
	     * @param {number} [controlX] - [description]
	     * @param {number} [controlY] - [description]
	     *
	     * @return {Phaser.Curves.Path} [description]
	     */
	    quadraticBezierTo: function (x, y, controlX, controlY)
	    {
	        var p0 = this.getEndPoint();
	        var p1;
	        var p2;
	
	        //  Assume they're all vec2s
	        if (x instanceof Vector2)
	        {
	            p1 = x;
	            p2 = y;
	        }
	        else
	        {
	            p1 = new Vector2(controlX, controlY);
	            p2 = new Vector2(x, y);
	        }
	
	        return this.add(new QuadraticBezierCurve(p0, p1, p2));
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Path#draw
	     * @since 3.0.0
	     *
	     * @generic {Phaser.GameObjects.Graphics} G - [out,$return]
	     *
	     * @param {Phaser.GameObjects.Graphics} graphics - [description]
	     * @param {integer} [pointsTotal=32] - [description]
	     *
	     * @return {Phaser.GameObjects.Graphics} [description]
	     */
	    draw: function (graphics, pointsTotal)
	    {
	        for (var i = 0; i < this.curves.length; i++)
	        {
	            var curve = this.curves[i];
	
	            if (!curve.active)
	            {
	                continue;
	            }
	
	            curve.draw(graphics, pointsTotal);
	        }
	
	        return graphics;
	    },
	
	    /**
	     * Creates an ellipse curve positioned at the previous end point, using the given parameters.
	     *
	     * @method Phaser.Curves.Path#ellipseTo
	     * @since 3.0.0
	     *
	     * @param {number} xRadius - [description]
	     * @param {number} yRadius - [description]
	     * @param {number} startAngle - [description]
	     * @param {number} endAngle - [description]
	     * @param {boolean} clockwise - [description]
	     * @param {number} rotation - [description]
	     *
	     * @return {Phaser.Curves.Path} [description]
	     */
	    ellipseTo: function (xRadius, yRadius, startAngle, endAngle, clockwise, rotation)
	    {
	        var ellipse = new EllipseCurve(0, 0, xRadius, yRadius, startAngle, endAngle, clockwise, rotation);
	
	        var end = this.getEndPoint(this._tmpVec2A);
	
	        //  Calculate where to center the ellipse
	        var start = ellipse.getStartPoint(this._tmpVec2B);
	
	        end.subtract(start);
	
	        ellipse.x = end.x;
	        ellipse.y = end.y;
	
	        return this.add(ellipse);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Path#fromJSON
	     * @since 3.0.0
	     *
	     * @param {object} data - [description]
	     *
	     * @return {Phaser.Curves.Path} [description]
	     */
	    fromJSON: function (data)
	    {
	        //  data should be an object matching the Path.toJSON object structure.
	
	        this.curves = [];
	        this.cacheLengths = [];
	
	        this.startPoint.set(data.x, data.y);
	
	        this.autoClose = data.autoClose;
	
	        for (var i = 0; i < data.curves.length; i++)
	        {
	            var curve = data.curves[i];
	
	            switch (curve.type)
	            {
	                case 'LineCurve':
	                    this.add(LineCurve.fromJSON(curve));
	                    break;
	
	                case 'EllipseCurve':
	                    this.add(EllipseCurve.fromJSON(curve));
	                    break;
	
	                case 'SplineCurve':
	                    this.add(SplineCurve.fromJSON(curve));
	                    break;
	
	                case 'CubicBezierCurve':
	                    this.add(CubicBezierCurve.fromJSON(curve));
	                    break;
	
	                case 'QuadraticBezierCurve':
	                    this.add(QuadraticBezierCurve.fromJSON(curve));
	                    break;
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Path#getBounds
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {Phaser.Geom.Rectangle} [out] - [description]
	     * @param {integer} [accuracy=16] - [description]
	     *
	     * @return {Phaser.Geom.Rectangle} [description]
	     */
	    getBounds: function (out, accuracy)
	    {
	        if (out === undefined) { out = new Rectangle(); }
	        if (accuracy === undefined) { accuracy = 16; }
	
	        out.x = Number.MAX_VALUE;
	        out.y = Number.MAX_VALUE;
	
	        var bounds = new Rectangle();
	        var maxRight = Number.MIN_SAFE_INTEGER;
	        var maxBottom = Number.MIN_SAFE_INTEGER;
	
	        for (var i = 0; i < this.curves.length; i++)
	        {
	            var curve = this.curves[i];
	
	            if (!curve.active)
	            {
	                continue;
	            }
	
	            curve.getBounds(bounds, accuracy);
	
	            out.x = Math.min(out.x, bounds.x);
	            out.y = Math.min(out.y, bounds.y);
	
	            maxRight = Math.max(maxRight, bounds.right);
	            maxBottom = Math.max(maxBottom, bounds.bottom);
	        }
	
	        out.right = maxRight;
	        out.bottom = maxBottom;
	
	        return out;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Path#getCurveLengths
	     * @since 3.0.0
	     *
	     * @return {number[]} [description]
	     */
	    getCurveLengths: function ()
	    {
	        // We use cache values if curves and cache array are same length
	
	        if (this.cacheLengths.length === this.curves.length)
	        {
	            return this.cacheLengths;
	        }
	
	        // Get length of sub-curve
	        // Push sums into cached array
	
	        var lengths = [];
	        var sums = 0;
	
	        for (var i = 0; i < this.curves.length; i++)
	        {
	            sums += this.curves[i].getLength();
	
	            lengths.push(sums);
	        }
	
	        this.cacheLengths = lengths;
	
	        return lengths;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Path#getEndPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {Phaser.Math.Vector2} [out] - [description]
	     *
	     * @return {Phaser.Math.Vector2} [description]
	     */
	    getEndPoint: function (out)
	    {
	        if (out === undefined) { out = new Vector2(); }
	
	        if (this.curves.length > 0)
	        {
	            this.curves[this.curves.length - 1].getPoint(1, out);
	        }
	        else
	        {
	            out.copy(this.startPoint);
	        }
	
	        return out;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Path#getLength
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    getLength: function ()
	    {
	        var lens = this.getCurveLengths();
	
	        return lens[lens.length - 1];
	    },
	
	    // To get accurate point with reference to
	    // entire path distance at time t,
	    // following has to be done:
	
	    // 1. Length of each sub path have to be known
	    // 2. Locate and identify type of curve
	    // 3. Get t for the curve
	    // 4. Return curve.getPointAt(t')
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Path#getPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {number} t - [description]
	     * @param {Phaser.Math.Vector2} [out] - [description]
	     *
	     * @return {?Phaser.Math.Vector2} [description]
	     */
	    getPoint: function (t, out)
	    {
	        if (out === undefined) { out = new Vector2(); }
	
	        var d = t * this.getLength();
	        var curveLengths = this.getCurveLengths();
	        var i = 0;
	
	        while (i < curveLengths.length)
	        {
	            if (curveLengths[i] >= d)
	            {
	                var diff = curveLengths[i] - d;
	                var curve = this.curves[i];
	
	                var segmentLength = curve.getLength();
	                var u = (segmentLength === 0) ? 0 : 1 - diff / segmentLength;
	
	                return curve.getPointAt(u, out);
	            }
	
	            i++;
	        }
	
	        // loop where sum != 0, sum > d , sum+1 <d
	        return null;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Path#getPoints
	     * @since 3.0.0
	     *
	     * @param {integer} [divisions=12] - [description]
	     *
	     * @return {Phaser.Math.Vector2[]} [description]
	     */
	    getPoints: function (divisions)
	    {
	        if (divisions === undefined) { divisions = 12; }
	
	        var points = [];
	        var last;
	
	        for (var i = 0; i < this.curves.length; i++)
	        {
	            var curve = this.curves[i];
	
	            if (!curve.active)
	            {
	                continue;
	            }
	
	            var resolution = curve.getResolution(divisions);
	
	            var pts = curve.getPoints(resolution);
	
	            for (var j = 0; j < pts.length; j++)
	            {
	                var point = pts[j];
	
	                if (last && last.equals(point))
	                {
	                    // ensures no consecutive points are duplicates
	                    continue;
	                }
	
	                points.push(point);
	
	                last = point;
	            }
	        }
	
	        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0]))
	        {
	            points.push(points[0]);
	        }
	
	        return points;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Path#getRandomPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {Phaser.Math.Vector2} [out] - [description]
	     *
	     * @return {Phaser.Math.Vector2} [description]
	     */
	    getRandomPoint: function (out)
	    {
	        if (out === undefined) { out = new Vector2(); }
	
	        return this.getPoint(Math.random(), out);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Path#getSpacedPoints
	     * @since 3.0.0
	     *
	     * @param {integer} [divisions=40] - [description]
	     *
	     * @return {Phaser.Math.Vector2[]} [description]
	     */
	    getSpacedPoints: function (divisions)
	    {
	        if (divisions === undefined) { divisions = 40; }
	
	        var points = [];
	
	        for (var i = 0; i <= divisions; i++)
	        {
	            points.push(this.getPoint(i / divisions));
	        }
	
	        if (this.autoClose)
	        {
	            points.push(points[0]);
	        }
	
	        return points;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Path#getStartPoint
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [out,$return]
	     *
	     * @param {Phaser.Math.Vector2} [out] - [description]
	     *
	     * @return {Phaser.Math.Vector2} [description]
	     */
	    getStartPoint: function (out)
	    {
	        if (out === undefined) { out = new Vector2(); }
	
	        return out.copy(this.startPoint);
	    },
	
	    //  Creates a line curve from the previous end point to x/y
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Path#lineTo
	     * @since 3.0.0
	     *
	     * @param {(number|Phaser.Math.Vector2)} x - [description]
	     * @param {number} [y] - [description]
	     *
	     * @return {Phaser.Curves.Path} [description]
	     */
	    lineTo: function (x, y)
	    {
	        if (x instanceof Vector2)
	        {
	            this._tmpVec2B.copy(x);
	        }
	        else
	        {
	            this._tmpVec2B.set(x, y);
	        }
	
	        var end = this.getEndPoint(this._tmpVec2A);
	
	        return this.add(new LineCurve([ end.x, end.y, this._tmpVec2B.x, this._tmpVec2B.y ]));
	    },
	
	    //  Creates a spline curve starting at the previous end point, using the given parameters
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Path#splineTo
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector2[]} points - [description]
	     *
	     * @return {Phaser.Curves.Path} [description]
	     */
	    splineTo: function (points)
	    {
	        points.unshift(this.getEndPoint());
	
	        return this.add(new SplineCurve(points));
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Path#moveTo
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     *
	     * @return {Phaser.Curves.Path} [description]
	     */
	    moveTo: function (x, y)
	    {
	        return this.add(new MovePathTo(x, y));
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Path#toJSON
	     * @since 3.0.0
	     *
	     * @return {JSONPath} [description]
	     */
	    toJSON: function ()
	    {
	        var out = [];
	
	        for (var i = 0; i < this.curves.length; i++)
	        {
	            out.push(this.curves[i].toJSON());
	        }
	
	        return {
	            type: 'Path',
	            x: this.startPoint.x,
	            y: this.startPoint.y,
	            autoClose: this.autoClose,
	            curves: out
	        };
	    },
	
	    // cacheLengths must be recalculated.
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Path#updateArcLengths
	     * @since 3.0.0
	     */
	    updateArcLengths: function ()
	    {
	        this.cacheLengths = [];
	
	        this.getCurveLengths();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Curves.Path#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.curves.length = 0;
	        this.cacheLengths.length = 0;
	        this.startPoint = undefined;
	    }
	
	});
	
	/**
	 * Creates a new Path Object.
	 *
	 * @method Phaser.GameObjects.GameObjectFactory#path
	 * @since 3.0.0
	 *
	 * @param {number} x - The horizontal position of this Path.
	 * @param {number} y - The vertical position of this Path.
	 *
	 * @return {Phaser.Curves.Path} The Path Object that was created.
	 */
	GameObjectFactory.register('path', function (x, y)
	{
	    return new Path(x, y);
	});
	
	//  When registering a factory function 'this' refers to the GameObjectFactory context.
	//
	//  There are several properties available to use:
	//
	//  this.scene - a reference to the Scene that owns the GameObjectFactory
	//  this.displayList - a reference to the Display List the Scene owns
	//  this.updateList - a reference to the Update List the Scene owns
	
	module.exports = Path;


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var DataManager = __webpack_require__(194);
	var PluginCache = __webpack_require__(29);
	
	/**
	 * @classdesc
	 * The Data Component features a means to store pieces of data specific to a Game Object, System or Plugin.
	 * You can then search, query it, and retrieve the data. The parent must either extend EventEmitter,
	 * or have a property called `events` that is an instance of it.
	 *
	 * @class DataManagerPlugin
	 * @extends Phaser.Data.DataManager
	 * @memberOf Phaser.Data
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - [description]
	 */
	var DataManagerPlugin = new Class({
	
	    Extends: DataManager,
	
	    initialize:
	
	    function DataManagerPlugin (scene)
	    {
	        DataManager.call(this, scene, scene.sys.events);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Data.DataManagerPlugin#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Data.DataManagerPlugin#systems
	         * @type {Phaser.Scenes.Systems}
	         * @since 3.0.0
	         */
	        this.systems = scene.sys;
	
	        scene.sys.events.once('boot', this.boot, this);
	        scene.sys.events.on('start', this.start, this);
	    },
	
	    /**
	     * This method is called automatically, only once, when the Scene is first created.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.Data.DataManagerPlugin#boot
	     * @private
	     * @since 3.5.1
	     */
	    boot: function ()
	    {
	        this.events = this.systems.events;
	
	        this.events.once('destroy', this.destroy, this);
	    },
	
	    /**
	     * This method is called automatically by the Scene when it is starting up.
	     * It is responsible for creating local systems, properties and listening for Scene events.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.Data.DataManagerPlugin#start
	     * @private
	     * @since 3.5.0
	     */
	    start: function ()
	    {
	        this.events.once('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * The Scene that owns this plugin is shutting down.
	     * We need to kill and reset all internal properties as well as stop listening to Scene events.
	     *
	     * @method Phaser.Data.DataManagerPlugin#shutdown
	     * @private
	     * @since 3.5.0
	     */
	    shutdown: function ()
	    {
	        this.systems.events.off('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * The Scene that owns this plugin is being destroyed.
	     * We need to shutdown and then kill off all external references.
	     *
	     * @method Phaser.Data.DataManagerPlugin#destroy
	     * @since 3.5.0
	     */
	    destroy: function ()
	    {
	        DataManager.prototype.destroy.call(this);
	
	        this.events.off('start', this.start, this);
	
	        this.scene = null;
	        this.systems = null;
	    }
	
	});
	
	PluginCache.register('DataManagerPlugin', DataManagerPlugin, 'data');
	
	module.exports = DataManagerPlugin;


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Data
	 */
	
	module.exports = {
	
	    DataManager: __webpack_require__(194),
	    DataManagerPlugin: __webpack_require__(1061)
	
	};


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Browser = __webpack_require__(195);
	
	/**
	 * Determines the audio playback capabilities of the device running this Phaser Game instance.
	 * These values are read-only and populated during the boot sequence of the game.
	 * They are then referenced by internal game systems and are available for you to access
	 * via `this.sys.game.device.audio` from within any Scene.
	 * 
	 * @typedef {object} Phaser.Device.Audio
	 * @since 3.0.0
	 * 
	 * @property {boolean} audioData - Can this device play HTML Audio tags?
	 * @property {boolean} dolby - Can this device play EC-3 Dolby Digital Plus files?
	 * @property {boolean} m4a - Can this device can play m4a files.
	 * @property {boolean} mp3 - Can this device play mp3 files?
	 * @property {boolean} ogg - Can this device play ogg files?
	 * @property {boolean} opus - Can this device play opus files?
	 * @property {boolean} wav - Can this device play wav files?
	 * @property {boolean} webAudio - Does this device have the Web Audio API?
	 * @property {boolean} webm - Can this device play webm files?
	 */
	var Audio = {
	
	    audioData: false,
	    dolby: false,
	    m4a: false,
	    mp3: false,
	    ogg: false,
	    opus: false,
	    wav: false,
	    webAudio: false,
	    webm: false
	
	};
	
	function init ()
	{
	    Audio.audioData = !!(window['Audio']);
	
	    Audio.webAudio = !!(window['AudioContext'] || window['webkitAudioContext']);
	
	    var audioElement = document.createElement('audio');
	
	    var result = !!audioElement.canPlayType;
	
	    try
	    {
	        if (result)
	        {
	            if (audioElement.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''))
	            {
	                Audio.ogg = true;
	            }
	
	            if (audioElement.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, '') || audioElement.canPlayType('audio/opus;').replace(/^no$/, ''))
	            {
	                Audio.opus = true;
	            }
	
	            if (audioElement.canPlayType('audio/mpeg;').replace(/^no$/, ''))
	            {
	                Audio.mp3 = true;
	            }
	
	            //  Mimetypes accepted:
	            //  developer.mozilla.org/En/Media_formats_supported_by_the_audio_and_video_elements
	            //  bit.ly/iphoneoscodecs
	            if (audioElement.canPlayType('audio/wav; codecs="1"').replace(/^no$/, ''))
	            {
	                Audio.wav = true;
	            }
	
	            if (audioElement.canPlayType('audio/x-m4a;') || audioElement.canPlayType('audio/aac;').replace(/^no$/, ''))
	            {
	                Audio.m4a = true;
	            }
	
	            if (audioElement.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, ''))
	            {
	                Audio.webm = true;
	            }
	
	            if (audioElement.canPlayType('audio/mp4;codecs="ec-3"') !== '')
	            {
	                if (Browser.edge)
	                {
	                    Audio.dolby = true;
	                }
	                else if (Browser.safari && Browser.safariVersion >= 9)
	                {
	                    if ((/Mac OS X (\d+)_(\d+)/).test(navigator.userAgent))
	                    {
	                        var major = parseInt(RegExp.$1, 10);
	                        var minor = parseInt(RegExp.$2, 10);
	
	                        if ((major === 10 && minor >= 11) || major > 10)
	                        {
	                            Audio.dolby = true;
	                        }
	                    }
	                }
	            }
	        }
	    }
	    catch (e)
	    {
	        //  Nothing to do here
	    }
	
	    return Audio;
	}
	
	module.exports = init();


/***/ }),
/* 1064 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Determines the full screen support of the browser running this Phaser Game instance.
	 * These values are read-only and populated during the boot sequence of the game.
	 * They are then referenced by internal game systems and are available for you to access
	 * via `this.sys.game.device.fullscreen` from within any Scene.
	 * 
	 * @typedef {object} Phaser.Device.Fullscreen
	 * @since 3.0.0
	 * 
	 * @property {boolean} available - Does the browser support the Full Screen API?
	 * @property {boolean} keyboard - Does the browser support access to the Keyboard during Full Screen mode?
	 * @property {string} cancel - If the browser supports the Full Screen API this holds the call you need to use to cancel it.
	 * @property {string} request - If the browser supports the Full Screen API this holds the call you need to use to activate it.
	 */
	var Fullscreen = {
	
	    available: false,
	    cancel: '',
	    keyboard: false,
	    request: ''
	
	};
	
	/**
	* Checks for support of the Full Screen API.
	*/
	function init ()
	{
	    var i;
	
	    var fs = [
	        'requestFullscreen',
	        'requestFullScreen',
	        'webkitRequestFullscreen',
	        'webkitRequestFullScreen',
	        'msRequestFullscreen',
	        'msRequestFullScreen',
	        'mozRequestFullScreen',
	        'mozRequestFullscreen'
	    ];
	
	    var element = document.createElement('div');
	
	    for (i = 0; i < fs.length; i++)
	    {
	        if (element[fs[i]])
	        {
	            Fullscreen.available = true;
	            Fullscreen.request = fs[i];
	            break;
	        }
	    }
	
	    var cfs = [
	        'cancelFullScreen',
	        'exitFullscreen',
	        'webkitCancelFullScreen',
	        'webkitExitFullscreen',
	        'msCancelFullScreen',
	        'msExitFullscreen',
	        'mozCancelFullScreen',
	        'mozExitFullscreen'
	    ];
	
	    if (Fullscreen.available)
	    {
	        for (i = 0; i < cfs.length; i++)
	        {
	            if (document[cfs[i]])
	            {
	                Fullscreen.cancel = cfs[i];
	                break;
	            }
	        }
	    }
	
	    //  Keyboard Input?
	    if (window['Element'] && Element['ALLOW_KEYBOARD_INPUT'])
	    {
	        Fullscreen.keyboard = true;
	    }
	
	    return Fullscreen;
	}
	
	module.exports = init();


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var OS = __webpack_require__(157);
	var Browser = __webpack_require__(195);
	
	/**
	 * Determines the input support of the browser running this Phaser Game instance.
	 * These values are read-only and populated during the boot sequence of the game.
	 * They are then referenced by internal game systems and are available for you to access
	 * via `this.sys.game.device.input` from within any Scene.
	 * 
	 * @typedef {object} Phaser.Device.Input
	 * @since 3.0.0
	 * 
	 * @property {?string} wheelType - The newest type of Wheel/Scroll event supported: 'wheel', 'mousewheel', 'DOMMouseScroll'
	 * @property {boolean} gamepads - Is navigator.getGamepads available?
	 * @property {boolean} mspointer - Is mspointer available?
	 * @property {boolean} touch - Is touch available?
	 */
	var Input = {
	
	    gamepads: false,
	    mspointer: false,
	    touch: false,
	    wheelEvent: null
	    
	};
	
	function init ()
	{
	    if ('ontouchstart' in document.documentElement || (navigator.maxTouchPoints && navigator.maxTouchPoints >= 1))
	    {
	        Input.touch = true;
	    }
	
	    if (navigator.msPointerEnabled || navigator.pointerEnabled)
	    {
	        Input.mspointer = true;
	    }
	
	    if (navigator.getGamepads)
	    {
	        Input.gamepads = true;
	    }
	
	    if (!OS.cocoonJS)
	    {
	        // See https://developer.mozilla.org/en-US/docs/Web/Events/wheel
	        if ('onwheel' in window || (Browser.ie && 'WheelEvent' in window))
	        {
	            // DOM3 Wheel Event: FF 17+, IE 9+, Chrome 31+, Safari 7+
	            Input.wheelEvent = 'wheel';
	        }
	        else if ('onmousewheel' in window)
	        {
	            // Non-FF legacy: IE 6-9, Chrome 1-31, Safari 5-7.
	            Input.wheelEvent = 'mousewheel';
	        }
	        else if (Browser.firefox && 'MouseScrollEvent' in window)
	        {
	            // FF prior to 17. This should probably be scrubbed.
	            Input.wheelEvent = 'DOMMouseScroll';
	        }
	    }
	
	    return Input;
	}
	
	module.exports = init();


/***/ }),
/* 1066 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Determines the video support of the browser running this Phaser Game instance.
	 * These values are read-only and populated during the boot sequence of the game.
	 * They are then referenced by internal game systems and are available for you to access
	 * via `this.sys.game.device.video` from within any Scene.
	 * 
	 * @typedef {object} Phaser.Device.Video
	 * @since 3.0.0
	 * 
	 * @property {boolean} h264Video - Can this device play h264 mp4 video files?
	 * @property {boolean} hlsVideo - Can this device play hls video files?
	 * @property {boolean} mp4Video - Can this device play h264 mp4 video files?
	 * @property {boolean} oggVideo - Can this device play ogg video files?
	 * @property {boolean} vp9Video - Can this device play vp9 video files?
	 * @property {boolean} webmVideo - Can this device play webm video files?
	 */
	var Video = {
	
	    h264Video: false,
	    hlsVideo: false,
	    mp4Video: false,
	    oggVideo: false,
	    vp9Video: false,
	    webmVideo: false
	
	};
	
	function init ()
	{
	    var videoElement = document.createElement('video');
	    var result = !!videoElement.canPlayType;
	
	    try
	    {
	        if (result)
	        {
	            if (videoElement.canPlayType('video/ogg; codecs="theora"').replace(/^no$/, ''))
	            {
	                Video.oggVideo = true;
	            }
	
	            if (videoElement.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/, ''))
	            {
	                // Without QuickTime, this value will be `undefined`. github.com/Modernizr/Modernizr/issues/546
	                Video.h264Video = true;
	                Video.mp4Video = true;
	            }
	
	            if (videoElement.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/, ''))
	            {
	                Video.webmVideo = true;
	            }
	
	            if (videoElement.canPlayType('video/webm; codecs="vp9"').replace(/^no$/, ''))
	            {
	                Video.vp9Video = true;
	            }
	
	            if (videoElement.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/, ''))
	            {
	                Video.hlsVideo = true;
	            }
	        }
	    }
	    catch (e)
	    {
	        //  Nothing to do
	    }
	
	    return Video;
	}
	
	module.exports = init();


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  This singleton is instantiated as soon as Phaser loads,
	//  before a Phaser.Game instance has even been created.
	//  Which means all instances of Phaser Games can share it,
	//  without having to re-poll the device all over again
	
	/**
	 * @namespace Phaser.Device
	 * @since 3.0.0
	 */
	
	/**
	 * @typedef {object} Phaser.DeviceConf
	 *
	 * @property {Phaser.Device.OS} os - The OS Device functions.
	 * @property {Phaser.Device.Browser} browser - The Browser Device functions.
	 * @property {Phaser.Device.Features} features - The Features Device functions.
	 * @property {Phaser.Device.Input} input - The Input Device functions.
	 * @property {Phaser.Device.Audio} audio - The Audio Device functions.
	 * @property {Phaser.Device.Video} video - The Video Device functions.
	 * @property {Phaser.Device.Fullscreen} fullscreen - The Fullscreen Device functions.
	 * @property {Phaser.Device.CanvasFeatures} canvasFeatures - The Canvas Device functions.
	 */
	
	module.exports = {
	
	    os: __webpack_require__(157),
	    browser: __webpack_require__(195),
	    features: __webpack_require__(266),
	    input: __webpack_require__(1065),
	    audio: __webpack_require__(1063),
	    video: __webpack_require__(1066),
	    fullscreen: __webpack_require__(1064),
	    canvasFeatures: __webpack_require__(459)
	
	};


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Display.Align.In
	 */
	
	module.exports = {
	
	    BottomCenter: __webpack_require__(460),
	    BottomLeft: __webpack_require__(461),
	    BottomRight: __webpack_require__(462),
	    Center: __webpack_require__(463),
	    LeftCenter: __webpack_require__(464),
	    QuickSet: __webpack_require__(465),
	    RightCenter: __webpack_require__(466),
	    TopCenter: __webpack_require__(467),
	    TopLeft: __webpack_require__(468),
	    TopRight: __webpack_require__(469)
	
	};


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CONST = __webpack_require__(267);
	var Extend = __webpack_require__(36);
	
	/**
	 * @namespace Phaser.Display.Align
	 */
	
	var Align = {
	
	    In: __webpack_require__(1068),
	    To: __webpack_require__(1082)
	
	};
	
	//   Merge in the consts
	Align = Extend(false, Align, CONST);
	
	module.exports = Align;


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetBottom = __webpack_require__(74);
	var GetCenterX = __webpack_require__(134);
	var SetCenterX = __webpack_require__(136);
	var SetTop = __webpack_require__(81);
	
	/**
	 * Takes given Game Object and aligns it so that it is positioned next to the bottom center position of the other.
	 *
	 * @function Phaser.Display.Align.To.BottomCenter
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
	 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
	 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
	 * @param {number} [offsetY=0] - Optional vertical offset from the position.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
	 */
	var BottomCenter = function (gameObject, alignTo, offsetX, offsetY)
	{
	    if (offsetX === undefined) { offsetX = 0; }
	    if (offsetY === undefined) { offsetY = 0; }
	
	    SetCenterX(gameObject, GetCenterX(alignTo) + offsetX);
	    SetTop(gameObject, GetBottom(alignTo) + offsetY);
	
	    return gameObject;
	};
	
	module.exports = BottomCenter;


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetBottom = __webpack_require__(74);
	var GetLeft = __webpack_require__(75);
	var SetLeft = __webpack_require__(79);
	var SetTop = __webpack_require__(81);
	
	/**
	 * Takes given Game Object and aligns it so that it is positioned next to the bottom left position of the other.
	 *
	 * @function Phaser.Display.Align.To.BottomLeft
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
	 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
	 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
	 * @param {number} [offsetY=0] - Optional vertical offset from the position.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
	 */
	var BottomLeft = function (gameObject, alignTo, offsetX, offsetY)
	{
	    if (offsetX === undefined) { offsetX = 0; }
	    if (offsetY === undefined) { offsetY = 0; }
	
	    SetLeft(gameObject, GetLeft(alignTo) - offsetX);
	    SetTop(gameObject, GetBottom(alignTo) + offsetY);
	
	    return gameObject;
	};
	
	module.exports = BottomLeft;


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetBottom = __webpack_require__(74);
	var GetRight = __webpack_require__(76);
	var SetRight = __webpack_require__(80);
	var SetTop = __webpack_require__(81);
	
	/**
	 * Takes given Game Object and aligns it so that it is positioned next to the bottom right position of the other.
	 *
	 * @function Phaser.Display.Align.To.BottomRight
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
	 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
	 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
	 * @param {number} [offsetY=0] - Optional vertical offset from the position.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
	 */
	var BottomRight = function (gameObject, alignTo, offsetX, offsetY)
	{
	    if (offsetX === undefined) { offsetX = 0; }
	    if (offsetY === undefined) { offsetY = 0; }
	
	    SetRight(gameObject, GetRight(alignTo) + offsetX);
	    SetTop(gameObject, GetBottom(alignTo) + offsetY);
	
	    return gameObject;
	};
	
	module.exports = BottomRight;


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetBottom = __webpack_require__(74);
	var GetLeft = __webpack_require__(75);
	var SetBottom = __webpack_require__(78);
	var SetRight = __webpack_require__(80);
	
	/**
	 * Takes given Game Object and aligns it so that it is positioned next to the left bottom position of the other.
	 *
	 * @function Phaser.Display.Align.To.LeftBottom
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
	 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
	 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
	 * @param {number} [offsetY=0] - Optional vertical offset from the position.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
	 */
	var LeftBottom = function (gameObject, alignTo, offsetX, offsetY)
	{
	    if (offsetX === undefined) { offsetX = 0; }
	    if (offsetY === undefined) { offsetY = 0; }
	
	    SetRight(gameObject, GetLeft(alignTo) - offsetX);
	    SetBottom(gameObject, GetBottom(alignTo) + offsetY);
	
	    return gameObject;
	};
	
	module.exports = LeftBottom;


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetCenterY = __webpack_require__(135);
	var GetLeft = __webpack_require__(75);
	var SetCenterY = __webpack_require__(137);
	var SetRight = __webpack_require__(80);
	
	/**
	 * Takes given Game Object and aligns it so that it is positioned next to the left center position of the other.
	 *
	 * @function Phaser.Display.Align.To.LeftCenter
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
	 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
	 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
	 * @param {number} [offsetY=0] - Optional vertical offset from the position.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
	 */
	var LeftCenter = function (gameObject, alignTo, offsetX, offsetY)
	{
	    if (offsetX === undefined) { offsetX = 0; }
	    if (offsetY === undefined) { offsetY = 0; }
	
	    SetRight(gameObject, GetLeft(alignTo) - offsetX);
	    SetCenterY(gameObject, GetCenterY(alignTo) + offsetY);
	
	    return gameObject;
	};
	
	module.exports = LeftCenter;


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetLeft = __webpack_require__(75);
	var GetTop = __webpack_require__(77);
	var SetRight = __webpack_require__(80);
	var SetTop = __webpack_require__(81);
	
	/**
	 * Takes given Game Object and aligns it so that it is positioned next to the left top position of the other.
	 *
	 * @function Phaser.Display.Align.To.LeftTop
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
	 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
	 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
	 * @param {number} [offsetY=0] - Optional vertical offset from the position.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
	 */
	var LeftTop = function (gameObject, alignTo, offsetX, offsetY)
	{
	    if (offsetX === undefined) { offsetX = 0; }
	    if (offsetY === undefined) { offsetY = 0; }
	
	    SetRight(gameObject, GetLeft(alignTo) - offsetX);
	    SetTop(gameObject, GetTop(alignTo) - offsetY);
	
	    return gameObject;
	};
	
	module.exports = LeftTop;


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetBottom = __webpack_require__(74);
	var GetRight = __webpack_require__(76);
	var SetBottom = __webpack_require__(78);
	var SetLeft = __webpack_require__(79);
	
	/**
	 * Takes given Game Object and aligns it so that it is positioned next to the right bottom position of the other.
	 *
	 * @function Phaser.Display.Align.To.RightBottom
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
	 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
	 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
	 * @param {number} [offsetY=0] - Optional vertical offset from the position.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
	 */
	var RightBottom = function (gameObject, alignTo, offsetX, offsetY)
	{
	    if (offsetX === undefined) { offsetX = 0; }
	    if (offsetY === undefined) { offsetY = 0; }
	
	    SetLeft(gameObject, GetRight(alignTo) + offsetX);
	    SetBottom(gameObject, GetBottom(alignTo) + offsetY);
	
	    return gameObject;
	};
	
	module.exports = RightBottom;


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetCenterY = __webpack_require__(135);
	var GetRight = __webpack_require__(76);
	var SetCenterY = __webpack_require__(137);
	var SetLeft = __webpack_require__(79);
	
	/**
	 * Takes given Game Object and aligns it so that it is positioned next to the right center position of the other.
	 *
	 * @function Phaser.Display.Align.To.RightCenter
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
	 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
	 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
	 * @param {number} [offsetY=0] - Optional vertical offset from the position.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
	 */
	var RightCenter = function (gameObject, alignTo, offsetX, offsetY)
	{
	    if (offsetX === undefined) { offsetX = 0; }
	    if (offsetY === undefined) { offsetY = 0; }
	
	    SetLeft(gameObject, GetRight(alignTo) + offsetX);
	    SetCenterY(gameObject, GetCenterY(alignTo) + offsetY);
	
	    return gameObject;
	};
	
	module.exports = RightCenter;


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetRight = __webpack_require__(76);
	var GetTop = __webpack_require__(77);
	var SetLeft = __webpack_require__(79);
	var SetTop = __webpack_require__(81);
	
	/**
	 * Takes given Game Object and aligns it so that it is positioned next to the right top position of the other.
	 *
	 * @function Phaser.Display.Align.To.RightTop
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
	 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
	 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
	 * @param {number} [offsetY=0] - Optional vertical offset from the position.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
	 */
	var RightTop = function (gameObject, alignTo, offsetX, offsetY)
	{
	    if (offsetX === undefined) { offsetX = 0; }
	    if (offsetY === undefined) { offsetY = 0; }
	
	    SetLeft(gameObject, GetRight(alignTo) + offsetX);
	    SetTop(gameObject, GetTop(alignTo) - offsetY);
	
	    return gameObject;
	};
	
	module.exports = RightTop;


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetCenterX = __webpack_require__(134);
	var GetTop = __webpack_require__(77);
	var SetBottom = __webpack_require__(78);
	var SetCenterX = __webpack_require__(136);
	
	/**
	 * Takes given Game Object and aligns it so that it is positioned next to the top center position of the other.
	 *
	 * @function Phaser.Display.Align.To.TopCenter
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
	 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
	 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
	 * @param {number} [offsetY=0] - Optional vertical offset from the position.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
	 */
	var TopCenter = function (gameObject, alignTo, offsetX, offsetY)
	{
	    if (offsetX === undefined) { offsetX = 0; }
	    if (offsetY === undefined) { offsetY = 0; }
	
	    SetCenterX(gameObject, GetCenterX(alignTo) + offsetX);
	    SetBottom(gameObject, GetTop(alignTo) - offsetY);
	
	    return gameObject;
	};
	
	module.exports = TopCenter;


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetLeft = __webpack_require__(75);
	var GetTop = __webpack_require__(77);
	var SetBottom = __webpack_require__(78);
	var SetLeft = __webpack_require__(79);
	
	/**
	 * Takes given Game Object and aligns it so that it is positioned next to the top left position of the other.
	 *
	 * @function Phaser.Display.Align.To.TopLeft
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
	 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
	 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
	 * @param {number} [offsetY=0] - Optional vertical offset from the position.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
	 */
	var TopLeft = function (gameObject, alignTo, offsetX, offsetY)
	{
	    if (offsetX === undefined) { offsetX = 0; }
	    if (offsetY === undefined) { offsetY = 0; }
	
	    SetLeft(gameObject, GetLeft(alignTo) - offsetX);
	    SetBottom(gameObject, GetTop(alignTo) - offsetY);
	
	    return gameObject;
	};
	
	module.exports = TopLeft;


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetRight = __webpack_require__(76);
	var GetTop = __webpack_require__(77);
	var SetBottom = __webpack_require__(78);
	var SetRight = __webpack_require__(80);
	
	/**
	 * Takes given Game Object and aligns it so that it is positioned next to the top right position of the other.
	 *
	 * @function Phaser.Display.Align.To.TopRight
	 * @since 3.0.0
	 *
	 * @generic {Phaser.GameObjects.GameObject} G - [gameObject,$return]
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object that will be positioned.
	 * @param {Phaser.GameObjects.GameObject} alignTo - The Game Object to base the alignment position on.
	 * @param {number} [offsetX=0] - Optional horizontal offset from the position.
	 * @param {number} [offsetY=0] - Optional vertical offset from the position.
	 *
	 * @return {Phaser.GameObjects.GameObject} The Game Object that was aligned.
	 */
	var TopRight = function (gameObject, alignTo, offsetX, offsetY)
	{
	    if (offsetX === undefined) { offsetX = 0; }
	    if (offsetY === undefined) { offsetY = 0; }
	
	    SetRight(gameObject, GetRight(alignTo) + offsetX);
	    SetBottom(gameObject, GetTop(alignTo) - offsetY);
	
	    return gameObject;
	};
	
	module.exports = TopRight;


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Display.Align.To
	 */
	
	module.exports = {
	
	    BottomCenter: __webpack_require__(1070),
	    BottomLeft: __webpack_require__(1071),
	    BottomRight: __webpack_require__(1072),
	    LeftBottom: __webpack_require__(1073),
	    LeftCenter: __webpack_require__(1074),
	    LeftTop: __webpack_require__(1075),
	    RightBottom: __webpack_require__(1076),
	    RightCenter: __webpack_require__(1077),
	    RightTop: __webpack_require__(1078),
	    TopCenter: __webpack_require__(1079),
	    TopLeft: __webpack_require__(1080),
	    TopRight: __webpack_require__(1081)
	
	};


/***/ }),
/* 1083 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Returns the amount the Game Object is visually offset from its x coordinate.
	 * This is the same as `width * origin.x`.
	 * This value will only be > 0 if `origin.x` is not equal to zero.
	 *
	 * @function Phaser.Display.Bounds.GetOffsetX
	 * @since 3.0.0
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
	 *
	 * @return {number} The horizontal offset of the Game Object.
	 */
	var GetOffsetX = function (gameObject)
	{
	    return gameObject.width * gameObject.originX;
	};
	
	module.exports = GetOffsetX;


/***/ }),
/* 1084 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Returns the amount the Game Object is visually offset from its y coordinate.
	 * This is the same as `width * origin.y`.
	 * This value will only be > 0 if `origin.y` is not equal to zero.
	 *
	 * @function Phaser.Display.Bounds.GetOffsetY
	 * @since 3.0.0
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - The Game Object to get the bounds value from.
	 *
	 * @return {number} The vertical offset of the Game Object.
	 */
	var GetOffsetY = function (gameObject)
	{
	    return gameObject.height * gameObject.originY;
	};
	
	module.exports = GetOffsetY;


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Display.Bounds
	 */
	
	module.exports = {
	
	    CenterOn: __webpack_require__(470),
	    GetBottom: __webpack_require__(74),
	    GetCenterX: __webpack_require__(134),
	    GetCenterY: __webpack_require__(135),
	    GetLeft: __webpack_require__(75),
	    GetOffsetX: __webpack_require__(1083),
	    GetOffsetY: __webpack_require__(1084),
	    GetRight: __webpack_require__(76),
	    GetTop: __webpack_require__(77),
	    SetBottom: __webpack_require__(78),
	    SetCenterX: __webpack_require__(136),
	    SetCenterY: __webpack_require__(137),
	    SetLeft: __webpack_require__(79),
	    SetRight: __webpack_require__(80),
	    SetTop: __webpack_require__(81)
	    
	};


/***/ }),
/* 1086 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Sets the touch-action property on the canvas style. Can be used to disable default browser touch actions.
	 *
	 * @function Phaser.Display.Canvas.TouchAction
	 * @since 3.0.0
	 *
	 * @param {HTMLCanvasElement} canvas - The canvas element to have the style applied to.
	 * @param {string} [value='none'] - The touch action value to set on the canvas. Set to `none` to disable touch actions.
	 *
	 * @return {HTMLCanvasElement} The canvas element.
	 */
	var TouchAction = function (canvas, value)
	{
	    if (value === undefined) { value = 'none'; }
	
	    canvas.style['msTouchAction'] = value;
	    canvas.style['ms-touch-action'] = value;
	    canvas.style['touch-action'] = value;
	
	    return canvas;
	};
	
	module.exports = TouchAction;


/***/ }),
/* 1087 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Sets the user-select property on the canvas style. Can be used to disable default browser selection actions.
	 *
	 * @function Phaser.Display.Canvas.UserSelect
	 * @since 3.0.0
	 *
	 * @param {HTMLCanvasElement} canvas - The canvas element to have the style applied to.
	 * @param {string} [value='none'] - The touch callout value to set on the canvas. Set to `none` to disable touch callouts.
	 *
	 * @return {HTMLCanvasElement} The canvas element.
	 */
	var UserSelect = function (canvas, value)
	{
	    if (value === undefined) { value = 'none'; }
	
	    var vendors = [
	        '-webkit-',
	        '-khtml-',
	        '-moz-',
	        '-ms-',
	        ''
	    ];
	
	    vendors.forEach(function (vendor)
	    {
	        canvas.style[vendor + 'user-select'] = value;
	    });
	
	    canvas.style['-webkit-touch-callout'] = value;
	    canvas.style['-webkit-tap-highlight-color'] = 'rgba(0, 0, 0, 0)';
	
	    return canvas;
	};
	
	module.exports = UserSelect;


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Display.Canvas
	 */
	
	module.exports = {
	
	    Interpolation: __webpack_require__(471),
	    Pool: __webpack_require__(56),
	    Smoothing: __webpack_require__(268),
	    TouchAction: __webpack_require__(1086),
	    UserSelect: __webpack_require__(1087)
	    
	};


/***/ }),
/* 1089 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Converts the given color value into an Object containing r,g,b and a properties.
	 *
	 * @function Phaser.Display.Color.ColorToRGBA
	 * @since 3.0.0
	 *
	 * @param {number} color - A color value, optionally including the alpha value.
	 *
	 * @return {ColorObject} An object containing the parsed color values.
	 */
	var ColorToRGBA = function (color)
	{
	    var output = {
	        r: color >> 16 & 0xFF,
	        g: color >> 8 & 0xFF,
	        b: color & 0xFF,
	        a: 255
	    };
	
	    if (color > 16777215)
	    {
	        output.a = color >>> 24;
	    }
	
	    return output;
	};
	
	module.exports = ColorToRGBA;


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Color = __webpack_require__(95);
	var HueToComponent = __webpack_require__(476);
	
	/**
	 * Converts HSL (hue, saturation and lightness) values to a Phaser Color object.
	 *
	 * @function Phaser.Display.Color.HSLToColor
	 * @since 3.0.0
	 *
	 * @param {number} h - The hue value in the range 0 to 1.
	 * @param {number} s - The saturation value in the range 0 to 1.
	 * @param {number} l - The lightness value in the range 0 to 1.
	 *
	 * @return {Phaser.Display.Color} A Color object created from the results of the h, s and l values.
	 */
	var HSLToColor = function (h, s, l)
	{
	    // achromatic by default
	    var r = l;
	    var g = l;
	    var b = l;
	
	    if (s !== 0)
	    {
	        var q = (l < 0.5) ? l * (1 + s) : l + s - l * s;
	        var p = 2 * l - q;
	
	        r = HueToComponent(p, q, h + 1 / 3);
	        g = HueToComponent(p, q, h);
	        b = HueToComponent(p, q, h - 1 / 3);
	    }
	
	    var color = new Color();
	
	    return color.setGLTo(r, g, b, 1);
	};
	
	module.exports = HSLToColor;


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var HSVToRGB = __webpack_require__(474);
	
	/**
	 * Get HSV color wheel values in an array which will be 360 elements in size.
	 *
	 * @function Phaser.Display.Color.HSVColorWheel
	 * @since 3.0.0
	 *
	 * @param {number} [s=1] - The saturation, in the range 0 - 1.
	 * @param {number} [v=1] - The value, in the range 0 - 1.
	 *
	 * @return {array} An array containing 360 elements, where each contains a single numeric value corresponding to the color at that point in the HSV color wheel.
	 */
	var HSVColorWheel = function (s, v)
	{
	    if (s === undefined) { s = 1; }
	    if (v === undefined) { v = 1; }
	
	    var colors = [];
	
	    for (var c = 0; c <= 359; c++)
	    {
	        colors.push(HSVToRGB(c / 359, s, v));
	    }
	
	    return colors;
	};
	
	module.exports = HSVColorWheel;


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Linear = __webpack_require__(306);
	
	/**
	 * Interpolates color values
	 *
	 * @namespace Phaser.Display.Color.Interpolate
	 * @since 3.0.0
	 */
	
	/**
	 * Interpolates between the two given color ranges over the length supplied.
	 *
	 * @function Phaser.Display.Color.Interpolate.RGBWithRGB
	 * @since 3.0.0
	 *
	 * @param {number} r1 - Red value.
	 * @param {number} g1 - Blue value.
	 * @param {number} b1 - Green value.
	 * @param {number} r2 - Red value.
	 * @param {number} g2 - Blue value.
	 * @param {number} b2 - Green value.
	 * @param {number} [length=100] - Distance to interpolate over.
	 * @param {number} [index=0] - Index to start from.
	 *
	 * @return {ColorObject} An object containing the interpolated color values.
	 */
	var RGBWithRGB = function (r1, g1, b1, r2, g2, b2, length, index)
	{
	    if (length === undefined) { length = 100; }
	    if (index === undefined) { index = 0; }
	
	    var t = index / length;
	
	    return {
	        r: Linear(r1, r2, t),
	        g: Linear(g1, g2, t),
	        b: Linear(b1, b2, t)
	    };
	};
	
	/**
	 * Interpolates between the two given color objects over the length supplied.
	 *
	 * @function Phaser.Display.Color.Interpolate.ColorWithColor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Display.Color} color1 - The first Color object.
	 * @param {Phaser.Display.Color} color2 - The second Color object.
	 * @param {number} [length=100] - Distance to interpolate over.
	 * @param {number} [index=0] - Index to start from.
	 *
	 * @return {ColorObject} An object containing the interpolated color values.
	 */
	var ColorWithColor = function (color1, color2, length, index)
	{
	    if (length === undefined) { length = 100; }
	    if (index === undefined) { index = 0; }
	
	    return RGBWithRGB(color1.r, color1.g, color1.b, color2.r, color2.g, color2.b, length, index);
	};
	
	/**
	 * Interpolates between the Color object and color values over the length supplied.
	 *
	 * @function Phaser.Display.Color.Interpolate.ColorWithRGB
	 * @since 3.0.0
	 *
	 * @param {Phaser.Display.Color} color1 - The first Color object.
	 * @param {number} r - Red value.
	 * @param {number} g - Blue value.
	 * @param {number} b - Green value.
	 * @param {number} [length=100] - Distance to interpolate over.
	 * @param {number} [index=0] - Index to start from.
	 *
	 * @return {ColorObject} An object containing the interpolated color values.
	 */
	var ColorWithRGB = function (color, r, g, b, length, index)
	{
	    if (length === undefined) { length = 100; }
	    if (index === undefined) { index = 0; }
	
	    return RGBWithRGB(color.r, color.g, color.b, r, g, b, length, index);
	};
	
	module.exports = {
	
	    RGBWithRGB: RGBWithRGB,
	    ColorWithRGB: ColorWithRGB,
	    ColorWithColor: ColorWithColor
	
	};


/***/ }),
/* 1093 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @typedef {object} HSLColorObject
	 *
	 * @property {number} h - The hue color value. A number between 0 and 1
	 * @property {number} s - The saturation color value. A number between 0 and 1
	 * @property {number} l - The lightness color value. A number between 0 and 1
	 */
	
	/**
	 * Converts an RGB color value to HSV (hue, saturation and value).
	 * Conversion forumla from http://en.wikipedia.org/wiki/HSL_color_space.
	 * Assumes RGB values are contained in the set [0, 255] and returns h, s and v in the set [0, 1].
	 * Based on code by Michael Jackson (https://github.com/mjijackson)
	 *
	 * @function Phaser.Display.Color.RGBToHSV
	 * @since 3.0.0
	 *
	 * @param {integer} r - The red color value. A number between 0 and 255.
	 * @param {integer} g - The green color value. A number between 0 and 255.
	 * @param {integer} b - The blue color value. A number between 0 and 255.
	 *
	 * @return {HSLColorObject} An object with the properties `h`, `s` and `v`.
	 */
	var RGBToHSV = function (r, g, b)
	{
	    r /= 255;
	    g /= 255;
	    b /= 255;
	
	    var min = Math.min(r, g, b);
	    var max = Math.max(r, g, b);
	    var d = max - min;
	
	    // achromatic by default
	    var h = 0;
	    var s = (max === 0) ? 0 : d / max;
	    var v = max;
	
	    if (max !== min)
	    {
	        if (max === r)
	        {
	            h = (g - b) / d + ((g < b) ? 6 : 0);
	        }
	        else if (max === g)
	        {
	            h = (b - r) / d + 2;
	        }
	        else if (max === b)
	        {
	            h = (r - g) / d + 4;
	        }
	
	        h /= 6;
	    }
	
	    return { h: h, s: s, v: v };
	};
	
	module.exports = RGBToHSV;


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var ComponentToHex = __webpack_require__(472);
	
	/**
	 * Converts the color values into an HTML compatible color string, prefixed with either `#` or `0x`.
	 *
	 * @function Phaser.Display.Color.RGBToString
	 * @since 3.0.0
	 *
	 * @param {integer} r - The red color value. A number between 0 and 255.
	 * @param {integer} g - The green color value. A number between 0 and 255.
	 * @param {integer} b - The blue color value. A number between 0 and 255.
	 * @param {integer} [a=255] - The alpha value. A number between 0 and 255.
	 * @param {string} [prefix=#] - The prefix of the string. Either `#` or `0x`.
	 *
	 * @return {string} A string-based representation of the color values.
	 */
	var RGBToString = function (r, g, b, a, prefix)
	{
	    if (a === undefined) { a = 255; }
	    if (prefix === undefined) { prefix = '#'; }
	
	    if (prefix === '#')
	    {
	        return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
	    }
	    else
	    {
	        return '0x' + ComponentToHex(a) + ComponentToHex(r) + ComponentToHex(g) + ComponentToHex(b);
	    }
	};
	
	module.exports = RGBToString;


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Between = __webpack_require__(549);
	var Color = __webpack_require__(95);
	
	/**
	 * Creates a new Color object where the r, g, and b values have been set to random values
	 * based on the given min max values.
	 *
	 * @function Phaser.Display.Color.RandomRGB
	 * @since 3.0.0
	 *
	 * @param {integer} [min=0] - The minimum value to set the random range from (between 0 and 255)
	 * @param {integer} [max=255] - The maximum value to set the random range from (between 0 and 255)
	 *
	 * @return {Phaser.Display.Color} A Color object.
	 */
	var RandomRGB = function (min, max)
	{
	    if (min === undefined) { min = 0; }
	    if (max === undefined) { max = 255; }
	
	    return new Color(Between(min, max), Between(min, max), Between(min, max));
	};
	
	module.exports = RandomRGB;


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Display
	 */
	
	module.exports = {
	
	    Align: __webpack_require__(1069),
	    Bounds: __webpack_require__(1085),
	    Canvas: __webpack_require__(1088),
	    Color: __webpack_require__(481),
	    Masks: __webpack_require__(1097)
	  
	};


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Display.Masks
	 */
	
	module.exports = {
	
	    BitmapMask: __webpack_require__(482),
	    GeometryMask: __webpack_require__(483)
	
	};


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.DOM
	 */
	
	module.exports = {
	
	    AddToDOM: __webpack_require__(271),
	    DOMContentLoaded: __webpack_require__(484),
	    ParseXML: __webpack_require__(485),
	    RemoveFromDOM: __webpack_require__(486),
	    RequestAnimationFrame: __webpack_require__(487)
	
	};


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var EE = __webpack_require__(22);
	var PluginCache = __webpack_require__(29);
	
	/**
	 * @classdesc
	 * EventEmitter is a Scene Systems plugin compatible version of eventemitter3.
	 *
	 * @class EventEmitter
	 * @memberOf Phaser.Events
	 * @constructor
	 * @since 3.0.0
	 */
	var EventEmitter = new Class({
	
	    Extends: EE,
	
	    initialize:
	
	    function EventEmitter ()
	    {
	        EE.call(this);
	    },
	
	    /**
	     * Removes all listeners.
	     *
	     * @method Phaser.Events.EventEmitter#shutdown
	     * @since 3.0.0
	     */
	    shutdown: function ()
	    {
	        this.removeAllListeners();
	    },
	
	    /**
	     * Removes all listeners.
	     *
	     * @method Phaser.Events.EventEmitter#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.removeAllListeners();
	    }
	
	});
	
	/**
	 * Return an array listing the events for which the emitter has registered listeners.
	 *
	 * @method Phaser.Events.EventEmitter#eventNames
	 * @since 3.0.0
	 *
	 * @return {array}
	 */
	
	/**
	 * Return the listeners registered for a given event.
	 *
	 * @method Phaser.Events.EventEmitter#listeners
	 * @since 3.0.0
	 *
	 * @param {(string|symbol)} event - The event name.
	 *
	 * @return {array} The registered listeners.
	 */
	
	/**
	 * Return the number of listeners listening to a given event.
	 *
	 * @method Phaser.Events.EventEmitter#listenerCount
	 * @since 3.0.0
	 *
	 * @param {(string|symbol)} event - The event name.
	 *
	 * @return {number} The number of listeners.
	 */
	
	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @method Phaser.Events.EventEmitter#emit
	 * @since 3.0.0
	 *
	 * @param {(string|symbol)} event - The event name.
	 * @param {...*} [args] - Additional arguments that will be passed to the event handler.
	 *
	 * @return {boolean} `true` if the event had listeners, else `false`.
	 */
	
	/**
	 * Add a listener for a given event.
	 *
	 * @method Phaser.Events.EventEmitter#on
	 * @since 3.0.0
	 *
	 * @param {(string|symbol)} event - The event name.
	 * @param {function} fn - The listener function.
	 * @param {*} [context=this] - The context to invoke the listener with.
	 *
	 * @return {Phaser.Events.EventEmitter} `this`.
	 */
	
	/**
	 * Add a listener for a given event.
	 *
	 * @method Phaser.Events.EventEmitter#addListener
	 * @since 3.0.0
	 *
	 * @param {(string|symbol)} event - The event name.
	 * @param {function} fn - The listener function.
	 * @param {*} [context=this] - The context to invoke the listener with.
	 *
	 * @return {Phaser.Events.EventEmitter} `this`.
	 */
	
	/**
	 * Add a one-time listener for a given event.
	 *
	 * @method Phaser.Events.EventEmitter#once
	 * @since 3.0.0
	 *
	 * @param {(string|symbol)} event - The event name.
	 * @param {function} fn - The listener function.
	 * @param {*} [context=this] - The context to invoke the listener with.
	 *
	 * @return {Phaser.Events.EventEmitter} `this`.
	 */
	
	/**
	 * Remove the listeners of a given event.
	 *
	 * @method Phaser.Events.EventEmitter#removeListener
	 * @since 3.0.0
	 *
	 * @param {(string|symbol)} event - The event name.
	 * @param {function} fn - Only remove the listeners that match this function.
	 * @param {*} context - Only remove the listeners that have this context.
	 * @param {boolean} once - Only remove one-time listeners.
	 *
	 * @return {Phaser.Events.EventEmitter} `this`.
	 */
	
	/**
	 * Remove the listeners of a given event.
	 *
	 * @method Phaser.Events.EventEmitter#off
	 * @since 3.0.0
	 *
	 * @param {(string|symbol)} event - The event name.
	 * @param {function} fn - Only remove the listeners that match this function.
	 * @param {*} context - Only remove the listeners that have this context.
	 * @param {boolean} once - Only remove one-time listeners.
	 *
	 * @return {Phaser.Events.EventEmitter} `this`.
	 */
	
	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @method Phaser.Events.EventEmitter#removeAllListeners
	 * @since 3.0.0
	 *
	 * @param {(string|symbol)} [event] - The event name.
	 *
	 * @return {Phaser.Events.EventEmitter} `this`.
	 */
	
	PluginCache.register('EventEmitter', EventEmitter, 'events');
	
	module.exports = EventEmitter;


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Events
	 */
	
	module.exports = { EventEmitter: __webpack_require__(1099) };


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var List = __webpack_require__(210);
	var PluginCache = __webpack_require__(29);
	var StableSort = __webpack_require__(219);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class DisplayList
	 * @extends Phaser.Structs.List.<Phaser.GameObjects.GameObject>
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - [description]
	 */
	var DisplayList = new Class({
	
	    Extends: List,
	
	    initialize:
	
	    function DisplayList (scene)
	    {
	        List.call(this, scene);
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.DisplayList#sortChildrenFlag
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.sortChildrenFlag = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.DisplayList#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.DisplayList#systems
	         * @type {Phaser.Scenes.Systems}
	         * @since 3.0.0
	         */
	        this.systems = scene.sys;
	
	        scene.sys.events.once('boot', this.boot, this);
	        scene.sys.events.on('start', this.start, this);
	    },
	
	    /**
	     * This method is called automatically, only once, when the Scene is first created.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.GameObjects.DisplayList#boot
	     * @private
	     * @since 3.5.1
	     */
	    boot: function ()
	    {
	        this.systems.events.once('destroy', this.destroy, this);
	    },
	
	    /**
	     * This method is called automatically by the Scene when it is starting up.
	     * It is responsible for creating local systems, properties and listening for Scene events.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.GameObjects.DisplayList#start
	     * @private
	     * @since 3.5.0
	     */
	    start: function ()
	    {
	        this.systems.events.once('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * Force a sort of the display list on the next call to depthSort.
	     *
	     * @method Phaser.GameObjects.DisplayList#queueDepthSort
	     * @since 3.0.0
	     */
	    queueDepthSort: function ()
	    {
	        this.sortChildrenFlag = true;
	    },
	
	    /**
	     * Immediately sorts the display list if the flag is set.
	     *
	     * @method Phaser.GameObjects.DisplayList#depthSort
	     * @since 3.0.0
	     */
	    depthSort: function ()
	    {
	        if (this.sortChildrenFlag)
	        {
	            StableSort.inplace(this.list, this.sortByDepth);
	
	            this.sortChildrenFlag = false;
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.DisplayList#sortByDepth
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} childA - [description]
	     * @param {Phaser.GameObjects.GameObject} childB - [description]
	     *
	     * @return {integer} [description]
	     */
	    sortByDepth: function (childA, childB)
	    {
	        return childA._depth - childB._depth;
	    },
	
	    /**
	     * Given an array of Game Objects, sort the array and return it,
	     * so that the objects are in index order with the lowest at the bottom.
	     *
	     * @method Phaser.GameObjects.DisplayList#sortGameObjects
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject[]} gameObjects - [description]
	     *
	     * @return {array} [description]
	     */
	    sortGameObjects: function (gameObjects)
	    {
	        if (gameObjects === undefined) { gameObjects = this.list; }
	
	        this.scene.sys.depthSort();
	
	        return gameObjects.sort(this.sortIndexHandler.bind(this));
	    },
	
	    /**
	     * Note that the given array is sorted in place, even though it isn't returned directly it will still be updated.
	     *
	     * @method Phaser.GameObjects.DisplayList#getTopGameObject
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject[]} gameObjects - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} The top-most Game Object on the Display List.
	     */
	    getTopGameObject: function (gameObjects)
	    {
	        this.sortGameObjects(gameObjects);
	
	        return gameObjects[gameObjects.length - 1];
	    },
	
	    /**
	     * The Scene that owns this plugin is shutting down.
	     * We need to kill and reset all internal properties as well as stop listening to Scene events.
	     *
	     * @method Phaser.GameObjects.DisplayList#shutdown
	     * @private
	     * @since 3.0.0
	     */
	    shutdown: function ()
	    {
	        this.removeAll();
	
	        this.systems.events.off('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * The Scene that owns this plugin is being destroyed.
	     * We need to shutdown and then kill off all external references.
	     *
	     * @method Phaser.GameObjects.DisplayList#destroy
	     * @private
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.shutdown();
	
	        this.scene.sys.events.off('start', this.start, this);
	
	        this.scene = null;
	        this.systems = null;
	    }
	
	});
	
	PluginCache.register('DisplayList', DisplayList, 'displayList');
	
	module.exports = DisplayList;


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var PluginCache = __webpack_require__(29);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class UpdateList
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - [description]
	 */
	var UpdateList = new Class({
	
	    initialize:
	
	    function UpdateList (scene)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.UpdateList#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.UpdateList#systems
	         * @type {Phaser.Scenes.Systems}
	         * @since 3.0.0
	         */
	        this.systems = scene.sys;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.UpdateList#_list
	         * @type {array}
	         * @private
	         * @default []
	         * @since 3.0.0
	         */
	        this._list = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.UpdateList#_pendingInsertion
	         * @type {array}
	         * @private
	         * @default []
	         * @since 3.0.0
	         */
	        this._pendingInsertion = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.UpdateList#_pendingRemoval
	         * @type {array}
	         * @private
	         * @default []
	         * @since 3.0.0
	         */
	        this._pendingRemoval = [];
	
	        scene.sys.events.once('boot', this.boot, this);
	        scene.sys.events.on('start', this.start, this);
	    },
	
	    /**
	     * This method is called automatically, only once, when the Scene is first created.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.GameObjects.UpdateList#boot
	     * @private
	     * @since 3.5.1
	     */
	    boot: function ()
	    {
	        this.systems.events.once('destroy', this.destroy, this);
	    },
	
	    /**
	     * This method is called automatically by the Scene when it is starting up.
	     * It is responsible for creating local systems, properties and listening for Scene events.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.GameObjects.UpdateList#start
	     * @private
	     * @since 3.5.0
	     */
	    start: function ()
	    {
	        var eventEmitter = this.systems.events;
	
	        eventEmitter.on('preupdate', this.preUpdate, this);
	        eventEmitter.on('update', this.update, this);
	        eventEmitter.once('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.UpdateList#add
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} child - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} [description]
	     */
	    add: function (child)
	    {
	        //  Is child already in this list?
	
	        if (this._list.indexOf(child) === -1 && this._pendingInsertion.indexOf(child) === -1)
	        {
	            this._pendingInsertion.push(child);
	        }
	
	        return child;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.UpdateList#preUpdate
	     * @since 3.0.0
	     *
	     * @param {number} time - [description]
	     * @param {number} delta - [description]
	     */
	    preUpdate: function ()
	    {
	        var toRemove = this._pendingRemoval.length;
	        var toInsert = this._pendingInsertion.length;
	
	        if (toRemove === 0 && toInsert === 0)
	        {
	            //  Quick bail
	            return;
	        }
	
	        var i;
	        var gameObject;
	
	        //  Delete old gameObjects
	        for (i = 0; i < toRemove; i++)
	        {
	            gameObject = this._pendingRemoval[i];
	
	            var index = this._list.indexOf(gameObject);
	
	            if (index > -1)
	            {
	                this._list.splice(index, 1);
	            }
	        }
	
	        //  Move pending to active
	        this._list = this._list.concat(this._pendingInsertion.splice(0));
	
	        //  Clear the lists
	        this._pendingRemoval.length = 0;
	        this._pendingInsertion.length = 0;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.UpdateList#update
	     * @since 3.0.0
	     *
	     * @param {number} time - [description]
	     * @param {number} delta - [description]
	     */
	    update: function (time, delta)
	    {
	        for (var i = 0; i < this._list.length; i++)
	        {
	            var gameObject = this._list[i];
	
	            if (gameObject.active)
	            {
	                gameObject.preUpdate.call(gameObject, time, delta);
	            }
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.UpdateList#remove
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} child - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} [description]
	     */
	    remove: function (child)
	    {
	        var index = this._list.indexOf(child);
	
	        if (index !== -1)
	        {
	            this._list.splice(index, 1);
	        }
	        
	        return child;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.UpdateList#removeAll
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.UpdateList} The UpdateList object.
	     */
	    removeAll: function ()
	    {
	        var i = this._list.length;
	
	        while (i--)
	        {
	            this.remove(this._list[i]);
	        }
	
	        return this;
	    },
	
	    /**
	     * The Scene that owns this plugin is shutting down.
	     * We need to kill and reset all internal properties as well as stop listening to Scene events.
	     *
	     * @method Phaser.GameObjects.UpdateList#shutdown
	     * @since 3.0.0
	     */
	    shutdown: function ()
	    {
	        this.removeAll();
	
	        this._list.length = 0;
	        this._pendingRemoval.length = 0;
	        this._pendingInsertion.length = 0;
	
	        var eventEmitter = this.systems.events;
	
	        eventEmitter.off('preupdate', this.preUpdate, this);
	        eventEmitter.off('update', this.update, this);
	        eventEmitter.off('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * The Scene that owns this plugin is being destroyed.
	     * We need to shutdown and then kill off all external references.
	     *
	     * @method Phaser.GameObjects.UpdateList#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.shutdown();
	
	        this.scene.sys.events.off('start', this.start, this);
	
	        this.scene = null;
	        this.systems = null;
	    }
	
	});
	
	PluginCache.register('UpdateList', UpdateList, 'updateList');
	
	module.exports = UpdateList;


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var ParseXMLBitmapFont = __webpack_require__(489);
	
	/**
	 * [description]
	 *
	 * @function ParseFromAtlas
	 * @since 3.0.0
	 * @private
	 */
	var ParseFromAtlas = function (scene, fontName, textureKey, frameKey, xmlKey, xSpacing, ySpacing)
	{
	    var frame = scene.sys.textures.getFrame(textureKey, frameKey);
	    var xml = scene.sys.cache.xml.get(xmlKey);
	
	    if (frame && xml)
	    {
	        var data = ParseXMLBitmapFont(xml, xSpacing, ySpacing, frame);
	
	        scene.sys.cache.bitmapFont.add(fontName, { data: data, texture: textureKey, frame: frameKey });
	
	        return true;
	    }
	    else
	    {
	        return false;
	    }
	};
	
	module.exports = ParseFromAtlas;


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetValue = __webpack_require__(10);
	
	/**
	 * Parses a Retro Font configuration object so you can pass it to the BitmapText constructor
	 * and create a BitmapText object using a fixed-width retro font.
	 *
	 * @function Phaser.GameObjects.RetroFont.Parse
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - A reference to the Phaser Scene.
	 * @param {Phaser.GameObjects.RetroFont.Config} config - The font configuration object.
	 */
	var ParseRetroFont = function (scene, config)
	{
	    var w = config.width;
	    var h = config.height;
	    var cx = Math.floor(w / 2);
	    var cy = Math.floor(h / 2);
	    var letters = GetValue(config, 'chars', '');
	
	    if (letters === '')
	    {
	        return;
	    }
	
	    var key = GetValue(config, 'image', '');
	    var offsetX = GetValue(config, 'offset.x', 0);
	    var offsetY = GetValue(config, 'offset.y', 0);
	    var spacingX = GetValue(config, 'spacing.x', 0);
	    var spacingY = GetValue(config, 'spacing.y', 0);
	
	    var charsPerRow = GetValue(config, 'charsPerRow', null);
	
	    if (charsPerRow === null)
	    {
	        charsPerRow = scene.sys.textures.getFrame(key).width / w;
	
	        if (charsPerRow > letters.length)
	        {
	            charsPerRow = letters.length;
	        }
	    }
	
	    var x = offsetX;
	    var y = offsetY;
	
	    var data = {
	        retroFont: true,
	        font: key,
	        size: w,
	        lineHeight: h,
	        chars: {}
	    };
	
	    var r = 0;
	
	    for (var i = 0; i < letters.length; i++)
	    {
	        // var node = letters[i];
	
	        var charCode = letters.charCodeAt(i);
	
	        data.chars[charCode] =
	        {
	            x: x,
	            y: y,
	            width: w,
	            height: h,
	            centerX: cx,
	            centerY: cy,
	            xOffset: 0,
	            yOffset: 0,
	            xAdvance: w,
	            data: {},
	            kerning: {}
	        };
	
	        r++;
	
	        if (r === charsPerRow)
	        {
	            r = 0;
	            x = offsetX;
	            y += h + spacingY;
	        }
	        else
	        {
	            x += w + spacingX;
	        }
	    }
	
	    var entry = {
	        data: data,
	        frame: null,
	        texture: key
	    };
	
	    return entry;
	};
	
	module.exports = ParseRetroFont;


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var RETRO_FONT_CONST = __webpack_require__(1106);
	var Extend = __webpack_require__(36);
	
	/**
	 * @typedef {object} Phaser.GameObjects.RetroFont.Config
	 * 
	 * @property {string} image - [description]
	 * @property {number} offset.x - If the font set doesn't start at the top left of the given image, specify the X coordinate offset here.
	 * @property {number} offset.y - If the font set doesn't start at the top left of the given image, specify the Y coordinate offset here.
	 * @property {number} width - The width of each character in the font set.
	 * @property {number} height - The height of each character in the font set.
	 * @property {string} chars - The characters used in the font set, in display order. You can use the TEXT_SET consts for common font set arrangements.
	 * @property {number} charsPerRow - The number of characters per row in the font set. If not given charsPerRow will be the image width / characterWidth.
	 * @property {number} spacing.x - If the characters in the font set have horizontal spacing between them set the required amount here.
	 * @property {number} spacing.y - If the characters in the font set have vertical spacing between them set the required amount here.
	*/
	
	/**
	 * @namespace Phaser.GameObjects.RetroFont
	 * @since 3.6.0
	 */
	
	var RetroFont = { Parse: __webpack_require__(1104) };
	
	//   Merge in the consts
	RetroFont = Extend(false, RetroFont, RETRO_FONT_CONST);
	
	module.exports = RetroFont;


/***/ }),
/* 1106 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var RETRO_FONT_CONST = {
	
	    /**
	     * Text Set 1 =  !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~
	     * 
	     * @name Phaser.GameObjects.RetroFont.TEXT_SET1
	     * @type {string}
	     * @since 3.6.0
	     */
	    TEXT_SET1: ' !"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~',
	
	    /**
	     * Text Set 2 =  !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ
	     * 
	     * @name Phaser.GameObjects.RetroFont.TEXT_SET2
	     * @type {string}
	     * @since 3.6.0
	     */
	    TEXT_SET2: ' !"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ',
	
	    /**
	     * Text Set 3 = ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 
	     * 
	     * @name Phaser.GameObjects.RetroFont.TEXT_SET3
	     * @type {string}
	     * @since 3.6.0
	     */
	    TEXT_SET3: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 ',
	
	    /**
	     * Text Set 4 = ABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789
	     * 
	     * @name Phaser.GameObjects.RetroFont.TEXT_SET4
	     * @type {string}
	     * @since 3.6.0
	     */
	    TEXT_SET4: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789',
	
	    /**
	     * Text Set 5 = ABCDEFGHIJKLMNOPQRSTUVWXYZ.,/() '!?-*:0123456789
	     * 
	     * @name Phaser.GameObjects.RetroFont.TEXT_SET5
	     * @type {string}
	     * @since 3.6.0
	     */
	    TEXT_SET5: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ.,/() \'!?-*:0123456789',
	
	    /**
	     * Text Set 6 = ABCDEFGHIJKLMNOPQRSTUVWXYZ!?:;0123456789"(),-.' 
	     * 
	     * @name Phaser.GameObjects.RetroFont.TEXT_SET6
	     * @type {string}
	     * @since 3.6.0
	     */
	    TEXT_SET6: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ!?:;0123456789"(),-.\' ',
	
	    /**
	     * Text Set 7 = AGMSY+:4BHNTZ!;5CIOU.?06DJPV,(17EKQW")28FLRX-'39
	     * 
	     * @name Phaser.GameObjects.RetroFont.TEXT_SET7
	     * @type {string}
	     * @since 3.6.0
	     */
	    TEXT_SET7: 'AGMSY+:4BHNTZ!;5CIOU.?06DJPV,(17EKQW")28FLRX-\'39',
	
	    /**
	     * Text Set 8 = 0123456789 .ABCDEFGHIJKLMNOPQRSTUVWXYZ
	     * 
	     * @name Phaser.GameObjects.RetroFont.TEXT_SET8
	     * @type {string}
	     * @since 3.6.0
	     */
	    TEXT_SET8: '0123456789 .ABCDEFGHIJKLMNOPQRSTUVWXYZ',
	
	    /**
	     * Text Set 9 = ABCDEFGHIJKLMNOPQRSTUVWXYZ()-0123456789.:,'"?!
	     * 
	     * @name Phaser.GameObjects.RetroFont.TEXT_SET9
	     * @type {string}
	     * @since 3.6.0
	     */
	    TEXT_SET9: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ()-0123456789.:,\'"?!',
	
	    /**
	     * Text Set 10 = ABCDEFGHIJKLMNOPQRSTUVWXYZ
	     * 
	     * @name Phaser.GameObjects.RetroFont.TEXT_SET10
	     * @type {string}
	     * @since 3.6.0
	     */
	    TEXT_SET10: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
	
	    /**
	     * Text Set 11 = ABCDEFGHIJKLMNOPQRSTUVWXYZ.,"-+!?()':;0123456789
	     * 
	     * @name Phaser.GameObjects.RetroFont.TEXT_SET11
	     * @since 3.6.0
	     * @type {string}
	     */
	    TEXT_SET11: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ.,"-+!?()\':;0123456789'
	
	};
	
	module.exports = RETRO_FONT_CONST;


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the Canvas Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.DynamicBitmapText#renderCanvas
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
	 * @param {Phaser.GameObjects.DynamicBitmapText} src - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 */
	var DynamicBitmapTextCanvasRenderer = function (renderer, src, interpolationPercentage, camera, parentMatrix)
	{
	    var text = src.text;
	    var textLength = text.length;
	
	    if (GameObject.RENDER_MASK !== src.renderFlags || textLength === 0 || (src.cameraFilter > 0 && (src.cameraFilter & camera._id)))
	    {
	        return;
	    }
	    
	    var textureFrame = src.frame;
	
	    var displayCallback = src.displayCallback;
	
	    var cameraScrollX = camera.scrollX * src.scrollFactorX;
	    var cameraScrollY = camera.scrollY * src.scrollFactorY;
	
	    var chars = src.fontData.chars;
	    var lineHeight = src.fontData.lineHeight;
	
	    var xAdvance = 0;
	    var yAdvance = 0;
	
	    var indexCount = 0;
	    var charCode = 0;
	
	    var glyph = null;
	    var glyphX = 0;
	    var glyphY = 0;
	    var glyphW = 0;
	    var glyphH = 0;
	
	    var x = 0;
	    var y = 0;
	
	    var lastGlyph = null;
	    var lastCharCode = 0;
	
	    var ctx = renderer.currentContext;
	    var image = src.frame.source.image;
	
	    var textureX = textureFrame.cutX;
	    var textureY = textureFrame.cutY;
	
	    var rotation = 0;
	    var scale = (src.fontSize / src.fontData.size);
	
	    //  Blend Mode
	    if (renderer.currentBlendMode !== src.blendMode)
	    {
	        renderer.currentBlendMode = src.blendMode;
	        ctx.globalCompositeOperation = renderer.blendModes[src.blendMode];
	    }
	
	    //  Alpha
	    if (renderer.currentAlpha !== src.alpha)
	    {
	        renderer.currentAlpha = src.alpha;
	        ctx.globalAlpha = src.alpha;
	    }
	
	    //  Smoothing
	    if (renderer.currentScaleMode !== src.scaleMode)
	    {
	        renderer.currentScaleMode = src.scaleMode;
	    }
	
	    ctx.save();
	
	    if (parentMatrix !== undefined)
	    {
	        var matrix = parentMatrix.matrix;
	        ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
	    }
	
	    ctx.translate(src.x, src.y);
	
	    ctx.rotate(src.rotation);
	
	    ctx.translate(-src.displayOriginX, -src.displayOriginY);
	
	    ctx.scale(src.scaleX, src.scaleY);
	
	    if (src.cropWidth > 0 && src.cropHeight > 0)
	    {
	        ctx.save();
	        ctx.beginPath();
	        ctx.rect(0, 0, src.cropWidth, src.cropHeight);
	        ctx.clip();
	    }
	
	    var roundPixels = renderer.config.roundPixels;
	
	    for (var index = 0; index < textLength; ++index)
	    {
	        //  Reset the scale (in case the callback changed it)
	        scale = (src.fontSize / src.fontData.size);
	        rotation = 0;
	
	        charCode = text.charCodeAt(index);
	
	        if (charCode === 10)
	        {
	            xAdvance = 0;
	            indexCount = 0;
	            yAdvance += lineHeight;
	            lastGlyph = null;
	            continue;
	        }
	
	        glyph = chars[charCode];
	
	        if (!glyph)
	        {
	            continue;
	        }
	
	        glyphX = textureX + glyph.x;
	        glyphY = textureY + glyph.y;
	
	        glyphW = glyph.width;
	        glyphH = glyph.height;
	
	        x = (indexCount + glyph.xOffset + xAdvance) - src.scrollX;
	        y = (glyph.yOffset + yAdvance) - src.scrollY;
	
	        //  This could be optimized so that it doesn't even bother drawing it if the x/y is out of range
	
	        if (lastGlyph !== null)
	        {
	            var kerningOffset = glyph.kerning[lastCharCode];
	            x += (kerningOffset !== undefined) ? kerningOffset : 0;
	        }
	
	        if (displayCallback)
	        {
	            var output = displayCallback({ tint: { topLeft: 0, topRight: 0, bottomLeft: 0, bottomRight: 0 }, index: index, charCode: charCode, x: x, y: y, scale: scale, rotation: 0, data: glyph.data });
	
	            x = output.x;
	            y = output.y;
	            scale = output.scale;
	            rotation = output.rotation;
	        }
	
	        x *= scale;
	        y *= scale;
	
	        x -= cameraScrollX;
	        y -= cameraScrollY;
	
	        if (roundPixels)
	        {
	            x |= 0;
	            y |= 0;
	        }
	
	        ctx.save();
	
	        ctx.translate(x, y);
	
	        ctx.rotate(rotation);
	
	        ctx.scale(scale, scale);
	
	        ctx.drawImage(image, glyphX, glyphY, glyphW, glyphH, 0, 0, glyphW, glyphH);
	
	        ctx.restore();
	        
	        xAdvance += glyph.xAdvance;
	        indexCount += 1;
	        lastGlyph = glyph;
	        lastCharCode = charCode;
	    }
	
	    if (src.cropWidth > 0 && src.cropHeight > 0)
	    {
	        ctx.restore();
	    }
	
	    ctx.restore();
	};
	
	module.exports = DynamicBitmapTextCanvasRenderer;


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BitmapText = __webpack_require__(273);
	var BuildGameObject = __webpack_require__(50);
	var GameObjectCreator = __webpack_require__(26);
	var GetAdvancedValue = __webpack_require__(24);
	
	/**
	 * @typedef {object} BitmapTextConfig
	 * @extends GameObjectConfig
	 *
	 * @property {string} [font=''] - [description]
	 * @property {string} [text=''] - [description]
	 * @property {(number|false)} [size=false] - [description]
	 * @property {string} [align='left'] - [description]
	 */
	
	/**
	 * Creates a new Dynamic Bitmap Text Game Object and returns it.
	 *
	 * Note: This method will only be available if the Dynamic Bitmap Text Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectCreator#dynamicBitmapText
	 * @since 3.0.0
	 *²
	 * @param {BitmapTextConfig} config - The configuration object this Game Object will use to create itself.
	 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
	 *
	 * @return {Phaser.GameObjects.DynamicBitmapText} The Game Object that was created.
	 */
	GameObjectCreator.register('dynamicBitmapText', function (config, addToScene)
	{
	    if (config === undefined) { config = {}; }
	
	    var font = GetAdvancedValue(config, 'font', '');
	    var text = GetAdvancedValue(config, 'text', '');
	    var size = GetAdvancedValue(config, 'size', false);
	    var align = GetAdvancedValue(config, 'align', 'left');
	
	    var bitmapText = new BitmapText(this.scene, 0, 0, font, text, size, align);
	
	    if (addToScene !== undefined)
	    {
	        config.add = addToScene;
	    }
	
	    BuildGameObject(this.scene, bitmapText, config);
	
	    return bitmapText;
	});
	
	//  When registering a factory function 'this' refers to the GameObjectCreator context.


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var DynamicBitmapText = __webpack_require__(273);
	var GameObjectFactory = __webpack_require__(18);
	
	/**
	 * Creates a new Dynamic Bitmap Text Game Object and adds it to the Scene.
	 *
	 * Note: This method will only be available if the Dynamic Bitmap Text Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectFactory#dynamicBitmapText
	 * @since 3.0.0
	 *
	 * @param {number} x - The x position of the Game Object.
	 * @param {number} y - The y position of the Game Object.
	 * @param {string} font - [description]
	 * @param {(string|string[])} [text] - [description]
	 * @param {number} [size] - [description]
	 *
	 * @return {Phaser.GameObjects.DynamicBitmapText} The Game Object that was created.
	 */
	GameObjectFactory.register('dynamicBitmapText', function (x, y, font, text, size)
	{
	    return this.displayList.add(new DynamicBitmapText(this.scene, x, y, font, text, size));
	});
	
	//  When registering a factory function 'this' refers to the GameObjectFactory context.
	//
	//  There are several properties available to use:
	//
	//  this.scene - a reference to the Scene that owns the GameObjectFactory
	//  this.displayList - a reference to the Display List the Scene owns
	//  this.updateList - a reference to the Update List the Scene owns


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var renderWebGL = __webpack_require__(6);
	var renderCanvas = __webpack_require__(6);
	
	if (true)
	{
	    renderWebGL = __webpack_require__(1111);
	}
	
	if (true)
	{
	    renderCanvas = __webpack_require__(1107);
	}
	
	module.exports = {
	
	    renderWebGL: renderWebGL,
	    renderCanvas: renderCanvas
	
	};


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the WebGL Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.DynamicBitmapText#renderWebGL
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
	 * @param {Phaser.GameObjects.DynamicBitmapText} gameObject - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 */
	var DynamicBitmapTextWebGLRenderer = function (renderer, bitmapText, interpolationPercentage, camera, parentMatrix)
	{
	    var text = bitmapText.text;
	    var textLength = text.length;
	
	    if (GameObject.RENDER_MASK !== bitmapText.renderFlags || textLength === 0 || (bitmapText.cameraFilter > 0 && (bitmapText.cameraFilter & camera._id)))
	    {
	        return;
	    }
	
	    this.pipeline.batchDynamicBitmapText(bitmapText, camera, parentMatrix);
	};
	
	module.exports = DynamicBitmapTextWebGLRenderer;


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the Canvas Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.BitmapText#renderCanvas
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
	 * @param {Phaser.GameObjects.BitmapText} src - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 */
	var BitmapTextCanvasRenderer = function (renderer, src, interpolationPercentage, camera, parentMatrix)
	{
	    var text = src.text;
	    var textLength = text.length;
	
	    if (GameObject.RENDER_MASK !== src.renderFlags || textLength === 0 || (src.cameraFilter > 0 && (src.cameraFilter & camera._id)))
	    {
	        return;
	    }
	    
	    var textureFrame = src.frame;
	
	    var chars = src.fontData.chars;
	    var lineHeight = src.fontData.lineHeight;
	    var letterSpacing = src.letterSpacing;
	
	    var xAdvance = 0;
	    var yAdvance = 0;
	
	    var indexCount = 0;
	    var charCode = 0;
	
	    var glyph = null;
	    var glyphX = 0;
	    var glyphY = 0;
	    var glyphW = 0;
	    var glyphH = 0;
	
	    var x = 0;
	    var y = 0;
	
	    var lastGlyph = null;
	    var lastCharCode = 0;
	
	    var ctx = renderer.currentContext;
	    var image = src.frame.source.image;
	
	    var textureX = textureFrame.cutX;
	    var textureY = textureFrame.cutY;
	
	    var scale = (src.fontSize / src.fontData.size);
	
	    //  Blend Mode
	    if (renderer.currentBlendMode !== src.blendMode)
	    {
	        renderer.currentBlendMode = src.blendMode;
	        ctx.globalCompositeOperation = renderer.blendModes[src.blendMode];
	    }
	
	    //  Alpha
	    if (renderer.currentAlpha !== src.alpha)
	    {
	        renderer.currentAlpha = src.alpha;
	        ctx.globalAlpha = src.alpha;
	    }
	
	    //  Smoothing
	    if (renderer.currentScaleMode !== src.scaleMode)
	    {
	        renderer.currentScaleMode = src.scaleMode;
	    }
	
	    var roundPixels = renderer.config.roundPixels;
	
	    var tx = (src.x - camera.scrollX * src.scrollFactorX) + src.frame.x;
	    var ty = (src.y - camera.scrollY * src.scrollFactorY) + src.frame.y;
	
	    if (roundPixels)
	    {
	        tx |= 0;
	        ty |= 0;
	    }
	
	    ctx.save();
	
	    if (parentMatrix !== undefined)
	    {
	        var matrix = parentMatrix.matrix;
	        ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
	    }
	
	    ctx.translate(tx, ty);
	
	    ctx.rotate(src.rotation);
	
	    ctx.translate(-src.displayOriginX, -src.displayOriginY);
	
	    ctx.scale(src.scaleX, src.scaleY);
	
	    for (var index = 0; index < textLength; ++index)
	    {
	        charCode = text.charCodeAt(index);
	
	        if (charCode === 10)
	        {
	            xAdvance = 0;
	            indexCount = 0;
	            yAdvance += lineHeight;
	            lastGlyph = null;
	            continue;
	        }
	
	        glyph = chars[charCode];
	
	        if (!glyph)
	        {
	            continue;
	        }
	
	        glyphX = textureX + glyph.x;
	        glyphY = textureY + glyph.y;
	
	        glyphW = glyph.width;
	        glyphH = glyph.height;
	
	        x = indexCount + glyph.xOffset + xAdvance;
	        y = glyph.yOffset + yAdvance;
	
	        if (lastGlyph !== null)
	        {
	            var kerningOffset = glyph.kerning[lastCharCode];
	            x += (kerningOffset !== undefined) ? kerningOffset : 0;
	        }
	
	        x *= scale;
	        y *= scale;
	
	        xAdvance += glyph.xAdvance + letterSpacing;
	        indexCount += 1;
	        lastGlyph = glyph;
	        lastCharCode = charCode;
	
	        //  Nothing to render or a space? Then skip to the next glyph
	        if (glyphW === 0 || glyphH === 0 || charCode === 32)
	        {
	            continue;
	        }
	
	        if (roundPixels)
	        {
	            x |= 0;
	            y |= 0;
	        }
	
	        ctx.save();
	
	        ctx.translate(x, y);
	
	        ctx.scale(scale, scale);
	
	        ctx.drawImage(image, glyphX, glyphY, glyphW, glyphH, 0, 0, glyphW, glyphH);
	
	        ctx.restore();
	    }
	
	    ctx.restore();
	};
	
	module.exports = BitmapTextCanvasRenderer;


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BitmapText = __webpack_require__(274);
	var BuildGameObject = __webpack_require__(50);
	var GameObjectCreator = __webpack_require__(26);
	var GetAdvancedValue = __webpack_require__(24);
	var GetValue = __webpack_require__(10);
	
	/**
	 * Creates a new Bitmap Text Game Object and returns it.
	 *
	 * Note: This method will only be available if the Bitmap Text Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectCreator#bitmapText
	 * @since 3.0.0
	 *
	 * @param {BitmapTextConfig} config - The configuration object this Game Object will use to create itself.
	 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
	 * 
	 * @return {Phaser.GameObjects.BitmapText} The Game Object that was created.
	 */
	GameObjectCreator.register('bitmapText', function (config, addToScene)
	{
	    if (config === undefined) { config = {}; }
	
	    var font = GetValue(config, 'font', '');
	    var text = GetAdvancedValue(config, 'text', '');
	    var size = GetAdvancedValue(config, 'size', false);
	
	    // var align = GetValue(config, 'align', 'left');
	
	    var bitmapText = new BitmapText(this.scene, 0, 0, font, text, size);
	
	    if (addToScene !== undefined)
	    {
	        config.add = addToScene;
	    }
	
	    BuildGameObject(this.scene, bitmapText, config);
	
	    return bitmapText;
	});
	
	//  When registering a factory function 'this' refers to the GameObjectCreator context.


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BitmapText = __webpack_require__(274);
	var GameObjectFactory = __webpack_require__(18);
	
	/**
	 * Creates a new Bitmap Text Game Object and adds it to the Scene.
	 *
	 * Note: This method will only be available if the Bitmap Text Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectFactory#bitmapText
	 * @since 3.0.0
	 *
	 * @param {number} x - The x position of the Game Object.
	 * @param {number} y - The y position of the Game Object.
	 * @param {string} font - [description]
	 * @param {(string|string[])} [text] - [description]
	 * @param {number} [size] - [description]
	 *
	 * @return {Phaser.GameObjects.BitmapText} The Game Object that was created.
	 */
	GameObjectFactory.register('bitmapText', function (x, y, font, text, size)
	{
	    return this.displayList.add(new BitmapText(this.scene, x, y, font, text, size));
	});
	
	//  When registering a factory function 'this' refers to the GameObjectFactory context.
	//
	//  There are several properties available to use:
	//
	//  this.scene - a reference to the Scene that owns the GameObjectFactory
	//  this.displayList - a reference to the Display List the Scene owns
	//  this.updateList - a reference to the Update List the Scene owns


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var renderWebGL = __webpack_require__(6);
	var renderCanvas = __webpack_require__(6);
	
	if (true)
	{
	    renderWebGL = __webpack_require__(1116);
	}
	
	if (true)
	{
	    renderCanvas = __webpack_require__(1112);
	}
	
	module.exports = {
	
	    renderWebGL: renderWebGL,
	    renderCanvas: renderCanvas
	
	};


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the WebGL Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.BitmapText#renderWebGL
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
	 * @param {Phaser.GameObjects.BitmapText} gameObject - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 */
	var BitmapTextWebGLRenderer = function (renderer, gameObject, interpolationPercentage, camera, parentMatrix)
	{
	    var text = gameObject.text;
	    var textLength = text.length;
	
	    if (GameObject.RENDER_MASK !== gameObject.renderFlags || textLength === 0 || (gameObject.cameraFilter > 0 && (gameObject.cameraFilter & camera._id)))
	    {
	        return;
	    }
	
	    this.pipeline.batchBitmapText(this, camera, parentMatrix);
	};
	
	module.exports = BitmapTextWebGLRenderer;


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the Canvas Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.Blitter#renderCanvas
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
	 * @param {Phaser.GameObjects.Blitter} src - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 */
	var BlitterCanvasRenderer = function (renderer, src, interpolationPercentage, camera, parentMatrix)
	{
	    if (GameObject.RENDER_MASK !== src.renderFlags || (src.cameraFilter > 0 && (src.cameraFilter & camera._id)))
	    {
	        return;
	    }
	
	    var list = src.getRenderList();
	
	    renderer.setBlendMode(src.blendMode);
	
	    var ctx = renderer.gameContext;
	    var cameraScrollX = src.x - camera.scrollX * src.scrollFactorX;
	    var cameraScrollY = src.y - camera.scrollY * src.scrollFactorY;
	
	    ctx.save();
	
	    if (parentMatrix !== undefined)
	    {
	        var matrix = parentMatrix.matrix;
	        ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
	    }
	
	    //  Render bobs
	    for (var i = 0; i < list.length; i++)
	    {
	        var bob = list[i];
	        var flip = (bob.flipX || bob.flipY);
	        var frame = bob.frame;
	        var cd = frame.canvasData;
	        var dx = frame.x;
	        var dy = frame.y;
	        var fx = 1;
	        var fy = 1;
	
	        if (!flip)
	        {
	            renderer.blitImage(dx + bob.x + cameraScrollX, dy + bob.y + cameraScrollY, bob.frame);
	        }
	        else
	        {
	            if (bob.flipX)
	            {
	                fx = -1;
	                dx -= cd.dWidth;
	            }
	
	            if (bob.flipY)
	            {
	                fy = -1;
	                dy -= cd.dHeight;
	            }
	
	            ctx.save();
	            ctx.translate(bob.x + cameraScrollX, bob.y + cameraScrollY);
	            ctx.scale(fx, fy);
	            ctx.drawImage(frame.source.image, cd.sx, cd.sy, cd.sWidth, cd.sHeight, dx, dy, cd.dWidth, cd.dHeight);
	            ctx.restore();
	        }
	    }
	    
	    ctx.restore();
	};
	
	module.exports = BlitterCanvasRenderer;


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Blitter = __webpack_require__(275);
	var BuildGameObject = __webpack_require__(50);
	var GameObjectCreator = __webpack_require__(26);
	var GetAdvancedValue = __webpack_require__(24);
	
	/**
	 * Creates a new Blitter Game Object and returns it.
	 *
	 * Note: This method will only be available if the Blitter Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectCreator#blitter
	 * @since 3.0.0
	 *
	 * @param {object} config - The configuration object this Game Object will use to create itself.
	 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
	 *
	 * @return {Phaser.GameObjects.Blitter} The Game Object that was created.
	 */
	GameObjectCreator.register('blitter', function (config, addToScene)
	{
	    if (config === undefined) { config = {}; }
	
	    var key = GetAdvancedValue(config, 'key', null);
	    var frame = GetAdvancedValue(config, 'frame', null);
	
	    var blitter = new Blitter(this.scene, 0, 0, key, frame);
	
	    if (addToScene !== undefined)
	    {
	        config.add = addToScene;
	    }
	
	    BuildGameObject(this.scene, blitter, config);
	
	    return blitter;
	});
	
	//  When registering a factory function 'this' refers to the GameObjectCreator context.


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Blitter = __webpack_require__(275);
	var GameObjectFactory = __webpack_require__(18);
	
	/**
	 * Creates a new Blitter Game Object and adds it to the Scene.
	 *
	 * Note: This method will only be available if the Blitter Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectFactory#blitter
	 * @since 3.0.0
	 *
	 * @param {number} x - The x position of the Game Object.
	 * @param {number} y - The y position of the Game Object.
	 * @param {string} key - The key of the Texture the Blitter object will use.
	 * @param {(string|integer)} [frame] - The default Frame children of the Blitter will use.
	 * 
	 * @return {Phaser.GameObjects.Blitter} The Game Object that was created.
	 */
	GameObjectFactory.register('blitter', function (x, y, key, frame)
	{
	    return this.displayList.add(new Blitter(this.scene, x, y, key, frame));
	});
	
	//  When registering a factory function 'this' refers to the GameObjectFactory context.
	//  
	//  There are several properties available to use:
	//  
	//  this.scene - a reference to the Scene that owns the GameObjectFactory
	//  this.displayList - a reference to the Display List the Scene owns
	//  this.updateList - a reference to the Update List the Scene owns


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var renderWebGL = __webpack_require__(6);
	var renderCanvas = __webpack_require__(6);
	
	if (true)
	{
	    renderWebGL = __webpack_require__(1121);
	}
	
	if (true)
	{
	    renderCanvas = __webpack_require__(1117);
	}
	
	module.exports = {
	
	    renderWebGL: renderWebGL,
	    renderCanvas: renderCanvas
	
	};


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the WebGL Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.Blitter#renderWebGL
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
	 * @param {Phaser.GameObjects.Blitter} gameObject - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 */
	var BlitterWebGLRenderer = function (renderer, gameObject, interpolationPercentage, camera, parentMatrix)
	{
	    if (GameObject.RENDER_MASK !== gameObject.renderFlags || (gameObject.cameraFilter > 0 && (gameObject.cameraFilter & camera._id)))
	    {
	        return;
	    }
	
	    this.pipeline.drawBlitter(gameObject, camera, parentMatrix);
	};
	
	module.exports = BlitterWebGLRenderer;


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * A Bob Game Object.
	 *
	 * A Bob belongs to a Blitter Game Object. The Blitter is responsible for managing and rendering this object.
	 *
	 * A Bob has a position, alpha value and a frame from a texture that it uses to render with. You can also toggle
	 * the flipped and visible state of the Bob. The Frame the Bob uses to render can be changed dynamically, but it
	 * must be a Frame within the Texture used by the parent Blitter.
	 *
	 * Bob positions are relative to the Blitter parent. So if you move the Blitter parent, all Bob children will
	 * have their positions impacted by this change as well.
	 *
	 * You can manipulate Bob objects directly from your game code, but the creation and destruction of them should be
	 * handled via the Blitter parent.
	 *
	 * @class Bob
	 * @memberOf Phaser.GameObjects.Blitter
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.GameObjects.Blitter} blitter - The parent Blitter object is responsible for updating this Bob.
	 * @param {number} x - The horizontal position of this Game Object in the world, relative to the parent Blitter position.
	 * @param {number} y - The vertical position of this Game Object in the world, relative to the parent Blitter position.
	 * @param {(string|integer)} frame - The Frame this Bob will render with, as defined in the Texture the parent Blitter is using.
	 * @param {boolean} visible - Should the Bob render visible or not to start with?
	 */
	var Bob = new Class({
	
	    initialize:
	
	    function Bob (blitter, x, y, frame, visible)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Blitter.Bob#parent
	         * @type {Phaser.GameObjects.Blitter}
	         * @since 3.0.0
	         */
	        this.parent = blitter;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Blitter.Bob#x
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.x = x;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Blitter.Bob#y
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.y = y;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Blitter.Bob#frame
	         * @type {(string|integer)}
	         * @since 3.0.0
	         */
	        this.frame = frame;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Blitter.Bob#data
	         * @type {object}
	         * @default {}
	         * @since 3.0.0
	         */
	        this.data = {};
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Blitter.Bob#_visible
	         * @type {boolean}
	         * @private
	         * @since 3.0.0
	         */
	        this._visible = visible;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Blitter.Bob#_alpha
	         * @type {number}
	         * @private
	         * @default 1
	         * @since 3.0.0
	         */
	        this._alpha = 1;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Blitter.Bob#flipX
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.flipX = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Blitter.Bob#flipY
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.flipY = false;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Blitter.Bob#setFrame
	     * @since 3.0.0
	     *
	     * @param {Phaser.Textures.Frame} [frame] - [description]
	     *
	     * @return {Phaser.GameObjects.Blitter.Bob} This Bob Game Object.
	     */
	    setFrame: function (frame)
	    {
	        if (frame === undefined)
	        {
	            frame = this.parent.frame;
	        }
	        else
	        {
	            frame = this.parent.texture.get(frame);
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Blitter.Bob#resetFlip
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Blitter.Bob} This Bob Game Object.
	     */
	    resetFlip: function ()
	    {
	        this.flipX = false;
	        this.flipY = false;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Blitter.Bob#reset
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {Phaser.Textures.Frame} frame - [description]
	     *
	     * @return {Phaser.GameObjects.Blitter.Bob} This Bob Game Object.
	     */
	    reset: function (x, y, frame)
	    {
	        this.x = x;
	        this.y = y;
	        this.frame = frame;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Blitter.Bob#setFlipX
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.Blitter.Bob} This Bob Game Object.
	     */
	    setFlipX: function (value)
	    {
	        this.flipX = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Blitter.Bob#setFlipY
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.Blitter.Bob} This Bob Game Object.
	     */
	    setFlipY: function (value)
	    {
	        this.flipY = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Blitter.Bob#setFlip
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     *
	     * @return {Phaser.GameObjects.Blitter.Bob} This Bob Game Object.
	     */
	    setFlip: function (x, y)
	    {
	        this.flipX = x;
	        this.flipY = y;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Blitter.Bob#setVisible
	     * @since 3.0.0
	     *
	     * @param {boolean} value - [description]
	     *
	     * @return {Phaser.GameObjects.Blitter.Bob} This Bob Game Object.
	     */
	    setVisible: function (value)
	    {
	        this.visible = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Blitter.Bob#setAlpha
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.Blitter.Bob} This Bob Game Object.
	     */
	    setAlpha: function (value)
	    {
	        this.alpha = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Blitter.Bob#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.parent.dirty = true;
	
	        this.parent.children.remove(this);
	
	        this.parent = undefined;
	        this.frame = undefined;
	        this.data = undefined;
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.GameObjects.Blitter.Bob#visible
	     * @type {boolean}
	     * @since 3.0.0
	     */
	    visible: {
	
	        get: function ()
	        {
	            return this._visible;
	        },
	
	        set: function (value)
	        {
	            this._visible = value;
	            this.parent.dirty = true;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.GameObjects.Blitter.Bob#alpha
	     * @type {number}
	     * @since 3.0.0
	     */
	    alpha: {
	
	        get: function ()
	        {
	            return this._alpha;
	        },
	
	        set: function (value)
	        {
	            this._alpha = value;
	            this.parent.dirty = true;
	        }
	
	    }
	
	});
	
	module.exports = Bob;


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Clamp = __webpack_require__(63);
	
	//  bitmask flag for GameObject.renderMask
	var _FLAG = 2; // 0010
	
	/**
	 * Provides methods used for setting the alpha properties of a Game Object.
	 * Should be applied as a mixin and not used directly.
	 * 
	 * @name Phaser.GameObjects.Components.Alpha
	 * @since 3.0.0
	 */
	
	var Alpha = {
	
	    /**
	     * Private internal value. Holds the global alpha value.
	     * 
	     * @name Phaser.GameObjects.Components.Alpha#_alpha
	     * @type {float}
	     * @private
	     * @default 1
	     * @since 3.0.0
	     */
	    _alpha: 1,
	
	    /**
	     * Private internal value. Holds the top-left alpha value.
	     * 
	     * @name Phaser.GameObjects.Components.Alpha#_alphaTL
	     * @type {float}
	     * @private
	     * @default 1
	     * @since 3.0.0
	     */
	    _alphaTL: 1,
	
	    /**
	     * Private internal value. Holds the top-right alpha value.
	     * 
	     * @name Phaser.GameObjects.Components.Alpha#_alphaTR
	     * @type {float}
	     * @private
	     * @default 1
	     * @since 3.0.0
	     */
	    _alphaTR: 1,
	
	    /**
	     * Private internal value. Holds the bottom-left alpha value.
	     * 
	     * @name Phaser.GameObjects.Components.Alpha#_alphaBL
	     * @type {float}
	     * @private
	     * @default 1
	     * @since 3.0.0
	     */
	    _alphaBL: 1,
	
	    /**
	     * Private internal value. Holds the bottom-right alpha value.
	     * 
	     * @name Phaser.GameObjects.Components.Alpha#_alphaBR
	     * @type {float}
	     * @private
	     * @default 1
	     * @since 3.0.0
	     */
	    _alphaBR: 1,
	
	    /**
	     * Clears all alpha values associated with this Game Object.
	     * Immediately sets the alpha levels back to 1 (fully opaque)
	     *
	     * @method Phaser.GameObjects.Components.Alpha#clearAlpha
	     * @since 3.0.0
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    clearAlpha: function ()
	    {
	        return this.setAlpha(1);
	    },
	
	    /**
	     * Set the Alpha level of this Game Object. The alpha controls the opacity of the Game Object as it renders.
	     * Alpha values are provided as a float between 0, fully transparent, and 1, fully opaque.
	     *
	     * If your game is running under WebGL you can optionally specify four different alpha values, each of which
	     * correspond to the four corners of the Game Object. Under Canvas only the `topLeft` value given is used.
	     *
	     * @method Phaser.GameObjects.Components.Alpha#setAlpha
	     * @since 3.0.0
	     * 
	     * @param {float} [topLeft=1] - The alpha value used for the top-left of the Game Object. If this is the only value given it's applied across the whole Game Object.
	     * @param {float} [topRight] - The alpha value used for the top-right of the Game Object. WebGL only.
	     * @param {float} [bottomLeft] - The alpha value used for the bottom-left of the Game Object. WebGL only.
	     * @param {float} [bottomRight] - The alpha value used for the bottom-right of the Game Object. WebGL only.
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setAlpha: function (topLeft, topRight, bottomLeft, bottomRight)
	    {
	        if (topLeft === undefined) { topLeft = 1; }
	
	        //  Treat as if there is only one alpha value for the whole Game Object
	        if (topRight === undefined)
	        {
	            this.alpha = topLeft;
	        }
	        else
	        {
	            this._alphaTL = Clamp(topLeft, 0, 1);
	            this._alphaTR = Clamp(topRight, 0, 1);
	            this._alphaBL = Clamp(bottomLeft, 0, 1);
	            this._alphaBR = Clamp(bottomRight, 0, 1);
	        }
	
	        return this;
	    },
	
	    /**
	     * The alpha value of the Game Object.
	     *
	     * This is a global value, impacting the entire Game Object, not just a region of it.
	     * 
	     * @name Phaser.GameObjects.Components.Alpha#alpha
	     * @type {float}
	     * @since 3.0.0
	     */
	    alpha: {
	
	        get: function ()
	        {
	            return this._alpha;
	        },
	
	        set: function (value)
	        {
	            var v = Clamp(value, 0, 1);
	
	            this._alpha = v;
	            this._alphaTL = v;
	            this._alphaTR = v;
	            this._alphaBL = v;
	            this._alphaBR = v;
	
	            if (v === 0)
	            {
	                this.renderFlags &= ~_FLAG;
	            }
	            else
	            {
	                this.renderFlags |= _FLAG;
	            }
	        }
	
	    },
	
	    /**
	     * The alpha value starting from the top-left of the Game Object.
	     * This value is interpolated from the corner to the center of the Game Object.
	     * 
	     * @name Phaser.GameObjects.Components.Alpha#alphaTopLeft
	     * @type {float}
	     * @webglOnly
	     * @since 3.0.0
	     */
	    alphaTopLeft: {
	
	        get: function ()
	        {
	            return this._alphaTL;
	        },
	
	        set: function (value)
	        {
	            var v = Clamp(value, 0, 1);
	
	            this._alphaTL = v;
	
	            if (v !== 0)
	            {
	                this.renderFlags |= _FLAG;
	            }
	        }
	
	    },
	
	    /**
	     * The alpha value starting from the top-right of the Game Object.
	     * This value is interpolated from the corner to the center of the Game Object.
	     * 
	     * @name Phaser.GameObjects.Components.Alpha#alphaTopRight
	     * @type {float}
	     * @webglOnly
	     * @since 3.0.0
	     */
	    alphaTopRight: {
	
	        get: function ()
	        {
	            return this._alphaTR;
	        },
	
	        set: function (value)
	        {
	            var v = Clamp(value, 0, 1);
	
	            this._alphaTR = v;
	
	            if (v !== 0)
	            {
	                this.renderFlags |= _FLAG;
	            }
	        }
	
	    },
	
	    /**
	     * The alpha value starting from the bottom-left of the Game Object.
	     * This value is interpolated from the corner to the center of the Game Object.
	     * 
	     * @name Phaser.GameObjects.Components.Alpha#alphaBottomLeft
	     * @type {float}
	     * @webglOnly
	     * @since 3.0.0
	     */
	    alphaBottomLeft: {
	
	        get: function ()
	        {
	            return this._alphaBL;
	        },
	
	        set: function (value)
	        {
	            var v = Clamp(value, 0, 1);
	
	            this._alphaBL = v;
	
	            if (v !== 0)
	            {
	                this.renderFlags |= _FLAG;
	            }
	        }
	
	    },
	
	    /**
	     * The alpha value starting from the bottom-right of the Game Object.
	     * This value is interpolated from the corner to the center of the Game Object.
	     * 
	     * @name Phaser.GameObjects.Components.Alpha#alphaBottomRight
	     * @type {float}
	     * @webglOnly
	     * @since 3.0.0
	     */
	    alphaBottomRight: {
	
	        get: function ()
	        {
	            return this._alphaBR;
	        },
	
	        set: function (value)
	        {
	            var v = Clamp(value, 0, 1);
	
	            this._alphaBR = v;
	
	            if (v !== 0)
	            {
	                this.renderFlags |= _FLAG;
	            }
	        }
	
	    }
	
	};
	
	module.exports = Alpha;


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BlendModes = __webpack_require__(145);
	
	/**
	 * Provides methods used for setting the blend mode of a Game Object.
	 * Should be applied as a mixin and not used directly.
	 *
	 * @name Phaser.GameObjects.Components.BlendMode
	 * @since 3.0.0
	 */
	
	var BlendMode = {
	
	    /**
	     * Private internal value. Holds the current blend mode.
	     * 
	     * @name Phaser.GameObjects.Components.BlendMode#_blendMode
	     * @type {integer}
	     * @private
	     * @default 0
	     * @since 3.0.0
	     */
	    _blendMode: BlendModes.NORMAL,
	
	    /**
	     * Sets the Blend Mode being used by this Game Object.
	     *
	     * This can be a const, such as `Phaser.BlendModes.SCREEN`, or an integer, such as 4 (for Overlay)
	     *
	     * Under WebGL only the following Blend Modes are available:
	     *
	     * * ADD
	     * * MULTIPLY
	     * * SCREEN
	     *
	     * Canvas has more available depending on browser support.
	     *
	     * You can also create your own custom Blend Modes in WebGL.
	     *
	     * Blend modes have different effects under Canvas and WebGL, and from browser to browser, depending
	     * on support. Blend Modes also cause a WebGL batch flush should it encounter a new blend mode. For these
	     * reasons try to be careful about the construction of your Scene and the frequency of which blend modes
	     * are used.
	     *
	     * @name Phaser.GameObjects.Components.BlendMode#blendMode
	     * @type {(Phaser.BlendModes|string)}
	     * @since 3.0.0
	     */
	    blendMode: {
	
	        get: function ()
	        {
	            return this._blendMode;
	        },
	
	        set: function (value)
	        {
	            if (typeof value === 'string')
	            {
	                value = BlendModes[value];
	            }
	
	            value |= 0;
	
	            if (value >= 0)
	            {
	                this._blendMode = value;
	            }
	        }
	
	    },
	
	    /**
	     * Sets the Blend Mode being used by this Game Object.
	     *
	     * This can be a const, such as `Phaser.BlendModes.SCREEN`, or an integer, such as 4 (for Overlay)
	     *
	     * Under WebGL only the following Blend Modes are available:
	     *
	     * * ADD
	     * * MULTIPLY
	     * * SCREEN
	     *
	     * Canvas has more available depending on browser support.
	     *
	     * You can also create your own custom Blend Modes in WebGL.
	     *
	     * Blend modes have different effects under Canvas and WebGL, and from browser to browser, depending
	     * on support. Blend Modes also cause a WebGL batch flush should it encounter a new blend mode. For these
	     * reasons try to be careful about the construction of your Scene and the frequency of which blend modes
	     * are used.
	     *
	     * @method Phaser.GameObjects.Components.BlendMode#setBlendMode
	     * @since 3.0.0
	     *
	     * @param {(string|Phaser.BlendModes)} value - The BlendMode value. Either a string or a CONST.
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setBlendMode: function (value)
	    {
	        this.blendMode = value;
	
	        return this;
	    }
	
	};
	
	module.exports = BlendMode;


/***/ }),
/* 1125 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Provides methods used for calculating and setting the size of a non-Frame based Game Object.
	 * Should be applied as a mixin and not used directly.
	 * 
	 * @name Phaser.GameObjects.Components.ComputedSize
	 * @since 3.0.0
	 */
	
	var ComputedSize = {
	
	    /**
	     * The native (un-scaled) width of this Game Object.
	     * 
	     * @name Phaser.GameObjects.Components.ComputedSize#width
	     * @type {number}
	     * @since 3.0.0
	     */
	    width: 0,
	
	    /**
	     * The native (un-scaled) height of this Game Object.
	     * 
	     * @name Phaser.GameObjects.Components.ComputedSize#height
	     * @type {number}
	     * @since 3.0.0
	     */
	    height: 0,
	
	    /**
	     * The displayed width of this Game Object.
	     * This value takes into account the scale factor.
	     * 
	     * @name Phaser.GameObjects.Components.ComputedSize#displayWidth
	     * @type {number}
	     * @since 3.0.0
	     */
	    displayWidth: {
	
	        get: function ()
	        {
	            return this.scaleX * this.width;
	        },
	
	        set: function (value)
	        {
	            this.scaleX = value / this.width;
	        }
	
	    },
	
	    /**
	     * The displayed height of this Game Object.
	     * This value takes into account the scale factor.
	     * 
	     * @name Phaser.GameObjects.Components.ComputedSize#displayHeight
	     * @type {number}
	     * @since 3.0.0
	     */
	    displayHeight: {
	
	        get: function ()
	        {
	            return this.scaleY * this.height;
	        },
	
	        set: function (value)
	        {
	            this.scaleY = value / this.height;
	        }
	
	    },
	
	    /**
	     * Sets the size of this Game Object.
	     * 
	     * @method Phaser.GameObjects.Components.ComputedSize#setSize
	     * @since 3.4.0
	     *
	     * @param {number} width - The width of this Game Object.
	     * @param {number} height - The height of this Game Object.
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setSize: function (width, height)
	    {
	        this.width = width;
	        this.height = height;
	
	        return this;
	    },
	
	    /**
	     * Sets the display size of this Game Object.
	     * Calling this will adjust the scale.
	     * 
	     * @method Phaser.GameObjects.Components.ComputedSize#setDisplaySize
	     * @since 3.4.0
	     *
	     * @param {number} width - The width of this Game Object.
	     * @param {number} height - The height of this Game Object.
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setDisplaySize: function (width, height)
	    {
	        this.displayWidth = width;
	        this.displayHeight = height;
	
	        return this;
	    }
	
	};
	
	module.exports = ComputedSize;


/***/ }),
/* 1126 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Provides methods used for setting the depth of a Game Object.
	 * Should be applied as a mixin and not used directly.
	 * 
	 * @name Phaser.GameObjects.Components.Depth
	 * @since 3.0.0
	 */
	
	var Depth = {
	
	    /**
	     * Private internal value. Holds the depth of the Game Object.
	     * 
	     * @name Phaser.GameObjects.Components.Depth#_depth
	     * @type {integer}
	     * @private
	     * @default 0
	     * @since 3.0.0
	     */
	    _depth: 0,
	
	    /**
	     * The depth of this Game Object within the Scene.
	     * 
	     * The depth is also known as the 'z-index' in some environments, and allows you to change the rendering order
	     * of Game Objects, without actually moving their position in the display list.
	     *
	     * The depth starts from zero (the default value) and increases from that point. A Game Object with a higher depth
	     * value will always render in front of one with a lower value.
	     *
	     * Setting the depth will queue a depth sort event within the Scene.
	     * 
	     * @name Phaser.GameObjects.Components.Depth#depth
	     * @type {number}
	     * @since 3.0.0
	     */
	    depth: {
	
	        get: function ()
	        {
	            return this._depth;
	        },
	
	        set: function (value)
	        {
	            this.scene.sys.queueDepthSort();
	            this._depth = value;
	        }
	
	    },
	
	    /**
	     * The depth of this Game Object within the Scene.
	     * 
	     * The depth is also known as the 'z-index' in some environments, and allows you to change the rendering order
	     * of Game Objects, without actually moving their position in the display list.
	     *
	     * The depth starts from zero (the default value) and increases from that point. A Game Object with a higher depth
	     * value will always render in front of one with a lower value.
	     *
	     * Setting the depth will queue a depth sort event within the Scene.
	     * 
	     * @method Phaser.GameObjects.Components.Depth#setDepth
	     * @since 3.0.0
	     *
	     * @param {integer} value - The depth of this Game Object.
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setDepth: function (value)
	    {
	        if (value === undefined) { value = 0; }
	
	        this.depth = value;
	
	        return this;
	    }
	
	};
	
	module.exports = Depth;


/***/ }),
/* 1127 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Provides methods used for visually flipping a Game Object.
	 * Should be applied as a mixin and not used directly.
	 * 
	 * @name Phaser.GameObjects.Components.Flip
	 * @since 3.0.0
	 */
	
	var Flip = {
	
	    /**
	     * The horizontally flipped state of the Game Object.
	     * A Game Object that is flipped horizontally will render inversed on the horizontal axis.
	     * Flipping always takes place from the middle of the texture and does not impact the scale value.
	     * 
	     * @name Phaser.GameObjects.Components.Flip#flipX
	     * @type {boolean}
	     * @default false
	     * @since 3.0.0
	     */
	    flipX: false,
	
	    /**
	     * The vertically flipped state of the Game Object.
	     * A Game Object that is flipped vertically will render inversed on the vertical axis (i.e. upside down)
	     * Flipping always takes place from the middle of the texture and does not impact the scale value.
	     * 
	     * @name Phaser.GameObjects.Components.Flip#flipY
	     * @type {boolean}
	     * @default false
	     * @since 3.0.0
	     */
	    flipY: false,
	
	    /**
	     * Toggles the horizontal flipped state of this Game Object.
	     * 
	     * @method Phaser.GameObjects.Components.Flip#toggleFlipX
	     * @since 3.0.0
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    toggleFlipX: function ()
	    {
	        this.flipX = !this.flipX;
	
	        return this;
	    },
	
	    /**
	     * Toggles the vertical flipped state of this Game Object.
	     * 
	     * @method Phaser.GameObjects.Components.Flip#toggleFlipY
	     * @since 3.0.0
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    toggleFlipY: function ()
	    {
	        this.flipY = !this.flipY;
	
	        return this;
	    },
	
	    /**
	     * Sets the horizontal flipped state of this Game Object.
	     * 
	     * @method Phaser.GameObjects.Components.Flip#setFlipX
	     * @since 3.0.0
	     *
	     * @param {boolean} value - The flipped state. `false` for no flip, or `true` to be flipped.
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setFlipX: function (value)
	    {
	        this.flipX = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the vertical flipped state of this Game Object.
	     * 
	     * @method Phaser.GameObjects.Components.Flip#setFlipY
	     * @since 3.0.0
	     *
	     * @param {boolean} value - The flipped state. `false` for no flip, or `true` to be flipped.
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setFlipY: function (value)
	    {
	        this.flipY = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the horizontal and vertical flipped state of this Game Object.
	     * 
	     * @method Phaser.GameObjects.Components.Flip#setFlip
	     * @since 3.0.0
	     *
	     * @param {boolean} x - The horizontal flipped state. `false` for no flip, or `true` to be flipped.
	     * @param {boolean} y - The horizontal flipped state. `false` for no flip, or `true` to be flipped.
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setFlip: function (x, y)
	    {
	        this.flipX = x;
	        this.flipY = y;
	
	        return this;
	    },
	
	    /**
	     * Resets the horizontal and vertical flipped state of this Game Object back to their default un-flipped state.
	     * 
	     * @method Phaser.GameObjects.Components.Flip#resetFlip
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    resetFlip: function ()
	    {
	        this.flipX = false;
	        this.flipY = false;
	
	        return this;
	    }
	
	};
	
	module.exports = Flip;


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Rectangle = __webpack_require__(23);
	var RotateAround = __webpack_require__(557);
	var Vector2 = __webpack_require__(9);
	
	/**
	 * Provides methods used for obtaining the bounds of a Game Object.
	 * Should be applied as a mixin and not used directly.
	 *
	 * @name Phaser.GameObjects.Components.GetBounds
	 * @since 3.0.0
	 */
	
	var GetBounds = {
	
	    /**
	     * Gets the center coordinate of this Game Object, regardless of origin.
	     * The returned point is calculated in local space and does not factor in any parent containers
	     *
	     * @method Phaser.GameObjects.Components.GetBounds#getCenter
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [output,$return]
	     *
	     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
	     *
	     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
	     */
	    getCenter: function (output)
	    {
	        if (output === undefined) { output = new Vector2(); }
	
	        output.x = this.x - (this.displayWidth * this.originX) + (this.displayWidth / 2);
	        output.y = this.y - (this.displayHeight * this.originY) + (this.displayHeight / 2);
	
	        return output;
	    },
	
	    /**
	     * Gets the top-left corner coordinate of this Game Object, regardless of origin.
	     * The returned point is calculated in local space and does not factor in any parent containers
	     *
	     * @method Phaser.GameObjects.Components.GetBounds#getTopLeft
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [output,$return]
	     *
	     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
	     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
	     *
	     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
	     */
	    getTopLeft: function (output, includeParent)
	    {
	        if (!output) { output = new Vector2(); }
	        if (includeParent === undefined) { includeParent = false; }
	
	        output.x = this.x - (this.displayWidth * this.originX);
	        output.y = this.y - (this.displayHeight * this.originY);
	
	        if (this.rotation !== 0)
	        {
	            RotateAround(output, this.x, this.y, this.rotation);
	        }
	
	        if (includeParent && this.parentContainer)
	        {
	            var parentMatrix = this.parentContainer.getBoundsTransformMatrix();
	
	            parentMatrix.transformPoint(output.x, output.y, output);
	        }
	
	        return output;
	    },
	
	    /**
	     * Gets the top-right corner coordinate of this Game Object, regardless of origin.
	     * The returned point is calculated in local space and does not factor in any parent containers
	     *
	     * @method Phaser.GameObjects.Components.GetBounds#getTopRight
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [output,$return]
	     *
	     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
	     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
	     *
	     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
	     */
	    getTopRight: function (output, includeParent)
	    {
	        if (!output) { output = new Vector2(); }
	        if (includeParent === undefined) { includeParent = false; }
	
	        output.x = (this.x - (this.displayWidth * this.originX)) + this.displayWidth;
	        output.y = this.y - (this.displayHeight * this.originY);
	
	        if (this.rotation !== 0)
	        {
	            RotateAround(output, this.x, this.y, this.rotation);
	        }
	
	        if (includeParent && this.parentContainer)
	        {
	            var parentMatrix = this.parentContainer.getBoundsTransformMatrix();
	
	            parentMatrix.transformPoint(output.x, output.y, output);
	        }
	
	        return output;
	    },
	
	    /**
	     * Gets the bottom-left corner coordinate of this Game Object, regardless of origin.
	     * The returned point is calculated in local space and does not factor in any parent containers
	     *
	     * @method Phaser.GameObjects.Components.GetBounds#getBottomLeft
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [output,$return]
	     *
	     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
	     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
	     *
	     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
	     */
	    getBottomLeft: function (output, includeParent)
	    {
	        if (!output) { output = new Vector2(); }
	        if (includeParent === undefined) { includeParent = false; }
	
	        output.x = this.x - (this.displayWidth * this.originX);
	        output.y = (this.y - (this.displayHeight * this.originY)) + this.displayHeight;
	
	        if (this.rotation !== 0)
	        {
	            RotateAround(output, this.x, this.y, this.rotation);
	        }
	
	        if (includeParent && this.parentContainer)
	        {
	            var parentMatrix = this.parentContainer.getBoundsTransformMatrix();
	
	            parentMatrix.transformPoint(output.x, output.y, output);
	        }
	
	        return output;
	    },
	
	    /**
	     * Gets the bottom-right corner coordinate of this Game Object, regardless of origin.
	     * The returned point is calculated in local space and does not factor in any parent containers
	     *
	     * @method Phaser.GameObjects.Components.GetBounds#getBottomRight
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Math.Vector2} O - [output,$return]
	     *
	     * @param {(Phaser.Math.Vector2|object)} [output] - An object to store the values in. If not provided a new Vector2 will be created.
	     * @param {boolean} [includeParent=false] - If this Game Object has a parent Container, include it (and all other ancestors) in the resulting vector?
	     *
	     * @return {(Phaser.Math.Vector2|object)} The values stored in the output object.
	     */
	    getBottomRight: function (output, includeParent)
	    {
	        if (!output) { output = new Vector2(); }
	        if (includeParent === undefined) { includeParent = false; }
	
	        output.x = (this.x - (this.displayWidth * this.originX)) + this.displayWidth;
	        output.y = (this.y - (this.displayHeight * this.originY)) + this.displayHeight;
	
	        if (this.rotation !== 0)
	        {
	            RotateAround(output, this.x, this.y, this.rotation);
	        }
	
	        if (includeParent && this.parentContainer)
	        {
	            var parentMatrix = this.parentContainer.getBoundsTransformMatrix();
	
	            parentMatrix.transformPoint(output.x, output.y, output);
	        }
	
	        return output;
	    },
	
	    /**
	     * Gets the bounds of this Game Object, regardless of origin.
	     * The values are stored and returned in a Rectangle, or Rectangle-like, object.
	     *
	     * @method Phaser.GameObjects.Components.GetBounds#getBounds
	     * @since 3.0.0
	     *
	     * @generic {Phaser.Geom.Rectangle} O - [output,$return]
	     *
	     * @param {(Phaser.Geom.Rectangle|object)} [output] - An object to store the values in. If not provided a new Rectangle will be created.
	     *
	     * @return {(Phaser.Geom.Rectangle|object)} The values stored in the output object.
	     */
	    getBounds: function (output)
	    {
	        if (output === undefined) { output = new Rectangle(); }
	
	        //  We can use the output object to temporarily store the x/y coords in:
	
	        var TLx, TLy, TRx, TRy, BLx, BLy, BRx, BRy;
	
	        // Instead of doing a check if parent container is 
	        // defined per corner we only do it once.
	        if (this.parentContainer)
	        {
	            var parentMatrix = this.parentContainer.getBoundsTransformMatrix();
	
	            this.getTopLeft(output);
	            parentMatrix.transformPoint(output.x, output.y, output);
	
	            TLx = output.x;
	            TLy = output.y;
	
	            this.getTopRight(output);
	            parentMatrix.transformPoint(output.x, output.y, output);
	
	            TRx = output.x;
	            TRy = output.y;
	
	            this.getBottomLeft(output);
	            parentMatrix.transformPoint(output.x, output.y, output);
	
	            BLx = output.x;
	            BLy = output.y;
	
	            this.getBottomRight(output);
	            parentMatrix.transformPoint(output.x, output.y, output);
	
	            BRx = output.x;
	            BRy = output.y;
	        }
	        else
	        {
	            this.getTopLeft(output);
	
	            TLx = output.x;
	            TLy = output.y;
	
	            this.getTopRight(output);
	
	            TRx = output.x;
	            TRy = output.y;
	
	            this.getBottomLeft(output);
	
	            BLx = output.x;
	            BLy = output.y;
	
	            this.getBottomRight(output);
	
	            BRx = output.x;
	            BRy = output.y;
	        }
	
	        output.x = Math.min(TLx, TRx, BLx, BRx);
	        output.y = Math.min(TLy, TRy, BLy, BRy);
	        output.width = Math.max(TLx, TRx, BLx, BRx) - output.x;
	        output.height = Math.max(TLy, TRy, BLy, BRy) - output.y;
	
	        return output;
	    }
	
	};
	
	module.exports = GetBounds;


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BitmapMask = __webpack_require__(482);
	var GeometryMask = __webpack_require__(483);
	
	/**
	 * Provides methods used for getting and setting the mask of a Game Object.
	 *
	 * @name Phaser.GameObjects.Components.Mask
	 * @since 3.0.0
	 */
	
	var Mask = {
	
	    /**
	     * The Mask this Game Object is using during render.
	     *
	     * @name Phaser.GameObjects.Components.Mask#mask
	     * @type {Phaser.Display.Masks.BitmapMask|Phaser.Display.Masks.GeometryMask}
	     * @since 3.0.0
	     */
	    mask: null,
	
	    /**
	     * Sets the mask that this Game Object will use to render with.
	     *
	     * The mask must have been previously created and can be either a
	     * GeometryMask or a BitmapMask.
	     *
	     * Note: Bitmap Masks only work on WebGL. Geometry Masks work on both WebGL and Canvas.
	     *
	     * If a mask is already set on this Game Object it will be immediately replaced.
	     *
	     * @method Phaser.GameObjects.Components.Mask#setMask
	     * @since 3.6.2
	     *
	     * @param {Phaser.Display.Masks.BitmapMask|Phaser.Display.Masks.GeometryMask} mask - The mask this Game Object will use when rendering.
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setMask: function (mask)
	    {
	        this.mask = mask;
	
	        return this;
	    },
	
	    /**
	     * Clears the mask that this Game Object was using.
	     *
	     * @method Phaser.GameObjects.Components.Mask#clearMask
	     * @since 3.6.2
	     *
	     * @param {boolean} [destroyMask=false] - Destroy the mask before clearing it?
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    clearMask: function (destroyMask)
	    {
	        if (destroyMask === undefined) { destroyMask = false; }
	
	        if (destroyMask)
	        {
	            this.mask.destroy();
	        }
	
	        this.mask = null;
	
	        return this;
	    },
	
	    /**
	     * Creates and returns a Bitmap Mask. This mask can be used by any Game Object,
	     * including this one.
	     *
	     * To create the mask you need to pass in a reference to a renderable Game Object.
	     * A renderable Game Object is one that uses a texture to render with, such as an
	     * Image, Sprite, Render Texture or BitmapText.
	     *
	     * If you do not provide a renderable object, and this Game Object has a texture,
	     * it will use itself as the object. This means you can call this method to create
	     * a Bitmap Mask from any renderable Game Object.
	     *
	     * @method Phaser.GameObjects.Components.Mask#createBitmapMask
	     * @since 3.6.2
	     * 
	     * @param {Phaser.GameObjects.GameObject} [renderable] - A renderable Game Object that uses a texture, such as a Sprite.
	     *
	     * @return {Phaser.Display.Masks.BitmapMask} This Bitmap Mask that was created.
	     */
	    createBitmapMask: function (renderable)
	    {
	        if (renderable === undefined && this.texture)
	        {
	            // eslint-disable-next-line consistent-this
	            renderable = this;
	        }
	
	        return new BitmapMask(this.scene, renderable);
	    },
	
	    /**
	     * Creates and returns a Geometry Mask. This mask can be used by any Game Object,
	     * including this one.
	     *
	     * To create the mask you need to pass in a reference to a Graphics Game Object.
	     *
	     * If you do not provide a graphics object, and this Game Object is an instance
	     * of a Graphics object, then it will use itself to create the mask.
	     * 
	     * This means you can call this method to create a Geometry Mask from any Graphics Game Object.
	     *
	     * @method Phaser.GameObjects.Components.Mask#createGeometryMask
	     * @since 3.6.2
	     * 
	     * @param {Phaser.GameObjects.Graphics} [graphics] - A Graphics Game Object. The geometry within it will be used as the mask.
	     *
	     * @return {Phaser.Display.Masks.GeometryMask} This Geometry Mask that was created.
	     */
	    createGeometryMask: function (graphics)
	    {
	        if (graphics === undefined && this.type === 'Graphics')
	        {
	            // eslint-disable-next-line consistent-this
	            graphics = this;
	        }
	
	        return new GeometryMask(this.scene, graphics);
	    }
	
	};
	
	module.exports = Mask;


/***/ }),
/* 1130 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Provides methods used for getting and setting the transform values of a Game Object.
	 * Should be applied as a mixin and not used directly.
	 * 
	 * @name Phaser.GameObjects.Components.MatrixStack
	 * @since 3.2.0
	 */
	
	var MatrixStack = {
	
	    /**
	     * [description]
	     * 
	     * @name Phaser.GameObjects.Components.MatrixStack#matrixStack
	     * @type {Float32Array}
	     * @private
	     * @since 3.2.0
	     */
	    matrixStack: null,
	
	    /**
	     * [description]
	     * 
	     * @name Phaser.GameObjects.Components.MatrixStack#currentMatrix
	     * @type {Float32Array}
	     * @private
	     * @since 3.2.0
	     */
	    currentMatrix: null,
	
	    /**
	     * [description]
	     * 
	     * @name Phaser.GameObjects.Components.MatrixStack#currentMatrixIndex
	     * @type {integer}
	     * @private
	     * @since 3.2.0
	     */
	    currentMatrixIndex: 0,
	
	    /**
	     * [description]
	     * 
	     * @method Phaser.GameObjects.Components.MatrixStack#initMatrixStack
	     * @since 3.2.0
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    initMatrixStack: function ()
	    {
	        this.matrixStack = new Float32Array(6000); // up to 1000 matrices
	        this.currentMatrix = new Float32Array([ 1, 0, 0, 1, 0, 0 ]);
	        this.currentMatrixIndex = 0;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     * 
	     * @method Phaser.GameObjects.Components.MatrixStack#save
	     * @since 3.2.0
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    save: function ()
	    {
	        if (this.currentMatrixIndex >= this.matrixStack.length) { return this; }
	
	        var matrixStack = this.matrixStack;
	        var currentMatrix = this.currentMatrix;
	        var currentMatrixIndex = this.currentMatrixIndex;
	        this.currentMatrixIndex += 6;
	
	        matrixStack[currentMatrixIndex + 0] = currentMatrix[0];
	        matrixStack[currentMatrixIndex + 1] = currentMatrix[1];
	        matrixStack[currentMatrixIndex + 2] = currentMatrix[2];
	        matrixStack[currentMatrixIndex + 3] = currentMatrix[3];
	        matrixStack[currentMatrixIndex + 4] = currentMatrix[4];
	        matrixStack[currentMatrixIndex + 5] = currentMatrix[5];
	        
	        return this;
	    },
	
	    /**
	     * [description]
	     * 
	     * @method Phaser.GameObjects.Components.MatrixStack#restore
	     * @since 3.2.0
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    restore: function ()
	    {
	        if (this.currentMatrixIndex <= 0) { return this; }
	
	        this.currentMatrixIndex -= 6;
	
	        var matrixStack = this.matrixStack;
	        var currentMatrix = this.currentMatrix;
	        var currentMatrixIndex = this.currentMatrixIndex;
	
	        currentMatrix[0] = matrixStack[currentMatrixIndex + 0];
	        currentMatrix[1] = matrixStack[currentMatrixIndex + 1];
	        currentMatrix[2] = matrixStack[currentMatrixIndex + 2];
	        currentMatrix[3] = matrixStack[currentMatrixIndex + 3];
	        currentMatrix[4] = matrixStack[currentMatrixIndex + 4];
	        currentMatrix[5] = matrixStack[currentMatrixIndex + 5];
	
	        return this;
	    },
	
	    /**
	     * [description]
	     * 
	     * @method Phaser.GameObjects.Components.MatrixStack#loadIdentity
	     * @since 3.2.0
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    loadIdentity: function ()
	    {
	        this.setTransform(1, 0, 0, 1, 0, 0);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     * 
	     * @method Phaser.GameObjects.Components.MatrixStack#transform
	     * @since 3.2.0
	     *
	     * @param {number} a - [description]
	     * @param {number} b - [description]
	     * @param {number} c - [description]
	     * @param {number} d - [description]
	     * @param {number} tx - [description]
	     * @param {number} ty - [description]
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    transform: function (a, b, c, d, tx, ty)
	    {
	        var currentMatrix = this.currentMatrix;
	        var m0 = currentMatrix[0];
	        var m1 = currentMatrix[1];
	        var m2 = currentMatrix[2];
	        var m3 = currentMatrix[3];
	        var m4 = currentMatrix[4];
	        var m5 = currentMatrix[5];
	
	        currentMatrix[0] = m0 * a + m2 * b;
	        currentMatrix[1] = m1 * a + m3 * b;
	        currentMatrix[2] = m0 * c + m2 * d;
	        currentMatrix[3] = m1 * c + m3 * d;
	        currentMatrix[4] = m0 * tx + m2 * ty + m4;
	        currentMatrix[5] = m1 * tx + m3 * ty + m5;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     * 
	     * @method Phaser.GameObjects.Components.MatrixStack#setTransform
	     * @since 3.2.0
	     *
	     * @param {number} a - [description]
	     * @param {number} b - [description]
	     * @param {number} c - [description]
	     * @param {number} d - [description]
	     * @param {number} tx - [description]
	     * @param {number} ty - [description]
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setTransform: function (a, b, c, d, tx, ty)
	    {
	        var currentMatrix = this.currentMatrix;
	
	        currentMatrix[0] = a;
	        currentMatrix[1] = b;
	        currentMatrix[2] = c;
	        currentMatrix[3] = d;
	        currentMatrix[4] = tx;
	        currentMatrix[5] = ty;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     * 
	     * @method Phaser.GameObjects.Components.MatrixStack#translate
	     * @since 3.2.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    translate: function (x, y)
	    {
	        var currentMatrix = this.currentMatrix;
	        var m0 = currentMatrix[0];
	        var m1 = currentMatrix[1];
	        var m2 = currentMatrix[2];
	        var m3 = currentMatrix[3];
	        var m4 = currentMatrix[4];
	        var m5 = currentMatrix[5];
	
	        currentMatrix[4] = m0 * x + m2 * y + m4;
	        currentMatrix[5] = m1 * x + m3 * y + m5;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     * 
	     * @method Phaser.GameObjects.Components.MatrixStack#scale
	     * @since 3.2.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    scale: function (x, y)
	    {
	        var currentMatrix = this.currentMatrix;
	        var m0 = currentMatrix[0];
	        var m1 = currentMatrix[1];
	        var m2 = currentMatrix[2];
	        var m3 = currentMatrix[3];
	
	        currentMatrix[0] = m0 * x;
	        currentMatrix[1] = m1 * x;
	        currentMatrix[2] = m2 * y;
	        currentMatrix[3] = m3 * y;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     * 
	     * @method Phaser.GameObjects.Components.MatrixStack#rotate
	     * @since 3.2.0
	     *
	     * @param {number} t - The angle of rotation, in radians.
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    rotate: function (t)
	    {
	        var currentMatrix = this.currentMatrix;
	        var m0 = currentMatrix[0];
	        var m1 = currentMatrix[1];
	        var m2 = currentMatrix[2];
	        var m3 = currentMatrix[3];
	        var st = Math.sin(t);
	        var ct = Math.cos(t);
	
	        currentMatrix[0] = m0 * ct + m2 * st;
	        currentMatrix[1] = m1 * ct + m3 * st;
	        currentMatrix[2] = m0 * -st + m2 * ct;
	        currentMatrix[3] = m1 * -st + m3 * ct;
	
	        return this;
	    }
	
	};
	
	module.exports = MatrixStack;


/***/ }),
/* 1131 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Provides methods used for getting and setting the origin of a Game Object.
	 * Values are normalized, given in the range 0 to 1.
	 * Display values contain the calculated pixel values.
	 * Should be applied as a mixin and not used directly.
	 *
	 * @name Phaser.GameObjects.Components.Origin
	 * @since 3.0.0
	 */
	
	var Origin = {
	
	    /**
	     * A property indicating that a Game Object has this component.
	     *
	     * @name Phaser.GameObjects.Components.Origin#_originComponent
	     * @type {boolean}
	     * @private
	     * @default true
	     * @since 3.2.0
	     */
	    _originComponent: true,
	
	    /**
	     * The horizontal origin of this Game Object.
	     * The origin maps the relationship between the size and position of the Game Object.
	     * The default value is 0.5, meaning all Game Objects are positioned based on their center.
	     * Setting the value to 0 means the position now relates to the left of the Game Object.
	     *
	     * @name Phaser.GameObjects.Components.Origin#originX
	     * @type {float}
	     * @default 0.5
	     * @since 3.0.0
	     */
	    originX: 0.5,
	
	    /**
	     * The vertical origin of this Game Object.
	     * The origin maps the relationship between the size and position of the Game Object.
	     * The default value is 0.5, meaning all Game Objects are positioned based on their center.
	     * Setting the value to 0 means the position now relates to the top of the Game Object.
	     *
	     * @name Phaser.GameObjects.Components.Origin#originY
	     * @type {float}
	     * @default 0.5
	     * @since 3.0.0
	     */
	    originY: 0.5,
	
	    //  private + read only
	    _displayOriginX: 0,
	    _displayOriginY: 0,
	
	    /**
	     * The horizontal display origin of this Game Object.
	     * The origin is a normalized value between 0 and 1.
	     * The displayOrigin is a pixel value, based on the size of the Game Object combined with the origin.
	     *
	     * @name Phaser.GameObjects.Components.Origin#displayOriginX
	     * @type {float}
	     * @since 3.0.0
	     */
	    displayOriginX: {
	
	        get: function ()
	        {
	            return this._displayOriginX;
	        },
	
	        set: function (value)
	        {
	            this._displayOriginX = value;
	            this.originX = value / this.width;
	        }
	
	    },
	
	    /**
	     * The vertical display origin of this Game Object.
	     * The origin is a normalized value between 0 and 1.
	     * The displayOrigin is a pixel value, based on the size of the Game Object combined with the origin.
	     *
	     * @name Phaser.GameObjects.Components.Origin#displayOriginY
	     * @type {float}
	     * @since 3.0.0
	     */
	    displayOriginY: {
	
	        get: function ()
	        {
	            return this._displayOriginY;
	        },
	
	        set: function (value)
	        {
	            this._displayOriginY = value;
	            this.originY = value / this.height;
	        }
	
	    },
	
	    /**
	     * Sets the origin of this Game Object.
	     *
	     * The values are given in the range 0 to 1.
	     *
	     * @method Phaser.GameObjects.Components.Origin#setOrigin
	     * @since 3.0.0
	     *
	     * @param {number} [x=0.5] - The horizontal origin value.
	     * @param {number} [y=x] - The vertical origin value. If not defined it will be set to the value of `x`.
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setOrigin: function (x, y)
	    {
	        if (x === undefined) { x = 0.5; }
	        if (y === undefined) { y = x; }
	
	        this.originX = x;
	        this.originY = y;
	
	        return this.updateDisplayOrigin();
	    },
	
	    /**
	     * Sets the origin of this Game Object based on the Pivot values in its Frame.
	     *
	     * @method Phaser.GameObjects.Components.Origin#setOriginFromFrame
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setOriginFromFrame: function ()
	    {
	        if (!this.frame || !this.frame.customPivot)
	        {
	            return this.setOrigin();
	        }
	        else
	        {
	            this.originX = this.frame.pivotX;
	            this.originY = this.frame.pivotY;
	        }
	
	        return this.updateDisplayOrigin();
	    },
	
	    /**
	     * Sets the display origin of this Game Object.
	     * The difference between this and setting the origin is that you can use pixel values for setting the display origin.
	     *
	     * @method Phaser.GameObjects.Components.Origin#setDisplayOrigin
	     * @since 3.0.0
	     *
	     * @param {number} [x=0] - The horizontal display origin value.
	     * @param {number} [y=x] - The vertical display origin value. If not defined it will be set to the value of `x`.
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setDisplayOrigin: function (x, y)
	    {
	        if (x === undefined) { x = 0; }
	        if (y === undefined) { y = x; }
	
	        this.displayOriginX = x;
	        this.displayOriginY = y;
	
	        return this;
	    },
	
	    /**
	     * Updates the Display Origin cached values internally stored on this Game Object.
	     * You don't usually call this directly, but it is exposed for edge-cases where you may.
	     *
	     * @method Phaser.GameObjects.Components.Origin#updateDisplayOrigin
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    updateDisplayOrigin: function ()
	    {
	        this._displayOriginX = Math.round(this.originX * this.width);
	        this._displayOriginY = Math.round(this.originY * this.height);
	
	        return this;
	    }
	
	};
	
	module.exports = Origin;


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var ScaleModes = __webpack_require__(167);
	
	/**
	 * Provides methods used for getting and setting the scale of a Game Object.
	 *
	 * @name Phaser.GameObjects.Components.ScaleMode
	 * @since 3.0.0
	 */
	
	var ScaleMode = {
	
	    _scaleMode: ScaleModes.DEFAULT,
	
	    /**
	     * The Scale Mode being used by this Game Object.
	     * Can be either `ScaleModes.LINEAR` or `ScaleModes.NEAREST`.
	     *
	     * @name Phaser.GameObjects.Components.ScaleMode#scaleMode
	     * @type {Phaser.ScaleModes}
	     * @since 3.0.0
	     */
	    scaleMode: {
	
	        get: function ()
	        {
	            return this._scaleMode;
	        },
	
	        set: function (value)
	        {
	            if (value === ScaleModes.LINEAR || value === ScaleModes.NEAREST)
	            {
	                this._scaleMode = value;
	            }
	        }
	
	    },
	
	    /**
	     * Sets the Scale Mode being used by this Game Object.
	     * Can be either `ScaleModes.LINEAR` or `ScaleModes.NEAREST`.
	     *
	     * @method Phaser.GameObjects.Components.ScaleMode#setScaleMode
	     * @since 3.0.0
	     *
	     * @param {Phaser.ScaleModes} value - The Scale Mode to be used by this Game Object.
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setScaleMode: function (value)
	    {
	        this.scaleMode = value;
	
	        return this;
	    }
	
	};
	
	module.exports = ScaleMode;


/***/ }),
/* 1133 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Provides methods used for getting and setting the Scroll Factor of a Game Object.
	 *
	 * @name Phaser.GameObjects.Components.ScrollFactor
	 * @since 3.0.0
	 */
	
	var ScrollFactor = {
	
	    /**
	     * The horizontal scroll factor of this Game Object.
	     *
	     * The scroll factor controls the influence of the movement of a Camera upon this Game Object.
	     *
	     * When a camera scrolls it will change the location at which this Game Object is rendered on-screen.
	     * It does not change the Game Objects actual position values.
	     *
	     * A value of 1 means it will move exactly in sync with a camera.
	     * A value of 0 means it will not move at all, even if the camera moves.
	     * Other values control the degree to which the camera movement is mapped to this Game Object.
	     *
	     * @name Phaser.GameObjects.Components.ScrollFactor#scrollFactorX
	     * @type {number}
	     * @default 1
	     * @since 3.0.0
	     */
	    scrollFactorX: 1,
	
	    /**
	     * The vertical scroll factor of this Game Object.
	     *
	     * The scroll factor controls the influence of the movement of a Camera upon this Game Object.
	     *
	     * When a camera scrolls it will change the location at which this Game Object is rendered on-screen.
	     * It does not change the Game Objects actual position values.
	     *
	     * A value of 1 means it will move exactly in sync with a camera.
	     * A value of 0 means it will not move at all, even if the camera moves.
	     * Other values control the degree to which the camera movement is mapped to this Game Object.
	     *
	     * @name Phaser.GameObjects.Components.ScrollFactor#scrollFactorY
	     * @type {number}
	     * @default 1
	     * @since 3.0.0
	     */
	    scrollFactorY: 1,
	
	    /**
	     * Sets the scroll factor of this Game Object.
	     *
	     * The scroll factor controls the influence of the movement of a Camera upon this Game Object.
	     *
	     * When a camera scrolls it will change the location at which this Game Object is rendered on-screen.
	     * It does not change the Game Objects actual position values.
	     *
	     * A value of 1 means it will move exactly in sync with a camera.
	     * A value of 0 means it will not move at all, even if the camera moves.
	     * Other values control the degree to which the camera movement is mapped to this Game Object.
	     *
	     * @method Phaser.GameObjects.Components.ScrollFactor#setScrollFactor
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal scroll factor of this Game Object.
	     * @param {number} [y=x] - The vertical scroll factor of this Game Object. If not set it will use the `x` value.
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setScrollFactor: function (x, y)
	    {
	        if (y === undefined) { y = x; }
	
	        this.scrollFactorX = x;
	        this.scrollFactorY = y;
	
	        return this;
	    }
	
	};
	
	module.exports = ScrollFactor;


/***/ }),
/* 1134 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Provides methods used for getting and setting the size of a Game Object.
	 * 
	 * @name Phaser.GameObjects.Components.Size
	 * @since 3.0.0
	 */
	
	var Size = {
	
	    /**
	     * A property indicating that a Game Object has this component.
	     * 
	     * @name Phaser.GameObjects.Components.Size#_sizeComponent
	     * @type {boolean}
	     * @private
	     * @default true
	     * @since 3.2.0
	     */
	    _sizeComponent: true,
	
	    /**
	     * The native (un-scaled) width of this Game Object.
	     * 
	     * @name Phaser.GameObjects.Components.Size#width
	     * @type {number}
	     * @since 3.0.0
	     */
	    width: 0,
	
	    /**
	     * The native (un-scaled) height of this Game Object.
	     * 
	     * @name Phaser.GameObjects.Components.Size#height
	     * @type {number}
	     * @since 3.0.0
	     */
	    height: 0,
	
	    /**
	     * The displayed width of this Game Object.
	     * This value takes into account the scale factor.
	     * 
	     * @name Phaser.GameObjects.Components.Size#displayWidth
	     * @type {number}
	     * @since 3.0.0
	     */
	    displayWidth: {
	
	        get: function ()
	        {
	            return this.scaleX * this.frame.realWidth;
	        },
	
	        set: function (value)
	        {
	            this.scaleX = value / this.frame.realWidth;
	        }
	
	    },
	
	    /**
	     * The displayed height of this Game Object.
	     * This value takes into account the scale factor.
	     * 
	     * @name Phaser.GameObjects.Components.Size#displayHeight
	     * @type {number}
	     * @since 3.0.0
	     */
	    displayHeight: {
	
	        get: function ()
	        {
	            return this.scaleY * this.frame.realHeight;
	        },
	
	        set: function (value)
	        {
	            this.scaleY = value / this.frame.realHeight;
	        }
	
	    },
	
	    /**
	     * Sets the size of this Game Object to be that of the given Frame.
	     * 
	     * @method Phaser.GameObjects.Components.Size#setSizeToFrame
	     * @since 3.0.0
	     *
	     * @param {Phaser.Textures.Frame} frame - The frame to base the size of this Game Object on.
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setSizeToFrame: function (frame)
	    {
	        if (frame === undefined) { frame = this.frame; }
	
	        this.width = frame.realWidth;
	        this.height = frame.realHeight;
	
	        return this;
	    },
	
	    /**
	     * Sets the size of this Game Object.
	     * 
	     * @method Phaser.GameObjects.Components.Size#setSize
	     * @since 3.0.0
	     *
	     * @param {number} width - The width of this Game Object.
	     * @param {number} height - The height of this Game Object.
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setSize: function (width, height)
	    {
	        this.width = width;
	        this.height = height;
	
	        return this;
	    },
	
	    /**
	     * Sets the display size of this Game Object.
	     * Calling this will adjust the scale.
	     * 
	     * @method Phaser.GameObjects.Components.Size#setDisplaySize
	     * @since 3.0.0
	     *
	     * @param {number} width - The width of this Game Object.
	     * @param {number} height - The height of this Game Object.
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setDisplaySize: function (width, height)
	    {
	        this.displayWidth = width;
	        this.displayHeight = height;
	
	        return this;
	    }
	
	};
	
	module.exports = Size;


/***/ }),
/* 1135 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  bitmask flag for GameObject.renderMask
	var _FLAG = 8; // 1000
	
	/**
	 * Provides methods used for getting and setting the texture of a Game Object.
	 *
	 * @name Phaser.GameObjects.Components.Texture
	 * @since 3.0.0
	 */
	
	var Texture = {
	
	    /**
	     * The Texture this Game Object is using to render with.
	     *
	     * @name Phaser.GameObjects.Components.Texture#texture
	     * @type {Phaser.Textures.Texture|Phaser.Textures.CanvasTexture}
	     * @since 3.0.0
	     */
	    texture: null,
	
	    /**
	     * The Texture Frame this Game Object is using to render with.
	     *
	     * @name Phaser.GameObjects.Components.Texture#frame
	     * @type {Phaser.Textures.Frame}
	     * @since 3.0.0
	     */
	    frame: null,
	
	    /**
	     * Sets the texture and frame this Game Object will use to render with.
	     *
	     * Textures are referenced by their string-based keys, as stored in the Texture Manager.
	     *
	     * @method Phaser.GameObjects.Components.Texture#setTexture
	     * @since 3.0.0
	     *
	     * @param {string} key - The key of the texture to be used, as stored in the Texture Manager.
	     * @param {(string|integer)} [frame] - The name or index of the frame within the Texture.
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setTexture: function (key, frame)
	    {
	        this.texture = this.scene.sys.textures.get(key);
	
	        return this.setFrame(frame);
	    },
	
	    /**
	     * Sets the frame this Game Object will use to render with.
	     *
	     * The Frame has to belong to the current Texture being used.
	     *
	     * It can be either a string or an index.
	     *
	     * Calling `setFrame` will modify the `width` and `height` properties of your Game Object.
	     * It will also change the `origin` if the Frame has a custom pivot point, as exported from packages like Texture Packer.
	     *
	     * @method Phaser.GameObjects.Components.Texture#setFrame
	     * @since 3.0.0
	     *
	     * @param {(string|integer)} frame - The name or index of the frame within the Texture.
	     * @param {boolean} [updateSize=true] - Should this call adjust the size of the Game Object?
	     * @param {boolean} [updateOrigin=true] - Should this call adjust the origin of the Game Object?
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setFrame: function (frame, updateSize, updateOrigin)
	    {
	        if (updateSize === undefined) { updateSize = true; }
	        if (updateOrigin === undefined) { updateOrigin = true; }
	
	        this.frame = this.texture.get(frame);
	
	        if (!this.frame.cutWidth || !this.frame.cutHeight)
	        {
	            this.renderFlags &= ~_FLAG;
	        }
	        else
	        {
	            this.renderFlags |= _FLAG;
	        }
	
	        if (this._sizeComponent && updateSize)
	        {
	            this.setSizeToFrame();
	        }
	
	        if (this._originComponent && updateOrigin)
	        {
	            if (this.frame.customPivot)
	            {
	                this.setOrigin(this.frame.pivotX, this.frame.pivotY);
	            }
	            else
	            {
	                this.updateDisplayOrigin();
	            }
	        }
	
	        return this;
	    }
	
	};
	
	module.exports = Texture;


/***/ }),
/* 1136 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @function GetColor
	 * @since 3.0.0
	 * @private
	 */
	var GetColor = function (value)
	{
	    return (value >> 16) + (value & 0xff00) + ((value & 0xff) << 16);
	};
	
	/**
	 * Provides methods used for setting the tint of a Game Object.
	 * Should be applied as a mixin and not used directly.
	 * 
	 * @name Phaser.GameObjects.Components.Tint
	 * @webglOnly
	 * @since 3.0.0
	 */
	
	var Tint = {
	
	    /**
	     * Private internal value. Holds the top-left tint value.
	     * 
	     * @name Phaser.GameObjects.Components.Tint#_tintTL
	     * @type {number}
	     * @private
	     * @default 16777215
	     * @since 3.0.0
	     */
	    _tintTL: 16777215,
	
	    /**
	     * Private internal value. Holds the top-right tint value.
	     * 
	     * @name Phaser.GameObjects.Components.Tint#_tintTR
	     * @type {number}
	     * @private
	     * @default 16777215
	     * @since 3.0.0
	     */
	    _tintTR: 16777215,
	
	    /**
	     * Private internal value. Holds the bottom-left tint value.
	     * 
	     * @name Phaser.GameObjects.Components.Tint#_tintBL
	     * @type {number}
	     * @private
	     * @default 16777215
	     * @since 3.0.0
	     */
	    _tintBL: 16777215,
	
	    /**
	     * Private internal value. Holds the bottom-right tint value.
	     * 
	     * @name Phaser.GameObjects.Components.Tint#_tintBR
	     * @type {number}
	     * @private
	     * @default 16777215
	     * @since 3.0.0
	     */
	    _tintBR: 16777215,
	
	    /**
	     * Clears all tint values associated with this Game Object.
	     * Immediately sets the alpha levels back to 0xffffff (no tint)
	     *
	     * @method Phaser.GameObjects.Components.Tint#clearTint
	     * @webglOnly
	     * @since 3.0.0
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    clearTint: function ()
	    {
	        this.setTint(0xffffff);
	
	        return this;
	    },
	
	    /**
	     * Sets the tint values for this Game Object.
	     *
	     * @method Phaser.GameObjects.Components.Tint#setTint
	     * @webglOnly
	     * @since 3.0.0
	     *
	     * @param {integer} [topLeft=0xffffff] - The tint being applied to the top-left of the Game Object. If not other values are given this value is applied evenly, tinting the whole Game Object.
	     * @param {integer} [topRight] - The tint being applied to the top-right of the Game Object.
	     * @param {integer} [bottomLeft] - The tint being applied to the bottom-left of the Game Object.
	     * @param {integer} [bottomRight] - The tint being applied to the bottom-right of the Game Object.
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setTint: function (topLeft, topRight, bottomLeft, bottomRight)
	    {
	        if (topLeft === undefined) { topLeft = 0xffffff; }
	
	        if (topRight === undefined)
	        {
	            topRight = topLeft;
	            bottomLeft = topLeft;
	            bottomRight = topLeft;
	        }
	
	        this._tintTL = GetColor(topLeft);
	        this._tintTR = GetColor(topRight);
	        this._tintBL = GetColor(bottomLeft);
	        this._tintBR = GetColor(bottomRight);
	
	        return this;
	    },
	
	    /**
	     * The tint value being applied to the top-left of the Game Object.
	     * This value is interpolated from the corner to the center of the Game Object.
	     * 
	     * @name Phaser.GameObjects.Components.Tint#tintTopLeft
	     * @type {integer}
	     * @webglOnly
	     * @since 3.0.0
	     */
	    tintTopLeft: {
	
	        get: function ()
	        {
	            return this._tintTL;
	        },
	
	        set: function (value)
	        {
	            this._tintTL = GetColor(value);
	        }
	
	    },
	
	    /**
	     * The tint value being applied to the top-right of the Game Object.
	     * This value is interpolated from the corner to the center of the Game Object.
	     * 
	     * @name Phaser.GameObjects.Components.Tint#tintTopRight
	     * @type {integer}
	     * @webglOnly
	     * @since 3.0.0
	     */
	    tintTopRight: {
	
	        get: function ()
	        {
	            return this._tintTR;
	        },
	
	        set: function (value)
	        {
	            this._tintTR = GetColor(value);
	        }
	
	    },
	
	    /**
	     * The tint value being applied to the bottom-left of the Game Object.
	     * This value is interpolated from the corner to the center of the Game Object.
	     * 
	     * @name Phaser.GameObjects.Components.Tint#tintBottomLeft
	     * @type {integer}
	     * @webglOnly
	     * @since 3.0.0
	     */
	    tintBottomLeft: {
	
	        get: function ()
	        {
	            return this._tintBL;
	        },
	
	        set: function (value)
	        {
	            this._tintBL = GetColor(value);
	        }
	
	    },
	
	    /**
	     * The tint value being applied to the bottom-right of the Game Object.
	     * This value is interpolated from the corner to the center of the Game Object.
	     * 
	     * @name Phaser.GameObjects.Components.Tint#tintBottomRight
	     * @type {integer}
	     * @webglOnly
	     * @since 3.0.0
	     */
	    tintBottomRight: {
	
	        get: function ()
	        {
	            return this._tintBR;
	        },
	
	        set: function (value)
	        {
	            this._tintBR = GetColor(value);
	        }
	
	    },
	
	    /**
	     * The tint value being applied to the whole of the Game Object.
	     * 
	     * @name Phaser.GameObjects.Components.Tint#tint
	     * @type {integer}
	     * @webglOnly
	     * @since 3.0.0
	     */
	    tint: {
	
	        set: function (value)
	        {
	            this.setTint(value, value, value, value);
	        }
	    }
	
	};
	
	module.exports = Tint;


/***/ }),
/* 1137 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @typedef {object} JSONGameObject
	 *
	 * @property {string} name - The name of this Game Object.
	 * @property {string} type - A textual representation of this Game Object, i.e. `sprite`.
	 * @property {number} x - The x position of this Game Object.
	 * @property {number} y - The y position of this Game Object.
	 * @property {object} scale - The scale of this Game Object
	 * @property {number} scale.x - The horizontal scale of this Game Object.
	 * @property {number} scale.y - The vertical scale of this Game Object.
	 * @property {object} origin - The origin of this Game Object.
	 * @property {float} origin.x - The horizontal origin of this Game Object.
	 * @property {float} origin.y - The vertical origin of this Game Object.
	 * @property {boolean} flipX - The horizontally flipped state of the Game Object.
	 * @property {boolean} flipY - The vertically flipped state of the Game Object.
	 * @property {number} rotation - The angle of this Game Object in radians.
	 * @property {float} alpha - The alpha value of the Game Object.
	 * @property {boolean} visible - The visible state of the Game Object.
	 * @property {integer} scaleMode - The Scale Mode being used by this Game Object.
	 * @property {(integer|string)} blendMode - Sets the Blend Mode being used by this Game Object.
	 * @property {string} textureKey - The texture key of this Game Object.
	 * @property {string} frameKey - The frame key of this Game Object.
	 * @property {object} data - The data of this Game Object.
	 */
	
	//  Default Game Object JSON export
	//  Is extended further by Game Object specific implementations
	
	/**
	 * [description]
	 *
	 * @method Phaser.GameObjects.Components.ToJSON
	 * @since 3.0.0
	 *
	 * @param {Phaser.GameObjects.GameObject} gameObject - [description]
	 *
	 * @return {JSONGameObject} [description]
	 */
	var ToJSON = function (gameObject)
	{
	    var out = {
	        name: gameObject.name,
	        type: gameObject.type,
	        x: gameObject.x,
	        y: gameObject.y,
	        depth: gameObject.depth,
	        scale: {
	            x: gameObject.scaleX,
	            y: gameObject.scaleY
	        },
	        origin: {
	            x: gameObject.originX,
	            y: gameObject.originY
	        },
	        flipX: gameObject.flipX,
	        flipY: gameObject.flipY,
	        rotation: gameObject.rotation,
	        alpha: gameObject.alpha,
	        visible: gameObject.visible,
	        scaleMode: gameObject.scaleMode,
	        blendMode: gameObject.blendMode,
	        textureKey: '',
	        frameKey: '',
	        data: {}
	    };
	
	    if (gameObject.texture)
	    {
	        out.textureKey = gameObject.texture.key;
	        out.frameKey = gameObject.frame.name;
	    }
	
	    return out;
	};
	
	module.exports = ToJSON;


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var MATH_CONST = __webpack_require__(33);
	var TransformMatrix = __webpack_require__(158);
	var WrapAngle = __webpack_require__(311);
	var WrapAngleDegrees = __webpack_require__(312);
	
	//  global bitmask flag for GameObject.renderMask (used by Scale)
	var _FLAG = 4; // 0100
	
	/**
	 * Provides methods used for getting and setting the position, scale and rotation of a Game Object.
	 *
	 * @name Phaser.GameObjects.Components.Transform
	 * @since 3.0.0
	 */
	
	var Transform = {
	
	    /**
	     * Private internal value. Holds the horizontal scale value.
	     * 
	     * @name Phaser.GameObjects.Components.Transform#_scaleX
	     * @type {float}
	     * @private
	     * @default 1
	     * @since 3.0.0
	     */
	    _scaleX: 1,
	
	    /**
	     * Private internal value. Holds the vertical scale value.
	     * 
	     * @name Phaser.GameObjects.Components.Transform#_scaleY
	     * @type {float}
	     * @private
	     * @default 1
	     * @since 3.0.0
	     */
	    _scaleY: 1,
	
	    /**
	     * Private internal value. Holds the rotation value in radians.
	     * 
	     * @name Phaser.GameObjects.Components.Transform#_rotation
	     * @type {float}
	     * @private
	     * @default 0
	     * @since 3.0.0
	     */
	    _rotation: 0,
	
	    /**
	     * The x position of this Game Object.
	     *
	     * @name Phaser.GameObjects.Components.Transform#x
	     * @type {number}
	     * @default 0
	     * @since 3.0.0
	     */
	    x: 0,
	
	    /**
	     * The y position of this Game Object.
	     *
	     * @name Phaser.GameObjects.Components.Transform#y
	     * @type {number}
	     * @default 0
	     * @since 3.0.0
	     */
	    y: 0,
	
	    /**
	     * The z position of this Game Object.
	     * Note: Do not use this value to set the z-index, instead see the `depth` property.
	     *
	     * @name Phaser.GameObjects.Components.Transform#z
	     * @type {number}
	     * @default 0
	     * @since 3.0.0
	     */
	    z: 0,
	
	    /**
	     * The w position of this Game Object.
	     *
	     * @name Phaser.GameObjects.Components.Transform#w
	     * @type {number}
	     * @default 0
	     * @since 3.0.0
	     */
	    w: 0,
	
	    /**
	     * The horizontal scale of this Game Object.
	     *
	     * @name Phaser.GameObjects.Components.Transform#scaleX
	     * @type {number}
	     * @default 1
	     * @since 3.0.0
	     */
	    scaleX: {
	
	        get: function ()
	        {
	            return this._scaleX;
	        },
	
	        set: function (value)
	        {
	            this._scaleX = value;
	
	            if (this._scaleX === 0)
	            {
	                this.renderFlags &= ~_FLAG;
	            }
	            else
	            {
	                this.renderFlags |= _FLAG;
	            }
	        }
	
	    },
	
	    /**
	     * The vertical scale of this Game Object.
	     *
	     * @name Phaser.GameObjects.Components.Transform#scaleY
	     * @type {number}
	     * @default 1
	     * @since 3.0.0
	     */
	    scaleY: {
	
	        get: function ()
	        {
	            return this._scaleY;
	        },
	
	        set: function (value)
	        {
	            this._scaleY = value;
	
	            if (this._scaleY === 0)
	            {
	                this.renderFlags &= ~_FLAG;
	            }
	            else
	            {
	                this.renderFlags |= _FLAG;
	            }
	        }
	
	    },
	
	    /**
	     * The angle of this Game Object as expressed in degrees.
	     *
	     * Where 0 is to the right, 90 is down, 180 is left.
	     *
	     * If you prefer to work in radians, see the `rotation` property instead.
	     *
	     * @name Phaser.GameObjects.Components.Transform#angle
	     * @type {integer}
	     * @default 0
	     * @since 3.0.0
	     */
	    angle: {
	
	        get: function ()
	        {
	            return WrapAngleDegrees(this._rotation * MATH_CONST.RAD_TO_DEG);
	        },
	
	        set: function (value)
	        {
	            //  value is in degrees
	            this.rotation = WrapAngleDegrees(value) * MATH_CONST.DEG_TO_RAD;
	        }
	    },
	
	    /**
	     * The angle of this Game Object in radians.
	     *
	     * If you prefer to work in degrees, see the `angle` property instead.
	     *
	     * @name Phaser.GameObjects.Components.Transform#rotation
	     * @type {number}
	     * @default 1
	     * @since 3.0.0
	     */
	    rotation: {
	
	        get: function ()
	        {
	            return this._rotation;
	        },
	
	        set: function (value)
	        {
	            //  value is in radians
	            this._rotation = WrapAngle(value);
	        }
	    },
	
	    /**
	     * Sets the position of this Game Object.
	     *
	     * @method Phaser.GameObjects.Components.Transform#setPosition
	     * @since 3.0.0
	     *
	     * @param {number} [x=0] - The x position of this Game Object.
	     * @param {number} [y=x] - The y position of this Game Object. If not set it will use the `x` value.
	     * @param {number} [z=0] - The z position of this Game Object.
	     * @param {number} [w=0] - The w position of this Game Object.
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setPosition: function (x, y, z, w)
	    {
	        if (x === undefined) { x = 0; }
	        if (y === undefined) { y = x; }
	        if (z === undefined) { z = 0; }
	        if (w === undefined) { w = 0; }
	
	        this.x = x;
	        this.y = y;
	        this.z = z;
	        this.w = w;
	
	        return this;
	    },
	
	    /**
	     * Sets the position of this Game Object to be a random position within the confines of
	     * the given area.
	     * 
	     * If no area is specified a random position between 0 x 0 and the game width x height is used instead.
	     *
	     * The position does not factor in the size of this Game Object, meaning that only the origin is
	     * guaranteed to be within the area.
	     *
	     * @method Phaser.GameObjects.Components.Transform#setRandomPosition
	     * @since 3.8.0
	     *
	     * @param {number} [x=0] - The x position of the top-left of the random area.
	     * @param {number} [y=0] - The y position of the top-left of the random area.
	     * @param {number} [width] - The width of the random area.
	     * @param {number} [height] - The height of the random area.
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setRandomPosition: function (x, y, width, height)
	    {
	        if (x === undefined) { x = 0; }
	        if (y === undefined) { y = 0; }
	        if (width === undefined) { width = this.scene.sys.game.config.width; }
	        if (height === undefined) { height = this.scene.sys.game.config.height; }
	
	        this.x = x + (Math.random() * width);
	        this.y = y + (Math.random() * height);
	
	        return this;
	    },
	
	    /**
	     * Sets the rotation of this Game Object.
	     *
	     * @method Phaser.GameObjects.Components.Transform#setRotation
	     * @since 3.0.0
	     *
	     * @param {number} [radians=0] - The rotation of this Game Object, in radians.
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setRotation: function (radians)
	    {
	        if (radians === undefined) { radians = 0; }
	
	        this.rotation = radians;
	
	        return this;
	    },
	
	    /**
	     * Sets the angle of this Game Object.
	     *
	     * @method Phaser.GameObjects.Components.Transform#setAngle
	     * @since 3.0.0
	     *
	     * @param {number} [degrees=0] - The rotation of this Game Object, in degrees.
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setAngle: function (degrees)
	    {
	        if (degrees === undefined) { degrees = 0; }
	
	        this.angle = degrees;
	
	        return this;
	    },
	
	    /**
	     * Sets the scale of this Game Object.
	     *
	     * @method Phaser.GameObjects.Components.Transform#setScale
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal scale of this Game Object.
	     * @param {number} [y=x] - The vertical scale of this Game Object. If not set it will use the `x` value.
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setScale: function (x, y)
	    {
	        if (x === undefined) { x = 1; }
	        if (y === undefined) { y = x; }
	
	        this.scaleX = x;
	        this.scaleY = y;
	
	        return this;
	    },
	
	    /**
	     * Sets the x position of this Game Object.
	     *
	     * @method Phaser.GameObjects.Components.Transform#setX
	     * @since 3.0.0
	     *
	     * @param {number} [value=0] - The x position of this Game Object.
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setX: function (value)
	    {
	        if (value === undefined) { value = 0; }
	
	        this.x = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the y position of this Game Object.
	     *
	     * @method Phaser.GameObjects.Components.Transform#setY
	     * @since 3.0.0
	     *
	     * @param {number} [value=0] - The y position of this Game Object.
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setY: function (value)
	    {
	        if (value === undefined) { value = 0; }
	
	        this.y = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the z position of this Game Object.
	     *
	     * @method Phaser.GameObjects.Components.Transform#setZ
	     * @since 3.0.0
	     *
	     * @param {number} [value=0] - The z position of this Game Object.
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setZ: function (value)
	    {
	        if (value === undefined) { value = 0; }
	
	        this.z = value;
	
	        return this;
	    },
	
	    /**
	     * Sets the w position of this Game Object.
	     *
	     * @method Phaser.GameObjects.Components.Transform#setW
	     * @since 3.0.0
	     *
	     * @param {number} [value=0] - The w position of this Game Object.
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setW: function (value)
	    {
	        if (value === undefined) { value = 0; }
	
	        this.w = value;
	
	        return this;
	    },
	
	    /**
	     * Gets the local transform matrix for this Game Object.
	     *
	     * @method Phaser.GameObjects.Components.Transform#getLocalTransformMatrix
	     * @since 3.4.0
	     *
	     * @param {Phaser.GameObjects.Components.TransformMatrix} [tempMatrix] - The matrix to populate with the values from this Game Object.
	     *
	     * @return {Phaser.GameObjects.Components.TransformMatrix} The populated Transform Matrix.
	     */
	    getLocalTransformMatrix: function (tempMatrix)
	    {
	        if (tempMatrix === undefined) { tempMatrix = new TransformMatrix(); }
	
	        return tempMatrix.applyITRS(this.x, this.y, this._rotation, this._scaleX, this._scaleY);
	    },
	
	    /**
	     * Gets the world transform matrix for this Game Object, factoring in any parent Containers.
	     *
	     * @method Phaser.GameObjects.Components.Transform#getWorldTransformMatrix
	     * @since 3.4.0
	     *
	     * @param {Phaser.GameObjects.Components.TransformMatrix} [tempMatrix] - The matrix to populate with the values from this Game Object.
	     *
	     * @return {Phaser.GameObjects.Components.TransformMatrix} The populated Transform Matrix.
	     */
	    getWorldTransformMatrix: function (tempMatrix)
	    {
	        if (tempMatrix === undefined) { tempMatrix = new TransformMatrix(); }
	
	        var parent = this.parentContainer;
	
	        if (!parent)
	        {
	            return this.getLocalTransformMatrix(tempMatrix);
	        }
	
	        var parents = [];
	        
	        while (parent)
	        {
	            parents.unshift(parent);
	            parent = parent.parentContainer;
	        }
	
	        tempMatrix.loadIdentity();
	
	        var length = parents.length;
	        
	        for (var i = 0; i < length; ++i)
	        {
	            parent = parents[i];
	
	            tempMatrix.translate(parent.x, parent.y);
	            tempMatrix.rotate(parent.rotation);
	            tempMatrix.scale(parent.scaleX, parent.scaleY);
	        }
	
	        tempMatrix.translate(this.x, this.y);
	        tempMatrix.rotate(this._rotation);
	        tempMatrix.scale(this._scaleX, this._scaleY);
	
	        return tempMatrix;
	    }
	
	};
	
	module.exports = Transform;


/***/ }),
/* 1139 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  bitmask flag for GameObject.renderMask
	var _FLAG = 1; // 0001
	
	/**
	 * Provides methods used for setting the visibility of a Game Object.
	 * Should be applied as a mixin and not used directly.
	 * 
	 * @name Phaser.GameObjects.Components.Visible
	 * @since 3.0.0
	 */
	
	var Visible = {
	
	    /**
	     * Private internal value. Holds the visible value.
	     * 
	     * @name Phaser.GameObjects.Components.Visible#_visible
	     * @type {boolean}
	     * @private
	     * @default true
	     * @since 3.0.0
	     */
	    _visible: true,
	
	    /**
	     * The visible state of the Game Object.
	     * 
	     * An invisible Game Object will skip rendering, but will still process update logic.
	     * 
	     * @name Phaser.GameObjects.Components.Visible#visible
	     * @type {boolean}
	     * @since 3.0.0
	     */
	    visible: {
	
	        get: function ()
	        {
	            return this._visible;
	        },
	
	        set: function (value)
	        {
	            if (value)
	            {
	                this._visible = true;
	                this.renderFlags |= _FLAG;
	            }
	            else
	            {
	                this._visible = false;
	                this.renderFlags &= ~_FLAG;
	            }
	        }
	
	    },
	
	    /**
	     * Sets the visibility of this Game Object.
	     * 
	     * An invisible Game Object will skip rendering, but will still process update logic.
	     *
	     * @method Phaser.GameObjects.Components.Visible#setVisible
	     * @since 3.0.0
	     *
	     * @param {boolean} value - The visible state of the Game Object.
	     * 
	     * @return {Phaser.GameObjects.GameObject} This Game Object instance.
	     */
	    setVisible: function (value)
	    {
	        this.visible = value;
	
	        return this;
	    }
	};
	
	module.exports = Visible;


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Felipe Alfonso <@bitnenfer>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the Canvas Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.Container#renderCanvas
	 * @since 3.4.0
	 * @private
	 *
	 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
	 * @param {Phaser.GameObjects.Container} container - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 */
	var ContainerCanvasRenderer = function (renderer, container, interpolationPercentage, camera, parentMatrix)
	{
	    if (GameObject.RENDER_MASK !== container.renderFlags || (container.cameraFilter > 0 && (container.cameraFilter & camera._id)))
	    {
	        return;
	    }
	
	    var children = container.list;
	    var transformMatrix = container.localTransform;
	    
	    if (parentMatrix === undefined)
	    {
	        transformMatrix.applyITRS(container.x, container.y, container.rotation, container.scaleX, container.scaleY);
	    }
	    else
	    {
	        transformMatrix.loadIdentity();
	        transformMatrix.multiply(parentMatrix);
	        transformMatrix.translate(container.x, container.y);
	        transformMatrix.rotate(container.rotation);
	        transformMatrix.scale(container.scaleX, container.scaleY);
	    }
	
	    var alpha = container._alpha;
	    var scrollFactorX = container.scrollFactorX;
	    var scrollFactorY = container.scrollFactorY;
	
	    for (var index = 0; index < children.length; ++index)
	    {
	        var child = children[index];
	        var childAlpha = child._alpha;
	        var childScrollFactorX = child.scrollFactorX;
	        var childScrollFactorY = child.scrollFactorY;
	
	        child.setScrollFactor(childScrollFactorX * scrollFactorX, childScrollFactorY * scrollFactorY);
	        child.setAlpha(childAlpha * alpha);
	        child.renderCanvas(renderer, child, interpolationPercentage, camera, transformMatrix);
	        child.setAlpha(childAlpha);
	        child.setScrollFactor(childScrollFactorX, childScrollFactorY);
	    }
	};
	
	module.exports = ContainerCanvasRenderer;


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Felipe Alfonso <@bitnenfer>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BuildGameObject = __webpack_require__(50);
	var Container = __webpack_require__(277);
	var GameObjectCreator = __webpack_require__(26);
	var GetAdvancedValue = __webpack_require__(24);
	
	/**
	 * Creates a new Container Game Object and returns it.
	 *
	 * Note: This method will only be available if the Container Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectCreator#container
	 * @since 3.4.0
	 *
	 * @param {object} config - The configuration object this Game Object will use to create itself.
	 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
	 *
	 * @return {Phaser.GameObjects.Container} The Game Object that was created.
	 */
	GameObjectCreator.register('container', function (config, addToScene)
	{
	    if (config === undefined) { config = {}; }
	
	    var x = GetAdvancedValue(config, 'x', 0);
	    var y = GetAdvancedValue(config, 'y', 0);
	
	    var container = new Container(this.scene, x, y);
	
	    if (addToScene !== undefined)
	    {
	        config.add = addToScene;
	    }
	
	    BuildGameObject(this.scene, container, config);
	    
	    return container;
	});


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Felipe Alfonso <@bitnenfer>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Container = __webpack_require__(277);
	var GameObjectFactory = __webpack_require__(18);
	
	/**
	 * Creates a new Container Game Object and adds it to the Scene.
	 *
	 * Note: This method will only be available if the Container Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectFactory#container
	 * @since 3.4.0
	 *
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[]} [children] - An optional array of Game Objects to add to this Container.
	 *
	 * @return {Phaser.GameObjects.Container} The Game Object that was created.
	 */
	GameObjectFactory.register('container', function (x, y, children)
	{
	    return this.displayList.add(new Container(this.scene, x, y, children));
	});


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Felipe Alfonso <@bitnenfer>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var renderWebGL = __webpack_require__(6);
	var renderCanvas = __webpack_require__(6);
	
	if (true)
	{
	    renderWebGL = __webpack_require__(1144);
	}
	
	if (true)
	{
	    renderCanvas = __webpack_require__(1140);
	}
	
	module.exports = {
	
	    renderWebGL: renderWebGL,
	    renderCanvas: renderCanvas
	
	};


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Felipe Alfonso <@bitnenfer>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the WebGL Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.Container#renderWebGL
	 * @since 3.4.0
	 * @private
	 *
	 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
	 * @param {Phaser.GameObjects.Container} container - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 */
	var ContainerWebGLRenderer = function (renderer, container, interpolationPercentage, camera, parentMatrix)
	{
	    if (GameObject.RENDER_MASK !== container.renderFlags || (container.cameraFilter > 0 && (container.cameraFilter & camera._id)))
	    {
	        return;
	    }
	
	    var children = container.list;
	    var transformMatrix = container.localTransform;
	    
	    if (parentMatrix === undefined)
	    {
	        transformMatrix.applyITRS(container.x, container.y, container.rotation, container.scaleX, container.scaleY);
	    }
	    else
	    {
	        transformMatrix.loadIdentity();
	        transformMatrix.multiply(parentMatrix);
	        transformMatrix.translate(container.x, container.y);
	        transformMatrix.rotate(container.rotation);
	        transformMatrix.scale(container.scaleX, container.scaleY);
	    }
	
	    var alpha = container._alpha;
	    var scrollFactorX = container.scrollFactorX;
	    var scrollFactorY = container.scrollFactorY;
	
	    for (var index = 0; index < children.length; ++index)
	    {
	        var child = children[index];
	        var childAlpha = child._alpha;
	        var childScrollFactorX = child.scrollFactorX;
	        var childScrollFactorY = child.scrollFactorY;
	
	        child.setScrollFactor(childScrollFactorX * scrollFactorX, childScrollFactorY * scrollFactorY);
	        child.setAlpha(childAlpha * alpha);
	        child.renderWebGL(renderer, child, interpolationPercentage, camera, transformMatrix);
	        child.setAlpha(childAlpha);
	        child.setScrollFactor(childScrollFactorX, childScrollFactorY);
	    }
	};
	
	module.exports = ContainerWebGLRenderer;


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObjectCreator = __webpack_require__(26);
	var Graphics = __webpack_require__(279);
	
	/**
	 * Creates a new Graphics Game Object and returns it.
	 *
	 * Note: This method will only be available if the Graphics Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectCreator#graphics
	 * @since 3.0.0
	 *
	 * @param {object} config - The configuration object this Game Object will use to create itself.
	 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
	 *
	 * @return {Phaser.GameObjects.Graphics} The Game Object that was created.
	 */
	GameObjectCreator.register('graphics', function (config, addToScene)
	{
	    if (config === undefined) { config = {}; }
	
	    if (addToScene !== undefined)
	    {
	        config.add = addToScene;
	    }
	
	    var graphics = new Graphics(this.scene, config);
	
	    if (config.add)
	    {
	        this.scene.sys.displayList.add(graphics);
	    }
	    
	    return graphics;
	});
	
	//  When registering a factory function 'this' refers to the GameObjectCreator context.


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Graphics = __webpack_require__(279);
	var GameObjectFactory = __webpack_require__(18);
	
	/**
	 * Creates a new Graphics Game Object and adds it to the Scene.
	 *
	 * Note: This method will only be available if the Graphics Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectFactory#graphics
	 * @since 3.0.0
	 *
	 * @param {object} [config] - [description]
	 * 
	 * @return {Phaser.GameObjects.Graphics} The Game Object that was created.
	 */
	GameObjectFactory.register('graphics', function (config)
	{
	    return this.displayList.add(new Graphics(this.scene, config));
	});
	
	//  When registering a factory function 'this' refers to the GameObjectFactory context.
	//  
	//  There are several properties available to use:
	//  
	//  this.scene - a reference to the Scene that owns the GameObjectFactory
	//  this.displayList - a reference to the Display List the Scene owns
	//  this.updateList - a reference to the Update List the Scene owns


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var renderWebGL = __webpack_require__(6);
	var renderCanvas = __webpack_require__(6);
	
	if (true)
	{
	    renderWebGL = __webpack_require__(1148);
	
	    //  Needed for Graphics.generateTexture
	    renderCanvas = __webpack_require__(491);
	}
	
	if (true)
	{
	    renderCanvas = __webpack_require__(491);
	}
	
	module.exports = {
	
	    renderWebGL: renderWebGL,
	    renderCanvas: renderCanvas
	
	};


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the WebGL Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.Graphics#renderWebGL
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
	 * @param {Phaser.GameObjects.Graphics} graphics - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 */
	var GraphicsWebGLRenderer = function (renderer, graphics, interpolationPercentage, camera, parentMatrix)
	{
	    if (GameObject.RENDER_MASK !== graphics.renderFlags || (graphics.cameraFilter > 0 && (graphics.cameraFilter & camera._id)))
	    {
	        return;
	    }
	
	    this.pipeline.batchGraphics(this, camera, parentMatrix);
	};
	
	module.exports = GraphicsWebGLRenderer;


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObjectCreator = __webpack_require__(26);
	var Group = __webpack_require__(159);
	
	/**
	 * Creates a new Group Game Object and returns it.
	 *
	 * Note: This method will only be available if the Group Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectCreator#group
	 * @since 3.0.0
	 *
	 * @param {GroupConfig} config - [description]
	 *
	 * @return {Phaser.GameObjects.Group} The Game Object that was created.
	 */
	GameObjectCreator.register('group', function (config)
	{
	    return new Group(this.scene, null, config);
	});
	
	//  When registering a factory function 'this' refers to the GameObjectCreator context.


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Group = __webpack_require__(159);
	var GameObjectFactory = __webpack_require__(18);
	
	/**
	 * Creates a new Group Game Object and adds it to the Scene.
	 *
	 * Note: This method will only be available if the Group Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectFactory#group
	 * @since 3.0.0
	 *
	 * @param {(Phaser.GameObjects.GameObject[]|GroupConfig)} [children] - Game Objects to add to this Group; or the `config` argument.
	 * @param {GroupConfig} [config] - A Group Configuration object.
	 *
	 * @return {Phaser.GameObjects.Group} The Game Object that was created.
	 */
	GameObjectFactory.register('group', function (children, config)
	{
	    if (typeof children === 'object' && config === undefined)
	    {
	        config = children;
	        children = [];
	    }
	
	    return this.updateList.add(new Group(this.scene, children, config));
	});


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the Canvas Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.Image#renderCanvas
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
	 * @param {Phaser.GameObjects.Image} src - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 */
	var ImageCanvasRenderer = function (renderer, src, interpolationPercentage, camera, parentMatrix)
	{
	    if (GameObject.RENDER_MASK !== src.renderFlags || (src.cameraFilter > 0 && (src.cameraFilter & camera._id)))
	    {
	        return;
	    }
	
	    renderer.drawImage(src, camera, parentMatrix);
	};
	
	module.exports = ImageCanvasRenderer;


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BuildGameObject = __webpack_require__(50);
	var GameObjectCreator = __webpack_require__(26);
	var GetAdvancedValue = __webpack_require__(24);
	var Image = __webpack_require__(138);
	
	/**
	 * Creates a new Image Game Object and returns it.
	 *
	 * Note: This method will only be available if the Image Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectCreator#image
	 * @since 3.0.0
	 *
	 * @param {object} config - The configuration object this Game Object will use to create itself.
	 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
	 *
	 * @return {Phaser.GameObjects.Image} The Game Object that was created.
	 */
	GameObjectCreator.register('image', function (config, addToScene)
	{
	    if (config === undefined) { config = {}; }
	
	    var key = GetAdvancedValue(config, 'key', null);
	    var frame = GetAdvancedValue(config, 'frame', null);
	
	    var image = new Image(this.scene, 0, 0, key, frame);
	
	    if (addToScene !== undefined)
	    {
	        config.add = addToScene;
	    }
	
	    BuildGameObject(this.scene, image, config);
	
	    return image;
	});
	
	//  When registering a factory function 'this' refers to the GameObjectCreator context.


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Image = __webpack_require__(138);
	var GameObjectFactory = __webpack_require__(18);
	
	/**
	 * Creates a new Image Game Object and adds it to the Scene.
	 *
	 * Note: This method will only be available if the Image Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectFactory#image
	 * @since 3.0.0
	 *
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	 * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	 *
	 * @return {Phaser.GameObjects.Image} The Game Object that was created.
	 */
	GameObjectFactory.register('image', function (x, y, key, frame)
	{
	    return this.displayList.add(new Image(this.scene, x, y, key, frame));
	});
	
	//  When registering a factory function 'this' refers to the GameObjectFactory context.
	//
	//  There are several properties available to use:
	//
	//  this.scene - a reference to the Scene that owns the GameObjectFactory
	//  this.displayList - a reference to the Display List the Scene owns
	//  this.updateList - a reference to the Update List the Scene owns


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var renderWebGL = __webpack_require__(6);
	var renderCanvas = __webpack_require__(6);
	
	if (true)
	{
	    renderWebGL = __webpack_require__(1155);
	}
	
	if (true)
	{
	    renderCanvas = __webpack_require__(1151);
	}
	
	module.exports = {
	
	    renderWebGL: renderWebGL,
	    renderCanvas: renderCanvas
	
	};


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the WebGL Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.Image#renderWebGL
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
	 * @param {Phaser.GameObjects.Image} src - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 */
	var ImageWebGLRenderer = function (renderer, src, interpolationPercentage, camera, parentMatrix)
	{
	    if (GameObject.RENDER_MASK !== src.renderFlags || (src.cameraFilter > 0 && (src.cameraFilter & camera._id)))
	    {
	        return;
	    }
	    
	    this.pipeline.batchSprite(src, camera, parentMatrix);
	};
	
	module.exports = ImageWebGLRenderer;


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.GameObjects
	 */
	
	var GameObjects = {
	
	    DisplayList: __webpack_require__(1101),
	    GameObjectCreator: __webpack_require__(26),
	    GameObjectFactory: __webpack_require__(18),
	    UpdateList: __webpack_require__(1102),
	
	    Components: __webpack_require__(28),
	
	    BuildGameObject: __webpack_require__(50),
	    BuildGameObjectAnimation: __webpack_require__(272),
	    GameObject: __webpack_require__(5),
	    BitmapText: __webpack_require__(274),
	    Blitter: __webpack_require__(275),
	    Container: __webpack_require__(277),
	    DynamicBitmapText: __webpack_require__(273),
	    Graphics: __webpack_require__(279),
	    Group: __webpack_require__(159),
	    Image: __webpack_require__(138),
	    Particles: __webpack_require__(1169),
	    PathFollower: __webpack_require__(500),
	    RenderTexture: __webpack_require__(282),
	    RetroFont: __webpack_require__(1105),
	    Sprite3D: __webpack_require__(197),
	    Sprite: __webpack_require__(82),
	    Text: __webpack_require__(283),
	    TileSprite: __webpack_require__(284),
	    Zone: __webpack_require__(198),
	
	    //  Game Object Factories
	
	    Factories: {
	        Blitter: __webpack_require__(1119),
	        Container: __webpack_require__(1142),
	        DynamicBitmapText: __webpack_require__(1109),
	        Graphics: __webpack_require__(1146),
	        Group: __webpack_require__(1150),
	        Image: __webpack_require__(1153),
	        Particles: __webpack_require__(1166),
	        PathFollower: __webpack_require__(1171),
	        RenderTexture: __webpack_require__(1177),
	        Sprite3D: __webpack_require__(1187),
	        Sprite: __webpack_require__(1183),
	        StaticBitmapText: __webpack_require__(1114),
	        Text: __webpack_require__(1193),
	        TileSprite: __webpack_require__(1198),
	        Zone: __webpack_require__(1202)
	    },
	
	    Creators: {
	        Blitter: __webpack_require__(1118),
	        Container: __webpack_require__(1141),
	        DynamicBitmapText: __webpack_require__(1108),
	        Graphics: __webpack_require__(1145),
	        Group: __webpack_require__(1149),
	        Image: __webpack_require__(1152),
	        Particles: __webpack_require__(1165),
	        RenderTexture: __webpack_require__(1176),
	        Sprite3D: __webpack_require__(1186),
	        Sprite: __webpack_require__(1182),
	        StaticBitmapText: __webpack_require__(1113),
	        Text: __webpack_require__(1192),
	        TileSprite: __webpack_require__(1197),
	        Zone: __webpack_require__(1201)
	    }
	
	};
	
	if (true)
	{
	    //  WebGL only Game Objects
	    GameObjects.Mesh = __webpack_require__(196);
	    GameObjects.Quad = __webpack_require__(281);
	
	    GameObjects.Factories.Mesh = __webpack_require__(1160);
	    GameObjects.Factories.Quad = __webpack_require__(1173);
	
	    GameObjects.Creators.Mesh = __webpack_require__(1159);
	    GameObjects.Creators.Quad = __webpack_require__(1172);
	
	    GameObjects.Light = __webpack_require__(492);
	
	    __webpack_require__(493);
	    __webpack_require__(1157);
	}
	
	module.exports = GameObjects;


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var LightsManager = __webpack_require__(493);
	var PluginCache = __webpack_require__(29);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class LightsPlugin
	 * @extends Phaser.GameObjects.LightsManager
	 * @memberOf Phaser.GameObjects
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - [description]
	 */
	var LightsPlugin = new Class({
	
	    Extends: LightsManager,
	
	    initialize:
	
	    function LightsPlugin (scene)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.LightsPlugin#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.LightsPlugin#systems
	         * @type {Phaser.Scenes.Systems}
	         * @since 3.0.0
	         */
	        this.systems = scene.sys;
	
	        if (!scene.sys.settings.isBooted)
	        {
	            scene.sys.events.once('boot', this.boot, this);
	        }
	
	        LightsManager.call(this);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.LightsPlugin#boot
	     * @since 3.0.0
	     */
	    boot: function ()
	    {
	        var eventEmitter = this.systems.events;
	
	        eventEmitter.on('shutdown', this.shutdown, this);
	        eventEmitter.on('destroy', this.destroy, this);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.LightsPlugin#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.shutdown();
	
	        this.scene = undefined;
	        this.systems = undefined;
	    }
	
	});
	
	PluginCache.register('LightsPlugin', LightsPlugin, 'lights');
	
	module.exports = LightsPlugin;


/***/ }),
/* 1158 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * This is a stub function for Mesh.Render. There is no Canvas renderer for Mesh objects.
	 *
	 * @method Phaser.GameObjects.Mesh#renderCanvas
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
	 * @param {Phaser.GameObjects.Mesh} src - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 */
	var MeshCanvasRenderer = function ()
	{
	};
	
	module.exports = MeshCanvasRenderer;


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BuildGameObject = __webpack_require__(50);
	var GameObjectCreator = __webpack_require__(26);
	var GetAdvancedValue = __webpack_require__(24);
	var GetValue = __webpack_require__(10);
	var Mesh = __webpack_require__(196);
	
	/**
	 * Creates a new Mesh Game Object and returns it.
	 *
	 * Note: This method will only be available if the Mesh Game Object and WebGL support have been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectCreator#mesh
	 * @since 3.0.0
	 *
	 * @param {object} config - The configuration object this Game Object will use to create itself.
	 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
	 *
	 * @return {Phaser.GameObjects.Mesh} The Game Object that was created.
	 */
	GameObjectCreator.register('mesh', function (config, addToScene)
	{
	    if (config === undefined) { config = {}; }
	
	    var key = GetAdvancedValue(config, 'key', null);
	    var frame = GetAdvancedValue(config, 'frame', null);
	    var vertices = GetValue(config, 'vertices', []);
	    var colors = GetValue(config, 'colors', []);
	    var alphas = GetValue(config, 'alphas', []);
	    var uv = GetValue(config, 'uv', []);
	
	    var mesh = new Mesh(this.scene, 0, 0, vertices, uv, colors, alphas, key, frame);
	
	    if (addToScene !== undefined)
	    {
	        config.add = addToScene;
	    }
	
	    BuildGameObject(this.scene, mesh, config);
	
	    return mesh;
	});
	
	//  When registering a factory function 'this' refers to the GameObjectCreator context.


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Mesh = __webpack_require__(196);
	var GameObjectFactory = __webpack_require__(18);
	
	/**
	 * Creates a new Mesh Game Object and adds it to the Scene.
	 *
	 * Note: This method will only be available if the Mesh Game Object and WebGL support have been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectFactory#mesh
	 * @webglOnly
	 * @since 3.0.0
	 *
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {float[]} vertices - An array containing the vertices data for this Mesh.
	 * @param {float[]} uv - An array containing the uv data for this Mesh.
	 * @param {float[]} colors - An array containing the color data for this Mesh.
	 * @param {float[]} alphas - An array containing the alpha data for this Mesh.
	 * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	 * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	 *
	 * @return {Phaser.GameObjects.Mesh} The Game Object that was created.
	 */
	if (true)
	{
	    GameObjectFactory.register('mesh', function (x, y, vertices, uv, colors, alphas, texture, frame)
	    {
	        return this.displayList.add(new Mesh(this.scene, x, y, vertices, uv, colors, alphas, texture, frame));
	    });
	}
	
	//  When registering a factory function 'this' refers to the GameObjectFactory context.
	//
	//  There are several properties available to use:
	//
	//  this.scene - a reference to the Scene that owns the GameObjectFactory
	//  this.displayList - a reference to the Display List the Scene owns
	//  this.updateList - a reference to the Update List the Scene owns


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var renderWebGL = __webpack_require__(6);
	var renderCanvas = __webpack_require__(6);
	
	if (true)
	{
	    renderWebGL = __webpack_require__(1162);
	}
	
	if (true)
	{
	    renderCanvas = __webpack_require__(1158);
	}
	
	module.exports = {
	
	    renderWebGL: renderWebGL,
	    renderCanvas: renderCanvas
	
	};


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the WebGL Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.Mesh#renderWebGL
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
	 * @param {Phaser.GameObjects.Mesh} src - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 */
	var MeshWebGLRenderer = function (renderer, src, interpolationPercentage, camera, parentMatrix)
	{
	    if (GameObject.RENDER_MASK !== src.renderFlags || (src.cameraFilter > 0 && (src.cameraFilter & camera._id)))
	    {
	        return;
	    }
	
	    this.pipeline.batchMesh(src, camera, parentMatrix);
	};
	
	module.exports = MeshWebGLRenderer;


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var FloatBetween = __webpack_require__(551);
	var GetEaseFunction = __webpack_require__(173);
	var GetFastValue = __webpack_require__(3);
	var Wrap = __webpack_require__(98);
	
	/**
	 * The returned value sets what the property will be at the START of the particle's life, on emit.
	 * @callback EmitterOpOnEmitCallback
	 *
	 * @param {Phaser.GameObjects.Particles.Particle} particle - The particle.
	 * @param {string} key - The name of the property.
	 * @param {number} value - The current value of the property.
	 *
	 * @return {number} The new value of the property.
	 */
	
	/**
	 * The returned value updates the property for the duration of the particle's life.
	 * @callback EmitterOpOnUpdateCallback
	 *
	 * @param {Phaser.GameObjects.Particles.Particle} particle - The particle.
	 * @param {string} key - The name of the property.
	 * @param {float} t - The normalized lifetime of the particle, between 0 (start) and 1 (end).
	 * @param {number} value - The current value of the property.
	 *
	 * @return {number} The new value of the property.
	 */
	
	/**
	 * Defines an operation yielding a random value within a range.
	 * @typedef {object} EmitterOpRandomConfig
	 *
	 * @property {float[]} random - The minimum and maximum values, as [min, max].
	 */
	
	/**
	 * Defines an operation yielding a random value within a range.
	 * @typedef {object} EmitterOpRandomMinMaxConfig
	 *
	 * @property {float} min - The minimum value.
	 * @property {float} max - The maximum value.
	 */
	
	/**
	 * Defines an operation yielding a random value within a range.
	 * @typedef {object} EmitterOpRandomStartEndConfig
	 *
	 * @property {float} start - The starting value.
	 * @property {float} end - The ending value.
	 * @property {boolean} random - If false, this becomes {@link EmitterOpEaseConfig}.
	 */
	
	/**
	 * Defines an operation yielding a value incremented continuously across a range.
	 * @typedef {object} EmitterOpEaseConfig
	 *
	 * @property {float} start - The starting value.
	 * @property {float} end - The ending value.
	 * @property {string} [ease='Linear'] - The name of the easing function.
	 */
	
	/**
	 * Defines an operation yielding a value incremented by steps across a range.
	 * @typedef {object} EmitterOpSteppedConfig
	 *
	 * @property {number} start - The starting value.
	 * @property {number} end - The ending value.
	 * @property {number} steps - The number of steps between start and end.
	 */
	
	/**
	 * @typedef {object} EmitterOpCustomEmitConfig
	 *
	 * @property {EmitterOpOnEmitCallback} onEmit - [description]
	 */
	
	/**
	 * @typedef {object} EmitterOpCustomUpdateConfig
	 *
	 * @property {EmitterOpOnEmitCallback} [onEmit] - [description]
	 * @property {EmitterOpOnUpdateCallback} onUpdate - [description]
	 */
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class EmitterOp
	 * @memberOf Phaser.GameObjects.Particles
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {object} config - [description]
	 * @param {string} key - [description]
	 * @param {number} defaultValue - [description]
	 * @param {boolean} [emitOnly=false] - [description]
	 */
	var EmitterOp = new Class({
	
	    initialize:
	
	    function EmitterOp (config, key, defaultValue, emitOnly)
	    {
	        if (emitOnly === undefined)
	        {
	            emitOnly = false;
	        }
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Particles.EmitterOp#propertyKey
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.propertyKey = key;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Particles.EmitterOp#propertyValue
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.propertyValue = defaultValue;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Particles.EmitterOp#defaultValue
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.defaultValue = defaultValue;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Particles.EmitterOp#steps
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.steps = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Particles.EmitterOp#counter
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.counter = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Particles.EmitterOp#start
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.start = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Particles.EmitterOp#end
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.end = 0;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Particles.EmitterOp#ease
	         * @type {?function}
	         * @since 3.0.0
	         */
	        this.ease;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Particles.EmitterOp#emitOnly
	         * @type {boolean}
	         * @since 3.0.0
	         */
	        this.emitOnly = emitOnly;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Particles.EmitterOp#onEmit
	         * @type {EmitterOpOnEmitCallback}
	         * @since 3.0.0
	         */
	        this.onEmit = this.defaultEmit;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Particles.EmitterOp#onUpdate
	         * @type {EmitterOpOnUpdateCallback}
	         * @since 3.0.0
	         */
	        this.onUpdate = this.defaultUpdate;
	
	        this.loadConfig(config);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Particles.EmitterOp#loadConfig
	     * @since 3.0.0
	     *
	     * @param {object} [config] - [description]
	     * @param {string} [newKey] - [description]
	     */
	    loadConfig: function (config, newKey)
	    {
	        if (config === undefined)
	        {
	            config = {};
	        }
	
	        if (newKey)
	        {
	            this.propertyKey = newKey;
	        }
	
	        this.propertyValue = GetFastValue(
	            config,
	            this.propertyKey,
	            this.defaultValue
	        );
	
	        this.setMethods();
	
	        if (this.emitOnly)
	        {
	            //  Reset it back again
	            this.onUpdate = this.defaultUpdate;
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Particles.EmitterOp#toJSON
	     * @since 3.0.0
	     *
	     * @return {object} [description]
	     */
	    toJSON: function ()
	    {
	        return this.propertyValue;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Particles.EmitterOp#onChange
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.Particles.EmitterOp} This Emitter Op object.
	     */
	    onChange: function (value)
	    {
	        this.propertyValue = value;
	
	        return this.setMethods();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Particles.EmitterOp#setMethods
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.Particles.EmitterOp} This Emitter Op object.
	     */
	    setMethods: function ()
	    {
	        var value = this.propertyValue;
	
	        var t = typeof value;
	
	        if (t === 'number')
	        {
	            //  Explicit static value:
	            //  x: 400
	
	            this.onEmit = this.staticValueEmit;
	            this.onUpdate = this.staticValueUpdate; // How?
	        }
	        else if (Array.isArray(value))
	        {
	            //  Picks a random element from the array:
	            //  x: [ 100, 200, 300, 400 ]
	
	            this.onEmit = this.randomStaticValueEmit;
	        }
	        else if (t === 'function')
	        {
	            //  The same as setting just the onUpdate function and no onEmit (unless this op is an emitOnly one)
	            //  Custom callback, must return a value:
	
	            /*
	            x: function (particle, key, t, value)
	               {
	                   return value + 50;
	               }
	            */
	
	            if (this.emitOnly)
	            {
	                this.onEmit = value;
	            }
	            else
	            {
	                this.onUpdate = value;
	            }
	        }
	        else if (t === 'object' && (this.has(value, 'random') || this.hasBoth(value, 'start', 'end') || this.hasBoth(value, 'min', 'max')))
	        {
	            this.start = this.has(value, 'start') ? value.start : value.min;
	            this.end = this.has(value, 'end') ? value.end : value.max;
	
	            var isRandom = (this.hasBoth(value, 'min', 'max') || this.has(value, 'random'));
	
	            //  A random starting value (using 'min | max' instead of 'start | end' automatically implies a random value)
	
	            //  x: { start: 100, end: 400, random: true } OR { min: 100, max: 400 } OR { random: [ 100, 400 ] }
	
	            if (isRandom)
	            {
	                var rnd = value.random;
	
	                //  x: { random: [ 100, 400 ] } = the same as doing: x: { start: 100, end: 400, random: true }
	                if (Array.isArray(rnd))
	                {
	                    this.start = rnd[0];
	                    this.end = rnd[1];
	                }
	
	                this.onEmit = this.randomRangedValueEmit;
	            }
	
	            if (this.has(value, 'steps'))
	            {
	                //  A stepped (per emit) range
	
	                //  x: { start: 100, end: 400, steps: 64 }
	
	                //  Increments a value stored in the emitter
	
	                this.steps = value.steps;
	                this.counter = this.start;
	
	                this.onEmit = this.steppedEmit;
	            }
	            else
	            {
	                //  An eased range (defaults to Linear if not specified)
	
	                //  x: { start: 100, end: 400, [ ease: 'Linear' ] }
	
	                var easeType = this.has(value, 'ease') ? value.ease : 'Linear';
	
	                this.ease = GetEaseFunction(easeType);
	
	                if (!isRandom)
	                {
	                    this.onEmit = this.easedValueEmit;
	                }
	
	                //  BUG: alpha, rotate, scaleX, scaleY, or tint are eased here if {min, max} is given.
	                //  Probably this branch should exclude isRandom entirely.
	
	                this.onUpdate = this.easeValueUpdate;
	            }
	        }
	        else if (t === 'object' && this.hasEither(value, 'onEmit', 'onUpdate'))
	        {
	            //  Custom onEmit and onUpdate callbacks
	
	            /*
	            x: {
	                //  Called at the start of the particles life, when it is being created
	                onEmit: function (particle, key, t, value)
	                {
	                    return value;
	                },
	
	                //  Called during the particles life on each update
	                onUpdate: function (particle, key, t, value)
	                {
	                    return value;
	                }
	            }
	            */
	
	            if (this.has(value, 'onEmit'))
	            {
	                this.onEmit = value.onEmit;
	            }
	
	            if (this.has(value, 'onUpdate'))
	            {
	                this.onUpdate = value.onUpdate;
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Particles.EmitterOp#has
	     * @since 3.0.0
	     *
	     * @param {object} object - [description]
	     * @param {string} key - [description]
	     *
	     * @return {boolean} [description]
	     */
	    has: function (object, key)
	    {
	        return object.hasOwnProperty(key);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Particles.EmitterOp#hasBoth
	     * @since 3.0.0
	     *
	     * @param {object} object - [description]
	     * @param {string} key1 - [description]
	     * @param {string} key2 - [description]
	     *
	     * @return {boolean} [description]
	     */
	    hasBoth: function (object, key1, key2)
	    {
	        return object.hasOwnProperty(key1) && object.hasOwnProperty(key2);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Particles.EmitterOp#hasEither
	     * @since 3.0.0
	     *
	     * @param {object} object - [description]
	     * @param {string} key1 - [description]
	     * @param {string} key2 - [description]
	     *
	     * @return {boolean} [description]
	     */
	    hasEither: function (object, key1, key2)
	    {
	        return object.hasOwnProperty(key1) || object.hasOwnProperty(key2);
	    },
	
	    /**
	     * The returned value sets what the property will be at the START of the particles life, on emit.
	     *
	     * @method Phaser.GameObjects.Particles.EmitterOp#defaultEmit
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Particles.Particle} particle - [description]
	     * @param {string} key - [description]
	     * @param {number} value - [description]
	     *
	     * @return {number} [description]
	     */
	    defaultEmit: function (particle, key, value)
	    {
	        return value;
	    },
	
	    /**
	     * The returned value updates the property for the duration of the particles life.
	     *
	     * @method Phaser.GameObjects.Particles.EmitterOp#defaultUpdate
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Particles.Particle} particle - [description]
	     * @param {string} key - [description]
	     * @param {float} t - The T value (between 0 and 1)
	     * @param {number} value - [description]
	     *
	     * @return {number} [description]
	     */
	    defaultUpdate: function (particle, key, t, value)
	    {
	        return value;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Particles.EmitterOp#staticValueEmit
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    staticValueEmit: function ()
	    {
	        return this.propertyValue;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Particles.EmitterOp#staticValueUpdate
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    staticValueUpdate: function ()
	    {
	        return this.propertyValue;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Particles.EmitterOp#randomStaticValueEmit
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    randomStaticValueEmit: function ()
	    {
	        var randomIndex = Math.floor(Math.random() * this.propertyValue.length);
	
	        return this.propertyValue[randomIndex];
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Particles.EmitterOp#randomRangedValueEmit
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Particles.Particle} particle - [description]
	     * @param {string} key - [description]
	     *
	     * @return {number} [description]
	     */
	    randomRangedValueEmit: function (particle, key)
	    {
	        var value = FloatBetween(this.start, this.end);
	
	        if (particle && particle.data[key])
	        {
	            particle.data[key].min = value;
	        }
	
	        return value;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Particles.EmitterOp#steppedEmit
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    steppedEmit: function ()
	    {
	        var current = this.counter;
	
	        var next = this.counter + (this.end - this.start) / this.steps;
	
	        this.counter = Wrap(next, this.start, this.end);
	
	        return current;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Particles.EmitterOp#easedValueEmit
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Particles.Particle} particle - [description]
	     * @param {string} key - [description]
	     *
	     * @return {number} [description]
	     */
	    easedValueEmit: function (particle, key)
	    {
	        if (particle && particle.data[key])
	        {
	            var data = particle.data[key];
	
	            data.min = this.start;
	            data.max = this.end;
	        }
	
	        return this.start;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Particles.EmitterOp#easeValueUpdate
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.Particles.Particle} particle - [description]
	     * @param {string} key - [description]
	     * @param {float} t - The T value (between 0 and 1)
	     *
	     * @return {number} [description]
	     */
	    easeValueUpdate: function (particle, key, t)
	    {
	        var data = particle.data[key];
	
	        return (data.max - data.min) * this.ease(t) + data.min;
	    }
	});
	
	module.exports = EmitterOp;


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the Canvas Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.Particles.EmitterManager#renderCanvas
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
	 * @param {Phaser.GameObjects.Particles.ParticleEmitterManager} emitterManager - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 */
	var ParticleManagerCanvasRenderer = function (renderer, emitterManager, interpolationPercentage, camera, parentMatrix)
	{
	    var emitters = emitterManager.emitters.list;
	
	    if (emitters.length === 0 || GameObject.RENDER_MASK !== emitterManager.renderFlags || (emitterManager.cameraFilter > 0 && (emitterManager.cameraFilter & camera._id)))
	    {
	        return;
	    }
	
	    var ctx = renderer.currentContext;
	
	    ctx.save();
	    if (parentMatrix !== undefined)
	    {
	        var matrix = parentMatrix.matrix;
	        ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
	    }
	
	    for (var i = 0; i < emitters.length; i++)
	    {
	        var emitter = emitters[i];
	
	        var particles = emitter.alive;
	        var length = particles.length;
	
	        if (!emitter.visible || length === 0)
	        {
	            continue;
	        }
	
	
	        var lastAlpha = ctx.globalAlpha;
	        var cameraScrollX = camera.scrollX * emitter.scrollFactorX;
	        var cameraScrollY = camera.scrollY * emitter.scrollFactorY;
	
	        if (renderer.currentBlendMode !== emitter.blendMode)
	        {
	            renderer.currentBlendMode = emitter.blendMode;
	            ctx.globalCompositeOperation = renderer.blendModes[emitter.blendMode];
	        }
	
	        var roundPixels = renderer.config.roundPixels;
	
	        for (var index = 0; index < length; ++index)
	        {
	            var particle = particles[index];
	
	            var alpha = ((particle.color >> 24) & 0xFF) / 255.0;
	
	            if (alpha <= 0)
	            {
	                continue;
	            }
	
	            var frame = particle.frame;
	            var width = frame.width;
	            var height = frame.height;
	            var ox = width * 0.5;
	            var oy = height * 0.5;
	            var cd = frame.canvasData;
	
	            var x = -ox;
	            var y = -oy;
	
	            var tx = particle.x - cameraScrollX;
	            var ty = particle.y - cameraScrollY;
	
	            if (roundPixels)
	            {
	                tx |= 0;
	                ty |= 0;
	            }
	
	            ctx.globalAlpha = alpha;
	        
	            ctx.save();
	
	            ctx.translate(tx, ty);
	
	            ctx.rotate(particle.rotation);
	
	            ctx.scale(particle.scaleX, particle.scaleY);
	
	            ctx.drawImage(frame.source.image, cd.sx, cd.sy, cd.sWidth, cd.sHeight, x, y, cd.dWidth, cd.dHeight);
	
	            ctx.restore();
	        }
	
	        ctx.globalAlpha = lastAlpha;
	    }
	
	    ctx.restore();
	};
	
	module.exports = ParticleManagerCanvasRenderer;


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObjectCreator = __webpack_require__(26);
	var GetAdvancedValue = __webpack_require__(24);
	var GetFastValue = __webpack_require__(3);
	var ParticleEmitterManager = __webpack_require__(280);
	
	/**
	 * Creates a new Particle Emitter Manager Game Object and returns it.
	 *
	 * Note: This method will only be available if the Particles Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectCreator#particles
	 * @since 3.0.0
	 *
	 * @param {object} config - The configuration object this Game Object will use to create itself.
	 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
	 *
	 * @return {Phaser.GameObjects.Particles.ParticleEmitterManager} The Game Object that was created.
	 */
	GameObjectCreator.register('particles', function (config, addToScene)
	{
	    if (config === undefined) { config = {}; }
	
	    var key = GetAdvancedValue(config, 'key', null);
	    var frame = GetAdvancedValue(config, 'frame', null);
	    var emitters = GetFastValue(config, 'emitters', null);
	
	    //  frame is optional and can contain the emitters array or object if skipped
	    var manager = new ParticleEmitterManager(this.scene, key, frame, emitters);
	
	    if (addToScene !== undefined)
	    {
	        config.add = addToScene;
	    }
	
	    var add = GetFastValue(config, 'add', false);
	
	    if (add)
	    {
	        this.displayList.add(manager);
	    }
	
	    this.updateList.add(manager);
	
	    return manager;
	});


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObjectFactory = __webpack_require__(18);
	var ParticleEmitterManager = __webpack_require__(280);
	
	/**
	 * Creates a new Particle Emitter Manager Game Object and adds it to the Scene.
	 *
	 * Note: This method will only be available if the Particles Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectFactory#particles
	 * @since 3.0.0
	 *
	 * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	 * @param {(string|integer|object)} [frame] - [description]
	 * @param {object} [emitters] - [description]
	 *
	 * @return {Phaser.GameObjects.Particles.ParticleEmitterManager} The Game Object that was created.
	 */
	GameObjectFactory.register('particles', function (key, frame, emitters)
	{
	    var manager = new ParticleEmitterManager(this.scene, key, frame, emitters);
	
	    this.displayList.add(manager);
	    this.updateList.add(manager);
	
	    return manager;
	});
	
	//  When registering a factory function 'this' refers to the GameObjectFactory context.
	//
	//  There are several properties available to use:
	//
	//  this.scene - a reference to the Scene that owns the GameObjectFactory
	//  this.displayList - a reference to the Display List the Scene owns
	//  this.updateList - a reference to the Update List the Scene owns


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var renderWebGL = __webpack_require__(6);
	var renderCanvas = __webpack_require__(6);
	
	if (true)
	{
	    renderWebGL = __webpack_require__(1168);
	}
	
	if (true)
	{
	    renderCanvas = __webpack_require__(1164);
	}
	
	module.exports = {
	
	    renderWebGL: renderWebGL,
	    renderCanvas: renderCanvas
	
	};


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the WebGL Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.Particles.EmitterManager#renderWebGL
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
	 * @param {Phaser.GameObjects.Particles.ParticleEmitterManager} emitterManager - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 */
	var ParticleManagerWebGLRenderer = function (renderer, emitterManager, interpolationPercentage, camera, parentMatrix)
	{
	    var emitters = emitterManager.emitters;
	
	    if (emitters.length === 0 || GameObject.RENDER_MASK !== emitterManager.renderFlags || (emitterManager.cameraFilter > 0 && (emitterManager.cameraFilter & camera._id)))
	    {
	        return;
	    }
	
	    this.pipeline.drawEmitterManager(emitterManager, camera, parentMatrix);
	};
	
	module.exports = ParticleManagerWebGLRenderer;


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.GameObjects.Particles
	 */
	
	module.exports = {
	
	    GravityWell: __webpack_require__(494),
	    Particle: __webpack_require__(495),
	    ParticleEmitter: __webpack_require__(496),
	    ParticleEmitterManager: __webpack_require__(280),
	    Zones: __webpack_require__(1170)
	
	};


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.GameObjects.Particles.Zones
	 */
	
	module.exports = {
	
	    DeathZone: __webpack_require__(497),
	    EdgeZone: __webpack_require__(498),
	    RandomZone: __webpack_require__(499)
	
	};


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObjectFactory = __webpack_require__(18);
	var PathFollower = __webpack_require__(500);
	
	/**
	 * Creates a new PathFollower Game Object and adds it to the Scene.
	 *
	 * Note: This method will only be available if the PathFollower Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectFactory#follower
	 * @since 3.0.0
	 *
	 * @param {Phaser.Curves.Path} path - The Path this PathFollower is connected to.
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	 * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	 *
	 * @return {Phaser.GameObjects.PathFollower} The Game Object that was created.
	 */
	GameObjectFactory.register('follower', function (path, x, y, key, frame)
	{
	    var sprite = new PathFollower(this.scene, path, x, y, key, frame);
	
	    this.displayList.add(sprite);
	    this.updateList.add(sprite);
	
	    return sprite;
	});
	
	//  When registering a factory function 'this' refers to the GameObjectFactory context.
	//
	//  There are several properties available to use:
	//
	//  this.scene - a reference to the Scene that owns the GameObjectFactory
	//  this.displayList - a reference to the Display List the Scene owns
	//  this.updateList - a reference to the Update List the Scene owns


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BuildGameObject = __webpack_require__(50);
	var GameObjectCreator = __webpack_require__(26);
	var GetAdvancedValue = __webpack_require__(24);
	var Quad = __webpack_require__(281);
	
	/**
	 * Creates a new Quad Game Object and returns it.
	 *
	 * Note: This method will only be available if the Quad Game Object and WebGL support have been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectCreator#quad
	 * @since 3.0.0
	 *
	 * @param {object} config - The configuration object this Game Object will use to create itself.
	 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
	 *
	 * @return {Phaser.GameObjects.Quad} The Game Object that was created.
	 */
	GameObjectCreator.register('quad', function (config, addToScene)
	{
	    if (config === undefined) { config = {}; }
	
	    var x = GetAdvancedValue(config, 'x', 0);
	    var y = GetAdvancedValue(config, 'y', 0);
	    var key = GetAdvancedValue(config, 'key', null);
	    var frame = GetAdvancedValue(config, 'frame', null);
	
	    var quad = new Quad(this.scene, x, y, key, frame);
	
	    if (addToScene !== undefined)
	    {
	        config.add = addToScene;
	    }
	
	    BuildGameObject(this.scene, quad, config);
	
	    return quad;
	});


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Quad = __webpack_require__(281);
	var GameObjectFactory = __webpack_require__(18);
	
	/**
	 * Creates a new Quad Game Object and adds it to the Scene.
	 *
	 * Note: This method will only be available if the Quad Game Object and WebGL support have been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectFactory#quad
	 * @webglOnly
	 * @since 3.0.0
	 *
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	 * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	 * 
	 * @return {Phaser.GameObjects.Quad} The Game Object that was created.
	 */
	if (true)
	{
	    GameObjectFactory.register('quad', function (x, y, key, frame)
	    {
	        return this.displayList.add(new Quad(this.scene, x, y, key, frame));
	    });
	}
	
	//  When registering a factory function 'this' refers to the GameObjectFactory context.
	//  
	//  There are several properties available to use:
	//  
	//  this.scene - a reference to the Scene that owns the GameObjectFactory
	//  this.displayList - a reference to the Display List the Scene owns
	//  this.updateList - a reference to the Update List the Scene owns


/***/ }),
/* 1174 */
/***/ (function(module, exports) {

	var RenderTextureCanvas = {
	
	    fill: function (rgb)
	    {
	        var ur = ((rgb >> 16)|0) & 0xff;
	        var ug = ((rgb >> 8)|0) & 0xff;
	        var ub = (rgb|0) & 0xff;
	
	        this.context.fillStyle = 'rgb(' + ur + ',' + ug + ',' + ub + ')';
	        this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
	        return this;
	    },
	
	    clear: function ()
	    {
	        this.context.save();
	        this.context.setTransform(1, 0, 0, 1, 0, 0);
	        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
	        this.context.restore();
	        return this;
	    },
	
	    draw: function (texture, frame, x, y)
	    {
	        var matrix = this.currentMatrix;
	
	        this.context.globalAlpha = this.globalAlpha;
	        this.context.setTransform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
	        this.context.drawImage(texture.source[frame.sourceIndex].image, frame.cutX, frame.cutY, frame.cutWidth, frame.cutHeight, x, y, frame.cutWidth, frame.cutWidth);
	        
	        return this;
	    }
	
	};
	
	module.exports = RenderTextureCanvas;


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the Canvas Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.RenderTexture#renderCanvas
	 * @since 3.2.0
	 * @private
	 *
	 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
	 * @param {Phaser.GameObjects.RenderTexture} renderTexture - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 */
	var RenderTextureCanvasRenderer = function (renderer, renderTexture, interpolationPercentage, camera, parentMatrix)
	{
	    if (GameObject.RENDER_MASK !== renderTexture.renderFlags || (renderTexture.cameraFilter > 0 && (renderTexture.cameraFilter & camera._id)))
	    {
	        return;
	    }
	
	    var ctx = renderer.currentContext;
	
	    if (renderer.currentBlendMode !== renderTexture.blendMode)
	    {
	        renderer.currentBlendMode = renderTexture.blendMode;
	        ctx.globalCompositeOperation = renderer.blendModes[renderTexture.blendMode];
	    }
	
	    if (renderer.currentAlpha !== renderTexture.alpha)
	    {
	        renderer.currentAlpha = renderTexture.alpha;
	        ctx.globalAlpha = renderTexture.alpha;
	    }
	
	    if (renderer.currentScaleMode !== renderTexture.scaleMode)
	    {
	        renderer.currentScaleMode = renderTexture.scaleMode;
	    }
	
	    var dx = 0;
	    var dy = 0;
	
	    var fx = 1;
	    var fy = 1;
	
	    if (renderTexture.flipX)
	    {
	        fx = -1;
	        dx -= renderTexture.canvas.width - renderTexture.displayOriginX;
	    }
	    else
	    {
	        dx -= renderTexture.displayOriginX;
	    }
	
	    if (renderTexture.flipY)
	    {
	        fy = -1;
	        dy -= renderTexture.canvas.height - renderTexture.displayOriginY;
	    }
	    else
	    {
	        dy -= renderTexture.displayOriginY;
	    }
	
	    ctx.save();
	    if (parentMatrix !== undefined)
	    {
	        var matrix = parentMatrix.matrix;
	        ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
	    }
	    ctx.translate(renderTexture.x - camera.scrollX * renderTexture.scrollFactorX, renderTexture.y - camera.scrollY * renderTexture.scrollFactorY);
	    ctx.rotate(renderTexture.rotation);
	    ctx.scale(renderTexture.scaleX, renderTexture.scaleY);
	    ctx.scale(fx, fy);
	    ctx.drawImage(renderTexture.canvas, dx, dy);
	    ctx.restore();
	};
	
	module.exports = RenderTextureCanvasRenderer;


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BuildGameObject = __webpack_require__(50);
	var GameObjectCreator = __webpack_require__(26);
	var GetAdvancedValue = __webpack_require__(24);
	var RenderTexture = __webpack_require__(282);
	
	/**
	 * @typedef {object} RenderTextureConfig
	 *
	 * @property {number} [x=0] - [description]
	 * @property {number} [y=0] - [description]
	 * @property {number} [width=32] - [description]
	 * @property {number} [height=32] - [description]
	 */
	
	/**
	 * Creates a new Render Texture Game Object and returns it.
	 *
	 * Note: This method will only be available if the Render Texture Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectCreator#renderTexture
	 * @since 3.2.0
	 *
	 * @param {RenderTextureConfig} config - The configuration object this Game Object will use to create itself.
	 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
	 *
	 * @return {Phaser.GameObjects.RenderTexture} The Game Object that was created.
	 */
	GameObjectCreator.register('renderTexture', function (config, addToScene)
	{
	    if (config === undefined) { config = {}; }
	
	    var x = GetAdvancedValue(config, 'x', 0);
	    var y = GetAdvancedValue(config, 'y', 0);
	    var width = GetAdvancedValue(config, 'width', 32);
	    var height = GetAdvancedValue(config, 'height', 32);
	
	    var renderTexture = new RenderTexture(this.scene, x, y, width, height);
	
	    if (addToScene !== undefined)
	    {
	        config.add = addToScene;
	    }
	
	    BuildGameObject(this.scene, renderTexture, config);
	
	    return renderTexture;
	});


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObjectFactory = __webpack_require__(18);
	var RenderTexture = __webpack_require__(282);
	
	/**
	 * Creates a new Render Texture Game Object and adds it to the Scene.
	 *
	 * Note: This method will only be available if the Render Texture Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectFactory#renderTexture
	 * @since 3.2.0
	 *
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {integer} [width=32] - The width of the Render Texture.
	 * @param {integer} [height=32] - The height of the Render Texture.
	 * 
	 * @return {Phaser.GameObjects.RenderTexture} The Game Object that was created.
	 */
	GameObjectFactory.register('renderTexture', function (x, y, width, height)
	{
	    return this.displayList.add(new RenderTexture(this.scene, x, y, width, height));
	});


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var renderWebGL = __webpack_require__(6);
	var renderCanvas = __webpack_require__(6);
	
	if (true)
	{
	    renderWebGL = __webpack_require__(1180);
	}
	
	if (true)
	{
	    renderCanvas = __webpack_require__(1175);
	}
	
	module.exports = {
	
	    renderWebGL: renderWebGL,
	    renderCanvas: renderCanvas
	
	};


/***/ }),
/* 1179 */
/***/ (function(module, exports) {

	var RenderTextureWebGL = {
	
	    fill: function (rgb)
	    {
	        var ur = ((rgb >> 16)|0) & 0xff;
	        var ug = ((rgb >> 8)|0) & 0xff;
	        var ub = (rgb|0) & 0xff;
	
	        this.renderer.setFramebuffer(this.framebuffer);
	        var gl = this.gl;
	        gl.clearColor(ur / 255.0, ug / 255.0, ub / 255.0, 1);
	        gl.clear(gl.COLOR_BUFFER_BIT);
	        this.renderer.setFramebuffer(null);
	        return this;
	    },
	
	    clear: function ()
	    {
	        this.renderer.setFramebuffer(this.framebuffer);
	        var gl = this.gl;
	        gl.clearColor(0, 0, 0, 0);
	        gl.clear(gl.COLOR_BUFFER_BIT);
	        this.renderer.setFramebuffer(null);
	        return this;
	    },
	
	    draw: function (texture, frame, x, y)
	    {
	        var glTexture = texture.source[frame.sourceIndex].glTexture;
	        var tint = (this.globalTint >> 16) + (this.globalTint & 0xff00) + ((this.globalTint & 0xff) << 16);
	        this.renderer.setFramebuffer(this.framebuffer);
	        this.renderer.pipelines.TextureTintPipeline.projOrtho(0, this.renderer.pipelines.TextureTintPipeline.width, 0, this.renderer.pipelines.TextureTintPipeline.height, -1000.0, 1000.0);
	        this.renderer.pipelines.TextureTintPipeline.drawTexture(glTexture, x, y, tint, this.globalAlpha, frame.cutX, frame.cutY, frame.cutWidth, frame.cutHeight, this.currentMatrix, null, this);
	        this.renderer.setFramebuffer(null);
	        this.renderer.pipelines.TextureTintPipeline.projOrtho(0, this.renderer.pipelines.TextureTintPipeline.width, this.renderer.pipelines.TextureTintPipeline.height, 0, -1000.0, 1000.0);
	        return this;
	    }
	
	};
	
	module.exports = RenderTextureWebGL;


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	var Utils = __webpack_require__(87);
	
	/**
	 * Renders this Game Object with the Canvas Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.RenderTexture#renderWebgl
	 * @since 3.2.0
	 * @private
	 *
	 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active Canvas renderer.
	 * @param {Phaser.GameObjects.RenderTexture} renderTexture - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 */
	var RenderTextureWebGLRenderer = function (renderer, renderTexture, interpolationPercentage, camera, parentMatrix)
	{
	    if (GameObject.RENDER_MASK !== renderTexture.renderFlags || (renderTexture.cameraFilter > 0 && (renderTexture.cameraFilter & camera._id)))
	    {
	        return;
	    }
	
	    this.pipeline.batchTexture(
	        renderTexture,
	        renderTexture.texture,
	        renderTexture.texture.width, renderTexture.texture.height,
	        renderTexture.x, renderTexture.y,
	        renderTexture.width, renderTexture.height,
	        renderTexture.scaleX, renderTexture.scaleY,
	        renderTexture.rotation,
	        renderTexture.flipX, !renderTexture.flipY,
	        renderTexture.scrollFactorX, renderTexture.scrollFactorY,
	        renderTexture.displayOriginX, renderTexture.displayOriginY,
	        0, 0, renderTexture.texture.width, renderTexture.texture.height,
	        Utils.getTintAppendFloatAlpha(renderTexture.tintTopLeft, renderTexture.alphaTopLeft), Utils.getTintAppendFloatAlpha(renderTexture.tintTopRight, renderTexture.alphaTopRight), Utils.getTintAppendFloatAlpha(renderTexture.tintBottomLeft, renderTexture.alphaBottomLeft), Utils.getTintAppendFloatAlpha(renderTexture.tintBottomRight, renderTexture.alphaBottomRight),
	        0, 0,
	        camera,
	        parentMatrix
	    );
	};
	
	module.exports = RenderTextureWebGLRenderer;


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the Canvas Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.Sprite#renderCanvas
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
	 * @param {Phaser.GameObjects.Sprite} src - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 */
	var SpriteCanvasRenderer = function (renderer, src, interpolationPercentage, camera, parentMatrix)
	{
	    if (GameObject.RENDER_MASK !== src.renderFlags || (src.cameraFilter > 0 && (src.cameraFilter & camera._id)))
	    {
	        return;
	    }
	
	    renderer.drawImage(src, camera, parentMatrix);
	};
	
	module.exports = SpriteCanvasRenderer;


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BuildGameObject = __webpack_require__(50);
	var BuildGameObjectAnimation = __webpack_require__(272);
	var GameObjectCreator = __webpack_require__(26);
	var GetAdvancedValue = __webpack_require__(24);
	var Sprite = __webpack_require__(82);
	
	/**
	 * Creates a new Sprite Game Object and returns it.
	 *
	 * Note: This method will only be available if the Sprite Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectCreator#sprite
	 * @since 3.0.0
	 *
	 * @param {object} config - The configuration object this Game Object will use to create itself.
	 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
	 *
	 * @return {Phaser.GameObjects.Sprite} The Game Object that was created.
	 */
	GameObjectCreator.register('sprite', function (config, addToScene)
	{
	    if (config === undefined) { config = {}; }
	
	    var key = GetAdvancedValue(config, 'key', null);
	    var frame = GetAdvancedValue(config, 'frame', null);
	
	    var sprite = new Sprite(this.scene, 0, 0, key, frame);
	
	    if (addToScene !== undefined)
	    {
	        config.add = addToScene;
	    }
	
	    BuildGameObject(this.scene, sprite, config);
	
	    //  Sprite specific config options:
	
	    BuildGameObjectAnimation(sprite, config);
	
	    return sprite;
	});


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObjectFactory = __webpack_require__(18);
	var Sprite = __webpack_require__(82);
	
	/**
	 * Creates a new Sprite Game Object and adds it to the Scene.
	 *
	 * Note: This method will only be available if the Sprite Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectFactory#sprite
	 * @since 3.0.0
	 *
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	 * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	 *
	 * @return {Phaser.GameObjects.Sprite} The Game Object that was created.
	 */
	GameObjectFactory.register('sprite', function (x, y, key, frame)
	{
	    var sprite = new Sprite(this.scene, x, y, key, frame);
	
	    this.displayList.add(sprite);
	    this.updateList.add(sprite);
	
	    return sprite;
	});
	
	//  When registering a factory function 'this' refers to the GameObjectFactory context.
	//
	//  There are several properties available to use:
	//
	//  this.scene - a reference to the Scene that owns the GameObjectFactory
	//  this.displayList - a reference to the Display List the Scene owns
	//  this.updateList - a reference to the Update List the Scene owns


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var renderWebGL = __webpack_require__(6);
	var renderCanvas = __webpack_require__(6);
	
	if (true)
	{
	    renderWebGL = __webpack_require__(1185);
	}
	
	if (true)
	{
	    renderCanvas = __webpack_require__(1181);
	}
	
	module.exports = {
	
	    renderWebGL: renderWebGL,
	    renderCanvas: renderCanvas
	
	};


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the WebGL Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.Sprite#renderWebGL
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
	 * @param {Phaser.GameObjects.Sprite} src - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 */
	var SpriteWebGLRenderer = function (renderer, src, interpolationPercentage, camera, parentMatrix)
	{
	    if (GameObject.RENDER_MASK !== src.renderFlags || (src.cameraFilter > 0 && (src.cameraFilter & camera._id)))
	    {
	        return;
	    }
	
	    this.pipeline.batchSprite(src, camera, parentMatrix);
	};
	
	module.exports = SpriteWebGLRenderer;


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BuildGameObject = __webpack_require__(50);
	var BuildGameObjectAnimation = __webpack_require__(272);
	var GameObjectCreator = __webpack_require__(26);
	var GetAdvancedValue = __webpack_require__(24);
	var Sprite3D = __webpack_require__(197);
	
	/**
	 * Creates a new Sprite3D Game Object and returns it.
	 *
	 * Note: This method will only be available if the Sprite3D Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectCreator#sprite3D
	 * @since 3.0.0
	 *
	 * @param {object} config - The configuration object this Game Object will use to create itself.
	 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
	 *
	 * @return {Phaser.GameObjects.Sprite3D} The Game Object that was created.
	 */
	GameObjectCreator.register('sprite3D', function (config, addToScene)
	{
	    if (config === undefined) { config = {}; }
	
	    var key = GetAdvancedValue(config, 'key', null);
	    var frame = GetAdvancedValue(config, 'frame', null);
	
	    var sprite = new Sprite3D(this.scene, 0, 0, key, frame);
	
	    if (addToScene !== undefined)
	    {
	        config.add = addToScene;
	    }
	
	    BuildGameObject(this.scene, sprite, config);
	
	    //  Sprite specific config options:
	
	    BuildGameObjectAnimation(sprite, config);
	
	    return sprite;
	});
	
	//  When registering a factory function 'this' refers to the GameObjectCreator context.


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Sprite3D = __webpack_require__(197);
	var GameObjectFactory = __webpack_require__(18);
	
	/**
	 * Creates a new Sprite3D Game Object and adds it to the Scene.
	 *
	 * Note: This method will only be available if the Sprite3D Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectFactory#sprite3D
	 * @since 3.0.0
	 *
	 * @param {number} x - The horizontal position of this Game Object.
	 * @param {number} y - The vertical position of this Game Object.
	 * @param {number} z - The z position of this Game Object.
	 * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	 * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	 *
	 * @return {Phaser.GameObjects.Sprite3D} The Game Object that was created.
	 */
	GameObjectFactory.register('sprite3D', function (x, y, z, key, frame)
	{
	    var sprite = new Sprite3D(this.scene, x, y, z, key, frame);
	
	    this.displayList.add(sprite.gameObject);
	    this.updateList.add(sprite.gameObject);
	
	    return sprite;
	});
	
	//  When registering a factory function 'this' refers to the GameObjectFactory context.
	//
	//  There are several properties available to use:
	//
	//  this.scene - a reference to the Scene that owns the GameObjectFactory
	//  this.displayList - a reference to the Display List the Scene owns
	//  this.updateList - a reference to the Update List the Scene owns


/***/ }),
/* 1188 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Returns an object containing dimensions of the Text object.
	 *
	 * @function Phaser.GameObjects.Text.GetTextSize
	 * @since 3.0.0
	 *
	 * @param {Phaser.GameObjects.Text} text - The Text object to get the size from.
	 * @param {number} size - [description]
	 * @param {array} lines - [description]
	 *
	 * @return {object} An object containing dimensions of the Text object.
	 */
	var GetTextSize = function (text, size, lines)
	{
	    var canvas = text.canvas;
	    var context = text.context;
	    var style = text.style;
	
	    var lineWidths = [];
	    var maxLineWidth = 0;
	    var drawnLines = lines.length;
	    
	    if (style.maxLines > 0 && style.maxLines < lines.length)
	    {
	        drawnLines = style.maxLines;
	    }
	
	    style.syncFont(canvas, context);
	
	    //  Text Width
	
	    for (var i = 0; i < drawnLines; i++)
	    {
	        var lineWidth = style.strokeThickness;
	
	        lineWidth += context.measureText(lines[i]).width;
	
	        // Adjust for wrapped text
	        if (style.wordWrap)
	        {
	            lineWidth -= context.measureText(' ').width;
	        }
	
	        lineWidths[i] = Math.ceil(lineWidth);
	        maxLineWidth = Math.max(maxLineWidth, lineWidths[i]);
	    }
	
	    //  Text Height
	
	    var lineHeight = size.fontSize + style.strokeThickness;
	    var height = lineHeight * drawnLines;
	    var lineSpacing = text._lineSpacing || 0;
	
	    if (lineSpacing < 0 && Math.abs(lineSpacing) > lineHeight)
	    {
	        lineSpacing = -lineHeight;
	    }
	
	    //  Adjust for line spacing
	    if (lineSpacing !== 0)
	    {
	        height += (lineSpacing > 0) ? lineSpacing * lines.length : lineSpacing * (lines.length - 1);
	    }
	
	    return {
	        width: maxLineWidth,
	        height: height,
	        lines: drawnLines,
	        lineWidths: lineWidths,
	        lineSpacing: lineSpacing,
	        lineHeight: lineHeight
	    };
	};
	
	module.exports = GetTextSize;


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CanvasPool = __webpack_require__(56);
	
	/**
	 * Calculates the ascent, descent and fontSize of a given font style.
	 *
	 * @function Phaser.GameObjects.Text.MeasureText
	 * @since 3.0.0
	 *
	 * @param {Phaser.GameObjects.Text.TextStyle} textStyle - The TextStyle object to measure.
	 *
	 * @return {object} An object containing the ascent, descent and fontSize of the TextStyle.
	 */
	var MeasureText = function (textStyle)
	{
	    // @property {HTMLCanvasElement} canvas - The canvas element that the text is rendered.
	    var canvas = CanvasPool.create(this);
	
	    // @property {HTMLCanvasElement} context - The context of the canvas element that the text is rendered to.
	    var context = canvas.getContext('2d');
	
	    textStyle.syncFont(canvas, context);
	
	    var width = Math.ceil(context.measureText(textStyle.testString).width * textStyle.baselineX);
	    var baseline = width;
	    var height = 2 * baseline;
	
	    baseline = baseline * textStyle.baselineY | 0;
	
	    canvas.width = width;
	    canvas.height = height;
	
	    context.fillStyle = '#f00';
	    context.fillRect(0, 0, width, height);
	
	    context.font = textStyle._font;
	
	    context.textBaseline = 'alphabetic';
	    context.fillStyle = '#000';
	    context.fillText(textStyle.testString, 0, baseline);
	
	    var output = {
	        ascent: 0,
	        descent: 0,
	        fontSize: 0
	    };
	
	    if (!context.getImageData(0, 0, width, height))
	    {
	        output.ascent = baseline;
	        output.descent = baseline + 6;
	        output.fontSize = output.ascent + output.descent;
	
	        CanvasPool.remove(canvas);
	
	        return output;
	    }
	
	    var imagedata = context.getImageData(0, 0, width, height).data;
	    var pixels = imagedata.length;
	    var line = width * 4;
	    var i;
	    var j;
	    var idx = 0;
	    var stop = false;
	
	    // ascent. scan from top to bottom until we find a non red pixel
	    for (i = 0; i < baseline; i++)
	    {
	        for (j = 0; j < line; j += 4)
	        {
	            if (imagedata[idx + j] !== 255)
	            {
	                stop = true;
	                break;
	            }
	        }
	
	        if (!stop)
	        {
	            idx += line;
	        }
	        else
	        {
	            break;
	        }
	    }
	
	    output.ascent = baseline - i;
	
	    idx = pixels - line;
	    stop = false;
	
	    // descent. scan from bottom to top until we find a non red pixel
	    for (i = height; i > baseline; i--)
	    {
	        for (j = 0; j < line; j += 4)
	        {
	            if (imagedata[idx + j] !== 255)
	            {
	                stop = true;
	                break;
	            }
	        }
	
	        if (!stop)
	        {
	            idx -= line;
	        }
	        else
	        {
	            break;
	        }
	    }
	
	    output.descent = (i - baseline);
	    output.fontSize = output.ascent + output.descent;
	
	    CanvasPool.remove(canvas);
	
	    return output;
	};
	
	module.exports = MeasureText;


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var GetAdvancedValue = __webpack_require__(24);
	var GetValue = __webpack_require__(10);
	var MeasureText = __webpack_require__(1189);
	
	//  Key: [ Object Key, Default Value ]
	
	/**
	 * A custom function that will be responsible for wrapping the text.
	 * @callback TextStyleWordWrapCallback
	 *
	 * @param {string} text - The string to wrap.
	 * @param {Phaser.GameObjects.Text} textObject - The Text instance.
	 *
	 * @return {(string|string[])} Should return the wrapped lines either as an array of lines or as a string with
	 * newline characters in place to indicate where breaks should happen.
	 */
	
	var propertyMap = {
	    fontFamily: [ 'fontFamily', 'Courier' ],
	    fontSize: [ 'fontSize', '16px' ],
	    fontStyle: [ 'fontStyle', '' ],
	    backgroundColor: [ 'backgroundColor', null ],
	    color: [ 'color', '#fff' ],
	    stroke: [ 'stroke', '#fff' ],
	    strokeThickness: [ 'strokeThickness', 0 ],
	    shadowOffsetX: [ 'shadow.offsetX', 0 ],
	    shadowOffsetY: [ 'shadow.offsetY', 0 ],
	    shadowColor: [ 'shadow.color', '#000' ],
	    shadowBlur: [ 'shadow.blur', 0 ],
	    shadowStroke: [ 'shadow.stroke', false ],
	    shadowFill: [ 'shadow.fill', false ],
	    align: [ 'align', 'left' ],
	    maxLines: [ 'maxLines', 0 ],
	    fixedWidth: [ 'fixedWidth', 0 ],
	    fixedHeight: [ 'fixedHeight', 0 ],
	    rtl: [ 'rtl', false ],
	    testString: [ 'testString', '|MÃ‰qgy' ],
	    baselineX: [ 'baselineX', 1.2 ],
	    baselineY: [ 'baselineY', 1.4 ],
	    wordWrapWidth: [ 'wordWrap.width', null ],
	    wordWrapCallback: [ 'wordWrap.callback', null ],
	    wordWrapCallbackScope: [ 'wordWrap.callbackScope', null ],
	    wordWrapUseAdvanced: [ 'wordWrap.useAdvancedWrap', false ]
	};
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class TextStyle
	 * @memberOf Phaser.GameObjects.Text
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.GameObjects.Text} text - The Text object that this TextStyle is styling.
	 * @param {object} style - [description]
	 */
	var TextStyle = new Class({
	
	    initialize:
	
	    function TextStyle (text, style)
	    {
	        /**
	         * The Text object that this TextStyle is styling.
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#parent
	         * @type {Phaser.GameObjects.Text}
	         * @since 3.0.0
	         */
	        this.parent = text;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#fontFamily
	         * @type {string}
	         * @default 'Courier'
	         * @since 3.0.0
	         */
	        this.fontFamily;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#fontSize
	         * @type {string}
	         * @default '16px'
	         * @since 3.0.0
	         */
	        this.fontSize;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#fontStyle
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.fontStyle;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#backgroundColor
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.backgroundColor;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#color
	         * @type {string}
	         * @default '#fff'
	         * @since 3.0.0
	         */
	        this.color;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#stroke
	         * @type {string}
	         * @default '#fff'
	         * @since 3.0.0
	         */
	        this.stroke;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#strokeThickness
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.strokeThickness;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#shadowOffsetX
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.shadowOffsetX;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#shadowOffsetY
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.shadowOffsetY;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#shadowColor
	         * @type {string}
	         * @default '#000'
	         * @since 3.0.0
	         */
	        this.shadowColor;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#shadowBlur
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.shadowBlur;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#shadowStroke
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.shadowStroke;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#shadowFill
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.shadowFill;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#align
	         * @type {string}
	         * @default 'left'
	         * @since 3.0.0
	         */
	        this.align;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#maxLines
	         * @type {integer}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.maxLines;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#fixedWidth
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.fixedWidth;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#fixedHeight
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.fixedHeight;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#rtl
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.rtl;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#testString
	         * @type {string}
	         * @default '|MÉqgy'
	         * @since 3.0.0
	         */
	        this.testString;
	
	        /**
	         * The amount of horizontal padding adding to the width of the text when calculating the font metrics.
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#baselineX
	         * @type {number}
	         * @default 1.2
	         * @since 3.3.0
	         */
	        this.baselineX;
	
	        /**
	         * The amount of vertical padding adding to the width of the text when calculating the font metrics.
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#baselineY
	         * @type {number}
	         * @default 1.4
	         * @since 3.3.0
	         */
	        this.baselineY;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.GameObjects.Text.TextStyle#_font
	         * @type {string}
	         * @private
	         * @since 3.0.0
	         */
	        this._font;
	
	        //  Set to defaults + user style
	        this.setStyle(style, false);
	
	        var metrics = GetValue(style, 'metrics', false);
	
	        //  Provide optional TextMetrics in the style object to avoid the canvas look-up / scanning
	        //  Doing this is reset if you then change the font of this TextStyle after creation
	        if (metrics)
	        {
	            this.metrics = {
	                ascent: GetValue(metrics, 'ascent', 0),
	                descent: GetValue(metrics, 'descent', 0),
	                fontSize: GetValue(metrics, 'fontSize', 0)
	            };
	        }
	        else
	        {
	            this.metrics = MeasureText(this);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#setStyle
	     * @since 3.0.0
	     *
	     * @param {CSSStyleRule} style - [description]
	     * @param {boolean} [updateText=true] - [description]
	     *
	     * @return {Phaser.GameObjects.Text} The parent Text object.
	     */
	    setStyle: function (style, updateText)
	    {
	        if (updateText === undefined) { updateText = true; }
	
	        //  Avoid type mutation
	        if (style && style.hasOwnProperty('fontSize') && typeof style.fontSize === 'number')
	        {
	            style.fontSize = style.fontSize.toString() + 'px';
	        }
	
	        for (var key in propertyMap)
	        {
	            if (key === 'wordWrapCallback' || key === 'wordWrapCallbackScope')
	            {
	                // Callback & scope should be set without processing the values
	                this[key] = GetValue(style, propertyMap[key][0], propertyMap[key][1]);
	            }
	            else
	            {
	                this[key] = GetAdvancedValue(style, propertyMap[key][0], propertyMap[key][1]);
	            }
	        }
	
	        //  Allow for 'font' override
	        var font = GetValue(style, 'font', null);
	
	        if (font === null)
	        {
	            this._font = [ this.fontStyle, this.fontSize, this.fontFamily ].join(' ');
	        }
	        else
	        {
	            this._font = font;
	        }
	
	        //  Allow for 'fill' to be used in place of 'color'
	        var fill = GetValue(style, 'fill', null);
	
	        if (fill !== null)
	        {
	            this.color = fill;
	        }
	
	        if (updateText)
	        {
	            return this.update(true);
	        }
	        else
	        {
	            return this.parent;
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#syncFont
	     * @since 3.0.0
	     *
	     * @param {HTMLCanvasElement} canvas - [description]
	     * @param {CanvasRenderingContext2D} context - [description]
	     */
	    syncFont: function (canvas, context)
	    {
	        context.font = this._font;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#syncStyle
	     * @since 3.0.0
	     *
	     * @param {HTMLCanvasElement} canvas - [description]
	     * @param {CanvasRenderingContext2D} context - [description]
	     */
	    syncStyle: function (canvas, context)
	    {
	        context.textBaseline = 'alphabetic';
	
	        context.fillStyle = this.color;
	        context.strokeStyle = this.stroke;
	
	        context.lineWidth = this.strokeThickness;
	        context.lineCap = 'round';
	        context.lineJoin = 'round';
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#syncShadow
	     * @since 3.0.0
	     *
	     * @param {CanvasRenderingContext2D} context - [description]
	     * @param {boolean} enabled - [description]
	     */
	    syncShadow: function (context, enabled)
	    {
	        if (enabled)
	        {
	            context.shadowOffsetX = this.shadowOffsetX;
	            context.shadowOffsetY = this.shadowOffsetY;
	            context.shadowColor = this.shadowColor;
	            context.shadowBlur = this.shadowBlur;
	        }
	        else
	        {
	            context.shadowOffsetX = 0;
	            context.shadowOffsetY = 0;
	            context.shadowColor = 0;
	            context.shadowBlur = 0;
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#update
	     * @since 3.0.0
	     *
	     * @param {boolean} recalculateMetrics - [description]
	     *
	     * @return {Phaser.GameObjects.Text} The parent Text object.
	     */
	    update: function (recalculateMetrics)
	    {
	        if (recalculateMetrics)
	        {
	            this._font = [ this.fontStyle, this.fontSize, this.fontFamily ].join(' ');
	
	            this.metrics = MeasureText(this);
	        }
	
	        return this.parent.updateText();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#setFont
	     * @since 3.0.0
	     *
	     * @param {(string|object)} font - [description]
	     *
	     * @return {Phaser.GameObjects.Text} The parent Text object.
	     */
	    setFont: function (font)
	    {
	        if (typeof font === 'string')
	        {
	            this.fontFamily = font;
	            this.fontSize = '';
	            this.fontStyle = '';
	        }
	        else
	        {
	            this.fontFamily = GetValue(font, 'fontFamily', 'Courier');
	            this.fontSize = GetValue(font, 'fontSize', '16px');
	            this.fontStyle = GetValue(font, 'fontStyle', '');
	        }
	
	        return this.update(true);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#setFontFamily
	     * @since 3.0.0
	     *
	     * @param {string} family - [description]
	     *
	     * @return {Phaser.GameObjects.Text} The parent Text object.
	     */
	    setFontFamily: function (family)
	    {
	        this.fontFamily = family;
	
	        return this.update(true);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#setFontStyle
	     * @since 3.0.0
	     *
	     * @param {string} style - [description]
	     *
	     * @return {Phaser.GameObjects.Text} The parent Text object.
	     */
	    setFontStyle: function (style)
	    {
	        this.fontStyle = style;
	
	        return this.update(true);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#setFontSize
	     * @since 3.0.0
	     *
	     * @param {(number|string)} size - [description]
	     *
	     * @return {Phaser.GameObjects.Text} The parent Text object.
	     */
	    setFontSize: function (size)
	    {
	        if (typeof size === 'number')
	        {
	            size = size.toString() + 'px';
	        }
	
	        this.fontSize = size;
	
	        return this.update(true);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#setTestString
	     * @since 3.0.0
	     *
	     * @param {string} string - [description]
	     *
	     * @return {Phaser.GameObjects.Text} The parent Text object.
	     */
	    setTestString: function (string)
	    {
	        this.testString = string;
	
	        return this.update(true);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#setFixedSize
	     * @since 3.0.0
	     *
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     *
	     * @return {Phaser.GameObjects.Text} The parent Text object.
	     */
	    setFixedSize: function (width, height)
	    {
	        this.fixedWidth = width;
	        this.fixedHeight = height;
	
	        if (width)
	        {
	            this.parent.width = width;
	        }
	
	        if (height)
	        {
	            this.parent.height = height;
	        }
	
	        return this.update(false);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#setBackgroundColor
	     * @since 3.0.0
	     *
	     * @param {string} color - [description]
	     *
	     * @return {Phaser.GameObjects.Text} The parent Text object.
	     */
	    setBackgroundColor: function (color)
	    {
	        this.backgroundColor = color;
	
	        return this.update(false);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#setFill
	     * @since 3.0.0
	     *
	     * @param {string} color - [description]
	     *
	     * @return {Phaser.GameObjects.Text} The parent Text object.
	     */
	    setFill: function (color)
	    {
	        this.color = color;
	
	        return this.update(false);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#setColor
	     * @since 3.0.0
	     *
	     * @param {string} color - [description]
	     *
	     * @return {Phaser.GameObjects.Text} The parent Text object.
	     */
	    setColor: function (color)
	    {
	        this.color = color;
	
	        return this.update(false);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#setStroke
	     * @since 3.0.0
	     *
	     * @param {string} color - [description]
	     * @param {number} thickness - [description]
	     *
	     * @return {Phaser.GameObjects.Text} The parent Text object.
	     */
	    setStroke: function (color, thickness)
	    {
	        if (color === undefined)
	        {
	            //  Reset the stroke to zero (disabling it)
	            this.strokeThickness = 0;
	        }
	        else
	        {
	            if (thickness === undefined) { thickness = this.strokeThickness; }
	
	            this.stroke = color;
	            this.strokeThickness = thickness;
	        }
	
	        return this.update(true);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#setShadow
	     * @since 3.0.0
	     *
	     * @param {number} [x=0] - [description]
	     * @param {number} [y=0] - [description]
	     * @param {string} [color='#000'] - [description]
	     * @param {number} [blur=0] - [description]
	     * @param {boolean} [shadowStroke=false] - [description]
	     * @param {boolean} [shadowFill=true] - [description]
	     *
	     * @return {Phaser.GameObjects.Text} The parent Text object.
	     */
	    setShadow: function (x, y, color, blur, shadowStroke, shadowFill)
	    {
	        if (x === undefined) { x = 0; }
	        if (y === undefined) { y = 0; }
	        if (color === undefined) { color = '#000'; }
	        if (blur === undefined) { blur = 0; }
	        if (shadowStroke === undefined) { shadowStroke = false; }
	        if (shadowFill === undefined) { shadowFill = true; }
	
	        this.shadowOffsetX = x;
	        this.shadowOffsetY = y;
	        this.shadowColor = color;
	        this.shadowBlur = blur;
	        this.shadowStroke = shadowStroke;
	        this.shadowFill = shadowFill;
	
	        return this.update(false);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#setShadowOffset
	     * @since 3.0.0
	     *
	     * @param {number} [x=0] - [description]
	     * @param {number} [y=0] - [description]
	     *
	     * @return {Phaser.GameObjects.Text} The parent Text object.
	     */
	    setShadowOffset: function (x, y)
	    {
	        if (x === undefined) { x = 0; }
	        if (y === undefined) { y = x; }
	
	        this.shadowOffsetX = x;
	        this.shadowOffsetY = y;
	
	        return this.update(false);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#setShadowColor
	     * @since 3.0.0
	     *
	     * @param {string} [color='#000'] - [description]
	     *
	     * @return {Phaser.GameObjects.Text} The parent Text object.
	     */
	    setShadowColor: function (color)
	    {
	        if (color === undefined) { color = '#000'; }
	
	        this.shadowColor = color;
	
	        return this.update(false);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#setShadowBlur
	     * @since 3.0.0
	     *
	     * @param {number} [blur=0] - [description]
	     *
	     * @return {Phaser.GameObjects.Text} The parent Text object.
	     */
	    setShadowBlur: function (blur)
	    {
	        if (blur === undefined) { blur = 0; }
	
	        this.shadowBlur = blur;
	
	        return this.update(false);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#setShadowStroke
	     * @since 3.0.0
	     *
	     * @param {boolean} enabled - [description]
	     *
	     * @return {Phaser.GameObjects.Text} The parent Text object.
	     */
	    setShadowStroke: function (enabled)
	    {
	        this.shadowStroke = enabled;
	
	        return this.update(false);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#setShadowFill
	     * @since 3.0.0
	     *
	     * @param {boolean} enabled - [description]
	     *
	     * @return {Phaser.GameObjects.Text} The parent Text object.
	     */
	    setShadowFill: function (enabled)
	    {
	        this.shadowFill = enabled;
	
	        return this.update(false);
	    },
	
	    /**
	     * Set the width (in pixels) to use for wrapping lines. Pass in null to remove wrapping by width.
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#setWordWrapWidth
	     * @since 3.0.0
	     *
	     * @param {number} width - The maximum width of a line in pixels. Set to null to remove wrapping.
	     * @param {boolean} [useAdvancedWrap=false] - Whether or not to use the advanced wrapping
	     * algorithm. If true, spaces are collapsed and whitespace is trimmed from lines. If false,
	     * spaces and whitespace are left as is.
	     *
	     * @return {Phaser.GameObjects.Text} The parent Text object.
	     */
	    setWordWrapWidth: function (width, useAdvancedWrap)
	    {
	        if (useAdvancedWrap === undefined) { useAdvancedWrap = false; }
	
	        this.wordWrapWidth = width;
	        this.wordWrapUseAdvanced = useAdvancedWrap;
	
	        return this.update(false);
	    },
	
	    /**
	     * Set a custom callback for wrapping lines. Pass in null to remove wrapping by callback.
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#setWordWrapCallback
	     * @since 3.0.0
	     *
	     * @param {TextStyleWordWrapCallback} callback - A custom function that will be responsible for wrapping the
	     * text. It will receive two arguments: text (the string to wrap), textObject (this Text
	     * instance). It should return the wrapped lines either as an array of lines or as a string with
	     * newline characters in place to indicate where breaks should happen.
	     * @param {object} [scope=null] - The scope that will be applied when the callback is invoked.
	     *
	     * @return {Phaser.GameObjects.Text} The parent Text object.
	     */
	    setWordWrapCallback: function (callback, scope)
	    {
	        if (scope === undefined) { scope = null; }
	
	        this.wordWrapCallback = callback;
	        this.wordWrapCallbackScope = scope;
	
	        return this.update(false);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#setAlign
	     * @since 3.0.0
	     *
	     * @param {string} align - [description]
	     *
	     * @return {Phaser.GameObjects.Text} The parent Text object.
	     */
	    setAlign: function (align)
	    {
	        if (align === undefined) { align = 'left'; }
	
	        this.align = align;
	
	        return this.update(false);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#setMaxLines
	     * @since 3.0.0
	     *
	     * @param {integer} [max=0] - [description]
	     *
	     * @return {Phaser.GameObjects.Text} The parent Text object.
	     */
	    setMaxLines: function (max)
	    {
	        if (max === undefined) { max = 0; }
	
	        this.maxLines = max;
	
	        return this.update(false);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#getTextMetrics
	     * @since 3.0.0
	     *
	     * @return {object} [description]
	     */
	    getTextMetrics: function ()
	    {
	        var metrics = this.metrics;
	
	        return {
	            ascent: metrics.ascent,
	            descent: metrics.descent,
	            fontSize: metrics.fontSize
	        };
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#toJSON
	     * @since 3.0.0
	     *
	     * @return {object} [description]
	     */
	    toJSON: function ()
	    {
	        var output = {};
	
	        for (var key in propertyMap)
	        {
	            output[key] = this[key];
	        }
	
	        output.metrics = this.getTextMetrics();
	
	        return output;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.GameObjects.Text.TextStyle#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.parent = undefined;
	    }
	
	});
	
	module.exports = TextStyle;


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the Canvas Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.Text#renderCanvas
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
	 * @param {Phaser.GameObjects.Text} src - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 */
	var TextCanvasRenderer = function (renderer, src, interpolationPercentage, camera, parentMatrix)
	{
	    if (GameObject.RENDER_MASK !== src.renderFlags || (src.cameraFilter > 0 && (src.cameraFilter & camera._id)) || src.text === '')
	    {
	        return;
	    }
	    
	    var ctx = renderer.currentContext;
	
	    // var resolution = src.resolution;
	
	    //  Blend Mode
	    if (renderer.currentBlendMode !== src.blendMode)
	    {
	        renderer.currentBlendMode = src.blendMode;
	        ctx.globalCompositeOperation = renderer.blendModes[src.blendMode];
	    }
	
	    //  Alpha
	    if (renderer.currentAlpha !== src.alpha)
	    {
	        renderer.currentAlpha = src.alpha;
	        ctx.globalAlpha = src.alpha;
	    }
	
	    //  Smoothing
	    if (renderer.currentScaleMode !== src.scaleMode)
	    {
	        renderer.currentScaleMode = src.scaleMode;
	    }
	
	    var canvas = src.canvas;
	
	    ctx.save();
	
	    if (parentMatrix !== undefined)
	    {
	        var matrix = parentMatrix.matrix;
	        ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
	    }
	
	    var tx = src.x - camera.scrollX * src.scrollFactorX;
	    var ty = src.y - camera.scrollY * src.scrollFactorY;
	
	    if (renderer.config.roundPixels)
	    {
	        tx |= 0;
	        ty |= 0;
	    }
	
	    ctx.translate(tx, ty);
	
	    ctx.rotate(src.rotation);
	
	    ctx.scale(src.scaleX, src.scaleY);
	
	    ctx.translate(canvas.width * (src.flipX ? 1 : 0), canvas.height * (src.flipY ? 1 : 0));
	
	    ctx.scale(src.flipX ? -1 : 1, src.flipY ? -1 : 1);
	
	    ctx.drawImage(canvas, 0, 0, canvas.width, canvas.height, -src.displayOriginX, -src.displayOriginY, canvas.width, canvas.height);
	
	    ctx.restore();
	};
	
	module.exports = TextCanvasRenderer;


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BuildGameObject = __webpack_require__(50);
	var GameObjectCreator = __webpack_require__(26);
	var GetAdvancedValue = __webpack_require__(24);
	var Text = __webpack_require__(283);
	
	/**
	 * Creates a new Text Game Object and returns it.
	 *
	 * Note: This method will only be available if the Text Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectCreator#text
	 * @since 3.0.0
	 *
	 * @param {object} config - The configuration object this Game Object will use to create itself.
	 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
	 *
	 * @return {Phaser.GameObjects.Text} The Game Object that was created.
	 */
	GameObjectCreator.register('text', function (config, addToScene)
	{
	    if (config === undefined) { config = {}; }
	
	    // style Object = {
	    //     font: [ 'font', '16px Courier' ],
	    //     backgroundColor: [ 'backgroundColor', null ],
	    //     fill: [ 'fill', '#fff' ],
	    //     stroke: [ 'stroke', '#fff' ],
	    //     strokeThickness: [ 'strokeThickness', 0 ],
	    //     shadowOffsetX: [ 'shadow.offsetX', 0 ],
	    //     shadowOffsetY: [ 'shadow.offsetY', 0 ],
	    //     shadowColor: [ 'shadow.color', '#000' ],
	    //     shadowBlur: [ 'shadow.blur', 0 ],
	    //     shadowStroke: [ 'shadow.stroke', false ],
	    //     shadowFill: [ 'shadow.fill', false ],
	    //     align: [ 'align', 'left' ],
	    //     maxLines: [ 'maxLines', 0 ],
	    //     fixedWidth: [ 'fixedWidth', false ],
	    //     fixedHeight: [ 'fixedHeight', false ],
	    //     rtl: [ 'rtl', false ]
	    // }
	
	    var content = GetAdvancedValue(config, 'text', '');
	    var style = GetAdvancedValue(config, 'style', null);
	
	    //  Padding
	    //      { padding: 2 }
	    //      { padding: { x: , y: }}
	    //      { padding: { left: , top: }}
	    //      { padding: { left: , right: , top: , bottom: }}
	
	    var padding = GetAdvancedValue(config, 'padding', null);
	
	    if (padding !== null)
	    {
	        style.padding = padding;
	    }
	
	    var text = new Text(this.scene, 0, 0, content, style);
	
	    if (addToScene !== undefined)
	    {
	        config.add = addToScene;
	    }
	
	    BuildGameObject(this.scene, text, config);
	
	    //  Text specific config options:
	
	    text.autoRound = GetAdvancedValue(config, 'autoRound', true);
	    text.resolution = GetAdvancedValue(config, 'resolution', 1);
	
	    return text;
	});
	
	//  When registering a factory function 'this' refers to the GameObjectCreator context.


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Text = __webpack_require__(283);
	var GameObjectFactory = __webpack_require__(18);
	
	/**
	 * Creates a new Text Game Object and adds it to the Scene.
	 *
	 * Note: This method will only be available if the Text Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectFactory#text
	 * @since 3.0.0
	 *
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {(string|string[])} text - The text this Text object will display.
	 * @param {object} [style] - The Text style configuration object.
	 *
	 * @return {Phaser.GameObjects.Text} The Game Object that was created.
	 */
	GameObjectFactory.register('text', function (x, y, text, style)
	{
	    return this.displayList.add(new Text(this.scene, x, y, text, style));
	});
	
	//  When registering a factory function 'this' refers to the GameObjectFactory context.
	//
	//  There are several properties available to use:
	//
	//  this.scene - a reference to the Scene that owns the GameObjectFactory
	//  this.displayList - a reference to the Display List the Scene owns
	//  this.updateList - a reference to the Update List the Scene owns


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var renderWebGL = __webpack_require__(6);
	var renderCanvas = __webpack_require__(6);
	
	if (true)
	{
	    renderWebGL = __webpack_require__(1195);
	}
	
	if (true)
	{
	    renderCanvas = __webpack_require__(1191);
	}
	
	module.exports = {
	
	    renderWebGL: renderWebGL,
	    renderCanvas: renderCanvas
	
	};


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the WebGL Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.Text#renderWebGL
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
	 * @param {Phaser.GameObjects.Text} src - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 */
	var TextWebGLRenderer = function (renderer, src, interpolationPercentage, camera, parentMatrix)
	{
	    if (GameObject.RENDER_MASK !== src.renderFlags || (src.cameraFilter > 0 && (src.cameraFilter & camera._id)) || src.text === '')
	    {
	        return;
	    }
	    
	    if (src.dirty)
	    {
	        src.canvasTexture = renderer.canvasToTexture(src.canvas, src.canvasTexture);
	        src.dirty = false;
	    }
	
	    this.pipeline.batchText(this, camera, parentMatrix);
	};
	
	module.exports = TextWebGLRenderer;


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the Canvas Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.TileSprite#renderCanvas
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
	 * @param {Phaser.GameObjects.TileSprite} src - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 */
	var TileSpriteCanvasRenderer = function (renderer, src, interpolationPercentage, camera, parentMatrix)
	{
	    if (GameObject.RENDER_MASK !== src.renderFlags || (src.cameraFilter > 0 && (src.cameraFilter & camera._id)))
	    {
	        return;
	    }
	
	    var ctx = renderer.currentContext;
	    var frame = src.frame;
	
	    src.updateTileTexture();
	
	    //  Blend Mode
	
	    if (renderer.currentBlendMode !== src.blendMode)
	    {
	        renderer.currentBlendMode = src.blendMode;
	        ctx.globalCompositeOperation = renderer.blendModes[src.blendMode];
	    }
	
	    //  Alpha
	
	    if (renderer.currentAlpha !== src.alpha)
	    {
	        renderer.currentAlpha = src.alpha;
	        ctx.globalAlpha = src.alpha;
	    }
	
	    //  Smoothing
	
	    if (renderer.currentScaleMode !== src.scaleMode)
	    {
	        renderer.currentScaleMode = src.scaleMode;
	    }
	
	    var dx = frame.x - (src.originX * src.width);
	    var dy = frame.y - (src.originY * src.height);
	
	    var tx = src.x - camera.scrollX * src.scrollFactorX;
	    var ty = src.y - camera.scrollY * src.scrollFactorY;
	
	    var fx = 1;
	    var fy = 1;
	
	    // Flipping
	
	    if (src.flipX)
	    {
	        fx = -1;
	        dx += src.width;
	    }
	
	    if (src.flipY)
	    {
	        fy = -1;
	        dy += src.height;
	    }
	
	    if (renderer.config.roundPixels)
	    {
	        dx |= 0;
	        dy |= 0;
	        tx |= 0;
	        ty |= 0;
	    }
	
	    ctx.save();
	
	    if (parentMatrix !== undefined)
	    {
	        var matrix = parentMatrix.matrix;
	        ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
	    }
	
	    ctx.translate(dx, dy);
	
	    ctx.translate(tx, ty);
	
	    // Flip
	    ctx.scale(fx, fy);
	
	    // Rotate and scale around center
	    ctx.translate((src.originX * src.width), (src.originY * src.height));
	    ctx.rotate(fx * fy * src.rotation);
	    ctx.scale(this.scaleX, this.scaleY);
	    ctx.translate(-(src.originX * src.width), -(src.originY * src.height));
	
	    // Draw
	    ctx.translate(-this.tilePositionX, -this.tilePositionY);
	    ctx.fillStyle = src.canvasPattern;
	    ctx.fillRect(this.tilePositionX, this.tilePositionY, src.width, src.height);
	
	    ctx.restore();
	};
	
	module.exports = TileSpriteCanvasRenderer;


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var BuildGameObject = __webpack_require__(50);
	var GameObjectCreator = __webpack_require__(26);
	var GetAdvancedValue = __webpack_require__(24);
	var TileSprite = __webpack_require__(284);
	
	/**
	 * @typedef {object} TileSprite
	 * @extends GameObjectConfig
	 *
	 * @property {number} [x=0] - [description]
	 * @property {number} [y=0] - [description]
	 * @property {number} [width=512] - [description]
	 * @property {number} [height=512] - [description]
	 * @property {string} [key=''] - [description]
	 * @property {string} [frame=''] - [description]
	 */
	
	/**
	 * Creates a new TileSprite Game Object and returns it.
	 *
	 * Note: This method will only be available if the TileSprite Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectCreator#tileSprite
	 * @since 3.0.0
	 *
	 * @param {TileSprite} config - The configuration object this Game Object will use to create itself.
	 * @param {boolean} [addToScene] - Add this Game Object to the Scene after creating it? If set this argument overrides the `add` property in the config object.
	 *
	 * @return {Phaser.GameObjects.TileSprite} The Game Object that was created.
	 */
	GameObjectCreator.register('tileSprite', function (config, addToScene)
	{
	    if (config === undefined) { config = {}; }
	
	    var x = GetAdvancedValue(config, 'x', 0);
	    var y = GetAdvancedValue(config, 'y', 0);
	    var width = GetAdvancedValue(config, 'width', 512);
	    var height = GetAdvancedValue(config, 'height', 512);
	    var key = GetAdvancedValue(config, 'key', '');
	    var frame = GetAdvancedValue(config, 'frame', '');
	
	    var tile = new TileSprite(this.scene, x, y, width, height, key, frame);
	
	    if (addToScene !== undefined)
	    {
	        config.add = addToScene;
	    }
	
	    BuildGameObject(this.scene, tile, config);
	
	    return tile;
	});
	
	//  When registering a factory function 'this' refers to the GameObjectCreator context.


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var TileSprite = __webpack_require__(284);
	var GameObjectFactory = __webpack_require__(18);
	
	/**
	 * Creates a new TileSprite Game Object and adds it to the Scene.
	 *
	 * Note: This method will only be available if the TileSprite Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectFactory#tileSprite
	 * @since 3.0.0
	 *
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {number} width - The width of the Game Object.
	 * @param {number} height - The height of the Game Object.
	 * @param {string} texture - The key of the Texture this Game Object will use to render with, as stored in the Texture Manager.
	 * @param {(string|integer)} [frame] - An optional frame from the Texture this Game Object is rendering with.
	 *
	 * @return {Phaser.GameObjects.TileSprite} The Game Object that was created.
	 */
	GameObjectFactory.register('tileSprite', function (x, y, width, height, key, frame)
	{
	    return this.displayList.add(new TileSprite(this.scene, x, y, width, height, key, frame));
	});
	
	//  When registering a factory function 'this' refers to the GameObjectFactory context.
	//
	//  There are several properties available to use:
	//
	//  this.scene - a reference to the Scene that owns the GameObjectFactory
	//  this.displayList - a reference to the Display List the Scene owns
	//  this.updateList - a reference to the Update List the Scene owns


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var renderWebGL = __webpack_require__(6);
	var renderCanvas = __webpack_require__(6);
	
	if (true)
	{
	    renderWebGL = __webpack_require__(1200);
	}
	
	if (true)
	{
	    renderCanvas = __webpack_require__(1196);
	}
	
	module.exports = {
	
	    renderWebGL: renderWebGL,
	    renderCanvas: renderCanvas
	
	};


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the WebGL Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.GameObjects.TileSprite#renderWebGL
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
	 * @param {Phaser.GameObjects.TileSprite} src - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 * @param {Phaser.GameObjects.Components.TransformMatrix} parentMatrix - This transform matrix is defined if the game object is nested
	 */
	var TileSpriteWebGLRenderer = function (renderer, src, interpolationPercentage, camera, parentMatrix)
	{
	    if (GameObject.RENDER_MASK !== src.renderFlags || (src.cameraFilter > 0 && (src.cameraFilter & camera._id)))
	    {
	        return;
	    }
	
	    src.updateTileTexture();
	
	    this.pipeline.batchTileSprite(this, camera, parentMatrix);
	};
	
	module.exports = TileSpriteWebGLRenderer;


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObjectCreator = __webpack_require__(26);
	var GetAdvancedValue = __webpack_require__(24);
	var Zone = __webpack_require__(198);
	
	/**
	 * Creates a new Zone Game Object and returns it.
	 *
	 * Note: This method will only be available if the Zone Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectCreator#zone
	 * @since 3.0.0
	 *
	 * @param {object} config - [description]
	 *
	 * @return {Phaser.GameObjects.Zone} The Game Object that was created.
	 */
	GameObjectCreator.register('zone', function (config)
	{
	    var x = GetAdvancedValue(config, 'x', 0);
	    var y = GetAdvancedValue(config, 'y', 0);
	    var width = GetAdvancedValue(config, 'width', 1);
	    var height = GetAdvancedValue(config, 'height', width);
	
	    return new Zone(this.scene, x, y, width, height);
	});
	
	//  When registering a factory function 'this' refers to the GameObjectCreator context.


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Zone = __webpack_require__(198);
	var GameObjectFactory = __webpack_require__(18);
	
	/**
	 * Creates a new Zone Game Object and adds it to the Scene.
	 *
	 * Note: This method will only be available if the Zone Game Object has been built into Phaser.
	 *
	 * @method Phaser.GameObjects.GameObjectFactory#zone
	 * @since 3.0.0
	 *
	 * @param {number} x - The horizontal position of this Game Object in the world.
	 * @param {number} y - The vertical position of this Game Object in the world.
	 * @param {number} width - The width of the Game Object.
	 * @param {number} height - The height of the Game Object.
	 * 
	 * @return {Phaser.GameObjects.Zone} The Game Object that was created.
	 */
	GameObjectFactory.register('zone', function (x, y, width, height)
	{
	    return this.displayList.add(new Zone(this.scene, x, y, width, height));
	});
	
	//  When registering a factory function 'this' refers to the GameObjectFactory context.
	//  
	//  There are several properties available to use:
	//  
	//  this.scene - a reference to the Scene that owns the GameObjectFactory
	//  this.displayList - a reference to the Display List the Scene owns
	//  this.updateList - a reference to the Update List the Scene owns


/***/ }),
/* 1203 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Calculates the area of the circle.
	 *
	 * @function Phaser.Geom.Circle.Area
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Circle} circle - The Circle to get the area of.
	 *
	 * @return {number} The area of the Circle.
	 */
	var Area = function (circle)
	{
	    return (circle.radius > 0) ? Math.PI * circle.radius * circle.radius : 0;
	};
	
	module.exports = Area;


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Circle = __webpack_require__(160);
	
	/**
	 * Creates a new Circle instance based on the values contained in the given source.
	 *
	 * @function Phaser.Geom.Circle.Clone
	 * @since 3.0.0
	 *
	 * @param {(Phaser.Geom.Circle|object)} source - The Circle to be cloned. Can be an instance of a Circle or a circle-like object, with x, y and radius properties.
	 *
	 * @return {Phaser.Geom.Circle} A clone of the source Circle.
	 */
	var Clone = function (source)
	{
	    return new Circle(source.x, source.y, source.radius);
	};
	
	module.exports = Clone;


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Contains = __webpack_require__(83);
	
	/**
	 * Check to see if the Circle contains the given Point object.
	 *
	 * @function Phaser.Geom.Circle.ContainsPoint
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Circle} circle - The Circle to check.
	 * @param {(Phaser.Geom.Point|object)} point - The Point object to check if it's within the Circle or not.
	 *
	 * @return {boolean} True if the Point coordinates are within the circle, otherwise false.
	 */
	var ContainsPoint = function (circle, point)
	{
	    return Contains(circle, point.x, point.y);
	};
	
	module.exports = ContainsPoint;


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Contains = __webpack_require__(83);
	
	/**
	 * Check to see if the Circle contains all four points of the given Rectangle object.
	 *
	 * @function Phaser.Geom.Circle.ContainsRect
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Circle} circle - The Circle to check.
	 * @param {(Phaser.Geom.Rectangle|object)} rect - The Rectangle object to check if it's within the Circle or not.
	 *
	 * @return {boolean} True if all of the Rectangle coordinates are within the circle, otherwise false.
	 */
	var ContainsRect = function (circle, rect)
	{
	    return (
	        Contains(circle, rect.x, rect.y) &&
	        Contains(circle, rect.right, rect.y) &&
	        Contains(circle, rect.x, rect.bottom) &&
	        Contains(circle, rect.right, rect.bottom)
	    );
	};
	
	module.exports = ContainsRect;


/***/ }),
/* 1207 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Copies the `x`, `y` and `radius` properties from the `source` Circle
	 * into the given `dest` Circle, then returns the `dest` Circle.
	 *
	 * @function Phaser.Geom.Circle.CopyFrom
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Circle} O - [dest,$return]
	 *
	 * @param {Phaser.Geom.Circle} source - The source Circle to copy the values from.
	 * @param {Phaser.Geom.Circle} dest - The destination Circle to copy the values to.
	 *
	 * @return {Phaser.Geom.Circle} The dest Circle.
	 */
	var CopyFrom = function (source, dest)
	{
	    return dest.setTo(source.x, source.y, source.radius);
	};
	
	module.exports = CopyFrom;


/***/ }),
/* 1208 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Compares the `x`, `y` and `radius` properties of the two given Circles.
	 * Returns `true` if they all match, otherwise returns `false`.
	 *
	 * @function Phaser.Geom.Circle.Equals
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Circle} circle - The first Circle to compare.
	 * @param {Phaser.Geom.Circle} toCompare - The second Circle to compare.
	 *
	 * @return {boolean} `true` if the two Circles equal each other, otherwise `false`.
	 */
	var Equals = function (circle, toCompare)
	{
	    return (
	        circle.x === toCompare.x &&
	        circle.y === toCompare.y &&
	        circle.radius === toCompare.radius
	    );
	};
	
	module.exports = Equals;


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Rectangle = __webpack_require__(23);
	
	/**
	 * Returns the bounds of the Circle object.
	 *
	 * @function Phaser.Geom.Circle.GetBounds
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Circle} circle - The Circle to get the bounds from.
	 * @param {(Phaser.Geom.Rectangle|object)} [out] - A Rectangle, or rectangle-like object, to store the circle bounds in. If not given a new Rectangle will be created.
	 *
	 * @return {(Phaser.Geom.Rectangle|object)} The Rectangle object containing the Circles bounds.
	 */
	var GetBounds = function (circle, out)
	{
	    if (out === undefined) { out = new Rectangle(); }
	
	    out.x = circle.left;
	    out.y = circle.top;
	    out.width = circle.diameter;
	    out.height = circle.diameter;
	
	    return out;
	};
	
	module.exports = GetBounds;


/***/ }),
/* 1210 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Offsets the Circle by the values given.
	 *
	 * @function Phaser.Geom.Circle.Offset
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Circle} O - [circle,$return]
	 *
	 * @param {Phaser.Geom.Circle} circle - The Circle to be offset (translated.)
	 * @param {number} x - The amount to horizontally offset the Circle by.
	 * @param {number} y - The amount to vertically offset the Circle by.
	 *
	 * @return {Phaser.Geom.Circle} The Circle that was offset.
	 */
	var Offset = function (circle, x, y)
	{
	    circle.x += x;
	    circle.y += y;
	
	    return circle;
	};
	
	module.exports = Offset;


/***/ }),
/* 1211 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Offsets the Circle by the values given in the `x` and `y` properties of the Point object.
	 *
	 * @function Phaser.Geom.Circle.OffsetPoint
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Circle} O - [circle,$return]
	 *
	 * @param {Phaser.Geom.Circle} circle - The Circle to be offset (translated.)
	 * @param {(Phaser.Geom.Point|object)} point - The Point object containing the values to offset the Circle by.
	 *
	 * @return {Phaser.Geom.Circle} The Circle that was offset.
	 */
	var OffsetPoint = function (circle, point)
	{
	    circle.x += point.x;
	    circle.y += point.y;
	
	    return circle;
	};
	
	module.exports = OffsetPoint;


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Circle = __webpack_require__(160);
	
	Circle.Area = __webpack_require__(1203);
	Circle.Circumference = __webpack_require__(501);
	Circle.CircumferencePoint = __webpack_require__(285);
	Circle.Clone = __webpack_require__(1204);
	Circle.Contains = __webpack_require__(83);
	Circle.ContainsPoint = __webpack_require__(1205);
	Circle.ContainsRect = __webpack_require__(1206);
	Circle.CopyFrom = __webpack_require__(1207);
	Circle.Equals = __webpack_require__(1208);
	Circle.GetBounds = __webpack_require__(1209);
	Circle.GetPoint = __webpack_require__(502);
	Circle.GetPoints = __webpack_require__(503);
	Circle.Offset = __webpack_require__(1210);
	Circle.OffsetPoint = __webpack_require__(1211);
	Circle.Random = __webpack_require__(286);
	
	module.exports = Circle;


/***/ }),
/* 1213 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Calculates the area of the Ellipse.
	 *
	 * @function Phaser.Geom.Ellipse.Area
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the area of.
	 *
	 * @return {number} The area of the Ellipse.
	 */
	var Area = function (ellipse)
	{
	    if (ellipse.isEmpty())
	    {
	        return 0;
	    }
	
	    //  units squared
	    return (ellipse.getMajorRadius() * ellipse.getMinorRadius() * Math.PI);
	};
	
	module.exports = Area;


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Ellipse = __webpack_require__(288);
	
	/**
	 * Creates a new Ellipse instance based on the values contained in the given source.
	 *
	 * @function Phaser.Geom.Ellipse.Clone
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Ellipse} source - The Ellipse to be cloned. Can be an instance of an Ellipse or a ellipse-like object, with x, y, width and height properties.
	 *
	 * @return {Phaser.Geom.Ellipse} A clone of the source Ellipse.
	 */
	var Clone = function (source)
	{
	    return new Ellipse(source.x, source.y, source.width, source.height);
	};
	
	module.exports = Clone;


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Contains = __webpack_require__(161);
	
	/**
	 * Check to see if the Ellipse contains the given Point object.
	 *
	 * @function Phaser.Geom.Ellipse.ContainsPoint
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to check.
	 * @param {(Phaser.Geom.Point|object)} point - The Point object to check if it's within the Circle or not.
	 *
	 * @return {boolean} True if the Point coordinates are within the circle, otherwise false.
	 */
	var ContainsPoint = function (ellipse, point)
	{
	    return Contains(ellipse, point.x, point.y);
	};
	
	module.exports = ContainsPoint;


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Contains = __webpack_require__(161);
	
	/**
	 * Check to see if the Ellipse contains all four points of the given Rectangle object.
	 *
	 * @function Phaser.Geom.Ellipse.ContainsRect
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Ellipse} ellipse - [description]
	 * @param {(Phaser.Geom.Rectangle|object)} rect - The Rectangle object to check if it's within the Ellipse or not.
	 *
	 * @return {boolean} True if all of the Rectangle coordinates are within the ellipse, otherwise false.
	 */
	var ContainsRect = function (ellipse, rect)
	{
	    return (
	        Contains(ellipse, rect.x, rect.y) &&
	        Contains(ellipse, rect.right, rect.y) &&
	        Contains(ellipse, rect.x, rect.bottom) &&
	        Contains(ellipse, rect.right, rect.bottom)
	    );
	};
	
	module.exports = ContainsRect;


/***/ }),
/* 1217 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Copies the `x`, `y`, `width` and `height` properties from the `source` Ellipse
	 * into the given `dest` Ellipse, then returns the `dest` Ellipse.
	 *
	 * @function Phaser.Geom.Ellipse.CopyFrom
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Ellipse} O - [dest,$return]
	 *
	 * @param {Phaser.Geom.Ellipse} source - The source Ellipse to copy the values from.
	 * @param {Phaser.Geom.Ellipse} dest - The destination Ellipse to copy the values to.
	 *
	 * @return {Phaser.Geom.Ellipse} The dest Ellipse.
	 */
	var CopyFrom = function (source, dest)
	{
	    return dest.setTo(source.x, source.y, source.width, source.height);
	};
	
	module.exports = CopyFrom;


/***/ }),
/* 1218 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Compares the `x`, `y`, `width` and `height` properties of the two given Ellipses.
	 * Returns `true` if they all match, otherwise returns `false`.
	 *
	 * @function Phaser.Geom.Ellipse.Equals
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Ellipse} ellipse - The first Ellipse to compare.
	 * @param {Phaser.Geom.Ellipse} toCompare - The second Ellipse to compare.
	 *
	 * @return {boolean} `true` if the two Ellipse equal each other, otherwise `false`.
	 */
	var Equals = function (ellipse, toCompare)
	{
	    return (
	        ellipse.x === toCompare.x &&
	        ellipse.y === toCompare.y &&
	        ellipse.width === toCompare.width &&
	        ellipse.height === toCompare.height
	    );
	};
	
	module.exports = Equals;


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Rectangle = __webpack_require__(23);
	
	/**
	 * Returns the bounds of the Ellipse object.
	 *
	 * @function Phaser.Geom.Ellipse.GetBounds
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to get the bounds from.
	 * @param {(Phaser.Geom.Rectangle|object)} [out] - A Rectangle, or rectangle-like object, to store the ellipse bounds in. If not given a new Rectangle will be created.
	 *
	 * @return {(Phaser.Geom.Rectangle|object)} The Rectangle object containing the Ellipse bounds.
	 */
	var GetBounds = function (ellipse, out)
	{
	    if (out === undefined) { out = new Rectangle(); }
	
	    out.x = ellipse.left;
	    out.y = ellipse.top;
	    out.width = ellipse.width;
	    out.height = ellipse.height;
	
	    return out;
	};
	
	module.exports = GetBounds;


/***/ }),
/* 1220 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Offsets the Ellipse by the values given.
	 *
	 * @function Phaser.Geom.Ellipse.Offset
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Ellipse} O - [ellipse,$return]
	 *
	 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to be offset (translated.)
	 * @param {number} x - The amount to horizontally offset the Ellipse by.
	 * @param {number} y - The amount to vertically offset the Ellipse by.
	 *
	 * @return {Phaser.Geom.Ellipse} The Ellipse that was offset.
	 */
	var Offset = function (ellipse, x, y)
	{
	    ellipse.x += x;
	    ellipse.y += y;
	
	    return ellipse;
	};
	
	module.exports = Offset;


/***/ }),
/* 1221 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Offsets the Ellipse by the values given in the `x` and `y` properties of the Point object.
	 *
	 * @function Phaser.Geom.Ellipse.OffsetPoint
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Ellipse} O - [ellipse,$return]
	 *
	 * @param {Phaser.Geom.Ellipse} ellipse - The Ellipse to be offset (translated.)
	 * @param {(Phaser.Geom.Point|object)} point - The Point object containing the values to offset the Ellipse by.
	 *
	 * @return {Phaser.Geom.Ellipse} The Ellipse that was offset.
	 */
	var OffsetPoint = function (ellipse, point)
	{
	    ellipse.x += point.x;
	    ellipse.y += point.y;
	
	    return ellipse;
	};
	
	module.exports = OffsetPoint;


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var DistanceBetween = __webpack_require__(116);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Intersects.CircleToCircle
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Circle} circleA - [description]
	 * @param {Phaser.Geom.Circle} circleB - [description]
	 *
	 * @return {boolean} [description]
	 */
	var CircleToCircle = function (circleA, circleB)
	{
	    return (DistanceBetween(circleA.x, circleA.y, circleB.x, circleB.y) <= (circleA.radius + circleB.radius));
	};
	
	module.exports = CircleToCircle;


/***/ }),
/* 1223 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Intersects.CircleToRectangle
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Circle} circle - [description]
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 *
	 * @return {boolean} [description]
	 */
	var CircleToRectangle = function (circle, rect)
	{
	    var halfWidth = rect.width / 2;
	    var halfHeight = rect.height / 2;
	
	    var cx = Math.abs(circle.x - rect.x - halfWidth);
	    var cy = Math.abs(circle.y - rect.y - halfHeight);
	    var xDist = halfWidth + circle.radius;
	    var yDist = halfHeight + circle.radius;
	
	    if (cx > xDist || cy > yDist)
	    {
	        return false;
	    }
	    else if (cx <= halfWidth || cy <= halfHeight)
	    {
	        return true;
	    }
	    else
	    {
	        var xCornerDist = cx - halfWidth;
	        var yCornerDist = cy - halfHeight;
	        var xCornerDistSq = xCornerDist * xCornerDist;
	        var yCornerDistSq = yCornerDist * yCornerDist;
	        var maxCornerDistSq = circle.radius * circle.radius;
	
	        return (xCornerDistSq + yCornerDistSq <= maxCornerDistSq);
	    }
	};
	
	module.exports = CircleToRectangle;


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Rectangle = __webpack_require__(23);
	var RectangleToRectangle = __webpack_require__(511);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Intersects.GetRectangleIntersection
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Rectangle} O - [output,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} rectA - [description]
	 * @param {Phaser.Geom.Rectangle} rectB - [description]
	 * @param {Phaser.Geom.Rectangle} [output] - [description]
	 *
	 * @return {Phaser.Geom.Rectangle} [description]
	 */
	var GetRectangleIntersection = function (rectA, rectB, output)
	{
	    if (output === undefined) { output = new Rectangle(); }
	
	    if (RectangleToRectangle(rectA, rectB))
	    {
	        output.x = Math.max(rectA.x, rectB.x);
	        output.y = Math.max(rectA.y, rectB.y);
	        output.width = Math.min(rectA.right, rectB.right) - output.x;
	        output.height = Math.min(rectA.bottom, rectB.bottom) - output.y;
	    }
	
	    return output;
	};
	
	module.exports = GetRectangleIntersection;


/***/ }),
/* 1225 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Checks for intersection between the Line and a Rectangle shape, or a rectangle-like
	 * object, with public `x`, `y`, `right` and `bottom` properties, such as a Sprite or Body.
	 *
	 * An intersection is considered valid if:
	 *
	 * The line starts within, or ends within, the Rectangle.
	 * The line segment intersects one of the 4 rectangle edges.
	 *
	 * The for the purposes of this function rectangles are considered 'solid'.
	 *
	 * @function Phaser.Geom.Intersects.LineToRectangle
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 * @param {(Phaser.Geom.Rectangle|object)} rect - [description]
	 *
	 * @return {boolean} [description]
	 */
	var LineToRectangle = function (line, rect)
	{
	    var x1 = line.x1;
	    var y1 = line.y1;
	
	    var x2 = line.x2;
	    var y2 = line.y2;
	
	    var bx1 = rect.x;
	    var by1 = rect.y;
	    var bx2 = rect.right;
	    var by2 = rect.bottom;
	
	    var t = 0;
	
	    //  If the start or end of the line is inside the rect then we assume
	    //  collision, as rects are solid for our use-case.
	
	    if ((x1 >= bx1 && x1 <= bx2 && y1 >= by1 && y1 <= by2) ||
	        (x2 >= bx1 && x2 <= bx2 && y2 >= by1 && y2 <= by2))
	    {
	        return true;
	    }
	
	    if (x1 < bx1 && x2 >= bx1)
	    {
	        //  Left edge
	        t = y1 + (y2 - y1) * (bx1 - x1) / (x2 - x1);
	
	        if (t > by1 && t <= by2)
	        {
	            return true;
	        }
	    }
	    else if (x1 > bx2 && x2 <= bx2)
	    {
	        //  Right edge
	        t = y1 + (y2 - y1) * (bx2 - x1) / (x2 - x1);
	
	        if (t >= by1 && t <= by2)
	        {
	            return true;
	        }
	    }
	
	    if (y1 < by1 && y2 >= by1)
	    {
	        //  Top edge
	        t = x1 + (x2 - x1) * (by1 - y1) / (y2 - y1);
	
	        if (t >= bx1 && t <= bx2)
	        {
	            return true;
	        }
	    }
	    else if (y1 > by2 && y2 <= by2)
	    {
	        //  Bottom edge
	        t = x1 + (x2 - x1) * (by2 - y1) / (y2 - y1);
	
	        if (t >= bx1 && t <= bx2)
	        {
	            return true;
	        }
	    }
	
	    return false;
	};
	
	module.exports = LineToRectangle;


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PointToLine = __webpack_require__(510);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Intersects.PointToLineSegment
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Point} point - [description]
	 * @param {Phaser.Geom.Line} line - [description]
	 *
	 * @return {boolean} [description]
	 */
	var PointToLineSegment = function (point, line)
	{
	    if (!PointToLine(point, line))
	    {
	        return false;
	    }
	
	    var xMin = Math.min(line.x1, line.x2);
	    var xMax = Math.max(line.x1, line.x2);
	    var yMin = Math.min(line.y1, line.y2);
	    var yMax = Math.max(line.y1, line.y2);
	
	    return ((point.x >= xMin && point.x <= xMax) && (point.y >= yMin && point.y <= yMax));
	};
	
	module.exports = PointToLineSegment;


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var LineToLine = __webpack_require__(199);
	var Contains = __webpack_require__(84);
	var ContainsArray = __webpack_require__(298);
	var Decompose = __webpack_require__(521);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Intersects.RectangleToTriangle
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 *
	 * @return {boolean} [description]
	 */
	var RectangleToTriangle = function (rect, triangle)
	{
	    //  First the cheapest ones:
	
	    if (
	        triangle.left > rect.right ||
	        triangle.right < rect.left ||
	        triangle.top > rect.bottom ||
	        triangle.bottom < rect.top)
	    {
	        return false;
	    }
	
	    var triA = triangle.getLineA();
	    var triB = triangle.getLineB();
	    var triC = triangle.getLineC();
	
	    //  Are any of the triangle points within the rectangle?
	
	    if (Contains(rect, triA.x1, triA.y1) || Contains(rect, triA.x2, triA.y2))
	    {
	        return true;
	    }
	
	    if (Contains(rect, triB.x1, triB.y1) || Contains(rect, triB.x2, triB.y2))
	    {
	        return true;
	    }
	
	    if (Contains(rect, triC.x1, triC.y1) || Contains(rect, triC.x2, triC.y2))
	    {
	        return true;
	    }
	
	    //  Cheap tests over, now to see if any of the lines intersect ...
	
	    var rectA = rect.getLineA();
	    var rectB = rect.getLineB();
	    var rectC = rect.getLineC();
	    var rectD = rect.getLineD();
	
	    if (LineToLine(triA, rectA) || LineToLine(triA, rectB) || LineToLine(triA, rectC) || LineToLine(triA, rectD))
	    {
	        return true;
	    }
	
	    if (LineToLine(triB, rectA) || LineToLine(triB, rectB) || LineToLine(triB, rectC) || LineToLine(triB, rectD))
	    {
	        return true;
	    }
	
	    if (LineToLine(triC, rectA) || LineToLine(triC, rectB) || LineToLine(triC, rectC) || LineToLine(triC, rectD))
	    {
	        return true;
	    }
	
	    //  None of the lines intersect, so are any rectangle points within the triangle?
	
	    var points = Decompose(rect);
	    var within = ContainsArray(triangle, points, true);
	
	    return (within.length > 0);
	};
	
	module.exports = RectangleToTriangle;


/***/ }),
/* 1228 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Intersects.RectangleToValues
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 * @param {number} left - [description]
	 * @param {number} right - [description]
	 * @param {number} top - [description]
	 * @param {number} bottom - [description]
	 * @param {float} [tolerance=0] - [description]
	 *
	 * @return {boolean} [description]
	 */
	var RectangleToValues = function (rect, left, right, top, bottom, tolerance)
	{
	    if (tolerance === undefined) { tolerance = 0; }
	
	    return !(
	        left > rect.right + tolerance ||
	        right < rect.left - tolerance ||
	        top > rect.bottom + tolerance ||
	        bottom < rect.top - tolerance
	    );
	};
	
	module.exports = RectangleToValues;


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var LineToCircle = __webpack_require__(509);
	var Contains = __webpack_require__(140);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Intersects.TriangleToCircle
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 * @param {Phaser.Geom.Circle} circle - [description]
	 *
	 * @return {boolean} [description]
	 */
	var TriangleToCircle = function (triangle, circle)
	{
	    //  First the cheapest ones:
	
	    if (
	        triangle.left > circle.right ||
	        triangle.right < circle.left ||
	        triangle.top > circle.bottom ||
	        triangle.bottom < circle.top)
	    {
	        return false;
	    }
	
	    if (Contains(triangle, circle.x, circle.y))
	    {
	        return true;
	    }
	
	    if (LineToCircle(triangle.getLineA(), circle))
	    {
	        return true;
	    }
	
	    if (LineToCircle(triangle.getLineB(), circle))
	    {
	        return true;
	    }
	
	    if (LineToCircle(triangle.getLineC(), circle))
	    {
	        return true;
	    }
	
	    return false;
	};
	
	module.exports = TriangleToCircle;


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Contains = __webpack_require__(140);
	var LineToLine = __webpack_require__(199);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Intersects.TriangleToLine
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 * @param {Phaser.Geom.Line} line - [description]
	 *
	 * @return {boolean} [description]
	 */
	var TriangleToLine = function (triangle, line)
	{
	    //  If the Triangle contains either the start or end point of the line, it intersects
	    if (Contains(triangle, line.getPointA()) || Contains(triangle, line.getPointB()))
	    {
	        return true;
	    }
	
	    //  Now check the line against each line of the Triangle
	    if (LineToLine(triangle.getLineA(), line))
	    {
	        return true;
	    }
	
	    if (LineToLine(triangle.getLineB(), line))
	    {
	        return true;
	    }
	
	    if (LineToLine(triangle.getLineC(), line))
	    {
	        return true;
	    }
	
	    return false;
	};
	
	module.exports = TriangleToLine;


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var ContainsArray = __webpack_require__(298);
	var Decompose = __webpack_require__(527);
	var LineToLine = __webpack_require__(199);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Intersects.TriangleToTriangle
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Triangle} triangleA - [description]
	 * @param {Phaser.Geom.Triangle} triangleB - [description]
	 *
	 * @return {boolean} [description]
	 */
	var TriangleToTriangle = function (triangleA, triangleB)
	{
	    //  First the cheapest ones:
	
	    if (
	        triangleA.left > triangleB.right ||
	        triangleA.right < triangleB.left ||
	        triangleA.top > triangleB.bottom ||
	        triangleA.bottom < triangleB.top)
	    {
	        return false;
	    }
	
	    var lineAA = triangleA.getLineA();
	    var lineAB = triangleA.getLineB();
	    var lineAC = triangleA.getLineC();
	
	    var lineBA = triangleB.getLineA();
	    var lineBB = triangleB.getLineB();
	    var lineBC = triangleB.getLineC();
	
	    //  Now check the lines against each line of TriangleB
	    if (LineToLine(lineAA, lineBA) || LineToLine(lineAA, lineBB) || LineToLine(lineAA, lineBC))
	    {
	        return true;
	    }
	
	    if (LineToLine(lineAB, lineBA) || LineToLine(lineAB, lineBB) || LineToLine(lineAB, lineBC))
	    {
	        return true;
	    }
	
	    if (LineToLine(lineAC, lineBA) || LineToLine(lineAC, lineBB) || LineToLine(lineAC, lineBC))
	    {
	        return true;
	    }
	
	    //  Nope, so check to see if any of the points of triangleA are within triangleB
	
	    var points = Decompose(triangleA);
	    var within = ContainsArray(triangleB, points, true);
	
	    if (within.length > 0)
	    {
	        return true;
	    }
	
	    //  Finally check to see if any of the points of triangleB are within triangleA
	
	    points = Decompose(triangleB);
	    within = ContainsArray(triangleA, points, true);
	
	    if (within.length > 0)
	    {
	        return true;
	    }
	
	    return false;
	};
	
	module.exports = TriangleToTriangle;


/***/ }),
/* 1232 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.CenterOn
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 * @param {number} x - [description]
	 * @param {number} y - [description]
	 *
	 * @return {Phaser.Geom.Line} [description]
	 */
	var CenterOn = function (line, x, y)
	{
	    var tx = x - ((line.x1 + line.x2) / 2);
	    var ty = y - ((line.y1 + line.y2) / 2);
	
	    line.x1 += tx;
	    line.y1 += ty;
	
	    line.x2 += tx;
	    line.y2 += ty;
	
	    return line;
	};
	
	module.exports = CenterOn;


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Line = __webpack_require__(200);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.Clone
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Line} source - [description]
	 *
	 * @return {Phaser.Geom.Line} [description]
	 */
	var Clone = function (source)
	{
	    return new Line(source.x1, source.y1, source.x2, source.y2);
	};
	
	module.exports = Clone;


/***/ }),
/* 1234 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.CopyFrom
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Line} O - [dest,$return]
	 *
	 * @param {Phaser.Geom.Line} source - [description]
	 * @param {Phaser.Geom.Line} dest - [description]
	 *
	 * @return {Phaser.Geom.Line} [description]
	 */
	var CopyFrom = function (source, dest)
	{
	    return dest.setTo(source.x1, source.y1, source.x2, source.y2);
	};
	
	module.exports = CopyFrom;


/***/ }),
/* 1235 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.Equals
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 * @param {Phaser.Geom.Line} toCompare - [description]
	 *
	 * @return {boolean} [description]
	 */
	var Equals = function (line, toCompare)
	{
	    return (
	        line.x1 === toCompare.x1 &&
	        line.y1 === toCompare.y1 &&
	        line.x2 === toCompare.x2 &&
	        line.y2 === toCompare.y2
	    );
	};
	
	module.exports = Equals;


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.GetMidPoint
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 * @param {(Phaser.Geom.Point|object)} [out] - [description]
	 *
	 * @return {(Phaser.Geom.Point|object)} [description]
	 */
	var GetMidPoint = function (line, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    out.x = (line.x1 + line.x2) / 2;
	    out.y = (line.y1 + line.y2) / 2;
	
	    return out;
	};
	
	module.exports = GetMidPoint;


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var MATH_CONST = __webpack_require__(33);
	var Angle = __webpack_require__(139);
	var Point = __webpack_require__(12);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.GetNormal
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 * @param {(Phaser.Geom.Point|object)} [out] - [description]
	 *
	 * @return {(Phaser.Geom.Point|object)} [description]
	 */
	var GetNormal = function (line, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    var a = Angle(line) - MATH_CONST.TAU;
	
	    out.x = Math.cos(a);
	    out.y = Math.sin(a);
	
	    return out;
	};
	
	module.exports = GetNormal;


/***/ }),
/* 1238 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.Height
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 *
	 * @return {number} [description]
	 */
	var Height = function (line)
	{
	    return Math.abs(line.y1 - line.y2);
	};
	
	module.exports = Height;


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var MATH_CONST = __webpack_require__(33);
	var Angle = __webpack_require__(139);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.NormalX
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 *
	 * @return {number} [description]
	 */
	var NormalX = function (line)
	{
	    return Math.cos(Angle(line) - MATH_CONST.TAU);
	};
	
	module.exports = NormalX;


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var MATH_CONST = __webpack_require__(33);
	var Angle = __webpack_require__(139);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.NormalY
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 *
	 * @return {number} [description]
	 */
	var NormalY = function (line)
	{
	    return Math.sin(Angle(line) - MATH_CONST.TAU);
	};
	
	module.exports = NormalY;


/***/ }),
/* 1241 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.Offset
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Line} O - [line,$return]
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 * @param {number} x - [description]
	 * @param {number} y - [description]
	 *
	 * @return {Phaser.Geom.Line} [description]
	 */
	var Offset = function (line, x, y)
	{
	    line.x1 += x;
	    line.y1 += y;
	
	    line.x2 += x;
	    line.y2 += y;
	
	    return line;
	};
	
	module.exports = Offset;


/***/ }),
/* 1242 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.PerpSlope
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 *
	 * @return {number} [description]
	 */
	var PerpSlope = function (line)
	{
	    return -((line.x2 - line.x1) / (line.y2 - line.y1));
	};
	
	module.exports = PerpSlope;


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Angle = __webpack_require__(139);
	var NormalAngle = __webpack_require__(515);
	
	/**
	* Returns the reflected angle between two lines.
	* This is the outgoing angle based on the angle of Line 1 and the normalAngle of Line 2.
	*/
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.ReflectAngle
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Line} lineA - [description]
	 * @param {Phaser.Geom.Line} lineB - [description]
	 *
	 * @return {number} [description]
	 */
	var ReflectAngle = function (lineA, lineB)
	{
	    return (2 * NormalAngle(lineB) - Math.PI - Angle(lineA));
	};
	
	module.exports = ReflectAngle;


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var RotateAroundXY = __webpack_require__(292);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.Rotate
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Line} O - [line,$return]
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 * @param {number} angle - [description]
	 *
	 * @return {Phaser.Geom.Line} [description]
	 */
	var Rotate = function (line, angle)
	{
	    var x = (line.x1 + line.x2) / 2;
	    var y = (line.y1 + line.y2) / 2;
	
	    return RotateAroundXY(line, x, y, angle);
	};
	
	module.exports = Rotate;


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var RotateAroundXY = __webpack_require__(292);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.RotateAroundPoint
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Line} O - [line,$return]
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 * @param {(Phaser.Geom.Point|object)} point - [description]
	 * @param {number} angle - [description]
	 *
	 * @return {Phaser.Geom.Line} [description]
	 */
	var RotateAroundPoint = function (line, point, angle)
	{
	    return RotateAroundXY(line, point.x, point.y, angle);
	};
	
	module.exports = RotateAroundPoint;


/***/ }),
/* 1246 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.SetToAngle
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Line} O - [line,$return]
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 * @param {number} x - [description]
	 * @param {number} y - [description]
	 * @param {number} angle - [description]
	 * @param {number} length - [description]
	 *
	 * @return {Phaser.Geom.Line} [description]
	 */
	var SetToAngle = function (line, x, y, angle, length)
	{
	    line.x1 = x;
	    line.y1 = y;
	
	    line.x2 = x + (Math.cos(angle) * length);
	    line.y2 = y + (Math.sin(angle) * length);
	
	    return line;
	};
	
	module.exports = SetToAngle;


/***/ }),
/* 1247 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.Slope
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 *
	 * @return {number} [description]
	 */
	var Slope = function (line)
	{
	    return (line.y2 - line.y1) / (line.x2 - line.x1);
	};
	
	module.exports = Slope;


/***/ }),
/* 1248 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Line.Width
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Line} line - [description]
	 *
	 * @return {number} [description]
	 */
	var Width = function (line)
	{
	    return Math.abs(line.x1 - line.x2);
	};
	
	module.exports = Width;


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Line = __webpack_require__(200);
	
	Line.Angle = __webpack_require__(139);
	Line.BresenhamPoints = __webpack_require__(513);
	Line.CenterOn = __webpack_require__(1232);
	Line.Clone = __webpack_require__(1233);
	Line.CopyFrom = __webpack_require__(1234);
	Line.Equals = __webpack_require__(1235);
	Line.GetMidPoint = __webpack_require__(1236);
	Line.GetNormal = __webpack_require__(1237);
	Line.GetPoint = __webpack_require__(514);
	Line.GetPoints = __webpack_require__(290);
	Line.Height = __webpack_require__(1238);
	Line.Length = __webpack_require__(162);
	Line.NormalAngle = __webpack_require__(515);
	Line.NormalX = __webpack_require__(1239);
	Line.NormalY = __webpack_require__(1240);
	Line.Offset = __webpack_require__(1241);
	Line.PerpSlope = __webpack_require__(1242);
	Line.Random = __webpack_require__(291);
	Line.ReflectAngle = __webpack_require__(1243);
	Line.Rotate = __webpack_require__(1244);
	Line.RotateAroundPoint = __webpack_require__(1245);
	Line.RotateAroundXY = __webpack_require__(292);
	Line.SetToAngle = __webpack_require__(1246);
	Line.Slope = __webpack_require__(1247);
	Line.Width = __webpack_require__(1248);
	
	module.exports = Line;


/***/ }),
/* 1250 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Point.Ceil
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [point,$return]
	 *
	 * @param {Phaser.Geom.Point} point - [description]
	 *
	 * @return {Phaser.Geom.Point} [description]
	 */
	var Ceil = function (point)
	{
	    return point.setTo(Math.ceil(point.x), Math.ceil(point.y));
	};
	
	module.exports = Ceil;


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Point.Clone
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Point} source - [description]
	 *
	 * @return {Phaser.Geom.Point} [description]
	 */
	var Clone = function (source)
	{
	    return new Point(source.x, source.y);
	};
	
	module.exports = Clone;


/***/ }),
/* 1252 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Point.CopyFrom
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [dest,$return]
	 *
	 * @param {Phaser.Geom.Point} source - [description]
	 * @param {Phaser.Geom.Point} dest - [description]
	 *
	 * @return {Phaser.Geom.Point} [description]
	 */
	var CopyFrom = function (source, dest)
	{
	    return dest.setTo(source.x, source.y);
	};
	
	module.exports = CopyFrom;


/***/ }),
/* 1253 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Point.Equals
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Point} point - [description]
	 * @param {Phaser.Geom.Point} toCompare - [description]
	 *
	 * @return {boolean} [description]
	 */
	var Equals = function (point, toCompare)
	{
	    return (point.x === toCompare.x && point.y === toCompare.y);
	};
	
	module.exports = Equals;


/***/ }),
/* 1254 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Point.Floor
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [point,$return]
	 *
	 * @param {Phaser.Geom.Point} point - [description]
	 *
	 * @return {Phaser.Geom.Point} [description]
	 */
	var Floor = function (point)
	{
	    return point.setTo(Math.floor(point.x), Math.floor(point.y));
	};
	
	module.exports = Floor;


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Point.GetCentroid
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Point[]} points - [description]
	 * @param {Phaser.Geom.Point} [out] - [description]
	 *
	 * @return {Phaser.Geom.Point} [description]
	 */
	var GetCentroid = function (points, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    if (!Array.isArray(points))
	    {
	        throw new Error('GetCentroid points argument must be an array');
	    }
	
	    var len = points.length;
	
	    if (len < 1)
	    {
	        throw new Error('GetCentroid points array must not be empty');
	    }
	    else if (len === 1)
	    {
	        out.x = points[0].x;
	        out.y = points[0].y;
	    }
	    else
	    {
	        for (var i = 0; i < len; i++)
	        {
	            out.x += points[i].x;
	            out.y += points[i].y;
	        }
	
	        out.x /= len;
	        out.y /= len;
	    }
	
	    return out;
	};
	
	module.exports = GetCentroid;


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Rectangle = __webpack_require__(23);
	
	/**
	 * Calculates the Axis Aligned Bounding Box (or aabb) from an array of points.
	 *
	 * @function Phaser.Geom.Point.GetRectangleFromPoints
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Point[]} points - [description]
	 * @param {Phaser.Geom.Rectangle} [out] - [description]
	 *
	 * @return {Phaser.Geom.Rectangle} [description]
	 */
	var GetRectangleFromPoints = function (points, out)
	{
	    if (out === undefined) { out = new Rectangle(); }
	
	    var xMax = Number.NEGATIVE_INFINITY;
	    var xMin = Number.POSITIVE_INFINITY;
	    var yMax = Number.NEGATIVE_INFINITY;
	    var yMin = Number.POSITIVE_INFINITY;
	
	    for (var i = 0; i < points.length; i++)
	    {
	        var point = points[i];
	
	        if (point.x > xMax)
	        {
	            xMax = point.x;
	        }
	
	        if (point.x < xMin)
	        {
	            xMin = point.x;
	        }
	
	        if (point.y > yMax)
	        {
	            yMax = point.y;
	        }
	
	        if (point.y < yMin)
	        {
	            yMin = point.y;
	        }
	    }
	
	    out.x = xMin;
	    out.y = yMin;
	    out.width = xMax - xMin;
	    out.height = yMax - yMin;
	
	    return out;
	};
	
	module.exports = GetRectangleFromPoints;


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Point.Interpolate
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Point} pointA - [description]
	 * @param {Phaser.Geom.Point} pointB - [description]
	 * @param {float} [t=0] - [description]
	 * @param {(Phaser.Geom.Point|object)} [out] - [description]
	 *
	 * @return {(Phaser.Geom.Point|object)} [description]
	 */
	var Interpolate = function (pointA, pointB, t, out)
	{
	    if (t === undefined) { t = 0; }
	    if (out === undefined) { out = new Point(); }
	
	    out.x = pointA.x + ((pointB.x - pointA.x) * t);
	    out.y = pointA.y + ((pointB.y - pointA.y) * t);
	
	    return out;
	};
	
	module.exports = Interpolate;


/***/ }),
/* 1258 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Point.Invert
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [point,$return]
	 *
	 * @param {Phaser.Geom.Point} point - [description]
	 *
	 * @return {Phaser.Geom.Point} [description]
	 */
	var Invert = function (point)
	{
	    return point.setTo(point.y, point.x);
	};
	
	module.exports = Invert;


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Point.Negative
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Point} point - [description]
	 * @param {Phaser.Geom.Point} [out] - [description]
	 *
	 * @return {Phaser.Geom.Point} [description]
	 */
	var Negative = function (point, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    return out.setTo(-point.x, -point.y);
	};
	
	module.exports = Negative;


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	var GetMagnitudeSq = __webpack_require__(517);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Point.Project
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Point} pointA - [description]
	 * @param {Phaser.Geom.Point} pointB - [description]
	 * @param {Phaser.Geom.Point} [out] - [description]
	 *
	 * @return {Phaser.Geom.Point} [description]
	 */
	var Project = function (pointA, pointB, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    var dot = ((pointA.x * pointB.x) + (pointA.y * pointB.y));
	    var amt = dot / GetMagnitudeSq(pointB);
	
	    if (amt !== 0)
	    {
	        out.x = amt * pointB.x;
	        out.y = amt * pointB.y;
	    }
	
	    return out;
	};
	
	module.exports = Project;


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Point.ProjectUnit
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Point} pointA - [description]
	 * @param {Phaser.Geom.Point} pointB - [description]
	 * @param {Phaser.Geom.Point} [out] - [description]
	 *
	 * @return {Phaser.Geom.Point} [description]
	 */
	var ProjectUnit = function (pointA, pointB, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    var amt = ((pointA.x * pointB.x) + (pointA.y * pointB.y));
	
	    if (amt !== 0)
	    {
	        out.x = amt * pointB.x;
	        out.y = amt * pointB.y;
	    }
	
	    return out;
	};
	
	module.exports = ProjectUnit;


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetMagnitude = __webpack_require__(516);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Point.SetMagnitude
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [point,$return]
	 *
	 * @param {Phaser.Geom.Point} point - [description]
	 * @param {number} magnitude - [description]
	 *
	 * @return {Phaser.Geom.Point} [description]
	 */
	var SetMagnitude = function (point, magnitude)
	{
	    if (point.x !== 0 || point.y !== 0)
	    {
	        var m = GetMagnitude(point);
	
	        point.x /= m;
	        point.y /= m;
	    }
	
	    point.x *= magnitude;
	    point.y *= magnitude;
	
	    return point;
	};
	
	module.exports = SetMagnitude;


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	
	Point.Ceil = __webpack_require__(1250);
	Point.Clone = __webpack_require__(1251);
	Point.CopyFrom = __webpack_require__(1252);
	Point.Equals = __webpack_require__(1253);
	Point.Floor = __webpack_require__(1254);
	Point.GetCentroid = __webpack_require__(1255);
	Point.GetMagnitude = __webpack_require__(516);
	Point.GetMagnitudeSq = __webpack_require__(517);
	Point.GetRectangleFromPoints = __webpack_require__(1256);
	Point.Interpolate = __webpack_require__(1257);
	Point.Invert = __webpack_require__(1258);
	Point.Negative = __webpack_require__(1259);
	Point.Project = __webpack_require__(1260);
	Point.ProjectUnit = __webpack_require__(1261);
	Point.SetMagnitude = __webpack_require__(1262);
	
	module.exports = Point;


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Polygon = __webpack_require__(519);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Polygon.Clone
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Polygon} polygon - [description]
	 *
	 * @return {Phaser.Geom.Polygon} [description]
	 */
	var Clone = function (polygon)
	{
	    return new Polygon(polygon.points);
	};
	
	module.exports = Clone;


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Contains = __webpack_require__(293);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Polygon.ContainsPoint
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Polygon} polygon - [description]
	 * @param {Phaser.Geom.Point} point - [description]
	 *
	 * @return {boolean} [description]
	 */
	var ContainsPoint = function (polygon, point)
	{
	    return Contains(polygon, point.x, point.y);
	};
	
	module.exports = ContainsPoint;


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Rectangle = __webpack_require__(23);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Polygon.GetAABB
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Rectangle} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Polygon} polygon - [description]
	 * @param {(Phaser.Geom.Rectangle|object)} [out] - [description]
	 *
	 * @return {(Phaser.Geom.Rectangle|object)} [description]
	 */
	var GetAABB = function (polygon, out)
	{
	    if (out === undefined) { out = new Rectangle(); }
	
	    var minX = Infinity;
	    var minY = Infinity;
	    var maxX = -minX;
	    var maxY = -minY;
	    var p;
	
	    for (var i = 0; i < polygon.points.length; i++)
	    {
	        p = polygon.points[i];
	
	        minX = Math.min(minX, p.x);
	        minY = Math.min(minY, p.y);
	        maxX = Math.max(maxX, p.x);
	        maxY = Math.max(maxY, p.y);
	    }
	
	    out.x = minX;
	    out.y = minY;
	    out.width = maxX - minX;
	    out.height = maxY - minY;
	
	    return out;
	};
	
	module.exports = GetAABB;


/***/ }),
/* 1267 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	// Export the points as an array of flat numbers, following the sequence [ x,y, x,y, x,y ]
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Polygon.GetNumberArray
	 * @since 3.0.0
	 *
	 * @generic {number[]} O - [output,$return]
	 *
	 * @param {Phaser.Geom.Polygon} polygon - [description]
	 * @param {(array|number[])} [output] - [description]
	 *
	 * @return {(array|number[])} [description]
	 */
	var GetNumberArray = function (polygon, output)
	{
	    if (output === undefined) { output = []; }
	
	    for (var i = 0; i < polygon.points.length; i++)
	    {
	        output.push(polygon.points[i].x);
	        output.push(polygon.points[i].y);
	    }
	
	    return output;
	};
	
	module.exports = GetNumberArray;


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Polygon = __webpack_require__(519);
	
	Polygon.Clone = __webpack_require__(1264);
	Polygon.Contains = __webpack_require__(293);
	Polygon.ContainsPoint = __webpack_require__(1265);
	Polygon.GetAABB = __webpack_require__(1266);
	Polygon.GetNumberArray = __webpack_require__(1267);
	
	module.exports = Polygon;


/***/ }),
/* 1269 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.Area
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 *
	 * @return {number} [description]
	 */
	var Area = function (rect)
	{
	    return rect.width * rect.height;
	};
	
	module.exports = Area;


/***/ }),
/* 1270 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.Ceil
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 *
	 * @return {Phaser.Geom.Rectangle} [description]
	 */
	var Ceil = function (rect)
	{
	    rect.x = Math.ceil(rect.x);
	    rect.y = Math.ceil(rect.y);
	
	    return rect;
	};
	
	module.exports = Ceil;


/***/ }),
/* 1271 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.CeilAll
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 *
	 * @return {Phaser.Geom.Rectangle} [description]
	 */
	var CeilAll = function (rect)
	{
	    rect.x = Math.ceil(rect.x);
	    rect.y = Math.ceil(rect.y);
	    rect.width = Math.ceil(rect.width);
	    rect.height = Math.ceil(rect.height);
	
	    return rect;
	};
	
	module.exports = CeilAll;


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Rectangle = __webpack_require__(23);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.Clone
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Rectangle} source - [description]
	 *
	 * @return {Phaser.Geom.Rectangle} [description]
	 */
	var Clone = function (source)
	{
	    return new Rectangle(source.x, source.y, source.width, source.height);
	};
	
	module.exports = Clone;


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Contains = __webpack_require__(84);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.ContainsPoint
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 * @param {Phaser.Geom.Point} point - [description]
	 *
	 * @return {boolean} [description]
	 */
	var ContainsPoint = function (rect, point)
	{
	    return Contains(rect, point.x, point.y);
	};
	
	module.exports = ContainsPoint;


/***/ }),
/* 1274 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  Checks if rectB is fully contained within rectA
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.ContainsRect
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Rectangle} rectA - [description]
	 * @param {Phaser.Geom.Rectangle} rectB - [description]
	 *
	 * @return {boolean} [description]
	 */
	var ContainsRect = function (rectA, rectB)
	{
	    //  Volume check (if rectB volume > rectA then rectA cannot contain it)
	    if ((rectB.width * rectB.height) > (rectA.width * rectA.height))
	    {
	        return false;
	    }
	
	    return (
	        (rectB.x > rectA.x && rectB.x < rectA.right) &&
	        (rectB.right > rectA.x && rectB.right < rectA.right) &&
	        (rectB.y > rectA.y && rectB.y < rectA.bottom) &&
	        (rectB.bottom > rectA.y && rectB.bottom < rectA.bottom)
	    );
	};
	
	module.exports = ContainsRect;


/***/ }),
/* 1275 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.CopyFrom
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Rectangle} O - [dest,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} source - [description]
	 * @param {Phaser.Geom.Rectangle} dest - [description]
	 *
	 * @return {Phaser.Geom.Rectangle} [description]
	 */
	var CopyFrom = function (source, dest)
	{
	    return dest.setTo(source.x, source.y, source.width, source.height);
	};
	
	module.exports = CopyFrom;


/***/ }),
/* 1276 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.Equals
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 * @param {Phaser.Geom.Rectangle} toCompare - [description]
	 *
	 * @return {boolean} [description]
	 */
	var Equals = function (rect, toCompare)
	{
	    return (
	        rect.x === toCompare.x &&
	        rect.y === toCompare.y &&
	        rect.width === toCompare.width &&
	        rect.height === toCompare.height
	    );
	};
	
	module.exports = Equals;


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetAspectRatio = __webpack_require__(295);
	
	//  Fits the target rectangle into the source rectangle.
	//  Preserves aspect ratio.
	//  Scales and centers the target rectangle to the source rectangle
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.FitInside
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Rectangle} O - [target,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} target - [description]
	 * @param {Phaser.Geom.Rectangle} source - [description]
	 *
	 * @return {Phaser.Geom.Rectangle} [description]
	 */
	var FitInside = function (target, source)
	{
	    var ratio = GetAspectRatio(target);
	
	    if (ratio < GetAspectRatio(source))
	    {
	        //  Taller than Wide
	        target.setSize(source.height * ratio, source.height);
	    }
	    else
	    {
	        //  Wider than Tall
	        target.setSize(source.width, source.width / ratio);
	    }
	
	    return target.setPosition(
	        source.centerX - (target.width / 2),
	        source.centerY - (target.height / 2)
	    );
	};
	
	module.exports = FitInside;


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetAspectRatio = __webpack_require__(295);
	
	//  Fits the target rectangle around the source rectangle.
	//  Preserves aspect ration.
	//  Scales and centers the target rectangle to the source rectangle
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.FitOutside
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Rectangle} O - [target,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} target - [description]
	 * @param {Phaser.Geom.Rectangle} source - [description]
	 *
	 * @return {Phaser.Geom.Rectangle} [description]
	 */
	var FitOutside = function (target, source)
	{
	    var ratio = GetAspectRatio(target);
	
	    if (ratio > GetAspectRatio(source))
	    {
	        //  Wider than Tall
	        target.setSize(source.height * ratio, source.height);
	    }
	    else
	    {
	        //  Taller than Wide
	        target.setSize(source.width, source.width / ratio);
	    }
	
	    return target.setPosition(
	        source.centerX - target.width / 2,
	        source.centerY - target.height / 2
	    );
	};
	
	module.exports = FitOutside;


/***/ }),
/* 1279 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.Floor
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 *
	 * @return {Phaser.Geom.Rectangle} [description]
	 */
	var Floor = function (rect)
	{
	    rect.x = Math.floor(rect.x);
	    rect.y = Math.floor(rect.y);
	
	    return rect;
	};
	
	module.exports = Floor;


/***/ }),
/* 1280 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.FloorAll
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 *
	 * @return {Phaser.Geom.Rectangle} [description]
	 */
	var FloorAll = function (rect)
	{
	    rect.x = Math.floor(rect.x);
	    rect.y = Math.floor(rect.y);
	    rect.width = Math.floor(rect.width);
	    rect.height = Math.floor(rect.height);
	
	    return rect;
	};
	
	module.exports = FloorAll;


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	
	//  The center of the Rectangle object, expressed as a Point object
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.GetCenter
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 * @param {(Phaser.Geom.Point|object)} [out] - [description]
	 *
	 * @return {(Phaser.Geom.Point|object)} [description]
	 */
	var GetCenter = function (rect, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    out.x = rect.centerX;
	    out.y = rect.centerY;
	
	    return out;
	};
	
	module.exports = GetCenter;


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	
	//  The size of the Rectangle object, expressed as a Point object
	//  with the values of the width and height properties.
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.GetSize
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 * @param {(Phaser.Geom.Point|object)} [out] - [description]
	 *
	 * @return {(Phaser.Geom.Point|object)} [description]
	 */
	var GetSize = function (rect, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    out.x = rect.width;
	    out.y = rect.height;
	
	    return out;
	};
	
	module.exports = GetSize;


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CenterOn = __webpack_require__(520);
	
	//  Increases the size of the Rectangle object by the specified amounts.
	//  The center point of the Rectangle object stays the same, and its size increases
	//  to the left and right by the x value, and to the top and the bottom by the y value.
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.Inflate
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 * @param {number} x - [description]
	 * @param {number} y - [description]
	 *
	 * @return {Phaser.Geom.Rectangle} [description]
	 */
	var Inflate = function (rect, x, y)
	{
	    var cx = rect.centerX;
	    var cy = rect.centerY;
	
	    rect.setSize(rect.width + (x * 2), rect.height + (y * 2));
	
	    return CenterOn(rect, cx, cy);
	};
	
	module.exports = Inflate;


/***/ }),
/* 1284 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  Merges the target Rectangle with a list of points.
	//  The points is an array of objects with public x/y properties.
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.MergePoints
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Rectangle} O - [target,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} target - [description]
	 * @param {Phaser.Geom.Point[]} points - [description]
	 *
	 * @return {Phaser.Geom.Rectangle} [description]
	 */
	var MergePoints = function (target, points)
	{
	    var minX = target.x;
	    var maxX = target.right;
	    var minY = target.y;
	    var maxY = target.bottom;
	
	    for (var i = 0; i < points.length; i++)
	    {
	        minX = Math.min(minX, points[i].x);
	        maxX = Math.max(maxX, points[i].x);
	        minY = Math.min(minY, points[i].y);
	        maxY = Math.max(maxY, points[i].y);
	    }
	
	    target.x = minX;
	    target.y = minY;
	    target.width = maxX - minX;
	    target.height = maxY - minY;
	
	    return target;
	};
	
	module.exports = MergePoints;


/***/ }),
/* 1285 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  Merges source rectangle into target rectangle and returns target
	//  Neither rect should have negative widths or heights
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.MergeRect
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Rectangle} O - [target,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} target - [description]
	 * @param {Phaser.Geom.Rectangle} source - [description]
	 *
	 * @return {Phaser.Geom.Rectangle} [description]
	 */
	var MergeRect = function (target, source)
	{
	    var minX = Math.min(target.x, source.x);
	    var maxX = Math.max(target.right, source.right);
	
	    target.x = minX;
	    target.width = maxX - minX;
	
	    var minY = Math.min(target.y, source.y);
	    var maxY = Math.max(target.bottom, source.bottom);
	
	    target.y = minY;
	    target.height = maxY - minY;
	
	    return target;
	};
	
	module.exports = MergeRect;


/***/ }),
/* 1286 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.MergeXY
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Rectangle} O - [target,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} target - [description]
	 * @param {number} x - [description]
	 * @param {number} y - [description]
	 *
	 * @return {Phaser.Geom.Rectangle} [description]
	 */
	var MergeXY = function (target, x, y)
	{
	    var minX = Math.min(target.x, x);
	    var maxX = Math.max(target.right, x);
	
	    target.x = minX;
	    target.width = maxX - minX;
	
	    var minY = Math.min(target.y, y);
	    var maxY = Math.max(target.bottom, y);
	
	    target.y = minY;
	    target.height = maxY - minY;
	
	    return target;
	};
	
	module.exports = MergeXY;


/***/ }),
/* 1287 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.Offset
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 * @param {number} x - [description]
	 * @param {number} y - [description]
	 *
	 * @return {Phaser.Geom.Rectangle} [description]
	 */
	var Offset = function (rect, x, y)
	{
	    rect.x += x;
	    rect.y += y;
	
	    return rect;
	};
	
	module.exports = Offset;


/***/ }),
/* 1288 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.OffsetPoint
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 * @param {Phaser.Geom.Point} point - [description]
	 *
	 * @return {Phaser.Geom.Rectangle} [description]
	 */
	var OffsetPoint = function (rect, point)
	{
	    rect.x += point.x;
	    rect.y += point.y;
	
	    return rect;
	};
	
	module.exports = OffsetPoint;


/***/ }),
/* 1289 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.Overlaps
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Rectangle} rectA - [description]
	 * @param {Phaser.Geom.Rectangle} rectB - [description]
	 *
	 * @return {boolean} [description]
	 */
	var Overlaps = function (rectA, rectB)
	{
	    return (
	        rectA.x < rectB.right &&
	        rectA.right > rectB.x &&
	        rectA.y < rectB.bottom &&
	        rectA.bottom > rectB.y
	    );
	};
	
	module.exports = Overlaps;


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Point = __webpack_require__(12);
	var DegToRad = __webpack_require__(97);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.PerimeterPoint
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Point} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} rectangle - [description]
	 * @param {integer} angle - [description]
	 * @param {Phaser.Geom.Point} [out] - [description]
	 *
	 * @return {Phaser.Geom.Point} [description]
	 */
	var PerimeterPoint = function (rectangle, angle, out)
	{
	    if (out === undefined) { out = new Point(); }
	
	    angle = DegToRad(angle);
	
	    var s = Math.sin(angle);
	    var c = Math.cos(angle);
	
	    var dx = (c > 0) ? rectangle.width / 2 : rectangle.width / -2;
	    var dy = (s > 0) ? rectangle.height / 2 : rectangle.height / -2;
	
	    if (Math.abs(dx * s) < Math.abs(dy * c))
	    {
	        dy = (dx * s) / c;
	    }
	    else
	    {
	        dx = (dy * c) / s;
	    }
	
	    out.x = dx + rectangle.centerX;
	    out.y = dy + rectangle.centerY;
	
	    return out;
	};
	
	module.exports = PerimeterPoint;


/***/ }),
/* 1291 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	// Scales the width and height of this Rectangle by the given amounts.
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Rectangle.Scale
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Rectangle} O - [rect,$return]
	 *
	 * @param {Phaser.Geom.Rectangle} rect - [description]
	 * @param {number} x - [description]
	 * @param {number} y - [description]
	 *
	 * @return {Phaser.Geom.Rectangle} [description]
	 */
	var Scale = function (rect, x, y)
	{
	    if (y === undefined) { y = x; }
	
	    rect.width *= x;
	    rect.height *= y;
	
	    return rect;
	};
	
	module.exports = Scale;


/***/ }),
/* 1292 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	// The 2D area of a triangle. The area value is always non-negative.
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.Area
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 *
	 * @return {number} [description]
	 */
	var Area = function (triangle)
	{
	    var x1 = triangle.x1;
	    var y1 = triangle.y1;
	
	    var x2 = triangle.x2;
	    var y2 = triangle.y2;
	
	    var x3 = triangle.x3;
	    var y3 = triangle.y3;
	
	    return Math.abs(((x3 - x1) * (y2 - y1) - (x2 - x1) * (y3 - y1)) / 2);
	};
	
	module.exports = Area;


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Triangle = __webpack_require__(141);
	
	// Builds an equilateral triangle.
	// In the equilateral triangle, all the sides are the same length (congruent)
	// and all the angles are the same size (congruent).
	
	//  The x/y specifies the top-middle of the triangle (x1/y1) and length
	//  is the length of each side
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.BuildEquilateral
	 * @since 3.0.0
	 *
	 * @param {number} x - [description]
	 * @param {number} y - [description]
	 * @param {number} length - [description]
	 *
	 * @return {Phaser.Geom.Triangle} [description]
	 */
	var BuildEquilateral = function (x, y, length)
	{
	    var height = length * (Math.sqrt(3) / 2);
	
	    var x1 = x;
	    var y1 = y;
	
	    var x2 = x + (length / 2);
	    var y2 = y + height;
	
	    var x3 = x - (length / 2);
	    var y3 = y + height;
	
	    return new Triangle(x1, y1, x2, y2, x3, y3);
	};
	
	module.exports = BuildEquilateral;


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var EarCut = __webpack_require__(518);
	var Triangle = __webpack_require__(141);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.BuildFromPolygon
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Triangle[]} O - [out,$return]
	 *
	 * @param {array} data - A flat array of vertice coordinates like [x0,y0, x1,y1, x2,y2, ...]
	 * @param {array} [holes=null] - An array of hole indices if any (e.g. [5, 8] for a 12-vertice input would mean one hole with vertices 5–7 and another with 8–11).
	 * @param {float} [scaleX=1] - [description]
	 * @param {float} [scaleY=1] - [description]
	 * @param {(array|Phaser.Geom.Triangle[])} [out] - [description]
	 *
	 * @return {(array|Phaser.Geom.Triangle[])} [description]
	 */
	var BuildFromPolygon = function (data, holes, scaleX, scaleY, out)
	{
	    if (holes === undefined) { holes = null; }
	    if (scaleX === undefined) { scaleX = 1; }
	    if (scaleY === undefined) { scaleY = 1; }
	    if (out === undefined) { out = []; }
	
	    var tris = EarCut(data, holes);
	
	    var a;
	    var b;
	    var c;
	
	    var x1;
	    var y1;
	
	    var x2;
	    var y2;
	
	    var x3;
	    var y3;
	
	    for (var i = 0; i < tris.length; i += 3)
	    {
	        a = tris[i];
	        b = tris[i + 1];
	        c = tris[i + 2];
	
	        x1 = data[a * 2] * scaleX;
	        y1 = data[(a * 2) + 1] * scaleY;
	
	        x2 = data[b * 2] * scaleX;
	        y2 = data[(b * 2) + 1] * scaleY;
	
	        x3 = data[c * 2] * scaleX;
	        y3 = data[(c * 2) + 1] * scaleY;
	
	        out.push(new Triangle(x1, y1, x2, y2, x3, y3));
	    }
	
	    return out;
	};
	
	module.exports = BuildFromPolygon;


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Triangle = __webpack_require__(141);
	
	//  Builds a right triangle, with one 90 degree angle and two acute angles
	//  The x/y is the coordinate of the 90 degree angle (and will map to x1/y1 in the resulting Triangle)
	//  w/h can be positive or negative and represent the length of each side
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.BuildRight
	 * @since 3.0.0
	 *
	 * @param {number} x - [description]
	 * @param {number} y - [description]
	 * @param {number} width - [description]
	 * @param {number} height - [description]
	 *
	 * @return {Phaser.Geom.Triangle} [description]
	 */
	var BuildRight = function (x, y, width, height)
	{
	    if (height === undefined) { height = width; }
	
	    //  90 degree angle
	    var x1 = x;
	    var y1 = y;
	
	    var x2 = x;
	    var y2 = y - height;
	
	    var x3 = x + width;
	    var y3 = y;
	
	    return new Triangle(x1, y1, x2, y2, x3, y3);
	};
	
	module.exports = BuildRight;


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Centroid = __webpack_require__(526);
	var Offset = __webpack_require__(531);
	
	/**
	 * @callback CenterFunction
	 *
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 *
	 * @return {Phaser.Math.Vector2} [description]
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.CenterOn
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Triangle} O - [triangle,$return]
	 *
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 * @param {number} x - [description]
	 * @param {number} y - [description]
	 * @param {CenterFunction} [centerFunc] - [description]
	 *
	 * @return {Phaser.Geom.Triangle} [description]
	 */
	var CenterOn = function (triangle, x, y, centerFunc)
	{
	    if (centerFunc === undefined) { centerFunc = Centroid; }
	
	    //  Get the center of the triangle
	    var center = centerFunc(triangle);
	
	    //  Difference
	    var diffX = x - center.x;
	    var diffY = y - center.y;
	
	    return Offset(triangle, diffX, diffY);
	};
	
	module.exports = CenterOn;


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Vector2 = __webpack_require__(9);
	
	//  Adapted from http://bjornharrtell.github.io/jsts/doc/api/jsts_geom_Triangle.js.html
	
	/**
	 * Computes the determinant of a 2x2 matrix. Uses standard double-precision arithmetic, so is susceptible to round-off error.
	 *
	 * @function det
	 * @private
	 * @since 3.0.0
	 *
	 * @param {number} m00 - The [0,0] entry of the matrix.
	 * @param {number} m01 - The [0,1] entry of the matrix.
	 * @param {number} m10 - The [1,0] entry of the matrix.
	 * @param {number} m11 - The [1,1] entry of the matrix.
	 *
	 * @return {number} the determinant.
	 */
	function det (m00, m01, m10, m11)
	{
	    return (m00 * m11) - (m01 * m10);
	}
	
	/**
	 * Computes the circumcentre of a triangle. The circumcentre is the centre of
	 * the circumcircle, the smallest circle which encloses the triangle. It is also
	 * the common intersection point of the perpendicular bisectors of the sides of
	 * the triangle, and is the only point which has equal distance to all three
	 * vertices of the triangle.
	 *
	 * @function Phaser.Geom.Triangle.CircumCenter
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Math.Vector2} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 * @param {Phaser.Math.Vector2} [out] - [description]
	 *
	 * @return {Phaser.Math.Vector2} [description]
	 */
	var CircumCenter = function (triangle, out)
	{
	    if (out === undefined) { out = new Vector2(); }
	
	    var cx = triangle.x3;
	    var cy = triangle.y3;
	
	    var ax = triangle.x1 - cx;
	    var ay = triangle.y1 - cy;
	
	    var bx = triangle.x2 - cx;
	    var by = triangle.y2 - cy;
	
	    var denom = 2 * det(ax, ay, bx, by);
	    var numx = det(ay, ax * ax + ay * ay, by, bx * bx + by * by);
	    var numy = det(ax, ax * ax + ay * ay, bx, bx * bx + by * by);
	
	    out.x = cx - numx / denom;
	    out.y = cy + numy / denom;
	
	    return out;
	};
	
	module.exports = CircumCenter;


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Circle = __webpack_require__(160);
	
	//  Adapted from https://gist.github.com/mutoo/5617691
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.CircumCircle
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Circle} O - [out,$return]
	 *
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 * @param {Phaser.Geom.Circle} [out] - [description]
	 *
	 * @return {Phaser.Geom.Circle} [description]
	 */
	var CircumCircle = function (triangle, out)
	{
	    if (out === undefined) { out = new Circle(); }
	
	    //  A
	    var x1 = triangle.x1;
	    var y1 = triangle.y1;
	
	    //  B
	    var x2 = triangle.x2;
	    var y2 = triangle.y2;
	
	    //  C
	    var x3 = triangle.x3;
	    var y3 = triangle.y3;
	
	    var A = x2 - x1;
	    var B = y2 - y1;
	    var C = x3 - x1;
	    var D = y3 - y1;
	    var E = A * (x1 + x2) + B * (y1 + y2);
	    var F = C * (x1 + x3) + D * (y1 + y3);
	    var G = 2 * (A * (y3 - y2) - B * (x3 - x2));
	
	    var dx;
	    var dy;
	
	    //  If the points of the triangle are collinear, then just find the
	    //  extremes and use the midpoint as the center of the circumcircle.
	
	    if (Math.abs(G) < 0.000001)
	    {
	        var minX = Math.min(x1, x2, x3);
	        var minY = Math.min(y1, y2, y3);
	        dx = (Math.max(x1, x2, x3) - minX) * 0.5;
	        dy = (Math.max(y1, y2, y3) - minY) * 0.5;
	
	        out.x = minX + dx;
	        out.y = minY + dy;
	        out.radius = Math.sqrt(dx * dx + dy * dy);
	    }
	    else
	    {
	        out.x = (D * E - B * F) / G;
	        out.y = (A * F - C * E) / G;
	        dx = out.x - x1;
	        dy = out.y - y1;
	        out.radius = Math.sqrt(dx * dx + dy * dy);
	    }
	
	    return out;
	};
	
	module.exports = CircumCircle;


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Triangle = __webpack_require__(141);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.Clone
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Triangle} source - [description]
	 *
	 * @return {Phaser.Geom.Triangle} [description]
	 */
	var Clone = function (source)
	{
	    return new Triangle(source.x1, source.y1, source.x2, source.y2, source.x3, source.y3);
	};
	
	module.exports = Clone;


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Contains = __webpack_require__(140);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.ContainsPoint
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 * @param {Phaser.Geom.Point} point - [description]
	 *
	 * @return {boolean} [description]
	 */
	var ContainsPoint = function (triangle, point)
	{
	    return Contains(triangle, point.x, point.y);
	};
	
	module.exports = ContainsPoint;


/***/ }),
/* 1301 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.CopyFrom
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Triangle} O - [dest,$return]
	 *
	 * @param {Phaser.Geom.Triangle} source - [description]
	 * @param {Phaser.Geom.Triangle} dest - [description]
	 *
	 * @return {Phaser.Geom.Triangle} [description]
	 */
	var CopyFrom = function (source, dest)
	{
	    return dest.setTo(source.x1, source.y1, source.x2, source.y2, source.x3, source.y3);
	};
	
	module.exports = CopyFrom;


/***/ }),
/* 1302 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.Equals
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 * @param {Phaser.Geom.Triangle} toCompare - [description]
	 *
	 * @return {boolean} [description]
	 */
	var Equals = function (triangle, toCompare)
	{
	    return (
	        triangle.x1 === toCompare.x1 &&
	        triangle.y1 === toCompare.y1 &&
	        triangle.x2 === toCompare.x2 &&
	        triangle.y2 === toCompare.y2 &&
	        triangle.x3 === toCompare.x3 &&
	        triangle.y3 === toCompare.y3
	    );
	};
	
	module.exports = Equals;


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Length = __webpack_require__(162);
	
	// The 2D area of a triangle. The area value is always non-negative.
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.Perimeter
	 * @since 3.0.0
	 *
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 *
	 * @return {number} [description]
	 */
	var Perimeter = function (triangle)
	{
	    var line1 = triangle.getLineA();
	    var line2 = triangle.getLineB();
	    var line3 = triangle.getLineC();
	
	    return (Length(line1) + Length(line2) + Length(line3));
	};
	
	module.exports = Perimeter;


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var RotateAroundXY = __webpack_require__(300);
	var InCenter = __webpack_require__(530);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.Rotate
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Triangle} O - [triangle,$return]
	 *
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 * @param {number} angle - [description]
	 *
	 * @return {Phaser.Geom.Triangle} [description]
	 */
	var Rotate = function (triangle, angle)
	{
	    var point = InCenter(triangle);
	
	    return RotateAroundXY(triangle, point.x, point.y, angle);
	};
	
	module.exports = Rotate;


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var RotateAroundXY = __webpack_require__(300);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Geom.Triangle.RotateAroundPoint
	 * @since 3.0.0
	 *
	 * @generic {Phaser.Geom.Triangle} O - [triangle,$return]
	 *
	 * @param {Phaser.Geom.Triangle} triangle - [description]
	 * @param {Phaser.Geom.Point} point - [description]
	 * @param {number} angle - [description]
	 *
	 * @return {Phaser.Geom.Triangle} [description]
	 */
	var RotateAroundPoint = function (triangle, point, angle)
	{
	    return RotateAroundXY(triangle, point.x, point.y, angle);
	};
	
	module.exports = RotateAroundPoint;


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Triangle = __webpack_require__(141);
	
	Triangle.Area = __webpack_require__(1292);
	Triangle.BuildEquilateral = __webpack_require__(1293);
	Triangle.BuildFromPolygon = __webpack_require__(1294);
	Triangle.BuildRight = __webpack_require__(1295);
	Triangle.CenterOn = __webpack_require__(1296);
	Triangle.Centroid = __webpack_require__(526);
	Triangle.CircumCenter = __webpack_require__(1297);
	Triangle.CircumCircle = __webpack_require__(1298);
	Triangle.Clone = __webpack_require__(1299);
	Triangle.Contains = __webpack_require__(140);
	Triangle.ContainsArray = __webpack_require__(298);
	Triangle.ContainsPoint = __webpack_require__(1300);
	Triangle.CopyFrom = __webpack_require__(1301);
	Triangle.Decompose = __webpack_require__(527);
	Triangle.Equals = __webpack_require__(1302);
	Triangle.GetPoint = __webpack_require__(528);
	Triangle.GetPoints = __webpack_require__(529);
	Triangle.InCenter = __webpack_require__(530);
	Triangle.Perimeter = __webpack_require__(1303);
	Triangle.Offset = __webpack_require__(531);
	Triangle.Random = __webpack_require__(299);
	Triangle.Rotate = __webpack_require__(1304);
	Triangle.RotateAroundPoint = __webpack_require__(1305);
	Triangle.RotateAroundXY = __webpack_require__(300);
	
	module.exports = Triangle;


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Circle = __webpack_require__(160);
	var CircleContains = __webpack_require__(83);
	var Class = __webpack_require__(1);
	var DistanceBetween = __webpack_require__(116);
	var Ellipse = __webpack_require__(288);
	var EllipseContains = __webpack_require__(161);
	var EventEmitter = __webpack_require__(22);
	var CreateInteractiveObject = __webpack_require__(532);
	var PluginCache = __webpack_require__(29);
	var Rectangle = __webpack_require__(23);
	var RectangleContains = __webpack_require__(84);
	var Triangle = __webpack_require__(141);
	var TriangleContains = __webpack_require__(140);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class InputPlugin
	 * @extends Phaser.Events.EventEmitter
	 * @memberOf Phaser.Input
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - The Scene that owns this plugin.
	 */
	var InputPlugin = new Class({
	
	    Extends: EventEmitter,
	
	    initialize:
	
	    function InputPlugin (scene)
	    {
	        EventEmitter.call(this);
	
	        /**
	         * The Scene that owns this plugin.
	         *
	         * @name Phaser.Input.InputPlugin#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputPlugin#systems
	         * @type {Phaser.Scenes.Systems}
	         * @since 3.0.0
	         */
	        this.systems = scene.sys;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputPlugin#settings
	         * @type {Phaser.Scenes.Settings.Object}
	         * @since 3.5.0
	         */
	        this.settings = scene.sys.settings;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputPlugin#manager
	         * @type {Phaser.Input.InputManager}
	         * @since 3.0.0
	         */
	        this.manager = scene.sys.game.input;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputPlugin#enabled
	         * @type {boolean}
	         * @default true
	         * @since 3.5.0
	         */
	        this.enabled = true;
	
	        /**
	         * A reference to this.scene.sys.displayList (set in boot)
	         *
	         * @name Phaser.Input.InputPlugin#displayList
	         * @type {Phaser.GameObjects.DisplayList}
	         * @since 3.0.0
	         */
	        this.displayList;
	
	        /**
	         * A reference to the this.scene.sys.cameras (set in boot)
	         *
	         * @name Phaser.Input.InputPlugin#cameras
	         * @type {null}
	         * @since 3.0.0
	         */
	        this.cameras;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputPlugin#keyboard
	         * @type {Phaser.Input.Keyboard.KeyboardManager}
	         * @since 3.0.0
	         */
	        this.keyboard = this.manager.keyboard;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputPlugin#mouse
	         * @type {Phaser.Input.Mouse.MouseManager}
	         * @since 3.0.0
	         */
	        this.mouse = this.manager.mouse;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputPlugin#gamepad
	         * @type {Phaser.Input.Gamepad.GamepadManager}
	         * @since 3.0.0
	         */
	        this.gamepad = this.manager.gamepad;
	
	        /**
	         * Only fire callbacks and events on the top-most Game Object in the display list (emulating DOM behavior)
	         * and ignore any GOs below it, or call them all?
	         *
	         * @name Phaser.Input.InputPlugin#topOnly
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.topOnly = true;
	
	        /**
	         * How often should the pointer input be checked?
	         * Time given in ms
	         * Pointer will *always* be checked if it has been moved by the user.
	         * This controls how often it will be polled if it hasn't been moved.
	         * Set to 0 to poll constantly. Set to -1 to only poll on user movement.
	         *
	         * @name Phaser.Input.InputPlugin#pollRate
	         * @type {integer}
	         * @default -1
	         * @since 3.0.0
	         */
	        this.pollRate = -1;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputPlugin#_pollTimer
	         * @type {number}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._pollTimer = 0;
	
	        /**
	         * The distance, in pixels, the pointer has to move while being held down, before it thinks it is being dragged.
	         *
	         * @name Phaser.Input.InputPlugin#dragDistanceThreshold
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.dragDistanceThreshold = 0;
	
	        /**
	         * The amount of time, in ms, the pointer has to be held down before it thinks it is dragging.
	         *
	         * @name Phaser.Input.InputPlugin#dragTimeThreshold
	         * @type {number}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.dragTimeThreshold = 0;
	
	        /**
	         * Used to temporarily store the results of the Hit Test
	         *
	         * @name Phaser.Input.InputPlugin#_temp
	         * @type {array}
	         * @private
	         * @default []
	         * @since 3.0.0
	         */
	        this._temp = [];
	
	        /**
	         * Used to temporarily store the results of the Hit Test dropZones
	         *
	         * @name Phaser.Input.InputPlugin#_tempZones
	         * @type {array}
	         * @private
	         * @default []
	         * @since 3.0.0
	         */
	        this._tempZones = [];
	
	        /**
	         * A list of all Game Objects that have been set to be interactive.
	         *
	         * @name Phaser.Input.InputPlugin#_list
	         * @type {Phaser.GameObjects.GameObject[]}
	         * @private
	         * @default []
	         * @since 3.0.0
	         */
	        this._list = [];
	
	        /**
	         * Objects waiting to be inserted to the list on the next call to 'begin'.
	         *
	         * @name Phaser.Input.InputPlugin#_pendingInsertion
	         * @type {Phaser.GameObjects.GameObject[]}
	         * @private
	         * @default []
	         * @since 3.0.0
	         */
	        this._pendingInsertion = [];
	
	        /**
	         * Objects waiting to be removed from the list on the next call to 'begin'.
	         *
	         * @name Phaser.Input.InputPlugin#_pendingRemoval
	         * @type {Phaser.GameObjects.GameObject[]}
	         * @private
	         * @default []
	         * @since 3.0.0
	         */
	        this._pendingRemoval = [];
	
	        /**
	         * A list of all Game Objects that have been enabled for dragging.
	         *
	         * @name Phaser.Input.InputPlugin#_draggable
	         * @type {Phaser.GameObjects.GameObject[]}
	         * @private
	         * @default []
	         * @since 3.0.0
	         */
	        this._draggable = [];
	
	        /**
	         * A list of all Interactive Objects currently considered as being 'draggable' by any pointer, indexed by pointer ID.
	         *
	         * @name Phaser.Input.InputPlugin#_drag
	         * @type {{0:Array,2:Array,3:Array,4:Array,5:Array,6:Array,7:Array,8:Array,9:Array}}
	         * @private
	         * @since 3.0.0
	         */
	        this._drag = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [], 8: [], 9: [] };
	
	        /**
	         * A list of all Interactive Objects currently considered as being 'over' by any pointer, indexed by pointer ID.
	         *
	         * @name Phaser.Input.InputPlugin#_over
	         * @type {{0:Array,2:Array,3:Array,4:Array,5:Array,6:Array,7:Array,8:Array,9:Array}}
	         * @private
	         * @since 3.0.0
	         */
	        this._over = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [], 8: [], 9: [] };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Input.InputPlugin#_validTypes
	         * @type {string[]}
	         * @private
	         * @since 3.0.0
	         */
	        this._validTypes = [ 'onDown', 'onUp', 'onOver', 'onOut', 'onMove', 'onDragStart', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragLeave', 'onDragOver', 'onDrop' ];
	
	        scene.sys.events.once('boot', this.boot, this);
	        scene.sys.events.on('start', this.start, this);
	    },
	
	    /**
	     * This method is called automatically, only once, when the Scene is first created.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.Input.InputPlugin#boot
	     * @private
	     * @since 3.5.1
	     */
	    boot: function ()
	    {
	        this.cameras = this.systems.cameras;
	
	        this.displayList = this.systems.displayList;
	
	        this.systems.events.once('destroy', this.destroy, this);
	    },
	
	    /**
	     * This method is called automatically by the Scene when it is starting up.
	     * It is responsible for creating local systems, properties and listening for Scene events.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.Input.InputPlugin#start
	     * @private
	     * @since 3.5.0
	     */
	    start: function ()
	    {
	        var eventEmitter = this.systems.events;
	
	        eventEmitter.on('transitionstart', this.transitionIn, this);
	        eventEmitter.on('transitionout', this.transitionOut, this);
	        eventEmitter.on('transitioncomplete', this.transitionComplete, this);
	        eventEmitter.on('preupdate', this.preUpdate, this);
	        eventEmitter.on('update', this.update, this);
	
	        eventEmitter.once('shutdown', this.shutdown, this);
	
	        this.enabled = true;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#preUpdate
	     * @since 3.0.0
	     */
	    preUpdate: function ()
	    {
	        var removeList = this._pendingRemoval;
	        var insertList = this._pendingInsertion;
	
	        var toRemove = removeList.length;
	        var toInsert = insertList.length;
	
	        if (toRemove === 0 && toInsert === 0)
	        {
	            //  Quick bail
	            return;
	        }
	
	        var current = this._list;
	
	        //  Delete old gameObjects
	        for (var i = 0; i < toRemove; i++)
	        {
	            var gameObject = removeList[i];
	
	            var index = current.indexOf(gameObject);
	
	            if (index > -1)
	            {
	                current.splice(index, 1);
	
	                this.clear(gameObject);
	            }
	        }
	
	        //  Clear the removal list
	        removeList.length = 0;
	
	        //  Move pendingInsertion to list (also clears pendingInsertion at the same time)
	        this._list = current.concat(insertList.splice(0));
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#clear
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} gameObject - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} [description]
	     */
	    clear: function (gameObject)
	    {
	        var input = gameObject.input;
	
	        input.gameObject = undefined;
	        input.target = undefined;
	        input.hitArea = undefined;
	        input.hitAreaCallback = undefined;
	        input.callbackContext = undefined;
	
	        gameObject.input = null;
	
	        //  Clear from _draggable, _drag and _over
	        var index = this._draggable.indexOf(gameObject);
	
	        if (index > -1)
	        {
	            this._draggable.splice(index, 1);
	        }
	
	        index = this._drag[0].indexOf(gameObject);
	
	        if (index > -1)
	        {
	            this._drag[0].splice(index, 1);
	        }
	
	        index = this._over[0].indexOf(gameObject);
	
	        if (index > -1)
	        {
	            this._over[0].splice(index, 1);
	        }
	
	        return gameObject;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#disable
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} gameObject - [description]
	     */
	    disable: function (gameObject)
	    {
	        gameObject.input.enabled = false;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#enable
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} gameObject - [description]
	     * @param {object} shape - [description]
	     * @param {HitAreaCallback} callback - [description]
	     * @param {boolean} [dropZone=false] - [description]
	     *
	     * @return {Phaser.Input.InputPlugin} This Input Plugin.
	     */
	    enable: function (gameObject, shape, callback, dropZone)
	    {
	        if (dropZone === undefined) { dropZone = false; }
	
	        if (gameObject.input)
	        {
	            //  If it is already has an InteractiveObject then just enable it and return
	            gameObject.input.enabled = true;
	        }
	        else
	        {
	            //  Create an InteractiveObject and enable it
	            this.setHitArea(gameObject, shape, callback);
	        }
	
	        if (gameObject.input)
	        {
	            gameObject.input.dropZone = dropZone;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#hitTestPointer
	     * @since 3.0.0
	     *
	     * @param {Phaser.Input.Pointer} pointer - [description]
	     *
	     * @return {array} [description]
	     */
	    hitTestPointer: function (pointer)
	    {
	        var camera = this.cameras.getCameraBelowPointer(pointer);
	
	        if (camera)
	        {
	            pointer.camera = camera;
	
	            //  Get a list of all objects that can be seen by the camera below the pointer in the scene and store in 'output' array.
	            //  All objects in this array are input enabled, as checked by the hitTest method, so we don't need to check later on as well.
	            var over = this.manager.hitTest(pointer.x, pointer.y, this._list, camera);
	
	            //  Filter out the drop zones
	            for (var i = 0; i < over.length; i++)
	            {
	                var obj = over[i];
	
	                if (obj.input.dropZone)
	                {
	                    this._tempZones.push(obj);
	                }
	            }
	
	            return over;
	        }
	        else
	        {
	            return [];
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#processDownEvents
	     * @since 3.0.0
	     *
	     * @param {Phaser.Input.Pointer} pointer - The Pointer to check for events against.
	     *
	     * @return {integer} The total number of objects interacted with.
	     */
	    processDownEvents: function (pointer)
	    {
	        var currentlyOver = this._temp;
	
	        //  Contains ALL Game Objects currently over in the array
	        this.emit('pointerdown', pointer, currentlyOver);
	
	        var total = 0;
	
	        //  Go through all objects the pointer was over and fire their events / callbacks
	        for (var i = 0; i < currentlyOver.length; i++)
	        {
	            var gameObject = currentlyOver[i];
	
	            if (!gameObject.input)
	            {
	                continue;
	            }
	
	            total++;
	
	            gameObject.emit('pointerdown', pointer, gameObject.input.localX, gameObject.input.localY, pointer.camera);
	
	            this.emit('gameobjectdown', pointer, gameObject);
	        }
	
	        return total;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#processDragEvents
	     * @since 3.0.0
	     *
	     * @param {number} pointer - [description]
	     * @param {number} time - [description]
	     *
	     * @return {integer} [description]
	     */
	    processDragEvents: function (pointer, time)
	    {
	        if (this._draggable.length === 0)
	        {
	            //  There are no draggable items, so let's not even bother going further
	            return 0;
	        }
	
	        var i;
	        var gameObject;
	        var list;
	        var input;
	        var currentlyOver = this._temp;
	
	        //  0 = Not dragging anything
	        //  1 = Primary button down and objects below, so collect a draglist
	        //  2 = Pointer being checked if meets drag criteria
	        //  3 = Pointer meets criteria, notify the draglist
	        //  4 = Pointer actively dragging the draglist and has moved
	        //  5 = Pointer actively dragging but has been released, notify draglist
	
	        if (pointer.dragState === 0 && pointer.primaryDown && pointer.justDown && currentlyOver.length > 0)
	        {
	            pointer.dragState = 1;
	        }
	        else if (pointer.dragState > 0 && !pointer.primaryDown && pointer.justUp)
	        {
	            pointer.dragState = 5;
	        }
	
	        //  Process the various drag states
	
	        //  1 = Primary button down and objects below, so collect a draglist
	        if (pointer.dragState === 1)
	        {
	            //  Get draggable objects, sort them, pick the top (or all) and store them somewhere
	            var draglist = [];
	
	            for (i = 0; i < currentlyOver.length; i++)
	            {
	                gameObject = currentlyOver[i];
	
	                if (gameObject.input.draggable)
	                {
	                    draglist.push(gameObject);
	                }
	            }
	
	            if (draglist.length === 0)
	            {
	                pointer.dragState = 0;
	
	                return 0;
	            }
	            else if (draglist.length > 1)
	            {
	                this.sortGameObjects(draglist);
	
	                if (this.topOnly)
	                {
	                    draglist.splice(1);
	                }
	            }
	
	            //  draglist now contains all potential candidates for dragging
	            this._drag[pointer.id] = draglist;
	
	            if (this.dragDistanceThreshold === 0 && this.dragTimeThreshold === 0)
	            {
	                //  No drag criteria, so snap immediately to mode 3
	                pointer.dragState = 3;
	            }
	            else
	            {
	                //  Check the distance / time
	                pointer.dragState = 2;
	            }
	        }
	
	        //  2 = Pointer being checked if meets drag criteria
	        if (pointer.dragState === 2)
	        {
	            //  Has it moved far enough to be considered a drag?
	            if (this.dragDistanceThreshold > 0 && DistanceBetween(pointer.x, pointer.y, pointer.downX, pointer.downY) >= this.dragDistanceThreshold)
	            {
	                //  Alrighty, we've got a drag going on ...
	                pointer.dragState = 3;
	            }
	
	            //  Held down long enough to be considered a drag?
	            if (this.dragTimeThreshold > 0 && (time >= pointer.downTime + this.dragTimeThreshold))
	            {
	                //  Alrighty, we've got a drag going on ...
	                pointer.dragState = 3;
	            }
	        }
	
	        //  3 = Pointer meets criteria and is freshly down, notify the draglist
	        if (pointer.dragState === 3)
	        {
	            list = this._drag[pointer.id];
	
	            for (i = 0; i < list.length; i++)
	            {
	                gameObject = list[i];
	
	                input = gameObject.input;
	
	                input.dragState = 2;
	
	                input.dragX = pointer.x - gameObject.x;
	                input.dragY = pointer.y - gameObject.y;
	
	                input.dragStartX = gameObject.x;
	                input.dragStartY = gameObject.y;
	
	                gameObject.emit('dragstart', pointer, input.dragX, input.dragY);
	
	                this.emit('dragstart', pointer, gameObject);
	            }
	
	            pointer.dragState = 4;
	
	            return list.length;
	        }
	
	        //  4 = Pointer actively dragging the draglist and has moved
	        if (pointer.dragState === 4 && pointer.justMoved)
	        {
	            var dropZones = this._tempZones;
	
	            list = this._drag[pointer.id];
	
	            for (i = 0; i < list.length; i++)
	            {
	                gameObject = list[i];
	
	                input = gameObject.input;
	
	                //  If this GO has a target then let's check it
	                if (input.target)
	                {
	                    var index = dropZones.indexOf(input.target);
	
	                    //  Got a target, are we still over it?
	                    if (index === 0)
	                    {
	                        //  We're still over it, and it's still the top of the display list, phew ...
	                        gameObject.emit('dragover', pointer, input.target);
	
	                        this.emit('dragover', pointer, gameObject, input.target);
	                    }
	                    else if (index > 0)
	                    {
	                        //  Still over it but it's no longer top of the display list (targets must always be at the top)
	                        gameObject.emit('dragleave', pointer, input.target);
	
	                        this.emit('dragleave', pointer, gameObject, input.target);
	
	                        input.target = dropZones[0];
	
	                        gameObject.emit('dragenter', pointer, input.target);
	
	                        this.emit('dragenter', pointer, gameObject, input.target);
	                    }
	                    else
	                    {
	                        //  Nope, we've moved on (or the target has!), leave the old target
	                        gameObject.emit('dragleave', pointer, input.target);
	
	                        this.emit('dragleave', pointer, gameObject, input.target);
	
	                        //  Anything new to replace it?
	                        //  Yup!
	                        if (dropZones[0])
	                        {
	                            input.target = dropZones[0];
	
	                            gameObject.emit('dragenter', pointer, input.target);
	
	                            this.emit('dragenter', pointer, gameObject, input.target);
	                        }
	                        else
	                        {
	                            //  Nope
	                            input.target = null;
	                        }
	                    }
	                }
	                else if (!input.target && dropZones[0])
	                {
	                    input.target = dropZones[0];
	
	                    gameObject.emit('dragenter', pointer, input.target);
	
	                    this.emit('dragenter', pointer, gameObject, input.target);
	                }
	
	                var dragX = pointer.x - gameObject.input.dragX;
	                var dragY = pointer.y - gameObject.input.dragY;
	
	                gameObject.emit('drag', pointer, dragX, dragY);
	
	                this.emit('drag', pointer, gameObject, dragX, dragY);
	            }
	
	            return list.length;
	        }
	
	        //  5 = Pointer was actively dragging but has been released, notify draglist
	        if (pointer.dragState === 5)
	        {
	            list = this._drag[pointer.id];
	
	            for (i = 0; i < list.length; i++)
	            {
	                gameObject = list[i];
	
	                input = gameObject.input;
	
	                input.dragState = 0;
	
	                input.dragX = input.localX - gameObject.displayOriginX;
	                input.dragY = input.localY - gameObject.displayOriginY;
	
	                var dropped = false;
	
	                if (input.target)
	                {
	                    gameObject.emit('drop', pointer, input.target);
	
	                    this.emit('drop', pointer, gameObject, input.target);
	
	                    input.target = null;
	
	                    dropped = true;
	                }
	
	                //  And finally the dragend event
	
	                gameObject.emit('dragend', pointer, input.dragX, input.dragY, dropped);
	
	                this.emit('dragend', pointer, gameObject, dropped);
	            }
	
	            pointer.dragState = 0;
	            list.splice(0);
	        }
	
	        return 0;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#processMoveEvents
	     * @since 3.0.0
	     *
	     * @param {Phaser.Input.Pointer} pointer - The pointer to check for events against.
	     *
	     * @return {integer} The total number of objects interacted with.
	     */
	    processMoveEvents: function (pointer)
	    {
	        var currentlyOver = this._temp;
	
	        this.emit('pointermove', pointer, currentlyOver);
	
	        var total = 0;
	
	        //  Go through all objects the pointer was over and fire their events / callbacks
	        for (var i = 0; i < currentlyOver.length; i++)
	        {
	            var gameObject = currentlyOver[i];
	
	            if (!gameObject.input)
	            {
	                continue;
	            }
	
	            total++;
	
	            gameObject.emit('pointermove', pointer, gameObject.input.localX, gameObject.input.localY);
	
	            this.emit('gameobjectmove', pointer, gameObject);
	
	            if (this.topOnly)
	            {
	                break;
	            }
	        }
	
	        return total;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#processOverOutEvents
	     * @since 3.0.0
	     *
	     * @param {Phaser.Input.Pointer} pointer - [description]
	     *
	     * @return {integer} The number of objects interacted with.
	     */
	    processOverOutEvents: function (pointer)
	    {
	        var currentlyOver = this._temp;
	
	        var i;
	        var gameObject;
	        var justOut = [];
	        var justOver = [];
	        var stillOver = [];
	        var previouslyOver = this._over[pointer.id];
	        var currentlyDragging = this._drag[pointer.id];
	
	        //  Go through all objects the pointer was previously over, and see if it still is.
	        //  Splits the previouslyOver array into two parts: justOut and stillOver
	
	        for (i = 0; i < previouslyOver.length; i++)
	        {
	            gameObject = previouslyOver[i];
	
	            if (currentlyOver.indexOf(gameObject) === -1 && currentlyDragging.indexOf(gameObject) === -1)
	            {
	                //  Not in the currentlyOver array, so must be outside of this object now
	                justOut.push(gameObject);
	            }
	            else
	            {
	                //  In the currentlyOver array
	                stillOver.push(gameObject);
	            }
	        }
	
	        //  Go through all objects the pointer is currently over (the hit test results)
	        //  and if not in the previouslyOver array we know it's a new entry, so add to justOver
	        for (i = 0; i < currentlyOver.length; i++)
	        {
	            gameObject = currentlyOver[i];
	
	            //  Is this newly over?
	
	            if (previouslyOver.indexOf(gameObject) === -1)
	            {
	                justOver.push(gameObject);
	            }
	        }
	
	        //  By this point the arrays are filled, so now we can process what happened...
	
	        //  Process the Just Out objects
	        var total = justOut.length;
	
	        var totalInteracted = 0;
	
	        if (total > 0)
	        {
	            this.sortGameObjects(justOut);
	
	            this.emit('pointerout', pointer, justOut);
	
	            //  Call onOut for everything in the justOut array
	            for (i = 0; i < total; i++)
	            {
	                gameObject = justOut[i];
	
	                if (!gameObject.input)
	                {
	                    continue;
	                }
	
	                this.emit('gameobjectout', pointer, gameObject);
	
	                gameObject.emit('pointerout', pointer);
	
	                totalInteracted++;
	            }
	        }
	
	        //  Process the Just Over objects
	        total = justOver.length;
	
	        if (total > 0)
	        {
	            this.sortGameObjects(justOver);
	
	            this.emit('pointerover', pointer, justOver);
	
	            //  Call onOver for everything in the justOver array
	            for (i = 0; i < total; i++)
	            {
	                gameObject = justOver[i];
	
	                if (!gameObject.input)
	                {
	                    continue;
	                }
	
	                this.emit('gameobjectover', pointer, gameObject);
	
	                gameObject.emit('pointerover', pointer, gameObject.input.localX, gameObject.input.localY);
	
	                totalInteracted++;
	            }
	        }
	
	        //  Add the contents of justOver to the previously over array
	        previouslyOver = stillOver.concat(justOver);
	
	        //  Then sort it into display list order
	        this._over[pointer.id] = this.sortGameObjects(previouslyOver);
	
	        return totalInteracted;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#processUpEvents
	     * @since 3.0.0
	     *
	     * @param {Phaser.Input.Pointer} pointer - [description]
	     */
	    processUpEvents: function (pointer)
	    {
	        var currentlyOver = this._temp;
	
	        //  Contains ALL Game Objects currently up in the array
	        this.emit('pointerup', pointer, currentlyOver);
	
	        //  Go through all objects the pointer was over and fire their events / callbacks
	        for (var i = 0; i < currentlyOver.length; i++)
	        {
	            var gameObject = currentlyOver[i];
	
	            if (!gameObject.input)
	            {
	                continue;
	            }
	
	            //  pointerupoutside
	
	            gameObject.emit('pointerup', pointer, gameObject.input.localX, gameObject.input.localY);
	
	            this.emit('gameobjectup', pointer, gameObject);
	        }
	
	        return currentlyOver.length;
	    },
	
	    /**
	     * Queues a Game Object for insertion into this Input Manager on the next update.
	     *
	     * @method Phaser.Input.InputPlugin#queueForInsertion
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} child - The Game Object to add.
	     *
	     * @return {Phaser.Input.InputPlugin} This InputPlugin object.
	     */
	    queueForInsertion: function (child)
	    {
	        if (this._pendingInsertion.indexOf(child) === -1 && this._list.indexOf(child) === -1)
	        {
	            this._pendingInsertion.push(child);
	        }
	
	        return this;
	    },
	
	    /**
	     * Queues a Game Object for removal from this Input Manager on the next update.
	     *
	     * @method Phaser.Input.InputPlugin#queueForRemoval
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} child - The Game Object to remove.
	     *
	     * @return {Phaser.Input.InputPlugin} This InputPlugin object.
	     */
	    queueForRemoval: function (child)
	    {
	        this._pendingRemoval.push(child);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#setDraggable
	     * @since 3.0.0
	     *
	     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to change the draggable state on.
	     * @param {boolean} [value=true] - Set to `true` if the Game Objects should be made draggable, `false` if they should be unset.
	     *
	     * @return {Phaser.Input.InputPlugin} This InputPlugin object.
	     */
	    setDraggable: function (gameObjects, value)
	    {
	        if (value === undefined) { value = true; }
	
	        if (!Array.isArray(gameObjects))
	        {
	            gameObjects = [ gameObjects ];
	        }
	
	        for (var i = 0; i < gameObjects.length; i++)
	        {
	            var gameObject = gameObjects[i];
	
	            gameObject.input.draggable = value;
	
	            var index = this._draggable.indexOf(gameObject);
	
	            if (value && index === -1)
	            {
	                this._draggable.push(gameObject);
	            }
	            else if (!value && index > -1)
	            {
	                this._draggable.splice(index, 1);
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#setHitArea
	     * @since 3.0.0
	     *
	     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set the hit area on.
	     * @param {object} [shape] - The shape or object to check if the pointer is within for hit area checks.
	     * @param {HitAreaCallback} [callback] - The 'contains' function to invoke to check if the pointer is within the hit area.
	     *
	     * @return {Phaser.Input.InputPlugin} This InputPlugin object.
	     */
	    setHitArea: function (gameObjects, shape, callback)
	    {
	        if (shape === undefined)
	        {
	            return this.setHitAreaFromTexture(gameObjects);
	        }
	
	        if (!Array.isArray(gameObjects))
	        {
	            gameObjects = [ gameObjects ];
	        }
	
	        for (var i = 0; i < gameObjects.length; i++)
	        {
	            var gameObject = gameObjects[i];
	
	            gameObject.input = CreateInteractiveObject(gameObject, shape, callback);
	
	            this.queueForInsertion(gameObject);
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#setHitAreaCircle
	     * @since 3.0.0
	     *
	     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set as having a circle hit area.
	     * @param {number} x - The center of the circle.
	     * @param {number} y - The center of the circle.
	     * @param {number} radius - The radius of the circle.
	     * @param {HitAreaCallback} [callback] - The hit area callback. If undefined it uses Circle.Contains.
	     *
	     * @return {Phaser.Input.InputPlugin} This InputPlugin object.
	     */
	    setHitAreaCircle: function (gameObjects, x, y, radius, callback)
	    {
	        if (callback === undefined) { callback = CircleContains; }
	
	        var shape = new Circle(x, y, radius);
	
	        return this.setHitArea(gameObjects, shape, callback);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#setHitAreaEllipse
	     * @since 3.0.0
	     *
	     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set as having an ellipse hit area.
	     * @param {number} x - The center of the ellipse.
	     * @param {number} y - The center of the ellipse.
	     * @param {number} width - The width of the ellipse.
	     * @param {number} height - The height of the ellipse.
	     * @param {HitAreaCallback} [callback] - The hit area callback. If undefined it uses Ellipse.Contains.
	     *
	     * @return {Phaser.Input.InputPlugin} This InputPlugin object.
	     */
	    setHitAreaEllipse: function (gameObjects, x, y, width, height, callback)
	    {
	        if (callback === undefined) { callback = EllipseContains; }
	
	        var shape = new Ellipse(x, y, width, height);
	
	        return this.setHitArea(gameObjects, shape, callback);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#setHitAreaFromTexture
	     * @since 3.0.0
	     *
	     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set as having an ellipse hit area.
	     * @param {HitAreaCallback} [callback] - The hit area callback. If undefined it uses Rectangle.Contains.
	     *
	     * @return {Phaser.Input.InputPlugin} This InputPlugin object.
	     */
	    setHitAreaFromTexture: function (gameObjects, callback)
	    {
	        if (callback === undefined) { callback = RectangleContains; }
	
	        if (!Array.isArray(gameObjects))
	        {
	            gameObjects = [ gameObjects ];
	        }
	
	        for (var i = 0; i < gameObjects.length; i++)
	        {
	            var gameObject = gameObjects[i];
	
	            if (gameObject.type === 'Container')
	            {
	                console.warn('Container.setInteractive() must specify a Shape');
	                continue;
	            }
	
	            var frame = gameObject.frame;
	
	            var width = 0;
	            var height = 0;
	
	            if (frame)
	            {
	                width = frame.realWidth;
	                height = frame.realHeight;
	            }
	            else if (gameObject.width)
	            {
	                width = gameObject.width;
	                height = gameObject.height;
	            }
	
	            if (width !== 0 && height !== 0)
	            {
	                gameObject.input = CreateInteractiveObject(gameObject, new Rectangle(0, 0, width, height), callback);
	
	                this.queueForInsertion(gameObject);
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#setHitAreaRectangle
	     * @since 3.0.0
	     *
	     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set as having a rectangular hit area.
	     * @param {number} x - The top-left of the rectangle.
	     * @param {number} y - The top-left of the rectangle.
	     * @param {number} width - The width of the rectangle.
	     * @param {number} height - The height of the rectangle.
	     * @param {HitAreaCallback} [callback] - The hit area callback. If undefined it uses Rectangle.Contains.
	     *
	     * @return {Phaser.Input.InputPlugin} This InputPlugin object.
	     */
	    setHitAreaRectangle: function (gameObjects, x, y, width, height, callback)
	    {
	        if (callback === undefined) { callback = RectangleContains; }
	
	        var shape = new Rectangle(x, y, width, height);
	
	        return this.setHitArea(gameObjects, shape, callback);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#setHitAreaTriangle
	     * @since 3.0.0
	     *
	     * @param {(Phaser.GameObjects.GameObject|Phaser.GameObjects.GameObject[])} gameObjects - An array of Game Objects to set as having a  triangular hit area.
	     * @param {number} x1 - The x coordinate of the first point of the triangle.
	     * @param {number} y1 - The y coordinate of the first point of the triangle.
	     * @param {number} x2 - The x coordinate of the second point of the triangle.
	     * @param {number} y2 - The y coordinate of the second point of the triangle.
	     * @param {number} x3 - The x coordinate of the third point of the triangle.
	     * @param {number} y3 - The y coordinate of the third point of the triangle.
	     * @param {HitAreaCallback} [callback] - The hit area callback. If undefined it uses Triangle.Contains.
	     *
	     * @return {Phaser.Input.InputPlugin} This InputPlugin object.
	     */
	    setHitAreaTriangle: function (gameObjects, x1, y1, x2, y2, x3, y3, callback)
	    {
	        if (callback === undefined) { callback = TriangleContains; }
	
	        var shape = new Triangle(x1, y1, x2, y2, x3, y3);
	
	        return this.setHitArea(gameObjects, shape, callback);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#setPollAlways
	     * @since 3.0.0
	     *
	     * @return {Phaser.Input.InputPlugin} This InputPlugin object.
	     */
	    setPollAlways: function ()
	    {
	        this.pollRate = 0;
	        this._pollTimer = 0;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#setPollOnMove
	     * @since 3.0.0
	     *
	     * @return {Phaser.Input.InputPlugin} This InputPlugin object.
	     */
	    setPollOnMove: function ()
	    {
	        this.pollRate = -1;
	        this._pollTimer = 0;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#setPollRate
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.Input.InputPlugin} This InputPlugin object.
	     */
	    setPollRate: function (value)
	    {
	        this.pollRate = value;
	        this._pollTimer = 0;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#setGlobalTopOnly
	     * @since 3.0.0
	     *
	     * @param {boolean} value - [description]
	     *
	     * @return {Phaser.Input.InputPlugin} This InputPlugin object.
	     */
	    setGlobalTopOnly: function (value)
	    {
	        this.manager.globalTopOnly = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#setTopOnly
	     * @since 3.0.0
	     *
	     * @param {boolean} value - [description]
	     *
	     * @return {Phaser.Input.InputPlugin} This InputPlugin object.
	     */
	    setTopOnly: function (value)
	    {
	        this.topOnly = value;
	
	        return this;
	    },
	
	    /**
	     * Given an array of Game Objects, sort the array and return it,
	     * so that the objects are in index order with the lowest at the bottom.
	     *
	     * @method Phaser.Input.InputPlugin#sortGameObjects
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject[]} gameObjects - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject[]} [description]
	     */
	    sortGameObjects: function (gameObjects)
	    {
	        if (gameObjects.length < 2)
	        {
	            return gameObjects;
	        }
	
	        this.scene.sys.depthSort();
	
	        return gameObjects.sort(this.sortHandlerGO.bind(this));
	    },
	
	    /**
	     * Return the child lowest down the display list (with the smallest index)
	     * Will iterate through all parent containers, if present.
	     *
	     * @method Phaser.Input.InputPlugin#sortHandlerGO
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} childA - The first Game Object to compare.
	     * @param {Phaser.GameObjects.GameObject} childB - The second Game Object to compare.
	     *
	     * @return {integer} Returns either a negative or positive integer, or zero if they match.
	     */
	    sortHandlerGO: function (childA, childB)
	    {
	        if (!childA.parentContainer && !childB.parentContainer)
	        {
	            //  Quick bail out when neither child has a container
	            return this.displayList.getIndex(childB) - this.displayList.getIndex(childA);
	        }
	        else if (childA.parentContainer === childB.parentContainer)
	        {
	            //  Quick bail out when both children have the same container
	            return childB.parentContainer.getIndex(childB) - childA.parentContainer.getIndex(childA);
	        }
	        else
	        {
	            //  Container index check
	            var listA = childA.getIndexList();
	            var listB = childB.getIndexList();
	            var len = Math.min(listA.length, listB.length);
	
	            for (var i = 0; i < len; i++)
	            {
	                // var indexA = listA[i][0];
	                // var indexB = listB[i][0];
	                var indexA = listA[i];
	                var indexB = listB[i];
	
	                if (indexA === indexB)
	                {
	                    //  Go to the next level down
	                    continue;
	                }
	                else
	                {
	                    //  Non-matching parents, so return
	                    return indexB - indexA;
	                }
	            }
	        }
	
	        //  Technically this shouldn't happen, but ...
	        return 0;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#stopPropagation
	     * @since 3.0.0
	     *
	     * @return {Phaser.Input.InputPlugin} This InputPlugin object.
	     */
	    stopPropagation: function ()
	    {
	        if (this.manager.globalTopOnly)
	        {
	            this.manager.ignoreEvents = true;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Input.InputPlugin#update
	     * @since 3.0.0
	     *
	     * @param {number} time - [description]
	     * @param {number} delta - [description]
	     */
	    update: function (time, delta)
	    {
	        var manager = this.manager;
	
	        //  Another Scene above this one has already consumed the input events, or we're in transition
	        if (!this.enabled || (manager.globalTopOnly && manager.ignoreEvents))
	        {
	            return;
	        }
	
	        var pointer = manager.activePointer;
	
	        var runUpdate = (pointer.dirty || this.pollRate === 0);
	
	        if (this.pollRate > -1)
	        {
	            this._pollTimer -= delta;
	
	            if (this._pollTimer < 0)
	            {
	                runUpdate = true;
	
	                //  Discard timer diff
	                this._pollTimer = this.pollRate;
	            }
	        }
	
	        if (!runUpdate)
	        {
	            return;
	        }
	
	        //  Always reset this array
	        this._tempZones = [];
	
	        //  _temp contains a hit tested and camera culled list of IO objects
	        this._temp = this.hitTestPointer(pointer);
	
	        this.sortGameObjects(this._temp);
	        this.sortGameObjects(this._tempZones);
	
	        if (this.topOnly)
	        {
	            //  Only the top-most one counts now, so safely ignore the rest
	            if (this._temp.length)
	            {
	                this._temp.splice(1);
	            }
	
	            if (this._tempZones.length)
	            {
	                this._tempZones.splice(1);
	            }
	        }
	
	        var total = this.processDragEvents(pointer, time);
	
	        if (!pointer.wasTouch)
	        {
	            total += this.processOverOutEvents(pointer);
	        }
	
	        if (pointer.justDown)
	        {
	            total += this.processDownEvents(pointer);
	        }
	
	        if (pointer.justUp)
	        {
	            total += this.processUpEvents(pointer);
	        }
	
	        if (pointer.justMoved)
	        {
	            total += this.processMoveEvents(pointer);
	        }
	
	        if (total > 0 && manager.globalTopOnly)
	        {
	            //  We interacted with an event in this Scene, so block any Scenes below us from doing the same this frame
	            manager.ignoreEvents = true;
	        }
	    },
	
	    /**
	     * The Scene that owns this plugin is transitioning in.
	     *
	     * @method Phaser.Input.InputPlugin#transitionIn
	     * @private
	     * @since 3.5.0
	     */
	    transitionIn: function ()
	    {
	        this.enabled = this.settings.transitionAllowInput;
	    },
	
	    /**
	     * The Scene that owns this plugin has finished transitioning in.
	     *
	     * @method Phaser.Input.InputPlugin#transitionComplete
	     * @private
	     * @since 3.5.0
	     */
	    transitionComplete: function ()
	    {
	        if (!this.settings.transitionAllowInput)
	        {
	            this.enabled = true;
	        }
	    },
	
	    /**
	     * The Scene that owns this plugin is transitioning out.
	     *
	     * @method Phaser.Input.InputPlugin#transitionOut
	     * @private
	     * @since 3.5.0
	     */
	    transitionOut: function ()
	    {
	        this.enabled = this.settings.transitionAllowInput;
	    },
	
	    /**
	     * The Scene that owns this plugin is shutting down.
	     * We need to kill and reset all internal properties as well as stop listening to Scene events.
	     *
	     * @method Phaser.Input.InputPlugin#shutdown
	     * @private
	     * @since 3.0.0
	     */
	    shutdown: function ()
	    {
	        this._temp.length = 0;
	        this._list.length = 0;
	        this._draggable.length = 0;
	        this._pendingRemoval.length = 0;
	        this._pendingInsertion.length = 0;
	
	        for (var i = 0; i < 10; i++)
	        {
	            this._drag[i] = [];
	            this._over[i] = [];
	        }
	
	        this.removeAllListeners();
	
	        var eventEmitter = this.systems.events;
	
	        eventEmitter.off('transitionstart', this.transitionIn, this);
	        eventEmitter.off('transitionout', this.transitionOut, this);
	        eventEmitter.off('transitioncomplete', this.transitionComplete, this);
	
	        eventEmitter.off('preupdate', this.preUpdate, this);
	        eventEmitter.off('update', this.update, this);
	        eventEmitter.off('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * The Scene that owns this plugin is being destroyed.
	     * We need to shutdown and then kill off all external references.
	     *
	     * @method Phaser.Input.InputPlugin#destroy
	     * @private
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.shutdown();
	
	        this.scene.sys.events.off('start', this.start, this);
	
	        this.scene = null;
	        this.cameras = null;
	        this.manager = null;
	        this.events = null;
	        this.keyboard = null;
	        this.mouse = null;
	        this.gamepad = null;
	    },
	
	    /**
	     * The current active input Pointer.
	     *
	     * @name Phaser.Input.InputPlugin#activePointer
	     * @type {Phaser.Input.Pointer}
	     * @readOnly
	     * @since 3.0.0
	     */
	    activePointer: {
	
	        get: function ()
	        {
	            return this.manager.activePointer;
	        }
	
	    },
	
	    /**
	     * The x coordinates of the ActivePointer based on the first camera in the camera list.
	     * This is only safe to use if your game has just 1 non-transformed camera and doesn't use multi-touch.
	     *
	     * @name Phaser.Input.InputPlugin#x
	     * @type {number}
	     * @readOnly
	     * @since 3.0.0
	     */
	    x: {
	
	        get: function ()
	        {
	            return this.manager.activePointer.x;
	        }
	
	    },
	
	    /**
	     * The y coordinates of the ActivePointer based on the first camera in the camera list.
	     * This is only safe to use if your game has just 1 non-transformed camera and doesn't use multi-touch.
	     *
	     * @name Phaser.Input.InputPlugin#y
	     * @type {number}
	     * @readOnly
	     * @since 3.0.0
	     */
	    y: {
	
	        get: function ()
	        {
	            return this.manager.activePointer.y;
	        }
	
	    }
	
	});
	
	PluginCache.register('InputPlugin', InputPlugin, 'input');
	
	module.exports = InputPlugin;


/***/ }),
/* 1308 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Tatar SNES USB Controller Gamepad Configuration.
	 * USB Gamepad  (STANDARD GAMEPAD Vendor: 0079 Product: 0011)
	 *
	 * @name Phaser.Input.Gamepad.Configs.SNES_USB
	 * @type {object}
	 * @since 3.0.0
	 */
	module.exports = {
	
	    UP: 12,
	    DOWN: 13,
	    LEFT: 14,
	    RIGHT: 15,
	
	    SELECT: 8,
	    START: 9,
	
	    B: 0,
	    A: 1,
	    Y: 2,
	    X: 3,
	
	    LEFT_SHOULDER: 4,
	    RIGHT_SHOULDER: 5
	
	};


/***/ }),
/* 1309 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * PlayStation DualShock 4 Gamepad Configuration.
	 * Sony PlayStation DualShock 4 (v2) wireless controller
	 *
	 * @name Phaser.Input.Gamepad.Configs.DUALSHOCK_4
	 * @type {object}
	 * @since 3.0.0
	 */
	module.exports = {
	
	    UP: 12,
	    DOWN: 13,
	    LEFT: 14,
	    RIGHT: 15,
	
	    SHARE: 8,
	    OPTIONS: 9,
	    PS: 16,
	    TOUCHBAR: 17,
	
	    X: 0,
	    CIRCLE: 1,
	    SQUARE: 2,
	    TRIANGLE: 3,
	
	    L1: 4,
	    R1: 5,
	    L2: 6,
	    R2: 7,
	    L3: 10,
	    R3: 11,
	
	    LEFT_STICK_H: 0,
	    LEFT_STICK_V: 1,
	    RIGHT_STICK_H: 2,
	    RIGHT_STICK_V: 3
	
	};


/***/ }),
/* 1310 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * XBox 360 Gamepad Configuration.
	 *
	 * @name Phaser.Input.Gamepad.Configs.XBOX_360
	 * @type {object}
	 * @since 3.0.0
	 */
	module.exports = {
	
	    UP: 12,
	    DOWN: 13,
	    LEFT: 14,
	    RIGHT: 15,
	
	    MENU: 16,
	
	    A: 0,
	    B: 1,
	    X: 2,
	    Y: 3,
	
	    LB: 4,
	    RB: 5,
	
	    LT: 6,
	    RT: 7,
	
	    BACK: 8,
	    START: 9,
	
	    LS: 10,
	    RS: 11,
	
	    LEFT_STICK_H: 0,
	    LEFT_STICK_V: 1,
	    RIGHT_STICK_H: 2,
	    RIGHT_STICK_V: 3
	
	};


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Input.Gamepad.Configs
	 */
	
	module.exports = {
	
	    DUALSHOCK_4: __webpack_require__(1309),
	    SNES_USB: __webpack_require__(1308),
	    XBOX_360: __webpack_require__(1310)
	
	};


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Input.Gamepad
	 */
	
	module.exports = {
	
	    Axis: __webpack_require__(535),
	    Button: __webpack_require__(536),
	    Gamepad: __webpack_require__(537),
	    GamepadManager: __webpack_require__(538),
	    
	    Configs: __webpack_require__(1311)
	};


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Input
	 */
	
	module.exports = {
	
	    CreateInteractiveObject: __webpack_require__(532),
	    Gamepad: __webpack_require__(1312),
	    InputManager: __webpack_require__(533),
	    InputPlugin: __webpack_require__(1307),
	    Keyboard: __webpack_require__(1317),
	    Mouse: __webpack_require__(1325),
	    Pointer: __webpack_require__(534),
	    Touch: __webpack_require__(1326)
	
	};


/***/ }),
/* 1314 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Used internally by the KeyCombo class.
	 * Return `true` if it reached the end of the combo, `false` if not.
	 *
	 * @function Phaser.Input.Keyboard.KeyCombo.AdvanceKeyCombo
	 * @since 3.0.0
	 *
	 * @param {KeyboardEvent} event - [description]
	 * @param {Phaser.Input.Keyboard.KeyCombo} combo - [description]
	 *
	 * @return {boolean} `true` if it reached the end of the combo, `false` if not.
	 */
	var AdvanceKeyCombo = function (event, combo)
	{
	    combo.timeLastMatched = event.timeStamp;
	    combo.index++;
	
	    if (combo.index === combo.size)
	    {
	        return true;
	    }
	    else
	    {
	        combo.current = combo.keyCodes[combo.index];
	        return false;
	    }
	};
	
	module.exports = AdvanceKeyCombo;


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var AdvanceKeyCombo = __webpack_require__(1314);
	
	/**
	 * Used internally by the KeyCombo class.
	 *
	 * @function Phaser.Input.Keyboard.KeyCombo.ProcessKeyCombo
	 * @since 3.0.0
	 *
	 * @param {KeyboardEvent} event - [description]
	 * @param {Phaser.Input.Keyboard.KeyCombo} combo - [description]
	 *
	 * @return {boolean} [description]
	 */
	var ProcessKeyCombo = function (event, combo)
	{
	    if (combo.matched)
	    {
	        return true;
	    }
	
	    var comboMatched = false;
	    var keyMatched = false;
	
	    if (event.keyCode === combo.current)
	    {
	        //  Key was correct
	
	        if (combo.index > 0 && combo.maxKeyDelay > 0)
	        {
	            //  We have to check to see if the delay between
	            //  the new key and the old one was too long (if enabled)
	
	            var timeLimit = combo.timeLastMatched + combo.maxKeyDelay;
	
	            //  Check if they pressed it in time or not
	            if (event.timeStamp <= timeLimit)
	            {
	                keyMatched = true;
	                comboMatched = AdvanceKeyCombo(event, combo);
	            }
	        }
	        else
	        {
	            keyMatched = true;
	
	            //  We don't check the time for the first key pressed, so just advance it
	            comboMatched = AdvanceKeyCombo(event, combo);
	        }
	    }
	
	    if (!keyMatched && combo.resetOnWrongKey)
	    {
	        //  Wrong key was pressed
	        combo.index = 0;
	        combo.current = combo.keyCodes[0];
	    }
	
	    if (comboMatched)
	    {
	        combo.timeLastMatched = event.timeStamp;
	        combo.matched = true;
	        combo.timeMatched = event.timeStamp;
	    }
	
	    return comboMatched;
	};
	
	module.exports = ProcessKeyCombo;


/***/ }),
/* 1316 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Used internally by the KeyCombo class.
	 *
	 * @function Phaser.Input.Keyboard.KeyCombo.ResetKeyCombo
	 * @since 3.0.0
	 *
	 * @param {Phaser.Input.Keyboard.KeyCombo} combo - The KeyCombo to reset.
	 *
	 * @return {Phaser.Input.Keyboard.KeyCombo} The KeyCombo.
	 */
	var ResetKeyCombo = function (combo)
	{
	    combo.current = combo.keyCodes[0];
	    combo.index = 0;
	    combo.timeLastMatched = 0;
	    combo.matched = false;
	    combo.timeMatched = 0;
	
	    return combo;
	};
	
	module.exports = ResetKeyCombo;


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Input.Keyboard
	 */
	
	module.exports = {
	
	    KeyboardManager: __webpack_require__(539),
	
	    Key: __webpack_require__(541),
	    KeyCodes: __webpack_require__(301),
	
	    KeyCombo: __webpack_require__(540),
	
	    JustDown: __webpack_require__(1319),
	    JustUp: __webpack_require__(1320),
	    DownDuration: __webpack_require__(1318),
	    UpDuration: __webpack_require__(1324)
	    
	};


/***/ }),
/* 1318 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Returns `true` if the Key was pressed down within the `duration` value given, or `false` if it either isn't down,
	 * or was pressed down longer ago than then given duration.
	 *
	 * @function Phaser.Input.Keyboard.DownDuration
	 * @since 3.0.0
	 *
	 * @param {Phaser.Input.Keyboard.Key} key - [description]
	 * @param {integer} [duration=50] - [description]
	 *
	 * @return {boolean} [description]
	 */
	var DownDuration = function (key, duration)
	{
	    if (duration === undefined) { duration = 50; }
	
	    return (key.isDown && key.duration < duration);
	};
	
	module.exports = DownDuration;


/***/ }),
/* 1319 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * The justDown value allows you to test if this Key has just been pressed down or not.
	 * When you check this value it will return `true` if the Key is down, otherwise `false`.
	 * You can only call justDown once per key press. It will only return `true` once, until the Key is released and pressed down again.
	 * This allows you to use it in situations where you want to check if this key is down without using a Signal, such as in a core game loop.
	 *
	 * @function Phaser.Input.Keyboard.JustDown
	 * @since 3.0.0
	 *
	 * @param {Phaser.Input.Keyboard.Key} key - [description]
	 *
	 * @return {boolean} [description]
	 */
	var JustDown = function (key)
	{
	    if (key._justDown)
	    {
	        key._justDown = false;
	
	        return true;
	    }
	    else
	    {
	        return false;
	    }
	};
	
	module.exports = JustDown;


/***/ }),
/* 1320 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * The justUp value allows you to test if this Key has just been released or not.
	 * When you check this value it will return `true` if the Key is up, otherwise `false`.
	 * You can only call justUp once per key release. It will only return `true` once, until the Key is pressed down and released again.
	 * This allows you to use it in situations where you want to check if this key is up without using a Signal, such as in a core game loop.
	 *
	 * @function Phaser.Input.Keyboard.JustUp
	 * @since 3.0.0
	 *
	 * @param {Phaser.Input.Keyboard.Key} key - [description]
	 *
	 * @return {boolean} [description]
	 */
	var JustUp = function (key)
	{
	    if (key._justUp)
	    {
	        key._justUp = false;
	
	        return true;
	    }
	    else
	    {
	        return false;
	    }
	};
	
	module.exports = JustUp;


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var KeyCodes = __webpack_require__(301);
	
	var KeyMap = {};
	
	for (var key in KeyCodes)
	{
	    KeyMap[KeyCodes[key]] = key;
	}
	
	module.exports = KeyMap;


/***/ }),
/* 1322 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Used internally by the KeyboardManager.
	 *
	 * @function Phaser.Input.Keyboard.ProcessKeyDown
	 * @since 3.0.0
	 *
	 * @param {Phaser.Input.Keyboard.Key} key - [description]
	 * @param {KeyboardEvent} event - [description]
	 *
	 * @return {Phaser.Input.Keyboard.Key} [description]
	 */
	var ProcessKeyDown = function (key, event)
	{
	    key.originalEvent = event;
	
	    if (key.preventDefault)
	    {
	        event.preventDefault();
	    }
	
	    if (!key.enabled)
	    {
	        return;
	    }
	
	    key.altKey = event.altKey;
	    key.ctrlKey = event.ctrlKey;
	    key.shiftKey = event.shiftKey;
	    key.location = event.location;
	
	    if (key.isDown === false)
	    {
	        key.isDown = true;
	        key.isUp = false;
	        key.timeDown = event.timeStamp;
	        key.duration = 0;
	        key._justDown = true;
	        key._justUp = false;
	    }
	
	    key.repeats++;
	
	    return key;
	};
	
	module.exports = ProcessKeyDown;


/***/ }),
/* 1323 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Used internally by the KeyboardManager.
	 *
	 * @function Phaser.Input.Keyboard.ProcessKeyUp
	 * @since 3.0.0
	 *
	 * @param {Phaser.Input.Keyboard.Key} key - [description]
	 * @param {KeyboardEvent} event - [description]
	 *
	 * @return {Phaser.Input.Keyboard.Key} [description]
	 */
	var ProcessKeyUp = function (key, event)
	{
	    key.originalEvent = event;
	
	    if (key.preventDefault)
	    {
	        event.preventDefault();
	    }
	
	    if (!key.enabled)
	    {
	        return;
	    }
	
	    key.isDown = false;
	    key.isUp = true;
	    key.timeUp = event.timeStamp;
	    key.duration = key.timeUp - key.timeDown;
	    key.repeats = 0;
	
	    key._justDown = false;
	    key._justUp = true;
	
	    return key;
	};
	
	module.exports = ProcessKeyUp;


/***/ }),
/* 1324 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Returns `true` if the Key was released within the `duration` value given, or `false` if it either isn't up,
	 * or was released longer ago than then given duration.
	 *
	 * @function Phaser.Input.Keyboard.UpDuration
	 * @since 3.0.0
	 *
	 * @param {Phaser.Input.Keyboard.Key} key - [description]
	 * @param {integer} [duration=50] - [description]
	 *
	 * @return {boolean} [description]
	 */
	var UpDuration = function (key, duration)
	{
	    if (duration === undefined) { duration = 50; }
	
	    return (key.isUp && key.duration < duration);
	};
	
	module.exports = UpDuration;


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Input.Mouse
	 */
	
	/* eslint-disable */
	module.exports = {
	
	    MouseManager: __webpack_require__(542)
	       
	};
	/* eslint-enable */


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Input.Touch
	 */
	
	/* eslint-disable */
	module.exports = {
	
	    TouchManager: __webpack_require__(543)
	       
	};
	/* eslint-enable */


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(35);
	var CustomSet = __webpack_require__(146);
	var EventEmitter = __webpack_require__(22);
	var FileTypesManager = __webpack_require__(15);
	var GetFastValue = __webpack_require__(3);
	var PluginCache = __webpack_require__(29);
	var XHRSettings = __webpack_require__(202);
	
	/**
	 * @classdesc
	 * The Loader handles loading all external content such as Images, Sounds, Texture Atlases and data files.
	 * You typically interact with it via `this.load` in your Scene. Scenes can have a `preload` method, which is always
	 * called before the Scenes `create` method, allowing you to preload assets that the Scene may need.
	 *
	 * If you call any `this.load` methods from outside of `Scene.preload` then you need to start the Loader going
	 * yourself by calling `Loader.start()`. It's only automatically started during the Scene preload.
	 *
	 * The Loader uses a combination of tag loading (eg. Audio elements) and XHR and provides progress and completion events.
	 * Files are loaded in parallel by default. The amount of concurrent connections can be controlled in your Game Configuration.
	 *
	 * Once the Loader has started loading you are still able to add files to it. These can be injected as a result of a loader
	 * event, the type of file being loaded (such as a pack file) or other external events. As long as the Loader hasn't finished
	 * simply adding a new file to it, while running, will ensure it's added into the current queue.
	 *
	 * Every Scene has its own instance of the Loader and they are bound to the Scene in which they are created. However,
	 * assets loaded by the Loader are placed into global game-level caches. For example, loading an XML file will place that
	 * file inside `Game.cache.xml`, which is accessible from every Scene in your game, no matter who was responsible
	 * for loading it. The same is true of Textures. A texture loaded in one Scene is instantly available to all other Scenes
	 * in your game.
	 *
	 * The Loader works by using custom File Types. These are stored in the FileTypesManager, which injects them into the Loader
	 * when it's instantiated. You can create your own custom file types by extending either the File or MultiFile classes.
	 * See those files for more details.
	 *
	 * @class LoaderPlugin
	 * @extends Phaser.Events.EventEmitter
	 * @memberOf Phaser.Loader
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - The Scene which owns this Loader instance.
	 */
	var LoaderPlugin = new Class({
	
	    Extends: EventEmitter,
	
	    initialize:
	
	    function LoaderPlugin (scene)
	    {
	        EventEmitter.call(this);
	
	        var gameConfig = scene.sys.game.config;
	        var sceneConfig = scene.sys.settings.loader;
	
	        /**
	         * The Scene which owns this Loader instance.
	         *
	         * @name Phaser.Loader.LoaderPlugin#scene
	         * @type {Phaser.Scene}
	         * @protected
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * A reference to the Scene Systems.
	         *
	         * @name Phaser.Loader.LoaderPlugin#systems
	         * @type {Phaser.Scenes.Systems}
	         * @protected
	         * @since 3.0.0
	         */
	        this.systems = scene.sys;
	
	        /**
	         * A reference to the global Cache Manager.
	         *
	         * @name Phaser.Loader.LoaderPlugin#cacheManager
	         * @type {Phaser.Cache.CacheManager}
	         * @protected
	         * @since 3.7.0
	         */
	        this.cacheManager = scene.sys.cache;
	
	        /**
	         * A reference to the global Texture Manager.
	         *
	         * @name Phaser.Loader.LoaderPlugin#textureManager
	         * @type {Phaser.Textures.TextureManager}
	         * @protected
	         * @since 3.7.0
	         */
	        this.textureManager = scene.sys.textures;
	
	        //  Inject the available filetypes into the Loader
	        FileTypesManager.install(this);
	
	        /**
	         * An optional prefix that is automatically prepended to the start of every file key.
	         * If prefix was `MENU.` and you load an image with the key 'Background' the resulting key would be `MENU.Background`.
	         * You can set this directly, or call `Loader.setPrefix()`. It will then affect every file added to the Loader
	         * from that point on. It does _not_ change any file already in the load queue.
	         *
	         * @name Phaser.Loader.LoaderPlugin#prefix
	         * @type {string}
	         * @default ''
	         * @since 3.7.0
	         */
	        this.prefix = '';
	
	        /**
	         * The value of `path`, if set, is placed before any _relative_ file path given. For example:
	         *
	         * ```javascript
	         * this.load.path = "images/sprites/";
	         * this.load.image("ball", "ball.png");
	         * this.load.image("tree", "level1/oaktree.png");
	         * this.load.image("boom", "http://server.com/explode.png");
	         * ```
	         *
	         * Would load the `ball` file from `images/sprites/ball.png` and the tree from
	         * `images/sprites/level1/oaktree.png` but the file `boom` would load from the URL
	         * given as it's an absolute URL.
	         *
	         * Please note that the path is added before the filename but *after* the baseURL (if set.)
	         *
	         * If you set this property directly then it _must_ end with a "/". Alternatively, call `setPath()` and it'll do it for you.
	         *
	         * @name Phaser.Loader.LoaderPlugin#path
	         * @type {string}
	         * @default ''
	         * @since 3.0.0
	         */
	        this.path = '';
	
	        /**
	         * If you want to append a URL before the path of any asset you can set this here.
	         * 
	         * Useful if allowing the asset base url to be configured outside of the game code.
	         * 
	         * If you set this property directly then it _must_ end with a "/". Alternatively, call `setBaseURL()` and it'll do it for you.
	         *
	         * @name Phaser.Loader.LoaderPlugin#baseURL
	         * @type {string}
	         * @default ''
	         * @since 3.0.0
	         */
	        this.baseURL = '';
	
	        this.setBaseURL(GetFastValue(sceneConfig, 'baseURL', gameConfig.loaderBaseURL));
	
	        this.setPath(GetFastValue(sceneConfig, 'path', gameConfig.loaderPath));
	
	        this.setPrefix(GetFastValue(sceneConfig, 'prefix', gameConfig.loaderPrefix));
	
	        /**
	         * The number of concurrent / parallel resources to try and fetch at once.
	         *
	         * Old browsers limit 6 requests per domain; modern ones, especially those with HTTP/2 don't limit it at all.
	         *
	         * The default is 32 but you can change this in your Game Config, or by changing this property before the Loader starts.
	         *
	         * @name Phaser.Loader.LoaderPlugin#maxParallelDownloads
	         * @type {integer}
	         * @since 3.0.0
	         */
	        this.maxParallelDownloads = GetFastValue(sceneConfig, 'maxParallelDownloads', gameConfig.loaderMaxParallelDownloads);
	
	        /**
	         * xhr specific global settings (can be overridden on a per-file basis)
	         *
	         * @name Phaser.Loader.LoaderPlugin#xhr
	         * @type {XHRSettingsObject}
	         * @since 3.0.0
	         */
	        this.xhr = XHRSettings(
	            GetFastValue(sceneConfig, 'responseType', gameConfig.loaderResponseType),
	            GetFastValue(sceneConfig, 'async', gameConfig.loaderAsync),
	            GetFastValue(sceneConfig, 'user', gameConfig.loaderUser),
	            GetFastValue(sceneConfig, 'password', gameConfig.loaderPassword),
	            GetFastValue(sceneConfig, 'timeout', gameConfig.loaderTimeout)
	        );
	
	        /**
	         * The crossOrigin value applied to loaded images. Very often this needs to be set to 'anonymous'.
	         *
	         * @name Phaser.Loader.LoaderPlugin#crossOrigin
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.crossOrigin = GetFastValue(sceneConfig, 'crossOrigin', gameConfig.loaderCrossOrigin);
	
	        /**
	         * The total number of files to load. It may not always be accurate because you may add to the Loader during the process
	         * of loading, especially if you load a Pack File. Therefore this value can change, but in most cases remains static.
	         *
	         * @name Phaser.Loader.LoaderPlugin#totalToLoad
	         * @type {integer}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.totalToLoad = 0;
	
	        /**
	         * The progress of the current load queue, as a float value between 0 and 1.
	         * This is updated automatically as files complete loading.
	         * Note that it is possible for this value to go down again if you add content to the current load queue during a load.
	         *
	         * @name Phaser.Loader.LoaderPlugin#progress
	         * @type {float}
	         * @default 0
	         * @since 3.0.0
	         */
	        this.progress = 0;
	
	        /**
	         * Files are placed in this Set when they're added to the Loader via `addFile`.
	         * 
	         * They are moved to the `inflight` Set when they start loading, and assuming a successful
	         * load, to the `queue` Set for further processing.
	         *
	         * By the end of the load process this Set will be empty.
	         *
	         * @name Phaser.Loader.LoaderPlugin#list
	         * @type {Phaser.Structs.Set.<Phaser.Loader.File>}
	         * @since 3.0.0
	         */
	        this.list = new CustomSet();
	
	        /**
	         * Files are stored in this Set while they're in the process of being loaded.
	         * 
	         * Upon a successful load they are moved to the `queue` Set.
	         * 
	         * By the end of the load process this Set will be empty.
	         *
	         * @name Phaser.Loader.LoaderPlugin#inflight
	         * @type {Phaser.Structs.Set.<Phaser.Loader.File>}
	         * @since 3.0.0
	         */
	        this.inflight = new CustomSet();
	
	        /**
	         * Files are stored in this Set while they're being processed.
	         * 
	         * If the process is successful they are moved to their final destination, which could be
	         * a Cache or the Texture Manager.
	         * 
	         * At the end of the load process this Set will be empty.
	         *
	         * @name Phaser.Loader.LoaderPlugin#queue
	         * @type {Phaser.Structs.Set.<Phaser.Loader.File>}
	         * @since 3.0.0
	         */
	        this.queue = new CustomSet();
	
	        /**
	         * A temporary Set in which files are stored after processing,
	         * awaiting destruction at the end of the load process.
	         *
	         * @name Phaser.Loader.LoaderPlugin#_deleteQueue
	         * @type {Phaser.Structs.Set.<Phaser.Loader.File>}
	         * @private
	         * @since 3.7.0
	         */
	        this._deleteQueue = new CustomSet();
	
	        /**
	         * The total number of files that failed to load during the most recent load.
	         * This value is reset when you call `Loader.start`.
	         *
	         * @name Phaser.Loader.LoaderPlugin#totalFailed
	         * @type {integer}
	         * @default 0
	         * @since 3.7.0
	         */
	        this.totalFailed = 0;
	
	        /**
	         * The total number of files that successfully loaded during the most recent load.
	         * This value is reset when you call `Loader.start`.
	         *
	         * @name Phaser.Loader.LoaderPlugin#totalComplete
	         * @type {integer}
	         * @default 0
	         * @since 3.7.0
	         */
	        this.totalComplete = 0;
	
	        /**
	         * The current state of the Loader.
	         *
	         * @name Phaser.Loader.LoaderPlugin#state
	         * @type {integer}
	         * @readOnly
	         * @since 3.0.0
	         */
	        this.state = CONST.LOADER_IDLE;
	
	        scene.sys.events.once('boot', this.boot, this);
	        scene.sys.events.on('start', this.pluginStart, this);
	    },
	
	    /**
	     * This method is called automatically, only once, when the Scene is first created.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.Loader.LoaderPlugin#boot
	     * @private
	     * @since 3.5.1
	     */
	    boot: function ()
	    {
	        this.systems.events.once('destroy', this.destroy, this);
	    },
	
	    /**
	     * This method is called automatically by the Scene when it is starting up.
	     * It is responsible for creating local systems, properties and listening for Scene events.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.Loader.LoaderPlugin#pluginStart
	     * @private
	     * @since 3.5.1
	     */
	    pluginStart: function ()
	    {
	        this.systems.events.once('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * If you want to append a URL before the path of any asset you can set this here.
	     * 
	     * Useful if allowing the asset base url to be configured outside of the game code.
	     * 
	     * Once a base URL is set it will affect every file loaded by the Loader from that point on. It does _not_ change any
	     * file _already_ being loaded. To reset it, call this method with no arguments.
	     *
	     * @method Phaser.Loader.LoaderPlugin#setBaseURL
	     * @since 3.0.0
	     *
	     * @param {string} [url] - The URL to use. Leave empty to reset.
	     *
	     * @return {Phaser.Loader.LoaderPlugin} This Loader object.
	     */
	    setBaseURL: function (url)
	    {
	        if (url === undefined) { url = ''; }
	
	        if (url !== '' && url.substr(-1) !== '/')
	        {
	            url = url.concat('/');
	        }
	
	        this.baseURL = url;
	
	        return this;
	    },
	
	    /**
	     * The value of `path`, if set, is placed before any _relative_ file path given. For example:
	     *
	     * ```javascript
	     * this.load.setPath("images/sprites/");
	     * this.load.image("ball", "ball.png");
	     * this.load.image("tree", "level1/oaktree.png");
	     * this.load.image("boom", "http://server.com/explode.png");
	     * ```
	     *
	     * Would load the `ball` file from `images/sprites/ball.png` and the tree from
	     * `images/sprites/level1/oaktree.png` but the file `boom` would load from the URL
	     * given as it's an absolute URL.
	     *
	     * Please note that the path is added before the filename but *after* the baseURL (if set.)
	     * 
	     * Once a path is set it will then affect every file added to the Loader from that point on. It does _not_ change any
	     * file _already_ in the load queue. To reset it, call this method with no arguments.
	     *
	     * @method Phaser.Loader.LoaderPlugin#setPath
	     * @since 3.0.0
	     *
	     * @param {string} [path] - The path to use. Leave empty to reset.
	     *
	     * @return {Phaser.Loader.LoaderPlugin} This Loader object.
	     */
	    setPath: function (path)
	    {
	        if (path === undefined) { path = ''; }
	
	        if (path !== '' && path.substr(-1) !== '/')
	        {
	            path = path.concat('/');
	        }
	
	        this.path = path;
	
	        return this;
	    },
	
	    /**
	     * An optional prefix that is automatically prepended to the start of every file key.
	     * 
	     * If prefix was `MENU.` and you load an image with the key 'Background' the resulting key would be `MENU.Background`.
	     * 
	     * Once a prefix is set it will then affect every file added to the Loader from that point on. It does _not_ change any
	     * file _already_ in the load queue. To reset it, call this method with no arguments.
	     *
	     * @method Phaser.Loader.LoaderPlugin#setPrefix
	     * @since 3.7.0
	     *
	     * @param {string} [prefix] - The prefix to use. Leave empty to reset.
	     *
	     * @return {Phaser.Loader.LoaderPlugin} This Loader object.
	     */
	    setPrefix: function (prefix)
	    {
	        if (prefix === undefined) { prefix = ''; }
	
	        this.prefix = prefix;
	
	        return this;
	    },
	
	    /**
	     * Sets the Cross Origin Resource Sharing value used when loading files.
	     * 
	     * Files can override this value on a per-file basis by specifying an alternative `crossOrigin` value in their file config.
	     * 
	     * Once CORs is set it will then affect every file loaded by the Loader from that point on, as long as they don't have
	     * their own CORs setting. To reset it, call this method with no arguments.
	     *
	     * For more details about CORs see https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS
	     *
	     * @method Phaser.Loader.LoaderPlugin#setCORS
	     * @since 3.0.0
	     *
	     * @param {string} [crossOrigin] - The value to use for the `crossOrigin` property in the load request.
	     *
	     * @return {Phaser.Loader.LoaderPlugin} This Loader object.
	     */
	    setCORS: function (crossOrigin)
	    {
	        this.crossOrigin = crossOrigin;
	
	        return this;
	    },
	
	    /**
	     * This event is fired when a Loader successfully begins to load its queue.
	     * 
	     * @event Phaser.Loader.LoaderPlugin#addFileEvent
	     * @param {string} key - The key of the file that was added.
	     * @param {string} type - The type of the file that was added.
	     * @param {Phaser.Loader.LoaderPlugin} loader - The Loader that had the file added to it.
	     * @param {Phaser.Loader.File} loader - The File object that was added to the Loader.
	     */
	
	    /**
	     * Adds a file, or array of files, into the load queue.
	     *
	     * The file must be an instance of `Phaser.Loader.File`, or a class that extends it. The Loader will check that the key
	     * used by the file won't conflict with any other key either in the loader, the inflight queue or the target cache.
	     * If allowed it will then add the file into the pending list, read for the load to start. Or, if the load has already
	     * started, ready for the next batch of files to be pulled from the list to the inflight queue.
	     *
	     * You should not normally call this method directly, but rather use one of the Loader methods like `image` or `atlas`,
	     * however you can call this as long as the file given to it is well formed.
	     *
	     * @method Phaser.Loader.LoaderPlugin#addFile
	     * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	     * @since 3.0.0
	     *
	     * @param {(Phaser.Loader.File|Phaser.Loader.File[])} file - The file, or array of files, to be added to the load queue.
	     */
	    addFile: function (file)
	    {
	        if (!Array.isArray(file))
	        {
	            file = [ file ];
	        }
	
	        for (var i = 0; i < file.length; i++)
	        {
	            var item = file[i];
	
	            //  Does the file already exist in the cache or texture manager?
	            //  Or will it conflict with a file already in the queue or inflight?
	            if (!this.keyExists(item))
	            {
	                this.list.set(item);
	
	                this.emit('addfile', item.key, item.type, this, item);
	
	                if (this.isLoading())
	                {
	                    this.totalToLoad++;
	                    this.updateProgress();
	                }
	            }
	        }
	    },
	
	    /**
	     * Checks the key and type of the given file to see if it will conflict with anything already
	     * in a Cache, the Texture Manager, or the list or inflight queues.
	     *
	     * @method Phaser.Loader.LoaderPlugin#keyExists
	     * @since 3.7.0
	     *
	     * @param {Phaser.Loader.File} file - The file to check the key of.
	     *
	     * @return {boolean} `true` if adding this file will cause a cache or queue conflict, otherwise `false`.
	     */
	    keyExists: function (file)
	    {
	        var keyConflict = file.hasCacheConflict();
	
	        if (!keyConflict)
	        {
	            this.list.iterate(function (item)
	            {
	                if (item.type === file.type && item.key === file.key)
	                {
	                    keyConflict = true;
	
	                    return false;
	                }
	
	            });
	        }
	
	        if (!keyConflict && this.isLoading())
	        {
	            this.inflight.iterate(function (item)
	            {
	                if (item.type === file.type && item.key === file.key)
	                {
	                    keyConflict = true;
	
	                    return false;
	                }
	
	            });
	
	            this.queue.iterate(function (item)
	            {
	                if (item.type === file.type && item.key === file.key)
	                {
	                    keyConflict = true;
	
	                    return false;
	                }
	
	            });
	        }
	
	        return keyConflict;
	    },
	
	    /**
	     * Takes a well formed, fully parsed pack file object and adds its entries into the load queue. Usually you do not call
	     * this method directly, but instead use `Loader.pack` and supply a path to a JSON file that holds the
	     * pack data. However, if you've got the data prepared you can pass it to this method.
	     *
	     * You can also provide an optional key. If you do then it will only add the entries from that part of the pack into
	     * to the load queue. If not specified it will add all entries it finds. For more details about the pack file format
	     * see the `LoaderPlugin.pack` method.
	     *
	     * @method Phaser.Loader.LoaderPlugin#addPack
	     * @since 3.7.0
	     *
	     * @param {any} data - The Pack File data to be parsed and each entry of it to added to the load queue.
	     * @param {string} [packKey] - An optional key to use from the pack file data.
	     *
	     * @return {boolean} `true` if any files were added to the queue, otherwise `false`.
	     */
	    addPack: function (pack, packKey)
	    {
	        //  if no packKey provided we'll add everything to the queue
	        if (packKey && pack.hasOwnProperty(packKey))
	        {
	            pack = { packKey: pack[packKey] };
	        }
	
	        var total = 0;
	
	        //  Store the loader settings in case this pack replaces them
	        var currentBaseURL = this.baseURL;
	        var currentPath = this.path;
	        var currentPrefix = this.prefix;
	
	        //  Here we go ...
	        for (var key in pack)
	        {
	            var config = pack[key];
	
	            //  Any meta data to process?
	            var baseURL = GetFastValue(config, 'baseURL', currentBaseURL);
	            var path = GetFastValue(config, 'path', currentPath);
	            var prefix = GetFastValue(config, 'prefix', currentPrefix);
	            var files = GetFastValue(config, 'files', null);
	            var defaultType = GetFastValue(config, 'defaultType', 'void');
	
	            if (Array.isArray(files))
	            {
	                this.setBaseURL(baseURL);
	                this.setPath(path);
	                this.setPrefix(prefix);
	
	                for (var i = 0; i < files.length; i++)
	                {
	                    var file = files[i];
	                    var type = (file.hasOwnProperty('type')) ? file.type : defaultType;
	
	                    if (this[type])
	                    {
	                        this[type](file);
	                        total++;
	                    }
	                }
	            }
	        }
	
	        //  Reset the loader settings
	        this.setBaseURL(currentBaseURL);
	        this.setPath(currentPath);
	        this.setPrefix(currentPrefix);
	
	        return (total > 0);
	    },
	
	    /**
	     * Is the Loader actively loading, or processing loaded files?
	     *
	     * @method Phaser.Loader.LoaderPlugin#isLoading
	     * @since 3.0.0
	     *
	     * @return {boolean} `true` if the Loader is busy loading or processing, otherwise `false`.
	     */
	    isLoading: function ()
	    {
	        return (this.state === CONST.LOADER_LOADING || this.state === CONST.LOADER_PROCESSING);
	    },
	
	    /**
	     * Is the Loader ready to start a new load?
	     *
	     * @method Phaser.Loader.LoaderPlugin#isReady
	     * @since 3.0.0
	     *
	     * @return {boolean} `true` if the Loader is ready to start a new load, otherwise `false`.
	     */
	    isReady: function ()
	    {
	        return (this.state === CONST.LOADER_IDLE || this.state === CONST.LOADER_COMPLETE);
	    },
	
	    /**
	     * This event is fired when a Loader successfully begins to load its queue.
	     * 
	     * @event Phaser.Loader.LoaderPlugin#startEvent
	     * @param {Phaser.Loader.LoaderPlugin} loader - The Loader instance that started.
	     */
	
	    /**
	     * Starts the Loader running. This will reset the progress and totals and then emit a `start` event.
	     * If there is nothing in the queue the Loader will immediately complete, otherwise it will start
	     * loading the first batch of files.
	     *
	     * The Loader is started automatically if the queue is populated within your Scenes `preload` method.
	     *
	     * However, outside of this, you need to call this method to start it.
	     *
	     * If the Loader is already running this method will simply return.
	     *
	     * @method Phaser.Loader.LoaderPlugin#start
	     * @fires Phaser.Loader.LoaderPlugin#startEvent
	     * @since 3.0.0
	     */
	    start: function ()
	    {
	        if (!this.isReady())
	        {
	            return;
	        }
	
	        this.progress = 0;
	
	        this.totalFailed = 0;
	        this.totalComplete = 0;
	        this.totalToLoad = this.list.size;
	
	        this.emit('start', this);
	
	        if (this.list.size === 0)
	        {
	            this.loadComplete();
	        }
	        else
	        {
	            this.state = CONST.LOADER_LOADING;
	
	            this.inflight.clear();
	            this.queue.clear();
	
	            this.updateProgress();
	
	            this.checkLoadQueue();
	        }
	    },
	
	    /**
	     * This event is fired when the Loader updates its progress, typically as a result of
	     * a file having completed loading.
	     * 
	     * @event Phaser.Loader.LoaderPlugin#progressEvent
	     * @param {float} progress - The current progress of the load. A value between 0 and 1.
	     */
	
	    /**
	     * Called automatically during the load process.
	     * It updates the `progress` value and then emits a progress event, which you can use to
	     * display a loading bar in your game.
	     *
	     * @method Phaser.Loader.LoaderPlugin#updateProgress
	     * @fires Phaser.Loader.LoaderPlugin#progressEvent
	     * @since 3.0.0
	     */
	    updateProgress: function ()
	    {
	        this.progress = 1 - ((this.list.size + this.inflight.size) / this.totalToLoad);
	
	        this.emit('progress', this.progress);
	    },
	
	    /**
	     * An internal method called by the Loader.
	     * 
	     * It will check to see if there are any more files in the pending list that need loading, and if so it will move
	     * them from the list Set into the inflight Set, set their CORs flag and start them loading.
	     * 
	     * It will carrying on doing this for each file in the pending list until it runs out, or hits the max allowed parallel downloads.
	     *
	     * @method Phaser.Loader.LoaderPlugin#checkLoadQueue
	     * @private
	     * @since 3.7.0
	     */
	    checkLoadQueue: function ()
	    {
	        this.list.each(function (file)
	        {
	            if (file.state === CONST.FILE_POPULATED || (file.state === CONST.FILE_PENDING && this.inflight.size < this.maxParallelDownloads))
	            {
	                this.inflight.set(file);
	
	                this.list.delete(file);
	
	                //  If the file doesn't have its own crossOrigin set,
	                //  we'll use the Loaders (which is undefined by default)
	                if (!file.crossOrigin)
	                {
	                    file.crossOrigin = this.crossOrigin;
	                }
	
	                file.load();
	            }
	
	            if (this.inflight.size === this.maxParallelDownloads)
	            {
	                //  Tells the Set iterator to abort
	                return false;
	            }
	
	        }, this);
	    },
	
	    /**
	     * This event is fired when the a file successfully completes loading, _before_ it is processed.
	     * 
	     * @event Phaser.Loader.LoaderPlugin#loadEvent
	     * @param {Phaser.Loader.File} file - The file that has completed loading.
	     */
	
	    /**
	     * This event is fired when the a file errors during load.
	     * 
	     * @event Phaser.Loader.LoaderPlugin#loadErrorEvent
	     * @param {Phaser.Loader.File} file - The file that has failed to load.
	     */
	
	    /**
	     * An internal method called automatically by the XHRLoader belong to a File.
	     * 
	     * This method will remove the given file from the inflight Set and update the load progress.
	     * If the file was successful its `onProcess` method is called, otherwise it is added to the delete queue.
	     *
	     * @method Phaser.Loader.LoaderPlugin#nextFile
	     * @fires Phaser.Loader.LoaderPlugin#loadEvent
	     * @fires Phaser.Loader.LoaderPlugin#loadErrorEvent
	     * @since 3.0.0
	     *
	     * @param {Phaser.Loader.File} file - The File that just finished loading, or errored during load.
	     * @param {boolean} success - `true` if the file loaded successfully, otherwise `false`.
	     */
	    nextFile: function (file, success)
	    {
	        this.inflight.delete(file);
	
	        this.updateProgress();
	
	        if (success)
	        {
	            this.totalComplete++;
	
	            this.queue.set(file);
	
	            this.emit('load', file);
	
	            file.onProcess();
	        }
	        else
	        {
	            this.totalFailed++;
	
	            this._deleteQueue.set(file);
	
	            this.emit('loaderror', file);
	        }
	
	        if (this.list.size > 0)
	        {
	            this.checkLoadQueue();
	        }
	    },
	
	    /**
	     * An internal method that is called automatically by the File when it has finished processing.
	     *
	     * If the process was successful, and the File isn't part of a MultiFile, its `addToCache` method is called.
	     *
	     * It this then removed from the queue. If there are more files to load, `checkLoadQueue` is called, otherwise `loadComplete` is.
	     *
	     * @method Phaser.Loader.LoaderPlugin#fileProcessComplete
	     * @since 3.7.0
	     *
	     * @param {Phaser.Loader.File} file - The file that has finished processing.
	     */
	    fileProcessComplete: function (file)
	    {
	        //  This file has failed, so move it to the failed Set
	        if (file.state === CONST.FILE_ERRORED)
	        {
	            if (file.multiFile)
	            {
	                file.multiFile.onFileFailed(file);
	            }
	        }
	        else if (file.state === CONST.FILE_COMPLETE)
	        {
	            if (file.multiFile)
	            {
	                if (file.multiFile.isReadyToProcess())
	                {
	                    //  If we got here then all files the link file needs are ready to add to the cache
	                    file.multiFile.addToCache();
	                }
	            }
	            else
	            {
	                //  If we got here, then the file processed, so let it add itself to its cache
	                file.addToCache();
	            }
	        }
	
	        //  Remove it from the queue
	        this.queue.delete(file);
	
	        //  Nothing left to do?
	        if (this.list.size === 0 && this.inflight.size === 0 && this.queue.size === 0)
	        {
	            this.loadComplete();
	        }
	        else
	        {
	            //  In case we've added to the list by processing this file
	            this.checkLoadQueue();
	        }
	    },
	
	    /**
	     * This event is fired when the Loader has finished loading everything and the queue is empty.
	     * By this point every loaded file will now be in its associated cache and ready for use.
	     * 
	     * @event Phaser.Loader.LoaderPlugin#completeEvent
	     * @param {Phaser.Loader.File} file - The file that has failed to load.
	     */
	
	    /**
	     * Called at the end when the load queue is exhausted and all files have either loaded or errored.
	     * By this point every loaded file will now be in its associated cache and ready for use.
	     *
	     * Also clears down the Sets, puts progress to 1 and clears the deletion queue.
	     *
	     * @method Phaser.Loader.LoaderPlugin#loadComplete
	     * @fires Phaser.Loader.LoaderPlugin#completeEvent
	     * @since 3.7.0
	     */
	    loadComplete: function ()
	    {
	        this.emit('loadcomplete', this);
	
	        this.list.clear();
	        this.inflight.clear();
	        this.queue.clear();
	
	        this.progress = 1;
	
	        this.state = CONST.LOADER_COMPLETE;
	
	        //  Call 'destroy' on each file ready for deletion
	        this._deleteQueue.iterateLocal('destroy');
	
	        this._deleteQueue.clear();
	
	        this.emit('complete', this, this.totalComplete, this.totalFailed);
	    },
	
	    /**
	     * Adds a File into the pending-deletion queue.
	     *
	     * @method Phaser.Loader.LoaderPlugin#flagForRemoval
	     * @since 3.7.0
	     * 
	     * @param {Phaser.Loader.File} file - The File to be queued for deletion when the Loader completes.
	     */
	    flagForRemoval: function (file)
	    {
	        this._deleteQueue.set(file);
	    },
	
	    /**
	     * Converts the given JSON data into a file that the browser then prompts you to download so you can save it locally.
	     *
	     * The data must be well formed JSON and ready-parsed, not a JavaScript object.
	     *
	     * @method Phaser.Loader.LoaderPlugin#saveJSON
	     * @since 3.0.0
	     *
	     * @param {*} data - The JSON data, ready parsed.
	     * @param {string} [filename=file.json] - The name to save the JSON file as.
	     *
	     * @return {Phaser.Loader.LoaderPlugin} This Loader plugin.
	     */
	    saveJSON: function (data, filename)
	    {
	        return this.save(JSON.stringify(data), filename);
	    },
	
	    /**
	     * Causes the browser to save the given data as a file to its default Downloads folder.
	     * 
	     * Creates a DOM level anchor link, assigns it as being a `download` anchor, sets the href
	     * to be an ObjectURL based on the given data, and then invokes a click event.
	     *
	     * @method Phaser.Loader.LoaderPlugin#save
	     * @since 3.0.0
	     *
	     * @param {*} data - The data to be saved. Will be passed through URL.createObjectURL.
	     * @param {string} [filename=file.json] - The filename to save the file as.
	     * @param {string} [filetype=application/json] - The file type to use when saving the file. Defaults to JSON.
	     *
	     * @return {Phaser.Loader.LoaderPlugin} This Loader plugin.
	     */
	    save: function (data, filename, filetype)
	    {
	        if (filename === undefined) { filename = 'file.json'; }
	        if (filetype === undefined) { filetype = 'application/json'; }
	
	        var blob = new Blob([ data ], { type: filetype });
	
	        var url = URL.createObjectURL(blob);
	
	        var a = document.createElement('a');
	
	        a.download = filename;
	        a.textContent = 'Download ' + filename;
	        a.href = url;
	        a.click();
	
	        return this;
	    },
	
	    /**
	     * Resets the Loader.
	     *
	     * This will clear all lists and reset the base URL, path and prefix.
	     *
	     * Warning: If the Loader is currently downloading files, or has files in its queue, they will be aborted.
	     *
	     * @method Phaser.Loader.LoaderPlugin#reset
	     * @since 3.0.0
	     */
	    reset: function ()
	    {
	        this.list.clear();
	        this.inflight.clear();
	        this.queue.clear();
	
	        var gameConfig = this.systems.game.config;
	        var sceneConfig = this.systems.settings.loader;
	
	        this.setBaseURL(GetFastValue(sceneConfig, 'baseURL', gameConfig.loaderBaseURL));
	        this.setPath(GetFastValue(sceneConfig, 'path', gameConfig.loaderPath));
	        this.setPrefix(GetFastValue(sceneConfig, 'prefix', gameConfig.loaderPrefix));
	
	        this.state = CONST.LOADER_IDLE;
	    },
	
	    /**
	     * The Scene that owns this plugin is shutting down.
	     * We need to kill and reset all internal properties as well as stop listening to Scene events.
	     *
	     * @method Phaser.Loader.LoaderPlugin#shutdown
	     * @private
	     * @since 3.0.0
	     */
	    shutdown: function ()
	    {
	        this.reset();
	
	        this.state = CONST.LOADER_SHUTDOWN;
	
	        this.systems.events.off('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * The Scene that owns this plugin is being destroyed.
	     * We need to shutdown and then kill off all external references.
	     *
	     * @method Phaser.Loader.LoaderPlugin#destroy
	     * @private
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.shutdown();
	
	        this.state = CONST.LOADER_DESTROYED;
	
	        this.systems.events.off('start', this.pluginStart, this);
	
	        this.list = null;
	        this.inflight = null;
	        this.queue = null;
	
	        this.scene = null;
	        this.systems = null;
	        this.textureManager = null;
	        this.cacheManager = null;
	    }
	
	});
	
	PluginCache.register('Loader', LoaderPlugin, 'load');
	
	module.exports = LoaderPlugin;


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var FileTypesManager = __webpack_require__(15);
	var JSONFile = __webpack_require__(96);
	
	/**
	 * @classdesc
	 * A single Animation JSON File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#animation method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#animation.
	 *
	 * @class AnimationJSONFile
	 * @extends Phaser.Loader.File
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.JSONFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
	 * @param {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 * @param {string} [dataKey] - When the JSON file loads only this property will be stored in the Cache.
	 */
	var AnimationJSONFile = new Class({
	
	    Extends: JSONFile,
	
	    initialize:
	
	    //  url can either be a string, in which case it is treated like a proper url, or an object, in which case it is treated as a ready-made JS Object
	    //  dataKey allows you to pluck a specific object out of the JSON and put just that into the cache, rather than the whole thing
	
	    function AnimationJSONFile (loader, key, url, xhrSettings, dataKey)
	    {
	        JSONFile.call(this, loader, key, url, xhrSettings, dataKey);
	
	        this.type = 'animationJSON';
	    },
	
	    /**
	     * Called automatically by Loader.nextFile.
	     * This method controls what extra work this File does with its loaded data.
	     *
	     * @method Phaser.Loader.FileTypes.AnimationJSONFile#onProcess
	     * @since 3.7.0
	     */
	    onProcess: function ()
	    {
	        //  We need to hook into this event:
	        this.loader.once('loadcomplete', this.onLoadComplete, this);
	
	        //  But the rest is the same as a normal JSON file
	        JSONFile.prototype.onProcess.call(this);
	    },
	
	    /**
	     * Called at the end of the load process, after the Loader has finished all files in its queue.
	     *
	     * @method Phaser.Loader.FileTypes.AnimationJSONFile#onLoadComplete
	     * @since 3.7.0
	     */
	    onLoadComplete: function ()
	    {
	        this.loader.systems.anims.fromJSON(this.data);
	
	        this.pendingDestroy();
	    }
	
	});
	
	/**
	 * Adds an Animation JSON Data file, or array of Animation JSON files, to the current load queue.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.animation('baddieAnims', 'files/BaddieAnims.json');
	 * }
	 * ```
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 * 
	 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
	 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
	 * 
	 * The key must be a unique String. It is used to add the file to the global JSON Cache upon a successful load.
	 * The key should be unique both in terms of files being loaded and files already present in the JSON Cache.
	 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
	 * then remove it from the JSON Cache first, before loading a new one.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.animation({
	 *     key: 'baddieAnims',
	 *     url: 'files/BaddieAnims.json'
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.JSONFileConfig` for more details.
	 *
	 * Once the file has finished loading it will automatically be passed to the global Animation Managers `fromJSON` method.
	 * This will parse all of the JSON data and create animation data from it. This process happens at the very end
	 * of the Loader, once every other file in the load queue has finished. The reason for this is to allow you to load
	 * both animation data and the images it relies upon in the same load call.
	 *
	 * Once the animation data has been parsed you will be able to play animations using that data.
	 * Please see the Animation Manager `fromJSON` method for more details about the format and playback.
	 * 
	 * You can also access the raw animation data from its Cache using its key:
	 * 
	 * ```javascript
	 * this.load.animation('baddieAnims', 'files/BaddieAnims.json');
	 * // and later in your game ...
	 * var data = this.cache.json.get('baddieAnims');
	 * ```
	 *
	 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
	 * key. For example, if the prefix was `LEVEL1.` and the key was `Waves` the final key will be `LEVEL1.Waves` and
	 * this is what you would use to retrieve the text from the JSON Cache.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "data"
	 * and no URL is given then the Loader will set the URL to be "data.json". It will always add `.json` as the extension, although
	 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
	 *
	 * You can also optionally provide a `dataKey` to use. This allows you to extract only a part of the JSON and store it in the Cache,
	 * rather than the whole file. For example, if your JSON data had a structure like this:
	 * 
	 * ```json
	 * {
	 *     "level1": {
	 *         "baddies": {
	 *             "aliens": {},
	 *             "boss": {}
	 *         }
	 *     },
	 *     "level2": {},
	 *     "level3": {}
	 * }
	 * ```
	 *
	 * And if you only wanted to create animations from the `boss` data, then you could pass `level1.baddies.boss`as the `dataKey`.
	 *
	 * Note: The ability to load this type of file will only be available if the JSON File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#animation
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.0.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.JSONFileConfig|Phaser.Loader.FileTypes.JSONFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
	 * @param {string} [dataKey] - When the Animation JSON file loads only this property will be stored in the Cache and used to create animation data.
	 * @param {XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('animation', function (key, url, dataKey, xhrSettings)
	{
	    //  Supports an Object file definition in the key argument
	    //  Or an array of objects in the key argument
	    //  Or a single entry where all arguments have been defined
	
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            this.addFile(new AnimationJSONFile(this, key[i]));
	        }
	    }
	    else
	    {
	        this.addFile(new AnimationJSONFile(this, key, url, xhrSettings, dataKey));
	    }
	
	    return this;
	});
	
	module.exports = AnimationJSONFile;


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var FileTypesManager = __webpack_require__(15);
	var GetFastValue = __webpack_require__(3);
	var ImageFile = __webpack_require__(115);
	var IsPlainObject = __webpack_require__(17);
	var JSONFile = __webpack_require__(96);
	var MultiFile = __webpack_require__(114);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.AtlasJSONFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within both the Loader and the Texture Manager.
	 * @property {string} [textureURL] - The absolute or relative URL to load the texture image file from.
	 * @property {string} [textureExtension='png'] - The default file extension to use for the image texture if no url is provided.
	 * @property {XHRSettingsObject} [textureXhrSettings] - Extra XHR Settings specifically for the texture image file.
	 * @property {string} [normalMap] - The filename of an associated normal map. It uses the same path and url to load as the texture image.
	 * @property {string} [atlasURL] - The absolute or relative URL to load the atlas json file from. Or a well formed JSON object to use instead.
	 * @property {string} [atlasExtension='json'] - The default file extension to use for the atlas json if no url is provided.
	 * @property {XHRSettingsObject} [atlasXhrSettings] - Extra XHR Settings specifically for the atlas json file.
	 */
	
	/**
	 * @classdesc
	 * A single JSON based Texture Atlas File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#atlas method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#atlas.
	 * 
	 * https://www.codeandweb.com/texturepacker/tutorials/how-to-create-sprite-sheets-for-phaser3?source=photonstorm
	 *
	 * @class AtlasJSONFile
	 * @extends Phaser.Loader.MultiFile
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.AtlasJSONFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
	 * @param {string} [atlasURL] - The absolute or relative URL to load the texture atlas json data file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
	 * @param {XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
	 * @param {XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas json file. Used in replacement of the Loaders default XHR Settings.
	 */
	var AtlasJSONFile = new Class({
	
	    Extends: MultiFile,
	
	    initialize:
	
	    function AtlasJSONFile (loader, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings)
	    {
	        var image;
	        var data;
	
	        if (IsPlainObject(key))
	        {
	            var config = key;
	
	            key = GetFastValue(config, 'key');
	
	            image = new ImageFile(loader, {
	                key: key,
	                url: GetFastValue(config, 'textureURL'),
	                extension: GetFastValue(config, 'textureExtension', 'png'),
	                normalMap: GetFastValue(config, 'normalMap'),
	                xhrSettings: GetFastValue(config, 'textureXhrSettings')
	            });
	
	            data = new JSONFile(loader, {
	                key: key,
	                url: GetFastValue(config, 'atlasURL'),
	                extension: GetFastValue(config, 'atlasExtension', 'json'),
	                xhrSettings: GetFastValue(config, 'atlasXhrSettings')
	            });
	        }
	        else
	        {
	            image = new ImageFile(loader, key, textureURL, textureXhrSettings);
	            data = new JSONFile(loader, key, atlasURL, atlasXhrSettings);
	        }
	
	        if (image.linkFile)
	        {
	            //  Image has a normal map
	            MultiFile.call(this, loader, 'atlasjson', key, [ image, data, image.linkFile ]);
	        }
	        else
	        {
	            MultiFile.call(this, loader, 'atlasjson', key, [ image, data ]);
	        }
	    },
	
	    /**
	     * Adds this file to its target cache upon successful loading and processing.
	     *
	     * @method Phaser.Loader.FileTypes.AtlasJSONFile#addToCache
	     * @since 3.7.0
	     */
	    addToCache: function ()
	    {
	        if (this.isReadyToProcess())
	        {
	            var image = this.files[0];
	            var json = this.files[1];
	            var normalMap = (this.files[2]) ? this.files[2].data : null;
	
	            this.loader.textureManager.addAtlas(image.key, image.data, json.data, normalMap);
	
	            json.addToCache();
	
	            this.complete = true;
	        }
	    }
	
	});
	
	/**
	 * Adds a JSON based Texture Atlas, or array of atlases, to the current load queue.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.atlas('mainmenu', 'images/MainMenu.png', 'images/MainMenu.json');
	 * }
	 * ```
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 * 
	 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
	 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
	 *
	 * Phaser expects the atlas data to be provided in a JSON file, using either the JSON Hash or JSON Array format.
	 * These files are created by software such as Texture Packer, Shoebox and Adobe Flash / Animate.
	 * If you are using Texture Packer and have enabled multi-atlas support, then please use the Phaser Multi Atlas loader
	 * instead of this one.
	 * 
	 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
	 *
	 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
	 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
	 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
	 * then remove it from the Texture Manager first, before loading a new one.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.atlas({
	 *     key: 'mainmenu',
	 *     textureURL: 'images/MainMenu.png',
	 *     atlasURL: 'images/MainMenu.json'
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.AtlasJSONFileConfig` for more details.
	 *
	 * Instead of passing a URL for the atlas JSON data you can also pass in a well formed JSON object instead.
	 *
	 * Once the atlas has finished loading you can use frames from it as textures for a Game Object by referencing its key:
	 * 
	 * ```javascript
	 * this.load.atlas('mainmenu', 'images/MainMenu.png', 'images/MainMenu.json');
	 * // and later in your game ...
	 * this.add.image(x, y, 'mainmenu', 'background');
	 * ```
	 *
	 * To get a list of all available frames within an atlas please consult your Texture Atlas software.
	 *
	 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
	 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
	 * this is what you would use to retrieve the image from the Texture Manager.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
	 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
	 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
	 *
	 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
	 * then you can specify it by providing an array as the `url` where the second element is the normal map:
	 * 
	 * ```javascript
	 * this.load.atlas('mainmenu', [ 'images/MainMenu.png', 'images/MainMenu-n.png' ], 'images/MainMenu.json');
	 * ```
	 *
	 * Or, if you are using a config object use the `normalMap` property:
	 * 
	 * ```javascript
	 * this.load.atlas({
	 *     key: 'mainmenu',
	 *     textureURL: 'images/MainMenu.png',
	 *     normalMap: 'images/MainMenu-n.png',
	 *     atlasURL: 'images/MainMenu.json'
	 * });
	 * ```
	 *
	 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
	 * Normal maps are a WebGL only feature.
	 *
	 * Note: The ability to load this type of file will only be available if the Atlas JSON File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#atlas
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.0.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.AtlasJSONFileConfig|Phaser.Loader.FileTypes.AtlasJSONFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
	 * @param {string} [atlasURL] - The absolute or relative URL to load the texture atlas json data file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
	 * @param {XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
	 * @param {XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas json file. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('atlas', function (key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings)
	{
	    var multifile;
	
	    //  Supports an Object file definition in the key argument
	    //  Or an array of objects in the key argument
	    //  Or a single entry where all arguments have been defined
	
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            multifile = new AtlasJSONFile(this, key[i]);
	
	            this.addFile(multifile.files);
	        }
	    }
	    else
	    {
	        multifile = new AtlasJSONFile(this, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings);
	
	        this.addFile(multifile.files);
	    }
	
	    return this;
	});
	
	module.exports = AtlasJSONFile;


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var FileTypesManager = __webpack_require__(15);
	var GetFastValue = __webpack_require__(3);
	var ImageFile = __webpack_require__(115);
	var IsPlainObject = __webpack_require__(17);
	var MultiFile = __webpack_require__(114);
	var XMLFile = __webpack_require__(304);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.AtlasXMLFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within both the Loader and the Texture Manager.
	 * @property {string} [textureURL] - The absolute or relative URL to load the texture image file from.
	 * @property {string} [textureExtension='png'] - The default file extension to use for the image texture if no url is provided.
	 * @property {XHRSettingsObject} [textureXhrSettings] - Extra XHR Settings specifically for the texture image file.
	 * @property {string} [normalMap] - The filename of an associated normal map. It uses the same path and url to load as the texture image.
	 * @property {string} [atlasURL] - The absolute or relative URL to load the atlas xml file from.
	 * @property {string} [atlasExtension='xml'] - The default file extension to use for the atlas xml if no url is provided.
	 * @property {XHRSettingsObject} [atlasXhrSettings] - Extra XHR Settings specifically for the atlas xml file.
	 */
	
	/**
	 * @classdesc
	 * A single XML based Texture Atlas File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#atlasXML method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#atlasXML.
	 *
	 * @class AtlasXMLFile
	 * @extends Phaser.Loader.MultiFile
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.AtlasXMLFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
	 * @param {string} [atlasURL] - The absolute or relative URL to load the texture atlas xml data file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
	 * @param {XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
	 * @param {XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas xml file. Used in replacement of the Loaders default XHR Settings.
	 */
	var AtlasXMLFile = new Class({
	
	    Extends: MultiFile,
	
	    initialize:
	
	    function AtlasXMLFile (loader, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings)
	    {
	        var image;
	        var data;
	
	        if (IsPlainObject(key))
	        {
	            var config = key;
	
	            key = GetFastValue(config, 'key');
	
	            image = new ImageFile(loader, {
	                key: key,
	                url: GetFastValue(config, 'textureURL'),
	                extension: GetFastValue(config, 'textureExtension', 'png'),
	                normalMap: GetFastValue(config, 'normalMap'),
	                xhrSettings: GetFastValue(config, 'textureXhrSettings')
	            });
	
	            data = new XMLFile(loader, {
	                key: key,
	                url: GetFastValue(config, 'atlasURL'),
	                extension: GetFastValue(config, 'atlasExtension', 'xml'),
	                xhrSettings: GetFastValue(config, 'atlasXhrSettings')
	            });
	        }
	        else
	        {
	            image = new ImageFile(loader, key, textureURL, textureXhrSettings);
	            data = new XMLFile(loader, key, atlasURL, atlasXhrSettings);
	        }
	
	        if (image.linkFile)
	        {
	            //  Image has a normal map
	            MultiFile.call(this, loader, 'atlasxml', key, [ image, data, image.linkFile ]);
	        }
	        else
	        {
	            MultiFile.call(this, loader, 'atlasxml', key, [ image, data ]);
	        }
	    },
	
	    /**
	     * Adds this file to its target cache upon successful loading and processing.
	     *
	     * @method Phaser.Loader.FileTypes.AtlasXMLFile#addToCache
	     * @since 3.7.0
	     */
	    addToCache: function ()
	    {
	        if (this.isReadyToProcess())
	        {
	            var image = this.files[0];
	            var xml = this.files[1];
	            var normalMap = (this.files[2]) ? this.files[2].data : null;
	
	            this.loader.textureManager.addAtlasXML(image.key, image.data, xml.data, normalMap);
	
	            xml.addToCache();
	
	            this.complete = true;
	        }
	    }
	
	});
	
	/**
	 * Adds an XML based Texture Atlas, or array of atlases, to the current load queue.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.atlasXML('mainmenu', 'images/MainMenu.png', 'images/MainMenu.xml');
	 * }
	 * ```
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 * 
	 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
	 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
	 *
	 * Phaser expects the atlas data to be provided in an XML file format.
	 * These files are created by software such as Shoebox and Adobe Flash / Animate.
	 * 
	 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
	 *
	 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
	 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
	 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
	 * then remove it from the Texture Manager first, before loading a new one.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.atlasXML({
	 *     key: 'mainmenu',
	 *     textureURL: 'images/MainMenu.png',
	 *     atlasURL: 'images/MainMenu.xml'
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.AtlasXMLFileConfig` for more details.
	 *
	 * Once the atlas has finished loading you can use frames from it as textures for a Game Object by referencing its key:
	 * 
	 * ```javascript
	 * this.load.atlasXML('mainmenu', 'images/MainMenu.png', 'images/MainMenu.xml');
	 * // and later in your game ...
	 * this.add.image(x, y, 'mainmenu', 'background');
	 * ```
	 *
	 * To get a list of all available frames within an atlas please consult your Texture Atlas software.
	 *
	 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
	 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
	 * this is what you would use to retrieve the image from the Texture Manager.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
	 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
	 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
	 *
	 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
	 * then you can specify it by providing an array as the `url` where the second element is the normal map:
	 * 
	 * ```javascript
	 * this.load.atlasXML('mainmenu', [ 'images/MainMenu.png', 'images/MainMenu-n.png' ], 'images/MainMenu.xml');
	 * ```
	 *
	 * Or, if you are using a config object use the `normalMap` property:
	 * 
	 * ```javascript
	 * this.load.atlasXML({
	 *     key: 'mainmenu',
	 *     textureURL: 'images/MainMenu.png',
	 *     normalMap: 'images/MainMenu-n.png',
	 *     atlasURL: 'images/MainMenu.xml'
	 * });
	 * ```
	 *
	 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
	 * Normal maps are a WebGL only feature.
	 *
	 * Note: The ability to load this type of file will only be available if the Atlas XML File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#atlasXML
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.7.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.AtlasXMLFileConfig|Phaser.Loader.FileTypes.AtlasXMLFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
	 * @param {string} [atlasURL] - The absolute or relative URL to load the texture atlas xml data file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
	 * @param {XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
	 * @param {XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas xml file. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('atlasXML', function (key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings)
	{
	    var multifile;
	
	    //  Supports an Object file definition in the key argument
	    //  Or an array of objects in the key argument
	    //  Or a single entry where all arguments have been defined
	
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            multifile = new AtlasXMLFile(this, key[i]);
	
	            this.addFile(multifile.files);
	        }
	    }
	    else
	    {
	        multifile = new AtlasXMLFile(this, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings);
	
	        this.addFile(multifile.files);
	    }
	
	    return this;
	});
	
	module.exports = AtlasXMLFile;


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var AudioFile = __webpack_require__(545);
	var Class = __webpack_require__(1);
	var FileTypesManager = __webpack_require__(15);
	var GetFastValue = __webpack_require__(3);
	var IsPlainObject = __webpack_require__(17);
	var JSONFile = __webpack_require__(96);
	var MultiFile = __webpack_require__(114);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.AudioSpriteFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within both the Loader and the Audio Cache.
	 * @property {string} jsonURL - The absolute or relative URL to load the json file from. Or a well formed JSON object to use instead.
	 * @property {XHRSettingsObject} [jsonXhrSettings] - Extra XHR Settings specifically for the json file.
	 * @property {string} [audioURL] - The absolute or relative URL to load the audio file from.
	 * @property {any} [audioConfig] - The audio configuration options.
	 * @property {XHRSettingsObject} [audioXhrSettings] - Extra XHR Settings specifically for the audio file.
	 */
	
	/**
	 * @classdesc
	 * An Audio Sprite File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#audioSprite method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#audioSprite.
	 *
	 * @class AudioSpriteFile
	 * @extends Phaser.Loader.MultiFile
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.7.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.AudioSpriteFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string} jsonURL - The absolute or relative URL to load the json file from. Or a well formed JSON object to use instead.
	 * @param {string} [audioURL] - The absolute or relative URL to load the audio file from. If empty it will be obtained by parsing the JSON file.
	 * @param {any} [audioConfig] - The audio configuration options.
	 * @param {XHRSettingsObject} [audioXhrSettings] - An XHR Settings configuration object for the audio file. Used in replacement of the Loaders default XHR Settings.
	 * @param {XHRSettingsObject} [jsonXhrSettings] - An XHR Settings configuration object for the json file. Used in replacement of the Loaders default XHR Settings.
	 */
	var AudioSpriteFile = new Class({
	
	    Extends: MultiFile,
	
	    initialize:
	
	    function AudioSpriteFile (loader, key, jsonURL, audioURL, audioConfig, audioXhrSettings, jsonXhrSettings)
	    {
	        if (IsPlainObject(key))
	        {
	            var config = key;
	
	            key = GetFastValue(config, 'key');
	            jsonURL = GetFastValue(config, 'jsonURL');
	            audioURL = GetFastValue(config, 'audioURL');
	            audioConfig = GetFastValue(config, 'audioConfig');
	            audioXhrSettings = GetFastValue(config, 'audioXhrSettings');
	            jsonXhrSettings = GetFastValue(config, 'jsonXhrSettings');
	        }
	
	        var data;
	
	        //  No url? then we're going to do a json load and parse it from that
	        if (!audioURL)
	        {
	            data = new JSONFile(loader, key, jsonURL, jsonXhrSettings);
	            
	            MultiFile.call(this, loader, 'audiosprite', key, [ data ]);
	
	            this.config.resourceLoad = true;
	            this.config.audioConfig = audioConfig;
	            this.config.audioXhrSettings = audioXhrSettings;
	        }
	        else
	        {
	            var audio = AudioFile.create(loader, key, audioURL, audioConfig, audioXhrSettings);
	
	            if (audio)
	            {
	                data = new JSONFile(loader, key, jsonURL, jsonXhrSettings);
	
	                MultiFile.call(this, loader, 'audiosprite', key, [ audio, data ]);
	
	                this.config.resourceLoad = false;
	            }
	        }
	    },
	
	    /**
	     * Called by each File when it finishes loading.
	     *
	     * @method Phaser.Loader.AudioSpriteFile#onFileComplete
	     * @since 3.7.0
	     *
	     * @param {Phaser.Loader.File} file - The File that has completed processing.
	     */
	    onFileComplete: function (file)
	    {
	        var index = this.files.indexOf(file);
	
	        if (index !== -1)
	        {
	            this.pending--;
	
	            if (this.config.resourceLoad && file.type === 'json' && file.data.hasOwnProperty('resources'))
	            {
	                //  Inspect the data for the files to now load
	                var urls = file.data.resources;
	
	                var audioConfig = GetFastValue(this.config, 'audioConfig');
	                var audioXhrSettings = GetFastValue(this.config, 'audioXhrSettings');
	
	                var audio = AudioFile.create(this.loader, file.key, urls, audioConfig, audioXhrSettings);
	
	                if (audio)
	                {
	                    this.addToMultiFile(audio);
	
	                    this.loader.addFile(audio);
	                }
	            }
	        }
	    },
	
	    /**
	     * Adds this file to its target cache upon successful loading and processing.
	     *
	     * @method Phaser.Loader.AudioSpriteFile#addToCache
	     * @since 3.7.0
	     */
	    addToCache: function ()
	    {
	        if (this.isReadyToProcess())
	        {
	            var fileA = this.files[0];
	            var fileB = this.files[1];
	
	            fileA.addToCache();
	            fileB.addToCache();
	
	            this.complete = true;
	        }
	    }
	
	});
	
	/**
	 * Adds a JSON based Audio Sprite, or array of audio sprites, to the current load queue.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.audioSprite('kyobi', 'kyobi.json', [
	 *         'kyobi.ogg',
	 *         'kyobi.mp3',
	 *         'kyobi.m4a'
	 *     ]);
	 * }
	 * ```
	 * 
	 * Audio Sprites are a combination of audio files and a JSON configuration.
	 * The JSON follows the format of that created by https://github.com/tonistiigi/audiosprite
	 *
	 * If the JSON file includes a 'resource' object then you can let Phaser parse it and load the audio
	 * files automatically based on its content. To do this exclude the audio URLs from the load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.audioSprite('kyobi', 'kyobi.json');
	 * }
	 * ```
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 * 
	 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
	 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
	 *
	 * The key must be a unique String. It is used to add the file to the global Audio Cache upon a successful load.
	 * The key should be unique both in terms of files being loaded and files already present in the Audio Cache.
	 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
	 * then remove it from the Audio Cache first, before loading a new one.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.audioSprite({
	 *     key: 'kyobi',
	 *     jsonURL: 'audio/Kyobi.json',
	 *     audioURL: [
	 *         'audio/Kyobi.ogg',
	 *         'audio/Kyobi.mp3',
	 *         'audio/Kyobi.m4a'
	 *     ]
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.AudioSpriteFileConfig` for more details.
	 *
	 * Instead of passing a URL for the audio JSON data you can also pass in a well formed JSON object instead.
	 *
	 * Once the audio has finished loading you can use it create an Audio Sprite by referencing its key:
	 * 
	 * ```javascript
	 * this.load.audioSprite('kyobi', 'kyobi.json');
	 * // and later in your game ...
	 * var music = this.sound.addAudioSprite('kyobi');
	 * music.play('title');
	 * ```
	 *
	 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
	 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
	 * this is what you would use to retrieve the image from the Texture Manager.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * Due to different browsers supporting different audio file types you should usually provide your audio files in a variety of formats.
	 * ogg, mp3 and m4a are the most common. If you provide an array of URLs then the Loader will determine which _one_ file to load based on
	 * browser support.
	 *
	 * If audio has been disabled in your game, either via the game config, or lack of support from the device, then no audio will be loaded.
	 * 
	 * Note: The ability to load this type of file will only be available if the Audio Sprite File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#audioSprite
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.0.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.AudioSpriteFileConfig|Phaser.Loader.FileTypes.AudioSpriteFileConfig[])} key - The key to use for this file, or a file configuration object, or an array of objects.
	 * @param {string} jsonURL - The absolute or relative URL to load the json file from. Or a well formed JSON object to use instead.
	 * @param {string} [audioURL] - The absolute or relative URL to load the audio file from. If empty it will be obtained by parsing the JSON file.
	 * @param {any} [audioConfig] - The audio configuration options.
	 * @param {XHRSettingsObject} [audioXhrSettings] - An XHR Settings configuration object for the audio file. Used in replacement of the Loaders default XHR Settings.
	 * @param {XHRSettingsObject} [jsonXhrSettings] - An XHR Settings configuration object for the json file. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader.
	 */
	FileTypesManager.register('audioSprite', function (key, jsonURL, audioURL, audioConfig, audioXhrSettings, jsonXhrSettings)
	{
	    var game = this.systems.game;
	    var gameAudioConfig = game.config.audio;
	    var deviceAudio = game.device.audio;
	
	    if ((gameAudioConfig && gameAudioConfig.noAudio) || (!deviceAudio.webAudio && !deviceAudio.audioData))
	    {
	        //  Sounds are disabled, so skip loading audio
	        return this;
	    }
	
	    var multifile;
	
	    //  Supports an Object file definition in the key argument
	    //  Or an array of objects in the key argument
	    //  Or a single entry where all arguments have been defined
	
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            multifile = new AudioSpriteFile(this, key[i]);
	
	            if (multifile.files)
	            {
	                this.addFile(multifile.files);
	            }
	        }
	    }
	    else
	    {
	        multifile = new AudioSpriteFile(this, key, jsonURL, audioURL, audioConfig, audioXhrSettings, jsonXhrSettings);
	
	        if (multifile.files)
	        {
	            this.addFile(multifile.files);
	        }
	    }
	
	    return this;
	});


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(35);
	var File = __webpack_require__(44);
	var FileTypesManager = __webpack_require__(15);
	var GetFastValue = __webpack_require__(3);
	var IsPlainObject = __webpack_require__(17);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.BinaryFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within both the Loader and the Binary Cache.
	 * @property {string} [url] - The absolute or relative URL to load the file from.
	 * @property {string} [extension='bin'] - The default file extension to use if no url is provided.
	 * @property {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 * @property {any} [dataType] - Optional type to cast the binary file to once loaded. For example, `Uint8Array`.
	 */
	
	/**
	 * @classdesc
	 * A single Binary File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#binary method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#binary.
	 *
	 * @class BinaryFile
	 * @extends Phaser.Loader.File
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.BinaryFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.bin`, i.e. if `key` was "alien" then the URL will be "alien.bin".
	 * @param {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 * @param {any} [dataType] - Optional type to cast the binary file to once loaded. For example, `Uint8Array`.
	 */
	var BinaryFile = new Class({
	
	    Extends: File,
	
	    initialize:
	
	    function BinaryFile (loader, key, url, xhrSettings, dataType)
	    {
	        var extension = 'bin';
	
	        if (IsPlainObject(key))
	        {
	            var config = key;
	
	            key = GetFastValue(config, 'key');
	            url = GetFastValue(config, 'url');
	            xhrSettings = GetFastValue(config, 'xhrSettings');
	            extension = GetFastValue(config, 'extension', extension);
	            dataType = GetFastValue(config, 'dataType', dataType);
	        }
	
	        var fileConfig = {
	            type: 'binary',
	            cache: loader.cacheManager.binary,
	            extension: extension,
	            responseType: 'arraybuffer',
	            key: key,
	            url: url,
	            xhrSettings: xhrSettings,
	            config: { dataType: dataType }
	        };
	
	        File.call(this, loader, fileConfig);
	    },
	
	    /**
	     * Called automatically by Loader.nextFile.
	     * This method controls what extra work this File does with its loaded data.
	     *
	     * @method Phaser.Loader.FileTypes.BinaryFile#onProcess
	     * @since 3.7.0
	     */
	    onProcess: function ()
	    {
	        this.state = CONST.FILE_PROCESSING;
	
	        var ctor = this.config.dataType;
	
	        this.data = (ctor) ? new ctor(this.xhrLoader.response) : this.xhrLoader.response;
	
	        this.onProcessComplete();
	    }
	
	});
	
	/**
	 * Adds a Binary file, or array of Binary files, to the current load queue.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.binary('doom', 'files/Doom.wad');
	 * }
	 * ```
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 * 
	 * The key must be a unique String. It is used to add the file to the global Binary Cache upon a successful load.
	 * The key should be unique both in terms of files being loaded and files already present in the Binary Cache.
	 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
	 * then remove it from the Binary Cache first, before loading a new one.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.binary({
	 *     key: 'doom',
	 *     url: 'files/Doom.wad',
	 *     dataType: Uint8Array
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.BinaryFileConfig` for more details.
	 *
	 * Once the file has finished loading you can access it from its Cache using its key:
	 * 
	 * ```javascript
	 * this.load.binary('doom', 'files/Doom.wad');
	 * // and later in your game ...
	 * var data = this.cache.binary.get('doom');
	 * ```
	 *
	 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
	 * key. For example, if the prefix was `LEVEL1.` and the key was `Data` the final key will be `LEVEL1.Data` and
	 * this is what you would use to retrieve the text from the Binary Cache.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "doom"
	 * and no URL is given then the Loader will set the URL to be "doom.bin". It will always add `.bin` as the extension, although
	 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
	 *
	 * Note: The ability to load this type of file will only be available if the Binary File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#binary
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.0.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.BinaryFileConfig|Phaser.Loader.FileTypes.BinaryFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.bin`, i.e. if `key` was "alien" then the URL will be "alien.bin".
	 * @param {any} [dataType] - Optional type to cast the binary file to once loaded. For example, `Uint8Array`.
	 * @param {XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('binary', function (key, url, dataType, xhrSettings)
	{
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
	            this.addFile(new BinaryFile(this, key[i]));
	        }
	    }
	    else
	    {
	        this.addFile(new BinaryFile(this, key, url, xhrSettings, dataType));
	    }
	
	    return this;
	});
	
	module.exports = BinaryFile;


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var FileTypesManager = __webpack_require__(15);
	var GetFastValue = __webpack_require__(3);
	var ImageFile = __webpack_require__(115);
	var IsPlainObject = __webpack_require__(17);
	var MultiFile = __webpack_require__(114);
	var ParseXMLBitmapFont = __webpack_require__(489);
	var XMLFile = __webpack_require__(304);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.BitmapFontFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within both the Loader and the Texture Manager.
	 * @property {string} [textureURL] - The absolute or relative URL to load the texture image file from.
	 * @property {string} [textureExtension='png'] - The default file extension to use for the image texture if no url is provided.
	 * @property {XHRSettingsObject} [textureXhrSettings] - Extra XHR Settings specifically for the texture image file.
	 * @property {string} [normalMap] - The filename of an associated normal map. It uses the same path and url to load as the texture image.
	 * @property {string} [fontDataURL] - The absolute or relative URL to load the font data xml file from.
	 * @property {string} [fontDataExtension='xml'] - The default file extension to use for the font data xml if no url is provided.
	 * @property {XHRSettingsObject} [fontDataXhrSettings] - Extra XHR Settings specifically for the font data xml file.
	 */
	
	/**
	 * @classdesc
	 * A single Bitmap Font based File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#bitmapFont method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#bitmapFont.
	 *
	 * @class BitmapFontFile
	 * @extends Phaser.Loader.MultiFile
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.BitmapFontFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the font image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
	 * @param {string} [fontDataURL] - The absolute or relative URL to load the font xml data file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
	 * @param {XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the font image file. Used in replacement of the Loaders default XHR Settings.
	 * @param {XHRSettingsObject} [fontDataXhrSettings] - An XHR Settings configuration object for the font data xml file. Used in replacement of the Loaders default XHR Settings.
	 */
	var BitmapFontFile = new Class({
	
	    Extends: MultiFile,
	
	    initialize:
	
	    function BitmapFontFile (loader, key, textureURL, fontDataURL, textureXhrSettings, fontDataXhrSettings)
	    {
	        var image;
	        var data;
	
	        if (IsPlainObject(key))
	        {
	            var config = key;
	
	            key = GetFastValue(config, 'key');
	
	            image = new ImageFile(loader, {
	                key: key,
	                url: GetFastValue(config, 'textureURL'),
	                extension: GetFastValue(config, 'textureExtension', 'png'),
	                normalMap: GetFastValue(config, 'normalMap'),
	                xhrSettings: GetFastValue(config, 'textureXhrSettings')
	            });
	
	            data = new XMLFile(loader, {
	                key: key,
	                url: GetFastValue(config, 'fontDataURL'),
	                extension: GetFastValue(config, 'fontDataExtension', 'xml'),
	                xhrSettings: GetFastValue(config, 'fontDataXhrSettings')
	            });
	        }
	        else
	        {
	            image = new ImageFile(loader, key, textureURL, textureXhrSettings);
	            data = new XMLFile(loader, key, fontDataURL, fontDataXhrSettings);
	        }
	
	        if (image.linkFile)
	        {
	            //  Image has a normal map
	            MultiFile.call(this, loader, 'bitmapfont', key, [ image, data, image.linkFile ]);
	        }
	        else
	        {
	            MultiFile.call(this, loader, 'bitmapfont', key, [ image, data ]);
	        }
	    },
	
	    /**
	     * Adds this file to its target cache upon successful loading and processing.
	     *
	     * @method Phaser.Loader.FileTypes.BitmapFontFile#addToCache
	     * @since 3.7.0
	     */
	    addToCache: function ()
	    {
	        if (this.isReadyToProcess())
	        {
	            var image = this.files[0];
	            var xml = this.files[1];
	
	            image.addToCache();
	            xml.addToCache();
	
	            this.loader.cacheManager.bitmapFont.add(image.key, { data: ParseXMLBitmapFont(xml.data), texture: image.key, frame: null });
	
	            this.complete = true;
	        }
	    }
	
	});
	
	/**
	 * Adds an XML based Bitmap Font, or array of fonts, to the current load queue.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.bitmapFont('goldenFont', 'images/GoldFont.png', 'images/GoldFont.xml');
	 * }
	 * ```
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 * 
	 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
	 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
	 *
	 * Phaser expects the font data to be provided in an XML file format.
	 * These files are created by software such as the [Angelcode Bitmap Font Generator](http://www.angelcode.com/products/bmfont/),
	 * [Littera](http://kvazars.com/littera/) or [Glyph Designer](https://71squared.com/glyphdesigner)
	 * 
	 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
	 *
	 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
	 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
	 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
	 * then remove it from the Texture Manager first, before loading a new one.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.bitmapFont({
	 *     key: 'goldenFont',
	 *     textureURL: 'images/GoldFont.png',
	 *     fontDataURL: 'images/GoldFont.xml'
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.BitmapFontFileConfig` for more details.
	 *
	 * Once the atlas has finished loading you can use key of it when creating a Bitmap Text Game Object:
	 * 
	 * ```javascript
	 * this.load.bitmapFont('goldenFont', 'images/GoldFont.png', 'images/GoldFont.xml');
	 * // and later in your game ...
	 * this.add.bitmapText(x, y, 'goldenFont', 'Hello World');
	 * ```
	 *
	 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
	 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
	 * this is what you would use when creating a Bitmap Text object.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
	 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
	 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
	 *
	 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
	 * then you can specify it by providing an array as the `url` where the second element is the normal map:
	 * 
	 * ```javascript
	 * this.load.bitmapFont('goldenFont', [ 'images/GoldFont.png', 'images/GoldFont-n.png' ], 'images/GoldFont.xml');
	 * ```
	 *
	 * Or, if you are using a config object use the `normalMap` property:
	 * 
	 * ```javascript
	 * this.load.bitmapFont({
	 *     key: 'goldenFont',
	 *     textureURL: 'images/GoldFont.png',
	 *     normalMap: 'images/GoldFont-n.png',
	 *     fontDataURL: 'images/GoldFont.xml'
	 * });
	 * ```
	 *
	 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
	 * Normal maps are a WebGL only feature.
	 *
	 * Note: The ability to load this type of file will only be available if the Bitmap Font File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#bitmapFont
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.0.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.BitmapFontFileConfig|Phaser.Loader.FileTypes.BitmapFontFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the font image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
	 * @param {string} [fontDataURL] - The absolute or relative URL to load the font xml data file from. If undefined or `null` it will be set to `<key>.xml`, i.e. if `key` was "alien" then the URL will be "alien.xml".
	 * @param {XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the font image file. Used in replacement of the Loaders default XHR Settings.
	 * @param {XHRSettingsObject} [fontDataXhrSettings] - An XHR Settings configuration object for the font data xml file. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('bitmapFont', function (key, textureURL, fontDataURL, textureXhrSettings, fontDataXhrSettings)
	{
	    var multifile;
	
	    //  Supports an Object file definition in the key argument
	    //  Or an array of objects in the key argument
	    //  Or a single entry where all arguments have been defined
	
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            multifile = new BitmapFontFile(this, key[i]);
	
	            this.addFile(multifile.files);
	        }
	    }
	    else
	    {
	        multifile = new BitmapFontFile(this, key, textureURL, fontDataURL, textureXhrSettings, fontDataXhrSettings);
	
	        this.addFile(multifile.files);
	    }
	
	    return this;
	});
	
	module.exports = BitmapFontFile;


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(35);
	var File = __webpack_require__(44);
	var FileTypesManager = __webpack_require__(15);
	var GetFastValue = __webpack_require__(3);
	var IsPlainObject = __webpack_require__(17);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.GLSLFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within both the Loader and the Text Cache.
	 * @property {string} [url] - The absolute or relative URL to load the file from.
	 * @property {string} [extension='glsl'] - The default file extension to use if no url is provided.
	 * @property {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	
	/**
	 * @classdesc
	 * A single GLSL File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#glsl method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#glsl.
	 *
	 * @class GLSLFile
	 * @extends Phaser.Loader.File
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.TextFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.txt`, i.e. if `key` was "alien" then the URL will be "alien.txt".
	 * @param {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	var GLSLFile = new Class({
	
	    Extends: File,
	
	    initialize:
	
	    function GLSLFile (loader, key, url, xhrSettings)
	    {
	        var extension = 'glsl';
	
	        if (IsPlainObject(key))
	        {
	            var config = key;
	
	            key = GetFastValue(config, 'key');
	            url = GetFastValue(config, 'url');
	            xhrSettings = GetFastValue(config, 'xhrSettings');
	            extension = GetFastValue(config, 'extension', extension);
	        }
	
	        var fileConfig = {
	            type: 'glsl',
	            cache: loader.cacheManager.shader,
	            extension: extension,
	            responseType: 'text',
	            key: key,
	            url: url,
	            xhrSettings: xhrSettings
	        };
	
	        File.call(this, loader, fileConfig);
	    },
	
	    /**
	     * Called automatically by Loader.nextFile.
	     * This method controls what extra work this File does with its loaded data.
	     *
	     * @method Phaser.Loader.FileTypes.GLSLFile#onProcess
	     * @since 3.7.0
	     */
	    onProcess: function ()
	    {
	        this.state = CONST.FILE_PROCESSING;
	
	        this.data = this.xhrLoader.responseText;
	
	        this.onProcessComplete();
	    }
	
	});
	
	/**
	 * Adds a GLSL file, or array of GLSL files, to the current load queue.
	 * In Phaser 3 GLSL files are just plain Text files at the current moment in time.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.glsl('plasma', 'shaders/Plasma.glsl');
	 * }
	 * ```
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 * 
	 * The key must be a unique String. It is used to add the file to the global Shader Cache upon a successful load.
	 * The key should be unique both in terms of files being loaded and files already present in the Shader Cache.
	 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
	 * then remove it from the Shader Cache first, before loading a new one.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.glsl({
	 *     key: 'plasma',
	 *     url: 'shaders/Plasma.glsl'
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.GLSLFileConfig` for more details.
	 *
	 * Once the file has finished loading you can access it from its Cache using its key:
	 * 
	 * ```javascript
	 * this.load.glsl('plasma', 'shaders/Plasma.glsl');
	 * // and later in your game ...
	 * var data = this.cache.shader.get('plasma');
	 * ```
	 *
	 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
	 * key. For example, if the prefix was `FX.` and the key was `Plasma` the final key will be `FX.Plasma` and
	 * this is what you would use to retrieve the text from the Shader Cache.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "plasma"
	 * and no URL is given then the Loader will set the URL to be "plasma.glsl". It will always add `.glsl` as the extension, although
	 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
	 *
	 * Note: The ability to load this type of file will only be available if the GLSL File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#glsl
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.0.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.GLSLFileConfig|Phaser.Loader.FileTypes.GLSLFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.glsl`, i.e. if `key` was "alien" then the URL will be "alien.glsl".
	 * @param {XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('glsl', function (key, url, xhrSettings)
	{
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
	            this.addFile(new GLSLFile(this, key[i]));
	        }
	    }
	    else
	    {
	        this.addFile(new GLSLFile(this, key, url, xhrSettings));
	    }
	
	    return this;
	});
	
	module.exports = GLSLFile;


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(35);
	var File = __webpack_require__(44);
	var FileTypesManager = __webpack_require__(15);
	var GetFastValue = __webpack_require__(3);
	var IsPlainObject = __webpack_require__(17);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.HTMLFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within both the Loader and the Texture Manager.
	 * @property {string} [url] - The absolute or relative URL to load the file from.
	 * @property {string} [extension='html'] - The default file extension to use if no url is provided.
	 * @property {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 * @property {integer} [width=512] - The width of the texture the HTML will be rendered to.
	 * @property {integer} [height=512] - The height of the texture the HTML will be rendered to.
	 */
	
	/**
	 * @classdesc
	 * A single HTML File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#html method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#html.
	 *
	 * @class HTMLFile
	 * @extends Phaser.Loader.File
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.HTMLFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
	 * @param {integer} [width] - The width of the texture the HTML will be rendered to.
	 * @param {integer} [height] - The height of the texture the HTML will be rendered to.
	 * @param {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	var HTMLFile = new Class({
	
	    Extends: File,
	
	    initialize:
	
	    function HTMLFile (loader, key, url, width, height, xhrSettings)
	    {
	        if (width === undefined) { width = 512; }
	        if (height === undefined) { height = 512; }
	
	        var extension = 'html';
	
	        if (IsPlainObject(key))
	        {
	            var config = key;
	
	            key = GetFastValue(config, 'key');
	            url = GetFastValue(config, 'url');
	            xhrSettings = GetFastValue(config, 'xhrSettings');
	            extension = GetFastValue(config, 'extension', extension);
	            width = GetFastValue(config, 'width', width);
	            height = GetFastValue(config, 'height', height);
	        }
	
	        var fileConfig = {
	            type: 'html',
	            cache: loader.textureManager,
	            extension: extension,
	            responseType: 'text',
	            key: key,
	            url: url,
	            xhrSettings: xhrSettings,
	            config: {
	                width: width,
	                height: height
	            }
	        };
	
	        File.call(this, loader, fileConfig);
	    },
	
	    /**
	     * Called automatically by Loader.nextFile.
	     * This method controls what extra work this File does with its loaded data.
	     *
	     * @method Phaser.Loader.FileTypes.HTMLFile#onProcess
	     * @since 3.7.0
	     */
	    onProcess: function ()
	    {
	        this.state = CONST.FILE_PROCESSING;
	
	        var w = this.config.width;
	        var h = this.config.height;
	
	        var data = [];
	
	        data.push('<svg width="' + w + 'px" height="' + h + 'px" viewBox="0 0 ' + w + ' ' + h + '" xmlns="http://www.w3.org/2000/svg">');
	        data.push('<foreignObject width="100%" height="100%">');
	        data.push('<body xmlns="http://www.w3.org/1999/xhtml">');
	        data.push(this.xhrLoader.responseText);
	        data.push('</body>');
	        data.push('</foreignObject>');
	        data.push('</svg>');
	
	        var svg = [ data.join('\n') ];
	        var _this = this;
	
	        try
	        {
	            var blob = new window.Blob(svg, { type: 'image/svg+xml;charset=utf-8' });
	        }
	        catch (e)
	        {
	            _this.state = CONST.FILE_ERRORED;
	
	            _this.onProcessComplete();
	
	            return;
	        }
	
	        this.data = new Image();
	
	        this.data.crossOrigin = this.crossOrigin;
	
	        this.data.onload = function ()
	        {
	            File.revokeObjectURL(_this.data);
	
	            _this.onProcessComplete();
	        };
	
	        this.data.onerror = function ()
	        {
	            File.revokeObjectURL(_this.data);
	
	            _this.onProcessError();
	        };
	
	        File.createObjectURL(this.data, blob, 'image/svg+xml');
	    },
	
	    /**
	     * Adds this file to its target cache upon successful loading and processing.
	     *
	     * @method Phaser.Loader.FileTypes.HTMLFile#addToCache
	     * @since 3.7.0
	     */
	    addToCache: function ()
	    {
	        var texture = this.cache.addImage(this.key, this.data);
	
	        this.pendingDestroy(texture);
	    }
	
	});
	
	/**
	 * Adds an HTML File, or array of HTML Files, to the current load queue.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.html('instructions', 'content/intro.html', 256, 512);
	 * }
	 * ```
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 *
	 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
	 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
	 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
	 * then remove it from the Texture Manager first, before loading a new one.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.html({
	 *     key: 'instructions',
	 *     url: 'content/intro.html',
	 *     width: 256,
	 *     height: 512
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.HTMLFileConfig` for more details.
	 *
	 * Once the file has finished loading you can use it as a texture for a Game Object by referencing its key:
	 * 
	 * ```javascript
	 * this.load.html('instructions', 'content/intro.html', 256, 512);
	 * // and later in your game ...
	 * this.add.image(x, y, 'instructions');
	 * ```
	 *
	 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
	 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
	 * this is what you would use to retrieve the image from the Texture Manager.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
	 * and no URL is given then the Loader will set the URL to be "alien.html". It will always add `.html` as the extension, although
	 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
	 *
	 * The width and height are the size of the texture to which the HTML will be rendered. It's not possible to determine these
	 * automatically, so you will need to provide them, either as arguments or in the file config object.
	 * When the HTML file has loaded a new SVG element is created with a size and viewbox set to the width and height given.
	 * The SVG file has a body tag added to it, with the HTML file contents included. It then calls `window.Blob` on the SVG,
	 * and if successful is added to the Texture Manager, otherwise it fails processing. The overall quality of the rendered
	 * HTML depends on your browser, and some of them may not even support the svg / blob process used. Be aware that there are
	 * limitations on what HTML can be inside an SVG. You can find out more details in this
	 * [Mozilla MDN entry](https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Drawing_DOM_objects_into_a_canvas).
	 *
	 * Note: The ability to load this type of file will only be available if the Image File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#html
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.0.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.ImageFileConfig|Phaser.Loader.FileTypes.ImageFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
	 * @param {integer} [width=512] - The width of the texture the HTML will be rendered to.
	 * @param {integer} [height=512] - The height of the texture the HTML will be rendered to.
	 * @param {XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('html', function (key, url, width, height, xhrSettings)
	{
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
	            this.addFile(new HTMLFile(this, key[i]));
	        }
	    }
	    else
	    {
	        this.addFile(new HTMLFile(this, key, url, width, height, xhrSettings));
	    }
	
	    return this;
	});
	
	module.exports = HTMLFile;


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var FileTypesManager = __webpack_require__(15);
	var GetFastValue = __webpack_require__(3);
	var ImageFile = __webpack_require__(115);
	var IsPlainObject = __webpack_require__(17);
	var JSONFile = __webpack_require__(96);
	var MultiFile = __webpack_require__(114);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.MultiAtlasFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within both the Loader and the Texture Manager.
	 * @property {string} [atlasURL] - The absolute or relative URL to load the multi atlas json file from. Or, a well formed JSON object.
	 * @property {string} [atlasExtension='json'] - The default file extension to use for the atlas json if no url is provided.
	 * @property {XHRSettingsObject} [atlasXhrSettings] - Extra XHR Settings specifically for the atlas json file.
	 * @property {string} [path] - Optional path to use when loading the textures defined in the atlas data.
	 * @property {string} [baseURL] - Optional Base URL to use when loading the textures defined in the atlas data.
	 * @property {XHRSettingsObject} [textureXhrSettings] - Extra XHR Settings specifically for the texture files.
	 */
	
	/**
	 * @classdesc
	 * A single Multi Texture Atlas File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#multiatlas method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#multiatlas.
	 *
	 * @class MultiAtlasFile
	 * @extends Phaser.Loader.MultiFile
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.7.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {string} key - The key of the file. Must be unique within both the Loader and the Texture Manager.
	 * @param {string} [atlasURL] - The absolute or relative URL to load the multi atlas json file from.
	 * @param {string} [path] - Optional path to use when loading the textures defined in the atlas data.
	 * @param {string} [baseURL] - Optional Base URL to use when loading the textures defined in the atlas data.
	 * @param {XHRSettingsObject} [atlasXhrSettings] - Extra XHR Settings specifically for the atlas json file.
	 * @param {XHRSettingsObject} [textureXhrSettings] - Extra XHR Settings specifically for the texture files.
	 */
	var MultiAtlasFile = new Class({
	
	    Extends: MultiFile,
	
	    initialize:
	
	    function MultiAtlasFile (loader, key, atlasURL, path, baseURL, atlasXhrSettings, textureXhrSettings)
	    {
	        if (IsPlainObject(key))
	        {
	            var config = key;
	
	            key = GetFastValue(config, 'key');
	            atlasURL = GetFastValue(config, 'url');
	            atlasXhrSettings = GetFastValue(config, 'xhrSettings');
	            path = GetFastValue(config, 'path');
	            baseURL = GetFastValue(config, 'baseURL');
	            textureXhrSettings = GetFastValue(config, 'textureXhrSettings');
	        }
	
	        var data = new JSONFile(loader, key, atlasURL, atlasXhrSettings);
	
	        MultiFile.call(this, loader, 'multiatlas', key, [ data ]);
	
	        this.config.path = path;
	        this.config.baseURL = baseURL;
	        this.config.textureXhrSettings = textureXhrSettings;
	    },
	
	    /**
	     * Called by each File when it finishes loading.
	     *
	     * @method Phaser.Loader.MultiFile#onFileComplete
	     * @since 3.7.0
	     *
	     * @param {Phaser.Loader.File} file - The File that has completed processing.
	     */
	    onFileComplete: function (file)
	    {
	        var index = this.files.indexOf(file);
	
	        if (index !== -1)
	        {
	            this.pending--;
	
	            if (file.type === 'json' && file.data.hasOwnProperty('textures'))
	            {
	                //  Inspect the data for the files to now load
	                var textures = file.data.textures;
	
	                var config = this.config;
	                var loader = this.loader;
	
	                var currentBaseURL = loader.baseURL;
	                var currentPath = loader.path;
	                var currentPrefix = loader.prefix;
	
	                var baseURL = GetFastValue(config, 'baseURL', currentBaseURL);
	                var path = GetFastValue(config, 'path', currentPath);
	                var prefix = GetFastValue(config, 'prefix', currentPrefix);
	                var textureXhrSettings = GetFastValue(config, 'textureXhrSettings');
	
	                loader.setBaseURL(baseURL);
	                loader.setPath(path);
	                loader.setPrefix(prefix);
	
	                for (var i = 0; i < textures.length; i++)
	                {
	                    //  "image": "texture-packer-multi-atlas-0.png",
	                    var textureURL = textures[i].image;
	
	                    var key = '_MA_' + textureURL;
	
	                    var image = new ImageFile(loader, key, textureURL, textureXhrSettings);
	
	                    this.addToMultiFile(image);
	
	                    loader.addFile(image);
	
	                    //  "normalMap": "texture-packer-multi-atlas-0_n.png",
	                    if (textures[i].normalMap)
	                    {
	                        var normalMap = new ImageFile(loader, key, textures[i].normalMap, textureXhrSettings);
	
	                        normalMap.type = 'normalMap';
	
	                        image.setLink(normalMap);
	
	                        this.addToMultiFile(normalMap);
	
	                        loader.addFile(normalMap);
	                    }
	                }
	
	                //  Reset the loader settings
	                loader.setBaseURL(currentBaseURL);
	                loader.setPath(currentPath);
	                loader.setPrefix(currentPrefix);
	            }
	        }
	    },
	
	    /**
	     * Adds this file to its target cache upon successful loading and processing.
	     *
	     * @method Phaser.Loader.MultiFile#addToCache
	     * @since 3.7.0
	     */
	    addToCache: function ()
	    {
	        if (this.isReadyToProcess())
	        {
	            var fileJSON = this.files[0];
	
	            fileJSON.addToCache();
	
	            var data = [];
	            var images = [];
	            var normalMaps = [];
	
	            for (var i = 1; i < this.files.length; i++)
	            {
	                var file = this.files[i];
	
	                if (file.type === 'normalMap')
	                {
	                    continue;
	                }
	
	                var key = file.key.substr(4);
	                var image = file.data;
	
	                //  Now we need to find out which json entry this mapped to
	                for (var t = 0; t < fileJSON.data.textures.length; t++)
	                {
	                    var item = fileJSON.data.textures[t];
	
	                    if (item.image === key)
	                    {
	                        images.push(image);
	                        
	                        data.push(item);
	
	                        if (file.linkFile)
	                        {
	                            normalMaps.push(file.linkFile.data);
	                        }
	
	                        break;
	                    }
	                }
	            }
	
	            if (normalMaps.length === 0)
	            {
	                normalMaps = undefined;
	            }
	
	            this.loader.textureManager.addAtlasJSONArray(this.key, images, data, normalMaps);
	
	            this.complete = true;
	
	            for (i = 0; i < this.files.length; i++)
	            {
	                this.files[i].pendingDestroy();
	            }
	        }
	    }
	
	});
	
	/**
	 * Adds a Multi Texture Atlas, or array of multi atlases, to the current load queue.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.multiatlas('level1', 'images/Level1.json');
	 * }
	 * ```
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 * 
	 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
	 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
	 *
	 * Phaser expects the atlas data to be provided in a JSON file as exported from the application Texture Packer,
	 * version 4.6.3 or above, where you have made sure to use the Phaser 3 Export option.
	 *
	 * The way it works internally is that you provide a URL to the JSON file. Phaser then loads this JSON, parses it and
	 * extracts which texture files it also needs to load to complete the process. If the JSON also defines normal maps,
	 * Phaser will load those as well.
	 * 
	 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
	 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
	 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
	 * then remove it from the Texture Manager first, before loading a new one.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.multiatlas({
	 *     key: 'level1',
	 *     atlasURL: 'images/Level1.json'
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.MultiAtlasFileConfig` for more details.
	 *
	 * Instead of passing a URL for the atlas JSON data you can also pass in a well formed JSON object instead.
	 *
	 * Once the atlas has finished loading you can use frames from it as textures for a Game Object by referencing its key:
	 * 
	 * ```javascript
	 * this.load.multiatlas('level1', 'images/Level1.json');
	 * // and later in your game ...
	 * this.add.image(x, y, 'level1', 'background');
	 * ```
	 *
	 * To get a list of all available frames within an atlas please consult your Texture Atlas software.
	 *
	 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
	 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
	 * this is what you would use to retrieve the image from the Texture Manager.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
	 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
	 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
	 *
	 * Note: The ability to load this type of file will only be available if the Multi Atlas File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#multiatlas
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.7.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.MultiAtlasFileConfig|Phaser.Loader.FileTypes.MultiAtlasFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {string} [atlasURL] - The absolute or relative URL to load the texture atlas json data file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
	 * @param {string} [path] - Optional path to use when loading the textures defined in the atlas data.
	 * @param {string} [baseURL] - Optional Base URL to use when loading the textures defined in the atlas data.
	 * @param {XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas json file. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('multiatlas', function (key, atlasURL, path, baseURL, atlasXhrSettings)
	{
	    var multifile;
	
	    //  Supports an Object file definition in the key argument
	    //  Or an array of objects in the key argument
	    //  Or a single entry where all arguments have been defined
	
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            multifile = new MultiAtlasFile(this, key[i]);
	
	            this.addFile(multifile.files);
	        }
	    }
	    else
	    {
	        multifile = new MultiAtlasFile(this, key, atlasURL, path, baseURL, atlasXhrSettings);
	
	        this.addFile(multifile.files);
	    }
	
	    return this;
	});
	
	module.exports = MultiAtlasFile;


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(35);
	var FileTypesManager = __webpack_require__(15);
	var JSONFile = __webpack_require__(96);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.PackFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within both the Loader and the JSON Cache.
	 * @property {string|any} [url] - The absolute or relative URL to load the file from. Or can be a ready formed JSON object, in which case it will be directly processed.
	 * @property {string} [extension='json'] - The default file extension to use if no url is provided.
	 * @property {string} [dataKey] - If specified instead of the whole JSON file being parsed, only the section corresponding to this property key will be added. If the property you want to extract is nested, use periods to divide it.
	 * @property {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	
	/**
	 * @classdesc
	 * A single JSON Pack File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#pack method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#pack.
	 *
	 * @class PackFile
	 * @extends Phaser.Loader.File
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.7.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.JSONFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
	 * @param {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 * @param {string} [dataKey] - When the JSON file loads only this property will be stored in the Cache.
	 */
	var PackFile = new Class({
	
	    Extends: JSONFile,
	
	    initialize:
	
	    //  url can either be a string, in which case it is treated like a proper url, or an object, in which case it is treated as a ready-made JS Object
	    //  dataKey allows you to pluck a specific object out of the JSON and put just that into the cache, rather than the whole thing
	
	    function PackFile (loader, key, url, xhrSettings, dataKey)
	    {
	        JSONFile.call(this, loader, key, url, xhrSettings, dataKey);
	
	        this.type = 'packfile';
	    },
	
	    /**
	     * Called automatically by Loader.nextFile.
	     * This method controls what extra work this File does with its loaded data.
	     *
	     * @method Phaser.Loader.FileTypes.PackFile#onProcess
	     * @since 3.7.0
	     */
	    onProcess: function ()
	    {
	        if (this.state !== CONST.FILE_POPULATED)
	        {
	            this.state = CONST.FILE_PROCESSING;
	
	            this.data = JSON.parse(this.xhrLoader.responseText);
	        }
	
	        //  Let's pass the pack file data over to the Loader ...
	        this.loader.addPack(this.data, this.config);
	
	        this.onProcessComplete();
	    }
	
	});
	
	/**
	 * Adds a JSON File Pack, or array of packs, to the current load queue.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.pack('level1', 'data/Level1Files.json');
	 * }
	 * ```
	 *
	 * A File Pack is a JSON file (or object) that contains details about other files that should be added into the Loader.
	 * Here is a small example:
	 *
	 * ```json
	 * { 
	 *    "test1": {
	 *        "files": [
	 *            {
	 *                "type": "image",
	 *                "key": "taikodrummaster",
	 *                "url": "assets/pics/taikodrummaster.jpg"
	 *            },
	 *            {
	 *                "type": "image",
	 *                "key": "sukasuka-chtholly",
	 *                "url": "assets/pics/sukasuka-chtholly.png"
	 *            }
	 *        ]
	 *    },
	 *    "meta": {
	 *        "generated": "1401380327373",
	 *        "app": "Phaser 3 Asset Packer",
	 *        "url": "https://phaser.io",
	 *        "version": "1.0",
	 *        "copyright": "Photon Storm Ltd. 2018"
	 *    }
	 * }
	 * ```
	 *
	 * The pack can be split into sections. In the example above you'll see a section called `test1. You can tell
	 * the `load.pack` method to parse only a particular section of a pack. The pack is stored in the JSON Cache,
	 * so you can pass it to the Loader to process additional sections as needed in your game, or you can just load
	 * them all at once without specifying anything.
	 *
	 * The pack file can contain an entry for any type of file that Phaser can load. The object structures exactly
	 * match that of the file type configs, and all properties available within the file type configs can be used
	 * in the pack file too.
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 * 
	 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
	 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
	 * 
	 * The key must be a unique String. It is used to add the file to the global JSON Cache upon a successful load.
	 * The key should be unique both in terms of files being loaded and files already present in the JSON Cache.
	 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
	 * then remove it from the JSON Cache first, before loading a new one.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.pack({
	 *     key: 'level1',
	 *     url: 'data/Level1Files.json'
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.PackFileConfig` for more details.
	 *
	 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
	 * key. For example, if the prefix was `LEVEL1.` and the key was `Waves` the final key will be `LEVEL1.Waves` and
	 * this is what you would use to retrieve the text from the JSON Cache.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "data"
	 * and no URL is given then the Loader will set the URL to be "data.json". It will always add `.json` as the extension, although
	 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
	 *
	 * You can also optionally provide a `dataKey` to use. This allows you to extract only a part of the JSON and store it in the Cache,
	 * rather than the whole file. For example, if your JSON data had a structure like this:
	 * 
	 * ```json
	 * {
	 *     "level1": {
	 *         "baddies": {
	 *             "aliens": {},
	 *             "boss": {}
	 *         }
	 *     },
	 *     "level2": {},
	 *     "level3": {}
	 * }
	 * ```
	 *
	 * And you only wanted to store the `boss` data in the Cache, then you could pass `level1.baddies.boss`as the `dataKey`.
	 *
	 * Note: The ability to load this type of file will only be available if the Pack File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#pack
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.7.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.PackFileConfig|Phaser.Loader.FileTypes.PackFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
	 * @param {string} [dataKey] - When the JSON file loads only this property will be stored in the Cache.
	 * @param {XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('pack', function (key, url, packKey, xhrSettings)
	{
	    //  Supports an Object file definition in the key argument
	    //  Or an array of objects in the key argument
	    //  Or a single entry where all arguments have been defined
	
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            this.addFile(new PackFile(this, key[i]));
	        }
	    }
	    else
	    {
	        this.addFile(new PackFile(this, key, url, xhrSettings, packKey));
	    }
	
	    return this;
	});
	
	module.exports = PackFile;


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(35);
	var File = __webpack_require__(44);
	var FileTypesManager = __webpack_require__(15);
	var GetFastValue = __webpack_require__(3);
	var IsPlainObject = __webpack_require__(17);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.PluginFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within the Loader.
	 * @property {string} [url] - The absolute or relative URL to load the file from.
	 * @property {string} [extension='js'] - The default file extension to use if no url is provided.
	 * @property {boolean} [start=false] - Automatically start the plugin after loading?
	 * @property {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	
	/**
	 * @classdesc
	 * A single Plugin Script File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#plugin method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#plugin.
	 *
	 * @class PluginFile
	 * @extends Phaser.Loader.File
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.PluginFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
	 * @param {boolean} [start=false] - Automatically start the plugin after loading?
	 * @param {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	var PluginFile = new Class({
	
	    Extends: File,
	
	    initialize:
	
	    function PluginFile (loader, key, url, start, xhrSettings)
	    {
	        var extension = 'js';
	
	        if (IsPlainObject(key))
	        {
	            var config = key;
	
	            key = GetFastValue(config, 'key');
	            url = GetFastValue(config, 'url');
	            xhrSettings = GetFastValue(config, 'xhrSettings');
	            extension = GetFastValue(config, 'extension', extension);
	            start = GetFastValue(config, 'start');
	        }
	
	        var fileConfig = {
	            type: 'plugin',
	            cache: false,
	            extension: extension,
	            responseType: 'text',
	            key: key,
	            url: url,
	            xhrSettings: xhrSettings,
	            config: { start: start }
	        };
	
	        File.call(this, loader, fileConfig);
	
	        // If the url variable refers to a class, add the plugin directly
	        if (typeof url === 'function')
	        {
	            this.data = url;
	
	            this.state = CONST.FILE_POPULATED;
	        }
	    },
	
	    /**
	     * Called automatically by Loader.nextFile.
	     * This method controls what extra work this File does with its loaded data.
	     *
	     * @method Phaser.Loader.FileTypes.PluginFile#onProcess
	     * @since 3.7.0
	     */
	    onProcess: function ()
	    {
	        var pluginManager = this.loader.systems.plugins;
	        var config = this.config;
	
	        var start = GetFastValue(config, 'start', false);
	
	        if (this.state === CONST.FILE_POPULATED)
	        {
	            pluginManager.install(this.key, this.data, start);
	        }
	        else
	        {
	            //  Plugin added via a js file
	            this.state = CONST.FILE_PROCESSING;
	
	            this.data = document.createElement('script');
	            this.data.language = 'javascript';
	            this.data.type = 'text/javascript';
	            this.data.defer = false;
	            this.data.text = this.xhrLoader.responseText;
	
	            document.head.appendChild(this.data);
	
	            pluginManager.install(this.key, window[this.key], start);
	        }
	
	        this.onProcessComplete();
	    }
	
	});
	
	/**
	 * Adds a Plugin Script file, or array of plugin files, to the current load queue.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.plugin('modplayer', 'plugins/ModPlayer.js');
	 * }
	 * ```
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 * 
	 * The key must be a unique String and not already in-use by another file in the Loader.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.plugin({
	 *     key: 'modplayer',
	 *     url: 'plugins/ModPlayer.js'
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.PluginFileConfig` for more details.
	 *
	 * Once the file has finished loading it will automatically be converted into a script element
	 * via `document.createElement('script')`. It will have its language set to JavaScript, `defer` set to
	 * false and then the resulting element will be appended to `document.head`. Any code then in the
	 * script will be executed. It will then be passed to the Phaser PluginCache.register method.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
	 * and no URL is given then the Loader will set the URL to be "alien.js". It will always add `.js` as the extension, although
	 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
	 *
	 * Note: The ability to load this type of file will only be available if the Script File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#plugin
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.0.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.PluginFileConfig|Phaser.Loader.FileTypes.PluginFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {(string|function)} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js". Or, a plugin function.
	 * @param {boolean} [start] - The plugin mapping configuration object.
	 * @param {XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('plugin', function (key, url, start, xhrSettings)
	{
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
	            this.addFile(new PluginFile(this, key[i]));
	        }
	    }
	    else
	    {
	        this.addFile(new PluginFile(this, key, url, start, xhrSettings));
	    }
	
	    return this;
	});
	
	module.exports = PluginFile;


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(35);
	var File = __webpack_require__(44);
	var FileTypesManager = __webpack_require__(15);
	var GetFastValue = __webpack_require__(3);
	var IsPlainObject = __webpack_require__(17);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.SVGFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within both the Loader and the Texture Manager.
	 * @property {string} [url] - The absolute or relative URL to load the file from.
	 * @property {string} [extension='svg'] - The default file extension to use if no url is provided.
	 * @property {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	
	/**
	 * @classdesc
	 * A single SVG File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#svg method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#svg.
	 *
	 * @class SVGFile
	 * @extends Phaser.Loader.File
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.SVGFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.svg`, i.e. if `key` was "alien" then the URL will be "alien.svg".
	 * @param {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	var SVGFile = new Class({
	
	    Extends: File,
	
	    initialize:
	
	    function SVGFile (loader, key, url, xhrSettings)
	    {
	        var extension = 'svg';
	
	        if (IsPlainObject(key))
	        {
	            var config = key;
	
	            key = GetFastValue(config, 'key');
	            url = GetFastValue(config, 'url');
	            xhrSettings = GetFastValue(config, 'xhrSettings');
	            extension = GetFastValue(config, 'extension', extension);
	        }
	
	        var fileConfig = {
	            type: 'svg',
	            cache: loader.textureManager,
	            extension: extension,
	            responseType: 'text',
	            key: key,
	            url: url,
	            xhrSettings: xhrSettings
	        };
	
	        File.call(this, loader, fileConfig);
	    },
	
	    /**
	     * Called automatically by Loader.nextFile.
	     * This method controls what extra work this File does with its loaded data.
	     *
	     * @method Phaser.Loader.FileTypes.SVGFile#onProcess
	     * @since 3.7.0
	     */
	    onProcess: function ()
	    {
	        this.state = CONST.FILE_PROCESSING;
	
	        var svg = [ this.xhrLoader.responseText ];
	
	        try
	        {
	            var blob = new window.Blob(svg, { type: 'image/svg+xml;charset=utf-8' });
	        }
	        catch (e)
	        {
	            this.onProcessError();
	
	            return;
	        }
	
	        this.data = new Image();
	
	        this.data.crossOrigin = this.crossOrigin;
	
	        var _this = this;
	        var retry = false;
	
	        this.data.onload = function ()
	        {
	            if (!retry)
	            {
	                File.revokeObjectURL(_this.data);
	            }
	
	            _this.onProcessComplete();
	        };
	
	        this.data.onerror = function ()
	        {
	            //  Safari 8 re-try
	            if (!retry)
	            {
	                retry = true;
	
	                File.revokeObjectURL(_this.data);
	
	                _this.data.src = 'data:image/svg+xml,' + encodeURIComponent(svg.join(''));
	            }
	            else
	            {
	                _this.onProcessError();
	            }
	        };
	
	        File.createObjectURL(this.data, blob, 'image/svg+xml');
	    },
	
	    /**
	     * Adds this file to its target cache upon successful loading and processing.
	     *
	     * @method Phaser.Loader.FileTypes.SVGFile#addToCache
	     * @since 3.7.0
	     */
	    addToCache: function ()
	    {
	        var texture = this.cache.addImage(this.key, this.data);
	
	        this.pendingDestroy(texture);
	    }
	
	});
	
	/**
	 * Adds an SVG File, or array of SVG Files, to the current load queue.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.svg('morty', 'images/Morty.svg');
	 * }
	 * ```
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 *
	 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
	 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
	 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
	 * then remove it from the Texture Manager first, before loading a new one.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.svg({
	 *     key: 'morty',
	 *     url: 'images/Morty.svg'
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.SVGFileConfig` for more details.
	 *
	 * Once the file has finished loading you can use it as a texture for a Game Object by referencing its key:
	 * 
	 * ```javascript
	 * this.load.svg('morty', 'images/Morty.svg');
	 * // and later in your game ...
	 * this.add.image(x, y, 'morty');
	 * ```
	 *
	 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
	 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
	 * this is what you would use to retrieve the image from the Texture Manager.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
	 * and no URL is given then the Loader will set the URL to be "alien.html". It will always add `.html` as the extension, although
	 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
	 *
	 * Note: The ability to load this type of file will only be available if the SVG File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#svg
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.0.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.SVGFileConfig|Phaser.Loader.FileTypes.SVGFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.svg`, i.e. if `key` was "alien" then the URL will be "alien.svg".
	 * @param {XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('svg', function (key, url, xhrSettings)
	{
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
	            this.addFile(new SVGFile(this, key[i]));
	        }
	    }
	    else
	    {
	        this.addFile(new SVGFile(this, key, url, xhrSettings));
	    }
	
	    return this;
	});
	
	module.exports = SVGFile;


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(35);
	var File = __webpack_require__(44);
	var FileTypesManager = __webpack_require__(15);
	var GetFastValue = __webpack_require__(3);
	var IsPlainObject = __webpack_require__(17);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.ScenePluginFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within the Loader.
	 * @property {(string|function)} [url] - The absolute or relative URL to load the file from. Or, a Scene Plugin.
	 * @property {string} [extension='js'] - The default file extension to use if no url is provided.
	 * @property {string} [systemKey] - If this plugin is to be added to Scene.Systems, this is the property key for it.
	 * @property {string} [sceneKey] - If this plugin is to be added to the Scene, this is the property key for it.
	 * @property {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	
	/**
	 * @classdesc
	 * A single Scene Plugin Script File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#scenePlugin method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#scenePlugin.
	 *
	 * @class ScenePluginFile
	 * @extends Phaser.Loader.File
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.8.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.ScenePluginFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
	 * @param {string} [systemKey] - If this plugin is to be added to Scene.Systems, this is the property key for it.
	 * @param {string} [sceneKey] - If this plugin is to be added to the Scene, this is the property key for it.
	 * @param {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	var ScenePluginFile = new Class({
	
	    Extends: File,
	
	    initialize:
	
	    function ScenePluginFile (loader, key, url, systemKey, sceneKey, xhrSettings)
	    {
	        var extension = 'js';
	
	        if (IsPlainObject(key))
	        {
	            var config = key;
	
	            key = GetFastValue(config, 'key');
	            url = GetFastValue(config, 'url');
	            xhrSettings = GetFastValue(config, 'xhrSettings');
	            extension = GetFastValue(config, 'extension', extension);
	            systemKey = GetFastValue(config, 'systemKey');
	            sceneKey = GetFastValue(config, 'sceneKey');
	        }
	
	        var fileConfig = {
	            type: 'scenePlugin',
	            cache: false,
	            extension: extension,
	            responseType: 'text',
	            key: key,
	            url: url,
	            xhrSettings: xhrSettings,
	            config: {
	                systemKey: systemKey,
	                sceneKey: sceneKey
	            }
	        };
	
	        File.call(this, loader, fileConfig);
	
	        // If the url variable refers to a class, add the plugin directly
	        if (typeof url === 'function')
	        {
	            this.data = url;
	
	            this.state = CONST.FILE_POPULATED;
	        }
	    },
	
	    /**
	     * Called automatically by Loader.nextFile.
	     * This method controls what extra work this File does with its loaded data.
	     *
	     * @method Phaser.Loader.FileTypes.ScenePluginFile#onProcess
	     * @since 3.8.0
	     */
	    onProcess: function ()
	    {
	        var pluginManager = this.loader.systems.plugins;
	        var config = this.config;
	
	        var key = this.key;
	        var systemKey = GetFastValue(config, 'systemKey', key);
	        var sceneKey = GetFastValue(config, 'sceneKey', key);
	
	        if (this.state === CONST.FILE_POPULATED)
	        {
	            pluginManager.installScenePlugin(systemKey, this.data, sceneKey, this.loader.scene);
	        }
	        else
	        {
	            //  Plugin added via a js file
	            this.state = CONST.FILE_PROCESSING;
	
	            this.data = document.createElement('script');
	            this.data.language = 'javascript';
	            this.data.type = 'text/javascript';
	            this.data.defer = false;
	            this.data.text = this.xhrLoader.responseText;
	
	            document.head.appendChild(this.data);
	
	            pluginManager.installScenePlugin(systemKey, window[this.key], sceneKey, this.loader.scene);
	        }
	
	        this.onProcessComplete();
	    }
	
	});
	
	/**
	 * Adds a Scene Plugin Script file, or array of plugin files, to the current load queue.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.scenePlugin('ModPlayer', 'plugins/ModPlayer.js', 'modPlayer', 'mods');
	 * }
	 * ```
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 * 
	 * The key must be a unique String and not already in-use by another file in the Loader.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.scenePlugin({
	 *     key: 'modplayer',
	 *     url: 'plugins/ModPlayer.js'
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.ScenePluginFileConfig` for more details.
	 *
	 * Once the file has finished loading it will automatically be converted into a script element
	 * via `document.createElement('script')`. It will have its language set to JavaScript, `defer` set to
	 * false and then the resulting element will be appended to `document.head`. Any code then in the
	 * script will be executed. It will then be passed to the Phaser PluginCache.register method.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
	 * and no URL is given then the Loader will set the URL to be "alien.js". It will always add `.js` as the extension, although
	 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
	 *
	 * Note: The ability to load this type of file will only be available if the Script File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#scenePlugin
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.8.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.ScenePluginFileConfig|Phaser.Loader.FileTypes.ScenePluginFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {(string|function)} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js". Or, set to a plugin function.
	 * @param {string} [systemKey] - If this plugin is to be added to Scene.Systems, this is the property key for it.
	 * @param {string} [sceneKey] - If this plugin is to be added to the Scene, this is the property key for it.
	 * @param {XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('scenePlugin', function (key, url, systemKey, sceneKey, xhrSettings)
	{
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
	            this.addFile(new ScenePluginFile(this, key[i]));
	        }
	    }
	    else
	    {
	        this.addFile(new ScenePluginFile(this, key, url, systemKey, sceneKey, xhrSettings));
	    }
	
	    return this;
	});
	
	module.exports = ScenePluginFile;


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(35);
	var File = __webpack_require__(44);
	var FileTypesManager = __webpack_require__(15);
	var GetFastValue = __webpack_require__(3);
	var IsPlainObject = __webpack_require__(17);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.ScriptFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within the Loader.
	 * @property {string} [url] - The absolute or relative URL to load the file from.
	 * @property {string} [extension='js'] - The default file extension to use if no url is provided.
	 * @property {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	
	/**
	 * @classdesc
	 * A single Script File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#script method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#script.
	 *
	 * @class ScriptFile
	 * @extends Phaser.Loader.File
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.ScriptFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
	 * @param {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	var ScriptFile = new Class({
	
	    Extends: File,
	
	    initialize:
	
	    function ScriptFile (loader, key, url, xhrSettings)
	    {
	        var extension = 'js';
	
	        if (IsPlainObject(key))
	        {
	            var config = key;
	
	            key = GetFastValue(config, 'key');
	            url = GetFastValue(config, 'url');
	            xhrSettings = GetFastValue(config, 'xhrSettings');
	            extension = GetFastValue(config, 'extension', extension);
	        }
	
	        var fileConfig = {
	            type: 'script',
	            cache: false,
	            extension: extension,
	            responseType: 'text',
	            key: key,
	            url: url,
	            xhrSettings: xhrSettings
	        };
	
	        File.call(this, loader, fileConfig);
	    },
	
	    /**
	     * Called automatically by Loader.nextFile.
	     * This method controls what extra work this File does with its loaded data.
	     *
	     * @method Phaser.Loader.FileTypes.ScriptFile#onProcess
	     * @since 3.7.0
	     */
	    onProcess: function ()
	    {
	        this.state = CONST.FILE_PROCESSING;
	
	        this.data = document.createElement('script');
	        this.data.language = 'javascript';
	        this.data.type = 'text/javascript';
	        this.data.defer = false;
	        this.data.text = this.xhrLoader.responseText;
	
	        document.head.appendChild(this.data);
	
	        this.onProcessComplete();
	    }
	
	});
	
	/**
	 * Adds a Script file, or array of Script files, to the current load queue.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.script('aliens', 'lib/aliens.js');
	 * }
	 * ```
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 * 
	 * The key must be a unique String and not already in-use by another file in the Loader.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.script({
	 *     key: 'aliens',
	 *     url: 'lib/aliens.js'
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.ScriptFileConfig` for more details.
	 *
	 * Once the file has finished loading it will automatically be converted into a script element
	 * via `document.createElement('script')`. It will have its language set to JavaScript, `defer` set to
	 * false and then the resulting element will be appended to `document.head`. Any code then in the
	 * script will be executed.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
	 * and no URL is given then the Loader will set the URL to be "alien.js". It will always add `.js` as the extension, although
	 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
	 *
	 * Note: The ability to load this type of file will only be available if the Script File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#script
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.0.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.ScriptFileConfig|Phaser.Loader.FileTypes.ScriptFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.js`, i.e. if `key` was "alien" then the URL will be "alien.js".
	 * @param {XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('script', function (key, url, xhrSettings)
	{
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
	            this.addFile(new ScriptFile(this, key[i]));
	        }
	    }
	    else
	    {
	        this.addFile(new ScriptFile(this, key, url, xhrSettings));
	    }
	
	    return this;
	});
	
	module.exports = ScriptFile;


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var FileTypesManager = __webpack_require__(15);
	var ImageFile = __webpack_require__(115);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.SpriteSheetFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within both the Loader and the Texture Manager.
	 * @property {string} [url] - The absolute or relative URL to load the file from.
	 * @property {string} [extension='png'] - The default file extension to use if no url is provided.
	 * @property {string} [normalMap] - The filename of an associated normal map. It uses the same path and url to load as the image.
	 * @property {Phaser.Loader.FileTypes.ImageFrameConfig} [frameConfig] - The frame configuration object.
	 * @property {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	
	/**
	 * @classdesc
	 * A single Sprite Sheet Image File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#spritesheet method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#spritesheet.
	 *
	 * @class SpriteSheetFile
	 * @extends Phaser.Loader.File
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.SpriteSheetFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string|string[]} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
	 * @param {Phaser.Loader.FileTypes.ImageFrameConfig} [frameConfig] - The frame configuration object.
	 * @param {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	var SpriteSheetFile = new Class({
	
	    Extends: ImageFile,
	
	    initialize:
	
	    function SpriteSheetFile (loader, key, url, frameConfig, xhrSettings)
	    {
	        ImageFile.call(this, loader, key, url, xhrSettings, frameConfig);
	
	        this.type = 'spritesheet';
	    },
	
	    /**
	     * Adds this file to its target cache upon successful loading and processing.
	     *
	     * @method Phaser.Loader.FileTypes.SpriteSheetFile#addToCache
	     * @since 3.7.0
	     */
	    addToCache: function ()
	    {
	        var texture = this.cache.addSpriteSheet(this.key, this.data, this.config);
	
	        this.pendingDestroy(texture);
	    }
	
	});
	
	/**
	 * Adds a Sprite Sheet Image, or array of Sprite Sheet Images, to the current load queue.
	 *
	 * The term 'Sprite Sheet' in Phaser means a fixed-size sheet. Where every frame in the sheet is the exact same size,
	 * and you reference those frames using numbers, not frame names. This is not the same thing as a Texture Atlas, where
	 * the frames are packed in a way where they take up the least amount of space, and are referenced by their names,
	 * not numbers. Some articles and software use the term 'Sprite Sheet' to mean Texture Atlas, so please be aware of
	 * what sort of file you're actually trying to load.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.spritesheet('bot', 'images/robot.png', { frameWidth: 32, frameHeight: 38 });
	 * }
	 * ```
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 * 
	 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
	 * If you try to load an animated gif only the first frame will be rendered. Browsers do not natively support playback
	 * of animated gifs to Canvas elements.
	 *
	 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
	 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
	 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
	 * then remove it from the Texture Manager first, before loading a new one.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.spritesheet({
	 *     key: 'bot',
	 *     url: 'images/robot.png',
	 *     frameConfig: {
	 *         frameWidth: 32,
	 *         frameHeight: 38,
	 *         startFrame: 0,
	 *         endFrame: 8
	 *     }
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.SpriteSheetFileConfig` for more details.
	 *
	 * Once the file has finished loading you can use it as a texture for a Game Object by referencing its key:
	 * 
	 * ```javascript
	 * this.load.spritesheet('bot', 'images/robot.png', { frameWidth: 32, frameHeight: 38 });
	 * // and later in your game ...
	 * this.add.image(x, y, 'bot', 0);
	 * ```
	 *
	 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
	 * key. For example, if the prefix was `PLAYER.` and the key was `Running` the final key will be `PLAYER.Running` and
	 * this is what you would use to retrieve the image from the Texture Manager.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
	 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
	 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
	 *
	 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
	 * then you can specify it by providing an array as the `url` where the second element is the normal map:
	 * 
	 * ```javascript
	 * this.load.spritesheet('logo', [ 'images/AtariLogo.png', 'images/AtariLogo-n.png' ], { frameWidth: 256, frameHeight: 80 });
	 * ```
	 *
	 * Or, if you are using a config object use the `normalMap` property:
	 * 
	 * ```javascript
	 * this.load.spritesheet({
	 *     key: 'logo',
	 *     url: 'images/AtariLogo.png',
	 *     normalMap: 'images/AtariLogo-n.png',
	 *     frameConfig: {
	 *         frameWidth: 256,
	 *         frameHeight: 80
	 *     }
	 * });
	 * ```
	 *
	 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
	 * Normal maps are a WebGL only feature.
	 * 
	 * Note: The ability to load this type of file will only be available if the Sprite Sheet File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#spritesheet
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.0.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.SpriteSheetFileConfig|Phaser.Loader.FileTypes.SpriteSheetFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
	 * @param {Phaser.Loader.FileTypes.ImageFrameConfig} [frameConfig] - The frame configuration object. At a minimum it should have a `frameWidth` property.
	 * @param {XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('spritesheet', function (key, url, frameConfig, xhrSettings)
	{
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
	            this.addFile(new SpriteSheetFile(this, key[i]));
	        }
	    }
	    else
	    {
	        this.addFile(new SpriteSheetFile(this, key, url, frameConfig, xhrSettings));
	    }
	
	    return this;
	});
	
	module.exports = SpriteSheetFile;


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(35);
	var File = __webpack_require__(44);
	var FileTypesManager = __webpack_require__(15);
	var GetFastValue = __webpack_require__(3);
	var IsPlainObject = __webpack_require__(17);
	var TILEMAP_FORMATS = __webpack_require__(57);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.TilemapCSVFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within both the Loader and the Tilemap Cache.
	 * @property {string} [url] - The absolute or relative URL to load the file from.
	 * @property {string} [extension='csv'] - The default file extension to use if no url is provided.
	 * @property {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	
	/**
	 * @classdesc
	 * A single Tilemap CSV File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#tilemapCSV method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#tilemapCSV.
	 *
	 * @class TilemapCSVFile
	 * @extends Phaser.Loader.File
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.TilemapCSVFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.csv`, i.e. if `key` was "alien" then the URL will be "alien.csv".
	 * @param {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	var TilemapCSVFile = new Class({
	
	    Extends: File,
	
	    initialize:
	
	    function TilemapCSVFile (loader, key, url, xhrSettings)
	    {
	        var extension = 'csv';
	
	        if (IsPlainObject(key))
	        {
	            var config = key;
	
	            key = GetFastValue(config, 'key');
	            url = GetFastValue(config, 'url');
	            xhrSettings = GetFastValue(config, 'xhrSettings');
	            extension = GetFastValue(config, 'extension', extension);
	        }
	
	        var fileConfig = {
	            type: 'tilemapCSV',
	            cache: loader.cacheManager.tilemap,
	            extension: extension,
	            responseType: 'text',
	            key: key,
	            url: url,
	            xhrSettings: xhrSettings
	        };
	
	        File.call(this, loader, fileConfig);
	
	        this.tilemapFormat = TILEMAP_FORMATS.CSV;
	    },
	
	    /**
	     * Called automatically by Loader.nextFile.
	     * This method controls what extra work this File does with its loaded data.
	     *
	     * @method Phaser.Loader.FileTypes.TilemapCSVFile#onProcess
	     * @since 3.7.0
	     */
	    onProcess: function ()
	    {
	        this.state = CONST.FILE_PROCESSING;
	
	        this.data = this.xhrLoader.responseText;
	
	        this.onProcessComplete();
	    },
	
	    /**
	     * Adds this file to its target cache upon successful loading and processing.
	     *
	     * @method Phaser.Loader.FileTypes.TilemapCSVFile#addToCache
	     * @since 3.7.0
	     */
	    addToCache: function ()
	    {
	        var tiledata = { format: this.tilemapFormat, data: this.data };
	
	        this.cache.add(this.key, tiledata);
	
	        this.pendingDestroy(tiledata);
	    }
	
	});
	
	/**
	 * Adds a CSV Tilemap file, or array of CSV files, to the current load queue.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.tilemapCSV('level1', maps/Level1.csv');
	 * }
	 * ```
	 *
	 * Tilemap CSV data can be created in a text editor, or a 3rd party app that exports as CSV.
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 * 
	 * The key must be a unique String. It is used to add the file to the global Tilemap Cache upon a successful load.
	 * The key should be unique both in terms of files being loaded and files already present in the Tilemap Cache.
	 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
	 * then remove it from the Text Cache first, before loading a new one.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.tilemapCSV({
	 *     key: 'level1',
	 *     url: 'maps/Level1.csv'
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.TilemapCSVFileConfig` for more details.
	 *
	 * Once the file has finished loading you can access it from its Cache using its key:
	 * 
	 * ```javascript
	 * this.load.tilemapCSV('level1', 'maps/Level1.csv');
	 * // and later in your game ...
	 * var map = this.make.tilemap({ key: 'level1' });
	 * ```
	 *
	 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
	 * key. For example, if the prefix was `LEVEL1.` and the key was `Story` the final key will be `LEVEL1.Story` and
	 * this is what you would use to retrieve the text from the Tilemap Cache.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "level"
	 * and no URL is given then the Loader will set the URL to be "level.csv". It will always add `.csv` as the extension, although
	 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
	 *
	 * Note: The ability to load this type of file will only be available if the Tilemap CSV File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#tilemapCSV
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.0.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.TilemapCSVFileConfig|Phaser.Loader.FileTypes.TilemapCSVFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.csv`, i.e. if `key` was "alien" then the URL will be "alien.csv".
	 * @param {XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('tilemapCSV', function (key, url, xhrSettings)
	{
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
	            this.addFile(new TilemapCSVFile(this, key[i]));
	        }
	    }
	    else
	    {
	        this.addFile(new TilemapCSVFile(this, key, url, xhrSettings));
	    }
	
	    return this;
	});
	
	module.exports = TilemapCSVFile;


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var FileTypesManager = __webpack_require__(15);
	var JSONFile = __webpack_require__(96);
	var TILEMAP_FORMATS = __webpack_require__(57);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.TilemapImpactFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within both the Loader and the Tilemap Cache.
	 * @property {string} [url] - The absolute or relative URL to load the file from.
	 * @property {string} [extension='json'] - The default file extension to use if no url is provided.
	 * @property {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	
	/**
	 * @classdesc
	 * A single Impact.js Tilemap JSON File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#tilemapImpact method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#tilemapImpact.
	 *
	 * @class TilemapImpactFile
	 * @extends Phaser.Loader.File
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.7.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.TilemapImpactFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
	 * @param {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	var TilemapImpactFile = new Class({
	
	    Extends: JSONFile,
	
	    initialize:
	
	    function TilemapImpactFile (loader, key, url, xhrSettings)
	    {
	        JSONFile.call(this, loader, key, url, xhrSettings);
	
	        this.type = 'tilemapJSON';
	
	        this.cache = loader.cacheManager.tilemap;
	    },
	
	    /**
	     * Adds this file to its target cache upon successful loading and processing.
	     *
	     * @method Phaser.Loader.FileTypes.TilemapImpactFile#addToCache
	     * @since 3.7.0
	     */
	    addToCache: function ()
	    {
	        var tiledata = { format: TILEMAP_FORMATS.WELTMEISTER, data: this.data };
	
	        this.cache.add(this.key, tiledata);
	
	        this.pendingDestroy(tiledata);
	    }
	
	});
	
	/**
	 * Adds an Impact.js Tilemap file, or array of map files, to the current load queue.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.tilemapImpact('level1', maps/Level1.json');
	 * }
	 * ```
	 *
	 * Impact Tilemap data is created the Impact.js Map Editor called Weltmeister.
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 * 
	 * The key must be a unique String. It is used to add the file to the global Tilemap Cache upon a successful load.
	 * The key should be unique both in terms of files being loaded and files already present in the Tilemap Cache.
	 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
	 * then remove it from the Text Cache first, before loading a new one.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.tilemapImpact({
	 *     key: 'level1',
	 *     url: 'maps/Level1.json'
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.TilemapImpactFileConfig` for more details.
	 *
	 * Once the file has finished loading you can access it from its Cache using its key:
	 * 
	 * ```javascript
	 * this.load.tilemapImpact('level1', 'maps/Level1.json');
	 * // and later in your game ...
	 * var map = this.make.tilemap({ key: 'level1' });
	 * ```
	 *
	 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
	 * key. For example, if the prefix was `LEVEL1.` and the key was `Story` the final key will be `LEVEL1.Story` and
	 * this is what you would use to retrieve the text from the Tilemap Cache.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "level"
	 * and no URL is given then the Loader will set the URL to be "level.json". It will always add `.json` as the extension, although
	 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
	 *
	 * Note: The ability to load this type of file will only be available if the Tilemap Impact File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#tilemapImpact
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.7.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.TilemapImpactFileConfig|Phaser.Loader.FileTypes.TilemapImpactFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
	 * @param {XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('tilemapImpact', function (key, url, xhrSettings)
	{
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
	            this.addFile(new TilemapImpactFile(this, key[i]));
	        }
	    }
	    else
	    {
	        this.addFile(new TilemapImpactFile(this, key, url, xhrSettings));
	    }
	
	    return this;
	});
	
	module.exports = TilemapImpactFile;


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var FileTypesManager = __webpack_require__(15);
	var JSONFile = __webpack_require__(96);
	var TILEMAP_FORMATS = __webpack_require__(57);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.TilemapJSONFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within both the Loader and the Tilemap Cache.
	 * @property {string} [url] - The absolute or relative URL to load the file from.
	 * @property {string} [extension='json'] - The default file extension to use if no url is provided.
	 * @property {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	
	/**
	 * @classdesc
	 * A single Tiled Tilemap JSON File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#tilemapTiledJSON method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#tilemapTiledJSON.
	 *
	 * @class TilemapJSONFile
	 * @extends Phaser.Loader.File
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.TilemapJSONFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
	 * @param {XHRSettingsObject} [xhrSettings] - Extra XHR Settings specifically for this file.
	 */
	var TilemapJSONFile = new Class({
	
	    Extends: JSONFile,
	
	    initialize:
	
	    function TilemapJSONFile (loader, key, url, xhrSettings)
	    {
	        JSONFile.call(this, loader, key, url, xhrSettings);
	
	        this.type = 'tilemapJSON';
	
	        this.cache = loader.cacheManager.tilemap;
	    },
	
	    /**
	     * Adds this file to its target cache upon successful loading and processing.
	     *
	     * @method Phaser.Loader.FileTypes.TilemapJSONFile#addToCache
	     * @since 3.7.0
	     */
	    addToCache: function ()
	    {
	        var tiledata = { format: TILEMAP_FORMATS.TILED_JSON, data: this.data };
	
	        this.cache.add(this.key, tiledata);
	
	        this.pendingDestroy(tiledata);
	    }
	
	});
	
	/**
	 * Adds a Tiled JSON Tilemap file, or array of map files, to the current load queue.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.tilemapTiledJSON('level1', maps/Level1.json');
	 * }
	 * ```
	 *
	 * The Tilemap data is created using the Tiled Map Editor and selecting JSON as the export format.
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 * 
	 * The key must be a unique String. It is used to add the file to the global Tilemap Cache upon a successful load.
	 * The key should be unique both in terms of files being loaded and files already present in the Tilemap Cache.
	 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
	 * then remove it from the Text Cache first, before loading a new one.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.tilemapTiledJSON({
	 *     key: 'level1',
	 *     url: 'maps/Level1.json'
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.TilemapJSONFileConfig` for more details.
	 *
	 * Once the file has finished loading you can access it from its Cache using its key:
	 * 
	 * ```javascript
	 * this.load.tilemapTiledJSON('level1', 'maps/Level1.json');
	 * // and later in your game ...
	 * var map = this.make.tilemap({ key: 'level1' });
	 * ```
	 *
	 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
	 * key. For example, if the prefix was `LEVEL1.` and the key was `Story` the final key will be `LEVEL1.Story` and
	 * this is what you would use to retrieve the text from the Tilemap Cache.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "level"
	 * and no URL is given then the Loader will set the URL to be "level.json". It will always add `.json` as the extension, although
	 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
	 *
	 * Note: The ability to load this type of file will only be available if the Tilemap JSON File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#tilemapTiledJSON
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.0.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.TilemapJSONFileConfig|Phaser.Loader.FileTypes.TilemapJSONFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {string} [url] - The absolute or relative URL to load this file from. If undefined or `null` it will be set to `<key>.json`, i.e. if `key` was "alien" then the URL will be "alien.json".
	 * @param {XHRSettingsObject} [xhrSettings] - An XHR Settings configuration object. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('tilemapTiledJSON', function (key, url, xhrSettings)
	{
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            //  If it's an array it has to be an array of Objects, so we get everything out of the 'key' object
	            this.addFile(new TilemapJSONFile(this, key[i]));
	        }
	    }
	    else
	    {
	        this.addFile(new TilemapJSONFile(this, key, url, xhrSettings));
	    }
	
	    return this;
	});
	
	module.exports = TilemapJSONFile;


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var FileTypesManager = __webpack_require__(15);
	var GetFastValue = __webpack_require__(3);
	var ImageFile = __webpack_require__(115);
	var IsPlainObject = __webpack_require__(17);
	var MultiFile = __webpack_require__(114);
	var TextFile = __webpack_require__(547);
	
	/**
	 * @typedef {object} Phaser.Loader.FileTypes.UnityAtlasFileConfig
	 *
	 * @property {string} key - The key of the file. Must be unique within both the Loader and the Texture Manager.
	 * @property {string} [textureURL] - The absolute or relative URL to load the texture image file from.
	 * @property {string} [textureExtension='png'] - The default file extension to use for the image texture if no url is provided.
	 * @property {XHRSettingsObject} [textureXhrSettings] - Extra XHR Settings specifically for the texture image file.
	 * @property {string} [normalMap] - The filename of an associated normal map. It uses the same path and url to load as the texture image.
	 * @property {string} [atlasURL] - The absolute or relative URL to load the atlas data file from.
	 * @property {string} [atlasExtension='txt'] - The default file extension to use for the atlas data if no url is provided.
	 * @property {XHRSettingsObject} [atlasXhrSettings] - Extra XHR Settings specifically for the atlas data file.
	 */
	
	/**
	 * @classdesc
	 * A single text file based Unity Texture Atlas File suitable for loading by the Loader.
	 *
	 * These are created when you use the Phaser.Loader.LoaderPlugin#unityAtlas method and are not typically created directly.
	 * 
	 * For documentation about what all the arguments and configuration options mean please see Phaser.Loader.LoaderPlugin#unityAtlas.
	 *
	 * @class UnityAtlasFile
	 * @extends Phaser.Loader.MultiFile
	 * @memberOf Phaser.Loader.FileTypes
	 * @constructor
	 *
	 * @param {Phaser.Loader.LoaderPlugin} loader - A reference to the Loader that is responsible for this file.
	 * @param {(string|Phaser.Loader.FileTypes.UnityAtlasFileConfig)} key - The key to use for this file, or a file configuration object.
	 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
	 * @param {string} [atlasURL] - The absolute or relative URL to load the texture atlas data file from. If undefined or `null` it will be set to `<key>.txt`, i.e. if `key` was "alien" then the URL will be "alien.txt".
	 * @param {XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
	 * @param {XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas data file. Used in replacement of the Loaders default XHR Settings.
	 */
	var UnityAtlasFile = new Class({
	
	    Extends: MultiFile,
	
	    initialize:
	
	    function UnityAtlasFile (loader, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings)
	    {
	        var image;
	        var data;
	
	        if (IsPlainObject(key))
	        {
	            var config = key;
	
	            image = new ImageFile(loader, {
	                key: key,
	                url: GetFastValue(config, 'textureURL'),
	                extension: GetFastValue(config, 'textureExtension', 'png'),
	                normalMap: GetFastValue(config, 'normalMap'),
	                xhrSettings: GetFastValue(config, 'textureXhrSettings')
	            });
	
	            data = new TextFile(loader, {
	                key: key,
	                url: GetFastValue(config, 'atlasURL'),
	                extension: GetFastValue(config, 'atlasExtension', 'txt'),
	                xhrSettings: GetFastValue(config, 'atlasXhrSettings')
	            });
	        }
	        else
	        {
	            image = new ImageFile(loader, key, textureURL, textureXhrSettings);
	            data = new TextFile(loader, key, atlasURL, atlasXhrSettings);
	        }
	
	        if (image.linkFile)
	        {
	            //  Image has a normal map
	            MultiFile.call(this, loader, 'unityatlas', key, [ image, data, image.linkFile ]);
	        }
	        else
	        {
	            MultiFile.call(this, loader, 'unityatlas', key, [ image, data ]);
	        }
	    },
	
	    /**
	     * Adds this file to its target cache upon successful loading and processing.
	     *
	     * @method Phaser.Loader.FileTypes.UnityAtlasFile#addToCache
	     * @since 3.7.0
	     */
	    addToCache: function ()
	    {
	        if (this.failed === 0 && !this.complete)
	        {
	            var image = this.files[0];
	            var text = this.files[1];
	            var normalMap = (this.files[2]) ? this.files[2].data : null;
	
	            this.loader.textureManager.addUnityAtlas(image.key, image.data, text.data, normalMap);
	
	            text.addToCache();
	
	            this.complete = true;
	        }
	    }
	
	});
	
	/**
	 * Adds a Unity YAML based Texture Atlas, or array of atlases, to the current load queue.
	 *
	 * You can call this method from within your Scene's `preload`, along with any other files you wish to load:
	 * 
	 * ```javascript
	 * function preload ()
	 * {
	 *     this.load.unityAtlas('mainmenu', 'images/MainMenu.png', 'images/MainMenu.txt');
	 * }
	 * ```
	 *
	 * The file is **not** loaded right away. It is added to a queue ready to be loaded either when the loader starts,
	 * or if it's already running, when the next free load slot becomes available. This happens automatically if you
	 * are calling this from within the Scene's `preload` method, or a related callback. Because the file is queued
	 * it means you cannot use the file immediately after calling this method, but must wait for the file to complete.
	 * The typical flow for a Phaser Scene is that you load assets in the Scene's `preload` method and then when the
	 * Scene's `create` method is called you are guaranteed that all of those assets are ready for use and have been
	 * loaded.
	 * 
	 * If you call this from outside of `preload` then you are responsible for starting the Loader afterwards and monitoring
	 * its events to know when it's safe to use the asset. Please see the Phaser.Loader.LoaderPlugin class for more details.
	 *
	 * Phaser expects the atlas data to be provided in a YAML formatted text file as exported from Unity.
	 * 
	 * Phaser can load all common image types: png, jpg, gif and any other format the browser can natively handle.
	 *
	 * The key must be a unique String. It is used to add the file to the global Texture Manager upon a successful load.
	 * The key should be unique both in terms of files being loaded and files already present in the Texture Manager.
	 * Loading a file using a key that is already taken will result in a warning. If you wish to replace an existing file
	 * then remove it from the Texture Manager first, before loading a new one.
	 *
	 * Instead of passing arguments you can pass a configuration object, such as:
	 * 
	 * ```javascript
	 * this.load.unityAtlas({
	 *     key: 'mainmenu',
	 *     textureURL: 'images/MainMenu.png',
	 *     atlasURL: 'images/MainMenu.txt'
	 * });
	 * ```
	 *
	 * See the documentation for `Phaser.Loader.FileTypes.UnityAtlasFileConfig` for more details.
	 *
	 * Once the atlas has finished loading you can use frames from it as textures for a Game Object by referencing its key:
	 * 
	 * ```javascript
	 * this.load.unityAtlas('mainmenu', 'images/MainMenu.png', 'images/MainMenu.json');
	 * // and later in your game ...
	 * this.add.image(x, y, 'mainmenu', 'background');
	 * ```
	 *
	 * To get a list of all available frames within an atlas please consult your Texture Atlas software.
	 *
	 * If you have specified a prefix in the loader, via `Loader.setPrefix` then this value will be prepended to this files
	 * key. For example, if the prefix was `MENU.` and the key was `Background` the final key will be `MENU.Background` and
	 * this is what you would use to retrieve the image from the Texture Manager.
	 *
	 * The URL can be relative or absolute. If the URL is relative the `Loader.baseURL` and `Loader.path` values will be prepended to it.
	 *
	 * If the URL isn't specified the Loader will take the key and create a filename from that. For example if the key is "alien"
	 * and no URL is given then the Loader will set the URL to be "alien.png". It will always add `.png` as the extension, although
	 * this can be overridden if using an object instead of method arguments. If you do not desire this action then provide a URL.
	 *
	 * Phaser also supports the automatic loading of associated normal maps. If you have a normal map to go with this image,
	 * then you can specify it by providing an array as the `url` where the second element is the normal map:
	 * 
	 * ```javascript
	 * this.load.unityAtlas('mainmenu', [ 'images/MainMenu.png', 'images/MainMenu-n.png' ], 'images/MainMenu.txt');
	 * ```
	 *
	 * Or, if you are using a config object use the `normalMap` property:
	 * 
	 * ```javascript
	 * this.load.unityAtlas({
	 *     key: 'mainmenu',
	 *     textureURL: 'images/MainMenu.png',
	 *     normalMap: 'images/MainMenu-n.png',
	 *     atlasURL: 'images/MainMenu.txt'
	 * });
	 * ```
	 *
	 * The normal map file is subject to the same conditions as the image file with regard to the path, baseURL, CORs and XHR Settings.
	 * Normal maps are a WebGL only feature.
	 *
	 * Note: The ability to load this type of file will only be available if the Unity Atlas File type has been built into Phaser.
	 * It is available in the default build but can be excluded from custom builds.
	 *
	 * @method Phaser.Loader.LoaderPlugin#unityAtlas
	 * @fires Phaser.Loader.LoaderPlugin#addFileEvent
	 * @since 3.0.0
	 *
	 * @param {(string|Phaser.Loader.FileTypes.UnityAtlasFileConfig|Phaser.Loader.FileTypes.UnityAtlasFileConfig[])} key - The key to use for this file, or a file configuration object, or array of them.
	 * @param {string|string[]} [textureURL] - The absolute or relative URL to load the texture image file from. If undefined or `null` it will be set to `<key>.png`, i.e. if `key` was "alien" then the URL will be "alien.png".
	 * @param {string} [atlasURL] - The absolute or relative URL to load the texture atlas data file from. If undefined or `null` it will be set to `<key>.txt`, i.e. if `key` was "alien" then the URL will be "alien.txt".
	 * @param {XHRSettingsObject} [textureXhrSettings] - An XHR Settings configuration object for the atlas image file. Used in replacement of the Loaders default XHR Settings.
	 * @param {XHRSettingsObject} [atlasXhrSettings] - An XHR Settings configuration object for the atlas data file. Used in replacement of the Loaders default XHR Settings.
	 *
	 * @return {Phaser.Loader.LoaderPlugin} The Loader instance.
	 */
	FileTypesManager.register('unityAtlas', function (key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings)
	{
	    var multifile;
	
	    //  Supports an Object file definition in the key argument
	    //  Or an array of objects in the key argument
	    //  Or a single entry where all arguments have been defined
	
	    if (Array.isArray(key))
	    {
	        for (var i = 0; i < key.length; i++)
	        {
	            multifile = new UnityAtlasFile(this, key[i]);
	
	            this.addFile(multifile.files);
	        }
	    }
	    else
	    {
	        multifile = new UnityAtlasFile(this, key, textureURL, atlasURL, textureXhrSettings, atlasXhrSettings);
	
	        this.addFile(multifile.files);
	    }
	
	    return this;
	});
	
	module.exports = UnityAtlasFile;


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Loader.FileTypes
	 */
	
	module.exports = {
	
	    AnimationJSONFile: __webpack_require__(1328),
	    AtlasJSONFile: __webpack_require__(1329),
	    AtlasXMLFile: __webpack_require__(1330),
	    AudioFile: __webpack_require__(545),
	    AudioSpriteFile: __webpack_require__(1331),
	    BinaryFile: __webpack_require__(1332),
	    BitmapFontFile: __webpack_require__(1333),
	    GLSLFile: __webpack_require__(1334),
	    HTML5AudioFile: __webpack_require__(546),
	    HTMLFile: __webpack_require__(1335),
	    ImageFile: __webpack_require__(115),
	    JSONFile: __webpack_require__(96),
	    MultiAtlasFile: __webpack_require__(1336),
	    PackFile: __webpack_require__(1337),
	    PluginFile: __webpack_require__(1338),
	    ScenePluginFile: __webpack_require__(1340),
	    ScriptFile: __webpack_require__(1341),
	    SpriteSheetFile: __webpack_require__(1342),
	    SVGFile: __webpack_require__(1339),
	    TextFile: __webpack_require__(547),
	    TilemapCSVFile: __webpack_require__(1343),
	    TilemapImpactFile: __webpack_require__(1344),
	    TilemapJSONFile: __webpack_require__(1345),
	    UnityAtlasFile: __webpack_require__(1346),
	    XMLFile: __webpack_require__(304)
	
	};


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CONST = __webpack_require__(35);
	var Extend = __webpack_require__(36);
	
	/**
	 * @namespace Phaser.Loader
	 */
	
	var Loader = {
	
	    FileTypes: __webpack_require__(1347),
	
	    File: __webpack_require__(44),
	    FileTypesManager: __webpack_require__(15),
	    GetURL: __webpack_require__(302),
	    LoaderPlugin: __webpack_require__(1327),
	    MergeXHRSettings: __webpack_require__(303),
	    MultiFile: __webpack_require__(114),
	    XHRLoader: __webpack_require__(544),
	    XHRSettings: __webpack_require__(202)
	
	};
	
	//   Merge in the consts
	Loader = Extend(false, Loader, CONST);
	
	module.exports = Loader;


/***/ }),
/* 1349 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Average
	 * @since 3.0.0
	 *
	 * @param {number[]} values - [description]
	 *
	 * @return {number} [description]
	 */
	var Average = function (values)
	{
	    var sum = 0;
	
	    for (var i = 0; i < values.length; i++)
	    {
	        sum += (+values[i]);
	    }
	
	    return sum / values.length;
	};
	
	module.exports = Average;


/***/ }),
/* 1350 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.CeilTo
	 * @since 3.0.0
	 *
	 * @param {number} value - [description]
	 * @param {number} [place=0] - [description]
	 * @param {integer} [base=10] - [description]
	 *
	 * @return {number} [description]
	 */
	var CeilTo = function (value, place, base)
	{
	    if (place === undefined) { place = 0; }
	    if (base === undefined) { base = 10; }
	
	    var p = Math.pow(base, -place);
	
	    return Math.ceil(value * p) / p;
	};
	
	module.exports = CeilTo;


/***/ }),
/* 1351 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Calculates the positive difference of two given numbers.
	 *
	 * @function Phaser.Math.Difference
	 * @since 3.0.0
	 *
	 * @param {number} a - The first number in the calculation.
	 * @param {number} b - The second number in the calculation.
	 *
	 * @return {number} The positive difference of the two given numbers.
	 */
	var Difference = function (a, b)
	{
	    return Math.abs(a - b);
	};
	
	module.exports = Difference;


/***/ }),
/* 1352 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.FloorTo
	 * @since 3.0.0
	 *
	 * @param {number} value - [description]
	 * @param {integer} [place=0 - [description]
	 * @param {integer} [base=10] - [description]
	 *
	 * @return {number} [description]
	 */
	var FloorTo = function (value, place, base)
	{
	    if (place === undefined) { place = 0; }
	    if (base === undefined) { base = 10; }
	
	    var p = Math.pow(base, -place);
	
	    return Math.floor(value * p) / p;
	};
	
	module.exports = FloorTo;


/***/ }),
/* 1353 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.GetSpeed
	 * @since 3.0.0
	 *
	 * @param {number} distance - The distance to travel in pixels.
	 * @param {integer} time - The time, in ms, to cover the distance in.
	 *
	 * @return {number} The amount you will need to increment the position by each step in order to cover the distance in the time given.
	 */
	var GetSpeed = function (distance, time)
	{
	    return (distance / time) / 1000;
	};
	
	module.exports = GetSpeed;


/***/ }),
/* 1354 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Check if a given value is an even number.
	 *
	 * @function Phaser.Math.IsEven
	 * @since 3.0.0
	 *
	 * @param {number} value - The number to perform the check with.
	 *
	 * @return {boolean} Whether the number is even or not.
	 */
	var IsEven = function (value)
	{
	    // Use abstract equality == for "is number" test
	
	    // eslint-disable-next-line eqeqeq
	    return (value == parseFloat(value)) ? !(value % 2) : void 0;
	};
	
	module.exports = IsEven;


/***/ }),
/* 1355 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.IsEvenStrict
	 * @since 3.0.0
	 *
	 * @param {number} value - [description]
	 *
	 * @return {boolean} [description]
	 */
	var IsEvenStrict = function (value)
	{
	    // Use strict equality === for "is number" test
	    return (value === parseFloat(value)) ? !(value % 2) : void 0;
	};
	
	module.exports = IsEvenStrict;


/***/ }),
/* 1356 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.MaxAdd
	 * @since 3.0.0
	 *
	 * @param {number} value - [description]
	 * @param {number} amount - [description]
	 * @param {number} max - [description]
	 *
	 * @return {number} [description]
	 */
	var MaxAdd = function (value, amount, max)
	{
	    return Math.min(value + amount, max);
	};
	
	module.exports = MaxAdd;


/***/ }),
/* 1357 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.MinSub
	 * @since 3.0.0
	 *
	 * @param {number} value - [description]
	 * @param {number} amount - [description]
	 * @param {number} min - [description]
	 *
	 * @return {number} [description]
	 */
	var MinSub = function (value, amount, min)
	{
	    return Math.max(value - amount, min);
	};
	
	module.exports = MinSub;


/***/ }),
/* 1358 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Work out what percentage `value` is of the range between `min` and `max`.
	 * If `max` isn't given then it will return the percentage of `value` to `min`.
	 *
	 * You can optionally specify an `upperMax` value, which is a mid-way point in the range that represents 100%, after which the % starts to go down to zero again.
	 *
	 * @function Phaser.Math.Percent
	 * @since 3.0.0
	 *
	 * @param {number} value - [description]
	 * @param {number} min - [description]
	 * @param {number} [max] - [description]
	 * @param {number} [upperMax] - [description]
	 *
	 * @return {float} A value between 0 and 1 representing the percentage.
	 */
	var Percent = function (value, min, max, upperMax)
	{
	    if (max === undefined) { max = min + 1; }
	
	    var percentage = (value - min) / (max - min);
	
	    if (percentage > 1)
	    {
	        if (upperMax !== undefined)
	        {
	            percentage = ((upperMax - value)) / (upperMax - max);
	
	            if (percentage < 0)
	            {
	                percentage = 0;
	            }
	        }
	        else
	        {
	            percentage = 1;
	        }
	    }
	    else if (percentage < 0)
	    {
	        percentage = 0;
	    }
	
	    return percentage;
	};
	
	module.exports = Percent;


/***/ }),
/* 1359 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.RandomXY
	 * @since 3.0.0
	 *
	 * @param {Phaser.Math.Vector2} vector - [description]
	 * @param {float} scale - [description]
	 *
	 * @return {Phaser.Math.Vector2} [description]
	 */
	var RandomXY = function (vector, scale)
	{
	    if (scale === undefined) { scale = 1; }
	
	    var r = Math.random() * 2 * Math.PI;
	
	    vector.x = Math.cos(r) * scale;
	    vector.y = Math.sin(r) * scale;
	
	    return vector;
	};
	
	module.exports = RandomXY;


/***/ }),
/* 1360 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.RoundTo
	 * @since 3.0.0
	 *
	 * @param {number} value - [description]
	 * @param {integer} [place=0] - [description]
	 * @param {integer} [base=10] - [description]
	 *
	 * @return {number} [description]
	 */
	var RoundTo = function (value, place, base)
	{
	    if (place === undefined) { place = 0; }
	    if (base === undefined) { base = 10; }
	
	    var p = Math.pow(base, -place);
	
	    return Math.round(value * p) / p;
	};
	
	module.exports = RoundTo;


/***/ }),
/* 1361 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @typedef {object} SinCosTable
	 *
	 * @property {number} sin - [description]
	 * @property {number} cos - [description]
	 * @property {number} length - [description]
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.SinCosTableGenerator
	 * @since 3.0.0
	 *
	 * @param {number} length - [description]
	 * @param {number} sinAmp - [description]
	 * @param {number} cosAmp - [description]
	 * @param {number} frequency - [description]
	 *
	 * @return {SinCosTable} [description]
	 */
	var SinCosTableGenerator = function (length, sinAmp, cosAmp, frequency)
	{
	    if (sinAmp === undefined) { sinAmp = 1; }
	    if (cosAmp === undefined) { cosAmp = 1; }
	    if (frequency === undefined) { frequency = 1; }
	
	    frequency *= Math.PI / length;
	
	    var cos = [];
	    var sin = [];
	
	    for (var c = 0; c < length; c++)
	    {
	        cosAmp -= sinAmp * frequency;
	        sinAmp += cosAmp * frequency;
	
	        cos[c] = cosAmp;
	        sin[c] = sinAmp;
	    }
	
	    return {
	        sin: sin,
	        cos: cos,
	        length: length
	    };
	};
	
	module.exports = SinCosTableGenerator;


/***/ }),
/* 1362 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Checks if the two values are within the given `tolerance` of each other.
	 *
	 * @function Phaser.Math.Within
	 * @since 3.0.0
	 *
	 * @param {number} a - The first value to use in the calculation.
	 * @param {number} b - The second value to use in the calculation.
	 * @param {number} tolerance - The tolerance. Anything equal to or less than this value is considered as being within range.
	 *
	 * @return {boolean} Returns `true` if `a` is less than or equal to the tolerance of `b`.
	 */
	var Within = function (a, b, tolerance)
	{
	    return (Math.abs(a - b) <= tolerance);
	};
	
	module.exports = Within;


/***/ }),
/* 1363 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Angle.Between
	 * @since 3.0.0
	 *
	 * @param {number} x1 - [description]
	 * @param {number} y1 - [description]
	 * @param {number} x2 - [description]
	 * @param {number} y2 - [description]
	 *
	 * @return {number} [description]
	 */
	var Between = function (x1, y1, x2, y2)
	{
	    return Math.atan2(y2 - y1, x2 - x1);
	};
	
	module.exports = Between;


/***/ }),
/* 1364 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Angle.BetweenPoints
	 * @since 3.0.0
	 *
	 * @param {(Phaser.Geom.Point|object)} point1 - [description]
	 * @param {(Phaser.Geom.Point|object)} point2 - [description]
	 *
	 * @return {number} [description]
	 */
	var BetweenPoints = function (point1, point2)
	{
	    return Math.atan2(point2.y - point1.y, point2.x - point1.x);
	};
	
	module.exports = BetweenPoints;


/***/ }),
/* 1365 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Angle.BetweenPointsY
	 * @since 3.0.0
	 *
	 * @param {(Phaser.Geom.Point|object)} point1 - [description]
	 * @param {(Phaser.Geom.Point|object)} point2 - [description]
	 *
	 * @return {number} [description]
	 */
	var BetweenPointsY = function (point1, point2)
	{
	    return Math.atan2(point2.x - point1.x, point2.y - point1.y);
	};
	
	module.exports = BetweenPointsY;


/***/ }),
/* 1366 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Angle.BetweenY
	 * @since 3.0.0
	 *
	 * @param {number} x1 - [description]
	 * @param {number} y1 - [description]
	 * @param {number} x2 - [description]
	 * @param {number} y2 - [description]
	 *
	 * @return {number} [description]
	 */
	var BetweenY = function (x1, y1, x2, y2)
	{
	    return Math.atan2(x2 - x1, y2 - y1);
	};
	
	module.exports = BetweenY;


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Normalize = __webpack_require__(563);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Angle.Reverse
	 * @since 3.0.0
	 *
	 * @param {number} angle - [description]
	 *
	 * @return {number} [description]
	 */
	var Reverse = function (angle)
	{
	    return Normalize(angle + Math.PI);
	};
	
	module.exports = Reverse;


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var MATH_CONST = __webpack_require__(33);
	
	/**
	 * Rotates `currentAngle` towards `targetAngle`, taking the shortest rotation distance. The `lerp` argument is the amount to rotate by in this call.
	 *
	 * @function Phaser.Math.Angle.RotateTo
	 * @since 3.0.0
	 *
	 * @param {number} currentAngle - The current angle, in radians.
	 * @param {number} targetAngle - The target angle to rotate to, in radians.
	 * @param {number} [lerp=0.05] - The lerp value to add to the current angle.
	 *
	 * @return {number} The adjusted angle.
	 */
	var RotateTo = function (currentAngle, targetAngle, lerp)
	{
	    if (lerp === undefined) { lerp = 0.05; }
	
	    if (currentAngle === targetAngle)
	    {
	        return currentAngle;
	    }
	
	    if (Math.abs(targetAngle - currentAngle) <= lerp || Math.abs(targetAngle - currentAngle) >= (MATH_CONST.PI2 - lerp))
	    {
	        currentAngle = targetAngle;
	    }
	    else
	    {
	        if (Math.abs(targetAngle - currentAngle) > Math.PI)
	        {
	            if (targetAngle < currentAngle)
	            {
	                targetAngle += MATH_CONST.PI2;
	            }
	            else
	            {
	                targetAngle -= MATH_CONST.PI2;
	            }
	        }
	
	        if (targetAngle > currentAngle)
	        {
	            currentAngle += lerp;
	        }
	        else if (targetAngle < currentAngle)
	        {
	            currentAngle -= lerp;
	        }
	    }
	
	    return currentAngle;
	};
	
	module.exports = RotateTo;


/***/ }),
/* 1369 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Gets the shortest angle between `angle1` and `angle2`.
	 * Both angles must be in the range -180 to 180, which is the same clamped
	 * range that `sprite.angle` uses, so you can pass in two sprite angles to
	 * this method and get the shortest angle back between the two of them.
	 *
	 * The angle returned will be in the same range. If the returned angle is
	 * greater than 0 then it's a counter-clockwise rotation, if < 0 then it's
	 * a clockwise rotation.
	 *
	 * @function Phaser.Math.Angle.ShortestBetween
	 * @since 3.0.0
	 *
	 * @param {number} angle1 - The first angle in the range -180 to 180.
	 * @param {number} angle2 - The second angle in the range -180 to 180.
	 *
	 * @return {number} The shortest angle, in degrees. If greater than zero it's a counter-clockwise rotation.
	 */
	var ShortestBetween = function (angle1, angle2)
	{
	    var difference = angle2 - angle1;
	
	    if (difference === 0)
	    {
	        return 0;
	    }
	
	    var times = Math.floor((difference - (-180)) / 360);
	
	    return difference - (times * 360);
	
	};
	
	module.exports = ShortestBetween;


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Math.Angle
	 */
	
	module.exports = {
	
	    Between: __webpack_require__(1363),
	    BetweenY: __webpack_require__(1366),
	    BetweenPoints: __webpack_require__(1364),
	    BetweenPointsY: __webpack_require__(1365),
	    Reverse: __webpack_require__(1367),
	    RotateTo: __webpack_require__(1368),
	    ShortestBetween: __webpack_require__(1369),
	    Normalize: __webpack_require__(563),
	    Wrap: __webpack_require__(311),
	    WrapDegrees: __webpack_require__(312)
	
	};


/***/ }),
/* 1371 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Distance.Power
	 * @since 3.0.0
	 *
	 * @param {number} x1 - [description]
	 * @param {number} y1 - [description]
	 * @param {number} x2 - [description]
	 * @param {number} y2 - [description]
	 * @param {number} pow - [description]
	 *
	 * @return {number} [description]
	 */
	var DistancePower = function (x1, y1, x2, y2, pow)
	{
	    if (pow === undefined) { pow = 2; }
	
	    return Math.sqrt(Math.pow(x2 - x1, pow) + Math.pow(y2 - y1, pow));
	};
	
	module.exports = DistancePower;


/***/ }),
/* 1372 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Distance.Squared
	 * @since 3.0.0
	 *
	 * @param {number} x1 - [description]
	 * @param {number} y1 - [description]
	 * @param {number} x2 - [description]
	 * @param {number} y2 - [description]
	 *
	 * @return {number} [description]
	 */
	var DistanceSquared = function (x1, y1, x2, y2)
	{
	    var dx = x1 - x2;
	    var dy = y1 - y2;
	
	    return dx * dx + dy * dy;
	};
	
	module.exports = DistanceSquared;


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Math.Distance
	 */
	
	module.exports = {
	
	    Between: __webpack_require__(116),
	    Power: __webpack_require__(1371),
	    Squared: __webpack_require__(1372)
	
	};


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Back = __webpack_require__(564);
	var Bounce = __webpack_require__(565);
	var Circular = __webpack_require__(566);
	var Cubic = __webpack_require__(567);
	var Elastic = __webpack_require__(568);
	var Expo = __webpack_require__(569);
	var Linear = __webpack_require__(570);
	var Quadratic = __webpack_require__(571);
	var Quartic = __webpack_require__(572);
	var Quintic = __webpack_require__(573);
	var Sine = __webpack_require__(574);
	var Stepped = __webpack_require__(575);
	
	//  EaseMap
	module.exports = {
	
	    Power0: Linear,
	    Power1: Quadratic.Out,
	    Power2: Cubic.Out,
	    Power3: Quartic.Out,
	    Power4: Quintic.Out,
	
	    Linear: Linear,
	    Quad: Quadratic.Out,
	    Cubic: Cubic.Out,
	    Quart: Quartic.Out,
	    Quint: Quintic.Out,
	    Sine: Sine.Out,
	    Expo: Expo.Out,
	    Circ: Circular.Out,
	    Elastic: Elastic.Out,
	    Back: Back.Out,
	    Bounce: Bounce.Out,
	    Stepped: Stepped,
	
	    'Quad.easeIn': Quadratic.In,
	    'Cubic.easeIn': Cubic.In,
	    'Quart.easeIn': Quartic.In,
	    'Quint.easeIn': Quintic.In,
	    'Sine.easeIn': Sine.In,
	    'Expo.easeIn': Expo.In,
	    'Circ.easeIn': Circular.In,
	    'Elastic.easeIn': Elastic.In,
	    'Back.easeIn': Back.In,
	    'Bounce.easeIn': Bounce.In,
	
	    'Quad.easeOut': Quadratic.Out,
	    'Cubic.easeOut': Cubic.Out,
	    'Quart.easeOut': Quartic.Out,
	    'Quint.easeOut': Quintic.Out,
	    'Sine.easeOut': Sine.Out,
	    'Expo.easeOut': Expo.Out,
	    'Circ.easeOut': Circular.Out,
	    'Elastic.easeOut': Elastic.Out,
	    'Back.easeOut': Back.Out,
	    'Bounce.easeOut': Bounce.Out,
	
	    'Quad.easeInOut': Quadratic.InOut,
	    'Cubic.easeInOut': Cubic.InOut,
	    'Quart.easeInOut': Quartic.InOut,
	    'Quint.easeInOut': Quintic.InOut,
	    'Sine.easeInOut': Sine.InOut,
	    'Expo.easeInOut': Expo.InOut,
	    'Circ.easeInOut': Circular.InOut,
	    'Elastic.easeInOut': Elastic.InOut,
	    'Back.easeInOut': Back.InOut,
	    'Bounce.easeInOut': Bounce.InOut
	
	};


/***/ }),
/* 1375 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Back.In
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 * @param {number} [overshoot=1.70158] - [description]
	 *
	 * @return {number} [description]
	 */
	var In = function (v, overshoot)
	{
	    if (overshoot === undefined) { overshoot = 1.70158; }
	
	    return v * v * ((overshoot + 1) * v - overshoot);
	};
	
	module.exports = In;


/***/ }),
/* 1376 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Back.InOut
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 * @param {number} [overshoot=1.70158] - [description]
	 *
	 * @return {number} [description]
	 */
	var InOut = function (v, overshoot)
	{
	    if (overshoot === undefined) { overshoot = 1.70158; }
	
	    var s = overshoot * 1.525;
	
	    if ((v *= 2) < 1)
	    {
	        return 0.5 * (v * v * ((s + 1) * v - s));
	    }
	    else
	    {
	        return 0.5 * ((v -= 2) * v * ((s + 1) * v + s) + 2);
	    }
	};
	
	module.exports = InOut;


/***/ }),
/* 1377 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Back.Out
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 * @param {number} [overshoot=1.70158] - [description]
	 *
	 * @return {number} [description]
	 */
	var Out = function (v, overshoot)
	{
	    if (overshoot === undefined) { overshoot = 1.70158; }
	
	    return --v * v * ((overshoot + 1) * v + overshoot) + 1;
	};
	
	module.exports = Out;


/***/ }),
/* 1378 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Bounce.In
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var In = function (v)
	{
	    v = 1 - v;
	
	    if (v < 1 / 2.75)
	    {
	        return 1 - (7.5625 * v * v);
	    }
	    else if (v < 2 / 2.75)
	    {
	        return 1 - (7.5625 * (v -= 1.5 / 2.75) * v + 0.75);
	    }
	    else if (v < 2.5 / 2.75)
	    {
	        return 1 - (7.5625 * (v -= 2.25 / 2.75) * v + 0.9375);
	    }
	    else
	    {
	        return 1 - (7.5625 * (v -= 2.625 / 2.75) * v + 0.984375);
	    }
	};
	
	module.exports = In;


/***/ }),
/* 1379 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Bounce.InOut
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var InOut = function (v)
	{
	    var reverse = false;
	
	    if (v < 0.5)
	    {
	        v = 1 - (v * 2);
	        reverse = true;
	    }
	    else
	    {
	        v = (v * 2) - 1;
	    }
	
	    if (v < 1 / 2.75)
	    {
	        v = 7.5625 * v * v;
	    }
	    else if (v < 2 / 2.75)
	    {
	        v = 7.5625 * (v -= 1.5 / 2.75) * v + 0.75;
	    }
	    else if (v < 2.5 / 2.75)
	    {
	        v = 7.5625 * (v -= 2.25 / 2.75) * v + 0.9375;
	    }
	    else
	    {
	        v = 7.5625 * (v -= 2.625 / 2.75) * v + 0.984375;
	    }
	
	    if (reverse)
	    {
	        return (1 - v) * 0.5;
	    }
	    else
	    {
	        return v * 0.5 + 0.5;
	    }
	};
	
	module.exports = InOut;


/***/ }),
/* 1380 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Bounce.Out
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var Out = function (v)
	{
	    if (v < 1 / 2.75)
	    {
	        return 7.5625 * v * v;
	    }
	    else if (v < 2 / 2.75)
	    {
	        return 7.5625 * (v -= 1.5 / 2.75) * v + 0.75;
	    }
	    else if (v < 2.5 / 2.75)
	    {
	        return 7.5625 * (v -= 2.25 / 2.75) * v + 0.9375;
	    }
	    else
	    {
	        return 7.5625 * (v -= 2.625 / 2.75) * v + 0.984375;
	    }
	};
	
	module.exports = Out;


/***/ }),
/* 1381 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Circular.In
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var In = function (v)
	{
	    return 1 - Math.sqrt(1 - v * v);
	};
	
	module.exports = In;


/***/ }),
/* 1382 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Circular.InOut
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var InOut = function (v)
	{
	    if ((v *= 2) < 1)
	    {
	        return -0.5 * (Math.sqrt(1 - v * v) - 1);
	    }
	    else
	    {
	        return 0.5 * (Math.sqrt(1 - (v -= 2) * v) + 1);
	    }
	};
	
	module.exports = InOut;


/***/ }),
/* 1383 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Circular.Out
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var Out = function (v)
	{
	    return Math.sqrt(1 - (--v * v));
	};
	
	module.exports = Out;


/***/ }),
/* 1384 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Cubic.In
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var In = function (v)
	{
	    return v * v * v;
	};
	
	module.exports = In;


/***/ }),
/* 1385 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Cubic.InOut
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var InOut = function (v)
	{
	    if ((v *= 2) < 1)
	    {
	        return 0.5 * v * v * v;
	    }
	    else
	    {
	        return 0.5 * ((v -= 2) * v * v + 2);
	    }
	};
	
	module.exports = InOut;


/***/ }),
/* 1386 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Cubic.Out
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var Out = function (v)
	{
	    return --v * v * v + 1;
	};
	
	module.exports = Out;


/***/ }),
/* 1387 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Elastic.In
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 * @param {float} [amplitude=0.1] - [description]
	 * @param {float} [period=0.1] - [description]
	 *
	 * @return {number} [description]
	 */
	var In = function (v, amplitude, period)
	{
	    if (amplitude === undefined) { amplitude = 0.1; }
	    if (period === undefined) { period = 0.1; }
	
	    if (v === 0)
	    {
	        return 0;
	    }
	    else if (v === 1)
	    {
	        return 1;
	    }
	    else
	    {
	        var s = period / 4;
	
	        if (amplitude < 1)
	        {
	            amplitude = 1;
	        }
	        else
	        {
	            s = period * Math.asin(1 / amplitude) / (2 * Math.PI);
	        }
	
	        return -(amplitude * Math.pow(2, 10 * (v -= 1)) * Math.sin((v - s) * (2 * Math.PI) / period));
	    }
	};
	
	module.exports = In;


/***/ }),
/* 1388 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Elastic.InOut
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 * @param {float} [amplitude=0.1] - [description]
	 * @param {float} [period=0.1] - [description]
	 *
	 * @return {number} [description]
	 */
	var InOut = function (v, amplitude, period)
	{
	    if (amplitude === undefined) { amplitude = 0.1; }
	    if (period === undefined) { period = 0.1; }
	
	    if (v === 0)
	    {
	        return 0;
	    }
	    else if (v === 1)
	    {
	        return 1;
	    }
	    else
	    {
	        var s = period / 4;
	
	        if (amplitude < 1)
	        {
	            amplitude = 1;
	        }
	        else
	        {
	            s = period * Math.asin(1 / amplitude) / (2 * Math.PI);
	        }
	
	        if ((v *= 2) < 1)
	        {
	            return -0.5 * (amplitude * Math.pow(2, 10 * (v -= 1)) * Math.sin((v - s) * (2 * Math.PI) / period));
	        }
	        else
	        {
	            return amplitude * Math.pow(2, -10 * (v -= 1)) * Math.sin((v - s) * (2 * Math.PI) / period) * 0.5 + 1;
	        }
	    }
	};
	
	module.exports = InOut;


/***/ }),
/* 1389 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Elastic.Out
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 * @param {float} [amplitude=0.1] - [description]
	 * @param {float} [period=0.1] - [description]
	 *
	 * @return {number} [description]
	 */
	var Out = function (v, amplitude, period)
	{
	    if (amplitude === undefined) { amplitude = 0.1; }
	    if (period === undefined) { period = 0.1; }
	
	    if (v === 0)
	    {
	        return 0;
	    }
	    else if (v === 1)
	    {
	        return 1;
	    }
	    else
	    {
	        var s = period / 4;
	
	        if (amplitude < 1)
	        {
	            amplitude = 1;
	        }
	        else
	        {
	            s = period * Math.asin(1 / amplitude) / (2 * Math.PI);
	        }
	
	        return (amplitude * Math.pow(2, -10 * v) * Math.sin((v - s) * (2 * Math.PI) / period) + 1);
	    }
	};
	
	module.exports = Out;


/***/ }),
/* 1390 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Expo.In
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var In = function (v)
	{
	    return Math.pow(2, 10 * (v - 1)) - 0.001;
	};
	
	module.exports = In;


/***/ }),
/* 1391 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Expo.InOut
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var InOut = function (v)
	{
	    if ((v *= 2) < 1)
	    {
	        return 0.5 * Math.pow(2, 10 * (v - 1));
	    }
	    else
	    {
	        return 0.5 * (2 - Math.pow(2, -10 * (v - 1)));
	    }
	};
	
	module.exports = InOut;


/***/ }),
/* 1392 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Expo.Out
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var Out = function (v)
	{
	    return 1 - Math.pow(2, -10 * v);
	};
	
	module.exports = Out;


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Math.Easing
	 */
	
	module.exports = {
	
	    Back: __webpack_require__(564),
	    Bounce: __webpack_require__(565),
	    Circular: __webpack_require__(566),
	    Cubic: __webpack_require__(567),
	    Elastic: __webpack_require__(568),
	    Expo: __webpack_require__(569),
	    Linear: __webpack_require__(570),
	    Quadratic: __webpack_require__(571),
	    Quartic: __webpack_require__(572),
	    Quintic: __webpack_require__(573),
	    Sine: __webpack_require__(574),
	    Stepped: __webpack_require__(575)
	
	};


/***/ }),
/* 1394 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Linear.Linear
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var Linear = function (v)
	{
	    return v;
	};
	
	module.exports = Linear;


/***/ }),
/* 1395 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Quadratic.In
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var In = function (v)
	{
	    return v * v;
	};
	
	module.exports = In;


/***/ }),
/* 1396 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Quadratic.InOut
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var InOut = function (v)
	{
	    if ((v *= 2) < 1)
	    {
	        return 0.5 * v * v;
	    }
	    else
	    {
	        return -0.5 * (--v * (v - 2) - 1);
	    }
	};
	
	module.exports = InOut;


/***/ }),
/* 1397 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Quadratic.Out
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var Out = function (v)
	{
	    return v * (2 - v);
	};
	
	module.exports = Out;


/***/ }),
/* 1398 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Quartic.In
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var In = function (v)
	{
	    return v * v * v * v;
	};
	
	module.exports = In;


/***/ }),
/* 1399 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Quartic.InOut
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var InOut = function (v)
	{
	    if ((v *= 2) < 1)
	    {
	        return 0.5 * v * v * v * v;
	    }
	    else
	    {
	        return -0.5 * ((v -= 2) * v * v * v - 2);
	    }
	};
	
	module.exports = InOut;


/***/ }),
/* 1400 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Quartic.Out
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var Out = function (v)
	{
	    return 1 - (--v * v * v * v);
	};
	
	module.exports = Out;


/***/ }),
/* 1401 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Quintic.In
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var In = function (v)
	{
	    return v * v * v * v * v;
	};
	
	module.exports = In;


/***/ }),
/* 1402 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Quintic.InOut
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var InOut = function (v)
	{
	    if ((v *= 2) < 1)
	    {
	        return 0.5 * v * v * v * v * v;
	    }
	    else
	    {
	        return 0.5 * ((v -= 2) * v * v * v * v + 2);
	    }
	};
	
	module.exports = InOut;


/***/ }),
/* 1403 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Quintic.Out
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var Out = function (v)
	{
	    return --v * v * v * v * v + 1;
	};
	
	module.exports = Out;


/***/ }),
/* 1404 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Sine.In
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var In = function (v)
	{
	    if (v === 0)
	    {
	        return 0;
	    }
	    else if (v === 1)
	    {
	        return 1;
	    }
	    else
	    {
	        return 1 - Math.cos(v * Math.PI / 2);
	    }
	};
	
	module.exports = In;


/***/ }),
/* 1405 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Sine.InOut
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var InOut = function (v)
	{
	    if (v === 0)
	    {
	        return 0;
	    }
	    else if (v === 1)
	    {
	        return 1;
	    }
	    else
	    {
	        return 0.5 * (1 - Math.cos(Math.PI * v));
	    }
	};
	
	module.exports = InOut;


/***/ }),
/* 1406 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Sine.Out
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 *
	 * @return {number} [description]
	 */
	var Out = function (v)
	{
	    if (v === 0)
	    {
	        return 0;
	    }
	    else if (v === 1)
	    {
	        return 1;
	    }
	    else
	    {
	        return Math.sin(v * Math.PI / 2);
	    }
	};
	
	module.exports = Out;


/***/ }),
/* 1407 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Easing.Stepped.Stepped
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 * @param {float} [steps=1] - [description]
	 *
	 * @return {number} [description]
	 */
	var Stepped = function (v, steps)
	{
	    if (steps === undefined) { steps = 1; }
	
	    if (v <= 0)
	    {
	        return 0;
	    }
	    else if (v >= 1)
	    {
	        return 1;
	    }
	    else
	    {
	        return (((steps * v) | 0) + 1) * (1 / steps);
	    }
	};
	
	module.exports = Stepped;


/***/ }),
/* 1408 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Fuzzy.Ceil
	 * @since 3.0.0
	 *
	 * @param {number} value - [description]
	 * @param {float} [epsilon=0.0001] - [description]
	 *
	 * @return {number} [description]
	 */
	var Ceil = function (value, epsilon)
	{
	    if (epsilon === undefined) { epsilon = 0.0001; }
	
	    return Math.ceil(value - epsilon);
	};
	
	module.exports = Ceil;


/***/ }),
/* 1409 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Fuzzy.Equal
	 * @since 3.0.0
	 *
	 * @param {number} a - [description]
	 * @param {number} b - [description]
	 * @param {float} [epsilon=0.0001] - [description]
	 *
	 * @return {boolean} [description]
	 */
	var Equal = function (a, b, epsilon)
	{
	    if (epsilon === undefined) { epsilon = 0.0001; }
	
	    return Math.abs(a - b) < epsilon;
	};
	
	module.exports = Equal;


/***/ }),
/* 1410 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Fuzzy.Floor
	 * @since 3.0.0
	 *
	 * @param {number} value - [description]
	 * @param {float} [epsilon=0.0001] - [description]
	 *
	 * @return {number} [description]
	 */
	var Floor = function (value, epsilon)
	{
	    if (epsilon === undefined) { epsilon = 0.0001; }
	
	    return Math.floor(value + epsilon);
	};
	
	module.exports = Floor;


/***/ }),
/* 1411 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Fuzzy.GreaterThan
	 * @since 3.0.0
	 *
	 * @param {number} a - [description]
	 * @param {number} b - [description]
	 * @param {float} [epsilon=0.0001] - [description]
	 *
	 * @return {boolean} [description]
	 */
	var GreaterThan = function (a, b, epsilon)
	{
	    if (epsilon === undefined) { epsilon = 0.0001; }
	
	    return a > b - epsilon;
	};
	
	module.exports = GreaterThan;


/***/ }),
/* 1412 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Fuzzy.LessThan
	 * @since 3.0.0
	 *
	 * @param {number} a - [description]
	 * @param {number} b - [description]
	 * @param {float} [epsilon=0.0001] - [description]
	 *
	 * @return {boolean} [description]
	 */
	var LessThan = function (a, b, epsilon)
	{
	    if (epsilon === undefined) { epsilon = 0.0001; }
	
	    return a < b + epsilon;
	};
	
	module.exports = LessThan;


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Math.Fuzzy
	 */
	
	module.exports = {
	
	    Ceil: __webpack_require__(1408),
	    Equal: __webpack_require__(1409),
	    Floor: __webpack_require__(1410),
	    GreaterThan: __webpack_require__(1411),
	    LessThan: __webpack_require__(1412)
	
	};


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CONST = __webpack_require__(33);
	var Extend = __webpack_require__(36);
	
	/**
	 * @namespace Phaser.Math
	 */
	
	var PhaserMath = {
	
	    //  Collections of functions
	    Angle: __webpack_require__(1370),
	    Distance: __webpack_require__(1373),
	    Easing: __webpack_require__(1393),
	    Fuzzy: __webpack_require__(1413),
	    Interpolation: __webpack_require__(1418),
	    Pow2: __webpack_require__(1420),
	    Snap: __webpack_require__(1424),
	
	    //  Expose the RNG Class
	    RandomDataGenerator: __webpack_require__(579),
	
	    //  Single functions
	    Average: __webpack_require__(1349),
	    Bernstein: __webpack_require__(548),
	    Between: __webpack_require__(549),
	    CatmullRom: __webpack_require__(305),
	    CeilTo: __webpack_require__(1350),
	    Clamp: __webpack_require__(63),
	    DegToRad: __webpack_require__(97),
	    Difference: __webpack_require__(1351),
	    Factorial: __webpack_require__(550),
	    FloatBetween: __webpack_require__(551),
	    FloorTo: __webpack_require__(1352),
	    FromPercent: __webpack_require__(163),
	    GetSpeed: __webpack_require__(1353),
	    IsEven: __webpack_require__(1354),
	    IsEvenStrict: __webpack_require__(1355),
	    Linear: __webpack_require__(306),
	    MaxAdd: __webpack_require__(1356),
	    MinSub: __webpack_require__(1357),
	    Percent: __webpack_require__(1358),
	    RadToDeg: __webpack_require__(308),
	    RandomXY: __webpack_require__(1359),
	    RandomXYZ: __webpack_require__(554),
	    RandomXYZW: __webpack_require__(555),
	    Rotate: __webpack_require__(556),
	    RotateAround: __webpack_require__(557),
	    RotateAroundDistance: __webpack_require__(309),
	    RoundAwayFromZero: __webpack_require__(559),
	    RoundTo: __webpack_require__(1360),
	    SinCosTableGenerator: __webpack_require__(1361),
	    SmootherStep: __webpack_require__(561),
	    SmoothStep: __webpack_require__(560),
	    TransformXY: __webpack_require__(562),
	    Within: __webpack_require__(1362),
	    Wrap: __webpack_require__(98),
	
	    //  Vector classes
	    Vector2: __webpack_require__(9),
	    Vector3: __webpack_require__(142),
	    Vector4: __webpack_require__(310),
	    Matrix3: __webpack_require__(552),
	    Matrix4: __webpack_require__(307),
	    Quaternion: __webpack_require__(553),
	    RotateVec3: __webpack_require__(558)
	
	};
	
	//   Merge in the consts
	
	PhaserMath = Extend(false, PhaserMath, CONST);
	
	//  Export it
	
	module.exports = PhaserMath;


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Bernstein = __webpack_require__(548);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Interpolation.Bezier
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 * @param {number} k - [description]
	 *
	 * @return {number} [description]
	 */
	var BezierInterpolation = function (v, k)
	{
	    var b = 0;
	    var n = v.length - 1;
	
	    for (var i = 0; i <= n; i++)
	    {
	        b += Math.pow(1 - k, n - i) * Math.pow(k, i) * v[i] * Bernstein(n, i);
	    }
	
	    return b;
	};
	
	module.exports = BezierInterpolation;


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CatmullRom = __webpack_require__(305);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Interpolation.CatmullRom
	 * @since 3.0.0
	 *
	 * @param {number} v - [description]
	 * @param {number} k - [description]
	 *
	 * @return {number} [description]
	 */
	var CatmullRomInterpolation = function (v, k)
	{
	    var m = v.length - 1;
	    var f = m * k;
	    var i = Math.floor(f);
	
	    if (v[0] === v[m])
	    {
	        if (k < 0)
	        {
	            i = Math.floor(f = m * (1 + k));
	        }
	
	        return CatmullRom(f - i, v[(i - 1 + m) % m], v[i], v[(i + 1) % m], v[(i + 2) % m]);
	    }
	    else
	    {
	        if (k < 0)
	        {
	            return v[0] - (CatmullRom(-f, v[0], v[0], v[1], v[1]) - v[0]);
	        }
	
	        if (k > 1)
	        {
	            return v[m] - (CatmullRom(f - m, v[m], v[m], v[m - 1], v[m - 1]) - v[m]);
	        }
	
	        return CatmullRom(f - i, v[i ? i - 1 : 0], v[i], v[m < i + 1 ? m : i + 1], v[m < i + 2 ? m : i + 2]);
	    }
	};
	
	module.exports = CatmullRomInterpolation;


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Linear = __webpack_require__(306);
	
	/**
	 * A Linear Interpolation Method.
	 *
	 * @function Phaser.Math.Interpolation.Linear
	 * @since 3.0.0
	 * @see https://en.wikipedia.org/wiki/Linear_interpolation
	 *
	 * @param {number[]} v - The input array of values to interpolate between.
	 * @param {!number} k - The percentage of interploation, between 0 and 1.
	 *
	 * @return {!number} The interpolated value.
	 */
	var LinearInterpolation = function (v, k)
	{
	    var m = v.length - 1;
	    var f = m * k;
	    var i = Math.floor(f);
	
	    if (k < 0)
	    {
	        return Linear(v[0], v[1], f);
	    }
	
	    if (k > 1)
	    {
	        return Linear(v[m], v[m - 1], m - f);
	    }
	
	    return Linear(v[i], v[(i + 1 > m) ? m : i + 1], f - i);
	};
	
	module.exports = LinearInterpolation;


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Math.Interpolation
	 */
	
	module.exports = {
	    Bezier: __webpack_require__(1415),
	    CatmullRom: __webpack_require__(1416),
	    CubicBezier: __webpack_require__(576),
	    Linear: __webpack_require__(1417),
	    QuadraticBezier: __webpack_require__(577)
	};


/***/ }),
/* 1419 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Tests the value and returns `true` if it is a power of two.
	 *
	 * @function Phaser.Math.Pow2.IsValuePowerOfTwo
	 * @since 3.0.0
	 *
	 * @param {number} value - The value to check if it's a power of two.
	 *
	 * @return {boolean} Returns `true` if `value` is a power of two, otherwise `false`.
	 */
	var IsValuePowerOfTwo = function (value)
	{
	    return (value > 0 && (value & (value - 1)) === 0);
	};
	
	module.exports = IsValuePowerOfTwo;


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Math.Pow2
	 */
	
	module.exports = {
	
	    GetNext: __webpack_require__(578),
	    IsSize: __webpack_require__(203),
	    IsValue: __webpack_require__(1419)
	
	};


/***/ }),
/* 1421 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Snap.Ceil
	 * @since 3.0.0
	 *
	 * @param {number} value - [description]
	 * @param {number} gap - [description]
	 * @param {number} [start=0] - [description]
	 *
	 * @return {number} [description]
	 */
	var SnapCeil = function (value, gap, start)
	{
	    if (start === undefined) { start = 0; }
	
	    if (gap === 0)
	    {
	        return value;
	    }
	
	    value -= start;
	    value = gap * Math.ceil(value / gap);
	
	    return start + value;
	};
	
	module.exports = SnapCeil;


/***/ }),
/* 1422 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Snap.Floor
	 * @since 3.0.0
	 *
	 * @param {number} value - [description]
	 * @param {number} gap - [description]
	 * @param {number} [start=0] - [description]
	 *
	 * @return {number} [description]
	 */
	var SnapFloor = function (value, gap, start)
	{
	    if (start === undefined) { start = 0; }
	
	    if (gap === 0)
	    {
	        return value;
	    }
	
	    value -= start;
	    value = gap * Math.floor(value / gap);
	
	    return start + value;
	};
	
	module.exports = SnapFloor;


/***/ }),
/* 1423 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Math.Snap.To
	 * @since 3.0.0
	 *
	 * @param {number} value - [description]
	 * @param {number} gap - [description]
	 * @param {number} [start=0] - [description]
	 *
	 * @return {number} [description]
	 */
	var SnapTo = function (value, gap, start)
	{
	    if (start === undefined) { start = 0; }
	
	    if (gap === 0)
	    {
	        return value;
	    }
	
	    value -= start;
	    value = gap * Math.round(value / gap);
	
	    return start + value;
	};
	
	module.exports = SnapTo;


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Math.Snap
	 */
	
	module.exports = {
	
	    Ceil: __webpack_require__(1421),
	    Floor: __webpack_require__(1422),
	    To: __webpack_require__(1423)
	
	};


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var DegToRad = __webpack_require__(97);
	var DistanceBetween = __webpack_require__(116);
	var Factory = __webpack_require__(583);
	var GetFastValue = __webpack_require__(3);
	var Merge = __webpack_require__(148);
	var PluginCache = __webpack_require__(29);
	var Vector2 = __webpack_require__(9);
	var World = __webpack_require__(589);
	
	//  All methods in this class are available under `this.physics` in a Scene.
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class ArcadePhysics
	 * @memberOf Phaser.Physics.Arcade
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - [description]
	 */
	var ArcadePhysics = new Class({
	
	    initialize:
	
	    function ArcadePhysics (scene)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.ArcadePhysics#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.ArcadePhysics#systems
	         * @type {Phaser.Scenes.Systems}
	         * @since 3.0.0
	         */
	        this.systems = scene.sys;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.ArcadePhysics#config
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.config = this.getConfig();
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.ArcadePhysics#world
	         * @type {Phaser.Physics.Arcade.World}
	         * @since 3.0.0
	         */
	        this.world;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Arcade.ArcadePhysics#add
	         * @type {Phaser.Physics.Arcade.Factory}
	         * @since 3.0.0
	         */
	        this.add;
	
	        scene.sys.events.once('boot', this.boot, this);
	        scene.sys.events.on('start', this.start, this);
	    },
	
	    /**
	     * This method is called automatically, only once, when the Scene is first created.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.Physics.Arcade.ArcadePhysics#boot
	     * @private
	     * @since 3.5.1
	     */
	    boot: function ()
	    {
	        this.world = new World(this.scene, this.config);
	        this.add = new Factory(this.world);
	
	        this.systems.events.once('destroy', this.destroy, this);
	    },
	
	    /**
	     * This method is called automatically by the Scene when it is starting up.
	     * It is responsible for creating local systems, properties and listening for Scene events.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.Physics.Arcade.ArcadePhysics#start
	     * @private
	     * @since 3.5.0
	     */
	    start: function ()
	    {
	        if (!this.world)
	        {
	            this.world = new World(this.scene, this.config);
	            this.add = new Factory(this.world);
	        }
	
	        var eventEmitter = this.systems.events;
	
	        eventEmitter.on('update', this.world.update, this.world);
	        eventEmitter.on('postupdate', this.world.postUpdate, this.world);
	        eventEmitter.once('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.ArcadePhysics#getConfig
	     * @since 3.0.0
	     *
	     * @return {object} [description]
	     */
	    getConfig: function ()
	    {
	        var gameConfig = this.systems.game.config.physics;
	        var sceneConfig = this.systems.settings.physics;
	
	        var config = Merge(
	            GetFastValue(sceneConfig, 'arcade', {}),
	            GetFastValue(gameConfig, 'arcade', {})
	        );
	
	        return config;
	    },
	
	    /**
	     * Checks for overlaps between two Game Objects. The objects can be any Game Object that have an Arcade Physics Body.
	     *
	     * Unlike {@link #collide} the objects are NOT automatically separated or have any physics applied, they merely test for overlap results.
	     *
	     * Both the first and second parameter can be arrays of objects, of differing types.
	     * If two arrays are passed, the contents of the first parameter will be tested against all contents of the 2nd parameter.
	     *
	     * ##### Tilemaps
	     *
	     * Any overlapping tiles, including blank/null tiles, will give a positive result. Tiles marked via {@link Phaser.Tilemap#setCollision} (and similar methods) have no special status, and callbacks added via {@link Phaser.Tilemap#setTileIndexCallback} or {@link Phaser.Tilemap#setTileLocationCallback} are not invoked. So calling this method without any callbacks isn't very useful.
	     *
	     * If you're interested only in whether an object overlaps a certain tile or class of tiles, filter the tiles with `processCallback` and then use the result returned by this method. Blank/null tiles can be excluded by their {@link Phaser.Tile#index index} (-1).
	     *
	     * If you want to take action on certain overlaps, examine the tiles in `collideCallback` and then handle as you like.
	     *
	     * @method Phaser.Physics.Arcade.ArcadePhysics#overlap
	     * @since 3.0.0
	     *
	     * @param {(Phaser.GameObjects.GameObject|array)} object1 - The first object or array of objects to check. Can be any Game Object that has an Arcade Physics Body.
	     * @param {(Phaser.GameObjects.GameObject|array)} object2 - The second object or array of objects to check. Can be any Game Object that has an Arcade Physics Body.
	     * @param {ArcadePhysicsCallback} [overlapCallback=null] - An optional callback function that is called if the objects overlap. The two objects will be passed to this function in the same order in which you specified them, unless you are checking Group vs. Sprite, in which case Sprite will always be the first parameter.
	     * @param {ArcadePhysicsCallback} [processCallback=null] - A callback function that lets you perform additional checks against the two objects if they overlap. If this is set then `overlapCallback` will only be called if this callback returns `true`.
	     * @param {*} [callbackContext] - The context in which to run the callbacks.
	     *
	     * @return {boolean} True if an overlap occurred otherwise false.
	     */
	    overlap: function (object1, object2, overlapCallback, processCallback, callbackContext)
	    {
	        if (overlapCallback === undefined) { overlapCallback = null; }
	        if (processCallback === undefined) { processCallback = null; }
	        if (callbackContext === undefined) { callbackContext = overlapCallback; }
	
	        return this.world.collideObjects(object1, object2, overlapCallback, processCallback, callbackContext, true);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.ArcadePhysics#collide
	     * @since 3.0.0
	     *
	     * @param {(Phaser.GameObjects.GameObject|array)} object1 - The first object or array of objects to check. Can be any Game Object that has an Arcade Physics Body.
	     * @param {(Phaser.GameObjects.GameObject|array)} object2 - The second object or array of objects to check. Can be any Game Object that has an Arcade Physics Body.
	     * @param {ArcadePhysicsCallback} [collideCallback=null] - An optional callback function that is called if the objects collide. The two objects will be passed to this function in the same order in which you specified them, unless you are checking Group vs. Sprite, in which case Sprite will always be the first parameter.
	     * @param {ArcadePhysicsCallback} [processCallback=null] - A callback function that lets you perform additional checks against the two objects if they collide. If this is set then `collideCallback` will only be called if this callback returns `true`.
	     * @param {*} [callbackContext] - The context in which to run the callbacks.
	     *
	     * @return {boolean} True if a collision occurred otherwise false.
	     */
	    collide: function (object1, object2, collideCallback, processCallback, callbackContext)
	    {
	        if (collideCallback === undefined) { collideCallback = null; }
	        if (processCallback === undefined) { processCallback = null; }
	        if (callbackContext === undefined) { callbackContext = collideCallback; }
	
	        return this.world.collideObjects(object1, object2, collideCallback, processCallback, callbackContext, false);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.ArcadePhysics#pause
	     * @since 3.0.0
	     *
	     * @return {Phaser.Physics.Arcade.World} [description]
	     */
	    pause: function ()
	    {
	        return this.world.pause();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.ArcadePhysics#resume
	     * @since 3.0.0
	     *
	     * @return {Phaser.Physics.Arcade.World} [description]
	     */
	    resume: function ()
	    {
	        return this.world.resume();
	    },
	
	    /**
	     * Sets the acceleration.x/y property on the game object so it will move towards the x/y coordinates at the given rate (in pixels per second squared)
	     *
	     * You must give a maximum speed value, beyond which the game object won't go any faster.
	     *
	     * Note: The game object does not continuously track the target. If the target changes location during transit the game object will not modify its course.
	     * Note: The game object doesn't stop moving once it reaches the destination coordinates.
	     *
	     * @method Phaser.Physics.Arcade.ArcadePhysics#accelerateTo
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} gameObject - Any Game Object with an Arcade Physics body.
	     * @param {number} x - The x coordinate to accelerate towards.
	     * @param {number} y - The y coordinate to accelerate towards.
	     * @param {number} [speed=60] - The acceleration (change in speed) in pixels per second squared.
	     * @param {number} [xSpeedMax=500] - The maximum x velocity the game object can reach.
	     * @param {number} [ySpeedMax=500] - The maximum y velocity the game object can reach.
	     *
	     * @return {number} The angle (in radians) that the object should be visually set to in order to match its new velocity.
	     */
	    accelerateTo: function (gameObject, x, y, speed, xSpeedMax, ySpeedMax)
	    {
	        if (speed === undefined) { speed = 60; }
	
	        var angle = Math.atan2(y - gameObject.y, x - gameObject.x);
	
	        gameObject.body.acceleration.setToPolar(angle, speed);
	
	        if (xSpeedMax !== undefined && ySpeedMax !== undefined)
	        {
	            gameObject.body.maxVelocity.set(xSpeedMax, ySpeedMax);
	        }
	
	        return angle;
	    },
	
	    /**
	     * Sets the acceleration.x/y property on the game object so it will move towards the x/y coordinates at the given rate (in pixels per second squared)
	     *
	     * You must give a maximum speed value, beyond which the game object won't go any faster.
	     *
	     * Note: The game object does not continuously track the target. If the target changes location during transit the game object will not modify its course.
	     * Note: The game object doesn't stop moving once it reaches the destination coordinates.
	     *
	     * @method Phaser.Physics.Arcade.ArcadePhysics#accelerateToObject
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} gameObject - Any Game Object with an Arcade Physics body.
	     * @param {Phaser.GameObjects.GameObject} destination - The Game Object to move towards. Can be any object but must have visible x/y properties.
	     * @param {number} [speed=60] - The acceleration (change in speed) in pixels per second squared.
	     * @param {number} [xSpeedMax=500] - The maximum x velocity the game object can reach.
	     * @param {number} [ySpeedMax=500] - The maximum y velocity the game object can reach.
	     *
	     * @return {number} The angle (in radians) that the object should be visually set to in order to match its new velocity.
	     */
	    accelerateToObject: function (gameObject, destination, speed, xSpeedMax, ySpeedMax)
	    {
	        return this.accelerateTo(gameObject, destination.x, destination.y, speed, xSpeedMax, ySpeedMax);
	    },
	
	    /**
	     * Finds the Body closest to a source point or object.
	     *
	     * @method Phaser.Physics.Arcade.ArcadePhysics#closest
	     * @since 3.0.0
	     *
	     * @param {object} source - Any object with public `x` and `y` properties, such as a Game Object or Geometry object.
	     *
	     * @return {Phaser.Physics.Arcade.Body} The closest Body to the given source point.
	     */
	    closest: function (source)
	    {
	        var bodies = this.tree.all();
	
	        var min = Number.MAX_VALUE;
	        var closest = null;
	        var x = source.x;
	        var y = source.y;
	
	        for (var i = bodies.length - 1; i >= 0; i--)
	        {
	            var target = bodies[i];
	            var distance = DistanceBetween(x, y, target.x, target.y);
	
	            if (distance < min)
	            {
	                closest = target;
	                min = distance;
	            }
	        }
	
	        return closest;
	    },
	
	    /**
	     * Finds the Body farthest from a source point or object.
	     *
	     * @method Phaser.Physics.Arcade.ArcadePhysics#furthest
	     * @since 3.0.0
	     *
	     * @param {object} source - Any object with public `x` and `y` properties, such as a Game Object or Geometry object.
	     *
	     * @return {Phaser.Physics.Arcade.Body} The Body furthest from the given source point.
	     */
	    furthest: function (source)
	    {
	        var bodies = this.tree.all();
	
	        var max = -1;
	        var farthest = null;
	        var x = source.x;
	        var y = source.y;
	
	        for (var i = bodies.length - 1; i >= 0; i--)
	        {
	            var target = bodies[i];
	            var distance = DistanceBetween(x, y, target.x, target.y);
	
	            if (distance > max)
	            {
	                farthest = target;
	                max = distance;
	            }
	        }
	
	        return farthest;
	    },
	
	    /**
	     * Move the given display object towards the x/y coordinates at a steady velocity.
	     * If you specify a maxTime then it will adjust the speed (over-writing what you set) so it arrives at the destination in that number of seconds.
	     * Timings are approximate due to the way browser timers work. Allow for a variance of +- 50ms.
	     * Note: The display object does not continuously track the target. If the target changes location during transit the display object will not modify its course.
	     * Note: The display object doesn't stop moving once it reaches the destination coordinates.
	     * Note: Doesn't take into account acceleration, maxVelocity or drag (if you've set drag or acceleration too high this object may not move at all)
	     *
	     * @method Phaser.Physics.Arcade.ArcadePhysics#moveTo
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} gameObject - Any Game Object with an Arcade Physics body.
	     * @param {number} x - The x coordinate to move towards.
	     * @param {number} y - The y coordinate to move towards.
	     * @param {number} [speed=60] - The speed it will move, in pixels per second (default is 60 pixels/sec)
	     * @param {number} [maxTime=0] - Time given in milliseconds (1000 = 1 sec). If set the speed is adjusted so the object will arrive at destination in the given number of ms.
	     *
	     * @return {number} The angle (in radians) that the object should be visually set to in order to match its new velocity.
	     */
	    moveTo: function (gameObject, x, y, speed, maxTime)
	    {
	        if (speed === undefined) { speed = 60; }
	        if (maxTime === undefined) { maxTime = 0; }
	
	        var angle = Math.atan2(y - gameObject.y, x - gameObject.x);
	
	        if (maxTime > 0)
	        {
	            //  We know how many pixels we need to move, but how fast?
	            speed = DistanceBetween(gameObject.x, gameObject.y, x, y) / (maxTime / 1000);
	        }
	
	        gameObject.body.velocity.setToPolar(angle, speed);
	
	        return angle;
	    },
	
	    /**
	     * Move the given display object towards the destination object at a steady velocity.
	     * If you specify a maxTime then it will adjust the speed (overwriting what you set) so it arrives at the destination in that number of seconds.
	     * Timings are approximate due to the way browser timers work. Allow for a variance of +- 50ms.
	     * Note: The display object does not continuously track the target. If the target changes location during transit the display object will not modify its course.
	     * Note: The display object doesn't stop moving once it reaches the destination coordinates.
	     * Note: Doesn't take into account acceleration, maxVelocity or drag (if you've set drag or acceleration too high this object may not move at all)
	     *
	     * @method Phaser.Physics.Arcade.ArcadePhysics#moveToObject
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} gameObject - Any Game Object with an Arcade Physics body.
	     * @param {object} destination - Any object with public `x` and `y` properties, such as a Game Object or Geometry object.
	     * @param {number} [speed=60] - The speed it will move, in pixels per second (default is 60 pixels/sec)
	     * @param {number} [maxTime=0] - Time given in milliseconds (1000 = 1 sec). If set the speed is adjusted so the object will arrive at destination in the given number of ms.
	     *
	     * @return {number} The angle (in radians) that the object should be visually set to in order to match its new velocity.
	     */
	    moveToObject: function (gameObject, destination, speed, maxTime)
	    {
	        return this.moveTo(gameObject, destination.x, destination.y, speed, maxTime);
	    },
	
	    /**
	     * Given the angle (in degrees) and speed calculate the velocity and return it as a vector, or set it to the given vector object.
	     * One way to use this is: velocityFromAngle(angle, 200, sprite.body.velocity) which will set the values directly to the sprite's velocity and not create a new vector object.
	     *
	     * @method Phaser.Physics.Arcade.ArcadePhysics#velocityFromAngle
	     * @since 3.0.0
	     *
	     * @param {number} angle - The angle in degrees calculated in clockwise positive direction (down = 90 degrees positive, right = 0 degrees positive, up = 90 degrees negative)
	     * @param {number} [speed=60] - The speed it will move, in pixels per second squared.
	     * @param {Phaser.Math.Vector2} [vec2] - The Vector2 in which the x and y properties will be set to the calculated velocity.
	     *
	     * @return {Phaser.Math.Vector2} The Vector2 that stores the velocity.
	     */
	    velocityFromAngle: function (angle, speed, vec2)
	    {
	        if (speed === undefined) { speed = 60; }
	        if (vec2 === undefined) { vec2 = new Vector2(); }
	
	        return vec2.setToPolar(DegToRad(angle), speed);
	    },
	
	    /**
	     * Given the rotation (in radians) and speed calculate the velocity and return it as a vector, or set it to the given vector object.
	     * One way to use this is: velocityFromRotation(rotation, 200, sprite.body.velocity) which will set the values directly to the sprite's velocity and not create a new vector object.
	     *
	     * @method Phaser.Physics.Arcade.ArcadePhysics#velocityFromRotation
	     * @since 3.0.0
	     *
	     * @param {number} rotation - The angle in radians.
	     * @param {number} [speed=60] - The speed it will move, in pixels per second squared
	     * @param {Phaser.Math.Vector2} [vec2] - The Vector2 in which the x and y properties will be set to the calculated velocity.
	     *
	     * @return {Phaser.Math.Vector2} The Vector2 that stores the velocity.
	     */
	    velocityFromRotation: function (rotation, speed, vec2)
	    {
	        if (speed === undefined) { speed = 60; }
	        if (vec2 === undefined) { vec2 = new Vector2(); }
	
	        return vec2.setToPolar(rotation, speed);
	    },
	
	    /**
	     * The Scene that owns this plugin is shutting down.
	     * We need to kill and reset all internal properties as well as stop listening to Scene events.
	     *
	     * @method Phaser.Physics.Arcade.ArcadePhysics#shutdown
	     * @since 3.0.0
	     */
	    shutdown: function ()
	    {
	        var eventEmitter = this.systems.events;
	
	        eventEmitter.off('update', this.world.update, this.world);
	        eventEmitter.off('postupdate', this.world.postUpdate, this.world);
	        eventEmitter.off('shutdown', this.shutdown, this);
	
	        this.add.destroy();
	        this.world.destroy();
	
	        this.add = null;
	        this.world = null;
	    },
	
	    /**
	     * The Scene that owns this plugin is being destroyed.
	     * We need to shutdown and then kill off all external references.
	     *
	     * @method Phaser.Physics.Arcade.ArcadePhysics#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.shutdown();
	
	        this.scene.sys.events.off('start', this.start, this);
	
	        this.scene = null;
	        this.systems = null;
	    }
	
	});
	
	PluginCache.register('ArcadePhysics', ArcadePhysics, 'arcadePhysics');
	
	module.exports = ArcadePhysics;


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetOverlapX = __webpack_require__(584);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Physics.Arcade.SeparateX
	 * @since 3.0.0
	 *
	 * @param {Phaser.Physics.Arcade.Body} body1 - [description]
	 * @param {Phaser.Physics.Arcade.Body} body2 - [description]
	 * @param {boolean} overlapOnly - [description]
	 * @param {number} bias - [description]
	 *
	 * @return {boolean} [description]
	 */
	var SeparateX = function (body1, body2, overlapOnly, bias)
	{
	    var overlap = GetOverlapX(body1, body2, overlapOnly, bias);
	
	    //  Can't separate two immovable bodies, or a body with its own custom separation logic
	    if (overlapOnly || overlap === 0 || (body1.immovable && body2.immovable) || body1.customSeparateX || body2.customSeparateX)
	    {
	        //  return true if there was some overlap, otherwise false
	        return (overlap !== 0) || (body1.embedded && body2.embedded);
	    }
	
	    //  Adjust their positions and velocities accordingly (if there was any overlap)
	    var v1 = body1.velocity.x;
	    var v2 = body2.velocity.x;
	
	    if (!body1.immovable && !body2.immovable)
	    {
	        overlap *= 0.5;
	
	        body1.x -= overlap;
	        body2.x += overlap;
	
	        var nv1 = Math.sqrt((v2 * v2 * body2.mass) / body1.mass) * ((v2 > 0) ? 1 : -1);
	        var nv2 = Math.sqrt((v1 * v1 * body1.mass) / body2.mass) * ((v1 > 0) ? 1 : -1);
	        var avg = (nv1 + nv2) * 0.5;
	
	        nv1 -= avg;
	        nv2 -= avg;
	
	        body1.velocity.x = avg + nv1 * body1.bounce.x;
	        body2.velocity.x = avg + nv2 * body2.bounce.x;
	    }
	    else if (!body1.immovable)
	    {
	        body1.x -= overlap;
	        body1.velocity.x = v2 - v1 * body1.bounce.x;
	
	        //  This is special case code that handles things like vertically moving platforms you can ride
	        if (body2.moves)
	        {
	            body1.y += (body2.y - body2.prev.y) * body2.friction.y;
	        }
	    }
	    else
	    {
	        body2.x += overlap;
	        body2.velocity.x = v1 - v2 * body2.bounce.x;
	
	        //  This is special case code that handles things like vertically moving platforms you can ride
	        if (body1.moves)
	        {
	            body2.y += (body1.y - body1.prev.y) * body1.friction.y;
	        }
	    }
	
	    //  If we got this far then there WAS overlap, and separation is complete, so return true
	    return true;
	};
	
	module.exports = SeparateX;


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetOverlapY = __webpack_require__(585);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Physics.Arcade.SeparateY
	 * @since 3.0.0
	 *
	 * @param {Phaser.Physics.Arcade.Body} body1 - [description]
	 * @param {Phaser.Physics.Arcade.Body} body2 - [description]
	 * @param {boolean} overlapOnly - [description]
	 * @param {number} bias - [description]
	 *
	 * @return {boolean} [description]
	 */
	var SeparateY = function (body1, body2, overlapOnly, bias)
	{
	    var overlap = GetOverlapY(body1, body2, overlapOnly, bias);
	
	    //  Can't separate two immovable bodies, or a body with its own custom separation logic
	    if (overlapOnly || overlap === 0 || (body1.immovable && body2.immovable) || body1.customSeparateY || body2.customSeparateY)
	    {
	        //  return true if there was some overlap, otherwise false
	        return (overlap !== 0) || (body1.embedded && body2.embedded);
	    }
	
	    //  Adjust their positions and velocities accordingly (if there was any overlap)
	    var v1 = body1.velocity.y;
	    var v2 = body2.velocity.y;
	
	    if (!body1.immovable && !body2.immovable)
	    {
	        overlap *= 0.5;
	
	        body1.y -= overlap;
	        body2.y += overlap;
	
	        var nv1 = Math.sqrt((v2 * v2 * body2.mass) / body1.mass) * ((v2 > 0) ? 1 : -1);
	        var nv2 = Math.sqrt((v1 * v1 * body1.mass) / body2.mass) * ((v1 > 0) ? 1 : -1);
	        var avg = (nv1 + nv2) * 0.5;
	
	        nv1 -= avg;
	        nv2 -= avg;
	
	        body1.velocity.y = avg + nv1 * body1.bounce.y;
	        body2.velocity.y = avg + nv2 * body2.bounce.y;
	    }
	    else if (!body1.immovable)
	    {
	        body1.y -= overlap;
	        body1.velocity.y = v2 - v1 * body1.bounce.y;
	
	        //  This is special case code that handles things like horizontal moving platforms you can ride
	        if (body2.moves)
	        {
	            body1.x += (body2.x - body2.prev.x) * body2.friction.x;
	        }
	    }
	    else
	    {
	        body2.y += overlap;
	        body2.velocity.y = v1 - v2 * body2.bounce.y;
	
	        //  This is special case code that handles things like horizontal moving platforms you can ride
	        if (body1.moves)
	        {
	            body2.x += (body1.x - body1.prev.x) * body1.friction.x;
	        }
	    }
	
	    //  If we got this far then there WAS overlap, and separation is complete, so return true
	    return true;
	};
	
	module.exports = SeparateY;


/***/ }),
/* 1428 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Arcade.Components.Acceleration
	 * @since 3.0.0
	 */
	var Acceleration = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Acceleration#setAcceleration
	     * @since 3.0.0
	     *
	     * @param {number} x - The horizontal acceleration
	     * @param {number} [y=x] - The vertical acceleration
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setAcceleration: function (x, y)
	    {
	        this.body.acceleration.set(x, y);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Acceleration#setAccelerationX
	     * @since 3.0.0
	     *
	     * @param {number} value - The horizontal acceleration
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setAccelerationX: function (value)
	    {
	        this.body.acceleration.x = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Acceleration#setAccelerationY
	     * @since 3.0.0
	     *
	     * @param {number} value - The vertical acceleration
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setAccelerationY: function (value)
	    {
	        this.body.acceleration.y = value;
	
	        return this;
	    }
	
	};
	
	module.exports = Acceleration;


/***/ }),
/* 1429 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Arcade.Components.Angular
	 * @since 3.0.0
	 */
	var Angular = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Angular#setAngularVelocity
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setAngularVelocity: function (value)
	    {
	        this.body.angularVelocity = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Angular#setAngularAcceleration
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setAngularAcceleration: function (value)
	    {
	        this.body.angularAcceleration = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Angular#setAngularDrag
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setAngularDrag: function (value)
	    {
	        this.body.angularDrag = value;
	
	        return this;
	    }
	
	};
	
	module.exports = Angular;


/***/ }),
/* 1430 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Arcade.Components.Bounce
	 * @since 3.0.0
	 */
	var Bounce = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Bounce#setBounce
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} [y=x] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setBounce: function (x, y)
	    {
	        this.body.bounce.set(x, y);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Bounce#setBounceX
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setBounceX: function (value)
	    {
	        this.body.bounce.x = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Bounce#setBounceY
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setBounceY: function (value)
	    {
	        this.body.bounce.y = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Bounce#setCollideWorldBounds
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setCollideWorldBounds: function (value)
	    {
	        this.body.collideWorldBounds = value;
	
	        return this;
	    }
	
	};
	
	module.exports = Bounce;


/***/ }),
/* 1431 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Arcade.Components.Debug
	 * @since 3.0.0
	 */
	var Debug = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Debug#setDebug
	     * @since 3.0.0
	     *
	     * @param {boolean} showBody - [description]
	     * @param {boolean} showVelocity - [description]
	     * @param {number} bodyColor - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setDebug: function (showBody, showVelocity, bodyColor)
	    {
	        this.debugShowBody = showBody;
	        this.debugShowVelocity = showVelocity;
	        this.debugBodyColor = bodyColor;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Debug#setDebugBodyColor
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setDebugBodyColor: function (value)
	    {
	        this.body.debugBodyColor = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Physics.Arcade.Components.Debug#debugShowBody
	     * @type {boolean}
	     * @since 3.0.0
	     */
	    debugShowBody: {
	
	        get: function ()
	        {
	            return this.body.debugShowBody;
	        },
	
	        set: function (value)
	        {
	            this.body.debugShowBody = value;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Physics.Arcade.Components.Debug#debugShowVelocity
	     * @type {boolean}
	     * @since 3.0.0
	     */
	    debugShowVelocity: {
	
	        get: function ()
	        {
	            return this.body.debugShowVelocity;
	        },
	
	        set: function (value)
	        {
	            this.body.debugShowVelocity = value;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Physics.Arcade.Components.Debug#debugBodyColor
	     * @type {number}
	     * @since 3.0.0
	     */
	    debugBodyColor: {
	
	        get: function ()
	        {
	            return this.body.debugBodyColor;
	        },
	
	        set: function (value)
	        {
	            this.body.debugBodyColor = value;
	        }
	
	    }
	
	};
	
	module.exports = Debug;


/***/ }),
/* 1432 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Arcade.Components.Drag
	 * @since 3.0.0
	 */
	var Drag = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Drag#setDrag
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} [y=x] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setDrag: function (x, y)
	    {
	        this.body.drag.set(x, y);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Drag#setDragX
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setDragX: function (value)
	    {
	        this.body.drag.x = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Drag#setDragY
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setDragY: function (value)
	    {
	        this.body.drag.y = value;
	
	        return this;
	    }
	
	};
	
	module.exports = Drag;


/***/ }),
/* 1433 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Arcade.Components.Enable
	 * @since 3.0.0
	 */
	var Enable = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Enable#enableBody
	     * @since 3.0.0
	     *
	     * @param {boolean} reset - [description]
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {boolean} enableGameObject - [description]
	     * @param {boolean} showGameObject - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    enableBody: function (reset, x, y, enableGameObject, showGameObject)
	    {
	        if (reset)
	        {
	            this.body.reset(x, y);
	        }
	
	        if (enableGameObject)
	        {
	            this.body.gameObject.active = true;
	        }
	
	        if (showGameObject)
	        {
	            this.body.gameObject.visible = true;
	        }
	
	        this.body.enable = true;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Enable#disableBody
	     * @since 3.0.0
	     *
	     * @param {boolean} [disableGameObject=false] - [description]
	     * @param {boolean} [hideGameObject=false] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    disableBody: function (disableGameObject, hideGameObject)
	    {
	        if (disableGameObject === undefined) { disableGameObject = false; }
	        if (hideGameObject === undefined) { hideGameObject = false; }
	
	        this.body.stop();
	
	        this.body.enable = false;
	
	        if (disableGameObject)
	        {
	            this.body.gameObject.active = false;
	        }
	
	        if (hideGameObject)
	        {
	            this.body.gameObject.visible = false;
	        }
	
	        return this;
	    },
	
	    /**
	     * Syncs the Bodies position and size with its parent Game Object.
	     * You don't need to call this for Dynamic Bodies, as it happens automatically.
	     * But for Static bodies it's a useful way of modifying the position of a Static Body
	     * in the Physics World, based on its Game Object.
	     *
	     * @method Phaser.Physics.Arcade.Components.Enable#refreshBody
	     * @since 3.1.0
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    refreshBody: function ()
	    {
	        this.body.updateFromGameObject();
	
	        return this;
	    }
	
	};
	
	module.exports = Enable;


/***/ }),
/* 1434 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Arcade.Components.Friction
	 * @since 3.0.0
	 */
	var Friction = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Friction#setFriction
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} [y=x] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setFriction: function (x, y)
	    {
	        this.body.friction.set(x, y);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Friction#setFrictionX
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setFrictionX: function (x)
	    {
	        this.body.friction.x = x;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Friction#setFrictionY
	     * @since 3.0.0
	     *
	     * @param {number} y - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setFrictionY: function (y)
	    {
	        this.body.friction.y = y;
	
	        return this;
	    }
	
	};
	
	module.exports = Friction;


/***/ }),
/* 1435 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Arcade.Components.Gravity
	 * @since 3.0.0
	 */
	var Gravity = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Gravity#setGravity
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} [y=x] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setGravity: function (x, y)
	    {
	        this.body.gravity.set(x, y);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Gravity#setGravityX
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setGravityX: function (x)
	    {
	        this.body.gravity.x = x;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Gravity#setGravityY
	     * @since 3.0.0
	     *
	     * @param {number} y - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setGravityY: function (y)
	    {
	        this.body.gravity.y = y;
	
	        return this;
	    }
	
	};
	
	module.exports = Gravity;


/***/ }),
/* 1436 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Arcade.Components.Immovable
	 * @since 3.0.0
	 */
	var Immovable = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Immovable#setImmovable
	     * @since 3.0.0
	     *
	     * @param {boolean} [value=true] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setImmovable: function (value)
	    {
	        if (value === undefined) { value = true; }
	
	        this.body.immovable = value;
	
	        return this;
	    }
	
	};
	
	module.exports = Immovable;


/***/ }),
/* 1437 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Arcade.Components.Mass
	 * @since 3.0.0
	 */
	var Mass = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Mass#setMass
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setMass: function (value)
	    {
	        this.body.mass = value;
	
	        return this;
	    }
	
	};
	
	module.exports = Mass;


/***/ }),
/* 1438 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Arcade.Components.Size
	 * @since 3.0.0
	 */
	var Size = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Size#setOffset
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} [y=x] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setOffset: function (x, y)
	    {
	        this.body.setOffset(x, y);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Size#setSize
	     * @since 3.0.0
	     *
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     * @param {boolean} [center=true] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setSize: function (width, height, center)
	    {
	        this.body.setSize(width, height, center);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Size#setCircle
	     * @since 3.0.0
	     *
	     * @param {number} radius - [description]
	     * @param {number} [offsetX] - [description]
	     * @param {number} [offsetY] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setCircle: function (radius, offsetX, offsetY)
	    {
	        this.body.setCircle(radius, offsetX, offsetY);
	
	        return this;
	    }
	
	};
	
	module.exports = Size;


/***/ }),
/* 1439 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Arcade.Components.Velocity
	 * @since 3.0.0
	 */
	var Velocity = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Velocity#setVelocity
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} [y=x] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setVelocity: function (x, y)
	    {
	        this.body.velocity.set(x, y);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Velocity#setVelocityX
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setVelocityX: function (x)
	    {
	        this.body.velocity.x = x;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Velocity#setVelocityY
	     * @since 3.0.0
	     *
	     * @param {number} y - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setVelocityY: function (y)
	    {
	        this.body.velocity.y = y;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Arcade.Components.Velocity#setMaxVelocity
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} [y=x] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setMaxVelocity: function (x, y)
	    {
	        this.body.maxVelocity.set(x, y);
	
	        return this;
	    }
	
	};
	
	module.exports = Velocity;


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CONST = __webpack_require__(117);
	var Extend = __webpack_require__(36);
	
	/**
	 * @callback ArcadePhysicsCallback
	 *
	 * @param {Phaser.GameObjects.GameObject} object1 - [description]
	 * @param {Phaser.GameObjects.GameObject} object2 - [description]
	 */
	
	/**
	 * @namespace Phaser.Physics.Arcade
	 */
	
	var Arcade = {
	
	    ArcadePhysics: __webpack_require__(1425),
	    Body: __webpack_require__(581),
	    Collider: __webpack_require__(582),
	    Factory: __webpack_require__(583),
	    Group: __webpack_require__(586),
	    Image: __webpack_require__(580),
	    Sprite: __webpack_require__(204),
	    StaticBody: __webpack_require__(587),
	    StaticGroup: __webpack_require__(588),
	    World: __webpack_require__(589)
	
	};
	
	//   Merge in the consts
	Arcade = Extend(false, Arcade, CONST);
	
	module.exports = Arcade;


/***/ }),
/* 1441 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Physics.Arcade.Tilemap.ProcessTileCallbacks
	 * @since 3.0.0
	 *
	 * @param {Phaser.Tilemaps.Tilemap} tile - [description]
	 * @param {Phaser.GameObjects.Sprite} sprite - [description]
	 *
	 * @return {boolean} [description]
	 */
	var ProcessTileCallbacks = function (tile, sprite)
	{
	    // Tile callbacks take priority over layer level callbacks
	    if (tile.collisionCallback)
	    {
	        return !tile.collisionCallback.call(tile.collisionCallbackContext, sprite, tile);
	    }
	    else if (tile.layer.callbacks[tile.index])
	    {
	        return !tile.layer.callbacks[tile.index].callback.call(
	            tile.layer.callbacks[tile.index].callbackContext, sprite, tile
	        );
	    }
	
	    return true;
	};
	
	module.exports = ProcessTileCallbacks;


/***/ }),
/* 1442 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Internal function to process the separation of a physics body from a tile.
	 *
	 * @function Phaser.Physics.Arcade.Tilemap.ProcessTileSeparationX
	 * @since 3.0.0
	 *
	 * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
	 * @param {number} x - The x separation amount.
	 */
	var ProcessTileSeparationX = function (body, x)
	{
	    if (x < 0)
	    {
	        body.blocked.left = true;
	    }
	    else if (x > 0)
	    {
	        body.blocked.right = true;
	    }
	
	    body.position.x -= x;
	
	    if (body.bounce.x === 0)
	    {
	        body.velocity.x = 0;
	    }
	    else
	    {
	        body.velocity.x = -body.velocity.x * body.bounce.x;
	    }
	};
	
	module.exports = ProcessTileSeparationX;


/***/ }),
/* 1443 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Internal function to process the separation of a physics body from a tile.
	 *
	 * @function Phaser.Physics.Arcade.Tilemap.ProcessTileSeparationY
	 * @since 3.0.0
	 *
	 * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
	 * @param {number} y - The y separation amount.
	 */
	var ProcessTileSeparationY = function (body, y)
	{
	    if (y < 0)
	    {
	        body.blocked.up = true;
	    }
	    else if (y > 0)
	    {
	        body.blocked.down = true;
	    }
	
	    body.position.y -= y;
	
	    if (body.bounce.y === 0)
	    {
	        body.velocity.y = 0;
	    }
	    else
	    {
	        body.velocity.y = -body.velocity.y * body.bounce.y;
	    }
	};
	
	module.exports = ProcessTileSeparationY;


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var TileCheckX = __webpack_require__(1445);
	var TileCheckY = __webpack_require__(1446);
	var TileIntersectsBody = __webpack_require__(591);
	
	/**
	 * The core separation function to separate a physics body and a tile.
	 *
	 * @function Phaser.Physics.Arcade.Tilemap.SeparateTile
	 * @since 3.0.0
	 *
	 * @param {number} i - [description]
	 * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
	 * @param {Phaser.Tilemaps.Tile} tile - The tile to collide against.
	 * @param {Phaser.Geom.Rectangle} tileWorldRect - [description]
	 * @param {(Phaser.Tilemaps.DynamicTilemapLayer|Phaser.Tilemaps.StaticTilemapLayer)} tilemapLayer - The tilemapLayer to collide against.
	 * @param {number} tileBias - [description]
	 *
	 * @return {boolean} Returns true if the body was separated, otherwise false.
	 */
	var SeparateTile = function (i, body, tile, tileWorldRect, tilemapLayer, tileBias)
	{
	    var tileLeft = tileWorldRect.left;
	    var tileTop = tileWorldRect.top;
	    var tileRight = tileWorldRect.right;
	    var tileBottom = tileWorldRect.bottom;
	    var faceHorizontal = tile.faceLeft || tile.faceRight;
	    var faceVertical = tile.faceTop || tile.faceBottom;
	
	    //  We don't need to go any further if this tile doesn't actually have any colliding faces. This
	    //  could happen if the tile was meant to be collided with re: a callback, but otherwise isn't
	    //  needed for separation.
	    if (!faceHorizontal && !faceVertical)
	    {
	        return false;
	    }
	
	    var ox = 0;
	    var oy = 0;
	    var minX = 0;
	    var minY = 1;
	
	    if (body.deltaAbsX() > body.deltaAbsY())
	    {
	        //  Moving faster horizontally, check X axis first
	        minX = -1;
	    }
	    else if (body.deltaAbsX() < body.deltaAbsY())
	    {
	        //  Moving faster vertically, check Y axis first
	        minY = -1;
	    }
	
	    if (body.deltaX() !== 0 && body.deltaY() !== 0 && faceHorizontal && faceVertical)
	    {
	        //  We only need do this if both axes have colliding faces AND we're moving in both
	        //  directions
	        minX = Math.min(Math.abs(body.position.x - tileRight), Math.abs(body.right - tileLeft));
	        minY = Math.min(Math.abs(body.position.y - tileBottom), Math.abs(body.bottom - tileTop));
	    }
	
	    if (minX < minY)
	    {
	        if (faceHorizontal)
	        {
	            ox = TileCheckX(body, tile, tileLeft, tileRight, tileBias);
	
	            //  That's horizontal done, check if we still intersects? If not then we can return now
	            if (ox !== 0 && !TileIntersectsBody(tileWorldRect, body))
	            {
	                return true;
	            }
	        }
	
	        if (faceVertical)
	        {
	            oy = TileCheckY(body, tile, tileTop, tileBottom, tileBias);
	        }
	    }
	    else
	    {
	        if (faceVertical)
	        {
	            oy = TileCheckY(body, tile, tileTop, tileBottom, tileBias);
	
	            //  That's vertical done, check if we still intersects? If not then we can return now
	            if (oy !== 0 && !TileIntersectsBody(tileWorldRect, body))
	            {
	                return true;
	            }
	        }
	
	        if (faceHorizontal)
	        {
	            ox = TileCheckX(body, tile, tileLeft, tileRight, tileBias);
	        }
	    }
	
	    return (ox !== 0 || oy !== 0);
	};
	
	module.exports = SeparateTile;


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var ProcessTileSeparationX = __webpack_require__(1442);
	
	/**
	 * Check the body against the given tile on the X axis.
	 *
	 * @function Phaser.Physics.Arcade.Tilemap.TileCheckX
	 * @since 3.0.0
	 *
	 * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
	 * @param {Phaser.Tilemaps.Tile} tile - The tile to check.
	 * @param {number} tileLeft - [description]
	 * @param {number} tileRight - [description]
	 * @param {number} tileBias - [description]
	 *
	 * @return {number} The amount of separation that occurred.
	 */
	var TileCheckX = function (body, tile, tileLeft, tileRight, tileBias)
	{
	    var ox = 0;
	
	    if (body.deltaX() < 0 && !body.blocked.left && tile.collideRight && body.checkCollision.left)
	    {
	        //  Body is moving LEFT
	        if (tile.faceRight && body.x < tileRight)
	        {
	            ox = body.x - tileRight;
	
	            if (ox < -tileBias)
	            {
	                ox = 0;
	            }
	        }
	    }
	    else if (body.deltaX() > 0 && !body.blocked.right && tile.collideLeft && body.checkCollision.right)
	    {
	        //  Body is moving RIGHT
	        if (tile.faceLeft && body.right > tileLeft)
	        {
	            ox = body.right - tileLeft;
	
	            if (ox > tileBias)
	            {
	                ox = 0;
	            }
	        }
	    }
	
	    if (ox !== 0)
	    {
	        if (body.customSeparateX)
	        {
	            body.overlapX = ox;
	        }
	        else
	        {
	            ProcessTileSeparationX(body, ox);
	        }
	    }
	
	    return ox;
	};
	
	module.exports = TileCheckX;


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var ProcessTileSeparationY = __webpack_require__(1443);
	
	/**
	 * Check the body against the given tile on the Y axis.
	 *
	 * @function Phaser.Physics.Arcade.Tilemap.TileCheckY
	 * @since 3.0.0
	 *
	 * @param {Phaser.Physics.Arcade.Body} body - The Body object to separate.
	 * @param {Phaser.Tilemaps.Tile} tile - The tile to check.
	 * @param {number} tileTop - [description]
	 * @param {number} tileBottom - [description]
	 * @param {number} tileBias - [description]
	 *
	 * @return {number} The amount of separation that occurred.
	 */
	var TileCheckY = function (body, tile, tileTop, tileBottom, tileBias)
	{
	    var oy = 0;
	
	    if (body.deltaY() < 0 && !body.blocked.up && tile.collideDown && body.checkCollision.up)
	    {
	        //  Body is moving UP
	        if (tile.faceBottom && body.y < tileBottom)
	        {
	            oy = body.y - tileBottom;
	
	            if (oy < -tileBias)
	            {
	                oy = 0;
	            }
	        }
	    }
	    else if (body.deltaY() > 0 && !body.blocked.down && tile.collideUp && body.checkCollision.down)
	    {
	        //  Body is moving DOWN
	        if (tile.faceTop && body.bottom > tileTop)
	        {
	            oy = body.bottom - tileTop;
	
	            if (oy > tileBias)
	            {
	                oy = 0;
	            }
	        }
	    }
	
	    if (oy !== 0)
	    {
	        if (body.customSeparateY)
	        {
	            body.overlapY = oy;
	        }
	        else
	        {
	            ProcessTileSeparationY(body, oy);
	        }
	    }
	
	    return oy;
	};
	
	module.exports = TileCheckY;


/***/ }),
/* 1447 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var H = 0.5;
	var N = 1 / 3;
	var M = 2 / 3;
	
	//  Tile ID to Slope defs.
	//  First 4 elements = line data, final = solid or non-solid behind the line
	    
	module.exports = {
	
	    2: [ 0, 1, 1, 0, true ],
	    3: [ 0, 1, 1, H, true ],
	    4: [ 0, H, 1, 0, true ],
	    5: [ 0, 1, 1, M, true ],
	    6: [ 0, M, 1, N, true ],
	    7: [ 0, N, 1, 0, true ],
	    8: [ H, 1, 0, 0, true ],
	    9: [ 1, 0, H, 1, true ],
	    10: [ H, 1, 1, 0, true ],
	    11: [ 0, 0, H, 1, true ],
	    12: [ 0, 0, 1, 0, false ],
	    13: [ 1, 1, 0, 0, true ],
	    14: [ 1, H, 0, 0, true ],
	    15: [ 1, 1, 0, H, true ],
	    16: [ 1, N, 0, 0, true ],
	    17: [ 1, M, 0, N, true ],
	    18: [ 1, 1, 0, M, true ],
	    19: [ 1, 1, H, 0, true ],
	    20: [ H, 0, 0, 1, true ],
	    21: [ 0, 1, H, 0, true ],
	    22: [ H, 0, 1, 1, true ],
	    23: [ 1, 1, 0, 1, false ],
	    24: [ 0, 0, 1, 1, true ],
	    25: [ 0, 0, 1, H, true ],
	    26: [ 0, H, 1, 1, true ],
	    27: [ 0, 0, 1, N, true ],
	    28: [ 0, N, 1, M, true ],
	    29: [ 0, M, 1, 1, true ],
	    30: [ N, 1, 0, 0, true ],
	    31: [ 1, 0, M, 1, true ],
	    32: [ M, 1, 1, 0, true ],
	    33: [ 0, 0, N, 1, true ],
	    34: [ 1, 0, 1, 1, false ],
	    35: [ 1, 0, 0, 1, true ],
	    36: [ 1, H, 0, 1, true ],
	    37: [ 1, 0, 0, H, true ],
	    38: [ 1, M, 0, 1, true ],
	    39: [ 1, N, 0, M, true ],
	    40: [ 1, 0, 0, N, true ],
	    41: [ M, 1, N, 0, true ],
	    42: [ M, 0, N, 1, true ],
	    43: [ N, 1, M, 0, true ],
	    44: [ N, 0, M, 1, true ],
	    45: [ 0, 1, 0, 0, false ],
	    52: [ 1, 1, M, 0, true ],
	    53: [ N, 0, 0, 1, true ],
	    54: [ 0, 1, N, 0, true ],
	    55: [ M, 0, 1, 1, true ]
	
	};


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Clamp = __webpack_require__(63);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Physics.Impact.GetVelocity
	 * @since 3.0.0
	 *
	 * @param {number} delta - [description]
	 * @param {number} vel - [description]
	 * @param {number} accel - [description]
	 * @param {number} friction - [description]
	 * @param {number} max - [description]
	 *
	 * @return {number} [description]
	 */
	var GetVelocity = function (delta, vel, accel, friction, max)
	{
	    if (accel)
	    {
	        return Clamp(vel + accel * delta, -max, max);
	    }
	    else if (friction)
	    {
	        var frictionDelta = friction * delta;
	        
	        if (vel - frictionDelta > 0)
	        {
	            return vel - frictionDelta;
	        }
	        else if (vel + frictionDelta < 0)
	        {
	            return vel + frictionDelta;
	        }
	        else
	        {
	            return 0;
	        }
	    }
	
	    return Clamp(vel, -max, max);
	};
	
	module.exports = GetVelocity;


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Factory = __webpack_require__(594);
	var GetFastValue = __webpack_require__(3);
	var Merge = __webpack_require__(148);
	var PluginCache = __webpack_require__(29);
	var World = __webpack_require__(598);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class ImpactPhysics
	 * @memberOf Phaser.Physics.Impact
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - [description]
	 */
	var ImpactPhysics = new Class({
	
	    initialize:
	
	    function ImpactPhysics (scene)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactPhysics#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactPhysics#systems
	         * @type {Phaser.Scenes.Systems}
	         * @since 3.0.0
	         */
	        this.systems = scene.sys;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactPhysics#config
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.config = this.getConfig();
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactPhysics#world
	         * @type {Phaser.Physics.Impact.World}
	         * @since 3.0.0
	         */
	        this.world;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Impact.ImpactPhysics#add
	         * @type {Phaser.Physics.Impact.Factory}
	         * @since 3.0.0
	         */
	        this.add;
	
	        scene.sys.events.once('boot', this.boot, this);
	        scene.sys.events.on('start', this.start, this);
	    },
	
	    /**
	     * This method is called automatically, only once, when the Scene is first created.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.Physics.Impact.ImpactPhysics#boot
	     * @private
	     * @since 3.5.1
	     */
	    boot: function ()
	    {
	        this.world = new World(this.scene, this.config);
	        this.add = new Factory(this.world);
	
	        this.systems.events.once('destroy', this.destroy, this);
	    },
	
	    /**
	     * This method is called automatically by the Scene when it is starting up.
	     * It is responsible for creating local systems, properties and listening for Scene events.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.Physics.Impact.ImpactPhysics#start
	     * @private
	     * @since 3.5.0
	     */
	    start: function ()
	    {
	        if (!this.world)
	        {
	            this.world = new World(this.scene, this.config);
	            this.add = new Factory(this.world);
	        }
	
	        var eventEmitter = this.systems.events;
	
	        eventEmitter.on('update', this.world.update, this.world);
	        eventEmitter.once('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.ImpactPhysics#getConfig
	     * @since 3.0.0
	     *
	     * @return {object} [description]
	     */
	    getConfig: function ()
	    {
	        var gameConfig = this.systems.game.config.physics;
	        var sceneConfig = this.systems.settings.physics;
	
	        var config = Merge(
	            GetFastValue(sceneConfig, 'impact', {}),
	            GetFastValue(gameConfig, 'impact', {})
	        );
	
	        return config;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.ImpactPhysics#pause
	     * @since 3.0.0
	     *
	     * @return {Phaser.Physics.Impact.World} The Impact World object.
	     */
	    pause: function ()
	    {
	        return this.world.pause();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.ImpactPhysics#resume
	     * @since 3.0.0
	     *
	     * @return {Phaser.Physics.Impact.World} The Impact World object.
	     */
	    resume: function ()
	    {
	        return this.world.resume();
	    },
	
	    /**
	     * The Scene that owns this plugin is shutting down.
	     * We need to kill and reset all internal properties as well as stop listening to Scene events.
	     *
	     * @method Phaser.Physics.Impact.ImpactPhysics#shutdown
	     * @private
	     * @since 3.0.0
	     */
	    shutdown: function ()
	    {
	        var eventEmitter = this.systems.events;
	
	        eventEmitter.off('update', this.world.update, this.world);
	        eventEmitter.off('shutdown', this.shutdown, this);
	
	        this.add.destroy();
	        this.world.destroy();
	
	        this.add = null;
	        this.world = null;
	    },
	
	    /**
	     * The Scene that owns this plugin is being destroyed.
	     * We need to shutdown and then kill off all external references.
	     *
	     * @method Phaser.Physics.Impact.ImpactPhysics#destroy
	     * @private
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.shutdown();
	
	        this.scene.sys.events.off('start', this.start, this);
	
	        this.scene = null;
	        this.systems = null;
	    }
	
	});
	
	PluginCache.register('ImpactPhysics', ImpactPhysics, 'impactPhysics');
	
	module.exports = ImpactPhysics;


/***/ }),
/* 1450 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Physics.Impact.SeperateX
	 * @since 3.0.0
	 *
	 * @param {Phaser.Physics.Impact.World} world - [description]
	 * @param {Phaser.Physics.Impact.Body} left - [description]
	 * @param {Phaser.Physics.Impact.Body} right - [description]
	 * @param {Phaser.Physics.Impact.Body} [weak] - [description]
	 */
	var SeperateX = function (world, left, right, weak)
	{
	    var nudge = left.pos.x + left.size.x - right.pos.x;
	    
	    // We have a weak entity, so just move this one
	    if (weak)
	    {
	        var strong = (left === weak) ? right : left;
	
	        weak.vel.x = -weak.vel.x * weak.bounciness + strong.vel.x;
	        
	        var resWeak = world.collisionMap.trace(weak.pos.x, weak.pos.y, weak === left ? -nudge : nudge, 0, weak.size.x, weak.size.y);
	
	        weak.pos.x = resWeak.pos.x;
	    }
	    else
	    {
	        var v2 = (left.vel.x - right.vel.x) / 2;
	
	        left.vel.x = -v2;
	        right.vel.x = v2;
	    
	        var resLeft = world.collisionMap.trace(left.pos.x, left.pos.y, -nudge / 2, 0, left.size.x, left.size.y);
	
	        left.pos.x = Math.floor(resLeft.pos.x);
	        
	        var resRight = world.collisionMap.trace(right.pos.x, right.pos.y, nudge / 2, 0, right.size.x, right.size.y);
	
	        right.pos.x = Math.ceil(resRight.pos.x);
	    }
	};
	
	module.exports = SeperateX;


/***/ }),
/* 1451 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Physics.Impact.SeperateY
	 * @since 3.0.0
	 *
	 * @param {Phaser.Physics.Impact.World} world - [description]
	 * @param {Phaser.Physics.Impact.Body} top - [description]
	 * @param {Phaser.Physics.Impact.Body} bottom - [description]
	 * @param {Phaser.Physics.Impact.Body} [weak] - [description]
	 */
	var SeperateY = function (world, top, bottom, weak)
	{
	    var nudge = (top.pos.y + top.size.y - bottom.pos.y);
	    var nudgeX;
	    var resTop;
	    
	    if (weak)
	    {
	        var strong = (top === weak) ? bottom : top;
	
	        weak.vel.y = -weak.vel.y * weak.bounciness + strong.vel.y;
	        
	        // Riding on a platform?
	        nudgeX = 0;
	
	        if (weak === top && Math.abs(weak.vel.y - strong.vel.y) < weak.minBounceVelocity)
	        {
	            weak.standing = true;
	            nudgeX = strong.vel.x * world.delta;
	        }
	        
	        var resWeak = world.collisionMap.trace(weak.pos.x, weak.pos.y, nudgeX, weak === top ? -nudge : nudge, weak.size.x, weak.size.y);
	
	        weak.pos.y = resWeak.pos.y;
	        weak.pos.x = resWeak.pos.x;
	    }
	    else if (world.gravity && (bottom.standing || top.vel.y > 0))
	    {
	        resTop = world.collisionMap.trace(top.pos.x, top.pos.y, 0, -(top.pos.y + top.size.y - bottom.pos.y), top.size.x, top.size.y);
	
	        top.pos.y = resTop.pos.y;
	        
	        if (top.bounciness > 0 && top.vel.y > top.minBounceVelocity)
	        {
	            top.vel.y *= -top.bounciness;
	        }
	        else
	        {
	            top.standing = true;
	            top.vel.y = 0;
	        }
	    }
	    else
	    {
	        var v2 = (top.vel.y - bottom.vel.y) / 2;
	
	        top.vel.y = -v2;
	        bottom.vel.y = v2;
	        
	        nudgeX = bottom.vel.x * world.delta;
	
	        resTop = world.collisionMap.trace(top.pos.x, top.pos.y, nudgeX, -nudge / 2, top.size.x, top.size.y);
	
	        top.pos.y = resTop.pos.y;
	        
	        var resBottom = world.collisionMap.trace(bottom.pos.x, bottom.pos.y, 0, nudge / 2, bottom.size.x, bottom.size.y);
	
	        bottom.pos.y = resBottom.pos.y;
	    }
	};
	
	module.exports = SeperateY;


/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var COLLIDES = __webpack_require__(164);
	var SeperateX = __webpack_require__(1450);
	var SeperateY = __webpack_require__(1451);
	
	/**
	 * Impact Physics Solver
	 *
	 * @function Phaser.Physics.Impact.Solver
	 * @since 3.0.0
	 *
	 * @param {Phaser.Physics.Impact.World} world - [description]
	 * @param {Phaser.Physics.Impact.Body} bodyA - [description]
	 * @param {Phaser.Physics.Impact.Body} bodyB - [description]
	 */
	var Solver = function (world, bodyA, bodyB)
	{
	    var weak = null;
	
	    if (bodyA.collides === COLLIDES.LITE || bodyB.collides === COLLIDES.FIXED)
	    {
	        weak = bodyA;
	    }
	    else if (bodyB.collides === COLLIDES.LITE || bodyA.collides === COLLIDES.FIXED)
	    {
	        weak = bodyB;
	    }
	
	    if (bodyA.last.x + bodyA.size.x > bodyB.last.x && bodyA.last.x < bodyB.last.x + bodyB.size.x)
	    {
	        if (bodyA.last.y < bodyB.last.y)
	        {
	            SeperateY(world, bodyA, bodyB, weak);
	        }
	        else
	        {
	            SeperateY(world, bodyB, bodyA, weak);
	        }
	
	        bodyA.collideWith(bodyB, 'y');
	        bodyB.collideWith(bodyA, 'y');
	
	        world.emit('collide', bodyA, bodyB, 'y');
	    }
	    else if (bodyA.last.y + bodyA.size.y > bodyB.last.y && bodyA.last.y < bodyB.last.y + bodyB.size.y)
	    {
	        if (bodyA.last.x < bodyB.last.x)
	        {
	            SeperateX(world, bodyA, bodyB, weak);
	        }
	        else
	        {
	            SeperateX(world, bodyB, bodyA, weak);
	        }
	
	        bodyA.collideWith(bodyB, 'x');
	        bodyB.collideWith(bodyA, 'x');
	
	        world.emit('collide', bodyA, bodyB, 'x');
	    }
	};
	
	module.exports = Solver;


/***/ }),
/* 1453 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Set up the trace-result
	 * var res = {
	 *     collision: {x: false, y: false, slope: false},
	 *     pos: {x: x, y: y},
	 *     tile: {x: 0, y: 0}
	 * };
	 *
	 * @function Phaser.Physics.Impact.UpdateMotion
	 * @since 3.0.0
	 *
	 * @param {Phaser.Physics.Impact.Body} body - [description]
	 * @param {object} res - [description]
	 */
	var UpdateMotion = function (body, res)
	{
	    body.standing = false;
	
	    //  Y
	    if (res.collision.y)
	    {
	        if (body.bounciness > 0 && Math.abs(body.vel.y) > body.minBounceVelocity)
	        {
	            body.vel.y *= -body.bounciness;
	        }
	        else
	        {
	            if (body.vel.y > 0)
	            {
	                body.standing = true;
	            }
	
	            body.vel.y = 0;
	        }
	    }
	
	    //  X
	    if (res.collision.x)
	    {
	        if (body.bounciness > 0 && Math.abs(body.vel.x) > body.minBounceVelocity)
	        {
	            body.vel.x *= -body.bounciness;
	        }
	        else
	        {
	            body.vel.x = 0;
	        }
	    }
	
	    //  SLOPE
	    if (res.collision.slope)
	    {
	        var s = res.collision.slope;
	       
	        if (body.bounciness > 0)
	        {
	            var proj = body.vel.x * s.nx + body.vel.y * s.ny;
	
	            body.vel.x = (body.vel.x - s.nx * proj * 2) * body.bounciness;
	            body.vel.y = (body.vel.y - s.ny * proj * 2) * body.bounciness;
	        }
	        else
	        {
	            var lengthSquared = s.x * s.x + s.y * s.y;
	            var dot = (body.vel.x * s.x + body.vel.y * s.y) / lengthSquared;
	            
	            body.vel.x = s.x * dot;
	            body.vel.y = s.y * dot;
	            
	            var angle = Math.atan2(s.x, s.y);
	
	            if (angle > body.slopeStanding.min && angle < body.slopeStanding.max)
	            {
	                body.standing = true;
	            }
	        }
	    }
	
	    body.pos.x = res.pos.x;
	    body.pos.y = res.pos.y;
	};
	
	module.exports = UpdateMotion;


/***/ }),
/* 1454 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Impact.Components.Acceleration
	 * @since 3.0.0
	 */
	var Acceleration = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.Acceleration#setAccelerationX
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setAccelerationX: function (x)
	    {
	        this.accel.x = x;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.Acceleration#setAccelerationY
	     * @since 3.0.0
	     *
	     * @param {number} y - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setAccelerationY: function (y)
	    {
	        this.accel.y = y;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.Acceleration#setAcceleration
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setAcceleration: function (x, y)
	    {
	        this.accel.x = x;
	        this.accel.y = y;
	
	        return this;
	    }
	
	};
	
	module.exports = Acceleration;


/***/ }),
/* 1455 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Impact.Components.BodyScale
	 * @since 3.0.0
	 */
	var BodyScale = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.BodyScale#setBodySize
	     * @since 3.0.0
	     *
	     * @param {number} width - [description]
	     * @param {number} [height=width] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setBodySize: function (width, height)
	    {
	        if (height === undefined) { height = width; }
	
	        this.body.size.x = Math.round(width);
	        this.body.size.y = Math.round(height);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.BodyScale#setBodyScale
	     * @since 3.0.0
	     *
	     * @param {number} scaleX - [description]
	     * @param {number} [scaleY] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setBodyScale: function (scaleX, scaleY)
	    {
	        if (scaleY === undefined) { scaleY = scaleX; }
	
	        var gameObject = this.body.gameObject;
	
	        if (gameObject)
	        {
	            gameObject.setScale(scaleX, scaleY);
	
	            return this.setBodySize(gameObject.width * gameObject.scaleX, gameObject.height * gameObject.scaleY);
	        }
	        else
	        {
	            return this.setBodySize(this.body.size.x * scaleX, this.body.size.y * scaleY);
	        }
	    }
	
	};
	
	module.exports = BodyScale;


/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var TYPE = __webpack_require__(165);
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Impact.Components.BodyType
	 * @since 3.0.0
	 */
	var BodyType = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.BodyType#getBodyType
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    getBodyType: function ()
	    {
	        return this.body.type;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.BodyType#setTypeNone
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setTypeNone: function ()
	    {
	        this.body.type = TYPE.NONE;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.BodyType#setTypeA
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setTypeA: function ()
	    {
	        this.body.type = TYPE.A;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.BodyType#setTypeB
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setTypeB: function ()
	    {
	        this.body.type = TYPE.B;
	
	        return this;
	    }
	
	};
	
	module.exports = BodyType;


/***/ }),
/* 1457 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Impact.Components.Bounce
	 * @since 3.0.0
	 */
	var Bounce = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.Bounce#setBounce
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setBounce: function (value)
	    {
	        this.body.bounciness = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.Bounce#setMinBounceVelocity
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setMinBounceVelocity: function (value)
	    {
	        this.body.minBounceVelocity = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Physics.Impact.Components.Bounce#bounce
	     * @type {number}
	     * @since 3.0.0
	     */
	    bounce: {
	
	        get: function ()
	        {
	            return this.body.bounciness;
	        },
	
	        set: function (value)
	        {
	            this.body.bounciness = value;
	        }
	
	    }
	
	};
	
	module.exports = Bounce;


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var TYPE = __webpack_require__(165);
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Impact.Components.CheckAgainst
	 * @since 3.0.0
	 */
	var CheckAgainst = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.CheckAgainst#setAvsB
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setAvsB: function ()
	    {
	        this.setTypeA();
	
	        return this.setCheckAgainstB();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.CheckAgainst#setBvsA
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setBvsA: function ()
	    {
	        this.setTypeB();
	
	        return this.setCheckAgainstA();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.CheckAgainst#setCheckAgainstNone
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setCheckAgainstNone: function ()
	    {
	        this.body.checkAgainst = TYPE.NONE;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.CheckAgainst#setCheckAgainstA
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setCheckAgainstA: function ()
	    {
	        this.body.checkAgainst = TYPE.A;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.CheckAgainst#setCheckAgainstB
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setCheckAgainstB: function ()
	    {
	        this.body.checkAgainst = TYPE.B;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Physics.Impact.Components.CheckAgainst#checkAgainst
	     * @type {number}
	     * @since 3.0.0
	     */
	    checkAgainst: {
	
	        get: function ()
	        {
	            return this.body.checkAgainst;
	        },
	
	        set: function (value)
	        {
	            this.body.checkAgainst = value;
	        }
	
	    }
	
	};
	
	module.exports = CheckAgainst;


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var COLLIDES = __webpack_require__(164);
	
	/**
	 * @callback CollideCallback
	 *
	 * @param {Phaser.Physics.Impact.Body} body - [description]
	 * @param {Phaser.Physics.Impact.Body} other - [description]
	 * @param {string} axis - [description]
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Impact.Components.Collides
	 * @since 3.0.0
	 */
	var Collides = {
	
	    _collideCallback: null,
	    _callbackScope: null,
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.Collides#setCollideCallback
	     * @since 3.0.0
	     *
	     * @param {CollideCallback} callback - [description]
	     * @param {*} scope - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setCollideCallback: function (callback, scope)
	    {
	        this._collideCallback = callback;
	
	        if (scope)
	        {
	            this._callbackScope = scope;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.Collides#setCollidesNever
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setCollidesNever: function ()
	    {
	        this.body.collides = COLLIDES.NEVER;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.Collides#setLiteCollision
	     * @since 3.6.0
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setLiteCollision: function ()
	    {
	        this.body.collides = COLLIDES.LITE;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.Collides#setPassiveCollision
	     * @since 3.6.0
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setPassiveCollision: function ()
	    {
	        this.body.collides = COLLIDES.PASSIVE;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.Collides#setActiveCollision
	     * @since 3.6.0
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setActiveCollision: function ()
	    {
	        this.body.collides = COLLIDES.ACTIVE;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.Collides#setFixedCollision
	     * @since 3.6.0
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setFixedCollision: function ()
	    {
	        this.body.collides = COLLIDES.FIXED;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Physics.Impact.Components.Collides#collides
	     * @type {number}
	     * @since 3.0.0
	     */
	    collides: {
	
	        get: function ()
	        {
	            return this.body.collides;
	        },
	
	        set: function (value)
	        {
	            this.body.collides = value;
	        }
	
	    }
	
	};
	
	module.exports = Collides;


/***/ }),
/* 1460 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Impact.Components.Debug
	 * @since 3.0.0
	 */
	var Debug = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.Debug#setDebug
	     * @since 3.0.0
	     *
	     * @param {boolean} showBody - [description]
	     * @param {boolean} showVelocity - [description]
	     * @param {number} bodyColor - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setDebug: function (showBody, showVelocity, bodyColor)
	    {
	        this.debugShowBody = showBody;
	        this.debugShowVelocity = showVelocity;
	        this.debugBodyColor = bodyColor;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.Debug#setDebugBodyColor
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setDebugBodyColor: function (value)
	    {
	        this.body.debugBodyColor = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Physics.Impact.Components.Debug#debugShowBody
	     * @type {boolean}
	     * @since 3.0.0
	     */
	    debugShowBody: {
	
	        get: function ()
	        {
	            return this.body.debugShowBody;
	        },
	
	        set: function (value)
	        {
	            this.body.debugShowBody = value;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Physics.Impact.Components.Debug#debugShowVelocity
	     * @type {boolean}
	     * @since 3.0.0
	     */
	    debugShowVelocity: {
	
	        get: function ()
	        {
	            return this.body.debugShowVelocity;
	        },
	
	        set: function (value)
	        {
	            this.body.debugShowVelocity = value;
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Physics.Impact.Components.Debug#debugBodyColor
	     * @type {number}
	     * @since 3.0.0
	     */
	    debugBodyColor: {
	
	        get: function ()
	        {
	            return this.body.debugBodyColor;
	        },
	
	        set: function (value)
	        {
	            this.body.debugBodyColor = value;
	        }
	
	    }
	
	};
	
	module.exports = Debug;


/***/ }),
/* 1461 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Impact.Components.Friction
	 * @since 3.0.0
	 */
	var Friction = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.Friction#setFrictionX
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setFrictionX: function (x)
	    {
	        this.friction.x = x;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.Friction#setFrictionY
	     * @since 3.0.0
	     *
	     * @param {number} y - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setFrictionY: function (y)
	    {
	        this.friction.y = y;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.Friction#setFriction
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setFriction: function (x, y)
	    {
	        this.friction.x = x;
	        this.friction.y = y;
	
	        return this;
	    }
	
	};
	
	module.exports = Friction;


/***/ }),
/* 1462 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Impact.Components.Gravity
	 * @since 3.0.0
	 */
	var Gravity = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.Gravity#setGravity
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setGravity: function (value)
	    {
	        this.body.gravityFactor = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Physics.Impact.Components.Gravity#gravity
	     * @type {number}
	     * @since 3.0.0
	     */
	    gravity: {
	
	        get: function ()
	        {
	            return this.body.gravityFactor;
	        },
	
	        set: function (value)
	        {
	            this.body.gravityFactor = value;
	        }
	
	    }
	
	};
	
	module.exports = Gravity;


/***/ }),
/* 1463 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Impact.Components.Offset
	 * @since 3.0.0
	 */
	var Offset = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.Offset#setOffset
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} y - [description]
	     * @param {number} [width] - [description]
	     * @param {number} [height] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setOffset: function (x, y, width, height)
	    {
	        this.body.offset.x = x;
	        this.body.offset.y = y;
	
	        if (width)
	        {
	            this.setBodySize(width, height);
	        }
	
	        return this;
	    }
	
	};
	
	module.exports = Offset;


/***/ }),
/* 1464 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Impact.Components.SetGameObject
	 * @since 3.0.0
	 */
	var SetGameObject = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.SetGameObject#setGameObject
	     * @since 3.0.0
	     *
	     * @param {Phaser.GameObjects.GameObject} gameObject - [description]
	     * @param {boolean} [sync=true] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setGameObject: function (gameObject, sync)
	    {
	        if (sync === undefined) { sync = true; }
	
	        if (gameObject)
	        {
	            this.body.gameObject = gameObject;
	
	            if (sync)
	            {
	                this.syncGameObject();
	            }
	        }
	        else
	        {
	            this.body.gameObject = null;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.SetGameObject#syncGameObject
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    syncGameObject: function ()
	    {
	        var gameObject = this.body.gameObject;
	
	        if (gameObject)
	        {
	            this.setBodySize(gameObject.width * gameObject.scaleX, gameObject.height * gameObject.scaleY);
	        }
	
	        return this;
	    }
	
	};
	
	module.exports = SetGameObject;


/***/ }),
/* 1465 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Impact.Components.Velocity
	 * @since 3.0.0
	 */
	var Velocity = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.Velocity#setVelocityX
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setVelocityX: function (x)
	    {
	        this.vel.x = x;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.Velocity#setVelocityY
	     * @since 3.0.0
	     *
	     * @param {number} y - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setVelocityY: function (y)
	    {
	        this.vel.y = y;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.Velocity#setVelocity
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} [y=x] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setVelocity: function (x, y)
	    {
	        if (y === undefined) { y = x; }
	
	        this.vel.x = x;
	        this.vel.y = y;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Impact.Components.Velocity#setMaxVelocity
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} [y=x] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setMaxVelocity: function (x, y)
	    {
	        if (y === undefined) { y = x; }
	
	        this.maxVel.x = x;
	        this.maxVel.y = y;
	
	        return this;
	    }
	
	};
	
	module.exports = Velocity;


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * An Impact.js compatible physics world, body and solver, for those who are used
	 * to the Impact way of defining and controlling physics bodies. Also works with
	 * the new Loader support for Weltmeister map data.
	 *
	 * World updated to run off the Phaser main loop.
	 * Body extended to support additional setter functions.
	 *
	 * To create the map data you'll need Weltmeister, which comes with Impact
	 * and can be purchased from http://impactjs.com
	 *
	 * My thanks to Dominic Szablewski for his permission to support Impact in Phaser.
	 *
	 * @namespace Phaser.Physics.Impact
	 */
	module.exports = {
	
	    Body: __webpack_require__(592),
	    COLLIDES: __webpack_require__(164),
	    CollisionMap: __webpack_require__(593),
	    Factory: __webpack_require__(594),
	    Image: __webpack_require__(596),
	    ImpactBody: __webpack_require__(595),
	    ImpactPhysics: __webpack_require__(1449),
	    Sprite: __webpack_require__(597),
	    TYPE: __webpack_require__(165),
	    World: __webpack_require__(598)
	
	};


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Physics
	 */
	
	module.exports = {
	
	    Arcade: __webpack_require__(1440),
	    Impact: __webpack_require__(1466),
	    Matter: __webpack_require__(1483)
	
	};


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Components = __webpack_require__(205);
	var GetFastValue = __webpack_require__(3);
	var Vector2 = __webpack_require__(9);
	
	/**
	 * [description]
	 *
	 * @function hasGetterOrSetter
	 * @private
	 *
	 * @param {object} def - The object to check.
	 *
	 * @return {boolean} True if it has a getter or setter, otherwise false.
	 */
	function hasGetterOrSetter (def)
	{
	    return (!!def.get && typeof def.get === 'function') || (!!def.set && typeof def.set === 'function');
	}
	
	/**
	 * [description]
	 *
	 * @function Phaser.Physics.Matter.MatterGameObject
	 * @since 3.3.0
	 *
	 * @param {Phaser.Physics.Matter.World} world - [description]
	 * @param {Phaser.GameObjects.GameObject} gameObject - [description]
	 * @param {object} options - [description]
	 *
	 * @return {Phaser.GameObjects.GameObject} [description]
	 */
	var MatterGameObject = function (world, gameObject, options)
	{
	    if (options === undefined) { options = {}; }
	
	    var x = gameObject.x;
	    var y = gameObject.y;
	
	    //  Temp body pos to avoid body null checks
	    gameObject.body = {
	        position: {
	            x: x,
	            y: y
	        }
	    };
	
	    var mixins = [
	        Components.Bounce,
	        Components.Collision,
	        Components.Force,
	        Components.Friction,
	        Components.Gravity,
	        Components.Mass,
	        Components.Sensor,
	        Components.SetBody,
	        Components.Sleep,
	        Components.Static,
	        Components.Transform,
	        Components.Velocity
	    ];
	
	    //  First let's inject all of the components into the Game Object
	    mixins.forEach(function (mixin)
	    {
	        for (var key in mixin)
	        {
	            if (hasGetterOrSetter(mixin[key]))
	            {
	                Object.defineProperty(gameObject, key, {
	                    get: mixin[key].get,
	                    set: mixin[key].set
	                });
	            }
	            else
	            {
	                Object.defineProperty(gameObject, key, {value: mixin[key]});
	            }
	        }
	
	    });
	
	    gameObject.world = world;
	
	    gameObject._tempVec2 = new Vector2(x, y);
	
	    var shape = GetFastValue(options, 'shape', null);
	
	    if (!shape)
	    {
	        shape = 'rectangle';
	    }
	
	    gameObject.setBody(shape, options);
	
	    return gameObject;
	};
	
	module.exports = MatterGameObject;


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var Factory = __webpack_require__(599);
	var GetFastValue = __webpack_require__(3);
	var GetValue = __webpack_require__(10);
	var MatterAttractors = __webpack_require__(1487);
	var MatterLib = __webpack_require__(607);
	var MatterWrap = __webpack_require__(1488);
	var Merge = __webpack_require__(148);
	var Plugin = __webpack_require__(320);
	var PluginCache = __webpack_require__(29);
	var World = __webpack_require__(602);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class MatterPhysics
	 * @memberOf Phaser.Physics.Matter
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - [description]
	 */
	var MatterPhysics = new Class({
	
	    initialize:
	
	    function MatterPhysics (scene)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.MatterPhysics#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.MatterPhysics#systems
	         * @type {Phaser.Scenes.Systems}
	         * @since 3.0.0
	         */
	        this.systems = scene.sys;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.MatterPhysics#config
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.config = this.getConfig();
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.MatterPhysics#world
	         * @type {Phaser.Physics.Matter.World}
	         * @since 3.0.0
	         */
	        this.world;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.MatterPhysics#add
	         * @type {Phaser.Physics.Matter.Factory}
	         * @since 3.0.0
	         */
	        this.add;
	
	        //  Matter plugins
	
	        if (GetValue(this.config, 'plugins.attractors', false))
	        {
	            Plugin.register(MatterAttractors);
	            Plugin.use(MatterLib, MatterAttractors);
	        }
	
	        if (GetValue(this.config, 'plugins.wrap', false))
	        {
	            Plugin.register(MatterWrap);
	            Plugin.use(MatterLib, MatterWrap);
	        }
	
	        scene.sys.events.once('boot', this.boot, this);
	        scene.sys.events.on('start', this.start, this);
	    },
	
	    /**
	     * This method is called automatically, only once, when the Scene is first created.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.Physics.Matter.MatterPhysics#boot
	     * @private
	     * @since 3.5.1
	     */
	    boot: function ()
	    {
	        this.world = new World(this.scene, this.config);
	        this.add = new Factory(this.world);
	
	        this.systems.events.once('destroy', this.destroy, this);
	    },
	
	    /**
	     * This method is called automatically by the Scene when it is starting up.
	     * It is responsible for creating local systems, properties and listening for Scene events.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.Physics.Matter.MatterPhysics#start
	     * @private
	     * @since 3.5.0
	     */
	    start: function ()
	    {
	        if (!this.world)
	        {
	            this.world = new World(this.scene, this.config);
	            this.add = new Factory(this.world);
	        }
	
	        var eventEmitter = this.systems.events;
	
	        eventEmitter.on('update', this.world.update, this.world);
	        eventEmitter.on('postupdate', this.world.postUpdate, this.world);
	        eventEmitter.once('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.MatterPhysics#getConfig
	     * @since 3.0.0
	     *
	     * @return {object} [description]
	     */
	    getConfig: function ()
	    {
	        var gameConfig = this.systems.game.config.physics;
	        var sceneConfig = this.systems.settings.physics;
	
	        var config = Merge(
	            GetFastValue(sceneConfig, 'matter', {}),
	            GetFastValue(gameConfig, 'matter', {})
	        );
	
	        return config;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.MatterPhysics#enableAttractorPlugin
	     * @since 3.0.0
	     * 
	     * @return {Phaser.Physics.Matter.MatterPhysics} This Matter Physics instance.
	     */
	    enableAttractorPlugin: function ()
	    {
	        Plugin.register(MatterAttractors);
	        Plugin.use(MatterLib, MatterAttractors);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.MatterPhysics#enableWrapPlugin
	     * @since 3.0.0
	     * 
	     * @return {Phaser.Physics.Matter.MatterPhysics} This Matter Physics instance.
	     */
	    enableWrapPlugin: function ()
	    {
	        Plugin.register(MatterWrap);
	        Plugin.use(MatterLib, MatterWrap);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.MatterPhysics#pause
	     * @since 3.0.0
	     *
	     * @return {Phaser.Physics.Matter.World} The Matter World object.
	     */
	    pause: function ()
	    {
	        return this.world.pause();
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.MatterPhysics#resume
	     * @since 3.0.0
	     *
	     * @return {Phaser.Physics.Matter.World} The Matter World object.
	     */
	    resume: function ()
	    {
	        return this.world.resume();
	    },
	
	    /**
	     * Sets the Matter Engine to run at fixed timestep of 60Hz and enables `autoUpdate`.
	     * If you have set a custom `getDelta` function then this will override it.
	     *
	     * @method Phaser.Physics.Matter.MatterPhysics#set60Hz
	     * @since 3.4.0
	     *
	     * @return {Phaser.Physics.Matter.MatterPhysics} This Matter Physics instance.
	     */
	    set60Hz: function ()
	    {
	        this.world.getDelta = this.world.update60Hz;
	        this.world.autoUpdate = true;
	
	        return this;
	    },
	
	    /**
	     * Sets the Matter Engine to run at fixed timestep of 30Hz and enables `autoUpdate`.
	     * If you have set a custom `getDelta` function then this will override it.
	     *
	     * @method Phaser.Physics.Matter.MatterPhysics#set30Hz
	     * @since 3.4.0
	     *
	     * @return {Phaser.Physics.Matter.MatterPhysics} This Matter Physics instance.
	     */
	    set30Hz: function ()
	    {
	        this.world.getDelta = this.world.update30Hz;
	        this.world.autoUpdate = true;
	
	        return this;
	    },
	
	    /**
	     * Manually advances the physics simulation by one iteration.
	     * 
	     * You can optionally pass in the `delta` and `correction` values to be used by Engine.update.
	     * If undefined they use the Matter defaults of 60Hz and no correction.
	     * 
	     * Calling `step` directly bypasses any checks of `enabled` or `autoUpdate`.
	     * 
	     * It also ignores any custom `getDelta` functions, as you should be passing the delta
	     * value in to this call.
	     *
	     * You can adjust the number of iterations that Engine.update performs internally.
	     * Use the Scene Matter Physics config object to set the following properties:
	     *
	     * positionIterations (defaults to 6)
	     * velocityIterations (defaults to 4)
	     * constraintIterations (defaults to 2)
	     *
	     * Adjusting these values can help performance in certain situations, depending on the physics requirements
	     * of your game.
	     *
	     * @method Phaser.Physics.Matter.MatterPhysics#step
	     * @since 3.4.0
	     *
	     * @param {number} [delta=16.666] - [description]
	     * @param {number} [correction=1] - [description]
	     */
	    step: function (delta, correction)
	    {
	        this.world.step(delta, correction);
	    },
	
	    /**
	     * The Scene that owns this plugin is shutting down.
	     * We need to kill and reset all internal properties as well as stop listening to Scene events.
	     *
	     * @method Phaser.Physics.Matter.MatterPhysics#shutdown
	     * @private
	     * @since 3.0.0
	     */
	    shutdown: function ()
	    {
	        var eventEmitter = this.systems.events;
	
	        eventEmitter.off('update', this.world.update, this.world);
	        eventEmitter.off('postupdate', this.world.postUpdate, this.world);
	        eventEmitter.off('shutdown', this.shutdown, this);
	
	        this.add.destroy();
	        this.world.destroy();
	
	        this.add = null;
	        this.world = null;
	    },
	
	    /**
	     * The Scene that owns this plugin is being destroyed.
	     * We need to shutdown and then kill off all external references.
	     *
	     * @method Phaser.Physics.Matter.MatterPhysics#destroy
	     * @private
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.shutdown();
	
	        this.scene.sys.events.off('start', this.start, this);
	
	        this.scene = null;
	        this.systems = null;
	    }
	
	});
	
	PluginCache.register('MatterPhysics', MatterPhysics, 'matterPhysics');
	
	module.exports = MatterPhysics;


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Bounds = __webpack_require__(85);
	var Class = __webpack_require__(1);
	var Composite = __webpack_require__(118);
	var Constraint = __webpack_require__(143);
	var Detector = __webpack_require__(318);
	var GetFastValue = __webpack_require__(3);
	var Merge = __webpack_require__(148);
	var Sleeping = __webpack_require__(166);
	var Vector2 = __webpack_require__(9);
	var Vertices = __webpack_require__(86);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class PointerConstraint
	 * @memberOf Phaser.Physics.Matter
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - [description]
	 * @param {Phaser.Physics.Matter.World} world - [description]
	 * @param {object} options - [description]
	 */
	var PointerConstraint = new Class({
	
	    initialize:
	
	    function PointerConstraint (scene, world, options)
	    {
	        if (options === undefined) { options = {}; }
	
	        //  Defaults
	        var defaults = {
	            label: 'Pointer Constraint',
	            pointA: { x: 0, y: 0 },
	            pointB: { x: 0, y: 0 },
	            damping: 0,
	            length: 0.01,
	            stiffness: 0.1,
	            angularStiffness: 1,
	            collisionFilter: {
	                category: 0x0001,
	                mask: 0xFFFFFFFF,
	                group: 0
	            }
	        };
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.PointerConstraint#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.PointerConstraint#world
	         * @type {Phaser.Physics.Matter.World}
	         * @since 3.0.0
	         */
	        this.world = world;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.PointerConstraint#camera
	         * @type {Phaser.Cameras.Scene2D.Camera}
	         * @since 3.0.0
	         */
	        var camera = GetFastValue(options, 'camera', null);
	
	        if (!camera)
	        {
	            this.camera = scene.sys.cameras.main;
	        }
	        else
	        {
	            this.camera = camera;
	
	            delete options.camera;
	        }
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.PointerConstraint#pointer
	         * @type {Phaser.Input.Pointer}
	         * @default null
	         * @since 3.0.0
	         */
	        this.pointer = null;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.PointerConstraint#active
	         * @type {boolean}
	         * @default true
	         * @since 3.0.0
	         */
	        this.active = true;
	
	        /**
	         * The transformed position.
	         *
	         * @name Phaser.Physics.Matter.PointerConstraint#position
	         * @type {Phaser.Math.Vector2}
	         * @since 3.0.0
	         */
	        this.position = new Vector2();
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Physics.Matter.PointerConstraint#constraint
	         * @type {object}
	         * @since 3.0.0
	         */
	        this.constraint = Constraint.create(Merge(options, defaults));
	
	        this.world.on('beforeupdate', this.update, this);
	
	        scene.sys.input.on('pointerdown', this.onDown, this);
	
	        scene.sys.input.on('pointerup', this.onUp, this);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.PointerConstraint#onDown
	     * @since 3.0.0
	     *
	     * @param {Phaser.Input.Pointer} pointer - [description]
	     */
	    onDown: function (pointer)
	    {
	        this.pointer = pointer;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.PointerConstraint#onUp
	     * @since 3.0.0
	     */
	    onUp: function ()
	    {
	        this.pointer = null;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.PointerConstraint#getBodyPart
	     * @since 3.0.0
	     *
	     * @param {MatterJS.Body} body - [description]
	     * @param {Phaser.Math.Vector2} position - [description]
	     *
	     * @return {boolean} [description]
	     */
	    getBodyPart: function (body, position)
	    {
	        var constraint = this.constraint;
	
	        var start = (body.parts.length > 1) ? 1 : 0;
	
	        for (var i = start; i < body.parts.length; i++)
	        {
	            var part = body.parts[i];
	
	            if (Vertices.contains(part.vertices, position))
	            {
	                constraint.bodyB = body;
	
	                constraint.pointA.x = position.x;
	                constraint.pointA.y = position.y;
	
	                constraint.pointB.x = position.x - body.position.x;
	                constraint.pointB.y = position.y - body.position.y;
	
	                constraint.angleB = body.angle;
	
	                Sleeping.set(body, false);
	
	                return true;
	            }
	        }
	
	        return false;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.PointerConstraint#update
	     * @since 3.0.0
	     */
	    update: function ()
	    {
	        if (!this.active)
	        {
	            return;
	        }
	
	        var pointer = this.pointer;
	        var constraint = this.constraint;
	
	        if (!pointer)
	        {
	            //  Pointer is up / released
	            if (constraint.bodyB)
	            {
	                constraint.bodyB = null;
	            }
	        }
	        else
	        {
	            var pos = this.position;
	
	            this.camera.getWorldPoint(pointer.x, pointer.y, pos);
	
	            if (constraint.bodyB)
	            {
	                //  Pointer is down and we have bodyB, so wake it up
	                Sleeping.set(constraint.bodyB, false);
	
	                constraint.pointA.x = pos.x;
	                constraint.pointA.y = pos.y;
	            }
	            else
	            {
	                var bodies = Composite.allBodies(this.world.localWorld);
	
	                //  Pointer is down and no bodyB, so check if we've hit anything
	                for (var i = 0; i < bodies.length; i++)
	                {
	                    var body = bodies[i];
	
	                    if (!body.ignorePointer && Bounds.contains(body.bounds, pos) &&
	                        Detector.canCollide(body.collisionFilter, constraint.collisionFilter))
	                    {
	                        if (this.getBodyPart(body, pos))
	                        {
	                            break;
	                        }
	                    }
	                }
	            }
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.PointerConstraint#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.world.removeConstraint(this.constraint);
	
	        this.constraint = null;
	
	        this.world.off('beforeupdate', this.update);
	
	        this.scene.sys.input.off('pointerdown', this.onDown, this);
	
	        this.scene.sys.input.off('pointerup', this.onUp, this);
	    }
	
	});
	
	module.exports = PointerConstraint;


/***/ }),
/* 1471 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Matter.Components.Bounce
	 * @since 3.0.0
	 */
	var Bounce = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Bounce#setBounce
	     * @since 3.0.0
	     *
	     * @param {float} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setBounce: function (value)
	    {
	        this.body.restitution = value;
	
	        return this;
	    }
	
	};
	
	module.exports = Bounce;


/***/ }),
/* 1472 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Matter.Components.Collision
	 * @since 3.0.0
	 */
	var Collision = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Collision#setCollisionCategory
	     * @since 3.0.0
	     *
	     * @param {number} value - Unique category bitfield.
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setCollisionCategory: function (value)
	    {
	        this.body.collisionFilter.category = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Collision#setCollisionGroup
	     * @since 3.0.0
	     *
	     * @param {number} value - Unique group index.
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setCollisionGroup: function (value)
	    {
	        this.body.collisionFilter.group = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Collision#setCollidesWith
	     * @since 3.0.0
	     *
	     * @param {(number|number[])} categories - A unique category bitfield, or an array of them.
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setCollidesWith: function (categories)
	    {
	        var flags = 0;
	
	        if (!Array.isArray(categories))
	        {
	            flags = categories;
	        }
	        else
	        {
	            for (var i = 0; i < categories.length; i++)
	            {
	                flags |= categories[i];
	            }
	        }
	
	        this.body.collisionFilter.mask = flags;
	
	        return this;
	    }
	
	};
	
	module.exports = Collision;


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Body = __webpack_require__(51);
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Matter.Components.Force
	 * @since 3.0.0
	 */
	var Force = {
	
	    //  force = vec2 / point
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Force#applyForce
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector2} force - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    applyForce: function (force)
	    {
	        this._tempVec2.set(this.body.position.x, this.body.position.y);
	
	        Body.applyForce(this.body, this._tempVec2, force);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Force#applyForceFrom
	     * @since 3.0.0
	     *
	     * @param {Phaser.Math.Vector2} position - [description]
	     * @param {Phaser.Math.Vector2} force - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    applyForceFrom: function (position, force)
	    {
	        Body.applyForce(this.body, position, force);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Force#thrust
	     * @since 3.0.0
	     *
	     * @param {number} speed - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    thrust: function (speed)
	    {
	        var angle = this.body.angle;
	
	        this._tempVec2.set(speed * Math.cos(angle), speed * Math.sin(angle));
	
	        Body.applyForce(this.body, { x: this.body.position.x, y: this.body.position.y }, this._tempVec2);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Force#thrustLeft
	     * @since 3.0.0
	     *
	     * @param {number} speed - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    thrustLeft: function (speed)
	    {
	        var angle = this.body.angle - Math.PI / 2;
	
	        this._tempVec2.set(speed * Math.cos(angle), speed * Math.sin(angle));
	
	        Body.applyForce(this.body, { x: this.body.position.x, y: this.body.position.y }, this._tempVec2);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Force#thrustRight
	     * @since 3.0.0
	     *
	     * @param {number} speed - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    thrustRight: function (speed)
	    {
	        var angle = this.body.angle + Math.PI / 2;
	
	        this._tempVec2.set(speed * Math.cos(angle), speed * Math.sin(angle));
	
	        Body.applyForce(this.body, { x: this.body.position.x, y: this.body.position.y }, this._tempVec2);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Force#thrustBack
	     * @since 3.0.0
	     *
	     * @param {number} speed - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    thrustBack: function (speed)
	    {
	        var angle = this.body.angle - Math.PI;
	
	        this._tempVec2.set(speed * Math.cos(angle), speed * Math.sin(angle));
	
	        Body.applyForce(this.body, { x: this.body.position.x, y: this.body.position.y }, this._tempVec2);
	
	        return this;
	    }
	
	};
	
	module.exports = Force;


/***/ }),
/* 1474 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Matter.Components.Friction
	 * @since 3.0.0
	 */
	var Friction = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Friction#setFriction
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     * @param {number} [air] - [description]
	     * @param {number} [fstatic] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setFriction: function (value, air, fstatic)
	    {
	        this.body.friction = value;
	
	        if (air !== undefined)
	        {
	            this.body.frictionAir = air;
	        }
	
	        if (fstatic !== undefined)
	        {
	            this.body.frictionStatic = fstatic;
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Friction#setFrictionAir
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setFrictionAir: function (value)
	    {
	        this.body.frictionAir = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Friction#setFrictionStatic
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setFrictionStatic: function (value)
	    {
	        this.body.frictionStatic = value;
	
	        return this;
	    }
	
	};
	
	module.exports = Friction;


/***/ }),
/* 1475 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Matter.Components.Gravity
	 * @since 3.0.0
	 */
	var Gravity = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Gravity#setIgnoreGravity
	     * @since 3.0.0
	     *
	     * @param {boolean} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setIgnoreGravity: function (value)
	    {
	        this.body.ignoreGravity = value;
	
	        return this;
	    }
	
	};
	
	module.exports = Gravity;


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Body = __webpack_require__(51);
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Matter.Components.Mass
	 * @since 3.0.0
	 */
	var Mass = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Mass#setMass
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setMass: function (value)
	    {
	        Body.setMass(this.body, value);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Mass#setDensity
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setDensity: function (value)
	    {
	        Body.setDensity(this.body, value);
	
	        return this;
	    }
	
	};
	
	module.exports = Mass;


/***/ }),
/* 1477 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Matter.Components.Sensor
	 * @since 3.0.0
	 */
	var Sensor = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Sensor#setSensor
	     * @since 3.0.0
	     *
	     * @param {boolean} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setSensor: function (value)
	    {
	        this.body.isSensor = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Sensor#isSensor
	     * @since 3.0.0
	     *
	     * @return {boolean} [description]
	     */
	    isSensor: function ()
	    {
	        return this.body.isSensor;
	    }
	
	};
	
	module.exports = Sensor;


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Bodies = __webpack_require__(119);
	var Body = __webpack_require__(51);
	var GetFastValue = __webpack_require__(3);
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Matter.Components.SetBody
	 * @since 3.0.0
	 */
	var SetBody = {
	
	    //  Calling any of these methods resets previous properties you may have set on the body, including plugins, mass, etc
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.SetBody#setRectangle
	     * @since 3.0.0
	     *
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     * @param {object} options - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setRectangle: function (width, height, options)
	    {
	        return this.setBody({ type: 'rectangle', width: width, height: height }, options);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.SetBody#setCircle
	     * @since 3.0.0
	     *
	     * @param {number} radius - [description]
	     * @param {object} options - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setCircle: function (radius, options)
	    {
	        return this.setBody({ type: 'circle', radius: radius }, options);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.SetBody#setPolygon
	     * @since 3.0.0
	     *
	     * @param {number} radius - [description]
	     * @param {number} sides - [description]
	     * @param {object} options - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setPolygon: function (radius, sides, options)
	    {
	        return this.setBody({ type: 'polygon', sides: sides, radius: radius }, options);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.SetBody#setTrapezoid
	     * @since 3.0.0
	     *
	     * @param {number} width - [description]
	     * @param {number} height - [description]
	     * @param {number} slope - [description]
	     * @param {object} options - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setTrapezoid: function (width, height, slope, options)
	    {
	        return this.setBody({ type: 'trapezoid', width: width, height: height, slope: slope }, options);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.SetBody#setExistingBody
	     * @since 3.0.0
	     *
	     * @param {MatterJS.Body} body - [description]
	     * @param {boolean} [addToWorld=true] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setExistingBody: function (body, addToWorld)
	    {
	        if (addToWorld === undefined)
	        {
	            addToWorld = true;
	        }
	
	        if (this.body)
	        {
	            this.world.remove(this.body);
	        }
	
	        this.body = body;
	        this.body.gameObject = this;
	
	        var _this = this;
	
	        body.destroy = function destroy ()
	        {
	            _this.world.remove(_this.body);
	            _this.body.gameObject = null;
	        };
	
	        if (addToWorld)
	        {
	            this.world.add(body);
	        }
	
	        if (this._originComponent)
	        {
	            this.setOrigin(body.render.sprite.xOffset, body.render.sprite.yOffset);
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.SetBody#setBody
	     * @since 3.0.0
	     *
	     * @param {object} config - [description]
	     * @param {object} options - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setBody: function (config, options)
	    {
	        if (!config)
	        {
	            return this;
	        }
	
	        var body;
	
	        //  Allow them to do: shape: 'circle' instead of shape: { type: 'circle' }
	        if (typeof config === 'string')
	        {
	            //  Using defaults
	            config = { type: config };
	        }
	
	        var shapeType = GetFastValue(config, 'type', 'rectangle');
	        var bodyX = GetFastValue(config, 'x', this._tempVec2.x);
	        var bodyY = GetFastValue(config, 'y', this._tempVec2.y);
	        var bodyWidth = GetFastValue(config, 'width', this.width);
	        var bodyHeight = GetFastValue(config, 'height', this.height);
	
	        switch (shapeType)
	        {
	            case 'rectangle':
	                body = Bodies.rectangle(bodyX, bodyY, bodyWidth, bodyHeight, options);
	                break;
	
	            case 'circle':
	                var radius = GetFastValue(config, 'radius', Math.max(bodyWidth, bodyHeight) / 2);
	                var maxSides = GetFastValue(config, 'maxSides', 25);
	                body = Bodies.circle(bodyX, bodyY, radius, options, maxSides);
	                break;
	
	            case 'trapezoid':
	                var slope = GetFastValue(config, 'slope', 0.5);
	                body = Bodies.trapezoid(bodyX, bodyY, bodyWidth, bodyHeight, slope, options);
	                break;
	
	            case 'polygon':
	                var sides = GetFastValue(config, 'sides', 5);
	                var pradius = GetFastValue(config, 'radius', Math.max(bodyWidth, bodyHeight) / 2);
	                body = Bodies.polygon(bodyX, bodyY, sides, pradius, options);
	                break;
	
	            case 'fromVertices':
	            case 'fromVerts':
	                var verts = GetFastValue(config, 'verts', []);
	
	                if (this.body)
	                {
	                    Body.setVertices(this.body, verts);
	                    body = this.body;
	                }
	                else
	                {
	                    var flagInternal = GetFastValue(config, 'flagInternal', false);
	                    var removeCollinear = GetFastValue(config, 'removeCollinear', 0.01);
	                    var minimumArea = GetFastValue(config, 'minimumArea', 10);
	                    body = Bodies.fromVertices(bodyX, bodyY, verts, options, flagInternal, removeCollinear, minimumArea);
	                }
	                break;
	        }
	
	        this.setExistingBody(body, config.addToWorld);
	
	        return this;
	    }
	
	};
	
	module.exports = SetBody;


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var MatterEvents = __webpack_require__(144);
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Matter.Components.Sleep
	 * @since 3.0.0
	 */
	var Sleep = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Sleep#setSleepThreshold
	     * @since 3.0.0
	     *
	     * @param {number} [value=60] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setSleepThreshold: function (value)
	    {
	        if (value === undefined) { value = 60; }
	
	        this.body.sleepThreshold = value;
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Sleep#setSleepEvents
	     * @since 3.0.0
	     *
	     * @param {boolean} start - [description]
	     * @param {boolean} end - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setSleepEvents: function (start, end)
	    {
	        this.setSleepStartEvent(start);
	        this.setSleepEndEvent(end);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Sleep#setSleepStartEvent
	     * @since 3.0.0
	     *
	     * @param {boolean} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setSleepStartEvent: function (value)
	    {
	        if (value)
	        {
	            var world = this.world;
	
	            MatterEvents.on(this.body, 'sleepStart', function (event)
	            {
	                world.emit('sleepstart', event, this);
	            });
	        }
	        else
	        {
	            MatterEvents.off(this.body, 'sleepStart');
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Sleep#setSleepEndEvent
	     * @since 3.0.0
	     *
	     * @param {boolean} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setSleepEndEvent: function (value)
	    {
	        if (value)
	        {
	            var world = this.world;
	
	            MatterEvents.on(this.body, 'sleepEnd', function (event)
	            {
	                world.emit('sleepend', event, this);
	            });
	        }
	        else
	        {
	            MatterEvents.off(this.body, 'sleepEnd');
	        }
	
	        return this;
	    }
	
	};
	
	module.exports = Sleep;


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Body = __webpack_require__(51);
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Matter.Components.Static
	 * @since 3.0.0
	 */
	var Static = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Static#setStatic
	     * @since 3.0.0
	     *
	     * @param {boolean} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setStatic: function (value)
	    {
	        Body.setStatic(this.body, value);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Static#isStatic
	     * @since 3.0.0
	     *
	     * @return {boolean} [description]
	     */
	    isStatic: function ()
	    {
	        return this.body.isStatic;
	    }
	
	};
	
	module.exports = Static;


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Body = __webpack_require__(51);
	var MATH_CONST = __webpack_require__(33);
	var WrapAngle = __webpack_require__(311);
	var WrapAngleDegrees = __webpack_require__(312);
	
	//  global bitmask flag for GameObject.renderMask (used by Scale)
	var _FLAG = 4; // 0100
	
	//  Transform Component
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Matter.Components.Transform
	 * @since 3.0.0
	 */
	var Transform = {
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Physics.Matter.Components.Transform#x
	     * @type {number}
	     * @since 3.0.0
	     */
	    x: {
	
	        get: function ()
	        {
	            return this.body.position.x;
	        },
	
	        set: function (value)
	        {
	            this._tempVec2.set(value, this.y);
	
	            Body.setPosition(this.body, this._tempVec2);
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Physics.Matter.Components.Transform#y
	     * @type {number}
	     * @since 3.0.0
	     */
	    y: {
	
	        get: function ()
	        {
	            return this.body.position.y;
	        },
	
	        set: function (value)
	        {
	            this._tempVec2.set(this.x, value);
	
	            Body.setPosition(this.body, this._tempVec2);
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Physics.Matter.Components.Transform#scaleX
	     * @type {number}
	     * @since 3.0.0
	     */
	    scaleX: {
	
	        get: function ()
	        {
	            return this._scaleX;
	        },
	
	        set: function (value)
	        {
	            this._scaleX = value;
	
	            if (this._scaleX === 0)
	            {
	                this.renderFlags &= ~_FLAG;
	            }
	            else
	            {
	                this.renderFlags |= _FLAG;
	            }
	
	            Body.scale(this.body, value, this._scaleY);
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Physics.Matter.Components.Transform#scaleY
	     * @type {number}
	     * @since 3.0.0
	     */
	    scaleY: {
	
	        get: function ()
	        {
	            return this._scaleY;
	        },
	
	        set: function (value)
	        {
	            this._scaleY = value;
	
	            if (this._scaleY === 0)
	            {
	                this.renderFlags &= ~_FLAG;
	            }
	            else
	            {
	                this.renderFlags |= _FLAG;
	            }
	
	            Body.scale(this.body, this._scaleX, value);
	        }
	
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Physics.Matter.Components.Transform#angle
	     * @type {number}
	     * @since 3.0.0
	     */
	    angle: {
	
	        get: function ()
	        {
	            return WrapAngleDegrees(this.body.angle * MATH_CONST.RAD_TO_DEG);
	        },
	
	        set: function (value)
	        {
	            //  value is in degrees
	            this.rotation = WrapAngleDegrees(value) * MATH_CONST.DEG_TO_RAD;
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @name Phaser.Physics.Matter.Components.Transform#rotation
	     * @type {number}
	     * @since 3.0.0
	     */
	    rotation: {
	
	        get: function ()
	        {
	            return this.body.angle;
	        },
	
	        set: function (value)
	        {
	            //  value is in radians
	            this._rotation = WrapAngle(value);
	
	            Body.setAngle(this.body, this._rotation);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Transform#setPosition
	     * @since 3.0.0
	     *
	     * @param {number} [x=0] - [description]
	     * @param {number} [y=x] - [description]
	     *
	     * @return{Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setPosition: function (x, y)
	    {
	        if (x === undefined) { x = 0; }
	        if (y === undefined) { y = x; }
	
	        this._tempVec2.set(x, y);
	
	        Body.setPosition(this.body, this._tempVec2);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Transform#setRotation
	     * @since 3.0.0
	     *
	     * @param {number} [radians=0] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setRotation: function (radians)
	    {
	        if (radians === undefined) { radians = 0; }
	
	        this._rotation = WrapAngle(radians);
	
	        Body.setAngle(this.body, radians);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Transform#setFixedRotation
	     * @since 3.0.0
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setFixedRotation: function ()
	    {
	        Body.setInertia(this.body, Infinity);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Transform#setAngle
	     * @since 3.0.0
	     *
	     * @param {number} [degrees=0] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setAngle: function (degrees)
	    {
	        if (degrees === undefined) { degrees = 0; }
	
	        this.angle = degrees;
	
	        Body.setAngle(this.body, this.rotation);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Transform#setScale
	     * @since 3.0.0
	     *
	     * @param {number} [x=1] - [description]
	     * @param {number} [y=x] - [description]
	     * @param {Phaser.Math.Vector2} [point] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setScale: function (x, y, point)
	    {
	        if (x === undefined) { x = 1; }
	        if (y === undefined) { y = x; }
	
	        this._scaleX = x;
	        this._scaleY = y;
	
	        Body.scale(this.body, x, y, point);
	
	        return this;
	    }
	
	};
	
	module.exports = Transform;


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Body = __webpack_require__(51);
	
	/**
	 * [description]
	 *
	 * @name Phaser.Physics.Matter.Components.Velocity
	 * @since 3.0.0
	 */
	var Velocity = {
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Velocity#setAngularVelocity
	     * @since 3.0.0
	     *
	     * @param {number} value - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setAngularVelocity: function (value)
	    {
	        Body.setAngularVelocity(this.body, value);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Velocity#setVelocityX
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setVelocityX: function (x)
	    {
	        this._tempVec2.set(x, this.body.velocity.y);
	
	        Body.setVelocity(this.body, this._tempVec2);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Velocity#setVelocityY
	     * @since 3.0.0
	     *
	     * @param {number} y - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setVelocityY: function (y)
	    {
	        this._tempVec2.set(this.body.velocity.x, y);
	
	        Body.setVelocity(this.body, this._tempVec2);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Physics.Matter.Components.Velocity#setVelocity
	     * @since 3.0.0
	     *
	     * @param {number} x - [description]
	     * @param {number} [y=x] - [description]
	     *
	     * @return {Phaser.GameObjects.GameObject} This Game Object.
	     */
	    setVelocity: function (x, y)
	    {
	        this._tempVec2.set(x, y);
	
	        Body.setVelocity(this.body, this._tempVec2);
	
	        return this;
	    }
	
	};
	
	module.exports = Velocity;


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Physics.Matter
	 */
	
	module.exports = {
	
	    Factory: __webpack_require__(599),
	    Image: __webpack_require__(600),
	    Matter: __webpack_require__(315),
	    MatterPhysics: __webpack_require__(1469),
	    PolyDecomp: __webpack_require__(609),
	    Sprite: __webpack_require__(601),
	    TileBody: __webpack_require__(316),
	    World: __webpack_require__(602)
	
	};
	
	/**
	 * @namespace MatterJS
	 */
	
	/**
	 * @classdesc
	 * The `Matter.Body` module contains methods for creating and manipulating body models.
	 * A `Matter.Body` is a rigid body that can be simulated by a `Matter.Engine`.
	 * Factories for commonly used body configurations (such as rectangles, circles and other polygons) can be found in the module `Matter.Bodies`.
	 *
	 * @class MatterJS.Body
	 */
	
	/**
	 * @classdesc
	 * The `Matter.Composite` module contains methods for creating and manipulating composite bodies.
	 * A composite body is a collection of `Matter.Body`, `Matter.Constraint` and other `Matter.Composite`, therefore composites form a tree structure.
	 * It is important to use the functions in this module to modify composites, rather than directly modifying their properties.
	 * Note that the `Matter.World` object is also a type of `Matter.Composite` and as such all composite methods here can also operate on a `Matter.World`.
	 *
	 * @class MatterJS.Composite
	 */
	
	/**
	 * @classdesc
	 * The `Matter.World` module contains methods for creating and manipulating the world composite.
	 * A `Matter.World` is a `Matter.Composite` body, which is a collection of `Matter.Body`, `Matter.Constraint` and other `Matter.Composite`.
	 * A `Matter.World` has a few additional properties including `gravity` and `bounds`.
	 * It is important to use the functions in the `Matter.Composite` module to modify the world composite, rather than directly modifying its properties.
	 * There are also a few methods here that alias those in `Matter.Composite` for easier readability.
	 *
	 * @class MatterJS.World
	 * @extends MatterJS.Composite
	 */
	
	/**
	 * @classdesc
	 * The `Matter.Constraint` module contains methods for creating and manipulating constraints.
	 * Constraints are used for specifying that a fixed distance must be maintained between two bodies (or a body and a fixed world-space position).
	 * The stiffness of constraints can be modified to create springs or elastic.
	 *
	 * @class MatterJS.Constraint
	 */
	
	/**
	 * @classdesc
	 * The `Matter.Engine` module contains methods for creating and manipulating engines.
	 * An engine is a controller that manages updating the simulation of the world.
	 *
	 * @class MatterJS.Engine
	 */


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* The `Matter.Query` module contains methods for performing collision queries.
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class Query
	*/
	
	var Query = {};
	
	module.exports = Query;
	
	var Vector = __webpack_require__(71);
	var SAT = __webpack_require__(319);
	var Bounds = __webpack_require__(85);
	var Bodies = __webpack_require__(119);
	var Vertices = __webpack_require__(86);
	
	(function() {
	
	    /**
	     * Casts a ray segment against a set of bodies and returns all collisions, ray width is optional. Intersection points are not provided.
	     * @method ray
	     * @param {body[]} bodies
	     * @param {vector} startPoint
	     * @param {vector} endPoint
	     * @param {number} [rayWidth]
	     * @return {object[]} Collisions
	     */
	    Query.ray = function(bodies, startPoint, endPoint, rayWidth) {
	        rayWidth = rayWidth || 1e-100;
	
	        var rayAngle = Vector.angle(startPoint, endPoint),
	            rayLength = Vector.magnitude(Vector.sub(startPoint, endPoint)),
	            rayX = (endPoint.x + startPoint.x) * 0.5,
	            rayY = (endPoint.y + startPoint.y) * 0.5,
	            ray = Bodies.rectangle(rayX, rayY, rayLength, rayWidth, { angle: rayAngle }),
	            collisions = [];
	
	        for (var i = 0; i < bodies.length; i++) {
	            var bodyA = bodies[i];
	            
	            if (Bounds.overlaps(bodyA.bounds, ray.bounds)) {
	                for (var j = bodyA.parts.length === 1 ? 0 : 1; j < bodyA.parts.length; j++) {
	                    var part = bodyA.parts[j];
	
	                    if (Bounds.overlaps(part.bounds, ray.bounds)) {
	                        var collision = SAT.collides(part, ray);
	                        if (collision.collided) {
	                            collision.body = collision.bodyA = collision.bodyB = bodyA;
	                            collisions.push(collision);
	                            break;
	                        }
	                    }
	                }
	            }
	        }
	
	        return collisions;
	    };
	
	    /**
	     * Returns all bodies whose bounds are inside (or outside if set) the given set of bounds, from the given set of bodies.
	     * @method region
	     * @param {body[]} bodies
	     * @param {bounds} bounds
	     * @param {bool} [outside=false]
	     * @return {body[]} The bodies matching the query
	     */
	    Query.region = function(bodies, bounds, outside) {
	        var result = [];
	
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i],
	                overlaps = Bounds.overlaps(body.bounds, bounds);
	            if ((overlaps && !outside) || (!overlaps && outside))
	                result.push(body);
	        }
	
	        return result;
	    };
	
	    /**
	     * Returns all bodies whose vertices contain the given point, from the given set of bodies.
	     * @method point
	     * @param {body[]} bodies
	     * @param {vector} point
	     * @return {body[]} The bodies matching the query
	     */
	    Query.point = function(bodies, point) {
	        var result = [];
	
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i];
	            
	            if (Bounds.contains(body.bounds, point)) {
	                for (var j = body.parts.length === 1 ? 0 : 1; j < body.parts.length; j++) {
	                    var part = body.parts[j];
	
	                    if (Bounds.contains(part.bounds, point)
	                        && Vertices.contains(part.vertices, point)) {
	                        result.push(body);
	                        break;
	                    }
	                }
	            }
	        }
	
	        return result;
	    };
	
	})();


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	// @if DEBUG
	/**
	* _Internal Class_, not generally used outside of the engine's internals.
	*
	*/
	
	var Metrics = {};
	
	module.exports = Metrics;
	
	var Composite = __webpack_require__(118);
	var Common = __webpack_require__(31);
	
	(function() {
	
	    /**
	     * Creates a new metrics.
	     * @method create
	     * @private
	     * @return {metrics} A new metrics
	     */
	    Metrics.create = function(options) {
	        var defaults = {
	            extended: false,
	            narrowDetections: 0,
	            narrowphaseTests: 0,
	            narrowReuse: 0,
	            narrowReuseCount: 0,
	            midphaseTests: 0,
	            broadphaseTests: 0,
	            narrowEff: 0.0001,
	            midEff: 0.0001,
	            broadEff: 0.0001,
	            collisions: 0,
	            buckets: 0,
	            bodies: 0,
	            pairs: 0
	        };
	
	        return Common.extend(defaults, false, options);
	    };
	
	    /**
	     * Resets metrics.
	     * @method reset
	     * @private
	     * @param {metrics} metrics
	     */
	    Metrics.reset = function(metrics) {
	        if (metrics.extended) {
	            metrics.narrowDetections = 0;
	            metrics.narrowphaseTests = 0;
	            metrics.narrowReuse = 0;
	            metrics.narrowReuseCount = 0;
	            metrics.midphaseTests = 0;
	            metrics.broadphaseTests = 0;
	            metrics.narrowEff = 0;
	            metrics.midEff = 0;
	            metrics.broadEff = 0;
	            metrics.collisions = 0;
	            metrics.buckets = 0;
	            metrics.pairs = 0;
	            metrics.bodies = 0;
	        }
	    };
	
	    /**
	     * Updates metrics.
	     * @method update
	     * @private
	     * @param {metrics} metrics
	     * @param {engine} engine
	     */
	    Metrics.update = function(metrics, engine) {
	        if (metrics.extended) {
	            var world = engine.world,
	                bodies = Composite.allBodies(world);
	
	            metrics.collisions = metrics.narrowDetections;
	            metrics.pairs = engine.pairs.list.length;
	            metrics.bodies = bodies.length;
	            metrics.midEff = (metrics.narrowDetections / (metrics.midphaseTests || 1)).toFixed(2);
	            metrics.narrowEff = (metrics.narrowDetections / (metrics.narrowphaseTests || 1)).toFixed(2);
	            metrics.broadEff = (1 - (metrics.broadphaseTests / (bodies.length || 1))).toFixed(2);
	            metrics.narrowReuse = (metrics.narrowReuseCount / (metrics.narrowphaseTests || 1)).toFixed(2);
	            //var broadphase = engine.broadphase[engine.broadphase.current];
	            //if (broadphase.instance)
	            //    metrics.buckets = Common.keys(broadphase.instance.buckets).length;
	        }
	    };
	
	})();
	// @endif


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* The `Matter.Svg` module contains methods for converting SVG images into an array of vector points.
	*
	* To use this module you also need the SVGPathSeg polyfill: https://github.com/progers/pathseg
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class Svg
	*/
	
	var Svg = {};
	
	module.exports = Svg;
	
	var Bounds = __webpack_require__(85);
	
	(function() {
	
	    /**
	     * Converts an SVG path into an array of vector points.
	     * If the input path forms a concave shape, you must decompose the result into convex parts before use.
	     * See `Bodies.fromVertices` which provides support for this.
	     * Note that this function is not guaranteed to support complex paths (such as those with holes).
	     * @method pathToVertices
	     * @param {SVGPathElement} path
	     * @param {Number} [sampleLength=15]
	     * @return {Vector[]} points
	     */
	    Svg.pathToVertices = function(path, sampleLength) {
	        // https://github.com/wout/svg.topoly.js/blob/master/svg.topoly.js
	        var i, il, total, point, segment, segments, 
	            segmentsQueue, lastSegment, 
	            lastPoint, segmentIndex, points = [],
	            lx, ly, length = 0, x = 0, y = 0;
	
	        sampleLength = sampleLength || 15;
	
	        var addPoint = function(px, py, pathSegType) {
	            // all odd-numbered path types are relative except PATHSEG_CLOSEPATH (1)
	            var isRelative = pathSegType % 2 === 1 && pathSegType > 1;
	
	            // when the last point doesn't equal the current point add the current point
	            if (!lastPoint || px != lastPoint.x || py != lastPoint.y) {
	                if (lastPoint && isRelative) {
	                    lx = lastPoint.x;
	                    ly = lastPoint.y;
	                } else {
	                    lx = 0;
	                    ly = 0;
	                }
	
	                var point = {
	                    x: lx + px,
	                    y: ly + py
	                };
	
	                // set last point
	                if (isRelative || !lastPoint) {
	                    lastPoint = point;
	                }
	
	                points.push(point);
	
	                x = lx + px;
	                y = ly + py;
	            }
	        };
	
	        var addSegmentPoint = function(segment) {
	            var segType = segment.pathSegTypeAsLetter.toUpperCase();
	
	            // skip path ends
	            if (segType === 'Z') 
	                return;
	
	            // map segment to x and y
	            switch (segType) {
	
	            case 'M':
	            case 'L':
	            case 'T':
	            case 'C':
	            case 'S':
	            case 'Q':
	                x = segment.x;
	                y = segment.y;
	                break;
	            case 'H':
	                x = segment.x;
	                break;
	            case 'V':
	                y = segment.y;
	                break;
	            }
	
	            addPoint(x, y, segment.pathSegType);
	        };
	
	        // ensure path is absolute
	        _svgPathToAbsolute(path);
	
	        // get total length
	        total = path.getTotalLength();
	
	        // queue segments
	        segments = [];
	        for (i = 0; i < path.pathSegList.numberOfItems; i += 1)
	            segments.push(path.pathSegList.getItem(i));
	
	        segmentsQueue = segments.concat();
	
	        // sample through path
	        while (length < total) {
	            // get segment at position
	            segmentIndex = path.getPathSegAtLength(length);
	            segment = segments[segmentIndex];
	
	            // new segment
	            if (segment != lastSegment) {
	                while (segmentsQueue.length && segmentsQueue[0] != segment)
	                    addSegmentPoint(segmentsQueue.shift());
	
	                lastSegment = segment;
	            }
	
	            // add points in between when curving
	            // TODO: adaptive sampling
	            switch (segment.pathSegTypeAsLetter.toUpperCase()) {
	
	            case 'C':
	            case 'T':
	            case 'S':
	            case 'Q':
	            case 'A':
	                point = path.getPointAtLength(length);
	                addPoint(point.x, point.y, 0);
	                break;
	
	            }
	
	            // increment by sample value
	            length += sampleLength;
	        }
	
	        // add remaining segments not passed by sampling
	        for (i = 0, il = segmentsQueue.length; i < il; ++i)
	            addSegmentPoint(segmentsQueue[i]);
	
	        return points;
	    };
	
	    var _svgPathToAbsolute = function(path) {
	        // http://phrogz.net/convert-svg-path-to-all-absolute-commands
	        // Copyright (c) Gavin Kistner
	        // http://phrogz.net/js/_ReuseLicense.txt
	        // Modifications: tidy formatting and naming
	        var x0, y0, x1, y1, x2, y2, segs = path.pathSegList,
	            x = 0, y = 0, len = segs.numberOfItems;
	
	        for (var i = 0; i < len; ++i) {
	            var seg = segs.getItem(i),
	                segType = seg.pathSegTypeAsLetter;
	
	            if (/[MLHVCSQTA]/.test(segType)) {
	                if ('x' in seg) x = seg.x;
	                if ('y' in seg) y = seg.y;
	            } else {
	                if ('x1' in seg) x1 = x + seg.x1;
	                if ('x2' in seg) x2 = x + seg.x2;
	                if ('y1' in seg) y1 = y + seg.y1;
	                if ('y2' in seg) y2 = y + seg.y2;
	                if ('x' in seg) x += seg.x;
	                if ('y' in seg) y += seg.y;
	
	                switch (segType) {
	
	                case 'm':
	                    segs.replaceItem(path.createSVGPathSegMovetoAbs(x, y), i);
	                    break;
	                case 'l':
	                    segs.replaceItem(path.createSVGPathSegLinetoAbs(x, y), i);
	                    break;
	                case 'h':
	                    segs.replaceItem(path.createSVGPathSegLinetoHorizontalAbs(x), i);
	                    break;
	                case 'v':
	                    segs.replaceItem(path.createSVGPathSegLinetoVerticalAbs(y), i);
	                    break;
	                case 'c':
	                    segs.replaceItem(path.createSVGPathSegCurvetoCubicAbs(x, y, x1, y1, x2, y2), i);
	                    break;
	                case 's':
	                    segs.replaceItem(path.createSVGPathSegCurvetoCubicSmoothAbs(x, y, x2, y2), i);
	                    break;
	                case 'q':
	                    segs.replaceItem(path.createSVGPathSegCurvetoQuadraticAbs(x, y, x1, y1), i);
	                    break;
	                case 't':
	                    segs.replaceItem(path.createSVGPathSegCurvetoQuadraticSmoothAbs(x, y), i);
	                    break;
	                case 'a':
	                    segs.replaceItem(path.createSVGPathSegArcAbs(x, y, seg.r1, seg.r2, seg.angle, seg.largeArcFlag, seg.sweepFlag), i);
	                    break;
	                case 'z':
	                case 'Z':
	                    x = x0;
	                    y = y0;
	                    break;
	
	                }
	            }
	
	            if (segType == 'M' || segType == 'm') {
	                x0 = x;
	                y0 = y;
	            }
	        }
	    };
	
	})();

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	var Matter = __webpack_require__(315);
	
	/**
	 * An attractors plugin for matter.js.
	 * See the readme for usage and examples.
	 * @module MatterAttractors
	 */
	var MatterAttractors = {
	  // plugin meta
	  name: 'matter-attractors', // PLUGIN_NAME
	  version: '0.1.7', // PLUGIN_VERSION
	  for: 'matter-js@^0.13.1',
	  silent: true, // no console log please
	
	  // installs the plugin where `base` is `Matter`
	  // you should not need to call this directly.
	  install: function(base) {
	    base.after('Body.create', function() {
	      MatterAttractors.Body.init(this);
	    });
	
	    base.before('Engine.update', function(engine) {
	      MatterAttractors.Engine.update(engine);
	    });
	  },
	
	  Body: {
	    /**
	     * Initialises the `body` to support attractors.
	     * This is called automatically by the plugin.
	     * @function MatterAttractors.Body.init
	     * @param {Matter.Body} body The body to init.
	     * @returns {void} No return value.
	     */
	    init: function(body) {
	      body.plugin.attractors = body.plugin.attractors || [];
	    }
	  },
	
	  Engine: {
	    /**
	     * Applies all attractors for all bodies in the `engine`.
	     * This is called automatically by the plugin.
	     * @function MatterAttractors.Engine.update
	     * @param {Matter.Engine} engine The engine to update.
	     * @returns {void} No return value.
	     */
	    update: function(engine) {
	      var world = engine.world,
	        bodies = Matter.Composite.allBodies(world);
	
	      for (var i = 0; i < bodies.length; i += 1) {
	        var bodyA = bodies[i],
	          attractors = bodyA.plugin.attractors;
	
	        if (attractors && attractors.length > 0) {
	          for (var j = i + 1; j < bodies.length; j += 1) {
	            var bodyB = bodies[j];
	
	            for (var k = 0; k < attractors.length; k += 1) {
	              var attractor = attractors[k],
	                forceVector = attractor;
	
	              if (Matter.Common.isFunction(attractor)) {
	                forceVector = attractor(bodyA, bodyB);
	              }
	
	              if (forceVector) {
	                Matter.Body.applyForce(bodyB, bodyB.position, forceVector);
	              }
	            }
	          }
	        }
	      }
	    }
	  },
	
	  /**
	   * Defines some useful common attractor functions that can be used
	   * by pushing them to your body's `body.plugin.attractors` array.
	   * @namespace MatterAttractors.Attractors
	   * @property {number} gravityConstant The gravitational constant used by the gravity attractor.
	   */
	  Attractors: {
	    gravityConstant: 0.001,
	
	    /**
	     * An attractor function that applies Newton's law of gravitation.
	     * Use this by pushing `MatterAttractors.Attractors.gravity` to your body's `body.plugin.attractors` array.
	     * The gravitational constant defaults to `0.001` which you can change
	     * at `MatterAttractors.Attractors.gravityConstant`.
	     * @function MatterAttractors.Attractors.gravity
	     * @param {Matter.Body} bodyA The first body.
	     * @param {Matter.Body} bodyB The second body.
	     * @returns {void} No return value.
	     */
	    gravity: function(bodyA, bodyB) {
	      // use Newton's law of gravitation
	      var bToA = Matter.Vector.sub(bodyB.position, bodyA.position),
	        distanceSq = Matter.Vector.magnitudeSquared(bToA) || 0.0001,
	        normal = Matter.Vector.normalise(bToA),
	        magnitude = -MatterAttractors.Attractors.gravityConstant * (bodyA.mass * bodyB.mass / distanceSq),
	        force = Matter.Vector.mult(normal, magnitude);
	
	      // to apply forces to both bodies
	      Matter.Body.applyForce(bodyA, bodyA.position, Matter.Vector.neg(force));
	      Matter.Body.applyForce(bodyB, bodyB.position, force);
	    }
	  }
	};
	
	module.exports = MatterAttractors;
	
	/**
	 * @namespace Matter.Body
	 * @see http://brm.io/matter-js/docs/classes/Body.html
	 */
	
	/**
	 * This plugin adds a new property `body.plugin.attractors` to instances of `Matter.Body`.
	 * This is an array of callback functions that will be called automatically
	 * for every pair of bodies, on every engine update.
	 * @property {Function[]} body.plugin.attractors
	 * @memberof Matter.Body
	 */
	
	/**
	 * An attractor function calculates the force to be applied
	 * to `bodyB`, it should either:
	 * - return the force vector to be applied to `bodyB`
	 * - or apply the force to the body(s) itself
	 * @callback AttractorFunction
	 * @param {Matter.Body} bodyA
	 * @param {Matter.Body} bodyB
	 * @returns {(Vector|undefined)} a force vector (optional)
	 */


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

	var Matter = __webpack_require__(315);
	
	/**
	 * A coordinate wrapping plugin for matter.js.
	 * See the readme for usage and examples.
	 * @module MatterWrap
	 */
	var MatterWrap = {
	  // plugin meta
	  name: 'matter-wrap', // PLUGIN_NAME
	  version: '0.1.4', // PLUGIN_VERSION
	  for: 'matter-js@^0.13.1',
	  silent: true, // no console log please
	
	  // installs the plugin where `base` is `Matter`
	  // you should not need to call this directly.
	  install: function(base) {
	    base.after('Engine.update', function() {
	      MatterWrap.Engine.update(this);
	    });
	  },
	
	  Engine: {
	    /**
	     * Updates the engine by wrapping bodies and composites inside `engine.world`.
	     * This is called automatically by the plugin.
	     * @function MatterWrap.Engine.update
	     * @param {Matter.Engine} engine The engine to update.
	     * @returns {void} No return value.
	     */
	    update: function(engine) {
	      var world = engine.world,
	        bodies = Matter.Composite.allBodies(world),
	        composites = Matter.Composite.allComposites(world);
	
	      for (var i = 0; i < bodies.length; i += 1) {
	        var body = bodies[i];
	
	        if (body.plugin.wrap) {
	          MatterWrap.Body.wrap(body, body.plugin.wrap);
	        }
	      }
	
	      for (i = 0; i < composites.length; i += 1) {
	        var composite = composites[i];
	
	        if (composite.plugin.wrap) {
	          MatterWrap.Composite.wrap(composite, composite.plugin.wrap);
	        }
	      }
	    }
	  },
	
	  Bounds: {
	    /**
	     * Returns a translation vector that wraps the `objectBounds` inside the `bounds`.
	     * @function MatterWrap.Bounds.wrap
	     * @param {Matter.Bounds} objectBounds The bounds of the object to wrap inside the bounds.
	     * @param {Matter.Bounds} bounds The bounds to wrap the body inside.
	     * @returns {?Matter.Vector} A translation vector (only if wrapping is required).
	     */
	    wrap: function(objectBounds, bounds) {
	      var x = null,
	        y = null;
	
	      if (typeof bounds.min.x !== 'undefined' && typeof bounds.max.x !== 'undefined') {
	        if (objectBounds.min.x > bounds.max.x) {
	          x = bounds.min.x - objectBounds.max.x;
	        } else if (objectBounds.max.x < bounds.min.x) {
	          x = bounds.max.x - objectBounds.min.x;
	        }
	      }
	
	      if (typeof bounds.min.y !== 'undefined' && typeof bounds.max.y !== 'undefined') {
	        if (objectBounds.min.y > bounds.max.y) {
	          y = bounds.min.y - objectBounds.max.y;
	        } else if (objectBounds.max.y < bounds.min.y) {
	          y = bounds.max.y - objectBounds.min.y;
	        }
	      }
	
	      if (x !== null || y !== null) {
	        return {
	          x: x || 0,
	          y: y || 0
	        };
	      }
	    }
	  },
	
	  Body: {
	    /**
	     * Wraps the `body` position such that it always stays within the given bounds. 
	     * Upon crossing a boundary the body will appear on the opposite side of the bounds, 
	     * while maintaining its velocity.
	     * This is called automatically by the plugin.
	     * @function MatterWrap.Body.wrap
	     * @param {Matter.Body} body The body to wrap.
	     * @param {Matter.Bounds} bounds The bounds to wrap the body inside.
	     * @returns {?Matter.Vector} The translation vector that was applied (only if wrapping was required).
	     */
	    wrap: function(body, bounds) {
	      var translation = MatterWrap.Bounds.wrap(body.bounds, bounds);
	
	      if (translation) {
	        Matter.Body.translate(body, translation);
	      }
	
	      return translation;
	    }
	  },
	
	  Composite: {
	    /**
	     * Returns the union of the bounds of all of the composite's bodies
	     * (not accounting for constraints).
	     * @function MatterWrap.Composite.bounds
	     * @param {Matter.Composite} composite The composite.
	     * @returns {Matter.Bounds} The composite bounds.
	     */
	    bounds: function(composite) {
	      var bodies = Matter.Composite.allBodies(composite),
	        vertices = [];
	      
	      for (var i = 0; i < bodies.length; i += 1) {
	        var body = bodies[i];
	        vertices.push(body.bounds.min, body.bounds.max);
	      }
	
	      return Matter.Bounds.create(vertices);
	    },
	
	    /**
	     * Wraps the `composite` position such that it always stays within the given bounds. 
	     * Upon crossing a boundary the composite will appear on the opposite side of the bounds, 
	     * while maintaining its velocity.
	     * This is called automatically by the plugin.
	     * @function MatterWrap.Composite.wrap
	     * @param {Matter.Composite} composite The composite to wrap.
	     * @param {Matter.Bounds} bounds The bounds to wrap the composite inside.
	     * @returns {?Matter.Vector} The translation vector that was applied (only if wrapping was required).
	     */
	    wrap: function(composite, bounds) {
	      var translation = MatterWrap.Bounds.wrap(
	        MatterWrap.Composite.bounds(composite), 
	        bounds
	      );
	
	      if (translation) {
	        Matter.Composite.translate(composite, translation);
	      }
	
	      return translation;
	    }
	  }
	};
	
	module.exports = MatterWrap;
	
	/**
	 * @namespace Matter.Body
	 * @see http://brm.io/matter-js/docs/classes/Body.html
	 */
	
	/**
	 * This plugin adds a new property `body.plugin.wrap` to instances of `Matter.Body`.  
	 * This is a `Matter.Bounds` instance that specifies the wrapping region.
	 * @property {Matter.Bounds} body.plugin.wrap
	 * @memberof Matter.Body
	 */
	
	/**
	 * This plugin adds a new property `composite.plugin.wrap` to instances of `Matter.Composite`.  
	 * This is a `Matter.Bounds` instance that specifies the wrapping region.
	 * @property {Matter.Bounds} composite.plugin.wrap
	 * @memberof Matter.Composite
	 */

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	* @author       Richard Davey <rich@photonstorm.com>
	* @copyright    2018 Photon Storm Ltd.
	* @license      {@link https://github.com/photonstorm/phaser3-plugin-template/blob/master/LICENSE|MIT License}
	*/
	
	var BasePlugin = __webpack_require__(610);
	var Class = __webpack_require__(1);
	
	/**
	 * @classdesc
	 * A Scene Level Plugin is installed into every Scene and belongs to that Scene.
	 * It can listen for Scene events and respond to them.
	 * It can map itself to a Scene property, or into the Scene Systems, or both.
	 *
	 * @class ScenePlugin
	 * @memberOf Phaser.Plugins
	 * @constructor
	 * @since 3.8.0
	 *
	 * @param {Phaser.Game} game - [description]
	 */
	var ScenePlugin = new Class({
	
	    Extends: BasePlugin,
	
	    initialize:
	
	    function ScenePlugin (scene, pluginManager)
	    {
	        BasePlugin.call(this, pluginManager);
	
	        /**
	         * A reference to the Scene that has installed this plugin.
	         * This property is only set when the plugin is instantiated and added to the Scene, not before.
	         *
	         * @name Phaser.Plugins.ScenePlugin#scene
	         * @type {?Phaser.Scene}
	         * @protected
	         * @since 3.8.0
	         */
	        this.scene = scene;
	
	        /**
	         * A reference to the Scene Systems of the Scene that has installed this plugin.
	         * This property is only set when the plugin is instantiated and added to the Scene, not before.
	         *
	         * @name Phaser.Plugins.ScenePlugin#systems
	         * @type {?Phaser.Scene.Systems}
	         * @protected
	         * @since 3.8.0
	         */
	        this.systems = scene.sys;
	
	        scene.sys.events.once('boot', this.boot, this);
	    },
	
	    /**
	     * This method is called when the Scene boots. It is only ever called once.
	     * 
	     * By this point the plugin properties `scene` and `systems` will have already been set.
	     * 
	     * In here you can listen for Scene events and set-up whatever you need for this plugin to run.
	     * Here are the Scene events you can listen to:
	     * 
	     * start
	     * ready
	     * preupdate
	     * update
	     * postupdate
	     * resize
	     * pause
	     * resume
	     * sleep
	     * wake
	     * transitioninit
	     * transitionstart
	     * transitioncomplete
	     * transitionout
	     * shutdown
	     * destroy
	     * 
	     * At the very least you should offer a destroy handler for when the Scene closes down, i.e:
	     *
	     * ```javascript
	     * var eventEmitter = this.systems.events;
	     * eventEmitter.once('destroy', this.sceneDestroy, this);
	     * ```
	     *
	     * @method Phaser.Plugins.ScenePlugin#boot
	     * @since 3.8.0
	     */
	    boot: function ()
	    {
	    }
	
	});
	
	module.exports = ScenePlugin;


/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Plugins
	 */
	
	module.exports = {
	
	    BasePlugin: __webpack_require__(610),
	    DefaultPlugins: __webpack_require__(322),
	    PluginCache: __webpack_require__(29),
	    PluginManager: __webpack_require__(611),
	    ScenePlugin: __webpack_require__(1489)
	
	};


/***/ }),
/* 1491 */
/***/ (function(module, exports) {

	/**
	* A polyfill for Array.forEach
	* https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
	*/
	if (!Array.prototype.forEach)
	{
	    Array.prototype.forEach = function (fun /*, thisArg */)
	    {
	        'use strict';
	
	        if (this === void 0 || this === null)
	        {
	            throw new TypeError();
	        }
	
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        if (typeof fun !== 'function')
	        {
	            throw new TypeError();
	        }
	
	        var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
	
	        for (var i = 0; i < len; i++)
	        {
	            if (i in t)
	            {
	                fun.call(thisArg, t[i], i, t);
	            }
	        }
	    };
	}


/***/ }),
/* 1492 */
/***/ (function(module, exports) {

	/**
	* A polyfill for Array.isArray
	*/
	if (!Array.isArray)
	{
	    Array.isArray = function (arg)
	    {
	        return Object.prototype.toString.call(arg) === '[object Array]';
	    };
	}


/***/ }),
/* 1493 */
/***/ (function(module, exports) {

	/* Copyright 2013 Chris Wilson
	
	   Licensed under the Apache License, Version 2.0 (the "License");
	   you may not use this file except in compliance with the License.
	   You may obtain a copy of the License at
	
	       http://www.apache.org/licenses/LICENSE-2.0
	
	   Unless required by applicable law or agreed to in writing, software
	   distributed under the License is distributed on an "AS IS" BASIS,
	   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   See the License for the specific language governing permissions and
	   limitations under the License.
	*/
	
	/*
	
	This monkeypatch library is intended to be included in projects that are
	written to the proper AudioContext spec (instead of webkitAudioContext),
	and that use the new naming and proper bits of the Web Audio API (e.g.
	using BufferSourceNode.start() instead of BufferSourceNode.noteOn()), but may
	have to run on systems that only support the deprecated bits.
	
	This library should be harmless to include if the browser supports
	unprefixed "AudioContext", and/or if it supports the new names.
	
	The patches this library handles:
	if window.AudioContext is unsupported, it will be aliased to webkitAudioContext().
	if AudioBufferSourceNode.start() is unimplemented, it will be routed to noteOn() or
	noteGrainOn(), depending on parameters.
	
	The following aliases only take effect if the new names are not already in place:
	
	AudioBufferSourceNode.stop() is aliased to noteOff()
	AudioContext.createGain() is aliased to createGainNode()
	AudioContext.createDelay() is aliased to createDelayNode()
	AudioContext.createScriptProcessor() is aliased to createJavaScriptNode()
	AudioContext.createPeriodicWave() is aliased to createWaveTable()
	OscillatorNode.start() is aliased to noteOn()
	OscillatorNode.stop() is aliased to noteOff()
	OscillatorNode.setPeriodicWave() is aliased to setWaveTable()
	AudioParam.setTargetAtTime() is aliased to setTargetValueAtTime()
	
	This library does NOT patch the enumerated type changes, as it is
	recommended in the specification that implementations support both integer
	and string types for AudioPannerNode.panningModel, AudioPannerNode.distanceModel
	BiquadFilterNode.type and OscillatorNode.type.
	
	*/
	(function (global, exports, perf) {
	  'use strict';
	
	  function fixSetTarget(param) {
	    if (!param)	// if NYI, just return
	      return;
	    if (!param.setTargetAtTime)
	      param.setTargetAtTime = param.setTargetValueAtTime;
	  }
	
	  if (window.hasOwnProperty('webkitAudioContext') &&
	      !window.hasOwnProperty('AudioContext')) {
	    window.AudioContext = webkitAudioContext;
	
	    if (!AudioContext.prototype.hasOwnProperty('createGain'))
	      AudioContext.prototype.createGain = AudioContext.prototype.createGainNode;
	    if (!AudioContext.prototype.hasOwnProperty('createDelay'))
	      AudioContext.prototype.createDelay = AudioContext.prototype.createDelayNode;
	    if (!AudioContext.prototype.hasOwnProperty('createScriptProcessor'))
	      AudioContext.prototype.createScriptProcessor = AudioContext.prototype.createJavaScriptNode;
	    if (!AudioContext.prototype.hasOwnProperty('createPeriodicWave'))
	      AudioContext.prototype.createPeriodicWave = AudioContext.prototype.createWaveTable;
	
	
	    AudioContext.prototype.internal_createGain = AudioContext.prototype.createGain;
	    AudioContext.prototype.createGain = function() {
	      var node = this.internal_createGain();
	      fixSetTarget(node.gain);
	      return node;
	    };
	
	    AudioContext.prototype.internal_createDelay = AudioContext.prototype.createDelay;
	    AudioContext.prototype.createDelay = function(maxDelayTime) {
	      var node = maxDelayTime ? this.internal_createDelay(maxDelayTime) : this.internal_createDelay();
	      fixSetTarget(node.delayTime);
	      return node;
	    };
	
	    AudioContext.prototype.internal_createBufferSource = AudioContext.prototype.createBufferSource;
	    AudioContext.prototype.createBufferSource = function() {
	      var node = this.internal_createBufferSource();
	      if (!node.start) {
	        node.start = function ( when, offset, duration ) {
	          if ( offset || duration )
	            this.noteGrainOn( when || 0, offset, duration );
	          else
	            this.noteOn( when || 0 );
	        };
	      } else {
	        node.internal_start = node.start;
	        node.start = function( when, offset, duration ) {
	          if( typeof duration !== 'undefined' )
	            node.internal_start( when || 0, offset, duration );
	          else
	            node.internal_start( when || 0, offset || 0 );
	        };
	      }
	      if (!node.stop) {
	        node.stop = function ( when ) {
	          this.noteOff( when || 0 );
	        };
	      } else {
	        node.internal_stop = node.stop;
	        node.stop = function( when ) {
	          node.internal_stop( when || 0 );
	        };
	      }
	      fixSetTarget(node.playbackRate);
	      return node;
	    };
	
	    AudioContext.prototype.internal_createDynamicsCompressor = AudioContext.prototype.createDynamicsCompressor;
	    AudioContext.prototype.createDynamicsCompressor = function() {
	      var node = this.internal_createDynamicsCompressor();
	      fixSetTarget(node.threshold);
	      fixSetTarget(node.knee);
	      fixSetTarget(node.ratio);
	      fixSetTarget(node.reduction);
	      fixSetTarget(node.attack);
	      fixSetTarget(node.release);
	      return node;
	    };
	
	    AudioContext.prototype.internal_createBiquadFilter = AudioContext.prototype.createBiquadFilter;
	    AudioContext.prototype.createBiquadFilter = function() {
	      var node = this.internal_createBiquadFilter();
	      fixSetTarget(node.frequency);
	      fixSetTarget(node.detune);
	      fixSetTarget(node.Q);
	      fixSetTarget(node.gain);
	      return node;
	    };
	
	    if (AudioContext.prototype.hasOwnProperty( 'createOscillator' )) {
	      AudioContext.prototype.internal_createOscillator = AudioContext.prototype.createOscillator;
	      AudioContext.prototype.createOscillator = function() {
	        var node = this.internal_createOscillator();
	        if (!node.start) {
	          node.start = function ( when ) {
	            this.noteOn( when || 0 );
	          };
	        } else {
	          node.internal_start = node.start;
	          node.start = function ( when ) {
	            node.internal_start( when || 0);
	          };
	        }
	        if (!node.stop) {
	          node.stop = function ( when ) {
	            this.noteOff( when || 0 );
	          };
	        } else {
	          node.internal_stop = node.stop;
	          node.stop = function( when ) {
	            node.internal_stop( when || 0 );
	          };
	        }
	        if (!node.setPeriodicWave)
	          node.setPeriodicWave = node.setWaveTable;
	        fixSetTarget(node.frequency);
	        fixSetTarget(node.detune);
	        return node;
	      };
	    }
	  }
	
	  if (window.hasOwnProperty('webkitOfflineAudioContext') &&
	      !window.hasOwnProperty('OfflineAudioContext')) {
	    window.OfflineAudioContext = webkitOfflineAudioContext;
	  }
	
	}(window));
	


/***/ }),
/* 1494 */
/***/ (function(module, exports) {

	/**
	* A polyfill for Function.prototype.bind
	*/
	if (!Function.prototype.bind) {
	
	    /* jshint freeze: false */
	    Function.prototype.bind = (function () {
	
	        var slice = Array.prototype.slice;
	
	        return function (thisArg) {
	
	            var target = this, boundArgs = slice.call(arguments, 1);
	
	            if (typeof target !== 'function')
	            {
	                throw new TypeError();
	            }
	
	            function bound() {
	                var args = boundArgs.concat(slice.call(arguments));
	                target.apply(this instanceof bound ? this : thisArg, args);
	            }
	
	            bound.prototype = (function F(proto) {
	                if (proto)
	                {
	                    F.prototype = proto;
	                }
	
	                if (!(this instanceof F))
	                {
	                    /* jshint supernew: true */
	                    return new F;
	                }
	            })(target.prototype);
	
	            return bound;
	        };
	    })();
	}
	


/***/ }),
/* 1495 */
/***/ (function(module, exports) {

	// ES6 Math.trunc - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/trunc
	if (!Math.trunc) {
	    Math.trunc = function trunc(x) {
	        return x < 0 ? Math.ceil(x) : Math.floor(x);
	    };
	}


/***/ }),
/* 1496 */
/***/ (function(module, exports) {

	/**
	* Low-budget Float32Array knock-off, suitable for use with P2.js in IE9
	* Source: http://www.html5gamedevs.com/topic/5988-phaser-12-ie9/
	* Cameron Foale (http://www.kibibu.com)
	*/
	if (typeof window.Uint32Array !== 'function' && typeof window.Uint32Array !== 'object')
	{
	    var CheapArray = function (fakeType)
	    {
	        var proto = new Array(); // jshint ignore:line
	
	        window[fakeType] = function(arg) {
	
	            if (typeof(arg) === 'number')
	            {
	                Array.call(this, arg);
	
	                this.length = arg;
	
	                for (var i = 0; i < this.length; i++)
	                {
	                    this[i] = 0;
	                }
	            }
	            else
	            {
	                Array.call(this, arg.length);
	
	                this.length = arg.length;
	
	                for (var i = 0; i < this.length; i++)
	                {
	                    this[i] = arg[i];
	                }
	            }
	        };
	
	        window[fakeType].prototype = proto;
	        window[fakeType].constructor = window[fakeType];
	    };
	
	    CheapArray('Float32Array'); // jshint ignore:line
	    CheapArray('Uint32Array'); // jshint ignore:line
	    CheapArray('Uint16Array'); // jshint ignore:line
	    CheapArray('Int16Array'); // jshint ignore:line
	    CheapArray('ArrayBuffer'); // jshint ignore:line
	}


/***/ }),
/* 1497 */
/***/ (function(module, exports) {

	/**
	 * Also fix for the absent console in IE9
	 */
	if (!window.console)
	{
	    window.console = {};
	    window.console.log = window.console.assert = function(){};
	    window.console.warn = window.console.assert = function(){};
	}


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1491);
	__webpack_require__(1492);
	__webpack_require__(1493);
	__webpack_require__(1497);
	__webpack_require__(1494);
	__webpack_require__(1495);
	__webpack_require__(1499);
	__webpack_require__(1500);
	__webpack_require__(1496);


/***/ }),
/* 1499 */
/***/ (function(module, exports) {

	/**
	 * performance.now
	 */
	(function () {
	
	    if ('performance' in window === false)
	    {
	        window.performance = {};
	    }
	
	    //  Thanks IE8
	    Date.now = (Date.now || function () {
	        return new Date().getTime();
	    });
	
	    if ('now' in window.performance === false)
	    {
	        var nowOffset = Date.now();
	
	        if (performance.timing && performance.timing.navigationStart)
	        {
	            nowOffset = performance.timing.navigationStart;
	        }
	
	        window.performance.now = function now ()
	        {
	            return Date.now() - nowOffset;
	        }
	    }
	
	})();


/***/ }),
/* 1500 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// References:
	// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	// https://gist.github.com/1579671
	// http://updates.html5rocks.com/2012/05/requestAnimationFrame-API-now-with-sub-millisecond-precision
	// https://gist.github.com/timhall/4078614
	// https://github.com/Financial-Times/polyfill-service/tree/master/polyfills/requestAnimationFrame
	
	// Expected to be used with Browserfiy
	// Browserify automatically detects the use of `global` and passes the
	// correct reference of `global`, `self`, and finally `window`
	
	// Date.now
	if (!(Date.now && Date.prototype.getTime)) {
	    Date.now = function now() {
	        return new Date().getTime();
	    };
	}
	
	// performance.now
	if (!(global.performance && global.performance.now)) {
	    var startTime = Date.now();
	    if (!global.performance) {
	        global.performance = {};
	    }
	    global.performance.now = function () {
	        return Date.now() - startTime;
	    };
	}
	
	// requestAnimationFrame
	var lastTime = Date.now();
	var vendors = ['ms', 'moz', 'webkit', 'o'];
	
	for(var x = 0; x < vendors.length && !global.requestAnimationFrame; ++x) {
	    global.requestAnimationFrame = global[vendors[x] + 'RequestAnimationFrame'];
	    global.cancelAnimationFrame = global[vendors[x] + 'CancelAnimationFrame'] ||
	        global[vendors[x] + 'CancelRequestAnimationFrame'];
	}
	
	if (!global.requestAnimationFrame) {
	    global.requestAnimationFrame = function (callback) {
	        if (typeof callback !== 'function') {
	            throw new TypeError(callback + 'is not a function');
	        }
	
	        var currentTime = Date.now(),
	            delay = 16 + lastTime - currentTime;
	
	        if (delay < 0) {
	            delay = 0;
	        }
	
	        lastTime = currentTime;
	
	        return setTimeout(function () {
	            lastTime = Date.now();
	            callback(performance.now());
	        }, delay);
	    };
	}
	
	if (!global.cancelAnimationFrame) {
	    global.cancelAnimationFrame = function(id) {
	        clearTimeout(id);
	    };
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Renderer.Canvas
	 */
	
	module.exports = {
	
	    BlitImage: __webpack_require__(613),
	    CanvasRenderer: __webpack_require__(612),
	    DrawImage: __webpack_require__(614),
	    GetBlendModes: __webpack_require__(615)
	
	};


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @typedef {object} RendererConfig
	 *
	 * @property {boolean} clearBeforeRender - [description]
	 * @property {boolean} pixelArt - [description]
	 * @property {Phaser.Display.Color} backgroundColor - [description]
	 * @property {number} resolution - [description]
	 * @property {boolean} autoResize - [description]
	 * @property {boolean} roundPixels - [description]
	 */
	
	/**
	 * @namespace Phaser.Renderer
	 */
	
	module.exports = {
	
	    Canvas: __webpack_require__(1501),
	    Snapshot: __webpack_require__(1503),
	    WebGL: __webpack_require__(1504)
	
	};


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @callback SnapshotCallback
	 *
	 * @param {HTMLImageElement} snapshot - [description]
	 */
	
	/**
	 * @namespace Phaser.Renderer.Snapshot
	 */
	
	module.exports = {
	
	    Canvas: __webpack_require__(616),
	    WebGL: __webpack_require__(617)
	
	};


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Renderer.WebGL
	 */
	
	module.exports = {
	
	    Utils: __webpack_require__(87),
	    WebGLPipeline: __webpack_require__(207),
	    WebGLRenderer: __webpack_require__(618),
	    Pipelines: __webpack_require__(1505),
	
	    // Constants
	    BYTE: 0,
	    SHORT: 1,
	    UNSIGNED_BYTE: 2,
	    UNSIGNED_SHORT: 3,
	    FLOAT: 4
	
	};


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Renderer.WebGL.Pipelines
	 */
	
	module.exports = {
	
	    BitmapMaskPipeline: __webpack_require__(619),
	    FlatTintPipeline: __webpack_require__(620),
	    ForwardDiffuseLightPipeline: __webpack_require__(323),
	    TextureTintPipeline: __webpack_require__(324)
	
	};


/***/ }),
/* 1506 */
/***/ (function(module, exports) {

	module.exports = [
	    '#define SHADER_NAME PHASER_BITMAP_MASK_FS',
	    '',
	    'precision mediump float;',
	    '',
	    'uniform vec2 uResolution;',
	    'uniform sampler2D uMainSampler;',
	    'uniform sampler2D uMaskSampler;',
	    'uniform bool uInvertMaskAlpha;',
	    '',
	    'void main()',
	    '{',
	    '    vec2 uv = gl_FragCoord.xy / uResolution;',
	    '    vec4 mainColor = texture2D(uMainSampler, uv);',
	    '    vec4 maskColor = texture2D(uMaskSampler, uv);',
	    '    float alpha = mainColor.a;',
	    '',
	    '    if (!uInvertMaskAlpha)',
	    '    {',
	    '        alpha *= (maskColor.a);',
	    '    }',
	    '    else',
	    '    {',
	    '        alpha *= (1.0 - maskColor.a);',
	    '    }',
	    '',
	    '    gl_FragColor = vec4(mainColor.rgb * alpha, alpha);',
	    '}',
	    ''
	].join('\n');


/***/ }),
/* 1507 */
/***/ (function(module, exports) {

	module.exports = [
	    '#define SHADER_NAME PHASER_BITMAP_MASK_VS',
	    '',
	    'precision mediump float;',
	    '',
	    'attribute vec2 inPosition;',
	    '',
	    'void main()',
	    '{',
	    '    gl_Position = vec4(inPosition, 0.0, 1.0);',
	    '}',
	    ''
	].join('\n');


/***/ }),
/* 1508 */
/***/ (function(module, exports) {

	module.exports = [
	    '#define SHADER_NAME PHASER_FLAT_TINT_FS',
	    '',
	    'precision mediump float;',
	    '',
	    'varying vec4 outTint;',
	    '',
	    'void main() {',
	    '    gl_FragColor = vec4(outTint.rgb * outTint.a, outTint.a);',
	    '}',
	    ''
	].join('\n');


/***/ }),
/* 1509 */
/***/ (function(module, exports) {

	module.exports = [
	    '#define SHADER_NAME PHASER_FLAT_TINT_VS',
	    '',
	    'precision mediump float;',
	    '',
	    'uniform mat4 uProjectionMatrix;',
	    'uniform mat4 uViewMatrix;',
	    'uniform mat4 uModelMatrix;',
	    '',
	    'attribute vec2 inPosition;',
	    'attribute vec4 inTint;',
	    '',
	    'varying vec4 outTint;',
	    '',
	    'void main () {',
	    '    gl_Position = uProjectionMatrix * uViewMatrix * uModelMatrix * vec4(inPosition, 1.0, 1.0);',
	    '    outTint = inTint;',
	    '}',
	    ''
	].join('\n');


/***/ }),
/* 1510 */
/***/ (function(module, exports) {

	module.exports = [
	    '#define SHADER_NAME PHASER_FORWARD_DIFFUSE_FS',
	    '',
	    'precision mediump float;',
	    '',
	    'struct Light',
	    '{',
	    '    vec2 position;',
	    '    vec3 color;',
	    '    float intensity;',
	    '    float radius;',
	    '};',
	    '',
	    'const int kMaxLights = %LIGHT_COUNT%;',
	    '',
	    'uniform vec4 uCamera; /* x, y, rotation, zoom */',
	    'uniform vec2 uResolution;',
	    'uniform sampler2D uMainSampler;',
	    'uniform sampler2D uNormSampler;',
	    'uniform vec3 uAmbientLightColor;',
	    'uniform Light uLights[kMaxLights];',
	    '',
	    'varying vec2 outTexCoord;',
	    'varying vec4 outTint;',
	    '',
	    'void main()',
	    '{',
	    '    vec3 finalColor = vec3(0.0, 0.0, 0.0);',
	    '    vec4 color = texture2D(uMainSampler, outTexCoord) * vec4(outTint.rgb * outTint.a, outTint.a);',
	    '    vec3 normalMap = texture2D(uNormSampler, outTexCoord).rgb;',
	    '    vec3 normal = normalize(vec3(normalMap * 2.0 - 1.0));',
	    '    vec2 res = vec2(min(uResolution.x, uResolution.y)) * uCamera.w;',
	    '',
	    '    for (int index = 0; index < kMaxLights; ++index)',
	    '    {',
	    '        Light light = uLights[index];',
	    '        vec3 lightDir = vec3((light.position.xy / res) - (gl_FragCoord.xy / res), 0.1);',
	    '        vec3 lightNormal = normalize(lightDir);',
	    '        float distToSurf = length(lightDir) * uCamera.w;',
	    '        float diffuseFactor = max(dot(normal, lightNormal), 0.0);',
	    '        float radius = (light.radius / res.x * uCamera.w) * uCamera.w;',
	    '        float attenuation = clamp(1.0 - distToSurf * distToSurf / (radius * radius), 0.0, 1.0);',
	    '        vec3 diffuse = light.color * diffuseFactor;',
	    '        finalColor += (attenuation * diffuse) * light.intensity;',
	    '    }',
	    '',
	    '    vec4 colorOutput = vec4(uAmbientLightColor + finalColor, 1.0);',
	    '    gl_FragColor = color * vec4(colorOutput.rgb * colorOutput.a, colorOutput.a);',
	    '',
	    '}',
	    ''
	].join('\n');


/***/ }),
/* 1511 */
/***/ (function(module, exports) {

	module.exports = [
	    '#define SHADER_NAME PHASER_TEXTURE_TINT_FS',
	    '',
	    'precision mediump float;',
	    '',
	    'uniform sampler2D uMainSampler;',
	    '',
	    'varying vec2 outTexCoord;',
	    'varying vec4 outTint;',
	    '',
	    'void main()',
	    '{',
	    '    vec4 texel = texture2D(uMainSampler, outTexCoord);',
	    '    texel *= vec4(outTint.rgb * outTint.a, outTint.a);',
	    '    gl_FragColor = texel;',
	    '}',
	    ''
	].join('\n');


/***/ }),
/* 1512 */
/***/ (function(module, exports) {

	module.exports = [
	    '#define SHADER_NAME PHASER_TEXTURE_TINT_VS',
	    '',
	    'precision mediump float;',
	    '',
	    'uniform mat4 uProjectionMatrix;',
	    'uniform mat4 uViewMatrix;',
	    'uniform mat4 uModelMatrix;',
	    '',
	    'attribute vec2 inPosition;',
	    'attribute vec2 inTexCoord;',
	    'attribute vec4 inTint;',
	    '',
	    'varying vec2 outTexCoord;',
	    'varying vec4 outTint;',
	    '',
	    'void main ()',
	    '{',
	    '    gl_Position = uProjectionMatrix * uViewMatrix * uModelMatrix * vec4(inPosition, 1.0, 1.0);',
	    '    outTexCoord = inTexCoord;',
	    '    outTint = inTint;',
	    '}',
	    '',
	    ''
	].join('\n');


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetFastValue = __webpack_require__(3);
	var UppercaseFirst = __webpack_require__(665);
	
	/**
	 * Builds an array of which physics plugins should be activated for the given Scene.
	 *
	 * @function Phaser.Scenes.GetPhysicsPlugins
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scenes.Systems} sys - The scene system to get the physics systems of.
	 *
	 * @return {array} An array of Physics systems to start for this Scene.
	 */
	var GetPhysicsPlugins = function (sys)
	{
	    var defaultSystem = sys.game.config.defaultPhysicsSystem;
	    var sceneSystems = GetFastValue(sys.settings, 'physics', false);
	
	    if (!defaultSystem && !sceneSystems)
	    {
	        //  No default physics system or systems in this scene
	        return;
	    }
	
	    //  Let's build the systems array
	    var output = [];
	
	    if (defaultSystem)
	    {
	        output.push(UppercaseFirst(defaultSystem + 'Physics'));
	    }
	
	    if (sceneSystems)
	    {
	        for (var key in sceneSystems)
	        {
	            key = UppercaseFirst(key.concat('Physics'));
	
	            if (output.indexOf(key) === -1)
	            {
	                output.push(key);
	            }
	        }
	    }
	
	    //  An array of Physics systems to start for this Scene
	    return output;
	};
	
	module.exports = GetPhysicsPlugins;


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetFastValue = __webpack_require__(3);
	
	/**
	 * Builds an array of which plugins (not including physics plugins) should be activated for the given Scene.
	 *
	 * @function Phaser.Scenes.GetScenePlugins
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scenes.Systems} sys - [description]
	 *
	 * @return {array} [description]
	 */
	var GetScenePlugins = function (sys)
	{
	    var defaultPlugins = sys.plugins.getDefaultScenePlugins();
	
	    var scenePlugins = GetFastValue(sys.settings, 'plugins', false);
	
	    //  Scene Plugins always override Default Plugins
	    if (Array.isArray(scenePlugins))
	    {
	        return scenePlugins;
	    }
	    else if (defaultPlugins)
	    {
	        return defaultPlugins;
	    }
	    else
	    {
	        //  No default plugins or plugins in this scene
	        return [];
	    }
	};
	
	module.exports = GetScenePlugins;


/***/ }),
/* 1515 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  These properties get injected into the Scene and map to local systems
	//  The map value is the property that is injected into the Scene, the key is the Scene.Systems reference.
	//  These defaults can be modified via the Scene config object
	//          var config = {
	//            map: {
	//                add: 'makeStuff',
	//                load: 'loader'
	//            }
	//        };
	
	var InjectionMap = {
	
	    game: 'game',
	
	    anims: 'anims',
	    cache: 'cache',
	    plugins: 'plugins',
	    registry: 'registry',
	    sound: 'sound',
	    textures: 'textures',
	
	    events: 'events',
	    cameras: 'cameras',
	    cameras3d: 'cameras3d',
	    add: 'add',
	    make: 'make',
	    scenePlugin: 'scene',
	    displayList: 'children',
	    lights: 'lights',
	
	    data: 'data',
	    input: 'input',
	    load: 'load',
	    time: 'time',
	    tweens: 'tweens',
	
	    arcadePhysics: 'physics',
	    impactPhysics: 'impact',
	    matterPhysics: 'matter'
	
	};
	
	module.exports = InjectionMap;


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Clamp = __webpack_require__(63);
	var Class = __webpack_require__(1);
	var CONST = __webpack_require__(168);
	var GetFastValue = __webpack_require__(3);
	var PluginCache = __webpack_require__(29);
	
	/**
	 * @classdesc
	 * A proxy class to the Global Scene Manager.
	 *
	 * @class ScenePlugin
	 * @memberOf Phaser.Scenes
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - The Scene that this ScenePlugin belongs to.
	 */
	var ScenePlugin = new Class({
	
	    initialize:
	
	    function ScenePlugin (scene)
	    {
	        /**
	         * The Scene that this ScenePlugin belongs to.
	         *
	         * @name Phaser.Scenes.ScenePlugin#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * The Scene Systems instance of the Scene that this ScenePlugin belongs to.
	         *
	         * @name Phaser.Scenes.ScenePlugin#systems
	         * @type {Phaser.Scenes.Systems}
	         * @since 3.0.0
	         */
	        this.systems = scene.sys;
	
	        /**
	         * The settings of the Scene this ScenePlugin belongs to.
	         *
	         * @name Phaser.Scenes.ScenePlugin#settings
	         * @type {Phaser.Scenes.Settings.Object}
	         * @since 3.0.0
	         */
	        this.settings = scene.sys.settings;
	
	        /**
	         * The key of the Scene this ScenePlugin belongs to.
	         *
	         * @name Phaser.Scenes.ScenePlugin#key
	         * @type {string}
	         * @since 3.0.0
	         */
	        this.key = scene.sys.settings.key;
	
	        /**
	         * The Game's SceneManager.
	         *
	         * @name Phaser.Scenes.ScenePlugin#manager
	         * @type {Phaser.Scenes.SceneManager}
	         * @since 3.0.0
	         */
	        this.manager = scene.sys.game.scene;
	
	        /**
	         * If this Scene is currently transitioning to another, this holds
	         * the current percentage of the transition progress, between 0 and 1.
	         *
	         * @name Phaser.Scenes.ScenePlugin#transitionProgress
	         * @type {float}
	         * @since 3.5.0
	         */
	        this.transitionProgress = 0;
	
	        /**
	         * Transition elapsed timer.
	         *
	         * @name Phaser.Scenes.ScenePlugin#_elapsed
	         * @type {integer}
	         * @private
	         * @since 3.5.0
	         */
	        this._elapsed = 0;
	
	        /**
	         * Transition elapsed timer.
	         *
	         * @name Phaser.Scenes.ScenePlugin#_target
	         * @type {?Phaser.Scenes.Scene}
	         * @private
	         * @since 3.5.0
	         */
	        this._target = null;
	
	        /**
	         * Transition duration.
	         *
	         * @name Phaser.Scenes.ScenePlugin#_duration
	         * @type {integer}
	         * @private
	         * @since 3.5.0
	         */
	        this._duration = 0;
	
	        /**
	         * Transition callback.
	         *
	         * @name Phaser.Scenes.ScenePlugin#_onUpdate
	         * @type {function}
	         * @private
	         * @since 3.5.0
	         */
	        this._onUpdate;
	
	        /**
	         * Transition callback scope.
	         *
	         * @name Phaser.Scenes.ScenePlugin#_onUpdateScope
	         * @type {object}
	         * @private
	         * @since 3.5.0
	         */
	        this._onUpdateScope;
	
	        /**
	         * Will this Scene sleep (true) after the transition, or stop (false)
	         *
	         * @name Phaser.Scenes.ScenePlugin#_willSleep
	         * @type {boolean}
	         * @private
	         * @since 3.5.0
	         */
	        this._willSleep = false;
	
	        /**
	         * Will this Scene be removed from the Scene Manager after the transition completes?
	         *
	         * @name Phaser.Scenes.ScenePlugin#_willRemove
	         * @type {boolean}
	         * @private
	         * @since 3.5.0
	         */
	        this._willRemove = false;
	
	        scene.sys.events.once('boot', this.boot, this);
	        scene.sys.events.on('start', this.pluginStart, this);
	    },
	
	    /**
	     * This method is called automatically, only once, when the Scene is first created.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.Scenes.ScenePlugin#boot
	     * @private
	     * @since 3.0.0
	     */
	    boot: function ()
	    {
	        this.systems.events.once('destroy', this.destroy, this);
	    },
	
	    /**
	     * This method is called automatically by the Scene when it is starting up.
	     * It is responsible for creating local systems, properties and listening for Scene events.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.Scenes.ScenePlugin#pluginStart
	     * @private
	     * @since 3.5.0
	     */
	    pluginStart: function ()
	    {
	        this._target = null;
	
	        this.systems.events.once('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * Shutdown this Scene and run the given one.
	     *
	     * @method Phaser.Scenes.ScenePlugin#start
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to start.
	     * @param {object} [data] - The Scene data.
	     *
	     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
	     */
	    start: function (key, data)
	    {
	        if (key === undefined) { key = this.key; }
	
	        if (this.settings.status !== CONST.RUNNING)
	        {
	            this.manager.queueOp('stop', this.key);
	            this.manager.queueOp('start', key, data);
	        }
	        else
	        {
	            this.manager.stop(this.key);
	            this.manager.start(key, data);
	        }
	
	        return this;
	    },
	
	    /**
	     * Restarts this Scene.
	     *
	     * @method Phaser.Scenes.ScenePlugin#restart
	     * @since 3.4.0
	     * 
	     * @param {object} [data] - The Scene data.
	     *
	     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
	     */
	    restart: function (data)
	    {
	        var key = this.key;
	
	        if (this.settings.status !== CONST.RUNNING)
	        {
	            this.manager.queueOp('stop', key);
	            this.manager.queueOp('start', key, data);
	        }
	        else
	        {
	            this.manager.stop(key);
	            this.manager.start(key, data);
	        }
	
	        return this;
	    },
	
	    /**
	     * @typedef {object} Phaser.Scenes.ScenePlugin.SceneTransitionConfig
	     * 
	     * @property {string} target - The Scene key to transition to.
	     * @property {integer} [duration=1000] - The duration, in ms, for the transition to last.
	     * @property {boolean} [sleep=false] - Will the Scene responsible for the transition be sent to sleep on completion (`true`), or stopped? (`false`)
	     * @property {boolean} [allowInput=false] - Will the Scenes Input system be able to process events while it is transitioning in or out?
	     * @property {boolean} [moveAbove] - More the target Scene to be above this one before the transition starts.
	     * @property {boolean} [moveBelow] - More the target Scene to be below this one before the transition starts.
	     * @property {function} [onUpdate] - This callback is invoked every frame for the duration of the transition.
	     * @property {any} [onUpdateScope] - The context in which the callback is invoked.
	     * @property {any} [data] - An object containing any data you wish to be passed to the target Scenes init / create methods.
	     */
	
	    /**
	     * This will start a transition from the current Scene to the target Scene given.
	     * 
	     * The transition will last for the duration specified in milliseconds.
	     * 
	     * You can have the target Scene moved above or below this one in the display list.
	     * 
	     * You can specify an update callback. This callback will be invoked _every frame_ for the duration
	     * of the transition.
	     *
	     * This Scene can either be sent to sleep at the end of the transition, or stopped. The default is to stop.
	     * 
	     * There are also 5 transition related events: This scene will emit the event `transitionto` when
	     * the transition begins, which is typically the frame after calling this method.
	     * 
	     * The target Scene will emit the event `transitioninit` when that Scene's `init` method is called.
	     * It will then emit the event `transitionstart` when its `create` method is called.
	     * If the Scene was sleeping and has been woken up, it will emit the event `transitionwake` instead of these two,
	     * as the Scenes `init` and `create` methods are not invoked when a sleep wakes up.
	     * 
	     * When the duration of the transition has elapsed it will emit the event `transitioncomplete`.
	     * These events are all cleared of listeners when the Scene shuts down, but not if it is sent to sleep.
	     *
	     * It's important to understand that the duration of the transition begins the moment you call this method.
	     * If the Scene you are transitioning to includes delayed processes, such as waiting for files to load, the
	     * time still counts down even while that is happening. If the game itself pauses, or something else causes
	     * this Scenes update loop to stop, then the transition will also pause for that duration. There are
	     * checks in place to prevent you accidentally stopping a transitioning Scene but if you've got code to
	     * override this understand that until the target Scene completes it might never be unlocked for input events.
	     * 
	     * @method Phaser.Scenes.ScenePlugin#transition
	     * @since 3.5.0
	     *
	     * @param {Phaser.Scenes.ScenePlugin.SceneTransitionConfig} config - The transition configuration object.
	     *
	     * @return {boolean} `true` is the transition was started, otherwise `false`.
	     */
	    transition: function (config)
	    {
	        if (config === undefined) { config = {}; }
	
	        var key = GetFastValue(config, 'target', false);
	
	        var target = this.manager.getScene(key);
	
	        if (!key || !this.checkValidTransition(target))
	        {
	            return false;
	        }
	
	        var duration = GetFastValue(config, 'duration', 1000);
	
	        this._elapsed = 0;
	        this._target = target;
	        this._duration = duration;
	        this._willSleep = GetFastValue(config, 'sleep', false);
	        this._willRemove = GetFastValue(config, 'remove', false);
	
	        var callback = GetFastValue(config, 'onUpdate', null);
	
	        if (callback)
	        {
	            this._onUpdate = callback;
	            this._onUpdateScope = GetFastValue(config, 'onUpdateScope', this.scene);
	        }
	
	        var allowInput = GetFastValue(config, 'allowInput', false);
	
	        this.settings.transitionAllowInput = allowInput;
	
	        var targetSettings = target.sys.settings;
	
	        targetSettings.isTransition = true;
	        targetSettings.transitionFrom = this.scene;
	        targetSettings.transitionDuration = duration;
	        targetSettings.transitionAllowInput = allowInput;
	
	        if (GetFastValue(config, 'moveAbove', false))
	        {
	            this.manager.moveAbove(this.key, key);
	        }
	        else if (GetFastValue(config, 'moveBelow', false))
	        {
	            this.manager.moveBelow(this.key, key);
	        }
	
	        if (target.sys.isSleeping())
	        {
	            target.sys.wake();
	        }
	        else
	        {
	            this.manager.start(key, GetFastValue(config, 'data'));
	        }
	
	        this.systems.events.emit('transitionout', target, duration);
	
	        this.systems.events.on('update', this.step, this);
	
	        return true;
	    },
	
	    /**
	     * Checks to see if this Scene can transition to the target Scene or not.
	     *
	     * @method Phaser.Scenes.ScenePlugin#checkValidTransition
	     * @private
	     * @since 3.5.0
	     *
	     * @param {Phaser.Scene} target - The Scene to test against.
	     *
	     * @return {boolean} `true` if this Scene can transition, otherwise `false`.
	     */
	    checkValidTransition: function (target)
	    {
	        //  Not a valid target if it doesn't exist, isn't active or is already transitioning in or out
	        if (!target || target.sys.isActive() || target.sys.isTransitioning() || target === this.scene || this.systems.isTransitioning())
	        {
	            return false;
	        }
	
	        return true;
	    },
	
	    /**
	     * A single game step. This is only called if the parent Scene is transitioning
	     * out to another Scene.
	     *
	     * @method Phaser.Scenes.ScenePlugin#step
	     * @private
	     * @since 3.5.0
	     *
	     * @param {number} time - [description]
	     * @param {number} delta - [description]
	     */
	    step: function (time, delta)
	    {
	        this._elapsed += delta;
	
	        this.transitionProgress = Clamp(this._elapsed / this._duration, 0, 1);
	
	        if (this._onUpdate)
	        {
	            this._onUpdate.call(this._onUpdateScope, this.transitionProgress);
	        }
	
	        if (this._elapsed >= this._duration)
	        {
	            this.transitionComplete();
	        }
	    },
	
	    /**
	     * Called by `step` when the transition out of this scene to another is over.
	     *
	     * @method Phaser.Scenes.ScenePlugin#transitionComplete
	     * @private
	     * @since 3.5.0
	     */
	    transitionComplete: function ()
	    {
	        var targetSys = this._target.sys;
	        var targetSettings = this._target.sys.settings;
	
	        //  Stop the step
	        this.systems.events.off('update', this.step, this);
	
	        //  Notify target scene
	        targetSys.events.emit('transitioncomplete', this.scene);
	
	        //  Clear target scene settings
	        targetSettings.isTransition = false;
	        targetSettings.transitionFrom = null;
	
	        //  Clear local settings
	        this._duration = 0;
	        this._target = null;
	        this._onUpdate = null;
	        this._onUpdateScope = null;
	
	        //  Now everything is clear we can handle what happens to this Scene
	        if (this._willRemove)
	        {
	            this.manager.remove(this.key);
	        }
	        else if (this._willSleep)
	        {
	            this.systems.sleep();
	        }
	        else
	        {
	            this.manager.stop(this.key);
	        }
	    },
	
	    /**
	     * Add the Scene into the Scene Manager and start it if 'autoStart' is true or the Scene config 'active' property is set.
	     *
	     * @method Phaser.Scenes.ScenePlugin#add
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene key.
	     * @param {(Phaser.Scene|Phaser.Scenes.Settings.Config|function)} sceneConfig - The config for the Scene.
	     * @param {boolean} autoStart - Whether to start the Scene after it's added.
	     *
	     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
	     */
	    add: function (key, sceneConfig, autoStart)
	    {
	        this.manager.add(key, sceneConfig, autoStart);
	
	        return this;
	    },
	
	    /**
	     * Launch the given Scene and run it in parallel with this one.
	     *
	     * @method Phaser.Scenes.ScenePlugin#launch
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to launch.
	     * @param {object} [data] - The Scene data.
	     *
	     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
	     */
	    launch: function (key, data)
	    {
	        if (key && key !== this.key)
	        {
	            if (this.settings.status !== CONST.RUNNING)
	            {
	                this.manager.queueOp('start', key, data);
	            }
	            else
	            {
	                this.manager.start(key, data);
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Pause the Scene - this stops the update step from happening but it still renders.
	     *
	     * @method Phaser.Scenes.ScenePlugin#pause
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to pause.
	     *
	     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
	     */
	    pause: function (key)
	    {
	        if (key === undefined) { key = this.key; }
	
	        this.manager.pause(key);
	
	        return this;
	    },
	
	    /**
	     * Resume the Scene - starts the update loop again.
	     *
	     * @method Phaser.Scenes.ScenePlugin#resume
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to resume.
	     *
	     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
	     */
	    resume: function (key)
	    {
	        if (key === undefined) { key = this.key; }
	
	        this.manager.resume(key);
	
	        return this;
	    },
	
	    /**
	     * Makes the Scene sleep (no update, no render) but doesn't shutdown.
	     *
	     * @method Phaser.Scenes.ScenePlugin#sleep
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to put to sleep.
	     *
	     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
	     */
	    sleep: function (key)
	    {
	        if (key === undefined) { key = this.key; }
	
	        this.manager.sleep(key);
	
	        return this;
	    },
	
	    /**
	     * Makes the Scene wake-up (starts update and render)
	     *
	     * @method Phaser.Scenes.ScenePlugin#wake
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to wake up.
	     *
	     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
	     */
	    wake: function (key)
	    {
	        if (key === undefined) { key = this.key; }
	
	        this.manager.wake(key);
	
	        return this;
	    },
	
	    /**
	     * Makes this Scene sleep then starts the Scene given.
	     *
	     * @method Phaser.Scenes.ScenePlugin#switch
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to start.
	     *
	     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
	     */
	    switch: function (key)
	    {
	        if (key !== this.key)
	        {
	            if (this.settings.status !== CONST.RUNNING)
	            {
	                this.manager.queueOp('switch', this.key, key);
	            }
	            else
	            {
	                this.manager.switch(this.key, key);
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Shutdown the Scene, clearing display list, timers, etc.
	     *
	     * @method Phaser.Scenes.ScenePlugin#stop
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to stop.
	     *
	     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
	     */
	    stop: function (key)
	    {
	        if (key === undefined) { key = this.key; }
	
	        this.manager.stop(key);
	
	        return this;
	    },
	
	    /**
	     * Sets the active state of the given Scene.
	     *
	     * @method Phaser.Scenes.ScenePlugin#setActive
	     * @since 3.0.0
	     *
	     * @param {boolean} value - The active value.
	     * @param {string} [key] - The Scene to set the active state for.
	     *
	     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
	     */
	    setActive: function (value, key)
	    {
	        if (key === undefined) { key = this.key; }
	
	        var scene = this.manager.getScene(key);
	
	        if (scene)
	        {
	            scene.sys.setActive(value);
	        }
	
	        return this;
	    },
	
	    /**
	     * Sets the visible state of the given Scene.
	     *
	     * @method Phaser.Scenes.ScenePlugin#setVisible
	     * @since 3.0.0
	     *
	     * @param {boolean} value - The visible value.
	     * @param {string} [key] - The Scene to set the visible state for.
	     *
	     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
	     */
	    setVisible: function (value, key)
	    {
	        if (key === undefined) { key = this.key; }
	
	        var scene = this.manager.getScene(key);
	
	        if (scene)
	        {
	            scene.sys.setVisible(value);
	        }
	
	        return this;
	    },
	
	    /**
	     * Checks if the given Scene is sleeping or not?
	     *
	     * @method Phaser.Scenes.ScenePlugin#isSleeping
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to check.
	     *
	     * @return {boolean} Whether the Scene is sleeping.
	     */
	    isSleeping: function (key)
	    {
	        if (key === undefined) { key = this.key; }
	
	        return this.manager.isSleeping(key);
	    },
	
	    /**
	     * Checks if the given Scene is active or not?
	     *
	     * @method Phaser.Scenes.ScenePlugin#isActive
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to check.
	     *
	     * @return {boolean} Whether the Scene is active.
	     */
	    isActive: function (key)
	    {
	        if (key === undefined) { key = this.key; }
	
	        return this.manager.isActive(key);
	    },
	
	    /**
	     * Checks if the given Scene is visible or not?
	     *
	     * @method Phaser.Scenes.ScenePlugin#isVisible
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to check.
	     *
	     * @return {boolean} Whether the Scene is visible.
	     */
	    isVisible: function (key)
	    {
	        if (key === undefined) { key = this.key; }
	
	        return this.manager.isVisible(key);
	    },
	
	    /**
	     * Swaps the position of two scenes in the Scenes list.
	     *
	     * This controls the order in which they are rendered and updated.
	     *
	     * @method Phaser.Scenes.ScenePlugin#swapPosition
	     * @since 3.2.0
	     *
	     * @param {string} keyA - The first Scene to swap.
	     * @param {string} [keyB] - The second Scene to swap. If none is given it defaults to this Scene.
	     *
	     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
	     */
	    swapPosition: function (keyA, keyB)
	    {
	        if (keyB === undefined) { keyB = this.key; }
	
	        if (keyA !== keyB)
	        {
	            this.manager.swapPosition(keyA, keyB);
	        }
	
	        return this;
	    },
	
	    /**
	     * Swaps the position of two scenes in the Scenes list, so that Scene B is directly above Scene A.
	     *
	     * This controls the order in which they are rendered and updated.
	     *
	     * @method Phaser.Scenes.ScenePlugin#moveAbove
	     * @since 3.2.0
	     *
	     * @param {string} keyA - The Scene that Scene B will be moved to be above.
	     * @param {string} [keyB] - The Scene to be moved. If none is given it defaults to this Scene.
	     *
	     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
	     */
	    moveAbove: function (keyA, keyB)
	    {
	        if (keyB === undefined) { keyB = this.key; }
	
	        if (keyA !== keyB)
	        {
	            this.manager.moveAbove(keyA, keyB);
	        }
	
	        return this;
	    },
	
	    /**
	     * Swaps the position of two scenes in the Scenes list, so that Scene B is directly below Scene A.
	     *
	     * This controls the order in which they are rendered and updated.
	     *
	     * @method Phaser.Scenes.ScenePlugin#moveBelow
	     * @since 3.2.0
	     *
	     * @param {string} keyA - The Scene that Scene B will be moved to be below.
	     * @param {string} [keyB] - The Scene to be moved. If none is given it defaults to this Scene.
	     *
	     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
	     */
	    moveBelow: function (keyA, keyB)
	    {
	        if (keyB === undefined) { keyB = this.key; }
	
	        if (keyA !== keyB)
	        {
	            this.manager.moveBelow(keyA, keyB);
	        }
	
	        return this;
	    },
	
	    /**
	     * Removes a Scene from the SceneManager.
	     *
	     * The Scene is removed from the local scenes array, it's key is cleared from the keys
	     * cache and Scene.Systems.destroy is then called on it.
	     *
	     * If the SceneManager is processing the Scenes when this method is called it wil
	     * queue the operation for the next update sequence.
	     *
	     * @method Phaser.Scenes.ScenePlugin#remove
	     * @since 3.2.0
	     *
	     * @param {(string|Phaser.Scene)} key - The Scene to be removed.
	     *
	     * @return {Phaser.Scenes.SceneManager} This SceneManager.
	     */
	    remove: function (key)
	    {
	        if (key === undefined) { key = this.key; }
	
	        this.manager.remove(key);
	
	        return this;
	    },
	
	    /**
	     * Moves a Scene up one position in the Scenes list.
	     *
	     * @method Phaser.Scenes.ScenePlugin#moveUp
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to move.
	     *
	     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
	     */
	    moveUp: function (key)
	    {
	        if (key === undefined) { key = this.key; }
	
	        this.manager.moveUp(key);
	
	        return this;
	    },
	
	    /**
	     * Moves a Scene down one position in the Scenes list.
	     *
	     * @method Phaser.Scenes.ScenePlugin#moveDown
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to move.
	     *
	     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
	     */
	    moveDown: function (key)
	    {
	        if (key === undefined) { key = this.key; }
	
	        this.manager.moveDown(key);
	
	        return this;
	    },
	
	    /**
	     * Brings a Scene to the top of the Scenes list.
	     *
	     * This means it will render above all other Scenes.
	     *
	     * @method Phaser.Scenes.ScenePlugin#bringToTop
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to move.
	     *
	     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
	     */
	    bringToTop: function (key)
	    {
	        if (key === undefined) { key = this.key; }
	
	        this.manager.bringToTop(key);
	
	        return this;
	    },
	
	    /**
	     * Sends a Scene to the back of the Scenes list.
	     *
	     * This means it will render below all other Scenes.
	     *
	     * @method Phaser.Scenes.ScenePlugin#sendToBack
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to move.
	     *
	     * @return {Phaser.Scenes.ScenePlugin} This ScenePlugin object.
	     */
	    sendToBack: function (key)
	    {
	        if (key === undefined) { key = this.key; }
	
	        this.manager.sendToBack(key);
	
	        return this;
	    },
	
	    /**
	     * Retrieve a Scene.
	     *
	     * @method Phaser.Scenes.ScenePlugin#get
	     * @since 3.0.0
	     *
	     * @param {string} key - The Scene to retrieve.
	     *
	     * @return {Phaser.Scene} The Scene.
	     */
	    get: function (key)
	    {
	        return this.manager.getScene(key);
	    },
	
	    /**
	     * Retrieves the numeric index of a Scene in the Scenes list.
	     *
	     * @method Phaser.Scenes.ScenePlugin#getIndex
	     * @since 3.7.0
	     *
	     * @param {(string|Phaser.Scene)} [key] - The Scene to get the index of.
	     *
	     * @return {integer} The index of the Scene.
	     */
	    getIndex: function (key)
	    {
	        if (key === undefined) { key = this.key; }
	
	        return this.manager.getIndex(key);
	    },
	
	    /**
	     * The Scene that owns this plugin is shutting down.
	     * We need to kill and reset all internal properties as well as stop listening to Scene events.
	     *
	     * @method Phaser.Scenes.ScenePlugin#shutdown
	     * @private
	     * @since 3.0.0
	     */
	    shutdown: function ()
	    {
	        var eventEmitter = this.systems.events;
	
	        eventEmitter.off('shutdown', this.shutdown, this);
	        eventEmitter.off('postupdate', this.step, this);
	        eventEmitter.off('transitionout');
	    },
	
	    /**
	     * The Scene that owns this plugin is being destroyed.
	     * We need to shutdown and then kill off all external references.
	     *
	     * @method Phaser.Scenes.ScenePlugin#destroy
	     * @private
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.shutdown();
	
	        this.scene.sys.events.off('start', this.start, this);
	
	        this.scene = null;
	        this.systems = null;
	        this.settings = null;
	        this.manager = null;
	    }
	
	});
	
	PluginCache.register('ScenePlugin', ScenePlugin, 'scenePlugin');
	
	module.exports = ScenePlugin;


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CONST = __webpack_require__(168);
	var Extend = __webpack_require__(36);
	
	/**
	 * @namespace Phaser.Scenes
	 */
	
	var Scene = {
	
	    SceneManager: __webpack_require__(623),
	    ScenePlugin: __webpack_require__(1516),
	    Settings: __webpack_require__(624),
	    Systems: __webpack_require__(325)
	
	};
	
	//   Merge in the consts
	Scene = Extend(false, Scene, CONST);
	
	module.exports = Scene;


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @author       Pavle Goloskokovic <pgoloskokovic@gmail.com> (http://prunegames.com)
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Sound
	 */
	
	/**
	 * Config object containing various sound settings.
	 *
	 * @typedef {object} SoundConfig
	 *
	 * @property {boolean} [mute=false] - Boolean indicating whether the sound should be muted or not.
	 * @property {number} [volume=1] - A value between 0 (silence) and 1 (full volume).
	 * @property {number} [rate=1] - Defines the speed at which the sound should be played.
	 * @property {number} [detune=0] - Represents detuning of sound in [cents](https://en.wikipedia.org/wiki/Cent_%28music%29).
	 * @property {number} [seek=0] - Position of playback for this sound, in seconds.
	 * @property {boolean} [loop=false] - Whether or not the sound or current sound marker should loop.
	 * @property {number} [delay=0] - Time, in seconds, that should elapse before the sound actually starts its playback.
	 */
	
	/**
	 * Marked section of a sound represented by name, and optionally start time, duration, and config object.
	 *
	 * @typedef {object} SoundMarker
	 *
	 * @property {string} name - Unique identifier of a sound marker.
	 * @property {number} [start=0] - Sound position offset at witch playback should start.
	 * @property {number} [duration] - Playback duration of this marker.
	 * @property {SoundConfig} [config] - An optional config object containing default marker settings.
	 */
	
	module.exports = {
	
	    SoundManagerCreator: __webpack_require__(625),
	
	    BaseSound: __webpack_require__(208),
	    BaseSoundManager: __webpack_require__(209),
	
	    WebAudioSound: __webpack_require__(630),
	    WebAudioSoundManager: __webpack_require__(631),
	
	    HTML5AudioSound: __webpack_require__(626),
	    HTML5AudioSoundManager: __webpack_require__(627),
	
	    NoAudioSound: __webpack_require__(628),
	    NoAudioSoundManager: __webpack_require__(629)
	
	};


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Structs
	 */
	
	module.exports = {
	
	    List: __webpack_require__(210),
	    Map: __webpack_require__(326),
	    ProcessQueue: __webpack_require__(632),
	    RTree: __webpack_require__(633),
	    Set: __webpack_require__(146)
	
	};


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var IsSizePowerOfTwo = __webpack_require__(203);
	var Texture = __webpack_require__(328);
	
	/**
	 * @classdesc
	 * A Canvas Texture is a special kind of Texture that is backed by an HTML Canvas Element as its source.
	 *
	 * You can use the properties of this texture to draw to the canvas element directly, using all of the standard
	 * canvas operations available in the browser. Any Game Object can be given this texture and will render with it.
	 *
	 * Note: When running under WebGL the Canvas Texture needs to re-generate its base WebGLTexture and reupload it to
	 * the GPU every time you modify it, otherwise the changes you make to this texture will not be visible. To do this
	 * you should call `CanvasTexture.refresh()` once you are finished with your changes to the canvas. Try and keep
	 * this to a minimum, especially on large canvas sizes, or you may inadvertently thrash the GPU by constantly uploading
	 * texture data to it. This restriction does not apply if using the Canvas Renderer.
	 * 
	 * It starts with only one frame that covers the whole of the canvas. You can add further frames, that specify
	 * sections of the canvas using the `add` method.
	 * 
	 * Should you need to resize the canvas use the `setSize` method so that it accurately updates all of the underlying
	 * texture data as well. Forgetting to do this (i.e. by changing the canvas size directly from your code) could cause
	 * graphical errors.
	 *
	 * @class CanvasTexture
	 * @extends Phaser.Textures.Texture
	 * @memberOf Phaser.Textures
	 * @constructor
	 * @since 3.7.0
	 *
	 * @param {Phaser.Textures.TextureManager} manager - A reference to the Texture Manager this Texture belongs to.
	 * @param {string} key - The unique string-based key of this Texture.
	 * @param {HTMLCanvasElement} source - The canvas element that is used as the base of this texture.
	 * @param {integer} width - The width of the canvas.
	 * @param {integer} height - The height of the canvas.
	 */
	var CanvasTexture = new Class({
	
	    Extends: Texture,
	
	    initialize:
	
	    function CanvasTexture (manager, key, source, width, height)
	    {
	        Texture.call(this, manager, key, source, width, height);
	
	        this.add('__BASE', 0, 0, 0, width, height);
	
	        /**
	         * A reference to the Texture Source of this Canvas.
	         *
	         * @name Phaser.Textures.TextureManager#_source
	         * @type {Phaser.Textures.TextureSource}
	         * @private
	         * @since 3.7.0
	         */
	        this._source = this.frames['__BASE'].source;
	
	        /**
	         * The source Canvas Element.
	         *
	         * @name Phaser.Textures.TextureManager#canvas
	         * @readOnly
	         * @type {HTMLCanvasElement}
	         * @since 3.7.0
	         */
	        this.canvas = this._source.image;
	
	        /**
	         * The 2D Canvas Rendering Context.
	         *
	         * @name Phaser.Textures.TextureManager#canvas
	         * @readOnly
	         * @type {CanvasRenderingContext2D}
	         * @since 3.7.0
	         */
	        this.context = this.canvas.getContext('2d');
	
	        /**
	         * The width of the Canvas.
	         * This property is read-only, if you wish to change use `setSize`.
	         *
	         * @name Phaser.Textures.TextureManager#width
	         * @readOnly
	         * @type {integer}
	         * @since 3.7.0
	         */
	        this.width = width;
	
	        /**
	         * The height of the Canvas.
	         * This property is read-only, if you wish to change use `setSize`.
	         *
	         * @name Phaser.Textures.TextureManager#height
	         * @readOnly
	         * @type {integer}
	         * @since 3.7.0
	         */
	        this.height = height;
	    },
	
	    /**
	     * This should be called manually if you are running under WebGL.
	     * It will refresh the WebGLTexture from the Canvas source. Only call this if you know that the
	     * canvas has changed, as there is a significant GPU texture allocation cost involved in doing so.
	     *
	     * @method Phaser.Textures.CanvasTexture#refresh
	     * @since 3.7.0
	     *
	     * @return {Phaser.Textures.CanvasTexture} This CanvasTexture.
	     */
	    refresh: function ()
	    {
	        this._source.update();
	
	        return this;
	    },
	
	    /**
	     * Gets the Canvas Element.
	     *
	     * @method Phaser.Textures.CanvasTexture#getCanvas
	     * @since 3.7.0
	     *
	     * @return {HTMLCanvasElement} The Canvas DOM element this texture is using.
	     */
	    getCanvas: function ()
	    {
	        return this.canvas;
	    },
	
	    /**
	     * Gets the 2D Canvas Rendering Context.
	     *
	     * @method Phaser.Textures.CanvasTexture#getContext
	     * @since 3.7.0
	     *
	     * @return {CanvasRenderingContext2D} The Canvas Rendering Context this texture is using.
	     */
	    getContext: function ()
	    {
	        return this.context;
	    },
	
	    /**
	     * Clears this Canvas Texture, resetting it back to transparent.
	     *
	     * @method Phaser.Textures.CanvasTexture#clear
	     * @since 3.7.0
	     *
	     * @return {Phaser.Textures.CanvasTexture} The Canvas Texture.
	     */
	    clear: function ()
	    {
	        this.context.clearRect(0, 0, this.width, this.height);
	
	        return this;
	    },
	
	    /**
	     * Changes the size of this Canvas Texture.
	     *
	     * @method Phaser.Textures.CanvasTexture#setSize
	     * @since 3.7.0
	     *
	     * @param {integer} width - The new width of the Canvas.
	     * @param {integer} [height] - The new height of the Canvas. If not given it will use the width as the height.
	     *
	     * @return {Phaser.Textures.CanvasTexture} The Canvas Texture.
	     */
	    setSize: function (width, height)
	    {
	        if (height === undefined) { height = width; }
	
	        if (width !== this.width || height !== this.height)
	        {
	            //  Update the Canvas
	            this.canvas.width = width;
	            this.canvas.height = height;
	
	            //  Update the Texture Source
	            this._source.width = width;
	            this._source.height = height;
	            this._source.isPowerOf2 = IsSizePowerOfTwo(width, height);
	
	            //  Update the Frame
	            this.frames['__BASE'].setSize(width, height, 0, 0);
	
	            this.refresh();
	        }
	
	        return this;
	    }
	
	});
	
	module.exports = CanvasTexture;


/***/ }),
/* 1521 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Filter Types.
	 *
	 * @name Phaser.Textures.FilterMode
	 * @enum {integer}
	 * @memberOf Phaser.Textures
	 * @readOnly
	 * @since 3.0.0
	 */
	var CONST = {
	
	    /**
	     * Linear filter type.
	     * 
	     * @name Phaser.Textures.FilterMode.LINEAR
	     */
	    LINEAR: 0,
	
	    /**
	     * Nearest neighbor filter type.
	     * 
	     * @name Phaser.Textures.FilterMode.NEAREST
	     */
	    NEAREST: 1
	    
	};
	
	module.exports = CONST;


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Extend = __webpack_require__(36);
	var FilterMode = __webpack_require__(1521);
	
	/**
	 * @namespace Phaser.Textures
	 */
	
	/**
	 * Linear filter type.
	 * 
	 * @name Phaser.Textures.LINEAR
	 * @constant
	 */
	
	/**
	 * Nearest Neighbor filter type.
	 * 
	 * @name Phaser.Textures.NEAREST
	 * @constant
	 */
	
	var Textures = {
	
	    FilterMode: FilterMode,
	    Frame: __webpack_require__(327),
	    Parsers: __webpack_require__(636),
	    Texture: __webpack_require__(328),
	    TextureManager: __webpack_require__(634),
	    TextureSource: __webpack_require__(635)
	
	};
	
	Textures = Extend(false, Textures, FilterMode);
	
	module.exports = Textures;


/***/ }),
/* 1523 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Parses an XML Texture Atlas object and adds all the Frames into a Texture.
	 *
	 * @function Phaser.Textures.Parsers.AtlasXML
	 * @memberOf Phaser.Textures.Parsers
	 * @private
	 * @since 3.7.0
	 *
	 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
	 * @param {integer} sourceIndex - The index of the TextureSource.
	 * @param {*} xml - The XML data.
	 *
	 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
	 */
	var AtlasXML = function (texture, sourceIndex, xml)
	{
	    //  Malformed?
	    if (!xml.getElementsByTagName('TextureAtlas'))
	    {
	        console.warn('Invalid Texture Atlas XML given');
	        return;
	    }
	
	    //  Add in a __BASE entry (for the entire atlas)
	    var source = texture.source[sourceIndex];
	
	    texture.add('__BASE', sourceIndex, 0, 0, source.width, source.height);
	
	    //  By this stage frames is a fully parsed array
	    var frames = xml.getElementsByTagName('SubTexture');
	
	    var newFrame;
	
	    for (var i = 0; i < frames.length; i++)
	    {
	        var frame = frames[i].attributes;
	
	        var name = frame.name.value;
	        var x = parseInt(frame.x.value, 10);
	        var y = parseInt(frame.y.value, 10);
	        var width = parseInt(frame.width.value, 10);
	        var height = parseInt(frame.height.value, 10);
	
	        //  The frame values are the exact coordinates to cut the frame out of the atlas from
	        newFrame = texture.add(name, sourceIndex, x, y, width, height);
	
	        //  These are the original (non-trimmed) sprite values
	        if (frame.frameX)
	        {
	            var frameX = Math.abs(parseInt(frame.frameX.value, 10));
	            var frameY = Math.abs(parseInt(frame.frameY.value, 10));
	            var frameWidth = parseInt(frame.frameWidth.value, 10);
	            var frameHeight = parseInt(frame.frameHeight.value, 10);
	
	            newFrame.setTrim(
	                width,
	                height,
	                frameX,
	                frameY,
	                frameWidth,
	                frameHeight
	            );
	        }
	    }
	
	    return texture;
	};
	
	module.exports = AtlasXML;


/***/ }),
/* 1524 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Adds a Canvas Element to a Texture.
	 *
	 * @function Phaser.Textures.Parsers.Canvas
	 * @memberOf Phaser.Textures.Parsers
	 * @private
	 * @since 3.0.0
	 *
	 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
	 * @param {integer} sourceIndex - The index of the TextureSource.
	 *
	 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
	 */
	var Canvas = function (texture, sourceIndex)
	{
	    var source = texture.source[sourceIndex];
	
	    texture.add('__BASE', sourceIndex, 0, 0, source.width, source.height);
	
	    return texture;
	};
	
	module.exports = Canvas;


/***/ }),
/* 1525 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Adds an Image Element to a Texture.
	 *
	 * @function Phaser.Textures.Parsers.Image
	 * @memberOf Phaser.Textures.Parsers
	 * @private
	 * @since 3.0.0
	 *
	 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
	 * @param {integer} sourceIndex - The index of the TextureSource.
	 *
	 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
	 */
	var Image = function (texture, sourceIndex)
	{
	    var source = texture.source[sourceIndex];
	
	    texture.add('__BASE', sourceIndex, 0, 0, source.width, source.height);
	
	    return texture;
	};
	
	module.exports = Image;


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Clone = __webpack_require__(123);
	
	/**
	 * Parses a Texture Atlas JSON Array and adds the Frames to the Texture.
	 * JSON format expected to match that defined by Texture Packer, with the frames property containing an array of Frames.
	 *
	 * @function Phaser.Textures.Parsers.JSONArray
	 * @memberOf Phaser.Textures.Parsers
	 * @private
	 * @since 3.0.0
	 *
	 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
	 * @param {integer} sourceIndex - The index of the TextureSource.
	 * @param {object} json - The JSON data.
	 *
	 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
	 */
	var JSONArray = function (texture, sourceIndex, json)
	{
	    //  Malformed?
	    if (!json['frames'] && !json['textures'])
	    {
	        console.warn('Invalid Texture Atlas JSON Array');
	        return;
	    }
	
	    //  Add in a __BASE entry (for the entire atlas)
	    var source = texture.source[sourceIndex];
	
	    texture.add('__BASE', sourceIndex, 0, 0, source.width, source.height);
	
	    //  By this stage frames is a fully parsed array
	    var frames = (Array.isArray(json.textures)) ? json.textures[sourceIndex].frames : json.frames;
	
	    var newFrame;
	
	    for (var i = 0; i < frames.length; i++)
	    {
	        var src = frames[i];
	
	        //  The frame values are the exact coordinates to cut the frame out of the atlas from
	        newFrame = texture.add(src.filename, sourceIndex, src.frame.x, src.frame.y, src.frame.w, src.frame.h);
	
	        //  These are the original (non-trimmed) sprite values
	        if (src.trimmed)
	        {
	            newFrame.setTrim(
	                src.sourceSize.w,
	                src.sourceSize.h,
	                src.spriteSourceSize.x,
	                src.spriteSourceSize.y,
	                src.spriteSourceSize.w,
	                src.spriteSourceSize.h
	            );
	        }
	
	        if (src.rotated)
	        {
	            newFrame.rotated = true;
	            newFrame.updateUVsInverted();
	        }
	
	        if (src.anchor)
	        {
	            newFrame.customPivot = true;
	            newFrame.pivotX = src.anchor.x;
	            newFrame.pivotY = src.anchor.y;
	        }
	
	        //  Copy over any extra data
	        newFrame.customData = Clone(src);
	    }
	
	    //  Copy over any additional data that was in the JSON to Texture.customData
	    for (var dataKey in json)
	    {
	        if (dataKey === 'frames')
	        {
	            continue;
	        }
	
	        if (Array.isArray(json[dataKey]))
	        {
	            texture.customData[dataKey] = json[dataKey].slice(0);
	        }
	        else
	        {
	            texture.customData[dataKey] = json[dataKey];
	        }
	    }
	
	    return texture;
	};
	
	module.exports = JSONArray;


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Clone = __webpack_require__(123);
	
	/**
	 * Parses a Texture Atlas JSON Hash and adds the Frames to the Texture.
	 * JSON format expected to match that defined by Texture Packer, with the frames property containing an object of Frames.
	 *
	 * @function Phaser.Textures.Parsers.JSONHash
	 * @memberOf Phaser.Textures.Parsers
	 * @private
	 * @since 3.0.0
	 *
	 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
	 * @param {integer} sourceIndex - The index of the TextureSource.
	 * @param {object} json - The JSON data.
	 *
	 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
	 */
	var JSONHash = function (texture, sourceIndex, json)
	{
	    //  Malformed?
	    if (!json['frames'])
	    {
	        console.warn('Invalid Texture Atlas JSON Hash given, missing \'frames\' Object');
	        return;
	    }
	
	    //  Add in a __BASE entry (for the entire atlas)
	    var source = texture.source[sourceIndex];
	
	    texture.add('__BASE', sourceIndex, 0, 0, source.width, source.height);
	
	    //  By this stage frames is a fully parsed Object
	    var frames = json['frames'];
	    var newFrame;
	
	    for (var key in frames)
	    {
	        var src = frames[key];
	
	        //  The frame values are the exact coordinates to cut the frame out of the atlas from
	        newFrame = texture.add(key, sourceIndex, src.frame.x, src.frame.y, src.frame.w, src.frame.h);
	
	        //  These are the original (non-trimmed) sprite values
	        if (src.trimmed)
	        {
	            newFrame.setTrim(
	                src.sourceSize.w,
	                src.sourceSize.h,
	                src.spriteSourceSize.x,
	                src.spriteSourceSize.y,
	                src.spriteSourceSize.w,
	                src.spriteSourceSize.h
	            );
	        }
	
	        if (src.rotated)
	        {
	            newFrame.rotated = true;
	            newFrame.updateUVsInverted();
	        }
	
	        //  Copy over any extra data
	        newFrame.customData = Clone(src);
	    }
	
	    //  Copy over any additional data that was in the JSON to Texture.customData
	    for (var dataKey in json)
	    {
	        if (dataKey === 'frames')
	        {
	            continue;
	        }
	
	        if (Array.isArray(json[dataKey]))
	        {
	            texture.customData[dataKey] = json[dataKey].slice(0);
	        }
	        else
	        {
	            texture.customData[dataKey] = json[dataKey];
	        }
	    }
	
	    return texture;
	};
	
	module.exports = JSONHash;


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetFastValue = __webpack_require__(3);
	
	/**
	 * Parses a Sprite Sheet and adds the Frames to the Texture.
	 * 
	 * In Phaser terminology a Sprite Sheet is a texture containing different frames, but each frame is the exact
	 * same size and cannot be trimmed or rotated.
	 *
	 * @function Phaser.Textures.Parsers.SpriteSheet
	 * @memberOf Phaser.Textures.Parsers
	 * @private
	 * @since 3.0.0
	 *
	 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
	 * @param {integer} sourceIndex - The index of the TextureSource.
	 * @param {integer} x - [description]
	 * @param {integer} y - [description]
	 * @param {integer} width - [description]
	 * @param {integer} height - [description]
	 * @param {object} config - An object describing how to parse the Sprite Sheet.
	 * @param {number} config.frameWidth - Width in pixels of a single frame in the sprite sheet.
	 * @param {number} [config.frameHeight] - Height in pixels of a single frame in the sprite sheet. Defaults to frameWidth if not provided.
	 * @param {number} [config.startFrame=0] - [description]
	 * @param {number} [config.endFrame=-1] - [description]
	 * @param {number} [config.margin=0] - If the frames have been drawn with a margin, specify the amount here.
	 * @param {number} [config.spacing=0] - If the frames have been drawn with spacing between them, specify the amount here.
	 *
	 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
	 */
	var SpriteSheet = function (texture, sourceIndex, x, y, width, height, config)
	{
	    var frameWidth = GetFastValue(config, 'frameWidth', null);
	    var frameHeight = GetFastValue(config, 'frameHeight', frameWidth);
	
	    //  If missing we can't proceed
	    if (frameWidth === null)
	    {
	        throw new Error('TextureManager.SpriteSheet: Invalid frameWidth given.');
	    }
	
	    //  Add in a __BASE entry (for the entire atlas)
	    var source = texture.source[sourceIndex];
	
	    texture.add('__BASE', sourceIndex, 0, 0, source.width, source.height);
	
	    var startFrame = GetFastValue(config, 'startFrame', 0);
	    var endFrame = GetFastValue(config, 'endFrame', -1);
	    var margin = GetFastValue(config, 'margin', 0);
	    var spacing = GetFastValue(config, 'spacing', 0);
	
	    var row = Math.floor((width - margin + spacing) / (frameWidth + spacing));
	    var column = Math.floor((height - margin + spacing) / (frameHeight + spacing));
	    var total = row * column;
	
	    if (startFrame > total || startFrame < -total)
	    {
	        startFrame = 0;
	    }
	
	    if (startFrame < 0)
	    {
	        //  Allow negative skipframes.
	        startFrame = total + startFrame;
	    }
	
	    if (endFrame !== -1)
	    {
	        total = startFrame + (endFrame + 1);
	    }
	
	    var fx = margin;
	    var fy = margin;
	    var ax = 0;
	    var ay = 0;
	
	    for (var i = 0; i < total; i++)
	    {
	        ax = 0;
	        ay = 0;
	
	        var w = fx + frameWidth;
	        var h = fy + frameHeight;
	
	        if (w > width)
	        {
	            ax = w - width;
	        }
	
	        if (h > height)
	        {
	            ay = h - height;
	        }
	
	        texture.add(i, sourceIndex, x + fx, y + fy, frameWidth - ax, frameHeight - ay);
	
	        fx += frameWidth + spacing;
	
	        if (fx + frameWidth > width)
	        {
	            fx = margin;
	            fy += frameHeight + spacing;
	        }
	    }
	
	    return texture;
	};
	
	module.exports = SpriteSheet;


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetFastValue = __webpack_require__(3);
	
	/**
	 * Parses a Sprite Sheet and adds the Frames to the Texture, where the Sprite Sheet is stored as a frame within an Atlas.
	 *
	 * In Phaser terminology a Sprite Sheet is a texture containing different frames, but each frame is the exact
	 * same size and cannot be trimmed or rotated.
	 *
	 * @function Phaser.Textures.Parsers.SpriteSheetFromAtlas
	 * @memberOf Phaser.Textures.Parsers
	 * @private
	 * @since 3.0.0
	 *
	 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
	 * @param {Phaser.Textures.Frame} frame - The Frame that contains the Sprite Sheet.
	 * @param {object} config - An object describing how to parse the Sprite Sheet.
	 * @param {number} config.frameWidth - Width in pixels of a single frame in the sprite sheet.
	 * @param {number} [config.frameHeight] - Height in pixels of a single frame in the sprite sheet. Defaults to frameWidth if not provided.
	 * @param {number} [config.startFrame=0] - [description]
	 * @param {number} [config.endFrame=-1] - [description]
	 * @param {number} [config.margin=0] - If the frames have been drawn with a margin, specify the amount here.
	 * @param {number} [config.spacing=0] - If the frames have been drawn with spacing between them, specify the amount here.
	 *
	 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
	 */
	var SpriteSheetFromAtlas = function (texture, frame, config)
	{
	    var frameWidth = GetFastValue(config, 'frameWidth', null);
	    var frameHeight = GetFastValue(config, 'frameHeight', frameWidth);
	
	    //  If missing we can't proceed
	    if (!frameWidth)
	    {
	        throw new Error('TextureManager.SpriteSheetFromAtlas: Invalid frameWidth given.');
	    }
	
	    //  Add in a __BASE entry (for the entire atlas)
	    // var source = texture.source[sourceIndex];
	    // texture.add('__BASE', sourceIndex, 0, 0, source.width, source.height);
	
	    var startFrame = GetFastValue(config, 'startFrame', 0);
	    var endFrame = GetFastValue(config, 'endFrame', -1);
	    var margin = GetFastValue(config, 'margin', 0);
	    var spacing = GetFastValue(config, 'spacing', 0);
	
	    var x = frame.cutX;
	    var y = frame.cutY;
	
	    var cutWidth = frame.cutWidth;
	    var cutHeight = frame.cutHeight;
	    var sheetWidth = frame.realWidth;
	    var sheetHeight = frame.realHeight;
	
	    var row = Math.floor((sheetWidth - margin + spacing) / (frameWidth + spacing));
	    var column = Math.floor((sheetHeight - margin + spacing) / (frameHeight + spacing));
	    var total = row * column;
	
	    //  trim offsets
	
	    var leftPad = frame.x;
	    var leftWidth = frameWidth - leftPad;
	
	    var rightWidth = frameWidth - ((sheetWidth - cutWidth) - leftPad);
	
	    var topPad = frame.y;
	    var topHeight = frameHeight - topPad;
	
	    var bottomHeight = frameHeight - ((sheetHeight - cutHeight) - topPad);
	
	    // console.log('x / y', x, y);
	    // console.log('cutW / H', cutWidth, cutHeight);
	    // console.log('sheetW / H', sheetWidth, sheetHeight);
	    // console.log('row', row, 'column', column, 'total', total);
	    // console.log('LW', leftWidth, 'RW', rightWidth, 'TH', topHeight, 'BH', bottomHeight);
	
	    if (startFrame > total || startFrame < -total)
	    {
	        startFrame = 0;
	    }
	
	    if (startFrame < 0)
	    {
	        //  Allow negative skipframes.
	        startFrame = total + startFrame;
	    }
	
	    if (endFrame !== -1)
	    {
	        total = startFrame + (endFrame + 1);
	    }
	
	    var sheetFrame;
	    var frameX = margin;
	    var frameY = margin;
	    var frameIndex = 0;
	    var sourceIndex = frame.sourceIndex;
	
	    for (var sheetY = 0; sheetY < column; sheetY++)
	    {
	        var topRow = (sheetY === 0);
	        var bottomRow = (sheetY === column - 1);
	
	        for (var sheetX = 0; sheetX < row; sheetX++)
	        {
	            var leftRow = (sheetX === 0);
	            var rightRow = (sheetX === row - 1);
	
	            sheetFrame = texture.add(frameIndex, sourceIndex, x + frameX, y + frameY, frameWidth, frameHeight);
	
	            if (leftRow || topRow || rightRow || bottomRow)
	            {
	                var destX = (leftRow) ? leftPad : 0;
	                var destY = (topRow) ? topPad : 0;
	                var destWidth = frameWidth;
	                var destHeight = frameHeight;
	
	                if (leftRow)
	                {
	                    destWidth = leftWidth;
	                }
	                else if (rightRow)
	                {
	                    destWidth = rightWidth;
	                }
	
	                if (topRow)
	                {
	                    destHeight = topHeight;
	                }
	                else if (bottomRow)
	                {
	                    destHeight = bottomHeight;
	                }
	
	                sheetFrame.cutWidth = destWidth;
	                sheetFrame.cutHeight = destHeight;
	
	                sheetFrame.setTrim(frameWidth, frameHeight, destX, destY, destWidth, destHeight);
	            }
	
	            frameX += spacing;
	
	            if (leftRow)
	            {
	                frameX += leftWidth;
	            }
	            else if (rightRow)
	            {
	                frameX += rightRow;
	            }
	            else
	            {
	                frameX += frameWidth;
	            }
	
	            frameIndex++;
	        }
	
	        frameX = margin;
	        frameY += spacing;
	
	        if (topRow)
	        {
	            frameY += topHeight;
	        }
	        else if (bottomRow)
	        {
	            frameY += bottomHeight;
	        }
	        else
	        {
	            frameY += frameHeight;
	        }
	    }
	
	    return texture;
	};
	
	module.exports = SpriteSheetFromAtlas;


/***/ }),
/* 1530 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var imageHeight = 0;
	
	/**
	 * @function addFrame
	 * @private
	 * @since 3.0.0
	 */
	var addFrame = function (texture, sourceIndex, name, frame)
	{
	    //  The frame values are the exact coordinates to cut the frame out of the atlas from
	
	    var y = imageHeight - frame.y - frame.height;
	
	    texture.add(name, sourceIndex, frame.x, y, frame.width, frame.height);
	
	    //  These are the original (non-trimmed) sprite values
	    /*
	    if (src.trimmed)
	    {
	        newFrame.setTrim(
	            src.sourceSize.w,
	            src.sourceSize.h,
	            src.spriteSourceSize.x,
	            src.spriteSourceSize.y,
	            src.spriteSourceSize.w,
	            src.spriteSourceSize.h
	        );
	    }
	    */
	};
	
	/**
	 * Parses a Unity YAML File and creates Frames in the Texture.
	 * For more details about Sprite Meta Data see https://docs.unity3d.com/ScriptReference/SpriteMetaData.html
	 *
	 * @function Phaser.Textures.Parsers.UnityYAML
	 * @memberOf Phaser.Textures.Parsers
	 * @private
	 * @since 3.0.0
	 *
	 * @param {Phaser.Textures.Texture} texture - The Texture to add the Frames to.
	 * @param {integer} sourceIndex - The index of the TextureSource.
	 * @param {object} yaml - The YAML data.
	 *
	 * @return {Phaser.Textures.Texture} The Texture modified by this parser.
	 */
	var UnityYAML = function (texture, sourceIndex, yaml)
	{
	    //  Add in a __BASE entry (for the entire atlas)
	    var source = texture.source[sourceIndex];
	
	    texture.add('__BASE', sourceIndex, 0, 0, source.width, source.height);
	
	    imageHeight = source.height;
	
	    var data = yaml.split('\n');
	
	    var lineRegExp = /^[ ]*(- )*(\w+)+[: ]+(.*)/;
	
	    var prevSprite = '';
	    var currentSprite = '';
	    var rect = { x: 0, y: 0, width: 0, height: 0 };
	
	    // var pivot = { x: 0, y: 0 };
	    // var border = { x: 0, y: 0, z: 0, w: 0 };
	
	    for (var i = 0; i < data.length; i++)
	    {
	        var results = data[i].match(lineRegExp);
	
	        if (!results)
	        {
	            continue;
	        }
	
	        var isList = (results[1] === '- ');
	        var key = results[2];
	        var value = results[3];
	
	        if (isList)
	        {
	            if (currentSprite !== prevSprite)
	            {
	                addFrame(texture, sourceIndex, currentSprite, rect);
	
	                prevSprite = currentSprite;
	            }
	
	            rect = { x: 0, y: 0, width: 0, height: 0 };
	        }
	
	        if (key === 'name')
	        {
	            //  Start new list
	            currentSprite = value;
	            continue;
	        }
	
	        switch (key)
	        {
	            case 'x':
	            case 'y':
	            case 'width':
	            case 'height':
	                rect[key] = parseInt(value, 10);
	                break;
	
	            // case 'pivot':
	            //     pivot = eval('var obj = ' + value);
	            //     break;
	
	            // case 'border':
	            //     border = eval('var obj = ' + value);
	            //     break;
	        }
	    }
	
	    if (currentSprite !== prevSprite)
	    {
	        addFrame(texture, sourceIndex, currentSprite, rect);
	    }
	
	    return texture;
	};
	
	module.exports = UnityYAML;
	
	/*
	Example data:
	
	TextureImporter:
	  spritePivot: {x: .5, y: .5}
	  spriteBorder: {x: 0, y: 0, z: 0, w: 0}
	  spritePixelsToUnits: 100
	  spriteSheet:
	    sprites:
	    - name: asteroids_0
	      rect:
	        serializedVersion: 2
	        x: 5
	        y: 328
	        width: 65
	        height: 82
	      alignment: 0
	      pivot: {x: 0, y: 0}
	      border: {x: 0, y: 0, z: 0, w: 0}
	    - name: asteroids_1
	      rect:
	        serializedVersion: 2
	        x: 80
	        y: 322
	        width: 53
	        height: 88
	      alignment: 0
	      pivot: {x: 0, y: 0}
	      border: {x: 0, y: 0, z: 0, w: 0}
	  spritePackingTag: Asteroids
	*/


/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObjectCreator = __webpack_require__(26);
	var ParseToTilemap = __webpack_require__(329);
	
	/**
	 * @typedef {object} TilemapConfig
	 * 
	 * @property {string} [key] - The key in the Phaser cache that corresponds to the loaded tilemap data.
	 * @property {integer[][]} [data] - Instead of loading from the cache, you can also load directly from a 2D array of tile indexes.
	 * @property {integer} [tileWidth=32] - The width of a tile in pixels.
	 * @property {integer} [tileHeight=32] - The height of a tile in pixels.
	 * @property {integer} [width=10] - The width of the map in tiles.
	 * @property {integer} [height=10] - The height of the map in tiles.
	 * @property {boolean} [insertNull=false] - Controls how empty tiles, tiles with an index of -1,
	 * in the map data are handled. If `true`, empty locations will get a value of `null`. If `false`,
	 * empty location will get a Tile object with an index of -1. If you've a large sparsely populated
	 * map and the tile data doesn't need to change then setting this value to `true` will help with
	 * memory consumption. However if your map is small or you need to update the tiles dynamically,
	 * then leave the default value set.
	 */
	
	/**
	 * Creates a Tilemap from the given key or data, or creates a blank Tilemap if no key/data provided.
	 * When loading from CSV or a 2D array, you should specify the tileWidth & tileHeight. When parsing
	 * from a map from Tiled, the tileWidth, tileHeight, width & height will be pulled from the map
	 * data. For an empty map, you should specify tileWidth, tileHeight, width & height.
	 *
	 * @method Phaser.GameObjects.GameObjectCreator#tilemap
	 * @since 3.0.0
	 * 
	 * @param {TilemapConfig} [config] - The config options for the Tilemap.
	 * 
	 * @return {Phaser.Tilemaps.Tilemap}
	 */
	GameObjectCreator.register('tilemap', function (config)
	{
	    // Defaults are applied in ParseToTilemap
	    var c = (config !== undefined) ? config : {};
	
	    return ParseToTilemap(
	        this.scene,
	        c.key,
	        c.tileWidth,
	        c.tileHeight,
	        c.width,
	        c.height,
	        c.data,
	        c.insertNull
	    );
	});


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObjectFactory = __webpack_require__(18);
	var ParseToTilemap = __webpack_require__(329);
	
	/**
	 * Creates a Tilemap from the given key or data, or creates a blank Tilemap if no key/data provided.
	 * When loading from CSV or a 2D array, you should specify the tileWidth & tileHeight. When parsing
	 * from a map from Tiled, the tileWidth, tileHeight, width & height will be pulled from the map
	 * data. For an empty map, you should specify tileWidth, tileHeight, width & height.
	 *
	 * @method Phaser.GameObjects.GameObjectFactory#tilemap
	 * @since 3.0.0
	 *
	 * @param {string} [key] - The key in the Phaser cache that corresponds to the loaded tilemap data.
	 * @param {integer} [tileWidth=32] - The width of a tile in pixels. Pass in `null` to leave as the
	 * default.
	 * @param {integer} [tileHeight=32] - The height of a tile in pixels. Pass in `null` to leave as the
	 * default.
	 * @param {integer} [width=10] - The width of the map in tiles. Pass in `null` to leave as the
	 * default.
	 * @param {integer} [height=10] - The height of the map in tiles. Pass in `null` to leave as the
	 * default.
	 * @param {integer[][]} [data] - Instead of loading from the cache, you can also load directly from
	 * a 2D array of tile indexes. Pass in `null` for no data.
	 * @param {boolean} [insertNull=false] - Controls how empty tiles, tiles with an index of -1, in the
	 * map data are handled. If `true`, empty locations will get a value of `null`. If `false`, empty
	 * location will get a Tile object with an index of -1. If you've a large sparsely populated map and
	 * the tile data doesn't need to change then setting this value to `true` will help with memory
	 * consumption. However if your map is small or you need to update the tiles dynamically, then leave
	 * the default value set.
	 * 
	 * @return {Phaser.Tilemaps.Tilemap}
	 */
	GameObjectFactory.register('tilemap', function (key, tileWidth, tileHeight, width, height, data, insertNull)
	{
	    // Allow users to specify null to indicate that they want the default value, since null is
	    // shorter & more legible than undefined. Convert null to undefined to allow ParseToTilemap
	    // defaults to take effect.
	
	    if (key === null) { key = undefined; }
	    if (tileWidth === null) { tileWidth = undefined; }
	    if (tileHeight === null) { tileHeight = undefined; }
	    if (width === null) { width = undefined; }
	    if (height === null) { height = undefined; }
	
	    return ParseToTilemap(this.scene, key, tileWidth, tileHeight, width, height, data, insertNull);
	});
	
	//  When registering a factory function 'this' refers to the GameObjectFactory context.
	//
	//  There are several properties available to use:
	//
	//  this.scene - a reference to the Scene that owns the GameObjectFactory
	//  this.displayList - a reference to the Display List the Scene owns
	//  this.updateList - a reference to the Update List the Scene owns


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetTilesWithin = __webpack_require__(34);
	var CalculateFacesWithin = __webpack_require__(88);
	
	/**
	 * Copies the tiles in the source rectangular area to a new destination (all specified in tile
	 * coordinates) within the layer. This copies all tile properties & recalculates collision
	 * information in the destination region.
	 *
	 * @function Phaser.Tilemaps.Components.Copy
	 * @private
	 * @since 3.0.0
	 *
	 * @param {integer} srcTileX - [description]
	 * @param {integer} srcTileY - [description]
	 * @param {integer} width - [description]
	 * @param {integer} height - [description]
	 * @param {integer} destTileX - [description]
	 * @param {integer} destTileY - [description]
	 * @param {boolean} [recalculateFaces=true] - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 */
	var Copy = function (srcTileX, srcTileY, width, height, destTileX, destTileY, recalculateFaces, layer)
	{
	    if (srcTileX < 0) { srcTileX = 0; }
	    if (srcTileY < 0) { srcTileY = 0; }
	    if (recalculateFaces === undefined) { recalculateFaces = true; }
	
	    var srcTiles = GetTilesWithin(srcTileX, srcTileY, width, height, null, layer);
	
	    var offsetX = destTileX - srcTileX;
	    var offsetY = destTileY - srcTileY;
	
	    for (var i = 0; i < srcTiles.length; i++)
	    {
	        var tileX = srcTiles[i].x + offsetX;
	        var tileY = srcTiles[i].y + offsetY;
	        if (tileX >= 0 && tileX < layer.width && tileY >= 0 && tileY < layer.height)
	        {
	            if (layer.data[tileY][tileX])
	            {
	                layer.data[tileY][tileX].copy(srcTiles[i]);
	            }
	        }
	    }
	
	    if (recalculateFaces)
	    {
	        // Recalculate the faces within the destination area and neighboring tiles
	        CalculateFacesWithin(destTileX - 1, destTileY - 1, width + 2, height + 2, layer);
	    }
	};
	
	module.exports = Copy;


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var TileToWorldX = __webpack_require__(213);
	var TileToWorldY = __webpack_require__(214);
	var GetTilesWithin = __webpack_require__(34);
	var ReplaceByIndex = __webpack_require__(641);
	
	/**
	 * Creates a Sprite for every object matching the given tile indexes in the layer. You can
	 * optionally specify if each tile will be replaced with a new tile after the Sprite has been
	 * created. This is useful if you want to lay down special tiles in a level that are converted to
	 * Sprites, but want to replace the tile itself with a floor tile or similar once converted.
	 *
	 * @function Phaser.Tilemaps.Components.CreateFromTiles
	 * @private
	 * @since 3.0.0
	 *
	 * @param {(integer|array)} indexes - The tile index, or array of indexes, to create Sprites from.
	 * @param {(integer|array)} replacements - The tile index, or array of indexes, to change a converted
	 * tile to. Set to `null` to leave the tiles unchanged. If an array is given, it is assumed to be a
	 * one-to-one mapping with the indexes array.
	 * @param {object} spriteConfig - The config object to pass into the Sprite creator (i.e.
	 * scene.make.sprite).
	 * @param {Phaser.Scene} [scene=scene the map is within] - The Scene to create the Sprites within.
	 * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - The Camera to use when determining the world XY
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 *
	 * @return {Phaser.GameObjects.Sprite[]} An array of the Sprites that were created.
	 */
	var CreateFromTiles = function (indexes, replacements, spriteConfig, scene, camera, layer)
	{
	    if (spriteConfig === undefined) { spriteConfig = {}; }
	
	    if (!Array.isArray(indexes)) { indexes = [ indexes ]; }
	
	    var tilemapLayer = layer.tilemapLayer;
	    if (scene === undefined) { scene = tilemapLayer.scene; }
	    if (camera === undefined) { camera = scene.cameras.main; }
	
	    var tiles = GetTilesWithin(0, 0, layer.width, layer.height, null, layer);
	    var sprites = [];
	    var i;
	
	    for (i = 0; i < tiles.length; i++)
	    {
	        var tile = tiles[i];
	
	        if (indexes.indexOf(tile.index) !== -1)
	        {
	            spriteConfig.x = TileToWorldX(tile.x, camera, layer);
	            spriteConfig.y = TileToWorldY(tile.y, camera, layer);
	
	            var sprite = scene.make.sprite(spriteConfig);
	            sprites.push(sprite);
	        }
	    }
	
	    if (typeof replacements === 'number')
	    {
	        //  Assume 1 replacement for all types of tile given
	        for (i = 0; i < indexes.length; i++)
	        {
	            ReplaceByIndex(indexes[i], replacements, 0, 0, layer.width, layer.height, layer);
	        }
	    }
	    else if (Array.isArray(replacements))
	    {
	        //  Assume 1 to 1 mapping with indexes array
	        for (i = 0; i < indexes.length; i++)
	        {
	            ReplaceByIndex(indexes[i], replacements[i], 0, 0, layer.width, layer.height, layer);
	        }
	    }
	
	    return sprites;
	};
	
	module.exports = CreateFromTiles;


/***/ }),
/* 1535 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Returns the tiles in the given layer that are within the camera's viewport. This is used
	 * internally.
	 *
	 * @function Phaser.Tilemaps.Components.CullTiles
	 * @private
	 * @since 3.0.0
	 *
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 * @param {Phaser.Cameras.Scene2D.Camera} [camera] - The Camera to run the cull check against.
	 * @param {array} [outputArray] - [description]
	 *
	 * @return {Phaser.Tilemaps.Tile[]} An array of Tile objects.
	 */
	var CullTiles = function (layer, camera, outputArray)
	{
	    if (outputArray === undefined) { outputArray = []; }
	
	    outputArray.length = 0;
	    
	    var zoom = camera.zoom;
	    var originX = camera.width / 2;
	    var originY = camera.height / 2;
	
	    camera.matrix.loadIdentity();
	    camera.matrix.translate(camera.x + originX, camera.y + originY);
	    camera.matrix.rotate(camera.rotation);
	    camera.matrix.scale(zoom, zoom);
	    camera.matrix.translate(-originX, -originY);
	    camera.matrix.invert();
	
	    var tilemapLayer = layer.tilemapLayer;
	    var tileW = layer.tileWidth;
	    var tileH = layer.tileHeight;
	    var cullX = ((camera.scrollX * tilemapLayer.scrollFactorX) - tileW);
	    var cullY = ((camera.scrollY * tilemapLayer.scrollFactorY) - tileH);
	    var cullW = (cullX + (camera.width + tileW * 2));
	    var cullH = (cullY + (camera.height + tileH * 2));
	    var mapData = layer.data;
	    var mapWidth = layer.width;
	    var mapHeight = layer.height;
	    var cameraMatrix = camera.matrix.matrix;
	    var a = cameraMatrix[0];
	    var b = cameraMatrix[1];
	    var c = cameraMatrix[2];
	    var d = cameraMatrix[3];
	    var e = cameraMatrix[4];
	    var f = cameraMatrix[5];
	    var tCullX = cullX * a + cullY * c + e;
	    var tCullY = cullX * b + cullY * d + f;
	    var tCullW = cullW * a + cullH * c + e;
	    var tCullH = cullW * b + cullH * d + f;
	
	
	    for (var y = 0; y < mapHeight; ++y)
	    {
	        for (var x = 0; x < mapWidth; ++x)
	        {
	            var tile = mapData[y][x];
	
	            if (tile === null || tile.index === -1)
	            { continue; }
	
	            var tileX = tile.pixelX * a + tile.pixelY * c + e;
	            var tileY = tile.pixelX * b + tile.pixelY * d + f;
	
	            if (tile.visible &&
	                tileX >= tCullX &&
	                tileY >= tCullY &&
	                tileX + tileW <= tCullW &&
	                tileY + tileH <= tCullH
	            )
	            {
	                outputArray.push(tile);
	            }
	        }
	    }
	
	
	    /* var tilemapLayer = layer.tilemapLayer;
	    var mapData = layer.data;
	    var mapWidth = layer.width;
	    var mapHeight = layer.height;
	    var left = (camera.scrollX * camera.zoom * tilemapLayer.scrollFactorX) - tilemapLayer.x;
	    var top = (camera.scrollY * camera.zoom * tilemapLayer.scrollFactorY) - tilemapLayer.y;
	    var sx = tilemapLayer.scaleX;
	    var sy = tilemapLayer.scaleY;
	    var tileWidth = layer.tileWidth * sx;
	    var tileHeight = layer.tileHeight * sy;
	
	    for (var row = 0; row < mapHeight; ++row)
	    {
	        for (var col = 0; col < mapWidth; ++col)
	        {
	            var tile = mapData[row][col];
	
	            if (tile === null || tile.index === -1) { continue; }
	
	            var tileX = tile.pixelX * sx - left;
	            var tileY = tile.pixelY * sy - top;
	            var cullW = camera.width + tileWidth;
	            var cullH = camera.height + tileHeight;
	
	            if (tile.visible &&
	                tileX > -tileWidth && tileY > -tileHeight &&
	                tileX < cullW && tileY < cullH)
	            {
	                outputArray.push(tile);
	            }
	        }
	    } */
	
	    return outputArray;
	};
	
	module.exports = CullTiles;


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetTilesWithin = __webpack_require__(34);
	var CalculateFacesWithin = __webpack_require__(88);
	var SetTileCollision = __webpack_require__(121);
	
	/**
	 * Sets the tiles in the given rectangular area (in tile coordinates) of the layer with the
	 * specified index. Tiles will be set to collide if the given index is a colliding index.
	 * Collision information in the region will be recalculated.
	 *
	 * @function Phaser.Tilemaps.Components.Fill
	 * @private
	 * @since 3.0.0
	 *
	 * @param {integer} index - [description]
	 * @param {integer} [tileX=0] - [description]
	 * @param {integer} [tileY=0] - [description]
	 * @param {integer} [width=max width based on tileX] - [description]
	 * @param {integer} [height=max height based on tileY] - [description]
	 * @param {boolean} [recalculateFaces=true] - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 */
	var Fill = function (index, tileX, tileY, width, height, recalculateFaces, layer)
	{
	    if (recalculateFaces === undefined) { recalculateFaces = true; }
	
	    var doesIndexCollide = (layer.collideIndexes.indexOf(index) !== -1);
	
	    var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
	    for (var i = 0; i < tiles.length; i++)
	    {
	        tiles[i].index = index;
	
	        SetTileCollision(tiles[i], doesIndexCollide);
	    }
	
	    if (recalculateFaces)
	    {
	        // Recalculate the faces within the area and neighboring tiles
	        CalculateFacesWithin(tileX - 1, tileY - 1, width + 2, height + 2, layer);
	    }
	};
	
	module.exports = Fill;


/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetTilesWithin = __webpack_require__(34);
	
	/**
	 * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
	 * filter callback function. Any tiles that pass the filter test (i.e. where the callback returns
	 * true) will returned as a new array. Similar to Array.prototype.Filter in vanilla JS.
	 *
	 * @function Phaser.Tilemaps.Components.FilterTiles
	 * @private
	 * @since 3.0.0
	 *
	 * @param {function} callback - The callback. Each tile in the given area will be passed to this
	 * callback as the first and only parameter. The callback should return true for tiles that pass the
	 * filter.
	 * @param {object} [context] - The context under which the callback should be run.
	 * @param {integer} [tileX=0] - [description]
	 * @param {integer} [tileY=0] - [description]
	 * @param {integer} [width=max width based on tileX] - [description]
	 * @param {integer} [height=max height based on tileY] - [description]
	 * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	 * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	 * -1 for an index.
	 * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide
	 * on at least one side.
	 * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	 * have at least one interesting face.
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 * 
	 * @return {Phaser.Tilemaps.Tile[]} The filtered array of Tiles.
	 */
	var FilterTiles = function (callback, context, tileX, tileY, width, height, filteringOptions, layer)
	{
	    var tiles = GetTilesWithin(tileX, tileY, width, height, filteringOptions, layer);
	    return tiles.filter(callback, context);
	};
	
	module.exports = FilterTiles;
	


/***/ }),
/* 1538 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Searches the entire map layer for the first tile matching the given index, then returns that Tile
	 * object. If no match is found, it returns null. The search starts from the top-left tile and
	 * continues horizontally until it hits the end of the row, then it drops down to the next column.
	 * If the reverse boolean is true, it scans starting from the bottom-right corner traveling up to
	 * the top-left.
	 *
	 * @function Phaser.Tilemaps.Components.FindByIndex
	 * @private
	 * @since 3.0.0
	 *
	 * @param {integer} index - The tile index value to search for.
	 * @param {integer} [skip=0] - The number of times to skip a matching tile before returning.
	 * @param {boolean} [reverse=false] - If true it will scan the layer in reverse, starting at the
	 * bottom-right. Otherwise it scans from the top-left.
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 *
	 * @return {?Phaser.Tilemaps.Tile} The first (or n skipped) tile with the matching index.
	 */
	var FindByIndex = function (findIndex, skip, reverse, layer)
	{
	    if (skip === undefined) { skip = 0; }
	    if (reverse === undefined) { reverse = false; }
	
	    var count = 0;
	    var tx;
	    var ty;
	    var tile;
	
	    if (reverse)
	    {
	        for (ty = layer.height - 1; ty >= 0; ty--)
	        {
	            for (tx = layer.width - 1; tx >= 0; tx--)
	            {
	                tile = layer.data[ty][tx];
	                if (tile && tile.index === findIndex)
	                {
	                    if (count === skip)
	                    {
	                        return tile;
	                    }
	                    else
	                    {
	                        count += 1;
	                    }
	                }
	            }
	        }
	    }
	    else
	    {
	        for (ty = 0; ty < layer.height; ty++)
	        {
	            for (tx = 0; tx < layer.width; tx++)
	            {
	                tile = layer.data[ty][tx];
	                if (tile && tile.index === findIndex)
	                {
	                    if (count === skip)
	                    {
	                        return tile;
	                    }
	                    else
	                    {
	                        count += 1;
	                    }
	                }
	            }
	        }
	    }
	
	    return null;
	};
	
	module.exports = FindByIndex;


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetTilesWithin = __webpack_require__(34);
	
	/**
	 * @callback FindTileCallback
	 *
	 * @param {Phaser.Tilemaps.Tile} value - [description]
	 * @param {number} index - [description]
	 * @param {Phaser.Tilemaps.Tile[]} array - [description]
	 *
	 * @return {boolean} [description]
	 */
	
	/**
	 * Find the first tile in the given rectangular area (in tile coordinates) of the layer that
	 * satisfies the provided testing function. I.e. finds the first tile for which `callback` returns
	 * true. Similar to Array.prototype.find in vanilla JS.
	 *
	 * @function Phaser.Tilemaps.Components.FindTile
	 * @private
	 * @since 3.0.0
	 *
	 * @param {FindTileCallback} callback - The callback. Each tile in the given area will be passed to this
	 * callback as the first and only parameter.
	 * @param {object} [context] - The context under which the callback should be run.
	 * @param {integer} [tileX=0] - [description]
	 * @param {integer} [tileY=0] - [description]
	 * @param {integer} [width=max width based on tileX] - [description]
	 * @param {integer} [height=max height based on tileY] - [description]
	 * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	 * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	 * -1 for an index.
	 * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide
	 * on at least one side.
	 * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	 * have at least one interesting face.
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 *
	 * @return {?Phaser.Tilemaps.Tile} A Tile that matches the search, or null if no Tile found
	 */
	var FindTile = function (callback, context, tileX, tileY, width, height, filteringOptions, layer)
	{
	    var tiles = GetTilesWithin(tileX, tileY, width, height, filteringOptions, layer);
	    return tiles.find(callback, context) || null;
	};
	
	module.exports = FindTile;


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetTilesWithin = __webpack_require__(34);
	
	/**
	 * @callback EachTileCallback
	 *
	 * @param {Phaser.Tilemaps.Tile} value - [description]
	 * @param {number} index - [description]
	 * @param {Phaser.Tilemaps.Tile[]} array - [description]
	 */
	
	/**
	 * For each tile in the given rectangular area (in tile coordinates) of the layer, run the given
	 * callback. Similar to Array.prototype.forEach in vanilla JS.
	 *
	 * @function Phaser.Tilemaps.Components.ForEachTile
	 * @private
	 * @since 3.0.0
	 *
	 * @param {EachTileCallback} callback - The callback. Each tile in the given area will be passed to this
	 * callback as the first and only parameter.
	 * @param {object} [context] - The context under which the callback should be run.
	 * @param {integer} [tileX=0] - [description]
	 * @param {integer} [tileY=0] - [description]
	 * @param {integer} [width=max width based on tileX] - [description]
	 * @param {integer} [height=max height based on tileY] - [description]
	 * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	 * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	 * -1 for an index.
	 * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide
	 * on at least one side.
	 * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	 * have at least one interesting face.
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 */
	var ForEachTile = function (callback, context, tileX, tileY, width, height, filteringOptions, layer)
	{
	    var tiles = GetTilesWithin(tileX, tileY, width, height, filteringOptions, layer);
	    tiles.forEach(callback, context);
	};
	
	module.exports = ForEachTile;


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetTileAt = __webpack_require__(212);
	var WorldToTileX = __webpack_require__(99);
	var WorldToTileY = __webpack_require__(100);
	
	/**
	 * Gets a tile at the given world coordinates from the given layer.
	 *
	 * @function Phaser.Tilemaps.Components.GetTileAtWorldXY
	 * @private
	 * @since 3.0.0
	 *
	 * @param {number} worldX - X position to get the tile from (given in pixels)
	 * @param {number} worldY - Y position to get the tile from (given in pixels)
	 * @param {boolean} [nonNull=false] - If true, function won't return null for empty tiles, but a Tile
	 * object with an index of -1.
	 * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 * 
	 * @return {Phaser.Tilemaps.Tile} The tile at the given coordinates or null if no tile was found or the coordinates
	 * were invalid.
	 */
	var GetTileAtWorldXY = function (worldX, worldY, nonNull, camera, layer)
	{
	    var tileX = WorldToTileX(worldX, true, camera, layer);
	    var tileY = WorldToTileY(worldY, true, camera, layer);
	
	    return GetTileAt(tileX, tileY, nonNull, layer);
	};
	
	module.exports = GetTileAtWorldXY;


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Geom = __webpack_require__(508);
	var GetTilesWithin = __webpack_require__(34);
	var Intersects = __webpack_require__(512);
	var NOOP = __webpack_require__(6);
	var TileToWorldX = __webpack_require__(213);
	var TileToWorldY = __webpack_require__(214);
	var WorldToTileX = __webpack_require__(99);
	var WorldToTileY = __webpack_require__(100);
	
	var TriangleToRectangle = function (triangle, rect)
	{
	    return Intersects.RectangleToTriangle(rect, triangle);
	};
	
	// Note: Could possibly be optimized by copying the shape and shifting it into tilemapLayer
	// coordinates instead of shifting the tiles.
	
	/**
	 * Gets the tiles that overlap with the given shape in the given layer. The shape must be a Circle,
	 * Line, Rectangle or Triangle. The shape should be in world coordinates.
	 *
	 * @function Phaser.Tilemaps.Components.GetTilesWithinShape
	 * @private
	 * @since 3.0.0
	 *
	 * @param {(Phaser.Geom.Circle|Phaser.Geom.Line|Phaser.Geom.Rectangle|Phaser.Geom.Triangle)} shape - A shape in world (pixel) coordinates
	 * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	 * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	 * -1 for an index.
	 * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide on
	 * at least one side.
	 * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	 * have at least one interesting face.
	 * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 *
	 * @return {Phaser.Tilemaps.Tile[]} Array of Tile objects.
	 */
	var GetTilesWithinShape = function (shape, filteringOptions, camera, layer)
	{
	    if (shape === undefined) { return []; }
	
	    // intersectTest is a function with parameters: shape, rect
	    var intersectTest = NOOP;
	    if (shape instanceof Geom.Circle) { intersectTest = Intersects.CircleToRectangle; }
	    else if (shape instanceof Geom.Rectangle) { intersectTest = Intersects.RectangleToRectangle; }
	    else if (shape instanceof Geom.Triangle) { intersectTest = TriangleToRectangle; }
	    else if (shape instanceof Geom.Line) { intersectTest = Intersects.LineToRectangle; }
	
	    // Top left corner of the shapes's bounding box, rounded down to include partial tiles
	    var xStart = WorldToTileX(shape.left, true, camera, layer);
	    var yStart = WorldToTileY(shape.top, true, camera, layer);
	
	    // Bottom right corner of the shapes's bounding box, rounded up to include partial tiles
	    var xEnd = Math.ceil(WorldToTileX(shape.right, false, camera, layer));
	    var yEnd = Math.ceil(WorldToTileY(shape.bottom, false, camera, layer));
	
	    // Tiles within bounding rectangle of shape. Bounds are forced to be at least 1 x 1 tile in size
	    // to grab tiles for shapes that don't have a height or width (e.g. a horizontal line).
	    var width = Math.max(xEnd - xStart, 1);
	    var height = Math.max(yEnd - yStart, 1);
	    var tiles = GetTilesWithin(xStart, yStart, width, height, filteringOptions, layer);
	
	    var tileWidth = layer.tileWidth;
	    var tileHeight = layer.tileHeight;
	    if (layer.tilemapLayer)
	    {
	        tileWidth *= layer.tilemapLayer.scaleX;
	        tileHeight *= layer.tilemapLayer.scaleY;
	    }
	
	    var results = [];
	    var tileRect = new Geom.Rectangle(0, 0, tileWidth, tileHeight);
	    for (var i = 0; i < tiles.length; i++)
	    {
	        var tile = tiles[i];
	        tileRect.x = TileToWorldX(tile.x, camera, layer);
	        tileRect.y = TileToWorldY(tile.y, camera, layer);
	        if (intersectTest(shape, tileRect))
	        {
	            results.push(tile);
	        }
	    }
	
	    return results;
	};
	
	module.exports = GetTilesWithinShape;


/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetTilesWithin = __webpack_require__(34);
	var WorldToTileX = __webpack_require__(99);
	var WorldToTileY = __webpack_require__(100);
	
	/**
	 * Gets the tiles in the given rectangular area (in world coordinates) of the layer.
	 *
	 * @function Phaser.Tilemaps.Components.GetTilesWithinWorldXY
	 * @private
	 * @since 3.0.0
	 *
	 * @param {number} worldX - [description]
	 * @param {number} worldY - [description]
	 * @param {number} width - [description]
	 * @param {number} height - [description]
	 * @param {object} [filteringOptions] - Optional filters to apply when getting the tiles.
	 * @param {boolean} [filteringOptions.isNotEmpty=false] - If true, only return tiles that don't have
	 * -1 for an index.
	 * @param {boolean} [filteringOptions.isColliding=false] - If true, only return tiles that collide on
	 * at least one side.
	 * @param {boolean} [filteringOptions.hasInterestingFace=false] - If true, only return tiles that
	 * have at least one interesting face.
	 * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 * 
	 * @return {Phaser.Tilemaps.Tile[]} Array of Tile objects.
	 */
	var GetTilesWithinWorldXY = function (worldX, worldY, width, height, filteringOptions, camera, layer)
	{
	    // Top left corner of the rect, rounded down to include partial tiles
	    var xStart = WorldToTileX(worldX, true, camera, layer);
	    var yStart = WorldToTileY(worldY, true, camera, layer);
	
	    // Bottom right corner of the rect, rounded up to include partial tiles
	    var xEnd = Math.ceil(WorldToTileX(worldX + width, false, camera, layer));
	    var yEnd = Math.ceil(WorldToTileY(worldY + height, false, camera, layer));
	
	    return GetTilesWithin(xStart, yStart, xEnd - xStart, yEnd - yStart, filteringOptions, layer);
	};
	
	module.exports = GetTilesWithinWorldXY;


/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var HasTileAt = __webpack_require__(639);
	var WorldToTileX = __webpack_require__(99);
	var WorldToTileY = __webpack_require__(100);
	
	/**
	 * Checks if there is a tile at the given location (in world coordinates) in the given layer. Returns
	 * false if there is no tile or if the tile at that location has an index of -1.
	 *
	 * @function Phaser.Tilemaps.Components.HasTileAtWorldXY
	 * @private
	 * @since 3.0.0
	 *
	 * @param {number} worldX - [description]
	 * @param {number} worldY - [description]
	 * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 * 
	 * @return {boolean}
	 */
	var HasTileAtWorldXY = function (worldX, worldY, camera, layer)
	{
	    var tileX = WorldToTileX(worldX, true, camera, layer);
	    var tileY = WorldToTileY(worldY, true, camera, layer);
	
	    return HasTileAt(tileX, tileY, layer);
	};
	
	module.exports = HasTileAtWorldXY;


/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var PutTileAt = __webpack_require__(331);
	var WorldToTileX = __webpack_require__(99);
	var WorldToTileY = __webpack_require__(100);
	
	/**
	 * Puts a tile at the given world coordinates (pixels) in the specified layer. You can pass in either
	 * an index or a Tile object. If you pass in a Tile, all attributes will be copied over to the
	 * specified location. If you pass in an index, only the index at the specified location will be
	 * changed. Collision information will be recalculated at the specified location.
	 *
	 * @function Phaser.Tilemaps.Components.PutTileAtWorldXY
	 * @private
	 * @since 3.0.0
	 *
	 * @param {(integer|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
	 * @param {integer} worldX - [description]
	 * @param {integer} worldY - [description]
	 * @param {boolean} [recalculateFaces=true] - [description]
	 * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 *
	 * @return {Phaser.Tilemaps.Tile} The Tile object that was created or added to this map.
	 */
	var PutTileAtWorldXY = function (tile, worldX, worldY, recalculateFaces, camera, layer)
	{
	    var tileX = WorldToTileX(worldX, true, camera, layer);
	    var tileY = WorldToTileY(worldY, true, camera, layer);
	    return PutTileAt(tile, tileX, tileY, recalculateFaces, layer);
	};
	
	module.exports = PutTileAtWorldXY;


/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CalculateFacesWithin = __webpack_require__(88);
	var PutTileAt = __webpack_require__(331);
	
	/**
	 * Puts an array of tiles or a 2D array of tiles at the given tile coordinates in the specified
	 * layer. The array can be composed of either tile indexes or Tile objects. If you pass in a Tile,
	 * all attributes will be copied over to the specified location. If you pass in an index, only the
	 * index at the specified location will be changed. Collision information will be recalculated
	 * within the region tiles were changed.
	 *
	 * @function Phaser.Tilemaps.Components.PutTilesAt
	 * @private
	 * @since 3.0.0
	 *
	 * @param {(integer[]|integer[][]|Phaser.Tilemaps.Tile[]|Phaser.Tilemaps.Tile[][])} tile - A row (array) or grid (2D array) of Tiles
	 * or tile indexes to place.
	 * @param {integer} tileX - [description]
	 * @param {integer} tileY - [description]
	 * @param {boolean} [recalculateFaces=true] - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 */
	var PutTilesAt = function (tilesArray, tileX, tileY, recalculateFaces, layer)
	{
	    if (!Array.isArray(tilesArray)) { return null; }
	    if (recalculateFaces === undefined) { recalculateFaces = true; }
	
	    // Force the input array to be a 2D array
	    if (!Array.isArray(tilesArray[0]))
	    {
	        tilesArray = [ tilesArray ];
	    }
	
	    var height = tilesArray.length;
	    var width = tilesArray[0].length;
	
	    for (var ty = 0; ty < height; ty++)
	    {
	        for (var tx = 0; tx < width; tx++)
	        {
	            var tile = tilesArray[ty][tx];
	            PutTileAt(tile, tileX + tx, tileY + ty, false, layer);
	        }
	    }
	
	    if (recalculateFaces)
	    {
	        // Recalculate the faces within the destination area and neighboring tiles
	        CalculateFacesWithin(tileX - 1, tileY - 1, width + 2, height + 2, layer);
	    }
	};
	
	module.exports = PutTilesAt;
	


/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetTilesWithin = __webpack_require__(34);
	var GetRandom = __webpack_require__(339);
	
	/**
	 * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
	 * specified layer. Each tile will receive a new index. If an array of indexes is passed in, then
	 * those will be used for randomly assigning new tile indexes. If an array is not provided, the
	 * indexes found within the region (excluding -1) will be used for randomly assigning new tile
	 * indexes. This method only modifies tile indexes and does not change collision information.
	 *
	 * @function Phaser.Tilemaps.Components.Randomize
	 * @private
	 * @since 3.0.0
	 *
	 * @param {integer} [tileX=0] - [description]
	 * @param {integer} [tileY=0] - [description]
	 * @param {integer} [width=max width based on tileX] - [description]
	 * @param {integer} [height=max height based on tileY] - [description]
	 * @param {integer[]} [indexes] - An array of indexes to randomly draw from during randomization.
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 */
	var Randomize = function (tileX, tileY, width, height, indexes, layer)
	{
	    var i;
	    var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
	
	    // If no indicies are given, then find all the unique indexes within the specified region
	    if (indexes === undefined)
	    {
	        indexes = [];
	        for (i = 0; i < tiles.length; i++)
	        {
	            if (indexes.indexOf(tiles[i].index) === -1)
	            {
	                indexes.push(tiles[i].index);
	            }
	        }
	    }
	
	    for (i = 0; i < tiles.length; i++)
	    {
	        tiles[i].index = GetRandom(indexes);
	    }
	};
	
	module.exports = Randomize;


/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var RemoveTileAt = __webpack_require__(640);
	var WorldToTileX = __webpack_require__(99);
	var WorldToTileY = __webpack_require__(100);
	
	/**
	 * Removes the tile at the given world coordinates in the specified layer and updates the layer's
	 * collision information.
	 *
	 * @function Phaser.Tilemaps.Components.RemoveTileAtWorldXY
	 * @private
	 * @since 3.0.0
	 *
	 * @param {(integer|Phaser.Tilemaps.Tile)} tile - The index of this tile to set or a Tile object.
	 * @param {number} worldX - [description]
	 * @param {number} worldY - [description]
	 * @param {boolean} [replaceWithNull=true] - If true, this will replace the tile at the specified
	 * location with null instead of a Tile with an index of -1.
	 * @param {boolean} [recalculateFaces=true] - [description]
	 * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 *
	 * @return {Phaser.Tilemaps.Tile} The Tile object that was removed.
	 */
	var RemoveTileAtWorldXY = function (worldX, worldY, replaceWithNull, recalculateFaces, camera, layer)
	{
	    var tileX = WorldToTileX(worldX, true, camera, layer);
	    var tileY = WorldToTileY(worldY, true, camera, layer);
	    return RemoveTileAt(tileX, tileY, replaceWithNull, recalculateFaces, layer);
	};
	
	module.exports = RemoveTileAtWorldXY;


/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetTilesWithin = __webpack_require__(34);
	var Color = __webpack_require__(481);
	
	/**
	 * Draws a debug representation of the layer to the given Graphics. This is helpful when you want to
	 * get a quick idea of which of your tiles are colliding and which have interesting faces. The tiles
	 * are drawn starting at (0, 0) in the Graphics, allowing you to place the debug representation
	 * wherever you want on the screen.
	 *
	 * @function Phaser.Tilemaps.Components.RenderDebug
	 * @private
	 * @since 3.0.0
	 *
	 * @param {Phaser.GameObjects.Graphics} graphics - The target Graphics object to draw upon.
	 * @param {object} styleConfig - An object specifying the colors to use for the debug drawing.
	 * @param {?Phaser.Display.Color} [styleConfig.tileColor=blue] - Color to use for drawing a filled rectangle at
	 * non-colliding tile locations. If set to null, non-colliding tiles will not be drawn.
	 * @param {?Phaser.Display.Color} [styleConfig.collidingTileColor=orange] - Color to use for drawing a filled
	 * rectangle at colliding tile locations. If set to null, colliding tiles will not be drawn.
	 * @param {?Phaser.Display.Color} [styleConfig.faceColor=grey] - Color to use for drawing a line at interesting
	 * tile faces. If set to null, interesting tile faces will not be drawn.
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 */
	var RenderDebug = function (graphics, styleConfig, layer)
	{
	    if (styleConfig === undefined) { styleConfig = {}; }
	
	    // Default colors without needlessly creating Color objects
	    var tileColor = styleConfig.tileColor !== undefined
	        ? styleConfig.tileColor
	        : new Color(105, 210, 231, 150);
	    var collidingTileColor = styleConfig.collidingTileColor !== undefined
	        ? styleConfig.collidingTileColor
	        : new Color(243, 134, 48, 200);
	    var faceColor = styleConfig.faceColor !== undefined
	        ? styleConfig.faceColor
	        : new Color(40, 39, 37, 150);
	
	    var tiles = GetTilesWithin(0, 0, layer.width, layer.height, null, layer);
	
	    for (var i = 0; i < tiles.length; i++)
	    {
	        var tile = tiles[i];
	
	        var tw = tile.width;
	        var th = tile.height;
	        var x = tile.pixelX;
	        var y = tile.pixelY;
	
	        var color = tile.collides ? collidingTileColor : tileColor;
	        if (color !== null)
	        {
	            graphics.fillStyle(color.color, color.alpha / 255);
	            graphics.fillRect(x, y, tw, th);
	        }
	
	        // Inset the face line to prevent neighboring tile's lines from overlapping
	        x += 1;
	        y += 1;
	        tw -= 2;
	        th -= 2;
	
	        if (faceColor !== null)
	        {
	            graphics.lineStyle(1, faceColor.color, faceColor.alpha / 255);
	            if (tile.faceTop) { graphics.lineBetween(x, y, x + tw, y); }
	            if (tile.faceRight) { graphics.lineBetween(x + tw, y, x + tw, y + th); }
	            if (tile.faceBottom) { graphics.lineBetween(x, y + th, x + tw, y + th); }
	            if (tile.faceLeft) { graphics.lineBetween(x, y, x, y + th); }
	        }
	    }
	};
	
	module.exports = RenderDebug;


/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var SetTileCollision = __webpack_require__(121);
	var CalculateFacesWithin = __webpack_require__(88);
	var SetLayerCollisionIndex = __webpack_require__(332);
	
	/**
	 * Sets collision on the given tile or tiles within a layer by index. You can pass in either a
	 * single numeric index or an array of indexes: [2, 3, 15, 20]. The `collides` parameter controls if
	 * collision will be enabled (true) or disabled (false).
	 *
	 * @function Phaser.Tilemaps.Components.SetCollision
	 * @private
	 * @since 3.0.0
	 *
	 * @param {(integer|array)} indexes - Either a single tile index, or an array of tile indexes.
	 * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear
	 * collision.
	 * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the
	 * update.
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 */
	var SetCollision = function (indexes, collides, recalculateFaces, layer)
	{
	    if (collides === undefined) { collides = true; }
	    if (recalculateFaces === undefined) { recalculateFaces = true; }
	    if (!Array.isArray(indexes)) { indexes = [ indexes ]; }
	
	    // Update the array of colliding indexes
	    for (var i = 0; i < indexes.length; i++)
	    {
	        SetLayerCollisionIndex(indexes[i], collides, layer);
	    }
	
	    // Update the tiles
	    for (var ty = 0; ty < layer.height; ty++)
	    {
	        for (var tx = 0; tx < layer.width; tx++)
	        {
	            var tile = layer.data[ty][tx];
	
	            if (tile && indexes.indexOf(tile.index) !== -1)
	            {
	                SetTileCollision(tile, collides);
	            }
	        }
	    }
	
	    if (recalculateFaces) { CalculateFacesWithin(0, 0, layer.width, layer.height, layer); }
	};
	
	module.exports = SetCollision;


/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var SetTileCollision = __webpack_require__(121);
	var CalculateFacesWithin = __webpack_require__(88);
	var SetLayerCollisionIndex = __webpack_require__(332);
	
	/**
	 * Sets collision on a range of tiles in a layer whose index is between the specified `start` and
	 * `stop` (inclusive). Calling this with a start value of 10 and a stop value of 14 would set
	 * collision for tiles 10, 11, 12, 13 and 14. The `collides` parameter controls if collision will be
	 * enabled (true) or disabled (false).
	 *
	 * @function Phaser.Tilemaps.Components.SetCollisionBetween
	 * @private
	 * @since 3.0.0
	 *
	 * @param {integer} start - The first index of the tile to be set for collision.
	 * @param {integer} stop - The last index of the tile to be set for collision.
	 * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear
	 * collision.
	 * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the
	 * update.
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 */
	var SetCollisionBetween = function (start, stop, collides, recalculateFaces, layer)
	{
	    if (collides === undefined) { collides = true; }
	    if (recalculateFaces === undefined) { recalculateFaces = true; }
	
	    if (start > stop) { return; }
	
	    // Update the array of colliding indexes
	    for (var index = start; index <= stop; index++)
	    {
	        SetLayerCollisionIndex(index, collides, layer);
	    }
	
	    // Update the tiles
	    for (var ty = 0; ty < layer.height; ty++)
	    {
	        for (var tx = 0; tx < layer.width; tx++)
	        {
	            var tile = layer.data[ty][tx];
	            if (tile)
	            {
	                if (tile.index >= start && tile.index <= stop)
	                {
	                    SetTileCollision(tile, collides);
	                }
	            }
	        }
	    }
	
	    if (recalculateFaces) { CalculateFacesWithin(0, 0, layer.width, layer.height, layer); }
	};
	
	module.exports = SetCollisionBetween;


/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var SetTileCollision = __webpack_require__(121);
	var CalculateFacesWithin = __webpack_require__(88);
	var SetLayerCollisionIndex = __webpack_require__(332);
	
	/**
	 * Sets collision on all tiles in the given layer, except for tiles that have an index specified in
	 * the given array. The `collides` parameter controls if collision will be enabled (true) or
	 * disabled (false).
	 *
	 * @function Phaser.Tilemaps.Components.SetCollisionByExclusion
	 * @private
	 * @since 3.0.0
	 *
	 * @param {integer[]} indexes - An array of the tile indexes to not be counted for collision.
	 * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear
	 * collision.
	 * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the
	 * update.
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 */
	var SetCollisionByExclusion = function (indexes, collides, recalculateFaces, layer)
	{
	    if (collides === undefined) { collides = true; }
	    if (recalculateFaces === undefined) { recalculateFaces = true; }
	    if (!Array.isArray(indexes)) { indexes = [ indexes ]; }
	
	    // Note: this only updates layer.collideIndexes for tile indexes found currently in the layer
	    for (var ty = 0; ty < layer.height; ty++)
	    {
	        for (var tx = 0; tx < layer.width; tx++)
	        {
	            var tile = layer.data[ty][tx];
	            if (tile && indexes.indexOf(tile.index) === -1)
	            {
	                SetTileCollision(tile, collides);
	                SetLayerCollisionIndex(tile.index, collides, layer);
	            }
	        }
	    }
	
	    if (recalculateFaces) { CalculateFacesWithin(0, 0, layer.width, layer.height, layer); }
	};
	
	module.exports = SetCollisionByExclusion;


/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var SetTileCollision = __webpack_require__(121);
	var CalculateFacesWithin = __webpack_require__(88);
	var HasValue = __webpack_require__(147);
	
	/**
	 * Sets collision on the tiles within a layer by checking tile properties. If a tile has a property
	 * that matches the given properties object, its collision flag will be set. The `collides`
	 * parameter controls if collision will be enabled (true) or disabled (false). Passing in
	 * `{ collides: true }` would update the collision flag on any tiles with a "collides" property that
	 * has a value of true. Any tile that doesn't have "collides" set to true will be ignored. You can
	 * also use an array of values, e.g. `{ types: ["stone", "lava", "sand" ] }`. If a tile has a
	 * "types" property that matches any of those values, its collision flag will be updated.
	 *
	 * @function Phaser.Tilemaps.Components.SetCollisionByProperty
	 * @private
	 * @since 3.0.0
	 *
	 * @param {object} properties - An object with tile properties and corresponding values that should
	 * be checked.
	 * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear
	 * collision.
	 * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the
	 * update.
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 */
	var SetCollisionByProperty = function (properties, collides, recalculateFaces, layer)
	{
	    if (collides === undefined) { collides = true; }
	    if (recalculateFaces === undefined) { recalculateFaces = true; }
	
	    for (var ty = 0; ty < layer.height; ty++)
	    {
	        for (var tx = 0; tx < layer.width; tx++)
	        {
	            var tile = layer.data[ty][tx];
	
	            if (!tile) { continue; }
	
	            for (var property in properties)
	            {
	                if (!HasValue(tile.properties, property)) { continue; }
	
	                var values = properties[property];
	                if (!Array.isArray(values))
	                {
	                    values = [ values ];
	                }
	
	                for (var i = 0; i < values.length; i++)
	                {
	                    if (tile.properties[property] === values[i])
	                    {
	                        SetTileCollision(tile, collides);
	                    }
	                }
	            }
	        }
	    }
	
	    if (recalculateFaces) { CalculateFacesWithin(0, 0, layer.width, layer.height, layer); }
	};
	
	module.exports = SetCollisionByProperty;


/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var SetTileCollision = __webpack_require__(121);
	var CalculateFacesWithin = __webpack_require__(88);
	
	/**
	 * Sets collision on the tiles within a layer by checking each tile's collision group data
	 * (typically defined in Tiled within the tileset collision editor). If any objects are found within
	 * a tile's collision group, the tile's colliding information will be set. The `collides` parameter
	 * controls if collision will be enabled (true) or disabled (false).
	 *
	 * @function Phaser.Tilemaps.Components.SetCollisionFromCollisionGroup
	 * @private
	 * @since 3.0.0
	 *
	 * @param {boolean} [collides=true] - If true it will enable collision. If false it will clear
	 * collision.
	 * @param {boolean} [recalculateFaces=true] - Whether or not to recalculate the tile faces after the
	 * update.
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 */
	var SetCollisionFromCollisionGroup = function (collides, recalculateFaces, layer)
	{
	    if (collides === undefined) { collides = true; }
	    if (recalculateFaces === undefined) { recalculateFaces = true; }
	
	    for (var ty = 0; ty < layer.height; ty++)
	    {
	        for (var tx = 0; tx < layer.width; tx++)
	        {
	            var tile = layer.data[ty][tx];
	
	            if (!tile) { continue; }
	
	            var collisionGroup = tile.getCollisionGroup();
	
	            // It's possible in Tiled to have a collision group without any shapes, e.g. create a
	            // shape and then delete the shape.
	            if (collisionGroup && collisionGroup.objects && collisionGroup.objects.length > 0)
	            {
	                SetTileCollision(tile, collides);
	            }
	        }
	    }
	
	    if (recalculateFaces) { CalculateFacesWithin(0, 0, layer.width, layer.height, layer); }
	};
	
	module.exports = SetCollisionFromCollisionGroup;


/***/ }),
/* 1555 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Sets a global collision callback for the given tile index within the layer. This will affect all
	 * tiles on this layer that have the same index. If a callback is already set for the tile index it
	 * will be replaced. Set the callback to null to remove it. If you want to set a callback for a tile
	 * at a specific location on the map then see setTileLocationCallback.
	 *
	 * @function Phaser.Tilemaps.Components.SetTileIndexCallback
	 * @private
	 * @since 3.0.0
	 *
	 * @param {(integer|array)} indexes - Either a single tile index, or an array of tile indexes to have a
	 * collision callback set for.
	 * @param {function} callback - The callback that will be invoked when the tile is collided with.
	 * @param {object} callbackContext - The context under which the callback is called.
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 */
	var SetTileIndexCallback = function (indexes, callback, callbackContext, layer)
	{
	    if (typeof indexes === 'number')
	    {
	        layer.callbacks[indexes] = (callback !== null)
	            ? { callback: callback, callbackContext: callbackContext }
	            : undefined;
	    }
	    else
	    {
	        for (var i = 0, len = indexes.length; i < len; i++)
	        {
	            layer.callbacks[indexes[i]] = (callback !== null)
	                ? { callback: callback, callbackContext: callbackContext }
	                : undefined;
	        }
	    }
	};
	
	module.exports = SetTileIndexCallback;


/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetTilesWithin = __webpack_require__(34);
	
	/**
	 * Sets a collision callback for the given rectangular area (in tile coordinates) within the layer.
	 * If a callback is already set for the tile index it will be replaced. Set the callback to null to
	 * remove it.
	 *
	 * @function Phaser.Tilemaps.Components.SetTileLocationCallback
	 * @private
	 * @since 3.0.0
	 *
	 * @param {integer} [tileX=0] - [description]
	 * @param {integer} [tileY=0] - [description]
	 * @param {integer} [width=max width based on tileX] - [description]
	 * @param {integer} [height=max height based on tileY] - [description]
	 * @param {function} callback - The callback that will be invoked when the tile is collided with.
	 * @param {object} callbackContext - The context under which the callback is called.
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 */
	var SetTileLocationCallback = function (tileX, tileY, width, height, callback, callbackContext, layer)
	{
	    var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
	
	    for (var i = 0; i < tiles.length; i++)
	    {
	        tiles[i].setCollisionCallback(callback, callbackContext);
	    }
	
	};
	
	module.exports = SetTileLocationCallback;


/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetTilesWithin = __webpack_require__(34);
	var ShuffleArray = __webpack_require__(218);
	
	/**
	 * Shuffles the tiles in a rectangular region (specified in tile coordinates) within the given
	 * layer. It will only randomize the tiles in that area, so if they're all the same nothing will
	 * appear to have changed! This method only modifies tile indexes and does not change collision
	 * information.
	 *
	 * @function Phaser.Tilemaps.Components.Shuffle
	 * @private
	 * @since 3.0.0
	 *
	 * @param {integer} [tileX=0] - [description]
	 * @param {integer} [tileY=0] - [description]
	 * @param {integer} [width=max width based on tileX] - [description]
	 * @param {integer} [height=max height based on tileY] - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 */
	var Shuffle = function (tileX, tileY, width, height, layer)
	{
	    var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
	
	    var indexes = tiles.map(function (tile) { return tile.index; });
	    ShuffleArray(indexes);
	
	    for (var i = 0; i < tiles.length; i++)
	    {
	        tiles[i].index = indexes[i];
	    }
	};
	
	module.exports = Shuffle;


/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetTilesWithin = __webpack_require__(34);
	
	/**
	 * Scans the given rectangular area (given in tile coordinates) for tiles with an index matching
	 * `indexA` and swaps then with `indexB`. This only modifies the index and does not change collision
	 * information.
	 *
	 * @function Phaser.Tilemaps.Components.SwapByIndex
	 * @private
	 * @since 3.0.0
	 *
	 * @param {integer} tileA - First tile index.
	 * @param {integer} tileB - Second tile index.
	 * @param {integer} [tileX=0] - [description]
	 * @param {integer} [tileY=0] - [description]
	 * @param {integer} [width=max width based on tileX] - [description]
	 * @param {integer} [height=max height based on tileY] - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 */
	var SwapByIndex = function (indexA, indexB, tileX, tileY, width, height, layer)
	{
	    var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
	    for (var i = 0; i < tiles.length; i++)
	    {
	        if (tiles[i])
	        {
	            if (tiles[i].index === indexA)
	            {
	                tiles[i].index = indexB;
	            }
	            else if (tiles[i].index === indexB)
	            {
	                tiles[i].index = indexA;
	            }
	        }
	    }
	};
	
	module.exports = SwapByIndex;


/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var TileToWorldX = __webpack_require__(213);
	var TileToWorldY = __webpack_require__(214);
	var Vector2 = __webpack_require__(9);
	
	/**
	 * Converts from tile XY coordinates (tile units) to world XY coordinates (pixels), factoring in the
	 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
	 * `point` object.
	 *
	 * @function Phaser.Tilemaps.Components.TileToWorldXY
	 * @private
	 * @since 3.0.0
	 *
	 * @param {integer} tileX - [description]
	 * @param {integer} tileY - [description]
	 * @param {Phaser.Math.Vector2} [point] - [description]
	 * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 * 
	 * @return {Phaser.Math.Vector2} The XY location in world coordinates.
	 */
	var TileToWorldXY = function (tileX, tileY, point, camera, layer)
	{
	    if (point === undefined) { point = new Vector2(0, 0); }
	
	    point.x = TileToWorldX(tileX, camera, layer);
	    point.y = TileToWorldY(tileY, camera, layer);
	
	    return point;
	};
	
	module.exports = TileToWorldXY;


/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetTilesWithin = __webpack_require__(34);
	
	/**
	 * Randomizes the indexes of a rectangular region of tiles (in tile coordinates) within the
	 * specified layer. Each tile will receive a new index. New indexes are drawn from the given
	 * weightedIndexes array. An example weighted array:
	 *
	 * [
	 *  { index: 6, weight: 4 },    // Probability of index 6 is 4 / 8
	 *  { index: 7, weight: 2 },    // Probability of index 7 would be 2 / 8
	 *  { index: 8, weight: 1.5 },  // Probability of index 8 would be 1.5 / 8
	 *  { index: 26, weight: 0.5 }  // Probability of index 27 would be 0.5 / 8
	 * ]
	 *
	 * The probability of any index being choose is (the index's weight) / (sum of all weights). This
	 * method only modifies tile indexes and does not change collision information.
	 *
	 * @function Phaser.Tilemaps.Components.WeightedRandomize
	 * @private
	 * @since 3.0.0
	 *
	 * @param {integer} [tileX=0] - [description]
	 * @param {integer} [tileY=0] - [description]
	 * @param {integer} [width=max width based on tileX] - [description]
	 * @param {integer} [height=max height based on tileY] - [description]
	 * @param {object[]} [weightedIndexes] - An array of objects to randomly draw from during
	 * randomization. They should be in the form: { index: 0, weight: 4 } or
	 * { index: [0, 1], weight: 4 } if you wish to draw from multiple tile indexes.
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 */
	var WeightedRandomize = function (tileX, tileY, width, height, weightedIndexes, layer)
	{
	    if (weightedIndexes === undefined) { return; }
	
	    var i;
	    var tiles = GetTilesWithin(tileX, tileY, width, height, null, layer);
	
	    var weightTotal = 0;
	    for (i = 0; i < weightedIndexes.length; i++)
	    {
	        weightTotal += weightedIndexes[i].weight;
	    }
	
	    if (weightTotal <= 0) { return; }
	
	    for (i = 0; i < tiles.length; i++)
	    {
	        var rand = Math.random() * weightTotal;
	        var sum = 0;
	        var randomIndex = -1;
	        for (var j = 0; j < weightedIndexes.length; j++)
	        {
	            sum += weightedIndexes[j].weight;
	            if (rand <= sum)
	            {
	                var chosen = weightedIndexes[j].index;
	                randomIndex = Array.isArray(chosen)
	                    ? chosen[Math.floor(Math.random() * chosen.length)]
	                    : chosen;
	                break;
	            }
	        }
	
	        tiles[i].index = randomIndex;
	    }
	};
	
	module.exports = WeightedRandomize;


/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var WorldToTileX = __webpack_require__(99);
	var WorldToTileY = __webpack_require__(100);
	var Vector2 = __webpack_require__(9);
	
	/**
	 * Converts from world XY coordinates (pixels) to tile XY coordinates (tile units), factoring in the
	 * layer's position, scale and scroll. This will return a new Vector2 object or update the given
	 * `point` object.
	 *
	 * @function Phaser.Tilemaps.Components.WorldToTileXY
	 * @private
	 * @since 3.0.0
	 *
	 * @param {number} worldX - [description]
	 * @param {number} worldY - [description]
	 * @param {boolean} [snapToFloor=true] - Whether or not to round the tile coordinate down to the
	 * nearest integer.
	 * @param {Phaser.Math.Vector2} [point] - [description]
	 * @param {Phaser.Cameras.Scene2D.Camera} [camera=main camera] - [description]
	 * @param {Phaser.Tilemaps.LayerData} layer - The Tilemap Layer to act upon.
	 * 
	 * @return {Phaser.Math.Vector2} The XY location in tile units.
	 */
	var WorldToTileXY = function (worldX, worldY, snapToFloor, point, camera, layer)
	{
	    if (point === undefined) { point = new Vector2(0, 0); }
	
	    point.x = WorldToTileX(worldX, snapToFloor, camera, layer);
	    point.y = WorldToTileY(worldY, snapToFloor, camera, layer);
	
	    return point;
	};
	
	module.exports = WorldToTileXY;


/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the Canvas Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.Tilemaps.DynamicTilemapLayer#renderCanvas
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
	 * @param {Phaser.Tilemaps.DynamicTilemapLayer} src - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 */
	var DynamicTilemapLayerCanvasRenderer = function (renderer, src, interpolationPercentage, camera)
	{
	    if (GameObject.RENDER_MASK !== src.renderFlags || (src.cameraFilter > 0 && (src.cameraFilter & camera._id)))
	    {
	        return;
	    }
	
	    src.cull(camera);
	
	    var renderTiles = src.culledTiles;
	    var length = renderTiles.length;
	    var image = src.tileset.image.getSourceImage();
	    var tileset = this.tileset;
	
	    var tx = src.x - camera.scrollX * src.scrollFactorX;
	    var ty = src.y - camera.scrollY * src.scrollFactorY;
	    var ctx = renderer.gameContext;
	
	    ctx.save();
	    ctx.translate(tx, ty);
	    ctx.rotate(src.rotation);
	    ctx.scale(src.scaleX, src.scaleY);
	    ctx.scale(src.flipX ? -1 : 1, src.flipY ? -1 : 1);
	
	    for (var index = 0; index < length; ++index)
	    {
	        var tile = renderTiles[index];
	
	        var tileTexCoords = tileset.getTileTextureCoordinates(tile.index);
	        if (tileTexCoords === null) { continue; }
	
	        var halfWidth = tile.width / 2;
	        var halfHeight = tile.height / 2;
	
	        ctx.save();
	        ctx.translate(tile.pixelX + halfWidth, tile.pixelY + halfHeight);
	
	        if (tile.rotation !== 0)
	        {
	            ctx.rotate(tile.rotation);
	        }
	
	        if (tile.flipX || tile.flipY)
	        {
	            ctx.scale(tile.flipX ? -1 : 1, tile.flipY ? -1 : 1);
	        }
	
	        ctx.globalAlpha = src.alpha * tile.alpha;
	
	        ctx.drawImage(
	            image,
	            tileTexCoords.x, tileTexCoords.y,
	            tile.width, tile.height,
	            -halfWidth, -halfHeight,
	            tile.width, tile.height
	        );
	
	        ctx.restore();
	    }
	
	    ctx.restore();
	};
	
	module.exports = DynamicTilemapLayerCanvasRenderer;


/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var renderWebGL = __webpack_require__(6);
	var renderCanvas = __webpack_require__(6);
	
	if (true)
	{
	    renderWebGL = __webpack_require__(1564);
	}
	
	if (true)
	{
	    renderCanvas = __webpack_require__(1562);
	}
	
	module.exports = {
	
	    renderWebGL: renderWebGL,
	    renderCanvas: renderCanvas
	
	};


/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the WebGL Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.Tilemaps.DynamicTilemapLayer#renderWebGL
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
	 * @param {Phaser.Tilemaps.DynamicTilemapLayer} src - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 */
	var DynamicTilemapLayerWebGLRenderer = function (renderer, src, interpolationPercentage, camera)
	{
	    if (GameObject.RENDER_MASK !== src.renderFlags || (src.cameraFilter > 0 && (src.cameraFilter & camera._id)))
	    {
	        return;
	    }
	
	    src.cull(camera);
	
	    this.pipeline.batchDynamicTilemapLayer(src, camera);
	};
	
	module.exports = DynamicTilemapLayerWebGLRenderer;


/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Tilemaps
	 */
	
	module.exports = {
	
	    Components: __webpack_require__(215),
	    Parsers: __webpack_require__(1568),
	
	    Formats: __webpack_require__(57),
	    ImageCollection: __webpack_require__(637),
	    ParseToTilemap: __webpack_require__(329),
	    Tile: __webpack_require__(120),
	    Tilemap: __webpack_require__(638),
	    TilemapCreator: __webpack_require__(1531),
	    TilemapFactory: __webpack_require__(1532),
	    Tileset: __webpack_require__(211),
	
	    LayerData: __webpack_require__(170),
	    MapData: __webpack_require__(171),
	    ObjectLayer: __webpack_require__(643),
	
	    DynamicTilemapLayer: __webpack_require__(642),
	    StaticTilemapLayer: __webpack_require__(650)
	
	};


/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var LayerData = __webpack_require__(170);
	var Tile = __webpack_require__(120);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Tilemaps.Parsers.Impact.ParseTileLayers
	 * @since 3.0.0
	 *
	 * @param {object} json - [description]
	 * @param {boolean} insertNull - [description]
	 *
	 * @return {array} [description]
	 */
	var ParseTileLayers = function (json, insertNull)
	{
	    var tileLayers = [];
	
	    for (var i = 0; i < json.layer.length; i++)
	    {
	        var layer = json.layer[i];
	
	        var layerData = new LayerData({
	            name: layer.name,
	            width: layer.width,
	            height: layer.height,
	            tileWidth: layer.tilesize,
	            tileHeight: layer.tilesize,
	            visible: layer.visible === 1
	        });
	
	        var row = [];
	        var tileGrid = [];
	
	        //  Loop through the data field in the JSON. This is a 2D array containing the tile indexes,
	        //  one after the other. The indexes are relative to the tileset that contains the tile.
	        for (var y = 0; y < layer.data.length; y++)
	        {
	            for (var x = 0; x < layer.data[y].length; x++)
	            {
	                // In Weltmeister, 0 = no tile, but the Tilemap API expects -1 = no tile.
	                var index = layer.data[y][x] - 1;
	
	                var tile;
	
	                if (index > -1)
	                {
	                    tile = new Tile(layerData, index, x, y, layer.tilesize, layer.tilesize);
	                }
	                else
	                {
	                    tile = insertNull
	                        ? null
	                        : new Tile(layerData, -1, x, y, layer.tilesize, layer.tilesize);
	                }
	
	                row.push(tile);
	            }
	
	            tileGrid.push(row);
	            row = [];
	        }
	
	        layerData.data = tileGrid;
	
	        tileLayers.push(layerData);
	    }
	
	    return tileLayers;
	};
	
	module.exports = ParseTileLayers;


/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Tileset = __webpack_require__(211);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Tilemaps.Parsers.Impact.ParseTilesets
	 * @since 3.0.0
	 *
	 * @param {object} json - [description]
	 *
	 * @return {array} [description]
	 */
	var ParseTilesets = function (json)
	{
	    var tilesets = [];
	    var tilesetsNames = [];
	
	    for (var i = 0; i < json.layer.length; i++)
	    {
	        var layer = json.layer[i];
	
	        // A relative filepath to the source image (within Weltmeister) is used for the name
	        var tilesetName = layer.tilesetName;
	
	        // Only add unique tilesets that have a valid name. Collision layers will have a blank name.
	        if (tilesetName !== '' && tilesetsNames.indexOf(tilesetName) === -1)
	        {
	            tilesetsNames.push(tilesetName);
	
	            // Tiles are stored with an ID relative to the tileset, rather than a globally unique ID
	            // across all tilesets. Also, tilesets in Weltmeister have no margin or padding.
	            tilesets.push(new Tileset(tilesetName, 0, layer.tilesize, layer.tilesize, 0, 0));
	        }
	    }
	
	    return tilesets;
	};
	
	module.exports = ParseTilesets;


/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Tilemaps.Parsers
	 */
	
	module.exports = {
	
	    Parse: __webpack_require__(644),
	    Parse2DArray: __webpack_require__(333),
	    ParseCSV: __webpack_require__(645),
	
	    Impact: __webpack_require__(646),
	    Tiled: __webpack_require__(648)
	
	};


/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Extend = __webpack_require__(36);
	
	/**
	 * Copy properties from tileset to tiles.
	 *
	 * @function Phaser.Tilemaps.Parsers.Tiled.AssignTileProperties
	 * @since 3.0.0
	 *
	 * @param {Phaser.Tilemaps.MapData} mapData - [description]
	 */
	var AssignTileProperties = function (mapData)
	{
	    var layerData;
	    var tile;
	    var sid;
	    var set;
	    var row;
	
	    // go through each of the map data layers
	    for (var i = 0; i < mapData.layers.length; i++)
	    {
	        layerData = mapData.layers[i];
	
	        set = null;
	
	        // rows of tiles
	        for (var j = 0; j < layerData.data.length; j++)
	        {
	            row = layerData.data[j];
	
	            // individual tiles
	            for (var k = 0; k < row.length; k++)
	            {
	                tile = row[k];
	
	                if (tile === null || tile.index < 0)
	                {
	                    continue;
	                }
	
	                // find the relevant tileset
	                sid = mapData.tiles[tile.index][2];
	                set = mapData.tilesets[sid];
	
	                // Ensure that a tile's size matches its tileset
	                tile.width = set.tileWidth;
	                tile.height = set.tileHeight;
	
	                // if that tile type has any properties, add them to the tile object
	                if (set.tileProperties && set.tileProperties[tile.index - set.firstgid])
	                {
	                    tile.properties = Extend(
	                        tile.properties, set.tileProperties[tile.index - set.firstgid]
	                    );
	                }
	            }
	        }
	    }
	};
	
	module.exports = AssignTileProperties;


/***/ }),
/* 1570 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Tilemaps.Parsers.Tiled.Base64Decode
	 * @since 3.0.0
	 *
	 * @param {object} data - [description]
	 *
	 * @return {array} [description]
	 */
	var Base64Decode = function (data)
	{
	    var binaryString = window.atob(data);
	    var len = binaryString.length;
	    var bytes = new Array(len / 4);
	
	    // Interpret binaryString as an array of bytes representing little-endian encoded uint32 values.
	    for (var i = 0; i < len; i += 4)
	    {
	        bytes[i / 4] = (
	            binaryString.charCodeAt(i) |
	            binaryString.charCodeAt(i + 1) << 8 |
	            binaryString.charCodeAt(i + 2) << 16 |
	            binaryString.charCodeAt(i + 3) << 24
	        ) >>> 0;
	    }
	
	    return bytes;
	};
	
	module.exports = Base64Decode;


/***/ }),
/* 1571 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Master list of tiles -> x, y, index in tileset.
	 *
	 * @function Phaser.Tilemaps.Parsers.Tiled.BuildTilesetIndex
	 * @since 3.0.0
	 *
	 * @param {Phaser.Tilemaps.MapData} mapData - [description]
	 *
	 * @return {array} [description]
	 */
	var BuildTilesetIndex = function (mapData)
	{
	    var tiles = [];
	
	    for (var i = 0; i < mapData.tilesets.length; i++)
	    {
	        var set = mapData.tilesets[i];
	
	        var x = set.tileMargin;
	        var y = set.tileMargin;
	
	        var count = 0;
	        var countX = 0;
	        var countY = 0;
	
	        for (var t = set.firstgid; t < set.firstgid + set.total; t++)
	        {
	            //  Can add extra properties here as needed
	            tiles[t] = [ x, y, i ];
	
	            x += set.tileWidth + set.tileSpacing;
	
	            count++;
	
	            if (count === set.total)
	            {
	                break;
	            }
	
	            countX++;
	
	            if (countX === set.columns)
	            {
	                x = set.tileMargin;
	                y += set.tileHeight + set.tileSpacing;
	
	                countX = 0;
	                countY++;
	
	                if (countY === set.rows)
	                {
	                    break;
	                }
	            }
	        }
	    }
	
	    return tiles;
	};
	
	module.exports = BuildTilesetIndex;


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetFastValue = __webpack_require__(3);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Tilemaps.Parsers.Tiled.ParseImageLayers
	 * @since 3.0.0
	 *
	 * @param {object} json - [description]
	 *
	 * @return {array} [description]
	 */
	var ParseImageLayers = function (json)
	{
	    var images = [];
	
	    for (var i = 0; i < json.layers.length; i++)
	    {
	        if (json.layers[i].type !== 'imagelayer')
	        {
	            continue;
	        }
	
	        var curi = json.layers[i];
	
	        images.push({
	            name: curi.name,
	            image: curi.image,
	            x: GetFastValue(curi, 'offsetx', 0) + curi.x,
	            y: GetFastValue(curi, 'offsety', 0) + curi.y,
	            alpha: curi.opacity,
	            visible: curi.visible,
	            properties: GetFastValue(curi, 'properties', {})
	        });
	    }
	
	    return images;
	};
	
	module.exports = ParseImageLayers;


/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetFastValue = __webpack_require__(3);
	var ParseObject = __webpack_require__(649);
	var ObjectLayer = __webpack_require__(643);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Tilemaps.Parsers.Tiled.ParseObjectLayers
	 * @since 3.0.0
	 *
	 * @param {object} json - [description]
	 *
	 * @return {array} [description]
	 */
	var ParseObjectLayers = function (json)
	{
	    var objectLayers = [];
	
	    for (var i = 0; i < json.layers.length; i++)
	    {
	        if (json.layers[i].type !== 'objectgroup')
	        {
	            continue;
	        }
	
	        var curo = json.layers[i];
	        var offsetX = GetFastValue(curo, 'offsetx', 0);
	        var offsetY = GetFastValue(curo, 'offsety', 0);
	        var objects = [];
	
	        for (var j = 0; j < curo.objects.length; j++)
	        {
	            var parsedObject = ParseObject(curo.objects[j], offsetX, offsetY);
	
	            objects.push(parsedObject);
	        }
	
	        var objectLayer = new ObjectLayer(curo);
	        objectLayer.objects = objects;
	
	        objectLayers.push(objectLayer);
	    }
	
	    return objectLayers;
	};
	
	module.exports = ParseObjectLayers;


/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Base64Decode = __webpack_require__(1570);
	var GetFastValue = __webpack_require__(3);
	var LayerData = __webpack_require__(170);
	var ParseGID = __webpack_require__(647);
	var Tile = __webpack_require__(120);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Tilemaps.Parsers.Tiled.ParseTileLayers
	 * @since 3.0.0
	 *
	 * @param {object} json - [description]
	 * @param {boolean} insertNull - [description]
	 *
	 * @return {array} [description]
	 */
	var ParseTileLayers = function (json, insertNull)
	{
	    var tileLayers = [];
	
	    for (var i = 0; i < json.layers.length; i++)
	    {
	        if (json.layers[i].type !== 'tilelayer')
	        {
	            continue;
	        }
	
	        var curl = json.layers[i];
	
	        // Base64 decode data if necessary. NOTE: uncompressed base64 only.
	        if (curl.compression)
	        {
	            console.warn(
	                'TilemapParser.parseTiledJSON - Layer compression is unsupported, skipping layer \''
	                + curl.name + '\''
	            );
	            continue;
	        }
	        else if (curl.encoding && curl.encoding === 'base64')
	        {
	            curl.data = Base64Decode(curl.data);
	            delete curl.encoding; // Allow the same map to be parsed multiple times
	        }
	
	        var layerData = new LayerData({
	            name: curl.name,
	            x: GetFastValue(curl, 'offsetx', 0) + curl.x,
	            y: GetFastValue(curl, 'offsety', 0) + curl.y,
	            width: curl.width,
	            height: curl.height,
	            tileWidth: json.tilewidth,
	            tileHeight: json.tileheight,
	            alpha: curl.opacity,
	            visible: curl.visible,
	            properties: GetFastValue(curl, 'properties', {})
	        });
	
	        var x = 0;
	        var row = [];
	        var output = [];
	
	        //  Loop through the data field in the JSON.
	
	        //  This is an array containing the tile indexes, one after the other. -1 = no tile,
	        //  everything else = the tile index (starting at 1 for Tiled, 0 for CSV) If the map
	        //  contains multiple tilesets then the indexes are relative to that which the set starts
	        //  from. Need to set which tileset in the cache = which tileset in the JSON, if you do this
	        //  manually it means you can use the same map data but a new tileset.
	
	        for (var t = 0, len = curl.data.length; t < len; t++)
	        {
	            var gidInfo = ParseGID(curl.data[t]);
	
	            //  index, x, y, width, height
	            if (gidInfo.gid > 0)
	            {
	                var tile = new Tile(layerData, gidInfo.gid, x, output.length, json.tilewidth,
	                    json.tileheight);
	
	                // Turning Tiled's FlippedHorizontal, FlippedVertical and FlippedAntiDiagonal
	                // propeties into flipX, flipY and rotation
	                tile.rotation = gidInfo.rotation;
	                tile.flipX = gidInfo.flipped;
	
	                row.push(tile);
	            }
	            else
	            {
	                var blankTile = insertNull
	                    ? null
	                    : new Tile(layerData, -1, x, output.length, json.tilewidth, json.tileheight);
	                row.push(blankTile);
	            }
	
	            x++;
	
	            if (x === curl.width)
	            {
	                output.push(row);
	                x = 0;
	                row = [];
	            }
	        }
	
	        layerData.data = output;
	
	        tileLayers.push(layerData);
	    }
	
	    return tileLayers;
	};
	
	module.exports = ParseTileLayers;


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Tileset = __webpack_require__(211);
	var ImageCollection = __webpack_require__(637);
	var ParseObject = __webpack_require__(649);
	
	/**
	 * Tilesets & Image Collections
	 *
	 * @function Phaser.Tilemaps.Parsers.Tiled.ParseTilesets
	 * @since 3.0.0
	 *
	 * @param {object} json - [description]
	 *
	 * @return {object} [description]
	 */
	var ParseTilesets = function (json)
	{
	    var tilesets = [];
	    var imageCollections = [];
	    var lastSet = null;
	    var stringID;
	
	    for (var i = 0; i < json.tilesets.length; i++)
	    {
	        //  name, firstgid, width, height, margin, spacing, properties
	        var set = json.tilesets[i];
	
	        if (set.source)
	        {
	            console.warn('Phaser can\'t load external tilesets. Use the Embed Tileset button and then export the map again.');
	        }
	        else if (set.image)
	        {
	            var newSet = new Tileset(set.name, set.firstgid, set.tilewidth, set.tileheight, set.margin, set.spacing);
	
	            // Properties stored per-tile in object with string indexes starting at "0"
	            if (set.tileproperties)
	            {
	                newSet.tileProperties = set.tileproperties;
	            }
	
	            // Object & terrain shapes stored per-tile in object with string indexes starting at "0"
	            if (set.tiles)
	            {
	                newSet.tileData = set.tiles;
	
	                // Parse the objects into Phaser format to match handling of other Tiled objects
	                for (stringID in newSet.tileData)
	                {
	                    var objectGroup = newSet.tileData[stringID].objectgroup;
	                    if (objectGroup && objectGroup.objects)
	                    {
	                        var parsedObjects = objectGroup.objects.map(
	                            function (obj) { return ParseObject(obj); }
	                        );
	                        newSet.tileData[stringID].objectgroup.objects = parsedObjects;
	                    }
	                }
	            }
	
	            // For a normal sliced tileset the row/count/size information is computed when updated.
	            // This is done (again) after the image is set.
	            newSet.updateTileData(set.imagewidth, set.imageheight);
	
	            tilesets.push(newSet);
	        }
	        else
	        {
	            var newCollection = new ImageCollection(set.name, set.firstgid, set.tilewidth,
	                set.tileheight, set.margin, set.spacing, set.properties);
	
	            for (stringID in set.tiles)
	            {
	                var image = set.tiles[stringID].image;
	                var gid = set.firstgid + parseInt(stringID, 10);
	                newCollection.addImage(gid, image);
	            }
	
	            imageCollections.push(newCollection);
	        }
	
	        //  We've got a new Tileset, so set the lastgid into the previous one
	        if (lastSet)
	        {
	            lastSet.lastgid = set.firstgid - 1;
	        }
	
	        lastSet = set;
	    }
	
	    return { tilesets: tilesets, imageCollections: imageCollections };
	};
	
	module.exports = ParseTilesets;


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var HasValue = __webpack_require__(147);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Tilemaps.Parsers.Tiled.Pick
	 * @since 3.0.0
	 *
	 * @param {object} object - [description]
	 * @param {array} keys - [description]
	 *
	 * @return {object} [description]
	 */
	var Pick = function (object, keys)
	{
	    var obj = {};
	
	    for (var i = 0; i < keys.length; i++)
	    {
	        var key = keys[i];
	
	        if (HasValue(object, key))
	        {
	            obj[key] = object[key];
	        }
	    }
	
	    return obj;
	};
	
	module.exports = Pick;


/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the Canvas Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.Tilemaps.StaticTilemapLayer#renderCanvas
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.Canvas.CanvasRenderer} renderer - A reference to the current active Canvas renderer.
	 * @param {Phaser.Tilemaps.StaticTilemapLayer} src - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 */
	var StaticTilemapLayerCanvasRenderer = function (renderer, src, interpolationPercentage, camera)
	{
	    if (GameObject.RENDER_MASK !== src.renderFlags || (src.cameraFilter > 0 && (src.cameraFilter & camera._id)))
	    {
	        return;
	    }
	
	    src.cull(camera);
	
	    var renderTiles = src.culledTiles;
	    var tileset = this.tileset;
	    var ctx = renderer.gameContext;
	    var tileCount = renderTiles.length;
	    var image = tileset.image.getSourceImage();
	    var tx = src.x - camera.scrollX * src.scrollFactorX;
	    var ty = src.y - camera.scrollY * src.scrollFactorY;
	
	    ctx.save();
	    ctx.translate(tx, ty);
	    ctx.rotate(src.rotation);
	    ctx.scale(src.scaleX, src.scaleY);
	    ctx.scale(src.flipX ? -1 : 1, src.flipY ? -1 : 1);
	    ctx.globalAlpha = src.alpha;
	
	    for (var index = 0; index < tileCount; ++index)
	    {
	        var tile = renderTiles[index];
	
	        var tileTexCoords = tileset.getTileTextureCoordinates(tile.index);
	
	        if (tileTexCoords === null) { continue; }
	
	        ctx.drawImage(
	            image,
	            tileTexCoords.x, tileTexCoords.y,
	            tile.width, tile.height,
	            tile.pixelX, tile.pixelY,
	            tile.width, tile.height
	        );
	    }
	
	    ctx.restore();
	};
	
	module.exports = StaticTilemapLayerCanvasRenderer;


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var renderWebGL = __webpack_require__(6);
	var renderCanvas = __webpack_require__(6);
	
	if (true)
	{
	    renderWebGL = __webpack_require__(1579);
	}
	
	if (true)
	{
	    renderCanvas = __webpack_require__(1577);
	}
	
	module.exports = {
	
	    renderWebGL: renderWebGL,
	    renderCanvas: renderCanvas
	
	};


/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GameObject = __webpack_require__(5);
	
	/**
	 * Renders this Game Object with the WebGL Renderer to the given Camera.
	 * The object will not render if any of its renderFlags are set or it is being actively filtered out by the Camera.
	 * This method should not be called directly. It is a utility function of the Render module.
	 *
	 * @method Phaser.Tilemaps.StaticTilemapLayer#renderWebGL
	 * @since 3.0.0
	 * @private
	 *
	 * @param {Phaser.Renderer.WebGL.WebGLRenderer} renderer - A reference to the current active WebGL renderer.
	 * @param {Phaser.Tilemaps.StaticTilemapLayer} src - The Game Object being rendered in this call.
	 * @param {number} interpolationPercentage - Reserved for future use and custom pipelines.
	 * @param {Phaser.Cameras.Scene2D.Camera} camera - The Camera that is rendering the Game Object.
	 */
	var StaticTilemapLayerWebGLRenderer = function (renderer, src, interpolationPercentage, camera)
	{
	    if (GameObject.RENDER_MASK !== src.renderFlags || (src.cameraFilter > 0 && (src.cameraFilter & camera._id)))
	    {
	        return;
	    }
	
	    src.upload(camera);
	
	    this.pipeline.drawStaticTilemapLayer(src, camera);
	};
	
	module.exports = StaticTilemapLayerWebGLRenderer;


/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var PluginCache = __webpack_require__(29);
	var TimerEvent = __webpack_require__(651);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class Clock
	 * @memberOf Phaser.Time
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - [description]
	 */
	var Clock = new Class({
	
	    initialize:
	
	    function Clock (scene)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Time.Clock#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Time.Clock#systems
	         * @type {Phaser.Scenes.Systems}
	         * @since 3.0.0
	         */
	        this.systems = scene.sys;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Time.Clock#now
	         * @type {number}
	         * @since 3.0.0
	         */
	        this.now = Date.now();
	
	        //  Scale the delta time coming into the Clock by this factor
	        //  which then influences anything using this Clock for calculations, like TimerEvents
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Time.Clock#timeScale
	         * @type {float}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.timeScale = 1;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Time.Clock#paused
	         * @type {boolean}
	         * @default false
	         * @since 3.0.0
	         */
	        this.paused = false;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Time.Clock#_active
	         * @type {Phaser.Time.TimerEvent[]}
	         * @private
	         * @default []
	         * @since 3.0.0
	         */
	        this._active = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Time.Clock#_pendingInsertion
	         * @type {Phaser.Time.TimerEvent[]}
	         * @private
	         * @default []
	         * @since 3.0.0
	         */
	        this._pendingInsertion = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Time.Clock#_pendingRemoval
	         * @type {Phaser.Time.TimerEvent[]}
	         * @private
	         * @default []
	         * @since 3.0.0
	         */
	        this._pendingRemoval = [];
	
	        scene.sys.events.once('boot', this.boot, this);
	        scene.sys.events.on('start', this.start, this);
	    },
	
	    /**
	     * This method is called automatically, only once, when the Scene is first created.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.Time.Clock#boot
	     * @private
	     * @since 3.5.1
	     */
	    boot: function ()
	    {
	        this.systems.events.once('destroy', this.destroy, this);
	    },
	
	    /**
	     * This method is called automatically by the Scene when it is starting up.
	     * It is responsible for creating local systems, properties and listening for Scene events.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.Time.Clock#start
	     * @private
	     * @since 3.5.0
	     */
	    start: function ()
	    {
	        var eventEmitter = this.systems.events;
	
	        eventEmitter.on('preupdate', this.preUpdate, this);
	        eventEmitter.on('update', this.update, this);
	        eventEmitter.once('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Time.Clock#addEvent
	     * @since 3.0.0
	     *
	     * @param {TimerEventConfig} config - [description]
	     *
	     * @return {Phaser.Time.TimerEvent} [description]
	     */
	    addEvent: function (config)
	    {
	        var event = new TimerEvent(config);
	
	        this._pendingInsertion.push(event);
	
	        return event;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Time.Clock#delayedCall
	     * @since 3.0.0
	     *
	     * @param {number} delay - [description]
	     * @param {function} callback - [description]
	     * @param {Array.<*>} args - [description]
	     * @param {*} callbackScope - [description]
	     *
	     * @return {Phaser.Time.TimerEvent} [description]
	     */
	    delayedCall: function (delay, callback, args, callbackScope)
	    {
	        return this.addEvent({ delay: delay, callback: callback, args: args, callbackScope: callbackScope });
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Time.Clock#clearPendingEvents
	     * @since 3.0.0
	     *
	     * @return {Phaser.Time.Clock} [description]
	     */
	    clearPendingEvents: function ()
	    {
	        this._pendingInsertion = [];
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Time.Clock#removeAllEvents
	     * @since 3.0.0
	     *
	     * @return {Phaser.Time.Clock} [description]
	     */
	    removeAllEvents: function ()
	    {
	        this._pendingRemoval = this._pendingRemoval.concat(this._active);
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Time.Clock#preUpdate
	     * @since 3.0.0
	     *
	     * @param {number} time - [description]
	     * @param {number} delta - [description]
	     */
	    preUpdate: function ()
	    {
	        var toRemove = this._pendingRemoval.length;
	        var toInsert = this._pendingInsertion.length;
	
	        if (toRemove === 0 && toInsert === 0)
	        {
	            //  Quick bail
	            return;
	        }
	
	        var i;
	        var event;
	
	        //  Delete old events
	        for (i = 0; i < toRemove; i++)
	        {
	            event = this._pendingRemoval[i];
	
	            var index = this._active.indexOf(event);
	
	            if (index > -1)
	            {
	                this._active.splice(index, 1);
	            }
	
	            //  Pool them?
	            event.destroy();
	        }
	
	        for (i = 0; i < toInsert; i++)
	        {
	            event = this._pendingInsertion[i];
	
	            this._active.push(event);
	        }
	
	        //  Clear the lists
	        this._pendingRemoval.length = 0;
	        this._pendingInsertion.length = 0;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Time.Clock#update
	     * @since 3.0.0
	     *
	     * @param {number} time - [description]
	     * @param {number} delta - [description]
	     */
	    update: function (time, delta)
	    {
	        this.now = time;
	
	        if (this.paused)
	        {
	            return;
	        }
	
	        delta *= this.timeScale;
	
	        for (var i = 0; i < this._active.length; i++)
	        {
	            var event = this._active[i];
	
	            if (event.paused)
	            {
	                continue;
	            }
	
	            //  Use delta time to increase elapsed.
	            //  Avoids needing to adjust for pause / resume.
	            //  Automatically smoothed by TimeStep class.
	            //  In testing accurate to +- 1ms!
	            event.elapsed += delta * event.timeScale;
	
	            if (event.elapsed >= event.delay)
	            {
	                var remainder = event.elapsed - event.delay;
	
	                //  Limit it, in case it's checked in the callback
	                event.elapsed = event.delay;
	
	                //  Process the event
	                if (!event.hasDispatched && event.callback)
	                {
	                    event.hasDispatched = true;
	                    event.callback.apply(event.callbackScope, event.args);
	                }
	
	                if (event.repeatCount > 0)
	                {
	                    event.repeatCount--;
	
	                    event.elapsed = remainder;
	                    event.hasDispatched = false;
	                }
	                else
	                {
	                    this._pendingRemoval.push(event);
	                }
	            }
	        }
	    },
	
	    /**
	     * The Scene that owns this plugin is shutting down.
	     * We need to kill and reset all internal properties as well as stop listening to Scene events.
	     *
	     * @method Phaser.Time.Clock#shutdown
	     * @private
	     * @since 3.0.0
	     */
	    shutdown: function ()
	    {
	        var i;
	
	        for (i = 0; i < this._pendingInsertion.length; i++)
	        {
	            this._pendingInsertion[i].destroy();
	        }
	
	        for (i = 0; i < this._active.length; i++)
	        {
	            this._active[i].destroy();
	        }
	
	        for (i = 0; i < this._pendingRemoval.length; i++)
	        {
	            this._pendingRemoval[i].destroy();
	        }
	
	        this._active.length = 0;
	        this._pendingRemoval.length = 0;
	        this._pendingInsertion.length = 0;
	
	        var eventEmitter = this.systems.events;
	
	        eventEmitter.off('preupdate', this.preUpdate, this);
	        eventEmitter.off('update', this.update, this);
	        eventEmitter.off('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * The Scene that owns this plugin is being destroyed.
	     * We need to shutdown and then kill off all external references.
	     *
	     * @method Phaser.Time.Clock#destroy
	     * @private
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.shutdown();
	
	        this.scene.sys.events.off('start', this.start, this);
	
	        this.scene = null;
	        this.systems = null;
	    }
	
	});
	
	PluginCache.register('Clock', Clock, 'time');
	
	module.exports = Clock;


/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Time
	 */
	
	module.exports = {
	
	    Clock: __webpack_require__(1580),
	    TimerEvent: __webpack_require__(651)
	
	};


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Class = __webpack_require__(1);
	var NumberTweenBuilder = __webpack_require__(655);
	var PluginCache = __webpack_require__(29);
	var TimelineBuilder = __webpack_require__(656);
	var TWEEN_CONST = __webpack_require__(174);
	var TweenBuilder = __webpack_require__(217);
	
	/**
	 * @classdesc
	 * [description]
	 *
	 * @class TweenManager
	 * @memberOf Phaser.Tweens
	 * @constructor
	 * @since 3.0.0
	 *
	 * @param {Phaser.Scene} scene - [description]
	 */
	var TweenManager = new Class({
	
	    initialize:
	
	    function TweenManager (scene)
	    {
	        /**
	         * [description]
	         *
	         * @name Phaser.Tweens.TweenManager#scene
	         * @type {Phaser.Scene}
	         * @since 3.0.0
	         */
	        this.scene = scene;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tweens.TweenManager#systems
	         * @type {Phaser.Scenes.Systems}
	         * @since 3.0.0
	         */
	        this.systems = scene.sys;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tweens.TweenManager#timeScale
	         * @type {number}
	         * @default 1
	         * @since 3.0.0
	         */
	        this.timeScale = 1;
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tweens.TweenManager#_add
	         * @type {array}
	         * @private
	         * @since 3.0.0
	         */
	        this._add = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tweens.TweenManager#_pending
	         * @type {array}
	         * @private
	         * @since 3.0.0
	         */
	        this._pending = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tweens.TweenManager#_active
	         * @type {array}
	         * @private
	         * @since 3.0.0
	         */
	        this._active = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tweens.TweenManager#_destroy
	         * @type {array}
	         * @private
	         * @since 3.0.0
	         */
	        this._destroy = [];
	
	        /**
	         * [description]
	         *
	         * @name Phaser.Tweens.TweenManager#_toProcess
	         * @type {integer}
	         * @private
	         * @default 0
	         * @since 3.0.0
	         */
	        this._toProcess = 0;
	
	        scene.sys.events.once('boot', this.boot, this);
	        scene.sys.events.on('start', this.start, this);
	    },
	
	    /**
	     * This method is called automatically, only once, when the Scene is first created.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.Tweens.TweenManager#boot
	     * @private
	     * @since 3.5.1
	     */
	    boot: function ()
	    {
	        this.systems.events.once('destroy', this.destroy, this);
	    },
	
	    /**
	     * This method is called automatically by the Scene when it is starting up.
	     * It is responsible for creating local systems, properties and listening for Scene events.
	     * Do not invoke it directly.
	     *
	     * @method Phaser.Tweens.TweenManager#start
	     * @private
	     * @since 3.5.0
	     */
	    start: function ()
	    {
	        var eventEmitter = this.systems.events;
	
	        eventEmitter.on('preupdate', this.preUpdate, this);
	        eventEmitter.on('update', this.update, this);
	        eventEmitter.once('shutdown', this.shutdown, this);
	
	        this.timeScale = 1;
	    },
	
	    /**
	     * Create a Tween Timeline and return it, but do NOT add it to the active or pending Tween lists.
	     *
	     * @method Phaser.Tweens.TweenManager#createTimeline
	     * @since 3.0.0
	     *
	     * @param {object} config - [description]
	     *
	     * @return {Phaser.Tweens.Timeline} [description]
	     */
	    createTimeline: function (config)
	    {
	        return TimelineBuilder(this, config);
	    },
	
	    /**
	     * Create a Tween Timeline and add it to the active Tween list/
	     *
	     * @method Phaser.Tweens.TweenManager#timeline
	     * @since 3.0.0
	     *
	     * @param {object} config - [description]
	     *
	     * @return {Phaser.Tweens.Timeline} [description]
	     */
	    timeline: function (config)
	    {
	        var timeline = TimelineBuilder(this, config);
	
	        if (!timeline.paused)
	        {
	            this._add.push(timeline);
	
	            this._toProcess++;
	        }
	
	        return timeline;
	    },
	
	    /**
	     * Create a Tween and return it, but do NOT add it to the active or pending Tween lists.
	     *
	     * @method Phaser.Tweens.TweenManager#create
	     * @since 3.0.0
	     *
	     * @param {object} config - [description]
	     *
	     * @return {Phaser.Tweens.Tween} [description]
	     */
	    create: function (config)
	    {
	        return TweenBuilder(this, config);
	    },
	
	    /**
	     * Create a Tween and add it to the active Tween list.
	     *
	     * @method Phaser.Tweens.TweenManager#add
	     * @since 3.0.0
	     *
	     * @param {object} config - [description]
	     *
	     * @return {Phaser.Tweens.Tween} [description]
	     */
	    add: function (config)
	    {
	        var tween = TweenBuilder(this, config);
	
	        this._add.push(tween);
	
	        this._toProcess++;
	
	        return tween;
	    },
	
	    /**
	     * Add an existing tween into the active Tween list.
	     *
	     * @method Phaser.Tweens.TweenManager#existing
	     * @since 3.0.0
	     *
	     * @param {Phaser.Tweens.Tween} tween - [description]
	     *
	     * @return {Phaser.Tweens.TweenManager} This Tween Manager object.
	     */
	    existing: function (tween)
	    {
	        this._add.push(tween);
	
	        this._toProcess++;
	
	        return this;
	    },
	
	    /**
	     * Create a Tween and add it to the active Tween list.
	     *
	     * @method Phaser.Tweens.TweenManager#addCounter
	     * @since 3.0.0
	     *
	     * @param {object} config - [description]
	     *
	     * @return {Phaser.Tweens.Tween} [description]
	     */
	    addCounter: function (config)
	    {
	        var tween = NumberTweenBuilder(this, config);
	
	        this._add.push(tween);
	
	        this._toProcess++;
	
	        return tween;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.TweenManager#preUpdate
	     * @since 3.0.0
	     */
	    preUpdate: function ()
	    {
	        if (this._toProcess === 0)
	        {
	            //  Quick bail
	            return;
	        }
	
	        var list = this._destroy;
	        var active = this._active;
	        var i;
	        var tween;
	
	        //  Clear the 'destroy' list
	        for (i = 0; i < list.length; i++)
	        {
	            tween = list[i];
	
	            //  Remove from the 'active' array
	            var idx = active.indexOf(tween);
	
	            if (idx !== -1)
	            {
	                tween.state = TWEEN_CONST.REMOVED;
	                active.splice(idx, 1);
	            }
	        }
	
	        list.length = 0;
	
	        //  Process the addition list
	        //  This stops callbacks and out of sync events from populating the active array mid-way during the update
	
	        list = this._add;
	
	        for (i = 0; i < list.length; i++)
	        {
	            tween = list[i];
	
	            if (tween.state === TWEEN_CONST.PENDING_ADD)
	            {
	                //  Return true if the Tween should be started right away, otherwise false
	                if (tween.init())
	                {
	                    tween.play();
	
	                    this._active.push(tween);
	                }
	                else
	                {
	                    this._pending.push(tween);
	                }
	            }
	        }
	
	        list.length = 0;
	
	        this._toProcess = 0;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.TweenManager#update
	     * @since 3.0.0
	     *
	     * @param {number} timestamp - [description]
	     * @param {number} delta - [description]
	     */
	    update: function (timestamp, delta)
	    {
	        //  Process active tweens
	        var list = this._active;
	        var tween;
	
	        //  Scale the delta
	        delta *= this.timeScale;
	
	        for (var i = 0; i < list.length; i++)
	        {
	            tween = list[i];
	
	            //  If Tween.update returns 'true' then it means it has completed,
	            //  so move it to the destroy list
	            if (tween.update(timestamp, delta))
	            {
	                this._destroy.push(tween);
	                this._toProcess++;
	            }
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.TweenManager#makeActive
	     * @since 3.0.0
	     *
	     * @param {Phaser.Tweens.Tween} tween - [description]
	     *
	     * @return {Phaser.Tweens.TweenManager} This Tween Manager object.
	     */
	    makeActive: function (tween)
	    {
	        if (this._add.indexOf(tween) !== -1 || this._active.indexOf(tween) !== -1)
	        {
	            return;
	        }
	
	        var idx = this._pending.indexOf(tween);
	
	        if (idx !== -1)
	        {
	            this._pending.splice(idx, 1);
	        }
	
	        this._add.push(tween);
	
	        tween.state = TWEEN_CONST.PENDING_ADD;
	
	        this._toProcess++;
	
	        return this;
	    },
	
	    /**
	     * Passes all Tweens to the given callback.
	     *
	     * @method Phaser.Tweens.TweenManager#each
	     * @since 3.0.0
	     *
	     * @param {function} callback - [description]
	     * @param {object} [scope] - [description]
	     * @param {...*} [args] - [description]
	     */
	    each: function (callback, scope)
	    {
	        var args = [ null ];
	
	        for (var i = 1; i < arguments.length; i++)
	        {
	            args.push(arguments[i]);
	        }
	
	        for (var texture in this.list)
	        {
	            args[0] = this.list[texture];
	
	            callback.apply(scope, args);
	        }
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.TweenManager#getAllTweens
	     * @since 3.0.0
	     *
	     * @return {Phaser.Tweens.Tween[]} [description]
	     */
	    getAllTweens: function ()
	    {
	        var list = this._active;
	        var output = [];
	
	        for (var i = 0; i < list.length; i++)
	        {
	            output.push(list[i]);
	        }
	
	        return output;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.TweenManager#getGlobalTimeScale
	     * @since 3.0.0
	     *
	     * @return {number} [description]
	     */
	    getGlobalTimeScale: function ()
	    {
	        return this.timeScale;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.TweenManager#getTweensOf
	     * @since 3.0.0
	     *
	     * @param {(object|array)} target - [description]
	     *
	     * @return {Phaser.Tweens.Tween[]} [description]
	     */
	    getTweensOf: function (target)
	    {
	        var list = this._active;
	        var tween;
	        var output = [];
	        var i;
	
	        if (Array.isArray(target))
	        {
	            for (i = 0; i < list.length; i++)
	            {
	                tween = list[i];
	
	                for (var t = 0; t < target.length; i++)
	                {
	                    if (tween.hasTarget(target[t]))
	                    {
	                        output.push(tween);
	                    }
	                }
	            }
	        }
	        else
	        {
	            for (i = 0; i < list.length; i++)
	            {
	                tween = list[i];
	
	                if (tween.hasTarget(target))
	                {
	                    output.push(tween);
	                }
	            }
	        }
	
	        return output;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.TweenManager#isTweening
	     * @since 3.0.0
	     *
	     * @param {object} target - [description]
	     *
	     * @return {boolean} [description]
	     */
	    isTweening: function (target)
	    {
	        var list = this._active;
	        var tween;
	
	        for (var i = 0; i < list.length; i++)
	        {
	            tween = list[i];
	
	            if (tween.hasTarget(target) && tween.isPlaying())
	            {
	                return true;
	            }
	        }
	
	        return false;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.TweenManager#killAll
	     * @since 3.0.0
	     *
	     * @return {Phaser.Tweens.TweenManager} [description]
	     */
	    killAll: function ()
	    {
	        var tweens = this.getAllTweens();
	
	        for (var i = 0; i < tweens.length; i++)
	        {
	            tweens[i].stop();
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.TweenManager#killTweensOf
	     * @since 3.0.0
	     *
	     * @param {(object|array)} target - [description]
	     *
	     * @return {Phaser.Tweens.TweenManager} [description]
	     */
	    killTweensOf: function (target)
	    {
	        var tweens = this.getTweensOf(target);
	
	        for (var i = 0; i < tweens.length; i++)
	        {
	            tweens[i].stop();
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.TweenManager#pauseAll
	     * @since 3.0.0
	     *
	     * @return {Phaser.Tweens.TweenManager} [description]
	     */
	    pauseAll: function ()
	    {
	        var list = this._active;
	
	        for (var i = 0; i < list.length; i++)
	        {
	            list[i].pause();
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.TweenManager#resumeAll
	     * @since 3.0.0
	     *
	     * @return {Phaser.Tweens.TweenManager} [description]
	     */
	    resumeAll: function ()
	    {
	        var list = this._active;
	
	        for (var i = 0; i < list.length; i++)
	        {
	            list[i].resume();
	        }
	
	        return this;
	    },
	
	    /**
	     * [description]
	     *
	     * @method Phaser.Tweens.TweenManager#setGlobalTimeScale
	     * @since 3.0.0
	     *
	     * @param {float} value - [description]
	     *
	     * @return {Phaser.Tweens.TweenManager} [description]
	     */
	    setGlobalTimeScale: function (value)
	    {
	        this.timeScale = value;
	
	        return this;
	    },
	
	    /**
	     * The Scene that owns this plugin is shutting down.
	     * We need to kill and reset all internal properties as well as stop listening to Scene events.
	     *
	     * @method Phaser.Tweens.TweenManager#shutdown
	     * @since 3.0.0
	     */
	    shutdown: function ()
	    {
	        this.killAll();
	
	        this._add = [];
	        this._pending = [];
	        this._active = [];
	        this._destroy = [];
	
	        this._toProcess = 0;
	
	        var eventEmitter = this.systems.events;
	
	        eventEmitter.off('preupdate', this.preUpdate, this);
	        eventEmitter.off('update', this.update, this);
	        eventEmitter.off('shutdown', this.shutdown, this);
	    },
	
	    /**
	     * The Scene that owns this plugin is being destroyed.
	     * We need to shutdown and then kill off all external references.
	     *
	     * @method Phaser.Tweens.TweenManager#destroy
	     * @since 3.0.0
	     */
	    destroy: function ()
	    {
	        this.shutdown();
	
	        this.scene.sys.events.off('start', this.start, this);
	
	        this.scene = null;
	        this.systems = null;
	    }
	
	});
	
	PluginCache.register('TweenManager', TweenManager, 'tweens');
	
	module.exports = TweenManager;


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Tweens.Builders
	 */
	
	module.exports = {
	
	    GetBoolean: __webpack_require__(172),
	    GetEaseFunction: __webpack_require__(173),
	    GetNewValue: __webpack_require__(216),
	    GetProps: __webpack_require__(653),
	    GetTargets: __webpack_require__(334),
	    GetTweens: __webpack_require__(654),
	    GetValueOp: __webpack_require__(335),
	    NumberTweenBuilder: __webpack_require__(655),
	    TimelineBuilder: __webpack_require__(656),
	    TweenBuilder: __webpack_require__(217)
	
	};


/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var CONST = __webpack_require__(174);
	var Extend = __webpack_require__(36);
	
	/**
	 * @namespace Phaser.Tweens
	 */
	
	var Tweens = {
	
	    Builders: __webpack_require__(1583),
	
	    TweenManager: __webpack_require__(1582),
	    Tween: __webpack_require__(337),
	    TweenData: __webpack_require__(338),
	    Timeline: __webpack_require__(652)
	
	};
	
	//   Merge in the consts
	Tweens = Extend(false, Tweens, CONST);
	
	module.exports = Tweens;


/***/ }),
/* 1585 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	//  RESERVED properties that a Tween config object uses
	
	//  completeDelay: The time the tween will wait before the onComplete event is dispatched once it has completed
	//  delay: The time the tween will wait before it first starts
	//  duration: The duration of the tween
	//  ease: The ease function used by the tween
	//  easeParams: The parameters to go with the ease function (if any)
	//  flipX: flip X the GameObject on tween end
	//  flipY: flip Y the GameObject on tween end//  hold: The time the tween will pause before running a yoyo
	//  hold: The time the tween will pause before running a yoyo
	//  loop: The time the tween will pause before starting either a yoyo or returning to the start for a repeat
	//  loopDelay: 
	//  offset: Used when the Tween is part of a Timeline
	//  paused: Does the tween start in a paused state, or playing?
	//  props: The properties being tweened by the tween
	//  repeat: The number of times the tween will repeat itself (a value of 1 means the tween will play twice, as it repeated once)
	//  repeatDelay: The time the tween will pause for before starting a repeat. The tween holds in the start state.
	//  targets: The targets the tween is updating.
	//  useFrames: Use frames or milliseconds?
	//  yoyo: boolean - Does the tween reverse itself (yoyo) when it reaches the end?
	
	module.exports = [
	    'callbackScope',
	    'completeDelay',
	    'delay',
	    'duration',
	    'ease',
	    'easeParams',
	    'flipX',
	    'flipY',
	    'hold',
	    'loop',
	    'loopDelay',
	    'offset',
	    'onComplete',
	    'onCompleteParams',
	    'onCompleteScope',
	    'onLoop',
	    'onLoopParams',
	    'onLoopScope',
	    'onRepeat',
	    'onRepeatParams',
	    'onRepeatScope',
	    'onStart',
	    'onStartParams',
	    'onStartScope',
	    'onUpdate',
	    'onUpdateParams',
	    'onUpdateScope',
	    'onYoyo',
	    'onYoyoParams',
	    'onYoyoScope',
	    'paused',
	    'props',
	    'repeat',
	    'repeatDelay',
	    'targets',
	    'useFrames',
	    'yoyo'
	];


/***/ }),
/* 1586 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Adds the given item, or array of items, to the array.
	 * 
	 * Each item must be unique within the array.
	 * 
	 * The array is modified in-place and returned.
	 * 
	 * You can optionally specify a limit to the maximum size of the array. If the quantity of items being
	 * added will take the array length over this limit, it will stop adding once the limit is reached.
	 * 
	 * You can optionally specify a callback to be invoked for each item successfully added to the array.
	 *
	 * @function Phaser.Utils.Array.Add
	 * @since 3.4.0
	 *
	 * @param {array} array - The array to be added to.
	 * @param {any|any[]} item - The item, or array of items, to add to the array. Each item must be unique within the array.
	 * @param {integer} [limit] - Optional limit which caps the size of the array.
	 * @param {function} [callback] - A callback to be invoked for each item successfully added to the array.
	 * @param {object} [context] - The context in which the callback is invoked.
	 *
	 * @return {array} The input array.
	 */
	var Add = function (array, item, limit, callback, context)
	{
	    if (context === undefined) { context = array; }
	
	    if (limit > 0)
	    {
	        var remaining = limit - array.length;
	
	        //  There's nothing more we can do here, the array is full
	        if (remaining <= 0)
	        {
	            return null;
	        }
	    }
	
	    //  Fast path to avoid array mutation and iteration
	    if (!Array.isArray(item))
	    {
	        if (array.indexOf(item) === -1)
	        {
	            array.push(item);
	
	            if (callback)
	            {
	                callback.call(context, item);
	            }
	    
	            return item;
	        }
	        else
	        {
	            return null;
	        }
	    }
	
	    //  If we got this far, we have an array of items to insert
	
	    //  Ensure all the items are unique
	    var itemLength = item.length - 1;
	
	    while (itemLength >= 0)
	    {
	        if (array.indexOf(item[itemLength]) !== -1)
	        {
	            //  Already exists in array, so remove it
	            item.pop();
	        }
	
	        itemLength--;
	    }
	
	    //  Anything left?
	    itemLength = item.length;
	
	    if (itemLength === 0)
	    {
	        return null;
	    }
	
	    if (limit > 0 && itemLength > remaining)
	    {
	        item.splice(remaining);
	
	        itemLength = remaining;
	    }
	
	    for (var i = 0; i < itemLength; i++)
	    {
	        var entry = item[i];
	
	        array.push(entry);
	
	        if (callback)
	        {
	            callback.call(context, entry);
	        }
	    }
	
	    return item;
	};
	
	module.exports = Add;


/***/ }),
/* 1587 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Adds the given item, or array of items, to the array starting at the index specified.
	 * 
	 * Each item must be unique within the array.
	 * 
	 * Existing elements in the array are shifted up.
	 * 
	 * The array is modified in-place and returned.
	 * 
	 * You can optionally specify a limit to the maximum size of the array. If the quantity of items being
	 * added will take the array length over this limit, it will stop adding once the limit is reached.
	 * 
	 * You can optionally specify a callback to be invoked for each item successfully added to the array.
	 *
	 * @function Phaser.Utils.Array.AddAt
	 * @since 3.4.0
	 *
	 * @param {array} array - The array to be added to.
	 * @param {any|any[]} item - The item, or array of items, to add to the array.
	 * @param {integer} [index=0] - The index in the array where the item will be inserted.
	 * @param {integer} [limit] - Optional limit which caps the size of the array.
	 * @param {function} [callback] - A callback to be invoked for each item successfully added to the array.
	 * @param {object} [context] - The context in which the callback is invoked.
	 *
	 * @return {array} The input array.
	 */
	var AddAt = function (array, item, index, limit, callback, context)
	{
	    if (index === undefined) { index = 0; }
	    if (context === undefined) { context = array; }
	
	    if (limit > 0)
	    {
	        var remaining = limit - array.length;
	
	        //  There's nothing more we can do here, the array is full
	        if (remaining <= 0)
	        {
	            return null;
	        }
	    }
	
	    //  Fast path to avoid array mutation and iteration
	    if (!Array.isArray(item))
	    {
	        if (array.indexOf(item) === -1)
	        {
	            array.splice(index, 0, item);
	
	            if (callback)
	            {
	                callback.call(context, item);
	            }
	
	            return item;
	        }
	        else
	        {
	            return null;
	        }
	    }
	
	    //  If we got this far, we have an array of items to insert
	
	    //  Ensure all the items are unique
	    var itemLength = item.length - 1;
	
	    while (itemLength >= 0)
	    {
	        if (array.indexOf(item[itemLength]) !== -1)
	        {
	            //  Already exists in array, so remove it
	            item.pop();
	        }
	
	        itemLength--;
	    }
	
	    //  Anything left?
	    itemLength = item.length;
	
	    if (itemLength === 0)
	    {
	        return null;
	    }
	
	    //  Truncate to the limit
	    if (limit > 0 && itemLength > remaining)
	    {
	        item.splice(remaining);
	
	        itemLength = remaining;
	    }
	
	    for (var i = itemLength; i > 0; i--)
	    {
	        var entry = item[i];
	
	        array.splice(index, 0, entry);
	
	        if (callback)
	        {
	            callback.call(context, entry);
	        }
	    }
	
	    return item;
	};
	
	module.exports = AddAt;


/***/ }),
/* 1588 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Moves the given element to the top of the array.
	 * The array is modified in-place.
	 *
	 * @function Phaser.Utils.Array.BringToTop
	 * @since 3.4.0
	 *
	 * @param {array} array - The array.
	 * @param {*} item - The element to move.
	 *
	 * @return {*} The element that was moved.
	 */
	var BringToTop = function (array, item)
	{
	    var currentIndex = array.indexOf(item);
	
	    if (currentIndex !== -1 && currentIndex < array.length)
	    {
	        array.splice(currentIndex, 1);
	        array.push(item);
	    }
	
	    return item;
	};
	
	module.exports = BringToTop;


/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var SafeRange = __webpack_require__(122);
	
	/**
	 * Returns the total number of elements in the array which have a property matching the given value.
	 *
	 * @function Phaser.Utils.Array.CountAllMatching
	 * @since 3.4.0
	 *
	 * @param {array} array - The array to search.
	 * @param {string} property - The property to test on each array element.
	 * @param {*} value - The value to test the property against. Must pass a strict (`===`) comparison check.
	 * @param {integer} [startIndex] - An optional start index to search from.
	 * @param {integer} [endIndex] - An optional end index to search to.
	 *
	 * @return {integer} The total number of elements with properties matching the given value.
	 */
	var CountAllMatching = function (array, property, value, startIndex, endIndex)
	{
	    if (startIndex === undefined) { startIndex = 0; }
	    if (endIndex === undefined) { endIndex = array.length; }
	
	    var total = 0;
	
	    if (SafeRange(array, startIndex, endIndex))
	    {
	        for (var i = startIndex; i < endIndex; i++)
	        {
	            var child = array[i];
	
	            if (child[property] === value)
	            {
	                total++;
	            }
	        }
	    }
	
	    return total;
	};
	
	module.exports = CountAllMatching;


/***/ }),
/* 1590 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Passes each element in the array to the given callback.
	 *
	 * @function Phaser.Utils.Array.Each
	 * @since 3.4.0
	 *
	 * @param {array} array - The array to search.
	 * @param {function} callback - A callback to be invoked for each item in the array.
	 * @param {object} context - The context in which the callback is invoked.
	 * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
	 *
	 * @return {array} The input array.
	 */
	var Each = function (array, callback, context)
	{
	    var i;
	    var args = [ null ];
	
	    for (i = 2; i < arguments.length; i++)
	    {
	        args.push(arguments[i]);
	    }
	
	    for (i = 0; i < array.length; i++)
	    {
	        args[0] = array[i];
	
	        callback.apply(context, args);
	    }
	
	    return array;
	};
	
	module.exports = Each;


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var SafeRange = __webpack_require__(122);
	
	/**
	 * Passes each element in the array, between the start and end indexes, to the given callback.
	 *
	 * @function Phaser.Utils.Array.EachInRange
	 * @since 3.4.0
	 *
	 * @param {array} array - The array to search.
	 * @param {function} callback - A callback to be invoked for each item in the array.
	 * @param {object} context - The context in which the callback is invoked.
	 * @param {integer} startIndex - The start index to search from.
	 * @param {integer} endIndex - The end index to search to.
	 * @param {...*} [args] - Additional arguments that will be passed to the callback, after the child.
	 *
	 * @return {array} The input array.
	 */
	var EachInRange = function (array, callback, context, startIndex, endIndex)
	{
	    if (startIndex === undefined) { startIndex = 0; }
	    if (endIndex === undefined) { endIndex = array.length; }
	
	    if (SafeRange(array, startIndex, endIndex))
	    {
	        var i;
	        var args = [ null ];
	
	        for (i = 5; i < arguments.length; i++)
	        {
	            args.push(arguments[i]);
	        }
	
	        for (i = startIndex; i < endIndex; i++)
	        {
	            args[0] = array[i];
	
	            callback.apply(context, args);
	        }
	    }
	
	    return array;
	};
	
	module.exports = EachInRange;


/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var SafeRange = __webpack_require__(122);
	
	/**
	 * Returns all elements in the array.
	 *
	 * You can optionally specify a matching criteria using the `property` and `value` arguments.
	 *
	 * For example: `getAll('visible', true)` would return only elements that have their visible property set.
	 *
	 * Optionally you can specify a start and end index. For example if the array had 100 elements,
	 * and you set `startIndex` to 0 and `endIndex` to 50, it would return matches from only
	 * the first 50 elements.
	 *
	 * @function Phaser.Utils.Array.GetAll
	 * @since 3.4.0
	 *
	 * @param {array} array - The array to search.
	 * @param {string} [property] - The property to test on each array element.
	 * @param {*} [value] - The value to test the property against. Must pass a strict (`===`) comparison check.
	 * @param {integer} [startIndex] - An optional start index to search from.
	 * @param {integer} [endIndex] - An optional end index to search to.
	 *
	 * @return {array} All matching elements from the array.
	 */
	var GetAll = function (array, property, value, startIndex, endIndex)
	{
	    if (startIndex === undefined) { startIndex = 0; }
	    if (endIndex === undefined) { endIndex = array.length; }
	
	    var output = [];
	
	    if (SafeRange(array, startIndex, endIndex))
	    {
	        for (var i = startIndex; i < endIndex; i++)
	        {
	            var child = array[i];
	
	            if (!property ||
	                (property && value === undefined && child.hasOwnProperty(property)) ||
	                (property && value !== undefined && child[property] === value))
	            {
	                output.push(child);
	            }
	        }
	    }
	
	    return output;
	};
	
	module.exports = GetAll;


/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var SafeRange = __webpack_require__(122);
	
	/**
	 * Returns the first element in the array.
	 *
	 * You can optionally specify a matching criteria using the `property` and `value` arguments.
	 *
	 * For example: `getAll('visible', true)` would return the first element that had its `visible` property set.
	 *
	 * Optionally you can specify a start and end index. For example if the array had 100 elements,
	 * and you set `startIndex` to 0 and `endIndex` to 50, it would search only the first 50 elements.
	 *
	 * @function Phaser.Utils.Array.GetFirst
	 * @since 3.4.0
	 *
	 * @param {array} array - The array to search.
	 * @param {string} [property] - The property to test on each array element.
	 * @param {*} [value] - The value to test the property against. Must pass a strict (`===`) comparison check.
	 * @param {integer} [startIndex=0] - An optional start index to search from.
	 * @param {integer} [endIndex=array.length] - An optional end index to search up to (but not included)
	 *
	 * @return {object} The first matching element from the array, or `null` if no element could be found in the range given.
	 */
	var GetFirst = function (array, property, value, startIndex, endIndex)
	{
	    if (startIndex === undefined) { startIndex = 0; }
	    if (endIndex === undefined) { endIndex = array.length; }
	
	    if (SafeRange(array, startIndex, endIndex))
	    {
	        for (var i = startIndex; i < endIndex; i++)
	        {
	            var child = array[i];
	
	            if (!property ||
	                (property && value === undefined && child.hasOwnProperty(property)) ||
	                (property && value !== undefined && child[property] === value))
	            {
	                return child;
	            }
	        }
	    }
	
	    return null;
	};
	
	module.exports = GetFirst;


/***/ }),
/* 1594 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Moves the given array element down one place in the array.
	 * The array is modified in-place.
	 *
	 * @function Phaser.Utils.Array.MoveDown
	 * @since 3.4.0
	 *
	 * @param {array} array - The input array.
	 * @param {*} item - The element to move down the array.
	 *
	 * @return {array} The input array.
	 */
	var MoveDown = function (array, item)
	{
	    var currentIndex = array.indexOf(item);
	
	    if (currentIndex > 0)
	    {
	        var item2 = array[currentIndex - 1];
	
	        var index2 = array.indexOf(item2);
	
	        array[currentIndex] = item2;
	        array[index2] = item;
	    }
	
	    return array;
	};
	
	module.exports = MoveDown;


/***/ }),
/* 1595 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Moves an element in an array to a new position within the same array.
	 * The array is modified in-place.
	 *
	 * @function Phaser.Utils.Array.MoveTo
	 * @since 3.4.0
	 *
	 * @param {array} array - The array.
	 * @param {*} item - The element to move.
	 * @param {integer} index - The new index that the element will be moved to.
	 *
	 * @return {*} The element that was moved.
	 */
	var MoveTo = function (array, item, index)
	{
	    var currentIndex = array.indexOf(item);
	
	    if (currentIndex === -1 || index < 0 || index >= array.length)
	    {
	        throw new Error('Supplied index out of bounds');
	    }
	
	    if (currentIndex !== index)
	    {
	        //  Remove
	        array.splice(currentIndex, 1);
	
	        //  Add in new location
	        array.splice(index, 0, item);
	    }
	
	    return item;
	};
	
	module.exports = MoveTo;


/***/ }),
/* 1596 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Moves the given array element up one place in the array.
	 * The array is modified in-place.
	 *
	 * @function Phaser.Utils.Array.MoveUp
	 * @since 3.4.0
	 *
	 * @param {array} array - The input array.
	 * @param {*} item - The element to move up the array.
	 *
	 * @return {array} The input array.
	 */
	var MoveUp = function (array, item)
	{
	    var currentIndex = array.indexOf(item);
	
	    if (currentIndex !== -1 && currentIndex < array.length - 2)
	    {
	        var item2 = array[currentIndex + 1];
	
	        var index2 = array.indexOf(item2);
	
	        array[currentIndex] = item2;
	        array[index2] = item;
	    }
	
	    return array;
	};
	
	module.exports = MoveUp;


/***/ }),
/* 1597 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Create an array representing the range of numbers (usually integers), between, and inclusive of,
	 * the given `start` and `end` arguments. For example:
	 *
	 * `var array = numberArray(2, 4); // array = [2, 3, 4]`
	 * `var array = numberArray(0, 9); // array = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]`
	 *
	 * This is equivalent to `numberArrayStep(start, end, 1)`.
	 *
	 * You can optionally provide a prefix and / or suffix string. If given the array will contain
	 * strings, not integers. For example:
	 *
	 * `var array = numberArray(1, 4, 'Level '); // array = ["Level 1", "Level 2", "Level 3", "Level 4"]`
	 * `var array = numberArray(5, 7, 'HD-', '.png'); // array = ["HD-5.png", "HD-6.png", "HD-7.png"]`
	 *
	 * @function Phaser.Utils.Array.NumberArray
	 * @since 3.0.0
	 *
	 * @param {number} start - The minimum value the array starts with.
	 * @param {number} end - The maximum value the array contains.
	 * @param {string} [prefix] - Optional prefix to place before the number. If provided the array will contain strings, not integers.
	 * @param {string} [suffix] - Optional suffix to place after the number. If provided the array will contain strings, not integers.
	 *
	 * @return {(number[]|string[])} The array of number values, or strings if a prefix or suffix was provided.
	 */
	var NumberArray = function (start, end, prefix, suffix)
	{
	    var result = [];
	
	    for (var i = start; i <= end; i++)
	    {
	        if (prefix || suffix)
	        {
	            var key = (prefix) ? prefix + i.toString() : i.toString();
	
	            if (suffix)
	            {
	                key = key.concat(suffix);
	            }
	
	            result.push(key);
	        }
	        else
	        {
	            result.push(i);
	        }
	    }
	
	    return result;
	};
	
	module.exports = NumberArray;


/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var RoundAwayFromZero = __webpack_require__(559);
	
	/**
	 * Create an array of numbers (positive and/or negative) progressing from `start`
	 * up to but not including `end` by advancing by `step`.
	 *
	 * If `start` is less than `end` a zero-length range is created unless a negative `step` is specified.
	 *
	 * Certain values for `start` and `end` (eg. NaN/undefined/null) are currently coerced to 0;
	 * for forward compatibility make sure to pass in actual numbers.
	 * 
	 * @example
	 * NumberArrayStep(4);
	 * // => [0, 1, 2, 3]
	 *
	 * NumberArrayStep(1, 5);
	 * // => [1, 2, 3, 4]
	 *
	 * NumberArrayStep(0, 20, 5);
	 * // => [0, 5, 10, 15]
	 *
	 * NumberArrayStep(0, -4, -1);
	 * // => [0, -1, -2, -3]
	 *
	 * NumberArrayStep(1, 4, 0);
	 * // => [1, 1, 1]
	 *
	 * NumberArrayStep(0);
	 * // => []
	 *
	 * @function Phaser.Utils.Array.NumberArrayStep
	 * @since 3.0.0
	 *
	 * @param {number} [start=0] - The start of the range.
	 * @param {number} [end=null] - The end of the range.
	 * @param {number} [step=1] - The value to increment or decrement by.
	 *
	 * @return {number[]} [description]
	 */
	var NumberArrayStep = function (start, end, step)
	{
	    if (start === undefined) { start = 0; }
	    if (end === undefined) { end = null; }
	    if (step === undefined) { step = 1; }
	
	    if (end === null)
	    {
	        end = start;
	        start = 0;
	    }
	
	    var result = [];
	
	    var total = Math.max(RoundAwayFromZero((end - start) / (step || 1)), 0);
	
	    for (var i = 0; i < total; i++)
	    {
	        result.push(start);
	        start += step;
	    }
	
	    return result;
	};
	
	module.exports = NumberArrayStep;


/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var SpliceOne = __webpack_require__(175);
	
	/**
	 * Removes the item from the given position in the array.
	 * 
	 * The array is modified in-place.
	 * 
	 * You can optionally specify a callback to be invoked for the item if it is successfully removed from the array.
	 *
	 * @function Phaser.Utils.Array.RemoveAt
	 * @since 3.4.0
	 *
	 * @param {array} array - The array to be modified.
	 * @param {integer} index - The array index to remove the item from. The index must be in bounds or it will throw an error.
	 * @param {function} [callback] - A callback to be invoked for the item removed from the array.
	 * @param {object} [context] - The context in which the callback is invoked.
	 *
	 * @return {*} The item that was removed.
	 */
	var RemoveAt = function (array, index, callback, context)
	{
	    if (context === undefined) { context = array; }
	
	    if (index < 0 || index > array.length - 1)
	    {
	        throw new Error('Index out of bounds');
	    }
	
	    var item = SpliceOne(array, index);
	
	    if (callback)
	    {
	        callback.call(context, item);
	    }
	
	    return item;
	};
	
	module.exports = RemoveAt;


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var SafeRange = __webpack_require__(122);
	
	/**
	 * Removes the item within the given range in the array.
	 * 
	 * The array is modified in-place.
	 * 
	 * You can optionally specify a callback to be invoked for the item/s successfully removed from the array.
	 *
	 * @function Phaser.Utils.Array.RemoveBetween
	 * @since 3.4.0
	 *
	 * @param {array} array - The array to be modified.
	 * @param {integer} startIndex - The start index to remove from.
	 * @param {integer} endIndex - The end index to remove to.
	 * @param {function} [callback] - A callback to be invoked for the item removed from the array.
	 * @param {object} [context] - The context in which the callback is invoked.
	 *
	 * @return {Array.<*>} An array of items that were removed.
	 */
	var RemoveBetween = function (array, startIndex, endIndex, callback, context)
	{
	    if (startIndex === undefined) { startIndex = 0; }
	    if (endIndex === undefined) { endIndex = array.length; }
	    if (context === undefined) { context = array; }
	
	    if (SafeRange(array, startIndex, endIndex))
	    {
	        var size = endIndex - startIndex;
	
	        var removed = array.splice(startIndex, size);
	
	        if (callback)
	        {
	            for (var i = 0; i < removed.length; i++)
	            {
	                var entry = removed[i];
	
	                callback.call(context, entry);
	            }
	        }
	
	        return removed;
	    }
	    else
	    {
	        return [];
	    }
	};
	
	module.exports = RemoveBetween;


/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var SpliceOne = __webpack_require__(175);
	
	/**
	 * Removes a random object from the given array and returns it.
	 * Will return null if there are no array items that fall within the specified range or if there is no item for the randomly chosen index.
	 *
	 * @function Phaser.Utils.Array.RemoveRandomElement
	 * @since 3.0.0
	 *
	 * @param {array} array - The array to removed a random element from.
	 * @param {integer} [start=0] - The array index to start the search from.
	 * @param {integer} [length=array.length] - Optional restriction on the number of elements to randomly select from.
	 *
	 * @return {object} The random element that was removed, or `null` if there were no array elements that fell within the given range.
	 */
	var RemoveRandomElement = function (array, start, length)
	{
	    if (start === undefined) { start = 0; }
	    if (length === undefined) { length = array.length; }
	
	    var randomIndex = start + Math.floor(Math.random() * length);
	
	    return SpliceOne(array, randomIndex);
	};
	
	module.exports = RemoveRandomElement;


/***/ }),
/* 1602 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Replaces an element of the array with the new element.
	 * The new element cannot already be a member of the array.
	 * The array is modified in-place.
	 *
	 * @function Phaser.Utils.Array.Replace
	 * @since 3.4.0
	 *
	 * @param {*} oldChild - The element in the array that will be replaced.
	 * @param {*} newChild - The element to be inserted into the array at the position of `oldChild`.
	 *
	 * @return {boolean} Returns true if the oldChild was successfully replaced, otherwise returns false.
	 */
	var Replace = function (array, oldChild, newChild)
	{
	    var index1 = array.indexOf(oldChild);
	    var index2 = array.indexOf(newChild);
	
	    if (index1 !== -1 && index2 === -1)
	    {
	        array[index1] = newChild;
	
	        return true;
	    }
	    else
	    {
	        return false;
	    }
	};
	
	module.exports = Replace;


/***/ }),
/* 1603 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Moves the given element to the bottom of the array.
	 * The array is modified in-place.
	 *
	 * @function Phaser.Utils.Array.SendToBack
	 * @since 3.4.0
	 *
	 * @param {array} array - The array.
	 * @param {*} item - The element to move.
	 *
	 * @return {*} The element that was moved.
	 */
	var SendToBack = function (array, item)
	{
	    var currentIndex = array.indexOf(item);
	
	    if (currentIndex !== -1 && currentIndex > 0)
	    {
	        array.splice(currentIndex, 1);
	        array.unshift(item);
	    }
	
	    return item;
	};
	
	module.exports = SendToBack;


/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var SafeRange = __webpack_require__(122);
	
	/**
	 * Scans the array for elements with the given property. If found, the property is set to the `value`.
	 *
	 * For example: `SetAll('visible', true)` would set all elements that have a `visible` property to `false`.
	 *
	 * Optionally you can specify a start and end index. For example if the array had 100 elements,
	 * and you set `startIndex` to 0 and `endIndex` to 50, it would update only the first 50 elements.
	 *
	 * @function Phaser.Utils.Array.SetAll
	 * @since 3.4.0
	 *
	 * @param {array} array - The array to search.
	 * @param {string} property - The property to test for on each array element.
	 * @param {*} value - The value to set the property to.
	 * @param {integer} [startIndex] - An optional start index to search from.
	 * @param {integer} [endIndex] - An optional end index to search to.
	 *
	 * @return {array} The input array.
	 */
	var SetAll = function (array, property, value, startIndex, endIndex)
	{
	    if (startIndex === undefined) { startIndex = 0; }
	    if (endIndex === undefined) { endIndex = array.length; }
	
	    if (SafeRange(array, startIndex, endIndex))
	    {
	        for (var i = startIndex; i < endIndex; i++)
	        {
	            var entry = array[i];
	
	            if (entry.hasOwnProperty(property))
	            {
	                entry[property] = value;
	            }
	        }
	    }
	
	    return array;
	};
	
	module.exports = SetAll;


/***/ }),
/* 1605 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Swaps the position of two elements in the given array.
	 * The elements must exist in the same array.
	 * The array is modified in-place.
	 *
	 * @function Phaser.Utils.Array.Swap
	 * @since 3.4.0
	 *
	 * @param {array} array - The input array.
	 * @param {*} item1 - The first element to swap.
	 * @param {*} item2 - The second element to swap.
	 *
	 * @return {array} The input array.
	 */
	var Swap = function (array, item1, item2)
	{
	    if (item1 === item2)
	    {
	        return;
	    }
	
	    var index1 = array.indexOf(item1);
	    var index2 = array.indexOf(item2);
	
	    if (index1 < 0 || index2 < 0)
	    {
	        throw new Error('Supplied items must be elements of the same array');
	    }
	
	    array[index1] = item2;
	    array[index2] = item1;
	
	    return array;
	};
	
	module.exports = Swap;


/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Pad = __webpack_require__(342);
	var CheckMatrix = __webpack_require__(341);
	
	//  Generates a string (which you can pass to console.log) from the given
	//  Array Matrix.
	
	/**
	 * [description]
	 *
	 * @function Phaser.Utils.Array.Matrix.MatrixToString
	 * @since 3.0.0
	 *
	 * @param {array} matrix - [description]
	 *
	 * @return {string} [description]
	 */
	var MatrixToString = function (matrix)
	{
	    var str = '';
	
	    if (!CheckMatrix(matrix))
	    {
	        return str;
	    }
	
	    for (var r = 0; r < matrix.length; r++)
	    {
	        for (var c = 0; c < matrix[r].length; c++)
	        {
	            var cell = matrix[r][c].toString();
	
	            if (cell !== 'undefined')
	            {
	                str += Pad(cell, 2);
	            }
	            else
	            {
	                str += '?';
	            }
	
	            if (c < matrix[r].length - 1)
	            {
	                str += ' |';
	            }
	        }
	
	        if (r < matrix.length - 1)
	        {
	            str += '\n';
	
	            for (var i = 0; i < matrix[r].length; i++)
	            {
	                str += '---';
	
	                if (i < matrix[r].length - 1)
	                {
	                    str += '+';
	                }
	            }
	
	            str += '\n';
	        }
	
	    }
	
	    return str;
	};
	
	module.exports = MatrixToString;


/***/ }),
/* 1607 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Utils.Array.Matrix.ReverseColumns
	 * @since 3.0.0
	 *
	 * @param {array} matrix - [description]
	 *
	 * @return {array} [description]
	 */
	var ReverseColumns = function (matrix)
	{
	    for (var i = 0; i < matrix.length; i++)
	    {
	        matrix[i].reverse();
	    }
	
	    return matrix;
	};
	
	module.exports = ReverseColumns;


/***/ }),
/* 1608 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * [description]
	 *
	 * @function Phaser.Utils.Array.Matrix.ReverseRows
	 * @since 3.0.0
	 *
	 * @param {array} matrix - [description]
	 *
	 * @return {array} [description]
	 */
	var ReverseRows = function (matrix)
	{
	    return matrix.reverse();
	};
	
	module.exports = ReverseRows;


/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var RotateMatrix = __webpack_require__(220);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Utils.Array.Matrix.Rotate180
	 * @since 3.0.0
	 *
	 * @param {array} matrix - [description]
	 *
	 * @return {array} [description]
	 */
	var Rotate180 = function (matrix)
	{
	    return RotateMatrix(matrix, 180);
	};
	
	module.exports = Rotate180;


/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var RotateMatrix = __webpack_require__(220);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Utils.Array.Matrix.RotateLeft
	 * @since 3.0.0
	 *
	 * @param {array} matrix - [description]
	 *
	 * @return {array} [description]
	 */
	var RotateLeft = function (matrix)
	{
	    return RotateMatrix(matrix, 90);
	};
	
	module.exports = RotateLeft;


/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var RotateMatrix = __webpack_require__(220);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Utils.Array.Matrix.RotateRight
	 * @since 3.0.0
	 *
	 * @param {array} matrix - [description]
	 *
	 * @return {array} [description]
	 */
	var RotateRight = function (matrix)
	{
	    return RotateMatrix(matrix, -90);
	};
	
	module.exports = RotateRight;


/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Utils.Array.Matrix
	 */
	
	module.exports = {
	
	    CheckMatrix: __webpack_require__(341),
	    MatrixToString: __webpack_require__(1606),
	    ReverseColumns: __webpack_require__(1607),
	    ReverseRows: __webpack_require__(1608),
	    Rotate180: __webpack_require__(1609),
	    RotateLeft: __webpack_require__(1610),
	    RotateMatrix: __webpack_require__(220),
	    RotateRight: __webpack_require__(1611),
	    TransposeMatrix: __webpack_require__(663)
	
	};


/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Utils
	 */
	
	module.exports = {
	
	    Array: __webpack_require__(340),
	    Objects: __webpack_require__(1617),
	    String: __webpack_require__(1620)
	
	};


/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var GetValue = __webpack_require__(10);
	var Clamp = __webpack_require__(63);
	
	/**
	 * [description]
	 *
	 * @function Phaser.Utils.Object.GetMinMaxValue
	 * @since 3.0.0
	 *
	 * @param {object} source - [description]
	 * @param {string} key - [description]
	 * @param {number} min - [description]
	 * @param {number} max - [description]
	 * @param {number} defaultValue - [description]
	 *
	 * @return {number} [description]
	 */
	var GetMinMaxValue = function (source, key, min, max, defaultValue)
	{
	    if (defaultValue === undefined) { defaultValue = min; }
	
	    var value = GetValue(source, key, defaultValue);
	
	    return Clamp(value, min, max);
	};
	
	module.exports = GetMinMaxValue;


/***/ }),
/* 1615 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Verifies that an object contains all requested keys
	 *
	 * @function Phaser.Utils.Object.HasAll
	 * @since 3.0.0
	 *
	 * @param {object} source - an object on which to check for key existence
	 * @param {string[]} keys - an array of keys to ensure the source object contains
	 *
	 * @return {boolean} true if the source object contains all keys, false otherwise.
	 */
	var HasAll = function (source, keys)
	{
	    for (var i = 0; i < keys.length; i++)
	    {
	        if (!source.hasOwnProperty(keys[i]))
	        {
	            return false;
	        }
	    }
	
	    return true;
	};
	
	module.exports = HasAll;


/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	var Clone = __webpack_require__(123);
	
	/**
	 * Creates a new Object using all values from obj1.
	 * 
	 * Then scans obj2. If a property is found in obj2 that *also* exists in obj1, the value from obj2 is used, otherwise the property is skipped.
	 *
	 * @function Phaser.Utils.Object.MergeRight
	 * @since 3.0.0
	 *
	 * @param {object} obj1 - [description]
	 * @param {object} obj2 - [description]
	 *
	 * @return {object} [description]
	 */
	var MergeRight = function (obj1, obj2)
	{
	    var clone = Clone(obj1);
	
	    for (var key in obj2)
	    {
	        if (clone.hasOwnProperty(key))
	        {
	            clone[key] = obj2[key];
	        }
	    }
	
	    return clone;
	};
	
	module.exports = MergeRight;


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Utils.Object
	 */
	
	module.exports = {
	
	    Clone: __webpack_require__(123),
	    Extend: __webpack_require__(36),
	    GetAdvancedValue: __webpack_require__(24),
	    GetFastValue: __webpack_require__(3),
	    GetMinMaxValue: __webpack_require__(1614),
	    GetValue: __webpack_require__(10),
	    HasAll: __webpack_require__(1615),
	    HasAny: __webpack_require__(664),
	    HasValue: __webpack_require__(147),
	    IsPlainObject: __webpack_require__(17),
	    Merge: __webpack_require__(148),
	    MergeRight: __webpack_require__(1616)
	
	};


/***/ }),
/* 1618 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Takes a string and replaces instances of markers with values in the given array.
	 * The markers take the form of `%1`, `%2`, etc. I.e.:
	 *
	 * `Format("The %1 is worth %2 gold", [ 'Sword', 500 ])`
	 *
	 * @function Phaser.Utils.String.Format
	 * @since 3.0.0
	 *
	 * @param {string} string - The string containing the replacement markers.
	 * @param {array} values - An array containing values that will replace the markers. If no value exists an empty string is inserted instead.
	 *
	 * @return {string} The string containing replaced values.
	 */
	var Format = function (string, values)
	{
	    return string.replace(/%([0-9]+)/g, function (s, n)
	    {
	        return values[Number(n) - 1];
	    });
	};
	
	module.exports = Format;


/***/ }),
/* 1619 */
/***/ (function(module, exports) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * Takes the given string and reverses it, returning the reversed string.
	 * For example if given the string `Atari 520ST` it would return `TS025 iratA`.
	 *
	 * @function Phaser.Utils.String.ReverseString
	 * @since 3.0.0
	 *
	 * @param {string} string - The string to be reversed.
	 *
	 * @return {string} The reversed string.
	 */
	var ReverseString = function (string)
	{
	    return string.split('').reverse().join('');
	};
	
	module.exports = ReverseString;


/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @author       Richard Davey <rich@photonstorm.com>
	 * @copyright    2018 Photon Storm Ltd.
	 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
	 */
	
	/**
	 * @namespace Phaser.Utils.String
	 */
	
	module.exports = {
	
	    Format: __webpack_require__(1618),
	    Pad: __webpack_require__(342),
	    Reverse: __webpack_require__(1619),
	    UppercaseFirst: __webpack_require__(665)
	
	};


/***/ }),
/* 1621 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 1622 */
/***/ (function(module, exports) {

	module.exports = "\"use strict\";\n\nvar _typeof = typeof Symbol === \"function\" && typeof Symbol.iterator === \"symbol\" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === \"function\" && obj.constructor === Symbol && obj !== Symbol.prototype ? \"symbol\" : typeof obj; };\n\n/*! modernizr 3.3.1 (Custom Build) | MIT *\n * https://modernizr.com/download/?-filereader-setclasses !*/\n!function (e, n, s) {\n  function o(e, n) {\n    return (typeof e === \"undefined\" ? \"undefined\" : _typeof(e)) === n;\n  }function a() {\n    var e, n, s, a, i, f, r;for (var c in l) {\n      if (l.hasOwnProperty(c)) {\n        if (e = [], n = l[c], n.name && (e.push(n.name.toLowerCase()), n.options && n.options.aliases && n.options.aliases.length)) for (s = 0; s < n.options.aliases.length; s++) {\n          e.push(n.options.aliases[s].toLowerCase());\n        }for (a = o(n.fn, \"function\") ? n.fn() : n.fn, i = 0; i < e.length; i++) {\n          f = e[i], r = f.split(\".\"), 1 === r.length ? Modernizr[r[0]] = a : (!Modernizr[r[0]] || Modernizr[r[0]] instanceof Boolean || (Modernizr[r[0]] = new Boolean(Modernizr[r[0]])), Modernizr[r[0]][r[1]] = a), t.push((a ? \"\" : \"no-\") + r.join(\"-\"));\n        }\n      }\n    }\n  }function i(e) {\n    var n = r.className,\n        s = Modernizr._config.classPrefix || \"\";if (c && (n = n.baseVal), Modernizr._config.enableJSClass) {\n      var o = new RegExp(\"(^|\\\\s)\" + s + \"no-js(\\\\s|$)\");n = n.replace(o, \"$1\" + s + \"js$2\");\n    }Modernizr._config.enableClasses && (n += \" \" + s + e.join(\" \" + s), c ? r.className.baseVal = n : r.className = n);\n  }var t = [],\n      l = [],\n      f = { _version: \"3.3.1\", _config: { classPrefix: \"\", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 }, _q: [], on: function on(e, n) {\n      var s = this;setTimeout(function () {\n        n(s[e]);\n      }, 0);\n    }, addTest: function addTest(e, n, s) {\n      l.push({ name: e, fn: n, options: s });\n    }, addAsyncTest: function addAsyncTest(e) {\n      l.push({ name: null, fn: e });\n    } },\n      Modernizr = function Modernizr() {};Modernizr.prototype = f, Modernizr = new Modernizr(), Modernizr.addTest(\"filereader\", !!(e.File && e.FileList && e.FileReader));var r = n.documentElement,\n      c = \"svg\" === r.nodeName.toLowerCase();a(), i(t), delete f.addTest, delete f.addAsyncTest;for (var u = 0; u < Modernizr._q.length; u++) {\n    Modernizr._q[u]();\n  }e.Modernizr = Modernizr;\n}(window, document);"

/***/ }),
/* 1623 */
/***/ (function(module, exports) {

	module.exports = "\"use strict\";\n\nvar _typeof = typeof Symbol === \"function\" && typeof Symbol.iterator === \"symbol\" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === \"function\" && obj.constructor === Symbol && obj !== Symbol.prototype ? \"symbol\" : typeof obj; };\n\n/* == jquery mousewheel plugin == Version: 3.1.13, License: MIT License (MIT) */\n!function (a) {\n  \"function\" == typeof define && define.amd ? define([\"jquery\"], a) : \"object\" == (typeof exports === \"undefined\" ? \"undefined\" : _typeof(exports)) ? module.exports = a : a(jQuery);\n}(function (a) {\n  function b(b) {\n    var g = b || window.event,\n        h = i.call(arguments, 1),\n        j = 0,\n        l = 0,\n        m = 0,\n        n = 0,\n        o = 0,\n        p = 0;if (b = a.event.fix(g), b.type = \"mousewheel\", \"detail\" in g && (m = -1 * g.detail), \"wheelDelta\" in g && (m = g.wheelDelta), \"wheelDeltaY\" in g && (m = g.wheelDeltaY), \"wheelDeltaX\" in g && (l = -1 * g.wheelDeltaX), \"axis\" in g && g.axis === g.HORIZONTAL_AXIS && (l = -1 * m, m = 0), j = 0 === m ? l : m, \"deltaY\" in g && (m = -1 * g.deltaY, j = m), \"deltaX\" in g && (l = g.deltaX, 0 === m && (j = -1 * l)), 0 !== m || 0 !== l) {\n      if (1 === g.deltaMode) {\n        var q = a.data(this, \"mousewheel-line-height\");j *= q, m *= q, l *= q;\n      } else if (2 === g.deltaMode) {\n        var r = a.data(this, \"mousewheel-page-height\");j *= r, m *= r, l *= r;\n      }if (n = Math.max(Math.abs(m), Math.abs(l)), (!f || f > n) && (f = n, d(g, n) && (f /= 40)), d(g, n) && (j /= 40, l /= 40, m /= 40), j = Math[j >= 1 ? \"floor\" : \"ceil\"](j / f), l = Math[l >= 1 ? \"floor\" : \"ceil\"](l / f), m = Math[m >= 1 ? \"floor\" : \"ceil\"](m / f), k.settings.normalizeOffset && this.getBoundingClientRect) {\n        var s = this.getBoundingClientRect();o = b.clientX - s.left, p = b.clientY - s.top;\n      }return b.deltaX = l, b.deltaY = m, b.deltaFactor = f, b.offsetX = o, b.offsetY = p, b.deltaMode = 0, h.unshift(b, j, l, m), e && clearTimeout(e), e = setTimeout(c, 200), (a.event.dispatch || a.event.handle).apply(this, h);\n    }\n  }function c() {\n    f = null;\n  }function d(a, b) {\n    return k.settings.adjustOldDeltas && \"mousewheel\" === a.type && b % 120 === 0;\n  }var e,\n      f,\n      g = [\"wheel\", \"mousewheel\", \"DOMMouseScroll\", \"MozMousePixelScroll\"],\n      h = \"onwheel\" in document || document.documentMode >= 9 ? [\"wheel\"] : [\"mousewheel\", \"DomMouseScroll\", \"MozMousePixelScroll\"],\n      i = Array.prototype.slice;if (a.event.fixHooks) for (var j = g.length; j;) {\n    a.event.fixHooks[g[--j]] = a.event.mouseHooks;\n  }var k = a.event.special.mousewheel = { version: \"3.1.12\", setup: function setup() {\n      if (this.addEventListener) for (var c = h.length; c;) {\n        this.addEventListener(h[--c], b, !1);\n      } else this.onmousewheel = b;a.data(this, \"mousewheel-line-height\", k.getLineHeight(this)), a.data(this, \"mousewheel-page-height\", k.getPageHeight(this));\n    }, teardown: function teardown() {\n      if (this.removeEventListener) for (var c = h.length; c;) {\n        this.removeEventListener(h[--c], b, !1);\n      } else this.onmousewheel = null;a.removeData(this, \"mousewheel-line-height\"), a.removeData(this, \"mousewheel-page-height\");\n    }, getLineHeight: function getLineHeight(b) {\n      var c = a(b),\n          d = c[\"offsetParent\" in a.fn ? \"offsetParent\" : \"parent\"]();return d.length || (d = a(\"body\")), parseInt(d.css(\"fontSize\"), 10) || parseInt(c.css(\"fontSize\"), 10) || 16;\n    }, getPageHeight: function getPageHeight(b) {\n      return a(b).height();\n    }, settings: { adjustOldDeltas: !0, normalizeOffset: !0 } };a.fn.extend({ mousewheel: function mousewheel(a) {\n      return a ? this.bind(\"mousewheel\", a) : this.trigger(\"mousewheel\");\n    }, unmousewheel: function unmousewheel(a) {\n      return this.unbind(\"mousewheel\", a);\n    } });\n});!function (a) {\n  \"function\" == typeof define && define.amd ? define([\"jquery\"], a) : \"object\" == (typeof exports === \"undefined\" ? \"undefined\" : _typeof(exports)) ? module.exports = a : a(jQuery);\n}(function (a) {\n  function b(b) {\n    var g = b || window.event,\n        h = i.call(arguments, 1),\n        j = 0,\n        l = 0,\n        m = 0,\n        n = 0,\n        o = 0,\n        p = 0;if (b = a.event.fix(g), b.type = \"mousewheel\", \"detail\" in g && (m = -1 * g.detail), \"wheelDelta\" in g && (m = g.wheelDelta), \"wheelDeltaY\" in g && (m = g.wheelDeltaY), \"wheelDeltaX\" in g && (l = -1 * g.wheelDeltaX), \"axis\" in g && g.axis === g.HORIZONTAL_AXIS && (l = -1 * m, m = 0), j = 0 === m ? l : m, \"deltaY\" in g && (m = -1 * g.deltaY, j = m), \"deltaX\" in g && (l = g.deltaX, 0 === m && (j = -1 * l)), 0 !== m || 0 !== l) {\n      if (1 === g.deltaMode) {\n        var q = a.data(this, \"mousewheel-line-height\");j *= q, m *= q, l *= q;\n      } else if (2 === g.deltaMode) {\n        var r = a.data(this, \"mousewheel-page-height\");j *= r, m *= r, l *= r;\n      }if (n = Math.max(Math.abs(m), Math.abs(l)), (!f || f > n) && (f = n, d(g, n) && (f /= 40)), d(g, n) && (j /= 40, l /= 40, m /= 40), j = Math[j >= 1 ? \"floor\" : \"ceil\"](j / f), l = Math[l >= 1 ? \"floor\" : \"ceil\"](l / f), m = Math[m >= 1 ? \"floor\" : \"ceil\"](m / f), k.settings.normalizeOffset && this.getBoundingClientRect) {\n        var s = this.getBoundingClientRect();o = b.clientX - s.left, p = b.clientY - s.top;\n      }return b.deltaX = l, b.deltaY = m, b.deltaFactor = f, b.offsetX = o, b.offsetY = p, b.deltaMode = 0, h.unshift(b, j, l, m), e && clearTimeout(e), e = setTimeout(c, 200), (a.event.dispatch || a.event.handle).apply(this, h);\n    }\n  }function c() {\n    f = null;\n  }function d(a, b) {\n    return k.settings.adjustOldDeltas && \"mousewheel\" === a.type && b % 120 === 0;\n  }var e,\n      f,\n      g = [\"wheel\", \"mousewheel\", \"DOMMouseScroll\", \"MozMousePixelScroll\"],\n      h = \"onwheel\" in document || document.documentMode >= 9 ? [\"wheel\"] : [\"mousewheel\", \"DomMouseScroll\", \"MozMousePixelScroll\"],\n      i = Array.prototype.slice;if (a.event.fixHooks) for (var j = g.length; j;) {\n    a.event.fixHooks[g[--j]] = a.event.mouseHooks;\n  }var k = a.event.special.mousewheel = { version: \"3.1.12\", setup: function setup() {\n      if (this.addEventListener) for (var c = h.length; c;) {\n        this.addEventListener(h[--c], b, !1);\n      } else this.onmousewheel = b;a.data(this, \"mousewheel-line-height\", k.getLineHeight(this)), a.data(this, \"mousewheel-page-height\", k.getPageHeight(this));\n    }, teardown: function teardown() {\n      if (this.removeEventListener) for (var c = h.length; c;) {\n        this.removeEventListener(h[--c], b, !1);\n      } else this.onmousewheel = null;a.removeData(this, \"mousewheel-line-height\"), a.removeData(this, \"mousewheel-page-height\");\n    }, getLineHeight: function getLineHeight(b) {\n      var c = a(b),\n          d = c[\"offsetParent\" in a.fn ? \"offsetParent\" : \"parent\"]();return d.length || (d = a(\"body\")), parseInt(d.css(\"fontSize\"), 10) || parseInt(c.css(\"fontSize\"), 10) || 16;\n    }, getPageHeight: function getPageHeight(b) {\n      return a(b).height();\n    }, settings: { adjustOldDeltas: !0, normalizeOffset: !0 } };a.fn.extend({ mousewheel: function mousewheel(a) {\n      return a ? this.bind(\"mousewheel\", a) : this.trigger(\"mousewheel\");\n    }, unmousewheel: function unmousewheel(a) {\n      return this.unbind(\"mousewheel\", a);\n    } });\n});\n/* == malihu jquery custom scrollbar plugin == Version: 3.1.5, License: MIT License (MIT) */\n!function (e) {\n  \"function\" == typeof define && define.amd ? define([\"jquery\"], e) : \"undefined\" != typeof module && module.exports ? module.exports = e : e(jQuery, window, document);\n}(function (e) {\n  !function (t) {\n    var o = \"function\" == typeof define && define.amd,\n        a = \"undefined\" != typeof module && module.exports,\n        n = \"https:\" == document.location.protocol ? \"https:\" : \"http:\",\n        i = \"cdnjs.cloudflare.com/ajax/libs/jquery-mousewheel/3.1.13/jquery.mousewheel.min.js\";o || (a ? require(\"jquery-mousewheel\")(e) : e.event.special.mousewheel || e(\"head\").append(decodeURI(\"%3Cscript src=\" + n + \"//\" + i + \"%3E%3C/script%3E\"))), t();\n  }(function () {\n    var t,\n        o = \"mCustomScrollbar\",\n        a = \"mCS\",\n        n = \".mCustomScrollbar\",\n        i = { setTop: 0, setLeft: 0, axis: \"y\", scrollbarPosition: \"inside\", scrollInertia: 950, autoDraggerLength: !0, alwaysShowScrollbar: 0, snapOffset: 0, mouseWheel: { enable: !0, scrollAmount: \"auto\", axis: \"y\", deltaFactor: \"auto\", disableOver: [\"select\", \"option\", \"keygen\", \"datalist\", \"textarea\"] }, scrollButtons: { scrollType: \"stepless\", scrollAmount: \"auto\" }, keyboard: { enable: !0, scrollType: \"stepless\", scrollAmount: \"auto\" }, contentTouchScroll: 25, documentTouchScroll: !0, advanced: { autoScrollOnFocus: \"input,textarea,select,button,datalist,keygen,a[tabindex],area,object,[contenteditable='true']\", updateOnContentResize: !0, updateOnImageLoad: \"auto\", autoUpdateTimeout: 60 }, theme: \"light\", callbacks: { onTotalScrollOffset: 0, onTotalScrollBackOffset: 0, alwaysTriggerOffsets: !0 } },\n        r = 0,\n        l = {},\n        s = window.attachEvent && !window.addEventListener ? 1 : 0,\n        c = !1,\n        d = [\"mCSB_dragger_onDrag\", \"mCSB_scrollTools_onDrag\", \"mCS_img_loaded\", \"mCS_disabled\", \"mCS_destroyed\", \"mCS_no_scrollbar\", \"mCS-autoHide\", \"mCS-dir-rtl\", \"mCS_no_scrollbar_y\", \"mCS_no_scrollbar_x\", \"mCS_y_hidden\", \"mCS_x_hidden\", \"mCSB_draggerContainer\", \"mCSB_buttonUp\", \"mCSB_buttonDown\", \"mCSB_buttonLeft\", \"mCSB_buttonRight\"],\n        u = { init: function init(t) {\n        var t = e.extend(!0, {}, i, t),\n            o = f.call(this);if (t.live) {\n          var s = t.liveSelector || this.selector || n,\n              c = e(s);if (\"off\" === t.live) return void m(s);l[s] = setTimeout(function () {\n            c.mCustomScrollbar(t), \"once\" === t.live && c.length && m(s);\n          }, 500);\n        } else m(s);return t.setWidth = t.set_width ? t.set_width : t.setWidth, t.setHeight = t.set_height ? t.set_height : t.setHeight, t.axis = t.horizontalScroll ? \"x\" : p(t.axis), t.scrollInertia = t.scrollInertia > 0 && t.scrollInertia < 17 ? 17 : t.scrollInertia, \"object\" != _typeof(t.mouseWheel) && 1 == t.mouseWheel && (t.mouseWheel = { enable: !0, scrollAmount: \"auto\", axis: \"y\", preventDefault: !1, deltaFactor: \"auto\", normalizeDelta: !1, invert: !1 }), t.mouseWheel.scrollAmount = t.mouseWheelPixels ? t.mouseWheelPixels : t.mouseWheel.scrollAmount, t.mouseWheel.normalizeDelta = t.advanced.normalizeMouseWheelDelta ? t.advanced.normalizeMouseWheelDelta : t.mouseWheel.normalizeDelta, t.scrollButtons.scrollType = g(t.scrollButtons.scrollType), h(t), e(o).each(function () {\n          var o = e(this);if (!o.data(a)) {\n            o.data(a, { idx: ++r, opt: t, scrollRatio: { y: null, x: null }, overflowed: null, contentReset: { y: null, x: null }, bindEvents: !1, tweenRunning: !1, sequential: {}, langDir: o.css(\"direction\"), cbOffsets: null, trigger: null, poll: { size: { o: 0, n: 0 }, img: { o: 0, n: 0 }, change: { o: 0, n: 0 } } });var n = o.data(a),\n                i = n.opt,\n                l = o.data(\"mcs-axis\"),\n                s = o.data(\"mcs-scrollbar-position\"),\n                c = o.data(\"mcs-theme\");l && (i.axis = l), s && (i.scrollbarPosition = s), c && (i.theme = c, h(i)), v.call(this), n && i.callbacks.onCreate && \"function\" == typeof i.callbacks.onCreate && i.callbacks.onCreate.call(this), e(\"#mCSB_\" + n.idx + \"_container img:not(.\" + d[2] + \")\").addClass(d[2]), u.update.call(null, o);\n          }\n        });\n      }, update: function update(t, o) {\n        var n = t || f.call(this);return e(n).each(function () {\n          var t = e(this);if (t.data(a)) {\n            var n = t.data(a),\n                i = n.opt,\n                r = e(\"#mCSB_\" + n.idx + \"_container\"),\n                l = e(\"#mCSB_\" + n.idx),\n                s = [e(\"#mCSB_\" + n.idx + \"_dragger_vertical\"), e(\"#mCSB_\" + n.idx + \"_dragger_horizontal\")];if (!r.length) return;n.tweenRunning && Q(t), o && n && i.callbacks.onBeforeUpdate && \"function\" == typeof i.callbacks.onBeforeUpdate && i.callbacks.onBeforeUpdate.call(this), t.hasClass(d[3]) && t.removeClass(d[3]), t.hasClass(d[4]) && t.removeClass(d[4]), l.css(\"max-height\", \"none\"), l.height() !== t.height() && l.css(\"max-height\", t.height()), _.call(this), \"y\" === i.axis || i.advanced.autoExpandHorizontalScroll || r.css(\"width\", x(r)), n.overflowed = y.call(this), M.call(this), i.autoDraggerLength && S.call(this), b.call(this), T.call(this);var c = [Math.abs(r[0].offsetTop), Math.abs(r[0].offsetLeft)];\"x\" !== i.axis && (n.overflowed[0] ? s[0].height() > s[0].parent().height() ? B.call(this) : (G(t, c[0].toString(), { dir: \"y\", dur: 0, overwrite: \"none\" }), n.contentReset.y = null) : (B.call(this), \"y\" === i.axis ? k.call(this) : \"yx\" === i.axis && n.overflowed[1] && G(t, c[1].toString(), { dir: \"x\", dur: 0, overwrite: \"none\" }))), \"y\" !== i.axis && (n.overflowed[1] ? s[1].width() > s[1].parent().width() ? B.call(this) : (G(t, c[1].toString(), { dir: \"x\", dur: 0, overwrite: \"none\" }), n.contentReset.x = null) : (B.call(this), \"x\" === i.axis ? k.call(this) : \"yx\" === i.axis && n.overflowed[0] && G(t, c[0].toString(), { dir: \"y\", dur: 0, overwrite: \"none\" }))), o && n && (2 === o && i.callbacks.onImageLoad && \"function\" == typeof i.callbacks.onImageLoad ? i.callbacks.onImageLoad.call(this) : 3 === o && i.callbacks.onSelectorChange && \"function\" == typeof i.callbacks.onSelectorChange ? i.callbacks.onSelectorChange.call(this) : i.callbacks.onUpdate && \"function\" == typeof i.callbacks.onUpdate && i.callbacks.onUpdate.call(this)), N.call(this);\n          }\n        });\n      }, scrollTo: function scrollTo(t, o) {\n        if (\"undefined\" != typeof t && null != t) {\n          var n = f.call(this);return e(n).each(function () {\n            var n = e(this);if (n.data(a)) {\n              var i = n.data(a),\n                  r = i.opt,\n                  l = { trigger: \"external\", scrollInertia: r.scrollInertia, scrollEasing: \"mcsEaseInOut\", moveDragger: !1, timeout: 60, callbacks: !0, onStart: !0, onUpdate: !0, onComplete: !0 },\n                  s = e.extend(!0, {}, l, o),\n                  c = Y.call(this, t),\n                  d = s.scrollInertia > 0 && s.scrollInertia < 17 ? 17 : s.scrollInertia;c[0] = X.call(this, c[0], \"y\"), c[1] = X.call(this, c[1], \"x\"), s.moveDragger && (c[0] *= i.scrollRatio.y, c[1] *= i.scrollRatio.x), s.dur = ne() ? 0 : d, setTimeout(function () {\n                null !== c[0] && \"undefined\" != typeof c[0] && \"x\" !== r.axis && i.overflowed[0] && (s.dir = \"y\", s.overwrite = \"all\", G(n, c[0].toString(), s)), null !== c[1] && \"undefined\" != typeof c[1] && \"y\" !== r.axis && i.overflowed[1] && (s.dir = \"x\", s.overwrite = \"none\", G(n, c[1].toString(), s));\n              }, s.timeout);\n            }\n          });\n        }\n      }, stop: function stop() {\n        var t = f.call(this);return e(t).each(function () {\n          var t = e(this);t.data(a) && Q(t);\n        });\n      }, disable: function disable(t) {\n        var o = f.call(this);return e(o).each(function () {\n          var o = e(this);if (o.data(a)) {\n            o.data(a);N.call(this, \"remove\"), k.call(this), t && B.call(this), M.call(this, !0), o.addClass(d[3]);\n          }\n        });\n      }, destroy: function destroy() {\n        var t = f.call(this);return e(t).each(function () {\n          var n = e(this);if (n.data(a)) {\n            var i = n.data(a),\n                r = i.opt,\n                l = e(\"#mCSB_\" + i.idx),\n                s = e(\"#mCSB_\" + i.idx + \"_container\"),\n                c = e(\".mCSB_\" + i.idx + \"_scrollbar\");r.live && m(r.liveSelector || e(t).selector), N.call(this, \"remove\"), k.call(this), B.call(this), n.removeData(a), $(this, \"mcs\"), c.remove(), s.find(\"img.\" + d[2]).removeClass(d[2]), l.replaceWith(s.contents()), n.removeClass(o + \" _\" + a + \"_\" + i.idx + \" \" + d[6] + \" \" + d[7] + \" \" + d[5] + \" \" + d[3]).addClass(d[4]);\n          }\n        });\n      } },\n        f = function f() {\n      return \"object\" != _typeof(e(this)) || e(this).length < 1 ? n : this;\n    },\n        h = function h(t) {\n      var o = [\"rounded\", \"rounded-dark\", \"rounded-dots\", \"rounded-dots-dark\"],\n          a = [\"rounded-dots\", \"rounded-dots-dark\", \"3d\", \"3d-dark\", \"3d-thick\", \"3d-thick-dark\", \"inset\", \"inset-dark\", \"inset-2\", \"inset-2-dark\", \"inset-3\", \"inset-3-dark\"],\n          n = [\"minimal\", \"minimal-dark\"],\n          i = [\"minimal\", \"minimal-dark\"],\n          r = [\"minimal\", \"minimal-dark\"];t.autoDraggerLength = e.inArray(t.theme, o) > -1 ? !1 : t.autoDraggerLength, t.autoExpandScrollbar = e.inArray(t.theme, a) > -1 ? !1 : t.autoExpandScrollbar, t.scrollButtons.enable = e.inArray(t.theme, n) > -1 ? !1 : t.scrollButtons.enable, t.autoHideScrollbar = e.inArray(t.theme, i) > -1 ? !0 : t.autoHideScrollbar, t.scrollbarPosition = e.inArray(t.theme, r) > -1 ? \"outside\" : t.scrollbarPosition;\n    },\n        m = function m(e) {\n      l[e] && (clearTimeout(l[e]), $(l, e));\n    },\n        p = function p(e) {\n      return \"yx\" === e || \"xy\" === e || \"auto\" === e ? \"yx\" : \"x\" === e || \"horizontal\" === e ? \"x\" : \"y\";\n    },\n        g = function g(e) {\n      return \"stepped\" === e || \"pixels\" === e || \"step\" === e || \"click\" === e ? \"stepped\" : \"stepless\";\n    },\n        v = function v() {\n      var t = e(this),\n          n = t.data(a),\n          i = n.opt,\n          r = i.autoExpandScrollbar ? \" \" + d[1] + \"_expand\" : \"\",\n          l = [\"<div id='mCSB_\" + n.idx + \"_scrollbar_vertical' class='mCSB_scrollTools mCSB_\" + n.idx + \"_scrollbar mCS-\" + i.theme + \" mCSB_scrollTools_vertical\" + r + \"'><div class='\" + d[12] + \"'><div id='mCSB_\" + n.idx + \"_dragger_vertical' class='mCSB_dragger' style='position:absolute;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>\", \"<div id='mCSB_\" + n.idx + \"_scrollbar_horizontal' class='mCSB_scrollTools mCSB_\" + n.idx + \"_scrollbar mCS-\" + i.theme + \" mCSB_scrollTools_horizontal\" + r + \"'><div class='\" + d[12] + \"'><div id='mCSB_\" + n.idx + \"_dragger_horizontal' class='mCSB_dragger' style='position:absolute;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>\"],\n          s = \"yx\" === i.axis ? \"mCSB_vertical_horizontal\" : \"x\" === i.axis ? \"mCSB_horizontal\" : \"mCSB_vertical\",\n          c = \"yx\" === i.axis ? l[0] + l[1] : \"x\" === i.axis ? l[1] : l[0],\n          u = \"yx\" === i.axis ? \"<div id='mCSB_\" + n.idx + \"_container_wrapper' class='mCSB_container_wrapper' />\" : \"\",\n          f = i.autoHideScrollbar ? \" \" + d[6] : \"\",\n          h = \"x\" !== i.axis && \"rtl\" === n.langDir ? \" \" + d[7] : \"\";i.setWidth && t.css(\"width\", i.setWidth), i.setHeight && t.css(\"height\", i.setHeight), i.setLeft = \"y\" !== i.axis && \"rtl\" === n.langDir ? \"989999px\" : i.setLeft, t.addClass(o + \" _\" + a + \"_\" + n.idx + f + h).wrapInner(\"<div id='mCSB_\" + n.idx + \"' class='mCustomScrollBox mCS-\" + i.theme + \" \" + s + \"'><div id='mCSB_\" + n.idx + \"_container' class='mCSB_container' style='position:relative; top:\" + i.setTop + \"; left:\" + i.setLeft + \";' dir='\" + n.langDir + \"' /></div>\");var m = e(\"#mCSB_\" + n.idx),\n          p = e(\"#mCSB_\" + n.idx + \"_container\");\"y\" === i.axis || i.advanced.autoExpandHorizontalScroll || p.css(\"width\", x(p)), \"outside\" === i.scrollbarPosition ? (\"static\" === t.css(\"position\") && t.css(\"position\", \"relative\"), t.css(\"overflow\", \"visible\"), m.addClass(\"mCSB_outside\").after(c)) : (m.addClass(\"mCSB_inside\").append(c), p.wrap(u)), w.call(this);var g = [e(\"#mCSB_\" + n.idx + \"_dragger_vertical\"), e(\"#mCSB_\" + n.idx + \"_dragger_horizontal\")];g[0].css(\"min-height\", g[0].height()), g[1].css(\"min-width\", g[1].width());\n    },\n        x = function x(t) {\n      var o = [t[0].scrollWidth, Math.max.apply(Math, t.children().map(function () {\n        return e(this).outerWidth(!0);\n      }).get())],\n          a = t.parent().width();return o[0] > a ? o[0] : o[1] > a ? o[1] : \"100%\";\n    },\n        _ = function _() {\n      var t = e(this),\n          o = t.data(a),\n          n = o.opt,\n          i = e(\"#mCSB_\" + o.idx + \"_container\");if (n.advanced.autoExpandHorizontalScroll && \"y\" !== n.axis) {\n        i.css({ width: \"auto\", \"min-width\": 0, \"overflow-x\": \"scroll\" });var r = Math.ceil(i[0].scrollWidth);3 === n.advanced.autoExpandHorizontalScroll || 2 !== n.advanced.autoExpandHorizontalScroll && r > i.parent().width() ? i.css({ width: r, \"min-width\": \"100%\", \"overflow-x\": \"inherit\" }) : i.css({ \"overflow-x\": \"inherit\", position: \"absolute\" }).wrap(\"<div class='mCSB_h_wrapper' style='position:relative; left:0; width:999999px;' />\").css({ width: Math.ceil(i[0].getBoundingClientRect().right + .4) - Math.floor(i[0].getBoundingClientRect().left), \"min-width\": \"100%\", position: \"relative\" }).unwrap();\n      }\n    },\n        w = function w() {\n      var t = e(this),\n          o = t.data(a),\n          n = o.opt,\n          i = e(\".mCSB_\" + o.idx + \"_scrollbar:first\"),\n          r = oe(n.scrollButtons.tabindex) ? \"tabindex='\" + n.scrollButtons.tabindex + \"'\" : \"\",\n          l = [\"<a href='#' class='\" + d[13] + \"' \" + r + \" />\", \"<a href='#' class='\" + d[14] + \"' \" + r + \" />\", \"<a href='#' class='\" + d[15] + \"' \" + r + \" />\", \"<a href='#' class='\" + d[16] + \"' \" + r + \" />\"],\n          s = [\"x\" === n.axis ? l[2] : l[0], \"x\" === n.axis ? l[3] : l[1], l[2], l[3]];n.scrollButtons.enable && i.prepend(s[0]).append(s[1]).next(\".mCSB_scrollTools\").prepend(s[2]).append(s[3]);\n    },\n        S = function S() {\n      var t = e(this),\n          o = t.data(a),\n          n = e(\"#mCSB_\" + o.idx),\n          i = e(\"#mCSB_\" + o.idx + \"_container\"),\n          r = [e(\"#mCSB_\" + o.idx + \"_dragger_vertical\"), e(\"#mCSB_\" + o.idx + \"_dragger_horizontal\")],\n          l = [n.height() / i.outerHeight(!1), n.width() / i.outerWidth(!1)],\n          c = [parseInt(r[0].css(\"min-height\")), Math.round(l[0] * r[0].parent().height()), parseInt(r[1].css(\"min-width\")), Math.round(l[1] * r[1].parent().width())],\n          d = s && c[1] < c[0] ? c[0] : c[1],\n          u = s && c[3] < c[2] ? c[2] : c[3];r[0].css({ height: d, \"max-height\": r[0].parent().height() - 10 }).find(\".mCSB_dragger_bar\").css({ \"line-height\": c[0] + \"px\" }), r[1].css({ width: u, \"max-width\": r[1].parent().width() - 10 });\n    },\n        b = function b() {\n      var t = e(this),\n          o = t.data(a),\n          n = e(\"#mCSB_\" + o.idx),\n          i = e(\"#mCSB_\" + o.idx + \"_container\"),\n          r = [e(\"#mCSB_\" + o.idx + \"_dragger_vertical\"), e(\"#mCSB_\" + o.idx + \"_dragger_horizontal\")],\n          l = [i.outerHeight(!1) - n.height(), i.outerWidth(!1) - n.width()],\n          s = [l[0] / (r[0].parent().height() - r[0].height()), l[1] / (r[1].parent().width() - r[1].width())];o.scrollRatio = { y: s[0], x: s[1] };\n    },\n        C = function C(e, t, o) {\n      var a = o ? d[0] + \"_expanded\" : \"\",\n          n = e.closest(\".mCSB_scrollTools\");\"active\" === t ? (e.toggleClass(d[0] + \" \" + a), n.toggleClass(d[1]), e[0]._draggable = e[0]._draggable ? 0 : 1) : e[0]._draggable || (\"hide\" === t ? (e.removeClass(d[0]), n.removeClass(d[1])) : (e.addClass(d[0]), n.addClass(d[1])));\n    },\n        y = function y() {\n      var t = e(this),\n          o = t.data(a),\n          n = e(\"#mCSB_\" + o.idx),\n          i = e(\"#mCSB_\" + o.idx + \"_container\"),\n          r = null == o.overflowed ? i.height() : i.outerHeight(!1),\n          l = null == o.overflowed ? i.width() : i.outerWidth(!1),\n          s = i[0].scrollHeight,\n          c = i[0].scrollWidth;return s > r && (r = s), c > l && (l = c), [r > n.height(), l > n.width()];\n    },\n        B = function B() {\n      var t = e(this),\n          o = t.data(a),\n          n = o.opt,\n          i = e(\"#mCSB_\" + o.idx),\n          r = e(\"#mCSB_\" + o.idx + \"_container\"),\n          l = [e(\"#mCSB_\" + o.idx + \"_dragger_vertical\"), e(\"#mCSB_\" + o.idx + \"_dragger_horizontal\")];if (Q(t), (\"x\" !== n.axis && !o.overflowed[0] || \"y\" === n.axis && o.overflowed[0]) && (l[0].add(r).css(\"top\", 0), G(t, \"_resetY\")), \"y\" !== n.axis && !o.overflowed[1] || \"x\" === n.axis && o.overflowed[1]) {\n        var s = dx = 0;\"rtl\" === o.langDir && (s = i.width() - r.outerWidth(!1), dx = Math.abs(s / o.scrollRatio.x)), r.css(\"left\", s), l[1].css(\"left\", dx), G(t, \"_resetX\");\n      }\n    },\n        T = function T() {\n      function t() {\n        r = setTimeout(function () {\n          e.event.special.mousewheel ? (clearTimeout(r), W.call(o[0])) : t();\n        }, 100);\n      }var o = e(this),\n          n = o.data(a),\n          i = n.opt;if (!n.bindEvents) {\n        if (I.call(this), i.contentTouchScroll && D.call(this), E.call(this), i.mouseWheel.enable) {\n          var r;t();\n        }P.call(this), U.call(this), i.advanced.autoScrollOnFocus && H.call(this), i.scrollButtons.enable && F.call(this), i.keyboard.enable && q.call(this), n.bindEvents = !0;\n      }\n    },\n        k = function k() {\n      var t = e(this),\n          o = t.data(a),\n          n = o.opt,\n          i = a + \"_\" + o.idx,\n          r = \".mCSB_\" + o.idx + \"_scrollbar\",\n          l = e(\"#mCSB_\" + o.idx + \",#mCSB_\" + o.idx + \"_container,#mCSB_\" + o.idx + \"_container_wrapper,\" + r + \" .\" + d[12] + \",#mCSB_\" + o.idx + \"_dragger_vertical,#mCSB_\" + o.idx + \"_dragger_horizontal,\" + r + \">a\"),\n          s = e(\"#mCSB_\" + o.idx + \"_container\");n.advanced.releaseDraggableSelectors && l.add(e(n.advanced.releaseDraggableSelectors)), n.advanced.extraDraggableSelectors && l.add(e(n.advanced.extraDraggableSelectors)), o.bindEvents && (e(document).add(e(!A() || top.document)).unbind(\".\" + i), l.each(function () {\n        e(this).unbind(\".\" + i);\n      }), clearTimeout(t[0]._focusTimeout), $(t[0], \"_focusTimeout\"), clearTimeout(o.sequential.step), $(o.sequential, \"step\"), clearTimeout(s[0].onCompleteTimeout), $(s[0], \"onCompleteTimeout\"), o.bindEvents = !1);\n    },\n        M = function M(t) {\n      var o = e(this),\n          n = o.data(a),\n          i = n.opt,\n          r = e(\"#mCSB_\" + n.idx + \"_container_wrapper\"),\n          l = r.length ? r : e(\"#mCSB_\" + n.idx + \"_container\"),\n          s = [e(\"#mCSB_\" + n.idx + \"_scrollbar_vertical\"), e(\"#mCSB_\" + n.idx + \"_scrollbar_horizontal\")],\n          c = [s[0].find(\".mCSB_dragger\"), s[1].find(\".mCSB_dragger\")];\"x\" !== i.axis && (n.overflowed[0] && !t ? (s[0].add(c[0]).add(s[0].children(\"a\")).css(\"display\", \"block\"), l.removeClass(d[8] + \" \" + d[10])) : (i.alwaysShowScrollbar ? (2 !== i.alwaysShowScrollbar && c[0].css(\"display\", \"none\"), l.removeClass(d[10])) : (s[0].css(\"display\", \"none\"), l.addClass(d[10])), l.addClass(d[8]))), \"y\" !== i.axis && (n.overflowed[1] && !t ? (s[1].add(c[1]).add(s[1].children(\"a\")).css(\"display\", \"block\"), l.removeClass(d[9] + \" \" + d[11])) : (i.alwaysShowScrollbar ? (2 !== i.alwaysShowScrollbar && c[1].css(\"display\", \"none\"), l.removeClass(d[11])) : (s[1].css(\"display\", \"none\"), l.addClass(d[11])), l.addClass(d[9]))), n.overflowed[0] || n.overflowed[1] ? o.removeClass(d[5]) : o.addClass(d[5]);\n    },\n        O = function O(t) {\n      var o = t.type,\n          a = t.target.ownerDocument !== document && null !== frameElement ? [e(frameElement).offset().top, e(frameElement).offset().left] : null,\n          n = A() && t.target.ownerDocument !== top.document && null !== frameElement ? [e(t.view.frameElement).offset().top, e(t.view.frameElement).offset().left] : [0, 0];switch (o) {case \"pointerdown\":case \"MSPointerDown\":case \"pointermove\":case \"MSPointerMove\":case \"pointerup\":case \"MSPointerUp\":\n          return a ? [t.originalEvent.pageY - a[0] + n[0], t.originalEvent.pageX - a[1] + n[1], !1] : [t.originalEvent.pageY, t.originalEvent.pageX, !1];case \"touchstart\":case \"touchmove\":case \"touchend\":\n          var i = t.originalEvent.touches[0] || t.originalEvent.changedTouches[0],\n              r = t.originalEvent.touches.length || t.originalEvent.changedTouches.length;return t.target.ownerDocument !== document ? [i.screenY, i.screenX, r > 1] : [i.pageY, i.pageX, r > 1];default:\n          return a ? [t.pageY - a[0] + n[0], t.pageX - a[1] + n[1], !1] : [t.pageY, t.pageX, !1];}\n    },\n        I = function I() {\n      function t(e, t, a, n) {\n        if (h[0].idleTimer = d.scrollInertia < 233 ? 250 : 0, o.attr(\"id\") === f[1]) var i = \"x\",\n            s = (o[0].offsetLeft - t + n) * l.scrollRatio.x;else var i = \"y\",\n            s = (o[0].offsetTop - e + a) * l.scrollRatio.y;G(r, s.toString(), { dir: i, drag: !0 });\n      }var o,\n          n,\n          i,\n          r = e(this),\n          l = r.data(a),\n          d = l.opt,\n          u = a + \"_\" + l.idx,\n          f = [\"mCSB_\" + l.idx + \"_dragger_vertical\", \"mCSB_\" + l.idx + \"_dragger_horizontal\"],\n          h = e(\"#mCSB_\" + l.idx + \"_container\"),\n          m = e(\"#\" + f[0] + \",#\" + f[1]),\n          p = d.advanced.releaseDraggableSelectors ? m.add(e(d.advanced.releaseDraggableSelectors)) : m,\n          g = d.advanced.extraDraggableSelectors ? e(!A() || top.document).add(e(d.advanced.extraDraggableSelectors)) : e(!A() || top.document);m.bind(\"contextmenu.\" + u, function (e) {\n        e.preventDefault();\n      }).bind(\"mousedown.\" + u + \" touchstart.\" + u + \" pointerdown.\" + u + \" MSPointerDown.\" + u, function (t) {\n        if (t.stopImmediatePropagation(), t.preventDefault(), ee(t)) {\n          c = !0, s && (document.onselectstart = function () {\n            return !1;\n          }), L.call(h, !1), Q(r), o = e(this);var a = o.offset(),\n              l = O(t)[0] - a.top,\n              u = O(t)[1] - a.left,\n              f = o.height() + a.top,\n              m = o.width() + a.left;f > l && l > 0 && m > u && u > 0 && (n = l, i = u), C(o, \"active\", d.autoExpandScrollbar);\n        }\n      }).bind(\"touchmove.\" + u, function (e) {\n        e.stopImmediatePropagation(), e.preventDefault();var a = o.offset(),\n            r = O(e)[0] - a.top,\n            l = O(e)[1] - a.left;t(n, i, r, l);\n      }), e(document).add(g).bind(\"mousemove.\" + u + \" pointermove.\" + u + \" MSPointerMove.\" + u, function (e) {\n        if (o) {\n          var a = o.offset(),\n              r = O(e)[0] - a.top,\n              l = O(e)[1] - a.left;if (n === r && i === l) return;t(n, i, r, l);\n        }\n      }).add(p).bind(\"mouseup.\" + u + \" touchend.\" + u + \" pointerup.\" + u + \" MSPointerUp.\" + u, function () {\n        o && (C(o, \"active\", d.autoExpandScrollbar), o = null), c = !1, s && (document.onselectstart = null), L.call(h, !0);\n      });\n    },\n        D = function D() {\n      function o(e) {\n        if (!te(e) || c || O(e)[2]) return void (t = 0);t = 1, b = 0, C = 0, d = 1, y.removeClass(\"mCS_touch_action\");var o = I.offset();u = O(e)[0] - o.top, f = O(e)[1] - o.left, z = [O(e)[0], O(e)[1]];\n      }function n(e) {\n        if (te(e) && !c && !O(e)[2] && (T.documentTouchScroll || e.preventDefault(), e.stopImmediatePropagation(), (!C || b) && d)) {\n          g = K();var t = M.offset(),\n              o = O(e)[0] - t.top,\n              a = O(e)[1] - t.left,\n              n = \"mcsLinearOut\";if (E.push(o), W.push(a), z[2] = Math.abs(O(e)[0] - z[0]), z[3] = Math.abs(O(e)[1] - z[1]), B.overflowed[0]) var i = D[0].parent().height() - D[0].height(),\n              r = u - o > 0 && o - u > -(i * B.scrollRatio.y) && (2 * z[3] < z[2] || \"yx\" === T.axis);if (B.overflowed[1]) var l = D[1].parent().width() - D[1].width(),\n              h = f - a > 0 && a - f > -(l * B.scrollRatio.x) && (2 * z[2] < z[3] || \"yx\" === T.axis);r || h ? (U || e.preventDefault(), b = 1) : (C = 1, y.addClass(\"mCS_touch_action\")), U && e.preventDefault(), w = \"yx\" === T.axis ? [u - o, f - a] : \"x\" === T.axis ? [null, f - a] : [u - o, null], I[0].idleTimer = 250, B.overflowed[0] && s(w[0], R, n, \"y\", \"all\", !0), B.overflowed[1] && s(w[1], R, n, \"x\", L, !0);\n        }\n      }function i(e) {\n        if (!te(e) || c || O(e)[2]) return void (t = 0);t = 1, e.stopImmediatePropagation(), Q(y), p = K();var o = M.offset();h = O(e)[0] - o.top, m = O(e)[1] - o.left, E = [], W = [];\n      }function r(e) {\n        if (te(e) && !c && !O(e)[2]) {\n          d = 0, e.stopImmediatePropagation(), b = 0, C = 0, v = K();var t = M.offset(),\n              o = O(e)[0] - t.top,\n              a = O(e)[1] - t.left;if (!(v - g > 30)) {\n            _ = 1e3 / (v - p);var n = \"mcsEaseOut\",\n                i = 2.5 > _,\n                r = i ? [E[E.length - 2], W[W.length - 2]] : [0, 0];x = i ? [o - r[0], a - r[1]] : [o - h, a - m];var u = [Math.abs(x[0]), Math.abs(x[1])];_ = i ? [Math.abs(x[0] / 4), Math.abs(x[1] / 4)] : [_, _];var f = [Math.abs(I[0].offsetTop) - x[0] * l(u[0] / _[0], _[0]), Math.abs(I[0].offsetLeft) - x[1] * l(u[1] / _[1], _[1])];w = \"yx\" === T.axis ? [f[0], f[1]] : \"x\" === T.axis ? [null, f[1]] : [f[0], null], S = [4 * u[0] + T.scrollInertia, 4 * u[1] + T.scrollInertia];var y = parseInt(T.contentTouchScroll) || 0;w[0] = u[0] > y ? w[0] : 0, w[1] = u[1] > y ? w[1] : 0, B.overflowed[0] && s(w[0], S[0], n, \"y\", L, !1), B.overflowed[1] && s(w[1], S[1], n, \"x\", L, !1);\n          }\n        }\n      }function l(e, t) {\n        var o = [1.5 * t, 2 * t, t / 1.5, t / 2];return e > 90 ? t > 4 ? o[0] : o[3] : e > 60 ? t > 3 ? o[3] : o[2] : e > 30 ? t > 8 ? o[1] : t > 6 ? o[0] : t > 4 ? t : o[2] : t > 8 ? t : o[3];\n      }function s(e, t, o, a, n, i) {\n        e && G(y, e.toString(), { dur: t, scrollEasing: o, dir: a, overwrite: n, drag: i });\n      }var d,\n          u,\n          f,\n          h,\n          m,\n          p,\n          g,\n          v,\n          x,\n          _,\n          w,\n          S,\n          b,\n          C,\n          y = e(this),\n          B = y.data(a),\n          T = B.opt,\n          k = a + \"_\" + B.idx,\n          M = e(\"#mCSB_\" + B.idx),\n          I = e(\"#mCSB_\" + B.idx + \"_container\"),\n          D = [e(\"#mCSB_\" + B.idx + \"_dragger_vertical\"), e(\"#mCSB_\" + B.idx + \"_dragger_horizontal\")],\n          E = [],\n          W = [],\n          R = 0,\n          L = \"yx\" === T.axis ? \"none\" : \"all\",\n          z = [],\n          P = I.find(\"iframe\"),\n          H = [\"touchstart.\" + k + \" pointerdown.\" + k + \" MSPointerDown.\" + k, \"touchmove.\" + k + \" pointermove.\" + k + \" MSPointerMove.\" + k, \"touchend.\" + k + \" pointerup.\" + k + \" MSPointerUp.\" + k],\n          U = void 0 !== document.body.style.touchAction && \"\" !== document.body.style.touchAction;I.bind(H[0], function (e) {\n        o(e);\n      }).bind(H[1], function (e) {\n        n(e);\n      }), M.bind(H[0], function (e) {\n        i(e);\n      }).bind(H[2], function (e) {\n        r(e);\n      }), P.length && P.each(function () {\n        e(this).bind(\"load\", function () {\n          A(this) && e(this.contentDocument || this.contentWindow.document).bind(H[0], function (e) {\n            o(e), i(e);\n          }).bind(H[1], function (e) {\n            n(e);\n          }).bind(H[2], function (e) {\n            r(e);\n          });\n        });\n      });\n    },\n        E = function E() {\n      function o() {\n        return window.getSelection ? window.getSelection().toString() : document.selection && \"Control\" != document.selection.type ? document.selection.createRange().text : 0;\n      }function n(e, t, o) {\n        d.type = o && i ? \"stepped\" : \"stepless\", d.scrollAmount = 10, j(r, e, t, \"mcsLinearOut\", o ? 60 : null);\n      }var i,\n          r = e(this),\n          l = r.data(a),\n          s = l.opt,\n          d = l.sequential,\n          u = a + \"_\" + l.idx,\n          f = e(\"#mCSB_\" + l.idx + \"_container\"),\n          h = f.parent();f.bind(\"mousedown.\" + u, function () {\n        t || i || (i = 1, c = !0);\n      }).add(document).bind(\"mousemove.\" + u, function (e) {\n        if (!t && i && o()) {\n          var a = f.offset(),\n              r = O(e)[0] - a.top + f[0].offsetTop,\n              c = O(e)[1] - a.left + f[0].offsetLeft;r > 0 && r < h.height() && c > 0 && c < h.width() ? d.step && n(\"off\", null, \"stepped\") : (\"x\" !== s.axis && l.overflowed[0] && (0 > r ? n(\"on\", 38) : r > h.height() && n(\"on\", 40)), \"y\" !== s.axis && l.overflowed[1] && (0 > c ? n(\"on\", 37) : c > h.width() && n(\"on\", 39)));\n        }\n      }).bind(\"mouseup.\" + u + \" dragend.\" + u, function () {\n        t || (i && (i = 0, n(\"off\", null)), c = !1);\n      });\n    },\n        W = function W() {\n      function t(t, a) {\n        if (Q(o), !z(o, t.target)) {\n          var r = \"auto\" !== i.mouseWheel.deltaFactor ? parseInt(i.mouseWheel.deltaFactor) : s && t.deltaFactor < 100 ? 100 : t.deltaFactor || 100,\n              d = i.scrollInertia;if (\"x\" === i.axis || \"x\" === i.mouseWheel.axis) var u = \"x\",\n              f = [Math.round(r * n.scrollRatio.x), parseInt(i.mouseWheel.scrollAmount)],\n              h = \"auto\" !== i.mouseWheel.scrollAmount ? f[1] : f[0] >= l.width() ? .9 * l.width() : f[0],\n              m = Math.abs(e(\"#mCSB_\" + n.idx + \"_container\")[0].offsetLeft),\n              p = c[1][0].offsetLeft,\n              g = c[1].parent().width() - c[1].width(),\n              v = \"y\" === i.mouseWheel.axis ? t.deltaY || a : t.deltaX;else var u = \"y\",\n              f = [Math.round(r * n.scrollRatio.y), parseInt(i.mouseWheel.scrollAmount)],\n              h = \"auto\" !== i.mouseWheel.scrollAmount ? f[1] : f[0] >= l.height() ? .9 * l.height() : f[0],\n              m = Math.abs(e(\"#mCSB_\" + n.idx + \"_container\")[0].offsetTop),\n              p = c[0][0].offsetTop,\n              g = c[0].parent().height() - c[0].height(),\n              v = t.deltaY || a;\"y\" === u && !n.overflowed[0] || \"x\" === u && !n.overflowed[1] || ((i.mouseWheel.invert || t.webkitDirectionInvertedFromDevice) && (v = -v), i.mouseWheel.normalizeDelta && (v = 0 > v ? -1 : 1), (v > 0 && 0 !== p || 0 > v && p !== g || i.mouseWheel.preventDefault) && (t.stopImmediatePropagation(), t.preventDefault()), t.deltaFactor < 5 && !i.mouseWheel.normalizeDelta && (h = t.deltaFactor, d = 17), G(o, (m - v * h).toString(), { dir: u, dur: d }));\n        }\n      }if (e(this).data(a)) {\n        var o = e(this),\n            n = o.data(a),\n            i = n.opt,\n            r = a + \"_\" + n.idx,\n            l = e(\"#mCSB_\" + n.idx),\n            c = [e(\"#mCSB_\" + n.idx + \"_dragger_vertical\"), e(\"#mCSB_\" + n.idx + \"_dragger_horizontal\")],\n            d = e(\"#mCSB_\" + n.idx + \"_container\").find(\"iframe\");d.length && d.each(function () {\n          e(this).bind(\"load\", function () {\n            A(this) && e(this.contentDocument || this.contentWindow.document).bind(\"mousewheel.\" + r, function (e, o) {\n              t(e, o);\n            });\n          });\n        }), l.bind(\"mousewheel.\" + r, function (e, o) {\n          t(e, o);\n        });\n      }\n    },\n        R = new Object(),\n        A = function A(t) {\n      var o = !1,\n          a = !1,\n          n = null;if (void 0 === t ? a = \"#empty\" : void 0 !== e(t).attr(\"id\") && (a = e(t).attr(\"id\")), a !== !1 && void 0 !== R[a]) return R[a];if (t) {\n        try {\n          var i = t.contentDocument || t.contentWindow.document;n = i.body.innerHTML;\n        } catch (r) {}o = null !== n;\n      } else {\n        try {\n          var i = top.document;n = i.body.innerHTML;\n        } catch (r) {}o = null !== n;\n      }return a !== !1 && (R[a] = o), o;\n    },\n        L = function L(e) {\n      var t = this.find(\"iframe\");if (t.length) {\n        var o = e ? \"auto\" : \"none\";t.css(\"pointer-events\", o);\n      }\n    },\n        z = function z(t, o) {\n      var n = o.nodeName.toLowerCase(),\n          i = t.data(a).opt.mouseWheel.disableOver,\n          r = [\"select\", \"textarea\"];return e.inArray(n, i) > -1 && !(e.inArray(n, r) > -1 && !e(o).is(\":focus\"));\n    },\n        P = function P() {\n      var t,\n          o = e(this),\n          n = o.data(a),\n          i = a + \"_\" + n.idx,\n          r = e(\"#mCSB_\" + n.idx + \"_container\"),\n          l = r.parent(),\n          s = e(\".mCSB_\" + n.idx + \"_scrollbar .\" + d[12]);s.bind(\"mousedown.\" + i + \" touchstart.\" + i + \" pointerdown.\" + i + \" MSPointerDown.\" + i, function (o) {\n        c = !0, e(o.target).hasClass(\"mCSB_dragger\") || (t = 1);\n      }).bind(\"touchend.\" + i + \" pointerup.\" + i + \" MSPointerUp.\" + i, function () {\n        c = !1;\n      }).bind(\"click.\" + i, function (a) {\n        if (t && (t = 0, e(a.target).hasClass(d[12]) || e(a.target).hasClass(\"mCSB_draggerRail\"))) {\n          Q(o);var i = e(this),\n              s = i.find(\".mCSB_dragger\");if (i.parent(\".mCSB_scrollTools_horizontal\").length > 0) {\n            if (!n.overflowed[1]) return;var c = \"x\",\n                u = a.pageX > s.offset().left ? -1 : 1,\n                f = Math.abs(r[0].offsetLeft) - u * (.9 * l.width());\n          } else {\n            if (!n.overflowed[0]) return;var c = \"y\",\n                u = a.pageY > s.offset().top ? -1 : 1,\n                f = Math.abs(r[0].offsetTop) - u * (.9 * l.height());\n          }G(o, f.toString(), { dir: c, scrollEasing: \"mcsEaseInOut\" });\n        }\n      });\n    },\n        H = function H() {\n      var t = e(this),\n          o = t.data(a),\n          n = o.opt,\n          i = a + \"_\" + o.idx,\n          r = e(\"#mCSB_\" + o.idx + \"_container\"),\n          l = r.parent();r.bind(\"focusin.\" + i, function () {\n        var o = e(document.activeElement),\n            a = r.find(\".mCustomScrollBox\").length,\n            i = 0;o.is(n.advanced.autoScrollOnFocus) && (Q(t), clearTimeout(t[0]._focusTimeout), t[0]._focusTimer = a ? (i + 17) * a : 0, t[0]._focusTimeout = setTimeout(function () {\n          var e = [ae(o)[0], ae(o)[1]],\n              a = [r[0].offsetTop, r[0].offsetLeft],\n              s = [a[0] + e[0] >= 0 && a[0] + e[0] < l.height() - o.outerHeight(!1), a[1] + e[1] >= 0 && a[0] + e[1] < l.width() - o.outerWidth(!1)],\n              c = \"yx\" !== n.axis || s[0] || s[1] ? \"all\" : \"none\";\"x\" === n.axis || s[0] || G(t, e[0].toString(), { dir: \"y\", scrollEasing: \"mcsEaseInOut\", overwrite: c, dur: i }), \"y\" === n.axis || s[1] || G(t, e[1].toString(), { dir: \"x\", scrollEasing: \"mcsEaseInOut\", overwrite: c, dur: i });\n        }, t[0]._focusTimer));\n      });\n    },\n        U = function U() {\n      var t = e(this),\n          o = t.data(a),\n          n = a + \"_\" + o.idx,\n          i = e(\"#mCSB_\" + o.idx + \"_container\").parent();i.bind(\"scroll.\" + n, function () {\n        0 === i.scrollTop() && 0 === i.scrollLeft() || e(\".mCSB_\" + o.idx + \"_scrollbar\").css(\"visibility\", \"hidden\");\n      });\n    },\n        F = function F() {\n      var t = e(this),\n          o = t.data(a),\n          n = o.opt,\n          i = o.sequential,\n          r = a + \"_\" + o.idx,\n          l = \".mCSB_\" + o.idx + \"_scrollbar\",\n          s = e(l + \">a\");s.bind(\"contextmenu.\" + r, function (e) {\n        e.preventDefault();\n      }).bind(\"mousedown.\" + r + \" touchstart.\" + r + \" pointerdown.\" + r + \" MSPointerDown.\" + r + \" mouseup.\" + r + \" touchend.\" + r + \" pointerup.\" + r + \" MSPointerUp.\" + r + \" mouseout.\" + r + \" pointerout.\" + r + \" MSPointerOut.\" + r + \" click.\" + r, function (a) {\n        function r(e, o) {\n          i.scrollAmount = n.scrollButtons.scrollAmount, j(t, e, o);\n        }if (a.preventDefault(), ee(a)) {\n          var l = e(this).attr(\"class\");switch (i.type = n.scrollButtons.scrollType, a.type) {case \"mousedown\":case \"touchstart\":case \"pointerdown\":case \"MSPointerDown\":\n              if (\"stepped\" === i.type) return;c = !0, o.tweenRunning = !1, r(\"on\", l);break;case \"mouseup\":case \"touchend\":case \"pointerup\":case \"MSPointerUp\":case \"mouseout\":case \"pointerout\":case \"MSPointerOut\":\n              if (\"stepped\" === i.type) return;c = !1, i.dir && r(\"off\", l);break;case \"click\":\n              if (\"stepped\" !== i.type || o.tweenRunning) return;r(\"on\", l);}\n        }\n      });\n    },\n        q = function q() {\n      function t(t) {\n        function a(e, t) {\n          r.type = i.keyboard.scrollType, r.scrollAmount = i.keyboard.scrollAmount, \"stepped\" === r.type && n.tweenRunning || j(o, e, t);\n        }switch (t.type) {case \"blur\":\n            n.tweenRunning && r.dir && a(\"off\", null);break;case \"keydown\":case \"keyup\":\n            var l = t.keyCode ? t.keyCode : t.which,\n                s = \"on\";if (\"x\" !== i.axis && (38 === l || 40 === l) || \"y\" !== i.axis && (37 === l || 39 === l)) {\n              if ((38 === l || 40 === l) && !n.overflowed[0] || (37 === l || 39 === l) && !n.overflowed[1]) return;\"keyup\" === t.type && (s = \"off\"), e(document.activeElement).is(u) || (t.preventDefault(), t.stopImmediatePropagation(), a(s, l));\n            } else if (33 === l || 34 === l) {\n              if ((n.overflowed[0] || n.overflowed[1]) && (t.preventDefault(), t.stopImmediatePropagation()), \"keyup\" === t.type) {\n                Q(o);var f = 34 === l ? -1 : 1;if (\"x\" === i.axis || \"yx\" === i.axis && n.overflowed[1] && !n.overflowed[0]) var h = \"x\",\n                    m = Math.abs(c[0].offsetLeft) - f * (.9 * d.width());else var h = \"y\",\n                    m = Math.abs(c[0].offsetTop) - f * (.9 * d.height());G(o, m.toString(), { dir: h, scrollEasing: \"mcsEaseInOut\" });\n              }\n            } else if ((35 === l || 36 === l) && !e(document.activeElement).is(u) && ((n.overflowed[0] || n.overflowed[1]) && (t.preventDefault(), t.stopImmediatePropagation()), \"keyup\" === t.type)) {\n              if (\"x\" === i.axis || \"yx\" === i.axis && n.overflowed[1] && !n.overflowed[0]) var h = \"x\",\n                  m = 35 === l ? Math.abs(d.width() - c.outerWidth(!1)) : 0;else var h = \"y\",\n                  m = 35 === l ? Math.abs(d.height() - c.outerHeight(!1)) : 0;G(o, m.toString(), { dir: h, scrollEasing: \"mcsEaseInOut\" });\n            }}\n      }var o = e(this),\n          n = o.data(a),\n          i = n.opt,\n          r = n.sequential,\n          l = a + \"_\" + n.idx,\n          s = e(\"#mCSB_\" + n.idx),\n          c = e(\"#mCSB_\" + n.idx + \"_container\"),\n          d = c.parent(),\n          u = \"input,textarea,select,datalist,keygen,[contenteditable='true']\",\n          f = c.find(\"iframe\"),\n          h = [\"blur.\" + l + \" keydown.\" + l + \" keyup.\" + l];f.length && f.each(function () {\n        e(this).bind(\"load\", function () {\n          A(this) && e(this.contentDocument || this.contentWindow.document).bind(h[0], function (e) {\n            t(e);\n          });\n        });\n      }), s.attr(\"tabindex\", \"0\").bind(h[0], function (e) {\n        t(e);\n      });\n    },\n        j = function j(t, o, n, i, r) {\n      function l(e) {\n        u.snapAmount && (f.scrollAmount = u.snapAmount instanceof Array ? \"x\" === f.dir[0] ? u.snapAmount[1] : u.snapAmount[0] : u.snapAmount);var o = \"stepped\" !== f.type,\n            a = r ? r : e ? o ? p / 1.5 : g : 1e3 / 60,\n            n = e ? o ? 7.5 : 40 : 2.5,\n            s = [Math.abs(h[0].offsetTop), Math.abs(h[0].offsetLeft)],\n            d = [c.scrollRatio.y > 10 ? 10 : c.scrollRatio.y, c.scrollRatio.x > 10 ? 10 : c.scrollRatio.x],\n            m = \"x\" === f.dir[0] ? s[1] + f.dir[1] * (d[1] * n) : s[0] + f.dir[1] * (d[0] * n),\n            v = \"x\" === f.dir[0] ? s[1] + f.dir[1] * parseInt(f.scrollAmount) : s[0] + f.dir[1] * parseInt(f.scrollAmount),\n            x = \"auto\" !== f.scrollAmount ? v : m,\n            _ = i ? i : e ? o ? \"mcsLinearOut\" : \"mcsEaseInOut\" : \"mcsLinear\",\n            w = !!e;return e && 17 > a && (x = \"x\" === f.dir[0] ? s[1] : s[0]), G(t, x.toString(), { dir: f.dir[0], scrollEasing: _, dur: a, onComplete: w }), e ? void (f.dir = !1) : (clearTimeout(f.step), void (f.step = setTimeout(function () {\n          l();\n        }, a)));\n      }function s() {\n        clearTimeout(f.step), $(f, \"step\"), Q(t);\n      }var c = t.data(a),\n          u = c.opt,\n          f = c.sequential,\n          h = e(\"#mCSB_\" + c.idx + \"_container\"),\n          m = \"stepped\" === f.type,\n          p = u.scrollInertia < 26 ? 26 : u.scrollInertia,\n          g = u.scrollInertia < 1 ? 17 : u.scrollInertia;switch (o) {case \"on\":\n          if (f.dir = [n === d[16] || n === d[15] || 39 === n || 37 === n ? \"x\" : \"y\", n === d[13] || n === d[15] || 38 === n || 37 === n ? -1 : 1], Q(t), oe(n) && \"stepped\" === f.type) return;l(m);break;case \"off\":\n          s(), (m || c.tweenRunning && f.dir) && l(!0);}\n    },\n        Y = function Y(t) {\n      var o = e(this).data(a).opt,\n          n = [];return \"function\" == typeof t && (t = t()), t instanceof Array ? n = t.length > 1 ? [t[0], t[1]] : \"x\" === o.axis ? [null, t[0]] : [t[0], null] : (n[0] = t.y ? t.y : t.x || \"x\" === o.axis ? null : t, n[1] = t.x ? t.x : t.y || \"y\" === o.axis ? null : t), \"function\" == typeof n[0] && (n[0] = n[0]()), \"function\" == typeof n[1] && (n[1] = n[1]()), n;\n    },\n        X = function X(t, o) {\n      if (null != t && \"undefined\" != typeof t) {\n        var n = e(this),\n            i = n.data(a),\n            r = i.opt,\n            l = e(\"#mCSB_\" + i.idx + \"_container\"),\n            s = l.parent(),\n            c = typeof t === \"undefined\" ? \"undefined\" : _typeof(t);o || (o = \"x\" === r.axis ? \"x\" : \"y\");var d = \"x\" === o ? l.outerWidth(!1) - s.width() : l.outerHeight(!1) - s.height(),\n            f = \"x\" === o ? l[0].offsetLeft : l[0].offsetTop,\n            h = \"x\" === o ? \"left\" : \"top\";switch (c) {case \"function\":\n            return t();case \"object\":\n            var m = t.jquery ? t : e(t);if (!m.length) return;return \"x\" === o ? ae(m)[1] : ae(m)[0];case \"string\":case \"number\":\n            if (oe(t)) return Math.abs(t);if (-1 !== t.indexOf(\"%\")) return Math.abs(d * parseInt(t) / 100);if (-1 !== t.indexOf(\"-=\")) return Math.abs(f - parseInt(t.split(\"-=\")[1]));if (-1 !== t.indexOf(\"+=\")) {\n              var p = f + parseInt(t.split(\"+=\")[1]);return p >= 0 ? 0 : Math.abs(p);\n            }if (-1 !== t.indexOf(\"px\") && oe(t.split(\"px\")[0])) return Math.abs(t.split(\"px\")[0]);if (\"top\" === t || \"left\" === t) return 0;if (\"bottom\" === t) return Math.abs(s.height() - l.outerHeight(!1));if (\"right\" === t) return Math.abs(s.width() - l.outerWidth(!1));if (\"first\" === t || \"last\" === t) {\n              var m = l.find(\":\" + t);return \"x\" === o ? ae(m)[1] : ae(m)[0];\n            }return e(t).length ? \"x\" === o ? ae(e(t))[1] : ae(e(t))[0] : (l.css(h, t), void u.update.call(null, n[0]));}\n      }\n    },\n        N = function N(t) {\n      function o() {\n        return clearTimeout(f[0].autoUpdate), 0 === l.parents(\"html\").length ? void (l = null) : void (f[0].autoUpdate = setTimeout(function () {\n          return c.advanced.updateOnSelectorChange && (s.poll.change.n = i(), s.poll.change.n !== s.poll.change.o) ? (s.poll.change.o = s.poll.change.n, void r(3)) : c.advanced.updateOnContentResize && (s.poll.size.n = l[0].scrollHeight + l[0].scrollWidth + f[0].offsetHeight + l[0].offsetHeight + l[0].offsetWidth, s.poll.size.n !== s.poll.size.o) ? (s.poll.size.o = s.poll.size.n, void r(1)) : !c.advanced.updateOnImageLoad || \"auto\" === c.advanced.updateOnImageLoad && \"y\" === c.axis || (s.poll.img.n = f.find(\"img\").length, s.poll.img.n === s.poll.img.o) ? void ((c.advanced.updateOnSelectorChange || c.advanced.updateOnContentResize || c.advanced.updateOnImageLoad) && o()) : (s.poll.img.o = s.poll.img.n, void f.find(\"img\").each(function () {\n            n(this);\n          }));\n        }, c.advanced.autoUpdateTimeout));\n      }function n(t) {\n        function o(e, t) {\n          return function () {\n            return t.apply(e, arguments);\n          };\n        }function a() {\n          this.onload = null, e(t).addClass(d[2]), r(2);\n        }if (e(t).hasClass(d[2])) return void r();var n = new Image();n.onload = o(n, a), n.src = t.src;\n      }function i() {\n        c.advanced.updateOnSelectorChange === !0 && (c.advanced.updateOnSelectorChange = \"*\");var e = 0,\n            t = f.find(c.advanced.updateOnSelectorChange);return c.advanced.updateOnSelectorChange && t.length > 0 && t.each(function () {\n          e += this.offsetHeight + this.offsetWidth;\n        }), e;\n      }function r(e) {\n        clearTimeout(f[0].autoUpdate), u.update.call(null, l[0], e);\n      }var l = e(this),\n          s = l.data(a),\n          c = s.opt,\n          f = e(\"#mCSB_\" + s.idx + \"_container\");return t ? (clearTimeout(f[0].autoUpdate), void $(f[0], \"autoUpdate\")) : void o();\n    },\n        V = function V(e, t, o) {\n      return Math.round(e / t) * t - o;\n    },\n        Q = function Q(t) {\n      var o = t.data(a),\n          n = e(\"#mCSB_\" + o.idx + \"_container,#mCSB_\" + o.idx + \"_container_wrapper,#mCSB_\" + o.idx + \"_dragger_vertical,#mCSB_\" + o.idx + \"_dragger_horizontal\");n.each(function () {\n        Z.call(this);\n      });\n    },\n        G = function G(t, o, n) {\n      function i(e) {\n        return s && c.callbacks[e] && \"function\" == typeof c.callbacks[e];\n      }function r() {\n        return [c.callbacks.alwaysTriggerOffsets || w >= S[0] + y, c.callbacks.alwaysTriggerOffsets || -B >= w];\n      }function l() {\n        var e = [h[0].offsetTop, h[0].offsetLeft],\n            o = [x[0].offsetTop, x[0].offsetLeft],\n            a = [h.outerHeight(!1), h.outerWidth(!1)],\n            i = [f.height(), f.width()];t[0].mcs = { content: h, top: e[0], left: e[1], draggerTop: o[0], draggerLeft: o[1], topPct: Math.round(100 * Math.abs(e[0]) / (Math.abs(a[0]) - i[0])), leftPct: Math.round(100 * Math.abs(e[1]) / (Math.abs(a[1]) - i[1])), direction: n.dir };\n      }var s = t.data(a),\n          c = s.opt,\n          d = { trigger: \"internal\", dir: \"y\", scrollEasing: \"mcsEaseOut\", drag: !1, dur: c.scrollInertia, overwrite: \"all\", callbacks: !0, onStart: !0, onUpdate: !0, onComplete: !0 },\n          n = e.extend(d, n),\n          u = [n.dur, n.drag ? 0 : n.dur],\n          f = e(\"#mCSB_\" + s.idx),\n          h = e(\"#mCSB_\" + s.idx + \"_container\"),\n          m = h.parent(),\n          p = c.callbacks.onTotalScrollOffset ? Y.call(t, c.callbacks.onTotalScrollOffset) : [0, 0],\n          g = c.callbacks.onTotalScrollBackOffset ? Y.call(t, c.callbacks.onTotalScrollBackOffset) : [0, 0];if (s.trigger = n.trigger, 0 === m.scrollTop() && 0 === m.scrollLeft() || (e(\".mCSB_\" + s.idx + \"_scrollbar\").css(\"visibility\", \"visible\"), m.scrollTop(0).scrollLeft(0)), \"_resetY\" !== o || s.contentReset.y || (i(\"onOverflowYNone\") && c.callbacks.onOverflowYNone.call(t[0]), s.contentReset.y = 1), \"_resetX\" !== o || s.contentReset.x || (i(\"onOverflowXNone\") && c.callbacks.onOverflowXNone.call(t[0]), s.contentReset.x = 1), \"_resetY\" !== o && \"_resetX\" !== o) {\n        if (!s.contentReset.y && t[0].mcs || !s.overflowed[0] || (i(\"onOverflowY\") && c.callbacks.onOverflowY.call(t[0]), s.contentReset.x = null), !s.contentReset.x && t[0].mcs || !s.overflowed[1] || (i(\"onOverflowX\") && c.callbacks.onOverflowX.call(t[0]), s.contentReset.x = null), c.snapAmount) {\n          var v = c.snapAmount instanceof Array ? \"x\" === n.dir ? c.snapAmount[1] : c.snapAmount[0] : c.snapAmount;o = V(o, v, c.snapOffset);\n        }switch (n.dir) {case \"x\":\n            var x = e(\"#mCSB_\" + s.idx + \"_dragger_horizontal\"),\n                _ = \"left\",\n                w = h[0].offsetLeft,\n                S = [f.width() - h.outerWidth(!1), x.parent().width() - x.width()],\n                b = [o, 0 === o ? 0 : o / s.scrollRatio.x],\n                y = p[1],\n                B = g[1],\n                T = y > 0 ? y / s.scrollRatio.x : 0,\n                k = B > 0 ? B / s.scrollRatio.x : 0;break;case \"y\":\n            var x = e(\"#mCSB_\" + s.idx + \"_dragger_vertical\"),\n                _ = \"top\",\n                w = h[0].offsetTop,\n                S = [f.height() - h.outerHeight(!1), x.parent().height() - x.height()],\n                b = [o, 0 === o ? 0 : o / s.scrollRatio.y],\n                y = p[0],\n                B = g[0],\n                T = y > 0 ? y / s.scrollRatio.y : 0,\n                k = B > 0 ? B / s.scrollRatio.y : 0;}b[1] < 0 || 0 === b[0] && 0 === b[1] ? b = [0, 0] : b[1] >= S[1] ? b = [S[0], S[1]] : b[0] = -b[0], t[0].mcs || (l(), i(\"onInit\") && c.callbacks.onInit.call(t[0])), clearTimeout(h[0].onCompleteTimeout), J(x[0], _, Math.round(b[1]), u[1], n.scrollEasing), !s.tweenRunning && (0 === w && b[0] >= 0 || w === S[0] && b[0] <= S[0]) || J(h[0], _, Math.round(b[0]), u[0], n.scrollEasing, n.overwrite, { onStart: function onStart() {\n            n.callbacks && n.onStart && !s.tweenRunning && (i(\"onScrollStart\") && (l(), c.callbacks.onScrollStart.call(t[0])), s.tweenRunning = !0, C(x), s.cbOffsets = r());\n          }, onUpdate: function onUpdate() {\n            n.callbacks && n.onUpdate && i(\"whileScrolling\") && (l(), c.callbacks.whileScrolling.call(t[0]));\n          }, onComplete: function onComplete() {\n            if (n.callbacks && n.onComplete) {\n              \"yx\" === c.axis && clearTimeout(h[0].onCompleteTimeout);var e = h[0].idleTimer || 0;h[0].onCompleteTimeout = setTimeout(function () {\n                i(\"onScroll\") && (l(), c.callbacks.onScroll.call(t[0])), i(\"onTotalScroll\") && b[1] >= S[1] - T && s.cbOffsets[0] && (l(), c.callbacks.onTotalScroll.call(t[0])), i(\"onTotalScrollBack\") && b[1] <= k && s.cbOffsets[1] && (l(), c.callbacks.onTotalScrollBack.call(t[0])), s.tweenRunning = !1, h[0].idleTimer = 0, C(x, \"hide\");\n              }, e);\n            }\n          } });\n      }\n    },\n        J = function J(e, t, o, a, n, i, r) {\n      function l() {\n        S.stop || (x || m.call(), x = K() - v, s(), x >= S.time && (S.time = x > S.time ? x + f - (x - S.time) : x + f - 1, S.time < x + 1 && (S.time = x + 1)), S.time < a ? S.id = h(l) : g.call());\n      }function s() {\n        a > 0 ? (S.currVal = u(S.time, _, b, a, n), w[t] = Math.round(S.currVal) + \"px\") : w[t] = o + \"px\", p.call();\n      }function c() {\n        f = 1e3 / 60, S.time = x + f, h = window.requestAnimationFrame ? window.requestAnimationFrame : function (e) {\n          return s(), setTimeout(e, .01);\n        }, S.id = h(l);\n      }function d() {\n        null != S.id && (window.requestAnimationFrame ? window.cancelAnimationFrame(S.id) : clearTimeout(S.id), S.id = null);\n      }function u(e, t, o, a, n) {\n        switch (n) {case \"linear\":case \"mcsLinear\":\n            return o * e / a + t;case \"mcsLinearOut\":\n            return e /= a, e--, o * Math.sqrt(1 - e * e) + t;case \"easeInOutSmooth\":\n            return e /= a / 2, 1 > e ? o / 2 * e * e + t : (e--, -o / 2 * (e * (e - 2) - 1) + t);case \"easeInOutStrong\":\n            return e /= a / 2, 1 > e ? o / 2 * Math.pow(2, 10 * (e - 1)) + t : (e--, o / 2 * (-Math.pow(2, -10 * e) + 2) + t);case \"easeInOut\":case \"mcsEaseInOut\":\n            return e /= a / 2, 1 > e ? o / 2 * e * e * e + t : (e -= 2, o / 2 * (e * e * e + 2) + t);case \"easeOutSmooth\":\n            return e /= a, e--, -o * (e * e * e * e - 1) + t;case \"easeOutStrong\":\n            return o * (-Math.pow(2, -10 * e / a) + 1) + t;case \"easeOut\":case \"mcsEaseOut\":default:\n            var i = (e /= a) * e,\n                r = i * e;return t + o * (.499999999999997 * r * i + -2.5 * i * i + 5.5 * r + -6.5 * i + 4 * e);}\n      }e._mTween || (e._mTween = { top: {}, left: {} });var f,\n          h,\n          r = r || {},\n          m = r.onStart || function () {},\n          p = r.onUpdate || function () {},\n          g = r.onComplete || function () {},\n          v = K(),\n          x = 0,\n          _ = e.offsetTop,\n          w = e.style,\n          S = e._mTween[t];\"left\" === t && (_ = e.offsetLeft);var b = o - _;S.stop = 0, \"none\" !== i && d(), c();\n    },\n        K = function K() {\n      return window.performance && window.performance.now ? window.performance.now() : window.performance && window.performance.webkitNow ? window.performance.webkitNow() : Date.now ? Date.now() : new Date().getTime();\n    },\n        Z = function Z() {\n      var e = this;e._mTween || (e._mTween = { top: {}, left: {} });for (var t = [\"top\", \"left\"], o = 0; o < t.length; o++) {\n        var a = t[o];e._mTween[a].id && (window.requestAnimationFrame ? window.cancelAnimationFrame(e._mTween[a].id) : clearTimeout(e._mTween[a].id), e._mTween[a].id = null, e._mTween[a].stop = 1);\n      }\n    },\n        $ = function $(e, t) {\n      try {\n        delete e[t];\n      } catch (o) {\n        e[t] = null;\n      }\n    },\n        ee = function ee(e) {\n      return !(e.which && 1 !== e.which);\n    },\n        te = function te(e) {\n      var t = e.originalEvent.pointerType;return !(t && \"touch\" !== t && 2 !== t);\n    },\n        oe = function oe(e) {\n      return !isNaN(parseFloat(e)) && isFinite(e);\n    },\n        ae = function ae(e) {\n      var t = e.parents(\".mCSB_container\");return [e.offset().top - t.offset().top, e.offset().left - t.offset().left];\n    },\n        ne = function ne() {\n      function e() {\n        var e = [\"webkit\", \"moz\", \"ms\", \"o\"];if (\"hidden\" in document) return \"hidden\";for (var t = 0; t < e.length; t++) {\n          if (e[t] + \"Hidden\" in document) return e[t] + \"Hidden\";\n        }return null;\n      }var t = e();return t ? document[t] : !1;\n    };e.fn[o] = function (t) {\n      return u[t] ? u[t].apply(this, Array.prototype.slice.call(arguments, 1)) : \"object\" != (typeof t === \"undefined\" ? \"undefined\" : _typeof(t)) && t ? void e.error(\"Method \" + t + \" does not exist\") : u.init.apply(this, arguments);\n    }, e[o] = function (t) {\n      return u[t] ? u[t].apply(this, Array.prototype.slice.call(arguments, 1)) : \"object\" != (typeof t === \"undefined\" ? \"undefined\" : _typeof(t)) && t ? void e.error(\"Method \" + t + \" does not exist\") : u.init.apply(this, arguments);\n    }, e[o].defaults = i, window[o] = !0, e(window).bind(\"load\", function () {\n      e(n)[o](), e.extend(e.expr[\":\"], { mcsInView: e.expr[\":\"].mcsInView || function (t) {\n          var o,\n              a,\n              n = e(t),\n              i = n.parents(\".mCSB_container\");if (i.length) return o = i.parent(), a = [i[0].offsetTop, i[0].offsetLeft], a[0] + ae(n)[0] >= 0 && a[0] + ae(n)[0] < o.height() - n.outerHeight(!1) && a[1] + ae(n)[1] >= 0 && a[1] + ae(n)[1] < o.width() - n.outerWidth(!1);\n        }, mcsInSight: e.expr[\":\"].mcsInSight || function (t, o, a) {\n          var n,\n              i,\n              r,\n              l,\n              s = e(t),\n              c = s.parents(\".mCSB_container\"),\n              d = \"exact\" === a[3] ? [[1, 0], [1, 0]] : [[.9, .1], [.6, .4]];if (c.length) return n = [s.outerHeight(!1), s.outerWidth(!1)], r = [c[0].offsetTop + ae(s)[0], c[0].offsetLeft + ae(s)[1]], i = [c.parent()[0].offsetHeight, c.parent()[0].offsetWidth], l = [n[0] < i[0] ? d[0] : d[1], n[1] < i[1] ? d[0] : d[1]], r[0] - i[0] * l[0][0] < 0 && r[0] + n[0] - i[0] * l[0][1] >= 0 && r[1] - i[1] * l[1][0] < 0 && r[1] + n[1] - i[1] * l[1][1] >= 0;\n        }, mcsOverflow: e.expr[\":\"].mcsOverflow || function (t) {\n          var o = e(t).data(a);if (o) return o.overflowed[0] || o.overflowed[1];\n        } });\n    });\n  });\n});"

/***/ }),
/* 1624 */
/***/ (function(module, exports) {

	module.exports = "!function(e){if(!e.hasInitialised){var t={escapeRegExp:function(e){return e.replace(/[\\-\\[\\]\\/\\{\\}\\(\\)\\*\\+\\?\\.\\\\\\^\\$\\|]/g,\"\\\\$&\")},hasClass:function(e,t){var i=\" \";return 1===e.nodeType&&(i+e.className+i).replace(/[\\n\\t]/g,i).indexOf(i+t+i)>=0},addClass:function(e,t){e.className+=\" \"+t},removeClass:function(e,t){var i=new RegExp(\"\\\\b\"+this.escapeRegExp(t)+\"\\\\b\");e.className=e.className.replace(i,\"\")},interpolateString:function(e,t){var i=/{{([a-z][a-z0-9\\-_]*)}}/gi;return e.replace(i,function(e){return t(arguments[1])||\"\"})},getCookie:function(e){var t=\"; \"+document.cookie,i=t.split(\"; \"+e+\"=\");return 2!=i.length?void 0:i.pop().split(\";\").shift()},setCookie:function(e,t,i,n,o){var s=new Date;s.setDate(s.getDate()+(i||365));var r=[e+\"=\"+t,\"expires=\"+s.toUTCString(),\"path=\"+(o||\"/\")];n&&r.push(\"domain=\"+n),document.cookie=r.join(\";\")},deepExtend:function(e,t){for(var i in t)t.hasOwnProperty(i)&&(i in e&&this.isPlainObject(e[i])&&this.isPlainObject(t[i])?this.deepExtend(e[i],t[i]):e[i]=t[i]);return e},throttle:function(e,t){var i=!1;return function(){i||(e.apply(this,arguments),i=!0,setTimeout(function(){i=!1},t))}},hash:function(e){var t,i,n,o=0;if(0===e.length)return o;for(t=0,n=e.length;t<n;++t)i=e.charCodeAt(t),o=(o<<5)-o+i,o|=0;return o},normaliseHex:function(e){return\"#\"==e[0]&&(e=e.substr(1)),3==e.length&&(e=e[0]+e[0]+e[1]+e[1]+e[2]+e[2]),e},getContrast:function(e){e=this.normaliseHex(e);var t=parseInt(e.substr(0,2),16),i=parseInt(e.substr(2,2),16),n=parseInt(e.substr(4,2),16),o=(299*t+587*i+114*n)/1e3;return o>=128?\"#000\":\"#fff\"},getLuminance:function(e){var t=parseInt(this.normaliseHex(e),16),i=38,n=(t>>16)+i,o=(t>>8&255)+i,s=(255&t)+i,r=(16777216+65536*(n<255?n<1?0:n:255)+256*(o<255?o<1?0:o:255)+(s<255?s<1?0:s:255)).toString(16).slice(1);return\"#\"+r},isMobile:function(){return/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)},isPlainObject:function(e){return\"object\"==typeof e&&null!==e&&e.constructor==Object}};e.status={deny:\"deny\",allow:\"allow\",dismiss:\"dismiss\"},e.transitionEnd=function(){var e=document.createElement(\"div\"),t={t:\"transitionend\",OT:\"oTransitionEnd\",msT:\"MSTransitionEnd\",MozT:\"transitionend\",WebkitT:\"webkitTransitionEnd\"};for(var i in t)if(t.hasOwnProperty(i)&&\"undefined\"!=typeof e.style[i+\"ransition\"])return t[i];return\"\"}(),e.hasTransition=!!e.transitionEnd;var i=Object.keys(e.status).map(t.escapeRegExp);e.customStyles={},e.Popup=function(){function n(){this.initialise.apply(this,arguments)}function o(e){this.openingTimeout=null,t.removeClass(e,\"cc-invisible\")}function s(t){t.style.display=\"none\",t.removeEventListener(e.transitionEnd,this.afterTransition),this.afterTransition=null}function r(){var t=this.options.onInitialise.bind(this);if(!window.navigator.cookieEnabled)return t(e.status.deny),!0;if(window.CookiesOK||window.navigator.CookiesOK)return t(e.status.allow),!0;var i=Object.keys(e.status),n=this.getStatus(),o=i.indexOf(n)>=0;return o&&t(n),o}function a(){var e=this.options.position.split(\"-\"),t=[];return e.forEach(function(e){t.push(\"cc-\"+e)}),t}function c(){var e=this.options,i=\"top\"==e.position||\"bottom\"==e.position?\"banner\":\"floating\";t.isMobile()&&(i=\"floating\");var n=[\"cc-\"+i,\"cc-type-\"+e.type,\"cc-theme-\"+e.theme];e[\"static\"]&&n.push(\"cc-static\"),n.push.apply(n,a.call(this));p.call(this,this.options.palette);return this.customStyleSelector&&n.push(this.customStyleSelector),n}function l(){var e={},i=this.options;i.showLink||(i.elements.link=\"\",i.elements.messagelink=i.elements.message),Object.keys(i.elements).forEach(function(n){e[n]=t.interpolateString(i.elements[n],function(e){var t=i.content[e];return e&&\"string\"==typeof t&&t.length?t:\"\"})});var n=i.compliance[i.type];n||(n=i.compliance.info),e.compliance=t.interpolateString(n,function(t){return e[t]});var o=i.layouts[i.layout];return o||(o=i.layouts.basic),t.interpolateString(o,function(t){return e[t]})}function u(i){var n=this.options,o=document.createElement(\"div\"),s=n.container&&1===n.container.nodeType?n.container:document.body;o.innerHTML=i;var r=o.children[0];return r.style.display=\"none\",t.hasClass(r,\"cc-window\")&&e.hasTransition&&t.addClass(r,\"cc-invisible\"),this.onButtonClick=h.bind(this),r.addEventListener(\"click\",this.onButtonClick),n.autoAttach&&(s.firstChild?s.insertBefore(r,s.firstChild):s.appendChild(r)),r}function h(n){var o=n.target;if(t.hasClass(o,\"cc-btn\")){var s=o.className.match(new RegExp(\"\\\\bcc-(\"+i.join(\"|\")+\")\\\\b\")),r=s&&s[1]||!1;r&&(this.setStatus(r),this.close(!0))}t.hasClass(o,\"cc-close\")&&(this.setStatus(e.status.dismiss),this.close(!0)),t.hasClass(o,\"cc-revoke\")&&this.revokeChoice()}function p(e){var i=t.hash(JSON.stringify(e)),n=\"cc-color-override-\"+i,o=t.isPlainObject(e);return this.customStyleSelector=o?n:null,o&&d(i,e,\".\"+n),o}function d(i,n,o){if(e.customStyles[i])return void++e.customStyles[i].references;var s={},r=n.popup,a=n.button,c=n.highlight;r&&(r.text=r.text?r.text:t.getContrast(r.background),r.link=r.link?r.link:r.text,s[o+\".cc-window\"]=[\"color: \"+r.text,\"background-color: \"+r.background],s[o+\".cc-revoke\"]=[\"color: \"+r.text,\"background-color: \"+r.background],s[o+\" .cc-link,\"+o+\" .cc-link:active,\"+o+\" .cc-link:visited\"]=[\"color: \"+r.link],a&&(a.text=a.text?a.text:t.getContrast(a.background),a.border=a.border?a.border:\"transparent\",s[o+\" .cc-btn\"]=[\"color: \"+a.text,\"border-color: \"+a.border,\"background-color: \"+a.background],\"transparent\"!=a.background&&(s[o+\" .cc-btn:hover, \"+o+\" .cc-btn:focus\"]=[\"background-color: \"+v(a.background)]),c?(c.text=c.text?c.text:t.getContrast(c.background),c.border=c.border?c.border:\"transparent\",s[o+\" .cc-highlight .cc-btn:first-child\"]=[\"color: \"+c.text,\"border-color: \"+c.border,\"background-color: \"+c.background]):s[o+\" .cc-highlight .cc-btn:first-child\"]=[\"color: \"+r.text]));var l=document.createElement(\"style\");document.head.appendChild(l),e.customStyles[i]={references:1,element:l.sheet};var u=-1;for(var h in s)s.hasOwnProperty(h)&&l.sheet.insertRule(h+\"{\"+s[h].join(\";\")+\"}\",++u)}function v(e){return e=t.normaliseHex(e),\"000000\"==e?\"#222\":t.getLuminance(e)}function f(i){if(t.isPlainObject(i)){var n=t.hash(JSON.stringify(i)),o=e.customStyles[n];if(o&&!--o.references){var s=o.element.ownerNode;s&&s.parentNode&&s.parentNode.removeChild(s),e.customStyles[n]=null}}}function m(e,t){for(var i=0,n=e.length;i<n;++i){var o=e[i];if(o instanceof RegExp&&o.test(t)||\"string\"==typeof o&&o.length&&o===t)return!0}return!1}function b(){var t=this.setStatus.bind(this),i=this.options.dismissOnTimeout;\"number\"==typeof i&&i>=0&&(this.dismissTimeout=window.setTimeout(function(){t(e.status.dismiss)},Math.floor(i)));var n=this.options.dismissOnScroll;if(\"number\"==typeof n&&n>=0){var o=function(i){window.pageYOffset>Math.floor(n)&&(t(e.status.dismiss),window.removeEventListener(\"scroll\",o),this.onWindowScroll=null)};this.onWindowScroll=o,window.addEventListener(\"scroll\",o)}}function y(){if(\"info\"!=this.options.type&&(this.options.revokable=!0),t.isMobile()&&(this.options.animateRevokable=!1),this.options.revokable){var e=a.call(this);this.options.animateRevokable&&e.push(\"cc-animate\"),this.customStyleSelector&&e.push(this.customStyleSelector);var i=this.options.revokeBtn.replace(\"{{classes}}\",e.join(\" \"));this.revokeBtn=u.call(this,i);var n=this.revokeBtn;if(this.options.animateRevokable){var o=t.throttle(function(e){var i=!1,o=20,s=window.innerHeight-20;t.hasClass(n,\"cc-top\")&&e.clientY<o&&(i=!0),t.hasClass(n,\"cc-bottom\")&&e.clientY>s&&(i=!0),i?t.hasClass(n,\"cc-active\")||t.addClass(n,\"cc-active\"):t.hasClass(n,\"cc-active\")&&t.removeClass(n,\"cc-active\")},200);this.onMouseMove=o,window.addEventListener(\"mousemove\",o)}}}var g={enabled:!0,container:null,cookie:{name:\"cookieconsent_status\",path:\"/\",domain:\"\",expiryDays:365},onPopupOpen:function(){},onPopupClose:function(){},onInitialise:function(e){},onStatusChange:function(e,t){},onRevokeChoice:function(){},content:{header:\"Cookies used on the website!\",message:\"This website uses cookies to ensure you get the best experience on our website.\",dismiss:\"Got it!\",allow:\"Allow cookies\",deny:\"Decline\",link:\"Learn more\",href:\"http://cookiesandyou.com\",close:\"&#x274c;\"},elements:{header:'<span class=\"cc-header\">{{header}}</span>&nbsp;',message:'<span id=\"cookieconsent:desc\" class=\"cc-message\">{{message}}</span>',messagelink:'<span id=\"cookieconsent:desc\" class=\"cc-message\">{{message}} <a aria-label=\"learn more about cookies\" role=button tabindex=\"0\" class=\"cc-link\" href=\"{{href}}\" rel=\"noopener noreferrer nofollow\" target=\"_blank\">{{link}}</a></span>',dismiss:'<a aria-label=\"dismiss cookie message\" role=button tabindex=\"0\" class=\"cc-btn cc-dismiss\">{{dismiss}}</a>',allow:'<a aria-label=\"allow cookies\" role=button tabindex=\"0\"  class=\"cc-btn cc-allow\">{{allow}}</a>',deny:'<a aria-label=\"deny cookies\" role=button tabindex=\"0\" class=\"cc-btn cc-deny\">{{deny}}</a>',link:'<a aria-label=\"learn more about cookies\" role=button tabindex=\"0\" class=\"cc-link\" href=\"{{href}}\" target=\"_blank\">{{link}}</a>',close:'<span aria-label=\"dismiss cookie message\" role=button tabindex=\"0\" class=\"cc-close\">{{close}}</span>'},window:'<div role=\"dialog\" aria-live=\"polite\" aria-label=\"cookieconsent\" aria-describedby=\"cookieconsent:desc\" class=\"cc-window {{classes}}\"><!--googleoff: all-->{{children}}<!--googleon: all--></div>',revokeBtn:'<div class=\"cc-revoke {{classes}}\">Cookie Policy</div>',compliance:{info:'<div class=\"cc-compliance\">{{dismiss}}</div>',\"opt-in\":'<div class=\"cc-compliance cc-highlight\">{{dismiss}}{{allow}}</div>',\"opt-out\":'<div class=\"cc-compliance cc-highlight\">{{deny}}{{dismiss}}</div>'},type:\"info\",layouts:{basic:\"{{messagelink}}{{compliance}}\",\"basic-close\":\"{{messagelink}}{{compliance}}{{close}}\",\"basic-header\":\"{{header}}{{message}}{{link}}{{compliance}}\"},layout:\"basic\",position:\"bottom\",theme:\"block\",\"static\":!1,palette:null,revokable:!1,animateRevokable:!0,showLink:!0,dismissOnScroll:!1,dismissOnTimeout:!1,autoOpen:!0,autoAttach:!0,whitelistPage:[],blacklistPage:[],overrideHTML:null};return n.prototype.initialise=function(e){this.options&&this.destroy(),t.deepExtend(this.options={},g),t.isPlainObject(e)&&t.deepExtend(this.options,e),r.call(this)&&(this.options.enabled=!1),m(this.options.blacklistPage,location.pathname)&&(this.options.enabled=!1),m(this.options.whitelistPage,location.pathname)&&(this.options.enabled=!0);var i=this.options.window.replace(\"{{classes}}\",c.call(this).join(\" \")).replace(\"{{children}}\",l.call(this)),n=this.options.overrideHTML;if(\"string\"==typeof n&&n.length&&(i=n),this.options[\"static\"]){var o=u.call(this,'<div class=\"cc-grower\">'+i+\"</div>\");o.style.display=\"\",this.element=o.firstChild,this.element.style.display=\"none\",t.addClass(this.element,\"cc-invisible\")}else this.element=u.call(this,i);b.call(this),y.call(this),this.options.autoOpen&&this.autoOpen()},n.prototype.destroy=function(){this.onButtonClick&&this.element&&(this.element.removeEventListener(\"click\",this.onButtonClick),this.onButtonClick=null),this.dismissTimeout&&(clearTimeout(this.dismissTimeout),this.dismissTimeout=null),this.onWindowScroll&&(window.removeEventListener(\"scroll\",this.onWindowScroll),this.onWindowScroll=null),this.onMouseMove&&(window.removeEventListener(\"mousemove\",this.onMouseMove),this.onMouseMove=null),this.element&&this.element.parentNode&&this.element.parentNode.removeChild(this.element),this.element=null,this.revokeBtn&&this.revokeBtn.parentNode&&this.revokeBtn.parentNode.removeChild(this.revokeBtn),this.revokeBtn=null,f(this.options.palette),this.options=null},n.prototype.open=function(t){if(this.element)return this.isOpen()||(e.hasTransition?this.fadeIn():this.element.style.display=\"\",this.options.revokable&&this.toggleRevokeButton(),this.options.onPopupOpen.call(this)),this},n.prototype.close=function(t){if(this.element)return this.isOpen()&&(e.hasTransition?this.fadeOut():this.element.style.display=\"none\",t&&this.options.revokable&&this.toggleRevokeButton(!0),this.options.onPopupClose.call(this)),this},n.prototype.fadeIn=function(){var i=this.element;if(e.hasTransition&&i&&(this.afterTransition&&s.call(this,i),t.hasClass(i,\"cc-invisible\"))){if(i.style.display=\"\",this.options[\"static\"]){var n=this.element.clientHeight;this.element.parentNode.style.maxHeight=n+\"px\"}var r=20;this.openingTimeout=setTimeout(o.bind(this,i),r)}},n.prototype.fadeOut=function(){var i=this.element;e.hasTransition&&i&&(this.openingTimeout&&(clearTimeout(this.openingTimeout),o.bind(this,i)),t.hasClass(i,\"cc-invisible\")||(this.options[\"static\"]&&(this.element.parentNode.style.maxHeight=\"\"),this.afterTransition=s.bind(this,i),i.addEventListener(e.transitionEnd,this.afterTransition),t.addClass(i,\"cc-invisible\")))},n.prototype.isOpen=function(){return this.element&&\"\"==this.element.style.display&&(!e.hasTransition||!t.hasClass(this.element,\"cc-invisible\"))},n.prototype.toggleRevokeButton=function(e){this.revokeBtn&&(this.revokeBtn.style.display=e?\"\":\"none\")},n.prototype.revokeChoice=function(e){this.options.enabled=!0,this.clearStatus(),this.options.onRevokeChoice.call(this),e||this.autoOpen()},n.prototype.hasAnswered=function(t){return Object.keys(e.status).indexOf(this.getStatus())>=0},n.prototype.hasConsented=function(t){var i=this.getStatus();return i==e.status.allow||i==e.status.dismiss},n.prototype.autoOpen=function(e){!this.hasAnswered()&&this.options.enabled&&this.open()},n.prototype.setStatus=function(i){var n=this.options.cookie,o=t.getCookie(n.name),s=Object.keys(e.status).indexOf(o)>=0;Object.keys(e.status).indexOf(i)>=0?(t.setCookie(n.name,i,n.expiryDays,n.domain,n.path),this.options.onStatusChange.call(this,i,s)):this.clearStatus()},n.prototype.getStatus=function(){return t.getCookie(this.options.cookie.name)},n.prototype.clearStatus=function(){var e=this.options.cookie;t.setCookie(e.name,\"\",-1,e.domain,e.path)},n}(),e.Location=function(){function e(e){t.deepExtend(this.options={},s),t.isPlainObject(e)&&t.deepExtend(this.options,e),this.currentServiceIndex=-1}function i(e,t,i){var n,o=document.createElement(\"script\");o.type=\"text/\"+(e.type||\"javascript\"),o.src=e.src||e,o.async=!1,o.onreadystatechange=o.onload=function(){var e=o.readyState;clearTimeout(n),t.done||e&&!/loaded|complete/.test(e)||(t.done=!0,t(),o.onreadystatechange=o.onload=null)},document.body.appendChild(o),n=setTimeout(function(){t.done=!0,t(),o.onreadystatechange=o.onload=null},i)}function n(e,t,i,n,o){var s=new(window.XMLHttpRequest||window.ActiveXObject)(\"MSXML2.XMLHTTP.3.0\");if(s.open(n?\"POST\":\"GET\",e,1),s.setRequestHeader(\"X-Requested-With\",\"XMLHttpRequest\"),s.setRequestHeader(\"Content-type\",\"application/x-www-form-urlencoded\"),Array.isArray(o))for(var r=0,a=o.length;r<a;++r){var c=o[r].split(\":\",2);s.setRequestHeader(c[0].replace(/^\\s+|\\s+$/g,\"\"),c[1].replace(/^\\s+|\\s+$/g,\"\"))}\"function\"==typeof t&&(s.onreadystatechange=function(){s.readyState>3&&t(s)}),s.send(n)}function o(e){return new Error(\"Error [\"+(e.code||\"UNKNOWN\")+\"]: \"+e.error)}var s={timeout:5e3,services:[\"freegeoip\",\"ipinfo\",\"maxmind\"],serviceDefinitions:{freegeoip:function(){return{url:\"//freegeoip.net/json/?callback={callback}\",isScript:!0,callback:function(e,t){try{var i=JSON.parse(t);return i.error?o(i):{code:i.country_code}}catch(n){return o({error:\"Invalid response (\"+n+\")\"})}}}},ipinfo:function(){return{url:\"//ipinfo.io\",headers:[\"Accept: application/json\"],callback:function(e,t){try{var i=JSON.parse(t);return i.error?o(i):{code:i.country}}catch(n){return o({error:\"Invalid response (\"+n+\")\"})}}}},ipinfodb:function(e){return{url:\"//api.ipinfodb.com/v3/ip-country/?key={api_key}&format=json&callback={callback}\",isScript:!0,callback:function(e,t){try{var i=JSON.parse(t);return\"ERROR\"==i.statusCode?o({error:i.statusMessage}):{code:i.countryCode}}catch(n){return o({error:\"Invalid response (\"+n+\")\"})}}}},maxmind:function(){return{url:\"//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js\",isScript:!0,callback:function(e){return window.geoip2?void geoip2.country(function(t){try{e({code:t.country.iso_code})}catch(i){e(o(i))}},function(t){e(o(t))}):void e(new Error(\"Unexpected response format. The downloaded script should have exported `geoip2` to the global scope\"))}}}}};return e.prototype.getNextService=function(){var e;do e=this.getServiceByIdx(++this.currentServiceIndex);while(this.currentServiceIndex<this.options.services.length&&!e);return e},e.prototype.getServiceByIdx=function(e){var i=this.options.services[e];if(\"function\"==typeof i){var n=i();return n.name&&t.deepExtend(n,this.options.serviceDefinitions[n.name](n)),n}return\"string\"==typeof i?this.options.serviceDefinitions[i]():t.isPlainObject(i)?this.options.serviceDefinitions[i.name](i):null},e.prototype.locate=function(e,t){var i=this.getNextService();return i?(this.callbackComplete=e,this.callbackError=t,void this.runService(i,this.runNextServiceOnError.bind(this))):void t(new Error(\"No services to run\"))},e.prototype.setupUrl=function(e){var t=this.getCurrentServiceOpts();return e.url.replace(/\\{(.*?)\\}/g,function(i,n){if(\"callback\"===n){var o=\"callback\"+Date.now();return window[o]=function(t){e.__JSONP_DATA=JSON.stringify(t)},o}if(n in t.interpolateUrl)return t.interpolateUrl[n]})},e.prototype.runService=function(e,t){var o=this;if(e&&e.url&&e.callback){var s=e.isScript?i:n,r=this.setupUrl(e);s(r,function(i){var n=i?i.responseText:\"\";e.__JSONP_DATA&&(n=e.__JSONP_DATA,delete e.__JSONP_DATA),o.runServiceCallback.call(o,t,e,n)},this.options.timeout,e.data,e.headers)}},e.prototype.runServiceCallback=function(e,t,i){var n=this,o=function(t){s||n.onServiceResult.call(n,e,t)},s=t.callback(o,i);s&&this.onServiceResult.call(this,e,s)},e.prototype.onServiceResult=function(e,t){t instanceof Error||t&&t.error?e.call(this,t,null):e.call(this,null,t)},e.prototype.runNextServiceOnError=function(e,t){if(e){this.logError(e);var i=this.getNextService();i?this.runService(i,this.runNextServiceOnError.bind(this)):this.completeService.call(this,this.callbackError,new Error(\"All services failed\"))}else this.completeService.call(this,this.callbackComplete,t)},e.prototype.getCurrentServiceOpts=function(){var e=this.options.services[this.currentServiceIndex];return\"string\"==typeof e?{name:e}:\"function\"==typeof e?e():t.isPlainObject(e)?e:{}},e.prototype.completeService=function(e,t){this.currentServiceIndex=-1,e&&e(t)},e.prototype.logError=function(e){var t=this.currentServiceIndex,i=this.getServiceByIdx(t);console.error(\"The service[\"+t+\"] (\"+i.url+\") responded with the following error\",e)},e}(),e.Law=function(){function e(e){this.initialise.apply(this,arguments)}var i={regionalLaw:!0,hasLaw:[\"AT\",\"BE\",\"BG\",\"HR\",\"CZ\",\"CY\",\"DK\",\"EE\",\"FI\",\"FR\",\"DE\",\"EL\",\"HU\",\"IE\",\"IT\",\"LV\",\"LT\",\"LU\",\"MT\",\"NL\",\"PL\",\"PT\",\"SK\",\"SI\",\"ES\",\"SE\",\"GB\",\"UK\"],revokable:[\"HR\",\"CY\",\"DK\",\"EE\",\"FR\",\"DE\",\"LV\",\"LT\",\"NL\",\"PT\",\"ES\"],explicitAction:[\"HR\",\"IT\",\"ES\"]};return e.prototype.initialise=function(e){t.deepExtend(this.options={},i),t.isPlainObject(e)&&t.deepExtend(this.options,e)},e.prototype.get=function(e){var t=this.options;return{hasLaw:t.hasLaw.indexOf(e)>=0,revokable:t.revokable.indexOf(e)>=0,explicitAction:t.explicitAction.indexOf(e)>=0}},e.prototype.applyLaw=function(e,t){var i=this.get(t);return i.hasLaw||(e.enabled=!1),this.options.regionalLaw&&(i.revokable&&(e.revokable=!0),i.explicitAction&&(e.dismissOnScroll=!1,e.dismissOnTimeout=!1)),e},e}(),e.initialise=function(t,i,n){var o=new e.Law(t.law);i||(i=function(){}),n||(n=function(){}),e.getCountryCode(t,function(n){delete t.law,delete t.location,n.code&&(t=o.applyLaw(t,n.code)),i(new e.Popup(t))},function(i){delete t.law,delete t.location,n(i,new e.Popup(t))})},e.getCountryCode=function(t,i,n){if(t.law&&t.law.countryCode)return void i({code:t.law.countryCode});if(t.location){var o=new e.Location(t.location);return void o.locate(function(e){i(e||{})},n)}i({})},e.utils=t,e.hasInitialised=!0,window.cookieconsent=e}}(window.cookieconsent||{});"

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(343)(__webpack_require__(1623))

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(343)(__webpack_require__(1624))

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(343)(__webpack_require__(1622))

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	     _ _      _       _
	 ___| (_) ___| | __  (_)___
	/ __| | |/ __| |/ /  | / __|
	\__ \ | | (__|   < _ | \__ \
	|___/_|_|\___|_|\_(_)/ |___/
	                   |__/
	
	 Version: 1.8.1
	  Author: Ken Wheeler
	 Website: http://kenwheeler.github.io
	    Docs: http://kenwheeler.github.io/slick
	    Repo: http://github.com/kenwheeler/slick
	  Issues: http://github.com/kenwheeler/slick/issues
	
	 */
	/* global window, document, define, jQuery, setInterval, clearInterval */
	;(function(factory) {
	    'use strict';
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== 'undefined') {
	        module.exports = factory(require('jquery'));
	    } else {
	        factory(jQuery);
	    }
	
	}(function($) {
	    'use strict';
	    var Slick = window.Slick || {};
	
	    Slick = (function() {
	
	        var instanceUid = 0;
	
	        function Slick(element, settings) {
	
	            var _ = this, dataSettings;
	
	            _.defaults = {
	                accessibility: true,
	                adaptiveHeight: false,
	                appendArrows: $(element),
	                appendDots: $(element),
	                arrows: true,
	                asNavFor: null,
	                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
	                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
	                autoplay: false,
	                autoplaySpeed: 3000,
	                centerMode: false,
	                centerPadding: '50px',
	                cssEase: 'ease',
	                customPaging: function(slider, i) {
	                    return $('<button type="button" />').text(i + 1);
	                },
	                dots: false,
	                dotsClass: 'slick-dots',
	                draggable: true,
	                easing: 'linear',
	                edgeFriction: 0.35,
	                fade: false,
	                focusOnSelect: false,
	                focusOnChange: false,
	                infinite: true,
	                initialSlide: 0,
	                lazyLoad: 'ondemand',
	                mobileFirst: false,
	                pauseOnHover: true,
	                pauseOnFocus: true,
	                pauseOnDotsHover: false,
	                respondTo: 'window',
	                responsive: null,
	                rows: 1,
	                rtl: false,
	                slide: '',
	                slidesPerRow: 1,
	                slidesToShow: 1,
	                slidesToScroll: 1,
	                speed: 500,
	                swipe: true,
	                swipeToSlide: false,
	                touchMove: true,
	                touchThreshold: 5,
	                useCSS: true,
	                useTransform: true,
	                variableWidth: false,
	                vertical: false,
	                verticalSwiping: false,
	                waitForAnimate: true,
	                zIndex: 1000
	            };
	
	            _.initials = {
	                animating: false,
	                dragging: false,
	                autoPlayTimer: null,
	                currentDirection: 0,
	                currentLeft: null,
	                currentSlide: 0,
	                direction: 1,
	                $dots: null,
	                listWidth: null,
	                listHeight: null,
	                loadIndex: 0,
	                $nextArrow: null,
	                $prevArrow: null,
	                scrolling: false,
	                slideCount: null,
	                slideWidth: null,
	                $slideTrack: null,
	                $slides: null,
	                sliding: false,
	                slideOffset: 0,
	                swipeLeft: null,
	                swiping: false,
	                $list: null,
	                touchObject: {},
	                transformsEnabled: false,
	                unslicked: false
	            };
	
	            $.extend(_, _.initials);
	
	            _.activeBreakpoint = null;
	            _.animType = null;
	            _.animProp = null;
	            _.breakpoints = [];
	            _.breakpointSettings = [];
	            _.cssTransitions = false;
	            _.focussed = false;
	            _.interrupted = false;
	            _.hidden = 'hidden';
	            _.paused = true;
	            _.positionProp = null;
	            _.respondTo = null;
	            _.rowCount = 1;
	            _.shouldClick = true;
	            _.$slider = $(element);
	            _.$slidesCache = null;
	            _.transformType = null;
	            _.transitionType = null;
	            _.visibilityChange = 'visibilitychange';
	            _.windowWidth = 0;
	            _.windowTimer = null;
	
	            dataSettings = $(element).data('slick') || {};
	
	            _.options = $.extend({}, _.defaults, settings, dataSettings);
	
	            _.currentSlide = _.options.initialSlide;
	
	            _.originalSettings = _.options;
	
	            if (typeof document.mozHidden !== 'undefined') {
	                _.hidden = 'mozHidden';
	                _.visibilityChange = 'mozvisibilitychange';
	            } else if (typeof document.webkitHidden !== 'undefined') {
	                _.hidden = 'webkitHidden';
	                _.visibilityChange = 'webkitvisibilitychange';
	            }
	
	            _.autoPlay = $.proxy(_.autoPlay, _);
	            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
	            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
	            _.changeSlide = $.proxy(_.changeSlide, _);
	            _.clickHandler = $.proxy(_.clickHandler, _);
	            _.selectHandler = $.proxy(_.selectHandler, _);
	            _.setPosition = $.proxy(_.setPosition, _);
	            _.swipeHandler = $.proxy(_.swipeHandler, _);
	            _.dragHandler = $.proxy(_.dragHandler, _);
	            _.keyHandler = $.proxy(_.keyHandler, _);
	
	            _.instanceUid = instanceUid++;
	
	            // A simple way to check for HTML strings
	            // Strict HTML recognition (must start with <)
	            // Extracted from jQuery v1.11 source
	            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
	
	
	            _.registerBreakpoints();
	            _.init(true);
	
	        }
	
	        return Slick;
	
	    }());
	
	    Slick.prototype.activateADA = function() {
	        var _ = this;
	
	        _.$slideTrack.find('.slick-active').attr({
	            'aria-hidden': 'false'
	        }).find('a, input, button, select').attr({
	            'tabindex': '0'
	        });
	
	    };
	
	    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {
	
	        var _ = this;
	
	        if (typeof(index) === 'boolean') {
	            addBefore = index;
	            index = null;
	        } else if (index < 0 || (index >= _.slideCount)) {
	            return false;
	        }
	
	        _.unload();
	
	        if (typeof(index) === 'number') {
	            if (index === 0 && _.$slides.length === 0) {
	                $(markup).appendTo(_.$slideTrack);
	            } else if (addBefore) {
	                $(markup).insertBefore(_.$slides.eq(index));
	            } else {
	                $(markup).insertAfter(_.$slides.eq(index));
	            }
	        } else {
	            if (addBefore === true) {
	                $(markup).prependTo(_.$slideTrack);
	            } else {
	                $(markup).appendTo(_.$slideTrack);
	            }
	        }
	
	        _.$slides = _.$slideTrack.children(this.options.slide);
	
	        _.$slideTrack.children(this.options.slide).detach();
	
	        _.$slideTrack.append(_.$slides);
	
	        _.$slides.each(function(index, element) {
	            $(element).attr('data-slick-index', index);
	        });
	
	        _.$slidesCache = _.$slides;
	
	        _.reinit();
	
	    };
	
	    Slick.prototype.animateHeight = function() {
	        var _ = this;
	        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
	            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
	            _.$list.animate({
	                height: targetHeight
	            }, _.options.speed);
	        }
	    };
	
	    Slick.prototype.animateSlide = function(targetLeft, callback) {
	
	        var animProps = {},
	            _ = this;
	
	        _.animateHeight();
	
	        if (_.options.rtl === true && _.options.vertical === false) {
	            targetLeft = -targetLeft;
	        }
	        if (_.transformsEnabled === false) {
	            if (_.options.vertical === false) {
	                _.$slideTrack.animate({
	                    left: targetLeft
	                }, _.options.speed, _.options.easing, callback);
	            } else {
	                _.$slideTrack.animate({
	                    top: targetLeft
	                }, _.options.speed, _.options.easing, callback);
	            }
	
	        } else {
	
	            if (_.cssTransitions === false) {
	                if (_.options.rtl === true) {
	                    _.currentLeft = -(_.currentLeft);
	                }
	                $({
	                    animStart: _.currentLeft
	                }).animate({
	                    animStart: targetLeft
	                }, {
	                    duration: _.options.speed,
	                    easing: _.options.easing,
	                    step: function(now) {
	                        now = Math.ceil(now);
	                        if (_.options.vertical === false) {
	                            animProps[_.animType] = 'translate(' +
	                                now + 'px, 0px)';
	                            _.$slideTrack.css(animProps);
	                        } else {
	                            animProps[_.animType] = 'translate(0px,' +
	                                now + 'px)';
	                            _.$slideTrack.css(animProps);
	                        }
	                    },
	                    complete: function() {
	                        if (callback) {
	                            callback.call();
	                        }
	                    }
	                });
	
	            } else {
	
	                _.applyTransition();
	                targetLeft = Math.ceil(targetLeft);
	
	                if (_.options.vertical === false) {
	                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
	                } else {
	                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
	                }
	                _.$slideTrack.css(animProps);
	
	                if (callback) {
	                    setTimeout(function() {
	
	                        _.disableTransition();
	
	                        callback.call();
	                    }, _.options.speed);
	                }
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.getNavTarget = function() {
	
	        var _ = this,
	            asNavFor = _.options.asNavFor;
	
	        if ( asNavFor && asNavFor !== null ) {
	            asNavFor = $(asNavFor).not(_.$slider);
	        }
	
	        return asNavFor;
	
	    };
	
	    Slick.prototype.asNavFor = function(index) {
	
	        var _ = this,
	            asNavFor = _.getNavTarget();
	
	        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
	            asNavFor.each(function() {
	                var target = $(this).slick('getSlick');
	                if(!target.unslicked) {
	                    target.slideHandler(index, true);
	                }
	            });
	        }
	
	    };
	
	    Slick.prototype.applyTransition = function(slide) {
	
	        var _ = this,
	            transition = {};
	
	        if (_.options.fade === false) {
	            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
	        } else {
	            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
	        }
	
	        if (_.options.fade === false) {
	            _.$slideTrack.css(transition);
	        } else {
	            _.$slides.eq(slide).css(transition);
	        }
	
	    };
	
	    Slick.prototype.autoPlay = function() {
	
	        var _ = this;
	
	        _.autoPlayClear();
	
	        if ( _.slideCount > _.options.slidesToShow ) {
	            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
	        }
	
	    };
	
	    Slick.prototype.autoPlayClear = function() {
	
	        var _ = this;
	
	        if (_.autoPlayTimer) {
	            clearInterval(_.autoPlayTimer);
	        }
	
	    };
	
	    Slick.prototype.autoPlayIterator = function() {
	
	        var _ = this,
	            slideTo = _.currentSlide + _.options.slidesToScroll;
	
	        if ( !_.paused && !_.interrupted && !_.focussed ) {
	
	            if ( _.options.infinite === false ) {
	
	                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
	                    _.direction = 0;
	                }
	
	                else if ( _.direction === 0 ) {
	
	                    slideTo = _.currentSlide - _.options.slidesToScroll;
	
	                    if ( _.currentSlide - 1 === 0 ) {
	                        _.direction = 1;
	                    }
	
	                }
	
	            }
	
	            _.slideHandler( slideTo );
	
	        }
	
	    };
	
	    Slick.prototype.buildArrows = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true ) {
	
	            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
	            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');
	
	            if( _.slideCount > _.options.slidesToShow ) {
	
	                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
	                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
	
	                if (_.htmlExpr.test(_.options.prevArrow)) {
	                    _.$prevArrow.prependTo(_.options.appendArrows);
	                }
	
	                if (_.htmlExpr.test(_.options.nextArrow)) {
	                    _.$nextArrow.appendTo(_.options.appendArrows);
	                }
	
	                if (_.options.infinite !== true) {
	                    _.$prevArrow
	                        .addClass('slick-disabled')
	                        .attr('aria-disabled', 'true');
	                }
	
	            } else {
	
	                _.$prevArrow.add( _.$nextArrow )
	
	                    .addClass('slick-hidden')
	                    .attr({
	                        'aria-disabled': 'true',
	                        'tabindex': '-1'
	                    });
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.buildDots = function() {
	
	        var _ = this,
	            i, dot;
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$slider.addClass('slick-dotted');
	
	            dot = $('<ul />').addClass(_.options.dotsClass);
	
	            for (i = 0; i <= _.getDotCount(); i += 1) {
	                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
	            }
	
	            _.$dots = dot.appendTo(_.options.appendDots);
	
	            _.$dots.find('li').first().addClass('slick-active');
	
	        }
	
	    };
	
	    Slick.prototype.buildOut = function() {
	
	        var _ = this;
	
	        _.$slides =
	            _.$slider
	                .children( _.options.slide + ':not(.slick-cloned)')
	                .addClass('slick-slide');
	
	        _.slideCount = _.$slides.length;
	
	        _.$slides.each(function(index, element) {
	            $(element)
	                .attr('data-slick-index', index)
	                .data('originalStyling', $(element).attr('style') || '');
	        });
	
	        _.$slider.addClass('slick-slider');
	
	        _.$slideTrack = (_.slideCount === 0) ?
	            $('<div class="slick-track"/>').appendTo(_.$slider) :
	            _.$slides.wrapAll('<div class="slick-track"/>').parent();
	
	        _.$list = _.$slideTrack.wrap(
	            '<div class="slick-list"/>').parent();
	        _.$slideTrack.css('opacity', 0);
	
	        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
	            _.options.slidesToScroll = 1;
	        }
	
	        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');
	
	        _.setupInfinite();
	
	        _.buildArrows();
	
	        _.buildDots();
	
	        _.updateDots();
	
	
	        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
	
	        if (_.options.draggable === true) {
	            _.$list.addClass('draggable');
	        }
	
	    };
	
	    Slick.prototype.buildRows = function() {
	
	        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;
	
	        newSlides = document.createDocumentFragment();
	        originalSlides = _.$slider.children();
	
	        if(_.options.rows > 0) {
	
	            slidesPerSection = _.options.slidesPerRow * _.options.rows;
	            numOfSlides = Math.ceil(
	                originalSlides.length / slidesPerSection
	            );
	
	            for(a = 0; a < numOfSlides; a++){
	                var slide = document.createElement('div');
	                for(b = 0; b < _.options.rows; b++) {
	                    var row = document.createElement('div');
	                    for(c = 0; c < _.options.slidesPerRow; c++) {
	                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
	                        if (originalSlides.get(target)) {
	                            row.appendChild(originalSlides.get(target));
	                        }
	                    }
	                    slide.appendChild(row);
	                }
	                newSlides.appendChild(slide);
	            }
	
	            _.$slider.empty().append(newSlides);
	            _.$slider.children().children().children()
	                .css({
	                    'width':(100 / _.options.slidesPerRow) + '%',
	                    'display': 'inline-block'
	                });
	
	        }
	
	    };
	
	    Slick.prototype.checkResponsive = function(initial, forceUpdate) {
	
	        var _ = this,
	            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
	        var sliderWidth = _.$slider.width();
	        var windowWidth = window.innerWidth || $(window).width();
	
	        if (_.respondTo === 'window') {
	            respondToWidth = windowWidth;
	        } else if (_.respondTo === 'slider') {
	            respondToWidth = sliderWidth;
	        } else if (_.respondTo === 'min') {
	            respondToWidth = Math.min(windowWidth, sliderWidth);
	        }
	
	        if ( _.options.responsive &&
	            _.options.responsive.length &&
	            _.options.responsive !== null) {
	
	            targetBreakpoint = null;
	
	            for (breakpoint in _.breakpoints) {
	                if (_.breakpoints.hasOwnProperty(breakpoint)) {
	                    if (_.originalSettings.mobileFirst === false) {
	                        if (respondToWidth < _.breakpoints[breakpoint]) {
	                            targetBreakpoint = _.breakpoints[breakpoint];
	                        }
	                    } else {
	                        if (respondToWidth > _.breakpoints[breakpoint]) {
	                            targetBreakpoint = _.breakpoints[breakpoint];
	                        }
	                    }
	                }
	            }
	
	            if (targetBreakpoint !== null) {
	                if (_.activeBreakpoint !== null) {
	                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
	                        _.activeBreakpoint =
	                            targetBreakpoint;
	                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
	                            _.unslick(targetBreakpoint);
	                        } else {
	                            _.options = $.extend({}, _.originalSettings,
	                                _.breakpointSettings[
	                                    targetBreakpoint]);
	                            if (initial === true) {
	                                _.currentSlide = _.options.initialSlide;
	                            }
	                            _.refresh(initial);
	                        }
	                        triggerBreakpoint = targetBreakpoint;
	                    }
	                } else {
	                    _.activeBreakpoint = targetBreakpoint;
	                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
	                        _.unslick(targetBreakpoint);
	                    } else {
	                        _.options = $.extend({}, _.originalSettings,
	                            _.breakpointSettings[
	                                targetBreakpoint]);
	                        if (initial === true) {
	                            _.currentSlide = _.options.initialSlide;
	                        }
	                        _.refresh(initial);
	                    }
	                    triggerBreakpoint = targetBreakpoint;
	                }
	            } else {
	                if (_.activeBreakpoint !== null) {
	                    _.activeBreakpoint = null;
	                    _.options = _.originalSettings;
	                    if (initial === true) {
	                        _.currentSlide = _.options.initialSlide;
	                    }
	                    _.refresh(initial);
	                    triggerBreakpoint = targetBreakpoint;
	                }
	            }
	
	            // only trigger breakpoints during an actual break. not on initialize.
	            if( !initial && triggerBreakpoint !== false ) {
	                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
	            }
	        }
	
	    };
	
	    Slick.prototype.changeSlide = function(event, dontAnimate) {
	
	        var _ = this,
	            $target = $(event.currentTarget),
	            indexOffset, slideOffset, unevenOffset;
	
	        // If target is a link, prevent default action.
	        if($target.is('a')) {
	            event.preventDefault();
	        }
	
	        // If target is not the <li> element (ie: a child), find the <li>.
	        if(!$target.is('li')) {
	            $target = $target.closest('li');
	        }
	
	        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
	        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
	
	        switch (event.data.message) {
	
	            case 'previous':
	                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
	                if (_.slideCount > _.options.slidesToShow) {
	                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
	                }
	                break;
	
	            case 'next':
	                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
	                if (_.slideCount > _.options.slidesToShow) {
	                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
	                }
	                break;
	
	            case 'index':
	                var index = event.data.index === 0 ? 0 :
	                    event.data.index || $target.index() * _.options.slidesToScroll;
	
	                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
	                $target.children().trigger('focus');
	                break;
	
	            default:
	                return;
	        }
	
	    };
	
	    Slick.prototype.checkNavigable = function(index) {
	
	        var _ = this,
	            navigables, prevNavigable;
	
	        navigables = _.getNavigableIndexes();
	        prevNavigable = 0;
	        if (index > navigables[navigables.length - 1]) {
	            index = navigables[navigables.length - 1];
	        } else {
	            for (var n in navigables) {
	                if (index < navigables[n]) {
	                    index = prevNavigable;
	                    break;
	                }
	                prevNavigable = navigables[n];
	            }
	        }
	
	        return index;
	    };
	
	    Slick.prototype.cleanUpEvents = function() {
	
	        var _ = this;
	
	        if (_.options.dots && _.$dots !== null) {
	
	            $('li', _.$dots)
	                .off('click.slick', _.changeSlide)
	                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
	                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	            if (_.options.accessibility === true) {
	                _.$dots.off('keydown.slick', _.keyHandler);
	            }
	        }
	
	        _.$slider.off('focus.slick blur.slick');
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
	            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
	
	            if (_.options.accessibility === true) {
	                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
	                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
	            }
	        }
	
	        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
	        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
	        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
	        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);
	
	        _.$list.off('click.slick', _.clickHandler);
	
	        $(document).off(_.visibilityChange, _.visibility);
	
	        _.cleanUpSlideEvents();
	
	        if (_.options.accessibility === true) {
	            _.$list.off('keydown.slick', _.keyHandler);
	        }
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
	        }
	
	        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);
	
	        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);
	
	        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);
	
	        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
	
	    };
	
	    Slick.prototype.cleanUpSlideEvents = function() {
	
	        var _ = this;
	
	        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
	        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	    };
	
	    Slick.prototype.cleanUpRows = function() {
	
	        var _ = this, originalSlides;
	
	        if(_.options.rows > 0) {
	            originalSlides = _.$slides.children().children();
	            originalSlides.removeAttr('style');
	            _.$slider.empty().append(originalSlides);
	        }
	
	    };
	
	    Slick.prototype.clickHandler = function(event) {
	
	        var _ = this;
	
	        if (_.shouldClick === false) {
	            event.stopImmediatePropagation();
	            event.stopPropagation();
	            event.preventDefault();
	        }
	
	    };
	
	    Slick.prototype.destroy = function(refresh) {
	
	        var _ = this;
	
	        _.autoPlayClear();
	
	        _.touchObject = {};
	
	        _.cleanUpEvents();
	
	        $('.slick-cloned', _.$slider).detach();
	
	        if (_.$dots) {
	            _.$dots.remove();
	        }
	
	        if ( _.$prevArrow && _.$prevArrow.length ) {
	
	            _.$prevArrow
	                .removeClass('slick-disabled slick-arrow slick-hidden')
	                .removeAttr('aria-hidden aria-disabled tabindex')
	                .css('display','');
	
	            if ( _.htmlExpr.test( _.options.prevArrow )) {
	                _.$prevArrow.remove();
	            }
	        }
	
	        if ( _.$nextArrow && _.$nextArrow.length ) {
	
	            _.$nextArrow
	                .removeClass('slick-disabled slick-arrow slick-hidden')
	                .removeAttr('aria-hidden aria-disabled tabindex')
	                .css('display','');
	
	            if ( _.htmlExpr.test( _.options.nextArrow )) {
	                _.$nextArrow.remove();
	            }
	        }
	
	
	        if (_.$slides) {
	
	            _.$slides
	                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
	                .removeAttr('aria-hidden')
	                .removeAttr('data-slick-index')
	                .each(function(){
	                    $(this).attr('style', $(this).data('originalStyling'));
	                });
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slideTrack.detach();
	
	            _.$list.detach();
	
	            _.$slider.append(_.$slides);
	        }
	
	        _.cleanUpRows();
	
	        _.$slider.removeClass('slick-slider');
	        _.$slider.removeClass('slick-initialized');
	        _.$slider.removeClass('slick-dotted');
	
	        _.unslicked = true;
	
	        if(!refresh) {
	            _.$slider.trigger('destroy', [_]);
	        }
	
	    };
	
	    Slick.prototype.disableTransition = function(slide) {
	
	        var _ = this,
	            transition = {};
	
	        transition[_.transitionType] = '';
	
	        if (_.options.fade === false) {
	            _.$slideTrack.css(transition);
	        } else {
	            _.$slides.eq(slide).css(transition);
	        }
	
	    };
	
	    Slick.prototype.fadeSlide = function(slideIndex, callback) {
	
	        var _ = this;
	
	        if (_.cssTransitions === false) {
	
	            _.$slides.eq(slideIndex).css({
	                zIndex: _.options.zIndex
	            });
	
	            _.$slides.eq(slideIndex).animate({
	                opacity: 1
	            }, _.options.speed, _.options.easing, callback);
	
	        } else {
	
	            _.applyTransition(slideIndex);
	
	            _.$slides.eq(slideIndex).css({
	                opacity: 1,
	                zIndex: _.options.zIndex
	            });
	
	            if (callback) {
	                setTimeout(function() {
	
	                    _.disableTransition(slideIndex);
	
	                    callback.call();
	                }, _.options.speed);
	            }
	
	        }
	
	    };
	
	    Slick.prototype.fadeSlideOut = function(slideIndex) {
	
	        var _ = this;
	
	        if (_.cssTransitions === false) {
	
	            _.$slides.eq(slideIndex).animate({
	                opacity: 0,
	                zIndex: _.options.zIndex - 2
	            }, _.options.speed, _.options.easing);
	
	        } else {
	
	            _.applyTransition(slideIndex);
	
	            _.$slides.eq(slideIndex).css({
	                opacity: 0,
	                zIndex: _.options.zIndex - 2
	            });
	
	        }
	
	    };
	
	    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {
	
	        var _ = this;
	
	        if (filter !== null) {
	
	            _.$slidesCache = _.$slides;
	
	            _.unload();
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
	
	            _.reinit();
	
	        }
	
	    };
	
	    Slick.prototype.focusHandler = function() {
	
	        var _ = this;
	
	        _.$slider
	            .off('focus.slick blur.slick')
	            .on('focus.slick blur.slick', '*', function(event) {
	
	            event.stopImmediatePropagation();
	            var $sf = $(this);
	
	            setTimeout(function() {
	
	                if( _.options.pauseOnFocus ) {
	                    _.focussed = $sf.is(':focus');
	                    _.autoPlay();
	                }
	
	            }, 0);
	
	        });
	    };
	
	    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {
	
	        var _ = this;
	        return _.currentSlide;
	
	    };
	
	    Slick.prototype.getDotCount = function() {
	
	        var _ = this;
	
	        var breakPoint = 0;
	        var counter = 0;
	        var pagerQty = 0;
	
	        if (_.options.infinite === true) {
	            if (_.slideCount <= _.options.slidesToShow) {
	                 ++pagerQty;
	            } else {
	                while (breakPoint < _.slideCount) {
	                    ++pagerQty;
	                    breakPoint = counter + _.options.slidesToScroll;
	                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	                }
	            }
	        } else if (_.options.centerMode === true) {
	            pagerQty = _.slideCount;
	        } else if(!_.options.asNavFor) {
	            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
	        }else {
	            while (breakPoint < _.slideCount) {
	                ++pagerQty;
	                breakPoint = counter + _.options.slidesToScroll;
	                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	            }
	        }
	
	        return pagerQty - 1;
	
	    };
	
	    Slick.prototype.getLeft = function(slideIndex) {
	
	        var _ = this,
	            targetLeft,
	            verticalHeight,
	            verticalOffset = 0,
	            targetSlide,
	            coef;
	
	        _.slideOffset = 0;
	        verticalHeight = _.$slides.first().outerHeight(true);
	
	        if (_.options.infinite === true) {
	            if (_.slideCount > _.options.slidesToShow) {
	                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
	                coef = -1
	
	                if (_.options.vertical === true && _.options.centerMode === true) {
	                    if (_.options.slidesToShow === 2) {
	                        coef = -1.5;
	                    } else if (_.options.slidesToShow === 1) {
	                        coef = -2
	                    }
	                }
	                verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
	            }
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
	                    if (slideIndex > _.slideCount) {
	                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
	                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
	                    } else {
	                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
	                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
	                    }
	                }
	            }
	        } else {
	            if (slideIndex + _.options.slidesToShow > _.slideCount) {
	                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
	                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
	            }
	        }
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            _.slideOffset = 0;
	            verticalOffset = 0;
	        }
	
	        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
	            _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
	        } else if (_.options.centerMode === true && _.options.infinite === true) {
	            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
	        } else if (_.options.centerMode === true) {
	            _.slideOffset = 0;
	            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
	        }
	
	        if (_.options.vertical === false) {
	            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
	        } else {
	            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
	        }
	
	        if (_.options.variableWidth === true) {
	
	            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
	                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
	            } else {
	                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
	            }
	
	            if (_.options.rtl === true) {
	                if (targetSlide[0]) {
	                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
	                } else {
	                    targetLeft =  0;
	                }
	            } else {
	                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
	            }
	
	            if (_.options.centerMode === true) {
	                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
	                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
	                } else {
	                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
	                }
	
	                if (_.options.rtl === true) {
	                    if (targetSlide[0]) {
	                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
	                    } else {
	                        targetLeft =  0;
	                    }
	                } else {
	                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
	                }
	
	                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
	            }
	        }
	
	        return targetLeft;
	
	    };
	
	    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {
	
	        var _ = this;
	
	        return _.options[option];
	
	    };
	
	    Slick.prototype.getNavigableIndexes = function() {
	
	        var _ = this,
	            breakPoint = 0,
	            counter = 0,
	            indexes = [],
	            max;
	
	        if (_.options.infinite === false) {
	            max = _.slideCount;
	        } else {
	            breakPoint = _.options.slidesToScroll * -1;
	            counter = _.options.slidesToScroll * -1;
	            max = _.slideCount * 2;
	        }
	
	        while (breakPoint < max) {
	            indexes.push(breakPoint);
	            breakPoint = counter + _.options.slidesToScroll;
	            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	        }
	
	        return indexes;
	
	    };
	
	    Slick.prototype.getSlick = function() {
	
	        return this;
	
	    };
	
	    Slick.prototype.getSlideCount = function() {
	
	        var _ = this,
	            slidesTraversed, swipedSlide, centerOffset;
	
	        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;
	
	        if (_.options.swipeToSlide === true) {
	            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
	                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
	                    swipedSlide = slide;
	                    return false;
	                }
	            });
	
	            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;
	
	            return slidesTraversed;
	
	        } else {
	            return _.options.slidesToScroll;
	        }
	
	    };
	
	    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'index',
	                index: parseInt(slide)
	            }
	        }, dontAnimate);
	
	    };
	
	    Slick.prototype.init = function(creation) {
	
	        var _ = this;
	
	        if (!$(_.$slider).hasClass('slick-initialized')) {
	
	            $(_.$slider).addClass('slick-initialized');
	
	            _.buildRows();
	            _.buildOut();
	            _.setProps();
	            _.startLoad();
	            _.loadSlider();
	            _.initializeEvents();
	            _.updateArrows();
	            _.updateDots();
	            _.checkResponsive(true);
	            _.focusHandler();
	
	        }
	
	        if (creation) {
	            _.$slider.trigger('init', [_]);
	        }
	
	        if (_.options.accessibility === true) {
	            _.initADA();
	        }
	
	        if ( _.options.autoplay ) {
	
	            _.paused = false;
	            _.autoPlay();
	
	        }
	
	    };
	
	    Slick.prototype.initADA = function() {
	        var _ = this,
	                numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
	                tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
	                    return (val >= 0) && (val < _.slideCount);
	                });
	
	        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
	            'aria-hidden': 'true',
	            'tabindex': '-1'
	        }).find('a, input, button, select').attr({
	            'tabindex': '-1'
	        });
	
	        if (_.$dots !== null) {
	            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
	                var slideControlIndex = tabControlIndexes.indexOf(i);
	
	                $(this).attr({
	                    'role': 'tabpanel',
	                    'id': 'slick-slide' + _.instanceUid + i,
	                    'tabindex': -1
	                });
	
	                if (slideControlIndex !== -1) {
	                   var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex
	                   if ($('#' + ariaButtonControl).length) {
	                     $(this).attr({
	                         'aria-describedby': ariaButtonControl
	                     });
	                   }
	                }
	            });
	
	            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
	                var mappedSlideIndex = tabControlIndexes[i];
	
	                $(this).attr({
	                    'role': 'presentation'
	                });
	
	                $(this).find('button').first().attr({
	                    'role': 'tab',
	                    'id': 'slick-slide-control' + _.instanceUid + i,
	                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
	                    'aria-label': (i + 1) + ' of ' + numDotGroups,
	                    'aria-selected': null,
	                    'tabindex': '-1'
	                });
	
	            }).eq(_.currentSlide).find('button').attr({
	                'aria-selected': 'true',
	                'tabindex': '0'
	            }).end();
	        }
	
	        for (var i=_.currentSlide, max=i+_.options.slidesToShow; i < max; i++) {
	          if (_.options.focusOnChange) {
	            _.$slides.eq(i).attr({'tabindex': '0'});
	          } else {
	            _.$slides.eq(i).removeAttr('tabindex');
	          }
	        }
	
	        _.activateADA();
	
	    };
	
	    Slick.prototype.initArrowEvents = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	            _.$prevArrow
	               .off('click.slick')
	               .on('click.slick', {
	                    message: 'previous'
	               }, _.changeSlide);
	            _.$nextArrow
	               .off('click.slick')
	               .on('click.slick', {
	                    message: 'next'
	               }, _.changeSlide);
	
	            if (_.options.accessibility === true) {
	                _.$prevArrow.on('keydown.slick', _.keyHandler);
	                _.$nextArrow.on('keydown.slick', _.keyHandler);
	            }
	        }
	
	    };
	
	    Slick.prototype.initDotEvents = function() {
	
	        var _ = this;
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	            $('li', _.$dots).on('click.slick', {
	                message: 'index'
	            }, _.changeSlide);
	
	            if (_.options.accessibility === true) {
	                _.$dots.on('keydown.slick', _.keyHandler);
	            }
	        }
	
	        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {
	
	            $('li', _.$dots)
	                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
	                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	        }
	
	    };
	
	    Slick.prototype.initSlideEvents = function() {
	
	        var _ = this;
	
	        if ( _.options.pauseOnHover ) {
	
	            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
	            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	        }
	
	    };
	
	    Slick.prototype.initializeEvents = function() {
	
	        var _ = this;
	
	        _.initArrowEvents();
	
	        _.initDotEvents();
	        _.initSlideEvents();
	
	        _.$list.on('touchstart.slick mousedown.slick', {
	            action: 'start'
	        }, _.swipeHandler);
	        _.$list.on('touchmove.slick mousemove.slick', {
	            action: 'move'
	        }, _.swipeHandler);
	        _.$list.on('touchend.slick mouseup.slick', {
	            action: 'end'
	        }, _.swipeHandler);
	        _.$list.on('touchcancel.slick mouseleave.slick', {
	            action: 'end'
	        }, _.swipeHandler);
	
	        _.$list.on('click.slick', _.clickHandler);
	
	        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
	
	        if (_.options.accessibility === true) {
	            _.$list.on('keydown.slick', _.keyHandler);
	        }
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
	        }
	
	        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));
	
	        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));
	
	        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);
	
	        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
	        $(_.setPosition);
	
	    };
	
	    Slick.prototype.initUI = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$prevArrow.show();
	            _.$nextArrow.show();
	
	        }
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$dots.show();
	
	        }
	
	    };
	
	    Slick.prototype.keyHandler = function(event) {
	
	        var _ = this;
	         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	            if (event.keyCode === 37 && _.options.accessibility === true) {
	                _.changeSlide({
	                    data: {
	                        message: _.options.rtl === true ? 'next' :  'previous'
	                    }
	                });
	            } else if (event.keyCode === 39 && _.options.accessibility === true) {
	                _.changeSlide({
	                    data: {
	                        message: _.options.rtl === true ? 'previous' : 'next'
	                    }
	                });
	            }
	        }
	
	    };
	
	    Slick.prototype.lazyLoad = function() {
	
	        var _ = this,
	            loadRange, cloneRange, rangeStart, rangeEnd;
	
	        function loadImages(imagesScope) {
	
	            $('img[data-lazy]', imagesScope).each(function() {
	
	                var image = $(this),
	                    imageSource = $(this).attr('data-lazy'),
	                    imageSrcSet = $(this).attr('data-srcset'),
	                    imageSizes  = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
	                    imageToLoad = document.createElement('img');
	
	                imageToLoad.onload = function() {
	
	                    image
	                        .animate({ opacity: 0 }, 100, function() {
	
	                            if (imageSrcSet) {
	                                image
	                                    .attr('srcset', imageSrcSet );
	
	                                if (imageSizes) {
	                                    image
	                                        .attr('sizes', imageSizes );
	                                }
	                            }
	
	                            image
	                                .attr('src', imageSource)
	                                .animate({ opacity: 1 }, 200, function() {
	                                    image
	                                        .removeAttr('data-lazy data-srcset data-sizes')
	                                        .removeClass('slick-loading');
	                                });
	                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
	                        });
	
	                };
	
	                imageToLoad.onerror = function() {
	
	                    image
	                        .removeAttr( 'data-lazy' )
	                        .removeClass( 'slick-loading' )
	                        .addClass( 'slick-lazyload-error' );
	
	                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);
	
	                };
	
	                imageToLoad.src = imageSource;
	
	            });
	
	        }
	
	        if (_.options.centerMode === true) {
	            if (_.options.infinite === true) {
	                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
	                rangeEnd = rangeStart + _.options.slidesToShow + 2;
	            } else {
	                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
	                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
	            }
	        } else {
	            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
	            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
	            if (_.options.fade === true) {
	                if (rangeStart > 0) rangeStart--;
	                if (rangeEnd <= _.slideCount) rangeEnd++;
	            }
	        }
	
	        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
	
	        if (_.options.lazyLoad === 'anticipated') {
	            var prevSlide = rangeStart - 1,
	                nextSlide = rangeEnd,
	                $slides = _.$slider.find('.slick-slide');
	
	            for (var i = 0; i < _.options.slidesToScroll; i++) {
	                if (prevSlide < 0) prevSlide = _.slideCount - 1;
	                loadRange = loadRange.add($slides.eq(prevSlide));
	                loadRange = loadRange.add($slides.eq(nextSlide));
	                prevSlide--;
	                nextSlide++;
	            }
	        }
	
	        loadImages(loadRange);
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            cloneRange = _.$slider.find('.slick-slide');
	            loadImages(cloneRange);
	        } else
	        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
	            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
	            loadImages(cloneRange);
	        } else if (_.currentSlide === 0) {
	            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
	            loadImages(cloneRange);
	        }
	
	    };
	
	    Slick.prototype.loadSlider = function() {
	
	        var _ = this;
	
	        _.setPosition();
	
	        _.$slideTrack.css({
	            opacity: 1
	        });
	
	        _.$slider.removeClass('slick-loading');
	
	        _.initUI();
	
	        if (_.options.lazyLoad === 'progressive') {
	            _.progressiveLazyLoad();
	        }
	
	    };
	
	    Slick.prototype.next = Slick.prototype.slickNext = function() {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'next'
	            }
	        });
	
	    };
	
	    Slick.prototype.orientationChange = function() {
	
	        var _ = this;
	
	        _.checkResponsive();
	        _.setPosition();
	
	    };
	
	    Slick.prototype.pause = Slick.prototype.slickPause = function() {
	
	        var _ = this;
	
	        _.autoPlayClear();
	        _.paused = true;
	
	    };
	
	    Slick.prototype.play = Slick.prototype.slickPlay = function() {
	
	        var _ = this;
	
	        _.autoPlay();
	        _.options.autoplay = true;
	        _.paused = false;
	        _.focussed = false;
	        _.interrupted = false;
	
	    };
	
	    Slick.prototype.postSlide = function(index) {
	
	        var _ = this;
	
	        if( !_.unslicked ) {
	
	            _.$slider.trigger('afterChange', [_, index]);
	
	            _.animating = false;
	
	            if (_.slideCount > _.options.slidesToShow) {
	                _.setPosition();
	            }
	
	            _.swipeLeft = null;
	
	            if ( _.options.autoplay ) {
	                _.autoPlay();
	            }
	
	            if (_.options.accessibility === true) {
	                _.initADA();
	
	                if (_.options.focusOnChange) {
	                    var $currentSlide = $(_.$slides.get(_.currentSlide));
	                    $currentSlide.attr('tabindex', 0).focus();
	                }
	            }
	
	        }
	
	    };
	
	    Slick.prototype.prev = Slick.prototype.slickPrev = function() {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'previous'
	            }
	        });
	
	    };
	
	    Slick.prototype.preventDefault = function(event) {
	
	        event.preventDefault();
	
	    };
	
	    Slick.prototype.progressiveLazyLoad = function( tryCount ) {
	
	        tryCount = tryCount || 1;
	
	        var _ = this,
	            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
	            image,
	            imageSource,
	            imageSrcSet,
	            imageSizes,
	            imageToLoad;
	
	        if ( $imgsToLoad.length ) {
	
	            image = $imgsToLoad.first();
	            imageSource = image.attr('data-lazy');
	            imageSrcSet = image.attr('data-srcset');
	            imageSizes  = image.attr('data-sizes') || _.$slider.attr('data-sizes');
	            imageToLoad = document.createElement('img');
	
	            imageToLoad.onload = function() {
	
	                if (imageSrcSet) {
	                    image
	                        .attr('srcset', imageSrcSet );
	
	                    if (imageSizes) {
	                        image
	                            .attr('sizes', imageSizes );
	                    }
	                }
	
	                image
	                    .attr( 'src', imageSource )
	                    .removeAttr('data-lazy data-srcset data-sizes')
	                    .removeClass('slick-loading');
	
	                if ( _.options.adaptiveHeight === true ) {
	                    _.setPosition();
	                }
	
	                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
	                _.progressiveLazyLoad();
	
	            };
	
	            imageToLoad.onerror = function() {
	
	                if ( tryCount < 3 ) {
	
	                    /**
	                     * try to load the image 3 times,
	                     * leave a slight delay so we don't get
	                     * servers blocking the request.
	                     */
	                    setTimeout( function() {
	                        _.progressiveLazyLoad( tryCount + 1 );
	                    }, 500 );
	
	                } else {
	
	                    image
	                        .removeAttr( 'data-lazy' )
	                        .removeClass( 'slick-loading' )
	                        .addClass( 'slick-lazyload-error' );
	
	                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);
	
	                    _.progressiveLazyLoad();
	
	                }
	
	            };
	
	            imageToLoad.src = imageSource;
	
	        } else {
	
	            _.$slider.trigger('allImagesLoaded', [ _ ]);
	
	        }
	
	    };
	
	    Slick.prototype.refresh = function( initializing ) {
	
	        var _ = this, currentSlide, lastVisibleIndex;
	
	        lastVisibleIndex = _.slideCount - _.options.slidesToShow;
	
	        // in non-infinite sliders, we don't want to go past the
	        // last visible index.
	        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
	            _.currentSlide = lastVisibleIndex;
	        }
	
	        // if less slides than to show, go to start.
	        if ( _.slideCount <= _.options.slidesToShow ) {
	            _.currentSlide = 0;
	
	        }
	
	        currentSlide = _.currentSlide;
	
	        _.destroy(true);
	
	        $.extend(_, _.initials, { currentSlide: currentSlide });
	
	        _.init();
	
	        if( !initializing ) {
	
	            _.changeSlide({
	                data: {
	                    message: 'index',
	                    index: currentSlide
	                }
	            }, false);
	
	        }
	
	    };
	
	    Slick.prototype.registerBreakpoints = function() {
	
	        var _ = this, breakpoint, currentBreakpoint, l,
	            responsiveSettings = _.options.responsive || null;
	
	        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {
	
	            _.respondTo = _.options.respondTo || 'window';
	
	            for ( breakpoint in responsiveSettings ) {
	
	                l = _.breakpoints.length-1;
	
	                if (responsiveSettings.hasOwnProperty(breakpoint)) {
	                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;
	
	                    // loop through the breakpoints and cut out any existing
	                    // ones with the same breakpoint number, we don't want dupes.
	                    while( l >= 0 ) {
	                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
	                            _.breakpoints.splice(l,1);
	                        }
	                        l--;
	                    }
	
	                    _.breakpoints.push(currentBreakpoint);
	                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
	
	                }
	
	            }
	
	            _.breakpoints.sort(function(a, b) {
	                return ( _.options.mobileFirst ) ? a-b : b-a;
	            });
	
	        }
	
	    };
	
	    Slick.prototype.reinit = function() {
	
	        var _ = this;
	
	        _.$slides =
	            _.$slideTrack
	                .children(_.options.slide)
	                .addClass('slick-slide');
	
	        _.slideCount = _.$slides.length;
	
	        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
	            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
	        }
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            _.currentSlide = 0;
	        }
	
	        _.registerBreakpoints();
	
	        _.setProps();
	        _.setupInfinite();
	        _.buildArrows();
	        _.updateArrows();
	        _.initArrowEvents();
	        _.buildDots();
	        _.updateDots();
	        _.initDotEvents();
	        _.cleanUpSlideEvents();
	        _.initSlideEvents();
	
	        _.checkResponsive(false, true);
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
	        }
	
	        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
	
	        _.setPosition();
	        _.focusHandler();
	
	        _.paused = !_.options.autoplay;
	        _.autoPlay();
	
	        _.$slider.trigger('reInit', [_]);
	
	    };
	
	    Slick.prototype.resize = function() {
	
	        var _ = this;
	
	        if ($(window).width() !== _.windowWidth) {
	            clearTimeout(_.windowDelay);
	            _.windowDelay = window.setTimeout(function() {
	                _.windowWidth = $(window).width();
	                _.checkResponsive();
	                if( !_.unslicked ) { _.setPosition(); }
	            }, 50);
	        }
	    };
	
	    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {
	
	        var _ = this;
	
	        if (typeof(index) === 'boolean') {
	            removeBefore = index;
	            index = removeBefore === true ? 0 : _.slideCount - 1;
	        } else {
	            index = removeBefore === true ? --index : index;
	        }
	
	        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
	            return false;
	        }
	
	        _.unload();
	
	        if (removeAll === true) {
	            _.$slideTrack.children().remove();
	        } else {
	            _.$slideTrack.children(this.options.slide).eq(index).remove();
	        }
	
	        _.$slides = _.$slideTrack.children(this.options.slide);
	
	        _.$slideTrack.children(this.options.slide).detach();
	
	        _.$slideTrack.append(_.$slides);
	
	        _.$slidesCache = _.$slides;
	
	        _.reinit();
	
	    };
	
	    Slick.prototype.setCSS = function(position) {
	
	        var _ = this,
	            positionProps = {},
	            x, y;
	
	        if (_.options.rtl === true) {
	            position = -position;
	        }
	        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
	        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';
	
	        positionProps[_.positionProp] = position;
	
	        if (_.transformsEnabled === false) {
	            _.$slideTrack.css(positionProps);
	        } else {
	            positionProps = {};
	            if (_.cssTransitions === false) {
	                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
	                _.$slideTrack.css(positionProps);
	            } else {
	                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
	                _.$slideTrack.css(positionProps);
	            }
	        }
	
	    };
	
	    Slick.prototype.setDimensions = function() {
	
	        var _ = this;
	
	        if (_.options.vertical === false) {
	            if (_.options.centerMode === true) {
	                _.$list.css({
	                    padding: ('0px ' + _.options.centerPadding)
	                });
	            }
	        } else {
	            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
	            if (_.options.centerMode === true) {
	                _.$list.css({
	                    padding: (_.options.centerPadding + ' 0px')
	                });
	            }
	        }
	
	        _.listWidth = _.$list.width();
	        _.listHeight = _.$list.height();
	
	
	        if (_.options.vertical === false && _.options.variableWidth === false) {
	            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
	            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));
	
	        } else if (_.options.variableWidth === true) {
	            _.$slideTrack.width(5000 * _.slideCount);
	        } else {
	            _.slideWidth = Math.ceil(_.listWidth);
	            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
	        }
	
	        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
	        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
	
	    };
	
	    Slick.prototype.setFade = function() {
	
	        var _ = this,
	            targetLeft;
	
	        _.$slides.each(function(index, element) {
	            targetLeft = (_.slideWidth * index) * -1;
	            if (_.options.rtl === true) {
	                $(element).css({
	                    position: 'relative',
	                    right: targetLeft,
	                    top: 0,
	                    zIndex: _.options.zIndex - 2,
	                    opacity: 0
	                });
	            } else {
	                $(element).css({
	                    position: 'relative',
	                    left: targetLeft,
	                    top: 0,
	                    zIndex: _.options.zIndex - 2,
	                    opacity: 0
	                });
	            }
	        });
	
	        _.$slides.eq(_.currentSlide).css({
	            zIndex: _.options.zIndex - 1,
	            opacity: 1
	        });
	
	    };
	
	    Slick.prototype.setHeight = function() {
	
	        var _ = this;
	
	        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
	            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
	            _.$list.css('height', targetHeight);
	        }
	
	    };
	
	    Slick.prototype.setOption =
	    Slick.prototype.slickSetOption = function() {
	
	        /**
	         * accepts arguments in format of:
	         *
	         *  - for changing a single option's value:
	         *     .slick("setOption", option, value, refresh )
	         *
	         *  - for changing a set of responsive options:
	         *     .slick("setOption", 'responsive', [{}, ...], refresh )
	         *
	         *  - for updating multiple values at once (not responsive)
	         *     .slick("setOption", { 'option': value, ... }, refresh )
	         */
	
	        var _ = this, l, item, option, value, refresh = false, type;
	
	        if( $.type( arguments[0] ) === 'object' ) {
	
	            option =  arguments[0];
	            refresh = arguments[1];
	            type = 'multiple';
	
	        } else if ( $.type( arguments[0] ) === 'string' ) {
	
	            option =  arguments[0];
	            value = arguments[1];
	            refresh = arguments[2];
	
	            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {
	
	                type = 'responsive';
	
	            } else if ( typeof arguments[1] !== 'undefined' ) {
	
	                type = 'single';
	
	            }
	
	        }
	
	        if ( type === 'single' ) {
	
	            _.options[option] = value;
	
	
	        } else if ( type === 'multiple' ) {
	
	            $.each( option , function( opt, val ) {
	
	                _.options[opt] = val;
	
	            });
	
	
	        } else if ( type === 'responsive' ) {
	
	            for ( item in value ) {
	
	                if( $.type( _.options.responsive ) !== 'array' ) {
	
	                    _.options.responsive = [ value[item] ];
	
	                } else {
	
	                    l = _.options.responsive.length-1;
	
	                    // loop through the responsive object and splice out duplicates.
	                    while( l >= 0 ) {
	
	                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {
	
	                            _.options.responsive.splice(l,1);
	
	                        }
	
	                        l--;
	
	                    }
	
	                    _.options.responsive.push( value[item] );
	
	                }
	
	            }
	
	        }
	
	        if ( refresh ) {
	
	            _.unload();
	            _.reinit();
	
	        }
	
	    };
	
	    Slick.prototype.setPosition = function() {
	
	        var _ = this;
	
	        _.setDimensions();
	
	        _.setHeight();
	
	        if (_.options.fade === false) {
	            _.setCSS(_.getLeft(_.currentSlide));
	        } else {
	            _.setFade();
	        }
	
	        _.$slider.trigger('setPosition', [_]);
	
	    };
	
	    Slick.prototype.setProps = function() {
	
	        var _ = this,
	            bodyStyle = document.body.style;
	
	        _.positionProp = _.options.vertical === true ? 'top' : 'left';
	
	        if (_.positionProp === 'top') {
	            _.$slider.addClass('slick-vertical');
	        } else {
	            _.$slider.removeClass('slick-vertical');
	        }
	
	        if (bodyStyle.WebkitTransition !== undefined ||
	            bodyStyle.MozTransition !== undefined ||
	            bodyStyle.msTransition !== undefined) {
	            if (_.options.useCSS === true) {
	                _.cssTransitions = true;
	            }
	        }
	
	        if ( _.options.fade ) {
	            if ( typeof _.options.zIndex === 'number' ) {
	                if( _.options.zIndex < 3 ) {
	                    _.options.zIndex = 3;
	                }
	            } else {
	                _.options.zIndex = _.defaults.zIndex;
	            }
	        }
	
	        if (bodyStyle.OTransform !== undefined) {
	            _.animType = 'OTransform';
	            _.transformType = '-o-transform';
	            _.transitionType = 'OTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.MozTransform !== undefined) {
	            _.animType = 'MozTransform';
	            _.transformType = '-moz-transform';
	            _.transitionType = 'MozTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.webkitTransform !== undefined) {
	            _.animType = 'webkitTransform';
	            _.transformType = '-webkit-transform';
	            _.transitionType = 'webkitTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.msTransform !== undefined) {
	            _.animType = 'msTransform';
	            _.transformType = '-ms-transform';
	            _.transitionType = 'msTransition';
	            if (bodyStyle.msTransform === undefined) _.animType = false;
	        }
	        if (bodyStyle.transform !== undefined && _.animType !== false) {
	            _.animType = 'transform';
	            _.transformType = 'transform';
	            _.transitionType = 'transition';
	        }
	        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
	    };
	
	
	    Slick.prototype.setSlideClasses = function(index) {
	
	        var _ = this,
	            centerOffset, allSlides, indexOffset, remainder;
	
	        allSlides = _.$slider
	            .find('.slick-slide')
	            .removeClass('slick-active slick-center slick-current')
	            .attr('aria-hidden', 'true');
	
	        _.$slides
	            .eq(index)
	            .addClass('slick-current');
	
	        if (_.options.centerMode === true) {
	
	            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;
	
	            centerOffset = Math.floor(_.options.slidesToShow / 2);
	
	            if (_.options.infinite === true) {
	
	                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
	                    _.$slides
	                        .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                } else {
	
	                    indexOffset = _.options.slidesToShow + index;
	                    allSlides
	                        .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                }
	
	                if (index === 0) {
	
	                    allSlides
	                        .eq(allSlides.length - 1 - _.options.slidesToShow)
	                        .addClass('slick-center');
	
	                } else if (index === _.slideCount - 1) {
	
	                    allSlides
	                        .eq(_.options.slidesToShow)
	                        .addClass('slick-center');
	
	                }
	
	            }
	
	            _.$slides
	                .eq(index)
	                .addClass('slick-center');
	
	        } else {
	
	            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {
	
	                _.$slides
	                    .slice(index, index + _.options.slidesToShow)
	                    .addClass('slick-active')
	                    .attr('aria-hidden', 'false');
	
	            } else if (allSlides.length <= _.options.slidesToShow) {
	
	                allSlides
	                    .addClass('slick-active')
	                    .attr('aria-hidden', 'false');
	
	            } else {
	
	                remainder = _.slideCount % _.options.slidesToShow;
	                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
	
	                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {
	
	                    allSlides
	                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                } else {
	
	                    allSlides
	                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                }
	
	            }
	
	        }
	
	        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
	            _.lazyLoad();
	        }
	    };
	
	    Slick.prototype.setupInfinite = function() {
	
	        var _ = this,
	            i, slideIndex, infiniteCount;
	
	        if (_.options.fade === true) {
	            _.options.centerMode = false;
	        }
	
	        if (_.options.infinite === true && _.options.fade === false) {
	
	            slideIndex = null;
	
	            if (_.slideCount > _.options.slidesToShow) {
	
	                if (_.options.centerMode === true) {
	                    infiniteCount = _.options.slidesToShow + 1;
	                } else {
	                    infiniteCount = _.options.slidesToShow;
	                }
	
	                for (i = _.slideCount; i > (_.slideCount -
	                        infiniteCount); i -= 1) {
	                    slideIndex = i - 1;
	                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
	                        .attr('data-slick-index', slideIndex - _.slideCount)
	                        .prependTo(_.$slideTrack).addClass('slick-cloned');
	                }
	                for (i = 0; i < infiniteCount  + _.slideCount; i += 1) {
	                    slideIndex = i;
	                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
	                        .attr('data-slick-index', slideIndex + _.slideCount)
	                        .appendTo(_.$slideTrack).addClass('slick-cloned');
	                }
	                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
	                    $(this).attr('id', '');
	                });
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.interrupt = function( toggle ) {
	
	        var _ = this;
	
	        if( !toggle ) {
	            _.autoPlay();
	        }
	        _.interrupted = toggle;
	
	    };
	
	    Slick.prototype.selectHandler = function(event) {
	
	        var _ = this;
	
	        var targetElement =
	            $(event.target).is('.slick-slide') ?
	                $(event.target) :
	                $(event.target).parents('.slick-slide');
	
	        var index = parseInt(targetElement.attr('data-slick-index'));
	
	        if (!index) index = 0;
	
	        if (_.slideCount <= _.options.slidesToShow) {
	
	            _.slideHandler(index, false, true);
	            return;
	
	        }
	
	        _.slideHandler(index);
	
	    };
	
	    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {
	
	        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
	            _ = this, navTarget;
	
	        sync = sync || false;
	
	        if (_.animating === true && _.options.waitForAnimate === true) {
	            return;
	        }
	
	        if (_.options.fade === true && _.currentSlide === index) {
	            return;
	        }
	
	        if (sync === false) {
	            _.asNavFor(index);
	        }
	
	        targetSlide = index;
	        targetLeft = _.getLeft(targetSlide);
	        slideLeft = _.getLeft(_.currentSlide);
	
	        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
	
	        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
	            if (_.options.fade === false) {
	                targetSlide = _.currentSlide;
	                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
	                    _.animateSlide(slideLeft, function() {
	                        _.postSlide(targetSlide);
	                    });
	                } else {
	                    _.postSlide(targetSlide);
	                }
	            }
	            return;
	        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
	            if (_.options.fade === false) {
	                targetSlide = _.currentSlide;
	                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
	                    _.animateSlide(slideLeft, function() {
	                        _.postSlide(targetSlide);
	                    });
	                } else {
	                    _.postSlide(targetSlide);
	                }
	            }
	            return;
	        }
	
	        if ( _.options.autoplay ) {
	            clearInterval(_.autoPlayTimer);
	        }
	
	        if (targetSlide < 0) {
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
	            } else {
	                animSlide = _.slideCount + targetSlide;
	            }
	        } else if (targetSlide >= _.slideCount) {
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                animSlide = 0;
	            } else {
	                animSlide = targetSlide - _.slideCount;
	            }
	        } else {
	            animSlide = targetSlide;
	        }
	
	        _.animating = true;
	
	        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);
	
	        oldSlide = _.currentSlide;
	        _.currentSlide = animSlide;
	
	        _.setSlideClasses(_.currentSlide);
	
	        if ( _.options.asNavFor ) {
	
	            navTarget = _.getNavTarget();
	            navTarget = navTarget.slick('getSlick');
	
	            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
	                navTarget.setSlideClasses(_.currentSlide);
	            }
	
	        }
	
	        _.updateDots();
	        _.updateArrows();
	
	        if (_.options.fade === true) {
	            if (dontAnimate !== true) {
	
	                _.fadeSlideOut(oldSlide);
	
	                _.fadeSlide(animSlide, function() {
	                    _.postSlide(animSlide);
	                });
	
	            } else {
	                _.postSlide(animSlide);
	            }
	            _.animateHeight();
	            return;
	        }
	
	        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
	            _.animateSlide(targetLeft, function() {
	                _.postSlide(animSlide);
	            });
	        } else {
	            _.postSlide(animSlide);
	        }
	
	    };
	
	    Slick.prototype.startLoad = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$prevArrow.hide();
	            _.$nextArrow.hide();
	
	        }
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$dots.hide();
	
	        }
	
	        _.$slider.addClass('slick-loading');
	
	    };
	
	    Slick.prototype.swipeDirection = function() {
	
	        var xDist, yDist, r, swipeAngle, _ = this;
	
	        xDist = _.touchObject.startX - _.touchObject.curX;
	        yDist = _.touchObject.startY - _.touchObject.curY;
	        r = Math.atan2(yDist, xDist);
	
	        swipeAngle = Math.round(r * 180 / Math.PI);
	        if (swipeAngle < 0) {
	            swipeAngle = 360 - Math.abs(swipeAngle);
	        }
	
	        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
	            return (_.options.rtl === false ? 'left' : 'right');
	        }
	        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
	            return (_.options.rtl === false ? 'left' : 'right');
	        }
	        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
	            return (_.options.rtl === false ? 'right' : 'left');
	        }
	        if (_.options.verticalSwiping === true) {
	            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
	                return 'down';
	            } else {
	                return 'up';
	            }
	        }
	
	        return 'vertical';
	
	    };
	
	    Slick.prototype.swipeEnd = function(event) {
	
	        var _ = this,
	            slideCount,
	            direction;
	
	        _.dragging = false;
	        _.swiping = false;
	
	        if (_.scrolling) {
	            _.scrolling = false;
	            return false;
	        }
	
	        _.interrupted = false;
	        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;
	
	        if ( _.touchObject.curX === undefined ) {
	            return false;
	        }
	
	        if ( _.touchObject.edgeHit === true ) {
	            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
	        }
	
	        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {
	
	            direction = _.swipeDirection();
	
	            switch ( direction ) {
	
	                case 'left':
	                case 'down':
	
	                    slideCount =
	                        _.options.swipeToSlide ?
	                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
	                            _.currentSlide + _.getSlideCount();
	
	                    _.currentDirection = 0;
	
	                    break;
	
	                case 'right':
	                case 'up':
	
	                    slideCount =
	                        _.options.swipeToSlide ?
	                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
	                            _.currentSlide - _.getSlideCount();
	
	                    _.currentDirection = 1;
	
	                    break;
	
	                default:
	
	
	            }
	
	            if( direction != 'vertical' ) {
	
	                _.slideHandler( slideCount );
	                _.touchObject = {};
	                _.$slider.trigger('swipe', [_, direction ]);
	
	            }
	
	        } else {
	
	            if ( _.touchObject.startX !== _.touchObject.curX ) {
	
	                _.slideHandler( _.currentSlide );
	                _.touchObject = {};
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.swipeHandler = function(event) {
	
	        var _ = this;
	
	        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
	            return;
	        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
	            return;
	        }
	
	        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
	            event.originalEvent.touches.length : 1;
	
	        _.touchObject.minSwipe = _.listWidth / _.options
	            .touchThreshold;
	
	        if (_.options.verticalSwiping === true) {
	            _.touchObject.minSwipe = _.listHeight / _.options
	                .touchThreshold;
	        }
	
	        switch (event.data.action) {
	
	            case 'start':
	                _.swipeStart(event);
	                break;
	
	            case 'move':
	                _.swipeMove(event);
	                break;
	
	            case 'end':
	                _.swipeEnd(event);
	                break;
	
	        }
	
	    };
	
	    Slick.prototype.swipeMove = function(event) {
	
	        var _ = this,
	            edgeWasHit = false,
	            curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;
	
	        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
	
	        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
	            return false;
	        }
	
	        curLeft = _.getLeft(_.currentSlide);
	
	        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
	        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
	
	        _.touchObject.swipeLength = Math.round(Math.sqrt(
	            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
	
	        verticalSwipeLength = Math.round(Math.sqrt(
	            Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
	
	        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
	            _.scrolling = true;
	            return false;
	        }
	
	        if (_.options.verticalSwiping === true) {
	            _.touchObject.swipeLength = verticalSwipeLength;
	        }
	
	        swipeDirection = _.swipeDirection();
	
	        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
	            _.swiping = true;
	            event.preventDefault();
	        }
	
	        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
	        if (_.options.verticalSwiping === true) {
	            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
	        }
	
	
	        swipeLength = _.touchObject.swipeLength;
	
	        _.touchObject.edgeHit = false;
	
	        if (_.options.infinite === false) {
	            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
	                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
	                _.touchObject.edgeHit = true;
	            }
	        }
	
	        if (_.options.vertical === false) {
	            _.swipeLeft = curLeft + swipeLength * positionOffset;
	        } else {
	            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
	        }
	        if (_.options.verticalSwiping === true) {
	            _.swipeLeft = curLeft + swipeLength * positionOffset;
	        }
	
	        if (_.options.fade === true || _.options.touchMove === false) {
	            return false;
	        }
	
	        if (_.animating === true) {
	            _.swipeLeft = null;
	            return false;
	        }
	
	        _.setCSS(_.swipeLeft);
	
	    };
	
	    Slick.prototype.swipeStart = function(event) {
	
	        var _ = this,
	            touches;
	
	        _.interrupted = true;
	
	        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
	            _.touchObject = {};
	            return false;
	        }
	
	        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
	            touches = event.originalEvent.touches[0];
	        }
	
	        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
	        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
	
	        _.dragging = true;
	
	    };
	
	    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {
	
	        var _ = this;
	
	        if (_.$slidesCache !== null) {
	
	            _.unload();
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slidesCache.appendTo(_.$slideTrack);
	
	            _.reinit();
	
	        }
	
	    };
	
	    Slick.prototype.unload = function() {
	
	        var _ = this;
	
	        $('.slick-cloned', _.$slider).remove();
	
	        if (_.$dots) {
	            _.$dots.remove();
	        }
	
	        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
	            _.$prevArrow.remove();
	        }
	
	        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
	            _.$nextArrow.remove();
	        }
	
	        _.$slides
	            .removeClass('slick-slide slick-active slick-visible slick-current')
	            .attr('aria-hidden', 'true')
	            .css('width', '');
	
	    };
	
	    Slick.prototype.unslick = function(fromBreakpoint) {
	
	        var _ = this;
	        _.$slider.trigger('unslick', [_, fromBreakpoint]);
	        _.destroy();
	
	    };
	
	    Slick.prototype.updateArrows = function() {
	
	        var _ = this,
	            centerOffset;
	
	        centerOffset = Math.floor(_.options.slidesToShow / 2);
	
	        if ( _.options.arrows === true &&
	            _.slideCount > _.options.slidesToShow &&
	            !_.options.infinite ) {
	
	            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            if (_.currentSlide === 0) {
	
	                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
	
	                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
	
	                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.updateDots = function() {
	
	        var _ = this;
	
	        if (_.$dots !== null) {
	
	            _.$dots
	                .find('li')
	                    .removeClass('slick-active')
	                    .end();
	
	            _.$dots
	                .find('li')
	                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
	                .addClass('slick-active');
	
	        }
	
	    };
	
	    Slick.prototype.visibility = function() {
	
	        var _ = this;
	
	        if ( _.options.autoplay ) {
	
	            if ( document[_.hidden] ) {
	
	                _.interrupted = true;
	
	            } else {
	
	                _.interrupted = false;
	
	            }
	
	        }
	
	    };
	
	    $.fn.slick = function() {
	        var _ = this,
	            opt = arguments[0],
	            args = Array.prototype.slice.call(arguments, 1),
	            l = _.length,
	            i,
	            ret;
	        for (i = 0; i < l; i++) {
	            if (typeof opt == 'object' || typeof opt == 'undefined')
	                _[i].slick = new Slick(_[i], opt);
	            else
	                ret = _[i].slick[opt].apply(_[i].slick, args);
	            if (typeof ret != 'undefined') return ret;
	        }
	        return _;
	    };
	
	}));


/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/games/atlas_carrot-game.c2d5017.png";

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/games/bg_cloud_green.71d241b.png";

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/games/bg_overlay.2e85348.png";

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/games/bg_track_clouds.5a2ce89.png";

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/games/bg_track_grass.191ea76.png";

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/games/bg_track_ground.4ac01e8.png";

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/games/bg_track_mountain.3de81f4.png";

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/games/bg_track_sky.115e4cc.jpg";

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/games/atlas_scarecrow-game.addd29b.png";

/***/ }),
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/logo_boerdereis_fr.1c7f00f.png";

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/logo_boerdereis_nl.cb069c9.png";

/***/ }),
/* 1660 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ })
]);


// WEBPACK FOOTER //
// js/vendor.20ae7266f51713250f4a.js